
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $68b7c89c821485ed$var$extendStatics = function(d, b) {
    $68b7c89c821485ed$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $68b7c89c821485ed$var$extendStatics(d, b);
};
function $68b7c89c821485ed$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $68b7c89c821485ed$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $68b7c89c821485ed$export$18ce0697a983be9b = function() {
    $68b7c89c821485ed$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $68b7c89c821485ed$export$18ce0697a983be9b.apply(this, arguments);
};
function $68b7c89c821485ed$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $68b7c89c821485ed$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $68b7c89c821485ed$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $68b7c89c821485ed$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $68b7c89c821485ed$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $68b7c89c821485ed$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $68b7c89c821485ed$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $68b7c89c821485ed$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $68b7c89c821485ed$export$45d3717a4c69092e(o, m, p);
}
function $68b7c89c821485ed$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $68b7c89c821485ed$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $68b7c89c821485ed$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($68b7c89c821485ed$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $68b7c89c821485ed$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $68b7c89c821485ed$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function $68b7c89c821485ed$export$10c90e4f7922046c(v) {
    return this instanceof $68b7c89c821485ed$export$10c90e4f7922046c ? (this.v = v, this) : new $68b7c89c821485ed$export$10c90e4f7922046c(v);
}
function $68b7c89c821485ed$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $68b7c89c821485ed$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $68b7c89c821485ed$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $68b7c89c821485ed$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $68b7c89c821485ed$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $68b7c89c821485ed$export$19a8beecd37a4c45 === "function" ? $68b7c89c821485ed$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $68b7c89c821485ed$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $68b7c89c821485ed$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $68b7c89c821485ed$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $68b7c89c821485ed$export$45d3717a4c69092e(result, mod, k);
    }
    $68b7c89c821485ed$var$__setModuleDefault(result, mod);
    return result;
}
function $68b7c89c821485ed$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $68b7c89c821485ed$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $68b7c89c821485ed$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}


/*!
* ZRender, a high performance 2d drawing library.
*
* Copyright (c) 2013, Baidu Inc.
* All rights reserved.
*
* LICENSE
* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
*/ var $ab22291f3e1e51d6$var$Browser = function() {
    function Browser() {
        this.firefox = false;
        this.ie = false;
        this.edge = false;
        this.newEdge = false;
        this.weChat = false;
    }
    return Browser;
}();
var $ab22291f3e1e51d6$var$Env = function() {
    function Env() {
        this.browser = new $ab22291f3e1e51d6$var$Browser();
        this.node = false;
        this.wxa = false;
        this.worker = false;
        this.svgSupported = false;
        this.touchEventsSupported = false;
        this.pointerEventsSupported = false;
        this.domSupported = false;
        this.transformSupported = false;
        this.transform3dSupported = false;
        this.hasGlobalWindow = typeof window !== 'undefined';
    }
    return Env;
}();
var $ab22291f3e1e51d6$var$env = new $ab22291f3e1e51d6$var$Env();
if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
    $ab22291f3e1e51d6$var$env.wxa = true;
    $ab22291f3e1e51d6$var$env.touchEventsSupported = true;
} else if (typeof document === 'undefined' && typeof self !== 'undefined') $ab22291f3e1e51d6$var$env.worker = true;
else if (!$ab22291f3e1e51d6$var$env.hasGlobalWindow || 'Deno' in window) {
    $ab22291f3e1e51d6$var$env.node = true;
    $ab22291f3e1e51d6$var$env.svgSupported = true;
} else $ab22291f3e1e51d6$var$detect(navigator.userAgent, $ab22291f3e1e51d6$var$env);
function $ab22291f3e1e51d6$var$detect(ua, env) {
    var browser = env.browser;
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/.+?rv:(([\d.]+))/);
    var edge = ua.match(/Edge?\/([\d.]+)/);
    var weChat = /micromessenger/i.test(ua);
    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }
    if (ie) {
        browser.ie = true;
        browser.version = ie[1];
    }
    if (edge) {
        browser.edge = true;
        browser.version = edge[1];
        browser.newEdge = +edge[1].split('.')[0] > 18;
    }
    if (weChat) browser.weChat = true;
    env.svgSupported = typeof SVGRect !== 'undefined';
    env.touchEventsSupported = 'ontouchstart' in window && !browser.ie && !browser.edge;
    env.pointerEventsSupported = 'onpointerdown' in window && (browser.edge || browser.ie && +browser.version >= 11);
    env.domSupported = typeof document !== 'undefined';
    var style = document.documentElement.style;
    env.transform3dSupported = (browser.ie && 'transition' in style || browser.edge || 'WebKitCSSMatrix' in window && 'm11' in new WebKitCSSMatrix() || 'MozPerspective' in style) && !('OTransition' in style);
    env.transformSupported = env.transform3dSupported || browser.ie && +browser.version >= 9;
}
var $ab22291f3e1e51d6$export$2e2bcd8739ae039 = $ab22291f3e1e51d6$var$env;


var $024b63ea846a8ccd$export$b1461457ea2c1179 = 12;
var $024b63ea846a8ccd$export$2653e0d5dd45b294 = 'sans-serif';
var $024b63ea846a8ccd$export$7d7a232b6d2cc80c = $024b63ea846a8ccd$export$b1461457ea2c1179 + "px " + $024b63ea846a8ccd$export$2653e0d5dd45b294;
var $024b63ea846a8ccd$var$OFFSET = 20;
var $024b63ea846a8ccd$var$SCALE = 100;
var $024b63ea846a8ccd$var$defaultWidthMapStr = "007LLmW'55;N0500LLLLLLLLLL00NNNLzWW\\\\WQb\\0FWLg\\bWb\\WQ\\WrWWQ000CL5LLFLL0LL**F*gLLLL5F0LF\\FFF5.5N";
function $024b63ea846a8ccd$var$getTextWidthMap(mapStr) {
    var map = {};
    if (typeof JSON === 'undefined') return map;
    for(var i = 0; i < mapStr.length; i++){
        var char = String.fromCharCode(i + 32);
        var size = (mapStr.charCodeAt(i) - $024b63ea846a8ccd$var$OFFSET) / $024b63ea846a8ccd$var$SCALE;
        map[char] = size;
    }
    return map;
}
var $024b63ea846a8ccd$export$69462fcc6bf851a4 = $024b63ea846a8ccd$var$getTextWidthMap($024b63ea846a8ccd$var$defaultWidthMapStr);
var $024b63ea846a8ccd$export$ef5e599365494451 = {
    createCanvas: function() {
        return typeof document !== 'undefined' && document.createElement('canvas');
    },
    measureText: function() {
        var _ctx;
        var _cachedFont;
        return function(text, font) {
            if (!_ctx) {
                var canvas = $024b63ea846a8ccd$export$ef5e599365494451.createCanvas();
                _ctx = canvas && canvas.getContext('2d');
            }
            if (_ctx) {
                if (_cachedFont !== font) _cachedFont = _ctx.font = font || $024b63ea846a8ccd$export$7d7a232b6d2cc80c;
                return _ctx.measureText(text);
            } else {
                text = text || '';
                font = font || $024b63ea846a8ccd$export$7d7a232b6d2cc80c;
                var res = /((?:\d+)?\.?\d*)px/.exec(font);
                var fontSize = res && +res[1] || $024b63ea846a8ccd$export$b1461457ea2c1179;
                var width = 0;
                if (font.indexOf('mono') >= 0) width = fontSize * text.length;
                else for(var i = 0; i < text.length; i++){
                    var preCalcWidth = $024b63ea846a8ccd$export$69462fcc6bf851a4[text[i]];
                    width += preCalcWidth == null ? fontSize : preCalcWidth * fontSize;
                }
                return {
                    width: width
                };
            }
        };
    }(),
    loadImage: function(src, onload, onerror) {
        var image = new Image();
        image.onload = onload;
        image.onerror = onerror;
        image.src = src;
        return image;
    }
};
function $024b63ea846a8ccd$export$61bcfd79465c1b7c(newPlatformApis) {
    for(var key in $024b63ea846a8ccd$export$ef5e599365494451)if (newPlatformApis[key]) $024b63ea846a8ccd$export$ef5e599365494451[key] = newPlatformApis[key];
}


var $1b239fc9d3a2f8ae$var$BUILTIN_OBJECT = $1b239fc9d3a2f8ae$export$533b26079ad0b4b([
    'Function',
    'RegExp',
    'Date',
    'Error',
    'CanvasGradient',
    'CanvasPattern',
    'Image',
    'Canvas'
], function(obj, val) {
    obj['[object ' + val + ']'] = true;
    return obj;
}, {});
var $1b239fc9d3a2f8ae$var$TYPED_ARRAY = $1b239fc9d3a2f8ae$export$533b26079ad0b4b([
    'Int8',
    'Uint8',
    'Uint8Clamped',
    'Int16',
    'Uint16',
    'Int32',
    'Uint32',
    'Float32',
    'Float64'
], function(obj, val) {
    obj['[object ' + val + 'Array]'] = true;
    return obj;
}, {});
var $1b239fc9d3a2f8ae$var$objToString = Object.prototype.toString;
var $1b239fc9d3a2f8ae$var$arrayProto = Array.prototype;
var $1b239fc9d3a2f8ae$var$nativeForEach = $1b239fc9d3a2f8ae$var$arrayProto.forEach;
var $1b239fc9d3a2f8ae$var$nativeFilter = $1b239fc9d3a2f8ae$var$arrayProto.filter;
var $1b239fc9d3a2f8ae$var$nativeSlice = $1b239fc9d3a2f8ae$var$arrayProto.slice;
var $1b239fc9d3a2f8ae$var$nativeMap = $1b239fc9d3a2f8ae$var$arrayProto.map;
var $1b239fc9d3a2f8ae$var$ctorFunction = (function() {}).constructor;
var $1b239fc9d3a2f8ae$var$protoFunction = $1b239fc9d3a2f8ae$var$ctorFunction ? $1b239fc9d3a2f8ae$var$ctorFunction.prototype : null;
var $1b239fc9d3a2f8ae$var$protoKey = '__proto__';
var $1b239fc9d3a2f8ae$var$idStart = 0x0907;
function $1b239fc9d3a2f8ae$export$46e8f25c7328f77e() {
    return $1b239fc9d3a2f8ae$var$idStart++;
}
function $1b239fc9d3a2f8ae$export$58da9968c3170cb1() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    if (typeof console !== 'undefined') console.error.apply(console, args);
}
function $1b239fc9d3a2f8ae$export$9cd59f9826255e47(source) {
    if (source == null || typeof source !== 'object') return source;
    var result = source;
    var typeStr = $1b239fc9d3a2f8ae$var$objToString.call(source);
    if (typeStr === '[object Array]') {
        if (!$1b239fc9d3a2f8ae$export$c3825b437cbdea5c(source)) {
            result = [];
            for(var i = 0, len = source.length; i < len; i++)result[i] = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(source[i]);
        }
    } else if ($1b239fc9d3a2f8ae$var$TYPED_ARRAY[typeStr]) {
        if (!$1b239fc9d3a2f8ae$export$c3825b437cbdea5c(source)) {
            var Ctor = source.constructor;
            if (Ctor.from) result = Ctor.from(source);
            else {
                result = new Ctor(source.length);
                for(var i = 0, len = source.length; i < len; i++)result[i] = source[i];
            }
        }
    } else if (!$1b239fc9d3a2f8ae$var$BUILTIN_OBJECT[typeStr] && !$1b239fc9d3a2f8ae$export$c3825b437cbdea5c(source) && !$1b239fc9d3a2f8ae$export$9f57505b7bd8dae(source)) {
        result = {};
        for(var key in source)if (source.hasOwnProperty(key) && key !== $1b239fc9d3a2f8ae$var$protoKey) result[key] = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(source[key]);
    }
    return result;
}
function $1b239fc9d3a2f8ae$export$4950aa0f605343fb(target, source, overwrite) {
    if (!$1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(source) || !$1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(target)) return overwrite ? $1b239fc9d3a2f8ae$export$9cd59f9826255e47(source) : target;
    for(var key in source)if (source.hasOwnProperty(key) && key !== $1b239fc9d3a2f8ae$var$protoKey) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(sourceProp) && $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(targetProp) && !$1b239fc9d3a2f8ae$export$43bee75e5e14138e(sourceProp) && !$1b239fc9d3a2f8ae$export$43bee75e5e14138e(targetProp) && !$1b239fc9d3a2f8ae$export$9f57505b7bd8dae(sourceProp) && !$1b239fc9d3a2f8ae$export$9f57505b7bd8dae(targetProp) && !$1b239fc9d3a2f8ae$export$fa523b2c4941fd4f(sourceProp) && !$1b239fc9d3a2f8ae$export$fa523b2c4941fd4f(targetProp) && !$1b239fc9d3a2f8ae$export$c3825b437cbdea5c(sourceProp) && !$1b239fc9d3a2f8ae$export$c3825b437cbdea5c(targetProp)) $1b239fc9d3a2f8ae$export$4950aa0f605343fb(targetProp, sourceProp, overwrite);
        else if (overwrite || !(key in target)) target[key] = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(source[key]);
    }
    return target;
}
function $1b239fc9d3a2f8ae$export$18aef43295bbe906(targetAndSources, overwrite) {
    var result = targetAndSources[0];
    for(var i = 1, len = targetAndSources.length; i < len; i++)result = $1b239fc9d3a2f8ae$export$4950aa0f605343fb(result, targetAndSources[i], overwrite);
    return result;
}
function $1b239fc9d3a2f8ae$export$8b58be045bf06082(target, source) {
    if (Object.assign) Object.assign(target, source);
    else {
        for(var key in source)if (source.hasOwnProperty(key) && key !== $1b239fc9d3a2f8ae$var$protoKey) target[key] = source[key];
    }
    return target;
}
function $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(target, source, overlay) {
    var keysArr = $1b239fc9d3a2f8ae$export$ed97f33186d4b816(source);
    for(var i = 0, len = keysArr.length; i < len; i++){
        var key = keysArr[i];
        if (overlay ? source[key] != null : target[key] == null) target[key] = source[key];
    }
    return target;
}
var $1b239fc9d3a2f8ae$export$cd3d1f114b139967 = (0, $024b63ea846a8ccd$export$ef5e599365494451).createCanvas;
function $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(array, value) {
    if (array) {
        if (array.indexOf) return array.indexOf(value);
        for(var i = 0, len = array.length; i < len; i++){
            if (array[i] === value) return i;
        }
    }
    return -1;
}
function $1b239fc9d3a2f8ae$export$69f1b2dcda23c5f8(clazz, baseClazz) {
    var clazzPrototype = clazz.prototype;
    function F() {}
    F.prototype = baseClazz.prototype;
    clazz.prototype = new F();
    for(var prop in clazzPrototype)if (clazzPrototype.hasOwnProperty(prop)) clazz.prototype[prop] = clazzPrototype[prop];
    clazz.prototype.constructor = clazz;
    clazz.superClass = baseClazz;
}
function $1b239fc9d3a2f8ae$export$e36fc9d62a853069(target, source, override) {
    target = 'prototype' in target ? target.prototype : target;
    source = 'prototype' in source ? source.prototype : source;
    if (Object.getOwnPropertyNames) {
        var keyList = Object.getOwnPropertyNames(source);
        for(var i = 0; i < keyList.length; i++){
            var key = keyList[i];
            if (key !== 'constructor') {
                if (override ? source[key] != null : target[key] == null) target[key] = source[key];
            }
        }
    } else $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(target, source, override);
}
function $1b239fc9d3a2f8ae$export$1e2f57719e155213(data) {
    if (!data) return false;
    if (typeof data === 'string') return false;
    return typeof data.length === 'number';
}
function $1b239fc9d3a2f8ae$export$79b2f7037acddd43(arr, cb, context) {
    if (!(arr && cb)) return;
    if (arr.forEach && arr.forEach === $1b239fc9d3a2f8ae$var$nativeForEach) arr.forEach(cb, context);
    else if (arr.length === +arr.length) for(var i = 0, len = arr.length; i < len; i++)cb.call(context, arr[i], i, arr);
    else {
        for(var key in arr)if (arr.hasOwnProperty(key)) cb.call(context, arr[key], key, arr);
    }
}
function $1b239fc9d3a2f8ae$export$871de8747c9eaa88(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $1b239fc9d3a2f8ae$export$58adb3bec8346d0f(arr);
    if (arr.map && arr.map === $1b239fc9d3a2f8ae$var$nativeMap) return arr.map(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)result.push(cb.call(context, arr[i], i, arr));
        return result;
    }
}
function $1b239fc9d3a2f8ae$export$533b26079ad0b4b(arr, cb, memo, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++)memo = cb.call(context, memo, arr[i], i, arr);
    return memo;
}
function $1b239fc9d3a2f8ae$export$3dea766d36a8935f(arr, cb, context) {
    if (!arr) return [];
    if (!cb) return $1b239fc9d3a2f8ae$export$58adb3bec8346d0f(arr);
    if (arr.filter && arr.filter === $1b239fc9d3a2f8ae$var$nativeFilter) return arr.filter(cb, context);
    else {
        var result = [];
        for(var i = 0, len = arr.length; i < len; i++)if (cb.call(context, arr[i], i, arr)) result.push(arr[i]);
        return result;
    }
}
function $1b239fc9d3a2f8ae$export$71aa6c912b956294(arr, cb, context) {
    if (!(arr && cb)) return;
    for(var i = 0, len = arr.length; i < len; i++){
        if (cb.call(context, arr[i], i, arr)) return arr[i];
    }
}
function $1b239fc9d3a2f8ae$export$ed97f33186d4b816(obj) {
    if (!obj) return [];
    if (Object.keys) return Object.keys(obj);
    var keyList = [];
    for(var key in obj)if (obj.hasOwnProperty(key)) keyList.push(key);
    return keyList;
}
function $1b239fc9d3a2f8ae$var$bindPolyfill(func, context) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return function() {
        return func.apply(context, args.concat($1b239fc9d3a2f8ae$var$nativeSlice.call(arguments)));
    };
}
var $1b239fc9d3a2f8ae$export$2385a24977818dd0 = $1b239fc9d3a2f8ae$var$protoFunction && $1b239fc9d3a2f8ae$export$f6e2535fb5126e54($1b239fc9d3a2f8ae$var$protoFunction.bind) ? $1b239fc9d3a2f8ae$var$protoFunction.call.bind($1b239fc9d3a2f8ae$var$protoFunction.bind) : $1b239fc9d3a2f8ae$var$bindPolyfill;
function $1b239fc9d3a2f8ae$export$c3095a23b368d1f2(func) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return function() {
        return func.apply(this, args.concat($1b239fc9d3a2f8ae$var$nativeSlice.call(arguments)));
    };
}
function $1b239fc9d3a2f8ae$export$43bee75e5e14138e(value) {
    if (Array.isArray) return Array.isArray(value);
    return $1b239fc9d3a2f8ae$var$objToString.call(value) === '[object Array]';
}
function $1b239fc9d3a2f8ae$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $1b239fc9d3a2f8ae$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
function $1b239fc9d3a2f8ae$export$29d0bb2a4e07b252(value) {
    return $1b239fc9d3a2f8ae$var$objToString.call(value) === '[object String]';
}
function $1b239fc9d3a2f8ae$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
function $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return type === 'function' || !!value && type === 'object';
}
function $1b239fc9d3a2f8ae$export$fa523b2c4941fd4f(value) {
    return !!$1b239fc9d3a2f8ae$var$BUILTIN_OBJECT[$1b239fc9d3a2f8ae$var$objToString.call(value)];
}
function $1b239fc9d3a2f8ae$export$b119cc7e1840e59c(value) {
    return !!$1b239fc9d3a2f8ae$var$TYPED_ARRAY[$1b239fc9d3a2f8ae$var$objToString.call(value)];
}
function $1b239fc9d3a2f8ae$export$9f57505b7bd8dae(value) {
    return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
}
function $1b239fc9d3a2f8ae$export$fa2c283003ed971c(value) {
    return value.colorStops != null;
}
function $1b239fc9d3a2f8ae$export$a49bbf3a55dcef7b(value) {
    return value.image != null;
}
function $1b239fc9d3a2f8ae$export$49841c62b9eff15(value) {
    return $1b239fc9d3a2f8ae$var$objToString.call(value) === '[object RegExp]';
}
function $1b239fc9d3a2f8ae$export$7d667b9a0c48c975(value) {
    return value !== value;
}
function $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    for(var i = 0, len = args.length; i < len; i++){
        if (args[i] != null) return args[i];
    }
}
function $1b239fc9d3a2f8ae$export$995e01f2f5c9d030(value0, value1) {
    return value0 != null ? value0 : value1;
}
function $1b239fc9d3a2f8ae$export$2e94551289abb95b(value0, value1, value2) {
    return value0 != null ? value0 : value1 != null ? value1 : value2;
}
function $1b239fc9d3a2f8ae$export$58adb3bec8346d0f(arr) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    return $1b239fc9d3a2f8ae$var$nativeSlice.apply(arr, args);
}
function $1b239fc9d3a2f8ae$export$f3a38102c49f4268(val) {
    if (typeof val === 'number') return [
        val,
        val,
        val,
        val
    ];
    var len = val.length;
    if (len === 2) return [
        val[0],
        val[1],
        val[0],
        val[1]
    ];
    else if (len === 3) return [
        val[0],
        val[1],
        val[2],
        val[1]
    ];
    return val;
}
function $1b239fc9d3a2f8ae$export$a7a9523472993e97(condition, message) {
    if (!condition) throw new Error(message);
}
function $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab(str) {
    if (str == null) return null;
    else if (typeof str.trim === 'function') return str.trim();
    else return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
}
var $1b239fc9d3a2f8ae$var$primitiveKey = '__ec_primitive__';
function $1b239fc9d3a2f8ae$export$112e66431016387b(obj) {
    obj[$1b239fc9d3a2f8ae$var$primitiveKey] = true;
}
function $1b239fc9d3a2f8ae$export$c3825b437cbdea5c(obj) {
    return obj[$1b239fc9d3a2f8ae$var$primitiveKey];
}
var $1b239fc9d3a2f8ae$var$MapPolyfill = function() {
    function MapPolyfill() {
        this.data = {};
    }
    MapPolyfill.prototype["delete"] = function(key) {
        var existed = this.has(key);
        if (existed) delete this.data[key];
        return existed;
    };
    MapPolyfill.prototype.has = function(key) {
        return this.data.hasOwnProperty(key);
    };
    MapPolyfill.prototype.get = function(key) {
        return this.data[key];
    };
    MapPolyfill.prototype.set = function(key, value) {
        this.data[key] = value;
        return this;
    };
    MapPolyfill.prototype.keys = function() {
        return $1b239fc9d3a2f8ae$export$ed97f33186d4b816(this.data);
    };
    MapPolyfill.prototype.forEach = function(callback) {
        var data = this.data;
        for(var key in data)if (data.hasOwnProperty(key)) callback(data[key], key);
    };
    return MapPolyfill;
}();
var $1b239fc9d3a2f8ae$var$isNativeMapSupported = typeof Map === 'function';
function $1b239fc9d3a2f8ae$var$maybeNativeMap() {
    return $1b239fc9d3a2f8ae$var$isNativeMapSupported ? new Map() : new $1b239fc9d3a2f8ae$var$MapPolyfill();
}
var $1b239fc9d3a2f8ae$export$60ef0b43d585640a = function() {
    function HashMap(obj) {
        var isArr = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(obj);
        this.data = $1b239fc9d3a2f8ae$var$maybeNativeMap();
        var thisMap = this;
        obj instanceof HashMap ? obj.each(visit) : obj && $1b239fc9d3a2f8ae$export$79b2f7037acddd43(obj, visit);
        function visit(value, key) {
            isArr ? thisMap.set(value, key) : thisMap.set(key, value);
        }
    }
    HashMap.prototype.hasKey = function(key) {
        return this.data.has(key);
    };
    HashMap.prototype.get = function(key) {
        return this.data.get(key);
    };
    HashMap.prototype.set = function(key, value) {
        this.data.set(key, value);
        return value;
    };
    HashMap.prototype.each = function(cb, context) {
        this.data.forEach(function(value, key) {
            cb.call(context, value, key);
        });
    };
    HashMap.prototype.keys = function() {
        var keys = this.data.keys();
        return $1b239fc9d3a2f8ae$var$isNativeMapSupported ? Array.from(keys) : keys;
    };
    HashMap.prototype.removeKey = function(key) {
        this.data["delete"](key);
    };
    return HashMap;
}();
function $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4(obj) {
    return new $1b239fc9d3a2f8ae$export$60ef0b43d585640a(obj);
}
function $1b239fc9d3a2f8ae$export$4fd8af2c48c43416(a, b) {
    var newArray = new a.constructor(a.length + b.length);
    for(var i = 0; i < a.length; i++)newArray[i] = a[i];
    var offset = a.length;
    for(var i = 0; i < b.length; i++)newArray[i + offset] = b[i];
    return newArray;
}
function $1b239fc9d3a2f8ae$export$79c7e160a7743efd(proto, properties) {
    var obj;
    if (Object.create) obj = Object.create(proto);
    else {
        var StyleCtor = function() {};
        StyleCtor.prototype = proto;
        obj = new StyleCtor();
    }
    if (properties) $1b239fc9d3a2f8ae$export$8b58be045bf06082(obj, properties);
    return obj;
}
function $1b239fc9d3a2f8ae$export$23a5d775868fdd2c(dom) {
    var domStyle = dom.style;
    domStyle.webkitUserSelect = 'none';
    domStyle.userSelect = 'none';
    domStyle.webkitTapHighlightColor = 'rgba(0,0,0,0)';
    domStyle['-webkit-touch-callout'] = 'none';
}
function $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3(own, prop) {
    return own.hasOwnProperty(prop);
}
function $1b239fc9d3a2f8ae$export$8793edee2d425525() {}
var $1b239fc9d3a2f8ae$export$bce8e055322a0ce6 = 180 / Math.PI;




function $3dde7d051fe20daa$export$185802fd694ee1f5(x, y) {
    if (x == null) x = 0;
    if (y == null) y = 0;
    return [
        x,
        y
    ];
}
function $3dde7d051fe20daa$export$784d13d8ee351f07(out, v) {
    out[0] = v[0];
    out[1] = v[1];
    return out;
}
function $3dde7d051fe20daa$export$9cd59f9826255e47(v) {
    return [
        v[0],
        v[1]
    ];
}
function $3dde7d051fe20daa$export$adaa4cf7ef1b65be(out, a, b) {
    out[0] = a;
    out[1] = b;
    return out;
}
function $3dde7d051fe20daa$export$e16d8520af44a096(out, v1, v2) {
    out[0] = v1[0] + v2[0];
    out[1] = v1[1] + v2[1];
    return out;
}
function $3dde7d051fe20daa$export$19cedf1da84ba854(out, v1, v2, a) {
    out[0] = v1[0] + v2[0] * a;
    out[1] = v1[1] + v2[1] * a;
    return out;
}
function $3dde7d051fe20daa$export$f93b5905241a7cca(out, v1, v2) {
    out[0] = v1[0] - v2[0];
    out[1] = v1[1] - v2[1];
    return out;
}
function $3dde7d051fe20daa$export$fc1400facf92c78(v) {
    return Math.sqrt($3dde7d051fe20daa$export$48e33bc611e4c25a(v));
}
var $3dde7d051fe20daa$export$f24224f1c91d8156 = $3dde7d051fe20daa$export$fc1400facf92c78;
function $3dde7d051fe20daa$export$48e33bc611e4c25a(v) {
    return v[0] * v[0] + v[1] * v[1];
}
var $3dde7d051fe20daa$export$2f106540dd9a5136 = $3dde7d051fe20daa$export$48e33bc611e4c25a;
function $3dde7d051fe20daa$export$6e3a27864ab166fe(out, v1, v2) {
    out[0] = v1[0] * v2[0];
    out[1] = v1[1] * v2[1];
    return out;
}
function $3dde7d051fe20daa$export$159d9494db57879b(out, v1, v2) {
    out[0] = v1[0] / v2[0];
    out[1] = v1[1] / v2[1];
    return out;
}
function $3dde7d051fe20daa$export$94132a0e348806d4(v1, v2) {
    return v1[0] * v2[0] + v1[1] * v2[1];
}
function $3dde7d051fe20daa$export$dcdf75081b88279d(out, v, s) {
    out[0] = v[0] * s;
    out[1] = v[1] * s;
    return out;
}
function $3dde7d051fe20daa$export$a3295358bff77e(out, v) {
    var d = $3dde7d051fe20daa$export$fc1400facf92c78(v);
    if (d === 0) {
        out[0] = 0;
        out[1] = 0;
    } else {
        out[0] = v[0] / d;
        out[1] = v[1] / d;
    }
    return out;
}
function $3dde7d051fe20daa$export$9f17032d917177de(v1, v2) {
    return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
}
var $3dde7d051fe20daa$export$6c4a311cc157c764 = $3dde7d051fe20daa$export$9f17032d917177de;
function $3dde7d051fe20daa$export$137c0a69d1ff4a79(v1, v2) {
    return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
}
var $3dde7d051fe20daa$export$c68db45a034c13b0 = $3dde7d051fe20daa$export$137c0a69d1ff4a79;
function $3dde7d051fe20daa$export$aef51622e549b8b0(out, v) {
    out[0] = -v[0];
    out[1] = -v[1];
    return out;
}
function $3dde7d051fe20daa$export$3a89f8d6f6bf6c9f(out, v1, v2, t) {
    out[0] = v1[0] + t * (v2[0] - v1[0]);
    out[1] = v1[1] + t * (v2[1] - v1[1]);
    return out;
}
function $3dde7d051fe20daa$export$9f9dcb98c894b623(out, v, m) {
    var x = v[0];
    var y = v[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $3dde7d051fe20daa$export$96ec731ed4dcb222(out, v1, v2) {
    out[0] = Math.min(v1[0], v2[0]);
    out[1] = Math.min(v1[1], v2[1]);
    return out;
}
function $3dde7d051fe20daa$export$8960430cfd85939f(out, v1, v2) {
    out[0] = Math.max(v1[0], v2[0]);
    out[1] = Math.max(v1[1], v2[1]);
    return out;
}


var $90e6083b80550a55$var$Param = function() {
    function Param(target, e) {
        this.target = target;
        this.topTarget = e && e.topTarget;
    }
    return Param;
}();
var $90e6083b80550a55$var$Draggable = function() {
    function Draggable(handler) {
        this.handler = handler;
        handler.on('mousedown', this._dragStart, this);
        handler.on('mousemove', this._drag, this);
        handler.on('mouseup', this._dragEnd, this);
    }
    Draggable.prototype._dragStart = function(e) {
        var draggingTarget = e.target;
        while(draggingTarget && !draggingTarget.draggable)draggingTarget = draggingTarget.parent || draggingTarget.__hostTarget;
        if (draggingTarget) {
            this._draggingTarget = draggingTarget;
            draggingTarget.dragging = true;
            this._x = e.offsetX;
            this._y = e.offsetY;
            this.handler.dispatchToElement(new $90e6083b80550a55$var$Param(draggingTarget, e), 'dragstart', e.event);
        }
    };
    Draggable.prototype._drag = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) {
            var x = e.offsetX;
            var y = e.offsetY;
            var dx = x - this._x;
            var dy = y - this._y;
            this._x = x;
            this._y = y;
            draggingTarget.drift(dx, dy, e);
            this.handler.dispatchToElement(new $90e6083b80550a55$var$Param(draggingTarget, e), 'drag', e.event);
            var dropTarget = this.handler.findHover(x, y, draggingTarget).target;
            var lastDropTarget = this._dropTarget;
            this._dropTarget = dropTarget;
            if (draggingTarget !== dropTarget) {
                if (lastDropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $90e6083b80550a55$var$Param(lastDropTarget, e), 'dragleave', e.event);
                if (dropTarget && dropTarget !== lastDropTarget) this.handler.dispatchToElement(new $90e6083b80550a55$var$Param(dropTarget, e), 'dragenter', e.event);
            }
        }
    };
    Draggable.prototype._dragEnd = function(e) {
        var draggingTarget = this._draggingTarget;
        if (draggingTarget) draggingTarget.dragging = false;
        this.handler.dispatchToElement(new $90e6083b80550a55$var$Param(draggingTarget, e), 'dragend', e.event);
        if (this._dropTarget) this.handler.dispatchToElement(new $90e6083b80550a55$var$Param(this._dropTarget, e), 'drop', e.event);
        this._draggingTarget = null;
        this._dropTarget = null;
    };
    return Draggable;
}();
var $90e6083b80550a55$export$2e2bcd8739ae039 = $90e6083b80550a55$var$Draggable;


var $abe8d7fba81d88ed$var$Eventful = function() {
    function Eventful(eventProcessors) {
        if (eventProcessors) this._$eventProcessor = eventProcessors;
    }
    Eventful.prototype.on = function(event, query, handler, context) {
        if (!this._$handlers) this._$handlers = {};
        var _h = this._$handlers;
        if (typeof query === 'function') {
            context = handler;
            handler = query;
            query = null;
        }
        if (!handler || !event) return this;
        var eventProcessor = this._$eventProcessor;
        if (query != null && eventProcessor && eventProcessor.normalizeQuery) query = eventProcessor.normalizeQuery(query);
        if (!_h[event]) _h[event] = [];
        for(var i = 0; i < _h[event].length; i++){
            if (_h[event][i].h === handler) return this;
        }
        var wrap = {
            h: handler,
            query: query,
            ctx: context || this,
            callAtLast: handler.zrEventfulCallAtLast
        };
        var lastIndex = _h[event].length - 1;
        var lastWrap = _h[event][lastIndex];
        lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
        return this;
    };
    Eventful.prototype.isSilent = function(eventName) {
        var _h = this._$handlers;
        return !_h || !_h[eventName] || !_h[eventName].length;
    };
    Eventful.prototype.off = function(eventType, handler) {
        var _h = this._$handlers;
        if (!_h) return this;
        if (!eventType) {
            this._$handlers = {};
            return this;
        }
        if (handler) {
            if (_h[eventType]) {
                var newList = [];
                for(var i = 0, l = _h[eventType].length; i < l; i++)if (_h[eventType][i].h !== handler) newList.push(_h[eventType][i]);
                _h[eventType] = newList;
            }
            if (_h[eventType] && _h[eventType].length === 0) delete _h[eventType];
        } else delete _h[eventType];
        return this;
    };
    Eventful.prototype.trigger = function(eventType) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[eventType];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(eventType, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(hItem.ctx);
                        break;
                    case 1:
                        hItem.h.call(hItem.ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(hItem.ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(hItem.ctx, args);
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(eventType);
        return this;
    };
    Eventful.prototype.triggerWithContext = function(type) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (!this._$handlers) return this;
        var _h = this._$handlers[type];
        var eventProcessor = this._$eventProcessor;
        if (_h) {
            var argLen = args.length;
            var ctx = args[argLen - 1];
            var len = _h.length;
            for(var i = 0; i < len; i++){
                var hItem = _h[i];
                if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) continue;
                switch(argLen){
                    case 0:
                        hItem.h.call(ctx);
                        break;
                    case 1:
                        hItem.h.call(ctx, args[0]);
                        break;
                    case 2:
                        hItem.h.call(ctx, args[0], args[1]);
                        break;
                    default:
                        hItem.h.apply(ctx, args.slice(1, argLen - 1));
                        break;
                }
            }
        }
        eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
        return this;
    };
    return Eventful;
}();
var $abe8d7fba81d88ed$export$2e2bcd8739ae039 = $abe8d7fba81d88ed$var$Eventful;





var $f9b43e6e197e1449$var$LN2 = Math.log(2);
function $f9b43e6e197e1449$var$determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
    var cacheKey = rowMask + '-' + colMask;
    var fullRank = rows.length;
    if (detCache.hasOwnProperty(cacheKey)) return detCache[cacheKey];
    if (rank === 1) {
        var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / $f9b43e6e197e1449$var$LN2);
        return rows[rowStart][colStart];
    }
    var subRowMask = rowMask | 1 << rowStart;
    var subRowStart = rowStart + 1;
    while(rowMask & 1 << subRowStart)subRowStart++;
    var sum = 0;
    for(var j = 0, colLocalIdx = 0; j < fullRank; j++){
        var colTag = 1 << j;
        if (!(colTag & colMask)) {
            sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] * $f9b43e6e197e1449$var$determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
            colLocalIdx++;
        }
    }
    detCache[cacheKey] = sum;
    return sum;
}
function $f9b43e6e197e1449$export$fbdb2748a8171a7e(src, dest) {
    var mA = [
        [
            src[0],
            src[1],
            1,
            0,
            0,
            0,
            -dest[0] * src[0],
            -dest[0] * src[1]
        ],
        [
            0,
            0,
            0,
            src[0],
            src[1],
            1,
            -dest[1] * src[0],
            -dest[1] * src[1]
        ],
        [
            src[2],
            src[3],
            1,
            0,
            0,
            0,
            -dest[2] * src[2],
            -dest[2] * src[3]
        ],
        [
            0,
            0,
            0,
            src[2],
            src[3],
            1,
            -dest[3] * src[2],
            -dest[3] * src[3]
        ],
        [
            src[4],
            src[5],
            1,
            0,
            0,
            0,
            -dest[4] * src[4],
            -dest[4] * src[5]
        ],
        [
            0,
            0,
            0,
            src[4],
            src[5],
            1,
            -dest[5] * src[4],
            -dest[5] * src[5]
        ],
        [
            src[6],
            src[7],
            1,
            0,
            0,
            0,
            -dest[6] * src[6],
            -dest[6] * src[7]
        ],
        [
            0,
            0,
            0,
            src[6],
            src[7],
            1,
            -dest[7] * src[6],
            -dest[7] * src[7]
        ]
    ];
    var detCache = {};
    var det = $f9b43e6e197e1449$var$determinant(mA, 8, 0, 0, 0, detCache);
    if (det === 0) return;
    var vh = [];
    for(var i = 0; i < 8; i++)for(var j = 0; j < 8; j++){
        vh[j] == null && (vh[j] = 0);
        vh[j] += ((i + j) % 2 ? -1 : 1) * $f9b43e6e197e1449$var$determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
    }
    return function(out, srcPointX, srcPointY) {
        var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
        out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
        out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
    };
}


var $8032584326d71745$var$EVENT_SAVED_PROP = '___zrEVENTSAVED';
var $8032584326d71745$var$_calcOut = [];
function $8032584326d71745$export$8c5c02e118307e20(out, elFrom, elTarget, inX, inY) {
    return $8032584326d71745$export$1219648acc517df4($8032584326d71745$var$_calcOut, elFrom, inX, inY, true) && $8032584326d71745$export$1219648acc517df4(out, elTarget, $8032584326d71745$var$_calcOut[0], $8032584326d71745$var$_calcOut[1]);
}
function $8032584326d71745$export$1219648acc517df4(out, el, inX, inY, inverse) {
    if (el.getBoundingClientRect && (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).domSupported && !$8032584326d71745$export$1b92e4fe606eff6d(el)) {
        var saved = el[$8032584326d71745$var$EVENT_SAVED_PROP] || (el[$8032584326d71745$var$EVENT_SAVED_PROP] = {});
        var markers = $8032584326d71745$var$prepareCoordMarkers(el, saved);
        var transformer = $8032584326d71745$var$preparePointerTransformer(markers, saved, inverse);
        if (transformer) {
            transformer(out, inX, inY);
            return true;
        }
    }
    return false;
}
function $8032584326d71745$var$prepareCoordMarkers(el, saved) {
    var markers = saved.markers;
    if (markers) return markers;
    markers = saved.markers = [];
    var propLR = [
        'left',
        'right'
    ];
    var propTB = [
        'top',
        'bottom'
    ];
    for(var i = 0; i < 4; i++){
        var marker = document.createElement('div');
        var stl = marker.style;
        var idxLR = i % 2;
        var idxTB = (i >> 1) % 2;
        stl.cssText = [
            'position: absolute',
            'visibility: hidden',
            'padding: 0',
            'margin: 0',
            'border-width: 0',
            'user-select: none',
            'width:0',
            'height:0',
            propLR[idxLR] + ':0',
            propTB[idxTB] + ':0',
            propLR[1 - idxLR] + ':auto',
            propTB[1 - idxTB] + ':auto',
            ''
        ].join('!important;');
        el.appendChild(marker);
        markers.push(marker);
    }
    return markers;
}
function $8032584326d71745$var$preparePointerTransformer(markers, saved, inverse) {
    var transformerName = inverse ? 'invTrans' : 'trans';
    var transformer = saved[transformerName];
    var oldSrcCoords = saved.srcCoords;
    var srcCoords = [];
    var destCoords = [];
    var oldCoordTheSame = true;
    for(var i = 0; i < 4; i++){
        var rect = markers[i].getBoundingClientRect();
        var ii = 2 * i;
        var x = rect.left;
        var y = rect.top;
        srcCoords.push(x, y);
        oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
        destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
    }
    return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? (0, $f9b43e6e197e1449$export$fbdb2748a8171a7e)(destCoords, srcCoords) : (0, $f9b43e6e197e1449$export$fbdb2748a8171a7e)(srcCoords, destCoords));
}
function $8032584326d71745$export$1b92e4fe606eff6d(el) {
    return el.nodeName.toUpperCase() === 'CANVAS';
}
var $8032584326d71745$var$replaceReg = /([&<>"'])/g;
var $8032584326d71745$var$replaceMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#39;'
};
function $8032584326d71745$export$f9d6449b9af28dc1(source) {
    return source == null ? '' : (source + '').replace($8032584326d71745$var$replaceReg, function(str, c) {
        return $8032584326d71745$var$replaceMap[c];
    });
}


var $8f7ba7c16ab1583e$var$MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
var $8f7ba7c16ab1583e$var$_calcOut = [];
var $8f7ba7c16ab1583e$var$firefoxNotSupportOffsetXY = (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).browser.firefox && +(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).browser.version.split('.')[0] < 39;
function $8f7ba7c16ab1583e$export$7d5fecde839eee88(el, e, out, calculate) {
    out = out || {};
    if (calculate) $8f7ba7c16ab1583e$var$calculateZrXY(el, e, out);
    else if ($8f7ba7c16ab1583e$var$firefoxNotSupportOffsetXY && e.layerX != null && e.layerX !== e.offsetX) {
        out.zrX = e.layerX;
        out.zrY = e.layerY;
    } else if (e.offsetX != null) {
        out.zrX = e.offsetX;
        out.zrY = e.offsetY;
    } else $8f7ba7c16ab1583e$var$calculateZrXY(el, e, out);
    return out;
}
function $8f7ba7c16ab1583e$var$calculateZrXY(el, e, out) {
    if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).domSupported && el.getBoundingClientRect) {
        var ex = e.clientX;
        var ey = e.clientY;
        if ((0, $8032584326d71745$export$1b92e4fe606eff6d)(el)) {
            var box = el.getBoundingClientRect();
            out.zrX = ex - box.left;
            out.zrY = ey - box.top;
            return;
        } else if ((0, $8032584326d71745$export$1219648acc517df4)($8f7ba7c16ab1583e$var$_calcOut, el, ex, ey)) {
            out.zrX = $8f7ba7c16ab1583e$var$_calcOut[0];
            out.zrY = $8f7ba7c16ab1583e$var$_calcOut[1];
            return;
        }
    }
    out.zrX = out.zrY = 0;
}
function $8f7ba7c16ab1583e$export$4abe0e945399ac1d(e) {
    return e || window.event;
}
function $8f7ba7c16ab1583e$export$40fadb093aebad71(el, e, calculate) {
    e = $8f7ba7c16ab1583e$export$4abe0e945399ac1d(e);
    if (e.zrX != null) return e;
    var eventType = e.type;
    var isTouch = eventType && eventType.indexOf('touch') >= 0;
    if (!isTouch) {
        $8f7ba7c16ab1583e$export$7d5fecde839eee88(el, e, e, calculate);
        var wheelDelta = $8f7ba7c16ab1583e$var$getWheelDeltaMayPolyfill(e);
        e.zrDelta = wheelDelta ? wheelDelta / 120 : -(e.detail || 0) / 3;
    } else {
        var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
        touch && $8f7ba7c16ab1583e$export$7d5fecde839eee88(el, touch, e, calculate);
    }
    var button = e.button;
    if (e.which == null && button !== undefined && $8f7ba7c16ab1583e$var$MOUSE_EVENT_REG.test(e.type)) e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
    return e;
}
function $8f7ba7c16ab1583e$var$getWheelDeltaMayPolyfill(e) {
    var rawWheelDelta = e.wheelDelta;
    if (rawWheelDelta) return rawWheelDelta;
    var deltaX = e.deltaX;
    var deltaY = e.deltaY;
    if (deltaX == null || deltaY == null) return rawWheelDelta;
    var delta = deltaY !== 0 ? Math.abs(deltaY) : Math.abs(deltaX);
    var sign = deltaY > 0 ? -1 : deltaY < 0 ? 1 : deltaX > 0 ? -1 : 1;
    return 3 * delta * sign;
}
function $8f7ba7c16ab1583e$export$3f65cefe8380dbea(el, name, handler, opt) {
    el.addEventListener(name, handler, opt);
}
function $8f7ba7c16ab1583e$export$8ff9f68337b520c0(el, name, handler, opt) {
    el.removeEventListener(name, handler, opt);
}
var $8f7ba7c16ab1583e$export$fa6813432f753b0d = function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.cancelBubble = true;
};
function $8f7ba7c16ab1583e$export$b7ae4cded3e71bd2(e) {
    return e.which === 2 || e.which === 3;
}



var $a9a46c49021f5414$export$f7557d6f27e9503 = function() {
    function GestureMgr() {
        this._track = [];
    }
    GestureMgr.prototype.recognize = function(event, target, root) {
        this._doTrack(event, target, root);
        return this._recognize(event);
    };
    GestureMgr.prototype.clear = function() {
        this._track.length = 0;
        return this;
    };
    GestureMgr.prototype._doTrack = function(event, target, root) {
        var touches = event.touches;
        if (!touches) return;
        var trackItem = {
            points: [],
            touches: [],
            target: target,
            event: event
        };
        for(var i = 0, len = touches.length; i < len; i++){
            var touch = touches[i];
            var pos = $8f7ba7c16ab1583e$export$7d5fecde839eee88(root, touch, {});
            trackItem.points.push([
                pos.zrX,
                pos.zrY
            ]);
            trackItem.touches.push(touch);
        }
        this._track.push(trackItem);
    };
    GestureMgr.prototype._recognize = function(event) {
        for(var eventName in $a9a46c49021f5414$var$recognizers)if ($a9a46c49021f5414$var$recognizers.hasOwnProperty(eventName)) {
            var gestureInfo = $a9a46c49021f5414$var$recognizers[eventName](this._track, event);
            if (gestureInfo) return gestureInfo;
        }
    };
    return GestureMgr;
}();
function $a9a46c49021f5414$var$dist(pointPair) {
    var dx = pointPair[1][0] - pointPair[0][0];
    var dy = pointPair[1][1] - pointPair[0][1];
    return Math.sqrt(dx * dx + dy * dy);
}
function $a9a46c49021f5414$var$center(pointPair) {
    return [
        (pointPair[0][0] + pointPair[1][0]) / 2,
        (pointPair[0][1] + pointPair[1][1]) / 2
    ];
}
var $a9a46c49021f5414$var$recognizers = {
    pinch: function(tracks, event) {
        var trackLen = tracks.length;
        if (!trackLen) return;
        var pinchEnd = (tracks[trackLen - 1] || {}).points;
        var pinchPre = (tracks[trackLen - 2] || {}).points || pinchEnd;
        if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
            var pinchScale = $a9a46c49021f5414$var$dist(pinchEnd) / $a9a46c49021f5414$var$dist(pinchPre);
            !isFinite(pinchScale) && (pinchScale = 1);
            event.pinchScale = pinchScale;
            var pinchCenter = $a9a46c49021f5414$var$center(pinchEnd);
            event.pinchX = pinchCenter[0];
            event.pinchY = pinchCenter[1];
            return {
                type: 'pinch',
                target: tracks[0].target,
                event: event
            };
        }
    }
};


function $78537c687449356c$export$185802fd694ee1f5() {
    return [
        1,
        0,
        0,
        1,
        0,
        0
    ];
}
function $78537c687449356c$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
}
function $78537c687449356c$export$784d13d8ee351f07(out, m) {
    out[0] = m[0];
    out[1] = m[1];
    out[2] = m[2];
    out[3] = m[3];
    out[4] = m[4];
    out[5] = m[5];
    return out;
}
function $78537c687449356c$export$6e3a27864ab166fe(out, m1, m2) {
    var out0 = m1[0] * m2[0] + m1[2] * m2[1];
    var out1 = m1[1] * m2[0] + m1[3] * m2[1];
    var out2 = m1[0] * m2[2] + m1[2] * m2[3];
    var out3 = m1[1] * m2[2] + m1[3] * m2[3];
    var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
    var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = out3;
    out[4] = out4;
    out[5] = out5;
    return out;
}
function $78537c687449356c$export$d73ee8ef04f5226a(out, a, v) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4] + v[0];
    out[5] = a[5] + v[1];
    return out;
}
function $78537c687449356c$export$bb628a54ab399bc9(out, a, rad, pivot) {
    if (pivot === void 0) pivot = [
        0,
        0
    ];
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var st = Math.sin(rad);
    var ct = Math.cos(rad);
    out[0] = aa * ct + ab * st;
    out[1] = -aa * st + ab * ct;
    out[2] = ac * ct + ad * st;
    out[3] = -ac * st + ct * ad;
    out[4] = ct * (atx - pivot[0]) + st * (aty - pivot[1]) + pivot[0];
    out[5] = ct * (aty - pivot[1]) - st * (atx - pivot[0]) + pivot[1];
    return out;
}
function $78537c687449356c$export$dcdf75081b88279d(out, a, v) {
    var vx = v[0];
    var vy = v[1];
    out[0] = a[0] * vx;
    out[1] = a[1] * vy;
    out[2] = a[2] * vx;
    out[3] = a[3] * vy;
    out[4] = a[4] * vx;
    out[5] = a[5] * vy;
    return out;
}
function $78537c687449356c$export$6897c284b6f9f4dc(out, a) {
    var aa = a[0];
    var ac = a[2];
    var atx = a[4];
    var ab = a[1];
    var ad = a[3];
    var aty = a[5];
    var det = aa * ad - ab * ac;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
}
function $78537c687449356c$export$9cd59f9826255e47(a) {
    var b = $78537c687449356c$export$185802fd694ee1f5();
    $78537c687449356c$export$784d13d8ee351f07(b, a);
    return b;
}


var $1a833abf0e5915e2$var$Point = function() {
    function Point(x, y) {
        this.x = x || 0;
        this.y = y || 0;
    }
    Point.prototype.copy = function(other) {
        this.x = other.x;
        this.y = other.y;
        return this;
    };
    Point.prototype.clone = function() {
        return new Point(this.x, this.y);
    };
    Point.prototype.set = function(x, y) {
        this.x = x;
        this.y = y;
        return this;
    };
    Point.prototype.equal = function(other) {
        return other.x === this.x && other.y === this.y;
    };
    Point.prototype.add = function(other) {
        this.x += other.x;
        this.y += other.y;
        return this;
    };
    Point.prototype.scale = function(scalar) {
        this.x *= scalar;
        this.y *= scalar;
    };
    Point.prototype.scaleAndAdd = function(other, scalar) {
        this.x += other.x * scalar;
        this.y += other.y * scalar;
    };
    Point.prototype.sub = function(other) {
        this.x -= other.x;
        this.y -= other.y;
        return this;
    };
    Point.prototype.dot = function(other) {
        return this.x * other.x + this.y * other.y;
    };
    Point.prototype.len = function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    };
    Point.prototype.lenSquare = function() {
        return this.x * this.x + this.y * this.y;
    };
    Point.prototype.normalize = function() {
        var len = this.len();
        this.x /= len;
        this.y /= len;
        return this;
    };
    Point.prototype.distance = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.distanceSquare = function(other) {
        var dx = this.x - other.x;
        var dy = this.y - other.y;
        return dx * dx + dy * dy;
    };
    Point.prototype.negate = function() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    };
    Point.prototype.transform = function(m) {
        if (!m) return;
        var x = this.x;
        var y = this.y;
        this.x = m[0] * x + m[2] * y + m[4];
        this.y = m[1] * x + m[3] * y + m[5];
        return this;
    };
    Point.prototype.toArray = function(out) {
        out[0] = this.x;
        out[1] = this.y;
        return out;
    };
    Point.prototype.fromArray = function(input) {
        this.x = input[0];
        this.y = input[1];
    };
    Point.set = function(p, x, y) {
        p.x = x;
        p.y = y;
    };
    Point.copy = function(p, p2) {
        p.x = p2.x;
        p.y = p2.y;
    };
    Point.len = function(p) {
        return Math.sqrt(p.x * p.x + p.y * p.y);
    };
    Point.lenSquare = function(p) {
        return p.x * p.x + p.y * p.y;
    };
    Point.dot = function(p0, p1) {
        return p0.x * p1.x + p0.y * p1.y;
    };
    Point.add = function(out, p0, p1) {
        out.x = p0.x + p1.x;
        out.y = p0.y + p1.y;
    };
    Point.sub = function(out, p0, p1) {
        out.x = p0.x - p1.x;
        out.y = p0.y - p1.y;
    };
    Point.scale = function(out, p0, scalar) {
        out.x = p0.x * scalar;
        out.y = p0.y * scalar;
    };
    Point.scaleAndAdd = function(out, p0, p1, scalar) {
        out.x = p0.x + p1.x * scalar;
        out.y = p0.y + p1.y * scalar;
    };
    Point.lerp = function(out, p0, p1, t) {
        var onet = 1 - t;
        out.x = onet * p0.x + t * p1.x;
        out.y = onet * p0.y + t * p1.y;
    };
    return Point;
}();
var $1a833abf0e5915e2$export$2e2bcd8739ae039 = $1a833abf0e5915e2$var$Point;


var $020465b49a1dd45f$var$mathMin = Math.min;
var $020465b49a1dd45f$var$mathMax = Math.max;
var $020465b49a1dd45f$var$lt = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $020465b49a1dd45f$var$rb = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $020465b49a1dd45f$var$lb = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $020465b49a1dd45f$var$rt = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $020465b49a1dd45f$var$minTv = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $020465b49a1dd45f$var$maxTv = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $020465b49a1dd45f$var$BoundingRect = function() {
    function BoundingRect(x, y, width, height) {
        if (width < 0) {
            x = x + width;
            width = -width;
        }
        if (height < 0) {
            y = y + height;
            height = -height;
        }
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BoundingRect.prototype.union = function(other) {
        var x = $020465b49a1dd45f$var$mathMin(other.x, this.x);
        var y = $020465b49a1dd45f$var$mathMin(other.y, this.y);
        if (isFinite(this.x) && isFinite(this.width)) this.width = $020465b49a1dd45f$var$mathMax(other.x + other.width, this.x + this.width) - x;
        else this.width = other.width;
        if (isFinite(this.y) && isFinite(this.height)) this.height = $020465b49a1dd45f$var$mathMax(other.y + other.height, this.y + this.height) - y;
        else this.height = other.height;
        this.x = x;
        this.y = y;
    };
    BoundingRect.prototype.applyTransform = function(m) {
        BoundingRect.applyTransform(this, this, m);
    };
    BoundingRect.prototype.calculateTransform = function(b) {
        var a = this;
        var sx = b.width / a.width;
        var sy = b.height / a.height;
        var m = $78537c687449356c$export$185802fd694ee1f5();
        $78537c687449356c$export$d73ee8ef04f5226a(m, m, [
            -a.x,
            -a.y
        ]);
        $78537c687449356c$export$dcdf75081b88279d(m, m, [
            sx,
            sy
        ]);
        $78537c687449356c$export$d73ee8ef04f5226a(m, m, [
            b.x,
            b.y
        ]);
        return m;
    };
    BoundingRect.prototype.intersect = function(b, mtv) {
        if (!b) return false;
        if (!(b instanceof BoundingRect)) b = BoundingRect.create(b);
        var a = this;
        var ax0 = a.x;
        var ax1 = a.x + a.width;
        var ay0 = a.y;
        var ay1 = a.y + a.height;
        var bx0 = b.x;
        var bx1 = b.x + b.width;
        var by0 = b.y;
        var by1 = b.y + b.height;
        var overlap = !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
        if (mtv) {
            var dMin = Infinity;
            var dMax = 0;
            var d0 = Math.abs(ax1 - bx0);
            var d1 = Math.abs(bx1 - ax0);
            var d2 = Math.abs(ay1 - by0);
            var d3 = Math.abs(by1 - ay0);
            var dx = Math.min(d0, d1);
            var dy = Math.min(d2, d3);
            if (ax1 < bx0 || bx1 < ax0) {
                if (dx > dMax) {
                    dMax = dx;
                    if (d0 < d1) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$maxTv, -d0, 0);
                    else (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$maxTv, d1, 0);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d0 < d1) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$minTv, d0, 0);
                else (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$minTv, -d1, 0);
            }
            if (ay1 < by0 || by1 < ay0) {
                if (dy > dMax) {
                    dMax = dy;
                    if (d2 < d3) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$maxTv, 0, -d2);
                    else (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$maxTv, 0, d3);
                }
            } else if (dx < dMin) {
                dMin = dx;
                if (d2 < d3) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$minTv, 0, d2);
                else (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).set($020465b49a1dd45f$var$minTv, 0, -d3);
            }
        }
        if (mtv) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).copy(mtv, overlap ? $020465b49a1dd45f$var$minTv : $020465b49a1dd45f$var$maxTv);
        return overlap;
    };
    BoundingRect.prototype.contain = function(x, y) {
        var rect = this;
        return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
    };
    BoundingRect.prototype.clone = function() {
        return new BoundingRect(this.x, this.y, this.width, this.height);
    };
    BoundingRect.prototype.copy = function(other) {
        BoundingRect.copy(this, other);
    };
    BoundingRect.prototype.plain = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height
        };
    };
    BoundingRect.prototype.isFinite = function() {
        return isFinite(this.x) && isFinite(this.y) && isFinite(this.width) && isFinite(this.height);
    };
    BoundingRect.prototype.isZero = function() {
        return this.width === 0 || this.height === 0;
    };
    BoundingRect.create = function(rect) {
        return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
    };
    BoundingRect.copy = function(target, source) {
        target.x = source.x;
        target.y = source.y;
        target.width = source.width;
        target.height = source.height;
    };
    BoundingRect.applyTransform = function(target, source, m) {
        if (!m) {
            if (target !== source) BoundingRect.copy(target, source);
            return;
        }
        if (m[1] < 1e-5 && m[1] > -0.00001 && m[2] < 1e-5 && m[2] > -0.00001) {
            var sx = m[0];
            var sy = m[3];
            var tx = m[4];
            var ty = m[5];
            target.x = source.x * sx + tx;
            target.y = source.y * sy + ty;
            target.width = source.width * sx;
            target.height = source.height * sy;
            if (target.width < 0) {
                target.x += target.width;
                target.width = -target.width;
            }
            if (target.height < 0) {
                target.y += target.height;
                target.height = -target.height;
            }
            return;
        }
        $020465b49a1dd45f$var$lt.x = $020465b49a1dd45f$var$lb.x = source.x;
        $020465b49a1dd45f$var$lt.y = $020465b49a1dd45f$var$rt.y = source.y;
        $020465b49a1dd45f$var$rb.x = $020465b49a1dd45f$var$rt.x = source.x + source.width;
        $020465b49a1dd45f$var$rb.y = $020465b49a1dd45f$var$lb.y = source.y + source.height;
        $020465b49a1dd45f$var$lt.transform(m);
        $020465b49a1dd45f$var$rt.transform(m);
        $020465b49a1dd45f$var$rb.transform(m);
        $020465b49a1dd45f$var$lb.transform(m);
        target.x = $020465b49a1dd45f$var$mathMin($020465b49a1dd45f$var$lt.x, $020465b49a1dd45f$var$rb.x, $020465b49a1dd45f$var$lb.x, $020465b49a1dd45f$var$rt.x);
        target.y = $020465b49a1dd45f$var$mathMin($020465b49a1dd45f$var$lt.y, $020465b49a1dd45f$var$rb.y, $020465b49a1dd45f$var$lb.y, $020465b49a1dd45f$var$rt.y);
        var maxX = $020465b49a1dd45f$var$mathMax($020465b49a1dd45f$var$lt.x, $020465b49a1dd45f$var$rb.x, $020465b49a1dd45f$var$lb.x, $020465b49a1dd45f$var$rt.x);
        var maxY = $020465b49a1dd45f$var$mathMax($020465b49a1dd45f$var$lt.y, $020465b49a1dd45f$var$rb.y, $020465b49a1dd45f$var$lb.y, $020465b49a1dd45f$var$rt.y);
        target.width = maxX - target.x;
        target.height = maxY - target.y;
    };
    return BoundingRect;
}();
var $020465b49a1dd45f$export$2e2bcd8739ae039 = $020465b49a1dd45f$var$BoundingRect;


var $75cb27ac1e5e15ce$var$SILENT = 'silent';
function $75cb27ac1e5e15ce$var$makeEventPacket(eveType, targetInfo, event) {
    return {
        type: eveType,
        event: event,
        target: targetInfo.target,
        topTarget: targetInfo.topTarget,
        cancelBubble: false,
        offsetX: event.zrX,
        offsetY: event.zrY,
        gestureEvent: event.gestureEvent,
        pinchX: event.pinchX,
        pinchY: event.pinchY,
        pinchScale: event.pinchScale,
        wheelDelta: event.zrDelta,
        zrByTouch: event.zrByTouch,
        which: event.which,
        stop: $75cb27ac1e5e15ce$var$stopEvent
    };
}
function $75cb27ac1e5e15ce$var$stopEvent() {
    $8f7ba7c16ab1583e$export$fa6813432f753b0d(this.event);
}
var $75cb27ac1e5e15ce$var$EmptyProxy = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(EmptyProxy, _super);
    function EmptyProxy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handler = null;
        return _this;
    }
    EmptyProxy.prototype.dispose = function() {};
    EmptyProxy.prototype.setCursor = function() {};
    return EmptyProxy;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
var $75cb27ac1e5e15ce$var$HoveredResult = function() {
    function HoveredResult(x, y) {
        this.x = x;
        this.y = y;
    }
    return HoveredResult;
}();
var $75cb27ac1e5e15ce$var$handlerNames = [
    'click',
    'dblclick',
    'mousewheel',
    'mouseout',
    'mouseup',
    'mousedown',
    'mousemove',
    'contextmenu'
];
var $75cb27ac1e5e15ce$var$tmpRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $75cb27ac1e5e15ce$var$Handler = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Handler, _super);
    function Handler(storage, painter, proxy, painterRoot, pointerSize) {
        var _this = _super.call(this) || this;
        _this._hovered = new $75cb27ac1e5e15ce$var$HoveredResult(0, 0);
        _this.storage = storage;
        _this.painter = painter;
        _this.painterRoot = painterRoot;
        _this._pointerSize = pointerSize;
        proxy = proxy || new $75cb27ac1e5e15ce$var$EmptyProxy();
        _this.proxy = null;
        _this.setHandlerProxy(proxy);
        _this._draggingMgr = new (0, $90e6083b80550a55$export$2e2bcd8739ae039)(_this);
        return _this;
    }
    Handler.prototype.setHandlerProxy = function(proxy) {
        if (this.proxy) this.proxy.dispose();
        if (proxy) {
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43($75cb27ac1e5e15ce$var$handlerNames, function(name) {
                proxy.on && proxy.on(name, this[name], this);
            }, this);
            proxy.handler = this;
        }
        this.proxy = proxy;
    };
    Handler.prototype.mousemove = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $75cb27ac1e5e15ce$var$isOutsideBoundary(this, x, y);
        var lastHovered = this._hovered;
        var lastHoveredTarget = lastHovered.target;
        if (lastHoveredTarget && !lastHoveredTarget.__zr) {
            lastHovered = this.findHover(lastHovered.x, lastHovered.y);
            lastHoveredTarget = lastHovered.target;
        }
        var hovered = this._hovered = isOutside ? new $75cb27ac1e5e15ce$var$HoveredResult(x, y) : this.findHover(x, y);
        var hoveredTarget = hovered.target;
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default');
        if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(lastHovered, 'mouseout', event);
        this.dispatchToElement(hovered, 'mousemove', event);
        if (hoveredTarget && hoveredTarget !== lastHoveredTarget) this.dispatchToElement(hovered, 'mouseover', event);
    };
    Handler.prototype.mouseout = function(event) {
        var eventControl = event.zrEventControl;
        if (eventControl !== 'only_globalout') this.dispatchToElement(this._hovered, 'mouseout', event);
        if (eventControl !== 'no_globalout') this.trigger('globalout', {
            type: 'globalout',
            event: event
        });
    };
    Handler.prototype.resize = function() {
        this._hovered = new $75cb27ac1e5e15ce$var$HoveredResult(0, 0);
    };
    Handler.prototype.dispatch = function(eventName, eventArgs) {
        var handler = this[eventName];
        handler && handler.call(this, eventArgs);
    };
    Handler.prototype.dispose = function() {
        this.proxy.dispose();
        this.storage = null;
        this.proxy = null;
        this.painter = null;
    };
    Handler.prototype.setCursorStyle = function(cursorStyle) {
        var proxy = this.proxy;
        proxy.setCursor && proxy.setCursor(cursorStyle);
    };
    Handler.prototype.dispatchToElement = function(targetInfo, eventName, event) {
        targetInfo = targetInfo || {};
        var el = targetInfo.target;
        if (el && el.silent) return;
        var eventKey = 'on' + eventName;
        var eventPacket = $75cb27ac1e5e15ce$var$makeEventPacket(eventName, targetInfo, event);
        while(el){
            el[eventKey] && (eventPacket.cancelBubble = !!el[eventKey].call(el, eventPacket));
            el.trigger(eventName, eventPacket);
            el = el.__hostTarget ? el.__hostTarget : el.parent;
            if (eventPacket.cancelBubble) break;
        }
        if (!eventPacket.cancelBubble) {
            this.trigger(eventName, eventPacket);
            if (this.painter && this.painter.eachOtherLayer) this.painter.eachOtherLayer(function(layer) {
                if (typeof layer[eventKey] === 'function') layer[eventKey].call(layer, eventPacket);
                if (layer.trigger) layer.trigger(eventName, eventPacket);
            });
        }
    };
    Handler.prototype.findHover = function(x, y, exclude) {
        var list = this.storage.getDisplayList();
        var out = new $75cb27ac1e5e15ce$var$HoveredResult(x, y);
        $75cb27ac1e5e15ce$var$setHoverTarget(list, out, x, y, exclude);
        if (this._pointerSize && !out.target) {
            var candidates = [];
            var pointerSize = this._pointerSize;
            var targetSizeHalf = pointerSize / 2;
            var pointerRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x - targetSizeHalf, y - targetSizeHalf, pointerSize, pointerSize);
            for(var i = list.length - 1; i >= 0; i--){
                var el = list[i];
                if (el !== exclude && !el.ignore && !el.ignoreCoarsePointer && (!el.parent || !el.parent.ignoreCoarsePointer)) {
                    $75cb27ac1e5e15ce$var$tmpRect.copy(el.getBoundingRect());
                    if (el.transform) $75cb27ac1e5e15ce$var$tmpRect.applyTransform(el.transform);
                    if ($75cb27ac1e5e15ce$var$tmpRect.intersect(pointerRect)) candidates.push(el);
                }
            }
            if (candidates.length) {
                var rStep = 4;
                var thetaStep = Math.PI / 12;
                var PI2 = Math.PI * 2;
                for(var r = 0; r < targetSizeHalf; r += rStep)for(var theta = 0; theta < PI2; theta += thetaStep){
                    var x1 = x + r * Math.cos(theta);
                    var y1 = y + r * Math.sin(theta);
                    $75cb27ac1e5e15ce$var$setHoverTarget(candidates, out, x1, y1, exclude);
                    if (out.target) return out;
                }
            }
        }
        return out;
    };
    Handler.prototype.processGesture = function(event, stage) {
        if (!this._gestureMgr) this._gestureMgr = new (0, $a9a46c49021f5414$export$f7557d6f27e9503)();
        var gestureMgr = this._gestureMgr;
        stage === 'start' && gestureMgr.clear();
        var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
        stage === 'end' && gestureMgr.clear();
        if (gestureInfo) {
            var type = gestureInfo.type;
            event.gestureEvent = type;
            var res = new $75cb27ac1e5e15ce$var$HoveredResult();
            res.target = gestureInfo.target;
            this.dispatchToElement(res, type, gestureInfo.event);
        }
    };
    return Handler;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
$1b239fc9d3a2f8ae$export$79b2f7037acddd43([
    'click',
    'mousedown',
    'mouseup',
    'mousewheel',
    'dblclick',
    'contextmenu'
], function(name) {
    $75cb27ac1e5e15ce$var$Handler.prototype[name] = function(event) {
        var x = event.zrX;
        var y = event.zrY;
        var isOutside = $75cb27ac1e5e15ce$var$isOutsideBoundary(this, x, y);
        var hovered;
        var hoveredTarget;
        if (name !== 'mouseup' || !isOutside) {
            hovered = this.findHover(x, y);
            hoveredTarget = hovered.target;
        }
        if (name === 'mousedown') {
            this._downEl = hoveredTarget;
            this._downPoint = [
                event.zrX,
                event.zrY
            ];
            this._upEl = hoveredTarget;
        } else if (name === 'mouseup') this._upEl = hoveredTarget;
        else if (name === 'click') {
            if (this._downEl !== this._upEl || !this._downPoint || $3dde7d051fe20daa$export$6c4a311cc157c764(this._downPoint, [
                event.zrX,
                event.zrY
            ]) > 4) return;
            this._downPoint = null;
        }
        this.dispatchToElement(hovered, name, event);
    };
});
function $75cb27ac1e5e15ce$var$isHover(displayable, x, y) {
    if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
        var el = displayable;
        var isSilent = void 0;
        var ignoreClip = false;
        while(el){
            if (el.ignoreClip) ignoreClip = true;
            if (!ignoreClip) {
                var clipPath = el.getClipPath();
                if (clipPath && !clipPath.contain(x, y)) return false;
            }
            if (el.silent) isSilent = true;
            var hostEl = el.__hostTarget;
            el = hostEl ? hostEl : el.parent;
        }
        return isSilent ? $75cb27ac1e5e15ce$var$SILENT : true;
    }
    return false;
}
function $75cb27ac1e5e15ce$var$setHoverTarget(list, out, x, y, exclude) {
    for(var i = list.length - 1; i >= 0; i--){
        var el = list[i];
        var hoverCheckResult = void 0;
        if (el !== exclude && !el.ignore && (hoverCheckResult = $75cb27ac1e5e15ce$var$isHover(el, x, y))) {
            !out.topTarget && (out.topTarget = el);
            if (hoverCheckResult !== $75cb27ac1e5e15ce$var$SILENT) {
                out.target = el;
                break;
            }
        }
    }
}
function $75cb27ac1e5e15ce$var$isOutsideBoundary(handlerInstance, x, y) {
    var painter = handlerInstance.painter;
    return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
}
var $75cb27ac1e5e15ce$export$2e2bcd8739ae039 = $75cb27ac1e5e15ce$var$Handler;



var $f91119cfbd7f3e96$var$DEFAULT_MIN_MERGE = 32;
var $f91119cfbd7f3e96$var$DEFAULT_MIN_GALLOPING = 7;
function $f91119cfbd7f3e96$var$minRunLength(n) {
    var r = 0;
    while(n >= $f91119cfbd7f3e96$var$DEFAULT_MIN_MERGE){
        r |= n & 1;
        n >>= 1;
    }
    return n + r;
}
function $f91119cfbd7f3e96$var$makeAscendingRun(array, lo, hi, compare) {
    var runHi = lo + 1;
    if (runHi === hi) return 1;
    if (compare(array[runHi++], array[lo]) < 0) {
        while(runHi < hi && compare(array[runHi], array[runHi - 1]) < 0)runHi++;
        $f91119cfbd7f3e96$var$reverseRun(array, lo, runHi);
    } else while(runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0)runHi++;
    return runHi - lo;
}
function $f91119cfbd7f3e96$var$reverseRun(array, lo, hi) {
    hi--;
    while(lo < hi){
        var t = array[lo];
        array[lo++] = array[hi];
        array[hi--] = t;
    }
}
function $f91119cfbd7f3e96$var$binaryInsertionSort(array, lo, hi, start, compare) {
    if (start === lo) start++;
    for(; start < hi; start++){
        var pivot = array[start];
        var left = lo;
        var right = start;
        var mid;
        while(left < right){
            mid = left + right >>> 1;
            if (compare(pivot, array[mid]) < 0) right = mid;
            else left = mid + 1;
        }
        var n = start - left;
        switch(n){
            case 3:
                array[left + 3] = array[left + 2];
            case 2:
                array[left + 2] = array[left + 1];
            case 1:
                array[left + 1] = array[left];
                break;
            default:
                while(n > 0){
                    array[left + n] = array[left + n - 1];
                    n--;
                }
        }
        array[left] = pivot;
    }
}
function $f91119cfbd7f3e96$var$gallopLeft(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) > 0) {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) > 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    } else {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) <= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) > 0) lastOffset = m + 1;
        else offset = m;
    }
    return offset;
}
function $f91119cfbd7f3e96$var$gallopRight(value, array, start, length, hint, compare) {
    var lastOffset = 0;
    var maxOffset = 0;
    var offset = 1;
    if (compare(value, array[start + hint]) < 0) {
        maxOffset = hint + 1;
        while(offset < maxOffset && compare(value, array[start + hint - offset]) < 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        var tmp = lastOffset;
        lastOffset = hint - offset;
        offset = hint - tmp;
    } else {
        maxOffset = length - hint;
        while(offset < maxOffset && compare(value, array[start + hint + offset]) >= 0){
            lastOffset = offset;
            offset = (offset << 1) + 1;
            if (offset <= 0) offset = maxOffset;
        }
        if (offset > maxOffset) offset = maxOffset;
        lastOffset += hint;
        offset += hint;
    }
    lastOffset++;
    while(lastOffset < offset){
        var m = lastOffset + (offset - lastOffset >>> 1);
        if (compare(value, array[start + m]) < 0) offset = m;
        else lastOffset = m + 1;
    }
    return offset;
}
function $f91119cfbd7f3e96$var$TimSort(array, compare) {
    var minGallop = $f91119cfbd7f3e96$var$DEFAULT_MIN_GALLOPING;
    var runStart;
    var runLength;
    var stackSize = 0;
    var tmp = [];
    runStart = [];
    runLength = [];
    function pushRun(_runStart, _runLength) {
        runStart[stackSize] = _runStart;
        runLength[stackSize] = _runLength;
        stackSize += 1;
    }
    function mergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
                if (runLength[n - 1] < runLength[n + 1]) n--;
            } else if (runLength[n] > runLength[n + 1]) break;
            mergeAt(n);
        }
    }
    function forceMergeRuns() {
        while(stackSize > 1){
            var n = stackSize - 2;
            if (n > 0 && runLength[n - 1] < runLength[n + 1]) n--;
            mergeAt(n);
        }
    }
    function mergeAt(i) {
        var start1 = runStart[i];
        var length1 = runLength[i];
        var start2 = runStart[i + 1];
        var length2 = runLength[i + 1];
        runLength[i] = length1 + length2;
        if (i === stackSize - 3) {
            runStart[i + 1] = runStart[i + 2];
            runLength[i + 1] = runLength[i + 2];
        }
        stackSize--;
        var k = $f91119cfbd7f3e96$var$gallopRight(array[start2], array, start1, length1, 0, compare);
        start1 += k;
        length1 -= k;
        if (length1 === 0) return;
        length2 = $f91119cfbd7f3e96$var$gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
        if (length2 === 0) return;
        if (length1 <= length2) mergeLow(start1, length1, start2, length2);
        else mergeHigh(start1, length1, start2, length2);
    }
    function mergeLow(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length1; i++)tmp[i] = array[start1 + i];
        var cursor1 = 0;
        var cursor2 = start2;
        var dest = start1;
        array[dest++] = array[cursor2++];
        if (--length2 === 0) {
            for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
            return;
        }
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
            return;
        }
        var _minGallop = minGallop;
        var count1;
        var count2;
        var exit;
        while(true){
            count1 = 0;
            count2 = 0;
            exit = false;
            do if (compare(array[cursor2], tmp[cursor1]) < 0) {
                array[dest++] = array[cursor2++];
                count2++;
                count1 = 0;
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest++] = tmp[cursor1++];
                count1++;
                count2 = 0;
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = $f91119cfbd7f3e96$var$gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
                if (count1 !== 0) {
                    for(i = 0; i < count1; i++)array[dest + i] = tmp[cursor1 + i];
                    dest += count1;
                    cursor1 += count1;
                    length1 -= count1;
                    if (length1 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = array[cursor2++];
                if (--length2 === 0) {
                    exit = true;
                    break;
                }
                count2 = $f91119cfbd7f3e96$var$gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
                if (count2 !== 0) {
                    for(i = 0; i < count2; i++)array[dest + i] = array[cursor2 + i];
                    dest += count2;
                    cursor2 += count2;
                    length2 -= count2;
                    if (length2 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest++] = tmp[cursor1++];
                if (--length1 === 1) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $f91119cfbd7f3e96$var$DEFAULT_MIN_GALLOPING || count2 >= $f91119cfbd7f3e96$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        minGallop < 1 && (minGallop = 1);
        if (length1 === 1) {
            for(i = 0; i < length2; i++)array[dest + i] = array[cursor2 + i];
            array[dest + length2] = tmp[cursor1];
        } else if (length1 === 0) throw new Error();
        else for(i = 0; i < length1; i++)array[dest + i] = tmp[cursor1 + i];
    }
    function mergeHigh(start1, length1, start2, length2) {
        var i = 0;
        for(i = 0; i < length2; i++)tmp[i] = array[start2 + i];
        var cursor1 = start1 + length1 - 1;
        var cursor2 = length2 - 1;
        var dest = start2 + length2 - 1;
        var customCursor = 0;
        var customDest = 0;
        array[dest--] = array[cursor1--];
        if (--length1 === 0) {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
            return;
        }
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
            return;
        }
        var _minGallop = minGallop;
        while(true){
            var count1 = 0;
            var count2 = 0;
            var exit = false;
            do if (compare(tmp[cursor2], array[cursor1]) < 0) {
                array[dest--] = array[cursor1--];
                count1++;
                count2 = 0;
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
            } else {
                array[dest--] = tmp[cursor2--];
                count2++;
                count1 = 0;
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
            }
            while ((count1 | count2) < _minGallop);
            if (exit) break;
            do {
                count1 = length1 - $f91119cfbd7f3e96$var$gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
                if (count1 !== 0) {
                    dest -= count1;
                    cursor1 -= count1;
                    length1 -= count1;
                    customDest = dest + 1;
                    customCursor = cursor1 + 1;
                    for(i = count1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
                    if (length1 === 0) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = tmp[cursor2--];
                if (--length2 === 1) {
                    exit = true;
                    break;
                }
                count2 = length2 - $f91119cfbd7f3e96$var$gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
                if (count2 !== 0) {
                    dest -= count2;
                    cursor2 -= count2;
                    length2 -= count2;
                    customDest = dest + 1;
                    customCursor = cursor2 + 1;
                    for(i = 0; i < count2; i++)array[customDest + i] = tmp[customCursor + i];
                    if (length2 <= 1) {
                        exit = true;
                        break;
                    }
                }
                array[dest--] = array[cursor1--];
                if (--length1 === 0) {
                    exit = true;
                    break;
                }
                _minGallop--;
            }while (count1 >= $f91119cfbd7f3e96$var$DEFAULT_MIN_GALLOPING || count2 >= $f91119cfbd7f3e96$var$DEFAULT_MIN_GALLOPING);
            if (exit) break;
            if (_minGallop < 0) _minGallop = 0;
            _minGallop += 2;
        }
        minGallop = _minGallop;
        if (minGallop < 1) minGallop = 1;
        if (length2 === 1) {
            dest -= length1;
            cursor1 -= length1;
            customDest = dest + 1;
            customCursor = cursor1 + 1;
            for(i = length1 - 1; i >= 0; i--)array[customDest + i] = array[customCursor + i];
            array[dest] = tmp[cursor2];
        } else if (length2 === 0) throw new Error();
        else {
            customCursor = dest - (length2 - 1);
            for(i = 0; i < length2; i++)array[customCursor + i] = tmp[i];
        }
    }
    return {
        mergeRuns: mergeRuns,
        forceMergeRuns: forceMergeRuns,
        pushRun: pushRun
    };
}
function $f91119cfbd7f3e96$export$2e2bcd8739ae039(array, compare, lo, hi) {
    if (!lo) lo = 0;
    if (!hi) hi = array.length;
    var remaining = hi - lo;
    if (remaining < 2) return;
    var runLength = 0;
    if (remaining < $f91119cfbd7f3e96$var$DEFAULT_MIN_MERGE) {
        runLength = $f91119cfbd7f3e96$var$makeAscendingRun(array, lo, hi, compare);
        $f91119cfbd7f3e96$var$binaryInsertionSort(array, lo, hi, lo + runLength, compare);
        return;
    }
    var ts = $f91119cfbd7f3e96$var$TimSort(array, compare);
    var minRun = $f91119cfbd7f3e96$var$minRunLength(remaining);
    do {
        runLength = $f91119cfbd7f3e96$var$makeAscendingRun(array, lo, hi, compare);
        if (runLength < minRun) {
            var force = remaining;
            if (force > minRun) force = minRun;
            $f91119cfbd7f3e96$var$binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
            runLength = force;
        }
        ts.pushRun(lo, runLength);
        ts.mergeRuns();
        remaining -= runLength;
        lo += runLength;
    }while (remaining !== 0);
    ts.forceMergeRuns();
}


var $7bc42091a9de0611$export$a7b6db622c6c7dbd = 1;
var $7bc42091a9de0611$export$ada8b2beb3d76671 = 2;
var $7bc42091a9de0611$export$f75fe89a33ebe115 = 4;


var $129eca35d5db819d$var$invalidZErrorLogged = false;
function $129eca35d5db819d$var$logInvalidZError() {
    if ($129eca35d5db819d$var$invalidZErrorLogged) return;
    $129eca35d5db819d$var$invalidZErrorLogged = true;
    console.warn('z / z2 / zlevel of displayable is invalid, which may cause unexpected errors');
}
function $129eca35d5db819d$var$shapeCompareFunc(a, b) {
    if (a.zlevel === b.zlevel) {
        if (a.z === b.z) return a.z2 - b.z2;
        return a.z - b.z;
    }
    return a.zlevel - b.zlevel;
}
var $129eca35d5db819d$var$Storage = function() {
    function Storage() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        this.displayableSortFunc = $129eca35d5db819d$var$shapeCompareFunc;
    }
    Storage.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._roots.length; i++)this._roots[i].traverse(cb, context);
    };
    Storage.prototype.getDisplayList = function(update, includeIgnore) {
        includeIgnore = includeIgnore || false;
        var displayList = this._displayList;
        if (update || !displayList.length) this.updateDisplayList(includeIgnore);
        return displayList;
    };
    Storage.prototype.updateDisplayList = function(includeIgnore) {
        this._displayListLen = 0;
        var roots = this._roots;
        var displayList = this._displayList;
        for(var i = 0, len = roots.length; i < len; i++)this._updateAndAddDisplayable(roots[i], null, includeIgnore);
        displayList.length = this._displayListLen;
        (0, $f91119cfbd7f3e96$export$2e2bcd8739ae039)(displayList, $129eca35d5db819d$var$shapeCompareFunc);
    };
    Storage.prototype._updateAndAddDisplayable = function(el, clipPaths, includeIgnore) {
        if (el.ignore && !includeIgnore) return;
        el.beforeUpdate();
        el.update();
        el.afterUpdate();
        var userSetClipPath = el.getClipPath();
        if (el.ignoreClip) clipPaths = null;
        else if (userSetClipPath) {
            if (clipPaths) clipPaths = clipPaths.slice();
            else clipPaths = [];
            var currentClipPath = userSetClipPath;
            var parentClipPath = el;
            while(currentClipPath){
                currentClipPath.parent = parentClipPath;
                currentClipPath.updateTransform();
                clipPaths.push(currentClipPath);
                parentClipPath = currentClipPath;
                currentClipPath = currentClipPath.getClipPath();
            }
        }
        if (el.childrenRef) {
            var children = el.childrenRef();
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (el.__dirty) child.__dirty |= (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
                this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
            }
            el.__dirty = 0;
        } else {
            var disp = el;
            if (clipPaths && clipPaths.length) disp.__clipPaths = clipPaths;
            else if (disp.__clipPaths && disp.__clipPaths.length > 0) disp.__clipPaths = [];
            if (isNaN(disp.z)) {
                $129eca35d5db819d$var$logInvalidZError();
                disp.z = 0;
            }
            if (isNaN(disp.z2)) {
                $129eca35d5db819d$var$logInvalidZError();
                disp.z2 = 0;
            }
            if (isNaN(disp.zlevel)) {
                $129eca35d5db819d$var$logInvalidZError();
                disp.zlevel = 0;
            }
            this._displayList[this._displayListLen++] = disp;
        }
        var decalEl = el.getDecalElement && el.getDecalElement();
        if (decalEl) this._updateAndAddDisplayable(decalEl, clipPaths, includeIgnore);
        var textGuide = el.getTextGuideLine();
        if (textGuide) this._updateAndAddDisplayable(textGuide, clipPaths, includeIgnore);
        var textEl = el.getTextContent();
        if (textEl) this._updateAndAddDisplayable(textEl, clipPaths, includeIgnore);
    };
    Storage.prototype.addRoot = function(el) {
        if (el.__zr && el.__zr.storage === this) return;
        this._roots.push(el);
    };
    Storage.prototype.delRoot = function(el) {
        if (el instanceof Array) {
            for(var i = 0, l = el.length; i < l; i++)this.delRoot(el[i]);
            return;
        }
        var idx = $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(this._roots, el);
        if (idx >= 0) this._roots.splice(idx, 1);
    };
    Storage.prototype.delAllRoots = function() {
        this._roots = [];
        this._displayList = [];
        this._displayListLen = 0;
        return;
    };
    Storage.prototype.getRoots = function() {
        return this._roots;
    };
    Storage.prototype.dispose = function() {
        this._displayList = null;
        this._roots = null;
    };
    return Storage;
}();
var $129eca35d5db819d$export$2e2bcd8739ae039 = $129eca35d5db819d$var$Storage;





var $e582c54f2022f90d$var$requestAnimationFrame;
$e582c54f2022f90d$var$requestAnimationFrame = (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).hasGlobalWindow && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function(func) {
    return setTimeout(func, 16);
};
var $e582c54f2022f90d$export$2e2bcd8739ae039 = $e582c54f2022f90d$var$requestAnimationFrame;


var $6a7e03908369e2ad$var$easingFuncs = {
    linear: function(k) {
        return k;
    },
    quadraticIn: function(k) {
        return k * k;
    },
    quadraticOut: function(k) {
        return k * (2 - k);
    },
    quadraticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k;
        return -0.5 * (--k * (k - 2) - 1);
    },
    cubicIn: function(k) {
        return k * k * k;
    },
    cubicOut: function(k) {
        return --k * k * k + 1;
    },
    cubicInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k;
        return 0.5 * ((k -= 2) * k * k + 2);
    },
    quarticIn: function(k) {
        return k * k * k * k;
    },
    quarticOut: function(k) {
        return 1 - --k * k * k * k;
    },
    quarticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k;
        return -0.5 * ((k -= 2) * k * k * k - 2);
    },
    quinticIn: function(k) {
        return k * k * k * k * k;
    },
    quinticOut: function(k) {
        return --k * k * k * k * k + 1;
    },
    quinticInOut: function(k) {
        if ((k *= 2) < 1) return 0.5 * k * k * k * k * k;
        return 0.5 * ((k -= 2) * k * k * k * k + 2);
    },
    sinusoidalIn: function(k) {
        return 1 - Math.cos(k * Math.PI / 2);
    },
    sinusoidalOut: function(k) {
        return Math.sin(k * Math.PI / 2);
    },
    sinusoidalInOut: function(k) {
        return 0.5 * (1 - Math.cos(Math.PI * k));
    },
    exponentialIn: function(k) {
        return k === 0 ? 0 : Math.pow(1024, k - 1);
    },
    exponentialOut: function(k) {
        return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
    },
    exponentialInOut: function(k) {
        if (k === 0) return 0;
        if (k === 1) return 1;
        if ((k *= 2) < 1) return 0.5 * Math.pow(1024, k - 1);
        return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
    },
    circularIn: function(k) {
        return 1 - Math.sqrt(1 - k * k);
    },
    circularOut: function(k) {
        return Math.sqrt(1 - --k * k);
    },
    circularInOut: function(k) {
        if ((k *= 2) < 1) return -0.5 * (Math.sqrt(1 - k * k) - 1);
        return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
    },
    elasticIn: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
    },
    elasticOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
    },
    elasticInOut: function(k) {
        var s;
        var a = 0.1;
        var p = 0.4;
        if (k === 0) return 0;
        if (k === 1) return 1;
        if (!a || a < 1) {
            a = 1;
            s = p / 4;
        } else s = p * Math.asin(1 / a) / (2 * Math.PI);
        if ((k *= 2) < 1) return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
        return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    backIn: function(k) {
        var s = 1.70158;
        return k * k * ((s + 1) * k - s);
    },
    backOut: function(k) {
        var s = 1.70158;
        return --k * k * ((s + 1) * k + s) + 1;
    },
    backInOut: function(k) {
        var s = 2.5949095;
        if ((k *= 2) < 1) return 0.5 * (k * k * ((s + 1) * k - s));
        return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
    },
    bounceIn: function(k) {
        return 1 - $6a7e03908369e2ad$var$easingFuncs.bounceOut(1 - k);
    },
    bounceOut: function(k) {
        if (k < 1 / 2.75) return 7.5625 * k * k;
        else if (k < 2 / 2.75) return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
        else if (k < 2.5 / 2.75) return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
        else return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
    },
    bounceInOut: function(k) {
        if (k < 0.5) return $6a7e03908369e2ad$var$easingFuncs.bounceIn(k * 2) * 0.5;
        return $6a7e03908369e2ad$var$easingFuncs.bounceOut(k * 2 - 1) * 0.5 + 0.5;
    }
};
var $6a7e03908369e2ad$export$2e2bcd8739ae039 = $6a7e03908369e2ad$var$easingFuncs;




var $eea9463646207a7b$var$mathPow = Math.pow;
var $eea9463646207a7b$var$mathSqrt = Math.sqrt;
var $eea9463646207a7b$var$EPSILON = 1e-8;
var $eea9463646207a7b$var$EPSILON_NUMERIC = 1e-4;
var $eea9463646207a7b$var$THREE_SQRT = $eea9463646207a7b$var$mathSqrt(3);
var $eea9463646207a7b$var$ONE_THIRD = 1 / 3;
var $eea9463646207a7b$var$_v0 = (0, $3dde7d051fe20daa$export$185802fd694ee1f5)();
var $eea9463646207a7b$var$_v1 = (0, $3dde7d051fe20daa$export$185802fd694ee1f5)();
var $eea9463646207a7b$var$_v2 = (0, $3dde7d051fe20daa$export$185802fd694ee1f5)();
function $eea9463646207a7b$var$isAroundZero(val) {
    return val > -$eea9463646207a7b$var$EPSILON && val < $eea9463646207a7b$var$EPSILON;
}
function $eea9463646207a7b$var$isNotAroundZero(val) {
    return val > $eea9463646207a7b$var$EPSILON || val < -$eea9463646207a7b$var$EPSILON;
}
function $eea9463646207a7b$export$547c21de482bbcb2(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
}
function $eea9463646207a7b$export$55fce925c60b6271(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
}
function $eea9463646207a7b$export$ca5d13faa10b167e(p0, p1, p2, p3, val, roots) {
    var a = p3 + 3 * (p1 - p2) - p0;
    var b = 3 * (p2 - p1 * 2 + p0);
    var c = 3 * (p1 - p0);
    var d = p0 - val;
    var A = b * b - 3 * a * c;
    var B = b * c - 9 * a * d;
    var C = c * c - 3 * b * d;
    var n = 0;
    if ($eea9463646207a7b$var$isAroundZero(A) && $eea9463646207a7b$var$isAroundZero(B)) {
        if ($eea9463646207a7b$var$isAroundZero(b)) roots[0] = 0;
        else {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = B * B - 4 * A * C;
        if ($eea9463646207a7b$var$isAroundZero(disc)) {
            var K = B / A;
            var t1 = -b / a + K;
            var t2 = -K / 2;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        } else if (disc > 0) {
            var discSqrt = $eea9463646207a7b$var$mathSqrt(disc);
            var Y1 = A * b + 1.5 * a * (-B + discSqrt);
            var Y2 = A * b + 1.5 * a * (-B - discSqrt);
            if (Y1 < 0) Y1 = -$eea9463646207a7b$var$mathPow(-Y1, $eea9463646207a7b$var$ONE_THIRD);
            else Y1 = $eea9463646207a7b$var$mathPow(Y1, $eea9463646207a7b$var$ONE_THIRD);
            if (Y2 < 0) Y2 = -$eea9463646207a7b$var$mathPow(-Y2, $eea9463646207a7b$var$ONE_THIRD);
            else Y2 = $eea9463646207a7b$var$mathPow(Y2, $eea9463646207a7b$var$ONE_THIRD);
            var t1 = (-b - (Y1 + Y2)) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else {
            var T = (2 * A * b - 3 * a * B) / (2 * $eea9463646207a7b$var$mathSqrt(A * A * A));
            var theta = Math.acos(T) / 3;
            var ASqrt = $eea9463646207a7b$var$mathSqrt(A);
            var tmp = Math.cos(theta);
            var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
            var t2 = (-b + ASqrt * (tmp + $eea9463646207a7b$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            var t3 = (-b + ASqrt * (tmp - $eea9463646207a7b$var$THREE_SQRT * Math.sin(theta))) / (3 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
            if (t3 >= 0 && t3 <= 1) roots[n++] = t3;
        }
    }
    return n;
}
function $eea9463646207a7b$export$df1a172f100d0457(p0, p1, p2, p3, extrema) {
    var b = 6 * p2 - 12 * p1 + 6 * p0;
    var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
    var c = 3 * p1 - 3 * p0;
    var n = 0;
    if ($eea9463646207a7b$var$isAroundZero(a)) {
        if ($eea9463646207a7b$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($eea9463646207a7b$var$isAroundZero(disc)) extrema[0] = -b / (2 * a);
        else if (disc > 0) {
            var discSqrt = $eea9463646207a7b$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extrema[n++] = t1;
            if (t2 >= 0 && t2 <= 1) extrema[n++] = t2;
        }
    }
    return n;
}
function $eea9463646207a7b$export$a2ee23a0567039da(p0, p1, p2, p3, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p23 = (p3 - p2) * t + p2;
    var p012 = (p12 - p01) * t + p01;
    var p123 = (p23 - p12) * t + p12;
    var p0123 = (p123 - p012) * t + p012;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p0123;
    out[4] = p0123;
    out[5] = p123;
    out[6] = p23;
    out[7] = p3;
}
function $eea9463646207a7b$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    var prev;
    var next;
    var d1;
    var d2;
    $eea9463646207a7b$var$_v0[0] = x;
    $eea9463646207a7b$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $eea9463646207a7b$var$_v1[0] = $eea9463646207a7b$export$547c21de482bbcb2(x0, x1, x2, x3, _t);
        $eea9463646207a7b$var$_v1[1] = $eea9463646207a7b$export$547c21de482bbcb2(y0, y1, y2, y3, _t);
        d1 = (0, $3dde7d051fe20daa$export$c68db45a034c13b0)($eea9463646207a7b$var$_v0, $eea9463646207a7b$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $eea9463646207a7b$var$EPSILON_NUMERIC) break;
        prev = t - interval;
        next = t + interval;
        $eea9463646207a7b$var$_v1[0] = $eea9463646207a7b$export$547c21de482bbcb2(x0, x1, x2, x3, prev);
        $eea9463646207a7b$var$_v1[1] = $eea9463646207a7b$export$547c21de482bbcb2(y0, y1, y2, y3, prev);
        d1 = (0, $3dde7d051fe20daa$export$c68db45a034c13b0)($eea9463646207a7b$var$_v1, $eea9463646207a7b$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $eea9463646207a7b$var$_v2[0] = $eea9463646207a7b$export$547c21de482bbcb2(x0, x1, x2, x3, next);
            $eea9463646207a7b$var$_v2[1] = $eea9463646207a7b$export$547c21de482bbcb2(y0, y1, y2, y3, next);
            d2 = (0, $3dde7d051fe20daa$export$c68db45a034c13b0)($eea9463646207a7b$var$_v2, $eea9463646207a7b$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $eea9463646207a7b$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        out[1] = $eea9463646207a7b$export$547c21de482bbcb2(y0, y1, y2, y3, t);
    }
    return $eea9463646207a7b$var$mathSqrt(d);
}
function $eea9463646207a7b$export$af1875d576f60d7c(x0, y0, x1, y1, x2, y2, x3, y3, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $eea9463646207a7b$export$547c21de482bbcb2(x0, x1, x2, x3, t);
        var y = $eea9463646207a7b$export$547c21de482bbcb2(y0, y1, y2, y3, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}
function $eea9463646207a7b$export$af17094a950f5073(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
}
function $eea9463646207a7b$export$7e161e77e6fff8cb(p0, p1, p2, t) {
    return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
}
function $eea9463646207a7b$export$fd895ac7ee764967(p0, p1, p2, val, roots) {
    var a = p0 - 2 * p1 + p2;
    var b = 2 * (p1 - p0);
    var c = p0 - val;
    var n = 0;
    if ($eea9463646207a7b$var$isAroundZero(a)) {
        if ($eea9463646207a7b$var$isNotAroundZero(b)) {
            var t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ($eea9463646207a7b$var$isAroundZero(disc)) {
            var t1 = -b / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
        } else if (disc > 0) {
            var discSqrt = $eea9463646207a7b$var$mathSqrt(disc);
            var t1 = (-b + discSqrt) / (2 * a);
            var t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) roots[n++] = t1;
            if (t2 >= 0 && t2 <= 1) roots[n++] = t2;
        }
    }
    return n;
}
function $eea9463646207a7b$export$752e1f8c6e7f7e11(p0, p1, p2) {
    var divider = p0 + p2 - 2 * p1;
    if (divider === 0) return 0.5;
    else return (p0 - p1) / divider;
}
function $eea9463646207a7b$export$117c659e21a7a060(p0, p1, p2, t, out) {
    var p01 = (p1 - p0) * t + p0;
    var p12 = (p2 - p1) * t + p1;
    var p012 = (p12 - p01) * t + p01;
    out[0] = p0;
    out[1] = p01;
    out[2] = p012;
    out[3] = p012;
    out[4] = p12;
    out[5] = p2;
}
function $eea9463646207a7b$export$81915a594fe10dee(x0, y0, x1, y1, x2, y2, x, y, out) {
    var t;
    var interval = 0.005;
    var d = Infinity;
    $eea9463646207a7b$var$_v0[0] = x;
    $eea9463646207a7b$var$_v0[1] = y;
    for(var _t = 0; _t < 1; _t += 0.05){
        $eea9463646207a7b$var$_v1[0] = $eea9463646207a7b$export$af17094a950f5073(x0, x1, x2, _t);
        $eea9463646207a7b$var$_v1[1] = $eea9463646207a7b$export$af17094a950f5073(y0, y1, y2, _t);
        var d1 = (0, $3dde7d051fe20daa$export$c68db45a034c13b0)($eea9463646207a7b$var$_v0, $eea9463646207a7b$var$_v1);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    d = Infinity;
    for(var i = 0; i < 32; i++){
        if (interval < $eea9463646207a7b$var$EPSILON_NUMERIC) break;
        var prev = t - interval;
        var next = t + interval;
        $eea9463646207a7b$var$_v1[0] = $eea9463646207a7b$export$af17094a950f5073(x0, x1, x2, prev);
        $eea9463646207a7b$var$_v1[1] = $eea9463646207a7b$export$af17094a950f5073(y0, y1, y2, prev);
        var d1 = (0, $3dde7d051fe20daa$export$c68db45a034c13b0)($eea9463646207a7b$var$_v1, $eea9463646207a7b$var$_v0);
        if (prev >= 0 && d1 < d) {
            t = prev;
            d = d1;
        } else {
            $eea9463646207a7b$var$_v2[0] = $eea9463646207a7b$export$af17094a950f5073(x0, x1, x2, next);
            $eea9463646207a7b$var$_v2[1] = $eea9463646207a7b$export$af17094a950f5073(y0, y1, y2, next);
            var d2 = (0, $3dde7d051fe20daa$export$c68db45a034c13b0)($eea9463646207a7b$var$_v2, $eea9463646207a7b$var$_v0);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    if (out) {
        out[0] = $eea9463646207a7b$export$af17094a950f5073(x0, x1, x2, t);
        out[1] = $eea9463646207a7b$export$af17094a950f5073(y0, y1, y2, t);
    }
    return $eea9463646207a7b$var$mathSqrt(d);
}
function $eea9463646207a7b$export$8a68adee46f3cf55(x0, y0, x1, y1, x2, y2, iteration) {
    var px = x0;
    var py = y0;
    var d = 0;
    var step = 1 / iteration;
    for(var i = 1; i <= iteration; i++){
        var t = i * step;
        var x = $eea9463646207a7b$export$af17094a950f5073(x0, x1, x2, t);
        var y = $eea9463646207a7b$export$af17094a950f5073(y0, y1, y2, t);
        var dx = x - px;
        var dy = y - py;
        d += Math.sqrt(dx * dx + dy * dy);
        px = x;
        py = y;
    }
    return d;
}



var $d1811699cfe8103c$var$regexp = /cubic-bezier\(([0-9,\.e ]+)\)/;
function $d1811699cfe8103c$export$ec0863d806fd857e(cubicEasingStr) {
    var cubic = cubicEasingStr && $d1811699cfe8103c$var$regexp.exec(cubicEasingStr);
    if (cubic) {
        var points = cubic[1].split(',');
        var a_1 = +(0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(points[0]);
        var b_1 = +(0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(points[1]);
        var c_1 = +(0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(points[2]);
        var d_1 = +(0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(points[3]);
        if (isNaN(a_1 + b_1 + c_1 + d_1)) return;
        var roots_1 = [];
        return function(p) {
            return p <= 0 ? 0 : p >= 1 ? 1 : (0, $eea9463646207a7b$export$ca5d13faa10b167e)(0, a_1, c_1, 1, p, roots_1) && (0, $eea9463646207a7b$export$547c21de482bbcb2)(0, b_1, d_1, 1, roots_1[0]);
        };
    }
}


var $f22bf67b3e548a26$var$Clip = function() {
    function Clip(opts) {
        this._inited = false;
        this._startTime = 0;
        this._pausedTime = 0;
        this._paused = false;
        this._life = opts.life || 1000;
        this._delay = opts.delay || 0;
        this.loop = opts.loop || false;
        this.onframe = opts.onframe || (0, $1b239fc9d3a2f8ae$export$8793edee2d425525);
        this.ondestroy = opts.ondestroy || (0, $1b239fc9d3a2f8ae$export$8793edee2d425525);
        this.onrestart = opts.onrestart || (0, $1b239fc9d3a2f8ae$export$8793edee2d425525);
        opts.easing && this.setEasing(opts.easing);
    }
    Clip.prototype.step = function(globalTime, deltaTime) {
        if (!this._inited) {
            this._startTime = globalTime + this._delay;
            this._inited = true;
        }
        if (this._paused) {
            this._pausedTime += deltaTime;
            return;
        }
        var life = this._life;
        var elapsedTime = globalTime - this._startTime - this._pausedTime;
        var percent = elapsedTime / life;
        if (percent < 0) percent = 0;
        percent = Math.min(percent, 1);
        var easingFunc = this.easingFunc;
        var schedule = easingFunc ? easingFunc(percent) : percent;
        this.onframe(schedule);
        if (percent === 1) {
            if (this.loop) {
                var remainder = elapsedTime % life;
                this._startTime = globalTime - remainder;
                this._pausedTime = 0;
                this.onrestart();
            } else return true;
        }
        return false;
    };
    Clip.prototype.pause = function() {
        this._paused = true;
    };
    Clip.prototype.resume = function() {
        this._paused = false;
    };
    Clip.prototype.setEasing = function(easing) {
        this.easing = easing;
        this.easingFunc = (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(easing) ? easing : (0, $6a7e03908369e2ad$export$2e2bcd8739ae039)[easing] || (0, $d1811699cfe8103c$export$ec0863d806fd857e)(easing);
    };
    return Clip;
}();
var $f22bf67b3e548a26$export$2e2bcd8739ae039 = $f22bf67b3e548a26$var$Clip;


var $db88c5ee7dbc7394$export$3bb977b3ba9d3b59 = function() {
    function Entry(val) {
        this.value = val;
    }
    return Entry;
}();
var $db88c5ee7dbc7394$export$f0ef28713f767754 = function() {
    function LinkedList() {
        this._len = 0;
    }
    LinkedList.prototype.insert = function(val) {
        var entry = new $db88c5ee7dbc7394$export$3bb977b3ba9d3b59(val);
        this.insertEntry(entry);
        return entry;
    };
    LinkedList.prototype.insertEntry = function(entry) {
        if (!this.head) this.head = this.tail = entry;
        else {
            this.tail.next = entry;
            entry.prev = this.tail;
            entry.next = null;
            this.tail = entry;
        }
        this._len++;
    };
    LinkedList.prototype.remove = function(entry) {
        var prev = entry.prev;
        var next = entry.next;
        if (prev) prev.next = next;
        else this.head = next;
        if (next) next.prev = prev;
        else this.tail = prev;
        entry.next = entry.prev = null;
        this._len--;
    };
    LinkedList.prototype.len = function() {
        return this._len;
    };
    LinkedList.prototype.clear = function() {
        this.head = this.tail = null;
        this._len = 0;
    };
    return LinkedList;
}();
var $db88c5ee7dbc7394$var$LRU = function() {
    function LRU(maxSize) {
        this._list = new $db88c5ee7dbc7394$export$f0ef28713f767754();
        this._maxSize = 10;
        this._map = {};
        this._maxSize = maxSize;
    }
    LRU.prototype.put = function(key, value) {
        var list = this._list;
        var map = this._map;
        var removed = null;
        if (map[key] == null) {
            var len = list.len();
            var entry = this._lastRemovedEntry;
            if (len >= this._maxSize && len > 0) {
                var leastUsedEntry = list.head;
                list.remove(leastUsedEntry);
                delete map[leastUsedEntry.key];
                removed = leastUsedEntry.value;
                this._lastRemovedEntry = leastUsedEntry;
            }
            if (entry) entry.value = value;
            else entry = new $db88c5ee7dbc7394$export$3bb977b3ba9d3b59(value);
            entry.key = key;
            list.insertEntry(entry);
            map[key] = entry;
        }
        return removed;
    };
    LRU.prototype.get = function(key) {
        var entry = this._map[key];
        var list = this._list;
        if (entry != null) {
            if (entry !== list.tail) {
                list.remove(entry);
                list.insertEntry(entry);
            }
            return entry.value;
        }
    };
    LRU.prototype.clear = function() {
        this._list.clear();
        this._map = {};
    };
    LRU.prototype.len = function() {
        return this._list.len();
    };
    return LRU;
}();
var $db88c5ee7dbc7394$export$2e2bcd8739ae039 = $db88c5ee7dbc7394$var$LRU;



var $35573db24643e2ef$var$kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function $35573db24643e2ef$var$clampCssByte(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function $35573db24643e2ef$var$clampCssAngle(i) {
    i = Math.round(i);
    return i < 0 ? 0 : i > 360 ? 360 : i;
}
function $35573db24643e2ef$var$clampCssFloat(f) {
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function $35573db24643e2ef$var$parseCssInt(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $35573db24643e2ef$var$clampCssByte(parseFloat(str) / 100 * 255);
    return $35573db24643e2ef$var$clampCssByte(parseInt(str, 10));
}
function $35573db24643e2ef$var$parseCssFloat(val) {
    var str = val;
    if (str.length && str.charAt(str.length - 1) === '%') return $35573db24643e2ef$var$clampCssFloat(parseFloat(str) / 100);
    return $35573db24643e2ef$var$clampCssFloat(parseFloat(str));
}
function $35573db24643e2ef$var$cssHueToRgb(m1, m2, h) {
    if (h < 0) h += 1;
    else if (h > 1) h -= 1;
    if (h * 6 < 1) return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1) return m2;
    if (h * 3 < 2) return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function $35573db24643e2ef$var$lerpNumber(a, b, p) {
    return a + (b - a) * p;
}
function $35573db24643e2ef$var$setRgba(out, r, g, b, a) {
    out[0] = r;
    out[1] = g;
    out[2] = b;
    out[3] = a;
    return out;
}
function $35573db24643e2ef$var$copyRgba(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
var $35573db24643e2ef$var$colorCache = new (0, $db88c5ee7dbc7394$export$2e2bcd8739ae039)(20);
var $35573db24643e2ef$var$lastRemovedArr = null;
function $35573db24643e2ef$var$putToCache(colorStr, rgbaArr) {
    if ($35573db24643e2ef$var$lastRemovedArr) $35573db24643e2ef$var$copyRgba($35573db24643e2ef$var$lastRemovedArr, rgbaArr);
    $35573db24643e2ef$var$lastRemovedArr = $35573db24643e2ef$var$colorCache.put(colorStr, $35573db24643e2ef$var$lastRemovedArr || rgbaArr.slice());
}
function $35573db24643e2ef$export$98e6a39c04603d36(colorStr, rgbaArr) {
    if (!colorStr) return;
    rgbaArr = rgbaArr || [];
    var cached = $35573db24643e2ef$var$colorCache.get(colorStr);
    if (cached) return $35573db24643e2ef$var$copyRgba(rgbaArr, cached);
    colorStr = colorStr + '';
    var str = colorStr.replace(/ /g, '').toLowerCase();
    if (str in $35573db24643e2ef$var$kCSSColorTable) {
        $35573db24643e2ef$var$copyRgba(rgbaArr, $35573db24643e2ef$var$kCSSColorTable[str]);
        $35573db24643e2ef$var$putToCache(colorStr, rgbaArr);
        return rgbaArr;
    }
    var strLen = str.length;
    if (str.charAt(0) === '#') {
        if (strLen === 4 || strLen === 5) {
            var iv = parseInt(str.slice(1, 4), 16);
            if (!(iv >= 0 && iv <= 0xfff)) {
                $35573db24643e2ef$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $35573db24643e2ef$var$setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, strLen === 5 ? parseInt(str.slice(4), 16) / 0xf : 1);
            $35573db24643e2ef$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        } else if (strLen === 7 || strLen === 9) {
            var iv = parseInt(str.slice(1, 7), 16);
            if (!(iv >= 0 && iv <= 0xffffff)) {
                $35573db24643e2ef$var$setRgba(rgbaArr, 0, 0, 0, 1);
                return;
            }
            $35573db24643e2ef$var$setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, strLen === 9 ? parseInt(str.slice(7), 16) / 0xff : 1);
            $35573db24643e2ef$var$putToCache(colorStr, rgbaArr);
            return rgbaArr;
        }
        return;
    }
    var op = str.indexOf('(');
    var ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === strLen) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        switch(fname){
            case 'rgba':
                if (params.length !== 4) return params.length === 3 ? $35573db24643e2ef$var$setRgba(rgbaArr, +params[0], +params[1], +params[2], 1) : $35573db24643e2ef$var$setRgba(rgbaArr, 0, 0, 0, 1);
                alpha = $35573db24643e2ef$var$parseCssFloat(params.pop());
            case 'rgb':
                if (params.length >= 3) {
                    $35573db24643e2ef$var$setRgba(rgbaArr, $35573db24643e2ef$var$parseCssInt(params[0]), $35573db24643e2ef$var$parseCssInt(params[1]), $35573db24643e2ef$var$parseCssInt(params[2]), params.length === 3 ? alpha : $35573db24643e2ef$var$parseCssFloat(params[3]));
                    $35573db24643e2ef$var$putToCache(colorStr, rgbaArr);
                    return rgbaArr;
                } else {
                    $35573db24643e2ef$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
            case 'hsla':
                if (params.length !== 4) {
                    $35573db24643e2ef$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                params[3] = $35573db24643e2ef$var$parseCssFloat(params[3]);
                $35573db24643e2ef$var$hsla2rgba(params, rgbaArr);
                $35573db24643e2ef$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            case 'hsl':
                if (params.length !== 3) {
                    $35573db24643e2ef$var$setRgba(rgbaArr, 0, 0, 0, 1);
                    return;
                }
                $35573db24643e2ef$var$hsla2rgba(params, rgbaArr);
                $35573db24643e2ef$var$putToCache(colorStr, rgbaArr);
                return rgbaArr;
            default:
                return;
        }
    }
    $35573db24643e2ef$var$setRgba(rgbaArr, 0, 0, 0, 1);
    return;
}
function $35573db24643e2ef$var$hsla2rgba(hsla, rgba) {
    var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360;
    var s = $35573db24643e2ef$var$parseCssFloat(hsla[1]);
    var l = $35573db24643e2ef$var$parseCssFloat(hsla[2]);
    var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
    var m1 = l * 2 - m2;
    rgba = rgba || [];
    $35573db24643e2ef$var$setRgba(rgba, $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$cssHueToRgb(m1, m2, h + 1 / 3) * 255), $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$cssHueToRgb(m1, m2, h) * 255), $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
    if (hsla.length === 4) rgba[3] = hsla[3];
    return rgba;
}
function $35573db24643e2ef$var$rgba2hsla(rgba) {
    if (!rgba) return;
    var R = rgba[0] / 255;
    var G = rgba[1] / 255;
    var B = rgba[2] / 255;
    var vMin = Math.min(R, G, B);
    var vMax = Math.max(R, G, B);
    var delta = vMax - vMin;
    var L = (vMax + vMin) / 2;
    var H;
    var S;
    if (delta === 0) {
        H = 0;
        S = 0;
    } else {
        if (L < 0.5) S = delta / (vMax + vMin);
        else S = delta / (2 - vMax - vMin);
        var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
        var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
        var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
        if (R === vMax) H = deltaB - deltaG;
        else if (G === vMax) H = 1 / 3 + deltaR - deltaB;
        else if (B === vMax) H = 2 / 3 + deltaG - deltaR;
        if (H < 0) H += 1;
        if (H > 1) H -= 1;
    }
    var hsla = [
        H * 360,
        S,
        L
    ];
    if (rgba[3] != null) hsla.push(rgba[3]);
    return hsla;
}
function $35573db24643e2ef$export$590e8b2c435046d9(color, level) {
    var colorArr = $35573db24643e2ef$export$98e6a39c04603d36(color);
    if (colorArr) {
        for(var i = 0; i < 3; i++){
            if (level < 0) colorArr[i] = colorArr[i] * (1 - level) | 0;
            else colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
            if (colorArr[i] > 255) colorArr[i] = 255;
            else if (colorArr[i] < 0) colorArr[i] = 0;
        }
        return $35573db24643e2ef$export$fac44ee5b035f737(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
    }
}
function $35573db24643e2ef$export$7ea66e3774a60b67(color) {
    var colorArr = $35573db24643e2ef$export$98e6a39c04603d36(color);
    if (colorArr) return (16777216 + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
}
function $35573db24643e2ef$export$66cb3c0e9efc61c8(normalizedValue, colors, out) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    out = out || [];
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = colors[leftIndex];
    var rightColor = colors[rightIndex];
    var dv = value - leftIndex;
    out[0] = $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$lerpNumber(leftColor[0], rightColor[0], dv));
    out[1] = $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$lerpNumber(leftColor[1], rightColor[1], dv));
    out[2] = $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$lerpNumber(leftColor[2], rightColor[2], dv));
    out[3] = $35573db24643e2ef$var$clampCssFloat($35573db24643e2ef$var$lerpNumber(leftColor[3], rightColor[3], dv));
    return out;
}
var $35573db24643e2ef$export$daa5a65daad5df58 = $35573db24643e2ef$export$66cb3c0e9efc61c8;
function $35573db24643e2ef$export$3a89f8d6f6bf6c9f(normalizedValue, colors, fullOutput) {
    if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) return;
    var value = normalizedValue * (colors.length - 1);
    var leftIndex = Math.floor(value);
    var rightIndex = Math.ceil(value);
    var leftColor = $35573db24643e2ef$export$98e6a39c04603d36(colors[leftIndex]);
    var rightColor = $35573db24643e2ef$export$98e6a39c04603d36(colors[rightIndex]);
    var dv = value - leftIndex;
    var color = $35573db24643e2ef$export$fac44ee5b035f737([
        $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$lerpNumber(leftColor[0], rightColor[0], dv)),
        $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$lerpNumber(leftColor[1], rightColor[1], dv)),
        $35573db24643e2ef$var$clampCssByte($35573db24643e2ef$var$lerpNumber(leftColor[2], rightColor[2], dv)),
        $35573db24643e2ef$var$clampCssFloat($35573db24643e2ef$var$lerpNumber(leftColor[3], rightColor[3], dv))
    ], 'rgba');
    return fullOutput ? {
        color: color,
        leftIndex: leftIndex,
        rightIndex: rightIndex,
        value: value
    } : color;
}
var $35573db24643e2ef$export$296e08242b78a3ec = $35573db24643e2ef$export$3a89f8d6f6bf6c9f;
function $35573db24643e2ef$export$d898ae866e27bf18(color, h, s, l) {
    var colorArr = $35573db24643e2ef$export$98e6a39c04603d36(color);
    if (color) {
        colorArr = $35573db24643e2ef$var$rgba2hsla(colorArr);
        h != null && (colorArr[0] = $35573db24643e2ef$var$clampCssAngle(h));
        s != null && (colorArr[1] = $35573db24643e2ef$var$parseCssFloat(s));
        l != null && (colorArr[2] = $35573db24643e2ef$var$parseCssFloat(l));
        return $35573db24643e2ef$export$fac44ee5b035f737($35573db24643e2ef$var$hsla2rgba(colorArr), 'rgba');
    }
}
function $35573db24643e2ef$export$ab4754bf42583a26(color, alpha) {
    var colorArr = $35573db24643e2ef$export$98e6a39c04603d36(color);
    if (colorArr && alpha != null) {
        colorArr[3] = $35573db24643e2ef$var$clampCssFloat(alpha);
        return $35573db24643e2ef$export$fac44ee5b035f737(colorArr, 'rgba');
    }
}
function $35573db24643e2ef$export$fac44ee5b035f737(arrColor, type) {
    if (!arrColor || !arrColor.length) return;
    var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
    if (type === 'rgba' || type === 'hsva' || type === 'hsla') colorStr += ',' + arrColor[3];
    return type + '(' + colorStr + ')';
}
function $35573db24643e2ef$export$16c0ec21a6f9ef95(color, backgroundLum) {
    var arr = $35573db24643e2ef$export$98e6a39c04603d36(color);
    return arr ? (0.299 * arr[0] + 0.587 * arr[1] + 0.114 * arr[2]) * arr[3] / 255 + (1 - arr[3]) * backgroundLum : 0;
}
function $35573db24643e2ef$export$4385e60b38654f68() {
    return $35573db24643e2ef$export$fac44ee5b035f737([
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255),
        Math.round(Math.random() * 255)
    ], 'rgb');
}
var $35573db24643e2ef$var$liftedColorCache = new (0, $db88c5ee7dbc7394$export$2e2bcd8739ae039)(100);
function $35573db24643e2ef$export$2b47e247dfb87a73(color) {
    if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(color)) {
        var liftedColor = $35573db24643e2ef$var$liftedColorCache.get(color);
        if (!liftedColor) {
            liftedColor = $35573db24643e2ef$export$590e8b2c435046d9(color, -0.1);
            $35573db24643e2ef$var$liftedColorCache.put(color, liftedColor);
        }
        return liftedColor;
    } else if ((0, $1b239fc9d3a2f8ae$export$fa2c283003ed971c)(color)) {
        var ret = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, color);
        ret.colorStops = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(color.colorStops, function(stop) {
            return {
                offset: stop.offset,
                color: $35573db24643e2ef$export$590e8b2c435046d9(stop.color, -0.1)
            };
        });
        return ret;
    }
    return color;
}








/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $2f4093b97fdc053e$export$a143d493d941bafc;
var $2f4093b97fdc053e$export$e4cf37d7f6fb9e0a;
var $2f4093b97fdc053e$export$f99ded8fe4b79145;
var $2f4093b97fdc053e$export$599f31c3813fae4d;
'use strict';
var $c1110228c8ce65d7$export$a48f0734ac7c2329;
var $c1110228c8ce65d7$export$d622b2ad8d90c771;
var $c1110228c8ce65d7$export$6100ba28696e12de;
'use strict';
$c1110228c8ce65d7$export$a48f0734ac7c2329 = $c1110228c8ce65d7$var$byteLength;
$c1110228c8ce65d7$export$d622b2ad8d90c771 = $c1110228c8ce65d7$var$toByteArray;
$c1110228c8ce65d7$export$6100ba28696e12de = $c1110228c8ce65d7$var$fromByteArray;
var $c1110228c8ce65d7$var$lookup = [];
var $c1110228c8ce65d7$var$revLookup = [];
var $c1110228c8ce65d7$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $c1110228c8ce65d7$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $c1110228c8ce65d7$var$i = 0, $c1110228c8ce65d7$var$len = $c1110228c8ce65d7$var$code.length; $c1110228c8ce65d7$var$i < $c1110228c8ce65d7$var$len; ++$c1110228c8ce65d7$var$i){
    $c1110228c8ce65d7$var$lookup[$c1110228c8ce65d7$var$i] = $c1110228c8ce65d7$var$code[$c1110228c8ce65d7$var$i];
    $c1110228c8ce65d7$var$revLookup[$c1110228c8ce65d7$var$code.charCodeAt($c1110228c8ce65d7$var$i)] = $c1110228c8ce65d7$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$c1110228c8ce65d7$var$revLookup['-'.charCodeAt(0)] = 62;
$c1110228c8ce65d7$var$revLookup['_'.charCodeAt(0)] = 63;
function $c1110228c8ce65d7$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $c1110228c8ce65d7$var$byteLength(b64) {
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $c1110228c8ce65d7$var$toByteArray(b64) {
    var tmp;
    var lens = $c1110228c8ce65d7$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $c1110228c8ce65d7$var$Arr($c1110228c8ce65d7$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 18 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 2 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i)] << 10 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $c1110228c8ce65d7$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $c1110228c8ce65d7$var$tripletToBase64(num) {
    return $c1110228c8ce65d7$var$lookup[num >> 18 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 12 & 0x3F] + $c1110228c8ce65d7$var$lookup[num >> 6 & 0x3F] + $c1110228c8ce65d7$var$lookup[num & 0x3F];
}
function $c1110228c8ce65d7$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($c1110228c8ce65d7$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $c1110228c8ce65d7$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($c1110228c8ce65d7$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 2] + $c1110228c8ce65d7$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($c1110228c8ce65d7$var$lookup[tmp >> 10] + $c1110228c8ce65d7$var$lookup[tmp >> 4 & 0x3F] + $c1110228c8ce65d7$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $0b8359fe6fd9cd49$export$aafa59e2e03f2942;
var $0b8359fe6fd9cd49$export$68d8715fc104d294;
$0b8359fe6fd9cd49$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$0b8359fe6fd9cd49$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $2f4093b97fdc053e$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$2f4093b97fdc053e$export$a143d493d941bafc = $2f4093b97fdc053e$var$Buffer;
$2f4093b97fdc053e$export$e4cf37d7f6fb9e0a = $2f4093b97fdc053e$var$SlowBuffer;
$2f4093b97fdc053e$export$f99ded8fe4b79145 = 50;
const $2f4093b97fdc053e$var$K_MAX_LENGTH = 0x7fffffff;
$2f4093b97fdc053e$export$599f31c3813fae4d = $2f4093b97fdc053e$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $2f4093b97fdc053e$var$Buffer.TYPED_ARRAY_SUPPORT = $2f4093b97fdc053e$var$typedArraySupport();
if (!$2f4093b97fdc053e$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $2f4093b97fdc053e$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($2f4093b97fdc053e$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$2f4093b97fdc053e$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($2f4093b97fdc053e$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$2f4093b97fdc053e$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $2f4093b97fdc053e$var$createBuffer(length) {
    if (length > $2f4093b97fdc053e$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $2f4093b97fdc053e$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $2f4093b97fdc053e$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $2f4093b97fdc053e$var$allocUnsafe(arg);
    }
    return $2f4093b97fdc053e$var$from(arg, encodingOrOffset, length);
}
$2f4093b97fdc053e$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $2f4093b97fdc053e$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $2f4093b97fdc053e$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $2f4093b97fdc053e$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($2f4093b97fdc053e$var$isInstance(value, ArrayBuffer) || value && $2f4093b97fdc053e$var$isInstance(value.buffer, ArrayBuffer)) return $2f4093b97fdc053e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($2f4093b97fdc053e$var$isInstance(value, SharedArrayBuffer) || value && $2f4093b97fdc053e$var$isInstance(value.buffer, SharedArrayBuffer))) return $2f4093b97fdc053e$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $2f4093b97fdc053e$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $2f4093b97fdc053e$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $2f4093b97fdc053e$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $2f4093b97fdc053e$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $2f4093b97fdc053e$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($2f4093b97fdc053e$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($2f4093b97fdc053e$var$Buffer, Uint8Array);
function $2f4093b97fdc053e$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $2f4093b97fdc053e$var$alloc(size, fill, encoding) {
    $2f4093b97fdc053e$var$assertSize(size);
    if (size <= 0) return $2f4093b97fdc053e$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $2f4093b97fdc053e$var$createBuffer(size).fill(fill, encoding) : $2f4093b97fdc053e$var$createBuffer(size).fill(fill);
    return $2f4093b97fdc053e$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $2f4093b97fdc053e$var$Buffer.alloc = function(size, fill, encoding) {
    return $2f4093b97fdc053e$var$alloc(size, fill, encoding);
};
function $2f4093b97fdc053e$var$allocUnsafe(size) {
    $2f4093b97fdc053e$var$assertSize(size);
    return $2f4093b97fdc053e$var$createBuffer(size < 0 ? 0 : $2f4093b97fdc053e$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $2f4093b97fdc053e$var$Buffer.allocUnsafe = function(size) {
    return $2f4093b97fdc053e$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $2f4093b97fdc053e$var$Buffer.allocUnsafeSlow = function(size) {
    return $2f4093b97fdc053e$var$allocUnsafe(size);
};
function $2f4093b97fdc053e$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$2f4093b97fdc053e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $2f4093b97fdc053e$var$byteLength(string, encoding) | 0;
    let buf = $2f4093b97fdc053e$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $2f4093b97fdc053e$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $2f4093b97fdc053e$var$checked(array.length) | 0;
    const buf = $2f4093b97fdc053e$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $2f4093b97fdc053e$var$fromArrayView(arrayView) {
    if ($2f4093b97fdc053e$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $2f4093b97fdc053e$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $2f4093b97fdc053e$var$fromArrayLike(arrayView);
}
function $2f4093b97fdc053e$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $2f4093b97fdc053e$var$Buffer.prototype);
    return buf;
}
function $2f4093b97fdc053e$var$fromObject(obj) {
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(obj)) {
        const len = $2f4093b97fdc053e$var$checked(obj.length) | 0;
        const buf = $2f4093b97fdc053e$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $2f4093b97fdc053e$var$numberIsNaN(obj.length)) return $2f4093b97fdc053e$var$createBuffer(0);
        return $2f4093b97fdc053e$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $2f4093b97fdc053e$var$fromArrayLike(obj.data);
}
function $2f4093b97fdc053e$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $2f4093b97fdc053e$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $2f4093b97fdc053e$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $2f4093b97fdc053e$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $2f4093b97fdc053e$var$Buffer.alloc(+length);
}
$2f4093b97fdc053e$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $2f4093b97fdc053e$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$2f4093b97fdc053e$var$Buffer.compare = function compare(a, b) {
    if ($2f4093b97fdc053e$var$isInstance(a, Uint8Array)) a = $2f4093b97fdc053e$var$Buffer.from(a, a.offset, a.byteLength);
    if ($2f4093b97fdc053e$var$isInstance(b, Uint8Array)) b = $2f4093b97fdc053e$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(a) || !$2f4093b97fdc053e$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$2f4093b97fdc053e$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$2f4093b97fdc053e$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $2f4093b97fdc053e$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $2f4093b97fdc053e$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($2f4093b97fdc053e$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) buf = $2f4093b97fdc053e$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $2f4093b97fdc053e$var$byteLength(string, encoding) {
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $2f4093b97fdc053e$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $2f4093b97fdc053e$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $2f4093b97fdc053e$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $2f4093b97fdc053e$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$2f4093b97fdc053e$var$Buffer.byteLength = $2f4093b97fdc053e$var$byteLength;
function $2f4093b97fdc053e$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $2f4093b97fdc053e$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $2f4093b97fdc053e$var$utf8Slice(this, start, end);
        case 'ascii':
            return $2f4093b97fdc053e$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $2f4093b97fdc053e$var$latin1Slice(this, start, end);
        case 'base64':
            return $2f4093b97fdc053e$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2f4093b97fdc053e$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$2f4093b97fdc053e$var$Buffer.prototype._isBuffer = true;
function $2f4093b97fdc053e$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$2f4093b97fdc053e$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$2f4093b97fdc053e$var$swap(this, i, i + 1);
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $2f4093b97fdc053e$var$swap(this, i, i + 3);
        $2f4093b97fdc053e$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $2f4093b97fdc053e$var$swap(this, i, i + 7);
        $2f4093b97fdc053e$var$swap(this, i + 1, i + 6);
        $2f4093b97fdc053e$var$swap(this, i + 2, i + 5);
        $2f4093b97fdc053e$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$2f4093b97fdc053e$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $2f4093b97fdc053e$var$utf8Slice(this, 0, length);
    return $2f4093b97fdc053e$var$slowToString.apply(this, arguments);
};
$2f4093b97fdc053e$var$Buffer.prototype.toLocaleString = $2f4093b97fdc053e$var$Buffer.prototype.toString;
$2f4093b97fdc053e$var$Buffer.prototype.equals = function equals(b) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $2f4093b97fdc053e$var$Buffer.compare(this, b) === 0;
};
$2f4093b97fdc053e$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $2f4093b97fdc053e$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($2f4093b97fdc053e$var$customInspectSymbol) $2f4093b97fdc053e$var$Buffer.prototype[$2f4093b97fdc053e$var$customInspectSymbol] = $2f4093b97fdc053e$var$Buffer.prototype.inspect;
$2f4093b97fdc053e$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($2f4093b97fdc053e$var$isInstance(target, Uint8Array)) target = $2f4093b97fdc053e$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $2f4093b97fdc053e$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($2f4093b97fdc053e$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $2f4093b97fdc053e$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($2f4093b97fdc053e$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $2f4093b97fdc053e$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $2f4093b97fdc053e$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $2f4093b97fdc053e$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$2f4093b97fdc053e$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$2f4093b97fdc053e$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $2f4093b97fdc053e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$2f4093b97fdc053e$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $2f4093b97fdc053e$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $2f4093b97fdc053e$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($2f4093b97fdc053e$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $2f4093b97fdc053e$var$utf8Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $2f4093b97fdc053e$var$asciiWrite(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$asciiToBytes(string), buf, offset, length);
}
function $2f4093b97fdc053e$var$base64Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$base64ToBytes(string), buf, offset, length);
}
function $2f4093b97fdc053e$var$ucs2Write(buf, string, offset, length) {
    return $2f4093b97fdc053e$var$blitBuffer($2f4093b97fdc053e$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$2f4093b97fdc053e$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $2f4093b97fdc053e$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $2f4093b97fdc053e$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $2f4093b97fdc053e$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $2f4093b97fdc053e$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2f4093b97fdc053e$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$2f4093b97fdc053e$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $2f4093b97fdc053e$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $c1110228c8ce65d7$export$6100ba28696e12de(buf);
    else return $c1110228c8ce65d7$export$6100ba28696e12de(buf.slice(start, end));
}
function $2f4093b97fdc053e$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $2f4093b97fdc053e$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $2f4093b97fdc053e$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $2f4093b97fdc053e$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $2f4093b97fdc053e$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $2f4093b97fdc053e$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $2f4093b97fdc053e$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $2f4093b97fdc053e$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $2f4093b97fdc053e$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$2f4093b97fdc053e$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $2f4093b97fdc053e$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $2f4093b97fdc053e$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$2f4093b97fdc053e$var$Buffer.prototype.readUintLE = $2f4093b97fdc053e$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUintBE = $2f4093b97fdc053e$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint8 = $2f4093b97fdc053e$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint16LE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint16BE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint32LE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$2f4093b97fdc053e$var$Buffer.prototype.readUint32BE = $2f4093b97fdc053e$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$2f4093b97fdc053e$var$Buffer.prototype.readBigUInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$2f4093b97fdc053e$var$Buffer.prototype.readBigUInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$2f4093b97fdc053e$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$2f4093b97fdc053e$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$2f4093b97fdc053e$var$Buffer.prototype.readBigInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$2f4093b97fdc053e$var$Buffer.prototype.readBigInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2f4093b97fdc053e$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$2f4093b97fdc053e$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$2f4093b97fdc053e$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 4, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$2f4093b97fdc053e$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 8, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$2f4093b97fdc053e$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkOffset(offset, 8, this.length);
    return $0b8359fe6fd9cd49$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $2f4093b97fdc053e$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$2f4093b97fdc053e$var$Buffer.prototype.writeUintLE = $2f4093b97fdc053e$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUintBE = $2f4093b97fdc053e$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint8 = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint16LE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint16BE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint32LE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeUint32BE = $2f4093b97fdc053e$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $2f4093b97fdc053e$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $2f4093b97fdc053e$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeBigUInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeBigUInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2f4093b97fdc053e$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$2f4093b97fdc053e$var$Buffer.prototype.writeBigInt64LE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$2f4093b97fdc053e$var$Buffer.prototype.writeBigInt64BE = $2f4093b97fdc053e$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $2f4093b97fdc053e$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $2f4093b97fdc053e$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $0b8359fe6fd9cd49$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeFloat(this, value, offset, true, noAssert);
};
$2f4093b97fdc053e$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeFloat(this, value, offset, false, noAssert);
};
function $2f4093b97fdc053e$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2f4093b97fdc053e$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $0b8359fe6fd9cd49$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$2f4093b97fdc053e$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeDouble(this, value, offset, true, noAssert);
};
$2f4093b97fdc053e$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $2f4093b97fdc053e$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$2f4093b97fdc053e$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$2f4093b97fdc053e$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$2f4093b97fdc053e$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$2f4093b97fdc053e$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $2f4093b97fdc053e$var$Buffer.isBuffer(val) ? val : $2f4093b97fdc053e$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $2f4093b97fdc053e$var$errors = {};
function $2f4093b97fdc053e$var$E(sym, getMessage, Base) {
    $2f4093b97fdc053e$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$2f4093b97fdc053e$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$2f4093b97fdc053e$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$2f4093b97fdc053e$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $2f4093b97fdc053e$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $2f4093b97fdc053e$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $2f4093b97fdc053e$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $2f4093b97fdc053e$var$checkBounds(buf, offset, byteLength) {
    $2f4093b97fdc053e$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $2f4093b97fdc053e$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $2f4093b97fdc053e$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $2f4093b97fdc053e$var$checkBounds(buf, offset, byteLength);
}
function $2f4093b97fdc053e$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $2f4093b97fdc053e$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $2f4093b97fdc053e$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $2f4093b97fdc053e$var$validateNumber(value, type);
        throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $2f4093b97fdc053e$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $2f4093b97fdc053e$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $2f4093b97fdc053e$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $2f4093b97fdc053e$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($2f4093b97fdc053e$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $2f4093b97fdc053e$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $2f4093b97fdc053e$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $2f4093b97fdc053e$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $2f4093b97fdc053e$var$base64ToBytes(str) {
    return $c1110228c8ce65d7$export$d622b2ad8d90c771($2f4093b97fdc053e$var$base64clean(str));
}
function $2f4093b97fdc053e$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $2f4093b97fdc053e$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $2f4093b97fdc053e$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $2f4093b97fdc053e$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $2f4093b97fdc053e$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $2f4093b97fdc053e$var$BufferBigIntNotDefined : fn;
}
function $2f4093b97fdc053e$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}


var $c453016f40eca611$require$Buffer = $2f4093b97fdc053e$export$a143d493d941bafc;
var $c453016f40eca611$var$mathRound = Math.round;
function $c453016f40eca611$export$4cde5df63f53f473(color) {
    var opacity;
    if (!color || color === 'transparent') color = 'none';
    else if (typeof color === 'string' && color.indexOf('rgba') > -1) {
        var arr = (0, $35573db24643e2ef$export$98e6a39c04603d36)(color);
        if (arr) {
            color = 'rgb(' + arr[0] + ',' + arr[1] + ',' + arr[2] + ')';
            opacity = arr[3];
        }
    }
    return {
        color: color,
        opacity: opacity == null ? 1 : opacity
    };
}
var $c453016f40eca611$var$EPSILON = 1e-4;
function $c453016f40eca611$export$4701367f5b4de464(transform) {
    return transform < $c453016f40eca611$var$EPSILON && transform > -$c453016f40eca611$var$EPSILON;
}
function $c453016f40eca611$export$4b9074ac37ee5a23(transform) {
    return $c453016f40eca611$var$mathRound(transform * 1e3) / 1e3;
}
function $c453016f40eca611$export$52bfc6d3e2ff0fc2(transform) {
    return $c453016f40eca611$var$mathRound(transform * 1e4) / 1e4;
}
function $c453016f40eca611$export$19676ab5cb1de150(transform) {
    return $c453016f40eca611$var$mathRound(transform * 10) / 10;
}
function $c453016f40eca611$export$f29a4456cf56ff21(m) {
    return 'matrix(' + $c453016f40eca611$export$4b9074ac37ee5a23(m[0]) + ',' + $c453016f40eca611$export$4b9074ac37ee5a23(m[1]) + ',' + $c453016f40eca611$export$4b9074ac37ee5a23(m[2]) + ',' + $c453016f40eca611$export$4b9074ac37ee5a23(m[3]) + ',' + $c453016f40eca611$export$52bfc6d3e2ff0fc2(m[4]) + ',' + $c453016f40eca611$export$52bfc6d3e2ff0fc2(m[5]) + ')';
}
var $c453016f40eca611$export$4062150f0600d971 = {
    left: 'start',
    right: 'end',
    center: 'middle',
    middle: 'middle'
};
function $c453016f40eca611$export$bf7d6802d2badd9(y, lineHeight, textBaseline) {
    if (textBaseline === 'top') y += lineHeight / 2;
    else if (textBaseline === 'bottom') y -= lineHeight / 2;
    return y;
}
function $c453016f40eca611$export$c62076b3a966c94b(style) {
    return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY);
}
function $c453016f40eca611$export$9e4c657be710688a(displayable) {
    var style = displayable.style;
    var globalScale = displayable.getGlobalScale();
    return [
        style.shadowColor,
        (style.shadowBlur || 0).toFixed(2),
        (style.shadowOffsetX || 0).toFixed(2),
        (style.shadowOffsetY || 0).toFixed(2),
        globalScale[0],
        globalScale[1]
    ].join(',');
}
function $c453016f40eca611$export$8abc07640cab0527(clipPaths) {
    var key = [];
    if (clipPaths) for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        key.push(clipPath.id);
    }
    return key.join(',');
}
function $c453016f40eca611$export$2ade673ac4f85dfe(val) {
    return val && !!val.image;
}
function $c453016f40eca611$export$30352f47600a13cd(val) {
    return val && !!val.svgElement;
}
function $c453016f40eca611$export$41a28f5a000a9d0f(val) {
    return $c453016f40eca611$export$2ade673ac4f85dfe(val) || $c453016f40eca611$export$30352f47600a13cd(val);
}
function $c453016f40eca611$export$7d961bca9d3b47d0(val) {
    return val.type === 'linear';
}
function $c453016f40eca611$export$2a9cca6692a0ce3a(val) {
    return val.type === 'radial';
}
function $c453016f40eca611$export$545e02bbd5f8fe95(val) {
    return val && (val.type === 'linear' || val.type === 'radial');
}
function $c453016f40eca611$export$bb094196179998a5(id) {
    return "url(#" + id + ")";
}
function $c453016f40eca611$export$93fa1ae8a509371c(el) {
    var scale = el.getGlobalScale();
    var size = Math.max(scale[0], scale[1]);
    return Math.max(Math.ceil(Math.log(size) / Math.log(10)), 1);
}
function $c453016f40eca611$export$3fe07c0888ff6164(transform) {
    var x = transform.x || 0;
    var y = transform.y || 0;
    var rotation = (transform.rotation || 0) * (0, $1b239fc9d3a2f8ae$export$bce8e055322a0ce6);
    var scaleX = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(transform.scaleX, 1);
    var scaleY = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(transform.scaleY, 1);
    var skewX = transform.skewX || 0;
    var skewY = transform.skewY || 0;
    var res = [];
    if (x || y) res.push("translate(" + x + "px," + y + "px)");
    if (rotation) res.push("rotate(" + rotation + ")");
    if (scaleX !== 1 || scaleY !== 1) res.push("scale(" + scaleX + "," + scaleY + ")");
    if (skewX || skewY) res.push("skew(" + $c453016f40eca611$var$mathRound(skewX * (0, $1b239fc9d3a2f8ae$export$bce8e055322a0ce6)) + "deg, " + $c453016f40eca611$var$mathRound(skewY * (0, $1b239fc9d3a2f8ae$export$bce8e055322a0ce6)) + "deg)");
    return res.join(' ');
}
var $c453016f40eca611$export$8fb536984ec8b4d7 = function() {
    if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).hasGlobalWindow && (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(window.btoa)) return function(str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    };
    if (typeof $c453016f40eca611$require$Buffer !== 'undefined') return function(str) {
        return $c453016f40eca611$require$Buffer.from(str).toString('base64');
    };
    return function(str) {
        return null;
    };
}();


var $dc7faf503a6299d4$var$arraySlice = Array.prototype.slice;
function $dc7faf503a6299d4$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
function $dc7faf503a6299d4$var$interpolate1DArray(out, p0, p1, percent) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = $dc7faf503a6299d4$var$interpolateNumber(p0[i], p1[i], percent);
    return out;
}
function $dc7faf503a6299d4$var$interpolate2DArray(out, p0, p1, percent) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = $dc7faf503a6299d4$var$interpolateNumber(p0[i][j], p1[i][j], percent);
    }
    return out;
}
function $dc7faf503a6299d4$var$add1DArray(out, p0, p1, sign) {
    var len = p0.length;
    for(var i = 0; i < len; i++)out[i] = p0[i] + p1[i] * sign;
    return out;
}
function $dc7faf503a6299d4$var$add2DArray(out, p0, p1, sign) {
    var len = p0.length;
    var len2 = len && p0[0].length;
    for(var i = 0; i < len; i++){
        if (!out[i]) out[i] = [];
        for(var j = 0; j < len2; j++)out[i][j] = p0[i][j] + p1[i][j] * sign;
    }
    return out;
}
function $dc7faf503a6299d4$var$fillColorStops(val0, val1) {
    var len0 = val0.length;
    var len1 = val1.length;
    var shorterArr = len0 > len1 ? val1 : val0;
    var shorterLen = Math.min(len0, len1);
    var last = shorterArr[shorterLen - 1] || {
        color: [
            0,
            0,
            0,
            0
        ],
        offset: 0
    };
    for(var i = shorterLen; i < Math.max(len0, len1); i++)shorterArr.push({
        offset: last.offset,
        color: last.color.slice()
    });
}
function $dc7faf503a6299d4$var$fillArray(val0, val1, arrDim) {
    var arr0 = val0;
    var arr1 = val1;
    if (!arr0.push || !arr1.push) return;
    var arr0Len = arr0.length;
    var arr1Len = arr1.length;
    if (arr0Len !== arr1Len) {
        var isPreviousLarger = arr0Len > arr1Len;
        if (isPreviousLarger) arr0.length = arr1Len;
        else for(var i = arr0Len; i < arr1Len; i++)arr0.push(arrDim === 1 ? arr1[i] : $dc7faf503a6299d4$var$arraySlice.call(arr1[i]));
    }
    var len2 = arr0[0] && arr0[0].length;
    for(var i = 0; i < arr0.length; i++){
        if (arrDim === 1) {
            if (isNaN(arr0[i])) arr0[i] = arr1[i];
        } else {
            for(var j = 0; j < len2; j++)if (isNaN(arr0[i][j])) arr0[i][j] = arr1[i][j];
        }
    }
}
function $dc7faf503a6299d4$export$c5e92b7f105af84e(value) {
    if ((0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(value)) {
        var len = value.length;
        if ((0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(value[0])) {
            var ret = [];
            for(var i = 0; i < len; i++)ret.push($dc7faf503a6299d4$var$arraySlice.call(value[i]));
            return ret;
        }
        return $dc7faf503a6299d4$var$arraySlice.call(value);
    }
    return value;
}
function $dc7faf503a6299d4$var$rgba2String(rgba) {
    rgba[0] = Math.floor(rgba[0]) || 0;
    rgba[1] = Math.floor(rgba[1]) || 0;
    rgba[2] = Math.floor(rgba[2]) || 0;
    rgba[3] = rgba[3] == null ? 1 : rgba[3];
    return 'rgba(' + rgba.join(',') + ')';
}
function $dc7faf503a6299d4$var$guessArrayDim(value) {
    return (0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(value && value[0]) ? 2 : 1;
}
var $dc7faf503a6299d4$var$VALUE_TYPE_NUMBER = 0;
var $dc7faf503a6299d4$var$VALUE_TYPE_1D_ARRAY = 1;
var $dc7faf503a6299d4$var$VALUE_TYPE_2D_ARRAY = 2;
var $dc7faf503a6299d4$var$VALUE_TYPE_COLOR = 3;
var $dc7faf503a6299d4$var$VALUE_TYPE_LINEAR_GRADIENT = 4;
var $dc7faf503a6299d4$var$VALUE_TYPE_RADIAL_GRADIENT = 5;
var $dc7faf503a6299d4$var$VALUE_TYPE_UNKOWN = 6;
function $dc7faf503a6299d4$var$isGradientValueType(valType) {
    return valType === $dc7faf503a6299d4$var$VALUE_TYPE_LINEAR_GRADIENT || valType === $dc7faf503a6299d4$var$VALUE_TYPE_RADIAL_GRADIENT;
}
function $dc7faf503a6299d4$var$isArrayValueType(valType) {
    return valType === $dc7faf503a6299d4$var$VALUE_TYPE_1D_ARRAY || valType === $dc7faf503a6299d4$var$VALUE_TYPE_2D_ARRAY;
}
var $dc7faf503a6299d4$var$tmpRgba = [
    0,
    0,
    0,
    0
];
var $dc7faf503a6299d4$var$Track = function() {
    function Track(propName) {
        this.keyframes = [];
        this.discrete = false;
        this._invalid = false;
        this._needsSort = false;
        this._lastFr = 0;
        this._lastFrP = 0;
        this.propName = propName;
    }
    Track.prototype.isFinished = function() {
        return this._finished;
    };
    Track.prototype.setFinished = function() {
        this._finished = true;
        if (this._additiveTrack) this._additiveTrack.setFinished();
    };
    Track.prototype.needsAnimate = function() {
        return this.keyframes.length >= 1;
    };
    Track.prototype.getAdditiveTrack = function() {
        return this._additiveTrack;
    };
    Track.prototype.addKeyframe = function(time, rawValue, easing) {
        this._needsSort = true;
        var keyframes = this.keyframes;
        var len = keyframes.length;
        var discrete = false;
        var valType = $dc7faf503a6299d4$var$VALUE_TYPE_UNKOWN;
        var value = rawValue;
        if ((0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(rawValue)) {
            var arrayDim = $dc7faf503a6299d4$var$guessArrayDim(rawValue);
            valType = arrayDim;
            if (arrayDim === 1 && !(0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rawValue[0]) || arrayDim === 2 && !(0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rawValue[0][0])) discrete = true;
        } else {
            if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rawValue) && !(0, $1b239fc9d3a2f8ae$export$7d667b9a0c48c975)(rawValue)) valType = $dc7faf503a6299d4$var$VALUE_TYPE_NUMBER;
            else if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(rawValue)) {
                if (!isNaN(+rawValue)) valType = $dc7faf503a6299d4$var$VALUE_TYPE_NUMBER;
                else {
                    var colorArray = $35573db24643e2ef$export$98e6a39c04603d36(rawValue);
                    if (colorArray) {
                        value = colorArray;
                        valType = $dc7faf503a6299d4$var$VALUE_TYPE_COLOR;
                    }
                }
            } else if ((0, $1b239fc9d3a2f8ae$export$fa2c283003ed971c)(rawValue)) {
                var parsedGradient = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, value);
                parsedGradient.colorStops = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(rawValue.colorStops, function(colorStop) {
                    return {
                        offset: colorStop.offset,
                        color: $35573db24643e2ef$export$98e6a39c04603d36(colorStop.color)
                    };
                });
                if ((0, $c453016f40eca611$export$7d961bca9d3b47d0)(rawValue)) valType = $dc7faf503a6299d4$var$VALUE_TYPE_LINEAR_GRADIENT;
                else if ((0, $c453016f40eca611$export$2a9cca6692a0ce3a)(rawValue)) valType = $dc7faf503a6299d4$var$VALUE_TYPE_RADIAL_GRADIENT;
                value = parsedGradient;
            }
        }
        if (len === 0) this.valType = valType;
        else if (valType !== this.valType || valType === $dc7faf503a6299d4$var$VALUE_TYPE_UNKOWN) discrete = true;
        this.discrete = this.discrete || discrete;
        var kf = {
            time: time,
            value: value,
            rawValue: rawValue,
            percent: 0
        };
        if (easing) {
            kf.easing = easing;
            kf.easingFunc = (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(easing) ? easing : (0, $6a7e03908369e2ad$export$2e2bcd8739ae039)[easing] || (0, $d1811699cfe8103c$export$ec0863d806fd857e)(easing);
        }
        keyframes.push(kf);
        return kf;
    };
    Track.prototype.prepare = function(maxTime, additiveTrack) {
        var kfs = this.keyframes;
        if (this._needsSort) kfs.sort(function(a, b) {
            return a.time - b.time;
        });
        var valType = this.valType;
        var kfsLen = kfs.length;
        var lastKf = kfs[kfsLen - 1];
        var isDiscrete = this.discrete;
        var isArr = $dc7faf503a6299d4$var$isArrayValueType(valType);
        var isGradient = $dc7faf503a6299d4$var$isGradientValueType(valType);
        for(var i = 0; i < kfsLen; i++){
            var kf = kfs[i];
            var value = kf.value;
            var lastValue = lastKf.value;
            kf.percent = kf.time / maxTime;
            if (!isDiscrete) {
                if (isArr && i !== kfsLen - 1) $dc7faf503a6299d4$var$fillArray(value, lastValue, valType);
                else if (isGradient) $dc7faf503a6299d4$var$fillColorStops(value.colorStops, lastValue.colorStops);
            }
        }
        if (!isDiscrete && valType !== $dc7faf503a6299d4$var$VALUE_TYPE_RADIAL_GRADIENT && additiveTrack && this.needsAnimate() && additiveTrack.needsAnimate() && valType === additiveTrack.valType && !additiveTrack._finished) {
            this._additiveTrack = additiveTrack;
            var startValue = kfs[0].value;
            for(var i = 0; i < kfsLen; i++){
                if (valType === $dc7faf503a6299d4$var$VALUE_TYPE_NUMBER) kfs[i].additiveValue = kfs[i].value - startValue;
                else if (valType === $dc7faf503a6299d4$var$VALUE_TYPE_COLOR) kfs[i].additiveValue = $dc7faf503a6299d4$var$add1DArray([], kfs[i].value, startValue, -1);
                else if ($dc7faf503a6299d4$var$isArrayValueType(valType)) kfs[i].additiveValue = valType === $dc7faf503a6299d4$var$VALUE_TYPE_1D_ARRAY ? $dc7faf503a6299d4$var$add1DArray([], kfs[i].value, startValue, -1) : $dc7faf503a6299d4$var$add2DArray([], kfs[i].value, startValue, -1);
            }
        }
    };
    Track.prototype.step = function(target, percent) {
        if (this._finished) return;
        if (this._additiveTrack && this._additiveTrack._finished) this._additiveTrack = null;
        var isAdditive = this._additiveTrack != null;
        var valueKey = isAdditive ? 'additiveValue' : 'value';
        var valType = this.valType;
        var keyframes = this.keyframes;
        var kfsNum = keyframes.length;
        var propName = this.propName;
        var isValueColor = valType === $dc7faf503a6299d4$var$VALUE_TYPE_COLOR;
        var frameIdx;
        var lastFrame = this._lastFr;
        var mathMin = Math.min;
        var frame;
        var nextFrame;
        if (kfsNum === 1) frame = nextFrame = keyframes[0];
        else {
            if (percent < 0) frameIdx = 0;
            else if (percent < this._lastFrP) {
                var start = mathMin(lastFrame + 1, kfsNum - 1);
                for(frameIdx = start; frameIdx >= 0; frameIdx--){
                    if (keyframes[frameIdx].percent <= percent) break;
                }
                frameIdx = mathMin(frameIdx, kfsNum - 2);
            } else {
                for(frameIdx = lastFrame; frameIdx < kfsNum; frameIdx++){
                    if (keyframes[frameIdx].percent > percent) break;
                }
                frameIdx = mathMin(frameIdx - 1, kfsNum - 2);
            }
            nextFrame = keyframes[frameIdx + 1];
            frame = keyframes[frameIdx];
        }
        if (!(frame && nextFrame)) return;
        this._lastFr = frameIdx;
        this._lastFrP = percent;
        var interval = nextFrame.percent - frame.percent;
        var w = interval === 0 ? 1 : mathMin((percent - frame.percent) / interval, 1);
        if (nextFrame.easingFunc) w = nextFrame.easingFunc(w);
        var targetArr = isAdditive ? this._additiveValue : isValueColor ? $dc7faf503a6299d4$var$tmpRgba : target[propName];
        if (($dc7faf503a6299d4$var$isArrayValueType(valType) || isValueColor) && !targetArr) targetArr = this._additiveValue = [];
        if (this.discrete) target[propName] = w < 1 ? frame.rawValue : nextFrame.rawValue;
        else if ($dc7faf503a6299d4$var$isArrayValueType(valType)) valType === $dc7faf503a6299d4$var$VALUE_TYPE_1D_ARRAY ? $dc7faf503a6299d4$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w) : $dc7faf503a6299d4$var$interpolate2DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
        else if ($dc7faf503a6299d4$var$isGradientValueType(valType)) {
            var val = frame[valueKey];
            var nextVal_1 = nextFrame[valueKey];
            var isLinearGradient_1 = valType === $dc7faf503a6299d4$var$VALUE_TYPE_LINEAR_GRADIENT;
            target[propName] = {
                type: isLinearGradient_1 ? 'linear' : 'radial',
                x: $dc7faf503a6299d4$var$interpolateNumber(val.x, nextVal_1.x, w),
                y: $dc7faf503a6299d4$var$interpolateNumber(val.y, nextVal_1.y, w),
                colorStops: (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(val.colorStops, function(colorStop, idx) {
                    var nextColorStop = nextVal_1.colorStops[idx];
                    return {
                        offset: $dc7faf503a6299d4$var$interpolateNumber(colorStop.offset, nextColorStop.offset, w),
                        color: $dc7faf503a6299d4$var$rgba2String($dc7faf503a6299d4$var$interpolate1DArray([], colorStop.color, nextColorStop.color, w))
                    };
                }),
                global: nextVal_1.global
            };
            if (isLinearGradient_1) {
                target[propName].x2 = $dc7faf503a6299d4$var$interpolateNumber(val.x2, nextVal_1.x2, w);
                target[propName].y2 = $dc7faf503a6299d4$var$interpolateNumber(val.y2, nextVal_1.y2, w);
            } else target[propName].r = $dc7faf503a6299d4$var$interpolateNumber(val.r, nextVal_1.r, w);
        } else if (isValueColor) {
            $dc7faf503a6299d4$var$interpolate1DArray(targetArr, frame[valueKey], nextFrame[valueKey], w);
            if (!isAdditive) target[propName] = $dc7faf503a6299d4$var$rgba2String(targetArr);
        } else {
            var value = $dc7faf503a6299d4$var$interpolateNumber(frame[valueKey], nextFrame[valueKey], w);
            if (isAdditive) this._additiveValue = value;
            else target[propName] = value;
        }
        if (isAdditive) this._addToTarget(target);
    };
    Track.prototype._addToTarget = function(target) {
        var valType = this.valType;
        var propName = this.propName;
        var additiveValue = this._additiveValue;
        if (valType === $dc7faf503a6299d4$var$VALUE_TYPE_NUMBER) target[propName] = target[propName] + additiveValue;
        else if (valType === $dc7faf503a6299d4$var$VALUE_TYPE_COLOR) {
            $35573db24643e2ef$export$98e6a39c04603d36(target[propName], $dc7faf503a6299d4$var$tmpRgba);
            $dc7faf503a6299d4$var$add1DArray($dc7faf503a6299d4$var$tmpRgba, $dc7faf503a6299d4$var$tmpRgba, additiveValue, 1);
            target[propName] = $dc7faf503a6299d4$var$rgba2String($dc7faf503a6299d4$var$tmpRgba);
        } else if (valType === $dc7faf503a6299d4$var$VALUE_TYPE_1D_ARRAY) $dc7faf503a6299d4$var$add1DArray(target[propName], target[propName], additiveValue, 1);
        else if (valType === $dc7faf503a6299d4$var$VALUE_TYPE_2D_ARRAY) $dc7faf503a6299d4$var$add2DArray(target[propName], target[propName], additiveValue, 1);
    };
    return Track;
}();
var $dc7faf503a6299d4$var$Animator = function() {
    function Animator(target, loop, allowDiscreteAnimation, additiveTo) {
        this._tracks = {};
        this._trackKeys = [];
        this._maxTime = 0;
        this._started = 0;
        this._clip = null;
        this._target = target;
        this._loop = loop;
        if (loop && additiveTo) {
            (0, $1b239fc9d3a2f8ae$export$58da9968c3170cb1)('Can\' use additive animation on looped animation.');
            return;
        }
        this._additiveAnimators = additiveTo;
        this._allowDiscrete = allowDiscreteAnimation;
    }
    Animator.prototype.getMaxTime = function() {
        return this._maxTime;
    };
    Animator.prototype.getDelay = function() {
        return this._delay;
    };
    Animator.prototype.getLoop = function() {
        return this._loop;
    };
    Animator.prototype.getTarget = function() {
        return this._target;
    };
    Animator.prototype.changeTarget = function(target) {
        this._target = target;
    };
    Animator.prototype.when = function(time, props, easing) {
        return this.whenWithKeys(time, props, (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(props), easing);
    };
    Animator.prototype.whenWithKeys = function(time, props, propNames, easing) {
        var tracks = this._tracks;
        for(var i = 0; i < propNames.length; i++){
            var propName = propNames[i];
            var track = tracks[propName];
            if (!track) {
                track = tracks[propName] = new $dc7faf503a6299d4$var$Track(propName);
                var initialValue = void 0;
                var additiveTrack = this._getAdditiveTrack(propName);
                if (additiveTrack) {
                    var addtiveTrackKfs = additiveTrack.keyframes;
                    var lastFinalKf = addtiveTrackKfs[addtiveTrackKfs.length - 1];
                    initialValue = lastFinalKf && lastFinalKf.value;
                    if (additiveTrack.valType === $dc7faf503a6299d4$var$VALUE_TYPE_COLOR && initialValue) initialValue = $dc7faf503a6299d4$var$rgba2String(initialValue);
                } else initialValue = this._target[propName];
                if (initialValue == null) continue;
                if (time > 0) track.addKeyframe(0, $dc7faf503a6299d4$export$c5e92b7f105af84e(initialValue), easing);
                this._trackKeys.push(propName);
            }
            track.addKeyframe(time, $dc7faf503a6299d4$export$c5e92b7f105af84e(props[propName]), easing);
        }
        this._maxTime = Math.max(this._maxTime, time);
        return this;
    };
    Animator.prototype.pause = function() {
        this._clip.pause();
        this._paused = true;
    };
    Animator.prototype.resume = function() {
        this._clip.resume();
        this._paused = false;
    };
    Animator.prototype.isPaused = function() {
        return !!this._paused;
    };
    Animator.prototype.duration = function(duration) {
        this._maxTime = duration;
        this._force = true;
        return this;
    };
    Animator.prototype._doneCallback = function() {
        this._setTracksFinished();
        this._clip = null;
        var doneList = this._doneCbs;
        if (doneList) {
            var len = doneList.length;
            for(var i = 0; i < len; i++)doneList[i].call(this);
        }
    };
    Animator.prototype._abortedCallback = function() {
        this._setTracksFinished();
        var animation = this.animation;
        var abortedList = this._abortedCbs;
        if (animation) animation.removeClip(this._clip);
        this._clip = null;
        if (abortedList) for(var i = 0; i < abortedList.length; i++)abortedList[i].call(this);
    };
    Animator.prototype._setTracksFinished = function() {
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < tracksKeys.length; i++)tracks[tracksKeys[i]].setFinished();
    };
    Animator.prototype._getAdditiveTrack = function(trackName) {
        var additiveTrack;
        var additiveAnimators = this._additiveAnimators;
        if (additiveAnimators) for(var i = 0; i < additiveAnimators.length; i++){
            var track = additiveAnimators[i].getTrack(trackName);
            if (track) additiveTrack = track;
        }
        return additiveTrack;
    };
    Animator.prototype.start = function(easing) {
        if (this._started > 0) return;
        this._started = 1;
        var self = this;
        var tracks = [];
        var maxTime = this._maxTime || 0;
        for(var i = 0; i < this._trackKeys.length; i++){
            var propName = this._trackKeys[i];
            var track = this._tracks[propName];
            var additiveTrack = this._getAdditiveTrack(propName);
            var kfs = track.keyframes;
            var kfsNum = kfs.length;
            track.prepare(maxTime, additiveTrack);
            if (track.needsAnimate()) {
                if (!this._allowDiscrete && track.discrete) {
                    var lastKf = kfs[kfsNum - 1];
                    if (lastKf) self._target[track.propName] = lastKf.rawValue;
                    track.setFinished();
                } else tracks.push(track);
            }
        }
        if (tracks.length || this._force) {
            var clip = new (0, $f22bf67b3e548a26$export$2e2bcd8739ae039)({
                life: maxTime,
                loop: this._loop,
                delay: this._delay || 0,
                onframe: function(percent) {
                    self._started = 2;
                    var additiveAnimators = self._additiveAnimators;
                    if (additiveAnimators) {
                        var stillHasAdditiveAnimator = false;
                        for(var i = 0; i < additiveAnimators.length; i++)if (additiveAnimators[i]._clip) {
                            stillHasAdditiveAnimator = true;
                            break;
                        }
                        if (!stillHasAdditiveAnimator) self._additiveAnimators = null;
                    }
                    for(var i = 0; i < tracks.length; i++)tracks[i].step(self._target, percent);
                    var onframeList = self._onframeCbs;
                    if (onframeList) for(var i = 0; i < onframeList.length; i++)onframeList[i](self._target, percent);
                },
                ondestroy: function() {
                    self._doneCallback();
                }
            });
            this._clip = clip;
            if (this.animation) this.animation.addClip(clip);
            if (easing) clip.setEasing(easing);
        } else this._doneCallback();
        return this;
    };
    Animator.prototype.stop = function(forwardToLast) {
        if (!this._clip) return;
        var clip = this._clip;
        if (forwardToLast) clip.onframe(1);
        this._abortedCallback();
    };
    Animator.prototype.delay = function(time) {
        this._delay = time;
        return this;
    };
    Animator.prototype.during = function(cb) {
        if (cb) {
            if (!this._onframeCbs) this._onframeCbs = [];
            this._onframeCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.done = function(cb) {
        if (cb) {
            if (!this._doneCbs) this._doneCbs = [];
            this._doneCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.aborted = function(cb) {
        if (cb) {
            if (!this._abortedCbs) this._abortedCbs = [];
            this._abortedCbs.push(cb);
        }
        return this;
    };
    Animator.prototype.getClip = function() {
        return this._clip;
    };
    Animator.prototype.getTrack = function(propName) {
        return this._tracks[propName];
    };
    Animator.prototype.getTracks = function() {
        var _this = this;
        return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(this._trackKeys, function(key) {
            return _this._tracks[key];
        });
    };
    Animator.prototype.stopTracks = function(propNames, forwardToLast) {
        if (!propNames.length || !this._clip) return true;
        var tracks = this._tracks;
        var tracksKeys = this._trackKeys;
        for(var i = 0; i < propNames.length; i++){
            var track = tracks[propNames[i]];
            if (track && !track.isFinished()) {
                if (forwardToLast) track.step(this._target, 1);
                else if (this._started === 1) track.step(this._target, 0);
                track.setFinished();
            }
        }
        var allAborted = true;
        for(var i = 0; i < tracksKeys.length; i++)if (!tracks[tracksKeys[i]].isFinished()) {
            allAborted = false;
            break;
        }
        if (allAborted) this._abortedCallback();
        return allAborted;
    };
    Animator.prototype.saveTo = function(target, trackKeys, firstOrLast) {
        if (!target) return;
        trackKeys = trackKeys || this._trackKeys;
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track || track.isFinished()) continue;
            var kfs = track.keyframes;
            var kf = kfs[firstOrLast ? 0 : kfs.length - 1];
            if (kf) target[propName] = $dc7faf503a6299d4$export$c5e92b7f105af84e(kf.rawValue);
        }
    };
    Animator.prototype.__changeFinalValue = function(finalProps, trackKeys) {
        trackKeys = trackKeys || (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(finalProps);
        for(var i = 0; i < trackKeys.length; i++){
            var propName = trackKeys[i];
            var track = this._tracks[propName];
            if (!track) continue;
            var kfs = track.keyframes;
            if (kfs.length > 1) {
                var lastKf = kfs.pop();
                track.addKeyframe(lastKf.time, finalProps[propName]);
                track.prepare(this._maxTime, track.getAdditiveTrack());
            }
        }
    };
    return Animator;
}();
var $dc7faf503a6299d4$export$2e2bcd8739ae039 = $dc7faf503a6299d4$var$Animator;


function $ea9a0fd9147f2ce4$export$1428f42a7de81803() {
    return new Date().getTime();
}
var $ea9a0fd9147f2ce4$var$Animation = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Animation, _super);
    function Animation(opts) {
        var _this = _super.call(this) || this;
        _this._running = false;
        _this._time = 0;
        _this._pausedTime = 0;
        _this._pauseStart = 0;
        _this._paused = false;
        opts = opts || {};
        _this.stage = opts.stage || {};
        return _this;
    }
    Animation.prototype.addClip = function(clip) {
        if (clip.animation) this.removeClip(clip);
        if (!this._head) this._head = this._tail = clip;
        else {
            this._tail.next = clip;
            clip.prev = this._tail;
            clip.next = null;
            this._tail = clip;
        }
        clip.animation = this;
    };
    Animation.prototype.addAnimator = function(animator) {
        animator.animation = this;
        var clip = animator.getClip();
        if (clip) this.addClip(clip);
    };
    Animation.prototype.removeClip = function(clip) {
        if (!clip.animation) return;
        var prev = clip.prev;
        var next = clip.next;
        if (prev) prev.next = next;
        else this._head = next;
        if (next) next.prev = prev;
        else this._tail = prev;
        clip.next = clip.prev = clip.animation = null;
    };
    Animation.prototype.removeAnimator = function(animator) {
        var clip = animator.getClip();
        if (clip) this.removeClip(clip);
        animator.animation = null;
    };
    Animation.prototype.update = function(notTriggerFrameAndStageUpdate) {
        var time = $ea9a0fd9147f2ce4$export$1428f42a7de81803() - this._pausedTime;
        var delta = time - this._time;
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            var finished = clip.step(time, delta);
            if (finished) {
                clip.ondestroy();
                this.removeClip(clip);
                clip = nextClip;
            } else clip = nextClip;
        }
        this._time = time;
        if (!notTriggerFrameAndStageUpdate) {
            this.trigger('frame', delta);
            this.stage.update && this.stage.update();
        }
    };
    Animation.prototype._startLoop = function() {
        var self = this;
        this._running = true;
        function step() {
            if (self._running) {
                (0, $e582c54f2022f90d$export$2e2bcd8739ae039)(step);
                !self._paused && self.update();
            }
        }
        (0, $e582c54f2022f90d$export$2e2bcd8739ae039)(step);
    };
    Animation.prototype.start = function() {
        if (this._running) return;
        this._time = $ea9a0fd9147f2ce4$export$1428f42a7de81803();
        this._pausedTime = 0;
        this._startLoop();
    };
    Animation.prototype.stop = function() {
        this._running = false;
    };
    Animation.prototype.pause = function() {
        if (!this._paused) {
            this._pauseStart = $ea9a0fd9147f2ce4$export$1428f42a7de81803();
            this._paused = true;
        }
    };
    Animation.prototype.resume = function() {
        if (this._paused) {
            this._pausedTime += $ea9a0fd9147f2ce4$export$1428f42a7de81803() - this._pauseStart;
            this._paused = false;
        }
    };
    Animation.prototype.clear = function() {
        var clip = this._head;
        while(clip){
            var nextClip = clip.next;
            clip.prev = clip.next = clip.animation = null;
            clip = nextClip;
        }
        this._head = this._tail = null;
    };
    Animation.prototype.isFinished = function() {
        return this._head == null;
    };
    Animation.prototype.animate = function(target, options) {
        options = options || {};
        this.start();
        var animator = new (0, $dc7faf503a6299d4$export$2e2bcd8739ae039)(target, options.loop);
        this.addAnimator(animator);
        return animator;
    };
    return Animation;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
var $ea9a0fd9147f2ce4$export$2e2bcd8739ae039 = $ea9a0fd9147f2ce4$var$Animation;







var $d89be63bc3db003e$var$TOUCH_CLICK_DELAY = 300;
var $d89be63bc3db003e$var$globalEventSupported = (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).domSupported;
var $d89be63bc3db003e$var$localNativeListenerNames = function() {
    var mouseHandlerNames = [
        'click',
        'dblclick',
        'mousewheel',
        'wheel',
        'mouseout',
        'mouseup',
        'mousedown',
        'mousemove',
        'contextmenu'
    ];
    var touchHandlerNames = [
        'touchstart',
        'touchend',
        'touchmove'
    ];
    var pointerEventNameMap = {
        pointerdown: 1,
        pointerup: 1,
        pointermove: 1,
        pointerout: 1
    };
    var pointerHandlerNames = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(mouseHandlerNames, function(name) {
        var nm = name.replace('mouse', 'pointer');
        return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
    });
    return {
        mouse: mouseHandlerNames,
        touch: touchHandlerNames,
        pointer: pointerHandlerNames
    };
}();
var $d89be63bc3db003e$var$globalNativeListenerNames = {
    mouse: [
        'mousemove',
        'mouseup'
    ],
    pointer: [
        'pointermove',
        'pointerup'
    ]
};
var $d89be63bc3db003e$var$wheelEventSupported = false;
function $d89be63bc3db003e$var$isPointerFromTouch(event) {
    var pointerType = event.pointerType;
    return pointerType === 'pen' || pointerType === 'touch';
}
function $d89be63bc3db003e$var$setTouchTimer(scope) {
    scope.touching = true;
    if (scope.touchTimer != null) {
        clearTimeout(scope.touchTimer);
        scope.touchTimer = null;
    }
    scope.touchTimer = setTimeout(function() {
        scope.touching = false;
        scope.touchTimer = null;
    }, 700);
}
function $d89be63bc3db003e$var$markTouch(event) {
    event && (event.zrByTouch = true);
}
function $d89be63bc3db003e$var$normalizeGlobalEvent(instance, event) {
    return (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(instance.dom, new $d89be63bc3db003e$var$FakeGlobalEvent(instance, event), true);
}
function $d89be63bc3db003e$var$isLocalEl(instance, el) {
    var elTmp = el;
    var isLocal = false;
    while(elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot))elTmp = elTmp.parentNode;
    return isLocal;
}
var $d89be63bc3db003e$var$FakeGlobalEvent = function() {
    function FakeGlobalEvent(instance, event) {
        this.stopPropagation = $1b239fc9d3a2f8ae$export$8793edee2d425525;
        this.stopImmediatePropagation = $1b239fc9d3a2f8ae$export$8793edee2d425525;
        this.preventDefault = $1b239fc9d3a2f8ae$export$8793edee2d425525;
        this.type = event.type;
        this.target = this.currentTarget = instance.dom;
        this.pointerType = event.pointerType;
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }
    return FakeGlobalEvent;
}();
var $d89be63bc3db003e$var$localDOMHandlers = {
    mousedown: function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        this.__mayPointerCapture = [
            event.zrX,
            event.zrY
        ];
        this.trigger('mousedown', event);
    },
    mousemove: function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        var downPoint = this.__mayPointerCapture;
        if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) this.__togglePointerCapture(true);
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
    },
    mouseout: function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        var element = event.toElement || event.relatedTarget;
        if (!$d89be63bc3db003e$var$isLocalEl(this, element)) {
            if (this.__pointerCapturing) event.zrEventControl = 'no_globalout';
            this.trigger('mouseout', event);
        }
    },
    wheel: function(event) {
        $d89be63bc3db003e$var$wheelEventSupported = true;
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    mousewheel: function(event) {
        if ($d89be63bc3db003e$var$wheelEventSupported) return;
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        this.trigger('mousewheel', event);
    },
    touchstart: function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        $d89be63bc3db003e$var$markTouch(event);
        this.__lastTouchMoment = new Date();
        this.handler.processGesture(event, 'start');
        $d89be63bc3db003e$var$localDOMHandlers.mousemove.call(this, event);
        $d89be63bc3db003e$var$localDOMHandlers.mousedown.call(this, event);
    },
    touchmove: function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        $d89be63bc3db003e$var$markTouch(event);
        this.handler.processGesture(event, 'change');
        $d89be63bc3db003e$var$localDOMHandlers.mousemove.call(this, event);
    },
    touchend: function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        $d89be63bc3db003e$var$markTouch(event);
        this.handler.processGesture(event, 'end');
        $d89be63bc3db003e$var$localDOMHandlers.mouseup.call(this, event);
        if (+new Date() - +this.__lastTouchMoment < $d89be63bc3db003e$var$TOUCH_CLICK_DELAY) $d89be63bc3db003e$var$localDOMHandlers.click.call(this, event);
    },
    pointerdown: function(event) {
        $d89be63bc3db003e$var$localDOMHandlers.mousedown.call(this, event);
    },
    pointermove: function(event) {
        if (!$d89be63bc3db003e$var$isPointerFromTouch(event)) $d89be63bc3db003e$var$localDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $d89be63bc3db003e$var$localDOMHandlers.mouseup.call(this, event);
    },
    pointerout: function(event) {
        if (!$d89be63bc3db003e$var$isPointerFromTouch(event)) $d89be63bc3db003e$var$localDOMHandlers.mouseout.call(this, event);
    }
};
$1b239fc9d3a2f8ae$export$79b2f7037acddd43([
    'click',
    'dblclick',
    'contextmenu'
], function(name) {
    $d89be63bc3db003e$var$localDOMHandlers[name] = function(event) {
        event = (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(this.dom, event);
        this.trigger(name, event);
    };
});
var $d89be63bc3db003e$var$globalDOMHandlers = {
    pointermove: function(event) {
        if (!$d89be63bc3db003e$var$isPointerFromTouch(event)) $d89be63bc3db003e$var$globalDOMHandlers.mousemove.call(this, event);
    },
    pointerup: function(event) {
        $d89be63bc3db003e$var$globalDOMHandlers.mouseup.call(this, event);
    },
    mousemove: function(event) {
        this.trigger('mousemove', event);
    },
    mouseup: function(event) {
        var pointerCaptureReleasing = this.__pointerCapturing;
        this.__togglePointerCapture(false);
        this.trigger('mouseup', event);
        if (pointerCaptureReleasing) {
            event.zrEventControl = 'only_globalout';
            this.trigger('mouseout', event);
        }
    }
};
function $d89be63bc3db003e$var$mountLocalDOMEventListeners(instance, scope) {
    var domHandlers = scope.domHandlers;
    if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).pointerEventsSupported) $1b239fc9d3a2f8ae$export$79b2f7037acddd43($d89be63bc3db003e$var$localNativeListenerNames.pointer, function(nativeEventName) {
        $d89be63bc3db003e$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
            domHandlers[nativeEventName].call(instance, event);
        });
    });
    else {
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).touchEventsSupported) $1b239fc9d3a2f8ae$export$79b2f7037acddd43($d89be63bc3db003e$var$localNativeListenerNames.touch, function(nativeEventName) {
            $d89be63bc3db003e$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                domHandlers[nativeEventName].call(instance, event);
                $d89be63bc3db003e$var$setTouchTimer(scope);
            });
        });
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($d89be63bc3db003e$var$localNativeListenerNames.mouse, function(nativeEventName) {
            $d89be63bc3db003e$var$mountSingleDOMEventListener(scope, nativeEventName, function(event) {
                event = (0, $8f7ba7c16ab1583e$export$4abe0e945399ac1d)(event);
                if (!scope.touching) domHandlers[nativeEventName].call(instance, event);
            });
        });
    }
}
function $d89be63bc3db003e$var$mountGlobalDOMEventListeners(instance, scope) {
    if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).pointerEventsSupported) $1b239fc9d3a2f8ae$export$79b2f7037acddd43($d89be63bc3db003e$var$globalNativeListenerNames.pointer, mount);
    else if (!(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).touchEventsSupported) $1b239fc9d3a2f8ae$export$79b2f7037acddd43($d89be63bc3db003e$var$globalNativeListenerNames.mouse, mount);
    function mount(nativeEventName) {
        function nativeEventListener(event) {
            event = (0, $8f7ba7c16ab1583e$export$4abe0e945399ac1d)(event);
            if (!$d89be63bc3db003e$var$isLocalEl(instance, event.target)) {
                event = $d89be63bc3db003e$var$normalizeGlobalEvent(instance, event);
                scope.domHandlers[nativeEventName].call(instance, event);
            }
        }
        $d89be63bc3db003e$var$mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
            capture: true
        });
    }
}
function $d89be63bc3db003e$var$mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
    scope.mounted[nativeEventName] = listener;
    scope.listenerOpts[nativeEventName] = opt;
    (0, $8f7ba7c16ab1583e$export$3f65cefe8380dbea)(scope.domTarget, nativeEventName, listener, opt);
}
function $d89be63bc3db003e$var$unmountDOMEventListeners(scope) {
    var mounted = scope.mounted;
    for(var nativeEventName in mounted)if (mounted.hasOwnProperty(nativeEventName)) (0, $8f7ba7c16ab1583e$export$8ff9f68337b520c0)(scope.domTarget, nativeEventName, mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
    scope.mounted = {};
}
var $d89be63bc3db003e$var$DOMHandlerScope = function() {
    function DOMHandlerScope(domTarget, domHandlers) {
        this.mounted = {};
        this.listenerOpts = {};
        this.touching = false;
        this.domTarget = domTarget;
        this.domHandlers = domHandlers;
    }
    return DOMHandlerScope;
}();
var $d89be63bc3db003e$var$HandlerDomProxy = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(HandlerDomProxy, _super);
    function HandlerDomProxy(dom, painterRoot) {
        var _this = _super.call(this) || this;
        _this.__pointerCapturing = false;
        _this.dom = dom;
        _this.painterRoot = painterRoot;
        _this._localHandlerScope = new $d89be63bc3db003e$var$DOMHandlerScope(dom, $d89be63bc3db003e$var$localDOMHandlers);
        if ($d89be63bc3db003e$var$globalEventSupported) _this._globalHandlerScope = new $d89be63bc3db003e$var$DOMHandlerScope(document, $d89be63bc3db003e$var$globalDOMHandlers);
        $d89be63bc3db003e$var$mountLocalDOMEventListeners(_this, _this._localHandlerScope);
        return _this;
    }
    HandlerDomProxy.prototype.dispose = function() {
        $d89be63bc3db003e$var$unmountDOMEventListeners(this._localHandlerScope);
        if ($d89be63bc3db003e$var$globalEventSupported) $d89be63bc3db003e$var$unmountDOMEventListeners(this._globalHandlerScope);
    };
    HandlerDomProxy.prototype.setCursor = function(cursorStyle) {
        this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
    };
    HandlerDomProxy.prototype.__togglePointerCapture = function(isPointerCapturing) {
        this.__mayPointerCapture = null;
        if ($d89be63bc3db003e$var$globalEventSupported && +this.__pointerCapturing ^ +isPointerCapturing) {
            this.__pointerCapturing = isPointerCapturing;
            var globalHandlerScope = this._globalHandlerScope;
            isPointerCapturing ? $d89be63bc3db003e$var$mountGlobalDOMEventListeners(this, globalHandlerScope) : $d89be63bc3db003e$var$unmountDOMEventListeners(globalHandlerScope);
        }
    };
    return HandlerDomProxy;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
var $d89be63bc3db003e$export$2e2bcd8739ae039 = $d89be63bc3db003e$var$HandlerDomProxy;




var $495ebc0cfec45c57$var$dpr = 1;
if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).hasGlobalWindow) $495ebc0cfec45c57$var$dpr = Math.max(window.devicePixelRatio || window.screen && window.screen.deviceXDPI / window.screen.logicalXDPI || 1, 1);
var $495ebc0cfec45c57$export$7cdcde344c85339c = 0;
var $495ebc0cfec45c57$export$508f096bfcdaac40 = $495ebc0cfec45c57$var$dpr;
var $495ebc0cfec45c57$export$fd81e7ebc7dae256 = 0.4;
var $495ebc0cfec45c57$export$f8ce94761f39398d = '#333';
var $495ebc0cfec45c57$export$3c6e95f318c8369b = '#ccc';
var $495ebc0cfec45c57$export$27682248795c3c6b = '#eee';






var $cd11a033fc7d29e7$var$mIdentity = $78537c687449356c$export$f0954fd7d5368655;
var $cd11a033fc7d29e7$var$EPSILON = 5e-5;
function $cd11a033fc7d29e7$var$isNotAroundZero(val) {
    return val > $cd11a033fc7d29e7$var$EPSILON || val < -$cd11a033fc7d29e7$var$EPSILON;
}
var $cd11a033fc7d29e7$var$scaleTmp = [];
var $cd11a033fc7d29e7$var$tmpTransform = [];
var $cd11a033fc7d29e7$var$originTransform = $78537c687449356c$export$185802fd694ee1f5();
var $cd11a033fc7d29e7$var$abs = Math.abs;
var $cd11a033fc7d29e7$var$Transformable = function() {
    function Transformable() {}
    Transformable.prototype.getLocalTransform = function(m) {
        return Transformable.getLocalTransform(this, m);
    };
    Transformable.prototype.setPosition = function(arr) {
        this.x = arr[0];
        this.y = arr[1];
    };
    Transformable.prototype.setScale = function(arr) {
        this.scaleX = arr[0];
        this.scaleY = arr[1];
    };
    Transformable.prototype.setSkew = function(arr) {
        this.skewX = arr[0];
        this.skewY = arr[1];
    };
    Transformable.prototype.setOrigin = function(arr) {
        this.originX = arr[0];
        this.originY = arr[1];
    };
    Transformable.prototype.needLocalTransform = function() {
        return $cd11a033fc7d29e7$var$isNotAroundZero(this.rotation) || $cd11a033fc7d29e7$var$isNotAroundZero(this.x) || $cd11a033fc7d29e7$var$isNotAroundZero(this.y) || $cd11a033fc7d29e7$var$isNotAroundZero(this.scaleX - 1) || $cd11a033fc7d29e7$var$isNotAroundZero(this.scaleY - 1) || $cd11a033fc7d29e7$var$isNotAroundZero(this.skewX) || $cd11a033fc7d29e7$var$isNotAroundZero(this.skewY);
    };
    Transformable.prototype.updateTransform = function() {
        var parentTransform = this.parent && this.parent.transform;
        var needLocalTransform = this.needLocalTransform();
        var m = this.transform;
        if (!(needLocalTransform || parentTransform)) {
            if (m) {
                $cd11a033fc7d29e7$var$mIdentity(m);
                this.invTransform = null;
            }
            return;
        }
        m = m || $78537c687449356c$export$185802fd694ee1f5();
        if (needLocalTransform) this.getLocalTransform(m);
        else $cd11a033fc7d29e7$var$mIdentity(m);
        if (parentTransform) {
            if (needLocalTransform) $78537c687449356c$export$6e3a27864ab166fe(m, parentTransform, m);
            else $78537c687449356c$export$784d13d8ee351f07(m, parentTransform);
        }
        this.transform = m;
        this._resolveGlobalScaleRatio(m);
    };
    Transformable.prototype._resolveGlobalScaleRatio = function(m) {
        var globalScaleRatio = this.globalScaleRatio;
        if (globalScaleRatio != null && globalScaleRatio !== 1) {
            this.getGlobalScale($cd11a033fc7d29e7$var$scaleTmp);
            var relX = $cd11a033fc7d29e7$var$scaleTmp[0] < 0 ? -1 : 1;
            var relY = $cd11a033fc7d29e7$var$scaleTmp[1] < 0 ? -1 : 1;
            var sx = (($cd11a033fc7d29e7$var$scaleTmp[0] - relX) * globalScaleRatio + relX) / $cd11a033fc7d29e7$var$scaleTmp[0] || 0;
            var sy = (($cd11a033fc7d29e7$var$scaleTmp[1] - relY) * globalScaleRatio + relY) / $cd11a033fc7d29e7$var$scaleTmp[1] || 0;
            m[0] *= sx;
            m[1] *= sx;
            m[2] *= sy;
            m[3] *= sy;
        }
        this.invTransform = this.invTransform || $78537c687449356c$export$185802fd694ee1f5();
        $78537c687449356c$export$6897c284b6f9f4dc(this.invTransform, m);
    };
    Transformable.prototype.getComputedTransform = function() {
        var transformNode = this;
        var ancestors = [];
        while(transformNode){
            ancestors.push(transformNode);
            transformNode = transformNode.parent;
        }
        while(transformNode = ancestors.pop())transformNode.updateTransform();
        return this.transform;
    };
    Transformable.prototype.setLocalTransform = function(m) {
        if (!m) return;
        var sx = m[0] * m[0] + m[1] * m[1];
        var sy = m[2] * m[2] + m[3] * m[3];
        var rotation = Math.atan2(m[1], m[0]);
        var shearX = Math.PI / 2 + rotation - Math.atan2(m[3], m[2]);
        sy = Math.sqrt(sy) * Math.cos(shearX);
        sx = Math.sqrt(sx);
        this.skewX = shearX;
        this.skewY = 0;
        this.rotation = -rotation;
        this.x = +m[4];
        this.y = +m[5];
        this.scaleX = sx;
        this.scaleY = sy;
        this.originX = 0;
        this.originY = 0;
    };
    Transformable.prototype.decomposeTransform = function() {
        if (!this.transform) return;
        var parent = this.parent;
        var m = this.transform;
        if (parent && parent.transform) {
            parent.invTransform = parent.invTransform || $78537c687449356c$export$185802fd694ee1f5();
            $78537c687449356c$export$6e3a27864ab166fe($cd11a033fc7d29e7$var$tmpTransform, parent.invTransform, m);
            m = $cd11a033fc7d29e7$var$tmpTransform;
        }
        var ox = this.originX;
        var oy = this.originY;
        if (ox || oy) {
            $cd11a033fc7d29e7$var$originTransform[4] = ox;
            $cd11a033fc7d29e7$var$originTransform[5] = oy;
            $78537c687449356c$export$6e3a27864ab166fe($cd11a033fc7d29e7$var$tmpTransform, m, $cd11a033fc7d29e7$var$originTransform);
            $cd11a033fc7d29e7$var$tmpTransform[4] -= ox;
            $cd11a033fc7d29e7$var$tmpTransform[5] -= oy;
            m = $cd11a033fc7d29e7$var$tmpTransform;
        }
        this.setLocalTransform(m);
    };
    Transformable.prototype.getGlobalScale = function(out) {
        var m = this.transform;
        out = out || [];
        if (!m) {
            out[0] = 1;
            out[1] = 1;
            return out;
        }
        out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
        out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
        if (m[0] < 0) out[0] = -out[0];
        if (m[3] < 0) out[1] = -out[1];
        return out;
    };
    Transformable.prototype.transformCoordToLocal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var invTransform = this.invTransform;
        if (invTransform) $3dde7d051fe20daa$export$9f9dcb98c894b623(v2, v2, invTransform);
        return v2;
    };
    Transformable.prototype.transformCoordToGlobal = function(x, y) {
        var v2 = [
            x,
            y
        ];
        var transform = this.transform;
        if (transform) $3dde7d051fe20daa$export$9f9dcb98c894b623(v2, v2, transform);
        return v2;
    };
    Transformable.prototype.getLineScale = function() {
        var m = this.transform;
        return m && $cd11a033fc7d29e7$var$abs(m[0] - 1) > 1e-10 && $cd11a033fc7d29e7$var$abs(m[3] - 1) > 1e-10 ? Math.sqrt($cd11a033fc7d29e7$var$abs(m[0] * m[3] - m[2] * m[1])) : 1;
    };
    Transformable.prototype.copyTransform = function(source) {
        $cd11a033fc7d29e7$export$234b1c16dfa57d6a(this, source);
    };
    Transformable.getLocalTransform = function(target, m) {
        m = m || [];
        var ox = target.originX || 0;
        var oy = target.originY || 0;
        var sx = target.scaleX;
        var sy = target.scaleY;
        var ax = target.anchorX;
        var ay = target.anchorY;
        var rotation = target.rotation || 0;
        var x = target.x;
        var y = target.y;
        var skewX = target.skewX ? Math.tan(target.skewX) : 0;
        var skewY = target.skewY ? Math.tan(-target.skewY) : 0;
        if (ox || oy || ax || ay) {
            var dx = ox + ax;
            var dy = oy + ay;
            m[4] = -dx * sx - skewX * dy * sy;
            m[5] = -dy * sy - skewY * dx * sx;
        } else m[4] = m[5] = 0;
        m[0] = sx;
        m[3] = sy;
        m[1] = skewY * sx;
        m[2] = skewX * sy;
        rotation && $78537c687449356c$export$bb628a54ab399bc9(m, m, rotation);
        m[4] += ox + x;
        m[5] += oy + y;
        return m;
    };
    Transformable.initDefaultProps = function() {
        var proto = Transformable.prototype;
        proto.scaleX = proto.scaleY = proto.globalScaleRatio = 1;
        proto.x = proto.y = proto.originX = proto.originY = proto.skewX = proto.skewY = proto.rotation = proto.anchorX = proto.anchorY = 0;
    }();
    return Transformable;
}();
var $cd11a033fc7d29e7$export$98ab6203ec3396e2 = [
    'x',
    'y',
    'originX',
    'originY',
    'anchorX',
    'anchorY',
    'rotation',
    'scaleX',
    'scaleY',
    'skewX',
    'skewY'
];
function $cd11a033fc7d29e7$export$234b1c16dfa57d6a(target, source) {
    for(var i = 0; i < $cd11a033fc7d29e7$export$98ab6203ec3396e2.length; i++){
        var propName = $cd11a033fc7d29e7$export$98ab6203ec3396e2[i];
        target[propName] = source[propName];
    }
}
var $cd11a033fc7d29e7$export$2e2bcd8739ae039 = $cd11a033fc7d29e7$var$Transformable;








var $297531217517fbce$var$textWidthCache = {};
function $297531217517fbce$export$3c49c185de0c2bfc(text, font) {
    font = font || (0, $024b63ea846a8ccd$export$7d7a232b6d2cc80c);
    var cacheOfFont = $297531217517fbce$var$textWidthCache[font];
    if (!cacheOfFont) cacheOfFont = $297531217517fbce$var$textWidthCache[font] = new (0, $db88c5ee7dbc7394$export$2e2bcd8739ae039)(500);
    var width = cacheOfFont.get(text);
    if (width == null) {
        width = (0, $024b63ea846a8ccd$export$ef5e599365494451).measureText(text, font).width;
        cacheOfFont.put(text, width);
    }
    return width;
}
function $297531217517fbce$export$85aabf24202fbe9b(text, font, textAlign, textBaseline) {
    var width = $297531217517fbce$export$3c49c185de0c2bfc(text, font);
    var height = $297531217517fbce$export$56204a27a2958a55(font);
    var x = $297531217517fbce$export$eb5a525ef00ef9a4(0, width, textAlign);
    var y = $297531217517fbce$export$bf7d6802d2badd9(0, height, textBaseline);
    var rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, width, height);
    return rect;
}
function $297531217517fbce$export$c381147bfed79d9f(text, font, textAlign, textBaseline) {
    var textLines = ((text || '') + '').split('\n');
    var len = textLines.length;
    if (len === 1) return $297531217517fbce$export$85aabf24202fbe9b(textLines[0], font, textAlign, textBaseline);
    else {
        var uniondRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
        for(var i = 0; i < textLines.length; i++){
            var rect = $297531217517fbce$export$85aabf24202fbe9b(textLines[i], font, textAlign, textBaseline);
            i === 0 ? uniondRect.copy(rect) : uniondRect.union(rect);
        }
        return uniondRect;
    }
}
function $297531217517fbce$export$eb5a525ef00ef9a4(x, width, textAlign) {
    if (textAlign === 'right') x -= width;
    else if (textAlign === 'center') x -= width / 2;
    return x;
}
function $297531217517fbce$export$bf7d6802d2badd9(y, height, verticalAlign) {
    if (verticalAlign === 'middle') y -= height / 2;
    else if (verticalAlign === 'bottom') y -= height;
    return y;
}
function $297531217517fbce$export$56204a27a2958a55(font) {
    return $297531217517fbce$export$3c49c185de0c2bfc("\u56FD", font);
}
function $297531217517fbce$export$866cc30a33805630(text, font) {
    return (0, $024b63ea846a8ccd$export$ef5e599365494451).measureText(text, font);
}
function $297531217517fbce$export$e8514cb5a5e2b40f(value, maxValue) {
    if (typeof value === 'string') {
        if (value.lastIndexOf('%') >= 0) return parseFloat(value) / 100 * maxValue;
        return parseFloat(value);
    }
    return value;
}
function $297531217517fbce$export$eee3603b512feab7(out, opts, rect) {
    var textPosition = opts.position || 'inside';
    var distance = opts.distance != null ? opts.distance : 5;
    var height = rect.height;
    var width = rect.width;
    var halfHeight = height / 2;
    var x = rect.x;
    var y = rect.y;
    var textAlign = 'left';
    var textVerticalAlign = 'top';
    if (textPosition instanceof Array) {
        x += $297531217517fbce$export$e8514cb5a5e2b40f(textPosition[0], rect.width);
        y += $297531217517fbce$export$e8514cb5a5e2b40f(textPosition[1], rect.height);
        textAlign = null;
        textVerticalAlign = null;
    } else switch(textPosition){
        case 'left':
            x -= distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'right':
            x += distance + width;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'top':
            x += width / 2;
            y -= distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'bottom':
            x += width / 2;
            y += height + distance;
            textAlign = 'center';
            break;
        case 'inside':
            x += width / 2;
            y += halfHeight;
            textAlign = 'center';
            textVerticalAlign = 'middle';
            break;
        case 'insideLeft':
            x += distance;
            y += halfHeight;
            textVerticalAlign = 'middle';
            break;
        case 'insideRight':
            x += width - distance;
            y += halfHeight;
            textAlign = 'right';
            textVerticalAlign = 'middle';
            break;
        case 'insideTop':
            x += width / 2;
            y += distance;
            textAlign = 'center';
            break;
        case 'insideBottom':
            x += width / 2;
            y += height - distance;
            textAlign = 'center';
            textVerticalAlign = 'bottom';
            break;
        case 'insideTopLeft':
            x += distance;
            y += distance;
            break;
        case 'insideTopRight':
            x += width - distance;
            y += distance;
            textAlign = 'right';
            break;
        case 'insideBottomLeft':
            x += distance;
            y += height - distance;
            textVerticalAlign = 'bottom';
            break;
        case 'insideBottomRight':
            x += width - distance;
            y += height - distance;
            textAlign = 'right';
            textVerticalAlign = 'bottom';
            break;
    }
    out = out || {};
    out.x = x;
    out.y = y;
    out.align = textAlign;
    out.verticalAlign = textVerticalAlign;
    return out;
}






var $32f73300204a2d4b$export$97b5e845c7286801 = '__zr_normal__';
var $32f73300204a2d4b$var$PRIMARY_STATES_KEYS = (0, $cd11a033fc7d29e7$export$98ab6203ec3396e2).concat([
    'ignore'
]);
var $32f73300204a2d4b$var$DEFAULT_ANIMATABLE_MAP = (0, $1b239fc9d3a2f8ae$export$533b26079ad0b4b)((0, $cd11a033fc7d29e7$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = true;
    return obj;
}, {
    ignore: false
});
var $32f73300204a2d4b$var$tmpTextPosCalcRes = {};
var $32f73300204a2d4b$var$tmpBoundingRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $32f73300204a2d4b$var$Element = function() {
    function Element(props) {
        this.id = (0, $1b239fc9d3a2f8ae$export$46e8f25c7328f77e)();
        this.animators = [];
        this.currentStates = [];
        this.states = {};
        this._init(props);
    }
    Element.prototype._init = function(props) {
        this.attr(props);
    };
    Element.prototype.drift = function(dx, dy, e) {
        switch(this.draggable){
            case 'horizontal':
                dy = 0;
                break;
            case 'vertical':
                dx = 0;
                break;
        }
        var m = this.transform;
        if (!m) m = this.transform = [
            1,
            0,
            0,
            1,
            0,
            0
        ];
        m[4] += dx;
        m[5] += dy;
        this.decomposeTransform();
        this.markRedraw();
    };
    Element.prototype.beforeUpdate = function() {};
    Element.prototype.afterUpdate = function() {};
    Element.prototype.update = function() {
        this.updateTransform();
        if (this.__dirty) this.updateInnerText();
    };
    Element.prototype.updateInnerText = function(forceUpdate) {
        var textEl = this._textContent;
        if (textEl && (!textEl.ignore || forceUpdate)) {
            if (!this.textConfig) this.textConfig = {};
            var textConfig = this.textConfig;
            var isLocal = textConfig.local;
            var innerTransformable = textEl.innerTransformable;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var textStyleChanged = false;
            innerTransformable.parent = isLocal ? this : null;
            var innerOrigin = false;
            innerTransformable.copyTransform(textEl);
            if (textConfig.position != null) {
                var layoutRect = $32f73300204a2d4b$var$tmpBoundingRect;
                if (textConfig.layoutRect) layoutRect.copy(textConfig.layoutRect);
                else layoutRect.copy(this.getBoundingRect());
                if (!isLocal) layoutRect.applyTransform(this.transform);
                if (this.calculateTextPosition) this.calculateTextPosition($32f73300204a2d4b$var$tmpTextPosCalcRes, textConfig, layoutRect);
                else (0, $297531217517fbce$export$eee3603b512feab7)($32f73300204a2d4b$var$tmpTextPosCalcRes, textConfig, layoutRect);
                innerTransformable.x = $32f73300204a2d4b$var$tmpTextPosCalcRes.x;
                innerTransformable.y = $32f73300204a2d4b$var$tmpTextPosCalcRes.y;
                textAlign = $32f73300204a2d4b$var$tmpTextPosCalcRes.align;
                textVerticalAlign = $32f73300204a2d4b$var$tmpTextPosCalcRes.verticalAlign;
                var textOrigin = textConfig.origin;
                if (textOrigin && textConfig.rotation != null) {
                    var relOriginX = void 0;
                    var relOriginY = void 0;
                    if (textOrigin === 'center') {
                        relOriginX = layoutRect.width * 0.5;
                        relOriginY = layoutRect.height * 0.5;
                    } else {
                        relOriginX = (0, $297531217517fbce$export$e8514cb5a5e2b40f)(textOrigin[0], layoutRect.width);
                        relOriginY = (0, $297531217517fbce$export$e8514cb5a5e2b40f)(textOrigin[1], layoutRect.height);
                    }
                    innerOrigin = true;
                    innerTransformable.originX = -innerTransformable.x + relOriginX + (isLocal ? 0 : layoutRect.x);
                    innerTransformable.originY = -innerTransformable.y + relOriginY + (isLocal ? 0 : layoutRect.y);
                }
            }
            if (textConfig.rotation != null) innerTransformable.rotation = textConfig.rotation;
            var textOffset = textConfig.offset;
            if (textOffset) {
                innerTransformable.x += textOffset[0];
                innerTransformable.y += textOffset[1];
                if (!innerOrigin) {
                    innerTransformable.originX = -textOffset[0];
                    innerTransformable.originY = -textOffset[1];
                }
            }
            var isInside = textConfig.inside == null ? typeof textConfig.position === 'string' && textConfig.position.indexOf('inside') >= 0 : textConfig.inside;
            var innerTextDefaultStyle = this._innerTextDefaultStyle || (this._innerTextDefaultStyle = {});
            var textFill = void 0;
            var textStroke = void 0;
            var autoStroke = void 0;
            if (isInside && this.canBeInsideText()) {
                textFill = textConfig.insideFill;
                textStroke = textConfig.insideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getInsideTextFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getInsideTextStroke(textFill);
                    autoStroke = true;
                }
            } else {
                textFill = textConfig.outsideFill;
                textStroke = textConfig.outsideStroke;
                if (textFill == null || textFill === 'auto') textFill = this.getOutsideFill();
                if (textStroke == null || textStroke === 'auto') {
                    textStroke = this.getOutsideStroke(textFill);
                    autoStroke = true;
                }
            }
            textFill = textFill || '#000';
            if (textFill !== innerTextDefaultStyle.fill || textStroke !== innerTextDefaultStyle.stroke || autoStroke !== innerTextDefaultStyle.autoStroke || textAlign !== innerTextDefaultStyle.align || textVerticalAlign !== innerTextDefaultStyle.verticalAlign) {
                textStyleChanged = true;
                innerTextDefaultStyle.fill = textFill;
                innerTextDefaultStyle.stroke = textStroke;
                innerTextDefaultStyle.autoStroke = autoStroke;
                innerTextDefaultStyle.align = textAlign;
                innerTextDefaultStyle.verticalAlign = textVerticalAlign;
                textEl.setDefaultTextStyle(innerTextDefaultStyle);
            }
            textEl.__dirty |= (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
            if (textStyleChanged) textEl.dirtyStyle(true);
        }
    };
    Element.prototype.canBeInsideText = function() {
        return true;
    };
    Element.prototype.getInsideTextFill = function() {
        return '#fff';
    };
    Element.prototype.getInsideTextStroke = function(textFill) {
        return '#000';
    };
    Element.prototype.getOutsideFill = function() {
        return this.__zr && this.__zr.isDarkMode() ? (0, $495ebc0cfec45c57$export$3c6e95f318c8369b) : (0, $495ebc0cfec45c57$export$f8ce94761f39398d);
    };
    Element.prototype.getOutsideStroke = function(textFill) {
        var backgroundColor = this.__zr && this.__zr.getBackgroundColor();
        var colorArr = typeof backgroundColor === 'string' && (0, $35573db24643e2ef$export$98e6a39c04603d36)(backgroundColor);
        if (!colorArr) colorArr = [
            255,
            255,
            255,
            1
        ];
        var alpha = colorArr[3];
        var isDark = this.__zr.isDarkMode();
        for(var i = 0; i < 3; i++)colorArr[i] = colorArr[i] * alpha + (isDark ? 0 : 255) * (1 - alpha);
        colorArr[3] = 1;
        return (0, $35573db24643e2ef$export$fac44ee5b035f737)(colorArr, 'rgba');
    };
    Element.prototype.traverse = function(cb, context) {};
    Element.prototype.attrKV = function(key, value) {
        if (key === 'textConfig') this.setTextConfig(value);
        else if (key === 'textContent') this.setTextContent(value);
        else if (key === 'clipPath') this.setClipPath(value);
        else if (key === 'extra') {
            this.extra = this.extra || {};
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(this.extra, value);
        } else this[key] = value;
    };
    Element.prototype.hide = function() {
        this.ignore = true;
        this.markRedraw();
    };
    Element.prototype.show = function() {
        this.ignore = false;
        this.markRedraw();
    };
    Element.prototype.attr = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.attrKV(keyOrObj, value);
        else if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(keyOrObj)) {
            var obj = keyOrObj;
            var keysArr = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(obj);
            for(var i = 0; i < keysArr.length; i++){
                var key = keysArr[i];
                this.attrKV(key, keyOrObj[key]);
            }
        }
        this.markRedraw();
        return this;
    };
    Element.prototype.saveCurrentToNormalState = function(toState) {
        this._innerSaveToNormal(toState);
        var normalState = this._normalState;
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var fromStateTransition = animator.__fromStateTransition;
            if (animator.getLoop() || fromStateTransition && fromStateTransition !== $32f73300204a2d4b$export$97b5e845c7286801) continue;
            var targetName = animator.targetName;
            var target = targetName ? normalState[targetName] : normalState;
            animator.saveTo(target);
        }
    };
    Element.prototype._innerSaveToNormal = function(toState) {
        var normalState = this._normalState;
        if (!normalState) normalState = this._normalState = {};
        if (toState.textConfig && !normalState.textConfig) normalState.textConfig = this.textConfig;
        this._savePrimaryToNormal(toState, normalState, $32f73300204a2d4b$var$PRIMARY_STATES_KEYS);
    };
    Element.prototype._savePrimaryToNormal = function(toState, normalState, primaryKeys) {
        for(var i = 0; i < primaryKeys.length; i++){
            var key = primaryKeys[i];
            if (toState[key] != null && !(key in normalState)) normalState[key] = this[key];
        }
    };
    Element.prototype.hasState = function() {
        return this.currentStates.length > 0;
    };
    Element.prototype.getState = function(name) {
        return this.states[name];
    };
    Element.prototype.ensureState = function(name) {
        var states = this.states;
        if (!states[name]) states[name] = {};
        return states[name];
    };
    Element.prototype.clearStates = function(noAnimation) {
        this.useState($32f73300204a2d4b$export$97b5e845c7286801, false, noAnimation);
    };
    Element.prototype.useState = function(stateName, keepCurrentStates, noAnimation, forceUseHoverLayer) {
        var toNormalState = stateName === $32f73300204a2d4b$export$97b5e845c7286801;
        var hasStates = this.hasState();
        if (!hasStates && toNormalState) return;
        var currentStates = this.currentStates;
        var animationCfg = this.stateTransition;
        if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(currentStates, stateName) >= 0 && (keepCurrentStates || currentStates.length === 1)) return;
        var state;
        if (this.stateProxy && !toNormalState) state = this.stateProxy(stateName);
        if (!state) state = this.states && this.states[stateName];
        if (!state && !toNormalState) {
            (0, $1b239fc9d3a2f8ae$export$58da9968c3170cb1)("State " + stateName + " not exists.");
            return;
        }
        if (!toNormalState) this.saveCurrentToNormalState(state);
        var useHoverLayer = !!(state && state.hoverLayer || forceUseHoverLayer);
        if (useHoverLayer) this._toggleHoverLayerFlag(true);
        this._applyStateObj(stateName, state, this._normalState, keepCurrentStates, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (textGuide) textGuide.useState(stateName, keepCurrentStates, noAnimation, useHoverLayer);
        if (toNormalState) {
            this.currentStates = [];
            this._normalState = {};
        } else if (!keepCurrentStates) this.currentStates = [
            stateName
        ];
        else this.currentStates.push(stateName);
        this._updateAnimationTargets();
        this.markRedraw();
        if (!useHoverLayer && this.__inHover) {
            this._toggleHoverLayerFlag(false);
            this.__dirty &= ~(0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
        }
        return state;
    };
    Element.prototype.useStates = function(states, noAnimation, forceUseHoverLayer) {
        if (!states.length) this.clearStates();
        else {
            var stateObjects = [];
            var currentStates = this.currentStates;
            var len = states.length;
            var notChange = len === currentStates.length;
            if (notChange) {
                for(var i = 0; i < len; i++)if (states[i] !== currentStates[i]) {
                    notChange = false;
                    break;
                }
            }
            if (notChange) return;
            for(var i = 0; i < len; i++){
                var stateName = states[i];
                var stateObj = void 0;
                if (this.stateProxy) stateObj = this.stateProxy(stateName, states);
                if (!stateObj) stateObj = this.states[stateName];
                if (stateObj) stateObjects.push(stateObj);
            }
            var lastStateObj = stateObjects[len - 1];
            var useHoverLayer = !!(lastStateObj && lastStateObj.hoverLayer || forceUseHoverLayer);
            if (useHoverLayer) this._toggleHoverLayerFlag(true);
            var mergedState = this._mergeStates(stateObjects);
            var animationCfg = this.stateTransition;
            this.saveCurrentToNormalState(mergedState);
            this._applyStateObj(states.join(','), mergedState, this._normalState, false, !noAnimation && !this.__inHover && animationCfg && animationCfg.duration > 0, animationCfg);
            var textContent = this._textContent;
            var textGuide = this._textGuide;
            if (textContent) textContent.useStates(states, noAnimation, useHoverLayer);
            if (textGuide) textGuide.useStates(states, noAnimation, useHoverLayer);
            this._updateAnimationTargets();
            this.currentStates = states.slice();
            this.markRedraw();
            if (!useHoverLayer && this.__inHover) {
                this._toggleHoverLayerFlag(false);
                this.__dirty &= ~(0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
            }
        }
    };
    Element.prototype.isSilent = function() {
        var isSilent = this.silent;
        var ancestor = this.parent;
        while(!isSilent && ancestor){
            if (ancestor.silent) {
                isSilent = true;
                break;
            }
            ancestor = ancestor.parent;
        }
        return isSilent;
    };
    Element.prototype._updateAnimationTargets = function() {
        for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            if (animator.targetName) animator.changeTarget(this[animator.targetName]);
        }
    };
    Element.prototype.removeState = function(state) {
        var idx = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(this.currentStates, state);
        if (idx >= 0) {
            var currentStates = this.currentStates.slice();
            currentStates.splice(idx, 1);
            this.useStates(currentStates);
        }
    };
    Element.prototype.replaceState = function(oldState, newState, forceAdd) {
        var currentStates = this.currentStates.slice();
        var idx = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(currentStates, oldState);
        var newStateExists = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(currentStates, newState) >= 0;
        if (idx >= 0) {
            if (!newStateExists) currentStates[idx] = newState;
            else currentStates.splice(idx, 1);
        } else if (forceAdd && !newStateExists) currentStates.push(newState);
        this.useStates(currentStates);
    };
    Element.prototype.toggleState = function(state, enable) {
        if (enable) this.useState(state, true);
        else this.removeState(state);
    };
    Element.prototype._mergeStates = function(states) {
        var mergedState = {};
        var mergedTextConfig;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(mergedState, state);
            if (state.textConfig) {
                mergedTextConfig = mergedTextConfig || {};
                (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(mergedTextConfig, state.textConfig);
            }
        }
        if (mergedTextConfig) mergedState.textConfig = mergedTextConfig;
        return mergedState;
    };
    Element.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        var needsRestoreToNormal = !(state && keepCurrentStates);
        if (state && state.textConfig) {
            this.textConfig = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, keepCurrentStates ? this.textConfig : normalState.textConfig);
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(this.textConfig, state.textConfig);
        } else if (needsRestoreToNormal) {
            if (normalState.textConfig) this.textConfig = normalState.textConfig;
        }
        var transitionTarget = {};
        var hasTransition = false;
        for(var i = 0; i < $32f73300204a2d4b$var$PRIMARY_STATES_KEYS.length; i++){
            var key = $32f73300204a2d4b$var$PRIMARY_STATES_KEYS[i];
            var propNeedsTransition = transition && $32f73300204a2d4b$var$DEFAULT_ANIMATABLE_MAP[key];
            if (state && state[key] != null) {
                if (propNeedsTransition) {
                    hasTransition = true;
                    transitionTarget[key] = state[key];
                } else this[key] = state[key];
            } else if (needsRestoreToNormal) {
                if (normalState[key] != null) {
                    if (propNeedsTransition) {
                        hasTransition = true;
                        transitionTarget[key] = normalState[key];
                    } else this[key] = normalState[key];
                }
            }
        }
        if (!transition) for(var i = 0; i < this.animators.length; i++){
            var animator = this.animators[i];
            var targetName = animator.targetName;
            if (!animator.getLoop()) animator.__changeFinalValue(targetName ? (state || normalState)[targetName] : state || normalState);
        }
        if (hasTransition) this._transitionState(stateName, transitionTarget, animationCfg);
    };
    Element.prototype._attachComponent = function(componentEl) {
        if (componentEl.__zr && !componentEl.__hostTarget) return;
        if (componentEl === this) return;
        var zr = this.__zr;
        if (zr) componentEl.addSelfToZr(zr);
        componentEl.__zr = zr;
        componentEl.__hostTarget = this;
    };
    Element.prototype._detachComponent = function(componentEl) {
        if (componentEl.__zr) componentEl.removeSelfFromZr(componentEl.__zr);
        componentEl.__zr = null;
        componentEl.__hostTarget = null;
    };
    Element.prototype.getClipPath = function() {
        return this._clipPath;
    };
    Element.prototype.setClipPath = function(clipPath) {
        if (this._clipPath && this._clipPath !== clipPath) this.removeClipPath();
        this._attachComponent(clipPath);
        this._clipPath = clipPath;
        this.markRedraw();
    };
    Element.prototype.removeClipPath = function() {
        var clipPath = this._clipPath;
        if (clipPath) {
            this._detachComponent(clipPath);
            this._clipPath = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextContent = function() {
        return this._textContent;
    };
    Element.prototype.setTextContent = function(textEl) {
        var previousTextContent = this._textContent;
        if (previousTextContent === textEl) return;
        if (previousTextContent && previousTextContent !== textEl) this.removeTextContent();
        textEl.innerTransformable = new (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039)();
        this._attachComponent(textEl);
        this._textContent = textEl;
        this.markRedraw();
    };
    Element.prototype.setTextConfig = function(cfg) {
        if (!this.textConfig) this.textConfig = {};
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(this.textConfig, cfg);
        this.markRedraw();
    };
    Element.prototype.removeTextConfig = function() {
        this.textConfig = null;
        this.markRedraw();
    };
    Element.prototype.removeTextContent = function() {
        var textEl = this._textContent;
        if (textEl) {
            textEl.innerTransformable = null;
            this._detachComponent(textEl);
            this._textContent = null;
            this._innerTextDefaultStyle = null;
            this.markRedraw();
        }
    };
    Element.prototype.getTextGuideLine = function() {
        return this._textGuide;
    };
    Element.prototype.setTextGuideLine = function(guideLine) {
        if (this._textGuide && this._textGuide !== guideLine) this.removeTextGuideLine();
        this._attachComponent(guideLine);
        this._textGuide = guideLine;
        this.markRedraw();
    };
    Element.prototype.removeTextGuideLine = function() {
        var textGuide = this._textGuide;
        if (textGuide) {
            this._detachComponent(textGuide);
            this._textGuide = null;
            this.markRedraw();
        }
    };
    Element.prototype.markRedraw = function() {
        this.__dirty |= (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
        var zr = this.__zr;
        if (zr) {
            if (this.__inHover) zr.refreshHover();
            else zr.refresh();
        }
        if (this.__hostTarget) this.__hostTarget.markRedraw();
    };
    Element.prototype.dirty = function() {
        this.markRedraw();
    };
    Element.prototype._toggleHoverLayerFlag = function(inHover) {
        this.__inHover = inHover;
        var textContent = this._textContent;
        var textGuide = this._textGuide;
        if (textContent) textContent.__inHover = inHover;
        if (textGuide) textGuide.__inHover = inHover;
    };
    Element.prototype.addSelfToZr = function(zr) {
        if (this.__zr === zr) return;
        this.__zr = zr;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.addAnimator(animators[i]);
        if (this._clipPath) this._clipPath.addSelfToZr(zr);
        if (this._textContent) this._textContent.addSelfToZr(zr);
        if (this._textGuide) this._textGuide.addSelfToZr(zr);
    };
    Element.prototype.removeSelfFromZr = function(zr) {
        if (!this.__zr) return;
        this.__zr = null;
        var animators = this.animators;
        if (animators) for(var i = 0; i < animators.length; i++)zr.animation.removeAnimator(animators[i]);
        if (this._clipPath) this._clipPath.removeSelfFromZr(zr);
        if (this._textContent) this._textContent.removeSelfFromZr(zr);
        if (this._textGuide) this._textGuide.removeSelfFromZr(zr);
    };
    Element.prototype.animate = function(key, loop, allowDiscreteAnimation) {
        var target = key ? this[key] : this;
        var animator = new (0, $dc7faf503a6299d4$export$2e2bcd8739ae039)(target, loop, allowDiscreteAnimation);
        key && (animator.targetName = key);
        this.addAnimator(animator, key);
        return animator;
    };
    Element.prototype.addAnimator = function(animator, key) {
        var zr = this.__zr;
        var el = this;
        animator.during(function() {
            el.updateDuringAnimation(key);
        }).done(function() {
            var animators = el.animators;
            var idx = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(animators, animator);
            if (idx >= 0) animators.splice(idx, 1);
        });
        this.animators.push(animator);
        if (zr) zr.animation.addAnimator(animator);
        zr && zr.wakeUp();
    };
    Element.prototype.updateDuringAnimation = function(key) {
        this.markRedraw();
    };
    Element.prototype.stopAnimation = function(scope, forwardToLast) {
        var animators = this.animators;
        var len = animators.length;
        var leftAnimators = [];
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            if (!scope || scope === animator.scope) animator.stop(forwardToLast);
            else leftAnimators.push(animator);
        }
        this.animators = leftAnimators;
        return this;
    };
    Element.prototype.animateTo = function(target, cfg, animationProps) {
        $32f73300204a2d4b$var$animateTo(this, target, cfg, animationProps);
    };
    Element.prototype.animateFrom = function(target, cfg, animationProps) {
        $32f73300204a2d4b$var$animateTo(this, target, cfg, animationProps, true);
    };
    Element.prototype._transitionState = function(stateName, target, cfg, animationProps) {
        var animators = $32f73300204a2d4b$var$animateTo(this, target, cfg, animationProps);
        for(var i = 0; i < animators.length; i++)animators[i].__fromStateTransition = stateName;
    };
    Element.prototype.getBoundingRect = function() {
        return null;
    };
    Element.prototype.getPaintRect = function() {
        return null;
    };
    Element.initDefaultProps = function() {
        var elProto = Element.prototype;
        elProto.type = 'element';
        elProto.name = '';
        elProto.ignore = elProto.silent = elProto.isGroup = elProto.draggable = elProto.dragging = elProto.ignoreClip = elProto.__inHover = false;
        elProto.__dirty = (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
        var logs = {};
        function logDeprecatedError(key, xKey, yKey) {
            if (!logs[key + xKey + yKey]) {
                console.warn("DEPRECATED: '" + key + "' has been deprecated. use '" + xKey + "', '" + yKey + "' instead");
                logs[key + xKey + yKey] = true;
            }
        }
        function createLegacyProperty(key, privateKey, xKey, yKey) {
            Object.defineProperty(elProto, key, {
                get: function() {
                    if (!this[privateKey]) {
                        var pos = this[privateKey] = [];
                        enhanceArray(this, pos);
                    }
                    return this[privateKey];
                },
                set: function(pos) {
                    this[xKey] = pos[0];
                    this[yKey] = pos[1];
                    this[privateKey] = pos;
                    enhanceArray(this, pos);
                }
            });
            function enhanceArray(self, pos) {
                Object.defineProperty(pos, 0, {
                    get: function() {
                        return self[xKey];
                    },
                    set: function(val) {
                        self[xKey] = val;
                    }
                });
                Object.defineProperty(pos, 1, {
                    get: function() {
                        return self[yKey];
                    },
                    set: function(val) {
                        self[yKey] = val;
                    }
                });
            }
        }
        if (Object.defineProperty) {
            createLegacyProperty('position', '_legacyPos', 'x', 'y');
            createLegacyProperty('scale', '_legacyScale', 'scaleX', 'scaleY');
            createLegacyProperty('origin', '_legacyOrigin', 'originX', 'originY');
        }
    }();
    return Element;
}();
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($32f73300204a2d4b$var$Element, (0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($32f73300204a2d4b$var$Element, (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039));
function $32f73300204a2d4b$var$animateTo(animatable, target, cfg, animationProps, reverse) {
    cfg = cfg || {};
    var animators = [];
    $32f73300204a2d4b$var$animateToShallow(animatable, '', animatable, target, cfg, animationProps, animators, reverse);
    var finishCount = animators.length;
    var doneHappened = false;
    var cfgDone = cfg.done;
    var cfgAborted = cfg.aborted;
    var doneCb = function() {
        doneHappened = true;
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    var abortedCb = function() {
        finishCount--;
        if (finishCount <= 0) doneHappened ? cfgDone && cfgDone() : cfgAborted && cfgAborted();
    };
    if (!finishCount) cfgDone && cfgDone();
    if (animators.length > 0 && cfg.during) animators[0].during(function(target, percent) {
        cfg.during(percent);
    });
    for(var i = 0; i < animators.length; i++){
        var animator = animators[i];
        if (doneCb) animator.done(doneCb);
        if (abortedCb) animator.aborted(abortedCb);
        if (cfg.force) animator.duration(cfg.duration);
        animator.start(cfg.easing);
    }
    return animators;
}
function $32f73300204a2d4b$var$copyArrShallow(source, target, len) {
    for(var i = 0; i < len; i++)source[i] = target[i];
}
function $32f73300204a2d4b$var$is2DArray(value) {
    return (0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(value[0]);
}
function $32f73300204a2d4b$var$copyValue(target, source, key) {
    if ((0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(source[key])) {
        if (!(0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(target[key])) target[key] = [];
        if ((0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(source[key])) {
            var len = source[key].length;
            if (target[key].length !== len) {
                target[key] = new source[key].constructor(len);
                $32f73300204a2d4b$var$copyArrShallow(target[key], source[key], len);
            }
        } else {
            var sourceArr = source[key];
            var targetArr = target[key];
            var len0 = sourceArr.length;
            if ($32f73300204a2d4b$var$is2DArray(sourceArr)) {
                var len1 = sourceArr[0].length;
                for(var i = 0; i < len0; i++)if (!targetArr[i]) targetArr[i] = Array.prototype.slice.call(sourceArr[i]);
                else $32f73300204a2d4b$var$copyArrShallow(targetArr[i], sourceArr[i], len1);
            } else $32f73300204a2d4b$var$copyArrShallow(targetArr, sourceArr, len0);
            targetArr.length = sourceArr.length;
        }
    } else target[key] = source[key];
}
function $32f73300204a2d4b$var$isValueSame(val1, val2) {
    return val1 === val2 || (0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(val1) && (0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(val2) && $32f73300204a2d4b$var$is1DArraySame(val1, val2);
}
function $32f73300204a2d4b$var$is1DArraySame(arr0, arr1) {
    var len = arr0.length;
    if (len !== arr1.length) return false;
    for(var i = 0; i < len; i++){
        if (arr0[i] !== arr1[i]) return false;
    }
    return true;
}
function $32f73300204a2d4b$var$animateToShallow(animatable, topKey, animateObj, target, cfg, animationProps, animators, reverse) {
    var targetKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(target);
    var duration = cfg.duration;
    var delay = cfg.delay;
    var additive = cfg.additive;
    var setToFinal = cfg.setToFinal;
    var animateAll = !(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(animationProps);
    var existsAnimators = animatable.animators;
    var animationKeys = [];
    for(var k = 0; k < targetKeys.length; k++){
        var innerKey = targetKeys[k];
        var targetVal = target[innerKey];
        if (targetVal != null && animateObj[innerKey] != null && (animateAll || animationProps[innerKey])) {
            if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(targetVal) && !(0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(targetVal) && !(0, $1b239fc9d3a2f8ae$export$fa2c283003ed971c)(targetVal)) {
                if (topKey) {
                    if (!reverse) {
                        animateObj[innerKey] = targetVal;
                        animatable.updateDuringAnimation(topKey);
                    }
                    continue;
                }
                $32f73300204a2d4b$var$animateToShallow(animatable, innerKey, animateObj[innerKey], targetVal, cfg, animationProps && animationProps[innerKey], animators, reverse);
            } else animationKeys.push(innerKey);
        } else if (!reverse) {
            animateObj[innerKey] = targetVal;
            animatable.updateDuringAnimation(topKey);
            animationKeys.push(innerKey);
        }
    }
    var keyLen = animationKeys.length;
    if (!additive && keyLen) for(var i = 0; i < existsAnimators.length; i++){
        var animator = existsAnimators[i];
        if (animator.targetName === topKey) {
            var allAborted = animator.stopTracks(animationKeys);
            if (allAborted) {
                var idx = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(existsAnimators, animator);
                existsAnimators.splice(idx, 1);
            }
        }
    }
    if (!cfg.force) {
        animationKeys = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(animationKeys, function(key) {
            return !$32f73300204a2d4b$var$isValueSame(target[key], animateObj[key]);
        });
        keyLen = animationKeys.length;
    }
    if (keyLen > 0 || cfg.force && !animators.length) {
        var revertedSource = void 0;
        var reversedTarget = void 0;
        var sourceClone = void 0;
        if (reverse) {
            reversedTarget = {};
            if (setToFinal) revertedSource = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                reversedTarget[innerKey] = animateObj[innerKey];
                if (setToFinal) revertedSource[innerKey] = target[innerKey];
                else animateObj[innerKey] = target[innerKey];
            }
        } else if (setToFinal) {
            sourceClone = {};
            for(var i = 0; i < keyLen; i++){
                var innerKey = animationKeys[i];
                sourceClone[innerKey] = (0, $dc7faf503a6299d4$export$c5e92b7f105af84e)(animateObj[innerKey]);
                $32f73300204a2d4b$var$copyValue(animateObj, target, innerKey);
            }
        }
        var animator = new (0, $dc7faf503a6299d4$export$2e2bcd8739ae039)(animateObj, false, false, additive ? (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(existsAnimators, function(animator) {
            return animator.targetName === topKey;
        }) : null);
        animator.targetName = topKey;
        if (cfg.scope) animator.scope = cfg.scope;
        if (setToFinal && revertedSource) animator.whenWithKeys(0, revertedSource, animationKeys);
        if (sourceClone) animator.whenWithKeys(0, sourceClone, animationKeys);
        animator.whenWithKeys(duration == null ? 500 : duration, reverse ? reversedTarget : target, animationKeys).delay(delay || 0);
        animatable.addAnimator(animator, topKey);
        animators.push(animator);
    }
}
var $32f73300204a2d4b$export$2e2bcd8739ae039 = $32f73300204a2d4b$var$Element;



var $6c313c3ef6000a43$var$Group = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Group, _super);
    function Group(opts) {
        var _this = _super.call(this) || this;
        _this.isGroup = true;
        _this._children = [];
        _this.attr(opts);
        return _this;
    }
    Group.prototype.childrenRef = function() {
        return this._children;
    };
    Group.prototype.children = function() {
        return this._children.slice();
    };
    Group.prototype.childAt = function(idx) {
        return this._children[idx];
    };
    Group.prototype.childOfName = function(name) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            if (children[i].name === name) return children[i];
        }
    };
    Group.prototype.childCount = function() {
        return this._children.length;
    };
    Group.prototype.add = function(child) {
        if (child) {
            if (child !== this && child.parent !== this) {
                this._children.push(child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.addBefore = function(child, nextSibling) {
        if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
            var children = this._children;
            var idx = children.indexOf(nextSibling);
            if (idx >= 0) {
                children.splice(idx, 0, child);
                this._doAdd(child);
            }
        }
        return this;
    };
    Group.prototype.replace = function(oldChild, newChild) {
        var idx = $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(this._children, oldChild);
        if (idx >= 0) this.replaceAt(newChild, idx);
        return this;
    };
    Group.prototype.replaceAt = function(child, index) {
        var children = this._children;
        var old = children[index];
        if (child && child !== this && child.parent !== this && child !== old) {
            children[index] = child;
            old.parent = null;
            var zr = this.__zr;
            if (zr) old.removeSelfFromZr(zr);
            this._doAdd(child);
        }
        return this;
    };
    Group.prototype._doAdd = function(child) {
        if (child.parent) child.parent.remove(child);
        child.parent = this;
        var zr = this.__zr;
        if (zr && zr !== child.__zr) child.addSelfToZr(zr);
        zr && zr.refresh();
    };
    Group.prototype.remove = function(child) {
        var zr = this.__zr;
        var children = this._children;
        var idx = $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(children, child);
        if (idx < 0) return this;
        children.splice(idx, 1);
        child.parent = null;
        if (zr) child.removeSelfFromZr(zr);
        zr && zr.refresh();
        return this;
    };
    Group.prototype.removeAll = function() {
        var children = this._children;
        var zr = this.__zr;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (zr) child.removeSelfFromZr(zr);
            child.parent = null;
        }
        children.length = 0;
        return this;
    };
    Group.prototype.eachChild = function(cb, context) {
        var children = this._children;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            cb.call(context, child, i);
        }
        return this;
    };
    Group.prototype.traverse = function(cb, context) {
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            var stopped = cb.call(context, child);
            if (child.isGroup && !stopped) child.traverse(cb, context);
        }
        return this;
    };
    Group.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.addSelfToZr(zr);
        }
    };
    Group.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.removeSelfFromZr(zr);
        }
    };
    Group.prototype.getBoundingRect = function(includeChildren) {
        var tmpRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
        var children = includeChildren || this._children;
        var tmpMat = [];
        var rect = null;
        for(var i = 0; i < children.length; i++){
            var child = children[i];
            if (child.ignore || child.invisible) continue;
            var childRect = child.getBoundingRect();
            var transform = child.getLocalTransform(tmpMat);
            if (transform) {
                (0, $020465b49a1dd45f$export$2e2bcd8739ae039).applyTransform(tmpRect, childRect, transform);
                rect = rect || tmpRect.clone();
                rect.union(tmpRect);
            } else {
                rect = rect || childRect.clone();
                rect.union(childRect);
            }
        }
        return rect || tmpRect;
    };
    return Group;
}((0, $32f73300204a2d4b$export$2e2bcd8739ae039));
$6c313c3ef6000a43$var$Group.prototype.type = 'group';
var $6c313c3ef6000a43$export$2e2bcd8739ae039 = $6c313c3ef6000a43$var$Group;


var $a6ecc7edacba791e$var$painterCtors = {};
var $a6ecc7edacba791e$var$instances = {};
function $a6ecc7edacba791e$var$delInstance(id) {
    delete $a6ecc7edacba791e$var$instances[id];
}
function $a6ecc7edacba791e$var$isDarkMode(backgroundColor) {
    if (!backgroundColor) return false;
    if (typeof backgroundColor === 'string') return (0, $35573db24643e2ef$export$16c0ec21a6f9ef95)(backgroundColor, 1) < (0, $495ebc0cfec45c57$export$fd81e7ebc7dae256);
    else if (backgroundColor.colorStops) {
        var colorStops = backgroundColor.colorStops;
        var totalLum = 0;
        var len = colorStops.length;
        for(var i = 0; i < len; i++)totalLum += (0, $35573db24643e2ef$export$16c0ec21a6f9ef95)(colorStops[i].color, 1);
        totalLum /= len;
        return totalLum < (0, $495ebc0cfec45c57$export$fd81e7ebc7dae256);
    }
    return false;
}
var $a6ecc7edacba791e$var$ZRender = function() {
    function ZRender(id, dom, opts) {
        var _this = this;
        this._sleepAfterStill = 10;
        this._stillFrameAccum = 0;
        this._needsRefresh = true;
        this._needsRefreshHover = true;
        this._darkMode = false;
        opts = opts || {};
        this.dom = dom;
        this.id = id;
        var storage = new (0, $129eca35d5db819d$export$2e2bcd8739ae039)();
        var rendererType = opts.renderer || 'canvas';
        if (!$a6ecc7edacba791e$var$painterCtors[rendererType]) rendererType = $1b239fc9d3a2f8ae$export$ed97f33186d4b816($a6ecc7edacba791e$var$painterCtors)[0];
        opts.useDirtyRect = opts.useDirtyRect == null ? false : opts.useDirtyRect;
        var painter = new $a6ecc7edacba791e$var$painterCtors[rendererType](dom, storage, opts, id);
        var ssrMode = opts.ssr || painter.ssrOnly;
        this.storage = storage;
        this.painter = painter;
        var handlerProxy = !(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node && !(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).worker && !ssrMode ? new (0, $d89be63bc3db003e$export$2e2bcd8739ae039)(painter.getViewportRoot(), painter.root) : null;
        var useCoarsePointer = opts.useCoarsePointer;
        var usePointerSize = useCoarsePointer == null || useCoarsePointer === 'auto' ? (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).touchEventsSupported : !!useCoarsePointer;
        var defaultPointerSize = 44;
        var pointerSize;
        if (usePointerSize) pointerSize = $1b239fc9d3a2f8ae$export$995e01f2f5c9d030(opts.pointerSize, defaultPointerSize);
        this.handler = new (0, $75cb27ac1e5e15ce$export$2e2bcd8739ae039)(storage, painter, handlerProxy, painter.root, pointerSize);
        this.animation = new (0, $ea9a0fd9147f2ce4$export$2e2bcd8739ae039)({
            stage: {
                update: ssrMode ? null : function() {
                    return _this._flush(true);
                }
            }
        });
        if (!ssrMode) this.animation.start();
    }
    ZRender.prototype.add = function(el) {
        if (this._disposed || !el) return;
        this.storage.addRoot(el);
        el.addSelfToZr(this);
        this.refresh();
    };
    ZRender.prototype.remove = function(el) {
        if (this._disposed || !el) return;
        this.storage.delRoot(el);
        el.removeSelfFromZr(this);
        this.refresh();
    };
    ZRender.prototype.configLayer = function(zLevel, config) {
        if (this._disposed) return;
        if (this.painter.configLayer) this.painter.configLayer(zLevel, config);
        this.refresh();
    };
    ZRender.prototype.setBackgroundColor = function(backgroundColor) {
        if (this._disposed) return;
        if (this.painter.setBackgroundColor) this.painter.setBackgroundColor(backgroundColor);
        this.refresh();
        this._backgroundColor = backgroundColor;
        this._darkMode = $a6ecc7edacba791e$var$isDarkMode(backgroundColor);
    };
    ZRender.prototype.getBackgroundColor = function() {
        return this._backgroundColor;
    };
    ZRender.prototype.setDarkMode = function(darkMode) {
        this._darkMode = darkMode;
    };
    ZRender.prototype.isDarkMode = function() {
        return this._darkMode;
    };
    ZRender.prototype.refreshImmediately = function(fromInside) {
        if (this._disposed) return;
        if (!fromInside) this.animation.update(true);
        this._needsRefresh = false;
        this.painter.refresh();
        this._needsRefresh = false;
    };
    ZRender.prototype.refresh = function() {
        if (this._disposed) return;
        this._needsRefresh = true;
        this.animation.start();
    };
    ZRender.prototype.flush = function() {
        if (this._disposed) return;
        this._flush(false);
    };
    ZRender.prototype._flush = function(fromInside) {
        var triggerRendered;
        var start = (0, $ea9a0fd9147f2ce4$export$1428f42a7de81803)();
        if (this._needsRefresh) {
            triggerRendered = true;
            this.refreshImmediately(fromInside);
        }
        if (this._needsRefreshHover) {
            triggerRendered = true;
            this.refreshHoverImmediately();
        }
        var end = (0, $ea9a0fd9147f2ce4$export$1428f42a7de81803)();
        if (triggerRendered) {
            this._stillFrameAccum = 0;
            this.trigger('rendered', {
                elapsedTime: end - start
            });
        } else if (this._sleepAfterStill > 0) {
            this._stillFrameAccum++;
            if (this._stillFrameAccum > this._sleepAfterStill) this.animation.stop();
        }
    };
    ZRender.prototype.setSleepAfterStill = function(stillFramesCount) {
        this._sleepAfterStill = stillFramesCount;
    };
    ZRender.prototype.wakeUp = function() {
        if (this._disposed) return;
        this.animation.start();
        this._stillFrameAccum = 0;
    };
    ZRender.prototype.refreshHover = function() {
        this._needsRefreshHover = true;
    };
    ZRender.prototype.refreshHoverImmediately = function() {
        if (this._disposed) return;
        this._needsRefreshHover = false;
        if (this.painter.refreshHover && this.painter.getType() === 'canvas') this.painter.refreshHover();
    };
    ZRender.prototype.resize = function(opts) {
        if (this._disposed) return;
        opts = opts || {};
        this.painter.resize(opts.width, opts.height);
        this.handler.resize();
    };
    ZRender.prototype.clearAnimation = function() {
        if (this._disposed) return;
        this.animation.clear();
    };
    ZRender.prototype.getWidth = function() {
        if (this._disposed) return;
        return this.painter.getWidth();
    };
    ZRender.prototype.getHeight = function() {
        if (this._disposed) return;
        return this.painter.getHeight();
    };
    ZRender.prototype.setCursorStyle = function(cursorStyle) {
        if (this._disposed) return;
        this.handler.setCursorStyle(cursorStyle);
    };
    ZRender.prototype.findHover = function(x, y) {
        if (this._disposed) return;
        return this.handler.findHover(x, y);
    };
    ZRender.prototype.on = function(eventName, eventHandler, context) {
        if (!this._disposed) this.handler.on(eventName, eventHandler, context);
        return this;
    };
    ZRender.prototype.off = function(eventName, eventHandler) {
        if (this._disposed) return;
        this.handler.off(eventName, eventHandler);
    };
    ZRender.prototype.trigger = function(eventName, event) {
        if (this._disposed) return;
        this.handler.trigger(eventName, event);
    };
    ZRender.prototype.clear = function() {
        if (this._disposed) return;
        var roots = this.storage.getRoots();
        for(var i = 0; i < roots.length; i++)if (roots[i] instanceof (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)) roots[i].removeSelfFromZr(this);
        this.storage.delAllRoots();
        this.painter.clear();
    };
    ZRender.prototype.dispose = function() {
        if (this._disposed) return;
        this.animation.stop();
        this.clear();
        this.storage.dispose();
        this.painter.dispose();
        this.handler.dispose();
        this.animation = this.storage = this.painter = this.handler = null;
        this._disposed = true;
        $a6ecc7edacba791e$var$delInstance(this.id);
    };
    return ZRender;
}();
function $a6ecc7edacba791e$export$2cd8252107eb640b(dom, opts) {
    var zr = new $a6ecc7edacba791e$var$ZRender($1b239fc9d3a2f8ae$export$46e8f25c7328f77e(), dom, opts);
    $a6ecc7edacba791e$var$instances[zr.id] = zr;
    return zr;
}
function $a6ecc7edacba791e$export$fcfbbcec2cb820d5(zr) {
    zr.dispose();
}
function $a6ecc7edacba791e$export$825f692fb04800ef() {
    for(var key in $a6ecc7edacba791e$var$instances)if ($a6ecc7edacba791e$var$instances.hasOwnProperty(key)) $a6ecc7edacba791e$var$instances[key].dispose();
    $a6ecc7edacba791e$var$instances = {};
}
function $a6ecc7edacba791e$export$8bedcca5bbd73999(id) {
    return $a6ecc7edacba791e$var$instances[id];
}
function $a6ecc7edacba791e$export$a3e793ccb11823a5(name, Ctor) {
    $a6ecc7edacba791e$var$painterCtors[name] = Ctor;
}
var $a6ecc7edacba791e$var$ssrDataGetter;
function $a6ecc7edacba791e$export$dd7015a5412ca583(el) {
    if (typeof $a6ecc7edacba791e$var$ssrDataGetter === 'function') return $a6ecc7edacba791e$var$ssrDataGetter(el);
}
function $a6ecc7edacba791e$export$e7a09d7fe68a4f7(getter) {
    $a6ecc7edacba791e$var$ssrDataGetter = getter;
}
var $a6ecc7edacba791e$export$83d89fbfd8236492 = '5.6.1';






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The method "quantile" was copied from "d3.js".
* (See more details in the comment of the method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $9fd90cf3bf18fbcd$var$RADIAN_EPSILON = 1e-4;
// Although chrome already enlarge this number to 100 for `toFixed`, but
// we sill follow the spec for compatibility.
var $9fd90cf3bf18fbcd$var$ROUND_SUPPORTED_PRECISION_MAX = 20;
function $9fd90cf3bf18fbcd$var$_trim(str) {
    return str.replace(/^\s+|\s+$/g, '');
}
function $9fd90cf3bf18fbcd$export$d3f68fbaa670562(val, domain, range, clamp) {
    var d0 = domain[0];
    var d1 = domain[1];
    var r0 = range[0];
    var r1 = range[1];
    var subDomain = d1 - d0;
    var subRange = r1 - r0;
    if (subDomain === 0) return subRange === 0 ? r0 : (r0 + r1) / 2;
    // Avoid accuracy problem in edge, such as
    // 146.39 - 62.83 === 83.55999999999999.
    // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
    // It is a little verbose for efficiency considering this method
    // is a hotspot.
    if (clamp) {
        if (subDomain > 0) {
            if (val <= d0) return r0;
            else if (val >= d1) return r1;
        } else {
            if (val >= d0) return r0;
            else if (val <= d1) return r1;
        }
    } else {
        if (val === d0) return r0;
        if (val === d1) return r1;
    }
    return (val - d0) / subDomain * subRange + r0;
}
function $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(percent, all) {
    switch(percent){
        case 'center':
        case 'middle':
            percent = '50%';
            break;
        case 'left':
        case 'top':
            percent = '0%';
            break;
        case 'right':
        case 'bottom':
            percent = '100%';
            break;
    }
    if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(percent)) {
        if ($9fd90cf3bf18fbcd$var$_trim(percent).match(/%$/)) return parseFloat(percent) / 100 * all;
        return parseFloat(percent);
    }
    return percent == null ? NaN : +percent;
}
function $9fd90cf3bf18fbcd$export$2077e0241d6afd3c(x, precision, returnStr) {
    if (precision == null) precision = 10;
    // Avoid range error
    precision = Math.min(Math.max(0, precision), $9fd90cf3bf18fbcd$var$ROUND_SUPPORTED_PRECISION_MAX);
    // PENDING: 1.005.toFixed(2) is '1.00' rather than '1.01'
    x = (+x).toFixed(precision);
    return returnStr ? x : +x;
}
function $9fd90cf3bf18fbcd$export$debe6e778e0a6d32(arr) {
    arr.sort(function(a, b) {
        return a - b;
    });
    return arr;
}
function $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68(val) {
    val = +val;
    if (isNaN(val)) return 0;
    // It is much faster than methods converting number to string as follows
    //      let tmp = val.toString();
    //      return tmp.length - 1 - tmp.indexOf('.');
    // especially when precision is low
    // Notice:
    // (1) If the loop count is over about 20, it is slower than `getPrecisionSafe`.
    //     (see https://jsbench.me/2vkpcekkvw/1)
    // (2) If the val is less than for example 1e-15, the result may be incorrect.
    //     (see test/ut/spec/util/number.test.ts `getPrecision_equal_random`)
    if (val > 1e-14) {
        var e = 1;
        for(var i = 0; i < 15; i++, e *= 10){
            if (Math.round(val * e) / e === val) return i;
        }
    }
    return $9fd90cf3bf18fbcd$export$6d86ba4ca4984d31(val);
}
function $9fd90cf3bf18fbcd$export$6d86ba4ca4984d31(val) {
    // toLowerCase for: '3.4E-12'
    var str = val.toString().toLowerCase();
    // Consider scientific notation: '3.4e-12' '3.4e+12'
    var eIndex = str.indexOf('e');
    var exp = eIndex > 0 ? +str.slice(eIndex + 1) : 0;
    var significandPartLen = eIndex > 0 ? eIndex : str.length;
    var dotIndex = str.indexOf('.');
    var decimalPartLen = dotIndex < 0 ? 0 : significandPartLen - 1 - dotIndex;
    return Math.max(0, decimalPartLen - exp);
}
function $9fd90cf3bf18fbcd$export$666260d9a2dda8a7(dataExtent, pixelExtent) {
    var log = Math.log;
    var LN10 = Math.LN10;
    var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
    var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10);
    // toFixed() digits argument must be between 0 and 20.
    var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
    return !isFinite(precision) ? 20 : precision;
}
function $9fd90cf3bf18fbcd$export$70cc11b075afeb90(valueList, idx, precision) {
    if (!valueList[idx]) return 0;
    var seats = $9fd90cf3bf18fbcd$export$222dabb13d5320df(valueList, precision);
    return seats[idx] || 0;
}
function $9fd90cf3bf18fbcd$export$222dabb13d5320df(valueList, precision) {
    var sum = $1b239fc9d3a2f8ae$export$533b26079ad0b4b(valueList, function(acc, val) {
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
    if (sum === 0) return [];
    var digits = Math.pow(10, precision);
    var votesPerQuota = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(valueList, function(val) {
        return (isNaN(val) ? 0 : val) / sum * digits * 100;
    });
    var targetSeats = digits * 100;
    var seats = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(votesPerQuota, function(votes) {
        // Assign automatic seats.
        return Math.floor(votes);
    });
    var currentSum = $1b239fc9d3a2f8ae$export$533b26079ad0b4b(seats, function(acc, val) {
        return acc + val;
    }, 0);
    var remainder = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(votesPerQuota, function(votes, idx) {
        return votes - seats[idx];
    });
    // Has remainding votes.
    while(currentSum < targetSeats){
        // Find next largest remainder.
        var max = Number.NEGATIVE_INFINITY;
        var maxId = null;
        for(var i = 0, len = remainder.length; i < len; ++i)if (remainder[i] > max) {
            max = remainder[i];
            maxId = i;
        }
        // Add a vote to max remainder.
        ++seats[maxId];
        remainder[maxId] = 0;
        ++currentSum;
    }
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(seats, function(seat) {
        return seat / digits;
    });
}
function $9fd90cf3bf18fbcd$export$d3389a301c3a5706(val0, val1) {
    var maxPrecision = Math.max($9fd90cf3bf18fbcd$export$e0c74b50bbd10f68(val0), $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68(val1));
    // const multiplier = Math.pow(10, maxPrecision);
    // return (Math.round(val0 * multiplier) + Math.round(val1 * multiplier)) / multiplier;
    var sum = val0 + val1;
    // // PENDING: support more?
    return maxPrecision > $9fd90cf3bf18fbcd$var$ROUND_SUPPORTED_PRECISION_MAX ? sum : $9fd90cf3bf18fbcd$export$2077e0241d6afd3c(sum, maxPrecision);
}
var $9fd90cf3bf18fbcd$export$18510406f204a1b9 = 9007199254740991;
function $9fd90cf3bf18fbcd$export$2ca6dd70a288b1c3(radian) {
    var pi2 = Math.PI * 2;
    return (radian % pi2 + pi2) % pi2;
}
function $9fd90cf3bf18fbcd$export$d1df570aea2868f(val) {
    return val > -$9fd90cf3bf18fbcd$var$RADIAN_EPSILON && val < $9fd90cf3bf18fbcd$var$RADIAN_EPSILON;
}
// eslint-disable-next-line
var $9fd90cf3bf18fbcd$var$TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d{1,2})(?::(\d{1,2})(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
function $9fd90cf3bf18fbcd$export$6b862160d295c8e(value) {
    if (value instanceof Date) return value;
    else if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(value)) {
        // Different browsers parse date in different way, so we parse it manually.
        // Some other issues:
        // new Date('1970-01-01') is UTC,
        // new Date('1970/01/01') and new Date('1970-1-01') is local.
        // See issue #3623
        var match = $9fd90cf3bf18fbcd$var$TIME_REG.exec(value);
        if (!match) // return Invalid Date.
        return new Date(NaN);
        // Use local time when no timezone offset is specified.
        if (!match[8]) // match[n] can only be string or undefined.
        // But take care of '12' + 1 => '121'.
        return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0);
        else {
            var hour = +match[4] || 0;
            if (match[8].toUpperCase() !== 'Z') hour -= +match[8].slice(0, 3);
            return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, match[7] ? +match[7].substring(0, 3) : 0));
        }
    } else if (value == null) return new Date(NaN);
    return new Date(Math.round(value));
}
function $9fd90cf3bf18fbcd$export$82dd68b83a44b253(val) {
    return Math.pow(10, $9fd90cf3bf18fbcd$export$97256a17b20a0c24(val));
}
function $9fd90cf3bf18fbcd$export$97256a17b20a0c24(val) {
    if (val === 0) return 0;
    var exp = Math.floor(Math.log(val) / Math.LN10);
    /**
   * exp is expected to be the rounded-down result of the base-10 log of val.
   * But due to the precision loss with Math.log(val), we need to restore it
   * using 10^exp to make sure we can get val back from exp. #11249
   */ if (val / Math.pow(10, exp) >= 10) exp++;
    return exp;
}
function $9fd90cf3bf18fbcd$export$7a695fe44258210b(val, round) {
    var exponent = $9fd90cf3bf18fbcd$export$97256a17b20a0c24(val);
    var exp10 = Math.pow(10, exponent);
    var f = val / exp10; // 1 <= f < 10
    var nf;
    if (round) {
        if (f < 1.5) nf = 1;
        else if (f < 2.5) nf = 2;
        else if (f < 4) nf = 3;
        else if (f < 7) nf = 5;
        else nf = 10;
    } else {
        if (f < 1) nf = 1;
        else if (f < 2) nf = 2;
        else if (f < 3) nf = 3;
        else if (f < 5) nf = 5;
        else nf = 10;
    }
    val = nf * exp10;
    // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
    // 20 is the uppper bound of toFixed.
    return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
}
function $9fd90cf3bf18fbcd$export$651fb4afdb6caa4b(ascArr, p) {
    var H = (ascArr.length - 1) * p + 1;
    var h = Math.floor(H);
    var v = +ascArr[h - 1];
    var e = H - h;
    return e ? v + e * (ascArr[h] - v) : v;
}
function $9fd90cf3bf18fbcd$export$12f7386070bc380a(list) {
    list.sort(function(a, b) {
        return littleThan(a, b, 0) ? -1 : 1;
    });
    var curr = -Infinity;
    var currClose = 1;
    for(var i = 0; i < list.length;){
        var interval = list[i].interval;
        var close_1 = list[i].close;
        for(var lg = 0; lg < 2; lg++){
            if (interval[lg] <= curr) {
                interval[lg] = curr;
                close_1[lg] = !lg ? 1 - currClose : 1;
            }
            curr = interval[lg];
            currClose = close_1[lg];
        }
        if (interval[0] === interval[1] && close_1[0] * close_1[1] !== 1) list.splice(i, 1);
        else i++;
    }
    return list;
    function littleThan(a, b, lg) {
        return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
    }
}
function $9fd90cf3bf18fbcd$export$8b4007b942b45a96(val) {
    var valFloat = parseFloat(val);
    return valFloat == val // eslint-disable-line eqeqeq
     && (valFloat !== 0 || !$1b239fc9d3a2f8ae$export$844ec244b1367d54(val) || val.indexOf('x') <= 0 // For case ' 0x0 '.
    ) ? valFloat : NaN;
}
function $9fd90cf3bf18fbcd$export$e90fb89750dba83f(val) {
    return !isNaN($9fd90cf3bf18fbcd$export$8b4007b942b45a96(val));
}
function $9fd90cf3bf18fbcd$export$474d2ec9aa44a22() {
    return Math.round(Math.random() * 9);
}
function $9fd90cf3bf18fbcd$export$a368fd580c0d0fe4(a, b) {
    if (b === 0) return a;
    return $9fd90cf3bf18fbcd$export$a368fd580c0d0fe4(b, a % b);
}
function $9fd90cf3bf18fbcd$export$680a45b749323f49(a, b) {
    if (a == null) return b;
    if (b == null) return a;
    return a * b / $9fd90cf3bf18fbcd$export$a368fd580c0d0fe4(a, b);
}



function $9ac03c46e8b6e711$var$interpolateNumber(p0, p1, percent) {
    return (p1 - p0) * percent + p0;
}
/**
 * Make the name displayable. But we should
 * make sure it is not duplicated with user
 * specified name, so use '\0';
 */ var $9ac03c46e8b6e711$var$DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
var $9ac03c46e8b6e711$var$INTERNAL_COMPONENT_ID_PREFIX = '\0_ec_\0';
function $9ac03c46e8b6e711$export$4f07b212a02c8051(value) {
    return value instanceof Array ? value : value == null ? [] : [
        value
    ];
}
function $9ac03c46e8b6e711$export$abdcc6a26372f94b(opt, key, subOpts) {
    // Caution: performance sensitive.
    if (opt) {
        opt[key] = opt[key] || {};
        opt.emphasis = opt.emphasis || {};
        opt.emphasis[key] = opt.emphasis[key] || {};
        // Default emphasis option from normal
        for(var i = 0, len = subOpts.length; i < len; i++){
            var subOptName = subOpts[i];
            if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) opt.emphasis[key][subOptName] = opt[key][subOptName];
        }
    }
}
var $9ac03c46e8b6e711$export$df45610347a602ad = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'rich',
    'tag',
    'color',
    'textBorderColor',
    'textBorderWidth',
    'width',
    'height',
    'lineHeight',
    'align',
    'verticalAlign',
    'baseline',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY',
    'backgroundColor',
    'borderColor',
    'borderWidth',
    'borderRadius',
    'padding'
];
function $9ac03c46e8b6e711$export$2c944e12edb48d4b(dataItem) {
    return (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dataItem) && !(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
}
function $9ac03c46e8b6e711$export$3e1a543f33ef6883(dataItem) {
    return (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dataItem) && !(dataItem instanceof Array);
// // markLine data can be array
// && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
}
function $9ac03c46e8b6e711$export$574f818966e4da87(existings, newCmptOptions, mode) {
    var isNormalMergeMode = mode === 'normalMerge';
    var isReplaceMergeMode = mode === 'replaceMerge';
    var isReplaceAllMode = mode === 'replaceAll';
    existings = existings || [];
    newCmptOptions = (newCmptOptions || []).slice();
    var existingIdIdxMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    // Validate id and name on user input option.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(cmptOption)) {
            newCmptOptions[index] = null;
            return;
        }
    });
    var result = $9ac03c46e8b6e711$var$prepareResult(existings, existingIdIdxMap, mode);
    if (isNormalMergeMode || isReplaceMergeMode) $9ac03c46e8b6e711$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions);
    if (isNormalMergeMode) $9ac03c46e8b6e711$var$mappingByName(result, newCmptOptions);
    if (isNormalMergeMode || isReplaceMergeMode) $9ac03c46e8b6e711$var$mappingByIndex(result, newCmptOptions, isReplaceMergeMode);
    else if (isReplaceAllMode) $9ac03c46e8b6e711$var$mappingInReplaceAllMode(result, newCmptOptions);
    $9ac03c46e8b6e711$var$makeIdAndName(result);
    // The array `result` MUST NOT contain elided items, otherwise the
    // forEach will omit those items and result in incorrect result.
    return result;
}
function $9ac03c46e8b6e711$var$prepareResult(existings, existingIdIdxMap, mode) {
    var result = [];
    if (mode === 'replaceAll') return result;
    // Do not use native `map` to in case that the array `existings`
    // contains elided items, which will be omitted.
    for(var index = 0; index < existings.length; index++){
        var existing = existings[index];
        // Because of replaceMerge, `existing` may be null/undefined.
        if (existing && existing.id != null) existingIdIdxMap.set(existing.id, index);
        // For non-internal-componnets:
        //     Mode "normalMerge": all existings kept.
        //     Mode "replaceMerge": all existing removed unless mapped by id.
        // For internal-components:
        //     go with "replaceMerge" approach in both mode.
        result.push({
            existing: mode === 'replaceMerge' || $9ac03c46e8b6e711$export$feece3e7d52a102b(existing) ? null : existing,
            newOption: null,
            keyInfo: null,
            brandNew: null
        });
    }
    return result;
}
function $9ac03c46e8b6e711$var$mappingById(result, existings, existingIdIdxMap, newCmptOptions) {
    // Mapping by id if specified.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.id == null) return;
        var optionId = $9ac03c46e8b6e711$var$makeComparableKey(cmptOption.id);
        var existingIdx = existingIdIdxMap.get(optionId);
        if (existingIdx != null) {
            var resultItem = result[existingIdx];
            (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(!resultItem.newOption, 'Duplicated option on id "' + optionId + '".');
            resultItem.newOption = cmptOption;
            // In both mode, if id matched, new option will be merged to
            // the existings rather than creating new component model.
            resultItem.existing = existings[existingIdx];
            newCmptOptions[index] = null;
        }
    });
}
function $9ac03c46e8b6e711$var$mappingByName(result, newCmptOptions) {
    // Mapping by name if specified.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption, index) {
        if (!cmptOption || cmptOption.name == null) return;
        for(var i = 0; i < result.length; i++){
            var existing = result[i].existing;
            if (!result[i].newOption // Consider name: two map to one.
             && existing && (existing.id == null || cmptOption.id == null) && !$9ac03c46e8b6e711$export$feece3e7d52a102b(cmptOption) && !$9ac03c46e8b6e711$export$feece3e7d52a102b(existing) && $9ac03c46e8b6e711$var$keyExistAndEqual('name', existing, cmptOption)) {
                result[i].newOption = cmptOption;
                newCmptOptions[index] = null;
                return;
            }
        }
    });
}
function $9ac03c46e8b6e711$var$mappingByIndex(result, newCmptOptions, brandNew) {
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        if (!cmptOption) return;
        // Find the first place that not mapped by id and not internal component (consider the "hole").
        var resultItem;
        var nextIdx = 0;
        while(// Be `!resultItem` only when `nextIdx >= result.length`.
        (resultItem = result[nextIdx]) && (resultItem.newOption || $9ac03c46e8b6e711$export$feece3e7d52a102b(resultItem.existing) || // In mode "replaceMerge", here no not-mapped-non-internal-existing.
        resultItem.existing && cmptOption.id != null && !$9ac03c46e8b6e711$var$keyExistAndEqual('id', cmptOption, resultItem.existing)))nextIdx++;
        if (resultItem) {
            resultItem.newOption = cmptOption;
            resultItem.brandNew = brandNew;
        } else result.push({
            newOption: cmptOption,
            brandNew: brandNew,
            existing: null,
            keyInfo: null
        });
        nextIdx++;
    });
}
function $9ac03c46e8b6e711$var$mappingInReplaceAllMode(result, newCmptOptions) {
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newCmptOptions, function(cmptOption) {
        // The feature "reproduce" requires "hole" will also reproduced
        // in case that component index referring are broken.
        result.push({
            newOption: cmptOption,
            brandNew: true,
            existing: null,
            keyInfo: null
        });
    });
}
/**
 * Make id and name for mapping result (result of mappingToExists)
 * into `keyInfo` field.
 */ function $9ac03c46e8b6e711$var$makeIdAndName(mapResult) {
    // We use this id to hash component models and view instances
    // in echarts. id can be specified by user, or auto generated.
    // The id generation rule ensures new view instance are able
    // to mapped to old instance when setOption are called in
    // no-merge mode. So we generate model id by name and plus
    // type in view id.
    // name can be duplicated among components, which is convenient
    // to specify multi components (like series) by one name.
    // Ensure that each id is distinct.
    var idMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mapResult, function(item) {
        var existing = item.existing;
        existing && idMap.set(existing.id, item);
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mapResult, function(item) {
        var opt = item.newOption;
        // Force ensure id not duplicated.
        (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
        opt && opt.id != null && idMap.set(opt.id, item);
        !item.keyInfo && (item.keyInfo = {});
    });
    // Make name and id.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mapResult, function(item, index) {
        var existing = item.existing;
        var opt = item.newOption;
        var keyInfo = item.keyInfo;
        if (!(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(opt)) return;
        // Name can be overwritten. Consider case: axis.name = '20km'.
        // But id generated by name will not be changed, which affect
        // only in that case: setOption with 'not merge mode' and view
        // instance will be recreated, which can be accepted.
        keyInfo.name = opt.name != null ? $9ac03c46e8b6e711$var$makeComparableKey(opt.name) : existing ? existing.name : $9ac03c46e8b6e711$var$DUMMY_COMPONENT_NAME_PREFIX + index;
        if (existing) keyInfo.id = $9ac03c46e8b6e711$var$makeComparableKey(existing.id);
        else if (opt.id != null) keyInfo.id = $9ac03c46e8b6e711$var$makeComparableKey(opt.id);
        else {
            // Consider this situatoin:
            //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
            //  optionB [{..}, {name: 'a'}, {name: 'a'}]
            // Series with the same name between optionA and optionB
            // should be mapped.
            var idNum = 0;
            do keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
            while (idMap.get(keyInfo.id));
        }
        idMap.set(keyInfo.id, item);
    });
}
function $9ac03c46e8b6e711$var$keyExistAndEqual(attr, obj1, obj2) {
    var key1 = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(obj1[attr], null);
    var key2 = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(obj2[attr], null);
    // See `MappingExistingItem`. `id` and `name` trade string equals to number.
    return key1 != null && key2 != null && key1 === key2;
}
/**
 * @return return null if not exist.
 */ function $9ac03c46e8b6e711$var$makeComparableKey(val) {
    return $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(val, '');
}
function $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(idOrName, defaultValue) {
    if (idOrName == null) return defaultValue;
    return (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(idOrName) ? idOrName : (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(idOrName) || (0, $1b239fc9d3a2f8ae$export$29d0bb2a4e07b252)(idOrName) ? idOrName + '' : defaultValue;
}
function $9ac03c46e8b6e711$var$warnInvalidateIdOrName(idOrName) {}
function $9ac03c46e8b6e711$var$isValidIdOrName(idOrName) {
    return (0, $1b239fc9d3a2f8ae$export$29d0bb2a4e07b252)(idOrName) || (0, $9fd90cf3bf18fbcd$export$e90fb89750dba83f)(idOrName);
}
function $9ac03c46e8b6e711$export$beae19a2652b3368(componentModel) {
    var name = componentModel.name;
    // Is specified when `indexOf` get -1 or > 0.
    return !!(name && name.indexOf($9ac03c46e8b6e711$var$DUMMY_COMPONENT_NAME_PREFIX));
}
function $9ac03c46e8b6e711$export$feece3e7d52a102b(cmptOption) {
    return cmptOption && cmptOption.id != null && $9ac03c46e8b6e711$var$makeComparableKey(cmptOption.id).indexOf($9ac03c46e8b6e711$var$INTERNAL_COMPONENT_ID_PREFIX) === 0;
}
function $9ac03c46e8b6e711$export$1753133c42e665e8(idSuffix) {
    return $9ac03c46e8b6e711$var$INTERNAL_COMPONENT_ID_PREFIX + idSuffix;
}
function $9ac03c46e8b6e711$export$5ac61aca2ba0282d(mappingResult, mainType, componentModelCtor) {
    // Set mainType and complete subType.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mappingResult, function(item) {
        var newOption = item.newOption;
        if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(newOption)) {
            item.keyInfo.mainType = mainType;
            item.keyInfo.subType = $9ac03c46e8b6e711$var$determineSubType(mainType, newOption, item.existing, componentModelCtor);
        }
    });
}
function $9ac03c46e8b6e711$var$determineSubType(mainType, newCmptOption, existComponent, componentModelCtor) {
    var subType = newCmptOption.type ? newCmptOption.type : existComponent ? existComponent.subType : componentModelCtor.determineSubType(mainType, newCmptOption);
    // tooltip, markline, markpoint may always has no subType
    return subType;
}
function $9ac03c46e8b6e711$export$6d12cabb0c9bf8e3(batchA, batchB) {
    var mapA = {};
    var mapB = {};
    makeMap(batchA || [], mapA);
    makeMap(batchB || [], mapB, mapA);
    return [
        mapToArray(mapA),
        mapToArray(mapB)
    ];
    function makeMap(sourceBatch, map, otherMap) {
        for(var i = 0, len = sourceBatch.length; i < len; i++){
            var seriesId = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(sourceBatch[i].seriesId, null);
            if (seriesId == null) return;
            var dataIndices = $9ac03c46e8b6e711$export$4f07b212a02c8051(sourceBatch[i].dataIndex);
            var otherDataIndices = otherMap && otherMap[seriesId];
            for(var j = 0, lenj = dataIndices.length; j < lenj; j++){
                var dataIndex = dataIndices[j];
                if (otherDataIndices && otherDataIndices[dataIndex]) otherDataIndices[dataIndex] = null;
                else (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
            }
        }
    }
    function mapToArray(map, isData) {
        var result = [];
        for(var i in map)if (map.hasOwnProperty(i) && map[i] != null) {
            if (isData) result.push(+i);
            else {
                var dataIndices = mapToArray(map[i], true);
                dataIndices.length && result.push({
                    seriesId: i,
                    dataIndex: dataIndices
                });
            }
        }
        return result;
    }
}
function $9ac03c46e8b6e711$export$42b26cae8b8d10(data, payload) {
    if (payload.dataIndexInside != null) return payload.dataIndexInside;
    else if (payload.dataIndex != null) return (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(payload.dataIndex) ? (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(payload.dataIndex, function(value) {
        return data.indexOfRawIndex(value);
    }) : data.indexOfRawIndex(payload.dataIndex);
    else if (payload.name != null) return (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(payload.name) ? (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(payload.name, function(value) {
        return data.indexOfName(value);
    }) : data.indexOfName(payload.name);
}
function $9ac03c46e8b6e711$export$64df9f8d92ae083f() {
    var key = '__ec_inner_' + $9ac03c46e8b6e711$var$innerUniqueIndex++;
    return function(hostObj) {
        return hostObj[key] || (hostObj[key] = {});
    };
}
var $9ac03c46e8b6e711$var$innerUniqueIndex = (0, $9fd90cf3bf18fbcd$export$474d2ec9aa44a22)();
function $9ac03c46e8b6e711$export$95de80076abac814(ecModel, finderInput, opt) {
    var _a = $9ac03c46e8b6e711$export$fe600815775d9400(finderInput, opt), mainTypeSpecified = _a.mainTypeSpecified, queryOptionMap = _a.queryOptionMap, others = _a.others;
    var result = others;
    var defaultMainType = opt ? opt.defaultMainType : null;
    if (!mainTypeSpecified && defaultMainType) queryOptionMap.set(defaultMainType, {});
    queryOptionMap.each(function(queryOption, mainType) {
        var queryResult = $9ac03c46e8b6e711$export$dc741340f7e5f186(ecModel, mainType, queryOption, {
            useDefault: defaultMainType === mainType,
            enableAll: opt && opt.enableAll != null ? opt.enableAll : true,
            enableNone: opt && opt.enableNone != null ? opt.enableNone : true
        });
        result[mainType + 'Models'] = queryResult.models;
        result[mainType + 'Model'] = queryResult.models[0];
    });
    return result;
}
function $9ac03c46e8b6e711$export$fe600815775d9400(finderInput, opt) {
    var finder;
    if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(finderInput)) {
        var obj = {};
        obj[finderInput + 'Index'] = 0;
        finder = obj;
    } else finder = finderInput;
    var queryOptionMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    var others = {};
    var mainTypeSpecified = false;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(finder, function(value, key) {
        // Exclude 'dataIndex' and other illgal keys.
        if (key === 'dataIndex' || key === 'dataIndexInside') {
            others[key] = value;
            return;
        }
        var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
        var mainType = parsedKey[1];
        var queryType = (parsedKey[2] || '').toLowerCase();
        if (!mainType || !queryType || opt && opt.includeMainTypes && (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(opt.includeMainTypes, mainType) < 0) return;
        mainTypeSpecified = mainTypeSpecified || !!mainType;
        var queryOption = queryOptionMap.get(mainType) || queryOptionMap.set(mainType, {});
        queryOption[queryType] = value;
    });
    return {
        mainTypeSpecified: mainTypeSpecified,
        queryOptionMap: queryOptionMap,
        others: others
    };
}
var $9ac03c46e8b6e711$export$f076738ec84e693c = {
    useDefault: true,
    enableAll: false,
    enableNone: false
};
var $9ac03c46e8b6e711$export$48d598924ce4892c = {
    useDefault: false,
    enableAll: true,
    enableNone: true
};
function $9ac03c46e8b6e711$export$dc741340f7e5f186(ecModel, mainType, userOption, opt) {
    opt = opt || $9ac03c46e8b6e711$export$f076738ec84e693c;
    var indexOption = userOption.index;
    var idOption = userOption.id;
    var nameOption = userOption.name;
    var result = {
        models: null,
        specified: indexOption != null || idOption != null || nameOption != null
    };
    if (!result.specified) {
        // Use the first as default if `useDefault`.
        var firstCmpt = void 0;
        result.models = opt.useDefault && (firstCmpt = ecModel.getComponent(mainType)) ? [
            firstCmpt
        ] : [];
        return result;
    }
    if (indexOption === 'none' || indexOption === false) {
        (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(opt.enableNone, '`"none"` or `false` is not a valid value on index option.');
        result.models = [];
        return result;
    }
    // `queryComponents` will return all components if
    // both all of index/id/name are null/undefined.
    if (indexOption === 'all') {
        (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(opt.enableAll, '`"all"` is not a valid value on index option.');
        indexOption = idOption = nameOption = null;
    }
    result.models = ecModel.queryComponents({
        mainType: mainType,
        index: indexOption,
        id: idOption,
        name: nameOption
    });
    return result;
}
function $9ac03c46e8b6e711$export$9fec4d97f1922e0b(dom, key, value) {
    dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
}
function $9ac03c46e8b6e711$export$735ee1799fd02602(dom, key) {
    return dom.getAttribute ? dom.getAttribute(key) : dom[key];
}
function $9ac03c46e8b6e711$export$cc0a17a5d27b4e17(renderModeOption) {
    if (renderModeOption === 'auto') // Using html when `document` exists, use richText otherwise
    return (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).domSupported ? 'html' : 'richText';
    else return renderModeOption || 'html';
}
function $9ac03c46e8b6e711$export$7ab5bda43e13168f(array, getKey // return key
) {
    var buckets = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    var keys = [];
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(array, function(item) {
        var key = getKey(item);
        (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
    });
    return {
        keys: keys,
        buckets: buckets
    };
}
function $9ac03c46e8b6e711$export$bd0439821a1869f3(data, precision, sourceValue, targetValue, percent) {
    var isAutoPrecision = precision == null || precision === 'auto';
    if (targetValue == null) return targetValue;
    if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(targetValue)) {
        var value = $9ac03c46e8b6e711$var$interpolateNumber(sourceValue || 0, targetValue, percent);
        return (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68)(sourceValue || 0), (0, $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68)(targetValue)) : precision);
    } else if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(targetValue)) return percent < 1 ? sourceValue : targetValue;
    else {
        var interpolated = [];
        var leftArr = sourceValue;
        var rightArr = targetValue;
        var length_1 = Math.max(leftArr ? leftArr.length : 0, rightArr.length);
        for(var i = 0; i < length_1; ++i){
            var info = data.getDimensionInfo(i);
            // Don't interpolate ordinal dims
            if (info && info.type === 'ordinal') // In init, there is no `sourceValue`, but should better not to get undefined result.
            interpolated[i] = (percent < 1 && leftArr ? leftArr : rightArr)[i];
            else {
                var leftVal = leftArr && leftArr[i] ? leftArr[i] : 0;
                var rightVal = rightArr[i];
                var value = $9ac03c46e8b6e711$var$interpolateNumber(leftVal, rightVal, percent);
                interpolated[i] = (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(value, isAutoPrecision ? Math.max((0, $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68)(leftVal), (0, $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68)(rightVal)) : precision);
            }
        }
        return interpolated;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $19c24724c14e5e48$var$TYPE_DELIMITER = '.';
var $19c24724c14e5e48$var$IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
var $19c24724c14e5e48$var$IS_EXTENDED_CLASS = '___EC__EXTENDED_CLASS___';
function $19c24724c14e5e48$export$fbe18865d303bf01(componentType) {
    var ret = {
        main: '',
        sub: ''
    };
    if (componentType) {
        var typeArr = componentType.split($19c24724c14e5e48$var$TYPE_DELIMITER);
        ret.main = typeArr[0] || '';
        ret.sub = typeArr[1] || '';
    }
    return ret;
}
/**
 * @public
 */ function $19c24724c14e5e48$var$checkClassType(componentType) {
    $1b239fc9d3a2f8ae$export$a7a9523472993e97(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
}
function $19c24724c14e5e48$export$4f3b818f3dd2d182(clz) {
    return !!(clz && clz[$19c24724c14e5e48$var$IS_EXTENDED_CLASS]);
}
function $19c24724c14e5e48$export$cd4c3a4dca301c70(rootClz, mandatoryMethods) {
    rootClz.$constructor = rootClz; // FIXME: not necessary?
    rootClz.extend = function(proto) {
        var superClass = this;
        var ExtendedClass;
        if ($19c24724c14e5e48$var$isESClass(superClass)) ExtendedClass = /** @class */ function(_super) {
            (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(class_1, _super);
            function class_1() {
                return _super.apply(this, arguments) || this;
            }
            return class_1;
        }(superClass);
        else {
            // For backward compat, we both support ts class inheritance and this
            // "extend" approach.
            // The constructor should keep the same behavior as ts class inheritance:
            // If this constructor/$constructor is not declared, auto invoke the super
            // constructor.
            // If this constructor/$constructor is declared, it is responsible for
            // calling the super constructor.
            ExtendedClass = function() {
                (proto.$constructor || superClass).apply(this, arguments);
            };
            $1b239fc9d3a2f8ae$export$69f1b2dcda23c5f8(ExtendedClass, this);
        }
        $1b239fc9d3a2f8ae$export$8b58be045bf06082(ExtendedClass.prototype, proto);
        ExtendedClass[$19c24724c14e5e48$var$IS_EXTENDED_CLASS] = true;
        ExtendedClass.extend = this.extend;
        ExtendedClass.superCall = $19c24724c14e5e48$var$superCall;
        ExtendedClass.superApply = $19c24724c14e5e48$var$superApply;
        ExtendedClass.superClass = superClass;
        return ExtendedClass;
    };
}
function $19c24724c14e5e48$var$isESClass(fn) {
    return $1b239fc9d3a2f8ae$export$f6e2535fb5126e54(fn) && /^class\s/.test(Function.prototype.toString.call(fn));
}
function $19c24724c14e5e48$export$c9c2d87774f1275d(SubClz, SupperClz) {
    SubClz.extend = SupperClz.extend;
}
// A random offset.
var $19c24724c14e5e48$var$classBase = Math.round(Math.random() * 10);
function $19c24724c14e5e48$export$e1aac4552ae82081(target) {
    var classAttr = [
        '__\0is_clz',
        $19c24724c14e5e48$var$classBase++
    ].join('_');
    target.prototype[classAttr] = true;
    target.isInstance = function(obj) {
        return !!(obj && obj[classAttr]);
    };
}
// superCall should have class info, which can not be fetched from 'this'.
// Consider this case:
// class A has method f,
// class B inherits class A, overrides method f, f call superApply('f'),
// class C inherits class B, does not override method f,
// then when method of class C is called, dead loop occurred.
function $19c24724c14e5e48$var$superCall(context, methodName) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    return this.superClass.prototype[methodName].apply(context, args);
}
function $19c24724c14e5e48$var$superApply(context, methodName, args) {
    return this.superClass.prototype[methodName].apply(context, args);
}
function $19c24724c14e5e48$export$241315e45585454d(target) {
    /**
   * Component model classes
   * key: componentType,
   * value:
   *     componentClass, when componentType is 'a'
   *     or Object.<subKey, componentClass>, when componentType is 'a.b'
   */ var storage = {};
    target.registerClass = function(clz) {
        // `type` should not be a "instance member".
        // If using TS class, should better declared as `static type = 'series.pie'`.
        // otherwise users have to mount `type` on prototype manually.
        // For backward compat and enable instance visit type via `this.type`,
        // we still support fetch `type` from prototype.
        var componentFullType = clz.type || clz.prototype.type;
        if (componentFullType) {
            $19c24724c14e5e48$var$checkClassType(componentFullType);
            // If only static type declared, we assign it to prototype mandatorily.
            clz.prototype.type = componentFullType;
            var componentTypeInfo = $19c24724c14e5e48$export$fbe18865d303bf01(componentFullType);
            if (!componentTypeInfo.sub) storage[componentTypeInfo.main] = clz;
            else if (componentTypeInfo.sub !== $19c24724c14e5e48$var$IS_CONTAINER) {
                var container = makeContainer(componentTypeInfo);
                container[componentTypeInfo.sub] = clz;
            }
        }
        return clz;
    };
    target.getClass = function(mainType, subType, throwWhenNotFound) {
        var clz = storage[mainType];
        if (clz && clz[$19c24724c14e5e48$var$IS_CONTAINER]) clz = subType ? clz[subType] : null;
        if (throwWhenNotFound && !clz) throw new Error(!subType ? mainType + '.' + 'type should be specified.' : 'Component ' + mainType + '.' + (subType || '') + ' is used but not imported.');
        return clz;
    };
    target.getClassesByMainType = function(componentType) {
        var componentTypeInfo = $19c24724c14e5e48$export$fbe18865d303bf01(componentType);
        var result = [];
        var obj = storage[componentTypeInfo.main];
        if (obj && obj[$19c24724c14e5e48$var$IS_CONTAINER]) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(obj, function(o, type) {
            type !== $19c24724c14e5e48$var$IS_CONTAINER && result.push(o);
        });
        else result.push(obj);
        return result;
    };
    target.hasClass = function(componentType) {
        // Just consider componentType.main.
        var componentTypeInfo = $19c24724c14e5e48$export$fbe18865d303bf01(componentType);
        return !!storage[componentTypeInfo.main];
    };
    /**
   * @return Like ['aa', 'bb'], but can not be ['aa.xx']
   */ target.getAllClassMainTypes = function() {
        var types = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(storage, function(obj, type) {
            types.push(type);
        });
        return types;
    };
    /**
   * If a main type is container and has sub types
   */ target.hasSubTypes = function(componentType) {
        var componentTypeInfo = $19c24724c14e5e48$export$fbe18865d303bf01(componentType);
        var obj = storage[componentTypeInfo.main];
        return obj && obj[$19c24724c14e5e48$var$IS_CONTAINER];
    };
    function makeContainer(componentTypeInfo) {
        var container = storage[componentTypeInfo.main];
        if (!container || !container[$19c24724c14e5e48$var$IS_CONTAINER]) {
            container = storage[componentTypeInfo.main] = {};
            container[$19c24724c14e5e48$var$IS_CONTAINER] = true;
        }
        return container;
    }
} // /**
 //  * @param {string|Array.<string>} properties
 //  */
 // export function setReadOnly(obj, properties) {
 // FIXME It seems broken in IE8 simulation of IE11
 // if (!zrUtil.isArray(properties)) {
 //     properties = properties != null ? [properties] : [];
 // }
 // zrUtil.each(properties, function (prop) {
 //     let value = obj[prop];
 //     Object.defineProperty
 //         && Object.defineProperty(obj, prop, {
 //             value: value, writable: false
 //         });
 //     zrUtil.isArray(obj[prop])
 //         && Object.freeze
 //         && Object.freeze(obj[prop]);
 // });
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Parse shadow style
// TODO Only shallow path support

function $8555b33f89f2677c$export$2e2bcd8739ae039(properties, ignoreParent) {
    // Normalize
    for(var i = 0; i < properties.length; i++)if (!properties[i][1]) properties[i][1] = properties[i][0];
    ignoreParent = ignoreParent || false;
    return function(model, excludes, includes) {
        var style = {};
        for(var i = 0; i < properties.length; i++){
            var propName = properties[i][1];
            if (excludes && $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(excludes, propName) >= 0 || includes && $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(includes, propName) < 0) continue;
            var val = model.getShallow(propName, ignoreParent);
            if (val != null) style[properties[i][0]] = val;
        }
        // TODO Text or image?
        return style;
    };
}


var $4038026ff7009ccc$export$52de6e304d934d85 = [
    [
        'fill',
        'color'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'opacity'
    ],
    [
        'shadowColor'
    ]
];
var $4038026ff7009ccc$var$getAreaStyle = (0, $8555b33f89f2677c$export$2e2bcd8739ae039)($4038026ff7009ccc$export$52de6e304d934d85);
var $4038026ff7009ccc$export$a3a0ed7e2dd84c9e = /** @class */ function() {
    function AreaStyleMixin() {}
    AreaStyleMixin.prototype.getAreaStyle = function(excludes, includes) {
        return $4038026ff7009ccc$var$getAreaStyle(this, excludes, includes);
    };
    return AreaStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $d03a6f18dabd43b1$var$globalImageCache = new (0, $db88c5ee7dbc7394$export$2e2bcd8739ae039)(50);
function $d03a6f18dabd43b1$export$1b614f30ac2c8867(newImageOrSrc) {
    if (typeof newImageOrSrc === 'string') {
        var cachedImgObj = $d03a6f18dabd43b1$var$globalImageCache.get(newImageOrSrc);
        return cachedImgObj && cachedImgObj.image;
    } else return newImageOrSrc;
}
function $d03a6f18dabd43b1$export$46c791b69ff9a0f(newImageOrSrc, image, hostEl, onload, cbPayload) {
    if (!newImageOrSrc) return image;
    else if (typeof newImageOrSrc === 'string') {
        if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) return image;
        var cachedImgObj = $d03a6f18dabd43b1$var$globalImageCache.get(newImageOrSrc);
        var pendingWrap = {
            hostEl: hostEl,
            cb: onload,
            cbPayload: cbPayload
        };
        if (cachedImgObj) {
            image = cachedImgObj.image;
            !$d03a6f18dabd43b1$export$37ca7dd901d0236d(image) && cachedImgObj.pending.push(pendingWrap);
        } else {
            image = (0, $024b63ea846a8ccd$export$ef5e599365494451).loadImage(newImageOrSrc, $d03a6f18dabd43b1$var$imageOnLoad, $d03a6f18dabd43b1$var$imageOnLoad);
            image.__zrImageSrc = newImageOrSrc;
            $d03a6f18dabd43b1$var$globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
                image: image,
                pending: [
                    pendingWrap
                ]
            });
        }
        return image;
    } else return newImageOrSrc;
}
function $d03a6f18dabd43b1$var$imageOnLoad() {
    var cachedImgObj = this.__cachedImgObj;
    this.onload = this.onerror = this.__cachedImgObj = null;
    for(var i = 0; i < cachedImgObj.pending.length; i++){
        var pendingWrap = cachedImgObj.pending[i];
        var cb = pendingWrap.cb;
        cb && cb(this, pendingWrap.cbPayload);
        pendingWrap.hostEl.dirty();
    }
    cachedImgObj.pending.length = 0;
}
function $d03a6f18dabd43b1$export$37ca7dd901d0236d(image) {
    return image && image.width && image.height;
}




var $39dcac9902a4af34$var$STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
function $39dcac9902a4af34$export$59a943b34a82e690(text, containerWidth, font, ellipsis, options) {
    var out = {};
    $39dcac9902a4af34$var$truncateText2(out, text, containerWidth, font, ellipsis, options);
    return out.text;
}
function $39dcac9902a4af34$var$truncateText2(out, text, containerWidth, font, ellipsis, options) {
    if (!containerWidth) {
        out.text = '';
        out.isTruncated = false;
        return;
    }
    var textLines = (text + '').split('\n');
    options = $39dcac9902a4af34$var$prepareTruncateOptions(containerWidth, font, ellipsis, options);
    var isTruncated = false;
    var truncateOut = {};
    for(var i = 0, len = textLines.length; i < len; i++){
        $39dcac9902a4af34$var$truncateSingleLine(truncateOut, textLines[i], options);
        textLines[i] = truncateOut.textLine;
        isTruncated = isTruncated || truncateOut.isTruncated;
    }
    out.text = textLines.join('\n');
    out.isTruncated = isTruncated;
}
function $39dcac9902a4af34$var$prepareTruncateOptions(containerWidth, font, ellipsis, options) {
    options = options || {};
    var preparedOpts = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, options);
    preparedOpts.font = font;
    ellipsis = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(ellipsis, '...');
    preparedOpts.maxIterations = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(options.maxIterations, 2);
    var minChar = preparedOpts.minChar = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(options.minChar, 0);
    preparedOpts.cnCharWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)("\u56FD", font);
    var ascCharWidth = preparedOpts.ascCharWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)('a', font);
    preparedOpts.placeholder = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(options.placeholder, '');
    var contentWidth = containerWidth = Math.max(0, containerWidth - 1);
    for(var i = 0; i < minChar && contentWidth >= ascCharWidth; i++)contentWidth -= ascCharWidth;
    var ellipsisWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)(ellipsis, font);
    if (ellipsisWidth > contentWidth) {
        ellipsis = '';
        ellipsisWidth = 0;
    }
    contentWidth = containerWidth - ellipsisWidth;
    preparedOpts.ellipsis = ellipsis;
    preparedOpts.ellipsisWidth = ellipsisWidth;
    preparedOpts.contentWidth = contentWidth;
    preparedOpts.containerWidth = containerWidth;
    return preparedOpts;
}
function $39dcac9902a4af34$var$truncateSingleLine(out, textLine, options) {
    var containerWidth = options.containerWidth;
    var font = options.font;
    var contentWidth = options.contentWidth;
    if (!containerWidth) {
        out.textLine = '';
        out.isTruncated = false;
        return;
    }
    var lineWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)(textLine, font);
    if (lineWidth <= containerWidth) {
        out.textLine = textLine;
        out.isTruncated = false;
        return;
    }
    for(var j = 0;; j++){
        if (lineWidth <= contentWidth || j >= options.maxIterations) {
            textLine += options.ellipsis;
            break;
        }
        var subLength = j === 0 ? $39dcac9902a4af34$var$estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
        textLine = textLine.substr(0, subLength);
        lineWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)(textLine, font);
    }
    if (textLine === '') textLine = options.placeholder;
    out.textLine = textLine;
    out.isTruncated = true;
}
function $39dcac9902a4af34$var$estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
    var width = 0;
    var i = 0;
    for(var len = text.length; i < len && width < contentWidth; i++){
        var charCode = text.charCodeAt(i);
        width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
    }
    return i;
}
function $39dcac9902a4af34$export$5772575e34ef80f9(text, style) {
    text != null && (text += '');
    var overflow = style.overflow;
    var padding = style.padding;
    var font = style.font;
    var truncate = overflow === 'truncate';
    var calculatedLineHeight = (0, $297531217517fbce$export$56204a27a2958a55)(font);
    var lineHeight = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(style.lineHeight, calculatedLineHeight);
    var bgColorDrawn = !!style.backgroundColor;
    var truncateLineOverflow = style.lineOverflow === 'truncate';
    var isTruncated = false;
    var width = style.width;
    var lines;
    if (width != null && (overflow === 'break' || overflow === 'breakAll')) lines = text ? $39dcac9902a4af34$var$wrapText(text, style.font, width, overflow === 'breakAll', 0).lines : [];
    else lines = text ? text.split('\n') : [];
    var contentHeight = lines.length * lineHeight;
    var height = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(style.height, contentHeight);
    if (contentHeight > height && truncateLineOverflow) {
        var lineCount = Math.floor(height / lineHeight);
        isTruncated = isTruncated || lines.length > lineCount;
        lines = lines.slice(0, lineCount);
    }
    if (text && truncate && width != null) {
        var options = $39dcac9902a4af34$var$prepareTruncateOptions(width, font, style.ellipsis, {
            minChar: style.truncateMinChar,
            placeholder: style.placeholder
        });
        var singleOut = {};
        for(var i = 0; i < lines.length; i++){
            $39dcac9902a4af34$var$truncateSingleLine(singleOut, lines[i], options);
            lines[i] = singleOut.textLine;
            isTruncated = isTruncated || singleOut.isTruncated;
        }
    }
    var outerHeight = height;
    var contentWidth = 0;
    for(var i = 0; i < lines.length; i++)contentWidth = Math.max((0, $297531217517fbce$export$3c49c185de0c2bfc)(lines[i], font), contentWidth);
    if (width == null) width = contentWidth;
    var outerWidth = contentWidth;
    if (padding) {
        outerHeight += padding[0] + padding[2];
        outerWidth += padding[1] + padding[3];
        width += padding[1] + padding[3];
    }
    if (bgColorDrawn) outerWidth = width;
    return {
        lines: lines,
        height: height,
        outerWidth: outerWidth,
        outerHeight: outerHeight,
        lineHeight: lineHeight,
        calculatedLineHeight: calculatedLineHeight,
        contentWidth: contentWidth,
        contentHeight: contentHeight,
        width: width,
        isTruncated: isTruncated
    };
}
var $39dcac9902a4af34$var$RichTextToken = function() {
    function RichTextToken() {}
    return RichTextToken;
}();
var $39dcac9902a4af34$var$RichTextLine = function() {
    function RichTextLine(tokens) {
        this.tokens = [];
        if (tokens) this.tokens = tokens;
    }
    return RichTextLine;
}();
var $39dcac9902a4af34$export$ca607d3c98caaf7e = function() {
    function RichTextContentBlock() {
        this.width = 0;
        this.height = 0;
        this.contentWidth = 0;
        this.contentHeight = 0;
        this.outerWidth = 0;
        this.outerHeight = 0;
        this.lines = [];
        this.isTruncated = false;
    }
    return RichTextContentBlock;
}();
function $39dcac9902a4af34$export$15ec9472ff2d721(text, style) {
    var contentBlock = new $39dcac9902a4af34$export$ca607d3c98caaf7e();
    text != null && (text += '');
    if (!text) return contentBlock;
    var topWidth = style.width;
    var topHeight = style.height;
    var overflow = style.overflow;
    var wrapInfo = (overflow === 'break' || overflow === 'breakAll') && topWidth != null ? {
        width: topWidth,
        accumWidth: 0,
        breakAll: overflow === 'breakAll'
    } : null;
    var lastIndex = $39dcac9902a4af34$var$STYLE_REG.lastIndex = 0;
    var result;
    while((result = $39dcac9902a4af34$var$STYLE_REG.exec(text)) != null){
        var matchedIndex = result.index;
        if (matchedIndex > lastIndex) $39dcac9902a4af34$var$pushTokens(contentBlock, text.substring(lastIndex, matchedIndex), style, wrapInfo);
        $39dcac9902a4af34$var$pushTokens(contentBlock, result[2], style, wrapInfo, result[1]);
        lastIndex = $39dcac9902a4af34$var$STYLE_REG.lastIndex;
    }
    if (lastIndex < text.length) $39dcac9902a4af34$var$pushTokens(contentBlock, text.substring(lastIndex, text.length), style, wrapInfo);
    var pendingList = [];
    var calculatedHeight = 0;
    var calculatedWidth = 0;
    var stlPadding = style.padding;
    var truncate = overflow === 'truncate';
    var truncateLine = style.lineOverflow === 'truncate';
    var tmpTruncateOut = {};
    function finishLine(line, lineWidth, lineHeight) {
        line.width = lineWidth;
        line.lineHeight = lineHeight;
        calculatedHeight += lineHeight;
        calculatedWidth = Math.max(calculatedWidth, lineWidth);
    }
    outer: for(var i = 0; i < contentBlock.lines.length; i++){
        var line = contentBlock.lines[i];
        var lineHeight = 0;
        var lineWidth = 0;
        for(var j = 0; j < line.tokens.length; j++){
            var token = line.tokens[j];
            var tokenStyle = token.styleName && style.rich[token.styleName] || {};
            var textPadding = token.textPadding = tokenStyle.padding;
            var paddingH = textPadding ? textPadding[1] + textPadding[3] : 0;
            var font = token.font = tokenStyle.font || style.font;
            token.contentHeight = (0, $297531217517fbce$export$56204a27a2958a55)(font);
            var tokenHeight = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(tokenStyle.height, token.contentHeight);
            token.innerHeight = tokenHeight;
            textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
            token.height = tokenHeight;
            token.lineHeight = (0, $1b239fc9d3a2f8ae$export$2e94551289abb95b)(tokenStyle.lineHeight, style.lineHeight, tokenHeight);
            token.align = tokenStyle && tokenStyle.align || style.align;
            token.verticalAlign = tokenStyle && tokenStyle.verticalAlign || 'middle';
            if (truncateLine && topHeight != null && calculatedHeight + token.lineHeight > topHeight) {
                var originalLength = contentBlock.lines.length;
                if (j > 0) {
                    line.tokens = line.tokens.slice(0, j);
                    finishLine(line, lineWidth, lineHeight);
                    contentBlock.lines = contentBlock.lines.slice(0, i + 1);
                } else contentBlock.lines = contentBlock.lines.slice(0, i);
                contentBlock.isTruncated = contentBlock.isTruncated || contentBlock.lines.length < originalLength;
                break outer;
            }
            var styleTokenWidth = tokenStyle.width;
            var tokenWidthNotSpecified = styleTokenWidth == null || styleTokenWidth === 'auto';
            if (typeof styleTokenWidth === 'string' && styleTokenWidth.charAt(styleTokenWidth.length - 1) === '%') {
                token.percentWidth = styleTokenWidth;
                pendingList.push(token);
                token.contentWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)(token.text, font);
            } else {
                if (tokenWidthNotSpecified) {
                    var textBackgroundColor = tokenStyle.backgroundColor;
                    var bgImg = textBackgroundColor && textBackgroundColor.image;
                    if (bgImg) {
                        bgImg = $d03a6f18dabd43b1$export$1b614f30ac2c8867(bgImg);
                        if ($d03a6f18dabd43b1$export$37ca7dd901d0236d(bgImg)) token.width = Math.max(token.width, bgImg.width * tokenHeight / bgImg.height);
                    }
                }
                var remainTruncWidth = truncate && topWidth != null ? topWidth - lineWidth : null;
                if (remainTruncWidth != null && remainTruncWidth < token.width) {
                    if (!tokenWidthNotSpecified || remainTruncWidth < paddingH) {
                        token.text = '';
                        token.width = token.contentWidth = 0;
                    } else {
                        $39dcac9902a4af34$var$truncateText2(tmpTruncateOut, token.text, remainTruncWidth - paddingH, font, style.ellipsis, {
                            minChar: style.truncateMinChar
                        });
                        token.text = tmpTruncateOut.text;
                        contentBlock.isTruncated = contentBlock.isTruncated || tmpTruncateOut.isTruncated;
                        token.width = token.contentWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)(token.text, font);
                    }
                } else token.contentWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)(token.text, font);
            }
            token.width += paddingH;
            lineWidth += token.width;
            tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
        }
        finishLine(line, lineWidth, lineHeight);
    }
    contentBlock.outerWidth = contentBlock.width = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(topWidth, calculatedWidth);
    contentBlock.outerHeight = contentBlock.height = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(topHeight, calculatedHeight);
    contentBlock.contentHeight = calculatedHeight;
    contentBlock.contentWidth = calculatedWidth;
    if (stlPadding) {
        contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
        contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
    }
    for(var i = 0; i < pendingList.length; i++){
        var token = pendingList[i];
        var percentWidth = token.percentWidth;
        token.width = parseInt(percentWidth, 10) / 100 * contentBlock.width;
    }
    return contentBlock;
}
function $39dcac9902a4af34$var$pushTokens(block, str, style, wrapInfo, styleName) {
    var isEmptyStr = str === '';
    var tokenStyle = styleName && style.rich[styleName] || {};
    var lines = block.lines;
    var font = tokenStyle.font || style.font;
    var newLine = false;
    var strLines;
    var linesWidths;
    if (wrapInfo) {
        var tokenPadding = tokenStyle.padding;
        var tokenPaddingH = tokenPadding ? tokenPadding[1] + tokenPadding[3] : 0;
        if (tokenStyle.width != null && tokenStyle.width !== 'auto') {
            var outerWidth_1 = (0, $297531217517fbce$export$e8514cb5a5e2b40f)(tokenStyle.width, wrapInfo.width) + tokenPaddingH;
            if (lines.length > 0) {
                if (outerWidth_1 + wrapInfo.accumWidth > wrapInfo.width) {
                    strLines = str.split('\n');
                    newLine = true;
                }
            }
            wrapInfo.accumWidth = outerWidth_1;
        } else {
            var res = $39dcac9902a4af34$var$wrapText(str, font, wrapInfo.width, wrapInfo.breakAll, wrapInfo.accumWidth);
            wrapInfo.accumWidth = res.accumWidth + tokenPaddingH;
            linesWidths = res.linesWidths;
            strLines = res.lines;
        }
    } else strLines = str.split('\n');
    for(var i = 0; i < strLines.length; i++){
        var text = strLines[i];
        var token = new $39dcac9902a4af34$var$RichTextToken();
        token.styleName = styleName;
        token.text = text;
        token.isLineHolder = !text && !isEmptyStr;
        if (typeof tokenStyle.width === 'number') token.width = tokenStyle.width;
        else token.width = linesWidths ? linesWidths[i] : (0, $297531217517fbce$export$3c49c185de0c2bfc)(text, font);
        if (!i && !newLine) {
            var tokens = (lines[lines.length - 1] || (lines[0] = new $39dcac9902a4af34$var$RichTextLine())).tokens;
            var tokensLen = tokens.length;
            tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : (text || !tokensLen || isEmptyStr) && tokens.push(token);
        } else lines.push(new $39dcac9902a4af34$var$RichTextLine([
            token
        ]));
    }
}
function $39dcac9902a4af34$var$isAlphabeticLetter(ch) {
    var code = ch.charCodeAt(0);
    return code >= 0x20 && code <= 0x24F || code >= 0x370 && code <= 0x10FF || code >= 0x1200 && code <= 0x13FF || code >= 0x1E00 && code <= 0x206F;
}
var $39dcac9902a4af34$var$breakCharMap = (0, $1b239fc9d3a2f8ae$export$533b26079ad0b4b)(',&?/;] '.split(''), function(obj, ch) {
    obj[ch] = true;
    return obj;
}, {});
function $39dcac9902a4af34$var$isWordBreakChar(ch) {
    if ($39dcac9902a4af34$var$isAlphabeticLetter(ch)) {
        if ($39dcac9902a4af34$var$breakCharMap[ch]) return true;
        return false;
    }
    return true;
}
function $39dcac9902a4af34$var$wrapText(text, font, lineWidth, isBreakAll, lastAccumWidth) {
    var lines = [];
    var linesWidths = [];
    var line = '';
    var currentWord = '';
    var currentWordWidth = 0;
    var accumWidth = 0;
    for(var i = 0; i < text.length; i++){
        var ch = text.charAt(i);
        if (ch === '\n') {
            if (currentWord) {
                line += currentWord;
                accumWidth += currentWordWidth;
            }
            lines.push(line);
            linesWidths.push(accumWidth);
            line = '';
            currentWord = '';
            currentWordWidth = 0;
            accumWidth = 0;
            continue;
        }
        var chWidth = (0, $297531217517fbce$export$3c49c185de0c2bfc)(ch, font);
        var inWord = isBreakAll ? false : !$39dcac9902a4af34$var$isWordBreakChar(ch);
        if (!lines.length ? lastAccumWidth + accumWidth + chWidth > lineWidth : accumWidth + chWidth > lineWidth) {
            if (!accumWidth) {
                if (inWord) {
                    lines.push(currentWord);
                    linesWidths.push(currentWordWidth);
                    currentWord = ch;
                    currentWordWidth = chWidth;
                } else {
                    lines.push(ch);
                    linesWidths.push(chWidth);
                }
            } else if (line || currentWord) {
                if (inWord) {
                    if (!line) {
                        line = currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                        accumWidth = currentWordWidth;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth - currentWordWidth);
                    currentWord += ch;
                    currentWordWidth += chWidth;
                    line = '';
                    accumWidth = currentWordWidth;
                } else {
                    if (currentWord) {
                        line += currentWord;
                        currentWord = '';
                        currentWordWidth = 0;
                    }
                    lines.push(line);
                    linesWidths.push(accumWidth);
                    line = ch;
                    accumWidth = chWidth;
                }
            }
            continue;
        }
        accumWidth += chWidth;
        if (inWord) {
            currentWord += ch;
            currentWordWidth += chWidth;
        } else {
            if (currentWord) {
                line += currentWord;
                currentWord = '';
                currentWordWidth = 0;
            }
            line += ch;
        }
    }
    if (!lines.length && !line) {
        line = text;
        currentWord = '';
        currentWordWidth = 0;
    }
    if (currentWord) line += currentWord;
    if (line) {
        lines.push(line);
        linesWidths.push(accumWidth);
    }
    if (lines.length === 1) accumWidth += lastAccumWidth;
    return {
        accumWidth: accumWidth,
        lines: lines,
        linesWidths: linesWidths
    };
}








var $cfd8540aca1ca40f$var$STYLE_MAGIC_KEY = '__zr_style_' + Math.round(Math.random() * 10);
var $cfd8540aca1ca40f$export$737672163db00fe3 = {
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    opacity: 1,
    blend: 'source-over'
};
var $cfd8540aca1ca40f$export$9908943fb57fbe51 = {
    style: {
        shadowBlur: true,
        shadowOffsetX: true,
        shadowOffsetY: true,
        shadowColor: true,
        opacity: true
    }
};
$cfd8540aca1ca40f$export$737672163db00fe3[$cfd8540aca1ca40f$var$STYLE_MAGIC_KEY] = true;
var $cfd8540aca1ca40f$var$PRIMARY_STATES_KEYS = [
    'z',
    'z2',
    'invisible'
];
var $cfd8540aca1ca40f$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER = [
    'invisible'
];
var $cfd8540aca1ca40f$var$Displayable = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Displayable, _super);
    function Displayable(props) {
        return _super.call(this, props) || this;
    }
    Displayable.prototype._init = function(props) {
        var keysArr = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(props);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            if (key === 'style') this.useStyle(props[key]);
            else _super.prototype.attrKV.call(this, key, props[key]);
        }
        if (!this.style) this.useStyle({});
    };
    Displayable.prototype.beforeBrush = function() {};
    Displayable.prototype.afterBrush = function() {};
    Displayable.prototype.innerBeforeBrush = function() {};
    Displayable.prototype.innerAfterBrush = function() {};
    Displayable.prototype.shouldBePainted = function(viewWidth, viewHeight, considerClipPath, considerAncestors) {
        var m = this.transform;
        if (this.ignore || this.invisible || this.style.opacity === 0 || this.culling && $cfd8540aca1ca40f$var$isDisplayableCulled(this, viewWidth, viewHeight) || m && !m[0] && !m[3]) return false;
        if (considerClipPath && this.__clipPaths) for(var i = 0; i < this.__clipPaths.length; ++i){
            if (this.__clipPaths[i].isZeroArea()) return false;
        }
        if (considerAncestors && this.parent) {
            var parent_1 = this.parent;
            while(parent_1){
                if (parent_1.ignore) return false;
                parent_1 = parent_1.parent;
            }
        }
        return true;
    };
    Displayable.prototype.contain = function(x, y) {
        return this.rectContain(x, y);
    };
    Displayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    Displayable.prototype.rectContain = function(x, y) {
        var coord = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        return rect.contain(coord[0], coord[1]);
    };
    Displayable.prototype.getPaintRect = function() {
        var rect = this._paintRect;
        if (!this._paintRect || this.__dirty) {
            var transform = this.transform;
            var elRect = this.getBoundingRect();
            var style = this.style;
            var shadowSize = style.shadowBlur || 0;
            var shadowOffsetX = style.shadowOffsetX || 0;
            var shadowOffsetY = style.shadowOffsetY || 0;
            rect = this._paintRect || (this._paintRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0));
            if (transform) (0, $020465b49a1dd45f$export$2e2bcd8739ae039).applyTransform(rect, elRect, transform);
            else rect.copy(elRect);
            if (shadowSize || shadowOffsetX || shadowOffsetY) {
                rect.width += shadowSize * 2 + Math.abs(shadowOffsetX);
                rect.height += shadowSize * 2 + Math.abs(shadowOffsetY);
                rect.x = Math.min(rect.x, rect.x + shadowOffsetX - shadowSize);
                rect.y = Math.min(rect.y, rect.y + shadowOffsetY - shadowSize);
            }
            var tolerance = this.dirtyRectTolerance;
            if (!rect.isZero()) {
                rect.x = Math.floor(rect.x - tolerance);
                rect.y = Math.floor(rect.y - tolerance);
                rect.width = Math.ceil(rect.width + 1 + tolerance * 2);
                rect.height = Math.ceil(rect.height + 1 + tolerance * 2);
            }
        }
        return rect;
    };
    Displayable.prototype.setPrevPaintRect = function(paintRect) {
        if (paintRect) {
            this._prevPaintRect = this._prevPaintRect || new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
            this._prevPaintRect.copy(paintRect);
        } else this._prevPaintRect = null;
    };
    Displayable.prototype.getPrevPaintRect = function() {
        return this._prevPaintRect;
    };
    Displayable.prototype.animateStyle = function(loop) {
        return this.animate('style', loop);
    };
    Displayable.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else this.markRedraw();
    };
    Displayable.prototype.attrKV = function(key, value) {
        if (key !== 'style') _super.prototype.attrKV.call(this, key, value);
        else if (!this.style) this.useStyle(value);
        else this.setStyle(value);
    };
    Displayable.prototype.setStyle = function(keyOrObj, value) {
        if (typeof keyOrObj === 'string') this.style[keyOrObj] = value;
        else (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(this.style, keyOrObj);
        this.dirtyStyle();
        return this;
    };
    Displayable.prototype.dirtyStyle = function(notRedraw) {
        if (!notRedraw) this.markRedraw();
        this.__dirty |= (0, $7bc42091a9de0611$export$ada8b2beb3d76671);
        if (this._rect) this._rect = null;
    };
    Displayable.prototype.dirty = function() {
        this.dirtyStyle();
    };
    Displayable.prototype.styleChanged = function() {
        return !!(this.__dirty & (0, $7bc42091a9de0611$export$ada8b2beb3d76671));
    };
    Displayable.prototype.styleUpdated = function() {
        this.__dirty &= ~(0, $7bc42091a9de0611$export$ada8b2beb3d76671);
    };
    Displayable.prototype.createStyle = function(obj) {
        return (0, $1b239fc9d3a2f8ae$export$79c7e160a7743efd)($cfd8540aca1ca40f$export$737672163db00fe3, obj);
    };
    Displayable.prototype.useStyle = function(obj) {
        if (!obj[$cfd8540aca1ca40f$var$STYLE_MAGIC_KEY]) obj = this.createStyle(obj);
        if (this.__inHover) this.__hoverStyle = obj;
        else this.style = obj;
        this.dirtyStyle();
    };
    Displayable.prototype.isStyleObject = function(obj) {
        return obj[$cfd8540aca1ca40f$var$STYLE_MAGIC_KEY];
    };
    Displayable.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.style && !normalState.style) normalState.style = this._mergeStyle(this.createStyle(), this.style);
        this._savePrimaryToNormal(toState, normalState, $cfd8540aca1ca40f$var$PRIMARY_STATES_KEYS);
    };
    Displayable.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetStyle;
        if (state && state.style) {
            if (transition) {
                if (keepCurrentStates) targetStyle = state.style;
                else {
                    targetStyle = this._mergeStyle(this.createStyle(), normalState.style);
                    this._mergeStyle(targetStyle, state.style);
                }
            } else {
                targetStyle = this._mergeStyle(this.createStyle(), keepCurrentStates ? this.style : normalState.style);
                this._mergeStyle(targetStyle, state.style);
            }
        } else if (needsRestoreToNormal) targetStyle = normalState.style;
        if (targetStyle) {
            if (transition) {
                var sourceStyle = this.style;
                this.style = this.createStyle(needsRestoreToNormal ? {} : sourceStyle);
                if (needsRestoreToNormal) {
                    var changedKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(sourceStyle);
                    for(var i = 0; i < changedKeys.length; i++){
                        var key = changedKeys[i];
                        if (key in targetStyle) {
                            targetStyle[key] = targetStyle[key];
                            this.style[key] = sourceStyle[key];
                        }
                    }
                }
                var targetKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(targetStyle);
                for(var i = 0; i < targetKeys.length; i++){
                    var key = targetKeys[i];
                    this.style[key] = this.style[key];
                }
                this._transitionState(stateName, {
                    style: targetStyle
                }, animationCfg, this.getAnimationStyleProps());
            } else this.useStyle(targetStyle);
        }
        var statesKeys = this.__inHover ? $cfd8540aca1ca40f$var$PRIMARY_STATES_KEYS_IN_HOVER_LAYER : $cfd8540aca1ca40f$var$PRIMARY_STATES_KEYS;
        for(var i = 0; i < statesKeys.length; i++){
            var key = statesKeys[i];
            if (state && state[key] != null) this[key] = state[key];
            else if (needsRestoreToNormal) {
                if (normalState[key] != null) this[key] = normalState[key];
            }
        }
    };
    Displayable.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedStyle;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.style) {
                mergedStyle = mergedStyle || {};
                this._mergeStyle(mergedStyle, state.style);
            }
        }
        if (mergedStyle) mergedState.style = mergedStyle;
        return mergedState;
    };
    Displayable.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(targetStyle, sourceStyle);
        return targetStyle;
    };
    Displayable.prototype.getAnimationStyleProps = function() {
        return $cfd8540aca1ca40f$export$9908943fb57fbe51;
    };
    Displayable.initDefaultProps = function() {
        var dispProto = Displayable.prototype;
        dispProto.type = 'displayable';
        dispProto.invisible = false;
        dispProto.z = 0;
        dispProto.z2 = 0;
        dispProto.zlevel = 0;
        dispProto.culling = false;
        dispProto.cursor = 'pointer';
        dispProto.rectHover = false;
        dispProto.incremental = false;
        dispProto._rect = null;
        dispProto.dirtyRectTolerance = 0;
        dispProto.__dirty = (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd) | (0, $7bc42091a9de0611$export$ada8b2beb3d76671);
    }();
    return Displayable;
}((0, $32f73300204a2d4b$export$2e2bcd8739ae039));
var $cfd8540aca1ca40f$var$tmpRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
var $cfd8540aca1ca40f$var$viewRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
function $cfd8540aca1ca40f$var$isDisplayableCulled(el, width, height) {
    $cfd8540aca1ca40f$var$tmpRect.copy(el.getBoundingRect());
    if (el.transform) $cfd8540aca1ca40f$var$tmpRect.applyTransform(el.transform);
    $cfd8540aca1ca40f$var$viewRect.width = width;
    $cfd8540aca1ca40f$var$viewRect.height = height;
    return !$cfd8540aca1ca40f$var$tmpRect.intersect($cfd8540aca1ca40f$var$viewRect);
}
var $cfd8540aca1ca40f$export$2e2bcd8739ae039 = $cfd8540aca1ca40f$var$Displayable;










var $9757a65ec1dd85b5$var$mathMin = Math.min;
var $9757a65ec1dd85b5$var$mathMax = Math.max;
var $9757a65ec1dd85b5$var$mathSin = Math.sin;
var $9757a65ec1dd85b5$var$mathCos = Math.cos;
var $9757a65ec1dd85b5$var$PI2 = Math.PI * 2;
var $9757a65ec1dd85b5$var$start = $3dde7d051fe20daa$export$185802fd694ee1f5();
var $9757a65ec1dd85b5$var$end = $3dde7d051fe20daa$export$185802fd694ee1f5();
var $9757a65ec1dd85b5$var$extremity = $3dde7d051fe20daa$export$185802fd694ee1f5();
function $9757a65ec1dd85b5$export$188c3cd07b4129dd(points, min, max) {
    if (points.length === 0) return;
    var p = points[0];
    var left = p[0];
    var right = p[0];
    var top = p[1];
    var bottom = p[1];
    for(var i = 1; i < points.length; i++){
        p = points[i];
        left = $9757a65ec1dd85b5$var$mathMin(left, p[0]);
        right = $9757a65ec1dd85b5$var$mathMax(right, p[0]);
        top = $9757a65ec1dd85b5$var$mathMin(top, p[1]);
        bottom = $9757a65ec1dd85b5$var$mathMax(bottom, p[1]);
    }
    min[0] = left;
    min[1] = top;
    max[0] = right;
    max[1] = bottom;
}
function $9757a65ec1dd85b5$export$d2b1491e4450bf2c(x0, y0, x1, y1, min, max) {
    min[0] = $9757a65ec1dd85b5$var$mathMin(x0, x1);
    min[1] = $9757a65ec1dd85b5$var$mathMin(y0, y1);
    max[0] = $9757a65ec1dd85b5$var$mathMax(x0, x1);
    max[1] = $9757a65ec1dd85b5$var$mathMax(y0, y1);
}
var $9757a65ec1dd85b5$var$xDim = [];
var $9757a65ec1dd85b5$var$yDim = [];
function $9757a65ec1dd85b5$export$c1bc6be456bb6609(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
    var cubicExtrema = $eea9463646207a7b$export$df1a172f100d0457;
    var cubicAt = $eea9463646207a7b$export$547c21de482bbcb2;
    var n = cubicExtrema(x0, x1, x2, x3, $9757a65ec1dd85b5$var$xDim);
    min[0] = Infinity;
    min[1] = Infinity;
    max[0] = -Infinity;
    max[1] = -Infinity;
    for(var i = 0; i < n; i++){
        var x = cubicAt(x0, x1, x2, x3, $9757a65ec1dd85b5$var$xDim[i]);
        min[0] = $9757a65ec1dd85b5$var$mathMin(x, min[0]);
        max[0] = $9757a65ec1dd85b5$var$mathMax(x, max[0]);
    }
    n = cubicExtrema(y0, y1, y2, y3, $9757a65ec1dd85b5$var$yDim);
    for(var i = 0; i < n; i++){
        var y = cubicAt(y0, y1, y2, y3, $9757a65ec1dd85b5$var$yDim[i]);
        min[1] = $9757a65ec1dd85b5$var$mathMin(y, min[1]);
        max[1] = $9757a65ec1dd85b5$var$mathMax(y, max[1]);
    }
    min[0] = $9757a65ec1dd85b5$var$mathMin(x0, min[0]);
    max[0] = $9757a65ec1dd85b5$var$mathMax(x0, max[0]);
    min[0] = $9757a65ec1dd85b5$var$mathMin(x3, min[0]);
    max[0] = $9757a65ec1dd85b5$var$mathMax(x3, max[0]);
    min[1] = $9757a65ec1dd85b5$var$mathMin(y0, min[1]);
    max[1] = $9757a65ec1dd85b5$var$mathMax(y0, max[1]);
    min[1] = $9757a65ec1dd85b5$var$mathMin(y3, min[1]);
    max[1] = $9757a65ec1dd85b5$var$mathMax(y3, max[1]);
}
function $9757a65ec1dd85b5$export$16fbe795323a1f4c(x0, y0, x1, y1, x2, y2, min, max) {
    var quadraticExtremum = $eea9463646207a7b$export$752e1f8c6e7f7e11;
    var quadraticAt = $eea9463646207a7b$export$af17094a950f5073;
    var tx = $9757a65ec1dd85b5$var$mathMax($9757a65ec1dd85b5$var$mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
    var ty = $9757a65ec1dd85b5$var$mathMax($9757a65ec1dd85b5$var$mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
    var x = quadraticAt(x0, x1, x2, tx);
    var y = quadraticAt(y0, y1, y2, ty);
    min[0] = $9757a65ec1dd85b5$var$mathMin(x0, x2, x);
    min[1] = $9757a65ec1dd85b5$var$mathMin(y0, y2, y);
    max[0] = $9757a65ec1dd85b5$var$mathMax(x0, x2, x);
    max[1] = $9757a65ec1dd85b5$var$mathMax(y0, y2, y);
}
function $9757a65ec1dd85b5$export$161c8bb0e1d9ef49(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
    var vec2Min = $3dde7d051fe20daa$export$96ec731ed4dcb222;
    var vec2Max = $3dde7d051fe20daa$export$8960430cfd85939f;
    var diff = Math.abs(startAngle - endAngle);
    if (diff % $9757a65ec1dd85b5$var$PI2 < 1e-4 && diff > 1e-4) {
        min[0] = x - rx;
        min[1] = y - ry;
        max[0] = x + rx;
        max[1] = y + ry;
        return;
    }
    $9757a65ec1dd85b5$var$start[0] = $9757a65ec1dd85b5$var$mathCos(startAngle) * rx + x;
    $9757a65ec1dd85b5$var$start[1] = $9757a65ec1dd85b5$var$mathSin(startAngle) * ry + y;
    $9757a65ec1dd85b5$var$end[0] = $9757a65ec1dd85b5$var$mathCos(endAngle) * rx + x;
    $9757a65ec1dd85b5$var$end[1] = $9757a65ec1dd85b5$var$mathSin(endAngle) * ry + y;
    vec2Min(min, $9757a65ec1dd85b5$var$start, $9757a65ec1dd85b5$var$end);
    vec2Max(max, $9757a65ec1dd85b5$var$start, $9757a65ec1dd85b5$var$end);
    startAngle = startAngle % $9757a65ec1dd85b5$var$PI2;
    if (startAngle < 0) startAngle = startAngle + $9757a65ec1dd85b5$var$PI2;
    endAngle = endAngle % $9757a65ec1dd85b5$var$PI2;
    if (endAngle < 0) endAngle = endAngle + $9757a65ec1dd85b5$var$PI2;
    if (startAngle > endAngle && !anticlockwise) endAngle += $9757a65ec1dd85b5$var$PI2;
    else if (startAngle < endAngle && anticlockwise) startAngle += $9757a65ec1dd85b5$var$PI2;
    if (anticlockwise) {
        var tmp = endAngle;
        endAngle = startAngle;
        startAngle = tmp;
    }
    for(var angle = 0; angle < endAngle; angle += Math.PI / 2)if (angle > startAngle) {
        $9757a65ec1dd85b5$var$extremity[0] = $9757a65ec1dd85b5$var$mathCos(angle) * rx + x;
        $9757a65ec1dd85b5$var$extremity[1] = $9757a65ec1dd85b5$var$mathSin(angle) * ry + y;
        vec2Min(min, $9757a65ec1dd85b5$var$extremity, min);
        vec2Max(max, $9757a65ec1dd85b5$var$extremity, max);
    }
}



var $3fd2aad7811d6df2$var$CMD = {
    M: 1,
    L: 2,
    C: 3,
    Q: 4,
    A: 5,
    Z: 6,
    R: 7
};
var $3fd2aad7811d6df2$var$tmpOutX = [];
var $3fd2aad7811d6df2$var$tmpOutY = [];
var $3fd2aad7811d6df2$var$min = [];
var $3fd2aad7811d6df2$var$max = [];
var $3fd2aad7811d6df2$var$min2 = [];
var $3fd2aad7811d6df2$var$max2 = [];
var $3fd2aad7811d6df2$var$mathMin = Math.min;
var $3fd2aad7811d6df2$var$mathMax = Math.max;
var $3fd2aad7811d6df2$var$mathCos = Math.cos;
var $3fd2aad7811d6df2$var$mathSin = Math.sin;
var $3fd2aad7811d6df2$var$mathAbs = Math.abs;
var $3fd2aad7811d6df2$var$PI = Math.PI;
var $3fd2aad7811d6df2$var$PI2 = $3fd2aad7811d6df2$var$PI * 2;
var $3fd2aad7811d6df2$var$hasTypedArray = typeof Float32Array !== 'undefined';
var $3fd2aad7811d6df2$var$tmpAngles = [];
function $3fd2aad7811d6df2$var$modPI2(radian) {
    var n = Math.round(radian / $3fd2aad7811d6df2$var$PI * 1e8) / 1e8;
    return n % 2 * $3fd2aad7811d6df2$var$PI;
}
function $3fd2aad7811d6df2$export$bc668021e937022a(angles, anticlockwise) {
    var newStartAngle = $3fd2aad7811d6df2$var$modPI2(angles[0]);
    if (newStartAngle < 0) newStartAngle += $3fd2aad7811d6df2$var$PI2;
    var delta = newStartAngle - angles[0];
    var newEndAngle = angles[1];
    newEndAngle += delta;
    if (!anticlockwise && newEndAngle - newStartAngle >= $3fd2aad7811d6df2$var$PI2) newEndAngle = newStartAngle + $3fd2aad7811d6df2$var$PI2;
    else if (anticlockwise && newStartAngle - newEndAngle >= $3fd2aad7811d6df2$var$PI2) newEndAngle = newStartAngle - $3fd2aad7811d6df2$var$PI2;
    else if (!anticlockwise && newStartAngle > newEndAngle) newEndAngle = newStartAngle + ($3fd2aad7811d6df2$var$PI2 - $3fd2aad7811d6df2$var$modPI2(newStartAngle - newEndAngle));
    else if (anticlockwise && newStartAngle < newEndAngle) newEndAngle = newStartAngle - ($3fd2aad7811d6df2$var$PI2 - $3fd2aad7811d6df2$var$modPI2(newEndAngle - newStartAngle));
    angles[0] = newStartAngle;
    angles[1] = newEndAngle;
}
var $3fd2aad7811d6df2$var$PathProxy = function() {
    function PathProxy(notSaveData) {
        this.dpr = 1;
        this._xi = 0;
        this._yi = 0;
        this._x0 = 0;
        this._y0 = 0;
        this._len = 0;
        if (notSaveData) this._saveData = false;
        if (this._saveData) this.data = [];
    }
    PathProxy.prototype.increaseVersion = function() {
        this._version++;
    };
    PathProxy.prototype.getVersion = function() {
        return this._version;
    };
    PathProxy.prototype.setScale = function(sx, sy, segmentIgnoreThreshold) {
        segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
        if (segmentIgnoreThreshold > 0) {
            this._ux = $3fd2aad7811d6df2$var$mathAbs(segmentIgnoreThreshold / (0, $495ebc0cfec45c57$export$508f096bfcdaac40) / sx) || 0;
            this._uy = $3fd2aad7811d6df2$var$mathAbs(segmentIgnoreThreshold / (0, $495ebc0cfec45c57$export$508f096bfcdaac40) / sy) || 0;
        }
    };
    PathProxy.prototype.setDPR = function(dpr) {
        this.dpr = dpr;
    };
    PathProxy.prototype.setContext = function(ctx) {
        this._ctx = ctx;
    };
    PathProxy.prototype.getContext = function() {
        return this._ctx;
    };
    PathProxy.prototype.beginPath = function() {
        this._ctx && this._ctx.beginPath();
        this.reset();
        return this;
    };
    PathProxy.prototype.reset = function() {
        if (this._saveData) this._len = 0;
        if (this._pathSegLen) {
            this._pathSegLen = null;
            this._pathLen = 0;
        }
        this._version++;
    };
    PathProxy.prototype.moveTo = function(x, y) {
        this._drawPendingPt();
        this.addData($3fd2aad7811d6df2$var$CMD.M, x, y);
        this._ctx && this._ctx.moveTo(x, y);
        this._x0 = x;
        this._y0 = y;
        this._xi = x;
        this._yi = y;
        return this;
    };
    PathProxy.prototype.lineTo = function(x, y) {
        var dx = $3fd2aad7811d6df2$var$mathAbs(x - this._xi);
        var dy = $3fd2aad7811d6df2$var$mathAbs(y - this._yi);
        var exceedUnit = dx > this._ux || dy > this._uy;
        this.addData($3fd2aad7811d6df2$var$CMD.L, x, y);
        if (this._ctx && exceedUnit) this._ctx.lineTo(x, y);
        if (exceedUnit) {
            this._xi = x;
            this._yi = y;
            this._pendingPtDist = 0;
        } else {
            var d2 = dx * dx + dy * dy;
            if (d2 > this._pendingPtDist) {
                this._pendingPtX = x;
                this._pendingPtY = y;
                this._pendingPtDist = d2;
            }
        }
        return this;
    };
    PathProxy.prototype.bezierCurveTo = function(x1, y1, x2, y2, x3, y3) {
        this._drawPendingPt();
        this.addData($3fd2aad7811d6df2$var$CMD.C, x1, y1, x2, y2, x3, y3);
        if (this._ctx) this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
        this._xi = x3;
        this._yi = y3;
        return this;
    };
    PathProxy.prototype.quadraticCurveTo = function(x1, y1, x2, y2) {
        this._drawPendingPt();
        this.addData($3fd2aad7811d6df2$var$CMD.Q, x1, y1, x2, y2);
        if (this._ctx) this._ctx.quadraticCurveTo(x1, y1, x2, y2);
        this._xi = x2;
        this._yi = y2;
        return this;
    };
    PathProxy.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this._drawPendingPt();
        $3fd2aad7811d6df2$var$tmpAngles[0] = startAngle;
        $3fd2aad7811d6df2$var$tmpAngles[1] = endAngle;
        $3fd2aad7811d6df2$export$bc668021e937022a($3fd2aad7811d6df2$var$tmpAngles, anticlockwise);
        startAngle = $3fd2aad7811d6df2$var$tmpAngles[0];
        endAngle = $3fd2aad7811d6df2$var$tmpAngles[1];
        var delta = endAngle - startAngle;
        this.addData($3fd2aad7811d6df2$var$CMD.A, cx, cy, r, r, startAngle, delta, 0, anticlockwise ? 0 : 1);
        this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
        this._xi = $3fd2aad7811d6df2$var$mathCos(endAngle) * r + cx;
        this._yi = $3fd2aad7811d6df2$var$mathSin(endAngle) * r + cy;
        return this;
    };
    PathProxy.prototype.arcTo = function(x1, y1, x2, y2, radius) {
        this._drawPendingPt();
        if (this._ctx) this._ctx.arcTo(x1, y1, x2, y2, radius);
        return this;
    };
    PathProxy.prototype.rect = function(x, y, w, h) {
        this._drawPendingPt();
        this._ctx && this._ctx.rect(x, y, w, h);
        this.addData($3fd2aad7811d6df2$var$CMD.R, x, y, w, h);
        return this;
    };
    PathProxy.prototype.closePath = function() {
        this._drawPendingPt();
        this.addData($3fd2aad7811d6df2$var$CMD.Z);
        var ctx = this._ctx;
        var x0 = this._x0;
        var y0 = this._y0;
        if (ctx) ctx.closePath();
        this._xi = x0;
        this._yi = y0;
        return this;
    };
    PathProxy.prototype.fill = function(ctx) {
        ctx && ctx.fill();
        this.toStatic();
    };
    PathProxy.prototype.stroke = function(ctx) {
        ctx && ctx.stroke();
        this.toStatic();
    };
    PathProxy.prototype.len = function() {
        return this._len;
    };
    PathProxy.prototype.setData = function(data) {
        var len = data.length;
        if (!(this.data && this.data.length === len) && $3fd2aad7811d6df2$var$hasTypedArray) this.data = new Float32Array(len);
        for(var i = 0; i < len; i++)this.data[i] = data[i];
        this._len = len;
    };
    PathProxy.prototype.appendPath = function(path) {
        if (!(path instanceof Array)) path = [
            path
        ];
        var len = path.length;
        var appendSize = 0;
        var offset = this._len;
        for(var i = 0; i < len; i++)appendSize += path[i].len();
        if ($3fd2aad7811d6df2$var$hasTypedArray && this.data instanceof Float32Array) this.data = new Float32Array(offset + appendSize);
        for(var i = 0; i < len; i++){
            var appendPathData = path[i].data;
            for(var k = 0; k < appendPathData.length; k++)this.data[offset++] = appendPathData[k];
        }
        this._len = offset;
    };
    PathProxy.prototype.addData = function(cmd, a, b, c, d, e, f, g, h) {
        if (!this._saveData) return;
        var data = this.data;
        if (this._len + arguments.length > data.length) {
            this._expandData();
            data = this.data;
        }
        for(var i = 0; i < arguments.length; i++)data[this._len++] = arguments[i];
    };
    PathProxy.prototype._drawPendingPt = function() {
        if (this._pendingPtDist > 0) {
            this._ctx && this._ctx.lineTo(this._pendingPtX, this._pendingPtY);
            this._pendingPtDist = 0;
        }
    };
    PathProxy.prototype._expandData = function() {
        if (!(this.data instanceof Array)) {
            var newData = [];
            for(var i = 0; i < this._len; i++)newData[i] = this.data[i];
            this.data = newData;
        }
    };
    PathProxy.prototype.toStatic = function() {
        if (!this._saveData) return;
        this._drawPendingPt();
        var data = this.data;
        if (data instanceof Array) {
            data.length = this._len;
            if ($3fd2aad7811d6df2$var$hasTypedArray && this._len > 11) this.data = new Float32Array(data);
        }
    };
    PathProxy.prototype.getBoundingRect = function() {
        $3fd2aad7811d6df2$var$min[0] = $3fd2aad7811d6df2$var$min[1] = $3fd2aad7811d6df2$var$min2[0] = $3fd2aad7811d6df2$var$min2[1] = Number.MAX_VALUE;
        $3fd2aad7811d6df2$var$max[0] = $3fd2aad7811d6df2$var$max[1] = $3fd2aad7811d6df2$var$max2[0] = $3fd2aad7811d6df2$var$max2[1] = -Number.MAX_VALUE;
        var data = this.data;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        var i;
        for(i = 0; i < this._len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            switch(cmd){
                case $3fd2aad7811d6df2$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    $3fd2aad7811d6df2$var$min2[0] = x0;
                    $3fd2aad7811d6df2$var$min2[1] = y0;
                    $3fd2aad7811d6df2$var$max2[0] = x0;
                    $3fd2aad7811d6df2$var$max2[1] = y0;
                    break;
                case $3fd2aad7811d6df2$var$CMD.L:
                    (0, $9757a65ec1dd85b5$export$d2b1491e4450bf2c)(xi, yi, data[i], data[i + 1], $3fd2aad7811d6df2$var$min2, $3fd2aad7811d6df2$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $3fd2aad7811d6df2$var$CMD.C:
                    (0, $9757a65ec1dd85b5$export$c1bc6be456bb6609)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], $3fd2aad7811d6df2$var$min2, $3fd2aad7811d6df2$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $3fd2aad7811d6df2$var$CMD.Q:
                    (0, $9757a65ec1dd85b5$export$16fbe795323a1f4c)(xi, yi, data[i++], data[i++], data[i], data[i + 1], $3fd2aad7811d6df2$var$min2, $3fd2aad7811d6df2$var$max2);
                    xi = data[i++];
                    yi = data[i++];
                    break;
                case $3fd2aad7811d6df2$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var endAngle = data[i++] + startAngle;
                    i += 1;
                    var anticlockwise = !data[i++];
                    if (isFirst) {
                        x0 = $3fd2aad7811d6df2$var$mathCos(startAngle) * rx + cx;
                        y0 = $3fd2aad7811d6df2$var$mathSin(startAngle) * ry + cy;
                    }
                    (0, $9757a65ec1dd85b5$export$161c8bb0e1d9ef49)(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, $3fd2aad7811d6df2$var$min2, $3fd2aad7811d6df2$var$max2);
                    xi = $3fd2aad7811d6df2$var$mathCos(endAngle) * rx + cx;
                    yi = $3fd2aad7811d6df2$var$mathSin(endAngle) * ry + cy;
                    break;
                case $3fd2aad7811d6df2$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    (0, $9757a65ec1dd85b5$export$d2b1491e4450bf2c)(x0, y0, x0 + width, y0 + height, $3fd2aad7811d6df2$var$min2, $3fd2aad7811d6df2$var$max2);
                    break;
                case $3fd2aad7811d6df2$var$CMD.Z:
                    xi = x0;
                    yi = y0;
                    break;
            }
            $3dde7d051fe20daa$export$96ec731ed4dcb222($3fd2aad7811d6df2$var$min, $3fd2aad7811d6df2$var$min, $3fd2aad7811d6df2$var$min2);
            $3dde7d051fe20daa$export$8960430cfd85939f($3fd2aad7811d6df2$var$max, $3fd2aad7811d6df2$var$max, $3fd2aad7811d6df2$var$max2);
        }
        if (i === 0) $3fd2aad7811d6df2$var$min[0] = $3fd2aad7811d6df2$var$min[1] = $3fd2aad7811d6df2$var$max[0] = $3fd2aad7811d6df2$var$max[1] = 0;
        return new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)($3fd2aad7811d6df2$var$min[0], $3fd2aad7811d6df2$var$min[1], $3fd2aad7811d6df2$var$max[0] - $3fd2aad7811d6df2$var$min[0], $3fd2aad7811d6df2$var$max[1] - $3fd2aad7811d6df2$var$min[1]);
    };
    PathProxy.prototype._calculateLength = function() {
        var data = this.data;
        var len = this._len;
        var ux = this._ux;
        var uy = this._uy;
        var xi = 0;
        var yi = 0;
        var x0 = 0;
        var y0 = 0;
        if (!this._pathSegLen) this._pathSegLen = [];
        var pathSegLen = this._pathSegLen;
        var pathTotalLen = 0;
        var segCount = 0;
        for(var i = 0; i < len;){
            var cmd = data[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = data[i];
                yi = data[i + 1];
                x0 = xi;
                y0 = yi;
            }
            var l = -1;
            switch(cmd){
                case $3fd2aad7811d6df2$var$CMD.M:
                    xi = x0 = data[i++];
                    yi = y0 = data[i++];
                    break;
                case $3fd2aad7811d6df2$var$CMD.L:
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var dx = x2 - xi;
                    var dy = y2 - yi;
                    if ($3fd2aad7811d6df2$var$mathAbs(dx) > ux || $3fd2aad7811d6df2$var$mathAbs(dy) > uy || i === len - 1) {
                        l = Math.sqrt(dx * dx + dy * dy);
                        xi = x2;
                        yi = y2;
                    }
                    break;
                case $3fd2aad7811d6df2$var$CMD.C:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    var x3 = data[i++];
                    var y3 = data[i++];
                    l = (0, $eea9463646207a7b$export$af1875d576f60d7c)(xi, yi, x1, y1, x2, y2, x3, y3, 10);
                    xi = x3;
                    yi = y3;
                    break;
                case $3fd2aad7811d6df2$var$CMD.Q:
                    var x1 = data[i++];
                    var y1 = data[i++];
                    var x2 = data[i++];
                    var y2 = data[i++];
                    l = (0, $eea9463646207a7b$export$8a68adee46f3cf55)(xi, yi, x1, y1, x2, y2, 10);
                    xi = x2;
                    yi = y2;
                    break;
                case $3fd2aad7811d6df2$var$CMD.A:
                    var cx = data[i++];
                    var cy = data[i++];
                    var rx = data[i++];
                    var ry = data[i++];
                    var startAngle = data[i++];
                    var delta = data[i++];
                    var endAngle = delta + startAngle;
                    i += 1;
                    if (isFirst) {
                        x0 = $3fd2aad7811d6df2$var$mathCos(startAngle) * rx + cx;
                        y0 = $3fd2aad7811d6df2$var$mathSin(startAngle) * ry + cy;
                    }
                    l = $3fd2aad7811d6df2$var$mathMax(rx, ry) * $3fd2aad7811d6df2$var$mathMin($3fd2aad7811d6df2$var$PI2, Math.abs(delta));
                    xi = $3fd2aad7811d6df2$var$mathCos(endAngle) * rx + cx;
                    yi = $3fd2aad7811d6df2$var$mathSin(endAngle) * ry + cy;
                    break;
                case $3fd2aad7811d6df2$var$CMD.R:
                    x0 = xi = data[i++];
                    y0 = yi = data[i++];
                    var width = data[i++];
                    var height = data[i++];
                    l = width * 2 + height * 2;
                    break;
                case $3fd2aad7811d6df2$var$CMD.Z:
                    var dx = x0 - xi;
                    var dy = y0 - yi;
                    l = Math.sqrt(dx * dx + dy * dy);
                    xi = x0;
                    yi = y0;
                    break;
            }
            if (l >= 0) {
                pathSegLen[segCount++] = l;
                pathTotalLen += l;
            }
        }
        this._pathLen = pathTotalLen;
        return pathTotalLen;
    };
    PathProxy.prototype.rebuildPath = function(ctx, percent) {
        var d = this.data;
        var ux = this._ux;
        var uy = this._uy;
        var len = this._len;
        var x0;
        var y0;
        var xi;
        var yi;
        var x;
        var y;
        var drawPart = percent < 1;
        var pathSegLen;
        var pathTotalLen;
        var accumLength = 0;
        var segCount = 0;
        var displayedLength;
        var pendingPtDist = 0;
        var pendingPtX;
        var pendingPtY;
        if (drawPart) {
            if (!this._pathSegLen) this._calculateLength();
            pathSegLen = this._pathSegLen;
            pathTotalLen = this._pathLen;
            displayedLength = percent * pathTotalLen;
            if (!displayedLength) return;
        }
        lo: for(var i = 0; i < len;){
            var cmd = d[i++];
            var isFirst = i === 1;
            if (isFirst) {
                xi = d[i];
                yi = d[i + 1];
                x0 = xi;
                y0 = yi;
            }
            if (cmd !== $3fd2aad7811d6df2$var$CMD.L && pendingPtDist > 0) {
                ctx.lineTo(pendingPtX, pendingPtY);
                pendingPtDist = 0;
            }
            switch(cmd){
                case $3fd2aad7811d6df2$var$CMD.M:
                    x0 = xi = d[i++];
                    y0 = yi = d[i++];
                    ctx.moveTo(xi, yi);
                    break;
                case $3fd2aad7811d6df2$var$CMD.L:
                    x = d[i++];
                    y = d[i++];
                    var dx = $3fd2aad7811d6df2$var$mathAbs(x - xi);
                    var dy = $3fd2aad7811d6df2$var$mathAbs(y - yi);
                    if (dx > ux || dy > uy) {
                        if (drawPart) {
                            var l = pathSegLen[segCount++];
                            if (accumLength + l > displayedLength) {
                                var t = (displayedLength - accumLength) / l;
                                ctx.lineTo(xi * (1 - t) + x * t, yi * (1 - t) + y * t);
                                break lo;
                            }
                            accumLength += l;
                        }
                        ctx.lineTo(x, y);
                        xi = x;
                        yi = y;
                        pendingPtDist = 0;
                    } else {
                        var d2 = dx * dx + dy * dy;
                        if (d2 > pendingPtDist) {
                            pendingPtX = x;
                            pendingPtY = y;
                            pendingPtDist = d2;
                        }
                    }
                    break;
                case $3fd2aad7811d6df2$var$CMD.C:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    var x3 = d[i++];
                    var y3 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $eea9463646207a7b$export$a2ee23a0567039da)(xi, x1, x2, x3, t, $3fd2aad7811d6df2$var$tmpOutX);
                            (0, $eea9463646207a7b$export$a2ee23a0567039da)(yi, y1, y2, y3, t, $3fd2aad7811d6df2$var$tmpOutY);
                            ctx.bezierCurveTo($3fd2aad7811d6df2$var$tmpOutX[1], $3fd2aad7811d6df2$var$tmpOutY[1], $3fd2aad7811d6df2$var$tmpOutX[2], $3fd2aad7811d6df2$var$tmpOutY[2], $3fd2aad7811d6df2$var$tmpOutX[3], $3fd2aad7811d6df2$var$tmpOutY[3]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    xi = x3;
                    yi = y3;
                    break;
                case $3fd2aad7811d6df2$var$CMD.Q:
                    var x1 = d[i++];
                    var y1 = d[i++];
                    var x2 = d[i++];
                    var y2 = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            (0, $eea9463646207a7b$export$117c659e21a7a060)(xi, x1, x2, t, $3fd2aad7811d6df2$var$tmpOutX);
                            (0, $eea9463646207a7b$export$117c659e21a7a060)(yi, y1, y2, t, $3fd2aad7811d6df2$var$tmpOutY);
                            ctx.quadraticCurveTo($3fd2aad7811d6df2$var$tmpOutX[1], $3fd2aad7811d6df2$var$tmpOutY[1], $3fd2aad7811d6df2$var$tmpOutX[2], $3fd2aad7811d6df2$var$tmpOutY[2]);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.quadraticCurveTo(x1, y1, x2, y2);
                    xi = x2;
                    yi = y2;
                    break;
                case $3fd2aad7811d6df2$var$CMD.A:
                    var cx = d[i++];
                    var cy = d[i++];
                    var rx = d[i++];
                    var ry = d[i++];
                    var startAngle = d[i++];
                    var delta = d[i++];
                    var psi = d[i++];
                    var anticlockwise = !d[i++];
                    var r = rx > ry ? rx : ry;
                    var isEllipse = $3fd2aad7811d6df2$var$mathAbs(rx - ry) > 1e-3;
                    var endAngle = startAngle + delta;
                    var breakBuild = false;
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            endAngle = startAngle + delta * (displayedLength - accumLength) / l;
                            breakBuild = true;
                        }
                        accumLength += l;
                    }
                    if (isEllipse && ctx.ellipse) ctx.ellipse(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise);
                    else ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
                    if (breakBuild) break lo;
                    if (isFirst) {
                        x0 = $3fd2aad7811d6df2$var$mathCos(startAngle) * rx + cx;
                        y0 = $3fd2aad7811d6df2$var$mathSin(startAngle) * ry + cy;
                    }
                    xi = $3fd2aad7811d6df2$var$mathCos(endAngle) * rx + cx;
                    yi = $3fd2aad7811d6df2$var$mathSin(endAngle) * ry + cy;
                    break;
                case $3fd2aad7811d6df2$var$CMD.R:
                    x0 = xi = d[i];
                    y0 = yi = d[i + 1];
                    x = d[i++];
                    y = d[i++];
                    var width = d[i++];
                    var height = d[i++];
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var d_1 = displayedLength - accumLength;
                            ctx.moveTo(x, y);
                            ctx.lineTo(x + $3fd2aad7811d6df2$var$mathMin(d_1, width), y);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x + width, y + $3fd2aad7811d6df2$var$mathMin(d_1, height));
                            d_1 -= height;
                            if (d_1 > 0) ctx.lineTo(x + $3fd2aad7811d6df2$var$mathMax(width - d_1, 0), y + height);
                            d_1 -= width;
                            if (d_1 > 0) ctx.lineTo(x, y + $3fd2aad7811d6df2$var$mathMax(height - d_1, 0));
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.rect(x, y, width, height);
                    break;
                case $3fd2aad7811d6df2$var$CMD.Z:
                    if (drawPart) {
                        var l = pathSegLen[segCount++];
                        if (accumLength + l > displayedLength) {
                            var t = (displayedLength - accumLength) / l;
                            ctx.lineTo(xi * (1 - t) + x0 * t, yi * (1 - t) + y0 * t);
                            break lo;
                        }
                        accumLength += l;
                    }
                    ctx.closePath();
                    xi = x0;
                    yi = y0;
            }
        }
    };
    PathProxy.prototype.clone = function() {
        var newProxy = new PathProxy();
        var data = this.data;
        newProxy.data = data.slice ? data.slice() : Array.prototype.slice.call(data);
        newProxy._len = this._len;
        return newProxy;
    };
    PathProxy.CMD = $3fd2aad7811d6df2$var$CMD;
    PathProxy.initDefaultProps = function() {
        var proto = PathProxy.prototype;
        proto._saveData = true;
        proto._ux = 0;
        proto._uy = 0;
        proto._pendingPtDist = 0;
        proto._version = 0;
    }();
    return PathProxy;
}();
var $3fd2aad7811d6df2$export$2e2bcd8739ae039 = $3fd2aad7811d6df2$var$PathProxy;



function $aca25f357ba197a3$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    var _a = 0;
    var _b = x0;
    if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) return false;
    if (x0 !== x1) {
        _a = (y0 - y1) / (x0 - x1);
        _b = (x0 * y1 - x1 * y0) / (x0 - x1);
    } else return Math.abs(x - x0) <= _l / 2;
    var tmp = _a * x - y + _b;
    var _s = tmp * tmp / (_a * _a + 1);
    return _s <= _l / 2 * _l / 2;
}



function $0d040a08d84d2578$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) return false;
    var d = $eea9463646207a7b$export$dbaa3801d1284367(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
    return d <= _l / 2;
}



function $8b785c696f02cfdb$export$8d36b1b5d19157c5(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) return false;
    var d = (0, $eea9463646207a7b$export$81915a594fe10dee)(x0, y0, x1, y1, x2, y2, x, y, null);
    return d <= _l / 2;
}


var $1851ee851ae60f55$var$PI2 = Math.PI * 2;
function $1851ee851ae60f55$export$d44861331f213635(angle) {
    angle %= $1851ee851ae60f55$var$PI2;
    if (angle < 0) angle += $1851ee851ae60f55$var$PI2;
    return angle;
}


var $94289a538ebb1c66$var$PI2 = Math.PI * 2;
function $94289a538ebb1c66$export$8d36b1b5d19157c5(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
    if (lineWidth === 0) return false;
    var _l = lineWidth;
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    if (d - _l > r || d + _l < r) return false;
    if (Math.abs(startAngle - endAngle) % $94289a538ebb1c66$var$PI2 < 1e-4) return true;
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(endAngle);
        endAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(startAngle);
        endAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $94289a538ebb1c66$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $94289a538ebb1c66$var$PI2;
    return angle >= startAngle && angle <= endAngle || angle + $94289a538ebb1c66$var$PI2 >= startAngle && angle + $94289a538ebb1c66$var$PI2 <= endAngle;
}



function $97e2e82619a31023$export$2e2bcd8739ae039(x0, y0, x1, y1, x, y) {
    if (y > y0 && y > y1 || y < y0 && y < y1) return 0;
    if (y1 === y0) return 0;
    var t = (y - y0) / (y1 - y0);
    var dir = y1 < y0 ? 1 : -1;
    if (t === 1 || t === 0) dir = y1 < y0 ? 0.5 : -0.5;
    var x_ = t * (x1 - x0) + x0;
    return x_ === x ? Infinity : x_ > x ? dir : 0;
}


var $8455a9550aa8b156$var$CMD = (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039).CMD;
var $8455a9550aa8b156$var$PI2 = Math.PI * 2;
var $8455a9550aa8b156$var$EPSILON = 1e-4;
function $8455a9550aa8b156$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $8455a9550aa8b156$var$EPSILON;
}
var $8455a9550aa8b156$var$roots = [
    -1,
    -1,
    -1
];
var $8455a9550aa8b156$var$extrema = [
    -1,
    -1
];
function $8455a9550aa8b156$var$swapExtrema() {
    var tmp = $8455a9550aa8b156$var$extrema[0];
    $8455a9550aa8b156$var$extrema[0] = $8455a9550aa8b156$var$extrema[1];
    $8455a9550aa8b156$var$extrema[1] = tmp;
}
function $8455a9550aa8b156$var$windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
    if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) return 0;
    var nRoots = $eea9463646207a7b$export$ca5d13faa10b167e(y0, y1, y2, y3, y, $8455a9550aa8b156$var$roots);
    if (nRoots === 0) return 0;
    else {
        var w = 0;
        var nExtrema = -1;
        var y0_ = void 0;
        var y1_ = void 0;
        for(var i = 0; i < nRoots; i++){
            var t = $8455a9550aa8b156$var$roots[i];
            var unit = t === 0 || t === 1 ? 0.5 : 1;
            var x_ = $eea9463646207a7b$export$547c21de482bbcb2(x0, x1, x2, x3, t);
            if (x_ < x) continue;
            if (nExtrema < 0) {
                nExtrema = $eea9463646207a7b$export$df1a172f100d0457(y0, y1, y2, y3, $8455a9550aa8b156$var$extrema);
                if ($8455a9550aa8b156$var$extrema[1] < $8455a9550aa8b156$var$extrema[0] && nExtrema > 1) $8455a9550aa8b156$var$swapExtrema();
                y0_ = $eea9463646207a7b$export$547c21de482bbcb2(y0, y1, y2, y3, $8455a9550aa8b156$var$extrema[0]);
                if (nExtrema > 1) y1_ = $eea9463646207a7b$export$547c21de482bbcb2(y0, y1, y2, y3, $8455a9550aa8b156$var$extrema[1]);
            }
            if (nExtrema === 2) {
                if (t < $8455a9550aa8b156$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
                else if (t < $8455a9550aa8b156$var$extrema[1]) w += y1_ < y0_ ? unit : -unit;
                else w += y3 < y1_ ? unit : -unit;
            } else if (t < $8455a9550aa8b156$var$extrema[0]) w += y0_ < y0 ? unit : -unit;
            else w += y3 < y0_ ? unit : -unit;
        }
        return w;
    }
}
function $8455a9550aa8b156$var$windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
    if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) return 0;
    var nRoots = $eea9463646207a7b$export$fd895ac7ee764967(y0, y1, y2, y, $8455a9550aa8b156$var$roots);
    if (nRoots === 0) return 0;
    else {
        var t = $eea9463646207a7b$export$752e1f8c6e7f7e11(y0, y1, y2);
        if (t >= 0 && t <= 1) {
            var w = 0;
            var y_ = $eea9463646207a7b$export$af17094a950f5073(y0, y1, y2, t);
            for(var i = 0; i < nRoots; i++){
                var unit = $8455a9550aa8b156$var$roots[i] === 0 || $8455a9550aa8b156$var$roots[i] === 1 ? 0.5 : 1;
                var x_ = $eea9463646207a7b$export$af17094a950f5073(x0, x1, x2, $8455a9550aa8b156$var$roots[i]);
                if (x_ < x) continue;
                if ($8455a9550aa8b156$var$roots[i] < t) w += y_ < y0 ? unit : -unit;
                else w += y2 < y_ ? unit : -unit;
            }
            return w;
        } else {
            var unit = $8455a9550aa8b156$var$roots[0] === 0 || $8455a9550aa8b156$var$roots[0] === 1 ? 0.5 : 1;
            var x_ = $eea9463646207a7b$export$af17094a950f5073(x0, x1, x2, $8455a9550aa8b156$var$roots[0]);
            if (x_ < x) return 0;
            return y2 < y0 ? unit : -unit;
        }
    }
}
function $8455a9550aa8b156$var$windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
    y -= cy;
    if (y > r || y < -r) return 0;
    var tmp = Math.sqrt(r * r - y * y);
    $8455a9550aa8b156$var$roots[0] = -tmp;
    $8455a9550aa8b156$var$roots[1] = tmp;
    var dTheta = Math.abs(startAngle - endAngle);
    if (dTheta < 1e-4) return 0;
    if (dTheta >= $8455a9550aa8b156$var$PI2 - 1e-4) {
        startAngle = 0;
        endAngle = $8455a9550aa8b156$var$PI2;
        var dir = anticlockwise ? 1 : -1;
        if (x >= $8455a9550aa8b156$var$roots[0] + cx && x <= $8455a9550aa8b156$var$roots[1] + cx) return dir;
        else return 0;
    }
    if (startAngle > endAngle) {
        var tmp_1 = startAngle;
        startAngle = endAngle;
        endAngle = tmp_1;
    }
    if (startAngle < 0) {
        startAngle += $8455a9550aa8b156$var$PI2;
        endAngle += $8455a9550aa8b156$var$PI2;
    }
    var w = 0;
    for(var i = 0; i < 2; i++){
        var x_ = $8455a9550aa8b156$var$roots[i];
        if (x_ + cx > x) {
            var angle = Math.atan2(y, x_);
            var dir = anticlockwise ? 1 : -1;
            if (angle < 0) angle = $8455a9550aa8b156$var$PI2 + angle;
            if (angle >= startAngle && angle <= endAngle || angle + $8455a9550aa8b156$var$PI2 >= startAngle && angle + $8455a9550aa8b156$var$PI2 <= endAngle) {
                if (angle > Math.PI / 2 && angle < Math.PI * 1.5) dir = -dir;
                w += dir;
            }
        }
    }
    return w;
}
function $8455a9550aa8b156$var$containPath(path, lineWidth, isStroke, x, y) {
    var data = path.data;
    var len = path.len();
    var w = 0;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (cmd === $8455a9550aa8b156$var$CMD.M && i > 1) {
            if (!isStroke) w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
        }
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        switch(cmd){
            case $8455a9550aa8b156$var$CMD.M:
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $8455a9550aa8b156$var$CMD.L:
                if (isStroke) {
                    if ($aca25f357ba197a3$export$8d36b1b5d19157c5(xi, yi, data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(xi, yi, data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $8455a9550aa8b156$var$CMD.C:
                if (isStroke) {
                    if ($0d040a08d84d2578$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $8455a9550aa8b156$var$windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $8455a9550aa8b156$var$CMD.Q:
                if (isStroke) {
                    if ($8b785c696f02cfdb$export$8d36b1b5d19157c5(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) return true;
                } else w += $8455a9550aa8b156$var$windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
                xi = data[i++];
                yi = data[i++];
                break;
            case $8455a9550aa8b156$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                if (!isFirst) w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(xi, yi, x1, y1, x, y);
                else {
                    x0 = x1;
                    y0 = y1;
                }
                var _x = (x - cx) * ry / rx + cx;
                if (isStroke) {
                    if ($94289a538ebb1c66$export$8d36b1b5d19157c5(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) return true;
                } else w += $8455a9550aa8b156$var$windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $8455a9550aa8b156$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                x1 = x0 + width;
                y1 = y0 + height;
                if (isStroke) {
                    if ($aca25f357ba197a3$export$8d36b1b5d19157c5(x0, y0, x1, y0, lineWidth, x, y) || $aca25f357ba197a3$export$8d36b1b5d19157c5(x1, y0, x1, y1, lineWidth, x, y) || $aca25f357ba197a3$export$8d36b1b5d19157c5(x1, y1, x0, y1, lineWidth, x, y) || $aca25f357ba197a3$export$8d36b1b5d19157c5(x0, y1, x0, y0, lineWidth, x, y)) return true;
                } else {
                    w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(x1, y0, x1, y1, x, y);
                    w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(x0, y1, x0, y0, x, y);
                }
                break;
            case $8455a9550aa8b156$var$CMD.Z:
                if (isStroke) {
                    if ($aca25f357ba197a3$export$8d36b1b5d19157c5(xi, yi, x0, y0, lineWidth, x, y)) return true;
                } else w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (!isStroke && !$8455a9550aa8b156$var$isAroundEqual(yi, y0)) w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(xi, yi, x0, y0, x, y) || 0;
    return w !== 0;
}
function $8455a9550aa8b156$export$8893e2b90ba10d92(pathProxy, x, y) {
    return $8455a9550aa8b156$var$containPath(pathProxy, 0, false, x, y);
}
function $8455a9550aa8b156$export$8d36b1b5d19157c5(pathProxy, lineWidth, x, y) {
    return $8455a9550aa8b156$var$containPath(pathProxy, lineWidth, true, x, y);
}







var $f9698154c9fcf427$export$deade517576e293a = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
    fill: '#000',
    stroke: null,
    strokePercent: 1,
    fillOpacity: 1,
    strokeOpacity: 1,
    lineDashOffset: 0,
    lineWidth: 1,
    lineCap: 'butt',
    miterLimit: 10,
    strokeNoScale: false,
    strokeFirst: false
}, (0, $cfd8540aca1ca40f$export$737672163db00fe3));
var $f9698154c9fcf427$export$71bb6c3c6862c6a5 = {
    style: (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        strokePercent: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineDashOffset: true,
        lineWidth: true,
        miterLimit: true
    }, (0, $cfd8540aca1ca40f$export$9908943fb57fbe51).style)
};
var $f9698154c9fcf427$var$pathCopyParams = (0, $cd11a033fc7d29e7$export$98ab6203ec3396e2).concat([
    'invisible',
    'culling',
    'z',
    'z2',
    'zlevel',
    'parent'
]);
var $f9698154c9fcf427$var$Path = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Path, _super);
    function Path(opts) {
        return _super.call(this, opts) || this;
    }
    Path.prototype.update = function() {
        var _this = this;
        _super.prototype.update.call(this);
        var style = this.style;
        if (style.decal) {
            var decalEl = this._decalEl = this._decalEl || new Path();
            if (decalEl.buildPath === Path.prototype.buildPath) decalEl.buildPath = function(ctx) {
                _this.buildPath(ctx, _this.shape);
            };
            decalEl.silent = true;
            var decalElStyle = decalEl.style;
            for(var key in style)if (decalElStyle[key] !== style[key]) decalElStyle[key] = style[key];
            decalElStyle.fill = style.fill ? style.decal : null;
            decalElStyle.decal = null;
            decalElStyle.shadowColor = null;
            style.strokeFirst && (decalElStyle.stroke = null);
            for(var i = 0; i < $f9698154c9fcf427$var$pathCopyParams.length; ++i)decalEl[$f9698154c9fcf427$var$pathCopyParams[i]] = this[$f9698154c9fcf427$var$pathCopyParams[i]];
            decalEl.__dirty |= (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
        } else if (this._decalEl) this._decalEl = null;
    };
    Path.prototype.getDecalElement = function() {
        return this._decalEl;
    };
    Path.prototype._init = function(props) {
        var keysArr = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(props);
        this.shape = this.getDefaultShape();
        var defaultStyle = this.getDefaultStyle();
        if (defaultStyle) this.useStyle(defaultStyle);
        for(var i = 0; i < keysArr.length; i++){
            var key = keysArr[i];
            var value = props[key];
            if (key === 'style') {
                if (!this.style) this.useStyle(value);
                else (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(this.style, value);
            } else if (key === 'shape') (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(this.shape, value);
            else _super.prototype.attrKV.call(this, key, value);
        }
        if (!this.style) this.useStyle({});
    };
    Path.prototype.getDefaultStyle = function() {
        return null;
    };
    Path.prototype.getDefaultShape = function() {
        return {};
    };
    Path.prototype.canBeInsideText = function() {
        return this.hasFill();
    };
    Path.prototype.getInsideTextFill = function() {
        var pathFill = this.style.fill;
        if (pathFill !== 'none') {
            if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(pathFill)) {
                var fillLum = (0, $35573db24643e2ef$export$16c0ec21a6f9ef95)(pathFill, 0);
                if (fillLum > 0.5) return 0, $495ebc0cfec45c57$export$f8ce94761f39398d;
                else if (fillLum > 0.2) return 0, $495ebc0cfec45c57$export$27682248795c3c6b;
                return 0, $495ebc0cfec45c57$export$3c6e95f318c8369b;
            } else if (pathFill) return 0, $495ebc0cfec45c57$export$3c6e95f318c8369b;
        }
        return 0, $495ebc0cfec45c57$export$f8ce94761f39398d;
    };
    Path.prototype.getInsideTextStroke = function(textFill) {
        var pathFill = this.style.fill;
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(pathFill)) {
            var zr = this.__zr;
            var isDarkMode = !!(zr && zr.isDarkMode());
            var isDarkLabel = (0, $35573db24643e2ef$export$16c0ec21a6f9ef95)(textFill, 0) < (0, $495ebc0cfec45c57$export$fd81e7ebc7dae256);
            if (isDarkMode === isDarkLabel) return pathFill;
        }
    };
    Path.prototype.buildPath = function(ctx, shapeCfg, inBatch) {};
    Path.prototype.pathUpdated = function() {
        this.__dirty &= ~(0, $7bc42091a9de0611$export$f75fe89a33ebe115);
    };
    Path.prototype.getUpdatedPathProxy = function(inBatch) {
        !this.path && this.createPathProxy();
        this.path.beginPath();
        this.buildPath(this.path, this.shape, inBatch);
        return this.path;
    };
    Path.prototype.createPathProxy = function() {
        this.path = new (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039)(false);
    };
    Path.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
    };
    Path.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    Path.prototype.getBoundingRect = function() {
        var rect = this._rect;
        var style = this.style;
        var needsUpdateRect = !rect;
        if (needsUpdateRect) {
            var firstInvoke = false;
            if (!this.path) {
                firstInvoke = true;
                this.createPathProxy();
            }
            var path = this.path;
            if (firstInvoke || this.__dirty & (0, $7bc42091a9de0611$export$f75fe89a33ebe115)) {
                path.beginPath();
                this.buildPath(path, this.shape, false);
                this.pathUpdated();
            }
            rect = path.getBoundingRect();
        }
        this._rect = rect;
        if (this.hasStroke() && this.path && this.path.len() > 0) {
            var rectStroke = this._rectStroke || (this._rectStroke = rect.clone());
            if (this.__dirty || needsUpdateRect) {
                rectStroke.copy(rect);
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                var w = style.lineWidth;
                if (!this.hasFill()) {
                    var strokeContainThreshold = this.strokeContainThreshold;
                    w = Math.max(w, strokeContainThreshold == null ? 4 : strokeContainThreshold);
                }
                if (lineScale > 1e-10) {
                    rectStroke.width += w / lineScale;
                    rectStroke.height += w / lineScale;
                    rectStroke.x -= w / lineScale / 2;
                    rectStroke.y -= w / lineScale / 2;
                }
            }
            return rectStroke;
        }
        return rect;
    };
    Path.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        var style = this.style;
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            var pathProxy = this.path;
            if (this.hasStroke()) {
                var lineWidth = style.lineWidth;
                var lineScale = style.strokeNoScale ? this.getLineScale() : 1;
                if (lineScale > 1e-10) {
                    if (!this.hasFill()) lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
                    if ($8455a9550aa8b156$export$8d36b1b5d19157c5(pathProxy, lineWidth / lineScale, x, y)) return true;
                }
            }
            if (this.hasFill()) return $8455a9550aa8b156$export$8893e2b90ba10d92(pathProxy, x, y);
        }
        return false;
    };
    Path.prototype.dirtyShape = function() {
        this.__dirty |= (0, $7bc42091a9de0611$export$f75fe89a33ebe115);
        if (this._rect) this._rect = null;
        if (this._decalEl) this._decalEl.dirtyShape();
        this.markRedraw();
    };
    Path.prototype.dirty = function() {
        this.dirtyStyle();
        this.dirtyShape();
    };
    Path.prototype.animateShape = function(loop) {
        return this.animate('shape', loop);
    };
    Path.prototype.updateDuringAnimation = function(targetKey) {
        if (targetKey === 'style') this.dirtyStyle();
        else if (targetKey === 'shape') this.dirtyShape();
        else this.markRedraw();
    };
    Path.prototype.attrKV = function(key, value) {
        if (key === 'shape') this.setShape(value);
        else _super.prototype.attrKV.call(this, key, value);
    };
    Path.prototype.setShape = function(keyOrObj, value) {
        var shape = this.shape;
        if (!shape) shape = this.shape = {};
        if (typeof keyOrObj === 'string') shape[keyOrObj] = value;
        else (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(shape, keyOrObj);
        this.dirtyShape();
        return this;
    };
    Path.prototype.shapeChanged = function() {
        return !!(this.__dirty & (0, $7bc42091a9de0611$export$f75fe89a33ebe115));
    };
    Path.prototype.createStyle = function(obj) {
        return (0, $1b239fc9d3a2f8ae$export$79c7e160a7743efd)($f9698154c9fcf427$export$deade517576e293a, obj);
    };
    Path.prototype._innerSaveToNormal = function(toState) {
        _super.prototype._innerSaveToNormal.call(this, toState);
        var normalState = this._normalState;
        if (toState.shape && !normalState.shape) normalState.shape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, this.shape);
    };
    Path.prototype._applyStateObj = function(stateName, state, normalState, keepCurrentStates, transition, animationCfg) {
        _super.prototype._applyStateObj.call(this, stateName, state, normalState, keepCurrentStates, transition, animationCfg);
        var needsRestoreToNormal = !(state && keepCurrentStates);
        var targetShape;
        if (state && state.shape) {
            if (transition) {
                if (keepCurrentStates) targetShape = state.shape;
                else {
                    targetShape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, normalState.shape);
                    (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(targetShape, state.shape);
                }
            } else {
                targetShape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, keepCurrentStates ? this.shape : normalState.shape);
                (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(targetShape, state.shape);
            }
        } else if (needsRestoreToNormal) targetShape = normalState.shape;
        if (targetShape) {
            if (transition) {
                this.shape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, this.shape);
                var targetShapePrimaryProps = {};
                var shapeKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(targetShape);
                for(var i = 0; i < shapeKeys.length; i++){
                    var key = shapeKeys[i];
                    if (typeof targetShape[key] === 'object') this.shape[key] = targetShape[key];
                    else targetShapePrimaryProps[key] = targetShape[key];
                }
                this._transitionState(stateName, {
                    shape: targetShapePrimaryProps
                }, animationCfg);
            } else {
                this.shape = targetShape;
                this.dirtyShape();
            }
        }
    };
    Path.prototype._mergeStates = function(states) {
        var mergedState = _super.prototype._mergeStates.call(this, states);
        var mergedShape;
        for(var i = 0; i < states.length; i++){
            var state = states[i];
            if (state.shape) {
                mergedShape = mergedShape || {};
                this._mergeStyle(mergedShape, state.shape);
            }
        }
        if (mergedShape) mergedState.shape = mergedShape;
        return mergedState;
    };
    Path.prototype.getAnimationStyleProps = function() {
        return $f9698154c9fcf427$export$71bb6c3c6862c6a5;
    };
    Path.prototype.isZeroArea = function() {
        return false;
    };
    Path.extend = function(defaultProps) {
        var Sub = function(_super) {
            (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Sub, _super);
            function Sub(opts) {
                var _this = _super.call(this, opts) || this;
                defaultProps.init && defaultProps.init.call(_this, opts);
                return _this;
            }
            Sub.prototype.getDefaultStyle = function() {
                return (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(defaultProps.style);
            };
            Sub.prototype.getDefaultShape = function() {
                return (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(defaultProps.shape);
            };
            return Sub;
        }(Path);
        for(var key in defaultProps)if (typeof defaultProps[key] === 'function') Sub.prototype[key] = defaultProps[key];
        return Sub;
    };
    Path.initDefaultProps = function() {
        var pathProto = Path.prototype;
        pathProto.type = 'path';
        pathProto.strokeContainThreshold = 5;
        pathProto.segmentIgnoreThreshold = 0;
        pathProto.subPixelOptimize = false;
        pathProto.autoBatch = false;
        pathProto.__dirty = (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd) | (0, $7bc42091a9de0611$export$ada8b2beb3d76671) | (0, $7bc42091a9de0611$export$f75fe89a33ebe115);
    }();
    return Path;
}((0, $cfd8540aca1ca40f$export$2e2bcd8739ae039));
var $f9698154c9fcf427$export$2e2bcd8739ae039 = $f9698154c9fcf427$var$Path;




var $d14badf4d84ba4b7$export$5fbb6d98091bcb56 = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
    strokeFirst: true,
    font: (0, $024b63ea846a8ccd$export$7d7a232b6d2cc80c),
    x: 0,
    y: 0,
    textAlign: 'left',
    textBaseline: 'top',
    miterLimit: 2
}, (0, $f9698154c9fcf427$export$deade517576e293a));
var $d14badf4d84ba4b7$var$TSpan = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TSpan, _super);
    function TSpan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TSpan.prototype.hasStroke = function() {
        var style = this.style;
        var stroke = style.stroke;
        return stroke != null && stroke !== 'none' && style.lineWidth > 0;
    };
    TSpan.prototype.hasFill = function() {
        var style = this.style;
        var fill = style.fill;
        return fill != null && fill !== 'none';
    };
    TSpan.prototype.createStyle = function(obj) {
        return (0, $1b239fc9d3a2f8ae$export$79c7e160a7743efd)($d14badf4d84ba4b7$export$5fbb6d98091bcb56, obj);
    };
    TSpan.prototype.setBoundingRect = function(rect) {
        this._rect = rect;
    };
    TSpan.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) {
            var text = style.text;
            text != null ? text += '' : text = '';
            var rect = (0, $297531217517fbce$export$c381147bfed79d9f)(text, style.font, style.textAlign, style.textBaseline);
            rect.x += style.x || 0;
            rect.y += style.y || 0;
            if (this.hasStroke()) {
                var w = style.lineWidth;
                rect.x -= w / 2;
                rect.y -= w / 2;
                rect.width += w;
                rect.height += w;
            }
            this._rect = rect;
        }
        return this._rect;
    };
    TSpan.initDefaultProps = function() {
        var tspanProto = TSpan.prototype;
        tspanProto.dirtyRectTolerance = 10;
    }();
    return TSpan;
}((0, $cfd8540aca1ca40f$export$2e2bcd8739ae039));
$d14badf4d84ba4b7$var$TSpan.prototype.type = 'tspan';
var $d14badf4d84ba4b7$export$2e2bcd8739ae039 = $d14badf4d84ba4b7$var$TSpan;








var $29f98103052059af$export$8993f922aeeac642 = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
    x: 0,
    y: 0
}, (0, $cfd8540aca1ca40f$export$737672163db00fe3));
var $29f98103052059af$export$4aba8ad70847a488 = {
    style: (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
        x: true,
        y: true,
        width: true,
        height: true,
        sx: true,
        sy: true,
        sWidth: true,
        sHeight: true
    }, (0, $cfd8540aca1ca40f$export$9908943fb57fbe51).style)
};
function $29f98103052059af$var$isImageLike(source) {
    return !!(source && typeof source !== 'string' && source.width && source.height);
}
var $29f98103052059af$var$ZRImage = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ZRImage, _super);
    function ZRImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ZRImage.prototype.createStyle = function(obj) {
        return (0, $1b239fc9d3a2f8ae$export$79c7e160a7743efd)($29f98103052059af$export$8993f922aeeac642, obj);
    };
    ZRImage.prototype._getSize = function(dim) {
        var style = this.style;
        var size = style[dim];
        if (size != null) return size;
        var imageSource = $29f98103052059af$var$isImageLike(style.image) ? style.image : this.__image;
        if (!imageSource) return 0;
        var otherDim = dim === 'width' ? 'height' : 'width';
        var otherDimSize = style[otherDim];
        if (otherDimSize == null) return imageSource[dim];
        else return imageSource[dim] / imageSource[otherDim] * otherDimSize;
    };
    ZRImage.prototype.getWidth = function() {
        return this._getSize('width');
    };
    ZRImage.prototype.getHeight = function() {
        return this._getSize('height');
    };
    ZRImage.prototype.getAnimationStyleProps = function() {
        return $29f98103052059af$export$4aba8ad70847a488;
    };
    ZRImage.prototype.getBoundingRect = function() {
        var style = this.style;
        if (!this._rect) this._rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(style.x || 0, style.y || 0, this.getWidth(), this.getHeight());
        return this._rect;
    };
    return ZRImage;
}((0, $cfd8540aca1ca40f$export$2e2bcd8739ae039));
$29f98103052059af$var$ZRImage.prototype.type = 'image';
var $29f98103052059af$export$2e2bcd8739ae039 = $29f98103052059af$var$ZRImage;




function $5574a08548dc34d5$export$5cc7f731b5937e99(ctx, shape) {
    var x = shape.x;
    var y = shape.y;
    var width = shape.width;
    var height = shape.height;
    var r = shape.r;
    var r1;
    var r2;
    var r3;
    var r4;
    if (width < 0) {
        x = x + width;
        width = -width;
    }
    if (height < 0) {
        y = y + height;
        height = -height;
    }
    if (typeof r === 'number') r1 = r2 = r3 = r4 = r;
    else if (r instanceof Array) {
        if (r.length === 1) r1 = r2 = r3 = r4 = r[0];
        else if (r.length === 2) {
            r1 = r3 = r[0];
            r2 = r4 = r[1];
        } else if (r.length === 3) {
            r1 = r[0];
            r2 = r4 = r[1];
            r3 = r[2];
        } else {
            r1 = r[0];
            r2 = r[1];
            r3 = r[2];
            r4 = r[3];
        }
    } else r1 = r2 = r3 = r4 = 0;
    var total;
    if (r1 + r2 > width) {
        total = r1 + r2;
        r1 *= width / total;
        r2 *= width / total;
    }
    if (r3 + r4 > width) {
        total = r3 + r4;
        r3 *= width / total;
        r4 *= width / total;
    }
    if (r2 + r3 > height) {
        total = r2 + r3;
        r2 *= height / total;
        r3 *= height / total;
    }
    if (r1 + r4 > height) {
        total = r1 + r4;
        r1 *= height / total;
        r4 *= height / total;
    }
    ctx.moveTo(x + r1, y);
    ctx.lineTo(x + width - r2, y);
    r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
    ctx.lineTo(x + width, y + height - r3);
    r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
    ctx.lineTo(x + r4, y + height);
    r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
    ctx.lineTo(x, y + r1);
    r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
}


var $76bb43c2e594ce84$var$round = Math.round;
function $76bb43c2e594ce84$export$8b4b620d7f4aad1b(outputShape, inputShape, style) {
    if (!inputShape) return;
    var x1 = inputShape.x1;
    var x2 = inputShape.x2;
    var y1 = inputShape.y1;
    var y2 = inputShape.y2;
    outputShape.x1 = x1;
    outputShape.x2 = x2;
    outputShape.y1 = y1;
    outputShape.y2 = y2;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    if ($76bb43c2e594ce84$var$round(x1 * 2) === $76bb43c2e594ce84$var$round(x2 * 2)) outputShape.x1 = outputShape.x2 = $76bb43c2e594ce84$export$72c4fd4c1b8fcb10(x1, lineWidth, true);
    if ($76bb43c2e594ce84$var$round(y1 * 2) === $76bb43c2e594ce84$var$round(y2 * 2)) outputShape.y1 = outputShape.y2 = $76bb43c2e594ce84$export$72c4fd4c1b8fcb10(y1, lineWidth, true);
    return outputShape;
}
function $76bb43c2e594ce84$export$60e2aa74957d0b9d(outputShape, inputShape, style) {
    if (!inputShape) return;
    var originX = inputShape.x;
    var originY = inputShape.y;
    var originWidth = inputShape.width;
    var originHeight = inputShape.height;
    outputShape.x = originX;
    outputShape.y = originY;
    outputShape.width = originWidth;
    outputShape.height = originHeight;
    var lineWidth = style && style.lineWidth;
    if (!lineWidth) return outputShape;
    outputShape.x = $76bb43c2e594ce84$export$72c4fd4c1b8fcb10(originX, lineWidth, true);
    outputShape.y = $76bb43c2e594ce84$export$72c4fd4c1b8fcb10(originY, lineWidth, true);
    outputShape.width = Math.max($76bb43c2e594ce84$export$72c4fd4c1b8fcb10(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
    outputShape.height = Math.max($76bb43c2e594ce84$export$72c4fd4c1b8fcb10(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
    return outputShape;
}
function $76bb43c2e594ce84$export$72c4fd4c1b8fcb10(position, lineWidth, positiveOrNegative) {
    if (!lineWidth) return position;
    var doubledPosition = $76bb43c2e594ce84$var$round(position * 2);
    return (doubledPosition + $76bb43c2e594ce84$var$round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
}


var $37476269d425e3f6$export$51140d6b71bb4ed5 = function() {
    function RectShape() {
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
    }
    return RectShape;
}();
var $37476269d425e3f6$var$subPixelOptimizeOutputShape = {};
var $37476269d425e3f6$var$Rect = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Rect, _super);
    function Rect(opts) {
        return _super.call(this, opts) || this;
    }
    Rect.prototype.getDefaultShape = function() {
        return new $37476269d425e3f6$export$51140d6b71bb4ed5();
    };
    Rect.prototype.buildPath = function(ctx, shape) {
        var x;
        var y;
        var width;
        var height;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $76bb43c2e594ce84$export$60e2aa74957d0b9d)($37476269d425e3f6$var$subPixelOptimizeOutputShape, shape, this.style);
            x = optimizedShape.x;
            y = optimizedShape.y;
            width = optimizedShape.width;
            height = optimizedShape.height;
            optimizedShape.r = shape.r;
            shape = optimizedShape;
        } else {
            x = shape.x;
            y = shape.y;
            width = shape.width;
            height = shape.height;
        }
        if (!shape.r) ctx.rect(x, y, width, height);
        else $5574a08548dc34d5$export$5cc7f731b5937e99(ctx, shape);
    };
    Rect.prototype.isZeroArea = function() {
        return !this.shape.width || !this.shape.height;
    };
    return Rect;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$37476269d425e3f6$var$Rect.prototype.type = 'rect';
var $37476269d425e3f6$export$2e2bcd8739ae039 = $37476269d425e3f6$var$Rect;





var $76f8f1d5b5bbe4fc$var$DEFAULT_RICH_TEXT_COLOR = {
    fill: '#000'
};
var $76f8f1d5b5bbe4fc$var$DEFAULT_STROKE_LINE_WIDTH = 2;
var $76f8f1d5b5bbe4fc$export$21aaaa0607ee0e2b = {
    style: (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
        fill: true,
        stroke: true,
        fillOpacity: true,
        strokeOpacity: true,
        lineWidth: true,
        fontSize: true,
        lineHeight: true,
        width: true,
        height: true,
        textShadowColor: true,
        textShadowBlur: true,
        textShadowOffsetX: true,
        textShadowOffsetY: true,
        backgroundColor: true,
        padding: true,
        borderColor: true,
        borderWidth: true,
        borderRadius: true
    }, (0, $cfd8540aca1ca40f$export$9908943fb57fbe51).style)
};
var $76f8f1d5b5bbe4fc$var$ZRText = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ZRText, _super);
    function ZRText(opts) {
        var _this = _super.call(this) || this;
        _this.type = 'text';
        _this._children = [];
        _this._defaultStyle = $76f8f1d5b5bbe4fc$var$DEFAULT_RICH_TEXT_COLOR;
        _this.attr(opts);
        return _this;
    }
    ZRText.prototype.childrenRef = function() {
        return this._children;
    };
    ZRText.prototype.update = function() {
        _super.prototype.update.call(this);
        if (this.styleChanged()) this._updateSubTexts();
        for(var i = 0; i < this._children.length; i++){
            var child = this._children[i];
            child.zlevel = this.zlevel;
            child.z = this.z;
            child.z2 = this.z2;
            child.culling = this.culling;
            child.cursor = this.cursor;
            child.invisible = this.invisible;
        }
    };
    ZRText.prototype.updateTransform = function() {
        var innerTransformable = this.innerTransformable;
        if (innerTransformable) {
            innerTransformable.updateTransform();
            if (innerTransformable.transform) this.transform = innerTransformable.transform;
        } else _super.prototype.updateTransform.call(this);
    };
    ZRText.prototype.getLocalTransform = function(m) {
        var innerTransformable = this.innerTransformable;
        return innerTransformable ? innerTransformable.getLocalTransform(m) : _super.prototype.getLocalTransform.call(this, m);
    };
    ZRText.prototype.getComputedTransform = function() {
        if (this.__hostTarget) {
            this.__hostTarget.getComputedTransform();
            this.__hostTarget.updateInnerText(true);
        }
        return _super.prototype.getComputedTransform.call(this);
    };
    ZRText.prototype._updateSubTexts = function() {
        this._childCursor = 0;
        $76f8f1d5b5bbe4fc$export$176336068cc5371f(this.style);
        this.style.rich ? this._updateRichTexts() : this._updatePlainTexts();
        this._children.length = this._childCursor;
        this.styleUpdated();
    };
    ZRText.prototype.addSelfToZr = function(zr) {
        _super.prototype.addSelfToZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = zr;
    };
    ZRText.prototype.removeSelfFromZr = function(zr) {
        _super.prototype.removeSelfFromZr.call(this, zr);
        for(var i = 0; i < this._children.length; i++)this._children[i].__zr = null;
    };
    ZRText.prototype.getBoundingRect = function() {
        if (this.styleChanged()) this._updateSubTexts();
        if (!this._rect) {
            var tmpRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
            var children = this._children;
            var tmpMat = [];
            var rect = null;
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                var childRect = child.getBoundingRect();
                var transform = child.getLocalTransform(tmpMat);
                if (transform) {
                    tmpRect.copy(childRect);
                    tmpRect.applyTransform(transform);
                    rect = rect || tmpRect.clone();
                    rect.union(tmpRect);
                } else {
                    rect = rect || childRect.clone();
                    rect.union(childRect);
                }
            }
            this._rect = rect || tmpRect;
        }
        return this._rect;
    };
    ZRText.prototype.setDefaultTextStyle = function(defaultTextStyle) {
        this._defaultStyle = defaultTextStyle || $76f8f1d5b5bbe4fc$var$DEFAULT_RICH_TEXT_COLOR;
    };
    ZRText.prototype.setTextContent = function(textContent) {};
    ZRText.prototype._mergeStyle = function(targetStyle, sourceStyle) {
        if (!sourceStyle) return targetStyle;
        var sourceRich = sourceStyle.rich;
        var targetRich = targetStyle.rich || sourceRich && {};
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(targetStyle, sourceStyle);
        if (sourceRich && targetRich) {
            this._mergeRich(targetRich, sourceRich);
            targetStyle.rich = targetRich;
        } else if (targetRich) targetStyle.rich = targetRich;
        return targetStyle;
    };
    ZRText.prototype._mergeRich = function(targetRich, sourceRich) {
        var richNames = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(sourceRich);
        for(var i = 0; i < richNames.length; i++){
            var richName = richNames[i];
            targetRich[richName] = targetRich[richName] || {};
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(targetRich[richName], sourceRich[richName]);
        }
    };
    ZRText.prototype.getAnimationStyleProps = function() {
        return $76f8f1d5b5bbe4fc$export$21aaaa0607ee0e2b;
    };
    ZRText.prototype._getOrCreateChild = function(Ctor) {
        var child = this._children[this._childCursor];
        if (!child || !(child instanceof Ctor)) child = new Ctor();
        this._children[this._childCursor++] = child;
        child.__zr = this.__zr;
        child.parent = this;
        return child;
    };
    ZRText.prototype._updatePlainTexts = function() {
        var style = this.style;
        var textFont = style.font || (0, $024b63ea846a8ccd$export$7d7a232b6d2cc80c);
        var textPadding = style.padding;
        var text = $76f8f1d5b5bbe4fc$var$getStyleText(style);
        var contentBlock = (0, $39dcac9902a4af34$export$5772575e34ef80f9)(text, style);
        var needDrawBg = $76f8f1d5b5bbe4fc$var$needDrawBackground(style);
        var bgColorDrawn = !!style.backgroundColor;
        var outerHeight = contentBlock.outerHeight;
        var outerWidth = contentBlock.outerWidth;
        var contentWidth = contentBlock.contentWidth;
        var textLines = contentBlock.lines;
        var lineHeight = contentBlock.lineHeight;
        var defaultStyle = this._defaultStyle;
        this.isTruncated = !!contentBlock.isTruncated;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var textAlign = style.align || defaultStyle.align || 'left';
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign || 'top';
        var textX = baseX;
        var textY = (0, $297531217517fbce$export$bf7d6802d2badd9)(baseY, contentBlock.contentHeight, verticalAlign);
        if (needDrawBg || textPadding) {
            var boxX = (0, $297531217517fbce$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
            var boxY = (0, $297531217517fbce$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
            needDrawBg && this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        }
        textY += lineHeight / 2;
        if (textPadding) {
            textX = $76f8f1d5b5bbe4fc$var$getTextXForPadding(baseX, textAlign, textPadding);
            if (verticalAlign === 'top') textY += textPadding[0];
            else if (verticalAlign === 'bottom') textY -= textPadding[2];
        }
        var defaultLineWidth = 0;
        var useDefaultFill = false;
        var textFill = $76f8f1d5b5bbe4fc$var$getFill('fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $76f8f1d5b5bbe4fc$var$getStroke('stroke' in style ? style.stroke : !bgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $76f8f1d5b5bbe4fc$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = style.textShadowBlur > 0;
        var fixedBoundingRect = style.width != null && (style.overflow === 'truncate' || style.overflow === 'break' || style.overflow === 'breakAll');
        var calculatedLineHeight = contentBlock.calculatedLineHeight;
        for(var i = 0; i < textLines.length; i++){
            var el = this._getOrCreateChild((0, $d14badf4d84ba4b7$export$2e2bcd8739ae039));
            var subElStyle = el.createStyle();
            el.useStyle(subElStyle);
            subElStyle.text = textLines[i];
            subElStyle.x = textX;
            subElStyle.y = textY;
            if (textAlign) subElStyle.textAlign = textAlign;
            subElStyle.textBaseline = 'middle';
            subElStyle.opacity = style.opacity;
            subElStyle.strokeFirst = true;
            if (hasShadow) {
                subElStyle.shadowBlur = style.textShadowBlur || 0;
                subElStyle.shadowColor = style.textShadowColor || 'transparent';
                subElStyle.shadowOffsetX = style.textShadowOffsetX || 0;
                subElStyle.shadowOffsetY = style.textShadowOffsetY || 0;
            }
            subElStyle.stroke = textStroke;
            subElStyle.fill = textFill;
            if (textStroke) {
                subElStyle.lineWidth = style.lineWidth || defaultLineWidth;
                subElStyle.lineDash = style.lineDash;
                subElStyle.lineDashOffset = style.lineDashOffset || 0;
            }
            subElStyle.font = textFont;
            $76f8f1d5b5bbe4fc$var$setSeparateFont(subElStyle, style);
            textY += lineHeight;
            if (fixedBoundingRect) el.setBoundingRect(new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)((0, $297531217517fbce$export$eb5a525ef00ef9a4)(subElStyle.x, contentWidth, subElStyle.textAlign), (0, $297531217517fbce$export$bf7d6802d2badd9)(subElStyle.y, calculatedLineHeight, subElStyle.textBaseline), contentWidth, calculatedLineHeight));
        }
    };
    ZRText.prototype._updateRichTexts = function() {
        var style = this.style;
        var text = $76f8f1d5b5bbe4fc$var$getStyleText(style);
        var contentBlock = (0, $39dcac9902a4af34$export$15ec9472ff2d721)(text, style);
        var contentWidth = contentBlock.width;
        var outerWidth = contentBlock.outerWidth;
        var outerHeight = contentBlock.outerHeight;
        var textPadding = style.padding;
        var baseX = style.x || 0;
        var baseY = style.y || 0;
        var defaultStyle = this._defaultStyle;
        var textAlign = style.align || defaultStyle.align;
        var verticalAlign = style.verticalAlign || defaultStyle.verticalAlign;
        this.isTruncated = !!contentBlock.isTruncated;
        var boxX = (0, $297531217517fbce$export$eb5a525ef00ef9a4)(baseX, outerWidth, textAlign);
        var boxY = (0, $297531217517fbce$export$bf7d6802d2badd9)(baseY, outerHeight, verticalAlign);
        var xLeft = boxX;
        var lineTop = boxY;
        if (textPadding) {
            xLeft += textPadding[3];
            lineTop += textPadding[0];
        }
        var xRight = xLeft + contentWidth;
        if ($76f8f1d5b5bbe4fc$var$needDrawBackground(style)) this._renderBackground(style, style, boxX, boxY, outerWidth, outerHeight);
        var bgColorDrawn = !!style.backgroundColor;
        for(var i = 0; i < contentBlock.lines.length; i++){
            var line = contentBlock.lines[i];
            var tokens = line.tokens;
            var tokenCount = tokens.length;
            var lineHeight = line.lineHeight;
            var remainedWidth = line.width;
            var leftIndex = 0;
            var lineXLeft = xLeft;
            var lineXRight = xRight;
            var rightIndex = tokenCount - 1;
            var token = void 0;
            while(leftIndex < tokenCount && (token = tokens[leftIndex], !token.align || token.align === 'left')){
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft, 'left', bgColorDrawn);
                remainedWidth -= token.width;
                lineXLeft += token.width;
                leftIndex++;
            }
            while(rightIndex >= 0 && (token = tokens[rightIndex], token.align === 'right')){
                this._placeToken(token, style, lineHeight, lineTop, lineXRight, 'right', bgColorDrawn);
                remainedWidth -= token.width;
                lineXRight -= token.width;
                rightIndex--;
            }
            lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - remainedWidth) / 2;
            while(leftIndex <= rightIndex){
                token = tokens[leftIndex];
                this._placeToken(token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center', bgColorDrawn);
                lineXLeft += token.width;
                leftIndex++;
            }
            lineTop += lineHeight;
        }
    };
    ZRText.prototype._placeToken = function(token, style, lineHeight, lineTop, x, textAlign, parentBgColorDrawn) {
        var tokenStyle = style.rich[token.styleName] || {};
        tokenStyle.text = token.text;
        var verticalAlign = token.verticalAlign;
        var y = lineTop + lineHeight / 2;
        if (verticalAlign === 'top') y = lineTop + token.height / 2;
        else if (verticalAlign === 'bottom') y = lineTop + lineHeight - token.height / 2;
        var needDrawBg = !token.isLineHolder && $76f8f1d5b5bbe4fc$var$needDrawBackground(tokenStyle);
        needDrawBg && this._renderBackground(tokenStyle, style, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
        var bgColorDrawn = !!tokenStyle.backgroundColor;
        var textPadding = token.textPadding;
        if (textPadding) {
            x = $76f8f1d5b5bbe4fc$var$getTextXForPadding(x, textAlign, textPadding);
            y -= token.height / 2 - textPadding[0] - token.innerHeight / 2;
        }
        var el = this._getOrCreateChild((0, $d14badf4d84ba4b7$export$2e2bcd8739ae039));
        var subElStyle = el.createStyle();
        el.useStyle(subElStyle);
        var defaultStyle = this._defaultStyle;
        var useDefaultFill = false;
        var defaultLineWidth = 0;
        var textFill = $76f8f1d5b5bbe4fc$var$getFill('fill' in tokenStyle ? tokenStyle.fill : 'fill' in style ? style.fill : (useDefaultFill = true, defaultStyle.fill));
        var textStroke = $76f8f1d5b5bbe4fc$var$getStroke('stroke' in tokenStyle ? tokenStyle.stroke : 'stroke' in style ? style.stroke : !bgColorDrawn && !parentBgColorDrawn && (!defaultStyle.autoStroke || useDefaultFill) ? (defaultLineWidth = $76f8f1d5b5bbe4fc$var$DEFAULT_STROKE_LINE_WIDTH, defaultStyle.stroke) : null);
        var hasShadow = tokenStyle.textShadowBlur > 0 || style.textShadowBlur > 0;
        subElStyle.text = token.text;
        subElStyle.x = x;
        subElStyle.y = y;
        if (hasShadow) {
            subElStyle.shadowBlur = tokenStyle.textShadowBlur || style.textShadowBlur || 0;
            subElStyle.shadowColor = tokenStyle.textShadowColor || style.textShadowColor || 'transparent';
            subElStyle.shadowOffsetX = tokenStyle.textShadowOffsetX || style.textShadowOffsetX || 0;
            subElStyle.shadowOffsetY = tokenStyle.textShadowOffsetY || style.textShadowOffsetY || 0;
        }
        subElStyle.textAlign = textAlign;
        subElStyle.textBaseline = 'middle';
        subElStyle.font = token.font || (0, $024b63ea846a8ccd$export$7d7a232b6d2cc80c);
        subElStyle.opacity = (0, $1b239fc9d3a2f8ae$export$2e94551289abb95b)(tokenStyle.opacity, style.opacity, 1);
        $76f8f1d5b5bbe4fc$var$setSeparateFont(subElStyle, tokenStyle);
        if (textStroke) {
            subElStyle.lineWidth = (0, $1b239fc9d3a2f8ae$export$2e94551289abb95b)(tokenStyle.lineWidth, style.lineWidth, defaultLineWidth);
            subElStyle.lineDash = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(tokenStyle.lineDash, style.lineDash);
            subElStyle.lineDashOffset = style.lineDashOffset || 0;
            subElStyle.stroke = textStroke;
        }
        if (textFill) subElStyle.fill = textFill;
        var textWidth = token.contentWidth;
        var textHeight = token.contentHeight;
        el.setBoundingRect(new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)((0, $297531217517fbce$export$eb5a525ef00ef9a4)(subElStyle.x, textWidth, subElStyle.textAlign), (0, $297531217517fbce$export$bf7d6802d2badd9)(subElStyle.y, textHeight, subElStyle.textBaseline), textWidth, textHeight));
    };
    ZRText.prototype._renderBackground = function(style, topStyle, x, y, width, height) {
        var textBackgroundColor = style.backgroundColor;
        var textBorderWidth = style.borderWidth;
        var textBorderColor = style.borderColor;
        var isImageBg = textBackgroundColor && textBackgroundColor.image;
        var isPlainOrGradientBg = textBackgroundColor && !isImageBg;
        var textBorderRadius = style.borderRadius;
        var self = this;
        var rectEl;
        var imgEl;
        if (isPlainOrGradientBg || style.lineHeight || textBorderWidth && textBorderColor) {
            rectEl = this._getOrCreateChild((0, $37476269d425e3f6$export$2e2bcd8739ae039));
            rectEl.useStyle(rectEl.createStyle());
            rectEl.style.fill = null;
            var rectShape = rectEl.shape;
            rectShape.x = x;
            rectShape.y = y;
            rectShape.width = width;
            rectShape.height = height;
            rectShape.r = textBorderRadius;
            rectEl.dirtyShape();
        }
        if (isPlainOrGradientBg) {
            var rectStyle = rectEl.style;
            rectStyle.fill = textBackgroundColor || null;
            rectStyle.fillOpacity = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(style.fillOpacity, 1);
        } else if (isImageBg) {
            imgEl = this._getOrCreateChild((0, $29f98103052059af$export$2e2bcd8739ae039));
            imgEl.onload = function() {
                self.dirtyStyle();
            };
            var imgStyle = imgEl.style;
            imgStyle.image = textBackgroundColor.image;
            imgStyle.x = x;
            imgStyle.y = y;
            imgStyle.width = width;
            imgStyle.height = height;
        }
        if (textBorderWidth && textBorderColor) {
            var rectStyle = rectEl.style;
            rectStyle.lineWidth = textBorderWidth;
            rectStyle.stroke = textBorderColor;
            rectStyle.strokeOpacity = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(style.strokeOpacity, 1);
            rectStyle.lineDash = style.borderDash;
            rectStyle.lineDashOffset = style.borderDashOffset || 0;
            rectEl.strokeContainThreshold = 0;
            if (rectEl.hasFill() && rectEl.hasStroke()) {
                rectStyle.strokeFirst = true;
                rectStyle.lineWidth *= 2;
            }
        }
        var commonStyle = (rectEl || imgEl).style;
        commonStyle.shadowBlur = style.shadowBlur || 0;
        commonStyle.shadowColor = style.shadowColor || 'transparent';
        commonStyle.shadowOffsetX = style.shadowOffsetX || 0;
        commonStyle.shadowOffsetY = style.shadowOffsetY || 0;
        commonStyle.opacity = (0, $1b239fc9d3a2f8ae$export$2e94551289abb95b)(style.opacity, topStyle.opacity, 1);
    };
    ZRText.makeFont = function(style) {
        var font = '';
        if ($76f8f1d5b5bbe4fc$export$4685c95d5118e76a(style)) font = [
            style.fontStyle,
            style.fontWeight,
            $76f8f1d5b5bbe4fc$export$51b066d9cfc2578e(style.fontSize),
            style.fontFamily || 'sans-serif'
        ].join(' ');
        return font && (0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(font) || style.textFont || style.font;
    };
    return ZRText;
}((0, $cfd8540aca1ca40f$export$2e2bcd8739ae039));
var $76f8f1d5b5bbe4fc$var$VALID_TEXT_ALIGN = {
    left: true,
    right: 1,
    center: 1
};
var $76f8f1d5b5bbe4fc$var$VALID_TEXT_VERTICAL_ALIGN = {
    top: 1,
    bottom: 1,
    middle: 1
};
var $76f8f1d5b5bbe4fc$var$FONT_PARTS = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily'
];
function $76f8f1d5b5bbe4fc$export$51b066d9cfc2578e(fontSize) {
    if (typeof fontSize === 'string' && (fontSize.indexOf('px') !== -1 || fontSize.indexOf('rem') !== -1 || fontSize.indexOf('em') !== -1)) return fontSize;
    else if (!isNaN(+fontSize)) return fontSize + 'px';
    else return (0, $024b63ea846a8ccd$export$b1461457ea2c1179) + 'px';
}
function $76f8f1d5b5bbe4fc$var$setSeparateFont(targetStyle, sourceStyle) {
    for(var i = 0; i < $76f8f1d5b5bbe4fc$var$FONT_PARTS.length; i++){
        var fontProp = $76f8f1d5b5bbe4fc$var$FONT_PARTS[i];
        var val = sourceStyle[fontProp];
        if (val != null) targetStyle[fontProp] = val;
    }
}
function $76f8f1d5b5bbe4fc$export$4685c95d5118e76a(style) {
    return style.fontSize != null || style.fontFamily || style.fontWeight;
}
function $76f8f1d5b5bbe4fc$export$176336068cc5371f(style) {
    $76f8f1d5b5bbe4fc$var$normalizeStyle(style);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(style.rich, $76f8f1d5b5bbe4fc$var$normalizeStyle);
    return style;
}
function $76f8f1d5b5bbe4fc$var$normalizeStyle(style) {
    if (style) {
        style.font = $76f8f1d5b5bbe4fc$var$ZRText.makeFont(style);
        var textAlign = style.align;
        textAlign === 'middle' && (textAlign = 'center');
        style.align = textAlign == null || $76f8f1d5b5bbe4fc$var$VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left';
        var verticalAlign = style.verticalAlign;
        verticalAlign === 'center' && (verticalAlign = 'middle');
        style.verticalAlign = verticalAlign == null || $76f8f1d5b5bbe4fc$var$VALID_TEXT_VERTICAL_ALIGN[verticalAlign] ? verticalAlign : 'top';
        var textPadding = style.padding;
        if (textPadding) style.padding = (0, $1b239fc9d3a2f8ae$export$f3a38102c49f4268)(style.padding);
    }
}
function $76f8f1d5b5bbe4fc$var$getStroke(stroke, lineWidth) {
    return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null : stroke.image || stroke.colorStops ? '#000' : stroke;
}
function $76f8f1d5b5bbe4fc$var$getFill(fill) {
    return fill == null || fill === 'none' ? null : fill.image || fill.colorStops ? '#000' : fill;
}
function $76f8f1d5b5bbe4fc$var$getTextXForPadding(x, textAlign, textPadding) {
    return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
}
function $76f8f1d5b5bbe4fc$var$getStyleText(style) {
    var text = style.text;
    text != null && (text += '');
    return text;
}
function $76f8f1d5b5bbe4fc$var$needDrawBackground(style) {
    return !!(style.backgroundColor || style.lineHeight || style.borderWidth && style.borderColor);
}
var $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039 = $76f8f1d5b5bbe4fc$var$ZRText;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $ea063383a2a89e3f$export$b1c39b2bacd1ddc2 = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $ea063383a2a89e3f$export$30d6736ebb8e18d5 = function(seriesIndex, dataType, dataIdx, el) {
    if (el) {
        var ecData = $ea063383a2a89e3f$export$b1c39b2bacd1ddc2(el);
        // Add data index and series index for indexing the data by element
        // Useful in tooltip
        ecData.dataIndex = dataIdx;
        ecData.dataType = dataType;
        ecData.seriesIndex = seriesIndex;
        ecData.ssrType = 'chart';
        // TODO: not store dataIndex on children.
        if (el.type === 'group') el.traverse(function(child) {
            var childECData = $ea063383a2a89e3f$export$b1c39b2bacd1ddc2(child);
            childECData.seriesIndex = seriesIndex;
            childECData.dataIndex = dataIdx;
            childECData.dataType = dataType;
            childECData.ssrType = 'chart';
        });
    }
};






// Reserve 0 as default.
var $b414df7d361a211c$var$_highlightNextDigit = 1;
var $b414df7d361a211c$var$_highlightKeyMap = {};
var $b414df7d361a211c$var$getSavedStates = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $b414df7d361a211c$var$getComponentStates = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $b414df7d361a211c$export$5542daa30722333e = 0;
var $b414df7d361a211c$export$1307d6a87d56baa = 1;
var $b414df7d361a211c$export$f0f2bee145debb31 = 2;
var $b414df7d361a211c$export$151308dceb52d5b = [
    'emphasis',
    'blur',
    'select'
];
var $b414df7d361a211c$export$57ee5306b85ad7d5 = [
    'normal',
    'emphasis',
    'blur',
    'select'
];
var $b414df7d361a211c$export$1cb9fc6ed5b9836c = 10;
var $b414df7d361a211c$export$3a2f97d39514bbc = 9;
var $b414df7d361a211c$export$df035d873a9de64f = 'highlight';
var $b414df7d361a211c$export$f8a2f7807cc185ea = 'downplay';
var $b414df7d361a211c$export$89616263e7d38fe9 = 'select';
var $b414df7d361a211c$export$7636ad95c0f68a79 = 'unselect';
var $b414df7d361a211c$export$1e90ed8a25542516 = 'toggleSelect';
function $b414df7d361a211c$var$hasFillOrStroke(fillOrStroke) {
    return fillOrStroke != null && fillOrStroke !== 'none';
}
function $b414df7d361a211c$var$doChangeHoverState(el, stateName, hoverStateEnum) {
    if (el.onHoverStateChange && (el.hoverState || 0) !== hoverStateEnum) el.onHoverStateChange(stateName);
    el.hoverState = hoverStateEnum;
}
function $b414df7d361a211c$var$singleEnterEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    $b414df7d361a211c$var$doChangeHoverState(el, 'emphasis', $b414df7d361a211c$export$f0f2bee145debb31);
}
function $b414df7d361a211c$var$singleLeaveEmphasis(el) {
    // Only mark the flag.
    // States will be applied in the echarts.ts in next frame.
    if (el.hoverState === $b414df7d361a211c$export$f0f2bee145debb31) $b414df7d361a211c$var$doChangeHoverState(el, 'normal', $b414df7d361a211c$export$5542daa30722333e);
}
function $b414df7d361a211c$var$singleEnterBlur(el) {
    $b414df7d361a211c$var$doChangeHoverState(el, 'blur', $b414df7d361a211c$export$1307d6a87d56baa);
}
function $b414df7d361a211c$var$singleLeaveBlur(el) {
    if (el.hoverState === $b414df7d361a211c$export$1307d6a87d56baa) $b414df7d361a211c$var$doChangeHoverState(el, 'normal', $b414df7d361a211c$export$5542daa30722333e);
}
function $b414df7d361a211c$var$singleEnterSelect(el) {
    el.selected = true;
}
function $b414df7d361a211c$var$singleLeaveSelect(el) {
    el.selected = false;
}
function $b414df7d361a211c$var$updateElementState(el, updater, commonParam) {
    updater(el, commonParam);
}
function $b414df7d361a211c$var$traverseUpdateState(el, updater, commonParam) {
    $b414df7d361a211c$var$updateElementState(el, updater, commonParam);
    el.isGroup && el.traverse(function(child) {
        $b414df7d361a211c$var$updateElementState(child, updater, commonParam);
    });
}
function $b414df7d361a211c$export$868ba38adffa9e39(el, stateName) {
    switch(stateName){
        case 'emphasis':
            el.hoverState = $b414df7d361a211c$export$f0f2bee145debb31;
            break;
        case 'normal':
            el.hoverState = $b414df7d361a211c$export$5542daa30722333e;
            break;
        case 'blur':
            el.hoverState = $b414df7d361a211c$export$1307d6a87d56baa;
            break;
        case 'select':
            el.selected = true;
    }
}
function $b414df7d361a211c$export$35330f949342a669(el) {
    if (el.isGroup) el.traverse(function(child) {
        child.clearStates();
    });
    else el.clearStates();
}
function $b414df7d361a211c$var$getFromStateStyle(el, props, toStateName, defaultValue) {
    var style = el.style;
    var fromState = {};
    for(var i = 0; i < props.length; i++){
        var propName = props[i];
        var val = style[propName];
        fromState[propName] = val == null ? defaultValue && defaultValue[propName] : val;
    }
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.__fromStateTransition && animator.__fromStateTransition.indexOf(toStateName) < 0 && animator.targetName === 'style') animator.saveTo(fromState, props);
    }
    return fromState;
}
function $b414df7d361a211c$var$createEmphasisDefaultState(el, stateName, targetStates, state) {
    var hasSelect = targetStates && (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(targetStates, 'select') >= 0;
    var cloned = false;
    if (el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039)) {
        var store = $b414df7d361a211c$var$getSavedStates(el);
        var fromFill = hasSelect ? store.selectFill || store.normalFill : store.normalFill;
        var fromStroke = hasSelect ? store.selectStroke || store.normalStroke : store.normalStroke;
        if ($b414df7d361a211c$var$hasFillOrStroke(fromFill) || $b414df7d361a211c$var$hasFillOrStroke(fromStroke)) {
            state = state || {};
            var emphasisStyle = state.style || {};
            // inherit case
            if (emphasisStyle.fill === 'inherit') {
                cloned = true;
                state = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, emphasisStyle);
                emphasisStyle.fill = fromFill;
            } else if (!$b414df7d361a211c$var$hasFillOrStroke(emphasisStyle.fill) && $b414df7d361a211c$var$hasFillOrStroke(fromFill)) {
                cloned = true;
                // Not modify the original value.
                state = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, state);
                emphasisStyle = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, emphasisStyle);
                // Already being applied 'emphasis'. DON'T lift color multiple times.
                emphasisStyle.fill = (0, $35573db24643e2ef$export$2b47e247dfb87a73)(fromFill);
            } else if (!$b414df7d361a211c$var$hasFillOrStroke(emphasisStyle.stroke) && $b414df7d361a211c$var$hasFillOrStroke(fromStroke)) {
                if (!cloned) {
                    state = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, state);
                    emphasisStyle = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, emphasisStyle);
                }
                emphasisStyle.stroke = (0, $35573db24643e2ef$export$2b47e247dfb87a73)(fromStroke);
            }
            state.style = emphasisStyle;
        }
    }
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            if (!cloned) state = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, state);
            var z2EmphasisLift = el.z2EmphasisLift;
            state.z2 = el.z2 + (z2EmphasisLift != null ? z2EmphasisLift : $b414df7d361a211c$export$1cb9fc6ed5b9836c);
        }
    }
    return state;
}
function $b414df7d361a211c$var$createSelectDefaultState(el, stateName, state) {
    // const hasSelect = indexOf(el.currentStates, stateName) >= 0;
    if (state) // TODO Share with textContent?
    {
        if (state.z2 == null) {
            state = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, state);
            var z2SelectLift = el.z2SelectLift;
            state.z2 = el.z2 + (z2SelectLift != null ? z2SelectLift : $b414df7d361a211c$export$3a2f97d39514bbc);
        }
    }
    return state;
}
function $b414df7d361a211c$var$createBlurDefaultState(el, stateName, state) {
    var hasBlur = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(el.currentStates, stateName) >= 0;
    var currentOpacity = el.style.opacity;
    var fromState = !hasBlur ? $b414df7d361a211c$var$getFromStateStyle(el, [
        'opacity'
    ], stateName, {
        opacity: 1
    }) : null;
    state = state || {};
    var blurStyle = state.style || {};
    if (blurStyle.opacity == null) {
        // clone state
        state = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, state);
        blurStyle = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
            // Already being applied 'emphasis'. DON'T mul opacity multiple times.
            opacity: hasBlur ? currentOpacity : fromState.opacity * 0.1
        }, blurStyle);
        state.style = blurStyle;
    }
    return state;
}
function $b414df7d361a211c$var$elementStateProxy(stateName, targetStates) {
    var state = this.states[stateName];
    if (this.style) {
        if (stateName === 'emphasis') return $b414df7d361a211c$var$createEmphasisDefaultState(this, stateName, targetStates, state);
        else if (stateName === 'blur') return $b414df7d361a211c$var$createBlurDefaultState(this, stateName, state);
        else if (stateName === 'select') return $b414df7d361a211c$var$createSelectDefaultState(this, stateName, state);
    }
    return state;
}
function $b414df7d361a211c$export$20f39bbe322fb9ab(el) {
    el.stateProxy = $b414df7d361a211c$var$elementStateProxy;
    var textContent = el.getTextContent();
    var textGuide = el.getTextGuideLine();
    if (textContent) textContent.stateProxy = $b414df7d361a211c$var$elementStateProxy;
    if (textGuide) textGuide.stateProxy = $b414df7d361a211c$var$elementStateProxy;
}
function $b414df7d361a211c$export$d899507e2598e4ae(el, e) {
    !$b414df7d361a211c$var$shouldSilent(el, e) && !el.__highByOuter && $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleEnterEmphasis);
}
function $b414df7d361a211c$export$784cba1f7fe58cca(el, e) {
    !$b414df7d361a211c$var$shouldSilent(el, e) && !el.__highByOuter && $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleLeaveEmphasis);
}
function $b414df7d361a211c$export$b2d02638cc34c042(el, highlightDigit) {
    el.__highByOuter |= 1 << (highlightDigit || 0);
    $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleEnterEmphasis);
}
function $b414df7d361a211c$export$11be6f716239ac55(el, highlightDigit) {
    !(el.__highByOuter &= ~(1 << (highlightDigit || 0))) && $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleLeaveEmphasis);
}
function $b414df7d361a211c$export$207f9cb3e1099375(el) {
    $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleEnterBlur);
}
function $b414df7d361a211c$export$fd4a9ec75456d3c1(el) {
    $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleLeaveBlur);
}
function $b414df7d361a211c$export$252d028dda8ef765(el) {
    $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleEnterSelect);
}
function $b414df7d361a211c$export$ea9a904bd6e32bd3(el) {
    $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$var$singleLeaveSelect);
}
function $b414df7d361a211c$var$shouldSilent(el, e) {
    return el.__highDownSilentOnTouch && e.zrByTouch;
}
function $b414df7d361a211c$export$b2a593c7b5243584(api) {
    var model = api.getModel();
    var leaveBlurredSeries = [];
    var allComponentViews = [];
    model.eachComponent(function(componentType, componentModel) {
        var componentStates = $b414df7d361a211c$var$getComponentStates(componentModel);
        var isSeries = componentType === 'series';
        var view = isSeries ? api.getViewOfSeriesModel(componentModel) : api.getViewOfComponentModel(componentModel);
        !isSeries && allComponentViews.push(view);
        if (componentStates.isBlured) {
            // Leave blur anyway
            view.group.traverse(function(child) {
                $b414df7d361a211c$var$singleLeaveBlur(child);
            });
            isSeries && leaveBlurredSeries.push(componentModel);
        }
        componentStates.isBlured = false;
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(allComponentViews, function(view) {
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(leaveBlurredSeries, false, model);
    });
}
function $b414df7d361a211c$export$7d399e067d6552e3(targetSeriesIndex, focus, blurScope, api) {
    var ecModel = api.getModel();
    blurScope = blurScope || 'coordinateSystem';
    function leaveBlurOfIndices(data, dataIndices) {
        for(var i = 0; i < dataIndices.length; i++){
            var itemEl = data.getItemGraphicEl(dataIndices[i]);
            itemEl && $b414df7d361a211c$export$fd4a9ec75456d3c1(itemEl);
        }
    }
    if (targetSeriesIndex == null) return;
    if (!focus || focus === 'none') return;
    var targetSeriesModel = ecModel.getSeriesByIndex(targetSeriesIndex);
    var targetCoordSys = targetSeriesModel.coordinateSystem;
    if (targetCoordSys && targetCoordSys.master) targetCoordSys = targetCoordSys.master;
    var blurredSeries = [];
    ecModel.eachSeries(function(seriesModel) {
        var sameSeries = targetSeriesModel === seriesModel;
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.master) coordSys = coordSys.master;
        var sameCoordSys = coordSys && targetCoordSys ? coordSys === targetCoordSys : sameSeries; // If there is no coordinate system. use sameSeries instead.
        if (!// Not blur other series if blurScope series
        (blurScope === 'series' && !sameSeries || blurScope === 'coordinateSystem' && !sameCoordSys || focus === 'series' && sameSeries)) {
            var view = api.getViewOfSeriesModel(seriesModel);
            view.group.traverse(function(child) {
                // For the elements that have been triggered by other components,
                // and are still required to be highlighted,
                // because the current is directly forced to blur the element,
                // it will cause the focus self to be unable to highlight, so skip the blur of this element.
                if (child.__highByOuter && sameSeries && focus === 'self') return;
                $b414df7d361a211c$var$singleEnterBlur(child);
            });
            if ((0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(focus)) leaveBlurOfIndices(seriesModel.getData(), focus);
            else if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(focus)) {
                var dataTypes = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(focus);
                for(var d = 0; d < dataTypes.length; d++)leaveBlurOfIndices(seriesModel.getData(dataTypes[d]), focus[dataTypes[d]]);
            }
            blurredSeries.push(seriesModel);
            $b414df7d361a211c$var$getComponentStates(seriesModel).isBlured = true;
        }
    });
    ecModel.eachComponent(function(componentType, componentModel) {
        if (componentType === 'series') return;
        var view = api.getViewOfComponentModel(componentModel);
        if (view && view.toggleBlurSeries) view.toggleBlurSeries(blurredSeries, true, ecModel);
    });
}
function $b414df7d361a211c$export$569da03256c8a55f(componentMainType, componentIndex, api) {
    if (componentMainType == null || componentIndex == null) return;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return;
    $b414df7d361a211c$var$getComponentStates(componentModel).isBlured = true;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.focusBlurEnabled) return;
    view.group.traverse(function(child) {
        $b414df7d361a211c$var$singleEnterBlur(child);
    });
}
function $b414df7d361a211c$export$64f1fd4daefef21b(seriesModel, payload, api) {
    var seriesIndex = seriesModel.seriesIndex;
    var data = seriesModel.getData(payload.dataType);
    if (!data) return;
    var dataIndex = (0, $9ac03c46e8b6e711$export$42b26cae8b8d10)(data, payload);
    // Pick the first one if there is multiple/none exists.
    dataIndex = ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(dataIndex) ? dataIndex[0] : dataIndex) || 0;
    var el = data.getItemGraphicEl(dataIndex);
    if (!el) {
        var count = data.count();
        var current = 0;
        // If data on dataIndex is NaN.
        while(!el && current < count)el = data.getItemGraphicEl(current++);
    }
    if (el) {
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
        $b414df7d361a211c$export$7d399e067d6552e3(seriesIndex, ecData.focus, ecData.blurScope, api);
    } else {
        // If there is no element put on the data. Try getting it from raw option
        // TODO Should put it on seriesModel?
        var focus_1 = seriesModel.get([
            'emphasis',
            'focus'
        ]);
        var blurScope = seriesModel.get([
            'emphasis',
            'blurScope'
        ]);
        if (focus_1 != null) $b414df7d361a211c$export$7d399e067d6552e3(seriesIndex, focus_1, blurScope, api);
    }
}
function $b414df7d361a211c$export$f31a644ccca0ef23(componentMainType, componentIndex, name, api) {
    var ret = {
        focusSelf: false,
        dispatchers: null
    };
    if (componentMainType == null || componentMainType === 'series' || componentIndex == null || name == null) return ret;
    var componentModel = api.getModel().getComponent(componentMainType, componentIndex);
    if (!componentModel) return ret;
    var view = api.getViewOfComponentModel(componentModel);
    if (!view || !view.findHighDownDispatchers) return ret;
    var dispatchers = view.findHighDownDispatchers(name);
    // At presnet, the component (like Geo) only blur inside itself.
    // So we do not use `blurScope` in component.
    var focusSelf;
    for(var i = 0; i < dispatchers.length; i++)if ((0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(dispatchers[i]).focus === 'self') {
        focusSelf = true;
        break;
    }
    return {
        focusSelf: focusSelf,
        dispatchers: dispatchers
    };
}
function $b414df7d361a211c$export$416765b6198234ff(dispatcher, e, api) {
    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(dispatcher);
    var _a = $b414df7d361a211c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api), dispatchers = _a.dispatchers, focusSelf = _a.focusSelf;
    // If `findHighDownDispatchers` is supported on the component,
    // highlight/downplay elements with the same name.
    if (dispatchers) {
        if (focusSelf) $b414df7d361a211c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
            return $b414df7d361a211c$export$d899507e2598e4ae(dispatcher, e);
        });
    } else {
        // Try blur all in the related series. Then emphasis the hoverred.
        // TODO. progressive mode.
        $b414df7d361a211c$export$7d399e067d6552e3(ecData.seriesIndex, ecData.focus, ecData.blurScope, api);
        if (ecData.focus === 'self') $b414df7d361a211c$export$569da03256c8a55f(ecData.componentMainType, ecData.componentIndex, api);
        // Other than series, component that not support `findHighDownDispatcher` will
        // also use it. But in this case, highlight/downplay are only supported in
        // mouse hover but not in dispatchAction.
        $b414df7d361a211c$export$d899507e2598e4ae(dispatcher, e);
    }
}
function $b414df7d361a211c$export$bb1c7b62436282a(dispatcher, e, api) {
    $b414df7d361a211c$export$b2a593c7b5243584(api);
    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(dispatcher);
    var dispatchers = $b414df7d361a211c$export$f31a644ccca0ef23(ecData.componentMainType, ecData.componentIndex, ecData.componentHighDownName, api).dispatchers;
    if (dispatchers) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
        return $b414df7d361a211c$export$784cba1f7fe58cca(dispatcher, e);
    });
    else $b414df7d361a211c$export$784cba1f7fe58cca(dispatcher, e);
}
function $b414df7d361a211c$export$1c7d489f62372d73(seriesModel, payload, api) {
    if (!$b414df7d361a211c$export$72aea10e60e45351(payload)) return;
    var dataType = payload.dataType;
    var data = seriesModel.getData(dataType);
    var dataIndex = (0, $9ac03c46e8b6e711$export$42b26cae8b8d10)(data, payload);
    if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(dataIndex)) dataIndex = [
        dataIndex
    ];
    seriesModel[payload.type === $b414df7d361a211c$export$1e90ed8a25542516 ? 'toggleSelect' : payload.type === $b414df7d361a211c$export$89616263e7d38fe9 ? 'select' : 'unselect'](dataIndex, dataType);
}
function $b414df7d361a211c$export$e4ea08ef52e0a73(seriesModel) {
    var allData = seriesModel.getAllData();
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(allData, function(_a) {
        var data = _a.data, type = _a.type;
        data.eachItemGraphicEl(function(el, idx) {
            seriesModel.isSelected(idx, type) ? $b414df7d361a211c$export$252d028dda8ef765(el) : $b414df7d361a211c$export$ea9a904bd6e32bd3(el);
        });
    });
}
function $b414df7d361a211c$export$c529643b619af6b3(ecModel) {
    var ret = [];
    ecModel.eachSeries(function(seriesModel) {
        var allData = seriesModel.getAllData();
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(allData, function(_a) {
            var data = _a.data, type = _a.type;
            var dataIndices = seriesModel.getSelectedDataIndices();
            if (dataIndices.length > 0) {
                var item = {
                    dataIndex: dataIndices,
                    seriesIndex: seriesModel.seriesIndex
                };
                if (type != null) item.dataType = type;
                ret.push(item);
            }
        });
    });
    return ret;
}
function $b414df7d361a211c$export$5f393df0b5aee2e7(el, focus, blurScope) {
    $b414df7d361a211c$export$9ba15aea1e048d48(el, true);
    $b414df7d361a211c$var$traverseUpdateState(el, $b414df7d361a211c$export$20f39bbe322fb9ab);
    $b414df7d361a211c$export$24972466b2b62ac2(el, focus, blurScope);
}
function $b414df7d361a211c$export$912cae7b47c8e437(el) {
    $b414df7d361a211c$export$9ba15aea1e048d48(el, false);
}
function $b414df7d361a211c$export$e51187539ff11209(el, focus, blurScope, isDisabled) {
    isDisabled ? $b414df7d361a211c$export$912cae7b47c8e437(el) : $b414df7d361a211c$export$5f393df0b5aee2e7(el, focus, blurScope);
}
function $b414df7d361a211c$export$24972466b2b62ac2(el, focus, blurScope) {
    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
    if (focus != null) {
        // TODO dataIndex may be set after this function. This check is not useful.
        // if (ecData.dataIndex == null) {
        //     if (__DEV__) {
        //         console.warn('focus can only been set on element with dataIndex');
        //     }
        // }
        // else {
        ecData.focus = focus;
        ecData.blurScope = blurScope;
    // }
    } else if (ecData.focus) ecData.focus = null;
}
var $b414df7d361a211c$var$OTHER_STATES = [
    'emphasis',
    'blur',
    'select'
];
var $b414df7d361a211c$var$defaultStyleGetterMap = {
    itemStyle: 'getItemStyle',
    lineStyle: 'getLineStyle',
    areaStyle: 'getAreaStyle'
};
function $b414df7d361a211c$export$48b68047d330bbc9(el, itemModel, styleType, // default itemStyle
getter) {
    styleType = styleType || 'itemStyle';
    for(var i = 0; i < $b414df7d361a211c$var$OTHER_STATES.length; i++){
        var stateName = $b414df7d361a211c$var$OTHER_STATES[i];
        var model = itemModel.getModel([
            stateName,
            styleType
        ]);
        var state = el.ensureState(stateName);
        // Let it throw error if getterType is not found.
        state.style = getter ? getter(model) : model[$b414df7d361a211c$var$defaultStyleGetterMap[styleType]]();
    }
}
function $b414df7d361a211c$export$9ba15aea1e048d48(el, asDispatcher) {
    var disable = asDispatcher === false;
    var extendedEl = el;
    // Make `highDownSilentOnTouch` and `onStateChange` only work after
    // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
    if (el.highDownSilentOnTouch) extendedEl.__highDownSilentOnTouch = el.highDownSilentOnTouch;
    // Simple optimize, since this method might be
    // called for each elements of a group in some cases.
    if (!disable || extendedEl.__highDownDispatcher) {
        // Emphasis, normal can be triggered manually by API or other components like hover link.
        // el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent);
        // Also keep previous record.
        extendedEl.__highByOuter = extendedEl.__highByOuter || 0;
        extendedEl.__highDownDispatcher = !disable;
    }
}
function $b414df7d361a211c$export$77d1445f699c58b5(el) {
    return !!(el && el.__highDownDispatcher);
}
function $b414df7d361a211c$export$4da05a9639f01954(el, componentModel, componentHighDownName) {
    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
    ecData.componentMainType = componentModel.mainType;
    ecData.componentIndex = componentModel.componentIndex;
    ecData.componentHighDownName = componentHighDownName;
}
function $b414df7d361a211c$export$824af40eb714530d(highlightKey) {
    var highlightDigit = $b414df7d361a211c$var$_highlightKeyMap[highlightKey];
    if (highlightDigit == null && $b414df7d361a211c$var$_highlightNextDigit <= 32) highlightDigit = $b414df7d361a211c$var$_highlightKeyMap[highlightKey] = $b414df7d361a211c$var$_highlightNextDigit++;
    return highlightDigit;
}
function $b414df7d361a211c$export$72aea10e60e45351(payload) {
    var payloadType = payload.type;
    return payloadType === $b414df7d361a211c$export$89616263e7d38fe9 || payloadType === $b414df7d361a211c$export$7636ad95c0f68a79 || payloadType === $b414df7d361a211c$export$1e90ed8a25542516;
}
function $b414df7d361a211c$export$aebe71265c1b77bf(payload) {
    var payloadType = payload.type;
    return payloadType === $b414df7d361a211c$export$df035d873a9de64f || payloadType === $b414df7d361a211c$export$f8a2f7807cc185ea;
}
function $b414df7d361a211c$export$9fe78019e6f395b6(el) {
    var store = $b414df7d361a211c$var$getSavedStates(el);
    store.normalFill = el.style.fill;
    store.normalStroke = el.style.stroke;
    var selectState = el.states.select || {};
    store.selectFill = selectState.style && selectState.style.fill || null;
    store.selectStroke = selectState.style && selectState.style.stroke || null;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $b40111164617dd60$export$ae7433df314f6ec3 = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $b40111164617dd60$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, // Extra opts can override the option in animatable model.
extraOpts, // TODO It's only for pictorial bar now.
extraDelayParams) {
    var animationPayload;
    // Check if there is global animation configuration from dataZoom/resize can override the config in option.
    // If animation is enabled. Will use this animation config in payload.
    // If animation is disabled. Just ignore it.
    if (animatableModel && animatableModel.ecModel) {
        var updatePayload = animatableModel.ecModel.getUpdatePayload();
        animationPayload = updatePayload && updatePayload.animation;
    }
    var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
    var isUpdate = animationType === 'update';
    if (animationEnabled) {
        var duration = void 0;
        var easing = void 0;
        var delay = void 0;
        if (extraOpts) {
            duration = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(extraOpts.duration, 200);
            easing = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(extraOpts.easing, 'cubicOut');
            delay = 0;
        } else {
            duration = animatableModel.getShallow(isUpdate ? 'animationDurationUpdate' : 'animationDuration');
            easing = animatableModel.getShallow(isUpdate ? 'animationEasingUpdate' : 'animationEasing');
            delay = animatableModel.getShallow(isUpdate ? 'animationDelayUpdate' : 'animationDelay');
        }
        // animation from payload has highest priority.
        if (animationPayload) {
            animationPayload.duration != null && (duration = animationPayload.duration);
            animationPayload.easing != null && (easing = animationPayload.easing);
            animationPayload.delay != null && (delay = animationPayload.delay);
        }
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(delay)) delay = delay(dataIndex, extraDelayParams);
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(duration)) duration = duration(dataIndex);
        var config = {
            duration: duration || 0,
            delay: delay,
            easing: easing
        };
        return config;
    } else return null;
}
function $b40111164617dd60$var$animateOrSetProps(animationType, el, props, animatableModel, dataIndex, cb, during) {
    var isFrom = false;
    var removeOpt;
    if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(dataIndex)) {
        during = cb;
        cb = dataIndex;
        dataIndex = null;
    } else if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dataIndex)) {
        cb = dataIndex.cb;
        during = dataIndex.during;
        isFrom = dataIndex.isFrom;
        removeOpt = dataIndex.removeOpt;
        dataIndex = dataIndex.dataIndex;
    }
    var isRemove = animationType === 'leave';
    if (!isRemove) // Must stop the remove animation.
    el.stopAnimation('leave');
    var animationConfig = $b40111164617dd60$export$5cc7add7ab591d0a(animationType, animatableModel, dataIndex, isRemove ? removeOpt || {} : null, animatableModel && animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
    if (animationConfig && animationConfig.duration > 0) {
        var duration = animationConfig.duration;
        var animationDelay = animationConfig.delay;
        var animationEasing = animationConfig.easing;
        var animateConfig = {
            duration: duration,
            delay: animationDelay || 0,
            easing: animationEasing,
            done: cb,
            force: !!cb || !!during,
            // Set to final state in update/init animation.
            // So the post processing based on the path shape can be done correctly.
            setToFinal: !isRemove,
            scope: animationType,
            during: during
        };
        isFrom ? el.animateFrom(props, animateConfig) : el.animateTo(props, animateConfig);
    } else {
        el.stopAnimation();
        // If `isFrom`, the props is the "from" props.
        !isFrom && el.attr(props);
        // Call during at least once.
        during && during(1);
        cb && cb();
    }
}
/**
 * Update graphic element properties with or without animation according to the
 * configuration in series.
 *
 * Caution: this method will stop previous animation.
 * So do not use this method to one element twice before
 * animation starts, unless you know what you are doing.
 * @example
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
 *     // Or
 *     graphic.updateProps(el, {
 *         position: [100, 100]
 *     }, seriesModel, function () { console.log('Animation done!'); });
 */ function $b40111164617dd60$export$c8dce3c08436e91e(el, props, // TODO: TYPE AnimatableModel
animatableModel, dataIndex, cb, during) {
    $b40111164617dd60$var$animateOrSetProps('update', el, props, animatableModel, dataIndex, cb, during);
}
function $b40111164617dd60$export$a121566aadcfe021(el, props, animatableModel, dataIndex, cb, during) {
    $b40111164617dd60$var$animateOrSetProps('enter', el, props, animatableModel, dataIndex, cb, during);
}
function $b40111164617dd60$export$5b89d4b643713034(el) {
    if (!el.__zr) return true;
    for(var i = 0; i < el.animators.length; i++){
        var animator = el.animators[i];
        if (animator.scope === 'leave') return true;
    }
    return false;
}
function $b40111164617dd60$export$f883456a56996078(el, props, animatableModel, dataIndex, cb, during) {
    // Don't do remove animation twice.
    if ($b40111164617dd60$export$5b89d4b643713034(el)) return;
    $b40111164617dd60$var$animateOrSetProps('leave', el, props, animatableModel, dataIndex, cb, during);
}
function $b40111164617dd60$var$fadeOutDisplayable(el, animatableModel, dataIndex, done) {
    el.removeTextContent();
    el.removeTextGuideLine();
    $b40111164617dd60$export$f883456a56996078(el, {
        style: {
            opacity: 0
        }
    }, animatableModel, dataIndex, done);
}
function $b40111164617dd60$export$6d0fd725cb4aee8a(el, animatableModel, dataIndex) {
    function doRemove() {
        el.parent && el.parent.remove(el);
    }
    // Hide label and labelLine first
    // TODO Also use fade out animation?
    if (!el.isGroup) $b40111164617dd60$var$fadeOutDisplayable(el, animatableModel, dataIndex, doRemove);
    else el.traverse(function(disp) {
        if (!disp.isGroup) // Can invoke doRemove multiple times.
        $b40111164617dd60$var$fadeOutDisplayable(disp, animatableModel, dataIndex, doRemove);
    });
}
function $b40111164617dd60$export$bca7290a9faf0ec9(el) {
    $b40111164617dd60$export$ae7433df314f6ec3(el).oldStyle = el.style;
}
function $b40111164617dd60$export$ccb1f1e4d2fa86ac(el) {
    return $b40111164617dd60$export$ae7433df314f6ec3(el).oldStyle;
}

var $8eb95236e1aa01e7$exports = {};

$parcel$export($8eb95236e1aa01e7$exports, "extendShape", function () { return $8eb95236e1aa01e7$export$d0d5398c9d612037; });
$parcel$export($8eb95236e1aa01e7$exports, "extendPath", function () { return $8eb95236e1aa01e7$export$53b54a3137026af0; });
$parcel$export($8eb95236e1aa01e7$exports, "registerShape", function () { return $8eb95236e1aa01e7$export$2b95b62e3aaf6fdd; });
$parcel$export($8eb95236e1aa01e7$exports, "getShapeClass", function () { return $8eb95236e1aa01e7$export$51df4b5565a58189; });
$parcel$export($8eb95236e1aa01e7$exports, "makePath", function () { return $8eb95236e1aa01e7$export$aa9bab72412f5613; });
$parcel$export($8eb95236e1aa01e7$exports, "resizePath", function () { return $8eb95236e1aa01e7$export$566dbf1c62b04fc7; });
$parcel$export($8eb95236e1aa01e7$exports, "makeImage", function () { return $8eb95236e1aa01e7$export$7a2bdede98851ac5; });
$parcel$export($8eb95236e1aa01e7$exports, "mergePath", function () { return $8eb95236e1aa01e7$export$7b1dd269fbc4e903; });
$parcel$export($8eb95236e1aa01e7$exports, "subPixelOptimizeLine", function () { return $8eb95236e1aa01e7$export$8b4b620d7f4aad1b; });
$parcel$export($8eb95236e1aa01e7$exports, "subPixelOptimizeRect", function () { return $8eb95236e1aa01e7$export$60e2aa74957d0b9d; });
$parcel$export($8eb95236e1aa01e7$exports, "subPixelOptimize", function () { return $8eb95236e1aa01e7$export$72c4fd4c1b8fcb10; });
$parcel$export($8eb95236e1aa01e7$exports, "getTransform", function () { return $8eb95236e1aa01e7$export$fce0c6cfca85ed96; });
$parcel$export($8eb95236e1aa01e7$exports, "applyTransform", function () { return $8eb95236e1aa01e7$export$9f9dcb98c894b623; });
$parcel$export($8eb95236e1aa01e7$exports, "transformDirection", function () { return $8eb95236e1aa01e7$export$fff94e9792354cfa; });
$parcel$export($8eb95236e1aa01e7$exports, "groupTransition", function () { return $8eb95236e1aa01e7$export$64fcab7860c216ae; });
$parcel$export($8eb95236e1aa01e7$exports, "clipPointsByRect", function () { return $8eb95236e1aa01e7$export$e2f409471bbbc1dc; });
$parcel$export($8eb95236e1aa01e7$exports, "clipRectByRect", function () { return $8eb95236e1aa01e7$export$d0d3709202b8b2a; });
$parcel$export($8eb95236e1aa01e7$exports, "createIcon", function () { return $8eb95236e1aa01e7$export$274edc73af1ae9c8; });
$parcel$export($8eb95236e1aa01e7$exports, "linePolygonIntersect", function () { return $8eb95236e1aa01e7$export$4f47c855a5e9ae9; });
$parcel$export($8eb95236e1aa01e7$exports, "lineLineIntersect", function () { return $8eb95236e1aa01e7$export$6c0a70ea1d8d158b; });
$parcel$export($8eb95236e1aa01e7$exports, "setTooltipConfig", function () { return $8eb95236e1aa01e7$export$fc6410d97fab306c; });
$parcel$export($8eb95236e1aa01e7$exports, "traverseElements", function () { return $8eb95236e1aa01e7$export$3e564442729bf048; });
$parcel$export($8eb95236e1aa01e7$exports, "updateProps", function () { return $b40111164617dd60$export$c8dce3c08436e91e; });
$parcel$export($8eb95236e1aa01e7$exports, "initProps", function () { return $b40111164617dd60$export$a121566aadcfe021; });
$parcel$export($8eb95236e1aa01e7$exports, "removeElement", function () { return $b40111164617dd60$export$f883456a56996078; });
$parcel$export($8eb95236e1aa01e7$exports, "removeElementWithFadeOut", function () { return $b40111164617dd60$export$6d0fd725cb4aee8a; });
$parcel$export($8eb95236e1aa01e7$exports, "isElementRemoved", function () { return $b40111164617dd60$export$5b89d4b643713034; });
$parcel$export($8eb95236e1aa01e7$exports, "Group", function () { return $6c313c3ef6000a43$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Image", function () { return $29f98103052059af$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Text", function () { return $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Circle", function () { return $7257c7c7414f291c$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Ellipse", function () { return $eeb942ee95fdec12$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Sector", function () { return $5fa26352e0605e60$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Ring", function () { return $bbdefe74c63a4c47$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Polygon", function () { return $399011f87accd5da$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Polyline", function () { return $f7f6523750aec7c8$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Rect", function () { return $37476269d425e3f6$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Line", function () { return $8324e8379a5583a5$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "BezierCurve", function () { return $13bf9e04ebecd3f2$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Arc", function () { return $5be9485ee0d860f6$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "IncrementalDisplayable", function () { return $d34a557c022d1393$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "CompoundPath", function () { return $dd9b7a63634188ff$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "LinearGradient", function () { return $e082211bdfcbd68a$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "RadialGradient", function () { return $5eb859f717d077f6$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "BoundingRect", function () { return $020465b49a1dd45f$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "OrientedBoundingRect", function () { return $95e9c620abdf35f3$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Point", function () { return $1a833abf0e5915e2$export$2e2bcd8739ae039; });
$parcel$export($8eb95236e1aa01e7$exports, "Path", function () { return $f9698154c9fcf427$export$2e2bcd8739ae039; });
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $88a5f62691b0684a$var$CMD = (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039).CMD;
var $88a5f62691b0684a$var$points = [
    [],
    [],
    []
];
var $88a5f62691b0684a$var$mathSqrt = Math.sqrt;
var $88a5f62691b0684a$var$mathAtan2 = Math.atan2;
function $88a5f62691b0684a$export$2e2bcd8739ae039(path, m) {
    if (!m) return;
    var data = path.data;
    var len = path.len();
    var cmd;
    var nPoint;
    var i;
    var j;
    var k;
    var p;
    var M = $88a5f62691b0684a$var$CMD.M;
    var C = $88a5f62691b0684a$var$CMD.C;
    var L = $88a5f62691b0684a$var$CMD.L;
    var R = $88a5f62691b0684a$var$CMD.R;
    var A = $88a5f62691b0684a$var$CMD.A;
    var Q = $88a5f62691b0684a$var$CMD.Q;
    for(i = 0, j = 0; i < len;){
        cmd = data[i++];
        j = i;
        nPoint = 0;
        switch(cmd){
            case M:
                nPoint = 1;
                break;
            case L:
                nPoint = 1;
                break;
            case C:
                nPoint = 3;
                break;
            case Q:
                nPoint = 2;
                break;
            case A:
                var x = m[4];
                var y = m[5];
                var sx = $88a5f62691b0684a$var$mathSqrt(m[0] * m[0] + m[1] * m[1]);
                var sy = $88a5f62691b0684a$var$mathSqrt(m[2] * m[2] + m[3] * m[3]);
                var angle = $88a5f62691b0684a$var$mathAtan2(-m[1] / sy, m[0] / sx);
                data[i] *= sx;
                data[i++] += x;
                data[i] *= sy;
                data[i++] += y;
                data[i++] *= sx;
                data[i++] *= sy;
                data[i++] += angle;
                data[i++] += angle;
                i += 2;
                j = i;
                break;
            case R:
                p[0] = data[i++];
                p[1] = data[i++];
                (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
                p[0] += data[i++];
                p[1] += data[i++];
                (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(p, p, m);
                data[j++] = p[0];
                data[j++] = p[1];
        }
        for(k = 0; k < nPoint; k++){
            var p_1 = $88a5f62691b0684a$var$points[k];
            p_1[0] = data[i++];
            p_1[1] = data[i++];
            (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(p_1, p_1, m);
            data[j++] = p_1[0];
            data[j++] = p_1[1];
        }
    }
    path.increaseVersion();
}



var $f444b8fb72be0619$var$mathSqrt = Math.sqrt;
var $f444b8fb72be0619$var$mathSin = Math.sin;
var $f444b8fb72be0619$var$mathCos = Math.cos;
var $f444b8fb72be0619$var$PI = Math.PI;
function $f444b8fb72be0619$var$vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
function $f444b8fb72be0619$var$vRatio(u, v) {
    return (u[0] * v[0] + u[1] * v[1]) / ($f444b8fb72be0619$var$vMag(u) * $f444b8fb72be0619$var$vMag(v));
}
function $f444b8fb72be0619$var$vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos($f444b8fb72be0619$var$vRatio(u, v));
}
function $f444b8fb72be0619$var$processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
    var psi = psiDeg * ($f444b8fb72be0619$var$PI / 180.0);
    var xp = $f444b8fb72be0619$var$mathCos(psi) * (x1 - x2) / 2.0 + $f444b8fb72be0619$var$mathSin(psi) * (y1 - y2) / 2.0;
    var yp = -1 * $f444b8fb72be0619$var$mathSin(psi) * (x1 - x2) / 2.0 + $f444b8fb72be0619$var$mathCos(psi) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= $f444b8fb72be0619$var$mathSqrt(lambda);
        ry *= $f444b8fb72be0619$var$mathSqrt(lambda);
    }
    var f = (fa === fs ? -1 : 1) * $f444b8fb72be0619$var$mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
    var cxp = f * rx * yp / ry;
    var cyp = f * -ry * xp / rx;
    var cx = (x1 + x2) / 2.0 + $f444b8fb72be0619$var$mathCos(psi) * cxp - $f444b8fb72be0619$var$mathSin(psi) * cyp;
    var cy = (y1 + y2) / 2.0 + $f444b8fb72be0619$var$mathSin(psi) * cxp + $f444b8fb72be0619$var$mathCos(psi) * cyp;
    var theta = $f444b8fb72be0619$var$vAngle([
        1,
        0
    ], [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ]);
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    var dTheta = $f444b8fb72be0619$var$vAngle(u, v);
    if ($f444b8fb72be0619$var$vRatio(u, v) <= -1) dTheta = $f444b8fb72be0619$var$PI;
    if ($f444b8fb72be0619$var$vRatio(u, v) >= 1) dTheta = 0;
    if (dTheta < 0) {
        var n = Math.round(dTheta / $f444b8fb72be0619$var$PI * 1e6) / 1e6;
        dTheta = $f444b8fb72be0619$var$PI * 2 + n % 2 * $f444b8fb72be0619$var$PI;
    }
    path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
}
var $f444b8fb72be0619$var$commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig;
var $f444b8fb72be0619$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $f444b8fb72be0619$var$createPathProxyFromString(data) {
    var path = new (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039)();
    if (!data) return path;
    var cpx = 0;
    var cpy = 0;
    var subpathX = cpx;
    var subpathY = cpy;
    var prevCmd;
    var CMD = (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039).CMD;
    var cmdList = data.match($f444b8fb72be0619$var$commandReg);
    if (!cmdList) return path;
    for(var l = 0; l < cmdList.length; l++){
        var cmdText = cmdList[l];
        var cmdStr = cmdText.charAt(0);
        var cmd = void 0;
        var p = cmdText.match($f444b8fb72be0619$var$numberReg) || [];
        var pLen = p.length;
        for(var i = 0; i < pLen; i++)p[i] = parseFloat(p[i]);
        var off = 0;
        while(off < pLen){
            var ctlPtx = void 0;
            var ctlPty = void 0;
            var rx = void 0;
            var ry = void 0;
            var psi = void 0;
            var fa = void 0;
            var fs = void 0;
            var x1 = cpx;
            var y1 = cpy;
            var len = void 0;
            var pathData = void 0;
            switch(cmdStr){
                case 'l':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'L':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'm':
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'l';
                    break;
                case 'M':
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.M;
                    path.addData(cmd, cpx, cpy);
                    subpathX = cpx;
                    subpathY = cpy;
                    cmdStr = 'L';
                    break;
                case 'h':
                    cpx += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'H':
                    cpx = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'v':
                    cpy += p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'V':
                    cpy = p[off++];
                    cmd = CMD.L;
                    path.addData(cmd, cpx, cpy);
                    break;
                case 'C':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
                    cpx = p[off - 2];
                    cpy = p[off - 1];
                    break;
                case 'c':
                    cmd = CMD.C;
                    path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
                    cpx += p[off - 2];
                    cpy += p[off - 1];
                    break;
                case 'S':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 's':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.C) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cmd = CMD.C;
                    x1 = cpx + p[off++];
                    y1 = cpy + p[off++];
                    cpx += p[off++];
                    cpy += p[off++];
                    path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
                    break;
                case 'Q':
                    x1 = p[off++];
                    y1 = p[off++];
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'q':
                    x1 = p[off++] + cpx;
                    y1 = p[off++] + cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, x1, y1, cpx, cpy);
                    break;
                case 'T':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 't':
                    ctlPtx = cpx;
                    ctlPty = cpy;
                    len = path.len();
                    pathData = path.data;
                    if (prevCmd === CMD.Q) {
                        ctlPtx += cpx - pathData[len - 4];
                        ctlPty += cpy - pathData[len - 3];
                    }
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.Q;
                    path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
                    break;
                case 'A':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx = p[off++];
                    cpy = p[off++];
                    cmd = CMD.A;
                    $f444b8fb72be0619$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
                case 'a':
                    rx = p[off++];
                    ry = p[off++];
                    psi = p[off++];
                    fa = p[off++];
                    fs = p[off++];
                    x1 = cpx, y1 = cpy;
                    cpx += p[off++];
                    cpy += p[off++];
                    cmd = CMD.A;
                    $f444b8fb72be0619$var$processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
                    break;
            }
        }
        if (cmdStr === 'z' || cmdStr === 'Z') {
            cmd = CMD.Z;
            path.addData(cmd);
            cpx = subpathX;
            cpy = subpathY;
        }
        prevCmd = cmd;
    }
    path.toStatic();
    return path;
}
var $f444b8fb72be0619$var$SVGPath = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SVGPath, _super);
    function SVGPath() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SVGPath.prototype.applyTransform = function(m) {};
    return SVGPath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
function $f444b8fb72be0619$var$isPathProxy(path) {
    return path.setData != null;
}
function $f444b8fb72be0619$var$createPathOptions(str, opts) {
    var pathProxy = $f444b8fb72be0619$var$createPathProxyFromString(str);
    var innerOpts = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, opts);
    innerOpts.buildPath = function(path) {
        if ($f444b8fb72be0619$var$isPathProxy(path)) {
            path.setData(pathProxy.data);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        } else {
            var ctx = path;
            pathProxy.rebuildPath(ctx, 1);
        }
    };
    innerOpts.applyTransform = function(m) {
        (0, $88a5f62691b0684a$export$2e2bcd8739ae039)(pathProxy, m);
        this.dirtyShape();
    };
    return innerOpts;
}
function $f444b8fb72be0619$export$ae5b259626f00aeb(str, opts) {
    return new $f444b8fb72be0619$var$SVGPath($f444b8fb72be0619$var$createPathOptions(str, opts));
}
function $f444b8fb72be0619$export$68e3a51ba2ed417c(str, defaultOpts) {
    var innerOpts = $f444b8fb72be0619$var$createPathOptions(str, defaultOpts);
    var Sub = function(_super) {
        (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Sub, _super);
        function Sub(opts) {
            var _this = _super.call(this, opts) || this;
            _this.applyTransform = innerOpts.applyTransform;
            _this.buildPath = innerOpts.buildPath;
            return _this;
        }
        return Sub;
    }($f444b8fb72be0619$var$SVGPath);
    return Sub;
}
function $f444b8fb72be0619$export$7b1dd269fbc4e903(pathEls, opts) {
    var pathList = [];
    var len = pathEls.length;
    for(var i = 0; i < len; i++){
        var pathEl = pathEls[i];
        pathList.push(pathEl.getUpdatedPathProxy(true));
    }
    var pathBundle = new (0, $f9698154c9fcf427$export$2e2bcd8739ae039)(opts);
    pathBundle.createPathProxy();
    pathBundle.buildPath = function(path) {
        if ($f444b8fb72be0619$var$isPathProxy(path)) {
            path.appendPath(pathList);
            var ctx = path.getContext();
            if (ctx) path.rebuildPath(ctx, 1);
        }
    };
    return pathBundle;
}
function $f444b8fb72be0619$export$18711d956bf1c3eb(sourcePath, opts) {
    opts = opts || {};
    var path = new (0, $f9698154c9fcf427$export$2e2bcd8739ae039)();
    if (sourcePath.shape) path.setShape(sourcePath.shape);
    path.setStyle(sourcePath.style);
    if (opts.bakeTransform) (0, $88a5f62691b0684a$export$2e2bcd8739ae039)(path.path, sourcePath.getComputedTransform());
    else if (opts.toLocal) path.setLocalTransform(sourcePath.getComputedTransform());
    else path.copyTransform(sourcePath);
    path.buildPath = sourcePath.buildPath;
    path.applyTransform = path.applyTransform;
    path.z = sourcePath.z;
    path.z2 = sourcePath.z2;
    path.zlevel = sourcePath.zlevel;
    return path;
}











var $7257c7c7414f291c$export$2c0b65c9c7b57845 = function() {
    function CircleShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
    }
    return CircleShape;
}();
var $7257c7c7414f291c$var$Circle = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Circle, _super);
    function Circle(opts) {
        return _super.call(this, opts) || this;
    }
    Circle.prototype.getDefaultShape = function() {
        return new $7257c7c7414f291c$export$2c0b65c9c7b57845();
    };
    Circle.prototype.buildPath = function(ctx, shape) {
        ctx.moveTo(shape.cx + shape.r, shape.cy);
        ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2);
    };
    return Circle;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$7257c7c7414f291c$var$Circle.prototype.type = 'circle';
var $7257c7c7414f291c$export$2e2bcd8739ae039 = $7257c7c7414f291c$var$Circle;




var $eeb942ee95fdec12$export$817919dfe2806d31 = function() {
    function EllipseShape() {
        this.cx = 0;
        this.cy = 0;
        this.rx = 0;
        this.ry = 0;
    }
    return EllipseShape;
}();
var $eeb942ee95fdec12$var$Ellipse = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Ellipse, _super);
    function Ellipse(opts) {
        return _super.call(this, opts) || this;
    }
    Ellipse.prototype.getDefaultShape = function() {
        return new $eeb942ee95fdec12$export$817919dfe2806d31();
    };
    Ellipse.prototype.buildPath = function(ctx, shape) {
        var k = 0.5522848;
        var x = shape.cx;
        var y = shape.cy;
        var a = shape.rx;
        var b = shape.ry;
        var ox = a * k;
        var oy = b * k;
        ctx.moveTo(x - a, y);
        ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
        ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
        ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
        ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
        ctx.closePath();
    };
    return Ellipse;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$eeb942ee95fdec12$var$Ellipse.prototype.type = 'ellipse';
var $eeb942ee95fdec12$export$2e2bcd8739ae039 = $eeb942ee95fdec12$var$Ellipse;





var $bc1ddcf7043c9826$var$PI = Math.PI;
var $bc1ddcf7043c9826$var$PI2 = $bc1ddcf7043c9826$var$PI * 2;
var $bc1ddcf7043c9826$var$mathSin = Math.sin;
var $bc1ddcf7043c9826$var$mathCos = Math.cos;
var $bc1ddcf7043c9826$var$mathACos = Math.acos;
var $bc1ddcf7043c9826$var$mathATan2 = Math.atan2;
var $bc1ddcf7043c9826$var$mathAbs = Math.abs;
var $bc1ddcf7043c9826$var$mathSqrt = Math.sqrt;
var $bc1ddcf7043c9826$var$mathMax = Math.max;
var $bc1ddcf7043c9826$var$mathMin = Math.min;
var $bc1ddcf7043c9826$var$e = 1e-4;
function $bc1ddcf7043c9826$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $bc1ddcf7043c9826$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
function $bc1ddcf7043c9826$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $bc1ddcf7043c9826$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $bc1ddcf7043c9826$var$mathSqrt($bc1ddcf7043c9826$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $bc1ddcf7043c9826$var$normalizeCornerRadius(cr) {
    var arr;
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(cr)) {
        var len = cr.length;
        if (!len) return cr;
        if (len === 1) arr = [
            cr[0],
            cr[0],
            0,
            0
        ];
        else if (len === 2) arr = [
            cr[0],
            cr[0],
            cr[1],
            cr[1]
        ];
        else if (len === 3) arr = cr.concat(cr[2]);
        else arr = cr;
    } else arr = [
        cr,
        cr,
        cr,
        cr
    ];
    return arr;
}
function $bc1ddcf7043c9826$export$5cc7f731b5937e99(ctx, shape) {
    var _a;
    var radius = $bc1ddcf7043c9826$var$mathMax(shape.r, 0);
    var innerRadius = $bc1ddcf7043c9826$var$mathMax(shape.r0 || 0, 0);
    var hasRadius = radius > 0;
    var hasInnerRadius = innerRadius > 0;
    if (!hasRadius && !hasInnerRadius) return;
    if (!hasRadius) {
        radius = innerRadius;
        innerRadius = 0;
    }
    if (innerRadius > radius) {
        var tmp = radius;
        radius = innerRadius;
        innerRadius = tmp;
    }
    var startAngle = shape.startAngle, endAngle = shape.endAngle;
    if (isNaN(startAngle) || isNaN(endAngle)) return;
    var cx = shape.cx, cy = shape.cy;
    var clockwise = !!shape.clockwise;
    var arc = $bc1ddcf7043c9826$var$mathAbs(endAngle - startAngle);
    var mod = arc > $bc1ddcf7043c9826$var$PI2 && arc % $bc1ddcf7043c9826$var$PI2;
    mod > $bc1ddcf7043c9826$var$e && (arc = mod);
    if (!(radius > $bc1ddcf7043c9826$var$e)) ctx.moveTo(cx, cy);
    else if (arc > $bc1ddcf7043c9826$var$PI2 - $bc1ddcf7043c9826$var$e) {
        ctx.moveTo(cx + radius * $bc1ddcf7043c9826$var$mathCos(startAngle), cy + radius * $bc1ddcf7043c9826$var$mathSin(startAngle));
        ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        if (innerRadius > $bc1ddcf7043c9826$var$e) {
            ctx.moveTo(cx + innerRadius * $bc1ddcf7043c9826$var$mathCos(endAngle), cy + innerRadius * $bc1ddcf7043c9826$var$mathSin(endAngle));
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    } else {
        var icrStart = void 0;
        var icrEnd = void 0;
        var ocrStart = void 0;
        var ocrEnd = void 0;
        var ocrs = void 0;
        var ocre = void 0;
        var icrs = void 0;
        var icre = void 0;
        var ocrMax = void 0;
        var icrMax = void 0;
        var limitedOcrMax = void 0;
        var limitedIcrMax = void 0;
        var xre = void 0;
        var yre = void 0;
        var xirs = void 0;
        var yirs = void 0;
        var xrs = radius * $bc1ddcf7043c9826$var$mathCos(startAngle);
        var yrs = radius * $bc1ddcf7043c9826$var$mathSin(startAngle);
        var xire = innerRadius * $bc1ddcf7043c9826$var$mathCos(endAngle);
        var yire = innerRadius * $bc1ddcf7043c9826$var$mathSin(endAngle);
        var hasArc = arc > $bc1ddcf7043c9826$var$e;
        if (hasArc) {
            var cornerRadius = shape.cornerRadius;
            if (cornerRadius) _a = $bc1ddcf7043c9826$var$normalizeCornerRadius(cornerRadius), icrStart = _a[0], icrEnd = _a[1], ocrStart = _a[2], ocrEnd = _a[3];
            var halfRd = $bc1ddcf7043c9826$var$mathAbs(radius - innerRadius) / 2;
            ocrs = $bc1ddcf7043c9826$var$mathMin(halfRd, ocrStart);
            ocre = $bc1ddcf7043c9826$var$mathMin(halfRd, ocrEnd);
            icrs = $bc1ddcf7043c9826$var$mathMin(halfRd, icrStart);
            icre = $bc1ddcf7043c9826$var$mathMin(halfRd, icrEnd);
            limitedOcrMax = ocrMax = $bc1ddcf7043c9826$var$mathMax(ocrs, ocre);
            limitedIcrMax = icrMax = $bc1ddcf7043c9826$var$mathMax(icrs, icre);
            if (ocrMax > $bc1ddcf7043c9826$var$e || icrMax > $bc1ddcf7043c9826$var$e) {
                xre = radius * $bc1ddcf7043c9826$var$mathCos(endAngle);
                yre = radius * $bc1ddcf7043c9826$var$mathSin(endAngle);
                xirs = innerRadius * $bc1ddcf7043c9826$var$mathCos(startAngle);
                yirs = innerRadius * $bc1ddcf7043c9826$var$mathSin(startAngle);
                if (arc < $bc1ddcf7043c9826$var$PI) {
                    var it_1 = $bc1ddcf7043c9826$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                    if (it_1) {
                        var x0 = xrs - it_1[0];
                        var y0 = yrs - it_1[1];
                        var x1 = xre - it_1[0];
                        var y1 = yre - it_1[1];
                        var a = 1 / $bc1ddcf7043c9826$var$mathSin($bc1ddcf7043c9826$var$mathACos((x0 * x1 + y0 * y1) / ($bc1ddcf7043c9826$var$mathSqrt(x0 * x0 + y0 * y0) * $bc1ddcf7043c9826$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                        var b = $bc1ddcf7043c9826$var$mathSqrt(it_1[0] * it_1[0] + it_1[1] * it_1[1]);
                        limitedOcrMax = $bc1ddcf7043c9826$var$mathMin(ocrMax, (radius - b) / (a + 1));
                        limitedIcrMax = $bc1ddcf7043c9826$var$mathMin(icrMax, (innerRadius - b) / (a - 1));
                    }
                }
            }
        }
        if (!hasArc) ctx.moveTo(cx + xrs, cy + yrs);
        else if (limitedOcrMax > $bc1ddcf7043c9826$var$e) {
            var crStart = $bc1ddcf7043c9826$var$mathMin(ocrStart, limitedOcrMax);
            var crEnd = $bc1ddcf7043c9826$var$mathMin(ocrEnd, limitedOcrMax);
            var ct0 = $bc1ddcf7043c9826$var$computeCornerTangents(xirs, yirs, xrs, yrs, radius, crStart, clockwise);
            var ct1 = $bc1ddcf7043c9826$var$computeCornerTangents(xre, yre, xire, yire, radius, crEnd, clockwise);
            ctx.moveTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedOcrMax < ocrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedOcrMax, $bc1ddcf7043c9826$var$mathATan2(ct0.y0, ct0.x0), $bc1ddcf7043c9826$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crStart > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crStart, $bc1ddcf7043c9826$var$mathATan2(ct0.y0, ct0.x0), $bc1ddcf7043c9826$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, radius, $bc1ddcf7043c9826$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $bc1ddcf7043c9826$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), !clockwise);
                crEnd > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crEnd, $bc1ddcf7043c9826$var$mathATan2(ct1.y1, ct1.x1), $bc1ddcf7043c9826$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.moveTo(cx + xrs, cy + yrs);
            ctx.arc(cx, cy, radius, startAngle, endAngle, !clockwise);
        }
        if (!(innerRadius > $bc1ddcf7043c9826$var$e) || !hasArc) ctx.lineTo(cx + xire, cy + yire);
        else if (limitedIcrMax > $bc1ddcf7043c9826$var$e) {
            var crStart = $bc1ddcf7043c9826$var$mathMin(icrStart, limitedIcrMax);
            var crEnd = $bc1ddcf7043c9826$var$mathMin(icrEnd, limitedIcrMax);
            var ct0 = $bc1ddcf7043c9826$var$computeCornerTangents(xire, yire, xre, yre, innerRadius, -crEnd, clockwise);
            var ct1 = $bc1ddcf7043c9826$var$computeCornerTangents(xrs, yrs, xirs, yirs, innerRadius, -crStart, clockwise);
            ctx.lineTo(cx + ct0.cx + ct0.x0, cy + ct0.cy + ct0.y0);
            if (limitedIcrMax < icrMax && crStart === crEnd) ctx.arc(cx + ct0.cx, cy + ct0.cy, limitedIcrMax, $bc1ddcf7043c9826$var$mathATan2(ct0.y0, ct0.x0), $bc1ddcf7043c9826$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            else {
                crEnd > 0 && ctx.arc(cx + ct0.cx, cy + ct0.cy, crEnd, $bc1ddcf7043c9826$var$mathATan2(ct0.y0, ct0.x0), $bc1ddcf7043c9826$var$mathATan2(ct0.y1, ct0.x1), !clockwise);
                ctx.arc(cx, cy, innerRadius, $bc1ddcf7043c9826$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1), $bc1ddcf7043c9826$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1), clockwise);
                crStart > 0 && ctx.arc(cx + ct1.cx, cy + ct1.cy, crStart, $bc1ddcf7043c9826$var$mathATan2(ct1.y1, ct1.x1), $bc1ddcf7043c9826$var$mathATan2(ct1.y0, ct1.x0), !clockwise);
            }
        } else {
            ctx.lineTo(cx + xire, cy + yire);
            ctx.arc(cx, cy, innerRadius, endAngle, startAngle, clockwise);
        }
    }
    ctx.closePath();
}


var $5fa26352e0605e60$export$98af62de8a972c99 = function() {
    function SectorShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
        this.cornerRadius = 0;
    }
    return SectorShape;
}();
var $5fa26352e0605e60$var$Sector = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Sector, _super);
    function Sector(opts) {
        return _super.call(this, opts) || this;
    }
    Sector.prototype.getDefaultShape = function() {
        return new $5fa26352e0605e60$export$98af62de8a972c99();
    };
    Sector.prototype.buildPath = function(ctx, shape) {
        $bc1ddcf7043c9826$export$5cc7f731b5937e99(ctx, shape);
    };
    Sector.prototype.isZeroArea = function() {
        return this.shape.startAngle === this.shape.endAngle || this.shape.r === this.shape.r0;
    };
    return Sector;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$5fa26352e0605e60$var$Sector.prototype.type = 'sector';
var $5fa26352e0605e60$export$2e2bcd8739ae039 = $5fa26352e0605e60$var$Sector;




var $bbdefe74c63a4c47$export$4a506b3cd4ea73db = function() {
    function RingShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.r0 = 0;
    }
    return RingShape;
}();
var $bbdefe74c63a4c47$var$Ring = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Ring, _super);
    function Ring(opts) {
        return _super.call(this, opts) || this;
    }
    Ring.prototype.getDefaultShape = function() {
        return new $bbdefe74c63a4c47$export$4a506b3cd4ea73db();
    };
    Ring.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var PI2 = Math.PI * 2;
        ctx.moveTo(x + shape.r, y);
        ctx.arc(x, y, shape.r, 0, PI2, false);
        ctx.moveTo(x + shape.r0, y);
        ctx.arc(x, y, shape.r0, 0, PI2, true);
    };
    return Ring;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$bbdefe74c63a4c47$var$Ring.prototype.type = 'ring';
var $bbdefe74c63a4c47$export$2e2bcd8739ae039 = $bbdefe74c63a4c47$var$Ring;





function $a1f2d24749c5269d$export$2e2bcd8739ae039(points, smooth, isLoop, constraint) {
    var cps = [];
    var v = [];
    var v1 = [];
    var v2 = [];
    var prevPoint;
    var nextPoint;
    var min;
    var max;
    if (constraint) {
        min = [
            Infinity,
            Infinity
        ];
        max = [
            -Infinity,
            -Infinity
        ];
        for(var i = 0, len = points.length; i < len; i++){
            (0, $3dde7d051fe20daa$export$96ec731ed4dcb222)(min, min, points[i]);
            (0, $3dde7d051fe20daa$export$8960430cfd85939f)(max, max, points[i]);
        }
        (0, $3dde7d051fe20daa$export$96ec731ed4dcb222)(min, min, constraint[0]);
        (0, $3dde7d051fe20daa$export$8960430cfd85939f)(max, max, constraint[1]);
    }
    for(var i = 0, len = points.length; i < len; i++){
        var point = points[i];
        if (isLoop) {
            prevPoint = points[i ? i - 1 : len - 1];
            nextPoint = points[(i + 1) % len];
        } else if (i === 0 || i === len - 1) {
            cps.push((0, $3dde7d051fe20daa$export$9cd59f9826255e47)(points[i]));
            continue;
        } else {
            prevPoint = points[i - 1];
            nextPoint = points[i + 1];
        }
        (0, $3dde7d051fe20daa$export$f93b5905241a7cca)(v, nextPoint, prevPoint);
        (0, $3dde7d051fe20daa$export$dcdf75081b88279d)(v, v, smooth);
        var d0 = (0, $3dde7d051fe20daa$export$9f17032d917177de)(point, prevPoint);
        var d1 = (0, $3dde7d051fe20daa$export$9f17032d917177de)(point, nextPoint);
        var sum = d0 + d1;
        if (sum !== 0) {
            d0 /= sum;
            d1 /= sum;
        }
        (0, $3dde7d051fe20daa$export$dcdf75081b88279d)(v1, v, -d0);
        (0, $3dde7d051fe20daa$export$dcdf75081b88279d)(v2, v, d1);
        var cp0 = (0, $3dde7d051fe20daa$export$e16d8520af44a096)([], point, v1);
        var cp1 = (0, $3dde7d051fe20daa$export$e16d8520af44a096)([], point, v2);
        if (constraint) {
            (0, $3dde7d051fe20daa$export$8960430cfd85939f)(cp0, cp0, min);
            (0, $3dde7d051fe20daa$export$96ec731ed4dcb222)(cp0, cp0, max);
            (0, $3dde7d051fe20daa$export$8960430cfd85939f)(cp1, cp1, min);
            (0, $3dde7d051fe20daa$export$96ec731ed4dcb222)(cp1, cp1, max);
        }
        cps.push(cp0);
        cps.push(cp1);
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}


function $265608633d2ca7c9$export$5cc7f731b5937e99(ctx, shape, closePath) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (points && points.length >= 2) {
        if (smooth) {
            var controlPoints = (0, $a1f2d24749c5269d$export$2e2bcd8739ae039)(points, smooth, closePath, shape.smoothConstraint);
            ctx.moveTo(points[0][0], points[0][1]);
            var len = points.length;
            for(var i = 0; i < (closePath ? len : len - 1); i++){
                var cp1 = controlPoints[i * 2];
                var cp2 = controlPoints[i * 2 + 1];
                var p = points[(i + 1) % len];
                ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
            }
        } else {
            ctx.moveTo(points[0][0], points[0][1]);
            for(var i = 1, l = points.length; i < l; i++)ctx.lineTo(points[i][0], points[i][1]);
        }
        closePath && ctx.closePath();
    }
}


var $399011f87accd5da$export$a34d87b9aaeedd46 = function() {
    function PolygonShape() {
        this.points = null;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolygonShape;
}();
var $399011f87accd5da$var$Polygon = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Polygon, _super);
    function Polygon(opts) {
        return _super.call(this, opts) || this;
    }
    Polygon.prototype.getDefaultShape = function() {
        return new $399011f87accd5da$export$a34d87b9aaeedd46();
    };
    Polygon.prototype.buildPath = function(ctx, shape) {
        $265608633d2ca7c9$export$5cc7f731b5937e99(ctx, shape, true);
    };
    return Polygon;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$399011f87accd5da$var$Polygon.prototype.type = 'polygon';
var $399011f87accd5da$export$2e2bcd8739ae039 = $399011f87accd5da$var$Polygon;





var $f7f6523750aec7c8$export$e9e5cc3985e19d11 = function() {
    function PolylineShape() {
        this.points = null;
        this.percent = 1;
        this.smooth = 0;
        this.smoothConstraint = null;
    }
    return PolylineShape;
}();
var $f7f6523750aec7c8$var$Polyline = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(opts) {
        return _super.call(this, opts) || this;
    }
    Polyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Polyline.prototype.getDefaultShape = function() {
        return new $f7f6523750aec7c8$export$e9e5cc3985e19d11();
    };
    Polyline.prototype.buildPath = function(ctx, shape) {
        $265608633d2ca7c9$export$5cc7f731b5937e99(ctx, shape, false);
    };
    return Polyline;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$f7f6523750aec7c8$var$Polyline.prototype.type = 'polyline';
var $f7f6523750aec7c8$export$2e2bcd8739ae039 = $f7f6523750aec7c8$var$Polyline;






var $8324e8379a5583a5$var$subPixelOptimizeOutputShape = {};
var $8324e8379a5583a5$export$64b674d0815308 = function() {
    function LineShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return LineShape;
}();
var $8324e8379a5583a5$var$Line = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Line, _super);
    function Line(opts) {
        return _super.call(this, opts) || this;
    }
    Line.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Line.prototype.getDefaultShape = function() {
        return new $8324e8379a5583a5$export$64b674d0815308();
    };
    Line.prototype.buildPath = function(ctx, shape) {
        var x1;
        var y1;
        var x2;
        var y2;
        if (this.subPixelOptimize) {
            var optimizedShape = (0, $76bb43c2e594ce84$export$8b4b620d7f4aad1b)($8324e8379a5583a5$var$subPixelOptimizeOutputShape, shape, this.style);
            x1 = optimizedShape.x1;
            y1 = optimizedShape.y1;
            x2 = optimizedShape.x2;
            y2 = optimizedShape.y2;
        } else {
            x1 = shape.x1;
            y1 = shape.y1;
            x2 = shape.x2;
            y2 = shape.y2;
        }
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (percent < 1) {
            x2 = x1 * (1 - percent) + x2 * percent;
            y2 = y1 * (1 - percent) + y2 * percent;
        }
        ctx.lineTo(x2, y2);
    };
    Line.prototype.pointAt = function(p) {
        var shape = this.shape;
        return [
            shape.x1 * (1 - p) + shape.x2 * p,
            shape.y1 * (1 - p) + shape.y2 * p
        ];
    };
    return Line;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$8324e8379a5583a5$var$Line.prototype.type = 'line';
var $8324e8379a5583a5$export$2e2bcd8739ae039 = $8324e8379a5583a5$var$Line;






var $13bf9e04ebecd3f2$var$out = [];
var $13bf9e04ebecd3f2$export$e10089729fef29aa = function() {
    function BezierCurveShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.percent = 1;
    }
    return BezierCurveShape;
}();
function $13bf9e04ebecd3f2$var$someVectorAt(shape, t, isTangent) {
    var cpx2 = shape.cpx2;
    var cpy2 = shape.cpy2;
    if (cpx2 != null || cpy2 != null) return [
        (isTangent ? (0, $eea9463646207a7b$export$55fce925c60b6271) : (0, $eea9463646207a7b$export$547c21de482bbcb2))(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t),
        (isTangent ? (0, $eea9463646207a7b$export$55fce925c60b6271) : (0, $eea9463646207a7b$export$547c21de482bbcb2))(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)
    ];
    else return [
        (isTangent ? (0, $eea9463646207a7b$export$7e161e77e6fff8cb) : (0, $eea9463646207a7b$export$af17094a950f5073))(shape.x1, shape.cpx1, shape.x2, t),
        (isTangent ? (0, $eea9463646207a7b$export$7e161e77e6fff8cb) : (0, $eea9463646207a7b$export$af17094a950f5073))(shape.y1, shape.cpy1, shape.y2, t)
    ];
}
var $13bf9e04ebecd3f2$var$BezierCurve = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BezierCurve, _super);
    function BezierCurve(opts) {
        return _super.call(this, opts) || this;
    }
    BezierCurve.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    BezierCurve.prototype.getDefaultShape = function() {
        return new $13bf9e04ebecd3f2$export$e10089729fef29aa();
    };
    BezierCurve.prototype.buildPath = function(ctx, shape) {
        var x1 = shape.x1;
        var y1 = shape.y1;
        var x2 = shape.x2;
        var y2 = shape.y2;
        var cpx1 = shape.cpx1;
        var cpy1 = shape.cpy1;
        var cpx2 = shape.cpx2;
        var cpy2 = shape.cpy2;
        var percent = shape.percent;
        if (percent === 0) return;
        ctx.moveTo(x1, y1);
        if (cpx2 == null || cpy2 == null) {
            if (percent < 1) {
                (0, $eea9463646207a7b$export$117c659e21a7a060)(x1, cpx1, x2, percent, $13bf9e04ebecd3f2$var$out);
                cpx1 = $13bf9e04ebecd3f2$var$out[1];
                x2 = $13bf9e04ebecd3f2$var$out[2];
                (0, $eea9463646207a7b$export$117c659e21a7a060)(y1, cpy1, y2, percent, $13bf9e04ebecd3f2$var$out);
                cpy1 = $13bf9e04ebecd3f2$var$out[1];
                y2 = $13bf9e04ebecd3f2$var$out[2];
            }
            ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
        } else {
            if (percent < 1) {
                (0, $eea9463646207a7b$export$a2ee23a0567039da)(x1, cpx1, cpx2, x2, percent, $13bf9e04ebecd3f2$var$out);
                cpx1 = $13bf9e04ebecd3f2$var$out[1];
                cpx2 = $13bf9e04ebecd3f2$var$out[2];
                x2 = $13bf9e04ebecd3f2$var$out[3];
                (0, $eea9463646207a7b$export$a2ee23a0567039da)(y1, cpy1, cpy2, y2, percent, $13bf9e04ebecd3f2$var$out);
                cpy1 = $13bf9e04ebecd3f2$var$out[1];
                cpy2 = $13bf9e04ebecd3f2$var$out[2];
                y2 = $13bf9e04ebecd3f2$var$out[3];
            }
            ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
        }
    };
    BezierCurve.prototype.pointAt = function(t) {
        return $13bf9e04ebecd3f2$var$someVectorAt(this.shape, t, false);
    };
    BezierCurve.prototype.tangentAt = function(t) {
        var p = $13bf9e04ebecd3f2$var$someVectorAt(this.shape, t, true);
        return $3dde7d051fe20daa$export$a3295358bff77e(p, p);
    };
    return BezierCurve;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$13bf9e04ebecd3f2$var$BezierCurve.prototype.type = 'bezier-curve';
var $13bf9e04ebecd3f2$export$2e2bcd8739ae039 = $13bf9e04ebecd3f2$var$BezierCurve;




var $5be9485ee0d860f6$export$a259dbdc51948277 = function() {
    function ArcShape() {
        this.cx = 0;
        this.cy = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return ArcShape;
}();
var $5be9485ee0d860f6$var$Arc = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Arc, _super);
    function Arc(opts) {
        return _super.call(this, opts) || this;
    }
    Arc.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    Arc.prototype.getDefaultShape = function() {
        return new $5be9485ee0d860f6$export$a259dbdc51948277();
    };
    Arc.prototype.buildPath = function(ctx, shape) {
        var x = shape.cx;
        var y = shape.cy;
        var r = Math.max(shape.r, 0);
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var unitX = Math.cos(startAngle);
        var unitY = Math.sin(startAngle);
        ctx.moveTo(unitX * r + x, unitY * r + y);
        ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
    };
    return Arc;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
$5be9485ee0d860f6$var$Arc.prototype.type = 'arc';
var $5be9485ee0d860f6$export$2e2bcd8739ae039 = $5be9485ee0d860f6$var$Arc;




var $dd9b7a63634188ff$var$CompoundPath = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CompoundPath, _super);
    function CompoundPath() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'compound';
        return _this;
    }
    CompoundPath.prototype._updatePathDirty = function() {
        var paths = this.shape.paths;
        var dirtyPath = this.shapeChanged();
        for(var i = 0; i < paths.length; i++)dirtyPath = dirtyPath || paths[i].shapeChanged();
        if (dirtyPath) this.dirtyShape();
    };
    CompoundPath.prototype.beforeBrush = function() {
        this._updatePathDirty();
        var paths = this.shape.paths || [];
        var scale = this.getGlobalScale();
        for(var i = 0; i < paths.length; i++){
            if (!paths[i].path) paths[i].createPathProxy();
            paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
        }
    };
    CompoundPath.prototype.buildPath = function(ctx, shape) {
        var paths = shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].buildPath(ctx, paths[i].shape, true);
    };
    CompoundPath.prototype.afterBrush = function() {
        var paths = this.shape.paths || [];
        for(var i = 0; i < paths.length; i++)paths[i].pathUpdated();
    };
    CompoundPath.prototype.getBoundingRect = function() {
        this._updatePathDirty.call(this);
        return (0, $f9698154c9fcf427$export$2e2bcd8739ae039).prototype.getBoundingRect.call(this);
    };
    return CompoundPath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
var $dd9b7a63634188ff$export$2e2bcd8739ae039 = $dd9b7a63634188ff$var$CompoundPath;



var $fe3eda7cb5345cd2$var$Gradient = function() {
    function Gradient(colorStops) {
        this.colorStops = colorStops || [];
    }
    Gradient.prototype.addColorStop = function(offset, color) {
        this.colorStops.push({
            offset: offset,
            color: color
        });
    };
    return Gradient;
}();
var $fe3eda7cb5345cd2$export$2e2bcd8739ae039 = $fe3eda7cb5345cd2$var$Gradient;


var $e082211bdfcbd68a$var$LinearGradient = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LinearGradient, _super);
    function LinearGradient(x, y, x2, y2, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0 : x;
        _this.y = y == null ? 0 : y;
        _this.x2 = x2 == null ? 1 : x2;
        _this.y2 = y2 == null ? 0 : y2;
        _this.type = 'linear';
        _this.global = globalCoord || false;
        return _this;
    }
    return LinearGradient;
}((0, $fe3eda7cb5345cd2$export$2e2bcd8739ae039));
var $e082211bdfcbd68a$export$2e2bcd8739ae039 = $e082211bdfcbd68a$var$LinearGradient;




var $5eb859f717d077f6$var$RadialGradient = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadialGradient, _super);
    function RadialGradient(x, y, r, colorStops, globalCoord) {
        var _this = _super.call(this, colorStops) || this;
        _this.x = x == null ? 0.5 : x;
        _this.y = y == null ? 0.5 : y;
        _this.r = r == null ? 0.5 : r;
        _this.type = 'radial';
        _this.global = globalCoord || false;
        return _this;
    }
    return RadialGradient;
}((0, $fe3eda7cb5345cd2$export$2e2bcd8739ae039));
var $5eb859f717d077f6$export$2e2bcd8739ae039 = $5eb859f717d077f6$var$RadialGradient;




var $95e9c620abdf35f3$var$extent = [
    0,
    0
];
var $95e9c620abdf35f3$var$extent2 = [
    0,
    0
];
var $95e9c620abdf35f3$var$minTv = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $95e9c620abdf35f3$var$maxTv = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $95e9c620abdf35f3$var$OrientedBoundingRect = function() {
    function OrientedBoundingRect(rect, transform) {
        this._corners = [];
        this._axes = [];
        this._origin = [
            0,
            0
        ];
        for(var i = 0; i < 4; i++)this._corners[i] = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
        for(var i = 0; i < 2; i++)this._axes[i] = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
        if (rect) this.fromBoundingRect(rect, transform);
    }
    OrientedBoundingRect.prototype.fromBoundingRect = function(rect, transform) {
        var corners = this._corners;
        var axes = this._axes;
        var x = rect.x;
        var y = rect.y;
        var x2 = x + rect.width;
        var y2 = y + rect.height;
        corners[0].set(x, y);
        corners[1].set(x2, y);
        corners[2].set(x2, y2);
        corners[3].set(x, y2);
        if (transform) for(var i = 0; i < 4; i++)corners[i].transform(transform);
        (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub(axes[0], corners[1], corners[0]);
        (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub(axes[1], corners[3], corners[0]);
        axes[0].normalize();
        axes[1].normalize();
        for(var i = 0; i < 2; i++)this._origin[i] = axes[i].dot(corners[0]);
    };
    OrientedBoundingRect.prototype.intersect = function(other, mtv) {
        var overlapped = true;
        var noMtv = !mtv;
        $95e9c620abdf35f3$var$minTv.set(Infinity, Infinity);
        $95e9c620abdf35f3$var$maxTv.set(0, 0);
        if (!this._intersectCheckOneSide(this, other, $95e9c620abdf35f3$var$minTv, $95e9c620abdf35f3$var$maxTv, noMtv, 1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!this._intersectCheckOneSide(other, this, $95e9c620abdf35f3$var$minTv, $95e9c620abdf35f3$var$maxTv, noMtv, -1)) {
            overlapped = false;
            if (noMtv) return overlapped;
        }
        if (!noMtv) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).copy(mtv, overlapped ? $95e9c620abdf35f3$var$minTv : $95e9c620abdf35f3$var$maxTv);
        return overlapped;
    };
    OrientedBoundingRect.prototype._intersectCheckOneSide = function(self, other, minTv, maxTv, noMtv, inverse) {
        var overlapped = true;
        for(var i = 0; i < 2; i++){
            var axis = this._axes[i];
            this._getProjMinMaxOnAxis(i, self._corners, $95e9c620abdf35f3$var$extent);
            this._getProjMinMaxOnAxis(i, other._corners, $95e9c620abdf35f3$var$extent2);
            if ($95e9c620abdf35f3$var$extent[1] < $95e9c620abdf35f3$var$extent2[0] || $95e9c620abdf35f3$var$extent[0] > $95e9c620abdf35f3$var$extent2[1]) {
                overlapped = false;
                if (noMtv) return overlapped;
                var dist0 = Math.abs($95e9c620abdf35f3$var$extent2[0] - $95e9c620abdf35f3$var$extent[1]);
                var dist1 = Math.abs($95e9c620abdf35f3$var$extent[0] - $95e9c620abdf35f3$var$extent2[1]);
                if (Math.min(dist0, dist1) > maxTv.len()) {
                    if (dist0 < dist1) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).scale(maxTv, axis, -dist0 * inverse);
                    else (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).scale(maxTv, axis, dist1 * inverse);
                }
            } else if (minTv) {
                var dist0 = Math.abs($95e9c620abdf35f3$var$extent2[0] - $95e9c620abdf35f3$var$extent[1]);
                var dist1 = Math.abs($95e9c620abdf35f3$var$extent[0] - $95e9c620abdf35f3$var$extent2[1]);
                if (Math.min(dist0, dist1) < minTv.len()) {
                    if (dist0 < dist1) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).scale(minTv, axis, dist0 * inverse);
                    else (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).scale(minTv, axis, -dist1 * inverse);
                }
            }
        }
        return overlapped;
    };
    OrientedBoundingRect.prototype._getProjMinMaxOnAxis = function(dim, corners, out) {
        var axis = this._axes[dim];
        var origin = this._origin;
        var proj = corners[0].dot(axis) + origin[dim];
        var min = proj;
        var max = proj;
        for(var i = 1; i < corners.length; i++){
            var proj_1 = corners[i].dot(axis) + origin[dim];
            min = Math.min(proj_1, min);
            max = Math.max(proj_1, max);
        }
        out[0] = min;
        out[1] = max;
    };
    return OrientedBoundingRect;
}();
var $95e9c620abdf35f3$export$2e2bcd8739ae039 = $95e9c620abdf35f3$var$OrientedBoundingRect;






var $d34a557c022d1393$var$m = [];
var $d34a557c022d1393$var$IncrementalDisplayable = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(IncrementalDisplayable, _super);
    function IncrementalDisplayable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notClear = true;
        _this.incremental = true;
        _this._displayables = [];
        _this._temporaryDisplayables = [];
        _this._cursor = 0;
        return _this;
    }
    IncrementalDisplayable.prototype.traverse = function(cb, context) {
        cb.call(context, this);
    };
    IncrementalDisplayable.prototype.useStyle = function() {
        this.style = {};
    };
    IncrementalDisplayable.prototype.getCursor = function() {
        return this._cursor;
    };
    IncrementalDisplayable.prototype.innerAfterBrush = function() {
        this._cursor = this._displayables.length;
    };
    IncrementalDisplayable.prototype.clearDisplaybles = function() {
        this._displayables = [];
        this._temporaryDisplayables = [];
        this._cursor = 0;
        this.markRedraw();
        this.notClear = false;
    };
    IncrementalDisplayable.prototype.clearTemporalDisplayables = function() {
        this._temporaryDisplayables = [];
    };
    IncrementalDisplayable.prototype.addDisplayable = function(displayable, notPersistent) {
        if (notPersistent) this._temporaryDisplayables.push(displayable);
        else this._displayables.push(displayable);
        this.markRedraw();
    };
    IncrementalDisplayable.prototype.addDisplayables = function(displayables, notPersistent) {
        notPersistent = notPersistent || false;
        for(var i = 0; i < displayables.length; i++)this.addDisplayable(displayables[i], notPersistent);
    };
    IncrementalDisplayable.prototype.getDisplayables = function() {
        return this._displayables;
    };
    IncrementalDisplayable.prototype.getTemporalDisplayables = function() {
        return this._temporaryDisplayables;
    };
    IncrementalDisplayable.prototype.eachPendingDisplayable = function(cb) {
        for(var i = this._cursor; i < this._displayables.length; i++)cb && cb(this._displayables[i]);
        for(var i = 0; i < this._temporaryDisplayables.length; i++)cb && cb(this._temporaryDisplayables[i]);
    };
    IncrementalDisplayable.prototype.update = function() {
        this.updateTransform();
        for(var i = this._cursor; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
        for(var i = 0; i < this._temporaryDisplayables.length; i++){
            var displayable = this._temporaryDisplayables[i];
            displayable.parent = this;
            displayable.update();
            displayable.parent = null;
        }
    };
    IncrementalDisplayable.prototype.getBoundingRect = function() {
        if (!this._rect) {
            var rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(Infinity, Infinity, -Infinity, -Infinity);
            for(var i = 0; i < this._displayables.length; i++){
                var displayable = this._displayables[i];
                var childRect = displayable.getBoundingRect().clone();
                if (displayable.needLocalTransform()) childRect.applyTransform(displayable.getLocalTransform($d34a557c022d1393$var$m));
                rect.union(childRect);
            }
            this._rect = rect;
        }
        return this._rect;
    };
    IncrementalDisplayable.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        if (rect.contain(localPos[0], localPos[1])) for(var i = 0; i < this._displayables.length; i++){
            var displayable = this._displayables[i];
            if (displayable.contain(x, y)) return true;
        }
        return false;
    };
    return IncrementalDisplayable;
}((0, $cfd8540aca1ca40f$export$2e2bcd8739ae039));
var $d34a557c022d1393$export$2e2bcd8739ae039 = $d34a557c022d1393$var$IncrementalDisplayable;






var $8eb95236e1aa01e7$var$mathMax = Math.max;
var $8eb95236e1aa01e7$var$mathMin = Math.min;
var $8eb95236e1aa01e7$var$_customShapeMap = {};
function $8eb95236e1aa01e7$export$d0d5398c9d612037(opts) {
    return (0, $f9698154c9fcf427$export$2e2bcd8739ae039).extend(opts);
}
var $8eb95236e1aa01e7$var$extendPathFromString = $f444b8fb72be0619$export$68e3a51ba2ed417c;
function $8eb95236e1aa01e7$export$53b54a3137026af0(pathData, opts) {
    return $8eb95236e1aa01e7$var$extendPathFromString(pathData, opts);
}
function $8eb95236e1aa01e7$export$2b95b62e3aaf6fdd(name, ShapeClass) {
    $8eb95236e1aa01e7$var$_customShapeMap[name] = ShapeClass;
}
function $8eb95236e1aa01e7$export$51df4b5565a58189(name) {
    if ($8eb95236e1aa01e7$var$_customShapeMap.hasOwnProperty(name)) return $8eb95236e1aa01e7$var$_customShapeMap[name];
}
function $8eb95236e1aa01e7$export$aa9bab72412f5613(pathData, opts, rect, layout) {
    var path = $f444b8fb72be0619$export$ae5b259626f00aeb(pathData, opts);
    if (rect) {
        if (layout === 'center') rect = $8eb95236e1aa01e7$var$centerGraphic(rect, path.getBoundingRect());
        $8eb95236e1aa01e7$export$566dbf1c62b04fc7(path, rect);
    }
    return path;
}
function $8eb95236e1aa01e7$export$7a2bdede98851ac5(imageUrl, rect, layout) {
    var zrImg = new (0, $29f98103052059af$export$2e2bcd8739ae039)({
        style: {
            image: imageUrl,
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        onload: function(img) {
            if (layout === 'center') {
                var boundingRect = {
                    width: img.width,
                    height: img.height
                };
                zrImg.setStyle($8eb95236e1aa01e7$var$centerGraphic(rect, boundingRect));
            }
        }
    });
    return zrImg;
}
/**
 * Get position of centered element in bounding box.
 *
 * @param  rect         element local bounding box
 * @param  boundingRect constraint bounding box
 * @return element position containing x, y, width, and height
 */ function $8eb95236e1aa01e7$var$centerGraphic(rect, boundingRect) {
    // Set rect to center, keep width / height ratio.
    var aspect = boundingRect.width / boundingRect.height;
    var width = rect.height * aspect;
    var height;
    if (width <= rect.width) height = rect.height;
    else {
        width = rect.width;
        height = width / aspect;
    }
    var cx = rect.x + rect.width / 2;
    var cy = rect.y + rect.height / 2;
    return {
        x: cx - width / 2,
        y: cy - height / 2,
        width: width,
        height: height
    };
}
var $8eb95236e1aa01e7$export$7b1dd269fbc4e903 = $f444b8fb72be0619$export$7b1dd269fbc4e903;
function $8eb95236e1aa01e7$export$566dbf1c62b04fc7(path, rect) {
    if (!path.applyTransform) return;
    var pathRect = path.getBoundingRect();
    var m = pathRect.calculateTransform(rect);
    path.applyTransform(m);
}
function $8eb95236e1aa01e7$export$8b4b620d7f4aad1b(shape, lineWidth) {
    $76bb43c2e594ce84$export$8b4b620d7f4aad1b(shape, shape, {
        lineWidth: lineWidth
    });
    return shape;
}
function $8eb95236e1aa01e7$export$60e2aa74957d0b9d(param) {
    $76bb43c2e594ce84$export$60e2aa74957d0b9d(param.shape, param.shape, param.style);
    return param;
}
var $8eb95236e1aa01e7$export$72c4fd4c1b8fcb10 = $76bb43c2e594ce84$export$72c4fd4c1b8fcb10;
function $8eb95236e1aa01e7$export$fce0c6cfca85ed96(target, ancestor) {
    var mat = $78537c687449356c$export$f0954fd7d5368655([]);
    while(target && target !== ancestor){
        $78537c687449356c$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
        target = target.parent;
    }
    return mat;
}
function $8eb95236e1aa01e7$export$9f9dcb98c894b623(target, transform, invert) {
    if (transform && !(0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(transform)) transform = (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039).getLocalTransform(transform);
    if (invert) transform = $78537c687449356c$export$6897c284b6f9f4dc([], transform);
    return $3dde7d051fe20daa$export$9f9dcb98c894b623([], target, transform);
}
function $8eb95236e1aa01e7$export$fff94e9792354cfa(direction, transform, invert) {
    // Pick a base, ensure that transform result will not be (0, 0).
    var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
    var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
    var vertex = [
        direction === 'left' ? -hBase : direction === 'right' ? hBase : 0,
        direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0
    ];
    vertex = $8eb95236e1aa01e7$export$9f9dcb98c894b623(vertex, transform, invert);
    return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
}
function $8eb95236e1aa01e7$var$isNotGroup(el) {
    return !el.isGroup;
}
function $8eb95236e1aa01e7$var$isPath(el) {
    return el.shape != null;
}
function $8eb95236e1aa01e7$export$64fcab7860c216ae(g1, g2, animatableModel) {
    if (!g1 || !g2) return;
    function getElMap(g) {
        var elMap = {};
        g.traverse(function(el) {
            if ($8eb95236e1aa01e7$var$isNotGroup(el) && el.anid) elMap[el.anid] = el;
        });
        return elMap;
    }
    function getAnimatableProps(el) {
        var obj = {
            x: el.x,
            y: el.y,
            rotation: el.rotation
        };
        if ($8eb95236e1aa01e7$var$isPath(el)) obj.shape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, el.shape);
        return obj;
    }
    var elMap1 = getElMap(g1);
    g2.traverse(function(el) {
        if ($8eb95236e1aa01e7$var$isNotGroup(el) && el.anid) {
            var oldEl = elMap1[el.anid];
            if (oldEl) {
                var newProp = getAnimatableProps(el);
                el.attr(getAnimatableProps(oldEl));
                (0, $b40111164617dd60$export$c8dce3c08436e91e)(el, newProp, animatableModel, (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).dataIndex);
            }
        }
    });
}
function $8eb95236e1aa01e7$export$e2f409471bbbc1dc(points, rect) {
    // FIXME: This way might be incorrect when graphic clipped by a corner
    // and when element has a border.
    return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(points, function(point) {
        var x = point[0];
        x = $8eb95236e1aa01e7$var$mathMax(x, rect.x);
        x = $8eb95236e1aa01e7$var$mathMin(x, rect.x + rect.width);
        var y = point[1];
        y = $8eb95236e1aa01e7$var$mathMax(y, rect.y);
        y = $8eb95236e1aa01e7$var$mathMin(y, rect.y + rect.height);
        return [
            x,
            y
        ];
    });
}
function $8eb95236e1aa01e7$export$d0d3709202b8b2a(targetRect, rect) {
    var x = $8eb95236e1aa01e7$var$mathMax(targetRect.x, rect.x);
    var x2 = $8eb95236e1aa01e7$var$mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
    var y = $8eb95236e1aa01e7$var$mathMax(targetRect.y, rect.y);
    var y2 = $8eb95236e1aa01e7$var$mathMin(targetRect.y + targetRect.height, rect.y + rect.height);
    // If the total rect is cliped, nothing, including the border,
    // should be painted. So return undefined.
    if (x2 >= x && y2 >= y) return {
        x: x,
        y: y,
        width: x2 - x,
        height: y2 - y
    };
}
function $8eb95236e1aa01e7$export$274edc73af1ae9c8(iconStr, // Support 'image://' or 'path://' or direct svg path.
opt, rect) {
    var innerOpts = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
        rectHover: true
    }, opt);
    var style = innerOpts.style = {
        strokeNoScale: true
    };
    rect = rect || {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    };
    if (iconStr) return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(style, rect), new (0, $29f98103052059af$export$2e2bcd8739ae039)(innerOpts)) : $8eb95236e1aa01e7$export$aa9bab72412f5613(iconStr.replace('path://', ''), innerOpts, rect, 'center');
}
function $8eb95236e1aa01e7$export$4f47c855a5e9ae9(a1x, a1y, a2x, a2y, points) {
    for(var i = 0, p2 = points[points.length - 1]; i < points.length; i++){
        var p = points[i];
        if ($8eb95236e1aa01e7$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) return true;
        p2 = p;
    }
}
function $8eb95236e1aa01e7$export$6c0a70ea1d8d158b(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    // `vec_m` and `vec_n` are parallel iff
    //     existing `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
    var nmCrossProduct = $8eb95236e1aa01e7$var$crossProduct2d(nx, ny, mx, my);
    if ($8eb95236e1aa01e7$var$nearZero(nmCrossProduct)) return false;
    // `vec_m` and `vec_n` are intersect iff
    //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
    //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
    //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var q = $8eb95236e1aa01e7$var$crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
    if (q < 0 || q > 1) return false;
    var p = $8eb95236e1aa01e7$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return false;
    return true;
}
/**
 * Cross product of 2-dimension vector.
 */ function $8eb95236e1aa01e7$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $8eb95236e1aa01e7$var$nearZero(val) {
    return val <= 1e-6 && val >= -0.000001;
}
function $8eb95236e1aa01e7$export$fc6410d97fab306c(opt) {
    var itemTooltipOption = opt.itemTooltipOption;
    var componentModel = opt.componentModel;
    var itemName = opt.itemName;
    var itemTooltipOptionObj = (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(itemTooltipOption) ? {
        formatter: itemTooltipOption
    } : itemTooltipOption;
    var mainType = componentModel.mainType;
    var componentIndex = componentModel.componentIndex;
    var formatterParams = {
        componentType: mainType,
        name: itemName,
        $vars: [
            'name'
        ]
    };
    formatterParams[mainType + 'Index'] = componentIndex;
    var formatterParamsExtra = opt.formatterParamsExtra;
    if (formatterParamsExtra) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(formatterParamsExtra), function(key) {
        if (!(0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(formatterParams, key)) {
            formatterParams[key] = formatterParamsExtra[key];
            formatterParams.$vars.push(key);
        }
    });
    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(opt.el);
    ecData.componentMainType = mainType;
    ecData.componentIndex = componentIndex;
    ecData.tooltipConfig = {
        name: itemName,
        option: (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
            content: itemName,
            encodeHTMLContent: true,
            formatterParams: formatterParams
        }, itemTooltipOptionObj)
    };
}
function $8eb95236e1aa01e7$var$traverseElement(el, cb) {
    var stopped;
    // TODO
    // Polyfill for fixing zrender group traverse don't visit it's root issue.
    if (el.isGroup) stopped = cb(el);
    if (!stopped) el.traverse(cb);
}
function $8eb95236e1aa01e7$export$3e564442729bf048(els, cb) {
    if (els) {
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(els)) for(var i = 0; i < els.length; i++)$8eb95236e1aa01e7$var$traverseElement(els[i], cb);
        else $8eb95236e1aa01e7$var$traverseElement(els, cb);
    }
}
// Register built-in shapes. These shapes might be overwritten
// by users, although we do not recommend that.
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('circle', (0, $7257c7c7414f291c$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('ellipse', (0, $eeb942ee95fdec12$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('sector', (0, $5fa26352e0605e60$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('ring', (0, $bbdefe74c63a4c47$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('polygon', (0, $399011f87accd5da$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('polyline', (0, $f7f6523750aec7c8$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('rect', (0, $37476269d425e3f6$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('line', (0, $8324e8379a5583a5$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('bezierCurve', (0, $13bf9e04ebecd3f2$export$2e2bcd8739ae039));
$8eb95236e1aa01e7$export$2b95b62e3aaf6fdd('arc', (0, $5be9485ee0d860f6$export$2e2bcd8739ae039));


var $3828198b2f2de836$var$EMPTY_OBJ = {};
function $3828198b2f2de836$export$b533918394a58529(label, labelTexts) {
    for(var i = 0; i < (0, $b414df7d361a211c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $b414df7d361a211c$export$151308dceb52d5b)[i];
        var text = labelTexts[stateName];
        var state = label.ensureState(stateName);
        state.style = state.style || {};
        state.style.text = text;
    }
    var oldStates = label.currentStates.slice();
    label.clearStates(true);
    label.setStyle({
        text: labelTexts.normal
    });
    label.useStates(oldStates, true);
}
function $3828198b2f2de836$var$getLabelText(opt, stateModels, interpolatedValue) {
    var labelFetcher = opt.labelFetcher;
    var labelDataIndex = opt.labelDataIndex;
    var labelDimIndex = opt.labelDimIndex;
    var normalModel = stateModels.normal;
    var baseText;
    if (labelFetcher) baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, normalModel && normalModel.get('formatter'), interpolatedValue != null ? {
        interpolatedValue: interpolatedValue
    } : null);
    if (baseText == null) baseText = (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(opt.defaultText) ? opt.defaultText(labelDataIndex, opt, interpolatedValue) : opt.defaultText;
    var statesText = {
        normal: baseText
    };
    for(var i = 0; i < (0, $b414df7d361a211c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $b414df7d361a211c$export$151308dceb52d5b)[i];
        var stateModel = stateModels[stateName];
        statesText[stateName] = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, stateName, null, labelDimIndex, stateModel && stateModel.get('formatter')) : null, baseText);
    }
    return statesText;
}
function $3828198b2f2de836$export$9a13992917966657(targetEl, labelStatesModels, opt, stateSpecified) {
    opt = opt || $3828198b2f2de836$var$EMPTY_OBJ;
    var isSetOnText = targetEl instanceof (0, $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039);
    var needsCreateText = false;
    for(var i = 0; i < (0, $b414df7d361a211c$export$57ee5306b85ad7d5).length; i++){
        var stateModel = labelStatesModels[(0, $b414df7d361a211c$export$57ee5306b85ad7d5)[i]];
        if (stateModel && stateModel.getShallow('show')) {
            needsCreateText = true;
            break;
        }
    }
    var textContent = isSetOnText ? targetEl : targetEl.getTextContent();
    if (needsCreateText) {
        if (!isSetOnText) {
            // Reuse the previous
            if (!textContent) {
                textContent = new (0, $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039)();
                targetEl.setTextContent(textContent);
            }
            // Use same state proxy
            if (targetEl.stateProxy) textContent.stateProxy = targetEl.stateProxy;
        }
        var labelStatesTexts = $3828198b2f2de836$var$getLabelText(opt, labelStatesModels);
        var normalModel = labelStatesModels.normal;
        var showNormal = !!normalModel.getShallow('show');
        var normalStyle = $3828198b2f2de836$export$f8998c3d0a13de59(normalModel, stateSpecified && stateSpecified.normal, opt, false, !isSetOnText);
        normalStyle.text = labelStatesTexts.normal;
        if (!isSetOnText) // Always create new
        targetEl.setTextConfig($3828198b2f2de836$export$e149afab8df6e053(normalModel, opt, false));
        for(var i = 0; i < (0, $b414df7d361a211c$export$151308dceb52d5b).length; i++){
            var stateName = (0, $b414df7d361a211c$export$151308dceb52d5b)[i];
            var stateModel = labelStatesModels[stateName];
            if (stateModel) {
                var stateObj = textContent.ensureState(stateName);
                var stateShow = !!(0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(stateModel.getShallow('show'), showNormal);
                if (stateShow !== showNormal) stateObj.ignore = !stateShow;
                stateObj.style = $3828198b2f2de836$export$f8998c3d0a13de59(stateModel, stateSpecified && stateSpecified[stateName], opt, true, !isSetOnText);
                stateObj.style.text = labelStatesTexts[stateName];
                if (!isSetOnText) {
                    var targetElEmphasisState = targetEl.ensureState(stateName);
                    targetElEmphasisState.textConfig = $3828198b2f2de836$export$e149afab8df6e053(stateModel, opt, true);
                }
            }
        }
        // PENDING: if there is many requirements that emphasis position
        // need to be different from normal position, we might consider
        // auto silent is those cases.
        textContent.silent = !!normalModel.getShallow('silent');
        // Keep x and y
        if (textContent.style.x != null) normalStyle.x = textContent.style.x;
        if (textContent.style.y != null) normalStyle.y = textContent.style.y;
        textContent.ignore = !showNormal;
        // Always create new style.
        textContent.useStyle(normalStyle);
        textContent.dirty();
        if (opt.enableTextSetter) $3828198b2f2de836$export$f62786d3261ab0f4(textContent).setLabelText = function(interpolatedValue) {
            var labelStatesTexts = $3828198b2f2de836$var$getLabelText(opt, labelStatesModels, interpolatedValue);
            $3828198b2f2de836$export$b533918394a58529(textContent, labelStatesTexts);
        };
    } else if (textContent) // Not display rich text.
    textContent.ignore = true;
    targetEl.dirty();
}
function $3828198b2f2de836$export$9739a32674be5893(itemModel, labelName) {
    labelName = labelName || 'label';
    var statesModels = {
        normal: itemModel.getModel(labelName)
    };
    for(var i = 0; i < (0, $b414df7d361a211c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $b414df7d361a211c$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelName
        ]);
    }
    return statesModels;
}
function $3828198b2f2de836$export$f8998c3d0a13de59(textStyleModel, specifiedTextStyle, // Fixed style in the code. Can't be set by model.
opt, isNotNormal, isAttached // If text is attached on an element. If so, auto color will handling in zrender.
) {
    var textStyle = {};
    $3828198b2f2de836$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached);
    specifiedTextStyle && (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(textStyle, specifiedTextStyle);
    // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
    return textStyle;
}
function $3828198b2f2de836$export$e149afab8df6e053(textStyleModel, opt, isNotNormal) {
    opt = opt || {};
    var textConfig = {};
    var labelPosition;
    var labelRotate = textStyleModel.getShallow('rotate');
    var labelDistance = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textStyleModel.getShallow('distance'), isNotNormal ? null : 5);
    var labelOffset = textStyleModel.getShallow('offset');
    labelPosition = textStyleModel.getShallow('position') || (isNotNormal ? null : 'inside');
    // 'outside' is not a valid zr textPostion value, but used
    // in bar series, and magric type should be considered.
    labelPosition === 'outside' && (labelPosition = opt.defaultOutsidePosition || 'top');
    if (labelPosition != null) textConfig.position = labelPosition;
    if (labelOffset != null) textConfig.offset = labelOffset;
    if (labelRotate != null) {
        labelRotate *= Math.PI / 180;
        textConfig.rotation = labelRotate;
    }
    if (labelDistance != null) textConfig.distance = labelDistance;
    // fill and auto is determined by the color of path fill if it's not specified by developers.
    textConfig.outsideFill = textStyleModel.get('color') === 'inherit' ? opt.inheritColor || null : 'auto';
    return textConfig;
}
/**
 * The uniform entry of set text style, that is, retrieve style definitions
 * from `model` and set to `textStyle` object.
 *
 * Never in merge mode, but in overwrite mode, that is, all of the text style
 * properties will be set. (Consider the states of normal and emphasis and
 * default value can be adopted, merge would make the logic too complicated
 * to manage.)
 */ function $3828198b2f2de836$var$setTextStyleCommon(textStyle, textStyleModel, opt, isNotNormal, isAttached) {
    // Consider there will be abnormal when merge hover style to normal style if given default value.
    opt = opt || $3828198b2f2de836$var$EMPTY_OBJ;
    var ecModel = textStyleModel.ecModel;
    var globalTextStyle = ecModel && ecModel.option.textStyle;
    // Consider case:
    // {
    //     data: [{
    //         value: 12,
    //         label: {
    //             rich: {
    //                 // no 'a' here but using parent 'a'.
    //             }
    //         }
    //     }],
    //     rich: {
    //         a: { ... }
    //     }
    // }
    var richItemNames = $3828198b2f2de836$var$getRichItemNames(textStyleModel);
    var richResult;
    if (richItemNames) {
        richResult = {};
        for(var name_1 in richItemNames)if (richItemNames.hasOwnProperty(name_1)) {
            // Cascade is supported in rich.
            var richTextStyle = textStyleModel.getModel([
                'rich',
                name_1
            ]);
            // In rich, never `disableBox`.
            // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
            // the default color `'blue'` will not be adopted if no color declared in `rich`.
            // That might confuses users. So probably we should put `textStyleModel` as the
            // root ancestor of the `richTextStyle`. But that would be a break change.
            $3828198b2f2de836$var$setTokenTextStyle(richResult[name_1] = {}, richTextStyle, globalTextStyle, opt, isNotNormal, isAttached, false, true);
        }
    }
    if (richResult) textStyle.rich = richResult;
    var overflow = textStyleModel.get('overflow');
    if (overflow) textStyle.overflow = overflow;
    var margin = textStyleModel.get('minMargin');
    if (margin != null) textStyle.margin = margin;
    $3828198b2f2de836$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, true, false);
}
// Consider case:
// {
//     data: [{
//         value: 12,
//         label: {
//             rich: {
//                 // no 'a' here but using parent 'a'.
//             }
//         }
//     }],
//     rich: {
//         a: { ... }
//     }
// }
// TODO TextStyleModel
function $3828198b2f2de836$var$getRichItemNames(textStyleModel) {
    // Use object to remove duplicated names.
    var richItemNameMap;
    while(textStyleModel && textStyleModel !== textStyleModel.ecModel){
        var rich = (textStyleModel.option || $3828198b2f2de836$var$EMPTY_OBJ).rich;
        if (rich) {
            richItemNameMap = richItemNameMap || {};
            var richKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(rich);
            for(var i = 0; i < richKeys.length; i++){
                var richKey = richKeys[i];
                richItemNameMap[richKey] = 1;
            }
        }
        textStyleModel = textStyleModel.parentModel;
    }
    return richItemNameMap;
}
var $3828198b2f2de836$var$TEXT_PROPS_WITH_GLOBAL = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'textShadowColor',
    'textShadowBlur',
    'textShadowOffsetX',
    'textShadowOffsetY'
];
var $3828198b2f2de836$var$TEXT_PROPS_SELF = [
    'align',
    'lineHeight',
    'width',
    'height',
    'tag',
    'verticalAlign',
    'ellipsis'
];
var $3828198b2f2de836$var$TEXT_PROPS_BOX = [
    'padding',
    'borderWidth',
    'borderRadius',
    'borderDashOffset',
    'backgroundColor',
    'borderColor',
    'shadowColor',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
function $3828198b2f2de836$var$setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isNotNormal, isAttached, isBlock, inRich) {
    // In merge mode, default value should not be given.
    globalTextStyle = !isNotNormal && globalTextStyle || $3828198b2f2de836$var$EMPTY_OBJ;
    var inheritColor = opt && opt.inheritColor;
    var fillColor = textStyleModel.getShallow('color');
    var strokeColor = textStyleModel.getShallow('textBorderColor');
    var opacity = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textStyleModel.getShallow('opacity'), globalTextStyle.opacity);
    if (fillColor === 'inherit' || fillColor === 'auto') {
        if (inheritColor) fillColor = inheritColor;
        else fillColor = null;
    }
    if (strokeColor === 'inherit' || strokeColor === 'auto') {
        if (inheritColor) strokeColor = inheritColor;
        else strokeColor = null;
    }
    if (!isAttached) {
        // Only use default global textStyle.color if text is individual.
        // Otherwise it will use the strategy of attached text color because text may be on a path.
        fillColor = fillColor || globalTextStyle.color;
        strokeColor = strokeColor || globalTextStyle.textBorderColor;
    }
    if (fillColor != null) textStyle.fill = fillColor;
    if (strokeColor != null) textStyle.stroke = strokeColor;
    var textBorderWidth = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
    if (textBorderWidth != null) textStyle.lineWidth = textBorderWidth;
    var textBorderType = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderType'), globalTextStyle.textBorderType);
    if (textBorderType != null) textStyle.lineDash = textBorderType;
    var textBorderDashOffset = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textStyleModel.getShallow('textBorderDashOffset'), globalTextStyle.textBorderDashOffset);
    if (textBorderDashOffset != null) textStyle.lineDashOffset = textBorderDashOffset;
    if (!isNotNormal && opacity == null && !inRich) opacity = opt && opt.defaultOpacity;
    if (opacity != null) textStyle.opacity = opacity;
    // TODO
    if (!isNotNormal && !isAttached) // Set default finally.
    {
        if (textStyle.fill == null && opt.inheritColor) textStyle.fill = opt.inheritColor;
    }
    // Do not use `getFont` here, because merge should be supported, where
    // part of these properties may be changed in emphasis style, and the
    // others should remain their original value got from normal style.
    for(var i = 0; i < $3828198b2f2de836$var$TEXT_PROPS_WITH_GLOBAL.length; i++){
        var key = $3828198b2f2de836$var$TEXT_PROPS_WITH_GLOBAL[i];
        var val = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textStyleModel.getShallow(key), globalTextStyle[key]);
        if (val != null) textStyle[key] = val;
    }
    for(var i = 0; i < $3828198b2f2de836$var$TEXT_PROPS_SELF.length; i++){
        var key = $3828198b2f2de836$var$TEXT_PROPS_SELF[i];
        var val = textStyleModel.getShallow(key);
        if (val != null) textStyle[key] = val;
    }
    if (textStyle.verticalAlign == null) {
        var baseline = textStyleModel.getShallow('baseline');
        if (baseline != null) textStyle.verticalAlign = baseline;
    }
    if (!isBlock || !opt.disableBox) {
        for(var i = 0; i < $3828198b2f2de836$var$TEXT_PROPS_BOX.length; i++){
            var key = $3828198b2f2de836$var$TEXT_PROPS_BOX[i];
            var val = textStyleModel.getShallow(key);
            if (val != null) textStyle[key] = val;
        }
        var borderType = textStyleModel.getShallow('borderType');
        if (borderType != null) textStyle.borderDash = borderType;
        if ((textStyle.backgroundColor === 'auto' || textStyle.backgroundColor === 'inherit') && inheritColor) textStyle.backgroundColor = inheritColor;
        if ((textStyle.borderColor === 'auto' || textStyle.borderColor === 'inherit') && inheritColor) textStyle.borderColor = inheritColor;
    }
}
function $3828198b2f2de836$export$155316a870a9d61e(opt, ecModel) {
    var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
    return (0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)([
        // FIXME in node-canvas fontWeight is before fontStyle
        opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '',
        opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '',
        (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px',
        opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'
    ].join(' '));
}
var $3828198b2f2de836$export$f62786d3261ab0f4 = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $3828198b2f2de836$export$7bdbceaf9ab378f2(label, labelStatesModels, value, getDefaultText) {
    if (!label) return;
    var obj = $3828198b2f2de836$export$f62786d3261ab0f4(label);
    obj.prevValue = obj.value;
    obj.value = value;
    var normalLabelModel = labelStatesModels.normal;
    obj.valueAnimation = normalLabelModel.get('valueAnimation');
    if (obj.valueAnimation) {
        obj.precision = normalLabelModel.get('precision');
        obj.defaultInterpolatedText = getDefaultText;
        obj.statesModels = labelStatesModels;
    }
}
function $3828198b2f2de836$export$dd6101605f5c186(textEl, dataIndex, data, animatableModel, labelFetcher) {
    var labelInnerStore = $3828198b2f2de836$export$f62786d3261ab0f4(textEl);
    if (!labelInnerStore.valueAnimation || labelInnerStore.prevValue === labelInnerStore.value) // Value not changed, no new label animation
    return;
    var defaultInterpolatedText = labelInnerStore.defaultInterpolatedText;
    // Consider the case that being animating, do not use the `obj.value`,
    // Otherwise it will jump to the `obj.value` when this new animation started.
    var currValue = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(labelInnerStore.interpolatedValue, labelInnerStore.prevValue);
    var targetValue = labelInnerStore.value;
    function during(percent) {
        var interpolated = (0, $9ac03c46e8b6e711$export$bd0439821a1869f3)(data, labelInnerStore.precision, currValue, targetValue, percent);
        labelInnerStore.interpolatedValue = percent === 1 ? null : interpolated;
        var labelText = $3828198b2f2de836$var$getLabelText({
            labelDataIndex: dataIndex,
            labelFetcher: labelFetcher,
            defaultText: defaultInterpolatedText ? defaultInterpolatedText(interpolated) : interpolated + ''
        }, labelInnerStore.statesModels, interpolated);
        $3828198b2f2de836$export$b533918394a58529(textEl, labelText);
    }
    textEl.percent = 0;
    (labelInnerStore.prevValue == null ? (0, $b40111164617dd60$export$a121566aadcfe021) : (0, $b40111164617dd60$export$c8dce3c08436e91e))(textEl, {
        // percent is used to prevent animation from being aborted #15916
        percent: 1
    }, animatableModel, dataIndex, null, during);
}



var $e2551acac8eeeb09$var$PATH_COLOR = [
    'textStyle',
    'color'
];
var $e2551acac8eeeb09$var$textStyleParams = [
    'fontStyle',
    'fontWeight',
    'fontSize',
    'fontFamily',
    'padding',
    'lineHeight',
    'rich',
    'width',
    'height',
    'overflow'
];
// TODO Performance improvement?
var $e2551acac8eeeb09$var$tmpText = new (0, $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039)();
var $e2551acac8eeeb09$var$TextStyleMixin = /** @class */ function() {
    function TextStyleMixin() {}
    /**
   * Get color property or get color from option.textStyle.color
   */ // TODO Callback
    TextStyleMixin.prototype.getTextColor = function(isEmphasis) {
        var ecModel = this.ecModel;
        return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get($e2551acac8eeeb09$var$PATH_COLOR) : null);
    };
    /**
   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
   * @return {string}
   */ TextStyleMixin.prototype.getFont = function() {
        return (0, $3828198b2f2de836$export$155316a870a9d61e)({
            fontStyle: this.getShallow('fontStyle'),
            fontWeight: this.getShallow('fontWeight'),
            fontSize: this.getShallow('fontSize'),
            fontFamily: this.getShallow('fontFamily')
        }, this.ecModel);
    };
    TextStyleMixin.prototype.getTextRect = function(text) {
        var style = {
            text: text,
            verticalAlign: this.getShallow('verticalAlign') || this.getShallow('baseline')
        };
        for(var i = 0; i < $e2551acac8eeeb09$var$textStyleParams.length; i++)style[$e2551acac8eeeb09$var$textStyleParams[i]] = this.getShallow($e2551acac8eeeb09$var$textStyleParams[i]);
        $e2551acac8eeeb09$var$tmpText.useStyle(style);
        $e2551acac8eeeb09$var$tmpText.update();
        return $e2551acac8eeeb09$var$tmpText.getBoundingRect();
    };
    return TextStyleMixin;
}();
var $e2551acac8eeeb09$export$2e2bcd8739ae039 = $e2551acac8eeeb09$var$TextStyleMixin;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $bfbaffcfb5351f33$export$9f34de5b59222949 = [
    [
        'lineWidth',
        'width'
    ],
    [
        'stroke',
        'color'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'type'
    ],
    [
        'lineDashOffset',
        'dashOffset'
    ],
    [
        'lineCap',
        'cap'
    ],
    [
        'lineJoin',
        'join'
    ],
    [
        'miterLimit'
    ]
];
var $bfbaffcfb5351f33$var$getLineStyle = (0, $8555b33f89f2677c$export$2e2bcd8739ae039)($bfbaffcfb5351f33$export$9f34de5b59222949);
var $bfbaffcfb5351f33$export$91eeeeed4a69a7e7 = /** @class */ function() {
    function LineStyleMixin() {}
    LineStyleMixin.prototype.getLineStyle = function(excludes) {
        return $bfbaffcfb5351f33$var$getLineStyle(this, excludes);
    };
    return LineStyleMixin;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $af85fd575926d85b$export$ffb0bba5dde0130b = [
    [
        'fill',
        'color'
    ],
    [
        'stroke',
        'borderColor'
    ],
    [
        'lineWidth',
        'borderWidth'
    ],
    [
        'opacity'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ],
    [
        'lineDash',
        'borderType'
    ],
    [
        'lineDashOffset',
        'borderDashOffset'
    ],
    [
        'lineCap',
        'borderCap'
    ],
    [
        'lineJoin',
        'borderJoin'
    ],
    [
        'miterLimit',
        'borderMiterLimit'
    ]
];
var $af85fd575926d85b$var$getItemStyle = (0, $8555b33f89f2677c$export$2e2bcd8739ae039)($af85fd575926d85b$export$ffb0bba5dde0130b);
var $af85fd575926d85b$export$e4f01e48d6fda412 = /** @class */ function() {
    function ItemStyleMixin() {}
    ItemStyleMixin.prototype.getItemStyle = function(excludes, includes) {
        return $af85fd575926d85b$var$getItemStyle(this, excludes, includes);
    };
    return ItemStyleMixin;
}();



var $3c5c9c3617b9c261$var$Model = /** @class */ function() {
    function Model(option, parentModel, ecModel) {
        this.parentModel = parentModel;
        this.ecModel = ecModel;
        this.option = option;
    // Simple optimization
    // if (this.init) {
    //     if (arguments.length <= 4) {
    //         this.init(option, parentModel, ecModel, extraOpt);
    //     }
    //     else {
    //         this.init.apply(this, arguments);
    //     }
    // }
    }
    Model.prototype.init = function(option, parentModel, ecModel) {
        var rest = [];
        for(var _i = 3; _i < arguments.length; _i++)rest[_i - 3] = arguments[_i];
    };
    /**
   * Merge the input option to me.
   */ Model.prototype.mergeOption = function(option, ecModel) {
        (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(this.option, option, true);
    };
    // `path` can be 'a.b.c', so the return value type have to be `ModelOption`
    // TODO: TYPE strict key check?
    // get(path: string | string[], ignoreParent?: boolean): ModelOption;
    Model.prototype.get = function(path, ignoreParent) {
        if (path == null) return this.option;
        return this._doGet(this.parsePath(path), !ignoreParent && this.parentModel);
    };
    Model.prototype.getShallow = function(key, ignoreParent) {
        var option = this.option;
        var val = option == null ? option : option[key];
        if (val == null && !ignoreParent) {
            var parentModel = this.parentModel;
            if (parentModel) // FIXME:TS do not know how to make it works
            val = parentModel.getShallow(key);
        }
        return val;
    };
    // `path` can be 'a.b.c', so the return value type have to be `Model<ModelOption>`
    // getModel(path: string | string[], parentModel?: Model): Model;
    // TODO 'a.b.c' is deprecated
    Model.prototype.getModel = function(path, parentModel) {
        var hasPath = path != null;
        var pathFinal = hasPath ? this.parsePath(path) : null;
        var obj = hasPath ? this._doGet(pathFinal) : this.option;
        parentModel = parentModel || this.parentModel && this.parentModel.getModel(this.resolveParentPath(pathFinal));
        return new Model(obj, parentModel, this.ecModel);
    };
    /**
   * If model has option
   */ Model.prototype.isEmpty = function() {
        return this.option == null;
    };
    Model.prototype.restoreData = function() {};
    // Pending
    Model.prototype.clone = function() {
        var Ctor = this.constructor;
        return new Ctor((0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(this.option));
    };
    // setReadOnly(properties): void {
    // clazzUtil.setReadOnly(this, properties);
    // }
    // If path is null/undefined, return null/undefined.
    Model.prototype.parsePath = function(path) {
        if (typeof path === 'string') return path.split('.');
        return path;
    };
    // Resolve path for parent. Perhaps useful when parent use a different property.
    // Default to be a identity resolver.
    // Can be modified to a different resolver.
    Model.prototype.resolveParentPath = function(path) {
        return path;
    };
    // FIXME:TS check whether put this method here
    Model.prototype.isAnimationEnabled = function() {
        if (!(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node && this.option) {
            if (this.option.animation != null) return !!this.option.animation;
            else if (this.parentModel) return this.parentModel.isAnimationEnabled();
        }
    };
    Model.prototype._doGet = function(pathArr, parentModel) {
        var obj = this.option;
        if (!pathArr) return obj;
        for(var i = 0; i < pathArr.length; i++){
            // Ignore empty
            if (!pathArr[i]) continue;
            // obj could be number/string/... (like 0)
            obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
            if (obj == null) break;
        }
        if (obj == null && parentModel) obj = parentModel._doGet(this.resolveParentPath(pathArr), parentModel.parentModel);
        return obj;
    };
    return Model;
}();
// Enable Model.extend.
(0, $19c24724c14e5e48$export$cd4c3a4dca301c70)($3c5c9c3617b9c261$var$Model);
(0, $19c24724c14e5e48$export$e1aac4552ae82081)($3c5c9c3617b9c261$var$Model);
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($3c5c9c3617b9c261$var$Model, (0, $bfbaffcfb5351f33$export$91eeeeed4a69a7e7));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($3c5c9c3617b9c261$var$Model, (0, $af85fd575926d85b$export$e4f01e48d6fda412));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($3c5c9c3617b9c261$var$Model, (0, $4038026ff7009ccc$export$a3a0ed7e2dd84c9e));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($3c5c9c3617b9c261$var$Model, (0, $e2551acac8eeeb09$export$2e2bcd8739ae039));
var $3c5c9c3617b9c261$export$2e2bcd8739ae039 = $3c5c9c3617b9c261$var$Model;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// A random offset
var $4e8eadf530aecaff$var$base = Math.round(Math.random() * 10);
function $4e8eadf530aecaff$export$6d2b3473b0986646(type) {
    // Considering the case of crossing js context,
    // use Math.random to make id as unique as possible.
    return [
        type || '',
        $4e8eadf530aecaff$var$base++
    ].join('_');
}
function $4e8eadf530aecaff$export$b9faf30b7d655a6f(target) {
    var subTypeDefaulters = {};
    target.registerSubTypeDefaulter = function(componentType, defaulter) {
        var componentTypeInfo = (0, $19c24724c14e5e48$export$fbe18865d303bf01)(componentType);
        subTypeDefaulters[componentTypeInfo.main] = defaulter;
    };
    target.determineSubType = function(componentType, option) {
        var type = option.type;
        if (!type) {
            var componentTypeMain = (0, $19c24724c14e5e48$export$fbe18865d303bf01)(componentType).main;
            if (target.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) type = subTypeDefaulters[componentTypeMain](option);
        }
        return type;
    };
}
function $4e8eadf530aecaff$export$ce592d345a3ec040(entity, dependencyGetter) {
    /**
   * @param targetNameList Target Component type list.
   *                       Can be ['aa', 'bb', 'aa.xx']
   * @param fullNameList By which we can build dependency graph.
   * @param callback Params: componentType, dependencies.
   * @param context Scope of callback.
   */ entity.topologicalTravel = function(targetNameList, fullNameList, callback, context) {
        if (!targetNameList.length) return;
        var result = makeDepndencyGraph(fullNameList);
        var graph = result.graph;
        var noEntryList = result.noEntryList;
        var targetNameSet = {};
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(targetNameList, function(name) {
            targetNameSet[name] = true;
        });
        while(noEntryList.length){
            var currComponentType = noEntryList.pop();
            var currVertex = graph[currComponentType];
            var isInTargetNameSet = !!targetNameSet[currComponentType];
            if (isInTargetNameSet) {
                callback.call(context, currComponentType, currVertex.originalDeps.slice());
                delete targetNameSet[currComponentType];
            }
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
        }
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(targetNameSet, function() {
            var errMsg = '';
            throw new Error(errMsg);
        });
        function removeEdge(succComponentType) {
            graph[succComponentType].entryCount--;
            if (graph[succComponentType].entryCount === 0) noEntryList.push(succComponentType);
        }
        // Consider this case: legend depends on series, and we call
        // chart.setOption({series: [...]}), where only series is in option.
        // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
        // not be called, but only sereis.mergeOption is called. Thus legend
        // have no chance to update its local record about series (like which
        // name of series is available in legend).
        function removeEdgeAndAdd(succComponentType) {
            targetNameSet[succComponentType] = true;
            removeEdge(succComponentType);
        }
    };
    function makeDepndencyGraph(fullNameList) {
        var graph = {};
        var noEntryList = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(fullNameList, function(name) {
            var thisItem = createDependencyGraphItem(graph, name);
            var originalDeps = thisItem.originalDeps = dependencyGetter(name);
            var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
            thisItem.entryCount = availableDeps.length;
            if (thisItem.entryCount === 0) noEntryList.push(name);
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(availableDeps, function(dependentName) {
                if ($1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(thisItem.predecessor, dependentName) < 0) thisItem.predecessor.push(dependentName);
                var thatItem = createDependencyGraphItem(graph, dependentName);
                if ($1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(thatItem.successor, dependentName) < 0) thatItem.successor.push(name);
            });
        });
        return {
            graph: graph,
            noEntryList: noEntryList
        };
    }
    function createDependencyGraphItem(graph, name) {
        if (!graph[name]) graph[name] = {
            predecessor: [],
            successor: []
        };
        return graph[name];
    }
    function getAvailableDependencies(originalDeps, fullNameList) {
        var availableDeps = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(originalDeps, function(dep) {
            $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(fullNameList, dep) >= 0 && availableDeps.push(dep);
        });
        return availableDeps;
    }
}
function $4e8eadf530aecaff$export$68acc510e46fef2(superOption, subOption) {
    // See also `model/Component.ts#getDefaultOption`
    return $1b239fc9d3a2f8ae$export$4950aa0f605343fb($1b239fc9d3a2f8ae$export$4950aa0f605343fb({}, superOption, true), subOption, true);
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Layout helpers for each component positioning



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ /**
 * Language: English.
 */ var $8dc21e749036cbe5$export$2e2bcd8739ae039 = {
    time: {
        month: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ],
        monthAbbr: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
        ],
        dayOfWeek: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ],
        dayOfWeekAbbr: [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ]
    },
    legend: {
        selector: {
            all: 'All',
            inverse: 'Inv'
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: 'Box Select',
                polygon: 'Lasso Select',
                lineX: 'Horizontally Select',
                lineY: 'Vertically Select',
                keep: 'Keep Selections',
                clear: 'Clear Selections'
            }
        },
        dataView: {
            title: 'Data View',
            lang: [
                'Data View',
                'Close',
                'Refresh'
            ]
        },
        dataZoom: {
            title: {
                zoom: 'Zoom',
                back: 'Zoom Reset'
            }
        },
        magicType: {
            title: {
                line: 'Switch to Line Chart',
                bar: 'Switch to Bar Chart',
                stack: 'Stack',
                tiled: 'Tile'
            }
        },
        restore: {
            title: 'Restore'
        },
        saveAsImage: {
            title: 'Save as Image',
            lang: [
                'Right Click to Save Image'
            ]
        }
    },
    series: {
        typeNames: {
            pie: 'Pie chart',
            bar: 'Bar chart',
            line: 'Line chart',
            scatter: 'Scatter plot',
            effectScatter: 'Ripple scatter plot',
            radar: 'Radar chart',
            tree: 'Tree',
            treemap: 'Treemap',
            boxplot: 'Boxplot',
            candlestick: 'Candlestick',
            k: 'K line chart',
            heatmap: 'Heat map',
            map: 'Map',
            parallel: 'Parallel coordinate map',
            lines: 'Line graph',
            graph: 'Relationship graph',
            sankey: 'Sankey diagram',
            funnel: 'Funnel chart',
            gauge: 'Gauge',
            pictorialBar: 'Pictorial bar',
            themeRiver: 'Theme River Map',
            sunburst: 'Sunburst',
            custom: 'Custom chart',
            chart: 'Chart'
        }
    },
    aria: {
        general: {
            withTitle: 'This is a chart about "{title}"',
            withoutTitle: 'This is a chart'
        },
        series: {
            single: {
                prefix: '',
                withName: ' with type {seriesType} named {seriesName}.',
                withoutName: ' with type {seriesType}.'
            },
            multiple: {
                prefix: '. It consists of {seriesCount} series count.',
                withName: ' The {seriesId} series is a {seriesType} representing {seriesName}.',
                withoutName: ' The {seriesId} series is a {seriesType}.',
                separator: {
                    middle: '',
                    end: ''
                }
            }
        },
        data: {
            allData: 'The data is as follows: ',
            partialData: 'The first {displayCnt} items are: ',
            withName: 'the data for {name} is {value}',
            withoutName: '{value}',
            separator: {
                middle: ', ',
                end: '. '
            }
        }
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */ var $a995a52fea6d4577$export$2e2bcd8739ae039 = {
    time: {
        month: [
            "\u4E00\u6708",
            "\u4E8C\u6708",
            "\u4E09\u6708",
            "\u56DB\u6708",
            "\u4E94\u6708",
            "\u516D\u6708",
            "\u4E03\u6708",
            "\u516B\u6708",
            "\u4E5D\u6708",
            "\u5341\u6708",
            "\u5341\u4E00\u6708",
            "\u5341\u4E8C\u6708"
        ],
        monthAbbr: [
            "1\u6708",
            "2\u6708",
            "3\u6708",
            "4\u6708",
            "5\u6708",
            "6\u6708",
            "7\u6708",
            "8\u6708",
            "9\u6708",
            "10\u6708",
            "11\u6708",
            "12\u6708"
        ],
        dayOfWeek: [
            "\u661F\u671F\u65E5",
            "\u661F\u671F\u4E00",
            "\u661F\u671F\u4E8C",
            "\u661F\u671F\u4E09",
            "\u661F\u671F\u56DB",
            "\u661F\u671F\u4E94",
            "\u661F\u671F\u516D"
        ],
        dayOfWeekAbbr: [
            "\u65E5",
            "\u4E00",
            "\u4E8C",
            "\u4E09",
            "\u56DB",
            "\u4E94",
            "\u516D"
        ]
    },
    legend: {
        selector: {
            all: "\u5168\u9009",
            inverse: "\u53CD\u9009"
        }
    },
    toolbox: {
        brush: {
            title: {
                rect: "\u77E9\u5F62\u9009\u62E9",
                polygon: "\u5708\u9009",
                lineX: "\u6A2A\u5411\u9009\u62E9",
                lineY: "\u7EB5\u5411\u9009\u62E9",
                keep: "\u4FDD\u6301\u9009\u62E9",
                clear: "\u6E05\u9664\u9009\u62E9"
            }
        },
        dataView: {
            title: "\u6570\u636E\u89C6\u56FE",
            lang: [
                "\u6570\u636E\u89C6\u56FE",
                "\u5173\u95ED",
                "\u5237\u65B0"
            ]
        },
        dataZoom: {
            title: {
                zoom: "\u533A\u57DF\u7F29\u653E",
                back: "\u533A\u57DF\u7F29\u653E\u8FD8\u539F"
            }
        },
        magicType: {
            title: {
                line: "\u5207\u6362\u4E3A\u6298\u7EBF\u56FE",
                bar: "\u5207\u6362\u4E3A\u67F1\u72B6\u56FE",
                stack: "\u5207\u6362\u4E3A\u5806\u53E0",
                tiled: "\u5207\u6362\u4E3A\u5E73\u94FA"
            }
        },
        restore: {
            title: "\u8FD8\u539F"
        },
        saveAsImage: {
            title: "\u4FDD\u5B58\u4E3A\u56FE\u7247",
            lang: [
                "\u53F3\u952E\u53E6\u5B58\u4E3A\u56FE\u7247"
            ]
        }
    },
    series: {
        typeNames: {
            pie: "\u997C\u56FE",
            bar: "\u67F1\u72B6\u56FE",
            line: "\u6298\u7EBF\u56FE",
            scatter: "\u6563\u70B9\u56FE",
            effectScatter: "\u6D9F\u6F2A\u6563\u70B9\u56FE",
            radar: "\u96F7\u8FBE\u56FE",
            tree: "\u6811\u56FE",
            treemap: "\u77E9\u5F62\u6811\u56FE",
            boxplot: "\u7BB1\u578B\u56FE",
            candlestick: "K\u7EBF\u56FE",
            k: "K\u7EBF\u56FE",
            heatmap: "\u70ED\u529B\u56FE",
            map: "\u5730\u56FE",
            parallel: "\u5E73\u884C\u5750\u6807\u56FE",
            lines: "\u7EBF\u56FE",
            graph: "\u5173\u7CFB\u56FE",
            sankey: "\u6851\u57FA\u56FE",
            funnel: "\u6F0F\u6597\u56FE",
            gauge: "\u4EEA\u8868\u76D8\u56FE",
            pictorialBar: "\u8C61\u5F62\u67F1\u56FE",
            themeRiver: "\u4E3B\u9898\u6CB3\u6D41\u56FE",
            sunburst: "\u65ED\u65E5\u56FE",
            custom: "\u81EA\u5B9A\u4E49\u56FE\u8868",
            chart: "\u56FE\u8868"
        }
    },
    aria: {
        general: {
            withTitle: "\u8FD9\u662F\u4E00\u4E2A\u5173\u4E8E\u201C{title}\u201D\u7684\u56FE\u8868\u3002",
            withoutTitle: "\u8FD9\u662F\u4E00\u4E2A\u56FE\u8868\uFF0C"
        },
        series: {
            single: {
                prefix: '',
                withName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\uFF0C\u8868\u793A{seriesName}\u3002",
                withoutName: "\u56FE\u8868\u7C7B\u578B\u662F{seriesType}\u3002"
            },
            multiple: {
                prefix: "\u5B83\u7531{seriesCount}\u4E2A\u56FE\u8868\u7CFB\u5217\u7EC4\u6210\u3002",
                withName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A\u8868\u793A{seriesName}\u7684{seriesType}\uFF0C",
                withoutName: "\u7B2C{seriesId}\u4E2A\u7CFB\u5217\u662F\u4E00\u4E2A{seriesType}\uFF0C",
                separator: {
                    middle: "\uFF1B",
                    end: "\u3002"
                }
            }
        },
        data: {
            allData: "\u5176\u6570\u636E\u662F\u2014\u2014",
            partialData: "\u5176\u4E2D\uFF0C\u524D{displayCnt}\u9879\u662F\u2014\u2014",
            withName: "{name}\u7684\u6570\u636E\u662F{value}",
            withoutName: '{value}',
            separator: {
                middle: "\uFF0C",
                end: ''
            }
        }
    }
};



var $db1a0fc42a360ea2$var$LOCALE_ZH = 'ZH';
var $db1a0fc42a360ea2$var$LOCALE_EN = 'EN';
var $db1a0fc42a360ea2$var$DEFAULT_LOCALE = $db1a0fc42a360ea2$var$LOCALE_EN;
var $db1a0fc42a360ea2$var$localeStorage = {};
var $db1a0fc42a360ea2$var$localeModels = {};
var $db1a0fc42a360ea2$export$9a2147b3808d4c6b = !(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).domSupported ? $db1a0fc42a360ea2$var$DEFAULT_LOCALE : function() {
    var langStr = /* eslint-disable-next-line */ (document.documentElement.lang || navigator.language || navigator.browserLanguage || $db1a0fc42a360ea2$var$DEFAULT_LOCALE).toUpperCase();
    return langStr.indexOf($db1a0fc42a360ea2$var$LOCALE_ZH) > -1 ? $db1a0fc42a360ea2$var$LOCALE_ZH : $db1a0fc42a360ea2$var$DEFAULT_LOCALE;
}();
function $db1a0fc42a360ea2$export$bab6a7822cc1e2cd(locale, localeObj) {
    locale = locale.toUpperCase();
    $db1a0fc42a360ea2$var$localeModels[locale] = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(localeObj);
    $db1a0fc42a360ea2$var$localeStorage[locale] = localeObj;
}
function $db1a0fc42a360ea2$export$ddc371781a6af754(locale) {
    if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(locale)) {
        var localeObj = $db1a0fc42a360ea2$var$localeStorage[locale.toUpperCase()] || {};
        if (locale === $db1a0fc42a360ea2$var$LOCALE_ZH || locale === $db1a0fc42a360ea2$var$LOCALE_EN) return (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(localeObj);
        else return (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)((0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(localeObj), (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)($db1a0fc42a360ea2$var$localeStorage[$db1a0fc42a360ea2$var$DEFAULT_LOCALE]), false);
    } else return (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)((0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(locale), (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)($db1a0fc42a360ea2$var$localeStorage[$db1a0fc42a360ea2$var$DEFAULT_LOCALE]), false);
}
function $db1a0fc42a360ea2$export$37cc638e0e11865f(lang) {
    return $db1a0fc42a360ea2$var$localeModels[lang];
}
function $db1a0fc42a360ea2$export$1188f179b2597821() {
    return $db1a0fc42a360ea2$var$localeModels[$db1a0fc42a360ea2$var$DEFAULT_LOCALE];
}
// Default locale
$db1a0fc42a360ea2$export$bab6a7822cc1e2cd($db1a0fc42a360ea2$var$LOCALE_EN, (0, $8dc21e749036cbe5$export$2e2bcd8739ae039));
$db1a0fc42a360ea2$export$bab6a7822cc1e2cd($db1a0fc42a360ea2$var$LOCALE_ZH, (0, $a995a52fea6d4577$export$2e2bcd8739ae039));



var $1e22c322bcf5ac75$export$32c0454ceff7f92d = 1000;
var $1e22c322bcf5ac75$export$35acaebf644db34e = $1e22c322bcf5ac75$export$32c0454ceff7f92d * 60;
var $1e22c322bcf5ac75$export$82541edf19e5e3b0 = $1e22c322bcf5ac75$export$35acaebf644db34e * 60;
var $1e22c322bcf5ac75$export$a97a1358cbb650ab = $1e22c322bcf5ac75$export$82541edf19e5e3b0 * 24;
var $1e22c322bcf5ac75$export$99cafda57477293d = $1e22c322bcf5ac75$export$a97a1358cbb650ab * 365;
var $1e22c322bcf5ac75$export$f7854271ddbda64e = {
    year: '{yyyy}',
    month: '{MMM}',
    day: '{d}',
    hour: '{HH}:{mm}',
    minute: '{HH}:{mm}',
    second: '{HH}:{mm}:{ss}',
    millisecond: '{HH}:{mm}:{ss} {SSS}',
    none: '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss} {SSS}'
};
var $1e22c322bcf5ac75$var$fullDayFormatter = '{yyyy}-{MM}-{dd}';
var $1e22c322bcf5ac75$export$445bdbd8d2334e40 = {
    year: '{yyyy}',
    month: '{yyyy}-{MM}',
    day: $1e22c322bcf5ac75$var$fullDayFormatter,
    hour: $1e22c322bcf5ac75$var$fullDayFormatter + ' ' + $1e22c322bcf5ac75$export$f7854271ddbda64e.hour,
    minute: $1e22c322bcf5ac75$var$fullDayFormatter + ' ' + $1e22c322bcf5ac75$export$f7854271ddbda64e.minute,
    second: $1e22c322bcf5ac75$var$fullDayFormatter + ' ' + $1e22c322bcf5ac75$export$f7854271ddbda64e.second,
    millisecond: $1e22c322bcf5ac75$export$f7854271ddbda64e.none
};
var $1e22c322bcf5ac75$export$87100da04d711986 = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
var $1e22c322bcf5ac75$export$833c398a55654bb7 = [
    'year',
    'half-year',
    'quarter',
    'month',
    'week',
    'half-week',
    'day',
    'half-day',
    'quarter-day',
    'hour',
    'minute',
    'second',
    'millisecond'
];
function $1e22c322bcf5ac75$export$5d04458e2a6c373e(str, len) {
    str += '';
    return '0000'.substr(0, len - str.length) + str;
}
function $1e22c322bcf5ac75$export$1da4b91a25d7e1c8(timeUnit) {
    switch(timeUnit){
        case 'half-year':
        case 'quarter':
            return 'month';
        case 'week':
        case 'half-week':
            return 'day';
        case 'half-day':
        case 'quarter-day':
            return 'hour';
        default:
            // year, minutes, second, milliseconds
            return timeUnit;
    }
}
function $1e22c322bcf5ac75$export$beb5920b69c13da(timeUnit) {
    return timeUnit === $1e22c322bcf5ac75$export$1da4b91a25d7e1c8(timeUnit);
}
function $1e22c322bcf5ac75$export$124c820721c4f66b(timeUnit) {
    switch(timeUnit){
        case 'year':
        case 'month':
            return 'day';
        case 'millisecond':
            return 'millisecond';
        default:
            // Also for day, hour, minute, second
            return 'second';
    }
}
function $1e22c322bcf5ac75$export$d9468344d3651243(// Note: The result based on `isUTC` are totally different, which can not be just simply
// substituted by the result without `isUTC`. So we make the param `isUTC` mandatory.
time, template, isUTC, lang) {
    var date = $9fd90cf3bf18fbcd$export$6b862160d295c8e(time);
    var y = date[$1e22c322bcf5ac75$export$8d046fefed9a548e(isUTC)]();
    var M = date[$1e22c322bcf5ac75$export$5c242a801a23eec7(isUTC)]() + 1;
    var q = Math.floor((M - 1) / 3) + 1;
    var d = date[$1e22c322bcf5ac75$export$4189e6cbc9753260(isUTC)]();
    var e = date['get' + (isUTC ? 'UTC' : '') + 'Day']();
    var H = date[$1e22c322bcf5ac75$export$8b40b55b3c06cbe2(isUTC)]();
    var h = (H - 1) % 12 + 1;
    var m = date[$1e22c322bcf5ac75$export$8807847c5c71eded(isUTC)]();
    var s = date[$1e22c322bcf5ac75$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$1e22c322bcf5ac75$export$312207a92d041116(isUTC)]();
    var a = H >= 12 ? 'pm' : 'am';
    var A = a.toUpperCase();
    var localeModel = lang instanceof (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039) ? lang : (0, $db1a0fc42a360ea2$export$37cc638e0e11865f)(lang || (0, $db1a0fc42a360ea2$export$9a2147b3808d4c6b)) || (0, $db1a0fc42a360ea2$export$1188f179b2597821)();
    var timeModel = localeModel.getModel('time');
    var month = timeModel.get('month');
    var monthAbbr = timeModel.get('monthAbbr');
    var dayOfWeek = timeModel.get('dayOfWeek');
    var dayOfWeekAbbr = timeModel.get('dayOfWeekAbbr');
    return (template || '').replace(/{a}/g, a + '').replace(/{A}/g, A + '').replace(/{yyyy}/g, y + '').replace(/{yy}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(y % 100 + '', 2)).replace(/{Q}/g, q + '').replace(/{MMMM}/g, month[M - 1]).replace(/{MMM}/g, monthAbbr[M - 1]).replace(/{MM}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(M, 2)).replace(/{M}/g, M + '').replace(/{dd}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(d, 2)).replace(/{d}/g, d + '').replace(/{eeee}/g, dayOfWeek[e]).replace(/{ee}/g, dayOfWeekAbbr[e]).replace(/{e}/g, e + '').replace(/{HH}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(H, 2)).replace(/{H}/g, H + '').replace(/{hh}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(h + '', 2)).replace(/{h}/g, h + '').replace(/{mm}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(m, 2)).replace(/{m}/g, m + '').replace(/{ss}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(s, 2)).replace(/{s}/g, s + '').replace(/{SSS}/g, $1e22c322bcf5ac75$export$5d04458e2a6c373e(S, 3)).replace(/{S}/g, S + '');
}
function $1e22c322bcf5ac75$export$fe777b6293828b5d(tick, idx, formatter, lang, isUTC) {
    var template = null;
    if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(formatter)) // Single formatter for all units at all levels
    template = formatter;
    else if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(formatter)) // Callback formatter
    template = formatter(tick.value, idx, {
        level: tick.level
    });
    else {
        var defaults = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, $1e22c322bcf5ac75$export$f7854271ddbda64e);
        if (tick.level > 0) for(var i = 0; i < $1e22c322bcf5ac75$export$87100da04d711986.length; ++i)defaults[$1e22c322bcf5ac75$export$87100da04d711986[i]] = "{primary|" + defaults[$1e22c322bcf5ac75$export$87100da04d711986[i]] + "}";
        var mergedFormatter = formatter ? formatter.inherit === false ? formatter // Use formatter with bigger units
         : $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(formatter, defaults) : defaults;
        var unit = $1e22c322bcf5ac75$export$4dfb0417ad6555b7(tick.value, isUTC);
        if (mergedFormatter[unit]) template = mergedFormatter[unit];
        else if (mergedFormatter.inherit) {
            // Unit formatter is not defined and should inherit from bigger units
            var targetId = $1e22c322bcf5ac75$export$833c398a55654bb7.indexOf(unit);
            for(var i = targetId - 1; i >= 0; --i)if (mergedFormatter[unit]) {
                template = mergedFormatter[unit];
                break;
            }
            template = template || defaults.none;
        }
        if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(template)) {
            var levelId = tick.level == null ? 0 : tick.level >= 0 ? tick.level : template.length + tick.level;
            levelId = Math.min(levelId, template.length - 1);
            template = template[levelId];
        }
    }
    return $1e22c322bcf5ac75$export$d9468344d3651243(new Date(tick.value), template, isUTC, lang);
}
function $1e22c322bcf5ac75$export$4dfb0417ad6555b7(value, isUTC) {
    var date = $9fd90cf3bf18fbcd$export$6b862160d295c8e(value);
    var M = date[$1e22c322bcf5ac75$export$5c242a801a23eec7(isUTC)]() + 1;
    var d = date[$1e22c322bcf5ac75$export$4189e6cbc9753260(isUTC)]();
    var h = date[$1e22c322bcf5ac75$export$8b40b55b3c06cbe2(isUTC)]();
    var m = date[$1e22c322bcf5ac75$export$8807847c5c71eded(isUTC)]();
    var s = date[$1e22c322bcf5ac75$export$8f49e73e2eebd168(isUTC)]();
    var S = date[$1e22c322bcf5ac75$export$312207a92d041116(isUTC)]();
    var isSecond = S === 0;
    var isMinute = isSecond && s === 0;
    var isHour = isMinute && m === 0;
    var isDay = isHour && h === 0;
    var isMonth = isDay && d === 1;
    var isYear = isMonth && M === 1;
    if (isYear) return 'year';
    else if (isMonth) return 'month';
    else if (isDay) return 'day';
    else if (isHour) return 'hour';
    else if (isMinute) return 'minute';
    else if (isSecond) return 'second';
    else return 'millisecond';
}
function $1e22c322bcf5ac75$export$e04e41a1e24ffd3f(value, unit, isUTC) {
    var date = $1b239fc9d3a2f8ae$export$7e4aa119212bc614(value) ? $9fd90cf3bf18fbcd$export$6b862160d295c8e(value) : value;
    unit = unit || $1e22c322bcf5ac75$export$4dfb0417ad6555b7(value, isUTC);
    switch(unit){
        case 'year':
            return date[$1e22c322bcf5ac75$export$8d046fefed9a548e(isUTC)]();
        case 'half-year':
            return date[$1e22c322bcf5ac75$export$5c242a801a23eec7(isUTC)]() >= 6 ? 1 : 0;
        case 'quarter':
            return Math.floor((date[$1e22c322bcf5ac75$export$5c242a801a23eec7(isUTC)]() + 1) / 4);
        case 'month':
            return date[$1e22c322bcf5ac75$export$5c242a801a23eec7(isUTC)]();
        case 'day':
            return date[$1e22c322bcf5ac75$export$4189e6cbc9753260(isUTC)]();
        case 'half-day':
            return date[$1e22c322bcf5ac75$export$8b40b55b3c06cbe2(isUTC)]() / 24;
        case 'hour':
            return date[$1e22c322bcf5ac75$export$8b40b55b3c06cbe2(isUTC)]();
        case 'minute':
            return date[$1e22c322bcf5ac75$export$8807847c5c71eded(isUTC)]();
        case 'second':
            return date[$1e22c322bcf5ac75$export$8f49e73e2eebd168(isUTC)]();
        case 'millisecond':
            return date[$1e22c322bcf5ac75$export$312207a92d041116(isUTC)]();
    }
}
function $1e22c322bcf5ac75$export$8d046fefed9a548e(isUTC) {
    return isUTC ? 'getUTCFullYear' : 'getFullYear';
}
function $1e22c322bcf5ac75$export$5c242a801a23eec7(isUTC) {
    return isUTC ? 'getUTCMonth' : 'getMonth';
}
function $1e22c322bcf5ac75$export$4189e6cbc9753260(isUTC) {
    return isUTC ? 'getUTCDate' : 'getDate';
}
function $1e22c322bcf5ac75$export$8b40b55b3c06cbe2(isUTC) {
    return isUTC ? 'getUTCHours' : 'getHours';
}
function $1e22c322bcf5ac75$export$8807847c5c71eded(isUTC) {
    return isUTC ? 'getUTCMinutes' : 'getMinutes';
}
function $1e22c322bcf5ac75$export$8f49e73e2eebd168(isUTC) {
    return isUTC ? 'getUTCSeconds' : 'getSeconds';
}
function $1e22c322bcf5ac75$export$312207a92d041116(isUTC) {
    return isUTC ? 'getUTCMilliseconds' : 'getMilliseconds';
}
function $1e22c322bcf5ac75$export$43fbeac90913b151(isUTC) {
    return isUTC ? 'setUTCFullYear' : 'setFullYear';
}
function $1e22c322bcf5ac75$export$233f59998ed71c09(isUTC) {
    return isUTC ? 'setUTCMonth' : 'setMonth';
}
function $1e22c322bcf5ac75$export$82fd379a67f37fa0(isUTC) {
    return isUTC ? 'setUTCDate' : 'setDate';
}
function $1e22c322bcf5ac75$export$b6f943e8d23c15bb(isUTC) {
    return isUTC ? 'setUTCHours' : 'setHours';
}
function $1e22c322bcf5ac75$export$50303078793fc7d(isUTC) {
    return isUTC ? 'setUTCMinutes' : 'setMinutes';
}
function $1e22c322bcf5ac75$export$a4a908acda9c3118(isUTC) {
    return isUTC ? 'setUTCSeconds' : 'setSeconds';
}
function $1e22c322bcf5ac75$export$c047afab75f6d84(isUTC) {
    return isUTC ? 'setUTCMilliseconds' : 'setMilliseconds';
}





function $ff2fba995230f3c9$export$b6fe44657ce35c42(x) {
    if (!(0, $9fd90cf3bf18fbcd$export$e90fb89750dba83f)(x)) return $1b239fc9d3a2f8ae$export$844ec244b1367d54(x) ? x : '-';
    var parts = (x + '').split('.');
    return parts[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (parts.length > 1 ? '.' + parts[1] : '');
}
function $ff2fba995230f3c9$export$86f54f62aa7a7514(str, upperCaseFirst) {
    str = (str || '').toLowerCase().replace(/-(.)/g, function(match, group1) {
        return group1.toUpperCase();
    });
    if (upperCaseFirst && str) str = str.charAt(0).toUpperCase() + str.slice(1);
    return str;
}
var $ff2fba995230f3c9$export$f3a38102c49f4268 = $1b239fc9d3a2f8ae$export$f3a38102c49f4268;
function $ff2fba995230f3c9$export$3cd8db88714decfc(value, valueType, useUTC) {
    var USER_READABLE_DEFUALT_TIME_PATTERN = '{yyyy}-{MM}-{dd} {HH}:{mm}:{ss}';
    function stringToUserReadable(str) {
        return str && $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab(str) ? str : '-';
    }
    function isNumberUserReadable(num) {
        return !!(num != null && !isNaN(num) && isFinite(num));
    }
    var isTypeTime = valueType === 'time';
    var isValueDate = value instanceof Date;
    if (isTypeTime || isValueDate) {
        var date = isTypeTime ? (0, $9fd90cf3bf18fbcd$export$6b862160d295c8e)(value) : value;
        if (!isNaN(+date)) return (0, $1e22c322bcf5ac75$export$d9468344d3651243)(date, USER_READABLE_DEFUALT_TIME_PATTERN, useUTC);
        else if (isValueDate) return '-';
    // In other cases, continue to try to display the value in the following code.
    }
    if (valueType === 'ordinal') return $1b239fc9d3a2f8ae$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : $1b239fc9d3a2f8ae$export$7e4aa119212bc614(value) ? isNumberUserReadable(value) ? value + '' : '-' : '-';
    // By default.
    var numericResult = (0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(value);
    return isNumberUserReadable(numericResult) ? $ff2fba995230f3c9$export$b6fe44657ce35c42(numericResult) : $1b239fc9d3a2f8ae$export$29d0bb2a4e07b252(value) ? stringToUserReadable(value) : typeof value === 'boolean' ? value + '' : '-';
}
var $ff2fba995230f3c9$var$TPL_VAR_ALIAS = [
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g'
];
var $ff2fba995230f3c9$var$wrapVar = function(varName, seriesIdx) {
    return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
};
function $ff2fba995230f3c9$export$2028496a35766e41(tpl, paramsList, encode) {
    if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(paramsList)) paramsList = [
        paramsList
    ];
    var seriesLen = paramsList.length;
    if (!seriesLen) return '';
    var $vars = paramsList[0].$vars || [];
    for(var i = 0; i < $vars.length; i++){
        var alias = $ff2fba995230f3c9$var$TPL_VAR_ALIAS[i];
        tpl = tpl.replace($ff2fba995230f3c9$var$wrapVar(alias), $ff2fba995230f3c9$var$wrapVar(alias, 0));
    }
    for(var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++)for(var k = 0; k < $vars.length; k++){
        var val = paramsList[seriesIdx][$vars[k]];
        tpl = tpl.replace($ff2fba995230f3c9$var$wrapVar($ff2fba995230f3c9$var$TPL_VAR_ALIAS[k], seriesIdx), encode ? (0, $8032584326d71745$export$f9d6449b9af28dc1)(val) : val);
    }
    return tpl;
}
function $ff2fba995230f3c9$export$2fa08233ee42f8e1(tpl, param, encode) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(param, function(value, key) {
        tpl = tpl.replace('{' + key + '}', encode ? (0, $8032584326d71745$export$f9d6449b9af28dc1)(value) : value);
    });
    return tpl;
}
function $ff2fba995230f3c9$export$1987a3dbdf3c45ca(inOpt, extraCssText) {
    var opt = $1b239fc9d3a2f8ae$export$844ec244b1367d54(inOpt) ? {
        color: inOpt,
        extraCssText: extraCssText
    } : inOpt || {};
    var color = opt.color;
    var type = opt.type;
    extraCssText = opt.extraCssText;
    var renderMode = opt.renderMode || 'html';
    if (!color) return '';
    if (renderMode === 'html') return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;border-radius:4px;width:4px;height:4px;background-color:' + (0, $8032584326d71745$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:' + (0, $8032584326d71745$export$f9d6449b9af28dc1)(color) + ';' + (extraCssText || '') + '"></span>';
    else {
        // Should better not to auto generate style name by auto-increment number here.
        // Because this util is usually called in tooltip formatter, which is probably
        // called repeatedly when mouse move and the auto-increment number increases fast.
        // Users can make their own style name by theirselves, make it unique and readable.
        var markerId = opt.markerId || 'markerX';
        return {
            renderMode: renderMode,
            content: '{' + markerId + '|}  ',
            style: type === 'subItem' ? {
                width: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor: color
            } : {
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: color
            }
        };
    }
}
function $ff2fba995230f3c9$export$3203edd9e5edd663(tpl, value, isUTC) {
    if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') tpl = 'MM-dd\nyyyy';
    var date = (0, $9fd90cf3bf18fbcd$export$6b862160d295c8e)(value);
    var getUTC = isUTC ? 'getUTC' : 'get';
    var y = date[getUTC + 'FullYear']();
    var M = date[getUTC + 'Month']() + 1;
    var d = date[getUTC + 'Date']();
    var h = date[getUTC + 'Hours']();
    var m = date[getUTC + 'Minutes']();
    var s = date[getUTC + 'Seconds']();
    var S = date[getUTC + 'Milliseconds']();
    tpl = tpl.replace('MM', (0, $1e22c322bcf5ac75$export$5d04458e2a6c373e)(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', (0, $1e22c322bcf5ac75$export$5d04458e2a6c373e)(y % 100 + '', 2)).replace('dd', (0, $1e22c322bcf5ac75$export$5d04458e2a6c373e)(d, 2)).replace('d', d).replace('hh', (0, $1e22c322bcf5ac75$export$5d04458e2a6c373e)(h, 2)).replace('h', h).replace('mm', (0, $1e22c322bcf5ac75$export$5d04458e2a6c373e)(m, 2)).replace('m', m).replace('ss', (0, $1e22c322bcf5ac75$export$5d04458e2a6c373e)(s, 2)).replace('s', s).replace('SSS', (0, $1e22c322bcf5ac75$export$5d04458e2a6c373e)(S, 3));
    return tpl;
}
function $ff2fba995230f3c9$export$38a1e7552f497c0e(str) {
    return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
}
function $ff2fba995230f3c9$export$cda04d03233e5555(color, defaultColor) {
    defaultColor = defaultColor || 'transparent';
    return $1b239fc9d3a2f8ae$export$844ec244b1367d54(color) ? color : $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(color) ? color.colorStops && (color.colorStops[0] || {}).color || defaultColor : defaultColor;
}
function $ff2fba995230f3c9$export$13e13f9b96dbe8fa(link, target) {
    /* global window */ if (target === '_blank' || target === 'blank') {
        var blank = window.open();
        blank.opener = null;
        blank.location.href = link;
    } else window.open(link, target);
}


var $501dc28f6c4d24ac$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $501dc28f6c4d24ac$export$a9aa2cc018afbed = [
    'left',
    'right',
    'top',
    'bottom',
    'width',
    'height'
];
var $501dc28f6c4d24ac$export$d7fd4338c7b20804 = [
    [
        'width',
        'left',
        'right'
    ],
    [
        'height',
        'top',
        'bottom'
    ]
];
function $501dc28f6c4d24ac$var$boxLayout(orient, group, gap, maxWidth, maxHeight) {
    var x = 0;
    var y = 0;
    if (maxWidth == null) maxWidth = Infinity;
    if (maxHeight == null) maxHeight = Infinity;
    var currentLineMaxSize = 0;
    group.eachChild(function(child, idx) {
        var rect = child.getBoundingRect();
        var nextChild = group.childAt(idx + 1);
        var nextChildRect = nextChild && nextChild.getBoundingRect();
        var nextX;
        var nextY;
        if (orient === 'horizontal') {
            var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
            nextX = x + moveX;
            // Wrap when width exceeds maxWidth or meet a `newline` group
            // FIXME compare before adding gap?
            if (nextX > maxWidth || child.newline) {
                x = 0;
                nextX = moveX;
                y += currentLineMaxSize + gap;
                currentLineMaxSize = rect.height;
            } else // FIXME: consider rect.y is not `0`?
            currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
        } else {
            var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
            nextY = y + moveY;
            // Wrap when width exceeds maxHeight or meet a `newline` group
            if (nextY > maxHeight || child.newline) {
                x += currentLineMaxSize + gap;
                y = 0;
                nextY = moveY;
                currentLineMaxSize = rect.width;
            } else currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
        }
        if (child.newline) return;
        child.x = x;
        child.y = y;
        child.markRedraw();
        orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
    });
}
var $501dc28f6c4d24ac$export$827f4ee28efc37 = $501dc28f6c4d24ac$var$boxLayout;
var $501dc28f6c4d24ac$export$be20d9158c17374c = $1b239fc9d3a2f8ae$export$c3095a23b368d1f2($501dc28f6c4d24ac$var$boxLayout, 'vertical');
var $501dc28f6c4d24ac$export$ae65a483d943e7a7 = $1b239fc9d3a2f8ae$export$c3095a23b368d1f2($501dc28f6c4d24ac$var$boxLayout, 'horizontal');
function $501dc28f6c4d24ac$export$145a8938a85a22b1(positionInfo, containerRect, margin) {
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var x = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var y = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var x2 = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var y2 = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    (isNaN(x) || isNaN(parseFloat(positionInfo.left))) && (x = 0);
    (isNaN(x2) || isNaN(parseFloat(positionInfo.right))) && (x2 = containerWidth);
    (isNaN(y) || isNaN(parseFloat(positionInfo.top))) && (y = 0);
    (isNaN(y2) || isNaN(parseFloat(positionInfo.bottom))) && (y2 = containerHeight);
    margin = $ff2fba995230f3c9$export$f3a38102c49f4268(margin || 0);
    return {
        width: Math.max(x2 - x - margin[1] - margin[3], 0),
        height: Math.max(y2 - y - margin[0] - margin[2], 0)
    };
}
function $501dc28f6c4d24ac$export$4517a5ca639a7293(positionInfo, containerRect, margin) {
    margin = $ff2fba995230f3c9$export$f3a38102c49f4268(margin || 0);
    var containerWidth = containerRect.width;
    var containerHeight = containerRect.height;
    var left = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.left, containerWidth);
    var top = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.top, containerHeight);
    var right = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.right, containerWidth);
    var bottom = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.bottom, containerHeight);
    var width = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.width, containerWidth);
    var height = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionInfo.height, containerHeight);
    var verticalMargin = margin[2] + margin[0];
    var horizontalMargin = margin[1] + margin[3];
    var aspect = positionInfo.aspect;
    // If width is not specified, calculate width from left and right
    if (isNaN(width)) width = containerWidth - right - horizontalMargin - left;
    if (isNaN(height)) height = containerHeight - bottom - verticalMargin - top;
    if (aspect != null) {
        // If width and height are not given
        // 1. Graph should not exceeds the container
        // 2. Aspect must be keeped
        // 3. Graph should take the space as more as possible
        // FIXME
        // Margin is not considered, because there is no case that both
        // using margin and aspect so far.
        if (isNaN(width) && isNaN(height)) {
            if (aspect > containerWidth / containerHeight) width = containerWidth * 0.8;
            else height = containerHeight * 0.8;
        }
        // Calculate width or height with given aspect
        if (isNaN(width)) width = aspect * height;
        if (isNaN(height)) height = width / aspect;
    }
    // If left is not specified, calculate left from right and width
    if (isNaN(left)) left = containerWidth - right - width - horizontalMargin;
    if (isNaN(top)) top = containerHeight - bottom - height - verticalMargin;
    // Align left and top
    switch(positionInfo.left || positionInfo.right){
        case 'center':
            left = containerWidth / 2 - width / 2 - margin[3];
            break;
        case 'right':
            left = containerWidth - width - horizontalMargin;
            break;
    }
    switch(positionInfo.top || positionInfo.bottom){
        case 'middle':
        case 'center':
            top = containerHeight / 2 - height / 2 - margin[0];
            break;
        case 'bottom':
            top = containerHeight - height - verticalMargin;
            break;
    }
    // If something is wrong and left, top, width, height are calculated as NaN
    left = left || 0;
    top = top || 0;
    if (isNaN(width)) // Width may be NaN if only one value is given except width
    width = containerWidth - horizontalMargin - left - (right || 0);
    if (isNaN(height)) // Height may be NaN if only one value is given except height
    height = containerHeight - verticalMargin - top - (bottom || 0);
    var rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(left + margin[3], top + margin[0], width, height);
    rect.margin = margin;
    return rect;
}
function $501dc28f6c4d24ac$export$74054bd96b5eeef1(el, positionInfo, containerRect, margin, opt, out) {
    var h = !opt || !opt.hv || opt.hv[0];
    var v = !opt || !opt.hv || opt.hv[1];
    var boundingMode = opt && opt.boundingMode || 'all';
    out = out || el;
    out.x = el.x;
    out.y = el.y;
    if (!h && !v) return false;
    var rect;
    if (boundingMode === 'raw') rect = el.type === 'group' ? new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
    else {
        rect = el.getBoundingRect();
        if (el.needLocalTransform()) {
            var transform = el.getLocalTransform();
            // Notice: raw rect may be inner object of el,
            // which should not be modified.
            rect = rect.clone();
            rect.applyTransform(transform);
        }
    }
    // The real width and height can not be specified but calculated by the given el.
    var layoutRect = $501dc28f6c4d24ac$export$4517a5ca639a7293($1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
        width: rect.width,
        height: rect.height
    }, positionInfo), containerRect, margin);
    // Because 'tranlate' is the last step in transform
    // (see zrender/core/Transformable#getLocalTransform),
    // we can just only modify el.position to get final result.
    var dx = h ? layoutRect.x - rect.x : 0;
    var dy = v ? layoutRect.y - rect.y : 0;
    if (boundingMode === 'raw') {
        out.x = dx;
        out.y = dy;
    } else {
        out.x += dx;
        out.y += dy;
    }
    if (out === el) el.markRedraw();
    return true;
}
function $501dc28f6c4d24ac$export$7ede609e8ebc9650(option, hvIdx) {
    return option[$501dc28f6c4d24ac$export$d7fd4338c7b20804[hvIdx][0]] != null || option[$501dc28f6c4d24ac$export$d7fd4338c7b20804[hvIdx][1]] != null && option[$501dc28f6c4d24ac$export$d7fd4338c7b20804[hvIdx][2]] != null;
}
function $501dc28f6c4d24ac$export$3968a28a7cbd6063(ins) {
    var layoutMode = ins.layoutMode || ins.constructor.layoutMode;
    return $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(layoutMode) ? layoutMode : layoutMode ? {
        type: layoutMode
    } : null;
}
function $501dc28f6c4d24ac$export$1754cb91f16ca028(targetOption, newOption, opt) {
    var ignoreSize = opt && opt.ignoreSize;
    !$1b239fc9d3a2f8ae$export$43bee75e5e14138e(ignoreSize) && (ignoreSize = [
        ignoreSize,
        ignoreSize
    ]);
    var hResult = merge($501dc28f6c4d24ac$export$d7fd4338c7b20804[0], 0);
    var vResult = merge($501dc28f6c4d24ac$export$d7fd4338c7b20804[1], 1);
    copy($501dc28f6c4d24ac$export$d7fd4338c7b20804[0], targetOption, hResult);
    copy($501dc28f6c4d24ac$export$d7fd4338c7b20804[1], targetOption, vResult);
    function merge(names, hvIdx) {
        var newParams = {};
        var newValueCount = 0;
        var merged = {};
        var mergedValueCount = 0;
        var enoughParamNumber = 2;
        $501dc28f6c4d24ac$var$each(names, function(name) {
            merged[name] = targetOption[name];
        });
        $501dc28f6c4d24ac$var$each(names, function(name) {
            // Consider case: newOption.width is null, which is
            // set by user for removing width setting.
            hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
            hasValue(newParams, name) && newValueCount++;
            hasValue(merged, name) && mergedValueCount++;
        });
        if (ignoreSize[hvIdx]) {
            // Only one of left/right is premitted to exist.
            if (hasValue(newOption, names[1])) merged[names[2]] = null;
            else if (hasValue(newOption, names[2])) merged[names[1]] = null;
            return merged;
        }
        // Case: newOption: {width: ..., right: ...},
        // or targetOption: {right: ...} and newOption: {width: ...},
        // There is no conflict when merged only has params count
        // little than enoughParamNumber.
        if (mergedValueCount === enoughParamNumber || !newValueCount) return merged;
        else if (newValueCount >= enoughParamNumber) return newParams;
        else {
            // Chose another param from targetOption by priority.
            for(var i = 0; i < names.length; i++){
                var name_1 = names[i];
                if (!hasProp(newParams, name_1) && hasProp(targetOption, name_1)) {
                    newParams[name_1] = targetOption[name_1];
                    break;
                }
            }
            return newParams;
        }
    }
    function hasProp(obj, name) {
        return obj.hasOwnProperty(name);
    }
    function hasValue(obj, name) {
        return obj[name] != null && obj[name] !== 'auto';
    }
    function copy(names, target, source) {
        $501dc28f6c4d24ac$var$each(names, function(name) {
            target[name] = source[name];
        });
    }
}
function $501dc28f6c4d24ac$export$4b0d20af19c9875e(source) {
    return $501dc28f6c4d24ac$export$7438999faea9b6cc({}, source);
}
function $501dc28f6c4d24ac$export$7438999faea9b6cc(target, source) {
    source && target && $501dc28f6c4d24ac$var$each($501dc28f6c4d24ac$export$a9aa2cc018afbed, function(name) {
        source.hasOwnProperty(name) && (target[name] = source[name]);
    });
    return target;
}


var $ba6ce7bfb5e68143$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $ba6ce7bfb5e68143$var$ComponentModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ComponentModel, _super);
    function ComponentModel(option, parentModel, ecModel) {
        var _this = _super.call(this, option, parentModel, ecModel) || this;
        _this.uid = $4e8eadf530aecaff$export$6d2b3473b0986646('ec_cpt_model');
        return _this;
    }
    ComponentModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    ComponentModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = $501dc28f6c4d24ac$export$3968a28a7cbd6063(this);
        var inputPositionParams = layoutMode ? $501dc28f6c4d24ac$export$4b0d20af19c9875e(option) : {};
        var themeModel = ecModel.getTheme();
        $1b239fc9d3a2f8ae$export$4950aa0f605343fb(option, themeModel.get(this.mainType));
        $1b239fc9d3a2f8ae$export$4950aa0f605343fb(option, this.getDefaultOption());
        if (layoutMode) $501dc28f6c4d24ac$export$1754cb91f16ca028(option, inputPositionParams, layoutMode);
    };
    ComponentModel.prototype.mergeOption = function(option, ecModel) {
        $1b239fc9d3a2f8ae$export$4950aa0f605343fb(this.option, option, true);
        var layoutMode = $501dc28f6c4d24ac$export$3968a28a7cbd6063(this);
        if (layoutMode) $501dc28f6c4d24ac$export$1754cb91f16ca028(this.option, option, layoutMode);
    };
    /**
   * Called immediately after `init` or `mergeOption` of this instance called.
   */ ComponentModel.prototype.optionUpdated = function(newCptOption, isInit) {};
    /**
   * [How to declare defaultOption]:
   *
   * (A) If using class declaration in typescript (since echarts 5):
   * ```ts
   * import {ComponentOption} from '../model/option.js';
   * export interface XxxOption extends ComponentOption {
   *     aaa: number
   * }
   * export class XxxModel extends Component {
   *     static type = 'xxx';
   *     static defaultOption: XxxOption = {
   *         aaa: 123
   *     }
   * }
   * Component.registerClass(XxxModel);
   * ```
   * ```ts
   * import {inheritDefaultOption} from '../util/component.js';
   * import {XxxModel, XxxOption} from './XxxModel.js';
   * export interface XxxSubOption extends XxxOption {
   *     bbb: number
   * }
   * class XxxSubModel extends XxxModel {
   *     static defaultOption: XxxSubOption = inheritDefaultOption(XxxModel.defaultOption, {
   *         bbb: 456
   *     })
   *     fn() {
   *         let opt = this.getDefaultOption();
   *         // opt is {aaa: 123, bbb: 456}
   *     }
   * }
   * ```
   *
   * (B) If using class extend (previous approach in echarts 3 & 4):
   * ```js
   * let XxxComponent = Component.extend({
   *     defaultOption: {
   *         xx: 123
   *     }
   * })
   * ```
   * ```js
   * let XxxSubComponent = XxxComponent.extend({
   *     defaultOption: {
   *         yy: 456
   *     },
   *     fn: function () {
   *         let opt = this.getDefaultOption();
   *         // opt is {xx: 123, yy: 456}
   *     }
   * })
   * ```
   */ ComponentModel.prototype.getDefaultOption = function() {
        var ctor = this.constructor;
        // If using class declaration, it is different to travel super class
        // in legacy env and auto merge defaultOption. So if using class
        // declaration, defaultOption should be merged manually.
        if (!(0, $19c24724c14e5e48$export$4f3b818f3dd2d182)(ctor)) // When using ts class, defaultOption must be declared as static.
        return ctor.defaultOption;
        // FIXME: remove this approach?
        var fields = $ba6ce7bfb5e68143$var$inner(this);
        if (!fields.defaultOption) {
            var optList = [];
            var clz = ctor;
            while(clz){
                var opt = clz.prototype.defaultOption;
                opt && optList.push(opt);
                clz = clz.superClass;
            }
            var defaultOption = {};
            for(var i = optList.length - 1; i >= 0; i--)defaultOption = $1b239fc9d3a2f8ae$export$4950aa0f605343fb(defaultOption, optList[i], true);
            fields.defaultOption = defaultOption;
        }
        return fields.defaultOption;
    };
    /**
   * Notice: always force to input param `useDefault` in case that forget to consider it.
   * The same behavior as `modelUtil.parseFinder`.
   *
   * @param useDefault In many cases like series refer axis and axis refer grid,
   *        If axis index / axis id not specified, use the first target as default.
   *        In other cases like dataZoom refer axis, if not specified, measn no refer.
   */ ComponentModel.prototype.getReferringComponents = function(mainType, opt) {
        var indexKey = mainType + 'Index';
        var idKey = mainType + 'Id';
        return (0, $9ac03c46e8b6e711$export$dc741340f7e5f186)(this.ecModel, mainType, {
            index: this.get(indexKey, true),
            id: this.get(idKey, true)
        }, opt);
    };
    ComponentModel.prototype.getBoxLayoutParams = function() {
        // Consider itself having box layout configs.
        var boxLayoutModel = this;
        return {
            left: boxLayoutModel.get('left'),
            top: boxLayoutModel.get('top'),
            right: boxLayoutModel.get('right'),
            bottom: boxLayoutModel.get('bottom'),
            width: boxLayoutModel.get('width'),
            height: boxLayoutModel.get('height')
        };
    };
    /**
   * Get key for zlevel.
   * If developers don't configure zlevel. We will assign zlevel to series based on the key.
   * For example, lines with trail effect and progressive series will in an individual zlevel.
   */ ComponentModel.prototype.getZLevelKey = function() {
        return '';
    };
    ComponentModel.prototype.setZLevel = function(zlevel) {
        this.option.zlevel = zlevel;
    };
    ComponentModel.protoInitialize = function() {
        var proto = ComponentModel.prototype;
        proto.type = 'component';
        proto.id = '';
        proto.name = '';
        proto.mainType = '';
        proto.subType = '';
        proto.componentIndex = 0;
    }();
    return ComponentModel;
}((0, $3c5c9c3617b9c261$export$2e2bcd8739ae039));
(0, $19c24724c14e5e48$export$c9c2d87774f1275d)($ba6ce7bfb5e68143$var$ComponentModel, (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039));
(0, $19c24724c14e5e48$export$241315e45585454d)($ba6ce7bfb5e68143$var$ComponentModel);
$4e8eadf530aecaff$export$b9faf30b7d655a6f($ba6ce7bfb5e68143$var$ComponentModel);
$4e8eadf530aecaff$export$ce592d345a3ec040($ba6ce7bfb5e68143$var$ComponentModel, $ba6ce7bfb5e68143$var$getDependencies);
function $ba6ce7bfb5e68143$var$getDependencies(componentType) {
    var deps = [];
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43($ba6ce7bfb5e68143$var$ComponentModel.getClassesByMainType(componentType), function(clz) {
        deps = deps.concat(clz.dependencies || clz.prototype.dependencies || []);
    });
    // Ensure main type.
    deps = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(deps, function(type) {
        return (0, $19c24724c14e5e48$export$fbe18865d303bf01)(type).main;
    });
    // Hack dataset for convenience.
    if (componentType !== 'dataset' && $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(deps, 'dataset') <= 0) deps.unshift('dataset');
    return deps;
}
var $ba6ce7bfb5e68143$export$2e2bcd8739ae039 = $ba6ce7bfb5e68143$var$ComponentModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $d33df6a494dc243d$var$platform = '';
// Navigator not exists in node
if (typeof navigator !== 'undefined') /* global navigator */ $d33df6a494dc243d$var$platform = navigator.platform || '';
var $d33df6a494dc243d$var$decalColor = 'rgba(0, 0, 0, 0.2)';
var $d33df6a494dc243d$export$2e2bcd8739ae039 = {
    darkMode: 'auto',
    // backgroundColor: 'rgba(0,0,0,0)',
    colorBy: 'series',
    color: [
        '#5470c6',
        '#91cc75',
        '#fac858',
        '#ee6666',
        '#73c0de',
        '#3ba272',
        '#fc8452',
        '#9a60b4',
        '#ea7ccc'
    ],
    gradientColor: [
        '#f6efa6',
        '#d88273',
        '#bf444c'
    ],
    aria: {
        decal: {
            decals: [
                {
                    color: $d33df6a494dc243d$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        2,
                        5
                    ],
                    symbolSize: 1,
                    rotation: Math.PI / 6
                },
                {
                    color: $d33df6a494dc243d$var$decalColor,
                    symbol: 'circle',
                    dashArrayX: [
                        [
                            8,
                            8
                        ],
                        [
                            0,
                            8,
                            8,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ],
                    symbolSize: 0.8
                },
                {
                    color: $d33df6a494dc243d$var$decalColor,
                    dashArrayX: [
                        1,
                        0
                    ],
                    dashArrayY: [
                        4,
                        3
                    ],
                    rotation: -Math.PI / 4
                },
                {
                    color: $d33df6a494dc243d$var$decalColor,
                    dashArrayX: [
                        [
                            6,
                            6
                        ],
                        [
                            0,
                            6,
                            6,
                            0
                        ]
                    ],
                    dashArrayY: [
                        6,
                        0
                    ]
                },
                {
                    color: $d33df6a494dc243d$var$decalColor,
                    dashArrayX: [
                        [
                            1,
                            0
                        ],
                        [
                            1,
                            6
                        ]
                    ],
                    dashArrayY: [
                        1,
                        0,
                        6,
                        0
                    ],
                    rotation: Math.PI / 4
                },
                {
                    color: $d33df6a494dc243d$var$decalColor,
                    symbol: 'triangle',
                    dashArrayX: [
                        [
                            9,
                            9
                        ],
                        [
                            0,
                            9,
                            9,
                            0
                        ]
                    ],
                    dashArrayY: [
                        7,
                        2
                    ],
                    symbolSize: 0.75
                }
            ]
        }
    },
    // If xAxis and yAxis declared, grid is created by default.
    // grid: {},
    textStyle: {
        // color: '#000',
        // decoration: 'none',
        // PENDING
        fontFamily: $d33df6a494dc243d$var$platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
        // fontFamily: 'Arial, Verdana, sans-serif',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 'normal'
    },
    // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
    // Default is source-over
    blendMode: null,
    stateAnimation: {
        duration: 300,
        easing: 'cubicOut'
    },
    animation: 'auto',
    animationDuration: 1000,
    animationDurationUpdate: 500,
    animationEasing: 'cubicInOut',
    animationEasingUpdate: 'cubicInOut',
    animationThreshold: 2000,
    // Configuration for progressive/incremental rendering
    progressiveThreshold: 3000,
    progressive: 400,
    // Threshold of if use single hover layer to optimize.
    // It is recommended that `hoverLayerThreshold` is equivalent to or less than
    // `progressiveThreshold`, otherwise hover will cause restart of progressive,
    // which is unexpected.
    // see example <echarts/test/heatmap-large.html>.
    hoverLayerThreshold: 3000,
    // See: module:echarts/scale/Time
    useUTC: false
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $369d2fc585e5938e$export$cd51b5ca77f6f0e4 = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)([
    'tooltip',
    'label',
    'itemName',
    'itemId',
    'itemGroupId',
    'itemChildGroupId',
    'seriesName'
]);
var $369d2fc585e5938e$export$2823037fb9d8f0c6 = 'original';
var $369d2fc585e5938e$export$fcd62ebf51387903 = 'arrayRows';
var $369d2fc585e5938e$export$703ae8a2d83f441 = 'objectRows';
var $369d2fc585e5938e$export$6a32b42c754a3cb8 = 'keyedColumns';
var $369d2fc585e5938e$export$a918cb016a382d45 = 'typedArray';
var $369d2fc585e5938e$export$c78f1330778d30d = 'unknown';
var $369d2fc585e5938e$export$7b3f3c6551b4949b = 'column';
var $369d2fc585e5938e$export$d55da1467cdf7804 = 'row';


var $669a01b8661bdd13$export$328749e9c5b40760 = {
    Must: 1,
    Might: 2,
    Not: 3 // Other cases
};
var $669a01b8661bdd13$var$innerGlobalModel = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $669a01b8661bdd13$export$b30cdea50aa00e6(ecModel) {
    // `datasetMap` is used to make default encode.
    $669a01b8661bdd13$var$innerGlobalModel(ecModel).datasetMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
}
function $669a01b8661bdd13$export$37682b8fdd2e83d(coordDimensions, seriesModel, source) {
    var encode = {};
    var datasetModel = $669a01b8661bdd13$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel || !coordDimensions) return encode;
    var encodeItemName = [];
    var encodeSeriesName = [];
    var ecModel = seriesModel.ecModel;
    var datasetMap = $669a01b8661bdd13$var$innerGlobalModel(ecModel).datasetMap;
    var key = datasetModel.uid + '_' + source.seriesLayoutBy;
    var baseCategoryDimIndex;
    var categoryWayValueDimStart;
    coordDimensions = coordDimensions.slice();
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfoLoose, coordDimIdx) {
        var coordDimInfo = (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(coordDimInfoLoose) ? coordDimInfoLoose : coordDimensions[coordDimIdx] = {
            name: coordDimInfoLoose
        };
        if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
            baseCategoryDimIndex = coordDimIdx;
            categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimInfo);
        }
        encode[coordDimInfo.name] = [];
    });
    var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
        categoryWayDim: categoryWayValueDimStart,
        valueWayDim: 0
    });
    // TODO
    // Auto detect first time axis and do arrangement.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(coordDimensions, function(coordDimInfo, coordDimIdx) {
        var coordDimName = coordDimInfo.name;
        var count = getDataDimCountOnCoordDim(coordDimInfo);
        // In value way.
        if (baseCategoryDimIndex == null) {
            var start = datasetRecord.valueWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.valueWayDim += count;
        // ??? TODO give a better default series name rule?
        // especially when encode x y specified.
        // consider: when multiple series share one dimension
        // category axis, series name should better use
        // the other dimension name. On the other hand, use
        // both dimensions name.
        } else if (baseCategoryDimIndex === coordDimIdx) {
            pushDim(encode[coordDimName], 0, count);
            pushDim(encodeItemName, 0, count);
        } else {
            var start = datasetRecord.categoryWayDim;
            pushDim(encode[coordDimName], start, count);
            pushDim(encodeSeriesName, start, count);
            datasetRecord.categoryWayDim += count;
        }
    });
    function pushDim(dimIdxArr, idxFrom, idxCount) {
        for(var i = 0; i < idxCount; i++)dimIdxArr.push(idxFrom + i);
    }
    function getDataDimCountOnCoordDim(coordDimInfo) {
        var dimsDef = coordDimInfo.dimsDef;
        return dimsDef ? dimsDef.length : 1;
    }
    encodeItemName.length && (encode.itemName = encodeItemName);
    encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
    return encode;
}
function $669a01b8661bdd13$export$60b8a57d1f2fed26(seriesModel, source, dimCount) {
    var encode = {};
    var datasetModel = $669a01b8661bdd13$export$8da66f73a1eda454(seriesModel);
    // Currently only make default when using dataset, util more reqirements occur.
    if (!datasetModel) return encode;
    var sourceFormat = source.sourceFormat;
    var dimensionsDefine = source.dimensionsDefine;
    var potentialNameDimIndex;
    if (sourceFormat === (0, $369d2fc585e5938e$export$703ae8a2d83f441) || sourceFormat === (0, $369d2fc585e5938e$export$6a32b42c754a3cb8)) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dimensionsDefine, function(dim, idx) {
        if (((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dim) ? dim.name : dim) === 'name') potentialNameDimIndex = idx;
    });
    var idxResult = function() {
        var idxRes0 = {};
        var idxRes1 = {};
        var guessRecords = [];
        // 5 is an experience value.
        for(var i = 0, len = Math.min(5, dimCount); i < len; i++){
            var guessResult = $669a01b8661bdd13$var$doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
            guessRecords.push(guessResult);
            var isPureNumber = guessResult === $669a01b8661bdd13$export$328749e9c5b40760.Not;
            // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
            // and then find a name dim with the priority:
            // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
            if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) idxRes0.v = i;
            if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === $669a01b8661bdd13$export$328749e9c5b40760.Not) idxRes0.n = i;
            if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== $669a01b8661bdd13$export$328749e9c5b40760.Not) return idxRes0;
            // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
            // find the first BE_ORDINAL.Might as the value dim,
            // and then find a name dim with the priority:
            // "other dim" > "the value dim itself".
            // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
            // treated as number.
            if (!isPureNumber) {
                if (guessResult === $669a01b8661bdd13$export$328749e9c5b40760.Might && idxRes1.v == null && i !== potentialNameDimIndex) idxRes1.v = i;
                if (idxRes1.n == null || idxRes1.n === idxRes1.v) idxRes1.n = i;
            }
        }
        function fulfilled(idxResult) {
            return idxResult.v != null && idxResult.n != null;
        }
        return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
    }();
    if (idxResult) {
        encode.value = [
            idxResult.v
        ];
        // `potentialNameDimIndex` has highest priority.
        var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n;
        // By default, label uses itemName in charts.
        // So we don't set encodeLabel here.
        encode.itemName = [
            nameDimIndex
        ];
        encode.seriesName = [
            nameDimIndex
        ];
    }
    return encode;
}
function $669a01b8661bdd13$export$8da66f73a1eda454(seriesModel) {
    // Caution: consider the scenario:
    // A dataset is declared and a series is not expected to use the dataset,
    // and at the beginning `setOption({series: { noData })` (just prepare other
    // option but no data), then `setOption({series: {data: [...]}); In this case,
    // the user should set an empty array to avoid that dataset is used by default.
    var thisData = seriesModel.get('data', true);
    if (!thisData) return (0, $9ac03c46e8b6e711$export$dc741340f7e5f186)(seriesModel.ecModel, 'dataset', {
        index: seriesModel.get('datasetIndex', true),
        id: seriesModel.get('datasetId', true)
    }, (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
}
function $669a01b8661bdd13$export$397ba553479711e7(datasetModel) {
    // Only these attributes declared, we by default reference to `datasetIndex: 0`.
    // Otherwise, no reference.
    if (!datasetModel.get('transform', true) && !datasetModel.get('fromTransformResult', true)) return [];
    return (0, $9ac03c46e8b6e711$export$dc741340f7e5f186)(datasetModel.ecModel, 'dataset', {
        index: datasetModel.get('fromDatasetIndex', true),
        id: datasetModel.get('fromDatasetId', true)
    }, (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models;
}
function $669a01b8661bdd13$export$c51adf1a2be01b9c(source, dimIndex) {
    return $669a01b8661bdd13$var$doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
}
// dimIndex may be overflow source data.
// return {BE_ORDINAL}
function $669a01b8661bdd13$var$doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
    var result;
    // Experience value.
    var maxLoop = 5;
    if ((0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(data)) return $669a01b8661bdd13$export$328749e9c5b40760.Not;
    // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
    // always exists in source.
    var dimName;
    var dimType;
    if (dimensionsDefine) {
        var dimDefItem = dimensionsDefine[dimIndex];
        if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dimDefItem)) {
            dimName = dimDefItem.name;
            dimType = dimDefItem.type;
        } else if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(dimDefItem)) dimName = dimDefItem;
    }
    if (dimType != null) return dimType === 'ordinal' ? $669a01b8661bdd13$export$328749e9c5b40760.Must : $669a01b8661bdd13$export$328749e9c5b40760.Not;
    if (sourceFormat === (0, $369d2fc585e5938e$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        if (seriesLayoutBy === (0, $369d2fc585e5938e$export$d55da1467cdf7804)) {
            var sample = dataArrayRows[dimIndex];
            for(var i = 0; i < (sample || []).length && i < maxLoop; i++){
                if ((result = detectValue(sample[startIndex + i])) != null) return result;
            }
        } else for(var i = 0; i < dataArrayRows.length && i < maxLoop; i++){
            var row = dataArrayRows[startIndex + i];
            if (row && (result = detectValue(row[dimIndex])) != null) return result;
        }
    } else if (sourceFormat === (0, $369d2fc585e5938e$export$703ae8a2d83f441)) {
        var dataObjectRows = data;
        if (!dimName) return $669a01b8661bdd13$export$328749e9c5b40760.Not;
        for(var i = 0; i < dataObjectRows.length && i < maxLoop; i++){
            var item = dataObjectRows[i];
            if (item && (result = detectValue(item[dimName])) != null) return result;
        }
    } else if (sourceFormat === (0, $369d2fc585e5938e$export$6a32b42c754a3cb8)) {
        var dataKeyedColumns = data;
        if (!dimName) return $669a01b8661bdd13$export$328749e9c5b40760.Not;
        var sample = dataKeyedColumns[dimName];
        if (!sample || (0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(sample)) return $669a01b8661bdd13$export$328749e9c5b40760.Not;
        for(var i = 0; i < sample.length && i < maxLoop; i++){
            if ((result = detectValue(sample[i])) != null) return result;
        }
    } else if (sourceFormat === (0, $369d2fc585e5938e$export$2823037fb9d8f0c6)) {
        var dataOriginal = data;
        for(var i = 0; i < dataOriginal.length && i < maxLoop; i++){
            var item = dataOriginal[i];
            var val = (0, $9ac03c46e8b6e711$export$2c944e12edb48d4b)(item);
            if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(val)) return $669a01b8661bdd13$export$328749e9c5b40760.Not;
            if ((result = detectValue(val[dimIndex])) != null) return result;
        }
    }
    function detectValue(val) {
        var beStr = (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(val);
        // Consider usage convenience, '1', '2' will be treated as "number".
        // `Number('')` (or any whitespace) is `0`.
        if (val != null && Number.isFinite(Number(val)) && val !== '') return beStr ? $669a01b8661bdd13$export$328749e9c5b40760.Might : $669a01b8661bdd13$export$328749e9c5b40760.Not;
        else if (beStr && val !== '-') return $669a01b8661bdd13$export$328749e9c5b40760.Must;
    }
    return $669a01b8661bdd13$export$328749e9c5b40760.Not;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $deee41f242222a3b$var$internalOptionCreatorMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
function $deee41f242222a3b$export$5a90be4668898d38(mainType, creator) {
    (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)($deee41f242222a3b$var$internalOptionCreatorMap.get(mainType) == null && creator);
    $deee41f242222a3b$var$internalOptionCreatorMap.set(mainType, creator);
}
function $deee41f242222a3b$export$c713a6a3b43f401d(ecModel, mainType, newCmptOptionList) {
    var internalOptionCreator = $deee41f242222a3b$var$internalOptionCreatorMap.get(mainType);
    if (!internalOptionCreator) return newCmptOptionList;
    var internalOptions = internalOptionCreator(ecModel);
    if (!internalOptions) return newCmptOptionList;
    var i;
    return newCmptOptionList.concat(internalOptions);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $6d8b6513f520ae7c$var$innerColor = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $6d8b6513f520ae7c$var$innerDecal = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $6d8b6513f520ae7c$export$55a3c39e852b90f4 = /** @class */ function() {
    function PaletteMixin() {}
    PaletteMixin.prototype.getColorFromPalette = function(name, scope, requestNum) {
        var defaultPalette = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(this.get('color', true));
        var layeredPalette = this.get('colorLayer', true);
        return $6d8b6513f520ae7c$var$getFromPalette(this, $6d8b6513f520ae7c$var$innerColor, defaultPalette, layeredPalette, name, scope, requestNum);
    };
    PaletteMixin.prototype.clearColorPalette = function() {
        $6d8b6513f520ae7c$var$clearPalette(this, $6d8b6513f520ae7c$var$innerColor);
    };
    return PaletteMixin;
}();
function $6d8b6513f520ae7c$export$e4d892222945a227(ecModel, name, scope, requestNum) {
    var defaultDecals = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    return $6d8b6513f520ae7c$var$getFromPalette(ecModel, $6d8b6513f520ae7c$var$innerDecal, defaultDecals, null, name, scope, requestNum);
}
function $6d8b6513f520ae7c$var$getNearestPalette(palettes, requestColorNum) {
    var paletteNum = palettes.length;
    // TODO palettes must be in order
    for(var i = 0; i < paletteNum; i++){
        if (palettes[i].length > requestColorNum) return palettes[i];
    }
    return palettes[paletteNum - 1];
}
/**
 * @param name MUST NOT be null/undefined. Otherwise call this function
 *             twise with the same parameters will get different result.
 * @param scope default this.
 * @return Can be null/undefined
 */ function $6d8b6513f520ae7c$var$getFromPalette(that, inner, defaultPalette, layeredPalette, name, scope, requestNum) {
    scope = scope || that;
    var scopeFields = inner(scope);
    var paletteIdx = scopeFields.paletteIdx || 0;
    var paletteNameMap = scopeFields.paletteNameMap = scopeFields.paletteNameMap || {};
    // Use `hasOwnProperty` to avoid conflict with Object.prototype.
    if (paletteNameMap.hasOwnProperty(name)) return paletteNameMap[name];
    var palette = requestNum == null || !layeredPalette ? defaultPalette : $6d8b6513f520ae7c$var$getNearestPalette(layeredPalette, requestNum);
    // In case can't find in layered color palette.
    palette = palette || defaultPalette;
    if (!palette || !palette.length) return;
    var pickedPaletteItem = palette[paletteIdx];
    if (name) paletteNameMap[name] = pickedPaletteItem;
    scopeFields.paletteIdx = (paletteIdx + 1) % palette.length;
    return pickedPaletteItem;
}
function $6d8b6513f520ae7c$var$clearPalette(that, inner) {
    inner(that).paletteIdx = 0;
    inner(that).paletteNameMap = {};
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $4ef07c0eafe44628$var$ECHARTS_PREFIX = '[ECharts] ';
var $4ef07c0eafe44628$var$storedLogs = {};
var $4ef07c0eafe44628$var$hasConsole = typeof console !== 'undefined' && console.warn && console.log;
function $4ef07c0eafe44628$var$outputLog(type, str, onlyOnce) {
    if ($4ef07c0eafe44628$var$hasConsole) {
        if (onlyOnce) {
            if ($4ef07c0eafe44628$var$storedLogs[str]) return;
            $4ef07c0eafe44628$var$storedLogs[str] = true;
        }
        // eslint-disable-next-line
        console[type]($4ef07c0eafe44628$var$ECHARTS_PREFIX + str);
    }
}
function $4ef07c0eafe44628$export$bef1f36f5486a6a3(str, onlyOnce) {
    $4ef07c0eafe44628$var$outputLog('log', str, onlyOnce);
}
function $4ef07c0eafe44628$export$c106dd0671a0fc2d(str, onlyOnce) {
    $4ef07c0eafe44628$var$outputLog('warn', str, onlyOnce);
}
function $4ef07c0eafe44628$export$a3bc9b8ed74fc(str, onlyOnce) {
    $4ef07c0eafe44628$var$outputLog('error', str, onlyOnce);
}
function $4ef07c0eafe44628$export$4a9c0b74eb885aa1(str) {}
function $4ef07c0eafe44628$export$bbd91d66002c4ea6(oldOpt, newOpt, scope) {}
function $4ef07c0eafe44628$export$a68bb8b222a6bd43() {
    var hintInfo = [];
    for(var _i = 0; _i < arguments.length; _i++)hintInfo[_i] = arguments[_i];
    var msg = '';
    var makePrintableStringIfPossible_1;
    return msg;
}
function $4ef07c0eafe44628$export$8bf7aba4a9e09055(msg) {
    throw new Error(msg);
}


// -----------------------
// Internal method names:
// -----------------------
var $eed56b0401cb1831$var$reCreateSeriesIndices;
var $eed56b0401cb1831$var$assertSeriesInitialized;
var $eed56b0401cb1831$var$initBase;
var $eed56b0401cb1831$var$OPTION_INNER_KEY = '\0_ec_inner';
var $eed56b0401cb1831$var$OPTION_INNER_VALUE = 1;
var $eed56b0401cb1831$var$BUITIN_COMPONENTS_MAP = {
    grid: 'GridComponent',
    polar: 'PolarComponent',
    geo: 'GeoComponent',
    singleAxis: 'SingleAxisComponent',
    parallel: 'ParallelComponent',
    calendar: 'CalendarComponent',
    graphic: 'GraphicComponent',
    toolbox: 'ToolboxComponent',
    tooltip: 'TooltipComponent',
    axisPointer: 'AxisPointerComponent',
    brush: 'BrushComponent',
    title: 'TitleComponent',
    timeline: 'TimelineComponent',
    markPoint: 'MarkPointComponent',
    markLine: 'MarkLineComponent',
    markArea: 'MarkAreaComponent',
    legend: 'LegendComponent',
    dataZoom: 'DataZoomComponent',
    visualMap: 'VisualMapComponent',
    // aria: 'AriaComponent',
    // dataset: 'DatasetComponent',
    // Dependencies
    xAxis: 'GridComponent',
    yAxis: 'GridComponent',
    angleAxis: 'PolarComponent',
    radiusAxis: 'PolarComponent'
};
var $eed56b0401cb1831$var$BUILTIN_CHARTS_MAP = {
    line: 'LineChart',
    bar: 'BarChart',
    pie: 'PieChart',
    scatter: 'ScatterChart',
    radar: 'RadarChart',
    map: 'MapChart',
    tree: 'TreeChart',
    treemap: 'TreemapChart',
    graph: 'GraphChart',
    gauge: 'GaugeChart',
    funnel: 'FunnelChart',
    parallel: 'ParallelChart',
    sankey: 'SankeyChart',
    boxplot: 'BoxplotChart',
    candlestick: 'CandlestickChart',
    effectScatter: 'EffectScatterChart',
    lines: 'LinesChart',
    heatmap: 'HeatmapChart',
    pictorialBar: 'PictorialBarChart',
    themeRiver: 'ThemeRiverChart',
    sunburst: 'SunburstChart',
    custom: 'CustomChart'
};
var $eed56b0401cb1831$var$componetsMissingLogPrinted = {};
function $eed56b0401cb1831$var$checkMissingComponents(option) {
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(option, function(componentOption, mainType) {
        if (!(0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).hasClass(mainType)) {
            var componentImportName = $eed56b0401cb1831$var$BUITIN_COMPONENTS_MAP[mainType];
            if (componentImportName && !$eed56b0401cb1831$var$componetsMissingLogPrinted[componentImportName]) {
                (0, $4ef07c0eafe44628$export$a3bc9b8ed74fc)("Component " + mainType + " is used but not imported.\nimport { " + componentImportName + " } from 'echarts/components';\necharts.use([" + componentImportName + "]);");
                $eed56b0401cb1831$var$componetsMissingLogPrinted[componentImportName] = true;
            }
        }
    });
}
var $eed56b0401cb1831$var$GlobalModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GlobalModel, _super);
    function GlobalModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GlobalModel.prototype.init = function(option, parentModel, ecModel, theme, locale, optionManager) {
        theme = theme || {};
        this.option = null; // Mark as not initialized.
        this._theme = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(theme);
        this._locale = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(locale);
        this._optionManager = optionManager;
    };
    GlobalModel.prototype.setOption = function(option, opts, optionPreprocessorFuncs) {
        var innerOpt = $eed56b0401cb1831$var$normalizeSetOptionInput(opts);
        this._optionManager.setOption(option, optionPreprocessorFuncs, innerOpt);
        this._resetOption(null, innerOpt);
    };
    /**
   * @param type null/undefined: reset all.
   *        'recreate': force recreate all.
   *        'timeline': only reset timeline option
   *        'media': only reset media query option
   * @return Whether option changed.
   */ GlobalModel.prototype.resetOption = function(type, opt) {
        return this._resetOption(type, $eed56b0401cb1831$var$normalizeSetOptionInput(opt));
    };
    GlobalModel.prototype._resetOption = function(type, opt) {
        var optionChanged = false;
        var optionManager = this._optionManager;
        if (!type || type === 'recreate') {
            var baseOption = optionManager.mountOption(type === 'recreate');
            if (!this.option || type === 'recreate') $eed56b0401cb1831$var$initBase(this, baseOption);
            else {
                this.restoreData();
                this._mergeOption(baseOption, opt);
            }
            optionChanged = true;
        }
        if (type === 'timeline' || type === 'media') this.restoreData();
        // By design, if `setOption(option2)` at the second time, and `option2` is a `ECUnitOption`,
        // it should better not have the same props with `MediaUnit['option']`.
        // Because either `option2` or `MediaUnit['option']` will be always merged to "current option"
        // rather than original "baseOption". If they both override a prop, the result might be
        // unexpected when media state changed after `setOption` called.
        // If we really need to modify a props in each `MediaUnit['option']`, use the full version
        // (`{baseOption, media}`) in `setOption`.
        // For `timeline`, the case is the same.
        if (!type || type === 'recreate' || type === 'timeline') {
            var timelineOption = optionManager.getTimelineOption(this);
            if (timelineOption) {
                optionChanged = true;
                this._mergeOption(timelineOption, opt);
            }
        }
        if (!type || type === 'recreate' || type === 'media') {
            var mediaOptions = optionManager.getMediaOption(this);
            if (mediaOptions.length) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mediaOptions, function(mediaOption) {
                optionChanged = true;
                this._mergeOption(mediaOption, opt);
            }, this);
        }
        return optionChanged;
    };
    GlobalModel.prototype.mergeOption = function(option) {
        this._mergeOption(option, null);
    };
    GlobalModel.prototype._mergeOption = function(newOption, opt) {
        var option = this.option;
        var componentsMap = this._componentsMap;
        var componentsCount = this._componentsCount;
        var newCmptTypes = [];
        var newCmptTypeMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        var replaceMergeMainTypeMap = opt && opt.replaceMergeMainTypeMap;
        (0, $669a01b8661bdd13$export$b30cdea50aa00e6)(this);
        // If no component class, merge directly.
        // For example: color, animaiton options, etc.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newOption, function(componentOption, mainType) {
            if (componentOption == null) return;
            if (!(0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).hasClass(mainType)) // globalSettingTask.dirty();
            option[mainType] = option[mainType] == null ? (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(componentOption) : (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(option[mainType], componentOption, true);
            else if (mainType) {
                newCmptTypes.push(mainType);
                newCmptTypeMap.set(mainType, true);
            }
        });
        if (replaceMergeMainTypeMap) // If there is a mainType `xxx` in `replaceMerge` but not declared in option,
        // we trade it as it is declared in option as `{xxx: []}`. Because:
        // (1) for normal merge, `{xxx: null/undefined}` are the same meaning as `{xxx: []}`.
        // (2) some preprocessor may convert some of `{xxx: null/undefined}` to `{xxx: []}`.
        replaceMergeMainTypeMap.each(function(val, mainTypeInReplaceMerge) {
            if ((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).hasClass(mainTypeInReplaceMerge) && !newCmptTypeMap.get(mainTypeInReplaceMerge)) {
                newCmptTypes.push(mainTypeInReplaceMerge);
                newCmptTypeMap.set(mainTypeInReplaceMerge, true);
            }
        });
        (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).topologicalTravel(newCmptTypes, (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).getAllClassMainTypes(), visitComponent, this);
        function visitComponent(mainType) {
            var newCmptOptionList = (0, $deee41f242222a3b$export$c713a6a3b43f401d)(this, mainType, $9ac03c46e8b6e711$export$4f07b212a02c8051(newOption[mainType]));
            var oldCmptList = componentsMap.get(mainType);
            var mergeMode = // `!oldCmptList` means init. See the comment in `mappingToExists`
            !oldCmptList ? 'replaceAll' : replaceMergeMainTypeMap && replaceMergeMainTypeMap.get(mainType) ? 'replaceMerge' : 'normalMerge';
            var mappingResult = $9ac03c46e8b6e711$export$574f818966e4da87(oldCmptList, newCmptOptionList, mergeMode);
            // Set mainType and complete subType.
            $9ac03c46e8b6e711$export$5ac61aca2ba0282d(mappingResult, mainType, (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
            // Empty it before the travel, in order to prevent `this._componentsMap`
            // from being used in the `init`/`mergeOption`/`optionUpdated` of some
            // components, which is probably incorrect logic.
            option[mainType] = null;
            componentsMap.set(mainType, null);
            componentsCount.set(mainType, 0);
            var optionsByMainType = [];
            var cmptsByMainType = [];
            var cmptsCountByMainType = 0;
            var tooltipExists;
            var tooltipWarningLogged;
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mappingResult, function(resultItem, index) {
                var componentModel = resultItem.existing;
                var newCmptOption = resultItem.newOption;
                if (!newCmptOption) {
                    if (componentModel) {
                        // Consider where is no new option and should be merged using {},
                        // see removeEdgeAndAdd in topologicalTravel and
                        // ComponentModel.getAllClassMainTypes.
                        componentModel.mergeOption({}, this);
                        componentModel.optionUpdated({}, false);
                    }
                } else {
                    var isSeriesType = mainType === 'series';
                    var ComponentModelClass = (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).getClass(mainType, resultItem.keyInfo.subType, !isSeriesType // Give a more detailed warn later if series don't exists
                    );
                    if (!ComponentModelClass) {
                        var subType, seriesImportName;
                        return;
                    }
                    // TODO Before multiple tooltips get supported, we do this check to avoid unexpected exception.
                    if (mainType === 'tooltip') {
                        if (tooltipExists) return;
                        tooltipExists = true;
                    }
                    if (componentModel && componentModel.constructor === ComponentModelClass) {
                        componentModel.name = resultItem.keyInfo.name;
                        // componentModel.settingTask && componentModel.settingTask.dirty();
                        componentModel.mergeOption(newCmptOption, this);
                        componentModel.optionUpdated(newCmptOption, false);
                    } else {
                        // PENDING Global as parent ?
                        var extraOpt = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
                            componentIndex: index
                        }, resultItem.keyInfo);
                        componentModel = new ComponentModelClass(newCmptOption, this, this, extraOpt);
                        // Assign `keyInfo`
                        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(componentModel, extraOpt);
                        if (resultItem.brandNew) componentModel.__requireNewView = true;
                        componentModel.init(newCmptOption, this, this);
                        // Call optionUpdated after init.
                        // newCmptOption has been used as componentModel.option
                        // and may be merged with theme and default, so pass null
                        // to avoid confusion.
                        componentModel.optionUpdated(null, true);
                    }
                }
                if (componentModel) {
                    optionsByMainType.push(componentModel.option);
                    cmptsByMainType.push(componentModel);
                    cmptsCountByMainType++;
                } else {
                    // Always do assign to avoid elided item in array.
                    optionsByMainType.push(void 0);
                    cmptsByMainType.push(void 0);
                }
            }, this);
            option[mainType] = optionsByMainType;
            componentsMap.set(mainType, cmptsByMainType);
            componentsCount.set(mainType, cmptsCountByMainType);
            // Backup series for filtering.
            if (mainType === 'series') $eed56b0401cb1831$var$reCreateSeriesIndices(this);
        }
        // If no series declared, ensure `_seriesIndices` initialized.
        if (!this._seriesIndices) $eed56b0401cb1831$var$reCreateSeriesIndices(this);
    };
    /**
   * Get option for output (cloned option and inner info removed)
   */ GlobalModel.prototype.getOption = function() {
        var option = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(this.option);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(option, function(optInMainType, mainType) {
            if ((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).hasClass(mainType)) {
                var opts = $9ac03c46e8b6e711$export$4f07b212a02c8051(optInMainType);
                // Inner cmpts need to be removed.
                // Inner cmpts might not be at last since ec5.0, but still
                // compatible for users: if inner cmpt at last, splice the returned array.
                var realLen = opts.length;
                var metNonInner = false;
                for(var i = realLen - 1; i >= 0; i--)// Remove options with inner id.
                if (opts[i] && !$9ac03c46e8b6e711$export$feece3e7d52a102b(opts[i])) metNonInner = true;
                else {
                    opts[i] = null;
                    !metNonInner && realLen--;
                }
                opts.length = realLen;
                option[mainType] = opts;
            }
        });
        delete option[$eed56b0401cb1831$var$OPTION_INNER_KEY];
        return option;
    };
    GlobalModel.prototype.getTheme = function() {
        return this._theme;
    };
    GlobalModel.prototype.getLocaleModel = function() {
        return this._locale;
    };
    GlobalModel.prototype.setUpdatePayload = function(payload) {
        this._payload = payload;
    };
    GlobalModel.prototype.getUpdatePayload = function() {
        return this._payload;
    };
    /**
   * @param idx If not specified, return the first one.
   */ GlobalModel.prototype.getComponent = function(mainType, idx) {
        var list = this._componentsMap.get(mainType);
        if (list) {
            var cmpt = list[idx || 0];
            if (cmpt) return cmpt;
            else if (idx == null) for(var i = 0; i < list.length; i++){
                if (list[i]) return list[i];
            }
        }
    };
    /**
   * @return Never be null/undefined.
   */ GlobalModel.prototype.queryComponents = function(condition) {
        var mainType = condition.mainType;
        if (!mainType) return [];
        var index = condition.index;
        var id = condition.id;
        var name = condition.name;
        var cmpts = this._componentsMap.get(mainType);
        if (!cmpts || !cmpts.length) return [];
        var result;
        if (index != null) {
            result = [];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($9ac03c46e8b6e711$export$4f07b212a02c8051(index), function(idx) {
                cmpts[idx] && result.push(cmpts[idx]);
            });
        } else if (id != null) result = $eed56b0401cb1831$var$queryByIdOrName('id', id, cmpts);
        else if (name != null) result = $eed56b0401cb1831$var$queryByIdOrName('name', name, cmpts);
        else // Return all non-empty components in that mainType
        result = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return !!cmpt;
        });
        return $eed56b0401cb1831$var$filterBySubType(result, condition);
    };
    /**
   * The interface is different from queryComponents,
   * which is convenient for inner usage.
   *
   * @usage
   * let result = findComponents(
   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
   * );
   * let result = findComponents(
   *     {mainType: 'series',
   *     filter: function (model, index) {...}}
   * );
   * // result like [component0, componnet1, ...]
   */ GlobalModel.prototype.findComponents = function(condition) {
        var query = condition.query;
        var mainType = condition.mainType;
        var queryCond = getQueryCond(query);
        var result = queryCond ? this.queryComponents(queryCond) : (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(this._componentsMap.get(mainType), function(cmpt) {
            return !!cmpt;
        });
        return doFilter($eed56b0401cb1831$var$filterBySubType(result, condition));
        function getQueryCond(q) {
            var indexAttr = mainType + 'Index';
            var idAttr = mainType + 'Id';
            var nameAttr = mainType + 'Name';
            return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
                mainType: mainType,
                // subType will be filtered finally.
                index: q[indexAttr],
                id: q[idAttr],
                name: q[nameAttr]
            } : null;
        }
        function doFilter(res) {
            return condition.filter ? (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(res, condition.filter) : res;
        }
    };
    GlobalModel.prototype.eachComponent = function(mainType, cb, context) {
        var componentsMap = this._componentsMap;
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(mainType)) {
            var ctxForAll_1 = cb;
            var cbForAll_1 = mainType;
            componentsMap.each(function(cmpts, componentType) {
                for(var i = 0; cmpts && i < cmpts.length; i++){
                    var cmpt = cmpts[i];
                    cmpt && cbForAll_1.call(ctxForAll_1, componentType, cmpt, cmpt.componentIndex);
                }
            });
        } else {
            var cmpts = (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(mainType) ? componentsMap.get(mainType) : (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(mainType) ? this.findComponents(mainType) : null;
            for(var i = 0; cmpts && i < cmpts.length; i++){
                var cmpt = cmpts[i];
                cmpt && cb.call(context, cmpt, cmpt.componentIndex);
            }
        }
    };
    /**
   * Get series list before filtered by name.
   */ GlobalModel.prototype.getSeriesByName = function(name) {
        var nameStr = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(name, null);
        return (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && nameStr != null && oneSeries.name === nameStr;
        });
    };
    /**
   * Get series list before filtered by index.
   */ GlobalModel.prototype.getSeriesByIndex = function(seriesIndex) {
        return this._componentsMap.get('series')[seriesIndex];
    };
    /**
   * Get series list before filtered by type.
   * FIXME: rename to getRawSeriesByType?
   */ GlobalModel.prototype.getSeriesByType = function(subType) {
        return (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries && oneSeries.subType === subType;
        });
    };
    /**
   * Get all series before filtered.
   */ GlobalModel.prototype.getSeries = function() {
        return (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(this._componentsMap.get('series'), function(oneSeries) {
            return !!oneSeries;
        });
    };
    /**
   * Count series before filtered.
   */ GlobalModel.prototype.getSeriesCount = function() {
        return this._componentsCount.get('series');
    };
    /**
   * After filtering, series may be different
   * from raw series.
   */ GlobalModel.prototype.eachSeries = function(cb, context) {
        $eed56b0401cb1831$var$assertSeriesInitialized(this);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered.
   *
   * @param {Function} cb
   * @param {*} context
   */ GlobalModel.prototype.eachRawSeries = function(cb, context) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._componentsMap.get('series'), function(series) {
            series && cb.call(context, series, series.componentIndex);
        });
    };
    /**
   * After filtering, series may be different.
   * from raw series.
   */ GlobalModel.prototype.eachSeriesByType = function(subType, cb, context) {
        $eed56b0401cb1831$var$assertSeriesInitialized(this);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._seriesIndices, function(rawSeriesIndex) {
            var series = this._componentsMap.get('series')[rawSeriesIndex];
            if (series.subType === subType) cb.call(context, series, rawSeriesIndex);
        }, this);
    };
    /**
   * Iterate raw series before filtered of given type.
   */ GlobalModel.prototype.eachRawSeriesByType = function(subType, cb, context) {
        return (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this.getSeriesByType(subType), cb, context);
    };
    GlobalModel.prototype.isSeriesFiltered = function(seriesModel) {
        $eed56b0401cb1831$var$assertSeriesInitialized(this);
        return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
    };
    GlobalModel.prototype.getCurrentSeriesIndices = function() {
        return (this._seriesIndices || []).slice();
    };
    GlobalModel.prototype.filterSeries = function(cb, context) {
        $eed56b0401cb1831$var$assertSeriesInitialized(this);
        var newSeriesIndices = [];
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._seriesIndices, function(seriesRawIdx) {
            var series = this._componentsMap.get('series')[seriesRawIdx];
            cb.call(context, series, seriesRawIdx) && newSeriesIndices.push(seriesRawIdx);
        }, this);
        this._seriesIndices = newSeriesIndices;
        this._seriesIndicesMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)(newSeriesIndices);
    };
    GlobalModel.prototype.restoreData = function(payload) {
        $eed56b0401cb1831$var$reCreateSeriesIndices(this);
        var componentsMap = this._componentsMap;
        var componentTypes = [];
        componentsMap.each(function(components, componentType) {
            if ((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).hasClass(componentType)) componentTypes.push(componentType);
        });
        (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).topologicalTravel(componentTypes, (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).getAllClassMainTypes(), function(componentType) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(componentsMap.get(componentType), function(component) {
                if (component && (componentType !== 'series' || !$eed56b0401cb1831$var$isNotTargetSeries(component, payload))) component.restoreData();
            });
        });
    };
    GlobalModel.internalField = function() {
        $eed56b0401cb1831$var$reCreateSeriesIndices = function(ecModel) {
            var seriesIndices = ecModel._seriesIndices = [];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(ecModel._componentsMap.get('series'), function(series) {
                // series may have been removed by `replaceMerge`.
                series && seriesIndices.push(series.componentIndex);
            });
            ecModel._seriesIndicesMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)(seriesIndices);
        };
        $eed56b0401cb1831$var$assertSeriesInitialized = function(ecModel) {};
        $eed56b0401cb1831$var$initBase = function(ecModel, baseOption) {
            // Using OPTION_INNER_KEY to mark that this option cannot be used outside,
            // i.e. `chart.setOption(chart.getModel().option);` is forbidden.
            ecModel.option = {};
            ecModel.option[$eed56b0401cb1831$var$OPTION_INNER_KEY] = $eed56b0401cb1831$var$OPTION_INNER_VALUE;
            // Init with series: [], in case of calling findSeries method
            // before series initialized.
            ecModel._componentsMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)({
                series: []
            });
            ecModel._componentsCount = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
            // If user spefied `option.aria`, aria will be enable. This detection should be
            // performed before theme and globalDefault merge.
            var airaOption = baseOption.aria;
            if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(airaOption) && airaOption.enabled == null) airaOption.enabled = true;
            $eed56b0401cb1831$var$mergeTheme(baseOption, ecModel._theme.option);
            // TODO Needs clone when merging to the unexisted property
            (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(baseOption, (0, $d33df6a494dc243d$export$2e2bcd8739ae039), false);
            ecModel._mergeOption(baseOption, null);
        };
    }();
    return GlobalModel;
}((0, $3c5c9c3617b9c261$export$2e2bcd8739ae039));
function $eed56b0401cb1831$var$isNotTargetSeries(seriesModel, payload) {
    if (payload) {
        var index = payload.seriesIndex;
        var id = payload.seriesId;
        var name_1 = payload.seriesName;
        return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name_1 != null && seriesModel.name !== name_1;
    }
}
function $eed56b0401cb1831$var$mergeTheme(option, theme) {
    // PENDING
    // NOT use `colorLayer` in theme if option has `color`
    var notMergeColorLayer = option.color && !option.colorLayer;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(theme, function(themeItem, name) {
        if (name === 'colorLayer' && notMergeColorLayer) return;
        // If it is component model mainType, the model handles that merge later.
        // otherwise, merge them here.
        if (!(0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).hasClass(name)) {
            if (typeof themeItem === 'object') option[name] = !option[name] ? (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(themeItem) : (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(option[name], themeItem, false);
            else if (option[name] == null) option[name] = themeItem;
        }
    });
}
function $eed56b0401cb1831$var$queryByIdOrName(attr, idOrName, cmpts) {
    // Here is a break from echarts4: string and number are
    // treated as equal.
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(idOrName)) {
        var keyMap_1 = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(idOrName, function(idOrNameItem) {
            if (idOrNameItem != null) {
                var idName = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(idOrNameItem, null);
                idName != null && keyMap_1.set(idOrNameItem, true);
            }
        });
        return (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && keyMap_1.get(cmpt[attr]);
        });
    } else {
        var idName_1 = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(idOrName, null);
        return (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(cmpts, function(cmpt) {
            return cmpt && idName_1 != null && cmpt[attr] === idName_1;
        });
    }
}
function $eed56b0401cb1831$var$filterBySubType(components, condition) {
    // Using hasOwnProperty for restrict. Consider
    // subType is undefined in user payload.
    return condition.hasOwnProperty('subType') ? (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(components, function(cmpt) {
        return cmpt && cmpt.subType === condition.subType;
    }) : components;
}
function $eed56b0401cb1831$var$normalizeSetOptionInput(opts) {
    var replaceMergeMainTypeMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    opts && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($9ac03c46e8b6e711$export$4f07b212a02c8051(opts.replaceMerge), function(mainType) {
        replaceMergeMainTypeMap.set(mainType, true);
    });
    return {
        replaceMergeMainTypeMap: replaceMergeMainTypeMap
    };
}
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($eed56b0401cb1831$var$GlobalModel, (0, $6d8b6513f520ae7c$export$55a3c39e852b90f4));
var $eed56b0401cb1831$export$2e2bcd8739ae039 = $eed56b0401cb1831$var$GlobalModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $545b8cf22e653ed1$var$availableMethods = [
    'getDom',
    'getZr',
    'getWidth',
    'getHeight',
    'getDevicePixelRatio',
    'dispatchAction',
    'isSSR',
    'isDisposed',
    'on',
    'off',
    'getDataURL',
    'getConnectedDataURL',
    // 'getModel',
    'getOption',
    // 'getViewOfComponentModel',
    // 'getViewOfSeriesModel',
    'getId',
    'updateLabelLayout'
];
var $545b8cf22e653ed1$var$ExtensionAPI = /** @class */ function() {
    function ExtensionAPI(ecInstance) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($545b8cf22e653ed1$var$availableMethods, function(methodName) {
            this[methodName] = $1b239fc9d3a2f8ae$export$2385a24977818dd0(ecInstance[methodName], ecInstance);
        }, this);
    }
    return ExtensionAPI;
}();
var $545b8cf22e653ed1$export$2e2bcd8739ae039 = $545b8cf22e653ed1$var$ExtensionAPI;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $02d04429d2792472$var$coordinateSystemCreators = {};
var $02d04429d2792472$var$CoordinateSystemManager = /** @class */ function() {
    function CoordinateSystemManager() {
        this._coordinateSystems = [];
    }
    CoordinateSystemManager.prototype.create = function(ecModel, api) {
        var coordinateSystems = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($02d04429d2792472$var$coordinateSystemCreators, function(creator, type) {
            var list = creator.create(ecModel, api);
            coordinateSystems = coordinateSystems.concat(list || []);
        });
        this._coordinateSystems = coordinateSystems;
    };
    CoordinateSystemManager.prototype.update = function(ecModel, api) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._coordinateSystems, function(coordSys) {
            coordSys.update && coordSys.update(ecModel, api);
        });
    };
    CoordinateSystemManager.prototype.getCoordinateSystems = function() {
        return this._coordinateSystems.slice();
    };
    CoordinateSystemManager.register = function(type, creator) {
        $02d04429d2792472$var$coordinateSystemCreators[type] = creator;
    };
    CoordinateSystemManager.get = function(type) {
        return $02d04429d2792472$var$coordinateSystemCreators[type];
    };
    return CoordinateSystemManager;
}();
var $02d04429d2792472$export$2e2bcd8739ae039 = $02d04429d2792472$var$CoordinateSystemManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $c8dc8d8fa1d11e2c$var$QUERY_REG = /^(min|max)?(.+)$/;
// Key: mainType
// type FakeComponentsMap = HashMap<(MappingExistingItem & { subType: string })[]>;
/**
 * TERM EXPLANATIONS:
 * See `ECOption` and `ECUnitOption` in `src/util/types.ts`.
 */ var $c8dc8d8fa1d11e2c$var$OptionManager = /** @class */ function() {
    // timeline.notMerge is not supported in ec3. Firstly there is rearly
    // case that notMerge is needed. Secondly supporting 'notMerge' requires
    // rawOption cloned and backuped when timeline changed, which does no
    // good to performance. What's more, that both timeline and setOption
    // method supply 'notMerge' brings complex and some problems.
    // Consider this case:
    // (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
    // (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
    function OptionManager(api) {
        this._timelineOptions = [];
        this._mediaList = [];
        /**
     * -1, means default.
     * empty means no media.
     */ this._currentMediaIndices = [];
        this._api = api;
    }
    OptionManager.prototype.setOption = function(rawOption, optionPreprocessorFuncs, opt) {
        if (rawOption) {
            // That set dat primitive is dangerous if user reuse the data when setOption again.
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(rawOption.series), function(series) {
                series && series.data && (0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(series.data) && (0, $1b239fc9d3a2f8ae$export$112e66431016387b)(series.data);
            });
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(rawOption.dataset), function(dataset) {
                dataset && dataset.source && (0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(dataset.source) && (0, $1b239fc9d3a2f8ae$export$112e66431016387b)(dataset.source);
            });
        }
        // Caution: some series modify option data, if do not clone,
        // it should ensure that the repeat modify correctly
        // (create a new object when modify itself).
        rawOption = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(rawOption);
        // FIXME
        // If some property is set in timeline options or media option but
        // not set in baseOption, a warning should be given.
        var optionBackup = this._optionBackup;
        var newParsedOption = $c8dc8d8fa1d11e2c$var$parseRawOption(rawOption, optionPreprocessorFuncs, !optionBackup);
        this._newBaseOption = newParsedOption.baseOption;
        // For setOption at second time (using merge mode);
        if (optionBackup) {
            // FIXME
            // the restore merge solution is essentially incorrect.
            // the mapping can not be 100% consistent with ecModel, which probably brings
            // potential bug!
            // The first merge is delayed, because in most cases, users do not call `setOption` twice.
            // let fakeCmptsMap = this._fakeCmptsMap;
            // if (!fakeCmptsMap) {
            //     fakeCmptsMap = this._fakeCmptsMap = createHashMap();
            //     mergeToBackupOption(fakeCmptsMap, null, optionBackup.baseOption, null);
            // }
            // mergeToBackupOption(
            //     fakeCmptsMap, optionBackup.baseOption, newParsedOption.baseOption, opt
            // );
            // For simplicity, timeline options and media options do not support merge,
            // that is, if you `setOption` twice and both has timeline options, the latter
            // timeline options will not be merged to the former, but just substitute them.
            if (newParsedOption.timelineOptions.length) optionBackup.timelineOptions = newParsedOption.timelineOptions;
            if (newParsedOption.mediaList.length) optionBackup.mediaList = newParsedOption.mediaList;
            if (newParsedOption.mediaDefault) optionBackup.mediaDefault = newParsedOption.mediaDefault;
        } else this._optionBackup = newParsedOption;
    };
    OptionManager.prototype.mountOption = function(isRecreate) {
        var optionBackup = this._optionBackup;
        this._timelineOptions = optionBackup.timelineOptions;
        this._mediaList = optionBackup.mediaList;
        this._mediaDefault = optionBackup.mediaDefault;
        this._currentMediaIndices = [];
        return (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(isRecreate ? optionBackup.baseOption : this._newBaseOption);
    };
    OptionManager.prototype.getTimelineOption = function(ecModel) {
        var option;
        var timelineOptions = this._timelineOptions;
        if (timelineOptions.length) {
            // getTimelineOption can only be called after ecModel inited,
            // so we can get currentIndex from timelineModel.
            var timelineModel = ecModel.getComponent('timeline');
            if (timelineModel) option = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(// FIXME:TS as TimelineModel or quivlant interface
            timelineOptions[timelineModel.getCurrentIndex()]);
        }
        return option;
    };
    OptionManager.prototype.getMediaOption = function(ecModel) {
        var ecWidth = this._api.getWidth();
        var ecHeight = this._api.getHeight();
        var mediaList = this._mediaList;
        var mediaDefault = this._mediaDefault;
        var indices = [];
        var result = [];
        // No media defined.
        if (!mediaList.length && !mediaDefault) return result;
        // Multi media may be applied, the latter defined media has higher priority.
        for(var i = 0, len = mediaList.length; i < len; i++)if ($c8dc8d8fa1d11e2c$var$applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) indices.push(i);
        // FIXME
        // Whether mediaDefault should force users to provide? Otherwise
        // the change by media query can not be recorvered.
        if (!indices.length && mediaDefault) indices = [
            -1
        ];
        if (indices.length && !$c8dc8d8fa1d11e2c$var$indicesEquals(indices, this._currentMediaIndices)) result = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(indices, function(index) {
            return (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(index === -1 ? mediaDefault.option : mediaList[index].option);
        });
        // Otherwise return nothing.
        this._currentMediaIndices = indices;
        return result;
    };
    return OptionManager;
}();
/**
 * [RAW_OPTION_PATTERNS]
 * (Note: "series: []" represents all other props in `ECUnitOption`)
 *
 * (1) No prop "baseOption" declared:
 * Root option is used as "baseOption" (except prop "options" and "media").
 * ```js
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 * };
 * option = {
 *     series: [],
 *     media: {},
 * };
 * option = {
 *     series: [],
 *     timeline: {},
 *     options: [],
 *     media: {},
 * }
 * ```
 *
 * (2) Prop "baseOption" declared:
 * If "baseOption" declared, `ECUnitOption` props can only be declared
 * inside "baseOption" except prop "timeline" (compat ec2).
 * ```js
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 * };
 * option = {
 *     baseOption: {
 *         series: [],
 *     },
 *     media: []
 * };
 * option = {
 *     baseOption: {
 *         timeline: {},
 *         series: [],
 *     },
 *     options: []
 *     media: []
 * };
 * option = {
 *     // ec3 compat ec2: allow (only) `timeline` declared
 *     // outside baseOption. Keep this setting for compat.
 *     timeline: {},
 *     baseOption: {
 *         series: [],
 *     },
 *     options: [],
 *     media: []
 * };
 * ```
 */ function $c8dc8d8fa1d11e2c$var$parseRawOption(// `rawOption` May be modified
rawOption, optionPreprocessorFuncs, isNew) {
    var mediaList = [];
    var mediaDefault;
    var baseOption;
    var declaredBaseOption = rawOption.baseOption;
    // Compatible with ec2, [RAW_OPTION_PATTERNS] above.
    var timelineOnRoot = rawOption.timeline;
    var timelineOptionsOnRoot = rawOption.options;
    var mediaOnRoot = rawOption.media;
    var hasMedia = !!rawOption.media;
    var hasTimeline = !!(timelineOptionsOnRoot || timelineOnRoot || declaredBaseOption && declaredBaseOption.timeline);
    if (declaredBaseOption) {
        baseOption = declaredBaseOption;
        // For merge option.
        if (!baseOption.timeline) baseOption.timeline = timelineOnRoot;
    } else {
        if (hasTimeline || hasMedia) rawOption.options = rawOption.media = null;
        baseOption = rawOption;
    }
    if (hasMedia) {
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(mediaOnRoot)) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mediaOnRoot, function(singleMedia) {
            if (singleMedia && singleMedia.option) {
                if (singleMedia.query) mediaList.push(singleMedia);
                else if (!mediaDefault) // Use the first media default.
                mediaDefault = singleMedia;
            }
        });
    }
    doPreprocess(baseOption);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(timelineOptionsOnRoot, function(option) {
        return doPreprocess(option);
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mediaList, function(media) {
        return doPreprocess(media.option);
    });
    function doPreprocess(option) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(optionPreprocessorFuncs, function(preProcess) {
            preProcess(option, isNew);
        });
    }
    return {
        baseOption: baseOption,
        timelineOptions: timelineOptionsOnRoot || [],
        mediaDefault: mediaDefault,
        mediaList: mediaList
    };
}
/**
 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
 * Support: width, height, aspectRatio
 * Can use max or min as prefix.
 */ function $c8dc8d8fa1d11e2c$var$applyMediaQuery(query, ecWidth, ecHeight) {
    var realMap = {
        width: ecWidth,
        height: ecHeight,
        aspectratio: ecWidth / ecHeight // lower case for convenience.
    };
    var applicable = true;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(query, function(value, attr) {
        var matched = attr.match($c8dc8d8fa1d11e2c$var$QUERY_REG);
        if (!matched || !matched[1] || !matched[2]) return;
        var operator = matched[1];
        var realAttr = matched[2].toLowerCase();
        if (!$c8dc8d8fa1d11e2c$var$compare(realMap[realAttr], value, operator)) applicable = false;
    });
    return applicable;
}
function $c8dc8d8fa1d11e2c$var$compare(real, expect, operator) {
    if (operator === 'min') return real >= expect;
    else if (operator === 'max') return real <= expect;
    else // Equals
    return real === expect;
}
function $c8dc8d8fa1d11e2c$var$indicesEquals(indices1, indices2) {
    // indices is always order by asc and has only finite number.
    return indices1.join(',') === indices2.join(',');
}
var /**
 * Consider case:
 * `chart.setOption(opt1);`
 * Then user do some interaction like dataZoom, dataView changing.
 * `chart.setOption(opt2);`
 * Then user press 'reset button' in toolbox.
 *
 * After doing that all of the interaction effects should be reset, the
 * chart should be the same as the result of invoke
 * `chart.setOption(opt1); chart.setOption(opt2);`.
 *
 * Although it is not able ensure that
 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
 * `chart.setOption(merge(opt1, opt2));` exactly,
 * this might be the only simple way to implement that feature.
 *
 * MEMO: We've considered some other approaches:
 * 1. Each model handles its self restoration but not uniform treatment.
 *     (Too complex in logic and error-prone)
 * 2. Use a shadow ecModel. (Performance expensive)
 *
 * FIXME: A possible solution:
 * Add a extra level of model for each component model. The inheritance chain would be:
 * ecModel <- componentModel <- componentActionModel <- dataItemModel
 * And all of the actions can only modify the `componentActionModel` rather than
 * `componentModel`. `setOption` will only modify the `ecModel` and `componentModel`.
 * When "resotre" action triggered, model from `componentActionModel` will be discarded
 * instead of recreating the "ecModel" from the "_optionBackup".
 */ // function mergeToBackupOption(
//     fakeCmptsMap: FakeComponentsMap,
//     // `tarOption` Can be null/undefined, means init
//     tarOption: ECUnitOption,
//     newOption: ECUnitOption,
//     // Can be null/undefined
//     opt: InnerSetOptionOpts
// ): void {
//     newOption = newOption || {} as ECUnitOption;
//     const notInit = !!tarOption;
//     each(newOption, function (newOptsInMainType, mainType) {
//         if (newOptsInMainType == null) {
//             return;
//         }
//         if (!ComponentModel.hasClass(mainType)) {
//             if (tarOption) {
//                 tarOption[mainType] = merge(tarOption[mainType], newOptsInMainType, true);
//             }
//         }
//         else {
//             const oldTarOptsInMainType = notInit ? normalizeToArray(tarOption[mainType]) : null;
//             const oldFakeCmptsInMainType = fakeCmptsMap.get(mainType) || [];
//             const resultTarOptsInMainType = notInit ? (tarOption[mainType] = [] as ComponentOption[]) : null;
//             const resultFakeCmptsInMainType = fakeCmptsMap.set(mainType, []);
//             const mappingResult = mappingToExists(
//                 oldFakeCmptsInMainType,
//                 normalizeToArray(newOptsInMainType),
//                 (opt && opt.replaceMergeMainTypeMap.get(mainType)) ? 'replaceMerge' : 'normalMerge'
//             );
//             setComponentTypeToKeyInfo(mappingResult, mainType, ComponentModel as ComponentModelConstructor);
//             each(mappingResult, function (resultItem, index) {
//                 // The same logic as `Global.ts#_mergeOption`.
//                 let fakeCmpt = resultItem.existing;
//                 const newOption = resultItem.newOption;
//                 const keyInfo = resultItem.keyInfo;
//                 let fakeCmptOpt;
//                 if (!newOption) {
//                     fakeCmptOpt = oldTarOptsInMainType[index];
//                 }
//                 else {
//                     if (fakeCmpt && fakeCmpt.subType === keyInfo.subType) {
//                         fakeCmpt.name = keyInfo.name;
//                         if (notInit) {
//                             fakeCmptOpt = merge(oldTarOptsInMainType[index], newOption, true);
//                         }
//                     }
//                     else {
//                         fakeCmpt = extend({}, keyInfo);
//                         if (notInit) {
//                             fakeCmptOpt = clone(newOption);
//                         }
//                     }
//                 }
//                 if (fakeCmpt) {
//                     notInit && resultTarOptsInMainType.push(fakeCmptOpt);
//                     resultFakeCmptsInMainType.push(fakeCmpt);
//                 }
//                 else {
//                     notInit && resultTarOptsInMainType.push(void 0);
//                     resultFakeCmptsInMainType.push(void 0);
//                 }
//             });
//         }
//     });
// }
$c8dc8d8fa1d11e2c$export$2e2bcd8739ae039 = $c8dc8d8fa1d11e2c$var$OptionManager;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $abdaabff8ecbae26$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $abdaabff8ecbae26$var$isObject = $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a;
var $abdaabff8ecbae26$var$POSSIBLE_STYLES = [
    'areaStyle',
    'lineStyle',
    'nodeStyle',
    'linkStyle',
    'chordStyle',
    'label',
    'labelLine'
];
function $abdaabff8ecbae26$var$compatEC2ItemStyle(opt) {
    var itemStyleOpt = opt && opt.itemStyle;
    if (!itemStyleOpt) return;
    for(var i = 0, len = $abdaabff8ecbae26$var$POSSIBLE_STYLES.length; i < len; i++){
        var styleName = $abdaabff8ecbae26$var$POSSIBLE_STYLES[i];
        var normalItemStyleOpt = itemStyleOpt.normal;
        var emphasisItemStyleOpt = itemStyleOpt.emphasis;
        if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].normal) opt[styleName].normal = normalItemStyleOpt[styleName];
            else $1b239fc9d3a2f8ae$export$4950aa0f605343fb(opt[styleName].normal, normalItemStyleOpt[styleName]);
            normalItemStyleOpt[styleName] = null;
        }
        if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
            opt[styleName] = opt[styleName] || {};
            if (!opt[styleName].emphasis) opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
            else $1b239fc9d3a2f8ae$export$4950aa0f605343fb(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
            emphasisItemStyleOpt[styleName] = null;
        }
    }
}
function $abdaabff8ecbae26$var$convertNormalEmphasis(opt, optType, useExtend) {
    if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
        var normalOpt = opt[optType].normal;
        var emphasisOpt = opt[optType].emphasis;
        if (normalOpt) {
            // Timeline controlStyle has other properties besides normal and emphasis
            if (useExtend) {
                opt[optType].normal = opt[optType].emphasis = null;
                $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(opt[optType], normalOpt);
            } else opt[optType] = normalOpt;
        }
        if (emphasisOpt) {
            opt.emphasis = opt.emphasis || {};
            opt.emphasis[optType] = emphasisOpt;
            // Also compat the case user mix the style and focus together in ec3 style
            // for example: { itemStyle: { normal: {}, emphasis: {focus, shadowBlur} } }
            if (emphasisOpt.focus) opt.emphasis.focus = emphasisOpt.focus;
            if (emphasisOpt.blurScope) opt.emphasis.blurScope = emphasisOpt.blurScope;
        }
    }
}
function $abdaabff8ecbae26$var$removeEC3NormalStatus(opt) {
    $abdaabff8ecbae26$var$convertNormalEmphasis(opt, 'itemStyle');
    $abdaabff8ecbae26$var$convertNormalEmphasis(opt, 'lineStyle');
    $abdaabff8ecbae26$var$convertNormalEmphasis(opt, 'areaStyle');
    $abdaabff8ecbae26$var$convertNormalEmphasis(opt, 'label');
    $abdaabff8ecbae26$var$convertNormalEmphasis(opt, 'labelLine');
    // treemap
    $abdaabff8ecbae26$var$convertNormalEmphasis(opt, 'upperLabel');
    // graph
    $abdaabff8ecbae26$var$convertNormalEmphasis(opt, 'edgeLabel');
}
function $abdaabff8ecbae26$var$compatTextStyle(opt, propName) {
    // Check whether is not object (string\null\undefined ...)
    var labelOptSingle = $abdaabff8ecbae26$var$isObject(opt) && opt[propName];
    var textStyle = $abdaabff8ecbae26$var$isObject(labelOptSingle) && labelOptSingle.textStyle;
    if (textStyle) for(var i = 0, len = $9ac03c46e8b6e711$export$df45610347a602ad.length; i < len; i++){
        var textPropName = $9ac03c46e8b6e711$export$df45610347a602ad[i];
        if (textStyle.hasOwnProperty(textPropName)) labelOptSingle[textPropName] = textStyle[textPropName];
    }
}
function $abdaabff8ecbae26$var$compatEC3CommonStyles(opt) {
    if (opt) {
        $abdaabff8ecbae26$var$removeEC3NormalStatus(opt);
        $abdaabff8ecbae26$var$compatTextStyle(opt, 'label');
        opt.emphasis && $abdaabff8ecbae26$var$compatTextStyle(opt.emphasis, 'label');
    }
}
function $abdaabff8ecbae26$var$processSeries(seriesOpt) {
    if (!$abdaabff8ecbae26$var$isObject(seriesOpt)) return;
    $abdaabff8ecbae26$var$compatEC2ItemStyle(seriesOpt);
    $abdaabff8ecbae26$var$removeEC3NormalStatus(seriesOpt);
    $abdaabff8ecbae26$var$compatTextStyle(seriesOpt, 'label');
    // treemap
    $abdaabff8ecbae26$var$compatTextStyle(seriesOpt, 'upperLabel');
    // graph
    $abdaabff8ecbae26$var$compatTextStyle(seriesOpt, 'edgeLabel');
    if (seriesOpt.emphasis) {
        $abdaabff8ecbae26$var$compatTextStyle(seriesOpt.emphasis, 'label');
        // treemap
        $abdaabff8ecbae26$var$compatTextStyle(seriesOpt.emphasis, 'upperLabel');
        // graph
        $abdaabff8ecbae26$var$compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
    }
    var markPoint = seriesOpt.markPoint;
    if (markPoint) {
        $abdaabff8ecbae26$var$compatEC2ItemStyle(markPoint);
        $abdaabff8ecbae26$var$compatEC3CommonStyles(markPoint);
    }
    var markLine = seriesOpt.markLine;
    if (markLine) {
        $abdaabff8ecbae26$var$compatEC2ItemStyle(markLine);
        $abdaabff8ecbae26$var$compatEC3CommonStyles(markLine);
    }
    var markArea = seriesOpt.markArea;
    if (markArea) $abdaabff8ecbae26$var$compatEC3CommonStyles(markArea);
    var data = seriesOpt.data;
    // Break with ec3: if `setOption` again, there may be no `type` in option,
    // then the backward compat based on option type will not be performed.
    if (seriesOpt.type === 'graph') {
        data = data || seriesOpt.nodes;
        var edgeData = seriesOpt.links || seriesOpt.edges;
        if (edgeData && !$1b239fc9d3a2f8ae$export$b119cc7e1840e59c(edgeData)) for(var i = 0; i < edgeData.length; i++)$abdaabff8ecbae26$var$compatEC3CommonStyles(edgeData[i]);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(seriesOpt.categories, function(opt) {
            $abdaabff8ecbae26$var$removeEC3NormalStatus(opt);
        });
    }
    if (data && !$1b239fc9d3a2f8ae$export$b119cc7e1840e59c(data)) for(var i = 0; i < data.length; i++)$abdaabff8ecbae26$var$compatEC3CommonStyles(data[i]);
    // mark point data
    markPoint = seriesOpt.markPoint;
    if (markPoint && markPoint.data) {
        var mpData = markPoint.data;
        for(var i = 0; i < mpData.length; i++)$abdaabff8ecbae26$var$compatEC3CommonStyles(mpData[i]);
    }
    // mark line data
    markLine = seriesOpt.markLine;
    if (markLine && markLine.data) {
        var mlData = markLine.data;
        for(var i = 0; i < mlData.length; i++)if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(mlData[i])) {
            $abdaabff8ecbae26$var$compatEC3CommonStyles(mlData[i][0]);
            $abdaabff8ecbae26$var$compatEC3CommonStyles(mlData[i][1]);
        } else $abdaabff8ecbae26$var$compatEC3CommonStyles(mlData[i]);
    }
    // Series
    if (seriesOpt.type === 'gauge') {
        $abdaabff8ecbae26$var$compatTextStyle(seriesOpt, 'axisLabel');
        $abdaabff8ecbae26$var$compatTextStyle(seriesOpt, 'title');
        $abdaabff8ecbae26$var$compatTextStyle(seriesOpt, 'detail');
    } else if (seriesOpt.type === 'treemap') {
        $abdaabff8ecbae26$var$convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(seriesOpt.levels, function(opt) {
            $abdaabff8ecbae26$var$removeEC3NormalStatus(opt);
        });
    } else if (seriesOpt.type === 'tree') $abdaabff8ecbae26$var$removeEC3NormalStatus(seriesOpt.leaves);
// sunburst starts from ec4, so it does not need to compat levels.
}
function $abdaabff8ecbae26$var$toArr(o) {
    return $1b239fc9d3a2f8ae$export$43bee75e5e14138e(o) ? o : o ? [
        o
    ] : [];
}
function $abdaabff8ecbae26$var$toObj(o) {
    return ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(o) ? o[0] : o) || {};
}
function $abdaabff8ecbae26$export$2e2bcd8739ae039(option, isTheme) {
    $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option.series), function(seriesOpt) {
        $abdaabff8ecbae26$var$isObject(seriesOpt) && $abdaabff8ecbae26$var$processSeries(seriesOpt);
    });
    var axes = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'parallelAxis',
        'radar'
    ];
    isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
    $abdaabff8ecbae26$var$each(axes, function(axisName) {
        $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option[axisName]), function(axisOpt) {
            if (axisOpt) {
                $abdaabff8ecbae26$var$compatTextStyle(axisOpt, 'axisLabel');
                $abdaabff8ecbae26$var$compatTextStyle(axisOpt.axisPointer, 'label');
            }
        });
    });
    $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option.parallel), function(parallelOpt) {
        var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
        $abdaabff8ecbae26$var$compatTextStyle(parallelAxisDefault, 'axisLabel');
        $abdaabff8ecbae26$var$compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
    });
    $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option.calendar), function(calendarOpt) {
        $abdaabff8ecbae26$var$convertNormalEmphasis(calendarOpt, 'itemStyle');
        $abdaabff8ecbae26$var$compatTextStyle(calendarOpt, 'dayLabel');
        $abdaabff8ecbae26$var$compatTextStyle(calendarOpt, 'monthLabel');
        $abdaabff8ecbae26$var$compatTextStyle(calendarOpt, 'yearLabel');
    });
    // radar.name.textStyle
    $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option.radar), function(radarOpt) {
        $abdaabff8ecbae26$var$compatTextStyle(radarOpt, 'name');
        // Use axisName instead of name because component has name property
        if (radarOpt.name && radarOpt.axisName == null) {
            radarOpt.axisName = radarOpt.name;
            delete radarOpt.name;
        }
        if (radarOpt.nameGap != null && radarOpt.axisNameGap == null) {
            radarOpt.axisNameGap = radarOpt.nameGap;
            delete radarOpt.nameGap;
        }
    });
    $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option.geo), function(geoOpt) {
        if ($abdaabff8ecbae26$var$isObject(geoOpt)) {
            $abdaabff8ecbae26$var$compatEC3CommonStyles(geoOpt);
            $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(geoOpt.regions), function(regionObj) {
                $abdaabff8ecbae26$var$compatEC3CommonStyles(regionObj);
            });
        }
    });
    $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option.timeline), function(timelineOpt) {
        $abdaabff8ecbae26$var$compatEC3CommonStyles(timelineOpt);
        $abdaabff8ecbae26$var$convertNormalEmphasis(timelineOpt, 'label');
        $abdaabff8ecbae26$var$convertNormalEmphasis(timelineOpt, 'itemStyle');
        $abdaabff8ecbae26$var$convertNormalEmphasis(timelineOpt, 'controlStyle', true);
        var data = timelineOpt.data;
        $1b239fc9d3a2f8ae$export$43bee75e5e14138e(data) && $1b239fc9d3a2f8ae$export$79b2f7037acddd43(data, function(item) {
            if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(item)) {
                $abdaabff8ecbae26$var$convertNormalEmphasis(item, 'label');
                $abdaabff8ecbae26$var$convertNormalEmphasis(item, 'itemStyle');
            }
        });
    });
    $abdaabff8ecbae26$var$each($abdaabff8ecbae26$var$toArr(option.toolbox), function(toolboxOpt) {
        $abdaabff8ecbae26$var$convertNormalEmphasis(toolboxOpt, 'iconStyle');
        $abdaabff8ecbae26$var$each(toolboxOpt.feature, function(featureOpt) {
            $abdaabff8ecbae26$var$convertNormalEmphasis(featureOpt, 'iconStyle');
        });
    });
    $abdaabff8ecbae26$var$compatTextStyle($abdaabff8ecbae26$var$toObj(option.axisPointer), 'label');
    $abdaabff8ecbae26$var$compatTextStyle($abdaabff8ecbae26$var$toObj(option.tooltip).axisPointer, 'label');
// Clean logs
// storedLogs = {};
}




function $cd438069cbdf9f3c$var$get(opt, path) {
    var pathArr = path.split(',');
    var obj = opt;
    for(var i = 0; i < pathArr.length; i++){
        obj = obj && obj[pathArr[i]];
        if (obj == null) break;
    }
    return obj;
}
function $cd438069cbdf9f3c$var$set(opt, path, val, overwrite) {
    var pathArr = path.split(',');
    var obj = opt;
    var key;
    var i = 0;
    for(; i < pathArr.length - 1; i++){
        key = pathArr[i];
        if (obj[key] == null) obj[key] = {};
        obj = obj[key];
    }
    if (overwrite || obj[pathArr[i]] == null) obj[pathArr[i]] = val;
}
function $cd438069cbdf9f3c$var$compatLayoutProperties(option) {
    option && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($cd438069cbdf9f3c$var$LAYOUT_PROPERTIES, function(prop) {
        if (prop[0] in option && !(prop[1] in option)) option[prop[1]] = option[prop[0]];
    });
}
var $cd438069cbdf9f3c$var$LAYOUT_PROPERTIES = [
    [
        'x',
        'left'
    ],
    [
        'y',
        'top'
    ],
    [
        'x2',
        'right'
    ],
    [
        'y2',
        'bottom'
    ]
];
var $cd438069cbdf9f3c$var$COMPATITABLE_COMPONENTS = [
    'grid',
    'geo',
    'parallel',
    'legend',
    'toolbox',
    'title',
    'visualMap',
    'dataZoom',
    'timeline'
];
var $cd438069cbdf9f3c$var$BAR_ITEM_STYLE_MAP = [
    [
        'borderRadius',
        'barBorderRadius'
    ],
    [
        'borderColor',
        'barBorderColor'
    ],
    [
        'borderWidth',
        'barBorderWidth'
    ]
];
function $cd438069cbdf9f3c$var$compatBarItemStyle(option) {
    var itemStyle = option && option.itemStyle;
    if (itemStyle) for(var i = 0; i < $cd438069cbdf9f3c$var$BAR_ITEM_STYLE_MAP.length; i++){
        var oldName = $cd438069cbdf9f3c$var$BAR_ITEM_STYLE_MAP[i][1];
        var newName = $cd438069cbdf9f3c$var$BAR_ITEM_STYLE_MAP[i][0];
        if (itemStyle[oldName] != null) itemStyle[newName] = itemStyle[oldName];
    }
}
function $cd438069cbdf9f3c$var$compatPieLabel(option) {
    if (!option) return;
    if (option.alignTo === 'edge' && option.margin != null && option.edgeDistance == null) option.edgeDistance = option.margin;
}
function $cd438069cbdf9f3c$var$compatSunburstState(option) {
    if (!option) return;
    if (option.downplay && !option.blur) option.blur = option.downplay;
}
function $cd438069cbdf9f3c$var$compatGraphFocus(option) {
    if (!option) return;
    if (option.focusNodeAdjacency != null) {
        option.emphasis = option.emphasis || {};
        if (option.emphasis.focus == null) option.emphasis.focus = 'adjacency';
    }
}
function $cd438069cbdf9f3c$var$traverseTree(data, cb) {
    if (data) for(var i = 0; i < data.length; i++){
        cb(data[i]);
        data[i] && $cd438069cbdf9f3c$var$traverseTree(data[i].children, cb);
    }
}
function $cd438069cbdf9f3c$export$2e2bcd8739ae039(option, isTheme) {
    (0, $abdaabff8ecbae26$export$2e2bcd8739ae039)(option, isTheme);
    // Make sure series array for model initialization.
    option.series = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(option.series);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(option.series, function(seriesOpt) {
        if (!(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(seriesOpt)) return;
        var seriesType = seriesOpt.type;
        if (seriesType === 'line') {
            if (seriesOpt.clipOverflow != null) seriesOpt.clip = seriesOpt.clipOverflow;
        } else if (seriesType === 'pie' || seriesType === 'gauge') {
            if (seriesOpt.clockWise != null) seriesOpt.clockwise = seriesOpt.clockWise;
            $cd438069cbdf9f3c$var$compatPieLabel(seriesOpt.label);
            var data = seriesOpt.data;
            if (data && !(0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(data)) for(var i = 0; i < data.length; i++)$cd438069cbdf9f3c$var$compatPieLabel(data[i]);
            if (seriesOpt.hoverOffset != null) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                seriesOpt.emphasis.scaleSize = null;
            }
        } else if (seriesType === 'gauge') {
            var pointerColor = $cd438069cbdf9f3c$var$get(seriesOpt, 'pointer.color');
            pointerColor != null && $cd438069cbdf9f3c$var$set(seriesOpt, 'itemStyle.color', pointerColor);
        } else if (seriesType === 'bar') {
            $cd438069cbdf9f3c$var$compatBarItemStyle(seriesOpt);
            $cd438069cbdf9f3c$var$compatBarItemStyle(seriesOpt.backgroundStyle);
            $cd438069cbdf9f3c$var$compatBarItemStyle(seriesOpt.emphasis);
            var data = seriesOpt.data;
            if (data && !(0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(data)) {
                for(var i = 0; i < data.length; i++)if (typeof data[i] === 'object') {
                    $cd438069cbdf9f3c$var$compatBarItemStyle(data[i]);
                    $cd438069cbdf9f3c$var$compatBarItemStyle(data[i] && data[i].emphasis);
                }
            }
        } else if (seriesType === 'sunburst') {
            var highlightPolicy = seriesOpt.highlightPolicy;
            if (highlightPolicy) {
                seriesOpt.emphasis = seriesOpt.emphasis || {};
                if (!seriesOpt.emphasis.focus) seriesOpt.emphasis.focus = highlightPolicy;
            }
            $cd438069cbdf9f3c$var$compatSunburstState(seriesOpt);
            $cd438069cbdf9f3c$var$traverseTree(seriesOpt.data, $cd438069cbdf9f3c$var$compatSunburstState);
        } else if (seriesType === 'graph' || seriesType === 'sankey') $cd438069cbdf9f3c$var$compatGraphFocus(seriesOpt);
        else if (seriesType === 'map') {
            if (seriesOpt.mapType && !seriesOpt.map) seriesOpt.map = seriesOpt.mapType;
            if (seriesOpt.mapLocation) (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(seriesOpt, seriesOpt.mapLocation);
        }
        if (seriesOpt.hoverAnimation != null) {
            seriesOpt.emphasis = seriesOpt.emphasis || {};
            if (seriesOpt.emphasis && seriesOpt.emphasis.scale == null) seriesOpt.emphasis.scale = seriesOpt.hoverAnimation;
        }
        $cd438069cbdf9f3c$var$compatLayoutProperties(seriesOpt);
    });
    // dataRange has changed to visualMap
    if (option.dataRange) option.visualMap = option.dataRange;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($cd438069cbdf9f3c$var$COMPATITABLE_COMPONENTS, function(componentName) {
        var options = option[componentName];
        if (options) {
            if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(options)) options = [
                options
            ];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(options, function(option) {
                $cd438069cbdf9f3c$var$compatLayoutProperties(option);
            });
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b1a74b75aafa5bd2$export$2e2bcd8739ae039(ecModel) {
    var stackInfoMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    ecModel.eachSeries(function(seriesModel) {
        var stack = seriesModel.get('stack');
        // Compatible: when `stack` is set as '', do not stack.
        if (stack) {
            var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
            var data = seriesModel.getData();
            var stackInfo = {
                // Used for calculate axis extent automatically.
                // TODO: Type getCalculationInfo return more specific type?
                stackResultDimension: data.getCalculationInfo('stackResultDimension'),
                stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
                stackedDimension: data.getCalculationInfo('stackedDimension'),
                stackedByDimension: data.getCalculationInfo('stackedByDimension'),
                isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
                data: data,
                seriesModel: seriesModel
            };
            // If stacked on axis that do not support data stack.
            if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) return;
            stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
            stackInfoList.push(stackInfo);
        }
    });
    stackInfoMap.each($b1a74b75aafa5bd2$var$calculateStack);
}
function $b1a74b75aafa5bd2$var$calculateStack(stackInfoList) {
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(stackInfoList, function(targetStackInfo, idxInStack) {
        var resultVal = [];
        var resultNaN = [
            NaN,
            NaN
        ];
        var dims = [
            targetStackInfo.stackResultDimension,
            targetStackInfo.stackedOverDimension
        ];
        var targetData = targetStackInfo.data;
        var isStackedByIndex = targetStackInfo.isStackedByIndex;
        var stackStrategy = targetStackInfo.seriesModel.get('stackStrategy') || 'samesign';
        // Should not write on raw data, because stack series model list changes
        // depending on legend selection.
        targetData.modify(dims, function(v0, v1, dataIndex) {
            var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex);
            // Consider `connectNulls` of line area, if value is NaN, stackedOver
            // should also be NaN, to draw a appropriate belt area.
            if (isNaN(sum)) return resultNaN;
            var byValue;
            var stackedDataRawIndex;
            if (isStackedByIndex) stackedDataRawIndex = targetData.getRawIndex(dataIndex);
            else byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
            // If stackOver is NaN, chart view will render point on value start.
            var stackedOver = NaN;
            for(var j = idxInStack - 1; j >= 0; j--){
                var stackInfo = stackInfoList[j];
                // Has been optimized by inverted indices on `stackedByDimension`.
                if (!isStackedByIndex) stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
                if (stackedDataRawIndex >= 0) {
                    var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex);
                    // Considering positive stack, negative stack and empty data
                    if (stackStrategy === 'all' // single stack group
                     || stackStrategy === 'positive' && val > 0 || stackStrategy === 'negative' && val < 0 || stackStrategy === 'samesign' && sum >= 0 && val > 0 // All positive stack
                     || stackStrategy === 'samesign' && sum <= 0 && val < 0 // All negative stack
                    ) {
                        // The sum has to be very small to be affected by the
                        // floating arithmetic problem. An incorrect result will probably
                        // cause axis min/max to be filtered incorrectly.
                        sum = (0, $9fd90cf3bf18fbcd$export$d3389a301c3a5706)(sum, val);
                        stackedOver = val;
                        break;
                    }
                }
            }
            resultVal[0] = sum;
            resultVal[1] = stackedOver;
            return resultVal;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// @inner
var $107136d10fa2cf04$var$SourceImpl = /** @class */ function() {
    function SourceImpl(fields) {
        this.data = fields.data || (fields.sourceFormat === (0, $369d2fc585e5938e$export$6a32b42c754a3cb8) ? {} : []);
        this.sourceFormat = fields.sourceFormat || (0, $369d2fc585e5938e$export$c78f1330778d30d);
        // Visit config
        this.seriesLayoutBy = fields.seriesLayoutBy || (0, $369d2fc585e5938e$export$7b3f3c6551b4949b);
        this.startIndex = fields.startIndex || 0;
        this.dimensionsDetectedCount = fields.dimensionsDetectedCount;
        this.metaRawOption = fields.metaRawOption;
        var dimensionsDefine = this.dimensionsDefine = fields.dimensionsDefine;
        if (dimensionsDefine) for(var i = 0; i < dimensionsDefine.length; i++){
            var dim = dimensionsDefine[i];
            if (dim.type == null) {
                if ((0, $669a01b8661bdd13$export$c51adf1a2be01b9c)(this, i) === (0, $669a01b8661bdd13$export$328749e9c5b40760).Must) dim.type = 'ordinal';
            }
        }
    }
    return SourceImpl;
}();
function $107136d10fa2cf04$export$22b808bc02a60488(val) {
    return val instanceof $107136d10fa2cf04$var$SourceImpl;
}
function $107136d10fa2cf04$export$1921362e86c73c88(sourceData, thisMetaRawOption, // can be null. If not provided, auto detect it from `sourceData`.
sourceFormat) {
    sourceFormat = sourceFormat || $107136d10fa2cf04$export$52a469afa4653e57(sourceData);
    var seriesLayoutBy = thisMetaRawOption.seriesLayoutBy;
    var determined = $107136d10fa2cf04$var$determineSourceDimensions(sourceData, sourceFormat, seriesLayoutBy, thisMetaRawOption.sourceHeader, thisMetaRawOption.dimensions);
    var source = new $107136d10fa2cf04$var$SourceImpl({
        data: sourceData,
        sourceFormat: sourceFormat,
        seriesLayoutBy: seriesLayoutBy,
        dimensionsDefine: determined.dimensionsDefine,
        startIndex: determined.startIndex,
        dimensionsDetectedCount: determined.dimensionsDetectedCount,
        metaRawOption: (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(thisMetaRawOption)
    });
    return source;
}
function $107136d10fa2cf04$export$75aef3f97c0a5edf(data) {
    return new $107136d10fa2cf04$var$SourceImpl({
        data: data,
        sourceFormat: (0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(data) ? (0, $369d2fc585e5938e$export$a918cb016a382d45) : (0, $369d2fc585e5938e$export$2823037fb9d8f0c6)
    });
}
function $107136d10fa2cf04$export$e0365e7e3555ddd4(source) {
    return new $107136d10fa2cf04$var$SourceImpl({
        data: source.data,
        sourceFormat: source.sourceFormat,
        seriesLayoutBy: source.seriesLayoutBy,
        dimensionsDefine: (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(source.dimensionsDefine),
        startIndex: source.startIndex,
        dimensionsDetectedCount: source.dimensionsDetectedCount
    });
}
function $107136d10fa2cf04$export$52a469afa4653e57(data) {
    var sourceFormat = (0, $369d2fc585e5938e$export$c78f1330778d30d);
    if ((0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(data)) sourceFormat = (0, $369d2fc585e5938e$export$a918cb016a382d45);
    else if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(data)) {
        // FIXME Whether tolerate null in top level array?
        if (data.length === 0) sourceFormat = (0, $369d2fc585e5938e$export$fcd62ebf51387903);
        for(var i = 0, len = data.length; i < len; i++){
            var item = data[i];
            if (item == null) continue;
            else if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(item) || (0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(item)) {
                sourceFormat = (0, $369d2fc585e5938e$export$fcd62ebf51387903);
                break;
            } else if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(item)) {
                sourceFormat = (0, $369d2fc585e5938e$export$703ae8a2d83f441);
                break;
            }
        }
    } else if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(data)) {
        for(var key in data)if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(data, key) && (0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(data[key])) {
            sourceFormat = (0, $369d2fc585e5938e$export$6a32b42c754a3cb8);
            break;
        }
    }
    return sourceFormat;
}
/**
 * Determine the source definitions from data standalone dimensions definitions
 * are not specified.
 */ function $107136d10fa2cf04$var$determineSourceDimensions(data, sourceFormat, seriesLayoutBy, sourceHeader, // standalone raw dimensions definition, like:
// {
//     dimensions: ['aa', 'bb', { name: 'cc', type: 'time' }]
// }
// in `dataset` or `series`
dimensionsDefine) {
    var dimensionsDetectedCount;
    var startIndex;
    // PENDING: Could data be null/undefined here?
    // currently, if `dataset.source` not specified, error thrown.
    // if `series.data` not specified, nothing rendered without error thrown.
    // Should test these cases.
    if (!data) return {
        dimensionsDefine: $107136d10fa2cf04$var$normalizeDimensionsOption(dimensionsDefine),
        startIndex: startIndex,
        dimensionsDetectedCount: dimensionsDetectedCount
    };
    if (sourceFormat === (0, $369d2fc585e5938e$export$fcd62ebf51387903)) {
        var dataArrayRows = data;
        // Rule: Most of the first line are string: it is header.
        // Caution: consider a line with 5 string and 1 number,
        // it still can not be sure it is a head, because the
        // 5 string may be 5 values of category columns.
        if (sourceHeader === 'auto' || sourceHeader == null) $107136d10fa2cf04$var$arrayRowsTravelFirst(function(val) {
            // '-' is regarded as null/undefined.
            if (val != null && val !== '-') {
                if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(val)) startIndex == null && (startIndex = 1);
                else startIndex = 0;
            }
        // 10 is an experience number, avoid long loop.
        }, seriesLayoutBy, dataArrayRows, 10);
        else startIndex = (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(sourceHeader) ? sourceHeader : sourceHeader ? 1 : 0;
        if (!dimensionsDefine && startIndex === 1) {
            dimensionsDefine = [];
            $107136d10fa2cf04$var$arrayRowsTravelFirst(function(val, index) {
                dimensionsDefine[index] = val != null ? val + '' : '';
            }, seriesLayoutBy, dataArrayRows, Infinity);
        }
        dimensionsDetectedCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === (0, $369d2fc585e5938e$export$d55da1467cdf7804) ? dataArrayRows.length : dataArrayRows[0] ? dataArrayRows[0].length : null;
    } else if (sourceFormat === (0, $369d2fc585e5938e$export$703ae8a2d83f441)) {
        if (!dimensionsDefine) dimensionsDefine = $107136d10fa2cf04$var$objectRowsCollectDimensions(data);
    } else if (sourceFormat === (0, $369d2fc585e5938e$export$6a32b42c754a3cb8)) {
        if (!dimensionsDefine) {
            dimensionsDefine = [];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(data, function(colArr, key) {
                dimensionsDefine.push(key);
            });
        }
    } else if (sourceFormat === (0, $369d2fc585e5938e$export$2823037fb9d8f0c6)) {
        var value0 = (0, $9ac03c46e8b6e711$export$2c944e12edb48d4b)(data[0]);
        dimensionsDetectedCount = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(value0) && value0.length || 1;
    }
    return {
        startIndex: startIndex,
        dimensionsDefine: $107136d10fa2cf04$var$normalizeDimensionsOption(dimensionsDefine),
        dimensionsDetectedCount: dimensionsDetectedCount
    };
}
function $107136d10fa2cf04$var$objectRowsCollectDimensions(data) {
    var firstIndex = 0;
    var obj;
    while(firstIndex < data.length && !(obj = data[firstIndex++])); // jshint ignore: line
    if (obj) return (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(obj);
}
// Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
// which is reasonable. But dimension name is duplicated.
// Returns undefined or an array contains only object without null/undefined or string.
function $107136d10fa2cf04$var$normalizeDimensionsOption(dimensionsDefine) {
    if (!dimensionsDefine) // The meaning of null/undefined is different from empty array.
    return;
    var nameMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(dimensionsDefine, function(rawItem, index) {
        rawItem = (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(rawItem) ? rawItem : {
            name: rawItem
        };
        // Other fields will be discarded.
        var item = {
            name: rawItem.name,
            displayName: rawItem.displayName,
            type: rawItem.type
        };
        // User can set null in dimensions.
        // We don't auto specify name, otherwise a given name may
        // cause it to be referred unexpectedly.
        if (item.name == null) return item;
        // Also consider number form like 2012.
        item.name += '';
        // User may also specify displayName.
        // displayName will always exists except user not
        // specified or dim name is not specified or detected.
        // (A auto generated dim name will not be used as
        // displayName).
        if (item.displayName == null) item.displayName = item.name;
        var exist = nameMap.get(item.name);
        if (!exist) nameMap.set(item.name, {
            count: 1
        });
        else item.name += '-' + exist.count++;
        return item;
    });
}
function $107136d10fa2cf04$var$arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
    if (seriesLayoutBy === (0, $369d2fc585e5938e$export$d55da1467cdf7804)) for(var i = 0; i < data.length && i < maxLoop; i++)cb(data[i] ? data[i][0] : null, i);
    else {
        var value0 = data[0] || [];
        for(var i = 0; i < value0.length && i < maxLoop; i++)cb(value0[i], i);
    }
}
function $107136d10fa2cf04$export$8911336b527f8517(source) {
    var sourceFormat = source.sourceFormat;
    return sourceFormat === (0, $369d2fc585e5938e$export$703ae8a2d83f441) || sourceFormat === (0, $369d2fc585e5938e$export$6a32b42c754a3cb8);
}



var $a0d276c4568d5ef4$var$_a, $a0d276c4568d5ef4$var$_b, $a0d276c4568d5ef4$var$_c;
var $a0d276c4568d5ef4$var$providerMethods;
var $a0d276c4568d5ef4$var$mountMethods;
/**
 * If normal array used, mutable chunk size is supported.
 * If typed array used, chunk size must be fixed.
 */ var $a0d276c4568d5ef4$export$b900d7c4c3952a40 = /** @class */ function() {
    function DefaultDataProvider(sourceParam, dimSize) {
        // let source: Source;
        var source = !(0, $107136d10fa2cf04$export$22b808bc02a60488)(sourceParam) ? (0, $107136d10fa2cf04$export$75aef3f97c0a5edf)(sourceParam) : sourceParam;
        // declare source is Source;
        this._source = source;
        var data = this._data = source.data;
        // Typed array. TODO IE10+?
        if (source.sourceFormat === (0, $369d2fc585e5938e$export$a918cb016a382d45)) {
            this._offset = 0;
            this._dimSize = dimSize;
            this._data = data;
        }
        $a0d276c4568d5ef4$var$mountMethods(this, data, source);
    }
    DefaultDataProvider.prototype.getSource = function() {
        return this._source;
    };
    DefaultDataProvider.prototype.count = function() {
        return 0;
    };
    DefaultDataProvider.prototype.getItem = function(idx, out) {
        return;
    };
    DefaultDataProvider.prototype.appendData = function(newData) {};
    DefaultDataProvider.prototype.clean = function() {};
    DefaultDataProvider.protoInitialize = function() {
        // PENDING: To avoid potential incompat (e.g., prototype
        // is visited somewhere), still init them on prototype.
        var proto = DefaultDataProvider.prototype;
        proto.pure = false;
        proto.persistent = true;
    }();
    DefaultDataProvider.internalField = function() {
        var _a;
        $a0d276c4568d5ef4$var$mountMethods = function(provider, data, source) {
            var sourceFormat = source.sourceFormat;
            var seriesLayoutBy = source.seriesLayoutBy;
            var startIndex = source.startIndex;
            var dimsDef = source.dimensionsDefine;
            var methods = $a0d276c4568d5ef4$var$providerMethods[$a0d276c4568d5ef4$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(provider, methods);
            if (sourceFormat === (0, $369d2fc585e5938e$export$a918cb016a382d45)) {
                provider.getItem = getItemForTypedArray;
                provider.count = countForTypedArray;
                provider.fillStorage = fillStorageForTypedArray;
            } else {
                var rawItemGetter = $a0d276c4568d5ef4$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy);
                provider.getItem = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(rawItemGetter, null, data, startIndex, dimsDef);
                var rawCounter = $a0d276c4568d5ef4$export$803742e832f4b52c(sourceFormat, seriesLayoutBy);
                provider.count = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(rawCounter, null, data, startIndex, dimsDef);
            }
        };
        var getItemForTypedArray = function(idx, out) {
            idx = idx - this._offset;
            out = out || [];
            var data = this._data;
            var dimSize = this._dimSize;
            var offset = dimSize * idx;
            for(var i = 0; i < dimSize; i++)out[i] = data[offset + i];
            return out;
        };
        var fillStorageForTypedArray = function(start, end, storage, extent) {
            var data = this._data;
            var dimSize = this._dimSize;
            for(var dim = 0; dim < dimSize; dim++){
                var dimExtent = extent[dim];
                var min = dimExtent[0] == null ? Infinity : dimExtent[0];
                var max = dimExtent[1] == null ? -Infinity : dimExtent[1];
                var count = end - start;
                var arr = storage[dim];
                for(var i = 0; i < count; i++){
                    // appendData with TypedArray will always do replace in provider.
                    var val = data[i * dimSize + dim];
                    arr[start + i] = val;
                    val < min && (min = val);
                    val > max && (max = val);
                }
                dimExtent[0] = min;
                dimExtent[1] = max;
            }
        };
        var countForTypedArray = function() {
            return this._data ? this._data.length / this._dimSize : 0;
        };
        $a0d276c4568d5ef4$var$providerMethods = (_a = {}, _a[(0, $369d2fc585e5938e$export$fcd62ebf51387903) + '_' + (0, $369d2fc585e5938e$export$7b3f3c6551b4949b)] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[(0, $369d2fc585e5938e$export$fcd62ebf51387903) + '_' + (0, $369d2fc585e5938e$export$d55da1467cdf7804)] = {
            pure: true,
            appendData: function() {
                throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
            }
        }, _a[0, $369d2fc585e5938e$export$703ae8a2d83f441] = {
            pure: true,
            appendData: appendDataSimply
        }, _a[0, $369d2fc585e5938e$export$6a32b42c754a3cb8] = {
            pure: true,
            appendData: function(newData) {
                var data = this._data;
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newData, function(newCol, key) {
                    var oldCol = data[key] || (data[key] = []);
                    for(var i = 0; i < (newCol || []).length; i++)oldCol.push(newCol[i]);
                });
            }
        }, _a[0, $369d2fc585e5938e$export$2823037fb9d8f0c6] = {
            appendData: appendDataSimply
        }, _a[0, $369d2fc585e5938e$export$a918cb016a382d45] = {
            persistent: false,
            pure: true,
            appendData: function(newData) {
                this._data = newData;
            },
            // Clean self if data is already used.
            clean: function() {
                // PENDING
                this._offset += this.count();
                this._data = null;
            }
        }, _a);
        function appendDataSimply(newData) {
            for(var i = 0; i < newData.length; i++)this._data.push(newData[i]);
        }
    }();
    return DefaultDataProvider;
}();
var $a0d276c4568d5ef4$var$getItemSimply = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx];
};
var $a0d276c4568d5ef4$var$rawSourceItemGetterMap = ($a0d276c4568d5ef4$var$_a = {}, $a0d276c4568d5ef4$var$_a[(0, $369d2fc585e5938e$export$fcd62ebf51387903) + '_' + (0, $369d2fc585e5938e$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef, idx) {
    return rawData[idx + startIndex];
}, $a0d276c4568d5ef4$var$_a[(0, $369d2fc585e5938e$export$fcd62ebf51387903) + '_' + (0, $369d2fc585e5938e$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef, idx, out) {
    idx += startIndex;
    var item = out || [];
    var data = rawData;
    for(var i = 0; i < data.length; i++){
        var row = data[i];
        item[i] = row ? row[idx] : null;
    }
    return item;
}, $a0d276c4568d5ef4$var$_a[0, $369d2fc585e5938e$export$703ae8a2d83f441] = $a0d276c4568d5ef4$var$getItemSimply, $a0d276c4568d5ef4$var$_a[0, $369d2fc585e5938e$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef, idx, out) {
    var item = out || [];
    for(var i = 0; i < dimsDef.length; i++){
        var dimName = dimsDef[i].name;
        var col = rawData[dimName];
        item[i] = col ? col[idx] : null;
    }
    return item;
}, $a0d276c4568d5ef4$var$_a[0, $369d2fc585e5938e$export$2823037fb9d8f0c6] = $a0d276c4568d5ef4$var$getItemSimply, $a0d276c4568d5ef4$var$_a);
function $a0d276c4568d5ef4$export$92c8ea8642b3957d(sourceFormat, seriesLayoutBy) {
    var method = $a0d276c4568d5ef4$var$rawSourceItemGetterMap[$a0d276c4568d5ef4$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $a0d276c4568d5ef4$var$countSimply = function(rawData, startIndex, dimsDef) {
    return rawData.length;
};
var $a0d276c4568d5ef4$var$rawSourceDataCounterMap = ($a0d276c4568d5ef4$var$_b = {}, $a0d276c4568d5ef4$var$_b[(0, $369d2fc585e5938e$export$fcd62ebf51387903) + '_' + (0, $369d2fc585e5938e$export$7b3f3c6551b4949b)] = function(rawData, startIndex, dimsDef) {
    return Math.max(0, rawData.length - startIndex);
}, $a0d276c4568d5ef4$var$_b[(0, $369d2fc585e5938e$export$fcd62ebf51387903) + '_' + (0, $369d2fc585e5938e$export$d55da1467cdf7804)] = function(rawData, startIndex, dimsDef) {
    var row = rawData[0];
    return row ? Math.max(0, row.length - startIndex) : 0;
}, $a0d276c4568d5ef4$var$_b[0, $369d2fc585e5938e$export$703ae8a2d83f441] = $a0d276c4568d5ef4$var$countSimply, $a0d276c4568d5ef4$var$_b[0, $369d2fc585e5938e$export$6a32b42c754a3cb8] = function(rawData, startIndex, dimsDef) {
    var dimName = dimsDef[0].name;
    var col = rawData[dimName];
    return col ? col.length : 0;
}, $a0d276c4568d5ef4$var$_b[0, $369d2fc585e5938e$export$2823037fb9d8f0c6] = $a0d276c4568d5ef4$var$countSimply, $a0d276c4568d5ef4$var$_b);
function $a0d276c4568d5ef4$export$803742e832f4b52c(sourceFormat, seriesLayoutBy) {
    var method = $a0d276c4568d5ef4$var$rawSourceDataCounterMap[$a0d276c4568d5ef4$var$getMethodMapKey(sourceFormat, seriesLayoutBy)];
    return method;
}
var $a0d276c4568d5ef4$var$getRawValueSimply = function(dataItem, dimIndex, property) {
    return dataItem[dimIndex];
};
var $a0d276c4568d5ef4$var$rawSourceValueGetterMap = ($a0d276c4568d5ef4$var$_c = {}, $a0d276c4568d5ef4$var$_c[0, $369d2fc585e5938e$export$fcd62ebf51387903] = $a0d276c4568d5ef4$var$getRawValueSimply, $a0d276c4568d5ef4$var$_c[0, $369d2fc585e5938e$export$703ae8a2d83f441] = function(dataItem, dimIndex, property) {
    return dataItem[property];
}, $a0d276c4568d5ef4$var$_c[0, $369d2fc585e5938e$export$6a32b42c754a3cb8] = $a0d276c4568d5ef4$var$getRawValueSimply, $a0d276c4568d5ef4$var$_c[0, $369d2fc585e5938e$export$2823037fb9d8f0c6] = function(dataItem, dimIndex, property) {
    // FIXME: In some case (markpoint in geo (geo-map.html)),
    // dataItem is {coord: [...]}
    var value = (0, $9ac03c46e8b6e711$export$2c944e12edb48d4b)(dataItem);
    return !(value instanceof Array) ? value : value[dimIndex];
}, $a0d276c4568d5ef4$var$_c[0, $369d2fc585e5938e$export$a918cb016a382d45] = $a0d276c4568d5ef4$var$getRawValueSimply, $a0d276c4568d5ef4$var$_c);
function $a0d276c4568d5ef4$export$1752de8084789a14(sourceFormat) {
    var method = $a0d276c4568d5ef4$var$rawSourceValueGetterMap[sourceFormat];
    return method;
}
function $a0d276c4568d5ef4$var$getMethodMapKey(sourceFormat, seriesLayoutBy) {
    return sourceFormat === (0, $369d2fc585e5938e$export$fcd62ebf51387903) ? sourceFormat + '_' + seriesLayoutBy : sourceFormat;
}
function $a0d276c4568d5ef4$export$cde9373da9aad801(data, dataIndex, // If dimIndex is null/undefined, return OptionDataItem.
// Otherwise, return OptionDataValue.
dim) {
    if (!data) return;
    // Consider data may be not persistent.
    var dataItem = data.getRawDataItem(dataIndex);
    if (dataItem == null) return;
    var store = data.getStore();
    var sourceFormat = store.getSource().sourceFormat;
    if (dim != null) {
        var dimIndex = data.getDimensionIndex(dim);
        var property = store.getDimensionProperty(dimIndex);
        return $a0d276c4568d5ef4$export$1752de8084789a14(sourceFormat)(dataItem, dimIndex, property);
    } else {
        var result = dataItem;
        if (sourceFormat === (0, $369d2fc585e5938e$export$2823037fb9d8f0c6)) result = (0, $9ac03c46e8b6e711$export$2c944e12edb48d4b)(dataItem);
        return result;
    }
}
function $a0d276c4568d5ef4$export$c8ae9e77e0ddc42a(data, dataIndex, attr) {
    if (!data) return;
    var sourceFormat = data.getStore().getSource().sourceFormat;
    if (sourceFormat !== (0, $369d2fc585e5938e$export$2823037fb9d8f0c6) && sourceFormat !== (0, $369d2fc585e5938e$export$703ae8a2d83f441)) return;
    var dataItem = data.getRawDataItem(dataIndex);
    if (sourceFormat === (0, $369d2fc585e5938e$export$2823037fb9d8f0c6) && !(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dataItem)) dataItem = null;
    if (dataItem) return dataItem[attr];
}




var $36ff81ce502a4a00$var$DIMENSION_LABEL_REG = /\{@(.+?)\}/g;
var $36ff81ce502a4a00$export$f23396ae04ea95a7 = /** @class */ function() {
    function DataFormatMixin() {}
    /**
   * Get params for formatter
   */ DataFormatMixin.prototype.getDataParams = function(dataIndex, dataType) {
        var data = this.getData(dataType);
        var rawValue = this.getRawValue(dataIndex, dataType);
        var rawDataIndex = data.getRawIndex(dataIndex);
        var name = data.getName(dataIndex);
        var itemOpt = data.getRawDataItem(dataIndex);
        var style = data.getItemVisual(dataIndex, 'style');
        var color = style && style[data.getItemVisual(dataIndex, 'drawType') || 'fill'];
        var borderColor = style && style.stroke;
        var mainType = this.mainType;
        var isSeries = mainType === 'series';
        var userOutput = data.userOutput && data.userOutput.get();
        return {
            componentType: mainType,
            componentSubType: this.subType,
            componentIndex: this.componentIndex,
            seriesType: isSeries ? this.subType : null,
            seriesIndex: this.seriesIndex,
            seriesId: isSeries ? this.id : null,
            seriesName: isSeries ? this.name : null,
            name: name,
            dataIndex: rawDataIndex,
            data: itemOpt,
            dataType: dataType,
            value: rawValue,
            color: color,
            borderColor: borderColor,
            dimensionNames: userOutput ? userOutput.fullDimensions : null,
            encode: userOutput ? userOutput.encode : null,
            // Param name list for mapping `a`, `b`, `c`, `d`, `e`
            $vars: [
                'seriesName',
                'name',
                'value'
            ]
        };
    };
    /**
   * Format label
   * @param dataIndex
   * @param status 'normal' by default
   * @param dataType
   * @param labelDimIndex Only used in some chart that
   *        use formatter in different dimensions, like radar.
   * @param formatter Formatter given outside.
   * @return return null/undefined if no formatter
   */ DataFormatMixin.prototype.getFormattedLabel = function(dataIndex, status, dataType, labelDimIndex, formatter, extendParams) {
        status = status || 'normal';
        var data = this.getData(dataType);
        var params = this.getDataParams(dataIndex, dataType);
        if (extendParams) params.value = extendParams.interpolatedValue;
        if (labelDimIndex != null && $1b239fc9d3a2f8ae$export$43bee75e5e14138e(params.value)) params.value = params.value[labelDimIndex];
        if (!formatter) {
            var itemModel = data.getItemModel(dataIndex);
            // @ts-ignore
            formatter = itemModel.get(status === 'normal' ? [
                'label',
                'formatter'
            ] : [
                status,
                'label',
                'formatter'
            ]);
        }
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            params.dimensionIndex = labelDimIndex;
            return formatter(params);
        } else if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(formatter)) {
            var str = (0, $ff2fba995230f3c9$export$2028496a35766e41)(formatter, params);
            // Support 'aaa{@[3]}bbb{@product}ccc'.
            // Do not support '}' in dim name util have to.
            return str.replace($36ff81ce502a4a00$var$DIMENSION_LABEL_REG, function(origin, dimStr) {
                var len = dimStr.length;
                var dimLoose = dimStr;
                if (dimLoose.charAt(0) === '[' && dimLoose.charAt(len - 1) === ']') dimLoose = +dimLoose.slice(1, len - 1); // Also support: '[]' => 0
                var val = (0, $a0d276c4568d5ef4$export$cde9373da9aad801)(data, dataIndex, dimLoose);
                if (extendParams && $1b239fc9d3a2f8ae$export$43bee75e5e14138e(extendParams.interpolatedValue)) {
                    var dimIndex = data.getDimensionIndex(dimLoose);
                    if (dimIndex >= 0) val = extendParams.interpolatedValue[dimIndex];
                }
                return val != null ? val + '' : '';
            });
        }
    };
    /**
   * Get raw value in option
   */ DataFormatMixin.prototype.getRawValue = function(idx, dataType) {
        return (0, $a0d276c4568d5ef4$export$cde9373da9aad801)(this.getData(dataType), idx);
    };
    /**
   * Should be implemented.
   * @param {number} dataIndex
   * @param {boolean} [multipleSeries=false]
   * @param {string} [dataType]
   */ DataFormatMixin.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // Empty function
        return;
    };
    return DataFormatMixin;
}();
function $36ff81ce502a4a00$export$2d16fa82a50c4741(result) {
    var markupText;
    // let markers: Dictionary<ColorString>;
    var markupFragment;
    if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(result)) {
        if (result.type) markupFragment = result;
    } else markupText = result;
    return {
        text: markupText,
        // markers: markers || markersExisting,
        frag: markupFragment
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $00bdcd96204d1130$export$f7292ab7796be73c(define) {
    return new $00bdcd96204d1130$export$2dea7024bcdd7731(define);
}
var $00bdcd96204d1130$export$2dea7024bcdd7731 = /** @class */ function() {
    function Task(define) {
        define = define || {};
        this._reset = define.reset;
        this._plan = define.plan;
        this._count = define.count;
        this._onDirty = define.onDirty;
        this._dirty = true;
    }
    /**
   * @param step Specified step.
   * @param skip Skip customer perform call.
   * @param modBy Sampling window size.
   * @param modDataCount Sampling count.
   * @return whether unfinished.
   */ Task.prototype.perform = function(performArgs) {
        var upTask = this._upstream;
        var skip = performArgs && performArgs.skip;
        // TODO some refactor.
        // Pull data. Must pull data each time, because context.data
        // may be updated by Series.setData.
        if (this._dirty && upTask) {
            var context = this.context;
            context.data = context.outputData = upTask.context.outputData;
        }
        if (this.__pipeline) this.__pipeline.currentTask = this;
        var planResult;
        if (this._plan && !skip) planResult = this._plan(this.context);
        // Support sharding by mod, which changes the render sequence and makes the rendered graphic
        // elements uniformed distributed when progress, especially when moving or zooming.
        var lastModBy = normalizeModBy(this._modBy);
        var lastModDataCount = this._modDataCount || 0;
        var modBy = normalizeModBy(performArgs && performArgs.modBy);
        var modDataCount = performArgs && performArgs.modDataCount || 0;
        if (lastModBy !== modBy || lastModDataCount !== modDataCount) planResult = 'reset';
        function normalizeModBy(val) {
            !(val >= 1) && (val = 1); // jshint ignore:line
            return val;
        }
        var forceFirstProgress;
        if (this._dirty || planResult === 'reset') {
            this._dirty = false;
            forceFirstProgress = this._doReset(skip);
        }
        this._modBy = modBy;
        this._modDataCount = modDataCount;
        var step = performArgs && performArgs.step;
        if (upTask) this._dueEnd = upTask._outputDueEnd;
        else this._dueEnd = this._count ? this._count(this.context) : Infinity;
        // Note: Stubs, that its host overall task let it has progress, has progress.
        // If no progress, pass index from upstream to downstream each time plan called.
        if (this._progress) {
            var start = this._dueIndex;
            var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
            if (!skip && (forceFirstProgress || start < end)) {
                var progress = this._progress;
                if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(progress)) for(var i = 0; i < progress.length; i++)this._doProgress(progress[i], start, end, modBy, modDataCount);
                else this._doProgress(progress, start, end, modBy, modDataCount);
            }
            this._dueIndex = end;
            // If no `outputDueEnd`, assume that output data and
            // input data is the same, so use `dueIndex` as `outputDueEnd`.
            var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
            this._outputDueEnd = outputDueEnd;
        } else // (1) Some overall task has no progress.
        // (2) Stubs, that its host overall task do not let it has progress, has no progress.
        // This should always be performed so it can be passed to downstream.
        this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
        return this.unfinished();
    };
    Task.prototype.dirty = function() {
        this._dirty = true;
        this._onDirty && this._onDirty(this.context);
    };
    Task.prototype._doProgress = function(progress, start, end, modBy, modDataCount) {
        $00bdcd96204d1130$var$iterator.reset(start, end, modBy, modDataCount);
        this._callingProgress = progress;
        this._callingProgress({
            start: start,
            end: end,
            count: end - start,
            next: $00bdcd96204d1130$var$iterator.next
        }, this.context);
    };
    Task.prototype._doReset = function(skip) {
        this._dueIndex = this._outputDueEnd = this._dueEnd = 0;
        this._settedOutputEnd = null;
        var progress;
        var forceFirstProgress;
        if (!skip && this._reset) {
            progress = this._reset(this.context);
            if (progress && progress.progress) {
                forceFirstProgress = progress.forceFirstProgress;
                progress = progress.progress;
            }
            // To simplify no progress checking, array must has item.
            if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(progress) && !progress.length) progress = null;
        }
        this._progress = progress;
        this._modBy = this._modDataCount = null;
        var downstream = this._downstream;
        downstream && downstream.dirty();
        return forceFirstProgress;
    };
    Task.prototype.unfinished = function() {
        return this._progress && this._dueIndex < this._dueEnd;
    };
    /**
   * @param downTask The downstream task.
   * @return The downstream task.
   */ Task.prototype.pipe = function(downTask) {
        // If already downstream, do not dirty downTask.
        if (this._downstream !== downTask || this._dirty) {
            this._downstream = downTask;
            downTask._upstream = this;
            downTask.dirty();
        }
    };
    Task.prototype.dispose = function() {
        if (this._disposed) return;
        this._upstream && (this._upstream._downstream = null);
        this._downstream && (this._downstream._upstream = null);
        this._dirty = false;
        this._disposed = true;
    };
    Task.prototype.getUpstream = function() {
        return this._upstream;
    };
    Task.prototype.getDownstream = function() {
        return this._downstream;
    };
    Task.prototype.setOutputEnd = function(end) {
        // This only happens in dataTask, dataZoom, map, currently.
        // where dataZoom do not set end each time, but only set
        // when reset. So we should record the set end, in case
        // that the stub of dataZoom perform again and earse the
        // set end by upstream.
        this._outputDueEnd = this._settedOutputEnd = end;
    };
    return Task;
}();
var $00bdcd96204d1130$var$iterator = function() {
    var end;
    var current;
    var modBy;
    var modDataCount;
    var winCount;
    var it = {
        reset: function(s, e, sStep, sCount) {
            current = s;
            end = e;
            modBy = sStep;
            modDataCount = sCount;
            winCount = Math.ceil(modDataCount / modBy);
            it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
        }
    };
    return it;
    function sequentialNext() {
        return current < end ? current++ : null;
    }
    function modNext() {
        var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
        var result = current >= end ? null : dataIndex < modDataCount ? dataIndex : current;
        current++;
        return result;
    }
}(); // -----------------------------------------------------------------------------
 // For stream debug (Should be commented out after used!)
 // @usage: printTask(this, 'begin');
 // @usage: printTask(this, null, {someExtraProp});
 // @usage: Use `__idxInPipeline` as conditional breakpiont.
 //
 // window.printTask = function (task: any, prefix: string, extra: { [key: string]: unknown }): void {
 //     window.ecTaskUID == null && (window.ecTaskUID = 0);
 //     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
 //     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
 //     let props = [];
 //     if (task.__pipeline) {
 //         let val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
 //         props.push({text: '__idxInPipeline/total', value: val});
 //     } else {
 //         let stubCount = 0;
 //         task.agentStubMap.each(() => stubCount++);
 //         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
 //     }
 //     props.push({text: 'uid', value: task.uidDebug});
 //     if (task.__pipeline) {
 //         props.push({text: 'pipelineId', value: task.__pipeline.id});
 //         task.agent && props.push(
 //             {text: 'stubFor', value: task.agent.uidDebug}
 //         );
 //     }
 //     props.push(
 //         {text: 'dirty', value: task._dirty},
 //         {text: 'dueIndex', value: task._dueIndex},
 //         {text: 'dueEnd', value: task._dueEnd},
 //         {text: 'outputDueEnd', value: task._outputDueEnd}
 //     );
 //     if (extra) {
 //         Object.keys(extra).forEach(key => {
 //             props.push({text: key, value: extra[key]});
 //         });
 //     }
 //     let args = ['color: blue'];
 //     let msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
 //         args.push('color: green', 'color: red'),
 //         `${item.text}: %c${item.value}`
 //     )).join('%c, ');
 //     console.log.apply(console, [msg].concat(args));
 //     // console.log(this);
 // };
 // window.printPipeline = function (task: any, prefix: string) {
 //     const pipeline = task.__pipeline;
 //     let currTask = pipeline.head;
 //     while (currTask) {
 //         window.printTask(currTask, prefix);
 //         currTask = currTask._downstream;
 //     }
 // };
 // window.showChain = function (chainHeadTask) {
 //     var chain = [];
 //     var task = chainHeadTask;
 //     while (task) {
 //         chain.push({
 //             task: task,
 //             up: task._upstream,
 //             down: task._downstream,
 //             idxInPipeline: task.__idxInPipeline
 //         });
 //         task = task._downstream;
 //     }
 //     return chain;
 // };
 // window.findTaskInChain = function (task, chainHeadTask) {
 //     let chain = window.showChain(chainHeadTask);
 //     let result = [];
 //     for (let i = 0; i < chain.length; i++) {
 //         let chainItem = chain[i];
 //         if (chainItem.task === task) {
 //             result.push(i);
 //         }
 //     }
 //     return result;
 // };
 // window.printChainAEachInChainB = function (chainHeadTaskA, chainHeadTaskB) {
 //     let chainA = window.showChain(chainHeadTaskA);
 //     for (let i = 0; i < chainA.length; i++) {
 //         console.log('chainAIdx:', i, 'inChainB:', window.findTaskInChain(chainA[i].task, chainHeadTaskB));
 //     }
 // };



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $b0b05721170d73df$export$cc7175145baad076(value, // For high performance, do not omit the second param.
opt) {
    // Performance sensitive.
    var dimType = opt && opt.type;
    if (dimType === 'ordinal') // If given value is a category string
    return value;
    if (dimType === 'time' && !(0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(value) && value != null && value !== '-') value = +(0, $9fd90cf3bf18fbcd$export$6b862160d295c8e)(value);
    // dimType defaults 'number'.
    // If dimType is not ordinal and value is null or undefined or NaN or '-',
    // parse to NaN.
    // number-like string (like ' 123 ') can be converted to a number.
    // where null/undefined or other string will be converted to NaN.
    return value == null || value === '' ? NaN : Number(value);
}
var $b0b05721170d73df$var$valueParserMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)({
    'number': function(val) {
        // Do not use `numericToNumber` here. We have `numericToNumber` by default.
        // Here the number parser can have loose rule:
        // enable to cut suffix: "120px" => 120, "14%" => 14.
        return parseFloat(val);
    },
    'time': function(val) {
        // return timestamp.
        return +(0, $9fd90cf3bf18fbcd$export$6b862160d295c8e)(val);
    },
    'trim': function(val) {
        return (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(val) ? (0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(val) : val;
    }
});
function $b0b05721170d73df$export$c88237b7c265b36b(type) {
    return $b0b05721170d73df$var$valueParserMap.get(type);
}
var $b0b05721170d73df$var$ORDER_COMPARISON_OP_MAP = {
    lt: function(lval, rval) {
        return lval < rval;
    },
    lte: function(lval, rval) {
        return lval <= rval;
    },
    gt: function(lval, rval) {
        return lval > rval;
    },
    gte: function(lval, rval) {
        return lval >= rval;
    }
};
var $b0b05721170d73df$var$FilterOrderComparator = /** @class */ function() {
    function FilterOrderComparator(op, rval) {
        if (!(0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rval)) {
            var errMsg = '';
            (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        }
        this._opFn = $b0b05721170d73df$var$ORDER_COMPARISON_OP_MAP[op];
        this._rvalFloat = (0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterOrderComparator.prototype.evaluate = function(lval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        return (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(lval) ? this._opFn(lval, this._rvalFloat) : this._opFn((0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(lval), this._rvalFloat);
    };
    return FilterOrderComparator;
}();
var $b0b05721170d73df$export$ed75a5d7b0144167 = /** @class */ function() {
    /**
   * @param order by default: 'asc'
   * @param incomparable by default: Always on the tail.
   *        That is, if 'asc' => 'max', if 'desc' => 'min'
   *        See the definition of "incomparable" in [SORT_COMPARISON_RULE].
   */ function SortOrderComparator(order, incomparable) {
        var isDesc = order === 'desc';
        this._resultLT = isDesc ? 1 : -1;
        if (incomparable == null) incomparable = isDesc ? 'min' : 'max';
        this._incomparable = incomparable === 'min' ? -Infinity : Infinity;
    }
    // See [SORT_COMPARISON_RULE].
    // Performance sensitive.
    SortOrderComparator.prototype.evaluate = function(lval, rval) {
        // Most cases is 'number', and typeof maybe 10 times faseter than parseFloat.
        var lvalFloat = (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(lval) ? lval : (0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(lval);
        var rvalFloat = (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rval) ? rval : (0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(rval);
        var lvalNotNumeric = isNaN(lvalFloat);
        var rvalNotNumeric = isNaN(rvalFloat);
        if (lvalNotNumeric) lvalFloat = this._incomparable;
        if (rvalNotNumeric) rvalFloat = this._incomparable;
        if (lvalNotNumeric && rvalNotNumeric) {
            var lvalIsStr = (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(lval);
            var rvalIsStr = (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(rval);
            if (lvalIsStr) lvalFloat = rvalIsStr ? lval : 0;
            if (rvalIsStr) rvalFloat = lvalIsStr ? rval : 0;
        }
        return lvalFloat < rvalFloat ? this._resultLT : lvalFloat > rvalFloat ? -this._resultLT : 0;
    };
    return SortOrderComparator;
}();
var $b0b05721170d73df$var$FilterEqualityComparator = /** @class */ function() {
    function FilterEqualityComparator(isEq, rval) {
        this._rval = rval;
        this._isEQ = isEq;
        this._rvalTypeof = typeof rval;
        this._rvalFloat = (0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(rval);
    }
    // Performance sensitive.
    FilterEqualityComparator.prototype.evaluate = function(lval) {
        var eqResult = lval === this._rval;
        if (!eqResult) {
            var lvalTypeof = typeof lval;
            if (lvalTypeof !== this._rvalTypeof && (lvalTypeof === 'number' || this._rvalTypeof === 'number')) eqResult = (0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(lval) === this._rvalFloat;
        }
        return this._isEQ ? eqResult : !eqResult;
    };
    return FilterEqualityComparator;
}();
function $b0b05721170d73df$export$f2644c3485f94c4e(op, rval) {
    return op === 'eq' || op === 'ne' ? new $b0b05721170d73df$var$FilterEqualityComparator(op === 'eq', rval) : (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)($b0b05721170d73df$var$ORDER_COMPARISON_OP_MAP, op) ? new $b0b05721170d73df$var$FilterOrderComparator(op, rval) : null;
}




/**
 * TODO: disable writable.
 * This structure will be exposed to users.
 */ var $ac5f46749660ad86$export$ffc19e40a21f08eb = /** @class */ function() {
    function ExternalSource() {}
    ExternalSource.prototype.getRawData = function() {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.getRawDataItem = function(dataIndex) {
        // Only built-in transform available.
        throw new Error('not supported');
    };
    ExternalSource.prototype.cloneRawData = function() {
        return;
    };
    /**
   * @return If dimension not found, return null/undefined.
   */ ExternalSource.prototype.getDimensionInfo = function(dim) {
        return;
    };
    /**
   * dimensions defined if and only if either:
   * (a) dataset.dimensions are declared.
   * (b) dataset data include dimensions definitions in data (detected or via specified `sourceHeader`).
   * If dimensions are defined, `dimensionInfoAll` is corresponding to
   * the defined dimensions.
   * Otherwise, `dimensionInfoAll` is determined by data columns.
   * @return Always return an array (even empty array).
   */ ExternalSource.prototype.cloneAllDimensionInfo = function() {
        return;
    };
    ExternalSource.prototype.count = function() {
        return;
    };
    /**
   * Only support by dimension index.
   * No need to support by dimension name in transform function,
   * because transform function is not case-specific, no need to use name literally.
   */ ExternalSource.prototype.retrieveValue = function(dataIndex, dimIndex) {
        return;
    };
    ExternalSource.prototype.retrieveValueFromItem = function(dataItem, dimIndex) {
        return;
    };
    ExternalSource.prototype.convertValue = function(rawVal, dimInfo) {
        return (0, $b0b05721170d73df$export$cc7175145baad076)(rawVal, dimInfo);
    };
    return ExternalSource;
}();
function $ac5f46749660ad86$var$createExternalSource(internalSource, externalTransform) {
    var extSource = new $ac5f46749660ad86$export$ffc19e40a21f08eb();
    var data = internalSource.data;
    var sourceFormat = extSource.sourceFormat = internalSource.sourceFormat;
    var sourceHeaderCount = internalSource.startIndex;
    var errMsg = '';
    if (internalSource.seriesLayoutBy !== (0, $369d2fc585e5938e$export$7b3f3c6551b4949b)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    // [MEMO]
    // Create a new dimensions structure for exposing.
    // Do not expose all dimension info to users directly.
    // Because the dimension is probably auto detected from data and not might reliable.
    // Should not lead the transformers to think that is reliable and return it.
    // See [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
    var dimensions = [];
    var dimsByName = {};
    var dimsDef = internalSource.dimensionsDefine;
    if (dimsDef) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dimsDef, function(dimDef, idx) {
        var name = dimDef.name;
        var dimDefExt = {
            index: idx,
            name: name,
            displayName: dimDef.displayName
        };
        dimensions.push(dimDefExt);
        // Users probably do not specify dimension name. For simplicity, data transform
        // does not generate dimension name.
        if (name != null) {
            // Dimension name should not be duplicated.
            // For simplicity, data transform forbids name duplication, do not generate
            // new name like module `completeDimensions.ts` did, but just tell users.
            var errMsg_1 = '';
            if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(dimsByName, name)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg_1);
            dimsByName[name] = dimDefExt;
        }
    });
    else for(var i = 0; i < internalSource.dimensionsDetectedCount || 0; i++)// Do not generete name or anything others. The consequence process in
    // `transform` or `series` probably have there own name generation strategry.
    dimensions.push({
        index: i
    });
    // Implement public methods:
    var rawItemGetter = (0, $a0d276c4568d5ef4$export$92c8ea8642b3957d)(sourceFormat, (0, $369d2fc585e5938e$export$7b3f3c6551b4949b));
    if (externalTransform.__isBuiltIn) {
        extSource.getRawDataItem = function(dataIndex) {
            return rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        };
        extSource.getRawData = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($ac5f46749660ad86$var$getRawData, null, internalSource);
    }
    extSource.cloneRawData = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($ac5f46749660ad86$var$cloneRawData, null, internalSource);
    var rawCounter = (0, $a0d276c4568d5ef4$export$803742e832f4b52c)(sourceFormat, (0, $369d2fc585e5938e$export$7b3f3c6551b4949b));
    extSource.count = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(rawCounter, null, data, sourceHeaderCount, dimensions);
    var rawValueGetter = (0, $a0d276c4568d5ef4$export$1752de8084789a14)(sourceFormat);
    extSource.retrieveValue = function(dataIndex, dimIndex) {
        var rawItem = rawItemGetter(data, sourceHeaderCount, dimensions, dataIndex);
        return retrieveValueFromItem(rawItem, dimIndex);
    };
    var retrieveValueFromItem = extSource.retrieveValueFromItem = function(dataItem, dimIndex) {
        if (dataItem == null) return;
        var dimDef = dimensions[dimIndex];
        // When `dimIndex` is `null`, `rawValueGetter` return the whole item.
        if (dimDef) return rawValueGetter(dataItem, dimIndex, dimDef.name);
    };
    extSource.getDimensionInfo = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($ac5f46749660ad86$var$getDimensionInfo, null, dimensions, dimsByName);
    extSource.cloneAllDimensionInfo = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($ac5f46749660ad86$var$cloneAllDimensionInfo, null, dimensions);
    return extSource;
}
function $ac5f46749660ad86$var$getRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    if (!$ac5f46749660ad86$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    }
    return upstream.data;
}
function $ac5f46749660ad86$var$cloneRawData(upstream) {
    var sourceFormat = upstream.sourceFormat;
    var data = upstream.data;
    if (!$ac5f46749660ad86$var$isSupportedSourceFormat(sourceFormat)) {
        var errMsg = '';
        (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    }
    if (sourceFormat === (0, $369d2fc585e5938e$export$fcd62ebf51387903)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push(data[i].slice());
        return result;
    } else if (sourceFormat === (0, $369d2fc585e5938e$export$703ae8a2d83f441)) {
        var result = [];
        for(var i = 0, len = data.length; i < len; i++)// Not strictly clone for performance
        result.push((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, data[i]));
        return result;
    }
}
function $ac5f46749660ad86$var$getDimensionInfo(dimensions, dimsByName, dim) {
    if (dim == null) return;
    // Keep the same logic as `List::getDimension` did.
    if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(dim) || !isNaN(dim) && !(0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimensions[dim];
    else if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(dimsByName, dim)) return dimsByName[dim];
}
function $ac5f46749660ad86$var$cloneAllDimensionInfo(dimensions) {
    return (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(dimensions);
}
var $ac5f46749660ad86$var$externalTransformMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
function $ac5f46749660ad86$export$92c96c6d8b255b7d(externalTransform) {
    externalTransform = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(externalTransform);
    var type = externalTransform.type;
    var errMsg = '';
    if (!type) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    var typeParsed = type.split(':');
    if (typeParsed.length !== 2) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    // Namespace 'echarts:xxx' is official namespace, where the transforms should
    // be called directly via 'xxx' rather than 'echarts:xxx'.
    var isBuiltIn = false;
    if (typeParsed[0] === 'echarts') {
        type = typeParsed[1];
        isBuiltIn = true;
    }
    externalTransform.__isBuiltIn = isBuiltIn;
    $ac5f46749660ad86$var$externalTransformMap.set(type, externalTransform);
}
function $ac5f46749660ad86$export$42a68f09db16803f(rawTransOption, sourceList, infoForPrint) {
    var pipedTransOption = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(rawTransOption);
    var pipeLen = pipedTransOption.length;
    var errMsg = '';
    if (!pipeLen) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    for(var i = 0, len = pipeLen; i < len; i++){
        var transOption = pipedTransOption[i];
        sourceList = $ac5f46749660ad86$var$applySingleDataTransform(transOption, sourceList, infoForPrint, pipeLen === 1 ? null : i);
        // piped transform only support single input, except the fist one.
        // piped transform only support single output, except the last one.
        if (i !== len - 1) sourceList.length = Math.max(sourceList.length, 1);
    }
    return sourceList;
}
function $ac5f46749660ad86$var$applySingleDataTransform(transOption, upSourceList, infoForPrint, // If `pipeIndex` is null/undefined, no piped transform.
pipeIndex) {
    var errMsg = '';
    if (!upSourceList.length) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    if (!(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(transOption)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    var transType = transOption.type;
    var externalTransform = $ac5f46749660ad86$var$externalTransformMap.get(transType);
    if (!externalTransform) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    // Prepare source
    var extUpSourceList = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(upSourceList, function(upSource) {
        return $ac5f46749660ad86$var$createExternalSource(upSource, externalTransform);
    });
    var resultList = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(externalTransform.transform({
        upstream: extUpSourceList[0],
        upstreamList: extUpSourceList,
        config: (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(transOption.config)
    }));
    var printStrArr;
    return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(resultList, function(result, resultIndex) {
        var errMsg = '';
        if (!(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(result)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        if (!result.data) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        var sourceFormat = (0, $107136d10fa2cf04$export$52a469afa4653e57)(result.data);
        if (!$ac5f46749660ad86$var$isSupportedSourceFormat(sourceFormat)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        var resultMetaRawOption;
        var firstUpSource = upSourceList[0];
        /**
     * Intuitively, the end users known the content of the original `dataset.source`,
     * calucating the transform result in mind.
     * Suppose the original `dataset.source` is:
     * ```js
     * [
     *     ['product', '2012', '2013', '2014', '2015'],
     *     ['AAA', 41.1, 30.4, 65.1, 53.3],
     *     ['BBB', 86.5, 92.1, 85.7, 83.1],
     *     ['CCC', 24.1, 67.2, 79.5, 86.4]
     * ]
     * ```
     * The dimension info have to be detected from the source data.
     * Some of the transformers (like filter, sort) will follow the dimension info
     * of upstream, while others use new dimensions (like aggregate).
     * Transformer can output a field `dimensions` to define the its own output dimensions.
     * We also allow transformers to ignore the output `dimensions` field, and
     * inherit the upstream dimensions definition. It can reduce the burden of handling
     * dimensions in transformers.
     *
     * See also [DIMENSION_INHERIT_RULE] in `sourceManager.ts`.
     */ if (firstUpSource && resultIndex === 0 && !result.dimensions) {
            var startIndex = firstUpSource.startIndex;
            // We copy the header of upstream to the result, because:
            // (1) The returned data always does not contain header line and can not be used
            // as dimension-detection. In this case we can not use "detected dimensions" of
            // upstream directly, because it might be detected based on different `seriesLayoutBy`.
            // (2) We should support that the series read the upstream source in `seriesLayoutBy: 'row'`.
            // So the original detected header should be add to the result, otherwise they can not be read.
            if (startIndex) result.data = firstUpSource.data.slice(0, startIndex).concat(result.data);
            resultMetaRawOption = {
                seriesLayoutBy: (0, $369d2fc585e5938e$export$7b3f3c6551b4949b),
                sourceHeader: startIndex,
                dimensions: firstUpSource.metaRawOption.dimensions
            };
        } else resultMetaRawOption = {
            seriesLayoutBy: (0, $369d2fc585e5938e$export$7b3f3c6551b4949b),
            sourceHeader: 0,
            dimensions: result.dimensions
        };
        return (0, $107136d10fa2cf04$export$1921362e86c73c88)(result.data, resultMetaRawOption, null);
    });
}
function $ac5f46749660ad86$var$isSupportedSourceFormat(sourceFormat) {
    return sourceFormat === (0, $369d2fc585e5938e$export$fcd62ebf51387903) || sourceFormat === (0, $369d2fc585e5938e$export$703ae8a2d83f441);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $28fb3a4f6a7eb423$var$UNDEFINED = 'undefined';
var $28fb3a4f6a7eb423$export$859a1fa4f1106aa0 = typeof Uint32Array === $28fb3a4f6a7eb423$var$UNDEFINED ? Array : Uint32Array;
var $28fb3a4f6a7eb423$export$78cf73566f32c185 = typeof Uint16Array === $28fb3a4f6a7eb423$var$UNDEFINED ? Array : Uint16Array;
var $28fb3a4f6a7eb423$export$b60d945128546f53 = typeof Int32Array === $28fb3a4f6a7eb423$var$UNDEFINED ? Array : Int32Array;
var $28fb3a4f6a7eb423$export$365b104db51a490a = typeof Float64Array === $28fb3a4f6a7eb423$var$UNDEFINED ? Array : Float64Array;
/**
 * Multi dimensional data store
 */ var $28fb3a4f6a7eb423$var$dataCtors = {
    'float': $28fb3a4f6a7eb423$export$365b104db51a490a,
    'int': $28fb3a4f6a7eb423$export$b60d945128546f53,
    // Ordinal data type can be string or int
    'ordinal': Array,
    'number': Array,
    'time': $28fb3a4f6a7eb423$export$365b104db51a490a
};
var $28fb3a4f6a7eb423$var$defaultDimValueGetters;
function $28fb3a4f6a7eb423$var$getIndicesCtor(rawCount) {
    // The possible max value in this._indicies is always this._rawCount despite of filtering.
    return rawCount > 65535 ? $28fb3a4f6a7eb423$export$859a1fa4f1106aa0 : $28fb3a4f6a7eb423$export$78cf73566f32c185;
}
function $28fb3a4f6a7eb423$var$getInitialExtent() {
    return [
        Infinity,
        -Infinity
    ];
}
function $28fb3a4f6a7eb423$var$cloneChunk(originalChunk) {
    var Ctor = originalChunk.constructor;
    // Only shallow clone is enough when Array.
    return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
}
function $28fb3a4f6a7eb423$var$prepareStore(store, dimIdx, dimType, end, append) {
    var DataCtor = $28fb3a4f6a7eb423$var$dataCtors[dimType || 'float'];
    if (append) {
        var oldStore = store[dimIdx];
        var oldLen = oldStore && oldStore.length;
        if (!(oldLen === end)) {
            var newStore = new DataCtor(end);
            // The cost of the copy is probably inconsiderable
            // within the initial chunkSize.
            for(var j = 0; j < oldLen; j++)newStore[j] = oldStore[j];
            store[dimIdx] = newStore;
        }
    } else store[dimIdx] = new DataCtor(end);
}
/**
 * Basically, DataStore API keep immutable.
 */ var $28fb3a4f6a7eb423$var$DataStore = /** @class */ function() {
    function DataStore() {
        this._chunks = [];
        // It will not be calculated until needed.
        this._rawExtent = [];
        this._extent = [];
        this._count = 0;
        this._rawCount = 0;
        this._calcDimNameToIdx = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    }
    /**
   * Initialize from data
   */ DataStore.prototype.initData = function(provider, inputDimensions, dimValueGetter) {
        this._provider = provider;
        // Clear
        this._chunks = [];
        this._indices = null;
        this.getRawIndex = this._getRawIdxIdentity;
        var source = provider.getSource();
        var defaultGetter = this.defaultDimValueGetter = $28fb3a4f6a7eb423$var$defaultDimValueGetters[source.sourceFormat];
        // Default dim value getter
        this._dimValueGetter = dimValueGetter || defaultGetter;
        // Reset raw extent.
        this._rawExtent = [];
        var willRetrieveDataByName = (0, $107136d10fa2cf04$export$8911336b527f8517)(source);
        this._dimensions = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(inputDimensions, function(dim) {
            return {
                // Only pick these two props. Not leak other properties like orderMeta.
                type: dim.type,
                property: dim.property
            };
        });
        this._initDataFromProvider(0, provider.count());
    };
    DataStore.prototype.getProvider = function() {
        return this._provider;
    };
    /**
   * Caution: even when a `source` instance owned by a series, the created data store
   * may still be shared by different sereis (the source hash does not use all `source`
   * props, see `sourceManager`). In this case, the `source` props that are not used in
   * hash (like `source.dimensionDefine`) probably only belongs to a certain series and
   * thus should not be fetch here.
   */ DataStore.prototype.getSource = function() {
        return this._provider.getSource();
    };
    /**
   * @caution Only used in dataStack.
   */ DataStore.prototype.ensureCalculationDimension = function(dimName, type) {
        var calcDimNameToIdx = this._calcDimNameToIdx;
        var dimensions = this._dimensions;
        var calcDimIdx = calcDimNameToIdx.get(dimName);
        if (calcDimIdx != null) {
            if (dimensions[calcDimIdx].type === type) return calcDimIdx;
        } else calcDimIdx = dimensions.length;
        dimensions[calcDimIdx] = {
            type: type
        };
        calcDimNameToIdx.set(dimName, calcDimIdx);
        this._chunks[calcDimIdx] = new $28fb3a4f6a7eb423$var$dataCtors[type || 'float'](this._rawCount);
        this._rawExtent[calcDimIdx] = $28fb3a4f6a7eb423$var$getInitialExtent();
        return calcDimIdx;
    };
    DataStore.prototype.collectOrdinalMeta = function(dimIdx, ordinalMeta) {
        var chunk = this._chunks[dimIdx];
        var dim = this._dimensions[dimIdx];
        var rawExtents = this._rawExtent;
        var offset = dim.ordinalOffset || 0;
        var len = chunk.length;
        if (offset === 0) // We need to reset the rawExtent if collect is from start.
        // Because this dimension may be guessed as number and calcuating a wrong extent.
        rawExtents[dimIdx] = $28fb3a4f6a7eb423$var$getInitialExtent();
        var dimRawExtent = rawExtents[dimIdx];
        // Parse from previous data offset. len may be changed after appendData
        for(var i = offset; i < len; i++){
            var val = chunk[i] = ordinalMeta.parseAndCollect(chunk[i]);
            if (!isNaN(val)) {
                dimRawExtent[0] = Math.min(val, dimRawExtent[0]);
                dimRawExtent[1] = Math.max(val, dimRawExtent[1]);
            }
        }
        dim.ordinalMeta = ordinalMeta;
        dim.ordinalOffset = len;
        dim.type = 'ordinal'; // Force to be ordinal
    };
    DataStore.prototype.getOrdinalMeta = function(dimIdx) {
        var dimInfo = this._dimensions[dimIdx];
        var ordinalMeta = dimInfo.ordinalMeta;
        return ordinalMeta;
    };
    DataStore.prototype.getDimensionProperty = function(dimIndex) {
        var item = this._dimensions[dimIndex];
        return item && item.property;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ DataStore.prototype.appendData = function(data) {
        var provider = this._provider;
        var start = this.count();
        provider.appendData(data);
        var end = provider.count();
        if (!provider.persistent) end += start;
        if (start < end) this._initDataFromProvider(start, end, true);
        return [
            start,
            end
        ];
    };
    DataStore.prototype.appendValues = function(values, minFillLen) {
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var start = this.count();
        var end = start + Math.max(values.length, minFillLen || 0);
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            $28fb3a4f6a7eb423$var$prepareStore(chunks, i, dim.type, end, true);
        }
        var emptyDataItem = [];
        for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            // Store the data by dimensions
            for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                var dim = dimensions[dimIdx];
                var val = $28fb3a4f6a7eb423$var$defaultDimValueGetters.arrayRows.call(this, values[sourceIdx] || emptyDataItem, dim.property, sourceIdx, dimIdx);
                chunks[dimIdx][idx] = val;
                var dimRawExtent = rawExtent[dimIdx];
                val < dimRawExtent[0] && (dimRawExtent[0] = val);
                val > dimRawExtent[1] && (dimRawExtent[1] = val);
            }
        }
        this._rawCount = this._count = end;
        return {
            start: start,
            end: end
        };
    };
    DataStore.prototype._initDataFromProvider = function(start, end, append) {
        var provider = this._provider;
        var chunks = this._chunks;
        var dimensions = this._dimensions;
        var dimLen = dimensions.length;
        var rawExtent = this._rawExtent;
        var dimNames = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(dimensions, function(dim) {
            return dim.property;
        });
        for(var i = 0; i < dimLen; i++){
            var dim = dimensions[i];
            if (!rawExtent[i]) rawExtent[i] = $28fb3a4f6a7eb423$var$getInitialExtent();
            $28fb3a4f6a7eb423$var$prepareStore(chunks, i, dim.type, end, append);
        }
        if (provider.fillStorage) provider.fillStorage(start, end, chunks, rawExtent);
        else {
            var dataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                dataItem = provider.getItem(idx, dataItem);
                // Each data item is value
                // [1, 2]
                // 2
                // Bar chart, line chart which uses category axis
                // only gives the 'y' value. 'x' value is the indices of category
                // Use a tempValue to normalize the value to be a (x, y) value
                // Store the data by dimensions
                for(var dimIdx = 0; dimIdx < dimLen; dimIdx++){
                    var dimStorage = chunks[dimIdx];
                    // PENDING NULL is empty or zero
                    var val = this._dimValueGetter(dataItem, dimNames[dimIdx], idx, dimIdx);
                    dimStorage[idx] = val;
                    var dimRawExtent = rawExtent[dimIdx];
                    val < dimRawExtent[0] && (dimRawExtent[0] = val);
                    val > dimRawExtent[1] && (dimRawExtent[1] = val);
                }
            }
        }
        if (!provider.persistent && provider.clean) // Clean unused data if data source is typed array.
        provider.clean();
        this._rawCount = this._count = end;
        // Reset data extent
        this._extent = [];
    };
    DataStore.prototype.count = function() {
        return this._count;
    };
    /**
   * Get value. Return NaN if idx is out of range.
   */ DataStore.prototype.get = function(dim, idx) {
        if (!(idx >= 0 && idx < this._count)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[this.getRawIndex(idx)] : NaN;
    };
    DataStore.prototype.getValues = function(dimensions, idx) {
        var values = [];
        var dimArr = [];
        if (idx == null) {
            idx = dimensions;
            // TODO get all from store?
            dimensions = [];
            // All dimensions
            for(var i = 0; i < this._dimensions.length; i++)dimArr.push(i);
        } else dimArr = dimensions;
        for(var i = 0, len = dimArr.length; i < len; i++)values.push(this.get(dimArr[i], idx));
        return values;
    };
    /**
   * @param dim concrete dim
   */ DataStore.prototype.getByRawIndex = function(dim, rawIdx) {
        if (!(rawIdx >= 0 && rawIdx < this._rawCount)) return NaN;
        var dimStore = this._chunks[dim];
        return dimStore ? dimStore[rawIdx] : NaN;
    };
    /**
   * Get sum of data in one dimension
   */ DataStore.prototype.getSum = function(dim) {
        var dimData = this._chunks[dim];
        var sum = 0;
        if (dimData) for(var i = 0, len = this.count(); i < len; i++){
            var value = this.get(dim, i);
            if (!isNaN(value)) sum += value;
        }
        return sum;
    };
    /**
   * Get median of data in one dimension
   */ DataStore.prototype.getMedian = function(dim) {
        var dimDataArray = [];
        // map all data of one dimension
        this.each([
            dim
        ], function(val) {
            if (!isNaN(val)) dimDataArray.push(val);
        });
        // TODO
        // Use quick select?
        var sortedDimDataArray = dimDataArray.sort(function(a, b) {
            return a - b;
        });
        var len = this.count();
        // calculate median
        return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
    };
    /**
   * Retrieve the index with given raw data index.
   */ DataStore.prototype.indexOfRawIndex = function(rawIndex) {
        if (rawIndex >= this._rawCount || rawIndex < 0) return -1;
        if (!this._indices) return rawIndex;
        // Indices are ascending
        var indices = this._indices;
        // If rawIndex === dataIndex
        var rawDataIndex = indices[rawIndex];
        if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) return rawIndex;
        var left = 0;
        var right = this._count - 1;
        while(left <= right){
            var mid = (left + right) / 2 | 0;
            if (indices[mid] < rawIndex) left = mid + 1;
            else if (indices[mid] > rawIndex) right = mid - 1;
            else return mid;
        }
        return -1;
    };
    /**
   * Retrieve the index of nearest value.
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices have
   *         the same value, they are put to the result.
   */ DataStore.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        var chunks = this._chunks;
        var dimData = chunks[dim];
        var nearestIndices = [];
        if (!dimData) return nearestIndices;
        if (maxDistance == null) maxDistance = Infinity;
        var minDist = Infinity;
        var minDiff = -1;
        var nearestIndicesLen = 0;
        // Check the test case of `test/ut/spec/data/SeriesData.js`.
        for(var i = 0, len = this.count(); i < len; i++){
            var dataIndex = this.getRawIndex(i);
            var diff = value - dimData[dataIndex];
            var dist = Math.abs(diff);
            if (dist <= maxDistance) {
                // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
                // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
                // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
                // So we choose the one that `diff >= 0` in this case.
                // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
                // should be push to `nearestIndices`.
                if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
                    minDist = dist;
                    minDiff = diff;
                    nearestIndicesLen = 0;
                }
                if (diff === minDiff) nearestIndices[nearestIndicesLen++] = i;
            }
        }
        nearestIndices.length = nearestIndicesLen;
        return nearestIndices;
    };
    DataStore.prototype.getIndices = function() {
        var newIndices;
        var indices = this._indices;
        if (indices) {
            var Ctor = indices.constructor;
            var thisCount = this._count;
            // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
            if (Ctor === Array) {
                newIndices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)newIndices[i] = indices[i];
            } else newIndices = new Ctor(indices.buffer, 0, thisCount);
        } else {
            var Ctor = $28fb3a4f6a7eb423$var$getIndicesCtor(this._rawCount);
            newIndices = new Ctor(this.count());
            for(var i = 0; i < newIndices.length; i++)newIndices[i] = i;
        }
        return newIndices;
    };
    /**
   * Data filter.
   */ DataStore.prototype.filter = function(dims, cb) {
        if (!this._count) return this;
        var newStore = this.clone();
        var count = newStore.count();
        var Ctor = $28fb3a4f6a7eb423$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(count);
        var value = [];
        var dimSize = dims.length;
        var offset = 0;
        var dim0 = dims[0];
        var chunks = newStore._chunks;
        for(var i = 0; i < count; i++){
            var keep = void 0;
            var rawIdx = newStore.getRawIndex(i);
            // Simple optimization
            if (dimSize === 0) keep = cb(i);
            else if (dimSize === 1) {
                var val = chunks[dim0][rawIdx];
                keep = cb(val, i);
            } else {
                var k = 0;
                for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                value[k] = i;
                keep = cb.apply(null, value);
            }
            if (keep) newIndices[offset++] = rawIdx;
        }
        // Set indices after filtered.
        if (offset < count) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ DataStore.prototype.selectRange = function(range) {
        var newStore = this.clone();
        var len = newStore._count;
        if (!len) return this;
        var dims = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(range);
        var dimSize = dims.length;
        if (!dimSize) return this;
        var originalCount = newStore.count();
        var Ctor = $28fb3a4f6a7eb423$var$getIndicesCtor(newStore._rawCount);
        var newIndices = new Ctor(originalCount);
        var offset = 0;
        var dim0 = dims[0];
        var min = range[dim0][0];
        var max = range[dim0][1];
        var storeArr = newStore._chunks;
        var quickFinished = false;
        if (!newStore._indices) {
            // Extreme optimization for common case. About 2x faster in chrome.
            var idx = 0;
            if (dimSize === 1) {
                var dimStorage = storeArr[dims[0]];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    // NaN will not be filtered. Consider the case, in line chart, empty
                    // value indicates the line should be broken. But for the case like
                    // scatter plot, a data item with empty value will not be rendered,
                    // but the axis extent may be effected if some other dim of the data
                    // item has value. Fortunately it is not a significant negative effect.
                    if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            } else if (dimSize === 2) {
                var dimStorage = storeArr[dims[0]];
                var dimStorage2 = storeArr[dims[1]];
                var min2 = range[dims[1]][0];
                var max2 = range[dims[1]][1];
                for(var i = 0; i < len; i++){
                    var val = dimStorage[i];
                    var val2 = dimStorage2[i];
                    // Do not filter NaN, see comment above.
                    if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) newIndices[offset++] = idx;
                    idx++;
                }
                quickFinished = true;
            }
        }
        if (!quickFinished) {
            if (dimSize === 1) for(var i = 0; i < originalCount; i++){
                var rawIndex = newStore.getRawIndex(i);
                var val = storeArr[dims[0]][rawIndex];
                // Do not filter NaN, see comment above.
                if (val >= min && val <= max || isNaN(val)) newIndices[offset++] = rawIndex;
            }
            else for(var i = 0; i < originalCount; i++){
                var keep = true;
                var rawIndex = newStore.getRawIndex(i);
                for(var k = 0; k < dimSize; k++){
                    var dimk = dims[k];
                    var val = storeArr[dimk][rawIndex];
                    // Do not filter NaN, see comment above.
                    if (val < range[dimk][0] || val > range[dimk][1]) keep = false;
                }
                if (keep) newIndices[offset++] = newStore.getRawIndex(i);
            }
        }
        // Set indices after filtered.
        if (offset < originalCount) newStore._indices = newIndices;
        newStore._count = offset;
        // Reset data extent
        newStore._extent = [];
        newStore._updateGetRawIdx();
        return newStore;
    };
    // /**
    //  * Data mapping to a plain array
    //  */
    // mapArray(dims: DimensionIndex[], cb: MapArrayCb): any[] {
    //     const result: any[] = [];
    //     this.each(dims, function () {
    //         result.push(cb && (cb as MapArrayCb).apply(null, arguments));
    //     });
    //     return result;
    // }
    /**
   * Data mapping to a new List with given dimensions
   */ DataStore.prototype.map = function(dims, cb) {
        // TODO only clone picked chunks.
        var target = this.clone(dims);
        this._updateDims(target, dims, cb);
        return target;
    };
    /**
   * @caution Danger!! Only used in dataStack.
   */ DataStore.prototype.modify = function(dims, cb) {
        this._updateDims(this, dims, cb);
    };
    DataStore.prototype._updateDims = function(target, dims, cb) {
        var targetChunks = target._chunks;
        var tmpRetValue = [];
        var dimSize = dims.length;
        var dataCount = target.count();
        var values = [];
        var rawExtent = target._rawExtent;
        for(var i = 0; i < dims.length; i++)rawExtent[dims[i]] = $28fb3a4f6a7eb423$var$getInitialExtent();
        for(var dataIndex = 0; dataIndex < dataCount; dataIndex++){
            var rawIndex = target.getRawIndex(dataIndex);
            for(var k = 0; k < dimSize; k++)values[k] = targetChunks[dims[k]][rawIndex];
            values[dimSize] = dataIndex;
            var retValue = cb && cb.apply(null, values);
            if (retValue != null) {
                // a number or string (in oridinal dimension)?
                if (typeof retValue !== 'object') {
                    tmpRetValue[0] = retValue;
                    retValue = tmpRetValue;
                }
                for(var i = 0; i < retValue.length; i++){
                    var dim = dims[i];
                    var val = retValue[i];
                    var rawExtentOnDim = rawExtent[dim];
                    var dimStore = targetChunks[dim];
                    if (dimStore) dimStore[rawIndex] = val;
                    if (val < rawExtentOnDim[0]) rawExtentOnDim[0] = val;
                    if (val > rawExtentOnDim[1]) rawExtentOnDim[1] = val;
                }
            }
        }
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ DataStore.prototype.lttbDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        var sampledIndex = 0;
        var frameSize = Math.floor(1 / rate);
        var currentRawIndex = this.getRawIndex(0);
        var maxArea;
        var area;
        var nextRawIndex;
        var newIndices = new ($28fb3a4f6a7eb423$var$getIndicesCtor(this._rawCount))(Math.min((Math.ceil(len / frameSize) + 2) * 2, len));
        // First frame use the first data.
        newIndices[sampledIndex++] = currentRawIndex;
        for(var i = 1; i < len - 1; i += frameSize){
            var nextFrameStart = Math.min(i + frameSize, len - 1);
            var nextFrameEnd = Math.min(i + frameSize * 2, len);
            var avgX = (nextFrameEnd + nextFrameStart) / 2;
            var avgY = 0;
            for(var idx = nextFrameStart; idx < nextFrameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) continue;
                avgY += y;
            }
            avgY /= nextFrameEnd - nextFrameStart;
            var frameStart = i;
            var frameEnd = Math.min(i + frameSize, len);
            var pointAX = i - 1;
            var pointAY = dimStore[currentRawIndex];
            maxArea = -1;
            nextRawIndex = frameStart;
            var firstNaNIndex = -1;
            var countNaN = 0;
            // Find a point from current frame that construct a triangle with largest area with previous selected point
            // And the average of next frame.
            for(var idx = frameStart; idx < frameEnd; idx++){
                var rawIndex = this.getRawIndex(idx);
                var y = dimStore[rawIndex];
                if (isNaN(y)) {
                    countNaN++;
                    if (firstNaNIndex < 0) firstNaNIndex = rawIndex;
                    continue;
                }
                // Calculate triangle area over three buckets
                area = Math.abs((pointAX - avgX) * (y - pointAY) - (pointAX - idx) * (avgY - pointAY));
                if (area > maxArea) {
                    maxArea = area;
                    nextRawIndex = rawIndex; // Next a is this b
                }
            }
            if (countNaN > 0 && countNaN < frameEnd - frameStart) {
                // Append first NaN point in every bucket.
                // It is necessary to ensure the correct order of indices.
                newIndices[sampledIndex++] = Math.min(firstNaNIndex, nextRawIndex);
                nextRawIndex = Math.max(firstNaNIndex, nextRawIndex);
            }
            newIndices[sampledIndex++] = nextRawIndex;
            currentRawIndex = nextRawIndex; // This a is the next a (chosen b)
        }
        // First frame use the last data.
        newIndices[sampledIndex++] = this.getRawIndex(len - 1);
        target._count = sampledIndex;
        target._indices = newIndices;
        target.getRawIndex = this._getRawIdx;
        return target;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ DataStore.prototype.minmaxDownSample = function(valueDimension, rate) {
        var target = this.clone([
            valueDimension
        ], true);
        var targetStorage = target._chunks;
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[valueDimension];
        var len = this.count();
        // Each frame results in 2 data points, one for min and one for max
        var newIndices = new ($28fb3a4f6a7eb423$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize) * 2);
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            var minIndex = i;
            var minValue = dimStore[this.getRawIndex(minIndex)];
            var maxIndex = i;
            var maxValue = dimStore[this.getRawIndex(maxIndex)];
            var thisFrameSize = frameSize;
            // Handle final smaller frame
            if (i + frameSize > len) thisFrameSize = len - i;
            // Determine min and max within the current frame
            for(var k = 0; k < thisFrameSize; k++){
                var rawIndex = this.getRawIndex(i + k);
                var value = dimStore[rawIndex];
                if (value < minValue) {
                    minValue = value;
                    minIndex = i + k;
                }
                if (value > maxValue) {
                    maxValue = value;
                    maxIndex = i + k;
                }
            }
            var rawMinIndex = this.getRawIndex(minIndex);
            var rawMaxIndex = this.getRawIndex(maxIndex);
            // Set the order of the min and max values, based on their ordering in the frame
            if (minIndex < maxIndex) {
                newIndices[offset++] = rawMinIndex;
                newIndices[offset++] = rawMaxIndex;
            } else {
                newIndices[offset++] = rawMaxIndex;
                newIndices[offset++] = rawMinIndex;
            }
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ DataStore.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var target = this.clone([
            dimension
        ], true);
        var targetStorage = target._chunks;
        var frameValues = [];
        var frameSize = Math.floor(1 / rate);
        var dimStore = targetStorage[dimension];
        var len = this.count();
        var rawExtentOnDim = target._rawExtent[dimension] = $28fb3a4f6a7eb423$var$getInitialExtent();
        var newIndices = new ($28fb3a4f6a7eb423$var$getIndicesCtor(this._rawCount))(Math.ceil(len / frameSize));
        var offset = 0;
        for(var i = 0; i < len; i += frameSize){
            // Last frame
            if (frameSize > len - i) {
                frameSize = len - i;
                frameValues.length = frameSize;
            }
            for(var k = 0; k < frameSize; k++){
                var dataIdx = this.getRawIndex(i + k);
                frameValues[k] = dimStore[dataIdx];
            }
            var value = sampleValue(frameValues);
            var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
            // Only write value on the filtered data
            dimStore[sampleFrameIdx] = value;
            if (value < rawExtentOnDim[0]) rawExtentOnDim[0] = value;
            if (value > rawExtentOnDim[1]) rawExtentOnDim[1] = value;
            newIndices[offset++] = sampleFrameIdx;
        }
        target._count = offset;
        target._indices = newIndices;
        target._updateGetRawIdx();
        return target;
    };
    /**
   * Data iteration
   * @param ctx default this
   * @example
   *  list.each('x', function (x, idx) {});
   *  list.each(['x', 'y'], function (x, y, idx) {});
   *  list.each(function (idx) {})
   */ DataStore.prototype.each = function(dims, cb) {
        if (!this._count) return;
        var dimSize = dims.length;
        var chunks = this._chunks;
        for(var i = 0, len = this.count(); i < len; i++){
            var rawIdx = this.getRawIndex(i);
            // Simple optimization
            switch(dimSize){
                case 0:
                    cb(i);
                    break;
                case 1:
                    cb(chunks[dims[0]][rawIdx], i);
                    break;
                case 2:
                    cb(chunks[dims[0]][rawIdx], chunks[dims[1]][rawIdx], i);
                    break;
                default:
                    var k = 0;
                    var value = [];
                    for(; k < dimSize; k++)value[k] = chunks[dims[k]][rawIdx];
                    // Index
                    value[k] = i;
                    cb.apply(null, value);
            }
        }
    };
    /**
   * Get extent of data in one dimension
   */ DataStore.prototype.getDataExtent = function(dim) {
        // Make sure use concrete dim as cache name.
        var dimData = this._chunks[dim];
        var initialExtent = $28fb3a4f6a7eb423$var$getInitialExtent();
        if (!dimData) return initialExtent;
        // Make more strict checkings to ensure hitting cache.
        var currEnd = this.count();
        // Consider the most cases when using data zoom, `getDataExtent`
        // happened before filtering. We cache raw extent, which is not
        // necessary to be cleared and recalculated when restore data.
        var useRaw = !this._indices;
        var dimExtent;
        if (useRaw) return this._rawExtent[dim].slice();
        dimExtent = this._extent[dim];
        if (dimExtent) return dimExtent.slice();
        dimExtent = initialExtent;
        var min = dimExtent[0];
        var max = dimExtent[1];
        for(var i = 0; i < currEnd; i++){
            var rawIdx = this.getRawIndex(i);
            var value = dimData[rawIdx];
            value < min && (min = value);
            value > max && (max = value);
        }
        dimExtent = [
            min,
            max
        ];
        this._extent[dim] = dimExtent;
        return dimExtent;
    };
    /**
   * Get raw data item
   */ DataStore.prototype.getRawDataItem = function(idx) {
        var rawIdx = this.getRawIndex(idx);
        if (!this._provider.persistent) {
            var val = [];
            var chunks = this._chunks;
            for(var i = 0; i < chunks.length; i++)val.push(chunks[i][rawIdx]);
            return val;
        } else return this._provider.getItem(rawIdx);
    };
    /**
   * Clone shallow.
   *
   * @param clonedDims Determine which dims to clone. Will share the data if not specified.
   */ DataStore.prototype.clone = function(clonedDims, ignoreIndices) {
        var target = new DataStore();
        var chunks = this._chunks;
        var clonedDimsMap = clonedDims && (0, $1b239fc9d3a2f8ae$export$533b26079ad0b4b)(clonedDims, function(obj, dimIdx) {
            obj[dimIdx] = true;
            return obj;
        }, {});
        if (clonedDimsMap) for(var i = 0; i < chunks.length; i++)// Not clone if dim is not picked.
        target._chunks[i] = !clonedDimsMap[i] ? chunks[i] : $28fb3a4f6a7eb423$var$cloneChunk(chunks[i]);
        else target._chunks = chunks;
        this._copyCommonProps(target);
        if (!ignoreIndices) target._indices = this._cloneIndices();
        target._updateGetRawIdx();
        return target;
    };
    DataStore.prototype._copyCommonProps = function(target) {
        target._count = this._count;
        target._rawCount = this._rawCount;
        target._provider = this._provider;
        target._dimensions = this._dimensions;
        target._extent = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(this._extent);
        target._rawExtent = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(this._rawExtent);
    };
    DataStore.prototype._cloneIndices = function() {
        if (this._indices) {
            var Ctor = this._indices.constructor;
            var indices = void 0;
            if (Ctor === Array) {
                var thisCount = this._indices.length;
                indices = new Ctor(thisCount);
                for(var i = 0; i < thisCount; i++)indices[i] = this._indices[i];
            } else indices = new Ctor(this._indices);
            return indices;
        }
        return null;
    };
    DataStore.prototype._getRawIdxIdentity = function(idx) {
        return idx;
    };
    DataStore.prototype._getRawIdx = function(idx) {
        if (idx < this._count && idx >= 0) return this._indices[idx];
        return -1;
    };
    DataStore.prototype._updateGetRawIdx = function() {
        this.getRawIndex = this._indices ? this._getRawIdx : this._getRawIdxIdentity;
    };
    DataStore.internalField = function() {
        function getDimValueSimply(dataItem, property, dataIndex, dimIndex) {
            return (0, $b0b05721170d73df$export$cc7175145baad076)(dataItem[dimIndex], this._dimensions[dimIndex]);
        }
        $28fb3a4f6a7eb423$var$defaultDimValueGetters = {
            arrayRows: getDimValueSimply,
            objectRows: function(dataItem, property, dataIndex, dimIndex) {
                return (0, $b0b05721170d73df$export$cc7175145baad076)(dataItem[property], this._dimensions[dimIndex]);
            },
            keyedColumns: getDimValueSimply,
            original: function(dataItem, property, dataIndex, dimIndex) {
                // Performance sensitive, do not use modelUtil.getDataItemValue.
                // If dataItem is an plain object with no value field, the let `value`
                // will be assigned with the object, but it will be tread correctly
                // in the `convertValue`.
                var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value);
                return (0, $b0b05721170d73df$export$cc7175145baad076)(value instanceof Array ? value[dimIndex] : value, this._dimensions[dimIndex]);
            },
            typedArray: function(dataItem, property, dataIndex, dimIndex) {
                return dataItem[dimIndex];
            }
        };
    }();
    return DataStore;
}();
var $28fb3a4f6a7eb423$export$2e2bcd8739ae039 = $28fb3a4f6a7eb423$var$DataStore;



/**
 * [REQUIREMENT_MEMO]:
 * (0) `metaRawOption` means `dimensions`/`sourceHeader`/`seriesLayoutBy` in raw option.
 * (1) Keep support the feature: `metaRawOption` can be specified both on `series` and
 * `root-dataset`. Them on `series` has higher priority.
 * (2) Do not support to set `metaRawOption` on a `non-root-dataset`, because it might
 * confuse users: whether those props indicate how to visit the upstream source or visit
 * the transform result source, and some transforms has nothing to do with these props,
 * and some transforms might have multiple upstream.
 * (3) Transforms should specify `metaRawOption` in each output, just like they can be
 * declared in `root-dataset`.
 * (4) At present only support visit source in `SERIES_LAYOUT_BY_COLUMN` in transforms.
 * That is for reducing complexity in transforms.
 * PENDING: Whether to provide transposition transform?
 *
 * [IMPLEMENTAION_MEMO]:
 * "sourceVisitConfig" are calculated from `metaRawOption` and `data`.
 * They will not be calculated until `source` is about to be visited (to prevent from
 * duplicate calcuation). `source` is visited only in series and input to transforms.
 *
 * [DIMENSION_INHERIT_RULE]:
 * By default the dimensions are inherited from ancestors, unless a transform return
 * a new dimensions definition.
 * Consider the case:
 * ```js
 * dataset: [{
 *     source: [ ['Product', 'Sales', 'Prise'], ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * dataset: [{
 *     dimension: ['Product', 'Sales', 'Prise'],
 *     source: [ ['Cookies', 321, 44.21], ...]
 * }, {
 *     transform: { type: 'filter', ... }
 * }]
 * ```
 * The two types of option should have the same behavior after transform.
 *
 *
 * [SCENARIO]:
 * (1) Provide source data directly:
 * ```js
 * series: {
 *     encode: {...},
 *     dimensions: [...]
 *     seriesLayoutBy: 'row',
 *     data: [[...]]
 * }
 * ```
 * (2) Series refer to dataset.
 * ```js
 * series: [{
 *     encode: {...}
 *     // Ignore datasetIndex means `datasetIndex: 0`
 *     // and the dimensions defination in dataset is used
 * }, {
 *     encode: {...},
 *     seriesLayoutBy: 'column',
 *     datasetIndex: 1
 * }]
 * ```
 * (3) dataset transform
 * ```js
 * dataset: [{
 *     source: [...]
 * }, {
 *     source: [...]
 * }, {
 *     // By default from 0.
 *     transform: { type: 'filter', config: {...} }
 * }, {
 *     // Piped.
 *     transform: [
 *         { type: 'filter', config: {...} },
 *         { type: 'sort', config: {...} }
 *     ]
 * }, {
 *     id: 'regressionData',
 *     fromDatasetIndex: 1,
 *     // Third-party transform
 *     transform: { type: 'ecStat:regression', config: {...} }
 * }, {
 *     // retrieve the extra result.
 *     id: 'regressionFormula',
 *     fromDatasetId: 'regressionData',
 *     fromTransformResult: 1
 * }]
 * ```
 */ var $9b5faf969a385e96$export$af4db9ec7e200ea2 = /** @class */ function() {
    function SourceManager(sourceHost) {
        // Cached source. Do not repeat calculating if not dirty.
        this._sourceList = [];
        this._storeList = [];
        // version sign of each upstream source manager.
        this._upstreamSignList = [];
        this._versionSignBase = 0;
        this._dirty = true;
        this._sourceHost = sourceHost;
    }
    /**
   * Mark dirty.
   */ SourceManager.prototype.dirty = function() {
        this._setLocalSource([], []);
        this._storeList = [];
        this._dirty = true;
    };
    SourceManager.prototype._setLocalSource = function(sourceList, upstreamSignList) {
        this._sourceList = sourceList;
        this._upstreamSignList = upstreamSignList;
        this._versionSignBase++;
        if (this._versionSignBase > 9e10) this._versionSignBase = 0;
    };
    /**
   * For detecting whether the upstream source is dirty, so that
   * the local cached source (in `_sourceList`) should be discarded.
   */ SourceManager.prototype._getVersionSign = function() {
        return this._sourceHost.uid + '_' + this._versionSignBase;
    };
    /**
   * Always return a source instance. Otherwise throw error.
   */ SourceManager.prototype.prepareSource = function() {
        // For the case that call `setOption` multiple time but no data changed,
        // cache the result source to prevent from repeating transform.
        if (this._isDirty()) {
            this._createSource();
            this._dirty = false;
        }
    };
    SourceManager.prototype._createSource = function() {
        this._setLocalSource([], []);
        var sourceHost = this._sourceHost;
        var upSourceMgrList = this._getUpstreamSourceManagers();
        var hasUpstream = !!upSourceMgrList.length;
        var resultSourceList;
        var upstreamSignList;
        if ($9b5faf969a385e96$var$isSeries(sourceHost)) {
            var seriesModel = sourceHost;
            var data = void 0;
            var sourceFormat = void 0;
            var upSource = void 0;
            // Has upstream dataset
            if (hasUpstream) {
                var upSourceMgr = upSourceMgrList[0];
                upSourceMgr.prepareSource();
                upSource = upSourceMgr.getSource();
                data = upSource.data;
                sourceFormat = upSource.sourceFormat;
                upstreamSignList = [
                    upSourceMgr._getVersionSign()
                ];
            } else {
                data = seriesModel.get('data', true);
                sourceFormat = (0, $1b239fc9d3a2f8ae$export$b119cc7e1840e59c)(data) ? (0, $369d2fc585e5938e$export$a918cb016a382d45) : (0, $369d2fc585e5938e$export$2823037fb9d8f0c6);
                upstreamSignList = [];
            }
            // See [REQUIREMENT_MEMO], merge settings on series and parent dataset if it is root.
            var newMetaRawOption = this._getSourceMetaRawOption() || {};
            var upMetaRawOption = upSource && upSource.metaRawOption || {};
            var seriesLayoutBy = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(newMetaRawOption.seriesLayoutBy, upMetaRawOption.seriesLayoutBy) || null;
            var sourceHeader = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(newMetaRawOption.sourceHeader, upMetaRawOption.sourceHeader);
            // Note here we should not use `upSource.dimensionsDefine`. Consider the case:
            // `upSource.dimensionsDefine` is detected by `seriesLayoutBy: 'column'`,
            // but series need `seriesLayoutBy: 'row'`.
            var dimensions = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(newMetaRawOption.dimensions, upMetaRawOption.dimensions);
            // We share source with dataset as much as possible
            // to avoid extra memory cost of high dimensional data.
            var needsCreateSource = seriesLayoutBy !== upMetaRawOption.seriesLayoutBy || !!sourceHeader !== !!upMetaRawOption.sourceHeader || dimensions;
            resultSourceList = needsCreateSource ? [
                (0, $107136d10fa2cf04$export$1921362e86c73c88)(data, {
                    seriesLayoutBy: seriesLayoutBy,
                    sourceHeader: sourceHeader,
                    dimensions: dimensions
                }, sourceFormat)
            ] : [];
        } else {
            var datasetModel = sourceHost;
            // Has upstream dataset.
            if (hasUpstream) {
                var result = this._applyTransform(upSourceMgrList);
                resultSourceList = result.sourceList;
                upstreamSignList = result.upstreamSignList;
            } else {
                var sourceData = datasetModel.get('source', true);
                resultSourceList = [
                    (0, $107136d10fa2cf04$export$1921362e86c73c88)(sourceData, this._getSourceMetaRawOption(), null)
                ];
                upstreamSignList = [];
            }
        }
        this._setLocalSource(resultSourceList, upstreamSignList);
    };
    SourceManager.prototype._applyTransform = function(upMgrList) {
        var datasetModel = this._sourceHost;
        var transformOption = datasetModel.get('transform', true);
        var fromTransformResult = datasetModel.get('fromTransformResult', true);
        if (fromTransformResult != null) {
            var errMsg = '';
            if (upMgrList.length !== 1) $9b5faf969a385e96$var$doThrow(errMsg);
        }
        var sourceList;
        var upSourceList = [];
        var upstreamSignList = [];
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(upMgrList, function(upMgr) {
            upMgr.prepareSource();
            var upSource = upMgr.getSource(fromTransformResult || 0);
            var errMsg = '';
            if (fromTransformResult != null && !upSource) $9b5faf969a385e96$var$doThrow(errMsg);
            upSourceList.push(upSource);
            upstreamSignList.push(upMgr._getVersionSign());
        });
        if (transformOption) sourceList = (0, $ac5f46749660ad86$export$42a68f09db16803f)(transformOption, upSourceList, {
            datasetIndex: datasetModel.componentIndex
        });
        else if (fromTransformResult != null) sourceList = [
            (0, $107136d10fa2cf04$export$e0365e7e3555ddd4)(upSourceList[0])
        ];
        return {
            sourceList: sourceList,
            upstreamSignList: upstreamSignList
        };
    };
    SourceManager.prototype._isDirty = function() {
        if (this._dirty) return true;
        // All sourceList is from the some upstream.
        var upSourceMgrList = this._getUpstreamSourceManagers();
        for(var i = 0; i < upSourceMgrList.length; i++){
            var upSrcMgr = upSourceMgrList[i];
            if (// Consider the case that there is ancestor diry, call it recursively.
            // The performance is probably not an issue because usually the chain is not long.
            upSrcMgr._isDirty() || this._upstreamSignList[i] !== upSrcMgr._getVersionSign()) return true;
        }
    };
    /**
   * @param sourceIndex By default 0, means "main source".
   *                    In most cases there is only one source.
   */ SourceManager.prototype.getSource = function(sourceIndex) {
        sourceIndex = sourceIndex || 0;
        var source = this._sourceList[sourceIndex];
        if (!source) {
            // Series may share source instance with dataset.
            var upSourceMgrList = this._getUpstreamSourceManagers();
            return upSourceMgrList[0] && upSourceMgrList[0].getSource(sourceIndex);
        }
        return source;
    };
    /**
   *
   * Get a data store which can be shared across series.
   * Only available for series.
   *
   * @param seriesDimRequest Dimensions that are generated in series.
   *        Should have been sorted by `storeDimIndex` asc.
   */ SourceManager.prototype.getSharedDataStore = function(seriesDimRequest) {
        var schema = seriesDimRequest.makeStoreSchema();
        return this._innerGetDataStore(schema.dimensions, seriesDimRequest.source, schema.hash);
    };
    SourceManager.prototype._innerGetDataStore = function(storeDims, seriesSource, sourceReadKey) {
        // TODO Can use other sourceIndex?
        var sourceIndex = 0;
        var storeList = this._storeList;
        var cachedStoreMap = storeList[sourceIndex];
        if (!cachedStoreMap) cachedStoreMap = storeList[sourceIndex] = {};
        var cachedStore = cachedStoreMap[sourceReadKey];
        if (!cachedStore) {
            var upSourceMgr = this._getUpstreamSourceManagers()[0];
            if ($9b5faf969a385e96$var$isSeries(this._sourceHost) && upSourceMgr) cachedStore = upSourceMgr._innerGetDataStore(storeDims, seriesSource, sourceReadKey);
            else {
                cachedStore = new (0, $28fb3a4f6a7eb423$export$2e2bcd8739ae039)();
                // Always create store from source of series.
                cachedStore.initData(new (0, $a0d276c4568d5ef4$export$b900d7c4c3952a40)(seriesSource, storeDims.length), storeDims);
            }
            cachedStoreMap[sourceReadKey] = cachedStore;
        }
        return cachedStore;
    };
    /**
   * PENDING: Is it fast enough?
   * If no upstream, return empty array.
   */ SourceManager.prototype._getUpstreamSourceManagers = function() {
        // Always get the relationship from the raw option.
        // Do not cache the link of the dependency graph, so that
        // there is no need to update them when change happens.
        var sourceHost = this._sourceHost;
        if ($9b5faf969a385e96$var$isSeries(sourceHost)) {
            var datasetModel = (0, $669a01b8661bdd13$export$8da66f73a1eda454)(sourceHost);
            return !datasetModel ? [] : [
                datasetModel.getSourceManager()
            ];
        } else return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $669a01b8661bdd13$export$397ba553479711e7)(sourceHost), function(datasetModel) {
            return datasetModel.getSourceManager();
        });
    };
    SourceManager.prototype._getSourceMetaRawOption = function() {
        var sourceHost = this._sourceHost;
        var seriesLayoutBy;
        var sourceHeader;
        var dimensions;
        if ($9b5faf969a385e96$var$isSeries(sourceHost)) {
            seriesLayoutBy = sourceHost.get('seriesLayoutBy', true);
            sourceHeader = sourceHost.get('sourceHeader', true);
            dimensions = sourceHost.get('dimensions', true);
        } else if (!this._getUpstreamSourceManagers().length) {
            var model = sourceHost;
            seriesLayoutBy = model.get('seriesLayoutBy', true);
            sourceHeader = model.get('sourceHeader', true);
            dimensions = model.get('dimensions', true);
        }
        return {
            seriesLayoutBy: seriesLayoutBy,
            sourceHeader: sourceHeader,
            dimensions: dimensions
        };
    };
    return SourceManager;
}();
function $9b5faf969a385e96$export$9451f4e9047441ec(datasetModel) {
    var transformOption = datasetModel.option.transform;
    transformOption && (0, $1b239fc9d3a2f8ae$export$112e66431016387b)(datasetModel.option.transform);
}
function $9b5faf969a385e96$var$isSeries(sourceHost) {
    // Avoid circular dependency with Series.ts
    return sourceHost.mainType === 'series';
}
function $9b5faf969a385e96$var$doThrow(errMsg) {
    throw new Error(errMsg);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6ceb7d0f0435c9d1$var$TOOLTIP_LINE_HEIGHT_CSS = 'line-height:1';
function $6ceb7d0f0435c9d1$var$getTooltipLineHeight(textStyle) {
    var lineHeight = textStyle.lineHeight;
    if (lineHeight == null) return $6ceb7d0f0435c9d1$var$TOOLTIP_LINE_HEIGHT_CSS;
    else return "line-height:" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(lineHeight + '') + "px";
}
// TODO: more textStyle option
function $6ceb7d0f0435c9d1$var$getTooltipTextStyle(textStyle, renderMode) {
    var nameFontColor = textStyle.color || '#6e7079';
    var nameFontSize = textStyle.fontSize || 12;
    var nameFontWeight = textStyle.fontWeight || '400';
    var valueFontColor = textStyle.color || '#464646';
    var valueFontSize = textStyle.fontSize || 14;
    var valueFontWeight = textStyle.fontWeight || '900';
    if (renderMode === 'html') // `textStyle` is probably from user input, should be encoded to reduce security risk.
    return {
        // eslint-disable-next-line max-len
        nameStyle: "font-size:" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(nameFontSize + '') + "px;color:" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(nameFontColor) + ";font-weight:" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(nameFontWeight + ''),
        // eslint-disable-next-line max-len
        valueStyle: "font-size:" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(valueFontSize + '') + "px;color:" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(valueFontColor) + ";font-weight:" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(valueFontWeight + '')
    };
    else return {
        nameStyle: {
            fontSize: nameFontSize,
            fill: nameFontColor,
            fontWeight: nameFontWeight
        },
        valueStyle: {
            fontSize: valueFontSize,
            fill: valueFontColor,
            fontWeight: valueFontWeight
        }
    };
}
// See `TooltipMarkupLayoutIntent['innerGapLevel']`.
// (value from UI design)
var $6ceb7d0f0435c9d1$var$HTML_GAPS = [
    0,
    10,
    20,
    30
];
var $6ceb7d0f0435c9d1$var$RICH_TEXT_GAPS = [
    '',
    '\n',
    '\n\n',
    '\n\n\n'
];
function $6ceb7d0f0435c9d1$export$cf63b23ce77d1921(type, option) {
    option.type = type;
    return option;
}
function $6ceb7d0f0435c9d1$var$isSectionFragment(frag) {
    return frag.type === 'section';
}
function $6ceb7d0f0435c9d1$var$getBuilder(frag) {
    return $6ceb7d0f0435c9d1$var$isSectionFragment(frag) ? $6ceb7d0f0435c9d1$var$buildSection : $6ceb7d0f0435c9d1$var$buildNameValue;
}
function $6ceb7d0f0435c9d1$var$getBlockGapLevel(frag) {
    if ($6ceb7d0f0435c9d1$var$isSectionFragment(frag)) {
        var gapLevel_1 = 0;
        var subBlockLen = frag.blocks.length;
        var hasInnerGap_1 = subBlockLen > 1 || subBlockLen > 0 && !frag.noHeader;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(frag.blocks, function(subBlock) {
            var subGapLevel = $6ceb7d0f0435c9d1$var$getBlockGapLevel(subBlock);
            // If the some of the sub-blocks have some gaps (like 10px) inside, this block
            // should use a larger gap (like 20px) to distinguish those sub-blocks.
            if (subGapLevel >= gapLevel_1) gapLevel_1 = subGapLevel + +(hasInnerGap_1 && // 0 always can not be readable gap level.
            (!subGapLevel || $6ceb7d0f0435c9d1$var$isSectionFragment(subBlock) && !subBlock.noHeader));
        });
        return gapLevel_1;
    }
    return 0;
}
function $6ceb7d0f0435c9d1$var$buildSection(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var noHeader = fragment.noHeader;
    var gaps = $6ceb7d0f0435c9d1$var$getGap($6ceb7d0f0435c9d1$var$getBlockGapLevel(fragment));
    var subMarkupTextList = [];
    var subBlocks = fragment.blocks || [];
    (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(!subBlocks || (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(subBlocks));
    subBlocks = subBlocks || [];
    var orderMode = ctx.orderMode;
    if (fragment.sortBlocks && orderMode) {
        subBlocks = subBlocks.slice();
        var orderMap = {
            valueAsc: 'asc',
            valueDesc: 'desc'
        };
        if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(orderMap, orderMode)) {
            var comparator_1 = new (0, $b0b05721170d73df$export$ed75a5d7b0144167)(orderMap[orderMode], null);
            subBlocks.sort(function(a, b) {
                return comparator_1.evaluate(a.sortParam, b.sortParam);
            });
        } else if (orderMode === 'seriesDesc') subBlocks.reverse();
    }
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(subBlocks, function(subBlock, idx) {
        var valueFormatter = fragment.valueFormatter;
        var subMarkupText = $6ceb7d0f0435c9d1$var$getBuilder(subBlock)(// Inherit valueFormatter
        valueFormatter ? (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, ctx), {
            valueFormatter: valueFormatter
        }) : ctx, subBlock, idx > 0 ? gaps.html : 0, toolTipTextStyle);
        subMarkupText != null && subMarkupTextList.push(subMarkupText);
    });
    var subMarkupText = ctx.renderMode === 'richText' ? subMarkupTextList.join(gaps.richText) : $6ceb7d0f0435c9d1$var$wrapBlockHTML(toolTipTextStyle, subMarkupTextList.join(''), noHeader ? topMarginForOuterGap : gaps.html);
    if (noHeader) return subMarkupText;
    var displayableHeader = (0, $ff2fba995230f3c9$export$3cd8db88714decfc)(fragment.header, 'ordinal', ctx.useUTC);
    var nameStyle = $6ceb7d0f0435c9d1$var$getTooltipTextStyle(toolTipTextStyle, ctx.renderMode).nameStyle;
    var tooltipLineHeight = $6ceb7d0f0435c9d1$var$getTooltipLineHeight(toolTipTextStyle);
    if (ctx.renderMode === 'richText') return $6ceb7d0f0435c9d1$var$wrapInlineNameRichText(ctx, displayableHeader, nameStyle) + gaps.richText + subMarkupText;
    else return $6ceb7d0f0435c9d1$var$wrapBlockHTML(toolTipTextStyle, "<div style=\"" + nameStyle + ";" + tooltipLineHeight + ";\">" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(displayableHeader) + '</div>' + subMarkupText, topMarginForOuterGap);
}
function $6ceb7d0f0435c9d1$var$buildNameValue(ctx, fragment, topMarginForOuterGap, toolTipTextStyle) {
    var renderMode = ctx.renderMode;
    var noName = fragment.noName;
    var noValue = fragment.noValue;
    var noMarker = !fragment.markerType;
    var name = fragment.name;
    var useUTC = ctx.useUTC;
    var valueFormatter = fragment.valueFormatter || ctx.valueFormatter || function(value) {
        value = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(value) ? value : [
            value
        ];
        return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(value, function(val, idx) {
            return (0, $ff2fba995230f3c9$export$3cd8db88714decfc)(val, (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(valueTypeOption) ? valueTypeOption[idx] : valueTypeOption, useUTC);
        });
    };
    if (noName && noValue) return;
    var markerStr = noMarker ? '' : ctx.markupStyleCreator.makeTooltipMarker(fragment.markerType, fragment.markerColor || '#333', renderMode);
    var readableName = noName ? '' : (0, $ff2fba995230f3c9$export$3cd8db88714decfc)(name, 'ordinal', useUTC);
    var valueTypeOption = fragment.valueType;
    var readableValueList = noValue ? [] : valueFormatter(fragment.value, fragment.dataIndex);
    var valueAlignRight = !noMarker || !noName;
    // It little weird if only value next to marker but far from marker.
    var valueCloseToMarker = !noMarker && noName;
    var _a = $6ceb7d0f0435c9d1$var$getTooltipTextStyle(toolTipTextStyle, renderMode), nameStyle = _a.nameStyle, valueStyle = _a.valueStyle;
    return renderMode === 'richText' ? (noMarker ? '' : markerStr) + (noName ? '' : $6ceb7d0f0435c9d1$var$wrapInlineNameRichText(ctx, readableName, nameStyle)) + (noValue ? '' : $6ceb7d0f0435c9d1$var$wrapInlineValueRichText(ctx, readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)) : $6ceb7d0f0435c9d1$var$wrapBlockHTML(toolTipTextStyle, (noMarker ? '' : markerStr) + (noName ? '' : $6ceb7d0f0435c9d1$var$wrapInlineNameHTML(readableName, !noMarker, nameStyle)) + (noValue ? '' : $6ceb7d0f0435c9d1$var$wrapInlineValueHTML(readableValueList, valueAlignRight, valueCloseToMarker, valueStyle)), topMarginForOuterGap);
}
function $6ceb7d0f0435c9d1$export$6969ffb02c1cb49a(fragment, markupStyleCreator, renderMode, orderMode, useUTC, toolTipTextStyle) {
    if (!fragment) return;
    var builder = $6ceb7d0f0435c9d1$var$getBuilder(fragment);
    var ctx = {
        useUTC: useUTC,
        renderMode: renderMode,
        orderMode: orderMode,
        markupStyleCreator: markupStyleCreator,
        valueFormatter: fragment.valueFormatter
    };
    return builder(ctx, fragment, 0, toolTipTextStyle);
}
function $6ceb7d0f0435c9d1$var$getGap(gapLevel) {
    return {
        html: $6ceb7d0f0435c9d1$var$HTML_GAPS[gapLevel],
        richText: $6ceb7d0f0435c9d1$var$RICH_TEXT_GAPS[gapLevel]
    };
}
function $6ceb7d0f0435c9d1$var$wrapBlockHTML(textStyle, encodedContent, topGap) {
    var clearfix = '<div style="clear:both"></div>';
    var marginCSS = "margin: " + topGap + "px 0 0";
    var tooltipLineHeight = $6ceb7d0f0435c9d1$var$getTooltipLineHeight(textStyle);
    return "<div style=\"" + marginCSS + ";" + tooltipLineHeight + ";\">" + encodedContent + clearfix + '</div>';
}
function $6ceb7d0f0435c9d1$var$wrapInlineNameHTML(name, leftHasMarker, style) {
    var marginCss = leftHasMarker ? 'margin-left:2px' : '';
    return "<span style=\"" + style + ";" + marginCss + "\">" + (0, $8032584326d71745$export$f9d6449b9af28dc1)(name) + '</span>';
}
function $6ceb7d0f0435c9d1$var$wrapInlineValueHTML(valueList, alignRight, valueCloseToMarker, style) {
    // Do not too close to marker, considering there are multiple values separated by spaces.
    var paddingStr = valueCloseToMarker ? '10px' : '20px';
    var alignCSS = alignRight ? "float:right;margin-left:" + paddingStr : '';
    valueList = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(valueList) ? valueList : [
        valueList
    ];
    return "<span style=\"" + alignCSS + ";" + style + "\">" + (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(valueList, function(value) {
        return (0, $8032584326d71745$export$f9d6449b9af28dc1)(value);
    }).join('&nbsp;&nbsp;') + '</span>';
}
function $6ceb7d0f0435c9d1$var$wrapInlineNameRichText(ctx, name, style) {
    return ctx.markupStyleCreator.wrapRichTextStyle(name, style);
}
function $6ceb7d0f0435c9d1$var$wrapInlineValueRichText(ctx, values, alignRight, valueCloseToMarker, style) {
    var styles = [
        style
    ];
    var paddingLeft = valueCloseToMarker ? 10 : 20;
    alignRight && styles.push({
        padding: [
            0,
            0,
            0,
            paddingLeft
        ],
        align: 'right'
    });
    // Value has commas inside, so use '  ' as delimiter for multiple values.
    return ctx.markupStyleCreator.wrapRichTextStyle((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(values) ? values.join('  ') : values, styles);
}
function $6ceb7d0f0435c9d1$export$ea15628039c0fa93(series, dataIndex) {
    var style = series.getData().getItemVisual(dataIndex, 'style');
    var color = style[series.visualDrawType];
    return (0, $ff2fba995230f3c9$export$cda04d03233e5555)(color);
}
function $6ceb7d0f0435c9d1$export$3048212c802df496(model, renderMode) {
    var padding = model.get('padding');
    return padding != null ? padding : renderMode === 'richText' ? [
        8,
        10
    ] : 10;
}
/**
 * The major feature is generate styles for `renderMode: 'richText'`.
 * But it also serves `renderMode: 'html'` to provide
 * "renderMode-independent" API.
 */ var $6ceb7d0f0435c9d1$export$2fba3afbcdcf3e18 = /** @class */ function() {
    function TooltipMarkupStyleCreator() {
        this.richTextStyles = {};
        // Notice that "generate a style name" usually happens repeatedly when mouse is moving and
        // a tooltip is displayed. So we put the `_nextStyleNameId` as a member of each creator
        // rather than static shared by all creators (which will cause it increase to fast).
        this._nextStyleNameId = (0, $9fd90cf3bf18fbcd$export$474d2ec9aa44a22)();
    }
    TooltipMarkupStyleCreator.prototype._generateStyleName = function() {
        return '__EC_aUTo_' + this._nextStyleNameId++;
    };
    TooltipMarkupStyleCreator.prototype.makeTooltipMarker = function(markerType, colorStr, renderMode) {
        var markerId = renderMode === 'richText' ? this._generateStyleName() : null;
        var marker = (0, $ff2fba995230f3c9$export$1987a3dbdf3c45ca)({
            color: colorStr,
            type: markerType,
            renderMode: renderMode,
            markerId: markerId
        });
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(marker)) return marker;
        else {
            this.richTextStyles[markerId] = marker.style;
            return marker.content;
        }
    };
    /**
   * @usage
   * ```ts
   * const styledText = markupStyleCreator.wrapRichTextStyle([
   *     // The styles will be auto merged.
   *     {
   *         fontSize: 12,
   *         color: 'blue'
   *     },
   *     {
   *         padding: 20
   *     }
   * ]);
   * ```
   */ TooltipMarkupStyleCreator.prototype.wrapRichTextStyle = function(text, styles) {
        var finalStl = {};
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(styles)) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(styles, function(stl) {
            return (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(finalStl, stl);
        });
        else (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(finalStl, styles);
        var styleName = this._generateStyleName();
        this.richTextStyles[styleName] = finalStl;
        return "{" + styleName + "|" + text + "}";
    };
    return TooltipMarkupStyleCreator;
}();




function $61040f4cb7ee424a$export$3a110b9fb5c88b34(opt) {
    var series = opt.series;
    var dataIndex = opt.dataIndex;
    var multipleSeries = opt.multipleSeries;
    var data = series.getData();
    var tooltipDims = data.mapDimensionsAll('defaultedTooltip');
    var tooltipDimLen = tooltipDims.length;
    var value = series.getRawValue(dataIndex);
    var isValueArr = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(value);
    var markerColor = (0, $6ceb7d0f0435c9d1$export$ea15628039c0fa93)(series, dataIndex);
    // Complicated rule for pretty tooltip.
    var inlineValue;
    var inlineValueType;
    var subBlocks;
    var sortParam;
    if (tooltipDimLen > 1 || isValueArr && !tooltipDimLen) {
        var formatArrResult = $61040f4cb7ee424a$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, markerColor);
        inlineValue = formatArrResult.inlineValues;
        inlineValueType = formatArrResult.inlineValueTypes;
        subBlocks = formatArrResult.blocks;
        // Only support tooltip sort by the first inline value. It's enough in most cases.
        sortParam = formatArrResult.inlineValues[0];
    } else if (tooltipDimLen) {
        var dimInfo = data.getDimensionInfo(tooltipDims[0]);
        sortParam = inlineValue = (0, $a0d276c4568d5ef4$export$cde9373da9aad801)(data, dataIndex, tooltipDims[0]);
        inlineValueType = dimInfo.type;
    } else sortParam = inlineValue = isValueArr ? value[0] : value;
    // Do not show generated series name. It might not be readable.
    var seriesNameSpecified = (0, $9ac03c46e8b6e711$export$beae19a2652b3368)(series);
    var seriesName = seriesNameSpecified && series.name || '';
    var itemName = data.getName(dataIndex);
    var inlineName = multipleSeries ? seriesName : itemName;
    return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('section', {
        header: seriesName,
        // When series name is not specified, do not show a header line with only '-'.
        // This case always happens in tooltip.trigger: 'item'.
        noHeader: multipleSeries || !seriesNameSpecified,
        sortParam: sortParam,
        blocks: [
            (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                markerType: 'item',
                markerColor: markerColor,
                // Do not mix display seriesName and itemName in one tooltip,
                // which might confuses users.
                name: inlineName,
                // name dimension might be auto assigned, where the name might
                // be not readable. So we check trim here.
                noName: !(0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(inlineName),
                value: inlineValue,
                valueType: inlineValueType,
                dataIndex: dataIndex
            })
        ].concat(subBlocks || [])
    });
}
function $61040f4cb7ee424a$var$formatTooltipArrayValue(value, series, dataIndex, tooltipDims, colorStr) {
    // check: category-no-encode-has-axis-data in dataset.html
    var data = series.getData();
    var isValueMultipleLine = (0, $1b239fc9d3a2f8ae$export$533b26079ad0b4b)(value, function(isValueMultipleLine, val, idx) {
        var dimItem = data.getDimensionInfo(idx);
        return isValueMultipleLine = isValueMultipleLine || dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
    }, false);
    var inlineValues = [];
    var inlineValueTypes = [];
    var blocks = [];
    tooltipDims.length ? (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(tooltipDims, function(dim) {
        setEachItem((0, $a0d276c4568d5ef4$export$cde9373da9aad801)(data, dataIndex, dim), dim);
    }) : (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(value, setEachItem);
    function setEachItem(val, dim) {
        var dimInfo = data.getDimensionInfo(dim);
        // If `dimInfo.tooltip` is not set, show tooltip.
        if (!dimInfo || dimInfo.otherDims.tooltip === false) return;
        if (isValueMultipleLine) blocks.push((0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
            markerType: 'subItem',
            markerColor: colorStr,
            name: dimInfo.displayName,
            value: val,
            valueType: dimInfo.type
        }));
        else {
            inlineValues.push(val);
            inlineValueTypes.push(dimInfo.type);
        }
    }
    return {
        inlineValues: inlineValues,
        inlineValueTypes: inlineValueTypes,
        blocks: blocks
    };
}


var $19b580a0cd6e92eb$var$inner = $9ac03c46e8b6e711$export$64df9f8d92ae083f();
function $19b580a0cd6e92eb$var$getSelectionKey(data, dataIndex) {
    return data.getName(dataIndex) || data.getId(dataIndex);
}
var $19b580a0cd6e92eb$export$e960441116ae2799 = '__universalTransitionEnabled';
var $19b580a0cd6e92eb$var$SeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SeriesModel, _super);
    function SeriesModel() {
        // [Caution]: Because this class or desecendants can be used as `XXX.extend(subProto)`,
        // the class members must not be initialized in constructor or declaration place.
        // Otherwise there is bad case:
        //   class A {xxx = 1;}
        //   enableClassExtend(A);
        //   class B extends A {}
        //   var C = B.extend({xxx: 5});
        //   var c = new C();
        //   console.log(c.xxx); // expect 5 but always 1.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // ---------------------------------------
        // Props about data selection
        // ---------------------------------------
        _this._selectedDataIndicesMap = {};
        return _this;
    }
    SeriesModel.prototype.init = function(option, parentModel, ecModel) {
        this.seriesIndex = this.componentIndex;
        this.dataTask = (0, $00bdcd96204d1130$export$f7292ab7796be73c)({
            count: $19b580a0cd6e92eb$var$dataTaskCount,
            reset: $19b580a0cd6e92eb$var$dataTaskReset
        });
        this.dataTask.context = {
            model: this
        };
        this.mergeDefaultAndTheme(option, ecModel);
        var sourceManager = $19b580a0cd6e92eb$var$inner(this).sourceManager = new (0, $9b5faf969a385e96$export$af4db9ec7e200ea2)(this);
        sourceManager.prepareSource();
        var data = this.getInitialData(option, ecModel);
        $19b580a0cd6e92eb$var$wrapData(data, this);
        this.dataTask.context.data = data;
        $19b580a0cd6e92eb$var$inner(this).dataBeforeProcessed = data;
        // If we reverse the order (make data firstly, and then make
        // dataBeforeProcessed by cloneShallow), cloneShallow will
        // cause data.graph.data !== data when using
        // module:echarts/data/Graph or module:echarts/data/Tree.
        // See module:echarts/data/helper/linkSeriesData
        // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
        // init or merge stage, because the data can be restored. So we do not `restoreData`
        // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
        // Call `seriesModel.getRawData()` instead.
        // this.restoreData();
        $19b580a0cd6e92eb$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    /**
   * Util for merge default and theme to option
   */ SeriesModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
        var layoutMode = (0, $501dc28f6c4d24ac$export$3968a28a7cbd6063)(this);
        var inputPositionParams = layoutMode ? (0, $501dc28f6c4d24ac$export$4b0d20af19c9875e)(option) : {};
        // Backward compat: using subType on theme.
        // But if name duplicate between series subType
        // (for example: parallel) add component mainType,
        // add suffix 'Series'.
        var themeSubType = this.subType;
        if ((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).hasClass(themeSubType)) themeSubType += 'Series';
        $1b239fc9d3a2f8ae$export$4950aa0f605343fb(option, ecModel.getTheme().get(this.subType));
        $1b239fc9d3a2f8ae$export$4950aa0f605343fb(option, this.getDefaultOption());
        // Default label emphasis `show`
        $9ac03c46e8b6e711$export$abdcc6a26372f94b(option, 'label', [
            'show'
        ]);
        this.fillDataTextStyle(option.data);
        if (layoutMode) (0, $501dc28f6c4d24ac$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
    };
    SeriesModel.prototype.mergeOption = function(newSeriesOption, ecModel) {
        // this.settingTask.dirty();
        newSeriesOption = $1b239fc9d3a2f8ae$export$4950aa0f605343fb(this.option, newSeriesOption, true);
        this.fillDataTextStyle(newSeriesOption.data);
        var layoutMode = (0, $501dc28f6c4d24ac$export$3968a28a7cbd6063)(this);
        if (layoutMode) (0, $501dc28f6c4d24ac$export$1754cb91f16ca028)(this.option, newSeriesOption, layoutMode);
        var sourceManager = $19b580a0cd6e92eb$var$inner(this).sourceManager;
        sourceManager.dirty();
        sourceManager.prepareSource();
        var data = this.getInitialData(newSeriesOption, ecModel);
        $19b580a0cd6e92eb$var$wrapData(data, this);
        this.dataTask.dirty();
        this.dataTask.context.data = data;
        $19b580a0cd6e92eb$var$inner(this).dataBeforeProcessed = data;
        $19b580a0cd6e92eb$var$autoSeriesName(this);
        this._initSelectedMapFromData(data);
    };
    SeriesModel.prototype.fillDataTextStyle = function(data) {
        // Default data label emphasis `show`
        // FIXME Tree structure data ?
        // FIXME Performance ?
        if (data && !$1b239fc9d3a2f8ae$export$b119cc7e1840e59c(data)) {
            var props = [
                'show'
            ];
            for(var i = 0; i < data.length; i++)if (data[i] && data[i].label) $9ac03c46e8b6e711$export$abdcc6a26372f94b(data[i], 'label', props);
        }
    };
    /**
   * Init a data structure from data related option in series
   * Must be overridden.
   */ SeriesModel.prototype.getInitialData = function(option, ecModel) {
        return;
    };
    /**
   * Append data to list
   */ SeriesModel.prototype.appendData = function(params) {
        // FIXME ???
        // (1) If data from dataset, forbidden append.
        // (2) support append data of dataset.
        var data = this.getRawData();
        data.appendData(params.data);
    };
    /**
   * Consider some method like `filter`, `map` need make new data,
   * We should make sure that `seriesModel.getData()` get correct
   * data in the stream procedure. So we fetch data from upstream
   * each time `task.perform` called.
   */ SeriesModel.prototype.getData = function(dataType) {
        var task = $19b580a0cd6e92eb$var$getCurrentTask(this);
        if (task) {
            var data = task.context.data;
            return dataType == null || !data.getLinkedData ? data : data.getLinkedData(dataType);
        } else // When series is not alive (that may happen when click toolbox
        // restore or setOption with not merge mode), series data may
        // be still need to judge animation or something when graphic
        // elements want to know whether fade out.
        return $19b580a0cd6e92eb$var$inner(this).data;
    };
    SeriesModel.prototype.getAllData = function() {
        var mainData = this.getData();
        return mainData && mainData.getLinkedDataAll ? mainData.getLinkedDataAll() : [
            {
                data: mainData
            }
        ];
    };
    SeriesModel.prototype.setData = function(data) {
        var task = $19b580a0cd6e92eb$var$getCurrentTask(this);
        if (task) {
            var context = task.context;
            // Consider case: filter, data sample.
            // FIXME:TS never used, so comment it
            // if (context.data !== data && task.modifyOutputEnd) {
            //     task.setOutputEnd(data.count());
            // }
            context.outputData = data;
            // Caution: setData should update context.data,
            // Because getData may be called multiply in a
            // single stage and expect to get the data just
            // set. (For example, AxisProxy, x y both call
            // getData and setDate sequentially).
            // So the context.data should be fetched from
            // upstream each time when a stage starts to be
            // performed.
            if (task !== this.dataTask) context.data = data;
        }
        $19b580a0cd6e92eb$var$inner(this).data = data;
    };
    SeriesModel.prototype.getEncode = function() {
        var encode = this.get('encode', true);
        if (encode) return $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4(encode);
    };
    SeriesModel.prototype.getSourceManager = function() {
        return $19b580a0cd6e92eb$var$inner(this).sourceManager;
    };
    SeriesModel.prototype.getSource = function() {
        return this.getSourceManager().getSource();
    };
    /**
   * Get data before processed
   */ SeriesModel.prototype.getRawData = function() {
        return $19b580a0cd6e92eb$var$inner(this).dataBeforeProcessed;
    };
    SeriesModel.prototype.getColorBy = function() {
        var colorBy = this.get('colorBy');
        return colorBy || 'series';
    };
    SeriesModel.prototype.isColorBySeries = function() {
        return this.getColorBy() === 'series';
    };
    /**
   * Get base axis if has coordinate system and has axis.
   * By default use coordSys.getBaseAxis();
   * Can be overridden for some chart.
   * @return {type} description
   */ SeriesModel.prototype.getBaseAxis = function() {
        var coordSys = this.coordinateSystem;
        // @ts-ignore
        return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
    };
    /**
   * Default tooltip formatter
   *
   * @param dataIndex
   * @param multipleSeries
   * @param dataType
   * @param renderMode valid values: 'html'(by default) and 'richText'.
   *        'html' is used for rendering tooltip in extra DOM form, and the result
   *        string is used as DOM HTML content.
   *        'richText' is used for rendering tooltip in rich text form, for those where
   *        DOM operation is not supported.
   * @return formatted tooltip with `html` and `markers`
   *        Notice: The override method can also return string
   */ SeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        return (0, $61040f4cb7ee424a$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
    };
    SeriesModel.prototype.isAnimationEnabled = function() {
        var ecModel = this.ecModel;
        // Disable animation if using echarts in node but not give ssr flag.
        // In ssr mode, renderToString will generate svg with css animation.
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node && !(ecModel && ecModel.ssr)) return false;
        var animationEnabled = this.getShallow('animation');
        if (animationEnabled) {
            if (this.getData().count() > this.getShallow('animationThreshold')) animationEnabled = false;
        }
        return !!animationEnabled;
    };
    SeriesModel.prototype.restoreData = function() {
        this.dataTask.dirty();
    };
    SeriesModel.prototype.getColorFromPalette = function(name, scope, requestColorNum) {
        var ecModel = this.ecModel;
        // PENDING
        var color = (0, $6d8b6513f520ae7c$export$55a3c39e852b90f4).prototype.getColorFromPalette.call(this, name, scope, requestColorNum);
        if (!color) color = ecModel.getColorFromPalette(name, scope, requestColorNum);
        return color;
    };
    /**
   * Use `data.mapDimensionsAll(coordDim)` instead.
   * @deprecated
   */ SeriesModel.prototype.coordDimToDataDim = function(coordDim) {
        return this.getRawData().mapDimensionsAll(coordDim);
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressive = function() {
        return this.get('progressive');
    };
    /**
   * Get progressive rendering count each step
   */ SeriesModel.prototype.getProgressiveThreshold = function() {
        return this.get('progressiveThreshold');
    };
    // PENGING If selectedMode is null ?
    SeriesModel.prototype.select = function(innerDataIndices, dataType) {
        this._innerSelect(this.getData(dataType), innerDataIndices);
    };
    SeriesModel.prototype.unselect = function(innerDataIndices, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return;
        var selectedMode = this.option.selectedMode;
        var data = this.getData(dataType);
        if (selectedMode === 'series' || selectedMap === 'all') {
            this.option.selectedMap = {};
            this._selectedDataIndicesMap = {};
            return;
        }
        for(var i = 0; i < innerDataIndices.length; i++){
            var dataIndex = innerDataIndices[i];
            var nameOrId = $19b580a0cd6e92eb$var$getSelectionKey(data, dataIndex);
            selectedMap[nameOrId] = false;
            this._selectedDataIndicesMap[nameOrId] = -1;
        }
    };
    SeriesModel.prototype.toggleSelect = function(innerDataIndices, dataType) {
        var tmpArr = [];
        for(var i = 0; i < innerDataIndices.length; i++){
            tmpArr[0] = innerDataIndices[i];
            this.isSelected(innerDataIndices[i], dataType) ? this.unselect(tmpArr, dataType) : this.select(tmpArr, dataType);
        }
    };
    SeriesModel.prototype.getSelectedDataIndices = function() {
        if (this.option.selectedMap === 'all') return [].slice.call(this.getData().getIndices());
        var selectedDataIndicesMap = this._selectedDataIndicesMap;
        var nameOrIds = $1b239fc9d3a2f8ae$export$ed97f33186d4b816(selectedDataIndicesMap);
        var dataIndices = [];
        for(var i = 0; i < nameOrIds.length; i++){
            var dataIndex = selectedDataIndicesMap[nameOrIds[i]];
            if (dataIndex >= 0) dataIndices.push(dataIndex);
        }
        return dataIndices;
    };
    SeriesModel.prototype.isSelected = function(dataIndex, dataType) {
        var selectedMap = this.option.selectedMap;
        if (!selectedMap) return false;
        var data = this.getData(dataType);
        return (selectedMap === 'all' || selectedMap[$19b580a0cd6e92eb$var$getSelectionKey(data, dataIndex)]) && !data.getItemModel(dataIndex).get([
            'select',
            'disabled'
        ]);
    };
    SeriesModel.prototype.isUniversalTransitionEnabled = function() {
        if (this[$19b580a0cd6e92eb$export$e960441116ae2799]) return true;
        var universalTransitionOpt = this.option.universalTransition;
        // Quick reject
        if (!universalTransitionOpt) return false;
        if (universalTransitionOpt === true) return true;
        // Can be simply 'universalTransition: true'
        return universalTransitionOpt && universalTransitionOpt.enabled;
    };
    SeriesModel.prototype._innerSelect = function(data, innerDataIndices) {
        var _a, _b;
        var option = this.option;
        var selectedMode = option.selectedMode;
        var len = innerDataIndices.length;
        if (!selectedMode || !len) return;
        if (selectedMode === 'series') option.selectedMap = 'all';
        else if (selectedMode === 'multiple') {
            if (!$1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(option.selectedMap)) option.selectedMap = {};
            var selectedMap = option.selectedMap;
            for(var i = 0; i < len; i++){
                var dataIndex = innerDataIndices[i];
                // TODO different types of data share same object.
                var nameOrId = $19b580a0cd6e92eb$var$getSelectionKey(data, dataIndex);
                selectedMap[nameOrId] = true;
                this._selectedDataIndicesMap[nameOrId] = data.getRawIndex(dataIndex);
            }
        } else if (selectedMode === 'single' || selectedMode === true) {
            var lastDataIndex = innerDataIndices[len - 1];
            var nameOrId = $19b580a0cd6e92eb$var$getSelectionKey(data, lastDataIndex);
            option.selectedMap = (_a = {}, _a[nameOrId] = true, _a);
            this._selectedDataIndicesMap = (_b = {}, _b[nameOrId] = data.getRawIndex(lastDataIndex), _b);
        }
    };
    SeriesModel.prototype._initSelectedMapFromData = function(data) {
        // Ignore select info in data if selectedMap exists.
        // NOTE It's only for legacy usage. edge data is not supported.
        if (this.option.selectedMap) return;
        var dataIndices = [];
        if (data.hasItemOption) data.each(function(idx) {
            var rawItem = data.getRawDataItem(idx);
            if (rawItem && rawItem.selected) dataIndices.push(idx);
        });
        if (dataIndices.length > 0) this._innerSelect(data, dataIndices);
    };
    // /**
    //  * @see {module:echarts/stream/Scheduler}
    //  */
    // abstract pipeTask: null
    SeriesModel.registerClass = function(clz) {
        return (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).registerClass(clz);
    };
    SeriesModel.protoInitialize = function() {
        var proto = SeriesModel.prototype;
        proto.type = 'series.__base__';
        proto.seriesIndex = 0;
        proto.ignoreStyleOnData = false;
        proto.hasSymbolVisual = false;
        proto.defaultSymbol = 'circle';
        // Make sure the values can be accessed!
        proto.visualStyleAccessPath = 'itemStyle';
        proto.visualDrawType = 'fill';
    }();
    return SeriesModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($19b580a0cd6e92eb$var$SeriesModel, (0, $36ff81ce502a4a00$export$f23396ae04ea95a7));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($19b580a0cd6e92eb$var$SeriesModel, (0, $6d8b6513f520ae7c$export$55a3c39e852b90f4));
(0, $19c24724c14e5e48$export$c9c2d87774f1275d)($19b580a0cd6e92eb$var$SeriesModel, (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
/**
 * MUST be called after `prepareSource` called
 * Here we need to make auto series, especially for auto legend. But we
 * do not modify series.name in option to avoid side effects.
 */ function $19b580a0cd6e92eb$var$autoSeriesName(seriesModel) {
    // User specified name has higher priority, otherwise it may cause
    // series can not be queried unexpectedly.
    var name = seriesModel.name;
    if (!$9ac03c46e8b6e711$export$beae19a2652b3368(seriesModel)) seriesModel.name = $19b580a0cd6e92eb$var$getSeriesAutoName(seriesModel) || name;
}
function $19b580a0cd6e92eb$var$getSeriesAutoName(seriesModel) {
    var data = seriesModel.getRawData();
    var dataDims = data.mapDimensionsAll('seriesName');
    var nameArr = [];
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(dataDims, function(dataDim) {
        var dimInfo = data.getDimensionInfo(dataDim);
        dimInfo.displayName && nameArr.push(dimInfo.displayName);
    });
    return nameArr.join(' ');
}
function $19b580a0cd6e92eb$var$dataTaskCount(context) {
    return context.model.getRawData().count();
}
function $19b580a0cd6e92eb$var$dataTaskReset(context) {
    var seriesModel = context.model;
    seriesModel.setData(seriesModel.getRawData().cloneShallow());
    return $19b580a0cd6e92eb$var$dataTaskProgress;
}
function $19b580a0cd6e92eb$var$dataTaskProgress(param, context) {
    // Avoid repeat cloneShallow when data just created in reset.
    if (context.outputData && param.end > context.outputData.count()) context.model.getRawData().cloneShallow(context.outputData);
}
// TODO refactor
function $19b580a0cd6e92eb$var$wrapData(data, seriesModel) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43($1b239fc9d3a2f8ae$export$4fd8af2c48c43416(data.CHANGABLE_METHODS, data.DOWNSAMPLE_METHODS), function(methodName) {
        data.wrapMethod(methodName, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2($19b580a0cd6e92eb$var$onDataChange, seriesModel));
    });
}
function $19b580a0cd6e92eb$var$onDataChange(seriesModel, newList) {
    var task = $19b580a0cd6e92eb$var$getCurrentTask(seriesModel);
    if (task) // Consider case: filter, selectRange
    task.setOutputEnd((newList || this).count());
    return newList;
}
function $19b580a0cd6e92eb$var$getCurrentTask(seriesModel) {
    var scheduler = (seriesModel.ecModel || {}).scheduler;
    var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
    if (pipeline) {
        // When pipline finished, the currrentTask keep the last
        // task (renderTask).
        var task = pipeline.currentTask;
        if (task) {
            var agentStubMap = task.agentStubMap;
            if (agentStubMap) task = agentStubMap.get(seriesModel.uid);
        }
        return task;
    }
}
var $19b580a0cd6e92eb$export$2e2bcd8739ae039 = $19b580a0cd6e92eb$var$SeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8b851331e51a1131$var$ComponentView = /** @class */ function() {
    function ComponentView() {
        this.group = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
        this.uid = $4e8eadf530aecaff$export$6d2b3473b0986646('viewComponent');
    }
    ComponentView.prototype.init = function(ecModel, api) {};
    ComponentView.prototype.render = function(model, ecModel, api, payload) {};
    ComponentView.prototype.dispose = function(ecModel, api) {};
    ComponentView.prototype.updateView = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateLayout = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    ComponentView.prototype.updateVisual = function(model, ecModel, api, payload) {
    // Do nothing;
    };
    /**
   * Hook for toggle blur target series.
   * Can be used in marker for blur or leave blur the markers
   */ ComponentView.prototype.toggleBlurSeries = function(seriesModels, isBlur, ecModel) {
    // Do nothing;
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ComponentView.prototype.eachRendered = function(cb) {
        var group = this.group;
        if (group) group.traverse(cb);
    };
    return ComponentView;
}();
$19c24724c14e5e48$export$cd4c3a4dca301c70($8b851331e51a1131$var$ComponentView);
$19c24724c14e5e48$export$241315e45585454d($8b851331e51a1131$var$ComponentView);
var $8b851331e51a1131$export$2e2bcd8739ae039 = $8b851331e51a1131$var$ComponentView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $0041f1ab5f0fd789$export$2e2bcd8739ae039() {
    var inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
    return function(seriesModel) {
        var fields = inner(seriesModel);
        var pipelineContext = seriesModel.pipelineContext;
        var originalLarge = !!fields.large;
        var originalProgressive = !!fields.progressiveRender;
        // FIXME: if the planner works on a filtered series, `pipelineContext` does not
        // exists. See #11611 . Probably we need to modify this structure, see the comment
        // on `performRawSeries` in `Schedular.js`.
        var large = fields.large = !!(pipelineContext && pipelineContext.large);
        var progressive = fields.progressiveRender = !!(pipelineContext && pipelineContext.progressiveRender);
        return !!(originalLarge !== large || originalProgressive !== progressive) && 'reset';
    };
}




var $80462d4f8a33fa64$var$inner = $9ac03c46e8b6e711$export$64df9f8d92ae083f();
var $80462d4f8a33fa64$var$renderPlanner = (0, $0041f1ab5f0fd789$export$2e2bcd8739ae039)();
var $80462d4f8a33fa64$var$ChartView = /** @class */ function() {
    function ChartView() {
        this.group = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
        this.uid = $4e8eadf530aecaff$export$6d2b3473b0986646('viewChart');
        this.renderTask = (0, $00bdcd96204d1130$export$f7292ab7796be73c)({
            plan: $80462d4f8a33fa64$var$renderTaskPlan,
            reset: $80462d4f8a33fa64$var$renderTaskReset
        });
        this.renderTask.context = {
            view: this
        };
    }
    ChartView.prototype.init = function(ecModel, api) {};
    ChartView.prototype.render = function(seriesModel, ecModel, api, payload) {};
    /**
   * Highlight series or specified data item.
   */ ChartView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $80462d4f8a33fa64$var$toggleHighlight(data, payload, 'emphasis');
    };
    /**
   * Downplay series or specified data item.
   */ ChartView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData(payload && payload.dataType);
        if (!data) return;
        $80462d4f8a33fa64$var$toggleHighlight(data, payload, 'normal');
    };
    /**
   * Remove self.
   */ ChartView.prototype.remove = function(ecModel, api) {
        this.group.removeAll();
    };
    /**
   * Dispose self.
   */ ChartView.prototype.dispose = function(ecModel, api) {};
    ChartView.prototype.updateView = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateLayout = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    // FIXME never used?
    ChartView.prototype.updateVisual = function(seriesModel, ecModel, api, payload) {
        this.render(seriesModel, ecModel, api, payload);
    };
    /**
   * Traverse the new rendered elements.
   *
   * It will traverse the new added element in progressive rendering.
   * And traverse all in normal rendering.
   */ ChartView.prototype.eachRendered = function(cb) {
        (0, $8eb95236e1aa01e7$export$3e564442729bf048)(this.group, cb);
    };
    ChartView.markUpdateMethod = function(payload, methodName) {
        $80462d4f8a33fa64$var$inner(payload).updateMethod = methodName;
    };
    ChartView.protoInitialize = function() {
        var proto = ChartView.prototype;
        proto.type = 'chart';
    }();
    return ChartView;
}();
/**
 * Set state of single element
 */ function $80462d4f8a33fa64$var$elSetState(el, state, highlightDigit) {
    if (el && (0, $b414df7d361a211c$export$77d1445f699c58b5)(el)) (state === 'emphasis' ? (0, $b414df7d361a211c$export$b2d02638cc34c042) : (0, $b414df7d361a211c$export$11be6f716239ac55))(el, highlightDigit);
}
function $80462d4f8a33fa64$var$toggleHighlight(data, payload, state) {
    var dataIndex = $9ac03c46e8b6e711$export$42b26cae8b8d10(data, payload);
    var highlightDigit = payload && payload.highlightKey != null ? (0, $b414df7d361a211c$export$824af40eb714530d)(payload.highlightKey) : null;
    if (dataIndex != null) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($9ac03c46e8b6e711$export$4f07b212a02c8051(dataIndex), function(dataIdx) {
        $80462d4f8a33fa64$var$elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
    });
    else data.eachItemGraphicEl(function(el) {
        $80462d4f8a33fa64$var$elSetState(el, state, highlightDigit);
    });
}
$19c24724c14e5e48$export$cd4c3a4dca301c70($80462d4f8a33fa64$var$ChartView, [
    'dispose'
]);
$19c24724c14e5e48$export$241315e45585454d($80462d4f8a33fa64$var$ChartView);
function $80462d4f8a33fa64$var$renderTaskPlan(context) {
    return $80462d4f8a33fa64$var$renderPlanner(context.model);
}
function $80462d4f8a33fa64$var$renderTaskReset(context) {
    var seriesModel = context.model;
    var ecModel = context.ecModel;
    var api = context.api;
    var payload = context.payload;
    // FIXME: remove updateView updateVisual
    var progressiveRender = seriesModel.pipelineContext.progressiveRender;
    var view = context.view;
    var updateMethod = payload && $80462d4f8a33fa64$var$inner(payload).updateMethod;
    var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod : 'render';
    if (methodName !== 'render') view[methodName](seriesModel, ecModel, api, payload);
    return $80462d4f8a33fa64$var$progressMethodMap[methodName];
}
var $80462d4f8a33fa64$var$progressMethodMap = {
    incrementalPrepareRender: {
        progress: function(params, context) {
            context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
        }
    },
    render: {
        // Put view.render in `progress` to support appendData. But in this case
        // view.render should not be called in reset, otherwise it will be called
        // twise. Use `forceFirstProgress` to make sure that view.render is called
        // in any cases.
        forceFirstProgress: true,
        progress: function(params, context) {
            context.view.render(context.model, context.ecModel, context.api, context.payload);
        }
    }
};
var $80462d4f8a33fa64$export$2e2bcd8739ae039 = $80462d4f8a33fa64$var$ChartView;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $ef22ba67fe7cfc59$var$ORIGIN_METHOD = '\0__throttleOriginMethod';
var $ef22ba67fe7cfc59$var$RATE = '\0__throttleRate';
var $ef22ba67fe7cfc59$var$THROTTLE_TYPE = '\0__throttleType';
function $ef22ba67fe7cfc59$export$de363e709c412c8a(fn, delay, debounce) {
    var currCall;
    var lastCall = 0;
    var lastExec = 0;
    var timer = null;
    var diff;
    var scope;
    var args;
    var debounceNextCall;
    delay = delay || 0;
    function exec() {
        lastExec = new Date().getTime();
        timer = null;
        fn.apply(scope, args || []);
    }
    var cb = function() {
        var cbArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)cbArgs[_i] = arguments[_i];
        currCall = new Date().getTime();
        scope = this;
        args = cbArgs;
        var thisDelay = debounceNextCall || delay;
        var thisDebounce = debounceNextCall || debounce;
        debounceNextCall = null;
        diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
        clearTimeout(timer);
        // Here we should make sure that: the `exec` SHOULD NOT be called later
        // than a new call of `cb`, that is, preserving the command order. Consider
        // calculating "scale rate" when roaming as an example. When a call of `cb`
        // happens, either the `exec` is called dierectly, or the call is delayed.
        // But the delayed call should never be later than next call of `cb`. Under
        // this assurance, we can simply update view state each time `dispatchAction`
        // triggered by user roaming, but not need to add extra code to avoid the
        // state being "rolled-back".
        if (thisDebounce) timer = setTimeout(exec, thisDelay);
        else if (diff >= 0) exec();
        else timer = setTimeout(exec, -diff);
        lastCall = currCall;
    };
    /**
   * Clear throttle.
   * @public
   */ cb.clear = function() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    };
    /**
   * Enable debounce once.
   */ cb.debounceNextCall = function(debounceDelay) {
        debounceNextCall = debounceDelay;
    };
    return cb;
}
function $ef22ba67fe7cfc59$export$958e3e1a02eac4b6(obj, fnAttr, rate, throttleType) {
    var fn = obj[fnAttr];
    if (!fn) return;
    var originFn = fn[$ef22ba67fe7cfc59$var$ORIGIN_METHOD] || fn;
    var lastThrottleType = fn[$ef22ba67fe7cfc59$var$THROTTLE_TYPE];
    var lastRate = fn[$ef22ba67fe7cfc59$var$RATE];
    if (lastRate !== rate || lastThrottleType !== throttleType) {
        if (rate == null || !throttleType) return obj[fnAttr] = originFn;
        fn = obj[fnAttr] = $ef22ba67fe7cfc59$export$de363e709c412c8a(originFn, rate, throttleType === 'debounce');
        fn[$ef22ba67fe7cfc59$var$ORIGIN_METHOD] = originFn;
        fn[$ef22ba67fe7cfc59$var$THROTTLE_TYPE] = throttleType;
        fn[$ef22ba67fe7cfc59$var$RATE] = rate;
    }
    return fn;
}
function $ef22ba67fe7cfc59$export$42ffd38884aecdac(obj, fnAttr) {
    var fn = obj[fnAttr];
    if (fn && fn[$ef22ba67fe7cfc59$var$ORIGIN_METHOD]) {
        // Clear throttle
        fn.clear && fn.clear();
        obj[fnAttr] = fn[$ef22ba67fe7cfc59$var$ORIGIN_METHOD];
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $692c090e846c7b27$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $692c090e846c7b27$var$defaultStyleMappers = {
    itemStyle: (0, $8555b33f89f2677c$export$2e2bcd8739ae039)((0, $af85fd575926d85b$export$ffb0bba5dde0130b), true),
    lineStyle: (0, $8555b33f89f2677c$export$2e2bcd8739ae039)((0, $bfbaffcfb5351f33$export$9f34de5b59222949), true)
};
var $692c090e846c7b27$var$defaultColorKey = {
    lineStyle: 'stroke',
    itemStyle: 'fill'
};
function $692c090e846c7b27$var$getStyleMapper(seriesModel, stylePath) {
    var styleMapper = seriesModel.visualStyleMapper || $692c090e846c7b27$var$defaultStyleMappers[stylePath];
    if (!styleMapper) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return $692c090e846c7b27$var$defaultStyleMappers.itemStyle;
    }
    return styleMapper;
}
function $692c090e846c7b27$var$getDefaultColorKey(seriesModel, stylePath) {
    // return defaultColorKey[stylePath] ||
    var colorKey = seriesModel.visualDrawType || $692c090e846c7b27$var$defaultColorKey[stylePath];
    if (!colorKey) {
        console.warn("Unknown style type '" + stylePath + "'.");
        return 'fill';
    }
    return colorKey;
}
var $692c090e846c7b27$export$7ce4d65f9b69240 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var styleModel = seriesModel.getModel(stylePath);
        var getStyle = $692c090e846c7b27$var$getStyleMapper(seriesModel, stylePath);
        var globalStyle = getStyle(styleModel);
        var decalOption = styleModel.getShallow('decal');
        if (decalOption) {
            data.setVisual('decal', decalOption);
            decalOption.dirty = true;
        }
        // TODO
        var colorKey = $692c090e846c7b27$var$getDefaultColorKey(seriesModel, stylePath);
        var color = globalStyle[colorKey];
        // TODO style callback
        var colorCallback = (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(color) ? color : null;
        var hasAutoColor = globalStyle.fill === 'auto' || globalStyle.stroke === 'auto';
        // Get from color palette by default.
        if (!globalStyle[colorKey] || colorCallback || hasAutoColor) {
            // Note: If some series has color specified (e.g., by itemStyle.color), we DO NOT
            // make it effect palette. Because some scenarios users need to make some series
            // transparent or as background, which should better not effect the palette.
            var colorPalette = seriesModel.getColorFromPalette(// TODO series count changed.
            seriesModel.name, null, ecModel.getSeriesCount());
            if (!globalStyle[colorKey]) {
                globalStyle[colorKey] = colorPalette;
                data.setVisual('colorFromPalette', true);
            }
            globalStyle.fill = globalStyle.fill === 'auto' || (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(globalStyle.fill) ? colorPalette : globalStyle.fill;
            globalStyle.stroke = globalStyle.stroke === 'auto' || (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(globalStyle.stroke) ? colorPalette : globalStyle.stroke;
        }
        data.setVisual('style', globalStyle);
        data.setVisual('drawType', colorKey);
        // Only visible series has each data be visual encoded
        if (!ecModel.isSeriesFiltered(seriesModel) && colorCallback) {
            data.setVisual('colorFromPalette', false);
            return {
                dataEach: function(data, idx) {
                    var dataParams = seriesModel.getDataParams(idx);
                    var itemStyle = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, globalStyle);
                    itemStyle[colorKey] = colorCallback(dataParams);
                    data.setItemVisual(idx, 'style', itemStyle);
                }
            };
        }
    }
};
var $692c090e846c7b27$var$sharedModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)();
var $692c090e846c7b27$export$f7dcb66a065003d1 = {
    createOnAllSeries: true,
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (seriesModel.ignoreStyleOnData || ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
        // Set in itemStyle
        var getStyle = $692c090e846c7b27$var$getStyleMapper(seriesModel, stylePath);
        var colorKey = data.getVisual('drawType');
        return {
            dataEach: data.hasItemOption ? function(data, idx) {
                // Not use getItemModel for performance considuration
                var rawItem = data.getRawDataItem(idx);
                if (rawItem && rawItem[stylePath]) {
                    $692c090e846c7b27$var$sharedModel.option = rawItem[stylePath];
                    var style = getStyle($692c090e846c7b27$var$sharedModel);
                    var existsStyle = data.ensureUniqueItemVisual(idx, 'style');
                    (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(existsStyle, style);
                    if ($692c090e846c7b27$var$sharedModel.option.decal) {
                        data.setItemVisual(idx, 'decal', $692c090e846c7b27$var$sharedModel.option.decal);
                        $692c090e846c7b27$var$sharedModel.option.decal.dirty = true;
                    }
                    if (colorKey in style) data.setItemVisual(idx, 'colorFromPalette', false);
                }
            } : null
        };
    }
};
// Pick color from palette for the data which has not been set with color yet.
// Note: do not support stream rendering. No such cases yet.
var $692c090e846c7b27$export$cf9758b0d6dc0aa9 = {
    performRawSeries: true,
    overallReset: function(ecModel) {
        // Each type of series uses one scope.
        // Pie and funnel are using different scopes.
        var paletteScopeGroupByType = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var colorBy = seriesModel.getColorBy();
            if (seriesModel.isColorBySeries()) return;
            var key = seriesModel.type + '-' + colorBy;
            var colorScope = paletteScopeGroupByType.get(key);
            if (!colorScope) {
                colorScope = {};
                paletteScopeGroupByType.set(key, colorScope);
            }
            $692c090e846c7b27$var$inner(seriesModel).scope = colorScope;
        });
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.isColorBySeries() || ecModel.isSeriesFiltered(seriesModel)) return;
            var dataAll = seriesModel.getRawData();
            var idxMap = {};
            var data = seriesModel.getData();
            var colorScope = $692c090e846c7b27$var$inner(seriesModel).scope;
            var stylePath = seriesModel.visualStyleAccessPath || 'itemStyle';
            var colorKey = $692c090e846c7b27$var$getDefaultColorKey(seriesModel, stylePath);
            data.each(function(idx) {
                var rawIdx = data.getRawIndex(idx);
                idxMap[rawIdx] = idx;
            });
            // Iterate on data before filtered. To make sure color from palette can be
            // Consistent when toggling legend.
            dataAll.each(function(rawIdx) {
                var idx = idxMap[rawIdx];
                var fromPalette = data.getItemVisual(idx, 'colorFromPalette');
                // Get color from palette for each data only when the color is inherited from series color, which is
                // also picked from color palette. So following situation is not in the case:
                // 1. series.itemStyle.color is set
                // 2. color is encoded by visualMap
                if (fromPalette) {
                    var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                    var name_1 = dataAll.getName(rawIdx) || rawIdx + '';
                    var dataCount = dataAll.count();
                    itemStyle[colorKey] = seriesModel.getColorFromPalette(name_1, colorScope, dataCount);
                }
            });
        });
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $c6c3cc1948dfb8e5$var$PI = Math.PI;
function $c6c3cc1948dfb8e5$export$2e2bcd8739ae039(api, opts) {
    opts = opts || {};
    $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(opts, {
        text: 'loading',
        textColor: '#000',
        fontSize: 12,
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontFamily: 'sans-serif',
        maskColor: 'rgba(255, 255, 255, 0.8)',
        showSpinner: true,
        color: '#5470c6',
        spinnerRadius: 10,
        lineWidth: 5,
        zlevel: 0
    });
    var group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
    var mask = new $37476269d425e3f6$export$2e2bcd8739ae039({
        style: {
            fill: opts.maskColor
        },
        zlevel: opts.zlevel,
        z: 10000
    });
    group.add(mask);
    var textContent = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
        style: {
            text: opts.text,
            fill: opts.textColor,
            fontSize: opts.fontSize,
            fontWeight: opts.fontWeight,
            fontStyle: opts.fontStyle,
            fontFamily: opts.fontFamily
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    var labelRect = new $37476269d425e3f6$export$2e2bcd8739ae039({
        style: {
            fill: 'none'
        },
        textContent: textContent,
        textConfig: {
            position: 'right',
            distance: 10
        },
        zlevel: opts.zlevel,
        z: 10001
    });
    group.add(labelRect);
    var arc;
    if (opts.showSpinner) {
        arc = new $5be9485ee0d860f6$export$2e2bcd8739ae039({
            shape: {
                startAngle: -$c6c3cc1948dfb8e5$var$PI / 2,
                endAngle: -$c6c3cc1948dfb8e5$var$PI / 2 + 0.1,
                r: opts.spinnerRadius
            },
            style: {
                stroke: opts.color,
                lineCap: 'round',
                lineWidth: opts.lineWidth
            },
            zlevel: opts.zlevel,
            z: 10001
        });
        arc.animateShape(true).when(1000, {
            endAngle: $c6c3cc1948dfb8e5$var$PI * 3 / 2
        }).start('circularInOut');
        arc.animateShape(true).when(1000, {
            startAngle: $c6c3cc1948dfb8e5$var$PI * 3 / 2
        }).delay(300).start('circularInOut');
        group.add(arc);
    }
    // Inject resize
    group.resize = function() {
        var textWidth = textContent.getBoundingRect().width;
        var r = opts.showSpinner ? opts.spinnerRadius : 0;
        // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
        // textDistance needs to be calculated when both animation and text exist
        var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 - (opts.showSpinner && textWidth ? 0 : 5 + textWidth / 2) + (opts.showSpinner ? 0 : textWidth / 2) + (textWidth ? 0 : r);
        var cy = api.getHeight() / 2;
        opts.showSpinner && arc.setShape({
            cx: cx,
            cy: cy
        });
        labelRect.setShape({
            x: cx - r,
            y: cy - r,
            width: r * 2,
            height: r * 2
        });
        mask.setShape({
            x: 0,
            y: 0,
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    group.resize();
    return group;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $930979848c1a297c$var$Scheduler = /** @class */ function() {
    function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
        // key: handlerUID
        this._stageTaskMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        this.ecInstance = ecInstance;
        this.api = api;
        // Fix current processors in case that in some rear cases that
        // processors might be registered after echarts instance created.
        // Register processors incrementally for a echarts instance is
        // not supported by this stream architecture.
        dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
        visualHandlers = this._visualHandlers = visualHandlers.slice();
        this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
    }
    Scheduler.prototype.restoreData = function(ecModel, payload) {
        // TODO: Only restore needed series and components, but not all components.
        // Currently `restoreData` of all of the series and component will be called.
        // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
        // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
        // and some components like coordinate system, axes, dataZoom, visualMap only
        // need their target series refresh.
        // (1) If we are implementing this feature some day, we should consider these cases:
        // if a data processor depends on a component (e.g., dataZoomProcessor depends
        // on the settings of `dataZoom`), it should be re-performed if the component
        // is modified by `setOption`.
        // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
        // it should be re-performed when the result array of `getTargetSeries` changed.
        // We use `dependencies` to cover these issues.
        // (3) How to update target series when coordinate system related components modified.
        // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
        // and this case all of the tasks will be set as dirty.
        ecModel.restoreData(payload);
        // Theoretically an overall task not only depends on each of its target series, but also
        // depends on all of the series.
        // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
        // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
        // that the overall task is set as dirty and to be performed, otherwise it probably cause
        // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
        // probably cause state chaos (consider `dataZoomProcessor`).
        this._stageTaskMap.each(function(taskRecord) {
            var overallTask = taskRecord.overallTask;
            overallTask && overallTask.dirty();
        });
    };
    // If seriesModel provided, incremental threshold is check by series data.
    Scheduler.prototype.getPerformArgs = function(task, isBlock) {
        // For overall task
        if (!task.__pipeline) return;
        var pipeline = this._pipelineMap.get(task.__pipeline.id);
        var pCtx = pipeline.context;
        var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
        var step = incremental ? pipeline.step : null;
        var modDataCount = pCtx && pCtx.modDataCount;
        var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
        return {
            step: step,
            modBy: modBy,
            modDataCount: modDataCount
        };
    };
    Scheduler.prototype.getPipeline = function(pipelineId) {
        return this._pipelineMap.get(pipelineId);
    };
    /**
   * Current, progressive rendering starts from visual and layout.
   * Always detect render mode in the same stage, avoiding that incorrect
   * detection caused by data filtering.
   * Caution:
   * `updateStreamModes` use `seriesModel.getData()`.
   */ Scheduler.prototype.updateStreamModes = function(seriesModel, view) {
        var pipeline = this._pipelineMap.get(seriesModel.uid);
        var data = seriesModel.getData();
        var dataLen = data.count();
        // `progressiveRender` means that can render progressively in each
        // animation frame. Note that some types of series do not provide
        // `view.incrementalPrepareRender` but support `chart.appendData`. We
        // use the term `incremental` but not `progressive` to describe the
        // case that `chart.appendData`.
        var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
        var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold');
        // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
        // see `test/candlestick-large3.html`
        var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
        seriesModel.pipelineContext = pipeline.context = {
            progressiveRender: progressiveRender,
            modDataCount: modDataCount,
            large: large
        };
    };
    Scheduler.prototype.restorePipelines = function(ecModel) {
        var scheduler = this;
        var pipelineMap = scheduler._pipelineMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        ecModel.eachSeries(function(seriesModel) {
            var progressive = seriesModel.getProgressive();
            var pipelineId = seriesModel.uid;
            pipelineMap.set(pipelineId, {
                id: pipelineId,
                head: null,
                tail: null,
                threshold: seriesModel.getProgressiveThreshold(),
                progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
                blockIndex: -1,
                step: Math.round(progressive || 700),
                count: 0
            });
            scheduler._pipe(seriesModel, seriesModel.dataTask);
        });
    };
    Scheduler.prototype.prepareStageTasks = function() {
        var stageTaskMap = this._stageTaskMap;
        var ecModel = this.api.getModel();
        var api = this.api;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._allHandlers, function(handler) {
            var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, {});
            var errMsg = '';
            (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(!(handler.reset && handler.overallReset), errMsg);
            handler.reset && this._createSeriesStageTask(handler, record, ecModel, api);
            handler.overallReset && this._createOverallStageTask(handler, record, ecModel, api);
        }, this);
    };
    Scheduler.prototype.prepareView = function(view, model, ecModel, api) {
        var renderTask = view.renderTask;
        var context = renderTask.context;
        context.model = model;
        context.ecModel = ecModel;
        context.api = api;
        renderTask.__block = !view.incrementalPrepareRender;
        this._pipe(model, renderTask);
    };
    Scheduler.prototype.performDataProcessorTasks = function(ecModel, payload) {
        // If we do not use `block` here, it should be considered when to update modes.
        this._performStageTasks(this._dataProcessorHandlers, ecModel, payload, {
            block: true
        });
    };
    Scheduler.prototype.performVisualTasks = function(ecModel, payload, opt) {
        this._performStageTasks(this._visualHandlers, ecModel, payload, opt);
    };
    Scheduler.prototype._performStageTasks = function(stageHandlers, ecModel, payload, opt) {
        opt = opt || {};
        var unfinished = false;
        var scheduler = this;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(stageHandlers, function(stageHandler, idx) {
            if (opt.visualType && opt.visualType !== stageHandler.visualType) return;
            var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
            var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
            var overallTask = stageHandlerRecord.overallTask;
            if (overallTask) {
                var overallNeedDirty_1;
                var agentStubMap = overallTask.agentStubMap;
                agentStubMap.each(function(stub) {
                    if (needSetDirty(opt, stub)) {
                        stub.dirty();
                        overallNeedDirty_1 = true;
                    }
                });
                overallNeedDirty_1 && overallTask.dirty();
                scheduler.updatePayload(overallTask, payload);
                var performArgs_1 = scheduler.getPerformArgs(overallTask, opt.block);
                // Execute stubs firstly, which may set the overall task dirty,
                // then execute the overall task. And stub will call seriesModel.setData,
                // which ensures that in the overallTask seriesModel.getData() will not
                // return incorrect data.
                agentStubMap.each(function(stub) {
                    stub.perform(performArgs_1);
                });
                if (overallTask.perform(performArgs_1)) unfinished = true;
            } else if (seriesTaskMap) seriesTaskMap.each(function(task, pipelineId) {
                if (needSetDirty(opt, task)) task.dirty();
                var performArgs = scheduler.getPerformArgs(task, opt.block);
                // FIXME
                // if intending to declare `performRawSeries` in handlers, only
                // stream-independent (specifically, data item independent) operations can be
                // performed. Because if a series is filtered, most of the tasks will not
                // be performed. A stream-dependent operation probably cause wrong biz logic.
                // Perhaps we should not provide a separate callback for this case instead
                // of providing the config `performRawSeries`. The stream-dependent operations
                // and stream-independent operations should better not be mixed.
                performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
                scheduler.updatePayload(task, payload);
                if (task.perform(performArgs)) unfinished = true;
            });
        });
        function needSetDirty(opt, task) {
            return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
        }
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.performSeriesTasks = function(ecModel) {
        var unfinished;
        ecModel.eachSeries(function(seriesModel) {
            // Progress to the end for dataInit and dataRestore.
            unfinished = seriesModel.dataTask.perform() || unfinished;
        });
        this.unfinished = unfinished || this.unfinished;
    };
    Scheduler.prototype.plan = function() {
        // Travel pipelines, check block.
        this._pipelineMap.each(function(pipeline) {
            var task = pipeline.tail;
            do {
                if (task.__block) {
                    pipeline.blockIndex = task.__idxInPipeline;
                    break;
                }
                task = task.getUpstream();
            }while (task);
        });
    };
    Scheduler.prototype.updatePayload = function(task, payload) {
        payload !== 'remain' && (task.context.payload = payload);
    };
    Scheduler.prototype._createSeriesStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var oldSeriesTaskMap = stageHandlerRecord.seriesTaskMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newSeriesTaskMap = stageHandlerRecord.seriesTaskMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
        // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
        // it works but it may cause other irrelevant charts blocked.
        if (stageHandler.createOnAllSeries) ecModel.eachRawSeries(create);
        else if (seriesType) ecModel.eachRawSeriesByType(seriesType, create);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(create);
        function create(seriesModel) {
            var pipelineId = seriesModel.uid;
            // Init tasks for each seriesModel only once.
            // Reuse original task instance.
            var task = newSeriesTaskMap.set(pipelineId, oldSeriesTaskMap && oldSeriesTaskMap.get(pipelineId) || (0, $00bdcd96204d1130$export$f7292ab7796be73c)({
                plan: $930979848c1a297c$var$seriesTaskPlan,
                reset: $930979848c1a297c$var$seriesTaskReset,
                count: $930979848c1a297c$var$seriesTaskCount
            }));
            task.context = {
                model: seriesModel,
                ecModel: ecModel,
                api: api,
                // PENDING: `useClearVisual` not used?
                useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
                plan: stageHandler.plan,
                reset: stageHandler.reset,
                scheduler: scheduler
            };
            scheduler._pipe(seriesModel, task);
        }
    };
    Scheduler.prototype._createOverallStageTask = function(stageHandler, stageHandlerRecord, ecModel, api) {
        var scheduler = this;
        var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask || (0, $00bdcd96204d1130$export$f7292ab7796be73c)({
            reset: $930979848c1a297c$var$overallTaskReset
        });
        overallTask.context = {
            ecModel: ecModel,
            api: api,
            overallReset: stageHandler.overallReset,
            scheduler: scheduler
        };
        var oldAgentStubMap = overallTask.agentStubMap;
        // The count of stages are totally about only several dozen, so
        // do not need to reuse the map.
        var newAgentStubMap = overallTask.agentStubMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        var seriesType = stageHandler.seriesType;
        var getTargetSeries = stageHandler.getTargetSeries;
        var overallProgress = true;
        var shouldOverallTaskDirty = false;
        // FIXME:TS never used, so comment it
        // let modifyOutputEnd = stageHandler.modifyOutputEnd;
        // An overall task with seriesType detected or has `getTargetSeries`, we add
        // stub in each pipelines, it will set the overall task dirty when the pipeline
        // progress. Moreover, to avoid call the overall task each frame (too frequent),
        // we set the pipeline block.
        var errMsg = '';
        (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(!stageHandler.createOnAllSeries, errMsg);
        if (seriesType) ecModel.eachRawSeriesByType(seriesType, createStub);
        else if (getTargetSeries) getTargetSeries(ecModel, api).each(createStub);
        else {
            overallProgress = false;
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(ecModel.getSeries(), createStub);
        }
        function createStub(seriesModel) {
            var pipelineId = seriesModel.uid;
            var stub = newAgentStubMap.set(pipelineId, oldAgentStubMap && oldAgentStubMap.get(pipelineId) || // When the result of `getTargetSeries` changed, the overallTask
            // should be set as dirty and re-performed.
            (shouldOverallTaskDirty = true, (0, $00bdcd96204d1130$export$f7292ab7796be73c)({
                reset: $930979848c1a297c$var$stubReset,
                onDirty: $930979848c1a297c$var$stubOnDirty
            })));
            stub.context = {
                model: seriesModel,
                overallProgress: overallProgress
            };
            stub.agent = overallTask;
            stub.__block = overallProgress;
            scheduler._pipe(seriesModel, stub);
        }
        if (shouldOverallTaskDirty) overallTask.dirty();
    };
    Scheduler.prototype._pipe = function(seriesModel, task) {
        var pipelineId = seriesModel.uid;
        var pipeline = this._pipelineMap.get(pipelineId);
        !pipeline.head && (pipeline.head = task);
        pipeline.tail && pipeline.tail.pipe(task);
        pipeline.tail = task;
        task.__idxInPipeline = pipeline.count++;
        task.__pipeline = pipeline;
    };
    Scheduler.wrapStageHandler = function(stageHandler, visualType) {
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(stageHandler)) stageHandler = {
            overallReset: stageHandler,
            seriesType: $930979848c1a297c$var$detectSeriseType(stageHandler)
        };
        stageHandler.uid = (0, $4e8eadf530aecaff$export$6d2b3473b0986646)('stageHandler');
        visualType && (stageHandler.visualType = visualType);
        return stageHandler;
    };
    return Scheduler;
}();
function $930979848c1a297c$var$overallTaskReset(context) {
    context.overallReset(context.ecModel, context.api, context.payload);
}
function $930979848c1a297c$var$stubReset(context) {
    return context.overallProgress && $930979848c1a297c$var$stubProgress;
}
function $930979848c1a297c$var$stubProgress() {
    this.agent.dirty();
    this.getDownstream().dirty();
}
function $930979848c1a297c$var$stubOnDirty() {
    this.agent && this.agent.dirty();
}
function $930979848c1a297c$var$seriesTaskPlan(context) {
    return context.plan ? context.plan(context.model, context.ecModel, context.api, context.payload) : null;
}
function $930979848c1a297c$var$seriesTaskReset(context) {
    if (context.useClearVisual) context.data.clearAllVisual();
    var resetDefines = context.resetDefines = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(context.reset(context.model, context.ecModel, context.api, context.payload));
    return resetDefines.length > 1 ? (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(resetDefines, function(v, idx) {
        return $930979848c1a297c$var$makeSeriesTaskProgress(idx);
    }) : $930979848c1a297c$var$singleSeriesTaskProgress;
}
var $930979848c1a297c$var$singleSeriesTaskProgress = $930979848c1a297c$var$makeSeriesTaskProgress(0);
function $930979848c1a297c$var$makeSeriesTaskProgress(resetDefineIdx) {
    return function(params, context) {
        var data = context.data;
        var resetDefine = context.resetDefines[resetDefineIdx];
        if (resetDefine && resetDefine.dataEach) for(var i = params.start; i < params.end; i++)resetDefine.dataEach(data, i);
        else if (resetDefine && resetDefine.progress) resetDefine.progress(params, data);
    };
}
function $930979848c1a297c$var$seriesTaskCount(context) {
    return context.data.count();
}
/**
 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
 * To ensure that they can work normally, they should work in block mode, that is,
 * they should not be started util the previous tasks finished. So they cause the
 * progressive rendering disabled. We try to detect the series type, to narrow down
 * the block range to only the series type they concern, but not all series.
 */ function $930979848c1a297c$var$detectSeriseType(legacyFunc) {
    $930979848c1a297c$var$seriesType = null;
    try {
        // Assume there is no async when calling `eachSeriesByType`.
        legacyFunc($930979848c1a297c$var$ecModelMock, $930979848c1a297c$var$apiMock);
    } catch (e) {}
    return $930979848c1a297c$var$seriesType;
}
var $930979848c1a297c$var$ecModelMock = {};
var $930979848c1a297c$var$apiMock = {};
var $930979848c1a297c$var$seriesType;
$930979848c1a297c$var$mockMethods($930979848c1a297c$var$ecModelMock, (0, $eed56b0401cb1831$export$2e2bcd8739ae039));
$930979848c1a297c$var$mockMethods($930979848c1a297c$var$apiMock, (0, $545b8cf22e653ed1$export$2e2bcd8739ae039));
$930979848c1a297c$var$ecModelMock.eachSeriesByType = $930979848c1a297c$var$ecModelMock.eachRawSeriesByType = function(type) {
    $930979848c1a297c$var$seriesType = type;
};
$930979848c1a297c$var$ecModelMock.eachComponent = function(cond) {
    if (cond.mainType === 'series' && cond.subType) $930979848c1a297c$var$seriesType = cond.subType;
};
function $930979848c1a297c$var$mockMethods(target, Clz) {
    /* eslint-disable */ for(var name_1 in Clz.prototype)// Do not use hasOwnProperty
    target[name_1] = (0, $1b239fc9d3a2f8ae$export$8793edee2d425525);
/* eslint-enable */ }
var $930979848c1a297c$export$2e2bcd8739ae039 = $930979848c1a297c$var$Scheduler;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $dbc9728520a9c914$var$colorAll = [
    '#37A2DA',
    '#32C5E9',
    '#67E0E3',
    '#9FE6B8',
    '#FFDB5C',
    '#ff9f7f',
    '#fb7293',
    '#E062AE',
    '#E690D1',
    '#e7bcf3',
    '#9d96f5',
    '#8378EA',
    '#96BFFF'
];
var $dbc9728520a9c914$export$2e2bcd8739ae039 = {
    color: $dbc9728520a9c914$var$colorAll,
    colorLayer: [
        [
            '#37A2DA',
            '#ffd85c',
            '#fd7b5f'
        ],
        [
            '#37A2DA',
            '#67E0E3',
            '#FFDB5C',
            '#ff9f7f',
            '#E062AE',
            '#9d96f5'
        ],
        [
            '#37A2DA',
            '#32C5E9',
            '#9FE6B8',
            '#FFDB5C',
            '#ff9f7f',
            '#fb7293',
            '#e7bcf3',
            '#8378EA',
            '#96BFFF'
        ],
        $dbc9728520a9c914$var$colorAll
    ]
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3e8f409f2362f7f5$var$contrastColor = '#B9B8CE';
var $3e8f409f2362f7f5$var$backgroundColor = '#100C2A';
var $3e8f409f2362f7f5$var$axisCommon = function() {
    return {
        axisLine: {
            lineStyle: {
                color: $3e8f409f2362f7f5$var$contrastColor
            }
        },
        splitLine: {
            lineStyle: {
                color: '#484753'
            }
        },
        splitArea: {
            areaStyle: {
                color: [
                    'rgba(255,255,255,0.02)',
                    'rgba(255,255,255,0.05)'
                ]
            }
        },
        minorSplitLine: {
            lineStyle: {
                color: '#20203B'
            }
        }
    };
};
var $3e8f409f2362f7f5$var$colorPalette = [
    '#4992ff',
    '#7cffb2',
    '#fddd60',
    '#ff6e76',
    '#58d9f9',
    '#05c091',
    '#ff8a45',
    '#8d48e3',
    '#dd79ff'
];
var $3e8f409f2362f7f5$var$theme = {
    darkMode: true,
    color: $3e8f409f2362f7f5$var$colorPalette,
    backgroundColor: $3e8f409f2362f7f5$var$backgroundColor,
    axisPointer: {
        lineStyle: {
            color: '#817f91'
        },
        crossStyle: {
            color: '#817f91'
        },
        label: {
            // TODO Contrast of label backgorundColor
            color: '#fff'
        }
    },
    legend: {
        textStyle: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        pageTextStyle: {
            color: $3e8f409f2362f7f5$var$contrastColor
        }
    },
    textStyle: {
        color: $3e8f409f2362f7f5$var$contrastColor
    },
    title: {
        textStyle: {
            color: '#EEF1FA'
        },
        subtextStyle: {
            color: '#B9B8CE'
        }
    },
    toolbox: {
        iconStyle: {
            borderColor: $3e8f409f2362f7f5$var$contrastColor
        }
    },
    dataZoom: {
        borderColor: '#71708A',
        textStyle: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        brushStyle: {
            color: 'rgba(135,163,206,0.3)'
        },
        handleStyle: {
            color: '#353450',
            borderColor: '#C5CBE3'
        },
        moveHandleStyle: {
            color: '#B0B6C3',
            opacity: 0.3
        },
        fillerColor: 'rgba(135,163,206,0.2)',
        emphasis: {
            handleStyle: {
                borderColor: '#91B7F2',
                color: '#4D587D'
            },
            moveHandleStyle: {
                color: '#636D9A',
                opacity: 0.7
            }
        },
        dataBackground: {
            lineStyle: {
                color: '#71708A',
                width: 1
            },
            areaStyle: {
                color: '#71708A'
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#87A3CE'
            },
            areaStyle: {
                color: '#87A3CE'
            }
        }
    },
    visualMap: {
        textStyle: {
            color: $3e8f409f2362f7f5$var$contrastColor
        }
    },
    timeline: {
        lineStyle: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        label: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        controlStyle: {
            color: $3e8f409f2362f7f5$var$contrastColor,
            borderColor: $3e8f409f2362f7f5$var$contrastColor
        }
    },
    calendar: {
        itemStyle: {
            color: $3e8f409f2362f7f5$var$backgroundColor
        },
        dayLabel: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        monthLabel: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        yearLabel: {
            color: $3e8f409f2362f7f5$var$contrastColor
        }
    },
    timeAxis: $3e8f409f2362f7f5$var$axisCommon(),
    logAxis: $3e8f409f2362f7f5$var$axisCommon(),
    valueAxis: $3e8f409f2362f7f5$var$axisCommon(),
    categoryAxis: $3e8f409f2362f7f5$var$axisCommon(),
    line: {
        symbol: 'circle'
    },
    graph: {
        color: $3e8f409f2362f7f5$var$colorPalette
    },
    gauge: {
        title: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        axisLine: {
            lineStyle: {
                color: [
                    [
                        1,
                        'rgba(207,212,219,0.2)'
                    ]
                ]
            }
        },
        axisLabel: {
            color: $3e8f409f2362f7f5$var$contrastColor
        },
        detail: {
            color: '#EEF1FA'
        }
    },
    candlestick: {
        itemStyle: {
            color: '#f64e56',
            color0: '#54ea92',
            borderColor: '#f64e56',
            borderColor0: '#54ea92'
        }
    }
};
$3e8f409f2362f7f5$var$theme.categoryAxis.splitLine.show = false;
var $3e8f409f2362f7f5$export$2e2bcd8739ae039 = $3e8f409f2362f7f5$var$theme;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Usage of query:
 * `chart.on('click', query, handler);`
 * The `query` can be:
 * + The component type query string, only `mainType` or `mainType.subType`,
 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
 * + The component query object, like:
 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
 * + The data query object, like:
 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
 * + The other query object (cmponent customized query), like:
 *   `{element: 'some'}` (only available in custom series).
 *
 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
 * same as there is no such prop in the `query` object.
 */ var $e30ccc45656fd95c$export$d0fd09f950257b52 = /** @class */ function() {
    function ECEventProcessor() {}
    ECEventProcessor.prototype.normalizeQuery = function(query) {
        var cptQuery = {};
        var dataQuery = {};
        var otherQuery = {};
        // `query` is `mainType` or `mainType.subType` of component.
        if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(query)) {
            var condCptType = (0, $19c24724c14e5e48$export$fbe18865d303bf01)(query);
            // `.main` and `.sub` may be ''.
            cptQuery.mainType = condCptType.main || null;
            cptQuery.subType = condCptType.sub || null;
        } else {
            // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
            // can not be used in `compomentModel.filterForExposedEvent`.
            var suffixes_1 = [
                'Index',
                'Name',
                'Id'
            ];
            var dataKeys_1 = {
                name: 1,
                dataIndex: 1,
                dataType: 1
            };
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(query, function(val, key) {
                var reserved = false;
                for(var i = 0; i < suffixes_1.length; i++){
                    var propSuffix = suffixes_1[i];
                    var suffixPos = key.lastIndexOf(propSuffix);
                    if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
                        var mainType = key.slice(0, suffixPos);
                        // Consider `dataIndex`.
                        if (mainType !== 'data') {
                            cptQuery.mainType = mainType;
                            cptQuery[propSuffix.toLowerCase()] = val;
                            reserved = true;
                        }
                    }
                }
                if (dataKeys_1.hasOwnProperty(key)) {
                    dataQuery[key] = val;
                    reserved = true;
                }
                if (!reserved) otherQuery[key] = val;
            });
        }
        return {
            cptQuery: cptQuery,
            dataQuery: dataQuery,
            otherQuery: otherQuery
        };
    };
    ECEventProcessor.prototype.filter = function(eventType, query) {
        // They should be assigned before each trigger call.
        var eventInfo = this.eventInfo;
        if (!eventInfo) return true;
        var targetEl = eventInfo.targetEl;
        var packedEvent = eventInfo.packedEvent;
        var model = eventInfo.model;
        var view = eventInfo.view;
        // For event like 'globalout'.
        if (!model || !view) return true;
        var cptQuery = query.cptQuery;
        var dataQuery = query.dataQuery;
        return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
        function check(query, host, prop, propOnHost) {
            return query[prop] == null || host[propOnHost || prop] === query[prop];
        }
    };
    ECEventProcessor.prototype.afterTrigger = function() {
        // Make sure the eventInfo won't be used in next trigger.
        this.eventInfo = null;
    };
    return ECEventProcessor;
}();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $66ca82a264fd1e9a$var$SYMBOL_PROPS_WITH_CB = [
    'symbol',
    'symbolSize',
    'symbolRotate',
    'symbolOffset'
];
var $66ca82a264fd1e9a$var$SYMBOL_PROPS = $66ca82a264fd1e9a$var$SYMBOL_PROPS_WITH_CB.concat([
    'symbolKeepAspect'
]);
// Encoding visual for all series include which is filtered for legend drawing
var $66ca82a264fd1e9a$export$144ac3beded415d9 = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        var data = seriesModel.getData();
        if (seriesModel.legendIcon) data.setVisual('legendIcon', seriesModel.legendIcon);
        if (!seriesModel.hasSymbolVisual) return;
        var symbolOptions = {};
        var symbolOptionsCb = {};
        var hasCallback = false;
        for(var i = 0; i < $66ca82a264fd1e9a$var$SYMBOL_PROPS_WITH_CB.length; i++){
            var symbolPropName = $66ca82a264fd1e9a$var$SYMBOL_PROPS_WITH_CB[i];
            var val = seriesModel.get(symbolPropName);
            if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(val)) {
                hasCallback = true;
                symbolOptionsCb[symbolPropName] = val;
            } else symbolOptions[symbolPropName] = val;
        }
        symbolOptions.symbol = symbolOptions.symbol || seriesModel.defaultSymbol;
        data.setVisual((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
            legendIcon: seriesModel.legendIcon || symbolOptions.symbol,
            symbolKeepAspect: seriesModel.get('symbolKeepAspect')
        }, symbolOptions));
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var symbolPropsCb = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(symbolOptionsCb);
        function dataEach(data, idx) {
            var rawValue = seriesModel.getRawValue(idx);
            var params = seriesModel.getDataParams(idx);
            for(var i = 0; i < symbolPropsCb.length; i++){
                var symbolPropName = symbolPropsCb[i];
                data.setItemVisual(idx, symbolPropName, symbolOptionsCb[symbolPropName](rawValue, params));
            }
        }
        return {
            dataEach: hasCallback ? dataEach : null
        };
    }
};
var $66ca82a264fd1e9a$export$435b956f7f1071fb = {
    createOnAllSeries: true,
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        if (!seriesModel.hasSymbolVisual) return;
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            for(var i = 0; i < $66ca82a264fd1e9a$var$SYMBOL_PROPS.length; i++){
                var symbolPropName = $66ca82a264fd1e9a$var$SYMBOL_PROPS[i];
                var val = itemModel.getShallow(symbolPropName, true);
                if (val != null) data.setItemVisual(idx, symbolPropName, val);
            }
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $aa7643c8305265d3$export$91d919a86b2df624(data, dataIndex, key) {
    switch(key){
        case 'color':
            var style = data.getItemVisual(dataIndex, 'style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getItemVisual(dataIndex, 'style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getItemVisual(dataIndex, key);
        default:
    }
}
function $aa7643c8305265d3$export$d76e333a86ea1a2(data, key) {
    switch(key){
        case 'color':
            var style = data.getVisual('style');
            return style[data.getVisual('drawType')];
        case 'opacity':
            return data.getVisual('style').opacity;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            return data.getVisual(key);
        default:
    }
}
function $aa7643c8305265d3$export$3aab879e9d0e7c75(data, dataIndex, key, value) {
    switch(key){
        case 'color':
            // Make sure not sharing style object.
            var style = data.ensureUniqueItemVisual(dataIndex, 'style');
            style[data.getVisual('drawType')] = value;
            // Mark the color has been changed, not from palette anymore
            data.setItemVisual(dataIndex, 'colorFromPalette', false);
            break;
        case 'opacity':
            data.ensureUniqueItemVisual(dataIndex, 'style').opacity = value;
            break;
        case 'symbol':
        case 'symbolSize':
        case 'liftZ':
            data.setItemVisual(dataIndex, key, value);
            break;
        default:
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $4a2d4f3079e03ea2$export$62942ba95693dbfc(seriesType, ecRegisterAction) {
    function getSeriesIndices(ecModel, payload) {
        var seriesIndices = [];
        ecModel.eachComponent({
            mainType: 'series',
            subType: seriesType,
            query: payload
        }, function(seriesModel) {
            seriesIndices.push(seriesModel.seriesIndex);
        });
        return seriesIndices;
    }
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        [
            seriesType + 'ToggleSelect',
            'toggleSelect'
        ],
        [
            seriesType + 'Select',
            'select'
        ],
        [
            seriesType + 'UnSelect',
            'unselect'
        ]
    ], function(eventsMap) {
        ecRegisterAction(eventsMap[0], function(payload, ecModel, api) {
            payload = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, payload);
            api.dispatchAction((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(payload, {
                type: eventsMap[1],
                seriesIndex: getSeriesIndices(ecModel, payload)
            }));
        });
    });
}
function $4a2d4f3079e03ea2$var$handleSeriesLegacySelectEvents(type, eventPostfix, ecIns, ecModel, payload) {
    var legacyEventName = type + eventPostfix;
    if (!ecIns.isSilent(legacyEventName)) ecModel.eachComponent({
        mainType: 'series',
        subType: 'pie'
    }, function(seriesModel) {
        var seriesIndex = seriesModel.seriesIndex;
        var selectedMap = seriesModel.option.selectedMap;
        var selected = payload.selected;
        for(var i = 0; i < selected.length; i++)if (selected[i].seriesIndex === seriesIndex) {
            var data = seriesModel.getData();
            var dataIndex = (0, $9ac03c46e8b6e711$export$42b26cae8b8d10)(data, payload.fromActionPayload);
            ecIns.trigger(legacyEventName, {
                type: legacyEventName,
                seriesId: seriesModel.id,
                name: (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(dataIndex) ? data.getName(dataIndex[0]) : data.getName(dataIndex),
                selected: (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(selectedMap) ? selectedMap : (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, selectedMap)
            });
        }
    });
}
function $4a2d4f3079e03ea2$export$2575c83262e49d0c(messageCenter, ecIns, api) {
    messageCenter.on('selectchanged', function(params) {
        var ecModel = api.getModel();
        if (params.isFromClick) {
            $4a2d4f3079e03ea2$var$handleSeriesLegacySelectEvents('map', 'selectchanged', ecIns, ecModel, params);
            $4a2d4f3079e03ea2$var$handleSeriesLegacySelectEvents('pie', 'selectchanged', ecIns, ecModel, params);
        } else if (params.fromAction === 'select') {
            $4a2d4f3079e03ea2$var$handleSeriesLegacySelectEvents('map', 'selected', ecIns, ecModel, params);
            $4a2d4f3079e03ea2$var$handleSeriesLegacySelectEvents('pie', 'selected', ecIns, ecModel, params);
        } else if (params.fromAction === 'unselect') {
            $4a2d4f3079e03ea2$var$handleSeriesLegacySelectEvents('map', 'unselected', ecIns, ecModel, params);
            $4a2d4f3079e03ea2$var$handleSeriesLegacySelectEvents('pie', 'unselected', ecIns, ecModel, params);
        }
    });
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $ee614fdac89517fb$export$8a4fca9e04eb4df6(target, det, returnFirstMatch) {
    var found;
    while(target){
        if (det(target)) {
            found = target;
            if (returnFirstMatch) break;
        }
        target = target.__hostTarget || target.parent;
    }
    return found;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $83864c6cb0bbf083$var$wmUniqueIndex = Math.round(Math.random() * 9);
var $83864c6cb0bbf083$var$supportDefineProperty = typeof Object.defineProperty === 'function';
var $83864c6cb0bbf083$var$WeakMap = function() {
    function WeakMap() {
        this._id = '__ec_inner_' + $83864c6cb0bbf083$var$wmUniqueIndex++;
    }
    WeakMap.prototype.get = function(key) {
        return this._guard(key)[this._id];
    };
    WeakMap.prototype.set = function(key, value) {
        var target = this._guard(key);
        if ($83864c6cb0bbf083$var$supportDefineProperty) Object.defineProperty(target, this._id, {
            value: value,
            enumerable: false,
            configurable: true
        });
        else target[this._id] = value;
        return this;
    };
    WeakMap.prototype["delete"] = function(key) {
        if (this.has(key)) {
            delete this._guard(key)[this._id];
            return true;
        }
        return false;
    };
    WeakMap.prototype.has = function(key) {
        return !!this._guard(key)[this._id];
    };
    WeakMap.prototype._guard = function(key) {
        if (key !== Object(key)) throw TypeError('Value of WeakMap is not a non-null object.');
        return key;
    };
    return WeakMap;
}();
var $83864c6cb0bbf083$export$2e2bcd8739ae039 = $83864c6cb0bbf083$var$WeakMap;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Symbol factory





/**
 * Triangle shape
 * @inner
 */ var $da6220012439db7b$var$Triangle = $f9698154c9fcf427$export$2e2bcd8739ae039.extend({
    type: 'triangle',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy + height);
        path.lineTo(cx - width, cy + height);
        path.closePath();
    }
});
/**
 * Diamond shape
 * @inner
 */ var $da6220012439db7b$var$Diamond = $f9698154c9fcf427$export$2e2bcd8739ae039.extend({
    type: 'diamond',
    shape: {
        cx: 0,
        cy: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var width = shape.width / 2;
        var height = shape.height / 2;
        path.moveTo(cx, cy - height);
        path.lineTo(cx + width, cy);
        path.lineTo(cx, cy + height);
        path.lineTo(cx - width, cy);
        path.closePath();
    }
});
/**
 * Pin shape
 * @inner
 */ var $da6220012439db7b$var$Pin = $f9698154c9fcf427$export$2e2bcd8739ae039.extend({
    type: 'pin',
    shape: {
        // x, y on the cusp
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(path, shape) {
        var x = shape.x;
        var y = shape.y;
        var w = shape.width / 5 * 3;
        // Height must be larger than width
        var h = Math.max(w, shape.height);
        var r = w / 2;
        // Dist on y with tangent point and circle center
        var dy = r * r / (h - r);
        var cy = y - h + r + dy;
        var angle = Math.asin(dy / r);
        // Dist on x with tangent point and circle center
        var dx = Math.cos(angle) * r;
        var tanX = Math.sin(angle);
        var tanY = Math.cos(angle);
        var cpLen = r * 0.6;
        var cpLen2 = r * 0.7;
        path.moveTo(x - dx, cy + dy);
        path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
        path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
        path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
        path.closePath();
    }
});
/**
 * Arrow shape
 * @inner
 */ var $da6220012439db7b$var$Arrow = $f9698154c9fcf427$export$2e2bcd8739ae039.extend({
    type: 'arrow',
    shape: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    buildPath: function(ctx, shape) {
        var height = shape.height;
        var width = shape.width;
        var x = shape.x;
        var y = shape.y;
        var dx = width / 3 * 2;
        ctx.moveTo(x, y);
        ctx.lineTo(x + dx, y + height);
        ctx.lineTo(x, y + height / 4 * 3);
        ctx.lineTo(x - dx, y + height);
        ctx.lineTo(x, y);
        ctx.closePath();
    }
});
/**
 * Map of path constructors
 */ // TODO Use function to build symbol path.
var $da6220012439db7b$var$symbolCtors = {
    line: $8324e8379a5583a5$export$2e2bcd8739ae039,
    rect: $37476269d425e3f6$export$2e2bcd8739ae039,
    roundRect: $37476269d425e3f6$export$2e2bcd8739ae039,
    square: $37476269d425e3f6$export$2e2bcd8739ae039,
    circle: $7257c7c7414f291c$export$2e2bcd8739ae039,
    diamond: $da6220012439db7b$var$Diamond,
    pin: $da6220012439db7b$var$Pin,
    arrow: $da6220012439db7b$var$Arrow,
    triangle: $da6220012439db7b$var$Triangle
};
var $da6220012439db7b$var$symbolShapeMakers = {
    line: function(x, y, w, h, shape) {
        shape.x1 = x;
        shape.y1 = y + h / 2;
        shape.x2 = x + w;
        shape.y2 = y + h / 2;
    },
    rect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
    },
    roundRect: function(x, y, w, h, shape) {
        shape.x = x;
        shape.y = y;
        shape.width = w;
        shape.height = h;
        shape.r = Math.min(w, h) / 4;
    },
    square: function(x, y, w, h, shape) {
        var size = Math.min(w, h);
        shape.x = x;
        shape.y = y;
        shape.width = size;
        shape.height = size;
    },
    circle: function(x, y, w, h, shape) {
        // Put circle in the center of square
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.r = Math.min(w, h) / 2;
    },
    diamond: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    pin: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    arrow: function(x, y, w, h, shape) {
        shape.x = x + w / 2;
        shape.y = y + h / 2;
        shape.width = w;
        shape.height = h;
    },
    triangle: function(x, y, w, h, shape) {
        shape.cx = x + w / 2;
        shape.cy = y + h / 2;
        shape.width = w;
        shape.height = h;
    }
};
var $da6220012439db7b$export$33fc3b478d332725 = {};
(0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($da6220012439db7b$var$symbolCtors, function(Ctor, name) {
    $da6220012439db7b$export$33fc3b478d332725[name] = new Ctor();
});
var $da6220012439db7b$var$SymbolClz = $f9698154c9fcf427$export$2e2bcd8739ae039.extend({
    type: 'symbol',
    shape: {
        symbolType: '',
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    calculateTextPosition: function(out, config, rect) {
        var res = (0, $297531217517fbce$export$eee3603b512feab7)(out, config, rect);
        var shape = this.shape;
        if (shape && shape.symbolType === 'pin' && config.position === 'inside') res.y = rect.y + rect.height * 0.4;
        return res;
    },
    buildPath: function(ctx, shape, inBundle) {
        var symbolType = shape.symbolType;
        if (symbolType !== 'none') {
            var proxySymbol = $da6220012439db7b$export$33fc3b478d332725[symbolType];
            if (!proxySymbol) {
                // Default rect
                symbolType = 'rect';
                proxySymbol = $da6220012439db7b$export$33fc3b478d332725[symbolType];
            }
            $da6220012439db7b$var$symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
            proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
        }
    }
});
// Provide setColor helper method to avoid determine if set the fill or stroke outside
function $da6220012439db7b$var$symbolPathSetColor(color, innerColor) {
    if (this.type !== 'image') {
        var symbolStyle = this.style;
        if (this.__isEmptyBrush) {
            symbolStyle.stroke = color;
            symbolStyle.fill = innerColor || '#fff';
            // TODO Same width with lineStyle in LineView
            symbolStyle.lineWidth = 2;
        } else if (this.shape.symbolType === 'line') symbolStyle.stroke = color;
        else symbolStyle.fill = color;
        this.markRedraw();
    }
}
function $da6220012439db7b$export$af050e04da3a02e8(symbolType, x, y, w, h, color, // whether to keep the ratio of w/h,
keepAspect) {
    // TODO Support image object, DynamicImage.
    var isEmpty = symbolType.indexOf('empty') === 0;
    if (isEmpty) symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
    var symbolPath;
    if (symbolType.indexOf('image://') === 0) symbolPath = $8eb95236e1aa01e7$export$7a2bdede98851ac5(symbolType.slice(8), new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else if (symbolType.indexOf('path://') === 0) symbolPath = $8eb95236e1aa01e7$export$aa9bab72412f5613(symbolType.slice(7), {}, new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, w, h), keepAspect ? 'center' : 'cover');
    else symbolPath = new $da6220012439db7b$var$SymbolClz({
        shape: {
            symbolType: symbolType,
            x: x,
            y: y,
            width: w,
            height: h
        }
    });
    symbolPath.__isEmptyBrush = isEmpty;
    // TODO Should deprecate setColor
    symbolPath.setColor = $da6220012439db7b$var$symbolPathSetColor;
    if (color) symbolPath.setColor(color);
    return symbolPath;
}
function $da6220012439db7b$export$a84524f03e8e8dfb(symbolSize) {
    if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
        +symbolSize,
        +symbolSize
    ];
    return [
        symbolSize[0] || 0,
        symbolSize[1] || 0
    ];
}
function $da6220012439db7b$export$e3e292895c033f6d(symbolOffset, symbolSize) {
    if (symbolOffset == null) return;
    if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
        symbolOffset,
        symbolOffset
    ];
    return [
        (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(symbolOffset[0], symbolSize[0]) || 0,
        (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)((0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(symbolOffset[1], symbolOffset[0]), symbolSize[1]) || 0
    ];
}





function $9b483e37735cf979$var$isSafeNum(num) {
    return isFinite(num);
}
function $9b483e37735cf979$export$235c7ac50fe1db0a(ctx, obj, rect) {
    var x = obj.x == null ? 0 : obj.x;
    var x2 = obj.x2 == null ? 1 : obj.x2;
    var y = obj.y == null ? 0 : obj.y;
    var y2 = obj.y2 == null ? 0 : obj.y2;
    if (!obj.global) {
        x = x * rect.width + rect.x;
        x2 = x2 * rect.width + rect.x;
        y = y * rect.height + rect.y;
        y2 = y2 * rect.height + rect.y;
    }
    x = $9b483e37735cf979$var$isSafeNum(x) ? x : 0;
    x2 = $9b483e37735cf979$var$isSafeNum(x2) ? x2 : 1;
    y = $9b483e37735cf979$var$isSafeNum(y) ? y : 0;
    y2 = $9b483e37735cf979$var$isSafeNum(y2) ? y2 : 0;
    var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
    return canvasGradient;
}
function $9b483e37735cf979$export$57f098206d57a443(ctx, obj, rect) {
    var width = rect.width;
    var height = rect.height;
    var min = Math.min(width, height);
    var x = obj.x == null ? 0.5 : obj.x;
    var y = obj.y == null ? 0.5 : obj.y;
    var r = obj.r == null ? 0.5 : obj.r;
    if (!obj.global) {
        x = x * width + rect.x;
        y = y * height + rect.y;
        r = r * min;
    }
    x = $9b483e37735cf979$var$isSafeNum(x) ? x : 0.5;
    y = $9b483e37735cf979$var$isSafeNum(y) ? y : 0.5;
    r = r >= 0 && $9b483e37735cf979$var$isSafeNum(r) ? r : 0.5;
    var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
    return canvasGradient;
}
function $9b483e37735cf979$export$3dab6afd018d48c7(ctx, obj, rect) {
    var canvasGradient = obj.type === 'radial' ? $9b483e37735cf979$export$57f098206d57a443(ctx, obj, rect) : $9b483e37735cf979$export$235c7ac50fe1db0a(ctx, obj, rect);
    var colorStops = obj.colorStops;
    for(var i = 0; i < colorStops.length; i++)canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
    return canvasGradient;
}
function $9b483e37735cf979$export$beeddc5150cb2e83(clipPaths, prevClipPaths) {
    if (clipPaths === prevClipPaths || !clipPaths && !prevClipPaths) return false;
    if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) return true;
    for(var i = 0; i < clipPaths.length; i++){
        if (clipPaths[i] !== prevClipPaths[i]) return true;
    }
    return false;
}
function $9b483e37735cf979$var$parseInt10(val) {
    return parseInt(val, 10);
}
function $9b483e37735cf979$export$31b21d0167753bb4(root, whIdx, opts) {
    var wh = [
        'width',
        'height'
    ][whIdx];
    var cwh = [
        'clientWidth',
        'clientHeight'
    ][whIdx];
    var plt = [
        'paddingLeft',
        'paddingTop'
    ][whIdx];
    var prb = [
        'paddingRight',
        'paddingBottom'
    ][whIdx];
    if (opts[wh] != null && opts[wh] !== 'auto') return parseFloat(opts[wh]);
    var stl = document.defaultView.getComputedStyle(root);
    return (root[cwh] || $9b483e37735cf979$var$parseInt10(stl[wh]) || $9b483e37735cf979$var$parseInt10(root.style[wh])) - ($9b483e37735cf979$var$parseInt10(stl[plt]) || 0) - ($9b483e37735cf979$var$parseInt10(stl[prb]) || 0) | 0;
}







function $ceacb1517b0bd545$export$9efb2ae8a603855d(lineType, lineWidth) {
    if (!lineType || lineType === 'solid' || !(lineWidth > 0)) return null;
    return lineType === 'dashed' ? [
        4 * lineWidth,
        2 * lineWidth
    ] : lineType === 'dotted' ? [
        lineWidth
    ] : (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(lineType) ? [
        lineType
    ] : (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(lineType) ? lineType : null;
}
function $ceacb1517b0bd545$export$9d315911f153b3b2(el) {
    var style = el.style;
    var lineDash = style.lineDash && style.lineWidth > 0 && $ceacb1517b0bd545$export$9efb2ae8a603855d(style.lineDash, style.lineWidth);
    var lineDashOffset = style.lineDashOffset;
    if (lineDash) {
        var lineScale_1 = style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1;
        if (lineScale_1 && lineScale_1 !== 1) {
            lineDash = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(lineDash, function(rawVal) {
                return rawVal / lineScale_1;
            });
            lineDashOffset /= lineScale_1;
        }
    }
    return [
        lineDash,
        lineDashOffset
    ];
}




var $a639152f35090585$var$pathProxyForDraw = new (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039)(true);
function $a639152f35090585$var$styleHasStroke(style) {
    var stroke = style.stroke;
    return !(stroke == null || stroke === 'none' || !(style.lineWidth > 0));
}
function $a639152f35090585$var$isValidStrokeFillStyle(strokeOrFill) {
    return typeof strokeOrFill === 'string' && strokeOrFill !== 'none';
}
function $a639152f35090585$var$styleHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== 'none';
}
function $a639152f35090585$var$doFillPath(ctx, style) {
    if (style.fillOpacity != null && style.fillOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.fillOpacity * style.opacity;
        ctx.fill();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.fill();
}
function $a639152f35090585$var$doStrokePath(ctx, style) {
    if (style.strokeOpacity != null && style.strokeOpacity !== 1) {
        var originalGlobalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = style.strokeOpacity * style.opacity;
        ctx.stroke();
        ctx.globalAlpha = originalGlobalAlpha;
    } else ctx.stroke();
}
function $a639152f35090585$export$8eb5db6b7bc27903(ctx, pattern, el) {
    var image = (0, $d03a6f18dabd43b1$export$46c791b69ff9a0f)(pattern.image, pattern.__image, el);
    if ((0, $d03a6f18dabd43b1$export$37ca7dd901d0236d)(image)) {
        var canvasPattern = ctx.createPattern(image, pattern.repeat || 'repeat');
        if (typeof DOMMatrix === 'function' && canvasPattern && canvasPattern.setTransform) {
            var matrix = new DOMMatrix();
            matrix.translateSelf(pattern.x || 0, pattern.y || 0);
            matrix.rotateSelf(0, 0, (pattern.rotation || 0) * (0, $1b239fc9d3a2f8ae$export$bce8e055322a0ce6));
            matrix.scaleSelf(pattern.scaleX || 1, pattern.scaleY || 1);
            canvasPattern.setTransform(matrix);
        }
        return canvasPattern;
    }
}
function $a639152f35090585$var$brushPath(ctx, el, style, inBatch) {
    var _a;
    var hasStroke = $a639152f35090585$var$styleHasStroke(style);
    var hasFill = $a639152f35090585$var$styleHasFill(style);
    var strokePercent = style.strokePercent;
    var strokePart = strokePercent < 1;
    var firstDraw = !el.path;
    if ((!el.silent || strokePart) && firstDraw) el.createPathProxy();
    var path = el.path || $a639152f35090585$var$pathProxyForDraw;
    var dirtyFlag = el.__dirty;
    if (!inBatch) {
        var fill = style.fill;
        var stroke = style.stroke;
        var hasFillGradient = hasFill && !!fill.colorStops;
        var hasStrokeGradient = hasStroke && !!stroke.colorStops;
        var hasFillPattern = hasFill && !!fill.image;
        var hasStrokePattern = hasStroke && !!stroke.image;
        var fillGradient = void 0;
        var strokeGradient = void 0;
        var fillPattern = void 0;
        var strokePattern = void 0;
        var rect = void 0;
        if (hasFillGradient || hasStrokeGradient) rect = el.getBoundingRect();
        if (hasFillGradient) {
            fillGradient = dirtyFlag ? (0, $9b483e37735cf979$export$3dab6afd018d48c7)(ctx, fill, rect) : el.__canvasFillGradient;
            el.__canvasFillGradient = fillGradient;
        }
        if (hasStrokeGradient) {
            strokeGradient = dirtyFlag ? (0, $9b483e37735cf979$export$3dab6afd018d48c7)(ctx, stroke, rect) : el.__canvasStrokeGradient;
            el.__canvasStrokeGradient = strokeGradient;
        }
        if (hasFillPattern) {
            fillPattern = dirtyFlag || !el.__canvasFillPattern ? $a639152f35090585$export$8eb5db6b7bc27903(ctx, fill, el) : el.__canvasFillPattern;
            el.__canvasFillPattern = fillPattern;
        }
        if (hasStrokePattern) {
            strokePattern = dirtyFlag || !el.__canvasStrokePattern ? $a639152f35090585$export$8eb5db6b7bc27903(ctx, stroke, el) : el.__canvasStrokePattern;
            el.__canvasStrokePattern = fillPattern;
        }
        if (hasFillGradient) ctx.fillStyle = fillGradient;
        else if (hasFillPattern) {
            if (fillPattern) ctx.fillStyle = fillPattern;
            else hasFill = false;
        }
        if (hasStrokeGradient) ctx.strokeStyle = strokeGradient;
        else if (hasStrokePattern) {
            if (strokePattern) ctx.strokeStyle = strokePattern;
            else hasStroke = false;
        }
    }
    var scale = el.getGlobalScale();
    path.setScale(scale[0], scale[1], el.segmentIgnoreThreshold);
    var lineDash;
    var lineDashOffset;
    if (ctx.setLineDash && style.lineDash) _a = (0, $ceacb1517b0bd545$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
    var needsRebuild = true;
    if (firstDraw || dirtyFlag & (0, $7bc42091a9de0611$export$f75fe89a33ebe115)) {
        path.setDPR(ctx.dpr);
        if (strokePart) path.setContext(null);
        else {
            path.setContext(ctx);
            needsRebuild = false;
        }
        path.reset();
        el.buildPath(path, el.shape, inBatch);
        path.toStatic();
        el.pathUpdated();
    }
    if (needsRebuild) path.rebuildPath(ctx, strokePart ? strokePercent : 1);
    if (lineDash) {
        ctx.setLineDash(lineDash);
        ctx.lineDashOffset = lineDashOffset;
    }
    if (!inBatch) {
        if (style.strokeFirst) {
            if (hasStroke) $a639152f35090585$var$doStrokePath(ctx, style);
            if (hasFill) $a639152f35090585$var$doFillPath(ctx, style);
        } else {
            if (hasFill) $a639152f35090585$var$doFillPath(ctx, style);
            if (hasStroke) $a639152f35090585$var$doStrokePath(ctx, style);
        }
    }
    if (lineDash) ctx.setLineDash([]);
}
function $a639152f35090585$var$brushImage(ctx, el, style) {
    var image = el.__image = (0, $d03a6f18dabd43b1$export$46c791b69ff9a0f)(style.image, el.__image, el, el.onload);
    if (!image || !(0, $d03a6f18dabd43b1$export$37ca7dd901d0236d)(image)) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var width = el.getWidth();
    var height = el.getHeight();
    var aspect = image.width / image.height;
    if (width == null && height != null) width = height * aspect;
    else if (height == null && width != null) height = width / aspect;
    else if (width == null && height == null) {
        width = image.width;
        height = image.height;
    }
    if (style.sWidth && style.sHeight) {
        var sx = style.sx || 0;
        var sy = style.sy || 0;
        ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
    } else if (style.sx && style.sy) {
        var sx = style.sx;
        var sy = style.sy;
        var sWidth = width - sx;
        var sHeight = height - sy;
        ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
    } else ctx.drawImage(image, x, y, width, height);
}
function $a639152f35090585$var$brushText(ctx, el, style) {
    var _a;
    var text = style.text;
    text != null && (text += '');
    if (text) {
        ctx.font = style.font || (0, $024b63ea846a8ccd$export$7d7a232b6d2cc80c);
        ctx.textAlign = style.textAlign;
        ctx.textBaseline = style.textBaseline;
        var lineDash = void 0;
        var lineDashOffset = void 0;
        if (ctx.setLineDash && style.lineDash) _a = (0, $ceacb1517b0bd545$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
        if (lineDash) {
            ctx.setLineDash(lineDash);
            ctx.lineDashOffset = lineDashOffset;
        }
        if (style.strokeFirst) {
            if ($a639152f35090585$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
            if ($a639152f35090585$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
        } else {
            if ($a639152f35090585$var$styleHasFill(style)) ctx.fillText(text, style.x, style.y);
            if ($a639152f35090585$var$styleHasStroke(style)) ctx.strokeText(text, style.x, style.y);
        }
        if (lineDash) ctx.setLineDash([]);
    }
}
var $a639152f35090585$var$SHADOW_NUMBER_PROPS = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $a639152f35090585$var$STROKE_PROPS = [
    [
        'lineCap',
        'butt'
    ],
    [
        'lineJoin',
        'miter'
    ],
    [
        'miterLimit',
        10
    ]
];
function $a639152f35090585$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope) {
    var styleChanged = false;
    if (!forceSetAll) {
        prevStyle = prevStyle || {};
        if (style === prevStyle) return false;
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        $a639152f35090585$var$flushPathDrawn(ctx, scope);
        styleChanged = true;
        var opacity = Math.max(Math.min(style.opacity, 1), 0);
        ctx.globalAlpha = isNaN(opacity) ? (0, $cfd8540aca1ca40f$export$737672163db00fe3).opacity : opacity;
    }
    if (forceSetAll || style.blend !== prevStyle.blend) {
        if (!styleChanged) {
            $a639152f35090585$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalCompositeOperation = style.blend || (0, $cfd8540aca1ca40f$export$737672163db00fe3).blend;
    }
    for(var i = 0; i < $a639152f35090585$var$SHADOW_NUMBER_PROPS.length; i++){
        var propName = $a639152f35090585$var$SHADOW_NUMBER_PROPS[i];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $a639152f35090585$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = ctx.dpr * (style[propName] || 0);
        }
    }
    if (forceSetAll || style.shadowColor !== prevStyle.shadowColor) {
        if (!styleChanged) {
            $a639152f35090585$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.shadowColor = style.shadowColor || (0, $cfd8540aca1ca40f$export$737672163db00fe3).shadowColor;
    }
    return styleChanged;
}
function $a639152f35090585$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetAll, scope) {
    var style = $a639152f35090585$var$getStyle(el, scope.inHover);
    var prevStyle = forceSetAll ? null : prevEl && $a639152f35090585$var$getStyle(prevEl, scope.inHover) || {};
    if (style === prevStyle) return false;
    var styleChanged = $a639152f35090585$var$bindCommonProps(ctx, style, prevStyle, forceSetAll, scope);
    if (forceSetAll || style.fill !== prevStyle.fill) {
        if (!styleChanged) {
            $a639152f35090585$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $a639152f35090585$var$isValidStrokeFillStyle(style.fill) && (ctx.fillStyle = style.fill);
    }
    if (forceSetAll || style.stroke !== prevStyle.stroke) {
        if (!styleChanged) {
            $a639152f35090585$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        $a639152f35090585$var$isValidStrokeFillStyle(style.stroke) && (ctx.strokeStyle = style.stroke);
    }
    if (forceSetAll || style.opacity !== prevStyle.opacity) {
        if (!styleChanged) {
            $a639152f35090585$var$flushPathDrawn(ctx, scope);
            styleChanged = true;
        }
        ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
    }
    if (el.hasStroke()) {
        var lineWidth = style.lineWidth;
        var newLineWidth = lineWidth / (style.strokeNoScale && el.getLineScale ? el.getLineScale() : 1);
        if (ctx.lineWidth !== newLineWidth) {
            if (!styleChanged) {
                $a639152f35090585$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx.lineWidth = newLineWidth;
        }
    }
    for(var i = 0; i < $a639152f35090585$var$STROKE_PROPS.length; i++){
        var prop = $a639152f35090585$var$STROKE_PROPS[i];
        var propName = prop[0];
        if (forceSetAll || style[propName] !== prevStyle[propName]) {
            if (!styleChanged) {
                $a639152f35090585$var$flushPathDrawn(ctx, scope);
                styleChanged = true;
            }
            ctx[propName] = style[propName] || prop[1];
        }
    }
    return styleChanged;
}
function $a639152f35090585$var$bindImageStyle(ctx, el, prevEl, forceSetAll, scope) {
    return $a639152f35090585$var$bindCommonProps(ctx, $a639152f35090585$var$getStyle(el, scope.inHover), prevEl && $a639152f35090585$var$getStyle(prevEl, scope.inHover), forceSetAll, scope);
}
function $a639152f35090585$var$setContextTransform(ctx, el) {
    var m = el.transform;
    var dpr = ctx.dpr || 1;
    if (m) ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
    else ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
}
function $a639152f35090585$var$updateClipStatus(clipPaths, ctx, scope) {
    var allClipped = false;
    for(var i = 0; i < clipPaths.length; i++){
        var clipPath = clipPaths[i];
        allClipped = allClipped || clipPath.isZeroArea();
        $a639152f35090585$var$setContextTransform(ctx, clipPath);
        ctx.beginPath();
        clipPath.buildPath(ctx, clipPath.shape);
        ctx.clip();
    }
    scope.allClipped = allClipped;
}
function $a639152f35090585$var$isTransformChanged(m0, m1) {
    if (m0 && m1) return m0[0] !== m1[0] || m0[1] !== m1[1] || m0[2] !== m1[2] || m0[3] !== m1[3] || m0[4] !== m1[4] || m0[5] !== m1[5];
    else if (!m0 && !m1) return false;
    return true;
}
var $a639152f35090585$var$DRAW_TYPE_PATH = 1;
var $a639152f35090585$var$DRAW_TYPE_IMAGE = 2;
var $a639152f35090585$var$DRAW_TYPE_TEXT = 3;
var $a639152f35090585$var$DRAW_TYPE_INCREMENTAL = 4;
function $a639152f35090585$var$canPathBatch(style) {
    var hasFill = $a639152f35090585$var$styleHasFill(style);
    var hasStroke = $a639152f35090585$var$styleHasStroke(style);
    return !(style.lineDash || !(+hasFill ^ +hasStroke) || hasFill && typeof style.fill !== 'string' || hasStroke && typeof style.stroke !== 'string' || style.strokePercent < 1 || style.strokeOpacity < 1 || style.fillOpacity < 1);
}
function $a639152f35090585$var$flushPathDrawn(ctx, scope) {
    scope.batchFill && ctx.fill();
    scope.batchStroke && ctx.stroke();
    scope.batchFill = '';
    scope.batchStroke = '';
}
function $a639152f35090585$var$getStyle(el, inHover) {
    return inHover ? el.__hoverStyle || el.style : el.style;
}
function $a639152f35090585$export$567881adfc3eb7f3(ctx, el) {
    $a639152f35090585$export$da5d6544e8c27bc1(ctx, el, {
        inHover: false,
        viewWidth: 0,
        viewHeight: 0
    }, true);
}
function $a639152f35090585$export$da5d6544e8c27bc1(ctx, el, scope, isLast) {
    var m = el.transform;
    if (!el.shouldBePainted(scope.viewWidth, scope.viewHeight, false, false)) {
        el.__dirty &= ~(0, $7bc42091a9de0611$export$a7b6db622c6c7dbd);
        el.__isRendered = false;
        return;
    }
    var clipPaths = el.__clipPaths;
    var prevElClipPaths = scope.prevElClipPaths;
    var forceSetTransform = false;
    var forceSetStyle = false;
    if (!prevElClipPaths || (0, $9b483e37735cf979$export$beeddc5150cb2e83)(clipPaths, prevElClipPaths)) {
        if (prevElClipPaths && prevElClipPaths.length) {
            $a639152f35090585$var$flushPathDrawn(ctx, scope);
            ctx.restore();
            forceSetStyle = forceSetTransform = true;
            scope.prevElClipPaths = null;
            scope.allClipped = false;
            scope.prevEl = null;
        }
        if (clipPaths && clipPaths.length) {
            $a639152f35090585$var$flushPathDrawn(ctx, scope);
            ctx.save();
            $a639152f35090585$var$updateClipStatus(clipPaths, ctx, scope);
            forceSetTransform = true;
        }
        scope.prevElClipPaths = clipPaths;
    }
    if (scope.allClipped) {
        el.__isRendered = false;
        return;
    }
    el.beforeBrush && el.beforeBrush();
    el.innerBeforeBrush();
    var prevEl = scope.prevEl;
    if (!prevEl) forceSetStyle = forceSetTransform = true;
    var canBatchPath = el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039) && el.autoBatch && $a639152f35090585$var$canPathBatch(el.style);
    if (forceSetTransform || $a639152f35090585$var$isTransformChanged(m, prevEl.transform)) {
        $a639152f35090585$var$flushPathDrawn(ctx, scope);
        $a639152f35090585$var$setContextTransform(ctx, el);
    } else if (!canBatchPath) $a639152f35090585$var$flushPathDrawn(ctx, scope);
    var style = $a639152f35090585$var$getStyle(el, scope.inHover);
    if (el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039)) {
        if (scope.lastDrawType !== $a639152f35090585$var$DRAW_TYPE_PATH) {
            forceSetStyle = true;
            scope.lastDrawType = $a639152f35090585$var$DRAW_TYPE_PATH;
        }
        $a639152f35090585$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
        if (!canBatchPath || !scope.batchFill && !scope.batchStroke) ctx.beginPath();
        $a639152f35090585$var$brushPath(ctx, el, style, canBatchPath);
        if (canBatchPath) {
            scope.batchFill = style.fill || '';
            scope.batchStroke = style.stroke || '';
        }
    } else {
        if (el instanceof (0, $d14badf4d84ba4b7$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $a639152f35090585$var$DRAW_TYPE_TEXT) {
                forceSetStyle = true;
                scope.lastDrawType = $a639152f35090585$var$DRAW_TYPE_TEXT;
            }
            $a639152f35090585$var$bindPathAndTextCommonStyle(ctx, el, prevEl, forceSetStyle, scope);
            $a639152f35090585$var$brushText(ctx, el, style);
        } else if (el instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) {
            if (scope.lastDrawType !== $a639152f35090585$var$DRAW_TYPE_IMAGE) {
                forceSetStyle = true;
                scope.lastDrawType = $a639152f35090585$var$DRAW_TYPE_IMAGE;
            }
            $a639152f35090585$var$bindImageStyle(ctx, el, prevEl, forceSetStyle, scope);
            $a639152f35090585$var$brushImage(ctx, el, style);
        } else if (el.getTemporalDisplayables) {
            if (scope.lastDrawType !== $a639152f35090585$var$DRAW_TYPE_INCREMENTAL) {
                forceSetStyle = true;
                scope.lastDrawType = $a639152f35090585$var$DRAW_TYPE_INCREMENTAL;
            }
            $a639152f35090585$var$brushIncremental(ctx, el, scope);
        }
    }
    if (canBatchPath && isLast) $a639152f35090585$var$flushPathDrawn(ctx, scope);
    el.innerAfterBrush();
    el.afterBrush && el.afterBrush();
    scope.prevEl = el;
    el.__dirty = 0;
    el.__isRendered = true;
}
function $a639152f35090585$var$brushIncremental(ctx, el, scope) {
    var displayables = el.getDisplayables();
    var temporalDisplayables = el.getTemporalDisplayables();
    ctx.save();
    var innerScope = {
        prevElClipPaths: null,
        prevEl: null,
        allClipped: false,
        viewWidth: scope.viewWidth,
        viewHeight: scope.viewHeight,
        inHover: scope.inHover
    };
    var i;
    var len;
    for(i = el.getCursor(), len = displayables.length; i < len; i++){
        var displayable = displayables[i];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $a639152f35090585$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i === len - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    for(var i_1 = 0, len_1 = temporalDisplayables.length; i_1 < len_1; i_1++){
        var displayable = temporalDisplayables[i_1];
        displayable.beforeBrush && displayable.beforeBrush();
        displayable.innerBeforeBrush();
        $a639152f35090585$export$da5d6544e8c27bc1(ctx, displayable, innerScope, i_1 === len_1 - 1);
        displayable.innerAfterBrush();
        displayable.afterBrush && displayable.afterBrush();
        innerScope.prevEl = displayable;
    }
    el.clearTemporalDisplayables();
    el.notClear = true;
    ctx.restore();
}



var $6d9628e7c6bac2b0$var$decalMap = new (0, $83864c6cb0bbf083$export$2e2bcd8739ae039)();
var $6d9628e7c6bac2b0$var$decalCache = new (0, $db88c5ee7dbc7394$export$2e2bcd8739ae039)(100);
var $6d9628e7c6bac2b0$var$decalKeys = [
    'symbol',
    'symbolSize',
    'symbolKeepAspect',
    'color',
    'backgroundColor',
    'dashArrayX',
    'dashArrayY',
    'maxTileWidth',
    'maxTileHeight'
];
function $6d9628e7c6bac2b0$export$a3ba048e1a648972(decalObject, api) {
    if (decalObject === 'none') return null;
    var dpr = api.getDevicePixelRatio();
    var zr = api.getZr();
    var isSVG = zr.painter.type === 'svg';
    if (decalObject.dirty) $6d9628e7c6bac2b0$var$decalMap["delete"](decalObject);
    var oldPattern = $6d9628e7c6bac2b0$var$decalMap.get(decalObject);
    if (oldPattern) return oldPattern;
    var decalOpt = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(decalObject, {
        symbol: 'rect',
        symbolSize: 1,
        symbolKeepAspect: true,
        color: 'rgba(0, 0, 0, 0.2)',
        backgroundColor: null,
        dashArrayX: 5,
        dashArrayY: 5,
        rotation: 0,
        maxTileWidth: 512,
        maxTileHeight: 512
    });
    if (decalOpt.backgroundColor === 'none') decalOpt.backgroundColor = null;
    var pattern = {
        repeat: 'repeat'
    };
    setPatternnSource(pattern);
    pattern.rotation = decalOpt.rotation;
    pattern.scaleX = pattern.scaleY = isSVG ? 1 : 1 / dpr;
    $6d9628e7c6bac2b0$var$decalMap.set(decalObject, pattern);
    decalObject.dirty = false;
    return pattern;
    function setPatternnSource(pattern) {
        var keys = [
            dpr
        ];
        var isValidKey = true;
        for(var i = 0; i < $6d9628e7c6bac2b0$var$decalKeys.length; ++i){
            var value = decalOpt[$6d9628e7c6bac2b0$var$decalKeys[i]];
            if (value != null && !(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(value) && !(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(value) && !(0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(value) && typeof value !== 'boolean') {
                isValidKey = false;
                break;
            }
            keys.push(value);
        }
        var cacheKey;
        if (isValidKey) {
            cacheKey = keys.join(',') + (isSVG ? '-svg' : '');
            var cache = $6d9628e7c6bac2b0$var$decalCache.get(cacheKey);
            if (cache) isSVG ? pattern.svgElement = cache : pattern.image = cache;
        }
        var dashArrayX = $6d9628e7c6bac2b0$var$normalizeDashArrayX(decalOpt.dashArrayX);
        var dashArrayY = $6d9628e7c6bac2b0$var$normalizeDashArrayY(decalOpt.dashArrayY);
        var symbolArray = $6d9628e7c6bac2b0$var$normalizeSymbolArray(decalOpt.symbol);
        var lineBlockLengthsX = $6d9628e7c6bac2b0$var$getLineBlockLengthX(dashArrayX);
        var lineBlockLengthY = $6d9628e7c6bac2b0$var$getLineBlockLengthY(dashArrayY);
        var canvas = !isSVG && (0, $024b63ea846a8ccd$export$ef5e599365494451).createCanvas();
        var svgRoot = isSVG && {
            tag: 'g',
            attrs: {},
            key: 'dcl',
            children: []
        };
        var pSize = getPatternSize();
        var ctx;
        if (canvas) {
            canvas.width = pSize.width * dpr;
            canvas.height = pSize.height * dpr;
            ctx = canvas.getContext('2d');
        }
        brushDecal();
        if (isValidKey) $6d9628e7c6bac2b0$var$decalCache.put(cacheKey, canvas || svgRoot);
        pattern.image = canvas;
        pattern.svgElement = svgRoot;
        pattern.svgWidth = pSize.width;
        pattern.svgHeight = pSize.height;
        /**
     * Get minimum length that can make a repeatable pattern.
     *
     * @return {Object} pattern width and height
     */ function getPatternSize() {
            /**
       * For example, if dash is [[3, 2], [2, 1]] for X, it looks like
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * |---  ---  ---  ---  --- ...
       * |-- -- -- -- -- -- -- -- ...
       * So the minimum length of X is 15,
       * which is the least common multiple of `3 + 2` and `2 + 1`
       * |---  ---  ---  |---  --- ...
       * |-- -- -- -- -- |-- -- -- ...
       */ var width = 1;
            for(var i = 0, xlen = lineBlockLengthsX.length; i < xlen; ++i)width = (0, $9fd90cf3bf18fbcd$export$680a45b749323f49)(width, lineBlockLengthsX[i]);
            var symbolRepeats = 1;
            for(var i = 0, xlen = symbolArray.length; i < xlen; ++i)symbolRepeats = (0, $9fd90cf3bf18fbcd$export$680a45b749323f49)(symbolRepeats, symbolArray[i].length);
            width *= symbolRepeats;
            var height = lineBlockLengthY * lineBlockLengthsX.length * symbolArray.length;
            var warn;
            return {
                width: Math.max(1, Math.min(width, decalOpt.maxTileWidth)),
                height: Math.max(1, Math.min(height, decalOpt.maxTileHeight))
            };
        }
        function brushDecal() {
            if (ctx) {
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                if (decalOpt.backgroundColor) {
                    ctx.fillStyle = decalOpt.backgroundColor;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                }
            }
            var ySum = 0;
            for(var i = 0; i < dashArrayY.length; ++i)ySum += dashArrayY[i];
            if (ySum <= 0) // dashArrayY is 0, draw nothing
            return;
            var y = -lineBlockLengthY;
            var yId = 0;
            var yIdTotal = 0;
            var xId0 = 0;
            while(y < pSize.height){
                if (yId % 2 === 0) {
                    var symbolYId = yIdTotal / 2 % symbolArray.length;
                    var x = 0;
                    var xId1 = 0;
                    var xId1Total = 0;
                    while(x < pSize.width * 2){
                        var xSum = 0;
                        for(var i = 0; i < dashArrayX[xId0].length; ++i)xSum += dashArrayX[xId0][i];
                        if (xSum <= 0) break;
                        // E.g., [15, 5, 20, 5] draws only for 15 and 20
                        if (xId1 % 2 === 0) {
                            var size = (1 - decalOpt.symbolSize) * 0.5;
                            var left = x + dashArrayX[xId0][xId1] * size;
                            var top_1 = y + dashArrayY[yId] * size;
                            var width = dashArrayX[xId0][xId1] * decalOpt.symbolSize;
                            var height = dashArrayY[yId] * decalOpt.symbolSize;
                            var symbolXId = xId1Total / 2 % symbolArray[symbolYId].length;
                            brushSymbol(left, top_1, width, height, symbolArray[symbolYId][symbolXId]);
                        }
                        x += dashArrayX[xId0][xId1];
                        ++xId1Total;
                        ++xId1;
                        if (xId1 === dashArrayX[xId0].length) xId1 = 0;
                    }
                    ++xId0;
                    if (xId0 === dashArrayX.length) xId0 = 0;
                }
                y += dashArrayY[yId];
                ++yIdTotal;
                ++yId;
                if (yId === dashArrayY.length) yId = 0;
            }
            function brushSymbol(x, y, width, height, symbolType) {
                var scale = isSVG ? 1 : dpr;
                var symbol = (0, $da6220012439db7b$export$af050e04da3a02e8)(symbolType, x * scale, y * scale, width * scale, height * scale, decalOpt.color, decalOpt.symbolKeepAspect);
                if (isSVG) {
                    var symbolVNode = zr.painter.renderOneToVNode(symbol);
                    if (symbolVNode) svgRoot.children.push(symbolVNode);
                } else // Paint to canvas for all other renderers.
                (0, $a639152f35090585$export$567881adfc3eb7f3)(ctx, symbol);
            }
        }
    }
}
/**
 * Convert symbol array into normalized array
 *
 * @param {string | (string | string[])[]} symbol symbol input
 * @return {string[][]} normolized symbol array
 */ function $6d9628e7c6bac2b0$var$normalizeSymbolArray(symbol) {
    if (!symbol || symbol.length === 0) return [
        [
            'rect'
        ]
    ];
    if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(symbol)) return [
        [
            symbol
        ]
    ];
    var isAllString = true;
    for(var i = 0; i < symbol.length; ++i)if (!(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(symbol[i])) {
        isAllString = false;
        break;
    }
    if (isAllString) return $6d9628e7c6bac2b0$var$normalizeSymbolArray([
        symbol
    ]);
    var result = [];
    for(var i = 0; i < symbol.length; ++i)if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(symbol[i])) result.push([
        symbol[i]
    ]);
    else result.push(symbol[i]);
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayX} dash dash input
 * @return {number[][]} normolized dash array
 */ function $6d9628e7c6bac2b0$var$normalizeDashArrayX(dash) {
    if (!dash || dash.length === 0) return [
        [
            0,
            0
        ]
    ];
    if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(dash)) {
        var dashValue = Math.ceil(dash);
        return [
            [
                dashValue,
                dashValue
            ]
        ];
    }
    /**
   * [20, 5] should be normalized into [[20, 5]],
   * while [20, [5, 10]] should be normalized into [[20, 20], [5, 10]]
   */ var isAllNumber = true;
    for(var i = 0; i < dash.length; ++i)if (!(0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(dash[i])) {
        isAllNumber = false;
        break;
    }
    if (isAllNumber) return $6d9628e7c6bac2b0$var$normalizeDashArrayX([
        dash
    ]);
    var result = [];
    for(var i = 0; i < dash.length; ++i)if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(dash[i])) {
        var dashValue = Math.ceil(dash[i]);
        result.push([
            dashValue,
            dashValue
        ]);
    } else {
        var dashValue = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(dash[i], function(n) {
            return Math.ceil(n);
        });
        if (dashValue.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
        // so normalize it to be [4, 2, 1, 4, 2, 1]
        result.push(dashValue.concat(dashValue));
        else result.push(dashValue);
    }
    return result;
}
/**
 * Convert dash input into dashArray
 *
 * @param {DecalDashArrayY} dash dash input
 * @return {number[]} normolized dash array
 */ function $6d9628e7c6bac2b0$var$normalizeDashArrayY(dash) {
    if (!dash || typeof dash === 'object' && dash.length === 0) return [
        0,
        0
    ];
    if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(dash)) {
        var dashValue_1 = Math.ceil(dash);
        return [
            dashValue_1,
            dashValue_1
        ];
    }
    var dashValue = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(dash, function(n) {
        return Math.ceil(n);
    });
    return dash.length % 2 ? dashValue.concat(dashValue) : dashValue;
}
/**
 * Get block length of each line. A block is the length of dash line and space.
 * For example, a line with [4, 1] has a dash line of 4 and a space of 1 after
 * that, so the block length of this line is 5.
 *
 * @param {number[][]} dash dash array of X or Y
 * @return {number[]} block length of each line
 */ function $6d9628e7c6bac2b0$var$getLineBlockLengthX(dash) {
    return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(dash, function(line) {
        return $6d9628e7c6bac2b0$var$getLineBlockLengthY(line);
    });
}
function $6d9628e7c6bac2b0$var$getLineBlockLengthY(dash) {
    var blockLength = 0;
    for(var i = 0; i < dash.length; ++i)blockLength += dash[i];
    if (dash.length % 2 === 1) // [4, 2, 1] means |----  -    -- |----  -    -- |
    // So total length is (4 + 2 + 1) * 2
    return blockLength * 2;
    return blockLength;
}


function $250689bdf6db13c0$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachRawSeries(function(seriesModel) {
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var data = seriesModel.getData();
        if (data.hasItemVisual()) data.each(function(idx) {
            var decal = data.getItemVisual(idx, 'decal');
            if (decal) {
                var itemStyle = data.ensureUniqueItemVisual(idx, 'style');
                itemStyle.decal = (0, $6d9628e7c6bac2b0$export$a3ba048e1a648972)(decal, api);
            }
        });
        var decal = data.getVisual('decal');
        if (decal) {
            var style = data.getVisual('style');
            style.decal = (0, $6d9628e7c6bac2b0$export$a3ba048e1a648972)(decal, api);
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $084ca3e1f7dbc024$var$lifecycle = new (0, $abe8d7fba81d88ed$export$2e2bcd8739ae039)();
var $084ca3e1f7dbc024$export$2e2bcd8739ae039 = $084ca3e1f7dbc024$var$lifecycle;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// Implementation of exported APIs. For example registerMap, getMap.
// The implementations will be registered when installing the component.
// Avoid these code being bundled to the core module.
var $5f25fe6b1afe7568$var$implsStore = {};
function $5f25fe6b1afe7568$export$9b808fd12256ddd3(name, impl) {
    $5f25fe6b1afe7568$var$implsStore[name] = impl;
}
function $5f25fe6b1afe7568$export$73333eb8a09d5f61(name) {
    return $5f25fe6b1afe7568$var$implsStore[name];
}


var $b45c5a9506b77a4f$export$83d89fbfd8236492 = '5.6.0';
var $b45c5a9506b77a4f$export$b74ff737e0e298b5 = {
    zrender: '5.6.1'
};
var $b45c5a9506b77a4f$var$TEST_FRAME_REMAIN_TIME = 1;
var $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_SERIES_FILTER = 800;
// Some data processors depends on the stack result dimension (to calculate data extent).
// So data stack stage should be in front of data processing stage.
var $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_DATASTACK = 900;
// "Data filter" will block the stream, so it should be
// put at the beginning of data processing.
var $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_FILTER = 1000;
var $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_DEFAULT = 2000;
var $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_STATISTIC = 5000;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_LAYOUT = 1000;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_GLOBAL = 2000;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART = 3000;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_COMPONENT = 4000;
// Visual property in data. Greater than `PRIORITY_VISUAL_COMPONENT` to enable to
// overwrite the viusal result of component (like `visualMap`)
// using data item specific setting (like itemStyle.xxx on data item)
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM = 4500;
// Greater than `PRIORITY_VISUAL_CHART_DATA_CUSTOM` to enable to layout based on
// visual result like `symbolSize`.
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_POST_CHART_LAYOUT = 4600;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_BRUSH = 5000;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_ARIA = 6000;
var $b45c5a9506b77a4f$var$PRIORITY_VISUAL_DECAL = 7000;
var $b45c5a9506b77a4f$export$bb34f3538ba26c7e = {
    PROCESSOR: {
        FILTER: $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_FILTER,
        SERIES_FILTER: $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_SERIES_FILTER,
        STATISTIC: $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_STATISTIC
    },
    VISUAL: {
        LAYOUT: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_LAYOUT,
        PROGRESSIVE_LAYOUT: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
        GLOBAL: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_GLOBAL,
        CHART: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART,
        POST_CHART_LAYOUT: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_POST_CHART_LAYOUT,
        COMPONENT: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_COMPONENT,
        BRUSH: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_BRUSH,
        CHART_ITEM: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM,
        ARIA: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_ARIA,
        DECAL: $b45c5a9506b77a4f$var$PRIORITY_VISUAL_DECAL
    }
};
// Main process have three entries: `setOption`, `dispatchAction` and `resize`,
// where they must not be invoked nestedly, except the only case: invoke
// dispatchAction with updateMethod "none" in main process.
// This flag is used to carry out this rule.
// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
var $b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY = '__flagInMainProcess';
var $b45c5a9506b77a4f$var$PENDING_UPDATE = '__pendingUpdate';
var $b45c5a9506b77a4f$var$STATUS_NEEDS_UPDATE_KEY = '__needsUpdateStatus';
var $b45c5a9506b77a4f$var$ACTION_REG = /^[a-zA-Z0-9_]+$/;
var $b45c5a9506b77a4f$var$CONNECT_STATUS_KEY = '__connectUpdateStatus';
var $b45c5a9506b77a4f$var$CONNECT_STATUS_PENDING = 0;
var $b45c5a9506b77a4f$var$CONNECT_STATUS_UPDATING = 1;
var $b45c5a9506b77a4f$var$CONNECT_STATUS_UPDATED = 2;
function $b45c5a9506b77a4f$var$createRegisterEventWithLowercaseECharts(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (this.isDisposed()) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        return $b45c5a9506b77a4f$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $b45c5a9506b77a4f$var$createRegisterEventWithLowercaseMessageCenter(method) {
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $b45c5a9506b77a4f$var$toLowercaseNameAndCallEventful(this, method, args);
    };
}
function $b45c5a9506b77a4f$var$toLowercaseNameAndCallEventful(host, method, args) {
    // `args[0]` is event name. Event name is all lowercase.
    args[0] = args[0] && args[0].toLowerCase();
    return (0, $abe8d7fba81d88ed$export$2e2bcd8739ae039).prototype[method].apply(host, args);
}
var $b45c5a9506b77a4f$var$MessageCenter = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MessageCenter, _super);
    function MessageCenter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MessageCenter;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
var $b45c5a9506b77a4f$var$messageCenterProto = $b45c5a9506b77a4f$var$MessageCenter.prototype;
$b45c5a9506b77a4f$var$messageCenterProto.on = $b45c5a9506b77a4f$var$createRegisterEventWithLowercaseMessageCenter('on');
$b45c5a9506b77a4f$var$messageCenterProto.off = $b45c5a9506b77a4f$var$createRegisterEventWithLowercaseMessageCenter('off');
// ---------------------------------------
// Internal method names for class ECharts
// ---------------------------------------
var $b45c5a9506b77a4f$var$prepare;
var $b45c5a9506b77a4f$var$prepareView;
var $b45c5a9506b77a4f$var$updateDirectly;
var $b45c5a9506b77a4f$var$updateMethods;
var $b45c5a9506b77a4f$var$doConvertPixel;
var $b45c5a9506b77a4f$var$updateStreamModes;
var $b45c5a9506b77a4f$var$doDispatchAction;
var $b45c5a9506b77a4f$var$flushPendingActions;
var $b45c5a9506b77a4f$var$triggerUpdatedEvent;
var $b45c5a9506b77a4f$var$bindRenderedEvent;
var $b45c5a9506b77a4f$var$bindMouseEvent;
var $b45c5a9506b77a4f$var$render;
var $b45c5a9506b77a4f$var$renderComponents;
var $b45c5a9506b77a4f$var$renderSeries;
var $b45c5a9506b77a4f$var$createExtensionAPI;
var $b45c5a9506b77a4f$var$enableConnect;
var $b45c5a9506b77a4f$var$markStatusToUpdate;
var $b45c5a9506b77a4f$var$applyChangedStates;
var $b45c5a9506b77a4f$var$ECharts = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ECharts, _super);
    function ECharts(dom, // Theme name or themeOption.
    theme, opts) {
        var _this = _super.call(this, new (0, $e30ccc45656fd95c$export$d0fd09f950257b52)()) || this;
        _this._chartsViews = [];
        _this._chartsMap = {};
        _this._componentsViews = [];
        _this._componentsMap = {};
        // Can't dispatch action during rendering procedure
        _this._pendingActions = [];
        opts = opts || {};
        // Get theme by name
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(theme)) theme = $b45c5a9506b77a4f$var$themeStorage[theme];
        _this._dom = dom;
        var defaultRenderer = 'canvas';
        var defaultCoarsePointer = 'auto';
        var defaultUseDirtyRect = false;
        var root;
        if (opts.ssr) $a6ecc7edacba791e$export$e7a09d7fe68a4f7(function(el) {
            var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            if (dataIndex == null) return;
            var hashMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
            hashMap.set('series_index', ecData.seriesIndex);
            hashMap.set('data_index', dataIndex);
            ecData.ssrType && hashMap.set('ssr_type', ecData.ssrType);
            return hashMap;
        });
        var zr = _this._zr = $a6ecc7edacba791e$export$2cd8252107eb640b(dom, {
            renderer: opts.renderer || defaultRenderer,
            devicePixelRatio: opts.devicePixelRatio,
            width: opts.width,
            height: opts.height,
            ssr: opts.ssr,
            useDirtyRect: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(opts.useDirtyRect, defaultUseDirtyRect),
            useCoarsePointer: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(opts.useCoarsePointer, defaultCoarsePointer),
            pointerSize: opts.pointerSize
        });
        _this._ssr = opts.ssr;
        // Expect 60 fps.
        _this._throttledZrFlush = (0, $ef22ba67fe7cfc59$export$de363e709c412c8a)((0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(zr.flush, zr), 17);
        theme = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(theme);
        theme && (0, $cd438069cbdf9f3c$export$2e2bcd8739ae039)(theme, true);
        _this._theme = theme;
        _this._locale = (0, $db1a0fc42a360ea2$export$ddc371781a6af754)(opts.locale || (0, $db1a0fc42a360ea2$export$9a2147b3808d4c6b));
        _this._coordSysMgr = new (0, $02d04429d2792472$export$2e2bcd8739ae039)();
        var api = _this._api = $b45c5a9506b77a4f$var$createExtensionAPI(_this);
        // Sort on demand
        function prioritySortFunc(a, b) {
            return a.__prio - b.__prio;
        }
        (0, $f91119cfbd7f3e96$export$2e2bcd8739ae039)($b45c5a9506b77a4f$var$visualFuncs, prioritySortFunc);
        (0, $f91119cfbd7f3e96$export$2e2bcd8739ae039)($b45c5a9506b77a4f$var$dataProcessorFuncs, prioritySortFunc);
        _this._scheduler = new (0, $930979848c1a297c$export$2e2bcd8739ae039)(_this, api, $b45c5a9506b77a4f$var$dataProcessorFuncs, $b45c5a9506b77a4f$var$visualFuncs);
        _this._messageCenter = new $b45c5a9506b77a4f$var$MessageCenter();
        // Init mouse events
        _this._initEvents();
        // In case some people write `window.onresize = chart.resize`
        _this.resize = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this.resize, _this);
        zr.animation.on('frame', _this._onframe, _this);
        $b45c5a9506b77a4f$var$bindRenderedEvent(zr, _this);
        $b45c5a9506b77a4f$var$bindMouseEvent(zr, _this);
        // ECharts instance can be used as value.
        (0, $1b239fc9d3a2f8ae$export$112e66431016387b)(_this);
        return _this;
    }
    ECharts.prototype._onframe = function() {
        if (this._disposed) return;
        $b45c5a9506b77a4f$var$applyChangedStates(this);
        var scheduler = this._scheduler;
        // Lazy update
        if (this[$b45c5a9506b77a4f$var$PENDING_UPDATE]) {
            var silent = this[$b45c5a9506b77a4f$var$PENDING_UPDATE].silent;
            this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = true;
            try {
                $b45c5a9506b77a4f$var$prepare(this);
                $b45c5a9506b77a4f$var$updateMethods.update.call(this, null, this[$b45c5a9506b77a4f$var$PENDING_UPDATE].updateParams);
            } catch (e) {
                this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
                this[$b45c5a9506b77a4f$var$PENDING_UPDATE] = null;
                throw e;
            }
            // At present, in each frame, zrender performs:
            //   (1) animation step forward.
            //   (2) trigger('frame') (where this `_onframe` is called)
            //   (3) zrender flush (render).
            // If we do nothing here, since we use `setToFinal: true`, the step (3) above
            // will render the final state of the elements before the real animation started.
            this._zr.flush();
            this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
            this[$b45c5a9506b77a4f$var$PENDING_UPDATE] = null;
            $b45c5a9506b77a4f$var$flushPendingActions.call(this, silent);
            $b45c5a9506b77a4f$var$triggerUpdatedEvent.call(this, silent);
        } else if (scheduler.unfinished) {
            // Stream progress.
            var remainTime = $b45c5a9506b77a4f$var$TEST_FRAME_REMAIN_TIME;
            var ecModel = this._model;
            var api = this._api;
            scheduler.unfinished = false;
            do {
                var startTime = +new Date();
                scheduler.performSeriesTasks(ecModel);
                // Currently dataProcessorFuncs do not check threshold.
                scheduler.performDataProcessorTasks(ecModel);
                $b45c5a9506b77a4f$var$updateStreamModes(this, ecModel);
                // Do not update coordinate system here. Because that coord system update in
                // each frame is not a good user experience. So we follow the rule that
                // the extent of the coordinate system is determined in the first frame (the
                // frame is executed immediately after task reset.
                // this._coordSysMgr.update(ecModel, api);
                // console.log('--- ec frame visual ---', remainTime);
                scheduler.performVisualTasks(ecModel);
                $b45c5a9506b77a4f$var$renderSeries(this, this._model, api, 'remain', {});
                remainTime -= +new Date() - startTime;
            }while (remainTime > 0 && scheduler.unfinished);
            // Call flush explicitly for trigger finished event.
            if (!scheduler.unfinished) this._zr.flush();
        // Else, zr flushing be ensue within the same frame,
        // because zr flushing is after onframe event.
        }
    };
    ECharts.prototype.getDom = function() {
        return this._dom;
    };
    ECharts.prototype.getId = function() {
        return this.id;
    };
    ECharts.prototype.getZr = function() {
        return this._zr;
    };
    ECharts.prototype.isSSR = function() {
        return this._ssr;
    };
    /* eslint-disable-next-line */ ECharts.prototype.setOption = function(option, notMerge, lazyUpdate) {
        if (this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        var silent;
        var replaceMerge;
        var transitionOpt;
        if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(notMerge)) {
            lazyUpdate = notMerge.lazyUpdate;
            silent = notMerge.silent;
            replaceMerge = notMerge.replaceMerge;
            transitionOpt = notMerge.transition;
            notMerge = notMerge.notMerge;
        }
        this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = true;
        if (!this._model || notMerge) {
            var optionManager = new (0, $c8dc8d8fa1d11e2c$export$2e2bcd8739ae039)(this._api);
            var theme = this._theme;
            var ecModel = this._model = new (0, $eed56b0401cb1831$export$2e2bcd8739ae039)();
            ecModel.scheduler = this._scheduler;
            ecModel.ssr = this._ssr;
            ecModel.init(null, null, null, theme, this._locale, optionManager);
        }
        this._model.setOption(option, {
            replaceMerge: replaceMerge
        }, $b45c5a9506b77a4f$var$optionPreprocessorFuncs);
        var updateParams = {
            seriesTransition: transitionOpt,
            optionChanged: true
        };
        if (lazyUpdate) {
            this[$b45c5a9506b77a4f$var$PENDING_UPDATE] = {
                silent: silent,
                updateParams: updateParams
            };
            this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
            // `setOption(option, {lazyMode: true})` may be called when zrender has been slept.
            // It should wake it up to make sure zrender start to render at the next frame.
            this.getZr().wakeUp();
        } else {
            try {
                $b45c5a9506b77a4f$var$prepare(this);
                $b45c5a9506b77a4f$var$updateMethods.update.call(this, null, updateParams);
            } catch (e) {
                this[$b45c5a9506b77a4f$var$PENDING_UPDATE] = null;
                this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Ensure zr refresh sychronously, and then pixel in canvas can be
            // fetched after `setOption`.
            if (!this._ssr) // not use flush when using ssr mode.
            this._zr.flush();
            this[$b45c5a9506b77a4f$var$PENDING_UPDATE] = null;
            this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
            $b45c5a9506b77a4f$var$flushPendingActions.call(this, silent);
            $b45c5a9506b77a4f$var$triggerUpdatedEvent.call(this, silent);
        }
    };
    /**
   * @deprecated
   */ ECharts.prototype.setTheme = function() {
        (0, $4ef07c0eafe44628$export$4a9c0b74eb885aa1)('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
    };
    // We don't want developers to use getModel directly.
    ECharts.prototype.getModel = function() {
        return this._model;
    };
    ECharts.prototype.getOption = function() {
        return this._model && this._model.getOption();
    };
    ECharts.prototype.getWidth = function() {
        return this._zr.getWidth();
    };
    ECharts.prototype.getHeight = function() {
        return this._zr.getHeight();
    };
    ECharts.prototype.getDevicePixelRatio = function() {
        return this._zr.painter.dpr || (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).hasGlobalWindow && window.devicePixelRatio || 1;
    };
    /**
   * Get canvas which has all thing rendered
   * @deprecated Use renderToCanvas instead.
   */ ECharts.prototype.getRenderedCanvas = function(opts) {
        return this.renderToCanvas(opts);
    };
    ECharts.prototype.renderToCanvas = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.getRenderedCanvas({
            backgroundColor: opts.backgroundColor || this._model.get('backgroundColor'),
            pixelRatio: opts.pixelRatio || this.getDevicePixelRatio()
        });
    };
    ECharts.prototype.renderToSVGString = function(opts) {
        opts = opts || {};
        var painter = this._zr.painter;
        return painter.renderToString({
            useViewBox: opts.useViewBox
        });
    };
    /**
   * Get svg data url
   */ ECharts.prototype.getSvgDataURL = function() {
        if (!(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).svgSupported) return;
        var zr = this._zr;
        var list = zr.storage.getDisplayList();
        // Stop animations
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(list, function(el) {
            el.stopAnimation(null, true);
        });
        return zr.painter.toDataURL();
    };
    ECharts.prototype.getDataURL = function(opts) {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        opts = opts || {};
        var excludeComponents = opts.excludeComponents;
        var ecModel = this._model;
        var excludesComponentViews = [];
        var self = this;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(excludeComponents, function(componentType) {
            ecModel.eachComponent({
                mainType: componentType
            }, function(component) {
                var view = self._componentsMap[component.__viewId];
                if (!view.group.ignore) {
                    excludesComponentViews.push(view);
                    view.group.ignore = true;
                }
            });
        });
        var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.renderToCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(excludesComponentViews, function(view) {
            view.group.ignore = false;
        });
        return url;
    };
    ECharts.prototype.getConnectedDataURL = function(opts) {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        var isSvg = opts.type === 'svg';
        var groupId = this.group;
        var mathMin = Math.min;
        var mathMax = Math.max;
        var MAX_NUMBER = Infinity;
        if ($b45c5a9506b77a4f$var$connectedGroups[groupId]) {
            var left_1 = MAX_NUMBER;
            var top_1 = MAX_NUMBER;
            var right_1 = -MAX_NUMBER;
            var bottom_1 = -MAX_NUMBER;
            var canvasList_1 = [];
            var dpr_1 = opts && opts.pixelRatio || this.getDevicePixelRatio();
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($b45c5a9506b77a4f$var$instances, function(chart, id) {
                if (chart.group === groupId) {
                    var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.renderToCanvas((0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(opts));
                    var boundingRect = chart.getDom().getBoundingClientRect();
                    left_1 = mathMin(boundingRect.left, left_1);
                    top_1 = mathMin(boundingRect.top, top_1);
                    right_1 = mathMax(boundingRect.right, right_1);
                    bottom_1 = mathMax(boundingRect.bottom, bottom_1);
                    canvasList_1.push({
                        dom: canvas,
                        left: boundingRect.left,
                        top: boundingRect.top
                    });
                }
            });
            left_1 *= dpr_1;
            top_1 *= dpr_1;
            right_1 *= dpr_1;
            bottom_1 *= dpr_1;
            var width = right_1 - left_1;
            var height = bottom_1 - top_1;
            var targetCanvas = (0, $024b63ea846a8ccd$export$ef5e599365494451).createCanvas();
            var zr_1 = $a6ecc7edacba791e$export$2cd8252107eb640b(targetCanvas, {
                renderer: isSvg ? 'svg' : 'canvas'
            });
            zr_1.resize({
                width: width,
                height: height
            });
            if (isSvg) {
                var content_1 = '';
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var x = item.left - left_1;
                    var y = item.top - top_1;
                    content_1 += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
                });
                zr_1.painter.getSvgRoot().innerHTML = content_1;
                if (opts.connectedBackgroundColor) zr_1.painter.setBackgroundColor(opts.connectedBackgroundColor);
                zr_1.refreshImmediately();
                return zr_1.painter.toDataURL();
            } else {
                // Background between the charts
                if (opts.connectedBackgroundColor) zr_1.add(new $37476269d425e3f6$export$2e2bcd8739ae039({
                    shape: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    },
                    style: {
                        fill: opts.connectedBackgroundColor
                    }
                }));
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(canvasList_1, function(item) {
                    var img = new $29f98103052059af$export$2e2bcd8739ae039({
                        style: {
                            x: item.left * dpr_1 - left_1,
                            y: item.top * dpr_1 - top_1,
                            image: item.dom
                        }
                    });
                    zr_1.add(img);
                });
                zr_1.refreshImmediately();
                return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
            }
        } else return this.getDataURL(opts);
    };
    ECharts.prototype.convertToPixel = function(finder, value) {
        return $b45c5a9506b77a4f$var$doConvertPixel(this, 'convertToPixel', finder, value);
    };
    ECharts.prototype.convertFromPixel = function(finder, value) {
        return $b45c5a9506b77a4f$var$doConvertPixel(this, 'convertFromPixel', finder, value);
    };
    /**
   * Is the specified coordinate systems or components contain the given pixel point.
   * @param {Array|number} value
   * @return {boolean} result
   */ ECharts.prototype.containPixel = function(finder, value) {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        var ecModel = this._model;
        var result;
        var findResult = $9ac03c46e8b6e711$export$95de80076abac814(ecModel, finder);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(findResult, function(models, key) {
            key.indexOf('Models') >= 0 && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(models, function(model) {
                var coordSys = model.coordinateSystem;
                if (coordSys && coordSys.containPoint) result = result || !!coordSys.containPoint(value);
                else if (key === 'seriesModels') {
                    var view = this._chartsMap[model.__viewId];
                    if (view && view.containPoint) result = result || view.containPoint(value, model);
                }
            }, this);
        }, this);
        return !!result;
    };
    /**
   * Get visual from series or data.
   * @param finder
   *        If string, e.g., 'series', means {seriesIndex: 0}.
   *        If Object, could contain some of these properties below:
   *        {
   *            seriesIndex / seriesId / seriesName,
   *            dataIndex / dataIndexInside
   *        }
   *        If dataIndex is not specified, series visual will be fetched,
   *        but not data item visual.
   *        If all of seriesIndex, seriesId, seriesName are not specified,
   *        visual will be fetched from first series.
   * @param visualType 'color', 'symbol', 'symbolSize'
   */ ECharts.prototype.getVisual = function(finder, visualType) {
        var ecModel = this._model;
        var parsedFinder = $9ac03c46e8b6e711$export$95de80076abac814(ecModel, finder, {
            defaultMainType: 'series'
        });
        var seriesModel = parsedFinder.seriesModel;
        var data = seriesModel.getData();
        var dataIndexInside = parsedFinder.hasOwnProperty('dataIndexInside') ? parsedFinder.dataIndexInside : parsedFinder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(parsedFinder.dataIndex) : null;
        return dataIndexInside != null ? (0, $aa7643c8305265d3$export$91d919a86b2df624)(data, dataIndexInside, visualType) : (0, $aa7643c8305265d3$export$d76e333a86ea1a2)(data, visualType);
    };
    /**
   * Get view of corresponding component model
   */ ECharts.prototype.getViewOfComponentModel = function(componentModel) {
        return this._componentsMap[componentModel.__viewId];
    };
    /**
   * Get view of corresponding series model
   */ ECharts.prototype.getViewOfSeriesModel = function(seriesModel) {
        return this._chartsMap[seriesModel.__viewId];
    };
    ECharts.prototype._initEvents = function() {
        var _this = this;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($b45c5a9506b77a4f$var$MOUSE_EVENT_NAMES, function(eveName) {
            var handler = function(e) {
                var ecModel = _this.getModel();
                var el = e.target;
                var params;
                var isGlobalOut = eveName === 'globalout';
                // no e.target when 'globalout'.
                if (isGlobalOut) params = {};
                else el && (0, $ee614fdac89517fb$export$8a4fca9e04eb4df6)(el, function(parent) {
                    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(parent);
                    if (ecData && ecData.dataIndex != null) {
                        var dataModel = ecData.dataModel || ecModel.getSeriesByIndex(ecData.seriesIndex);
                        params = dataModel && dataModel.getDataParams(ecData.dataIndex, ecData.dataType, el) || {};
                        return true;
                    } else if (ecData.eventData) {
                        params = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, ecData.eventData);
                        return true;
                    }
                }, true);
                // Contract: if params prepared in mouse event,
                // these properties must be specified:
                // {
                //    componentType: string (component main type)
                //    componentIndex: number
                // }
                // Otherwise event query can not work.
                if (params) {
                    var componentType = params.componentType;
                    var componentIndex = params.componentIndex;
                    // Special handling for historic reason: when trigger by
                    // markLine/markPoint/markArea, the componentType is
                    // 'markLine'/'markPoint'/'markArea', but we should better
                    // enable them to be queried by seriesIndex, since their
                    // option is set in each series.
                    if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
                        componentType = 'series';
                        componentIndex = params.seriesIndex;
                    }
                    var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
                    var view = model && _this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
                    params.event = e;
                    params.type = eveName;
                    _this._$eventProcessor.eventInfo = {
                        targetEl: el,
                        packedEvent: params,
                        model: model,
                        view: view
                    };
                    _this.trigger(eveName, params);
                }
            };
            // Consider that some component (like tooltip, brush, ...)
            // register zr event handler, but user event handler might
            // do anything, such as call `setOption` or `dispatchAction`,
            // which probably update any of the content and probably
            // cause problem if it is called previous other inner handlers.
            handler.zrEventfulCallAtLast = true;
            _this._zr.on(eveName, handler, _this);
        });
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($b45c5a9506b77a4f$var$eventActionMap, function(actionType, eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        // Extra events
        // TODO register?
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            'selectchanged'
        ], function(eventType) {
            _this._messageCenter.on(eventType, function(event) {
                this.trigger(eventType, event);
            }, _this);
        });
        (0, $4a2d4f3079e03ea2$export$2575c83262e49d0c)(this._messageCenter, this, this._api);
    };
    ECharts.prototype.isDisposed = function() {
        return this._disposed;
    };
    ECharts.prototype.clear = function() {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        this.setOption({
            series: []
        }, true);
    };
    ECharts.prototype.dispose = function() {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        this._disposed = true;
        var dom = this.getDom();
        if (dom) $9ac03c46e8b6e711$export$9fec4d97f1922e0b(this.getDom(), $b45c5a9506b77a4f$var$DOM_ATTRIBUTE_KEY, '');
        var chart = this;
        var api = chart._api;
        var ecModel = chart._model;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(chart._componentsViews, function(component) {
            component.dispose(ecModel, api);
        });
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(chart._chartsViews, function(chart) {
            chart.dispose(ecModel, api);
        });
        // Dispose after all views disposed
        chart._zr.dispose();
        // Set properties to null.
        // To reduce the memory cost in case the top code still holds this instance unexpectedly.
        chart._dom = chart._model = chart._chartsMap = chart._componentsMap = chart._chartsViews = chart._componentsViews = chart._scheduler = chart._api = chart._zr = chart._throttledZrFlush = chart._theme = chart._coordSysMgr = chart._messageCenter = null;
        delete $b45c5a9506b77a4f$var$instances[chart.id];
    };
    /**
   * Resize the chart
   */ ECharts.prototype.resize = function(opts) {
        if (this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY]) return;
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        this._zr.resize(opts);
        var ecModel = this._model;
        // Resize loading effect
        this._loadingFX && this._loadingFX.resize();
        if (!ecModel) return;
        var needPrepare = ecModel.resetOption('media');
        var silent = opts && opts.silent;
        // There is some real cases that:
        // chart.setOption(option, { lazyUpdate: true });
        // chart.resize();
        if (this[$b45c5a9506b77a4f$var$PENDING_UPDATE]) {
            if (silent == null) silent = this[$b45c5a9506b77a4f$var$PENDING_UPDATE].silent;
            needPrepare = true;
            this[$b45c5a9506b77a4f$var$PENDING_UPDATE] = null;
        }
        this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = true;
        try {
            needPrepare && $b45c5a9506b77a4f$var$prepare(this);
            $b45c5a9506b77a4f$var$updateMethods.update.call(this, {
                type: 'resize',
                animation: (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
                    // Disable animation
                    duration: 0
                }, opts && opts.animation)
            });
        } catch (e) {
            this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
            throw e;
        }
        this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
        $b45c5a9506b77a4f$var$flushPendingActions.call(this, silent);
        $b45c5a9506b77a4f$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.showLoading = function(name, cfg) {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(name)) {
            cfg = name;
            name = '';
        }
        name = name || 'default';
        this.hideLoading();
        if (!$b45c5a9506b77a4f$var$loadingEffects[name]) return;
        var el = $b45c5a9506b77a4f$var$loadingEffects[name](this._api, cfg);
        var zr = this._zr;
        this._loadingFX = el;
        zr.add(el);
    };
    /**
   * Hide loading effect
   */ ECharts.prototype.hideLoading = function() {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        this._loadingFX && this._zr.remove(this._loadingFX);
        this._loadingFX = null;
    };
    ECharts.prototype.makeActionFromEvent = function(eventObj) {
        var payload = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, eventObj);
        payload.type = $b45c5a9506b77a4f$var$eventActionMap[eventObj.type];
        return payload;
    };
    /**
   * @param opt If pass boolean, means opt.silent
   * @param opt.silent Default `false`. Whether trigger events.
   * @param opt.flush Default `undefined`.
   *        true: Flush immediately, and then pixel in canvas can be fetched
   *            immediately. Caution: it might affect performance.
   *        false: Not flush.
   *        undefined: Auto decide whether perform flush.
   */ ECharts.prototype.dispatchAction = function(payload, opt) {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        if (!(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(opt)) opt = {
            silent: !!opt
        };
        if (!$b45c5a9506b77a4f$var$actions[payload.type]) return;
        // Avoid dispatch action before setOption. Especially in `connect`.
        if (!this._model) return;
        // May dispatchAction in rendering procedure
        if (this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY]) {
            this._pendingActions.push(payload);
            return;
        }
        var silent = opt.silent;
        $b45c5a9506b77a4f$var$doDispatchAction.call(this, payload, silent);
        var flush = opt.flush;
        if (flush) this._zr.flush();
        else if (flush !== false && (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).browser.weChat) // In WeChat embedded browser, `requestAnimationFrame` and `setInterval`
        // hang when sliding page (on touch event), which cause that zr does not
        // refresh until user interaction finished, which is not expected.
        // But `dispatchAction` may be called too frequently when pan on touch
        // screen, which impacts performance if do not throttle them.
        this._throttledZrFlush();
        $b45c5a9506b77a4f$var$flushPendingActions.call(this, silent);
        $b45c5a9506b77a4f$var$triggerUpdatedEvent.call(this, silent);
    };
    ECharts.prototype.updateLabelLayout = function() {
        (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('series:layoutlabels', this._model, this._api, {
            // Not adding series labels.
            // TODO
            updatedSeries: []
        });
    };
    ECharts.prototype.appendData = function(params) {
        if (this._disposed) {
            $b45c5a9506b77a4f$var$disposedWarning(this.id);
            return;
        }
        var seriesIndex = params.seriesIndex;
        var ecModel = this.getModel();
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        seriesModel.appendData(params);
        // Note: `appendData` does not support that update extent of coordinate
        // system, util some scenario require that. In the expected usage of
        // `appendData`, the initial extent of coordinate system should better
        // be fixed by axis `min`/`max` setting or initial data, otherwise if
        // the extent changed while `appendData`, the location of the painted
        // graphic elements have to be changed, which make the usage of
        // `appendData` meaningless.
        this._scheduler.unfinished = true;
        this.getZr().wakeUp();
    };
    // A work around for no `internal` modifier in ts yet but
    // need to strictly hide private methods to JS users.
    ECharts.internalField = function() {
        $b45c5a9506b77a4f$var$prepare = function(ecIns) {
            var scheduler = ecIns._scheduler;
            scheduler.restorePipelines(ecIns._model);
            scheduler.prepareStageTasks();
            $b45c5a9506b77a4f$var$prepareView(ecIns, true);
            $b45c5a9506b77a4f$var$prepareView(ecIns, false);
            scheduler.plan();
        };
        /**
     * Prepare view instances of charts and components
     */ $b45c5a9506b77a4f$var$prepareView = function(ecIns, isComponent) {
            var ecModel = ecIns._model;
            var scheduler = ecIns._scheduler;
            var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
            var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
            var zr = ecIns._zr;
            var api = ecIns._api;
            for(var i = 0; i < viewList.length; i++)viewList[i].__alive = false;
            isComponent ? ecModel.eachComponent(function(componentType, model) {
                componentType !== 'series' && doPrepare(model);
            }) : ecModel.eachSeries(doPrepare);
            function doPrepare(model) {
                // By default view will be reused if possible for the case that `setOption` with "notMerge"
                // mode and need to enable transition animation. (Usually, when they have the same id, or
                // especially no id but have the same type & name & index. See the `model.id` generation
                // rule in `makeIdAndName` and `viewId` generation rule here).
                // But in `replaceMerge` mode, this feature should be able to disabled when it is clear that
                // the new model has nothing to do with the old model.
                var requireNewView = model.__requireNewView;
                // This command should not work twice.
                model.__requireNewView = false;
                // Consider: id same and type changed.
                var viewId = '_ec_' + model.id + '_' + model.type;
                var view = !requireNewView && viewMap[viewId];
                if (!view) {
                    var classType = (0, $19c24724c14e5e48$export$fbe18865d303bf01)(model.type);
                    var Clazz = isComponent ? (0, $8b851331e51a1131$export$2e2bcd8739ae039).getClass(classType.main, classType.sub) : // FIXME:TS
                    // (ChartView as ChartViewConstructor).getClass('series', classType.sub)
                    // For backward compat, still support a chart type declared as only subType
                    // like "liquidfill", but recommend "series.liquidfill"
                    // But need a base class to make a type series.
                    (0, $80462d4f8a33fa64$export$2e2bcd8739ae039).getClass(classType.sub);
                    view = new Clazz();
                    view.init(ecModel, api);
                    viewMap[viewId] = view;
                    viewList.push(view);
                    zr.add(view.group);
                }
                model.__viewId = view.__id = viewId;
                view.__alive = true;
                view.__model = model;
                view.group.__ecComponentInfo = {
                    mainType: model.mainType,
                    index: model.componentIndex
                };
                !isComponent && scheduler.prepareView(view, model, ecModel, api);
            }
            for(var i = 0; i < viewList.length;){
                var view = viewList[i];
                if (!view.__alive) {
                    !isComponent && view.renderTask.dispose();
                    zr.remove(view.group);
                    view.dispose(ecModel, api);
                    viewList.splice(i, 1);
                    if (viewMap[view.__id] === view) delete viewMap[view.__id];
                    view.__id = view.group.__ecComponentInfo = null;
                } else i++;
            }
        };
        $b45c5a9506b77a4f$var$updateDirectly = function(ecIns, method, payload, mainType, subType) {
            var ecModel = ecIns._model;
            ecModel.setUpdatePayload(payload);
            // broadcast
            if (!mainType) {
                // FIXME
                // Chart will not be update directly here, except set dirty.
                // But there is no such scenario now.
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([].concat(ecIns._componentsViews).concat(ecIns._chartsViews), callView);
                return;
            }
            var query = {};
            query[mainType + 'Id'] = payload[mainType + 'Id'];
            query[mainType + 'Index'] = payload[mainType + 'Index'];
            query[mainType + 'Name'] = payload[mainType + 'Name'];
            var condition = {
                mainType: mainType,
                query: query
            };
            subType && (condition.subType = subType); // subType may be '' by parseClassType;
            var excludeSeriesId = payload.excludeSeriesId;
            var excludeSeriesIdMap;
            if (excludeSeriesId != null) {
                excludeSeriesIdMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($9ac03c46e8b6e711$export$4f07b212a02c8051(excludeSeriesId), function(id) {
                    var modelId = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(id, null);
                    if (modelId != null) excludeSeriesIdMap.set(modelId, true);
                });
            }
            // If dispatchAction before setOption, do nothing.
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                if ((0, $b414df7d361a211c$export$aebe71265c1b77bf)(payload)) {
                    if (model instanceof (0, $19b580a0cd6e92eb$export$2e2bcd8739ae039)) {
                        if (payload.type === (0, $b414df7d361a211c$export$df035d873a9de64f) && !payload.notBlur && !model.get([
                            'emphasis',
                            'disabled'
                        ])) (0, $b414df7d361a211c$export$64f1fd4daefef21b)(model, payload, ecIns._api);
                    } else {
                        var _a = (0, $b414df7d361a211c$export$f31a644ccca0ef23)(model.mainType, model.componentIndex, payload.name, ecIns._api), focusSelf = _a.focusSelf, dispatchers = _a.dispatchers;
                        if (payload.type === (0, $b414df7d361a211c$export$df035d873a9de64f) && focusSelf && !payload.notBlur) (0, $b414df7d361a211c$export$569da03256c8a55f)(model.mainType, model.componentIndex, ecIns._api);
                        // PENDING:
                        // Whether to put this "enter emphasis" code in `ComponentView`,
                        // which will be the same as `ChartView` but might be not necessary
                        // and will be far from this logic.
                        if (dispatchers) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dispatchers, function(dispatcher) {
                            payload.type === (0, $b414df7d361a211c$export$df035d873a9de64f) ? (0, $b414df7d361a211c$export$b2d02638cc34c042)(dispatcher) : (0, $b414df7d361a211c$export$11be6f716239ac55)(dispatcher);
                        });
                    }
                } else if ((0, $b414df7d361a211c$export$72aea10e60e45351)(payload)) // TODO geo
                {
                    if (model instanceof (0, $19b580a0cd6e92eb$export$2e2bcd8739ae039)) {
                        (0, $b414df7d361a211c$export$1c7d489f62372d73)(model, payload, ecIns._api);
                        (0, $b414df7d361a211c$export$e4ea08ef52e0a73)(model);
                        $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                    }
                }
            }, ecIns);
            ecModel && ecModel.eachComponent(condition, function(model) {
                var isExcluded = excludeSeriesIdMap && excludeSeriesIdMap.get(model.id) != null;
                if (isExcluded) return;
                callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
            }, ecIns);
            function callView(view) {
                view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
            }
        };
        $b45c5a9506b77a4f$var$updateMethods = {
            prepareAndUpdate: function(payload) {
                $b45c5a9506b77a4f$var$prepare(this);
                $b45c5a9506b77a4f$var$updateMethods.update.call(this, payload, {
                    // Needs to mark option changed if newOption is given.
                    // It's from MagicType.
                    // TODO If use a separate flag optionChanged in payload?
                    optionChanged: payload.newOption != null
                });
            },
            update: function(payload, updateParams) {
                var ecModel = this._model;
                var api = this._api;
                var zr = this._zr;
                var coordSysMgr = this._coordSysMgr;
                var scheduler = this._scheduler;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                scheduler.restoreData(ecModel, payload);
                scheduler.performSeriesTasks(ecModel);
                // TODO
                // Save total ecModel here for undo/redo (after restoring data and before processing data).
                // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
                // Create new coordinate system each update
                // In LineView may save the old coordinate system and use it to get the original point.
                coordSysMgr.create(ecModel, api);
                scheduler.performDataProcessorTasks(ecModel, payload);
                // Current stream render is not supported in data process. So we can update
                // stream modes after data processing, where the filtered data is used to
                // determine whether to use progressive rendering.
                $b45c5a9506b77a4f$var$updateStreamModes(this, ecModel);
                // We update stream modes before coordinate system updated, then the modes info
                // can be fetched when coord sys updating (consider the barGrid extent fix). But
                // the drawback is the full coord info can not be fetched. Fortunately this full
                // coord is not required in stream mode updater currently.
                coordSysMgr.update(ecModel, api);
                clearColorPalette(ecModel);
                scheduler.performVisualTasks(ecModel, payload);
                $b45c5a9506b77a4f$var$render(this, ecModel, api, payload, updateParams);
                // Set background
                var backgroundColor = ecModel.get('backgroundColor') || 'transparent';
                var darkMode = ecModel.get('darkMode');
                zr.setBackgroundColor(backgroundColor);
                // Force set dark mode.
                if (darkMode != null && darkMode !== 'auto') zr.setDarkMode(darkMode);
                (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateTransform: function(payload) {
                var _this = this;
                var ecModel = this._model;
                var api = this._api;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // ChartView.markUpdateMethod(payload, 'updateTransform');
                var componentDirtyList = [];
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType === 'series') return;
                    var componentView = _this.getViewOfComponentModel(componentModel);
                    if (componentView && componentView.__alive) {
                        if (componentView.updateTransform) {
                            var result = componentView.updateTransform(componentModel, ecModel, api, payload);
                            result && result.update && componentDirtyList.push(componentView);
                        } else componentDirtyList.push(componentView);
                    }
                });
                var seriesDirtyMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    if (chartView.updateTransform) {
                        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
                        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
                    } else seriesDirtyMap.set(seriesModel.uid, 1);
                });
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true,
                    dirtyMap: seriesDirtyMap
                });
                // Currently, not call render of components. Geo render cost a lot.
                // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
                $b45c5a9506b77a4f$var$renderSeries(this, ecModel, api, payload, {}, seriesDirtyMap);
                (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, api);
            },
            updateView: function(payload) {
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                (0, $80462d4f8a33fa64$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateView');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    setDirty: true
                });
                $b45c5a9506b77a4f$var$render(this, ecModel, this._api, payload, {});
                (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateVisual: function(payload) {
                // updateMethods.update.call(this, payload);
                var _this = this;
                var ecModel = this._model;
                // update before setOption
                if (!ecModel) return;
                ecModel.setUpdatePayload(payload);
                // clear all visual
                ecModel.eachSeries(function(seriesModel) {
                    seriesModel.getData().clearAllVisual();
                });
                // Perform visual
                (0, $80462d4f8a33fa64$export$2e2bcd8739ae039).markUpdateMethod(payload, 'updateVisual');
                clearColorPalette(ecModel);
                // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
                this._scheduler.performVisualTasks(ecModel, payload, {
                    visualType: 'visual',
                    setDirty: true
                });
                ecModel.eachComponent(function(componentType, componentModel) {
                    if (componentType !== 'series') {
                        var componentView = _this.getViewOfComponentModel(componentModel);
                        componentView && componentView.__alive && componentView.updateVisual(componentModel, ecModel, _this._api, payload);
                    }
                });
                ecModel.eachSeries(function(seriesModel) {
                    var chartView = _this._chartsMap[seriesModel.__viewId];
                    chartView.updateVisual(seriesModel, ecModel, _this._api, payload);
                });
                (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('afterupdate', ecModel, this._api);
            },
            updateLayout: function(payload) {
                $b45c5a9506b77a4f$var$updateMethods.update.call(this, payload);
            }
        };
        $b45c5a9506b77a4f$var$doConvertPixel = function(ecIns, methodName, finder, value) {
            if (ecIns._disposed) {
                $b45c5a9506b77a4f$var$disposedWarning(ecIns.id);
                return;
            }
            var ecModel = ecIns._model;
            var coordSysList = ecIns._coordSysMgr.getCoordinateSystems();
            var result;
            var parsedFinder = $9ac03c46e8b6e711$export$95de80076abac814(ecModel, finder);
            for(var i = 0; i < coordSysList.length; i++){
                var coordSys = coordSysList[i];
                if (coordSys[methodName] && (result = coordSys[methodName](ecModel, parsedFinder, value)) != null) return result;
            }
        };
        $b45c5a9506b77a4f$var$updateStreamModes = function(ecIns, ecModel) {
            var chartsMap = ecIns._chartsMap;
            var scheduler = ecIns._scheduler;
            ecModel.eachSeries(function(seriesModel) {
                scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
            });
        };
        $b45c5a9506b77a4f$var$doDispatchAction = function(payload, silent) {
            var _this = this;
            var ecModel = this.getModel();
            var payloadType = payload.type;
            var escapeConnect = payload.escapeConnect;
            var actionWrap = $b45c5a9506b77a4f$var$actions[payloadType];
            var actionInfo = actionWrap.actionInfo;
            var cptTypeTmp = (actionInfo.update || 'update').split(':');
            var updateMethod = cptTypeTmp.pop();
            var cptType = cptTypeTmp[0] != null && (0, $19c24724c14e5e48$export$fbe18865d303bf01)(cptTypeTmp[0]);
            this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = true;
            var payloads = [
                payload
            ];
            var batched = false;
            // Batch action
            if (payload.batch) {
                batched = true;
                payloads = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(payload.batch, function(item) {
                    item = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, item), payload);
                    item.batch = null;
                    return item;
                });
            }
            var eventObjBatch = [];
            var eventObj;
            var isSelectChange = (0, $b414df7d361a211c$export$72aea10e60e45351)(payload);
            var isHighDown = (0, $b414df7d361a211c$export$aebe71265c1b77bf)(payload);
            // Only leave blur once if there are multiple batches.
            if (isHighDown) (0, $b414df7d361a211c$export$b2a593c7b5243584)(this._api);
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(payloads, function(batchItem) {
                // Action can specify the event by return it.
                eventObj = actionWrap.action(batchItem, _this._model, _this._api);
                // Emit event outside
                eventObj = eventObj || (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, batchItem);
                // Convert type to eventType
                eventObj.type = actionInfo.event || eventObj.type;
                eventObjBatch.push(eventObj);
                // light update does not perform data process, layout and visual.
                if (isHighDown) {
                    var _a = $9ac03c46e8b6e711$export$fe600815775d9400(payload), queryOptionMap = _a.queryOptionMap, mainTypeSpecified = _a.mainTypeSpecified;
                    var componentMainType = mainTypeSpecified ? queryOptionMap.keys()[0] : 'series';
                    $b45c5a9506b77a4f$var$updateDirectly(_this, updateMethod, batchItem, componentMainType);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(_this);
                } else if (isSelectChange) {
                    // At present `dispatchAction({ type: 'select', ... })` is not supported on components.
                    // geo still use 'geoselect'.
                    $b45c5a9506b77a4f$var$updateDirectly(_this, updateMethod, batchItem, 'series');
                    $b45c5a9506b77a4f$var$markStatusToUpdate(_this);
                } else if (cptType) $b45c5a9506b77a4f$var$updateDirectly(_this, updateMethod, batchItem, cptType.main, cptType.sub);
            });
            if (updateMethod !== 'none' && !isHighDown && !isSelectChange && !cptType) try {
                // Still dirty
                if (this[$b45c5a9506b77a4f$var$PENDING_UPDATE]) {
                    $b45c5a9506b77a4f$var$prepare(this);
                    $b45c5a9506b77a4f$var$updateMethods.update.call(this, payload);
                    this[$b45c5a9506b77a4f$var$PENDING_UPDATE] = null;
                } else $b45c5a9506b77a4f$var$updateMethods[updateMethod].call(this, payload);
            } catch (e) {
                this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
                throw e;
            }
            // Follow the rule of action batch
            if (batched) eventObj = {
                type: actionInfo.event || payloadType,
                escapeConnect: escapeConnect,
                batch: eventObjBatch
            };
            else eventObj = eventObjBatch[0];
            this[$b45c5a9506b77a4f$var$IN_MAIN_PROCESS_KEY] = false;
            if (!silent) {
                var messageCenter = this._messageCenter;
                messageCenter.trigger(eventObj.type, eventObj);
                // Extra triggered 'selectchanged' event
                if (isSelectChange) {
                    var newObj = {
                        type: 'selectchanged',
                        escapeConnect: escapeConnect,
                        selected: (0, $b414df7d361a211c$export$c529643b619af6b3)(ecModel),
                        isFromClick: payload.isFromClick || false,
                        fromAction: payload.type,
                        fromActionPayload: payload
                    };
                    messageCenter.trigger(newObj.type, newObj);
                }
            }
        };
        $b45c5a9506b77a4f$var$flushPendingActions = function(silent) {
            var pendingActions = this._pendingActions;
            while(pendingActions.length){
                var payload = pendingActions.shift();
                $b45c5a9506b77a4f$var$doDispatchAction.call(this, payload, silent);
            }
        };
        $b45c5a9506b77a4f$var$triggerUpdatedEvent = function(silent) {
            !silent && this.trigger('updated');
        };
        /**
     * Event `rendered` is triggered when zr
     * rendered. It is useful for realtime
     * snapshot (reflect animation).
     *
     * Event `finished` is triggered when:
     * (1) zrender rendering finished.
     * (2) initial animation finished.
     * (3) progressive rendering finished.
     * (4) no pending action.
     * (5) no delayed setOption needs to be processed.
     */ $b45c5a9506b77a4f$var$bindRenderedEvent = function(zr, ecIns) {
            zr.on('rendered', function(params) {
                ecIns.trigger('rendered', params);
                // The `finished` event should not be triggered repeatedly,
                // so it should only be triggered when rendering indeed happens
                // in zrender. (Consider the case that dipatchAction is keep
                // triggering when mouse move).
                if (// Although zr is dirty if initial animation is not finished
                // and this checking is called on frame, we also check
                // animation finished for robustness.
                zr.animation.isFinished() && !ecIns[$b45c5a9506b77a4f$var$PENDING_UPDATE] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) ecIns.trigger('finished');
            });
        };
        $b45c5a9506b77a4f$var$bindMouseEvent = function(zr, ecIns) {
            zr.on('mouseover', function(e) {
                var el = e.target;
                var dispatcher = (0, $ee614fdac89517fb$export$8a4fca9e04eb4df6)(el, (0, $b414df7d361a211c$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $b414df7d361a211c$export$416765b6198234ff)(dispatcher, e, ecIns._api);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                }
            }).on('mouseout', function(e) {
                var el = e.target;
                var dispatcher = (0, $ee614fdac89517fb$export$8a4fca9e04eb4df6)(el, (0, $b414df7d361a211c$export$77d1445f699c58b5));
                if (dispatcher) {
                    (0, $b414df7d361a211c$export$bb1c7b62436282a)(dispatcher, e, ecIns._api);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                }
            }).on('click', function(e) {
                var el = e.target;
                var dispatcher = (0, $ee614fdac89517fb$export$8a4fca9e04eb4df6)(el, function(target) {
                    return (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(target).dataIndex != null;
                }, true);
                if (dispatcher) {
                    var actionType = dispatcher.selected ? 'unselect' : 'select';
                    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(dispatcher);
                    ecIns._api.dispatchAction({
                        type: actionType,
                        dataType: ecData.dataType,
                        dataIndexInside: ecData.dataIndex,
                        seriesIndex: ecData.seriesIndex,
                        isFromClick: true
                    });
                }
            });
        };
        function clearColorPalette(ecModel) {
            ecModel.clearColorPalette();
            ecModel.eachSeries(function(seriesModel) {
                seriesModel.clearColorPalette();
            });
        }
        // Allocate zlevels for series and components
        function allocateZlevels(ecModel) {
            var componentZLevels = [];
            var seriesZLevels = [];
            var hasSeparateZLevel = false;
            ecModel.eachComponent(function(componentType, componentModel) {
                var zlevel = componentModel.get('zlevel') || 0;
                var z = componentModel.get('z') || 0;
                var zlevelKey = componentModel.getZLevelKey();
                hasSeparateZLevel = hasSeparateZLevel || !!zlevelKey;
                (componentType === 'series' ? seriesZLevels : componentZLevels).push({
                    zlevel: zlevel,
                    z: z,
                    idx: componentModel.componentIndex,
                    type: componentType,
                    key: zlevelKey
                });
            });
            if (hasSeparateZLevel) {
                // Series after component
                var zLevels = componentZLevels.concat(seriesZLevels);
                var lastSeriesZLevel_1;
                var lastSeriesKey_1;
                (0, $f91119cfbd7f3e96$export$2e2bcd8739ae039)(zLevels, function(a, b) {
                    if (a.zlevel === b.zlevel) return a.z - b.z;
                    return a.zlevel - b.zlevel;
                });
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(zLevels, function(item) {
                    var componentModel = ecModel.getComponent(item.type, item.idx);
                    var zlevel = item.zlevel;
                    var key = item.key;
                    if (lastSeriesZLevel_1 != null) zlevel = Math.max(lastSeriesZLevel_1, zlevel);
                    if (key) {
                        if (zlevel === lastSeriesZLevel_1 && key !== lastSeriesKey_1) zlevel++;
                        lastSeriesKey_1 = key;
                    } else if (lastSeriesKey_1) {
                        if (zlevel === lastSeriesZLevel_1) zlevel++;
                        lastSeriesKey_1 = '';
                    }
                    lastSeriesZLevel_1 = zlevel;
                    componentModel.setZLevel(zlevel);
                });
            }
        }
        $b45c5a9506b77a4f$var$render = function(ecIns, ecModel, api, payload, updateParams) {
            allocateZlevels(ecModel);
            $b45c5a9506b77a4f$var$renderComponents(ecIns, ecModel, api, payload, updateParams);
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                chart.__alive = false;
            });
            $b45c5a9506b77a4f$var$renderSeries(ecIns, ecModel, api, payload, updateParams);
            // Remove groups of unrendered charts
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(ecIns._chartsViews, function(chart) {
                if (!chart.__alive) chart.remove(ecModel, api);
            });
        };
        $b45c5a9506b77a4f$var$renderComponents = function(ecIns, ecModel, api, payload, updateParams, dirtyList) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dirtyList || ecIns._componentsViews, function(componentView) {
                var componentModel = componentView.__model;
                clearStates(componentModel, componentView);
                componentView.render(componentModel, ecModel, api, payload);
                updateZ(componentModel, componentView);
                updateStates(componentModel, componentView);
            });
        };
        /**
     * Render each chart and component
     */ $b45c5a9506b77a4f$var$renderSeries = function(ecIns, ecModel, api, payload, updateParams, dirtyMap) {
            // Render all charts
            var scheduler = ecIns._scheduler;
            updateParams = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(updateParams || {}, {
                updatedSeries: ecModel.getSeries()
            });
            // TODO progressive?
            (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('series:beforeupdate', ecModel, api, updateParams);
            var unfinished = false;
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                chartView.__alive = true;
                var renderTask = chartView.renderTask;
                scheduler.updatePayload(renderTask, payload);
                // TODO states on marker.
                clearStates(seriesModel, chartView);
                if (dirtyMap && dirtyMap.get(seriesModel.uid)) renderTask.dirty();
                if (renderTask.perform(scheduler.getPerformArgs(renderTask))) unfinished = true;
                chartView.group.silent = !!seriesModel.get('silent');
                // Should not call markRedraw on group, because it will disable zrender
                // incremental render (always render from the __startIndex each frame)
                // chartView.group.markRedraw();
                updateBlend(seriesModel, chartView);
                (0, $b414df7d361a211c$export$e4ea08ef52e0a73)(seriesModel);
            });
            scheduler.unfinished = unfinished || scheduler.unfinished;
            (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('series:layoutlabels', ecModel, api, updateParams);
            // transition after label is layouted.
            (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('series:transition', ecModel, api, updateParams);
            ecModel.eachSeries(function(seriesModel) {
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                // Update Z after labels updated. Before applying states.
                updateZ(seriesModel, chartView);
                // NOTE: Update states after label is updated.
                // label should be in normal status when layouting.
                updateStates(seriesModel, chartView);
            });
            // If use hover layer
            updateHoverLayerStatus(ecIns, ecModel);
            (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('series:afterupdate', ecModel, api, updateParams);
        };
        $b45c5a9506b77a4f$var$markStatusToUpdate = function(ecIns) {
            ecIns[$b45c5a9506b77a4f$var$STATUS_NEEDS_UPDATE_KEY] = true;
            // Wake up zrender if it's sleep. Let it update states in the next frame.
            ecIns.getZr().wakeUp();
        };
        $b45c5a9506b77a4f$var$applyChangedStates = function(ecIns) {
            if (!ecIns[$b45c5a9506b77a4f$var$STATUS_NEEDS_UPDATE_KEY]) return;
            ecIns.getZr().storage.traverse(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($b40111164617dd60$export$5b89d4b643713034(el)) return;
                applyElementStates(el);
            });
            ecIns[$b45c5a9506b77a4f$var$STATUS_NEEDS_UPDATE_KEY] = false;
        };
        function applyElementStates(el) {
            var newStates = [];
            var oldStates = el.currentStates;
            // Keep other states.
            for(var i = 0; i < oldStates.length; i++){
                var stateName = oldStates[i];
                if (!(stateName === 'emphasis' || stateName === 'blur' || stateName === 'select')) newStates.push(stateName);
            }
            // Only use states when it's exists.
            if (el.selected && el.states.select) newStates.push('select');
            if (el.hoverState === (0, $b414df7d361a211c$export$f0f2bee145debb31) && el.states.emphasis) newStates.push('emphasis');
            else if (el.hoverState === (0, $b414df7d361a211c$export$1307d6a87d56baa) && el.states.blur) newStates.push('blur');
            el.useStates(newStates);
        }
        function updateHoverLayerStatus(ecIns, ecModel) {
            var zr = ecIns._zr;
            var storage = zr.storage;
            var elCount = 0;
            storage.traverse(function(el) {
                if (!el.isGroup) elCount++;
            });
            if (elCount > ecModel.get('hoverLayerThreshold') && !(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node && !(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).worker) ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.preventUsingHoverLayer) return;
                var chartView = ecIns._chartsMap[seriesModel.__viewId];
                if (chartView.__alive) chartView.eachRendered(function(el) {
                    if (el.states.emphasis) el.states.emphasis.hoverLayer = true;
                });
            });
        }
        /**
     * Update chart and blend.
     */ function updateBlend(seriesModel, chartView) {
            var blendMode = seriesModel.get('blendMode') || null;
            chartView.eachRendered(function(el) {
                // FIXME marker and other components
                if (!el.isGroup) // DON'T mark the element dirty. In case element is incremental and don't want to rerender.
                el.style.blend = blendMode;
            });
        }
        function updateZ(model, view) {
            if (model.preventAutoZ) return;
            var z = model.get('z') || 0;
            var zlevel = model.get('zlevel') || 0;
            // Set z and zlevel
            view.eachRendered(function(el) {
                doUpdateZ(el, z, zlevel, -Infinity);
                // Don't traverse the children because it has been traversed in _updateZ.
                return true;
            });
        }
        function doUpdateZ(el, z, zlevel, maxZ2) {
            // Group may also have textContent
            var label = el.getTextContent();
            var labelLine = el.getTextGuideLine();
            var isGroup = el.isGroup;
            if (isGroup) {
                // set z & zlevel of children elements of Group
                var children = el.childrenRef();
                for(var i = 0; i < children.length; i++)maxZ2 = Math.max(doUpdateZ(children[i], z, zlevel, maxZ2), maxZ2);
            } else {
                // not Group
                el.z = z;
                el.zlevel = zlevel;
                maxZ2 = Math.max(el.z2, maxZ2);
            }
            // always set z and zlevel if label/labelLine exists
            if (label) {
                label.z = z;
                label.zlevel = zlevel;
                // lift z2 of text content
                // TODO if el.emphasis.z2 is spcefied, what about textContent.
                isFinite(maxZ2) && (label.z2 = maxZ2 + 2);
            }
            if (labelLine) {
                var textGuideLineConfig = el.textGuideLineConfig;
                labelLine.z = z;
                labelLine.zlevel = zlevel;
                isFinite(maxZ2) && (labelLine.z2 = maxZ2 + (textGuideLineConfig && textGuideLineConfig.showAbove ? 1 : -1));
            }
            return maxZ2;
        }
        // Clear states without animation.
        // TODO States on component.
        function clearStates(model, view) {
            view.eachRendered(function(el) {
                // Not applied on removed elements, it may still in fading.
                if ($b40111164617dd60$export$5b89d4b643713034(el)) return;
                var textContent = el.getTextContent();
                var textGuide = el.getTextGuideLine();
                if (el.stateTransition) el.stateTransition = null;
                if (textContent && textContent.stateTransition) textContent.stateTransition = null;
                if (textGuide && textGuide.stateTransition) textGuide.stateTransition = null;
                // TODO If el is incremental.
                if (el.hasState()) {
                    el.prevStates = el.currentStates;
                    el.clearStates();
                } else if (el.prevStates) el.prevStates = null;
            });
        }
        function updateStates(model, view) {
            var stateAnimationModel = model.getModel('stateAnimation');
            var enableAnimation = model.isAnimationEnabled();
            var duration = stateAnimationModel.get('duration');
            var stateTransition = duration > 0 ? {
                duration: duration,
                delay: stateAnimationModel.get('delay'),
                easing: stateAnimationModel.get('easing')
            } : null;
            view.eachRendered(function(el) {
                if (el.states && el.states.emphasis) {
                    // Not applied on removed elements, it may still in fading.
                    if ($b40111164617dd60$export$5b89d4b643713034(el)) return;
                    if (el instanceof $f9698154c9fcf427$export$2e2bcd8739ae039) (0, $b414df7d361a211c$export$9fe78019e6f395b6)(el);
                    // Only updated on changed element. In case element is incremental and don't want to rerender.
                    // TODO, a more proper way?
                    if (el.__dirty) {
                        var prevStates = el.prevStates;
                        // Restore states without animation
                        if (prevStates) el.useStates(prevStates);
                    }
                    // Update state transition and enable animation again.
                    if (enableAnimation) {
                        el.stateTransition = stateTransition;
                        var textContent = el.getTextContent();
                        var textGuide = el.getTextGuideLine();
                        // TODO Is it necessary to animate label?
                        if (textContent) textContent.stateTransition = stateTransition;
                        if (textGuide) textGuide.stateTransition = stateTransition;
                    }
                    // Use highlighted and selected flag to toggle states.
                    if (el.__dirty) applyElementStates(el);
                }
            });
        }
        $b45c5a9506b77a4f$var$createExtensionAPI = function(ecIns) {
            return new /** @class */ (function(_super) {
                (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(class_1, _super);
                function class_1() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                class_1.prototype.getCoordinateSystems = function() {
                    return ecIns._coordSysMgr.getCoordinateSystems();
                };
                class_1.prototype.getComponentByElement = function(el) {
                    while(el){
                        var modelInfo = el.__ecComponentInfo;
                        if (modelInfo != null) return ecIns._model.getComponent(modelInfo.mainType, modelInfo.index);
                        el = el.parent;
                    }
                };
                class_1.prototype.enterEmphasis = function(el, highlightDigit) {
                    (0, $b414df7d361a211c$export$b2d02638cc34c042)(el, highlightDigit);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveEmphasis = function(el, highlightDigit) {
                    (0, $b414df7d361a211c$export$11be6f716239ac55)(el, highlightDigit);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterBlur = function(el) {
                    (0, $b414df7d361a211c$export$207f9cb3e1099375)(el);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveBlur = function(el) {
                    (0, $b414df7d361a211c$export$fd4a9ec75456d3c1)(el);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.enterSelect = function(el) {
                    (0, $b414df7d361a211c$export$252d028dda8ef765)(el);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.leaveSelect = function(el) {
                    (0, $b414df7d361a211c$export$ea9a904bd6e32bd3)(el);
                    $b45c5a9506b77a4f$var$markStatusToUpdate(ecIns);
                };
                class_1.prototype.getModel = function() {
                    return ecIns.getModel();
                };
                class_1.prototype.getViewOfComponentModel = function(componentModel) {
                    return ecIns.getViewOfComponentModel(componentModel);
                };
                class_1.prototype.getViewOfSeriesModel = function(seriesModel) {
                    return ecIns.getViewOfSeriesModel(seriesModel);
                };
                return class_1;
            }((0, $545b8cf22e653ed1$export$2e2bcd8739ae039)))(ecIns);
        };
        $b45c5a9506b77a4f$var$enableConnect = function(chart) {
            function updateConnectedChartsStatus(charts, status) {
                for(var i = 0; i < charts.length; i++){
                    var otherChart = charts[i];
                    otherChart[$b45c5a9506b77a4f$var$CONNECT_STATUS_KEY] = status;
                }
            }
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($b45c5a9506b77a4f$var$eventActionMap, function(actionType, eventType) {
                chart._messageCenter.on(eventType, function(event) {
                    if ($b45c5a9506b77a4f$var$connectedGroups[chart.group] && chart[$b45c5a9506b77a4f$var$CONNECT_STATUS_KEY] !== $b45c5a9506b77a4f$var$CONNECT_STATUS_PENDING) {
                        if (event && event.escapeConnect) return;
                        var action_1 = chart.makeActionFromEvent(event);
                        var otherCharts_1 = [];
                        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($b45c5a9506b77a4f$var$instances, function(otherChart) {
                            if (otherChart !== chart && otherChart.group === chart.group) otherCharts_1.push(otherChart);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $b45c5a9506b77a4f$var$CONNECT_STATUS_PENDING);
                        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(otherCharts_1, function(otherChart) {
                            if (otherChart[$b45c5a9506b77a4f$var$CONNECT_STATUS_KEY] !== $b45c5a9506b77a4f$var$CONNECT_STATUS_UPDATING) otherChart.dispatchAction(action_1);
                        });
                        updateConnectedChartsStatus(otherCharts_1, $b45c5a9506b77a4f$var$CONNECT_STATUS_UPDATED);
                    }
                });
            });
        };
    }();
    return ECharts;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
var $b45c5a9506b77a4f$var$echartsProto = $b45c5a9506b77a4f$var$ECharts.prototype;
$b45c5a9506b77a4f$var$echartsProto.on = $b45c5a9506b77a4f$var$createRegisterEventWithLowercaseECharts('on');
$b45c5a9506b77a4f$var$echartsProto.off = $b45c5a9506b77a4f$var$createRegisterEventWithLowercaseECharts('off');
/**
 * @deprecated
 */ // @ts-ignore
$b45c5a9506b77a4f$var$echartsProto.one = function(eventName, cb, ctx) {
    var self = this;
    (0, $4ef07c0eafe44628$export$4a9c0b74eb885aa1)('ECharts#one is deprecated.');
    function wrapped() {
        var args2 = [];
        for(var _i = 0; _i < arguments.length; _i++)args2[_i] = arguments[_i];
        cb && cb.apply && cb.apply(this, args2);
        // @ts-ignore
        self.off(eventName, wrapped);
    }
    // @ts-ignore
    this.on.call(this, eventName, wrapped, ctx);
};
var $b45c5a9506b77a4f$var$MOUSE_EVENT_NAMES = [
    'click',
    'dblclick',
    'mouseover',
    'mouseout',
    'mousemove',
    'mousedown',
    'mouseup',
    'globalout',
    'contextmenu'
];
function $b45c5a9506b77a4f$var$disposedWarning(id) {}
var $b45c5a9506b77a4f$var$actions = {};
/**
 * Map eventType to actionType
 */ var $b45c5a9506b77a4f$var$eventActionMap = {};
var $b45c5a9506b77a4f$var$dataProcessorFuncs = [];
var $b45c5a9506b77a4f$var$optionPreprocessorFuncs = [];
var $b45c5a9506b77a4f$var$visualFuncs = [];
var $b45c5a9506b77a4f$var$themeStorage = {};
var $b45c5a9506b77a4f$var$loadingEffects = {};
var $b45c5a9506b77a4f$var$instances = {};
var $b45c5a9506b77a4f$var$connectedGroups = {};
var $b45c5a9506b77a4f$var$idBase = +new Date() - 0;
var $b45c5a9506b77a4f$var$groupIdBase = +new Date() - 0;
var $b45c5a9506b77a4f$var$DOM_ATTRIBUTE_KEY = '_echarts_instance_';
function $b45c5a9506b77a4f$export$2cd8252107eb640b(dom, theme, opts) {
    var isClient = !(opts && opts.ssr);
    if (isClient) {
        var existInstance = $b45c5a9506b77a4f$export$33b6fbccd4f643f8(dom);
        if (existInstance) return existInstance;
    }
    var chart = new $b45c5a9506b77a4f$var$ECharts(dom, theme, opts);
    chart.id = 'ec_' + $b45c5a9506b77a4f$var$idBase++;
    $b45c5a9506b77a4f$var$instances[chart.id] = chart;
    isClient && $9ac03c46e8b6e711$export$9fec4d97f1922e0b(dom, $b45c5a9506b77a4f$var$DOM_ATTRIBUTE_KEY, chart.id);
    $b45c5a9506b77a4f$var$enableConnect(chart);
    (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).trigger('afterinit', chart);
    return chart;
}
function $b45c5a9506b77a4f$export$64605811ab45167f(groupId) {
    // Is array of charts
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(groupId)) {
        var charts = groupId;
        groupId = null;
        // If any chart has group
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(charts, function(chart) {
            if (chart.group != null) groupId = chart.group;
        });
        groupId = groupId || 'g_' + $b45c5a9506b77a4f$var$groupIdBase++;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(charts, function(chart) {
            chart.group = groupId;
        });
    }
    $b45c5a9506b77a4f$var$connectedGroups[groupId] = true;
    return groupId;
}
function $b45c5a9506b77a4f$export$37dfea93db2e14ed(groupId) {
    $b45c5a9506b77a4f$var$connectedGroups[groupId] = false;
}
var $b45c5a9506b77a4f$export$87cd6834112ecb52 = $b45c5a9506b77a4f$export$37dfea93db2e14ed;
function $b45c5a9506b77a4f$export$fcfbbcec2cb820d5(chart) {
    if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(chart)) chart = $b45c5a9506b77a4f$var$instances[chart];
    else if (!(chart instanceof $b45c5a9506b77a4f$var$ECharts)) // Try to treat as dom
    chart = $b45c5a9506b77a4f$export$33b6fbccd4f643f8(chart);
    if (chart instanceof $b45c5a9506b77a4f$var$ECharts && !chart.isDisposed()) chart.dispose();
}
function $b45c5a9506b77a4f$export$33b6fbccd4f643f8(dom) {
    return $b45c5a9506b77a4f$var$instances[$9ac03c46e8b6e711$export$735ee1799fd02602(dom, $b45c5a9506b77a4f$var$DOM_ATTRIBUTE_KEY)];
}
function $b45c5a9506b77a4f$export$89b4be35062c4a3f(key) {
    return $b45c5a9506b77a4f$var$instances[key];
}
function $b45c5a9506b77a4f$export$f9c59eed5de5ff80(name, theme) {
    $b45c5a9506b77a4f$var$themeStorage[name] = theme;
}
function $b45c5a9506b77a4f$export$77095792a057b768(preprocessorFunc) {
    if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)($b45c5a9506b77a4f$var$optionPreprocessorFuncs, preprocessorFunc) < 0) $b45c5a9506b77a4f$var$optionPreprocessorFuncs.push(preprocessorFunc);
}
function $b45c5a9506b77a4f$export$d575e6557ac1729f(priority, processor) {
    $b45c5a9506b77a4f$var$normalizeRegister($b45c5a9506b77a4f$var$dataProcessorFuncs, priority, processor, $b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_DEFAULT);
}
function $b45c5a9506b77a4f$export$c8c249911ee8c1ed(postInitFunc) {
    $b45c5a9506b77a4f$export$c9ec4b5faef04865('afterinit', postInitFunc);
}
function $b45c5a9506b77a4f$export$99560909c18c76bb(postUpdateFunc) {
    $b45c5a9506b77a4f$export$c9ec4b5faef04865('afterupdate', postUpdateFunc);
}
function $b45c5a9506b77a4f$export$c9ec4b5faef04865(name, cb) {
    (0, $084ca3e1f7dbc024$export$2e2bcd8739ae039).on(name, cb);
}
function $b45c5a9506b77a4f$export$408c24786cd729c6(actionInfo, eventName, action) {
    if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(eventName)) {
        action = eventName;
        eventName = '';
    }
    var actionType = (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(actionInfo) ? actionInfo.type : [
        actionInfo,
        actionInfo = {
            event: eventName
        }
    ][0];
    // Event name is all lowercase
    actionInfo.event = (actionInfo.event || actionType).toLowerCase();
    eventName = actionInfo.event;
    if ($b45c5a9506b77a4f$var$eventActionMap[eventName]) // Already registered.
    return;
    // Validate action type and event name.
    (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)($b45c5a9506b77a4f$var$ACTION_REG.test(actionType) && $b45c5a9506b77a4f$var$ACTION_REG.test(eventName));
    if (!$b45c5a9506b77a4f$var$actions[actionType]) $b45c5a9506b77a4f$var$actions[actionType] = {
        action: action,
        actionInfo: actionInfo
    };
    $b45c5a9506b77a4f$var$eventActionMap[eventName] = actionType;
}
function $b45c5a9506b77a4f$export$1dd5e025a8a37dd(type, coordSysCreator) {
    (0, $02d04429d2792472$export$2e2bcd8739ae039).register(type, coordSysCreator);
}
function $b45c5a9506b77a4f$export$fc2638719e4159b9(type) {
    var coordSysCreator = (0, $02d04429d2792472$export$2e2bcd8739ae039).get(type);
    if (coordSysCreator) return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
}
function $b45c5a9506b77a4f$export$d768f97700ca6bea(priority, layoutTask) {
    $b45c5a9506b77a4f$var$normalizeRegister($b45c5a9506b77a4f$var$visualFuncs, priority, layoutTask, $b45c5a9506b77a4f$var$PRIORITY_VISUAL_LAYOUT, 'layout');
}
function $b45c5a9506b77a4f$export$5f32c1eb94c381bb(priority, visualTask) {
    $b45c5a9506b77a4f$var$normalizeRegister($b45c5a9506b77a4f$var$visualFuncs, priority, visualTask, $b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART, 'visual');
}
var $b45c5a9506b77a4f$var$registeredTasks = [];
function $b45c5a9506b77a4f$var$normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
    if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(priority) || (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(priority)) {
        fn = priority;
        priority = defaultPriority;
    }
    // Already registered
    if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)($b45c5a9506b77a4f$var$registeredTasks, fn) >= 0) return;
    $b45c5a9506b77a4f$var$registeredTasks.push(fn);
    var stageHandler = (0, $930979848c1a297c$export$2e2bcd8739ae039).wrapStageHandler(fn, visualType);
    stageHandler.__prio = priority;
    stageHandler.__raw = fn;
    targetList.push(stageHandler);
}
function $b45c5a9506b77a4f$export$e06b68a82007c015(name, loadingFx) {
    $b45c5a9506b77a4f$var$loadingEffects[name] = loadingFx;
}
function $b45c5a9506b77a4f$export$10425ea7a243b114(creator) {
    (0, $024b63ea846a8ccd$export$61bcfd79465c1b7c)({
        createCanvas: creator
    });
}
function $b45c5a9506b77a4f$export$d456de060be2dba1(mapName, geoJson, specialAreas) {
    var registerMap = (0, $5f25fe6b1afe7568$export$73333eb8a09d5f61)('registerMap');
    registerMap && registerMap(mapName, geoJson, specialAreas);
}
function $b45c5a9506b77a4f$export$b8586192aead8a7e(mapName) {
    var getMap = (0, $5f25fe6b1afe7568$export$73333eb8a09d5f61)('getMap');
    return getMap && getMap(mapName);
}
var $b45c5a9506b77a4f$export$f01d71dd0389d7e4 = (0, $ac5f46749660ad86$export$92c96c6d8b255b7d);
/**
 * Globa dispatchAction to a specified chart instance.
 */ // export function dispatchAction(payload: { chartId: string } & Payload, opt?: Parameters<ECharts['dispatchAction']>[1]) {
//     if (!payload || !payload.chartId) {
//         // Must have chartId to find chart
//         return;
//     }
//     const chart = instances[payload.chartId];
//     if (chart) {
//         chart.dispatchAction(payload, opt);
//     }
// }
// Builtin global visual
$b45c5a9506b77a4f$export$5f32c1eb94c381bb($b45c5a9506b77a4f$var$PRIORITY_VISUAL_GLOBAL, (0, $692c090e846c7b27$export$7ce4d65f9b69240));
$b45c5a9506b77a4f$export$5f32c1eb94c381bb($b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $692c090e846c7b27$export$f7dcb66a065003d1));
$b45c5a9506b77a4f$export$5f32c1eb94c381bb($b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $692c090e846c7b27$export$cf9758b0d6dc0aa9));
$b45c5a9506b77a4f$export$5f32c1eb94c381bb($b45c5a9506b77a4f$var$PRIORITY_VISUAL_GLOBAL, (0, $66ca82a264fd1e9a$export$144ac3beded415d9));
$b45c5a9506b77a4f$export$5f32c1eb94c381bb($b45c5a9506b77a4f$var$PRIORITY_VISUAL_CHART_DATA_CUSTOM, (0, $66ca82a264fd1e9a$export$435b956f7f1071fb));
$b45c5a9506b77a4f$export$5f32c1eb94c381bb($b45c5a9506b77a4f$var$PRIORITY_VISUAL_DECAL, (0, $250689bdf6db13c0$export$2e2bcd8739ae039));
$b45c5a9506b77a4f$export$77095792a057b768((0, $cd438069cbdf9f3c$export$2e2bcd8739ae039));
$b45c5a9506b77a4f$export$d575e6557ac1729f($b45c5a9506b77a4f$var$PRIORITY_PROCESSOR_DATASTACK, (0, $b1a74b75aafa5bd2$export$2e2bcd8739ae039));
$b45c5a9506b77a4f$export$e06b68a82007c015('default', (0, $c6c3cc1948dfb8e5$export$2e2bcd8739ae039));
// Default actions
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: (0, $b414df7d361a211c$export$df035d873a9de64f),
    event: (0, $b414df7d361a211c$export$df035d873a9de64f),
    update: (0, $b414df7d361a211c$export$df035d873a9de64f)
}, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: (0, $b414df7d361a211c$export$f8a2f7807cc185ea),
    event: (0, $b414df7d361a211c$export$f8a2f7807cc185ea),
    update: (0, $b414df7d361a211c$export$f8a2f7807cc185ea)
}, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: (0, $b414df7d361a211c$export$89616263e7d38fe9),
    event: (0, $b414df7d361a211c$export$89616263e7d38fe9),
    update: (0, $b414df7d361a211c$export$89616263e7d38fe9)
}, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: (0, $b414df7d361a211c$export$7636ad95c0f68a79),
    event: (0, $b414df7d361a211c$export$7636ad95c0f68a79),
    update: (0, $b414df7d361a211c$export$7636ad95c0f68a79)
}, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: (0, $b414df7d361a211c$export$1e90ed8a25542516),
    event: (0, $b414df7d361a211c$export$1e90ed8a25542516),
    update: (0, $b414df7d361a211c$export$1e90ed8a25542516)
}, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
// Default theme
$b45c5a9506b77a4f$export$f9c59eed5de5ff80('light', (0, $dbc9728520a9c914$export$2e2bcd8739ae039));
$b45c5a9506b77a4f$export$f9c59eed5de5ff80('dark', (0, $3e8f409f2362f7f5$export$2e2bcd8739ae039));
var $b45c5a9506b77a4f$export$73cae5e090579589 = {};









var $dcd0766d99a0579a$var$extensions = [];
var $dcd0766d99a0579a$var$extensionRegisters = {
    registerPreprocessor: (0, $b45c5a9506b77a4f$export$77095792a057b768),
    registerProcessor: (0, $b45c5a9506b77a4f$export$d575e6557ac1729f),
    registerPostInit: (0, $b45c5a9506b77a4f$export$c8c249911ee8c1ed),
    registerPostUpdate: (0, $b45c5a9506b77a4f$export$99560909c18c76bb),
    registerUpdateLifecycle: (0, $b45c5a9506b77a4f$export$c9ec4b5faef04865),
    registerAction: (0, $b45c5a9506b77a4f$export$408c24786cd729c6),
    registerCoordinateSystem: (0, $b45c5a9506b77a4f$export$1dd5e025a8a37dd),
    registerLayout: (0, $b45c5a9506b77a4f$export$d768f97700ca6bea),
    registerVisual: (0, $b45c5a9506b77a4f$export$5f32c1eb94c381bb),
    registerTransform: (0, $b45c5a9506b77a4f$export$f01d71dd0389d7e4),
    registerLoading: (0, $b45c5a9506b77a4f$export$e06b68a82007c015),
    registerMap: (0, $b45c5a9506b77a4f$export$d456de060be2dba1),
    registerImpl: (0, $5f25fe6b1afe7568$export$9b808fd12256ddd3),
    PRIORITY: (0, $b45c5a9506b77a4f$export$bb34f3538ba26c7e),
    ComponentModel: (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039),
    ComponentView: (0, $8b851331e51a1131$export$2e2bcd8739ae039),
    SeriesModel: (0, $19b580a0cd6e92eb$export$2e2bcd8739ae039),
    ChartView: (0, $80462d4f8a33fa64$export$2e2bcd8739ae039),
    // TODO Use ComponentModel and SeriesModel instead of Constructor
    registerComponentModel: function(ComponentModelClass) {
        (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).registerClass(ComponentModelClass);
    },
    registerComponentView: function(ComponentViewClass) {
        (0, $8b851331e51a1131$export$2e2bcd8739ae039).registerClass(ComponentViewClass);
    },
    registerSeriesModel: function(SeriesModelClass) {
        (0, $19b580a0cd6e92eb$export$2e2bcd8739ae039).registerClass(SeriesModelClass);
    },
    registerChartView: function(ChartViewClass) {
        (0, $80462d4f8a33fa64$export$2e2bcd8739ae039).registerClass(ChartViewClass);
    },
    registerSubTypeDefaulter: function(componentType, defaulter) {
        (0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039).registerSubTypeDefaulter(componentType, defaulter);
    },
    registerPainter: function(painterType, PainterCtor) {
        (0, $a6ecc7edacba791e$export$a3e793ccb11823a5)(painterType, PainterCtor);
    }
};
function $dcd0766d99a0579a$export$1f96ae73734a86cc(ext) {
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(ext)) {
        // use([ChartLine, ChartBar]);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(ext, function(singleExt) {
            $dcd0766d99a0579a$export$1f96ae73734a86cc(singleExt);
        });
        return;
    }
    if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)($dcd0766d99a0579a$var$extensions, ext) >= 0) return;
    $dcd0766d99a0579a$var$extensions.push(ext);
    if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(ext)) ext = {
        install: ext
    };
    ext.install($dcd0766d99a0579a$var$extensionRegisters);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










function $5840dfd310848969$var$createDom(id, painter, dpr) {
    var newDom = (0, $024b63ea846a8ccd$export$ef5e599365494451).createCanvas();
    var width = painter.getWidth();
    var height = painter.getHeight();
    var newDomStyle = newDom.style;
    if (newDomStyle) {
        newDomStyle.position = 'absolute';
        newDomStyle.left = '0';
        newDomStyle.top = '0';
        newDomStyle.width = width + 'px';
        newDomStyle.height = height + 'px';
        newDom.setAttribute('data-zr-dom-id', id);
    }
    newDom.width = width * dpr;
    newDom.height = height * dpr;
    return newDom;
}
var $5840dfd310848969$var$Layer = function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, painter, dpr) {
        var _this = _super.call(this) || this;
        _this.motionBlur = false;
        _this.lastFrameAlpha = 0.7;
        _this.dpr = 1;
        _this.virtual = false;
        _this.config = {};
        _this.incremental = false;
        _this.zlevel = 0;
        _this.maxRepaintRectCount = 5;
        _this.__dirty = true;
        _this.__firstTimePaint = true;
        _this.__used = false;
        _this.__drawIndex = 0;
        _this.__startIndex = 0;
        _this.__endIndex = 0;
        _this.__prevStartIndex = null;
        _this.__prevEndIndex = null;
        var dom;
        dpr = dpr || (0, $495ebc0cfec45c57$export$508f096bfcdaac40);
        if (typeof id === 'string') dom = $5840dfd310848969$var$createDom(id, painter, dpr);
        else if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(id)) {
            dom = id;
            id = dom.id;
        }
        _this.id = id;
        _this.dom = dom;
        var domStyle = dom.style;
        if (domStyle) {
            $1b239fc9d3a2f8ae$export$23a5d775868fdd2c(dom);
            dom.onselectstart = function() {
                return false;
            };
            domStyle.padding = '0';
            domStyle.margin = '0';
            domStyle.borderWidth = '0';
        }
        _this.painter = painter;
        _this.dpr = dpr;
        return _this;
    }
    Layer.prototype.getElementCount = function() {
        return this.__endIndex - this.__startIndex;
    };
    Layer.prototype.afterBrush = function() {
        this.__prevStartIndex = this.__startIndex;
        this.__prevEndIndex = this.__endIndex;
    };
    Layer.prototype.initContext = function() {
        this.ctx = this.dom.getContext('2d');
        this.ctx.dpr = this.dpr;
    };
    Layer.prototype.setUnpainted = function() {
        this.__firstTimePaint = true;
    };
    Layer.prototype.createBackBuffer = function() {
        var dpr = this.dpr;
        this.domBack = $5840dfd310848969$var$createDom('back-' + this.id, this.painter, dpr);
        this.ctxBack = this.domBack.getContext('2d');
        if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
    };
    Layer.prototype.createRepaintRects = function(displayList, prevList, viewWidth, viewHeight) {
        if (this.__firstTimePaint) {
            this.__firstTimePaint = false;
            return null;
        }
        var mergedRepaintRects = [];
        var maxRepaintRectCount = this.maxRepaintRectCount;
        var full = false;
        var pendingRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
        function addRectToMergePool(rect) {
            if (!rect.isFinite() || rect.isZero()) return;
            if (mergedRepaintRects.length === 0) {
                var boundingRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
                boundingRect.copy(rect);
                mergedRepaintRects.push(boundingRect);
            } else {
                var isMerged = false;
                var minDeltaArea = Infinity;
                var bestRectToMergeIdx = 0;
                for(var i = 0; i < mergedRepaintRects.length; ++i){
                    var mergedRect = mergedRepaintRects[i];
                    if (mergedRect.intersect(rect)) {
                        var pendingRect_1 = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
                        pendingRect_1.copy(mergedRect);
                        pendingRect_1.union(rect);
                        mergedRepaintRects[i] = pendingRect_1;
                        isMerged = true;
                        break;
                    } else if (full) {
                        pendingRect.copy(rect);
                        pendingRect.union(mergedRect);
                        var aArea = rect.width * rect.height;
                        var bArea = mergedRect.width * mergedRect.height;
                        var pendingArea = pendingRect.width * pendingRect.height;
                        var deltaArea = pendingArea - aArea - bArea;
                        if (deltaArea < minDeltaArea) {
                            minDeltaArea = deltaArea;
                            bestRectToMergeIdx = i;
                        }
                    }
                }
                if (full) {
                    mergedRepaintRects[bestRectToMergeIdx].union(rect);
                    isMerged = true;
                }
                if (!isMerged) {
                    var boundingRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
                    boundingRect.copy(rect);
                    mergedRepaintRects.push(boundingRect);
                }
                if (!full) full = mergedRepaintRects.length >= maxRepaintRectCount;
            }
        }
        for(var i = this.__startIndex; i < this.__endIndex; ++i){
            var el = displayList[i];
            if (el) {
                var shouldPaint = el.shouldBePainted(viewWidth, viewHeight, true, true);
                var prevRect = el.__isRendered && (el.__dirty & (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd) || !shouldPaint) ? el.getPrevPaintRect() : null;
                if (prevRect) addRectToMergePool(prevRect);
                var curRect = shouldPaint && (el.__dirty & (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd) || !el.__isRendered) ? el.getPaintRect() : null;
                if (curRect) addRectToMergePool(curRect);
            }
        }
        for(var i = this.__prevStartIndex; i < this.__prevEndIndex; ++i){
            var el = prevList[i];
            var shouldPaint = el && el.shouldBePainted(viewWidth, viewHeight, true, true);
            if (el && (!shouldPaint || !el.__zr) && el.__isRendered) {
                var prevRect = el.getPrevPaintRect();
                if (prevRect) addRectToMergePool(prevRect);
            }
        }
        var hasIntersections;
        do {
            hasIntersections = false;
            for(var i = 0; i < mergedRepaintRects.length;){
                if (mergedRepaintRects[i].isZero()) {
                    mergedRepaintRects.splice(i, 1);
                    continue;
                }
                for(var j = i + 1; j < mergedRepaintRects.length;)if (mergedRepaintRects[i].intersect(mergedRepaintRects[j])) {
                    hasIntersections = true;
                    mergedRepaintRects[i].union(mergedRepaintRects[j]);
                    mergedRepaintRects.splice(j, 1);
                } else j++;
                i++;
            }
        }while (hasIntersections);
        this._paintRects = mergedRepaintRects;
        return mergedRepaintRects;
    };
    Layer.prototype.debugGetPaintRects = function() {
        return (this._paintRects || []).slice();
    };
    Layer.prototype.resize = function(width, height) {
        var dpr = this.dpr;
        var dom = this.dom;
        var domStyle = dom.style;
        var domBack = this.domBack;
        if (domStyle) {
            domStyle.width = width + 'px';
            domStyle.height = height + 'px';
        }
        dom.width = width * dpr;
        dom.height = height * dpr;
        if (domBack) {
            domBack.width = width * dpr;
            domBack.height = height * dpr;
            if (dpr !== 1) this.ctxBack.scale(dpr, dpr);
        }
    };
    Layer.prototype.clear = function(clearAll, clearColor, repaintRects) {
        var dom = this.dom;
        var ctx = this.ctx;
        var width = dom.width;
        var height = dom.height;
        clearColor = clearColor || this.clearColor;
        var haveMotionBLur = this.motionBlur && !clearAll;
        var lastFrameAlpha = this.lastFrameAlpha;
        var dpr = this.dpr;
        var self = this;
        if (haveMotionBLur) {
            if (!this.domBack) this.createBackBuffer();
            this.ctxBack.globalCompositeOperation = 'copy';
            this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
        }
        var domBack = this.domBack;
        function doClear(x, y, width, height) {
            ctx.clearRect(x, y, width, height);
            if (clearColor && clearColor !== 'transparent') {
                var clearColorGradientOrPattern = void 0;
                if ($1b239fc9d3a2f8ae$export$fa2c283003ed971c(clearColor)) {
                    var shouldCache = clearColor.global || clearColor.__width === width && clearColor.__height === height;
                    clearColorGradientOrPattern = shouldCache && clearColor.__canvasGradient || (0, $9b483e37735cf979$export$3dab6afd018d48c7)(ctx, clearColor, {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                    clearColor.__canvasGradient = clearColorGradientOrPattern;
                    clearColor.__width = width;
                    clearColor.__height = height;
                } else if ($1b239fc9d3a2f8ae$export$a49bbf3a55dcef7b(clearColor)) {
                    clearColor.scaleX = clearColor.scaleX || dpr;
                    clearColor.scaleY = clearColor.scaleY || dpr;
                    clearColorGradientOrPattern = (0, $a639152f35090585$export$8eb5db6b7bc27903)(ctx, clearColor, {
                        dirty: function() {
                            self.setUnpainted();
                            self.painter.refresh();
                        }
                    });
                }
                ctx.save();
                ctx.fillStyle = clearColorGradientOrPattern || clearColor;
                ctx.fillRect(x, y, width, height);
                ctx.restore();
            }
            if (haveMotionBLur) {
                ctx.save();
                ctx.globalAlpha = lastFrameAlpha;
                ctx.drawImage(domBack, x, y, width, height);
                ctx.restore();
            }
        }
        if (!repaintRects || haveMotionBLur) doClear(0, 0, width, height);
        else if (repaintRects.length) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(repaintRects, function(rect) {
            doClear(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
        });
    };
    return Layer;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
var $5840dfd310848969$export$2e2bcd8739ae039 = $5840dfd310848969$var$Layer;







var $2da3e1f738322bb9$var$HOVER_LAYER_ZLEVEL = 1e5;
var $2da3e1f738322bb9$var$CANVAS_ZLEVEL = 314159;
var $2da3e1f738322bb9$var$EL_AFTER_INCREMENTAL_INC = 0.01;
var $2da3e1f738322bb9$var$INCREMENTAL_INC = 0.001;
function $2da3e1f738322bb9$var$isLayerValid(layer) {
    if (!layer) return false;
    if (layer.__builtin__) return true;
    if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') return false;
    return true;
}
function $2da3e1f738322bb9$var$createRoot(width, height) {
    var domRoot = document.createElement('div');
    domRoot.style.cssText = [
        'position:relative',
        'width:' + width + 'px',
        'height:' + height + 'px',
        'padding:0',
        'margin:0',
        'border-width:0'
    ].join(';') + ';';
    return domRoot;
}
var $2da3e1f738322bb9$var$CanvasPainter = function() {
    function CanvasPainter(root, storage, opts, id) {
        this.type = 'canvas';
        this._zlevelList = [];
        this._prevDisplayList = [];
        this._layers = {};
        this._layerConfig = {};
        this._needsManuallyCompositing = false;
        this.type = 'canvas';
        var singleCanvas = !root.nodeName || root.nodeName.toUpperCase() === 'CANVAS';
        this._opts = opts = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, opts || {});
        this.dpr = opts.devicePixelRatio || (0, $495ebc0cfec45c57$export$508f096bfcdaac40);
        this._singleCanvas = singleCanvas;
        this.root = root;
        var rootStyle = root.style;
        if (rootStyle) {
            $1b239fc9d3a2f8ae$export$23a5d775868fdd2c(root);
            root.innerHTML = '';
        }
        this.storage = storage;
        var zlevelList = this._zlevelList;
        this._prevDisplayList = [];
        var layers = this._layers;
        if (!singleCanvas) {
            this._width = (0, $9b483e37735cf979$export$31b21d0167753bb4)(root, 0, opts);
            this._height = (0, $9b483e37735cf979$export$31b21d0167753bb4)(root, 1, opts);
            var domRoot = this._domRoot = $2da3e1f738322bb9$var$createRoot(this._width, this._height);
            root.appendChild(domRoot);
        } else {
            var rootCanvas = root;
            var width = rootCanvas.width;
            var height = rootCanvas.height;
            if (opts.width != null) width = opts.width;
            if (opts.height != null) height = opts.height;
            this.dpr = opts.devicePixelRatio || 1;
            rootCanvas.width = width * this.dpr;
            rootCanvas.height = height * this.dpr;
            this._width = width;
            this._height = height;
            var mainLayer = new (0, $5840dfd310848969$export$2e2bcd8739ae039)(rootCanvas, this, this.dpr);
            mainLayer.__builtin__ = true;
            mainLayer.initContext();
            layers[$2da3e1f738322bb9$var$CANVAS_ZLEVEL] = mainLayer;
            mainLayer.zlevel = $2da3e1f738322bb9$var$CANVAS_ZLEVEL;
            zlevelList.push($2da3e1f738322bb9$var$CANVAS_ZLEVEL);
            this._domRoot = root;
        }
    }
    CanvasPainter.prototype.getType = function() {
        return 'canvas';
    };
    CanvasPainter.prototype.isSingleCanvas = function() {
        return this._singleCanvas;
    };
    CanvasPainter.prototype.getViewportRoot = function() {
        return this._domRoot;
    };
    CanvasPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    CanvasPainter.prototype.refresh = function(paintAll) {
        var list = this.storage.getDisplayList(true);
        var prevList = this._prevDisplayList;
        var zlevelList = this._zlevelList;
        this._redrawId = Math.random();
        this._paintList(list, prevList, paintAll, this._redrawId);
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__ && layer.refresh) {
                var clearColor = i === 0 ? this._backgroundColor : null;
                layer.refresh(clearColor);
            }
        }
        if (this._opts.useDirtyRect) this._prevDisplayList = list.slice();
        return this;
    };
    CanvasPainter.prototype.refreshHover = function() {
        this._paintHoverList(this.storage.getDisplayList(false));
    };
    CanvasPainter.prototype._paintHoverList = function(list) {
        var len = list.length;
        var hoverLayer = this._hoverlayer;
        hoverLayer && hoverLayer.clear();
        if (!len) return;
        var scope = {
            inHover: true,
            viewWidth: this._width,
            viewHeight: this._height
        };
        var ctx;
        for(var i = 0; i < len; i++){
            var el = list[i];
            if (el.__inHover) {
                if (!hoverLayer) hoverLayer = this._hoverlayer = this.getLayer($2da3e1f738322bb9$var$HOVER_LAYER_ZLEVEL);
                if (!ctx) {
                    ctx = hoverLayer.ctx;
                    ctx.save();
                }
                (0, $a639152f35090585$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        if (ctx) ctx.restore();
    };
    CanvasPainter.prototype.getHoverLayer = function() {
        return this.getLayer($2da3e1f738322bb9$var$HOVER_LAYER_ZLEVEL);
    };
    CanvasPainter.prototype.paintOne = function(ctx, el) {
        (0, $a639152f35090585$export$567881adfc3eb7f3)(ctx, el);
    };
    CanvasPainter.prototype._paintList = function(list, prevList, paintAll, redrawId) {
        if (this._redrawId !== redrawId) return;
        paintAll = paintAll || false;
        this._updateLayerStatus(list);
        var _a = this._doPaintList(list, prevList, paintAll), finished = _a.finished, needsRefreshHover = _a.needsRefreshHover;
        if (this._needsManuallyCompositing) this._compositeManually();
        if (needsRefreshHover) this._paintHoverList(list);
        if (!finished) {
            var self_1 = this;
            (0, $e582c54f2022f90d$export$2e2bcd8739ae039)(function() {
                self_1._paintList(list, prevList, paintAll, redrawId);
            });
        } else this.eachLayer(function(layer) {
            layer.afterBrush && layer.afterBrush();
        });
    };
    CanvasPainter.prototype._compositeManually = function() {
        var ctx = this.getLayer($2da3e1f738322bb9$var$CANVAS_ZLEVEL).ctx;
        var width = this._domRoot.width;
        var height = this._domRoot.height;
        ctx.clearRect(0, 0, width, height);
        this.eachBuiltinLayer(function(layer) {
            if (layer.virtual) ctx.drawImage(layer.dom, 0, 0, width, height);
        });
    };
    CanvasPainter.prototype._doPaintList = function(list, prevList, paintAll) {
        var _this = this;
        var layerList = [];
        var useDirtyRect = this._opts.useDirtyRect;
        for(var zi = 0; zi < this._zlevelList.length; zi++){
            var zlevel = this._zlevelList[zi];
            var layer = this._layers[zlevel];
            if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) layerList.push(layer);
        }
        var finished = true;
        var needsRefreshHover = false;
        var _loop_1 = function(k) {
            var layer = layerList[k];
            var ctx = layer.ctx;
            var repaintRects = useDirtyRect && layer.createRepaintRects(list, prevList, this_1._width, this_1._height);
            var start = paintAll ? layer.__startIndex : layer.__drawIndex;
            var useTimer = !paintAll && layer.incremental && Date.now;
            var startTime = useTimer && Date.now();
            var clearColor = layer.zlevel === this_1._zlevelList[0] ? this_1._backgroundColor : null;
            if (layer.__startIndex === layer.__endIndex) layer.clear(false, clearColor, repaintRects);
            else if (start === layer.__startIndex) {
                var firstEl = list[start];
                if (!firstEl.incremental || !firstEl.notClear || paintAll) layer.clear(false, clearColor, repaintRects);
            }
            if (start === -1) {
                console.error('For some unknown reason. drawIndex is -1');
                start = layer.__startIndex;
            }
            var i;
            var repaint = function(repaintRect) {
                var scope = {
                    inHover: false,
                    allClipped: false,
                    prevEl: null,
                    viewWidth: _this._width,
                    viewHeight: _this._height
                };
                for(i = start; i < layer.__endIndex; i++){
                    var el = list[i];
                    if (el.__inHover) needsRefreshHover = true;
                    _this._doPaintEl(el, layer, useDirtyRect, repaintRect, scope, i === layer.__endIndex - 1);
                    if (useTimer) {
                        var dTime = Date.now() - startTime;
                        if (dTime > 15) break;
                    }
                }
                if (scope.prevElClipPaths) ctx.restore();
            };
            if (repaintRects) {
                if (repaintRects.length === 0) i = layer.__endIndex;
                else {
                    var dpr = this_1.dpr;
                    for(var r = 0; r < repaintRects.length; ++r){
                        var rect = repaintRects[r];
                        ctx.save();
                        ctx.beginPath();
                        ctx.rect(rect.x * dpr, rect.y * dpr, rect.width * dpr, rect.height * dpr);
                        ctx.clip();
                        repaint(rect);
                        ctx.restore();
                    }
                }
            } else {
                ctx.save();
                repaint();
                ctx.restore();
            }
            layer.__drawIndex = i;
            if (layer.__drawIndex < layer.__endIndex) finished = false;
        };
        var this_1 = this;
        for(var k = 0; k < layerList.length; k++)_loop_1(k);
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).wxa) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._layers, function(layer) {
            if (layer && layer.ctx && layer.ctx.draw) layer.ctx.draw();
        });
        return {
            finished: finished,
            needsRefreshHover: needsRefreshHover
        };
    };
    CanvasPainter.prototype._doPaintEl = function(el, currentLayer, useDirtyRect, repaintRect, scope, isLast) {
        var ctx = currentLayer.ctx;
        if (useDirtyRect) {
            var paintRect = el.getPaintRect();
            if (!repaintRect || paintRect && paintRect.intersect(repaintRect)) {
                (0, $a639152f35090585$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
                el.setPrevPaintRect(paintRect);
            }
        } else (0, $a639152f35090585$export$da5d6544e8c27bc1)(ctx, el, scope, isLast);
    };
    CanvasPainter.prototype.getLayer = function(zlevel, virtual) {
        if (this._singleCanvas && !this._needsManuallyCompositing) zlevel = $2da3e1f738322bb9$var$CANVAS_ZLEVEL;
        var layer = this._layers[zlevel];
        if (!layer) {
            layer = new (0, $5840dfd310848969$export$2e2bcd8739ae039)('zr_' + zlevel, this, this.dpr);
            layer.zlevel = zlevel;
            layer.__builtin__ = true;
            if (this._layerConfig[zlevel]) $1b239fc9d3a2f8ae$export$4950aa0f605343fb(layer, this._layerConfig[zlevel], true);
            else if (this._layerConfig[zlevel - $2da3e1f738322bb9$var$EL_AFTER_INCREMENTAL_INC]) $1b239fc9d3a2f8ae$export$4950aa0f605343fb(layer, this._layerConfig[zlevel - $2da3e1f738322bb9$var$EL_AFTER_INCREMENTAL_INC], true);
            if (virtual) layer.virtual = virtual;
            this.insertLayer(zlevel, layer);
            layer.initContext();
        }
        return layer;
    };
    CanvasPainter.prototype.insertLayer = function(zlevel, layer) {
        var layersMap = this._layers;
        var zlevelList = this._zlevelList;
        var len = zlevelList.length;
        var domRoot = this._domRoot;
        var prevLayer = null;
        var i = -1;
        if (layersMap[zlevel]) return;
        if (!$2da3e1f738322bb9$var$isLayerValid(layer)) return;
        if (len > 0 && zlevel > zlevelList[0]) {
            for(i = 0; i < len - 1; i++){
                if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) break;
            }
            prevLayer = layersMap[zlevelList[i]];
        }
        zlevelList.splice(i + 1, 0, zlevel);
        layersMap[zlevel] = layer;
        if (!layer.virtual) {
            if (prevLayer) {
                var prevDom = prevLayer.dom;
                if (prevDom.nextSibling) domRoot.insertBefore(layer.dom, prevDom.nextSibling);
                else domRoot.appendChild(layer.dom);
            } else if (domRoot.firstChild) domRoot.insertBefore(layer.dom, domRoot.firstChild);
            else domRoot.appendChild(layer.dom);
        }
        layer.painter || (layer.painter = this);
    };
    CanvasPainter.prototype.eachLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            cb.call(context, this._layers[z], z);
        }
    };
    CanvasPainter.prototype.eachBuiltinLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.eachOtherLayer = function(cb, context) {
        var zlevelList = this._zlevelList;
        for(var i = 0; i < zlevelList.length; i++){
            var z = zlevelList[i];
            var layer = this._layers[z];
            if (!layer.__builtin__) cb.call(context, layer, z);
        }
    };
    CanvasPainter.prototype.getLayers = function() {
        return this._layers;
    };
    CanvasPainter.prototype._updateLayerStatus = function(list) {
        this.eachBuiltinLayer(function(layer, z) {
            layer.__dirty = layer.__used = false;
        });
        function updatePrevLayer(idx) {
            if (prevLayer) {
                if (prevLayer.__endIndex !== idx) prevLayer.__dirty = true;
                prevLayer.__endIndex = idx;
            }
        }
        if (this._singleCanvas) for(var i_1 = 1; i_1 < list.length; i_1++){
            var el = list[i_1];
            if (el.zlevel !== list[i_1 - 1].zlevel || el.incremental) {
                this._needsManuallyCompositing = true;
                break;
            }
        }
        var prevLayer = null;
        var incrementalLayerCount = 0;
        var prevZlevel;
        var i;
        for(i = 0; i < list.length; i++){
            var el = list[i];
            var zlevel = el.zlevel;
            var layer = void 0;
            if (prevZlevel !== zlevel) {
                prevZlevel = zlevel;
                incrementalLayerCount = 0;
            }
            if (el.incremental) {
                layer = this.getLayer(zlevel + $2da3e1f738322bb9$var$INCREMENTAL_INC, this._needsManuallyCompositing);
                layer.incremental = true;
                incrementalLayerCount = 1;
            } else layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? $2da3e1f738322bb9$var$EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
            if (!layer.__builtin__) $1b239fc9d3a2f8ae$export$58da9968c3170cb1('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
            if (layer !== prevLayer) {
                layer.__used = true;
                if (layer.__startIndex !== i) layer.__dirty = true;
                layer.__startIndex = i;
                if (!layer.incremental) layer.__drawIndex = i;
                else layer.__drawIndex = -1;
                updatePrevLayer(i);
                prevLayer = layer;
            }
            if (el.__dirty & (0, $7bc42091a9de0611$export$a7b6db622c6c7dbd) && !el.__inHover) {
                layer.__dirty = true;
                if (layer.incremental && layer.__drawIndex < 0) layer.__drawIndex = i;
            }
        }
        updatePrevLayer(i);
        this.eachBuiltinLayer(function(layer, z) {
            if (!layer.__used && layer.getElementCount() > 0) {
                layer.__dirty = true;
                layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
            }
            if (layer.__dirty && layer.__drawIndex < 0) layer.__drawIndex = layer.__startIndex;
        });
    };
    CanvasPainter.prototype.clear = function() {
        this.eachBuiltinLayer(this._clearLayer);
        return this;
    };
    CanvasPainter.prototype._clearLayer = function(layer) {
        layer.clear();
    };
    CanvasPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._layers, function(layer) {
            layer.setUnpainted();
        });
    };
    CanvasPainter.prototype.configLayer = function(zlevel, config) {
        if (config) {
            var layerConfig = this._layerConfig;
            if (!layerConfig[zlevel]) layerConfig[zlevel] = config;
            else $1b239fc9d3a2f8ae$export$4950aa0f605343fb(layerConfig[zlevel], config, true);
            for(var i = 0; i < this._zlevelList.length; i++){
                var _zlevel = this._zlevelList[i];
                if (_zlevel === zlevel || _zlevel === zlevel + $2da3e1f738322bb9$var$EL_AFTER_INCREMENTAL_INC) {
                    var layer = this._layers[_zlevel];
                    $1b239fc9d3a2f8ae$export$4950aa0f605343fb(layer, layerConfig[zlevel], true);
                }
            }
        }
    };
    CanvasPainter.prototype.delLayer = function(zlevel) {
        var layers = this._layers;
        var zlevelList = this._zlevelList;
        var layer = layers[zlevel];
        if (!layer) return;
        layer.dom.parentNode.removeChild(layer.dom);
        delete layers[zlevel];
        zlevelList.splice($1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(zlevelList, zlevel), 1);
    };
    CanvasPainter.prototype.resize = function(width, height) {
        if (!this._domRoot.style) {
            if (width == null || height == null) return;
            this._width = width;
            this._height = height;
            this.getLayer($2da3e1f738322bb9$var$CANVAS_ZLEVEL).resize(width, height);
        } else {
            var domRoot = this._domRoot;
            domRoot.style.display = 'none';
            var opts = this._opts;
            var root = this.root;
            width != null && (opts.width = width);
            height != null && (opts.height = height);
            width = (0, $9b483e37735cf979$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $9b483e37735cf979$export$31b21d0167753bb4)(root, 1, opts);
            domRoot.style.display = '';
            if (this._width !== width || height !== this._height) {
                domRoot.style.width = width + 'px';
                domRoot.style.height = height + 'px';
                for(var id in this._layers)if (this._layers.hasOwnProperty(id)) this._layers[id].resize(width, height);
                this.refresh(true);
            }
            this._width = width;
            this._height = height;
        }
        return this;
    };
    CanvasPainter.prototype.clearLayer = function(zlevel) {
        var layer = this._layers[zlevel];
        if (layer) layer.clear();
    };
    CanvasPainter.prototype.dispose = function() {
        this.root.innerHTML = '';
        this.root = this.storage = this._domRoot = this._layers = null;
    };
    CanvasPainter.prototype.getRenderedCanvas = function(opts) {
        opts = opts || {};
        if (this._singleCanvas && !this._compositeManually) return this._layers[$2da3e1f738322bb9$var$CANVAS_ZLEVEL].dom;
        var imageLayer = new (0, $5840dfd310848969$export$2e2bcd8739ae039)('image', this, opts.pixelRatio || this.dpr);
        imageLayer.initContext();
        imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
        var ctx = imageLayer.ctx;
        if (opts.pixelRatio <= this.dpr) {
            this.refresh();
            var width_1 = imageLayer.dom.width;
            var height_1 = imageLayer.dom.height;
            this.eachLayer(function(layer) {
                if (layer.__builtin__) ctx.drawImage(layer.dom, 0, 0, width_1, height_1);
                else if (layer.renderToCanvas) {
                    ctx.save();
                    layer.renderToCanvas(ctx);
                    ctx.restore();
                }
            });
        } else {
            var scope = {
                inHover: false,
                viewWidth: this._width,
                viewHeight: this._height
            };
            var displayList = this.storage.getDisplayList(true);
            for(var i = 0, len = displayList.length; i < len; i++){
                var el = displayList[i];
                (0, $a639152f35090585$export$da5d6544e8c27bc1)(ctx, el, scope, i === len - 1);
            }
        }
        return imageLayer.dom;
    };
    CanvasPainter.prototype.getWidth = function() {
        return this._width;
    };
    CanvasPainter.prototype.getHeight = function() {
        return this._height;
    };
    return CanvasPainter;
}();
var $2da3e1f738322bb9$export$2e2bcd8739ae039 = $2da3e1f738322bb9$var$CanvasPainter;


function $f3906492a1ee40ef$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('canvas', (0, $2da3e1f738322bb9$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $7cf1288ed6dc4172$var$mathSin = Math.sin;
var $7cf1288ed6dc4172$var$mathCos = Math.cos;
var $7cf1288ed6dc4172$var$PI = Math.PI;
var $7cf1288ed6dc4172$var$PI2 = Math.PI * 2;
var $7cf1288ed6dc4172$var$degree = 180 / $7cf1288ed6dc4172$var$PI;
var $7cf1288ed6dc4172$var$SVGPathRebuilder = function() {
    function SVGPathRebuilder() {}
    SVGPathRebuilder.prototype.reset = function(precision) {
        this._start = true;
        this._d = [];
        this._str = '';
        this._p = Math.pow(10, precision || 4);
    };
    SVGPathRebuilder.prototype.moveTo = function(x, y) {
        this._add('M', x, y);
    };
    SVGPathRebuilder.prototype.lineTo = function(x, y) {
        this._add('L', x, y);
    };
    SVGPathRebuilder.prototype.bezierCurveTo = function(x, y, x2, y2, x3, y3) {
        this._add('C', x, y, x2, y2, x3, y3);
    };
    SVGPathRebuilder.prototype.quadraticCurveTo = function(x, y, x2, y2) {
        this._add('Q', x, y, x2, y2);
    };
    SVGPathRebuilder.prototype.arc = function(cx, cy, r, startAngle, endAngle, anticlockwise) {
        this.ellipse(cx, cy, r, r, 0, startAngle, endAngle, anticlockwise);
    };
    SVGPathRebuilder.prototype.ellipse = function(cx, cy, rx, ry, psi, startAngle, endAngle, anticlockwise) {
        var dTheta = endAngle - startAngle;
        var clockwise = !anticlockwise;
        var dThetaPositive = Math.abs(dTheta);
        var isCircle = (0, $c453016f40eca611$export$4701367f5b4de464)(dThetaPositive - $7cf1288ed6dc4172$var$PI2) || (clockwise ? dTheta >= $7cf1288ed6dc4172$var$PI2 : -dTheta >= $7cf1288ed6dc4172$var$PI2);
        var unifiedTheta = dTheta > 0 ? dTheta % $7cf1288ed6dc4172$var$PI2 : dTheta % $7cf1288ed6dc4172$var$PI2 + $7cf1288ed6dc4172$var$PI2;
        var large = false;
        if (isCircle) large = true;
        else if ((0, $c453016f40eca611$export$4701367f5b4de464)(dThetaPositive)) large = false;
        else large = unifiedTheta >= $7cf1288ed6dc4172$var$PI === !!clockwise;
        var x0 = cx + rx * $7cf1288ed6dc4172$var$mathCos(startAngle);
        var y0 = cy + ry * $7cf1288ed6dc4172$var$mathSin(startAngle);
        if (this._start) this._add('M', x0, y0);
        var xRot = Math.round(psi * $7cf1288ed6dc4172$var$degree);
        if (isCircle) {
            var p = 1 / this._p;
            var dTheta_1 = (clockwise ? 1 : -1) * ($7cf1288ed6dc4172$var$PI2 - p);
            this._add('A', rx, ry, xRot, 1, +clockwise, cx + rx * $7cf1288ed6dc4172$var$mathCos(startAngle + dTheta_1), cy + ry * $7cf1288ed6dc4172$var$mathSin(startAngle + dTheta_1));
            if (p > 1e-2) this._add('A', rx, ry, xRot, 0, +clockwise, x0, y0);
        } else {
            var x = cx + rx * $7cf1288ed6dc4172$var$mathCos(endAngle);
            var y = cy + ry * $7cf1288ed6dc4172$var$mathSin(endAngle);
            this._add('A', rx, ry, xRot, +large, +clockwise, x, y);
        }
    };
    SVGPathRebuilder.prototype.rect = function(x, y, w, h) {
        this._add('M', x, y);
        this._add('l', w, 0);
        this._add('l', 0, h);
        this._add('l', -w, 0);
        this._add('Z');
    };
    SVGPathRebuilder.prototype.closePath = function() {
        if (this._d.length > 0) this._add('Z');
    };
    SVGPathRebuilder.prototype._add = function(cmd, a, b, c, d, e, f, g, h) {
        var vals = [];
        var p = this._p;
        for(var i = 1; i < arguments.length; i++){
            var val = arguments[i];
            if (isNaN(val)) {
                this._invalid = true;
                return;
            }
            vals.push(Math.round(val * p) / p);
        }
        this._d.push(cmd + vals.join(' '));
        this._start = cmd === 'Z';
    };
    SVGPathRebuilder.prototype.generateStr = function() {
        this._str = this._invalid ? '' : this._d.join('');
        this._d = [];
    };
    SVGPathRebuilder.prototype.getStr = function() {
        return this._str;
    };
    return SVGPathRebuilder;
}();
var $7cf1288ed6dc4172$export$2e2bcd8739ae039 = $7cf1288ed6dc4172$var$SVGPathRebuilder;







var $efed2c3938181f04$var$NONE = 'none';
var $efed2c3938181f04$var$mathRound = Math.round;
function $efed2c3938181f04$var$pathHasFill(style) {
    var fill = style.fill;
    return fill != null && fill !== $efed2c3938181f04$var$NONE;
}
function $efed2c3938181f04$var$pathHasStroke(style) {
    var stroke = style.stroke;
    return stroke != null && stroke !== $efed2c3938181f04$var$NONE;
}
var $efed2c3938181f04$var$strokeProps = [
    'lineCap',
    'miterLimit',
    'lineJoin'
];
var $efed2c3938181f04$var$svgStrokeProps = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)($efed2c3938181f04$var$strokeProps, function(prop) {
    return "stroke-" + prop.toLowerCase();
});
function $efed2c3938181f04$export$2e2bcd8739ae039(updateAttr, style, el, forceUpdate) {
    var opacity = style.opacity == null ? 1 : style.opacity;
    if (el instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) {
        updateAttr('opacity', opacity);
        return;
    }
    if ($efed2c3938181f04$var$pathHasFill(style)) {
        var fill = (0, $c453016f40eca611$export$4cde5df63f53f473)(style.fill);
        updateAttr('fill', fill.color);
        var fillOpacity = style.fillOpacity != null ? style.fillOpacity * fill.opacity * opacity : fill.opacity * opacity;
        if (forceUpdate || fillOpacity < 1) updateAttr('fill-opacity', fillOpacity);
    } else updateAttr('fill', $efed2c3938181f04$var$NONE);
    if ($efed2c3938181f04$var$pathHasStroke(style)) {
        var stroke = (0, $c453016f40eca611$export$4cde5df63f53f473)(style.stroke);
        updateAttr('stroke', stroke.color);
        var strokeScale = style.strokeNoScale ? el.getLineScale() : 1;
        var strokeWidth = strokeScale ? (style.lineWidth || 0) / strokeScale : 0;
        var strokeOpacity = style.strokeOpacity != null ? style.strokeOpacity * stroke.opacity * opacity : stroke.opacity * opacity;
        var strokeFirst = style.strokeFirst;
        if (forceUpdate || strokeWidth !== 1) updateAttr('stroke-width', strokeWidth);
        if (forceUpdate || strokeFirst) updateAttr('paint-order', strokeFirst ? 'stroke' : 'fill');
        if (forceUpdate || strokeOpacity < 1) updateAttr('stroke-opacity', strokeOpacity);
        if (style.lineDash) {
            var _a = (0, $ceacb1517b0bd545$export$9d315911f153b3b2)(el), lineDash = _a[0], lineDashOffset = _a[1];
            if (lineDash) {
                lineDashOffset = $efed2c3938181f04$var$mathRound(lineDashOffset || 0);
                updateAttr('stroke-dasharray', lineDash.join(','));
                if (lineDashOffset || forceUpdate) updateAttr('stroke-dashoffset', lineDashOffset);
            }
        } else if (forceUpdate) updateAttr('stroke-dasharray', $efed2c3938181f04$var$NONE);
        for(var i = 0; i < $efed2c3938181f04$var$strokeProps.length; i++){
            var propName = $efed2c3938181f04$var$strokeProps[i];
            if (forceUpdate || style[propName] !== (0, $f9698154c9fcf427$export$deade517576e293a)[propName]) {
                var val = style[propName] || (0, $f9698154c9fcf427$export$deade517576e293a)[propName];
                val && updateAttr($efed2c3938181f04$var$svgStrokeProps[i], val);
            }
        }
    } else if (forceUpdate) updateAttr('stroke', $efed2c3938181f04$var$NONE);
}




var $c1d313cff8511f25$export$a690ad4c9a38f86e = 'http://www.w3.org/2000/svg';
var $c1d313cff8511f25$export$b22c6da1792ecec8 = 'http://www.w3.org/1999/xlink';
var $c1d313cff8511f25$export$fac09d762d15fa3b = 'http://www.w3.org/2000/xmlns/';
var $c1d313cff8511f25$export$ad4c4fdecd3b4156 = 'http://www.w3.org/XML/1998/namespace';
var $c1d313cff8511f25$export$d3f79611f155197c = 'ecmeta_';
function $c1d313cff8511f25$export$c8a8987d4410bf2d(name) {
    return document.createElementNS($c1d313cff8511f25$export$a690ad4c9a38f86e, name);
}
function $c1d313cff8511f25$export$bf5c4cf060303d58(tag, key, attrs, children, text) {
    return {
        tag: tag,
        attrs: attrs || {},
        children: children,
        text: text,
        key: key
    };
}
function $c1d313cff8511f25$var$createElementOpen(name, attrs) {
    var attrsStr = [];
    if (attrs) for(var key in attrs){
        var val = attrs[key];
        var part = key;
        if (val === false) continue;
        else if (val !== true && val != null) part += "=\"" + val + "\"";
        attrsStr.push(part);
    }
    return "<" + name + " " + attrsStr.join(' ') + ">";
}
function $c1d313cff8511f25$var$createElementClose(name) {
    return "</" + name + ">";
}
function $c1d313cff8511f25$export$f5c4a9a0e027f2b(el, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    function convertElToString(el) {
        var children = el.children, tag = el.tag, attrs = el.attrs, text = el.text;
        return $c1d313cff8511f25$var$createElementOpen(tag, attrs) + (tag !== 'style' ? (0, $8032584326d71745$export$f9d6449b9af28dc1)(text) : text || '') + (children ? "" + S + (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(children, function(child) {
            return convertElToString(child);
        }).join(S) + S : '') + $c1d313cff8511f25$var$createElementClose(tag);
    }
    return convertElToString(el);
}
function $c1d313cff8511f25$export$e2b4f3597c7a7dcb(selectorNodes, animationNodes, opts) {
    opts = opts || {};
    var S = opts.newline ? '\n' : '';
    var bracketBegin = " {" + S;
    var bracketEnd = S + "}";
    var selectors = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(selectorNodes), function(className) {
        return className + bracketBegin + (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(selectorNodes[className]), function(attrName) {
            return attrName + ":" + selectorNodes[className][attrName] + ";";
        }).join(S) + bracketEnd;
    }).join(S);
    var animations = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(animationNodes), function(animationName) {
        return "@keyframes " + animationName + bracketBegin + (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(animationNodes[animationName]), function(percent) {
            return percent + bracketBegin + (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(animationNodes[animationName][percent]), function(attrName) {
                var val = animationNodes[animationName][percent][attrName];
                if (attrName === 'd') val = "path(\"" + val + "\")";
                return attrName + ":" + val + ";";
            }).join(S) + bracketEnd;
        }).join(S) + bracketEnd;
    }).join(S);
    if (!selectors && !animations) return '';
    return [
        '<![CDATA[',
        selectors,
        animations,
        ']]>'
    ].join(S);
}
function $c1d313cff8511f25$export$96fee5f38ed01741(zrId) {
    return {
        zrId: zrId,
        shadowCache: {},
        patternCache: {},
        gradientCache: {},
        clipPathCache: {},
        defs: {},
        cssNodes: {},
        cssAnims: {},
        cssStyleCache: {},
        cssAnimIdx: 0,
        shadowIdx: 0,
        gradientIdx: 0,
        patternIdx: 0,
        clipPathIdx: 0
    };
}
function $c1d313cff8511f25$export$5529a6aad332ee75(width, height, children, useViewBox) {
    return $c1d313cff8511f25$export$bf5c4cf060303d58('svg', 'root', {
        'width': width,
        'height': height,
        'xmlns': $c1d313cff8511f25$export$a690ad4c9a38f86e,
        'xmlns:xlink': $c1d313cff8511f25$export$b22c6da1792ecec8,
        'version': '1.1',
        'baseProfile': 'full',
        'viewBox': useViewBox ? "0 0 " + width + " " + height : false
    }, children);
}












var $8b8ff42b3e08c5ac$var$cssClassIdx = 0;
function $8b8ff42b3e08c5ac$export$9c80c36b7367fb56() {
    return $8b8ff42b3e08c5ac$var$cssClassIdx++;
}


var $b2c1901c47c8f594$export$54ee1847795bcf37 = {
    cubicIn: '0.32,0,0.67,0',
    cubicOut: '0.33,1,0.68,1',
    cubicInOut: '0.65,0,0.35,1',
    quadraticIn: '0.11,0,0.5,0',
    quadraticOut: '0.5,1,0.89,1',
    quadraticInOut: '0.45,0,0.55,1',
    quarticIn: '0.5,0,0.75,0',
    quarticOut: '0.25,1,0.5,1',
    quarticInOut: '0.76,0,0.24,1',
    quinticIn: '0.64,0,0.78,0',
    quinticOut: '0.22,1,0.36,1',
    quinticInOut: '0.83,0,0.17,1',
    sinusoidalIn: '0.12,0,0.39,0',
    sinusoidalOut: '0.61,1,0.88,1',
    sinusoidalInOut: '0.37,0,0.63,1',
    exponentialIn: '0.7,0,0.84,0',
    exponentialOut: '0.16,1,0.3,1',
    exponentialInOut: '0.87,0,0.13,1',
    circularIn: '0.55,0,1,0.45',
    circularOut: '0,0.55,0.45,1',
    circularInOut: '0.85,0,0.15,1'
};
var $b2c1901c47c8f594$var$transformOriginKey = 'transform-origin';
function $b2c1901c47c8f594$var$buildPathString(el, kfShape, path) {
    var shape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, el.shape);
    (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(shape, kfShape);
    el.buildPath(path, shape);
    var svgPathBuilder = new (0, $7cf1288ed6dc4172$export$2e2bcd8739ae039)();
    svgPathBuilder.reset((0, $c453016f40eca611$export$93fa1ae8a509371c)(el));
    path.rebuildPath(svgPathBuilder, 1);
    svgPathBuilder.generateStr();
    return svgPathBuilder.getStr();
}
function $b2c1901c47c8f594$var$setTransformOrigin(target, transform) {
    var originX = transform.originX, originY = transform.originY;
    if (originX || originY) target[$b2c1901c47c8f594$var$transformOriginKey] = originX + "px " + originY + "px";
}
var $b2c1901c47c8f594$export$f0dede2064ee89d7 = {
    fill: 'fill',
    opacity: 'opacity',
    lineWidth: 'stroke-width',
    lineDashOffset: 'stroke-dashoffset'
};
function $b2c1901c47c8f594$var$addAnimation(cssAnim, scope) {
    var animationName = scope.zrId + '-ani-' + scope.cssAnimIdx++;
    scope.cssAnims[animationName] = cssAnim;
    return animationName;
}
function $b2c1901c47c8f594$var$createCompoundPathCSSAnimation(el, attrs, scope) {
    var paths = el.shape.paths;
    var composedAnim = {};
    var cssAnimationCfg;
    var cssAnimationName;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(paths, function(path) {
        var subScope = (0, $c1d313cff8511f25$export$96fee5f38ed01741)(scope.zrId);
        subScope.animation = true;
        $b2c1901c47c8f594$export$dc9722e37397d426(path, {}, subScope, true);
        var cssAnims = subScope.cssAnims;
        var cssNodes = subScope.cssNodes;
        var animNames = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(cssAnims);
        var len = animNames.length;
        if (!len) return;
        cssAnimationName = animNames[len - 1];
        var lastAnim = cssAnims[cssAnimationName];
        for(var percent in lastAnim){
            var kf = lastAnim[percent];
            composedAnim[percent] = composedAnim[percent] || {
                d: ''
            };
            composedAnim[percent].d += kf.d || '';
        }
        for(var className in cssNodes){
            var val = cssNodes[className].animation;
            if (val.indexOf(cssAnimationName) >= 0) cssAnimationCfg = val;
        }
    });
    if (!cssAnimationCfg) return;
    attrs.d = false;
    var animationName = $b2c1901c47c8f594$var$addAnimation(composedAnim, scope);
    return cssAnimationCfg.replace(cssAnimationName, animationName);
}
function $b2c1901c47c8f594$var$getEasingFunc(easing) {
    return (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(easing) ? $b2c1901c47c8f594$export$54ee1847795bcf37[easing] ? "cubic-bezier(" + $b2c1901c47c8f594$export$54ee1847795bcf37[easing] + ")" : (0, $d1811699cfe8103c$export$ec0863d806fd857e)(easing) ? easing : '' : '';
}
function $b2c1901c47c8f594$export$dc9722e37397d426(el, attrs, scope, onlyShape) {
    var animators = el.animators;
    var len = animators.length;
    var cssAnimations = [];
    if (el instanceof (0, $dd9b7a63634188ff$export$2e2bcd8739ae039)) {
        var animationCfg = $b2c1901c47c8f594$var$createCompoundPathCSSAnimation(el, attrs, scope);
        if (animationCfg) cssAnimations.push(animationCfg);
        else if (!len) return;
    } else if (!len) return;
    var groupAnimators = {};
    for(var i = 0; i < len; i++){
        var animator = animators[i];
        var cfgArr = [
            animator.getMaxTime() / 1000 + 's'
        ];
        var easing = $b2c1901c47c8f594$var$getEasingFunc(animator.getClip().easing);
        var delay = animator.getDelay();
        if (easing) cfgArr.push(easing);
        else cfgArr.push('linear');
        if (delay) cfgArr.push(delay / 1000 + 's');
        if (animator.getLoop()) cfgArr.push('infinite');
        var cfg = cfgArr.join(' ');
        groupAnimators[cfg] = groupAnimators[cfg] || [
            cfg,
            []
        ];
        groupAnimators[cfg][1].push(animator);
    }
    function createSingleCSSAnimation(groupAnimator) {
        var animators = groupAnimator[1];
        var len = animators.length;
        var transformKfs = {};
        var shapeKfs = {};
        var finalKfs = {};
        var animationTimingFunctionAttrName = 'animation-timing-function';
        function saveAnimatorTrackToCssKfs(animator, cssKfs, toCssAttrName) {
            var tracks = animator.getTracks();
            var maxTime = animator.getMaxTime();
            for(var k = 0; k < tracks.length; k++){
                var track = tracks[k];
                if (track.needsAnimate()) {
                    var kfs = track.keyframes;
                    var attrName = track.propName;
                    toCssAttrName && (attrName = toCssAttrName(attrName));
                    if (attrName) for(var i = 0; i < kfs.length; i++){
                        var kf = kfs[i];
                        var percent = Math.round(kf.time / maxTime * 100) + '%';
                        var kfEasing = $b2c1901c47c8f594$var$getEasingFunc(kf.easing);
                        var rawValue = kf.rawValue;
                        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(rawValue) || (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rawValue)) {
                            cssKfs[percent] = cssKfs[percent] || {};
                            cssKfs[percent][attrName] = kf.rawValue;
                            if (kfEasing) cssKfs[percent][animationTimingFunctionAttrName] = kfEasing;
                        }
                    }
                }
            }
        }
        for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (!targetProp) !onlyShape && saveAnimatorTrackToCssKfs(animator, transformKfs);
            else if (targetProp === 'shape') saveAnimatorTrackToCssKfs(animator, shapeKfs);
        }
        for(var percent in transformKfs){
            var transform = {};
            (0, $cd11a033fc7d29e7$export$234b1c16dfa57d6a)(transform, el);
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(transform, transformKfs[percent]);
            var str = (0, $c453016f40eca611$export$3fe07c0888ff6164)(transform);
            var timingFunction = transformKfs[percent][animationTimingFunctionAttrName];
            finalKfs[percent] = str ? {
                transform: str
            } : {};
            $b2c1901c47c8f594$var$setTransformOrigin(finalKfs[percent], transform);
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        var path;
        var canAnimateShape = true;
        for(var percent in shapeKfs){
            finalKfs[percent] = finalKfs[percent] || {};
            var isFirst = !path;
            var timingFunction = shapeKfs[percent][animationTimingFunctionAttrName];
            if (isFirst) path = new (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039)();
            var len_1 = path.len();
            path.reset();
            finalKfs[percent].d = $b2c1901c47c8f594$var$buildPathString(el, shapeKfs[percent], path);
            var newLen = path.len();
            if (!isFirst && len_1 !== newLen) {
                canAnimateShape = false;
                break;
            }
            if (timingFunction) finalKfs[percent][animationTimingFunctionAttrName] = timingFunction;
        }
        if (!canAnimateShape) for(var percent in finalKfs)delete finalKfs[percent].d;
        if (!onlyShape) for(var i = 0; i < len; i++){
            var animator = animators[i];
            var targetProp = animator.targetName;
            if (targetProp === 'style') saveAnimatorTrackToCssKfs(animator, finalKfs, function(propName) {
                return $b2c1901c47c8f594$export$f0dede2064ee89d7[propName];
            });
        }
        var percents = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(finalKfs);
        var allTransformOriginSame = true;
        var transformOrigin;
        for(var i = 1; i < percents.length; i++){
            var p0 = percents[i - 1];
            var p1 = percents[i];
            if (finalKfs[p0][$b2c1901c47c8f594$var$transformOriginKey] !== finalKfs[p1][$b2c1901c47c8f594$var$transformOriginKey]) {
                allTransformOriginSame = false;
                break;
            }
            transformOrigin = finalKfs[p0][$b2c1901c47c8f594$var$transformOriginKey];
        }
        if (allTransformOriginSame && transformOrigin) {
            for(var percent in finalKfs)if (finalKfs[percent][$b2c1901c47c8f594$var$transformOriginKey]) delete finalKfs[percent][$b2c1901c47c8f594$var$transformOriginKey];
            attrs[$b2c1901c47c8f594$var$transformOriginKey] = transformOrigin;
        }
        if ((0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(percents, function(percent) {
            return (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(finalKfs[percent]).length > 0;
        }).length) {
            var animationName = $b2c1901c47c8f594$var$addAnimation(finalKfs, scope);
            return animationName + " " + groupAnimator[0] + " both";
        }
    }
    for(var key in groupAnimators){
        var animationCfg = createSingleCSSAnimation(groupAnimators[key]);
        if (animationCfg) cssAnimations.push(animationCfg);
    }
    if (cssAnimations.length) {
        var className = scope.zrId + '-cls-' + (0, $8b8ff42b3e08c5ac$export$9c80c36b7367fb56)();
        scope.cssNodes['.' + className] = {
            animation: cssAnimations.join(',')
        };
        attrs["class"] = className;
    }
}






function $0d0cb11dd1a647ef$export$b4c8f742d3cb22ba(el, attrs, scope) {
    if (!el.ignore) {
        if (el.isSilent()) {
            var style = {
                'pointer-events': 'none'
            };
            $0d0cb11dd1a647ef$var$setClassAttribute(style, attrs, scope, true);
        } else {
            var emphasisStyle = el.states.emphasis && el.states.emphasis.style ? el.states.emphasis.style : {};
            var fill = emphasisStyle.fill;
            if (!fill) {
                var normalFill = el.style && el.style.fill;
                var selectFill = el.states.select && el.states.select.style && el.states.select.style.fill;
                var fromFill = el.currentStates.indexOf('select') >= 0 ? selectFill || normalFill : normalFill;
                if (fromFill) fill = (0, $35573db24643e2ef$export$2b47e247dfb87a73)(fromFill);
            }
            var lineWidth = emphasisStyle.lineWidth;
            if (lineWidth) {
                var scaleX = !emphasisStyle.strokeNoScale && el.transform ? el.transform[0] : 1;
                lineWidth = lineWidth / scaleX;
            }
            var style = {
                cursor: 'pointer'
            };
            if (fill) style.fill = fill;
            if (emphasisStyle.stroke) style.stroke = emphasisStyle.stroke;
            if (lineWidth) style['stroke-width'] = lineWidth;
            $0d0cb11dd1a647ef$var$setClassAttribute(style, attrs, scope, true);
        }
    }
}
function $0d0cb11dd1a647ef$var$setClassAttribute(style, attrs, scope, withHover) {
    var styleKey = JSON.stringify(style);
    var className = scope.cssStyleCache[styleKey];
    if (!className) {
        className = scope.zrId + '-cls-' + (0, $8b8ff42b3e08c5ac$export$9c80c36b7367fb56)();
        scope.cssStyleCache[styleKey] = className;
        scope.cssNodes['.' + className + (withHover ? ':hover' : '')] = style;
    }
    attrs["class"] = attrs["class"] ? attrs["class"] + ' ' + className : className;
}



var $496d053c37728dad$var$round = Math.round;
function $496d053c37728dad$var$isImageLike(val) {
    return val && (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(val.src);
}
function $496d053c37728dad$var$isCanvasLike(val) {
    return val && (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(val.toDataURL);
}
function $496d053c37728dad$var$setStyleAttrs(attrs, style, el, scope) {
    (0, $efed2c3938181f04$export$2e2bcd8739ae039)(function(key, val) {
        var isFillStroke = key === 'fill' || key === 'stroke';
        if (isFillStroke && (0, $c453016f40eca611$export$545e02bbd5f8fe95)(val)) $496d053c37728dad$export$afaa8352c6a43a44(style, attrs, key, scope);
        else if (isFillStroke && (0, $c453016f40eca611$export$41a28f5a000a9d0f)(val)) $496d053c37728dad$export$faed90dbedc3b6d5(el, attrs, key, scope);
        else attrs[key] = val;
        if (isFillStroke && scope.ssr && val === 'none') attrs['pointer-events'] = 'visible';
    }, style, el, false);
    $496d053c37728dad$var$setShadow(el, attrs, scope);
}
function $496d053c37728dad$var$setMetaData(attrs, el) {
    var metaData = (0, $a6ecc7edacba791e$export$dd7015a5412ca583)(el);
    if (metaData) {
        metaData.each(function(val, key) {
            val != null && (attrs[((0, $c1d313cff8511f25$export$d3f79611f155197c) + key).toLowerCase()] = val + '');
        });
        if (el.isSilent()) attrs[(0, $c1d313cff8511f25$export$d3f79611f155197c) + 'silent'] = 'true';
    }
}
function $496d053c37728dad$var$noRotateScale(m) {
    return (0, $c453016f40eca611$export$4701367f5b4de464)(m[0] - 1) && (0, $c453016f40eca611$export$4701367f5b4de464)(m[1]) && (0, $c453016f40eca611$export$4701367f5b4de464)(m[2]) && (0, $c453016f40eca611$export$4701367f5b4de464)(m[3] - 1);
}
function $496d053c37728dad$var$noTranslate(m) {
    return (0, $c453016f40eca611$export$4701367f5b4de464)(m[4]) && (0, $c453016f40eca611$export$4701367f5b4de464)(m[5]);
}
function $496d053c37728dad$var$setTransform(attrs, m, compress) {
    if (m && !($496d053c37728dad$var$noTranslate(m) && $496d053c37728dad$var$noRotateScale(m))) {
        var mul = compress ? 10 : 1e4;
        attrs.transform = $496d053c37728dad$var$noRotateScale(m) ? "translate(" + $496d053c37728dad$var$round(m[4] * mul) / mul + " " + $496d053c37728dad$var$round(m[5] * mul) / mul + ")" : (0, $c453016f40eca611$export$f29a4456cf56ff21)(m);
    }
}
function $496d053c37728dad$var$convertPolyShape(shape, attrs, mul) {
    var points = shape.points;
    var strArr = [];
    for(var i = 0; i < points.length; i++){
        strArr.push($496d053c37728dad$var$round(points[i][0] * mul) / mul);
        strArr.push($496d053c37728dad$var$round(points[i][1] * mul) / mul);
    }
    attrs.points = strArr.join(' ');
}
function $496d053c37728dad$var$validatePolyShape(shape) {
    return !shape.smooth;
}
function $496d053c37728dad$var$createAttrsConvert(desc) {
    var normalizedDesc = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(desc, function(item) {
        return typeof item === 'string' ? [
            item,
            item
        ] : item;
    });
    return function(shape, attrs, mul) {
        for(var i = 0; i < normalizedDesc.length; i++){
            var item = normalizedDesc[i];
            var val = shape[item[0]];
            if (val != null) attrs[item[1]] = $496d053c37728dad$var$round(val * mul) / mul;
        }
    };
}
var $496d053c37728dad$var$builtinShapesDef = {
    circle: [
        $496d053c37728dad$var$createAttrsConvert([
            'cx',
            'cy',
            'r'
        ])
    ],
    polyline: [
        $496d053c37728dad$var$convertPolyShape,
        $496d053c37728dad$var$validatePolyShape
    ],
    polygon: [
        $496d053c37728dad$var$convertPolyShape,
        $496d053c37728dad$var$validatePolyShape
    ]
};
function $496d053c37728dad$var$hasShapeAnimation(el) {
    var animators = el.animators;
    for(var i = 0; i < animators.length; i++){
        if (animators[i].targetName === 'shape') return true;
    }
    return false;
}
function $496d053c37728dad$export$1dc017d31b76c55b(el, scope) {
    var style = el.style;
    var shape = el.shape;
    var builtinShpDef = $496d053c37728dad$var$builtinShapesDef[el.type];
    var attrs = {};
    var needsAnimate = scope.animation;
    var svgElType = 'path';
    var strokePercent = el.style.strokePercent;
    var precision = scope.compress && (0, $c453016f40eca611$export$93fa1ae8a509371c)(el) || 4;
    if (builtinShpDef && !scope.willUpdate && !(builtinShpDef[1] && !builtinShpDef[1](shape)) && !(needsAnimate && $496d053c37728dad$var$hasShapeAnimation(el)) && !(strokePercent < 1)) {
        svgElType = el.type;
        var mul = Math.pow(10, precision);
        builtinShpDef[0](shape, attrs, mul);
    } else {
        var needBuildPath = !el.path || el.shapeChanged();
        if (!el.path) el.createPathProxy();
        var path = el.path;
        if (needBuildPath) {
            path.beginPath();
            el.buildPath(path, el.shape);
            el.pathUpdated();
        }
        var pathVersion = path.getVersion();
        var elExt = el;
        var svgPathBuilder = elExt.__svgPathBuilder;
        if (elExt.__svgPathVersion !== pathVersion || !svgPathBuilder || strokePercent !== elExt.__svgPathStrokePercent) {
            if (!svgPathBuilder) svgPathBuilder = elExt.__svgPathBuilder = new (0, $7cf1288ed6dc4172$export$2e2bcd8739ae039)();
            svgPathBuilder.reset(precision);
            path.rebuildPath(svgPathBuilder, strokePercent);
            svgPathBuilder.generateStr();
            elExt.__svgPathVersion = pathVersion;
            elExt.__svgPathStrokePercent = strokePercent;
        }
        attrs.d = svgPathBuilder.getStr();
    }
    $496d053c37728dad$var$setTransform(attrs, el.transform);
    $496d053c37728dad$var$setStyleAttrs(attrs, style, el, scope);
    $496d053c37728dad$var$setMetaData(attrs, el);
    scope.animation && (0, $b2c1901c47c8f594$export$dc9722e37397d426)(el, attrs, scope);
    scope.emphasis && (0, $0d0cb11dd1a647ef$export$b4c8f742d3cb22ba)(el, attrs, scope);
    return (0, $c1d313cff8511f25$export$bf5c4cf060303d58)(svgElType, el.id + '', attrs);
}
function $496d053c37728dad$export$a35ef46dc8240635(el, scope) {
    var style = el.style;
    var image = style.image;
    if (image && !(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(image)) {
        if ($496d053c37728dad$var$isImageLike(image)) image = image.src;
        else if ($496d053c37728dad$var$isCanvasLike(image)) image = image.toDataURL();
    }
    if (!image) return;
    var x = style.x || 0;
    var y = style.y || 0;
    var dw = style.width;
    var dh = style.height;
    var attrs = {
        href: image,
        width: dw,
        height: dh
    };
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $496d053c37728dad$var$setTransform(attrs, el.transform);
    $496d053c37728dad$var$setStyleAttrs(attrs, style, el, scope);
    $496d053c37728dad$var$setMetaData(attrs, el);
    scope.animation && (0, $b2c1901c47c8f594$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('image', el.id + '', attrs);
}
function $496d053c37728dad$export$d506f5385e62a84a(el, scope) {
    var style = el.style;
    var text = style.text;
    text != null && (text += '');
    if (!text || isNaN(style.x) || isNaN(style.y)) return;
    var font = style.font || (0, $024b63ea846a8ccd$export$7d7a232b6d2cc80c);
    var x = style.x || 0;
    var y = (0, $c453016f40eca611$export$bf7d6802d2badd9)(style.y || 0, (0, $297531217517fbce$export$56204a27a2958a55)(font), style.textBaseline);
    var textAlign = (0, $c453016f40eca611$export$4062150f0600d971)[style.textAlign] || style.textAlign;
    var attrs = {
        'dominant-baseline': 'central',
        'text-anchor': textAlign
    };
    if ((0, $76f8f1d5b5bbe4fc$export$4685c95d5118e76a)(style)) {
        var separatedFontStr = '';
        var fontStyle = style.fontStyle;
        var fontSize = (0, $76f8f1d5b5bbe4fc$export$51b066d9cfc2578e)(style.fontSize);
        if (!parseFloat(fontSize)) return;
        var fontFamily = style.fontFamily || (0, $024b63ea846a8ccd$export$2653e0d5dd45b294);
        var fontWeight = style.fontWeight;
        separatedFontStr += "font-size:" + fontSize + ";font-family:" + fontFamily + ";";
        if (fontStyle && fontStyle !== 'normal') separatedFontStr += "font-style:" + fontStyle + ";";
        if (fontWeight && fontWeight !== 'normal') separatedFontStr += "font-weight:" + fontWeight + ";";
        attrs.style = separatedFontStr;
    } else attrs.style = "font: " + font;
    if (text.match(/\s/)) attrs['xml:space'] = 'preserve';
    if (x) attrs.x = x;
    if (y) attrs.y = y;
    $496d053c37728dad$var$setTransform(attrs, el.transform);
    $496d053c37728dad$var$setStyleAttrs(attrs, style, el, scope);
    $496d053c37728dad$var$setMetaData(attrs, el);
    scope.animation && (0, $b2c1901c47c8f594$export$dc9722e37397d426)(el, attrs, scope);
    return (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('text', el.id + '', attrs, undefined, text);
}
function $496d053c37728dad$export$da5d6544e8c27bc1(el, scope) {
    if (el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039)) return $496d053c37728dad$export$1dc017d31b76c55b(el, scope);
    else if (el instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) return $496d053c37728dad$export$a35ef46dc8240635(el, scope);
    else if (el instanceof (0, $d14badf4d84ba4b7$export$2e2bcd8739ae039)) return $496d053c37728dad$export$d506f5385e62a84a(el, scope);
}
function $496d053c37728dad$var$setShadow(el, attrs, scope) {
    var style = el.style;
    if ((0, $c453016f40eca611$export$c62076b3a966c94b)(style)) {
        var shadowKey = (0, $c453016f40eca611$export$9e4c657be710688a)(el);
        var shadowCache = scope.shadowCache;
        var shadowId = shadowCache[shadowKey];
        if (!shadowId) {
            var globalScale = el.getGlobalScale();
            var scaleX = globalScale[0];
            var scaleY = globalScale[1];
            if (!scaleX || !scaleY) return;
            var offsetX = style.shadowOffsetX || 0;
            var offsetY = style.shadowOffsetY || 0;
            var blur_1 = style.shadowBlur;
            var _a = (0, $c453016f40eca611$export$4cde5df63f53f473)(style.shadowColor), opacity = _a.opacity, color = _a.color;
            var stdDx = blur_1 / 2 / scaleX;
            var stdDy = blur_1 / 2 / scaleY;
            var stdDeviation = stdDx + ' ' + stdDy;
            shadowId = scope.zrId + '-s' + scope.shadowIdx++;
            scope.defs[shadowId] = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('filter', shadowId, {
                'id': shadowId,
                'x': '-100%',
                'y': '-100%',
                'width': '300%',
                'height': '300%'
            }, [
                (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('feDropShadow', '', {
                    'dx': offsetX / scaleX,
                    'dy': offsetY / scaleY,
                    'stdDeviation': stdDeviation,
                    'flood-color': color,
                    'flood-opacity': opacity
                })
            ]);
            shadowCache[shadowKey] = shadowId;
        }
        attrs.filter = (0, $c453016f40eca611$export$bb094196179998a5)(shadowId);
    }
}
function $496d053c37728dad$export$afaa8352c6a43a44(style, attrs, target, scope) {
    var val = style[target];
    var gradientTag;
    var gradientAttrs = {
        'gradientUnits': val.global ? 'userSpaceOnUse' : 'objectBoundingBox'
    };
    if ((0, $c453016f40eca611$export$7d961bca9d3b47d0)(val)) {
        gradientTag = 'linearGradient';
        gradientAttrs.x1 = val.x;
        gradientAttrs.y1 = val.y;
        gradientAttrs.x2 = val.x2;
        gradientAttrs.y2 = val.y2;
    } else if ((0, $c453016f40eca611$export$2a9cca6692a0ce3a)(val)) {
        gradientTag = 'radialGradient';
        gradientAttrs.cx = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(val.x, 0.5);
        gradientAttrs.cy = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(val.y, 0.5);
        gradientAttrs.r = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(val.r, 0.5);
    } else return;
    var colors = val.colorStops;
    var colorStops = [];
    for(var i = 0, len = colors.length; i < len; ++i){
        var offset = (0, $c453016f40eca611$export$52bfc6d3e2ff0fc2)(colors[i].offset) * 100 + '%';
        var stopColor = colors[i].color;
        var _a = (0, $c453016f40eca611$export$4cde5df63f53f473)(stopColor), color = _a.color, opacity = _a.opacity;
        var stopsAttrs = {
            'offset': offset
        };
        stopsAttrs['stop-color'] = color;
        if (opacity < 1) stopsAttrs['stop-opacity'] = opacity;
        colorStops.push((0, $c1d313cff8511f25$export$bf5c4cf060303d58)('stop', i + '', stopsAttrs));
    }
    var gradientVNode = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)(gradientTag, '', gradientAttrs, colorStops);
    var gradientKey = (0, $c1d313cff8511f25$export$f5c4a9a0e027f2b)(gradientVNode);
    var gradientCache = scope.gradientCache;
    var gradientId = gradientCache[gradientKey];
    if (!gradientId) {
        gradientId = scope.zrId + '-g' + scope.gradientIdx++;
        gradientCache[gradientKey] = gradientId;
        gradientAttrs.id = gradientId;
        scope.defs[gradientId] = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)(gradientTag, gradientId, gradientAttrs, colorStops);
    }
    attrs[target] = (0, $c453016f40eca611$export$bb094196179998a5)(gradientId);
}
function $496d053c37728dad$export$faed90dbedc3b6d5(el, attrs, target, scope) {
    var val = el.style[target];
    var boundingRect = el.getBoundingRect();
    var patternAttrs = {};
    var repeat = val.repeat;
    var noRepeat = repeat === 'no-repeat';
    var repeatX = repeat === 'repeat-x';
    var repeatY = repeat === 'repeat-y';
    var child;
    if ((0, $c453016f40eca611$export$2ade673ac4f85dfe)(val)) {
        var imageWidth_1 = val.imageWidth;
        var imageHeight_1 = val.imageHeight;
        var imageSrc = void 0;
        var patternImage = val.image;
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(patternImage)) imageSrc = patternImage;
        else if ($496d053c37728dad$var$isImageLike(patternImage)) imageSrc = patternImage.src;
        else if ($496d053c37728dad$var$isCanvasLike(patternImage)) imageSrc = patternImage.toDataURL();
        if (typeof Image === 'undefined') {
            var errMsg = 'Image width/height must been given explictly in svg-ssr renderer.';
            (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(imageWidth_1, errMsg);
            (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(imageHeight_1, errMsg);
        } else if (imageWidth_1 == null || imageHeight_1 == null) {
            var setSizeToVNode_1 = function(vNode, img) {
                if (vNode) {
                    var svgEl = vNode.elm;
                    var width = imageWidth_1 || img.width;
                    var height = imageHeight_1 || img.height;
                    if (vNode.tag === 'pattern') {
                        if (repeatX) {
                            height = 1;
                            width /= boundingRect.width;
                        } else if (repeatY) {
                            width = 1;
                            height /= boundingRect.height;
                        }
                    }
                    vNode.attrs.width = width;
                    vNode.attrs.height = height;
                    if (svgEl) {
                        svgEl.setAttribute('width', width);
                        svgEl.setAttribute('height', height);
                    }
                }
            };
            var createdImage = (0, $d03a6f18dabd43b1$export$46c791b69ff9a0f)(imageSrc, null, el, function(img) {
                noRepeat || setSizeToVNode_1(patternVNode, img);
                setSizeToVNode_1(child, img);
            });
            if (createdImage && createdImage.width && createdImage.height) {
                imageWidth_1 = imageWidth_1 || createdImage.width;
                imageHeight_1 = imageHeight_1 || createdImage.height;
            }
        }
        child = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('image', 'img', {
            href: imageSrc,
            width: imageWidth_1,
            height: imageHeight_1
        });
        patternAttrs.width = imageWidth_1;
        patternAttrs.height = imageHeight_1;
    } else if (val.svgElement) {
        child = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(val.svgElement);
        patternAttrs.width = val.svgWidth;
        patternAttrs.height = val.svgHeight;
    }
    if (!child) return;
    var patternWidth;
    var patternHeight;
    if (noRepeat) patternWidth = patternHeight = 1;
    else if (repeatX) {
        patternHeight = 1;
        patternWidth = patternAttrs.width / boundingRect.width;
    } else if (repeatY) {
        patternWidth = 1;
        patternHeight = patternAttrs.height / boundingRect.height;
    } else patternAttrs.patternUnits = 'userSpaceOnUse';
    if (patternWidth != null && !isNaN(patternWidth)) patternAttrs.width = patternWidth;
    if (patternHeight != null && !isNaN(patternHeight)) patternAttrs.height = patternHeight;
    var patternTransform = (0, $c453016f40eca611$export$3fe07c0888ff6164)(val);
    patternTransform && (patternAttrs.patternTransform = patternTransform);
    var patternVNode = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('pattern', '', patternAttrs, [
        child
    ]);
    var patternKey = (0, $c1d313cff8511f25$export$f5c4a9a0e027f2b)(patternVNode);
    var patternCache = scope.patternCache;
    var patternId = patternCache[patternKey];
    if (!patternId) {
        patternId = scope.zrId + '-p' + scope.patternIdx++;
        patternCache[patternKey] = patternId;
        patternAttrs.id = patternId;
        patternVNode = scope.defs[patternId] = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('pattern', patternId, patternAttrs, [
            child
        ]);
    }
    attrs[target] = (0, $c453016f40eca611$export$bb094196179998a5)(patternId);
}
function $496d053c37728dad$export$8f1d80b445d4fc(clipPath, attrs, scope) {
    var clipPathCache = scope.clipPathCache, defs = scope.defs;
    var clipPathId = clipPathCache[clipPath.id];
    if (!clipPathId) {
        clipPathId = scope.zrId + '-c' + scope.clipPathIdx++;
        var clipPathAttrs = {
            id: clipPathId
        };
        clipPathCache[clipPath.id] = clipPathId;
        defs[clipPathId] = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('clipPath', clipPathId, clipPathAttrs, [
            $496d053c37728dad$export$1dc017d31b76c55b(clipPath, scope)
        ]);
    }
    attrs['clip-path'] = (0, $c453016f40eca611$export$bb094196179998a5)(clipPathId);
}







function $7c07c7d1b2ed5cac$export$b2ce9ad90858ed7a(text) {
    return document.createTextNode(text);
}
function $7c07c7d1b2ed5cac$export$2a15b079e3f46654(text) {
    return document.createComment(text);
}
function $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $7c07c7d1b2ed5cac$export$7ae609f7af59e4f7(node, child) {
    node.removeChild(child);
}
function $7c07c7d1b2ed5cac$export$1b8e57c9ea42f1d2(node, child) {
    node.appendChild(child);
}
function $7c07c7d1b2ed5cac$export$b54be7ce267a037b(node) {
    return node.parentNode;
}
function $7c07c7d1b2ed5cac$export$335219007e689d29(node) {
    return node.nextSibling;
}
function $7c07c7d1b2ed5cac$export$45e0b80f1e500bd4(elm) {
    return elm.tagName;
}
function $7c07c7d1b2ed5cac$export$94b0296cab6203e(node, text) {
    node.textContent = text;
}
function $7c07c7d1b2ed5cac$export$132e79e4118a78e0(node) {
    return node.textContent;
}
function $7c07c7d1b2ed5cac$export$45a5e7f76e0caa8d(node) {
    return node.nodeType === 1;
}
function $7c07c7d1b2ed5cac$export$1879817ac5c922b7(node) {
    return node.nodeType === 3;
}
function $7c07c7d1b2ed5cac$export$3ab01370f5e64ac8(node) {
    return node.nodeType === 8;
}


var $5c801839a8b54d89$var$colonChar = 58;
var $5c801839a8b54d89$var$xChar = 120;
var $5c801839a8b54d89$var$emptyNode = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('', '');
function $5c801839a8b54d89$var$isUndef(s) {
    return s === undefined;
}
function $5c801839a8b54d89$var$isDef(s) {
    return s !== undefined;
}
function $5c801839a8b54d89$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var map = {};
    for(var i = beginIdx; i <= endIdx; ++i){
        var key = children[i].key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
function $5c801839a8b54d89$var$sameVnode(vnode1, vnode2) {
    var isSameKey = vnode1.key === vnode2.key;
    var isSameTag = vnode1.tag === vnode2.tag;
    return isSameTag && isSameKey;
}
function $5c801839a8b54d89$var$createElm(vnode) {
    var i;
    var children = vnode.children;
    var tag = vnode.tag;
    if ($5c801839a8b54d89$var$isDef(tag)) {
        var elm = vnode.elm = (0, $c1d313cff8511f25$export$c8a8987d4410bf2d)(tag);
        $5c801839a8b54d89$export$277dcc6f06048f24($5c801839a8b54d89$var$emptyNode, vnode);
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(children)) for(i = 0; i < children.length; ++i){
            var ch = children[i];
            if (ch != null) $7c07c7d1b2ed5cac$export$1b8e57c9ea42f1d2(elm, $5c801839a8b54d89$var$createElm(ch));
        }
        else if ($5c801839a8b54d89$var$isDef(vnode.text) && !(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(vnode.text)) $7c07c7d1b2ed5cac$export$1b8e57c9ea42f1d2(elm, $7c07c7d1b2ed5cac$export$b2ce9ad90858ed7a(vnode.text));
    } else vnode.elm = $7c07c7d1b2ed5cac$export$b2ce9ad90858ed7a(vnode.text);
    return vnode.elm;
}
function $5c801839a8b54d89$var$addVnodes(parentElm, before, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parentElm, $5c801839a8b54d89$var$createElm(ch), before);
    }
}
function $5c801839a8b54d89$var$removeVnodes(parentElm, vnodes, startIdx, endIdx) {
    for(; startIdx <= endIdx; ++startIdx){
        var ch = vnodes[startIdx];
        if (ch != null) {
            if ($5c801839a8b54d89$var$isDef(ch.tag)) {
                var parent_1 = $7c07c7d1b2ed5cac$export$b54be7ce267a037b(ch.elm);
                $7c07c7d1b2ed5cac$export$7ae609f7af59e4f7(parent_1, ch.elm);
            } else $7c07c7d1b2ed5cac$export$7ae609f7af59e4f7(parentElm, ch.elm);
        }
    }
}
function $5c801839a8b54d89$export$277dcc6f06048f24(oldVnode, vnode) {
    var key;
    var elm = vnode.elm;
    var oldAttrs = oldVnode && oldVnode.attrs || {};
    var attrs = vnode.attrs || {};
    if (oldAttrs === attrs) return;
    for(key in attrs){
        var cur = attrs[key];
        var old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, '');
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key === 'style') elm.style.cssText = cur;
                else if (key.charCodeAt(0) !== $5c801839a8b54d89$var$xChar) elm.setAttribute(key, cur);
                else if (key === 'xmlns:xlink' || key === 'xmlns') elm.setAttributeNS((0, $c1d313cff8511f25$export$fac09d762d15fa3b), key, cur);
                else if (key.charCodeAt(3) === $5c801839a8b54d89$var$colonChar) elm.setAttributeNS((0, $c1d313cff8511f25$export$ad4c4fdecd3b4156), key, cur);
                else if (key.charCodeAt(5) === $5c801839a8b54d89$var$colonChar) elm.setAttributeNS((0, $c1d313cff8511f25$export$b22c6da1792ecec8), key, cur);
                else elm.setAttribute(key, cur);
            }
        }
    }
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
function $5c801839a8b54d89$var$updateChildren(parentElm, oldCh, newCh) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx;
    var idxInOld;
    var elmToMove;
    var before;
    while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
        if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx];
        else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
        else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
        else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
        else if ($5c801839a8b54d89$var$sameVnode(oldStartVnode, newStartVnode)) {
            $5c801839a8b54d89$var$patchVnode(oldStartVnode, newStartVnode);
            oldStartVnode = oldCh[++oldStartIdx];
            newStartVnode = newCh[++newStartIdx];
        } else if ($5c801839a8b54d89$var$sameVnode(oldEndVnode, newEndVnode)) {
            $5c801839a8b54d89$var$patchVnode(oldEndVnode, newEndVnode);
            oldEndVnode = oldCh[--oldEndIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($5c801839a8b54d89$var$sameVnode(oldStartVnode, newEndVnode)) {
            $5c801839a8b54d89$var$patchVnode(oldStartVnode, newEndVnode);
            $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parentElm, oldStartVnode.elm, $7c07c7d1b2ed5cac$export$335219007e689d29(oldEndVnode.elm));
            oldStartVnode = oldCh[++oldStartIdx];
            newEndVnode = newCh[--newEndIdx];
        } else if ($5c801839a8b54d89$var$sameVnode(oldEndVnode, newStartVnode)) {
            $5c801839a8b54d89$var$patchVnode(oldEndVnode, newStartVnode);
            $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parentElm, oldEndVnode.elm, oldStartVnode.elm);
            oldEndVnode = oldCh[--oldEndIdx];
            newStartVnode = newCh[++newStartIdx];
        } else {
            if ($5c801839a8b54d89$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $5c801839a8b54d89$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
            idxInOld = oldKeyToIdx[newStartVnode.key];
            if ($5c801839a8b54d89$var$isUndef(idxInOld)) $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parentElm, $5c801839a8b54d89$var$createElm(newStartVnode), oldStartVnode.elm);
            else {
                elmToMove = oldCh[idxInOld];
                if (elmToMove.tag !== newStartVnode.tag) $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parentElm, $5c801839a8b54d89$var$createElm(newStartVnode), oldStartVnode.elm);
                else {
                    $5c801839a8b54d89$var$patchVnode(elmToMove, newStartVnode);
                    oldCh[idxInOld] = undefined;
                    $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parentElm, elmToMove.elm, oldStartVnode.elm);
                }
            }
            newStartVnode = newCh[++newStartIdx];
        }
    }
    if (oldStartIdx <= oldEndIdx || newStartIdx <= newEndIdx) {
        if (oldStartIdx > oldEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            $5c801839a8b54d89$var$addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx);
        } else $5c801839a8b54d89$var$removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
}
function $5c801839a8b54d89$var$patchVnode(oldVnode, vnode) {
    var elm = vnode.elm = oldVnode.elm;
    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (oldVnode === vnode) return;
    $5c801839a8b54d89$export$277dcc6f06048f24(oldVnode, vnode);
    if ($5c801839a8b54d89$var$isUndef(vnode.text)) {
        if ($5c801839a8b54d89$var$isDef(oldCh) && $5c801839a8b54d89$var$isDef(ch)) {
            if (oldCh !== ch) $5c801839a8b54d89$var$updateChildren(elm, oldCh, ch);
        } else if ($5c801839a8b54d89$var$isDef(ch)) {
            if ($5c801839a8b54d89$var$isDef(oldVnode.text)) $7c07c7d1b2ed5cac$export$94b0296cab6203e(elm, '');
            $5c801839a8b54d89$var$addVnodes(elm, null, ch, 0, ch.length - 1);
        } else if ($5c801839a8b54d89$var$isDef(oldCh)) $5c801839a8b54d89$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        else if ($5c801839a8b54d89$var$isDef(oldVnode.text)) $7c07c7d1b2ed5cac$export$94b0296cab6203e(elm, '');
    } else if (oldVnode.text !== vnode.text) {
        if ($5c801839a8b54d89$var$isDef(oldCh)) $5c801839a8b54d89$var$removeVnodes(elm, oldCh, 0, oldCh.length - 1);
        $7c07c7d1b2ed5cac$export$94b0296cab6203e(elm, vnode.text);
    }
}
function $5c801839a8b54d89$export$2e2bcd8739ae039(oldVnode, vnode) {
    if ($5c801839a8b54d89$var$sameVnode(oldVnode, vnode)) $5c801839a8b54d89$var$patchVnode(oldVnode, vnode);
    else {
        var elm = oldVnode.elm;
        var parent_2 = $7c07c7d1b2ed5cac$export$b54be7ce267a037b(elm);
        $5c801839a8b54d89$var$createElm(vnode);
        if (parent_2 !== null) {
            $7c07c7d1b2ed5cac$export$86b68c7dbeb53c22(parent_2, vnode.elm, $7c07c7d1b2ed5cac$export$335219007e689d29(elm));
            $5c801839a8b54d89$var$removeVnodes(parent_2, [
                oldVnode
            ], 0, 0);
        }
    }
    return vnode;
}



var $66736ddc15a82100$var$svgId = 0;
var $66736ddc15a82100$var$SVGPainter = function() {
    function SVGPainter(root, storage, opts) {
        this.type = 'svg';
        this.refreshHover = $66736ddc15a82100$var$createMethodNotSupport('refreshHover');
        this.configLayer = $66736ddc15a82100$var$createMethodNotSupport('configLayer');
        this.storage = storage;
        this._opts = opts = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, opts);
        this.root = root;
        this._id = 'zr' + $66736ddc15a82100$var$svgId++;
        this._oldVNode = (0, $c1d313cff8511f25$export$5529a6aad332ee75)(opts.width, opts.height);
        if (root && !opts.ssr) {
            var viewport = this._viewport = document.createElement('div');
            viewport.style.cssText = 'position:relative;overflow:hidden';
            var svgDom = this._svgDom = this._oldVNode.elm = (0, $c1d313cff8511f25$export$c8a8987d4410bf2d)('svg');
            (0, $5c801839a8b54d89$export$277dcc6f06048f24)(null, this._oldVNode);
            viewport.appendChild(svgDom);
            root.appendChild(viewport);
        }
        this.resize(opts.width, opts.height);
    }
    SVGPainter.prototype.getType = function() {
        return this.type;
    };
    SVGPainter.prototype.getViewportRoot = function() {
        return this._viewport;
    };
    SVGPainter.prototype.getViewportRootOffset = function() {
        var viewportRoot = this.getViewportRoot();
        if (viewportRoot) return {
            offsetLeft: viewportRoot.offsetLeft || 0,
            offsetTop: viewportRoot.offsetTop || 0
        };
    };
    SVGPainter.prototype.getSvgDom = function() {
        return this._svgDom;
    };
    SVGPainter.prototype.refresh = function() {
        if (this.root) {
            var vnode = this.renderToVNode({
                willUpdate: true
            });
            vnode.attrs.style = 'position:absolute;left:0;top:0;user-select:none';
            (0, $5c801839a8b54d89$export$2e2bcd8739ae039)(this._oldVNode, vnode);
            this._oldVNode = vnode;
        }
    };
    SVGPainter.prototype.renderOneToVNode = function(el) {
        return (0, $496d053c37728dad$export$da5d6544e8c27bc1)(el, (0, $c1d313cff8511f25$export$96fee5f38ed01741)(this._id));
    };
    SVGPainter.prototype.renderToVNode = function(opts) {
        opts = opts || {};
        var list = this.storage.getDisplayList(true);
        var width = this._width;
        var height = this._height;
        var scope = (0, $c1d313cff8511f25$export$96fee5f38ed01741)(this._id);
        scope.animation = opts.animation;
        scope.willUpdate = opts.willUpdate;
        scope.compress = opts.compress;
        scope.emphasis = opts.emphasis;
        scope.ssr = this._opts.ssr;
        var children = [];
        var bgVNode = this._bgVNode = $66736ddc15a82100$var$createBackgroundVNode(width, height, this._backgroundColor, scope);
        bgVNode && children.push(bgVNode);
        var mainVNode = !opts.compress ? this._mainVNode = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('g', 'main', {}, []) : null;
        this._paintList(list, scope, mainVNode ? mainVNode.children : children);
        mainVNode && children.push(mainVNode);
        var defs = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(scope.defs), function(id) {
            return scope.defs[id];
        });
        if (defs.length) children.push((0, $c1d313cff8511f25$export$bf5c4cf060303d58)('defs', 'defs', {}, defs));
        if (opts.animation) {
            var animationCssStr = (0, $c1d313cff8511f25$export$e2b4f3597c7a7dcb)(scope.cssNodes, scope.cssAnims, {
                newline: true
            });
            if (animationCssStr) {
                var styleNode = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('style', 'stl', {}, [], animationCssStr);
                children.push(styleNode);
            }
        }
        return (0, $c1d313cff8511f25$export$5529a6aad332ee75)(width, height, children, opts.useViewBox);
    };
    SVGPainter.prototype.renderToString = function(opts) {
        opts = opts || {};
        return (0, $c1d313cff8511f25$export$f5c4a9a0e027f2b)(this.renderToVNode({
            animation: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(opts.cssAnimation, true),
            emphasis: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(opts.cssEmphasis, true),
            willUpdate: false,
            compress: true,
            useViewBox: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(opts.useViewBox, true)
        }), {
            newline: true
        });
    };
    SVGPainter.prototype.setBackgroundColor = function(backgroundColor) {
        this._backgroundColor = backgroundColor;
    };
    SVGPainter.prototype.getSvgRoot = function() {
        return this._mainVNode && this._mainVNode.elm;
    };
    SVGPainter.prototype._paintList = function(list, scope, out) {
        var listLen = list.length;
        var clipPathsGroupsStack = [];
        var clipPathsGroupsStackDepth = 0;
        var currentClipPathGroup;
        var prevClipPaths;
        var clipGroupNodeIdx = 0;
        for(var i = 0; i < listLen; i++){
            var displayable = list[i];
            if (!displayable.invisible) {
                var clipPaths = displayable.__clipPaths;
                var len = clipPaths && clipPaths.length || 0;
                var prevLen = prevClipPaths && prevClipPaths.length || 0;
                var lca = void 0;
                for(lca = Math.max(len - 1, prevLen - 1); lca >= 0; lca--){
                    if (clipPaths && prevClipPaths && clipPaths[lca] === prevClipPaths[lca]) break;
                }
                for(var i_1 = prevLen - 1; i_1 > lca; i_1--){
                    clipPathsGroupsStackDepth--;
                    currentClipPathGroup = clipPathsGroupsStack[clipPathsGroupsStackDepth - 1];
                }
                for(var i_2 = lca + 1; i_2 < len; i_2++){
                    var groupAttrs = {};
                    (0, $496d053c37728dad$export$8f1d80b445d4fc)(clipPaths[i_2], groupAttrs, scope);
                    var g = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('g', 'clip-g-' + clipGroupNodeIdx++, groupAttrs, []);
                    (currentClipPathGroup ? currentClipPathGroup.children : out).push(g);
                    clipPathsGroupsStack[clipPathsGroupsStackDepth++] = g;
                    currentClipPathGroup = g;
                }
                prevClipPaths = clipPaths;
                var ret = (0, $496d053c37728dad$export$da5d6544e8c27bc1)(displayable, scope);
                if (ret) (currentClipPathGroup ? currentClipPathGroup.children : out).push(ret);
            }
        }
    };
    SVGPainter.prototype.resize = function(width, height) {
        var opts = this._opts;
        var root = this.root;
        var viewport = this._viewport;
        width != null && (opts.width = width);
        height != null && (opts.height = height);
        if (root && viewport) {
            viewport.style.display = 'none';
            width = (0, $9b483e37735cf979$export$31b21d0167753bb4)(root, 0, opts);
            height = (0, $9b483e37735cf979$export$31b21d0167753bb4)(root, 1, opts);
            viewport.style.display = '';
        }
        if (this._width !== width || this._height !== height) {
            this._width = width;
            this._height = height;
            if (viewport) {
                var viewportStyle = viewport.style;
                viewportStyle.width = width + 'px';
                viewportStyle.height = height + 'px';
            }
            if (!(0, $c453016f40eca611$export$41a28f5a000a9d0f)(this._backgroundColor)) {
                var svgDom = this._svgDom;
                if (svgDom) {
                    svgDom.setAttribute('width', width);
                    svgDom.setAttribute('height', height);
                }
                var bgEl = this._bgVNode && this._bgVNode.elm;
                if (bgEl) {
                    bgEl.setAttribute('width', width);
                    bgEl.setAttribute('height', height);
                }
            } else this.refresh();
        }
    };
    SVGPainter.prototype.getWidth = function() {
        return this._width;
    };
    SVGPainter.prototype.getHeight = function() {
        return this._height;
    };
    SVGPainter.prototype.dispose = function() {
        if (this.root) this.root.innerHTML = '';
        this._svgDom = this._viewport = this.storage = this._oldVNode = this._bgVNode = this._mainVNode = null;
    };
    SVGPainter.prototype.clear = function() {
        if (this._svgDom) this._svgDom.innerHTML = null;
        this._oldVNode = null;
    };
    SVGPainter.prototype.toDataURL = function(base64) {
        var str = this.renderToString();
        var prefix = 'data:image/svg+xml;';
        if (base64) {
            str = (0, $c453016f40eca611$export$8fb536984ec8b4d7)(str);
            return str && prefix + 'base64,' + str;
        }
        return prefix + 'charset=UTF-8,' + encodeURIComponent(str);
    };
    return SVGPainter;
}();
function $66736ddc15a82100$var$createMethodNotSupport(method) {
    return function() {};
}
function $66736ddc15a82100$var$createBackgroundVNode(width, height, backgroundColor, scope) {
    var bgVNode;
    if (backgroundColor && backgroundColor !== 'none') {
        bgVNode = (0, $c1d313cff8511f25$export$bf5c4cf060303d58)('rect', 'bg', {
            width: width,
            height: height,
            x: '0',
            y: '0'
        });
        if ((0, $c453016f40eca611$export$545e02bbd5f8fe95)(backgroundColor)) (0, $496d053c37728dad$export$afaa8352c6a43a44)({
            fill: backgroundColor
        }, bgVNode.attrs, 'fill', scope);
        else if ((0, $c453016f40eca611$export$41a28f5a000a9d0f)(backgroundColor)) (0, $496d053c37728dad$export$faed90dbedc3b6d5)({
            style: {
                fill: backgroundColor
            },
            dirty: (0, $1b239fc9d3a2f8ae$export$8793edee2d425525),
            getBoundingRect: function() {
                return {
                    width: width,
                    height: height
                };
            }
        }, bgVNode.attrs, 'fill', scope);
        else {
            var _a = (0, $c453016f40eca611$export$4cde5df63f53f473)(backgroundColor), color = _a.color, opacity = _a.opacity;
            bgVNode.attrs.fill = color;
            opacity < 1 && (bgVNode.attrs['fill-opacity'] = opacity);
        }
    }
    return bgVNode;
}
var $66736ddc15a82100$export$2e2bcd8739ae039 = $66736ddc15a82100$var$SVGPainter;


function $9017ee1f0b09b5da$export$4b3e715f166fdd78(registers) {
    registers.registerPainter('svg', (0, $66736ddc15a82100$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Int32Array */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $74d9e7a7c8458183$var$dataIndexMapValueLength(valNumOrArrLengthMoreThan2) {
    return valNumOrArrLengthMoreThan2 == null ? 0 : valNumOrArrLengthMoreThan2.length || 1;
}
function $74d9e7a7c8458183$var$defaultKeyGetter(item) {
    return item;
}
var $74d9e7a7c8458183$var$DataDiffer = /** @class */ function() {
    /**
   * @param context Can be visited by this.context in callback.
   */ function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context, // By default: 'oneToOne'.
    diffMode) {
        this._old = oldArr;
        this._new = newArr;
        this._oldKeyGetter = oldKeyGetter || $74d9e7a7c8458183$var$defaultKeyGetter;
        this._newKeyGetter = newKeyGetter || $74d9e7a7c8458183$var$defaultKeyGetter;
        // Visible in callback via `this.context`;
        this.context = context;
        this._diffModeMultiple = diffMode === 'multiple';
    }
    /**
   * Callback function when add a data
   */ DataDiffer.prototype.add = function(func) {
        this._add = func;
        return this;
    };
    /**
   * Callback function when update a data
   */ DataDiffer.prototype.update = function(func) {
        this._update = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToOne = function(func) {
        this._updateManyToOne = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateOneToMany = function(func) {
        this._updateOneToMany = func;
        return this;
    };
    /**
   * Callback function when update a data and only work in `cbMode: 'byKey'`.
   */ DataDiffer.prototype.updateManyToMany = function(func) {
        this._updateManyToMany = func;
        return this;
    };
    /**
   * Callback function when remove a data
   */ DataDiffer.prototype.remove = function(func) {
        this._remove = func;
        return this;
    };
    DataDiffer.prototype.execute = function() {
        this[this._diffModeMultiple ? '_executeMultiple' : '_executeOneToOne']();
    };
    DataDiffer.prototype._executeOneToOne = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var newDataIndexMap = {};
        var oldDataKeyArr = new Array(oldArr.length);
        var newDataKeyArr = new Array(newArr.length);
        this._initIndexMap(oldArr, null, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var newIdxMapValLen = $74d9e7a7c8458183$var$dataIndexMapValueLength(newIdxMapVal);
            // idx can never be empty array here. see 'set null' logic below.
            if (newIdxMapValLen > 1) {
                // Consider there is duplicate key (for example, use dataItem.name as key).
                // We should make sure every item in newArr and oldArr can be visited.
                var newIdx = newIdxMapVal.shift();
                if (newIdxMapVal.length === 1) newDataIndexMap[oldKey] = newIdxMapVal[0];
                this._update && this._update(newIdx, i);
            } else if (newIdxMapValLen === 1) {
                newDataIndexMap[oldKey] = null;
                this._update && this._update(newIdxMapVal, i);
            } else this._remove && this._remove(i);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    /**
   * For example, consider the case:
   * oldData: [o0, o1, o2, o3, o4, o5, o6, o7],
   * newData: [n0, n1, n2, n3, n4, n5, n6, n7, n8],
   * Where:
   *     o0, o1, n0 has key 'a' (many to one)
   *     o5, n4, n5, n6 has key 'b' (one to many)
   *     o2, n1 has key 'c' (one to one)
   *     n2, n3 has key 'd' (add)
   *     o3, o4 has key 'e' (remove)
   *     o6, o7, n7, n8 has key 'f' (many to many, treated as add and remove)
   * Then:
   *     (The order of the following directives are not ensured.)
   *     this._updateManyToOne(n0, [o0, o1]);
   *     this._updateOneToMany([n4, n5, n6], o5);
   *     this._update(n1, o2);
   *     this._remove(o3);
   *     this._remove(o4);
   *     this._remove(o6);
   *     this._remove(o7);
   *     this._add(n2);
   *     this._add(n3);
   *     this._add(n7);
   *     this._add(n8);
   */ DataDiffer.prototype._executeMultiple = function() {
        var oldArr = this._old;
        var newArr = this._new;
        var oldDataIndexMap = {};
        var newDataIndexMap = {};
        var oldDataKeyArr = [];
        var newDataKeyArr = [];
        this._initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter');
        this._initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter');
        for(var i = 0; i < oldDataKeyArr.length; i++){
            var oldKey = oldDataKeyArr[i];
            var oldIdxMapVal = oldDataIndexMap[oldKey];
            var newIdxMapVal = newDataIndexMap[oldKey];
            var oldIdxMapValLen = $74d9e7a7c8458183$var$dataIndexMapValueLength(oldIdxMapVal);
            var newIdxMapValLen = $74d9e7a7c8458183$var$dataIndexMapValueLength(newIdxMapVal);
            if (oldIdxMapValLen > 1 && newIdxMapValLen === 1) {
                this._updateManyToOne && this._updateManyToOne(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen > 1) {
                this._updateOneToMany && this._updateOneToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen === 1 && newIdxMapValLen === 1) {
                this._update && this._update(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1 && newIdxMapValLen > 1) {
                this._updateManyToMany && this._updateManyToMany(newIdxMapVal, oldIdxMapVal);
                newDataIndexMap[oldKey] = null;
            } else if (oldIdxMapValLen > 1) for(var i_1 = 0; i_1 < oldIdxMapValLen; i_1++)this._remove && this._remove(oldIdxMapVal[i_1]);
            else this._remove && this._remove(oldIdxMapVal);
        }
        this._performRestAdd(newDataKeyArr, newDataIndexMap);
    };
    DataDiffer.prototype._performRestAdd = function(newDataKeyArr, newDataIndexMap) {
        for(var i = 0; i < newDataKeyArr.length; i++){
            var newKey = newDataKeyArr[i];
            var newIdxMapVal = newDataIndexMap[newKey];
            var idxMapValLen = $74d9e7a7c8458183$var$dataIndexMapValueLength(newIdxMapVal);
            if (idxMapValLen > 1) for(var j = 0; j < idxMapValLen; j++)this._add && this._add(newIdxMapVal[j]);
            else if (idxMapValLen === 1) this._add && this._add(newIdxMapVal);
            // Support both `newDataKeyArr` are duplication removed or not removed.
            newDataIndexMap[newKey] = null;
        }
    };
    DataDiffer.prototype._initIndexMap = function(arr, // Can be null.
    map, // In 'byKey', the output `keyArr` is duplication removed.
    // In 'byIndex', the output `keyArr` is not duplication removed and
    //     its indices are accurately corresponding to `arr`.
    keyArr, keyGetterName) {
        var cbModeMultiple = this._diffModeMultiple;
        for(var i = 0; i < arr.length; i++){
            // Add prefix to avoid conflict with Object.prototype.
            var key = '_ec_' + this[keyGetterName](arr[i], i);
            if (!cbModeMultiple) keyArr[i] = key;
            if (!map) continue;
            var idxMapVal = map[key];
            var idxMapValLen = $74d9e7a7c8458183$var$dataIndexMapValueLength(idxMapVal);
            if (idxMapValLen === 0) {
                // Simple optimize: in most cases, one index has one key,
                // do not need array.
                map[key] = i;
                if (cbModeMultiple) keyArr.push(key);
            } else if (idxMapValLen === 1) map[key] = [
                idxMapVal,
                i
            ];
            else idxMapVal.push(i);
        }
    };
    return DataDiffer;
}();
var $74d9e7a7c8458183$export$2e2bcd8739ae039 = $74d9e7a7c8458183$var$DataDiffer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $e1ef773174d5a33a$var$DimensionUserOuput = /** @class */ function() {
    function DimensionUserOuput(encode, dimRequest) {
        this._encode = encode;
        this._schema = dimRequest;
    }
    DimensionUserOuput.prototype.get = function() {
        return {
            // Do not generate full dimension name until fist used.
            fullDimensions: this._getFullDimensionNames(),
            encode: this._encode
        };
    };
    /**
   * Get all data store dimension names.
   * Theoretically a series data store is defined both by series and used dataset (if any).
   * If some dimensions are omitted for performance reason in `this.dimensions`,
   * the dimension name may not be auto-generated if user does not specify a dimension name.
   * In this case, the dimension name is `null`/`undefined`.
   */ DimensionUserOuput.prototype._getFullDimensionNames = function() {
        if (!this._cachedDimNames) this._cachedDimNames = this._schema ? this._schema.makeOutputDimensionNames() : [];
        return this._cachedDimNames;
    };
    return DimensionUserOuput;
}();
function $e1ef773174d5a33a$export$505a22c3734846f1(data, schema) {
    var summary = {};
    var encode = summary.encode = {};
    var notExtraCoordDimMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    var defaultedLabel = [];
    var defaultedTooltip = [];
    var userOutputEncode = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimItem = data.getDimensionInfo(dimName);
        var coordDim = dimItem.coordDim;
        if (coordDim) {
            var coordDimIndex = dimItem.coordDimIndex;
            $e1ef773174d5a33a$var$getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
            if (!dimItem.isExtraCoord) {
                notExtraCoordDimMap.set(coordDim, 1);
                // Use the last coord dim (and label friendly) as default label,
                // because when dataset is used, it is hard to guess which dimension
                // can be value dimension. If both show x, y on label is not look good,
                // and conventionally y axis is focused more.
                if ($e1ef773174d5a33a$var$mayLabelDimType(dimItem.type)) defaultedLabel[0] = dimName;
                // User output encode do not contain generated coords.
                // And it only has index. User can use index to retrieve value from the raw item array.
                $e1ef773174d5a33a$var$getOrCreateEncodeArr(userOutputEncode, coordDim)[coordDimIndex] = data.getDimensionIndex(dimItem.name);
            }
            if (dimItem.defaultTooltip) defaultedTooltip.push(dimName);
        }
        (0, $369d2fc585e5938e$export$cd51b5ca77f6f0e4).each(function(v, otherDim) {
            var encodeArr = $e1ef773174d5a33a$var$getOrCreateEncodeArr(encode, otherDim);
            var dimIndex = dimItem.otherDims[otherDim];
            if (dimIndex != null && dimIndex !== false) encodeArr[dimIndex] = dimItem.name;
        });
    });
    var dataDimsOnCoord = [];
    var encodeFirstDimNotExtra = {};
    notExtraCoordDimMap.each(function(v, coordDim) {
        var dimArr = encode[coordDim];
        encodeFirstDimNotExtra[coordDim] = dimArr[0];
        // Not necessary to remove duplicate, because a data
        // dim canot on more than one coordDim.
        dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
    });
    summary.dataDimsOnCoord = dataDimsOnCoord;
    summary.dataDimIndicesOnCoord = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(dataDimsOnCoord, function(dimName) {
        return data.getDimensionInfo(dimName).storeDimIndex;
    });
    summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
    var encodeLabel = encode.label;
    // FIXME `encode.label` is not recommended, because formatter cannot be set
    // in this way. Use label.formatter instead. Maybe remove this approach someday.
    if (encodeLabel && encodeLabel.length) defaultedLabel = encodeLabel.slice();
    var encodeTooltip = encode.tooltip;
    if (encodeTooltip && encodeTooltip.length) defaultedTooltip = encodeTooltip.slice();
    else if (!defaultedTooltip.length) defaultedTooltip = defaultedLabel.slice();
    encode.defaultedLabel = defaultedLabel;
    encode.defaultedTooltip = defaultedTooltip;
    summary.userOutput = new $e1ef773174d5a33a$var$DimensionUserOuput(userOutputEncode, schema);
    return summary;
}
function $e1ef773174d5a33a$var$getOrCreateEncodeArr(encode, dim) {
    if (!encode.hasOwnProperty(dim)) encode[dim] = [];
    return encode[dim];
}
function $e1ef773174d5a33a$export$af1622903e71278e(axisType) {
    return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
}
function $e1ef773174d5a33a$var$mayLabelDimType(dimType) {
    // In most cases, ordinal and time do not suitable for label.
    // Ordinal info can be displayed on axis. Time is too long.
    return !(dimType === 'ordinal' || dimType === 'time');
} // function findTheLastDimMayLabel(data) {
 //     // Get last value dim
 //     let dimensions = data.dimensions.slice();
 //     let valueType;
 //     let valueDim;
 //     while (dimensions.length && (
 //         valueDim = dimensions.pop(),
 //         valueType = data.getDimensionInfo(valueDim).type,
 //         valueType === 'ordinal' || valueType === 'time'
 //     )) {} // jshint ignore:line
 //     return valueDim;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $1fa5d70417e8025f$var$SeriesDimensionDefine = /** @class */ function() {
    /**
   * @param opt All of the fields will be shallow copied.
   */ function SeriesDimensionDefine(opt) {
        /**
     * The format of `otherDims` is:
     * ```js
     * {
     *     tooltip?: number
     *     label?: number
     *     itemName?: number
     *     seriesName?: number
     * }
     * ```
     *
     * A `series.encode` can specified these fields:
     * ```js
     * encode: {
     *     // "3, 1, 5" is the index of data dimension.
     *     tooltip: [3, 1, 5],
     *     label: [0, 3],
     *     ...
     * }
     * ```
     * `otherDims` is the parse result of the `series.encode` above, like:
     * ```js
     * // Suppose the index of this data dimension is `3`.
     * this.otherDims = {
     *     // `3` is at the index `0` of the `encode.tooltip`
     *     tooltip: 0,
     *     // `3` is at the index `1` of the `encode.label`
     *     label: 1
     * };
     * ```
     *
     * This prop should never be `null`/`undefined` after initialized.
     */ this.otherDims = {};
        if (opt != null) $1b239fc9d3a2f8ae$export$8b58be045bf06082(this, opt);
    }
    return SeriesDimensionDefine;
}();
var $1fa5d70417e8025f$export$2e2bcd8739ae039 = $1fa5d70417e8025f$var$SeriesDimensionDefine;







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $8233286fea22402d$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $8233286fea22402d$var$dimTypeShort = {
    float: 'f',
    int: 'i',
    ordinal: 'o',
    number: 'n',
    time: 't'
};
/**
 * Represents the dimension requirement of a series.
 *
 * NOTICE:
 * When there are too many dimensions in dataset and many series, only the used dimensions
 * (i.e., used by coord sys and declared in `series.encode`) are add to `dimensionDefineList`.
 * But users may query data by other unused dimension names.
 * In this case, users can only query data if and only if they have defined dimension names
 * via ec option, so we provide `getDimensionIndexFromSource`, which only query them from
 * `source` dimensions.
 */ var $8233286fea22402d$export$a1ef064685775f3e = /** @class */ function() {
    function SeriesDataSchema(opt) {
        this.dimensions = opt.dimensions;
        this._dimOmitted = opt.dimensionOmitted;
        this.source = opt.source;
        this._fullDimCount = opt.fullDimensionCount;
        this._updateDimOmitted(opt.dimensionOmitted);
    }
    SeriesDataSchema.prototype.isDimensionOmitted = function() {
        return this._dimOmitted;
    };
    SeriesDataSchema.prototype._updateDimOmitted = function(dimensionOmitted) {
        this._dimOmitted = dimensionOmitted;
        if (!dimensionOmitted) return;
        if (!this._dimNameMap) this._dimNameMap = $8233286fea22402d$export$be39ae17310c33f7(this.source);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Get index by user defined dimension name (i.e., not internal generate name).
   * That is, get index from `dimensionsDefine`.
   * If no `dimensionsDefine`, or no name get, return -1.
   */ SeriesDataSchema.prototype.getSourceDimensionIndex = function(dimName) {
        return (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(this._dimNameMap.get(dimName), -1);
    };
    /**
   * @caution Can only be used when `dimensionOmitted: true`.
   *
   * Notice: may return `null`/`undefined` if user not specify dimension names.
   */ SeriesDataSchema.prototype.getSourceDimension = function(dimIndex) {
        var dimensionsDefine = this.source.dimensionsDefine;
        if (dimensionsDefine) return dimensionsDefine[dimIndex];
    };
    SeriesDataSchema.prototype.makeStoreSchema = function() {
        var dimCount = this._fullDimCount;
        var willRetrieveDataByName = (0, $107136d10fa2cf04$export$8911336b527f8517)(this.source);
        var makeHashStrict = !$8233286fea22402d$export$238b87930d825d87(dimCount);
        // If source don't have dimensions or series don't omit unsed dimensions.
        // Generate from seriesDimList directly
        var dimHash = '';
        var dims = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < dimCount; fullDimIdx++){
            var property = void 0;
            var type = void 0;
            var ordinalMeta = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                property = willRetrieveDataByName ? seriesDimDef.name : null;
                type = seriesDimDef.type;
                ordinalMeta = seriesDimDef.ordinalMeta;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) {
                    property = willRetrieveDataByName ? sourceDimDef.name : null;
                    type = sourceDimDef.type;
                }
            }
            dims.push({
                property: property,
                type: type,
                ordinalMeta: ordinalMeta
            });
            // If retrieving data by index,
            //   use <index, type, ordinalMeta> to determine whether data can be shared.
            //   (Because in this case there might be no dimension name defined in dataset, but indices always exists).
            //   (Indices are always 0, 1, 2, ..., so we can ignore them to shorten the hash).
            // Otherwise if retrieving data by property name (like `data: [{aa: 123, bb: 765}, ...]`),
            //   use <property, type, ordinalMeta> in hash.
            if (willRetrieveDataByName && property != null && (!seriesDimDef || !seriesDimDef.isCalculationCoord)) dimHash += makeHashStrict ? property.replace(/\`/g, '`1').replace(/\$/g, '`2') : property;
            dimHash += '$';
            dimHash += $8233286fea22402d$var$dimTypeShort[type] || 'f';
            if (ordinalMeta) dimHash += ordinalMeta.uid;
            dimHash += '$';
        }
        // Source from endpoint(usually series) will be read differently
        // when seriesLayoutBy or startIndex(which is affected by sourceHeader) are different.
        // So we use this three props as key.
        var source = this.source;
        var hash = [
            source.seriesLayoutBy,
            source.startIndex,
            dimHash
        ].join('$$');
        return {
            dimensions: dims,
            hash: hash
        };
    };
    SeriesDataSchema.prototype.makeOutputDimensionNames = function() {
        var result = [];
        for(var fullDimIdx = 0, seriesDimIdx = 0; fullDimIdx < this._fullDimCount; fullDimIdx++){
            var name_1 = void 0;
            var seriesDimDef = this.dimensions[seriesDimIdx];
            // The list has been sorted by `storeDimIndex` asc.
            if (seriesDimDef && seriesDimDef.storeDimIndex === fullDimIdx) {
                if (!seriesDimDef.isCalculationCoord) name_1 = seriesDimDef.name;
                seriesDimIdx++;
            } else {
                var sourceDimDef = this.getSourceDimension(fullDimIdx);
                if (sourceDimDef) name_1 = sourceDimDef.name;
            }
            result.push(name_1);
        }
        return result;
    };
    SeriesDataSchema.prototype.appendCalculationDimension = function(dimDef) {
        this.dimensions.push(dimDef);
        dimDef.isCalculationCoord = true;
        this._fullDimCount++;
        // If append dimension on a data store, consider the store
        // might be shared by different series, series dimensions not
        // really map to store dimensions.
        this._updateDimOmitted(true);
    };
    return SeriesDataSchema;
}();
function $8233286fea22402d$export$fafbc856132a3a0e(schema) {
    return schema instanceof $8233286fea22402d$export$a1ef064685775f3e;
}
function $8233286fea22402d$export$a477f5bebfd07944(dimsDef) {
    var dataDimNameMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < (dimsDef || []).length; i++){
        var dimDefItemRaw = dimsDef[i];
        var userDimName = (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw.name : dimDefItemRaw;
        if (userDimName != null && dataDimNameMap.get(userDimName) == null) dataDimNameMap.set(userDimName, i);
    }
    return dataDimNameMap;
}
function $8233286fea22402d$export$be39ae17310c33f7(source) {
    var innerSource = $8233286fea22402d$var$inner(source);
    return innerSource.dimNameMap || (innerSource.dimNameMap = $8233286fea22402d$export$a477f5bebfd07944(source.dimensionsDefine));
}
function $8233286fea22402d$export$238b87930d825d87(dimCount) {
    return dimCount > 30;
}


var $3df3379dddbd72fe$var$isObject = $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a;
var $3df3379dddbd72fe$var$map = $1b239fc9d3a2f8ae$export$871de8747c9eaa88;
var $3df3379dddbd72fe$var$CtorInt32Array = typeof Int32Array === 'undefined' ? Array : Int32Array;
// Use prefix to avoid index to be the same as otherIdList[idx],
// which will cause weird update animation.
var $3df3379dddbd72fe$var$ID_PREFIX = 'e\0\0';
var $3df3379dddbd72fe$var$INDEX_NOT_FOUND = -1;
// type SeriesDimensionIndex = DimensionIndex;
var $3df3379dddbd72fe$var$TRANSFERABLE_PROPERTIES = [
    'hasItemOption',
    '_nameList',
    '_idList',
    '_invertedIndicesMap',
    '_dimSummary',
    'userOutput',
    '_rawData',
    '_dimValueGetter',
    '_nameDimIdx',
    '_idDimIdx',
    '_nameRepeatCount'
];
var $3df3379dddbd72fe$var$CLONE_PROPERTIES = [
    '_approximateExtent'
];
// -----------------------------
// Internal method declarations:
// -----------------------------
var $3df3379dddbd72fe$var$prepareInvertedIndex;
var $3df3379dddbd72fe$var$getId;
var $3df3379dddbd72fe$var$getIdNameFromStore;
var $3df3379dddbd72fe$var$normalizeDimensions;
var $3df3379dddbd72fe$var$transferProperties;
var $3df3379dddbd72fe$var$cloneListForMapAndSample;
var $3df3379dddbd72fe$var$makeIdFromName;
var $3df3379dddbd72fe$var$SeriesData = /** @class */ function() {
    /**
   * @param dimensionsInput.dimensions
   *        For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
   *        Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
   */ function SeriesData(dimensionsInput, hostModel) {
        this.type = 'list';
        this._dimOmitted = false;
        this._nameList = [];
        this._idList = [];
        // Models of data option is stored sparse for optimizing memory cost
        // Never used yet (not used yet).
        // private _optionModels: Model[] = [];
        // Global visual properties after visual coding
        this._visual = {};
        // Global layout properties.
        this._layout = {};
        // Item visual properties after visual coding
        this._itemVisuals = [];
        // Item layout properties after layout
        this._itemLayouts = [];
        // Graphic elements
        this._graphicEls = [];
        // key: dim, value: extent
        this._approximateExtent = {};
        this._calculationInfo = {};
        // Having detected that there is data item is non primitive type
        // (in type `OptionDataItemObject`).
        // Like `data: [ { value: xx, itemStyle: {...} }, ...]`
        // At present it only happen in `SOURCE_FORMAT_ORIGINAL`.
        this.hasItemOption = false;
        // Methods that create a new list based on this list should be listed here.
        // Notice that those method should `RETURN` the new list.
        this.TRANSFERABLE_METHODS = [
            'cloneShallow',
            'downSample',
            'minmaxDownSample',
            'lttbDownSample',
            'map'
        ];
        // Methods that change indices of this list should be listed here.
        this.CHANGABLE_METHODS = [
            'filterSelf',
            'selectRange'
        ];
        this.DOWNSAMPLE_METHODS = [
            'downSample',
            'minmaxDownSample',
            'lttbDownSample'
        ];
        var dimensions;
        var assignStoreDimIdx = false;
        if ((0, $8233286fea22402d$export$fafbc856132a3a0e)(dimensionsInput)) {
            dimensions = dimensionsInput.dimensions;
            this._dimOmitted = dimensionsInput.isDimensionOmitted();
            this._schema = dimensionsInput;
        } else {
            assignStoreDimIdx = true;
            dimensions = dimensionsInput;
        }
        dimensions = dimensions || [
            'x',
            'y'
        ];
        var dimensionInfos = {};
        var dimensionNames = [];
        var invertedIndicesMap = {};
        var needsHasOwn = false;
        var emptyObj = {};
        for(var i = 0; i < dimensions.length; i++){
            // Use the original dimensions[i], where other flag props may exists.
            var dimInfoInput = dimensions[i];
            var dimensionInfo = $1b239fc9d3a2f8ae$export$844ec244b1367d54(dimInfoInput) ? new (0, $1fa5d70417e8025f$export$2e2bcd8739ae039)({
                name: dimInfoInput
            }) : !(dimInfoInput instanceof (0, $1fa5d70417e8025f$export$2e2bcd8739ae039)) ? new (0, $1fa5d70417e8025f$export$2e2bcd8739ae039)(dimInfoInput) : dimInfoInput;
            var dimensionName = dimensionInfo.name;
            dimensionInfo.type = dimensionInfo.type || 'float';
            if (!dimensionInfo.coordDim) {
                dimensionInfo.coordDim = dimensionName;
                dimensionInfo.coordDimIndex = 0;
            }
            var otherDims = dimensionInfo.otherDims = dimensionInfo.otherDims || {};
            dimensionNames.push(dimensionName);
            dimensionInfos[dimensionName] = dimensionInfo;
            if (emptyObj[dimensionName] != null) needsHasOwn = true;
            if (dimensionInfo.createInvertedIndices) invertedIndicesMap[dimensionName] = [];
            if (otherDims.itemName === 0) this._nameDimIdx = i;
            if (otherDims.itemId === 0) this._idDimIdx = i;
            if (assignStoreDimIdx) dimensionInfo.storeDimIndex = i;
        }
        this.dimensions = dimensionNames;
        this._dimInfos = dimensionInfos;
        this._initGetDimensionInfo(needsHasOwn);
        this.hostModel = hostModel;
        this._invertedIndicesMap = invertedIndicesMap;
        if (this._dimOmitted) {
            var dimIdxToName_1 = this._dimIdxToName = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(dimensionNames, function(dimName) {
                dimIdxToName_1.set(dimensionInfos[dimName].storeDimIndex, dimName);
            });
        }
    }
    /**
   *
   * Get concrete dimension name by dimension name or dimension index.
   * If input a dimension name, do not validate whether the dimension name exits.
   *
   * @caution
   * @param dim Must make sure the dimension is `SeriesDimensionLoose`.
   * Because only those dimensions will have auto-generated dimension names if not
   * have a user-specified name, and other dimensions will get a return of null/undefined.
   *
   * @notice Because of this reason, should better use `getDimensionIndex` instead, for examples:
   * ```js
   * const val = data.getStore().get(data.getDimensionIndex(dim), dataIdx);
   * ```
   *
   * @return Concrete dim name.
   */ SeriesData.prototype.getDimension = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx == null) return dim;
        dimIdx = dim;
        if (!this._dimOmitted) return this.dimensions[dimIdx];
        // Retrieve from series dimension definition because it probably contains
        // generated dimension name (like 'x', 'y').
        var dimName = this._dimIdxToName.get(dimIdx);
        if (dimName != null) return dimName;
        var sourceDimDef = this._schema.getSourceDimension(dimIdx);
        if (sourceDimDef) return sourceDimDef.name;
    };
    /**
   * Get dimension index in data store. Return -1 if not found.
   * Can be used to index value from getRawValue.
   */ SeriesData.prototype.getDimensionIndex = function(dim) {
        var dimIdx = this._recognizeDimIndex(dim);
        if (dimIdx != null) return dimIdx;
        if (dim == null) return -1;
        var dimInfo = this._getDimInfo(dim);
        return dimInfo ? dimInfo.storeDimIndex : this._dimOmitted ? this._schema.getSourceDimensionIndex(dim) : -1;
    };
    /**
   * The meanings of the input parameter `dim`:
   *
   * + If dim is a number (e.g., `1`), it means the index of the dimension.
   *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
   * + If dim is a number-like string (e.g., `"1"`):
   *     + If there is the same concrete dim name defined in `series.dimensions` or `dataset.dimensions`,
   *        it means that concrete name.
   *     + If not, it will be converted to a number, which means the index of the dimension.
   *        (why? because of the backward compatibility. We have been tolerating number-like string in
   *        dimension setting, although now it seems that it is not a good idea.)
   *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
   *     if no dimension name is defined as `"1"`.
   * + If dim is a not-number-like string, it means the concrete dim name.
   *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
   *   or customized in `dimensions` property of option like `"age"`.
   *
   * @return recognized `DimensionIndex`. Otherwise return null/undefined (means that dim is `DimensionName`).
   */ SeriesData.prototype._recognizeDimIndex = function(dim) {
        if ($1b239fc9d3a2f8ae$export$7e4aa119212bc614(dim) || dim != null && !isNaN(dim) && !this._getDimInfo(dim) && (!this._dimOmitted || this._schema.getSourceDimensionIndex(dim) < 0)) return +dim;
    };
    SeriesData.prototype._getStoreDimIndex = function(dim) {
        var dimIdx = this.getDimensionIndex(dim);
        return dimIdx;
    };
    /**
   * Get type and calculation info of particular dimension
   * @param dim
   *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
   *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
   */ SeriesData.prototype.getDimensionInfo = function(dim) {
        // Do not clone, because there may be categories in dimInfo.
        return this._getDimInfo(this.getDimension(dim));
    };
    SeriesData.prototype._initGetDimensionInfo = function(needsHasOwn) {
        var dimensionInfos = this._dimInfos;
        this._getDimInfo = needsHasOwn ? function(dimName) {
            return dimensionInfos.hasOwnProperty(dimName) ? dimensionInfos[dimName] : undefined;
        } : function(dimName) {
            return dimensionInfos[dimName];
        };
    };
    /**
   * concrete dimension name list on coord.
   */ SeriesData.prototype.getDimensionsOnCoord = function() {
        return this._dimSummary.dataDimsOnCoord.slice();
    };
    SeriesData.prototype.mapDimension = function(coordDim, idx) {
        var dimensionsSummary = this._dimSummary;
        if (idx == null) return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
        var dims = dimensionsSummary.encode[coordDim];
        return dims ? dims[idx] : null;
    };
    SeriesData.prototype.mapDimensionsAll = function(coordDim) {
        var dimensionsSummary = this._dimSummary;
        var dims = dimensionsSummary.encode[coordDim];
        return (dims || []).slice();
    };
    SeriesData.prototype.getStore = function() {
        return this._store;
    };
    /**
   * Initialize from data
   * @param data source or data or data store.
   * @param nameList The name of a datum is used on data diff and
   *        default label/tooltip.
   *        A name can be specified in encode.itemName,
   *        or dataItem.name (only for series option data),
   *        or provided in nameList from outside.
   */ SeriesData.prototype.initData = function(data, nameList, dimValueGetter) {
        var _this = this;
        var store;
        if (data instanceof (0, $28fb3a4f6a7eb423$export$2e2bcd8739ae039)) store = data;
        if (!store) {
            var dimensions = this.dimensions;
            var provider = (0, $107136d10fa2cf04$export$22b808bc02a60488)(data) || $1b239fc9d3a2f8ae$export$1e2f57719e155213(data) ? new (0, $a0d276c4568d5ef4$export$b900d7c4c3952a40)(data, dimensions.length) : data;
            store = new (0, $28fb3a4f6a7eb423$export$2e2bcd8739ae039)();
            var dimensionInfos = $3df3379dddbd72fe$var$map(dimensions, function(dimName) {
                return {
                    type: _this._dimInfos[dimName].type,
                    property: dimName
                };
            });
            store.initData(provider, dimensionInfos, dimValueGetter);
        }
        this._store = store;
        // Reset
        this._nameList = (nameList || []).slice();
        this._idList = [];
        this._nameRepeatCount = {};
        this._doInit(0, store.count());
        // Cache summary info for fast visit. See "dimensionHelper".
        // Needs to be initialized after store is prepared.
        this._dimSummary = (0, $e1ef773174d5a33a$export$505a22c3734846f1)(this, this._schema);
        this.userOutput = this._dimSummary.userOutput;
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   */ SeriesData.prototype.appendData = function(data) {
        var range = this._store.appendData(data);
        this._doInit(range[0], range[1]);
    };
    /**
   * Caution: Can be only called on raw data (before `this._indices` created).
   * This method does not modify `rawData` (`dataProvider`), but only
   * add values to store.
   *
   * The final count will be increased by `Math.max(values.length, names.length)`.
   *
   * @param values That is the SourceType: 'arrayRows', like
   *        [
   *            [12, 33, 44],
   *            [NaN, 43, 1],
   *            ['-', 'asdf', 0]
   *        ]
   *        Each item is exactly corresponding to a dimension.
   */ SeriesData.prototype.appendValues = function(values, names) {
        var _a = this._store.appendValues(values, names && names.length), start = _a.start, end = _a.end;
        var shouldMakeIdFromName = this._shouldMakeIdFromName();
        this._updateOrdinalMeta();
        if (names) for(var idx = start; idx < end; idx++){
            var sourceIdx = idx - start;
            this._nameList[idx] = names[sourceIdx];
            if (shouldMakeIdFromName) $3df3379dddbd72fe$var$makeIdFromName(this, idx);
        }
    };
    SeriesData.prototype._updateOrdinalMeta = function() {
        var store = this._store;
        var dimensions = this.dimensions;
        for(var i = 0; i < dimensions.length; i++){
            var dimInfo = this._dimInfos[dimensions[i]];
            if (dimInfo.ordinalMeta) store.collectOrdinalMeta(dimInfo.storeDimIndex, dimInfo.ordinalMeta);
        }
    };
    SeriesData.prototype._shouldMakeIdFromName = function() {
        var provider = this._store.getProvider();
        return this._idDimIdx == null && provider.getSource().sourceFormat !== (0, $369d2fc585e5938e$export$a918cb016a382d45) && !provider.fillStorage;
    };
    SeriesData.prototype._doInit = function(start, end) {
        if (start >= end) return;
        var store = this._store;
        var provider = store.getProvider();
        this._updateOrdinalMeta();
        var nameList = this._nameList;
        var idList = this._idList;
        var sourceFormat = provider.getSource().sourceFormat;
        var isFormatOriginal = sourceFormat === (0, $369d2fc585e5938e$export$2823037fb9d8f0c6);
        // Each data item is value
        // [1, 2]
        // 2
        // Bar chart, line chart which uses category axis
        // only gives the 'y' value. 'x' value is the indices of category
        // Use a tempValue to normalize the value to be a (x, y) value
        // If dataItem is {name: ...} or {id: ...}, it has highest priority.
        // This kind of ids and names are always stored `_nameList` and `_idList`.
        if (isFormatOriginal && !provider.pure) {
            var sharedDataItem = [];
            for(var idx = start; idx < end; idx++){
                // NOTICE: Try not to write things into dataItem
                var dataItem = provider.getItem(idx, sharedDataItem);
                if (!this.hasItemOption && (0, $9ac03c46e8b6e711$export$3e1a543f33ef6883)(dataItem)) this.hasItemOption = true;
                if (dataItem) {
                    var itemName = dataItem.name;
                    if (nameList[idx] == null && itemName != null) nameList[idx] = (0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)(itemName, null);
                    var itemId = dataItem.id;
                    if (idList[idx] == null && itemId != null) idList[idx] = (0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)(itemId, null);
                }
            }
        }
        if (this._shouldMakeIdFromName()) for(var idx = start; idx < end; idx++)$3df3379dddbd72fe$var$makeIdFromName(this, idx);
        $3df3379dddbd72fe$var$prepareInvertedIndex(this);
    };
    /**
   * PENDING: In fact currently this function is only used to short-circuit
   * the calling of `scale.unionExtentFromData` when data have been filtered by modules
   * like "dataZoom". `scale.unionExtentFromData` is used to calculate data extent for series on
   * an axis, but if a "axis related data filter module" is used, the extent of the axis have
   * been fixed and no need to calling `scale.unionExtentFromData` actually.
   * But if we add "custom data filter" in future, which is not "axis related", this method may
   * be still needed.
   *
   * Optimize for the scenario that data is filtered by a given extent.
   * Consider that if data amount is more than hundreds of thousand,
   * extent calculation will cost more than 10ms and the cache will
   * be erased because of the filtering.
   */ SeriesData.prototype.getApproximateExtent = function(dim) {
        return this._approximateExtent[dim] || this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    /**
   * Calculate extent on a filtered data might be time consuming.
   * Approximate extent is only used for: calculate extent of filtered data outside.
   */ SeriesData.prototype.setApproximateExtent = function(extent, dim) {
        dim = this.getDimension(dim);
        this._approximateExtent[dim] = extent.slice();
    };
    SeriesData.prototype.getCalculationInfo = function(key) {
        return this._calculationInfo[key];
    };
    SeriesData.prototype.setCalculationInfo = function(key, value) {
        $3df3379dddbd72fe$var$isObject(key) ? $1b239fc9d3a2f8ae$export$8b58be045bf06082(this._calculationInfo, key) : this._calculationInfo[key] = value;
    };
    /**
   * @return Never be null/undefined. `number` will be converted to string. Because:
   * In most cases, name is used in display, where returning a string is more convenient.
   * In other cases, name is used in query (see `indexOfName`), where we can keep the
   * rule that name `2` equals to name `'2'`.
   */ SeriesData.prototype.getName = function(idx) {
        var rawIndex = this.getRawIndex(idx);
        var name = this._nameList[rawIndex];
        if (name == null && this._nameDimIdx != null) name = $3df3379dddbd72fe$var$getIdNameFromStore(this, this._nameDimIdx, rawIndex);
        if (name == null) name = '';
        return name;
    };
    SeriesData.prototype._getCategory = function(dimIdx, idx) {
        var ordinal = this._store.get(dimIdx, idx);
        var ordinalMeta = this._store.getOrdinalMeta(dimIdx);
        if (ordinalMeta) return ordinalMeta.categories[ordinal];
        return ordinal;
    };
    /**
   * @return Never null/undefined. `number` will be converted to string. Because:
   * In all cases having encountered at present, id is used in making diff comparison, which
   * are usually based on hash map. We can keep the rule that the internal id are always string
   * (treat `2` is the same as `'2'`) to make the related logic simple.
   */ SeriesData.prototype.getId = function(idx) {
        return $3df3379dddbd72fe$var$getId(this, this.getRawIndex(idx));
    };
    SeriesData.prototype.count = function() {
        return this._store.count();
    };
    /**
   * Get value. Return NaN if idx is out of range.
   *
   * @notice Should better to use `data.getStore().get(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.get = function(dim, idx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.get(dimInfo.storeDimIndex, idx);
    };
    /**
   * @notice Should better to use `data.getStore().getByRawIndex(dimIndex, dataIdx)` instead.
   */ SeriesData.prototype.getByRawIndex = function(dim, rawIdx) {
        var store = this._store;
        var dimInfo = this._dimInfos[dim];
        if (dimInfo) return store.getByRawIndex(dimInfo.storeDimIndex, rawIdx);
    };
    SeriesData.prototype.getIndices = function() {
        return this._store.getIndices();
    };
    SeriesData.prototype.getDataExtent = function(dim) {
        return this._store.getDataExtent(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getSum = function(dim) {
        return this._store.getSum(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getMedian = function(dim) {
        return this._store.getMedian(this._getStoreDimIndex(dim));
    };
    SeriesData.prototype.getValues = function(dimensions, idx) {
        var _this = this;
        var store = this._store;
        return $1b239fc9d3a2f8ae$export$43bee75e5e14138e(dimensions) ? store.getValues($3df3379dddbd72fe$var$map(dimensions, function(dim) {
            return _this._getStoreDimIndex(dim);
        }), idx) : store.getValues(dimensions);
    };
    /**
   * If value is NaN. Including '-'
   * Only check the coord dimensions.
   */ SeriesData.prototype.hasValue = function(idx) {
        var dataDimIndicesOnCoord = this._dimSummary.dataDimIndicesOnCoord;
        for(var i = 0, len = dataDimIndicesOnCoord.length; i < len; i++){
            // Ordinal type originally can be string or number.
            // But when an ordinal type is used on coord, it can
            // not be string but only number. So we can also use isNaN.
            if (isNaN(this._store.get(dataDimIndicesOnCoord[i], idx))) return false;
        }
        return true;
    };
    /**
   * Retrieve the index with given name
   */ SeriesData.prototype.indexOfName = function(name) {
        for(var i = 0, len = this._store.count(); i < len; i++){
            if (this.getName(i) === name) return i;
        }
        return -1;
    };
    SeriesData.prototype.getRawIndex = function(idx) {
        return this._store.getRawIndex(idx);
    };
    SeriesData.prototype.indexOfRawIndex = function(rawIndex) {
        return this._store.indexOfRawIndex(rawIndex);
    };
    /**
   * Only support the dimension which inverted index created.
   * Do not support other cases until required.
   * @param dim concrete dim
   * @param value ordinal index
   * @return rawIndex
   */ SeriesData.prototype.rawIndexOf = function(dim, value) {
        var invertedIndices = dim && this._invertedIndicesMap[dim];
        var rawIndex = invertedIndices && invertedIndices[value];
        if (rawIndex == null || isNaN(rawIndex)) return $3df3379dddbd72fe$var$INDEX_NOT_FOUND;
        return rawIndex;
    };
    /**
   * Retrieve the index of nearest value
   * @param dim
   * @param value
   * @param [maxDistance=Infinity]
   * @return If and only if multiple indices has
   *         the same value, they are put to the result.
   */ SeriesData.prototype.indicesOfNearest = function(dim, value, maxDistance) {
        return this._store.indicesOfNearest(this._getStoreDimIndex(dim), value, maxDistance);
    };
    SeriesData.prototype.each = function(dims, cb, ctx) {
        'use strict';
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $3df3379dddbd72fe$var$map($3df3379dddbd72fe$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store.each(dimIndices, fCtx ? $1b239fc9d3a2f8ae$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    SeriesData.prototype.filterSelf = function(dims, cb, ctx) {
        'use strict';
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        var fCtx = ctx || this;
        var dimIndices = $3df3379dddbd72fe$var$map($3df3379dddbd72fe$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        this._store = this._store.filter(dimIndices, fCtx ? $1b239fc9d3a2f8ae$export$2385a24977818dd0(cb, fCtx) : cb);
        return this;
    };
    /**
   * Select data in range. (For optimization of filter)
   * (Manually inline code, support 5 million data filtering in data zoom.)
   */ SeriesData.prototype.selectRange = function(range) {
        'use strict';
        var _this = this;
        var innerRange = {};
        var dims = $1b239fc9d3a2f8ae$export$ed97f33186d4b816(range);
        var dimIndices = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(dims, function(dim) {
            var dimIdx = _this._getStoreDimIndex(dim);
            innerRange[dimIdx] = range[dim];
            dimIndices.push(dimIdx);
        });
        this._store = this._store.selectRange(innerRange);
        return this;
    };
    /* eslint-enable max-len */ SeriesData.prototype.mapArray = function(dims, cb, ctx) {
        'use strict';
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(dims)) {
            ctx = cb;
            cb = dims;
            dims = [];
        }
        // ctxCompat just for compat echarts3
        ctx = ctx || this;
        var result = [];
        this.each(dims, function() {
            result.push(cb && cb.apply(this, arguments));
        }, ctx);
        return result;
    };
    SeriesData.prototype.map = function(dims, cb, ctx, ctxCompat) {
        'use strict';
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $3df3379dddbd72fe$var$map($3df3379dddbd72fe$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        var list = $3df3379dddbd72fe$var$cloneListForMapAndSample(this);
        list._store = this._store.map(dimIndices, fCtx ? $1b239fc9d3a2f8ae$export$2385a24977818dd0(cb, fCtx) : cb);
        return list;
    };
    SeriesData.prototype.modify = function(dims, cb, ctx, ctxCompat) {
        var _this = this;
        // ctxCompat just for compat echarts3
        var fCtx = ctx || ctxCompat || this;
        var dimIndices = $3df3379dddbd72fe$var$map($3df3379dddbd72fe$var$normalizeDimensions(dims), this._getStoreDimIndex, this);
        // If do shallow clone here, if there are too many stacked series,
        // it still cost lots of memory, because `_store.dimensions` are not shared.
        // We should consider there probably be shallow clone happen in each series
        // in consequent filter/map.
        this._store.modify(dimIndices, fCtx ? $1b239fc9d3a2f8ae$export$2385a24977818dd0(cb, fCtx) : cb);
    };
    /**
   * Large data down sampling on given dimension
   * @param sampleIndex Sample index for name and id
   */ SeriesData.prototype.downSample = function(dimension, rate, sampleValue, sampleIndex) {
        var list = $3df3379dddbd72fe$var$cloneListForMapAndSample(this);
        list._store = this._store.downSample(this._getStoreDimIndex(dimension), rate, sampleValue, sampleIndex);
        return list;
    };
    /**
   * Large data down sampling using min-max
   * @param {string} valueDimension
   * @param {number} rate
   */ SeriesData.prototype.minmaxDownSample = function(valueDimension, rate) {
        var list = $3df3379dddbd72fe$var$cloneListForMapAndSample(this);
        list._store = this._store.minmaxDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    /**
   * Large data down sampling using largest-triangle-three-buckets
   * @param {string} valueDimension
   * @param {number} targetCount
   */ SeriesData.prototype.lttbDownSample = function(valueDimension, rate) {
        var list = $3df3379dddbd72fe$var$cloneListForMapAndSample(this);
        list._store = this._store.lttbDownSample(this._getStoreDimIndex(valueDimension), rate);
        return list;
    };
    SeriesData.prototype.getRawDataItem = function(idx) {
        return this._store.getRawDataItem(idx);
    };
    /**
   * Get model of one data item.
   */ // TODO: Type of data item
    SeriesData.prototype.getItemModel = function(idx) {
        var hostModel = this.hostModel;
        var dataItem = this.getRawDataItem(idx);
        return new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(dataItem, hostModel, hostModel && hostModel.ecModel);
    };
    /**
   * Create a data differ
   */ SeriesData.prototype.diff = function(otherList) {
        var thisList = this;
        return new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(otherList ? otherList.getStore().getIndices() : [], this.getStore().getIndices(), function(idx) {
            return $3df3379dddbd72fe$var$getId(otherList, idx);
        }, function(idx) {
            return $3df3379dddbd72fe$var$getId(thisList, idx);
        });
    };
    /**
   * Get visual property.
   */ SeriesData.prototype.getVisual = function(key) {
        var visual = this._visual;
        return visual && visual[key];
    };
    SeriesData.prototype.setVisual = function(kvObj, val) {
        this._visual = this._visual || {};
        if ($3df3379dddbd72fe$var$isObject(kvObj)) $1b239fc9d3a2f8ae$export$8b58be045bf06082(this._visual, kvObj);
        else this._visual[kvObj] = val;
    };
    /**
   * Get visual property of single data item
   */ // eslint-disable-next-line
    SeriesData.prototype.getItemVisual = function(idx, key) {
        var itemVisual = this._itemVisuals[idx];
        var val = itemVisual && itemVisual[key];
        if (val == null) // Use global visual property
        return this.getVisual(key);
        return val;
    };
    /**
   * If exists visual property of single data item
   */ SeriesData.prototype.hasItemVisual = function() {
        return this._itemVisuals.length > 0;
    };
    /**
   * Make sure itemVisual property is unique
   */ // TODO: use key to save visual to reduce memory.
    SeriesData.prototype.ensureUniqueItemVisual = function(idx, key) {
        var itemVisuals = this._itemVisuals;
        var itemVisual = itemVisuals[idx];
        if (!itemVisual) itemVisual = itemVisuals[idx] = {};
        var val = itemVisual[key];
        if (val == null) {
            val = this.getVisual(key);
            // TODO Performance?
            if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(val)) val = val.slice();
            else if ($3df3379dddbd72fe$var$isObject(val)) val = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, val);
            itemVisual[key] = val;
        }
        return val;
    };
    // eslint-disable-next-line
    SeriesData.prototype.setItemVisual = function(idx, key, value) {
        var itemVisual = this._itemVisuals[idx] || {};
        this._itemVisuals[idx] = itemVisual;
        if ($3df3379dddbd72fe$var$isObject(key)) $1b239fc9d3a2f8ae$export$8b58be045bf06082(itemVisual, key);
        else itemVisual[key] = value;
    };
    /**
   * Clear itemVisuals and list visual.
   */ SeriesData.prototype.clearAllVisual = function() {
        this._visual = {};
        this._itemVisuals = [];
    };
    SeriesData.prototype.setLayout = function(key, val) {
        $3df3379dddbd72fe$var$isObject(key) ? $1b239fc9d3a2f8ae$export$8b58be045bf06082(this._layout, key) : this._layout[key] = val;
    };
    /**
   * Get layout property.
   */ SeriesData.prototype.getLayout = function(key) {
        return this._layout[key];
    };
    /**
   * Get layout of single data item
   */ SeriesData.prototype.getItemLayout = function(idx) {
        return this._itemLayouts[idx];
    };
    /**
   * Set layout of single data item
   */ SeriesData.prototype.setItemLayout = function(idx, layout, merge) {
        this._itemLayouts[idx] = merge ? $1b239fc9d3a2f8ae$export$8b58be045bf06082(this._itemLayouts[idx] || {}, layout) : layout;
    };
    /**
   * Clear all layout of single data item
   */ SeriesData.prototype.clearItemLayouts = function() {
        this._itemLayouts.length = 0;
    };
    /**
   * Set graphic element relative to data. It can be set as null
   */ SeriesData.prototype.setItemGraphicEl = function(idx, el) {
        var seriesIndex = this.hostModel && this.hostModel.seriesIndex;
        (0, $ea063383a2a89e3f$export$30d6736ebb8e18d5)(seriesIndex, this.dataType, idx, el);
        this._graphicEls[idx] = el;
    };
    SeriesData.prototype.getItemGraphicEl = function(idx) {
        return this._graphicEls[idx];
    };
    SeriesData.prototype.eachItemGraphicEl = function(cb, context) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._graphicEls, function(el, idx) {
            if (el) cb && cb.call(context, el, idx);
        });
    };
    /**
   * Shallow clone a new list except visual and layout properties, and graph elements.
   * New list only change the indices.
   */ SeriesData.prototype.cloneShallow = function(list) {
        if (!list) list = new SeriesData(this._schema ? this._schema : $3df3379dddbd72fe$var$map(this.dimensions, this._getDimInfo, this), this.hostModel);
        $3df3379dddbd72fe$var$transferProperties(list, this);
        list._store = this._store;
        return list;
    };
    /**
   * Wrap some method to add more feature
   */ SeriesData.prototype.wrapMethod = function(methodName, injectFunction) {
        var originalMethod = this[methodName];
        if (!$1b239fc9d3a2f8ae$export$f6e2535fb5126e54(originalMethod)) return;
        this.__wrappedMethods = this.__wrappedMethods || [];
        this.__wrappedMethods.push(methodName);
        this[methodName] = function() {
            var res = originalMethod.apply(this, arguments);
            return injectFunction.apply(this, [
                res
            ].concat($1b239fc9d3a2f8ae$export$58adb3bec8346d0f(arguments)));
        };
    };
    // ----------------------------------------------------------
    // A work around for internal method visiting private member.
    // ----------------------------------------------------------
    SeriesData.internalField = function() {
        $3df3379dddbd72fe$var$prepareInvertedIndex = function(data) {
            var invertedIndicesMap = data._invertedIndicesMap;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(invertedIndicesMap, function(invertedIndices, dim) {
                var dimInfo = data._dimInfos[dim];
                // Currently, only dimensions that has ordinalMeta can create inverted indices.
                var ordinalMeta = dimInfo.ordinalMeta;
                var store = data._store;
                if (ordinalMeta) {
                    invertedIndices = invertedIndicesMap[dim] = new $3df3379dddbd72fe$var$CtorInt32Array(ordinalMeta.categories.length);
                    // The default value of TypedArray is 0. To avoid miss
                    // mapping to 0, we should set it as INDEX_NOT_FOUND.
                    for(var i = 0; i < invertedIndices.length; i++)invertedIndices[i] = $3df3379dddbd72fe$var$INDEX_NOT_FOUND;
                    for(var i = 0; i < store.count(); i++)// Only support the case that all values are distinct.
                    invertedIndices[store.get(dimInfo.storeDimIndex, i)] = i;
                }
            });
        };
        $3df3379dddbd72fe$var$getIdNameFromStore = function(data, dimIdx, idx) {
            return (0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)(data._getCategory(dimIdx, idx), null);
        };
        /**
     * @see the comment of `List['getId']`.
     */ $3df3379dddbd72fe$var$getId = function(data, rawIndex) {
            var id = data._idList[rawIndex];
            if (id == null && data._idDimIdx != null) id = $3df3379dddbd72fe$var$getIdNameFromStore(data, data._idDimIdx, rawIndex);
            if (id == null) id = $3df3379dddbd72fe$var$ID_PREFIX + rawIndex;
            return id;
        };
        $3df3379dddbd72fe$var$normalizeDimensions = function(dimensions) {
            if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(dimensions)) dimensions = dimensions != null ? [
                dimensions
            ] : [];
            return dimensions;
        };
        /**
     * Data in excludeDimensions is copied, otherwise transferred.
     */ $3df3379dddbd72fe$var$cloneListForMapAndSample = function(original) {
            var list = new SeriesData(original._schema ? original._schema : $3df3379dddbd72fe$var$map(original.dimensions, original._getDimInfo, original), original.hostModel);
            // FIXME If needs stackedOn, value may already been stacked
            $3df3379dddbd72fe$var$transferProperties(list, original);
            return list;
        };
        $3df3379dddbd72fe$var$transferProperties = function(target, source) {
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43($3df3379dddbd72fe$var$TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function(propName) {
                if (source.hasOwnProperty(propName)) target[propName] = source[propName];
            });
            target.__wrappedMethods = source.__wrappedMethods;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43($3df3379dddbd72fe$var$CLONE_PROPERTIES, function(propName) {
                target[propName] = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(source[propName]);
            });
            target._calculationInfo = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, source._calculationInfo);
        };
        $3df3379dddbd72fe$var$makeIdFromName = function(data, idx) {
            var nameList = data._nameList;
            var idList = data._idList;
            var nameDimIdx = data._nameDimIdx;
            var idDimIdx = data._idDimIdx;
            var name = nameList[idx];
            var id = idList[idx];
            if (name == null && nameDimIdx != null) nameList[idx] = name = $3df3379dddbd72fe$var$getIdNameFromStore(data, nameDimIdx, idx);
            if (id == null && idDimIdx != null) idList[idx] = id = $3df3379dddbd72fe$var$getIdNameFromStore(data, idDimIdx, idx);
            if (id == null && name != null) {
                var nameRepeatCount = data._nameRepeatCount;
                var nmCnt = nameRepeatCount[name] = (nameRepeatCount[name] || 0) + 1;
                id = name;
                if (nmCnt > 1) id += '__ec__' + nmCnt;
                idList[idx] = id;
            }
        };
    }();
    return SeriesData;
}();
var $3df3379dddbd72fe$export$2e2bcd8739ae039 = $3df3379dddbd72fe$var$SeriesData;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $02c5dbb1162b825d$export$8066c1b52b2e9504(source, opt) {
    return $02c5dbb1162b825d$export$2e2bcd8739ae039(source, opt).dimensions;
}
function $02c5dbb1162b825d$export$2e2bcd8739ae039(// TODO: TYPE completeDimensions type
source, opt) {
    if (!(0, $107136d10fa2cf04$export$22b808bc02a60488)(source)) source = (0, $107136d10fa2cf04$export$75aef3f97c0a5edf)(source);
    opt = opt || {};
    var sysDims = opt.coordDimensions || [];
    var dimsDef = opt.dimensionsDefine || source.dimensionsDefine || [];
    var coordDimNameMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    var resultList = [];
    var dimCount = $02c5dbb1162b825d$var$getDimCount(source, sysDims, dimsDef, opt.dimensionsCount);
    // Try to ignore unused dimensions if sharing a high dimension datastore
    // 30 is an experience value.
    var omitUnusedDimensions = opt.canOmitUnusedDimensions && (0, $8233286fea22402d$export$238b87930d825d87)(dimCount);
    var isUsingSourceDimensionsDef = dimsDef === source.dimensionsDefine;
    var dataDimNameMap = isUsingSourceDimensionsDef ? (0, $8233286fea22402d$export$be39ae17310c33f7)(source) : (0, $8233286fea22402d$export$a477f5bebfd07944)(dimsDef);
    var encodeDef = opt.encodeDefine;
    if (!encodeDef && opt.encodeDefaulter) encodeDef = opt.encodeDefaulter(source, dimCount);
    var encodeDefMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)(encodeDef);
    var indicesMap = new (0, $28fb3a4f6a7eb423$export$b60d945128546f53)(dimCount);
    for(var i = 0; i < indicesMap.length; i++)indicesMap[i] = -1;
    function getResultItem(dimIdx) {
        var idx = indicesMap[dimIdx];
        if (idx < 0) {
            var dimDefItemRaw = dimsDef[dimIdx];
            var dimDefItem = (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(dimDefItemRaw) ? dimDefItemRaw : {
                name: dimDefItemRaw
            };
            var resultItem = new (0, $1fa5d70417e8025f$export$2e2bcd8739ae039)();
            var userDimName = dimDefItem.name;
            if (userDimName != null && dataDimNameMap.get(userDimName) != null) // Only if `series.dimensions` is defined in option
            // displayName, will be set, and dimension will be displayed vertically in
            // tooltip by default.
            resultItem.name = resultItem.displayName = userDimName;
            dimDefItem.type != null && (resultItem.type = dimDefItem.type);
            dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
            var newIdx = resultList.length;
            indicesMap[dimIdx] = newIdx;
            resultItem.storeDimIndex = dimIdx;
            resultList.push(resultItem);
            return resultItem;
        }
        return resultList[idx];
    }
    if (!omitUnusedDimensions) for(var i = 0; i < dimCount; i++)getResultItem(i);
    // Set `coordDim` and `coordDimIndex` by `encodeDefMap` and normalize `encodeDefMap`.
    encodeDefMap.each(function(dataDimsRaw, coordDim) {
        var dataDims = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(dataDimsRaw).slice();
        // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
        // `{encode: {x: -1, y: 1}}`. Should not filter anything in
        // this case.
        if (dataDims.length === 1 && !(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(dataDims[0]) && dataDims[0] < 0) {
            encodeDefMap.set(coordDim, false);
            return;
        }
        var validDataDims = encodeDefMap.set(coordDim, []);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dataDims, function(resultDimIdxOrName, idx) {
            // The input resultDimIdx can be dim name or index.
            var resultDimIdx = (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(resultDimIdxOrName) ? dataDimNameMap.get(resultDimIdxOrName) : resultDimIdxOrName;
            if (resultDimIdx != null && resultDimIdx < dimCount) {
                validDataDims[idx] = resultDimIdx;
                applyDim(getResultItem(resultDimIdx), coordDim, idx);
            }
        });
    });
    // Apply templates and default order from `sysDims`.
    var availDimIdx = 0;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(sysDims, function(sysDimItemRaw) {
        var coordDim;
        var sysDimItemDimsDef;
        var sysDimItemOtherDims;
        var sysDimItem;
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(sysDimItemRaw)) {
            coordDim = sysDimItemRaw;
            sysDimItem = {};
        } else {
            sysDimItem = sysDimItemRaw;
            coordDim = sysDimItem.name;
            var ordinalMeta = sysDimItem.ordinalMeta;
            sysDimItem.ordinalMeta = null;
            sysDimItem = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, sysDimItem);
            sysDimItem.ordinalMeta = ordinalMeta;
            // `coordDimIndex` should not be set directly.
            sysDimItemDimsDef = sysDimItem.dimsDef;
            sysDimItemOtherDims = sysDimItem.otherDims;
            sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
        }
        var dataDims = encodeDefMap.get(coordDim);
        // negative resultDimIdx means no need to mapping.
        if (dataDims === false) return;
        dataDims = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(dataDims);
        // dimensions provides default dim sequences.
        if (!dataDims.length) for(var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++){
            while(availDimIdx < dimCount && getResultItem(availDimIdx).coordDim != null)availDimIdx++;
            availDimIdx < dimCount && dataDims.push(availDimIdx++);
        }
        // Apply templates.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dataDims, function(resultDimIdx, coordDimIndex) {
            var resultItem = getResultItem(resultDimIdx);
            // Coordinate system has a higher priority on dim type than source.
            if (isUsingSourceDimensionsDef && sysDimItem.type != null) resultItem.type = sysDimItem.type;
            applyDim((0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(resultItem, sysDimItem), coordDim, coordDimIndex);
            if (resultItem.name == null && sysDimItemDimsDef) {
                var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
                !(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
                    name: sysDimItemDimsDefItem
                });
                resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
                resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
            }
            // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
            sysDimItemOtherDims && (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(resultItem.otherDims, sysDimItemOtherDims);
        });
    });
    function applyDim(resultItem, coordDim, coordDimIndex) {
        if ((0, $369d2fc585e5938e$export$cd51b5ca77f6f0e4).get(coordDim) != null) resultItem.otherDims[coordDim] = coordDimIndex;
        else {
            resultItem.coordDim = coordDim;
            resultItem.coordDimIndex = coordDimIndex;
            coordDimNameMap.set(coordDim, true);
        }
    }
    // Make sure the first extra dim is 'value'.
    var generateCoord = opt.generateCoord;
    var generateCoordCount = opt.generateCoordCount;
    var fromZero = generateCoordCount != null;
    generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
    var extra = generateCoord || 'value';
    function ifNoNameFillWithCoordName(resultItem) {
        if (resultItem.name == null) // Duplication will be removed in the next step.
        resultItem.name = resultItem.coordDim;
    }
    // Set dim `name` and other `coordDim` and other props.
    if (!omitUnusedDimensions) for(var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++){
        var resultItem = getResultItem(resultDimIdx);
        var coordDim = resultItem.coordDim;
        if (coordDim == null) {
            // TODO no need to generate coordDim for isExtraCoord?
            resultItem.coordDim = $02c5dbb1162b825d$var$genCoordDimName(extra, coordDimNameMap, fromZero);
            resultItem.coordDimIndex = 0;
            // Series specified generateCoord is using out.
            if (!generateCoord || generateCoordCount <= 0) resultItem.isExtraCoord = true;
            generateCoordCount--;
        }
        ifNoNameFillWithCoordName(resultItem);
        if (resultItem.type == null && ((0, $669a01b8661bdd13$export$c51adf1a2be01b9c)(source, resultDimIdx) === (0, $669a01b8661bdd13$export$328749e9c5b40760).Must || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) resultItem.type = 'ordinal';
    }
    else {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(resultList, function(resultItem) {
            // PENDING: guessOrdinal or let user specify type: 'ordinal' manually?
            ifNoNameFillWithCoordName(resultItem);
        });
        // Sort dimensions: there are some rule that use the last dim as label,
        // and for some latter travel process easier.
        resultList.sort(function(item0, item1) {
            return item0.storeDimIndex - item1.storeDimIndex;
        });
    }
    $02c5dbb1162b825d$var$removeDuplication(resultList);
    return new (0, $8233286fea22402d$export$a1ef064685775f3e)({
        source: source,
        dimensions: resultList,
        fullDimensionCount: dimCount,
        dimensionOmitted: omitUnusedDimensions
    });
}
function $02c5dbb1162b825d$var$removeDuplication(result) {
    var duplicationMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    for(var i = 0; i < result.length; i++){
        var dim = result[i];
        var dimOriginalName = dim.name;
        var count = duplicationMap.get(dimOriginalName) || 0;
        if (count > 0) // Starts from 0.
        dim.name = dimOriginalName + (count - 1);
        count++;
        duplicationMap.set(dimOriginalName, count);
    }
}
// ??? TODO
// Originally detect dimCount by data[0]. Should we
// optimize it to only by sysDims and dimensions and encode.
// So only necessary dims will be initialized.
// But
// (1) custom series should be considered. where other dims
// may be visited.
// (2) sometimes user need to calculate bubble size or use visualMap
// on other dimensions besides coordSys needed.
// So, dims that is not used by system, should be shared in data store?
function $02c5dbb1162b825d$var$getDimCount(source, sysDims, dimsDef, optDimCount) {
    // Note that the result dimCount should not small than columns count
    // of data, otherwise `dataDimNameMap` checking will be incorrect.
    var dimCount = Math.max(source.dimensionsDetectedCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(sysDims, function(sysDimItem) {
        var sysDimItemDimsDef;
        if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(sysDimItem) && (sysDimItemDimsDef = sysDimItem.dimsDef)) dimCount = Math.max(dimCount, sysDimItemDimsDef.length);
    });
    return dimCount;
}
function $02c5dbb1162b825d$var$genCoordDimName(name, map, fromZero) {
    if (fromZero || map.hasKey(name)) {
        var i = 0;
        while(map.hasKey(name + i))i++;
        name += i;
    }
    map.set(name, true);
    return name;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Helper for model references.
 * There are many manners to refer axis/coordSys.
 */ // TODO
// merge relevant logic to this file?
// check: "modelHelper" of tooltip and "BrushTargetManager".


/**
 * @class
 * For example:
 * {
 *     coordSysName: 'cartesian2d',
 *     coordSysDims: ['x', 'y', ...],
 *     axisMap: HashMap({
 *         x: xAxisModel,
 *         y: yAxisModel
 *     }),
 *     categoryAxisMap: HashMap({
 *         x: xAxisModel,
 *         y: undefined
 *     }),
 *     // The index of the first category axis in `coordSysDims`.
 *     // `null/undefined` means no category axis exists.
 *     firstCategoryDimIndex: 1,
 *     // To replace user specified encode.
 * }
 */ var $61809454471b7c8b$var$CoordSysInfo = /** @class */ function() {
    function CoordSysInfo(coordSysName) {
        this.coordSysDims = [];
        this.axisMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        this.categoryAxisMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        this.coordSysName = coordSysName;
    }
    return CoordSysInfo;
}();
function $61809454471b7c8b$export$f2befeb2f4933656(seriesModel) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var result = new $61809454471b7c8b$var$CoordSysInfo(coordSysName);
    var fetch = $61809454471b7c8b$var$fetchers[coordSysName];
    if (fetch) {
        fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
        return result;
    }
}
var $61809454471b7c8b$var$fetchers = {
    cartesian2d: function(seriesModel, result, axisMap, categoryAxisMap) {
        var xAxisModel = seriesModel.getReferringComponents('xAxis', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        var yAxisModel = seriesModel.getReferringComponents('yAxis', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'x',
            'y'
        ];
        axisMap.set('x', xAxisModel);
        axisMap.set('y', yAxisModel);
        if ($61809454471b7c8b$var$isCategory(xAxisModel)) {
            categoryAxisMap.set('x', xAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($61809454471b7c8b$var$isCategory(yAxisModel)) {
            categoryAxisMap.set('y', yAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    singleAxis: function(seriesModel, result, axisMap, categoryAxisMap) {
        var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        result.coordSysDims = [
            'single'
        ];
        axisMap.set('single', singleAxisModel);
        if ($61809454471b7c8b$var$isCategory(singleAxisModel)) {
            categoryAxisMap.set('single', singleAxisModel);
            result.firstCategoryDimIndex = 0;
        }
    },
    polar: function(seriesModel, result, axisMap, categoryAxisMap) {
        var polarModel = seriesModel.getReferringComponents('polar', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
        var angleAxisModel = polarModel.findAxisModel('angleAxis');
        result.coordSysDims = [
            'radius',
            'angle'
        ];
        axisMap.set('radius', radiusAxisModel);
        axisMap.set('angle', angleAxisModel);
        if ($61809454471b7c8b$var$isCategory(radiusAxisModel)) {
            categoryAxisMap.set('radius', radiusAxisModel);
            result.firstCategoryDimIndex = 0;
        }
        if ($61809454471b7c8b$var$isCategory(angleAxisModel)) {
            categoryAxisMap.set('angle', angleAxisModel);
            result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
        }
    },
    geo: function(seriesModel, result, axisMap, categoryAxisMap) {
        result.coordSysDims = [
            'lng',
            'lat'
        ];
    },
    parallel: function(seriesModel, result, axisMap, categoryAxisMap) {
        var ecModel = seriesModel.ecModel;
        var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
        var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(parallelModel.parallelAxisIndex, function(axisIndex, index) {
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axisDim = coordSysDims[index];
            axisMap.set(axisDim, axisModel);
            if ($61809454471b7c8b$var$isCategory(axisModel)) {
                categoryAxisMap.set(axisDim, axisModel);
                if (result.firstCategoryDimIndex == null) result.firstCategoryDimIndex = index;
            }
        });
    }
};
function $61809454471b7c8b$var$isCategory(axisModel) {
    return axisModel.get('type') === 'category';
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $495dfc021fe3a3f7$export$f2165f9e8499b278(seriesModel, dimensionsInput, opt) {
    opt = opt || {};
    var byIndex = opt.byIndex;
    var stackedCoordDimension = opt.stackedCoordDimension;
    var dimensionDefineList;
    var schema;
    var store;
    if ($495dfc021fe3a3f7$var$isLegacyDimensionsInput(dimensionsInput)) dimensionDefineList = dimensionsInput;
    else {
        schema = dimensionsInput.schema;
        dimensionDefineList = schema.dimensions;
        store = dimensionsInput.store;
    }
    // Compatibal: when `stack` is set as '', do not stack.
    var mayStack = !!(seriesModel && seriesModel.get('stack'));
    var stackedByDimInfo;
    var stackedDimInfo;
    var stackResultDimension;
    var stackedOverDimension;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo, index) {
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(dimensionInfo)) dimensionDefineList[index] = dimensionInfo = {
            name: dimensionInfo
        };
        if (mayStack && !dimensionInfo.isExtraCoord) {
            // Find the first ordinal dimension as the stackedByDimInfo.
            if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) stackedByDimInfo = dimensionInfo;
            // Find the first stackable dimension as the stackedDimInfo.
            if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) stackedDimInfo = dimensionInfo;
        }
    });
    if (stackedDimInfo && !byIndex && !stackedByDimInfo) // Compatible with previous design, value axis (time axis) only stack by index.
    // It may make sense if the user provides elaborately constructed data.
    byIndex = true;
    // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
    // That put stack logic in List is for using conveniently in echarts extensions, but it
    // might not be a good way.
    if (stackedDimInfo) {
        // Use a weird name that not duplicated with other names.
        // Also need to use seriesModel.id as postfix because different
        // series may share same data store. The stack dimension needs to be distinguished.
        stackResultDimension = '__\0ecstackresult_' + seriesModel.id;
        stackedOverDimension = '__\0ecstackedover_' + seriesModel.id;
        // Create inverted index to fast query index by value.
        if (stackedByDimInfo) stackedByDimInfo.createInvertedIndices = true;
        var stackedDimCoordDim_1 = stackedDimInfo.coordDim;
        var stackedDimType = stackedDimInfo.type;
        var stackedDimCoordIndex_1 = 0;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dimensionDefineList, function(dimensionInfo) {
            if (dimensionInfo.coordDim === stackedDimCoordDim_1) stackedDimCoordIndex_1++;
        });
        var stackedOverDimensionDefine = {
            name: stackResultDimension,
            coordDim: stackedDimCoordDim_1,
            coordDimIndex: stackedDimCoordIndex_1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length
        };
        var stackResultDimensionDefine = {
            name: stackedOverDimension,
            // This dimension contains stack base (generally, 0), so do not set it as
            // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
            coordDim: stackedOverDimension,
            coordDimIndex: stackedDimCoordIndex_1 + 1,
            type: stackedDimType,
            isExtraCoord: true,
            isCalculationCoord: true,
            storeDimIndex: dimensionDefineList.length + 1
        };
        if (schema) {
            if (store) {
                stackedOverDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackedOverDimension, stackedDimType);
                stackResultDimensionDefine.storeDimIndex = store.ensureCalculationDimension(stackResultDimension, stackedDimType);
            }
            schema.appendCalculationDimension(stackedOverDimensionDefine);
            schema.appendCalculationDimension(stackResultDimensionDefine);
        } else {
            dimensionDefineList.push(stackedOverDimensionDefine);
            dimensionDefineList.push(stackResultDimensionDefine);
        }
    }
    return {
        stackedDimension: stackedDimInfo && stackedDimInfo.name,
        stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
        isStackedByIndex: byIndex,
        stackedOverDimension: stackedOverDimension,
        stackResultDimension: stackResultDimension
    };
}
function $495dfc021fe3a3f7$var$isLegacyDimensionsInput(dimensionsInput) {
    return !(0, $8233286fea22402d$export$fafbc856132a3a0e)(dimensionsInput.schema);
}
function $495dfc021fe3a3f7$export$1dedc39359ae35c(data, stackedDim) {
    // Each single series only maps to one pair of axis. So we do not need to
    // check stackByDim, whatever stacked by a dimension or stacked by index.
    return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension');
}
function $495dfc021fe3a3f7$export$909db2be4938fbdf(data, targetDim) {
    return $495dfc021fe3a3f7$export$1dedc39359ae35c(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
}




function $82d36b0ba2609dcb$var$getCoordSysDimDefs(seriesModel, coordSysInfo) {
    var coordSysName = seriesModel.get('coordinateSystem');
    var registeredCoordSys = (0, $02d04429d2792472$export$2e2bcd8739ae039).get(coordSysName);
    var coordSysDimDefs;
    if (coordSysInfo && coordSysInfo.coordSysDims) coordSysDimDefs = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(coordSysInfo.coordSysDims, function(dim) {
        var dimInfo = {
            name: dim
        };
        var axisModel = coordSysInfo.axisMap.get(dim);
        if (axisModel) {
            var axisType = axisModel.get('type');
            dimInfo.type = (0, $e1ef773174d5a33a$export$af1622903e71278e)(axisType);
        }
        return dimInfo;
    });
    if (!coordSysDimDefs) // Get dimensions from registered coordinate system
    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || [
        'x',
        'y'
    ];
    return coordSysDimDefs;
}
function $82d36b0ba2609dcb$var$injectOrdinalMeta(dimInfoList, createInvertedIndices, coordSysInfo) {
    var firstCategoryDimIndex;
    var hasNameEncode;
    coordSysInfo && $1b239fc9d3a2f8ae$export$79b2f7037acddd43(dimInfoList, function(dimInfo, dimIndex) {
        var coordDim = dimInfo.coordDim;
        var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
        if (categoryAxisModel) {
            if (firstCategoryDimIndex == null) firstCategoryDimIndex = dimIndex;
            dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
            if (createInvertedIndices) dimInfo.createInvertedIndices = true;
        }
        if (dimInfo.otherDims.itemName != null) hasNameEncode = true;
    });
    if (!hasNameEncode && firstCategoryDimIndex != null) dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
    return firstCategoryDimIndex;
}
/**
 * Caution: there are side effects to `sourceManager` in this method.
 * Should better only be called in `Series['getInitialData']`.
 */ function $82d36b0ba2609dcb$var$createSeriesData(sourceRaw, seriesModel, opt) {
    opt = opt || {};
    var sourceManager = seriesModel.getSourceManager();
    var source;
    var isOriginalSource = false;
    if (sourceRaw) {
        isOriginalSource = true;
        source = (0, $107136d10fa2cf04$export$75aef3f97c0a5edf)(sourceRaw);
    } else {
        source = sourceManager.getSource();
        // Is series.data. not dataset.
        isOriginalSource = source.sourceFormat === (0, $369d2fc585e5938e$export$2823037fb9d8f0c6);
    }
    var coordSysInfo = (0, $61809454471b7c8b$export$f2befeb2f4933656)(seriesModel);
    var coordSysDimDefs = $82d36b0ba2609dcb$var$getCoordSysDimDefs(seriesModel, coordSysInfo);
    var useEncodeDefaulter = opt.useEncodeDefaulter;
    var encodeDefaulter = $1b239fc9d3a2f8ae$export$f6e2535fb5126e54(useEncodeDefaulter) ? useEncodeDefaulter : useEncodeDefaulter ? $1b239fc9d3a2f8ae$export$c3095a23b368d1f2((0, $669a01b8661bdd13$export$37682b8fdd2e83d), coordSysDimDefs, seriesModel) : null;
    var createDimensionOptions = {
        coordDimensions: coordSysDimDefs,
        generateCoord: opt.generateCoord,
        encodeDefine: seriesModel.getEncode(),
        encodeDefaulter: encodeDefaulter,
        canOmitUnusedDimensions: !isOriginalSource
    };
    var schema = (0, $02c5dbb1162b825d$export$2e2bcd8739ae039)(source, createDimensionOptions);
    var firstCategoryDimIndex = $82d36b0ba2609dcb$var$injectOrdinalMeta(schema.dimensions, opt.createInvertedIndices, coordSysInfo);
    var store = !isOriginalSource ? sourceManager.getSharedDataStore(schema) : null;
    var stackCalculationInfo = (0, $495dfc021fe3a3f7$export$f2165f9e8499b278)(seriesModel, {
        schema: schema,
        store: store
    });
    var data = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(schema, seriesModel);
    data.setCalculationInfo(stackCalculationInfo);
    var dimValueGetter = firstCategoryDimIndex != null && $82d36b0ba2609dcb$var$isNeedCompleteOrdinalData(source) ? function(itemOpt, dimName, dataIndex, dimIndex) {
        // Use dataIndex as ordinal value in categoryAxis
        return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
    } : null;
    data.hasItemOption = false;
    data.initData(// Try to reuse the data store in sourceManager if using dataset.
    isOriginalSource ? source : store, null, dimValueGetter);
    return data;
}
function $82d36b0ba2609dcb$var$isNeedCompleteOrdinalData(source) {
    if (source.sourceFormat === (0, $369d2fc585e5938e$export$2823037fb9d8f0c6)) {
        var sampleItem = $82d36b0ba2609dcb$var$firstDataNotNull(source.data || []);
        return !$1b239fc9d3a2f8ae$export$43bee75e5e14138e((0, $9ac03c46e8b6e711$export$2c944e12edb48d4b)(sampleItem));
    }
}
function $82d36b0ba2609dcb$var$firstDataNotNull(arr) {
    var i = 0;
    while(i < arr.length && arr[i] == null)i++;
    return arr[i];
}
var $82d36b0ba2609dcb$export$2e2bcd8739ae039 = $82d36b0ba2609dcb$var$createSeriesData;





var $db0d1c534c1bd5bb$var$LineSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LineSeriesModel, _super);
    function LineSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LineSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    LineSeriesModel.prototype.getInitialData = function(option) {
        var coordSys;
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    LineSeriesModel.prototype.getLegendIcon = function(opt) {
        var group = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
        var line = (0, $da6220012439db7b$export$af050e04da3a02e8)('line', 0, opt.itemHeight / 2, opt.itemWidth, 0, opt.lineStyle.stroke, false);
        group.add(line);
        line.setStyle(opt.lineStyle);
        var visualType = this.getData().getVisual('symbol');
        var visualRotate = this.getData().getVisual('symbolRotate');
        var symbolType = visualType === 'none' ? 'circle' : visualType;
        // Symbol size is 80% when there is a line
        var size = opt.itemHeight * 0.8;
        var symbol = (0, $da6220012439db7b$export$af050e04da3a02e8)(symbolType, (opt.itemWidth - size) / 2, (opt.itemHeight - size) / 2, size, size, opt.itemStyle.fill);
        group.add(symbol);
        symbol.setStyle(opt.itemStyle);
        var symbolRotate = opt.iconRotate === 'inherit' ? visualRotate : opt.iconRotate || 0;
        symbol.rotation = symbolRotate * Math.PI / 180;
        symbol.setOrigin([
            opt.itemWidth / 2,
            opt.itemHeight / 2
        ]);
        if (symbolType.indexOf('empty') > -1) {
            symbol.style.stroke = symbol.style.fill;
            symbol.style.fill = '#fff';
            symbol.style.lineWidth = 2;
        }
        return group;
    };
    LineSeriesModel.type = 'series.line';
    LineSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    LineSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 3,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        clip: true,
        label: {
            position: 'top'
        },
        // itemStyle: {
        // },
        endLabel: {
            show: false,
            valueAnimation: true,
            distance: 8
        },
        lineStyle: {
            width: 2,
            type: 'solid'
        },
        emphasis: {
            scale: true
        },
        // areaStyle: {
        // origin of areaStyle. Valid values:
        // `'auto'/null/undefined`: from axisLine to data
        // `'start'`: from min to data
        // `'end'`: from data to max
        // origin: 'auto'
        // },
        // false, 'start', 'end', 'middle'
        step: false,
        // Disabled if step is true
        smooth: false,
        smoothMonotone: null,
        symbol: 'emptyCircle',
        symbolSize: 4,
        symbolRotate: null,
        showSymbol: true,
        // `false`: follow the label interval strategy.
        // `true`: show all symbols.
        // `'auto'`: If possible, show all symbols, otherwise
        //           follow the label interval strategy.
        showAllSymbol: 'auto',
        // Whether to connect break point.
        connectNulls: false,
        // Sampling for large data. Can be: 'average', 'max', 'min', 'sum', 'lttb'.
        sampling: 'none',
        animationEasing: 'linear',
        // Disable progressive
        progressive: 0,
        hoverLayerThreshold: Infinity,
        universalTransition: {
            divideShape: 'clone'
        },
        triggerLineEvent: false
    };
    return LineSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $db0d1c534c1bd5bb$export$2e2bcd8739ae039 = $db0d1c534c1bd5bb$var$LineSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $3aa4a91235bead55$export$5ff20667590927ed(data, dataIndex) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    var len = labelDims.length;
    // Simple optimization (in lots of cases, label dims length is 1)
    if (len === 1) {
        var rawVal = (0, $a0d276c4568d5ef4$export$cde9373da9aad801)(data, dataIndex, labelDims[0]);
        return rawVal != null ? rawVal + '' : null;
    } else if (len) {
        var vals = [];
        for(var i = 0; i < labelDims.length; i++)vals.push((0, $a0d276c4568d5ef4$export$cde9373da9aad801)(data, dataIndex, labelDims[i]));
        return vals.join(' ');
    }
}
function $3aa4a91235bead55$export$5f84815e91ca6775(data, interpolatedValue) {
    var labelDims = data.mapDimensionsAll('defaultedLabel');
    if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(interpolatedValue)) return interpolatedValue + '';
    var vals = [];
    for(var i = 0; i < labelDims.length; i++){
        var dimIndex = data.getDimensionIndex(labelDims[i]);
        if (dimIndex >= 0) vals.push(interpolatedValue[dimIndex]);
    }
    return vals.join(' ');
}






var $6864622a33ae23ca$var$Symbol = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Symbol, _super);
    function Symbol(data, idx, seriesScope, opts) {
        var _this = _super.call(this) || this;
        _this.updateData(data, idx, seriesScope, opts);
        return _this;
    }
    Symbol.prototype._createSymbol = function(symbolType, data, idx, symbolSize, keepAspect) {
        // Remove paths created before
        this.removeAll();
        // let symbolPath = createSymbol(
        //     symbolType, -0.5, -0.5, 1, 1, color
        // );
        // If width/height are set too small (e.g., set to 1) on ios10
        // and macOS Sierra, a circle stroke become a rect, no matter what
        // the scale is set. So we set width/height as 2. See #4150.
        var symbolPath = (0, $da6220012439db7b$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, null, keepAspect);
        symbolPath.attr({
            z2: 100,
            culling: true,
            scaleX: symbolSize[0] / 2,
            scaleY: symbolSize[1] / 2
        });
        // Rewrite drift method
        symbolPath.drift = $6864622a33ae23ca$var$driftSymbol;
        this._symbolType = symbolType;
        this.add(symbolPath);
    };
    /**
   * Stop animation
   * @param {boolean} toLastFrame
   */ Symbol.prototype.stopSymbolAnimation = function(toLastFrame) {
        this.childAt(0).stopAnimation(null, toLastFrame);
    };
    Symbol.prototype.getSymbolType = function() {
        return this._symbolType;
    };
    /**
   * FIXME:
   * Caution: This method breaks the encapsulation of this module,
   * but it indeed brings convenience. So do not use the method
   * unless you detailedly know all the implements of `Symbol`,
   * especially animation.
   *
   * Get symbol path element.
   */ Symbol.prototype.getSymbolPath = function() {
        return this.childAt(0);
    };
    /**
   * Highlight symbol
   */ Symbol.prototype.highlight = function() {
        (0, $b414df7d361a211c$export$b2d02638cc34c042)(this.childAt(0));
    };
    /**
   * Downplay symbol
   */ Symbol.prototype.downplay = function() {
        (0, $b414df7d361a211c$export$11be6f716239ac55)(this.childAt(0));
    };
    /**
   * @param {number} zlevel
   * @param {number} z
   */ Symbol.prototype.setZ = function(zlevel, z) {
        var symbolPath = this.childAt(0);
        symbolPath.zlevel = zlevel;
        symbolPath.z = z;
    };
    Symbol.prototype.setDraggable = function(draggable, hasCursorOption) {
        var symbolPath = this.childAt(0);
        symbolPath.draggable = draggable;
        symbolPath.cursor = !hasCursorOption && draggable ? 'move' : symbolPath.cursor;
    };
    /**
   * Update symbol properties
   */ Symbol.prototype.updateData = function(data, idx, seriesScope, opts) {
        this.silent = false;
        var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
        var seriesModel = data.hostModel;
        var symbolSize = Symbol.getSymbolSize(data, idx);
        var isInit = symbolType !== this._symbolType;
        var disableAnimation = opts && opts.disableAnimation;
        if (isInit) {
            var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
            this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
        } else {
            var symbolPath = this.childAt(0);
            symbolPath.silent = false;
            var target = {
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2
            };
            disableAnimation ? symbolPath.attr(target) : $b40111164617dd60$export$c8dce3c08436e91e(symbolPath, target, seriesModel, idx);
            (0, $b40111164617dd60$export$bca7290a9faf0ec9)(symbolPath);
        }
        this._updateCommon(data, idx, symbolSize, seriesScope, opts);
        if (isInit) {
            var symbolPath = this.childAt(0);
            if (!disableAnimation) {
                var target = {
                    scaleX: this._sizeX,
                    scaleY: this._sizeY,
                    style: {
                        // Always fadeIn. Because it has fadeOut animation when symbol is removed..
                        opacity: symbolPath.style.opacity
                    }
                };
                symbolPath.scaleX = symbolPath.scaleY = 0;
                symbolPath.style.opacity = 0;
                $b40111164617dd60$export$a121566aadcfe021(symbolPath, target, seriesModel, idx);
            }
        }
        if (disableAnimation) // Must stop leave transition manually if don't call initProps or updateProps.
        this.childAt(0).stopAnimation('leave');
    };
    Symbol.prototype._updateCommon = function(data, idx, symbolSize, seriesScope, opts) {
        var symbolPath = this.childAt(0);
        var seriesModel = data.hostModel;
        var emphasisItemStyle;
        var blurItemStyle;
        var selectItemStyle;
        var focus;
        var blurScope;
        var emphasisDisabled;
        var labelStatesModels;
        var hoverScale;
        var cursorStyle;
        if (seriesScope) {
            emphasisItemStyle = seriesScope.emphasisItemStyle;
            blurItemStyle = seriesScope.blurItemStyle;
            selectItemStyle = seriesScope.selectItemStyle;
            focus = seriesScope.focus;
            blurScope = seriesScope.blurScope;
            labelStatesModels = seriesScope.labelStatesModels;
            hoverScale = seriesScope.hoverScale;
            cursorStyle = seriesScope.cursorStyle;
            emphasisDisabled = seriesScope.emphasisDisabled;
        }
        if (!seriesScope || data.hasItemOption) {
            var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            selectItemStyle = itemModel.getModel([
                'select',
                'itemStyle'
            ]).getItemStyle();
            blurItemStyle = itemModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            emphasisDisabled = emphasisModel.get('disabled');
            labelStatesModels = (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel);
            hoverScale = emphasisModel.getShallow('scale');
            cursorStyle = itemModel.getShallow('cursor');
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
        var symbolOffset = (0, $da6220012439db7b$export$e3e292895c033f6d)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            symbolPath.x = symbolOffset[0];
            symbolPath.y = symbolOffset[1];
        }
        cursorStyle && symbolPath.attr('cursor', cursorStyle);
        var symbolStyle = data.getItemVisual(idx, 'style');
        var visualColor = symbolStyle.fill;
        if (symbolPath instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) {
            var pathStyle = symbolPath.style;
            symbolPath.useStyle((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolStyle));
        } else {
            if (symbolPath.__isEmptyBrush) // fill and stroke will be swapped if it's empty.
            // So we cloned a new style to avoid it affecting the original style in visual storage.
            // TODO Better implementation. No empty logic!
            symbolPath.useStyle((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, symbolStyle));
            else symbolPath.useStyle(symbolStyle);
            // Disable decal because symbol scale will been applied on the decal.
            symbolPath.style.decal = null;
            symbolPath.setColor(visualColor, opts && opts.symbolInnerColor);
            symbolPath.style.strokeNoScale = true;
        }
        var liftZ = data.getItemVisual(idx, 'liftZ');
        var z2Origin = this._z2;
        if (liftZ != null) {
            if (z2Origin == null) {
                this._z2 = symbolPath.z2;
                symbolPath.z2 += liftZ;
            }
        } else if (z2Origin != null) {
            symbolPath.z2 = z2Origin;
            this._z2 = null;
        }
        var useNameLabel = opts && opts.useNameLabel;
        (0, $3828198b2f2de836$export$9a13992917966657)(symbolPath, labelStatesModels, {
            labelFetcher: seriesModel,
            labelDataIndex: idx,
            defaultText: getLabelDefaultText,
            inheritColor: visualColor,
            defaultOpacity: symbolStyle.opacity
        });
        // Do not execute util needed.
        function getLabelDefaultText(idx) {
            return useNameLabel ? data.getName(idx) : (0, $3aa4a91235bead55$export$5ff20667590927ed)(data, idx);
        }
        this._sizeX = symbolSize[0] / 2;
        this._sizeY = symbolSize[1] / 2;
        var emphasisState = symbolPath.ensureState('emphasis');
        emphasisState.style = emphasisItemStyle;
        symbolPath.ensureState('select').style = selectItemStyle;
        symbolPath.ensureState('blur').style = blurItemStyle;
        // null / undefined / true means to use default strategy.
        // 0 / false / negative number / NaN / Infinity means no scale.
        var scaleRatio = hoverScale == null || hoverScale === true ? Math.max(1.1, 3 / this._sizeY) : isFinite(hoverScale) && hoverScale > 0 ? +hoverScale : 1;
        // always set scale to allow resetting
        emphasisState.scaleX = this._sizeX * scaleRatio;
        emphasisState.scaleY = this._sizeY * scaleRatio;
        this.setSymbolScale(1);
        (0, $b414df7d361a211c$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Symbol.prototype.setSymbolScale = function(scale) {
        this.scaleX = this.scaleY = scale;
    };
    Symbol.prototype.fadeOut = function(cb, seriesModel, opt) {
        var symbolPath = this.childAt(0);
        var dataIndex = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(this).dataIndex;
        var animationOpt = opt && opt.animation;
        // Avoid mistaken hover when fading out
        this.silent = symbolPath.silent = true;
        // Not show text when animating
        if (opt && opt.fadeLabel) {
            var textContent = symbolPath.getTextContent();
            if (textContent) $b40111164617dd60$export$f883456a56996078(textContent, {
                style: {
                    opacity: 0
                }
            }, seriesModel, {
                dataIndex: dataIndex,
                removeOpt: animationOpt,
                cb: function() {
                    symbolPath.removeTextContent();
                }
            });
        } else symbolPath.removeTextContent();
        $b40111164617dd60$export$f883456a56996078(symbolPath, {
            style: {
                opacity: 0
            },
            scaleX: 0,
            scaleY: 0
        }, seriesModel, {
            dataIndex: dataIndex,
            cb: cb,
            removeOpt: animationOpt
        });
    };
    Symbol.getSymbolSize = function(data, idx) {
        return (0, $da6220012439db7b$export$a84524f03e8e8dfb)(data.getItemVisual(idx, 'symbolSize'));
    };
    return Symbol;
}($6c313c3ef6000a43$export$2e2bcd8739ae039);
function $6864622a33ae23ca$var$driftSymbol(dx, dy) {
    this.parent.drift(dx, dy);
}
var $6864622a33ae23ca$export$2e2bcd8739ae039 = $6864622a33ae23ca$var$Symbol;




function $89a14c17b9971b0f$var$symbolNeedsDraw(data, point, idx, opt) {
    return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
}
function $89a14c17b9971b0f$var$normalizeUpdateOpt(opt) {
    if (opt != null && !(0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(opt)) opt = {
        isIgnore: opt
    };
    return opt || {};
}
function $89a14c17b9971b0f$var$makeSeriesScope(data) {
    var seriesModel = data.hostModel;
    var emphasisModel = seriesModel.getModel('emphasis');
    return {
        emphasisItemStyle: emphasisModel.getModel('itemStyle').getItemStyle(),
        blurItemStyle: seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle(),
        selectItemStyle: seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle(),
        focus: emphasisModel.get('focus'),
        blurScope: emphasisModel.get('blurScope'),
        emphasisDisabled: emphasisModel.get('disabled'),
        hoverScale: emphasisModel.get('scale'),
        labelStatesModels: (0, $3828198b2f2de836$export$9739a32674be5893)(seriesModel),
        cursorStyle: seriesModel.get('cursor')
    };
}
var $89a14c17b9971b0f$var$SymbolDraw = /** @class */ function() {
    function SymbolDraw(SymbolCtor) {
        this.group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this._SymbolCtor = SymbolCtor || (0, $6864622a33ae23ca$export$2e2bcd8739ae039);
    }
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.updateData = function(data, opt) {
        // Remove progressive els.
        this._progressiveEls = null;
        opt = $89a14c17b9971b0f$var$normalizeUpdateOpt(opt);
        var group = this.group;
        var seriesModel = data.hostModel;
        var oldData = this._data;
        var SymbolCtor = this._SymbolCtor;
        var disableAnimation = opt.disableAnimation;
        var seriesScope = $89a14c17b9971b0f$var$makeSeriesScope(data);
        var symbolUpdateOpt = {
            disableAnimation: disableAnimation
        };
        var getSymbolPoint = opt.getSymbolPoint || function(idx) {
            return data.getItemLayout(idx);
        };
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldData) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            var point = getSymbolPoint(newIdx);
            if ($89a14c17b9971b0f$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                var symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            var point = getSymbolPoint(newIdx);
            if (!$89a14c17b9971b0f$var$symbolNeedsDraw(data, point, newIdx, opt)) {
                group.remove(symbolEl);
                return;
            }
            var newSymbolType = data.getItemVisual(newIdx, 'symbol') || 'circle';
            var oldSymbolType = symbolEl && symbolEl.getSymbolType && symbolEl.getSymbolType();
            if (!symbolEl || oldSymbolType && oldSymbolType !== newSymbolType) {
                group.remove(symbolEl);
                symbolEl = new SymbolCtor(data, newIdx, seriesScope, symbolUpdateOpt);
                symbolEl.setPosition(point);
            } else {
                symbolEl.updateData(data, newIdx, seriesScope, symbolUpdateOpt);
                var target = {
                    x: point[0],
                    y: point[1]
                };
                disableAnimation ? symbolEl.attr(target) : $b40111164617dd60$export$c8dce3c08436e91e(symbolEl, target, seriesModel);
            }
            // Add back
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && el.fadeOut(function() {
                group.remove(el);
            }, seriesModel);
        }).execute();
        this._getSymbolPoint = getSymbolPoint;
        this._data = data;
    };
    SymbolDraw.prototype.updateLayout = function() {
        var _this = this;
        var data = this._data;
        if (data) // Not use animation
        data.eachItemGraphicEl(function(el, idx) {
            var point = _this._getSymbolPoint(idx);
            el.setPosition(point);
            el.markRedraw();
        });
    };
    SymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._seriesScope = $89a14c17b9971b0f$var$makeSeriesScope(data);
        this._data = null;
        this.group.removeAll();
    };
    /**
   * Update symbols draw by new data
   */ SymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        // Clear
        this._progressiveEls = [];
        opt = $89a14c17b9971b0f$var$normalizeUpdateOpt(opt);
        function updateIncrementalAndHover(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var point = data.getItemLayout(idx);
            if ($89a14c17b9971b0f$var$symbolNeedsDraw(data, point, idx, opt)) {
                var el = new this._SymbolCtor(data, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                el.setPosition(point);
                this.group.add(el);
                data.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    SymbolDraw.prototype.eachRendered = function(cb) {
        $8eb95236e1aa01e7$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    SymbolDraw.prototype.remove = function(enableAnimation) {
        var group = this.group;
        var data = this._data;
        // Incremental model do not have this._data.
        if (data && enableAnimation) data.eachItemGraphicEl(function(el) {
            el.fadeOut(function() {
                group.remove(el);
            }, data.hostModel);
        });
        else group.removeAll();
    };
    return SymbolDraw;
}();
var $89a14c17b9971b0f$export$2e2bcd8739ae039 = $89a14c17b9971b0f$var$SymbolDraw;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $09cfe0e50d7c5a28$export$b488a529581b37e(coordSys, data, valueOrigin) {
    var baseAxis = coordSys.getBaseAxis();
    var valueAxis = coordSys.getOtherAxis(baseAxis);
    var valueStart = $09cfe0e50d7c5a28$var$getValueStart(valueAxis, valueOrigin);
    var baseAxisDim = baseAxis.dim;
    var valueAxisDim = valueAxis.dim;
    var valueDim = data.mapDimension(valueAxisDim);
    var baseDim = data.mapDimension(baseAxisDim);
    var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
    var dims = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(coordSys.dimensions, function(coordDim) {
        return data.mapDimension(coordDim);
    });
    var stacked = false;
    var stackResultDim = data.getCalculationInfo('stackResultDimension');
    if ((0, $495dfc021fe3a3f7$export$1dedc39359ae35c)(data, dims[0])) {
        // jshint ignore:line
        stacked = true;
        dims[0] = stackResultDim;
    }
    if ((0, $495dfc021fe3a3f7$export$1dedc39359ae35c)(data, dims[1])) {
        // jshint ignore:line
        stacked = true;
        dims[1] = stackResultDim;
    }
    return {
        dataDimsForPoint: dims,
        valueStart: valueStart,
        valueAxisDim: valueAxisDim,
        baseAxisDim: baseAxisDim,
        stacked: !!stacked,
        valueDim: valueDim,
        baseDim: baseDim,
        baseDataOffset: baseDataOffset,
        stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
    };
}
function $09cfe0e50d7c5a28$var$getValueStart(valueAxis, valueOrigin) {
    var valueStart = 0;
    var extent = valueAxis.scale.getExtent();
    if (valueOrigin === 'start') valueStart = extent[0];
    else if (valueOrigin === 'end') valueStart = extent[1];
    else if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(valueOrigin) && !isNaN(valueOrigin)) valueStart = valueOrigin;
    else {
        // Both positive
        if (extent[0] > 0) valueStart = extent[0];
        else if (extent[1] < 0) valueStart = extent[1];
    // If is one positive, and one negative, onZero shall be true
    }
    return valueStart;
}
function $09cfe0e50d7c5a28$export$c1601aa630e7b5f8(dataCoordInfo, coordSys, data, idx) {
    var value = NaN;
    if (dataCoordInfo.stacked) value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
    if (isNaN(value)) value = dataCoordInfo.valueStart;
    var baseDataOffset = dataCoordInfo.baseDataOffset;
    var stackedData = [];
    stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
    stackedData[1 - baseDataOffset] = value;
    return coordSys.dataToPoint(stackedData);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/* global Float32Array */ var $015cdaafd8b34e25$var$supportFloat32Array = typeof Float32Array !== 'undefined';
var $015cdaafd8b34e25$var$Float32ArrayCtor = !$015cdaafd8b34e25$var$supportFloat32Array ? Array : Float32Array;
function $015cdaafd8b34e25$export$21d2298f3f56bbaf(arg) {
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(arg)) // Return self directly if don't support TypedArray.
    return $015cdaafd8b34e25$var$supportFloat32Array ? new Float32Array(arg) : arg;
    // Else is number
    return new $015cdaafd8b34e25$var$Float32ArrayCtor(arg);
}


function $e8b11ce12cfee9ed$var$diffData(oldData, newData) {
    var diffResult = [];
    newData.diff(oldData).add(function(idx) {
        diffResult.push({
            cmd: '+',
            idx: idx
        });
    }).update(function(newIdx, oldIdx) {
        diffResult.push({
            cmd: '=',
            idx: oldIdx,
            idx1: newIdx
        });
    }).remove(function(idx) {
        diffResult.push({
            cmd: '-',
            idx: idx
        });
    }).execute();
    return diffResult;
}
function $e8b11ce12cfee9ed$export$2e2bcd8739ae039(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
    var diff = $e8b11ce12cfee9ed$var$diffData(oldData, newData);
    // let newIdList = newData.mapArray(newData.getId);
    // let oldIdList = oldData.mapArray(oldData.getId);
    // convertToIntId(newIdList, oldIdList);
    // // FIXME One data ?
    // diff = arrayDiff(oldIdList, newIdList);
    var currPoints = [];
    var nextPoints = [];
    // Points for stacking base line
    var currStackedPoints = [];
    var nextStackedPoints = [];
    var status = [];
    var sortedIndices = [];
    var rawIndices = [];
    var newDataOldCoordInfo = (0, $09cfe0e50d7c5a28$export$b488a529581b37e)(oldCoordSys, newData, oldValueOrigin);
    // const oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
    var oldPoints = oldData.getLayout('points') || [];
    var newPoints = newData.getLayout('points') || [];
    for(var i = 0; i < diff.length; i++){
        var diffItem = diff[i];
        var pointAdded = true;
        var oldIdx2 = void 0;
        var newIdx2 = void 0;
        // FIXME, animation is not so perfect when dataZoom window moves fast
        // Which is in case remvoing or add more than one data in the tail or head
        switch(diffItem.cmd){
            case '=':
                oldIdx2 = diffItem.idx * 2;
                newIdx2 = diffItem.idx1 * 2;
                var currentX = oldPoints[oldIdx2];
                var currentY = oldPoints[oldIdx2 + 1];
                var nextX = newPoints[newIdx2];
                var nextY = newPoints[newIdx2 + 1];
                // If previous data is NaN, use next point directly
                if (isNaN(currentX) || isNaN(currentY)) {
                    currentX = nextX;
                    currentY = nextY;
                }
                currPoints.push(currentX, currentY);
                nextPoints.push(nextX, nextY);
                currStackedPoints.push(oldStackedOnPoints[oldIdx2], oldStackedOnPoints[oldIdx2 + 1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(diffItem.idx1));
                break;
            case '+':
                var newIdx = diffItem.idx;
                var newDataDimsForPoint = newDataOldCoordInfo.dataDimsForPoint;
                var oldPt = oldCoordSys.dataToPoint([
                    newData.get(newDataDimsForPoint[0], newIdx),
                    newData.get(newDataDimsForPoint[1], newIdx)
                ]);
                newIdx2 = newIdx * 2;
                currPoints.push(oldPt[0], oldPt[1]);
                nextPoints.push(newPoints[newIdx2], newPoints[newIdx2 + 1]);
                var stackedOnPoint = (0, $09cfe0e50d7c5a28$export$c1601aa630e7b5f8)(newDataOldCoordInfo, oldCoordSys, newData, newIdx);
                currStackedPoints.push(stackedOnPoint[0], stackedOnPoint[1]);
                nextStackedPoints.push(newStackedOnPoints[newIdx2], newStackedOnPoints[newIdx2 + 1]);
                rawIndices.push(newData.getRawIndex(newIdx));
                break;
            case '-':
                pointAdded = false;
        }
        // Original indices
        if (pointAdded) {
            status.push(diffItem);
            sortedIndices.push(sortedIndices.length);
        }
    }
    // Diff result may be crossed if all items are changed
    // Sort by data index
    sortedIndices.sort(function(a, b) {
        return rawIndices[a] - rawIndices[b];
    });
    var len = currPoints.length;
    var sortedCurrPoints = (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(len);
    var sortedNextPoints = (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(len);
    var sortedCurrStackedPoints = (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(len);
    var sortedNextStackedPoints = (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(len);
    var sortedStatus = [];
    for(var i = 0; i < sortedIndices.length; i++){
        var idx = sortedIndices[i];
        var i2 = i * 2;
        var idx2 = idx * 2;
        sortedCurrPoints[i2] = currPoints[idx2];
        sortedCurrPoints[i2 + 1] = currPoints[idx2 + 1];
        sortedNextPoints[i2] = nextPoints[idx2];
        sortedNextPoints[i2 + 1] = nextPoints[idx2 + 1];
        sortedCurrStackedPoints[i2] = currStackedPoints[idx2];
        sortedCurrStackedPoints[i2 + 1] = currStackedPoints[idx2 + 1];
        sortedNextStackedPoints[i2] = nextStackedPoints[idx2];
        sortedNextStackedPoints[i2 + 1] = nextStackedPoints[idx2 + 1];
        sortedStatus[i] = status[idx];
    }
    return {
        current: sortedCurrPoints,
        next: sortedNextPoints,
        stackedOnCurrent: sortedCurrStackedPoints,
        stackedOnNext: sortedNextStackedPoints,
        status: sortedStatus
    };
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4994818843f5bc5a$var$mathMin = Math.min;
var $4994818843f5bc5a$var$mathMax = Math.max;
function $4994818843f5bc5a$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
/**
 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
 * situations. This should be used when points are non-monotone neither in x or
 * y dimension.
 */ function $4994818843f5bc5a$var$drawSegment(ctx, points, start, segLen, allLen, dir, smooth, smoothMonotone, connectNulls) {
    var prevX;
    var prevY;
    var cpx0;
    var cpy0;
    var cpx1;
    var cpy1;
    var idx = start;
    var k = 0;
    for(; k < segLen; k++){
        var x = points[idx * 2];
        var y = points[idx * 2 + 1];
        if (idx >= allLen || idx < 0) break;
        if ($4994818843f5bc5a$var$isPointNull(x, y)) {
            if (connectNulls) {
                idx += dir;
                continue;
            }
            break;
        }
        if (idx === start) {
            ctx[dir > 0 ? 'moveTo' : 'lineTo'](x, y);
            cpx0 = x;
            cpy0 = y;
        } else {
            var dx = x - prevX;
            var dy = y - prevY;
            // Ignore tiny segment.
            if (dx * dx + dy * dy < 0.5) {
                idx += dir;
                continue;
            }
            if (smooth > 0) {
                var nextIdx = idx + dir;
                var nextX = points[nextIdx * 2];
                var nextY = points[nextIdx * 2 + 1];
                // Ignore duplicate point
                while(nextX === x && nextY === y && k < segLen){
                    k++;
                    nextIdx += dir;
                    idx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                    x = points[idx * 2];
                    y = points[idx * 2 + 1];
                    dx = x - prevX;
                    dy = y - prevY;
                }
                var tmpK = k + 1;
                if (connectNulls) // Find next point not null
                while($4994818843f5bc5a$var$isPointNull(nextX, nextY) && tmpK < segLen){
                    tmpK++;
                    nextIdx += dir;
                    nextX = points[nextIdx * 2];
                    nextY = points[nextIdx * 2 + 1];
                }
                var ratioNextSeg = 0.5;
                var vx = 0;
                var vy = 0;
                var nextCpx0 = void 0;
                var nextCpy0 = void 0;
                // Is last point
                if (tmpK >= segLen || $4994818843f5bc5a$var$isPointNull(nextX, nextY)) {
                    cpx1 = x;
                    cpy1 = y;
                } else {
                    vx = nextX - prevX;
                    vy = nextY - prevY;
                    var dx0 = x - prevX;
                    var dx1 = nextX - x;
                    var dy0 = y - prevY;
                    var dy1 = nextY - y;
                    var lenPrevSeg = void 0;
                    var lenNextSeg = void 0;
                    if (smoothMonotone === 'x') {
                        lenPrevSeg = Math.abs(dx0);
                        lenNextSeg = Math.abs(dx1);
                        var dir_1 = vx > 0 ? 1 : -1;
                        cpx1 = x - dir_1 * lenPrevSeg * smooth;
                        cpy1 = y;
                        nextCpx0 = x + dir_1 * lenNextSeg * smooth;
                        nextCpy0 = y;
                    } else if (smoothMonotone === 'y') {
                        lenPrevSeg = Math.abs(dy0);
                        lenNextSeg = Math.abs(dy1);
                        var dir_2 = vy > 0 ? 1 : -1;
                        cpx1 = x;
                        cpy1 = y - dir_2 * lenPrevSeg * smooth;
                        nextCpx0 = x;
                        nextCpy0 = y + dir_2 * lenNextSeg * smooth;
                    } else {
                        lenPrevSeg = Math.sqrt(dx0 * dx0 + dy0 * dy0);
                        lenNextSeg = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                        // Use ratio of seg length
                        ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
                        cpx1 = x - vx * smooth * (1 - ratioNextSeg);
                        cpy1 = y - vy * smooth * (1 - ratioNextSeg);
                        // cp0 of next segment
                        nextCpx0 = x + vx * smooth * ratioNextSeg;
                        nextCpy0 = y + vy * smooth * ratioNextSeg;
                        // Smooth constraint between point and next point.
                        // Avoid exceeding extreme after smoothing.
                        nextCpx0 = $4994818843f5bc5a$var$mathMin(nextCpx0, $4994818843f5bc5a$var$mathMax(nextX, x));
                        nextCpy0 = $4994818843f5bc5a$var$mathMin(nextCpy0, $4994818843f5bc5a$var$mathMax(nextY, y));
                        nextCpx0 = $4994818843f5bc5a$var$mathMax(nextCpx0, $4994818843f5bc5a$var$mathMin(nextX, x));
                        nextCpy0 = $4994818843f5bc5a$var$mathMax(nextCpy0, $4994818843f5bc5a$var$mathMin(nextY, y));
                        // Reclaculate cp1 based on the adjusted cp0 of next seg.
                        vx = nextCpx0 - x;
                        vy = nextCpy0 - y;
                        cpx1 = x - vx * lenPrevSeg / lenNextSeg;
                        cpy1 = y - vy * lenPrevSeg / lenNextSeg;
                        // Smooth constraint between point and prev point.
                        // Avoid exceeding extreme after smoothing.
                        cpx1 = $4994818843f5bc5a$var$mathMin(cpx1, $4994818843f5bc5a$var$mathMax(prevX, x));
                        cpy1 = $4994818843f5bc5a$var$mathMin(cpy1, $4994818843f5bc5a$var$mathMax(prevY, y));
                        cpx1 = $4994818843f5bc5a$var$mathMax(cpx1, $4994818843f5bc5a$var$mathMin(prevX, x));
                        cpy1 = $4994818843f5bc5a$var$mathMax(cpy1, $4994818843f5bc5a$var$mathMin(prevY, y));
                        // Adjust next cp0 again.
                        vx = x - cpx1;
                        vy = y - cpy1;
                        nextCpx0 = x + vx * lenNextSeg / lenPrevSeg;
                        nextCpy0 = y + vy * lenNextSeg / lenPrevSeg;
                    }
                }
                ctx.bezierCurveTo(cpx0, cpy0, cpx1, cpy1, x, y);
                cpx0 = nextCpx0;
                cpy0 = nextCpy0;
            } else ctx.lineTo(x, y);
        }
        prevX = x;
        prevY = y;
        idx += dir;
    }
    return k;
}
var $4994818843f5bc5a$var$ECPolylineShape = /** @class */ function() {
    function ECPolylineShape() {
        this.smooth = 0;
        this.smoothConstraint = true;
    }
    return ECPolylineShape;
}();
var $4994818843f5bc5a$export$bf7c0585b8f7d00f = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ECPolyline, _super);
    function ECPolyline(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polyline';
        return _this;
    }
    ECPolyline.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECPolyline.prototype.getDefaultShape = function() {
        return new $4994818843f5bc5a$var$ECPolylineShape();
    };
    ECPolyline.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var i = 0;
        var len = points.length / 2;
        // const result = getBoundingBox(points, shape.smoothConstraint);
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$4994818843f5bc5a$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$4994818843f5bc5a$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len)i += $4994818843f5bc5a$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
    };
    ECPolyline.prototype.getPointOn = function(xOrY, dim) {
        if (!this.path) {
            this.createPathProxy();
            this.buildPath(this.path, this.shape);
        }
        var path = this.path;
        var data = path.data;
        var CMD = (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039).CMD;
        var x0;
        var y0;
        var isDimX = dim === 'x';
        var roots = [];
        for(var i = 0; i < data.length;){
            var cmd = data[i++];
            var x = void 0;
            var y = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var x3 = void 0;
            var y3 = void 0;
            var t = void 0;
            switch(cmd){
                case CMD.M:
                    x0 = data[i++];
                    y0 = data[i++];
                    break;
                case CMD.L:
                    x = data[i++];
                    y = data[i++];
                    t = isDimX ? (xOrY - x0) / (x - x0) : (xOrY - y0) / (y - y0);
                    if (t <= 1 && t >= 0) {
                        var val = isDimX ? (y - y0) * t + y0 : (x - x0) * t + x0;
                        return isDimX ? [
                            xOrY,
                            val
                        ] : [
                            val,
                            xOrY
                        ];
                    }
                    x0 = x;
                    y0 = y;
                    break;
                case CMD.C:
                    x = data[i++];
                    y = data[i++];
                    x2 = data[i++];
                    y2 = data[i++];
                    x3 = data[i++];
                    y3 = data[i++];
                    var nRoot = isDimX ? (0, $eea9463646207a7b$export$ca5d13faa10b167e)(x0, x, x2, x3, xOrY, roots) : (0, $eea9463646207a7b$export$ca5d13faa10b167e)(y0, y, y2, y3, xOrY, roots);
                    if (nRoot > 0) for(var i_1 = 0; i_1 < nRoot; i_1++){
                        var t_1 = roots[i_1];
                        if (t_1 <= 1 && t_1 >= 0) {
                            var val = isDimX ? (0, $eea9463646207a7b$export$547c21de482bbcb2)(y0, y, y2, y3, t_1) : (0, $eea9463646207a7b$export$547c21de482bbcb2)(x0, x, x2, x3, t_1);
                            return isDimX ? [
                                xOrY,
                                val
                            ] : [
                                val,
                                xOrY
                            ];
                        }
                    }
                    x0 = x3;
                    y0 = y3;
                    break;
            }
        }
    };
    return ECPolyline;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
var $4994818843f5bc5a$var$ECPolygonShape = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ECPolygonShape, _super);
    function ECPolygonShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ECPolygonShape;
}($4994818843f5bc5a$var$ECPolylineShape);
var $4994818843f5bc5a$export$6042a400d113f2bd = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ECPolygon, _super);
    function ECPolygon(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-polygon';
        return _this;
    }
    ECPolygon.prototype.getDefaultShape = function() {
        return new $4994818843f5bc5a$var$ECPolygonShape();
    };
    ECPolygon.prototype.buildPath = function(ctx, shape) {
        var points = shape.points;
        var stackedOnPoints = shape.stackedOnPoints;
        var i = 0;
        var len = points.length / 2;
        var smoothMonotone = shape.smoothMonotone;
        if (shape.connectNulls) {
            // Must remove first and last null values avoid draw error in polygon
            for(; len > 0; len--){
                if (!$4994818843f5bc5a$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
            }
            for(; i < len; i++){
                if (!$4994818843f5bc5a$var$isPointNull(points[i * 2], points[i * 2 + 1])) break;
            }
        }
        while(i < len){
            var k = $4994818843f5bc5a$var$drawSegment(ctx, points, i, len, len, 1, shape.smooth, smoothMonotone, shape.connectNulls);
            $4994818843f5bc5a$var$drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
            i += k + 1;
            ctx.closePath();
        }
    };
    return ECPolygon;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $6206a29b0d1240e0$export$83958787eb658d14(cartesian, hasAnimation, seriesModel, done, during) {
    var rect = cartesian.getArea();
    var x = rect.x;
    var y = rect.y;
    var width = rect.width;
    var height = rect.height;
    var lineWidth = seriesModel.get([
        'lineStyle',
        'width'
    ]) || 0;
    // Expand the clip path a bit to avoid the border is clipped and looks thinner
    x -= lineWidth / 2;
    y -= lineWidth / 2;
    width += lineWidth;
    height += lineWidth;
    // fix: https://github.com/apache/incubator-echarts/issues/11369
    width = Math.ceil(width);
    if (x !== Math.floor(x)) {
        x = Math.floor(x);
        // if no extra 1px on `width`, it will still be clipped since `x` is floored
        width++;
    }
    var clipPath = new $37476269d425e3f6$export$2e2bcd8739ae039({
        shape: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    });
    if (hasAnimation) {
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var isAxisInversed = baseAxis.inverse;
        if (isHorizontal) {
            if (isAxisInversed) clipPath.shape.x += width;
            clipPath.shape.width = 0;
        } else {
            if (!isAxisInversed) clipPath.shape.y += height;
            clipPath.shape.height = 0;
        }
        var duringCb = (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(during) ? function(percent) {
            during(percent, clipPath);
        } : null;
        $b40111164617dd60$export$a121566aadcfe021(clipPath, {
            shape: {
                width: width,
                height: height,
                x: x,
                y: y
            }
        }, seriesModel, null, done, duringCb);
    }
    return clipPath;
}
function $6206a29b0d1240e0$export$13dc2b2230df3cb5(polar, hasAnimation, seriesModel) {
    var sectorArea = polar.getArea();
    // Avoid float number rounding error for symbol on the edge of axis extent.
    var r0 = (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(sectorArea.r0, 1);
    var r = (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(sectorArea.r, 1);
    var clipPath = new $5fa26352e0605e60$export$2e2bcd8739ae039({
        shape: {
            cx: (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(polar.cx, 1),
            cy: (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(polar.cy, 1),
            r0: r0,
            r: r,
            startAngle: sectorArea.startAngle,
            endAngle: sectorArea.endAngle,
            clockwise: sectorArea.clockwise
        }
    });
    if (hasAnimation) {
        var isRadial = polar.getBaseAxis().dim === 'angle';
        if (isRadial) clipPath.shape.endAngle = sectorArea.startAngle;
        else clipPath.shape.r = r0;
        $b40111164617dd60$export$a121566aadcfe021(clipPath, {
            shape: {
                endAngle: sectorArea.endAngle,
                r: r
            }
        }, seriesModel);
    }
    return clipPath;
}
function $6206a29b0d1240e0$export$e0fe5081209d01c9(coordSys, hasAnimation, seriesModel, done, during) {
    if (!coordSys) return null;
    else if (coordSys.type === 'polar') return $6206a29b0d1240e0$export$13dc2b2230df3cb5(coordSys, hasAnimation, seriesModel);
    else if (coordSys.type === 'cartesian2d') return $6206a29b0d1240e0$export$83958787eb658d14(coordSys, hasAnimation, seriesModel, done, during);
    return null;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $9ca39efe18dd5899$export$8567506e6336616(coordSys, type) {
    return coordSys.type === type;
}









function $7580519309ffae6a$var$isPointsSame(points1, points2) {
    if (points1.length !== points2.length) return;
    for(var i = 0; i < points1.length; i++){
        if (points1[i] !== points2[i]) return;
    }
    return true;
}
function $7580519309ffae6a$var$bboxFromPoints(points) {
    var minX = Infinity;
    var minY = Infinity;
    var maxX = -Infinity;
    var maxY = -Infinity;
    for(var i = 0; i < points.length;){
        var x = points[i++];
        var y = points[i++];
        if (!isNaN(x)) {
            minX = Math.min(x, minX);
            maxX = Math.max(x, maxX);
        }
        if (!isNaN(y)) {
            minY = Math.min(y, minY);
            maxY = Math.max(y, maxY);
        }
    }
    return [
        [
            minX,
            minY
        ],
        [
            maxX,
            maxY
        ]
    ];
}
function $7580519309ffae6a$var$getBoundingDiff(points1, points2) {
    var _a = $7580519309ffae6a$var$bboxFromPoints(points1), min1 = _a[0], max1 = _a[1];
    var _b = $7580519309ffae6a$var$bboxFromPoints(points2), min2 = _b[0], max2 = _b[1];
    // Get a max value from each corner of two boundings.
    return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
}
function $7580519309ffae6a$var$getSmooth(smooth) {
    return $1b239fc9d3a2f8ae$export$7e4aa119212bc614(smooth) ? smooth : smooth ? 0.5 : 0;
}
function $7580519309ffae6a$var$getStackedOnPoints(coordSys, data, dataCoordInfo) {
    if (!dataCoordInfo.valueDim) return [];
    var len = data.count();
    var points = (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(len * 2);
    for(var idx = 0; idx < len; idx++){
        var pt = (0, $09cfe0e50d7c5a28$export$c1601aa630e7b5f8)(dataCoordInfo, coordSys, data, idx);
        points[idx * 2] = pt[0];
        points[idx * 2 + 1] = pt[1];
    }
    return points;
}
/**
 * Filter the null data and extend data for step considering `stepTurnAt`
 *
 * @param points data to convert, that may containing null
 * @param basePoints base data to reference, used only for areaStyle points
 * @param coordSys coordinate system
 * @param stepTurnAt 'start' | 'end' | 'middle' | true
 * @param connectNulls whether to connect nulls
 * @returns converted point positions
 */ function $7580519309ffae6a$var$turnPointsIntoStep(points, basePoints, coordSys, stepTurnAt, connectNulls) {
    var baseAxis = coordSys.getBaseAxis();
    var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
    var stepPoints = [];
    var i = 0;
    var stepPt = [];
    var pt = [];
    var nextPt = [];
    var filteredPoints = [];
    if (connectNulls) {
        for(i = 0; i < points.length; i += 2){
            /**
       * For areaStyle of stepped lines, `stackedOnPoints` should be
       * filtered the same as `points` so that the base axis values
       * should stay the same as the lines above. See #20021
       */ var reference = basePoints || points;
            if (!isNaN(reference[i]) && !isNaN(reference[i + 1])) filteredPoints.push(points[i], points[i + 1]);
        }
        points = filteredPoints;
    }
    for(i = 0; i < points.length - 2; i += 2){
        nextPt[0] = points[i + 2];
        nextPt[1] = points[i + 3];
        pt[0] = points[i];
        pt[1] = points[i + 1];
        stepPoints.push(pt[0], pt[1]);
        switch(stepTurnAt){
            case 'end':
                stepPt[baseIndex] = nextPt[baseIndex];
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                break;
            case 'middle':
                var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
                var stepPt2 = [];
                stepPt[baseIndex] = stepPt2[baseIndex] = middle;
                stepPt[1 - baseIndex] = pt[1 - baseIndex];
                stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
                stepPoints.push(stepPt2[0], stepPt2[1]);
                break;
            default:
                // default is start
                stepPt[baseIndex] = pt[baseIndex];
                stepPt[1 - baseIndex] = nextPt[1 - baseIndex];
                stepPoints.push(stepPt[0], stepPt[1]);
        }
    }
    // Last points
    stepPoints.push(points[i++], points[i++]);
    return stepPoints;
}
/**
 * Clip color stops to edge. Avoid creating too large gradients.
 * Which may lead to blurry when GPU acceleration is enabled. See #15680
 *
 * The stops has been sorted from small to large.
 */ function $7580519309ffae6a$var$clipColorStops(colorStops, maxSize) {
    var newColorStops = [];
    var len = colorStops.length;
    // coord will always < 0 in prevOutOfRangeColorStop.
    var prevOutOfRangeColorStop;
    var prevInRangeColorStop;
    function lerpStop(stop0, stop1, clippedCoord) {
        var coord0 = stop0.coord;
        var p = (clippedCoord - coord0) / (stop1.coord - coord0);
        var color = (0, $35573db24643e2ef$export$3a89f8d6f6bf6c9f)(p, [
            stop0.color,
            stop1.color
        ]);
        return {
            coord: clippedCoord,
            color: color
        };
    }
    for(var i = 0; i < len; i++){
        var stop_1 = colorStops[i];
        var coord = stop_1.coord;
        if (coord < 0) prevOutOfRangeColorStop = stop_1;
        else if (coord > maxSize) {
            if (prevInRangeColorStop) newColorStops.push(lerpStop(prevInRangeColorStop, stop_1, maxSize));
            else if (prevOutOfRangeColorStop) // If there are two stops and coord range is between these two stops
            newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0), lerpStop(prevOutOfRangeColorStop, stop_1, maxSize));
            break;
        } else {
            if (prevOutOfRangeColorStop) {
                newColorStops.push(lerpStop(prevOutOfRangeColorStop, stop_1, 0));
                // Reset
                prevOutOfRangeColorStop = null;
            }
            newColorStops.push(stop_1);
            prevInRangeColorStop = stop_1;
        }
    }
    return newColorStops;
}
function $7580519309ffae6a$var$getVisualGradient(data, coordSys, api) {
    var visualMetaList = data.getVisual('visualMeta');
    if (!visualMetaList || !visualMetaList.length || !data.count()) // When data.count() is 0, gradient range can not be calculated.
    return;
    if (coordSys.type !== 'cartesian2d') return;
    var coordDim;
    var visualMeta;
    for(var i = visualMetaList.length - 1; i >= 0; i--){
        var dimInfo = data.getDimensionInfo(visualMetaList[i].dimension);
        coordDim = dimInfo && dimInfo.coordDim;
        // Can only be x or y
        if (coordDim === 'x' || coordDim === 'y') {
            visualMeta = visualMetaList[i];
            break;
        }
    }
    if (!visualMeta) return;
    // If the area to be rendered is bigger than area defined by LinearGradient,
    // the canvas spec prescribes that the color of the first stop and the last
    // stop should be used. But if two stops are added at offset 0, in effect
    // browsers use the color of the second stop to render area outside
    // LinearGradient. So we can only infinitesimally extend area defined in
    // LinearGradient to render `outerColors`.
    var axis = coordSys.getAxis(coordDim);
    // dataToCoord mapping may not be linear, but must be monotonic.
    var colorStops = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(visualMeta.stops, function(stop) {
        // offset will be calculated later.
        return {
            coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
            color: stop.color
        };
    });
    var stopLen = colorStops.length;
    var outerColors = visualMeta.outerColors.slice();
    if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
        colorStops.reverse();
        outerColors.reverse();
    }
    var colorStopsInRange = $7580519309ffae6a$var$clipColorStops(colorStops, coordDim === 'x' ? api.getWidth() : api.getHeight());
    var inRangeStopLen = colorStopsInRange.length;
    if (!inRangeStopLen && stopLen) // All stops are out of range. All will be the same color.
    return colorStops[0].coord < 0 ? outerColors[1] ? outerColors[1] : colorStops[stopLen - 1].color : outerColors[0] ? outerColors[0] : colorStops[0].color;
    var tinyExtent = 10; // Arbitrary value: 10px
    var minCoord = colorStopsInRange[0].coord - tinyExtent;
    var maxCoord = colorStopsInRange[inRangeStopLen - 1].coord + tinyExtent;
    var coordSpan = maxCoord - minCoord;
    if (coordSpan < 1e-3) return 'transparent';
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(colorStopsInRange, function(stop) {
        stop.offset = (stop.coord - minCoord) / coordSpan;
    });
    colorStopsInRange.push({
        // NOTE: inRangeStopLen may still be 0 if stoplen is zero.
        offset: inRangeStopLen ? colorStopsInRange[inRangeStopLen - 1].offset : 0.5,
        color: outerColors[1] || 'transparent'
    });
    colorStopsInRange.unshift({
        offset: inRangeStopLen ? colorStopsInRange[0].offset : 0.5,
        color: outerColors[0] || 'transparent'
    });
    var gradient = new $e082211bdfcbd68a$export$2e2bcd8739ae039(0, 0, 0, 0, colorStopsInRange, true);
    gradient[coordDim] = minCoord;
    gradient[coordDim + '2'] = maxCoord;
    return gradient;
}
function $7580519309ffae6a$var$getIsIgnoreFunc(seriesModel, data, coordSys) {
    var showAllSymbol = seriesModel.get('showAllSymbol');
    var isAuto = showAllSymbol === 'auto';
    if (showAllSymbol && !isAuto) return;
    var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
    if (!categoryAxis) return;
    // Note that category label interval strategy might bring some weird effect
    // in some scenario: users may wonder why some of the symbols are not
    // displayed. So we show all symbols as possible as we can.
    if (isAuto && $7580519309ffae6a$var$canShowAllSymbolForCategory(categoryAxis, data)) return;
    // Otherwise follow the label interval strategy on category axis.
    var categoryDataDim = data.mapDimension(categoryAxis.dim);
    var labelMap = {};
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(categoryAxis.getViewLabels(), function(labelItem) {
        var ordinalNumber = categoryAxis.scale.getRawOrdinalNumber(labelItem.tickValue);
        labelMap[ordinalNumber] = 1;
    });
    return function(dataIndex) {
        return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
    };
}
function $7580519309ffae6a$var$canShowAllSymbolForCategory(categoryAxis, data) {
    // In most cases, line is monotonous on category axis, and the label size
    // is close with each other. So we check the symbol size and some of the
    // label size alone with the category axis to estimate whether all symbol
    // can be shown without overlap.
    var axisExtent = categoryAxis.getExtent();
    var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
    isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
    // Sampling some points, max 5.
    var dataLen = data.count();
    var step = Math.max(1, Math.round(dataLen / 5));
    for(var dataIndex = 0; dataIndex < dataLen; dataIndex += step){
        if ((0, $6864622a33ae23ca$export$2e2bcd8739ae039).getSymbolSize(data, dataIndex)[categoryAxis.isHorizontal() ? 1 : 0] * 1.5 > availSize) return false;
    }
    return true;
}
function $7580519309ffae6a$var$isPointNull(x, y) {
    return isNaN(x) || isNaN(y);
}
function $7580519309ffae6a$var$getLastIndexNotNull(points) {
    var len = points.length / 2;
    for(; len > 0; len--){
        if (!$7580519309ffae6a$var$isPointNull(points[len * 2 - 2], points[len * 2 - 1])) break;
    }
    return len - 1;
}
function $7580519309ffae6a$var$getPointAtIndex(points, idx) {
    return [
        points[idx * 2],
        points[idx * 2 + 1]
    ];
}
function $7580519309ffae6a$var$getIndexRange(points, xOrY, dim) {
    var len = points.length / 2;
    var dimIdx = dim === 'x' ? 0 : 1;
    var a;
    var b;
    var prevIndex = 0;
    var nextIndex = -1;
    for(var i = 0; i < len; i++){
        b = points[i * 2 + dimIdx];
        if (isNaN(b) || isNaN(points[i * 2 + 1 - dimIdx])) continue;
        if (i === 0) {
            a = b;
            continue;
        }
        if (a <= xOrY && b >= xOrY || a >= xOrY && b <= xOrY) {
            nextIndex = i;
            break;
        }
        prevIndex = i;
        a = b;
    }
    return {
        range: [
            prevIndex,
            nextIndex
        ],
        t: (xOrY - a) / (b - a)
    };
}
function $7580519309ffae6a$var$anyStateShowEndLabel(seriesModel) {
    if (seriesModel.get([
        'endLabel',
        'show'
    ])) return true;
    for(var i = 0; i < (0, $b414df7d361a211c$export$151308dceb52d5b).length; i++){
        if (seriesModel.get([
            (0, $b414df7d361a211c$export$151308dceb52d5b)[i],
            'endLabel',
            'show'
        ])) return true;
    }
    return false;
}
function $7580519309ffae6a$var$createLineClipPath(lineView, coordSys, hasAnimation, seriesModel) {
    if ((0, $9ca39efe18dd5899$export$8567506e6336616)(coordSys, 'cartesian2d')) {
        var endLabelModel_1 = seriesModel.getModel('endLabel');
        var valueAnimation_1 = endLabelModel_1.get('valueAnimation');
        var data_1 = seriesModel.getData();
        var labelAnimationRecord_1 = {
            lastFrameIndex: 0
        };
        var during = $7580519309ffae6a$var$anyStateShowEndLabel(seriesModel) ? function(percent, clipRect) {
            lineView._endLabelOnDuring(percent, clipRect, data_1, labelAnimationRecord_1, valueAnimation_1, endLabelModel_1, coordSys);
        } : null;
        var isHorizontal = coordSys.getBaseAxis().isHorizontal();
        var clipPath = (0, $6206a29b0d1240e0$export$83958787eb658d14)(coordSys, hasAnimation, seriesModel, function() {
            var endLabel = lineView._endLabel;
            if (endLabel && hasAnimation) {
                if (labelAnimationRecord_1.originalX != null) endLabel.attr({
                    x: labelAnimationRecord_1.originalX,
                    y: labelAnimationRecord_1.originalY
                });
            }
        }, during);
        // Expand clip shape to avoid clipping when line value exceeds axis
        if (!seriesModel.get('clip', true)) {
            var rectShape = clipPath.shape;
            var expandSize = Math.max(rectShape.width, rectShape.height);
            if (isHorizontal) {
                rectShape.y -= expandSize;
                rectShape.height += expandSize * 2;
            } else {
                rectShape.x -= expandSize;
                rectShape.width += expandSize * 2;
            }
        }
        // Set to the final frame. To make sure label layout is right.
        if (during) during(1, clipPath);
        return clipPath;
    } else return (0, $6206a29b0d1240e0$export$13dc2b2230df3cb5)(coordSys, hasAnimation, seriesModel);
}
function $7580519309ffae6a$var$getEndLabelStateSpecified(endLabelModel, coordSys) {
    var baseAxis = coordSys.getBaseAxis();
    var isHorizontal = baseAxis.isHorizontal();
    var isBaseInversed = baseAxis.inverse;
    var align = isHorizontal ? isBaseInversed ? 'right' : 'left' : 'center';
    var verticalAlign = isHorizontal ? 'middle' : isBaseInversed ? 'top' : 'bottom';
    return {
        normal: {
            align: endLabelModel.get('align') || align,
            verticalAlign: endLabelModel.get('verticalAlign') || verticalAlign
        }
    };
}
var $7580519309ffae6a$var$LineView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LineView, _super);
    function LineView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LineView.prototype.init = function() {
        var lineGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        var symbolDraw = new (0, $89a14c17b9971b0f$export$2e2bcd8739ae039)();
        this.group.add(symbolDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineGroup = lineGroup;
        this._changePolyState = $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._changePolyState, this);
    };
    LineView.prototype.render = function(seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var lineStyleModel = seriesModel.getModel('lineStyle');
        var areaStyleModel = seriesModel.getModel('areaStyle');
        var points = data.getLayout('points') || [];
        var isCoordSysPolar = coordSys.type === 'polar';
        var prevCoordSys = this._coordSys;
        var symbolDraw = this._symbolDraw;
        var polyline = this._polyline;
        var polygon = this._polygon;
        var lineGroup = this._lineGroup;
        var hasAnimation = !ecModel.ssr && seriesModel.get('animation');
        var isAreaChart = !areaStyleModel.isEmpty();
        var valueOrigin = areaStyleModel.get('origin');
        var dataCoordInfo = (0, $09cfe0e50d7c5a28$export$b488a529581b37e)(coordSys, data, valueOrigin);
        var stackedOnPoints = isAreaChart && $7580519309ffae6a$var$getStackedOnPoints(coordSys, data, dataCoordInfo);
        var showSymbol = seriesModel.get('showSymbol');
        var connectNulls = seriesModel.get('connectNulls');
        var isIgnoreFunc = showSymbol && !isCoordSysPolar && $7580519309ffae6a$var$getIsIgnoreFunc(seriesModel, data, coordSys);
        // Remove temporary symbols
        var oldData = this._data;
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        // Remove previous created symbols if showSymbol changed to false
        if (!showSymbol) symbolDraw.remove();
        group.add(lineGroup);
        // FIXME step not support polar
        var step = !isCoordSysPolar ? seriesModel.get('step') : false;
        var clipShapeForSymbol;
        if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
            clipShapeForSymbol = coordSys.getArea();
            // Avoid float number rounding error for symbol on the edge of axis extent.
            // See #7913 and `test/dataZoom-clip.html`.
            if (clipShapeForSymbol.width != null) {
                clipShapeForSymbol.x -= 0.1;
                clipShapeForSymbol.y -= 0.1;
                clipShapeForSymbol.width += 0.2;
                clipShapeForSymbol.height += 0.2;
            } else if (clipShapeForSymbol.r0) {
                clipShapeForSymbol.r0 -= 0.5;
                clipShapeForSymbol.r += 0.5;
            }
        }
        this._clipShapeForSymbol = clipShapeForSymbol;
        var visualColor = $7580519309ffae6a$var$getVisualGradient(data, coordSys, api) || data.getVisual('style')[data.getVisual('drawType')];
        // Initialization animation or coordinate system changed
        if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            hasAnimation && this._initSymbolLabelAnimation(data, coordSys, clipShapeForSymbol);
            if (step) {
                if (stackedOnPoints) stackedOnPoints = $7580519309ffae6a$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                // TODO If stacked series is not step
                points = $7580519309ffae6a$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
            }
            polyline = this._newPolyline(points);
            if (isAreaChart) polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon) {
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $ff2fba995230f3c9$export$cda04d03233e5555)(visualColor));
            lineGroup.setClipPath($7580519309ffae6a$var$createLineClipPath(this, coordSys, true, seriesModel));
        } else {
            if (isAreaChart && !polygon) // If areaStyle is added
            polygon = this._newPolygon(points, stackedOnPoints);
            else if (polygon && !isAreaChart) {
                // If areaStyle is removed
                lineGroup.remove(polygon);
                polygon = this._polygon = null;
            }
            // NOTE: Must update _endLabel before setClipPath.
            if (!isCoordSysPolar) this._initOrUpdateEndLabel(seriesModel, coordSys, (0, $ff2fba995230f3c9$export$cda04d03233e5555)(visualColor));
            // Update clipPath
            var oldClipPath = lineGroup.getClipPath();
            if (oldClipPath) {
                var newClipPath = $7580519309ffae6a$var$createLineClipPath(this, coordSys, false, seriesModel);
                $b40111164617dd60$export$a121566aadcfe021(oldClipPath, {
                    shape: newClipPath.shape
                }, seriesModel);
            } else lineGroup.setClipPath($7580519309ffae6a$var$createLineClipPath(this, coordSys, true, seriesModel));
            // Always update, or it is wrong in the case turning on legend
            // because points are not changed.
            showSymbol && symbolDraw.updateData(data, {
                isIgnore: isIgnoreFunc,
                clipShape: clipShapeForSymbol,
                disableAnimation: true,
                getSymbolPoint: function(idx) {
                    return [
                        points[idx * 2],
                        points[idx * 2 + 1]
                    ];
                }
            });
            // In the case data zoom triggered refreshing frequently
            // Data may not change if line has a category axis. So it should animate nothing.
            if (!$7580519309ffae6a$var$isPointsSame(this._stackedOnPoints, stackedOnPoints) || !$7580519309ffae6a$var$isPointsSame(this._points, points)) {
                if (hasAnimation) this._doUpdateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls);
                else {
                    // Not do it in update with animation
                    if (step) {
                        if (stackedOnPoints) stackedOnPoints = $7580519309ffae6a$var$turnPointsIntoStep(stackedOnPoints, points, coordSys, step, connectNulls);
                        // TODO If stacked series is not step
                        points = $7580519309ffae6a$var$turnPointsIntoStep(points, null, coordSys, step, connectNulls);
                    }
                    polyline.setShape({
                        points: points
                    });
                    polygon && polygon.setShape({
                        points: points,
                        stackedOnPoints: stackedOnPoints
                    });
                }
            }
        }
        var emphasisModel = seriesModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');
        polyline.useStyle($1b239fc9d3a2f8ae$export$ebe90cb607ad99e(// Use color in lineStyle first
        lineStyleModel.getLineStyle(), {
            fill: 'none',
            stroke: visualColor,
            lineJoin: 'bevel'
        }));
        (0, $b414df7d361a211c$export$48b68047d330bbc9)(polyline, seriesModel, 'lineStyle');
        if (polyline.style.lineWidth > 0 && seriesModel.get([
            'emphasis',
            'lineStyle',
            'width'
        ]) === 'bolder') {
            var emphasisLineStyle = polyline.getState('emphasis').style;
            emphasisLineStyle.lineWidth = +polyline.style.lineWidth + 1;
        }
        // Needs seriesIndex for focus
        (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(polyline).seriesIndex = seriesModel.seriesIndex;
        (0, $b414df7d361a211c$export$e51187539ff11209)(polyline, focus, blurScope, emphasisDisabled);
        var smooth = $7580519309ffae6a$var$getSmooth(seriesModel.get('smooth'));
        var smoothMonotone = seriesModel.get('smoothMonotone');
        polyline.setShape({
            smooth: smooth,
            smoothMonotone: smoothMonotone,
            connectNulls: connectNulls
        });
        if (polygon) {
            var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
            var stackedOnSmooth = 0;
            polygon.useStyle($1b239fc9d3a2f8ae$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: visualColor,
                opacity: 0.7,
                lineJoin: 'bevel',
                decal: data.getVisual('style').decal
            }));
            if (stackedOnSeries) stackedOnSmooth = $7580519309ffae6a$var$getSmooth(stackedOnSeries.get('smooth'));
            polygon.setShape({
                smooth: smooth,
                stackedOnSmooth: stackedOnSmooth,
                smoothMonotone: smoothMonotone,
                connectNulls: connectNulls
            });
            (0, $b414df7d361a211c$export$48b68047d330bbc9)(polygon, seriesModel, 'areaStyle');
            // Needs seriesIndex for focus
            (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(polygon).seriesIndex = seriesModel.seriesIndex;
            (0, $b414df7d361a211c$export$e51187539ff11209)(polygon, focus, blurScope, emphasisDisabled);
        }
        var changePolyState = this._changePolyState;
        data.eachItemGraphicEl(function(el) {
            // Switch polyline / polygon state if element changed its state.
            el && (el.onHoverStateChange = changePolyState);
        });
        this._polyline.onHoverStateChange = changePolyState;
        this._data = data;
        // Save the coordinate system for transition animation when data changed
        this._coordSys = coordSys;
        this._stackedOnPoints = stackedOnPoints;
        this._points = points;
        this._step = step;
        this._valueOrigin = valueOrigin;
        if (seriesModel.get('triggerLineEvent')) {
            this.packEventData(seriesModel, polyline);
            polygon && this.packEventData(seriesModel, polygon);
        }
    };
    LineView.prototype.packEventData = function(seriesModel, el) {
        (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).eventData = {
            componentType: 'series',
            componentSubType: 'line',
            componentIndex: seriesModel.componentIndex,
            seriesIndex: seriesModel.seriesIndex,
            seriesName: seriesModel.name,
            seriesType: 'line'
        };
    };
    LineView.prototype.highlight = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $9ac03c46e8b6e711$export$42b26cae8b8d10(data, payload);
        this._changePolyState('emphasis');
        if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
            var points = data.getLayout('points');
            var symbol = data.getItemGraphicEl(dataIndex);
            if (!symbol) {
                // Create a temporary symbol if it is not exists
                var x = points[dataIndex * 2];
                var y = points[dataIndex * 2 + 1];
                if (isNaN(x) || isNaN(y)) // Null data
                return;
                // fix #11360: shouldn't draw symbol outside clipShapeForSymbol
                if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(x, y)) return;
                var zlevel = seriesModel.get('zlevel') || 0;
                var z = seriesModel.get('z') || 0;
                symbol = new (0, $6864622a33ae23ca$export$2e2bcd8739ae039)(data, dataIndex);
                symbol.x = x;
                symbol.y = y;
                symbol.setZ(zlevel, z);
                // ensure label text of the temporary symbol is in front of line and area polygon
                var symbolLabel = symbol.getSymbolPath().getTextContent();
                if (symbolLabel) {
                    symbolLabel.zlevel = zlevel;
                    symbolLabel.z = z;
                    symbolLabel.z2 = this._polyline.z2 + 1;
                }
                symbol.__temp = true;
                data.setItemGraphicEl(dataIndex, symbol);
                // Stop scale animation
                symbol.stopSymbolAnimation(true);
                this.group.add(symbol);
            }
            symbol.highlight();
        } else // Highlight whole series
        (0, $80462d4f8a33fa64$export$2e2bcd8739ae039).prototype.highlight.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype.downplay = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var dataIndex = $9ac03c46e8b6e711$export$42b26cae8b8d10(data, payload);
        this._changePolyState('normal');
        if (dataIndex != null && dataIndex >= 0) {
            var symbol = data.getItemGraphicEl(dataIndex);
            if (symbol) {
                if (symbol.__temp) {
                    data.setItemGraphicEl(dataIndex, null);
                    this.group.remove(symbol);
                } else symbol.downplay();
            }
        } else // FIXME
        // can not downplay completely.
        // Downplay whole series
        (0, $80462d4f8a33fa64$export$2e2bcd8739ae039).prototype.downplay.call(this, seriesModel, ecModel, api, payload);
    };
    LineView.prototype._changePolyState = function(toState) {
        var polygon = this._polygon;
        (0, $b414df7d361a211c$export$868ba38adffa9e39)(this._polyline, toState);
        polygon && (0, $b414df7d361a211c$export$868ba38adffa9e39)(polygon, toState);
    };
    LineView.prototype._newPolyline = function(points) {
        var polyline = this._polyline;
        // Remove previous created polyline
        if (polyline) this._lineGroup.remove(polyline);
        polyline = new (0, $4994818843f5bc5a$export$bf7c0585b8f7d00f)({
            shape: {
                points: points
            },
            segmentIgnoreThreshold: 2,
            z2: 10
        });
        this._lineGroup.add(polyline);
        this._polyline = polyline;
        return polyline;
    };
    LineView.prototype._newPolygon = function(points, stackedOnPoints) {
        var polygon = this._polygon;
        // Remove previous created polygon
        if (polygon) this._lineGroup.remove(polygon);
        polygon = new (0, $4994818843f5bc5a$export$6042a400d113f2bd)({
            shape: {
                points: points,
                stackedOnPoints: stackedOnPoints
            },
            segmentIgnoreThreshold: 2
        });
        this._lineGroup.add(polygon);
        this._polygon = polygon;
        return polygon;
    };
    LineView.prototype._initSymbolLabelAnimation = function(data, coordSys, clipShape) {
        var isHorizontalOrRadial;
        var isCoordSysPolar;
        var baseAxis = coordSys.getBaseAxis();
        var isAxisInverse = baseAxis.inverse;
        if (coordSys.type === 'cartesian2d') {
            isHorizontalOrRadial = baseAxis.isHorizontal();
            isCoordSysPolar = false;
        } else if (coordSys.type === 'polar') {
            isHorizontalOrRadial = baseAxis.dim === 'angle';
            isCoordSysPolar = true;
        }
        var seriesModel = data.hostModel;
        var seriesDuration = seriesModel.get('animationDuration');
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(seriesDuration)) seriesDuration = seriesDuration(null);
        var seriesDelay = seriesModel.get('animationDelay') || 0;
        var seriesDelayValue = $1b239fc9d3a2f8ae$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(null) : seriesDelay;
        data.eachItemGraphicEl(function(symbol, idx) {
            var el = symbol;
            if (el) {
                var point = [
                    symbol.x,
                    symbol.y
                ];
                var start = void 0;
                var end = void 0;
                var current = void 0;
                if (clipShape) {
                    if (isCoordSysPolar) {
                        var polarClip = clipShape;
                        var coord = coordSys.pointToCoord(point);
                        if (isHorizontalOrRadial) {
                            start = polarClip.startAngle;
                            end = polarClip.endAngle;
                            current = -coord[1] / 180 * Math.PI;
                        } else {
                            start = polarClip.r0;
                            end = polarClip.r;
                            current = coord[0];
                        }
                    } else {
                        var gridClip = clipShape;
                        if (isHorizontalOrRadial) {
                            start = gridClip.x;
                            end = gridClip.x + gridClip.width;
                            current = symbol.x;
                        } else {
                            start = gridClip.y + gridClip.height;
                            end = gridClip.y;
                            current = symbol.y;
                        }
                    }
                }
                var ratio = end === start ? 0 : (current - start) / (end - start);
                if (isAxisInverse) ratio = 1 - ratio;
                var delay = $1b239fc9d3a2f8ae$export$f6e2535fb5126e54(seriesDelay) ? seriesDelay(idx) : seriesDuration * ratio + seriesDelayValue;
                var symbolPath = el.getSymbolPath();
                var text = symbolPath.getTextContent();
                el.attr({
                    scaleX: 0,
                    scaleY: 0
                });
                el.animateTo({
                    scaleX: 1,
                    scaleY: 1
                }, {
                    duration: 200,
                    setToFinal: true,
                    delay: delay
                });
                if (text) text.animateFrom({
                    style: {
                        opacity: 0
                    }
                }, {
                    duration: 300,
                    delay: delay
                });
                symbolPath.disableLabelAnimation = true;
            }
        });
    };
    LineView.prototype._initOrUpdateEndLabel = function(seriesModel, coordSys, inheritColor) {
        var endLabelModel = seriesModel.getModel('endLabel');
        if ($7580519309ffae6a$var$anyStateShowEndLabel(seriesModel)) {
            var data_2 = seriesModel.getData();
            var polyline = this._polyline;
            // series may be filtered.
            var points = data_2.getLayout('points');
            if (!points) {
                polyline.removeTextContent();
                this._endLabel = null;
                return;
            }
            var endLabel = this._endLabel;
            if (!endLabel) {
                endLabel = this._endLabel = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                    z2: 200 // should be higher than item symbol
                });
                endLabel.ignoreClip = true;
                polyline.setTextContent(this._endLabel);
                polyline.disableLabelAnimation = true;
            }
            // Find last non-NaN data to display data
            var dataIndex = $7580519309ffae6a$var$getLastIndexNotNull(points);
            if (dataIndex >= 0) {
                (0, $3828198b2f2de836$export$9a13992917966657)(polyline, (0, $3828198b2f2de836$export$9739a32674be5893)(seriesModel, 'endLabel'), {
                    inheritColor: inheritColor,
                    labelFetcher: seriesModel,
                    labelDataIndex: dataIndex,
                    defaultText: function(dataIndex, opt, interpolatedValue) {
                        return interpolatedValue != null ? (0, $3aa4a91235bead55$export$5f84815e91ca6775)(data_2, interpolatedValue) : (0, $3aa4a91235bead55$export$5ff20667590927ed)(data_2, dataIndex);
                    },
                    enableTextSetter: true
                }, $7580519309ffae6a$var$getEndLabelStateSpecified(endLabelModel, coordSys));
                polyline.textConfig.position = null;
            }
        } else if (this._endLabel) {
            this._polyline.removeTextContent();
            this._endLabel = null;
        }
    };
    LineView.prototype._endLabelOnDuring = function(percent, clipRect, data, animationRecord, valueAnimation, endLabelModel, coordSys) {
        var endLabel = this._endLabel;
        var polyline = this._polyline;
        if (endLabel) {
            // NOTE: Don't remove percent < 1. percent === 1 means the first frame during render.
            // The label is not prepared at this time.
            if (percent < 1 && animationRecord.originalX == null) {
                animationRecord.originalX = endLabel.x;
                animationRecord.originalY = endLabel.y;
            }
            var points = data.getLayout('points');
            var seriesModel = data.hostModel;
            var connectNulls = seriesModel.get('connectNulls');
            var precision = endLabelModel.get('precision');
            var distance = endLabelModel.get('distance') || 0;
            var baseAxis = coordSys.getBaseAxis();
            var isHorizontal = baseAxis.isHorizontal();
            var isBaseInversed = baseAxis.inverse;
            var clipShape = clipRect.shape;
            var xOrY = isBaseInversed ? isHorizontal ? clipShape.x : clipShape.y + clipShape.height : isHorizontal ? clipShape.x + clipShape.width : clipShape.y;
            var distanceX = (isHorizontal ? distance : 0) * (isBaseInversed ? -1 : 1);
            var distanceY = (isHorizontal ? 0 : -distance) * (isBaseInversed ? -1 : 1);
            var dim = isHorizontal ? 'x' : 'y';
            var dataIndexRange = $7580519309ffae6a$var$getIndexRange(points, xOrY, dim);
            var indices = dataIndexRange.range;
            var diff = indices[1] - indices[0];
            var value = void 0;
            if (diff >= 1) {
                // diff > 1 && connectNulls, which is on the null data.
                if (diff > 1 && !connectNulls) {
                    var pt = $7580519309ffae6a$var$getPointAtIndex(points, indices[0]);
                    endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    valueAnimation && (value = seriesModel.getRawValue(indices[0]));
                } else {
                    var pt = polyline.getPointOn(xOrY, dim);
                    pt && endLabel.attr({
                        x: pt[0] + distanceX,
                        y: pt[1] + distanceY
                    });
                    var startValue = seriesModel.getRawValue(indices[0]);
                    var endValue = seriesModel.getRawValue(indices[1]);
                    valueAnimation && (value = $9ac03c46e8b6e711$export$bd0439821a1869f3(data, precision, startValue, endValue, dataIndexRange.t));
                }
                animationRecord.lastFrameIndex = indices[0];
            } else {
                // If diff <= 0, which is the range is not found(Include NaN)
                // Choose the first point or last point.
                var idx = percent === 1 || animationRecord.lastFrameIndex > 0 ? indices[0] : 0;
                var pt = $7580519309ffae6a$var$getPointAtIndex(points, idx);
                valueAnimation && (value = seriesModel.getRawValue(idx));
                endLabel.attr({
                    x: pt[0] + distanceX,
                    y: pt[1] + distanceY
                });
            }
            if (valueAnimation) {
                var inner = (0, $3828198b2f2de836$export$f62786d3261ab0f4)(endLabel);
                if (typeof inner.setLabelText === 'function') inner.setLabelText(value);
            }
        }
    };
    /**
   * @private
   */ // FIXME Two value axis
    LineView.prototype._doUpdateAnimation = function(data, stackedOnPoints, coordSys, api, step, valueOrigin, connectNulls) {
        var polyline = this._polyline;
        var polygon = this._polygon;
        var seriesModel = data.hostModel;
        var diff = (0, $e8b11ce12cfee9ed$export$2e2bcd8739ae039)(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
        var current = diff.current;
        var stackedOnCurrent = diff.stackedOnCurrent;
        var next = diff.next;
        var stackedOnNext = diff.stackedOnNext;
        if (step) {
            // TODO If stacked series is not step
            stackedOnCurrent = $7580519309ffae6a$var$turnPointsIntoStep(diff.stackedOnCurrent, diff.current, coordSys, step, connectNulls);
            current = $7580519309ffae6a$var$turnPointsIntoStep(diff.current, null, coordSys, step, connectNulls);
            stackedOnNext = $7580519309ffae6a$var$turnPointsIntoStep(diff.stackedOnNext, diff.next, coordSys, step, connectNulls);
            next = $7580519309ffae6a$var$turnPointsIntoStep(diff.next, null, coordSys, step, connectNulls);
        }
        // Don't apply animation if diff is large.
        // For better result and avoid memory explosion problems like
        // https://github.com/apache/incubator-echarts/issues/12229
        if ($7580519309ffae6a$var$getBoundingDiff(current, next) > 3000 || polygon && $7580519309ffae6a$var$getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
            polyline.stopAnimation();
            polyline.setShape({
                points: next
            });
            if (polygon) {
                polygon.stopAnimation();
                polygon.setShape({
                    points: next,
                    stackedOnPoints: stackedOnNext
                });
            }
            return;
        }
        polyline.shape.__points = diff.current;
        polyline.shape.points = current;
        var target = {
            shape: {
                points: next
            }
        };
        // Also animate the original points.
        // If points reference is changed when turning into step line.
        if (diff.current !== current) target.shape.__points = diff.next;
        // Stop previous animation.
        polyline.stopAnimation();
        $b40111164617dd60$export$c8dce3c08436e91e(polyline, target, seriesModel);
        if (polygon) {
            polygon.setShape({
                // Reuse the points with polyline.
                points: current,
                stackedOnPoints: stackedOnCurrent
            });
            polygon.stopAnimation();
            $b40111164617dd60$export$c8dce3c08436e91e(polygon, {
                shape: {
                    stackedOnPoints: stackedOnNext
                }
            }, seriesModel);
            // If use attr directly in updateProps.
            if (polyline.shape.points !== polygon.shape.points) polygon.shape.points = polyline.shape.points;
        }
        var updatedDataInfo = [];
        var diffStatus = diff.status;
        for(var i = 0; i < diffStatus.length; i++){
            var cmd = diffStatus[i].cmd;
            if (cmd === '=') {
                var el = data.getItemGraphicEl(diffStatus[i].idx1);
                if (el) updatedDataInfo.push({
                    el: el,
                    ptIdx: i // Index of points
                });
            }
        }
        if (polyline.animators && polyline.animators.length) polyline.animators[0].during(function() {
            polygon && polygon.dirtyShape();
            var points = polyline.shape.__points;
            for(var i = 0; i < updatedDataInfo.length; i++){
                var el = updatedDataInfo[i].el;
                var offset = updatedDataInfo[i].ptIdx * 2;
                el.x = points[offset];
                el.y = points[offset + 1];
                el.markRedraw();
            }
        });
    };
    LineView.prototype.remove = function(ecModel) {
        var group = this.group;
        var oldData = this._data;
        this._lineGroup.removeAll();
        this._symbolDraw.remove(true);
        // Remove temporary created elements when highlighting
        oldData && oldData.eachItemGraphicEl(function(el, idx) {
            if (el.__temp) {
                group.remove(el);
                oldData.setItemGraphicEl(idx, null);
            }
        });
        this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._endLabel = this._data = null;
    };
    LineView.type = 'line';
    return LineView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $7580519309ffae6a$export$2e2bcd8739ae039 = $7580519309ffae6a$var$LineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $264cfd4c63b95c0a$export$2e2bcd8739ae039(seriesType, forceStoreInTypedArray) {
    return {
        seriesType: seriesType,
        plan: (0, $0041f1ab5f0fd789$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            var coordSys = seriesModel.coordinateSystem;
            var pipelineContext = seriesModel.pipelineContext;
            var useTypedArray = forceStoreInTypedArray || pipelineContext.large;
            if (!coordSys) return;
            var dims = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(coordSys.dimensions, function(dim) {
                return data.mapDimension(dim);
            }).slice(0, 2);
            var dimLen = dims.length;
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            if ((0, $495dfc021fe3a3f7$export$1dedc39359ae35c)(data, dims[0])) dims[0] = stackResultDim;
            if ((0, $495dfc021fe3a3f7$export$1dedc39359ae35c)(data, dims[1])) dims[1] = stackResultDim;
            var store = data.getStore();
            var dimIdx0 = data.getDimensionIndex(dims[0]);
            var dimIdx1 = data.getDimensionIndex(dims[1]);
            return dimLen && {
                progress: function(params, data) {
                    var segCount = params.end - params.start;
                    var points = useTypedArray && (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(segCount * dimLen);
                    var tmpIn = [];
                    var tmpOut = [];
                    for(var i = params.start, offset = 0; i < params.end; i++){
                        var point = void 0;
                        if (dimLen === 1) {
                            var x = store.get(dimIdx0, i);
                            // NOTE: Make sure the second parameter is null to use default strategy.
                            point = coordSys.dataToPoint(x, null, tmpOut);
                        } else {
                            tmpIn[0] = store.get(dimIdx0, i);
                            tmpIn[1] = store.get(dimIdx1, i);
                            // Let coordinate system to handle the NaN data.
                            point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                        }
                        if (useTypedArray) {
                            points[offset++] = point[0];
                            points[offset++] = point[1];
                        } else data.setItemLayout(i, point.slice());
                    }
                    useTypedArray && data.setLayout('points', points);
                }
            };
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7414668c13eb92e7$var$samplers = {
    average: function(frame) {
        var sum = 0;
        var count = 0;
        for(var i = 0; i < frame.length; i++)if (!isNaN(frame[i])) {
            sum += frame[i];
            count++;
        }
        // Return NaN if count is 0
        return count === 0 ? NaN : sum / count;
    },
    sum: function(frame) {
        var sum = 0;
        for(var i = 0; i < frame.length; i++)// Ignore NaN
        sum += frame[i] || 0;
        return sum;
    },
    max: function(frame) {
        var max = -Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] > max && (max = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(max) ? max : NaN;
    },
    min: function(frame) {
        var min = Infinity;
        for(var i = 0; i < frame.length; i++)frame[i] < min && (min = frame[i]);
        // NaN will cause illegal axis extent.
        return isFinite(min) ? min : NaN;
    },
    // TODO
    // Median
    nearest: function(frame) {
        return frame[0];
    }
};
var $7414668c13eb92e7$var$indexSampler = function(frame) {
    return Math.round(frame.length / 2);
};
function $7414668c13eb92e7$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        // FIXME:TS never used, so comment it
        // modifyOutputEnd: true,
        reset: function(seriesModel, ecModel, api) {
            var data = seriesModel.getData();
            var sampling = seriesModel.get('sampling');
            var coordSys = seriesModel.coordinateSystem;
            var count = data.count();
            // Only cartesian2d support down sampling. Disable it when there is few data.
            if (count > 10 && coordSys.type === 'cartesian2d' && sampling) {
                var baseAxis = coordSys.getBaseAxis();
                var valueAxis = coordSys.getOtherAxis(baseAxis);
                var extent = baseAxis.getExtent();
                var dpr = api.getDevicePixelRatio();
                // Coordinste system has been resized
                var size = Math.abs(extent[1] - extent[0]) * (dpr || 1);
                var rate = Math.round(count / size);
                if (isFinite(rate) && rate > 1) {
                    if (sampling === 'lttb') seriesModel.setData(data.lttbDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    else if (sampling === 'minmax') seriesModel.setData(data.minmaxDownSample(data.mapDimension(valueAxis.dim), 1 / rate));
                    var sampler = void 0;
                    if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(sampling)) sampler = $7414668c13eb92e7$var$samplers[sampling];
                    else if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(sampling)) sampler = sampling;
                    if (sampler) // Only support sample the first dim mapped from value axis.
                    seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, $7414668c13eb92e7$var$indexSampler));
                }
            }
        }
    };
}


function $0b9643135da9a2ad$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $7580519309ffae6a$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $db0d1c534c1bd5bb$export$2e2bcd8739ae039));
    registers.registerLayout((0, $264cfd4c63b95c0a$export$2e2bcd8739ae039)('line', true));
    registers.registerVisual({
        seriesType: 'line',
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // Visual coding for legend
            var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
            if (lineStyle && !lineStyle.stroke) // Fill in visual should be palette color if
            // has color callback
            lineStyle.stroke = data.getVisual('style').fill;
            data.setVisual('legendLineStyle', lineStyle);
        }
    });
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $7414668c13eb92e7$export$2e2bcd8739ae039)('line'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $b069e7ac30ed5deb$var$STACK_PREFIX = '__ec_stack_';
function $b069e7ac30ed5deb$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || $b069e7ac30ed5deb$var$STACK_PREFIX + seriesModel.seriesIndex;
}
function $b069e7ac30ed5deb$var$getAxisKey(axis) {
    return axis.dim + axis.index;
}
function $b069e7ac30ed5deb$export$658df087977b9e84(opt) {
    var params = [];
    var baseAxis = opt.axis;
    var axisKey = 'axis0';
    if (baseAxis.type !== 'category') return;
    var bandWidth = baseAxis.getBandWidth();
    for(var i = 0; i < opt.count || 0; i++)params.push((0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
        bandWidth: bandWidth,
        axisKey: axisKey,
        stackId: $b069e7ac30ed5deb$var$STACK_PREFIX + i
    }, opt));
    var widthAndOffsets = $b069e7ac30ed5deb$var$doCalBarWidthAndOffset(params);
    var result = [];
    for(var i = 0; i < opt.count; i++){
        var item = widthAndOffsets[axisKey][$b069e7ac30ed5deb$var$STACK_PREFIX + i];
        item.offsetCenter = item.offset + item.width / 2;
        result.push(item);
    }
    return result;
}
function $b069e7ac30ed5deb$export$efbd0c3f5ab0d5e4(seriesType, ecModel) {
    var seriesModels = [];
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for cartesian2d only
        if ($b069e7ac30ed5deb$var$isOnCartesian(seriesModel)) seriesModels.push(seriesModel);
    });
    return seriesModels;
}
/**
 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
 * values.
 * This works for time axes, value axes, and log axes.
 * For a single time axis, return value is in the form like
 * {'x_0': [1000000]}.
 * The value of 1000000 is in milliseconds.
 */ function $b069e7ac30ed5deb$var$getValueAxesMinGaps(barSeries) {
    /**
   * Map from axis.index to values.
   * For a single time axis, axisValues is in the form like
   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
   * Items in axisValues[x], e.g. 1495555200000, are time values of all
   * series.
   */ var axisValues = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        if (baseAxis.type !== 'time' && baseAxis.type !== 'value') return;
        var data = seriesModel.getData();
        var key = baseAxis.dim + '_' + baseAxis.index;
        var dimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
        var store = data.getStore();
        for(var i = 0, cnt = store.count(); i < cnt; ++i){
            var value = store.get(dimIdx, i);
            if (!axisValues[key]) // No previous data for the axis
            axisValues[key] = [
                value
            ];
            else // No value in previous series
            axisValues[key].push(value);
        // Ignore duplicated time values in the same axis
        }
    });
    var axisMinGaps = {};
    for(var key in axisValues)if (axisValues.hasOwnProperty(key)) {
        var valuesInAxis = axisValues[key];
        if (valuesInAxis) {
            // Sort axis values into ascending order to calculate gaps
            valuesInAxis.sort(function(a, b) {
                return a - b;
            });
            var min = null;
            for(var j = 1; j < valuesInAxis.length; ++j){
                var delta = valuesInAxis[j] - valuesInAxis[j - 1];
                if (delta > 0) // Ignore 0 delta because they are of the same axis value
                min = min === null ? delta : Math.min(min, delta);
            }
            // Set to null if only have one data
            axisMinGaps[key] = min;
        }
    }
    return axisMinGaps;
}
function $b069e7ac30ed5deb$export$20769dafc84e0299(barSeries) {
    var axisMinGaps = $b069e7ac30ed5deb$var$getValueAxesMinGaps(barSeries);
    var seriesInfoList = [];
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(barSeries, function(seriesModel) {
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var axisExtent = baseAxis.getExtent();
        var bandWidth;
        if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
        else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
            var key = baseAxis.dim + '_' + baseAxis.index;
            var minGap = axisMinGaps[key];
            var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
            var scale = baseAxis.scale.getExtent();
            var scaleSpan = Math.abs(scale[1] - scale[0]);
            bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
        } else {
            var data = seriesModel.getData();
            bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        }
        var barWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('barMaxWidth'), bandWidth);
        var barMinWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(// barMinWidth by default is 0.5 / 1 in cartesian. Because in value axis,
        // the auto-calculated bar width might be less than 0.5 / 1.
        seriesModel.get('barMinWidth') || ($b069e7ac30ed5deb$var$isInLargeMode(seriesModel) ? 0.5 : 1), bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        seriesInfoList.push({
            bandWidth: bandWidth,
            barWidth: barWidth,
            barMaxWidth: barMaxWidth,
            barMinWidth: barMinWidth,
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            axisKey: $b069e7ac30ed5deb$var$getAxisKey(baseAxis),
            stackId: $b069e7ac30ed5deb$var$getSeriesStackId(seriesModel)
        });
    });
    return $b069e7ac30ed5deb$var$doCalBarWidthAndOffset(seriesInfoList);
}
function $b069e7ac30ed5deb$var$doCalBarWidthAndOffset(seriesInfoList) {
    // Columns info on each category axis. Key is cartesian name
    var columnsMap = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(seriesInfoList, function(seriesInfo, idx) {
        var axisKey = seriesInfo.axisKey;
        var bandWidth = seriesInfo.bandWidth;
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: null,
            gap: '20%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = seriesInfo.stackId;
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        // Caution: In a single coordinate system, these barGrid attributes
        // will be shared by series. Consider that they have default values,
        // only the attributes set on the last series will work.
        // Do not change this fact unless there will be a break change.
        var barWidth = seriesInfo.barWidth;
        if (barWidth && !stacks[stackId].width) {
            // See #6312, do not restrict width.
            stacks[stackId].width = barWidth;
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            columnsOnAxis.remainedWidth -= barWidth;
        }
        var barMaxWidth = seriesInfo.barMaxWidth;
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        var barMinWidth = seriesInfo.barMinWidth;
        barMinWidth && (stacks[stackId].minWidth = barMinWidth);
        var barGap = seriesInfo.barGap;
        barGap != null && (columnsOnAxis.gap = barGap);
        var barCategoryGap = seriesInfo.barCategoryGap;
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGapPercent = columnsOnAxis.categoryGap;
        if (categoryGapPercent == null) {
            var columnCount = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(stacks).length;
            // More columns in one group
            // the spaces between group is smaller. Or the column will be too thin.
            categoryGapPercent = Math.max(35 - columnCount * 4, 15) + '%';
        }
        var categoryGap = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(categoryGapPercent, bandWidth);
        var barGapPercent = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(stacks, function(column) {
            var maxWidth = column.maxWidth;
            var minWidth = column.minWidth;
            if (!column.width) {
                var finalWidth = autoWidth;
                if (maxWidth && maxWidth < finalWidth) finalWidth = Math.min(maxWidth, remainedWidth);
                // `minWidth` has higher priority. `minWidth` decide that whether the
                // bar is able to be visible. So `minWidth` should not be restricted
                // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
                // the extreme cases for `value` axis, bars are allowed to overlap
                // with each other if `minWidth` specified.
                if (minWidth && minWidth > finalWidth) finalWidth = minWidth;
                if (finalWidth !== autoWidth) {
                    column.width = finalWidth;
                    remainedWidth -= finalWidth + barGapPercent * finalWidth;
                    autoWidthCount--;
                }
            } else {
                // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
                // CSS does. Because barWidth can be a percent value, where
                // `barMaxWidth` can be used to restrict the final width.
                var finalWidth = column.width;
                if (maxWidth) finalWidth = Math.min(finalWidth, maxWidth);
                // `minWidth` has higher priority, as described above
                if (minWidth) finalWidth = Math.max(finalWidth, minWidth);
                column.width = finalWidth;
                remainedWidth -= finalWidth + barGapPercent * finalWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                bandWidth: bandWidth,
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
function $b069e7ac30ed5deb$export$35920bb6556da1c2(barWidthAndOffset, axis, seriesModel) {
    if (barWidthAndOffset && axis) {
        var result = barWidthAndOffset[$b069e7ac30ed5deb$var$getAxisKey(axis)];
        if (result != null && seriesModel != null) return result[$b069e7ac30ed5deb$var$getSeriesStackId(seriesModel)];
        return result;
    }
}
function $b069e7ac30ed5deb$export$b3219800bda33a1f(seriesType, ecModel) {
    var seriesModels = $b069e7ac30ed5deb$export$efbd0c3f5ab0d5e4(seriesType, ecModel);
    var barWidthAndOffset = $b069e7ac30ed5deb$export$20769dafc84e0299(seriesModels);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
        var data = seriesModel.getData();
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var stackId = $b069e7ac30ed5deb$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[$b069e7ac30ed5deb$var$getAxisKey(baseAxis)][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        data.setLayout({
            bandWidth: columnLayoutInfo.bandWidth,
            offset: columnOffset,
            size: columnWidth
        });
    });
}
function $b069e7ac30ed5deb$export$16e8685758531cb6(seriesType) {
    return {
        seriesType: seriesType,
        plan: (0, $0041f1ab5f0fd789$export$2e2bcd8739ae039)(),
        reset: function(seriesModel) {
            if (!$b069e7ac30ed5deb$var$isOnCartesian(seriesModel)) return;
            var data = seriesModel.getData();
            var cartesian = seriesModel.coordinateSystem;
            var baseAxis = cartesian.getBaseAxis();
            var valueAxis = cartesian.getOtherAxis(baseAxis);
            var valueDimIdx = data.getDimensionIndex(data.mapDimension(valueAxis.dim));
            var baseDimIdx = data.getDimensionIndex(data.mapDimension(baseAxis.dim));
            var drawBackground = seriesModel.get('showBackground', true);
            var valueDim = data.mapDimension(valueAxis.dim);
            var stackResultDim = data.getCalculationInfo('stackResultDimension');
            var stacked = (0, $495dfc021fe3a3f7$export$1dedc39359ae35c)(data, valueDim) && !!data.getCalculationInfo('stackedOnSeries');
            var isValueAxisH = valueAxis.isHorizontal();
            var valueAxisStart = $b069e7ac30ed5deb$var$getValueAxisStart(baseAxis, valueAxis);
            var isLarge = $b069e7ac30ed5deb$var$isInLargeMode(seriesModel);
            var barMinHeight = seriesModel.get('barMinHeight') || 0;
            var stackedDimIdx = stackResultDim && data.getDimensionIndex(stackResultDim);
            // Layout info.
            var columnWidth = data.getLayout('size');
            var columnOffset = data.getLayout('offset');
            return {
                progress: function(params, data) {
                    var count = params.count;
                    var largePoints = isLarge && (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(count * 3);
                    var largeBackgroundPoints = isLarge && drawBackground && (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(count * 3);
                    var largeDataIndices = isLarge && (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(count);
                    var coordLayout = cartesian.master.getRect();
                    var bgSize = isValueAxisH ? coordLayout.width : coordLayout.height;
                    var dataIndex;
                    var store = data.getStore();
                    var idxOffset = 0;
                    while((dataIndex = params.next()) != null){
                        var value = store.get(stacked ? stackedDimIdx : valueDimIdx, dataIndex);
                        var baseValue = store.get(baseDimIdx, dataIndex);
                        var baseCoord = valueAxisStart;
                        var stackStartValue = void 0;
                        // Because of the barMinHeight, we can not use the value in
                        // stackResultDimension directly.
                        if (stacked) stackStartValue = +value - store.get(valueDimIdx, dataIndex);
                        var x = void 0;
                        var y = void 0;
                        var width = void 0;
                        var height = void 0;
                        if (isValueAxisH) {
                            var coord = cartesian.dataToPoint([
                                value,
                                baseValue
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    stackStartValue,
                                    baseValue
                                ]);
                                baseCoord = startCoord[0];
                            }
                            x = baseCoord;
                            y = coord[1] + columnOffset;
                            width = coord[0] - baseCoord;
                            height = columnWidth;
                            if (Math.abs(width) < barMinHeight) width = (width < 0 ? -1 : 1) * barMinHeight;
                        } else {
                            var coord = cartesian.dataToPoint([
                                baseValue,
                                value
                            ]);
                            if (stacked) {
                                var startCoord = cartesian.dataToPoint([
                                    baseValue,
                                    stackStartValue
                                ]);
                                baseCoord = startCoord[1];
                            }
                            x = coord[0] + columnOffset;
                            y = baseCoord;
                            width = columnWidth;
                            height = coord[1] - baseCoord;
                            if (Math.abs(height) < barMinHeight) // Include zero to has a positive bar
                            height = (height <= 0 ? -1 : 1) * barMinHeight;
                        }
                        if (!isLarge) data.setItemLayout(dataIndex, {
                            x: x,
                            y: y,
                            width: width,
                            height: height
                        });
                        else {
                            largePoints[idxOffset] = x;
                            largePoints[idxOffset + 1] = y;
                            largePoints[idxOffset + 2] = isValueAxisH ? width : height;
                            if (largeBackgroundPoints) {
                                largeBackgroundPoints[idxOffset] = isValueAxisH ? coordLayout.x : x;
                                largeBackgroundPoints[idxOffset + 1] = isValueAxisH ? y : coordLayout.y;
                                largeBackgroundPoints[idxOffset + 2] = bgSize;
                            }
                            largeDataIndices[dataIndex] = dataIndex;
                        }
                        idxOffset += 3;
                    }
                    if (isLarge) data.setLayout({
                        largePoints: largePoints,
                        largeDataIndices: largeDataIndices,
                        largeBackgroundPoints: largeBackgroundPoints,
                        valueAxisHorizontal: isValueAxisH
                    });
                }
            };
        }
    };
}
function $b069e7ac30ed5deb$var$isOnCartesian(seriesModel) {
    return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
}
function $b069e7ac30ed5deb$var$isInLargeMode(seriesModel) {
    return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
}
// See cases in `test/bar-start.html` and `#7412`, `#8747`.
function $b069e7ac30ed5deb$var$getValueAxisStart(baseAxis, valueAxis) {
    var startValue = valueAxis.model.get('startValue');
    if (!startValue) startValue = 0;
    return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? startValue > 0 ? startValue : 1 : startValue));
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $9fc1adb8451c6cdc$var$BaseBarSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BaseBarSeriesModel, _super);
    function BaseBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BaseBarSeriesModel.type;
        return _this;
    }
    BaseBarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    BaseBarSeriesModel.prototype.getMarkerPosition = function(value, dims, startingAtTick) {
        var coordSys = this.coordinateSystem;
        if (coordSys && coordSys.clampData) {
            // PENDING if clamp ?
            var clampData_1 = coordSys.clampData(value);
            var pt_1 = coordSys.dataToPoint(clampData_1);
            if (startingAtTick) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(coordSys.getAxes(), function(axis, idx) {
                // If axis type is category, use tick coords instead
                if (axis.type === 'category' && dims != null) {
                    var tickCoords = axis.getTicksCoords();
                    var alignTicksWithLabel = axis.getTickModel().get('alignWithLabel');
                    var targetTickId = clampData_1[idx];
                    // The index of rightmost tick of markArea is 1 larger than x1/y1 index
                    var isEnd = dims[idx] === 'x1' || dims[idx] === 'y1';
                    if (isEnd && !alignTicksWithLabel) targetTickId += 1;
                    // The only contains one tick, tickCoords is
                    // like [{coord: 0, tickValue: 0}, {coord: 0}]
                    // to the length should always be larger than 1
                    if (tickCoords.length < 2) return;
                    else if (tickCoords.length === 2) {
                        // The left value and right value of the axis are
                        // the same. coord is 0 in both items. Use the max
                        // value of the axis as the coord
                        pt_1[idx] = axis.toGlobalCoord(axis.getExtent()[isEnd ? 1 : 0]);
                        return;
                    }
                    var leftCoord = void 0;
                    var coord = void 0;
                    var stepTickValue = 1;
                    for(var i = 0; i < tickCoords.length; i++){
                        var tickCoord = tickCoords[i].coord;
                        // The last item of tickCoords doesn't contain
                        // tickValue
                        var tickValue = i === tickCoords.length - 1 ? tickCoords[i - 1].tickValue + stepTickValue : tickCoords[i].tickValue;
                        if (tickValue === targetTickId) {
                            coord = tickCoord;
                            break;
                        } else if (tickValue < targetTickId) leftCoord = tickCoord;
                        else if (leftCoord != null && tickValue > targetTickId) {
                            coord = (tickCoord + leftCoord) / 2;
                            break;
                        }
                        if (i === 1) // Here we assume the step of category axes is
                        // the same
                        stepTickValue = tickValue - tickCoords[0].tickValue;
                    }
                    if (coord == null) {
                        if (!leftCoord) // targetTickId is smaller than all tick ids in the
                        // visible area, use the leftmost tick coord
                        coord = tickCoords[0].coord;
                        else if (leftCoord) // targetTickId is larger than all tick ids in the
                        // visible area, use the rightmost tick coord
                        coord = tickCoords[tickCoords.length - 1].coord;
                    }
                    pt_1[idx] = axis.toGlobalCoord(coord);
                }
            });
            else {
                var data = this.getData();
                var offset = data.getLayout('offset');
                var size = data.getLayout('size');
                var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
                pt_1[offsetIndex] += offset + size / 2;
            }
            return pt_1;
        }
        return [
            NaN,
            NaN
        ];
    };
    BaseBarSeriesModel.type = 'series.__base_bar__';
    BaseBarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // stack: null
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        barMinHeight: 0,
        barMinAngle: 0,
        // cursor: null,
        large: false,
        largeThreshold: 400,
        progressive: 3e3,
        progressiveChunkMode: 'mod'
    };
    return BaseBarSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
(0, $19b580a0cd6e92eb$export$2e2bcd8739ae039).registerClass($9fc1adb8451c6cdc$var$BaseBarSeriesModel);
var $9fc1adb8451c6cdc$export$2e2bcd8739ae039 = $9fc1adb8451c6cdc$var$BaseBarSeriesModel;




var $92ea9d381bfdb6fe$var$BarSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BarSeriesModel, _super);
    function BarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BarSeriesModel.type;
        return _this;
    }
    BarSeriesModel.prototype.getInitialData = function() {
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true,
            createInvertedIndices: !!this.get('realtimeSort', true) || null
        });
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressive = function() {
        // Do not support progressive in normal mode.
        return this.get('large') ? this.get('progressive') : false;
    };
    /**
   * @override
   */ BarSeriesModel.prototype.getProgressiveThreshold = function() {
        // Do not support progressive in normal mode.
        var progressiveThreshold = this.get('progressiveThreshold');
        var largeThreshold = this.get('largeThreshold');
        if (largeThreshold > progressiveThreshold) progressiveThreshold = largeThreshold;
        return progressiveThreshold;
    };
    BarSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.rect(data.getItemLayout(dataIndex));
    };
    BarSeriesModel.type = 'series.bar';
    BarSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    BarSeriesModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $9fc1adb8451c6cdc$export$2e2bcd8739ae039).defaultOption, {
        // If clipped
        // Only available on cartesian2d
        clip: true,
        roundCap: false,
        showBackground: false,
        backgroundStyle: {
            color: 'rgba(180, 180, 180, 0.2)',
            borderColor: null,
            borderWidth: 0,
            borderType: 'solid',
            borderRadius: 0,
            shadowBlur: 0,
            shadowColor: null,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        realtimeSort: false
    });
    return BarSeriesModel;
}((0, $9fc1adb8451c6cdc$export$2e2bcd8739ae039));
var $92ea9d381bfdb6fe$export$2e2bcd8739ae039 = $92ea9d381bfdb6fe$var$BarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Sausage: similar to sector, but have half circle on both sides
 */ var $ff7cc14bc4a8408f$var$SausageShape = /** @class */ function() {
    function SausageShape() {
        this.cx = 0;
        this.cy = 0;
        this.r0 = 0;
        this.r = 0;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clockwise = true;
    }
    return SausageShape;
}();
var $ff7cc14bc4a8408f$var$SausagePath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SausagePath, _super);
    function SausagePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'sausage';
        return _this;
    }
    SausagePath.prototype.getDefaultShape = function() {
        return new $ff7cc14bc4a8408f$var$SausageShape();
    };
    SausagePath.prototype.buildPath = function(ctx, shape) {
        var cx = shape.cx;
        var cy = shape.cy;
        var r0 = Math.max(shape.r0 || 0, 0);
        var r = Math.max(shape.r, 0);
        var dr = (r - r0) * 0.5;
        var rCenter = r0 + dr;
        var startAngle = shape.startAngle;
        var endAngle = shape.endAngle;
        var clockwise = shape.clockwise;
        var PI2 = Math.PI * 2;
        var lessThanCircle = clockwise ? endAngle - startAngle < PI2 : startAngle - endAngle < PI2;
        if (!lessThanCircle) // Normalize angles
        startAngle = endAngle - (clockwise ? PI2 : -PI2);
        var unitStartX = Math.cos(startAngle);
        var unitStartY = Math.sin(startAngle);
        var unitEndX = Math.cos(endAngle);
        var unitEndY = Math.sin(endAngle);
        if (lessThanCircle) {
            ctx.moveTo(unitStartX * r0 + cx, unitStartY * r0 + cy);
            ctx.arc(unitStartX * rCenter + cx, unitStartY * rCenter + cy, dr, -Math.PI + startAngle, startAngle, !clockwise);
        } else ctx.moveTo(unitStartX * r + cx, unitStartY * r + cy);
        ctx.arc(cx, cy, r, startAngle, endAngle, !clockwise);
        ctx.arc(unitEndX * rCenter + cx, unitEndY * rCenter + cy, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
        if (r0 !== 0) ctx.arc(cx, cy, r0, endAngle, startAngle, clockwise);
    // ctx.closePath();
    };
    return SausagePath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
var $ff7cc14bc4a8408f$export$2e2bcd8739ae039 = $ff7cc14bc4a8408f$var$SausagePath;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $b7408b8833e56695$export$359a1e2d210ed734(positionMapping, opts) {
    opts = opts || {};
    var isRoundCap = opts.isRoundCap;
    return function(out, opts, boundingRect) {
        var textPosition = opts.position;
        if (!textPosition || textPosition instanceof Array) return (0, $297531217517fbce$export$eee3603b512feab7)(out, opts, boundingRect);
        var mappedSectorPosition = positionMapping(textPosition);
        var distance = opts.distance != null ? opts.distance : 5;
        var sector = this.shape;
        var cx = sector.cx;
        var cy = sector.cy;
        var r = sector.r;
        var r0 = sector.r0;
        var middleR = (r + r0) / 2;
        var startAngle = sector.startAngle;
        var endAngle = sector.endAngle;
        var middleAngle = (startAngle + endAngle) / 2;
        var extraDist = isRoundCap ? Math.abs(r - r0) / 2 : 0;
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        // base position: top-left
        var x = cx + r * mathCos(startAngle);
        var y = cy + r * mathSin(startAngle);
        var textAlign = 'left';
        var textVerticalAlign = 'top';
        switch(mappedSectorPosition){
            case 'startArc':
                x = cx + (r0 - distance) * mathCos(middleAngle);
                y = cy + (r0 - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'insideStartArc':
                x = cx + (r0 + distance) * mathCos(middleAngle);
                y = cy + (r0 + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'startAngle':
                x = cx + middleR * mathCos(startAngle) + $b7408b8833e56695$var$adjustAngleDistanceX(startAngle, distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $b7408b8833e56695$var$adjustAngleDistanceY(startAngle, distance + extraDist, false);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            case 'insideStartAngle':
                x = cx + middleR * mathCos(startAngle) + $b7408b8833e56695$var$adjustAngleDistanceX(startAngle, -distance + extraDist, false);
                y = cy + middleR * mathSin(startAngle) + $b7408b8833e56695$var$adjustAngleDistanceY(startAngle, -distance + extraDist, false);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'middle':
                x = cx + middleR * mathCos(middleAngle);
                y = cy + middleR * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'middle';
                break;
            case 'endArc':
                x = cx + (r + distance) * mathCos(middleAngle);
                y = cy + (r + distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'bottom';
                break;
            case 'insideEndArc':
                x = cx + (r - distance) * mathCos(middleAngle);
                y = cy + (r - distance) * mathSin(middleAngle);
                textAlign = 'center';
                textVerticalAlign = 'top';
                break;
            case 'endAngle':
                x = cx + middleR * mathCos(endAngle) + $b7408b8833e56695$var$adjustAngleDistanceX(endAngle, distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $b7408b8833e56695$var$adjustAngleDistanceY(endAngle, distance + extraDist, true);
                textAlign = 'left';
                textVerticalAlign = 'middle';
                break;
            case 'insideEndAngle':
                x = cx + middleR * mathCos(endAngle) + $b7408b8833e56695$var$adjustAngleDistanceX(endAngle, -distance + extraDist, true);
                y = cy + middleR * mathSin(endAngle) + $b7408b8833e56695$var$adjustAngleDistanceY(endAngle, -distance + extraDist, true);
                textAlign = 'right';
                textVerticalAlign = 'middle';
                break;
            default:
                return (0, $297531217517fbce$export$eee3603b512feab7)(out, opts, boundingRect);
        }
        out = out || {};
        out.x = x;
        out.y = y;
        out.align = textAlign;
        out.verticalAlign = textVerticalAlign;
        return out;
    };
}
function $b7408b8833e56695$export$672ce504c0db395a(sector, textPosition, positionMapping, rotateType) {
    if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rotateType)) {
        // user-set rotation
        sector.setTextConfig({
            rotation: rotateType
        });
        return;
    } else if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(textPosition)) {
        // user-set position, use 0 as auto rotation
        sector.setTextConfig({
            rotation: 0
        });
        return;
    }
    var shape = sector.shape;
    var startAngle = shape.clockwise ? shape.startAngle : shape.endAngle;
    var endAngle = shape.clockwise ? shape.endAngle : shape.startAngle;
    var middleAngle = (startAngle + endAngle) / 2;
    var anchorAngle;
    var mappedSectorPosition = positionMapping(textPosition);
    switch(mappedSectorPosition){
        case 'startArc':
        case 'insideStartArc':
        case 'middle':
        case 'insideEndArc':
        case 'endArc':
            anchorAngle = middleAngle;
            break;
        case 'startAngle':
        case 'insideStartAngle':
            anchorAngle = startAngle;
            break;
        case 'endAngle':
        case 'insideEndAngle':
            anchorAngle = endAngle;
            break;
        default:
            sector.setTextConfig({
                rotation: 0
            });
            return;
    }
    var rotate = Math.PI * 1.5 - anchorAngle;
    /**
   * TODO: labels with rotate > Math.PI / 2 should be rotate another
   * half round flipped to increase readability. However, only middle
   * position supports this for now, because in other positions, the
   * anchor point is not at the center of the text, so the positions
   * after rotating is not as expected.
   */ if (mappedSectorPosition === 'middle' && rotate > Math.PI / 2 && rotate < Math.PI * 1.5) rotate -= Math.PI;
    sector.setTextConfig({
        rotation: rotate
    });
}
function $b7408b8833e56695$var$adjustAngleDistanceX(angle, distance, isEnd) {
    return distance * Math.sin(angle) * (isEnd ? -1 : 1);
}
function $b7408b8833e56695$var$adjustAngleDistanceY(angle, distance, isEnd) {
    return distance * Math.cos(angle) * (isEnd ? 1 : -1);
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $76e2a0dbb7483b91$export$b395eeeb2ad7cce5(model, shape, zeroIfNull) {
    var cornerRadius = model.get('borderRadius');
    if (cornerRadius == null) return zeroIfNull ? {
        cornerRadius: 0
    } : null;
    if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(cornerRadius)) cornerRadius = [
        cornerRadius,
        cornerRadius,
        cornerRadius,
        cornerRadius
    ];
    var dr = Math.abs(shape.r || 0 - shape.r0 || 0);
    return {
        cornerRadius: (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(cornerRadius, function(cr) {
            return (0, $297531217517fbce$export$e8514cb5a5e2b40f)(cr, dr);
        })
    };
}


var $e0de2d726d30d17d$var$mathMax = Math.max;
var $e0de2d726d30d17d$var$mathMin = Math.min;
function $e0de2d726d30d17d$var$getClipArea(coord, data) {
    var coordSysClipArea = coord.getArea && coord.getArea();
    if ((0, $9ca39efe18dd5899$export$8567506e6336616)(coord, 'cartesian2d')) {
        var baseAxis = coord.getBaseAxis();
        // When boundaryGap is false or using time axis. bar may exceed the grid.
        // We should not clip this part.
        // See test/bar2.html
        if (baseAxis.type !== 'category' || !baseAxis.onBand) {
            var expandWidth = data.getLayout('bandWidth');
            if (baseAxis.isHorizontal()) {
                coordSysClipArea.x -= expandWidth;
                coordSysClipArea.width += expandWidth * 2;
            } else {
                coordSysClipArea.y -= expandWidth;
                coordSysClipArea.height += expandWidth * 2;
            }
        }
    }
    return coordSysClipArea;
}
var $e0de2d726d30d17d$var$BarView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BarView, _super);
    function BarView() {
        var _this = _super.call(this) || this;
        _this.type = BarView.type;
        _this._isFirstFrame = true;
        return _this;
    }
    BarView.prototype.render = function(seriesModel, ecModel, api, payload) {
        this._model = seriesModel;
        this._removeOnRenderedListener(api);
        this._updateDrawMode(seriesModel);
        var coordinateSystemType = seriesModel.get('coordinateSystem');
        if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
            // Clear previously rendered progressive elements.
            this._progressiveEls = null;
            this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api, payload);
        }
    };
    BarView.prototype.incrementalPrepareRender = function(seriesModel) {
        this._clear();
        this._updateDrawMode(seriesModel);
        // incremental also need to clip, otherwise might be overlow.
        // But must not set clip in each frame, otherwise all of the children will be marked redraw.
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype.incrementalRender = function(params, seriesModel) {
        // Reset
        this._progressiveEls = [];
        // Do not support progressive in normal mode.
        this._incrementalRenderLarge(params, seriesModel);
    };
    BarView.prototype.eachRendered = function(cb) {
        (0, $8eb95236e1aa01e7$export$3e564442729bf048)(this._progressiveEls || this.group, cb);
    };
    BarView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    BarView.prototype._renderNormal = function(seriesModel, ecModel, api, payload) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coord = seriesModel.coordinateSystem;
        var baseAxis = coord.getBaseAxis();
        var isHorizontalOrRadial;
        if (coord.type === 'cartesian2d') isHorizontalOrRadial = baseAxis.isHorizontal();
        else if (coord.type === 'polar') isHorizontalOrRadial = baseAxis.dim === 'angle';
        var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
        var realtimeSortCfg = $e0de2d726d30d17d$var$shouldRealtimeSort(seriesModel, coord);
        if (realtimeSortCfg) this._enableRealtimeSort(realtimeSortCfg, data, api);
        var needsClip = seriesModel.get('clip', true) || realtimeSortCfg;
        var coordSysClipArea = $e0de2d726d30d17d$var$getClipArea(coord, data);
        // If there is clipPath created in large mode. Remove it.
        group.removeClipPath();
        // We don't use clipPath in normal mode because we needs a perfect animation
        // And don't want the label are clipped.
        var roundCap = seriesModel.get('roundCap', true);
        var drawBackground = seriesModel.get('showBackground', true);
        var backgroundModel = seriesModel.getModel('backgroundStyle');
        var barBorderRadius = backgroundModel.get('borderRadius') || 0;
        var bgEls = [];
        var oldBgEls = this._backgroundEls;
        var isInitSort = payload && payload.isInitSort;
        var isChangeOrder = payload && payload.type === 'changeAxisOrder';
        function createBackground(dataIndex) {
            var bgLayout = $e0de2d726d30d17d$var$getLayout[coord.type](data, dataIndex);
            var bgEl = $e0de2d726d30d17d$var$createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
            bgEl.useStyle(backgroundModel.getItemStyle());
            // Only cartesian2d support borderRadius.
            if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
            else bgEl.setShape('cornerRadius', barBorderRadius);
            bgEls[dataIndex] = bgEl;
            return bgEl;
        }
        data.diff(oldData).add(function(dataIndex) {
            var itemModel = data.getItemModel(dataIndex);
            var layout = $e0de2d726d30d17d$var$getLayout[coord.type](data, dataIndex, itemModel);
            if (drawBackground) createBackground(dataIndex);
            // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
            if (!data.hasValue(dataIndex) || !$e0de2d726d30d17d$var$isValidLayout[coord.type](layout)) return;
            var isClipped = false;
            if (needsClip) // Clip will modify the layout params.
            // And return a boolean to determine if the shape are fully clipped.
            isClipped = $e0de2d726d30d17d$var$clip[coord.type](coordSysClipArea, layout);
            var el = $e0de2d726d30d17d$var$elementCreator[coord.type](seriesModel, data, dataIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, false, roundCap);
            if (realtimeSortCfg) /**
         * Force label animation because even if the element is
         * ignored because it's clipped, it may not be clipped after
         * changing order. Then, if not using forceLabelAnimation,
         * the label animation was never started, in which case,
         * the label will be the final value and doesn't have label
         * animation.
         */ el.forceLabelAnimation = true;
            $e0de2d726d30d17d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $e0de2d726d30d17d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, dataIndex, isHorizontalOrRadial, false, false);
            else (0, $b40111164617dd60$export$a121566aadcfe021)(el, {
                shape: layout
            }, seriesModel, dataIndex);
            data.setItemGraphicEl(dataIndex, el);
            group.add(el);
            el.ignore = isClipped;
        }).update(function(newIndex, oldIndex) {
            var itemModel = data.getItemModel(newIndex);
            var layout = $e0de2d726d30d17d$var$getLayout[coord.type](data, newIndex, itemModel);
            if (drawBackground) {
                var bgEl = void 0;
                if (oldBgEls.length === 0) bgEl = createBackground(oldIndex);
                else {
                    bgEl = oldBgEls[oldIndex];
                    bgEl.useStyle(backgroundModel.getItemStyle());
                    // Only cartesian2d support borderRadius.
                    if (coord.type === 'cartesian2d') bgEl.setShape('r', barBorderRadius);
                    else bgEl.setShape('cornerRadius', barBorderRadius);
                    bgEls[newIndex] = bgEl;
                }
                var bgLayout = $e0de2d726d30d17d$var$getLayout[coord.type](data, newIndex);
                var shape = $e0de2d726d30d17d$var$createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
                (0, $b40111164617dd60$export$c8dce3c08436e91e)(bgEl, {
                    shape: shape
                }, animationModel, newIndex);
            }
            var el = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex) || !$e0de2d726d30d17d$var$isValidLayout[coord.type](layout)) {
                group.remove(el);
                return;
            }
            var isClipped = false;
            if (needsClip) {
                isClipped = $e0de2d726d30d17d$var$clip[coord.type](coordSysClipArea, layout);
                if (isClipped) group.remove(el);
            }
            if (!el) el = $e0de2d726d30d17d$var$elementCreator[coord.type](seriesModel, data, newIndex, layout, isHorizontalOrRadial, animationModel, baseAxis.model, !!el, roundCap);
            else (0, $b40111164617dd60$export$bca7290a9faf0ec9)(el);
            if (realtimeSortCfg) el.forceLabelAnimation = true;
            if (isChangeOrder) {
                var textEl = el.getTextContent();
                if (textEl) {
                    var labelInnerStore = (0, $3828198b2f2de836$export$f62786d3261ab0f4)(textEl);
                    if (labelInnerStore.prevValue != null) /**
             * Set preValue to be value so that no new label
             * should be started, otherwise, it will take a full
             * `animationDurationUpdate` time to finish the
             * animation, which is not expected.
             */ labelInnerStore.prevValue = labelInnerStore.value;
                }
            } else $e0de2d726d30d17d$var$updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
            if (isInitSort) el.attr({
                shape: layout
            });
            else if (realtimeSortCfg) $e0de2d726d30d17d$var$updateRealtimeAnimation(realtimeSortCfg, animationModel, el, layout, newIndex, isHorizontalOrRadial, true, isChangeOrder);
            else (0, $b40111164617dd60$export$c8dce3c08436e91e)(el, {
                shape: layout
            }, seriesModel, newIndex, null);
            data.setItemGraphicEl(newIndex, el);
            el.ignore = isClipped;
            group.add(el);
        }).remove(function(dataIndex) {
            var el = oldData.getItemGraphicEl(dataIndex);
            el && (0, $b40111164617dd60$export$6d0fd725cb4aee8a)(el, seriesModel, dataIndex);
        }).execute();
        var bgGroup = this._backgroundGroup || (this._backgroundGroup = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)());
        bgGroup.removeAll();
        for(var i = 0; i < bgEls.length; ++i)bgGroup.add(bgEls[i]);
        group.add(bgGroup);
        this._backgroundEls = bgEls;
        this._data = data;
    };
    BarView.prototype._renderLarge = function(seriesModel, ecModel, api) {
        this._clear();
        $e0de2d726d30d17d$var$createLarge(seriesModel, this.group);
        this._updateLargeClip(seriesModel);
    };
    BarView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        this._removeBackground();
        $e0de2d726d30d17d$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    BarView.prototype._updateLargeClip = function(seriesModel) {
        // Use clipPath in large mode.
        var clipPath = seriesModel.get('clip', true) && (0, $6206a29b0d1240e0$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        var group = this.group;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
    };
    BarView.prototype._enableRealtimeSort = function(realtimeSortCfg, data, api) {
        var _this = this;
        // If no data in the first frame, wait for data to initSort
        if (!data.count()) return;
        var baseAxis = realtimeSortCfg.baseAxis;
        if (this._isFirstFrame) {
            this._dispatchInitSort(data, realtimeSortCfg, api);
            this._isFirstFrame = false;
        } else {
            var orderMapping_1 = function(idx) {
                var el = data.getItemGraphicEl(idx);
                var shape = el && el.shape;
                return shape && // The result should be consistent with the initial sort by data value.
                // Do not support the case that both positive and negative exist.
                Math.abs(baseAxis.isHorizontal() ? shape.height : shape.width) || 0;
            };
            this._onRendered = function() {
                _this._updateSortWithinSameData(data, orderMapping_1, baseAxis, api);
            };
            api.getZr().on('rendered', this._onRendered);
        }
    };
    BarView.prototype._dataSort = function(data, baseAxis, orderMapping) {
        var info = [];
        data.each(data.mapDimension(baseAxis.dim), function(ordinalNumber, dataIdx) {
            var mappedValue = orderMapping(dataIdx);
            mappedValue = mappedValue == null ? NaN : mappedValue;
            info.push({
                dataIndex: dataIdx,
                mappedValue: mappedValue,
                ordinalNumber: ordinalNumber
            });
        });
        info.sort(function(a, b) {
            // If NaN, it will be treated as min val.
            return b.mappedValue - a.mappedValue;
        });
        return {
            ordinalNumbers: (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(info, function(item) {
                return item.ordinalNumber;
            })
        };
    };
    BarView.prototype._isOrderChangedWithinSameData = function(data, orderMapping, baseAxis) {
        var scale = baseAxis.scale;
        var ordinalDataDim = data.mapDimension(baseAxis.dim);
        var lastValue = Number.MAX_VALUE;
        for(var tickNum = 0, len = scale.getOrdinalMeta().categories.length; tickNum < len; ++tickNum){
            var rawIdx = data.rawIndexOf(ordinalDataDim, scale.getRawOrdinalNumber(tickNum));
            var value = rawIdx < 0 ? Number.MIN_VALUE : orderMapping(data.indexOfRawIndex(rawIdx));
            if (value > lastValue) return true;
            lastValue = value;
        }
        return false;
    };
    /*
   * Consider the case when A and B changed order, whose representing
   * bars are both out of sight, we don't wish to trigger reorder action
   * as long as the order in the view doesn't change.
   */ BarView.prototype._isOrderDifferentInView = function(orderInfo, baseAxis) {
        var scale = baseAxis.scale;
        var extent = scale.getExtent();
        var tickNum = Math.max(0, extent[0]);
        var tickMax = Math.min(extent[1], scale.getOrdinalMeta().categories.length - 1);
        for(; tickNum <= tickMax; ++tickNum){
            if (orderInfo.ordinalNumbers[tickNum] !== scale.getRawOrdinalNumber(tickNum)) return true;
        }
    };
    BarView.prototype._updateSortWithinSameData = function(data, orderMapping, baseAxis, api) {
        if (!this._isOrderChangedWithinSameData(data, orderMapping, baseAxis)) return;
        var sortInfo = this._dataSort(data, baseAxis, orderMapping);
        if (this._isOrderDifferentInView(sortInfo, baseAxis)) {
            this._removeOnRenderedListener(api);
            api.dispatchAction({
                type: 'changeAxisOrder',
                componentType: baseAxis.dim + 'Axis',
                axisId: baseAxis.index,
                sortInfo: sortInfo
            });
        }
    };
    BarView.prototype._dispatchInitSort = function(data, realtimeSortCfg, api) {
        var baseAxis = realtimeSortCfg.baseAxis;
        var sortResult = this._dataSort(data, baseAxis, function(dataIdx) {
            return data.get(data.mapDimension(realtimeSortCfg.otherAxis.dim), dataIdx);
        });
        api.dispatchAction({
            type: 'changeAxisOrder',
            componentType: baseAxis.dim + 'Axis',
            isInitSort: true,
            axisId: baseAxis.index,
            sortInfo: sortResult
        });
    };
    BarView.prototype.remove = function(ecModel, api) {
        this._clear(this._model);
        this._removeOnRenderedListener(api);
    };
    BarView.prototype.dispose = function(ecModel, api) {
        this._removeOnRenderedListener(api);
    };
    BarView.prototype._removeOnRenderedListener = function(api) {
        if (this._onRendered) {
            api.getZr().off('rendered', this._onRendered);
            this._onRendered = null;
        }
    };
    BarView.prototype._clear = function(model) {
        var group = this.group;
        var data = this._data;
        if (model && model.isAnimationEnabled() && data && !this._isLargeDraw) {
            this._removeBackground();
            this._backgroundEls = [];
            data.eachItemGraphicEl(function(el) {
                (0, $b40111164617dd60$export$6d0fd725cb4aee8a)(el, model, (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).dataIndex);
            });
        } else group.removeAll();
        this._data = null;
        this._isFirstFrame = true;
    };
    BarView.prototype._removeBackground = function() {
        this.group.remove(this._backgroundGroup);
        this._backgroundGroup = null;
    };
    BarView.type = 'bar';
    return BarView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $e0de2d726d30d17d$var$clip = {
    cartesian2d: function(coordSysBoundingRect, layout) {
        var signWidth = layout.width < 0 ? -1 : 1;
        var signHeight = layout.height < 0 ? -1 : 1;
        // Needs positive width and height
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        var coordSysX2 = coordSysBoundingRect.x + coordSysBoundingRect.width;
        var coordSysY2 = coordSysBoundingRect.y + coordSysBoundingRect.height;
        var x = $e0de2d726d30d17d$var$mathMax(layout.x, coordSysBoundingRect.x);
        var x2 = $e0de2d726d30d17d$var$mathMin(layout.x + layout.width, coordSysX2);
        var y = $e0de2d726d30d17d$var$mathMax(layout.y, coordSysBoundingRect.y);
        var y2 = $e0de2d726d30d17d$var$mathMin(layout.y + layout.height, coordSysY2);
        var xClipped = x2 < x;
        var yClipped = y2 < y;
        // When xClipped or yClipped, the element will be marked as `ignore`.
        // But we should also place the element at the edge of the coord sys bounding rect.
        // Because if data changed and the bar shows again, its transition animation
        // will begin at this place.
        layout.x = xClipped && x > coordSysX2 ? x2 : x;
        layout.y = yClipped && y > coordSysY2 ? y2 : y;
        layout.width = xClipped ? 0 : x2 - x;
        layout.height = yClipped ? 0 : y2 - y;
        // Reverse back
        if (signWidth < 0) {
            layout.x += layout.width;
            layout.width = -layout.width;
        }
        if (signHeight < 0) {
            layout.y += layout.height;
            layout.height = -layout.height;
        }
        return xClipped || yClipped;
    },
    polar: function(coordSysClipArea, layout) {
        var signR = layout.r0 <= layout.r ? 1 : -1;
        // Make sure r is larger than r0
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        var r = $e0de2d726d30d17d$var$mathMin(layout.r, coordSysClipArea.r);
        var r0 = $e0de2d726d30d17d$var$mathMax(layout.r0, coordSysClipArea.r0);
        layout.r = r;
        layout.r0 = r0;
        var clipped = r - r0 < 0;
        // Reverse back
        if (signR < 0) {
            var tmp = layout.r;
            layout.r = layout.r0;
            layout.r0 = tmp;
        }
        return clipped;
    }
};
var $e0de2d726d30d17d$var$elementCreator = {
    cartesian2d: function(seriesModel, data, newIndex, layout, isHorizontal, animationModel, axisModel, isUpdate, roundCap) {
        var rect = new (0, $37476269d425e3f6$export$2e2bcd8739ae039)({
            shape: (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, layout),
            z2: 1
        });
        rect.__dataIndex = newIndex;
        rect.name = 'item';
        if (animationModel) {
            var rectShape = rect.shape;
            var animateProperty = isHorizontal ? 'height' : 'width';
            rectShape[animateProperty] = 0;
        }
        return rect;
    },
    polar: function(seriesModel, data, newIndex, layout, isRadial, animationModel, axisModel, isUpdate, roundCap) {
        var ShapeClass = !isRadial && roundCap ? (0, $ff7cc14bc4a8408f$export$2e2bcd8739ae039) : (0, $5fa26352e0605e60$export$2e2bcd8739ae039);
        var sector = new ShapeClass({
            shape: layout,
            z2: 1
        });
        sector.name = 'item';
        var positionMap = $e0de2d726d30d17d$var$createPolarPositionMapping(isRadial);
        sector.calculateTextPosition = (0, $b7408b8833e56695$export$359a1e2d210ed734)(positionMap, {
            isRoundCap: ShapeClass === (0, $ff7cc14bc4a8408f$export$2e2bcd8739ae039)
        });
        // Animation
        if (animationModel) {
            var sectorShape = sector.shape;
            var animateProperty = isRadial ? 'r' : 'endAngle';
            var animateTarget = {};
            sectorShape[animateProperty] = isRadial ? layout.r0 : layout.startAngle;
            animateTarget[animateProperty] = layout[animateProperty];
            (isUpdate ? (0, $b40111164617dd60$export$c8dce3c08436e91e) : (0, $b40111164617dd60$export$a121566aadcfe021))(sector, {
                shape: animateTarget
            }, animationModel);
        }
        return sector;
    }
};
function $e0de2d726d30d17d$var$shouldRealtimeSort(seriesModel, coordSys) {
    var realtimeSortOption = seriesModel.get('realtimeSort', true);
    var baseAxis = coordSys.getBaseAxis();
    if (realtimeSortOption && baseAxis.type === 'category' && coordSys.type === 'cartesian2d') return {
        baseAxis: baseAxis,
        otherAxis: coordSys.getOtherAxis(baseAxis)
    };
}
function $e0de2d726d30d17d$var$updateRealtimeAnimation(realtimeSortCfg, seriesAnimationModel, el, layout, newIndex, isHorizontal, isUpdate, isChangeOrder) {
    var seriesTarget;
    var axisTarget;
    if (isHorizontal) {
        axisTarget = {
            x: layout.x,
            width: layout.width
        };
        seriesTarget = {
            y: layout.y,
            height: layout.height
        };
    } else {
        axisTarget = {
            y: layout.y,
            height: layout.height
        };
        seriesTarget = {
            x: layout.x,
            width: layout.width
        };
    }
    if (!isChangeOrder) // Keep the original growth animation if only axis order changed.
    // Not start a new animation.
    (isUpdate ? (0, $b40111164617dd60$export$c8dce3c08436e91e) : (0, $b40111164617dd60$export$a121566aadcfe021))(el, {
        shape: seriesTarget
    }, seriesAnimationModel, newIndex, null);
    var axisAnimationModel = seriesAnimationModel ? realtimeSortCfg.baseAxis.model : null;
    (isUpdate ? (0, $b40111164617dd60$export$c8dce3c08436e91e) : (0, $b40111164617dd60$export$a121566aadcfe021))(el, {
        shape: axisTarget
    }, axisAnimationModel, newIndex);
}
function $e0de2d726d30d17d$var$checkPropertiesNotValid(obj, props) {
    for(var i = 0; i < props.length; i++){
        if (!isFinite(obj[props[i]])) return true;
    }
    return false;
}
var $e0de2d726d30d17d$var$rectPropties = [
    'x',
    'y',
    'width',
    'height'
];
var $e0de2d726d30d17d$var$polarPropties = [
    'cx',
    'cy',
    'r',
    'startAngle',
    'endAngle'
];
var $e0de2d726d30d17d$var$isValidLayout = {
    cartesian2d: function(layout) {
        return !$e0de2d726d30d17d$var$checkPropertiesNotValid(layout, $e0de2d726d30d17d$var$rectPropties);
    },
    polar: function(layout) {
        return !$e0de2d726d30d17d$var$checkPropertiesNotValid(layout, $e0de2d726d30d17d$var$polarPropties);
    }
};
var $e0de2d726d30d17d$var$getLayout = {
    // itemModel is only used to get borderWidth, which is not needed
    // when calculating bar background layout.
    cartesian2d: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        var fixedLineWidth = itemModel ? $e0de2d726d30d17d$var$getLineWidth(itemModel, layout) : 0;
        // fix layout with lineWidth
        var signX = layout.width > 0 ? 1 : -1;
        var signY = layout.height > 0 ? 1 : -1;
        return {
            x: layout.x + signX * fixedLineWidth / 2,
            y: layout.y + signY * fixedLineWidth / 2,
            width: layout.width - signX * fixedLineWidth,
            height: layout.height - signY * fixedLineWidth
        };
    },
    polar: function(data, dataIndex, itemModel) {
        var layout = data.getItemLayout(dataIndex);
        return {
            cx: layout.cx,
            cy: layout.cy,
            r0: layout.r0,
            r: layout.r,
            startAngle: layout.startAngle,
            endAngle: layout.endAngle,
            clockwise: layout.clockwise
        };
    }
};
function $e0de2d726d30d17d$var$isZeroOnPolar(layout) {
    return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
}
function $e0de2d726d30d17d$var$createPolarPositionMapping(isRadial) {
    return function(isRadial) {
        var arcOrAngle = isRadial ? 'Arc' : 'Angle';
        return function(position) {
            switch(position){
                case 'start':
                case 'insideStart':
                case 'end':
                case 'insideEnd':
                    return position + arcOrAngle;
                default:
                    return position;
            }
        };
    }(isRadial);
}
function $e0de2d726d30d17d$var$updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, isPolar) {
    var style = data.getItemVisual(dataIndex, 'style');
    if (!isPolar) {
        var borderRadius = itemModel.get([
            'itemStyle',
            'borderRadius'
        ]) || 0;
        el.setShape('r', borderRadius);
    } else if (!seriesModel.get('roundCap')) {
        var sectorShape = el.shape;
        var cornerRadius = (0, $76e2a0dbb7483b91$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), sectorShape, true);
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(sectorShape, cornerRadius);
        el.setShape(sectorShape);
    }
    el.useStyle(style);
    var cursorStyle = itemModel.getShallow('cursor');
    cursorStyle && el.attr('cursor', cursorStyle);
    var labelPositionOutside = isPolar ? isHorizontalOrRadial ? layout.r >= layout.r0 ? 'endArc' : 'startArc' : layout.endAngle >= layout.startAngle ? 'endAngle' : 'startAngle' : isHorizontalOrRadial ? layout.height >= 0 ? 'bottom' : 'top' : layout.width >= 0 ? 'right' : 'left';
    var labelStatesModels = (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel);
    (0, $3828198b2f2de836$export$9a13992917966657)(el, labelStatesModels, {
        labelFetcher: seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $3aa4a91235bead55$export$5ff20667590927ed)(seriesModel.getData(), dataIndex),
        inheritColor: style.fill,
        defaultOpacity: style.opacity,
        defaultOutsidePosition: labelPositionOutside
    });
    var label = el.getTextContent();
    if (isPolar && label) {
        var position = itemModel.get([
            'label',
            'position'
        ]);
        el.textConfig.inside = position === 'middle' ? true : null;
        (0, $b7408b8833e56695$export$672ce504c0db395a)(el, position === 'outside' ? labelPositionOutside : position, $e0de2d726d30d17d$var$createPolarPositionMapping(isHorizontalOrRadial), itemModel.get([
            'label',
            'rotate'
        ]));
    }
    (0, $3828198b2f2de836$export$7bdbceaf9ab378f2)(label, labelStatesModels, seriesModel.getRawValue(dataIndex), function(value) {
        return (0, $3aa4a91235bead55$export$5f84815e91ca6775)(data, value);
    });
    var emphasisModel = itemModel.getModel([
        'emphasis'
    ]);
    (0, $b414df7d361a211c$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    (0, $b414df7d361a211c$export$48b68047d330bbc9)(el, itemModel);
    if ($e0de2d726d30d17d$var$isZeroOnPolar(layout)) {
        el.style.fill = 'none';
        el.style.stroke = 'none';
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(el.states, function(state) {
            if (state.style) state.style.fill = state.style.stroke = 'none';
        });
    }
}
// In case width or height are too small.
function $e0de2d726d30d17d$var$getLineWidth(itemModel, rawLayout) {
    // Has no border.
    var borderColor = itemModel.get([
        'itemStyle',
        'borderColor'
    ]);
    if (!borderColor || borderColor === 'none') return 0;
    var lineWidth = itemModel.get([
        'itemStyle',
        'borderWidth'
    ]) || 0;
    // width or height may be NaN for empty data
    var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
    var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
    return Math.min(lineWidth, width, height);
}
var $e0de2d726d30d17d$var$LagePathShape = /** @class */ function() {
    function LagePathShape() {}
    return LagePathShape;
}();
var $e0de2d726d30d17d$var$LargePath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LargePath, _super);
    function LargePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeBar';
        return _this;
    }
    LargePath.prototype.getDefaultShape = function() {
        return new $e0de2d726d30d17d$var$LagePathShape();
    };
    LargePath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        var baseDimIdx = this.baseDimIdx;
        var valueDimIdx = 1 - this.baseDimIdx;
        var startPoint = [];
        var size = [];
        var barWidth = this.barWidth;
        for(var i = 0; i < points.length; i += 3){
            size[baseDimIdx] = barWidth;
            size[valueDimIdx] = points[i + 2];
            startPoint[baseDimIdx] = points[i + baseDimIdx];
            startPoint[valueDimIdx] = points[i + valueDimIdx];
            ctx.rect(startPoint[0], startPoint[1], size[0], size[1]);
        }
    };
    return LargePath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
function $e0de2d726d30d17d$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    // TODO support polar
    var data = seriesModel.getData();
    var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
    var largeDataIndices = data.getLayout('largeDataIndices');
    var barWidth = data.getLayout('size');
    var backgroundModel = seriesModel.getModel('backgroundStyle');
    var bgPoints = data.getLayout('largeBackgroundPoints');
    if (bgPoints) {
        var bgEl = new $e0de2d726d30d17d$var$LargePath({
            shape: {
                points: bgPoints
            },
            incremental: !!incremental,
            silent: true,
            z2: 0
        });
        bgEl.baseDimIdx = baseDimIdx;
        bgEl.largeDataIndices = largeDataIndices;
        bgEl.barWidth = barWidth;
        bgEl.useStyle(backgroundModel.getItemStyle());
        group.add(bgEl);
        progressiveEls && progressiveEls.push(bgEl);
    }
    var el = new $e0de2d726d30d17d$var$LargePath({
        shape: {
            points: data.getLayout('largePoints')
        },
        incremental: !!incremental,
        ignoreCoarsePointer: true,
        z2: 1
    });
    el.baseDimIdx = baseDimIdx;
    el.largeDataIndices = largeDataIndices;
    el.barWidth = barWidth;
    group.add(el);
    el.useStyle(data.getVisual('style'));
    // Stroke is rendered first to avoid overlapping with fill
    el.style.stroke = null;
    // Enable tooltip and user mouse/touch event handlers.
    (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).seriesIndex = seriesModel.seriesIndex;
    if (!seriesModel.get('silent')) {
        el.on('mousedown', $e0de2d726d30d17d$var$largePathUpdateDataIndex);
        el.on('mousemove', $e0de2d726d30d17d$var$largePathUpdateDataIndex);
    }
    progressiveEls && progressiveEls.push(el);
}
// Use throttle to avoid frequently traverse to find dataIndex.
var $e0de2d726d30d17d$var$largePathUpdateDataIndex = (0, $ef22ba67fe7cfc59$export$de363e709c412c8a)(function(event) {
    var largePath = this;
    var dataIndex = $e0de2d726d30d17d$var$largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
    (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(largePath).dataIndex = dataIndex >= 0 ? dataIndex : null;
}, 30, false);
function $e0de2d726d30d17d$var$largePathFindDataIndex(largePath, x, y) {
    var baseDimIdx = largePath.baseDimIdx;
    var valueDimIdx = 1 - baseDimIdx;
    var points = largePath.shape.points;
    var largeDataIndices = largePath.largeDataIndices;
    var startPoint = [];
    var size = [];
    var barWidth = largePath.barWidth;
    for(var i = 0, len = points.length / 3; i < len; i++){
        var ii = i * 3;
        size[baseDimIdx] = barWidth;
        size[valueDimIdx] = points[ii + 2];
        startPoint[baseDimIdx] = points[ii + baseDimIdx];
        startPoint[valueDimIdx] = points[ii + valueDimIdx];
        if (size[valueDimIdx] < 0) {
            startPoint[valueDimIdx] += size[valueDimIdx];
            size[valueDimIdx] = -size[valueDimIdx];
        }
        if (x >= startPoint[0] && x <= startPoint[0] + size[0] && y >= startPoint[1] && y <= startPoint[1] + size[1]) return largeDataIndices[i];
    }
    return -1;
}
function $e0de2d726d30d17d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord) {
    if ((0, $9ca39efe18dd5899$export$8567506e6336616)(coord, 'cartesian2d')) {
        var rectShape = layout;
        var coordLayout = coord.getArea();
        return {
            x: isHorizontalOrRadial ? rectShape.x : coordLayout.x,
            y: isHorizontalOrRadial ? coordLayout.y : rectShape.y,
            width: isHorizontalOrRadial ? rectShape.width : coordLayout.width,
            height: isHorizontalOrRadial ? coordLayout.height : rectShape.height
        };
    } else {
        var coordLayout = coord.getArea();
        var sectorShape = layout;
        return {
            cx: coordLayout.cx,
            cy: coordLayout.cy,
            r0: isHorizontalOrRadial ? coordLayout.r0 : sectorShape.r0,
            r: isHorizontalOrRadial ? coordLayout.r : sectorShape.r,
            startAngle: isHorizontalOrRadial ? sectorShape.startAngle : 0,
            endAngle: isHorizontalOrRadial ? sectorShape.endAngle : Math.PI * 2
        };
    }
}
function $e0de2d726d30d17d$var$createBackgroundEl(coord, isHorizontalOrRadial, layout) {
    var ElementClz = coord.type === 'polar' ? (0, $5fa26352e0605e60$export$2e2bcd8739ae039) : (0, $37476269d425e3f6$export$2e2bcd8739ae039);
    return new ElementClz({
        shape: $e0de2d726d30d17d$var$createBackgroundShape(isHorizontalOrRadial, layout, coord),
        silent: true,
        z2: 0
    });
}
var $e0de2d726d30d17d$export$2e2bcd8739ae039 = $e0de2d726d30d17d$var$BarView;


function $9348aed335468b05$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $e0de2d726d30d17d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $92ea9d381bfdb6fe$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2((0, $b069e7ac30ed5deb$export$b3219800bda33a1f), 'bar'));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $b069e7ac30ed5deb$export$16e8685758531cb6)('bar'));
    // Down sample after filter
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $7414668c13eb92e7$export$2e2bcd8739ae039)('bar'));
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'changeAxisOrder',
        event: 'changeAxisOrder',
        update: 'update'
    }, function(payload, ecModel) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            if (payload.sortInfo) componentModel.axis.setCategorySortInfo(payload.sortInfo);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $0cb303fc070de4f6$var$PI2 = Math.PI * 2;
var $0cb303fc070de4f6$var$RADIAN = Math.PI / 180;
function $0cb303fc070de4f6$var$getViewRect(seriesModel, api) {
    return $501dc28f6c4d24ac$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $0cb303fc070de4f6$export$2a0d4d5b12383eb9(seriesModel, api) {
    var viewRect = $0cb303fc070de4f6$var$getViewRect(seriesModel, api);
    // center can be string or number when coordinateSystem is specified
    var center = seriesModel.get('center');
    var radius = seriesModel.get('radius');
    if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(radius)) radius = [
        0,
        radius
    ];
    var width = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(viewRect.width, api.getWidth());
    var height = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(viewRect.height, api.getHeight());
    var size = Math.min(width, height);
    var r0 = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(radius[0], size / 2);
    var r = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(radius[1], size / 2);
    var cx;
    var cy;
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys) {
        // percentage is not allowed when coordinate system is specified
        var point = coordSys.dataToPoint(center);
        cx = point[0] || 0;
        cy = point[1] || 0;
    } else {
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        cx = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[0], width) + viewRect.x;
        cy = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[1], height) + viewRect.y;
    }
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r
    };
}
function $0cb303fc070de4f6$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var viewRect = $0cb303fc070de4f6$var$getViewRect(seriesModel, api);
        var _a = $0cb303fc070de4f6$export$2a0d4d5b12383eb9(seriesModel, api), cx = _a.cx, cy = _a.cy, r = _a.r, r0 = _a.r0;
        var startAngle = -seriesModel.get('startAngle') * $0cb303fc070de4f6$var$RADIAN;
        var endAngle = seriesModel.get('endAngle');
        var padAngle = seriesModel.get('padAngle') * $0cb303fc070de4f6$var$RADIAN;
        endAngle = endAngle === 'auto' ? startAngle - $0cb303fc070de4f6$var$PI2 : -endAngle * $0cb303fc070de4f6$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $0cb303fc070de4f6$var$RADIAN;
        var minAndPadAngle = minAngle + padAngle;
        var validDataCount = 0;
        data.each(valueDim, function(value) {
            !isNaN(value) && validDataCount++;
        });
        var sum = data.getSum(valueDim);
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var clockwise = seriesModel.get('clockwise');
        var roseType = seriesModel.get('roseType');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
        // [0...max]
        var extent = data.getDataExtent(valueDim);
        extent[0] = 0;
        var dir = clockwise ? 1 : -1;
        var angles = [
            startAngle,
            endAngle
        ];
        var halfPadAngle = dir * padAngle / 2;
        (0, $3fd2aad7811d6df2$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0], endAngle = angles[1];
        var layoutData = $0cb303fc070de4f6$export$4e43b88a06b9f223(seriesModel);
        layoutData.startAngle = startAngle;
        layoutData.endAngle = endAngle;
        layoutData.clockwise = clockwise;
        var angleRange = Math.abs(endAngle - startAngle);
        // In the case some sector angle is smaller than minAngle
        var restAngle = angleRange;
        var valueSumLargerThanMinAngle = 0;
        var currentAngle = startAngle;
        data.setLayout({
            viewRect: viewRect,
            r: r
        });
        data.each(valueDim, function(value, idx) {
            var angle;
            if (isNaN(value)) {
                data.setItemLayout(idx, {
                    angle: NaN,
                    startAngle: NaN,
                    endAngle: NaN,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: r0,
                    r: roseType ? NaN : r
                });
                return;
            }
            // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
            if (roseType !== 'area') angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
            else angle = angleRange / validDataCount;
            if (angle < minAndPadAngle) {
                angle = minAndPadAngle;
                restAngle -= minAndPadAngle;
            } else valueSumLargerThanMinAngle += value;
            var endAngle = currentAngle + dir * angle;
            // calculate display angle
            var actualStartAngle = 0;
            var actualEndAngle = 0;
            if (padAngle > angle) {
                actualStartAngle = currentAngle + dir * angle / 2;
                actualEndAngle = actualStartAngle;
            } else {
                actualStartAngle = currentAngle + halfPadAngle;
                actualEndAngle = endAngle - halfPadAngle;
            }
            data.setItemLayout(idx, {
                angle: angle,
                startAngle: actualStartAngle,
                endAngle: actualEndAngle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: r0,
                r: roseType ? (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(value, extent, [
                    r0,
                    r
                ]) : r
            });
            currentAngle = endAngle;
        });
        // Some sector is constrained by minAngle and padAngle
        // Rest sectors needs recalculate angle
        if (restAngle < $0cb303fc070de4f6$var$PI2 && validDataCount) {
            // Average the angle if rest angle is not enough after all angles is
            // Constrained by minAngle and padAngle
            if (restAngle <= 1e-3) {
                var angle_1 = angleRange / validDataCount;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_1 = data.getItemLayout(idx);
                        layout_1.angle = angle_1;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle_1 < padAngle) {
                            actualStartAngle = startAngle + dir * (idx + 0.5) * angle_1;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = startAngle + dir * idx * angle_1 + halfPadAngle;
                            actualEndAngle = startAngle + dir * (idx + 1) * angle_1 - halfPadAngle;
                        }
                        layout_1.startAngle = actualStartAngle;
                        layout_1.endAngle = actualEndAngle;
                    }
                });
            } else {
                unitRadian = restAngle / valueSumLargerThanMinAngle;
                currentAngle = startAngle;
                data.each(valueDim, function(value, idx) {
                    if (!isNaN(value)) {
                        var layout_2 = data.getItemLayout(idx);
                        var angle = layout_2.angle === minAndPadAngle ? minAndPadAngle : value * unitRadian;
                        var actualStartAngle = 0;
                        var actualEndAngle = 0;
                        if (angle < padAngle) {
                            actualStartAngle = currentAngle + dir * angle / 2;
                            actualEndAngle = actualStartAngle;
                        } else {
                            actualStartAngle = currentAngle + halfPadAngle;
                            actualEndAngle = currentAngle + dir * angle - halfPadAngle;
                        }
                        layout_2.startAngle = actualStartAngle;
                        layout_2.endAngle = actualEndAngle;
                        currentAngle += dir * angle;
                    }
                });
            }
        }
    });
}
var $0cb303fc070de4f6$export$4e43b88a06b9f223 = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $2f4b2083cfaef73d$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var legendModels = ecModel.findComponents({
                mainType: 'legend'
            });
            if (!legendModels || !legendModels.length) return;
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                var name = data.getName(idx);
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    // @ts-ignore FIXME: LegendModel
                    if (!legendModels[i].isSelected(name)) return false;
                }
                return true;
            });
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME emphasis label position is not same with normal label position



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $8503bd2779bcc1a6$var$PI2 = Math.PI * 2;
var $8503bd2779bcc1a6$var$CMD = (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039).CMD;
var $8503bd2779bcc1a6$var$DEFAULT_SEARCH_SPACE = [
    'top',
    'right',
    'bottom',
    'left'
];
function $8503bd2779bcc1a6$var$getCandidateAnchor(pos, distance, rect, outPt, outDir) {
    var width = rect.width;
    var height = rect.height;
    switch(pos){
        case 'top':
            outPt.set(rect.x + width / 2, rect.y - distance);
            outDir.set(0, -1);
            break;
        case 'bottom':
            outPt.set(rect.x + width / 2, rect.y + height + distance);
            outDir.set(0, 1);
            break;
        case 'left':
            outPt.set(rect.x - distance, rect.y + height / 2);
            outDir.set(-1, 0);
            break;
        case 'right':
            outPt.set(rect.x + width + distance, rect.y + height / 2);
            outDir.set(1, 0);
            break;
    }
}
function $8503bd2779bcc1a6$var$projectPointToArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y, out) {
    x -= cx;
    y -= cy;
    var d = Math.sqrt(x * x + y * y);
    x /= d;
    y /= d;
    // Intersect point.
    var ox = x * r + cx;
    var oy = y * r + cy;
    if (Math.abs(startAngle - endAngle) % $8503bd2779bcc1a6$var$PI2 < 1e-4) {
        // Is a circle
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    if (anticlockwise) {
        var tmp = startAngle;
        startAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(endAngle);
        endAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(tmp);
    } else {
        startAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(startAngle);
        endAngle = (0, $1851ee851ae60f55$export$d44861331f213635)(endAngle);
    }
    if (startAngle > endAngle) endAngle += $8503bd2779bcc1a6$var$PI2;
    var angle = Math.atan2(y, x);
    if (angle < 0) angle += $8503bd2779bcc1a6$var$PI2;
    if (angle >= startAngle && angle <= endAngle || angle + $8503bd2779bcc1a6$var$PI2 >= startAngle && angle + $8503bd2779bcc1a6$var$PI2 <= endAngle) {
        // Project point is on the arc.
        out[0] = ox;
        out[1] = oy;
        return d - r;
    }
    var x1 = r * Math.cos(startAngle) + cx;
    var y1 = r * Math.sin(startAngle) + cy;
    var x2 = r * Math.cos(endAngle) + cx;
    var y2 = r * Math.sin(endAngle) + cy;
    var d1 = (x1 - x) * (x1 - x) + (y1 - y) * (y1 - y);
    var d2 = (x2 - x) * (x2 - x) + (y2 - y) * (y2 - y);
    if (d1 < d2) {
        out[0] = x1;
        out[1] = y1;
        return Math.sqrt(d1);
    } else {
        out[0] = x2;
        out[1] = y2;
        return Math.sqrt(d2);
    }
}
function $8503bd2779bcc1a6$var$projectPointToLine(x1, y1, x2, y2, x, y, out, limitToEnds) {
    var dx = x - x1;
    var dy = y - y1;
    var dx1 = x2 - x1;
    var dy1 = y2 - y1;
    var lineLen = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    dx1 /= lineLen;
    dy1 /= lineLen;
    // dot product
    var projectedLen = dx * dx1 + dy * dy1;
    var t = projectedLen / lineLen;
    if (limitToEnds) t = Math.min(Math.max(t, 0), 1);
    t *= lineLen;
    var ox = out[0] = x1 + t * dx1;
    var oy = out[1] = y1 + t * dy1;
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
function $8503bd2779bcc1a6$var$projectPointToRect(x1, y1, width, height, x, y, out) {
    if (width < 0) {
        x1 = x1 + width;
        width = -width;
    }
    if (height < 0) {
        y1 = y1 + height;
        height = -height;
    }
    var x2 = x1 + width;
    var y2 = y1 + height;
    var ox = out[0] = Math.min(Math.max(x, x1), x2);
    var oy = out[1] = Math.min(Math.max(y, y1), y2);
    return Math.sqrt((ox - x) * (ox - x) + (oy - y) * (oy - y));
}
var $8503bd2779bcc1a6$var$tmpPt = [];
function $8503bd2779bcc1a6$var$nearestPointOnRect(pt, rect, out) {
    var dist = $8503bd2779bcc1a6$var$projectPointToRect(rect.x, rect.y, rect.width, rect.height, pt.x, pt.y, $8503bd2779bcc1a6$var$tmpPt);
    out.set($8503bd2779bcc1a6$var$tmpPt[0], $8503bd2779bcc1a6$var$tmpPt[1]);
    return dist;
}
/**
 * Calculate min distance corresponding point.
 * This method won't evaluate if point is in the path.
 */ function $8503bd2779bcc1a6$var$nearestPointOnPath(pt, path, out) {
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    var x1;
    var y1;
    var minDist = Infinity;
    var data = path.data;
    var x = pt.x;
    var y = pt.y;
    for(var i = 0; i < data.length;){
        var cmd = data[i++];
        if (i === 1) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
        }
        var d = minDist;
        switch(cmd){
            case $8503bd2779bcc1a6$var$CMD.M:
                // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
                // 在 closePath 的时候使用
                x0 = data[i++];
                y0 = data[i++];
                xi = x0;
                yi = y0;
                break;
            case $8503bd2779bcc1a6$var$CMD.L:
                d = $8503bd2779bcc1a6$var$projectPointToLine(xi, yi, data[i], data[i + 1], x, y, $8503bd2779bcc1a6$var$tmpPt, true);
                xi = data[i++];
                yi = data[i++];
                break;
            case $8503bd2779bcc1a6$var$CMD.C:
                d = (0, $eea9463646207a7b$export$dbaa3801d1284367)(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y, $8503bd2779bcc1a6$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $8503bd2779bcc1a6$var$CMD.Q:
                d = (0, $eea9463646207a7b$export$81915a594fe10dee)(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y, $8503bd2779bcc1a6$var$tmpPt);
                xi = data[i++];
                yi = data[i++];
                break;
            case $8503bd2779bcc1a6$var$CMD.A:
                // TODO Arc 判断的开销比较大
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var theta = data[i++];
                var dTheta = data[i++];
                // TODO Arc 旋转
                i += 1;
                var anticlockwise = !!(1 - data[i++]);
                x1 = Math.cos(theta) * rx + cx;
                y1 = Math.sin(theta) * ry + cy;
                // 不是直接使用 arc 命令
                if (i <= 1) {
                    // 第一个命令起点还未定义
                    x0 = x1;
                    y0 = y1;
                }
                // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
                var _x = (x - cx) * ry / rx + cx;
                d = $8503bd2779bcc1a6$var$projectPointToArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y, $8503bd2779bcc1a6$var$tmpPt);
                xi = Math.cos(theta + dTheta) * rx + cx;
                yi = Math.sin(theta + dTheta) * ry + cy;
                break;
            case $8503bd2779bcc1a6$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                var width = data[i++];
                var height = data[i++];
                d = $8503bd2779bcc1a6$var$projectPointToRect(x0, y0, width, height, x, y, $8503bd2779bcc1a6$var$tmpPt);
                break;
            case $8503bd2779bcc1a6$var$CMD.Z:
                d = $8503bd2779bcc1a6$var$projectPointToLine(xi, yi, x0, y0, x, y, $8503bd2779bcc1a6$var$tmpPt, true);
                xi = x0;
                yi = y0;
                break;
        }
        if (d < minDist) {
            minDist = d;
            out.set($8503bd2779bcc1a6$var$tmpPt[0], $8503bd2779bcc1a6$var$tmpPt[1]);
        }
    }
    return minDist;
}
// Temporal variable for intermediate usage.
var $8503bd2779bcc1a6$var$pt0 = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $8503bd2779bcc1a6$var$pt1 = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $8503bd2779bcc1a6$var$pt2 = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $8503bd2779bcc1a6$var$dir = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
var $8503bd2779bcc1a6$var$dir2 = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
function $8503bd2779bcc1a6$export$cc93ba643cd97d83(target, labelLineModel) {
    if (!target) return;
    var labelLine = target.getTextGuideLine();
    var label = target.getTextContent();
    // Needs to create text guide in each charts.
    if (!(label && labelLine)) return;
    var labelGuideConfig = target.textGuideLineConfig || {};
    var points = [
        [
            0,
            0
        ],
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    var searchSpace = labelGuideConfig.candidates || $8503bd2779bcc1a6$var$DEFAULT_SEARCH_SPACE;
    var labelRect = label.getBoundingRect().clone();
    labelRect.applyTransform(label.getComputedTransform());
    var minDist = Infinity;
    var anchorPoint = labelGuideConfig.anchor;
    var targetTransform = target.getComputedTransform();
    var targetInversedTransform = targetTransform && (0, $78537c687449356c$export$6897c284b6f9f4dc)([], targetTransform);
    var len = labelLineModel.get('length2') || 0;
    if (anchorPoint) $8503bd2779bcc1a6$var$pt2.copy(anchorPoint);
    for(var i = 0; i < searchSpace.length; i++){
        var candidate = searchSpace[i];
        $8503bd2779bcc1a6$var$getCandidateAnchor(candidate, 0, labelRect, $8503bd2779bcc1a6$var$pt0, $8503bd2779bcc1a6$var$dir);
        (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).scaleAndAdd($8503bd2779bcc1a6$var$pt1, $8503bd2779bcc1a6$var$pt0, $8503bd2779bcc1a6$var$dir, len);
        // Transform to target coord space.
        $8503bd2779bcc1a6$var$pt1.transform(targetInversedTransform);
        // Note: getBoundingRect will ensure the `path` being created.
        var boundingRect = target.getBoundingRect();
        var dist = anchorPoint ? anchorPoint.distance($8503bd2779bcc1a6$var$pt1) : target instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039) ? $8503bd2779bcc1a6$var$nearestPointOnPath($8503bd2779bcc1a6$var$pt1, target.path, $8503bd2779bcc1a6$var$pt2) : $8503bd2779bcc1a6$var$nearestPointOnRect($8503bd2779bcc1a6$var$pt1, boundingRect, $8503bd2779bcc1a6$var$pt2);
        // TODO pt2 is in the path
        if (dist < minDist) {
            minDist = dist;
            // Transform back to global space.
            $8503bd2779bcc1a6$var$pt1.transform(targetTransform);
            $8503bd2779bcc1a6$var$pt2.transform(targetTransform);
            $8503bd2779bcc1a6$var$pt2.toArray(points[0]);
            $8503bd2779bcc1a6$var$pt1.toArray(points[1]);
            $8503bd2779bcc1a6$var$pt0.toArray(points[2]);
        }
    }
    $8503bd2779bcc1a6$export$ac52062003fbe6a(points, labelLineModel.get('minTurnAngle'));
    labelLine.setShape({
        points: points
    });
}
// Temporal variable for the limitTurnAngle function
var $8503bd2779bcc1a6$var$tmpArr = [];
var $8503bd2779bcc1a6$var$tmpProjPoint = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
function $8503bd2779bcc1a6$export$ac52062003fbe6a(linePoints, minTurnAngle) {
    if (!(minTurnAngle <= 180 && minTurnAngle > 0)) return;
    minTurnAngle = minTurnAngle / 180 * Math.PI;
    // The line points can be
    //      /pt1----pt2 (label)
    //     /
    // pt0/
    $8503bd2779bcc1a6$var$pt0.fromArray(linePoints[0]);
    $8503bd2779bcc1a6$var$pt1.fromArray(linePoints[1]);
    $8503bd2779bcc1a6$var$pt2.fromArray(linePoints[2]);
    (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub($8503bd2779bcc1a6$var$dir, $8503bd2779bcc1a6$var$pt0, $8503bd2779bcc1a6$var$pt1);
    (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub($8503bd2779bcc1a6$var$dir2, $8503bd2779bcc1a6$var$pt2, $8503bd2779bcc1a6$var$pt1);
    var len1 = $8503bd2779bcc1a6$var$dir.len();
    var len2 = $8503bd2779bcc1a6$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $8503bd2779bcc1a6$var$dir.scale(1 / len1);
    $8503bd2779bcc1a6$var$dir2.scale(1 / len2);
    var angleCos = $8503bd2779bcc1a6$var$dir.dot($8503bd2779bcc1a6$var$dir2);
    var minTurnAngleCos = Math.cos(minTurnAngle);
    if (minTurnAngleCos < angleCos) {
        // Smaller than minTurnAngle
        // Calculate project point of pt0 on pt1-pt2
        var d = $8503bd2779bcc1a6$var$projectPointToLine($8503bd2779bcc1a6$var$pt1.x, $8503bd2779bcc1a6$var$pt1.y, $8503bd2779bcc1a6$var$pt2.x, $8503bd2779bcc1a6$var$pt2.y, $8503bd2779bcc1a6$var$pt0.x, $8503bd2779bcc1a6$var$pt0.y, $8503bd2779bcc1a6$var$tmpArr, false);
        $8503bd2779bcc1a6$var$tmpProjPoint.fromArray($8503bd2779bcc1a6$var$tmpArr);
        // Calculate new projected length with limited minTurnAngle and get the new connect point
        $8503bd2779bcc1a6$var$tmpProjPoint.scaleAndAdd($8503bd2779bcc1a6$var$dir2, d / Math.tan(Math.PI - minTurnAngle));
        // Limit the new calculated connect point between pt1 and pt2.
        var t = $8503bd2779bcc1a6$var$pt2.x !== $8503bd2779bcc1a6$var$pt1.x ? ($8503bd2779bcc1a6$var$tmpProjPoint.x - $8503bd2779bcc1a6$var$pt1.x) / ($8503bd2779bcc1a6$var$pt2.x - $8503bd2779bcc1a6$var$pt1.x) : ($8503bd2779bcc1a6$var$tmpProjPoint.y - $8503bd2779bcc1a6$var$pt1.y) / ($8503bd2779bcc1a6$var$pt2.y - $8503bd2779bcc1a6$var$pt1.y);
        if (isNaN(t)) return;
        if (t < 0) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).copy($8503bd2779bcc1a6$var$tmpProjPoint, $8503bd2779bcc1a6$var$pt1);
        else if (t > 1) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).copy($8503bd2779bcc1a6$var$tmpProjPoint, $8503bd2779bcc1a6$var$pt2);
        $8503bd2779bcc1a6$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $8503bd2779bcc1a6$export$973e1fdb2708f71b(linePoints, surfaceNormal, maxSurfaceAngle) {
    if (!(maxSurfaceAngle <= 180 && maxSurfaceAngle > 0)) return;
    maxSurfaceAngle = maxSurfaceAngle / 180 * Math.PI;
    $8503bd2779bcc1a6$var$pt0.fromArray(linePoints[0]);
    $8503bd2779bcc1a6$var$pt1.fromArray(linePoints[1]);
    $8503bd2779bcc1a6$var$pt2.fromArray(linePoints[2]);
    (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub($8503bd2779bcc1a6$var$dir, $8503bd2779bcc1a6$var$pt1, $8503bd2779bcc1a6$var$pt0);
    (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub($8503bd2779bcc1a6$var$dir2, $8503bd2779bcc1a6$var$pt2, $8503bd2779bcc1a6$var$pt1);
    var len1 = $8503bd2779bcc1a6$var$dir.len();
    var len2 = $8503bd2779bcc1a6$var$dir2.len();
    if (len1 < 1e-3 || len2 < 1e-3) return;
    $8503bd2779bcc1a6$var$dir.scale(1 / len1);
    $8503bd2779bcc1a6$var$dir2.scale(1 / len2);
    var angleCos = $8503bd2779bcc1a6$var$dir.dot(surfaceNormal);
    var maxSurfaceAngleCos = Math.cos(maxSurfaceAngle);
    if (angleCos < maxSurfaceAngleCos) {
        // Calculate project point of pt0 on pt1-pt2
        var d = $8503bd2779bcc1a6$var$projectPointToLine($8503bd2779bcc1a6$var$pt1.x, $8503bd2779bcc1a6$var$pt1.y, $8503bd2779bcc1a6$var$pt2.x, $8503bd2779bcc1a6$var$pt2.y, $8503bd2779bcc1a6$var$pt0.x, $8503bd2779bcc1a6$var$pt0.y, $8503bd2779bcc1a6$var$tmpArr, false);
        $8503bd2779bcc1a6$var$tmpProjPoint.fromArray($8503bd2779bcc1a6$var$tmpArr);
        var HALF_PI = Math.PI / 2;
        var angle2 = Math.acos($8503bd2779bcc1a6$var$dir2.dot(surfaceNormal));
        var newAngle = HALF_PI + angle2 - maxSurfaceAngle;
        if (newAngle >= HALF_PI) // parallel
        (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).copy($8503bd2779bcc1a6$var$tmpProjPoint, $8503bd2779bcc1a6$var$pt2);
        else {
            // Calculate new projected length with limited minTurnAngle and get the new connect point
            $8503bd2779bcc1a6$var$tmpProjPoint.scaleAndAdd($8503bd2779bcc1a6$var$dir2, d / Math.tan(Math.PI / 2 - newAngle));
            // Limit the new calculated connect point between pt1 and pt2.
            var t = $8503bd2779bcc1a6$var$pt2.x !== $8503bd2779bcc1a6$var$pt1.x ? ($8503bd2779bcc1a6$var$tmpProjPoint.x - $8503bd2779bcc1a6$var$pt1.x) / ($8503bd2779bcc1a6$var$pt2.x - $8503bd2779bcc1a6$var$pt1.x) : ($8503bd2779bcc1a6$var$tmpProjPoint.y - $8503bd2779bcc1a6$var$pt1.y) / ($8503bd2779bcc1a6$var$pt2.y - $8503bd2779bcc1a6$var$pt1.y);
            if (isNaN(t)) return;
            if (t < 0) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).copy($8503bd2779bcc1a6$var$tmpProjPoint, $8503bd2779bcc1a6$var$pt1);
            else if (t > 1) (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).copy($8503bd2779bcc1a6$var$tmpProjPoint, $8503bd2779bcc1a6$var$pt2);
        }
        $8503bd2779bcc1a6$var$tmpProjPoint.toArray(linePoints[1]);
    }
}
function $8503bd2779bcc1a6$var$setLabelLineState(labelLine, ignore, stateName, stateModel) {
    var isNormal = stateName === 'normal';
    var stateObj = isNormal ? labelLine : labelLine.ensureState(stateName);
    // Make sure display.
    stateObj.ignore = ignore;
    // Set smooth
    var smooth = stateModel.get('smooth');
    if (smooth && smooth === true) smooth = 0.3;
    stateObj.shape = stateObj.shape || {};
    if (smooth > 0) stateObj.shape.smooth = smooth;
    var styleObj = stateModel.getModel('lineStyle').getLineStyle();
    isNormal ? labelLine.useStyle(styleObj) : stateObj.style = styleObj;
}
function $8503bd2779bcc1a6$var$buildLabelLinePath(path, shape) {
    var smooth = shape.smooth;
    var points = shape.points;
    if (!points) return;
    path.moveTo(points[0][0], points[0][1]);
    if (smooth > 0 && points.length >= 3) {
        var len1 = $3dde7d051fe20daa$export$6c4a311cc157c764(points[0], points[1]);
        var len2 = $3dde7d051fe20daa$export$6c4a311cc157c764(points[1], points[2]);
        if (!len1 || !len2) {
            path.lineTo(points[1][0], points[1][1]);
            path.lineTo(points[2][0], points[2][1]);
            return;
        }
        var moveLen = Math.min(len1, len2) * smooth;
        var midPoint0 = $3dde7d051fe20daa$export$3a89f8d6f6bf6c9f([], points[1], points[0], moveLen / len1);
        var midPoint2 = $3dde7d051fe20daa$export$3a89f8d6f6bf6c9f([], points[1], points[2], moveLen / len2);
        var midPoint1 = $3dde7d051fe20daa$export$3a89f8d6f6bf6c9f([], midPoint0, midPoint2, 0.5);
        path.bezierCurveTo(midPoint0[0], midPoint0[1], midPoint0[0], midPoint0[1], midPoint1[0], midPoint1[1]);
        path.bezierCurveTo(midPoint2[0], midPoint2[1], midPoint2[0], midPoint2[1], points[2][0], points[2][1]);
    } else for(var i = 1; i < points.length; i++)path.lineTo(points[i][0], points[i][1]);
}
function $8503bd2779bcc1a6$export$c09e0b0574bdd2dc(targetEl, statesModels, defaultStyle) {
    var labelLine = targetEl.getTextGuideLine();
    var label = targetEl.getTextContent();
    if (!label) {
        // Not show label line if there is no label.
        if (labelLine) targetEl.removeTextGuideLine();
        return;
    }
    var normalModel = statesModels.normal;
    var showNormal = normalModel.get('show');
    var labelIgnoreNormal = label.ignore;
    for(var i = 0; i < (0, $b414df7d361a211c$export$57ee5306b85ad7d5).length; i++){
        var stateName = (0, $b414df7d361a211c$export$57ee5306b85ad7d5)[i];
        var stateModel = statesModels[stateName];
        var isNormal = stateName === 'normal';
        if (stateModel) {
            var stateShow = stateModel.get('show');
            var isLabelIgnored = isNormal ? labelIgnoreNormal : (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(label.states[stateName] && label.states[stateName].ignore, labelIgnoreNormal);
            if (isLabelIgnored // Not show when label is not shown in this state.
             || !(0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(stateShow, showNormal) // Use normal state by default if not set.
            ) {
                var stateObj = isNormal ? labelLine : labelLine && labelLine.states[stateName];
                if (stateObj) stateObj.ignore = true;
                if (!!labelLine) $8503bd2779bcc1a6$var$setLabelLineState(labelLine, true, stateName, stateModel);
                continue;
            }
            // Create labelLine if not exists
            if (!labelLine) {
                labelLine = new (0, $f7f6523750aec7c8$export$2e2bcd8739ae039)();
                targetEl.setTextGuideLine(labelLine);
                // Reset state of normal because it's new created.
                // NOTE: NORMAL should always been the first!
                if (!isNormal && (labelIgnoreNormal || !showNormal)) $8503bd2779bcc1a6$var$setLabelLineState(labelLine, true, 'normal', statesModels.normal);
                // Use same state proxy.
                if (targetEl.stateProxy) labelLine.stateProxy = targetEl.stateProxy;
            }
            $8503bd2779bcc1a6$var$setLabelLineState(labelLine, false, stateName, stateModel);
        }
    }
    if (labelLine) {
        (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(labelLine.style, defaultStyle);
        // Not fill.
        labelLine.style.fill = null;
        var showAbove = normalModel.get('showAbove');
        var labelLineConfig = targetEl.textGuideLineConfig = targetEl.textGuideLineConfig || {};
        labelLineConfig.showAbove = showAbove || false;
        // Custom the buildPath.
        labelLine.buildPath = $8503bd2779bcc1a6$var$buildLabelLinePath;
    }
}
function $8503bd2779bcc1a6$export$2979fdbf5ebce521(itemModel, labelLineName) {
    labelLineName = labelLineName || 'labelLine';
    var statesModels = {
        normal: itemModel.getModel(labelLineName)
    };
    for(var i = 0; i < (0, $b414df7d361a211c$export$151308dceb52d5b).length; i++){
        var stateName = (0, $b414df7d361a211c$export$151308dceb52d5b)[i];
        statesModels[stateName] = itemModel.getModel([
            stateName,
            labelLineName
        ]);
    }
    return statesModels;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $59fb24bbd5ce7072$export$6c403cad1ae3e239(input) {
    var list = [];
    for(var i = 0; i < input.length; i++){
        var rawItem = input[i];
        if (rawItem.defaultAttr.ignore) continue;
        var label = rawItem.label;
        var transform = label.getComputedTransform();
        // NOTE: Get bounding rect after getComputedTransform, or label may not been updated by the host el.
        var localRect = label.getBoundingRect();
        var isAxisAligned = !transform || transform[1] < 1e-5 && transform[2] < 1e-5;
        var minMargin = label.style.margin || 0;
        var globalRect = localRect.clone();
        globalRect.applyTransform(transform);
        globalRect.x -= minMargin / 2;
        globalRect.y -= minMargin / 2;
        globalRect.width += minMargin;
        globalRect.height += minMargin;
        var obb = isAxisAligned ? new (0, $95e9c620abdf35f3$export$2e2bcd8739ae039)(localRect, transform) : null;
        list.push({
            label: label,
            labelLine: rawItem.labelLine,
            rect: globalRect,
            localRect: localRect,
            obb: obb,
            priority: rawItem.priority,
            defaultAttr: rawItem.defaultAttr,
            layoutOption: rawItem.computedLayoutOption,
            axisAligned: isAxisAligned,
            transform: transform
        });
    }
    return list;
}
function $59fb24bbd5ce7072$var$shiftLayout(list, xyDim, sizeDim, minBound, maxBound, balanceShift) {
    var len = list.length;
    if (len < 2) return;
    list.sort(function(a, b) {
        return a.rect[xyDim] - b.rect[xyDim];
    });
    var lastPos = 0;
    var delta;
    var adjusted = false;
    var shifts = [];
    var totalShifts = 0;
    for(var i = 0; i < len; i++){
        var item = list[i];
        var rect = item.rect;
        delta = rect[xyDim] - lastPos;
        if (delta < 0) {
            // shiftForward(i, len, -delta);
            rect[xyDim] -= delta;
            item.label[xyDim] -= delta;
            adjusted = true;
        }
        var shift = Math.max(-delta, 0);
        shifts.push(shift);
        totalShifts += shift;
        lastPos = rect[xyDim] + rect[sizeDim];
    }
    if (totalShifts > 0 && balanceShift) // Shift back to make the distribution more equally.
    shiftList(-totalShifts / len, 0, len);
    // TODO bleedMargin?
    var first = list[0];
    var last = list[len - 1];
    var minGap;
    var maxGap;
    updateMinMaxGap();
    // If ends exceed two bounds, squeeze at most 80%, then take the gap of two bounds.
    minGap < 0 && squeezeGaps(-minGap, 0.8);
    maxGap < 0 && squeezeGaps(maxGap, 0.8);
    updateMinMaxGap();
    takeBoundsGap(minGap, maxGap, 1);
    takeBoundsGap(maxGap, minGap, -1);
    // Handle bailout when there is not enough space.
    updateMinMaxGap();
    if (minGap < 0) squeezeWhenBailout(-minGap);
    if (maxGap < 0) squeezeWhenBailout(maxGap);
    function updateMinMaxGap() {
        minGap = first.rect[xyDim] - minBound;
        maxGap = maxBound - last.rect[xyDim] - last.rect[sizeDim];
    }
    function takeBoundsGap(gapThisBound, gapOtherBound, moveDir) {
        if (gapThisBound < 0) {
            // Move from other gap if can.
            var moveFromMaxGap = Math.min(gapOtherBound, -gapThisBound);
            if (moveFromMaxGap > 0) {
                shiftList(moveFromMaxGap * moveDir, 0, len);
                var remained = moveFromMaxGap + gapThisBound;
                if (remained < 0) squeezeGaps(-remained * moveDir, 1);
            } else squeezeGaps(-gapThisBound * moveDir, 1);
        }
    }
    function shiftList(delta, start, end) {
        if (delta !== 0) adjusted = true;
        for(var i = start; i < end; i++){
            var item = list[i];
            var rect = item.rect;
            rect[xyDim] += delta;
            item.label[xyDim] += delta;
        }
    }
    // Squeeze gaps if the labels exceed margin.
    function squeezeGaps(delta, maxSqeezePercent) {
        var gaps = [];
        var totalGaps = 0;
        for(var i = 1; i < len; i++){
            var prevItemRect = list[i - 1].rect;
            var gap = Math.max(list[i].rect[xyDim] - prevItemRect[xyDim] - prevItemRect[sizeDim], 0);
            gaps.push(gap);
            totalGaps += gap;
        }
        if (!totalGaps) return;
        var squeezePercent = Math.min(Math.abs(delta) / totalGaps, maxSqeezePercent);
        if (delta > 0) for(var i = 0; i < len - 1; i++){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i] * squeezePercent;
            // Forward
            shiftList(movement, 0, i + 1);
        }
        else // Backward
        for(var i = len - 1; i > 0; i--){
            // Distribute the shift delta to all gaps.
            var movement = gaps[i - 1] * squeezePercent;
            shiftList(-movement, i, len);
        }
    }
    /**
   * Squeeze to allow overlap if there is no more space available.
   * Let other overlapping strategy like hideOverlap do the job instead of keep exceeding the bounds.
   */ function squeezeWhenBailout(delta) {
        var dir = delta < 0 ? -1 : 1;
        delta = Math.abs(delta);
        var moveForEachLabel = Math.ceil(delta / (len - 1));
        for(var i = 0; i < len - 1; i++){
            if (dir > 0) // Forward
            shiftList(moveForEachLabel, 0, i + 1);
            else // Backward
            shiftList(-moveForEachLabel, len - i - 1, len);
            delta -= moveForEachLabel;
            if (delta <= 0) return;
        }
    }
    return adjusted;
}
function $59fb24bbd5ce7072$export$b6b2b07f8ed32bd6(list, leftBound, rightBound, // If average the shifts on all labels and add them to 0
// TODO: Not sure if should enable it.
// Pros: The angle of lines will distribute more equally
// Cons: In some layout. It may not what user wanted. like in pie. the label of last sector is usually changed unexpectedly.
balanceShift) {
    return $59fb24bbd5ce7072$var$shiftLayout(list, 'x', 'width', leftBound, rightBound, balanceShift);
}
function $59fb24bbd5ce7072$export$118c25e0932528e4(list, topBound, bottomBound, // If average the shifts on all labels and add them to 0
balanceShift) {
    return $59fb24bbd5ce7072$var$shiftLayout(list, 'y', 'height', topBound, bottomBound, balanceShift);
}
function $59fb24bbd5ce7072$export$8ce774e164a49410(labelList) {
    var displayedLabels = [];
    // TODO, render overflow visible first, put in the displayedLabels.
    labelList.sort(function(a, b) {
        return b.priority - a.priority;
    });
    var globalRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0);
    function hideEl(el) {
        if (!el.ignore) {
            // Show on emphasis.
            var emphasisState = el.ensureState('emphasis');
            if (emphasisState.ignore == null) emphasisState.ignore = false;
        }
        el.ignore = true;
    }
    for(var i = 0; i < labelList.length; i++){
        var labelItem = labelList[i];
        var isAxisAligned = labelItem.axisAligned;
        var localRect = labelItem.localRect;
        var transform = labelItem.transform;
        var label = labelItem.label;
        var labelLine = labelItem.labelLine;
        globalRect.copy(labelItem.rect);
        // Add a threshold because layout may be aligned precisely.
        globalRect.width -= 0.1;
        globalRect.height -= 0.1;
        globalRect.x += 0.05;
        globalRect.y += 0.05;
        var obb = labelItem.obb;
        var overlapped = false;
        for(var j = 0; j < displayedLabels.length; j++){
            var existsTextCfg = displayedLabels[j];
            // Fast rejection.
            if (!globalRect.intersect(existsTextCfg.rect)) continue;
            if (isAxisAligned && existsTextCfg.axisAligned) {
                // Is overlapped
                overlapped = true;
                break;
            }
            if (!existsTextCfg.obb) // If self is not axis aligned. But other is.
            existsTextCfg.obb = new (0, $95e9c620abdf35f3$export$2e2bcd8739ae039)(existsTextCfg.localRect, existsTextCfg.transform);
            if (!obb) // If self is axis aligned. But other is not.
            obb = new (0, $95e9c620abdf35f3$export$2e2bcd8739ae039)(localRect, transform);
            if (obb.intersect(existsTextCfg.obb)) {
                overlapped = true;
                break;
            }
        }
        // TODO Callback to determine if this overlap should be handled?
        if (overlapped) {
            hideEl(label);
            labelLine && hideEl(labelLine);
        } else {
            label.attr('ignore', labelItem.defaultAttr.ignore);
            labelLine && labelLine.attr('ignore', labelItem.defaultAttr.labelGuideIgnore);
            displayedLabels.push(labelItem);
        }
    }
}


var $a43531ab8c5f16d6$var$RADIAN = Math.PI / 180;
function $a43531ab8c5f16d6$var$adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
    if (list.length < 2) return;
    function recalculateXOnSemiToAlignOnEllipseCurve(semi) {
        var rB = semi.rB;
        var rB2 = rB * rB;
        for(var i = 0; i < semi.list.length; i++){
            var item = semi.list[i];
            var dy = Math.abs(item.label.y - cy);
            // horizontal r is always same with original r because x is not changed.
            var rA = r + item.len;
            var rA2 = rA * rA;
            // Use ellipse implicit function to calculate x
            var dx = Math.sqrt(Math.abs((1 - dy * dy / rB2) * rA2));
            var newX = cx + (dx + item.len2) * dir;
            var deltaX = newX - item.label.x;
            var newTargetWidth = item.targetTextWidth - deltaX * dir;
            // text x is changed, so need to recalculate width.
            $a43531ab8c5f16d6$var$constrainTextWidth(item, newTargetWidth, true);
            item.label.x = newX;
        }
    }
    // Adjust X based on the shifted y. Make tight labels aligned on an ellipse curve.
    function recalculateX(items) {
        // Extremes of
        var topSemi = {
            list: [],
            maxY: 0
        };
        var bottomSemi = {
            list: [],
            maxY: 0
        };
        for(var i = 0; i < items.length; i++){
            if (items[i].labelAlignTo !== 'none') continue;
            var item = items[i];
            var semi = item.label.y > cy ? bottomSemi : topSemi;
            var dy = Math.abs(item.label.y - cy);
            if (dy >= semi.maxY) {
                var dx = item.label.x - cx - item.len2 * dir;
                // horizontal r is always same with original r because x is not changed.
                var rA = r + item.len;
                // Canculate rB based on the topest / bottemest label.
                var rB = Math.abs(dx) < rA ? Math.sqrt(dy * dy / (1 - dx * dx / rA / rA)) : rA;
                semi.rB = rB;
                semi.maxY = dy;
            }
            semi.list.push(item);
        }
        recalculateXOnSemiToAlignOnEllipseCurve(topSemi);
        recalculateXOnSemiToAlignOnEllipseCurve(bottomSemi);
    }
    var len = list.length;
    for(var i = 0; i < len; i++)if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
        var dx = list[i].label.x - farthestX;
        list[i].linePoints[1][0] += dx;
        list[i].label.x = farthestX;
    }
    if ((0, $59fb24bbd5ce7072$export$118c25e0932528e4)(list, viewTop, viewTop + viewHeight)) recalculateX(list);
}
function $a43531ab8c5f16d6$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
    var leftList = [];
    var rightList = [];
    var leftmostX = Number.MAX_VALUE;
    var rightmostX = -Number.MAX_VALUE;
    for(var i = 0; i < labelLayoutList.length; i++){
        var label = labelLayoutList[i].label;
        if ($a43531ab8c5f16d6$var$isPositionCenter(labelLayoutList[i])) continue;
        if (label.x < cx) {
            leftmostX = Math.min(leftmostX, label.x);
            leftList.push(labelLayoutList[i]);
        } else {
            rightmostX = Math.max(rightmostX, label.x);
            rightList.push(labelLayoutList[i]);
        }
    }
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$a43531ab8c5f16d6$var$isPositionCenter(layout) && layout.linePoints) {
            if (layout.labelStyleWidth != null) continue;
            var label = layout.label;
            var linePoints = layout.linePoints;
            var targetTextWidth = void 0;
            if (layout.labelAlignTo === 'edge') {
                if (label.x < cx) targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.edgeDistance;
                else targetTextWidth = viewLeft + viewWidth - layout.edgeDistance - linePoints[2][0] - layout.labelDistance;
            } else if (layout.labelAlignTo === 'labelLine') {
                if (label.x < cx) targetTextWidth = leftmostX - viewLeft - layout.bleedMargin;
                else targetTextWidth = viewLeft + viewWidth - rightmostX - layout.bleedMargin;
            } else if (label.x < cx) targetTextWidth = label.x - viewLeft - layout.bleedMargin;
            else targetTextWidth = viewLeft + viewWidth - label.x - layout.bleedMargin;
            layout.targetTextWidth = targetTextWidth;
            $a43531ab8c5f16d6$var$constrainTextWidth(layout, targetTextWidth);
        }
    }
    $a43531ab8c5f16d6$var$adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
    $a43531ab8c5f16d6$var$adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        if (!$a43531ab8c5f16d6$var$isPositionCenter(layout) && layout.linePoints) {
            var label = layout.label;
            var linePoints = layout.linePoints;
            var isAlignToEdge = layout.labelAlignTo === 'edge';
            var padding = label.style.padding;
            var paddingH = padding ? padding[1] + padding[3] : 0;
            // textRect.width already contains paddingH if bgColor is set
            var extraPaddingH = label.style.backgroundColor ? 0 : paddingH;
            var realTextWidth = layout.rect.width + extraPaddingH;
            var dist = linePoints[1][0] - linePoints[2][0];
            if (isAlignToEdge) {
                if (label.x < cx) linePoints[2][0] = viewLeft + layout.edgeDistance + realTextWidth + layout.labelDistance;
                else linePoints[2][0] = viewLeft + viewWidth - layout.edgeDistance - realTextWidth - layout.labelDistance;
            } else {
                if (label.x < cx) linePoints[2][0] = label.x + layout.labelDistance;
                else linePoints[2][0] = label.x - layout.labelDistance;
                linePoints[1][0] = linePoints[2][0] + dist;
            }
            linePoints[1][1] = linePoints[2][1] = label.y;
        }
    }
}
/**
 * Set max width of each label, and then wrap each label to the max width.
 *
 * @param layout label layout
 * @param availableWidth max width for the label to display
 * @param forceRecalculate recaculate the text layout even if the current width
 * is smaller than `availableWidth`. This is useful when the text was previously
 * wrapped by calling `constrainTextWidth` but now `availableWidth` changed, in
 * which case, previous wrapping should be redo.
 */ function $a43531ab8c5f16d6$var$constrainTextWidth(layout, availableWidth, forceRecalculate) {
    if (forceRecalculate === void 0) forceRecalculate = false;
    if (layout.labelStyleWidth != null) // User-defined style.width has the highest priority.
    return;
    var label = layout.label;
    var style = label.style;
    var textRect = layout.rect;
    var bgColor = style.backgroundColor;
    var padding = style.padding;
    var paddingH = padding ? padding[1] + padding[3] : 0;
    var overflow = style.overflow;
    // textRect.width already contains paddingH if bgColor is set
    var oldOuterWidth = textRect.width + (bgColor ? 0 : paddingH);
    if (availableWidth < oldOuterWidth || forceRecalculate) {
        var oldHeight = textRect.height;
        if (overflow && overflow.match('break')) {
            // Temporarily set background to be null to calculate
            // the bounding box without background.
            label.setStyle('backgroundColor', null);
            // Set constraining width
            label.setStyle('width', availableWidth - paddingH);
            // This is the real bounding box of the text without padding.
            var innerRect = label.getBoundingRect();
            label.setStyle('width', Math.ceil(innerRect.width));
            label.setStyle('backgroundColor', bgColor);
        } else {
            var availableInnerWidth = availableWidth - paddingH;
            var newWidth = availableWidth < oldOuterWidth ? availableInnerWidth : // Current available width is enough, but the text may have
            // already been wrapped with a smaller available width.
            forceRecalculate ? availableInnerWidth > layout.unconstrainedWidth ? null : availableInnerWidth : null;
            label.setStyle('width', newWidth);
        }
        var newRect = label.getBoundingRect();
        textRect.width = newRect.width;
        var margin = (label.style.margin || 0) + 2.1;
        textRect.height = newRect.height + margin;
        textRect.y -= (textRect.height - oldHeight) / 2;
    }
}
function $a43531ab8c5f16d6$var$isPositionCenter(sectorShape) {
    // Not change x for center label
    return sectorShape.position === 'center';
}
function $a43531ab8c5f16d6$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var labelLayoutList = [];
    var cx;
    var cy;
    var hasLabelRotate = false;
    var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * $a43531ab8c5f16d6$var$RADIAN;
    var viewRect = data.getLayout('viewRect');
    var r = data.getLayout('r');
    var viewWidth = viewRect.width;
    var viewLeft = viewRect.x;
    var viewTop = viewRect.y;
    var viewHeight = viewRect.height;
    function setNotShow(el) {
        el.ignore = true;
    }
    function isLabelShown(label) {
        if (!label.ignore) return true;
        for(var key in label.states){
            if (label.states[key].ignore === false) return true;
        }
        return false;
    }
    data.each(function(idx) {
        var sector = data.getItemGraphicEl(idx);
        var sectorShape = sector.shape;
        var label = sector.getTextContent();
        var labelLine = sector.getTextGuideLine();
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label');
        // Use position in normal or emphasis
        var labelPosition = labelModel.get('position') || itemModel.get([
            'emphasis',
            'label',
            'position'
        ]);
        var labelDistance = labelModel.get('distanceToLabelLine');
        var labelAlignTo = labelModel.get('alignTo');
        var edgeDistance = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(labelModel.get('edgeDistance'), viewWidth);
        var bleedMargin = labelModel.get('bleedMargin');
        var labelLineModel = itemModel.getModel('labelLine');
        var labelLineLen = labelLineModel.get('length');
        labelLineLen = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(labelLineLen, viewWidth);
        var labelLineLen2 = labelLineModel.get('length2');
        labelLineLen2 = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(labelLineLen2, viewWidth);
        if (Math.abs(sectorShape.endAngle - sectorShape.startAngle) < minShowLabelRadian) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(label.states, setNotShow);
            label.ignore = true;
            if (labelLine) {
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            }
            return;
        }
        if (!isLabelShown(label)) return;
        var midAngle = (sectorShape.startAngle + sectorShape.endAngle) / 2;
        var nx = Math.cos(midAngle);
        var ny = Math.sin(midAngle);
        var textX;
        var textY;
        var linePoints;
        var textAlign;
        cx = sectorShape.cx;
        cy = sectorShape.cy;
        var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
        if (labelPosition === 'center') {
            textX = sectorShape.cx;
            textY = sectorShape.cy;
            textAlign = 'center';
        } else {
            var x1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * nx : sectorShape.r * nx) + cx;
            var y1 = (isLabelInside ? (sectorShape.r + sectorShape.r0) / 2 * ny : sectorShape.r * ny) + cy;
            textX = x1 + nx * 3;
            textY = y1 + ny * 3;
            if (!isLabelInside) {
                // For roseType
                var x2 = x1 + nx * (labelLineLen + r - sectorShape.r);
                var y2 = y1 + ny * (labelLineLen + r - sectorShape.r);
                var x3 = x2 + (nx < 0 ? -1 : 1) * labelLineLen2;
                var y3 = y2;
                if (labelAlignTo === 'edge') // Adjust textX because text align of edge is opposite
                textX = nx < 0 ? viewLeft + edgeDistance : viewLeft + viewWidth - edgeDistance;
                else textX = x3 + (nx < 0 ? -labelDistance : labelDistance);
                textY = y3;
                linePoints = [
                    [
                        x1,
                        y1
                    ],
                    [
                        x2,
                        y2
                    ],
                    [
                        x3,
                        y3
                    ]
                ];
            }
            textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? nx > 0 ? 'right' : 'left' : nx > 0 ? 'left' : 'right';
        }
        var PI = Math.PI;
        var labelRotate = 0;
        var rotate = labelModel.get('rotate');
        if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rotate)) labelRotate = rotate * (PI / 180);
        else if (labelPosition === 'center') labelRotate = 0;
        else if (rotate === 'radial' || rotate === true) {
            var radialAngle = nx < 0 ? -midAngle + PI : -midAngle;
            labelRotate = radialAngle;
        } else if (rotate === 'tangential' && labelPosition !== 'outside' && labelPosition !== 'outer') {
            var rad = Math.atan2(nx, ny);
            if (rad < 0) rad = PI * 2 + rad;
            var isDown = ny > 0;
            if (isDown) rad = PI + rad;
            labelRotate = rad - PI;
        }
        hasLabelRotate = !!labelRotate;
        label.x = textX;
        label.y = textY;
        label.rotation = labelRotate;
        label.setStyle({
            verticalAlign: 'middle'
        });
        // Not sectorShape the inside label
        if (!isLabelInside) {
            var textRect = label.getBoundingRect().clone();
            textRect.applyTransform(label.getComputedTransform());
            // Text has a default 1px stroke. Exclude this.
            var margin = (label.style.margin || 0) + 2.1;
            textRect.y -= margin / 2;
            textRect.height += margin;
            labelLayoutList.push({
                label: label,
                labelLine: labelLine,
                position: labelPosition,
                len: labelLineLen,
                len2: labelLineLen2,
                minTurnAngle: labelLineModel.get('minTurnAngle'),
                maxSurfaceAngle: labelLineModel.get('maxSurfaceAngle'),
                surfaceNormal: new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)(nx, ny),
                linePoints: linePoints,
                textAlign: textAlign,
                labelDistance: labelDistance,
                labelAlignTo: labelAlignTo,
                edgeDistance: edgeDistance,
                bleedMargin: bleedMargin,
                rect: textRect,
                unconstrainedWidth: textRect.width,
                labelStyleWidth: label.style.width
            });
        } else {
            label.setStyle({
                align: textAlign
            });
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        sector.setTextConfig({
            inside: isLabelInside
        });
    });
    if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) $a43531ab8c5f16d6$var$avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
    for(var i = 0; i < labelLayoutList.length; i++){
        var layout = labelLayoutList[i];
        var label = layout.label;
        var labelLine = layout.labelLine;
        var notShowLabel = isNaN(label.x) || isNaN(label.y);
        if (label) {
            label.setStyle({
                align: layout.textAlign
            });
            if (notShowLabel) {
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(label.states, setNotShow);
                label.ignore = true;
            }
            var selectState = label.states.select;
            if (selectState) {
                selectState.x += label.x;
                selectState.y += label.y;
            }
        }
        if (labelLine) {
            var linePoints = layout.linePoints;
            if (notShowLabel || !linePoints) {
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(labelLine.states, setNotShow);
                labelLine.ignore = true;
            } else {
                (0, $8503bd2779bcc1a6$export$ac52062003fbe6a)(linePoints, layout.minTurnAngle);
                (0, $8503bd2779bcc1a6$export$973e1fdb2708f71b)(linePoints, layout.surfaceNormal, layout.maxSurfaceAngle);
                labelLine.setShape({
                    points: linePoints
                });
                // Set the anchor to the midpoint of sector
                label.__hostTarget.textGuideLineConfig = {
                    anchor: new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)(linePoints[0][0], linePoints[0][1])
                };
            }
        }
    }
}







/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $469a7b1fa914c55b$var$PiePiece = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PiePiece, _super);
    function PiePiece(data, idx, startAngle) {
        var _this = _super.call(this) || this;
        _this.z2 = 2;
        var text = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039();
        _this.setTextContent(text);
        _this.updateData(data, idx, startAngle, true);
        return _this;
    }
    PiePiece.prototype.updateData = function(data, idx, startAngle, firstCreate) {
        var sector = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = data.getItemLayout(idx);
        // cornerRadius & innerCornerRadius doesn't exist in the item layout. Use `0` if null value is specified.
        // see `setItemLayout` in `pieLayout.ts`.
        var sectorShape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $76e2a0dbb7483b91$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), layout, true), layout);
        // Ignore NaN data.
        if (isNaN(sectorShape.startAngle)) {
            // Use NaN shape to avoid drawing shape.
            sector.setShape(sectorShape);
            return;
        }
        if (firstCreate) {
            sector.setShape(sectorShape);
            var animationType = seriesModel.getShallow('animationType');
            if (seriesModel.ecModel.ssr) {
                // Use scale animation in SSR mode(opacity?)
                // Because CSS SVG animation doesn't support very customized shape animation.
                $b40111164617dd60$export$a121566aadcfe021(sector, {
                    scaleX: 0,
                    scaleY: 0
                }, seriesModel, {
                    dataIndex: idx,
                    isFrom: true
                });
                sector.originX = sectorShape.cx;
                sector.originY = sectorShape.cy;
            } else if (animationType === 'scale') {
                sector.shape.r = layout.r0;
                $b40111164617dd60$export$a121566aadcfe021(sector, {
                    shape: {
                        r: layout.r
                    }
                }, seriesModel, idx);
            } else if (startAngle != null) {
                sector.setShape({
                    startAngle: startAngle,
                    endAngle: startAngle
                });
                $b40111164617dd60$export$a121566aadcfe021(sector, {
                    shape: {
                        startAngle: layout.startAngle,
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            } else {
                sector.shape.endAngle = layout.startAngle;
                $b40111164617dd60$export$c8dce3c08436e91e(sector, {
                    shape: {
                        endAngle: layout.endAngle
                    }
                }, seriesModel, idx);
            }
        } else {
            (0, $b40111164617dd60$export$bca7290a9faf0ec9)(sector);
            // Transition animation from the old shape
            $b40111164617dd60$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel, idx);
        }
        sector.useStyle(data.getItemVisual(idx, 'style'));
        (0, $b414df7d361a211c$export$48b68047d330bbc9)(sector, itemModel);
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var offset = seriesModel.get('selectedOffset');
        var dx = Math.cos(midAngle) * offset;
        var dy = Math.sin(midAngle) * offset;
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._updateLabel(seriesModel, data, idx);
        sector.ensureState('emphasis').shape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
            r: layout.r + (emphasisModel.get('scale') ? emphasisModel.get('scaleSize') || 0 : 0)
        }, (0, $76e2a0dbb7483b91$export$b395eeeb2ad7cce5)(emphasisModel.getModel('itemStyle'), layout));
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(sector.ensureState('select'), {
            x: dx,
            y: dy,
            shape: (0, $76e2a0dbb7483b91$export$b395eeeb2ad7cce5)(itemModel.getModel([
                'select',
                'itemStyle'
            ]), layout)
        });
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(sector.ensureState('blur'), {
            shape: (0, $76e2a0dbb7483b91$export$b395eeeb2ad7cce5)(itemModel.getModel([
                'blur',
                'itemStyle'
            ]), layout)
        });
        var labelLine = sector.getTextGuideLine();
        var labelText = sector.getTextContent();
        labelLine && (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(labelLine.ensureState('select'), {
            x: dx,
            y: dy
        });
        // TODO: needs dx, dy in zrender?
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(labelText.ensureState('select'), {
            x: dx,
            y: dy
        });
        (0, $b414df7d361a211c$export$e51187539ff11209)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    PiePiece.prototype._updateLabel = function(seriesModel, data, idx) {
        var sector = this;
        var itemModel = data.getItemModel(idx);
        var labelLineModel = itemModel.getModel('labelLine');
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style && style.fill;
        var visualOpacity = style && style.opacity;
        (0, $3828198b2f2de836$export$9a13992917966657)(sector, (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            defaultText: seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx)
        });
        var labelText = sector.getTextContent();
        // Set textConfig on sector.
        sector.setTextConfig({
            // reset position, rotation
            position: null,
            rotation: null
        });
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        labelText.attr({
            z2: 10
        });
        var labelPosition = seriesModel.get([
            'label',
            'position'
        ]);
        if (labelPosition !== 'outside' && labelPosition !== 'outer') sector.removeTextGuideLine();
        else {
            var polyline = this.getTextGuideLine();
            if (!polyline) {
                polyline = new $f7f6523750aec7c8$export$2e2bcd8739ae039();
                this.setTextGuideLine(polyline);
            }
            // Default use item visual color
            (0, $8503bd2779bcc1a6$export$c09e0b0574bdd2dc)(this, (0, $8503bd2779bcc1a6$export$2979fdbf5ebce521)(itemModel), {
                stroke: visualColor,
                opacity: (0, $1b239fc9d3a2f8ae$export$2e94551289abb95b)(labelLineModel.get([
                    'lineStyle',
                    'opacity'
                ]), visualOpacity, 1)
            });
        }
    };
    return PiePiece;
}($5fa26352e0605e60$export$2e2bcd8739ae039);
// Pie view
var $469a7b1fa914c55b$var$PieView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PieView, _super);
    function PieView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    PieView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var startAngle;
        // First render
        if (!oldData && data.count() > 0) {
            var shape = data.getItemLayout(0);
            for(var s = 1; isNaN(shape && shape.startAngle) && s < data.count(); ++s)shape = data.getItemLayout(s);
            if (shape) startAngle = shape.startAngle;
        }
        // remove empty-circle if it exists
        if (this._emptyCircleSector) group.remove(this._emptyCircleSector);
        // when all data are filtered, show lightgray empty circle
        if (data.count() === 0 && seriesModel.get('showEmptyCircle')) {
            var layoutData = (0, $0cb303fc070de4f6$export$4e43b88a06b9f223)(seriesModel);
            var sector = new $5fa26352e0605e60$export$2e2bcd8739ae039({
                shape: (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $0cb303fc070de4f6$export$2a0d4d5b12383eb9)(seriesModel, api), layoutData)
            });
            sector.useStyle(seriesModel.getModel('emptyCircleStyle').getItemStyle());
            this._emptyCircleSector = sector;
            group.add(sector);
        }
        data.diff(oldData).add(function(idx) {
            var piePiece = new $469a7b1fa914c55b$var$PiePiece(data, idx, startAngle);
            data.setItemGraphicEl(idx, piePiece);
            group.add(piePiece);
        }).update(function(newIdx, oldIdx) {
            var piePiece = oldData.getItemGraphicEl(oldIdx);
            piePiece.updateData(data, newIdx, startAngle);
            piePiece.off('click');
            group.add(piePiece);
            data.setItemGraphicEl(newIdx, piePiece);
        }).remove(function(idx) {
            var piePiece = oldData.getItemGraphicEl(idx);
            $b40111164617dd60$export$6d0fd725cb4aee8a(piePiece, seriesModel, idx);
        }).execute();
        (0, $a43531ab8c5f16d6$export$2e2bcd8739ae039)(seriesModel);
        // Always use initial animation.
        if (seriesModel.get('animationTypeUpdate') !== 'expansion') this._data = data;
    };
    PieView.prototype.dispose = function() {};
    PieView.prototype.containPoint = function(point, seriesModel) {
        var data = seriesModel.getData();
        var itemLayout = data.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    PieView.type = 'pie';
    return PieView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $469a7b1fa914c55b$export$2e2bcd8739ae039 = $469a7b1fa914c55b$var$PieView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $4433247721525340$export$2e2bcd8739ae039(seriesModel, opt, nameList) {
    opt = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(opt) && {
        coordDimensions: opt
    } || (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
        encodeDefine: seriesModel.getEncode()
    }, opt);
    var source = seriesModel.getSource();
    var dimensions = (0, $02c5dbb1162b825d$export$2e2bcd8739ae039)(source, opt).dimensions;
    var list = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(dimensions, seriesModel);
    list.initData(source, nameList);
    return list;
}






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * LegendVisualProvider is an bridge that pick encoded color from data and
 * provide to the legend component.
 */ var $f7d155e85e188448$var$LegendVisualProvider = /** @class */ function() {
    function LegendVisualProvider(// Function to get data after filtered. It stores all the encoding info
    getDataWithEncodedVisual, // Function to get raw data before filtered.
    getRawData) {
        this._getDataWithEncodedVisual = getDataWithEncodedVisual;
        this._getRawData = getRawData;
    }
    LegendVisualProvider.prototype.getAllNames = function() {
        var rawData = this._getRawData();
        // We find the name from the raw data. In case it's filtered by the legend component.
        // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
        return rawData.mapArray(rawData.getName);
    };
    LegendVisualProvider.prototype.containName = function(name) {
        var rawData = this._getRawData();
        return rawData.indexOfName(name) >= 0;
    };
    LegendVisualProvider.prototype.indexOfName = function(name) {
        // Only get data when necessary.
        // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
        // Invoking Series#getData immediately will throw an error.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.indexOfName(name);
    };
    LegendVisualProvider.prototype.getItemVisual = function(dataIndex, key) {
        // Get encoded visual properties from final filtered data.
        var dataWithEncodedVisual = this._getDataWithEncodedVisual();
        return dataWithEncodedVisual.getItemVisual(dataIndex, key);
    };
    return LegendVisualProvider;
}();
var $f7d155e85e188448$export$2e2bcd8739ae039 = $f7d155e85e188448$var$LegendVisualProvider;



var $6915c9b32959cc25$var$innerData = $9ac03c46e8b6e711$export$64df9f8d92ae083f();
var $6915c9b32959cc25$var$PieSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PieSeriesModel, _super);
    function PieSeriesModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @overwrite
   */ PieSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $f7d155e85e188448$export$2e2bcd8739ae039)($1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getData, this), $1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getRawData, this));
        this._defaultLabelLine(option);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.mergeOption = function() {
        _super.prototype.mergeOption.apply(this, arguments);
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getInitialData = function() {
        return (0, $4433247721525340$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $1b239fc9d3a2f8ae$export$c3095a23b368d1f2((0, $669a01b8661bdd13$export$60b8a57d1f2fed26), this)
        });
    };
    /**
   * @overwrite
   */ PieSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        // update seats when data is changed
        var dataInner = $6915c9b32959cc25$var$innerData(data);
        var seats = dataInner.seats;
        if (!seats) {
            var valueList_1 = [];
            data.each(data.mapDimension('value'), function(value) {
                valueList_1.push(value);
            });
            seats = dataInner.seats = (0, $9fd90cf3bf18fbcd$export$222dabb13d5320df)(valueList_1, data.hostModel.get('percentPrecision'));
        }
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        // seats may be empty when sum is 0
        params.percent = seats[dataIndex] || 0;
        params.$vars.push('percent');
        return params;
    };
    PieSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        $9ac03c46e8b6e711$export$abdcc6a26372f94b(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    PieSeriesModel.type = 'series.pie';
    PieSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '75%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        endAngle: 'auto',
        padAngle: 0,
        // 最小角度改为0
        minAngle: 0,
        // If the angle of a sector less than `minShowLabelAngle`,
        // the label will not be displayed.
        minShowLabelAngle: 0,
        // 选中时扇区偏移量
        selectedOffset: 10,
        // 选择模式，默认关闭，可选single，multiple
        // selectedMode: false,
        // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
        // roseType: null,
        percentPrecision: 2,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // cursor: null,
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: null,
        height: null,
        label: {
            // color: 'inherit',
            // If rotate around circle
            rotate: 0,
            show: true,
            overflow: 'truncate',
            // 'outer', 'inside', 'center'
            position: 'outer',
            // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
            alignTo: 'none',
            // Closest distance between label and chart edge.
            // Works only position is 'outer' and alignTo is 'edge'.
            edgeDistance: '25%',
            // Works only position is 'outer' and alignTo is not 'edge'.
            bleedMargin: 10,
            // Distance between text and label line.
            distanceToLabelLine: 5
        },
        // Enabled when label.normal.position is 'outer'
        labelLine: {
            show: true,
            // 引导线两段中的第一段长度
            length: 15,
            // 引导线两段中的第二段长度
            length2: 15,
            smooth: false,
            minTurnAngle: 90,
            maxSurfaceAngle: 90,
            lineStyle: {
                // color: 各异,
                width: 1,
                type: 'solid'
            }
        },
        itemStyle: {
            borderWidth: 1,
            borderJoin: 'round'
        },
        showEmptyCircle: true,
        emptyCircleStyle: {
            color: 'lightgray',
            opacity: 1
        },
        labelLayout: {
            // Hide the overlapped label.
            hideOverlap: true
        },
        emphasis: {
            scale: true,
            scaleSize: 5
        },
        // If use strategy to avoid label overlapping
        avoidLabelOverlap: true,
        // Animation type. Valid values: expansion, scale
        animationType: 'expansion',
        animationDuration: 1000,
        // Animation type when update. Valid values: transition, expansion
        animationTypeUpdate: 'transition',
        animationEasingUpdate: 'cubicInOut',
        animationDurationUpdate: 500,
        animationEasing: 'cubicInOut'
    };
    return PieSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $6915c9b32959cc25$export$2e2bcd8739ae039 = $6915c9b32959cc25$var$PieSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $78156c5589b8539c$export$2e2bcd8739ae039(seriesType) {
    return {
        seriesType: seriesType,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            data.filterSelf(function(idx) {
                // handle negative value condition
                var valueDim = data.mapDimension('value');
                var curValue = data.get(valueDim, idx);
                if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(curValue) && !isNaN(curValue) && curValue < 0) return false;
                return true;
            });
        }
    };
}


function $6bcac0aff570bb6f$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $469a7b1fa914c55b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $6915c9b32959cc25$export$2e2bcd8739ae039));
    (0, $4a2d4f3079e03ea2$export$62942ba95693dbfc)('pie', registers.registerAction);
    registers.registerLayout((0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)((0, $0cb303fc070de4f6$export$2e2bcd8739ae039), 'pie'));
    registers.registerProcessor((0, $2f4b2083cfaef73d$export$2e2bcd8739ae039)('pie'));
    registers.registerProcessor((0, $78156c5589b8539c$export$2e2bcd8739ae039)('pie'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $1f73913f6546b9c8$var$ScatterSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ScatterSeriesModel, _super);
    function ScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    ScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    ScatterSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) // PENDING
        return this.option.large ? 5e3 : this.get('progressive');
        return progressive;
    };
    ScatterSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) // PENDING
        return this.option.large ? 1e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    ScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    ScatterSeriesModel.prototype.getZLevelKey = function() {
        // Each progressive series has individual key.
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : '';
    };
    ScatterSeriesModel.type = 'series.scatter';
    ScatterSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    ScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        symbolSize: 10,
        // symbolRotate: null,  // 图形旋转控制
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        // cursor: null,
        itemStyle: {
            opacity: 0.8
        },
        emphasis: {
            scale: true
        },
        // If clip the overflow graphics
        // Works on cartesian / polar series
        clip: true,
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        universalTransition: {
            divideShape: 'clone'
        }
    };
    return ScatterSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $1f73913f6546b9c8$export$2e2bcd8739ae039 = $1f73913f6546b9c8$var$ScatterSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $93119e7bd962d2b4$var$BOOST_SIZE_THRESHOLD = 4;
var $93119e7bd962d2b4$var$LargeSymbolPathShape = /** @class */ function() {
    function LargeSymbolPathShape() {}
    return LargeSymbolPathShape;
}();
var $93119e7bd962d2b4$var$LargeSymbolPath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LargeSymbolPath, _super);
    function LargeSymbolPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeSymbolPath.prototype.getDefaultShape = function() {
        return new $93119e7bd962d2b4$var$LargeSymbolPathShape();
    };
    LargeSymbolPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeSymbolPath.prototype.buildPath = function(path, shape) {
        var points = shape.points;
        var size = shape.size;
        var symbolProxy = this.symbolProxy;
        var symbolProxyShape = symbolProxy.shape;
        var ctx = path.getContext ? path.getContext() : path;
        var canBoost = ctx && size[0] < $93119e7bd962d2b4$var$BOOST_SIZE_THRESHOLD;
        var softClipShape = this.softClipShape;
        var i;
        // Do draw in afterBrush.
        if (canBoost) {
            this._ctx = ctx;
            return;
        }
        this._ctx = null;
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            symbolProxyShape.x = x - size[0] / 2;
            symbolProxyShape.y = y - size[1] / 2;
            symbolProxyShape.width = size[0];
            symbolProxyShape.height = size[1];
            symbolProxy.buildPath(path, symbolProxyShape, true);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.afterBrush = function() {
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var ctx = this._ctx;
        var softClipShape = this.softClipShape;
        var i;
        if (!ctx) return;
        // PENDING If style or other canvas status changed?
        for(i = this._off; i < points.length;){
            var x = points[i++];
            var y = points[i++];
            if (isNaN(x) || isNaN(y)) continue;
            if (softClipShape && !softClipShape.contain(x, y)) continue;
            // fillRect is faster than building a rect path and draw.
            // And it support light globalCompositeOperation.
            ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeSymbolPath.prototype.findDataIndex = function(x, y) {
        // TODO ???
        // Consider transform
        var shape = this.shape;
        var points = shape.points;
        var size = shape.size;
        var w = Math.max(size[0], 4);
        var h = Math.max(size[1], 4);
        // Not consider transform
        // Treat each element as a rect
        // top down traverse
        for(var idx = points.length / 2 - 1; idx >= 0; idx--){
            var i = idx * 2;
            var x0 = points[i] - w / 2;
            var y0 = points[i + 1] - h / 2;
            if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) return idx;
        }
        return -1;
    };
    LargeSymbolPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeSymbolPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.points;
            var size = shape.size;
            var w = size[0];
            var h = size[1];
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $020465b49a1dd45f$export$2e2bcd8739ae039(minX - w / 2, minY - h / 2, maxX - minX + w, maxY - minY + h);
        }
        return rect;
    };
    return LargeSymbolPath;
}($f9698154c9fcf427$export$2e2bcd8739ae039);
var $93119e7bd962d2b4$var$LargeSymbolDraw = /** @class */ function() {
    function LargeSymbolDraw() {
        this.group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeSymbolDraw.prototype.updateData = function(data, opt) {
        this._clear();
        var symbolEl = this._create();
        symbolEl.setShape({
            points: data.getLayout('points')
        });
        this._setCommon(symbolEl, data, opt);
    };
    LargeSymbolDraw.prototype.updateLayout = function(data) {
        var points = data.getLayout('points');
        this.group.eachChild(function(child) {
            if (child.startIndex != null) {
                var len = (child.endIndex - child.startIndex) * 2;
                var byteOffset = child.startIndex * 8;
                points = new Float32Array(points.buffer, byteOffset, len);
            }
            child.setShape('points', points);
            // Reset draw cursor.
            child.reset();
        });
    };
    LargeSymbolDraw.prototype.incrementalPrepareUpdate = function(data) {
        this._clear();
    };
    LargeSymbolDraw.prototype.incrementalUpdate = function(taskParams, data, opt) {
        var lastAdded = this._newAdded[0];
        var points = data.getLayout('points');
        var oldPoints = lastAdded && lastAdded.shape.points;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldPoints && oldPoints.length < 2e4) {
            var oldLen = oldPoints.length;
            var newPoints = new Float32Array(oldLen + points.length);
            // Concat two array
            newPoints.set(oldPoints);
            newPoints.set(points, oldLen);
            // Update endIndex
            lastAdded.endIndex = taskParams.end;
            lastAdded.setShape({
                points: newPoints
            });
        } else {
            // Clear
            this._newAdded = [];
            var symbolEl = this._create();
            symbolEl.startIndex = taskParams.start;
            symbolEl.endIndex = taskParams.end;
            symbolEl.incremental = true;
            symbolEl.setShape({
                points: points
            });
            this._setCommon(symbolEl, data, opt);
        }
    };
    LargeSymbolDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeSymbolDraw.prototype._create = function() {
        var symbolEl = new $93119e7bd962d2b4$var$LargeSymbolPath({
            cursor: 'default'
        });
        symbolEl.ignoreCoarsePointer = true;
        this.group.add(symbolEl);
        this._newAdded.push(symbolEl);
        return symbolEl;
    };
    LargeSymbolDraw.prototype._setCommon = function(symbolEl, data, opt) {
        var hostModel = data.hostModel;
        opt = opt || {};
        var size = data.getVisual('symbolSize');
        symbolEl.setShape('size', size instanceof Array ? size : [
            size,
            size
        ]);
        symbolEl.softClipShape = opt.clipShape || null;
        // Create symbolProxy to build path for each data
        symbolEl.symbolProxy = (0, $da6220012439db7b$export$af050e04da3a02e8)(data.getVisual('symbol'), 0, 0, 0, 0);
        // Use symbolProxy setColor method
        symbolEl.setColor = symbolEl.symbolProxy.setColor;
        var extrudeShadow = symbolEl.shape.size[0] < $93119e7bd962d2b4$var$BOOST_SIZE_THRESHOLD;
        symbolEl.useStyle(// Draw shadow when doing fillRect is extremely slow.
        hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? [
            'color',
            'shadowBlur',
            'shadowColor'
        ] : [
            'color'
        ]));
        var globalStyle = data.getVisual('style');
        var visualColor = globalStyle && globalStyle.fill;
        if (visualColor) symbolEl.setColor(visualColor);
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(symbolEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        symbolEl.on('mousemove', function(e) {
            ecData.dataIndex = null;
            var dataIndex = symbolEl.hoverDataIdx;
            if (dataIndex >= 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + (symbolEl.startIndex || 0);
        });
    };
    LargeSymbolDraw.prototype.remove = function() {
        this._clear();
    };
    LargeSymbolDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeSymbolDraw;
}();
var $93119e7bd962d2b4$export$2e2bcd8739ae039 = $93119e7bd962d2b4$var$LargeSymbolDraw;




var $378f527abfa8e24c$var$ScatterView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ScatterView, _super);
    function ScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScatterView.type;
        return _this;
    }
    ScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.updateData(data, {
            // TODO
            // If this parameter should be a shape or a bounding volume
            // shape will be more general.
            // But bounding volume like bounding rect will be much faster in the contain calculation
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = true;
    };
    ScatterView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var symbolDraw = this._updateSymbolDraw(data, seriesModel);
        symbolDraw.incrementalPrepareUpdate(data);
        this._finished = false;
    };
    ScatterView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
            clipShape: this._getClipShape(seriesModel)
        });
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    ScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        // Must mark group dirty and make sure the incremental layer will be cleared
        // PENDING
        this.group.dirty();
        if (!this._finished || data.count() > 1e4) return {
            update: true
        };
        else {
            var res = (0, $264cfd4c63b95c0a$export$2e2bcd8739ae039)('').reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            this._symbolDraw.updateLayout(data);
        }
    };
    ScatterView.prototype.eachRendered = function(cb) {
        this._symbolDraw && this._symbolDraw.eachRendered(cb);
    };
    ScatterView.prototype._getClipShape = function(seriesModel) {
        if (!seriesModel.get('clip', true)) return;
        var coordSys = seriesModel.coordinateSystem;
        // PENDING make `0.1` configurable, for example, `clipTolerance`?
        return coordSys && coordSys.getArea && coordSys.getArea(.1);
    };
    ScatterView.prototype._updateSymbolDraw = function(data, seriesModel) {
        var symbolDraw = this._symbolDraw;
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
            symbolDraw && symbolDraw.remove();
            symbolDraw = this._symbolDraw = isLargeDraw ? new (0, $93119e7bd962d2b4$export$2e2bcd8739ae039)() : new (0, $89a14c17b9971b0f$export$2e2bcd8739ae039)();
            this._isLargeDraw = isLargeDraw;
            this.group.removeAll();
        }
        this.group.add(symbolDraw.group);
        return symbolDraw;
    };
    ScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
        this._symbolDraw = null;
    };
    ScatterView.prototype.dispose = function() {};
    ScatterView.type = 'scatter';
    return ScatterView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $378f527abfa8e24c$export$2e2bcd8739ae039 = $378f527abfa8e24c$var$ScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $68a2294e6dddbbf6$var$GridModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GridModel, _super);
    function GridModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GridModel.type = 'grid';
    GridModel.dependencies = [
        'xAxis',
        'yAxis'
    ];
    GridModel.layoutMode = 'box';
    GridModel.defaultOption = {
        show: false,
        // zlevel: 0,
        z: 0,
        left: '10%',
        top: 60,
        right: '10%',
        bottom: 70,
        // If grid size contain label
        containLabel: false,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        backgroundColor: 'rgba(0,0,0,0)',
        borderWidth: 1,
        borderColor: '#ccc'
    };
    return GridModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $68a2294e6dddbbf6$export$2e2bcd8739ae039 = $68a2294e6dddbbf6$var$GridModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
var $12a09fd102c04f88$export$5c54b224726edb5a = /** @class */ function() {
    function AxisModelCommonMixin() {}
    AxisModelCommonMixin.prototype.getNeedCrossZero = function() {
        var option = this.option;
        return !option.scale;
    };
    /**
   * Should be implemented by each axis model if necessary.
   * @return coordinate system model
   */ AxisModelCommonMixin.prototype.getCoordSysModel = function() {
        return;
    };
    return AxisModelCommonMixin;
}();



var $9679afe54c0be17d$export$483dc37e6ad83a3c = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CartesianAxisModel, _super);
    function CartesianAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CartesianAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('grid', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
    };
    CartesianAxisModel.type = 'cartesian2dAxis';
    return CartesianAxisModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($9679afe54c0be17d$export$483dc37e6ad83a3c, (0, $12a09fd102c04f88$export$5c54b224726edb5a));
var $9679afe54c0be17d$export$2e2bcd8739ae039 = $9679afe54c0be17d$export$483dc37e6ad83a3c;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7e57a56fbe9f136e$var$defaultOption = {
    show: true,
    // zlevel: 0,
    z: 0,
    // Inverse the axis.
    inverse: false,
    // Axis name displayed.
    name: '',
    // 'start' | 'middle' | 'end'
    nameLocation: 'end',
    // By degree. By default auto rotate by nameLocation.
    nameRotate: null,
    nameTruncate: {
        maxWidth: null,
        ellipsis: '...',
        placeholder: '.'
    },
    // Use global text style by default.
    nameTextStyle: {},
    // The gap between axisName and axisLine.
    nameGap: 15,
    // Default `false` to support tooltip.
    silent: false,
    // Default `false` to avoid legacy user event listener fail.
    triggerEvent: false,
    tooltip: {
        show: false
    },
    axisPointer: {},
    axisLine: {
        show: true,
        onZero: true,
        onZeroAxisIndex: null,
        lineStyle: {
            color: '#6E7079',
            width: 1,
            type: 'solid'
        },
        // The arrow at both ends the the axis.
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            15
        ]
    },
    axisTick: {
        show: true,
        // Whether axisTick is inside the grid or outside the grid.
        inside: false,
        // The length of axisTick.
        length: 5,
        lineStyle: {
            width: 1
        }
    },
    axisLabel: {
        show: true,
        // Whether axisLabel is inside the grid or outside the grid.
        inside: false,
        rotate: 0,
        // true | false | null/undefined (auto)
        showMinLabel: null,
        // true | false | null/undefined (auto)
        showMaxLabel: null,
        margin: 8,
        // formatter: null,
        fontSize: 12
    },
    splitLine: {
        show: true,
        showMinLine: true,
        showMaxLine: true,
        lineStyle: {
            color: [
                '#E0E6F1'
            ],
            width: 1,
            type: 'solid'
        }
    },
    splitArea: {
        show: false,
        areaStyle: {
            color: [
                'rgba(250,250,250,0.2)',
                'rgba(210,219,238,0.2)'
            ]
        }
    }
};
var $7e57a56fbe9f136e$var$categoryAxis = $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
    // The gap at both ends of the axis. For categoryAxis, boolean.
    boundaryGap: true,
    // Set false to faster category collection.
    deduplication: null,
    // splitArea: {
    // show: false
    // },
    splitLine: {
        show: false
    },
    axisTick: {
        // If tick is align with label when boundaryGap is true
        alignWithLabel: false,
        interval: 'auto'
    },
    axisLabel: {
        interval: 'auto'
    }
}, $7e57a56fbe9f136e$var$defaultOption);
var $7e57a56fbe9f136e$var$valueAxis = $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
    boundaryGap: [
        0,
        0
    ],
    axisLine: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    axisTick: {
        // Not shown when other axis is categoryAxis in cartesian
        show: 'auto'
    },
    // TODO
    // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
    splitNumber: 5,
    minorTick: {
        // Minor tick, not available for cateogry axis.
        show: false,
        // Split number of minor ticks. The value should be in range of (0, 100)
        splitNumber: 5,
        // Length of minor tick
        length: 3,
        // Line style
        lineStyle: {
        }
    },
    minorSplitLine: {
        show: false,
        lineStyle: {
            color: '#F4F7FD',
            width: 1
        }
    }
}, $7e57a56fbe9f136e$var$defaultOption);
var $7e57a56fbe9f136e$var$timeAxis = $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
    splitNumber: 6,
    axisLabel: {
        // To eliminate labels that are not nice
        showMinLabel: false,
        showMaxLabel: false,
        rich: {
            primary: {
                fontWeight: 'bold'
            }
        }
    },
    splitLine: {
        show: false
    }
}, $7e57a56fbe9f136e$var$valueAxis);
var $7e57a56fbe9f136e$var$logAxis = $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
    logBase: 10
}, $7e57a56fbe9f136e$var$valueAxis);
var $7e57a56fbe9f136e$export$2e2bcd8739ae039 = {
    category: $7e57a56fbe9f136e$var$categoryAxis,
    value: $7e57a56fbe9f136e$var$valueAxis,
    time: $7e57a56fbe9f136e$var$timeAxis,
    log: $7e57a56fbe9f136e$var$logAxis
};



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $d1ce7a98e5293f8e$var$uidBase = 0;
var $d1ce7a98e5293f8e$var$OrdinalMeta = /** @class */ function() {
    function OrdinalMeta(opt) {
        this.categories = opt.categories || [];
        this._needCollect = opt.needCollect;
        this._deduplication = opt.deduplication;
        this.uid = ++$d1ce7a98e5293f8e$var$uidBase;
    }
    OrdinalMeta.createByAxisModel = function(axisModel) {
        var option = axisModel.option;
        var data = option.data;
        var categories = data && (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(data, $d1ce7a98e5293f8e$var$getName);
        return new OrdinalMeta({
            categories: categories,
            needCollect: !categories,
            // deduplication is default in axis.
            deduplication: option.dedplication !== false
        });
    };
    OrdinalMeta.prototype.getOrdinal = function(category) {
        // @ts-ignore
        return this._getOrCreateMap().get(category);
    };
    /**
   * @return The ordinal. If not found, return NaN.
   */ OrdinalMeta.prototype.parseAndCollect = function(category) {
        var index;
        var needCollect = this._needCollect;
        // The value of category dim can be the index of the given category set.
        // This feature is only supported when !needCollect, because we should
        // consider a common case: a value is 2017, which is a number but is
        // expected to be tread as a category. This case usually happen in dataset,
        // where it happent to be no need of the index feature.
        if (!(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(category) && !needCollect) return category;
        // Optimize for the scenario:
        // category is ['2012-01-01', '2012-01-02', ...], where the input
        // data has been ensured not duplicate and is large data.
        // Notice, if a dataset dimension provide categroies, usually echarts
        // should remove duplication except user tell echarts dont do that
        // (set axis.deduplication = false), because echarts do not know whether
        // the values in the category dimension has duplication (consider the
        // parallel-aqi example)
        if (needCollect && !this._deduplication) {
            index = this.categories.length;
            this.categories[index] = category;
            return index;
        }
        var map = this._getOrCreateMap();
        // @ts-ignore
        index = map.get(category);
        if (index == null) {
            if (needCollect) {
                index = this.categories.length;
                this.categories[index] = category;
                // @ts-ignore
                map.set(category, index);
            } else index = NaN;
        }
        return index;
    };
    // Consider big data, do not create map until needed.
    OrdinalMeta.prototype._getOrCreateMap = function() {
        return this._map || (this._map = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)(this.categories));
    };
    return OrdinalMeta;
}();
function $d1ce7a98e5293f8e$var$getName(obj) {
    if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(obj) && obj.value != null) return obj.value;
    else return obj + '';
}
var $d1ce7a98e5293f8e$export$2e2bcd8739ae039 = $d1ce7a98e5293f8e$var$OrdinalMeta;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $037894d53f0eb4ac$export$2e0057d176d6f690 = {
    value: 1,
    category: 1,
    time: 1,
    log: 1
};



function $74540b73e60dbb04$export$2e2bcd8739ae039(registers, axisName, BaseAxisModelClass, extraDefaultOption) {
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $037894d53f0eb4ac$export$2e0057d176d6f690), function(v, axisType) {
        var defaultOption = (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)((0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)({}, (0, $7e57a56fbe9f136e$export$2e2bcd8739ae039)[axisType], true), extraDefaultOption, true);
        var AxisModel = /** @class */ function(_super) {
            (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(AxisModel, _super);
            function AxisModel() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.type = axisName + 'Axis.' + axisType;
                return _this;
            }
            AxisModel.prototype.mergeDefaultAndTheme = function(option, ecModel) {
                var layoutMode = (0, $501dc28f6c4d24ac$export$3968a28a7cbd6063)(this);
                var inputPositionParams = layoutMode ? (0, $501dc28f6c4d24ac$export$4b0d20af19c9875e)(option) : {};
                var themeModel = ecModel.getTheme();
                (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(option, themeModel.get(axisType + 'Axis'));
                (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(option, this.getDefaultOption());
                option.type = $74540b73e60dbb04$var$getAxisType(option);
                if (layoutMode) (0, $501dc28f6c4d24ac$export$1754cb91f16ca028)(option, inputPositionParams, layoutMode);
            };
            AxisModel.prototype.optionUpdated = function() {
                var thisOption = this.option;
                if (thisOption.type === 'category') this.__ordinalMeta = (0, $d1ce7a98e5293f8e$export$2e2bcd8739ae039).createByAxisModel(this);
            };
            /**
       * Should not be called before all of 'getInitailData' finished.
       * Because categories are collected during initializing data.
       */ AxisModel.prototype.getCategories = function(rawData) {
                var option = this.option;
                // FIXME
                // warning if called before all of 'getInitailData' finished.
                if (option.type === 'category') {
                    if (rawData) return option.data;
                    return this.__ordinalMeta.categories;
                }
            };
            AxisModel.prototype.getOrdinalMeta = function() {
                return this.__ordinalMeta;
            };
            AxisModel.type = axisName + 'Axis.' + axisType;
            AxisModel.defaultOption = defaultOption;
            return AxisModel;
        }(BaseAxisModelClass);
        registers.registerComponentModel(AxisModel);
    });
    registers.registerSubTypeDefaulter(axisName + 'Axis', $74540b73e60dbb04$var$getAxisType);
}
function $74540b73e60dbb04$var$getAxisType(option) {
    // Default axis with data is category axis
    return option.type || (option.data ? 'category' : 'value');
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Grid is a region which contains at most 4 cartesian systems
 *
 * TODO Default cartesian
 */ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $c961137ecae10b1b$var$Scale = /** @class */ function() {
    function Scale(setting) {
        this._setting = setting || {};
        this._extent = [
            Infinity,
            -Infinity
        ];
    }
    Scale.prototype.getSetting = function(name) {
        return this._setting[name];
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
    // not setExtent because in log axis it may transformed to power
    // this.setExtent(extent[0], extent[1]);
    };
    /**
   * Set extent from data
   */ Scale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Get extent
   *
   * Extent is always in increase order.
   */ Scale.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Set extent
   */ Scale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        if (!isNaN(start)) thisExtent[0] = start;
        if (!isNaN(end)) thisExtent[1] = end;
    };
    /**
   * If value is in extent range
   */ Scale.prototype.isInExtentRange = function(value) {
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.isBlank = function() {
        return this._isBlank;
    };
    /**
   * When axis extent depends on data and no data exists,
   * axis ticks should not be drawn, which is named 'blank'.
   */ Scale.prototype.setBlank = function(isBlank) {
        this._isBlank = isBlank;
    };
    return Scale;
}();
$19c24724c14e5e48$export$241315e45585454d($c961137ecae10b1b$var$Scale);
var $c961137ecae10b1b$export$2e2bcd8739ae039 = $c961137ecae10b1b$var$Scale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $b8495dfcf11610d1$export$a8a5b03ea14764df(val) {
    var exp10 = Math.pow(10, (0, $9fd90cf3bf18fbcd$export$97256a17b20a0c24)(Math.abs(val)));
    var f = Math.abs(val / exp10);
    return f === 0 || f === 1 || f === 2 || f === 3 || f === 5;
}
function $b8495dfcf11610d1$export$dfc8cd28ed7b22a0(scale) {
    return scale.type === 'interval' || scale.type === 'log';
}
function $b8495dfcf11610d1$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval) {
    var result = {};
    var span = extent[1] - extent[0];
    var interval = result.interval = (0, $9fd90cf3bf18fbcd$export$7a695fe44258210b)(span / splitNumber, true);
    if (minInterval != null && interval < minInterval) interval = result.interval = minInterval;
    if (maxInterval != null && interval > maxInterval) interval = result.interval = maxInterval;
    // Tow more digital for tick.
    var precision = result.intervalPrecision = $b8495dfcf11610d1$export$86a060b060d3d31a(interval);
    // Niced extent inside original extent
    var niceTickExtent = result.niceTickExtent = [
        (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(Math.ceil(extent[0] / interval) * interval, precision),
        (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(Math.floor(extent[1] / interval) * interval, precision)
    ];
    $b8495dfcf11610d1$export$624b8c8c438031ad(niceTickExtent, extent);
    return result;
}
function $b8495dfcf11610d1$export$f39031e8422f329d(interval) {
    var exp10 = Math.pow(10, (0, $9fd90cf3bf18fbcd$export$97256a17b20a0c24)(interval));
    // Increase interval
    var f = interval / exp10;
    if (!f) f = 1;
    else if (f === 2) f = 3;
    else if (f === 3) f = 5;
    else // f is 1 or 5
    f *= 2;
    return (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(f * exp10);
}
function $b8495dfcf11610d1$export$86a060b060d3d31a(interval) {
    // Tow more digital for tick.
    return (0, $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68)(interval) + 2;
}
function $b8495dfcf11610d1$var$clamp(niceTickExtent, idx, extent) {
    niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
}
function $b8495dfcf11610d1$export$624b8c8c438031ad(niceTickExtent, extent) {
    !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
    !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
    $b8495dfcf11610d1$var$clamp(niceTickExtent, 0, extent);
    $b8495dfcf11610d1$var$clamp(niceTickExtent, 1, extent);
    if (niceTickExtent[0] > niceTickExtent[1]) niceTickExtent[0] = niceTickExtent[1];
}
function $b8495dfcf11610d1$export$8893e2b90ba10d92(val, extent) {
    return val >= extent[0] && val <= extent[1];
}
function $b8495dfcf11610d1$export$a3295358bff77e(val, extent) {
    if (extent[1] === extent[0]) return 0.5;
    return (val - extent[0]) / (extent[1] - extent[0]);
}
function $b8495dfcf11610d1$export$dcdf75081b88279d(val, extent) {
    return val * (extent[1] - extent[0]) + extent[0];
}



var $0c02dcf77630eefb$var$OrdinalScale = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(OrdinalScale, _super);
    function OrdinalScale(setting) {
        var _this = _super.call(this, setting) || this;
        _this.type = 'ordinal';
        var ordinalMeta = _this.getSetting('ordinalMeta');
        // Caution: Should not use instanceof, consider ec-extensions using
        // import approach to get OrdinalMeta class.
        if (!ordinalMeta) ordinalMeta = new (0, $d1ce7a98e5293f8e$export$2e2bcd8739ae039)({});
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(ordinalMeta)) ordinalMeta = new (0, $d1ce7a98e5293f8e$export$2e2bcd8739ae039)({
            categories: (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(ordinalMeta, function(item) {
                return (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(item) ? item.value : item;
            })
        });
        _this._ordinalMeta = ordinalMeta;
        _this._extent = _this.getSetting('extent') || [
            0,
            ordinalMeta.categories.length - 1
        ];
        return _this;
    }
    OrdinalScale.prototype.parse = function(val) {
        // Caution: Math.round(null) will return `0` rather than `NaN`
        if (val == null) return NaN;
        return (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(val) ? this._ordinalMeta.getOrdinal(val) : Math.round(val);
    };
    OrdinalScale.prototype.contain = function(rank) {
        rank = this.parse(rank);
        return $b8495dfcf11610d1$export$8893e2b90ba10d92(rank, this._extent) && this._ordinalMeta.categories[rank] != null;
    };
    /**
   * Normalize given rank or name to linear [0, 1]
   * @param val raw ordinal number.
   * @return normalized value in [0, 1].
   */ OrdinalScale.prototype.normalize = function(val) {
        val = this._getTickNumber(this.parse(val));
        return $b8495dfcf11610d1$export$a3295358bff77e(val, this._extent);
    };
    /**
   * @param val normalized value in [0, 1].
   * @return raw ordinal number.
   */ OrdinalScale.prototype.scale = function(val) {
        val = Math.round($b8495dfcf11610d1$export$dcdf75081b88279d(val, this._extent));
        return this.getRawOrdinalNumber(val);
    };
    OrdinalScale.prototype.getTicks = function() {
        var ticks = [];
        var extent = this._extent;
        var rank = extent[0];
        while(rank <= extent[1]){
            ticks.push({
                value: rank
            });
            rank++;
        }
        return ticks;
    };
    OrdinalScale.prototype.getMinorTicks = function(splitNumber) {
        // Not support.
        return;
    };
    /**
   * @see `Ordinal['_ordinalNumbersByTick']`
   */ OrdinalScale.prototype.setSortInfo = function(info) {
        if (info == null) {
            this._ordinalNumbersByTick = this._ticksByOrdinalNumber = null;
            return;
        }
        var infoOrdinalNumbers = info.ordinalNumbers;
        var ordinalsByTick = this._ordinalNumbersByTick = [];
        var ticksByOrdinal = this._ticksByOrdinalNumber = [];
        // Unnecessary support negative tick in `realtimeSort`.
        var tickNum = 0;
        var allCategoryLen = this._ordinalMeta.categories.length;
        for(var len = Math.min(allCategoryLen, infoOrdinalNumbers.length); tickNum < len; ++tickNum){
            var ordinalNumber = infoOrdinalNumbers[tickNum];
            ordinalsByTick[tickNum] = ordinalNumber;
            ticksByOrdinal[ordinalNumber] = tickNum;
        }
        // Handle that `series.data` only covers part of the `axis.category.data`.
        var unusedOrdinal = 0;
        for(; tickNum < allCategoryLen; ++tickNum){
            while(ticksByOrdinal[unusedOrdinal] != null)unusedOrdinal++;
            ordinalsByTick.push(unusedOrdinal);
            ticksByOrdinal[unusedOrdinal] = tickNum;
        }
    };
    OrdinalScale.prototype._getTickNumber = function(ordinal) {
        var ticksByOrdinalNumber = this._ticksByOrdinalNumber;
        // also support ordinal out of range of `ordinalMeta.categories.length`,
        // where ordinal numbers are used as tick value directly.
        return ticksByOrdinalNumber && ordinal >= 0 && ordinal < ticksByOrdinalNumber.length ? ticksByOrdinalNumber[ordinal] : ordinal;
    };
    /**
   * @usage
   * ```js
   * const ordinalNumber = ordinalScale.getRawOrdinalNumber(tickVal);
   *
   * // case0
   * const rawOrdinalValue = axisModel.getCategories()[ordinalNumber];
   * // case1
   * const rawOrdinalValue = this._ordinalMeta.categories[ordinalNumber];
   * // case2
   * const coord = axis.dataToCoord(ordinalNumber);
   * ```
   *
   * @param {OrdinalNumber} tickNumber index of display
   */ OrdinalScale.prototype.getRawOrdinalNumber = function(tickNumber) {
        var ordinalNumbersByTick = this._ordinalNumbersByTick;
        // tickNumber may be out of range, e.g., when axis max is larger than `ordinalMeta.categories.length`.,
        // where ordinal numbers are used as tick value directly.
        return ordinalNumbersByTick && tickNumber >= 0 && tickNumber < ordinalNumbersByTick.length ? ordinalNumbersByTick[tickNumber] : tickNumber;
    };
    /**
   * Get item on tick
   */ OrdinalScale.prototype.getLabel = function(tick) {
        if (!this.isBlank()) {
            var ordinalNumber = this.getRawOrdinalNumber(tick.value);
            var cateogry = this._ordinalMeta.categories[ordinalNumber];
            // Note that if no data, ordinalMeta.categories is an empty array.
            // Return empty if it's not exist.
            return cateogry == null ? '' : cateogry + '';
        }
    };
    OrdinalScale.prototype.count = function() {
        return this._extent[1] - this._extent[0] + 1;
    };
    OrdinalScale.prototype.unionExtentFromData = function(data, dim) {
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * @override
   * If value is in extent range
   */ OrdinalScale.prototype.isInExtentRange = function(value) {
        value = this._getTickNumber(value);
        return this._extent[0] <= value && this._extent[1] >= value;
    };
    OrdinalScale.prototype.getOrdinalMeta = function() {
        return this._ordinalMeta;
    };
    OrdinalScale.prototype.calcNiceTicks = function() {};
    OrdinalScale.prototype.calcNiceExtent = function() {};
    OrdinalScale.type = 'ordinal';
    return OrdinalScale;
}((0, $c961137ecae10b1b$export$2e2bcd8739ae039));
(0, $c961137ecae10b1b$export$2e2bcd8739ae039).registerClass($0c02dcf77630eefb$var$OrdinalScale);
var $0c02dcf77630eefb$export$2e2bcd8739ae039 = $0c02dcf77630eefb$var$OrdinalScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $2388fa31203c7d49$var$roundNumber = $9fd90cf3bf18fbcd$export$2077e0241d6afd3c;
var $2388fa31203c7d49$var$IntervalScale = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(IntervalScale, _super);
    function IntervalScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'interval';
        // Step is calculated in adjustExtent.
        _this._interval = 0;
        _this._intervalPrecision = 2;
        return _this;
    }
    IntervalScale.prototype.parse = function(val) {
        return val;
    };
    IntervalScale.prototype.contain = function(val) {
        return $b8495dfcf11610d1$export$8893e2b90ba10d92(val, this._extent);
    };
    IntervalScale.prototype.normalize = function(val) {
        return $b8495dfcf11610d1$export$a3295358bff77e(val, this._extent);
    };
    IntervalScale.prototype.scale = function(val) {
        return $b8495dfcf11610d1$export$dcdf75081b88279d(val, this._extent);
    };
    IntervalScale.prototype.setExtent = function(start, end) {
        var thisExtent = this._extent;
        // start,end may be a Number like '25',so...
        if (!isNaN(start)) thisExtent[0] = parseFloat(start);
        if (!isNaN(end)) thisExtent[1] = parseFloat(end);
    };
    IntervalScale.prototype.unionExtent = function(other) {
        var extent = this._extent;
        other[0] < extent[0] && (extent[0] = other[0]);
        other[1] > extent[1] && (extent[1] = other[1]);
        // unionExtent may called by it's sub classes
        this.setExtent(extent[0], extent[1]);
    };
    IntervalScale.prototype.getInterval = function() {
        return this._interval;
    };
    IntervalScale.prototype.setInterval = function(interval) {
        this._interval = interval;
        // Dropped auto calculated niceExtent and use user-set extent.
        // We assume user wants to set both interval, min, max to get a better result.
        this._niceExtent = this._extent.slice();
        this._intervalPrecision = $b8495dfcf11610d1$export$86a060b060d3d31a(interval);
    };
    /**
   * @param expandToNicedExtent Whether expand the ticks to niced extent.
   */ IntervalScale.prototype.getTicks = function(expandToNicedExtent) {
        var interval = this._interval;
        var extent = this._extent;
        var niceTickExtent = this._niceExtent;
        var intervalPrecision = this._intervalPrecision;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        // Consider this case: using dataZoom toolbox, zoom and zoom.
        var safeLimit = 10000;
        if (extent[0] < niceTickExtent[0]) {
            if (expandToNicedExtent) ticks.push({
                value: $2388fa31203c7d49$var$roundNumber(niceTickExtent[0] - interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[0]
            });
        }
        var tick = niceTickExtent[0];
        while(tick <= niceTickExtent[1]){
            ticks.push({
                value: tick
            });
            // Avoid rounding error
            tick = $2388fa31203c7d49$var$roundNumber(tick + interval, intervalPrecision);
            if (tick === ticks[ticks.length - 1].value) break;
            if (ticks.length > safeLimit) return [];
        }
        // Consider this case: the last item of ticks is smaller
        // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
        var lastNiceTick = ticks.length ? ticks[ticks.length - 1].value : niceTickExtent[1];
        if (extent[1] > lastNiceTick) {
            if (expandToNicedExtent) ticks.push({
                value: $2388fa31203c7d49$var$roundNumber(lastNiceTick + interval, intervalPrecision)
            });
            else ticks.push({
                value: extent[1]
            });
        }
        return ticks;
    };
    IntervalScale.prototype.getMinorTicks = function(splitNumber) {
        var ticks = this.getTicks(true);
        var minorTicks = [];
        var extent = this.getExtent();
        for(var i = 1; i < ticks.length; i++){
            var nextTick = ticks[i];
            var prevTick = ticks[i - 1];
            var count = 0;
            var minorTicksGroup = [];
            var interval = nextTick.value - prevTick.value;
            var minorInterval = interval / splitNumber;
            while(count < splitNumber - 1){
                var minorTick = $2388fa31203c7d49$var$roundNumber(prevTick.value + (count + 1) * minorInterval);
                // For the first and last interval. The count may be less than splitNumber.
                if (minorTick > extent[0] && minorTick < extent[1]) minorTicksGroup.push(minorTick);
                count++;
            }
            minorTicks.push(minorTicksGroup);
        }
        return minorTicks;
    };
    /**
   * @param opt.precision If 'auto', use nice presision.
   * @param opt.pad returns 1.50 but not 1.5 if precision is 2.
   */ IntervalScale.prototype.getLabel = function(data, opt) {
        if (data == null) return '';
        var precision = opt && opt.precision;
        if (precision == null) precision = $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68(data.value) || 0;
        else if (precision === 'auto') // Should be more precise then tick.
        precision = this._intervalPrecision;
        // (1) If `precision` is set, 12.005 should be display as '12.00500'.
        // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
        var dataNum = $2388fa31203c7d49$var$roundNumber(data.value, precision, true);
        return $ff2fba995230f3c9$export$b6fe44657ce35c42(dataNum);
    };
    /**
   * @param splitNumber By default `5`.
   */ IntervalScale.prototype.calcNiceTicks = function(splitNumber, minInterval, maxInterval) {
        splitNumber = splitNumber || 5;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (!isFinite(span)) return;
        // User may set axis min 0 and data are all negative
        // FIXME If it needs to reverse ?
        if (span < 0) {
            span = -span;
            extent.reverse();
        }
        var result = $b8495dfcf11610d1$export$eeea879a611eb991(extent, splitNumber, minInterval, maxInterval);
        this._intervalPrecision = result.intervalPrecision;
        this._interval = result.interval;
        this._niceExtent = result.niceTickExtent;
    };
    IntervalScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            if (extent[0] !== 0) {
                // Expand extent
                // Note that extents can be both negative. See #13154
                var expandSize = Math.abs(extent[0]);
                // In the fowllowing case
                //      Axis has been fixed max 100
                //      Plus data are all 100 and axis extent are [100, 100].
                // Extend to the both side will cause expanded max is larger than fixed max.
                // So only expand to the smaller side.
                if (!opt.fixMax) {
                    extent[1] += expandSize / 2;
                    extent[0] -= expandSize / 2;
                } else extent[0] -= expandSize / 2;
            } else extent[1] = 1;
        }
        var span = extent[1] - extent[0];
        // If there are no data and extent are [Infinity, -Infinity]
        if (!isFinite(span)) {
            extent[0] = 0;
            extent[1] = 1;
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
        // let extent = this._extent;
        var interval = this._interval;
        if (!opt.fixMin) extent[0] = $2388fa31203c7d49$var$roundNumber(Math.floor(extent[0] / interval) * interval);
        if (!opt.fixMax) extent[1] = $2388fa31203c7d49$var$roundNumber(Math.ceil(extent[1] / interval) * interval);
    };
    IntervalScale.prototype.setNiceExtent = function(min, max) {
        this._niceExtent = [
            min,
            max
        ];
    };
    IntervalScale.type = 'interval';
    return IntervalScale;
}((0, $c961137ecae10b1b$export$2e2bcd8739ae039));
(0, $c961137ecae10b1b$export$2e2bcd8739ae039).registerClass($2388fa31203c7d49$var$IntervalScale);
var $2388fa31203c7d49$export$2e2bcd8739ae039 = $2388fa31203c7d49$var$IntervalScale;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







// FIXME 公用？
var $998964b027d914e1$var$bisect = function(a, x, lo, hi) {
    while(lo < hi){
        var mid = lo + hi >>> 1;
        if (a[mid][1] < x) lo = mid + 1;
        else hi = mid;
    }
    return lo;
};
var $998964b027d914e1$var$TimeScale = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TimeScale, _super);
    function TimeScale(settings) {
        var _this = _super.call(this, settings) || this;
        _this.type = 'time';
        return _this;
    }
    /**
   * Get label is mainly for other components like dataZoom, tooltip.
   */ TimeScale.prototype.getLabel = function(tick) {
        var useUTC = this.getSetting('useUTC');
        return (0, $1e22c322bcf5ac75$export$d9468344d3651243)(tick.value, (0, $1e22c322bcf5ac75$export$445bdbd8d2334e40)[(0, $1e22c322bcf5ac75$export$124c820721c4f66b)((0, $1e22c322bcf5ac75$export$1da4b91a25d7e1c8)(this._minLevelUnit))] || (0, $1e22c322bcf5ac75$export$445bdbd8d2334e40).second, useUTC, this.getSetting('locale'));
    };
    TimeScale.prototype.getFormattedLabel = function(tick, idx, labelFormatter) {
        var isUTC = this.getSetting('useUTC');
        var lang = this.getSetting('locale');
        return (0, $1e22c322bcf5ac75$export$fe777b6293828b5d)(tick, idx, labelFormatter, lang, isUTC);
    };
    /**
   * @override
   */ TimeScale.prototype.getTicks = function() {
        var interval = this._interval;
        var extent = this._extent;
        var ticks = [];
        // If interval is 0, return [];
        if (!interval) return ticks;
        ticks.push({
            value: extent[0],
            level: 0
        });
        var useUTC = this.getSetting('useUTC');
        var innerTicks = $998964b027d914e1$var$getIntervalTicks(this._minLevelUnit, this._approxInterval, useUTC, extent);
        ticks = ticks.concat(innerTicks);
        ticks.push({
            value: extent[1],
            level: 0
        });
        return ticks;
    };
    TimeScale.prototype.calcNiceExtent = function(opt) {
        var extent = this._extent;
        // If extent start and end are same, expand them
        if (extent[0] === extent[1]) {
            // Expand extent
            extent[0] -= (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab);
            extent[1] += (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab);
        }
        // If there are no data and extent are [Infinity, -Infinity]
        if (extent[1] === -Infinity && extent[0] === Infinity) {
            var d = new Date();
            extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
            extent[0] = extent[1] - (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab);
        }
        this.calcNiceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval);
    };
    TimeScale.prototype.calcNiceTicks = function(approxTickNum, minInterval, maxInterval) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        this._approxInterval = span / approxTickNum;
        if (minInterval != null && this._approxInterval < minInterval) this._approxInterval = minInterval;
        if (maxInterval != null && this._approxInterval > maxInterval) this._approxInterval = maxInterval;
        var scaleIntervalsLen = $998964b027d914e1$var$scaleIntervals.length;
        var idx = Math.min($998964b027d914e1$var$bisect($998964b027d914e1$var$scaleIntervals, this._approxInterval, 0, scaleIntervalsLen), scaleIntervalsLen - 1);
        // Interval that can be used to calculate ticks
        this._interval = $998964b027d914e1$var$scaleIntervals[idx][1];
        // Min level used when picking ticks from top down.
        // We check one more level to avoid the ticks are to sparse in some case.
        this._minLevelUnit = $998964b027d914e1$var$scaleIntervals[Math.max(idx - 1, 0)][0];
    };
    TimeScale.prototype.parse = function(val) {
        // val might be float.
        return (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(val) ? val : +$9fd90cf3bf18fbcd$export$6b862160d295c8e(val);
    };
    TimeScale.prototype.contain = function(val) {
        return $b8495dfcf11610d1$export$8893e2b90ba10d92(this.parse(val), this._extent);
    };
    TimeScale.prototype.normalize = function(val) {
        return $b8495dfcf11610d1$export$a3295358bff77e(this.parse(val), this._extent);
    };
    TimeScale.prototype.scale = function(val) {
        return $b8495dfcf11610d1$export$dcdf75081b88279d(val, this._extent);
    };
    TimeScale.type = 'time';
    return TimeScale;
}((0, $2388fa31203c7d49$export$2e2bcd8739ae039));
/**
 * This implementation was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ var $998964b027d914e1$var$scaleIntervals = [
    // Format                           interval
    [
        'second',
        (0, $1e22c322bcf5ac75$export$32c0454ceff7f92d)
    ],
    [
        'minute',
        (0, $1e22c322bcf5ac75$export$35acaebf644db34e)
    ],
    [
        'hour',
        (0, $1e22c322bcf5ac75$export$82541edf19e5e3b0)
    ],
    [
        'quarter-day',
        (0, $1e22c322bcf5ac75$export$82541edf19e5e3b0) * 6
    ],
    [
        'half-day',
        (0, $1e22c322bcf5ac75$export$82541edf19e5e3b0) * 12
    ],
    [
        'day',
        (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab) * 1.2
    ],
    [
        'half-week',
        (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab) * 3.5
    ],
    [
        'week',
        (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab) * 7
    ],
    [
        'month',
        (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab) * 31
    ],
    [
        'quarter',
        (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab) * 95
    ],
    [
        'half-year',
        (0, $1e22c322bcf5ac75$export$99cafda57477293d) / 2
    ],
    [
        'year',
        (0, $1e22c322bcf5ac75$export$99cafda57477293d)
    ] // 1Y
];
function $998964b027d914e1$var$isUnitValueSame(unit, valueA, valueB, isUTC) {
    var dateA = $9fd90cf3bf18fbcd$export$6b862160d295c8e(valueA);
    var dateB = $9fd90cf3bf18fbcd$export$6b862160d295c8e(valueB);
    var isSame = function(unit) {
        return (0, $1e22c322bcf5ac75$export$e04e41a1e24ffd3f)(dateA, unit, isUTC) === (0, $1e22c322bcf5ac75$export$e04e41a1e24ffd3f)(dateB, unit, isUTC);
    };
    var isSameYear = function() {
        return isSame('year');
    };
    // const isSameHalfYear = () => isSameYear() && isSame('half-year');
    // const isSameQuater = () => isSameYear() && isSame('quarter');
    var isSameMonth = function() {
        return isSameYear() && isSame('month');
    };
    var isSameDay = function() {
        return isSameMonth() && isSame('day');
    };
    // const isSameHalfDay = () => isSameDay() && isSame('half-day');
    var isSameHour = function() {
        return isSameDay() && isSame('hour');
    };
    var isSameMinute = function() {
        return isSameHour() && isSame('minute');
    };
    var isSameSecond = function() {
        return isSameMinute() && isSame('second');
    };
    var isSameMilliSecond = function() {
        return isSameSecond() && isSame('millisecond');
    };
    switch(unit){
        case 'year':
            return isSameYear();
        case 'month':
            return isSameMonth();
        case 'day':
            return isSameDay();
        case 'hour':
            return isSameHour();
        case 'minute':
            return isSameMinute();
        case 'second':
            return isSameSecond();
        case 'millisecond':
            return isSameMilliSecond();
    }
}
// const primaryUnitGetters = {
//     year: fullYearGetterName(),
//     month: monthGetterName(),
//     day: dateGetterName(),
//     hour: hoursGetterName(),
//     minute: minutesGetterName(),
//     second: secondsGetterName(),
//     millisecond: millisecondsGetterName()
// };
// const primaryUnitUTCGetters = {
//     year: fullYearGetterName(true),
//     month: monthGetterName(true),
//     day: dateGetterName(true),
//     hour: hoursGetterName(true),
//     minute: minutesGetterName(true),
//     second: secondsGetterName(true),
//     millisecond: millisecondsGetterName(true)
// };
// function moveTick(date: Date, unitName: TimeUnit, step: number, isUTC: boolean) {
//     step = step || 1;
//     switch (getPrimaryTimeUnit(unitName)) {
//         case 'year':
//             date[fullYearSetterName(isUTC)](date[fullYearGetterName(isUTC)]() + step);
//             break;
//         case 'month':
//             date[monthSetterName(isUTC)](date[monthGetterName(isUTC)]() + step);
//             break;
//         case 'day':
//             date[dateSetterName(isUTC)](date[dateGetterName(isUTC)]() + step);
//             break;
//         case 'hour':
//             date[hoursSetterName(isUTC)](date[hoursGetterName(isUTC)]() + step);
//             break;
//         case 'minute':
//             date[minutesSetterName(isUTC)](date[minutesGetterName(isUTC)]() + step);
//             break;
//         case 'second':
//             date[secondsSetterName(isUTC)](date[secondsGetterName(isUTC)]() + step);
//             break;
//         case 'millisecond':
//             date[millisecondsSetterName(isUTC)](date[millisecondsGetterName(isUTC)]() + step);
//             break;
//     }
//     return date.getTime();
// }
// const DATE_INTERVALS = [[8, 7.5], [4, 3.5], [2, 1.5]];
// const MONTH_INTERVALS = [[6, 5.5], [3, 2.5], [2, 1.5]];
// const MINUTES_SECONDS_INTERVALS = [[30, 30], [20, 20], [15, 15], [10, 10], [5, 5], [2, 2]];
function $998964b027d914e1$var$getDateInterval(approxInterval, daysInMonth) {
    approxInterval /= (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab);
    return approxInterval > 16 ? 16 : approxInterval > 7.5 ? 7 // TODO week 7 or day 8?
     : approxInterval > 3.5 ? 4 : approxInterval > 1.5 ? 2 : 1;
}
function $998964b027d914e1$var$getMonthInterval(approxInterval) {
    var APPROX_ONE_MONTH = 30 * (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab);
    approxInterval /= APPROX_ONE_MONTH;
    return approxInterval > 6 ? 6 : approxInterval > 3 ? 3 : approxInterval > 2 ? 2 : 1;
}
function $998964b027d914e1$var$getHourInterval(approxInterval) {
    approxInterval /= (0, $1e22c322bcf5ac75$export$82541edf19e5e3b0);
    return approxInterval > 12 ? 12 : approxInterval > 6 ? 6 : approxInterval > 3.5 ? 4 : approxInterval > 2 ? 2 : 1;
}
function $998964b027d914e1$var$getMinutesAndSecondsInterval(approxInterval, isMinutes) {
    approxInterval /= isMinutes ? (0, $1e22c322bcf5ac75$export$35acaebf644db34e) : (0, $1e22c322bcf5ac75$export$32c0454ceff7f92d);
    return approxInterval > 30 ? 30 : approxInterval > 20 ? 20 : approxInterval > 15 ? 15 : approxInterval > 10 ? 10 : approxInterval > 5 ? 5 : approxInterval > 2 ? 2 : 1;
}
function $998964b027d914e1$var$getMillisecondsInterval(approxInterval) {
    return $9fd90cf3bf18fbcd$export$7a695fe44258210b(approxInterval, true);
}
function $998964b027d914e1$var$getFirstTimestampOfUnit(date, unitName, isUTC) {
    var outDate = new Date(date);
    switch((0, $1e22c322bcf5ac75$export$1da4b91a25d7e1c8)(unitName)){
        case 'year':
        case 'month':
            outDate[(0, $1e22c322bcf5ac75$export$233f59998ed71c09)(isUTC)](0);
        case 'day':
            outDate[(0, $1e22c322bcf5ac75$export$82fd379a67f37fa0)(isUTC)](1);
        case 'hour':
            outDate[(0, $1e22c322bcf5ac75$export$b6f943e8d23c15bb)(isUTC)](0);
        case 'minute':
            outDate[(0, $1e22c322bcf5ac75$export$50303078793fc7d)(isUTC)](0);
        case 'second':
            outDate[(0, $1e22c322bcf5ac75$export$a4a908acda9c3118)(isUTC)](0);
            outDate[(0, $1e22c322bcf5ac75$export$c047afab75f6d84)(isUTC)](0);
    }
    return outDate.getTime();
}
function $998964b027d914e1$var$getIntervalTicks(bottomUnitName, approxInterval, isUTC, extent) {
    var safeLimit = 10000;
    var unitNames = (0, $1e22c322bcf5ac75$export$833c398a55654bb7);
    var iter = 0;
    function addTicksInSpan(interval, minTimestamp, maxTimestamp, getMethodName, setMethodName, isDate, out) {
        var date = new Date(minTimestamp);
        var dateTime = minTimestamp;
        var d = date[getMethodName]();
        // if (isDate) {
        //     d -= 1; // Starts with 0;   PENDING
        // }
        while(dateTime < maxTimestamp && dateTime <= extent[1]){
            out.push({
                value: dateTime
            });
            d += interval;
            date[setMethodName](d);
            dateTime = date.getTime();
        }
        // This extra tick is for calcuating ticks of next level. Will not been added to the final result
        out.push({
            value: dateTime,
            notAdd: true
        });
    }
    function addLevelTicks(unitName, lastLevelTicks, levelTicks) {
        var newAddedTicks = [];
        var isFirstLevel = !lastLevelTicks.length;
        if ($998964b027d914e1$var$isUnitValueSame((0, $1e22c322bcf5ac75$export$1da4b91a25d7e1c8)(unitName), extent[0], extent[1], isUTC)) return;
        if (isFirstLevel) lastLevelTicks = [
            {
                // TODO Optimize. Not include so may ticks.
                value: $998964b027d914e1$var$getFirstTimestampOfUnit(new Date(extent[0]), unitName, isUTC)
            },
            {
                value: extent[1]
            }
        ];
        for(var i = 0; i < lastLevelTicks.length - 1; i++){
            var startTick = lastLevelTicks[i].value;
            var endTick = lastLevelTicks[i + 1].value;
            if (startTick === endTick) continue;
            var interval = void 0;
            var getterName = void 0;
            var setterName = void 0;
            var isDate = false;
            switch(unitName){
                case 'year':
                    interval = Math.max(1, Math.round(approxInterval / (0, $1e22c322bcf5ac75$export$a97a1358cbb650ab) / 365));
                    getterName = (0, $1e22c322bcf5ac75$export$8d046fefed9a548e)(isUTC);
                    setterName = (0, $1e22c322bcf5ac75$export$43fbeac90913b151)(isUTC);
                    break;
                case 'half-year':
                case 'quarter':
                case 'month':
                    interval = $998964b027d914e1$var$getMonthInterval(approxInterval);
                    getterName = (0, $1e22c322bcf5ac75$export$5c242a801a23eec7)(isUTC);
                    setterName = (0, $1e22c322bcf5ac75$export$233f59998ed71c09)(isUTC);
                    break;
                case 'week':
                case 'half-week':
                case 'day':
                    interval = $998964b027d914e1$var$getDateInterval(approxInterval, 31); // Use 32 days and let interval been 16
                    getterName = (0, $1e22c322bcf5ac75$export$4189e6cbc9753260)(isUTC);
                    setterName = (0, $1e22c322bcf5ac75$export$82fd379a67f37fa0)(isUTC);
                    isDate = true;
                    break;
                case 'half-day':
                case 'quarter-day':
                case 'hour':
                    interval = $998964b027d914e1$var$getHourInterval(approxInterval);
                    getterName = (0, $1e22c322bcf5ac75$export$8b40b55b3c06cbe2)(isUTC);
                    setterName = (0, $1e22c322bcf5ac75$export$b6f943e8d23c15bb)(isUTC);
                    break;
                case 'minute':
                    interval = $998964b027d914e1$var$getMinutesAndSecondsInterval(approxInterval, true);
                    getterName = (0, $1e22c322bcf5ac75$export$8807847c5c71eded)(isUTC);
                    setterName = (0, $1e22c322bcf5ac75$export$50303078793fc7d)(isUTC);
                    break;
                case 'second':
                    interval = $998964b027d914e1$var$getMinutesAndSecondsInterval(approxInterval, false);
                    getterName = (0, $1e22c322bcf5ac75$export$8f49e73e2eebd168)(isUTC);
                    setterName = (0, $1e22c322bcf5ac75$export$a4a908acda9c3118)(isUTC);
                    break;
                case 'millisecond':
                    interval = $998964b027d914e1$var$getMillisecondsInterval(approxInterval);
                    getterName = (0, $1e22c322bcf5ac75$export$312207a92d041116)(isUTC);
                    setterName = (0, $1e22c322bcf5ac75$export$c047afab75f6d84)(isUTC);
                    break;
            }
            addTicksInSpan(interval, startTick, endTick, getterName, setterName, isDate, newAddedTicks);
            if (unitName === 'year' && levelTicks.length > 1 && i === 0) // Add nearest years to the left extent.
            levelTicks.unshift({
                value: levelTicks[0].value - interval
            });
        }
        for(var i = 0; i < newAddedTicks.length; i++)levelTicks.push(newAddedTicks[i]);
        // newAddedTicks.length && console.log(unitName, newAddedTicks);
        return newAddedTicks;
    }
    var levelsTicks = [];
    var currentLevelTicks = [];
    var tickCount = 0;
    var lastLevelTickCount = 0;
    for(var i = 0; i < unitNames.length && iter++ < safeLimit; ++i){
        var primaryTimeUnit = (0, $1e22c322bcf5ac75$export$1da4b91a25d7e1c8)(unitNames[i]);
        if (!(0, $1e22c322bcf5ac75$export$beb5920b69c13da)(unitNames[i])) continue;
        addLevelTicks(unitNames[i], levelsTicks[levelsTicks.length - 1] || [], currentLevelTicks);
        var nextPrimaryTimeUnit = unitNames[i + 1] ? (0, $1e22c322bcf5ac75$export$1da4b91a25d7e1c8)(unitNames[i + 1]) : null;
        if (primaryTimeUnit !== nextPrimaryTimeUnit) {
            if (currentLevelTicks.length) {
                lastLevelTickCount = tickCount;
                // Remove the duplicate so the tick count can be precisely.
                currentLevelTicks.sort(function(a, b) {
                    return a.value - b.value;
                });
                var levelTicksRemoveDuplicated = [];
                for(var i_1 = 0; i_1 < currentLevelTicks.length; ++i_1){
                    var tickValue = currentLevelTicks[i_1].value;
                    if (i_1 === 0 || currentLevelTicks[i_1 - 1].value !== tickValue) {
                        levelTicksRemoveDuplicated.push(currentLevelTicks[i_1]);
                        if (tickValue >= extent[0] && tickValue <= extent[1]) tickCount++;
                    }
                }
                var targetTickNum = (extent[1] - extent[0]) / approxInterval;
                // Added too much in this level and not too less in last level
                if (tickCount > targetTickNum * 1.5 && lastLevelTickCount > targetTickNum / 1.5) break;
                // Only treat primary time unit as one level.
                levelsTicks.push(levelTicksRemoveDuplicated);
                if (tickCount > targetTickNum || bottomUnitName === unitNames[i]) break;
            }
            // Reset if next unitName is primary
            currentLevelTicks = [];
        }
    }
    var levelsTicksInExtent = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(levelsTicks, function(levelTicks) {
        return (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(levelTicks, function(tick) {
            return tick.value >= extent[0] && tick.value <= extent[1] && !tick.notAdd;
        });
    }), function(levelTicks) {
        return levelTicks.length > 0;
    });
    var ticks = [];
    var maxLevel = levelsTicksInExtent.length - 1;
    for(var i = 0; i < levelsTicksInExtent.length; ++i){
        var levelTicks = levelsTicksInExtent[i];
        for(var k = 0; k < levelTicks.length; ++k)ticks.push({
            value: levelTicks[k].value,
            level: maxLevel - i
        });
    }
    ticks.sort(function(a, b) {
        return a.value - b.value;
    });
    // Remove duplicates
    var result = [];
    for(var i = 0; i < ticks.length; ++i)if (i === 0 || ticks[i].value !== ticks[i - 1].value) result.push(ticks[i]);
    return result;
}
(0, $c961137ecae10b1b$export$2e2bcd8739ae039).registerClass($998964b027d914e1$var$TimeScale);
var $998964b027d914e1$export$2e2bcd8739ae039 = $998964b027d914e1$var$TimeScale;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $a465ba1eea37b098$var$scaleProto = (0, $c961137ecae10b1b$export$2e2bcd8739ae039).prototype;
// FIXME:TS refactor: not good to call it directly with `this`?
var $a465ba1eea37b098$var$intervalScaleProto = (0, $2388fa31203c7d49$export$2e2bcd8739ae039).prototype;
var $a465ba1eea37b098$var$roundingErrorFix = $9fd90cf3bf18fbcd$export$2077e0241d6afd3c;
var $a465ba1eea37b098$var$mathFloor = Math.floor;
var $a465ba1eea37b098$var$mathCeil = Math.ceil;
var $a465ba1eea37b098$var$mathPow = Math.pow;
var $a465ba1eea37b098$var$mathLog = Math.log;
var $a465ba1eea37b098$var$LogScale = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LogScale, _super);
    function LogScale() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'log';
        _this.base = 10;
        _this._originalScale = new (0, $2388fa31203c7d49$export$2e2bcd8739ae039)();
        // FIXME:TS actually used by `IntervalScale`
        _this._interval = 0;
        return _this;
    }
    /**
   * @param Whether expand the ticks to niced extent.
   */ LogScale.prototype.getTicks = function(expandToNicedExtent) {
        var originalScale = this._originalScale;
        var extent = this._extent;
        var originalExtent = originalScale.getExtent();
        var ticks = $a465ba1eea37b098$var$intervalScaleProto.getTicks.call(this, expandToNicedExtent);
        return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(ticks, function(tick) {
            var val = tick.value;
            var powVal = $9fd90cf3bf18fbcd$export$2077e0241d6afd3c($a465ba1eea37b098$var$mathPow(this.base, val));
            // Fix #4158
            powVal = val === extent[0] && this._fixMin ? $a465ba1eea37b098$var$fixRoundingError(powVal, originalExtent[0]) : powVal;
            powVal = val === extent[1] && this._fixMax ? $a465ba1eea37b098$var$fixRoundingError(powVal, originalExtent[1]) : powVal;
            return {
                value: powVal
            };
        }, this);
    };
    LogScale.prototype.setExtent = function(start, end) {
        var base = $a465ba1eea37b098$var$mathLog(this.base);
        // log(-Infinity) is NaN, so safe guard here
        start = $a465ba1eea37b098$var$mathLog(Math.max(0, start)) / base;
        end = $a465ba1eea37b098$var$mathLog(Math.max(0, end)) / base;
        $a465ba1eea37b098$var$intervalScaleProto.setExtent.call(this, start, end);
    };
    /**
   * @return {number} end
   */ LogScale.prototype.getExtent = function() {
        var base = this.base;
        var extent = $a465ba1eea37b098$var$scaleProto.getExtent.call(this);
        extent[0] = $a465ba1eea37b098$var$mathPow(base, extent[0]);
        extent[1] = $a465ba1eea37b098$var$mathPow(base, extent[1]);
        // Fix #4158
        var originalScale = this._originalScale;
        var originalExtent = originalScale.getExtent();
        this._fixMin && (extent[0] = $a465ba1eea37b098$var$fixRoundingError(extent[0], originalExtent[0]));
        this._fixMax && (extent[1] = $a465ba1eea37b098$var$fixRoundingError(extent[1], originalExtent[1]));
        return extent;
    };
    LogScale.prototype.unionExtent = function(extent) {
        this._originalScale.unionExtent(extent);
        var base = this.base;
        extent[0] = $a465ba1eea37b098$var$mathLog(extent[0]) / $a465ba1eea37b098$var$mathLog(base);
        extent[1] = $a465ba1eea37b098$var$mathLog(extent[1]) / $a465ba1eea37b098$var$mathLog(base);
        $a465ba1eea37b098$var$scaleProto.unionExtent.call(this, extent);
    };
    LogScale.prototype.unionExtentFromData = function(data, dim) {
        // TODO
        // filter value that <= 0
        this.unionExtent(data.getApproximateExtent(dim));
    };
    /**
   * Update interval and extent of intervals for nice ticks
   * @param approxTickNum default 10 Given approx tick number
   */ LogScale.prototype.calcNiceTicks = function(approxTickNum) {
        approxTickNum = approxTickNum || 10;
        var extent = this._extent;
        var span = extent[1] - extent[0];
        if (span === Infinity || span <= 0) return;
        var interval = $9fd90cf3bf18fbcd$export$82dd68b83a44b253(span);
        var err = approxTickNum / span * interval;
        // Filter ticks to get closer to the desired count.
        if (err <= 0.5) interval *= 10;
        // Interval should be integer
        while(!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0)interval *= 10;
        var niceExtent = [
            $9fd90cf3bf18fbcd$export$2077e0241d6afd3c($a465ba1eea37b098$var$mathCeil(extent[0] / interval) * interval),
            $9fd90cf3bf18fbcd$export$2077e0241d6afd3c($a465ba1eea37b098$var$mathFloor(extent[1] / interval) * interval)
        ];
        this._interval = interval;
        this._niceExtent = niceExtent;
    };
    LogScale.prototype.calcNiceExtent = function(opt) {
        $a465ba1eea37b098$var$intervalScaleProto.calcNiceExtent.call(this, opt);
        this._fixMin = opt.fixMin;
        this._fixMax = opt.fixMax;
    };
    LogScale.prototype.parse = function(val) {
        return val;
    };
    LogScale.prototype.contain = function(val) {
        val = $a465ba1eea37b098$var$mathLog(val) / $a465ba1eea37b098$var$mathLog(this.base);
        return $b8495dfcf11610d1$export$8893e2b90ba10d92(val, this._extent);
    };
    LogScale.prototype.normalize = function(val) {
        val = $a465ba1eea37b098$var$mathLog(val) / $a465ba1eea37b098$var$mathLog(this.base);
        return $b8495dfcf11610d1$export$a3295358bff77e(val, this._extent);
    };
    LogScale.prototype.scale = function(val) {
        val = $b8495dfcf11610d1$export$dcdf75081b88279d(val, this._extent);
        return $a465ba1eea37b098$var$mathPow(this.base, val);
    };
    LogScale.type = 'log';
    return LogScale;
}((0, $c961137ecae10b1b$export$2e2bcd8739ae039));
var $a465ba1eea37b098$var$proto = $a465ba1eea37b098$var$LogScale.prototype;
$a465ba1eea37b098$var$proto.getMinorTicks = $a465ba1eea37b098$var$intervalScaleProto.getMinorTicks;
$a465ba1eea37b098$var$proto.getLabel = $a465ba1eea37b098$var$intervalScaleProto.getLabel;
function $a465ba1eea37b098$var$fixRoundingError(val, originalVal) {
    return $a465ba1eea37b098$var$roundingErrorFix(val, $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68(originalVal));
}
(0, $c961137ecae10b1b$export$2e2bcd8739ae039).registerClass($a465ba1eea37b098$var$LogScale);
var $a465ba1eea37b098$export$2e2bcd8739ae039 = $a465ba1eea37b098$var$LogScale;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $2c2289b75ab1ab72$export$c35454f678e99c82 = /** @class */ function() {
    function ScaleRawExtentInfo(scale, model, // Usually: data extent from all series on this axis.
    originalExtent) {
        this._prepareParams(scale, model, originalExtent);
    }
    /**
   * Parameters depending on outside (like model, user callback)
   * are prepared and fixed here.
   */ ScaleRawExtentInfo.prototype._prepareParams = function(scale, model, // Usually: data extent from all series on this axis.
    dataExtent) {
        if (dataExtent[1] < dataExtent[0]) dataExtent = [
            NaN,
            NaN
        ];
        this._dataMin = dataExtent[0];
        this._dataMax = dataExtent[1];
        var isOrdinal = this._isOrdinal = scale.type === 'ordinal';
        this._needCrossZero = scale.type === 'interval' && model.getNeedCrossZero && model.getNeedCrossZero();
        var axisMinValue = model.get('min', true);
        if (axisMinValue == null) axisMinValue = model.get('startValue', true);
        var modelMinRaw = this._modelMinRaw = axisMinValue;
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(modelMinRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMinNum = $2c2289b75ab1ab72$export$d02f2e65dfc3c2b(scale, modelMinRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMinRaw !== 'dataMin') this._modelMinNum = $2c2289b75ab1ab72$export$d02f2e65dfc3c2b(scale, modelMinRaw);
        var modelMaxRaw = this._modelMaxRaw = model.get('max', true);
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(modelMaxRaw)) // This callback always provides users the full data extent (before data is filtered).
        this._modelMaxNum = $2c2289b75ab1ab72$export$d02f2e65dfc3c2b(scale, modelMaxRaw({
            min: dataExtent[0],
            max: dataExtent[1]
        }));
        else if (modelMaxRaw !== 'dataMax') this._modelMaxNum = $2c2289b75ab1ab72$export$d02f2e65dfc3c2b(scale, modelMaxRaw);
        if (isOrdinal) // FIXME: there is a flaw here: if there is no "block" data processor like `dataZoom`,
        // and progressive rendering is using, here the category result might just only contain
        // the processed chunk rather than the entire result.
        this._axisDataLen = model.getCategories().length;
        else {
            var boundaryGap = model.get('boundaryGap');
            var boundaryGapArr = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(boundaryGap) ? boundaryGap : [
                boundaryGap || 0,
                boundaryGap || 0
            ];
            if (typeof boundaryGapArr[0] === 'boolean' || typeof boundaryGapArr[1] === 'boolean') this._boundaryGapInner = [
                0,
                0
            ];
            else this._boundaryGapInner = [
                (0, $297531217517fbce$export$e8514cb5a5e2b40f)(boundaryGapArr[0], 1),
                (0, $297531217517fbce$export$e8514cb5a5e2b40f)(boundaryGapArr[1], 1)
            ];
        }
    };
    /**
   * Calculate extent by prepared parameters.
   * This method has no external dependency and can be called duplicatedly,
   * getting the same result.
   * If parameters changed, should call this method to recalcuate.
   */ ScaleRawExtentInfo.prototype.calculate = function() {
        // Notice: When min/max is not set (that is, when there are null/undefined,
        // which is the most common case), these cases should be ensured:
        // (1) For 'ordinal', show all axis.data.
        // (2) For others:
        //      + `boundaryGap` is applied (if min/max set, boundaryGap is
        //      disabled).
        //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
        //      be the result that originalExtent enlarged by boundaryGap.
        // (3) If no data, it should be ensured that `scale.setBlank` is set.
        var isOrdinal = this._isOrdinal;
        var dataMin = this._dataMin;
        var dataMax = this._dataMax;
        var axisDataLen = this._axisDataLen;
        var boundaryGapInner = this._boundaryGapInner;
        var span = !isOrdinal ? dataMax - dataMin || Math.abs(dataMin) : null;
        // Currently if a `'value'` axis model min is specified as 'dataMin'/'dataMax',
        // `boundaryGap` will not be used. It's the different from specifying as `null`/`undefined`.
        var min = this._modelMinRaw === 'dataMin' ? dataMin : this._modelMinNum;
        var max = this._modelMaxRaw === 'dataMax' ? dataMax : this._modelMaxNum;
        // If `_modelMinNum`/`_modelMaxNum` is `null`/`undefined`, should not be fixed.
        var minFixed = min != null;
        var maxFixed = max != null;
        if (min == null) min = isOrdinal ? axisDataLen ? 0 : NaN : dataMin - boundaryGapInner[0] * span;
        if (max == null) max = isOrdinal ? axisDataLen ? axisDataLen - 1 : NaN : dataMax + boundaryGapInner[1] * span;
        (min == null || !isFinite(min)) && (min = NaN);
        (max == null || !isFinite(max)) && (max = NaN);
        var isBlank = (0, $1b239fc9d3a2f8ae$export$7d667b9a0c48c975)(min) || (0, $1b239fc9d3a2f8ae$export$7d667b9a0c48c975)(max) || isOrdinal && !axisDataLen;
        // If data extent modified, need to recalculated to ensure cross zero.
        if (this._needCrossZero) {
            // Axis is over zero and min is not set
            if (min > 0 && max > 0 && !minFixed) min = 0;
            // Axis is under zero and max is not set
            if (min < 0 && max < 0 && !maxFixed) max = 0;
        // PENDING:
        // When `needCrossZero` and all data is positive/negative, should it be ensured
        // that the results processed by boundaryGap are positive/negative?
        // If so, here `minFixed`/`maxFixed` need to be set.
        }
        var determinedMin = this._determinedMin;
        var determinedMax = this._determinedMax;
        if (determinedMin != null) {
            min = determinedMin;
            minFixed = true;
        }
        if (determinedMax != null) {
            max = determinedMax;
            maxFixed = true;
        }
        // Ensure min/max be finite number or NaN here. (not to be null/undefined)
        // `NaN` means min/max axis is blank.
        return {
            min: min,
            max: max,
            minFixed: minFixed,
            maxFixed: maxFixed,
            isBlank: isBlank
        };
    };
    ScaleRawExtentInfo.prototype.modifyDataMinMax = function(minMaxName, val) {
        this[$2c2289b75ab1ab72$var$DATA_MIN_MAX_ATTR[minMaxName]] = val;
    };
    ScaleRawExtentInfo.prototype.setDeterminedMinMax = function(minMaxName, val) {
        var attr = $2c2289b75ab1ab72$var$DETERMINED_MIN_MAX_ATTR[minMaxName];
        this[attr] = val;
    };
    ScaleRawExtentInfo.prototype.freeze = function() {
        // @ts-ignore
        this.frozen = true;
    };
    return ScaleRawExtentInfo;
}();
var $2c2289b75ab1ab72$var$DETERMINED_MIN_MAX_ATTR = {
    min: '_determinedMin',
    max: '_determinedMax'
};
var $2c2289b75ab1ab72$var$DATA_MIN_MAX_ATTR = {
    min: '_dataMin',
    max: '_dataMax'
};
function $2c2289b75ab1ab72$export$5c3dbcbeb9ce7f5a(scale, model, // Usually: data extent from all series on this axis.
originalExtent) {
    // Do not permit to recreate.
    var rawExtentInfo = scale.rawExtentInfo;
    if (rawExtentInfo) return rawExtentInfo;
    rawExtentInfo = new $2c2289b75ab1ab72$export$c35454f678e99c82(scale, model, originalExtent);
    // @ts-ignore
    scale.rawExtentInfo = rawExtentInfo;
    return rawExtentInfo;
}
function $2c2289b75ab1ab72$export$d02f2e65dfc3c2b(scale, minMax) {
    return minMax == null ? null : (0, $1b239fc9d3a2f8ae$export$7d667b9a0c48c975)(minMax) ? NaN : scale.parse(minMax);
}


function $5435624263a719a6$export$9c0ba8df7eb7b328(scale, model) {
    var scaleType = scale.type;
    var rawExtentResult = (0, $2c2289b75ab1ab72$export$5c3dbcbeb9ce7f5a)(scale, model, scale.getExtent()).calculate();
    scale.setBlank(rawExtentResult.isBlank);
    var min = rawExtentResult.min;
    var max = rawExtentResult.max;
    // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
    // is base axis
    // FIXME
    // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
    // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
    //     Should not depend on series type `bar`?
    // (3) Fix that might overlap when using dataZoom.
    // (4) Consider other chart types using `barGrid`?
    // See #6728, #4862, `test/bar-overflow-time-plot.html`
    var ecModel = model.ecModel;
    if (ecModel && scaleType === 'time' /* || scaleType === 'interval' */ ) {
        var barSeriesModels = (0, $b069e7ac30ed5deb$export$efbd0c3f5ab0d5e4)('bar', ecModel);
        var isBaseAxisAndHasBarSeries_1 = false;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(barSeriesModels, function(seriesModel) {
            isBaseAxisAndHasBarSeries_1 = isBaseAxisAndHasBarSeries_1 || seriesModel.getBaseAxis() === model.axis;
        });
        if (isBaseAxisAndHasBarSeries_1) {
            // Calculate placement of bars on axis. TODO should be decoupled
            // with barLayout
            var barWidthAndOffset = (0, $b069e7ac30ed5deb$export$20769dafc84e0299)(barSeriesModels);
            // Adjust axis min and max to account for overflow
            var adjustedScale = $5435624263a719a6$var$adjustScaleForOverflow(min, max, model, barWidthAndOffset);
            min = adjustedScale.min;
            max = adjustedScale.max;
        }
    }
    return {
        extent: [
            min,
            max
        ],
        // "fix" means "fixed", the value should not be
        // changed in the subsequent steps.
        fixMin: rawExtentResult.minFixed,
        fixMax: rawExtentResult.maxFixed
    };
}
function $5435624263a719a6$var$adjustScaleForOverflow(min, max, model, // Only support cartesian coord yet.
barWidthAndOffset) {
    // Get Axis Length
    var axisExtent = model.axis.getExtent();
    var axisLength = Math.abs(axisExtent[1] - axisExtent[0]);
    // Get bars on current base axis and calculate min and max overflow
    var barsOnCurrentAxis = (0, $b069e7ac30ed5deb$export$35920bb6556da1c2)(barWidthAndOffset, model.axis);
    if (barsOnCurrentAxis === undefined) return {
        min: min,
        max: max
    };
    var minOverflow = Infinity;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        minOverflow = Math.min(item.offset, minOverflow);
    });
    var maxOverflow = -Infinity;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(barsOnCurrentAxis, function(item) {
        maxOverflow = Math.max(item.offset + item.width, maxOverflow);
    });
    minOverflow = Math.abs(minOverflow);
    maxOverflow = Math.abs(maxOverflow);
    var totalOverFlow = minOverflow + maxOverflow;
    // Calculate required buffer based on old range and overflow
    var oldRange = max - min;
    var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
    var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
    max += overflowBuffer * (maxOverflow / totalOverFlow);
    min -= overflowBuffer * (minOverflow / totalOverFlow);
    return {
        min: min,
        max: max
    };
}
function $5435624263a719a6$export$51f3e70a54405d5a(scale, inModel) {
    var model = inModel;
    var extentInfo = $5435624263a719a6$export$9c0ba8df7eb7b328(scale, model);
    var extent = extentInfo.extent;
    var splitNumber = model.get('splitNumber');
    if (scale instanceof (0, $a465ba1eea37b098$export$2e2bcd8739ae039)) scale.base = model.get('logBase');
    var scaleType = scale.type;
    var interval = model.get('interval');
    var isIntervalOrTime = scaleType === 'interval' || scaleType === 'time';
    scale.setExtent(extent[0], extent[1]);
    scale.calcNiceExtent({
        splitNumber: splitNumber,
        fixMin: extentInfo.fixMin,
        fixMax: extentInfo.fixMax,
        minInterval: isIntervalOrTime ? model.get('minInterval') : null,
        maxInterval: isIntervalOrTime ? model.get('maxInterval') : null
    });
    // If some one specified the min, max. And the default calculated interval
    // is not good enough. He can specify the interval. It is often appeared
    // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
    // to be 60.
    // FIXME
    if (interval != null) scale.setInterval && scale.setInterval(interval);
}
function $5435624263a719a6$export$8941c4cacdc8f5a5(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $0c02dcf77630eefb$export$2e2bcd8739ae039)({
                ordinalMeta: model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $998964b027d914e1$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // case 'value'/'interval', 'log', or others.
            return new ((0, $c961137ecae10b1b$export$2e2bcd8739ae039).getClass(axisType) || (0, $2388fa31203c7d49$export$2e2bcd8739ae039))();
    }
}
function $5435624263a719a6$export$3eac36a69f37d52(axis) {
    var dataExtent = axis.scale.getExtent();
    var min = dataExtent[0];
    var max = dataExtent[1];
    return !(min > 0 && max > 0 || min < 0 && max < 0);
}
function $5435624263a719a6$export$742f19a75415b2ae(axis) {
    var labelFormatter = axis.getLabelModel().get('formatter');
    var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
    if (axis.scale.type === 'time') return function(tpl) {
        return function(tick, idx) {
            return axis.scale.getFormattedLabel(tick, idx, tpl);
        };
    }(labelFormatter);
    else if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(labelFormatter)) return function(tpl) {
        return function(tick) {
            // For category axis, get raw value; for numeric axis,
            // get formatted label like '1,333,444'.
            var label = axis.scale.getLabel(tick);
            var text = tpl.replace('{value}', label != null ? label : '');
            return text;
        };
    }(labelFormatter);
    else if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(labelFormatter)) return function(cb) {
        return function(tick, idx) {
            // The original intention of `idx` is "the index of the tick in all ticks".
            // But the previous implementation of category axis do not consider the
            // `axisLabel.interval`, which cause that, for example, the `interval` is
            // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
            // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
            // the definition here for back compatibility.
            if (categoryTickStart != null) idx = tick.value - categoryTickStart;
            return cb($5435624263a719a6$export$a5a32f324c1fa457(axis, tick), idx, tick.level != null ? {
                level: tick.level
            } : null);
        };
    }(labelFormatter);
    else return function(tick) {
        return axis.scale.getLabel(tick);
    };
}
function $5435624263a719a6$export$a5a32f324c1fa457(axis, tick) {
    // In category axis with data zoom, tick is not the original
    // index of axis.data. So tick should not be exposed to user
    // in category axis.
    return axis.type === 'category' ? axis.scale.getLabel(tick) : tick.value;
}
function $5435624263a719a6$export$fef1c7f0af0b48d(axis) {
    var axisModel = axis.model;
    var scale = axis.scale;
    if (!axisModel.get([
        'axisLabel',
        'show'
    ]) || scale.isBlank()) return;
    var realNumberScaleTicks;
    var tickCount;
    var categoryScaleExtent = scale.getExtent();
    // Optimize for large category data, avoid call `getTicks()`.
    if (scale instanceof (0, $0c02dcf77630eefb$export$2e2bcd8739ae039)) tickCount = scale.count();
    else {
        realNumberScaleTicks = scale.getTicks();
        tickCount = realNumberScaleTicks.length;
    }
    var axisLabelModel = axis.getLabelModel();
    var labelFormatter = $5435624263a719a6$export$742f19a75415b2ae(axis);
    var rect;
    var step = 1;
    // Simple optimization for large amount of labels
    if (tickCount > 40) step = Math.ceil(tickCount / 40);
    for(var i = 0; i < tickCount; i += step){
        var tick = realNumberScaleTicks ? realNumberScaleTicks[i] : {
            value: categoryScaleExtent[0] + i
        };
        var label = labelFormatter(tick, i);
        var unrotatedSingleRect = axisLabelModel.getTextRect(label);
        var singleRect = $5435624263a719a6$var$rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
        rect ? rect.union(singleRect) : rect = singleRect;
    }
    return rect;
}
function $5435624263a719a6$var$rotateTextRect(textRect, rotate) {
    var rotateRadians = rotate * Math.PI / 180;
    var beforeWidth = textRect.width;
    var beforeHeight = textRect.height;
    var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
    var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
    var rotatedRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(textRect.x, textRect.y, afterWidth, afterHeight);
    return rotatedRect;
}
function $5435624263a719a6$export$6d0bc2429155c088(model) {
    var interval = model.get('interval');
    return interval == null ? 'auto' : interval;
}
function $5435624263a719a6$export$c2911c025243d6a6(axis) {
    return axis.type === 'category' && $5435624263a719a6$export$6d0bc2429155c088(axis.getLabelModel()) === 0;
}
function $5435624263a719a6$export$e4cf30b1e74cd69d(data, axisDim) {
    // Remove duplicated dat dimensions caused by `getStackedDimension`.
    var dataDimMap = {};
    // Currently `mapDimensionsAll` will contain stack result dimension ('__\0ecstackresult').
    // PENDING: is it reasonable? Do we need to remove the original dim from "coord dim" since
    // there has been stacked result dim?
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(data.mapDimensionsAll(axisDim), function(dataDim) {
        // For example, the extent of the original dimension
        // is [0.1, 0.5], the extent of the `stackResultDimension`
        // is [7, 9], the final extent should NOT include [0.1, 0.5],
        // because there is no graphic corresponding to [0.1, 0.5].
        // See the case in `test/area-stack.html` `main1`, where area line
        // stack needs `yAxis` not start from 0.
        dataDimMap[(0, $495dfc021fe3a3f7$export$909db2be4938fbdf)(data, dataDim)] = true;
    });
    return $1b239fc9d3a2f8ae$export$ed97f33186d4b816(dataDimMap);
}
function $5435624263a719a6$export$635fe7f20d0f4c70(dataExtent, data, axisDim) {
    if (data) $1b239fc9d3a2f8ae$export$79b2f7037acddd43($5435624263a719a6$export$e4cf30b1e74cd69d(data, axisDim), function(dim) {
        var seriesExtent = data.getApproximateExtent(dim);
        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $954beded4d53af39$var$Cartesian = /** @class */ function() {
    function Cartesian(name) {
        this.type = 'cartesian';
        this._dimList = [];
        this._axes = {};
        this.name = name || '';
    }
    Cartesian.prototype.getAxis = function(dim) {
        return this._axes[dim];
    };
    Cartesian.prototype.getAxes = function() {
        return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(this._dimList, function(dim) {
            return this._axes[dim];
        }, this);
    };
    Cartesian.prototype.getAxesByScale = function(scaleType) {
        scaleType = scaleType.toLowerCase();
        return $1b239fc9d3a2f8ae$export$3dea766d36a8935f(this.getAxes(), function(axis) {
            return axis.scale.type === scaleType;
        });
    };
    Cartesian.prototype.addAxis = function(axis) {
        var dim = axis.dim;
        this._axes[dim] = axis;
        this._dimList.push(dim);
    };
    return Cartesian;
}();
var $954beded4d53af39$export$2e2bcd8739ae039 = $954beded4d53af39$var$Cartesian;




var $1f31cd4b553b0612$export$988a008d2b9120f4 = [
    'x',
    'y'
];
function $1f31cd4b553b0612$var$canCalculateAffineTransform(scale) {
    return scale.type === 'interval' || scale.type === 'time';
}
var $1f31cd4b553b0612$var$Cartesian2D = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Cartesian2D, _super);
    function Cartesian2D() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'cartesian2d';
        _this.dimensions = $1f31cd4b553b0612$export$988a008d2b9120f4;
        return _this;
    }
    /**
   * Calculate an affine transform matrix if two axes are time or value.
   * It's mainly for accelartion on the large time series data.
   */ Cartesian2D.prototype.calcAffineTransform = function() {
        this._transform = this._invTransform = null;
        var xAxisScale = this.getAxis('x').scale;
        var yAxisScale = this.getAxis('y').scale;
        if (!$1f31cd4b553b0612$var$canCalculateAffineTransform(xAxisScale) || !$1f31cd4b553b0612$var$canCalculateAffineTransform(yAxisScale)) return;
        var xScaleExtent = xAxisScale.getExtent();
        var yScaleExtent = yAxisScale.getExtent();
        var start = this.dataToPoint([
            xScaleExtent[0],
            yScaleExtent[0]
        ]);
        var end = this.dataToPoint([
            xScaleExtent[1],
            yScaleExtent[1]
        ]);
        var xScaleSpan = xScaleExtent[1] - xScaleExtent[0];
        var yScaleSpan = yScaleExtent[1] - yScaleExtent[0];
        if (!xScaleSpan || !yScaleSpan) return;
        // Accelerate data to point calculation on the special large time series data.
        var scaleX = (end[0] - start[0]) / xScaleSpan;
        var scaleY = (end[1] - start[1]) / yScaleSpan;
        var translateX = start[0] - xScaleExtent[0] * scaleX;
        var translateY = start[1] - yScaleExtent[0] * scaleY;
        var m = this._transform = [
            scaleX,
            0,
            0,
            scaleY,
            translateX,
            translateY
        ];
        this._invTransform = (0, $78537c687449356c$export$6897c284b6f9f4dc)([], m);
    };
    /**
   * Base axis will be used on stacking.
   */ Cartesian2D.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
    };
    Cartesian2D.prototype.containPoint = function(point) {
        var axisX = this.getAxis('x');
        var axisY = this.getAxis('y');
        return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
    };
    Cartesian2D.prototype.containData = function(data) {
        return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
    };
    Cartesian2D.prototype.containZone = function(data1, data2) {
        var zoneDiag1 = this.dataToPoint(data1);
        var zoneDiag2 = this.dataToPoint(data2);
        var area = this.getArea();
        var zone = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(zoneDiag1[0], zoneDiag1[1], zoneDiag2[0] - zoneDiag1[0], zoneDiag2[1] - zoneDiag1[1]);
        return area.intersect(zone);
    };
    Cartesian2D.prototype.dataToPoint = function(data, clamp, out) {
        out = out || [];
        var xVal = data[0];
        var yVal = data[1];
        // Fast path
        if (this._transform && xVal != null && isFinite(xVal) && yVal != null && isFinite(yVal)) return (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(out, data, this._transform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(xVal, clamp));
        out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(yVal, clamp));
        return out;
    };
    Cartesian2D.prototype.clampData = function(data, out) {
        var xScale = this.getAxis('x').scale;
        var yScale = this.getAxis('y').scale;
        var xAxisExtent = xScale.getExtent();
        var yAxisExtent = yScale.getExtent();
        var x = xScale.parse(data[0]);
        var y = yScale.parse(data[1]);
        out = out || [];
        out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
        out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
        return out;
    };
    Cartesian2D.prototype.pointToData = function(point, clamp) {
        var out = [];
        if (this._invTransform) return (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(out, point, this._invTransform);
        var xAxis = this.getAxis('x');
        var yAxis = this.getAxis('y');
        out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]), clamp);
        out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]), clamp);
        return out;
    };
    Cartesian2D.prototype.getOtherAxis = function(axis) {
        return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
    };
    /**
   * Get rect area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Cartesian2D.prototype.getArea = function(tolerance) {
        tolerance = tolerance || 0;
        var xExtent = this.getAxis('x').getGlobalExtent();
        var yExtent = this.getAxis('y').getGlobalExtent();
        var x = Math.min(xExtent[0], xExtent[1]) - tolerance;
        var y = Math.min(yExtent[0], yExtent[1]) - tolerance;
        var width = Math.max(xExtent[0], xExtent[1]) - x + tolerance;
        var height = Math.max(yExtent[0], yExtent[1]) - y + tolerance;
        return new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, width, height);
    };
    return Cartesian2D;
}((0, $954beded4d53af39$export$2e2bcd8739ae039));
var $1f31cd4b553b0612$export$2e2bcd8739ae039 = $1f31cd4b553b0612$var$Cartesian2D;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6bba7f6d39db3a9e$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $6bba7f6d39db3a9e$var$tickValuesToNumbers(axis, values) {
    var nums = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(values, function(val) {
        return axis.scale.parse(val);
    });
    if (axis.type === 'time' && nums.length > 0) {
        // Time axis needs duplicate first/last tick (see TimeScale.getTicks())
        // The first and last tick/label don't get drawn
        nums.sort();
        nums.unshift(nums[0]);
        nums.push(nums[nums.length - 1]);
    }
    return nums;
}
function $6bba7f6d39db3a9e$export$10216ebd3e3e485e(axis) {
    var custom = axis.getLabelModel().get('customValues');
    if (custom) {
        var labelFormatter_1 = (0, $5435624263a719a6$export$742f19a75415b2ae)(axis);
        var extent_1 = axis.scale.getExtent();
        var tickNumbers = $6bba7f6d39db3a9e$var$tickValuesToNumbers(axis, custom);
        var ticks = $1b239fc9d3a2f8ae$export$3dea766d36a8935f(tickNumbers, function(val) {
            return val >= extent_1[0] && val <= extent_1[1];
        });
        return {
            labels: $1b239fc9d3a2f8ae$export$871de8747c9eaa88(ticks, function(numval) {
                var tick = {
                    value: numval
                };
                return {
                    formattedLabel: labelFormatter_1(tick),
                    rawLabel: axis.scale.getLabel(tick),
                    tickValue: numval
                };
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $6bba7f6d39db3a9e$var$makeCategoryLabels(axis) : $6bba7f6d39db3a9e$var$makeRealNumberLabels(axis);
}
function $6bba7f6d39db3a9e$export$7cccf6836ae8323c(axis, tickModel) {
    var custom = axis.getTickModel().get('customValues');
    if (custom) {
        var extent_2 = axis.scale.getExtent();
        var tickNumbers = $6bba7f6d39db3a9e$var$tickValuesToNumbers(axis, custom);
        return {
            ticks: $1b239fc9d3a2f8ae$export$3dea766d36a8935f(tickNumbers, function(val) {
                return val >= extent_2[0] && val <= extent_2[1];
            })
        };
    }
    // Only ordinal scale support tick interval
    return axis.type === 'category' ? $6bba7f6d39db3a9e$var$makeCategoryTicks(axis, tickModel) : {
        ticks: $1b239fc9d3a2f8ae$export$871de8747c9eaa88(axis.scale.getTicks(), function(tick) {
            return tick.value;
        })
    };
}
function $6bba7f6d39db3a9e$var$makeCategoryLabels(axis) {
    var labelModel = axis.getLabelModel();
    var result = $6bba7f6d39db3a9e$var$makeCategoryLabelsActually(axis, labelModel);
    return !labelModel.get('show') || axis.scale.isBlank() ? {
        labels: [],
        labelCategoryInterval: result.labelCategoryInterval
    } : result;
}
function $6bba7f6d39db3a9e$var$makeCategoryLabelsActually(axis, labelModel) {
    var labelsCache = $6bba7f6d39db3a9e$var$getListCache(axis, 'labels');
    var optionLabelInterval = (0, $5435624263a719a6$export$6d0bc2429155c088)(labelModel);
    var result = $6bba7f6d39db3a9e$var$listCacheGet(labelsCache, optionLabelInterval);
    if (result) return result;
    var labels;
    var numericLabelInterval;
    if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(optionLabelInterval)) labels = $6bba7f6d39db3a9e$var$makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
    else {
        numericLabelInterval = optionLabelInterval === 'auto' ? $6bba7f6d39db3a9e$var$makeAutoCategoryInterval(axis) : optionLabelInterval;
        labels = $6bba7f6d39db3a9e$var$makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6bba7f6d39db3a9e$var$listCacheSet(labelsCache, optionLabelInterval, {
        labels: labels,
        labelCategoryInterval: numericLabelInterval
    });
}
function $6bba7f6d39db3a9e$var$makeCategoryTicks(axis, tickModel) {
    var ticksCache = $6bba7f6d39db3a9e$var$getListCache(axis, 'ticks');
    var optionTickInterval = (0, $5435624263a719a6$export$6d0bc2429155c088)(tickModel);
    var result = $6bba7f6d39db3a9e$var$listCacheGet(ticksCache, optionTickInterval);
    if (result) return result;
    var ticks;
    var tickCategoryInterval;
    // Optimize for the case that large category data and no label displayed,
    // we should not return all ticks.
    if (!tickModel.get('show') || axis.scale.isBlank()) ticks = [];
    if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(optionTickInterval)) ticks = $6bba7f6d39db3a9e$var$makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
    else if (optionTickInterval === 'auto') {
        var labelsResult = $6bba7f6d39db3a9e$var$makeCategoryLabelsActually(axis, axis.getLabelModel());
        tickCategoryInterval = labelsResult.labelCategoryInterval;
        ticks = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(labelsResult.labels, function(labelItem) {
            return labelItem.tickValue;
        });
    } else {
        tickCategoryInterval = optionTickInterval;
        ticks = $6bba7f6d39db3a9e$var$makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
    }
    // Cache to avoid calling interval function repeatedly.
    return $6bba7f6d39db3a9e$var$listCacheSet(ticksCache, optionTickInterval, {
        ticks: ticks,
        tickCategoryInterval: tickCategoryInterval
    });
}
function $6bba7f6d39db3a9e$var$makeRealNumberLabels(axis) {
    var ticks = axis.scale.getTicks();
    var labelFormatter = (0, $5435624263a719a6$export$742f19a75415b2ae)(axis);
    return {
        labels: $1b239fc9d3a2f8ae$export$871de8747c9eaa88(ticks, function(tick, idx) {
            return {
                level: tick.level,
                formattedLabel: labelFormatter(tick, idx),
                rawLabel: axis.scale.getLabel(tick),
                tickValue: tick.value
            };
        })
    };
}
function $6bba7f6d39db3a9e$var$getListCache(axis, prop) {
    // Because key can be a function, and cache size always is small, we use array cache.
    return $6bba7f6d39db3a9e$var$inner(axis)[prop] || ($6bba7f6d39db3a9e$var$inner(axis)[prop] = []);
}
function $6bba7f6d39db3a9e$var$listCacheGet(cache, key) {
    for(var i = 0; i < cache.length; i++){
        if (cache[i].key === key) return cache[i].value;
    }
}
function $6bba7f6d39db3a9e$var$listCacheSet(cache, key, value) {
    cache.push({
        key: key,
        value: value
    });
    return value;
}
function $6bba7f6d39db3a9e$var$makeAutoCategoryInterval(axis) {
    var result = $6bba7f6d39db3a9e$var$inner(axis).autoInterval;
    return result != null ? result : $6bba7f6d39db3a9e$var$inner(axis).autoInterval = axis.calculateCategoryInterval();
}
function $6bba7f6d39db3a9e$export$9ea1d3f146a5a65f(axis) {
    var params = $6bba7f6d39db3a9e$var$fetchAutoCategoryIntervalCalculationParams(axis);
    var labelFormatter = (0, $5435624263a719a6$export$742f19a75415b2ae)(axis);
    var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    // Providing this method is for optimization:
    // avoid generating a long array by `getTicks`
    // in large category data case.
    var tickCount = ordinalScale.count();
    if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
    var step = 1;
    // Simple optimization. Empirical value: tick count should less than 40.
    if (tickCount > 40) step = Math.max(1, Math.floor(tickCount / 40));
    var tickValue = ordinalExtent[0];
    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
    var unitW = Math.abs(unitSpan * Math.cos(rotation));
    var unitH = Math.abs(unitSpan * Math.sin(rotation));
    var maxW = 0;
    var maxH = 0;
    // Caution: Performance sensitive for large category data.
    // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
    for(; tickValue <= ordinalExtent[1]; tickValue += step){
        var width = 0;
        var height = 0;
        // Not precise, do not consider align and vertical align
        // and each distance from axis line yet.
        var rect = $297531217517fbce$export$c381147bfed79d9f(labelFormatter({
            value: tickValue
        }), params.font, 'center', 'top');
        // Magic number
        width = rect.width * 1.3;
        height = rect.height * 1.3;
        // Min size, void long loop.
        maxW = Math.max(maxW, width, 7);
        maxH = Math.max(maxH, height, 7);
    }
    var dw = maxW / unitW;
    var dh = maxH / unitH;
    // 0/0 is NaN, 1/0 is Infinity.
    isNaN(dw) && (dw = Infinity);
    isNaN(dh) && (dh = Infinity);
    var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
    var cache = $6bba7f6d39db3a9e$var$inner(axis.model);
    var axisExtent = axis.getExtent();
    var lastAutoInterval = cache.lastAutoInterval;
    var lastTickCount = cache.lastTickCount;
    // Use cache to keep interval stable while moving zoom window,
    // otherwise the calculated interval might jitter when the zoom
    // window size is close to the interval-changing size.
    // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
    // The jitter will cause that sometimes the displayed labels are
    // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval && cache.axisExtent0 === axisExtent[0] && cache.axisExtent1 === axisExtent[1]) interval = lastAutoInterval;
    else {
        cache.lastTickCount = tickCount;
        cache.lastAutoInterval = interval;
        cache.axisExtent0 = axisExtent[0];
        cache.axisExtent1 = axisExtent[1];
    }
    return interval;
}
function $6bba7f6d39db3a9e$var$fetchAutoCategoryIntervalCalculationParams(axis) {
    var labelModel = axis.getLabelModel();
    return {
        axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
        labelRotate: labelModel.get('rotate') || 0,
        font: labelModel.getFont()
    };
}
function $6bba7f6d39db3a9e$var$makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
    var labelFormatter = (0, $5435624263a719a6$export$742f19a75415b2ae)(axis);
    var ordinalScale = axis.scale;
    var ordinalExtent = ordinalScale.getExtent();
    var labelModel = axis.getLabelModel();
    var result = [];
    // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
    var step = Math.max((categoryInterval || 0) + 1, 1);
    var startTick = ordinalExtent[0];
    var tickCount = ordinalScale.count();
    // Calculate start tick based on zero if possible to keep label consistent
    // while zooming and moving while interval > 0. Otherwise the selection
    // of displayable ticks and symbols probably keep changing.
    // 3 is empirical value.
    if (startTick !== 0 && step > 1 && tickCount / step > 2) startTick = Math.round(Math.ceil(startTick / step) * step);
    // (1) Only add min max label here but leave overlap checking
    // to render stage, which also ensure the returned list
    // suitable for splitLine and splitArea rendering.
    // (2) Scales except category always contain min max label so
    // do not need to perform this process.
    var showAllLabel = (0, $5435624263a719a6$export$c2911c025243d6a6)(axis);
    var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
    var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
    if (includeMinLabel && startTick !== ordinalExtent[0]) addItem(ordinalExtent[0]);
    // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
    var tickValue = startTick;
    for(; tickValue <= ordinalExtent[1]; tickValue += step)addItem(tickValue);
    if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) addItem(ordinalExtent[1]);
    function addItem(tickValue) {
        var tickObj = {
            value: tickValue
        };
        result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tickObj),
            rawLabel: ordinalScale.getLabel(tickObj),
            tickValue: tickValue
        });
    }
    return result;
}
function $6bba7f6d39db3a9e$var$makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
    var ordinalScale = axis.scale;
    var labelFormatter = (0, $5435624263a719a6$export$742f19a75415b2ae)(axis);
    var result = [];
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(ordinalScale.getTicks(), function(tick) {
        var rawLabel = ordinalScale.getLabel(tick);
        var tickValue = tick.value;
        if (categoryInterval(tick.value, rawLabel)) result.push(onlyTick ? tickValue : {
            formattedLabel: labelFormatter(tick),
            rawLabel: rawLabel,
            tickValue: tickValue
        });
    });
    return result;
}


var $099c976b90502319$var$NORMALIZED_EXTENT = [
    0,
    1
];
/**
 * Base class of Axis.
 */ var $099c976b90502319$var$Axis = /** @class */ function() {
    function Axis(dim, scale, extent) {
        this.onBand = false;
        this.inverse = false;
        this.dim = dim;
        this.scale = scale;
        this._extent = extent || [
            0,
            0
        ];
    }
    /**
   * If axis extent contain given coord
   */ Axis.prototype.contain = function(coord) {
        var extent = this._extent;
        var min = Math.min(extent[0], extent[1]);
        var max = Math.max(extent[0], extent[1]);
        return coord >= min && coord <= max;
    };
    /**
   * If axis extent contain given data
   */ Axis.prototype.containData = function(data) {
        return this.scale.contain(data);
    };
    /**
   * Get coord extent.
   */ Axis.prototype.getExtent = function() {
        return this._extent.slice();
    };
    /**
   * Get precision used for formatting
   */ Axis.prototype.getPixelPrecision = function(dataExtent) {
        return (0, $9fd90cf3bf18fbcd$export$666260d9a2dda8a7)(dataExtent || this.scale.getExtent(), this._extent);
    };
    /**
   * Set coord extent
   */ Axis.prototype.setExtent = function(start, end) {
        var extent = this._extent;
        extent[0] = start;
        extent[1] = end;
    };
    /**
   * Convert data to coord. Data is the rank if it has an ordinal scale
   */ Axis.prototype.dataToCoord = function(data, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        data = scale.normalize(data);
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $099c976b90502319$var$fixExtentWithBands(extent, scale.count());
        }
        return (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(data, $099c976b90502319$var$NORMALIZED_EXTENT, extent, clamp);
    };
    /**
   * Convert coord to data. Data is the rank if it has an ordinal scale
   */ Axis.prototype.coordToData = function(coord, clamp) {
        var extent = this._extent;
        var scale = this.scale;
        if (this.onBand && scale.type === 'ordinal') {
            extent = extent.slice();
            $099c976b90502319$var$fixExtentWithBands(extent, scale.count());
        }
        var t = (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(coord, extent, $099c976b90502319$var$NORMALIZED_EXTENT, clamp);
        return this.scale.scale(t);
    };
    /**
   * Convert pixel point to data in axis
   */ Axis.prototype.pointToData = function(point, clamp) {
        // Should be implemented in derived class if necessary.
        return;
    };
    /**
   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
   * `axis.getTicksCoords` considers `onBand`, which is used by
   * `boundaryGap:true` of category axis and splitLine and splitArea.
   * @param opt.tickModel default: axis.model.getModel('axisTick')
   * @param opt.clamp If `true`, the first and the last
   *        tick must be at the axis end points. Otherwise, clip ticks
   *        that outside the axis extent.
   */ Axis.prototype.getTicksCoords = function(opt) {
        opt = opt || {};
        var tickModel = opt.tickModel || this.getTickModel();
        var result = (0, $6bba7f6d39db3a9e$export$7cccf6836ae8323c)(this, tickModel);
        var ticks = result.ticks;
        var ticksCoords = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(ticks, function(tickVal) {
            return {
                coord: this.dataToCoord(this.scale.type === 'ordinal' ? this.scale.getRawOrdinalNumber(tickVal) : tickVal),
                tickValue: tickVal
            };
        }, this);
        var alignWithLabel = tickModel.get('alignWithLabel');
        $099c976b90502319$var$fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
        return ticksCoords;
    };
    Axis.prototype.getMinorTicksCoords = function() {
        if (this.scale.type === 'ordinal') // Category axis doesn't support minor ticks
        return [];
        var minorTickModel = this.model.getModel('minorTick');
        var splitNumber = minorTickModel.get('splitNumber');
        // Protection.
        if (!(splitNumber > 0 && splitNumber < 100)) splitNumber = 5;
        var minorTicks = this.scale.getMinorTicks(splitNumber);
        var minorTicksCoords = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(minorTicks, function(minorTicksGroup) {
            return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(minorTicksGroup, function(minorTick) {
                return {
                    coord: this.dataToCoord(minorTick),
                    tickValue: minorTick
                };
            }, this);
        }, this);
        return minorTicksCoords;
    };
    Axis.prototype.getViewLabels = function() {
        return (0, $6bba7f6d39db3a9e$export$10216ebd3e3e485e)(this).labels;
    };
    Axis.prototype.getLabelModel = function() {
        return this.model.getModel('axisLabel');
    };
    /**
   * Notice here we only get the default tick model. For splitLine
   * or splitArea, we should pass the splitLineModel or splitAreaModel
   * manually when calling `getTicksCoords`.
   * In GL, this method may be overridden to:
   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
   */ Axis.prototype.getTickModel = function() {
        return this.model.getModel('axisTick');
    };
    /**
   * Get width of band
   */ Axis.prototype.getBandWidth = function() {
        var axisExtent = this._extent;
        var dataExtent = this.scale.getExtent();
        var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0);
        // Fix #2728, avoid NaN when only one data.
        len === 0 && (len = 1);
        var size = Math.abs(axisExtent[1] - axisExtent[0]);
        return Math.abs(size) / len;
    };
    /**
   * Only be called in category axis.
   * Can be overridden, consider other axes like in 3D.
   * @return Auto interval for cateogry axis tick and label
   */ Axis.prototype.calculateCategoryInterval = function() {
        return (0, $6bba7f6d39db3a9e$export$9ea1d3f146a5a65f)(this);
    };
    return Axis;
}();
function $099c976b90502319$var$fixExtentWithBands(extent, nTick) {
    var size = extent[1] - extent[0];
    var len = nTick;
    var margin = size / len / 2;
    extent[0] += margin;
    extent[1] -= margin;
}
// If axis has labels [1, 2, 3, 4]. Bands on the axis are
// |---1---|---2---|---3---|---4---|.
// So the displayed ticks and splitLine/splitArea should between
// each data item, otherwise cause misleading (e.g., split tow bars
// of a single data item when there are two bar series).
// Also consider if tickCategoryInterval > 0 and onBand, ticks and
// splitLine/spliteArea should layout appropriately corresponding
// to displayed labels. (So we should not use `getBandWidth` in this
// case).
function $099c976b90502319$var$fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
    var ticksLen = ticksCoords.length;
    if (!axis.onBand || alignWithLabel || !ticksLen) return;
    var axisExtent = axis.getExtent();
    var last;
    var diffSize;
    if (ticksLen === 1) {
        ticksCoords[0].coord = axisExtent[0];
        last = ticksCoords[1] = {
            coord: axisExtent[1],
            tickValue: ticksCoords[0].tickValue
        };
    } else {
        var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
        var shift_1 = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(ticksCoords, function(ticksItem) {
            ticksItem.coord -= shift_1 / 2;
        });
        var dataExtent = axis.scale.getExtent();
        diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
        last = {
            coord: ticksCoords[ticksLen - 1].coord + shift_1 * diffSize,
            tickValue: dataExtent[1] + 1
        };
        ticksCoords.push(last);
    }
    var inverse = axisExtent[0] > axisExtent[1];
    // Handling clamp.
    if (littleThan(ticksCoords[0].coord, axisExtent[0])) clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
    if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) ticksCoords.unshift({
        coord: axisExtent[0]
    });
    if (littleThan(axisExtent[1], last.coord)) clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
    if (clamp && littleThan(last.coord, axisExtent[1])) ticksCoords.push({
        coord: axisExtent[1]
    });
    function littleThan(a, b) {
        // Avoid rounding error cause calculated tick coord different with extent.
        // It may cause an extra unnecessary tick added.
        a = (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(a);
        b = (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(b);
        return inverse ? a > b : a < b;
    }
}
var $099c976b90502319$export$2e2bcd8739ae039 = $099c976b90502319$var$Axis;


var $bfcec2d6e3dc76f6$var$Axis2D = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Axis2D, _super);
    function Axis2D(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        /**
     * Index of axis, can be used as key
     * Injected outside.
     */ _this.index = 0;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    Axis2D.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    /**
   * Each item cooresponds to this.getExtent(), which
   * means globalExtent[0] may greater than globalExtent[1],
   * unless `asc` is input.
   *
   * @param {boolean} [asc]
   * @return {Array.<number>}
   */ Axis2D.prototype.getGlobalExtent = function(asc) {
        var ret = this.getExtent();
        ret[0] = this.toGlobalCoord(ret[0]);
        ret[1] = this.toGlobalCoord(ret[1]);
        asc && ret[0] > ret[1] && ret.reverse();
        return ret;
    };
    Axis2D.prototype.pointToData = function(point, clamp) {
        return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
    };
    /**
   * Set ordinalSortInfo
   * @param info new OrdinalSortInfo
   */ Axis2D.prototype.setCategorySortInfo = function(info) {
        if (this.type !== 'category') return false;
        this.model.option.categorySortInfo = info;
        this.scale.setSortInfo(info);
    };
    return Axis2D;
}((0, $099c976b90502319$export$2e2bcd8739ae039));
var $bfcec2d6e3dc76f6$export$2e2bcd8739ae039 = $bfcec2d6e3dc76f6$var$Axis2D;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $9a3224039b65a07f$export$b3219800bda33a1f(gridModel, axisModel, opt) {
    opt = opt || {};
    var grid = gridModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
    var rawAxisPosition = axis.position;
    var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
    var axisDim = axis.dim;
    var rect = grid.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var idx = {
        left: 0,
        right: 1,
        top: 0,
        bottom: 1,
        onZero: 2
    };
    var axisOffset = axisModel.get('offset') || 0;
    var posBound = axisDim === 'x' ? [
        rectBound[2] - axisOffset,
        rectBound[3] + axisOffset
    ] : [
        rectBound[0] - axisOffset,
        rectBound[1] + axisOffset
    ];
    if (otherAxisOnZeroOf) {
        var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
        posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
    }
    // Axis position
    layout.position = [
        axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0],
        axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]
    ];
    // Axis rotation
    layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1);
    // Tick and label direction, x y is axisDim
    var dirMap = {
        top: -1,
        bottom: 1,
        left: -1,
        right: 1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
    layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($1b239fc9d3a2f8ae$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    // Special label rotation
    var labelRotate = axisModel.get([
        'axisLabel',
        'rotate'
    ]);
    layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate;
    // Over splitLine and splitArea
    layout.z2 = 1;
    return layout;
}
function $9a3224039b65a07f$export$c2a0b77974c5e35d(seriesModel) {
    return seriesModel.get('coordinateSystem') === 'cartesian2d';
}
function $9a3224039b65a07f$export$8220131ac1d61d28(seriesModel) {
    var axisModelMap = {
        xAxisModel: null,
        yAxisModel: null
    };
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(axisModelMap, function(v, key) {
        var axisType = key.replace(/Model$/, '');
        var axisModel = seriesModel.getReferringComponents(axisType, (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        axisModelMap[key] = axisModel;
    });
    return axisModelMap;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $7f5c719b1dc0f126$var$mathLog = Math.log;
function $7f5c719b1dc0f126$export$c0b3be0e9eb0c2d9(scale, axisModel, alignToScale) {
    var intervalScaleProto = (0, $2388fa31203c7d49$export$2e2bcd8739ae039).prototype;
    // NOTE: There is a precondition for log scale  here:
    // In log scale we store _interval and _extent of exponent value.
    // So if we use the method of InternalScale to set/get these data.
    // It process the exponent value, which is linear and what we want here.
    var alignToTicks = intervalScaleProto.getTicks.call(alignToScale);
    var alignToNicedTicks = intervalScaleProto.getTicks.call(alignToScale, true);
    var alignToSplitNumber = alignToTicks.length - 1;
    var alignToInterval = intervalScaleProto.getInterval.call(alignToScale);
    var scaleExtent = (0, $5435624263a719a6$export$9c0ba8df7eb7b328)(scale, axisModel);
    var rawExtent = scaleExtent.extent;
    var isMinFixed = scaleExtent.fixMin;
    var isMaxFixed = scaleExtent.fixMax;
    if (scale.type === 'log') {
        var logBase = $7f5c719b1dc0f126$var$mathLog(scale.base);
        rawExtent = [
            $7f5c719b1dc0f126$var$mathLog(rawExtent[0]) / logBase,
            $7f5c719b1dc0f126$var$mathLog(rawExtent[1]) / logBase
        ];
    }
    scale.setExtent(rawExtent[0], rawExtent[1]);
    scale.calcNiceExtent({
        splitNumber: alignToSplitNumber,
        fixMin: isMinFixed,
        fixMax: isMaxFixed
    });
    var extent = intervalScaleProto.getExtent.call(scale);
    // Need to update the rawExtent.
    // Because value in rawExtent may be not parsed. e.g. 'dataMin', 'dataMax'
    if (isMinFixed) rawExtent[0] = extent[0];
    if (isMaxFixed) rawExtent[1] = extent[1];
    var interval = intervalScaleProto.getInterval.call(scale);
    var min = rawExtent[0];
    var max = rawExtent[1];
    if (isMinFixed && isMaxFixed) // User set min, max, divide to get new interval
    interval = (max - min) / alignToSplitNumber;
    else if (isMinFixed) {
        max = rawExtent[0] + interval * alignToSplitNumber;
        // User set min, expand extent on the other side
        while(max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1])){
            interval = (0, $b8495dfcf11610d1$export$f39031e8422f329d)(interval);
            max = rawExtent[0] + interval * alignToSplitNumber;
        }
    } else if (isMaxFixed) {
        // User set max, expand extent on the other side
        min = rawExtent[1] - interval * alignToSplitNumber;
        while(min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0])){
            interval = (0, $b8495dfcf11610d1$export$f39031e8422f329d)(interval);
            min = rawExtent[1] - interval * alignToSplitNumber;
        }
    } else {
        var nicedSplitNumber = scale.getTicks().length - 1;
        if (nicedSplitNumber > alignToSplitNumber) interval = (0, $b8495dfcf11610d1$export$f39031e8422f329d)(interval);
        var range = interval * alignToSplitNumber;
        max = Math.ceil(rawExtent[1] / interval) * interval;
        min = (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(max - range);
        // Not change the result that crossing zero.
        if (min < 0 && rawExtent[0] >= 0) {
            min = 0;
            max = (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(range);
        } else if (max > 0 && rawExtent[1] <= 0) {
            max = 0;
            min = -(0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(range);
        }
    }
    // Adjust min, max based on the extent of alignTo. When min or max is set in alignTo scale
    var t0 = (alignToTicks[0].value - alignToNicedTicks[0].value) / alignToInterval;
    var t1 = (alignToTicks[alignToSplitNumber].value - alignToNicedTicks[alignToSplitNumber].value) / alignToInterval;
    // NOTE: Must in setExtent -> setInterval -> setNiceExtent order.
    intervalScaleProto.setExtent.call(scale, min + interval * t0, max + interval * t1);
    intervalScaleProto.setInterval.call(scale, interval);
    if (t0 || t1) intervalScaleProto.setNiceExtent.call(scale, min + interval, max - interval);
    var ticks;
}


var $5055baafbf3324ef$var$Grid = /** @class */ function() {
    function Grid(gridModel, ecModel, api) {
        // FIXME:TS where used (different from registered type 'cartesian2d')?
        this.type = 'grid';
        this._coordsMap = {};
        this._coordsList = [];
        this._axesMap = {};
        this._axesList = [];
        this.axisPointerEnabled = true;
        this.dimensions = (0, $1f31cd4b553b0612$export$988a008d2b9120f4);
        this._initCartesian(gridModel, ecModel, api);
        this.model = gridModel;
    }
    Grid.prototype.getRect = function() {
        return this._rect;
    };
    Grid.prototype.update = function(ecModel, api) {
        var axesMap = this._axesMap;
        this._updateScale(ecModel, this.model);
        function updateAxisTicks(axes) {
            var alignTo;
            // Axis is added in order of axisIndex.
            var axesIndices = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(axes);
            var len = axesIndices.length;
            if (!len) return;
            var axisNeedsAlign = [];
            // Process once and calculate the ticks for those don't use alignTicks.
            for(var i = len - 1; i >= 0; i--){
                var idx = +axesIndices[i]; // Convert to number.
                var axis = axes[idx];
                var model = axis.model;
                var scale = axis.scale;
                if (// Only value and log axis without interval support alignTicks.
                (0, $b8495dfcf11610d1$export$dfc8cd28ed7b22a0)(scale) && model.get('alignTicks') && model.get('interval') == null) axisNeedsAlign.push(axis);
                else {
                    (0, $5435624263a719a6$export$51f3e70a54405d5a)(scale, model);
                    if ((0, $b8495dfcf11610d1$export$dfc8cd28ed7b22a0)(scale)) // Can only align to interval or log axis.
                    alignTo = axis;
                }
            }
            // All axes has set alignTicks. Pick the first one.
            // PENDING. Should we find the axis that both set interval, min, max and align to this one?
            if (axisNeedsAlign.length) {
                if (!alignTo) {
                    alignTo = axisNeedsAlign.pop();
                    (0, $5435624263a719a6$export$51f3e70a54405d5a)(alignTo.scale, alignTo.model);
                }
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axisNeedsAlign, function(axis) {
                    (0, $7f5c719b1dc0f126$export$c0b3be0e9eb0c2d9)(axis.scale, axis.model, alignTo.scale);
                });
            }
        }
        updateAxisTicks(axesMap.x);
        updateAxisTicks(axesMap.y);
        // Key: axisDim_axisIndex, value: boolean, whether onZero target.
        var onZeroRecords = {};
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesMap.x, function(xAxis) {
            $5055baafbf3324ef$var$fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
        });
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesMap.y, function(yAxis) {
            $5055baafbf3324ef$var$fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
        });
        // Resize again if containLabel is enabled
        // FIXME It may cause getting wrong grid size in data processing stage
        this.resize(this.model, api);
    };
    /**
   * Resize the grid
   */ Grid.prototype.resize = function(gridModel, api, ignoreContainLabel) {
        var boxLayoutParams = gridModel.getBoxLayoutParams();
        var isContainLabel = !ignoreContainLabel && gridModel.get('containLabel');
        var gridRect = (0, $501dc28f6c4d24ac$export$4517a5ca639a7293)(boxLayoutParams, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._rect = gridRect;
        var axesList = this._axesList;
        adjustAxes();
        // Minus label size
        if (isContainLabel) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesList, function(axis) {
                if (!axis.model.get([
                    'axisLabel',
                    'inside'
                ])) {
                    var labelUnionRect = (0, $5435624263a719a6$export$fef1c7f0af0b48d)(axis);
                    if (labelUnionRect) {
                        var dim = axis.isHorizontal() ? 'height' : 'width';
                        var margin = axis.model.get([
                            'axisLabel',
                            'margin'
                        ]);
                        gridRect[dim] -= labelUnionRect[dim] + margin;
                        if (axis.position === 'top') gridRect.y += labelUnionRect.height + margin;
                        else if (axis.position === 'left') gridRect.x += labelUnionRect.width + margin;
                    }
                }
            });
            adjustAxes();
        }
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._coordsList, function(coord) {
            // Calculate affine matrix to accelerate the data to point transform.
            // If all the axes scales are time or value.
            coord.calcAffineTransform();
        });
        function adjustAxes() {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesList, function(axis) {
                var isHorizontal = axis.isHorizontal();
                var extent = isHorizontal ? [
                    0,
                    gridRect.width
                ] : [
                    0,
                    gridRect.height
                ];
                var idx = axis.inverse ? 1 : 0;
                axis.setExtent(extent[idx], extent[1 - idx]);
                $5055baafbf3324ef$var$updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
            });
        }
    };
    Grid.prototype.getAxis = function(dim, axisIndex) {
        var axesMapOnDim = this._axesMap[dim];
        if (axesMapOnDim != null) return axesMapOnDim[axisIndex || 0];
    };
    Grid.prototype.getAxes = function() {
        return this._axesList.slice();
    };
    Grid.prototype.getCartesian = function(xAxisIndex, yAxisIndex) {
        if (xAxisIndex != null && yAxisIndex != null) {
            var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
            return this._coordsMap[key];
        }
        if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(xAxisIndex)) {
            yAxisIndex = xAxisIndex.yAxisIndex;
            xAxisIndex = xAxisIndex.xAxisIndex;
        }
        for(var i = 0, coordList = this._coordsList; i < coordList.length; i++){
            if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) return coordList[i];
        }
    };
    Grid.prototype.getCartesians = function() {
        return this._coordsList.slice();
    };
    /**
   * @implements
   */ Grid.prototype.convertToPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
    };
    /**
   * @implements
   */ Grid.prototype.convertFromPixel = function(ecModel, finder, value) {
        var target = this._findConvertTarget(finder);
        return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
    };
    Grid.prototype._findConvertTarget = function(finder) {
        var seriesModel = finder.seriesModel;
        var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        var gridModel = finder.gridModel;
        var coordsList = this._coordsList;
        var cartesian;
        var axis;
        if (seriesModel) {
            cartesian = seriesModel.coordinateSystem;
            (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(coordsList, cartesian) < 0 && (cartesian = null);
        } else if (xAxisModel && yAxisModel) cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        else if (xAxisModel) axis = this.getAxis('x', xAxisModel.componentIndex);
        else if (yAxisModel) axis = this.getAxis('y', yAxisModel.componentIndex);
        else if (gridModel) {
            var grid = gridModel.coordinateSystem;
            if (grid === this) cartesian = this._coordsList[0];
        }
        return {
            cartesian: cartesian,
            axis: axis
        };
    };
    /**
   * @implements
   */ Grid.prototype.containPoint = function(point) {
        var coord = this._coordsList[0];
        if (coord) return coord.containPoint(point);
    };
    /**
   * Initialize cartesian coordinate systems
   */ Grid.prototype._initCartesian = function(gridModel, ecModel, api) {
        var _this = this;
        var grid = this;
        var axisPositionUsed = {
            left: false,
            right: false,
            top: false,
            bottom: false
        };
        var axesMap = {
            x: {},
            y: {}
        };
        var axesCount = {
            x: 0,
            y: 0
        };
        // Create axis
        ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
        ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
        if (!axesCount.x || !axesCount.y) {
            // Roll back when there no either x or y axis
            this._axesMap = {};
            this._axesList = [];
            return;
        }
        this._axesMap = axesMap;
        // Create cartesian2d
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesMap.x, function(xAxis, xAxisIndex) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesMap.y, function(yAxis, yAxisIndex) {
                var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
                var cartesian = new (0, $1f31cd4b553b0612$export$2e2bcd8739ae039)(key);
                cartesian.master = _this;
                cartesian.model = gridModel;
                _this._coordsMap[key] = cartesian;
                _this._coordsList.push(cartesian);
                cartesian.addAxis(xAxis);
                cartesian.addAxis(yAxis);
            });
        });
        function createAxisCreator(dimName) {
            return function(axisModel, idx) {
                if (!$5055baafbf3324ef$var$isAxisUsedInTheGrid(axisModel, gridModel)) return;
                var axisPosition = axisModel.get('position');
                if (dimName === 'x') // Fix position
                {
                    if (axisPosition !== 'top' && axisPosition !== 'bottom') // Default bottom of X
                    axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
                } else // Fix position
                if (axisPosition !== 'left' && axisPosition !== 'right') // Default left of Y
                axisPosition = axisPositionUsed.left ? 'right' : 'left';
                axisPositionUsed[axisPosition] = true;
                var axis = new (0, $bfcec2d6e3dc76f6$export$2e2bcd8739ae039)(dimName, (0, $5435624263a719a6$export$8941c4cacdc8f5a5)(axisModel), [
                    0,
                    0
                ], axisModel.get('type'), axisPosition);
                var isCategory = axis.type === 'category';
                axis.onBand = isCategory && axisModel.get('boundaryGap');
                axis.inverse = axisModel.get('inverse');
                // Inject axis into axisModel
                axisModel.axis = axis;
                // Inject axisModel into axis
                axis.model = axisModel;
                // Inject grid info axis
                axis.grid = grid;
                // Index of axis, can be used as key
                axis.index = idx;
                grid._axesList.push(axis);
                axesMap[dimName][idx] = axis;
                axesCount[dimName]++;
            };
        }
    };
    /**
   * Update cartesian properties from series.
   */ Grid.prototype._updateScale = function(ecModel, gridModel) {
        // Reset scale
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._axesList, function(axis) {
            axis.scale.setExtent(Infinity, -Infinity);
            if (axis.type === 'category') {
                var categorySortInfo = axis.model.get('categorySortInfo');
                axis.scale.setSortInfo(categorySortInfo);
            }
        });
        ecModel.eachSeries(function(seriesModel) {
            if ((0, $9a3224039b65a07f$export$c2a0b77974c5e35d)(seriesModel)) {
                var axesModelMap = (0, $9a3224039b65a07f$export$8220131ac1d61d28)(seriesModel);
                var xAxisModel = axesModelMap.xAxisModel;
                var yAxisModel = axesModelMap.yAxisModel;
                if (!$5055baafbf3324ef$var$isAxisUsedInTheGrid(xAxisModel, gridModel) || !$5055baafbf3324ef$var$isAxisUsedInTheGrid(yAxisModel, gridModel)) return;
                var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
                var data = seriesModel.getData();
                var xAxis = cartesian.getAxis('x');
                var yAxis = cartesian.getAxis('y');
                unionExtent(data, xAxis);
                unionExtent(data, yAxis);
            }
        }, this);
        function unionExtent(data, axis) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $5435624263a719a6$export$e4cf30b1e74cd69d)(data, axis.dim), function(dim) {
                axis.scale.unionExtentFromData(data, dim);
            });
        }
    };
    /**
   * @param dim 'x' or 'y' or 'auto' or null/undefined
   */ Grid.prototype.getTooltipAxes = function(dim) {
        var baseAxes = [];
        var otherAxes = [];
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this.getCartesians(), function(cartesian) {
            var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
            var otherAxis = cartesian.getOtherAxis(baseAxis);
            (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
            (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
        });
        return {
            baseAxes: baseAxes,
            otherAxes: otherAxes
        };
    };
    Grid.create = function(ecModel, api) {
        var grids = [];
        ecModel.eachComponent('grid', function(gridModel, idx) {
            var grid = new Grid(gridModel, ecModel, api);
            grid.name = 'grid_' + idx;
            // dataSampling requires axis extent, so resize
            // should be performed in create stage.
            grid.resize(gridModel, api, true);
            gridModel.coordinateSystem = grid;
            grids.push(grid);
        });
        // Inject the coordinateSystems into seriesModel
        ecModel.eachSeries(function(seriesModel) {
            if (!(0, $9a3224039b65a07f$export$c2a0b77974c5e35d)(seriesModel)) return;
            var axesModelMap = (0, $9a3224039b65a07f$export$8220131ac1d61d28)(seriesModel);
            var xAxisModel = axesModelMap.xAxisModel;
            var yAxisModel = axesModelMap.yAxisModel;
            var gridModel = xAxisModel.getCoordSysModel();
            var grid = gridModel.coordinateSystem;
            seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
        });
        return grids;
    };
    // For deciding which dimensions to use when creating list data
    Grid.dimensions = (0, $1f31cd4b553b0612$export$988a008d2b9120f4);
    return Grid;
}();
/**
 * Check if the axis is used in the specified grid.
 */ function $5055baafbf3324ef$var$isAxisUsedInTheGrid(axisModel, gridModel) {
    return axisModel.getCoordSysModel() === gridModel;
}
function $5055baafbf3324ef$var$fixAxisOnZero(axesMap, otherAxisDim, axis, // Key: see `getOnZeroRecordKey`
onZeroRecords) {
    axis.getAxesOnZeroOf = function() {
        // TODO: onZero of multiple axes.
        return otherAxisOnZeroOf ? [
            otherAxisOnZeroOf
        ] : [];
    };
    // onZero can not be enabled in these two situations:
    // 1. When any other axis is a category axis.
    // 2. When no axis is cross 0 point.
    var otherAxes = axesMap[otherAxisDim];
    var otherAxisOnZeroOf;
    var axisModel = axis.model;
    var onZero = axisModel.get([
        'axisLine',
        'onZero'
    ]);
    var onZeroAxisIndex = axisModel.get([
        'axisLine',
        'onZeroAxisIndex'
    ]);
    if (!onZero) return;
    // If target axis is specified.
    if (onZeroAxisIndex != null) {
        if ($5055baafbf3324ef$var$canOnZeroToAxis(otherAxes[onZeroAxisIndex])) otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
    } else {
        // Find the first available other axis.
        for(var idx in otherAxes)if (otherAxes.hasOwnProperty(idx) && $5055baafbf3324ef$var$canOnZeroToAxis(otherAxes[idx]) && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
            otherAxisOnZeroOf = otherAxes[idx];
            break;
        }
    }
    if (otherAxisOnZeroOf) onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
    function getOnZeroRecordKey(axis) {
        return axis.dim + '_' + axis.index;
    }
}
function $5055baafbf3324ef$var$canOnZeroToAxis(axis) {
    return axis && axis.type !== 'category' && axis.type !== 'time' && (0, $5435624263a719a6$export$3eac36a69f37d52)(axis);
}
function $5055baafbf3324ef$var$updateAxisTransform(axis, coordBase) {
    var axisExtent = axis.getExtent();
    var axisExtentSum = axisExtent[0] + axisExtent[1];
    // Fast transform
    axis.toGlobalCoord = axis.dim === 'x' ? function(coord) {
        return coord + coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
    axis.toLocalCoord = axis.dim === 'x' ? function(coord) {
        return coord - coordBase;
    } : function(coord) {
        return axisExtentSum - coord + coordBase;
    };
}
var $5055baafbf3324ef$export$2e2bcd8739ae039 = $5055baafbf3324ef$var$Grid;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $7e7c5ff91aafa083$var$PI = Math.PI;
/**
 * A final axis is translated and rotated from a "standard axis".
 * So opt.position and opt.rotation is required.
 *
 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
 * for example: (0, 0) ------------> (0, 50)
 *
 * nameDirection or tickDirection or labelDirection is 1 means tick
 * or label is below the standard axis, whereas is -1 means above
 * the standard axis. labelOffset means offset between label and axis,
 * which is useful when 'onZero', where axisLabel is in the grid and
 * label in outside grid.
 *
 * Tips: like always,
 * positive rotation represents anticlockwise, and negative rotation
 * represents clockwise.
 * The direction of position coordinate is the same as the direction
 * of screen coordinate.
 *
 * Do not need to consider axis 'inverse', which is auto processed by
 * axis extent.
 */ var $7e7c5ff91aafa083$var$AxisBuilder = /** @class */ function() {
    function AxisBuilder(axisModel, opt) {
        this.group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this.opt = opt;
        this.axisModel = axisModel;
        // Default value
        (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(opt, {
            labelOffset: 0,
            nameDirection: 1,
            tickDirection: 1,
            labelDirection: 1,
            silent: true,
            handleAutoShown: function() {
                return true;
            }
        });
        // FIXME Not use a separate text group?
        var transformGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039({
            x: opt.position[0],
            y: opt.position[1],
            rotation: opt.rotation
        });
        // this.group.add(transformGroup);
        // this._transformGroup = transformGroup;
        transformGroup.updateTransform();
        this._transformGroup = transformGroup;
    }
    AxisBuilder.prototype.hasBuilder = function(name) {
        return !!$7e7c5ff91aafa083$var$builders[name];
    };
    AxisBuilder.prototype.add = function(name) {
        $7e7c5ff91aafa083$var$builders[name](this.opt, this.axisModel, this.group, this._transformGroup);
    };
    AxisBuilder.prototype.getGroup = function() {
        return this.group;
    };
    AxisBuilder.innerTextLayout = function(axisRotation, textRotation, direction) {
        var rotationDiff = (0, $9fd90cf3bf18fbcd$export$2ca6dd70a288b1c3)(textRotation - axisRotation);
        var textAlign;
        var textVerticalAlign;
        if ((0, $9fd90cf3bf18fbcd$export$d1df570aea2868f)(rotationDiff)) {
            // Label is parallel with axis line.
            textVerticalAlign = direction > 0 ? 'top' : 'bottom';
            textAlign = 'center';
        } else if ((0, $9fd90cf3bf18fbcd$export$d1df570aea2868f)(rotationDiff - $7e7c5ff91aafa083$var$PI)) {
            // Label is inverse parallel with axis line.
            textVerticalAlign = direction > 0 ? 'bottom' : 'top';
            textAlign = 'center';
        } else {
            textVerticalAlign = 'middle';
            if (rotationDiff > 0 && rotationDiff < $7e7c5ff91aafa083$var$PI) textAlign = direction > 0 ? 'right' : 'left';
            else textAlign = direction > 0 ? 'left' : 'right';
        }
        return {
            rotation: rotationDiff,
            textAlign: textAlign,
            textVerticalAlign: textVerticalAlign
        };
    };
    AxisBuilder.makeAxisEventDataBase = function(axisModel) {
        var eventData = {
            componentType: axisModel.mainType,
            componentIndex: axisModel.componentIndex
        };
        eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
        return eventData;
    };
    AxisBuilder.isLabelSilent = function(axisModel) {
        var tooltipOpt = axisModel.get('tooltip');
        return axisModel.get('silent') || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
    };
    return AxisBuilder;
}();
var $7e7c5ff91aafa083$var$builders = {
    axisLine: function(opt, axisModel, group, transformGroup) {
        var shown = axisModel.get([
            'axisLine',
            'show'
        ]);
        if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisLine');
        if (!shown) return;
        var extent = axisModel.axis.getExtent();
        var matrix = transformGroup.transform;
        var pt1 = [
            extent[0],
            0
        ];
        var pt2 = [
            extent[1],
            0
        ];
        var inverse = pt1[0] > pt2[0];
        if (matrix) {
            (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(pt1, pt1, matrix);
            (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(pt2, pt2, matrix);
        }
        var lineStyle = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
            lineCap: 'round'
        }, axisModel.getModel([
            'axisLine',
            'lineStyle'
        ]).getLineStyle());
        var line = new $8324e8379a5583a5$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: lineStyle,
            strokeContainThreshold: opt.strokeContainThreshold || 5,
            silent: true,
            z2: 1
        });
        $8eb95236e1aa01e7$export$8b4b620d7f4aad1b(line.shape, line.style.lineWidth);
        line.anid = 'line';
        group.add(line);
        var arrows = axisModel.get([
            'axisLine',
            'symbol'
        ]);
        if (arrows != null) {
            var arrowSize = axisModel.get([
                'axisLine',
                'symbolSize'
            ]);
            if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(arrows)) // Use the same arrow for start and end point
            arrows = [
                arrows,
                arrows
            ];
            if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(arrowSize) || (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(arrowSize)) // Use the same size for width and height
            arrowSize = [
                arrowSize,
                arrowSize
            ];
            var arrowOffset = (0, $da6220012439db7b$export$e3e292895c033f6d)(axisModel.get([
                'axisLine',
                'symbolOffset'
            ]) || 0, arrowSize);
            var symbolWidth_1 = arrowSize[0];
            var symbolHeight_1 = arrowSize[1];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
                {
                    rotate: opt.rotation + Math.PI / 2,
                    offset: arrowOffset[0],
                    r: 0
                },
                {
                    rotate: opt.rotation - Math.PI / 2,
                    offset: arrowOffset[1],
                    r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
                }
            ], function(point, index) {
                if (arrows[index] !== 'none' && arrows[index] != null) {
                    var symbol = (0, $da6220012439db7b$export$af050e04da3a02e8)(arrows[index], -symbolWidth_1 / 2, -symbolHeight_1 / 2, symbolWidth_1, symbolHeight_1, lineStyle.stroke, true);
                    // Calculate arrow position with offset
                    var r = point.r + point.offset;
                    var pt = inverse ? pt2 : pt1;
                    symbol.attr({
                        rotation: point.rotate,
                        x: pt[0] + r * Math.cos(opt.rotation),
                        y: pt[1] - r * Math.sin(opt.rotation),
                        silent: true,
                        z2: 11
                    });
                    group.add(symbol);
                }
            });
        }
    },
    axisTickLabel: function(opt, axisModel, group, transformGroup) {
        var ticksEls = $7e7c5ff91aafa083$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt);
        var labelEls = $7e7c5ff91aafa083$var$buildAxisLabel(group, transformGroup, axisModel, opt);
        $7e7c5ff91aafa083$var$fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
        $7e7c5ff91aafa083$var$buildAxisMinorTicks(group, transformGroup, axisModel, opt.tickDirection);
        // This bit fixes the label overlap issue for the time chart.
        // See https://github.com/apache/echarts/issues/14266 for more.
        if (axisModel.get([
            'axisLabel',
            'hideOverlap'
        ])) {
            var labelList = (0, $59fb24bbd5ce7072$export$6c403cad1ae3e239)((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(labelEls, function(label) {
                return {
                    label: label,
                    priority: label.z2,
                    defaultAttr: {
                        ignore: label.ignore
                    }
                };
            }));
            (0, $59fb24bbd5ce7072$export$8ce774e164a49410)(labelList);
        }
    },
    axisName: function(opt, axisModel, group, transformGroup) {
        var name = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(opt.axisName, axisModel.get('name'));
        if (!name) return;
        var nameLocation = axisModel.get('nameLocation');
        var nameDirection = opt.nameDirection;
        var textStyleModel = axisModel.getModel('nameTextStyle');
        var gap = axisModel.get('nameGap') || 0;
        var extent = axisModel.axis.getExtent();
        var gapSignal = extent[0] > extent[1] ? -1 : 1;
        var pos = [
            nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2,
            // Reuse labelOffset.
            $7e7c5ff91aafa083$var$isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0
        ];
        var labelLayout;
        var nameRotation = axisModel.get('nameRotate');
        if (nameRotation != null) nameRotation = nameRotation * $7e7c5ff91aafa083$var$PI / 180; // To radian.
        var axisNameAvailableWidth;
        if ($7e7c5ff91aafa083$var$isNameLocationCenter(nameLocation)) labelLayout = $7e7c5ff91aafa083$var$AxisBuilder.innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
        nameDirection);
        else {
            labelLayout = $7e7c5ff91aafa083$var$endTextLayout(opt.rotation, nameLocation, nameRotation || 0, extent);
            axisNameAvailableWidth = opt.axisNameAvailableWidth;
            if (axisNameAvailableWidth != null) {
                axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
                !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
            }
        }
        var textFont = textStyleModel.getFont();
        var truncateOpt = axisModel.get('nameTruncate', true) || {};
        var ellipsis = truncateOpt.ellipsis;
        var maxWidth = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth);
        var textEl = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            x: pos[0],
            y: pos[1],
            rotation: labelLayout.rotation,
            silent: $7e7c5ff91aafa083$var$AxisBuilder.isLabelSilent(axisModel),
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                text: name,
                font: textFont,
                overflow: 'truncate',
                width: maxWidth,
                ellipsis: ellipsis,
                fill: textStyleModel.getTextColor() || axisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ]),
                align: textStyleModel.get('align') || labelLayout.textAlign,
                verticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
            }),
            z2: 1
        });
        $8eb95236e1aa01e7$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: name
        });
        textEl.__fullText = name;
        // Id for animation
        textEl.anid = 'name';
        if (axisModel.get('triggerEvent')) {
            var eventData = $7e7c5ff91aafa083$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisName';
            eventData.name = name;
            (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        group.add(textEl);
        textEl.decomposeTransform();
    }
};
function $7e7c5ff91aafa083$var$endTextLayout(rotation, textPosition, textRotate, extent) {
    var rotationDiff = (0, $9fd90cf3bf18fbcd$export$2ca6dd70a288b1c3)(textRotate - rotation);
    var textAlign;
    var textVerticalAlign;
    var inverse = extent[0] > extent[1];
    var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
    if ((0, $9fd90cf3bf18fbcd$export$d1df570aea2868f)(rotationDiff - $7e7c5ff91aafa083$var$PI / 2)) {
        textVerticalAlign = onLeft ? 'bottom' : 'top';
        textAlign = 'center';
    } else if ((0, $9fd90cf3bf18fbcd$export$d1df570aea2868f)(rotationDiff - $7e7c5ff91aafa083$var$PI * 1.5)) {
        textVerticalAlign = onLeft ? 'top' : 'bottom';
        textAlign = 'center';
    } else {
        textVerticalAlign = 'middle';
        if (rotationDiff < $7e7c5ff91aafa083$var$PI * 1.5 && rotationDiff > $7e7c5ff91aafa083$var$PI / 2) textAlign = onLeft ? 'left' : 'right';
        else textAlign = onLeft ? 'right' : 'left';
    }
    return {
        rotation: rotationDiff,
        textAlign: textAlign,
        textVerticalAlign: textVerticalAlign
    };
}
function $7e7c5ff91aafa083$var$fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
    if ((0, $5435624263a719a6$export$c2911c025243d6a6)(axisModel.axis)) return;
    // If min or max are user set, we need to check
    // If the tick on min(max) are overlap on their neighbour tick
    // If they are overlapped, we need to hide the min(max) tick label
    var showMinLabel = axisModel.get([
        'axisLabel',
        'showMinLabel'
    ]);
    var showMaxLabel = axisModel.get([
        'axisLabel',
        'showMaxLabel'
    ]);
    // FIXME
    // Have not consider onBand yet, where tick els is more than label els.
    labelEls = labelEls || [];
    tickEls = tickEls || [];
    var firstLabel = labelEls[0];
    var nextLabel = labelEls[1];
    var lastLabel = labelEls[labelEls.length - 1];
    var prevLabel = labelEls[labelEls.length - 2];
    var firstTick = tickEls[0];
    var nextTick = tickEls[1];
    var lastTick = tickEls[tickEls.length - 1];
    var prevTick = tickEls[tickEls.length - 2];
    if (showMinLabel === false) {
        $7e7c5ff91aafa083$var$ignoreEl(firstLabel);
        $7e7c5ff91aafa083$var$ignoreEl(firstTick);
    } else if ($7e7c5ff91aafa083$var$isTwoLabelOverlapped(firstLabel, nextLabel)) {
        if (showMinLabel) {
            $7e7c5ff91aafa083$var$ignoreEl(nextLabel);
            $7e7c5ff91aafa083$var$ignoreEl(nextTick);
        } else {
            $7e7c5ff91aafa083$var$ignoreEl(firstLabel);
            $7e7c5ff91aafa083$var$ignoreEl(firstTick);
        }
    }
    if (showMaxLabel === false) {
        $7e7c5ff91aafa083$var$ignoreEl(lastLabel);
        $7e7c5ff91aafa083$var$ignoreEl(lastTick);
    } else if ($7e7c5ff91aafa083$var$isTwoLabelOverlapped(prevLabel, lastLabel)) {
        if (showMaxLabel) {
            $7e7c5ff91aafa083$var$ignoreEl(prevLabel);
            $7e7c5ff91aafa083$var$ignoreEl(prevTick);
        } else {
            $7e7c5ff91aafa083$var$ignoreEl(lastLabel);
            $7e7c5ff91aafa083$var$ignoreEl(lastTick);
        }
    }
}
function $7e7c5ff91aafa083$var$ignoreEl(el) {
    el && (el.ignore = true);
}
function $7e7c5ff91aafa083$var$isTwoLabelOverlapped(current, next) {
    // current and next has the same rotation.
    var firstRect = current && current.getBoundingRect().clone();
    var nextRect = next && next.getBoundingRect().clone();
    if (!firstRect || !nextRect) return;
    // When checking intersect of two rotated labels, we use mRotationBack
    // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
    var mRotationBack = $78537c687449356c$export$f0954fd7d5368655([]);
    $78537c687449356c$export$bb628a54ab399bc9(mRotationBack, mRotationBack, -current.rotation);
    firstRect.applyTransform($78537c687449356c$export$6e3a27864ab166fe([], mRotationBack, current.getLocalTransform()));
    nextRect.applyTransform($78537c687449356c$export$6e3a27864ab166fe([], mRotationBack, next.getLocalTransform()));
    return firstRect.intersect(nextRect);
}
function $7e7c5ff91aafa083$var$isNameLocationCenter(nameLocation) {
    return nameLocation === 'middle' || nameLocation === 'center';
}
function $7e7c5ff91aafa083$var$createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, anidPrefix) {
    var tickEls = [];
    var pt1 = [];
    var pt2 = [];
    for(var i = 0; i < ticksCoords.length; i++){
        var tickCoord = ticksCoords[i].coord;
        pt1[0] = tickCoord;
        pt1[1] = 0;
        pt2[0] = tickCoord;
        pt2[1] = tickEndCoord;
        if (tickTransform) {
            (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(pt1, pt1, tickTransform);
            (0, $3dde7d051fe20daa$export$9f9dcb98c894b623)(pt2, pt2, tickTransform);
        }
        // Tick line, Not use group transform to have better line draw
        var tickEl = new $8324e8379a5583a5$export$2e2bcd8739ae039({
            shape: {
                x1: pt1[0],
                y1: pt1[1],
                x2: pt2[0],
                y2: pt2[1]
            },
            style: tickLineStyle,
            z2: 2,
            autoBatch: true,
            silent: true
        });
        $8eb95236e1aa01e7$export$8b4b620d7f4aad1b(tickEl.shape, tickEl.style.lineWidth);
        tickEl.anid = anidPrefix + '_' + ticksCoords[i].tickValue;
        tickEls.push(tickEl);
    }
    return tickEls;
}
function $7e7c5ff91aafa083$var$buildAxisMajorTicks(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var tickModel = axisModel.getModel('axisTick');
    var shown = tickModel.get('show');
    if (shown === 'auto' && opt.handleAutoShown) shown = opt.handleAutoShown('axisTick');
    if (!shown || axis.scale.isBlank()) return;
    var lineStyleModel = tickModel.getModel('lineStyle');
    var tickEndCoord = opt.tickDirection * tickModel.get('length');
    var ticksCoords = axis.getTicksCoords();
    var ticksEls = $7e7c5ff91aafa083$var$createTicks(ticksCoords, transformGroup.transform, tickEndCoord, (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }), 'ticks');
    for(var i = 0; i < ticksEls.length; i++)group.add(ticksEls[i]);
    return ticksEls;
}
function $7e7c5ff91aafa083$var$buildAxisMinorTicks(group, transformGroup, axisModel, tickDirection) {
    var axis = axisModel.axis;
    var minorTickModel = axisModel.getModel('minorTick');
    if (!minorTickModel.get('show') || axis.scale.isBlank()) return;
    var minorTicksCoords = axis.getMinorTicksCoords();
    if (!minorTicksCoords.length) return;
    var lineStyleModel = minorTickModel.getModel('lineStyle');
    var tickEndCoord = tickDirection * minorTickModel.get('length');
    var minorTickLineStyle = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(lineStyleModel.getLineStyle(), (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(axisModel.getModel('axisTick').getLineStyle(), {
        stroke: axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ])
    }));
    for(var i = 0; i < minorTicksCoords.length; i++){
        var minorTicksEls = $7e7c5ff91aafa083$var$createTicks(minorTicksCoords[i], transformGroup.transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
        for(var k = 0; k < minorTicksEls.length; k++)group.add(minorTicksEls[k]);
    }
}
function $7e7c5ff91aafa083$var$buildAxisLabel(group, transformGroup, axisModel, opt) {
    var axis = axisModel.axis;
    var show = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(opt.axisLabelShow, axisModel.get([
        'axisLabel',
        'show'
    ]));
    if (!show || axis.scale.isBlank()) return;
    var labelModel = axisModel.getModel('axisLabel');
    var labelMargin = labelModel.get('margin');
    var labels = axis.getViewLabels();
    // Special label rotate.
    var labelRotation = ((0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(opt.labelRotate, labelModel.get('rotate')) || 0) * $7e7c5ff91aafa083$var$PI / 180;
    var labelLayout = $7e7c5ff91aafa083$var$AxisBuilder.innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
    var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
    var labelEls = [];
    var silent = $7e7c5ff91aafa083$var$AxisBuilder.isLabelSilent(axisModel);
    var triggerEvent = axisModel.get('triggerEvent');
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(labels, function(labelItem, index) {
        var tickValue = axis.scale.type === 'ordinal' ? axis.scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
        var formattedLabel = labelItem.formattedLabel;
        var rawLabel = labelItem.rawLabel;
        var itemLabelModel = labelModel;
        if (rawCategoryData && rawCategoryData[tickValue]) {
            var rawCategoryItem = rawCategoryData[tickValue];
            if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(rawCategoryItem) && rawCategoryItem.textStyle) itemLabelModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, labelModel, axisModel.ecModel);
        }
        var textColor = itemLabelModel.getTextColor() || axisModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var tickCoord = axis.dataToCoord(tickValue);
        var align = itemLabelModel.getShallow('align', true) || labelLayout.textAlign;
        var alignMin = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMinLabel', true), align);
        var alignMax = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemLabelModel.getShallow('alignMaxLabel', true), align);
        var verticalAlign = itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign;
        var verticalAlignMin = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMinLabel', true), verticalAlign);
        var verticalAlignMax = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemLabelModel.getShallow('verticalAlignMaxLabel', true), verticalAlign);
        var textEl = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            x: tickCoord,
            y: opt.labelOffset + opt.labelDirection * labelMargin,
            rotation: labelLayout.rotation,
            silent: silent,
            z2: 10 + (labelItem.level || 0),
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(itemLabelModel, {
                text: formattedLabel,
                align: index === 0 ? alignMin : index === labels.length - 1 ? alignMax : align,
                verticalAlign: index === 0 ? verticalAlignMin : index === labels.length - 1 ? verticalAlignMax : verticalAlign,
                fill: (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(textColor) ? textColor(// (1) In category axis with data zoom, tick is not the original
                // index of axis.data. So tick should not be exposed to user
                // in category axis.
                // (2) Compatible with previous version, which always use formatted label as
                // input. But in interval scale the formatted label is like '223,445', which
                // maked user replace ','. So we modify it to return original val but remain
                // it as 'string' to avoid error in replacing.
                axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
            })
        });
        textEl.anid = 'label_' + tickValue;
        $8eb95236e1aa01e7$export$fc6410d97fab306c({
            el: textEl,
            componentModel: axisModel,
            itemName: formattedLabel,
            formatterParamsExtra: {
                isTruncated: function() {
                    return textEl.isTruncated;
                },
                value: rawLabel,
                tickIndex: index
            }
        });
        // Pack data for mouse event
        if (triggerEvent) {
            var eventData = $7e7c5ff91aafa083$var$AxisBuilder.makeAxisEventDataBase(axisModel);
            eventData.targetType = 'axisLabel';
            eventData.value = rawLabel;
            eventData.tickIndex = index;
            if (axis.type === 'category') eventData.dataIndex = tickValue;
            (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
        }
        // FIXME
        transformGroup.add(textEl);
        textEl.updateTransform();
        labelEls.push(textEl);
        group.add(textEl);
        textEl.decomposeTransform();
    });
    return labelEls;
}
var $7e7c5ff91aafa083$export$2e2bcd8739ae039 = $7e7c5ff91aafa083$var$AxisBuilder;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $c55894497062b37c$export$bb44f104e3c54dae(ecModel, api) {
    var result = {
        /**
     * key: makeKey(axis.model)
     * value: {
     *      axis,
     *      coordSys,
     *      axisPointerModel,
     *      triggerTooltip,
     *      triggerEmphasis,
     *      involveSeries,
     *      snap,
     *      seriesModels,
     *      seriesDataCount
     * }
     */ axesInfo: {},
        seriesInvolved: false,
        /**
     * key: makeKey(coordSys.model)
     * value: Object: key makeKey(axis.model), value: axisInfo
     */ coordSysAxesInfo: {},
        coordSysMap: {}
    };
    $c55894497062b37c$var$collectAxesInfo(result, ecModel, api);
    // Check seriesInvolved for performance, in case too many series in some chart.
    result.seriesInvolved && $c55894497062b37c$var$collectSeriesInfo(result, ecModel);
    return result;
}
function $c55894497062b37c$var$collectAxesInfo(result, ecModel, api) {
    var globalTooltipModel = ecModel.getComponent('tooltip');
    var globalAxisPointerModel = ecModel.getComponent('axisPointer');
    // links can only be set on global.
    var linksOption = globalAxisPointerModel.get('link', true) || [];
    var linkGroups = [];
    // Collect axes info.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(api.getCoordinateSystems(), function(coordSys) {
        // Some coordinate system do not support axes, like geo.
        if (!coordSys.axisPointerEnabled) return;
        var coordSysKey = $c55894497062b37c$export$d01b444bafb1a792(coordSys.model);
        var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
        result.coordSysMap[coordSysKey] = coordSys;
        // Set tooltip (like 'cross') is a convenient way to show axisPointer
        // for user. So we enable setting tooltip on coordSys model.
        var coordSysModel = coordSys.model;
        var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(coordSys.getAxes(), (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)(saveTooltipAxisInfo, false, null));
        // If axis tooltip used, choose tooltip axis for each coordSys.
        // Notice this case: coordSys is `grid` but not `cartesian2D` here.
        if (coordSys.getTooltipAxes && globalTooltipModel && baseTooltipModel.get('show')) {
            // Compatible with previous logic. But series.tooltip.trigger: 'axis'
            // or series.data[n].tooltip.trigger: 'axis' are not support any more.
            var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
            var cross = baseTooltipModel.get([
                'axisPointer',
                'type'
            ]) === 'cross';
            var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get([
                'axisPointer',
                'axis'
            ]));
            if (triggerAxis || cross) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(tooltipAxes.baseAxes, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
            if (cross) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(tooltipAxes.otherAxes, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)(saveTooltipAxisInfo, 'cross', false));
        }
        // fromTooltip: true | false | 'cross'
        // triggerTooltip: true | false | null
        function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
            var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
            var axisPointerShow = axisPointerModel.get('show');
            if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !$c55894497062b37c$var$isHandleTrigger(axisPointerModel)) return;
            if (triggerTooltip == null) triggerTooltip = axisPointerModel.get('triggerTooltip');
            axisPointerModel = fromTooltip ? $c55894497062b37c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
            var snap = axisPointerModel.get('snap');
            var triggerEmphasis = axisPointerModel.get('triggerEmphasis');
            var axisKey = $c55894497062b37c$export$d01b444bafb1a792(axis.model);
            var involveSeries = triggerTooltip || snap || axis.type === 'category';
            // If result.axesInfo[key] exist, override it (tooltip has higher priority).
            var axisInfo = result.axesInfo[axisKey] = {
                key: axisKey,
                axis: axis,
                coordSys: coordSys,
                axisPointerModel: axisPointerModel,
                triggerTooltip: triggerTooltip,
                triggerEmphasis: triggerEmphasis,
                involveSeries: involveSeries,
                snap: snap,
                useHandle: $c55894497062b37c$var$isHandleTrigger(axisPointerModel),
                seriesModels: [],
                linkGroup: null
            };
            axesInfoInCoordSys[axisKey] = axisInfo;
            result.seriesInvolved = result.seriesInvolved || involveSeries;
            var groupIndex = $c55894497062b37c$var$getLinkGroupIndex(linksOption, axis);
            if (groupIndex != null) {
                var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
                    axesInfo: {}
                });
                linkGroup.axesInfo[axisKey] = axisInfo;
                linkGroup.mapper = linksOption[groupIndex].mapper;
                axisInfo.linkGroup = linkGroup;
            }
        }
    });
}
function $c55894497062b37c$var$makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
    var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
    var fields = [
        'type',
        'snap',
        'lineStyle',
        'shadowStyle',
        'label',
        'animation',
        'animationDurationUpdate',
        'animationEasingUpdate',
        'z'
    ];
    var volatileOption = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(fields, function(field) {
        volatileOption[field] = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(tooltipAxisPointerModel.get(field));
    });
    // category axis do not auto snap, otherwise some tick that do not
    // has value can not be hovered. value/time/log axis default snap if
    // triggered from tooltip and trigger tooltip.
    volatileOption.snap = axis.type !== 'category' && !!triggerTooltip;
    // Compatible with previous behavior, tooltip axis does not show label by default.
    // Only these properties can be overridden from tooltip to axisPointer.
    if (tooltipAxisPointerModel.get('type') === 'cross') volatileOption.type = 'line';
    var labelOption = volatileOption.label || (volatileOption.label = {});
    // Follow the convention, do not show label when triggered by tooltip by default.
    labelOption.show == null && (labelOption.show = false);
    if (fromTooltip === 'cross') {
        // When 'cross', both axes show labels.
        var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get([
            'label',
            'show'
        ]);
        labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true;
        // If triggerTooltip, this is a base axis, which should better not use cross style
        // (cross style is dashed by default)
        if (!triggerTooltip) {
            var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
            crossStyle && (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(labelOption, crossStyle.textStyle);
        }
    }
    return axis.model.getModel('axisPointer', new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(volatileOption, globalAxisPointerModel, ecModel));
}
function $c55894497062b37c$var$collectSeriesInfo(result, ecModel) {
    // Prepare data for axis trigger
    ecModel.eachSeries(function(seriesModel) {
        // Notice this case: this coordSys is `cartesian2D` but not `grid`.
        var coordSys = seriesModel.coordinateSystem;
        var seriesTooltipTrigger = seriesModel.get([
            'tooltip',
            'trigger'
        ], true);
        var seriesTooltipShow = seriesModel.get([
            'tooltip',
            'show'
        ], true);
        if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get([
            'axisPointer',
            'show'
        ], true) === false) return;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(result.coordSysAxesInfo[$c55894497062b37c$export$d01b444bafb1a792(coordSys.model)], function(axisInfo) {
            var axis = axisInfo.axis;
            if (coordSys.getAxis(axis.dim) === axis) {
                axisInfo.seriesModels.push(seriesModel);
                axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
                axisInfo.seriesDataCount += seriesModel.getData().count();
            }
        });
    });
}
/**
 * For example:
 * {
 *     axisPointer: {
 *         links: [{
 *             xAxisIndex: [2, 4],
 *             yAxisIndex: 'all'
 *         }, {
 *             xAxisId: ['a5', 'a7'],
 *             xAxisName: 'xxx'
 *         }]
 *     }
 * }
 */ function $c55894497062b37c$var$getLinkGroupIndex(linksOption, axis) {
    var axisModel = axis.model;
    var dim = axis.dim;
    for(var i = 0; i < linksOption.length; i++){
        var linkOption = linksOption[i] || {};
        if ($c55894497062b37c$var$checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || $c55894497062b37c$var$checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || $c55894497062b37c$var$checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) return i;
    }
}
function $c55894497062b37c$var$checkPropInLink(linkPropValue, axisPropValue) {
    return linkPropValue === 'all' || (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(linkPropValue) && (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
}
function $c55894497062b37c$export$f5ea32e3629d8043(axisModel) {
    var axisInfo = $c55894497062b37c$export$bd39458db76002ab(axisModel);
    if (!axisInfo) return;
    var axisPointerModel = axisInfo.axisPointerModel;
    var scale = axisInfo.axis.scale;
    var option = axisPointerModel.option;
    var status = axisPointerModel.get('status');
    var value = axisPointerModel.get('value');
    // Parse init value for category and time axis.
    if (value != null) value = scale.parse(value);
    var useHandle = $c55894497062b37c$var$isHandleTrigger(axisPointerModel);
    // If `handle` used, `axisPointer` will always be displayed, so value
    // and status should be initialized.
    if (status == null) option.status = useHandle ? 'show' : 'hide';
    var extent = scale.getExtent().slice();
    extent[0] > extent[1] && extent.reverse();
    if (// Pick a value on axis when initializing.
    value == null || value > extent[1]) // Make handle displayed on the end of the axis when init, which looks better.
    value = extent[1];
    if (value < extent[0]) value = extent[0];
    option.value = value;
    if (useHandle) option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
}
function $c55894497062b37c$export$bd39458db76002ab(axisModel) {
    var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
    return coordSysAxesInfo && coordSysAxesInfo.axesInfo[$c55894497062b37c$export$d01b444bafb1a792(axisModel)];
}
function $c55894497062b37c$export$3b06fce3f68b734(axisModel) {
    var axisInfo = $c55894497062b37c$export$bd39458db76002ab(axisModel);
    return axisInfo && axisInfo.axisPointerModel;
}
function $c55894497062b37c$var$isHandleTrigger(axisPointerModel) {
    return !!axisPointerModel.get([
        'handle',
        'show'
    ]);
}
function $c55894497062b37c$export$d01b444bafb1a792(model) {
    return model.type + '||' + model.id;
}



var $9d9acba2c65ca6e6$var$axisPointerClazz = {};
/**
 * Base class of AxisView.
 */ var $9d9acba2c65ca6e6$var$AxisView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(AxisView, _super);
    function AxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisView.type;
        return _this;
    }
    /**
   * @override
   */ AxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        // FIXME
        // This process should proformed after coordinate systems updated
        // (axis scale updated), and should be performed each time update.
        // So put it here temporarily, although it is not appropriate to
        // put a model-writing procedure in `view`.
        this.axisPointerClass && $c55894497062b37c$export$f5ea32e3629d8043(axisModel);
        _super.prototype.render.apply(this, arguments);
        this._doUpdateAxisPointerClass(axisModel, api, true);
    };
    /**
   * Action handler.
   */ AxisView.prototype.updateAxisPointer = function(axisModel, ecModel, api, payload) {
        this._doUpdateAxisPointerClass(axisModel, api, false);
    };
    /**
   * @override
   */ AxisView.prototype.remove = function(ecModel, api) {
        var axisPointer = this._axisPointer;
        axisPointer && axisPointer.remove(api);
    };
    /**
   * @override
   */ AxisView.prototype.dispose = function(ecModel, api) {
        this._disposeAxisPointer(api);
        _super.prototype.dispose.apply(this, arguments);
    };
    AxisView.prototype._doUpdateAxisPointerClass = function(axisModel, api, forceRender) {
        var Clazz = AxisView.getAxisPointerClass(this.axisPointerClass);
        if (!Clazz) return;
        var axisPointerModel = $c55894497062b37c$export$3b06fce3f68b734(axisModel);
        axisPointerModel ? (this._axisPointer || (this._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : this._disposeAxisPointer(api);
    };
    AxisView.prototype._disposeAxisPointer = function(api) {
        this._axisPointer && this._axisPointer.dispose(api);
        this._axisPointer = null;
    };
    AxisView.registerAxisPointerClass = function(type, clazz) {
        $9d9acba2c65ca6e6$var$axisPointerClazz[type] = clazz;
    };
    AxisView.getAxisPointerClass = function(type) {
        return type && $9d9acba2c65ca6e6$var$axisPointerClazz[type];
    };
    AxisView.type = 'axis';
    return AxisView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $9d9acba2c65ca6e6$export$2e2bcd8739ae039 = $9d9acba2c65ca6e6$var$AxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $fe011900558a70d8$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $fe011900558a70d8$export$c80b7ef1527ec8c9(axisView, axisGroup, axisModel, gridModel) {
    var axis = axisModel.axis;
    if (axis.scale.isBlank()) return;
    // TODO: TYPE
    var splitAreaModel = axisModel.getModel('splitArea');
    var areaStyleModel = splitAreaModel.getModel('areaStyle');
    var areaColors = areaStyleModel.get('color');
    var gridRect = gridModel.coordinateSystem.getRect();
    var ticksCoords = axis.getTicksCoords({
        tickModel: splitAreaModel,
        clamp: true
    });
    if (!ticksCoords.length) return;
    // For Making appropriate splitArea animation, the color and anid
    // should be corresponding to previous one if possible.
    var areaColorsLen = areaColors.length;
    var lastSplitAreaColors = $fe011900558a70d8$var$inner(axisView).splitAreaColors;
    var newSplitAreaColors = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
    var colorIndex = 0;
    if (lastSplitAreaColors) for(var i = 0; i < ticksCoords.length; i++){
        var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
        if (cIndex != null) {
            colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
            break;
        }
    }
    var prev = axis.toGlobalCoord(ticksCoords[0].coord);
    var areaStyle = areaStyleModel.getAreaStyle();
    areaColors = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(areaColors) ? areaColors : [
        areaColors
    ];
    for(var i = 1; i < ticksCoords.length; i++){
        var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
        var x = void 0;
        var y = void 0;
        var width = void 0;
        var height = void 0;
        if (axis.isHorizontal()) {
            x = prev;
            y = gridRect.y;
            width = tickCoord - x;
            height = gridRect.height;
            prev = x + width;
        } else {
            x = gridRect.x;
            y = prev;
            width = gridRect.width;
            height = tickCoord - y;
            prev = y + height;
        }
        var tickValue = ticksCoords[i - 1].tickValue;
        tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
        axisGroup.add(new $37476269d425e3f6$export$2e2bcd8739ae039({
            anid: tickValue != null ? 'area_' + tickValue : null,
            shape: {
                x: x,
                y: y,
                width: width,
                height: height
            },
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                fill: areaColors[colorIndex]
            }, areaStyle),
            autoBatch: true,
            silent: true
        }));
        colorIndex = (colorIndex + 1) % areaColorsLen;
    }
    $fe011900558a70d8$var$inner(axisView).splitAreaColors = newSplitAreaColors;
}
function $fe011900558a70d8$export$48ebf2d6ce8ad076(axisView) {
    $fe011900558a70d8$var$inner(axisView).splitAreaColors = null;
}



var $f76bb98ca5a4aca2$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $f76bb98ca5a4aca2$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine',
    'minorSplitLine'
];
var $f76bb98ca5a4aca2$var$CartesianAxisView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CartesianAxisView, _super);
    function CartesianAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianAxisView.type;
        _this.axisPointerClass = 'CartesianAxisPointer';
        return _this;
    }
    /**
   * @override
   */ CartesianAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var gridModel = axisModel.getCoordSysModel();
        var layout = $9a3224039b65a07f$export$b3219800bda33a1f(gridModel, axisModel);
        var axisBuilder = new (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039)(axisModel, $1b239fc9d3a2f8ae$export$8b58be045bf06082({
            handleAutoShown: function(elementType) {
                var cartesians = gridModel.coordinateSystem.getCartesians();
                for(var i = 0; i < cartesians.length; i++){
                    if ((0, $b8495dfcf11610d1$export$dfc8cd28ed7b22a0)(cartesians[i].getOtherAxis(axisModel.axis).scale)) // Still show axis tick or axisLine if other axis is value / log
                    return true;
                }
                // Not show axisTick or axisLine if other axis is category / time
                return false;
            }
        }, layout));
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($f76bb98ca5a4aca2$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($f76bb98ca5a4aca2$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $f76bb98ca5a4aca2$var$axisElementBuilders[name](this, this._axisGroup, axisModel, gridModel);
        }, this);
        // THIS is a special case for bar racing chart.
        // Update the axis label from the natural initial layout to
        // sorted layout should has no animation.
        var isInitialSortFromBarRacing = payload && payload.type === 'changeAxisOrder' && payload.isInitSort;
        if (!isInitialSortFromBarRacing) $8eb95236e1aa01e7$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    CartesianAxisView.prototype.remove = function() {
        (0, $fe011900558a70d8$export$48ebf2d6ce8ad076)(this);
    };
    CartesianAxisView.type = 'cartesianAxis';
    return CartesianAxisView;
}((0, $9d9acba2c65ca6e6$export$2e2bcd8739ae039));
var $f76bb98ca5a4aca2$var$axisElementBuilders = {
    splitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var showMinLine = splitLineModel.get('showMinLine') !== false;
        var showMaxLine = splitLineModel.get('showMaxLine') !== false;
        lineColors = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(lineColors) ? lineColors : [
            lineColors
        ];
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < ticksCoords.length; i++){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (i === 0 && !showMinLine || i === ticksCoords.length - 1 && !showMaxLine) continue;
            var tickValue = ticksCoords[i].tickValue;
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var colorIndex = lineCount++ % lineColors.length;
            var line = new $8324e8379a5583a5$export$2e2bcd8739ae039({
                anid: tickValue != null ? 'line_' + tickValue : null,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                    stroke: lineColors[colorIndex]
                }, lineStyle),
                silent: true
            });
            $8eb95236e1aa01e7$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    minorSplitLine: function(axisView, axisGroup, axisModel, gridModel) {
        var axis = axisModel.axis;
        var minorSplitLineModel = axisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var gridRect = gridModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var minorTicksCoords = axis.getMinorTicksCoords();
        if (!minorTicksCoords.length) return;
        var p1 = [];
        var p2 = [];
        var lineStyle = lineStyleModel.getLineStyle();
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++){
            var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $8324e8379a5583a5$export$2e2bcd8739ae039({
                anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
                autoBatch: true,
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                style: lineStyle,
                silent: true
            });
            $8eb95236e1aa01e7$export$8b4b620d7f4aad1b(line.shape, lineStyle.lineWidth);
            axisGroup.add(line);
        }
    },
    splitArea: function(axisView, axisGroup, axisModel, gridModel) {
        (0, $fe011900558a70d8$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, gridModel);
    }
};
var $f76bb98ca5a4aca2$export$b6d40cd875b8a1c8 = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CartesianXAxisView, _super);
    function CartesianXAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CartesianXAxisView.type;
        return _this;
    }
    CartesianXAxisView.type = 'xAxis';
    return CartesianXAxisView;
}($f76bb98ca5a4aca2$var$CartesianAxisView);
var $f76bb98ca5a4aca2$export$417e1bdd0616e0dc = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CartesianYAxisView, _super);
    function CartesianYAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = $f76bb98ca5a4aca2$export$b6d40cd875b8a1c8.type;
        return _this;
    }
    CartesianYAxisView.type = 'yAxis';
    return CartesianYAxisView;
}($f76bb98ca5a4aca2$var$CartesianAxisView);
var $f76bb98ca5a4aca2$export$2e2bcd8739ae039 = $f76bb98ca5a4aca2$var$CartesianAxisView;


// Grid view
var $cd1a81fbb12c3d5f$var$GridView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GridView, _super);
    function GridView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'grid';
        return _this;
    }
    GridView.prototype.render = function(gridModel, ecModel) {
        this.group.removeAll();
        if (gridModel.get('show')) this.group.add(new (0, $37476269d425e3f6$export$2e2bcd8739ae039)({
            shape: gridModel.coordinateSystem.getRect(),
            style: (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
                fill: gridModel.get('backgroundColor')
            }, gridModel.getItemStyle()),
            silent: true,
            z2: -1
        }));
    };
    GridView.type = 'grid';
    return GridView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $cd1a81fbb12c3d5f$var$extraOption = {
    // gridIndex: 0,
    // gridId: '',
    offset: 0
};
function $cd1a81fbb12c3d5f$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView($cd1a81fbb12c3d5f$var$GridView);
    registers.registerComponentModel((0, $68a2294e6dddbbf6$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('cartesian2d', (0, $5055baafbf3324ef$export$2e2bcd8739ae039));
    (0, $74540b73e60dbb04$export$2e2bcd8739ae039)(registers, 'x', (0, $9679afe54c0be17d$export$483dc37e6ad83a3c), $cd1a81fbb12c3d5f$var$extraOption);
    (0, $74540b73e60dbb04$export$2e2bcd8739ae039)(registers, 'y', (0, $9679afe54c0be17d$export$483dc37e6ad83a3c), $cd1a81fbb12c3d5f$var$extraOption);
    registers.registerComponentView((0, $f76bb98ca5a4aca2$export$b6d40cd875b8a1c8));
    registers.registerComponentView((0, $f76bb98ca5a4aca2$export$417e1bdd0616e0dc));
    registers.registerPreprocessor(function(option) {
        // Only create grid when need
        if (option.xAxis && option.yAxis && !option.grid) option.grid = {};
    });
}



function $e44ec2a6885fa0f6$export$4b3e715f166fdd78(registers) {
    // In case developer forget to include grid component
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $cd1a81fbb12c3d5f$export$4b3e715f166fdd78));
    registers.registerSeriesModel((0, $1f73913f6546b9c8$export$2e2bcd8739ae039));
    registers.registerChartView((0, $378f527abfa8e24c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $264cfd4c63b95c0a$export$2e2bcd8739ae039)('scatter'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $9a0eb754bdb57623$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('radar', function(seriesModel) {
        var data = seriesModel.getData();
        var points = [];
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var axes = coordSys.getIndicatorAxes();
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(axes, function(axis, axisIndex) {
            data.each(data.mapDimension(axes[axisIndex].dim), function(val, dataIndex) {
                points[dataIndex] = points[dataIndex] || [];
                var point = coordSys.dataToPoint(val, axisIndex);
                points[dataIndex][axisIndex] = $9a0eb754bdb57623$var$isValidPoint(point) ? point : $9a0eb754bdb57623$var$getValueMissingPoint(coordSys);
            });
        });
        // Close polygon
        data.each(function(idx) {
            // TODO
            // Is it appropriate to connect to the next data when some data is missing?
            // Or, should trade it like `connectNull` in line chart?
            var firstPoint = $1b239fc9d3a2f8ae$export$71aa6c912b956294(points[idx], function(point) {
                return $9a0eb754bdb57623$var$isValidPoint(point);
            }) || $9a0eb754bdb57623$var$getValueMissingPoint(coordSys);
            // Copy the first actual point to the end of the array
            points[idx].push(firstPoint.slice());
            data.setItemLayout(idx, points[idx]);
        });
    });
}
function $9a0eb754bdb57623$var$isValidPoint(point) {
    return !isNaN(point[0]) && !isNaN(point[1]);
}
function $9a0eb754bdb57623$var$getValueMissingPoint(coordSys) {
    // It is error-prone to input [NaN, NaN] into polygon, polygon.
    // (probably cause problem when refreshing or animating)
    return [
        coordSys.cx,
        coordSys.cy
    ];
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck
// Backward compat for radar chart in 2

function $26e1c72093b0b6d9$export$2e2bcd8739ae039(option) {
    var polarOptArr = option.polar;
    if (polarOptArr) {
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(polarOptArr)) polarOptArr = [
            polarOptArr
        ];
        var polarNotRadar_1 = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(polarOptArr, function(polarOpt, idx) {
            if (polarOpt.indicator) {
                if (polarOpt.type && !polarOpt.shape) polarOpt.shape = polarOpt.type;
                option.radar = option.radar || [];
                if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(option.radar)) option.radar = [
                    option.radar
                ];
                option.radar.push(polarOpt);
            } else polarNotRadar_1.push(polarOpt);
        });
        option.polar = polarNotRadar_1;
    }
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) seriesOpt.radarIndex = seriesOpt.polarIndex;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $f28322616d56e09b$var$RadarView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(seriesModel, ecModel, api) {
        var polar = seriesModel.coordinateSystem;
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        function createSymbol(data, idx) {
            var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
            if (symbolType === 'none') return;
            var symbolSize = $da6220012439db7b$export$a84524f03e8e8dfb(data.getItemVisual(idx, 'symbolSize'));
            var symbolPath = $da6220012439db7b$export$af050e04da3a02e8(symbolType, -1, -1, 2, 2);
            var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
            symbolPath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 100,
                scaleX: symbolSize[0] / 2,
                scaleY: symbolSize[1] / 2,
                rotation: symbolRotate * Math.PI / 180 || 0
            });
            return symbolPath;
        }
        function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
            // Simply rerender all
            symbolGroup.removeAll();
            for(var i = 0; i < newPoints.length - 1; i++){
                var symbolPath = createSymbol(data, idx);
                if (symbolPath) {
                    symbolPath.__dimIdx = i;
                    if (oldPoints[i]) {
                        symbolPath.setPosition(oldPoints[i]);
                        $8eb95236e1aa01e7$exports[isInit ? 'initProps' : 'updateProps'](symbolPath, {
                            x: newPoints[i][0],
                            y: newPoints[i][1]
                        }, seriesModel, idx);
                    } else symbolPath.setPosition(newPoints[i]);
                    symbolGroup.add(symbolPath);
                }
            }
        }
        function getInitialPoints(points) {
            return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(points, function(pt) {
                return [
                    polar.cx,
                    polar.cy
                ];
            });
        }
        data.diff(oldData).add(function(idx) {
            var points = data.getItemLayout(idx);
            if (!points) return;
            var polygon = new $8eb95236e1aa01e7$exports.Polygon();
            var polyline = new $8eb95236e1aa01e7$exports.Polyline();
            var target = {
                shape: {
                    points: points
                }
            };
            polygon.shape.points = getInitialPoints(points);
            polyline.shape.points = getInitialPoints(points);
            $8eb95236e1aa01e7$exports.initProps(polygon, target, seriesModel, idx);
            $8eb95236e1aa01e7$exports.initProps(polyline, target, seriesModel, idx);
            var itemGroup = new $8eb95236e1aa01e7$exports.Group();
            var symbolGroup = new $8eb95236e1aa01e7$exports.Group();
            itemGroup.add(polyline);
            itemGroup.add(polygon);
            itemGroup.add(symbolGroup);
            updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
            data.setItemGraphicEl(idx, itemGroup);
        }).update(function(newIdx, oldIdx) {
            var itemGroup = oldData.getItemGraphicEl(oldIdx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            var target = {
                shape: {
                    points: data.getItemLayout(newIdx)
                }
            };
            if (!target.shape.points) return;
            updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
            (0, $b40111164617dd60$export$bca7290a9faf0ec9)(polygon);
            (0, $b40111164617dd60$export$bca7290a9faf0ec9)(polyline);
            $8eb95236e1aa01e7$exports.updateProps(polyline, target, seriesModel);
            $8eb95236e1aa01e7$exports.updateProps(polygon, target, seriesModel);
            data.setItemGraphicEl(newIdx, itemGroup);
        }).remove(function(idx) {
            group.remove(oldData.getItemGraphicEl(idx));
        }).execute();
        data.eachItemGraphicEl(function(itemGroup, idx) {
            var itemModel = data.getItemModel(idx);
            var polyline = itemGroup.childAt(0);
            var polygon = itemGroup.childAt(1);
            var symbolGroup = itemGroup.childAt(2);
            // Radar uses the visual encoded from itemStyle.
            var itemStyle = data.getItemVisual(idx, 'style');
            var color = itemStyle.fill;
            group.add(itemGroup);
            polyline.useStyle($1b239fc9d3a2f8ae$export$ebe90cb607ad99e(itemModel.getModel('lineStyle').getLineStyle(), {
                fill: 'none',
                stroke: color
            }));
            (0, $b414df7d361a211c$export$48b68047d330bbc9)(polyline, itemModel, 'lineStyle');
            (0, $b414df7d361a211c$export$48b68047d330bbc9)(polygon, itemModel, 'areaStyle');
            var areaStyleModel = itemModel.getModel('areaStyle');
            var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
            polygon.ignore = polygonIgnore;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
                'emphasis',
                'select',
                'blur'
            ], function(stateName) {
                var stateModel = itemModel.getModel([
                    stateName,
                    'areaStyle'
                ]);
                var stateIgnore = stateModel.isEmpty() && stateModel.parentModel.isEmpty();
                // Won't be ignore if normal state is not ignore.
                polygon.ensureState(stateName).ignore = stateIgnore && polygonIgnore;
            });
            polygon.useStyle($1b239fc9d3a2f8ae$export$ebe90cb607ad99e(areaStyleModel.getAreaStyle(), {
                fill: color,
                opacity: 0.7,
                decal: itemStyle.decal
            }));
            var emphasisModel = itemModel.getModel('emphasis');
            var itemHoverStyle = emphasisModel.getModel('itemStyle').getItemStyle();
            symbolGroup.eachChild(function(symbolPath) {
                if (symbolPath instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) {
                    var pathStyle = symbolPath.style;
                    symbolPath.useStyle($1b239fc9d3a2f8ae$export$8b58be045bf06082({
                        // TODO other properties like x, y ?
                        image: pathStyle.image,
                        x: pathStyle.x,
                        y: pathStyle.y,
                        width: pathStyle.width,
                        height: pathStyle.height
                    }, itemStyle));
                } else {
                    symbolPath.useStyle(itemStyle);
                    symbolPath.setColor(color);
                    symbolPath.style.strokeNoScale = true;
                }
                var pathEmphasisState = symbolPath.ensureState('emphasis');
                pathEmphasisState.style = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(itemHoverStyle);
                var defaultText = data.getStore().get(data.getDimensionIndex(symbolPath.__dimIdx), idx);
                (defaultText == null || isNaN(defaultText)) && (defaultText = '');
                (0, $3828198b2f2de836$export$9a13992917966657)(symbolPath, (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel), {
                    labelFetcher: data.hostModel,
                    labelDataIndex: idx,
                    labelDimIndex: symbolPath.__dimIdx,
                    defaultText: defaultText,
                    inheritColor: color,
                    defaultOpacity: itemStyle.opacity
                });
            });
            (0, $b414df7d361a211c$export$e51187539ff11209)(itemGroup, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        this._data = data;
    };
    RadarView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    RadarView.type = 'radar';
    return RadarView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $f28322616d56e09b$export$2e2bcd8739ae039 = $f28322616d56e09b$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $f58e98c6f6001353$var$RadarSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadarSeriesModel, _super);
    function RadarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    // Overwrite
    RadarSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $f7d155e85e188448$export$2e2bcd8739ae039)($1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getData, this), $1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getRawData, this));
    };
    RadarSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $4433247721525340$export$2e2bcd8739ae039)(this, {
            generateCoord: 'indicator_',
            generateCoordCount: Infinity
        });
    };
    RadarSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var coordSys = this.coordinateSystem;
        var indicatorAxes = coordSys.getIndicatorAxes();
        var name = this.getData().getName(dataIndex);
        var nameToDisplay = name === '' ? this.name : name;
        var markerColor = (0, $6ceb7d0f0435c9d1$export$ea15628039c0fa93)(this, dataIndex);
        return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('section', {
            header: nameToDisplay,
            sortBlocks: true,
            blocks: $1b239fc9d3a2f8ae$export$871de8747c9eaa88(indicatorAxes, function(axis) {
                var val = data.get(data.mapDimension(axis.dim), dataIndex);
                return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                    markerType: 'subItem',
                    markerColor: markerColor,
                    name: axis.name,
                    value: val,
                    sortParam: val
                });
            })
        });
    };
    RadarSeriesModel.prototype.getTooltipPosition = function(dataIndex) {
        if (dataIndex != null) {
            var data_1 = this.getData();
            var coordSys = this.coordinateSystem;
            var values = data_1.getValues($1b239fc9d3a2f8ae$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
                return data_1.mapDimension(dim);
            }), dataIndex);
            for(var i = 0, len = values.length; i < len; i++)if (!isNaN(values[i])) {
                var indicatorAxes = coordSys.getIndicatorAxes();
                return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
            }
        }
    };
    RadarSeriesModel.type = 'series.radar';
    RadarSeriesModel.dependencies = [
        'radar'
    ];
    RadarSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        coordinateSystem: 'radar',
        legendHoverLink: true,
        radarIndex: 0,
        lineStyle: {
            width: 2,
            type: 'solid',
            join: 'round'
        },
        label: {
            position: 'top'
        },
        // areaStyle: {
        // },
        // itemStyle: {}
        symbolSize: 8
    };
    return RadarSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $f58e98c6f6001353$export$2e2bcd8739ae039 = $f58e98c6f6001353$var$RadarSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $d758e4edac9262df$var$valueAxisDefault = (0, $7e57a56fbe9f136e$export$2e2bcd8739ae039).value;
function $d758e4edac9262df$var$defaultsShow(opt, show) {
    return $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
        show: show
    }, opt);
}
var $d758e4edac9262df$var$RadarModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadarModel, _super);
    function RadarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarModel.type;
        return _this;
    }
    RadarModel.prototype.optionUpdated = function() {
        var boundaryGap = this.get('boundaryGap');
        var splitNumber = this.get('splitNumber');
        var scale = this.get('scale');
        var axisLine = this.get('axisLine');
        var axisTick = this.get('axisTick');
        // let axisType = this.get('axisType');
        var axisLabel = this.get('axisLabel');
        var nameTextStyle = this.get('axisName');
        var showName = this.get([
            'axisName',
            'show'
        ]);
        var nameFormatter = this.get([
            'axisName',
            'formatter'
        ]);
        var nameGap = this.get('axisNameGap');
        var triggerEvent = this.get('triggerEvent');
        var indicatorModels = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(this.get('indicator') || [], function(indicatorOpt) {
            // PENDING
            if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) indicatorOpt.min = 0;
            else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) indicatorOpt.max = 0;
            var iNameTextStyle = nameTextStyle;
            if (indicatorOpt.color != null) iNameTextStyle = $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                color: indicatorOpt.color
            }, nameTextStyle);
            // Use same configuration
            var innerIndicatorOpt = $1b239fc9d3a2f8ae$export$4950aa0f605343fb($1b239fc9d3a2f8ae$export$9cd59f9826255e47(indicatorOpt), {
                boundaryGap: boundaryGap,
                splitNumber: splitNumber,
                scale: scale,
                axisLine: axisLine,
                axisTick: axisTick,
                // axisType: axisType,
                axisLabel: axisLabel,
                // Compatible with 2 and use text
                name: indicatorOpt.text,
                showName: showName,
                nameLocation: 'end',
                nameGap: nameGap,
                // min: 0,
                nameTextStyle: iNameTextStyle,
                triggerEvent: triggerEvent
            }, false);
            if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(nameFormatter)) {
                var indName = innerIndicatorOpt.name;
                innerIndicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
            } else if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(nameFormatter)) innerIndicatorOpt.name = nameFormatter(innerIndicatorOpt.name, innerIndicatorOpt);
            var model = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(innerIndicatorOpt, null, this.ecModel);
            $1b239fc9d3a2f8ae$export$e36fc9d62a853069(model, (0, $12a09fd102c04f88$export$5c54b224726edb5a).prototype);
            // For triggerEvent.
            model.mainType = 'radar';
            model.componentIndex = this.componentIndex;
            return model;
        }, this);
        this._indicatorModels = indicatorModels;
    };
    RadarModel.prototype.getIndicatorModels = function() {
        return this._indicatorModels;
    };
    RadarModel.type = 'radar';
    RadarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            '50%',
            '50%'
        ],
        radius: '75%',
        startAngle: 90,
        axisName: {
            show: true
        },
        boundaryGap: [
            0,
            0
        ],
        splitNumber: 5,
        axisNameGap: 15,
        scale: false,
        // Polygon or circle
        shape: 'polygon',
        axisLine: $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
            lineStyle: {
                color: '#bbb'
            }
        }, $d758e4edac9262df$var$valueAxisDefault.axisLine),
        axisLabel: $d758e4edac9262df$var$defaultsShow($d758e4edac9262df$var$valueAxisDefault.axisLabel, false),
        axisTick: $d758e4edac9262df$var$defaultsShow($d758e4edac9262df$var$valueAxisDefault.axisTick, false),
        // axisType: 'value',
        splitLine: $d758e4edac9262df$var$defaultsShow($d758e4edac9262df$var$valueAxisDefault.splitLine, true),
        splitArea: $d758e4edac9262df$var$defaultsShow($d758e4edac9262df$var$valueAxisDefault.splitArea, true),
        // {text, min, max}
        indicator: []
    };
    return RadarModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $d758e4edac9262df$export$2e2bcd8739ae039 = $d758e4edac9262df$var$RadarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $4467c68c7feee4e6$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $4467c68c7feee4e6$var$RadarView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadarView, _super);
    function RadarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadarView.type;
        return _this;
    }
    RadarView.prototype.render = function(radarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        this._buildAxes(radarModel);
        this._buildSplitLineAndArea(radarModel);
    };
    RadarView.prototype._buildAxes = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        var axisBuilders = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis) {
            var axisName = indicatorAxis.model.get('showName') ? indicatorAxis.name : ''; // hide name
            var axisBuilder = new (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039)(indicatorAxis.model, {
                axisName: axisName,
                position: [
                    radar.cx,
                    radar.cy
                ],
                rotation: indicatorAxis.angle,
                labelDirection: -1,
                tickDirection: -1,
                nameDirection: 1
            });
            return axisBuilder;
        });
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(axisBuilders, function(axisBuilder) {
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43($4467c68c7feee4e6$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
            this.group.add(axisBuilder.getGroup());
        }, this);
    };
    RadarView.prototype._buildSplitLineAndArea = function(radarModel) {
        var radar = radarModel.coordinateSystem;
        var indicatorAxes = radar.getIndicatorAxes();
        if (!indicatorAxes.length) return;
        var shape = radarModel.get('shape');
        var splitLineModel = radarModel.getModel('splitLine');
        var splitAreaModel = radarModel.getModel('splitArea');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var showSplitLine = splitLineModel.get('show');
        var showSplitArea = splitAreaModel.get('show');
        var splitLineColors = lineStyleModel.get('color');
        var splitAreaColors = areaStyleModel.get('color');
        var splitLineColorsArr = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(splitLineColors) ? splitLineColors : [
            splitLineColors
        ];
        var splitAreaColorsArr = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(splitAreaColors) ? splitAreaColors : [
            splitAreaColors
        ];
        var splitLines = [];
        var splitAreas = [];
        function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
            var colorIndex = idx % areaOrLineColorList.length;
            areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
            return colorIndex;
        }
        if (shape === 'circle') {
            var ticksRadius = indicatorAxes[0].getTicksCoords();
            var cx = radar.cx;
            var cy = radar.cy;
            for(var i = 0; i < ticksRadius.length; i++){
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $7257c7c7414f291c$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r: ticksRadius[i].coord
                        }
                    }));
                }
                if (showSplitArea && i < ticksRadius.length - 1) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i);
                    splitAreas[colorIndex].push(new $bbdefe74c63a4c47$export$2e2bcd8739ae039({
                        shape: {
                            cx: cx,
                            cy: cy,
                            r0: ticksRadius[i].coord,
                            r: ticksRadius[i + 1].coord
                        }
                    }));
                }
            }
        } else {
            var realSplitNumber_1;
            var axesTicksPoints = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(indicatorAxes, function(indicatorAxis, idx) {
                var ticksCoords = indicatorAxis.getTicksCoords();
                realSplitNumber_1 = realSplitNumber_1 == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber_1);
                return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(ticksCoords, function(tickCoord) {
                    return radar.coordToPoint(tickCoord.coord, idx);
                });
            });
            var prevPoints = [];
            for(var i = 0; i <= realSplitNumber_1; i++){
                var points = [];
                for(var j = 0; j < indicatorAxes.length; j++)points.push(axesTicksPoints[j][i]);
                // Close
                if (points[0]) points.push(points[0].slice());
                if (showSplitLine) {
                    var colorIndex = getColorIndex(splitLines, splitLineColorsArr, i);
                    splitLines[colorIndex].push(new $f7f6523750aec7c8$export$2e2bcd8739ae039({
                        shape: {
                            points: points
                        }
                    }));
                }
                if (showSplitArea && prevPoints) {
                    var colorIndex = getColorIndex(splitAreas, splitAreaColorsArr, i - 1);
                    splitAreas[colorIndex].push(new $399011f87accd5da$export$2e2bcd8739ae039({
                        shape: {
                            points: points.concat(prevPoints)
                        }
                    }));
                }
                prevPoints = points.slice().reverse();
            }
        }
        var lineStyle = lineStyleModel.getLineStyle();
        var areaStyle = areaStyleModel.getAreaStyle();
        // Add splitArea before splitLine
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(splitAreas, function(splitAreas, idx) {
            this.group.add($8eb95236e1aa01e7$export$7b1dd269fbc4e903(splitAreas, {
                style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                    stroke: 'none',
                    fill: splitAreaColorsArr[idx % splitAreaColorsArr.length]
                }, areaStyle),
                silent: true
            }));
        }, this);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(splitLines, function(splitLines, idx) {
            this.group.add($8eb95236e1aa01e7$export$7b1dd269fbc4e903(splitLines, {
                style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                    fill: 'none',
                    stroke: splitLineColorsArr[idx % splitLineColorsArr.length]
                }, lineStyle),
                silent: true
            }));
        }, this);
    };
    RadarView.type = 'radar';
    return RadarView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $4467c68c7feee4e6$export$2e2bcd8739ae039 = $4467c68c7feee4e6$var$RadarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO clockwise
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $1472b64576b965b0$var$IndicatorAxis = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(IndicatorAxis, _super);
    function IndicatorAxis(dim, scale, radiusExtent) {
        var _this = _super.call(this, dim, scale, radiusExtent) || this;
        _this.type = 'value';
        _this.angle = 0;
        _this.name = '';
        return _this;
    }
    return IndicatorAxis;
}((0, $099c976b90502319$export$2e2bcd8739ae039));
var $1472b64576b965b0$export$2e2bcd8739ae039 = $1472b64576b965b0$var$IndicatorAxis;






var $4722d251b7e90182$var$Radar = /** @class */ function() {
    function Radar(radarModel, ecModel, api) {
        /**
     *
     * Radar dimensions
     */ this.dimensions = [];
        this._model = radarModel;
        this._indicatorAxes = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(radarModel.getIndicatorModels(), function(indicatorModel, idx) {
            var dim = 'indicator_' + idx;
            var indicatorAxis = new (0, $1472b64576b965b0$export$2e2bcd8739ae039)(dim, new (0, $2388fa31203c7d49$export$2e2bcd8739ae039)());
            indicatorAxis.name = indicatorModel.get('name');
            // Inject model and axis
            indicatorAxis.model = indicatorModel;
            indicatorModel.axis = indicatorAxis;
            this.dimensions.push(dim);
            return indicatorAxis;
        }, this);
        this.resize(radarModel, api);
    }
    Radar.prototype.getIndicatorAxes = function() {
        return this._indicatorAxes;
    };
    Radar.prototype.dataToPoint = function(value, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
    };
    // TODO: API should be coordToPoint([coord, indicatorIndex])
    Radar.prototype.coordToPoint = function(coord, indicatorIndex) {
        var indicatorAxis = this._indicatorAxes[indicatorIndex];
        var angle = indicatorAxis.angle;
        var x = this.cx + coord * Math.cos(angle);
        var y = this.cy - coord * Math.sin(angle);
        return [
            x,
            y
        ];
    };
    Radar.prototype.pointToData = function(pt) {
        var dx = pt[0] - this.cx;
        var dy = pt[1] - this.cy;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx);
        // Find the closest angle
        // FIXME index can calculated directly
        var minRadianDiff = Infinity;
        var closestAxis;
        var closestAxisIdx = -1;
        for(var i = 0; i < this._indicatorAxes.length; i++){
            var indicatorAxis = this._indicatorAxes[i];
            var diff = Math.abs(radian - indicatorAxis.angle);
            if (diff < minRadianDiff) {
                closestAxis = indicatorAxis;
                closestAxisIdx = i;
                minRadianDiff = diff;
            }
        }
        return [
            closestAxisIdx,
            +(closestAxis && closestAxis.coordToData(radius))
        ];
    };
    Radar.prototype.resize = function(radarModel, api) {
        var center = radarModel.get('center');
        var viewWidth = api.getWidth();
        var viewHeight = api.getHeight();
        var viewSize = Math.min(viewWidth, viewHeight) / 2;
        this.cx = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(center[0], viewWidth);
        this.cy = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(center[1], viewHeight);
        this.startAngle = radarModel.get('startAngle') * Math.PI / 180;
        // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
        var radius = radarModel.get('radius');
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(radius) || (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(radius)) radius = [
            0,
            radius
        ];
        this.r0 = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(radius[0], viewSize);
        this.r = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(radius[1], viewSize);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._indicatorAxes, function(indicatorAxis, idx) {
            indicatorAxis.setExtent(this.r0, this.r);
            var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length;
            // Normalize to [-PI, PI]
            angle = Math.atan2(Math.sin(angle), Math.cos(angle));
            indicatorAxis.angle = angle;
        }, this);
    };
    Radar.prototype.update = function(ecModel, api) {
        var indicatorAxes = this._indicatorAxes;
        var radarModel = this._model;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
            indicatorAxis.scale.setExtent(Infinity, -Infinity);
        });
        ecModel.eachSeriesByType('radar', function(radarSeries, idx) {
            if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) return;
            var data = radarSeries.getData();
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis) {
                indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
            });
        }, this);
        var splitNumber = radarModel.get('splitNumber');
        var dummyScale = new (0, $2388fa31203c7d49$export$2e2bcd8739ae039)();
        dummyScale.setExtent(0, splitNumber);
        dummyScale.setInterval(1);
        // Force all the axis fixing the maxSplitNumber.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(indicatorAxes, function(indicatorAxis, idx) {
            (0, $7f5c719b1dc0f126$export$c0b3be0e9eb0c2d9)(indicatorAxis.scale, indicatorAxis.model, dummyScale);
        });
    };
    Radar.prototype.convertToPixel = function(ecModel, finder, value) {
        console.warn('Not implemented.');
        return null;
    };
    Radar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        console.warn('Not implemented.');
        return null;
    };
    Radar.prototype.containPoint = function(point) {
        console.warn('Not implemented.');
        return false;
    };
    Radar.create = function(ecModel, api) {
        var radarList = [];
        ecModel.eachComponent('radar', function(radarModel) {
            var radar = new Radar(radarModel, ecModel, api);
            radarList.push(radar);
            radarModel.coordinateSystem = radar;
        });
        ecModel.eachSeriesByType('radar', function(radarSeries) {
            if (radarSeries.get('coordinateSystem') === 'radar') // Inject coordinate system
            // @ts-ignore
            radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
        });
        return radarList;
    };
    /**
   * Radar dimensions is based on the data
   */ Radar.dimensions = [];
    return Radar;
}();
var $4722d251b7e90182$export$2e2bcd8739ae039 = $4722d251b7e90182$var$Radar;


function $2513d83984f304fb$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem('radar', (0, $4722d251b7e90182$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $d758e4edac9262df$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $4467c68c7feee4e6$export$2e2bcd8739ae039));
    registers.registerVisual({
        seriesType: 'radar',
        reset: function(seriesModel) {
            var data = seriesModel.getData();
            // itemVisual symbol is for selected data
            data.each(function(idx) {
                data.setItemVisual(idx, 'legendIcon', 'roundRect');
            });
            // visual is for unselected data
            data.setVisual('legendIcon', 'roundRect');
        }
    });
}


function $36c64f43e7840177$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $2513d83984f304fb$export$4b3e715f166fdd78));
    registers.registerChartView((0, $f28322616d56e09b$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f58e98c6f6001353$export$2e2bcd8739ae039));
    registers.registerLayout((0, $9a0eb754bdb57623$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $2f4b2083cfaef73d$export$2e2bcd8739ae039)('radar'));
    registers.registerPreprocessor((0, $26e1c72093b0b6d9$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck


var $08d6a23f548c50b6$var$ATTR = '\0_ec_interaction_mutex';
function $08d6a23f548c50b6$export$b7df5d561049483a(zr, resourceKey, userKey) {
    var store = $08d6a23f548c50b6$var$getStore(zr);
    store[resourceKey] = userKey;
}
function $08d6a23f548c50b6$export$23d3fad09dc44362(zr, resourceKey, userKey) {
    var store = $08d6a23f548c50b6$var$getStore(zr);
    var uKey = store[resourceKey];
    if (uKey === userKey) store[resourceKey] = null;
}
function $08d6a23f548c50b6$export$5623cba512bc9470(zr, resourceKey) {
    return !!$08d6a23f548c50b6$var$getStore(zr)[resourceKey];
}
function $08d6a23f548c50b6$var$getStore(zr) {
    return zr[$08d6a23f548c50b6$var$ATTR] || (zr[$08d6a23f548c50b6$var$ATTR] = {});
}
/**
 * payload: {
 *     type: 'takeGlobalCursor',
 *     key: 'dataZoomSelect', or 'brush', or ...,
 *         If no userKey, release global cursor.
 * }
 */ // TODO: SELF REGISTERED.
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: 'takeGlobalCursor',
    event: 'globalCursorTaken',
    update: 'update'
}, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));



var $36ebde58055237cc$var$RoamController = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RoamController, _super);
    function RoamController(zr) {
        var _this = _super.call(this) || this;
        _this._zr = zr;
        // Avoid two roamController bind the same handler
        var mousedownHandler = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this._mousedownHandler, _this);
        var mousemoveHandler = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this._mousemoveHandler, _this);
        var mouseupHandler = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this._mouseupHandler, _this);
        var mousewheelHandler = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this._mousewheelHandler, _this);
        var pinchHandler = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this._pinchHandler, _this);
        /**
     * Notice: only enable needed types. For example, if 'zoom'
     * is not needed, 'zoom' should not be enabled, otherwise
     * default mousewheel behaviour (scroll page) will be disabled.
     */ _this.enable = function(controlType, opt) {
            // Disable previous first
            this.disable();
            this._opt = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)((0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(opt) || {}, {
                zoomOnMouseWheel: true,
                moveOnMouseMove: true,
                // By default, wheel do not trigger move.
                moveOnMouseWheel: false,
                preventDefaultMouseMove: true
            });
            if (controlType == null) controlType = true;
            if (controlType === true || controlType === 'move' || controlType === 'pan') {
                zr.on('mousedown', mousedownHandler);
                zr.on('mousemove', mousemoveHandler);
                zr.on('mouseup', mouseupHandler);
            }
            if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
                zr.on('mousewheel', mousewheelHandler);
                zr.on('pinch', pinchHandler);
            }
        };
        _this.disable = function() {
            zr.off('mousedown', mousedownHandler);
            zr.off('mousemove', mousemoveHandler);
            zr.off('mouseup', mouseupHandler);
            zr.off('mousewheel', mousewheelHandler);
            zr.off('pinch', pinchHandler);
        };
        return _this;
    }
    RoamController.prototype.isDragging = function() {
        return this._dragging;
    };
    RoamController.prototype.isPinching = function() {
        return this._pinching;
    };
    RoamController.prototype.setPointerChecker = function(pointerChecker) {
        this.pointerChecker = pointerChecker;
    };
    RoamController.prototype.dispose = function() {
        this.disable();
    };
    RoamController.prototype._mousedownHandler = function(e) {
        if ($8f7ba7c16ab1583e$export$b7ae4cded3e71bd2(e)) return;
        var el = e.target;
        while(el){
            if (el.draggable) return;
            // check if host is draggable
            el = el.__hostTarget || el.parent;
        }
        var x = e.offsetX;
        var y = e.offsetY;
        // Only check on mosedown, but not mousemove.
        // Mouse can be out of target when mouse moving.
        if (this.pointerChecker && this.pointerChecker(e, x, y)) {
            this._x = x;
            this._y = y;
            this._dragging = true;
        }
    };
    RoamController.prototype._mousemoveHandler = function(e) {
        if (!this._dragging || !$36ebde58055237cc$var$isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || $08d6a23f548c50b6$export$5623cba512bc9470(this._zr, 'globalPan')) return;
        var x = e.offsetX;
        var y = e.offsetY;
        var oldX = this._x;
        var oldY = this._y;
        var dx = x - oldX;
        var dy = y - oldY;
        this._x = x;
        this._y = y;
        this._opt.preventDefaultMouseMove && $8f7ba7c16ab1583e$export$fa6813432f753b0d(e.event);
        $36ebde58055237cc$var$trigger(this, 'pan', 'moveOnMouseMove', e, {
            dx: dx,
            dy: dy,
            oldX: oldX,
            oldY: oldY,
            newX: x,
            newY: y,
            isAvailableBehavior: null
        });
    };
    RoamController.prototype._mouseupHandler = function(e) {
        if (!$8f7ba7c16ab1583e$export$b7ae4cded3e71bd2(e)) this._dragging = false;
    };
    RoamController.prototype._mousewheelHandler = function(e) {
        var shouldZoom = $36ebde58055237cc$var$isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
        var shouldMove = $36ebde58055237cc$var$isAvailableBehavior('moveOnMouseWheel', e, this._opt);
        var wheelDelta = e.wheelDelta;
        var absWheelDeltaDelta = Math.abs(wheelDelta);
        var originX = e.offsetX;
        var originY = e.offsetY;
        // wheelDelta maybe -0 in chrome mac.
        if (wheelDelta === 0 || !shouldZoom && !shouldMove) return;
        // If both `shouldZoom` and `shouldMove` is true, trigger
        // their event both, and the final behavior is determined
        // by event listener themselves.
        if (shouldZoom) {
            // Convenience:
            // Mac and VM Windows on Mac: scroll up: zoom out.
            // Windows: scroll up: zoom in.
            // FIXME: Should do more test in different environment.
            // wheelDelta is too complicated in difference nvironment
            // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
            // although it has been normallized by zrender.
            // wheelDelta of mouse wheel is bigger than touch pad.
            var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
            var scale = wheelDelta > 0 ? factor : 1 / factor;
            $36ebde58055237cc$var$checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
                scale: scale,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
        if (shouldMove) {
            // FIXME: Should do more test in different environment.
            var absDelta = Math.abs(wheelDelta);
            // wheelDelta of mouse wheel is bigger than touch pad.
            var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
            $36ebde58055237cc$var$checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
                scrollDelta: scrollDelta,
                originX: originX,
                originY: originY,
                isAvailableBehavior: null
            });
        }
    };
    RoamController.prototype._pinchHandler = function(e) {
        if ($08d6a23f548c50b6$export$5623cba512bc9470(this._zr, 'globalPan')) return;
        var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
        $36ebde58055237cc$var$checkPointerAndTrigger(this, 'zoom', null, e, {
            scale: scale,
            originX: e.pinchX,
            originY: e.pinchY,
            isAvailableBehavior: null
        });
    };
    return RoamController;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
function $36ebde58055237cc$var$checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
        // When mouse is out of roamController rect,
        // default befavoius should not be be disabled, otherwise
        // page sliding is disabled, contrary to expectation.
        $8f7ba7c16ab1583e$export$fa6813432f753b0d(e.event);
        $36ebde58055237cc$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
    }
}
function $36ebde58055237cc$var$trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
    // Also provide behavior checker for event listener, for some case that
    // multiple components share one listener.
    contollerEvent.isAvailableBehavior = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($36ebde58055237cc$var$isAvailableBehavior, null, behaviorToCheck, e);
    // TODO should not have type issue.
    controller.trigger(eventName, contollerEvent);
}
// settings: {
//     zoomOnMouseWheel
//     moveOnMouseMove
//     moveOnMouseWheel
// }
// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
function $36ebde58055237cc$var$isAvailableBehavior(behaviorToCheck, e, settings) {
    var setting = settings[behaviorToCheck];
    return !behaviorToCheck || setting && (!(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(setting) || e.event[setting + 'Key']);
}
var $36ebde58055237cc$export$2e2bcd8739ae039 = $36ebde58055237cc$var$RoamController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * For geo and graph.
 */ function $77c59df9b4754854$export$1e6abcd98caba733(controllerHost, dx, dy) {
    var target = controllerHost.target;
    target.x += dx;
    target.y += dy;
    target.dirty();
}
function $77c59df9b4754854$export$29b3c66d30a4866(controllerHost, zoomDelta, zoomX, zoomY) {
    var target = controllerHost.target;
    var zoomLimit = controllerHost.zoomLimit;
    var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
    newZoom *= zoomDelta;
    if (zoomLimit) {
        var zoomMin = zoomLimit.min || 0;
        var zoomMax = zoomLimit.max || Infinity;
        newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
    }
    var zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom;
    // Keep the mouse center when scaling
    target.x -= (zoomX - target.x) * (zoomScale - 1);
    target.y -= (zoomY - target.y) * (zoomScale - 1);
    target.scaleX *= zoomScale;
    target.scaleY *= zoomScale;
    target.dirty();
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $644ca0c6add6ebe3$var$IRRELEVANT_EXCLUDES = {
    'axisPointer': 1,
    'tooltip': 1,
    'brush': 1
};
function $644ca0c6add6ebe3$export$8a33eacb690eac07(e, api, targetCoordSysModel) {
    var model = api.getComponentByElement(e.topTarget);
    // If model is axisModel, it works only if it is injected with coordinateSystem.
    var coordSys = model && model.coordinateSystem;
    return model && model !== targetCoordSysModel && !$644ca0c6add6ebe3$var$IRRELEVANT_EXCLUDES.hasOwnProperty(model.mainType) && coordSys && coordSys.model !== targetCoordSysModel;
}




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














function $ec85454b03d98614$export$eacefc55fad2867e(svg) {
    if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(svg)) {
        var parser = new DOMParser();
        svg = parser.parseFromString(svg, 'text/xml');
    }
    var svgNode = svg;
    if (svgNode.nodeType === 9) svgNode = svgNode.firstChild;
    while(svgNode.nodeName.toLowerCase() !== 'svg' || svgNode.nodeType !== 1)svgNode = svgNode.nextSibling;
    return svgNode;
}


var $72b39913bf057a5e$var$nodeParsers;
var $72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP = {
    'fill': 'fill',
    'stroke': 'stroke',
    'stroke-width': 'lineWidth',
    'opacity': 'opacity',
    'fill-opacity': 'fillOpacity',
    'stroke-opacity': 'strokeOpacity',
    'stroke-dasharray': 'lineDash',
    'stroke-dashoffset': 'lineDashOffset',
    'stroke-linecap': 'lineCap',
    'stroke-linejoin': 'lineJoin',
    'stroke-miterlimit': 'miterLimit',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'text-anchor': 'textAlign',
    'visibility': 'visibility',
    'display': 'display'
};
var $72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)($72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP);
var $72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP = {
    'alignment-baseline': 'textBaseline',
    'stop-color': 'stopColor'
};
var $72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)($72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP);
var $72b39913bf057a5e$var$SVGParser = function() {
    function SVGParser() {
        this._defs = {};
        this._root = null;
    }
    SVGParser.prototype.parse = function(xml, opt) {
        opt = opt || {};
        var svg = (0, $ec85454b03d98614$export$eacefc55fad2867e)(xml);
        this._defsUsePending = [];
        var root = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
        this._root = root;
        var named = [];
        var viewBox = svg.getAttribute('viewBox') || '';
        var width = parseFloat(svg.getAttribute('width') || opt.width);
        var height = parseFloat(svg.getAttribute('height') || opt.height);
        isNaN(width) && (width = null);
        isNaN(height) && (height = null);
        $72b39913bf057a5e$var$parseAttributes(svg, root, null, true, false);
        var child = svg.firstChild;
        while(child){
            this._parseNode(child, root, named, null, false, false);
            child = child.nextSibling;
        }
        $72b39913bf057a5e$var$applyDefs(this._defs, this._defsUsePending);
        this._defsUsePending = [];
        var viewBoxRect;
        var viewBoxTransform;
        if (viewBox) {
            var viewBoxArr = $72b39913bf057a5e$var$splitNumberSequence(viewBox);
            if (viewBoxArr.length >= 4) viewBoxRect = {
                x: parseFloat(viewBoxArr[0] || 0),
                y: parseFloat(viewBoxArr[1] || 0),
                width: parseFloat(viewBoxArr[2]),
                height: parseFloat(viewBoxArr[3])
            };
        }
        if (viewBoxRect && width != null && height != null) {
            viewBoxTransform = $72b39913bf057a5e$export$3e2db4420f14f50f(viewBoxRect, {
                x: 0,
                y: 0,
                width: width,
                height: height
            });
            if (!opt.ignoreViewBox) {
                var elRoot = root;
                root = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
                root.add(elRoot);
                elRoot.scaleX = elRoot.scaleY = viewBoxTransform.scale;
                elRoot.x = viewBoxTransform.x;
                elRoot.y = viewBoxTransform.y;
            }
        }
        if (!opt.ignoreRootClip && width != null && height != null) root.setClipPath(new (0, $37476269d425e3f6$export$2e2bcd8739ae039)({
            shape: {
                x: 0,
                y: 0,
                width: width,
                height: height
            }
        }));
        return {
            root: root,
            width: width,
            height: height,
            viewBoxRect: viewBoxRect,
            viewBoxTransform: viewBoxTransform,
            named: named
        };
    };
    SVGParser.prototype._parseNode = function(xmlNode, parentGroup, named, namedFrom, isInDefs, isInText) {
        var nodeName = xmlNode.nodeName.toLowerCase();
        var el;
        var namedFromForSub = namedFrom;
        if (nodeName === 'defs') isInDefs = true;
        if (nodeName === 'text') isInText = true;
        if (nodeName === 'defs' || nodeName === 'switch') el = parentGroup;
        else {
            if (!isInDefs) {
                var parser_1 = $72b39913bf057a5e$var$nodeParsers[nodeName];
                if (parser_1 && (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)($72b39913bf057a5e$var$nodeParsers, nodeName)) {
                    el = parser_1.call(this, xmlNode, parentGroup);
                    var nameAttr = xmlNode.getAttribute('name');
                    if (nameAttr) {
                        var newNamed = {
                            name: nameAttr,
                            namedFrom: null,
                            svgNodeTagLower: nodeName,
                            el: el
                        };
                        named.push(newNamed);
                        if (nodeName === 'g') namedFromForSub = newNamed;
                    } else if (namedFrom) named.push({
                        name: namedFrom.name,
                        namedFrom: namedFrom,
                        svgNodeTagLower: nodeName,
                        el: el
                    });
                    parentGroup.add(el);
                }
            }
            var parser = $72b39913bf057a5e$var$paintServerParsers[nodeName];
            if (parser && (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)($72b39913bf057a5e$var$paintServerParsers, nodeName)) {
                var def = parser.call(this, xmlNode);
                var id = xmlNode.getAttribute('id');
                if (id) this._defs[id] = def;
            }
        }
        if (el && el.isGroup) {
            var child = xmlNode.firstChild;
            while(child){
                if (child.nodeType === 1) this._parseNode(child, el, named, namedFromForSub, isInDefs, isInText);
                else if (child.nodeType === 3 && isInText) this._parseText(child, el);
                child = child.nextSibling;
            }
        }
    };
    SVGParser.prototype._parseText = function(xmlNode, parentGroup) {
        var text = new (0, $d14badf4d84ba4b7$export$2e2bcd8739ae039)({
            style: {
                text: xmlNode.textContent
            },
            silent: true,
            x: this._textX || 0,
            y: this._textY || 0
        });
        $72b39913bf057a5e$var$inheritStyle(parentGroup, text);
        $72b39913bf057a5e$var$parseAttributes(xmlNode, text, this._defsUsePending, false, false);
        $72b39913bf057a5e$var$applyTextAlignment(text, parentGroup);
        var textStyle = text.style;
        var fontSize = textStyle.fontSize;
        if (fontSize && fontSize < 9) {
            textStyle.fontSize = 9;
            text.scaleX *= fontSize / 9;
            text.scaleY *= fontSize / 9;
        }
        var font = (textStyle.fontSize || textStyle.fontFamily) && [
            textStyle.fontStyle,
            textStyle.fontWeight,
            (textStyle.fontSize || 12) + 'px',
            textStyle.fontFamily || 'sans-serif'
        ].join(' ');
        textStyle.font = font;
        var rect = text.getBoundingRect();
        this._textX += rect.width;
        parentGroup.add(text);
        return text;
    };
    SVGParser.internalField = function() {
        $72b39913bf057a5e$var$nodeParsers = {
            'g': function(xmlNode, parentGroup) {
                var g = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, g);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, g, this._defsUsePending, false, false);
                return g;
            },
            'rect': function(xmlNode, parentGroup) {
                var rect = new (0, $37476269d425e3f6$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, rect);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, rect, this._defsUsePending, false, false);
                rect.setShape({
                    x: parseFloat(xmlNode.getAttribute('x') || '0'),
                    y: parseFloat(xmlNode.getAttribute('y') || '0'),
                    width: parseFloat(xmlNode.getAttribute('width') || '0'),
                    height: parseFloat(xmlNode.getAttribute('height') || '0')
                });
                rect.silent = true;
                return rect;
            },
            'circle': function(xmlNode, parentGroup) {
                var circle = new (0, $7257c7c7414f291c$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, circle);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, circle, this._defsUsePending, false, false);
                circle.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    r: parseFloat(xmlNode.getAttribute('r') || '0')
                });
                circle.silent = true;
                return circle;
            },
            'line': function(xmlNode, parentGroup) {
                var line = new (0, $8324e8379a5583a5$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, line);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, line, this._defsUsePending, false, false);
                line.setShape({
                    x1: parseFloat(xmlNode.getAttribute('x1') || '0'),
                    y1: parseFloat(xmlNode.getAttribute('y1') || '0'),
                    x2: parseFloat(xmlNode.getAttribute('x2') || '0'),
                    y2: parseFloat(xmlNode.getAttribute('y2') || '0')
                });
                line.silent = true;
                return line;
            },
            'ellipse': function(xmlNode, parentGroup) {
                var ellipse = new (0, $eeb942ee95fdec12$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, ellipse);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, ellipse, this._defsUsePending, false, false);
                ellipse.setShape({
                    cx: parseFloat(xmlNode.getAttribute('cx') || '0'),
                    cy: parseFloat(xmlNode.getAttribute('cy') || '0'),
                    rx: parseFloat(xmlNode.getAttribute('rx') || '0'),
                    ry: parseFloat(xmlNode.getAttribute('ry') || '0')
                });
                ellipse.silent = true;
                return ellipse;
            },
            'polygon': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $72b39913bf057a5e$var$parsePoints(pointsStr);
                var polygon = new (0, $399011f87accd5da$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $72b39913bf057a5e$var$inheritStyle(parentGroup, polygon);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, polygon, this._defsUsePending, false, false);
                return polygon;
            },
            'polyline': function(xmlNode, parentGroup) {
                var pointsStr = xmlNode.getAttribute('points');
                var pointsArr;
                if (pointsStr) pointsArr = $72b39913bf057a5e$var$parsePoints(pointsStr);
                var polyline = new (0, $f7f6523750aec7c8$export$2e2bcd8739ae039)({
                    shape: {
                        points: pointsArr || []
                    },
                    silent: true
                });
                $72b39913bf057a5e$var$inheritStyle(parentGroup, polyline);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, polyline, this._defsUsePending, false, false);
                return polyline;
            },
            'image': function(xmlNode, parentGroup) {
                var img = new (0, $29f98103052059af$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, img);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, img, this._defsUsePending, false, false);
                img.setStyle({
                    image: xmlNode.getAttribute('xlink:href') || xmlNode.getAttribute('href'),
                    x: +xmlNode.getAttribute('x'),
                    y: +xmlNode.getAttribute('y'),
                    width: +xmlNode.getAttribute('width'),
                    height: +xmlNode.getAttribute('height')
                });
                img.silent = true;
                return img;
            },
            'text': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x') || '0';
                var y = xmlNode.getAttribute('y') || '0';
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                this._textX = parseFloat(x) + parseFloat(dx);
                this._textY = parseFloat(y) + parseFloat(dy);
                var g = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, g);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                return g;
            },
            'tspan': function(xmlNode, parentGroup) {
                var x = xmlNode.getAttribute('x');
                var y = xmlNode.getAttribute('y');
                if (x != null) this._textX = parseFloat(x);
                if (y != null) this._textY = parseFloat(y);
                var dx = xmlNode.getAttribute('dx') || '0';
                var dy = xmlNode.getAttribute('dy') || '0';
                var g = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
                $72b39913bf057a5e$var$inheritStyle(parentGroup, g);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, g, this._defsUsePending, false, true);
                this._textX += parseFloat(dx);
                this._textY += parseFloat(dy);
                return g;
            },
            'path': function(xmlNode, parentGroup) {
                var d = xmlNode.getAttribute('d') || '';
                var path = (0, $f444b8fb72be0619$export$ae5b259626f00aeb)(d);
                $72b39913bf057a5e$var$inheritStyle(parentGroup, path);
                $72b39913bf057a5e$var$parseAttributes(xmlNode, path, this._defsUsePending, false, false);
                path.silent = true;
                return path;
            }
        };
    }();
    return SVGParser;
}();
var $72b39913bf057a5e$var$paintServerParsers = {
    'lineargradient': function(xmlNode) {
        var x1 = parseInt(xmlNode.getAttribute('x1') || '0', 10);
        var y1 = parseInt(xmlNode.getAttribute('y1') || '0', 10);
        var x2 = parseInt(xmlNode.getAttribute('x2') || '10', 10);
        var y2 = parseInt(xmlNode.getAttribute('y2') || '0', 10);
        var gradient = new (0, $e082211bdfcbd68a$export$2e2bcd8739ae039)(x1, y1, x2, y2);
        $72b39913bf057a5e$var$parsePaintServerUnit(xmlNode, gradient);
        $72b39913bf057a5e$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    },
    'radialgradient': function(xmlNode) {
        var cx = parseInt(xmlNode.getAttribute('cx') || '0', 10);
        var cy = parseInt(xmlNode.getAttribute('cy') || '0', 10);
        var r = parseInt(xmlNode.getAttribute('r') || '0', 10);
        var gradient = new (0, $5eb859f717d077f6$export$2e2bcd8739ae039)(cx, cy, r);
        $72b39913bf057a5e$var$parsePaintServerUnit(xmlNode, gradient);
        $72b39913bf057a5e$var$parseGradientColorStops(xmlNode, gradient);
        return gradient;
    }
};
function $72b39913bf057a5e$var$parsePaintServerUnit(xmlNode, gradient) {
    var gradientUnits = xmlNode.getAttribute('gradientUnits');
    if (gradientUnits === 'userSpaceOnUse') gradient.global = true;
}
function $72b39913bf057a5e$var$parseGradientColorStops(xmlNode, gradient) {
    var stop = xmlNode.firstChild;
    while(stop){
        if (stop.nodeType === 1 && stop.nodeName.toLocaleLowerCase() === 'stop') {
            var offsetStr = stop.getAttribute('offset');
            var offset = void 0;
            if (offsetStr && offsetStr.indexOf('%') > 0) offset = parseInt(offsetStr, 10) / 100;
            else if (offsetStr) offset = parseFloat(offsetStr);
            else offset = 0;
            var styleVals = {};
            $72b39913bf057a5e$var$parseInlineStyle(stop, styleVals, styleVals);
            var stopColor = styleVals.stopColor || stop.getAttribute('stop-color') || '#000000';
            gradient.colorStops.push({
                offset: offset,
                color: stopColor
            });
        }
        stop = stop.nextSibling;
    }
}
function $72b39913bf057a5e$var$inheritStyle(parent, child) {
    if (parent && parent.__inheritedStyle) {
        if (!child.__inheritedStyle) child.__inheritedStyle = {};
        (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(child.__inheritedStyle, parent.__inheritedStyle);
    }
}
function $72b39913bf057a5e$var$parsePoints(pointsString) {
    var list = $72b39913bf057a5e$var$splitNumberSequence(pointsString);
    var points = [];
    for(var i = 0; i < list.length; i += 2){
        var x = parseFloat(list[i]);
        var y = parseFloat(list[i + 1]);
        points.push([
            x,
            y
        ]);
    }
    return points;
}
function $72b39913bf057a5e$var$parseAttributes(xmlNode, el, defsUsePending, onlyInlineStyle, isTextGroup) {
    var disp = el;
    var inheritedStyle = disp.__inheritedStyle = disp.__inheritedStyle || {};
    var selfStyle = {};
    if (xmlNode.nodeType === 1) {
        $72b39913bf057a5e$var$parseTransformAttribute(xmlNode, el);
        $72b39913bf057a5e$var$parseInlineStyle(xmlNode, inheritedStyle, selfStyle);
        if (!onlyInlineStyle) $72b39913bf057a5e$var$parseAttributeStyle(xmlNode, inheritedStyle, selfStyle);
    }
    disp.style = disp.style || {};
    if (inheritedStyle.fill != null) disp.style.fill = $72b39913bf057a5e$var$getFillStrokeStyle(disp, 'fill', inheritedStyle.fill, defsUsePending);
    if (inheritedStyle.stroke != null) disp.style.stroke = $72b39913bf057a5e$var$getFillStrokeStyle(disp, 'stroke', inheritedStyle.stroke, defsUsePending);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        'lineWidth',
        'opacity',
        'fillOpacity',
        'strokeOpacity',
        'miterLimit',
        'fontSize'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = parseFloat(inheritedStyle[propName]);
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        'lineDashOffset',
        'lineCap',
        'lineJoin',
        'fontWeight',
        'fontFamily',
        'fontStyle',
        'textAlign'
    ], function(propName) {
        if (inheritedStyle[propName] != null) disp.style[propName] = inheritedStyle[propName];
    });
    if (isTextGroup) disp.__selfStyle = selfStyle;
    if (inheritedStyle.lineDash) disp.style.lineDash = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)($72b39913bf057a5e$var$splitNumberSequence(inheritedStyle.lineDash), function(str) {
        return parseFloat(str);
    });
    if (inheritedStyle.visibility === 'hidden' || inheritedStyle.visibility === 'collapse') disp.invisible = true;
    if (inheritedStyle.display === 'none') disp.ignore = true;
}
function $72b39913bf057a5e$var$applyTextAlignment(text, parentGroup) {
    var parentSelfStyle = parentGroup.__selfStyle;
    if (parentSelfStyle) {
        var textBaseline = parentSelfStyle.textBaseline;
        var zrTextBaseline = textBaseline;
        if (!textBaseline || textBaseline === 'auto') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'baseline') zrTextBaseline = 'alphabetic';
        else if (textBaseline === 'before-edge' || textBaseline === 'text-before-edge') zrTextBaseline = 'top';
        else if (textBaseline === 'after-edge' || textBaseline === 'text-after-edge') zrTextBaseline = 'bottom';
        else if (textBaseline === 'central' || textBaseline === 'mathematical') zrTextBaseline = 'middle';
        text.style.textBaseline = zrTextBaseline;
    }
    var parentInheritedStyle = parentGroup.__inheritedStyle;
    if (parentInheritedStyle) {
        var textAlign = parentInheritedStyle.textAlign;
        var zrTextAlign = textAlign;
        if (textAlign) {
            if (textAlign === 'middle') zrTextAlign = 'center';
            text.style.textAlign = zrTextAlign;
        }
    }
}
var $72b39913bf057a5e$var$urlRegex = /^url\(\s*#(.*?)\)/;
function $72b39913bf057a5e$var$getFillStrokeStyle(el, method, str, defsUsePending) {
    var urlMatch = str && str.match($72b39913bf057a5e$var$urlRegex);
    if (urlMatch) {
        var url = (0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(urlMatch[1]);
        defsUsePending.push([
            el,
            method,
            url
        ]);
        return;
    }
    if (str === 'none') str = null;
    return str;
}
function $72b39913bf057a5e$var$applyDefs(defs, defsUsePending) {
    for(var i = 0; i < defsUsePending.length; i++){
        var item = defsUsePending[i];
        item[0].style[item[1]] = defs[item[2]];
    }
}
var $72b39913bf057a5e$var$numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g;
function $72b39913bf057a5e$var$splitNumberSequence(rawStr) {
    return rawStr.match($72b39913bf057a5e$var$numberReg) || [];
}
var $72b39913bf057a5e$var$transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.eE,]*)\)/g;
var $72b39913bf057a5e$var$DEGREE_TO_ANGLE = Math.PI / 180;
function $72b39913bf057a5e$var$parseTransformAttribute(xmlNode, node) {
    var transform = xmlNode.getAttribute('transform');
    if (transform) {
        transform = transform.replace(/,/g, ' ');
        var transformOps_1 = [];
        var mt = null;
        transform.replace($72b39913bf057a5e$var$transformRegex, function(str, type, value) {
            transformOps_1.push(type, value);
            return '';
        });
        for(var i = transformOps_1.length - 1; i > 0; i -= 2){
            var value = transformOps_1[i];
            var type = transformOps_1[i - 1];
            var valueArr = $72b39913bf057a5e$var$splitNumberSequence(value);
            mt = mt || $78537c687449356c$export$185802fd694ee1f5();
            switch(type){
                case 'translate':
                    $78537c687449356c$export$d73ee8ef04f5226a(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || '0')
                    ]);
                    break;
                case 'scale':
                    $78537c687449356c$export$dcdf75081b88279d(mt, mt, [
                        parseFloat(valueArr[0]),
                        parseFloat(valueArr[1] || valueArr[0])
                    ]);
                    break;
                case 'rotate':
                    $78537c687449356c$export$bb628a54ab399bc9(mt, mt, -parseFloat(valueArr[0]) * $72b39913bf057a5e$var$DEGREE_TO_ANGLE, [
                        parseFloat(valueArr[1] || '0'),
                        parseFloat(valueArr[2] || '0')
                    ]);
                    break;
                case 'skewX':
                    var sx = Math.tan(parseFloat(valueArr[0]) * $72b39913bf057a5e$var$DEGREE_TO_ANGLE);
                    $78537c687449356c$export$6e3a27864ab166fe(mt, [
                        1,
                        0,
                        sx,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'skewY':
                    var sy = Math.tan(parseFloat(valueArr[0]) * $72b39913bf057a5e$var$DEGREE_TO_ANGLE);
                    $78537c687449356c$export$6e3a27864ab166fe(mt, [
                        1,
                        sy,
                        0,
                        1,
                        0,
                        0
                    ], mt);
                    break;
                case 'matrix':
                    mt[0] = parseFloat(valueArr[0]);
                    mt[1] = parseFloat(valueArr[1]);
                    mt[2] = parseFloat(valueArr[2]);
                    mt[3] = parseFloat(valueArr[3]);
                    mt[4] = parseFloat(valueArr[4]);
                    mt[5] = parseFloat(valueArr[5]);
                    break;
            }
        }
        node.setLocalTransform(mt);
    }
}
var $72b39913bf057a5e$var$styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
function $72b39913bf057a5e$var$parseInlineStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    var style = xmlNode.getAttribute('style');
    if (!style) return;
    $72b39913bf057a5e$var$styleRegex.lastIndex = 0;
    var styleRegResult;
    while((styleRegResult = $72b39913bf057a5e$var$styleRegex.exec(style)) != null){
        var svgStlAttr = styleRegResult[1];
        var zrInheritableStlAttr = (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)($72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrInheritableStlAttr) inheritableStyleResult[zrInheritableStlAttr] = styleRegResult[2];
        var zrSelfStlAttr = (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)($72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP, svgStlAttr) ? $72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP[svgStlAttr] : null;
        if (zrSelfStlAttr) selfStyleResult[zrSelfStlAttr] = styleRegResult[2];
    }
}
function $72b39913bf057a5e$var$parseAttributeStyle(xmlNode, inheritableStyleResult, selfStyleResult) {
    for(var i = 0; i < $72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) inheritableStyleResult[$72b39913bf057a5e$var$INHERITABLE_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
    for(var i = 0; i < $72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS.length; i++){
        var svgAttrName = $72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP_KEYS[i];
        var attrValue = xmlNode.getAttribute(svgAttrName);
        if (attrValue != null) selfStyleResult[$72b39913bf057a5e$var$SELF_STYLE_ATTRIBUTES_MAP[svgAttrName]] = attrValue;
    }
}
function $72b39913bf057a5e$export$3e2db4420f14f50f(viewBoxRect, boundingRect) {
    var scaleX = boundingRect.width / viewBoxRect.width;
    var scaleY = boundingRect.height / viewBoxRect.height;
    var scale = Math.min(scaleX, scaleY);
    return {
        scale: scale,
        x: -(viewBoxRect.x + viewBoxRect.width / 2) * scale + (boundingRect.x + boundingRect.width / 2),
        y: -(viewBoxRect.y + viewBoxRect.height / 2) * scale + (boundingRect.y + boundingRect.height / 2)
    };
}
function $72b39913bf057a5e$export$1919f5101c220601(xml, opt) {
    var parser = new $72b39913bf057a5e$var$SVGParser();
    return parser.parse(xml, opt);
}







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $945622e457f87e31$var$EPSILON = 1e-8;
function $945622e457f87e31$var$isAroundEqual(a, b) {
    return Math.abs(a - b) < $945622e457f87e31$var$EPSILON;
}
function $945622e457f87e31$export$8893e2b90ba10d92(points, x, y) {
    var w = 0;
    var p = points[0];
    if (!p) return false;
    for(var i = 1; i < points.length; i++){
        var p2 = points[i];
        w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(p[0], p[1], p2[0], p2[1], x, y);
        p = p2;
    }
    var p0 = points[0];
    if (!$945622e457f87e31$var$isAroundEqual(p[0], p0[0]) || !$945622e457f87e31$var$isAroundEqual(p[1], p0[1])) w += (0, $97e2e82619a31023$export$2e2bcd8739ae039)(p[0], p[1], p0[0], p0[1], x, y);
    return w !== 0;
}




var $ce4eefe3f35ba9ce$var$TMP_TRANSFORM = [];
function $ce4eefe3f35ba9ce$var$transformPoints(points, transform) {
    for(var p = 0; p < points.length; p++)$3dde7d051fe20daa$export$9f9dcb98c894b623(points[p], points[p], transform);
}
function $ce4eefe3f35ba9ce$var$updateBBoxFromPoints(points, min, max, projection) {
    for(var i = 0; i < points.length; i++){
        var p = points[i];
        if (projection) // projection may return null point.
        p = projection.project(p);
        if (p && isFinite(p[0]) && isFinite(p[1])) {
            $3dde7d051fe20daa$export$96ec731ed4dcb222(min, min, p);
            $3dde7d051fe20daa$export$8960430cfd85939f(max, max, p);
        }
    }
}
function $ce4eefe3f35ba9ce$var$centroid(points) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = points.length;
    var x0 = points[len - 1][0];
    var y0 = points[len - 1][1];
    // Polygon should been closed.
    for(var i = 0; i < len; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
        x0 = x1;
        y0 = y1;
    }
    return signedArea ? [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ] : [
        points[0][0] || 0,
        points[0][1] || 0
    ];
}
var $ce4eefe3f35ba9ce$export$b1f97c3099fc6872 = /** @class */ function() {
    function Region(name) {
        this.name = name;
    }
    Region.prototype.setCenter = function(center) {
        this._center = center;
    };
    /**
   * Get center point in data unit. That is,
   * for GeoJSONRegion, the unit is lat/lng,
   * for GeoSVGRegion, the unit is SVG local coord.
   */ Region.prototype.getCenter = function() {
        var center = this._center;
        if (!center) // In most cases there are no need to calculate this center.
        // So calculate only when called.
        center = this._center = this.calcCenter();
        return center;
    };
    return Region;
}();
var $ce4eefe3f35ba9ce$export$91e20b0f72443753 = /** @class */ function() {
    function GeoJSONPolygonGeometry(exterior, interiors) {
        this.type = 'polygon';
        this.exterior = exterior;
        this.interiors = interiors;
    }
    return GeoJSONPolygonGeometry;
}();
var $ce4eefe3f35ba9ce$export$335807c9e785d92c = /** @class */ function() {
    function GeoJSONLineStringGeometry(points) {
        this.type = 'linestring';
        this.points = points;
    }
    return GeoJSONLineStringGeometry;
}();
var $ce4eefe3f35ba9ce$export$ee84fcb463f24b3d = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GeoJSONRegion, _super);
    function GeoJSONRegion(name, geometries, cp) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoJSON';
        _this.geometries = geometries;
        _this._center = cp && [
            cp[0],
            cp[1]
        ];
        return _this;
    }
    GeoJSONRegion.prototype.calcCenter = function() {
        var geometries = this.geometries;
        var largestGeo;
        var largestGeoSize = 0;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            var exterior = geo.exterior;
            // Simple trick to use points count instead of polygon area as region size.
            // Ignore linestring
            var size = exterior && exterior.length;
            if (size > largestGeoSize) {
                largestGeo = geo;
                largestGeoSize = size;
            }
        }
        if (largestGeo) return $ce4eefe3f35ba9ce$var$centroid(largestGeo.exterior);
        // from bounding rect by default.
        var rect = this.getBoundingRect();
        return [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.getBoundingRect = function(projection) {
        var rect = this._rect;
        // Always recalculate if using projection.
        if (rect && !projection) return rect;
        var min = [
            Infinity,
            Infinity
        ];
        var max = [
            -Infinity,
            -Infinity
        ];
        var geometries = this.geometries;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(geometries, function(geo) {
            if (geo.type === 'polygon') // Doesn't consider hole
            $ce4eefe3f35ba9ce$var$updateBBoxFromPoints(geo.exterior, min, max, projection);
            else (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(geo.points, function(points) {
                $ce4eefe3f35ba9ce$var$updateBBoxFromPoints(points, min, max, projection);
            });
        });
        // Normalie invalid bounding.
        if (!(isFinite(min[0]) && isFinite(min[1]) && isFinite(max[0]) && isFinite(max[1]))) min[0] = min[1] = max[0] = max[1] = 0;
        rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        if (!projection) this._rect = rect;
        return rect;
    };
    GeoJSONRegion.prototype.contain = function(coord) {
        var rect = this.getBoundingRect();
        var geometries = this.geometries;
        if (!rect.contain(coord[0], coord[1])) return false;
        loopGeo: for(var i = 0, len = geometries.length; i < len; i++){
            var geo = geometries[i];
            // Only support polygon.
            if (geo.type !== 'polygon') continue;
            var exterior = geo.exterior;
            var interiors = geo.interiors;
            if ($945622e457f87e31$export$8893e2b90ba10d92(exterior, coord[0], coord[1])) {
                // Not in the region if point is in the hole.
                for(var k = 0; k < (interiors ? interiors.length : 0); k++){
                    if ($945622e457f87e31$export$8893e2b90ba10d92(interiors[k], coord[0], coord[1])) continue loopGeo;
                }
                return true;
            }
        }
        return false;
    };
    /**
   * Transform the raw coords to target bounding.
   * @param x
   * @param y
   * @param width
   * @param height
   */ GeoJSONRegion.prototype.transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var aspect = rect.width / rect.height;
        if (!width) width = aspect * height;
        else if (!height) height = width / aspect;
        var target = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, width, height);
        var transform = rect.calculateTransform(target);
        var geometries = this.geometries;
        for(var i = 0; i < geometries.length; i++){
            var geo = geometries[i];
            if (geo.type === 'polygon') {
                $ce4eefe3f35ba9ce$var$transformPoints(geo.exterior, transform);
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(geo.interiors, function(interior) {
                    $ce4eefe3f35ba9ce$var$transformPoints(interior, transform);
                });
            } else (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(geo.points, function(points) {
                $ce4eefe3f35ba9ce$var$transformPoints(points, transform);
            });
        }
        rect = this._rect;
        rect.copy(target);
        // Update center
        this._center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    };
    GeoJSONRegion.prototype.cloneShallow = function(name) {
        name == null && (name = this.name);
        var newRegion = new GeoJSONRegion(name, this.geometries, this._center);
        newRegion._rect = this._rect;
        newRegion.transformTo = null; // Simply avoid to be called.
        return newRegion;
    };
    return GeoJSONRegion;
}($ce4eefe3f35ba9ce$export$b1f97c3099fc6872);
var $ce4eefe3f35ba9ce$export$5f3d89e7254f3e69 = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GeoSVGRegion, _super);
    function GeoSVGRegion(name, elOnlyForCalculate) {
        var _this = _super.call(this, name) || this;
        _this.type = 'geoSVG';
        _this._elOnlyForCalculate = elOnlyForCalculate;
        return _this;
    }
    GeoSVGRegion.prototype.calcCenter = function() {
        var el = this._elOnlyForCalculate;
        var rect = el.getBoundingRect();
        var center = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
        var mat = $78537c687449356c$export$f0954fd7d5368655($ce4eefe3f35ba9ce$var$TMP_TRANSFORM);
        var target = el;
        while(target && !target.isGeoSVGGraphicRoot){
            $78537c687449356c$export$6e3a27864ab166fe(mat, target.getLocalTransform(), mat);
            target = target.parent;
        }
        $78537c687449356c$export$6897c284b6f9f4dc(mat, mat);
        $3dde7d051fe20daa$export$9f9dcb98c894b623(center, center, mat);
        return center;
    };
    return GeoSVGRegion;
}($ce4eefe3f35ba9ce$export$b1f97c3099fc6872);


/**
 * "region available" means that: enable users to set attribute `name="xxx"` on those tags
 * to make it be a region.
 * 1. region styles and its label styles can be defined in echarts opton:
 * ```js
 * geo: {
 *     regions: [{
 *         name: 'xxx',
 *         itemStyle: { ... },
 *         label: { ... }
 *     }, {
 *         ...
 *     },
 *     ...]
 * };
 * ```
 * 2. name can be duplicated in different SVG tag. All of the tags with the same name share
 * a region option. For exampel if there are two <path> representing two lung lobes. They have
 * no common parents but both of them need to display label "lung" inside.
 */ var $e1272ef55316374e$var$REGION_AVAILABLE_SVG_TAG_MAP = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)([
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path',
    // <text> <tspan> are also enabled because some SVG might paint text itself,
    // but still need to trigger events or tooltip.
    'text',
    'tspan',
    // <g> is also enabled because this case: if multiple tags share one name
    // and need label displayed, every tags will display the name, which is not
    // expected. So we can put them into a <g name="xxx">. Thereby only one label
    // displayed and located based on the bounding rect of the <g>.
    'g'
]);
var $e1272ef55316374e$export$be52c950efae1f84 = /** @class */ function() {
    function GeoSVGResource(mapName, svg) {
        this.type = 'geoSVG';
        // All used graphics. key: hostKey, value: root
        this._usedGraphicMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        // All unused graphics.
        this._freedGraphics = [];
        this._mapName = mapName;
        // Only perform parse to XML object here, which might be time
        // consiming for large SVG.
        // Although convert XML to zrender element is also time consiming,
        // if we do it here, the clone of zrender elements has to be
        // required. So we do it once for each geo instance, util real
        // performance issues call for optimizing it.
        this._parsedXML = (0, $ec85454b03d98614$export$eacefc55fad2867e)(svg);
    }
    GeoSVGResource.prototype.load = function() {
        // In the "load" stage, graphic need to be built to
        // get boundingRect for geo coordinate system.
        var firstGraphic = this._firstGraphic;
        // Create the return data structure only when first graphic created.
        // Because they will be used in geo coordinate system update stage,
        // and `regions` will be mounted at `geo` coordinate system,
        // in which there is no "view" info, so that it should better not to
        // make references to graphic elements.
        if (!firstGraphic) {
            firstGraphic = this._firstGraphic = this._buildGraphic(this._parsedXML);
            this._freedGraphics.push(firstGraphic);
            this._boundingRect = this._firstGraphic.boundingRect.clone();
            // PENDING: `nameMap` will not be supported until some real requirement come.
            // if (nameMap) {
            //     named = applyNameMap(named, nameMap);
            // }
            var _a = $e1272ef55316374e$var$createRegions(firstGraphic.named), regions = _a.regions, regionsMap = _a.regionsMap;
            this._regions = regions;
            this._regionsMap = regionsMap;
        }
        return {
            boundingRect: this._boundingRect,
            regions: this._regions,
            regionsMap: this._regionsMap
        };
    };
    GeoSVGResource.prototype._buildGraphic = function(svgXML) {
        var result;
        var rootFromParse;
        try {
            result = svgXML && (0, $72b39913bf057a5e$export$1919f5101c220601)(svgXML, {
                ignoreViewBox: true,
                ignoreRootClip: true
            }) || {};
            rootFromParse = result.root;
            (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(rootFromParse != null);
        } catch (e) {
            throw new Error('Invalid svg format\n' + e.message);
        }
        // Note: we keep the covenant that the root has no transform. So always add an extra root.
        var root = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
        root.add(rootFromParse);
        root.isGeoSVGGraphicRoot = true;
        // [THE_RULE_OF_VIEWPORT_AND_VIEWBOX]
        //
        // Consider: `<svg width="..." height="..." viewBox="...">`
        // - the `width/height` we call it `svgWidth/svgHeight` for short.
        // - `(0, 0, svgWidth, svgHeight)` defines the viewport of the SVG, or say,
        //   "viewport boundingRect", or `boundingRect` for short.
        // - `viewBox` defines the transform from the real content ot the viewport.
        //   `viewBox` has the same unit as the content of SVG.
        //   If `viewBox` exists, a transform is defined, so the unit of `svgWidth/svgHeight` become
        //   different from the content of SVG. Otherwise, they are the same.
        //
        // If both `svgWidth/svgHeight/viewBox` are specified in a SVG file, the transform rule will be:
        // 0. `boundingRect` is `(0, 0, svgWidth, svgHeight)`. Set it to Geo['_rect'] (View['_rect']).
        // 1. Make a transform from `viewBox` to `boundingRect`.
        //    Note: only support `preserveAspectRatio 'xMidYMid'` here. That is, this transform will preserve
        //    the aspect ratio.
        // 2. Make a transform from boundingRect to Geo['_viewRect'] (View['_viewRect'])
        //    (`Geo`/`View` will do this job).
        //    Note: this transform might not preserve aspect radio, which depending on how users specify
        //    viewRect in echarts option (e.g., `geo.left/top/width/height` will not preserve aspect ratio,
        //    but `geo.layoutCenter/layoutSize` will preserve aspect ratio).
        //
        // If `svgWidth/svgHeight` not specified, we use `viewBox` as the `boundingRect` to make the SVG
        // layout look good.
        //
        // If neither `svgWidth/svgHeight` nor `viewBox` are not specified, we calculate the boundingRect
        // of the SVG content and use them to make SVG layout look good.
        var svgWidth = result.width;
        var svgHeight = result.height;
        var viewBoxRect = result.viewBoxRect;
        var boundingRect = this._boundingRect;
        if (!boundingRect) {
            var bRectX = void 0;
            var bRectY = void 0;
            var bRectWidth = void 0;
            var bRectHeight = void 0;
            if (svgWidth != null) {
                bRectX = 0;
                bRectWidth = svgWidth;
            } else if (viewBoxRect) {
                bRectX = viewBoxRect.x;
                bRectWidth = viewBoxRect.width;
            }
            if (svgHeight != null) {
                bRectY = 0;
                bRectHeight = svgHeight;
            } else if (viewBoxRect) {
                bRectY = viewBoxRect.y;
                bRectHeight = viewBoxRect.height;
            }
            // If both viewBox and svgWidth/svgHeight not specified,
            // we have to determine how to layout those element to make them look good.
            if (bRectX == null || bRectY == null) {
                var calculatedBoundingRect = rootFromParse.getBoundingRect();
                if (bRectX == null) {
                    bRectX = calculatedBoundingRect.x;
                    bRectWidth = calculatedBoundingRect.width;
                }
                if (bRectY == null) {
                    bRectY = calculatedBoundingRect.y;
                    bRectHeight = calculatedBoundingRect.height;
                }
            }
            boundingRect = this._boundingRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(bRectX, bRectY, bRectWidth, bRectHeight);
        }
        if (viewBoxRect) {
            var viewBoxTransform = (0, $72b39913bf057a5e$export$3e2db4420f14f50f)(viewBoxRect, boundingRect);
            // Only support `preserveAspectRatio 'xMidYMid'`
            rootFromParse.scaleX = rootFromParse.scaleY = viewBoxTransform.scale;
            rootFromParse.x = viewBoxTransform.x;
            rootFromParse.y = viewBoxTransform.y;
        }
        // SVG needs to clip based on `viewBox`. And some SVG files really rely on this feature.
        // They do not strictly confine all of the content inside a display rect, but deliberately
        // use a `viewBox` to define a displayable rect.
        // PENDING:
        // The drawback of the `setClipPath` here is: the region label (genereted by echarts) near the
        // edge might also be clipped, because region labels are put as `textContent` of the SVG path.
        root.setClipPath(new (0, $37476269d425e3f6$export$2e2bcd8739ae039)({
            shape: boundingRect.plain()
        }));
        var named = [];
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(result.named, function(namedItem) {
            if ($e1272ef55316374e$var$REGION_AVAILABLE_SVG_TAG_MAP.get(namedItem.svgNodeTagLower) != null) {
                named.push(namedItem);
                $e1272ef55316374e$var$setSilent(namedItem.el);
            }
        });
        return {
            root: root,
            boundingRect: boundingRect,
            named: named
        };
    };
    /**
   * Consider:
   * (1) One graphic element can not be shared by different `geoView` running simultaneously.
   *     Notice, also need to consider multiple echarts instances share a `mapRecord`.
   * (2) Converting SVG to graphic elements is time consuming.
   * (3) In the current architecture, `load` should be called frequently to get boundingRect,
   *     and it is called without view info.
   * So we maintain graphic elements in this module, and enables `view` to use/return these
   * graphics from/to the pool with it's uid.
   */ GeoSVGResource.prototype.useGraphic = function(hostKey /* , nameMap: NameMap */ ) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) return svgGraphic;
        svgGraphic = this._freedGraphics.pop() || this._buildGraphic(this._parsedXML);
        usedRootMap.set(hostKey, svgGraphic);
        // PENDING: `nameMap` will not be supported until some real requirement come.
        // `nameMap` can only be obtained from echarts option.
        // The original `named` must not be modified.
        // if (nameMap) {
        //     svgGraphic = extend({}, svgGraphic);
        //     svgGraphic.named = applyNameMap(svgGraphic.named, nameMap);
        // }
        return svgGraphic;
    };
    GeoSVGResource.prototype.freeGraphic = function(hostKey) {
        var usedRootMap = this._usedGraphicMap;
        var svgGraphic = usedRootMap.get(hostKey);
        if (svgGraphic) {
            usedRootMap.removeKey(hostKey);
            this._freedGraphics.push(svgGraphic);
        }
    };
    return GeoSVGResource;
}();
function $e1272ef55316374e$var$setSilent(el) {
    // Only named element has silent: false, other elements should
    // act as background and has no user interaction.
    el.silent = false;
    // text|tspan will be converted to group.
    if (el.isGroup) el.traverse(function(child) {
        child.silent = false;
    });
}
function $e1272ef55316374e$var$createRegions(named) {
    var regions = [];
    var regionsMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    // Create resions only for the first graphic.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(named, function(namedItem) {
        // Region has feature to calculate center for tooltip or other features.
        // If there is a <g name="xxx">, the center should be the center of the
        // bounding rect of the g.
        if (namedItem.namedFrom != null) return;
        var region = new (0, $ce4eefe3f35ba9ce$export$5f3d89e7254f3e69)(namedItem.name, namedItem.el);
        // PENDING: if `nameMap` supported, this region can not be mounted on
        // `this`, but can only be created each time `load()` called.
        regions.push(region);
        // PENDING: if multiple tag named with the same name, only one will be
        // found by `_regionsMap`. `_regionsMap` is used to find a coordinate
        // by name. We use `region.getCenter()` as the coordinate.
        regionsMap.set(namedItem.name, region);
    });
    return {
        regions: regions,
        regionsMap: regionsMap
    };
} // PENDING: `nameMap` will not be supported until some real requirement come.
 // /**
 //  * Use the alias in geoNameMap.
 //  * The input `named` must not be modified.
 //  */
 // function applyNameMap(
 //     named: GeoSVGGraphicRecord['named'],
 //     nameMap: NameMap
 // ): GeoSVGGraphicRecord['named'] {
 //     const result = [] as GeoSVGGraphicRecord['named'];
 //     for (let i = 0; i < named.length; i++) {
 //         let regionGraphic = named[i];
 //         const name = regionGraphic.name;
 //         if (nameMap && nameMap.hasOwnProperty(name)) {
 //             regionGraphic = extend({}, regionGraphic);
 //             regionGraphic.name = name;
 //         }
 //         result.push(regionGraphic);
 //     }
 //     return result;
 // }


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parse and decode geo json
 */ 

function $3f3b936dda85d569$var$decode(json) {
    if (!json.UTF8Encoding) return json;
    var jsonCompressed = json;
    var encodeScale = jsonCompressed.UTF8Scale;
    if (encodeScale == null) encodeScale = 1024;
    var features = jsonCompressed.features;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(features, function(feature) {
        var geometry = feature.geometry;
        var encodeOffsets = geometry.encodeOffsets;
        var coordinates = geometry.coordinates;
        // Geometry may be appeded manually in the script after json loaded.
        // In this case this geometry is usually not encoded.
        if (!encodeOffsets) return;
        switch(geometry.type){
            case 'LineString':
                geometry.coordinates = $3f3b936dda85d569$var$decodeRing(coordinates, encodeOffsets, encodeScale);
                break;
            case 'Polygon':
                $3f3b936dda85d569$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case 'MultiLineString':
                $3f3b936dda85d569$var$decodeRings(coordinates, encodeOffsets, encodeScale);
                break;
            case 'MultiPolygon':
                $1b239fc9d3a2f8ae$export$79b2f7037acddd43(coordinates, function(rings, idx) {
                    return $3f3b936dda85d569$var$decodeRings(rings, encodeOffsets[idx], encodeScale);
                });
        }
    });
    // Has been decoded
    jsonCompressed.UTF8Encoding = false;
    return jsonCompressed;
}
function $3f3b936dda85d569$var$decodeRings(rings, encodeOffsets, encodeScale) {
    for(var c = 0; c < rings.length; c++)rings[c] = $3f3b936dda85d569$var$decodeRing(rings[c], encodeOffsets[c], encodeScale);
}
function $3f3b936dda85d569$var$decodeRing(coordinate, encodeOffsets, encodeScale) {
    var result = [];
    var prevX = encodeOffsets[0];
    var prevY = encodeOffsets[1];
    for(var i = 0; i < coordinate.length; i += 2){
        var x = coordinate.charCodeAt(i) - 64;
        var y = coordinate.charCodeAt(i + 1) - 64;
        // ZigZag decoding
        x = x >> 1 ^ -(x & 1);
        y = y >> 1 ^ -(y & 1);
        // Delta deocding
        x += prevX;
        y += prevY;
        prevX = x;
        prevY = y;
        // Dequantize
        result.push([
            x / encodeScale,
            y / encodeScale
        ]);
    }
    return result;
}
function $3f3b936dda85d569$export$2e2bcd8739ae039(geoJson, nameProperty) {
    geoJson = $3f3b936dda85d569$var$decode(geoJson);
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88($1b239fc9d3a2f8ae$export$3dea766d36a8935f(geoJson.features, function(featureObj) {
        // Output of mapshaper may have geometry null
        return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
    }), function(featureObj) {
        var properties = featureObj.properties;
        var geo = featureObj.geometry;
        var geometries = [];
        switch(geo.type){
            case 'Polygon':
                var coordinates = geo.coordinates;
                // According to the GeoJSON specification.
                // First must be exterior, and the rest are all interior(holes).
                geometries.push(new (0, $ce4eefe3f35ba9ce$export$91e20b0f72443753)(coordinates[0], coordinates.slice(1)));
                break;
            case 'MultiPolygon':
                $1b239fc9d3a2f8ae$export$79b2f7037acddd43(geo.coordinates, function(item) {
                    if (item[0]) geometries.push(new (0, $ce4eefe3f35ba9ce$export$91e20b0f72443753)(item[0], item.slice(1)));
                });
                break;
            case 'LineString':
                geometries.push(new (0, $ce4eefe3f35ba9ce$export$335807c9e785d92c)([
                    geo.coordinates
                ]));
                break;
            case 'MultiLineString':
                geometries.push(new (0, $ce4eefe3f35ba9ce$export$335807c9e785d92c)(geo.coordinates));
        }
        var region = new (0, $ce4eefe3f35ba9ce$export$ee84fcb463f24b3d)(properties[nameProperty || 'name'], geometries, properties.cp);
        region.properties = properties;
        return region;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 南海诸岛


var $a3fcf4d3b7734df8$var$geoCoord = [
    126,
    25
];
var $a3fcf4d3b7734df8$var$nanhaiName = "\u5357\u6D77\u8BF8\u5C9B";
var $a3fcf4d3b7734df8$var$points = [
    [
        [
            0,
            3.5
        ],
        [
            7,
            11.2
        ],
        [
            15,
            11.9
        ],
        [
            30,
            7
        ],
        [
            42,
            0.7
        ],
        [
            52,
            0.7
        ],
        [
            56,
            7.7
        ],
        [
            59,
            0.7
        ],
        [
            64,
            0.7
        ],
        [
            64,
            0
        ],
        [
            5,
            0
        ],
        [
            0,
            3.5
        ]
    ],
    [
        [
            13,
            16.1
        ],
        [
            19,
            14.7
        ],
        [
            16,
            21.7
        ],
        [
            11,
            23.1
        ],
        [
            13,
            16.1
        ]
    ],
    [
        [
            12,
            32.2
        ],
        [
            14,
            38.5
        ],
        [
            15,
            38.5
        ],
        [
            13,
            32.2
        ],
        [
            12,
            32.2
        ]
    ],
    [
        [
            16,
            47.6
        ],
        [
            12,
            53.2
        ],
        [
            13,
            53.2
        ],
        [
            18,
            47.6
        ],
        [
            16,
            47.6
        ]
    ],
    [
        [
            6,
            64.4
        ],
        [
            8,
            70
        ],
        [
            9,
            70
        ],
        [
            8,
            64.4
        ],
        [
            6,
            64.4
        ]
    ],
    [
        [
            23,
            82.6
        ],
        [
            29,
            79.8
        ],
        [
            30,
            79.8
        ],
        [
            25,
            82.6
        ],
        [
            23,
            82.6
        ]
    ],
    [
        [
            37,
            70.7
        ],
        [
            43,
            62.3
        ],
        [
            44,
            62.3
        ],
        [
            39,
            70.7
        ],
        [
            37,
            70.7
        ]
    ],
    [
        [
            48,
            51.1
        ],
        [
            51,
            45.5
        ],
        [
            53,
            45.5
        ],
        [
            50,
            51.1
        ],
        [
            48,
            51.1
        ]
    ],
    [
        [
            51,
            35
        ],
        [
            51,
            28.7
        ],
        [
            53,
            28.7
        ],
        [
            53,
            35
        ],
        [
            51,
            35
        ]
    ],
    [
        [
            52,
            22.4
        ],
        [
            55,
            17.5
        ],
        [
            56,
            17.5
        ],
        [
            53,
            22.4
        ],
        [
            52,
            22.4
        ]
    ],
    [
        [
            58,
            12.6
        ],
        [
            62,
            7
        ],
        [
            63,
            7
        ],
        [
            60,
            12.6
        ],
        [
            58,
            12.6
        ]
    ],
    [
        [
            0,
            3.5
        ],
        [
            0,
            93.1
        ],
        [
            64,
            93.1
        ],
        [
            64,
            0
        ],
        [
            63,
            0
        ],
        [
            63,
            92.4
        ],
        [
            1,
            92.4
        ],
        [
            1,
            3.5
        ],
        [
            0,
            3.5
        ]
    ]
];
for(var $a3fcf4d3b7734df8$var$i = 0; $a3fcf4d3b7734df8$var$i < $a3fcf4d3b7734df8$var$points.length; $a3fcf4d3b7734df8$var$i++)for(var $a3fcf4d3b7734df8$var$k = 0; $a3fcf4d3b7734df8$var$k < $a3fcf4d3b7734df8$var$points[$a3fcf4d3b7734df8$var$i].length; $a3fcf4d3b7734df8$var$k++){
    $a3fcf4d3b7734df8$var$points[$a3fcf4d3b7734df8$var$i][$a3fcf4d3b7734df8$var$k][0] /= 10.5;
    $a3fcf4d3b7734df8$var$points[$a3fcf4d3b7734df8$var$i][$a3fcf4d3b7734df8$var$k][1] /= -14;
    $a3fcf4d3b7734df8$var$points[$a3fcf4d3b7734df8$var$i][$a3fcf4d3b7734df8$var$k][0] += $a3fcf4d3b7734df8$var$geoCoord[0];
    $a3fcf4d3b7734df8$var$points[$a3fcf4d3b7734df8$var$i][$a3fcf4d3b7734df8$var$k][1] += $a3fcf4d3b7734df8$var$geoCoord[1];
}
function $a3fcf4d3b7734df8$export$2e2bcd8739ae039(mapType, regions) {
    if (mapType === 'china') {
        for(var i = 0; i < regions.length; i++){
            // Already exists.
            if (regions[i].name === $a3fcf4d3b7734df8$var$nanhaiName) return;
        }
        regions.push(new (0, $ce4eefe3f35ba9ce$export$ee84fcb463f24b3d)($a3fcf4d3b7734df8$var$nanhaiName, $1b239fc9d3a2f8ae$export$871de8747c9eaa88($a3fcf4d3b7734df8$var$points, function(exterior) {
            return {
                type: 'polygon',
                exterior: exterior
            };
        }), $a3fcf4d3b7734df8$var$geoCoord));
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $a8a3b7e6e206e8cf$var$coordsOffsetMap = {
    "\u5357\u6D77\u8BF8\u5C9B": [
        32,
        80
    ],
    // 全国
    "\u5E7F\u4E1C": [
        0,
        -10
    ],
    "\u9999\u6E2F": [
        10,
        5
    ],
    "\u6FB3\u95E8": [
        -10,
        10
    ],
    // '北京': [-10, 0],
    "\u5929\u6D25": [
        5,
        5
    ]
};
function $a8a3b7e6e206e8cf$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china') {
        var coordFix = $a8a3b7e6e206e8cf$var$coordsOffsetMap[region.name];
        if (coordFix) {
            var cp = region.getCenter();
            cp[0] += coordFix[0] / 10.5;
            cp[1] += -coordFix[1] / 14;
            region.setCenter(cp);
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Fix for 钓鱼岛
// let Region = require('../Region');
// let zrUtil = require('zrender/lib/core/util');
// let geoCoord = [126, 25];
var $eccf0837f0b333be$var$points = [
    [
        [
            123.45165252685547,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.73527164402261
        ],
        [
            123.49731445312499,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.750734064600884
        ],
        [
            123.45165252685547,
            25.73527164402261
        ]
    ]
];
function $eccf0837f0b333be$export$2e2bcd8739ae039(mapType, region) {
    if (mapType === 'china' && region.name === "\u53F0\u6E7E") region.geometries.push({
        type: 'polygon',
        exterior: $eccf0837f0b333be$var$points[0]
    });
}



var $485ab40398976507$var$DEFAULT_NAME_PROPERTY = 'name';
var $485ab40398976507$export$859cf85c67f2df51 = /** @class */ function() {
    function GeoJSONResource(mapName, geoJSON, specialAreas) {
        this.type = 'geoJSON';
        this._parsedMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        this._mapName = mapName;
        this._specialAreas = specialAreas;
        // PENDING: delay the parse to the first usage to rapid up the FMP?
        this._geoJSON = $485ab40398976507$var$parseInput(geoJSON);
    }
    /**
   * @param nameMap can be null/undefined
   * @param nameProperty can be null/undefined
   */ GeoJSONResource.prototype.load = function(nameMap, nameProperty) {
        nameProperty = nameProperty || $485ab40398976507$var$DEFAULT_NAME_PROPERTY;
        var parsed = this._parsedMap.get(nameProperty);
        if (!parsed) {
            var rawRegions = this._parseToRegions(nameProperty);
            parsed = this._parsedMap.set(nameProperty, {
                regions: rawRegions,
                boundingRect: $485ab40398976507$var$calculateBoundingRect(rawRegions)
            });
        }
        var regionsMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        var finalRegions = [];
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(parsed.regions, function(region) {
            var regionName = region.name;
            // Try use the alias in geoNameMap
            if (nameMap && (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(nameMap, regionName)) region = region.cloneShallow(regionName = nameMap[regionName]);
            finalRegions.push(region);
            regionsMap.set(regionName, region);
        });
        return {
            regions: finalRegions,
            boundingRect: parsed.boundingRect || new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, 0, 0),
            regionsMap: regionsMap
        };
    };
    GeoJSONResource.prototype._parseToRegions = function(nameProperty) {
        var mapName = this._mapName;
        var geoJSON = this._geoJSON;
        var rawRegions;
        // https://jsperf.com/try-catch-performance-overhead
        try {
            rawRegions = geoJSON ? (0, $3f3b936dda85d569$export$2e2bcd8739ae039)(geoJSON, nameProperty) : [];
        } catch (e) {
            throw new Error('Invalid geoJson format\n' + e.message);
        }
        (0, $a3fcf4d3b7734df8$export$2e2bcd8739ae039)(mapName, rawRegions);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(rawRegions, function(region) {
            var regionName = region.name;
            (0, $a8a3b7e6e206e8cf$export$2e2bcd8739ae039)(mapName, region);
            (0, $eccf0837f0b333be$export$2e2bcd8739ae039)(mapName, region);
            // Some area like Alaska in USA map needs to be tansformed
            // to look better
            var specialArea = this._specialAreas && this._specialAreas[regionName];
            if (specialArea) region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
        }, this);
        return rawRegions;
    };
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ GeoJSONResource.prototype.getMapForUser = function() {
        return {
            // For backward compatibility, use geoJson
            // PENDING: it has been returning them without clone.
            // do we need to avoid outsite modification?
            geoJson: this._geoJSON,
            geoJSON: this._geoJSON,
            specialAreas: this._specialAreas
        };
    };
    return GeoJSONResource;
}();
function $485ab40398976507$var$calculateBoundingRect(regions) {
    var rect;
    for(var i = 0; i < regions.length; i++){
        var regionRect = regions[i].getBoundingRect();
        rect = rect || regionRect.clone();
        rect.union(regionRect);
    }
    return rect;
}
function $485ab40398976507$var$parseInput(source) {
    return !(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
}


var $30ff5c6f9e262156$var$storage = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
var $30ff5c6f9e262156$export$2e2bcd8739ae039 = {
    /**
   * Compatible with previous `echarts.registerMap`.
   *
   * @usage
   * ```js
   *
   * echarts.registerMap('USA', geoJson, specialAreas);
   *
   * echarts.registerMap('USA', {
   *     geoJson: geoJson,
   *     specialAreas: {...}
   * });
   * echarts.registerMap('USA', {
   *     geoJSON: geoJson,
   *     specialAreas: {...}
   * });
   *
   * echarts.registerMap('airport', {
   *     svg: svg
   * }
   * ```
   *
   * Note:
   * Do not support that register multiple geoJSON or SVG
   * one map name. Because different geoJSON and SVG have
   * different unit. It's not easy to make sure how those
   * units are mapping/normalize.
   * If intending to use multiple geoJSON or SVG, we can
   * use multiple geo coordinate system.
   */ registerMap: function(mapName, rawDef, rawSpecialAreas) {
        if (rawDef.svg) {
            var resource = new (0, $e1272ef55316374e$export$be52c950efae1f84)(mapName, rawDef.svg);
            $30ff5c6f9e262156$var$storage.set(mapName, resource);
        } else {
            // Recommend:
            //     echarts.registerMap('eu', { geoJSON: xxx, specialAreas: xxx });
            // Backward compatibility:
            //     echarts.registerMap('eu', geoJSON, specialAreas);
            //     echarts.registerMap('eu', { geoJson: xxx, specialAreas: xxx });
            var geoJSON = rawDef.geoJson || rawDef.geoJSON;
            if (geoJSON && !rawDef.features) rawSpecialAreas = rawDef.specialAreas;
            else geoJSON = rawDef;
            var resource = new (0, $485ab40398976507$export$859cf85c67f2df51)(mapName, geoJSON, rawSpecialAreas);
            $30ff5c6f9e262156$var$storage.set(mapName, resource);
        }
    },
    getGeoResource: function(mapName) {
        return $30ff5c6f9e262156$var$storage.get(mapName);
    },
    /**
   * Only for exporting to users.
   * **MUST NOT** used internally.
   */ getMapForUser: function(mapName) {
        var resource = $30ff5c6f9e262156$var$storage.get(mapName);
        // Do not support return SVG until some real requirement come.
        return resource && resource.type === 'geoJSON' && resource.getMapForUser();
    },
    load: function(mapName, nameMap, nameProperty) {
        var resource = $30ff5c6f9e262156$var$storage.get(mapName);
        if (!resource) return;
        return resource.load(nameMap, nameProperty);
    }
};








/**
 * Only these tags enable use `itemStyle` if they are named in SVG.
 * Other tags like <text> <tspan> <image> might not suitable for `itemStyle`.
 * They will not be considered to be styled until some requirements come.
 */ var $f8d0aa06849f0cb3$var$OPTION_STYLE_ENABLED_TAGS = [
    'rect',
    'circle',
    'line',
    'ellipse',
    'polygon',
    'polyline',
    'path'
];
var $f8d0aa06849f0cb3$var$OPTION_STYLE_ENABLED_TAG_MAP = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4($f8d0aa06849f0cb3$var$OPTION_STYLE_ENABLED_TAGS);
var $f8d0aa06849f0cb3$var$STATE_TRIGGER_TAG_MAP = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4($f8d0aa06849f0cb3$var$OPTION_STYLE_ENABLED_TAGS.concat([
    'g'
]));
var $f8d0aa06849f0cb3$var$LABEL_HOST_MAP = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4($f8d0aa06849f0cb3$var$OPTION_STYLE_ENABLED_TAGS.concat([
    'g'
]));
var $f8d0aa06849f0cb3$var$mapLabelRaw = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $f8d0aa06849f0cb3$var$getFixedItemStyle(model) {
    var itemStyle = model.getItemStyle();
    var areaColor = model.get('areaColor');
    // If user want the color not to be changed when hover,
    // they should both set areaColor and color to be null.
    if (areaColor != null) itemStyle.fill = areaColor;
    return itemStyle;
}
// Only stroke can be used for line.
// Using fill in style if stroke not exits.
// TODO Not sure yet. Perhaps a separate `lineStyle`?
function $f8d0aa06849f0cb3$var$fixLineStyle(styleHost) {
    var style = styleHost.style;
    if (style) {
        style.stroke = style.stroke || style.fill;
        style.fill = null;
    }
}
var $f8d0aa06849f0cb3$var$MapDraw = /** @class */ function() {
    function MapDraw(api) {
        var group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this.uid = (0, $4e8eadf530aecaff$export$6d2b3473b0986646)('ec_map_draw');
        this._controller = new (0, $36ebde58055237cc$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        this.group = group;
        group.add(this._regionsGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039());
        group.add(this._svgGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039());
    }
    MapDraw.prototype.draw = function(mapOrGeoModel, ecModel, api, fromView, payload) {
        var isGeo = mapOrGeoModel.mainType === 'geo';
        // Map series has data. GEO model that controlled by map series
        // will be assigned with map data. Other GEO model has no data.
        var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
        isGeo && ecModel.eachComponent({
            mainType: 'series',
            subType: 'map'
        }, function(mapSeries) {
            if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) data = mapSeries.getData();
        });
        var geo = mapOrGeoModel.coordinateSystem;
        var regionsGroup = this._regionsGroup;
        var group = this.group;
        var transformInfo = geo.getTransformInfo();
        var transformInfoRaw = transformInfo.raw;
        var transformInfoRoam = transformInfo.roam;
        // No animation when first draw or in action
        var isFirstDraw = !regionsGroup.childAt(0) || payload;
        if (isFirstDraw) {
            group.x = transformInfoRoam.x;
            group.y = transformInfoRoam.y;
            group.scaleX = transformInfoRoam.scaleX;
            group.scaleY = transformInfoRoam.scaleY;
            group.dirty();
        } else $b40111164617dd60$export$c8dce3c08436e91e(group, transformInfoRoam, mapOrGeoModel);
        var isVisualEncodedByVisualMap = data && data.getVisual('visualMeta') && data.getVisual('visualMeta').length > 0;
        var viewBuildCtx = {
            api: api,
            geo: geo,
            mapOrGeoModel: mapOrGeoModel,
            data: data,
            isVisualEncodedByVisualMap: isVisualEncodedByVisualMap,
            isGeo: isGeo,
            transformInfoRaw: transformInfoRaw
        };
        if (geo.resourceType === 'geoJSON') this._buildGeoJSON(viewBuildCtx);
        else if (geo.resourceType === 'geoSVG') this._buildSVG(viewBuildCtx);
        this._updateController(mapOrGeoModel, ecModel, api);
        this._updateMapSelectHandler(mapOrGeoModel, regionsGroup, api, fromView);
    };
    MapDraw.prototype._buildGeoJSON = function(viewBuildCtx) {
        var regionsGroupByName = this._regionsGroupByName = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var regionsInfoByName = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var regionsGroup = this._regionsGroup;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
        var data = viewBuildCtx.data;
        var projection = viewBuildCtx.geo.projection;
        var projectionStream = projection && projection.stream;
        function transformPoint(point, project) {
            if (project) // projection may return null point.
            point = project(point);
            return point && [
                point[0] * transformInfoRaw.scaleX + transformInfoRaw.x,
                point[1] * transformInfoRaw.scaleY + transformInfoRaw.y
            ];
        }
        function transformPolygonPoints(inPoints) {
            var outPoints = [];
            // If projectionStream is provided. Use it instead of single point project.
            var project = !projectionStream && projection && projection.project;
            for(var i = 0; i < inPoints.length; ++i){
                var newPt = transformPoint(inPoints[i], project);
                newPt && outPoints.push(newPt);
            }
            return outPoints;
        }
        function getPolyShape(points) {
            return {
                shape: {
                    points: transformPolygonPoints(points)
                }
            };
        }
        regionsGroup.removeAll();
        // Only when the resource is GeoJSON, there is `geo.regions`.
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(viewBuildCtx.geo.regions, function(region) {
            var regionName = region.name;
            // Consider in GeoJson properties.name may be duplicated, for example,
            // there is multiple region named "United Kindom" or "France" (so many
            // colonies). And it is not appropriate to merge them in geo, which
            // will make them share the same label and bring trouble in label
            // location calculation.
            var regionGroup = regionsGroupByName.get(regionName);
            var _a = regionsInfoByName.get(regionName) || {}, dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            if (!regionGroup) {
                regionGroup = regionsGroupByName.set(regionName, new $6c313c3ef6000a43$export$2e2bcd8739ae039());
                regionsGroup.add(regionGroup);
                dataIdx = data ? data.indexOfName(regionName) : null;
                regionModel = viewBuildCtx.isGeo ? mapOrGeoModel.getRegionModel(regionName) : data ? data.getItemModel(dataIdx) : null;
                var silent = regionModel.get('silent', true);
                silent != null && (regionGroup.silent = silent);
                regionsInfoByName.set(regionName, {
                    dataIdx: dataIdx,
                    regionModel: regionModel
                });
            }
            var polygonSubpaths = [];
            var polylineSubpaths = [];
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(region.geometries, function(geometry) {
                // Polygon and MultiPolygon
                if (geometry.type === 'polygon') {
                    var polys = [
                        geometry.exterior
                    ].concat(geometry.interiors || []);
                    if (projectionStream) polys = $f8d0aa06849f0cb3$var$projectPolys(polys, projectionStream);
                    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(polys, function(poly) {
                        polygonSubpaths.push(new $399011f87accd5da$export$2e2bcd8739ae039(getPolyShape(poly)));
                    });
                } else {
                    var points = geometry.points;
                    if (projectionStream) points = $f8d0aa06849f0cb3$var$projectPolys(points, projectionStream, true);
                    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(points, function(points) {
                        polylineSubpaths.push(new $f7f6523750aec7c8$export$2e2bcd8739ae039(getPolyShape(points)));
                    });
                }
            });
            var centerPt = transformPoint(region.getCenter(), projection && projection.project);
            function createCompoundPath(subpaths, isLine) {
                if (!subpaths.length) return;
                var compoundPath = new $dd9b7a63634188ff$export$2e2bcd8739ae039({
                    culling: true,
                    segmentIgnoreThreshold: 1,
                    shape: {
                        paths: subpaths
                    }
                });
                regionGroup.add(compoundPath);
                $f8d0aa06849f0cb3$var$applyOptionStyleForRegion(viewBuildCtx, compoundPath, dataIdx, regionModel);
                $f8d0aa06849f0cb3$var$resetLabelForRegion(viewBuildCtx, compoundPath, regionName, regionModel, mapOrGeoModel, dataIdx, centerPt);
                if (isLine) {
                    $f8d0aa06849f0cb3$var$fixLineStyle(compoundPath);
                    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(compoundPath.states, $f8d0aa06849f0cb3$var$fixLineStyle);
                }
            }
            createCompoundPath(polygonSubpaths);
            createCompoundPath(polylineSubpaths, true);
        });
        // Ensure children have been added to `regionGroup` before calling them.
        regionsGroupByName.each(function(regionGroup, regionName) {
            var _a = regionsInfoByName.get(regionName), dataIdx = _a.dataIdx, regionModel = _a.regionModel;
            $f8d0aa06849f0cb3$var$resetEventTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel, dataIdx);
            $f8d0aa06849f0cb3$var$resetTooltipForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
            $f8d0aa06849f0cb3$var$resetStateTriggerForRegion(viewBuildCtx, regionGroup, regionName, regionModel, mapOrGeoModel);
        }, this);
    };
    MapDraw.prototype._buildSVG = function(viewBuildCtx) {
        var mapName = viewBuildCtx.geo.map;
        var transformInfoRaw = viewBuildCtx.transformInfoRaw;
        this._svgGroup.x = transformInfoRaw.x;
        this._svgGroup.y = transformInfoRaw.y;
        this._svgGroup.scaleX = transformInfoRaw.scaleX;
        this._svgGroup.scaleY = transformInfoRaw.scaleY;
        if (this._svgResourceChanged(mapName)) {
            this._freeSVG();
            this._useSVG(mapName);
        }
        var svgDispatcherMap = this._svgDispatcherMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var focusSelf = false;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._svgGraphicRecord.named, function(namedItem) {
            // Note that we also allow different elements have the same name.
            // For example, a glyph of a city and the label of the city have
            // the same name and their tooltip info can be defined in a single
            // region option.
            var regionName = namedItem.name;
            var mapOrGeoModel = viewBuildCtx.mapOrGeoModel;
            var data = viewBuildCtx.data;
            var svgNodeTagLower = namedItem.svgNodeTagLower;
            var el = namedItem.el;
            var dataIdx = data ? data.indexOfName(regionName) : null;
            var regionModel = mapOrGeoModel.getRegionModel(regionName);
            if ($f8d0aa06849f0cb3$var$OPTION_STYLE_ENABLED_TAG_MAP.get(svgNodeTagLower) != null && el instanceof (0, $cfd8540aca1ca40f$export$2e2bcd8739ae039)) $f8d0aa06849f0cb3$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIdx, regionModel);
            if (el instanceof (0, $cfd8540aca1ca40f$export$2e2bcd8739ae039)) el.culling = true;
            var silent = regionModel.get('silent', true);
            silent != null && (el.silent = silent);
            // We do not know how the SVG like so we'd better not to change z2.
            // Otherwise it might bring some unexpected result. For example,
            // an area hovered that make some inner city can not be clicked.
            el.z2EmphasisLift = 0;
            // If self named:
            if (!namedItem.namedFrom) {
                // label should batter to be displayed based on the center of <g>
                // if it is named rather than displayed on each child.
                if ($f8d0aa06849f0cb3$var$LABEL_HOST_MAP.get(svgNodeTagLower) != null) $f8d0aa06849f0cb3$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx, null);
                $f8d0aa06849f0cb3$var$resetEventTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, dataIdx);
                $f8d0aa06849f0cb3$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                if ($f8d0aa06849f0cb3$var$STATE_TRIGGER_TAG_MAP.get(svgNodeTagLower) != null) {
                    var focus_1 = $f8d0aa06849f0cb3$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel);
                    if (focus_1 === 'self') focusSelf = true;
                    var els = svgDispatcherMap.get(regionName) || svgDispatcherMap.set(regionName, []);
                    els.push(el);
                }
            }
        }, this);
        this._enableBlurEntireSVG(focusSelf, viewBuildCtx);
    };
    MapDraw.prototype._enableBlurEntireSVG = function(focusSelf, viewBuildCtx) {
        // It's a little complicated to support blurring the entire geoSVG in series-map.
        // So do not support it until some requirements come.
        // At present, in series-map, only regions can be blurred.
        if (focusSelf && viewBuildCtx.isGeo) {
            var blurStyle = viewBuildCtx.mapOrGeoModel.getModel([
                'blur',
                'itemStyle'
            ]).getItemStyle();
            // Only support `opacity` here. Because not sure that other props are suitable for
            // all of the elements generated by SVG (especially for Text/TSpan/Image/... ).
            var opacity_1 = blurStyle.opacity;
            this._svgGraphicRecord.root.traverse(function(el) {
                if (!el.isGroup) {
                    // PENDING: clear those settings to SVG elements when `_freeSVG`.
                    // (Currently it happen not to be needed.)
                    (0, $b414df7d361a211c$export$20f39bbe322fb9ab)(el);
                    var style = el.ensureState('blur').style || {};
                    // Do not overwrite the region style that already set from region option.
                    if (style.opacity == null && opacity_1 != null) style.opacity = opacity_1;
                    // If `ensureState('blur').style = {}`, there will be default opacity.
                    // Enable `stateTransition` (animation).
                    el.ensureState('emphasis');
                }
            });
        }
    };
    MapDraw.prototype.remove = function() {
        this._regionsGroup.removeAll();
        this._regionsGroupByName = null;
        this._svgGroup.removeAll();
        this._freeSVG();
        this._controller.dispose();
        this._controllerHost = null;
    };
    MapDraw.prototype.findHighDownDispatchers = function(name, geoModel) {
        if (name == null) return [];
        var geo = geoModel.coordinateSystem;
        if (geo.resourceType === 'geoJSON') {
            var regionsGroupByName = this._regionsGroupByName;
            if (regionsGroupByName) {
                var regionGroup = regionsGroupByName.get(name);
                return regionGroup ? [
                    regionGroup
                ] : [];
            }
        } else if (geo.resourceType === 'geoSVG') return this._svgDispatcherMap && this._svgDispatcherMap.get(name) || [];
    };
    MapDraw.prototype._svgResourceChanged = function(mapName) {
        return this._svgMapName !== mapName;
    };
    MapDraw.prototype._useSVG = function(mapName) {
        var resource = (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === 'geoSVG') {
            var svgGraphic = resource.useGraphic(this.uid);
            this._svgGroup.add(svgGraphic.root);
            this._svgGraphicRecord = svgGraphic;
            this._svgMapName = mapName;
        }
    };
    MapDraw.prototype._freeSVG = function() {
        var mapName = this._svgMapName;
        if (mapName == null) return;
        var resource = (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).getGeoResource(mapName);
        if (resource && resource.type === 'geoSVG') resource.freeGraphic(this.uid);
        this._svgGraphicRecord = null;
        this._svgDispatcherMap = null;
        this._svgGroup.removeAll();
        this._svgMapName = null;
    };
    MapDraw.prototype._updateController = function(mapOrGeoModel, ecModel, api) {
        var geo = mapOrGeoModel.coordinateSystem;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        // @ts-ignore FIXME:TS
        controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
        controllerHost.zoom = geo.getZoom();
        // roamType is will be set default true if it is null
        // @ts-ignore FIXME:TS
        controller.enable(mapOrGeoModel.get('roam') || false);
        var mainType = mapOrGeoModel.mainType;
        function makeActionBase() {
            var action = {
                type: 'geoRoam',
                componentType: mainType
            };
            action[mainType + 'Id'] = mapOrGeoModel.id;
            return action;
        }
        controller.off('pan').on('pan', function(e) {
            this._mouseDownFlag = false;
            $77c59df9b4754854$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction($1b239fc9d3a2f8ae$export$8b58be045bf06082(makeActionBase(), {
                dx: e.dx,
                dy: e.dy,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.off('zoom').on('zoom', function(e) {
            this._mouseDownFlag = false;
            $77c59df9b4754854$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction($1b239fc9d3a2f8ae$export$8b58be045bf06082(makeActionBase(), {
                totalZoom: controllerHost.zoom,
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY,
                animation: {
                    duration: 0
                }
            }));
        }, this);
        controller.setPointerChecker(function(e, x, y) {
            return geo.containPoint([
                x,
                y
            ]) && !(0, $644ca0c6add6ebe3$export$8a33eacb690eac07)(e, api, mapOrGeoModel);
        });
    };
    /**
   * FIXME: this is a temporarily workaround.
   * When `geoRoam` the elements need to be reset in `MapView['render']`, because the props like
   * `ignore` might have been modified by `LabelManager`, and `LabelManager#addLabelsOfSeries`
   * will subsequently cache `defaultAttr` like `ignore`. If do not do this reset, the modified
   * props will have no chance to be restored.
   * Note: This reset should be after `clearStates` in `renderSeries` because `useStates` in
   * `renderSeries` will cache the modified `ignore` to `el._normalState`.
   * TODO:
   * Use clone/immutable in `LabelManager`?
   */ MapDraw.prototype.resetForLabelLayout = function() {
        this.group.traverse(function(el) {
            var label = el.getTextContent();
            if (label) label.ignore = $f8d0aa06849f0cb3$var$mapLabelRaw(label).ignore;
        });
    };
    MapDraw.prototype._updateMapSelectHandler = function(mapOrGeoModel, regionsGroup, api, fromView) {
        var mapDraw = this;
        regionsGroup.off('mousedown');
        regionsGroup.off('click');
        // @ts-ignore FIXME:TS resolve type conflict
        if (mapOrGeoModel.get('selectedMode')) {
            regionsGroup.on('mousedown', function() {
                mapDraw._mouseDownFlag = true;
            });
            regionsGroup.on('click', function(e) {
                if (!mapDraw._mouseDownFlag) return;
                mapDraw._mouseDownFlag = false;
            });
        }
    };
    return MapDraw;
}();
function $f8d0aa06849f0cb3$var$applyOptionStyleForRegion(viewBuildCtx, el, dataIndex, regionModel) {
    // All of the path are using `itemStyle`, because
    // (1) Some SVG also use fill on polyline (The different between
    // polyline and polygon is "open" or "close" but not fill or not).
    // (2) For the common props like opacity, if some use itemStyle
    // and some use `lineStyle`, it might confuse users.
    // (3) Most SVG use <path>, where can not detect whether to draw a "line"
    // or a filled shape, so use `itemStyle` for <path>.
    var normalStyleModel = regionModel.getModel('itemStyle');
    var emphasisStyleModel = regionModel.getModel([
        'emphasis',
        'itemStyle'
    ]);
    var blurStyleModel = regionModel.getModel([
        'blur',
        'itemStyle'
    ]);
    var selectStyleModel = regionModel.getModel([
        'select',
        'itemStyle'
    ]);
    // NOTE: DON'T use 'style' in visual when drawing map.
    // This component is used for drawing underlying map for both geo component and map series.
    var normalStyle = $f8d0aa06849f0cb3$var$getFixedItemStyle(normalStyleModel);
    var emphasisStyle = $f8d0aa06849f0cb3$var$getFixedItemStyle(emphasisStyleModel);
    var selectStyle = $f8d0aa06849f0cb3$var$getFixedItemStyle(selectStyleModel);
    var blurStyle = $f8d0aa06849f0cb3$var$getFixedItemStyle(blurStyleModel);
    // Update the itemStyle if has data visual
    var data = viewBuildCtx.data;
    if (data) {
        // Only visual color of each item will be used. It can be encoded by visualMap
        // But visual color of series is used in symbol drawing
        // Visual color for each series is for the symbol draw
        var style = data.getItemVisual(dataIndex, 'style');
        var decal = data.getItemVisual(dataIndex, 'decal');
        if (viewBuildCtx.isVisualEncodedByVisualMap && style.fill) normalStyle.fill = style.fill;
        if (decal) normalStyle.decal = (0, $6d9628e7c6bac2b0$export$a3ba048e1a648972)(decal, viewBuildCtx.api);
    }
    // SVG text, tspan and image can be named but not supporeted
    // to be styled by region option yet.
    el.setStyle(normalStyle);
    el.style.strokeNoScale = true;
    el.ensureState('emphasis').style = emphasisStyle;
    el.ensureState('select').style = selectStyle;
    el.ensureState('blur').style = blurStyle;
    // Enable blur
    (0, $b414df7d361a211c$export$20f39bbe322fb9ab)(el);
}
function $f8d0aa06849f0cb3$var$resetLabelForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx, // If labelXY not provided, use `textConfig.position: 'inside'`
labelXY) {
    var data = viewBuildCtx.data;
    var isGeo = viewBuildCtx.isGeo;
    var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
    var itemLayout = data && data.getItemLayout(dataIdx);
    // In the following cases label will be drawn
    // 1. In map series and data value is NaN
    // 2. In geo component
    // 3. Region has no series legendIcon, which will be add a showLabel flag in mapSymbolLayout
    if (isGeo || isDataNaN || itemLayout && itemLayout.showLabel) {
        var query = !isGeo ? dataIdx : regionName;
        var labelFetcher = void 0;
        // Consider dataIdx not found.
        if (!data || dataIdx >= 0) labelFetcher = mapOrGeoModel;
        var specifiedTextOpt = labelXY ? {
            normal: {
                align: 'center',
                verticalAlign: 'middle'
            }
        } : null;
        // Caveat: must be called after `setDefaultStateProxy(el);` called.
        // because textContent will be assign with `el.stateProxy` inside.
        (0, $3828198b2f2de836$export$9a13992917966657)(el, (0, $3828198b2f2de836$export$9739a32674be5893)(regionModel), {
            labelFetcher: labelFetcher,
            labelDataIndex: query,
            defaultText: regionName
        }, specifiedTextOpt);
        var textEl = el.getTextContent();
        if (textEl) {
            $f8d0aa06849f0cb3$var$mapLabelRaw(textEl).ignore = textEl.ignore;
            if (el.textConfig && labelXY) {
                // Compute a relative offset based on the el bounding rect.
                var rect = el.getBoundingRect().clone();
                // Need to make sure the percent position base on the same rect in normal and
                // emphasis state. Otherwise if using boundingRect of el, but the emphasis state
                // has borderWidth (even 0.5px), the text position will be changed obviously
                // if the position is very big like ['1234%', '1345%'].
                el.textConfig.layoutRect = rect;
                el.textConfig.position = [
                    (labelXY[0] - rect.x) / rect.width * 100 + '%',
                    (labelXY[1] - rect.y) / rect.height * 100 + '%'
                ];
            }
        }
        // PENDING:
        // If labelLayout is enabled (test/label-layout.html), el.dataIndex should be specified.
        // But el.dataIndex is also used to determine whether user event should be triggered,
        // where el.seriesIndex or el.dataModel must be specified. At present for a single el
        // there is not case that "only label layout enabled but user event disabled", so here
        // we depends `resetEventTriggerForRegion` to do the job of setting `el.dataIndex`.
        el.disableLabelAnimation = true;
    } else {
        el.removeTextContent();
        el.removeTextConfig();
        el.disableLabelAnimation = null;
    }
}
function $f8d0aa06849f0cb3$var$resetEventTriggerForRegion(viewBuildCtx, eventTrigger, regionName, regionModel, mapOrGeoModel, // Exist only if `viewBuildCtx.data` exists.
dataIdx) {
    // setItemGraphicEl, setHoverStyle after all polygons and labels
    // are added to the regionGroup
    if (viewBuildCtx.data) // FIXME: when series-map use a SVG map, and there are duplicated name specified
    // on different SVG elements, after `data.setItemGraphicEl(...)`:
    // (1) all of them will be mounted with `dataIndex`, `seriesIndex`, so that tooltip
    // can be triggered only mouse hover. That's correct.
    // (2) only the last element will be kept in `data`, so that if trigger tooltip
    // by `dispatchAction`, only the last one can be found and triggered. That might be
    // not correct. We will fix it in future if anyone demanding that.
    viewBuildCtx.data.setItemGraphicEl(dataIdx, eventTrigger);
    else // Package custom mouse event for geo component
    (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(eventTrigger).eventData = {
        componentType: 'geo',
        componentIndex: mapOrGeoModel.componentIndex,
        geoIndex: mapOrGeoModel.componentIndex,
        name: regionName,
        region: regionModel && regionModel.option || {}
    };
}
function $f8d0aa06849f0cb3$var$resetTooltipForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    if (!viewBuildCtx.data) $8eb95236e1aa01e7$export$fc6410d97fab306c({
        el: el,
        componentModel: mapOrGeoModel,
        itemName: regionName,
        // @ts-ignore FIXME:TS fix the "compatible with each other"?
        itemTooltipOption: regionModel.get('tooltip')
    });
}
function $f8d0aa06849f0cb3$var$resetStateTriggerForRegion(viewBuildCtx, el, regionName, regionModel, mapOrGeoModel) {
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    el.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
    // @ts-ignore FIXME:TS fix the "compatible with each other"?
    var emphasisModel = regionModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    (0, $b414df7d361a211c$export$e51187539ff11209)(el, focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    if (viewBuildCtx.isGeo) (0, $b414df7d361a211c$export$4da05a9639f01954)(el, mapOrGeoModel, regionName);
    return focus;
}
function $f8d0aa06849f0cb3$var$projectPolys(rings, // Polygons include exterior and interiors. Or polylines.
createStream, isLine) {
    var polygons = [];
    var curPoly;
    function startPolygon() {
        curPoly = [];
    }
    function endPolygon() {
        if (curPoly.length) {
            polygons.push(curPoly);
            curPoly = [];
        }
    }
    var stream = createStream({
        polygonStart: startPolygon,
        polygonEnd: endPolygon,
        lineStart: startPolygon,
        lineEnd: endPolygon,
        point: function(x, y) {
            // May have NaN values from stream.
            if (isFinite(x) && isFinite(y)) curPoly.push([
                x,
                y
            ]);
        },
        sphere: function() {}
    });
    !isLine && stream.polygonStart();
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(rings, function(ring) {
        stream.lineStart();
        for(var i = 0; i < ring.length; i++)stream.point(ring[i][0], ring[i][1]);
        stream.lineEnd();
    });
    !isLine && stream.polygonEnd();
    return polygons;
}
var $f8d0aa06849f0cb3$export$2e2bcd8739ae039 // @ts-ignore FIXME:TS fix the "compatible with each other"?
 = $f8d0aa06849f0cb3$var$MapDraw;





var $f9c26faeaa1cb045$var$MapView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MapView, _super);
    function MapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapView.type;
        return _this;
    }
    MapView.prototype.render = function(mapModel, ecModel, api, payload) {
        // Not render if it is an toggleSelect action from self
        if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) return;
        var group = this.group;
        group.removeAll();
        if (mapModel.getHostGeoModel()) return;
        if (this._mapDraw && payload && payload.type === 'geoRoam') this._mapDraw.resetForLabelLayout();
        // Not update map if it is an roam action from self
        if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
            if (mapModel.needsDrawMap) {
                var mapDraw = this._mapDraw || new (0, $f8d0aa06849f0cb3$export$2e2bcd8739ae039)(api);
                group.add(mapDraw.group);
                mapDraw.draw(mapModel, ecModel, api, this, payload);
                this._mapDraw = mapDraw;
            } else {
                // Remove drawn map
                this._mapDraw && this._mapDraw.remove();
                this._mapDraw = null;
            }
        } else {
            var mapDraw = this._mapDraw;
            mapDraw && group.add(mapDraw.group);
        }
        mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
    };
    MapView.prototype.remove = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
        this.group.removeAll();
    };
    MapView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
        this._mapDraw = null;
    };
    MapView.prototype._renderSymbols = function(mapModel, ecModel, api) {
        var originalData = mapModel.originalData;
        var group = this.group;
        originalData.each(originalData.mapDimension('value'), function(value, originalDataIndex) {
            if (isNaN(value)) return;
            var layout = originalData.getItemLayout(originalDataIndex);
            if (!layout || !layout.point) // Not exists in map
            return;
            var point = layout.point;
            var offset = layout.offset;
            var circle = new $7257c7c7414f291c$export$2e2bcd8739ae039({
                style: {
                    // Because the special of map draw.
                    // Which needs statistic of multiple series and draw on one map.
                    // And each series also need a symbol with legend color
                    //
                    // Layout and visual are put one the different data
                    // TODO
                    fill: mapModel.getData().getVisual('style').fill
                },
                shape: {
                    cx: point[0] + offset * 9,
                    cy: point[1],
                    r: 3
                },
                silent: true,
                // Do not overlap the first series, on which labels are displayed.
                z2: 8 + (!offset ? (0, $b414df7d361a211c$export$1cb9fc6ed5b9836c) + 1 : 0)
            });
            // Only the series that has the first value on the same region is in charge of rendering the label.
            // But consider the case:
            // series: [
            //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
            //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
            // ]
            // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
            // For backward compatibility, we follow the rule that render label `A` by the
            // settings on series `X` but render label `C` by the settings on series `Y`.
            if (!offset) {
                var fullData = mapModel.mainSeries.getData();
                var name_1 = originalData.getName(originalDataIndex);
                var fullIndex_1 = fullData.indexOfName(name_1);
                var itemModel = originalData.getItemModel(originalDataIndex);
                var labelModel = itemModel.getModel('label');
                var regionGroup = fullData.getItemGraphicEl(fullIndex_1);
                // `getFormattedLabel` needs to use `getData` inside. Here
                // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
                // FIXME
                // If this is not the `mainSeries`, the item model (like label formatter)
                // set on original data item will never get. But it has been working
                // like that from the beginning, and this scenario is rarely encountered.
                // So it won't be fixed until we have to.
                (0, $3828198b2f2de836$export$9a13992917966657)(circle, (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel), {
                    labelFetcher: {
                        getFormattedLabel: function(idx, state) {
                            return mapModel.getFormattedLabel(fullIndex_1, state);
                        }
                    },
                    defaultText: name_1
                });
                circle.disableLabelAnimation = true;
                if (!labelModel.get('position')) circle.setTextConfig({
                    position: 'bottom'
                });
                regionGroup.onHoverStateChange = function(toState) {
                    (0, $b414df7d361a211c$export$868ba38adffa9e39)(circle, toState);
                };
            }
            group.add(circle);
        });
    };
    MapView.type = 'map';
    return MapView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $f9c26faeaa1cb045$export$2e2bcd8739ae039 = $f9c26faeaa1cb045$var$MapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $5258b5a09c385547$var$MapSeries = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MapSeries, _super);
    function MapSeries() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MapSeries.type;
        // Only first map series of same mapType will drawMap.
        _this.needsDrawMap = false;
        // Group of all map series with same mapType
        _this.seriesGroup = [];
        _this.getTooltipPosition = function(dataIndex) {
            if (dataIndex != null) {
                var name_1 = this.getData().getName(dataIndex);
                var geo = this.coordinateSystem;
                var region = geo.getRegion(name_1);
                return region && geo.dataToPoint(region.getCenter());
            }
        };
        return _this;
    }
    MapSeries.prototype.getInitialData = function(option) {
        var data = (0, $4433247721525340$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $1b239fc9d3a2f8ae$export$c3095a23b368d1f2((0, $669a01b8661bdd13$export$60b8a57d1f2fed26), this)
        });
        var dataNameIndexMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var toAppendItems = [];
        for(var i = 0, len = data.count(); i < len; i++){
            var name_2 = data.getName(i);
            dataNameIndexMap.set(name_2, i);
        }
        var geoSource = (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(geoSource.regions, function(region) {
            var name = region.name;
            var dataNameIdx = dataNameIndexMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            var dataItem;
            if (dataNameIdx == null) {
                dataItem = {
                    name: name
                };
                toAppendItems.push(dataItem);
            } else dataItem = data.getRawDataItem(dataNameIdx);
            specifiedGeoJSONRegionStyle && $1b239fc9d3a2f8ae$export$4950aa0f605343fb(dataItem, specifiedGeoJSONRegionStyle);
        });
        // Complete data with missing regions. The consequent processes (like visual
        // map and render) can not be performed without a "full data". For example,
        // find `dataIndex` by name.
        data.appendData(toAppendItems);
        return data;
    };
    /**
   * If no host geo model, return null, which means using a
   * inner exclusive geo model.
   */ MapSeries.prototype.getHostGeoModel = function() {
        var geoIndex = this.option.geoIndex;
        return geoIndex != null ? this.ecModel.getComponent('geo', geoIndex) : null;
    };
    MapSeries.prototype.getMapType = function() {
        return (this.getHostGeoModel() || this).option.map;
    };
    // _fillOption(option, mapName) {
    // Shallow clone
    // option = zrUtil.extend({}, option);
    // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
    // return option;
    // }
    MapSeries.prototype.getRawValue = function(dataIndex) {
        // Use value stored in data instead because it is calculated from multiple series
        // FIXME Provide all value of multiple series ?
        var data = this.getData();
        return data.get(data.mapDimension('value'), dataIndex);
    };
    /**
   * Get model of region
   */ MapSeries.prototype.getRegionModel = function(regionName) {
        var data = this.getData();
        return data.getItemModel(data.indexOfName(regionName));
    };
    /**
   * Map tooltip formatter
   */ MapSeries.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        // FIXME orignalData and data is a bit confusing
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        var seriesGroup = this.seriesGroup;
        var seriesNames = [];
        for(var i = 0; i < seriesGroup.length; i++){
            var otherIndex = seriesGroup[i].originalData.indexOfName(name);
            var valueDim = data.mapDimension('value');
            if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) seriesNames.push(seriesGroup[i].name);
        }
        return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('section', {
            header: seriesNames.join(', '),
            noHeader: !seriesNames.length,
            blocks: [
                (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                    name: name,
                    value: value
                })
            ]
        });
    };
    MapSeries.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    MapSeries.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    MapSeries.prototype.getLegendIcon = function(opt) {
        var iconType = opt.icon || 'roundRect';
        var icon = (0, $da6220012439db7b$export$af050e04da3a02e8)(iconType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill);
        icon.setStyle(opt.itemStyle);
        // Map do not use itemStyle.borderWidth as border width
        icon.style.stroke = 'none';
        // No rotation because no series visual symbol for map
        if (iconType.indexOf('empty') > -1) {
            icon.style.stroke = icon.style.fill;
            icon.style.fill = '#fff';
            icon.style.lineWidth = 2;
        }
        return icon;
    };
    MapSeries.type = 'series.map';
    MapSeries.dependencies = [
        'geo'
    ];
    MapSeries.layoutMode = 'box';
    MapSeries.defaultOption = {
        // 一级层叠
        // zlevel: 0,
        // 二级层叠
        z: 2,
        coordinateSystem: 'geo',
        // map should be explicitly specified since ec3.
        map: '',
        // If `geoIndex` is not specified, a exclusive geo will be
        // created. Otherwise use the specified geo component, and
        // `map` and `mapType` are ignored.
        // geoIndex: 0,
        // 'center' | 'left' | 'right' | 'x%' | {number}
        left: 'center',
        // 'center' | 'top' | 'bottom' | 'x%' | {number}
        top: 'center',
        // right
        // bottom
        // width:
        // height
        // Aspect is width / height. Inited to be geoJson bbox aspect
        // This parameter is used for scale this aspect
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient.
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        showLegendSymbol: true,
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ],
        // higher priority than center and zoom
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        selectedMode: true,
        label: {
            show: false,
            color: '#000'
        },
        // scaleLimit: null,
        itemStyle: {
            borderWidth: 0.5,
            borderColor: '#444',
            areaColor: '#eee'
        },
        emphasis: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                areaColor: 'rgba(255,215,0,0.8)'
            }
        },
        select: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                color: 'rgba(255,215,0,0.8)'
            }
        },
        nameProperty: 'name'
    };
    return MapSeries;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $5258b5a09c385547$export$2e2bcd8739ae039 = $5258b5a09c385547$var$MapSeries;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// FIXME 公用？
function $431e427dee6cc5f5$var$dataStatistics(datas, statisticType) {
    var dataNameMap = {};
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(datas, function(data) {
        data.each(data.mapDimension('value'), function(value, idx) {
            // Add prefix to avoid conflict with Object.prototype.
            var mapKey = 'ec-' + data.getName(idx);
            dataNameMap[mapKey] = dataNameMap[mapKey] || [];
            if (!isNaN(value)) dataNameMap[mapKey].push(value);
        });
    });
    return datas[0].map(datas[0].mapDimension('value'), function(value, idx) {
        var mapKey = 'ec-' + datas[0].getName(idx);
        var sum = 0;
        var min = Infinity;
        var max = -Infinity;
        var len = dataNameMap[mapKey].length;
        for(var i = 0; i < len; i++){
            min = Math.min(min, dataNameMap[mapKey][i]);
            max = Math.max(max, dataNameMap[mapKey][i]);
            sum += dataNameMap[mapKey][i];
        }
        var result;
        if (statisticType === 'min') result = min;
        else if (statisticType === 'max') result = max;
        else if (statisticType === 'average') result = sum / len;
        else result = sum;
        return len === 0 ? NaN : result;
    });
}
function $431e427dee6cc5f5$export$2e2bcd8739ae039(ecModel) {
    var seriesGroups = {};
    ecModel.eachSeriesByType('map', function(seriesModel) {
        var hostGeoModel = seriesModel.getHostGeoModel();
        var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
        (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
    });
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(seriesGroups, function(seriesList, key) {
        var data = $431e427dee6cc5f5$var$dataStatistics($1b239fc9d3a2f8ae$export$871de8747c9eaa88(seriesList, function(seriesModel) {
            return seriesModel.getData();
        }), seriesList[0].get('mapValueCalculation'));
        for(var i = 0; i < seriesList.length; i++)seriesList[i].originalData = seriesList[i].getData();
        // FIXME Put where?
        for(var i = 0; i < seriesList.length; i++){
            seriesList[i].seriesGroup = seriesList;
            seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
            seriesList[i].setData(data.cloneShallow());
            seriesList[i].mainSeries = seriesList[0];
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $9ed6e6759c0745f5$export$2e2bcd8739ae039(ecModel) {
    var processedMapType = {};
    ecModel.eachSeriesByType('map', function(mapSeries) {
        var mapType = mapSeries.getMapType();
        if (mapSeries.getHostGeoModel() || processedMapType[mapType]) return;
        var mapSymbolOffsets = {};
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(mapSeries.seriesGroup, function(subMapSeries) {
            var geo = subMapSeries.coordinateSystem;
            var data = subMapSeries.originalData;
            if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) data.each(data.mapDimension('value'), function(value, idx) {
                var name = data.getName(idx);
                var region = geo.getRegion(name);
                // If input series.data is [11, 22, '-'/null/undefined, 44],
                // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
                // not be drawn. So here must validate if value is NaN.
                if (!region || isNaN(value)) return;
                var offset = mapSymbolOffsets[name] || 0;
                var point = geo.dataToPoint(region.getCenter());
                mapSymbolOffsets[name] = offset + 1;
                data.setItemLayout(idx, {
                    point: point,
                    offset: offset
                });
            });
        });
        // Show label of those region not has legendIcon (which is offset 0)
        var data = mapSeries.getData();
        data.each(function(idx) {
            var name = data.getName(idx);
            var layout = data.getItemLayout(idx) || {};
            layout.showLabel = !mapSymbolOffsets[name];
            data.setItemLayout(idx, layout);
        });
        processedMapType[mapType] = true;
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $6713d37ec624c52a$var$v2ApplyTransform = $3dde7d051fe20daa$export$9f9dcb98c894b623;
var $6713d37ec624c52a$var$View = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(View, _super);
    function View(name) {
        var _this = _super.call(this) || this;
        _this.type = 'view';
        _this.dimensions = [
            'x',
            'y'
        ];
        /**
     * Represents the transform brought by roam/zoom.
     * If `View['_viewRect']` applies roam transform,
     * we can get the final displayed rect.
     */ _this._roamTransformable = new (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039)();
        /**
     * Represents the transform from `View['_rect']` to `View['_viewRect']`.
     */ _this._rawTransformable = new (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039)();
        _this.name = name;
        return _this;
    }
    View.prototype.setBoundingRect = function(x, y, width, height) {
        this._rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, width, height);
        return this._rect;
    };
    /**
   * @return {module:zrender/core/BoundingRect}
   */ View.prototype.getBoundingRect = function() {
        return this._rect;
    };
    View.prototype.setViewRect = function(x, y, width, height) {
        this._transformTo(x, y, width, height);
        this._viewRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, width, height);
    };
    /**
   * Transformed to particular position and size
   */ View.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var rawTransform = this._rawTransformable;
        rawTransform.transform = rect.calculateTransform(new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransform.parent;
        rawTransform.parent = null;
        rawTransform.decomposeTransform();
        rawTransform.parent = rawParent;
        this._updateTransform();
    };
    /**
   * Set center of view
   */ View.prototype.setCenter = function(centerCoord, api) {
        if (!centerCoord) return;
        this._center = [
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(centerCoord[0], api.getWidth()),
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(centerCoord[1], api.getHeight())
        ];
        this._updateCenterAndZoom();
    };
    View.prototype.setZoom = function(zoom) {
        zoom = zoom || 1;
        var zoomLimit = this.zoomLimit;
        if (zoomLimit) {
            if (zoomLimit.max != null) zoom = Math.min(zoomLimit.max, zoom);
            if (zoomLimit.min != null) zoom = Math.max(zoomLimit.min, zoom);
        }
        this._zoom = zoom;
        this._updateCenterAndZoom();
    };
    /**
   * Get default center without roam
   */ View.prototype.getDefaultCenter = function() {
        // Rect before any transform
        var rawRect = this.getBoundingRect();
        var cx = rawRect.x + rawRect.width / 2;
        var cy = rawRect.y + rawRect.height / 2;
        return [
            cx,
            cy
        ];
    };
    View.prototype.getCenter = function() {
        return this._center || this.getDefaultCenter();
    };
    View.prototype.getZoom = function() {
        return this._zoom || 1;
    };
    View.prototype.getRoamTransform = function() {
        return this._roamTransformable.getLocalTransform();
    };
    /**
   * Remove roam
   */ View.prototype._updateCenterAndZoom = function() {
        // Must update after view transform updated
        var rawTransformMatrix = this._rawTransformable.getLocalTransform();
        var roamTransform = this._roamTransformable;
        var defaultCenter = this.getDefaultCenter();
        var center = this.getCenter();
        var zoom = this.getZoom();
        center = $3dde7d051fe20daa$export$9f9dcb98c894b623([], center, rawTransformMatrix);
        defaultCenter = $3dde7d051fe20daa$export$9f9dcb98c894b623([], defaultCenter, rawTransformMatrix);
        roamTransform.originX = center[0];
        roamTransform.originY = center[1];
        roamTransform.x = defaultCenter[0] - center[0];
        roamTransform.y = defaultCenter[1] - center[1];
        roamTransform.scaleX = roamTransform.scaleY = zoom;
        this._updateTransform();
    };
    /**
   * Update transform props on `this` based on the current
   * `this._roamTransformable` and `this._rawTransformable`.
   */ View.prototype._updateTransform = function() {
        var roamTransformable = this._roamTransformable;
        var rawTransformable = this._rawTransformable;
        rawTransformable.parent = roamTransformable;
        roamTransformable.updateTransform();
        rawTransformable.updateTransform();
        $78537c687449356c$export$784d13d8ee351f07(this.transform || (this.transform = []), rawTransformable.transform || $78537c687449356c$export$185802fd694ee1f5());
        this._rawTransform = rawTransformable.getLocalTransform();
        this.invTransform = this.invTransform || [];
        $78537c687449356c$export$6897c284b6f9f4dc(this.invTransform, this.transform);
        this.decomposeTransform();
    };
    View.prototype.getTransformInfo = function() {
        var rawTransformable = this._rawTransformable;
        var roamTransformable = this._roamTransformable;
        // Because roamTransformabel has `originX/originY` modified,
        // but the caller of `getTransformInfo` can not handle `originX/originY`,
        // so need to recalculate them.
        var dummyTransformable = new (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039)();
        dummyTransformable.transform = roamTransformable.transform;
        dummyTransformable.decomposeTransform();
        return {
            roam: {
                x: dummyTransformable.x,
                y: dummyTransformable.y,
                scaleX: dummyTransformable.scaleX,
                scaleY: dummyTransformable.scaleY
            },
            raw: {
                x: rawTransformable.x,
                y: rawTransformable.y,
                scaleX: rawTransformable.scaleX,
                scaleY: rawTransformable.scaleY
            }
        };
    };
    View.prototype.getViewRect = function() {
        return this._viewRect;
    };
    /**
   * Get view rect after roam transform
   */ View.prototype.getViewRectAfterRoam = function() {
        var rect = this.getBoundingRect().clone();
        rect.applyTransform(this.transform);
        return rect;
    };
    /**
   * Convert a single (lon, lat) data item to (x, y) point.
   */ View.prototype.dataToPoint = function(data, noRoam, out) {
        var transform = noRoam ? this._rawTransform : this.transform;
        out = out || [];
        return transform ? $6713d37ec624c52a$var$v2ApplyTransform(out, data, transform) : $3dde7d051fe20daa$export$784d13d8ee351f07(out, data);
    };
    /**
   * Convert a (x, y) point to (lon, lat) data
   */ View.prototype.pointToData = function(point) {
        var invTransform = this.invTransform;
        return invTransform ? $6713d37ec624c52a$var$v2ApplyTransform([], point, invTransform) : [
            point[0],
            point[1]
        ];
    };
    View.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $6713d37ec624c52a$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    View.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $6713d37ec624c52a$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    /**
   * @implements
   */ View.prototype.containPoint = function(point) {
        return this.getViewRectAfterRoam().contain(point[0], point[1]);
    };
    View.dimensions = [
        'x',
        'y'
    ];
    return View;
}((0, $cd11a033fc7d29e7$export$2e2bcd8739ae039));
function $6713d37ec624c52a$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    return seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
}
var $6713d37ec624c52a$export$2e2bcd8739ae039 = $6713d37ec624c52a$var$View;





var $b49435fc6ef60b52$var$GEO_DEFAULT_PARAMS = {
    'geoJSON': {
        aspectScale: 0.75,
        invertLongitute: true
    },
    'geoSVG': {
        aspectScale: 1,
        invertLongitute: false
    }
};
var $b49435fc6ef60b52$export$10dbc57975912e0f = [
    'lng',
    'lat'
];
var $b49435fc6ef60b52$var$Geo = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Geo, _super);
    function Geo(name, map, opt) {
        var _this = _super.call(this, name) || this;
        _this.dimensions = $b49435fc6ef60b52$export$10dbc57975912e0f;
        _this.type = 'geo';
        // Only store specified name coord via `addGeoCoord`.
        _this._nameCoordMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        _this.map = map;
        var projection = opt.projection;
        var source = (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).load(map, opt.nameMap, opt.nameProperty);
        var resource = (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).getGeoResource(map);
        var resourceType = _this.resourceType = resource ? resource.type : null;
        var regions = _this.regions = source.regions;
        var defaultParams = $b49435fc6ef60b52$var$GEO_DEFAULT_PARAMS[resource.type];
        _this._regionsMap = source.regionsMap;
        _this.regions = source.regions;
        _this.projection = projection;
        var boundingRect;
        if (projection) // Can't reuse the raw bounding rect
        for(var i = 0; i < regions.length; i++){
            var regionRect = regions[i].getBoundingRect(projection);
            boundingRect = boundingRect || regionRect.clone();
            boundingRect.union(regionRect);
        }
        else boundingRect = source.boundingRect;
        _this.setBoundingRect(boundingRect.x, boundingRect.y, boundingRect.width, boundingRect.height);
        // aspectScale and invertLongitute actually is the parameters default raw projection.
        // So we ignore them if projection is given.
        // Ignore default aspect scale if projection exits.
        _this.aspectScale = projection ? 1 : $1b239fc9d3a2f8ae$export$995e01f2f5c9d030(opt.aspectScale, defaultParams.aspectScale);
        // Not invert longitude if projection exits.
        _this._invertLongitute = projection ? false : defaultParams.invertLongitute;
        return _this;
    }
    Geo.prototype._transformTo = function(x, y, width, height) {
        var rect = this.getBoundingRect();
        var invertLongitute = this._invertLongitute;
        rect = rect.clone();
        if (invertLongitute) // Longitude is inverted.
        rect.y = -rect.y - rect.height;
        var rawTransformable = this._rawTransformable;
        rawTransformable.transform = rect.calculateTransform(new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(x, y, width, height));
        var rawParent = rawTransformable.parent;
        rawTransformable.parent = null;
        rawTransformable.decomposeTransform();
        rawTransformable.parent = rawParent;
        if (invertLongitute) rawTransformable.scaleY = -rawTransformable.scaleY;
        this._updateTransform();
    };
    Geo.prototype.getRegion = function(name) {
        return this._regionsMap.get(name);
    };
    Geo.prototype.getRegionByCoord = function(coord) {
        var regions = this.regions;
        for(var i = 0; i < regions.length; i++){
            var region = regions[i];
            if (region.type === 'geoJSON' && region.contain(coord)) return regions[i];
        }
    };
    /**
   * Add geoCoord for indexing by name
   */ Geo.prototype.addGeoCoord = function(name, geoCoord) {
        this._nameCoordMap.set(name, geoCoord);
    };
    /**
   * Get geoCoord by name
   */ Geo.prototype.getGeoCoord = function(name) {
        var region = this._regionsMap.get(name);
        // Calculate center only on demand.
        return this._nameCoordMap.get(name) || region && region.getCenter();
    };
    Geo.prototype.dataToPoint = function(data, noRoam, out) {
        if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(data)) // Map area name to geoCoord
        data = this.getGeoCoord(data);
        if (data) {
            var projection = this.projection;
            if (projection) // projection may return null point.
            data = projection.project(data);
            return data && this.projectedToPoint(data, noRoam, out);
        }
    };
    Geo.prototype.pointToData = function(point) {
        var projection = this.projection;
        if (projection) // projection may return null point.
        point = projection.unproject(point);
        return point && this.pointToProjected(point);
    };
    /**
   * Point to projected data. Same with pointToData when projection is used.
   */ Geo.prototype.pointToProjected = function(point) {
        return _super.prototype.pointToData.call(this, point);
    };
    Geo.prototype.projectedToPoint = function(projected, noRoam, out) {
        return _super.prototype.dataToPoint.call(this, projected, noRoam, out);
    };
    Geo.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $b49435fc6ef60b52$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Geo.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $b49435fc6ef60b52$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    return Geo;
}((0, $6713d37ec624c52a$export$2e2bcd8739ae039));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($b49435fc6ef60b52$var$Geo, (0, $6713d37ec624c52a$export$2e2bcd8739ae039));
function $b49435fc6ef60b52$var$getCoordSys(finder) {
    var geoModel = finder.geoModel;
    var seriesModel = finder.seriesModel;
    return geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map series.
     || (seriesModel.getReferringComponents('geo', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0] || {}).coordinateSystem : null;
}
var $b49435fc6ef60b52$export$2e2bcd8739ae039 = $b49435fc6ef60b52$var$Geo;






/**
 * Resize method bound to the geo
 */ function $1e06be8fcfd03d9a$var$resizeGeo(geoModel, api) {
    var boundingCoords = geoModel.get('boundingCoords');
    if (boundingCoords != null) {
        var leftTop_1 = boundingCoords[0];
        var rightBottom_1 = boundingCoords[1];
        if (!(isFinite(leftTop_1[0]) && isFinite(leftTop_1[1]) && isFinite(rightBottom_1[0]) && isFinite(rightBottom_1[1]))) ;
        else {
            // Sample around the lng/lat rect and use projection to calculate actual bounding rect.
            var projection_1 = this.projection;
            if (projection_1) {
                var xMin = leftTop_1[0];
                var yMin = leftTop_1[1];
                var xMax = rightBottom_1[0];
                var yMax = rightBottom_1[1];
                leftTop_1 = [
                    Infinity,
                    Infinity
                ];
                rightBottom_1 = [
                    -Infinity,
                    -Infinity
                ];
                // TODO better way?
                var sampleLine = function(x0, y0, x1, y1) {
                    var dx = x1 - x0;
                    var dy = y1 - y0;
                    for(var i = 0; i <= 100; i++){
                        var p = i / 100;
                        var pt = projection_1.project([
                            x0 + dx * p,
                            y0 + dy * p
                        ]);
                        $3dde7d051fe20daa$export$96ec731ed4dcb222(leftTop_1, leftTop_1, pt);
                        $3dde7d051fe20daa$export$8960430cfd85939f(rightBottom_1, rightBottom_1, pt);
                    }
                };
                // Top
                sampleLine(xMin, yMin, xMax, yMin);
                // Right
                sampleLine(xMax, yMin, xMax, yMax);
                // Bottom
                sampleLine(xMax, yMax, xMin, yMax);
                // Left
                sampleLine(xMin, yMax, xMax, yMin);
            }
            this.setBoundingRect(leftTop_1[0], leftTop_1[1], rightBottom_1[0] - leftTop_1[0], rightBottom_1[1] - leftTop_1[1]);
        }
    }
    var rect = this.getBoundingRect();
    var centerOption = geoModel.get('layoutCenter');
    var sizeOption = geoModel.get('layoutSize');
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    var aspect = rect.width / rect.height * this.aspectScale;
    var useCenterAndSize = false;
    var center;
    var size;
    if (centerOption && sizeOption) {
        center = [
            $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(centerOption[0], viewWidth),
            $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(centerOption[1], viewHeight)
        ];
        size = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(sizeOption, Math.min(viewWidth, viewHeight));
        if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) useCenterAndSize = true;
    }
    var viewRect;
    if (useCenterAndSize) {
        viewRect = {};
        if (aspect > 1) {
            // Width is same with size
            viewRect.width = size;
            viewRect.height = size / aspect;
        } else {
            viewRect.height = size;
            viewRect.width = size * aspect;
        }
        viewRect.y = center[1] - viewRect.height / 2;
        viewRect.x = center[0] - viewRect.width / 2;
    } else {
        // Use left/top/width/height
        var boxLayoutOption = geoModel.getBoxLayoutParams();
        boxLayoutOption.aspect = aspect;
        viewRect = $501dc28f6c4d24ac$export$4517a5ca639a7293(boxLayoutOption, {
            width: viewWidth,
            height: viewHeight
        });
    }
    this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
    this.setCenter(geoModel.get('center'), api);
    this.setZoom(geoModel.get('zoom'));
}
// Back compat for ECharts2, where the coord map is set on map series:
// {type: 'map', geoCoord: {'cityA': [116.46,39.92], 'cityA': [119.12,24.61]}},
function $1e06be8fcfd03d9a$var$setGeoCoords(geo, model) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(model.get('geoCoord'), function(geoCoord, name) {
        geo.addGeoCoord(name, geoCoord);
    });
}
var $1e06be8fcfd03d9a$var$GeoCreator = /** @class */ function() {
    function GeoCreator() {
        // For deciding which dimensions to use when creating list data
        this.dimensions = (0, $b49435fc6ef60b52$export$10dbc57975912e0f);
    }
    GeoCreator.prototype.create = function(ecModel, api) {
        var geoList = [];
        function getCommonGeoProperties(model) {
            return {
                nameProperty: model.get('nameProperty'),
                aspectScale: model.get('aspectScale'),
                projection: model.get('projection')
            };
        }
        // FIXME Create each time may be slow
        ecModel.eachComponent('geo', function(geoModel, idx) {
            var mapName = geoModel.get('map');
            var geo = new (0, $b49435fc6ef60b52$export$2e2bcd8739ae039)(mapName + idx, mapName, $1b239fc9d3a2f8ae$export$8b58be045bf06082({
                nameMap: geoModel.get('nameMap')
            }, getCommonGeoProperties(geoModel)));
            geo.zoomLimit = geoModel.get('scaleLimit');
            geoList.push(geo);
            // setGeoCoords(geo, geoModel);
            geoModel.coordinateSystem = geo;
            geo.model = geoModel;
            // Inject resize method
            geo.resize = $1e06be8fcfd03d9a$var$resizeGeo;
            geo.resize(geoModel, api);
        });
        ecModel.eachSeries(function(seriesModel) {
            var coordSys = seriesModel.get('coordinateSystem');
            if (coordSys === 'geo') {
                var geoIndex = seriesModel.get('geoIndex') || 0;
                seriesModel.coordinateSystem = geoList[geoIndex];
            }
        });
        // If has map series
        var mapModelGroupBySeries = {};
        ecModel.eachSeriesByType('map', function(seriesModel) {
            if (!seriesModel.getHostGeoModel()) {
                var mapType = seriesModel.getMapType();
                mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
                mapModelGroupBySeries[mapType].push(seriesModel);
            }
        });
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(mapModelGroupBySeries, function(mapSeries, mapType) {
            var nameMapList = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get('nameMap');
            });
            var geo = new (0, $b49435fc6ef60b52$export$2e2bcd8739ae039)(mapType, mapType, $1b239fc9d3a2f8ae$export$8b58be045bf06082({
                nameMap: $1b239fc9d3a2f8ae$export$18aef43295bbe906(nameMapList)
            }, getCommonGeoProperties(mapSeries[0])));
            geo.zoomLimit = $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66.apply(null, $1b239fc9d3a2f8ae$export$871de8747c9eaa88(mapSeries, function(singleMapSeries) {
                return singleMapSeries.get('scaleLimit');
            }));
            geoList.push(geo);
            // Inject resize method
            geo.resize = $1e06be8fcfd03d9a$var$resizeGeo;
            geo.resize(mapSeries[0], api);
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(mapSeries, function(singleMapSeries) {
                singleMapSeries.coordinateSystem = geo;
                $1e06be8fcfd03d9a$var$setGeoCoords(geo, singleMapSeries);
            });
        });
        return geoList;
    };
    /**
   * Fill given regions array
   */ GeoCreator.prototype.getFilledRegions = function(originRegionArr, mapName, nameMap, nameProperty) {
        // Not use the original
        var regionsArr = (originRegionArr || []).slice();
        var dataNameMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        for(var i = 0; i < regionsArr.length; i++)dataNameMap.set(regionsArr[i].name, regionsArr[i]);
        var source = (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).load(mapName, nameMap, nameProperty);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(source.regions, function(region) {
            var name = region.name;
            var regionOption = dataNameMap.get(name);
            // apply specified echarts style in GeoJSON data
            var specifiedGeoJSONRegionStyle = region.properties && region.properties.echartsStyle;
            if (!regionOption) {
                regionOption = {
                    name: name
                };
                regionsArr.push(regionOption);
            }
            specifiedGeoJSONRegionStyle && $1b239fc9d3a2f8ae$export$4950aa0f605343fb(regionOption, specifiedGeoJSONRegionStyle);
        });
        return regionsArr;
    };
    return GeoCreator;
}();
var $1e06be8fcfd03d9a$var$geoCreator = new $1e06be8fcfd03d9a$var$GeoCreator();
var $1e06be8fcfd03d9a$export$2e2bcd8739ae039 = $1e06be8fcfd03d9a$var$geoCreator;



var $8a7e5db1c951506d$var$GeoModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GeoModel, _super);
    function GeoModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoModel.type;
        return _this;
    }
    GeoModel.prototype.init = function(option, parentModel, ecModel) {
        var source = (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).getGeoResource(option.map);
        if (source && source.type === 'geoJSON') {
            var itemStyle = option.itemStyle = option.itemStyle || {};
            if (!('color' in itemStyle)) itemStyle.color = '#eee';
        }
        this.mergeDefaultAndTheme(option, ecModel);
        // Default label emphasis `show`
        $9ac03c46e8b6e711$export$abdcc6a26372f94b(option, 'label', [
            'show'
        ]);
    };
    GeoModel.prototype.optionUpdated = function() {
        var _this = this;
        var option = this.option;
        option.regions = (0, $1e06be8fcfd03d9a$export$2e2bcd8739ae039).getFilledRegions(option.regions, option.map, option.nameMap, option.nameProperty);
        var selectedMap = {};
        this._optionModelMap = $1b239fc9d3a2f8ae$export$533b26079ad0b4b(option.regions || [], function(optionModelMap, regionOpt) {
            var regionName = regionOpt.name;
            if (regionName) {
                optionModelMap.set(regionName, new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(regionOpt, _this, _this.ecModel));
                if (regionOpt.selected) selectedMap[regionName] = true;
            }
            return optionModelMap;
        }, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4());
        if (!option.selectedMap) option.selectedMap = selectedMap;
    };
    /**
   * Get model of region.
   */ GeoModel.prototype.getRegionModel = function(name) {
        return this._optionModelMap.get(name) || new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(null, this, this.ecModel);
    };
    /**
   * Format label
   * @param name Region name
   */ GeoModel.prototype.getFormattedLabel = function(name, status) {
        var regionModel = this.getRegionModel(name);
        var formatter = status === 'normal' ? regionModel.get([
            'label',
            'formatter'
        ]) : regionModel.get([
            'emphasis',
            'label',
            'formatter'
        ]);
        var params = {
            name: name
        };
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(formatter)) {
            params.status = status;
            return formatter(params);
        } else if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(formatter)) return formatter.replace('{a}', name != null ? name : '');
    };
    GeoModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GeoModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    // PENGING If selectedMode is null ?
    GeoModel.prototype.select = function(name) {
        var option = this.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        if (selectedMode !== 'multiple') option.selectedMap = null;
        var selectedMap = option.selectedMap || (option.selectedMap = {});
        selectedMap[name] = true;
    };
    GeoModel.prototype.unSelect = function(name) {
        var selectedMap = this.option.selectedMap;
        if (selectedMap) selectedMap[name] = false;
    };
    GeoModel.prototype.toggleSelected = function(name) {
        this[this.isSelected(name) ? 'unSelect' : 'select'](name);
    };
    GeoModel.prototype.isSelected = function(name) {
        var selectedMap = this.option.selectedMap;
        return !!(selectedMap && selectedMap[name]);
    };
    GeoModel.type = 'geo';
    GeoModel.layoutMode = 'box';
    GeoModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        show: true,
        left: 'center',
        top: 'center',
        // Default value:
        // for geoSVG source: 1,
        // for geoJSON source: 0.75.
        aspectScale: null,
        // /// Layout with center and size
        // If you want to put map in a fixed size box with right aspect ratio
        // This two properties may be more convenient
        // layoutCenter: [50%, 50%]
        // layoutSize: 100
        silent: false,
        // Map type
        map: '',
        // Define left-top, right-bottom coords to control view
        // For example, [ [180, 90], [-180, -90] ]
        boundingCoords: null,
        // Default on center of map
        center: null,
        zoom: 1,
        scaleLimit: null,
        // selectedMode: false
        label: {
            show: false,
            color: '#000'
        },
        itemStyle: {
            borderWidth: 0.5,
            borderColor: '#444'
        },
        emphasis: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                color: 'rgba(255,215,0,0.8)'
            }
        },
        select: {
            label: {
                show: true,
                color: 'rgb(100,0,0)'
            },
            itemStyle: {
                color: 'rgba(255,215,0,0.8)'
            }
        },
        regions: []
    };
    return GeoModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $8a7e5db1c951506d$export$2e2bcd8739ae039 = $8a7e5db1c951506d$var$GeoModel;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $4ae3ee9cd93604f8$var$getCenterCoord(view, point) {
    // Use projected coord as center because it's linear.
    return view.pointToProjected ? view.pointToProjected(point) : view.pointToData(point);
}
function $4ae3ee9cd93604f8$export$797ecc50d262ebd8(view, payload, zoomLimit, api) {
    var previousZoom = view.getZoom();
    var center = view.getCenter();
    var zoom = payload.zoom;
    var point = view.projectedToPoint ? view.projectedToPoint(center) : view.dataToPoint(center);
    if (payload.dx != null && payload.dy != null) {
        point[0] -= payload.dx;
        point[1] -= payload.dy;
        view.setCenter($4ae3ee9cd93604f8$var$getCenterCoord(view, point), api);
    }
    if (zoom != null) {
        if (zoomLimit) {
            var zoomMin = zoomLimit.min || 0;
            var zoomMax = zoomLimit.max || Infinity;
            zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
        }
        // Zoom on given point(originX, originY)
        view.scaleX *= zoom;
        view.scaleY *= zoom;
        var fixX = (payload.originX - view.x) * (zoom - 1);
        var fixY = (payload.originY - view.y) * (zoom - 1);
        view.x -= fixX;
        view.y -= fixY;
        view.updateTransform();
        // Get the new center
        view.setCenter($4ae3ee9cd93604f8$var$getCenterCoord(view, point), api);
        view.setZoom(zoom * previousZoom);
    }
    return {
        center: view.getCenter(),
        zoom: view.getZoom()
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $bd0d497aecec0ccf$var$GeoView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GeoView, _super);
    function GeoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GeoView.type;
        _this.focusBlurEnabled = true;
        return _this;
    }
    GeoView.prototype.init = function(ecModel, api) {
        this._api = api;
    };
    GeoView.prototype.render = function(geoModel, ecModel, api, payload) {
        this._model = geoModel;
        if (!geoModel.get('show')) {
            this._mapDraw && this._mapDraw.remove();
            this._mapDraw = null;
            return;
        }
        if (!this._mapDraw) this._mapDraw = new (0, $f8d0aa06849f0cb3$export$2e2bcd8739ae039)(api);
        var mapDraw = this._mapDraw;
        mapDraw.draw(geoModel, ecModel, api, this, payload);
        mapDraw.group.on('click', this._handleRegionClick, this);
        mapDraw.group.silent = geoModel.get('silent');
        this.group.add(mapDraw.group);
        this.updateSelectStatus(geoModel, ecModel, api);
    };
    GeoView.prototype._handleRegionClick = function(e) {
        var eventData;
        (0, $ee614fdac89517fb$export$8a4fca9e04eb4df6)(e.target, function(current) {
            return (eventData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(current).eventData) != null;
        }, true);
        if (eventData) this._api.dispatchAction({
            type: 'geoToggleSelect',
            geoId: this._model.id,
            name: eventData.name
        });
    };
    GeoView.prototype.updateSelectStatus = function(model, ecModel, api) {
        var _this = this;
        this._mapDraw.group.traverse(function(node) {
            var eventData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(node).eventData;
            if (eventData) {
                _this._model.isSelected(eventData.name) ? api.enterSelect(node) : api.leaveSelect(node);
                // No need to traverse children.
                return true;
            }
        });
    };
    GeoView.prototype.findHighDownDispatchers = function(name) {
        return this._mapDraw && this._mapDraw.findHighDownDispatchers(name, this._model);
    };
    GeoView.prototype.dispose = function() {
        this._mapDraw && this._mapDraw.remove();
    };
    GeoView.type = 'geo';
    return GeoView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $bd0d497aecec0ccf$export$2e2bcd8739ae039 = $bd0d497aecec0ccf$var$GeoView;



function $cd1245ce0ea8a98b$var$registerMap(mapName, geoJson, specialAreas) {
    (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).registerMap(mapName, geoJson, specialAreas);
}
function $cd1245ce0ea8a98b$export$4b3e715f166fdd78(registers) {
    registers.registerCoordinateSystem('geo', (0, $1e06be8fcfd03d9a$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $8a7e5db1c951506d$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $bd0d497aecec0ccf$export$2e2bcd8739ae039));
    registers.registerImpl('registerMap', $cd1245ce0ea8a98b$var$registerMap);
    registers.registerImpl('getMap', function(mapName) {
        return (0, $30ff5c6f9e262156$export$2e2bcd8739ae039).getMapForUser(mapName);
    });
    function makeAction(method, actionInfo) {
        actionInfo.update = 'geo:updateSelectStatus';
        registers.registerAction(actionInfo, function(payload, ecModel) {
            var selected = {};
            var allSelected = [];
            ecModel.eachComponent({
                mainType: 'geo',
                query: payload
            }, function(geoModel) {
                geoModel[method](payload.name);
                var geo = geoModel.coordinateSystem;
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(geo.regions, function(region) {
                    selected[region.name] = geoModel.isSelected(region.name) || false;
                });
                // Notice: there might be duplicated name in different regions.
                var names = [];
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(selected, function(v, name) {
                    selected[name] && names.push(name);
                });
                allSelected.push({
                    geoIndex: geoModel.componentIndex,
                    // Use singular, the same naming convention as the event `selectchanged`.
                    name: names
                });
            });
            return {
                selected: selected,
                allSelected: allSelected,
                name: payload.name
            };
        });
    }
    makeAction('toggleSelected', {
        type: 'geoToggleSelect',
        event: 'geoselectchanged'
    });
    makeAction('select', {
        type: 'geoSelect',
        event: 'geoselected'
    });
    makeAction('unSelect', {
        type: 'geoUnSelect',
        event: 'geounselected'
    });
    /**
   * @payload
   * @property {string} [componentType=series]
   * @property {number} [dx]
   * @property {number} [dy]
   * @property {number} [zoom]
   * @property {number} [originX]
   * @property {number} [originY]
   */ registers.registerAction({
        type: 'geoRoam',
        event: 'geoRoam',
        update: 'updateTransform'
    }, function(payload, ecModel, api) {
        var componentType = payload.componentType || 'series';
        ecModel.eachComponent({
            mainType: componentType,
            query: payload
        }, function(componentModel) {
            var geo = componentModel.coordinateSystem;
            if (geo.type !== 'geo') return;
            var res = (0, $4ae3ee9cd93604f8$export$797ecc50d262ebd8)(geo, payload, componentModel.get('scaleLimit'), api);
            componentModel.setCenter && componentModel.setCenter(res.center);
            componentModel.setZoom && componentModel.setZoom(res.zoom);
            // All map series with same `map` use the same geo coordinate system
            // So the center and zoom must be in sync. Include the series not selected by legend
            if (componentType === 'series') (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(componentModel.seriesGroup, function(seriesModel) {
                seriesModel.setCenter(res.center);
                seriesModel.setZoom(res.zoom);
            });
        });
    });
}


function $f204e5dbe71b9b2d$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $cd1245ce0ea8a98b$export$4b3e715f166fdd78));
    registers.registerChartView((0, $f9c26faeaa1cb045$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5258b5a09c385547$export$2e2bcd8739ae039));
    registers.registerLayout((0, $9ed6e6759c0745f5$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, (0, $431e427dee6cc5f5$export$2e2bcd8739ae039));
    (0, $4a2d4f3079e03ea2$export$62942ba95693dbfc)('map', registers.registerAction);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The tree layoutHelper implementation was originally copied from
* "d3.js"(https://github.com/d3/d3-hierarchy) with
* some modifications made for this project.
* (see more details in the comment of the specific method below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the licence of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ /**
 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
 *       the tree.
 */ 
function $e243d94cb2f9041d$export$2cd8252107eb640b(inRoot) {
    var root = inRoot;
    root.hierNode = {
        defaultAncestor: null,
        ancestor: root,
        prelim: 0,
        modifier: 0,
        change: 0,
        shift: 0,
        i: 0,
        thread: null
    };
    var nodes = [
        root
    ];
    var node;
    var children;
    while(node = nodes.pop()){
        // jshint ignore:line
        children = node.children;
        if (node.isExpand && children.length) {
            var n = children.length;
            for(var i = n - 1; i >= 0; i--){
                var child = children[i];
                child.hierNode = {
                    defaultAncestor: null,
                    ancestor: child,
                    prelim: 0,
                    modifier: 0,
                    change: 0,
                    shift: 0,
                    i: i,
                    thread: null
                };
                nodes.push(child);
            }
        }
    }
}
function $e243d94cb2f9041d$export$f7eff93d75358a2c(node, separation) {
    var children = node.isExpand ? node.children : [];
    var siblings = node.parentNode.children;
    var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
    if (children.length) {
        $e243d94cb2f9041d$var$executeShifts(node);
        var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
        if (subtreeW) {
            node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
            node.hierNode.modifier = node.hierNode.prelim - midPoint;
        } else node.hierNode.prelim = midPoint;
    } else if (subtreeW) node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
    node.parentNode.hierNode.defaultAncestor = $e243d94cb2f9041d$var$apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
}
function $e243d94cb2f9041d$export$39e6f19b1ce889be(node) {
    var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
    node.setLayout({
        x: nodeX
    }, true);
    node.hierNode.modifier += node.parentNode.hierNode.modifier;
}
function $e243d94cb2f9041d$export$3bf720ece7bc7b2e(cb) {
    return arguments.length ? cb : $e243d94cb2f9041d$var$defaultSeparation;
}
function $e243d94cb2f9041d$export$60198ec123d36099(rad, r) {
    rad -= Math.PI / 2;
    return {
        x: r * Math.cos(rad),
        y: r * Math.sin(rad)
    };
}
function $e243d94cb2f9041d$export$c02eeb5f98d59b89(seriesModel, api) {
    return $501dc28f6c4d24ac$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
/**
 * All other shifts, applied to the smaller subtrees between w- and w+, are
 * performed by this function.
 *
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $e243d94cb2f9041d$var$executeShifts(node) {
    var children = node.children;
    var n = children.length;
    var shift = 0;
    var change = 0;
    while(--n >= 0){
        var child = children[n];
        child.hierNode.prelim += shift;
        child.hierNode.modifier += shift;
        change += child.hierNode.change;
        shift += child.hierNode.shift + change;
    }
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * The core of the algorithm. Here, a new subtree is combined with the
 * previous subtrees. Threads are used to traverse the inside and outside
 * contours of the left and right subtree up to the highest common level.
 * Whenever two nodes of the inside contours conflict, we compute the left
 * one of the greatest uncommon ancestors using the function nextAncestor()
 * and call moveSubtree() to shift the subtree and prepare the shifts of
 * smaller subtrees. Finally, we add a new thread (if necessary).
 */ function $e243d94cb2f9041d$var$apportion(subtreeV, subtreeW, ancestor, separation) {
    if (subtreeW) {
        var nodeOutRight = subtreeV;
        var nodeInRight = subtreeV;
        var nodeOutLeft = nodeInRight.parentNode.children[0];
        var nodeInLeft = subtreeW;
        var sumOutRight = nodeOutRight.hierNode.modifier;
        var sumInRight = nodeInRight.hierNode.modifier;
        var sumOutLeft = nodeOutLeft.hierNode.modifier;
        var sumInLeft = nodeInLeft.hierNode.modifier;
        while(nodeInLeft = $e243d94cb2f9041d$var$nextRight(nodeInLeft), nodeInRight = $e243d94cb2f9041d$var$nextLeft(nodeInRight), nodeInLeft && nodeInRight){
            nodeOutRight = $e243d94cb2f9041d$var$nextRight(nodeOutRight);
            nodeOutLeft = $e243d94cb2f9041d$var$nextLeft(nodeOutLeft);
            nodeOutRight.hierNode.ancestor = subtreeV;
            var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
            if (shift > 0) {
                $e243d94cb2f9041d$var$moveSubtree($e243d94cb2f9041d$var$nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
                sumInRight += shift;
                sumOutRight += shift;
            }
            sumInLeft += nodeInLeft.hierNode.modifier;
            sumInRight += nodeInRight.hierNode.modifier;
            sumOutRight += nodeOutRight.hierNode.modifier;
            sumOutLeft += nodeOutLeft.hierNode.modifier;
        }
        if (nodeInLeft && !$e243d94cb2f9041d$var$nextRight(nodeOutRight)) {
            nodeOutRight.hierNode.thread = nodeInLeft;
            nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
        }
        if (nodeInRight && !$e243d94cb2f9041d$var$nextLeft(nodeOutLeft)) {
            nodeOutLeft.hierNode.thread = nodeInRight;
            nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
            ancestor = subtreeV;
        }
    }
    return ancestor;
}
/**
 * This function is used to traverse the right contour of a subtree.
 * It returns the rightmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $e243d94cb2f9041d$var$nextRight(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
}
/**
 * This function is used to traverse the left contour of a subtree (or a subforest).
 * It returns the leftmost child of node or the thread of node. The function
 * returns null if and only if node is on the highest depth of its subtree.
 */ function $e243d94cb2f9041d$var$nextLeft(node) {
    var children = node.children;
    return children.length && node.isExpand ? children[0] : node.hierNode.thread;
}
/**
 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
 * Otherwise, returns the specified ancestor.
 */ function $e243d94cb2f9041d$var$nextAncestor(nodeInLeft, node, ancestor) {
    return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * Shifts the current subtree rooted at wr.
 * This is done by increasing prelim(w+) and modifier(w+) by shift.
 */ function $e243d94cb2f9041d$var$moveSubtree(wl, wr, shift) {
    var change = shift / (wr.hierNode.i - wl.hierNode.i);
    wr.hierNode.change -= change;
    wr.hierNode.shift += shift;
    wr.hierNode.modifier += shift;
    wr.hierNode.prelim += shift;
    wl.hierNode.change += change;
}
/**
 * The implementation of this function was originally copied from "d3.js"
 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 */ function $e243d94cb2f9041d$var$defaultSeparation(node1, node2) {
    return node1.parentNode === node2.parentNode ? 1 : 2;
}











var $6361679824bbf999$var$TreeEdgeShape = /** @class */ function() {
    function TreeEdgeShape() {
        this.parentPoint = [];
        this.childPoints = [];
    }
    return TreeEdgeShape;
}();
var $6361679824bbf999$var$TreePath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TreePath, _super);
    function TreePath(opts) {
        return _super.call(this, opts) || this;
    }
    TreePath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    TreePath.prototype.getDefaultShape = function() {
        return new $6361679824bbf999$var$TreeEdgeShape();
    };
    TreePath.prototype.buildPath = function(ctx, shape) {
        var childPoints = shape.childPoints;
        var childLen = childPoints.length;
        var parentPoint = shape.parentPoint;
        var firstChildPos = childPoints[0];
        var lastChildPos = childPoints[childLen - 1];
        if (childLen === 1) {
            ctx.moveTo(parentPoint[0], parentPoint[1]);
            ctx.lineTo(firstChildPos[0], firstChildPos[1]);
            return;
        }
        var orient = shape.orient;
        var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
        var otherDim = 1 - forkDim;
        var forkPosition = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(shape.forkPosition, 1);
        var tmpPoint = [];
        tmpPoint[forkDim] = parentPoint[forkDim];
        tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
        ctx.moveTo(parentPoint[0], parentPoint[1]);
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.moveTo(firstChildPos[0], firstChildPos[1]);
        tmpPoint[forkDim] = firstChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        tmpPoint[forkDim] = lastChildPos[forkDim];
        ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        ctx.lineTo(lastChildPos[0], lastChildPos[1]);
        for(var i = 1; i < childLen - 1; i++){
            var point = childPoints[i];
            ctx.moveTo(point[0], point[1]);
            tmpPoint[forkDim] = point[forkDim];
            ctx.lineTo(tmpPoint[0], tmpPoint[1]);
        }
    };
    return TreePath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
var $6361679824bbf999$var$TreeView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TreeView, _super);
    function TreeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreeView.type;
        _this._mainGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        return _this;
    }
    TreeView.prototype.init = function(ecModel, api) {
        this._controller = new (0, $36ebde58055237cc$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: this.group
        };
        this.group.add(this._mainGroup);
    };
    TreeView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var layoutInfo = seriesModel.layoutInfo;
        var group = this._mainGroup;
        var layout = seriesModel.get('layout');
        if (layout === 'radial') {
            group.x = layoutInfo.x + layoutInfo.width / 2;
            group.y = layoutInfo.y + layoutInfo.height / 2;
        } else {
            group.x = layoutInfo.x;
            group.y = layoutInfo.y;
        }
        this._updateViewCoordSys(seriesModel, api);
        this._updateController(seriesModel, ecModel, api);
        var oldData = this._data;
        data.diff(oldData).add(function(newIdx) {
            if ($6361679824bbf999$var$symbolNeedsDraw(data, newIdx)) // Create node and edge
            $6361679824bbf999$var$updateNode(data, newIdx, null, group, seriesModel);
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            if (!$6361679824bbf999$var$symbolNeedsDraw(data, newIdx)) {
                symbolEl && $6361679824bbf999$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
                return;
            }
            // Update node and edge
            $6361679824bbf999$var$updateNode(data, newIdx, symbolEl, group, seriesModel);
        }).remove(function(oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // When remove a collapsed node of subtree, since the collapsed
            // node haven't been initialized with a symbol element,
            // you can't found it's symbol element through index.
            // so if we want to remove the symbol element we should insure
            // that the symbol element is not null.
            if (symbolEl) $6361679824bbf999$var$removeNode(oldData, oldIdx, symbolEl, group, seriesModel);
        }).execute();
        this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
        this._updateNodeAndLinkScale(seriesModel);
        if (seriesModel.get('expandAndCollapse') === true) data.eachItemGraphicEl(function(el, dataIndex) {
            el.off('click').on('click', function() {
                api.dispatchAction({
                    type: 'treeExpandAndCollapse',
                    seriesId: seriesModel.id,
                    dataIndex: dataIndex
                });
            });
        });
        this._data = data;
    };
    TreeView.prototype._updateViewCoordSys = function(seriesModel, api) {
        var data = seriesModel.getData();
        var points = [];
        data.each(function(idx) {
            var layout = data.getItemLayout(idx);
            if (layout && !isNaN(layout.x) && !isNaN(layout.y)) points.push([
                +layout.x,
                +layout.y
            ]);
        });
        var min = [];
        var max = [];
        $9757a65ec1dd85b5$export$188c3cd07b4129dd(points, min, max);
        // If don't Store min max when collapse the root node after roam,
        // the root node will disappear.
        var oldMin = this._min;
        var oldMax = this._max;
        // If width or height is 0
        if (max[0] - min[0] === 0) {
            min[0] = oldMin ? oldMin[0] : min[0] - 1;
            max[0] = oldMax ? oldMax[0] : max[0] + 1;
        }
        if (max[1] - min[1] === 0) {
            min[1] = oldMin ? oldMin[1] : min[1] - 1;
            max[1] = oldMax ? oldMax[1] : max[1] + 1;
        }
        var viewCoordSys = seriesModel.coordinateSystem = new (0, $6713d37ec624c52a$export$2e2bcd8739ae039)();
        viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
        viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
        viewCoordSys.setCenter(seriesModel.get('center'), api);
        viewCoordSys.setZoom(seriesModel.get('zoom'));
        // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
        this.group.attr({
            x: viewCoordSys.x,
            y: viewCoordSys.y,
            scaleX: viewCoordSys.scaleX,
            scaleY: viewCoordSys.scaleY
        });
        this._min = min;
        this._max = max;
    };
    TreeView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $644ca0c6add6ebe3$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        controller.enable(seriesModel.get('roam'));
        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off('pan').off('zoom').on('pan', function(e) {
            $77c59df9b4754854$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'treeRoam',
                dx: e.dx,
                dy: e.dy
            });
        }).on('zoom', function(e) {
            $77c59df9b4754854$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'treeRoam',
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale(seriesModel);
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    TreeView.prototype._updateNodeAndLinkScale = function(seriesModel) {
        var data = seriesModel.getData();
        var nodeScale = this._getNodeGlobalScale(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el.setSymbolScale(nodeScale);
        });
    };
    TreeView.prototype._getNodeGlobalScale = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type !== 'view') return 1;
        var nodeScaleRatio = this._nodeScaleRatio;
        var groupZoom = coordSys.scaleX || 1;
        // Scale node when zoom changes
        var roamZoom = coordSys.getZoom();
        var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
        return nodeScale / groupZoom;
    };
    TreeView.prototype.dispose = function() {
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    TreeView.prototype.remove = function() {
        this._mainGroup.removeAll();
        this._data = null;
    };
    TreeView.type = 'tree';
    return TreeView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
function $6361679824bbf999$var$symbolNeedsDraw(data, dataIndex) {
    var layout = data.getItemLayout(dataIndex);
    return layout && !isNaN(layout.x) && !isNaN(layout.y);
}
function $6361679824bbf999$var$updateNode(data, dataIndex, symbolEl, group, seriesModel) {
    var isInit = !symbolEl;
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var itemModel = node.getModel();
    var visualColor = node.getVisual('style').fill;
    var symbolInnerColor = node.isExpand === false && node.children.length !== 0 ? visualColor : '#fff';
    var virtualRoot = data.tree.root;
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceLayout = source.getLayout();
    var sourceOldLayout = sourceSymbolEl ? {
        x: sourceSymbolEl.__oldX,
        y: sourceSymbolEl.__oldY,
        rawX: sourceSymbolEl.__radialOldRawX,
        rawY: sourceSymbolEl.__radialOldRawY
    } : sourceLayout;
    var targetLayout = node.getLayout();
    if (isInit) {
        symbolEl = new (0, $6864622a33ae23ca$export$2e2bcd8739ae039)(data, dataIndex, null, {
            symbolInnerColor: symbolInnerColor,
            useNameLabel: true
        });
        symbolEl.x = sourceOldLayout.x;
        symbolEl.y = sourceOldLayout.y;
    } else symbolEl.updateData(data, dataIndex, null, {
        symbolInnerColor: symbolInnerColor,
        useNameLabel: true
    });
    symbolEl.__radialOldRawX = symbolEl.__radialRawX;
    symbolEl.__radialOldRawY = symbolEl.__radialRawY;
    symbolEl.__radialRawX = targetLayout.rawX;
    symbolEl.__radialRawY = targetLayout.rawY;
    group.add(symbolEl);
    data.setItemGraphicEl(dataIndex, symbolEl);
    symbolEl.__oldX = symbolEl.x;
    symbolEl.__oldY = symbolEl.y;
    $b40111164617dd60$export$c8dce3c08436e91e(symbolEl, {
        x: targetLayout.x,
        y: targetLayout.y
    }, seriesModel);
    var symbolPath = symbolEl.getSymbolPath();
    if (seriesModel.get('layout') === 'radial') {
        var realRoot = virtualRoot.children[0];
        var rootLayout = realRoot.getLayout();
        var length_1 = realRoot.children.length;
        var rad = void 0;
        var isLeft = void 0;
        if (targetLayout.x === rootLayout.x && node.isExpand === true && realRoot.children.length) {
            var center = {
                x: (realRoot.children[0].getLayout().x + realRoot.children[length_1 - 1].getLayout().x) / 2,
                y: (realRoot.children[0].getLayout().y + realRoot.children[length_1 - 1].getLayout().y) / 2
            };
            rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            isLeft = center.x < rootLayout.x;
            if (isLeft) rad = rad - Math.PI;
        } else {
            rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
            if (rad < 0) rad = Math.PI * 2 + rad;
            if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
                isLeft = targetLayout.x < rootLayout.x;
                if (isLeft) rad = rad - Math.PI;
            } else {
                isLeft = targetLayout.x > rootLayout.x;
                if (!isLeft) rad = rad - Math.PI;
            }
        }
        var textPosition = isLeft ? 'left' : 'right';
        var normalLabelModel = itemModel.getModel('label');
        var rotate = normalLabelModel.get('rotate');
        var labelRotateRadian = rotate * (Math.PI / 180);
        var textContent = symbolPath.getTextContent();
        if (textContent) {
            symbolPath.setTextConfig({
                position: normalLabelModel.get('position') || textPosition,
                rotation: rotate == null ? -rad : labelRotateRadian,
                origin: 'center'
            });
            textContent.setStyle('verticalAlign', 'middle');
        }
    }
    // Handle status
    var focus = itemModel.get([
        'emphasis',
        'focus'
    ]);
    var focusDataIndices = focus === 'relative' ? $1b239fc9d3a2f8ae$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : null;
    if (focusDataIndices) // Modify the focus to data indices.
    (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(symbolEl).focus = focusDataIndices;
    $6361679824bbf999$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group);
    if (symbolEl.__edge) symbolEl.onHoverStateChange = function(toState) {
        if (toState !== 'blur') {
            // NOTE: Ensure the parent elements will been blurred firstly.
            // According to the return of getAncestorsIndices and getDescendantIndices
            // TODO: A bit tricky.
            var parentEl = node.parentNode && data.getItemGraphicEl(node.parentNode.dataIndex);
            if (!(parentEl && parentEl.hoverState === (0, $b414df7d361a211c$export$1307d6a87d56baa))) (0, $b414df7d361a211c$export$868ba38adffa9e39)(symbolEl.__edge, toState);
        }
    };
}
function $6361679824bbf999$var$drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group) {
    var itemModel = node.getModel();
    var edgeShape = seriesModel.get('edgeShape');
    var layout = seriesModel.get('layout');
    var orient = seriesModel.getOrient();
    var curvature = seriesModel.get([
        'lineStyle',
        'curveness'
    ]);
    var edgeForkPosition = seriesModel.get('edgeForkPosition');
    var lineStyle = itemModel.getModel('lineStyle').getLineStyle();
    var edge = symbolEl.__edge;
    // curve edge from node -> parent
    // polyline edge from node -> children
    if (edgeShape === 'curve') {
        if (node.parentNode && node.parentNode !== virtualRoot) {
            if (!edge) edge = symbolEl.__edge = new $13bf9e04ebecd3f2$export$2e2bcd8739ae039({
                shape: $6361679824bbf999$var$getEdgeShape(layout, orient, curvature, sourceOldLayout, sourceOldLayout)
            });
            $b40111164617dd60$export$c8dce3c08436e91e(edge, {
                shape: $6361679824bbf999$var$getEdgeShape(layout, orient, curvature, sourceLayout, targetLayout)
            }, seriesModel);
        }
    } else if (edgeShape === 'polyline') {
        if (layout === 'orthogonal') {
            if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
                var children = node.children;
                var childPoints = [];
                for(var i = 0; i < children.length; i++){
                    var childLayout = children[i].getLayout();
                    childPoints.push([
                        childLayout.x,
                        childLayout.y
                    ]);
                }
                if (!edge) edge = symbolEl.__edge = new $6361679824bbf999$var$TreePath({
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: [
                            [
                                targetLayout.x,
                                targetLayout.y
                            ]
                        ],
                        orient: orient,
                        forkPosition: edgeForkPosition
                    }
                });
                $b40111164617dd60$export$c8dce3c08436e91e(edge, {
                    shape: {
                        parentPoint: [
                            targetLayout.x,
                            targetLayout.y
                        ],
                        childPoints: childPoints
                    }
                }, seriesModel);
            }
        }
    }
    // show all edge when edgeShape is 'curve', filter node `isExpand` is false when edgeShape is 'polyline'
    if (edge && !(edgeShape === 'polyline' && !node.isExpand)) {
        edge.useStyle($1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
            strokeNoScale: true,
            fill: null
        }, lineStyle));
        (0, $b414df7d361a211c$export$48b68047d330bbc9)(edge, itemModel, 'lineStyle');
        (0, $b414df7d361a211c$export$20f39bbe322fb9ab)(edge);
        group.add(edge);
    }
}
function $6361679824bbf999$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt) {
    var virtualRoot = data.tree.root;
    var _a = $6361679824bbf999$var$getSourceNode(virtualRoot, node), source = _a.source, sourceLayout = _a.sourceLayout;
    var symbolEl = data.getItemGraphicEl(node.dataIndex);
    if (!symbolEl) return;
    var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
    var sourceEdge = sourceSymbolEl.__edge;
    // 1. when expand the sub tree, delete the children node should delete the edge of
    // the source at the same time. because the polyline edge shape is only owned by the source.
    // 2.when the node is the only children of the source, delete the node should delete the edge of
    // the source at the same time. the same reason as above.
    var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
    var edgeShape = seriesModel.get('edgeShape');
    var layoutOpt = seriesModel.get('layout');
    var orient = seriesModel.get('orient');
    var curvature = seriesModel.get([
        'lineStyle',
        'curveness'
    ]);
    if (edge) {
        if (edgeShape === 'curve') $b40111164617dd60$export$f883456a56996078(edge, {
            shape: $6361679824bbf999$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, sourceLayout),
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
        else if (edgeShape === 'polyline' && seriesModel.get('layout') === 'orthogonal') $b40111164617dd60$export$f883456a56996078(edge, {
            shape: {
                parentPoint: [
                    sourceLayout.x,
                    sourceLayout.y
                ],
                childPoints: [
                    [
                        sourceLayout.x,
                        sourceLayout.y
                    ]
                ]
            },
            style: {
                opacity: 0
            }
        }, seriesModel, {
            cb: function() {
                group.remove(edge);
            },
            removeOpt: removeAnimationOpt
        });
    }
}
function $6361679824bbf999$var$getSourceNode(virtualRoot, node) {
    var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
    var sourceLayout;
    while(sourceLayout = source.getLayout(), sourceLayout == null)source = source.parentNode === virtualRoot ? source : source.parentNode || source;
    return {
        source: source,
        sourceLayout: sourceLayout
    };
}
function $6361679824bbf999$var$removeNode(data, dataIndex, symbolEl, group, seriesModel) {
    var node = data.tree.getNodeByDataIndex(dataIndex);
    var virtualRoot = data.tree.root;
    var sourceLayout = $6361679824bbf999$var$getSourceNode(virtualRoot, node).sourceLayout;
    // Use same duration and easing with update to have more consistent animation.
    var removeAnimationOpt = {
        duration: seriesModel.get('animationDurationUpdate'),
        easing: seriesModel.get('animationEasingUpdate')
    };
    $b40111164617dd60$export$f883456a56996078(symbolEl, {
        x: sourceLayout.x + 1,
        y: sourceLayout.y + 1
    }, seriesModel, {
        cb: function() {
            group.remove(symbolEl);
            data.setItemGraphicEl(dataIndex, null);
        },
        removeOpt: removeAnimationOpt
    });
    symbolEl.fadeOut(null, data.hostModel, {
        fadeLabel: true,
        animation: removeAnimationOpt
    });
    // remove edge as parent node
    node.children.forEach(function(childNode) {
        $6361679824bbf999$var$removeNodeEdge(childNode, data, group, seriesModel, removeAnimationOpt);
    });
    // remove edge as child node
    $6361679824bbf999$var$removeNodeEdge(node, data, group, seriesModel, removeAnimationOpt);
}
function $6361679824bbf999$var$getEdgeShape(layoutOpt, orient, curvature, sourceLayout, targetLayout) {
    var cpx1;
    var cpy1;
    var cpx2;
    var cpy2;
    var x1;
    var x2;
    var y1;
    var y2;
    if (layoutOpt === 'radial') {
        x1 = sourceLayout.rawX;
        y1 = sourceLayout.rawY;
        x2 = targetLayout.rawX;
        y2 = targetLayout.rawY;
        var radialCoor1 = (0, $e243d94cb2f9041d$export$60198ec123d36099)(x1, y1);
        var radialCoor2 = (0, $e243d94cb2f9041d$export$60198ec123d36099)(x1, y1 + (y2 - y1) * curvature);
        var radialCoor3 = (0, $e243d94cb2f9041d$export$60198ec123d36099)(x2, y2 + (y1 - y2) * curvature);
        var radialCoor4 = (0, $e243d94cb2f9041d$export$60198ec123d36099)(x2, y2);
        return {
            x1: radialCoor1.x || 0,
            y1: radialCoor1.y || 0,
            x2: radialCoor4.x || 0,
            y2: radialCoor4.y || 0,
            cpx1: radialCoor2.x || 0,
            cpy1: radialCoor2.y || 0,
            cpx2: radialCoor3.x || 0,
            cpy2: radialCoor3.y || 0
        };
    } else {
        x1 = sourceLayout.x;
        y1 = sourceLayout.y;
        x2 = targetLayout.x;
        y2 = targetLayout.y;
        if (orient === 'LR' || orient === 'RL') {
            cpx1 = x1 + (x2 - x1) * curvature;
            cpy1 = y1;
            cpx2 = x2 + (x1 - x2) * curvature;
            cpy2 = y2;
        }
        if (orient === 'TB' || orient === 'BT') {
            cpx1 = x1;
            cpy1 = y1 + (y2 - y1) * curvature;
            cpx2 = x2;
            cpy2 = y2 + (y1 - y2) * curvature;
        }
    }
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2,
        cpx1: cpx1,
        cpy1: cpy1,
        cpx2: cpx2,
        cpy2: cpy2
    };
}
var $6361679824bbf999$export$2e2bcd8739ae039 = $6361679824bbf999$var$TreeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Tree data structure
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Link lists and struct (graph or tree)
 */ 

var $2006c76a251ecd6d$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $2006c76a251ecd6d$var$linkSeriesData(opt) {
    var mainData = opt.mainData;
    var datas = opt.datas;
    if (!datas) {
        datas = {
            main: mainData
        };
        opt.datasAttr = {
            main: 'data'
        };
    }
    opt.datas = opt.mainData = null;
    $2006c76a251ecd6d$var$linkAll(mainData, datas, opt);
    // Porxy data original methods.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(datas, function(data) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mainData.TRANSFERABLE_METHODS, function(methodName) {
            data.wrapMethod(methodName, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($2006c76a251ecd6d$var$transferInjection, opt));
        });
    });
    // Beyond transfer, additional features should be added to `cloneShallow`.
    mainData.wrapMethod('cloneShallow', (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($2006c76a251ecd6d$var$cloneShallowInjection, opt));
    // Only mainData trigger change, because struct.update may trigger
    // another changable methods, which may bring about dead lock.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(mainData.CHANGABLE_METHODS, function(methodName) {
        mainData.wrapMethod(methodName, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($2006c76a251ecd6d$var$changeInjection, opt));
    });
    // Make sure datas contains mainData.
    (0, $1b239fc9d3a2f8ae$export$a7a9523472993e97)(datas[mainData.dataType] === mainData);
}
function $2006c76a251ecd6d$var$transferInjection(opt, res) {
    if ($2006c76a251ecd6d$var$isMainData(this)) {
        // Transfer datas to new main data.
        var datas = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, $2006c76a251ecd6d$var$inner(this).datas);
        datas[this.dataType] = res;
        $2006c76a251ecd6d$var$linkAll(res, datas, opt);
    } else // Modify the reference in main data to point newData.
    $2006c76a251ecd6d$var$linkSingle(res, this.dataType, $2006c76a251ecd6d$var$inner(this).mainData, opt);
    return res;
}
function $2006c76a251ecd6d$var$changeInjection(opt, res) {
    opt.struct && opt.struct.update();
    return res;
}
function $2006c76a251ecd6d$var$cloneShallowInjection(opt, res) {
    // cloneShallow, which brings about some fragilities, may be inappropriate
    // to be exposed as an API. So for implementation simplicity we can make
    // the restriction that cloneShallow of not-mainData should not be invoked
    // outside, but only be invoked here.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($2006c76a251ecd6d$var$inner(res).datas, function(data, dataType) {
        data !== res && $2006c76a251ecd6d$var$linkSingle(data.cloneShallow(), dataType, res, opt);
    });
    return res;
}
/**
 * Supplement method to List.
 *
 * @public
 * @param [dataType] If not specified, return mainData.
 */ function $2006c76a251ecd6d$var$getLinkedData(dataType) {
    var mainData = $2006c76a251ecd6d$var$inner(this).mainData;
    return dataType == null || mainData == null ? mainData : $2006c76a251ecd6d$var$inner(mainData).datas[dataType];
}
/**
 * Get list of all linked data
 */ function $2006c76a251ecd6d$var$getLinkedDataAll() {
    var mainData = $2006c76a251ecd6d$var$inner(this).mainData;
    return mainData == null ? [
        {
            data: mainData
        }
    ] : (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)($2006c76a251ecd6d$var$inner(mainData).datas), function(type) {
        return {
            type: type,
            data: $2006c76a251ecd6d$var$inner(mainData).datas[type]
        };
    });
}
function $2006c76a251ecd6d$var$isMainData(data) {
    return $2006c76a251ecd6d$var$inner(data).mainData === data;
}
function $2006c76a251ecd6d$var$linkAll(mainData, datas, opt) {
    $2006c76a251ecd6d$var$inner(mainData).datas = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(datas, function(data, dataType) {
        $2006c76a251ecd6d$var$linkSingle(data, dataType, mainData, opt);
    });
}
function $2006c76a251ecd6d$var$linkSingle(data, dataType, mainData, opt) {
    $2006c76a251ecd6d$var$inner(mainData).datas[dataType] = data;
    $2006c76a251ecd6d$var$inner(data).mainData = mainData;
    data.dataType = dataType;
    if (opt.struct) {
        data[opt.structAttr] = opt.struct;
        opt.struct[opt.datasAttr[dataType]] = data;
    }
    // Supplement method.
    data.getLinkedData = $2006c76a251ecd6d$var$getLinkedData;
    data.getLinkedDataAll = $2006c76a251ecd6d$var$getLinkedDataAll;
}
var $2006c76a251ecd6d$export$2e2bcd8739ae039 = $2006c76a251ecd6d$var$linkSeriesData;





var $f0c725dcad2a6e38$export$2eba8ec3a333fdbb = /** @class */ function() {
    function TreeNode(name, hostTree) {
        this.depth = 0;
        this.height = 0;
        /**
     * Reference to list item.
     * Do not persistent dataIndex outside,
     * besause it may be changed by list.
     * If dataIndex -1,
     * this node is logical deleted (filtered) in list.
     */ this.dataIndex = -1;
        this.children = [];
        this.viewChildren = [];
        this.isExpand = false;
        this.name = name || '';
        this.hostTree = hostTree;
    }
    /**
   * The node is removed.
   */ TreeNode.prototype.isRemoved = function() {
        return this.dataIndex < 0;
    };
    TreeNode.prototype.eachNode = function(options, cb, context) {
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(options)) {
            context = cb;
            cb = options;
            options = null;
        }
        options = options || {};
        if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(options)) options = {
            order: options
        };
        var order = options.order || 'preorder';
        var children = this[options.attr || 'children'];
        var suppressVisitSub;
        order === 'preorder' && (suppressVisitSub = cb.call(context, this));
        for(var i = 0; !suppressVisitSub && i < children.length; i++)children[i].eachNode(options, cb, context);
        order === 'postorder' && cb.call(context, this);
    };
    /**
   * Update depth and height of this subtree.
   */ TreeNode.prototype.updateDepthAndHeight = function(depth) {
        var height = 0;
        this.depth = depth;
        for(var i = 0; i < this.children.length; i++){
            var child = this.children[i];
            child.updateDepthAndHeight(depth + 1);
            if (child.height > height) height = child.height;
        }
        this.height = height + 1;
    };
    TreeNode.prototype.getNodeById = function(id) {
        if (this.getId() === id) return this;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].getNodeById(id);
            if (res) return res;
        }
    };
    TreeNode.prototype.contains = function(node) {
        if (node === this) return true;
        for(var i = 0, children = this.children, len = children.length; i < len; i++){
            var res = children[i].contains(node);
            if (res) return res;
        }
    };
    /**
   * @param includeSelf Default false.
   * @return order: [root, child, grandchild, ...]
   */ TreeNode.prototype.getAncestors = function(includeSelf) {
        var ancestors = [];
        var node = includeSelf ? this : this.parentNode;
        while(node){
            ancestors.push(node);
            node = node.parentNode;
        }
        ancestors.reverse();
        return ancestors;
    };
    TreeNode.prototype.getAncestorsIndices = function() {
        var indices = [];
        var currNode = this;
        while(currNode){
            indices.push(currNode.dataIndex);
            currNode = currNode.parentNode;
        }
        indices.reverse();
        return indices;
    };
    TreeNode.prototype.getDescendantIndices = function() {
        var indices = [];
        this.eachNode(function(childNode) {
            indices.push(childNode.dataIndex);
        });
        return indices;
    };
    TreeNode.prototype.getValue = function(dimension) {
        var data = this.hostTree.data;
        return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
    };
    TreeNode.prototype.setLayout = function(layout, merge) {
        this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
    };
    /**
   * @return {Object} layout
   */ TreeNode.prototype.getLayout = function() {
        return this.hostTree.data.getItemLayout(this.dataIndex);
    };
    // @depcrecated
    // getModel<T = unknown, S extends keyof T = keyof T>(path: S): Model<T[S]>
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    TreeNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var hostTree = this.hostTree;
        var itemModel = hostTree.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    // TODO: TYPE More specific model
    TreeNode.prototype.getLevelModel = function() {
        return (this.hostTree.levelModels || [])[this.depth];
    };
    TreeNode.prototype.setVisual = function(key, value) {
        this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
    };
    /**
   * Get item visual
   * FIXME: make return type better
   */ TreeNode.prototype.getVisual = function(key) {
        return this.hostTree.data.getItemVisual(this.dataIndex, key);
    };
    TreeNode.prototype.getRawIndex = function() {
        return this.hostTree.data.getRawIndex(this.dataIndex);
    };
    TreeNode.prototype.getId = function() {
        return this.hostTree.data.getId(this.dataIndex);
    };
    /**
   * index in parent's children
   */ TreeNode.prototype.getChildIndex = function() {
        if (this.parentNode) {
            var children = this.parentNode.children;
            for(var i = 0; i < children.length; ++i){
                if (children[i] === this) return i;
            }
            return -1;
        }
        return -1;
    };
    /**
   * if this is an ancestor of another node
   *
   * @param node another node
   * @return if is ancestor
   */ TreeNode.prototype.isAncestorOf = function(node) {
        var parent = node.parentNode;
        while(parent){
            if (parent === this) return true;
            parent = parent.parentNode;
        }
        return false;
    };
    /**
   * if this is an descendant of another node
   *
   * @param node another node
   * @return if is descendant
   */ TreeNode.prototype.isDescendantOf = function(node) {
        return node !== this && node.isAncestorOf(this);
    };
    return TreeNode;
}();
var $f0c725dcad2a6e38$var$Tree = /** @class */ function() {
    function Tree(hostModel) {
        this.type = 'tree';
        this._nodes = [];
        this.hostModel = hostModel;
    }
    Tree.prototype.eachNode = function(options, cb, context) {
        this.root.eachNode(options, cb, context);
    };
    Tree.prototype.getNodeByDataIndex = function(dataIndex) {
        var rawIndex = this.data.getRawIndex(dataIndex);
        return this._nodes[rawIndex];
    };
    Tree.prototype.getNodeById = function(name) {
        return this.root.getNodeById(name);
    };
    /**
   * Update item available by list,
   * when list has been performed options like 'filterSelf' or 'map'.
   */ Tree.prototype.update = function() {
        var data = this.data;
        var nodes = this._nodes;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
    };
    /**
   * Clear all layouts
   */ Tree.prototype.clearLayouts = function() {
        this.data.clearItemLayouts();
    };
    /**
   * data node format:
   * {
   *     name: ...
   *     value: ...
   *     children: [
   *         {
   *             name: ...
   *             value: ...
   *             children: ...
   *         },
   *         ...
   *     ]
   * }
   */ Tree.createTree = function(dataRoot, hostModel, beforeLink) {
        var tree = new Tree(hostModel);
        var listData = [];
        var dimMax = 1;
        buildHierarchy(dataRoot);
        function buildHierarchy(dataNode, parentNode) {
            var value = dataNode.value;
            dimMax = Math.max(dimMax, $1b239fc9d3a2f8ae$export$43bee75e5e14138e(value) ? value.length : 1);
            listData.push(dataNode);
            var node = new $f0c725dcad2a6e38$export$2eba8ec3a333fdbb((0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)(dataNode.name, ''), tree);
            parentNode ? $f0c725dcad2a6e38$var$addChild(node, parentNode) : tree.root = node;
            tree._nodes.push(node);
            var children = dataNode.children;
            if (children) for(var i = 0; i < children.length; i++)buildHierarchy(children[i], node);
        }
        tree.root.updateDepthAndHeight(0);
        var dimensions = (0, $02c5dbb1162b825d$export$2e2bcd8739ae039)(listData, {
            coordDimensions: [
                'value'
            ],
            dimensionsCount: dimMax
        }).dimensions;
        var list = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(dimensions, hostModel);
        list.initData(listData);
        beforeLink && beforeLink(list);
        (0, $2006c76a251ecd6d$export$2e2bcd8739ae039)({
            mainData: list,
            struct: tree,
            structAttr: 'tree'
        });
        tree.update();
        return tree;
    };
    return Tree;
}();
/**
 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
 * so this function is not ready and not necessary to be public.
 */ function $f0c725dcad2a6e38$var$addChild(child, node) {
    var children = node.children;
    if (child.parentNode === node) return;
    children.push(child);
    child.parentNode = node;
}
var $f0c725dcad2a6e38$export$2e2bcd8739ae039 = $f0c725dcad2a6e38$var$Tree;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $cbdb4002b7a38cc3$export$c5445fa59c15dec4(payload, validPayloadTypes, seriesModel) {
    if (payload && $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(validPayloadTypes, payload.type) >= 0) {
        var root = seriesModel.getData().tree.root;
        var targetNode = payload.targetNode;
        if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(targetNode)) targetNode = root.getNodeById(targetNode);
        if (targetNode && root.contains(targetNode)) return {
            node: targetNode
        };
        var targetNodeId = payload.targetNodeId;
        if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) return {
            node: targetNode
        };
    }
}
function $cbdb4002b7a38cc3$export$6be31fe4499506f9(node) {
    var path = [];
    while(node){
        node = node.parentNode;
        node && path.push(node);
    }
    return path.reverse();
}
function $cbdb4002b7a38cc3$export$df59de26c77b5bea(viewRoot, node) {
    var viewPath = $cbdb4002b7a38cc3$export$6be31fe4499506f9(viewRoot);
    return $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(viewPath, node) >= 0;
}
function $cbdb4002b7a38cc3$export$c5baa480d6ceb0a3(node, seriesModel) {
    var treePathInfo = [];
    while(node){
        var nodeDataIndex = node.dataIndex;
        treePathInfo.push({
            name: node.name,
            dataIndex: nodeDataIndex,
            value: seriesModel.getRawValue(nodeDataIndex)
        });
        node = node.parentNode;
    }
    treePathInfo.reverse();
    return treePathInfo;
}


var $f716b47fbc8b9d34$var$TreeSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TreeSeriesModel, _super);
    function TreeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasSymbolVisual = true;
        // Do it self.
        _this.ignoreStyleOnData = true;
        return _this;
    }
    /**
   * Init a tree data structure from data in option series
   */ TreeSeriesModel.prototype.getInitialData = function(option) {
        // create a virtual root
        var root = {
            name: option.name,
            children: option.data
        };
        var leaves = option.leaves || {};
        var leavesModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(leaves, this, this.ecModel);
        var tree = (0, $f0c725dcad2a6e38$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                if (!(node && node.children.length && node.isExpand)) model.parentModel = leavesModel;
                return model;
            });
        }
        var treeDepth = 0;
        tree.eachNode('preorder', function(node) {
            if (node.depth > treeDepth) treeDepth = node.depth;
        });
        var expandAndCollapse = option.expandAndCollapse;
        var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
        tree.root.eachNode('preorder', function(node) {
            var item = node.hostTree.data.getRawDataItem(node.dataIndex);
            // Add item.collapsed != null, because users can collapse node original in the series.data.
            node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
        });
        return tree.data;
    };
    /**
   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
   * @returns {string} orient
   */ TreeSeriesModel.prototype.getOrient = function() {
        var orient = this.get('orient');
        if (orient === 'horizontal') orient = 'LR';
        else if (orient === 'vertical') orient = 'TB';
        return orient;
    };
    TreeSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    TreeSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    TreeSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var tree = this.getData().tree;
        var realRoot = tree.root.children[0];
        var node = tree.getNodeByDataIndex(dataIndex);
        var value = node.getValue();
        var name = node.name;
        while(node && node !== realRoot){
            name = node.parentNode.name + '.' + name;
            node = node.parentNode;
        }
        return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
            name: name,
            value: value,
            noValue: isNaN(value) || value == null
        });
    };
    // Add tree path to tooltip param
    TreeSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $cbdb4002b7a38cc3$export$c5baa480d6ceb0a3)(node, this);
        params.collapsed = !node.isExpand;
        return params;
    };
    TreeSeriesModel.type = 'series.tree';
    // can support the position parameters 'left', 'top','right','bottom', 'width',
    // 'height' in the setOption() with 'merge' mode normal.
    TreeSeriesModel.layoutMode = 'box';
    TreeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'view',
        // the position of the whole view
        left: '12%',
        top: '12%',
        right: '12%',
        bottom: '12%',
        // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
        layout: 'orthogonal',
        // value can be 'polyline'
        edgeShape: 'curve',
        edgeForkPosition: '50%',
        // true | false | 'move' | 'scale', see module:component/helper/RoamController.
        roam: false,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.4,
        // Default on center of graph
        center: null,
        zoom: 1,
        orient: 'LR',
        symbol: 'emptyCircle',
        symbolSize: 7,
        expandAndCollapse: true,
        initialTreeDepth: 2,
        lineStyle: {
            color: '#ccc',
            width: 1.5,
            curveness: 0.5
        },
        itemStyle: {
            color: 'lightsteelblue',
            // borderColor: '#c23531',
            borderWidth: 1.5
        },
        label: {
            show: true
        },
        animationEasing: 'linear',
        animationDuration: 700,
        animationDurationUpdate: 500
    };
    return TreeSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $f716b47fbc8b9d34$export$2e2bcd8739ae039 = $f716b47fbc8b9d34$var$TreeSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Traverse the tree from bottom to top and do something
 */ function $3d46c9f2bc6c706a$export$bd961f70bc91ffb4(root, callback, separation) {
    var nodes = [
        root
    ];
    var next = [];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        next.push(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = 0; i < children.length; i++)nodes.push(children[i]);
        }
    }
    while(node = next.pop())// jshint ignore:line
    callback(node, separation);
}
/**
 * Traverse the tree from top to bottom and do something
 */ function $3d46c9f2bc6c706a$export$32a66ec2b39acdac(root, callback) {
    var nodes = [
        root
    ];
    var node;
    while(node = nodes.pop()){
        // jshint ignore:line
        callback(node);
        if (node.isExpand) {
            var children = node.children;
            if (children.length) for(var i = children.length - 1; i >= 0; i--)nodes.push(children[i]);
        }
    }
}



function $49243802fecc61db$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('tree', function(seriesModel) {
        $49243802fecc61db$var$commonLayout(seriesModel, api);
    });
}
function $49243802fecc61db$var$commonLayout(seriesModel, api) {
    var layoutInfo = (0, $e243d94cb2f9041d$export$c02eeb5f98d59b89)(seriesModel, api);
    seriesModel.layoutInfo = layoutInfo;
    var layout = seriesModel.get('layout');
    var width = 0;
    var height = 0;
    var separation = null;
    if (layout === 'radial') {
        width = 2 * Math.PI;
        height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
        separation = (0, $e243d94cb2f9041d$export$3bf720ece7bc7b2e)(function(node1, node2) {
            return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
        });
    } else {
        width = layoutInfo.width;
        height = layoutInfo.height;
        separation = (0, $e243d94cb2f9041d$export$3bf720ece7bc7b2e)();
    }
    var virtualRoot = seriesModel.getData().tree.root;
    var realRoot = virtualRoot.children[0];
    if (realRoot) {
        (0, $e243d94cb2f9041d$export$2cd8252107eb640b)(virtualRoot);
        (0, $3d46c9f2bc6c706a$export$bd961f70bc91ffb4)(realRoot, (0, $e243d94cb2f9041d$export$f7eff93d75358a2c), separation);
        virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
        (0, $3d46c9f2bc6c706a$export$32a66ec2b39acdac)(realRoot, (0, $e243d94cb2f9041d$export$39e6f19b1ce889be));
        var left_1 = realRoot;
        var right_1 = realRoot;
        var bottom_1 = realRoot;
        (0, $3d46c9f2bc6c706a$export$32a66ec2b39acdac)(realRoot, function(node) {
            var x = node.getLayout().x;
            if (x < left_1.getLayout().x) left_1 = node;
            if (x > right_1.getLayout().x) right_1 = node;
            if (node.depth > bottom_1.depth) bottom_1 = node;
        });
        var delta = left_1 === right_1 ? 1 : separation(left_1, right_1) / 2;
        var tx_1 = delta - left_1.getLayout().x;
        var kx_1 = 0;
        var ky_1 = 0;
        var coorX_1 = 0;
        var coorY_1 = 0;
        if (layout === 'radial') {
            kx_1 = width / (right_1.getLayout().x + delta + tx_1);
            // here we use (node.depth - 1), bucause the real root's depth is 1
            ky_1 = height / (bottom_1.depth - 1 || 1);
            (0, $3d46c9f2bc6c706a$export$32a66ec2b39acdac)(realRoot, function(node) {
                coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                coorY_1 = (node.depth - 1) * ky_1;
                var finalCoor = (0, $e243d94cb2f9041d$export$60198ec123d36099)(coorX_1, coorY_1);
                node.setLayout({
                    x: finalCoor.x,
                    y: finalCoor.y,
                    rawX: coorX_1,
                    rawY: coorY_1
                }, true);
            });
        } else {
            var orient_1 = seriesModel.getOrient();
            if (orient_1 === 'RL' || orient_1 === 'LR') {
                ky_1 = height / (right_1.getLayout().x + delta + tx_1);
                kx_1 = width / (bottom_1.depth - 1 || 1);
                (0, $3d46c9f2bc6c706a$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorY_1 = (node.getLayout().x + tx_1) * ky_1;
                    coorX_1 = orient_1 === 'LR' ? (node.depth - 1) * kx_1 : width - (node.depth - 1) * kx_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            } else if (orient_1 === 'TB' || orient_1 === 'BT') {
                kx_1 = width / (right_1.getLayout().x + delta + tx_1);
                ky_1 = height / (bottom_1.depth - 1 || 1);
                (0, $3d46c9f2bc6c706a$export$32a66ec2b39acdac)(realRoot, function(node) {
                    coorX_1 = (node.getLayout().x + tx_1) * kx_1;
                    coorY_1 = orient_1 === 'TB' ? (node.depth - 1) * ky_1 : height - (node.depth - 1) * ky_1;
                    node.setLayout({
                        x: coorX_1,
                        y: coorY_1
                    }, true);
                });
            }
        }
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $301472cb71c9b008$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('tree', function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            // TODO Optimize
            var style = model.getModel('itemStyle').getItemStyle();
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $dce7c7617e65008d$export$83b6a0f4104bd4f4(registers) {
    registers.registerAction({
        type: 'treeExpandAndCollapse',
        event: 'treeExpandAndCollapse',
        update: 'update'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'tree',
            query: payload
        }, function(seriesModel) {
            var dataIndex = payload.dataIndex;
            var tree = seriesModel.getData().tree;
            var node = tree.getNodeByDataIndex(dataIndex);
            node.isExpand = !node.isExpand;
        });
    });
    registers.registerAction({
        type: 'treeRoam',
        event: 'treeRoam',
        // Here we set 'none' instead of 'update', because roam action
        // just need to update the transform matrix without having to recalculate
        // the layout. So don't need to go through the whole update process, such
        // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
        update: 'none'
    }, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'tree',
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $4ae3ee9cd93604f8$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}


function $5c4df8e42fbaca0b$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $6361679824bbf999$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f716b47fbc8b9d34$export$2e2bcd8739ae039));
    registers.registerLayout((0, $49243802fecc61db$export$2e2bcd8739ae039));
    registers.registerVisual((0, $301472cb71c9b008$export$2e2bcd8739ae039));
    (0, $dce7c7617e65008d$export$83b6a0f4104bd4f4)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8809f67a476e3c3a$var$actionTypes = [
    'treemapZoomToNode',
    'treemapRender',
    'treemapMove'
];
function $8809f67a476e3c3a$export$1ad90fc3f3a8bbf9(registers) {
    for(var i = 0; i < $8809f67a476e3c3a$var$actionTypes.length; i++)registers.registerAction({
        type: $8809f67a476e3c3a$var$actionTypes[i],
        update: 'updateView'
    }, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
    registers.registerAction({
        type: 'treemapRootToNode',
        update: 'updateView'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'treemap',
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var types = [
                'treemapZoomToNode',
                'treemapRootToNode'
            ];
            var targetInfo = $cbdb4002b7a38cc3$export$c5445fa59c15dec4(payload, types, model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = $cbdb4002b7a38cc3$export$df59de26c77b5bea(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $94b6547605aff76f$export$2e2bcd8739ae039(seriesModel) {
    var data = seriesModel.getData();
    var tree = data.tree;
    var decalPaletteScope = {};
    tree.eachNode(function(node) {
        // Use decal of level 1 node
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var decal = (0, $6d8b6513f520ae7c$export$e4d892222945a227)(seriesModel.ecModel, current.name || current.dataIndex + '', decalPaletteScope);
        node.setVisual('decal', decal);
    });
}


var $9300d85770d0960a$var$TreemapSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TreemapSeriesModel, _super);
    function TreemapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapSeriesModel.type;
        _this.preventUsingHoverLayer = true;
        return _this;
    }
    /**
   * @override
   */ TreemapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $9300d85770d0960a$var$completeTreeValue(root);
        var levels = option.levels || [];
        // Used in "visual priority" in `treemapVisual.js`.
        // This way is a little tricky, must satisfy the precondition:
        //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
        //   2. The `Model.prototype.getModel()` will not use any clone-like way.
        var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
        var designatedVisualModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)({
            itemStyle: designatedVisualItemStyle
        }, this, ecModel);
        levels = option.levels = $9300d85770d0960a$var$setDefault(levels, ecModel);
        var levelModels = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(levels || [], function(levelDefine) {
            return new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(levelDefine, designatedVisualModel, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $f0c725dcad2a6e38$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = node ? levelModels[node.depth] : null;
                // If no levelModel, we also need `designatedVisualModel`.
                model.parentModel = levelModel || designatedVisualModel;
                return model;
            });
        }
        return tree.data;
    };
    TreemapSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /**
   * @override
   * @param {number} dataIndex
   * @param {boolean} [mutipleSeries=false]
   */ TreemapSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var name = data.getName(dataIndex);
        return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
            name: name,
            value: value
        });
    };
    /**
   * Add tree path to tooltip param
   *
   * @override
   * @param {number} dataIndex
   * @return {Object}
   */ TreemapSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treeAncestors = (0, $cbdb4002b7a38cc3$export$c5baa480d6ceb0a3)(node, this);
        // compatitable the previous code.
        params.treePathInfo = params.treeAncestors;
        return params;
    };
    /**
   * @public
   * @param {Object} layoutInfo {
   *                                x: containerGroup x
   *                                y: containerGroup y
   *                                width: containerGroup width
   *                                height: containerGroup height
   *                            }
   */ TreemapSeriesModel.prototype.setLayoutInfo = function(layoutInfo) {
        /**
     * @readOnly
     * @type {Object}
     */ this.layoutInfo = this.layoutInfo || {};
        $1b239fc9d3a2f8ae$export$8b58be045bf06082(this.layoutInfo, layoutInfo);
    };
    /**
   * @param  {string} id
   * @return {number} index
   */ TreemapSeriesModel.prototype.mapIdToIndex = function(id) {
        // A feature is implemented:
        // index is monotone increasing with the sequence of
        // input id at the first time.
        // This feature can make sure that each data item and its
        // mapped color have the same index between data list and
        // color list at the beginning, which is useful for user
        // to adjust data-color mapping.
        /**
     * @private
     * @type {Object}
     */ var idIndexMap = this._idIndexMap;
        if (!idIndexMap) {
            idIndexMap = this._idIndexMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
            /**
       * @private
       * @type {number}
       */ this._idIndexMapCount = 0;
        }
        var index = idIndexMap.get(id);
        if (index == null) idIndexMap.set(id, index = this._idIndexMapCount++);
        return index;
    };
    TreemapSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    TreemapSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    TreemapSeriesModel.prototype.enableAriaDecal = function() {
        (0, $94b6547605aff76f$export$2e2bcd8739ae039)(this);
    };
    TreemapSeriesModel.type = 'series.treemap';
    TreemapSeriesModel.layoutMode = 'box';
    TreemapSeriesModel.defaultOption = {
        // Disable progressive rendering
        progressive: 0,
        // size: ['80%', '80%'],            // deprecated, compatible with ec2.
        left: 'center',
        top: 'middle',
        width: '80%',
        height: '80%',
        sort: true,
        clipWindow: 'origin',
        squareRatio: 0.5 * (1 + Math.sqrt(5)),
        leafDepth: null,
        drillDownIcon: "\u25B6",
        // to align specialized icon. ▷▶❒❐▼✚
        zoomToNodeRatio: 0.1024,
        scaleLimit: null,
        roam: true,
        nodeClick: 'zoomToNode',
        animation: true,
        animationDurationUpdate: 900,
        animationEasing: 'quinticInOut',
        breadcrumb: {
            show: true,
            height: 22,
            left: 'center',
            top: 'bottom',
            // right
            // bottom
            emptyItemWidth: 25,
            itemStyle: {
                color: 'rgba(0,0,0,0.7)',
                textStyle: {
                    color: '#fff'
                }
            },
            emphasis: {
                itemStyle: {
                    color: 'rgba(0,0,0,0.9)' // '#5793f3',
                }
            }
        },
        label: {
            show: true,
            // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
            distance: 0,
            padding: 5,
            position: 'inside',
            // formatter: null,
            color: '#fff',
            overflow: 'truncate'
        },
        upperLabel: {
            show: false,
            position: [
                0,
                '50%'
            ],
            height: 20,
            // formatter: null,
            // color: '#fff',
            overflow: 'truncate',
            // align: null,
            verticalAlign: 'middle'
        },
        itemStyle: {
            color: null,
            colorAlpha: null,
            colorSaturation: null,
            borderWidth: 0,
            gapWidth: 0,
            borderColor: '#fff',
            borderColorSaturation: null // If specified, borderColor will be ineffective, and the
        },
        emphasis: {
            upperLabel: {
                show: true,
                position: [
                    0,
                    '50%'
                ],
                overflow: 'truncate',
                verticalAlign: 'middle'
            }
        },
        visualDimension: 0,
        visualMin: null,
        visualMax: null,
        color: [],
        // level[n].color (if necessary).
        // + Specify color list of each level. level[0].color would be global
        // color list if not specified. (see method `setDefault`).
        // + But set as a empty array to forbid fetch color from global palette
        // when using nodeModel.get('color'), otherwise nodes on deep level
        // will always has color palette set and are not able to inherit color
        // from parent node.
        // + TreemapSeries.color can not be set as 'none', otherwise effect
        // legend color fetching (see seriesColor.js).
        colorAlpha: null,
        colorSaturation: null,
        colorMappingBy: 'index',
        visibleMin: 10,
        // be rendered. Only works when sort is 'asc' or 'desc'.
        childrenVisibleMin: null,
        // grandchildren will not show.
        // Why grandchildren? If not grandchildren but children,
        // some siblings show children and some not,
        // the appearance may be mess and not consistent,
        levels: [] // Each item: {
    };
    return TreemapSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
/**
 * @param {Object} dataNode
 */ function $9300d85770d0960a$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(dataNode.children, function(child) {
        $9300d85770d0960a$var$completeTreeValue(child);
        var childValue = child.value;
        $1b239fc9d3a2f8ae$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $1b239fc9d3a2f8ae$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
/**
 * set default to level configuration
 */ function $9300d85770d0960a$var$setDefault(levels, ecModel) {
    var globalColorList = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(ecModel.get('color'));
    var globalDecalList = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(ecModel.get([
        'aria',
        'decal',
        'decals'
    ]));
    if (!globalColorList) return;
    levels = levels || [];
    var hasColorDefine;
    var hasDecalDefine;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(levels, function(levelDefine) {
        var model = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(levelDefine);
        var modelColor = model.get('color');
        var modelDecal = model.get('decal');
        if (model.get([
            'itemStyle',
            'color'
        ]) || modelColor && modelColor !== 'none') hasColorDefine = true;
        if (model.get([
            'itemStyle',
            'decal'
        ]) || modelDecal && modelDecal !== 'none') hasDecalDefine = true;
    });
    var level0 = levels[0] || (levels[0] = {});
    if (!hasColorDefine) level0.color = globalColorList.slice();
    if (!hasDecalDefine && globalDecalList) level0.decal = globalDecalList.slice();
    return levels;
}
var $9300d85770d0960a$export$2e2bcd8739ae039 = $9300d85770d0960a$var$TreemapSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $e98ead0fb9ca7469$var$TEXT_PADDING = 8;
var $e98ead0fb9ca7469$var$ITEM_GAP = 8;
var $e98ead0fb9ca7469$var$ARRAY_LENGTH = 5;
var $e98ead0fb9ca7469$var$Breadcrumb = /** @class */ function() {
    function Breadcrumb(containerGroup) {
        this.group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        containerGroup.add(this.group);
    }
    Breadcrumb.prototype.render = function(seriesModel, api, targetNode, onSelect) {
        var model = seriesModel.getModel('breadcrumb');
        var thisGroup = this.group;
        thisGroup.removeAll();
        if (!model.get('show') || !targetNode) return;
        var normalStyleModel = model.getModel('itemStyle');
        var emphasisModel = model.getModel('emphasis');
        var textStyleModel = normalStyleModel.getModel('textStyle');
        var emphasisTextStyleModel = emphasisModel.getModel([
            'itemStyle',
            'textStyle'
        ]);
        var layoutParam = {
            pos: {
                left: model.get('left'),
                right: model.get('right'),
                top: model.get('top'),
                bottom: model.get('bottom')
            },
            box: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            emptyItemWidth: model.get('emptyItemWidth'),
            totalWidth: 0,
            renderList: []
        };
        this._prepare(targetNode, layoutParam, textStyleModel);
        this._renderContent(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect);
        $501dc28f6c4d24ac$export$74054bd96b5eeef1(thisGroup, layoutParam.pos, layoutParam.box);
    };
    /**
   * Prepare render list and total width
   * @private
   */ Breadcrumb.prototype._prepare = function(targetNode, layoutParam, textStyleModel) {
        for(var node = targetNode; node; node = node.parentNode){
            var text = (0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)(node.getModel().get('name'), '');
            var textRect = textStyleModel.getTextRect(text);
            var itemWidth = Math.max(textRect.width + $e98ead0fb9ca7469$var$TEXT_PADDING * 2, layoutParam.emptyItemWidth);
            layoutParam.totalWidth += itemWidth + $e98ead0fb9ca7469$var$ITEM_GAP;
            layoutParam.renderList.push({
                node: node,
                text: text,
                width: itemWidth
            });
        }
    };
    /**
   * @private
   */ Breadcrumb.prototype._renderContent = function(seriesModel, layoutParam, normalStyleModel, emphasisModel, textStyleModel, emphasisTextStyleModel, onSelect) {
        // Start rendering.
        var lastX = 0;
        var emptyItemWidth = layoutParam.emptyItemWidth;
        var height = seriesModel.get([
            'breadcrumb',
            'height'
        ]);
        var availableSize = $501dc28f6c4d24ac$export$145a8938a85a22b1(layoutParam.pos, layoutParam.box);
        var totalWidth = layoutParam.totalWidth;
        var renderList = layoutParam.renderList;
        var emphasisItemStyle = emphasisModel.getModel('itemStyle').getItemStyle();
        for(var i = renderList.length - 1; i >= 0; i--){
            var item = renderList[i];
            var itemNode = item.node;
            var itemWidth = item.width;
            var text = item.text;
            // Hdie text and shorten width if necessary.
            if (totalWidth > availableSize.width) {
                totalWidth -= itemWidth - emptyItemWidth;
                itemWidth = emptyItemWidth;
                text = null;
            }
            var el = new $399011f87accd5da$export$2e2bcd8739ae039({
                shape: {
                    points: $e98ead0fb9ca7469$var$makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
                },
                style: (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)(normalStyleModel.getItemStyle(), {
                    lineJoin: 'bevel'
                }),
                textContent: new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                    style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                        text: text
                    })
                }),
                textConfig: {
                    position: 'inside'
                },
                z2: (0, $b414df7d361a211c$export$1cb9fc6ed5b9836c) * 1e4,
                onclick: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)(onSelect, itemNode)
            });
            el.disableLabelAnimation = true;
            el.getTextContent().ensureState('emphasis').style = (0, $3828198b2f2de836$export$f8998c3d0a13de59)(emphasisTextStyleModel, {
                text: text
            });
            el.ensureState('emphasis').style = emphasisItemStyle;
            (0, $b414df7d361a211c$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
            this.group.add(el);
            $e98ead0fb9ca7469$var$packEventData(el, seriesModel, itemNode);
            lastX += itemWidth + $e98ead0fb9ca7469$var$ITEM_GAP;
        }
    };
    Breadcrumb.prototype.remove = function() {
        this.group.removeAll();
    };
    return Breadcrumb;
}();
function $e98ead0fb9ca7469$var$makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
    var points = [
        [
            head ? x : x - $e98ead0fb9ca7469$var$ARRAY_LENGTH,
            y
        ],
        [
            x + itemWidth,
            y
        ],
        [
            x + itemWidth,
            y + itemHeight
        ],
        [
            head ? x : x - $e98ead0fb9ca7469$var$ARRAY_LENGTH,
            y + itemHeight
        ]
    ];
    !tail && points.splice(2, 0, [
        x + itemWidth + $e98ead0fb9ca7469$var$ARRAY_LENGTH,
        y + itemHeight / 2
    ]);
    !head && points.push([
        x,
        y + itemHeight / 2
    ]);
    return points;
}
// Package custom mouse event.
function $e98ead0fb9ca7469$var$packEventData(el, seriesModel, itemNode) {
    (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: 'series',
        componentSubType: 'treemap',
        componentIndex: seriesModel.componentIndex,
        seriesIndex: seriesModel.seriesIndex,
        seriesName: seriesModel.name,
        seriesType: 'treemap',
        selfType: 'breadcrumb',
        nodeData: {
            dataIndex: itemNode && itemNode.dataIndex,
            name: itemNode && itemNode.name
        },
        treePathInfo: itemNode && (0, $cbdb4002b7a38cc3$export$c5baa480d6ceb0a3)(itemNode, seriesModel)
    };
}
var $e98ead0fb9ca7469$export$2e2bcd8739ae039 = $e98ead0fb9ca7469$var$Breadcrumb;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Animate multiple elements with a single done-callback.
 *
 * @example
 *  animation
 *      .createWrap()
 *      .add(el1, {x: 10, y: 10})
 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
 *      .done(function () { // done })
 *      .start('cubicOut');
 */ var $01a408e0c6ba4cdf$var$AnimationWrap = /** @class */ function() {
    function AnimationWrap() {
        this._storage = [];
        this._elExistsMap = {};
    }
    /**
   * Caution: a el can only be added once, otherwise 'done'
   * might not be called. This method checks this (by el.id),
   * suppresses adding and returns false when existing el found.
   *
   * @return Whether adding succeeded.
   */ AnimationWrap.prototype.add = function(el, target, duration, delay, easing) {
        if (this._elExistsMap[el.id]) return false;
        this._elExistsMap[el.id] = true;
        this._storage.push({
            el: el,
            target: target,
            duration: duration,
            delay: delay,
            easing: easing
        });
        return true;
    };
    /**
   * Only execute when animation done/aborted.
   */ AnimationWrap.prototype.finished = function(callback) {
        this._finishedCallback = callback;
        return this;
    };
    /**
   * Will stop exist animation firstly.
   */ AnimationWrap.prototype.start = function() {
        var _this = this;
        var count = this._storage.length;
        var checkTerminate = function() {
            count--;
            if (count <= 0) {
                // Guard.
                _this._storage.length = 0;
                _this._elExistsMap = {};
                _this._finishedCallback && _this._finishedCallback();
            }
        };
        for(var i = 0, len = this._storage.length; i < len; i++){
            var item = this._storage[i];
            item.el.animateTo(item.target, {
                duration: item.duration,
                delay: item.delay,
                easing: item.easing,
                setToFinal: true,
                done: checkTerminate,
                aborted: checkTerminate
            });
        }
        return this;
    };
    return AnimationWrap;
}();
function $01a408e0c6ba4cdf$export$944643101ee10c7() {
    return new $01a408e0c6ba4cdf$var$AnimationWrap();
}








var $4f63729a8b2a7c09$var$Group = $6c313c3ef6000a43$export$2e2bcd8739ae039;
var $4f63729a8b2a7c09$var$Rect = $37476269d425e3f6$export$2e2bcd8739ae039;
var $4f63729a8b2a7c09$var$DRAG_THRESHOLD = 3;
var $4f63729a8b2a7c09$var$PATH_LABEL_NOAMAL = 'label';
var $4f63729a8b2a7c09$var$PATH_UPPERLABEL_NORMAL = 'upperLabel';
// Should larger than emphasis states lift z
var $4f63729a8b2a7c09$var$Z2_BASE = (0, $b414df7d361a211c$export$1cb9fc6ed5b9836c) * 10; // Should bigger than every z2.
var $4f63729a8b2a7c09$var$Z2_BG = (0, $b414df7d361a211c$export$1cb9fc6ed5b9836c) * 2;
var $4f63729a8b2a7c09$var$Z2_CONTENT = (0, $b414df7d361a211c$export$1cb9fc6ed5b9836c) * 3;
var $4f63729a8b2a7c09$var$getStateItemStyle = (0, $8555b33f89f2677c$export$2e2bcd8739ae039)([
    [
        'fill',
        'color'
    ],
    // `borderColor` and `borderWidth` has been occupied,
    // so use `stroke` to indicate the stroke of the rect.
    [
        'stroke',
        'strokeColor'
    ],
    [
        'lineWidth',
        'strokeWidth'
    ],
    [
        'shadowBlur'
    ],
    [
        'shadowOffsetX'
    ],
    [
        'shadowOffsetY'
    ],
    [
        'shadowColor'
    ]
]);
var $4f63729a8b2a7c09$var$getItemStyleNormal = function(model) {
    // Normal style props should include emphasis style props.
    var itemStyle = $4f63729a8b2a7c09$var$getStateItemStyle(model);
    // Clear styles set by emphasis.
    itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
    return itemStyle;
};
var $4f63729a8b2a7c09$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $4f63729a8b2a7c09$var$TreemapView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TreemapView, _super);
    function TreemapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TreemapView.type;
        _this._state = 'ready';
        _this._storage = $4f63729a8b2a7c09$var$createStorage();
        return _this;
    }
    /**
   * @override
   */ TreemapView.prototype.render = function(seriesModel, ecModel, api, payload) {
        var models = ecModel.findComponents({
            mainType: 'series',
            subType: 'treemap',
            query: payload
        });
        if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(models, seriesModel) < 0) return;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var types = [
            'treemapZoomToNode',
            'treemapRootToNode'
        ];
        var targetInfo = $cbdb4002b7a38cc3$export$c5445fa59c15dec4(payload, types, seriesModel);
        var payloadType = payload && payload.type;
        var layoutInfo = seriesModel.layoutInfo;
        var isInit = !this._oldTree;
        var thisStorage = this._storage;
        // Mark new root when action is treemapRootToNode.
        var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
            rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
            direction: payload.direction
        } : null;
        var containerGroup = this._giveContainerGroup(layoutInfo);
        var hasAnimation = seriesModel.get('animation');
        var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
        hasAnimation && !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
        this._resetController(api);
        this._renderBreadcrumb(seriesModel, api, targetInfo);
    };
    TreemapView.prototype._giveContainerGroup = function(layoutInfo) {
        var containerGroup = this._containerGroup;
        if (!containerGroup) {
            // FIXME
            // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
            containerGroup = this._containerGroup = new $4f63729a8b2a7c09$var$Group();
            this._initEvents(containerGroup);
            this.group.add(containerGroup);
        }
        containerGroup.x = layoutInfo.x;
        containerGroup.y = layoutInfo.y;
        return containerGroup;
    };
    TreemapView.prototype._doRender = function(containerGroup, seriesModel, reRoot) {
        var thisTree = seriesModel.getData().tree;
        var oldTree = this._oldTree;
        // Clear last shape records.
        var lastsForAnimation = $4f63729a8b2a7c09$var$createStorage();
        var thisStorage = $4f63729a8b2a7c09$var$createStorage();
        var oldStorage = this._storage;
        var willInvisibleEls = [];
        function doRenderNode(thisNode, oldNode, parentGroup, depth) {
            return $4f63729a8b2a7c09$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth);
        }
        // Notice: When thisTree and oldTree are the same tree (see list.cloneShallow),
        // the oldTree is actually losted, so we cannot find all of the old graphic
        // elements from tree. So we use this strategy: make element storage, move
        // from old storage to new storage, clear old storage.
        dualTravel(thisTree.root ? [
            thisTree.root
        ] : [], oldTree && oldTree.root ? [
            oldTree.root
        ] : [], containerGroup, thisTree === oldTree || !oldTree, 0);
        // Process all removing.
        var willDeleteEls = clearStorage(oldStorage);
        this._oldTree = thisTree;
        this._storage = thisStorage;
        if (this._controllerHost) {
            var _oldRootLayout = this.seriesModel.layoutInfo;
            var rootLayout = thisTree.root.getLayout();
            if (rootLayout.width === _oldRootLayout.width && rootLayout.height === _oldRootLayout.height) this._controllerHost.zoom = 1;
        }
        return {
            lastsForAnimation: lastsForAnimation,
            willDeleteEls: willDeleteEls,
            renderFinally: renderFinally
        };
        function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
            // When 'render' is triggered by action,
            // 'this' and 'old' may be the same tree,
            // we use rawIndex in that case.
            if (sameTree) {
                oldViewChildren = thisViewChildren;
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(thisViewChildren, function(child, index) {
                    !child.isRemoved() && processNode(index, index);
                });
            } else new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove((0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)(processNode, null)).execute();
            function getKey(node) {
                // Identify by name or raw index.
                return node.getId();
            }
            function processNode(newIndex, oldIndex) {
                var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
                var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
                var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
                group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
            }
        }
        function clearStorage(storage) {
            var willDeleteEls = $4f63729a8b2a7c09$var$createStorage();
            storage && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(storage, function(store, storageName) {
                var delEls = willDeleteEls[storageName];
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(store, function(el) {
                    el && (delEls.push(el), $4f63729a8b2a7c09$var$inner(el).willDelete = true);
                });
            });
            return willDeleteEls;
        }
        function renderFinally() {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(willDeleteEls, function(els) {
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(els, function(el) {
                    el.parent && el.parent.remove(el);
                });
            });
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(willInvisibleEls, function(el) {
                el.invisible = true;
                // Setting invisible is for optimizing, so no need to set dirty,
                // just mark as invisible.
                el.dirty();
            });
        }
    };
    TreemapView.prototype._doAnimation = function(containerGroup, renderResult, seriesModel, reRoot) {
        var durationOption = seriesModel.get('animationDurationUpdate');
        var easingOption = seriesModel.get('animationEasing');
        // TODO: do not support function until necessary.
        var duration = ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(durationOption) ? 0 : durationOption) || 0;
        var easing = ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(easingOption) ? null : easingOption) || 'cubicOut';
        var animationWrap = $01a408e0c6ba4cdf$export$944643101ee10c7();
        // Make delete animations.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(renderResult.willDeleteEls, function(store, storageName) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                if (el.invisible) return;
                var parent = el.parent; // Always has parent, and parent is nodeGroup.
                var target;
                var innerStore = $4f63729a8b2a7c09$var$inner(parent);
                if (reRoot && reRoot.direction === 'drillDown') target = parent === reRoot.rootNodeGroup ? {
                    shape: {
                        x: 0,
                        y: 0,
                        width: innerStore.nodeWidth,
                        height: innerStore.nodeHeight
                    },
                    style: {
                        opacity: 0
                    }
                } : {
                    style: {
                        opacity: 0
                    }
                };
                else {
                    var targetX = 0;
                    var targetY = 0;
                    if (!innerStore.willDelete) {
                        // Let node animate to right-bottom corner, cooperating with fadeout,
                        // which is appropriate for user understanding.
                        // Divided by 2 for reRoot rolling up effect.
                        targetX = innerStore.nodeWidth / 2;
                        targetY = innerStore.nodeHeight / 2;
                    }
                    target = storageName === 'nodeGroup' ? {
                        x: targetX,
                        y: targetY,
                        style: {
                            opacity: 0
                        }
                    } : {
                        shape: {
                            x: targetX,
                            y: targetY,
                            width: 0,
                            height: 0
                        },
                        style: {
                            opacity: 0
                        }
                    };
                }
                // TODO: do not support delay until necessary.
                target && animationWrap.add(el, target, duration, 0, easing);
            });
        });
        // Make other animations
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._storage, function(store, storageName) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(store, function(el, rawIndex) {
                var last = renderResult.lastsForAnimation[storageName][rawIndex];
                var target = {};
                if (!last) return;
                if (el instanceof $6c313c3ef6000a43$export$2e2bcd8739ae039) {
                    if (last.oldX != null) {
                        target.x = el.x;
                        target.y = el.y;
                        el.x = last.oldX;
                        el.y = last.oldY;
                    }
                } else {
                    if (last.oldShape) {
                        target.shape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, el.shape);
                        el.setShape(last.oldShape);
                    }
                    if (last.fadein) {
                        el.setStyle('opacity', 0);
                        target.style = {
                            opacity: 1
                        };
                    } else if (el.style.opacity !== 1) target.style = {
                        opacity: 1
                    };
                }
                animationWrap.add(el, target, duration, 0, easing);
            });
        }, this);
        this._state = 'animating';
        animationWrap.finished((0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(function() {
            this._state = 'ready';
            renderResult.renderFinally();
        }, this)).start();
    };
    TreemapView.prototype._resetController = function(api) {
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        if (!controllerHost) {
            this._controllerHost = {
                target: this.group
            };
            controllerHost = this._controllerHost;
        }
        // Init controller.
        if (!controller) {
            controller = this._controller = new (0, $36ebde58055237cc$export$2e2bcd8739ae039)(api.getZr());
            controller.enable(this.seriesModel.get('roam'));
            controllerHost.zoomLimit = this.seriesModel.get('scaleLimit');
            controllerHost.zoom = this.seriesModel.get('zoom');
            controller.on('pan', (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onPan, this));
            controller.on('zoom', (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onZoom, this));
        }
        var rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(0, 0, api.getWidth(), api.getHeight());
        controller.setPointerChecker(function(e, x, y) {
            return rect.contain(x, y);
        });
    };
    TreemapView.prototype._clearController = function() {
        var controller = this._controller;
        this._controllerHost = null;
        if (controller) {
            controller.dispose();
            controller = null;
        }
    };
    TreemapView.prototype._onPan = function(e) {
        if (this._state !== 'animating' && (Math.abs(e.dx) > $4f63729a8b2a7c09$var$DRAG_THRESHOLD || Math.abs(e.dy) > $4f63729a8b2a7c09$var$DRAG_THRESHOLD)) {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            this.api.dispatchAction({
                type: 'treemapMove',
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rootLayout.x + e.dx,
                    y: rootLayout.y + e.dy,
                    width: rootLayout.width,
                    height: rootLayout.height
                }
            });
        }
    };
    TreemapView.prototype._onZoom = function(e) {
        var mouseX = e.originX;
        var mouseY = e.originY;
        var zoomDelta = e.scale;
        if (this._state !== 'animating') {
            // These param must not be cached.
            var root = this.seriesModel.getData().tree.root;
            if (!root) return;
            var rootLayout = root.getLayout();
            if (!rootLayout) return;
            var rect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
            // scaleLimit
            var zoomLimit = null;
            var _controllerHost = this._controllerHost;
            zoomLimit = _controllerHost.zoomLimit;
            var newZoom = _controllerHost.zoom = _controllerHost.zoom || 1;
            newZoom *= zoomDelta;
            if (zoomLimit) {
                var zoomMin = zoomLimit.min || 0;
                var zoomMax = zoomLimit.max || Infinity;
                newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
            }
            var zoomScale = newZoom / _controllerHost.zoom;
            _controllerHost.zoom = newZoom;
            var layoutInfo = this.seriesModel.layoutInfo;
            // Transform mouse coord from global to containerGroup.
            mouseX -= layoutInfo.x;
            mouseY -= layoutInfo.y;
            // Scale root bounding rect.
            var m = $78537c687449356c$export$185802fd694ee1f5();
            $78537c687449356c$export$d73ee8ef04f5226a(m, m, [
                -mouseX,
                -mouseY
            ]);
            $78537c687449356c$export$dcdf75081b88279d(m, m, [
                zoomScale,
                zoomScale
            ]);
            $78537c687449356c$export$d73ee8ef04f5226a(m, m, [
                mouseX,
                mouseY
            ]);
            rect.applyTransform(m);
            this.api.dispatchAction({
                type: 'treemapRender',
                from: this.uid,
                seriesId: this.seriesModel.id,
                rootRect: {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                }
            });
        }
    };
    TreemapView.prototype._initEvents = function(containerGroup) {
        var _this = this;
        containerGroup.on('click', function(e) {
            if (_this._state !== 'ready') return;
            var nodeClick = _this.seriesModel.get('nodeClick', true);
            if (!nodeClick) return;
            var targetInfo = _this.findTarget(e.offsetX, e.offsetY);
            if (!targetInfo) return;
            var node = targetInfo.node;
            if (node.getLayout().isLeafRoot) _this._rootToNode(targetInfo);
            else {
                if (nodeClick === 'zoomToNode') _this._zoomToNode(targetInfo);
                else if (nodeClick === 'link') {
                    var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
                    var link = itemModel.get('link', true);
                    var linkTarget = itemModel.get('target', true) || 'blank';
                    link && (0, $ff2fba995230f3c9$export$13e13f9b96dbe8fa)(link, linkTarget);
                }
            }
        }, this);
    };
    TreemapView.prototype._renderBreadcrumb = function(seriesModel, api, targetInfo) {
        var _this = this;
        if (!targetInfo) {
            targetInfo = seriesModel.get('leafDepth', true) != null ? {
                node: seriesModel.getViewRoot()
            } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
            if (!targetInfo) targetInfo = {
                node: seriesModel.getData().tree.root
            };
        }
        (this._breadcrumb || (this._breadcrumb = new (0, $e98ead0fb9ca7469$export$2e2bcd8739ae039)(this.group))).render(seriesModel, api, targetInfo.node, function(node) {
            if (_this._state !== 'animating') $cbdb4002b7a38cc3$export$df59de26c77b5bea(seriesModel.getViewRoot(), node) ? _this._rootToNode({
                node: node
            }) : _this._zoomToNode({
                node: node
            });
        });
    };
    /**
   * @override
   */ TreemapView.prototype.remove = function() {
        this._clearController();
        this._containerGroup && this._containerGroup.removeAll();
        this._storage = $4f63729a8b2a7c09$var$createStorage();
        this._state = 'ready';
        this._breadcrumb && this._breadcrumb.remove();
    };
    TreemapView.prototype.dispose = function() {
        this._clearController();
    };
    TreemapView.prototype._zoomToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: 'treemapZoomToNode',
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    TreemapView.prototype._rootToNode = function(targetInfo) {
        this.api.dispatchAction({
            type: 'treemapRootToNode',
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: targetInfo.node
        });
    };
    /**
   * @public
   * @param {number} x Global coord x.
   * @param {number} y Global coord y.
   * @return {Object} info If not found, return undefined;
   * @return {number} info.node Target node.
   * @return {number} info.offsetX x refer to target node.
   * @return {number} info.offsetY y refer to target node.
   */ TreemapView.prototype.findTarget = function(x, y) {
        var targetInfo;
        var viewRoot = this.seriesModel.getViewRoot();
        viewRoot.eachNode({
            attr: 'viewChildren',
            order: 'preorder'
        }, function(node) {
            var bgEl = this._storage.background[node.getRawIndex()];
            // If invisible, there might be no element.
            if (bgEl) {
                var point = bgEl.transformCoordToLocal(x, y);
                var shape = bgEl.shape;
                // For performance consideration, don't use 'getBoundingRect'.
                if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) targetInfo = {
                    node: node,
                    offsetX: point[0],
                    offsetY: point[1]
                };
                else return false; // Suppress visit subtree.
            }
        }, this);
        return targetInfo;
    };
    TreemapView.type = 'treemap';
    return TreemapView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
/**
 * @inner
 */ function $4f63729a8b2a7c09$var$createStorage() {
    return {
        nodeGroup: [],
        background: [],
        content: []
    };
}
/**
 * @inner
 * @return Return undefined means do not travel further.
 */ function $4f63729a8b2a7c09$var$renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
    // Whether under viewRoot.
    if (!thisNode) // Deleting nodes will be performed finally. This method just find
    // element from old storage, or create new element, set them to new
    // storage, and set styles.
    return;
    // -------------------------------------------------------------------
    // Start of closure variables available in "Procedures in renderNode".
    var thisLayout = thisNode.getLayout();
    var data = seriesModel.getData();
    var nodeModel = thisNode.getModel();
    // Only for enabling highlight/downplay. Clear firstly.
    // Because some node will not be rendered.
    data.setItemGraphicEl(thisNode.dataIndex, null);
    if (!thisLayout || !thisLayout.isInView) return;
    var thisWidth = thisLayout.width;
    var thisHeight = thisLayout.height;
    var borderWidth = thisLayout.borderWidth;
    var thisInvisible = thisLayout.invisible;
    var thisRawIndex = thisNode.getRawIndex();
    var oldRawIndex = oldNode && oldNode.getRawIndex();
    var thisViewChildren = thisNode.viewChildren;
    var upperHeight = thisLayout.upperHeight;
    var isParent = thisViewChildren && thisViewChildren.length;
    var itemStyleNormalModel = nodeModel.getModel('itemStyle');
    var itemStyleEmphasisModel = nodeModel.getModel([
        'emphasis',
        'itemStyle'
    ]);
    var itemStyleBlurModel = nodeModel.getModel([
        'blur',
        'itemStyle'
    ]);
    var itemStyleSelectModel = nodeModel.getModel([
        'select',
        'itemStyle'
    ]);
    var borderRadius = itemStyleNormalModel.get('borderRadius') || 0;
    // End of closure ariables available in "Procedures in renderNode".
    // -----------------------------------------------------------------
    // Node group
    var group = giveGraphic('nodeGroup', $4f63729a8b2a7c09$var$Group);
    if (!group) return;
    parentGroup.add(group);
    // x,y are not set when el is above view root.
    group.x = thisLayout.x || 0;
    group.y = thisLayout.y || 0;
    group.markRedraw();
    $4f63729a8b2a7c09$var$inner(group).nodeWidth = thisWidth;
    $4f63729a8b2a7c09$var$inner(group).nodeHeight = thisHeight;
    if (thisLayout.isAboveViewRoot) return group;
    // Background
    var bg = giveGraphic('background', $4f63729a8b2a7c09$var$Rect, depth, $4f63729a8b2a7c09$var$Z2_BG);
    bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight);
    var emphasisModel = nodeModel.getModel('emphasis');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var isDisabled = emphasisModel.get('disabled');
    var focusOrIndices = focus === 'ancestor' ? thisNode.getAncestorsIndices() : focus === 'descendant' ? thisNode.getDescendantIndices() : focus;
    // No children, render content.
    if (isParent) {
        // Because of the implementation about "traverse" in graphic hover style, we
        // can not set hover listener on the "group" of non-leaf node. Otherwise the
        // hover event from the descendents will be listenered.
        if ((0, $b414df7d361a211c$export$77d1445f699c58b5)(group)) (0, $b414df7d361a211c$export$9ba15aea1e048d48)(group, false);
        if (bg) {
            (0, $b414df7d361a211c$export$9ba15aea1e048d48)(bg, !isDisabled);
            // Only for enabling highlight/downplay.
            data.setItemGraphicEl(thisNode.dataIndex, bg);
            (0, $b414df7d361a211c$export$24972466b2b62ac2)(bg, focusOrIndices, blurScope);
        }
    } else {
        var content = giveGraphic('content', $4f63729a8b2a7c09$var$Rect, depth, $4f63729a8b2a7c09$var$Z2_CONTENT);
        content && renderContent(group, content);
        bg.disableMorphing = true;
        if (bg && (0, $b414df7d361a211c$export$77d1445f699c58b5)(bg)) (0, $b414df7d361a211c$export$9ba15aea1e048d48)(bg, false);
        (0, $b414df7d361a211c$export$9ba15aea1e048d48)(group, !isDisabled);
        // Only for enabling highlight/downplay.
        data.setItemGraphicEl(thisNode.dataIndex, group);
        var cursorStyle = nodeModel.getShallow('cursor');
        cursorStyle && content.attr('cursor', cursorStyle);
        (0, $b414df7d361a211c$export$24972466b2b62ac2)(group, focusOrIndices, blurScope);
    }
    return group;
    // ----------------------------
    // | Procedures in renderNode |
    // ----------------------------
    function renderBackground(group, bg, useUpperLabel) {
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(bg);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        bg.setShape({
            x: 0,
            y: 0,
            width: thisWidth,
            height: thisHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(bg);
        else {
            bg.invisible = false;
            var style = thisNode.getVisual('style');
            var visualBorderColor = style.stroke;
            var normalStyle = $4f63729a8b2a7c09$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualBorderColor;
            var emphasisStyle = $4f63729a8b2a7c09$var$getStateItemStyle(itemStyleEmphasisModel);
            emphasisStyle.fill = itemStyleEmphasisModel.get('borderColor');
            var blurStyle = $4f63729a8b2a7c09$var$getStateItemStyle(itemStyleBlurModel);
            blurStyle.fill = itemStyleBlurModel.get('borderColor');
            var selectStyle = $4f63729a8b2a7c09$var$getStateItemStyle(itemStyleSelectModel);
            selectStyle.fill = itemStyleSelectModel.get('borderColor');
            if (useUpperLabel) {
                var upperLabelWidth = thisWidth - 2 * borderWidth;
                prepareText(// PENDING: convert ZRColor to ColorString for text.
                bg, visualBorderColor, style.opacity, {
                    x: borderWidth,
                    y: 0,
                    width: upperLabelWidth,
                    height: upperHeight
                });
            } else bg.removeTextContent();
            bg.setStyle(normalStyle);
            bg.ensureState('emphasis').style = emphasisStyle;
            bg.ensureState('blur').style = blurStyle;
            bg.ensureState('select').style = selectStyle;
            (0, $b414df7d361a211c$export$20f39bbe322fb9ab)(bg);
        }
        group.add(bg);
    }
    function renderContent(group, content) {
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(content);
        // For tooltip.
        ecData.dataIndex = thisNode.dataIndex;
        ecData.seriesIndex = seriesModel.seriesIndex;
        var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
        var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
        content.culling = true;
        content.setShape({
            x: borderWidth,
            y: borderWidth,
            width: contentWidth,
            height: contentHeight,
            r: borderRadius
        });
        if (thisInvisible) // If invisible, do not set visual, otherwise the element will
        // change immediately before animation. We think it is OK to
        // remain its origin color when moving out of the view window.
        processInvisible(content);
        else {
            content.invisible = false;
            var nodeStyle = thisNode.getVisual('style');
            var visualColor = nodeStyle.fill;
            var normalStyle = $4f63729a8b2a7c09$var$getItemStyleNormal(itemStyleNormalModel);
            normalStyle.fill = visualColor;
            normalStyle.decal = nodeStyle.decal;
            var emphasisStyle = $4f63729a8b2a7c09$var$getStateItemStyle(itemStyleEmphasisModel);
            var blurStyle = $4f63729a8b2a7c09$var$getStateItemStyle(itemStyleBlurModel);
            var selectStyle = $4f63729a8b2a7c09$var$getStateItemStyle(itemStyleSelectModel);
            // PENDING: convert ZRColor to ColorString for text.
            prepareText(content, visualColor, nodeStyle.opacity, null);
            content.setStyle(normalStyle);
            content.ensureState('emphasis').style = emphasisStyle;
            content.ensureState('blur').style = blurStyle;
            content.ensureState('select').style = selectStyle;
            (0, $b414df7d361a211c$export$20f39bbe322fb9ab)(content);
        }
        group.add(content);
    }
    function processInvisible(element) {
        // Delay invisible setting utill animation finished,
        // avoid element vanish suddenly before animation.
        !element.invisible && willInvisibleEls.push(element);
    }
    function prepareText(rectEl, visualColor, visualOpacity, // Can be null/undefined
    upperLabelRect) {
        var normalLabelModel = nodeModel.getModel(upperLabelRect ? $4f63729a8b2a7c09$var$PATH_UPPERLABEL_NORMAL : $4f63729a8b2a7c09$var$PATH_LABEL_NOAMAL);
        var defaultText = (0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)(nodeModel.get('name'), null);
        var isShow = normalLabelModel.getShallow('show');
        (0, $3828198b2f2de836$export$9a13992917966657)(rectEl, (0, $3828198b2f2de836$export$9739a32674be5893)(nodeModel, upperLabelRect ? $4f63729a8b2a7c09$var$PATH_UPPERLABEL_NORMAL : $4f63729a8b2a7c09$var$PATH_LABEL_NOAMAL), {
            defaultText: isShow ? defaultText : null,
            inheritColor: visualColor,
            defaultOpacity: visualOpacity,
            labelFetcher: seriesModel,
            labelDataIndex: thisNode.dataIndex
        });
        var textEl = rectEl.getTextContent();
        if (!textEl) return;
        var textStyle = textEl.style;
        var textPadding = (0, $1b239fc9d3a2f8ae$export$f3a38102c49f4268)(textStyle.padding || 0);
        if (upperLabelRect) {
            rectEl.setTextConfig({
                layoutRect: upperLabelRect
            });
            textEl.disableLabelLayout = true;
        }
        textEl.beforeUpdate = function() {
            var width = Math.max((upperLabelRect ? upperLabelRect.width : rectEl.shape.width) - textPadding[1] - textPadding[3], 0);
            var height = Math.max((upperLabelRect ? upperLabelRect.height : rectEl.shape.height) - textPadding[0] - textPadding[2], 0);
            if (textStyle.width !== width || textStyle.height !== height) textEl.setStyle({
                width: width,
                height: height
            });
        };
        textStyle.truncateMinChar = 2;
        textStyle.lineOverflow = 'truncate';
        addDrillDownIcon(textStyle, upperLabelRect, thisLayout);
        var textEmphasisState = textEl.getState('emphasis');
        addDrillDownIcon(textEmphasisState ? textEmphasisState.style : null, upperLabelRect, thisLayout);
    }
    function addDrillDownIcon(style, upperLabelRect, thisLayout) {
        var text = style ? style.text : null;
        if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
            var iconChar = seriesModel.get('drillDownIcon', true);
            style.text = iconChar ? iconChar + ' ' + text : text;
        }
    }
    function giveGraphic(storageName, Ctor, depth, z) {
        var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
        var lasts = lastsForAnimation[storageName];
        if (element) {
            // Remove from oldStorage
            oldStorage[storageName][oldRawIndex] = null;
            prepareAnimationWhenHasOld(lasts, element);
        } else if (!thisInvisible) {
            element = new Ctor();
            if (element instanceof (0, $cfd8540aca1ca40f$export$2e2bcd8739ae039)) element.z2 = $4f63729a8b2a7c09$var$calculateZ2(depth, z);
            prepareAnimationWhenNoOld(lasts, element);
        }
        // Set to thisStorage
        return thisStorage[storageName][thisRawIndex] = element;
    }
    function prepareAnimationWhenHasOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        if (element instanceof $4f63729a8b2a7c09$var$Group) {
            lastCfg.oldX = element.x;
            lastCfg.oldY = element.y;
        } else lastCfg.oldShape = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, element.shape);
    }
    // If a element is new, we need to find the animation start point carefully,
    // otherwise it will looks strange when 'zoomToNode'.
    function prepareAnimationWhenNoOld(lasts, element) {
        var lastCfg = lasts[thisRawIndex] = {};
        var parentNode = thisNode.parentNode;
        var isGroup = element instanceof $6c313c3ef6000a43$export$2e2bcd8739ae039;
        if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
            var parentOldX = 0;
            var parentOldY = 0;
            // New nodes appear from right-bottom corner in 'zoomToNode' animation.
            // For convenience, get old bounding rect from background.
            var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
            if (!reRoot && parentOldBg && parentOldBg.oldShape) {
                parentOldX = parentOldBg.oldShape.width;
                parentOldY = parentOldBg.oldShape.height;
            }
            // When no parent old shape found, its parent is new too,
            // so we can just use {x:0, y:0}.
            if (isGroup) {
                lastCfg.oldX = 0;
                lastCfg.oldY = parentOldY;
            } else lastCfg.oldShape = {
                x: parentOldX,
                y: parentOldY,
                width: 0,
                height: 0
            };
        }
        // Fade in, user can be aware that these nodes are new.
        lastCfg.fadein = !isGroup;
    }
}
// We cannot set all background with the same z, because the behaviour of
// drill down and roll up differ background creation sequence from tree
// hierarchy sequence, which cause lower background elements to overlap
// upper ones. So we calculate z based on depth.
// Moreover, we try to shrink down z interval to [0, 1] to avoid that
// treemap with large z overlaps other components.
function $4f63729a8b2a7c09$var$calculateZ2(depth, z2InLevel) {
    return depth * $4f63729a8b2a7c09$var$Z2_BASE + z2InLevel;
}
var $4f63729a8b2a7c09$export$2e2bcd8739ae039 = $4f63729a8b2a7c09$var$TreemapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $e0963dffa3af9ce8$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $e0963dffa3af9ce8$var$isObject = $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a;
var $e0963dffa3af9ce8$var$CATEGORY_DEFAULT_VISUAL_INDEX = -1;
var $e0963dffa3af9ce8$var$VisualMapping = /** @class */ function() {
    function VisualMapping(option) {
        var mappingMethod = option.mappingMethod;
        var visualType = option.type;
        var thisOption = this.option = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(option);
        this.type = visualType;
        this.mappingMethod = mappingMethod;
        this._normalizeData = $e0963dffa3af9ce8$var$normalizers[mappingMethod];
        var visualHandler = VisualMapping.visualHandlers[visualType];
        this.applyVisual = visualHandler.applyVisual;
        this.getColorMapper = visualHandler.getColorMapper;
        this._normalizedToVisual = visualHandler._normalizedToVisual[mappingMethod];
        if (mappingMethod === 'piecewise') {
            $e0963dffa3af9ce8$var$normalizeVisualRange(thisOption);
            $e0963dffa3af9ce8$var$preprocessForPiecewise(thisOption);
        } else if (mappingMethod === 'category') thisOption.categories ? $e0963dffa3af9ce8$var$preprocessForSpecifiedCategory(thisOption) : $e0963dffa3af9ce8$var$normalizeVisualRange(thisOption, true);
        else {
            // mappingMethod === 'linear' or 'fixed'
            $1b239fc9d3a2f8ae$export$a7a9523472993e97(mappingMethod !== 'linear' || thisOption.dataExtent);
            $e0963dffa3af9ce8$var$normalizeVisualRange(thisOption);
        }
    }
    VisualMapping.prototype.mapValueToVisual = function(value) {
        var normalized = this._normalizeData(value);
        return this._normalizedToVisual(normalized, value);
    };
    VisualMapping.prototype.getNormalizer = function() {
        return $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._normalizeData, this);
    };
    /**
   * List available visual types.
   *
   * @public
   * @return {Array.<string>}
   */ VisualMapping.listVisualTypes = function() {
        return $1b239fc9d3a2f8ae$export$ed97f33186d4b816(VisualMapping.visualHandlers);
    };
    // /**
    //  * @public
    //  */
    // static addVisualHandler(name, handler) {
    //     visualHandlers[name] = handler;
    // }
    /**
   * @public
   */ VisualMapping.isValidType = function(visualType) {
        return VisualMapping.visualHandlers.hasOwnProperty(visualType);
    };
    /**
   * Convenient method.
   * Visual can be Object or Array or primary type.
   */ VisualMapping.eachVisual = function(visual, callback, context) {
        if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(visual)) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(visual, callback, context);
        else callback.call(context, visual);
    };
    VisualMapping.mapVisual = function(visual, callback, context) {
        var isPrimary;
        var newVisual = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(visual) ? [] : $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(visual) ? {} : (isPrimary = true, null);
        VisualMapping.eachVisual(visual, function(v, key) {
            var newVal = callback.call(context, v, key);
            isPrimary ? newVisual = newVal : newVisual[key] = newVal;
        });
        return newVisual;
    };
    /**
   * Retrieve visual properties from given object.
   */ VisualMapping.retrieveVisuals = function(obj) {
        var ret = {};
        var hasVisual;
        obj && $e0963dffa3af9ce8$var$each(VisualMapping.visualHandlers, function(h, visualType) {
            if (obj.hasOwnProperty(visualType)) {
                ret[visualType] = obj[visualType];
                hasVisual = true;
            }
        });
        return hasVisual ? ret : null;
    };
    /**
   * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
   *
   * @public
   * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
   *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
   * @return {Array.<string>} Sorted visual types.
   */ VisualMapping.prepareVisualTypes = function(visualTypes) {
        if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(visualTypes)) visualTypes = visualTypes.slice();
        else if ($e0963dffa3af9ce8$var$isObject(visualTypes)) {
            var types_1 = [];
            $e0963dffa3af9ce8$var$each(visualTypes, function(item, type) {
                types_1.push(type);
            });
            visualTypes = types_1;
        } else return [];
        visualTypes.sort(function(type1, type2) {
            // color should be front of colorSaturation, colorAlpha, ...
            // symbol and symbolSize do not matter.
            return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
        });
        return visualTypes;
    };
    /**
   * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
   * Other visuals are only depends on themself.
   */ VisualMapping.dependsOn = function(visualType1, visualType2) {
        return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
    };
    /**
   * @param value
   * @param pieceList [{value: ..., interval: [min, max]}, ...]
   *                         Always from small to big.
   * @param findClosestWhenOutside Default to be false
   * @return index
   */ VisualMapping.findPieceIndex = function(value, pieceList, findClosestWhenOutside) {
        var possibleI;
        var abs = Infinity;
        // value has the higher priority.
        for(var i = 0, len = pieceList.length; i < len; i++){
            var pieceValue = pieceList[i].value;
            if (pieceValue != null) {
                if (pieceValue === value || $1b239fc9d3a2f8ae$export$844ec244b1367d54(pieceValue) && pieceValue === value + '') return i;
                findClosestWhenOutside && updatePossible(pieceValue, i);
            }
        }
        for(var i = 0, len = pieceList.length; i < len; i++){
            var piece = pieceList[i];
            var interval = piece.interval;
            var close_1 = piece.close;
            if (interval) {
                if (interval[0] === -Infinity) {
                    if ($e0963dffa3af9ce8$var$littleThan(close_1[1], value, interval[1])) return i;
                } else if (interval[1] === Infinity) {
                    if ($e0963dffa3af9ce8$var$littleThan(close_1[0], interval[0], value)) return i;
                } else if ($e0963dffa3af9ce8$var$littleThan(close_1[0], interval[0], value) && $e0963dffa3af9ce8$var$littleThan(close_1[1], value, interval[1])) return i;
                findClosestWhenOutside && updatePossible(interval[0], i);
                findClosestWhenOutside && updatePossible(interval[1], i);
            }
        }
        if (findClosestWhenOutside) return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
        function updatePossible(val, index) {
            var newAbs = Math.abs(val - value);
            if (newAbs < abs) {
                abs = newAbs;
                possibleI = index;
            }
        }
    };
    VisualMapping.visualHandlers = {
        color: {
            applyVisual: $e0963dffa3af9ce8$var$makeApplyVisual('color'),
            getColorMapper: function() {
                var thisOption = this.option;
                return $1b239fc9d3a2f8ae$export$2385a24977818dd0(thisOption.mappingMethod === 'category' ? function(value, isNormalized) {
                    !isNormalized && (value = this._normalizeData(value));
                    return $e0963dffa3af9ce8$var$doMapCategory.call(this, value);
                } : function(value, isNormalized, out) {
                    // If output rgb array
                    // which will be much faster and useful in pixel manipulation
                    var returnRGBArray = !!out;
                    !isNormalized && (value = this._normalizeData(value));
                    out = $35573db24643e2ef$export$66cb3c0e9efc61c8(value, thisOption.parsedVisual, out);
                    return returnRGBArray ? out : $35573db24643e2ef$export$fac44ee5b035f737(out, 'rgba');
                }, this);
            },
            _normalizedToVisual: {
                linear: function(normalized) {
                    return $35573db24643e2ef$export$fac44ee5b035f737($35573db24643e2ef$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), 'rgba');
                },
                category: $e0963dffa3af9ce8$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $e0963dffa3af9ce8$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $35573db24643e2ef$export$fac44ee5b035f737($35573db24643e2ef$export$66cb3c0e9efc61c8(normalized, this.option.parsedVisual), 'rgba');
                    return result;
                },
                fixed: $e0963dffa3af9ce8$var$doMapFixed
            }
        },
        colorHue: $e0963dffa3af9ce8$var$makePartialColorVisualHandler(function(color, value) {
            return $35573db24643e2ef$export$d898ae866e27bf18(color, value);
        }),
        colorSaturation: $e0963dffa3af9ce8$var$makePartialColorVisualHandler(function(color, value) {
            return $35573db24643e2ef$export$d898ae866e27bf18(color, null, value);
        }),
        colorLightness: $e0963dffa3af9ce8$var$makePartialColorVisualHandler(function(color, value) {
            return $35573db24643e2ef$export$d898ae866e27bf18(color, null, null, value);
        }),
        colorAlpha: $e0963dffa3af9ce8$var$makePartialColorVisualHandler(function(color, value) {
            return $35573db24643e2ef$export$ab4754bf42583a26(color, value);
        }),
        decal: {
            applyVisual: $e0963dffa3af9ce8$var$makeApplyVisual('decal'),
            _normalizedToVisual: {
                linear: null,
                category: $e0963dffa3af9ce8$var$doMapCategory,
                piecewise: null,
                fixed: null
            }
        },
        opacity: {
            applyVisual: $e0963dffa3af9ce8$var$makeApplyVisual('opacity'),
            _normalizedToVisual: $e0963dffa3af9ce8$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        },
        liftZ: {
            applyVisual: $e0963dffa3af9ce8$var$makeApplyVisual('liftZ'),
            _normalizedToVisual: {
                linear: $e0963dffa3af9ce8$var$doMapFixed,
                category: $e0963dffa3af9ce8$var$doMapFixed,
                piecewise: $e0963dffa3af9ce8$var$doMapFixed,
                fixed: $e0963dffa3af9ce8$var$doMapFixed
            }
        },
        symbol: {
            applyVisual: function(value, getter, setter) {
                var symbolCfg = this.mapValueToVisual(value);
                setter('symbol', symbolCfg);
            },
            _normalizedToVisual: {
                linear: $e0963dffa3af9ce8$var$doMapToArray,
                category: $e0963dffa3af9ce8$var$doMapCategory,
                piecewise: function(normalized, value) {
                    var result = $e0963dffa3af9ce8$var$getSpecifiedVisual.call(this, value);
                    if (result == null) result = $e0963dffa3af9ce8$var$doMapToArray.call(this, normalized);
                    return result;
                },
                fixed: $e0963dffa3af9ce8$var$doMapFixed
            }
        },
        symbolSize: {
            applyVisual: $e0963dffa3af9ce8$var$makeApplyVisual('symbolSize'),
            _normalizedToVisual: $e0963dffa3af9ce8$var$createNormalizedToNumericVisual([
                0,
                1
            ])
        }
    };
    return VisualMapping;
}();
function $e0963dffa3af9ce8$var$preprocessForPiecewise(thisOption) {
    var pieceList = thisOption.pieceList;
    thisOption.hasSpecialVisual = false;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(pieceList, function(piece, index) {
        piece.originIndex = index;
        // piece.visual is "result visual value" but not
        // a visual range, so it does not need to be normalized.
        if (piece.visual != null) thisOption.hasSpecialVisual = true;
    });
}
function $e0963dffa3af9ce8$var$preprocessForSpecifiedCategory(thisOption) {
    // Hash categories.
    var categories = thisOption.categories;
    var categoryMap = thisOption.categoryMap = {};
    var visual = thisOption.visual;
    $e0963dffa3af9ce8$var$each(categories, function(cate, index) {
        categoryMap[cate] = index;
    });
    // Process visual map input.
    if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(visual)) {
        var visualArr_1 = [];
        if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(visual)) $e0963dffa3af9ce8$var$each(visual, function(v, cate) {
            var index = categoryMap[cate];
            visualArr_1[index != null ? index : $e0963dffa3af9ce8$var$CATEGORY_DEFAULT_VISUAL_INDEX] = v;
        });
        else // Is primary type, represents default visual.
        visualArr_1[$e0963dffa3af9ce8$var$CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
        visual = $e0963dffa3af9ce8$var$setVisualToOption(thisOption, visualArr_1);
    }
    // Remove categories that has no visual,
    // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
    for(var i = categories.length - 1; i >= 0; i--)if (visual[i] == null) {
        delete categoryMap[categories[i]];
        categories.pop();
    }
}
function $e0963dffa3af9ce8$var$normalizeVisualRange(thisOption, isCategory) {
    var visual = thisOption.visual;
    var visualArr = [];
    if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(visual)) $e0963dffa3af9ce8$var$each(visual, function(v) {
        visualArr.push(v);
    });
    else if (visual != null) visualArr.push(visual);
    var doNotNeedPair = {
        color: 1,
        symbol: 1
    };
    if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) // Do not care visualArr.length === 0, which is illegal.
    visualArr[1] = visualArr[0];
    $e0963dffa3af9ce8$var$setVisualToOption(thisOption, visualArr);
}
function $e0963dffa3af9ce8$var$makePartialColorVisualHandler(applyValue) {
    return {
        applyVisual: function(value, getter, setter) {
            // Only used in HSL
            var colorChannel = this.mapValueToVisual(value);
            // Must not be array value
            setter('color', applyValue(getter('color'), colorChannel));
        },
        _normalizedToVisual: $e0963dffa3af9ce8$var$createNormalizedToNumericVisual([
            0,
            1
        ])
    };
}
function $e0963dffa3af9ce8$var$doMapToArray(normalized) {
    var visual = this.option.visual;
    return visual[Math.round((0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(normalized, [
        0,
        1
    ], [
        0,
        visual.length - 1
    ], true))] || {}; // TODO {}?
}
function $e0963dffa3af9ce8$var$makeApplyVisual(visualType) {
    return function(value, getter, setter) {
        setter(visualType, this.mapValueToVisual(value));
    };
}
function $e0963dffa3af9ce8$var$doMapCategory(normalized) {
    var visual = this.option.visual;
    return visual[this.option.loop && normalized !== $e0963dffa3af9ce8$var$CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
}
function $e0963dffa3af9ce8$var$doMapFixed() {
    // visual will be convert to array.
    return this.option.visual[0];
}
/**
 * Create mapped to numeric visual
 */ function $e0963dffa3af9ce8$var$createNormalizedToNumericVisual(sourceExtent) {
    return {
        linear: function(normalized) {
            return (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
        },
        category: $e0963dffa3af9ce8$var$doMapCategory,
        piecewise: function(normalized, value) {
            var result = $e0963dffa3af9ce8$var$getSpecifiedVisual.call(this, value);
            if (result == null) result = (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(normalized, sourceExtent, this.option.visual, true);
            return result;
        },
        fixed: $e0963dffa3af9ce8$var$doMapFixed
    };
}
function $e0963dffa3af9ce8$var$getSpecifiedVisual(value) {
    var thisOption = this.option;
    var pieceList = thisOption.pieceList;
    if (thisOption.hasSpecialVisual) {
        var pieceIndex = $e0963dffa3af9ce8$var$VisualMapping.findPieceIndex(value, pieceList);
        var piece = pieceList[pieceIndex];
        if (piece && piece.visual) return piece.visual[this.type];
    }
}
function $e0963dffa3af9ce8$var$setVisualToOption(thisOption, visualArr) {
    thisOption.visual = visualArr;
    if (thisOption.type === 'color') thisOption.parsedVisual = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(visualArr, function(item) {
        var color = $35573db24643e2ef$export$98e6a39c04603d36(item);
        color;
        return color || [
            0,
            0,
            0,
            1
        ];
    });
    return visualArr;
}
/**
 * Normalizers by mapping methods.
 */ var $e0963dffa3af9ce8$var$normalizers = {
    linear: function(value) {
        return (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(value, this.option.dataExtent, [
            0,
            1
        ], true);
    },
    piecewise: function(value) {
        var pieceList = this.option.pieceList;
        var pieceIndex = $e0963dffa3af9ce8$var$VisualMapping.findPieceIndex(value, pieceList, true);
        if (pieceIndex != null) return (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(pieceIndex, [
            0,
            pieceList.length - 1
        ], [
            0,
            1
        ], true);
    },
    category: function(value) {
        var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal value
        return index == null ? $e0963dffa3af9ce8$var$CATEGORY_DEFAULT_VISUAL_INDEX : index;
    },
    fixed: $1b239fc9d3a2f8ae$export$8793edee2d425525
};
function $e0963dffa3af9ce8$var$littleThan(close, a, b) {
    return close ? a <= b : a < b;
}
var $e0963dffa3af9ce8$export$2e2bcd8739ae039 = $e0963dffa3af9ce8$var$VisualMapping;





var $c368189f3c3ecf9c$var$ITEM_STYLE_NORMAL = 'itemStyle';
var $c368189f3c3ecf9c$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $c368189f3c3ecf9c$export$2e2bcd8739ae039 = {
    seriesType: 'treemap',
    reset: function(seriesModel) {
        var tree = seriesModel.getData().tree;
        var root = tree.root;
        if (root.isRemoved()) return;
        $c368189f3c3ecf9c$var$travelTree(root, // Visual should calculate from tree root but not view root.
        {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
    }
};
function $c368189f3c3ecf9c$var$travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
    var nodeModel = node.getModel();
    var nodeLayout = node.getLayout();
    var data = node.hostTree.data;
    // Optimize
    if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) return;
    var nodeItemStyleModel = nodeModel.getModel($c368189f3c3ecf9c$var$ITEM_STYLE_NORMAL);
    var visuals = $c368189f3c3ecf9c$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel);
    var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
    // calculate border color
    var borderColor = nodeItemStyleModel.get('borderColor');
    var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
    var thisNodeColor;
    if (borderColorSaturation != null) {
        // For performance, do not always execute 'calculateColor'.
        thisNodeColor = $c368189f3c3ecf9c$var$calculateColor(visuals);
        borderColor = $c368189f3c3ecf9c$var$calculateBorderColor(borderColorSaturation, thisNodeColor);
    }
    existsStyle.stroke = borderColor;
    var viewChildren = node.viewChildren;
    if (!viewChildren || !viewChildren.length) {
        thisNodeColor = $c368189f3c3ecf9c$var$calculateColor(visuals);
        // Apply visual to this node.
        existsStyle.fill = thisNodeColor;
    } else {
        var mapping_1 = $c368189f3c3ecf9c$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren);
        // Designate visual to children.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(viewChildren, function(child, index) {
            // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
            if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
                var childVisual = $c368189f3c3ecf9c$var$mapVisual(nodeModel, visuals, child, index, mapping_1, seriesModel);
                $c368189f3c3ecf9c$var$travelTree(child, childVisual, viewRootAncestors, seriesModel);
            }
        });
    }
}
function $c368189f3c3ecf9c$var$buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
    var visuals = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, designatedVisual);
    var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        'color',
        'colorAlpha',
        'colorSaturation'
    ], function(visualName) {
        // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
        designatedVisualItemStyle[visualName] = designatedVisual[visualName];
        var val = nodeItemStyleModel.get(visualName);
        designatedVisualItemStyle[visualName] = null;
        val != null && (visuals[visualName] = val);
    });
    return visuals;
}
function $c368189f3c3ecf9c$var$calculateColor(visuals) {
    var color = $c368189f3c3ecf9c$var$getValueVisualDefine(visuals, 'color');
    if (color) {
        var colorAlpha = $c368189f3c3ecf9c$var$getValueVisualDefine(visuals, 'colorAlpha');
        var colorSaturation = $c368189f3c3ecf9c$var$getValueVisualDefine(visuals, 'colorSaturation');
        if (colorSaturation) color = (0, $35573db24643e2ef$export$d898ae866e27bf18)(color, null, null, colorSaturation);
        if (colorAlpha) color = (0, $35573db24643e2ef$export$ab4754bf42583a26)(color, colorAlpha);
        return color;
    }
}
function $c368189f3c3ecf9c$var$calculateBorderColor(borderColorSaturation, thisNodeColor) {
    return thisNodeColor != null ? (0, $35573db24643e2ef$export$d898ae866e27bf18)(thisNodeColor, null, null, borderColorSaturation) : null;
}
function $c368189f3c3ecf9c$var$getValueVisualDefine(visuals, name) {
    var value = visuals[name];
    if (value != null && value !== 'none') return value;
}
function $c368189f3c3ecf9c$var$buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
    if (!viewChildren || !viewChildren.length) return;
    var rangeVisual = $c368189f3c3ecf9c$var$getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && ($c368189f3c3ecf9c$var$getRangeVisual(nodeModel, 'colorAlpha') || $c368189f3c3ecf9c$var$getRangeVisual(nodeModel, 'colorSaturation'));
    if (!rangeVisual) return;
    var visualMin = nodeModel.get('visualMin');
    var visualMax = nodeModel.get('visualMax');
    var dataExtent = nodeLayout.dataExtent.slice();
    visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
    visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
    var colorMappingBy = nodeModel.get('colorMappingBy');
    var opt = {
        type: rangeVisual.name,
        dataExtent: dataExtent,
        visual: rangeVisual.range
    };
    if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
        opt.mappingMethod = 'category';
        opt.loop = true;
    // categories is ordinal, so do not set opt.categories.
    } else opt.mappingMethod = 'linear';
    var mapping = new (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039)(opt);
    $c368189f3c3ecf9c$var$inner(mapping).drColorMappingBy = colorMappingBy;
    return mapping;
}
// Notice: If we don't have the attribute 'colorRange', but only use
// attribute 'color' to represent both concepts of 'colorRange' and 'color',
// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
// this problem will be encountered:
// If a level-1 node doesn't have children, and its siblings have children,
// and colorRange is set on level-1, then the node cannot be colored.
// So we separate 'colorRange' and 'color' to different attributes.
function $c368189f3c3ecf9c$var$getRangeVisual(nodeModel, name) {
    // 'colorRange', 'colorARange', 'colorSRange'.
    // If not exists on this node, fetch from levels and series.
    var range = nodeModel.get(name);
    return (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(range) && range.length ? {
        name: name,
        range: range
    } : null;
}
function $c368189f3c3ecf9c$var$mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
    var childVisuals = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, visuals);
    if (mapping) {
        // Only support color, colorAlpha, colorSaturation.
        var mappingType = mapping.type;
        var colorMappingBy = mappingType === 'color' && $c368189f3c3ecf9c$var$inner(mapping).drColorMappingBy;
        var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
        childVisuals[mappingType] = mapping.mapValueToVisual(value);
    }
    return childVisuals;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* The treemap layout implementation was originally copied from
* "d3.js" with some modifications made for this project.
* (See more details in the comment of the method "squarify" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 




var $aaba05b85ec4c91f$var$mathMax = Math.max;
var $aaba05b85ec4c91f$var$mathMin = Math.min;
var $aaba05b85ec4c91f$var$retrieveValue = $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66;
var $aaba05b85ec4c91f$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $aaba05b85ec4c91f$var$PATH_BORDER_WIDTH = [
    'itemStyle',
    'borderWidth'
];
var $aaba05b85ec4c91f$var$PATH_GAP_WIDTH = [
    'itemStyle',
    'gapWidth'
];
var $aaba05b85ec4c91f$var$PATH_UPPER_LABEL_SHOW = [
    'upperLabel',
    'show'
];
var $aaba05b85ec4c91f$var$PATH_UPPER_LABEL_HEIGHT = [
    'upperLabel',
    'height'
];
var /**
 * @public
 */ $aaba05b85ec4c91f$export$2e2bcd8739ae039 = {
    seriesType: 'treemap',
    reset: function(seriesModel, ecModel, api, payload) {
        // Layout result in each node:
        // {x, y, width, height, area, borderWidth}
        var ecWidth = api.getWidth();
        var ecHeight = api.getHeight();
        var seriesOption = seriesModel.option;
        var layoutInfo = $501dc28f6c4d24ac$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        var size = seriesOption.size || []; // Compatible with ec2.
        var containerWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)($aaba05b85ec4c91f$var$retrieveValue(layoutInfo.width, size[0]), ecWidth);
        var containerHeight = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)($aaba05b85ec4c91f$var$retrieveValue(layoutInfo.height, size[1]), ecHeight);
        // Fetch payload info.
        var payloadType = payload && payload.type;
        var types = [
            'treemapZoomToNode',
            'treemapRootToNode'
        ];
        var targetInfo = $cbdb4002b7a38cc3$export$c5445fa59c15dec4(payload, types, seriesModel);
        var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
        var viewRoot = seriesModel.getViewRoot();
        var viewAbovePath = $cbdb4002b7a38cc3$export$6be31fe4499506f9(viewRoot);
        if (payloadType !== 'treemapMove') {
            var rootSize = payloadType === 'treemapZoomToNode' ? $aaba05b85ec4c91f$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [
                rootRect.width,
                rootRect.height
            ] : [
                containerWidth,
                containerHeight
            ];
            var sort_1 = seriesOption.sort;
            if (sort_1 && sort_1 !== 'asc' && sort_1 !== 'desc') // Default to be desc order.
            sort_1 = 'desc';
            var options = {
                squareRatio: seriesOption.squareRatio,
                sort: sort_1,
                leafDepth: seriesOption.leafDepth
            };
            // layout should be cleared because using updateView but not update.
            viewRoot.hostTree.clearLayouts();
            // TODO
            // optimize: if out of view clip, do not layout.
            // But take care that if do not render node out of view clip,
            // how to calculate start po
            var viewRootLayout_1 = {
                x: 0,
                y: 0,
                width: rootSize[0],
                height: rootSize[1],
                area: rootSize[0] * rootSize[1]
            };
            viewRoot.setLayout(viewRootLayout_1);
            $aaba05b85ec4c91f$var$squarify(viewRoot, options, false, 0);
            // Supplement layout.
            viewRootLayout_1 = viewRoot.getLayout();
            $aaba05b85ec4c91f$var$each(viewAbovePath, function(node, index) {
                var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
                node.setLayout($1b239fc9d3a2f8ae$export$8b58be045bf06082({
                    dataExtent: [
                        childValue,
                        childValue
                    ],
                    borderWidth: 0,
                    upperHeight: 0
                }, viewRootLayout_1));
            });
        }
        var treeRoot = seriesModel.getData().tree.root;
        treeRoot.setLayout($aaba05b85ec4c91f$var$calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
        seriesModel.setLayoutInfo(layoutInfo);
        // FIXME
        // 现在没有clip功能，暂时取ec高宽。
        $aaba05b85ec4c91f$var$prunning(treeRoot, // Transform to base element coordinate system.
        new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
    }
};
/**
 * Layout treemap with squarify algorithm.
 * The original presentation of this algorithm
 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
 * The implementation of this algorithm was originally copied from "d3.js"
 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
 * with some modifications made for this program.
 * See the license statement at the head of this file.
 *
 * @protected
 * @param {module:echarts/data/Tree~TreeNode} node
 * @param {Object} options
 * @param {string} options.sort 'asc' or 'desc'
 * @param {number} options.squareRatio
 * @param {boolean} hideChildren
 * @param {number} depth
 */ function $aaba05b85ec4c91f$var$squarify(node, options, hideChildren, depth) {
    var width;
    var height;
    if (node.isRemoved()) return;
    var thisLayout = node.getLayout();
    width = thisLayout.width;
    height = thisLayout.height;
    // Considering border and gap
    var nodeModel = node.getModel();
    var borderWidth = nodeModel.get($aaba05b85ec4c91f$var$PATH_BORDER_WIDTH);
    var halfGapWidth = nodeModel.get($aaba05b85ec4c91f$var$PATH_GAP_WIDTH) / 2;
    var upperLabelHeight = $aaba05b85ec4c91f$var$getUpperLabelHeight(nodeModel);
    var upperHeight = Math.max(borderWidth, upperLabelHeight);
    var layoutOffset = borderWidth - halfGapWidth;
    var layoutOffsetUpper = upperHeight - halfGapWidth;
    node.setLayout({
        borderWidth: borderWidth,
        upperHeight: upperHeight,
        upperLabelHeight: upperLabelHeight
    }, true);
    width = $aaba05b85ec4c91f$var$mathMax(width - 2 * layoutOffset, 0);
    height = $aaba05b85ec4c91f$var$mathMax(height - layoutOffset - layoutOffsetUpper, 0);
    var totalArea = width * height;
    var viewChildren = $aaba05b85ec4c91f$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
    if (!viewChildren.length) return;
    var rect = {
        x: layoutOffset,
        y: layoutOffsetUpper,
        width: width,
        height: height
    };
    var rowFixedLength = $aaba05b85ec4c91f$var$mathMin(width, height);
    var best = Infinity; // the best row score so far
    var row = [];
    row.area = 0;
    for(var i = 0, len = viewChildren.length; i < len;){
        var child = viewChildren[i];
        row.push(child);
        row.area += child.getLayout().area;
        var score = $aaba05b85ec4c91f$var$worst(row, rowFixedLength, options.squareRatio);
        // continue with this orientation
        if (score <= best) {
            i++;
            best = score;
        } else {
            row.area -= row.pop().getLayout().area;
            $aaba05b85ec4c91f$var$position(row, rowFixedLength, rect, halfGapWidth, false);
            rowFixedLength = $aaba05b85ec4c91f$var$mathMin(rect.width, rect.height);
            row.length = row.area = 0;
            best = Infinity;
        }
    }
    if (row.length) $aaba05b85ec4c91f$var$position(row, rowFixedLength, rect, halfGapWidth, true);
    if (!hideChildren) {
        var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
        if (childrenVisibleMin != null && totalArea < childrenVisibleMin) hideChildren = true;
    }
    for(var i = 0, len = viewChildren.length; i < len; i++)$aaba05b85ec4c91f$var$squarify(viewChildren[i], options, hideChildren, depth + 1);
}
/**
 * Set area to each child, and calculate data extent for visual coding.
 */ function $aaba05b85ec4c91f$var$initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
    var viewChildren = node.children || [];
    var orderBy = options.sort;
    orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
    var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth;
    // leafDepth has higher priority.
    if (hideChildren && !overLeafDepth) return node.viewChildren = [];
    // Sort children, order by desc.
    viewChildren = $1b239fc9d3a2f8ae$export$3dea766d36a8935f(viewChildren, function(child) {
        return !child.isRemoved();
    });
    $aaba05b85ec4c91f$var$sort(viewChildren, orderBy);
    var info = $aaba05b85ec4c91f$var$statistic(nodeModel, viewChildren, orderBy);
    if (info.sum === 0) return node.viewChildren = [];
    info.sum = $aaba05b85ec4c91f$var$filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
    if (info.sum === 0) return node.viewChildren = [];
    // Set area to each child.
    for(var i = 0, len = viewChildren.length; i < len; i++){
        var area = viewChildren[i].getValue() / info.sum * totalArea;
        // Do not use setLayout({...}, true), because it is needed to clear last layout.
        viewChildren[i].setLayout({
            area: area
        });
    }
    if (overLeafDepth) {
        viewChildren.length && node.setLayout({
            isLeafRoot: true
        }, true);
        viewChildren.length = 0;
    }
    node.viewChildren = viewChildren;
    node.setLayout({
        dataExtent: info.dataExtent
    }, true);
    return viewChildren;
}
/**
 * Consider 'visibleMin'. Modify viewChildren and get new sum.
 */ function $aaba05b85ec4c91f$var$filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
    // visibleMin is not supported yet when no option.sort.
    if (!orderBy) return sum;
    var visibleMin = nodeModel.get('visibleMin');
    var len = orderedChildren.length;
    var deletePoint = len;
    // Always travel from little value to big value.
    for(var i = len - 1; i >= 0; i--){
        var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
        if (value / sum * totalArea < visibleMin) {
            deletePoint = i;
            sum -= value;
        }
    }
    orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
    return sum;
}
/**
 * Sort
 */ function $aaba05b85ec4c91f$var$sort(viewChildren, orderBy) {
    if (orderBy) viewChildren.sort(function(a, b) {
        var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
        return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
    });
    return viewChildren;
}
/**
 * Statistic
 */ function $aaba05b85ec4c91f$var$statistic(nodeModel, children, orderBy) {
    // Calculate sum.
    var sum = 0;
    for(var i = 0, len = children.length; i < len; i++)sum += children[i].getValue();
    // Statistic data extent for latter visual coding.
    // Notice: data extent should be calculate based on raw children
    // but not filtered view children, otherwise visual mapping will not
    // be stable when zoom (where children is filtered by visibleMin).
    var dimension = nodeModel.get('visualDimension');
    var dataExtent;
    // The same as area dimension.
    if (!children || !children.length) dataExtent = [
        NaN,
        NaN
    ];
    else if (dimension === 'value' && orderBy) {
        dataExtent = [
            children[children.length - 1].getValue(),
            children[0].getValue()
        ];
        orderBy === 'asc' && dataExtent.reverse();
    } else {
        dataExtent = [
            Infinity,
            -Infinity
        ];
        $aaba05b85ec4c91f$var$each(children, function(child) {
            var value = child.getValue(dimension);
            value < dataExtent[0] && (dataExtent[0] = value);
            value > dataExtent[1] && (dataExtent[1] = value);
        });
    }
    return {
        sum: sum,
        dataExtent: dataExtent
    };
}
/**
 * Computes the score for the specified row,
 * as the worst aspect ratio.
 */ function $aaba05b85ec4c91f$var$worst(row, rowFixedLength, ratio) {
    var areaMax = 0;
    var areaMin = Infinity;
    for(var i = 0, area = void 0, len = row.length; i < len; i++){
        area = row[i].getLayout().area;
        if (area) {
            area < areaMin && (areaMin = area);
            area > areaMax && (areaMax = area);
        }
    }
    var squareArea = row.area * row.area;
    var f = rowFixedLength * rowFixedLength * ratio;
    return squareArea ? $aaba05b85ec4c91f$var$mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
}
/**
 * Positions the specified row of nodes. Modifies `rect`.
 */ function $aaba05b85ec4c91f$var$position(row, rowFixedLength, rect, halfGapWidth, flush) {
    // When rowFixedLength === rect.width,
    // it is horizontal subdivision,
    // rowFixedLength is the width of the subdivision,
    // rowOtherLength is the height of the subdivision,
    // and nodes will be positioned from left to right.
    // wh[idx0WhenH] means: when horizontal,
    //      wh[idx0WhenH] => wh[0] => 'width'.
    //      xy[idx1WhenH] => xy[1] => 'y'.
    var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
    var idx1WhenH = 1 - idx0WhenH;
    var xy = [
        'x',
        'y'
    ];
    var wh = [
        'width',
        'height'
    ];
    var last = rect[xy[idx0WhenH]];
    var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
    if (flush || rowOtherLength > rect[wh[idx1WhenH]]) rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
    for(var i = 0, rowLen = row.length; i < rowLen; i++){
        var node = row[i];
        var nodeLayout = {};
        var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
        var wh1 = nodeLayout[wh[idx1WhenH]] = $aaba05b85ec4c91f$var$mathMax(rowOtherLength - 2 * halfGapWidth, 0);
        // We use Math.max/min to avoid negative width/height when considering gap width.
        var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
        var modWH = i === rowLen - 1 || remain < step ? remain : step;
        var wh0 = nodeLayout[wh[idx0WhenH]] = $aaba05b85ec4c91f$var$mathMax(modWH - 2 * halfGapWidth, 0);
        nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + $aaba05b85ec4c91f$var$mathMin(halfGapWidth, wh1 / 2);
        nodeLayout[xy[idx0WhenH]] = last + $aaba05b85ec4c91f$var$mathMin(halfGapWidth, wh0 / 2);
        last += modWH;
        node.setLayout(nodeLayout, true);
    }
    rect[xy[idx1WhenH]] += rowOtherLength;
    rect[wh[idx1WhenH]] -= rowOtherLength;
}
// Return [containerWidth, containerHeight] as default.
function $aaba05b85ec4c91f$var$estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
    // If targetInfo.node exists, we zoom to the node,
    // so estimate whole width and height by target node.
    var currNode = (targetInfo || {}).node;
    var defaultSize = [
        containerWidth,
        containerHeight
    ];
    if (!currNode || currNode === viewRoot) return defaultSize;
    var parent;
    var viewArea = containerWidth * containerHeight;
    var area = viewArea * seriesModel.option.zoomToNodeRatio;
    while(parent = currNode.parentNode){
        // jshint ignore:line
        var sum = 0;
        var siblings = parent.children;
        for(var i = 0, len = siblings.length; i < len; i++)sum += siblings[i].getValue();
        var currNodeValue = currNode.getValue();
        if (currNodeValue === 0) return defaultSize;
        area *= sum / currNodeValue;
        // Considering border, suppose aspect ratio is 1.
        var parentModel = parent.getModel();
        var borderWidth = parentModel.get($aaba05b85ec4c91f$var$PATH_BORDER_WIDTH);
        var upperHeight = Math.max(borderWidth, $aaba05b85ec4c91f$var$getUpperLabelHeight(parentModel));
        area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
        area > (0, $9fd90cf3bf18fbcd$export$18510406f204a1b9) && (area = (0, $9fd90cf3bf18fbcd$export$18510406f204a1b9));
        currNode = parent;
    }
    area < viewArea && (area = viewArea);
    var scale = Math.pow(area / viewArea, 0.5);
    return [
        containerWidth * scale,
        containerHeight * scale
    ];
}
// Root position based on coord of containerGroup
function $aaba05b85ec4c91f$var$calculateRootPosition(layoutInfo, rootRect, targetInfo) {
    if (rootRect) return {
        x: rootRect.x,
        y: rootRect.y
    };
    var defaultPosition = {
        x: 0,
        y: 0
    };
    if (!targetInfo) return defaultPosition;
    // If targetInfo is fetched by 'retrieveTargetInfo',
    // old tree and new tree are the same tree,
    // so the node still exists and we can visit it.
    var targetNode = targetInfo.node;
    var layout = targetNode.getLayout();
    if (!layout) return defaultPosition;
    // Transform coord from local to container.
    var targetCenter = [
        layout.width / 2,
        layout.height / 2
    ];
    var node = targetNode;
    while(node){
        var nodeLayout = node.getLayout();
        targetCenter[0] += nodeLayout.x;
        targetCenter[1] += nodeLayout.y;
        node = node.parentNode;
    }
    return {
        x: layoutInfo.width / 2 - targetCenter[0],
        y: layoutInfo.height / 2 - targetCenter[1]
    };
}
// Mark nodes visible for prunning when visual coding and rendering.
// Prunning depends on layout and root position, so we have to do it after layout.
function $aaba05b85ec4c91f$var$prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
    var nodeLayout = node.getLayout();
    var nodeInViewAbovePath = viewAbovePath[depth];
    var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
    if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) return;
    node.setLayout({
        // isInView means: viewRoot sub tree + viewAbovePath
        isInView: true,
        // invisible only means: outside view clip so that the node can not
        // see but still layout for animation preparation but not render.
        invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
        isAboveViewRoot: isAboveViewRoot
    }, true);
    // Transform to child coordinate.
    var childClipRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
    $aaba05b85ec4c91f$var$each(node.viewChildren || [], function(child) {
        $aaba05b85ec4c91f$var$prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
    });
}
function $aaba05b85ec4c91f$var$getUpperLabelHeight(model) {
    return model.get($aaba05b85ec4c91f$var$PATH_UPPER_LABEL_SHOW) ? model.get($aaba05b85ec4c91f$var$PATH_UPPER_LABEL_HEIGHT) : 0;
}


function $f993502a4ef2f084$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $9300d85770d0960a$export$2e2bcd8739ae039));
    registers.registerChartView((0, $4f63729a8b2a7c09$export$2e2bcd8739ae039));
    registers.registerVisual((0, $c368189f3c3ecf9c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $aaba05b85ec4c91f$export$2e2bcd8739ae039));
    (0, $8809f67a476e3c3a$export$1ad90fc3f3a8bbf9)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $a3eb6b45c47d1d67$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (!legendModels || !legendModels.length) return;
    ecModel.eachSeriesByType('graph', function(graphSeries) {
        var categoriesData = graphSeries.getCategoriesData();
        var graph = graphSeries.getGraph();
        var data = graph.data;
        var categoryNames = categoriesData.mapArray(categoriesData.getName);
        data.filterSelf(function(idx) {
            var model = data.getItemModel(idx);
            var category = model.getShallow('category');
            if (category != null) {
                if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(category)) category = categoryNames[category];
                // If in any legend component the status is not selected.
                for(var i = 0; i < legendModels.length; i++){
                    if (!legendModels[i].isSelected(category)) return false;
                }
            }
            return true;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $d6191c8947b6285c$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var categoriesData = seriesModel.getCategoriesData();
        var data = seriesModel.getData();
        var categoryNameIdxMap = {};
        categoriesData.each(function(idx) {
            var name = categoriesData.getName(idx);
            // Add prefix to avoid conflict with Object.prototype.
            categoryNameIdxMap['ec-' + name] = idx;
            var itemModel = categoriesData.getItemModel(idx);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (!style.fill) // Get color from palette.
            style.fill = seriesModel.getColorFromPalette(name, paletteScope);
            categoriesData.setItemVisual(idx, 'style', style);
            var symbolVisualList = [
                'symbol',
                'symbolSize',
                'symbolKeepAspect'
            ];
            for(var i = 0; i < symbolVisualList.length; i++){
                var symbolVisual = itemModel.getShallow(symbolVisualList[i], true);
                if (symbolVisual != null) categoriesData.setItemVisual(idx, symbolVisualList[i], symbolVisual);
            }
        });
        // Assign category color to visual
        if (categoriesData.count()) data.each(function(idx) {
            var model = data.getItemModel(idx);
            var categoryIdx = model.getShallow('category');
            if (categoryIdx != null) {
                if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(categoryIdx)) categoryIdx = categoryNameIdxMap['ec-' + categoryIdx];
                var categoryStyle = categoriesData.getItemVisual(categoryIdx, 'style');
                var style = data.ensureUniqueItemVisual(idx, 'style');
                (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(style, categoryStyle);
                var visualList = [
                    'symbol',
                    'symbolSize',
                    'symbolKeepAspect'
                ];
                for(var i = 0; i < visualList.length; i++)data.setItemVisual(idx, visualList[i], categoriesData.getItemVisual(categoryIdx, visualList[i]));
            }
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $30c6525273d94b44$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
function $30c6525273d94b44$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var graph = seriesModel.getGraph();
        var edgeData = seriesModel.getEdgeData();
        var symbolType = $30c6525273d94b44$var$normalize(seriesModel.get('edgeSymbol'));
        var symbolSize = $30c6525273d94b44$var$normalize(seriesModel.get('edgeSymbolSize'));
        // const colorQuery = ['lineStyle', 'color'] as const;
        // const opacityQuery = ['lineStyle', 'opacity'] as const;
        edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
        edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
        edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
        edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
        edgeData.setVisual('style', seriesModel.getModel('lineStyle').getLineStyle());
        edgeData.each(function(idx) {
            var itemModel = edgeData.getItemModel(idx);
            var edge = graph.getEdgeByIndex(idx);
            var symbolType = $30c6525273d94b44$var$normalize(itemModel.getShallow('symbol', true));
            var symbolSize = $30c6525273d94b44$var$normalize(itemModel.getShallow('symbolSize', true));
            // Edge visual must after node visual
            var style = itemModel.getModel('lineStyle').getLineStyle();
            var existsStyle = edgeData.ensureUniqueItemVisual(idx, 'style');
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(existsStyle, style);
            switch(existsStyle.stroke){
                case 'source':
                    var nodeStyle = edge.node1.getVisual('style');
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
                case 'target':
                    var nodeStyle = edge.node2.getVisual('style');
                    existsStyle.stroke = nodeStyle && nodeStyle.fill;
                    break;
            }
            symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
            symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
            symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
            symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $0e33d794c0e19777$var$KEY_DELIMITER = '-->';
/**
 * params handler
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {*}
 */ var $0e33d794c0e19777$var$getAutoCurvenessParams = function(seriesModel) {
    return seriesModel.get('autoCurveness') || null;
};
/**
 * Generate a list of edge curvatures, 20 is the default
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @param {number} appendLength
 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
 */ var $0e33d794c0e19777$var$createCurveness = function(seriesModel, appendLength) {
    var autoCurvenessParmas = $0e33d794c0e19777$var$getAutoCurvenessParams(seriesModel);
    var length = 20;
    var curvenessList = [];
    // handler the function set
    if ($1b239fc9d3a2f8ae$export$7e4aa119212bc614(autoCurvenessParmas)) length = autoCurvenessParmas;
    else if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(autoCurvenessParmas)) {
        seriesModel.__curvenessList = autoCurvenessParmas;
        return;
    }
    // append length
    if (appendLength > length) length = appendLength;
    // make sure the length is even
    var len = length % 2 ? length + 2 : length + 3;
    curvenessList = [];
    for(var i = 0; i < len; i++)curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
    seriesModel.__curvenessList = curvenessList;
};
/**
 * Create different cache key data in the positive and negative directions, in order to set the curvature later
 * @param {number|string|module:echarts/data/Graph.Node} n1
 * @param {number|string|module:echarts/data/Graph.Node} n2
 * @param {module:echarts/model/SeriesModel} seriesModel
 * @returns {string} key
 */ var $0e33d794c0e19777$var$getKeyOfEdges = function(n1, n2, seriesModel) {
    var source = [
        n1.id,
        n1.dataIndex
    ].join('.');
    var target = [
        n2.id,
        n2.dataIndex
    ].join('.');
    return [
        seriesModel.uid,
        source,
        target
    ].join($0e33d794c0e19777$var$KEY_DELIMITER);
};
/**
 * get opposite key
 * @param {string} key
 * @returns {string}
 */ var $0e33d794c0e19777$var$getOppositeKey = function(key) {
    var keys = key.split($0e33d794c0e19777$var$KEY_DELIMITER);
    return [
        keys[0],
        keys[2],
        keys[1]
    ].join($0e33d794c0e19777$var$KEY_DELIMITER);
};
/**
 * get edgeMap with key
 * @param edge
 * @param {module:echarts/model/SeriesModel} seriesModel
 */ var $0e33d794c0e19777$var$getEdgeFromMap = function(edge, seriesModel) {
    var key = $0e33d794c0e19777$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    return seriesModel.__edgeMap[key];
};
/**
 * calculate all cases total length
 * @param edge
 * @param seriesModel
 * @returns {number}
 */ var $0e33d794c0e19777$var$getTotalLengthBetweenNodes = function(edge, seriesModel) {
    var len = $0e33d794c0e19777$var$getEdgeMapLengthWithKey($0e33d794c0e19777$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
    var lenV = $0e33d794c0e19777$var$getEdgeMapLengthWithKey($0e33d794c0e19777$var$getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
    return len + lenV;
};
/**
 *
 * @param key
 */ var $0e33d794c0e19777$var$getEdgeMapLengthWithKey = function(key, seriesModel) {
    var edgeMap = seriesModel.__edgeMap;
    return edgeMap[key] ? edgeMap[key].length : 0;
};
function $0e33d794c0e19777$export$4f05389c1f2934b8(seriesModel) {
    if (!$0e33d794c0e19777$var$getAutoCurvenessParams(seriesModel)) return;
    seriesModel.__curvenessList = [];
    seriesModel.__edgeMap = {};
    // calc the array of curveness List
    $0e33d794c0e19777$var$createCurveness(seriesModel);
}
function $0e33d794c0e19777$export$c47b549eed9a7311(n1, n2, seriesModel, index) {
    if (!$0e33d794c0e19777$var$getAutoCurvenessParams(seriesModel)) return;
    var key = $0e33d794c0e19777$var$getKeyOfEdges(n1, n2, seriesModel);
    var edgeMap = seriesModel.__edgeMap;
    var oppositeEdges = edgeMap[$0e33d794c0e19777$var$getOppositeKey(key)];
    // set direction
    if (edgeMap[key] && !oppositeEdges) edgeMap[key].isForward = true;
    else if (oppositeEdges && edgeMap[key]) {
        oppositeEdges.isForward = true;
        edgeMap[key].isForward = false;
    }
    edgeMap[key] = edgeMap[key] || [];
    edgeMap[key].push(index);
}
function $0e33d794c0e19777$export$7e88123f7f1f62da(edge, seriesModel, index, needReverse) {
    var autoCurvenessParams = $0e33d794c0e19777$var$getAutoCurvenessParams(seriesModel);
    var isArrayParam = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(autoCurvenessParams);
    if (!autoCurvenessParams) return null;
    var edgeArray = $0e33d794c0e19777$var$getEdgeFromMap(edge, seriesModel);
    if (!edgeArray) return null;
    var edgeIndex = -1;
    for(var i = 0; i < edgeArray.length; i++)if (edgeArray[i] === index) {
        edgeIndex = i;
        break;
    }
    // if totalLen is Longer createCurveness
    var totalLen = $0e33d794c0e19777$var$getTotalLengthBetweenNodes(edge, seriesModel);
    $0e33d794c0e19777$var$createCurveness(seriesModel, totalLen);
    edge.lineStyle = edge.lineStyle || {};
    // if is opposite edge, must set curvenss to opposite number
    var curKey = $0e33d794c0e19777$var$getKeyOfEdges(edge.node1, edge.node2, seriesModel);
    var curvenessList = seriesModel.__curvenessList;
    // if pass array no need parity
    var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
    if (!edgeArray.isForward) {
        // the opposite edge show outside
        var oppositeKey = $0e33d794c0e19777$var$getOppositeKey(curKey);
        var len = $0e33d794c0e19777$var$getEdgeMapLengthWithKey(oppositeKey, seriesModel);
        var resValue = curvenessList[edgeIndex + len + parityCorrection];
        // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
        if (needReverse) {
            // set as array may make the parity handle with the len of opposite
            if (isArrayParam) {
                if (autoCurvenessParams && autoCurvenessParams[0] === 0) return (len + parityCorrection) % 2 ? resValue : -resValue;
                else return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
            } else return (len + parityCorrection) % 2 ? resValue : -resValue;
        } else return curvenessList[edgeIndex + len + parityCorrection];
    } else return curvenessList[parityCorrection + edgeIndex];
}


function $e60de15cea0c1d76$export$6d7efb25f4dcb4db(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== 'view') return;
    var graph = seriesModel.getGraph();
    graph.eachNode(function(node) {
        var model = node.getModel();
        node.setLayout([
            +model.get('x'),
            +model.get('y')
        ]);
    });
    $e60de15cea0c1d76$export$a25b52345bee32aa(graph, seriesModel);
}
function $e60de15cea0c1d76$export$a25b52345bee32aa(graph, seriesModel) {
    graph.eachEdge(function(edge, index) {
        var curveness = $1b239fc9d3a2f8ae$export$2e94551289abb95b(edge.getModel().get([
            'lineStyle',
            'curveness'
        ]), -(0, $0e33d794c0e19777$export$7e88123f7f1f62da)(edge, seriesModel, index, true), 0);
        var p1 = $3dde7d051fe20daa$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $3dde7d051fe20daa$export$9cd59f9826255e47(edge.node2.getLayout());
        var points = [
            p1,
            p2
        ];
        if (+curveness) points.push([
            (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness,
            (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness
        ]);
        edge.setLayout(points);
    });
}


function $14787d2cae490f6f$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var layout = seriesModel.get('layout');
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.type !== 'view') {
            var data_1 = seriesModel.getData();
            var dimensions_1 = [];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(coordSys.dimensions, function(coordDim) {
                dimensions_1 = dimensions_1.concat(data_1.mapDimensionsAll(coordDim));
            });
            for(var dataIndex = 0; dataIndex < data_1.count(); dataIndex++){
                var value = [];
                var hasValue = false;
                for(var i = 0; i < dimensions_1.length; i++){
                    var val = data_1.get(dimensions_1[i], dataIndex);
                    if (!isNaN(val)) hasValue = true;
                    value.push(val);
                }
                if (hasValue) data_1.setItemLayout(dataIndex, coordSys.dataToPoint(value));
                else // Also {Array.<number>}, not undefined to avoid if...else... statement
                data_1.setItemLayout(dataIndex, [
                    NaN,
                    NaN
                ]);
            }
            (0, $e60de15cea0c1d76$export$a25b52345bee32aa)(data_1.graph, seriesModel);
        } else if (!layout || layout === 'none') (0, $e60de15cea0c1d76$export$6d7efb25f4dcb4db)(seriesModel);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $447ca6843adad8c5$export$e2aa0fb9ed198ba7(seriesModel) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys.type !== 'view') return 1;
    var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
    var groupZoom = coordSys.scaleX;
    // Scale node when zoom changes
    var roamZoom = coordSys.getZoom();
    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
    return nodeScale / groupZoom;
}
function $447ca6843adad8c5$export$8d4a06d3facd414b(node) {
    var symbolSize = node.getVisual('symbolSize');
    if (symbolSize instanceof Array) symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
    return +symbolSize;
}




var $1debe8addc501597$var$PI = Math.PI;
var $1debe8addc501597$var$_symbolRadiansHalf = [];
function $1debe8addc501597$export$cbfed6ae5cab3dae(seriesModel, basedOn, draggingNode, pointer) {
    var coordSys = seriesModel.coordinateSystem;
    if (coordSys && coordSys.type !== 'view') return;
    var rect = coordSys.getBoundingRect();
    var nodeData = seriesModel.getData();
    var graph = nodeData.graph;
    var cx = rect.width / 2 + rect.x;
    var cy = rect.height / 2 + rect.y;
    var r = Math.min(rect.width, rect.height) / 2;
    var count = nodeData.count();
    nodeData.setLayout({
        cx: cx,
        cy: cy
    });
    if (!count) return;
    if (draggingNode) {
        var _a = coordSys.pointToData(pointer), tempX = _a[0], tempY = _a[1];
        var v = [
            tempX - cx,
            tempY - cy
        ];
        $3dde7d051fe20daa$export$a3295358bff77e(v, v);
        $3dde7d051fe20daa$export$dcdf75081b88279d(v, v, r);
        draggingNode.setLayout([
            cx + v[0],
            cy + v[1]
        ], true);
        var circularRotateLabel = seriesModel.get([
            'circular',
            'rotateLabel'
        ]);
        $1debe8addc501597$export$c768377a6a0a9ab8(draggingNode, circularRotateLabel, cx, cy);
    }
    $1debe8addc501597$var$_layoutNodesBasedOn[basedOn](seriesModel, graph, nodeData, r, cx, cy, count);
    graph.eachEdge(function(edge, index) {
        var curveness = $1b239fc9d3a2f8ae$export$2e94551289abb95b(edge.getModel().get([
            'lineStyle',
            'curveness'
        ]), (0, $0e33d794c0e19777$export$7e88123f7f1f62da)(edge, seriesModel, index), 0);
        var p1 = $3dde7d051fe20daa$export$9cd59f9826255e47(edge.node1.getLayout());
        var p2 = $3dde7d051fe20daa$export$9cd59f9826255e47(edge.node2.getLayout());
        var cp1;
        var x12 = (p1[0] + p2[0]) / 2;
        var y12 = (p1[1] + p2[1]) / 2;
        if (+curveness) {
            curveness *= 3;
            cp1 = [
                cx * curveness + x12 * (1 - curveness),
                cy * curveness + y12 * (1 - curveness)
            ];
        }
        edge.setLayout([
            p1,
            p2,
            cp1
        ]);
    });
}
var $1debe8addc501597$var$_layoutNodesBasedOn = {
    value: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var angle = 0;
        var sum = nodeData.getSum('value');
        var unitAngle = Math.PI * 2 / (sum || count);
        graph.eachNode(function(node) {
            var value = node.getValue('value');
            var radianHalf = unitAngle * (sum ? value : 1) / 2;
            angle += radianHalf;
            node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    },
    symbolSize: function(seriesModel, graph, nodeData, r, cx, cy, count) {
        var sumRadian = 0;
        $1debe8addc501597$var$_symbolRadiansHalf.length = count;
        var nodeScale = (0, $447ca6843adad8c5$export$e2aa0fb9ed198ba7)(seriesModel);
        graph.eachNode(function(node) {
            var symbolSize = (0, $447ca6843adad8c5$export$8d4a06d3facd414b)(node);
            // Normally this case will not happen, but we still add
            // some the defensive code (2px is an arbitrary value).
            isNaN(symbolSize) && (symbolSize = 2);
            symbolSize < 0 && (symbolSize = 0);
            symbolSize *= nodeScale;
            var symbolRadianHalf = Math.asin(symbolSize / 2 / r);
            // when `symbolSize / 2` is bigger than `r`.
            isNaN(symbolRadianHalf) && (symbolRadianHalf = $1debe8addc501597$var$PI / 2);
            $1debe8addc501597$var$_symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
            sumRadian += symbolRadianHalf * 2;
        });
        var halfRemainRadian = (2 * $1debe8addc501597$var$PI - sumRadian) / count / 2;
        var angle = 0;
        graph.eachNode(function(node) {
            var radianHalf = halfRemainRadian + $1debe8addc501597$var$_symbolRadiansHalf[node.dataIndex];
            angle += radianHalf;
            // init circular layout for
            // 1. layout undefined node
            // 2. not fixed node
            (!node.getLayout() || !node.getLayout().fixed) && node.setLayout([
                r * Math.cos(angle) + cx,
                r * Math.sin(angle) + cy
            ]);
            angle += radianHalf;
        });
    }
};
function $1debe8addc501597$export$c768377a6a0a9ab8(node, circularRotateLabel, cx, cy) {
    var el = node.getGraphicEl();
    // need to check if el exists. '-' value may not create node element.
    if (!el) return;
    var nodeModel = node.getModel();
    var labelRotate = nodeModel.get([
        'label',
        'rotate'
    ]) || 0;
    var symbolPath = el.getSymbolPath();
    if (circularRotateLabel) {
        var pos = node.getLayout();
        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
        if (rad < 0) rad = Math.PI * 2 + rad;
        var isLeft = pos[0] < cx;
        if (isLeft) rad = rad - Math.PI;
        var textPosition = isLeft ? 'left' : 'right';
        symbolPath.setTextConfig({
            rotation: -rad,
            position: textPosition,
            origin: 'center'
        });
        var emphasisState = symbolPath.ensureState('emphasis');
        $1b239fc9d3a2f8ae$export$8b58be045bf06082(emphasisState.textConfig || (emphasisState.textConfig = {}), {
            position: textPosition
        });
    } else symbolPath.setTextConfig({
        rotation: labelRotate *= Math.PI / 180
    });
}


function $1f9590f1cf133b7f$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        if (seriesModel.get('layout') === 'circular') (0, $1debe8addc501597$export$cbfed6ae5cab3dae)(seriesModel, 'symbolSize');
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* A third-party license is embedded for some of the code in this file:
* Some formulas were originally copied from "d3.js" with some
* modifications made for this project.
* (See more details in the comment of the method "step" below.)
* The use of the source code of this file is also subject to the terms
* and consitions of the license of "d3.js" (BSD-3Clause, see
* </licenses/LICENSE-d3>).
*/ 
var $8f1cb7a1d1d0c6da$var$scaleAndAdd = $3dde7d051fe20daa$export$19cedf1da84ba854;
function $8f1cb7a1d1d0c6da$export$100e93b4853dcbde(inNodes, inEdges, opts) {
    var nodes = inNodes;
    var edges = inEdges;
    var rect = opts.rect;
    var width = rect.width;
    var height = rect.height;
    var center = [
        rect.x + width / 2,
        rect.y + height / 2
    ];
    // let scale = opts.scale || 1;
    var gravity = opts.gravity == null ? 0.1 : opts.gravity;
    // for (let i = 0; i < edges.length; i++) {
    //     let e = edges[i];
    //     let n1 = e.n1;
    //     let n2 = e.n2;
    //     n1.edges = n1.edges || [];
    //     n2.edges = n2.edges || [];
    //     n1.edges.push(e);
    //     n2.edges.push(e);
    // }
    // Init position
    for(var i = 0; i < nodes.length; i++){
        var n = nodes[i];
        if (!n.p) n.p = $3dde7d051fe20daa$export$185802fd694ee1f5(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
        n.pp = $3dde7d051fe20daa$export$9cd59f9826255e47(n.p);
        n.edges = null;
    }
    // Formula in 'Graph Drawing by Force-directed Placement'
    // let k = scale * Math.sqrt(width * height / nodes.length);
    // let k2 = k * k;
    var initialFriction = opts.friction == null ? 0.6 : opts.friction;
    var friction = initialFriction;
    var beforeStepCallback;
    var afterStepCallback;
    return {
        warmUp: function() {
            friction = initialFriction * 0.8;
        },
        setFixed: function(idx) {
            nodes[idx].fixed = true;
        },
        setUnfixed: function(idx) {
            nodes[idx].fixed = false;
        },
        /**
     * Before step hook
     */ beforeStep: function(cb) {
            beforeStepCallback = cb;
        },
        /**
     * After step hook
     */ afterStep: function(cb) {
            afterStepCallback = cb;
        },
        /**
     * Some formulas were originally copied from "d3.js"
     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
     * with some modifications made for this project.
     * See the license statement at the head of this file.
     */ step: function(cb) {
            beforeStepCallback && beforeStepCallback(nodes, edges);
            var v12 = [];
            var nLen = nodes.length;
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                if (e.ignoreForceLayout) continue;
                var n1 = e.n1;
                var n2 = e.n2;
                $3dde7d051fe20daa$export$f93b5905241a7cca(v12, n2.p, n1.p);
                var d = $3dde7d051fe20daa$export$fc1400facf92c78(v12) - e.d;
                var w = n2.w / (n1.w + n2.w);
                if (isNaN(w)) w = 0;
                $3dde7d051fe20daa$export$a3295358bff77e(v12, v12);
                !n1.fixed && $8f1cb7a1d1d0c6da$var$scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
                !n2.fixed && $8f1cb7a1d1d0c6da$var$scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
            }
            // Gravity
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $3dde7d051fe20daa$export$f93b5905241a7cca(v12, center, n.p);
                    // let d = vec2.len(v12);
                    // vec2.scale(v12, v12, 1 / d);
                    // let gravityFactor = gravity;
                    $8f1cb7a1d1d0c6da$var$scaleAndAdd(n.p, n.p, v12, gravity * friction);
                }
            }
            // Repulsive
            // PENDING
            for(var i = 0; i < nLen; i++){
                var n1 = nodes[i];
                for(var j = i + 1; j < nLen; j++){
                    var n2 = nodes[j];
                    $3dde7d051fe20daa$export$f93b5905241a7cca(v12, n2.p, n1.p);
                    var d = $3dde7d051fe20daa$export$fc1400facf92c78(v12);
                    if (d === 0) {
                        // Random repulse
                        $3dde7d051fe20daa$export$adaa4cf7ef1b65be(v12, Math.random() - 0.5, Math.random() - 0.5);
                        d = 1;
                    }
                    var repFact = (n1.rep + n2.rep) / d / d;
                    !n1.fixed && $8f1cb7a1d1d0c6da$var$scaleAndAdd(n1.pp, n1.pp, v12, repFact);
                    !n2.fixed && $8f1cb7a1d1d0c6da$var$scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
                }
            }
            var v = [];
            for(var i = 0; i < nLen; i++){
                var n = nodes[i];
                if (!n.fixed) {
                    $3dde7d051fe20daa$export$f93b5905241a7cca(v, n.p, n.pp);
                    $8f1cb7a1d1d0c6da$var$scaleAndAdd(n.p, n.p, v, friction);
                    $3dde7d051fe20daa$export$784d13d8ee351f07(n.pp, n.p);
                }
            }
            friction = friction * 0.992;
            var finished = friction < 0.01;
            afterStepCallback && afterStepCallback(nodes, edges, finished);
            cb && cb(finished);
        }
    };
}








function $4fe373109e3bb70b$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('graph', function(graphSeries) {
        var coordSys = graphSeries.coordinateSystem;
        if (coordSys && coordSys.type !== 'view') return;
        if (graphSeries.get('layout') === 'force') {
            var preservedPoints_1 = graphSeries.preservedPoints || {};
            var graph_1 = graphSeries.getGraph();
            var nodeData_1 = graph_1.data;
            var edgeData = graph_1.edgeData;
            var forceModel = graphSeries.getModel('force');
            var initLayout = forceModel.get('initLayout');
            if (graphSeries.preservedPoints) nodeData_1.each(function(idx) {
                var id = nodeData_1.getId(idx);
                nodeData_1.setItemLayout(idx, preservedPoints_1[id] || [
                    NaN,
                    NaN
                ]);
            });
            else if (!initLayout || initLayout === 'none') (0, $e60de15cea0c1d76$export$6d7efb25f4dcb4db)(graphSeries);
            else if (initLayout === 'circular') (0, $1debe8addc501597$export$cbfed6ae5cab3dae)(graphSeries, 'value');
            var nodeDataExtent_1 = nodeData_1.getDataExtent('value');
            var edgeDataExtent_1 = edgeData.getDataExtent('value');
            // let edgeDataExtent = edgeData.getDataExtent('value');
            var repulsion = forceModel.get('repulsion');
            var edgeLength = forceModel.get('edgeLength');
            var repulsionArr_1 = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(repulsion) ? repulsion : [
                repulsion,
                repulsion
            ];
            var edgeLengthArr_1 = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(edgeLength) ? edgeLength : [
                edgeLength,
                edgeLength
            ];
            // Larger value has smaller length
            edgeLengthArr_1 = [
                edgeLengthArr_1[1],
                edgeLengthArr_1[0]
            ];
            var nodes_1 = nodeData_1.mapArray('value', function(value, idx) {
                var point = nodeData_1.getItemLayout(idx);
                var rep = (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(value, nodeDataExtent_1, repulsionArr_1);
                if (isNaN(rep)) rep = (repulsionArr_1[0] + repulsionArr_1[1]) / 2;
                return {
                    w: rep,
                    rep: rep,
                    fixed: nodeData_1.getItemModel(idx).get('fixed'),
                    p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
                };
            });
            var edges = edgeData.mapArray('value', function(value, idx) {
                var edge = graph_1.getEdgeByIndex(idx);
                var d = (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(value, edgeDataExtent_1, edgeLengthArr_1);
                if (isNaN(d)) d = (edgeLengthArr_1[0] + edgeLengthArr_1[1]) / 2;
                var edgeModel = edge.getModel();
                var curveness = $1b239fc9d3a2f8ae$export$2e94551289abb95b(edge.getModel().get([
                    'lineStyle',
                    'curveness'
                ]), -(0, $0e33d794c0e19777$export$7e88123f7f1f62da)(edge, graphSeries, idx, true), 0);
                return {
                    n1: nodes_1[edge.node1.dataIndex],
                    n2: nodes_1[edge.node2.dataIndex],
                    d: d,
                    curveness: curveness,
                    ignoreForceLayout: edgeModel.get('ignoreForceLayout')
                };
            });
            // let coordSys = graphSeries.coordinateSystem;
            var rect = coordSys.getBoundingRect();
            var forceInstance = (0, $8f1cb7a1d1d0c6da$export$100e93b4853dcbde)(nodes_1, edges, {
                rect: rect,
                gravity: forceModel.get('gravity'),
                friction: forceModel.get('friction')
            });
            forceInstance.beforeStep(function(nodes, edges) {
                for(var i = 0, l = nodes.length; i < l; i++)if (nodes[i].fixed) // Write back to layout instance
                $3dde7d051fe20daa$export$784d13d8ee351f07(nodes[i].p, graph_1.getNodeByIndex(i).getLayout());
            });
            forceInstance.afterStep(function(nodes, edges, stopped) {
                for(var i = 0, l = nodes.length; i < l; i++){
                    if (!nodes[i].fixed) graph_1.getNodeByIndex(i).setLayout(nodes[i].p);
                    preservedPoints_1[nodeData_1.getId(i)] = nodes[i].p;
                }
                for(var i = 0, l = edges.length; i < l; i++){
                    var e = edges[i];
                    var edge = graph_1.getEdgeByIndex(i);
                    var p1 = e.n1.p;
                    var p2 = e.n2.p;
                    var points = edge.getLayout();
                    points = points ? points.slice() : [];
                    points[0] = points[0] || [];
                    points[1] = points[1] || [];
                    $3dde7d051fe20daa$export$784d13d8ee351f07(points[0], p1);
                    $3dde7d051fe20daa$export$784d13d8ee351f07(points[1], p2);
                    if (+e.curveness) points[2] = [
                        (p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness,
                        (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness
                    ];
                    edge.setLayout(points);
                }
            });
            graphSeries.forceLayout = forceInstance;
            graphSeries.preservedPoints = preservedPoints_1;
            // Step to get the layout
            forceInstance.step();
        } else // Remove prev injected forceLayout instance
        graphSeries.forceLayout = null;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // FIXME Where to create the simple view coordinate system




function $8d25196a2f1e6b5b$var$getViewRect(seriesModel, api, aspect) {
    var option = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(seriesModel.getBoxLayoutParams(), {
        aspect: aspect
    });
    return (0, $501dc28f6c4d24ac$export$4517a5ca639a7293)(option, {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $8d25196a2f1e6b5b$export$2e2bcd8739ae039(ecModel, api) {
    var viewList = [];
    ecModel.eachSeriesByType('graph', function(seriesModel) {
        var coordSysType = seriesModel.get('coordinateSystem');
        if (!coordSysType || coordSysType === 'view') {
            var data_1 = seriesModel.getData();
            var positions = data_1.mapArray(function(idx) {
                var itemModel = data_1.getItemModel(idx);
                return [
                    +itemModel.get('x'),
                    +itemModel.get('y')
                ];
            });
            var min = [];
            var max = [];
            $9757a65ec1dd85b5$export$188c3cd07b4129dd(positions, min, max);
            // If width or height is 0
            if (max[0] - min[0] === 0) {
                max[0] += 1;
                min[0] -= 1;
            }
            if (max[1] - min[1] === 0) {
                max[1] += 1;
                min[1] -= 1;
            }
            var aspect = (max[0] - min[0]) / (max[1] - min[1]);
            // FIXME If get view rect after data processed?
            var viewRect = $8d25196a2f1e6b5b$var$getViewRect(seriesModel, api, aspect);
            // Position may be NaN, use view rect instead
            if (isNaN(aspect)) {
                min = [
                    viewRect.x,
                    viewRect.y
                ];
                max = [
                    viewRect.x + viewRect.width,
                    viewRect.y + viewRect.height
                ];
            }
            var bbWidth = max[0] - min[0];
            var bbHeight = max[1] - min[1];
            var viewWidth = viewRect.width;
            var viewHeight = viewRect.height;
            var viewCoordSys = seriesModel.coordinateSystem = new (0, $6713d37ec624c52a$export$2e2bcd8739ae039)();
            viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
            viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
            viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight);
            // Update roam info
            viewCoordSys.setCenter(seriesModel.get('center'), api);
            viewCoordSys.setZoom(seriesModel.get('zoom'));
            viewList.push(viewCoordSys);
        }
    });
    return viewList;
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $e778907f30c7bb29$var$straightLineProto = $8324e8379a5583a5$export$2e2bcd8739ae039.prototype;
var $e778907f30c7bb29$var$bezierCurveProto = $13bf9e04ebecd3f2$export$2e2bcd8739ae039.prototype;
var $e778907f30c7bb29$var$StraightLineShape = /** @class */ function() {
    function StraightLineShape() {
        // Start point
        this.x1 = 0;
        this.y1 = 0;
        // End point
        this.x2 = 0;
        this.y2 = 0;
        this.percent = 1;
    }
    return StraightLineShape;
}();
var $e778907f30c7bb29$var$CurveShape = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CurveShape, _super);
    function CurveShape() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CurveShape;
}($e778907f30c7bb29$var$StraightLineShape);
function $e778907f30c7bb29$var$isStraightLine(shape) {
    return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
}
var $e778907f30c7bb29$var$ECLinePath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ECLinePath, _super);
    function ECLinePath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'ec-line';
        return _this;
    }
    ECLinePath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    ECLinePath.prototype.getDefaultShape = function() {
        return new $e778907f30c7bb29$var$StraightLineShape();
    };
    ECLinePath.prototype.buildPath = function(ctx, shape) {
        if ($e778907f30c7bb29$var$isStraightLine(shape)) $e778907f30c7bb29$var$straightLineProto.buildPath.call(this, ctx, shape);
        else $e778907f30c7bb29$var$bezierCurveProto.buildPath.call(this, ctx, shape);
    };
    ECLinePath.prototype.pointAt = function(t) {
        if ($e778907f30c7bb29$var$isStraightLine(this.shape)) return $e778907f30c7bb29$var$straightLineProto.pointAt.call(this, t);
        else return $e778907f30c7bb29$var$bezierCurveProto.pointAt.call(this, t);
    };
    ECLinePath.prototype.tangentAt = function(t) {
        var shape = this.shape;
        var p = $e778907f30c7bb29$var$isStraightLine(shape) ? [
            shape.x2 - shape.x1,
            shape.y2 - shape.y1
        ] : $e778907f30c7bb29$var$bezierCurveProto.tangentAt.call(this, t);
        return $3dde7d051fe20daa$export$a3295358bff77e(p, p);
    };
    return ECLinePath;
}($f9698154c9fcf427$export$2e2bcd8739ae039);
var $e778907f30c7bb29$export$2e2bcd8739ae039 = $e778907f30c7bb29$var$ECLinePath;






var $7c246668238b1397$var$SYMBOL_CATEGORIES = [
    'fromSymbol',
    'toSymbol'
];
function $7c246668238b1397$var$makeSymbolTypeKey(symbolCategory) {
    return '_' + symbolCategory + 'Type';
}
function $7c246668238b1397$var$makeSymbolTypeValue(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return symbolType;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $da6220012439db7b$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $da6220012439db7b$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    return symbolType + symbolSizeArr + symbolOffsetArr + (symbolRotate || '') + (symbolKeepAspect || '');
}
/**
 * @inner
 */ function $7c246668238b1397$var$createSymbol(name, lineData, idx) {
    var symbolType = lineData.getItemVisual(idx, name);
    if (!symbolType || symbolType === 'none') return;
    var symbolSize = lineData.getItemVisual(idx, name + 'Size');
    var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
    var symbolOffset = lineData.getItemVisual(idx, name + 'Offset');
    var symbolKeepAspect = lineData.getItemVisual(idx, name + 'KeepAspect');
    var symbolSizeArr = $da6220012439db7b$export$a84524f03e8e8dfb(symbolSize);
    var symbolOffsetArr = $da6220012439db7b$export$e3e292895c033f6d(symbolOffset || 0, symbolSizeArr);
    var symbolPath = $da6220012439db7b$export$af050e04da3a02e8(symbolType, -symbolSizeArr[0] / 2 + symbolOffsetArr[0], -symbolSizeArr[1] / 2 + symbolOffsetArr[1], symbolSizeArr[0], symbolSizeArr[1], null, symbolKeepAspect);
    symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
    symbolPath.name = name;
    return symbolPath;
}
function $7c246668238b1397$var$createLine(points) {
    var line = new (0, $e778907f30c7bb29$export$2e2bcd8739ae039)({
        name: 'line',
        subPixelOptimize: true
    });
    $7c246668238b1397$var$setLinePoints(line.shape, points);
    return line;
}
function $7c246668238b1397$var$setLinePoints(targetShape, points) {
    targetShape.x1 = points[0][0];
    targetShape.y1 = points[0][1];
    targetShape.x2 = points[1][0];
    targetShape.y2 = points[1][1];
    targetShape.percent = 1;
    var cp1 = points[2];
    if (cp1) {
        targetShape.cpx1 = cp1[0];
        targetShape.cpy1 = cp1[1];
    } else {
        targetShape.cpx1 = NaN;
        targetShape.cpy1 = NaN;
    }
}
var $7c246668238b1397$var$Line = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Line, _super);
    function Line(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createLine(lineData, idx, seriesScope);
        return _this;
    }
    Line.prototype._createLine = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var linePoints = lineData.getItemLayout(idx);
        var line = $7c246668238b1397$var$createLine(linePoints);
        line.shape.percent = 0;
        $b40111164617dd60$export$a121566aadcfe021(line, {
            shape: {
                percent: 1
            }
        }, seriesModel, idx);
        this.add(line);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($7c246668238b1397$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = $7c246668238b1397$var$createSymbol(symbolCategory, lineData, idx);
            // symbols must added after line to make sure
            // it will be updated after line#update.
            // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
            this.add(symbol);
            this[$7c246668238b1397$var$makeSymbolTypeKey(symbolCategory)] = $7c246668238b1397$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    // TODO More strict on the List type in parameters?
    Line.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var linePoints = lineData.getItemLayout(idx);
        var target = {
            shape: {}
        };
        $7c246668238b1397$var$setLinePoints(target.shape, linePoints);
        $b40111164617dd60$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($7c246668238b1397$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbolType = $7c246668238b1397$var$makeSymbolTypeValue(symbolCategory, lineData, idx);
            var key = $7c246668238b1397$var$makeSymbolTypeKey(symbolCategory);
            // Symbol changed
            if (this[key] !== symbolType) {
                this.remove(this.childOfName(symbolCategory));
                var symbol = $7c246668238b1397$var$createSymbol(symbolCategory, lineData, idx);
                this.add(symbol);
            }
            this[key] = symbolType;
        }, this);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Line.prototype.getLinePath = function() {
        return this.childAt(0);
    };
    Line.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childOfName('line');
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var blurLineStyle = seriesScope && seriesScope.blurLineStyle;
        var selectLineStyle = seriesScope && seriesScope.selectLineStyle;
        var labelStatesModels = seriesScope && seriesScope.labelStatesModels;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        // Optimization for large dataset
        if (!seriesScope || lineData.hasItemOption) {
            var itemModel = lineData.getItemModel(idx);
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
            blurLineStyle = itemModel.getModel([
                'blur',
                'lineStyle'
            ]).getLineStyle();
            selectLineStyle = itemModel.getModel([
                'select',
                'lineStyle'
            ]).getLineStyle();
            emphasisDisabled = emphasisModel.get('disabled');
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
            labelStatesModels = (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel);
        }
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var visualColor = lineStyle.stroke;
        line.useStyle(lineStyle);
        line.style.fill = null;
        line.style.strokeNoScale = true;
        line.ensureState('emphasis').style = emphasisLineStyle;
        line.ensureState('blur').style = blurLineStyle;
        line.ensureState('select').style = selectLineStyle;
        // Update symbol
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($7c246668238b1397$var$SYMBOL_CATEGORIES, function(symbolCategory) {
            var symbol = this.childOfName(symbolCategory);
            if (symbol) {
                // Share opacity and color with line.
                symbol.setColor(visualColor);
                symbol.style.opacity = lineStyle.opacity;
                for(var i = 0; i < (0, $b414df7d361a211c$export$151308dceb52d5b).length; i++){
                    var stateName = (0, $b414df7d361a211c$export$151308dceb52d5b)[i];
                    var lineState = line.getState(stateName);
                    if (lineState) {
                        var lineStateStyle = lineState.style || {};
                        var state = symbol.ensureState(stateName);
                        var stateStyle = state.style || (state.style = {});
                        if (lineStateStyle.stroke != null) stateStyle[symbol.__isEmptyBrush ? 'stroke' : 'fill'] = lineStateStyle.stroke;
                        if (lineStateStyle.opacity != null) stateStyle.opacity = lineStateStyle.opacity;
                    }
                }
                symbol.markRedraw();
            }
        }, this);
        var rawVal = seriesModel.getRawValue(idx);
        (0, $3828198b2f2de836$export$9a13992917966657)(this, labelStatesModels, {
            labelDataIndex: idx,
            labelFetcher: {
                getFormattedLabel: function(dataIndex, stateName) {
                    return seriesModel.getFormattedLabel(dataIndex, stateName, lineData.dataType);
                }
            },
            inheritColor: visualColor || '#000',
            defaultOpacity: lineStyle.opacity,
            defaultText: (rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? (0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(rawVal) : rawVal) + ''
        });
        var label = this.getTextContent();
        // Always set `textStyle` even if `normalStyle.text` is null, because default
        // values have to be set on `normalStyle`.
        if (label) {
            var labelNormalModel = labelStatesModels.normal;
            label.__align = label.style.align;
            label.__verticalAlign = label.style.verticalAlign;
            // 'start', 'middle', 'end'
            label.__position = labelNormalModel.get('position') || 'middle';
            var distance = labelNormalModel.get('distance');
            if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(distance)) distance = [
                distance,
                distance
            ];
            label.__labelDistance = distance;
        }
        this.setTextConfig({
            position: null,
            local: true,
            inside: false // Can't be inside for stroke element.
        });
        (0, $b414df7d361a211c$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Line.prototype.highlight = function() {
        (0, $b414df7d361a211c$export$b2d02638cc34c042)(this);
    };
    Line.prototype.downplay = function() {
        (0, $b414df7d361a211c$export$11be6f716239ac55)(this);
    };
    Line.prototype.updateLayout = function(lineData, idx) {
        this.setLinePoints(lineData.getItemLayout(idx));
    };
    Line.prototype.setLinePoints = function(points) {
        var linePath = this.childOfName('line');
        $7c246668238b1397$var$setLinePoints(linePath.shape, points);
        linePath.dirty();
    };
    Line.prototype.beforeUpdate = function() {
        var lineGroup = this;
        var symbolFrom = lineGroup.childOfName('fromSymbol');
        var symbolTo = lineGroup.childOfName('toSymbol');
        var label = lineGroup.getTextContent();
        // Quick reject
        if (!symbolFrom && !symbolTo && (!label || label.ignore)) return;
        var invScale = 1;
        var parentNode = this.parent;
        while(parentNode){
            if (parentNode.scaleX) invScale /= parentNode.scaleX;
            parentNode = parentNode.parent;
        }
        var line = lineGroup.childOfName('line');
        // If line not changed
        // FIXME Parent scale changed
        if (!this.__dirty && !line.__dirty) return;
        var percent = line.shape.percent;
        var fromPos = line.pointAt(0);
        var toPos = line.pointAt(percent);
        var d = $3dde7d051fe20daa$export$f93b5905241a7cca([], toPos, fromPos);
        $3dde7d051fe20daa$export$a3295358bff77e(d, d);
        function setSymbolRotation(symbol, percent) {
            // Fix #12388
            // when symbol is set to be 'arrow' in markLine,
            // symbolRotate value will be ignored, and compulsively use tangent angle.
            // rotate by default if symbol rotation is not specified
            var specifiedRotation = symbol.__specifiedRotation;
            if (specifiedRotation == null) {
                var tangent = line.tangentAt(percent);
                symbol.attr('rotation', (percent === 1 ? -1 : 1) * Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
            } else symbol.attr('rotation', specifiedRotation);
        }
        if (symbolFrom) {
            symbolFrom.setPosition(fromPos);
            setSymbolRotation(symbolFrom, 0);
            symbolFrom.scaleX = symbolFrom.scaleY = invScale * percent;
            symbolFrom.markRedraw();
        }
        if (symbolTo) {
            symbolTo.setPosition(toPos);
            setSymbolRotation(symbolTo, 1);
            symbolTo.scaleX = symbolTo.scaleY = invScale * percent;
            symbolTo.markRedraw();
        }
        if (label && !label.ignore) {
            label.x = label.y = 0;
            label.originX = label.originY = 0;
            var textAlign = void 0;
            var textVerticalAlign = void 0;
            var distance = label.__labelDistance;
            var distanceX = distance[0] * invScale;
            var distanceY = distance[1] * invScale;
            var halfPercent = percent / 2;
            var tangent = line.tangentAt(halfPercent);
            var n = [
                tangent[1],
                -tangent[0]
            ];
            var cp = line.pointAt(halfPercent);
            if (n[1] > 0) {
                n[0] = -n[0];
                n[1] = -n[1];
            }
            var dir = tangent[0] < 0 ? -1 : 1;
            if (label.__position !== 'start' && label.__position !== 'end') {
                var rotation = -Math.atan2(tangent[1], tangent[0]);
                if (toPos[0] < fromPos[0]) rotation = Math.PI + rotation;
                label.rotation = rotation;
            }
            var dy = void 0;
            switch(label.__position){
                case 'insideStartTop':
                case 'insideMiddleTop':
                case 'insideEndTop':
                case 'middle':
                    dy = -distanceY;
                    textVerticalAlign = 'bottom';
                    break;
                case 'insideStartBottom':
                case 'insideMiddleBottom':
                case 'insideEndBottom':
                    dy = distanceY;
                    textVerticalAlign = 'top';
                    break;
                default:
                    dy = 0;
                    textVerticalAlign = 'middle';
            }
            switch(label.__position){
                case 'end':
                    label.x = d[0] * distanceX + toPos[0];
                    label.y = d[1] * distanceY + toPos[1];
                    textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
                    break;
                case 'start':
                    label.x = -d[0] * distanceX + fromPos[0];
                    label.y = -d[1] * distanceY + fromPos[1];
                    textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
                    textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
                    break;
                case 'insideStartTop':
                case 'insideStart':
                case 'insideStartBottom':
                    label.x = distanceX * dir + fromPos[0];
                    label.y = fromPos[1] + dy;
                    textAlign = tangent[0] < 0 ? 'right' : 'left';
                    label.originX = -distanceX * dir;
                    label.originY = -dy;
                    break;
                case 'insideMiddleTop':
                case 'insideMiddle':
                case 'insideMiddleBottom':
                case 'middle':
                    label.x = cp[0];
                    label.y = cp[1] + dy;
                    textAlign = 'center';
                    label.originY = -dy;
                    break;
                case 'insideEndTop':
                case 'insideEnd':
                case 'insideEndBottom':
                    label.x = -distanceX * dir + toPos[0];
                    label.y = toPos[1] + dy;
                    textAlign = tangent[0] >= 0 ? 'right' : 'left';
                    label.originX = distanceX * dir;
                    label.originY = -dy;
                    break;
            }
            label.scaleX = label.scaleY = invScale;
            label.setStyle({
                // Use the user specified text align and baseline first
                verticalAlign: label.__verticalAlign || textVerticalAlign,
                align: label.__align || textAlign
            });
        }
    };
    return Line;
}($6c313c3ef6000a43$export$2e2bcd8739ae039);
var $7c246668238b1397$export$2e2bcd8739ae039 = $7c246668238b1397$var$Line;



var $52292566d9cfa1f6$var$LineDraw = /** @class */ function() {
    function LineDraw(LineCtor) {
        this.group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this._LineCtor = LineCtor || (0, $7c246668238b1397$export$2e2bcd8739ae039);
    }
    LineDraw.prototype.updateData = function(lineData) {
        var _this = this;
        // Remove progressive els.
        this._progressiveEls = null;
        var lineDraw = this;
        var group = lineDraw.group;
        var oldLineData = lineDraw._lineData;
        lineDraw._lineData = lineData;
        // There is no oldLineData only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!oldLineData) group.removeAll();
        var seriesScope = $52292566d9cfa1f6$var$makeSeriesScope(lineData);
        lineData.diff(oldLineData).add(function(idx) {
            _this._doAdd(lineData, idx, seriesScope);
        }).update(function(newIdx, oldIdx) {
            _this._doUpdate(oldLineData, lineData, oldIdx, newIdx, seriesScope);
        }).remove(function(idx) {
            group.remove(oldLineData.getItemGraphicEl(idx));
        }).execute();
    };
    LineDraw.prototype.updateLayout = function() {
        var lineData = this._lineData;
        // Do not support update layout in incremental mode.
        if (!lineData) return;
        lineData.eachItemGraphicEl(function(el, idx) {
            el.updateLayout(lineData, idx);
        }, this);
    };
    LineDraw.prototype.incrementalPrepareUpdate = function(lineData) {
        this._seriesScope = $52292566d9cfa1f6$var$makeSeriesScope(lineData);
        this._lineData = null;
        this.group.removeAll();
    };
    LineDraw.prototype.incrementalUpdate = function(taskParams, lineData) {
        this._progressiveEls = [];
        function updateIncrementalAndHover(el) {
            if (!el.isGroup && !$52292566d9cfa1f6$var$isEffectObject(el)) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = taskParams.start; idx < taskParams.end; idx++){
            var itemLayout = lineData.getItemLayout(idx);
            if ($52292566d9cfa1f6$var$lineNeedsDraw(itemLayout)) {
                var el = new this._LineCtor(lineData, idx, this._seriesScope);
                el.traverse(updateIncrementalAndHover);
                this.group.add(el);
                lineData.setItemGraphicEl(idx, el);
                this._progressiveEls.push(el);
            }
        }
    };
    LineDraw.prototype.remove = function() {
        this.group.removeAll();
    };
    LineDraw.prototype.eachRendered = function(cb) {
        $8eb95236e1aa01e7$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    LineDraw.prototype._doAdd = function(lineData, idx, seriesScope) {
        var itemLayout = lineData.getItemLayout(idx);
        if (!$52292566d9cfa1f6$var$lineNeedsDraw(itemLayout)) return;
        var el = new this._LineCtor(lineData, idx, seriesScope);
        lineData.setItemGraphicEl(idx, el);
        this.group.add(el);
    };
    LineDraw.prototype._doUpdate = function(oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
        var itemEl = oldLineData.getItemGraphicEl(oldIdx);
        if (!$52292566d9cfa1f6$var$lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
            this.group.remove(itemEl);
            return;
        }
        if (!itemEl) itemEl = new this._LineCtor(newLineData, newIdx, seriesScope);
        else itemEl.updateData(newLineData, newIdx, seriesScope);
        newLineData.setItemGraphicEl(newIdx, itemEl);
        this.group.add(itemEl);
    };
    return LineDraw;
}();
function $52292566d9cfa1f6$var$isEffectObject(el) {
    return el.animators && el.animators.length > 0;
}
function $52292566d9cfa1f6$var$makeSeriesScope(lineData) {
    var hostModel = lineData.hostModel;
    var emphasisModel = hostModel.getModel('emphasis');
    return {
        lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
        emphasisLineStyle: emphasisModel.getModel([
            'lineStyle'
        ]).getLineStyle(),
        blurLineStyle: hostModel.getModel([
            'blur',
            'lineStyle'
        ]).getLineStyle(),
        selectLineStyle: hostModel.getModel([
            'select',
            'lineStyle'
        ]).getLineStyle(),
        emphasisDisabled: emphasisModel.get('disabled'),
        blurScope: emphasisModel.get('blurScope'),
        focus: emphasisModel.get('focus'),
        labelStatesModels: (0, $3828198b2f2de836$export$9739a32674be5893)(hostModel)
    };
}
function $52292566d9cfa1f6$var$isPointNaN(pt) {
    return isNaN(pt[0]) || isNaN(pt[1]);
}
function $52292566d9cfa1f6$var$lineNeedsDraw(pts) {
    return pts && !$52292566d9cfa1f6$var$isPointNaN(pts[0]) && !$52292566d9cfa1f6$var$isPointNaN(pts[1]);
}
var $52292566d9cfa1f6$export$2e2bcd8739ae039 = $52292566d9cfa1f6$var$LineDraw;






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $76f7100aa34eec9e$var$v1 = [];
var $76f7100aa34eec9e$var$v2 = [];
var $76f7100aa34eec9e$var$v3 = [];
var $76f7100aa34eec9e$var$quadraticAt = $eea9463646207a7b$export$af17094a950f5073;
var $76f7100aa34eec9e$var$v2DistSquare = $3dde7d051fe20daa$export$c68db45a034c13b0;
var $76f7100aa34eec9e$var$mathAbs = Math.abs;
function $76f7100aa34eec9e$var$intersectCurveCircle(curvePoints, center, radius) {
    var p0 = curvePoints[0];
    var p1 = curvePoints[1];
    var p2 = curvePoints[2];
    var d = Infinity;
    var t;
    var radiusSquare = radius * radius;
    var interval = 0.1;
    for(var _t = 0.1; _t <= 0.9; _t += 0.1){
        $76f7100aa34eec9e$var$v1[0] = $76f7100aa34eec9e$var$quadraticAt(p0[0], p1[0], p2[0], _t);
        $76f7100aa34eec9e$var$v1[1] = $76f7100aa34eec9e$var$quadraticAt(p0[1], p1[1], p2[1], _t);
        var diff = $76f7100aa34eec9e$var$mathAbs($76f7100aa34eec9e$var$v2DistSquare($76f7100aa34eec9e$var$v1, center) - radiusSquare);
        if (diff < d) {
            d = diff;
            t = _t;
        }
    }
    // Assume the segment is monotone，Find root through Bisection method
    // At most 32 iteration
    for(var i = 0; i < 32; i++){
        // let prev = t - interval;
        var next = t + interval;
        // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
        // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
        $76f7100aa34eec9e$var$v2[0] = $76f7100aa34eec9e$var$quadraticAt(p0[0], p1[0], p2[0], t);
        $76f7100aa34eec9e$var$v2[1] = $76f7100aa34eec9e$var$quadraticAt(p0[1], p1[1], p2[1], t);
        $76f7100aa34eec9e$var$v3[0] = $76f7100aa34eec9e$var$quadraticAt(p0[0], p1[0], p2[0], next);
        $76f7100aa34eec9e$var$v3[1] = $76f7100aa34eec9e$var$quadraticAt(p0[1], p1[1], p2[1], next);
        var diff = $76f7100aa34eec9e$var$v2DistSquare($76f7100aa34eec9e$var$v2, center) - radiusSquare;
        if ($76f7100aa34eec9e$var$mathAbs(diff) < 1e-2) break;
        // let prevDiff = v2DistSquare(v1, center) - radiusSquare;
        var nextDiff = $76f7100aa34eec9e$var$v2DistSquare($76f7100aa34eec9e$var$v3, center) - radiusSquare;
        interval /= 2;
        if (diff < 0) {
            if (nextDiff >= 0) t = t + interval;
            else t = t - interval;
        } else if (nextDiff >= 0) t = t - interval;
        else t = t + interval;
    }
    return t;
}
function $76f7100aa34eec9e$export$2e2bcd8739ae039(graph, scale) {
    var tmp0 = [];
    var quadraticSubdivide = $eea9463646207a7b$export$117c659e21a7a060;
    var pts = [
        [],
        [],
        []
    ];
    var pts2 = [
        [],
        []
    ];
    var v = [];
    scale /= 2;
    graph.eachEdge(function(edge, idx) {
        var linePoints = edge.getLayout();
        var fromSymbol = edge.getVisual('fromSymbol');
        var toSymbol = edge.getVisual('toSymbol');
        if (!linePoints.__original) {
            linePoints.__original = [
                $3dde7d051fe20daa$export$9cd59f9826255e47(linePoints[0]),
                $3dde7d051fe20daa$export$9cd59f9826255e47(linePoints[1])
            ];
            if (linePoints[2]) linePoints.__original.push($3dde7d051fe20daa$export$9cd59f9826255e47(linePoints[2]));
        }
        var originalPoints = linePoints.__original;
        // Quadratic curve
        if (linePoints[2] != null) {
            $3dde7d051fe20daa$export$784d13d8ee351f07(pts[0], originalPoints[0]);
            $3dde7d051fe20daa$export$784d13d8ee351f07(pts[1], originalPoints[2]);
            $3dde7d051fe20daa$export$784d13d8ee351f07(pts[2], originalPoints[1]);
            if (fromSymbol && fromSymbol !== 'none') {
                var symbolSize = (0, $447ca6843adad8c5$export$8d4a06d3facd414b)(edge.node1);
                var t = $76f7100aa34eec9e$var$intersectCurveCircle(pts, originalPoints[0], symbolSize * scale);
                // Subdivide and get the second
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[0][0] = tmp0[3];
                pts[1][0] = tmp0[4];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[0][1] = tmp0[3];
                pts[1][1] = tmp0[4];
            }
            if (toSymbol && toSymbol !== 'none') {
                var symbolSize = (0, $447ca6843adad8c5$export$8d4a06d3facd414b)(edge.node2);
                var t = $76f7100aa34eec9e$var$intersectCurveCircle(pts, originalPoints[1], symbolSize * scale);
                // Subdivide and get the first
                quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
                pts[1][0] = tmp0[1];
                pts[2][0] = tmp0[2];
                quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
                pts[1][1] = tmp0[1];
                pts[2][1] = tmp0[2];
            }
            // Copy back to layout
            $3dde7d051fe20daa$export$784d13d8ee351f07(linePoints[0], pts[0]);
            $3dde7d051fe20daa$export$784d13d8ee351f07(linePoints[1], pts[2]);
            $3dde7d051fe20daa$export$784d13d8ee351f07(linePoints[2], pts[1]);
        } else {
            $3dde7d051fe20daa$export$784d13d8ee351f07(pts2[0], originalPoints[0]);
            $3dde7d051fe20daa$export$784d13d8ee351f07(pts2[1], originalPoints[1]);
            $3dde7d051fe20daa$export$f93b5905241a7cca(v, pts2[1], pts2[0]);
            $3dde7d051fe20daa$export$a3295358bff77e(v, v);
            if (fromSymbol && fromSymbol !== 'none') {
                var symbolSize = (0, $447ca6843adad8c5$export$8d4a06d3facd414b)(edge.node1);
                $3dde7d051fe20daa$export$19cedf1da84ba854(pts2[0], pts2[0], v, symbolSize * scale);
            }
            if (toSymbol && toSymbol !== 'none') {
                var symbolSize = (0, $447ca6843adad8c5$export$8d4a06d3facd414b)(edge.node2);
                $3dde7d051fe20daa$export$19cedf1da84ba854(pts2[1], pts2[1], v, -symbolSize * scale);
            }
            $3dde7d051fe20daa$export$784d13d8ee351f07(linePoints[0], pts2[0]);
            $3dde7d051fe20daa$export$784d13d8ee351f07(linePoints[1], pts2[1]);
        }
    });
}







function $ee78d61e3c92bfb4$var$isViewCoordSys(coordSys) {
    return coordSys.type === 'view';
}
var $ee78d61e3c92bfb4$var$GraphView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GraphView, _super);
    function GraphView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphView.type;
        return _this;
    }
    GraphView.prototype.init = function(ecModel, api) {
        var symbolDraw = new (0, $89a14c17b9971b0f$export$2e2bcd8739ae039)();
        var lineDraw = new (0, $52292566d9cfa1f6$export$2e2bcd8739ae039)();
        var group = this.group;
        this._controller = new (0, $36ebde58055237cc$export$2e2bcd8739ae039)(api.getZr());
        this._controllerHost = {
            target: group
        };
        group.add(symbolDraw.group);
        group.add(lineDraw.group);
        this._symbolDraw = symbolDraw;
        this._lineDraw = lineDraw;
        this._firstRender = true;
    };
    GraphView.prototype.render = function(seriesModel, ecModel, api) {
        var _this = this;
        var coordSys = seriesModel.coordinateSystem;
        this._model = seriesModel;
        var symbolDraw = this._symbolDraw;
        var lineDraw = this._lineDraw;
        var group = this.group;
        if ($ee78d61e3c92bfb4$var$isViewCoordSys(coordSys)) {
            var groupNewProp = {
                x: coordSys.x,
                y: coordSys.y,
                scaleX: coordSys.scaleX,
                scaleY: coordSys.scaleY
            };
            if (this._firstRender) group.attr(groupNewProp);
            else $b40111164617dd60$export$c8dce3c08436e91e(group, groupNewProp, seriesModel);
        }
        // Fix edge contact point with node
        (0, $76f7100aa34eec9e$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $447ca6843adad8c5$export$e2aa0fb9ed198ba7)(seriesModel));
        var data = seriesModel.getData();
        symbolDraw.updateData(data);
        var edgeData = seriesModel.getEdgeData();
        // TODO: TYPE
        lineDraw.updateData(edgeData);
        this._updateNodeAndLinkScale();
        this._updateController(seriesModel, ecModel, api);
        clearTimeout(this._layoutTimeout);
        var forceLayout = seriesModel.forceLayout;
        var layoutAnimation = seriesModel.get([
            'force',
            'layoutAnimation'
        ]);
        if (forceLayout) this._startForceLayoutIteration(forceLayout, layoutAnimation);
        var layout = seriesModel.get('layout');
        data.graph.eachNode(function(node) {
            var idx = node.dataIndex;
            var el = node.getGraphicEl();
            var itemModel = node.getModel();
            if (!el) return;
            // Update draggable
            el.off('drag').off('dragend');
            var draggable = itemModel.get('draggable');
            if (draggable) el.on('drag', function(e) {
                switch(layout){
                    case 'force':
                        forceLayout.warmUp();
                        !_this._layouting && _this._startForceLayoutIteration(forceLayout, layoutAnimation);
                        forceLayout.setFixed(idx);
                        // Write position back to layout
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        break;
                    case 'circular':
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // mark node fixed
                        node.setLayout({
                            fixed: true
                        }, true);
                        // recalculate circular layout
                        (0, $1debe8addc501597$export$cbfed6ae5cab3dae)(seriesModel, 'symbolSize', node, [
                            e.offsetX,
                            e.offsetY
                        ]);
                        _this.updateLayout(seriesModel);
                        break;
                    case 'none':
                    default:
                        data.setItemLayout(idx, [
                            el.x,
                            el.y
                        ]);
                        // update edge
                        (0, $e60de15cea0c1d76$export$a25b52345bee32aa)(seriesModel.getGraph(), seriesModel);
                        _this.updateLayout(seriesModel);
                        break;
                }
            }).on('dragend', function() {
                if (forceLayout) forceLayout.setUnfixed(idx);
            });
            el.setDraggable(draggable, !!itemModel.get('cursor'));
            var focus = itemModel.get([
                'emphasis',
                'focus'
            ]);
            if (focus === 'adjacency') (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).focus = node.getAdjacentDataIndices();
        });
        data.graph.eachEdge(function(edge) {
            var el = edge.getGraphicEl();
            var focus = edge.getModel().get([
                'emphasis',
                'focus'
            ]);
            if (!el) return;
            if (focus === 'adjacency') (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).focus = {
                edge: [
                    edge.dataIndex
                ],
                node: [
                    edge.node1.dataIndex,
                    edge.node2.dataIndex
                ]
            };
        });
        var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get([
            'circular',
            'rotateLabel'
        ]);
        var cx = data.getLayout('cx');
        var cy = data.getLayout('cy');
        data.graph.eachNode(function(node) {
            (0, $1debe8addc501597$export$c768377a6a0a9ab8)(node, circularRotateLabel, cx, cy);
        });
        this._firstRender = false;
    };
    GraphView.prototype.dispose = function() {
        this.remove();
        this._controller && this._controller.dispose();
        this._controllerHost = null;
    };
    GraphView.prototype._startForceLayoutIteration = function(forceLayout, layoutAnimation) {
        var self = this;
        (function step() {
            forceLayout.step(function(stopped) {
                self.updateLayout(self._model);
                (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
            });
        })();
    };
    GraphView.prototype._updateController = function(seriesModel, ecModel, api) {
        var _this = this;
        var controller = this._controller;
        var controllerHost = this._controllerHost;
        var group = this.group;
        controller.setPointerChecker(function(e, x, y) {
            var rect = group.getBoundingRect();
            rect.applyTransform(group.transform);
            return rect.contain(x, y) && !(0, $644ca0c6add6ebe3$export$8a33eacb690eac07)(e, api, seriesModel);
        });
        if (!$ee78d61e3c92bfb4$var$isViewCoordSys(seriesModel.coordinateSystem)) {
            controller.disable();
            return;
        }
        controller.enable(seriesModel.get('roam'));
        controllerHost.zoomLimit = seriesModel.get('scaleLimit');
        controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
        controller.off('pan').off('zoom').on('pan', function(e) {
            $77c59df9b4754854$export$1e6abcd98caba733(controllerHost, e.dx, e.dy);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'graphRoam',
                dx: e.dx,
                dy: e.dy
            });
        }).on('zoom', function(e) {
            $77c59df9b4754854$export$29b3c66d30a4866(controllerHost, e.scale, e.originX, e.originY);
            api.dispatchAction({
                seriesId: seriesModel.id,
                type: 'graphRoam',
                zoom: e.scale,
                originX: e.originX,
                originY: e.originY
            });
            _this._updateNodeAndLinkScale();
            (0, $76f7100aa34eec9e$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $447ca6843adad8c5$export$e2aa0fb9ed198ba7)(seriesModel));
            _this._lineDraw.updateLayout();
            // Only update label layout on zoom
            api.updateLabelLayout();
        });
    };
    GraphView.prototype._updateNodeAndLinkScale = function() {
        var seriesModel = this._model;
        var data = seriesModel.getData();
        var nodeScale = (0, $447ca6843adad8c5$export$e2aa0fb9ed198ba7)(seriesModel);
        data.eachItemGraphicEl(function(el, idx) {
            el && el.setSymbolScale(nodeScale);
        });
    };
    GraphView.prototype.updateLayout = function(seriesModel) {
        (0, $76f7100aa34eec9e$export$2e2bcd8739ae039)(seriesModel.getGraph(), (0, $447ca6843adad8c5$export$e2aa0fb9ed198ba7)(seriesModel));
        this._symbolDraw.updateLayout();
        this._lineDraw.updateLayout();
    };
    GraphView.prototype.remove = function() {
        clearTimeout(this._layoutTimeout);
        this._layouting = false;
        this._layoutTimeout = null;
        this._symbolDraw && this._symbolDraw.remove();
        this._lineDraw && this._lineDraw.remove();
    };
    GraphView.type = 'graph';
    return GraphView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $ee78d61e3c92bfb4$export$2e2bcd8739ae039 = $ee78d61e3c92bfb4$var$GraphView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// id may be function name of Object, add a prefix to avoid this problem.
function $cbd784a1af34887f$var$generateNodeKey(id) {
    return '_EC_' + id;
}
var $cbd784a1af34887f$var$Graph = /** @class */ function() {
    function Graph(directed) {
        this.type = 'graph';
        this.nodes = [];
        this.edges = [];
        this._nodesMap = {};
        /**
     * @type {Object.<string, module:echarts/data/Graph.Edge>}
     * @private
     */ this._edgesMap = {};
        this._directed = directed || false;
    }
    /**
   * If is directed graph
   */ Graph.prototype.isDirected = function() {
        return this._directed;
    };
    /**
   * Add a new node
   */ Graph.prototype.addNode = function(id, dataIndex) {
        id = id == null ? '' + dataIndex : '' + id;
        var nodesMap = this._nodesMap;
        if (nodesMap[$cbd784a1af34887f$var$generateNodeKey(id)]) return;
        var node = new $cbd784a1af34887f$export$32866653dfc29d0d(id, dataIndex);
        node.hostGraph = this;
        this.nodes.push(node);
        nodesMap[$cbd784a1af34887f$var$generateNodeKey(id)] = node;
        return node;
    };
    /**
   * Get node by data index
   */ Graph.prototype.getNodeByIndex = function(dataIndex) {
        var rawIdx = this.data.getRawIndex(dataIndex);
        return this.nodes[rawIdx];
    };
    /**
   * Get node by id
   */ Graph.prototype.getNodeById = function(id) {
        return this._nodesMap[$cbd784a1af34887f$var$generateNodeKey(id)];
    };
    /**
   * Add a new edge
   */ Graph.prototype.addEdge = function(n1, n2, dataIndex) {
        var nodesMap = this._nodesMap;
        var edgesMap = this._edgesMap;
        // PENDING
        if ($1b239fc9d3a2f8ae$export$7e4aa119212bc614(n1)) n1 = this.nodes[n1];
        if ($1b239fc9d3a2f8ae$export$7e4aa119212bc614(n2)) n2 = this.nodes[n2];
        if (!(n1 instanceof $cbd784a1af34887f$export$32866653dfc29d0d)) n1 = nodesMap[$cbd784a1af34887f$var$generateNodeKey(n1)];
        if (!(n2 instanceof $cbd784a1af34887f$export$32866653dfc29d0d)) n2 = nodesMap[$cbd784a1af34887f$var$generateNodeKey(n2)];
        if (!n1 || !n2) return;
        var key = n1.id + '-' + n2.id;
        var edge = new $cbd784a1af34887f$export$87f150720cc8d165(n1, n2, dataIndex);
        edge.hostGraph = this;
        if (this._directed) {
            n1.outEdges.push(edge);
            n2.inEdges.push(edge);
        }
        n1.edges.push(edge);
        if (n1 !== n2) n2.edges.push(edge);
        this.edges.push(edge);
        edgesMap[key] = edge;
        return edge;
    };
    /**
   * Get edge by data index
   */ Graph.prototype.getEdgeByIndex = function(dataIndex) {
        var rawIdx = this.edgeData.getRawIndex(dataIndex);
        return this.edges[rawIdx];
    };
    /**
   * Get edge by two linked nodes
   */ Graph.prototype.getEdge = function(n1, n2) {
        if (n1 instanceof $cbd784a1af34887f$export$32866653dfc29d0d) n1 = n1.id;
        if (n2 instanceof $cbd784a1af34887f$export$32866653dfc29d0d) n2 = n2.id;
        var edgesMap = this._edgesMap;
        if (this._directed) return edgesMap[n1 + '-' + n2];
        else return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
    };
    /**
   * Iterate all nodes
   */ Graph.prototype.eachNode = function(cb, context) {
        var nodes = this.nodes;
        var len = nodes.length;
        for(var i = 0; i < len; i++)if (nodes[i].dataIndex >= 0) cb.call(context, nodes[i], i);
    };
    /**
   * Iterate all edges
   */ Graph.prototype.eachEdge = function(cb, context) {
        var edges = this.edges;
        var len = edges.length;
        for(var i = 0; i < len; i++)if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) cb.call(context, edges[i], i);
    };
    /**
   * Breadth first traverse
   * Return true to stop traversing
   */ Graph.prototype.breadthFirstTraverse = function(cb, startNode, direction, context) {
        if (!(startNode instanceof $cbd784a1af34887f$export$32866653dfc29d0d)) startNode = this._nodesMap[$cbd784a1af34887f$var$generateNodeKey(startNode)];
        if (!startNode) return;
        var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
        for(var i = 0; i < this.nodes.length; i++)this.nodes[i].__visited = false;
        if (cb.call(context, startNode, null)) return;
        var queue = [
            startNode
        ];
        while(queue.length){
            var currentNode = queue.shift();
            var edges = currentNode[edgeType];
            for(var i = 0; i < edges.length; i++){
                var e = edges[i];
                var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
                if (!otherNode.__visited) {
                    if (cb.call(context, otherNode, currentNode)) // Stop traversing
                    return;
                    queue.push(otherNode);
                    otherNode.__visited = true;
                }
            }
        }
    };
    // TODO
    // depthFirstTraverse(
    //     cb, startNode, direction, context
    // ) {
    // };
    // Filter update
    Graph.prototype.update = function() {
        var data = this.data;
        var edgeData = this.edgeData;
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0, len = nodes.length; i < len; i++)nodes[i].dataIndex = -1;
        for(var i = 0, len = data.count(); i < len; i++)nodes[data.getRawIndex(i)].dataIndex = i;
        edgeData.filterSelf(function(idx) {
            var edge = edges[edgeData.getRawIndex(idx)];
            return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
        });
        // Update edge
        for(var i = 0, len = edges.length; i < len; i++)edges[i].dataIndex = -1;
        for(var i = 0, len = edgeData.count(); i < len; i++)edges[edgeData.getRawIndex(i)].dataIndex = i;
    };
    /**
   * @return {module:echarts/data/Graph}
   */ Graph.prototype.clone = function() {
        var graph = new Graph(this._directed);
        var nodes = this.nodes;
        var edges = this.edges;
        for(var i = 0; i < nodes.length; i++)graph.addNode(nodes[i].id, nodes[i].dataIndex);
        for(var i = 0; i < edges.length; i++){
            var e = edges[i];
            graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
        }
        return graph;
    };
    return Graph;
}();
var $cbd784a1af34887f$export$32866653dfc29d0d = /** @class */ function() {
    function GraphNode(id, dataIndex) {
        this.inEdges = [];
        this.outEdges = [];
        this.edges = [];
        this.dataIndex = -1;
        this.id = id == null ? '' : id;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    /**
   * @return {number}
   */ GraphNode.prototype.degree = function() {
        return this.edges.length;
    };
    /**
   * @return {number}
   */ GraphNode.prototype.inDegree = function() {
        return this.inEdges.length;
    };
    /**
  * @return {number}
  */ GraphNode.prototype.outDegree = function() {
        return this.outEdges.length;
    };
    GraphNode.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.data.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphNode.prototype.getAdjacentDataIndices = function() {
        var dataIndices = {
            edge: [],
            node: []
        };
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            dataIndices.edge.push(adjacentEdge.dataIndex);
            dataIndices.node.push(adjacentEdge.node1.dataIndex, adjacentEdge.node2.dataIndex);
        }
        return dataIndices;
    };
    GraphNode.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        for(var i = 0; i < this.edges.length; i++){
            var adjacentEdge = this.edges[i];
            if (adjacentEdge.dataIndex < 0) continue;
            connectedEdgesMap.set(adjacentEdge.dataIndex, true);
            var sourceNodesQueue = [
                adjacentEdge.node1
            ];
            var targetNodesQueue = [
                adjacentEdge.node2
            ];
            var nodeIteratorIndex = 0;
            while(nodeIteratorIndex < sourceNodesQueue.length){
                var sourceNode = sourceNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(sourceNode.dataIndex, true);
                for(var j = 0; j < sourceNode.inEdges.length; j++){
                    connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                    sourceNodesQueue.push(sourceNode.inEdges[j].node1);
                }
            }
            nodeIteratorIndex = 0;
            while(nodeIteratorIndex < targetNodesQueue.length){
                var targetNode = targetNodesQueue[nodeIteratorIndex];
                nodeIteratorIndex++;
                connectedNodesMap.set(targetNode.dataIndex, true);
                for(var j = 0; j < targetNode.outEdges.length; j++){
                    connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                    targetNodesQueue.push(targetNode.outEdges[j].node2);
                }
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphNode;
}();
var $cbd784a1af34887f$export$87f150720cc8d165 = /** @class */ function() {
    function GraphEdge(n1, n2, dataIndex) {
        this.dataIndex = -1;
        this.node1 = n1;
        this.node2 = n2;
        this.dataIndex = dataIndex == null ? -1 : dataIndex;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    GraphEdge.prototype.getModel = function(path) {
        if (this.dataIndex < 0) return;
        var graph = this.hostGraph;
        var itemModel = graph.edgeData.getItemModel(this.dataIndex);
        return itemModel.getModel(path);
    };
    GraphEdge.prototype.getAdjacentDataIndices = function() {
        return {
            edge: [
                this.dataIndex
            ],
            node: [
                this.node1.dataIndex,
                this.node2.dataIndex
            ]
        };
    };
    GraphEdge.prototype.getTrajectoryDataIndices = function() {
        var connectedEdgesMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var connectedNodesMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        connectedEdgesMap.set(this.dataIndex, true);
        var sourceNodes = [
            this.node1
        ];
        var targetNodes = [
            this.node2
        ];
        var nodeIteratorIndex = 0;
        while(nodeIteratorIndex < sourceNodes.length){
            var sourceNode = sourceNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(sourceNode.dataIndex, true);
            for(var j = 0; j < sourceNode.inEdges.length; j++){
                connectedEdgesMap.set(sourceNode.inEdges[j].dataIndex, true);
                sourceNodes.push(sourceNode.inEdges[j].node1);
            }
        }
        nodeIteratorIndex = 0;
        while(nodeIteratorIndex < targetNodes.length){
            var targetNode = targetNodes[nodeIteratorIndex];
            nodeIteratorIndex++;
            connectedNodesMap.set(targetNode.dataIndex, true);
            for(var j = 0; j < targetNode.outEdges.length; j++){
                connectedEdgesMap.set(targetNode.outEdges[j].dataIndex, true);
                targetNodes.push(targetNode.outEdges[j].node2);
            }
        }
        return {
            edge: connectedEdgesMap.keys(),
            node: connectedNodesMap.keys()
        };
    };
    return GraphEdge;
}();
function $cbd784a1af34887f$var$createGraphDataProxyMixin(hostName, dataName) {
    return {
        /**
     * @param Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
     */ getValue: function(dimension) {
            var data = this[hostName][dataName];
            return data.getStore().get(data.getDimensionIndex(dimension || 'value'), this.dataIndex);
        },
        // TODO: TYPE stricter type.
        setVisual: function(key, value) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
        },
        getVisual: function(key) {
            return this[hostName][dataName].getItemVisual(this.dataIndex, key);
        },
        setLayout: function(layout, merge) {
            this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
        },
        getLayout: function() {
            return this[hostName][dataName].getItemLayout(this.dataIndex);
        },
        getGraphicEl: function() {
            return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
        },
        getRawIndex: function() {
            return this[hostName][dataName].getRawIndex(this.dataIndex);
        }
    };
}
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($cbd784a1af34887f$export$32866653dfc29d0d, $cbd784a1af34887f$var$createGraphDataProxyMixin('hostGraph', 'data'));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($cbd784a1af34887f$export$87f150720cc8d165, $cbd784a1af34887f$var$createGraphDataProxyMixin('hostGraph', 'edgeData'));
var $cbd784a1af34887f$export$2e2bcd8739ae039 = $cbd784a1af34887f$var$Graph;







function $986d83b3918bd6aa$export$2e2bcd8739ae039(nodes, edges, seriesModel, directed, beforeLink) {
    // ??? TODO
    // support dataset?
    var graph = new (0, $cbd784a1af34887f$export$2e2bcd8739ae039)(directed);
    for(var i = 0; i < nodes.length; i++)graph.addNode($1b239fc9d3a2f8ae$export$8a4d17b6e8486e66(// Id, name, dataIndex
    nodes[i].id, nodes[i].name, i), i);
    var linkNameList = [];
    var validEdges = [];
    var linkCount = 0;
    for(var i = 0; i < edges.length; i++){
        var link = edges[i];
        var source = link.source;
        var target = link.target;
        // addEdge may fail when source or target not exists
        if (graph.addEdge(source, target, linkCount)) {
            validEdges.push(link);
            linkNameList.push($1b239fc9d3a2f8ae$export$8a4d17b6e8486e66((0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)(link.id, null), source + ' > ' + target));
            linkCount++;
        }
    }
    var coordSys = seriesModel.get('coordinateSystem');
    var nodeData;
    if (coordSys === 'cartesian2d' || coordSys === 'polar') nodeData = (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(nodes, seriesModel);
    else {
        var coordSysCtor = (0, $02d04429d2792472$export$2e2bcd8739ae039).get(coordSys);
        var coordDimensions = coordSysCtor ? coordSysCtor.dimensions || [] : [];
        // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
        // `value` dimension, but graph need `value` dimension. It's better to
        // uniform this behavior.
        if ($1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(coordDimensions, 'value') < 0) coordDimensions.concat([
            'value'
        ]);
        var dimensions = (0, $02c5dbb1162b825d$export$2e2bcd8739ae039)(nodes, {
            coordDimensions: coordDimensions,
            encodeDefine: seriesModel.getEncode()
        }).dimensions;
        nodeData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(dimensions, seriesModel);
        nodeData.initData(nodes);
    }
    var edgeData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)([
        'value'
    ], seriesModel);
    edgeData.initData(validEdges, linkNameList);
    beforeLink && beforeLink(nodeData, edgeData);
    (0, $2006c76a251ecd6d$export$2e2bcd8739ae039)({
        mainData: nodeData,
        struct: graph,
        structAttr: 'graph',
        datas: {
            node: nodeData,
            edge: edgeData
        },
        datasAttr: {
            node: 'data',
            edge: 'edgeData'
        }
    });
    // Update dataIndex of nodes and edges because invalid edge may be removed
    graph.update();
    return graph;
}







var $b20ec7d27a9baf03$var$GraphSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GraphSeriesModel, _super);
    function GraphSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    GraphSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        var self = this;
        function getCategoriesData() {
            return self._categoriesData;
        }
        // Provide data for legend select
        this.legendVisualProvider = new (0, $f7d155e85e188448$export$2e2bcd8739ae039)(getCategoriesData, getCategoriesData);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this.fillDataTextStyle(option.edges || option.links);
        this._updateCategoriesData();
    };
    GraphSeriesModel.prototype.mergeDefaultAndTheme = function(option) {
        _super.prototype.mergeDefaultAndTheme.apply(this, arguments);
        (0, $9ac03c46e8b6e711$export$abdcc6a26372f94b)(option, 'edgeLabel', [
            'show'
        ]);
    };
    GraphSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var edges = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var self = this;
        if (nodes && edges) {
            // auto curveness
            (0, $0e33d794c0e19777$export$4f05389c1f2934b8)(this);
            var graph = (0, $986d83b3918bd6aa$export$2e2bcd8739ae039)(nodes, edges, this, true, beforeLink);
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(graph.edges, function(edge) {
                (0, $0e33d794c0e19777$export$c47b549eed9a7311)(edge.node1, edge.node2, this, edge.dataIndex);
            }, this);
            return graph.data;
        }
        function beforeLink(nodeData, edgeData) {
            // Overwrite nodeData.getItemModel to
            nodeData.wrapMethod('getItemModel', function(model) {
                var categoriesModels = self._categoriesModels;
                var categoryIdx = model.getShallow('category');
                var categoryModel = categoriesModels[categoryIdx];
                if (categoryModel) {
                    categoryModel.parentModel = model.parentModel;
                    model.parentModel = categoryModel;
                }
                return model;
            });
            // TODO Inherit resolveParentPath by default in Model#getModel?
            var oldGetModel = (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039).prototype.getModel;
            function newGetModel(path, parentModel) {
                var model = oldGetModel.call(this, path, parentModel);
                model.resolveParentPath = resolveParentPath;
                return model;
            }
            edgeData.wrapMethod('getItemModel', function(model) {
                model.resolveParentPath = resolveParentPath;
                model.getModel = newGetModel;
                return model;
            });
            function resolveParentPath(pathArr) {
                if (pathArr && (pathArr[0] === 'label' || pathArr[1] === 'label')) {
                    var newPathArr = pathArr.slice();
                    if (pathArr[0] === 'label') newPathArr[0] = 'edgeLabel';
                    else if (pathArr[1] === 'label') newPathArr[1] = 'edgeLabel';
                    return newPathArr;
                }
                return pathArr;
            }
        }
    };
    GraphSeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    GraphSeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    GraphSeriesModel.prototype.getCategoriesData = function() {
        return this._categoriesData;
    };
    GraphSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        if (dataType === 'edge') {
            var nodeData = this.getData();
            var params = this.getDataParams(dataIndex, dataType);
            var edge = nodeData.graph.getEdgeByIndex(dataIndex);
            var sourceName = nodeData.getName(edge.node1.dataIndex);
            var targetName = nodeData.getName(edge.node2.dataIndex);
            var nameArr = [];
            sourceName != null && nameArr.push(sourceName);
            targetName != null && nameArr.push(targetName);
            return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                name: nameArr.join(' > '),
                value: params.value,
                noValue: params.value == null
            });
        }
        // dataType === 'node' or empty
        var nodeMarkup = (0, $61040f4cb7ee424a$export$3a110b9fb5c88b34)({
            series: this,
            dataIndex: dataIndex,
            multipleSeries: multipleSeries
        });
        return nodeMarkup;
    };
    GraphSeriesModel.prototype._updateCategoriesData = function() {
        var categories = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(this.option.categories || [], function(category) {
            // Data must has value
            return category.value != null ? category : $1b239fc9d3a2f8ae$export$8b58be045bf06082({
                value: 0
            }, category);
        });
        var categoriesData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)([
            'value'
        ], this);
        categoriesData.initData(categories);
        this._categoriesData = categoriesData;
        this._categoriesModels = categoriesData.mapArray(function(idx) {
            return categoriesData.getItemModel(idx);
        });
    };
    GraphSeriesModel.prototype.setZoom = function(zoom) {
        this.option.zoom = zoom;
    };
    GraphSeriesModel.prototype.setCenter = function(center) {
        this.option.center = center;
    };
    GraphSeriesModel.prototype.isAnimationEnabled = function() {
        return _super.prototype.isAnimationEnabled.call(this) && !(this.get('layout') === 'force' && this.get([
            'force',
            'layoutAnimation'
        ]));
    };
    GraphSeriesModel.type = 'series.graph';
    GraphSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    GraphSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'view',
        // Default option for all coordinate systems
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // polarIndex: 0,
        // geoIndex: 0,
        legendHoverLink: true,
        layout: null,
        // Configuration of circular layout
        circular: {
            rotateLabel: false
        },
        // Configuration of force directed layout
        force: {
            initLayout: null,
            // Node repulsion. Can be an array to represent range.
            repulsion: [
                0,
                50
            ],
            gravity: 0.1,
            // Initial friction
            friction: 0.6,
            // Edge length. Can be an array to represent range.
            edgeLength: 30,
            layoutAnimation: true
        },
        left: 'center',
        top: 'center',
        // right: null,
        // bottom: null,
        // width: '80%',
        // height: '80%',
        symbol: 'circle',
        symbolSize: 10,
        edgeSymbol: [
            'none',
            'none'
        ],
        edgeSymbolSize: 10,
        edgeLabel: {
            position: 'middle',
            distance: 5
        },
        draggable: false,
        roam: false,
        // Default on center of graph
        center: null,
        zoom: 1,
        // Symbol size scale ratio in roam
        nodeScaleRatio: 0.6,
        // cursor: null,
        // categories: [],
        // data: []
        // Or
        // nodes: []
        //
        // links: []
        // Or
        // edges: []
        label: {
            show: false,
            formatter: '{b}'
        },
        itemStyle: {},
        lineStyle: {
            color: '#aaa',
            width: 1,
            opacity: 0.5
        },
        emphasis: {
            scale: true,
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    };
    return GraphSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $b20ec7d27a9baf03$export$2e2bcd8739ae039 = $b20ec7d27a9baf03$var$GraphSeriesModel;




var $79203a7e07e1ae9b$var$actionInfo = {
    type: 'graphRoam',
    event: 'graphRoam',
    update: 'none'
};
function $79203a7e07e1ae9b$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $ee78d61e3c92bfb4$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $b20ec7d27a9baf03$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $a3eb6b45c47d1d67$export$2e2bcd8739ae039));
    registers.registerVisual((0, $d6191c8947b6285c$export$2e2bcd8739ae039));
    registers.registerVisual((0, $30c6525273d94b44$export$2e2bcd8739ae039));
    registers.registerLayout((0, $14787d2cae490f6f$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.POST_CHART_LAYOUT, (0, $1f9590f1cf133b7f$export$2e2bcd8739ae039));
    registers.registerLayout((0, $4fe373109e3bb70b$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('graphView', {
        dimensions: (0, $6713d37ec624c52a$export$2e2bcd8739ae039).dimensions,
        create: (0, $8d25196a2f1e6b5b$export$2e2bcd8739ae039)
    });
    // Register legacy focus actions
    registers.registerAction({
        type: 'focusNodeAdjacency',
        event: 'focusNodeAdjacency',
        update: 'series:focusNodeAdjacency'
    }, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
    registers.registerAction({
        type: 'unfocusNodeAdjacency',
        event: 'unfocusNodeAdjacency',
        update: 'series:unfocusNodeAdjacency'
    }, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
    // Register roam action.
    registers.registerAction($79203a7e07e1ae9b$var$actionInfo, function(payload, ecModel, api) {
        ecModel.eachComponent({
            mainType: 'series',
            query: payload
        }, function(seriesModel) {
            var coordSys = seriesModel.coordinateSystem;
            var res = (0, $4ae3ee9cd93604f8$export$797ecc50d262ebd8)(coordSys, payload, undefined, api);
            seriesModel.setCenter && seriesModel.setCenter(res.center);
            seriesModel.setZoom && seriesModel.setZoom(res.zoom);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $e7c68e51f6da6d37$var$PointerShape = /** @class */ function() {
    function PointerShape() {
        this.angle = 0;
        this.width = 10;
        this.r = 10;
        this.x = 0;
        this.y = 0;
    }
    return PointerShape;
}();
var $e7c68e51f6da6d37$var$PointerPath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PointerPath, _super);
    function PointerPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'pointer';
        return _this;
    }
    PointerPath.prototype.getDefaultShape = function() {
        return new $e7c68e51f6da6d37$var$PointerShape();
    };
    PointerPath.prototype.buildPath = function(ctx, shape) {
        var mathCos = Math.cos;
        var mathSin = Math.sin;
        var r = shape.r;
        var width = shape.width;
        var angle = shape.angle;
        var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
        var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
        angle = shape.angle - Math.PI / 2;
        ctx.moveTo(x, y);
        ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
        ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
        ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
        ctx.lineTo(x, y);
    };
    return PointerPath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
var $e7c68e51f6da6d37$export$2e2bcd8739ae039 = $e7c68e51f6da6d37$var$PointerPath;













function $9e4ce2696c2378ec$var$parsePosition(seriesModel, api) {
    var center = seriesModel.get('center');
    var width = api.getWidth();
    var height = api.getHeight();
    var size = Math.min(width, height);
    var cx = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[0], api.getWidth());
    var cy = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[1], api.getHeight());
    var r = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('radius'), size / 2);
    return {
        cx: cx,
        cy: cy,
        r: r
    };
}
function $9e4ce2696c2378ec$var$formatLabel(value, labelFormatter) {
    var label = value == null ? '' : value + '';
    if (labelFormatter) {
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(labelFormatter)) label = labelFormatter.replace('{value}', label);
        else if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(labelFormatter)) label = labelFormatter(value);
    }
    return label;
}
var $9e4ce2696c2378ec$var$GaugeView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GaugeView, _super);
    function GaugeView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeView.type;
        return _this;
    }
    GaugeView.prototype.render = function(seriesModel, ecModel, api) {
        this.group.removeAll();
        var colorList = seriesModel.get([
            'axisLine',
            'lineStyle',
            'color'
        ]);
        var posInfo = $9e4ce2696c2378ec$var$parsePosition(seriesModel, api);
        this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
        this._data = seriesModel.getData();
    };
    GaugeView.prototype.dispose = function() {};
    GaugeView.prototype._renderMain = function(seriesModel, ecModel, api, colorList, posInfo) {
        var group = this.group;
        var clockwise = seriesModel.get('clockwise');
        var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
        var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
        var axisLineModel = seriesModel.getModel('axisLine');
        var roundCap = axisLineModel.get('roundCap');
        var MainPath = roundCap ? (0, $ff7cc14bc4a8408f$export$2e2bcd8739ae039) : $5fa26352e0605e60$export$2e2bcd8739ae039;
        var showAxis = axisLineModel.get('show');
        var lineStyleModel = axisLineModel.getModel('lineStyle');
        var axisLineWidth = lineStyleModel.get('width');
        var angles = [
            startAngle,
            endAngle
        ];
        (0, $3fd2aad7811d6df2$export$bc668021e937022a)(angles, !clockwise);
        startAngle = angles[0];
        endAngle = angles[1];
        var angleRangeSpan = endAngle - startAngle;
        var prevEndAngle = startAngle;
        var sectors = [];
        for(var i = 0; showAxis && i < colorList.length; i++){
            // Clamp
            var percent = Math.min(Math.max(colorList[i][0], 0), 1);
            endAngle = startAngle + angleRangeSpan * percent;
            var sector = new MainPath({
                shape: {
                    startAngle: prevEndAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: posInfo.r - axisLineWidth,
                    r: posInfo.r
                },
                silent: true
            });
            sector.setStyle({
                fill: colorList[i][1]
            });
            sector.setStyle(lineStyleModel.getLineStyle(// Because we use sector to simulate arc
            // so the properties for stroking are useless
            [
                'color',
                'width'
            ]));
            sectors.push(sector);
            prevEndAngle = endAngle;
        }
        sectors.reverse();
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(sectors, function(sector) {
            return group.add(sector);
        });
        var getColor = function(percent) {
            // Less than 0
            if (percent <= 0) return colorList[0][1];
            var i;
            for(i = 0; i < colorList.length; i++){
                if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) return colorList[i][1];
            }
            // More than 1
            return colorList[i - 1][1];
        };
        this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
        this._renderTitleAndDetail(seriesModel, ecModel, api, getColor, posInfo);
        this._renderAnchor(seriesModel, posInfo);
        this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth);
    };
    GaugeView.prototype._renderTicks = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var cx = posInfo.cx;
        var cy = posInfo.cy;
        var r = posInfo.r;
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var splitLineModel = seriesModel.getModel('splitLine');
        var tickModel = seriesModel.getModel('axisTick');
        var labelModel = seriesModel.getModel('axisLabel');
        var splitNumber = seriesModel.get('splitNumber');
        var subSplitNumber = tickModel.get('splitNumber');
        var splitLineLen = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(splitLineModel.get('length'), r);
        var tickLen = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(tickModel.get('length'), r);
        var angle = startAngle;
        var step = (endAngle - startAngle) / splitNumber;
        var subStep = step / subSplitNumber;
        var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
        var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
        var splitLineDistance = splitLineModel.get('distance');
        var unitX;
        var unitY;
        for(var i = 0; i <= splitNumber; i++){
            unitX = Math.cos(angle);
            unitY = Math.sin(angle);
            // Split line
            if (splitLineModel.get('show')) {
                var distance = splitLineDistance ? splitLineDistance + axisLineWidth : axisLineWidth;
                var splitLine = new $8324e8379a5583a5$export$2e2bcd8739ae039({
                    shape: {
                        x1: unitX * (r - distance) + cx,
                        y1: unitY * (r - distance) + cy,
                        x2: unitX * (r - splitLineLen - distance) + cx,
                        y2: unitY * (r - splitLineLen - distance) + cy
                    },
                    style: splitLineStyle,
                    silent: true
                });
                if (splitLineStyle.stroke === 'auto') splitLine.setStyle({
                    stroke: getColor(i / splitNumber)
                });
                group.add(splitLine);
            }
            // Label
            if (labelModel.get('show')) {
                var distance = labelModel.get('distance') + splitLineDistance;
                var label = $9e4ce2696c2378ec$var$formatLabel((0, $9fd90cf3bf18fbcd$export$2077e0241d6afd3c)(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
                var autoColor = getColor(i / splitNumber);
                var textStyleX = unitX * (r - splitLineLen - distance) + cx;
                var textStyleY = unitY * (r - splitLineLen - distance) + cy;
                var rotateType = labelModel.get('rotate');
                var rotate = 0;
                if (rotateType === 'radial') {
                    rotate = -angle + 2 * Math.PI;
                    if (rotate > Math.PI / 2) rotate += Math.PI;
                } else if (rotateType === 'tangential') rotate = -angle - Math.PI / 2;
                else if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(rotateType)) rotate = rotateType * Math.PI / 180;
                if (rotate === 0) group.add(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                    style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: unitY < -0.8 ? 'top' : unitY > 0.8 ? 'bottom' : 'middle',
                        align: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true
                }));
                else group.add(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                    style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(labelModel, {
                        text: label,
                        x: textStyleX,
                        y: textStyleY,
                        verticalAlign: 'middle',
                        align: 'center'
                    }, {
                        inheritColor: autoColor
                    }),
                    silent: true,
                    originX: textStyleX,
                    originY: textStyleY,
                    rotation: rotate
                }));
            }
            // Axis tick
            if (tickModel.get('show') && i !== splitNumber) {
                var distance = tickModel.get('distance');
                distance = distance ? distance + axisLineWidth : axisLineWidth;
                for(var j = 0; j <= subSplitNumber; j++){
                    unitX = Math.cos(angle);
                    unitY = Math.sin(angle);
                    var tickLine = new $8324e8379a5583a5$export$2e2bcd8739ae039({
                        shape: {
                            x1: unitX * (r - distance) + cx,
                            y1: unitY * (r - distance) + cy,
                            x2: unitX * (r - tickLen - distance) + cx,
                            y2: unitY * (r - tickLen - distance) + cy
                        },
                        silent: true,
                        style: tickLineStyle
                    });
                    if (tickLineStyle.stroke === 'auto') tickLine.setStyle({
                        stroke: getColor((i + j / subSplitNumber) / splitNumber)
                    });
                    group.add(tickLine);
                    angle += subStep;
                }
                angle -= subStep;
            } else angle += step;
        }
    };
    GaugeView.prototype._renderPointer = function(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise, axisLineWidth) {
        var group = this.group;
        var oldData = this._data;
        var oldProgressData = this._progressEls;
        var progressList = [];
        var showPointer = seriesModel.get([
            'pointer',
            'show'
        ]);
        var progressModel = seriesModel.getModel('progress');
        var showProgress = progressModel.get('show');
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var valueExtent = [
            minVal,
            maxVal
        ];
        var angleExtent = [
            startAngle,
            endAngle
        ];
        function createPointer(idx, angle) {
            var itemModel = data.getItemModel(idx);
            var pointerModel = itemModel.getModel('pointer');
            var pointerWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(pointerModel.get('width'), posInfo.r);
            var pointerLength = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(pointerModel.get('length'), posInfo.r);
            var pointerStr = seriesModel.get([
                'pointer',
                'icon'
            ]);
            var pointerOffset = pointerModel.get('offsetCenter');
            var pointerOffsetX = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(pointerOffset[0], posInfo.r);
            var pointerOffsetY = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(pointerOffset[1], posInfo.r);
            var pointerKeepAspect = pointerModel.get('keepAspect');
            var pointer;
            // not exist icon type will be set 'rect'
            if (pointerStr) pointer = (0, $da6220012439db7b$export$af050e04da3a02e8)(pointerStr, pointerOffsetX - pointerWidth / 2, pointerOffsetY - pointerLength, pointerWidth, pointerLength, null, pointerKeepAspect);
            else pointer = new (0, $e7c68e51f6da6d37$export$2e2bcd8739ae039)({
                shape: {
                    angle: -Math.PI / 2,
                    width: pointerWidth,
                    r: pointerLength,
                    x: pointerOffsetX,
                    y: pointerOffsetY
                }
            });
            pointer.rotation = -(angle + Math.PI / 2);
            pointer.x = posInfo.cx;
            pointer.y = posInfo.cy;
            return pointer;
        }
        function createProgress(idx, endAngle) {
            var roundCap = progressModel.get('roundCap');
            var ProgressPath = roundCap ? (0, $ff7cc14bc4a8408f$export$2e2bcd8739ae039) : $5fa26352e0605e60$export$2e2bcd8739ae039;
            var isOverlap = progressModel.get('overlap');
            var progressWidth = isOverlap ? progressModel.get('width') : axisLineWidth / data.count();
            var r0 = isOverlap ? posInfo.r - progressWidth : posInfo.r - (idx + 1) * progressWidth;
            var r = isOverlap ? posInfo.r : posInfo.r - idx * progressWidth;
            var progress = new ProgressPath({
                shape: {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    cx: posInfo.cx,
                    cy: posInfo.cy,
                    clockwise: clockwise,
                    r0: r0,
                    r: r
                }
            });
            isOverlap && (progress.z2 = (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(data.get(valueDim, idx), [
                minVal,
                maxVal
            ], [
                100,
                0
            ], true));
            return progress;
        }
        if (showProgress || showPointer) {
            data.diff(oldData).add(function(idx) {
                var val = data.get(valueDim, idx);
                if (showPointer) {
                    var pointer = createPointer(idx, startAngle);
                    // TODO hide pointer on NaN value?
                    $b40111164617dd60$export$a121566aadcfe021(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(idx, pointer);
                }
                if (showProgress) {
                    var progress = createProgress(idx, startAngle);
                    var isClip = progressModel.get('clip');
                    $b40111164617dd60$export$a121566aadcfe021(progress, {
                        shape: {
                            endAngle: (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $ea063383a2a89e3f$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, idx, progress);
                    progressList[idx] = progress;
                }
            }).update(function(newIdx, oldIdx) {
                var val = data.get(valueDim, newIdx);
                if (showPointer) {
                    var previousPointer = oldData.getItemGraphicEl(oldIdx);
                    var previousRotate = previousPointer ? previousPointer.rotation : startAngle;
                    var pointer = createPointer(newIdx, previousRotate);
                    pointer.rotation = previousRotate;
                    $b40111164617dd60$export$c8dce3c08436e91e(pointer, {
                        rotation: -((isNaN(+val) ? angleExtent[0] : (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(val, valueExtent, angleExtent, true)) + Math.PI / 2)
                    }, seriesModel);
                    group.add(pointer);
                    data.setItemGraphicEl(newIdx, pointer);
                }
                if (showProgress) {
                    var previousProgress = oldProgressData[oldIdx];
                    var previousEndAngle = previousProgress ? previousProgress.shape.endAngle : startAngle;
                    var progress = createProgress(newIdx, previousEndAngle);
                    var isClip = progressModel.get('clip');
                    $b40111164617dd60$export$c8dce3c08436e91e(progress, {
                        shape: {
                            endAngle: (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(val, valueExtent, angleExtent, isClip)
                        }
                    }, seriesModel);
                    group.add(progress);
                    // Add data index and series index for indexing the data by element
                    // Useful in tooltip
                    (0, $ea063383a2a89e3f$export$30d6736ebb8e18d5)(seriesModel.seriesIndex, data.dataType, newIdx, progress);
                    progressList[newIdx] = progress;
                }
            }).execute();
            data.each(function(idx) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel = itemModel.getModel('emphasis');
                var focus = emphasisModel.get('focus');
                var blurScope = emphasisModel.get('blurScope');
                var emphasisDisabled = emphasisModel.get('disabled');
                if (showPointer) {
                    var pointer = data.getItemGraphicEl(idx);
                    var symbolStyle = data.getItemVisual(idx, 'style');
                    var visualColor = symbolStyle.fill;
                    if (pointer instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) {
                        var pathStyle = pointer.style;
                        pointer.useStyle((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
                            image: pathStyle.image,
                            x: pathStyle.x,
                            y: pathStyle.y,
                            width: pathStyle.width,
                            height: pathStyle.height
                        }, symbolStyle));
                    } else {
                        pointer.useStyle(symbolStyle);
                        pointer.type !== 'pointer' && pointer.setColor(visualColor);
                    }
                    pointer.setStyle(itemModel.getModel([
                        'pointer',
                        'itemStyle'
                    ]).getItemStyle());
                    if (pointer.style.fill === 'auto') pointer.setStyle('fill', getColor((0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(data.get(valueDim, idx), valueExtent, [
                        0,
                        1
                    ], true)));
                    pointer.z2EmphasisLift = 0;
                    (0, $b414df7d361a211c$export$48b68047d330bbc9)(pointer, itemModel);
                    (0, $b414df7d361a211c$export$e51187539ff11209)(pointer, focus, blurScope, emphasisDisabled);
                }
                if (showProgress) {
                    var progress = progressList[idx];
                    progress.useStyle(data.getItemVisual(idx, 'style'));
                    progress.setStyle(itemModel.getModel([
                        'progress',
                        'itemStyle'
                    ]).getItemStyle());
                    progress.z2EmphasisLift = 0;
                    (0, $b414df7d361a211c$export$48b68047d330bbc9)(progress, itemModel);
                    (0, $b414df7d361a211c$export$e51187539ff11209)(progress, focus, blurScope, emphasisDisabled);
                }
            });
            this._progressEls = progressList;
        }
    };
    GaugeView.prototype._renderAnchor = function(seriesModel, posInfo) {
        var anchorModel = seriesModel.getModel('anchor');
        var showAnchor = anchorModel.get('show');
        if (showAnchor) {
            var anchorSize = anchorModel.get('size');
            var anchorType = anchorModel.get('icon');
            var offsetCenter = anchorModel.get('offsetCenter');
            var anchorKeepAspect = anchorModel.get('keepAspect');
            var anchor = (0, $da6220012439db7b$export$af050e04da3a02e8)(anchorType, posInfo.cx - anchorSize / 2 + (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(offsetCenter[0], posInfo.r), posInfo.cy - anchorSize / 2 + (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(offsetCenter[1], posInfo.r), anchorSize, anchorSize, null, anchorKeepAspect);
            anchor.z2 = anchorModel.get('showAbove') ? 1 : 0;
            anchor.setStyle(anchorModel.getModel('itemStyle').getItemStyle());
            this.group.add(anchor);
        }
    };
    GaugeView.prototype._renderTitleAndDetail = function(seriesModel, ecModel, api, getColor, posInfo) {
        var _this = this;
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var minVal = +seriesModel.get('min');
        var maxVal = +seriesModel.get('max');
        var contentGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        var newTitleEls = [];
        var newDetailEls = [];
        var hasAnimation = seriesModel.isAnimationEnabled();
        var showPointerAbove = seriesModel.get([
            'pointer',
            'showAbove'
        ]);
        data.diff(this._data).add(function(idx) {
            newTitleEls[idx] = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                silent: true
            });
            newDetailEls[idx] = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                silent: true
            });
        }).update(function(idx, oldIdx) {
            newTitleEls[idx] = _this._titleEls[oldIdx];
            newDetailEls[idx] = _this._detailEls[oldIdx];
        }).execute();
        data.each(function(idx) {
            var itemModel = data.getItemModel(idx);
            var value = data.get(valueDim, idx);
            var itemGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
            var autoColor = getColor((0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(value, [
                minVal,
                maxVal
            ], [
                0,
                1
            ], true));
            var itemTitleModel = itemModel.getModel('title');
            if (itemTitleModel.get('show')) {
                var titleOffsetCenter = itemTitleModel.get('offsetCenter');
                var titleX = posInfo.cx + (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(titleOffsetCenter[0], posInfo.r);
                var titleY = posInfo.cy + (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(titleOffsetCenter[1], posInfo.r);
                var labelEl = newTitleEls[idx];
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(itemTitleModel, {
                        x: titleX,
                        y: titleY,
                        text: data.getName(idx),
                        align: 'center',
                        verticalAlign: 'middle'
                    }, {
                        inheritColor: autoColor
                    })
                });
                itemGroup.add(labelEl);
            }
            var itemDetailModel = itemModel.getModel('detail');
            if (itemDetailModel.get('show')) {
                var detailOffsetCenter = itemDetailModel.get('offsetCenter');
                var detailX = posInfo.cx + (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(detailOffsetCenter[0], posInfo.r);
                var detailY = posInfo.cy + (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(detailOffsetCenter[1], posInfo.r);
                var width = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(itemDetailModel.get('width'), posInfo.r);
                var height = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(itemDetailModel.get('height'), posInfo.r);
                var detailColor = seriesModel.get([
                    'progress',
                    'show'
                ]) ? data.getItemVisual(idx, 'style').fill : autoColor;
                var labelEl = newDetailEls[idx];
                var formatter_1 = itemDetailModel.get('formatter');
                labelEl.attr({
                    z2: showPointerAbove ? 0 : 2,
                    style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(itemDetailModel, {
                        x: detailX,
                        y: detailY,
                        text: $9e4ce2696c2378ec$var$formatLabel(value, formatter_1),
                        width: isNaN(width) ? null : width,
                        height: isNaN(height) ? null : height,
                        align: 'center',
                        verticalAlign: 'middle'
                    }, {
                        inheritColor: detailColor
                    })
                });
                (0, $3828198b2f2de836$export$7bdbceaf9ab378f2)(labelEl, {
                    normal: itemDetailModel
                }, value, function(value) {
                    return $9e4ce2696c2378ec$var$formatLabel(value, formatter_1);
                });
                hasAnimation && (0, $3828198b2f2de836$export$dd6101605f5c186)(labelEl, idx, data, seriesModel, {
                    getFormattedLabel: function(labelDataIndex, status, dataType, labelDimIndex, fmt, extendParams) {
                        return $9e4ce2696c2378ec$var$formatLabel(extendParams ? extendParams.interpolatedValue : value, formatter_1);
                    }
                });
                itemGroup.add(labelEl);
            }
            contentGroup.add(itemGroup);
        });
        this.group.add(contentGroup);
        this._titleEls = newTitleEls;
        this._detailEls = newDetailEls;
    };
    GaugeView.type = 'gauge';
    return GaugeView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $9e4ce2696c2378ec$export$2e2bcd8739ae039 = $9e4ce2696c2378ec$var$GaugeView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $10e46a45083ff1df$var$GaugeSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GaugeSeriesModel, _super);
    function GaugeSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GaugeSeriesModel.type;
        _this.visualStyleAccessPath = 'itemStyle';
        return _this;
    }
    GaugeSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $4433247721525340$export$2e2bcd8739ae039)(this, [
            'value'
        ]);
    };
    GaugeSeriesModel.type = 'series.gauge';
    GaugeSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        legendHoverLink: true,
        radius: '75%',
        startAngle: 225,
        endAngle: -45,
        clockwise: true,
        // 最小值
        min: 0,
        // 最大值
        max: 100,
        // 分割段数，默认为10
        splitNumber: 10,
        // 坐标轴线
        axisLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            roundCap: false,
            lineStyle: {
                color: [
                    [
                        1,
                        '#E6EBF8'
                    ]
                ],
                width: 10
            }
        },
        // 坐标轴线
        progress: {
            // 默认显示，属性show控制显示与否
            show: false,
            overlap: true,
            width: 10,
            roundCap: false,
            clip: true
        },
        // 分隔线
        splitLine: {
            // 默认显示，属性show控制显示与否
            show: true,
            // 属性length控制线长
            length: 10,
            distance: 10,
            // 属性lineStyle（详见lineStyle）控制线条样式
            lineStyle: {
                color: '#63677A',
                width: 3,
                type: 'solid'
            }
        },
        // 坐标轴小标记
        axisTick: {
            // 属性show控制显示与否，默认不显示
            show: true,
            // 每份split细分多少段
            splitNumber: 5,
            // 属性length控制线长
            length: 6,
            distance: 10,
            // 属性lineStyle控制线条样式
            lineStyle: {
                color: '#63677A',
                width: 1,
                type: 'solid'
            }
        },
        axisLabel: {
            show: true,
            distance: 15,
            // formatter: null,
            color: '#464646',
            fontSize: 12,
            rotate: 0
        },
        pointer: {
            icon: null,
            offsetCenter: [
                0,
                0
            ],
            show: true,
            showAbove: true,
            length: '60%',
            width: 6,
            keepAspect: false
        },
        anchor: {
            show: false,
            showAbove: false,
            size: 6,
            icon: 'circle',
            offsetCenter: [
                0,
                0
            ],
            keepAspect: false,
            itemStyle: {
                color: '#fff',
                borderWidth: 0,
                borderColor: '#5470c6'
            }
        },
        title: {
            show: true,
            // x, y，单位px
            offsetCenter: [
                0,
                '20%'
            ],
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: '#464646',
            fontSize: 16,
            valueAnimation: false
        },
        detail: {
            show: true,
            backgroundColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            borderColor: '#ccc',
            width: 100,
            height: null,
            padding: [
                5,
                10
            ],
            // x, y，单位px
            offsetCenter: [
                0,
                '40%'
            ],
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: '#464646',
            fontSize: 30,
            fontWeight: 'bold',
            lineHeight: 30,
            valueAnimation: false
        }
    };
    return GaugeSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $10e46a45083ff1df$export$2e2bcd8739ae039 = $10e46a45083ff1df$var$GaugeSeriesModel;


function $df0f48503277acc3$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $9e4ce2696c2378ec$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $10e46a45083ff1df$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $2559594dc16a1583$var$opacityAccessPath = [
    'itemStyle',
    'opacity'
];
/**
 * Piece of pie including Sector, Label, LabelLine
 */ var $2559594dc16a1583$var$FunnelPiece = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(FunnelPiece, _super);
    function FunnelPiece(data, idx) {
        var _this = _super.call(this) || this;
        var polygon = _this;
        var labelLine = new $f7f6523750aec7c8$export$2e2bcd8739ae039();
        var text = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039();
        polygon.setTextContent(text);
        _this.setTextGuideLine(labelLine);
        _this.updateData(data, idx, true);
        return _this;
    }
    FunnelPiece.prototype.updateData = function(data, idx, firstCreate) {
        var polygon = this;
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var emphasisModel = itemModel.getModel('emphasis');
        var opacity = itemModel.get($2559594dc16a1583$var$opacityAccessPath);
        opacity = opacity == null ? 1 : opacity;
        if (!firstCreate) (0, $b40111164617dd60$export$bca7290a9faf0ec9)(polygon);
        // Update common style
        polygon.useStyle(data.getItemVisual(idx, 'style'));
        polygon.style.lineJoin = 'round';
        if (firstCreate) {
            polygon.setShape({
                points: layout.points
            });
            polygon.style.opacity = 0;
            $b40111164617dd60$export$a121566aadcfe021(polygon, {
                style: {
                    opacity: opacity
                }
            }, seriesModel, idx);
        } else $b40111164617dd60$export$c8dce3c08436e91e(polygon, {
            style: {
                opacity: opacity
            },
            shape: {
                points: layout.points
            }
        }, seriesModel, idx);
        (0, $b414df7d361a211c$export$48b68047d330bbc9)(polygon, itemModel);
        this._updateLabel(data, idx);
        (0, $b414df7d361a211c$export$e51187539ff11209)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    FunnelPiece.prototype._updateLabel = function(data, idx) {
        var polygon = this;
        var labelLine = this.getTextGuideLine();
        var labelText = polygon.getTextContent();
        var seriesModel = data.hostModel;
        var itemModel = data.getItemModel(idx);
        var layout = data.getItemLayout(idx);
        var labelLayout = layout.label;
        var style = data.getItemVisual(idx, 'style');
        var visualColor = style.fill;
        (0, $3828198b2f2de836$export$9a13992917966657)(// position will not be used in setLabelStyle
        labelText, (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel), {
            labelFetcher: data.hostModel,
            labelDataIndex: idx,
            defaultOpacity: style.opacity,
            defaultText: data.getName(idx)
        }, {
            normal: {
                align: labelLayout.textAlign,
                verticalAlign: labelLayout.verticalAlign
            }
        });
        polygon.setTextConfig({
            local: true,
            inside: !!labelLayout.inside,
            insideStroke: visualColor,
            // insideFill: 'auto',
            outsideFill: visualColor
        });
        var linePoints = labelLayout.linePoints;
        labelLine.setShape({
            points: linePoints
        });
        polygon.textGuideLineConfig = {
            anchor: linePoints ? new $1a833abf0e5915e2$export$2e2bcd8739ae039(linePoints[0][0], linePoints[0][1]) : null
        };
        // Make sure update style on labelText after setLabelStyle.
        // Because setLabelStyle will replace a new style on it.
        $b40111164617dd60$export$c8dce3c08436e91e(labelText, {
            style: {
                x: labelLayout.x,
                y: labelLayout.y
            }
        }, seriesModel, idx);
        labelText.attr({
            rotation: labelLayout.rotation,
            originX: labelLayout.x,
            originY: labelLayout.y,
            z2: 10
        });
        (0, $8503bd2779bcc1a6$export$c09e0b0574bdd2dc)(polygon, (0, $8503bd2779bcc1a6$export$2979fdbf5ebce521)(itemModel), {
            // Default use item visual color
            stroke: visualColor
        });
    };
    return FunnelPiece;
}($399011f87accd5da$export$2e2bcd8739ae039);
var $2559594dc16a1583$var$FunnelView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(FunnelView, _super);
    function FunnelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelView.type;
        _this.ignoreLabelLineUpdate = true;
        return _this;
    }
    FunnelView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        data.diff(oldData).add(function(idx) {
            var funnelPiece = new $2559594dc16a1583$var$FunnelPiece(data, idx);
            data.setItemGraphicEl(idx, funnelPiece);
            group.add(funnelPiece);
        }).update(function(newIdx, oldIdx) {
            var piece = oldData.getItemGraphicEl(oldIdx);
            piece.updateData(data, newIdx);
            group.add(piece);
            data.setItemGraphicEl(newIdx, piece);
        }).remove(function(idx) {
            var piece = oldData.getItemGraphicEl(idx);
            $b40111164617dd60$export$6d0fd725cb4aee8a(piece, seriesModel, idx);
        }).execute();
        this._data = data;
    };
    FunnelView.prototype.remove = function() {
        this.group.removeAll();
        this._data = null;
    };
    FunnelView.prototype.dispose = function() {};
    FunnelView.type = 'funnel';
    return FunnelView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $2559594dc16a1583$export$2e2bcd8739ae039 = $2559594dc16a1583$var$FunnelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $41a175bdaad6fd75$var$FunnelSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(FunnelSeriesModel, _super);
    function FunnelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = FunnelSeriesModel.type;
        return _this;
    }
    FunnelSeriesModel.prototype.init = function(option) {
        _super.prototype.init.apply(this, arguments);
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $f7d155e85e188448$export$2e2bcd8739ae039)($1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getData, this), $1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getRawData, this));
        // Extend labelLine emphasis
        this._defaultLabelLine(option);
    };
    FunnelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $4433247721525340$export$2e2bcd8739ae039)(this, {
            coordDimensions: [
                'value'
            ],
            encodeDefaulter: $1b239fc9d3a2f8ae$export$c3095a23b368d1f2((0, $669a01b8661bdd13$export$60b8a57d1f2fed26), this)
        });
    };
    FunnelSeriesModel.prototype._defaultLabelLine = function(option) {
        // Extend labelLine emphasis
        (0, $9ac03c46e8b6e711$export$abdcc6a26372f94b)(option, 'labelLine', [
            'show'
        ]);
        var labelLineNormalOpt = option.labelLine;
        var labelLineEmphasisOpt = option.emphasis.labelLine;
        // Not show label line if `label.normal.show = false`
        labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
        labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
    };
    // Overwrite
    FunnelSeriesModel.prototype.getDataParams = function(dataIndex) {
        var data = this.getData();
        var params = _super.prototype.getDataParams.call(this, dataIndex);
        var valueDim = data.mapDimension('value');
        var sum = data.getSum(valueDim);
        // Percent is 0 if sum is 0
        params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
        params.$vars.push('percent');
        return params;
    };
    FunnelSeriesModel.type = 'series.funnel';
    FunnelSeriesModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 2,
        legendHoverLink: true,
        colorBy: 'data',
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        // 默认取数据最小最大值
        // min: 0,
        // max: 100,
        minSize: '0%',
        maxSize: '100%',
        sort: 'descending',
        orient: 'vertical',
        gap: 0,
        funnelAlign: 'center',
        label: {
            show: true,
            position: 'outer'
        },
        labelLine: {
            show: true,
            length: 20,
            lineStyle: {
                // color: 各异,
                width: 1
            }
        },
        itemStyle: {
            // color: 各异,
            borderColor: '#fff',
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true
            }
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    };
    return FunnelSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $41a175bdaad6fd75$export$2e2bcd8739ae039 = $41a175bdaad6fd75$var$FunnelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $74deca9f3bb8ad33$var$getViewRect(seriesModel, api) {
    return $501dc28f6c4d24ac$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $74deca9f3bb8ad33$var$getSortedIndices(data, sort) {
    var valueDim = data.mapDimension('value');
    var valueArr = data.mapArray(valueDim, function(val) {
        return val;
    });
    var indices = [];
    var isAscending = sort === 'ascending';
    for(var i = 0, len = data.count(); i < len; i++)indices[i] = i;
    // Add custom sortable function & none sortable opetion by "options.sort"
    if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(sort)) indices.sort(sort);
    else if (sort !== 'none') indices.sort(function(a, b) {
        return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
    });
    return indices;
}
function $74deca9f3bb8ad33$var$labelLayout(data) {
    var seriesModel = data.hostModel;
    var orient = seriesModel.get('orient');
    data.each(function(idx) {
        var itemModel = data.getItemModel(idx);
        var labelModel = itemModel.getModel('label');
        var labelPosition = labelModel.get('position');
        var labelLineModel = itemModel.getModel('labelLine');
        var layout = data.getItemLayout(idx);
        var points = layout.points;
        var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
        var textAlign;
        var textX;
        var textY;
        var linePoints;
        if (isLabelInside) {
            if (labelPosition === 'insideLeft') {
                textX = (points[0][0] + points[3][0]) / 2 + 5;
                textY = (points[0][1] + points[3][1]) / 2;
                textAlign = 'left';
            } else if (labelPosition === 'insideRight') {
                textX = (points[1][0] + points[2][0]) / 2 - 5;
                textY = (points[1][1] + points[2][1]) / 2;
                textAlign = 'right';
            } else {
                textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
                textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
                textAlign = 'center';
            }
            linePoints = [
                [
                    textX,
                    textY
                ],
                [
                    textX,
                    textY
                ]
            ];
        } else {
            var x1 = void 0;
            var y1 = void 0;
            var x2 = void 0;
            var y2 = void 0;
            var labelLineLen = labelLineModel.get('length');
            if (labelPosition === 'left') {
                // Left side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                x2 = x1 - labelLineLen;
                textX = x2 - 5;
                textAlign = 'right';
            } else if (labelPosition === 'right') {
                // Right side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                x2 = x1 + labelLineLen;
                textX = x2 + 5;
                textAlign = 'left';
            } else if (labelPosition === 'top') {
                // Top side
                x1 = (points[3][0] + points[0][0]) / 2;
                y1 = (points[3][1] + points[0][1]) / 2;
                y2 = y1 - labelLineLen;
                textY = y2 - 5;
                textAlign = 'center';
            } else if (labelPosition === 'bottom') {
                // Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                y2 = y1 + labelLineLen;
                textY = y2 + 5;
                textAlign = 'center';
            } else if (labelPosition === 'rightTop') {
                // RightTop side
                x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
                y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
                if (orient === 'horizontal') {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'top';
                }
            } else if (labelPosition === 'rightBottom') {
                // RightBottom side
                x1 = points[2][0];
                y1 = points[2][1];
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'bottom';
                }
            } else if (labelPosition === 'leftTop') {
                // LeftTop side
                x1 = points[0][0];
                y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
                if (orient === 'horizontal') {
                    y2 = y1 - labelLineLen;
                    textY = y2 - 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = 'right';
                }
            } else if (labelPosition === 'leftBottom') {
                // LeftBottom side
                x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
                y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 - labelLineLen;
                    textX = x2 - 5;
                    textAlign = 'right';
                }
            } else {
                // Right side or Bottom side
                x1 = (points[1][0] + points[2][0]) / 2;
                y1 = (points[1][1] + points[2][1]) / 2;
                if (orient === 'horizontal') {
                    y2 = y1 + labelLineLen;
                    textY = y2 + 5;
                    textAlign = 'center';
                } else {
                    x2 = x1 + labelLineLen;
                    textX = x2 + 5;
                    textAlign = 'left';
                }
            }
            if (orient === 'horizontal') {
                x2 = x1;
                textX = x2;
            } else {
                y2 = y1;
                textY = y2;
            }
            linePoints = [
                [
                    x1,
                    y1
                ],
                [
                    x2,
                    y2
                ]
            ];
        }
        layout.label = {
            linePoints: linePoints,
            x: textX,
            y: textY,
            verticalAlign: 'middle',
            textAlign: textAlign,
            inside: isLabelInside
        };
    });
}
function $74deca9f3bb8ad33$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('funnel', function(seriesModel) {
        var data = seriesModel.getData();
        var valueDim = data.mapDimension('value');
        var sort = seriesModel.get('sort');
        var viewRect = $74deca9f3bb8ad33$var$getViewRect(seriesModel, api);
        var orient = seriesModel.get('orient');
        var viewWidth = viewRect.width;
        var viewHeight = viewRect.height;
        var indices = $74deca9f3bb8ad33$var$getSortedIndices(data, sort);
        var x = viewRect.x;
        var y = viewRect.y;
        var sizeExtent = orient === 'horizontal' ? [
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('minSize'), viewHeight),
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('maxSize'), viewHeight)
        ] : [
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('minSize'), viewWidth),
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('maxSize'), viewWidth)
        ];
        var dataExtent = data.getDataExtent(valueDim);
        var min = seriesModel.get('min');
        var max = seriesModel.get('max');
        if (min == null) min = Math.min(dataExtent[0], 0);
        if (max == null) max = dataExtent[1];
        var funnelAlign = seriesModel.get('funnelAlign');
        var gap = seriesModel.get('gap');
        var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
        var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
        var getLinePoints = function(idx, offset) {
            // End point index is data.count() and we assign it 0
            if (orient === 'horizontal') {
                var val_1 = data.get(valueDim, idx) || 0;
                var itemHeight = (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(val_1, [
                    min,
                    max
                ], sizeExtent, true);
                var y0 = void 0;
                switch(funnelAlign){
                    case 'top':
                        y0 = y;
                        break;
                    case 'center':
                        y0 = y + (viewHeight - itemHeight) / 2;
                        break;
                    case 'bottom':
                        y0 = y + (viewHeight - itemHeight);
                        break;
                }
                return [
                    [
                        offset,
                        y0
                    ],
                    [
                        offset,
                        y0 + itemHeight
                    ]
                ];
            }
            var val = data.get(valueDim, idx) || 0;
            var itemWidth = (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(val, [
                min,
                max
            ], sizeExtent, true);
            var x0;
            switch(funnelAlign){
                case 'left':
                    x0 = x;
                    break;
                case 'center':
                    x0 = x + (viewWidth - itemWidth) / 2;
                    break;
                case 'right':
                    x0 = x + viewWidth - itemWidth;
                    break;
            }
            return [
                [
                    x0,
                    offset
                ],
                [
                    x0 + itemWidth,
                    offset
                ]
            ];
        };
        if (sort === 'ascending') {
            // From bottom to top
            itemSize = -itemSize;
            gap = -gap;
            if (orient === 'horizontal') x += viewWidth;
            else y += viewHeight;
            indices = indices.reverse();
        }
        for(var i = 0; i < indices.length; i++){
            var idx = indices[i];
            var nextIdx = indices[i + 1];
            var itemModel = data.getItemModel(idx);
            if (orient === 'horizontal') {
                var width = itemModel.get([
                    'itemStyle',
                    'width'
                ]);
                if (width == null) width = itemSize;
                else {
                    width = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(width, viewWidth);
                    if (sort === 'ascending') width = -width;
                }
                var start = getLinePoints(idx, x);
                var end = getLinePoints(nextIdx, x + width);
                x += width + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            } else {
                var height = itemModel.get([
                    'itemStyle',
                    'height'
                ]);
                if (height == null) height = itemSize;
                else {
                    height = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(height, viewHeight);
                    if (sort === 'ascending') height = -height;
                }
                var start = getLinePoints(idx, y);
                var end = getLinePoints(nextIdx, y + height);
                y += height + gap;
                data.setItemLayout(idx, {
                    points: start.concat(end.slice().reverse())
                });
            }
        }
        $74deca9f3bb8ad33$var$labelLayout(data);
    });
}



function $874ce9d907064d71$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $2559594dc16a1583$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $41a175bdaad6fd75$export$2e2bcd8739ae039));
    registers.registerLayout((0, $74deca9f3bb8ad33$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $2f4b2083cfaef73d$export$2e2bcd8739ae039)('funnel'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $92e7d40b2165913d$var$DEFAULT_SMOOTH = 0.3;
var $92e7d40b2165913d$var$ParallelView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        _this._dataGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        _this._initialized = false;
        return _this;
    }
    ParallelView.prototype.init = function() {
        this.group.add(this._dataGroup);
    };
    /**
   * @override
   */ ParallelView.prototype.render = function(seriesModel, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var dataGroup = this._dataGroup;
        var data = seriesModel.getData();
        var oldData = this._data;
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $92e7d40b2165913d$var$makeSeriesScope(seriesModel);
        data.diff(oldData).add(add).update(update).remove(remove).execute();
        function add(newDataIndex) {
            var line = $92e7d40b2165913d$var$addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
            $92e7d40b2165913d$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function update(newDataIndex, oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            var points = $92e7d40b2165913d$var$createLinePoints(data, newDataIndex, dimensions, coordSys);
            data.setItemGraphicEl(newDataIndex, line);
            $b40111164617dd60$export$c8dce3c08436e91e(line, {
                shape: {
                    points: points
                }
            }, seriesModel, newDataIndex);
            (0, $b40111164617dd60$export$bca7290a9faf0ec9)(line);
            $92e7d40b2165913d$var$updateElCommon(line, data, newDataIndex, seriesScope);
        }
        function remove(oldDataIndex) {
            var line = oldData.getItemGraphicEl(oldDataIndex);
            dataGroup.remove(line);
        }
        // First create
        if (!this._initialized) {
            this._initialized = true;
            var clipPath = $92e7d40b2165913d$var$createGridClipShape(coordSys, seriesModel, function() {
                // Callback will be invoked immediately if there is no animation
                setTimeout(function() {
                    dataGroup.removeClipPath();
                });
            });
            dataGroup.setClipPath(clipPath);
        }
        this._data = data;
    };
    ParallelView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._initialized = true;
        this._data = null;
        this._dataGroup.removeAll();
    };
    ParallelView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        var data = seriesModel.getData();
        var coordSys = seriesModel.coordinateSystem;
        var dimensions = coordSys.dimensions;
        var seriesScope = $92e7d40b2165913d$var$makeSeriesScope(seriesModel);
        var progressiveEls = this._progressiveEls = [];
        for(var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++){
            var line = $92e7d40b2165913d$var$addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
            line.incremental = true;
            $92e7d40b2165913d$var$updateElCommon(line, data, dataIndex, seriesScope);
            progressiveEls.push(line);
        }
    };
    ParallelView.prototype.remove = function() {
        this._dataGroup && this._dataGroup.removeAll();
        this._data = null;
    };
    ParallelView.type = 'parallel';
    return ParallelView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
function $92e7d40b2165913d$var$createGridClipShape(coordSys, seriesModel, cb) {
    var parallelModel = coordSys.model;
    var rect = coordSys.getRect();
    var rectEl = new $37476269d425e3f6$export$2e2bcd8739ae039({
        shape: {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        }
    });
    var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
    rectEl.setShape(dim, 0);
    $b40111164617dd60$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width,
            height: rect.height
        }
    }, seriesModel, cb);
    return rectEl;
}
function $92e7d40b2165913d$var$createLinePoints(data, dataIndex, dimensions, coordSys) {
    var points = [];
    for(var i = 0; i < dimensions.length; i++){
        var dimName = dimensions[i];
        var value = data.get(data.mapDimension(dimName), dataIndex);
        if (!$92e7d40b2165913d$var$isEmptyValue(value, coordSys.getAxis(dimName).type)) points.push(coordSys.dataToPoint(value, dimName));
    }
    return points;
}
function $92e7d40b2165913d$var$addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
    var points = $92e7d40b2165913d$var$createLinePoints(data, dataIndex, dimensions, coordSys);
    var line = new $f7f6523750aec7c8$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        // silent: true,
        z2: 10
    });
    dataGroup.add(line);
    data.setItemGraphicEl(dataIndex, line);
    return line;
}
function $92e7d40b2165913d$var$makeSeriesScope(seriesModel) {
    var smooth = seriesModel.get('smooth', true);
    smooth === true && (smooth = $92e7d40b2165913d$var$DEFAULT_SMOOTH);
    smooth = (0, $9fd90cf3bf18fbcd$export$8b4007b942b45a96)(smooth);
    (0, $1b239fc9d3a2f8ae$export$7d667b9a0c48c975)(smooth) && (smooth = 0);
    return {
        smooth: smooth
    };
}
function $92e7d40b2165913d$var$updateElCommon(el, data, dataIndex, seriesScope) {
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.fill = null;
    el.setShape('smooth', seriesScope.smooth);
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $b414df7d361a211c$export$48b68047d330bbc9)(el, itemModel, 'lineStyle');
    (0, $b414df7d361a211c$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
// function simpleDiff(oldData, newData, dimensions) {
//     let oldLen;
//     if (!oldData
//         || !oldData.__plProgressive
//         || (oldLen = oldData.count()) !== newData.count()
//     ) {
//         return true;
//     }
//     let dimLen = dimensions.length;
//     for (let i = 0; i < oldLen; i++) {
//         for (let j = 0; j < dimLen; j++) {
//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
//                 return true;
//             }
//         }
//     }
//     return false;
// }
// FIXME put in common util?
function $92e7d40b2165913d$var$isEmptyValue(val, axisType) {
    return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
}
var $92e7d40b2165913d$export$2e2bcd8739ae039 = $92e7d40b2165913d$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $3b3ad254e85dc8ea$var$ParallelSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ParallelSeriesModel, _super);
    function ParallelSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelSeriesModel.type;
        _this.visualStyleAccessPath = 'lineStyle';
        _this.visualDrawType = 'stroke';
        return _this;
    }
    ParallelSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($3b3ad254e85dc8ea$var$makeDefaultEncode, null, this)
        });
    };
    /**
   * User can get data raw indices on 'axisAreaSelected' event received.
   *
   * @return Raw indices
   */ ParallelSeriesModel.prototype.getRawIndicesByActiveState = function(activeState) {
        var coordSys = this.coordinateSystem;
        var data = this.getData();
        var indices = [];
        coordSys.eachActiveState(data, function(theActiveState, dataIndex) {
            if (activeState === theActiveState) indices.push(data.getRawIndex(dataIndex));
        });
        return indices;
    };
    ParallelSeriesModel.type = 'series.parallel';
    ParallelSeriesModel.dependencies = [
        'parallel'
    ];
    ParallelSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'parallel',
        parallelIndex: 0,
        label: {
            show: false
        },
        inactiveOpacity: 0.05,
        activeOpacity: 1,
        lineStyle: {
            width: 1,
            opacity: 0.45,
            type: 'solid'
        },
        emphasis: {
            label: {
                show: false
            }
        },
        progressive: 500,
        smooth: false,
        animationEasing: 'linear'
    };
    return ParallelSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
function $3b3ad254e85dc8ea$var$makeDefaultEncode(seriesModel) {
    // The mapping of parallelAxis dimension to data dimension can
    // be specified in parallelAxis.option.dim. For example, if
    // parallelAxis.option.dim is 'dim3', it mapping to the third
    // dimension of data. But `data.encode` has higher priority.
    // Moreover, parallelModel.dimension should not be regarded as data
    // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
    var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
    if (!parallelModel) return;
    var encodeDefine = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(parallelModel.dimensions, function(axisDim) {
        var dataDimIndex = $3b3ad254e85dc8ea$var$convertDimNameToNumber(axisDim);
        encodeDefine[axisDim] = dataDimIndex;
    });
    return encodeDefine;
}
function $3b3ad254e85dc8ea$var$convertDimNameToNumber(dimName) {
    return +dimName.replace('dim', '');
}
var $3b3ad254e85dc8ea$export$2e2bcd8739ae039 = $3b3ad254e85dc8ea$var$ParallelSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $0def90bbad63cc86$var$opacityAccessPath = [
    'lineStyle',
    'opacity'
];
var $0def90bbad63cc86$var$parallelVisual = {
    seriesType: 'parallel',
    reset: function(seriesModel, ecModel) {
        var coordSys = seriesModel.coordinateSystem;
        var opacityMap = {
            normal: seriesModel.get([
                'lineStyle',
                'opacity'
            ]),
            active: seriesModel.get('activeOpacity'),
            inactive: seriesModel.get('inactiveOpacity')
        };
        return {
            progress: function(params, data) {
                coordSys.eachActiveState(data, function(activeState, dataIndex) {
                    var opacity = opacityMap[activeState];
                    if (activeState === 'normal' && data.hasItemOption) {
                        var itemOpacity = data.getItemModel(dataIndex).get($0def90bbad63cc86$var$opacityAccessPath, true);
                        itemOpacity != null && (opacity = itemOpacity);
                    }
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
                    existsStyle.opacity = opacity;
                }, params.start, params.end);
            }
        };
    }
};
var $0def90bbad63cc86$export$2e2bcd8739ae039 = $0def90bbad63cc86$var$parallelVisual;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $41688c9d4bad6892$export$2e2bcd8739ae039(option) {
    $41688c9d4bad6892$var$createParallelIfNeeded(option);
    $41688c9d4bad6892$var$mergeAxisOptionFromParallel(option);
}
/**
 * Create a parallel coordinate if not exists.
 * @inner
 */ function $41688c9d4bad6892$var$createParallelIfNeeded(option) {
    if (option.parallel) return;
    var hasParallelSeries = false;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(option.series, function(seriesOpt) {
        if (seriesOpt && seriesOpt.type === 'parallel') hasParallelSeries = true;
    });
    if (hasParallelSeries) option.parallel = [
        {}
    ];
}
/**
 * Merge aixs definition from parallel option (if exists) to axis option.
 * @inner
 */ function $41688c9d4bad6892$var$mergeAxisOptionFromParallel(option) {
    var axes = $9ac03c46e8b6e711$export$4f07b212a02c8051(option.parallelAxis);
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(axes, function(axisOption) {
        if (!$1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(axisOption)) return;
        var parallelIndex = axisOption.parallelIndex || 0;
        var parallelOption = $9ac03c46e8b6e711$export$4f07b212a02c8051(option.parallel)[parallelIndex];
        if (parallelOption && parallelOption.parallelAxisDefault) $1b239fc9d3a2f8ae$export$4950aa0f605343fb(axisOption, parallelOption.parallelAxisDefault, false);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $6e8d56132909b23d$var$CLICK_THRESHOLD = 5; // > 4
var $6e8d56132909b23d$var$ParallelView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ParallelView, _super);
    function ParallelView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelView.type;
        return _this;
    }
    ParallelView.prototype.render = function(parallelModel, ecModel, api) {
        this._model = parallelModel;
        this._api = api;
        if (!this._handlers) {
            this._handlers = {};
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($6e8d56132909b23d$var$handlers, function(handler, eventName) {
                api.getZr().on(eventName, this._handlers[eventName] = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(handler, this));
            }, this);
        }
        (0, $ef22ba67fe7cfc59$export$958e3e1a02eac4b6)(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
    };
    ParallelView.prototype.dispose = function(ecModel, api) {
        (0, $ef22ba67fe7cfc59$export$42ffd38884aecdac)(this, '_throttledDispatchExpand');
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            api.getZr().off(eventName, handler);
        });
        this._handlers = null;
    };
    /**
   * @internal
   * @param {Object} [opt] If null, cancel the last action triggering for debounce.
   */ ParallelView.prototype._throttledDispatchExpand = function(opt) {
        this._dispatchExpand(opt);
    };
    /**
   * @internal
   */ ParallelView.prototype._dispatchExpand = function(opt) {
        opt && this._api.dispatchAction((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
            type: 'parallelAxisExpand'
        }, opt));
    };
    ParallelView.type = 'parallel';
    return ParallelView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $6e8d56132909b23d$var$handlers = {
    mousedown: function(e) {
        if ($6e8d56132909b23d$var$checkTrigger(this, 'click')) this._mouseDownPoint = [
            e.offsetX,
            e.offsetY
        ];
    },
    mouseup: function(e) {
        var mouseDownPoint = this._mouseDownPoint;
        if ($6e8d56132909b23d$var$checkTrigger(this, 'click') && mouseDownPoint) {
            var point = [
                e.offsetX,
                e.offsetY
            ];
            var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
            if (dist > $6e8d56132909b23d$var$CLICK_THRESHOLD) return;
            var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([
                e.offsetX,
                e.offsetY
            ]);
            result.behavior !== 'none' && this._dispatchExpand({
                axisExpandWindow: result.axisExpandWindow
            });
        }
        this._mouseDownPoint = null;
    },
    mousemove: function(e) {
        // Should do nothing when brushing.
        if (this._mouseDownPoint || !$6e8d56132909b23d$var$checkTrigger(this, 'mousemove')) return;
        var model = this._model;
        var result = model.coordinateSystem.getSlidedAxisExpandWindow([
            e.offsetX,
            e.offsetY
        ]);
        var behavior = result.behavior;
        behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
        this._throttledDispatchExpand(behavior === 'none' ? null // Cancel the last trigger, in case that mouse slide out of the area quickly.
         : {
            axisExpandWindow: result.axisExpandWindow,
            // Jumping uses animation, and sliding suppresses animation.
            animation: behavior === 'jump' ? null : {
                duration: 0 // Disable animation.
            }
        });
    }
};
function $6e8d56132909b23d$var$checkTrigger(view, triggerOn) {
    var model = view._model;
    return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
}
var $6e8d56132909b23d$export$2e2bcd8739ae039 = $6e8d56132909b23d$var$ParallelView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $bc237362f726c38a$var$ParallelModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ParallelModel, _super);
    function ParallelModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelModel.type;
        return _this;
    }
    ParallelModel.prototype.init = function() {
        _super.prototype.init.apply(this, arguments);
        this.mergeOption({});
    };
    ParallelModel.prototype.mergeOption = function(newOption) {
        var thisOption = this.option;
        newOption && $1b239fc9d3a2f8ae$export$4950aa0f605343fb(thisOption, newOption, true);
        this._initDimensions();
    };
    /**
   * Whether series or axis is in this coordinate system.
   */ ParallelModel.prototype.contains = function(model, ecModel) {
        var parallelIndex = model.get('parallelIndex');
        return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
    };
    ParallelModel.prototype.setAxisExpand = function(opt) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
            'axisExpandable',
            'axisExpandCenter',
            'axisExpandCount',
            'axisExpandWidth',
            'axisExpandWindow'
        ], function(name) {
            if (opt.hasOwnProperty(name)) // @ts-ignore FIXME: why "never" inferred in this.option[name]?
            this.option[name] = opt[name];
        }, this);
    };
    ParallelModel.prototype._initDimensions = function() {
        var dimensions = this.dimensions = [];
        var parallelAxisIndex = this.parallelAxisIndex = [];
        var axisModels = $1b239fc9d3a2f8ae$export$3dea766d36a8935f(this.ecModel.queryComponents({
            mainType: 'parallelAxis'
        }), function(axisModel) {
            // Can not use this.contains here, because
            // initialization has not been completed yet.
            return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
        }, this);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(axisModels, function(axisModel) {
            dimensions.push('dim' + axisModel.get('dim'));
            parallelAxisIndex.push(axisModel.componentIndex);
        });
    };
    ParallelModel.type = 'parallel';
    ParallelModel.dependencies = [
        'parallelAxis'
    ];
    ParallelModel.layoutMode = 'box';
    ParallelModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        left: 80,
        top: 60,
        right: 80,
        bottom: 60,
        // width: {totalWidth} - left - right,
        // height: {totalHeight} - top - bottom,
        layout: 'horizontal',
        // FIXME
        // naming?
        axisExpandable: false,
        axisExpandCenter: null,
        axisExpandCount: 0,
        axisExpandWidth: 50,
        axisExpandRate: 17,
        axisExpandDebounce: 50,
        // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
        // Do not doc to user until necessary.
        axisExpandSlideTriggerArea: [
            -0.15,
            0.05,
            0.4
        ],
        axisExpandTriggerOn: 'click',
        parallelAxisDefault: null
    };
    return ParallelModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $bc237362f726c38a$export$2e2bcd8739ae039 = $bc237362f726c38a$var$ParallelModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel coordinate system creater.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Parallel Coordinates
 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
 */ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $6c55fb2a5b2a1688$var$ParallelAxis = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ParallelAxis, _super);
    function ParallelAxis(dim, scale, coordExtent, axisType, axisIndex) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        _this.axisIndex = axisIndex;
        return _this;
    }
    ParallelAxis.prototype.isHorizontal = function() {
        return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
    };
    return ParallelAxis;
}((0, $099c976b90502319$export$2e2bcd8739ae039));
var $6c55fb2a5b2a1688$export$2e2bcd8739ae039 = $6c55fb2a5b2a1688$var$ParallelAxis;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Calculate slider move result.
 * Usage:
 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
 *
 * @param delta Move length.
 * @param handleEnds handleEnds[0] can be bigger then handleEnds[1].
 *              handleEnds will be modified in this method.
 * @param extent handleEnds is restricted by extent.
 *              extent[0] should less or equals than extent[1].
 * @param handleIndex Can be 'all', means that both move the two handleEnds.
 * @param minSpan The range of dataZoom can not be smaller than that.
 *              If not set, handle0 and cross handle1. If set as a non-negative
 *              number (including `0`), handles will push each other when reaching
 *              the minSpan.
 * @param maxSpan The range of dataZoom can not be larger than that.
 * @return The input handleEnds.
 */ function $15a7158def1e4179$export$2e2bcd8739ae039(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
    delta = delta || 0;
    var extentSpan = extent[1] - extent[0];
    // Notice maxSpan and minSpan can be null/undefined.
    if (minSpan != null) minSpan = $15a7158def1e4179$var$restrict(minSpan, [
        0,
        extentSpan
    ]);
    if (maxSpan != null) maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
    if (handleIndex === 'all') {
        var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
        handleSpan = $15a7158def1e4179$var$restrict(handleSpan, [
            0,
            extentSpan
        ]);
        minSpan = maxSpan = $15a7158def1e4179$var$restrict(handleSpan, [
            minSpan,
            maxSpan
        ]);
        handleIndex = 0;
    }
    handleEnds[0] = $15a7158def1e4179$var$restrict(handleEnds[0], extent);
    handleEnds[1] = $15a7158def1e4179$var$restrict(handleEnds[1], extent);
    var originalDistSign = $15a7158def1e4179$var$getSpanSign(handleEnds, handleIndex);
    handleEnds[handleIndex] += delta;
    // Restrict in extent.
    var extentMinSpan = minSpan || 0;
    var realExtent = extent.slice();
    originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
    handleEnds[handleIndex] = $15a7158def1e4179$var$restrict(handleEnds[handleIndex], realExtent);
    // Expand span.
    var currDistSign;
    currDistSign = $15a7158def1e4179$var$getSpanSign(handleEnds, handleIndex);
    if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) // If minSpan exists, 'cross' is forbidden.
    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
    // Shrink span.
    currDistSign = $15a7158def1e4179$var$getSpanSign(handleEnds, handleIndex);
    if (maxSpan != null && currDistSign.span > maxSpan) handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
    return handleEnds;
}
function $15a7158def1e4179$var$getSpanSign(handleEnds, handleIndex) {
    var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex];
    // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
    // is at left of handleEnds[1] for non-cross case.
    return {
        span: Math.abs(dist),
        sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
    };
}
function $15a7158def1e4179$var$restrict(value, extend) {
    return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
}


var $2c9476ebac8b0b88$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $2c9476ebac8b0b88$var$mathMin = Math.min;
var $2c9476ebac8b0b88$var$mathMax = Math.max;
var $2c9476ebac8b0b88$var$mathFloor = Math.floor;
var $2c9476ebac8b0b88$var$mathCeil = Math.ceil;
var $2c9476ebac8b0b88$var$round = $9fd90cf3bf18fbcd$export$2077e0241d6afd3c;
var $2c9476ebac8b0b88$var$PI = Math.PI;
var $2c9476ebac8b0b88$var$Parallel = /** @class */ function() {
    function Parallel(parallelModel, ecModel, api) {
        this.type = 'parallel';
        /**
     * key: dimension
     */ this._axesMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        /**
     * key: dimension
     * value: {position: [], rotation, }
     */ this._axesLayout = {};
        this.dimensions = parallelModel.dimensions;
        this._model = parallelModel;
        this._init(parallelModel, ecModel, api);
    }
    Parallel.prototype._init = function(parallelModel, ecModel, api) {
        var dimensions = parallelModel.dimensions;
        var parallelAxisIndex = parallelModel.parallelAxisIndex;
        $2c9476ebac8b0b88$var$each(dimensions, function(dim, idx) {
            var axisIndex = parallelAxisIndex[idx];
            var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
            var axis = this._axesMap.set(dim, new (0, $6c55fb2a5b2a1688$export$2e2bcd8739ae039)(dim, $5435624263a719a6$export$8941c4cacdc8f5a5(axisModel), [
                0,
                0
            ], axisModel.get('type'), axisIndex));
            var isCategory = axis.type === 'category';
            axis.onBand = isCategory && axisModel.get('boundaryGap');
            axis.inverse = axisModel.get('inverse');
            // Injection
            axisModel.axis = axis;
            axis.model = axisModel;
            axis.coordinateSystem = axisModel.coordinateSystem = this;
        }, this);
    };
    /**
   * Update axis scale after data processed
   */ Parallel.prototype.update = function(ecModel, api) {
        this._updateAxesFromSeries(this._model, ecModel);
    };
    Parallel.prototype.containPoint = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var axisBase = layoutInfo.axisBase;
        var layoutBase = layoutInfo.layoutBase;
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var pAxis = point[1 - pixelDimIndex];
        var pLayout = point[pixelDimIndex];
        return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
    };
    Parallel.prototype.getModel = function() {
        return this._model;
    };
    /**
   * Update properties from series
   */ Parallel.prototype._updateAxesFromSeries = function(parallelModel, ecModel) {
        ecModel.eachSeries(function(seriesModel) {
            if (!parallelModel.contains(seriesModel, ecModel)) return;
            var data = seriesModel.getData();
            $2c9476ebac8b0b88$var$each(this.dimensions, function(dim) {
                var axis = this._axesMap.get(dim);
                axis.scale.unionExtentFromData(data, data.mapDimension(dim));
                $5435624263a719a6$export$51f3e70a54405d5a(axis.scale, axis.model);
            }, this);
        }, this);
    };
    /**
   * Resize the parallel coordinate system.
   */ Parallel.prototype.resize = function(parallelModel, api) {
        this._rect = $501dc28f6c4d24ac$export$4517a5ca639a7293(parallelModel.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._layoutAxes();
    };
    Parallel.prototype.getRect = function() {
        return this._rect;
    };
    Parallel.prototype._makeLayoutInfo = function() {
        var parallelModel = this._model;
        var rect = this._rect;
        var xy = [
            'x',
            'y'
        ];
        var wh = [
            'width',
            'height'
        ];
        var layout = parallelModel.get('layout');
        var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
        var layoutLength = rect[wh[pixelDimIndex]];
        var layoutExtent = [
            0,
            layoutLength
        ];
        var axisCount = this.dimensions.length;
        var axisExpandWidth = $2c9476ebac8b0b88$var$restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
        var axisExpandCount = $2c9476ebac8b0b88$var$restrict(parallelModel.get('axisExpandCount') || 0, [
            0,
            axisCount
        ]);
        var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0;
        // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
        // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
        // where collapsed axes should be overlapped.
        var axisExpandWindow = parallelModel.get('axisExpandWindow');
        var winSize;
        if (!axisExpandWindow) {
            winSize = $2c9476ebac8b0b88$var$restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
            var axisExpandCenter = parallelModel.get('axisExpandCenter') || $2c9476ebac8b0b88$var$mathFloor(axisCount / 2);
            axisExpandWindow = [
                axisExpandWidth * axisExpandCenter - winSize / 2
            ];
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        } else {
            winSize = $2c9476ebac8b0b88$var$restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
            axisExpandWindow[1] = axisExpandWindow[0] + winSize;
        }
        var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount);
        // Avoid axisCollapseWidth is too small.
        axisCollapseWidth < 3 && (axisCollapseWidth = 0);
        // Find the first and last indices > ewin[0] and < ewin[1].
        var winInnerIndices = [
            $2c9476ebac8b0b88$var$mathFloor($2c9476ebac8b0b88$var$round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1,
            $2c9476ebac8b0b88$var$mathCeil($2c9476ebac8b0b88$var$round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1
        ];
        // Pos in ec coordinates.
        var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
        return {
            layout: layout,
            pixelDimIndex: pixelDimIndex,
            layoutBase: rect[xy[pixelDimIndex]],
            layoutLength: layoutLength,
            axisBase: rect[xy[1 - pixelDimIndex]],
            axisLength: rect[wh[1 - pixelDimIndex]],
            axisExpandable: axisExpandable,
            axisExpandWidth: axisExpandWidth,
            axisCollapseWidth: axisCollapseWidth,
            axisExpandWindow: axisExpandWindow,
            axisCount: axisCount,
            winInnerIndices: winInnerIndices,
            axisExpandWindow0Pos: axisExpandWindow0Pos
        };
    };
    Parallel.prototype._layoutAxes = function() {
        var rect = this._rect;
        var axes = this._axesMap;
        var dimensions = this.dimensions;
        var layoutInfo = this._makeLayoutInfo();
        var layout = layoutInfo.layout;
        axes.each(function(axis) {
            var axisExtent = [
                0,
                layoutInfo.axisLength
            ];
            var idx = axis.inverse ? 1 : 0;
            axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
        });
        $2c9476ebac8b0b88$var$each(dimensions, function(dim, idx) {
            var posInfo = (layoutInfo.axisExpandable ? $2c9476ebac8b0b88$var$layoutAxisWithExpand : $2c9476ebac8b0b88$var$layoutAxisWithoutExpand)(idx, layoutInfo);
            var positionTable = {
                horizontal: {
                    x: posInfo.position,
                    y: layoutInfo.axisLength
                },
                vertical: {
                    x: 0,
                    y: posInfo.position
                }
            };
            var rotationTable = {
                horizontal: $2c9476ebac8b0b88$var$PI / 2,
                vertical: 0
            };
            var position = [
                positionTable[layout].x + rect.x,
                positionTable[layout].y + rect.y
            ];
            var rotation = rotationTable[layout];
            var transform = $78537c687449356c$export$185802fd694ee1f5();
            $78537c687449356c$export$bb628a54ab399bc9(transform, transform, rotation);
            $78537c687449356c$export$d73ee8ef04f5226a(transform, transform, position);
            // TODO
            // tick layout info
            // TODO
            // update dimensions info based on axis order.
            this._axesLayout[dim] = {
                position: position,
                rotation: rotation,
                transform: transform,
                axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
                axisLabelShow: posInfo.axisLabelShow,
                nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
                tickDirection: 1,
                labelDirection: 1
            };
        }, this);
    };
    /**
   * Get axis by dim.
   */ Parallel.prototype.getAxis = function(dim) {
        return this._axesMap.get(dim);
    };
    /**
   * Convert a dim value of a single item of series data to Point.
   */ Parallel.prototype.dataToPoint = function(value, dim) {
        return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
    };
    /**
   * Travel data for one time, get activeState of each data item.
   * @param start the start dataIndex that travel from.
   * @param end the next dataIndex of the last dataIndex will be travel.
   */ Parallel.prototype.eachActiveState = function(data, callback, start, end) {
        start == null && (start = 0);
        end == null && (end = data.count());
        var axesMap = this._axesMap;
        var dimensions = this.dimensions;
        var dataDimensions = [];
        var axisModels = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(dimensions, function(axisDim) {
            dataDimensions.push(data.mapDimension(axisDim));
            axisModels.push(axesMap.get(axisDim).model);
        });
        var hasActiveSet = this.hasAxisBrushed();
        for(var dataIndex = start; dataIndex < end; dataIndex++){
            var activeState = void 0;
            if (!hasActiveSet) activeState = 'normal';
            else {
                activeState = 'active';
                var values = data.getValues(dataDimensions, dataIndex);
                for(var j = 0, lenj = dimensions.length; j < lenj; j++){
                    var state = axisModels[j].getActiveState(values[j]);
                    if (state === 'inactive') {
                        activeState = 'inactive';
                        break;
                    }
                }
            }
            callback(activeState, dataIndex);
        }
    };
    /**
   * Whether has any activeSet.
   */ Parallel.prototype.hasAxisBrushed = function() {
        var dimensions = this.dimensions;
        var axesMap = this._axesMap;
        var hasActiveSet = false;
        for(var j = 0, lenj = dimensions.length; j < lenj; j++)if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') hasActiveSet = true;
        return hasActiveSet;
    };
    /**
   * Convert coords of each axis to Point.
   *  Return point. For example: [10, 20]
   */ Parallel.prototype.axisCoordToPoint = function(coord, dim) {
        var axisLayout = this._axesLayout[dim];
        return $8eb95236e1aa01e7$export$9f9dcb98c894b623([
            coord,
            0
        ], axisLayout.transform);
    };
    /**
   * Get axis layout.
   */ Parallel.prototype.getAxisLayout = function(dim) {
        return $1b239fc9d3a2f8ae$export$9cd59f9826255e47(this._axesLayout[dim]);
    };
    /**
   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
   */ Parallel.prototype.getSlidedAxisExpandWindow = function(point) {
        var layoutInfo = this._makeLayoutInfo();
        var pixelDimIndex = layoutInfo.pixelDimIndex;
        var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
        var extent = [
            0,
            layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)
        ];
        // Out of the area of coordinate system.
        if (!this.containPoint(point)) return {
            behavior: 'none',
            axisExpandWindow: axisExpandWindow
        };
        // Convert the point from global to expand coordinates.
        var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos;
        // For dragging operation convenience, the window should not be
        // slided when mouse is the center area of the window.
        var delta;
        var behavior = 'slide';
        var axisCollapseWidth = layoutInfo.axisCollapseWidth;
        var triggerArea = this._model.get('axisExpandSlideTriggerArea');
        // But consider touch device, jump is necessary.
        var useJump = triggerArea[0] != null;
        if (axisCollapseWidth) {
            if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
                behavior = 'jump';
                delta = pointCoord - winSize * triggerArea[2];
            } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
                behavior = 'jump';
                delta = pointCoord - winSize * (1 - triggerArea[2]);
            } else (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
            delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
            delta ? (0, $15a7158def1e4179$export$2e2bcd8739ae039)(delta, axisExpandWindow, extent, 'all') : behavior = 'none';
        } else {
            var winSize2 = axisExpandWindow[1] - axisExpandWindow[0];
            var pos = extent[1] * pointCoord / winSize2;
            axisExpandWindow = [
                $2c9476ebac8b0b88$var$mathMax(0, pos - winSize2 / 2)
            ];
            axisExpandWindow[1] = $2c9476ebac8b0b88$var$mathMin(extent[1], axisExpandWindow[0] + winSize2);
            axisExpandWindow[0] = axisExpandWindow[1] - winSize2;
        }
        return {
            axisExpandWindow: axisExpandWindow,
            behavior: behavior
        };
    };
    return Parallel;
}();
function $2c9476ebac8b0b88$var$restrict(len, extent) {
    return $2c9476ebac8b0b88$var$mathMin($2c9476ebac8b0b88$var$mathMax(len, extent[0]), extent[1]);
}
function $2c9476ebac8b0b88$var$layoutAxisWithoutExpand(axisIndex, layoutInfo) {
    var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
    return {
        position: step * axisIndex,
        axisNameAvailableWidth: step,
        axisLabelShow: true
    };
}
function $2c9476ebac8b0b88$var$layoutAxisWithExpand(axisIndex, layoutInfo) {
    var layoutLength = layoutInfo.layoutLength;
    var axisExpandWidth = layoutInfo.axisExpandWidth;
    var axisCount = layoutInfo.axisCount;
    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
    var winInnerIndices = layoutInfo.winInnerIndices;
    var position;
    var axisNameAvailableWidth = axisCollapseWidth;
    var axisLabelShow = false;
    var nameTruncateMaxWidth;
    if (axisIndex < winInnerIndices[0]) {
        position = axisIndex * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    } else if (axisIndex <= winInnerIndices[1]) {
        position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
        axisNameAvailableWidth = axisExpandWidth;
        axisLabelShow = true;
    } else {
        position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
        nameTruncateMaxWidth = axisCollapseWidth;
    }
    return {
        position: position,
        axisNameAvailableWidth: axisNameAvailableWidth,
        axisLabelShow: axisLabelShow,
        nameTruncateMaxWidth: nameTruncateMaxWidth
    };
}
var $2c9476ebac8b0b88$export$2e2bcd8739ae039 = $2c9476ebac8b0b88$var$Parallel;



function $f6f1517f8b4f9ba9$var$createParallelCoordSys(ecModel, api) {
    var coordSysList = [];
    ecModel.eachComponent('parallel', function(parallelModel, idx) {
        var coordSys = new (0, $2c9476ebac8b0b88$export$2e2bcd8739ae039)(parallelModel, ecModel, api);
        coordSys.name = 'parallel_' + idx;
        coordSys.resize(parallelModel, api);
        parallelModel.coordinateSystem = coordSys;
        coordSys.model = parallelModel;
        coordSysList.push(coordSys);
    });
    // Inject the coordinateSystems into seriesModel
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get('coordinateSystem') === 'parallel') {
            var parallelModel = seriesModel.getReferringComponents('parallel', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = parallelModel.coordinateSystem;
        }
    });
    return coordSysList;
}
var $f6f1517f8b4f9ba9$var$parallelCoordSysCreator = {
    create: $f6f1517f8b4f9ba9$var$createParallelCoordSys
};
var $f6f1517f8b4f9ba9$export$2e2bcd8739ae039 = $f6f1517f8b4f9ba9$var$parallelCoordSysCreator;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $4ba8f929f09c97ef$var$ParallelAxisModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ParallelAxisModel, _super);
    function ParallelAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisModel.type;
        /**
     * @readOnly
     */ _this.activeIntervals = [];
        return _this;
    }
    ParallelAxisModel.prototype.getAreaSelectStyle = function() {
        return (0, $8555b33f89f2677c$export$2e2bcd8739ae039)([
            [
                'fill',
                'color'
            ],
            [
                'lineWidth',
                'borderWidth'
            ],
            [
                'stroke',
                'borderColor'
            ],
            [
                'width',
                'width'
            ],
            [
                'opacity',
                'opacity'
            ]
        ])(this.getModel('areaSelectStyle'));
    };
    /**
   * The code of this feature is put on AxisModel but not ParallelAxis,
   * because axisModel can be alive after echarts updating but instance of
   * ParallelAxis having been disposed. this._activeInterval should be kept
   * when action dispatched (i.e. legend click).
   *
   * @param intervals `interval.length === 0` means set all active.
   */ ParallelAxisModel.prototype.setActiveIntervals = function(intervals) {
        var activeIntervals = this.activeIntervals = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(intervals);
        // Normalize
        if (activeIntervals) for(var i = activeIntervals.length - 1; i >= 0; i--)$9fd90cf3bf18fbcd$export$debe6e778e0a6d32(activeIntervals[i]);
    };
    /**
   * @param value When only attempting detect whether 'no activeIntervals set',
   *        `value` is not needed to be input.
   */ ParallelAxisModel.prototype.getActiveState = function(value) {
        var activeIntervals = this.activeIntervals;
        if (!activeIntervals.length) return 'normal';
        if (value == null || isNaN(+value)) return 'inactive';
        // Simple optimization
        if (activeIntervals.length === 1) {
            var interval = activeIntervals[0];
            if (interval[0] <= value && value <= interval[1]) return 'active';
        } else for(var i = 0, len = activeIntervals.length; i < len; i++){
            if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) return 'active';
        }
        return 'inactive';
    };
    return ParallelAxisModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($4ba8f929f09c97ef$var$ParallelAxisModel, (0, $12a09fd102c04f88$export$5c54b224726edb5a));
var $4ba8f929f09c97ef$export$2e2bcd8739ae039 = $4ba8f929f09c97ef$var$ParallelAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL = true;
var $f3dfc951a5a73cbe$var$mathMin = Math.min;
var $f3dfc951a5a73cbe$var$mathMax = Math.max;
var $f3dfc951a5a73cbe$var$mathPow = Math.pow;
var $f3dfc951a5a73cbe$var$COVER_Z = 10000;
var $f3dfc951a5a73cbe$var$UNSELECT_THRESHOLD = 6;
var $f3dfc951a5a73cbe$var$MIN_RESIZE_LINE_WIDTH = 6;
var $f3dfc951a5a73cbe$var$MUTEX_RESOURCE_KEY = 'globalPan';
var $f3dfc951a5a73cbe$var$DIRECTION_MAP = {
    w: [
        0,
        0
    ],
    e: [
        0,
        1
    ],
    n: [
        1,
        0
    ],
    s: [
        1,
        1
    ]
};
var $f3dfc951a5a73cbe$var$CURSOR_MAP = {
    w: 'ew',
    e: 'ew',
    n: 'ns',
    s: 'ns',
    ne: 'nesw',
    sw: 'nesw',
    nw: 'nwse',
    se: 'nwse'
};
var $f3dfc951a5a73cbe$var$DEFAULT_BRUSH_OPT = {
    brushStyle: {
        lineWidth: 2,
        stroke: 'rgba(210,219,238,0.3)',
        fill: '#D2DBEE'
    },
    transformable: true,
    brushMode: 'single',
    removeOnClick: false
};
var $f3dfc951a5a73cbe$var$baseUID = 0;
/**
 * params:
 *     areas: Array.<Array>, coord relates to container group,
 *                             If no container specified, to global.
 *     opt {
 *         isEnd: boolean,
 *         removeOnClick: boolean
 *     }
 */ var $f3dfc951a5a73cbe$var$BrushController = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BrushController, _super);
    function BrushController(zr) {
        var _this = _super.call(this) || this;
        /**
     * @internal
     */ _this._track = [];
        /**
     * @internal
     */ _this._covers = [];
        _this._handlers = {};
        _this._zr = zr;
        _this.group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        _this._uid = 'brushController_' + $f3dfc951a5a73cbe$var$baseUID++;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($f3dfc951a5a73cbe$var$pointerHandlers, function(handler, eventName) {
            this._handlers[eventName] = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(handler, this);
        }, _this);
        return _this;
    }
    /**
   * If set to `false`, select disabled.
   */ BrushController.prototype.enableBrush = function(brushOption) {
        this._brushType && this._doDisableBrush();
        brushOption.brushType && this._doEnableBrush(brushOption);
        return this;
    };
    BrushController.prototype._doEnableBrush = function(brushOption) {
        var zr = this._zr;
        // Consider roam, which takes globalPan too.
        if (!this._enableGlobalPan) $08d6a23f548c50b6$export$b7df5d561049483a(zr, $f3dfc951a5a73cbe$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.on(eventName, handler);
        });
        this._brushType = brushOption.brushType;
        this._brushOption = (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)((0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)($f3dfc951a5a73cbe$var$DEFAULT_BRUSH_OPT), brushOption, true);
    };
    BrushController.prototype._doDisableBrush = function() {
        var zr = this._zr;
        $08d6a23f548c50b6$export$23d3fad09dc44362(zr, $f3dfc951a5a73cbe$var$MUTEX_RESOURCE_KEY, this._uid);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._handlers, function(handler, eventName) {
            zr.off(eventName, handler);
        });
        this._brushType = this._brushOption = null;
    };
    /**
   * @param panelOpts If not pass, it is global brush.
   */ BrushController.prototype.setPanels = function(panelOpts) {
        if (panelOpts && panelOpts.length) {
            var panels_1 = this._panels = {};
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(panelOpts, function(panelOpts) {
                panels_1[panelOpts.panelId] = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(panelOpts);
            });
        } else this._panels = null;
        return this;
    };
    BrushController.prototype.mount = function(opt) {
        opt = opt || {};
        this._enableGlobalPan = opt.enableGlobalPan;
        var thisGroup = this.group;
        this._zr.add(thisGroup);
        thisGroup.attr({
            x: opt.x || 0,
            y: opt.y || 0,
            rotation: opt.rotation || 0,
            scaleX: opt.scaleX || 1,
            scaleY: opt.scaleY || 1
        });
        this._transform = thisGroup.getLocalTransform();
        return this;
    };
    // eachCover(cb, context): void {
    //     each(this._covers, cb, context);
    // }
    /**
   * Update covers.
   * @param coverConfigList
   *        If coverConfigList is null/undefined, all covers removed.
   */ BrushController.prototype.updateCovers = function(coverConfigList) {
        coverConfigList = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(coverConfigList, function(coverConfig) {
            return (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)((0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)($f3dfc951a5a73cbe$var$DEFAULT_BRUSH_OPT), coverConfig, true);
        });
        var tmpIdPrefix = '\0-brush-index-';
        var oldCovers = this._covers;
        var newCovers = this._covers = [];
        var controller = this;
        var creatingCover = this._creatingCover;
        new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(oldCovers, coverConfigList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
        return this;
        function getKey(brushOption, index) {
            return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
        }
        function oldGetKey(cover, index) {
            return getKey(cover.__brushOption, index);
        }
        function addOrUpdate(newIndex, oldIndex) {
            var newBrushInternal = coverConfigList[newIndex];
            // Consider setOption in event listener of brushSelect,
            // where updating cover when creating should be forbidden.
            if (oldIndex != null && oldCovers[oldIndex] === creatingCover) newCovers[newIndex] = oldCovers[oldIndex];
            else {
                var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushInternal, oldCovers[oldIndex]) : $f3dfc951a5a73cbe$var$endCreating(controller, $f3dfc951a5a73cbe$var$createCover(controller, newBrushInternal));
                $f3dfc951a5a73cbe$var$updateCoverAfterCreation(controller, cover);
            }
        }
        function remove(oldIndex) {
            if (oldCovers[oldIndex] !== creatingCover) controller.group.remove(oldCovers[oldIndex]);
        }
    };
    BrushController.prototype.unmount = function() {
        this.enableBrush(false);
        // container may 'removeAll' outside.
        $f3dfc951a5a73cbe$var$clearCovers(this);
        this._zr.remove(this.group);
        return this;
    };
    BrushController.prototype.dispose = function() {
        this.unmount();
        this.off();
    };
    return BrushController;
}((0, $abe8d7fba81d88ed$export$2e2bcd8739ae039));
function $f3dfc951a5a73cbe$var$createCover(controller, brushOption) {
    var cover = $f3dfc951a5a73cbe$var$coverRenderers[brushOption.brushType].createCover(controller, brushOption);
    cover.__brushOption = brushOption;
    $f3dfc951a5a73cbe$var$updateZ(cover, brushOption);
    controller.group.add(cover);
    return cover;
}
function $f3dfc951a5a73cbe$var$endCreating(controller, creatingCover) {
    var coverRenderer = $f3dfc951a5a73cbe$var$getCoverRenderer(creatingCover);
    if (coverRenderer.endCreating) {
        coverRenderer.endCreating(controller, creatingCover);
        $f3dfc951a5a73cbe$var$updateZ(creatingCover, creatingCover.__brushOption);
    }
    return creatingCover;
}
function $f3dfc951a5a73cbe$var$updateCoverShape(controller, cover) {
    var brushOption = cover.__brushOption;
    $f3dfc951a5a73cbe$var$getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
}
function $f3dfc951a5a73cbe$var$updateZ(cover, brushOption) {
    var z = brushOption.z;
    z == null && (z = $f3dfc951a5a73cbe$var$COVER_Z);
    cover.traverse(function(el) {
        el.z = z;
        el.z2 = z; // Consider in given container.
    });
}
function $f3dfc951a5a73cbe$var$updateCoverAfterCreation(controller, cover) {
    $f3dfc951a5a73cbe$var$getCoverRenderer(cover).updateCommon(controller, cover);
    $f3dfc951a5a73cbe$var$updateCoverShape(controller, cover);
}
function $f3dfc951a5a73cbe$var$getCoverRenderer(cover) {
    return $f3dfc951a5a73cbe$var$coverRenderers[cover.__brushOption.brushType];
}
// return target panel or `true` (means global panel)
function $f3dfc951a5a73cbe$var$getPanelByPoint(controller, e, localCursorPoint) {
    var panels = controller._panels;
    if (!panels) return $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panel;
    var transform = controller._transform;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(panels, function(pn) {
        pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
    });
    return panel;
}
// Return a panel or true
function $f3dfc951a5a73cbe$var$getPanelByCover(controller, cover) {
    var panels = controller._panels;
    if (!panels) return $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL; // Global panel
    var panelId = cover.__brushOption.panelId;
    // User may give cover without coord sys info,
    // which is then treated as global panel.
    return panelId != null ? panels[panelId] : $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL;
}
function $f3dfc951a5a73cbe$var$clearCovers(controller) {
    var covers = controller._covers;
    var originalLength = covers.length;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(covers, function(cover) {
        controller.group.remove(cover);
    }, controller);
    covers.length = 0;
    return !!originalLength;
}
function $f3dfc951a5a73cbe$var$trigger(controller, opt) {
    var areas = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(controller._covers, function(cover) {
        var brushOption = cover.__brushOption;
        var range = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(brushOption.range);
        return {
            brushType: brushOption.brushType,
            panelId: brushOption.panelId,
            range: range
        };
    });
    controller.trigger('brush', {
        areas: areas,
        isEnd: !!opt.isEnd,
        removeOnClick: !!opt.removeOnClick
    });
}
function $f3dfc951a5a73cbe$var$shouldShowCover(controller) {
    var track = controller._track;
    if (!track.length) return false;
    var p2 = track[track.length - 1];
    var p1 = track[0];
    var dx = p2[0] - p1[0];
    var dy = p2[1] - p1[1];
    var dist = $f3dfc951a5a73cbe$var$mathPow(dx * dx + dy * dy, 0.5);
    return dist > $f3dfc951a5a73cbe$var$UNSELECT_THRESHOLD;
}
function $f3dfc951a5a73cbe$var$getTrackEnds(track) {
    var tail = track.length - 1;
    tail < 0 && (tail = 0);
    return [
        track[0],
        track[tail]
    ];
}
function $f3dfc951a5a73cbe$var$createBaseRectCover(rectRangeConverter, controller, brushOption, edgeNameSequences) {
    var cover = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
    cover.add(new $37476269d425e3f6$export$2e2bcd8739ae039({
        name: 'main',
        style: $f3dfc951a5a73cbe$var$makeStyle(brushOption),
        silent: true,
        draggable: true,
        cursor: 'move',
        drift: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f3dfc951a5a73cbe$var$driftRect, rectRangeConverter, controller, cover, [
            'n',
            's',
            'w',
            'e'
        ]),
        ondragend: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f3dfc951a5a73cbe$var$trigger, controller, {
            isEnd: true
        })
    }));
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(edgeNameSequences, function(nameSequence) {
        cover.add(new $37476269d425e3f6$export$2e2bcd8739ae039({
            name: nameSequence.join(''),
            style: {
                opacity: 0
            },
            draggable: true,
            silent: true,
            invisible: true,
            drift: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f3dfc951a5a73cbe$var$driftRect, rectRangeConverter, controller, cover, nameSequence),
            ondragend: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f3dfc951a5a73cbe$var$trigger, controller, {
                isEnd: true
            })
        }));
    });
    return cover;
}
function $f3dfc951a5a73cbe$var$updateBaseRect(controller, cover, localRange, brushOption) {
    var lineWidth = brushOption.brushStyle.lineWidth || 0;
    var handleSize = $f3dfc951a5a73cbe$var$mathMax(lineWidth, $f3dfc951a5a73cbe$var$MIN_RESIZE_LINE_WIDTH);
    var x = localRange[0][0];
    var y = localRange[1][0];
    var xa = x - lineWidth / 2;
    var ya = y - lineWidth / 2;
    var x2 = localRange[0][1];
    var y2 = localRange[1][1];
    var x2a = x2 - handleSize + lineWidth / 2;
    var y2a = y2 - handleSize + lineWidth / 2;
    var width = x2 - x;
    var height = y2 - y;
    var widtha = width + lineWidth;
    var heighta = height + lineWidth;
    $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'main', x, y, width, height);
    if (brushOption.transformable) {
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
        $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
    }
}
function $f3dfc951a5a73cbe$var$updateCommon(controller, cover) {
    var brushOption = cover.__brushOption;
    var transformable = brushOption.transformable;
    var mainEl = cover.childAt(0);
    mainEl.useStyle($f3dfc951a5a73cbe$var$makeStyle(brushOption));
    mainEl.attr({
        silent: !transformable,
        cursor: transformable ? 'move' : 'default'
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        [
            'w'
        ],
        [
            'e'
        ],
        [
            'n'
        ],
        [
            's'
        ],
        [
            's',
            'e'
        ],
        [
            's',
            'w'
        ],
        [
            'n',
            'e'
        ],
        [
            'n',
            'w'
        ]
    ], function(nameSequence) {
        var el = cover.childOfName(nameSequence.join(''));
        var globalDir = nameSequence.length === 1 ? $f3dfc951a5a73cbe$var$getGlobalDirection1(controller, nameSequence[0]) : $f3dfc951a5a73cbe$var$getGlobalDirection2(controller, nameSequence);
        el && el.attr({
            silent: !transformable,
            invisible: !transformable,
            cursor: transformable ? $f3dfc951a5a73cbe$var$CURSOR_MAP[globalDir] + '-resize' : null
        });
    });
}
function $f3dfc951a5a73cbe$var$updateRectShape(controller, cover, name, x, y, w, h) {
    var el = cover.childOfName(name);
    el && el.setShape($f3dfc951a5a73cbe$var$pointsToRect($f3dfc951a5a73cbe$var$clipByPanel(controller, cover, [
        [
            x,
            y
        ],
        [
            x + w,
            y + h
        ]
    ])));
}
function $f3dfc951a5a73cbe$var$makeStyle(brushOption) {
    return (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
        strokeNoScale: true
    }, brushOption.brushStyle);
}
function $f3dfc951a5a73cbe$var$formatRectRange(x, y, x2, y2) {
    var min = [
        $f3dfc951a5a73cbe$var$mathMin(x, x2),
        $f3dfc951a5a73cbe$var$mathMin(y, y2)
    ];
    var max = [
        $f3dfc951a5a73cbe$var$mathMax(x, x2),
        $f3dfc951a5a73cbe$var$mathMax(y, y2)
    ];
    return [
        [
            min[0],
            max[0]
        ],
        [
            min[1],
            max[1]
        ] // y range
    ];
}
function $f3dfc951a5a73cbe$var$getTransform(controller) {
    return $8eb95236e1aa01e7$export$fce0c6cfca85ed96(controller.group);
}
function $f3dfc951a5a73cbe$var$getGlobalDirection1(controller, localDirName) {
    var map = {
        w: 'left',
        e: 'right',
        n: 'top',
        s: 'bottom'
    };
    var inverseMap = {
        left: 'w',
        right: 'e',
        top: 'n',
        bottom: 's'
    };
    var dir = $8eb95236e1aa01e7$export$fff94e9792354cfa(map[localDirName], $f3dfc951a5a73cbe$var$getTransform(controller));
    return inverseMap[dir];
}
function $f3dfc951a5a73cbe$var$getGlobalDirection2(controller, localDirNameSeq) {
    var globalDir = [
        $f3dfc951a5a73cbe$var$getGlobalDirection1(controller, localDirNameSeq[0]),
        $f3dfc951a5a73cbe$var$getGlobalDirection1(controller, localDirNameSeq[1])
    ];
    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
    return globalDir.join('');
}
function $f3dfc951a5a73cbe$var$driftRect(rectRangeConverter, controller, cover, dirNameSequence, dx, dy) {
    var brushOption = cover.__brushOption;
    var rectRange = rectRangeConverter.toRectRange(brushOption.range);
    var localDelta = $f3dfc951a5a73cbe$var$toLocalDelta(controller, dx, dy);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dirNameSequence, function(dirName) {
        var ind = $f3dfc951a5a73cbe$var$DIRECTION_MAP[dirName];
        rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
    });
    brushOption.range = rectRangeConverter.fromRectRange($f3dfc951a5a73cbe$var$formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
    $f3dfc951a5a73cbe$var$updateCoverAfterCreation(controller, cover);
    $f3dfc951a5a73cbe$var$trigger(controller, {
        isEnd: false
    });
}
function $f3dfc951a5a73cbe$var$driftPolygon(controller, cover, dx, dy) {
    var range = cover.__brushOption.range;
    var localDelta = $f3dfc951a5a73cbe$var$toLocalDelta(controller, dx, dy);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(range, function(point) {
        point[0] += localDelta[0];
        point[1] += localDelta[1];
    });
    $f3dfc951a5a73cbe$var$updateCoverAfterCreation(controller, cover);
    $f3dfc951a5a73cbe$var$trigger(controller, {
        isEnd: false
    });
}
function $f3dfc951a5a73cbe$var$toLocalDelta(controller, dx, dy) {
    var thisGroup = controller.group;
    var localD = thisGroup.transformCoordToLocal(dx, dy);
    var localZero = thisGroup.transformCoordToLocal(0, 0);
    return [
        localD[0] - localZero[0],
        localD[1] - localZero[1]
    ];
}
function $f3dfc951a5a73cbe$var$clipByPanel(controller, cover, data) {
    var panel = $f3dfc951a5a73cbe$var$getPanelByCover(controller, cover);
    return panel && panel !== $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL ? panel.clipPath(data, controller._transform) : (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(data);
}
function $f3dfc951a5a73cbe$var$pointsToRect(points) {
    var xmin = $f3dfc951a5a73cbe$var$mathMin(points[0][0], points[1][0]);
    var ymin = $f3dfc951a5a73cbe$var$mathMin(points[0][1], points[1][1]);
    var xmax = $f3dfc951a5a73cbe$var$mathMax(points[0][0], points[1][0]);
    var ymax = $f3dfc951a5a73cbe$var$mathMax(points[0][1], points[1][1]);
    return {
        x: xmin,
        y: ymin,
        width: xmax - xmin,
        height: ymax - ymin
    };
}
function $f3dfc951a5a73cbe$var$resetCursor(controller, e, localCursorPoint) {
    if (// Check active
    !controller._brushType || $f3dfc951a5a73cbe$var$isOutsideZrArea(controller, e.offsetX, e.offsetY)) return;
    var zr = controller._zr;
    var covers = controller._covers;
    var currPanel = $f3dfc951a5a73cbe$var$getPanelByPoint(controller, e, localCursorPoint);
    // Check whether in covers.
    if (!controller._dragging) for(var i = 0; i < covers.length; i++){
        var brushOption = covers[i].__brushOption;
        if (currPanel && (currPanel === $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL || brushOption.panelId === currPanel.panelId) && $f3dfc951a5a73cbe$var$coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) // Use cursor style set on cover.
        return;
    }
    currPanel && zr.setCursorStyle('crosshair');
}
function $f3dfc951a5a73cbe$var$preventDefault(e) {
    var rawE = e.event;
    rawE.preventDefault && rawE.preventDefault();
}
function $f3dfc951a5a73cbe$var$mainShapeContain(cover, x, y) {
    return cover.childOfName('main').contain(x, y);
}
function $f3dfc951a5a73cbe$var$updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
    var creatingCover = controller._creatingCover;
    var panel = controller._creatingPanel;
    var thisBrushOption = controller._brushOption;
    var eventParams;
    controller._track.push(localCursorPoint.slice());
    if ($f3dfc951a5a73cbe$var$shouldShowCover(controller) || creatingCover) {
        if (panel && !creatingCover) {
            thisBrushOption.brushMode === 'single' && $f3dfc951a5a73cbe$var$clearCovers(controller);
            var brushOption = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(thisBrushOption);
            brushOption.brushType = $f3dfc951a5a73cbe$var$determineBrushType(brushOption.brushType, panel);
            brushOption.panelId = panel === $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL ? null : panel.panelId;
            creatingCover = controller._creatingCover = $f3dfc951a5a73cbe$var$createCover(controller, brushOption);
            controller._covers.push(creatingCover);
        }
        if (creatingCover) {
            var coverRenderer = $f3dfc951a5a73cbe$var$coverRenderers[$f3dfc951a5a73cbe$var$determineBrushType(controller._brushType, panel)];
            var coverBrushOption = creatingCover.__brushOption;
            coverBrushOption.range = coverRenderer.getCreatingRange($f3dfc951a5a73cbe$var$clipByPanel(controller, creatingCover, controller._track));
            if (isEnd) {
                $f3dfc951a5a73cbe$var$endCreating(controller, creatingCover);
                coverRenderer.updateCommon(controller, creatingCover);
            }
            $f3dfc951a5a73cbe$var$updateCoverShape(controller, creatingCover);
            eventParams = {
                isEnd: isEnd
            };
        }
    } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
    // But a single click do not clear covers, because user may have casual
    // clicks (for example, click on other component and do not expect covers
    // disappear).
    // Only some cover removed, trigger action, but not every click trigger action.
    {
        if ($f3dfc951a5a73cbe$var$getPanelByPoint(controller, e, localCursorPoint) && $f3dfc951a5a73cbe$var$clearCovers(controller)) eventParams = {
            isEnd: isEnd,
            removeOnClick: true
        };
    }
    return eventParams;
}
function $f3dfc951a5a73cbe$var$determineBrushType(brushType, panel) {
    if (brushType === 'auto') return panel.defaultBrushType;
    return brushType;
}
var $f3dfc951a5a73cbe$var$pointerHandlers = {
    mousedown: function(e) {
        if (this._dragging) // In case some browser do not support globalOut,
        // and release mouse out side the browser.
        $f3dfc951a5a73cbe$var$handleDragEnd(this, e);
        else if (!e.target || !e.target.draggable) {
            $f3dfc951a5a73cbe$var$preventDefault(e);
            var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
            this._creatingCover = null;
            var panel = this._creatingPanel = $f3dfc951a5a73cbe$var$getPanelByPoint(this, e, localCursorPoint);
            if (panel) {
                this._dragging = true;
                this._track = [
                    localCursorPoint.slice()
                ];
            }
        }
    },
    mousemove: function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = this.group.transformCoordToLocal(x, y);
        $f3dfc951a5a73cbe$var$resetCursor(this, e, localCursorPoint);
        if (this._dragging) {
            $f3dfc951a5a73cbe$var$preventDefault(e);
            var eventParams = $f3dfc951a5a73cbe$var$updateCoverByMouse(this, e, localCursorPoint, false);
            eventParams && $f3dfc951a5a73cbe$var$trigger(this, eventParams);
        }
    },
    mouseup: function(e) {
        $f3dfc951a5a73cbe$var$handleDragEnd(this, e);
    }
};
function $f3dfc951a5a73cbe$var$handleDragEnd(controller, e) {
    if (controller._dragging) {
        $f3dfc951a5a73cbe$var$preventDefault(e);
        var x = e.offsetX;
        var y = e.offsetY;
        var localCursorPoint = controller.group.transformCoordToLocal(x, y);
        var eventParams = $f3dfc951a5a73cbe$var$updateCoverByMouse(controller, e, localCursorPoint, true);
        controller._dragging = false;
        controller._track = [];
        controller._creatingCover = null;
        // trigger event should be at final, after procedure will be nested.
        eventParams && $f3dfc951a5a73cbe$var$trigger(controller, eventParams);
    }
}
function $f3dfc951a5a73cbe$var$isOutsideZrArea(controller, x, y) {
    var zr = controller._zr;
    return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
}
/**
 * key: brushType
 */ var $f3dfc951a5a73cbe$var$coverRenderers = {
    lineX: $f3dfc951a5a73cbe$var$getLineRenderer(0),
    lineY: $f3dfc951a5a73cbe$var$getLineRenderer(1),
    rect: {
        createCover: function(controller, brushOption) {
            function returnInput(range) {
                return range;
            }
            return $f3dfc951a5a73cbe$var$createBaseRectCover({
                toRectRange: returnInput,
                fromRectRange: returnInput
            }, controller, brushOption, [
                [
                    'w'
                ],
                [
                    'e'
                ],
                [
                    'n'
                ],
                [
                    's'
                ],
                [
                    's',
                    'e'
                ],
                [
                    's',
                    'w'
                ],
                [
                    'n',
                    'e'
                ],
                [
                    'n',
                    'w'
                ]
            ]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $f3dfc951a5a73cbe$var$getTrackEnds(localTrack);
            return $f3dfc951a5a73cbe$var$formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            $f3dfc951a5a73cbe$var$updateBaseRect(controller, cover, localRange, brushOption);
        },
        updateCommon: $f3dfc951a5a73cbe$var$updateCommon,
        contain: $f3dfc951a5a73cbe$var$mainShapeContain
    },
    polygon: {
        createCover: function(controller, brushOption) {
            var cover = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
            // Do not use graphic.Polygon because graphic.Polyline do not close the
            // border of the shape when drawing, which is a better experience for user.
            cover.add(new $f7f6523750aec7c8$export$2e2bcd8739ae039({
                name: 'main',
                style: $f3dfc951a5a73cbe$var$makeStyle(brushOption),
                silent: true
            }));
            return cover;
        },
        getCreatingRange: function(localTrack) {
            return localTrack;
        },
        endCreating: function(controller, cover) {
            cover.remove(cover.childAt(0));
            // Use graphic.Polygon close the shape.
            cover.add(new $399011f87accd5da$export$2e2bcd8739ae039({
                name: 'main',
                draggable: true,
                drift: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f3dfc951a5a73cbe$var$driftPolygon, controller, cover),
                ondragend: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f3dfc951a5a73cbe$var$trigger, controller, {
                    isEnd: true
                })
            }));
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            cover.childAt(0).setShape({
                points: $f3dfc951a5a73cbe$var$clipByPanel(controller, cover, localRange)
            });
        },
        updateCommon: $f3dfc951a5a73cbe$var$updateCommon,
        contain: $f3dfc951a5a73cbe$var$mainShapeContain
    }
};
function $f3dfc951a5a73cbe$var$getLineRenderer(xyIndex) {
    return {
        createCover: function(controller, brushOption) {
            return $f3dfc951a5a73cbe$var$createBaseRectCover({
                toRectRange: function(range) {
                    var rectRange = [
                        range,
                        [
                            0,
                            100
                        ]
                    ];
                    xyIndex && rectRange.reverse();
                    return rectRange;
                },
                fromRectRange: function(rectRange) {
                    return rectRange[xyIndex];
                }
            }, controller, brushOption, [
                [
                    [
                        'w'
                    ],
                    [
                        'e'
                    ]
                ],
                [
                    [
                        'n'
                    ],
                    [
                        's'
                    ]
                ]
            ][xyIndex]);
        },
        getCreatingRange: function(localTrack) {
            var ends = $f3dfc951a5a73cbe$var$getTrackEnds(localTrack);
            var min = $f3dfc951a5a73cbe$var$mathMin(ends[0][xyIndex], ends[1][xyIndex]);
            var max = $f3dfc951a5a73cbe$var$mathMax(ends[0][xyIndex], ends[1][xyIndex]);
            return [
                min,
                max
            ];
        },
        updateCoverShape: function(controller, cover, localRange, brushOption) {
            var otherExtent;
            // If brushWidth not specified, fit the panel.
            var panel = $f3dfc951a5a73cbe$var$getPanelByCover(controller, cover);
            if (panel !== $f3dfc951a5a73cbe$var$BRUSH_PANEL_GLOBAL && panel.getLinearBrushOtherExtent) otherExtent = panel.getLinearBrushOtherExtent(xyIndex);
            else {
                var zr = controller._zr;
                otherExtent = [
                    0,
                    [
                        zr.getWidth(),
                        zr.getHeight()
                    ][1 - xyIndex]
                ];
            }
            var rectRange = [
                localRange,
                otherExtent
            ];
            xyIndex && rectRange.reverse();
            $f3dfc951a5a73cbe$var$updateBaseRect(controller, cover, rectRange, brushOption);
        },
        updateCommon: $f3dfc951a5a73cbe$var$updateCommon,
        contain: $f3dfc951a5a73cbe$var$mainShapeContain
    };
}
var $f3dfc951a5a73cbe$export$2e2bcd8739ae039 = $f3dfc951a5a73cbe$var$BrushController;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $1b1a2d237741e26c$export$fee17964a62a87a7(rect) {
    rect = $1b1a2d237741e26c$var$normalizeRect(rect);
    return function(localPoints) {
        return $8eb95236e1aa01e7$export$e2f409471bbbc1dc(localPoints, rect);
    };
}
function $1b1a2d237741e26c$export$7280070e90fad7a0(rect, specifiedXYIndex) {
    rect = $1b1a2d237741e26c$var$normalizeRect(rect);
    return function(xyIndex) {
        var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
        var brushWidth = idx ? rect.width : rect.height;
        var base = idx ? rect.x : rect.y;
        return [
            base,
            base + (brushWidth || 0)
        ];
    };
}
function $1b1a2d237741e26c$export$e63e66b3b18aa99f(rect, api, targetModel) {
    var boundingRect = $1b1a2d237741e26c$var$normalizeRect(rect);
    return function(e, localCursorPoint) {
        return boundingRect.contain(localCursorPoint[0], localCursorPoint[1]) && !(0, $644ca0c6add6ebe3$export$8a33eacb690eac07)(e, api, targetModel);
    };
}
// Consider width/height is negative.
function $1b1a2d237741e26c$var$normalizeRect(rect) {
    return (0, $020465b49a1dd45f$export$2e2bcd8739ae039).create(rect);
}




var $4c61f4198c9475a2$var$elementList = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $4c61f4198c9475a2$var$ParallelAxisView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ParallelAxisView, _super);
    function ParallelAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ParallelAxisView.type;
        return _this;
    }
    ParallelAxisView.prototype.init = function(ecModel, api) {
        _super.prototype.init.apply(this, arguments);
        (this._brushController = new (0, $f3dfc951a5a73cbe$export$2e2bcd8739ae039)(api.getZr())).on('brush', $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._onBrush, this));
    };
    ParallelAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        if ($4c61f4198c9475a2$var$fromAxisAreaSelect(axisModel, ecModel, payload)) return;
        this.axisModel = axisModel;
        this.api = api;
        this.group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this.group.add(this._axisGroup);
        if (!axisModel.get('show')) return;
        var coordSysModel = $4c61f4198c9475a2$var$getCoordSysModel(axisModel, ecModel);
        var coordSys = coordSysModel.coordinateSystem;
        var areaSelectStyle = axisModel.getAreaSelectStyle();
        var areaWidth = areaSelectStyle.width;
        var dim = axisModel.axis.dim;
        var axisLayout = coordSys.getAxisLayout(dim);
        var builderOpt = $1b239fc9d3a2f8ae$export$8b58be045bf06082({
            strokeContainThreshold: areaWidth
        }, axisLayout);
        var axisBuilder = new (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039)(axisModel, builderOpt);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($4c61f4198c9475a2$var$elementList, axisBuilder.add, axisBuilder);
        this._axisGroup.add(axisBuilder.getGroup());
        this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
        $8eb95236e1aa01e7$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
    };
    // /**
    //  * @override
    //  */
    // updateVisual(axisModel, ecModel, api, payload) {
    //     this._brushController && this._brushController
    //         .updateCovers(getCoverInfoList(axisModel));
    // }
    ParallelAxisView.prototype._refreshBrushController = function(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
        // After filtering, axis may change, select area needs to be update.
        var extent = axisModel.axis.getExtent();
        var extentLen = extent[1] - extent[0];
        var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
        // width/height might be negative, which will be
        // normalized in BoundingRect.
        var rect = $020465b49a1dd45f$export$2e2bcd8739ae039.create({
            x: extent[0],
            y: -areaWidth / 2,
            width: extentLen,
            height: areaWidth
        });
        rect.x -= extra;
        rect.width += 2 * extra;
        this._brushController.mount({
            enableGlobalPan: true,
            rotation: builderOpt.rotation,
            x: builderOpt.position[0],
            y: builderOpt.position[1]
        }).setPanels([
            {
                panelId: 'pl',
                clipPath: $1b1a2d237741e26c$export$fee17964a62a87a7(rect),
                isTargetByCursor: $1b1a2d237741e26c$export$e63e66b3b18aa99f(rect, api, coordSysModel),
                getLinearBrushOtherExtent: $1b1a2d237741e26c$export$7280070e90fad7a0(rect, 0)
            }
        ]).enableBrush({
            brushType: 'lineX',
            brushStyle: areaSelectStyle,
            removeOnClick: true
        }).updateCovers($4c61f4198c9475a2$var$getCoverInfoList(axisModel));
    };
    ParallelAxisView.prototype._onBrush = function(eventParam) {
        var coverInfoList = eventParam.areas;
        // Do not cache these object, because the mey be changed.
        var axisModel = this.axisModel;
        var axis = axisModel.axis;
        var intervals = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(coverInfoList, function(coverInfo) {
            return [
                axis.coordToData(coverInfo.range[0], true),
                axis.coordToData(coverInfo.range[1], true)
            ];
        });
        // If realtime is true, action is not dispatched on drag end, because
        // the drag end emits the same params with the last drag move event,
        // and may have some delay when using touch pad.
        if (!axisModel.option.realtime === eventParam.isEnd || eventParam.removeOnClick) // jshint ignore:line
        this.api.dispatchAction({
            type: 'axisAreaSelect',
            parallelAxisId: axisModel.id,
            intervals: intervals
        });
    };
    ParallelAxisView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    ParallelAxisView.type = 'parallelAxis';
    return ParallelAxisView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $4c61f4198c9475a2$var$fromAxisAreaSelect(axisModel, ecModel, payload) {
    return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
        mainType: 'parallelAxis',
        query: payload
    })[0] === axisModel;
}
function $4c61f4198c9475a2$var$getCoverInfoList(axisModel) {
    var axis = axisModel.axis;
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(axisModel.activeIntervals, function(interval) {
        return {
            brushType: 'lineX',
            panelId: 'pl',
            range: [
                axis.dataToCoord(interval[0], true),
                axis.dataToCoord(interval[1], true)
            ]
        };
    });
}
function $4c61f4198c9475a2$var$getCoordSysModel(axisModel, ecModel) {
    return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
}
var $4c61f4198c9475a2$export$2e2bcd8739ae039 = $4c61f4198c9475a2$var$ParallelAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $3aa13d40a65a85ce$var$actionInfo = {
    type: 'axisAreaSelect',
    event: 'axisAreaSelected'
};
function $3aa13d40a65a85ce$export$a97c1e0aa84f4f71(registers) {
    registers.registerAction($3aa13d40a65a85ce$var$actionInfo, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'parallelAxis',
            query: payload
        }, function(parallelAxisModel) {
            parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
        });
    });
    /**
   * @payload
   */ registers.registerAction('parallelAxisExpand', function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'parallel',
            query: payload
        }, function(parallelModel) {
            parallelModel.setAxisExpand(payload);
        });
    });
}


var $fd0deca40be1b110$var$defaultAxisOption = {
    type: 'value',
    areaSelectStyle: {
        width: 20,
        borderWidth: 1,
        borderColor: 'rgba(160,197,232)',
        color: 'rgba(160,197,232)',
        opacity: 0.3
    },
    realtime: true,
    z: 10
};
function $fd0deca40be1b110$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $6e8d56132909b23d$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $bc237362f726c38a$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('parallel', (0, $f6f1517f8b4f9ba9$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $41688c9d4bad6892$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $4ba8f929f09c97ef$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $4c61f4198c9475a2$export$2e2bcd8739ae039));
    (0, $74540b73e60dbb04$export$2e2bcd8739ae039)(registers, 'parallel', (0, $4ba8f929f09c97ef$export$2e2bcd8739ae039), $fd0deca40be1b110$var$defaultAxisOption);
    (0, $3aa13d40a65a85ce$export$a97c1e0aa84f4f71)(registers);
}


function $223f95c2d7b7ecc0$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $fd0deca40be1b110$export$4b3e715f166fdd78));
    registers.registerChartView((0, $92e7d40b2165913d$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $3b3ad254e85dc8ea$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $0def90bbad63cc86$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $732198fd54455741$var$SankeyPathShape = /** @class */ function() {
    function SankeyPathShape() {
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.cpx1 = 0;
        this.cpy1 = 0;
        this.cpx2 = 0;
        this.cpy2 = 0;
        this.extent = 0;
    }
    return SankeyPathShape;
}();
var $732198fd54455741$var$SankeyPath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SankeyPath, _super);
    function SankeyPath(opts) {
        return _super.call(this, opts) || this;
    }
    SankeyPath.prototype.getDefaultShape = function() {
        return new $732198fd54455741$var$SankeyPathShape();
    };
    SankeyPath.prototype.buildPath = function(ctx, shape) {
        var extent = shape.extent;
        ctx.moveTo(shape.x1, shape.y1);
        ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
        if (shape.orient === 'vertical') {
            ctx.lineTo(shape.x2 + extent, shape.y2);
            ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
        } else {
            ctx.lineTo(shape.x2, shape.y2 + extent);
            ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
        }
        ctx.closePath();
    };
    SankeyPath.prototype.highlight = function() {
        (0, $b414df7d361a211c$export$b2d02638cc34c042)(this);
    };
    SankeyPath.prototype.downplay = function() {
        (0, $b414df7d361a211c$export$11be6f716239ac55)(this);
    };
    return SankeyPath;
}($f9698154c9fcf427$export$2e2bcd8739ae039);
var $732198fd54455741$var$SankeyView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SankeyView, _super);
    function SankeyView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeyView.type;
        _this._focusAdjacencyDisabled = false;
        return _this;
    }
    SankeyView.prototype.render = function(seriesModel, ecModel, api) {
        var sankeyView = this;
        var graph = seriesModel.getGraph();
        var group = this.group;
        var layoutInfo = seriesModel.layoutInfo;
        // view width
        var width = layoutInfo.width;
        // view height
        var height = layoutInfo.height;
        var nodeData = seriesModel.getData();
        var edgeData = seriesModel.getData('edge');
        var orient = seriesModel.get('orient');
        this._model = seriesModel;
        group.removeAll();
        group.x = layoutInfo.x;
        group.y = layoutInfo.y;
        // generate a bezire Curve for each edge
        graph.eachEdge(function(edge) {
            var curve = new $732198fd54455741$var$SankeyPath();
            var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(curve);
            ecData.dataIndex = edge.dataIndex;
            ecData.seriesIndex = seriesModel.seriesIndex;
            ecData.dataType = 'edge';
            var edgeModel = edge.getModel();
            var lineStyleModel = edgeModel.getModel('lineStyle');
            var curvature = lineStyleModel.get('curveness');
            var n1Layout = edge.node1.getLayout();
            var node1Model = edge.node1.getModel();
            var dragX1 = node1Model.get('localX');
            var dragY1 = node1Model.get('localY');
            var n2Layout = edge.node2.getLayout();
            var node2Model = edge.node2.getModel();
            var dragX2 = node2Model.get('localX');
            var dragY2 = node2Model.get('localY');
            var edgeLayout = edge.getLayout();
            var x1;
            var y1;
            var x2;
            var y2;
            var cpx1;
            var cpy1;
            var cpx2;
            var cpy2;
            curve.shape.extent = Math.max(1, edgeLayout.dy);
            curve.shape.orient = orient;
            if (orient === 'vertical') {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
                x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
                y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
                cpx1 = x1;
                cpy1 = y1 * (1 - curvature) + y2 * curvature;
                cpx2 = x2;
                cpy2 = y1 * curvature + y2 * (1 - curvature);
            } else {
                x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
                y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
                x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
                y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
                cpx1 = x1 * (1 - curvature) + x2 * curvature;
                cpy1 = y1;
                cpx2 = x1 * curvature + x2 * (1 - curvature);
                cpy2 = y2;
            }
            curve.setShape({
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2,
                cpx1: cpx1,
                cpy1: cpy1,
                cpx2: cpx2,
                cpy2: cpy2
            });
            curve.useStyle(lineStyleModel.getItemStyle());
            // Special color, use source node color or target node color
            $732198fd54455741$var$applyCurveStyle(curve.style, orient, edge);
            var defaultEdgeLabelText = "" + edgeModel.get('value');
            var edgeLabelStateModels = (0, $3828198b2f2de836$export$9739a32674be5893)(edgeModel, 'edgeLabel');
            (0, $3828198b2f2de836$export$9a13992917966657)(curve, edgeLabelStateModels, {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName, dataType, labelDimIndex, formatter, extendParams) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, 'edge', labelDimIndex, // ensure edgeLabel formatter is provided
                        // to prevent the inheritance from `label.formatter` of the series
                        (0, $1b239fc9d3a2f8ae$export$2e94551289abb95b)(formatter, edgeLabelStateModels.normal && edgeLabelStateModels.normal.get('formatter'), defaultEdgeLabelText), extendParams);
                    }
                },
                labelDataIndex: edge.dataIndex,
                defaultText: defaultEdgeLabelText
            });
            curve.setTextConfig({
                position: 'inside'
            });
            var emphasisModel = edgeModel.getModel('emphasis');
            (0, $b414df7d361a211c$export$48b68047d330bbc9)(curve, edgeModel, 'lineStyle', function(model) {
                var style = model.getItemStyle();
                $732198fd54455741$var$applyCurveStyle(style, orient, edge);
                return style;
            });
            group.add(curve);
            edgeData.setItemGraphicEl(edge.dataIndex, curve);
            var focus = emphasisModel.get('focus');
            (0, $b414df7d361a211c$export$e51187539ff11209)(curve, focus === 'adjacency' ? edge.getAdjacentDataIndices() : focus === 'trajectory' ? edge.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        // Generate a rect for each node
        graph.eachNode(function(node) {
            var layout = node.getLayout();
            var itemModel = node.getModel();
            var dragX = itemModel.get('localX');
            var dragY = itemModel.get('localY');
            var emphasisModel = itemModel.getModel('emphasis');
            var borderRadius = itemModel.get([
                'itemStyle',
                'borderRadius'
            ]) || 0;
            var rect = new $37476269d425e3f6$export$2e2bcd8739ae039({
                shape: {
                    x: dragX != null ? dragX * width : layout.x,
                    y: dragY != null ? dragY * height : layout.y,
                    width: layout.dx,
                    height: layout.dy,
                    r: borderRadius
                },
                style: itemModel.getModel('itemStyle').getItemStyle(),
                z2: 10
            });
            (0, $3828198b2f2de836$export$9a13992917966657)(rect, (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel), {
                labelFetcher: {
                    getFormattedLabel: function(dataIndex, stateName) {
                        return seriesModel.getFormattedLabel(dataIndex, stateName, 'node');
                    }
                },
                labelDataIndex: node.dataIndex,
                defaultText: node.id
            });
            rect.disableLabelAnimation = true;
            rect.setStyle('fill', node.getVisual('color'));
            rect.setStyle('decal', node.getVisual('style').decal);
            (0, $b414df7d361a211c$export$48b68047d330bbc9)(rect, itemModel);
            group.add(rect);
            nodeData.setItemGraphicEl(node.dataIndex, rect);
            (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(rect).dataType = 'node';
            var focus = emphasisModel.get('focus');
            (0, $b414df7d361a211c$export$e51187539ff11209)(rect, focus === 'adjacency' ? node.getAdjacentDataIndices() : focus === 'trajectory' ? node.getTrajectoryDataIndices() : focus, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        });
        nodeData.eachItemGraphicEl(function(el, dataIndex) {
            var itemModel = nodeData.getItemModel(dataIndex);
            if (itemModel.get('draggable')) {
                el.drift = function(dx, dy) {
                    sankeyView._focusAdjacencyDisabled = true;
                    this.shape.x += dx;
                    this.shape.y += dy;
                    this.dirty();
                    api.dispatchAction({
                        type: 'dragNode',
                        seriesId: seriesModel.id,
                        dataIndex: nodeData.getRawIndex(dataIndex),
                        localX: this.shape.x / width,
                        localY: this.shape.y / height
                    });
                };
                el.ondragend = function() {
                    sankeyView._focusAdjacencyDisabled = false;
                };
                el.draggable = true;
                el.cursor = 'move';
            }
        });
        if (!this._data && seriesModel.isAnimationEnabled()) group.setClipPath($732198fd54455741$var$createGridClipShape(group.getBoundingRect(), seriesModel, function() {
            group.removeClipPath();
        }));
        this._data = seriesModel.getData();
    };
    SankeyView.prototype.dispose = function() {};
    SankeyView.type = 'sankey';
    return SankeyView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
/**
 * Special color, use source node color or target node color
 * @param curveProps curve's style to parse
 * @param orient direction
 * @param edge current curve data
 */ function $732198fd54455741$var$applyCurveStyle(curveProps, orient, edge) {
    switch(curveProps.fill){
        case 'source':
            curveProps.fill = edge.node1.getVisual('color');
            curveProps.decal = edge.node1.getVisual('style').decal;
            break;
        case 'target':
            curveProps.fill = edge.node2.getVisual('color');
            curveProps.decal = edge.node2.getVisual('style').decal;
            break;
        case 'gradient':
            var sourceColor = edge.node1.getVisual('color');
            var targetColor = edge.node2.getVisual('color');
            if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(sourceColor) && (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(targetColor)) curveProps.fill = new $e082211bdfcbd68a$export$2e2bcd8739ae039(0, 0, +(orient === 'horizontal'), +(orient === 'vertical'), [
                {
                    color: sourceColor,
                    offset: 0
                },
                {
                    color: targetColor,
                    offset: 1
                }
            ]);
    }
}
// Add animation to the view
function $732198fd54455741$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $37476269d425e3f6$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $b40111164617dd60$export$a121566aadcfe021(rectEl, {
        shape: {
            width: rect.width + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $732198fd54455741$export$2e2bcd8739ae039 = $732198fd54455741$var$SankeyView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $91dc1df8ad2e14a4$var$SankeySeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SankeySeriesModel, _super);
    function SankeySeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SankeySeriesModel.type;
        return _this;
    }
    /**
   * Init a graph data structure from data in option series
   */ SankeySeriesModel.prototype.getInitialData = function(option, ecModel) {
        var links = option.edges || option.links || [];
        var nodes = option.data || option.nodes || [];
        var levels = option.levels || [];
        this.levelModels = [];
        var levelModels = this.levelModels;
        for(var i = 0; i < levels.length; i++)if (levels[i].depth != null && levels[i].depth >= 0) levelModels[levels[i].depth] = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(levels[i], this, ecModel);
        var graph = (0, $986d83b3918bd6aa$export$2e2bcd8739ae039)(nodes, links, this, true, beforeLink);
        return graph.data;
        function beforeLink(nodeData, edgeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var seriesModel = model.parentModel;
                var layout = seriesModel.getData().getItemLayout(idx);
                if (layout) {
                    var nodeDepth = layout.depth;
                    var levelModel = seriesModel.levelModels[nodeDepth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
            edgeData.wrapMethod('getItemModel', function(model, idx) {
                var seriesModel = model.parentModel;
                var edge = seriesModel.getGraph().getEdgeByIndex(idx);
                var layout = edge.node1.getLayout();
                if (layout) {
                    var depth = layout.depth;
                    var levelModel = seriesModel.levelModels[depth];
                    if (levelModel) model.parentModel = levelModel;
                }
                return model;
            });
        }
    };
    SankeySeriesModel.prototype.setNodePosition = function(dataIndex, localPosition) {
        var nodes = this.option.data || this.option.nodes;
        var dataItem = nodes[dataIndex];
        dataItem.localX = localPosition[0];
        dataItem.localY = localPosition[1];
    };
    /**
   * Return the graphic data structure
   *
   * @return graphic data structure
   */ SankeySeriesModel.prototype.getGraph = function() {
        return this.getData().graph;
    };
    /**
   * Get edge data of graphic data structure
   *
   * @return data structure of list
   */ SankeySeriesModel.prototype.getEdgeData = function() {
        return this.getGraph().edgeData;
    };
    SankeySeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        function noValue(val) {
            return isNaN(val) || val == null;
        }
        // dataType === 'node' or empty do not show tooltip by default
        if (dataType === 'edge') {
            var params = this.getDataParams(dataIndex, dataType);
            var rawDataOpt = params.data;
            var edgeValue = params.value;
            var edgeName = rawDataOpt.source + ' -- ' + rawDataOpt.target;
            return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                name: edgeName,
                value: edgeValue,
                noValue: noValue(edgeValue)
            });
        } else {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var value = node.getLayout().value;
            var name_1 = this.getDataParams(dataIndex, dataType).data.name;
            return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                name: name_1 != null ? name_1 + '' : null,
                value: value,
                noValue: noValue(value)
            });
        }
    };
    SankeySeriesModel.prototype.optionUpdated = function() {};
    // Override Series.getDataParams()
    SankeySeriesModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        if (params.value == null && dataType === 'node') {
            var node = this.getGraph().getNodeByIndex(dataIndex);
            var nodeValue = node.getLayout().value;
            params.value = nodeValue;
        }
        return params;
    };
    SankeySeriesModel.type = 'series.sankey';
    SankeySeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'view',
        left: '5%',
        top: '5%',
        right: '20%',
        bottom: '5%',
        orient: 'horizontal',
        nodeWidth: 20,
        nodeGap: 8,
        draggable: true,
        layoutIterations: 32,
        label: {
            show: true,
            position: 'right',
            fontSize: 12
        },
        edgeLabel: {
            show: false,
            fontSize: 12
        },
        levels: [],
        nodeAlign: 'justify',
        lineStyle: {
            color: '#314656',
            opacity: 0.2,
            curveness: 0.5
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                opacity: 0.5
            }
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        },
        animationEasing: 'linear',
        animationDuration: 1000
    };
    return SankeySeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $91dc1df8ad2e14a4$export$2e2bcd8739ae039 = $91dc1df8ad2e14a4$var$SankeySeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $184dc662b26f0ff2$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('sankey', function(seriesModel) {
        var nodeWidth = seriesModel.get('nodeWidth');
        var nodeGap = seriesModel.get('nodeGap');
        var layoutInfo = $184dc662b26f0ff2$var$getViewRect(seriesModel, api);
        seriesModel.layoutInfo = layoutInfo;
        var width = layoutInfo.width;
        var height = layoutInfo.height;
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        $184dc662b26f0ff2$var$computeNodeValues(nodes);
        var filteredNodes = $1b239fc9d3a2f8ae$export$3dea766d36a8935f(nodes, function(node) {
            return node.getLayout().value === 0;
        });
        var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
        var orient = seriesModel.get('orient');
        var nodeAlign = seriesModel.get('nodeAlign');
        $184dc662b26f0ff2$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
    });
}
/**
 * Get the layout position of the whole view
 */ function $184dc662b26f0ff2$var$getViewRect(seriesModel, api) {
    return $501dc28f6c4d24ac$export$4517a5ca639a7293(seriesModel.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    });
}
function $184dc662b26f0ff2$var$layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
    $184dc662b26f0ff2$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
    $184dc662b26f0ff2$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
    $184dc662b26f0ff2$var$computeEdgeDepths(nodes, orient);
}
/**
 * Compute the value of each node by summing the associated edge's value
 */ function $184dc662b26f0ff2$var$computeNodeValues(nodes) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
        var value1 = $184dc662b26f0ff2$var$sum(node.outEdges, $184dc662b26f0ff2$var$getEdgeValue);
        var value2 = $184dc662b26f0ff2$var$sum(node.inEdges, $184dc662b26f0ff2$var$getEdgeValue);
        var nodeRawValue = node.getValue() || 0;
        var value = Math.max(value1, value2, nodeRawValue);
        node.setLayout({
            value: value
        }, true);
    });
}
/**
 * Compute the x-position for each node.
 *
 * Here we use Kahn algorithm to detect cycle when we traverse
 * the node to computer the initial x position.
 */ function $184dc662b26f0ff2$var$computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
    // Used to mark whether the edge is deleted. if it is deleted,
    // the value is 0, otherwise it is 1.
    var remainEdges = [];
    // Storage each node's indegree.
    var indegreeArr = [];
    // Used to storage the node with indegree is equal to 0.
    var zeroIndegrees = [];
    var nextTargetNode = [];
    var x = 0;
    // let kx = 0;
    for(var i = 0; i < edges.length; i++)remainEdges[i] = 1;
    for(var i = 0; i < nodes.length; i++){
        indegreeArr[i] = nodes[i].inEdges.length;
        if (indegreeArr[i] === 0) zeroIndegrees.push(nodes[i]);
    }
    var maxNodeDepth = -1;
    // Traversing nodes using topological sorting to calculate the
    // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
    // position of the nodes.
    while(zeroIndegrees.length){
        for(var idx = 0; idx < zeroIndegrees.length; idx++){
            var node = zeroIndegrees[idx];
            var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
            var isItemDepth = item.depth != null && item.depth >= 0;
            if (isItemDepth && item.depth > maxNodeDepth) maxNodeDepth = item.depth;
            node.setLayout({
                depth: isItemDepth ? item.depth : x
            }, true);
            orient === 'vertical' ? node.setLayout({
                dy: nodeWidth
            }, true) : node.setLayout({
                dx: nodeWidth
            }, true);
            for(var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++){
                var edge = node.outEdges[edgeIdx];
                var indexEdge = edges.indexOf(edge);
                remainEdges[indexEdge] = 0;
                var targetNode = edge.node2;
                var nodeIndex = nodes.indexOf(targetNode);
                if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) nextTargetNode.push(targetNode);
            }
        }
        ++x;
        zeroIndegrees = nextTargetNode;
        nextTargetNode = [];
    }
    for(var i = 0; i < remainEdges.length; i++){
        if (remainEdges[i] === 1) throw new Error('Sankey is a DAG, the original data has cycle!');
    }
    var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
    if (nodeAlign && nodeAlign !== 'left') $184dc662b26f0ff2$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
    var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
    $184dc662b26f0ff2$var$scaleNodeBreadths(nodes, kx, orient);
}
function $184dc662b26f0ff2$var$isNodeDepth(node) {
    var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
    return item.depth != null && item.depth >= 0;
}
function $184dc662b26f0ff2$var$adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
    if (nodeAlign === 'right') {
        var nextSourceNode = [];
        var remainNodes = nodes;
        var nodeHeight = 0;
        while(remainNodes.length){
            for(var i = 0; i < remainNodes.length; i++){
                var node = remainNodes[i];
                node.setLayout({
                    skNodeHeight: nodeHeight
                }, true);
                for(var j = 0; j < node.inEdges.length; j++){
                    var edge = node.inEdges[j];
                    if (nextSourceNode.indexOf(edge.node1) < 0) nextSourceNode.push(edge.node1);
                }
            }
            remainNodes = nextSourceNode;
            nextSourceNode = [];
            ++nodeHeight;
        }
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
            if (!$184dc662b26f0ff2$var$isNodeDepth(node)) node.setLayout({
                depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
            }, true);
        });
    } else if (nodeAlign === 'justify') $184dc662b26f0ff2$var$moveSinksRight(nodes, maxDepth);
}
/**
 * All the node without outEgdes are assigned maximum x-position and
 *     be aligned in the last column.
 *
 * @param nodes.  node of sankey view.
 * @param maxDepth.  use to assign to node without outEdges as x-position.
 */ function $184dc662b26f0ff2$var$moveSinksRight(nodes, maxDepth) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
        if (!$184dc662b26f0ff2$var$isNodeDepth(node) && !node.outEdges.length) node.setLayout({
            depth: maxDepth
        }, true);
    });
}
/**
 * Scale node x-position to the width
 *
 * @param nodes  node of sankey view
 * @param kx   multiple used to scale nodes
 */ function $184dc662b26f0ff2$var$scaleNodeBreadths(nodes, kx, orient) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
        var nodeDepth = node.getLayout().depth * kx;
        orient === 'vertical' ? node.setLayout({
            y: nodeDepth
        }, true) : node.setLayout({
            x: nodeDepth
        }, true);
    });
}
/**
 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
 *
 * @param nodes  node of sankey view
 * @param edges  edge of sankey view
 * @param height  the whole height of the area to draw the view
 * @param nodeGap  the vertical distance between two nodes
 *     in the same column.
 * @param iterations  the number of iterations for the algorithm
 */ function $184dc662b26f0ff2$var$computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
    var nodesByBreadth = $184dc662b26f0ff2$var$prepareNodesByBreadth(nodes, orient);
    $184dc662b26f0ff2$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
    $184dc662b26f0ff2$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    for(var alpha = 1; iterations > 0; iterations--){
        // 0.99 is a experience parameter, ensure that each iterations of
        // changes as small as possible.
        alpha *= 0.99;
        $184dc662b26f0ff2$var$relaxRightToLeft(nodesByBreadth, alpha, orient);
        $184dc662b26f0ff2$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
        $184dc662b26f0ff2$var$relaxLeftToRight(nodesByBreadth, alpha, orient);
        $184dc662b26f0ff2$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
    }
}
function $184dc662b26f0ff2$var$prepareNodesByBreadth(nodes, orient) {
    var nodesByBreadth = [];
    var keyAttr = orient === 'vertical' ? 'y' : 'x';
    var groupResult = (0, $9ac03c46e8b6e711$export$7ab5bda43e13168f)(nodes, function(node) {
        return node.getLayout()[keyAttr];
    });
    groupResult.keys.sort(function(a, b) {
        return a - b;
    });
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(groupResult.keys, function(key) {
        nodesByBreadth.push(groupResult.buckets.get(key));
    });
    return nodesByBreadth;
}
/**
 * Compute the original y-position for each node
 */ function $184dc662b26f0ff2$var$initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
    var minKy = Infinity;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        var n = nodes.length;
        var sum = 0;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
            sum += node.getLayout().value;
        });
        var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
        if (ky < minKy) minKy = ky;
    });
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node, i) {
            var nodeDy = node.getLayout().value * minKy;
            if (orient === 'vertical') {
                node.setLayout({
                    x: i
                }, true);
                node.setLayout({
                    dx: nodeDy
                }, true);
            } else {
                node.setLayout({
                    y: i
                }, true);
                node.setLayout({
                    dy: nodeDy
                }, true);
            }
        });
    });
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(edges, function(edge) {
        var edgeDy = +edge.getValue() * minKy;
        edge.setLayout({
            dy: edgeDy
        }, true);
    });
}
/**
 * Resolve the collision of initialized depth (y-position)
 */ function $184dc662b26f0ff2$var$resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
    var keyAttr = orient === 'vertical' ? 'x' : 'y';
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        nodes.sort(function(a, b) {
            return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
        });
        var nodeX;
        var node;
        var dy;
        var y0 = 0;
        var n = nodes.length;
        var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
        for(var i = 0; i < n; i++){
            node = nodes[i];
            dy = y0 - node.getLayout()[keyAttr];
            if (dy > 0) {
                nodeX = node.getLayout()[keyAttr] + dy;
                orient === 'vertical' ? node.setLayout({
                    x: nodeX
                }, true) : node.setLayout({
                    y: nodeX
                }, true);
            }
            y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
        }
        var viewWidth = orient === 'vertical' ? width : height;
        // If the bottommost node goes outside the bounds, push it back up
        dy = y0 - nodeGap - viewWidth;
        if (dy > 0) {
            nodeX = node.getLayout()[keyAttr] - dy;
            orient === 'vertical' ? node.setLayout({
                x: nodeX
            }, true) : node.setLayout({
                y: nodeX
            }, true);
            y0 = nodeX;
            for(var i = n - 2; i >= 0; --i){
                node = nodes[i];
                dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
                if (dy > 0) {
                    nodeX = node.getLayout()[keyAttr] - dy;
                    orient === 'vertical' ? node.setLayout({
                        x: nodeX
                    }, true) : node.setLayout({
                        y: nodeX
                    }, true);
                }
                y0 = node.getLayout()[keyAttr];
            }
        }
    });
}
/**
 * Change the y-position of the nodes, except most the right side nodes
 * @param nodesByBreadth
 * @param alpha  parameter used to adjust the nodes y-position
 */ function $184dc662b26f0ff2$var$relaxRightToLeft(nodesByBreadth, alpha, orient) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodesByBreadth.slice().reverse(), function(nodes) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
            if (node.outEdges.length) {
                var y = $184dc662b26f0ff2$var$sum(node.outEdges, $184dc662b26f0ff2$var$weightedTarget, orient) / $184dc662b26f0ff2$var$sum(node.outEdges, $184dc662b26f0ff2$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.outEdges.length;
                    y = len ? $184dc662b26f0ff2$var$sum(node.outEdges, $184dc662b26f0ff2$var$centerTarget, orient) / len : 0;
                }
                if (orient === 'vertical') {
                    var nodeX = node.getLayout().x + (y - $184dc662b26f0ff2$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $184dc662b26f0ff2$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
function $184dc662b26f0ff2$var$weightedTarget(edge, orient) {
    return $184dc662b26f0ff2$var$center(edge.node2, orient) * edge.getValue();
}
function $184dc662b26f0ff2$var$centerTarget(edge, orient) {
    return $184dc662b26f0ff2$var$center(edge.node2, orient);
}
function $184dc662b26f0ff2$var$weightedSource(edge, orient) {
    return $184dc662b26f0ff2$var$center(edge.node1, orient) * edge.getValue();
}
function $184dc662b26f0ff2$var$centerSource(edge, orient) {
    return $184dc662b26f0ff2$var$center(edge.node1, orient);
}
function $184dc662b26f0ff2$var$center(node, orient) {
    return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
}
function $184dc662b26f0ff2$var$getEdgeValue(edge) {
    return edge.getValue();
}
function $184dc662b26f0ff2$var$sum(array, cb, orient) {
    var sum = 0;
    var len = array.length;
    var i = -1;
    while(++i < len){
        var value = +cb(array[i], orient);
        if (!isNaN(value)) sum += value;
    }
    return sum;
}
/**
 * Change the y-position of the nodes, except most the left side nodes
 */ function $184dc662b26f0ff2$var$relaxLeftToRight(nodesByBreadth, alpha, orient) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodesByBreadth, function(nodes) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
            if (node.inEdges.length) {
                var y = $184dc662b26f0ff2$var$sum(node.inEdges, $184dc662b26f0ff2$var$weightedSource, orient) / $184dc662b26f0ff2$var$sum(node.inEdges, $184dc662b26f0ff2$var$getEdgeValue);
                if (isNaN(y)) {
                    var len = node.inEdges.length;
                    y = len ? $184dc662b26f0ff2$var$sum(node.inEdges, $184dc662b26f0ff2$var$centerSource, orient) / len : 0;
                }
                if (orient === 'vertical') {
                    var nodeX = node.getLayout().x + (y - $184dc662b26f0ff2$var$center(node, orient)) * alpha;
                    node.setLayout({
                        x: nodeX
                    }, true);
                } else {
                    var nodeY = node.getLayout().y + (y - $184dc662b26f0ff2$var$center(node, orient)) * alpha;
                    node.setLayout({
                        y: nodeY
                    }, true);
                }
            }
        });
    });
}
/**
 * Compute the depth(y-position) of each edge
 */ function $184dc662b26f0ff2$var$computeEdgeDepths(nodes, orient) {
    var keyAttr = orient === 'vertical' ? 'x' : 'y';
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
        node.outEdges.sort(function(a, b) {
            return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
        });
        node.inEdges.sort(function(a, b) {
            return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
        });
    });
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
        var sy = 0;
        var ty = 0;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(node.outEdges, function(edge) {
            edge.setLayout({
                sy: sy
            }, true);
            sy += edge.getLayout().dy;
        });
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(node.inEdges, function(edge) {
            edge.setLayout({
                ty: ty
            }, true);
            ty += edge.getLayout().dy;
        });
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $27542e61373ec111$export$2e2bcd8739ae039(ecModel) {
    ecModel.eachSeriesByType('sankey', function(seriesModel) {
        var graph = seriesModel.getGraph();
        var nodes = graph.nodes;
        var edges = graph.edges;
        if (nodes.length) {
            var minValue_1 = Infinity;
            var maxValue_1 = -Infinity;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
                var nodeValue = node.getLayout().value;
                if (nodeValue < minValue_1) minValue_1 = nodeValue;
                if (nodeValue > maxValue_1) maxValue_1 = nodeValue;
            });
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(nodes, function(node) {
                var mapping = new (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039)({
                    type: 'color',
                    mappingMethod: 'linear',
                    dataExtent: [
                        minValue_1,
                        maxValue_1
                    ],
                    visual: seriesModel.get('color')
                });
                var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
                var customColor = node.getModel().get([
                    'itemStyle',
                    'color'
                ]);
                if (customColor != null) {
                    node.setVisual('color', customColor);
                    node.setVisual('style', {
                        fill: customColor
                    });
                } else {
                    node.setVisual('color', mapValueToColor);
                    node.setVisual('style', {
                        fill: mapValueToColor
                    });
                }
            });
        }
        if (edges.length) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(edges, function(edge) {
            var edgeStyle = edge.getModel().get('lineStyle');
            edge.setVisual('style', edgeStyle);
        });
    });
}


function $2194da37bf3543d5$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $732198fd54455741$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $91dc1df8ad2e14a4$export$2e2bcd8739ae039));
    registers.registerLayout((0, $184dc662b26f0ff2$export$2e2bcd8739ae039));
    registers.registerVisual((0, $27542e61373ec111$export$2e2bcd8739ae039));
    registers.registerAction({
        type: 'dragNode',
        event: 'dragnode',
        // here can only use 'update' now, other value is not support in echarts.
        update: 'update'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sankey',
            query: payload
        }, function(seriesModel) {
            seriesModel.setNodePosition(payload.dataIndex, [
                payload.localX,
                payload.localY
            ]);
        });
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $25873f74d3daa041$export$ccfed902f8630510 = /** @class */ function() {
    function WhiskerBoxCommonMixin() {}
    /**
   * @private
   */ WhiskerBoxCommonMixin.prototype._hasEncodeRule = function(key) {
        var encodeRules = this.getEncode();
        return encodeRules && encodeRules.get(key) != null;
    };
    /**
   * @override
   */ WhiskerBoxCommonMixin.prototype.getInitialData = function(option, ecModel) {
        // When both types of xAxis and yAxis are 'value', layout is
        // needed to be specified by user. Otherwise, layout can be
        // judged by which axis is category.
        var ordinalMeta;
        var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
        var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
        var xAxisType = xAxisModel.get('type');
        var yAxisType = yAxisModel.get('type');
        var addOrdinal;
        // FIXME
        // Consider time axis.
        if (xAxisType === 'category') {
            option.layout = 'horizontal';
            ordinalMeta = xAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule('x');
        } else if (yAxisType === 'category') {
            option.layout = 'vertical';
            ordinalMeta = yAxisModel.getOrdinalMeta();
            addOrdinal = !this._hasEncodeRule('y');
        } else option.layout = option.layout || 'horizontal';
        var coordDims = [
            'x',
            'y'
        ];
        var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
        var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
        var otherAxisDim = coordDims[1 - baseAxisDimIndex];
        var axisModels = [
            xAxisModel,
            yAxisModel
        ];
        var baseAxisType = axisModels[baseAxisDimIndex].get('type');
        var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
        var data = option.data;
        // Clone a new data for next setOption({}) usage.
        // Avoid modifying current data will affect further update.
        if (data && addOrdinal) {
            var newOptionData_1 = [];
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(data, function(item, index) {
                var newItem;
                if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(item)) {
                    newItem = item.slice();
                    // Modify current using data.
                    item.unshift(index);
                } else if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(item.value)) {
                    newItem = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, item);
                    newItem.value = newItem.value.slice();
                    // Modify current using data.
                    item.value.unshift(index);
                } else newItem = item;
                newOptionData_1.push(newItem);
            });
            option.data = newOptionData_1;
        }
        var defaultValueDimensions = this.defaultValueDimensions;
        var coordDimensions = [
            {
                name: baseAxisDim,
                type: (0, $e1ef773174d5a33a$export$af1622903e71278e)(baseAxisType),
                ordinalMeta: ordinalMeta,
                otherDims: {
                    tooltip: false,
                    itemName: 0
                },
                dimsDef: [
                    'base'
                ]
            },
            {
                name: otherAxisDim,
                type: (0, $e1ef773174d5a33a$export$af1622903e71278e)(otherAxisType),
                dimsDef: defaultValueDimensions.slice()
            }
        ];
        return (0, $4433247721525340$export$2e2bcd8739ae039)(this, {
            coordDimensions: coordDimensions,
            dimensionsCount: defaultValueDimensions.length + 1,
            encodeDefaulter: $1b239fc9d3a2f8ae$export$c3095a23b368d1f2((0, $669a01b8661bdd13$export$37682b8fdd2e83d), coordDimensions, this)
        });
    };
    /**
   * If horizontal, base axis is x, otherwise y.
   * @override
   */ WhiskerBoxCommonMixin.prototype.getBaseAxis = function() {
        var dim = this._baseAxisDim;
        return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
    };
    return WhiskerBoxCommonMixin;
}();



var $944c99a712ebe95c$var$BoxplotSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BoxplotSeriesModel, _super);
    function BoxplotSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotSeriesModel.type;
        // TODO
        // box width represents group size, so dimension should have 'size'.
        /**
     * @see <https://en.wikipedia.org/wiki/Box_plot>
     * The meanings of 'min' and 'max' depend on user,
     * and echarts do not need to know it.
     * @readOnly
     */ _this.defaultValueDimensions = [
            {
                name: 'min',
                defaultTooltip: true
            },
            {
                name: 'Q1',
                defaultTooltip: true
            },
            {
                name: 'median',
                defaultTooltip: true
            },
            {
                name: 'Q3',
                defaultTooltip: true
            },
            {
                name: 'max',
                defaultTooltip: true
            }
        ];
        _this.visualDrawType = 'stroke';
        return _this;
    }
    BoxplotSeriesModel.type = 'series.boxplot';
    BoxplotSeriesModel.dependencies = [
        'xAxis',
        'yAxis',
        'grid'
    ];
    BoxplotSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        layout: null,
        boxWidth: [
            7,
            50
        ],
        itemStyle: {
            color: '#fff',
            borderWidth: 1
        },
        emphasis: {
            scale: true,
            itemStyle: {
                borderWidth: 2,
                shadowBlur: 5,
                shadowOffsetX: 1,
                shadowOffsetY: 1,
                shadowColor: 'rgba(0,0,0,0.2)'
            }
        },
        animationDuration: 800
    };
    return BoxplotSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($944c99a712ebe95c$var$BoxplotSeriesModel, (0, $25873f74d3daa041$export$ccfed902f8630510), true);
var $944c99a712ebe95c$export$2e2bcd8739ae039 = $944c99a712ebe95c$var$BoxplotSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $689c532301e5d11b$var$BoxplotView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BoxplotView, _super);
    function BoxplotView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BoxplotView.type;
        return _this;
    }
    BoxplotView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var group = this.group;
        var oldData = this._data;
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                var symbolEl = $689c532301e5d11b$var$createNormalBox(itemLayout, data, newIdx, constDim, true);
                data.setItemGraphicEl(newIdx, symbolEl);
                group.add(symbolEl);
            }
        }).update(function(newIdx, oldIdx) {
            var symbolEl = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(symbolEl);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (!symbolEl) symbolEl = $689c532301e5d11b$var$createNormalBox(itemLayout, data, newIdx, constDim);
            else {
                (0, $b40111164617dd60$export$bca7290a9faf0ec9)(symbolEl);
                $689c532301e5d11b$var$updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
            }
            group.add(symbolEl);
            data.setItemGraphicEl(newIdx, symbolEl);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    BoxplotView.prototype.remove = function(ecModel) {
        var group = this.group;
        var data = this._data;
        this._data = null;
        data && data.eachItemGraphicEl(function(el) {
            el && group.remove(el);
        });
    };
    BoxplotView.type = 'boxplot';
    return BoxplotView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $689c532301e5d11b$var$BoxPathShape = /** @class */ function() {
    function BoxPathShape() {}
    return BoxPathShape;
}();
var $689c532301e5d11b$var$BoxPath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BoxPath, _super);
    function BoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'boxplotBoxPath';
        return _this;
    }
    BoxPath.prototype.getDefaultShape = function() {
        return new $689c532301e5d11b$var$BoxPathShape();
    };
    BoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        var i = 0;
        ctx.moveTo(ends[i][0], ends[i][1]);
        i++;
        for(; i < 4; i++)ctx.lineTo(ends[i][0], ends[i][1]);
        ctx.closePath();
        for(; i < ends.length; i++){
            ctx.moveTo(ends[i][0], ends[i][1]);
            i++;
            ctx.lineTo(ends[i][0], ends[i][1]);
        }
    };
    return BoxPath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
function $689c532301e5d11b$var$createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
    var ends = itemLayout.ends;
    var el = new $689c532301e5d11b$var$BoxPath({
        shape: {
            points: isInit ? $689c532301e5d11b$var$transInit(ends, constDim, itemLayout) : ends
        }
    });
    $689c532301e5d11b$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
    return el;
}
function $689c532301e5d11b$var$updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
    var seriesModel = data.hostModel;
    var updateMethod = $8eb95236e1aa01e7$exports[isInit ? 'initProps' : 'updateProps'];
    updateMethod(el, {
        shape: {
            points: itemLayout.ends
        }
    }, seriesModel, dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.strokeNoScale = true;
    el.z2 = 100;
    var itemModel = data.getItemModel(dataIndex);
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $b414df7d361a211c$export$48b68047d330bbc9)(el, itemModel);
    (0, $b414df7d361a211c$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
function $689c532301e5d11b$var$transInit(points, dim, itemLayout) {
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[dim] = itemLayout.initBaseline;
        return point;
    });
}
var $689c532301e5d11b$export$2e2bcd8739ae039 = $689c532301e5d11b$var$BoxplotView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $e25d451bb6e14b17$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
function $e25d451bb6e14b17$export$2e2bcd8739ae039(ecModel) {
    var groupResult = $e25d451bb6e14b17$var$groupSeriesByAxis(ecModel);
    $e25d451bb6e14b17$var$each(groupResult, function(groupItem) {
        var seriesModels = groupItem.seriesModels;
        if (!seriesModels.length) return;
        $e25d451bb6e14b17$var$calculateBase(groupItem);
        $e25d451bb6e14b17$var$each(seriesModels, function(seriesModel, idx) {
            $e25d451bb6e14b17$var$layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
        });
    });
}
/**
 * Group series by axis.
 */ function $e25d451bb6e14b17$var$groupSeriesByAxis(ecModel) {
    var result = [];
    var axisList = [];
    ecModel.eachSeriesByType('boxplot', function(seriesModel) {
        var baseAxis = seriesModel.getBaseAxis();
        var idx = $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(axisList, baseAxis);
        if (idx < 0) {
            idx = axisList.length;
            axisList[idx] = baseAxis;
            result[idx] = {
                axis: baseAxis,
                seriesModels: []
            };
        }
        result[idx].seriesModels.push(seriesModel);
    });
    return result;
}
/**
 * Calculate offset and box width for each series.
 */ function $e25d451bb6e14b17$var$calculateBase(groupItem) {
    var baseAxis = groupItem.axis;
    var seriesModels = groupItem.seriesModels;
    var seriesCount = seriesModels.length;
    var boxWidthList = groupItem.boxWidthList = [];
    var boxOffsetList = groupItem.boxOffsetList = [];
    var boundList = [];
    var bandWidth;
    if (baseAxis.type === 'category') bandWidth = baseAxis.getBandWidth();
    else {
        var maxDataCount_1 = 0;
        $e25d451bb6e14b17$var$each(seriesModels, function(seriesModel) {
            maxDataCount_1 = Math.max(maxDataCount_1, seriesModel.getData().count());
        });
        var extent = baseAxis.getExtent();
        bandWidth = Math.abs(extent[1] - extent[0]) / maxDataCount_1;
    }
    $e25d451bb6e14b17$var$each(seriesModels, function(seriesModel) {
        var boxWidthBound = seriesModel.get('boxWidth');
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(boxWidthBound)) boxWidthBound = [
            boxWidthBound,
            boxWidthBound
        ];
        boundList.push([
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(boxWidthBound[0], bandWidth) || 0,
            (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(boxWidthBound[1], bandWidth) || 0
        ]);
    });
    var availableWidth = bandWidth * 0.8 - 2;
    var boxGap = availableWidth / seriesCount * 0.3;
    var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
    var base = boxWidth / 2 - availableWidth / 2;
    $e25d451bb6e14b17$var$each(seriesModels, function(seriesModel, idx) {
        boxOffsetList.push(base);
        base += boxGap + boxWidth;
        boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
    });
}
/**
 * Calculate points location for each series.
 */ function $e25d451bb6e14b17$var$layoutSingleSeries(seriesModel, offset, boxWidth) {
    var coordSys = seriesModel.coordinateSystem;
    var data = seriesModel.getData();
    var halfWidth = boxWidth / 2;
    var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
    var vDimIdx = 1 - cDimIdx;
    var coordDims = [
        'x',
        'y'
    ];
    var cDim = data.mapDimension(coordDims[cDimIdx]);
    var vDims = data.mapDimensionsAll(coordDims[vDimIdx]);
    if (cDim == null || vDims.length < 5) return;
    for(var dataIndex = 0; dataIndex < data.count(); dataIndex++){
        var axisDimVal = data.get(cDim, dataIndex);
        var median = getPoint(axisDimVal, vDims[2], dataIndex);
        var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
        var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
        var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
        var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
        var ends = [];
        addBodyEnd(ends, end2, false);
        addBodyEnd(ends, end4, true);
        ends.push(end1, end2, end5, end4);
        layEndLine(ends, end1);
        layEndLine(ends, end5);
        layEndLine(ends, median);
        data.setItemLayout(dataIndex, {
            initBaseline: median[vDimIdx],
            ends: ends
        });
    }
    function getPoint(axisDimVal, dim, dataIndex) {
        var val = data.get(dim, dataIndex);
        var p = [];
        p[cDimIdx] = axisDimVal;
        p[vDimIdx] = val;
        var point;
        if (isNaN(axisDimVal) || isNaN(val)) point = [
            NaN,
            NaN
        ];
        else {
            point = coordSys.dataToPoint(p);
            point[cDimIdx] += offset;
        }
        return point;
    }
    function addBodyEnd(ends, point, start) {
        var point1 = point.slice();
        var point2 = point.slice();
        point1[cDimIdx] += halfWidth;
        point2[cDimIdx] -= halfWidth;
        start ? ends.push(point1, point2) : ends.push(point2, point1);
    }
    function layEndLine(ends, endCenter) {
        var from = endCenter.slice();
        var to = endCenter.slice();
        from[cDimIdx] -= halfWidth;
        to[cDimIdx] += halfWidth;
        ends.push(from, to);
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $181cceb9e51fd6db$export$2e2bcd8739ae039(rawData, opt) {
    opt = opt || {};
    var boxData = [];
    var outliers = [];
    var boundIQR = opt.boundIQR;
    var useExtreme = boundIQR === 'none' || boundIQR === 0;
    for(var i = 0; i < rawData.length; i++){
        var ascList = (0, $9fd90cf3bf18fbcd$export$debe6e778e0a6d32)(rawData[i].slice());
        var Q1 = (0, $9fd90cf3bf18fbcd$export$651fb4afdb6caa4b)(ascList, 0.25);
        var Q2 = (0, $9fd90cf3bf18fbcd$export$651fb4afdb6caa4b)(ascList, 0.5);
        var Q3 = (0, $9fd90cf3bf18fbcd$export$651fb4afdb6caa4b)(ascList, 0.75);
        var min = ascList[0];
        var max = ascList[ascList.length - 1];
        var bound = (boundIQR == null ? 1.5 : boundIQR) * (Q3 - Q1);
        var low = useExtreme ? min : Math.max(min, Q1 - bound);
        var high = useExtreme ? max : Math.min(max, Q3 + bound);
        var itemNameFormatter = opt.itemNameFormatter;
        var itemName = (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(itemNameFormatter) ? itemNameFormatter({
            value: i
        }) : (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(itemNameFormatter) ? itemNameFormatter.replace('{value}', i + '') : i + '';
        boxData.push([
            itemName,
            low,
            Q1,
            Q2,
            Q3,
            high
        ]);
        for(var j = 0; j < ascList.length; j++){
            var dataItem = ascList[j];
            if (dataItem < low || dataItem > high) {
                var outlier = [
                    itemName,
                    dataItem
                ];
                outliers.push(outlier);
            }
        }
    }
    return {
        boxData: boxData,
        outliers: outliers
    };
}




var $cc963dfa272d255b$export$e0915fae26dedefc = {
    type: 'echarts:boxplot',
    transform: function transform(params) {
        var upstream = params.upstream;
        if (upstream.sourceFormat !== (0, $369d2fc585e5938e$export$fcd62ebf51387903)) {
            var errMsg = '';
            (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        }
        var result = (0, $181cceb9e51fd6db$export$2e2bcd8739ae039)(upstream.getRawData(), params.config);
        return [
            {
                dimensions: [
                    'ItemName',
                    'Low',
                    'Q1',
                    'Q2',
                    'Q3',
                    'High'
                ],
                data: result.boxData
            },
            {
                data: result.outliers
            }
        ];
    }
};


function $91cfb17b659a052e$export$4b3e715f166fdd78(registers) {
    registers.registerSeriesModel((0, $944c99a712ebe95c$export$2e2bcd8739ae039));
    registers.registerChartView((0, $689c532301e5d11b$export$2e2bcd8739ae039));
    registers.registerLayout((0, $e25d451bb6e14b17$export$2e2bcd8739ae039));
    registers.registerTransform((0, $cc963dfa272d255b$export$e0915fae26dedefc));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8f507801291ff723$var$positiveBorderColorQuery = [
    'itemStyle',
    'borderColor'
];
var $8f507801291ff723$var$negativeBorderColorQuery = [
    'itemStyle',
    'borderColor0'
];
var $8f507801291ff723$var$dojiBorderColorQuery = [
    'itemStyle',
    'borderColorDoji'
];
var $8f507801291ff723$var$positiveColorQuery = [
    'itemStyle',
    'color'
];
var $8f507801291ff723$var$negativeColorQuery = [
    'itemStyle',
    'color0'
];
function $8f507801291ff723$export$5551a2d24ff40153(sign, model) {
    return model.get(sign > 0 ? $8f507801291ff723$var$positiveColorQuery : $8f507801291ff723$var$negativeColorQuery);
}
function $8f507801291ff723$export$dbc6cfecd630bcea(sign, model) {
    return model.get(sign === 0 ? $8f507801291ff723$var$dojiBorderColorQuery : sign > 0 ? $8f507801291ff723$var$positiveBorderColorQuery : $8f507801291ff723$var$negativeBorderColorQuery);
}
var $8f507801291ff723$var$candlestickVisual = {
    seriesType: 'candlestick',
    plan: (0, $0041f1ab5f0fd789$export$2e2bcd8739ae039)(),
    // For legend.
    performRawSeries: true,
    reset: function(seriesModel, ecModel) {
        // Only visible series has each data be visual encoded
        if (ecModel.isSeriesFiltered(seriesModel)) return;
        var isLargeRender = seriesModel.pipelineContext.large;
        return !isLargeRender && {
            progress: function(params, data) {
                var dataIndex;
                while((dataIndex = params.next()) != null){
                    var itemModel = data.getItemModel(dataIndex);
                    var sign = data.getItemLayout(dataIndex).sign;
                    var style = itemModel.getItemStyle();
                    style.fill = $8f507801291ff723$export$5551a2d24ff40153(sign, itemModel);
                    style.stroke = $8f507801291ff723$export$dbc6cfecd630bcea(sign, itemModel) || style.fill;
                    var existsStyle = data.ensureUniqueItemVisual(dataIndex, 'style');
                    (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(existsStyle, style);
                }
            }
        };
    }
};
var $8f507801291ff723$export$2e2bcd8739ae039 = $8f507801291ff723$var$candlestickVisual;


var $5f26cabb5c27fb76$var$SKIP_PROPS = [
    'color',
    'borderColor'
];
var $5f26cabb5c27fb76$var$CandlestickView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CandlestickView, _super);
    function CandlestickView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickView.type;
        return _this;
    }
    CandlestickView.prototype.render = function(seriesModel, ecModel, api) {
        // If there is clipPath created in large mode. Remove it.
        this.group.removeClipPath();
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this._updateDrawMode(seriesModel);
        this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
    };
    CandlestickView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this._clear();
        this._updateDrawMode(seriesModel);
    };
    CandlestickView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        this._progressiveEls = [];
        this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
    };
    CandlestickView.prototype.eachRendered = function(cb) {
        $8eb95236e1aa01e7$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CandlestickView.prototype._updateDrawMode = function(seriesModel) {
        var isLargeDraw = seriesModel.pipelineContext.large;
        if (this._isLargeDraw == null || isLargeDraw !== this._isLargeDraw) {
            this._isLargeDraw = isLargeDraw;
            this._clear();
        }
    };
    CandlestickView.prototype._renderNormal = function(seriesModel) {
        var data = seriesModel.getData();
        var oldData = this._data;
        var group = this.group;
        var isSimpleBox = data.getLayout('isSimpleBox');
        var needsClip = seriesModel.get('clip', true);
        var coord = seriesModel.coordinateSystem;
        var clipArea = coord.getArea && coord.getArea();
        // There is no old data only when first rendering or switching from
        // stream mode to normal mode, where previous elements should be removed.
        if (!this._data) group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            if (data.hasValue(newIdx)) {
                var itemLayout = data.getItemLayout(newIdx);
                if (needsClip && $5f26cabb5c27fb76$var$isNormalBoxClipped(clipArea, itemLayout)) return;
                var el = $5f26cabb5c27fb76$var$createNormalBox(itemLayout, newIdx, true);
                $b40111164617dd60$export$a121566aadcfe021(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                $5f26cabb5c27fb76$var$setBoxCommon(el, data, newIdx, isSimpleBox);
                group.add(el);
                data.setItemGraphicEl(newIdx, el);
            }
        }).update(function(newIdx, oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            // Empty data
            if (!data.hasValue(newIdx)) {
                group.remove(el);
                return;
            }
            var itemLayout = data.getItemLayout(newIdx);
            if (needsClip && $5f26cabb5c27fb76$var$isNormalBoxClipped(clipArea, itemLayout)) {
                group.remove(el);
                return;
            }
            if (!el) el = $5f26cabb5c27fb76$var$createNormalBox(itemLayout, newIdx);
            else {
                $b40111164617dd60$export$c8dce3c08436e91e(el, {
                    shape: {
                        points: itemLayout.ends
                    }
                }, seriesModel, newIdx);
                (0, $b40111164617dd60$export$bca7290a9faf0ec9)(el);
            }
            $5f26cabb5c27fb76$var$setBoxCommon(el, data, newIdx, isSimpleBox);
            group.add(el);
            data.setItemGraphicEl(newIdx, el);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && group.remove(el);
        }).execute();
        this._data = data;
    };
    CandlestickView.prototype._renderLarge = function(seriesModel) {
        this._clear();
        $5f26cabb5c27fb76$var$createLarge(seriesModel, this.group);
        var clipPath = seriesModel.get('clip', true) ? (0, $6206a29b0d1240e0$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
    };
    CandlestickView.prototype._incrementalRenderNormal = function(params, seriesModel) {
        var data = seriesModel.getData();
        var isSimpleBox = data.getLayout('isSimpleBox');
        var dataIndex;
        while((dataIndex = params.next()) != null){
            var itemLayout = data.getItemLayout(dataIndex);
            var el = $5f26cabb5c27fb76$var$createNormalBox(itemLayout, dataIndex);
            $5f26cabb5c27fb76$var$setBoxCommon(el, data, dataIndex, isSimpleBox);
            el.incremental = true;
            this.group.add(el);
            this._progressiveEls.push(el);
        }
    };
    CandlestickView.prototype._incrementalRenderLarge = function(params, seriesModel) {
        $5f26cabb5c27fb76$var$createLarge(seriesModel, this.group, this._progressiveEls, true);
    };
    CandlestickView.prototype.remove = function(ecModel) {
        this._clear();
    };
    CandlestickView.prototype._clear = function() {
        this.group.removeAll();
        this._data = null;
    };
    CandlestickView.type = 'candlestick';
    return CandlestickView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $5f26cabb5c27fb76$var$NormalBoxPathShape = /** @class */ function() {
    function NormalBoxPathShape() {}
    return NormalBoxPathShape;
}();
var $5f26cabb5c27fb76$var$NormalBoxPath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(NormalBoxPath, _super);
    function NormalBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'normalCandlestickBox';
        return _this;
    }
    NormalBoxPath.prototype.getDefaultShape = function() {
        return new $5f26cabb5c27fb76$var$NormalBoxPathShape();
    };
    NormalBoxPath.prototype.buildPath = function(ctx, shape) {
        var ends = shape.points;
        if (this.__simpleBox) {
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[6][0], ends[6][1]);
        } else {
            ctx.moveTo(ends[0][0], ends[0][1]);
            ctx.lineTo(ends[1][0], ends[1][1]);
            ctx.lineTo(ends[2][0], ends[2][1]);
            ctx.lineTo(ends[3][0], ends[3][1]);
            ctx.closePath();
            ctx.moveTo(ends[4][0], ends[4][1]);
            ctx.lineTo(ends[5][0], ends[5][1]);
            ctx.moveTo(ends[6][0], ends[6][1]);
            ctx.lineTo(ends[7][0], ends[7][1]);
        }
    };
    return NormalBoxPath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
function $5f26cabb5c27fb76$var$createNormalBox(itemLayout, dataIndex, isInit) {
    var ends = itemLayout.ends;
    return new $5f26cabb5c27fb76$var$NormalBoxPath({
        shape: {
            points: isInit ? $5f26cabb5c27fb76$var$transInit(ends, itemLayout) : ends
        },
        z2: 100
    });
}
function $5f26cabb5c27fb76$var$isNormalBoxClipped(clipArea, itemLayout) {
    var clipped = true;
    for(var i = 0; i < itemLayout.ends.length; i++)// If any point are in the region.
    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
        clipped = false;
        break;
    }
    return clipped;
}
function $5f26cabb5c27fb76$var$setBoxCommon(el, data, dataIndex, isSimpleBox) {
    var itemModel = data.getItemModel(dataIndex);
    el.useStyle(data.getItemVisual(dataIndex, 'style'));
    el.style.strokeNoScale = true;
    el.__simpleBox = isSimpleBox;
    (0, $b414df7d361a211c$export$48b68047d330bbc9)(el, itemModel);
    var sign = data.getItemLayout(dataIndex).sign;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(el.states, function(state, stateName) {
        var stateModel = itemModel.getModel(stateName);
        var color = (0, $8f507801291ff723$export$5551a2d24ff40153)(sign, stateModel);
        var borderColor = (0, $8f507801291ff723$export$dbc6cfecd630bcea)(sign, stateModel) || color;
        var stateStyle = state.style || (state.style = {});
        color && (stateStyle.fill = color);
        borderColor && (stateStyle.stroke = borderColor);
    });
    var emphasisModel = itemModel.getModel('emphasis');
    (0, $b414df7d361a211c$export$e51187539ff11209)(el, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
}
function $5f26cabb5c27fb76$var$transInit(points, itemLayout) {
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(points, function(point) {
        point = point.slice();
        point[1] = itemLayout.initBaseline;
        return point;
    });
}
var $5f26cabb5c27fb76$var$LargeBoxPathShape = /** @class */ function() {
    function LargeBoxPathShape() {}
    return LargeBoxPathShape;
}();
var $5f26cabb5c27fb76$var$LargeBoxPath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LargeBoxPath, _super);
    function LargeBoxPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this.type = 'largeCandlestickBox';
        return _this;
    }
    LargeBoxPath.prototype.getDefaultShape = function() {
        return new $5f26cabb5c27fb76$var$LargeBoxPathShape();
    };
    LargeBoxPath.prototype.buildPath = function(ctx, shape) {
        // Drawing lines is more efficient than drawing
        // a whole line or drawing rects.
        var points = shape.points;
        for(var i = 0; i < points.length;)if (this.__sign === points[i++]) {
            var x = points[i++];
            ctx.moveTo(x, points[i++]);
            ctx.lineTo(x, points[i++]);
        } else i += 3;
    };
    return LargeBoxPath;
}((0, $f9698154c9fcf427$export$2e2bcd8739ae039));
function $5f26cabb5c27fb76$var$createLarge(seriesModel, group, progressiveEls, incremental) {
    var data = seriesModel.getData();
    var largePoints = data.getLayout('largePoints');
    var elP = new $5f26cabb5c27fb76$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 1,
        ignoreCoarsePointer: true
    });
    group.add(elP);
    var elN = new $5f26cabb5c27fb76$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: -1,
        ignoreCoarsePointer: true
    });
    group.add(elN);
    var elDoji = new $5f26cabb5c27fb76$var$LargeBoxPath({
        shape: {
            points: largePoints
        },
        __sign: 0,
        ignoreCoarsePointer: true
    });
    group.add(elDoji);
    $5f26cabb5c27fb76$var$setLargeStyle(1, elP, seriesModel, data);
    $5f26cabb5c27fb76$var$setLargeStyle(-1, elN, seriesModel, data);
    $5f26cabb5c27fb76$var$setLargeStyle(0, elDoji, seriesModel, data);
    if (incremental) {
        elP.incremental = true;
        elN.incremental = true;
    }
    if (progressiveEls) progressiveEls.push(elP, elN);
}
function $5f26cabb5c27fb76$var$setLargeStyle(sign, el, seriesModel, data) {
    // TODO put in visual?
    var borderColor = (0, $8f507801291ff723$export$dbc6cfecd630bcea)(sign, seriesModel) || (0, $8f507801291ff723$export$5551a2d24ff40153)(sign, seriesModel);
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var itemStyle = seriesModel.getModel('itemStyle').getItemStyle($5f26cabb5c27fb76$var$SKIP_PROPS);
    el.useStyle(itemStyle);
    el.style.fill = null;
    el.style.stroke = borderColor;
}
var $5f26cabb5c27fb76$export$2e2bcd8739ae039 = $5f26cabb5c27fb76$var$CandlestickView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $07c2d27f28bde28c$var$CandlestickSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CandlestickSeriesModel, _super);
    function CandlestickSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CandlestickSeriesModel.type;
        _this.defaultValueDimensions = [
            {
                name: 'open',
                defaultTooltip: true
            },
            {
                name: 'close',
                defaultTooltip: true
            },
            {
                name: 'lowest',
                defaultTooltip: true
            },
            {
                name: 'highest',
                defaultTooltip: true
            }
        ];
        return _this;
    }
    /**
   * Get dimension for shadow in dataZoom
   * @return dimension name
   */ CandlestickSeriesModel.prototype.getShadowDim = function() {
        return 'open';
    };
    CandlestickSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        var itemLayout = data.getItemLayout(dataIndex);
        return itemLayout && selectors.rect(itemLayout.brushRect);
    };
    CandlestickSeriesModel.type = 'series.candlestick';
    CandlestickSeriesModel.dependencies = [
        'xAxis',
        'yAxis',
        'grid'
    ];
    CandlestickSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        coordinateSystem: 'cartesian2d',
        legendHoverLink: true,
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        layout: null,
        clip: true,
        itemStyle: {
            color: '#eb5454',
            color0: '#47b262',
            borderColor: '#eb5454',
            borderColor0: '#47b262',
            borderColorDoji: null,
            // borderColor: '#d24040',
            // borderColor0: '#398f4f',
            borderWidth: 1
        },
        emphasis: {
            itemStyle: {
                borderWidth: 2
            }
        },
        barMaxWidth: null,
        barMinWidth: null,
        barWidth: null,
        large: true,
        largeThreshold: 600,
        progressive: 3e3,
        progressiveThreshold: 1e4,
        progressiveChunkMode: 'mod',
        animationEasing: 'linear',
        animationDuration: 300
    };
    return CandlestickSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($07c2d27f28bde28c$var$CandlestickSeriesModel, (0, $25873f74d3daa041$export$ccfed902f8630510), true);
var $07c2d27f28bde28c$export$2e2bcd8739ae039 = $07c2d27f28bde28c$var$CandlestickSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $0e8677cfa58be740$export$2e2bcd8739ae039(option) {
    if (!option || !$1b239fc9d3a2f8ae$export$43bee75e5e14138e(option.series)) return;
    // Translate 'k' to 'candlestick'.
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(option.series, function(seriesItem) {
        if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(seriesItem) && seriesItem.type === 'k') seriesItem.type = 'candlestick';
    });
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f4e105e0d014f6e6$var$candlestickLayout = {
    seriesType: 'candlestick',
    plan: (0, $0041f1ab5f0fd789$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var data = seriesModel.getData();
        var candleWidth = $f4e105e0d014f6e6$var$calculateCandleWidth(seriesModel, data);
        var cDimIdx = 0;
        var vDimIdx = 1;
        var coordDims = [
            'x',
            'y'
        ];
        var cDimI = data.getDimensionIndex(data.mapDimension(coordDims[cDimIdx]));
        var vDimsI = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(data.mapDimensionsAll(coordDims[vDimIdx]), data.getDimensionIndex, data);
        var openDimI = vDimsI[0];
        var closeDimI = vDimsI[1];
        var lowestDimI = vDimsI[2];
        var highestDimI = vDimsI[3];
        data.setLayout({
            candleWidth: candleWidth,
            // The value is experimented visually.
            isSimpleBox: candleWidth <= 1.3
        });
        if (cDimI < 0 || vDimsI.length < 4) return;
        return {
            progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
        };
        function normalProgress(params, data) {
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                var ocLow = Math.min(openVal, closeVal);
                var ocHigh = Math.max(openVal, closeVal);
                var ocLowPoint = getPoint(ocLow, axisDimVal);
                var ocHighPoint = getPoint(ocHigh, axisDimVal);
                var lowestPoint = getPoint(lowestVal, axisDimVal);
                var highestPoint = getPoint(highestVal, axisDimVal);
                var ends = [];
                addBodyEnd(ends, ocHighPoint, 0);
                addBodyEnd(ends, ocLowPoint, 1);
                ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
                var itemModel = data.getItemModel(dataIndex);
                var hasDojiColor = !!itemModel.get([
                    'itemStyle',
                    'borderColorDoji'
                ]);
                data.setItemLayout(dataIndex, {
                    sign: $f4e105e0d014f6e6$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor),
                    initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
                    ends: ends,
                    brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
                });
            }
            function getPoint(val, axisDimVal) {
                var p = [];
                p[cDimIdx] = axisDimVal;
                p[vDimIdx] = val;
                return isNaN(axisDimVal) || isNaN(val) ? [
                    NaN,
                    NaN
                ] : coordSys.dataToPoint(p);
            }
            function addBodyEnd(ends, point, start) {
                var point1 = point.slice();
                var point2 = point.slice();
                point1[cDimIdx] = (0, $8eb95236e1aa01e7$export$72c4fd4c1b8fcb10)(point1[cDimIdx] + candleWidth / 2, 1, false);
                point2[cDimIdx] = (0, $8eb95236e1aa01e7$export$72c4fd4c1b8fcb10)(point2[cDimIdx] - candleWidth / 2, 1, true);
                start ? ends.push(point1, point2) : ends.push(point2, point1);
            }
            function makeBrushRect(lowestVal, highestVal, axisDimVal) {
                var pmin = getPoint(lowestVal, axisDimVal);
                var pmax = getPoint(highestVal, axisDimVal);
                pmin[cDimIdx] -= candleWidth / 2;
                pmax[cDimIdx] -= candleWidth / 2;
                return {
                    x: pmin[0],
                    y: pmin[1],
                    width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
                    height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
                };
            }
            function subPixelOptimizePoint(point) {
                point[cDimIdx] = (0, $8eb95236e1aa01e7$export$72c4fd4c1b8fcb10)(point[cDimIdx], 1);
                return point;
            }
        }
        function largeProgress(params, data) {
            // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
            var points = (0, $015cdaafd8b34e25$export$21d2298f3f56bbaf)(params.count * 4);
            var offset = 0;
            var point;
            var tmpIn = [];
            var tmpOut = [];
            var dataIndex;
            var store = data.getStore();
            var hasDojiColor = !!seriesModel.get([
                'itemStyle',
                'borderColorDoji'
            ]);
            while((dataIndex = params.next()) != null){
                var axisDimVal = store.get(cDimI, dataIndex);
                var openVal = store.get(openDimI, dataIndex);
                var closeVal = store.get(closeDimI, dataIndex);
                var lowestVal = store.get(lowestDimI, dataIndex);
                var highestVal = store.get(highestDimI, dataIndex);
                if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
                    points[offset++] = NaN;
                    offset += 3;
                    continue;
                }
                points[offset++] = $f4e105e0d014f6e6$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor);
                tmpIn[cDimIdx] = axisDimVal;
                tmpIn[vDimIdx] = lowestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[0] : NaN;
                points[offset++] = point ? point[1] : NaN;
                tmpIn[vDimIdx] = highestVal;
                point = coordSys.dataToPoint(tmpIn, null, tmpOut);
                points[offset++] = point ? point[1] : NaN;
            }
            data.setLayout('largePoints', points);
        }
    }
};
/**
 * Get the sign of a single data.
 *
 * @returns 0 for doji with hasDojiColor: true,
 *          1 for positive,
 *          -1 for negative.
 */ function $f4e105e0d014f6e6$var$getSign(store, dataIndex, openVal, closeVal, closeDimI, hasDojiColor) {
    var sign;
    if (openVal > closeVal) sign = -1;
    else if (openVal < closeVal) sign = 1;
    else sign = hasDojiColor ? 0 : dataIndex > 0 ? store.get(closeDimI, dataIndex - 1) <= closeVal ? 1 : -1 : 1;
    return sign;
}
function $f4e105e0d014f6e6$var$calculateCandleWidth(seriesModel, data) {
    var baseAxis = seriesModel.getBaseAxis();
    var extent;
    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
    var barMaxWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)((0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
    var barMinWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)((0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(seriesModel.get('barMinWidth'), 1), bandWidth);
    var barWidth = seriesModel.get('barWidth');
    return barWidth != null ? (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(barWidth, bandWidth) : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
}
var $f4e105e0d014f6e6$export$2e2bcd8739ae039 = $f4e105e0d014f6e6$var$candlestickLayout;


function $1fdfdcf3811ef3f5$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $5f26cabb5c27fb76$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $07c2d27f28bde28c$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $0e8677cfa58be740$export$2e2bcd8739ae039));
    registers.registerVisual((0, $8f507801291ff723$export$2e2bcd8739ae039));
    registers.registerLayout((0, $f4e105e0d014f6e6$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $38a3bc365f250ad9$var$updateRipplePath(rippleGroup, effectCfg) {
    var color = effectCfg.rippleEffectColor || effectCfg.color;
    rippleGroup.eachChild(function(ripplePath) {
        ripplePath.attr({
            z: effectCfg.z,
            zlevel: effectCfg.zlevel,
            style: {
                stroke: effectCfg.brushType === 'stroke' ? color : null,
                fill: effectCfg.brushType === 'fill' ? color : null
            }
        });
    });
}
var $38a3bc365f250ad9$var$EffectSymbol = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(EffectSymbol, _super);
    function EffectSymbol(data, idx) {
        var _this = _super.call(this) || this;
        var symbol = new (0, $6864622a33ae23ca$export$2e2bcd8739ae039)(data, idx);
        var rippleGroup = new (0, $6c313c3ef6000a43$export$2e2bcd8739ae039)();
        _this.add(symbol);
        _this.add(rippleGroup);
        _this.updateData(data, idx);
        return _this;
    }
    EffectSymbol.prototype.stopEffectAnimation = function() {
        this.childAt(1).removeAll();
    };
    EffectSymbol.prototype.startEffectAnimation = function(effectCfg) {
        var symbolType = effectCfg.symbolType;
        var color = effectCfg.color;
        var rippleNumber = effectCfg.rippleNumber;
        var rippleGroup = this.childAt(1);
        for(var i = 0; i < rippleNumber; i++){
            // If width/height are set too small (e.g., set to 1) on ios10
            // and macOS Sierra, a circle stroke become a rect, no matter what
            // the scale is set. So we set width/height as 2. See #4136.
            var ripplePath = (0, $da6220012439db7b$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
            ripplePath.attr({
                style: {
                    strokeNoScale: true
                },
                z2: 99,
                silent: true,
                scaleX: 0.5,
                scaleY: 0.5
            });
            var delay = -i / rippleNumber * effectCfg.period + effectCfg.effectOffset;
            ripplePath.animate('', true).when(effectCfg.period, {
                scaleX: effectCfg.rippleScale / 2,
                scaleY: effectCfg.rippleScale / 2
            }).delay(delay).start();
            ripplePath.animateStyle(true).when(effectCfg.period, {
                opacity: 0
            }).delay(delay).start();
            rippleGroup.add(ripplePath);
        }
        $38a3bc365f250ad9$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Update effect symbol
   */ EffectSymbol.prototype.updateEffectAnimation = function(effectCfg) {
        var oldEffectCfg = this._effectCfg;
        var rippleGroup = this.childAt(1);
        // Must reinitialize effect if following configuration changed
        var DIFFICULT_PROPS = [
            'symbolType',
            'period',
            'rippleScale',
            'rippleNumber'
        ];
        for(var i = 0; i < DIFFICULT_PROPS.length; i++){
            var propName = DIFFICULT_PROPS[i];
            if (oldEffectCfg[propName] !== effectCfg[propName]) {
                this.stopEffectAnimation();
                this.startEffectAnimation(effectCfg);
                return;
            }
        }
        $38a3bc365f250ad9$var$updateRipplePath(rippleGroup, effectCfg);
    };
    /**
   * Highlight symbol
   */ EffectSymbol.prototype.highlight = function() {
        (0, $b414df7d361a211c$export$b2d02638cc34c042)(this);
    };
    /**
   * Downplay symbol
   */ EffectSymbol.prototype.downplay = function() {
        (0, $b414df7d361a211c$export$11be6f716239ac55)(this);
    };
    EffectSymbol.prototype.getSymbolType = function() {
        var symbol = this.childAt(0);
        return symbol && symbol.getSymbolType();
    };
    /**
   * Update symbol properties
   */ EffectSymbol.prototype.updateData = function(data, idx) {
        var _this = this;
        var seriesModel = data.hostModel;
        this.childAt(0).updateData(data, idx);
        var rippleGroup = this.childAt(1);
        var itemModel = data.getItemModel(idx);
        var symbolType = data.getItemVisual(idx, 'symbol');
        var symbolSize = (0, $da6220012439db7b$export$a84524f03e8e8dfb)(data.getItemVisual(idx, 'symbolSize'));
        var symbolStyle = data.getItemVisual(idx, 'style');
        var color = symbolStyle && symbolStyle.fill;
        var emphasisModel = itemModel.getModel('emphasis');
        rippleGroup.setScale(symbolSize);
        rippleGroup.traverse(function(ripplePath) {
            ripplePath.setStyle('fill', color);
        });
        var symbolOffset = (0, $da6220012439db7b$export$e3e292895c033f6d)(data.getItemVisual(idx, 'symbolOffset'), symbolSize);
        if (symbolOffset) {
            rippleGroup.x = symbolOffset[0];
            rippleGroup.y = symbolOffset[1];
        }
        var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
        rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
        var effectCfg = {};
        effectCfg.showEffectOn = seriesModel.get('showEffectOn');
        effectCfg.rippleScale = itemModel.get([
            'rippleEffect',
            'scale'
        ]);
        effectCfg.brushType = itemModel.get([
            'rippleEffect',
            'brushType'
        ]);
        effectCfg.period = itemModel.get([
            'rippleEffect',
            'period'
        ]) * 1000;
        effectCfg.effectOffset = idx / data.count();
        effectCfg.z = seriesModel.getShallow('z') || 0;
        effectCfg.zlevel = seriesModel.getShallow('zlevel') || 0;
        effectCfg.symbolType = symbolType;
        effectCfg.color = color;
        effectCfg.rippleEffectColor = itemModel.get([
            'rippleEffect',
            'color'
        ]);
        effectCfg.rippleNumber = itemModel.get([
            'rippleEffect',
            'number'
        ]);
        if (effectCfg.showEffectOn === 'render') {
            this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
            this._effectCfg = effectCfg;
        } else {
            // Not keep old effect config
            this._effectCfg = null;
            this.stopEffectAnimation();
            this.onHoverStateChange = function(toState) {
                if (toState === 'emphasis') {
                    if (effectCfg.showEffectOn !== 'render') _this.startEffectAnimation(effectCfg);
                } else if (toState === 'normal') {
                    if (effectCfg.showEffectOn !== 'render') _this.stopEffectAnimation();
                }
            };
        }
        this._effectCfg = effectCfg;
        (0, $b414df7d361a211c$export$e51187539ff11209)(this, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    EffectSymbol.prototype.fadeOut = function(cb) {
        cb && cb();
    };
    return EffectSymbol;
}((0, $6c313c3ef6000a43$export$2e2bcd8739ae039));
var $38a3bc365f250ad9$export$2e2bcd8739ae039 = $38a3bc365f250ad9$var$EffectSymbol;





var $539ec10db25962f6$var$EffectScatterView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(EffectScatterView, _super);
    function EffectScatterView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterView.type;
        return _this;
    }
    EffectScatterView.prototype.init = function() {
        this._symbolDraw = new (0, $89a14c17b9971b0f$export$2e2bcd8739ae039)((0, $38a3bc365f250ad9$export$2e2bcd8739ae039));
    };
    EffectScatterView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var effectSymbolDraw = this._symbolDraw;
        effectSymbolDraw.updateData(data, {
            clipShape: this._getClipShape(seriesModel)
        });
        this.group.add(effectSymbolDraw.group);
    };
    EffectScatterView.prototype._getClipShape = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
        return seriesModel.get('clip', true) ? clipArea : null;
    };
    EffectScatterView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        this.group.dirty();
        var res = (0, $264cfd4c63b95c0a$export$2e2bcd8739ae039)('').reset(seriesModel, ecModel, api);
        if (res.progress) res.progress({
            start: 0,
            end: data.count(),
            count: data.count()
        }, data);
        this._symbolDraw.updateLayout();
    };
    EffectScatterView.prototype._updateGroupTransform = function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && coordSys.getRoamTransform) {
            this.group.transform = $78537c687449356c$export$9cd59f9826255e47(coordSys.getRoamTransform());
            this.group.decomposeTransform();
        }
    };
    EffectScatterView.prototype.remove = function(ecModel, api) {
        this._symbolDraw && this._symbolDraw.remove(true);
    };
    EffectScatterView.type = 'effectScatter';
    return EffectScatterView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $539ec10db25962f6$export$2e2bcd8739ae039 = $539ec10db25962f6$var$EffectScatterView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $c7b2901ed0113ef5$var$EffectScatterSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(EffectScatterSeriesModel, _super);
    function EffectScatterSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = EffectScatterSeriesModel.type;
        _this.hasSymbolVisual = true;
        return _this;
    }
    EffectScatterSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this, {
            useEncodeDefaulter: true
        });
    };
    EffectScatterSeriesModel.prototype.brushSelector = function(dataIndex, data, selectors) {
        return selectors.point(data.getItemLayout(dataIndex));
    };
    EffectScatterSeriesModel.type = 'series.effectScatter';
    EffectScatterSeriesModel.dependencies = [
        'grid',
        'polar'
    ];
    EffectScatterSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        effectType: 'ripple',
        progressive: 0,
        // When to show the effect, option: 'render'|'emphasis'
        showEffectOn: 'render',
        clip: true,
        // Ripple effect config
        rippleEffect: {
            period: 4,
            // Scale of ripple
            scale: 2.5,
            // Brush type can be fill or stroke
            brushType: 'fill',
            // Ripple number
            number: 3
        },
        universalTransition: {
            divideShape: 'clone'
        },
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Polar coordinate system
        // polarIndex: 0,
        // Geo coordinate system
        // geoIndex: 0,
        // symbol: null,        // 图形类型
        symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
    };
    return EffectScatterSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $c7b2901ed0113ef5$export$2e2bcd8739ae039 = $c7b2901ed0113ef5$var$EffectScatterSeriesModel;



function $d149b2646419b32d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $539ec10db25962f6$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $c7b2901ed0113ef5$export$2e2bcd8739ae039));
    registers.registerLayout((0, $264cfd4c63b95c0a$export$2e2bcd8739ae039)('effectScatter'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $d2c0d32a85b569aa$var$EffectLine = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(EffectLine, _super);
    function EffectLine(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this.add(_this.createLine(lineData, idx, seriesScope));
        _this._updateEffectSymbol(lineData, idx);
        return _this;
    }
    EffectLine.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $7c246668238b1397$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    EffectLine.prototype._updateEffectSymbol = function(lineData, idx) {
        var itemModel = lineData.getItemModel(idx);
        var effectModel = itemModel.getModel('effect');
        var size = effectModel.get('symbolSize');
        var symbolType = effectModel.get('symbol');
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(size)) size = [
            size,
            size
        ];
        var lineStyle = lineData.getItemVisual(idx, 'style');
        var color = effectModel.get('color') || lineStyle && lineStyle.stroke;
        var symbol = this.childAt(1);
        if (this._symbolType !== symbolType) {
            // Remove previous
            this.remove(symbol);
            symbol = (0, $da6220012439db7b$export$af050e04da3a02e8)(symbolType, -0.5, -0.5, 1, 1, color);
            symbol.z2 = 100;
            symbol.culling = true;
            this.add(symbol);
        }
        // Symbol may be removed if loop is false
        if (!symbol) return;
        // Shadow color is same with color in default
        symbol.setStyle('shadowColor', color);
        symbol.setStyle(effectModel.getItemStyle([
            'color'
        ]));
        symbol.scaleX = size[0];
        symbol.scaleY = size[1];
        symbol.setColor(color);
        this._symbolType = symbolType;
        this._symbolScale = size;
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    EffectLine.prototype._updateEffectAnimation = function(lineData, effectModel, idx) {
        var symbol = this.childAt(1);
        if (!symbol) return;
        var points = lineData.getItemLayout(idx);
        var period = effectModel.get('period') * 1000;
        var loop = effectModel.get('loop');
        var roundTrip = effectModel.get('roundTrip');
        var constantSpeed = effectModel.get('constantSpeed');
        var delayExpr = $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66(effectModel.get('delay'), function(idx) {
            return idx / lineData.count() * period / 3;
        });
        // Ignore when updating
        symbol.ignore = true;
        this._updateAnimationPoints(symbol, points);
        if (constantSpeed > 0) period = this._getLineLength(symbol) / constantSpeed * 1000;
        if (period !== this._period || loop !== this._loop || roundTrip !== this._roundTrip) {
            symbol.stopAnimation();
            var delayNum = void 0;
            if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(delayExpr)) delayNum = delayExpr(idx);
            else delayNum = delayExpr;
            if (symbol.__t > 0) delayNum = -period * symbol.__t;
            this._animateSymbol(symbol, period, delayNum, loop, roundTrip);
        }
        this._period = period;
        this._loop = loop;
        this._roundTrip = roundTrip;
    };
    EffectLine.prototype._animateSymbol = function(symbol, period, delayNum, loop, roundTrip) {
        if (period > 0) {
            symbol.__t = 0;
            var self_1 = this;
            var animator = symbol.animate('', loop).when(roundTrip ? period * 2 : period, {
                __t: roundTrip ? 2 : 1
            }).delay(delayNum).during(function() {
                self_1._updateSymbolPosition(symbol);
            });
            if (!loop) animator.done(function() {
                self_1.remove(symbol);
            });
            animator.start();
        }
    };
    EffectLine.prototype._getLineLength = function(symbol) {
        // Not so accurate
        return $3dde7d051fe20daa$export$6c4a311cc157c764(symbol.__p1, symbol.__cp1) + $3dde7d051fe20daa$export$6c4a311cc157c764(symbol.__cp1, symbol.__p2);
    };
    EffectLine.prototype._updateAnimationPoints = function(symbol, points) {
        symbol.__p1 = points[0];
        symbol.__p2 = points[1];
        symbol.__cp1 = points[2] || [
            (points[0][0] + points[1][0]) / 2,
            (points[0][1] + points[1][1]) / 2
        ];
    };
    EffectLine.prototype.updateData = function(lineData, idx, seriesScope) {
        this.childAt(0).updateData(lineData, idx, seriesScope);
        this._updateEffectSymbol(lineData, idx);
    };
    EffectLine.prototype._updateSymbolPosition = function(symbol) {
        var p1 = symbol.__p1;
        var p2 = symbol.__p2;
        var cp1 = symbol.__cp1;
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var pos = [
            symbol.x,
            symbol.y
        ];
        var lastPos = pos.slice();
        var quadraticAt = $eea9463646207a7b$export$af17094a950f5073;
        var quadraticDerivativeAt = $eea9463646207a7b$export$7e161e77e6fff8cb;
        pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
        pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t);
        // Tangent
        var tx = symbol.__t < 1 ? quadraticDerivativeAt(p1[0], cp1[0], p2[0], t) : quadraticDerivativeAt(p2[0], cp1[0], p1[0], 1 - t);
        var ty = symbol.__t < 1 ? quadraticDerivativeAt(p1[1], cp1[1], p2[1], t) : quadraticDerivativeAt(p2[1], cp1[1], p1[1], 1 - t);
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
        if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
            if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
                symbol.scaleY = $3dde7d051fe20daa$export$6c4a311cc157c764(lastPos, pos) * 1.05;
                // make sure the last segment render within endPoint
                if (t === 1) {
                    pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
                    pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
                }
            } else if (symbol.__lastT === 1) // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
            symbol.scaleY = 2 * $3dde7d051fe20daa$export$6c4a311cc157c764(p1, pos);
            else symbol.scaleY = this._symbolScale[1];
        }
        symbol.__lastT = symbol.__t;
        symbol.ignore = false;
        symbol.x = pos[0];
        symbol.y = pos[1];
    };
    EffectLine.prototype.updateLayout = function(lineData, idx) {
        this.childAt(0).updateLayout(lineData, idx);
        var effectModel = lineData.getItemModel(idx).getModel('effect');
        this._updateEffectAnimation(lineData, effectModel, idx);
    };
    return EffectLine;
}($6c313c3ef6000a43$export$2e2bcd8739ae039);
var $d2c0d32a85b569aa$export$2e2bcd8739ae039 = $d2c0d32a85b569aa$var$EffectLine;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $71a7991440409a76$var$Polyline = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(Polyline, _super);
    function Polyline(lineData, idx, seriesScope) {
        var _this = _super.call(this) || this;
        _this._createPolyline(lineData, idx, seriesScope);
        return _this;
    }
    Polyline.prototype._createPolyline = function(lineData, idx, seriesScope) {
        // let seriesModel = lineData.hostModel;
        var points = lineData.getItemLayout(idx);
        var line = new $f7f6523750aec7c8$export$2e2bcd8739ae039({
            shape: {
                points: points
            }
        });
        this.add(line);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype.updateData = function(lineData, idx, seriesScope) {
        var seriesModel = lineData.hostModel;
        var line = this.childAt(0);
        var target = {
            shape: {
                points: lineData.getItemLayout(idx)
            }
        };
        $b40111164617dd60$export$c8dce3c08436e91e(line, target, seriesModel, idx);
        this._updateCommonStl(lineData, idx, seriesScope);
    };
    Polyline.prototype._updateCommonStl = function(lineData, idx, seriesScope) {
        var line = this.childAt(0);
        var itemModel = lineData.getItemModel(idx);
        var emphasisLineStyle = seriesScope && seriesScope.emphasisLineStyle;
        var focus = seriesScope && seriesScope.focus;
        var blurScope = seriesScope && seriesScope.blurScope;
        var emphasisDisabled = seriesScope && seriesScope.emphasisDisabled;
        if (!seriesScope || lineData.hasItemOption) {
            var emphasisModel = itemModel.getModel('emphasis');
            emphasisLineStyle = emphasisModel.getModel('lineStyle').getLineStyle();
            emphasisDisabled = emphasisModel.get('disabled');
            focus = emphasisModel.get('focus');
            blurScope = emphasisModel.get('blurScope');
        }
        line.useStyle(lineData.getItemVisual(idx, 'style'));
        line.style.fill = null;
        line.style.strokeNoScale = true;
        var lineEmphasisState = line.ensureState('emphasis');
        lineEmphasisState.style = emphasisLineStyle;
        (0, $b414df7d361a211c$export$e51187539ff11209)(this, focus, blurScope, emphasisDisabled);
    };
    Polyline.prototype.updateLayout = function(lineData, idx) {
        var polyline = this.childAt(0);
        polyline.setShape('points', lineData.getItemLayout(idx));
    };
    return Polyline;
}($6c313c3ef6000a43$export$2e2bcd8739ae039);
var $71a7991440409a76$export$2e2bcd8739ae039 = $71a7991440409a76$var$Polyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $a58d95a46b020034$var$EffectPolyline = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(EffectPolyline, _super);
    function EffectPolyline() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._lastFrame = 0;
        _this._lastFramePercent = 0;
        return _this;
    }
    // Override
    EffectPolyline.prototype.createLine = function(lineData, idx, seriesScope) {
        return new (0, $71a7991440409a76$export$2e2bcd8739ae039)(lineData, idx, seriesScope);
    };
    // Override
    EffectPolyline.prototype._updateAnimationPoints = function(symbol, points) {
        this._points = points;
        var accLenArr = [
            0
        ];
        var len = 0;
        for(var i = 1; i < points.length; i++){
            var p1 = points[i - 1];
            var p2 = points[i];
            len += $3dde7d051fe20daa$export$6c4a311cc157c764(p1, p2);
            accLenArr.push(len);
        }
        if (len === 0) {
            this._length = 0;
            return;
        }
        for(var i = 0; i < accLenArr.length; i++)accLenArr[i] /= len;
        this._offsets = accLenArr;
        this._length = len;
    };
    // Override
    EffectPolyline.prototype._getLineLength = function() {
        return this._length;
    };
    // Override
    EffectPolyline.prototype._updateSymbolPosition = function(symbol) {
        var t = symbol.__t < 1 ? symbol.__t : 2 - symbol.__t;
        var points = this._points;
        var offsets = this._offsets;
        var len = points.length;
        if (!offsets) // Has length 0
        return;
        var lastFrame = this._lastFrame;
        var frame;
        if (t < this._lastFramePercent) {
            // Start from the next frame
            // PENDING start from lastFrame ?
            var start = Math.min(lastFrame + 1, len - 1);
            for(frame = start; frame >= 0; frame--){
                if (offsets[frame] <= t) break;
            }
            // PENDING really need to do this ?
            frame = Math.min(frame, len - 2);
        } else {
            for(frame = lastFrame; frame < len; frame++){
                if (offsets[frame] > t) break;
            }
            frame = Math.min(frame - 1, len - 2);
        }
        var p = (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]);
        var p0 = points[frame];
        var p1 = points[frame + 1];
        symbol.x = p0[0] * (1 - p) + p * p1[0];
        symbol.y = p0[1] * (1 - p) + p * p1[1];
        var tx = symbol.__t < 1 ? p1[0] - p0[0] : p0[0] - p1[0];
        var ty = symbol.__t < 1 ? p1[1] - p0[1] : p0[1] - p1[1];
        symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
        this._lastFrame = frame;
        this._lastFramePercent = t;
        symbol.ignore = false;
    };
    return EffectPolyline;
}((0, $d2c0d32a85b569aa$export$2e2bcd8739ae039));
var $a58d95a46b020034$export$2e2bcd8739ae039 = $a58d95a46b020034$var$EffectPolyline;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $230d1550e84d99ee$var$LargeLinesPathShape = /** @class */ function() {
    function LargeLinesPathShape() {
        this.polyline = false;
        this.curveness = 0;
        this.segs = [];
    }
    return LargeLinesPathShape;
}();
var $230d1550e84d99ee$var$LargeLinesPath = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LargeLinesPath, _super);
    function LargeLinesPath(opts) {
        var _this = _super.call(this, opts) || this;
        _this._off = 0;
        _this.hoverDataIdx = -1;
        return _this;
    }
    LargeLinesPath.prototype.reset = function() {
        this.notClear = false;
        this._off = 0;
    };
    LargeLinesPath.prototype.getDefaultStyle = function() {
        return {
            stroke: '#000',
            fill: null
        };
    };
    LargeLinesPath.prototype.getDefaultShape = function() {
        return new $230d1550e84d99ee$var$LargeLinesPathShape();
    };
    LargeLinesPath.prototype.buildPath = function(ctx, shape) {
        var segs = shape.segs;
        var curveness = shape.curveness;
        var i;
        if (shape.polyline) for(i = this._off; i < segs.length;){
            var count = segs[i++];
            if (count > 0) {
                ctx.moveTo(segs[i++], segs[i++]);
                for(var k = 1; k < count; k++)ctx.lineTo(segs[i++], segs[i++]);
            }
        }
        else for(i = this._off; i < segs.length;){
            var x0 = segs[i++];
            var y0 = segs[i++];
            var x1 = segs[i++];
            var y1 = segs[i++];
            ctx.moveTo(x0, y0);
            if (curveness > 0) {
                var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                ctx.quadraticCurveTo(x2, y2, x1, y1);
            } else ctx.lineTo(x1, y1);
        }
        if (this.incremental) {
            this._off = i;
            this.notClear = true;
        }
    };
    LargeLinesPath.prototype.findDataIndex = function(x, y) {
        var shape = this.shape;
        var segs = shape.segs;
        var curveness = shape.curveness;
        var lineWidth = this.style.lineWidth;
        if (shape.polyline) {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var count = segs[i++];
                if (count > 0) {
                    var x0 = segs[i++];
                    var y0 = segs[i++];
                    for(var k = 1; k < count; k++){
                        var x1 = segs[i++];
                        var y1 = segs[i++];
                        if ($aca25f357ba197a3$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                    }
                }
                dataIndex++;
            }
        } else {
            var dataIndex = 0;
            for(var i = 0; i < segs.length;){
                var x0 = segs[i++];
                var y0 = segs[i++];
                var x1 = segs[i++];
                var y1 = segs[i++];
                if (curveness > 0) {
                    var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
                    var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
                    if ($8b785c696f02cfdb$export$8d36b1b5d19157c5(x0, y0, x2, y2, x1, y1, lineWidth, x, y)) return dataIndex;
                } else {
                    if ($aca25f357ba197a3$export$8d36b1b5d19157c5(x0, y0, x1, y1, lineWidth, x, y)) return dataIndex;
                }
                dataIndex++;
            }
        }
        return -1;
    };
    LargeLinesPath.prototype.contain = function(x, y) {
        var localPos = this.transformCoordToLocal(x, y);
        var rect = this.getBoundingRect();
        x = localPos[0];
        y = localPos[1];
        if (rect.contain(x, y)) {
            // Cache found data index.
            var dataIdx = this.hoverDataIdx = this.findDataIndex(x, y);
            return dataIdx >= 0;
        }
        this.hoverDataIdx = -1;
        return false;
    };
    LargeLinesPath.prototype.getBoundingRect = function() {
        // Ignore stroke for large symbol draw.
        var rect = this._rect;
        if (!rect) {
            var shape = this.shape;
            var points = shape.segs;
            var minX = Infinity;
            var minY = Infinity;
            var maxX = -Infinity;
            var maxY = -Infinity;
            for(var i = 0; i < points.length;){
                var x = points[i++];
                var y = points[i++];
                minX = Math.min(x, minX);
                maxX = Math.max(x, maxX);
                minY = Math.min(y, minY);
                maxY = Math.max(y, maxY);
            }
            rect = this._rect = new $020465b49a1dd45f$export$2e2bcd8739ae039(minX, minY, maxX, maxY);
        }
        return rect;
    };
    return LargeLinesPath;
}($f9698154c9fcf427$export$2e2bcd8739ae039);
var $230d1550e84d99ee$var$LargeLineDraw = /** @class */ function() {
    function LargeLineDraw() {
        this.group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
    }
    /**
   * Update symbols draw by new data
   */ LargeLineDraw.prototype.updateData = function(data) {
        this._clear();
        var lineEl = this._create();
        lineEl.setShape({
            segs: data.getLayout('linesPoints')
        });
        this._setCommon(lineEl, data);
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalPrepareUpdate = function(data) {
        this.group.removeAll();
        this._clear();
    };
    /**
   * @override
   */ LargeLineDraw.prototype.incrementalUpdate = function(taskParams, data) {
        var lastAdded = this._newAdded[0];
        var linePoints = data.getLayout('linesPoints');
        var oldSegs = lastAdded && lastAdded.shape.segs;
        // Merging the exists. Each element has 1e4 points.
        // Consider the performance balance between too much elements and too much points in one shape(may affect hover optimization)
        if (oldSegs && oldSegs.length < 2e4) {
            var oldLen = oldSegs.length;
            var newSegs = new Float32Array(oldLen + linePoints.length);
            // Concat two array
            newSegs.set(oldSegs);
            newSegs.set(linePoints, oldLen);
            lastAdded.setShape({
                segs: newSegs
            });
        } else {
            // Clear
            this._newAdded = [];
            var lineEl = this._create();
            lineEl.incremental = true;
            lineEl.setShape({
                segs: linePoints
            });
            this._setCommon(lineEl, data);
            lineEl.__startIndex = taskParams.start;
        }
    };
    /**
   * @override
   */ LargeLineDraw.prototype.remove = function() {
        this._clear();
    };
    LargeLineDraw.prototype.eachRendered = function(cb) {
        this._newAdded[0] && cb(this._newAdded[0]);
    };
    LargeLineDraw.prototype._create = function() {
        var lineEl = new $230d1550e84d99ee$var$LargeLinesPath({
            cursor: 'default',
            ignoreCoarsePointer: true
        });
        this._newAdded.push(lineEl);
        this.group.add(lineEl);
        return lineEl;
    };
    LargeLineDraw.prototype._setCommon = function(lineEl, data, isIncremental) {
        var hostModel = data.hostModel;
        lineEl.setShape({
            polyline: hostModel.get('polyline'),
            curveness: hostModel.get([
                'lineStyle',
                'curveness'
            ])
        });
        lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
        lineEl.style.strokeNoScale = true;
        var style = data.getVisual('style');
        if (style && style.stroke) lineEl.setStyle('stroke', style.stroke);
        lineEl.setStyle('fill', null);
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(lineEl);
        // Enable tooltip
        // PENDING May have performance issue when path is extremely large
        ecData.seriesIndex = hostModel.seriesIndex;
        lineEl.on('mousemove', function(e) {
            ecData.dataIndex = null;
            var dataIndex = lineEl.hoverDataIdx;
            if (dataIndex > 0) // Provide dataIndex for tooltip
            ecData.dataIndex = dataIndex + lineEl.__startIndex;
        });
    };
    LargeLineDraw.prototype._clear = function() {
        this._newAdded = [];
        this.group.removeAll();
    };
    return LargeLineDraw;
}();
var $230d1550e84d99ee$export$2e2bcd8739ae039 = $230d1550e84d99ee$var$LargeLineDraw;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Float32Array */ 

var $beda4648b087ddfe$var$linesLayout = {
    seriesType: 'lines',
    plan: (0, $0041f1ab5f0fd789$export$2e2bcd8739ae039)(),
    reset: function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (!coordSys) return;
        var isPolyline = seriesModel.get('polyline');
        var isLarge = seriesModel.pipelineContext.large;
        return {
            progress: function(params, lineData) {
                var lineCoords = [];
                if (isLarge) {
                    var points = void 0;
                    var segCount = params.end - params.start;
                    if (isPolyline) {
                        var totalCoordsCount = 0;
                        for(var i = params.start; i < params.end; i++)totalCoordsCount += seriesModel.getLineCoordsCount(i);
                        points = new Float32Array(segCount + totalCoordsCount * 2);
                    } else points = new Float32Array(segCount * 4);
                    var offset = 0;
                    var pt = [];
                    for(var i = params.start; i < params.end; i++){
                        var len = seriesModel.getLineCoords(i, lineCoords);
                        if (isPolyline) points[offset++] = len;
                        for(var k = 0; k < len; k++){
                            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
                            points[offset++] = pt[0];
                            points[offset++] = pt[1];
                        }
                    }
                    lineData.setLayout('linesPoints', points);
                } else for(var i = params.start; i < params.end; i++){
                    var itemModel = lineData.getItemModel(i);
                    var len = seriesModel.getLineCoords(i, lineCoords);
                    var pts = [];
                    if (isPolyline) for(var j = 0; j < len; j++)pts.push(coordSys.dataToPoint(lineCoords[j]));
                    else {
                        pts[0] = coordSys.dataToPoint(lineCoords[0]);
                        pts[1] = coordSys.dataToPoint(lineCoords[1]);
                        var curveness = itemModel.get([
                            'lineStyle',
                            'curveness'
                        ]);
                        if (+curveness) pts[2] = [
                            (pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness,
                            (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness
                        ];
                    }
                    lineData.setItemLayout(i, pts);
                }
            }
        };
    }
};
var $beda4648b087ddfe$export$2e2bcd8739ae039 = $beda4648b087ddfe$var$linesLayout;




var $61075d483e8e5801$var$LinesView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LinesView, _super);
    function LinesView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesView.type;
        return _this;
    }
    LinesView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        var zlevel = seriesModel.get('zlevel');
        var trailLength = seriesModel.get([
            'effect',
            'trailLength'
        ]);
        var zr = api.getZr();
        // Avoid the drag cause ghost shadow
        // FIXME Better way ?
        // SVG doesn't support
        var isSvg = zr.painter.getType() === 'svg';
        if (!isSvg) zr.painter.getLayer(zlevel).clear(true);
        // Config layer with motion blur
        if (this._lastZlevel != null && !isSvg) zr.configLayer(this._lastZlevel, {
            motionBlur: false
        });
        if (this._showEffect(seriesModel) && trailLength > 0) {
            if (!isSvg) zr.configLayer(zlevel, {
                motionBlur: true,
                lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
            });
        }
        lineDraw.updateData(data);
        var clipPath = seriesModel.get('clip', true) && (0, $6206a29b0d1240e0$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel);
        if (clipPath) this.group.setClipPath(clipPath);
        else this.group.removeClipPath();
        this._lastZlevel = zlevel;
        this._finished = true;
    };
    LinesView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var lineDraw = this._updateLineDraw(data, seriesModel);
        lineDraw.incrementalPrepareUpdate(data);
        this._clearLayer(api);
        this._finished = false;
    };
    LinesView.prototype.incrementalRender = function(taskParams, seriesModel, ecModel) {
        this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
        this._finished = taskParams.end === seriesModel.getData().count();
    };
    LinesView.prototype.eachRendered = function(cb) {
        this._lineDraw && this._lineDraw.eachRendered(cb);
    };
    LinesView.prototype.updateTransform = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var pipelineContext = seriesModel.pipelineContext;
        if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) // TODO Don't have to do update in large mode. Only do it when there are millions of data.
        return {
            update: true
        };
        else {
            // TODO Use same logic with ScatterView.
            // Manually update layout
            var res = (0, $beda4648b087ddfe$export$2e2bcd8739ae039).reset(seriesModel, ecModel, api);
            if (res.progress) res.progress({
                start: 0,
                end: data.count(),
                count: data.count()
            }, data);
            // Not in large mode
            this._lineDraw.updateLayout();
            this._clearLayer(api);
        }
    };
    LinesView.prototype._updateLineDraw = function(data, seriesModel) {
        var lineDraw = this._lineDraw;
        var hasEffect = this._showEffect(seriesModel);
        var isPolyline = !!seriesModel.get('polyline');
        var pipelineContext = seriesModel.pipelineContext;
        var isLargeDraw = pipelineContext.large;
        if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
            if (lineDraw) lineDraw.remove();
            lineDraw = this._lineDraw = isLargeDraw ? new (0, $230d1550e84d99ee$export$2e2bcd8739ae039)() : new (0, $52292566d9cfa1f6$export$2e2bcd8739ae039)(isPolyline ? hasEffect ? (0, $a58d95a46b020034$export$2e2bcd8739ae039) : (0, $71a7991440409a76$export$2e2bcd8739ae039) : hasEffect ? (0, $d2c0d32a85b569aa$export$2e2bcd8739ae039) : (0, $7c246668238b1397$export$2e2bcd8739ae039));
            this._hasEffet = hasEffect;
            this._isPolyline = isPolyline;
            this._isLargeDraw = isLargeDraw;
        }
        this.group.add(lineDraw.group);
        return lineDraw;
    };
    LinesView.prototype._showEffect = function(seriesModel) {
        return !!seriesModel.get([
            'effect',
            'show'
        ]);
    };
    LinesView.prototype._clearLayer = function(api) {
        // Not use motion when dragging or zooming
        var zr = api.getZr();
        var isSvg = zr.painter.getType() === 'svg';
        if (!isSvg && this._lastZlevel != null) zr.painter.getLayer(this._lastZlevel).clear(true);
    };
    LinesView.prototype.remove = function(ecModel, api) {
        this._lineDraw && this._lineDraw.remove();
        this._lineDraw = null;
        // Clear motion when lineDraw is removed
        this._clearLayer(api);
    };
    LinesView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    LinesView.type = 'lines';
    return LinesView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $61075d483e8e5801$export$2e2bcd8739ae039 = $61075d483e8e5801$var$LinesView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $36f558a943d7bea1$var$Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
var $36f558a943d7bea1$var$Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
function $36f558a943d7bea1$var$compatEc2(seriesOpt) {
    var data = seriesOpt.data;
    if (data && data[0] && data[0][0] && data[0][0].coord) seriesOpt.data = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(data, function(itemOpt) {
        var coords = [
            itemOpt[0].coord,
            itemOpt[1].coord
        ];
        var target = {
            coords: coords
        };
        if (itemOpt[0].name) target.fromName = itemOpt[0].name;
        if (itemOpt[1].name) target.toName = itemOpt[1].name;
        return (0, $1b239fc9d3a2f8ae$export$18aef43295bbe906)([
            target,
            itemOpt[0],
            itemOpt[1]
        ]);
    });
}
var $36f558a943d7bea1$var$LinesSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LinesSeriesModel, _super);
    function LinesSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LinesSeriesModel.type;
        _this.visualStyleAccessPath = 'lineStyle';
        _this.visualDrawType = 'stroke';
        return _this;
    }
    LinesSeriesModel.prototype.init = function(option) {
        // The input data may be null/undefined.
        option.data = option.data || [];
        // Not using preprocessor because mergeOption may not have series.type
        $36f558a943d7bea1$var$compatEc2(option);
        var result = this._processFlatCoordsArray(option.data);
        this._flatCoords = result.flatCoords;
        this._flatCoordsOffset = result.flatCoordsOffset;
        if (result.flatCoords) option.data = new Float32Array(result.count);
        _super.prototype.init.apply(this, arguments);
    };
    LinesSeriesModel.prototype.mergeOption = function(option) {
        $36f558a943d7bea1$var$compatEc2(option);
        if (option.data) {
            // Only update when have option data to merge.
            var result = this._processFlatCoordsArray(option.data);
            this._flatCoords = result.flatCoords;
            this._flatCoordsOffset = result.flatCoordsOffset;
            if (result.flatCoords) option.data = new Float32Array(result.count);
        }
        _super.prototype.mergeOption.apply(this, arguments);
    };
    LinesSeriesModel.prototype.appendData = function(params) {
        var result = this._processFlatCoordsArray(params.data);
        if (result.flatCoords) {
            if (!this._flatCoords) {
                this._flatCoords = result.flatCoords;
                this._flatCoordsOffset = result.flatCoordsOffset;
            } else {
                this._flatCoords = (0, $1b239fc9d3a2f8ae$export$4fd8af2c48c43416)(this._flatCoords, result.flatCoords);
                this._flatCoordsOffset = (0, $1b239fc9d3a2f8ae$export$4fd8af2c48c43416)(this._flatCoordsOffset, result.flatCoordsOffset);
            }
            params.data = new Float32Array(result.count);
        }
        this.getRawData().appendData(params.data);
    };
    LinesSeriesModel.prototype._getCoordsFromItemModel = function(idx) {
        var itemModel = this.getData().getItemModel(idx);
        var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
        return coords;
    };
    LinesSeriesModel.prototype.getLineCoordsCount = function(idx) {
        if (this._flatCoordsOffset) return this._flatCoordsOffset[idx * 2 + 1];
        else return this._getCoordsFromItemModel(idx).length;
    };
    LinesSeriesModel.prototype.getLineCoords = function(idx, out) {
        if (this._flatCoordsOffset) {
            var offset = this._flatCoordsOffset[idx * 2];
            var len = this._flatCoordsOffset[idx * 2 + 1];
            for(var i = 0; i < len; i++){
                out[i] = out[i] || [];
                out[i][0] = this._flatCoords[offset + i * 2];
                out[i][1] = this._flatCoords[offset + i * 2 + 1];
            }
            return len;
        } else {
            var coords = this._getCoordsFromItemModel(idx);
            for(var i = 0; i < coords.length; i++){
                out[i] = out[i] || [];
                out[i][0] = coords[i][0];
                out[i][1] = coords[i][1];
            }
            return coords.length;
        }
    };
    LinesSeriesModel.prototype._processFlatCoordsArray = function(data) {
        var startOffset = 0;
        if (this._flatCoords) startOffset = this._flatCoords.length;
        // Stored as a typed array. In format
        // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
        if ((0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(data[0])) {
            var len = data.length;
            // Store offset and len of each segment
            var coordsOffsetAndLenStorage = new $36f558a943d7bea1$var$Uint32Arr(len);
            var coordsStorage = new $36f558a943d7bea1$var$Float64Arr(len);
            var coordsCursor = 0;
            var offsetCursor = 0;
            var dataCount = 0;
            for(var i = 0; i < len;){
                dataCount++;
                var count = data[i++];
                // Offset
                coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset;
                // Len
                coordsOffsetAndLenStorage[offsetCursor++] = count;
                for(var k = 0; k < count; k++){
                    var x = data[i++];
                    var y = data[i++];
                    coordsStorage[coordsCursor++] = x;
                    coordsStorage[coordsCursor++] = y;
                }
            }
            return {
                flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
                flatCoords: coordsStorage,
                count: dataCount
            };
        }
        return {
            flatCoordsOffset: null,
            flatCoords: null,
            count: data.length
        };
    };
    LinesSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var CoordSys;
        var lineData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)([
            'value'
        ], this);
        lineData.hasItemOption = false;
        lineData.initData(option.data, [], function(dataItem, dimName, dataIndex, dimIndex) {
            // dataItem is simply coords
            if (dataItem instanceof Array) return NaN;
            else {
                lineData.hasItemOption = true;
                var value = dataItem.value;
                if (value != null) return value instanceof Array ? value[dimIndex] : value;
            }
        });
        return lineData;
    };
    LinesSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var itemModel = data.getItemModel(dataIndex);
        var name = itemModel.get('name');
        if (name) return name;
        var fromName = itemModel.get('fromName');
        var toName = itemModel.get('toName');
        var nameArr = [];
        fromName != null && nameArr.push(fromName);
        toName != null && nameArr.push(toName);
        return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
            name: nameArr.join(' > ')
        });
    };
    LinesSeriesModel.prototype.preventIncremental = function() {
        return !!this.get([
            'effect',
            'show'
        ]);
    };
    LinesSeriesModel.prototype.getProgressive = function() {
        var progressive = this.option.progressive;
        if (progressive == null) return this.option.large ? 1e4 : this.get('progressive');
        return progressive;
    };
    LinesSeriesModel.prototype.getProgressiveThreshold = function() {
        var progressiveThreshold = this.option.progressiveThreshold;
        if (progressiveThreshold == null) return this.option.large ? 2e4 : this.get('progressiveThreshold');
        return progressiveThreshold;
    };
    LinesSeriesModel.prototype.getZLevelKey = function() {
        var effectModel = this.getModel('effect');
        var trailLength = effectModel.get('trailLength');
        return this.getData().count() > this.getProgressiveThreshold() ? this.id : effectModel.get('show') && trailLength > 0 ? trailLength + '' : '';
    };
    LinesSeriesModel.type = 'series.lines';
    LinesSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'calendar'
    ];
    LinesSeriesModel.defaultOption = {
        coordinateSystem: 'geo',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Cartesian coordinate system
        xAxisIndex: 0,
        yAxisIndex: 0,
        symbol: [
            'none',
            'none'
        ],
        symbolSize: [
            10,
            10
        ],
        // Geo coordinate system
        geoIndex: 0,
        effect: {
            show: false,
            period: 4,
            constantSpeed: 0,
            symbol: 'circle',
            symbolSize: 3,
            loop: true,
            trailLength: 0.2
        },
        large: false,
        // Available when large is true
        largeThreshold: 2000,
        polyline: false,
        clip: true,
        label: {
            show: false,
            position: 'end'
        },
        lineStyle: {
            opacity: 0.5
        }
    };
    return LinesSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $36f558a943d7bea1$export$2e2bcd8739ae039 = $36f558a943d7bea1$var$LinesSeriesModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $98eef3ba9c7a0864$var$normalize(a) {
    if (!(a instanceof Array)) a = [
        a,
        a
    ];
    return a;
}
var $98eef3ba9c7a0864$var$linesVisual = {
    seriesType: 'lines',
    reset: function(seriesModel) {
        var symbolType = $98eef3ba9c7a0864$var$normalize(seriesModel.get('symbol'));
        var symbolSize = $98eef3ba9c7a0864$var$normalize(seriesModel.get('symbolSize'));
        var data = seriesModel.getData();
        data.setVisual('fromSymbol', symbolType && symbolType[0]);
        data.setVisual('toSymbol', symbolType && symbolType[1]);
        data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
        data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
        function dataEach(data, idx) {
            var itemModel = data.getItemModel(idx);
            var symbolType = $98eef3ba9c7a0864$var$normalize(itemModel.getShallow('symbol', true));
            var symbolSize = $98eef3ba9c7a0864$var$normalize(itemModel.getShallow('symbolSize', true));
            symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
            symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
            symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
            symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
        }
        return {
            dataEach: data.hasItemOption ? dataEach : null
        };
    }
};
var $98eef3ba9c7a0864$export$2e2bcd8739ae039 = $98eef3ba9c7a0864$var$linesVisual;


function $d7cc9df24d777511$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $61075d483e8e5801$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $36f558a943d7bea1$export$2e2bcd8739ae039));
    registers.registerLayout((0, $beda4648b087ddfe$export$2e2bcd8739ae039));
    registers.registerVisual((0, $98eef3ba9c7a0864$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /* global Uint8ClampedArray */ 
var $7001847e154cb81c$var$GRADIENT_LEVELS = 256;
var $7001847e154cb81c$var$HeatmapLayer = /** @class */ function() {
    function HeatmapLayer() {
        this.blurSize = 30;
        this.pointSize = 20;
        this.maxOpacity = 1;
        this.minOpacity = 0;
        this._gradientPixels = {
            inRange: null,
            outOfRange: null
        };
        var canvas = (0, $024b63ea846a8ccd$export$ef5e599365494451).createCanvas();
        this.canvas = canvas;
    }
    /**
   * Renders Heatmap and returns the rendered canvas
   * @param data array of data, each has x, y, value
   * @param width canvas width
   * @param height canvas height
   */ HeatmapLayer.prototype.update = function(data, width, height, normalize, colorFunc, isInRange) {
        var brush = this._getBrush();
        var gradientInRange = this._getGradient(colorFunc, 'inRange');
        var gradientOutOfRange = this._getGradient(colorFunc, 'outOfRange');
        var r = this.pointSize + this.blurSize;
        var canvas = this.canvas;
        var ctx = canvas.getContext('2d');
        var len = data.length;
        canvas.width = width;
        canvas.height = height;
        for(var i = 0; i < len; ++i){
            var p = data[i];
            var x = p[0];
            var y = p[1];
            var value = p[2];
            // calculate alpha using value
            var alpha = normalize(value);
            // draw with the circle brush with alpha
            ctx.globalAlpha = alpha;
            ctx.drawImage(brush, x - r, y - r);
        }
        if (!canvas.width || !canvas.height) // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
        // 'CanvasRenderingContext2D': The source height is 0."
        return canvas;
        // colorize the canvas using alpha value and set with gradient
        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var pixels = imageData.data;
        var offset = 0;
        var pixelLen = pixels.length;
        var minOpacity = this.minOpacity;
        var maxOpacity = this.maxOpacity;
        var diffOpacity = maxOpacity - minOpacity;
        while(offset < pixelLen){
            var alpha = pixels[offset + 3] / 256;
            var gradientOffset = Math.floor(alpha * ($7001847e154cb81c$var$GRADIENT_LEVELS - 1)) * 4;
            // Simple optimize to ignore the empty data
            if (alpha > 0) {
                var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange;
                // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
                alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
                pixels[offset++] = gradient[gradientOffset];
                pixels[offset++] = gradient[gradientOffset + 1];
                pixels[offset++] = gradient[gradientOffset + 2];
                pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
            } else offset += 4;
        }
        ctx.putImageData(imageData, 0, 0);
        return canvas;
    };
    /**
   * get canvas of a black circle brush used for canvas to draw later
   */ HeatmapLayer.prototype._getBrush = function() {
        var brushCanvas = this._brushCanvas || (this._brushCanvas = (0, $024b63ea846a8ccd$export$ef5e599365494451).createCanvas());
        // set brush size
        var r = this.pointSize + this.blurSize;
        var d = r * 2;
        brushCanvas.width = d;
        brushCanvas.height = d;
        var ctx = brushCanvas.getContext('2d');
        ctx.clearRect(0, 0, d, d);
        // in order to render shadow without the distinct circle,
        // draw the distinct circle in an invisible place,
        // and use shadowOffset to draw shadow in the center of the canvas
        ctx.shadowOffsetX = d;
        ctx.shadowBlur = this.blurSize;
        // draw the shadow in black, and use alpha and shadow blur to generate
        // color in color map
        ctx.shadowColor = '#000';
        // draw circle in the left to the canvas
        ctx.beginPath();
        ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
        ctx.closePath();
        ctx.fill();
        return brushCanvas;
    };
    /**
   * get gradient color map
   * @private
   */ HeatmapLayer.prototype._getGradient = function(colorFunc, state) {
        var gradientPixels = this._gradientPixels;
        var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(1024));
        var color = [
            0,
            0,
            0,
            0
        ];
        var off = 0;
        for(var i = 0; i < 256; i++){
            colorFunc[state](i / 255, true, color);
            pixelsSingleState[off++] = color[0];
            pixelsSingleState[off++] = color[1];
            pixelsSingleState[off++] = color[2];
            pixelsSingleState[off++] = color[3];
        }
        return pixelsSingleState;
    };
    return HeatmapLayer;
}();
var $7001847e154cb81c$export$2e2bcd8739ae039 = $7001847e154cb81c$var$HeatmapLayer;






function $4477ae4951b43944$var$getIsInPiecewiseRange(dataExtent, pieceList, selected) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    pieceList = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(pieceList, function(piece) {
        return {
            interval: [
                (piece.interval[0] - dataExtent[0]) / dataSpan,
                (piece.interval[1] - dataExtent[0]) / dataSpan
            ]
        };
    });
    var len = pieceList.length;
    var lastIndex = 0;
    return function(val) {
        var i;
        // Try to find in the location of the last found
        for(i = lastIndex; i < len; i++){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        if (i === len) // Not found, back interation
        for(i = lastIndex - 1; i >= 0; i--){
            var interval = pieceList[i].interval;
            if (interval[0] <= val && val <= interval[1]) {
                lastIndex = i;
                break;
            }
        }
        return i >= 0 && i < len && selected[i];
    };
}
function $4477ae4951b43944$var$getIsInContinuousRange(dataExtent, range) {
    var dataSpan = dataExtent[1] - dataExtent[0];
    range = [
        (range[0] - dataExtent[0]) / dataSpan,
        (range[1] - dataExtent[0]) / dataSpan
    ];
    return function(val) {
        return val >= range[0] && val <= range[1];
    };
}
function $4477ae4951b43944$var$isGeoCoordSys(coordSys) {
    var dimensions = coordSys.dimensions;
    // Not use coordSys.type === 'geo' because coordSys maybe extended
    return dimensions[0] === 'lng' && dimensions[1] === 'lat';
}
var $4477ae4951b43944$var$HeatmapView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(HeatmapView, _super);
    function HeatmapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapView.type;
        return _this;
    }
    HeatmapView.prototype.render = function(seriesModel, ecModel, api) {
        var visualMapOfThisSeries;
        ecModel.eachComponent('visualMap', function(visualMap) {
            visualMap.eachTargetSeries(function(targetSeries) {
                if (targetSeries === seriesModel) visualMapOfThisSeries = visualMap;
            });
        });
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        this.group.removeAll();
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
        else if ($4477ae4951b43944$var$isGeoCoordSys(coordSys)) this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
    };
    HeatmapView.prototype.incrementalPrepareRender = function(seriesModel, ecModel, api) {
        this.group.removeAll();
    };
    HeatmapView.prototype.incrementalRender = function(params, seriesModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys) {
            // geo does not support incremental rendering?
            if ($4477ae4951b43944$var$isGeoCoordSys(coordSys)) this.render(seriesModel, ecModel, api);
            else {
                this._progressiveEls = [];
                this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
            }
        }
    };
    HeatmapView.prototype.eachRendered = function(cb) {
        $8eb95236e1aa01e7$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    HeatmapView.prototype._renderOnCartesianAndCalendar = function(seriesModel, api, start, end, incremental) {
        var coordSys = seriesModel.coordinateSystem;
        var isCartesian2d = (0, $9ca39efe18dd5899$export$8567506e6336616)(coordSys, 'cartesian2d');
        var width;
        var height;
        var xAxisExtent;
        var yAxisExtent;
        if (isCartesian2d) {
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            // add 0.5px to avoid the gaps
            width = xAxis.getBandWidth() + .5;
            height = yAxis.getBandWidth() + .5;
            xAxisExtent = xAxis.scale.getExtent();
            yAxisExtent = yAxis.scale.getExtent();
        }
        var group = this.group;
        var data = seriesModel.getData();
        var emphasisStyle = seriesModel.getModel([
            'emphasis',
            'itemStyle'
        ]).getItemStyle();
        var blurStyle = seriesModel.getModel([
            'blur',
            'itemStyle'
        ]).getItemStyle();
        var selectStyle = seriesModel.getModel([
            'select',
            'itemStyle'
        ]).getItemStyle();
        var borderRadius = seriesModel.get([
            'itemStyle',
            'borderRadius'
        ]);
        var labelStatesModels = (0, $3828198b2f2de836$export$9739a32674be5893)(seriesModel);
        var emphasisModel = seriesModel.getModel('emphasis');
        var focus = emphasisModel.get('focus');
        var blurScope = emphasisModel.get('blurScope');
        var emphasisDisabled = emphasisModel.get('disabled');
        var dataDims = isCartesian2d ? [
            data.mapDimension('x'),
            data.mapDimension('y'),
            data.mapDimension('value')
        ] : [
            data.mapDimension('time'),
            data.mapDimension('value')
        ];
        for(var idx = start; idx < end; idx++){
            var rect = void 0;
            var style = data.getItemVisual(idx, 'style');
            if (isCartesian2d) {
                var dataDimX = data.get(dataDims[0], idx);
                var dataDimY = data.get(dataDims[1], idx);
                // Ignore empty data and out of extent data
                if (isNaN(data.get(dataDims[2], idx)) || isNaN(dataDimX) || isNaN(dataDimY) || dataDimX < xAxisExtent[0] || dataDimX > xAxisExtent[1] || dataDimY < yAxisExtent[0] || dataDimY > yAxisExtent[1]) continue;
                var point = coordSys.dataToPoint([
                    dataDimX,
                    dataDimY
                ]);
                rect = new $37476269d425e3f6$export$2e2bcd8739ae039({
                    shape: {
                        x: point[0] - width / 2,
                        y: point[1] - height / 2,
                        width: width,
                        height: height
                    },
                    style: style
                });
            } else {
                // Ignore empty data
                if (isNaN(data.get(dataDims[1], idx))) continue;
                rect = new $37476269d425e3f6$export$2e2bcd8739ae039({
                    z2: 1,
                    shape: coordSys.dataToRect([
                        data.get(dataDims[0], idx)
                    ]).contentShape,
                    style: style
                });
            }
            // Optimization for large dataset
            if (data.hasItemOption) {
                var itemModel = data.getItemModel(idx);
                var emphasisModel_1 = itemModel.getModel('emphasis');
                emphasisStyle = emphasisModel_1.getModel('itemStyle').getItemStyle();
                blurStyle = itemModel.getModel([
                    'blur',
                    'itemStyle'
                ]).getItemStyle();
                selectStyle = itemModel.getModel([
                    'select',
                    'itemStyle'
                ]).getItemStyle();
                // Each item value struct in the data would be firstly
                // {
                //     itemStyle: { borderRadius: [30, 30] },
                //     value: [2022, 02, 22]
                // }
                borderRadius = itemModel.get([
                    'itemStyle',
                    'borderRadius'
                ]);
                focus = emphasisModel_1.get('focus');
                blurScope = emphasisModel_1.get('blurScope');
                emphasisDisabled = emphasisModel_1.get('disabled');
                labelStatesModels = (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel);
            }
            rect.shape.r = borderRadius;
            var rawValue = seriesModel.getRawValue(idx);
            var defaultText = '-';
            if (rawValue && rawValue[2] != null) defaultText = rawValue[2] + '';
            (0, $3828198b2f2de836$export$9a13992917966657)(rect, labelStatesModels, {
                labelFetcher: seriesModel,
                labelDataIndex: idx,
                defaultOpacity: style.opacity,
                defaultText: defaultText
            });
            rect.ensureState('emphasis').style = emphasisStyle;
            rect.ensureState('blur').style = blurStyle;
            rect.ensureState('select').style = selectStyle;
            (0, $b414df7d361a211c$export$e51187539ff11209)(rect, focus, blurScope, emphasisDisabled);
            rect.incremental = incremental;
            // PENDING
            if (incremental) // Rect must use hover layer if it's incremental.
            rect.states.emphasis.hoverLayer = true;
            group.add(rect);
            data.setItemGraphicEl(idx, rect);
            if (this._progressiveEls) this._progressiveEls.push(rect);
        }
    };
    HeatmapView.prototype._renderOnGeo = function(geo, seriesModel, visualMapModel, api) {
        var inRangeVisuals = visualMapModel.targetVisuals.inRange;
        var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange;
        // if (!visualMapping) {
        //     throw new Error('Data range must have color visuals');
        // }
        var data = seriesModel.getData();
        var hmLayer = this._hmLayer || this._hmLayer || new (0, $7001847e154cb81c$export$2e2bcd8739ae039)();
        hmLayer.blurSize = seriesModel.get('blurSize');
        hmLayer.pointSize = seriesModel.get('pointSize');
        hmLayer.minOpacity = seriesModel.get('minOpacity');
        hmLayer.maxOpacity = seriesModel.get('maxOpacity');
        var rect = geo.getViewRect().clone();
        var roamTransform = geo.getRoamTransform();
        rect.applyTransform(roamTransform);
        // Clamp on viewport
        var x = Math.max(rect.x, 0);
        var y = Math.max(rect.y, 0);
        var x2 = Math.min(rect.width + rect.x, api.getWidth());
        var y2 = Math.min(rect.height + rect.y, api.getHeight());
        var width = x2 - x;
        var height = y2 - y;
        var dims = [
            data.mapDimension('lng'),
            data.mapDimension('lat'),
            data.mapDimension('value')
        ];
        var points = data.mapArray(dims, function(lng, lat, value) {
            var pt = geo.dataToPoint([
                lng,
                lat
            ]);
            pt[0] -= x;
            pt[1] -= y;
            pt.push(value);
            return pt;
        });
        var dataExtent = visualMapModel.getExtent();
        var isInRange = visualMapModel.type === 'visualMap.continuous' ? $4477ae4951b43944$var$getIsInContinuousRange(dataExtent, visualMapModel.option.range) : $4477ae4951b43944$var$getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
        hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
            inRange: inRangeVisuals.color.getColorMapper(),
            outOfRange: outOfRangeVisuals.color.getColorMapper()
        }, isInRange);
        var img = new $29f98103052059af$export$2e2bcd8739ae039({
            style: {
                width: width,
                height: height,
                x: x,
                y: y,
                image: hmLayer.canvas
            },
            silent: true
        });
        this.group.add(img);
    };
    HeatmapView.type = 'heatmap';
    return HeatmapView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $4477ae4951b43944$export$2e2bcd8739ae039 = $4477ae4951b43944$var$HeatmapView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $cd1674fbc86d367c$var$HeatmapSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(HeatmapSeriesModel, _super);
    function HeatmapSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = HeatmapSeriesModel.type;
        return _this;
    }
    HeatmapSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this, {
            generateCoord: 'value'
        });
    };
    HeatmapSeriesModel.prototype.preventIncremental = function() {
        var coordSysCreator = (0, $02d04429d2792472$export$2e2bcd8739ae039).get(this.get('coordinateSystem'));
        if (coordSysCreator && coordSysCreator.dimensions) return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
    };
    HeatmapSeriesModel.type = 'series.heatmap';
    HeatmapSeriesModel.dependencies = [
        'grid',
        'geo',
        'calendar'
    ];
    HeatmapSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        // Cartesian coordinate system
        // xAxisIndex: 0,
        // yAxisIndex: 0,
        // Geo coordinate system
        geoIndex: 0,
        blurSize: 30,
        pointSize: 20,
        maxOpacity: 1,
        minOpacity: 0,
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    };
    return HeatmapSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $cd1674fbc86d367c$export$2e2bcd8739ae039 = $cd1674fbc86d367c$var$HeatmapSeriesModel;


function $9956c93250b2085d$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $4477ae4951b43944$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $cd1674fbc86d367c$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $99df958a3f3307eb$var$BAR_BORDER_WIDTH_QUERY = [
    'itemStyle',
    'borderWidth'
];
// index: +isHorizontal
var $99df958a3f3307eb$var$LAYOUT_ATTRS = [
    {
        xy: 'x',
        wh: 'width',
        index: 0,
        posDesc: [
            'left',
            'right'
        ]
    },
    {
        xy: 'y',
        wh: 'height',
        index: 1,
        posDesc: [
            'top',
            'bottom'
        ]
    }
];
var $99df958a3f3307eb$var$pathForLineWidth = new $8eb95236e1aa01e7$exports.Circle();
var $99df958a3f3307eb$var$PictorialBarView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PictorialBarView, _super);
    function PictorialBarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarView.type;
        return _this;
    }
    PictorialBarView.prototype.render = function(seriesModel, ecModel, api) {
        var group = this.group;
        var data = seriesModel.getData();
        var oldData = this._data;
        var cartesian = seriesModel.coordinateSystem;
        var baseAxis = cartesian.getBaseAxis();
        var isHorizontal = baseAxis.isHorizontal();
        var coordSysRect = cartesian.master.getRect();
        var opt = {
            ecSize: {
                width: api.getWidth(),
                height: api.getHeight()
            },
            seriesModel: seriesModel,
            coordSys: cartesian,
            coordSysExtent: [
                [
                    coordSysRect.x,
                    coordSysRect.x + coordSysRect.width
                ],
                [
                    coordSysRect.y,
                    coordSysRect.y + coordSysRect.height
                ]
            ],
            isHorizontal: isHorizontal,
            valueDim: $99df958a3f3307eb$var$LAYOUT_ATTRS[+isHorizontal],
            categoryDim: $99df958a3f3307eb$var$LAYOUT_ATTRS[1 - +isHorizontal]
        };
        data.diff(oldData).add(function(dataIndex) {
            if (!data.hasValue(dataIndex)) return;
            var itemModel = $99df958a3f3307eb$var$getItemModel(data, dataIndex);
            var symbolMeta = $99df958a3f3307eb$var$getSymbolMeta(data, dataIndex, itemModel, opt);
            var bar = $99df958a3f3307eb$var$createBar(data, opt, symbolMeta);
            data.setItemGraphicEl(dataIndex, bar);
            group.add(bar);
            $99df958a3f3307eb$var$updateCommon(bar, opt, symbolMeta);
        }).update(function(newIndex, oldIndex) {
            var bar = oldData.getItemGraphicEl(oldIndex);
            if (!data.hasValue(newIndex)) {
                group.remove(bar);
                return;
            }
            var itemModel = $99df958a3f3307eb$var$getItemModel(data, newIndex);
            var symbolMeta = $99df958a3f3307eb$var$getSymbolMeta(data, newIndex, itemModel, opt);
            var pictorialShapeStr = $99df958a3f3307eb$var$getShapeStr(data, symbolMeta);
            if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
                group.remove(bar);
                data.setItemGraphicEl(newIndex, null);
                bar = null;
            }
            if (bar) $99df958a3f3307eb$var$updateBar(bar, opt, symbolMeta);
            else bar = $99df958a3f3307eb$var$createBar(data, opt, symbolMeta, true);
            data.setItemGraphicEl(newIndex, bar);
            bar.__pictorialSymbolMeta = symbolMeta;
            // Add back
            group.add(bar);
            $99df958a3f3307eb$var$updateCommon(bar, opt, symbolMeta);
        }).remove(function(dataIndex) {
            var bar = oldData.getItemGraphicEl(dataIndex);
            bar && $99df958a3f3307eb$var$removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
        }).execute();
        // Do clipping
        var clipPath = seriesModel.get('clip', true) ? (0, $6206a29b0d1240e0$export$e0fe5081209d01c9)(seriesModel.coordinateSystem, false, seriesModel) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
        return this.group;
    };
    PictorialBarView.prototype.remove = function(ecModel, api) {
        var group = this.group;
        var data = this._data;
        if (ecModel.get('animation')) {
            if (data) data.eachItemGraphicEl(function(bar) {
                $99df958a3f3307eb$var$removeBar(data, (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(bar).dataIndex, ecModel, bar);
            });
        } else group.removeAll();
    };
    PictorialBarView.type = 'pictorialBar';
    return PictorialBarView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
// Set or calculate default value about symbol, and calculate layout info.
function $99df958a3f3307eb$var$getSymbolMeta(data, dataIndex, itemModel, opt) {
    var layout = data.getItemLayout(dataIndex);
    var symbolRepeat = itemModel.get('symbolRepeat');
    var symbolClip = itemModel.get('symbolClip');
    var symbolPosition = itemModel.get('symbolPosition') || 'start';
    var symbolRotate = itemModel.get('symbolRotate');
    var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
    var isAnimationEnabled = itemModel.isAnimationEnabled();
    var symbolMeta = {
        dataIndex: dataIndex,
        layout: layout,
        itemModel: itemModel,
        symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
        style: data.getItemVisual(dataIndex, 'style'),
        symbolClip: symbolClip,
        symbolRepeat: symbolRepeat,
        symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
        symbolPatternSize: symbolPatternSize,
        rotation: rotation,
        animationModel: isAnimationEnabled ? itemModel : null,
        hoverScale: isAnimationEnabled && itemModel.get([
            'emphasis',
            'scale'
        ]),
        z2: itemModel.getShallow('z', true) || 0
    };
    $99df958a3f3307eb$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
    $99df958a3f3307eb$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
    $99df958a3f3307eb$var$prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
    var symbolSize = symbolMeta.symbolSize;
    var symbolOffset = (0, $da6220012439db7b$export$e3e292895c033f6d)(itemModel.get('symbolOffset'), symbolSize);
    $99df958a3f3307eb$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
    return symbolMeta;
}
// bar length can be negative.
function $99df958a3f3307eb$var$prepareBarLength(itemModel, symbolRepeat, layout, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var symbolBoundingData = itemModel.get('symbolBoundingData');
    var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
    var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
    var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
    var boundingLength;
    if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(symbolBoundingData)) {
        var symbolBoundingExtent = [
            $99df958a3f3307eb$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx,
            $99df958a3f3307eb$var$convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx
        ];
        symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
        boundingLength = symbolBoundingExtent[pxSignIdx];
    } else if (symbolBoundingData != null) boundingLength = $99df958a3f3307eb$var$convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
    else if (symbolRepeat) boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
    else boundingLength = layout[valueDim.wh];
    outputSymbolMeta.boundingLength = boundingLength;
    if (symbolRepeat) outputSymbolMeta.repeatCutLength = layout[valueDim.wh];
    // if 'pxSign' means sign of pixel,  it can't be zero, or symbolScale will be zero
    // and when borderWidth be settled, the actual linewidth will be NaN
    var isXAxis = valueDim.xy === 'x';
    var isInverse = valueAxis.inverse;
    outputSymbolMeta.pxSign = isXAxis && !isInverse || !isXAxis && isInverse ? boundingLength >= 0 ? 1 : -1 : boundingLength > 0 ? 1 : -1;
}
function $99df958a3f3307eb$var$convertToCoordOnAxis(axis, value) {
    return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
}
// Support ['100%', '100%']
function $99df958a3f3307eb$var$prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, outputSymbolMeta) {
    var valueDim = opt.valueDim;
    var categoryDim = opt.categoryDim;
    var categorySize = Math.abs(layout[categoryDim.wh]);
    var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
    var parsedSymbolSize;
    if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(symbolSize)) parsedSymbolSize = symbolSize.slice();
    else if (symbolSize == null) // will parse to number below
    parsedSymbolSize = [
        '100%',
        '100%'
    ];
    else parsedSymbolSize = [
        symbolSize,
        symbolSize
    ];
    // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
    // to complicated to calculate real percent value if considering scaled lineWidth.
    // So the actual size will bigger than layout size if lineWidth is bigger than zero,
    // which can be tolerated in pictorial chart.
    parsedSymbolSize[categoryDim.index] = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(parsedSymbolSize[categoryDim.index], categorySize);
    parsedSymbolSize[valueDim.index] = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(parsedSymbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
    outputSymbolMeta.symbolSize = parsedSymbolSize;
    // If x or y is less than zero, show reversed shape.
    var symbolScale = outputSymbolMeta.symbolScale = [
        parsedSymbolSize[0] / symbolPatternSize,
        parsedSymbolSize[1] / symbolPatternSize
    ];
    // Follow convention, 'right' and 'top' is the normal scale.
    symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
}
function $99df958a3f3307eb$var$prepareLineWidth(itemModel, symbolScale, rotation, opt, outputSymbolMeta) {
    // In symbols are drawn with scale, so do not need to care about the case that width
    // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
    // be calculated.
    var valueLineWidth = itemModel.get($99df958a3f3307eb$var$BAR_BORDER_WIDTH_QUERY) || 0;
    if (valueLineWidth) {
        $99df958a3f3307eb$var$pathForLineWidth.attr({
            scaleX: symbolScale[0],
            scaleY: symbolScale[1],
            rotation: rotation
        });
        $99df958a3f3307eb$var$pathForLineWidth.updateTransform();
        valueLineWidth /= $99df958a3f3307eb$var$pathForLineWidth.getLineScale();
        valueLineWidth *= symbolScale[opt.valueDim.index];
    }
    outputSymbolMeta.valueLineWidth = valueLineWidth || 0;
}
function $99df958a3f3307eb$var$prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, outputSymbolMeta) {
    var categoryDim = opt.categoryDim;
    var valueDim = opt.valueDim;
    var pxSign = outputSymbolMeta.pxSign;
    var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
    var pathLen = unitLength;
    // Note: rotation will not effect the layout of symbols, because user may
    // want symbols to rotate on its center, which should not be translated
    // when rotating.
    if (symbolRepeat) {
        var absBoundingLength = Math.abs(boundingLength);
        var symbolMargin = $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66(itemModel.get('symbolMargin'), '15%') + '';
        var hasEndGap = false;
        if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
            hasEndGap = true;
            symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
        }
        var symbolMarginNumeric = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(symbolMargin, symbolSize[valueDim.index]);
        var uLenWithMargin = Math.max(unitLength + symbolMarginNumeric * 2, 0);
        // When symbol margin is less than 0, margin at both ends will be subtracted
        // to ensure that all of the symbols will not be overflow the given area.
        var endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Both final repeatTimes and final symbolMarginNumeric area calculated based on
        // boundingLength.
        var repeatSpecified = (0, $9fd90cf3bf18fbcd$export$e90fb89750dba83f)(symbolRepeat);
        var repeatTimes = repeatSpecified ? symbolRepeat : $99df958a3f3307eb$var$toIntTimes((absBoundingLength + endFix) / uLenWithMargin);
        // Adjust calculate margin, to ensure each symbol is displayed
        // entirely in the given layout area.
        var mDiff = absBoundingLength - repeatTimes * unitLength;
        symbolMarginNumeric = mDiff / 2 / (hasEndGap ? repeatTimes : Math.max(repeatTimes - 1, 1));
        uLenWithMargin = unitLength + symbolMarginNumeric * 2;
        endFix = hasEndGap ? 0 : symbolMarginNumeric * 2;
        // Update repeatTimes when not all symbol will be shown.
        if (!repeatSpecified && symbolRepeat !== 'fixed') repeatTimes = repeatCutLength ? $99df958a3f3307eb$var$toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
        pathLen = repeatTimes * uLenWithMargin - endFix;
        outputSymbolMeta.repeatTimes = repeatTimes;
        outputSymbolMeta.symbolMargin = symbolMarginNumeric;
    }
    var sizeFix = pxSign * (pathLen / 2);
    var pathPosition = outputSymbolMeta.pathPosition = [];
    pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
    pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
    if (symbolOffset) {
        pathPosition[0] += symbolOffset[0];
        pathPosition[1] += symbolOffset[1];
    }
    var bundlePosition = outputSymbolMeta.bundlePosition = [];
    bundlePosition[categoryDim.index] = layout[categoryDim.xy];
    bundlePosition[valueDim.index] = layout[valueDim.xy];
    var barRectShape = outputSymbolMeta.barRectShape = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, layout);
    barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
    barRectShape[categoryDim.wh] = layout[categoryDim.wh];
    var clipShape = outputSymbolMeta.clipShape = {};
    // Consider that symbol may be overflow layout rect.
    clipShape[categoryDim.xy] = -layout[categoryDim.xy];
    clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
    clipShape[valueDim.xy] = 0;
    clipShape[valueDim.wh] = layout[valueDim.wh];
}
function $99df958a3f3307eb$var$createPath(symbolMeta) {
    var symbolPatternSize = symbolMeta.symbolPatternSize;
    var path = (0, $da6220012439db7b$export$af050e04da3a02e8)(// Consider texture img, make a big size.
    symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize);
    path.attr({
        culling: true
    });
    path.type !== 'image' && path.setStyle({
        strokeNoScale: true
    });
    return path;
}
function $99df958a3f3307eb$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var symbolSize = symbolMeta.symbolSize;
    var valueLineWidth = symbolMeta.valueLineWidth;
    var pathPosition = symbolMeta.pathPosition;
    var valueDim = opt.valueDim;
    var repeatTimes = symbolMeta.repeatTimes || 0;
    var index = 0;
    var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
    $99df958a3f3307eb$var$eachPath(bar, function(path) {
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        if (index < repeatTimes) $99df958a3f3307eb$var$updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
        else $99df958a3f3307eb$var$updateAttr(path, null, {
            scaleX: 0,
            scaleY: 0
        }, symbolMeta, isUpdate, function() {
            bundle.remove(path);
        });
        // updateHoverAnimation(path, symbolMeta);
        index++;
    });
    for(; index < repeatTimes; index++){
        var path = $99df958a3f3307eb$var$createPath(symbolMeta);
        path.__pictorialAnimationIndex = index;
        path.__pictorialRepeatTimes = repeatTimes;
        bundle.add(path);
        var target = makeTarget(index);
        $99df958a3f3307eb$var$updateAttr(path, {
            x: target.x,
            y: target.y,
            scaleX: 0,
            scaleY: 0
        }, {
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            rotation: target.rotation
        }, symbolMeta, isUpdate);
    }
    function makeTarget(index) {
        var position = pathPosition.slice();
        // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
        // Otherwise: i = index;
        var pxSign = symbolMeta.pxSign;
        var i = index;
        if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) i = repeatTimes - 1 - index;
        position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
        return {
            x: position[0],
            y: position[1],
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1],
            rotation: symbolMeta.rotation
        };
    }
}
function $99df958a3f3307eb$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
    var bundle = bar.__pictorialBundle;
    var mainPath = bar.__pictorialMainPath;
    if (!mainPath) {
        mainPath = bar.__pictorialMainPath = $99df958a3f3307eb$var$createPath(symbolMeta);
        bundle.add(mainPath);
        $99df958a3f3307eb$var$updateAttr(mainPath, {
            x: symbolMeta.pathPosition[0],
            y: symbolMeta.pathPosition[1],
            scaleX: 0,
            scaleY: 0,
            rotation: symbolMeta.rotation
        }, {
            scaleX: symbolMeta.symbolScale[0],
            scaleY: symbolMeta.symbolScale[1]
        }, symbolMeta, isUpdate);
    } else $99df958a3f3307eb$var$updateAttr(mainPath, null, {
        x: symbolMeta.pathPosition[0],
        y: symbolMeta.pathPosition[1],
        scaleX: symbolMeta.symbolScale[0],
        scaleY: symbolMeta.symbolScale[1],
        rotation: symbolMeta.rotation
    }, symbolMeta, isUpdate);
}
// bar rect is used for label.
function $99df958a3f3307eb$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
    var rectShape = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, symbolMeta.barRectShape);
    var barRect = bar.__pictorialBarRect;
    if (!barRect) {
        barRect = bar.__pictorialBarRect = new $8eb95236e1aa01e7$exports.Rect({
            z2: 2,
            shape: rectShape,
            silent: true,
            style: {
                stroke: 'transparent',
                fill: 'transparent',
                lineWidth: 0
            }
        });
        barRect.disableMorphing = true;
        bar.add(barRect);
    } else $99df958a3f3307eb$var$updateAttr(barRect, null, {
        shape: rectShape
    }, symbolMeta, isUpdate);
}
function $99df958a3f3307eb$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
    // If not clip, symbol will be remove and rebuilt.
    if (symbolMeta.symbolClip) {
        var clipPath = bar.__pictorialClipPath;
        var clipShape = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, symbolMeta.clipShape);
        var valueDim = opt.valueDim;
        var animationModel = symbolMeta.animationModel;
        var dataIndex = symbolMeta.dataIndex;
        if (clipPath) $8eb95236e1aa01e7$exports.updateProps(clipPath, {
            shape: clipShape
        }, animationModel, dataIndex);
        else {
            clipShape[valueDim.wh] = 0;
            clipPath = new $8eb95236e1aa01e7$exports.Rect({
                shape: clipShape
            });
            bar.__pictorialBundle.setClipPath(clipPath);
            bar.__pictorialClipPath = clipPath;
            var target = {};
            target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
            $8eb95236e1aa01e7$exports[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
                shape: target
            }, animationModel, dataIndex);
        }
    }
}
function $99df958a3f3307eb$var$getItemModel(data, dataIndex) {
    var itemModel = data.getItemModel(dataIndex);
    itemModel.getAnimationDelayParams = $99df958a3f3307eb$var$getAnimationDelayParams;
    itemModel.isAnimationEnabled = $99df958a3f3307eb$var$isAnimationEnabled;
    return itemModel;
}
function $99df958a3f3307eb$var$getAnimationDelayParams(path) {
    // The order is the same as the z-order, see `symbolRepeatDiretion`.
    return {
        index: path.__pictorialAnimationIndex,
        count: path.__pictorialRepeatTimes
    };
}
function $99df958a3f3307eb$var$isAnimationEnabled() {
    // `animation` prop can be set on itemModel in pictorial bar chart.
    return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
}
function $99df958a3f3307eb$var$createBar(data, opt, symbolMeta, isUpdate) {
    // bar is the main element for each data.
    var bar = new $8eb95236e1aa01e7$exports.Group();
    // bundle is used for location and clip.
    var bundle = new $8eb95236e1aa01e7$exports.Group();
    bar.add(bundle);
    bar.__pictorialBundle = bundle;
    bundle.x = symbolMeta.bundlePosition[0];
    bundle.y = symbolMeta.bundlePosition[1];
    if (symbolMeta.symbolRepeat) $99df958a3f3307eb$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
    else $99df958a3f3307eb$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta);
    $99df958a3f3307eb$var$createOrUpdateBarRect(bar, symbolMeta, isUpdate);
    $99df958a3f3307eb$var$createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
    bar.__pictorialShapeStr = $99df958a3f3307eb$var$getShapeStr(data, symbolMeta);
    bar.__pictorialSymbolMeta = symbolMeta;
    return bar;
}
function $99df958a3f3307eb$var$updateBar(bar, opt, symbolMeta) {
    var animationModel = symbolMeta.animationModel;
    var dataIndex = symbolMeta.dataIndex;
    var bundle = bar.__pictorialBundle;
    $8eb95236e1aa01e7$exports.updateProps(bundle, {
        x: symbolMeta.bundlePosition[0],
        y: symbolMeta.bundlePosition[1]
    }, animationModel, dataIndex);
    if (symbolMeta.symbolRepeat) $99df958a3f3307eb$var$createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
    else $99df958a3f3307eb$var$createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
    $99df958a3f3307eb$var$createOrUpdateBarRect(bar, symbolMeta, true);
    $99df958a3f3307eb$var$createOrUpdateClip(bar, opt, symbolMeta, true);
}
function $99df958a3f3307eb$var$removeBar(data, dataIndex, animationModel, bar) {
    // Not show text when animating
    var labelRect = bar.__pictorialBarRect;
    labelRect && labelRect.removeTextContent();
    var paths = [];
    $99df958a3f3307eb$var$eachPath(bar, function(path) {
        paths.push(path);
    });
    bar.__pictorialMainPath && paths.push(bar.__pictorialMainPath);
    // I do not find proper remove animation for clip yet.
    bar.__pictorialClipPath && (animationModel = null);
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(paths, function(path) {
        $8eb95236e1aa01e7$exports.removeElement(path, {
            scaleX: 0,
            scaleY: 0
        }, animationModel, dataIndex, function() {
            bar.parent && bar.parent.remove(bar);
        });
    });
    data.setItemGraphicEl(dataIndex, null);
}
function $99df958a3f3307eb$var$getShapeStr(data, symbolMeta) {
    return [
        data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none',
        !!symbolMeta.symbolRepeat,
        !!symbolMeta.symbolClip
    ].join(':');
}
function $99df958a3f3307eb$var$eachPath(bar, cb, context) {
    // Do not use Group#eachChild, because it do not support remove.
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(bar.__pictorialBundle.children(), function(el) {
        el !== bar.__pictorialBarRect && cb.call(context, el);
    });
}
function $99df958a3f3307eb$var$updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
    immediateAttrs && el.attr(immediateAttrs);
    // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
    if (symbolMeta.symbolClip && !isUpdate) animationAttrs && el.attr(animationAttrs);
    else animationAttrs && $8eb95236e1aa01e7$exports[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
}
function $99df958a3f3307eb$var$updateCommon(bar, opt, symbolMeta) {
    var dataIndex = symbolMeta.dataIndex;
    var itemModel = symbolMeta.itemModel;
    // Color must be excluded.
    // Because symbol provide setColor individually to set fill and stroke
    var emphasisModel = itemModel.getModel('emphasis');
    var emphasisStyle = emphasisModel.getModel('itemStyle').getItemStyle();
    var blurStyle = itemModel.getModel([
        'blur',
        'itemStyle'
    ]).getItemStyle();
    var selectStyle = itemModel.getModel([
        'select',
        'itemStyle'
    ]).getItemStyle();
    var cursorStyle = itemModel.getShallow('cursor');
    var focus = emphasisModel.get('focus');
    var blurScope = emphasisModel.get('blurScope');
    var hoverScale = emphasisModel.get('scale');
    $99df958a3f3307eb$var$eachPath(bar, function(path) {
        if (path instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) {
            var pathStyle = path.style;
            path.useStyle($1b239fc9d3a2f8ae$export$8b58be045bf06082({
                // TODO other properties like dx, dy ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, symbolMeta.style));
        } else path.useStyle(symbolMeta.style);
        var emphasisState = path.ensureState('emphasis');
        emphasisState.style = emphasisStyle;
        if (hoverScale) {
            // NOTE: Must after scale is set after updateAttr
            emphasisState.scaleX = path.scaleX * 1.1;
            emphasisState.scaleY = path.scaleY * 1.1;
        }
        path.ensureState('blur').style = blurStyle;
        path.ensureState('select').style = selectStyle;
        cursorStyle && (path.cursor = cursorStyle);
        path.z2 = symbolMeta.z2;
    });
    var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
    var barRect = bar.__pictorialBarRect;
    barRect.ignoreClip = true;
    (0, $3828198b2f2de836$export$9a13992917966657)(barRect, (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel), {
        labelFetcher: opt.seriesModel,
        labelDataIndex: dataIndex,
        defaultText: (0, $3aa4a91235bead55$export$5ff20667590927ed)(opt.seriesModel.getData(), dataIndex),
        inheritColor: symbolMeta.style.fill,
        defaultOpacity: symbolMeta.style.opacity,
        defaultOutsidePosition: barPositionOutside
    });
    (0, $b414df7d361a211c$export$e51187539ff11209)(bar, focus, blurScope, emphasisModel.get('disabled'));
}
function $99df958a3f3307eb$var$toIntTimes(times) {
    var roundedTimes = Math.round(times);
    // Escapse accurate error
    return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
}
var $99df958a3f3307eb$export$2e2bcd8739ae039 = $99df958a3f3307eb$var$PictorialBarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $f79a59cb32b7b677$var$PictorialBarSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PictorialBarSeriesModel, _super);
    function PictorialBarSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PictorialBarSeriesModel.type;
        _this.hasSymbolVisual = true;
        _this.defaultSymbol = 'roundRect';
        return _this;
    }
    PictorialBarSeriesModel.prototype.getInitialData = function(option) {
        // Disable stack.
        option.stack = null;
        return _super.prototype.getInitialData.apply(this, arguments);
    };
    PictorialBarSeriesModel.type = 'series.pictorialBar';
    PictorialBarSeriesModel.dependencies = [
        'grid'
    ];
    PictorialBarSeriesModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $9fc1adb8451c6cdc$export$2e2bcd8739ae039).defaultOption, {
        symbol: 'circle',
        symbolSize: null,
        symbolRotate: null,
        symbolPosition: null,
        symbolOffset: null,
        symbolMargin: null,
        symbolRepeat: false,
        symbolRepeatDirection: 'end',
        symbolClip: false,
        symbolBoundingData: null,
        symbolPatternSize: 400,
        barGap: '-100%',
        // Pictorial bar do not clip by default because in many cases
        // xAxis and yAxis are not displayed and it's expected not to clip
        clip: false,
        // z can be set in data item, which is z2 actually.
        // Disable progressive
        progressive: 0,
        emphasis: {
            // By default pictorialBar do not hover scale. Hover scale is not suitable
            // for the case that both has foreground and background.
            scale: false
        },
        select: {
            itemStyle: {
                borderColor: '#212121'
            }
        }
    });
    return PictorialBarSeriesModel;
}((0, $9fc1adb8451c6cdc$export$2e2bcd8739ae039));
var $f79a59cb32b7b677$export$2e2bcd8739ae039 = $f79a59cb32b7b677$var$PictorialBarSeriesModel;




function $80e5f7bfc017ec2e$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $99df958a3f3307eb$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $f79a59cb32b7b677$export$2e2bcd8739ae039));
    registers.registerLayout(registers.PRIORITY.VISUAL.LAYOUT, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)((0, $b069e7ac30ed5deb$export$b3219800bda33a1f), 'pictorialBar'));
    // Do layout after other overall layout, which can prepare some information.
    registers.registerLayout(registers.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, (0, $b069e7ac30ed5deb$export$16e8685758531cb6)('pictorialBar'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $ee9e6c288b273332$var$ThemeRiverView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ThemeRiverView, _super);
    function ThemeRiverView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverView.type;
        _this._layers = [];
        return _this;
    }
    ThemeRiverView.prototype.render = function(seriesModel, ecModel, api) {
        var data = seriesModel.getData();
        var self = this;
        var group = this.group;
        var layersSeries = seriesModel.getLayerSeries();
        var layoutInfo = data.getLayout('layoutInfo');
        var rect = layoutInfo.rect;
        var boundaryGap = layoutInfo.boundaryGap;
        group.x = 0;
        group.y = rect.y + boundaryGap[0];
        function keyGetter(item) {
            return item.name;
        }
        var dataDiffer = new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(this._layersSeries || [], layersSeries, keyGetter, keyGetter);
        var newLayersGroups = [];
        dataDiffer.add((0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(process, this, 'add')).update((0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(process, this, 'update')).remove((0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(process, this, 'remove')).execute();
        function process(status, idx, oldIdx) {
            var oldLayersGroups = self._layers;
            if (status === 'remove') {
                group.remove(oldLayersGroups[idx]);
                return;
            }
            var points0 = [];
            var points1 = [];
            var style;
            var indices = layersSeries[idx].indices;
            var j = 0;
            for(; j < indices.length; j++){
                var layout = data.getItemLayout(indices[j]);
                var x = layout.x;
                var y0 = layout.y0;
                var y = layout.y;
                points0.push(x, y0);
                points1.push(x, y0 + y);
                style = data.getItemVisual(indices[j], 'style');
            }
            var polygon;
            var textLayout = data.getItemLayout(indices[0]);
            var labelModel = seriesModel.getModel('label');
            var margin = labelModel.get('margin');
            var emphasisModel = seriesModel.getModel('emphasis');
            if (status === 'add') {
                var layerGroup = newLayersGroups[idx] = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
                polygon = new (0, $4994818843f5bc5a$export$6042a400d113f2bd)({
                    shape: {
                        points: points0,
                        stackedOnPoints: points1,
                        smooth: 0.4,
                        stackedOnSmooth: 0.4,
                        smoothConstraint: false
                    },
                    z2: 0
                });
                layerGroup.add(polygon);
                group.add(layerGroup);
                if (seriesModel.isAnimationEnabled()) polygon.setClipPath($ee9e6c288b273332$var$createGridClipShape(polygon.getBoundingRect(), seriesModel, function() {
                    polygon.removeClipPath();
                }));
            } else {
                var layerGroup = oldLayersGroups[oldIdx];
                polygon = layerGroup.childAt(0);
                group.add(layerGroup);
                newLayersGroups[idx] = layerGroup;
                $b40111164617dd60$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: points0,
                        stackedOnPoints: points1
                    }
                }, seriesModel);
                (0, $b40111164617dd60$export$bca7290a9faf0ec9)(polygon);
            }
            (0, $3828198b2f2de836$export$9a13992917966657)(polygon, (0, $3828198b2f2de836$export$9739a32674be5893)(seriesModel), {
                labelDataIndex: indices[j - 1],
                defaultText: data.getName(indices[j - 1]),
                inheritColor: style.fill
            }, {
                normal: {
                    verticalAlign: 'middle'
                }
            });
            polygon.setTextConfig({
                position: null,
                local: true
            });
            var labelEl = polygon.getTextContent();
            // TODO More label position options.
            if (labelEl) {
                labelEl.x = textLayout.x - margin;
                labelEl.y = textLayout.y0 + textLayout.y / 2;
            }
            polygon.useStyle(style);
            data.setItemGraphicEl(idx, polygon);
            (0, $b414df7d361a211c$export$48b68047d330bbc9)(polygon, seriesModel);
            (0, $b414df7d361a211c$export$e51187539ff11209)(polygon, emphasisModel.get('focus'), emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
        }
        this._layersSeries = layersSeries;
        this._layers = newLayersGroups;
    };
    ThemeRiverView.type = 'themeRiver';
    return ThemeRiverView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
// add animation to the view
function $ee9e6c288b273332$var$createGridClipShape(rect, seriesModel, cb) {
    var rectEl = new $37476269d425e3f6$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - 10,
            y: rect.y - 10,
            width: 0,
            height: rect.height + 20
        }
    });
    $b40111164617dd60$export$a121566aadcfe021(rectEl, {
        shape: {
            x: rect.x - 50,
            width: rect.width + 100,
            height: rect.height + 20
        }
    }, seriesModel, cb);
    return rectEl;
}
var $ee9e6c288b273332$export$2e2bcd8739ae039 = $ee9e6c288b273332$var$ThemeRiverView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $0ff92129212a375c$var$DATA_NAME_INDEX = 2;
var $0ff92129212a375c$var$ThemeRiverSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ThemeRiverSeriesModel, _super);
    function ThemeRiverSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ThemeRiverSeriesModel.type;
        return _this;
    }
    /**
   * @override
   */ ThemeRiverSeriesModel.prototype.init = function(option) {
        // eslint-disable-next-line
        _super.prototype.init.apply(this, arguments);
        // Put this function here is for the sake of consistency of code style.
        // Enable legend selection for each data item
        // Use a function instead of direct access because data reference may changed
        this.legendVisualProvider = new (0, $f7d155e85e188448$export$2e2bcd8739ae039)($1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getData, this), $1b239fc9d3a2f8ae$export$2385a24977818dd0(this.getRawData, this));
    };
    /**
   * If there is no value of a certain point in the time for some event,set it value to 0.
   *
   * @param {Array} data  initial data in the option
   * @return {Array}
   */ ThemeRiverSeriesModel.prototype.fixData = function(data) {
        var rawDataLength = data.length;
        /**
     * Make sure every layer data get the same keys.
     * The value index tells which layer has visited.
     * {
     *  2014/01/01: -1
     * }
     */ var timeValueKeys = {};
        // grouped data by name
        var groupResult = (0, $9ac03c46e8b6e711$export$7ab5bda43e13168f)(data, function(item) {
            if (!timeValueKeys.hasOwnProperty(item[0] + '')) timeValueKeys[item[0] + ''] = -1;
            return item[2];
        });
        var layerData = [];
        groupResult.buckets.each(function(items, key) {
            layerData.push({
                name: key,
                dataList: items
            });
        });
        var layerNum = layerData.length;
        for(var k = 0; k < layerNum; ++k){
            var name_1 = layerData[k].name;
            for(var j = 0; j < layerData[k].dataList.length; ++j){
                var timeValue = layerData[k].dataList[j][0] + '';
                timeValueKeys[timeValue] = k;
            }
            for(var timeValue in timeValueKeys)if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
                timeValueKeys[timeValue] = k;
                data[rawDataLength] = [
                    timeValue,
                    0,
                    name_1
                ];
                rawDataLength++;
            }
        }
        return data;
    };
    /**
   * @override
   * @param  option  the initial option that user gave
   * @param  ecModel  the model object for themeRiver option
   */ ThemeRiverSeriesModel.prototype.getInitialData = function(option, ecModel) {
        var singleAxisModel = this.getReferringComponents('singleAxis', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
        var axisType = singleAxisModel.get('type');
        // filter the data item with the value of label is undefined
        var filterData = $1b239fc9d3a2f8ae$export$3dea766d36a8935f(option.data, function(dataItem) {
            return dataItem[2] !== undefined;
        });
        // ??? TODO design a stage to transfer data for themeRiver and lines?
        var data = this.fixData(filterData || []);
        var nameList = [];
        var nameMap = this.nameMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var count = 0;
        for(var i = 0; i < data.length; ++i){
            nameList.push(data[i][$0ff92129212a375c$var$DATA_NAME_INDEX]);
            if (!nameMap.get(data[i][$0ff92129212a375c$var$DATA_NAME_INDEX])) {
                nameMap.set(data[i][$0ff92129212a375c$var$DATA_NAME_INDEX], count);
                count++;
            }
        }
        var dimensions = (0, $02c5dbb1162b825d$export$2e2bcd8739ae039)(data, {
            coordDimensions: [
                'single'
            ],
            dimensionsDefine: [
                {
                    name: 'time',
                    type: (0, $e1ef773174d5a33a$export$af1622903e71278e)(axisType)
                },
                {
                    name: 'value',
                    type: 'float'
                },
                {
                    name: 'name',
                    type: 'ordinal'
                }
            ],
            encodeDefine: {
                single: 0,
                value: 1,
                itemName: 2
            }
        }).dimensions;
        var list = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(dimensions, this);
        list.initData(data);
        return list;
    };
    /**
   * The raw data is divided into multiple layers and each layer
   *     has same name.
   */ ThemeRiverSeriesModel.prototype.getLayerSeries = function() {
        var data = this.getData();
        var lenCount = data.count();
        var indexArr = [];
        for(var i = 0; i < lenCount; ++i)indexArr[i] = i;
        var timeDim = data.mapDimension('single');
        // data group by name
        var groupResult = (0, $9ac03c46e8b6e711$export$7ab5bda43e13168f)(indexArr, function(index) {
            return data.get('name', index);
        });
        var layerSeries = [];
        groupResult.buckets.each(function(items, key) {
            items.sort(function(index1, index2) {
                return data.get(timeDim, index1) - data.get(timeDim, index2);
            });
            layerSeries.push({
                name: key,
                indices: items
            });
        });
        return layerSeries;
    };
    /**
   * Get data indices for show tooltip content
   */ ThemeRiverSeriesModel.prototype.getAxisTooltipData = function(dim, value, baseAxis) {
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(dim)) dim = dim ? [
            dim
        ] : [];
        var data = this.getData();
        var layerSeries = this.getLayerSeries();
        var indices = [];
        var layerNum = layerSeries.length;
        var nestestValue;
        for(var i = 0; i < layerNum; ++i){
            var minDist = Number.MAX_VALUE;
            var nearestIdx = -1;
            var pointNum = layerSeries[i].indices.length;
            for(var j = 0; j < pointNum; ++j){
                var theValue = data.get(dim[0], layerSeries[i].indices[j]);
                var dist = Math.abs(theValue - value);
                if (dist <= minDist) {
                    nestestValue = theValue;
                    minDist = dist;
                    nearestIdx = layerSeries[i].indices[j];
                }
            }
            indices.push(nearestIdx);
        }
        return {
            dataIndices: indices,
            nestestValue: nestestValue
        };
    };
    ThemeRiverSeriesModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var name = data.getName(dataIndex);
        var value = data.get(data.mapDimension('value'), dataIndex);
        return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
            name: name,
            value: value
        });
    };
    ThemeRiverSeriesModel.type = 'series.themeRiver';
    ThemeRiverSeriesModel.dependencies = [
        'singleAxis'
    ];
    ThemeRiverSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        colorBy: 'data',
        coordinateSystem: 'singleAxis',
        // gap in axis's orthogonal orientation
        boundaryGap: [
            '10%',
            '10%'
        ],
        // legendHoverLink: true,
        singleAxisIndex: 0,
        animationEasing: 'linear',
        label: {
            margin: 4,
            show: true,
            position: 'left',
            fontSize: 11
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return ThemeRiverSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $0ff92129212a375c$export$2e2bcd8739ae039 = $0ff92129212a375c$var$ThemeRiverSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $75dfc7d16058880f$export$2e2bcd8739ae039(ecModel, api) {
    ecModel.eachSeriesByType('themeRiver', function(seriesModel) {
        var data = seriesModel.getData();
        var single = seriesModel.coordinateSystem;
        var layoutInfo = {};
        // use the axis boundingRect for view
        var rect = single.getRect();
        layoutInfo.rect = rect;
        var boundaryGap = seriesModel.get('boundaryGap');
        var axis = single.getAxis();
        layoutInfo.boundaryGap = boundaryGap;
        if (axis.orient === 'horizontal') {
            boundaryGap[0] = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(boundaryGap[0], rect.height);
            boundaryGap[1] = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(boundaryGap[1], rect.height);
            var height = rect.height - boundaryGap[0] - boundaryGap[1];
            $75dfc7d16058880f$var$doThemeRiverLayout(data, seriesModel, height);
        } else {
            boundaryGap[0] = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(boundaryGap[0], rect.width);
            boundaryGap[1] = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(boundaryGap[1], rect.width);
            var width = rect.width - boundaryGap[0] - boundaryGap[1];
            $75dfc7d16058880f$var$doThemeRiverLayout(data, seriesModel, width);
        }
        data.setLayout('layoutInfo', layoutInfo);
    });
}
/**
 * The layout information about themeriver
 *
 * @param data  data in the series
 * @param seriesModel  the model object of themeRiver series
 * @param height  value used to compute every series height
 */ function $75dfc7d16058880f$var$doThemeRiverLayout(data, seriesModel, height) {
    if (!data.count()) return;
    var coordSys = seriesModel.coordinateSystem;
    // the data in each layer are organized into a series.
    var layerSeries = seriesModel.getLayerSeries();
    // the points in each layer.
    var timeDim = data.mapDimension('single');
    var valueDim = data.mapDimension('value');
    var layerPoints = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(layerSeries, function(singleLayer) {
        return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(singleLayer.indices, function(idx) {
            var pt = coordSys.dataToPoint(data.get(timeDim, idx));
            pt[1] = data.get(valueDim, idx);
            return pt;
        });
    });
    var base = $75dfc7d16058880f$var$computeBaseline(layerPoints);
    var baseLine = base.y0;
    var ky = height / base.max;
    // set layout information for each item.
    var n = layerSeries.length;
    var m = layerSeries[0].indices.length;
    var baseY0;
    for(var j = 0; j < m; ++j){
        baseY0 = baseLine[j] * ky;
        data.setItemLayout(layerSeries[0].indices[j], {
            layerIndex: 0,
            x: layerPoints[0][j][0],
            y0: baseY0,
            y: layerPoints[0][j][1] * ky
        });
        for(var i = 1; i < n; ++i){
            baseY0 += layerPoints[i - 1][j][1] * ky;
            data.setItemLayout(layerSeries[i].indices[j], {
                layerIndex: i,
                x: layerPoints[i][j][0],
                y0: baseY0,
                y: layerPoints[i][j][1] * ky
            });
        }
    }
}
/**
 * Compute the baseLine of the rawdata
 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
 *
 * @param  data  the points in each layer
 */ function $75dfc7d16058880f$var$computeBaseline(data) {
    var layerNum = data.length;
    var pointNum = data[0].length;
    var sums = [];
    var y0 = [];
    var max = 0;
    for(var i = 0; i < pointNum; ++i){
        var temp = 0;
        for(var j = 0; j < layerNum; ++j)temp += data[j][i][1];
        if (temp > max) max = temp;
        sums.push(temp);
    }
    for(var k = 0; k < pointNum; ++k)y0[k] = (max - sums[k]) / 2;
    max = 0;
    for(var l = 0; l < pointNum; ++l){
        var sum = sums[l] + y0[l];
        if (sum > max) max = sum;
    }
    return {
        y0: y0,
        max: max
    };
}



function $8c75f7b1260d18e8$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $ee9e6c288b273332$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $0ff92129212a375c$export$2e2bcd8739ae039));
    registers.registerLayout((0, $75dfc7d16058880f$export$2e2bcd8739ae039));
    registers.registerProcessor((0, $2f4b2083cfaef73d$export$2e2bcd8739ae039)('themeRiver'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 










var $08dad55fa79f3e30$var$DEFAULT_SECTOR_Z = 2;
var $08dad55fa79f3e30$var$DEFAULT_TEXT_Z = 4;
/**
 * Sunburstce of Sunburst including Sector, Label, LabelLine
 */ var $08dad55fa79f3e30$var$SunburstPiece = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SunburstPiece, _super);
    function SunburstPiece(node, seriesModel, ecModel, api) {
        var _this = _super.call(this) || this;
        _this.z2 = $08dad55fa79f3e30$var$DEFAULT_SECTOR_Z;
        _this.textConfig = {
            inside: true
        };
        (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(_this).seriesIndex = seriesModel.seriesIndex;
        var text = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            z2: $08dad55fa79f3e30$var$DEFAULT_TEXT_Z,
            silent: node.getModel().get([
                'label',
                'silent'
            ])
        });
        _this.setTextContent(text);
        _this.updateData(true, node, seriesModel, ecModel, api);
        return _this;
    }
    SunburstPiece.prototype.updateData = function(firstCreate, node, // state: 'emphasis' | 'normal' | 'highlight' | 'downplay',
    seriesModel, ecModel, api) {
        this.node = node;
        node.piece = this;
        seriesModel = seriesModel || this._seriesModel;
        ecModel = ecModel || this._ecModel;
        var sector = this;
        (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(sector).dataIndex = node.dataIndex;
        var itemModel = node.getModel();
        var emphasisModel = itemModel.getModel('emphasis');
        var layout = node.getLayout();
        var sectorShape = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, layout);
        sectorShape.label = null;
        var normalStyle = node.getVisual('style');
        normalStyle.lineJoin = 'bevel';
        var decal = node.getVisual('decal');
        if (decal) normalStyle.decal = (0, $6d9628e7c6bac2b0$export$a3ba048e1a648972)(decal, api);
        var cornerRadius = (0, $76e2a0dbb7483b91$export$b395eeeb2ad7cce5)(itemModel.getModel('itemStyle'), sectorShape, true);
        $1b239fc9d3a2f8ae$export$8b58be045bf06082(sectorShape, cornerRadius);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43((0, $b414df7d361a211c$export$151308dceb52d5b), function(stateName) {
            var state = sector.ensureState(stateName);
            var itemStyleModel = itemModel.getModel([
                stateName,
                'itemStyle'
            ]);
            state.style = itemStyleModel.getItemStyle();
            // border radius
            var cornerRadius = (0, $76e2a0dbb7483b91$export$b395eeeb2ad7cce5)(itemStyleModel, sectorShape);
            if (cornerRadius) state.shape = cornerRadius;
        });
        if (firstCreate) {
            sector.setShape(sectorShape);
            sector.shape.r = layout.r0;
            $b40111164617dd60$export$a121566aadcfe021(sector, {
                shape: {
                    r: layout.r
                }
            }, seriesModel, node.dataIndex);
        } else {
            // Disable animation for gradient since no interpolation method
            // is supported for gradient
            $b40111164617dd60$export$c8dce3c08436e91e(sector, {
                shape: sectorShape
            }, seriesModel);
            (0, $b40111164617dd60$export$bca7290a9faf0ec9)(sector);
        }
        sector.useStyle(normalStyle);
        this._updateLabel(seriesModel);
        var cursorStyle = itemModel.getShallow('cursor');
        cursorStyle && sector.attr('cursor', cursorStyle);
        this._seriesModel = seriesModel || this._seriesModel;
        this._ecModel = ecModel || this._ecModel;
        var focus = emphasisModel.get('focus');
        var focusOrIndices = focus === 'relative' ? $1b239fc9d3a2f8ae$export$4fd8af2c48c43416(node.getAncestorsIndices(), node.getDescendantIndices()) : focus === 'ancestor' ? node.getAncestorsIndices() : focus === 'descendant' ? node.getDescendantIndices() : focus;
        (0, $b414df7d361a211c$export$e51187539ff11209)(this, focusOrIndices, emphasisModel.get('blurScope'), emphasisModel.get('disabled'));
    };
    SunburstPiece.prototype._updateLabel = function(seriesModel) {
        var _this = this;
        var itemModel = this.node.getModel();
        var normalLabelModel = itemModel.getModel('label');
        var layout = this.node.getLayout();
        var angle = layout.endAngle - layout.startAngle;
        var midAngle = (layout.startAngle + layout.endAngle) / 2;
        var dx = Math.cos(midAngle);
        var dy = Math.sin(midAngle);
        var sector = this;
        var label = sector.getTextContent();
        var dataIndex = this.node.dataIndex;
        var labelMinAngle = normalLabelModel.get('minAngle') / 180 * Math.PI;
        var isNormalShown = normalLabelModel.get('show') && !(labelMinAngle != null && Math.abs(angle) < labelMinAngle);
        label.ignore = !isNormalShown;
        // TODO use setLabelStyle
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43((0, $b414df7d361a211c$export$57ee5306b85ad7d5), function(stateName) {
            var labelStateModel = stateName === 'normal' ? itemModel.getModel('label') : itemModel.getModel([
                stateName,
                'label'
            ]);
            var isNormal = stateName === 'normal';
            var state = isNormal ? label : label.ensureState(stateName);
            var text = seriesModel.getFormattedLabel(dataIndex, stateName);
            if (isNormal) text = text || _this.node.name;
            state.style = (0, $3828198b2f2de836$export$f8998c3d0a13de59)(labelStateModel, {}, null, stateName !== 'normal', true);
            if (text) state.style.text = text;
            // Not displaying text when angle is too small
            var isShown = labelStateModel.get('show');
            if (isShown != null && !isNormal) state.ignore = !isShown;
            var labelPosition = getLabelAttr(labelStateModel, 'position');
            var sectorState = isNormal ? sector : sector.states[stateName];
            var labelColor = sectorState.style.fill;
            sectorState.textConfig = {
                outsideFill: labelStateModel.get('color') === 'inherit' ? labelColor : null,
                inside: labelPosition !== 'outside'
            };
            var r;
            var labelPadding = getLabelAttr(labelStateModel, 'distance') || 0;
            var textAlign = getLabelAttr(labelStateModel, 'align');
            var rotateType = getLabelAttr(labelStateModel, 'rotate');
            var flipStartAngle = Math.PI * 0.5;
            var flipEndAngle = Math.PI * 1.5;
            var midAngleNormal = (0, $1851ee851ae60f55$export$d44861331f213635)(rotateType === 'tangential' ? Math.PI / 2 - midAngle : midAngle);
            // For text that is up-side down, rotate 180 degrees to make sure
            // it's readable
            var needsFlip = midAngleNormal > flipStartAngle && !(0, $9fd90cf3bf18fbcd$export$d1df570aea2868f)(midAngleNormal - flipStartAngle) && midAngleNormal < flipEndAngle;
            if (labelPosition === 'outside') {
                r = layout.r + labelPadding;
                textAlign = needsFlip ? 'right' : 'left';
            } else {
                if (!textAlign || textAlign === 'center') {
                    // Put label in the center if it's a circle
                    if (angle === 2 * Math.PI && layout.r0 === 0) r = 0;
                    else r = (layout.r + layout.r0) / 2;
                    textAlign = 'center';
                } else if (textAlign === 'left') {
                    r = layout.r0 + labelPadding;
                    textAlign = needsFlip ? 'right' : 'left';
                } else if (textAlign === 'right') {
                    r = layout.r - labelPadding;
                    textAlign = needsFlip ? 'left' : 'right';
                }
            }
            state.style.align = textAlign;
            state.style.verticalAlign = getLabelAttr(labelStateModel, 'verticalAlign') || 'middle';
            state.x = r * dx + layout.cx;
            state.y = r * dy + layout.cy;
            var rotate = 0;
            if (rotateType === 'radial') rotate = (0, $1851ee851ae60f55$export$d44861331f213635)(-midAngle) + (needsFlip ? Math.PI : 0);
            else if (rotateType === 'tangential') rotate = (0, $1851ee851ae60f55$export$d44861331f213635)(Math.PI / 2 - midAngle) + (needsFlip ? Math.PI : 0);
            else if ($1b239fc9d3a2f8ae$export$7e4aa119212bc614(rotateType)) rotate = rotateType * Math.PI / 180;
            state.rotation = (0, $1851ee851ae60f55$export$d44861331f213635)(rotate);
        });
        function getLabelAttr(model, name) {
            var stateAttr = model.get(name);
            if (stateAttr == null) return normalLabelModel.get(name);
            return stateAttr;
        }
        label.dirtyStyle();
    };
    return SunburstPiece;
}($5fa26352e0605e60$export$2e2bcd8739ae039);
var $08dad55fa79f3e30$export$2e2bcd8739ae039 = $08dad55fa79f3e30$var$SunburstPiece;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $be262e9193f19f7b$export$b06afbbb40399c8b = 'sunburstRootToNode';
var $be262e9193f19f7b$var$HIGHLIGHT_ACTION = 'sunburstHighlight';
var $be262e9193f19f7b$var$UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
function $be262e9193f19f7b$export$d2def111ea616eb3(registers) {
    registers.registerAction({
        type: $be262e9193f19f7b$export$b06afbbb40399c8b,
        update: 'updateView'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sunburst',
            query: payload
        }, handleRootToNode);
        function handleRootToNode(model, index) {
            var targetInfo = (0, $cbdb4002b7a38cc3$export$c5445fa59c15dec4)(payload, [
                $be262e9193f19f7b$export$b06afbbb40399c8b
            ], model);
            if (targetInfo) {
                var originViewRoot = model.getViewRoot();
                if (originViewRoot) payload.direction = (0, $cbdb4002b7a38cc3$export$df59de26c77b5bea)(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
                model.resetViewRoot(targetInfo.node);
            }
        }
    });
    registers.registerAction({
        type: $be262e9193f19f7b$var$HIGHLIGHT_ACTION,
        update: 'none'
    }, function(payload, ecModel, api) {
        // Clone
        payload = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, payload);
        ecModel.eachComponent({
            mainType: 'series',
            subType: 'sunburst',
            query: payload
        }, handleHighlight);
        function handleHighlight(model) {
            var targetInfo = (0, $cbdb4002b7a38cc3$export$c5445fa59c15dec4)(payload, [
                $be262e9193f19f7b$var$HIGHLIGHT_ACTION
            ], model);
            if (targetInfo) payload.dataIndex = targetInfo.node.dataIndex;
        }
        // Fast forward action
        api.dispatchAction((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(payload, {
            type: 'highlight'
        }));
    });
    registers.registerAction({
        type: $be262e9193f19f7b$var$UNHIGHLIGHT_ACTION,
        update: 'updateView'
    }, function(payload, ecModel, api) {
        payload = (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, payload);
        api.dispatchAction((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(payload, {
            type: 'downplay'
        }));
    });
}



var $51a3fd2e1b504532$var$SunburstView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SunburstView, _super);
    function SunburstView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstView.type;
        return _this;
    }
    SunburstView.prototype.render = function(seriesModel, ecModel, api, // @ts-ignore
    payload) {
        var self = this;
        this.seriesModel = seriesModel;
        this.api = api;
        this.ecModel = ecModel;
        var data = seriesModel.getData();
        var virtualRoot = data.tree.root;
        var newRoot = seriesModel.getViewRoot();
        var group = this.group;
        var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
        var newChildren = [];
        newRoot.eachNode(function(node) {
            newChildren.push(node);
        });
        var oldChildren = this._oldChildren || [];
        dualTravel(newChildren, oldChildren);
        renderRollUp(virtualRoot, newRoot);
        this._initEvents();
        this._oldChildren = newChildren;
        function dualTravel(newChildren, oldChildren) {
            if (newChildren.length === 0 && oldChildren.length === 0) return;
            new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove($1b239fc9d3a2f8ae$export$c3095a23b368d1f2(processNode, null)).execute();
            function getKey(node) {
                return node.getId();
            }
            function processNode(newIdx, oldIdx) {
                var newNode = newIdx == null ? null : newChildren[newIdx];
                var oldNode = oldIdx == null ? null : oldChildren[oldIdx];
                doRenderNode(newNode, oldNode);
            }
        }
        function doRenderNode(newNode, oldNode) {
            if (!renderLabelForZeroData && newNode && !newNode.getValue()) // Not render data with value 0
            newNode = null;
            if (newNode !== virtualRoot && oldNode !== virtualRoot) {
                if (oldNode && oldNode.piece) {
                    if (newNode) {
                        // Update
                        oldNode.piece.updateData(false, newNode, seriesModel, ecModel, api);
                        // For tooltip
                        data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
                    } else // Remove
                    removeNode(oldNode);
                } else if (newNode) {
                    // Add
                    var piece = new (0, $08dad55fa79f3e30$export$2e2bcd8739ae039)(newNode, seriesModel, ecModel, api);
                    group.add(piece);
                    // For tooltip
                    data.setItemGraphicEl(newNode.dataIndex, piece);
                }
            }
        }
        function removeNode(node) {
            if (!node) return;
            if (node.piece) {
                group.remove(node.piece);
                node.piece = null;
            }
        }
        function renderRollUp(virtualRoot, viewRoot) {
            if (viewRoot.depth > 0) {
                // Render
                if (self.virtualPiece) // Update
                self.virtualPiece.updateData(false, virtualRoot, seriesModel, ecModel, api);
                else {
                    // Add
                    self.virtualPiece = new (0, $08dad55fa79f3e30$export$2e2bcd8739ae039)(virtualRoot, seriesModel, ecModel, api);
                    group.add(self.virtualPiece);
                }
                // TODO event scope
                viewRoot.piece.off('click');
                self.virtualPiece.on('click', function(e) {
                    self._rootToNode(viewRoot.parentNode);
                });
            } else if (self.virtualPiece) {
                // Remove
                group.remove(self.virtualPiece);
                self.virtualPiece = null;
            }
        }
    };
    /**
   * @private
   */ SunburstView.prototype._initEvents = function() {
        var _this = this;
        this.group.off('click');
        this.group.on('click', function(e) {
            var targetFound = false;
            var viewRoot = _this.seriesModel.getViewRoot();
            viewRoot.eachNode(function(node) {
                if (!targetFound && node.piece && node.piece === e.target) {
                    var nodeClick = node.getModel().get('nodeClick');
                    if (nodeClick === 'rootToNode') _this._rootToNode(node);
                    else if (nodeClick === 'link') {
                        var itemModel = node.getModel();
                        var link = itemModel.get('link');
                        if (link) {
                            var linkTarget = itemModel.get('target', true) || '_blank';
                            (0, $ff2fba995230f3c9$export$13e13f9b96dbe8fa)(link, linkTarget);
                        }
                    }
                    targetFound = true;
                }
            });
        });
    };
    /**
   * @private
   */ SunburstView.prototype._rootToNode = function(node) {
        if (node !== this.seriesModel.getViewRoot()) this.api.dispatchAction({
            type: (0, $be262e9193f19f7b$export$b06afbbb40399c8b),
            from: this.uid,
            seriesId: this.seriesModel.id,
            targetNode: node
        });
    };
    /**
   * @implement
   */ SunburstView.prototype.containPoint = function(point, seriesModel) {
        var treeRoot = seriesModel.getData();
        var itemLayout = treeRoot.getItemLayout(0);
        if (itemLayout) {
            var dx = point[0] - itemLayout.cx;
            var dy = point[1] - itemLayout.cy;
            var radius = Math.sqrt(dx * dx + dy * dy);
            return radius <= itemLayout.r && radius >= itemLayout.r0;
        }
    };
    SunburstView.type = 'sunburst';
    return SunburstView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $51a3fd2e1b504532$export$2e2bcd8739ae039 = $51a3fd2e1b504532$var$SunburstView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $5c857b2065a2f6b1$var$SunburstSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SunburstSeriesModel, _super);
    function SunburstSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SunburstSeriesModel.type;
        _this.ignoreStyleOnData = true;
        return _this;
    }
    SunburstSeriesModel.prototype.getInitialData = function(option, ecModel) {
        // Create a virtual root.
        var root = {
            name: option.name,
            children: option.data
        };
        $5c857b2065a2f6b1$var$completeTreeValue(root);
        var levelModels = this._levelModels = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(option.levels || [], function(levelDefine) {
            return new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(levelDefine, this, ecModel);
        }, this);
        // Make sure always a new tree is created when setOption,
        // in TreemapView, we check whether oldTree === newTree
        // to choose mappings approach among old shapes and new shapes.
        var tree = (0, $f0c725dcad2a6e38$export$2e2bcd8739ae039).createTree(root, this, beforeLink);
        function beforeLink(nodeData) {
            nodeData.wrapMethod('getItemModel', function(model, idx) {
                var node = tree.getNodeByDataIndex(idx);
                var levelModel = levelModels[node.depth];
                levelModel && (model.parentModel = levelModel);
                return model;
            });
        }
        return tree.data;
    };
    SunburstSeriesModel.prototype.optionUpdated = function() {
        this.resetViewRoot();
    };
    /*
   * @override
   */ SunburstSeriesModel.prototype.getDataParams = function(dataIndex) {
        var params = _super.prototype.getDataParams.apply(this, arguments);
        var node = this.getData().tree.getNodeByDataIndex(dataIndex);
        params.treePathInfo = (0, $cbdb4002b7a38cc3$export$c5baa480d6ceb0a3)(node, this);
        return params;
    };
    SunburstSeriesModel.prototype.getLevelModel = function(node) {
        return this._levelModels && this._levelModels[node.depth];
    };
    SunburstSeriesModel.prototype.getViewRoot = function() {
        return this._viewRoot;
    };
    SunburstSeriesModel.prototype.resetViewRoot = function(viewRoot) {
        viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
        var root = this.getRawData().tree.root;
        if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) this._viewRoot = root;
    };
    SunburstSeriesModel.prototype.enableAriaDecal = function() {
        (0, $94b6547605aff76f$export$2e2bcd8739ae039)(this);
    };
    SunburstSeriesModel.type = 'series.sunburst';
    SunburstSeriesModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        // 默认全局居中
        center: [
            '50%',
            '50%'
        ],
        radius: [
            0,
            '75%'
        ],
        // 默认顺时针
        clockwise: true,
        startAngle: 90,
        // 最小角度改为0
        minAngle: 0,
        // If still show when all data zero.
        stillShowZeroSum: true,
        // 'rootToNode', 'link', or false
        nodeClick: 'rootToNode',
        renderLabelForZeroData: false,
        label: {
            // could be: 'radial', 'tangential', or 'none'
            rotate: 'radial',
            show: true,
            opacity: 1,
            // 'left' is for inner side of inside, and 'right' is for outer
            // side for inside
            align: 'center',
            position: 'inside',
            distance: 5,
            silent: true
        },
        itemStyle: {
            borderWidth: 1,
            borderColor: 'white',
            borderType: 'solid',
            shadowBlur: 0,
            shadowColor: 'rgba(0, 0, 0, 0.2)',
            shadowOffsetX: 0,
            shadowOffsetY: 0,
            opacity: 1
        },
        emphasis: {
            focus: 'descendant'
        },
        blur: {
            itemStyle: {
                opacity: 0.2
            },
            label: {
                opacity: 0.1
            }
        },
        // Animation type can be expansion, scale.
        animationType: 'expansion',
        animationDuration: 1000,
        animationDurationUpdate: 500,
        data: [],
        /**
     * Sort order.
     *
     * Valid values: 'desc', 'asc', null, or callback function.
     * 'desc' and 'asc' for descend and ascendant order;
     * null for not sorting;
     * example of callback function:
     * function(nodeA, nodeB) {
     *     return nodeA.getValue() - nodeB.getValue();
     * }
     */ sort: 'desc'
    };
    return SunburstSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
function $5c857b2065a2f6b1$var$completeTreeValue(dataNode) {
    // Postorder travel tree.
    // If value of none-leaf node is not set,
    // calculate it by suming up the value of all children.
    var sum = 0;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(dataNode.children, function(child) {
        $5c857b2065a2f6b1$var$completeTreeValue(child);
        var childValue = child.value;
        // TODO First value of array must be a number
        $1b239fc9d3a2f8ae$export$43bee75e5e14138e(childValue) && (childValue = childValue[0]);
        sum += childValue;
    });
    var thisValue = dataNode.value;
    if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(thisValue)) thisValue = thisValue[0];
    if (thisValue == null || isNaN(thisValue)) thisValue = sum;
    // Value should not less than 0.
    if (thisValue < 0) thisValue = 0;
    $1b239fc9d3a2f8ae$export$43bee75e5e14138e(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
}
var $5c857b2065a2f6b1$export$2e2bcd8739ae039 = $5c857b2065a2f6b1$var$SunburstSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

// let PI2 = Math.PI * 2;
var $d044493528d8317d$var$RADIAN = Math.PI / 180;
function $d044493528d8317d$export$2e2bcd8739ae039(seriesType, ecModel, api) {
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        var center = seriesModel.get('center');
        var radius = seriesModel.get('radius');
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(radius)) radius = [
            0,
            radius
        ];
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(center)) center = [
            center,
            center
        ];
        var width = api.getWidth();
        var height = api.getHeight();
        var size = Math.min(width, height);
        var cx = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[0], width);
        var cy = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[1], height);
        var r0 = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(radius[0], size / 2);
        var r = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(radius[1], size / 2);
        var startAngle = -seriesModel.get('startAngle') * $d044493528d8317d$var$RADIAN;
        var minAngle = seriesModel.get('minAngle') * $d044493528d8317d$var$RADIAN;
        var virtualRoot = seriesModel.getData().tree.root;
        var treeRoot = seriesModel.getViewRoot();
        var rootDepth = treeRoot.depth;
        var sort = seriesModel.get('sort');
        if (sort != null) $d044493528d8317d$var$initChildren(treeRoot, sort);
        var validDataCount = 0;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(treeRoot.children, function(child) {
            !isNaN(child.getValue()) && validDataCount++;
        });
        var sum = treeRoot.getValue();
        // Sum may be 0
        var unitRadian = Math.PI / (sum || validDataCount) * 2;
        var renderRollupNode = treeRoot.depth > 0;
        var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
        var rPerLevel = (r - r0) / (levels || 1);
        var clockwise = seriesModel.get('clockwise');
        var stillShowZeroSum = seriesModel.get('stillShowZeroSum');
        // In the case some sector angle is smaller than minAngle
        // let restAngle = PI2;
        // let valueSumLargerThanMinAngle = 0;
        var dir = clockwise ? 1 : -1;
        /**
     * Render a tree
     * @return increased angle
     */ var renderNode = function(node, startAngle) {
            if (!node) return;
            var endAngle = startAngle;
            // Render self
            if (node !== virtualRoot) {
                // Tree node is virtual, so it doesn't need to be drawn
                var value = node.getValue();
                var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
                if (angle < minAngle) angle = minAngle;
                // else {
                //     valueSumLargerThanMinAngle += value;
                // }
                endAngle = startAngle + dir * angle;
                var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
                var rStart = r0 + rPerLevel * depth;
                var rEnd = r0 + rPerLevel * (depth + 1);
                var levelModel = seriesModel.getLevelModel(node);
                if (levelModel) {
                    var r0_1 = levelModel.get('r0', true);
                    var r_1 = levelModel.get('r', true);
                    var radius_1 = levelModel.get('radius', true);
                    if (radius_1 != null) {
                        r0_1 = radius_1[0];
                        r_1 = radius_1[1];
                    }
                    r0_1 != null && (rStart = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(r0_1, size / 2));
                    r_1 != null && (rEnd = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(r_1, size / 2));
                }
                node.setLayout({
                    angle: angle,
                    startAngle: startAngle,
                    endAngle: endAngle,
                    clockwise: clockwise,
                    cx: cx,
                    cy: cy,
                    r0: rStart,
                    r: rEnd
                });
            }
            // Render children
            if (node.children && node.children.length) {
                // currentAngle = startAngle;
                var siblingAngle_1 = 0;
                $1b239fc9d3a2f8ae$export$79b2f7037acddd43(node.children, function(node) {
                    siblingAngle_1 += renderNode(node, startAngle + siblingAngle_1);
                });
            }
            return endAngle - startAngle;
        };
        // Virtual root node for roll up
        if (renderRollupNode) {
            var rStart = r0;
            var rEnd = r0 + rPerLevel;
            var angle = Math.PI * 2;
            virtualRoot.setLayout({
                angle: angle,
                startAngle: startAngle,
                endAngle: startAngle + angle,
                clockwise: clockwise,
                cx: cx,
                cy: cy,
                r0: rStart,
                r: rEnd
            });
        }
        renderNode(treeRoot, startAngle);
    });
}
/**
 * Init node children by order and update visual
 */ function $d044493528d8317d$var$initChildren(node, sortOrder) {
    var children = node.children || [];
    node.children = $d044493528d8317d$var$sort(children, sortOrder);
    // Init children recursively
    if (children.length) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(node.children, function(child) {
        $d044493528d8317d$var$initChildren(child, sortOrder);
    });
}
/**
 * Sort children nodes
 *
 * @param {TreeNode[]}               children children of node to be sorted
 * @param {string | function | null} sort sort method
 *                                   See SunburstSeries.js for details.
 */ function $d044493528d8317d$var$sort(children, sortOrder) {
    if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(sortOrder)) {
        var sortTargets = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(children, function(child, idx) {
            var value = child.getValue();
            return {
                params: {
                    depth: child.depth,
                    height: child.height,
                    dataIndex: child.dataIndex,
                    getValue: function() {
                        return value;
                    }
                },
                index: idx
            };
        });
        sortTargets.sort(function(a, b) {
            return sortOrder(a.params, b.params);
        });
        return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(sortTargets, function(target) {
            return children[target.index];
        });
    } else {
        var isAsc_1 = sortOrder === 'asc';
        return children.sort(function(a, b) {
            var diff = (a.getValue() - b.getValue()) * (isAsc_1 ? 1 : -1);
            return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc_1 ? -1 : 1) : diff;
        });
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $a0fd61fcd930cfe1$export$2e2bcd8739ae039(ecModel) {
    var paletteScope = {};
    // Default color strategy
    function pickColor(node, seriesModel, treeHeight) {
        // Choose color from palette based on the first level.
        var current = node;
        while(current && current.depth > 1)current = current.parentNode;
        var color = seriesModel.getColorFromPalette(current.name || current.dataIndex + '', paletteScope);
        if (node.depth > 1 && (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(color)) // Lighter on the deeper level.
        color = (0, $35573db24643e2ef$export$590e8b2c435046d9)(color, (node.depth - 1) / (treeHeight - 1) * 0.5);
        return color;
    }
    ecModel.eachSeriesByType('sunburst', function(seriesModel) {
        var data = seriesModel.getData();
        var tree = data.tree;
        tree.eachNode(function(node) {
            var model = node.getModel();
            var style = model.getModel('itemStyle').getItemStyle();
            if (!style.fill) style.fill = pickColor(node, seriesModel, tree.root.height);
            var existsStyle = data.ensureUniqueItemVisual(node.dataIndex, 'style');
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(existsStyle, style);
        });
    });
}





function $c27c6ba19daaef65$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $51a3fd2e1b504532$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $5c857b2065a2f6b1$export$2e2bcd8739ae039));
    registers.registerLayout((0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)((0, $d044493528d8317d$export$2e2bcd8739ae039), 'sunburst'));
    registers.registerProcessor((0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)((0, $2f4b2083cfaef73d$export$2e2bcd8739ae039), 'sunburst'));
    registers.registerVisual((0, $a0fd61fcd930cfe1$export$2e2bcd8739ae039));
    (0, $be262e9193f19f7b$export$d2def111ea616eb3)(registers);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $b0b459864cc21fca$export$84369c8e2229fa7f = {
    color: 'fill',
    borderColor: 'stroke'
};
var $b0b459864cc21fca$export$734d775a14929701 = {
    symbol: 1,
    symbolSize: 1,
    symbolKeepAspect: 1,
    legendIcon: 1,
    visualMeta: 1,
    liftZ: 1,
    decal: 1
};
var $b0b459864cc21fca$export$dd5c3cc86073562f = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $b0b459864cc21fca$var$CustomSeriesModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CustomSeriesModel, _super);
    function CustomSeriesModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomSeriesModel.type;
        return _this;
    }
    CustomSeriesModel.prototype.optionUpdated = function() {
        this.currentZLevel = this.get('zlevel', true);
        this.currentZ = this.get('z', true);
    };
    CustomSeriesModel.prototype.getInitialData = function(option, ecModel) {
        return (0, $82d36b0ba2609dcb$export$2e2bcd8739ae039)(null, this);
    };
    CustomSeriesModel.prototype.getDataParams = function(dataIndex, dataType, el) {
        var params = _super.prototype.getDataParams.call(this, dataIndex, dataType);
        el && (params.info = $b0b459864cc21fca$export$dd5c3cc86073562f(el).info);
        return params;
    };
    CustomSeriesModel.type = 'series.custom';
    CustomSeriesModel.dependencies = [
        'grid',
        'polar',
        'geo',
        'singleAxis',
        'calendar'
    ];
    CustomSeriesModel.defaultOption = {
        coordinateSystem: 'cartesian2d',
        // zlevel: 0,
        z: 2,
        legendHoverLink: true,
        // Custom series will not clip by default.
        // Some case will use custom series to draw label
        // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
        clip: false
    };
    return CustomSeriesModel;
}((0, $19b580a0cd6e92eb$export$2e2bcd8739ae039));
var $b0b459864cc21fca$export$2e2bcd8739ae039 = $b0b459864cc21fca$var$CustomSeriesModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 









/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $857c01f69c883950$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88([
        'x',
        'y'
    ], function(dim, dimIdx) {
        var axis = this.getAxis(dim);
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
    }, this);
}
function $857c01f69c883950$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.master.getRect();
    return {
        coordSys: {
            // The name exposed to user is always 'cartesian2d' but not 'grid'.
            type: 'cartesian2d',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(data) {
                // do not provide "out" param
                return coordSys.dataToPoint(data);
            },
            size: $1b239fc9d3a2f8ae$export$2385a24977818dd0($857c01f69c883950$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $9b362282a6e5e6b3$var$dataToCoordSize(dataSize, dataItem) {
    dataItem = dataItem || [
        0,
        0
    ];
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88([
        0,
        1
    ], function(dimIdx) {
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var p1 = [];
        var p2 = [];
        p1[dimIdx] = val - halfSize;
        p2[dimIdx] = val + halfSize;
        p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
        return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
    }, this);
}
function $9b362282a6e5e6b3$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getBoundingRect();
    return {
        coordSys: {
            type: 'geo',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            zoom: coordSys.getZoom()
        },
        api: {
            coord: function(data) {
                // do not provide "out" and noRoam param,
                // Compatible with this usage:
                // echarts.util.map(item.points, api.coord)
                return coordSys.dataToPoint(data);
            },
            size: $1b239fc9d3a2f8ae$export$2385a24977818dd0($9b362282a6e5e6b3$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $5c26c2ae786e1f88$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    var axis = this.getAxis();
    var val = dataItem instanceof Array ? dataItem[0] : dataItem;
    var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
}
function $5c26c2ae786e1f88$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    return {
        coordSys: {
            type: 'singleAxis',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height
        },
        api: {
            coord: function(val) {
                // do not provide "out" param
                return coordSys.dataToPoint(val);
            },
            size: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($5c26c2ae786e1f88$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
// import AngleAxis from './AngleAxis.js';
function $e305008378be31bf$var$dataToCoordSize(dataSize, dataItem) {
    // dataItem is necessary in log axis.
    dataItem = dataItem || [
        0,
        0
    ];
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88([
        'Radius',
        'Angle'
    ], function(dim, dimIdx) {
        var getterName = 'get' + dim + 'Axis';
        // TODO: TYPE Check Angle Axis
        var axis = this[getterName]();
        var val = dataItem[dimIdx];
        var halfSize = dataSize[dimIdx] / 2;
        var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
        if (dim === 'Angle') result = result * Math.PI / 180;
        return result;
    }, this);
}
function $e305008378be31bf$export$2e2bcd8739ae039(coordSys) {
    var radiusAxis = coordSys.getRadiusAxis();
    var angleAxis = coordSys.getAngleAxis();
    var radius = radiusAxis.getExtent();
    radius[0] > radius[1] && radius.reverse();
    return {
        coordSys: {
            type: 'polar',
            cx: coordSys.cx,
            cy: coordSys.cy,
            r: radius[1],
            r0: radius[0]
        },
        api: {
            coord: function(data) {
                var radius = radiusAxis.dataToRadius(data[0]);
                var angle = angleAxis.dataToAngle(data[1]);
                var coord = coordSys.coordToPoint([
                    radius,
                    angle
                ]);
                coord.push(radius, angle * Math.PI / 180);
                return coord;
            },
            size: $1b239fc9d3a2f8ae$export$2385a24977818dd0($e305008378be31bf$var$dataToCoordSize, coordSys)
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $f31773547cc0a64a$export$2e2bcd8739ae039(coordSys) {
    var rect = coordSys.getRect();
    var rangeInfo = coordSys.getRangeInfo();
    return {
        coordSys: {
            type: 'calendar',
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            cellWidth: coordSys.getCellWidth(),
            cellHeight: coordSys.getCellHeight(),
            rangeInfo: {
                start: rangeInfo.start,
                end: rangeInfo.end,
                weeks: rangeInfo.weeks,
                dayCount: rangeInfo.allDay
            }
        },
        api: {
            coord: function(data, clamp) {
                return coordSys.dataToPoint(data, clamp);
            }
        }
    };
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $412257960513441c$var$deprecatedLogs = {};
function $412257960513441c$export$3b868abde5eae7d1(style, elType, hasOwnTextContentOption, hasOwnTextConfig) {
    // Since echarts5, `RectText` is separated from its host element and style.text
    // does not exist any more. The compat work brings some extra burden on performance.
    // So we provide:
    // `legacy: true` force make compat.
    // `legacy: false`, force do not compat.
    // `legacy` not set: auto detect whether legacy.
    //     But in this case we do not compat (difficult to detect and rare case):
    //     Becuse custom series and graphic component support "merge", users may firstly
    //     only set `textStrokeWidth` style or secondly only set `text`.
    return style && (style.legacy || style.legacy !== false && !hasOwnTextContentOption && !hasOwnTextConfig && elType !== 'tspan' && (elType === 'text' || (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(style, 'text')));
}
function $412257960513441c$export$7748133eaaa8aecc(hostStyle, elType, isNormal) {
    var srcStyle = hostStyle;
    var textConfig;
    var textContent;
    var textContentStyle;
    if (elType === 'text') textContentStyle = srcStyle;
    else {
        textContentStyle = {};
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'text') && (textContentStyle.text = srcStyle.text);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'rich') && (textContentStyle.rich = srcStyle.rich);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'textFill') && (textContentStyle.fill = srcStyle.textFill);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'textStroke') && (textContentStyle.stroke = srcStyle.textStroke);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'fontFamily') && (textContentStyle.fontFamily = srcStyle.fontFamily);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'fontSize') && (textContentStyle.fontSize = srcStyle.fontSize);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'fontStyle') && (textContentStyle.fontStyle = srcStyle.fontStyle);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'fontWeight') && (textContentStyle.fontWeight = srcStyle.fontWeight);
        textContent = {
            type: 'text',
            style: textContentStyle,
            // ec4 does not support rectText trigger.
            // And when text position is different in normal and emphasis
            // => hover text trigger emphasis;
            // => text position changed, leave mouse pointer immediately;
            // That might cause incorrect state.
            silent: true
        };
        textConfig = {};
        var hasOwnPos = (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'textPosition');
        if (isNormal) textConfig.position = hasOwnPos ? srcStyle.textPosition : 'inside';
        else hasOwnPos && (textConfig.position = srcStyle.textPosition);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'textPosition') && (textConfig.position = srcStyle.textPosition);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'textOffset') && (textConfig.offset = srcStyle.textOffset);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'textRotation') && (textConfig.rotation = srcStyle.textRotation);
        (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(srcStyle, 'textDistance') && (textConfig.distance = srcStyle.textDistance);
    }
    $412257960513441c$var$convertEC4CompatibleRichItem(textContentStyle, hostStyle);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(textContentStyle.rich, function(richItem) {
        $412257960513441c$var$convertEC4CompatibleRichItem(richItem, richItem);
    });
    return {
        textConfig: textConfig,
        textContent: textContent
    };
}
/**
 * The result will be set to `out`.
 */ function $412257960513441c$var$convertEC4CompatibleRichItem(out, richItem) {
    if (!richItem) return;
    // (1) For simplicity, make textXXX properties (deprecated since ec5) has
    // higher priority. For example, consider in ec4 `borderColor: 5, textBorderColor: 10`
    // on a rect means `borderColor: 4` on the rect and `borderColor: 10` on an attached
    // richText in ec5.
    // (2) `out === richItem` if and only if `out` is text el or rich item.
    // So we can overwrite existing props in `out` since textXXX has higher priority.
    richItem.font = richItem.textFont || richItem.font;
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textStrokeWidth') && (out.lineWidth = richItem.textStrokeWidth);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textAlign') && (out.align = richItem.textAlign);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textVerticalAlign') && (out.verticalAlign = richItem.textVerticalAlign);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textLineHeight') && (out.lineHeight = richItem.textLineHeight);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textWidth') && (out.width = richItem.textWidth);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textHeight') && (out.height = richItem.textHeight);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBackgroundColor') && (out.backgroundColor = richItem.textBackgroundColor);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textPadding') && (out.padding = richItem.textPadding);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBorderColor') && (out.borderColor = richItem.textBorderColor);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBorderWidth') && (out.borderWidth = richItem.textBorderWidth);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBorderRadius') && (out.borderRadius = richItem.textBorderRadius);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowColor') && (out.shadowColor = richItem.textBoxShadowColor);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowBlur') && (out.shadowBlur = richItem.textBoxShadowBlur);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowOffsetX') && (out.shadowOffsetX = richItem.textBoxShadowOffsetX);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textBoxShadowOffsetY') && (out.shadowOffsetY = richItem.textBoxShadowOffsetY);
}
function $412257960513441c$export$b8ddb75bd1b9b791(itemStl, txStl, txCfg) {
    var out = itemStl;
    // See `custom.ts`, a trick to set extra `textPosition` firstly.
    out.textPosition = out.textPosition || txCfg.position || 'inside';
    txCfg.offset != null && (out.textOffset = txCfg.offset);
    txCfg.rotation != null && (out.textRotation = txCfg.rotation);
    txCfg.distance != null && (out.textDistance = txCfg.distance);
    var isInside = out.textPosition.indexOf('inside') >= 0;
    var hostFill = itemStl.fill || '#000';
    $412257960513441c$var$convertToEC4RichItem(out, txStl);
    var textFillNotSet = out.textFill == null;
    if (isInside) {
        if (textFillNotSet) {
            out.textFill = txCfg.insideFill || '#fff';
            !out.textStroke && txCfg.insideStroke && (out.textStroke = txCfg.insideStroke);
            !out.textStroke && (out.textStroke = hostFill);
            out.textStrokeWidth == null && (out.textStrokeWidth = 2);
        }
    } else {
        if (textFillNotSet) out.textFill = itemStl.fill || txCfg.outsideFill || '#000';
        !out.textStroke && txCfg.outsideStroke && (out.textStroke = txCfg.outsideStroke);
    }
    out.text = txStl.text;
    out.rich = txStl.rich;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(txStl.rich, function(richItem) {
        $412257960513441c$var$convertToEC4RichItem(richItem, richItem);
    });
    return out;
}
function $412257960513441c$var$convertToEC4RichItem(out, richItem) {
    if (!richItem) return;
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'fill') && (out.textFill = richItem.fill);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'stroke') && (out.textStroke = richItem.fill);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'lineWidth') && (out.textStrokeWidth = richItem.lineWidth);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'font') && (out.font = richItem.font);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'fontStyle') && (out.fontStyle = richItem.fontStyle);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'fontWeight') && (out.fontWeight = richItem.fontWeight);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'fontSize') && (out.fontSize = richItem.fontSize);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'fontFamily') && (out.fontFamily = richItem.fontFamily);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'align') && (out.textAlign = richItem.align);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'verticalAlign') && (out.textVerticalAlign = richItem.verticalAlign);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'lineHeight') && (out.textLineHeight = richItem.lineHeight);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'width') && (out.textWidth = richItem.width);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'height') && (out.textHeight = richItem.height);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'backgroundColor') && (out.textBackgroundColor = richItem.backgroundColor);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'padding') && (out.textPadding = richItem.padding);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'borderColor') && (out.textBorderColor = richItem.borderColor);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'borderWidth') && (out.textBorderWidth = richItem.borderWidth);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'borderRadius') && (out.textBorderRadius = richItem.borderRadius);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'shadowColor') && (out.textBoxShadowColor = richItem.shadowColor);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'shadowBlur') && (out.textBoxShadowBlur = richItem.shadowBlur);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'shadowOffsetX') && (out.textBoxShadowOffsetX = richItem.shadowOffsetX);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'shadowOffsetY') && (out.textBoxShadowOffsetY = richItem.shadowOffsetY);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textShadowColor') && (out.textShadowColor = richItem.textShadowColor);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textShadowBlur') && (out.textShadowBlur = richItem.textShadowBlur);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textShadowOffsetX') && (out.textShadowOffsetX = richItem.textShadowOffsetX);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(richItem, 'textShadowOffsetY') && (out.textShadowOffsetY = richItem.textShadowOffsetY);
}
function $412257960513441c$export$606a5c06d13e04b6(deprecated, insteadApproach) {
    var key;
}





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $4ad5d316e369014d$var$LEGACY_TRANSFORM_PROPS_MAP = {
    position: [
        'x',
        'y'
    ],
    scale: [
        'scaleX',
        'scaleY'
    ],
    origin: [
        'originX',
        'originY'
    ]
};
var $4ad5d316e369014d$var$LEGACY_TRANSFORM_PROPS = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)($4ad5d316e369014d$var$LEGACY_TRANSFORM_PROPS_MAP);
var $4ad5d316e369014d$var$TRANSFORM_PROPS_MAP = (0, $1b239fc9d3a2f8ae$export$533b26079ad0b4b)((0, $cd11a033fc7d29e7$export$98ab6203ec3396e2), function(obj, key) {
    obj[key] = 1;
    return obj;
}, {});
var $4ad5d316e369014d$var$transformPropNamesStr = (0, $cd11a033fc7d29e7$export$98ab6203ec3396e2).join(', ');
var $4ad5d316e369014d$export$9a911ad86e905b13 = [
    '',
    'style',
    'shape',
    'extra'
];
var $4ad5d316e369014d$var$transitionInnerStore = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $4ad5d316e369014d$var$getElementAnimationConfig(animationType, el, elOption, parentModel, dataIndex) {
    var animationProp = animationType + "Animation";
    var config = (0, $b40111164617dd60$export$5cc7add7ab591d0a)(animationType, parentModel, dataIndex) || {};
    var userDuring = $4ad5d316e369014d$var$transitionInnerStore(el).userDuring;
    // Only set when duration is > 0 and it's need to be animated.
    if (config.duration > 0) {
        // For simplicity, if during not specified, the previous during will not work any more.
        config.during = userDuring ? (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($4ad5d316e369014d$var$duringCall, {
            el: el,
            userDuring: userDuring
        }) : null;
        config.setToFinal = true;
        config.scope = animationType;
    }
    (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(config, elOption[animationProp]);
    return config;
}
function $4ad5d316e369014d$export$4342b281b9b5d77e(el, elOption, animatableModel, opts) {
    opts = opts || {};
    var dataIndex = opts.dataIndex, isInit = opts.isInit, clearStyle = opts.clearStyle;
    var hasAnimation = animatableModel.isAnimationEnabled();
    // Save the meta info for further morphing. Like apply on the sub morphing elements.
    var store = $4ad5d316e369014d$var$transitionInnerStore(el);
    var styleOpt = elOption.style;
    store.userDuring = elOption.during;
    var transFromProps = {};
    var propsToSet = {};
    $4ad5d316e369014d$var$prepareTransformAllPropsFinal(el, elOption, propsToSet);
    $4ad5d316e369014d$var$prepareShapeOrExtraAllPropsFinal('shape', elOption, propsToSet);
    $4ad5d316e369014d$var$prepareShapeOrExtraAllPropsFinal('extra', elOption, propsToSet);
    if (!isInit && hasAnimation) {
        $4ad5d316e369014d$var$prepareTransformTransitionFrom(el, elOption, transFromProps);
        $4ad5d316e369014d$var$prepareShapeOrExtraTransitionFrom('shape', el, elOption, transFromProps);
        $4ad5d316e369014d$var$prepareShapeOrExtraTransitionFrom('extra', el, elOption, transFromProps);
        $4ad5d316e369014d$var$prepareStyleTransitionFrom(el, elOption, styleOpt, transFromProps);
    }
    propsToSet.style = styleOpt;
    $4ad5d316e369014d$var$applyPropsDirectly(el, propsToSet, clearStyle);
    $4ad5d316e369014d$var$applyMiscProps(el, elOption);
    if (hasAnimation) {
        if (isInit) {
            var enterFromProps_1 = {};
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($4ad5d316e369014d$export$9a911ad86e905b13, function(propName) {
                var prop = propName ? elOption[propName] : elOption;
                if (prop && prop.enterFrom) {
                    if (propName) enterFromProps_1[propName] = enterFromProps_1[propName] || {};
                    (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(propName ? enterFromProps_1[propName] : enterFromProps_1, prop.enterFrom);
                }
            });
            var config = $4ad5d316e369014d$var$getElementAnimationConfig('enter', el, elOption, animatableModel, dataIndex);
            if (config.duration > 0) el.animateFrom(enterFromProps_1, config);
        } else $4ad5d316e369014d$var$applyPropsTransition(el, elOption, dataIndex || 0, animatableModel, transFromProps);
    }
    // Store leave to be used in leave transition.
    $4ad5d316e369014d$export$a6f11bb1cb100e2a(el, elOption);
    styleOpt ? el.dirty() : el.markRedraw();
}
function $4ad5d316e369014d$export$a6f11bb1cb100e2a(el, elOption) {
    // Try merge to previous set leaveTo
    var leaveToProps = $4ad5d316e369014d$var$transitionInnerStore(el).leaveToProps;
    for(var i = 0; i < $4ad5d316e369014d$export$9a911ad86e905b13.length; i++){
        var propName = $4ad5d316e369014d$export$9a911ad86e905b13[i];
        var prop = propName ? elOption[propName] : elOption;
        if (prop && prop.leaveTo) {
            if (!leaveToProps) leaveToProps = $4ad5d316e369014d$var$transitionInnerStore(el).leaveToProps = {};
            if (propName) leaveToProps[propName] = leaveToProps[propName] || {};
            (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(propName ? leaveToProps[propName] : leaveToProps, prop.leaveTo);
        }
    }
}
function $4ad5d316e369014d$export$15575b6d82d35bb3(el, elOption, animatableModel, onRemove) {
    if (el) {
        var parent_1 = el.parent;
        var leaveToProps = $4ad5d316e369014d$var$transitionInnerStore(el).leaveToProps;
        if (leaveToProps) {
            // TODO TODO use leave after leaveAnimation in series is introduced
            // TODO Data index?
            var config = $4ad5d316e369014d$var$getElementAnimationConfig('update', el, elOption, animatableModel, 0);
            config.done = function() {
                parent_1.remove(el);
                onRemove && onRemove();
            };
            el.animateTo(leaveToProps, config);
        } else {
            parent_1.remove(el);
            onRemove && onRemove();
        }
    }
}
function $4ad5d316e369014d$export$6f3361b4b8d7a8ba(transition) {
    return transition === 'all';
}
function $4ad5d316e369014d$var$applyPropsDirectly(el, // Can be null/undefined
allPropsFinal, clearStyle) {
    var styleOpt = allPropsFinal.style;
    if (!el.isGroup && styleOpt) {
        if (clearStyle) {
            el.useStyle({});
            // When style object changed, how to trade the existing animation?
            // It is probably complicated and not needed to cover all the cases.
            // But still need consider the case:
            // (1) When using init animation on `style.opacity`, and before the animation
            //     ended users triggers an update by mousewhel. At that time the init
            //     animation should better be continued rather than terminated.
            //     So after `useStyle` called, we should change the animation target manually
            //     to continue the effect of the init animation.
            // (2) PENDING: If the previous animation targeted at a `val1`, and currently we need
            //     to update the value to `val2` and no animation declared, should be terminate
            //     the previous animation or just modify the target of the animation?
            //     Therotically That will happen not only on `style` but also on `shape` and
            //     `transfrom` props. But we haven't handle this case at present yet.
            // (3) PENDING: Is it proper to visit `animators` and `targetName`?
            var animators = el.animators;
            for(var i = 0; i < animators.length; i++){
                var animator = animators[i];
                // targetName is the "topKey".
                if (animator.targetName === 'style') animator.changeTarget(el.style);
            }
        }
        el.setStyle(styleOpt);
    }
    if (allPropsFinal) {
        // Not set style here.
        allPropsFinal.style = null;
        // Set el to the final state firstly.
        allPropsFinal && el.attr(allPropsFinal);
        allPropsFinal.style = styleOpt;
    }
}
function $4ad5d316e369014d$var$applyPropsTransition(el, elOption, dataIndex, model, // Can be null/undefined
transFromProps) {
    if (transFromProps) {
        var config = $4ad5d316e369014d$var$getElementAnimationConfig('update', el, elOption, model, dataIndex);
        if (config.duration > 0) el.animateFrom(transFromProps, config);
    }
}
function $4ad5d316e369014d$var$applyMiscProps(el, elOption) {
    // Merge by default.
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(elOption, 'silent') && (el.silent = elOption.silent);
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(elOption, 'ignore') && (el.ignore = elOption.ignore);
    if (el instanceof (0, $cfd8540aca1ca40f$export$2e2bcd8739ae039)) (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(elOption, 'invisible') && (el.invisible = elOption.invisible);
    if (el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039)) (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(elOption, 'autoBatch') && (el.autoBatch = elOption.autoBatch);
}
// Use it to avoid it be exposed to user.
var $4ad5d316e369014d$var$tmpDuringScope = {};
var $4ad5d316e369014d$var$transitionDuringAPI = {
    // Usually other props do not need to be changed in animation during.
    setTransform: function(key, val) {
        $4ad5d316e369014d$var$tmpDuringScope.el[key] = val;
        return this;
    },
    getTransform: function(key) {
        return $4ad5d316e369014d$var$tmpDuringScope.el[key];
    },
    setShape: function(key, val) {
        var el = $4ad5d316e369014d$var$tmpDuringScope.el;
        var shape = el.shape || (el.shape = {});
        shape[key] = val;
        el.dirtyShape && el.dirtyShape();
        return this;
    },
    getShape: function(key) {
        var shape = $4ad5d316e369014d$var$tmpDuringScope.el.shape;
        if (shape) return shape[key];
    },
    setStyle: function(key, val) {
        var el = $4ad5d316e369014d$var$tmpDuringScope.el;
        var style = el.style;
        if (style) {
            style[key] = val;
            el.dirtyStyle && el.dirtyStyle();
        }
        return this;
    },
    getStyle: function(key) {
        var style = $4ad5d316e369014d$var$tmpDuringScope.el.style;
        if (style) return style[key];
    },
    setExtra: function(key, val) {
        var extra = $4ad5d316e369014d$var$tmpDuringScope.el.extra || ($4ad5d316e369014d$var$tmpDuringScope.el.extra = {});
        extra[key] = val;
        return this;
    },
    getExtra: function(key) {
        var extra = $4ad5d316e369014d$var$tmpDuringScope.el.extra;
        if (extra) return extra[key];
    }
};
function $4ad5d316e369014d$var$assertNotReserved(key) {}
function $4ad5d316e369014d$var$duringCall() {
    // Do not provide "percent" until some requirements come.
    // Because consider thies case:
    // enterFrom: {x: 100, y: 30}, transition: 'x'.
    // And enter duration is different from update duration.
    // Thus it might be confused about the meaning of "percent" in during callback.
    var scope = this;
    var el = scope.el;
    if (!el) return;
    // If el is remove from zr by reason like legend, during still need to called,
    // because el will be added back to zr and the prop value should not be incorrect.
    var latestUserDuring = $4ad5d316e369014d$var$transitionInnerStore(el).userDuring;
    var scopeUserDuring = scope.userDuring;
    // Ensured a during is only called once in each animation frame.
    // If a during is called multiple times in one frame, maybe some users' calculation logic
    // might be wrong (not sure whether this usage exists).
    // The case of a during might be called twice can be: by default there is a animator for
    // 'x', 'y' when init. Before the init animation finished, call `setOption` to start
    // another animators for 'style'/'shape'/'extra'.
    if (latestUserDuring !== scopeUserDuring) {
        // release
        scope.el = scope.userDuring = null;
        return;
    }
    $4ad5d316e369014d$var$tmpDuringScope.el = el;
    // Give no `this` to user in "during" calling.
    scopeUserDuring($4ad5d316e369014d$var$transitionDuringAPI);
// FIXME: if in future meet the case that some prop will be both modified in `during` and `state`,
// consider the issue that the prop might be incorrect when return to "normal" state.
}
function $4ad5d316e369014d$var$prepareShapeOrExtraTransitionFrom(mainAttr, fromEl, elOption, transFromProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var elPropsInAttr = fromEl[mainAttr];
    var transFromPropsInAttr;
    if (elPropsInAttr) {
        var transition = elOption.transition;
        var attrTransition = attrOpt.transition;
        if (attrTransition) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            if ($4ad5d316e369014d$export$6f3361b4b8d7a8ba(attrTransition)) (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(transFromPropsInAttr, elPropsInAttr);
            else {
                var transitionKeys = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(attrTransition);
                for(var i = 0; i < transitionKeys.length; i++){
                    var key = transitionKeys[i];
                    var elVal = elPropsInAttr[key];
                    transFromPropsInAttr[key] = elVal;
                }
            }
        } else if ($4ad5d316e369014d$export$6f3361b4b8d7a8ba(transition) || (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(transition, mainAttr) >= 0) {
            !transFromPropsInAttr && (transFromPropsInAttr = transFromProps[mainAttr] = {});
            var elPropsInAttrKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(elPropsInAttr);
            for(var i = 0; i < elPropsInAttrKeys.length; i++){
                var key = elPropsInAttrKeys[i];
                var elVal = elPropsInAttr[key];
                if ($4ad5d316e369014d$var$isNonStyleTransitionEnabled(attrOpt[key], elVal)) transFromPropsInAttr[key] = elVal;
            }
        }
    }
}
function $4ad5d316e369014d$var$prepareShapeOrExtraAllPropsFinal(mainAttr, elOption, allProps) {
    var attrOpt = elOption[mainAttr];
    if (!attrOpt) return;
    var allPropsInAttr = allProps[mainAttr] = {};
    var keysInAttr = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(attrOpt);
    for(var i = 0; i < keysInAttr.length; i++){
        var key = keysInAttr[i];
        // To avoid share one object with different element, and
        // to avoid user modify the object inexpectedly, have to clone.
        allPropsInAttr[key] = (0, $dc7faf503a6299d4$export$c5e92b7f105af84e)(attrOpt[key]);
    }
}
function $4ad5d316e369014d$var$prepareTransformTransitionFrom(el, elOption, transFromProps) {
    var transition = elOption.transition;
    var transitionKeys = $4ad5d316e369014d$export$6f3361b4b8d7a8ba(transition) ? (0, $cd11a033fc7d29e7$export$98ab6203ec3396e2) : (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(transition || []);
    for(var i = 0; i < transitionKeys.length; i++){
        var key = transitionKeys[i];
        if (key === 'style' || key === 'shape' || key === 'extra') continue;
        var elVal = el[key];
        // Do not clone, animator will perform that clone.
        transFromProps[key] = elVal;
    }
}
function $4ad5d316e369014d$var$prepareTransformAllPropsFinal(el, elOption, allProps) {
    for(var i = 0; i < $4ad5d316e369014d$var$LEGACY_TRANSFORM_PROPS.length; i++){
        var legacyName = $4ad5d316e369014d$var$LEGACY_TRANSFORM_PROPS[i];
        var xyName = $4ad5d316e369014d$var$LEGACY_TRANSFORM_PROPS_MAP[legacyName];
        var legacyArr = elOption[legacyName];
        if (legacyArr) {
            allProps[xyName[0]] = legacyArr[0];
            allProps[xyName[1]] = legacyArr[1];
        }
    }
    for(var i = 0; i < (0, $cd11a033fc7d29e7$export$98ab6203ec3396e2).length; i++){
        var key = (0, $cd11a033fc7d29e7$export$98ab6203ec3396e2)[i];
        if (elOption[key] != null) allProps[key] = elOption[key];
    }
}
function $4ad5d316e369014d$var$prepareStyleTransitionFrom(fromEl, elOption, styleOpt, transFromProps) {
    if (!styleOpt) return;
    var fromElStyle = fromEl.style;
    var transFromStyleProps;
    if (fromElStyle) {
        var styleTransition = styleOpt.transition;
        var elTransition = elOption.transition;
        if (styleTransition && !$4ad5d316e369014d$export$6f3361b4b8d7a8ba(styleTransition)) {
            var transitionKeys = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(styleTransition);
            !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
            for(var i = 0; i < transitionKeys.length; i++){
                var key = transitionKeys[i];
                var elVal = fromElStyle[key];
                // Do not clone, see `checkNonStyleTansitionRefer`.
                transFromStyleProps[key] = elVal;
            }
        } else if (fromEl.getAnimationStyleProps && ($4ad5d316e369014d$export$6f3361b4b8d7a8ba(elTransition) || $4ad5d316e369014d$export$6f3361b4b8d7a8ba(styleTransition) || (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(elTransition, 'style') >= 0)) {
            var animationProps = fromEl.getAnimationStyleProps();
            var animationStyleProps = animationProps ? animationProps.style : null;
            if (animationStyleProps) {
                !transFromStyleProps && (transFromStyleProps = transFromProps.style = {});
                var styleKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(styleOpt);
                for(var i = 0; i < styleKeys.length; i++){
                    var key = styleKeys[i];
                    if (animationStyleProps[key]) {
                        var elVal = fromElStyle[key];
                        transFromStyleProps[key] = elVal;
                    }
                }
            }
        }
    }
}
function $4ad5d316e369014d$var$isNonStyleTransitionEnabled(optVal, elVal) {
    // The same as `checkNonStyleTansitionRefer`.
    return !(0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(optVal) ? optVal != null && isFinite(optVal) : optVal !== elVal;
}
var $4ad5d316e369014d$var$checkTransformPropRefer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $babc3887e878ce38$var$getStateToRestore = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $babc3887e878ce38$var$KEYFRAME_EXCLUDE_KEYS = [
    'percent',
    'easing',
    'shape',
    'style',
    'extra'
];
function $babc3887e878ce38$export$9e5c70edf1ec0cb4(el) {
    // Stop previous keyframe animation.
    el.stopAnimation('keyframe');
    // Restore
    el.attr($babc3887e878ce38$var$getStateToRestore(el));
}
function $babc3887e878ce38$export$b0aa6a5f01693fa4(el, animationOpts, animatableModel) {
    if (!animatableModel.isAnimationEnabled() || !animationOpts) return;
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(animationOpts)) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(animationOpts, function(singleAnimationOpts) {
            $babc3887e878ce38$export$b0aa6a5f01693fa4(el, singleAnimationOpts, animatableModel);
        });
        return;
    }
    var keyframes = animationOpts.keyframes;
    var duration = animationOpts.duration;
    if (animatableModel && duration == null) {
        // Default to use duration of config.
        // NOTE: animation config from payload will be ignored because they are mainly for transitions.
        var config = (0, $b40111164617dd60$export$5cc7add7ab591d0a)('enter', animatableModel, 0);
        duration = config && config.duration;
    }
    if (!keyframes || !duration) return;
    var stateToRestore = $babc3887e878ce38$var$getStateToRestore(el);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $4ad5d316e369014d$export$9a911ad86e905b13), function(targetPropName) {
        if (targetPropName && !el[targetPropName]) return;
        var animator;
        var endFrameIsSet = false;
        // Sort keyframes by percent.
        keyframes.sort(function(a, b) {
            return a.percent - b.percent;
        });
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(keyframes, function(kf) {
            // Stop current animation.
            var animators = el.animators;
            var kfValues = targetPropName ? kf[targetPropName] : kf;
            if (!kfValues) return;
            var propKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(kfValues);
            if (!targetPropName) // PENDING performance?
            propKeys = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(propKeys, function(key) {
                return (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)($babc3887e878ce38$var$KEYFRAME_EXCLUDE_KEYS, key) < 0;
            });
            if (!propKeys.length) return;
            if (!animator) {
                animator = el.animate(targetPropName, animationOpts.loop, true);
                animator.scope = 'keyframe';
            }
            for(var i = 0; i < animators.length; i++)// Stop all other animation that is not keyframe.
            if (animators[i] !== animator && animators[i].targetName === animator.targetName) animators[i].stopTracks(propKeys);
            targetPropName && (stateToRestore[targetPropName] = stateToRestore[targetPropName] || {});
            var savedTarget = targetPropName ? stateToRestore[targetPropName] : stateToRestore;
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(propKeys, function(key) {
                // Save original value.
                savedTarget[key] = ((targetPropName ? el[targetPropName] : el) || {})[key];
            });
            animator.whenWithKeys(duration * kf.percent, kfValues, propKeys, kf.easing);
        });
        if (!animator) return;
        animator.delay(animationOpts.delay || 0).duration(duration).start(animationOpts.easing);
    });
}


var $07ba8d60bc888f30$var$EMPHASIS = 'emphasis';
var $07ba8d60bc888f30$var$NORMAL = 'normal';
var $07ba8d60bc888f30$var$BLUR = 'blur';
var $07ba8d60bc888f30$var$SELECT = 'select';
var $07ba8d60bc888f30$var$STATES = [
    $07ba8d60bc888f30$var$NORMAL,
    $07ba8d60bc888f30$var$EMPHASIS,
    $07ba8d60bc888f30$var$BLUR,
    $07ba8d60bc888f30$var$SELECT
];
var $07ba8d60bc888f30$var$PATH_ITEM_STYLE = {
    normal: [
        'itemStyle'
    ],
    emphasis: [
        $07ba8d60bc888f30$var$EMPHASIS,
        'itemStyle'
    ],
    blur: [
        $07ba8d60bc888f30$var$BLUR,
        'itemStyle'
    ],
    select: [
        $07ba8d60bc888f30$var$SELECT,
        'itemStyle'
    ]
};
var $07ba8d60bc888f30$var$PATH_LABEL = {
    normal: [
        'label'
    ],
    emphasis: [
        $07ba8d60bc888f30$var$EMPHASIS,
        'label'
    ],
    blur: [
        $07ba8d60bc888f30$var$BLUR,
        'label'
    ],
    select: [
        $07ba8d60bc888f30$var$SELECT,
        'label'
    ]
};
var $07ba8d60bc888f30$var$DEFAULT_TRANSITION = [
    'x',
    'y'
];
// Use prefix to avoid index to be the same as el.name,
// which will cause weird update animation.
var $07ba8d60bc888f30$var$GROUP_DIFF_PREFIX = 'e\0\0';
var $07ba8d60bc888f30$var$attachedTxInfoTmp = {
    normal: {},
    emphasis: {},
    blur: {},
    select: {}
};
/**
 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
 * of each coordinate systems are not required by each coordinate systems directly, but
 * required by the module `custom`.
 *
 * prepareInfoForCustomSeries {Function}: optional
 *     @return {Object} {coordSys: {...}, api: {
 *         coord: function (data, clamp) {}, // return point in global.
 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
 *     }}
 */ var $07ba8d60bc888f30$var$prepareCustoms = {
    cartesian2d: (0, $857c01f69c883950$export$2e2bcd8739ae039),
    geo: (0, $9b362282a6e5e6b3$export$2e2bcd8739ae039),
    single: (0, $5c26c2ae786e1f88$export$2e2bcd8739ae039),
    polar: (0, $e305008378be31bf$export$2e2bcd8739ae039),
    calendar: (0, $f31773547cc0a64a$export$2e2bcd8739ae039)
};
function $07ba8d60bc888f30$var$isPath(el) {
    return el instanceof $f9698154c9fcf427$export$2e2bcd8739ae039;
}
function $07ba8d60bc888f30$var$isDisplayable(el) {
    return el instanceof (0, $cfd8540aca1ca40f$export$2e2bcd8739ae039);
}
function $07ba8d60bc888f30$var$copyElement(sourceEl, targetEl) {
    targetEl.copyTransform(sourceEl);
    if ($07ba8d60bc888f30$var$isDisplayable(targetEl) && $07ba8d60bc888f30$var$isDisplayable(sourceEl)) {
        targetEl.setStyle(sourceEl.style);
        targetEl.z = sourceEl.z;
        targetEl.z2 = sourceEl.z2;
        targetEl.zlevel = sourceEl.zlevel;
        targetEl.invisible = sourceEl.invisible;
        targetEl.ignore = sourceEl.ignore;
        if ($07ba8d60bc888f30$var$isPath(targetEl) && $07ba8d60bc888f30$var$isPath(sourceEl)) targetEl.setShape(sourceEl.shape);
    }
}
var $07ba8d60bc888f30$var$CustomChartView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CustomChartView, _super);
    function CustomChartView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CustomChartView.type;
        return _this;
    }
    CustomChartView.prototype.render = function(customSeries, ecModel, api, payload) {
        // Clear previously rendered progressive elements.
        this._progressiveEls = null;
        var oldData = this._data;
        var data = customSeries.getData();
        var group = this.group;
        var renderItem = $07ba8d60bc888f30$var$makeRenderItem(customSeries, data, ecModel, api);
        if (!oldData) // Previous render is incremental render or first render.
        // Needs remove the incremental rendered elements.
        group.removeAll();
        data.diff(oldData).add(function(newIdx) {
            $07ba8d60bc888f30$var$createOrUpdateItem(api, null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).remove(function(oldIdx) {
            var el = oldData.getItemGraphicEl(oldIdx);
            el && (0, $4ad5d316e369014d$export$15575b6d82d35bb3)(el, (0, $b0b459864cc21fca$export$dd5c3cc86073562f)(el).option, customSeries);
        }).update(function(newIdx, oldIdx) {
            var oldEl = oldData.getItemGraphicEl(oldIdx);
            $07ba8d60bc888f30$var$createOrUpdateItem(api, oldEl, newIdx, renderItem(newIdx, payload), customSeries, group, data);
        }).execute();
        // Do clipping
        var clipPath = customSeries.get('clip', true) ? (0, $6206a29b0d1240e0$export$e0fe5081209d01c9)(customSeries.coordinateSystem, false, customSeries) : null;
        if (clipPath) group.setClipPath(clipPath);
        else group.removeClipPath();
        this._data = data;
    };
    CustomChartView.prototype.incrementalPrepareRender = function(customSeries, ecModel, api) {
        this.group.removeAll();
        this._data = null;
    };
    CustomChartView.prototype.incrementalRender = function(params, customSeries, ecModel, api, payload) {
        var data = customSeries.getData();
        var renderItem = $07ba8d60bc888f30$var$makeRenderItem(customSeries, data, ecModel, api);
        var progressiveEls = this._progressiveEls = [];
        function setIncrementalAndHoverLayer(el) {
            if (!el.isGroup) {
                el.incremental = true;
                el.ensureState('emphasis').hoverLayer = true;
            }
        }
        for(var idx = params.start; idx < params.end; idx++){
            var el = $07ba8d60bc888f30$var$createOrUpdateItem(null, null, idx, renderItem(idx, payload), customSeries, this.group, data);
            if (el) {
                el.traverse(setIncrementalAndHoverLayer);
                progressiveEls.push(el);
            }
        }
    };
    CustomChartView.prototype.eachRendered = function(cb) {
        $8eb95236e1aa01e7$export$3e564442729bf048(this._progressiveEls || this.group, cb);
    };
    CustomChartView.prototype.filterForExposedEvent = function(eventType, query, targetEl, packedEvent) {
        var elementName = query.element;
        if (elementName == null || targetEl.name === elementName) return true;
        // Enable to give a name on a group made by `renderItem`, and listen
        // events that are triggered by its descendents.
        while((targetEl = targetEl.__hostTarget || targetEl.parent) && targetEl !== this.group){
            if (targetEl.name === elementName) return true;
        }
        return false;
    };
    CustomChartView.type = 'custom';
    return CustomChartView;
}((0, $80462d4f8a33fa64$export$2e2bcd8739ae039));
var $07ba8d60bc888f30$export$2e2bcd8739ae039 = $07ba8d60bc888f30$var$CustomChartView;
function $07ba8d60bc888f30$var$createEl(elOption) {
    var graphicType = elOption.type;
    var el;
    // Those graphic elements are not shapes. They should not be
    // overwritten by users, so do them first.
    if (graphicType === 'path') {
        var shape = elOption.shape;
        // Using pathRect brings convenience to users sacle svg path.
        var pathRect = shape.width != null && shape.height != null ? {
            x: shape.x || 0,
            y: shape.y || 0,
            width: shape.width,
            height: shape.height
        } : null;
        var pathData = $07ba8d60bc888f30$var$getPathData(shape);
        // Path is also used for icon, so layout 'center' by default.
        el = $8eb95236e1aa01e7$export$aa9bab72412f5613(pathData, null, pathRect, shape.layout || 'center');
        (0, $b0b459864cc21fca$export$dd5c3cc86073562f)(el).customPathData = pathData;
    } else if (graphicType === 'image') {
        el = new $29f98103052059af$export$2e2bcd8739ae039({});
        (0, $b0b459864cc21fca$export$dd5c3cc86073562f)(el).customImagePath = elOption.style.image;
    } else if (graphicType === 'text') el = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({});
    else if (graphicType === 'group') el = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
    else if (graphicType === 'compoundPath') throw new Error('"compoundPath" is not supported yet.');
    else {
        var Clz = $8eb95236e1aa01e7$export$51df4b5565a58189(graphicType);
        if (!Clz) {
            var errMsg = '';
            (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        }
        el = new Clz();
    }
    (0, $b0b459864cc21fca$export$dd5c3cc86073562f)(el).customGraphicType = graphicType;
    el.name = elOption.name;
    // Compat ec4: the default z2 lift is 1. If changing the number,
    // some cases probably be broken: hierarchy layout along z, like circle packing,
    // where emphasis only intending to modify color/border rather than lift z2.
    el.z2EmphasisLift = 1;
    el.z2SelectLift = 1;
    return el;
}
function $07ba8d60bc888f30$var$updateElNormal(// Can be null/undefined
api, el, dataIndex, elOption, attachedTxInfo, seriesModel, isInit) {
    // Stop and restore before update any other attributes.
    (0, $babc3887e878ce38$export$9e5c70edf1ec0cb4)(el);
    var txCfgOpt = attachedTxInfo && attachedTxInfo.normal.cfg;
    if (txCfgOpt) // PENDING: whether use user object directly rather than clone?
    // TODO:5.0 textConfig transition animation?
    el.setTextConfig(txCfgOpt);
    // Default transition ['x', 'y']
    if (elOption && elOption.transition == null) elOption.transition = $07ba8d60bc888f30$var$DEFAULT_TRANSITION;
    // Do some normalization on style.
    var styleOpt = elOption && elOption.style;
    if (styleOpt) {
        if (el.type === 'text') {
            var textOptionStyle = styleOpt;
            // Compatible with ec4: if `textFill` or `textStroke` exists use them.
            (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(textOptionStyle, 'textFill') && (textOptionStyle.fill = textOptionStyle.textFill);
            (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(textOptionStyle, 'textStroke') && (textOptionStyle.stroke = textOptionStyle.textStroke);
        }
        var decalPattern = void 0;
        var decalObj = $07ba8d60bc888f30$var$isPath(el) ? styleOpt.decal : null;
        if (api && decalObj) {
            decalObj.dirty = true;
            decalPattern = (0, $6d9628e7c6bac2b0$export$a3ba048e1a648972)(decalObj, api);
        }
        // Always overwrite in case user specify this prop.
        styleOpt.__decalPattern = decalPattern;
    }
    if ($07ba8d60bc888f30$var$isDisplayable(el)) {
        if (styleOpt) {
            var decalPattern = styleOpt.__decalPattern;
            if (decalPattern) styleOpt.decal = decalPattern;
        }
    }
    (0, $4ad5d316e369014d$export$4342b281b9b5d77e)(el, elOption, seriesModel, {
        dataIndex: dataIndex,
        isInit: isInit,
        clearStyle: true
    });
    (0, $babc3887e878ce38$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, seriesModel);
}
function $07ba8d60bc888f30$var$updateElOnState(state, el, elStateOpt, styleOpt, attachedTxInfo) {
    var elDisplayable = el.isGroup ? null : el;
    var txCfgOpt = attachedTxInfo && attachedTxInfo[state].cfg;
    // PENDING:5.0 support customize scale change and transition animation?
    if (elDisplayable) {
        // By default support auto lift color when hover whether `emphasis` specified.
        var stateObj = elDisplayable.ensureState(state);
        if (styleOpt === false) {
            var existingEmphasisState = elDisplayable.getState(state);
            if (existingEmphasisState) existingEmphasisState.style = null;
        } else // style is needed to enable default emphasis.
        stateObj.style = styleOpt || null;
        // If `elOption.styleEmphasis` or `elOption.emphasis.style` is `false`,
        // remove hover style.
        // If `elOption.textConfig` or `elOption.emphasis.textConfig` is null/undefined, it does not
        // make sense. So for simplicity, we do not ditinguish `hasOwnProperty` and null/undefined.
        if (txCfgOpt) stateObj.textConfig = txCfgOpt;
        (0, $b414df7d361a211c$export$20f39bbe322fb9ab)(elDisplayable);
    }
}
function $07ba8d60bc888f30$var$updateZ(el, elOption, seriesModel) {
    // Group not support textContent and not support z yet.
    if (el.isGroup) return;
    var elDisplayable = el;
    var currentZ = seriesModel.currentZ;
    var currentZLevel = seriesModel.currentZLevel;
    // Always erase.
    elDisplayable.z = currentZ;
    elDisplayable.zlevel = currentZLevel;
    // z2 must not be null/undefined, otherwise sort error may occur.
    var optZ2 = elOption.z2;
    optZ2 != null && (elDisplayable.z2 = optZ2 || 0);
    for(var i = 0; i < $07ba8d60bc888f30$var$STATES.length; i++)$07ba8d60bc888f30$var$updateZForEachState(elDisplayable, elOption, $07ba8d60bc888f30$var$STATES[i]);
}
function $07ba8d60bc888f30$var$updateZForEachState(elDisplayable, elOption, state) {
    var isNormal = state === $07ba8d60bc888f30$var$NORMAL;
    var elStateOpt = isNormal ? elOption : $07ba8d60bc888f30$var$retrieveStateOption(elOption, state);
    var optZ2 = elStateOpt ? elStateOpt.z2 : null;
    var stateObj;
    if (optZ2 != null) {
        // Do not `ensureState` until required.
        stateObj = isNormal ? elDisplayable : elDisplayable.ensureState(state);
        stateObj.z2 = optZ2 || 0;
    }
}
function $07ba8d60bc888f30$var$makeRenderItem(customSeries, data, ecModel, api) {
    var renderItem = customSeries.get('renderItem');
    var coordSys = customSeries.coordinateSystem;
    var prepareResult = {};
    if (coordSys) // `coordSys.prepareCustoms` is used for external coord sys like bmap.
    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms(coordSys) : $07ba8d60bc888f30$var$prepareCustoms[coordSys.type](coordSys);
    var userAPI = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
        getWidth: api.getWidth,
        getHeight: api.getHeight,
        getZr: api.getZr,
        getDevicePixelRatio: api.getDevicePixelRatio,
        value: value,
        style: style,
        ordinalRawValue: ordinalRawValue,
        styleEmphasis: styleEmphasis,
        visual: visual,
        barLayout: barLayout,
        currentSeriesIndices: currentSeriesIndices,
        font: font
    }, prepareResult.api || {});
    var userParams = {
        // The life cycle of context: current round of rendering.
        // The global life cycle is probably not necessary, because
        // user can store global status by themselves.
        context: {},
        seriesId: customSeries.id,
        seriesName: customSeries.name,
        seriesIndex: customSeries.seriesIndex,
        coordSys: prepareResult.coordSys,
        dataInsideLength: data.count(),
        encode: $07ba8d60bc888f30$var$wrapEncodeDef(customSeries.getData())
    };
    // If someday intending to refactor them to a class, should consider do not
    // break change: currently these attribute member are encapsulated in a closure
    // so that do not need to force user to call these method with a scope.
    // Do not support call `api` asynchronously without dataIndexInside input.
    var currDataIndexInside;
    var currItemModel;
    var currItemStyleModels = {};
    var currLabelModels = {};
    var seriesItemStyleModels = {};
    var seriesLabelModels = {};
    for(var i = 0; i < $07ba8d60bc888f30$var$STATES.length; i++){
        var stateName = $07ba8d60bc888f30$var$STATES[i];
        seriesItemStyleModels[stateName] = customSeries.getModel($07ba8d60bc888f30$var$PATH_ITEM_STYLE[stateName]);
        seriesLabelModels[stateName] = customSeries.getModel($07ba8d60bc888f30$var$PATH_LABEL[stateName]);
    }
    function getItemModel(dataIndexInside) {
        return dataIndexInside === currDataIndexInside ? currItemModel || (currItemModel = data.getItemModel(dataIndexInside)) : data.getItemModel(dataIndexInside);
    }
    function getItemStyleModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesItemStyleModels[state] : dataIndexInside === currDataIndexInside ? currItemStyleModels[state] || (currItemStyleModels[state] = getItemModel(dataIndexInside).getModel($07ba8d60bc888f30$var$PATH_ITEM_STYLE[state])) : getItemModel(dataIndexInside).getModel($07ba8d60bc888f30$var$PATH_ITEM_STYLE[state]);
    }
    function getLabelModel(dataIndexInside, state) {
        return !data.hasItemOption ? seriesLabelModels[state] : dataIndexInside === currDataIndexInside ? currLabelModels[state] || (currLabelModels[state] = getItemModel(dataIndexInside).getModel($07ba8d60bc888f30$var$PATH_LABEL[state])) : getItemModel(dataIndexInside).getModel($07ba8d60bc888f30$var$PATH_LABEL[state]);
    }
    return function(dataIndexInside, payload) {
        currDataIndexInside = dataIndexInside;
        currItemModel = null;
        currItemStyleModels = {};
        currLabelModels = {};
        return renderItem && renderItem((0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
            dataIndexInside: dataIndexInside,
            dataIndex: data.getRawIndex(dataIndexInside),
            // Can be used for optimization when zoom or roam.
            actionType: payload ? payload.type : null
        }, userParams), userAPI);
    };
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function value(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        return data.getStore().get(data.getDimensionIndex(dim || 0), dataIndexInside);
    }
    /**
   * @public
   * @param dim by default 0.
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function ordinalRawValue(dim, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        dim = dim || 0;
        var dimInfo = data.getDimensionInfo(dim);
        if (!dimInfo) {
            var dimIndex = data.getDimensionIndex(dim);
            return dimIndex >= 0 ? data.getStore().get(dimIndex, dataIndexInside) : undefined;
        }
        var val = data.get(dimInfo.name, dataIndexInside);
        var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
        return ordinalMeta ? ordinalMeta.categories[val] : val;
    }
    /**
   * @deprecated The original intention of `api.style` is enable to set itemStyle
   * like other series. But it is not necessary and not easy to give a strict definition
   * of what it returns. And since echarts5 it needs to be make compat work. So
   * deprecates it since echarts5.
   *
   * By default, `visual` is applied to style (to support visualMap).
   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
   * it can be implemented as:
   * `api.style({stroke: api.visual('color'), fill: null})`;
   *
   * [Compat]: since ec5, RectText has been separated from its hosts el.
   * so `api.style()` will only return the style from `itemStyle` but not handle `label`
   * any more. But `series.label` config is never published in doc.
   * We still compat it in `api.style()`. But not encourage to use it and will still not
   * to pulish it to doc.
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function style(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var style = data.getItemVisual(dataIndexInside, 'style');
        var visualColor = style && style.fill;
        var opacity = style && style.opacity;
        var itemStyle = getItemStyleModel(dataIndexInside, $07ba8d60bc888f30$var$NORMAL).getItemStyle();
        visualColor != null && (itemStyle.fill = visualColor);
        opacity != null && (itemStyle.opacity = opacity);
        var opt = {
            inheritColor: (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(visualColor) ? visualColor : '#000'
        };
        var labelModel = getLabelModel(dataIndexInside, $07ba8d60bc888f30$var$NORMAL);
        // Now that the feature of "auto adjust text fill/stroke" has been migrated to zrender
        // since ec5, we should set `isAttached` as `false` here and make compat in
        // `convertToEC4StyleForCustomSerise`.
        var textStyle = $3828198b2f2de836$export$f8998c3d0a13de59(labelModel, null, opt, false, true);
        textStyle.text = labelModel.getShallow('show') ? (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(customSeries.getFormattedLabel(dataIndexInside, $07ba8d60bc888f30$var$NORMAL), (0, $3aa4a91235bead55$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $3828198b2f2de836$export$e149afab8df6e053(labelModel, opt, false);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $412257960513441c$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    /**
   * @deprecated The reason see `api.style()`
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function styleEmphasis(userProps, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        var itemStyle = getItemStyleModel(dataIndexInside, $07ba8d60bc888f30$var$EMPHASIS).getItemStyle();
        var labelModel = getLabelModel(dataIndexInside, $07ba8d60bc888f30$var$EMPHASIS);
        var textStyle = $3828198b2f2de836$export$f8998c3d0a13de59(labelModel, null, null, true, true);
        textStyle.text = labelModel.getShallow('show') ? (0, $1b239fc9d3a2f8ae$export$2e94551289abb95b)(customSeries.getFormattedLabel(dataIndexInside, $07ba8d60bc888f30$var$EMPHASIS), customSeries.getFormattedLabel(dataIndexInside, $07ba8d60bc888f30$var$NORMAL), (0, $3aa4a91235bead55$export$5ff20667590927ed)(data, dataIndexInside)) : null;
        var textConfig = $3828198b2f2de836$export$e149afab8df6e053(labelModel, null, true);
        preFetchFromExtra(userProps, itemStyle);
        itemStyle = (0, $412257960513441c$export$b8ddb75bd1b9b791)(itemStyle, textStyle, textConfig);
        userProps && applyUserPropsAfter(itemStyle, userProps);
        itemStyle.legacy = true;
        return itemStyle;
    }
    function applyUserPropsAfter(itemStyle, extra) {
        for(var key in extra)if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(extra, key)) itemStyle[key] = extra[key];
    }
    function preFetchFromExtra(extra, itemStyle) {
        // A trick to retrieve those props firstly, which are used to
        // apply auto inside fill/stroke in `convertToEC4StyleForCustomSerise`.
        // (It's not reasonable but only for a degree of compat)
        if (extra) {
            extra.textFill && (itemStyle.textFill = extra.textFill);
            extra.textPosition && (itemStyle.textPosition = extra.textPosition);
        }
    }
    /**
   * @public
   * @param dataIndexInside by default `currDataIndexInside`.
   */ function visual(visualType, dataIndexInside) {
        dataIndexInside == null && (dataIndexInside = currDataIndexInside);
        if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)((0, $b0b459864cc21fca$export$84369c8e2229fa7f), visualType)) {
            var style_1 = data.getItemVisual(dataIndexInside, 'style');
            return style_1 ? style_1[(0, $b0b459864cc21fca$export$84369c8e2229fa7f)[visualType]] : null;
        }
        // Only support these visuals. Other visual might be inner tricky
        // for performance (like `style`), do not expose to users.
        if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)((0, $b0b459864cc21fca$export$734d775a14929701), visualType)) return data.getItemVisual(dataIndexInside, visualType);
    }
    /**
   * @public
   * @return If not support, return undefined.
   */ function barLayout(opt) {
        if (coordSys.type === 'cartesian2d') {
            var baseAxis = coordSys.getBaseAxis();
            return (0, $b069e7ac30ed5deb$export$658df087977b9e84)((0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
                axis: baseAxis
            }, opt));
        }
    }
    /**
   * @public
   */ function currentSeriesIndices() {
        return ecModel.getCurrentSeriesIndices();
    }
    /**
   * @public
   * @return font string
   */ function font(opt) {
        return $3828198b2f2de836$export$155316a870a9d61e(opt, ecModel);
    }
}
function $07ba8d60bc888f30$var$wrapEncodeDef(data) {
    var encodeDef = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(data.dimensions, function(dimName) {
        var dimInfo = data.getDimensionInfo(dimName);
        if (!dimInfo.isExtraCoord) {
            var coordDim = dimInfo.coordDim;
            var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
            dataDims[dimInfo.coordDimIndex] = data.getDimensionIndex(dimName);
        }
    });
    return encodeDef;
}
function $07ba8d60bc888f30$var$createOrUpdateItem(api, existsEl, dataIndex, elOption, seriesModel, group, data) {
    // [Rule]
    // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
    //     (It seems that violate the "merge" principle, but most of users probably intuitively
    //     regard "return;" as "show nothing element whatever", so make a exception to meet the
    //     most cases.)
    // The rule or "merge" see [STRATEGY_MERGE].
    // If `elOption` is `null`/`undefined`/`false` (when `renderItem` returns nothing).
    if (!elOption) {
        group.remove(existsEl);
        return;
    }
    var el = $07ba8d60bc888f30$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group);
    el && data.setItemGraphicEl(dataIndex, el);
    el && (0, $b414df7d361a211c$export$e51187539ff11209)(el, elOption.focus, elOption.blurScope, elOption.emphasisDisabled);
    return el;
}
function $07ba8d60bc888f30$var$doCreateOrUpdateEl(api, existsEl, dataIndex, elOption, seriesModel, group) {
    var toBeReplacedIdx = -1;
    var oldEl = existsEl;
    if (existsEl && $07ba8d60bc888f30$var$doesElNeedRecreate(existsEl, elOption, seriesModel)) {
        // Should keep at the original index, otherwise "merge by index" will be incorrect.
        toBeReplacedIdx = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(group.childrenRef(), existsEl);
        existsEl = null;
    }
    var isInit = !existsEl;
    var el = existsEl;
    if (!el) {
        el = $07ba8d60bc888f30$var$createEl(elOption);
        if (oldEl) $07ba8d60bc888f30$var$copyElement(oldEl, el);
    } else // FIMXE:NEXT unified clearState?
    // If in some case the performance issue arised, consider
    // do not clearState but update cached normal state directly.
    el.clearStates();
    // Need to set morph: false explictly to disable automatically morphing.
    if (elOption.morph === false) el.disableMorphing = true;
    else if (el.disableMorphing) el.disableMorphing = false;
    $07ba8d60bc888f30$var$attachedTxInfoTmp.normal.cfg = $07ba8d60bc888f30$var$attachedTxInfoTmp.normal.conOpt = $07ba8d60bc888f30$var$attachedTxInfoTmp.emphasis.cfg = $07ba8d60bc888f30$var$attachedTxInfoTmp.emphasis.conOpt = $07ba8d60bc888f30$var$attachedTxInfoTmp.blur.cfg = $07ba8d60bc888f30$var$attachedTxInfoTmp.blur.conOpt = $07ba8d60bc888f30$var$attachedTxInfoTmp.select.cfg = $07ba8d60bc888f30$var$attachedTxInfoTmp.select.conOpt = null;
    $07ba8d60bc888f30$var$attachedTxInfoTmp.isLegacy = false;
    $07ba8d60bc888f30$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, $07ba8d60bc888f30$var$attachedTxInfoTmp);
    $07ba8d60bc888f30$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit);
    $07ba8d60bc888f30$var$updateElNormal(api, el, dataIndex, elOption, $07ba8d60bc888f30$var$attachedTxInfoTmp, seriesModel, isInit);
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    // Update them only when user specified, otherwise, remain.
    (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(elOption, 'info') && ((0, $b0b459864cc21fca$export$dd5c3cc86073562f)(el).info = elOption.info);
    for(var i = 0; i < $07ba8d60bc888f30$var$STATES.length; i++){
        var stateName = $07ba8d60bc888f30$var$STATES[i];
        if (stateName !== $07ba8d60bc888f30$var$NORMAL) {
            var otherStateOpt = $07ba8d60bc888f30$var$retrieveStateOption(elOption, stateName);
            var otherStyleOpt = $07ba8d60bc888f30$var$retrieveStyleOptionOnState(elOption, otherStateOpt, stateName);
            $07ba8d60bc888f30$var$updateElOnState(stateName, el, otherStateOpt, otherStyleOpt, $07ba8d60bc888f30$var$attachedTxInfoTmp);
        }
    }
    $07ba8d60bc888f30$var$updateZ(el, elOption, seriesModel);
    if (elOption.type === 'group') $07ba8d60bc888f30$var$mergeChildren(api, el, dataIndex, elOption, seriesModel);
    if (toBeReplacedIdx >= 0) group.replaceAt(el, toBeReplacedIdx);
    else group.add(el);
    return el;
}
// `el` must not be null/undefined.
function $07ba8d60bc888f30$var$doesElNeedRecreate(el, elOption, seriesModel) {
    var elInner = (0, $b0b459864cc21fca$export$dd5c3cc86073562f)(el);
    var elOptionType = elOption.type;
    var elOptionShape = elOption.shape;
    var elOptionStyle = elOption.style;
    return(// Always create new if universal transition is enabled.
    // Because we do transition after render. It needs to know what old element is. Replacement will loose it.
    seriesModel.isUniversalTransitionEnabled() || elOptionType != null && elOptionType !== elInner.customGraphicType || elOptionType === 'path' && $07ba8d60bc888f30$var$hasOwnPathData(elOptionShape) && $07ba8d60bc888f30$var$getPathData(elOptionShape) !== elInner.customPathData || elOptionType === 'image' && (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(elOptionStyle, 'image') && elOptionStyle.image !== elInner.customImagePath);
}
function $07ba8d60bc888f30$var$doCreateOrUpdateClipPath(el, dataIndex, elOption, seriesModel, isInit) {
    // Based on the "merge" principle, if no clipPath provided,
    // do nothing. The exists clip will be totally removed only if
    // `el.clipPath` is `false`. Otherwise it will be merged/replaced.
    var clipPathOpt = elOption.clipPath;
    if (clipPathOpt === false) {
        if (el && el.getClipPath()) el.removeClipPath();
    } else if (clipPathOpt) {
        var clipPath = el.getClipPath();
        if (clipPath && $07ba8d60bc888f30$var$doesElNeedRecreate(clipPath, clipPathOpt, seriesModel)) clipPath = null;
        if (!clipPath) {
            clipPath = $07ba8d60bc888f30$var$createEl(clipPathOpt);
            el.setClipPath(clipPath);
        }
        $07ba8d60bc888f30$var$updateElNormal(null, clipPath, dataIndex, clipPathOpt, null, seriesModel, isInit);
    }
// If not define `clipPath` in option, do nothing unnecessary.
}
function $07ba8d60bc888f30$var$doCreateOrUpdateAttachedTx(el, dataIndex, elOption, seriesModel, isInit, attachedTxInfo) {
    // Group does not support textContent temporarily until necessary.
    if (el.isGroup) return;
    // Normal must be called before emphasis, for `isLegacy` detection.
    $07ba8d60bc888f30$var$processTxInfo(elOption, null, attachedTxInfo);
    $07ba8d60bc888f30$var$processTxInfo(elOption, $07ba8d60bc888f30$var$EMPHASIS, attachedTxInfo);
    // If `elOption.textConfig` or `elOption.textContent` is null/undefined, it does not make sense.
    // So for simplicity, if "elOption hasOwnProperty of them but be null/undefined", we do not
    // trade them as set to null to el.
    // Especially:
    // `elOption.textContent: false` means remove textContent.
    // `elOption.textContent.emphasis.style: false` means remove the style from emphasis state.
    var txConOptNormal = attachedTxInfo.normal.conOpt;
    var txConOptEmphasis = attachedTxInfo.emphasis.conOpt;
    var txConOptBlur = attachedTxInfo.blur.conOpt;
    var txConOptSelect = attachedTxInfo.select.conOpt;
    if (txConOptNormal != null || txConOptEmphasis != null || txConOptSelect != null || txConOptBlur != null) {
        var textContent = el.getTextContent();
        if (txConOptNormal === false) textContent && el.removeTextContent();
        else {
            txConOptNormal = attachedTxInfo.normal.conOpt = txConOptNormal || {
                type: 'text'
            };
            if (!textContent) {
                textContent = $07ba8d60bc888f30$var$createEl(txConOptNormal);
                el.setTextContent(textContent);
            } else // If in some case the performance issue arised, consider
            // do not clearState but update cached normal state directly.
            textContent.clearStates();
            $07ba8d60bc888f30$var$updateElNormal(null, textContent, dataIndex, txConOptNormal, null, seriesModel, isInit);
            var txConStlOptNormal = txConOptNormal && txConOptNormal.style;
            for(var i = 0; i < $07ba8d60bc888f30$var$STATES.length; i++){
                var stateName = $07ba8d60bc888f30$var$STATES[i];
                if (stateName !== $07ba8d60bc888f30$var$NORMAL) {
                    var txConOptOtherState = attachedTxInfo[stateName].conOpt;
                    $07ba8d60bc888f30$var$updateElOnState(stateName, textContent, txConOptOtherState, $07ba8d60bc888f30$var$retrieveStyleOptionOnState(txConOptNormal, txConOptOtherState, stateName), null);
                }
            }
            txConStlOptNormal ? textContent.dirty() : textContent.markRedraw();
        }
    }
}
function $07ba8d60bc888f30$var$processTxInfo(elOption, state, attachedTxInfo) {
    var stateOpt = !state ? elOption : $07ba8d60bc888f30$var$retrieveStateOption(elOption, state);
    var styleOpt = !state ? elOption.style : $07ba8d60bc888f30$var$retrieveStyleOptionOnState(elOption, stateOpt, $07ba8d60bc888f30$var$EMPHASIS);
    var elType = elOption.type;
    var txCfg = stateOpt ? stateOpt.textConfig : null;
    var txConOptNormal = elOption.textContent;
    var txConOpt = !txConOptNormal ? null : !state ? txConOptNormal : $07ba8d60bc888f30$var$retrieveStateOption(txConOptNormal, state);
    if (styleOpt && // Because emphasis style has little info to detect legacy,
    // if normal is legacy, emphasis is trade as legacy.
    (attachedTxInfo.isLegacy || (0, $412257960513441c$export$3b868abde5eae7d1)(styleOpt, elType, !!txCfg, !!txConOpt))) {
        attachedTxInfo.isLegacy = true;
        var convertResult = (0, $412257960513441c$export$7748133eaaa8aecc)(styleOpt, elType, !state);
        // Explicitly specified `textConfig` and `textContent` has higher priority than
        // the ones generated by legacy style. Otherwise if users use them and `api.style`
        // at the same time, they not both work and hardly to known why.
        if (!txCfg && convertResult.textConfig) txCfg = convertResult.textConfig;
        if (!txConOpt && convertResult.textContent) txConOpt = convertResult.textContent;
    }
    if (!state && txConOpt) {
        var txConOptNormal_1 = txConOpt;
        // `textContent: {type: 'text'}`, the "type" is easy to be missing. So we tolerate it.
        !txConOptNormal_1.type && (txConOptNormal_1.type = 'text');
    }
    var info = !state ? attachedTxInfo.normal : attachedTxInfo[state];
    info.cfg = txCfg;
    info.conOpt = txConOpt;
}
function $07ba8d60bc888f30$var$retrieveStateOption(elOption, state) {
    return !state ? elOption : elOption ? elOption[state] : null;
}
function $07ba8d60bc888f30$var$retrieveStyleOptionOnState(stateOptionNormal, stateOption, state) {
    var style = stateOption && stateOption.style;
    if (style == null && state === $07ba8d60bc888f30$var$EMPHASIS && stateOptionNormal) style = stateOptionNormal.styleEmphasis;
    return style;
}
// Usage:
// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates
//     that the existing children will not be removed, and enables the feature
//     that update some of the props of some of the children simply by construct
//     the returned children of `renderItem` like:
//     `var children = group.children = []; children[3] = {opacity: 0.5};`
// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
//     by child.name. But that might be lower performance.
// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
//     replaced totally.
// (4) If `!elOption.children`, following the "merge" principle, nothing will
//     happen.
// (5) If `elOption.$mergeChildren` is not `false` neither `'byName'` and the
//     `el` is a group, and if any of the new child is null, it means to remove
//     the element at the same index, if exists. On the other hand, if the new
//     child is and empty object `{}`, it means to keep the element not changed.
//
// For implementation simpleness, do not provide a direct way to remove single
// child (otherwise the total indices of the children array have to be modified).
// User can remove a single child by setting its `ignore` to `true`.
function $07ba8d60bc888f30$var$mergeChildren(api, el, dataIndex, elOption, seriesModel) {
    var newChildren = elOption.children;
    var newLen = newChildren ? newChildren.length : 0;
    var mergeChildren = elOption.$mergeChildren;
    // `diffChildrenByName` has been deprecated.
    var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
    var notMerge = mergeChildren === false;
    // For better performance on roam update, only enter if necessary.
    if (!newLen && !byName && !notMerge) return;
    if (byName) {
        $07ba8d60bc888f30$var$diffGroupChildren({
            api: api,
            oldChildren: el.children() || [],
            newChildren: newChildren || [],
            dataIndex: dataIndex,
            seriesModel: seriesModel,
            group: el
        });
        return;
    }
    notMerge && el.removeAll();
    // Mapping children of a group simply by index, which
    // might be better performance.
    var index = 0;
    for(; index < newLen; index++){
        var newChild = newChildren[index];
        var oldChild = el.childAt(index);
        if (newChild) {
            if (newChild.ignore == null) // The old child is set to be ignored if null (see comments
            // below). So we need to set ignore to be false back.
            newChild.ignore = false;
            $07ba8d60bc888f30$var$doCreateOrUpdateEl(api, oldChild, dataIndex, newChild, seriesModel, el);
        } else // If the new element option is null, it means to remove the old
        // element. But we cannot really remove the element from the group
        // directly, because the element order may not be stable when this
        // element is added back. So we set the element to be ignored.
        oldChild.ignore = true;
    }
    for(var i = el.childCount() - 1; i >= index; i--){
        var child = el.childAt(i);
        $07ba8d60bc888f30$var$removeChildFromGroup(el, child, seriesModel);
    }
}
function $07ba8d60bc888f30$var$removeChildFromGroup(group, child, seriesModel) {
    // Do not support leave elements that are not mentioned in the latest
    // `renderItem` return. Otherwise users may not have a clear and simple
    // concept that how to control all of the elements.
    child && (0, $4ad5d316e369014d$export$15575b6d82d35bb3)(child, (0, $b0b459864cc21fca$export$dd5c3cc86073562f)(group).option, seriesModel);
}
function $07ba8d60bc888f30$var$diffGroupChildren(context) {
    new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(context.oldChildren, context.newChildren, $07ba8d60bc888f30$var$getKey, $07ba8d60bc888f30$var$getKey, context).add($07ba8d60bc888f30$var$processAddUpdate).update($07ba8d60bc888f30$var$processAddUpdate).remove($07ba8d60bc888f30$var$processRemove).execute();
}
function $07ba8d60bc888f30$var$getKey(item, idx) {
    var name = item && item.name;
    return name != null ? name : $07ba8d60bc888f30$var$GROUP_DIFF_PREFIX + idx;
}
function $07ba8d60bc888f30$var$processAddUpdate(newIndex, oldIndex) {
    var context = this.context;
    var childOption = newIndex != null ? context.newChildren[newIndex] : null;
    var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
    $07ba8d60bc888f30$var$doCreateOrUpdateEl(context.api, child, context.dataIndex, childOption, context.seriesModel, context.group);
}
function $07ba8d60bc888f30$var$processRemove(oldIndex) {
    var context = this.context;
    var child = context.oldChildren[oldIndex];
    child && (0, $4ad5d316e369014d$export$15575b6d82d35bb3)(child, (0, $b0b459864cc21fca$export$dd5c3cc86073562f)(child).option, context.seriesModel);
}
/**
 * @return SVG Path data.
 */ function $07ba8d60bc888f30$var$getPathData(shape) {
    // "d" follows the SVG convention.
    return shape && (shape.pathData || shape.d);
}
function $07ba8d60bc888f30$var$hasOwnPathData(shape) {
    return shape && ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(shape, 'pathData') || (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(shape, 'd'));
}


function $294e9fb89da1901a$export$4b3e715f166fdd78(registers) {
    registers.registerChartView((0, $07ba8d60bc888f30$export$2e2bcd8739ae039));
    registers.registerSeriesModel((0, $b0b459864cc21fca$export$2e2bcd8739ae039));
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $26b546213ed8e9de$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $26b546213ed8e9de$var$clone = $1b239fc9d3a2f8ae$export$9cd59f9826255e47;
var $26b546213ed8e9de$var$bind = $1b239fc9d3a2f8ae$export$2385a24977818dd0;
/**
 * Base axis pointer class in 2D.
 */ var $26b546213ed8e9de$var$BaseAxisPointer = /** @class */ function() {
    function BaseAxisPointer() {
        this._dragging = false;
        /**
     * In px, arbitrary value. Do not set too small,
     * no animation is ok for most cases.
     */ this.animationThreshold = 15;
    }
    /**
   * @implement
   */ BaseAxisPointer.prototype.render = function(axisModel, axisPointerModel, api, forceRender) {
        var value = axisPointerModel.get('value');
        var status = axisPointerModel.get('status');
        // Bind them to `this`, not in closure, otherwise they will not
        // be replaced when user calling setOption in not merge mode.
        this._axisModel = axisModel;
        this._axisPointerModel = axisPointerModel;
        this._api = api;
        // Optimize: `render` will be called repeatedly during mouse move.
        // So it is power consuming if performing `render` each time,
        // especially on mobile device.
        if (!forceRender && this._lastValue === value && this._lastStatus === status) return;
        this._lastValue = value;
        this._lastStatus = status;
        var group = this._group;
        var handle = this._handle;
        if (!status || status === 'hide') {
            // Do not clear here, for animation better.
            group && group.hide();
            handle && handle.hide();
            return;
        }
        group && group.show();
        handle && handle.show();
        // Otherwise status is 'show'
        var elOption = {};
        this.makeElOption(elOption, value, axisModel, axisPointerModel, api);
        // Enable change axis pointer type.
        var graphicKey = elOption.graphicKey;
        if (graphicKey !== this._lastGraphicKey) this.clear(api);
        this._lastGraphicKey = graphicKey;
        var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
        if (!group) {
            group = this._group = new $8eb95236e1aa01e7$exports.Group();
            this.createPointerEl(group, elOption, axisModel, axisPointerModel);
            this.createLabelEl(group, elOption, axisModel, axisPointerModel);
            api.getZr().add(group);
        } else {
            var doUpdateProps = $1b239fc9d3a2f8ae$export$c3095a23b368d1f2($26b546213ed8e9de$var$updateProps, axisPointerModel, moveAnimation);
            this.updatePointerEl(group, elOption, doUpdateProps);
            this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
        }
        $26b546213ed8e9de$var$updateMandatoryProps(group, axisPointerModel, true);
        this._renderHandle(value);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.remove = function(api) {
        this.clear(api);
    };
    /**
   * @implement
   */ BaseAxisPointer.prototype.dispose = function(api) {
        this.clear(api);
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.determineAnimation = function(axisModel, axisPointerModel) {
        var animation = axisPointerModel.get('animation');
        var axis = axisModel.axis;
        var isCategoryAxis = axis.type === 'category';
        var useSnap = axisPointerModel.get('snap');
        // Value axis without snap always do not snap.
        if (!useSnap && !isCategoryAxis) return false;
        if (animation === 'auto' || animation == null) {
            var animationThreshold = this.animationThreshold;
            if (isCategoryAxis && axis.getBandWidth() > animationThreshold) return true;
            // It is important to auto animation when snap used. Consider if there is
            // a dataZoom, animation will be disabled when too many points exist, while
            // it will be enabled for better visual effect when little points exist.
            if (useSnap) {
                var seriesDataCount = $c55894497062b37c$export$bd39458db76002ab(axisModel).seriesDataCount;
                var axisExtent = axis.getExtent();
                // Approximate band width
                return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
            }
            return false;
        }
        return animation === true;
    };
    /**
   * add {pointer, label, graphicKey} to elOption
   * @protected
   */ BaseAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
    // Should be implemenented by sub-class.
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createPointerEl = function(group, elOption, axisModel, axisPointerModel) {
        var pointerOption = elOption.pointer;
        if (pointerOption) {
            var pointerEl = $26b546213ed8e9de$var$inner(group).pointerEl = new $8eb95236e1aa01e7$exports[pointerOption.type]($26b546213ed8e9de$var$clone(elOption.pointer));
            group.add(pointerEl);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.createLabelEl = function(group, elOption, axisModel, axisPointerModel) {
        if (elOption.label) {
            var labelEl = $26b546213ed8e9de$var$inner(group).labelEl = new $8eb95236e1aa01e7$exports.Text($26b546213ed8e9de$var$clone(elOption.label));
            group.add(labelEl);
            $26b546213ed8e9de$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updatePointerEl = function(group, elOption, updateProps) {
        var pointerEl = $26b546213ed8e9de$var$inner(group).pointerEl;
        if (pointerEl && elOption.pointer) {
            pointerEl.setStyle(elOption.pointer.style);
            updateProps(pointerEl, {
                shape: elOption.pointer.shape
            });
        }
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.updateLabelEl = function(group, elOption, updateProps, axisPointerModel) {
        var labelEl = $26b546213ed8e9de$var$inner(group).labelEl;
        if (labelEl) {
            labelEl.setStyle(elOption.label.style);
            updateProps(labelEl, {
                // Consider text length change in vertical axis, animation should
                // be used on shape, otherwise the effect will be weird.
                // TODOTODO
                // shape: elOption.label.shape,
                x: elOption.label.x,
                y: elOption.label.y
            });
            $26b546213ed8e9de$var$updateLabelShowHide(labelEl, axisPointerModel);
        }
    };
    /**
   * @private
   */ BaseAxisPointer.prototype._renderHandle = function(value) {
        if (this._dragging || !this.updateHandleTransform) return;
        var axisPointerModel = this._axisPointerModel;
        var zr = this._api.getZr();
        var handle = this._handle;
        var handleModel = axisPointerModel.getModel('handle');
        var status = axisPointerModel.get('status');
        if (!handleModel.get('show') || !status || status === 'hide') {
            handle && zr.remove(handle);
            this._handle = null;
            return;
        }
        var isInit;
        if (!this._handle) {
            isInit = true;
            handle = this._handle = $8eb95236e1aa01e7$exports.createIcon(handleModel.get('icon'), {
                cursor: 'move',
                draggable: true,
                onmousemove: function(e) {
                    // For mobile device, prevent screen slider on the button.
                    $8f7ba7c16ab1583e$export$fa6813432f753b0d(e.event);
                },
                onmousedown: $26b546213ed8e9de$var$bind(this._onHandleDragMove, this, 0, 0),
                drift: $26b546213ed8e9de$var$bind(this._onHandleDragMove, this),
                ondragend: $26b546213ed8e9de$var$bind(this._onHandleDragEnd, this)
            });
            zr.add(handle);
        }
        $26b546213ed8e9de$var$updateMandatoryProps(handle, axisPointerModel, false);
        // update style
        handle.setStyle(handleModel.getItemStyle(null, [
            'color',
            'borderColor',
            'borderWidth',
            'opacity',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ]));
        // update position
        var handleSize = handleModel.get('size');
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(handleSize)) handleSize = [
            handleSize,
            handleSize
        ];
        handle.scaleX = handleSize[0] / 2;
        handle.scaleY = handleSize[1] / 2;
        $ef22ba67fe7cfc59$export$958e3e1a02eac4b6(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
        this._moveHandleToValue(value, isInit);
    };
    BaseAxisPointer.prototype._moveHandleToValue = function(value, isInit) {
        $26b546213ed8e9de$var$updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, $26b546213ed8e9de$var$getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
    };
    BaseAxisPointer.prototype._onHandleDragMove = function(dx, dy) {
        var handle = this._handle;
        if (!handle) return;
        this._dragging = true;
        // Persistent for throttle.
        var trans = this.updateHandleTransform($26b546213ed8e9de$var$getHandleTransProps(handle), [
            dx,
            dy
        ], this._axisModel, this._axisPointerModel);
        this._payloadInfo = trans;
        handle.stopAnimation();
        handle.attr($26b546213ed8e9de$var$getHandleTransProps(trans));
        $26b546213ed8e9de$var$inner(handle).lastProp = null;
        this._doDispatchAxisPointer();
    };
    /**
   * Throttled method.
   */ BaseAxisPointer.prototype._doDispatchAxisPointer = function() {
        var handle = this._handle;
        if (!handle) return;
        var payloadInfo = this._payloadInfo;
        var axisModel = this._axisModel;
        this._api.dispatchAction({
            type: 'updateAxisPointer',
            x: payloadInfo.cursorPoint[0],
            y: payloadInfo.cursorPoint[1],
            tooltipOption: payloadInfo.tooltipOption,
            axesInfo: [
                {
                    axisDim: axisModel.axis.dim,
                    axisIndex: axisModel.componentIndex
                }
            ]
        });
    };
    BaseAxisPointer.prototype._onHandleDragEnd = function() {
        this._dragging = false;
        var handle = this._handle;
        if (!handle) return;
        var value = this._axisPointerModel.get('value');
        // Consider snap or categroy axis, handle may be not consistent with
        // axisPointer. So move handle to align the exact value position when
        // drag ended.
        this._moveHandleToValue(value);
        // For the effect: tooltip will be shown when finger holding on handle
        // button, and will be hidden after finger left handle button.
        this._api.dispatchAction({
            type: 'hideTip'
        });
    };
    /**
   * @private
   */ BaseAxisPointer.prototype.clear = function(api) {
        this._lastValue = null;
        this._lastStatus = null;
        var zr = api.getZr();
        var group = this._group;
        var handle = this._handle;
        if (zr && group) {
            this._lastGraphicKey = null;
            group && zr.remove(group);
            handle && zr.remove(handle);
            this._group = null;
            this._handle = null;
            this._payloadInfo = null;
        }
        $ef22ba67fe7cfc59$export$42ffd38884aecdac(this, '_doDispatchAxisPointer');
    };
    /**
   * @protected
   */ BaseAxisPointer.prototype.doClear = function() {
    // Implemented by sub-class if necessary.
    };
    BaseAxisPointer.prototype.buildLabel = function(xy, wh, xDimIndex) {
        xDimIndex = xDimIndex || 0;
        return {
            x: xy[xDimIndex],
            y: xy[1 - xDimIndex],
            width: wh[xDimIndex],
            height: wh[1 - xDimIndex]
        };
    };
    return BaseAxisPointer;
}();
function $26b546213ed8e9de$var$updateProps(animationModel, moveAnimation, el, props) {
    // Animation optimize.
    if (!$26b546213ed8e9de$var$propsEqual($26b546213ed8e9de$var$inner(el).lastProp, props)) {
        $26b546213ed8e9de$var$inner(el).lastProp = props;
        moveAnimation ? $8eb95236e1aa01e7$exports.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
    }
}
function $26b546213ed8e9de$var$propsEqual(lastProps, newProps) {
    if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(lastProps) && $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(newProps)) {
        var equals_1 = true;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(newProps, function(item, key) {
            equals_1 = equals_1 && $26b546213ed8e9de$var$propsEqual(lastProps[key], item);
        });
        return !!equals_1;
    } else return lastProps === newProps;
}
function $26b546213ed8e9de$var$updateLabelShowHide(labelEl, axisPointerModel) {
    labelEl[axisPointerModel.get([
        'label',
        'show'
    ]) ? 'show' : 'hide']();
}
function $26b546213ed8e9de$var$getHandleTransProps(trans) {
    return {
        x: trans.x || 0,
        y: trans.y || 0,
        rotation: trans.rotation || 0
    };
}
function $26b546213ed8e9de$var$updateMandatoryProps(group, axisPointerModel, silent) {
    var z = axisPointerModel.get('z');
    var zlevel = axisPointerModel.get('zlevel');
    group && group.traverse(function(el) {
        if (el.type !== 'group') {
            z != null && (el.z = z);
            zlevel != null && (el.zlevel = zlevel);
            el.silent = silent;
        }
    });
}
var $26b546213ed8e9de$export$2e2bcd8739ae039 = $26b546213ed8e9de$var$BaseAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







function $4c9900f2e2ca23a4$export$b7fe459c7cc50060(axisPointerModel) {
    var axisPointerType = axisPointerModel.get('type');
    var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
    var style;
    if (axisPointerType === 'line') {
        style = styleModel.getLineStyle();
        style.fill = null;
    } else if (axisPointerType === 'shadow') {
        style = styleModel.getAreaStyle();
        style.stroke = null;
    }
    return style;
}
function $4c9900f2e2ca23a4$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos) {
    var value = axisPointerModel.get('value');
    var text = $4c9900f2e2ca23a4$export$7cffee0f9aed39d0(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
        precision: axisPointerModel.get([
            'label',
            'precision'
        ]),
        formatter: axisPointerModel.get([
            'label',
            'formatter'
        ])
    });
    var labelModel = axisPointerModel.getModel('label');
    var paddings = $ff2fba995230f3c9$export$f3a38102c49f4268(labelModel.get('padding') || 0);
    var font = labelModel.getFont();
    var textRect = $297531217517fbce$export$c381147bfed79d9f(text, font);
    var position = labelPos.position;
    var width = textRect.width + paddings[1] + paddings[3];
    var height = textRect.height + paddings[0] + paddings[2];
    // Adjust by align.
    var align = labelPos.align;
    align === 'right' && (position[0] -= width);
    align === 'center' && (position[0] -= width / 2);
    var verticalAlign = labelPos.verticalAlign;
    verticalAlign === 'bottom' && (position[1] -= height);
    verticalAlign === 'middle' && (position[1] -= height / 2);
    // Not overflow ec container
    $4c9900f2e2ca23a4$var$confineInContainer(position, width, height, api);
    var bgColor = labelModel.get('backgroundColor');
    if (!bgColor || bgColor === 'auto') bgColor = axisModel.get([
        'axisLine',
        'lineStyle',
        'color'
    ]);
    elOption.label = {
        // shape: {x: 0, y: 0, width: width, height: height, r: labelModel.get('borderRadius')},
        x: position[0],
        y: position[1],
        style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(labelModel, {
            text: text,
            font: font,
            fill: labelModel.getTextColor(),
            padding: paddings,
            backgroundColor: bgColor
        }),
        // Label should be over axisPointer.
        z2: 10
    };
}
// Do not overflow ec container
function $4c9900f2e2ca23a4$var$confineInContainer(position, width, height, api) {
    var viewWidth = api.getWidth();
    var viewHeight = api.getHeight();
    position[0] = Math.min(position[0] + width, viewWidth) - width;
    position[1] = Math.min(position[1] + height, viewHeight) - height;
    position[0] = Math.max(position[0], 0);
    position[1] = Math.max(position[1], 0);
}
function $4c9900f2e2ca23a4$export$7cffee0f9aed39d0(value, axis, ecModel, seriesDataIndices, opt) {
    value = axis.scale.parse(value);
    var text = axis.scale.getLabel({
        value: value
    }, {
        // If `precision` is set, width can be fixed (like '12.00500'), which
        // helps to debounce when when moving label.
        precision: opt.precision
    });
    var formatter = opt.formatter;
    if (formatter) {
        var params_1 = {
            value: $5435624263a719a6$export$a5a32f324c1fa457(axis, {
                value: value
            }),
            axisDimension: axis.dim,
            axisIndex: axis.index,
            seriesData: []
        };
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(seriesDataIndices, function(idxItem) {
            var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
            var dataIndex = idxItem.dataIndexInside;
            var dataParams = series && series.getDataParams(dataIndex);
            dataParams && params_1.seriesData.push(dataParams);
        });
        if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(formatter)) text = formatter.replace('{value}', text);
        else if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(formatter)) text = formatter(params_1);
    }
    return text;
}
function $4c9900f2e2ca23a4$export$4bb66440324c3a3d(axis, value, layoutInfo) {
    var transform = $78537c687449356c$export$185802fd694ee1f5();
    $78537c687449356c$export$bb628a54ab399bc9(transform, transform, layoutInfo.rotation);
    $78537c687449356c$export$d73ee8ef04f5226a(transform, transform, layoutInfo.position);
    return $8eb95236e1aa01e7$export$9f9dcb98c894b623([
        axis.dataToCoord(value),
        (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)
    ], transform);
}
function $4c9900f2e2ca23a4$export$fd3eb3812211a173(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
    // @ts-ignore
    var textLayout = (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039).innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
    layoutInfo.labelMargin = axisPointerModel.get([
        'label',
        'margin'
    ]);
    $4c9900f2e2ca23a4$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, {
        position: $4c9900f2e2ca23a4$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo),
        align: textLayout.textAlign,
        verticalAlign: textLayout.textVerticalAlign
    });
}
function $4c9900f2e2ca23a4$export$885fa0ad5a826207(p1, p2, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x1: p1[xDimIndex],
        y1: p1[1 - xDimIndex],
        x2: p2[xDimIndex],
        y2: p2[1 - xDimIndex]
    };
}
function $4c9900f2e2ca23a4$export$a8b35248bcc02756(xy, wh, xDimIndex) {
    xDimIndex = xDimIndex || 0;
    return {
        x: xy[xDimIndex],
        y: xy[1 - xDimIndex],
        width: wh[xDimIndex],
        height: wh[1 - xDimIndex]
    };
}
function $4c9900f2e2ca23a4$export$b0cf82e7ebc0d7d0(cx, cy, r0, r, startAngle, endAngle) {
    return {
        cx: cx,
        cy: cy,
        r0: r0,
        r: r,
        startAngle: startAngle,
        endAngle: endAngle,
        clockwise: true
    };
}



var $04ab6e67eac027a4$var$CartesianAxisPointer = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CartesianAxisPointer, _super);
    function CartesianAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ CartesianAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisPointerType = axisPointerModel.get('type');
        var otherExtent = $04ab6e67eac027a4$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $4c9900f2e2ca23a4$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $04ab6e67eac027a4$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $9a3224039b65a07f$export$b3219800bda33a1f(grid.model, axisModel);
        $4c9900f2e2ca23a4$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $9a3224039b65a07f$export$b3219800bda33a1f(axisModel.axis.grid.model, axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var pos = $4c9900f2e2ca23a4$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: pos[0],
            y: pos[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ CartesianAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var grid = axis.grid;
        var axisExtent = axis.getGlobalExtent(true);
        var otherExtent = $04ab6e67eac027a4$var$getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
        var dimIndex = axis.dim === 'x' ? 0 : 1;
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        // Make tooltip do not overlap axisPointer and in the middle of the grid.
        var tooltipOptions = [
            {
                verticalAlign: 'middle'
            },
            {
                align: 'center'
            }
        ];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: tooltipOptions[dimIndex]
        };
    };
    return CartesianAxisPointer;
}((0, $26b546213ed8e9de$export$2e2bcd8739ae039));
function $04ab6e67eac027a4$var$getCartesian(grid, axis) {
    var opt = {};
    opt[axis.dim + 'AxisIndex'] = axis.index;
    return grid.getCartesian(opt);
}
var $04ab6e67eac027a4$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $4c9900f2e2ca23a4$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $04ab6e67eac027a4$var$getAxisDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $4c9900f2e2ca23a4$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $04ab6e67eac027a4$var$getAxisDimIndex(axis))
        };
    }
};
function $04ab6e67eac027a4$var$getAxisDimIndex(axis) {
    return axis.dim === 'x' ? 0 : 1;
}
var $04ab6e67eac027a4$export$2e2bcd8739ae039 = $04ab6e67eac027a4$var$CartesianAxisPointer;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $c1252479db9a5b0d$var$AxisPointerModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(AxisPointerModel, _super);
    function AxisPointerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerModel.type;
        return _this;
    }
    AxisPointerModel.type = 'axisPointer';
    AxisPointerModel.defaultOption = {
        // 'auto' means that show when triggered by tooltip or handle.
        show: 'auto',
        // zlevel: 0,
        z: 50,
        type: 'line',
        // axispointer triggered by tootip determine snap automatically,
        // see `modelHelper`.
        snap: false,
        triggerTooltip: true,
        triggerEmphasis: true,
        value: null,
        status: null,
        link: [],
        // Do not set 'auto' here, otherwise global animation: false
        // will not effect at this axispointer.
        animation: null,
        animationDurationUpdate: 200,
        lineStyle: {
            color: '#B9BEC9',
            width: 1,
            type: 'dashed'
        },
        shadowStyle: {
            color: 'rgba(210,219,238,0.2)'
        },
        label: {
            show: true,
            formatter: null,
            precision: 'auto',
            margin: 3,
            color: '#fff',
            padding: [
                5,
                7,
                5,
                7
            ],
            backgroundColor: 'auto',
            borderColor: null,
            borderWidth: 0,
            borderRadius: 3
        },
        handle: {
            show: false,
            // eslint-disable-next-line
            icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
            size: 45,
            // handle margin is from symbol center to axis, which is stable when circular move.
            margin: 50,
            // color: '#1b8bbd'
            // color: '#2f4554'
            color: '#333',
            shadowBlur: 3,
            shadowColor: '#aaa',
            shadowOffsetX: 0,
            shadowOffsetY: 2,
            // For mobile performance
            throttle: 40
        }
    };
    return AxisPointerModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $c1252479db9a5b0d$export$2e2bcd8739ae039 = $c1252479db9a5b0d$var$AxisPointerModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $86b7fb18065b1c0c$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $86b7fb18065b1c0c$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
function $86b7fb18065b1c0c$export$6503ec6e8aabbaf(key, api, handler) {
    if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    $86b7fb18065b1c0c$var$inner(zr).records || ($86b7fb18065b1c0c$var$inner(zr).records = {});
    $86b7fb18065b1c0c$var$initGlobalListeners(zr, api);
    var record = $86b7fb18065b1c0c$var$inner(zr).records[key] || ($86b7fb18065b1c0c$var$inner(zr).records[key] = {});
    record.handler = handler;
}
function $86b7fb18065b1c0c$var$initGlobalListeners(zr, api) {
    if ($86b7fb18065b1c0c$var$inner(zr).initialized) return;
    $86b7fb18065b1c0c$var$inner(zr).initialized = true;
    useHandler('click', $1b239fc9d3a2f8ae$export$c3095a23b368d1f2($86b7fb18065b1c0c$var$doEnter, 'click'));
    useHandler('mousemove', $1b239fc9d3a2f8ae$export$c3095a23b368d1f2($86b7fb18065b1c0c$var$doEnter, 'mousemove'));
    // useHandler('mouseout', onLeave);
    useHandler('globalout', $86b7fb18065b1c0c$var$onLeave);
    function useHandler(eventType, cb) {
        zr.on(eventType, function(e) {
            var dis = $86b7fb18065b1c0c$var$makeDispatchAction(api);
            $86b7fb18065b1c0c$var$each($86b7fb18065b1c0c$var$inner(zr).records, function(record) {
                record && cb(record, e, dis.dispatchAction);
            });
            $86b7fb18065b1c0c$var$dispatchTooltipFinally(dis.pendings, api);
        });
    }
}
function $86b7fb18065b1c0c$var$dispatchTooltipFinally(pendings, api) {
    var showLen = pendings.showTip.length;
    var hideLen = pendings.hideTip.length;
    var actuallyPayload;
    if (showLen) actuallyPayload = pendings.showTip[showLen - 1];
    else if (hideLen) actuallyPayload = pendings.hideTip[hideLen - 1];
    if (actuallyPayload) {
        actuallyPayload.dispatchAction = null;
        api.dispatchAction(actuallyPayload);
    }
}
function $86b7fb18065b1c0c$var$onLeave(record, e, dispatchAction) {
    record.handler('leave', null, dispatchAction);
}
function $86b7fb18065b1c0c$var$doEnter(currTrigger, record, e, dispatchAction) {
    record.handler(currTrigger, e, dispatchAction);
}
function $86b7fb18065b1c0c$var$makeDispatchAction(api) {
    var pendings = {
        showTip: [],
        hideTip: []
    };
    // FIXME
    // better approach?
    // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
    // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
    // So we have to add "final stage" to merge those dispatched actions.
    var dispatchAction = function(payload) {
        var pendingList = pendings[payload.type];
        if (pendingList) pendingList.push(payload);
        else {
            payload.dispatchAction = dispatchAction;
            api.dispatchAction(payload);
        }
    };
    return {
        dispatchAction: dispatchAction,
        pendings: pendings
    };
}
function $86b7fb18065b1c0c$export$d07f55d4c15c0440(key, api) {
    if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node) return;
    var zr = api.getZr();
    var record = ($86b7fb18065b1c0c$var$inner(zr).records || {})[key];
    if (record) $86b7fb18065b1c0c$var$inner(zr).records[key] = null;
}



var $ce224f2e74f17df6$var$AxisPointerView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(AxisPointerView, _super);
    function AxisPointerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AxisPointerView.type;
        return _this;
    }
    AxisPointerView.prototype.render = function(globalAxisPointerModel, ecModel, api) {
        var globalTooltipModel = ecModel.getComponent('tooltip');
        var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click';
        // Register global listener in AxisPointerView to enable
        // AxisPointerView to be independent to Tooltip.
        $86b7fb18065b1c0c$export$6503ec6e8aabbaf('axisPointer', api, function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) dispatchAction({
                type: 'updateAxisPointer',
                currTrigger: currTrigger,
                x: e && e.offsetX,
                y: e && e.offsetY
            });
        });
    };
    AxisPointerView.prototype.remove = function(ecModel, api) {
        $86b7fb18065b1c0c$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.prototype.dispose = function(ecModel, api) {
        $86b7fb18065b1c0c$export$d07f55d4c15c0440('axisPointer', api);
    };
    AxisPointerView.type = 'axisPointer';
    return AxisPointerView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $ce224f2e74f17df6$export$2e2bcd8739ae039 = $ce224f2e74f17df6$var$AxisPointerView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $0b09587509d00b8a$export$2e2bcd8739ae039(finder, ecModel) {
    var point = [];
    var seriesIndex = finder.seriesIndex;
    var seriesModel;
    if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) return {
        point: []
    };
    var data = seriesModel.getData();
    var dataIndex = $9ac03c46e8b6e711$export$42b26cae8b8d10(data, finder);
    if (dataIndex == null || dataIndex < 0 || $1b239fc9d3a2f8ae$export$43bee75e5e14138e(dataIndex)) return {
        point: []
    };
    var el = data.getItemGraphicEl(dataIndex);
    var coordSys = seriesModel.coordinateSystem;
    if (seriesModel.getTooltipPosition) point = seriesModel.getTooltipPosition(dataIndex) || [];
    else if (coordSys && coordSys.dataToPoint) {
        if (finder.isStacked) {
            var baseAxis = coordSys.getBaseAxis();
            var valueAxis = coordSys.getOtherAxis(baseAxis);
            var valueAxisDim = valueAxis.dim;
            var baseAxisDim = baseAxis.dim;
            var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
            var baseDim = data.mapDimension(baseAxisDim);
            var stackedData = [];
            stackedData[baseDataOffset] = data.get(baseDim, dataIndex);
            stackedData[1 - baseDataOffset] = data.get(data.getCalculationInfo('stackResultDimension'), dataIndex);
            point = coordSys.dataToPoint(stackedData) || [];
        } else point = coordSys.dataToPoint(data.getValues($1b239fc9d3a2f8ae$export$871de8747c9eaa88(coordSys.dimensions, function(dim) {
            return data.mapDimension(dim);
        }), dataIndex)) || [];
    } else if (el) {
        // Use graphic bounding rect
        var rect = el.getBoundingRect().clone();
        rect.applyTransform(el.transform);
        point = [
            rect.x + rect.width / 2,
            rect.y + rect.height / 2
        ];
    }
    return {
        point: point,
        el: el
    };
}



var $0c1726ea63d677e3$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $0c1726ea63d677e3$export$2e2bcd8739ae039(payload, ecModel, api) {
    var currTrigger = payload.currTrigger;
    var point = [
        payload.x,
        payload.y
    ];
    var finder = payload;
    var dispatchAction = payload.dispatchAction || (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(api.dispatchAction, api);
    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
    // Pending
    // See #6121. But we are not able to reproduce it yet.
    if (!coordSysAxesInfo) return;
    if ($0c1726ea63d677e3$var$illegalPoint(point)) // Used in the default behavior of `connection`: use the sample seriesIndex
    // and dataIndex. And also used in the tooltipView trigger.
    point = (0, $0b09587509d00b8a$export$2e2bcd8739ae039)({
        seriesIndex: finder.seriesIndex,
        // Do not use dataIndexInside from other ec instance.
        // FIXME: auto detect it?
        dataIndex: finder.dataIndex
    }, ecModel).point;
    var isIllegalPoint = $0c1726ea63d677e3$var$illegalPoint(point);
    // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
    // Notice: In this case, it is difficult to get the `point` (which is necessary to show
    // tooltip, so if point is not given, we just use the point found by sample seriesIndex
    // and dataIndex.
    var inputAxesInfo = finder.axesInfo;
    var axesInfo = coordSysAxesInfo.axesInfo;
    var shouldHide = currTrigger === 'leave' || $0c1726ea63d677e3$var$illegalPoint(point);
    var outputPayload = {};
    var showValueMap = {};
    var dataByCoordSys = {
        list: [],
        map: {}
    };
    var updaters = {
        showPointer: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($0c1726ea63d677e3$var$showPointer, showValueMap),
        showTooltip: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($0c1726ea63d677e3$var$showTooltip, dataByCoordSys)
    };
    // Process for triggered axes.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysMap, function(coordSys, coordSysKey) {
        // If a point given, it must be contained by the coordinate system.
        var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function(axisInfo, key) {
            var axis = axisInfo.axis;
            var inputAxisInfo = $0c1726ea63d677e3$var$findInputAxisInfo(inputAxesInfo, axisInfo);
            // If no inputAxesInfo, no axis is restricted.
            if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
                var val = inputAxisInfo && inputAxisInfo.value;
                if (val == null && !isIllegalPoint) val = axis.pointToData(point);
                val != null && $0c1726ea63d677e3$var$processOnAxis(axisInfo, val, updaters, false, outputPayload);
            }
        });
    });
    // Process for linked axes.
    var linkTriggers = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesInfo, function(tarAxisInfo, tarKey) {
        var linkGroup = tarAxisInfo.linkGroup;
        // If axis has been triggered in the previous stage, it should not be triggered by link.
        if (linkGroup && !showValueMap[tarKey]) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(linkGroup.axesInfo, function(srcAxisInfo, srcKey) {
            var srcValItem = showValueMap[srcKey];
            // If srcValItem exist, source axis is triggered, so link to target axis.
            if (srcAxisInfo !== tarAxisInfo && srcValItem) {
                var val = srcValItem.value;
                linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, $0c1726ea63d677e3$var$makeMapperParam(srcAxisInfo), $0c1726ea63d677e3$var$makeMapperParam(tarAxisInfo))));
                linkTriggers[tarAxisInfo.key] = val;
            }
        });
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(linkTriggers, function(val, tarKey) {
        $0c1726ea63d677e3$var$processOnAxis(axesInfo[tarKey], val, updaters, true, outputPayload);
    });
    $0c1726ea63d677e3$var$updateModelActually(showValueMap, axesInfo, outputPayload);
    $0c1726ea63d677e3$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
    $0c1726ea63d677e3$var$dispatchHighDownActually(axesInfo, dispatchAction, api);
    return outputPayload;
}
function $0c1726ea63d677e3$var$processOnAxis(axisInfo, newValue, updaters, noSnap, outputFinder) {
    var axis = axisInfo.axis;
    if (axis.scale.isBlank() || !axis.containData(newValue)) return;
    if (!axisInfo.involveSeries) {
        updaters.showPointer(axisInfo, newValue);
        return;
    }
    // Heavy calculation. So put it after axis.containData checking.
    var payloadInfo = $0c1726ea63d677e3$var$buildPayloadsBySeries(newValue, axisInfo);
    var payloadBatch = payloadInfo.payloadBatch;
    var snapToValue = payloadInfo.snapToValue;
    // Fill content of event obj for echarts.connect.
    // By default use the first involved series data as a sample to connect.
    if (payloadBatch[0] && outputFinder.seriesIndex == null) (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)(outputFinder, payloadBatch[0]);
    // If no linkSource input, this process is for collecting link
    // target, where snap should not be accepted.
    if (!noSnap && axisInfo.snap) {
        if (axis.containData(snapToValue) && snapToValue != null) newValue = snapToValue;
    }
    updaters.showPointer(axisInfo, newValue, payloadBatch);
    // Tooltip should always be snapToValue, otherwise there will be
    // incorrect "axis value ~ series value" mapping displayed in tooltip.
    updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
}
function $0c1726ea63d677e3$var$buildPayloadsBySeries(value, axisInfo) {
    var axis = axisInfo.axis;
    var dim = axis.dim;
    var snapToValue = value;
    var payloadBatch = [];
    var minDist = Number.MAX_VALUE;
    var minDiff = -1;
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axisInfo.seriesModels, function(series, idx) {
        var dataDim = series.getData().mapDimensionsAll(dim);
        var seriesNestestValue;
        var dataIndices;
        if (series.getAxisTooltipData) {
            var result = series.getAxisTooltipData(dataDim, value, axis);
            dataIndices = result.dataIndices;
            seriesNestestValue = result.nestestValue;
        } else {
            dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
            // when data length is not same.
            // false,
            axis.type === 'category' ? 0.5 : null);
            if (!dataIndices.length) return;
            seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
        }
        if (seriesNestestValue == null || !isFinite(seriesNestestValue)) return;
        var diff = value - seriesNestestValue;
        var dist = Math.abs(diff);
        // Consider category case
        if (dist <= minDist) {
            if (dist < minDist || diff >= 0 && minDiff < 0) {
                minDist = dist;
                minDiff = diff;
                snapToValue = seriesNestestValue;
                payloadBatch.length = 0;
            }
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dataIndices, function(dataIndex) {
                payloadBatch.push({
                    seriesIndex: series.seriesIndex,
                    dataIndexInside: dataIndex,
                    dataIndex: series.getData().getRawIndex(dataIndex)
                });
            });
        }
    });
    return {
        payloadBatch: payloadBatch,
        snapToValue: snapToValue
    };
}
function $0c1726ea63d677e3$var$showPointer(showValueMap, axisInfo, value, payloadBatch) {
    showValueMap[axisInfo.key] = {
        value: value,
        payloadBatch: payloadBatch
    };
}
function $0c1726ea63d677e3$var$showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
    var payloadBatch = payloadInfo.payloadBatch;
    var axis = axisInfo.axis;
    var axisModel = axis.model;
    var axisPointerModel = axisInfo.axisPointerModel;
    // If no data, do not create anything in dataByCoordSys,
    // whose length will be used to judge whether dispatch action.
    if (!axisInfo.triggerTooltip || !payloadBatch.length) return;
    var coordSysModel = axisInfo.coordSys.model;
    var coordSysKey = $c55894497062b37c$export$d01b444bafb1a792(coordSysModel);
    var coordSysItem = dataByCoordSys.map[coordSysKey];
    if (!coordSysItem) {
        coordSysItem = dataByCoordSys.map[coordSysKey] = {
            coordSysId: coordSysModel.id,
            coordSysIndex: coordSysModel.componentIndex,
            coordSysType: coordSysModel.type,
            coordSysMainType: coordSysModel.mainType,
            dataByAxis: []
        };
        dataByCoordSys.list.push(coordSysItem);
    }
    coordSysItem.dataByAxis.push({
        axisDim: axis.dim,
        axisIndex: axisModel.componentIndex,
        axisType: axisModel.type,
        axisId: axisModel.id,
        value: value,
        // Caustion: viewHelper.getValueLabel is actually on "view stage", which
        // depends that all models have been updated. So it should not be performed
        // here. Considering axisPointerModel used here is volatile, which is hard
        // to be retrieve in TooltipView, we prepare parameters here.
        valueLabelOpt: {
            precision: axisPointerModel.get([
                'label',
                'precision'
            ]),
            formatter: axisPointerModel.get([
                'label',
                'formatter'
            ])
        },
        seriesDataIndices: payloadBatch.slice()
    });
}
function $0c1726ea63d677e3$var$updateModelActually(showValueMap, axesInfo, outputPayload) {
    var outputAxesInfo = outputPayload.axesInfo = [];
    // Basic logic: If no 'show' required, 'hide' this axisPointer.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        var valItem = showValueMap[key];
        if (valItem) {
            !axisInfo.useHandle && (option.status = 'show');
            option.value = valItem.value;
            // For label formatter param and highlight.
            option.seriesDataIndices = (valItem.payloadBatch || []).slice();
        } else // If hide, value still need to be set, consider
        // click legend to toggle axis blank.
        !axisInfo.useHandle && (option.status = 'hide');
        // If status is 'hide', should be no info in payload.
        option.status === 'show' && outputAxesInfo.push({
            axisDim: axisInfo.axis.dim,
            axisIndex: axisInfo.axis.model.componentIndex,
            value: option.value
        });
    });
}
function $0c1726ea63d677e3$var$dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
    // Basic logic: If no showTip required, hideTip will be dispatched.
    if ($0c1726ea63d677e3$var$illegalPoint(point) || !dataByCoordSys.list.length) {
        dispatchAction({
            type: 'hideTip'
        });
        return;
    }
    // In most case only one axis (or event one series is used). It is
    // convenient to fetch payload.seriesIndex and payload.dataIndex
    // directly. So put the first seriesIndex and dataIndex of the first
    // axis on the payload.
    var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
    dispatchAction({
        type: 'showTip',
        escapeConnect: true,
        x: point[0],
        y: point[1],
        tooltipOption: payload.tooltipOption,
        position: payload.position,
        dataIndexInside: sampleItem.dataIndexInside,
        dataIndex: sampleItem.dataIndex,
        seriesIndex: sampleItem.seriesIndex,
        dataByCoordSys: dataByCoordSys.list
    });
}
function $0c1726ea63d677e3$var$dispatchHighDownActually(axesInfo, dispatchAction, api) {
    // FIXME
    // highlight status modification should be a stage of main process?
    // (Consider confilct (e.g., legend and axisPointer) and setOption)
    var zr = api.getZr();
    var highDownKey = 'axisPointerLastHighlights';
    var lastHighlights = $0c1726ea63d677e3$var$inner(zr)[highDownKey] || {};
    var newHighlights = $0c1726ea63d677e3$var$inner(zr)[highDownKey] = {};
    // Update highlight/downplay status according to axisPointer model.
    // Build hash map and remove duplicate incidentally.
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axesInfo, function(axisInfo, key) {
        var option = axisInfo.axisPointerModel.option;
        option.status === 'show' && axisInfo.triggerEmphasis && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(option.seriesDataIndices, function(batchItem) {
            var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
            newHighlights[key] = batchItem;
        });
    });
    // Diff.
    var toHighlight = [];
    var toDownplay = [];
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(lastHighlights, function(batchItem, key) {
        !newHighlights[key] && toDownplay.push(batchItem);
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newHighlights, function(batchItem, key) {
        !lastHighlights[key] && toHighlight.push(batchItem);
    });
    toDownplay.length && api.dispatchAction({
        type: 'downplay',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toDownplay
    });
    toHighlight.length && api.dispatchAction({
        type: 'highlight',
        escapeConnect: true,
        // Not blur others when highlight in axisPointer.
        notBlur: true,
        batch: toHighlight
    });
}
function $0c1726ea63d677e3$var$findInputAxisInfo(inputAxesInfo, axisInfo) {
    for(var i = 0; i < (inputAxesInfo || []).length; i++){
        var inputAxisInfo = inputAxesInfo[i];
        if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) return inputAxisInfo;
    }
}
function $0c1726ea63d677e3$var$makeMapperParam(axisInfo) {
    var axisModel = axisInfo.axis.model;
    var item = {};
    var dim = item.axisDim = axisInfo.axis.dim;
    item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
    item.axisName = item[dim + 'AxisName'] = axisModel.name;
    item.axisId = item[dim + 'AxisId'] = axisModel.id;
    return item;
}
function $0c1726ea63d677e3$var$illegalPoint(point) {
    return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
}


function $d1d2b9dcfa505105$export$4b3e715f166fdd78(registers) {
    // CartesianAxisPointer is not supposed to be required here. But consider
    // echarts.simple.js and online build tooltip, which only require gridSimple,
    // CartesianAxisPointer should be able to required somewhere.
    (0, $9d9acba2c65ca6e6$export$2e2bcd8739ae039).registerAxisPointerClass('CartesianAxisPointer', (0, $04ab6e67eac027a4$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $c1252479db9a5b0d$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $ce224f2e74f17df6$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(option) {
        // Always has a global axisPointerModel for default setting.
        if (option) {
            (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
            var link = option.axisPointer.link;
            // Normalize to array to avoid object mergin. But if link
            // is not set, remain null/undefined, otherwise it will
            // override existent link setting.
            if (link && !(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(link)) option.axisPointer.link = [
                link
            ];
        }
    });
    // This process should proformed after coordinate systems created
    // and series data processed. So put it on statistic processing stage.
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.STATISTIC, function(ecModel, api) {
        // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
        // allAxesInfo should be updated when setOption performed.
        ecModel.getComponent('axisPointer').coordSysAxesInfo = (0, $c55894497062b37c$export$bb44f104e3c54dae)(ecModel, api);
    });
    // Broadcast to all views.
    registers.registerAction({
        type: 'updateAxisPointer',
        event: 'updateAxisPointer',
        update: ':updateAxisPointer'
    }, (0, $0c1726ea63d677e3$export$2e2bcd8739ae039));
}



function $3fdff82213dffd8e$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $cd1a81fbb12c3d5f$export$4b3e715f166fdd78));
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $d1d2b9dcfa505105$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $056fedf6e253b5ca$var$PolarAxisPointer = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PolarAxisPointer, _super);
    function PolarAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ PolarAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        if (axis.dim === 'angle') this.animationThreshold = Math.PI / 18;
        var polar = axis.polar;
        var otherAxis = polar.getOtherAxis(axis);
        var otherExtent = otherAxis.getExtent();
        var coordValue = axis.dataToCoord(value);
        var axisPointerType = axisPointerModel.get('type');
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $4c9900f2e2ca23a4$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $056fedf6e253b5ca$var$pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var labelMargin = axisPointerModel.get([
            'label',
            'margin'
        ]);
        var labelPos = $056fedf6e253b5ca$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
        $4c9900f2e2ca23a4$export$8206a9937c45910f(elOption, axisModel, axisPointerModel, api, labelPos);
    };
    return PolarAxisPointer;
}((0, $26b546213ed8e9de$export$2e2bcd8739ae039));
function $056fedf6e253b5ca$var$getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
    var axis = axisModel.axis;
    var coord = axis.dataToCoord(value);
    var axisAngle = polar.getAngleAxis().getExtent()[0];
    axisAngle = axisAngle / 180 * Math.PI;
    var radiusExtent = polar.getRadiusAxis().getExtent();
    var position;
    var align;
    var verticalAlign;
    if (axis.dim === 'radius') {
        var transform = $78537c687449356c$export$185802fd694ee1f5();
        $78537c687449356c$export$bb628a54ab399bc9(transform, transform, axisAngle);
        $78537c687449356c$export$d73ee8ef04f5226a(transform, transform, [
            polar.cx,
            polar.cy
        ]);
        position = $8eb95236e1aa01e7$export$9f9dcb98c894b623([
            coord,
            -labelMargin
        ], transform);
        var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
        // @ts-ignore
        var labelLayout = (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039).innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
        align = labelLayout.textAlign;
        verticalAlign = labelLayout.textVerticalAlign;
    } else {
        // angle axis
        var r = radiusExtent[1];
        position = polar.coordToPoint([
            r + labelMargin,
            coord
        ]);
        var cx = polar.cx;
        var cy = polar.cy;
        align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
        verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
    }
    return {
        position: position,
        align: align,
        verticalAlign: verticalAlign
    };
}
var $056fedf6e253b5ca$var$pointerShapeBuilder = {
    line: function(axis, polar, coordValue, otherExtent) {
        return axis.dim === 'angle' ? {
            type: 'Line',
            shape: $4c9900f2e2ca23a4$export$885fa0ad5a826207(polar.coordToPoint([
                otherExtent[0],
                coordValue
            ]), polar.coordToPoint([
                otherExtent[1],
                coordValue
            ]))
        } : {
            type: 'Circle',
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: coordValue
            }
        };
    },
    shadow: function(axis, polar, coordValue, otherExtent) {
        var bandWidth = Math.max(1, axis.getBandWidth());
        var radian = Math.PI / 180;
        return axis.dim === 'angle' ? {
            type: 'Sector',
            shape: $4c9900f2e2ca23a4$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
            (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
        } : {
            type: 'Sector',
            shape: $4c9900f2e2ca23a4$export$b0cf82e7ebc0d7d0(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
        };
    }
};
var $056fedf6e253b5ca$export$2e2bcd8739ae039 = $056fedf6e253b5ca$var$PolarAxisPointer;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $dda15ae8c6f5dd65$var$PolarModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PolarModel, _super);
    function PolarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarModel.type;
        return _this;
    }
    PolarModel.prototype.findAxisModel = function(axisType) {
        var foundAxisModel;
        var ecModel = this.ecModel;
        ecModel.eachComponent(axisType, function(axisModel) {
            if (axisModel.getCoordSysModel() === this) foundAxisModel = axisModel;
        }, this);
        return foundAxisModel;
    };
    PolarModel.type = 'polar';
    PolarModel.dependencies = [
        'radiusAxis',
        'angleAxis'
    ];
    PolarModel.defaultOption = {
        // zlevel: 0,
        z: 0,
        center: [
            '50%',
            '50%'
        ],
        radius: '80%'
    };
    return PolarModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $dda15ae8c6f5dd65$export$2e2bcd8739ae039 = $dda15ae8c6f5dd65$var$PolarModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $a75bde112118309d$export$ae9b190f9f84c66f = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PolarAxisModel, _super);
    function PolarAxisModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PolarAxisModel.prototype.getCoordSysModel = function() {
        return this.getReferringComponents('polar', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
    };
    PolarAxisModel.type = 'polarAxis';
    return PolarAxisModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($a75bde112118309d$export$ae9b190f9f84c66f, (0, $12a09fd102c04f88$export$5c54b224726edb5a));
var $a75bde112118309d$export$34735c2c701428ca = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(AngleAxisModel, _super);
    function AngleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisModel.type;
        return _this;
    }
    AngleAxisModel.type = 'angleAxis';
    return AngleAxisModel;
}($a75bde112118309d$export$ae9b190f9f84c66f);
var $a75bde112118309d$export$de202388c212a23b = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadiusAxisModel, _super);
    function RadiusAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisModel.type;
        return _this;
    }
    RadiusAxisModel.type = 'radiusAxis';
    return RadiusAxisModel;
}($a75bde112118309d$export$ae9b190f9f84c66f);


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO Axis scale

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $29ff6bc1ebfab1cd$var$RadiusAxis = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadiusAxis, _super);
    function RadiusAxis(scale, radiusExtent) {
        return _super.call(this, 'radius', scale, radiusExtent) || this;
    }
    RadiusAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
    };
    return RadiusAxis;
}((0, $099c976b90502319$export$2e2bcd8739ae039));
$29ff6bc1ebfab1cd$var$RadiusAxis.prototype.dataToRadius = (0, $099c976b90502319$export$2e2bcd8739ae039).prototype.dataToCoord;
$29ff6bc1ebfab1cd$var$RadiusAxis.prototype.radiusToData = (0, $099c976b90502319$export$2e2bcd8739ae039).prototype.coordToData;
var $29ff6bc1ebfab1cd$export$2e2bcd8739ae039 = $29ff6bc1ebfab1cd$var$RadiusAxis;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $9321a53c15ff6d39$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $9321a53c15ff6d39$var$AngleAxis = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(AngleAxis, _super);
    function AngleAxis(scale, angleExtent) {
        return _super.call(this, 'angle', scale, angleExtent || [
            0,
            360
        ]) || this;
    }
    AngleAxis.prototype.pointToData = function(point, clamp) {
        return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
    };
    /**
   * Only be called in category axis.
   * Angle axis uses text height to decide interval
   *
   * @override
   * @return {number} Auto interval for cateogry axis tick and label
   */ AngleAxis.prototype.calculateCategoryInterval = function() {
        var axis = this;
        var labelModel = axis.getLabelModel();
        var ordinalScale = axis.scale;
        var ordinalExtent = ordinalScale.getExtent();
        // Providing this method is for optimization:
        // avoid generating a long array by `getTicks`
        // in large category data case.
        var tickCount = ordinalScale.count();
        if (ordinalExtent[1] - ordinalExtent[0] < 1) return 0;
        var tickValue = ordinalExtent[0];
        var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
        var unitH = Math.abs(unitSpan);
        // Not precise, just use height as text width
        // and each distance from axis line yet.
        var rect = $297531217517fbce$export$c381147bfed79d9f(tickValue == null ? '' : tickValue + '', labelModel.getFont(), 'center', 'top');
        var maxH = Math.max(rect.height, 7);
        var dh = maxH / unitH;
        // 0/0 is NaN, 1/0 is Infinity.
        isNaN(dh) && (dh = Infinity);
        var interval = Math.max(0, Math.floor(dh));
        var cache = $9321a53c15ff6d39$var$inner(axis.model);
        var lastAutoInterval = cache.lastAutoInterval;
        var lastTickCount = cache.lastTickCount;
        // Use cache to keep interval stable while moving zoom window,
        // otherwise the calculated interval might jitter when the zoom
        // window size is close to the interval-changing size.
        if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 && lastAutoInterval > interval) interval = lastAutoInterval;
        else {
            cache.lastTickCount = tickCount;
            cache.lastAutoInterval = interval;
        }
        return interval;
    };
    return AngleAxis;
}((0, $099c976b90502319$export$2e2bcd8739ae039));
$9321a53c15ff6d39$var$AngleAxis.prototype.dataToAngle = (0, $099c976b90502319$export$2e2bcd8739ae039).prototype.dataToCoord;
$9321a53c15ff6d39$var$AngleAxis.prototype.angleToData = (0, $099c976b90502319$export$2e2bcd8739ae039).prototype.coordToData;
var $9321a53c15ff6d39$export$2e2bcd8739ae039 = $9321a53c15ff6d39$var$AngleAxis;


var $969bb187078bb0a6$export$f6d9521c10640456 = [
    'radius',
    'angle'
];
var $969bb187078bb0a6$var$Polar = /** @class */ function() {
    function Polar(name) {
        this.dimensions = $969bb187078bb0a6$export$f6d9521c10640456;
        this.type = 'polar';
        /**
     * x of polar center
     */ this.cx = 0;
        /**
     * y of polar center
     */ this.cy = 0;
        this._radiusAxis = new (0, $29ff6bc1ebfab1cd$export$2e2bcd8739ae039)();
        this._angleAxis = new (0, $9321a53c15ff6d39$export$2e2bcd8739ae039)();
        this.axisPointerEnabled = true;
        this.name = name || '';
        this._radiusAxis.polar = this._angleAxis.polar = this;
    }
    /**
   * If contain coord
   */ Polar.prototype.containPoint = function(point) {
        var coord = this.pointToCoord(point);
        return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
    };
    /**
   * If contain data
   */ Polar.prototype.containData = function(data) {
        return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
    };
    Polar.prototype.getAxis = function(dim) {
        var key = '_' + dim + 'Axis';
        return this[key];
    };
    Polar.prototype.getAxes = function() {
        return [
            this._radiusAxis,
            this._angleAxis
        ];
    };
    /**
   * Get axes by type of scale
   */ Polar.prototype.getAxesByScale = function(scaleType) {
        var axes = [];
        var angleAxis = this._angleAxis;
        var radiusAxis = this._radiusAxis;
        angleAxis.scale.type === scaleType && axes.push(angleAxis);
        radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
        return axes;
    };
    Polar.prototype.getAngleAxis = function() {
        return this._angleAxis;
    };
    Polar.prototype.getRadiusAxis = function() {
        return this._radiusAxis;
    };
    Polar.prototype.getOtherAxis = function(axis) {
        var angleAxis = this._angleAxis;
        return axis === angleAxis ? this._radiusAxis : angleAxis;
    };
    /**
   * Base axis will be used on stacking.
   *
   */ Polar.prototype.getBaseAxis = function() {
        return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
    };
    Polar.prototype.getTooltipAxes = function(dim) {
        var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
        return {
            baseAxes: [
                baseAxis
            ],
            otherAxes: [
                this.getOtherAxis(baseAxis)
            ]
        };
    };
    /**
   * Convert a single data item to (x, y) point.
   * Parameter data is an array which the first element is radius and the second is angle
   */ Polar.prototype.dataToPoint = function(data, clamp) {
        return this.coordToPoint([
            this._radiusAxis.dataToRadius(data[0], clamp),
            this._angleAxis.dataToAngle(data[1], clamp)
        ]);
    };
    /**
   * Convert a (x, y) point to data
   */ Polar.prototype.pointToData = function(point, clamp) {
        var coord = this.pointToCoord(point);
        return [
            this._radiusAxis.radiusToData(coord[0], clamp),
            this._angleAxis.angleToData(coord[1], clamp)
        ];
    };
    /**
   * Convert a (x, y) point to (radius, angle) coord
   */ Polar.prototype.pointToCoord = function(point) {
        var dx = point[0] - this.cx;
        var dy = point[1] - this.cy;
        var angleAxis = this.getAngleAxis();
        var extent = angleAxis.getExtent();
        var minAngle = Math.min(extent[0], extent[1]);
        var maxAngle = Math.max(extent[0], extent[1]);
        // Fix fixed extent in polarCreator
        // FIXME
        angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
        var radius = Math.sqrt(dx * dx + dy * dy);
        dx /= radius;
        dy /= radius;
        var radian = Math.atan2(-dy, dx) / Math.PI * 180;
        // move to angleExtent
        var dir = radian < minAngle ? 1 : -1;
        while(radian < minAngle || radian > maxAngle)radian += dir * 360;
        return [
            radius,
            radian
        ];
    };
    /**
   * Convert a (radius, angle) coord to (x, y) point
   */ Polar.prototype.coordToPoint = function(coord) {
        var radius = coord[0];
        var radian = coord[1] / 180 * Math.PI;
        var x = Math.cos(radian) * radius + this.cx;
        // Inverse the y
        var y = -Math.sin(radian) * radius + this.cy;
        return [
            x,
            y
        ];
    };
    /**
   * Get ring area of cartesian.
   * Area will have a contain function to determine if a point is in the coordinate system.
   */ Polar.prototype.getArea = function() {
        var angleAxis = this.getAngleAxis();
        var radiusAxis = this.getRadiusAxis();
        var radiusExtent = radiusAxis.getExtent().slice();
        radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
        var angleExtent = angleAxis.getExtent();
        var RADIAN = Math.PI / 180;
        var EPSILON = 1e-4;
        return {
            cx: this.cx,
            cy: this.cy,
            r0: radiusExtent[0],
            r: radiusExtent[1],
            startAngle: -angleExtent[0] * RADIAN,
            endAngle: -angleExtent[1] * RADIAN,
            clockwise: angleAxis.inverse,
            contain: function(x, y) {
                // It's a ring shape.
                // Start angle and end angle don't matter
                var dx = x - this.cx;
                var dy = y - this.cy;
                var d2 = dx * dx + dy * dy;
                var r = this.r;
                var r0 = this.r0;
                // minus a tiny value 1e-4 in double side to avoid being clipped unexpectedly
                // r == r0 contain nothing
                return r !== r0 && d2 - EPSILON <= r * r && d2 + EPSILON >= r0 * r0;
            }
        };
    };
    Polar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $969bb187078bb0a6$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Polar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $969bb187078bb0a6$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Polar;
}();
function $969bb187078bb0a6$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var polarModel = finder.polarModel;
    return polarModel && polarModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $969bb187078bb0a6$export$2e2bcd8739ae039 = $969bb187078bb0a6$var$Polar;





/**
 * Resize method bound to the polar
 */ function $40c5a3a9dc926bf7$var$resizePolar(polar, polarModel, api) {
    var center = polarModel.get('center');
    var width = api.getWidth();
    var height = api.getHeight();
    polar.cx = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[0], width);
    polar.cy = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(center[1], height);
    var radiusAxis = polar.getRadiusAxis();
    var size = Math.min(width, height) / 2;
    var radius = polarModel.get('radius');
    if (radius == null) radius = [
        0,
        '100%'
    ];
    else if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(radius)) // r0 = 0
    radius = [
        0,
        radius
    ];
    var parsedRadius = [
        (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(radius[0], size),
        (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(radius[1], size)
    ];
    radiusAxis.inverse ? radiusAxis.setExtent(parsedRadius[1], parsedRadius[0]) : radiusAxis.setExtent(parsedRadius[0], parsedRadius[1]);
}
/**
 * Update polar
 */ function $40c5a3a9dc926bf7$var$updatePolarScale(ecModel, api) {
    var polar = this;
    var angleAxis = polar.getAngleAxis();
    var radiusAxis = polar.getRadiusAxis();
    // Reset scale
    angleAxis.scale.setExtent(Infinity, -Infinity);
    radiusAxis.scale.setExtent(Infinity, -Infinity);
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.coordinateSystem === polar) {
            var data_1 = seriesModel.getData();
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43((0, $5435624263a719a6$export$e4cf30b1e74cd69d)(data_1, 'radius'), function(dim) {
                radiusAxis.scale.unionExtentFromData(data_1, dim);
            });
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43((0, $5435624263a719a6$export$e4cf30b1e74cd69d)(data_1, 'angle'), function(dim) {
                angleAxis.scale.unionExtentFromData(data_1, dim);
            });
        }
    });
    (0, $5435624263a719a6$export$51f3e70a54405d5a)(angleAxis.scale, angleAxis.model);
    (0, $5435624263a719a6$export$51f3e70a54405d5a)(radiusAxis.scale, radiusAxis.model);
    // Fix extent of category angle axis
    if (angleAxis.type === 'category' && !angleAxis.onBand) {
        var extent = angleAxis.getExtent();
        var diff = 360 / angleAxis.scale.count();
        angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
        angleAxis.setExtent(extent[0], extent[1]);
    }
}
function $40c5a3a9dc926bf7$var$isAngleAxisModel(axisModel) {
    return axisModel.mainType === 'angleAxis';
}
/**
 * Set common axis properties
 */ function $40c5a3a9dc926bf7$var$setAxis(axis, axisModel) {
    var _a;
    axis.type = axisModel.get('type');
    axis.scale = (0, $5435624263a719a6$export$8941c4cacdc8f5a5)(axisModel);
    axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
    axis.inverse = axisModel.get('inverse');
    if ($40c5a3a9dc926bf7$var$isAngleAxisModel(axisModel)) {
        axis.inverse = axis.inverse !== axisModel.get('clockwise');
        var startAngle = axisModel.get('startAngle');
        var endAngle = (_a = axisModel.get('endAngle')) !== null && _a !== void 0 ? _a : startAngle + (axis.inverse ? -360 : 360);
        axis.setExtent(startAngle, endAngle);
    }
    // Inject axis instance
    axisModel.axis = axis;
    axis.model = axisModel;
}
var $40c5a3a9dc926bf7$var$polarCreator = {
    dimensions: (0, $969bb187078bb0a6$export$f6d9521c10640456),
    create: function(ecModel, api) {
        var polarList = [];
        ecModel.eachComponent('polar', function(polarModel, idx) {
            var polar = new (0, $969bb187078bb0a6$export$2e2bcd8739ae039)(idx + '');
            // Inject resize and update method
            polar.update = $40c5a3a9dc926bf7$var$updatePolarScale;
            var radiusAxis = polar.getRadiusAxis();
            var angleAxis = polar.getAngleAxis();
            var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
            var angleAxisModel = polarModel.findAxisModel('angleAxis');
            $40c5a3a9dc926bf7$var$setAxis(radiusAxis, radiusAxisModel);
            $40c5a3a9dc926bf7$var$setAxis(angleAxis, angleAxisModel);
            $40c5a3a9dc926bf7$var$resizePolar(polar, polarModel, api);
            polarList.push(polar);
            polarModel.coordinateSystem = polar;
            polar.model = polarModel;
        });
        // Inject coordinateSystem to series
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.get('coordinateSystem') === 'polar') {
                var polarModel = seriesModel.getReferringComponents('polar', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
                seriesModel.coordinateSystem = polarModel.coordinateSystem;
            }
        });
        return polarList;
    }
};
var $40c5a3a9dc926bf7$export$2e2bcd8739ae039 = $40c5a3a9dc926bf7$var$polarCreator;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $b4fd964c15f33be5$var$elementList = [
    'axisLine',
    'axisLabel',
    'axisTick',
    'minorTick',
    'splitLine',
    'minorSplitLine',
    'splitArea'
];
function $b4fd964c15f33be5$var$getAxisLineShape(polar, rExtent, angle) {
    rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
    var start = polar.coordToPoint([
        rExtent[0],
        angle
    ]);
    var end = polar.coordToPoint([
        rExtent[1],
        angle
    ]);
    return {
        x1: start[0],
        y1: start[1],
        x2: end[0],
        y2: end[1]
    };
}
function $b4fd964c15f33be5$var$getRadiusIdx(polar) {
    var radiusAxis = polar.getRadiusAxis();
    return radiusAxis.inverse ? 0 : 1;
}
// Remove the last tick which will overlap the first tick
function $b4fd964c15f33be5$var$fixAngleOverlap(list) {
    var firstItem = list[0];
    var lastItem = list[list.length - 1];
    if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) list.pop();
}
var $b4fd964c15f33be5$var$AngleAxisView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(AngleAxisView, _super);
    function AngleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = AngleAxisView.type;
        _this.axisPointerClass = 'PolarAxisPointer';
        return _this;
    }
    AngleAxisView.prototype.render = function(angleAxisModel, ecModel) {
        this.group.removeAll();
        if (!angleAxisModel.get('show')) return;
        var angleAxis = angleAxisModel.axis;
        var polar = angleAxis.polar;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var ticksAngles = angleAxis.getTicksCoords();
        var minorTickAngles = angleAxis.getMinorTicksCoords();
        var labels = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(angleAxis.getViewLabels(), function(labelItem) {
            labelItem = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(labelItem);
            var scale = angleAxis.scale;
            var tickValue = scale.type === 'ordinal' ? scale.getRawOrdinalNumber(labelItem.tickValue) : labelItem.tickValue;
            labelItem.coord = angleAxis.dataToCoord(tickValue);
            return labelItem;
        });
        $b4fd964c15f33be5$var$fixAngleOverlap(labels);
        $b4fd964c15f33be5$var$fixAngleOverlap(ticksAngles);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($b4fd964c15f33be5$var$elementList, function(name) {
            if (angleAxisModel.get([
                name,
                'show'
            ]) && (!angleAxis.scale.isBlank() || name === 'axisLine')) $b4fd964c15f33be5$var$angelAxisElementsBuilders[name](this.group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
        }, this);
    };
    AngleAxisView.type = 'angleAxis';
    return AngleAxisView;
}((0, $9d9acba2c65ca6e6$export$2e2bcd8739ae039));
var $b4fd964c15f33be5$var$angelAxisElementsBuilders = {
    axisLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var lineStyleModel = angleAxisModel.getModel([
            'axisLine',
            'lineStyle'
        ]);
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        // extent id of the axis radius (r0 and r)
        var rId = $b4fd964c15f33be5$var$getRadiusIdx(polar);
        var r0Id = rId ? 0 : 1;
        var shape;
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? 'Circle' : 'Arc';
        if (radiusExtent[r0Id] === 0) shape = new $8eb95236e1aa01e7$exports[shapeType]({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                startAngle: -angleExtent[0] * RADIAN,
                endAngle: -angleExtent[1] * RADIAN,
                clockwise: angleAxis.inverse
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        else shape = new $8eb95236e1aa01e7$exports.Ring({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: radiusExtent[rId],
                r0: radiusExtent[r0Id]
            },
            style: lineStyleModel.getLineStyle(),
            z2: 1,
            silent: true
        });
        shape.style.fill = null;
        group.add(shape);
    },
    axisTick: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var tickModel = angleAxisModel.getModel('axisTick');
        var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
        var radius = radiusExtent[$b4fd964c15f33be5$var$getRadiusIdx(polar)];
        var lines = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(ticksAngles, function(tickAngleItem) {
            return new $8eb95236e1aa01e7$exports.Line({
                shape: $b4fd964c15f33be5$var$getAxisLineShape(polar, [
                    radius,
                    radius + tickLen
                ], tickAngleItem.coord)
            });
        });
        group.add($8eb95236e1aa01e7$exports.mergePath(lines, {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(tickModel.getModel('lineStyle').getLineStyle(), {
                stroke: angleAxisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ])
            })
        }));
    },
    minorTick: function(group, angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var tickModel = angleAxisModel.getModel('axisTick');
        var minorTickModel = angleAxisModel.getModel('minorTick');
        var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
        var radius = radiusExtent[$b4fd964c15f33be5$var$getRadiusIdx(polar)];
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $8eb95236e1aa01e7$exports.Line({
            shape: $b4fd964c15f33be5$var$getAxisLineShape(polar, [
                radius,
                radius + tickLen
            ], minorTickAngles[i][k].coord)
        }));
        group.add($8eb95236e1aa01e7$exports.mergePath(lines, {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(minorTickModel.getModel('lineStyle').getLineStyle(), $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(tickModel.getLineStyle(), {
                stroke: angleAxisModel.get([
                    'axisLine',
                    'lineStyle',
                    'color'
                ])
            }))
        }));
    },
    axisLabel: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
        var rawCategoryData = angleAxisModel.getCategories(true);
        var commonLabelModel = angleAxisModel.getModel('axisLabel');
        var labelMargin = commonLabelModel.get('margin');
        var triggerEvent = angleAxisModel.get('triggerEvent');
        // Use length of ticksAngles because it may remove the last tick to avoid overlapping
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(labels, function(labelItem, idx) {
            var labelModel = commonLabelModel;
            var tickValue = labelItem.tickValue;
            var r = radiusExtent[$b4fd964c15f33be5$var$getRadiusIdx(polar)];
            var p = polar.coordToPoint([
                r + labelMargin,
                labelItem.coord
            ]);
            var cx = polar.cx;
            var cy = polar.cy;
            var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
            var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
            if (rawCategoryData && rawCategoryData[tickValue]) {
                var rawCategoryItem = rawCategoryData[tickValue];
                if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(rawCategoryItem) && rawCategoryItem.textStyle) labelModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(rawCategoryItem.textStyle, commonLabelModel, commonLabelModel.ecModel);
            }
            var textEl = new $8eb95236e1aa01e7$exports.Text({
                silent: (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039).isLabelSilent(angleAxisModel),
                style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(labelModel, {
                    x: p[0],
                    y: p[1],
                    fill: labelModel.getTextColor() || angleAxisModel.get([
                        'axisLine',
                        'lineStyle',
                        'color'
                    ]),
                    text: labelItem.formattedLabel,
                    align: labelTextAlign,
                    verticalAlign: labelTextVerticalAlign
                })
            });
            group.add(textEl);
            // Pack data for mouse event
            if (triggerEvent) {
                var eventData = (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039).makeAxisEventDataBase(angleAxisModel);
                eventData.targetType = 'axisLabel';
                eventData.value = labelItem.rawLabel;
                (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(textEl).eventData = eventData;
            }
        }, this);
    },
    splitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        var splitLineModel = angleAxisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var lineCount = 0;
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksAngles.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $8eb95236e1aa01e7$exports.Line({
                shape: $b4fd964c15f33be5$var$getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($8eb95236e1aa01e7$exports.mergePath(splitLines[i], {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyleModel.getLineStyle()),
            silent: true,
            z: angleAxisModel.get('z')
        }));
    },
    minorSplitLine: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!minorTickAngles.length) return;
        var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var lines = [];
        for(var i = 0; i < minorTickAngles.length; i++)for(var k = 0; k < minorTickAngles[i].length; k++)lines.push(new $8eb95236e1aa01e7$exports.Line({
            shape: $b4fd964c15f33be5$var$getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
        }));
        group.add($8eb95236e1aa01e7$exports.mergePath(lines, {
            style: lineStyleModel.getLineStyle(),
            silent: true,
            z: angleAxisModel.get('z')
        }));
    },
    splitArea: function(group, angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
        if (!ticksAngles.length) return;
        var splitAreaModel = angleAxisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var RADIAN = Math.PI / 180;
        var prevAngle = -ticksAngles[0].coord * RADIAN;
        var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
        var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
        var clockwise = angleAxisModel.get('clockwise');
        for(var i = 1, len = ticksAngles.length; i <= len; i++){
            var coord = i === len ? ticksAngles[0].coord : ticksAngles[i].coord;
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $8eb95236e1aa01e7$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: r0,
                    r: r1,
                    startAngle: prevAngle,
                    endAngle: -coord * RADIAN,
                    clockwise: clockwise
                },
                silent: true
            }));
            prevAngle = -coord * RADIAN;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($8eb95236e1aa01e7$exports.mergePath(splitAreas[i], {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
var $b4fd964c15f33be5$export$2e2bcd8739ae039 = $b4fd964c15f33be5$var$AngleAxisView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $fe6e59fe897817d5$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $fe6e59fe897817d5$var$selfBuilderAttrs = [
    'splitLine',
    'splitArea',
    'minorSplitLine'
];
var $fe6e59fe897817d5$var$RadiusAxisView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RadiusAxisView, _super);
    function RadiusAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = RadiusAxisView.type;
        _this.axisPointerClass = 'PolarAxisPointer';
        return _this;
    }
    RadiusAxisView.prototype.render = function(radiusAxisModel, ecModel) {
        this.group.removeAll();
        if (!radiusAxisModel.get('show')) return;
        var oldAxisGroup = this._axisGroup;
        var newAxisGroup = this._axisGroup = new $8eb95236e1aa01e7$exports.Group();
        this.group.add(newAxisGroup);
        var radiusAxis = radiusAxisModel.axis;
        var polar = radiusAxis.polar;
        var angleAxis = polar.getAngleAxis();
        var ticksCoords = radiusAxis.getTicksCoords();
        var minorTicksCoords = radiusAxis.getMinorTicksCoords();
        var axisAngle = angleAxis.getExtent()[0];
        var radiusExtent = radiusAxis.getExtent();
        var layout = $fe6e59fe897817d5$var$layoutAxis(polar, radiusAxisModel, axisAngle);
        var axisBuilder = new (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039)(radiusAxisModel, layout);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($fe6e59fe897817d5$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        newAxisGroup.add(axisBuilder.getGroup());
        $8eb95236e1aa01e7$exports.groupTransition(oldAxisGroup, newAxisGroup, radiusAxisModel);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($fe6e59fe897817d5$var$selfBuilderAttrs, function(name) {
            if (radiusAxisModel.get([
                name,
                'show'
            ]) && !radiusAxis.scale.isBlank()) $fe6e59fe897817d5$var$axisElementBuilders[name](this.group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
        }, this);
    };
    RadiusAxisView.type = 'radiusAxis';
    return RadiusAxisView;
}((0, $9d9acba2c65ca6e6$export$2e2bcd8739ae039));
var $fe6e59fe897817d5$var$axisElementBuilders = {
    splitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        var splitLineModel = radiusAxisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        var lineCount = 0;
        var angleAxis = polar.getAngleAxis();
        var RADIAN = Math.PI / 180;
        var angleExtent = angleAxis.getExtent();
        var shapeType = Math.abs(angleExtent[1] - angleExtent[0]) === 360 ? 'Circle' : 'Arc';
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var splitLines = [];
        for(var i = 0; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(new $8eb95236e1aa01e7$exports[shapeType]({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    // ensure circle radius >= 0
                    r: Math.max(ticksCoords[i].coord, 0),
                    startAngle: -angleExtent[0] * RADIAN,
                    endAngle: -angleExtent[1] * RADIAN,
                    clockwise: angleAxis.inverse
                }
            }));
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitLines.length; i++)group.add($8eb95236e1aa01e7$exports.mergePath(splitLines[i], {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length],
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    minorSplitLine: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
        if (!minorTicksCoords.length) return;
        var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
        var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
        var lines = [];
        for(var i = 0; i < minorTicksCoords.length; i++)for(var k = 0; k < minorTicksCoords[i].length; k++)lines.push(new $8eb95236e1aa01e7$exports.Circle({
            shape: {
                cx: polar.cx,
                cy: polar.cy,
                r: minorTicksCoords[i][k].coord
            }
        }));
        group.add($8eb95236e1aa01e7$exports.mergePath(lines, {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                fill: null
            }, lineStyleModel.getLineStyle()),
            silent: true
        }));
    },
    splitArea: function(group, radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
        if (!ticksCoords.length) return;
        var splitAreaModel = radiusAxisModel.getModel('splitArea');
        var areaStyleModel = splitAreaModel.getModel('areaStyle');
        var areaColors = areaStyleModel.get('color');
        var lineCount = 0;
        areaColors = areaColors instanceof Array ? areaColors : [
            areaColors
        ];
        var splitAreas = [];
        var prevRadius = ticksCoords[0].coord;
        for(var i = 1; i < ticksCoords.length; i++){
            var colorIndex = lineCount++ % areaColors.length;
            splitAreas[colorIndex] = splitAreas[colorIndex] || [];
            splitAreas[colorIndex].push(new $8eb95236e1aa01e7$exports.Sector({
                shape: {
                    cx: polar.cx,
                    cy: polar.cy,
                    r0: prevRadius,
                    r: ticksCoords[i].coord,
                    startAngle: 0,
                    endAngle: Math.PI * 2
                },
                silent: true
            }));
            prevRadius = ticksCoords[i].coord;
        }
        // Simple optimization
        // Batching the lines if color are the same
        for(var i = 0; i < splitAreas.length; i++)group.add($8eb95236e1aa01e7$exports.mergePath(splitAreas[i], {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                fill: areaColors[i % areaColors.length]
            }, areaStyleModel.getAreaStyle()),
            silent: true
        }));
    }
};
/**
 * @inner
 */ function $fe6e59fe897817d5$var$layoutAxis(polar, radiusAxisModel, axisAngle) {
    return {
        position: [
            polar.cx,
            polar.cy
        ],
        rotation: axisAngle / 180 * Math.PI,
        labelDirection: -1,
        tickDirection: -1,
        nameDirection: 1,
        labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
        // Over splitLine and splitArea
        z2: 1
    };
}
var $fe6e59fe897817d5$export$2e2bcd8739ae039 = $fe6e59fe897817d5$var$RadiusAxisView;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $3e5058fed9ab994d$var$getSeriesStackId(seriesModel) {
    return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
}
function $3e5058fed9ab994d$var$getAxisKey(polar, axis) {
    return axis.dim + polar.model.componentIndex;
}
function $3e5058fed9ab994d$var$barLayoutPolar(seriesType, ecModel, api) {
    var lastStackCoords = {};
    var barWidthAndOffset = $3e5058fed9ab994d$var$calRadialBar($1b239fc9d3a2f8ae$export$3dea766d36a8935f(ecModel.getSeriesByType(seriesType), function(seriesModel) {
        return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
    }));
    ecModel.eachSeriesByType(seriesType, function(seriesModel) {
        // Check series coordinate, do layout for polar only
        if (seriesModel.coordinateSystem.type !== 'polar') return;
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $3e5058fed9ab994d$var$getAxisKey(polar, baseAxis);
        var stackId = $3e5058fed9ab994d$var$getSeriesStackId(seriesModel);
        var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
        var columnOffset = columnLayoutInfo.offset;
        var columnWidth = columnLayoutInfo.width;
        var valueAxis = polar.getOtherAxis(baseAxis);
        var cx = seriesModel.coordinateSystem.cx;
        var cy = seriesModel.coordinateSystem.cy;
        var barMinHeight = seriesModel.get('barMinHeight') || 0;
        var barMinAngle = seriesModel.get('barMinAngle') || 0;
        lastStackCoords[stackId] = lastStackCoords[stackId] || [];
        var valueDim = data.mapDimension(valueAxis.dim);
        var baseDim = data.mapDimension(baseAxis.dim);
        var stacked = (0, $495dfc021fe3a3f7$export$1dedc39359ae35c)(data, valueDim /* , baseDim */ );
        var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
        var valueAxisModel = valueAxis.model;
        var startValue = valueAxisModel.get('startValue');
        var valueAxisStart = valueAxis.dataToCoord(startValue || 0);
        for(var idx = 0, len = data.count(); idx < len; idx++){
            var value = data.get(valueDim, idx);
            var baseValue = data.get(baseDim, idx);
            var sign = value >= 0 ? 'p' : 'n';
            var baseCoord = valueAxisStart;
            // Because of the barMinHeight, we can not use the value in
            // stackResultDimension directly.
            // Only ordinal axis can be stacked.
            if (stacked) {
                if (!lastStackCoords[stackId][baseValue]) lastStackCoords[stackId][baseValue] = {
                    p: valueAxisStart,
                    n: valueAxisStart // Negative stack
                };
                // Should also consider #4243
                baseCoord = lastStackCoords[stackId][baseValue][sign];
            }
            var r0 = void 0;
            var r = void 0;
            var startAngle = void 0;
            var endAngle = void 0;
            // radial sector
            if (valueAxis.dim === 'radius') {
                var radiusSpan = valueAxis.dataToCoord(value) - valueAxisStart;
                var angle = baseAxis.dataToCoord(baseValue);
                if (Math.abs(radiusSpan) < barMinHeight) radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
                r0 = baseCoord;
                r = baseCoord + radiusSpan;
                startAngle = angle - columnOffset;
                endAngle = startAngle - columnWidth;
                stacked && (lastStackCoords[stackId][baseValue][sign] = r);
            } else {
                var angleSpan = valueAxis.dataToCoord(value, clampLayout) - valueAxisStart;
                var radius = baseAxis.dataToCoord(baseValue);
                if (Math.abs(angleSpan) < barMinAngle) angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
                r0 = radius + columnOffset;
                r = r0 + columnWidth;
                startAngle = baseCoord;
                endAngle = baseCoord + angleSpan;
                // if the previous stack is at the end of the ring,
                // add a round to differentiate it from origin
                // let extent = angleAxis.getExtent();
                // let stackCoord = angle;
                // if (stackCoord === extent[0] && value > 0) {
                //     stackCoord = extent[1];
                // }
                // else if (stackCoord === extent[1] && value < 0) {
                //     stackCoord = extent[0];
                // }
                stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
            }
            data.setItemLayout(idx, {
                cx: cx,
                cy: cy,
                r0: r0,
                r: r,
                // Consider that positive angle is anti-clockwise,
                // while positive radian of sector is clockwise
                startAngle: -startAngle * Math.PI / 180,
                endAngle: -endAngle * Math.PI / 180,
                /**
         * Keep the same logic with bar in catesion: use end value to
         * control direction. Notice that if clockwise is true (by
         * default), the sector will always draw clockwisely, no matter
         * whether endAngle is greater or less than startAngle.
         */ clockwise: startAngle >= endAngle
            });
        }
    });
}
/**
 * Calculate bar width and offset for radial bar charts
 */ function $3e5058fed9ab994d$var$calRadialBar(barSeries) {
    // Columns info on each category axis. Key is polar name
    var columnsMap = {};
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(barSeries, function(seriesModel, idx) {
        var data = seriesModel.getData();
        var polar = seriesModel.coordinateSystem;
        var baseAxis = polar.getBaseAxis();
        var axisKey = $3e5058fed9ab994d$var$getAxisKey(polar, baseAxis);
        var axisExtent = baseAxis.getExtent();
        var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
        var columnsOnAxis = columnsMap[axisKey] || {
            bandWidth: bandWidth,
            remainedWidth: bandWidth,
            autoWidthCount: 0,
            categoryGap: '20%',
            gap: '30%',
            stacks: {}
        };
        var stacks = columnsOnAxis.stacks;
        columnsMap[axisKey] = columnsOnAxis;
        var stackId = $3e5058fed9ab994d$var$getSeriesStackId(seriesModel);
        if (!stacks[stackId]) columnsOnAxis.autoWidthCount++;
        stacks[stackId] = stacks[stackId] || {
            width: 0,
            maxWidth: 0
        };
        var barWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('barWidth'), bandWidth);
        var barMaxWidth = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(seriesModel.get('barMaxWidth'), bandWidth);
        var barGap = seriesModel.get('barGap');
        var barCategoryGap = seriesModel.get('barCategoryGap');
        if (barWidth && !stacks[stackId].width) {
            barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
            stacks[stackId].width = barWidth;
            columnsOnAxis.remainedWidth -= barWidth;
        }
        barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
        barGap != null && (columnsOnAxis.gap = barGap);
        barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
    });
    var result = {};
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(columnsMap, function(columnsOnAxis, coordSysName) {
        result[coordSysName] = {};
        var stacks = columnsOnAxis.stacks;
        var bandWidth = columnsOnAxis.bandWidth;
        var categoryGap = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(columnsOnAxis.categoryGap, bandWidth);
        var barGapPercent = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(columnsOnAxis.gap, 1);
        var remainedWidth = columnsOnAxis.remainedWidth;
        var autoWidthCount = columnsOnAxis.autoWidthCount;
        var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        // Find if any auto calculated bar exceeded maxBarWidth
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(stacks, function(column, stack) {
            var maxWidth = column.maxWidth;
            if (maxWidth && maxWidth < autoWidth) {
                maxWidth = Math.min(maxWidth, remainedWidth);
                if (column.width) maxWidth = Math.min(maxWidth, column.width);
                remainedWidth -= maxWidth;
                column.width = maxWidth;
                autoWidthCount--;
            }
        });
        // Recalculate width again
        autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
        autoWidth = Math.max(autoWidth, 0);
        var widthSum = 0;
        var lastColumn;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(stacks, function(column, idx) {
            if (!column.width) column.width = autoWidth;
            lastColumn = column;
            widthSum += column.width * (1 + barGapPercent);
        });
        if (lastColumn) widthSum -= lastColumn.width * barGapPercent;
        var offset = -widthSum / 2;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(stacks, function(column, stackId) {
            result[coordSysName][stackId] = result[coordSysName][stackId] || {
                offset: offset,
                width: column.width
            };
            offset += column.width * (1 + barGapPercent);
        });
    });
    return result;
}
var $3e5058fed9ab994d$export$2e2bcd8739ae039 = $3e5058fed9ab994d$var$barLayoutPolar;


var $e1106d6cbdf816de$var$angleAxisExtraOption = {
    startAngle: 90,
    clockwise: true,
    splitNumber: 12,
    axisLabel: {
        rotate: 0
    }
};
var $e1106d6cbdf816de$var$radiusAxisExtraOption = {
    splitNumber: 5
};
var $e1106d6cbdf816de$var$PolarView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PolarView, _super);
    function PolarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PolarView.type;
        return _this;
    }
    PolarView.type = 'polar';
    return PolarView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $e1106d6cbdf816de$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $d1d2b9dcfa505105$export$4b3e715f166fdd78));
    (0, $9d9acba2c65ca6e6$export$2e2bcd8739ae039).registerAxisPointerClass('PolarAxisPointer', (0, $056fedf6e253b5ca$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('polar', (0, $40c5a3a9dc926bf7$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $dda15ae8c6f5dd65$export$2e2bcd8739ae039));
    registers.registerComponentView($e1106d6cbdf816de$var$PolarView);
    // Model and view for angleAxis and radiusAxis
    (0, $74540b73e60dbb04$export$2e2bcd8739ae039)(registers, 'angle', (0, $a75bde112118309d$export$34735c2c701428ca), $e1106d6cbdf816de$var$angleAxisExtraOption);
    (0, $74540b73e60dbb04$export$2e2bcd8739ae039)(registers, 'radius', (0, $a75bde112118309d$export$de202388c212a23b), $e1106d6cbdf816de$var$radiusAxisExtraOption);
    registers.registerComponentView((0, $b4fd964c15f33be5$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $fe6e59fe897817d5$export$2e2bcd8739ae039));
    registers.registerLayout((0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)((0, $3e5058fed9ab994d$export$2e2bcd8739ae039), 'bar'));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $2beabe1e32e35096$export$b3219800bda33a1f(axisModel, opt) {
    opt = opt || {};
    var single = axisModel.coordinateSystem;
    var axis = axisModel.axis;
    var layout = {};
    var axisPosition = axis.position;
    var orient = axis.orient;
    var rect = single.getRect();
    var rectBound = [
        rect.x,
        rect.x + rect.width,
        rect.y,
        rect.y + rect.height
    ];
    var positionMap = {
        horizontal: {
            top: rectBound[2],
            bottom: rectBound[3]
        },
        vertical: {
            left: rectBound[0],
            right: rectBound[1]
        }
    };
    layout.position = [
        orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0],
        orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]
    ];
    var r = {
        horizontal: 0,
        vertical: 1
    };
    layout.rotation = Math.PI / 2 * r[orient];
    var directionMap = {
        top: -1,
        bottom: 1,
        right: 1,
        left: -1
    };
    layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
    if (axisModel.get([
        'axisTick',
        'inside'
    ])) layout.tickDirection = -layout.tickDirection;
    if ($1b239fc9d3a2f8ae$export$8a4d17b6e8486e66(opt.labelInside, axisModel.get([
        'axisLabel',
        'inside'
    ]))) layout.labelDirection = -layout.labelDirection;
    var labelRotation = opt.rotate;
    labelRotation == null && (labelRotation = axisModel.get([
        'axisLabel',
        'rotate'
    ]));
    layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
    layout.z2 = 1;
    return layout;
}




var $5b9cc991c6ffeb01$var$axisBuilderAttrs = [
    'axisLine',
    'axisTickLabel',
    'axisName'
];
var $5b9cc991c6ffeb01$var$selfBuilderAttrs = [
    'splitArea',
    'splitLine'
];
var $5b9cc991c6ffeb01$var$SingleAxisView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SingleAxisView, _super);
    function SingleAxisView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisView.type;
        _this.axisPointerClass = 'SingleAxisPointer';
        return _this;
    }
    SingleAxisView.prototype.render = function(axisModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        var oldAxisGroup = this._axisGroup;
        this._axisGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        var layout = $2beabe1e32e35096$export$b3219800bda33a1f(axisModel);
        var axisBuilder = new (0, $7e7c5ff91aafa083$export$2e2bcd8739ae039)(axisModel, layout);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($5b9cc991c6ffeb01$var$axisBuilderAttrs, axisBuilder.add, axisBuilder);
        group.add(this._axisGroup);
        group.add(axisBuilder.getGroup());
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($5b9cc991c6ffeb01$var$selfBuilderAttrs, function(name) {
            if (axisModel.get([
                name,
                'show'
            ])) $5b9cc991c6ffeb01$var$axisElementBuilders[name](this, this.group, this._axisGroup, axisModel);
        }, this);
        $8eb95236e1aa01e7$export$64fcab7860c216ae(oldAxisGroup, this._axisGroup, axisModel);
        _super.prototype.render.call(this, axisModel, ecModel, api, payload);
    };
    SingleAxisView.prototype.remove = function() {
        (0, $fe011900558a70d8$export$48ebf2d6ce8ad076)(this);
    };
    SingleAxisView.type = 'singleAxis';
    return SingleAxisView;
}((0, $9d9acba2c65ca6e6$export$2e2bcd8739ae039));
var $5b9cc991c6ffeb01$var$axisElementBuilders = {
    splitLine: function(axisView, group, axisGroup, axisModel) {
        var axis = axisModel.axis;
        if (axis.scale.isBlank()) return;
        var splitLineModel = axisModel.getModel('splitLine');
        var lineStyleModel = splitLineModel.getModel('lineStyle');
        var lineColors = lineStyleModel.get('color');
        lineColors = lineColors instanceof Array ? lineColors : [
            lineColors
        ];
        var lineWidth = lineStyleModel.get('width');
        var gridRect = axisModel.coordinateSystem.getRect();
        var isHorizontal = axis.isHorizontal();
        var splitLines = [];
        var lineCount = 0;
        var ticksCoords = axis.getTicksCoords({
            tickModel: splitLineModel
        });
        var p1 = [];
        var p2 = [];
        for(var i = 0; i < ticksCoords.length; ++i){
            var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
            if (isHorizontal) {
                p1[0] = tickCoord;
                p1[1] = gridRect.y;
                p2[0] = tickCoord;
                p2[1] = gridRect.y + gridRect.height;
            } else {
                p1[0] = gridRect.x;
                p1[1] = tickCoord;
                p2[0] = gridRect.x + gridRect.width;
                p2[1] = tickCoord;
            }
            var line = new $8324e8379a5583a5$export$2e2bcd8739ae039({
                shape: {
                    x1: p1[0],
                    y1: p1[1],
                    x2: p2[0],
                    y2: p2[1]
                },
                silent: true
            });
            $8eb95236e1aa01e7$export$8b4b620d7f4aad1b(line.shape, lineWidth);
            var colorIndex = lineCount++ % lineColors.length;
            splitLines[colorIndex] = splitLines[colorIndex] || [];
            splitLines[colorIndex].push(line);
        }
        var lineStyle = lineStyleModel.getLineStyle([
            'color'
        ]);
        for(var i = 0; i < splitLines.length; ++i)group.add($8eb95236e1aa01e7$export$7b1dd269fbc4e903(splitLines[i], {
            style: $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                stroke: lineColors[i % lineColors.length]
            }, lineStyle),
            silent: true
        }));
    },
    splitArea: function(axisView, group, axisGroup, axisModel) {
        (0, $fe011900558a70d8$export$c80b7ef1527ec8c9)(axisView, axisGroup, axisModel, axisModel);
    }
};
var $5b9cc991c6ffeb01$export$2e2bcd8739ae039 = $5b9cc991c6ffeb01$var$SingleAxisView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $9dfa33b46bb15c11$var$SingleAxisModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SingleAxisModel, _super);
    function SingleAxisModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleAxisModel.type;
        return _this;
    }
    SingleAxisModel.prototype.getCoordSysModel = function() {
        return this;
    };
    SingleAxisModel.type = 'singleAxis';
    SingleAxisModel.layoutMode = 'box';
    SingleAxisModel.defaultOption = {
        left: '5%',
        top: '5%',
        right: '5%',
        bottom: '5%',
        type: 'value',
        position: 'bottom',
        orient: 'horizontal',
        axisLine: {
            show: true,
            lineStyle: {
                width: 1,
                type: 'solid'
            }
        },
        // Single coordinate system and single axis is the,
        // which is used as the parent tooltip model.
        // same model, so we set default tooltip show as true.
        tooltip: {
            show: true
        },
        axisTick: {
            show: true,
            length: 6,
            lineStyle: {
                width: 1
            }
        },
        axisLabel: {
            show: true,
            interval: 'auto'
        },
        splitLine: {
            show: true,
            lineStyle: {
                type: 'dashed',
                opacity: 0.2
            }
        }
    };
    return SingleAxisModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($9dfa33b46bb15c11$var$SingleAxisModel, (0, $12a09fd102c04f88$export$5c54b224726edb5a).prototype);
var $9dfa33b46bb15c11$export$2e2bcd8739ae039 = $9dfa33b46bb15c11$var$SingleAxisModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinate system creator.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * Single coordinates system.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ef766a6ab36b230d$var$SingleAxis = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SingleAxis, _super);
    function SingleAxis(dim, scale, coordExtent, axisType, position) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        _this.position = position || 'bottom';
        return _this;
    }
    /**
   * Judge the orient of the axis.
   */ SingleAxis.prototype.isHorizontal = function() {
        var position = this.position;
        return position === 'top' || position === 'bottom';
    };
    SingleAxis.prototype.pointToData = function(point, clamp) {
        return this.coordinateSystem.pointToData(point)[0];
    };
    return SingleAxis;
}((0, $099c976b90502319$export$2e2bcd8739ae039));
var $ef766a6ab36b230d$export$2e2bcd8739ae039 = $ef766a6ab36b230d$var$SingleAxis;





var $6988b303fb16b051$export$28486687f659fb1a = [
    'single'
];
/**
 * Create a single coordinates system.
 */ var $6988b303fb16b051$var$Single = /** @class */ function() {
    function Single(axisModel, ecModel, api) {
        this.type = 'single';
        this.dimension = 'single';
        /**
     * Add it just for draw tooltip.
     */ this.dimensions = $6988b303fb16b051$export$28486687f659fb1a;
        this.axisPointerEnabled = true;
        this.model = axisModel;
        this._init(axisModel, ecModel, api);
    }
    /**
   * Initialize single coordinate system.
   */ Single.prototype._init = function(axisModel, ecModel, api) {
        var dim = this.dimension;
        var axis = new (0, $ef766a6ab36b230d$export$2e2bcd8739ae039)(dim, $5435624263a719a6$export$8941c4cacdc8f5a5(axisModel), [
            0,
            0
        ], axisModel.get('type'), axisModel.get('position'));
        var isCategory = axis.type === 'category';
        axis.onBand = isCategory && axisModel.get('boundaryGap');
        axis.inverse = axisModel.get('inverse');
        axis.orient = axisModel.get('orient');
        axisModel.axis = axis;
        axis.model = axisModel;
        axis.coordinateSystem = this;
        this._axis = axis;
    };
    /**
   * Update axis scale after data processed
   */ Single.prototype.update = function(ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            if (seriesModel.coordinateSystem === this) {
                var data_1 = seriesModel.getData();
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(data_1.mapDimensionsAll(this.dimension), function(dim) {
                    this._axis.scale.unionExtentFromData(data_1, dim);
                }, this);
                $5435624263a719a6$export$51f3e70a54405d5a(this._axis.scale, this._axis.model);
            }
        }, this);
    };
    /**
   * Resize the single coordinate system.
   */ Single.prototype.resize = function(axisModel, api) {
        this._rect = (0, $501dc28f6c4d24ac$export$4517a5ca639a7293)({
            left: axisModel.get('left'),
            top: axisModel.get('top'),
            right: axisModel.get('right'),
            bottom: axisModel.get('bottom'),
            width: axisModel.get('width'),
            height: axisModel.get('height')
        }, {
            width: api.getWidth(),
            height: api.getHeight()
        });
        this._adjustAxis();
    };
    Single.prototype.getRect = function() {
        return this._rect;
    };
    Single.prototype._adjustAxis = function() {
        var rect = this._rect;
        var axis = this._axis;
        var isHorizontal = axis.isHorizontal();
        var extent = isHorizontal ? [
            0,
            rect.width
        ] : [
            0,
            rect.height
        ];
        var idx = axis.inverse ? 1 : 0;
        axis.setExtent(extent[idx], extent[1 - idx]);
        this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
    };
    Single.prototype._updateAxisTransform = function(axis, coordBase) {
        var axisExtent = axis.getExtent();
        var extentSum = axisExtent[0] + axisExtent[1];
        var isHorizontal = axis.isHorizontal();
        axis.toGlobalCoord = isHorizontal ? function(coord) {
            return coord + coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
        axis.toLocalCoord = isHorizontal ? function(coord) {
            return coord - coordBase;
        } : function(coord) {
            return extentSum - coord + coordBase;
        };
    };
    /**
   * Get axis.
   */ Single.prototype.getAxis = function() {
        return this._axis;
    };
    /**
   * Get axis, add it just for draw tooltip.
   */ Single.prototype.getBaseAxis = function() {
        return this._axis;
    };
    Single.prototype.getAxes = function() {
        return [
            this._axis
        ];
    };
    Single.prototype.getTooltipAxes = function() {
        return {
            baseAxes: [
                this.getAxis()
            ],
            // Empty otherAxes
            otherAxes: []
        };
    };
    /**
   * If contain point.
   */ Single.prototype.containPoint = function(point) {
        var rect = this.getRect();
        var axis = this.getAxis();
        var orient = axis.orient;
        if (orient === 'horizontal') return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
        else return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
    };
    Single.prototype.pointToData = function(point) {
        var axis = this.getAxis();
        return [
            axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))
        ];
    };
    /**
   * Convert the series data to concrete point.
   * Can be [val] | val
   */ Single.prototype.dataToPoint = function(val) {
        var axis = this.getAxis();
        var rect = this.getRect();
        var pt = [];
        var idx = axis.orient === 'horizontal' ? 0 : 1;
        if (val instanceof Array) val = val[0];
        pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
        pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
        return pt;
    };
    Single.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $6988b303fb16b051$var$getCoordSys(finder);
        return coordSys === this ? this.dataToPoint(value) : null;
    };
    Single.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $6988b303fb16b051$var$getCoordSys(finder);
        return coordSys === this ? this.pointToData(pixel) : null;
    };
    return Single;
}();
function $6988b303fb16b051$var$getCoordSys(finder) {
    var seriesModel = finder.seriesModel;
    var singleModel = finder.singleAxisModel;
    return singleModel && singleModel.coordinateSystem || seriesModel && seriesModel.coordinateSystem;
}
var $6988b303fb16b051$export$2e2bcd8739ae039 = $6988b303fb16b051$var$Single;



/**
 * Create single coordinate system and inject it into seriesModel.
 */ function $25389db0d776edf1$var$create(ecModel, api) {
    var singles = [];
    ecModel.eachComponent('singleAxis', function(axisModel, idx) {
        var single = new (0, $6988b303fb16b051$export$2e2bcd8739ae039)(axisModel, ecModel, api);
        single.name = 'single_' + idx;
        single.resize(axisModel, api);
        axisModel.coordinateSystem = single;
        singles.push(single);
    });
    ecModel.eachSeries(function(seriesModel) {
        if (seriesModel.get('coordinateSystem') === 'singleAxis') {
            var singleAxisModel = seriesModel.getReferringComponents('singleAxis', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
            seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
        }
    });
    return singles;
}
var $25389db0d776edf1$var$singleCreator = {
    create: $25389db0d776edf1$var$create,
    dimensions: (0, $6988b303fb16b051$export$28486687f659fb1a)
};
var $25389db0d776edf1$export$2e2bcd8739ae039 = $25389db0d776edf1$var$singleCreator;




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $4f2b92fcf08da6b7$var$XY = [
    'x',
    'y'
];
var $4f2b92fcf08da6b7$var$WH = [
    'width',
    'height'
];
var $4f2b92fcf08da6b7$var$SingleAxisPointer = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SingleAxisPointer, _super);
    function SingleAxisPointer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
   * @override
   */ SingleAxisPointer.prototype.makeElOption = function(elOption, value, axisModel, axisPointerModel, api) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var otherExtent = $4f2b92fcf08da6b7$var$getGlobalExtent(coordSys, 1 - $4f2b92fcf08da6b7$var$getPointDimIndex(axis));
        var pixelValue = coordSys.dataToPoint(value)[0];
        var axisPointerType = axisPointerModel.get('type');
        if (axisPointerType && axisPointerType !== 'none') {
            var elStyle = $4c9900f2e2ca23a4$export$b7fe459c7cc50060(axisPointerModel);
            var pointerOption = $4f2b92fcf08da6b7$var$pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
            pointerOption.style = elStyle;
            elOption.graphicKey = pointerOption.type;
            elOption.pointer = pointerOption;
        }
        var layoutInfo = $2beabe1e32e35096$export$b3219800bda33a1f(axisModel);
        $4c9900f2e2ca23a4$export$fd3eb3812211a173(// @ts-ignore
        value, elOption, layoutInfo, axisModel, axisPointerModel, api);
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.getHandleTransform = function(value, axisModel, axisPointerModel) {
        var layoutInfo = $2beabe1e32e35096$export$b3219800bda33a1f(axisModel, {
            labelInside: false
        });
        // @ts-ignore
        layoutInfo.labelMargin = axisPointerModel.get([
            'handle',
            'margin'
        ]);
        var position = $4c9900f2e2ca23a4$export$4bb66440324c3a3d(axisModel.axis, value, layoutInfo);
        return {
            x: position[0],
            y: position[1],
            rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
        };
    };
    /**
   * @override
   */ SingleAxisPointer.prototype.updateHandleTransform = function(transform, delta, axisModel, axisPointerModel) {
        var axis = axisModel.axis;
        var coordSys = axis.coordinateSystem;
        var dimIndex = $4f2b92fcf08da6b7$var$getPointDimIndex(axis);
        var axisExtent = $4f2b92fcf08da6b7$var$getGlobalExtent(coordSys, dimIndex);
        var currPosition = [
            transform.x,
            transform.y
        ];
        currPosition[dimIndex] += delta[dimIndex];
        currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
        currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
        var otherExtent = $4f2b92fcf08da6b7$var$getGlobalExtent(coordSys, 1 - dimIndex);
        var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
        var cursorPoint = [
            cursorOtherValue,
            cursorOtherValue
        ];
        cursorPoint[dimIndex] = currPosition[dimIndex];
        return {
            x: currPosition[0],
            y: currPosition[1],
            rotation: transform.rotation,
            cursorPoint: cursorPoint,
            tooltipOption: {
                verticalAlign: 'middle'
            }
        };
    };
    return SingleAxisPointer;
}((0, $26b546213ed8e9de$export$2e2bcd8739ae039));
var $4f2b92fcf08da6b7$var$pointerShapeBuilder = {
    line: function(axis, pixelValue, otherExtent) {
        var targetShape = $4c9900f2e2ca23a4$export$885fa0ad5a826207([
            pixelValue,
            otherExtent[0]
        ], [
            pixelValue,
            otherExtent[1]
        ], $4f2b92fcf08da6b7$var$getPointDimIndex(axis));
        return {
            type: 'Line',
            subPixelOptimize: true,
            shape: targetShape
        };
    },
    shadow: function(axis, pixelValue, otherExtent) {
        var bandWidth = axis.getBandWidth();
        var span = otherExtent[1] - otherExtent[0];
        return {
            type: 'Rect',
            shape: $4c9900f2e2ca23a4$export$a8b35248bcc02756([
                pixelValue - bandWidth / 2,
                otherExtent[0]
            ], [
                bandWidth,
                span
            ], $4f2b92fcf08da6b7$var$getPointDimIndex(axis))
        };
    }
};
function $4f2b92fcf08da6b7$var$getPointDimIndex(axis) {
    return axis.isHorizontal() ? 0 : 1;
}
function $4f2b92fcf08da6b7$var$getGlobalExtent(coordSys, dimIndex) {
    var rect = coordSys.getRect();
    return [
        rect[$4f2b92fcf08da6b7$var$XY[dimIndex]],
        rect[$4f2b92fcf08da6b7$var$XY[dimIndex]] + rect[$4f2b92fcf08da6b7$var$WH[dimIndex]]
    ];
}
var $4f2b92fcf08da6b7$export$2e2bcd8739ae039 = $4f2b92fcf08da6b7$var$SingleAxisPointer;


var $ce032a9d547c6354$var$SingleView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SingleView, _super);
    function SingleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SingleView.type;
        return _this;
    }
    SingleView.type = 'single';
    return SingleView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $ce032a9d547c6354$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $d1d2b9dcfa505105$export$4b3e715f166fdd78));
    (0, $9d9acba2c65ca6e6$export$2e2bcd8739ae039).registerAxisPointerClass('SingleAxisPointer', (0, $4f2b92fcf08da6b7$export$2e2bcd8739ae039));
    registers.registerComponentView($ce032a9d547c6354$var$SingleView);
    // Axis
    registers.registerComponentView((0, $5b9cc991c6ffeb01$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $9dfa33b46bb15c11$export$2e2bcd8739ae039));
    (0, $74540b73e60dbb04$export$2e2bcd8739ae039)(registers, 'single', (0, $9dfa33b46bb15c11$export$2e2bcd8739ae039), (0, $9dfa33b46bb15c11$export$2e2bcd8739ae039).defaultOption);
    registers.registerCoordinateSystem('single', (0, $25389db0d776edf1$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $5b99c99b6ec6ef6c$var$CalendarModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CalendarModel, _super);
    function CalendarModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarModel.type;
        return _this;
    }
    /**
   * @override
   */ CalendarModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $501dc28f6c4d24ac$export$4b0d20af19c9875e)(option);
        _super.prototype.init.apply(this, arguments);
        $5b99c99b6ec6ef6c$var$mergeAndNormalizeLayoutParams(option, inputPositionParams);
    };
    /**
   * @override
   */ CalendarModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        $5b99c99b6ec6ef6c$var$mergeAndNormalizeLayoutParams(this.option, option);
    };
    CalendarModel.prototype.getCellSize = function() {
        // Has been normalized
        return this.option.cellSize;
    };
    CalendarModel.type = 'calendar';
    CalendarModel.defaultOption = {
        // zlevel: 0,
        z: 2,
        left: 80,
        top: 60,
        cellSize: 20,
        // horizontal vertical
        orient: 'horizontal',
        // month separate line style
        splitLine: {
            show: true,
            lineStyle: {
                color: '#000',
                width: 1,
                type: 'solid'
            }
        },
        // rect style  temporarily unused emphasis
        itemStyle: {
            color: '#fff',
            borderWidth: 1,
            borderColor: '#ccc'
        },
        // week text style
        dayLabel: {
            show: true,
            firstDay: 0,
            // start end
            position: 'start',
            margin: '50%',
            color: '#000'
        },
        // month text style
        monthLabel: {
            show: true,
            // start end
            position: 'start',
            margin: 5,
            // center or left
            align: 'center',
            formatter: null,
            color: '#000'
        },
        // year text style
        yearLabel: {
            show: true,
            // top bottom left right
            position: null,
            margin: 30,
            formatter: null,
            color: '#ccc',
            fontFamily: 'sans-serif',
            fontWeight: 'bolder',
            fontSize: 20
        }
    };
    return CalendarModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
function $5b99c99b6ec6ef6c$var$mergeAndNormalizeLayoutParams(target, raw) {
    // Normalize cellSize
    var cellSize = target.cellSize;
    var cellSizeArr;
    if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(cellSize)) cellSizeArr = target.cellSize = [
        cellSize,
        cellSize
    ];
    else cellSizeArr = cellSize;
    if (cellSizeArr.length === 1) cellSizeArr[1] = cellSizeArr[0];
    var ignoreSize = $1b239fc9d3a2f8ae$export$871de8747c9eaa88([
        0,
        1
    ], function(hvIdx) {
        // If user have set `width` or both `left` and `right`, cellSizeArr
        // will be automatically set to 'auto', otherwise the default
        // setting of cellSizeArr will make `width` setting not work.
        if ((0, $501dc28f6c4d24ac$export$7ede609e8ebc9650)(raw, hvIdx)) cellSizeArr[hvIdx] = 'auto';
        return cellSizeArr[hvIdx] != null && cellSizeArr[hvIdx] !== 'auto';
    });
    (0, $501dc28f6c4d24ac$export$1754cb91f16ca028)(target, raw, {
        type: 'box',
        ignoreSize: ignoreSize
    });
}
var $5b99c99b6ec6ef6c$export$2e2bcd8739ae039 = $5b99c99b6ec6ef6c$var$CalendarModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $cf6c23e66afb44dc$var$CalendarView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(CalendarView, _super);
    function CalendarView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = CalendarView.type;
        return _this;
    }
    CalendarView.prototype.render = function(calendarModel, ecModel, api) {
        var group = this.group;
        group.removeAll();
        var coordSys = calendarModel.coordinateSystem;
        // range info
        var rangeData = coordSys.getRangeInfo();
        var orient = coordSys.getOrient();
        // locale
        var localeModel = ecModel.getLocaleModel();
        this._renderDayRect(calendarModel, rangeData, group);
        // _renderLines must be called prior to following function
        this._renderLines(calendarModel, rangeData, orient, group);
        this._renderYearText(calendarModel, rangeData, orient, group);
        this._renderMonthText(calendarModel, localeModel, orient, group);
        this._renderWeekText(calendarModel, localeModel, rangeData, orient, group);
    };
    // render day rect
    CalendarView.prototype._renderDayRect = function(calendarModel, rangeData, group) {
        var coordSys = calendarModel.coordinateSystem;
        var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
        var sw = coordSys.getCellWidth();
        var sh = coordSys.getCellHeight();
        for(var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time){
            var point = coordSys.dataToRect([
                i
            ], false).tl;
            // every rect
            var rect = new $37476269d425e3f6$export$2e2bcd8739ae039({
                shape: {
                    x: point[0],
                    y: point[1],
                    width: sw,
                    height: sh
                },
                cursor: 'default',
                style: itemRectStyleModel
            });
            group.add(rect);
        }
    };
    // render separate line
    CalendarView.prototype._renderLines = function(calendarModel, rangeData, orient, group) {
        var self = this;
        var coordSys = calendarModel.coordinateSystem;
        var lineStyleModel = calendarModel.getModel([
            'splitLine',
            'lineStyle'
        ]).getLineStyle();
        var show = calendarModel.get([
            'splitLine',
            'show'
        ]);
        var lineWidth = lineStyleModel.lineWidth;
        this._tlpoints = [];
        this._blpoints = [];
        this._firstDayOfMonth = [];
        this._firstDayPoints = [];
        var firstDay = rangeData.start;
        for(var i = 0; firstDay.time <= rangeData.end.time; i++){
            addPoints(firstDay.formatedDate);
            if (i === 0) firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
            var date = firstDay.date;
            date.setMonth(date.getMonth() + 1);
            firstDay = coordSys.getDateInfo(date);
        }
        addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
        function addPoints(date) {
            self._firstDayOfMonth.push(coordSys.getDateInfo(date));
            self._firstDayPoints.push(coordSys.dataToRect([
                date
            ], false).tl);
            var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
            self._tlpoints.push(points[0]);
            self._blpoints.push(points[points.length - 1]);
            show && self._drawSplitline(points, lineStyleModel, group);
        }
        // render top/left line
        show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group);
        // render bottom/right line
        show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
    };
    // get points at both ends
    CalendarView.prototype._getEdgesPoints = function(points, lineWidth, orient) {
        var rs = [
            points[0].slice(),
            points[points.length - 1].slice()
        ];
        var idx = orient === 'horizontal' ? 0 : 1;
        // both ends of the line are extend half lineWidth
        rs[0][idx] = rs[0][idx] - lineWidth / 2;
        rs[1][idx] = rs[1][idx] + lineWidth / 2;
        return rs;
    };
    // render split line
    CalendarView.prototype._drawSplitline = function(points, lineStyle, group) {
        var poyline = new $f7f6523750aec7c8$export$2e2bcd8739ae039({
            z2: 20,
            shape: {
                points: points
            },
            style: lineStyle
        });
        group.add(poyline);
    };
    // render month line of one week points
    CalendarView.prototype._getLinePointsOfOneWeek = function(calendarModel, date, orient) {
        var coordSys = calendarModel.coordinateSystem;
        var parsedDate = coordSys.getDateInfo(date);
        var points = [];
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(parsedDate.time, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false);
            points[2 * tmpD.day] = point.tl;
            points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
        }
        return points;
    };
    CalendarView.prototype._formatterLabel = function(formatter, params) {
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(formatter) && formatter) return (0, $ff2fba995230f3c9$export$2fa08233ee42f8e1)(formatter, params);
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(formatter)) return formatter(params);
        return params.nameMap;
    };
    CalendarView.prototype._yearTextPositionControl = function(textEl, point, orient, position, margin) {
        var x = point[0];
        var y = point[1];
        var aligns = [
            'center',
            'bottom'
        ];
        if (position === 'bottom') {
            y += margin;
            aligns = [
                'center',
                'top'
            ];
        } else if (position === 'left') x -= margin;
        else if (position === 'right') {
            x += margin;
            aligns = [
                'center',
                'top'
            ];
        } else // top
        y -= margin;
        var rotate = 0;
        if (position === 'left' || position === 'right') rotate = Math.PI / 2;
        return {
            rotation: rotate,
            x: x,
            y: y,
            style: {
                align: aligns[0],
                verticalAlign: aligns[1]
            }
        };
    };
    // render year
    CalendarView.prototype._renderYearText = function(calendarModel, rangeData, orient, group) {
        var yearLabel = calendarModel.getModel('yearLabel');
        if (!yearLabel.get('show')) return;
        var margin = yearLabel.get('margin');
        var pos = yearLabel.get('position');
        if (!pos) pos = orient !== 'horizontal' ? 'top' : 'left';
        var points = [
            this._tlpoints[this._tlpoints.length - 1],
            this._blpoints[0]
        ];
        var xc = (points[0][0] + points[1][0]) / 2;
        var yc = (points[0][1] + points[1][1]) / 2;
        var idx = orient === 'horizontal' ? 0 : 1;
        var posPoints = {
            top: [
                xc,
                points[idx][1]
            ],
            bottom: [
                xc,
                points[1 - idx][1]
            ],
            left: [
                points[1 - idx][0],
                yc
            ],
            right: [
                points[idx][0],
                yc
            ]
        };
        var name = rangeData.start.y;
        if (+rangeData.end.y > +rangeData.start.y) name = name + '-' + rangeData.end.y;
        var formatter = yearLabel.get('formatter');
        var params = {
            start: rangeData.start.y,
            end: rangeData.end.y,
            nameMap: name
        };
        var content = this._formatterLabel(formatter, params);
        var yearText = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            z2: 30,
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(yearLabel, {
                text: content
            }),
            silent: yearLabel.get('silent')
        });
        yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
        group.add(yearText);
    };
    CalendarView.prototype._monthTextPositionControl = function(point, isCenter, orient, position, margin) {
        var align = 'left';
        var vAlign = 'top';
        var x = point[0];
        var y = point[1];
        if (orient === 'horizontal') {
            y = y + margin;
            if (isCenter) align = 'center';
            if (position === 'start') vAlign = 'bottom';
        } else {
            x = x + margin;
            if (isCenter) vAlign = 'middle';
            if (position === 'start') align = 'right';
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render month and year text
    CalendarView.prototype._renderMonthText = function(calendarModel, localeModel, orient, group) {
        var monthLabel = calendarModel.getModel('monthLabel');
        if (!monthLabel.get('show')) return;
        var nameMap = monthLabel.get('nameMap');
        var margin = monthLabel.get('margin');
        var pos = monthLabel.get('position');
        var align = monthLabel.get('align');
        var termPoints = [
            this._tlpoints,
            this._blpoints
        ];
        if (!nameMap || (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $db1a0fc42a360ea2$export$37cc638e0e11865f)(nameMap) || localeModel;
            // PENDING
            // for ZH locale, original form is `一月` but current form is `1月`
            nameMap = localeModel.get([
                'time',
                'monthAbbr'
            ]) || [];
        }
        var idx = pos === 'start' ? 0 : 1;
        var axis = orient === 'horizontal' ? 0 : 1;
        margin = pos === 'start' ? -margin : margin;
        var isCenter = align === 'center';
        var labelSilent = monthLabel.get('silent');
        for(var i = 0; i < termPoints[idx].length - 1; i++){
            var tmp = termPoints[idx][i].slice();
            var firstDay = this._firstDayOfMonth[i];
            if (isCenter) {
                var firstDayPoints = this._firstDayPoints[i];
                tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
            }
            var formatter = monthLabel.get('formatter');
            var name_1 = nameMap[+firstDay.m - 1];
            var params = {
                yyyy: firstDay.y,
                yy: (firstDay.y + '').slice(2),
                MM: firstDay.m,
                M: +firstDay.m,
                nameMap: name_1
            };
            var content = this._formatterLabel(formatter, params);
            var monthText = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $3828198b2f2de836$export$f8998c3d0a13de59)(monthLabel, {
                    text: content
                }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin)),
                silent: labelSilent
            });
            group.add(monthText);
        }
    };
    CalendarView.prototype._weekTextPositionControl = function(point, orient, position, margin, cellSize) {
        var align = 'center';
        var vAlign = 'middle';
        var x = point[0];
        var y = point[1];
        var isStart = position === 'start';
        if (orient === 'horizontal') {
            x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
            align = isStart ? 'right' : 'left';
        } else {
            y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
            vAlign = isStart ? 'bottom' : 'top';
        }
        return {
            x: x,
            y: y,
            align: align,
            verticalAlign: vAlign
        };
    };
    // render weeks
    CalendarView.prototype._renderWeekText = function(calendarModel, localeModel, rangeData, orient, group) {
        var dayLabel = calendarModel.getModel('dayLabel');
        if (!dayLabel.get('show')) return;
        var coordSys = calendarModel.coordinateSystem;
        var pos = dayLabel.get('position');
        var nameMap = dayLabel.get('nameMap');
        var margin = dayLabel.get('margin');
        var firstDayOfWeek = coordSys.getFirstDayOfWeek();
        if (!nameMap || (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(nameMap)) {
            if (nameMap) // case-sensitive
            localeModel = (0, $db1a0fc42a360ea2$export$37cc638e0e11865f)(nameMap) || localeModel;
            // Use the first letter of `dayOfWeekAbbr` if `dayOfWeekShort` doesn't exist in the locale file
            var dayOfWeekShort = localeModel.get([
                'time',
                'dayOfWeekShort'
            ]);
            nameMap = dayOfWeekShort || (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(localeModel.get([
                'time',
                'dayOfWeekAbbr'
            ]), function(val) {
                return val[0];
            });
        }
        var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
        var cellSize = [
            coordSys.getCellWidth(),
            coordSys.getCellHeight()
        ];
        margin = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(margin, Math.min(cellSize[1], cellSize[0]));
        if (pos === 'start') {
            start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
            margin = -margin;
        }
        var labelSilent = dayLabel.get('silent');
        for(var i = 0; i < 7; i++){
            var tmpD = coordSys.getNextNDay(start, i);
            var point = coordSys.dataToRect([
                tmpD.time
            ], false).center;
            var day = i;
            day = Math.abs((i + firstDayOfWeek) % 7);
            var weekText = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                z2: 30,
                style: (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $3828198b2f2de836$export$f8998c3d0a13de59)(dayLabel, {
                    text: nameMap[day]
                }), this._weekTextPositionControl(point, orient, pos, margin, cellSize)),
                silent: labelSilent
            });
            group.add(weekText);
        }
    };
    CalendarView.type = 'calendar';
    return CalendarView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $cf6c23e66afb44dc$export$2e2bcd8739ae039 = $cf6c23e66afb44dc$var$CalendarView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


// (24*60*60*1000)
var $7b117042f4dc06d9$var$PROXIMATE_ONE_DAY = 86400000;
var $7b117042f4dc06d9$var$Calendar = /** @class */ function() {
    function Calendar(calendarModel, ecModel, api) {
        this.type = 'calendar';
        this.dimensions = Calendar.dimensions;
        // Required in createListFromData
        this.getDimensionsInfo = Calendar.getDimensionsInfo;
        this._model = calendarModel;
    }
    Calendar.getDimensionsInfo = function() {
        return [
            {
                name: 'time',
                type: 'time'
            },
            'value'
        ];
    };
    Calendar.prototype.getRangeInfo = function() {
        return this._rangeInfo;
    };
    Calendar.prototype.getModel = function() {
        return this._model;
    };
    Calendar.prototype.getRect = function() {
        return this._rect;
    };
    Calendar.prototype.getCellWidth = function() {
        return this._sw;
    };
    Calendar.prototype.getCellHeight = function() {
        return this._sh;
    };
    Calendar.prototype.getOrient = function() {
        return this._orient;
    };
    /**
   * getFirstDayOfWeek
   *
   * @example
   *     0 : start at Sunday
   *     1 : start at Monday
   *
   * @return {number}
   */ Calendar.prototype.getFirstDayOfWeek = function() {
        return this._firstDayOfWeek;
    };
    /**
   * get date info
   * }
   */ Calendar.prototype.getDateInfo = function(date) {
        date = $9fd90cf3bf18fbcd$export$6b862160d295c8e(date);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        var mStr = m < 10 ? '0' + m : '' + m;
        var d = date.getDate();
        var dStr = d < 10 ? '0' + d : '' + d;
        var day = date.getDay();
        day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
        return {
            y: y + '',
            m: mStr,
            d: dStr,
            day: day,
            time: date.getTime(),
            formatedDate: y + '-' + mStr + '-' + dStr,
            date: date
        };
    };
    Calendar.prototype.getNextNDay = function(date, n) {
        n = n || 0;
        if (n === 0) return this.getDateInfo(date);
        date = new Date(this.getDateInfo(date).time);
        date.setDate(date.getDate() + n);
        return this.getDateInfo(date);
    };
    Calendar.prototype.update = function(ecModel, api) {
        this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
        this._orient = this._model.get('orient');
        this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
        this._rangeInfo = this._getRangeInfo(this._initRangeOption());
        var weeks = this._rangeInfo.weeks || 1;
        var whNames = [
            'width',
            'height'
        ];
        var cellSize = this._model.getCellSize().slice();
        var layoutParams = this._model.getBoxLayoutParams();
        var cellNumbers = this._orient === 'horizontal' ? [
            weeks,
            7
        ] : [
            7,
            weeks
        ];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (cellSizeSpecified(cellSize, idx)) layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
        });
        var whGlobal = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var calendarRect = this._rect = $501dc28f6c4d24ac$export$4517a5ca639a7293(layoutParams, whGlobal);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
            0,
            1
        ], function(idx) {
            if (!cellSizeSpecified(cellSize, idx)) cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
        });
        function cellSizeSpecified(cellSize, idx) {
            return cellSize[idx] != null && cellSize[idx] !== 'auto';
        }
        // Has been calculated out number.
        this._sw = cellSize[0];
        this._sh = cellSize[1];
    };
    /**
   * Convert a time data(time, value) item to (x, y) point.
   */ // TODO Clamp of calendar is not same with cartesian coordinate systems.
    // It will return NaN if data exceeds.
    Calendar.prototype.dataToPoint = function(data, clamp) {
        $1b239fc9d3a2f8ae$export$43bee75e5e14138e(data) && (data = data[0]);
        clamp == null && (clamp = true);
        var dayInfo = this.getDateInfo(data);
        var range = this._rangeInfo;
        var date = dayInfo.formatedDate;
        // if not in range return [NaN, NaN]
        if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + $7b117042f4dc06d9$var$PROXIMATE_ONE_DAY)) return [
            NaN,
            NaN
        ];
        var week = dayInfo.day;
        var nthWeek = this._getRangeInfo([
            range.start.time,
            date
        ]).nthWeek;
        if (this._orient === 'vertical') return [
            this._rect.x + week * this._sw + this._sw / 2,
            this._rect.y + nthWeek * this._sh + this._sh / 2
        ];
        return [
            this._rect.x + nthWeek * this._sw + this._sw / 2,
            this._rect.y + week * this._sh + this._sh / 2
        ];
    };
    /**
   * Convert a (x, y) point to time data
   */ Calendar.prototype.pointToData = function(point) {
        var date = this.pointToDate(point);
        return date && date.time;
    };
    /**
   * Convert a time date item to (x, y) four point.
   */ Calendar.prototype.dataToRect = function(data, clamp) {
        var point = this.dataToPoint(data, clamp);
        return {
            contentShape: {
                x: point[0] - (this._sw - this._lineWidth) / 2,
                y: point[1] - (this._sh - this._lineWidth) / 2,
                width: this._sw - this._lineWidth,
                height: this._sh - this._lineWidth
            },
            center: point,
            tl: [
                point[0] - this._sw / 2,
                point[1] - this._sh / 2
            ],
            tr: [
                point[0] + this._sw / 2,
                point[1] - this._sh / 2
            ],
            br: [
                point[0] + this._sw / 2,
                point[1] + this._sh / 2
            ],
            bl: [
                point[0] - this._sw / 2,
                point[1] + this._sh / 2
            ]
        };
    };
    /**
   * Convert a (x, y) point to time date
   *
   * @param  {Array} point point
   * @return {Object}       date
   */ Calendar.prototype.pointToDate = function(point) {
        var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
        var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
        var range = this._rangeInfo.range;
        if (this._orient === 'vertical') return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
        return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
    };
    Calendar.prototype.convertToPixel = function(ecModel, finder, value) {
        var coordSys = $7b117042f4dc06d9$var$getCoordSys(finder);
        return coordSys === this ? coordSys.dataToPoint(value) : null;
    };
    Calendar.prototype.convertFromPixel = function(ecModel, finder, pixel) {
        var coordSys = $7b117042f4dc06d9$var$getCoordSys(finder);
        return coordSys === this ? coordSys.pointToData(pixel) : null;
    };
    Calendar.prototype.containPoint = function(point) {
        console.warn('Not implemented.');
        return false;
    };
    /**
   * initRange
   * Normalize to an [start, end] array
   */ Calendar.prototype._initRangeOption = function() {
        var range = this._model.get('range');
        var normalizedRange;
        // Convert [1990] to 1990
        if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(range) && range.length === 1) range = range[0];
        if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(range)) {
            var rangeStr = range.toString();
            // One year.
            if (/^\d{4}$/.test(rangeStr)) normalizedRange = [
                rangeStr + '-01-01',
                rangeStr + '-12-31'
            ];
            // One month
            if (/^\d{4}[\/|-]\d{1,2}$/.test(rangeStr)) {
                var start = this.getDateInfo(rangeStr);
                var firstDay = start.date;
                firstDay.setMonth(firstDay.getMonth() + 1);
                var end = this.getNextNDay(firstDay, -1);
                normalizedRange = [
                    start.formatedDate,
                    end.formatedDate
                ];
            }
            // One day
            if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rangeStr)) normalizedRange = [
                rangeStr,
                rangeStr
            ];
        } else normalizedRange = range;
        if (!normalizedRange) // Not handling it.
        return range;
        var tmp = this._getRangeInfo(normalizedRange);
        if (tmp.start.time > tmp.end.time) normalizedRange.reverse();
        return normalizedRange;
    };
    /**
   * range info
   *
   * @private
   * @param  {Array} range range ['2017-01-01', '2017-07-08']
   *  If range[0] > range[1], they will not be reversed.
   * @return {Object}       obj
   */ Calendar.prototype._getRangeInfo = function(range) {
        var parsedRange = [
            this.getDateInfo(range[0]),
            this.getDateInfo(range[1])
        ];
        var reversed;
        if (parsedRange[0].time > parsedRange[1].time) {
            reversed = true;
            parsedRange.reverse();
        }
        var allDay = Math.floor(parsedRange[1].time / $7b117042f4dc06d9$var$PROXIMATE_ONE_DAY) - Math.floor(parsedRange[0].time / $7b117042f4dc06d9$var$PROXIMATE_ONE_DAY) + 1;
        // Consider case1 (#11677 #10430):
        // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
        // Consider case2:
        // Firstly set system timezone as "Time Zone: America/Toronto",
        // ```
        // let first = new Date(1478412000000 - 3600 * 1000 * 2.5);
        // let second = new Date(1478412000000);
        // let allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
        // ```
        // will get wrong result because of DST. So we should fix it.
        var date = new Date(parsedRange[0].time);
        var startDateNum = date.getDate();
        var endDateNum = parsedRange[1].date.getDate();
        date.setDate(startDateNum + allDay - 1);
        // The bias can not over a month, so just compare date.
        var dateNum = date.getDate();
        if (dateNum !== endDateNum) {
            var sign = date.getTime() - parsedRange[1].time > 0 ? 1 : -1;
            while((dateNum = date.getDate()) !== endDateNum && (date.getTime() - parsedRange[1].time) * sign > 0){
                allDay -= sign;
                date.setDate(dateNum - sign);
            }
        }
        var weeks = Math.floor((allDay + parsedRange[0].day + 6) / 7);
        var nthWeek = reversed ? -weeks + 1 : weeks - 1;
        reversed && parsedRange.reverse();
        return {
            range: [
                parsedRange[0].formatedDate,
                parsedRange[1].formatedDate
            ],
            start: parsedRange[0],
            end: parsedRange[1],
            allDay: allDay,
            weeks: weeks,
            // From 0.
            nthWeek: nthWeek,
            fweek: parsedRange[0].day,
            lweek: parsedRange[1].day
        };
    };
    /**
   * get date by nthWeeks and week day in range
   *
   * @private
   * @param  {number} nthWeek the week
   * @param  {number} day   the week day
   * @param  {Array} range [d1, d2]
   * @return {Object}
   */ Calendar.prototype._getDateByWeeksAndDay = function(nthWeek, day, range) {
        var rangeInfo = this._getRangeInfo(range);
        if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) return null;
        var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
        var date = new Date(rangeInfo.start.time);
        date.setDate(+rangeInfo.start.d + nthDay);
        return this.getDateInfo(date);
    };
    Calendar.create = function(ecModel, api) {
        var calendarList = [];
        ecModel.eachComponent('calendar', function(calendarModel) {
            var calendar = new Calendar(calendarModel, ecModel, api);
            calendarList.push(calendar);
            calendarModel.coordinateSystem = calendar;
        });
        ecModel.eachSeries(function(calendarSeries) {
            if (calendarSeries.get('coordinateSystem') === 'calendar') // Inject coordinate system
            calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
        });
        return calendarList;
    };
    Calendar.dimensions = [
        'time',
        'value'
    ];
    return Calendar;
}();
function $7b117042f4dc06d9$var$getCoordSys(finder) {
    var calendarModel = finder.calendarModel;
    var seriesModel = finder.seriesModel;
    var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
    return coordSys;
}
var $7b117042f4dc06d9$export$2e2bcd8739ae039 = $7b117042f4dc06d9$var$Calendar;


function $db3c318a0e442502$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $5b99c99b6ec6ef6c$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $cf6c23e66afb44dc$export$2e2bcd8739ae039));
    registers.registerCoordinateSystem('calendar', (0, $7b117042f4dc06d9$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




function $cc708c5d0ddd00ce$export$f6339b3d96c5d3d7(resultItem, newElOption) {
    var existElOption = resultItem.existing;
    // Set id and type after id assigned.
    newElOption.id = resultItem.keyInfo.id;
    !newElOption.type && existElOption && (newElOption.type = existElOption.type);
    // Set parent id if not specified
    if (newElOption.parentId == null) {
        var newElParentOption = newElOption.parentOption;
        if (newElParentOption) newElOption.parentId = newElParentOption.id;
        else if (existElOption) newElOption.parentId = existElOption.parentId;
    }
    // Clear
    newElOption.parentOption = null;
}
function $cc708c5d0ddd00ce$var$isSetLoc(obj, props) {
    var isSet;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(props, function(prop) {
        obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
    });
    return isSet;
}
function $cc708c5d0ddd00ce$var$mergeNewElOptionToExist(existList, index, newElOption) {
    // Update existing options, for `getOption` feature.
    var newElOptCopy = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, newElOption);
    var existElOption = existList[index];
    var $action = newElOption.$action || 'merge';
    if ($action === 'merge') {
        if (existElOption) {
            var newType;
            // We can ensure that newElOptCopy and existElOption are not
            // the same object, so `merge` will not change newElOptCopy.
            $1b239fc9d3a2f8ae$export$4950aa0f605343fb(existElOption, newElOptCopy, true);
            // Rigid body, use ignoreSize.
            (0, $501dc28f6c4d24ac$export$1754cb91f16ca028)(existElOption, newElOptCopy, {
                ignoreSize: true
            });
            // Will be used in render.
            (0, $501dc28f6c4d24ac$export$7438999faea9b6cc)(newElOption, existElOption);
            // Copy transition info to new option so it can be used in the transition.
            // DO IT AFTER merge
            $cc708c5d0ddd00ce$var$copyTransitionInfo(newElOption, existElOption);
            $cc708c5d0ddd00ce$var$copyTransitionInfo(newElOption, existElOption, 'shape');
            $cc708c5d0ddd00ce$var$copyTransitionInfo(newElOption, existElOption, 'style');
            $cc708c5d0ddd00ce$var$copyTransitionInfo(newElOption, existElOption, 'extra');
            // Copy clipPath
            newElOption.clipPath = existElOption.clipPath;
        } else existList[index] = newElOptCopy;
    } else if ($action === 'replace') existList[index] = newElOptCopy;
    else if ($action === 'remove') // null will be cleaned later.
    existElOption && (existList[index] = null);
}
var $cc708c5d0ddd00ce$var$TRANSITION_PROPS_TO_COPY = [
    'transition',
    'enterFrom',
    'leaveTo'
];
var $cc708c5d0ddd00ce$var$ROOT_TRANSITION_PROPS_TO_COPY = $cc708c5d0ddd00ce$var$TRANSITION_PROPS_TO_COPY.concat([
    'enterAnimation',
    'updateAnimation',
    'leaveAnimation'
]);
function $cc708c5d0ddd00ce$var$copyTransitionInfo(target, source, targetProp) {
    if (targetProp) {
        if (!target[targetProp] && source[targetProp]) // TODO avoid creating this empty object when there is no transition configuration.
        target[targetProp] = {};
        target = target[targetProp];
        source = source[targetProp];
    }
    if (!target || !source) return;
    var props = targetProp ? $cc708c5d0ddd00ce$var$TRANSITION_PROPS_TO_COPY : $cc708c5d0ddd00ce$var$ROOT_TRANSITION_PROPS_TO_COPY;
    for(var i = 0; i < props.length; i++){
        var prop = props[i];
        if (target[prop] == null && source[prop] != null) target[prop] = source[prop];
    }
}
function $cc708c5d0ddd00ce$var$setLayoutInfoToExist(existItem, newElOption) {
    if (!existItem) return;
    existItem.hv = newElOption.hv = [
        // Rigid body, don't care about `width`.
        $cc708c5d0ddd00ce$var$isSetLoc(newElOption, [
            'left',
            'right'
        ]),
        // Rigid body, don't care about `height`.
        $cc708c5d0ddd00ce$var$isSetLoc(newElOption, [
            'top',
            'bottom'
        ])
    ];
    // Give default group size. Otherwise layout error may occur.
    if (existItem.type === 'group') {
        var existingGroupOpt = existItem;
        var newGroupOpt = newElOption;
        existingGroupOpt.width == null && (existingGroupOpt.width = newGroupOpt.width = 0);
        existingGroupOpt.height == null && (existingGroupOpt.height = newGroupOpt.height = 0);
    }
}
var $cc708c5d0ddd00ce$export$6d85925da4d2cf23 = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GraphicComponentModel, _super);
    function GraphicComponentModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentModel.type;
        _this.preventAutoZ = true;
        return _this;
    }
    GraphicComponentModel.prototype.mergeOption = function(option, ecModel) {
        // Prevent default merge to elements
        var elements = this.option.elements;
        this.option.elements = null;
        _super.prototype.mergeOption.call(this, option, ecModel);
        this.option.elements = elements;
    };
    GraphicComponentModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        var newList = (isInit ? thisOption : newOption).elements;
        var existList = thisOption.elements = isInit ? [] : thisOption.elements;
        var flattenedList = [];
        this._flatten(newList, flattenedList, null);
        var mappingResult = $9ac03c46e8b6e711$export$574f818966e4da87(existList, flattenedList, 'normalMerge');
        // Clear elOptionsToUpdate
        var elOptionsToUpdate = this._elOptionsToUpdate = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(mappingResult, function(resultItem, index) {
            var newElOption = resultItem.newOption;
            if (!newElOption) return;
            elOptionsToUpdate.push(newElOption);
            $cc708c5d0ddd00ce$export$f6339b3d96c5d3d7(resultItem, newElOption);
            $cc708c5d0ddd00ce$var$mergeNewElOptionToExist(existList, index, newElOption);
            $cc708c5d0ddd00ce$var$setLayoutInfoToExist(existList[index], newElOption);
        }, this);
        // Clean
        thisOption.elements = $1b239fc9d3a2f8ae$export$3dea766d36a8935f(existList, function(item) {
            // $action should be volatile, otherwise option gotten from
            // `getOption` will contain unexpected $action.
            item && delete item.$action;
            return item != null;
        });
    };
    /**
   * Convert
   * [{
   *  type: 'group',
   *  id: 'xx',
   *  children: [{type: 'circle'}, {type: 'polygon'}]
   * }]
   * to
   * [
   *  {type: 'group', id: 'xx'},
   *  {type: 'circle', parentId: 'xx'},
   *  {type: 'polygon', parentId: 'xx'}
   * ]
   */ GraphicComponentModel.prototype._flatten = function(optionList, result, parentOption) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(optionList, function(option) {
            if (!option) return;
            if (parentOption) option.parentOption = parentOption;
            result.push(option);
            var children = option.children;
            // here we don't judge if option.type is `group`
            // when new option doesn't provide `type`, it will cause that the children can't be updated.
            if (children && children.length) this._flatten(children, result, option);
            // Deleting for JSON output, and for not affecting group creation.
            delete option.children;
        }, this);
    };
    // FIXME
    // Pass to view using payload? setOption has a payload?
    GraphicComponentModel.prototype.useElOptionsToUpdate = function() {
        var els = this._elOptionsToUpdate;
        // Clear to avoid render duplicately when zooming.
        this._elOptionsToUpdate = null;
        return els;
    };
    GraphicComponentModel.type = 'graphic';
    GraphicComponentModel.defaultOption = {
        elements: []
    };
    return GraphicComponentModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $af2cd1e7ee6aeaf5$var$nonShapeGraphicElements = {
    // Reserved but not supported in graphic component.
    path: null,
    compoundPath: null,
    // Supported in graphic component.
    group: $6c313c3ef6000a43$export$2e2bcd8739ae039,
    image: $29f98103052059af$export$2e2bcd8739ae039,
    text: $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039
};
var $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658 = $9ac03c46e8b6e711$export$64df9f8d92ae083f();
// ------------------------
// View
// ------------------------
var $af2cd1e7ee6aeaf5$export$1132c9ab9ad80748 = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(GraphicComponentView, _super);
    function GraphicComponentView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = GraphicComponentView.type;
        return _this;
    }
    GraphicComponentView.prototype.init = function() {
        this._elMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.render = function(graphicModel, ecModel, api) {
        // Having leveraged between use cases and algorithm complexity, a very
        // simple layout mechanism is used:
        // The size(width/height) can be determined by itself or its parent (not
        // implemented yet), but can not by its children. (Top-down travel)
        // The location(x/y) can be determined by the bounding rect of itself
        // (can including its descendants or not) and the size of its parent.
        // (Bottom-up travel)
        // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
        // view will be reused.
        if (graphicModel !== this._lastGraphicModel) this._clear();
        this._lastGraphicModel = graphicModel;
        this._updateElements(graphicModel);
        this._relocate(graphicModel, api);
    };
    /**
   * Update graphic elements.
   */ GraphicComponentView.prototype._updateElements = function(graphicModel) {
        var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
        if (!elOptionsToUpdate) return;
        var elMap = this._elMap;
        var rootGroup = this.group;
        var globalZ = graphicModel.get('z');
        var globalZLevel = graphicModel.get('zlevel');
        // Top-down tranverse to assign graphic settings to each elements.
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(elOptionsToUpdate, function(elOption) {
            var id = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(elOption.id, null);
            var elExisting = id != null ? elMap.get(id) : null;
            var parentId = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(elOption.parentId, null);
            var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
            var elType = elOption.type;
            var elOptionStyle = elOption.style;
            if (elType === 'text' && elOptionStyle) // In top/bottom mode, textVerticalAlign should not be used, which cause
            // inaccurately locating.
            {
                if (elOption.hv && elOption.hv[1]) elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = elOptionStyle.verticalAlign = elOptionStyle.align = null;
            }
            var textContentOption = elOption.textContent;
            var textConfig = elOption.textConfig;
            if (elOptionStyle && (0, $412257960513441c$export$3b868abde5eae7d1)(elOptionStyle, elType, !!textConfig, !!textContentOption)) {
                var convertResult = (0, $412257960513441c$export$7748133eaaa8aecc)(elOptionStyle, elType, true);
                if (!textConfig && convertResult.textConfig) textConfig = elOption.textConfig = convertResult.textConfig;
                if (!textContentOption && convertResult.textContent) textContentOption = convertResult.textContent;
            }
            // Remove unnecessary props to avoid potential problems.
            var elOptionCleaned = $af2cd1e7ee6aeaf5$var$getCleanedElOption(elOption);
            var $action = elOption.$action || 'merge';
            var isMerge = $action === 'merge';
            var isReplace = $action === 'replace';
            if (isMerge) {
                var isInit = !elExisting;
                var el_1 = elExisting;
                if (isInit) el_1 = $af2cd1e7ee6aeaf5$var$createEl(id, targetElParent, elOption.type, elMap);
                else {
                    el_1 && ($af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el_1).isNew = false);
                    // Stop and restore before update any other attributes.
                    (0, $babc3887e878ce38$export$9e5c70edf1ec0cb4)(el_1);
                }
                if (el_1) {
                    (0, $4ad5d316e369014d$export$4342b281b9b5d77e)(el_1, elOptionCleaned, graphicModel, {
                        isInit: isInit
                    });
                    $af2cd1e7ee6aeaf5$var$updateCommonAttrs(el_1, elOption, globalZ, globalZLevel);
                }
            } else if (isReplace) {
                $af2cd1e7ee6aeaf5$var$removeEl(elExisting, elOption, elMap, graphicModel);
                var el_2 = $af2cd1e7ee6aeaf5$var$createEl(id, targetElParent, elOption.type, elMap);
                if (el_2) {
                    (0, $4ad5d316e369014d$export$4342b281b9b5d77e)(el_2, elOptionCleaned, graphicModel, {
                        isInit: true
                    });
                    $af2cd1e7ee6aeaf5$var$updateCommonAttrs(el_2, elOption, globalZ, globalZLevel);
                }
            } else if ($action === 'remove') {
                (0, $4ad5d316e369014d$export$a6f11bb1cb100e2a)(elExisting, elOption);
                $af2cd1e7ee6aeaf5$var$removeEl(elExisting, elOption, elMap, graphicModel);
            }
            var el = elMap.get(id);
            if (el && textContentOption) {
                if (isMerge) {
                    var textContentExisting = el.getTextContent();
                    textContentExisting ? textContentExisting.attr(textContentOption) : el.setTextContent(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039(textContentOption));
                } else if (isReplace) el.setTextContent(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039(textContentOption));
            }
            if (el) {
                var clipPathOption = elOption.clipPath;
                if (clipPathOption) {
                    var clipPathType = clipPathOption.type;
                    var clipPath = void 0;
                    var isInit = false;
                    if (isMerge) {
                        var oldClipPath = el.getClipPath();
                        isInit = !oldClipPath || $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(oldClipPath).type !== clipPathType;
                        clipPath = isInit ? $af2cd1e7ee6aeaf5$var$newEl(clipPathType) : oldClipPath;
                    } else if (isReplace) {
                        isInit = true;
                        clipPath = $af2cd1e7ee6aeaf5$var$newEl(clipPathType);
                    }
                    el.setClipPath(clipPath);
                    (0, $4ad5d316e369014d$export$4342b281b9b5d77e)(clipPath, clipPathOption, graphicModel, {
                        isInit: isInit
                    });
                    (0, $babc3887e878ce38$export$b0aa6a5f01693fa4)(clipPath, clipPathOption.keyframeAnimation, graphicModel);
                }
                var elInner = $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el);
                el.setTextConfig(textConfig);
                elInner.option = elOption;
                $af2cd1e7ee6aeaf5$var$setEventData(el, graphicModel, elOption);
                $8eb95236e1aa01e7$export$fc6410d97fab306c({
                    el: el,
                    componentModel: graphicModel,
                    itemName: el.name,
                    itemTooltipOption: elOption.tooltip
                });
                (0, $babc3887e878ce38$export$b0aa6a5f01693fa4)(el, elOption.keyframeAnimation, graphicModel);
            }
        });
    };
    /**
   * Locate graphic elements.
   */ GraphicComponentView.prototype._relocate = function(graphicModel, api) {
        var elOptions = graphicModel.option.elements;
        var rootGroup = this.group;
        var elMap = this._elMap;
        var apiWidth = api.getWidth();
        var apiHeight = api.getHeight();
        var xy = [
            'x',
            'y'
        ];
        // Top-down to calculate percentage width/height of group
        for(var i = 0; i < elOptions.length; i++){
            var elOption = elOptions[i];
            var id = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el || !el.isGroup) continue;
            var parentEl = el.parent;
            var isParentRoot = parentEl === rootGroup;
            // Like 'position:absolut' in css, default 0.
            var elInner = $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el);
            var parentElInner = $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(parentEl);
            elInner.width = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(elInner.option.width, isParentRoot ? apiWidth : parentElInner.width) || 0;
            elInner.height = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(elInner.option.height, isParentRoot ? apiHeight : parentElInner.height) || 0;
        }
        // Bottom-up tranvese all elements (consider ec resize) to locate elements.
        for(var i = elOptions.length - 1; i >= 0; i--){
            var elOption = elOptions[i];
            var id = $9ac03c46e8b6e711$export$fb1a222ba5dd6e51(elOption.id, null);
            var el = id != null ? elMap.get(id) : null;
            if (!el) continue;
            var parentEl = el.parent;
            var parentElInner = $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(parentEl);
            var containerInfo = parentEl === rootGroup ? {
                width: apiWidth,
                height: apiHeight
            } : {
                width: parentElInner.width,
                height: parentElInner.height
            };
            // PENDING
            // Currently, when `bounding: 'all'`, the union bounding rect of the group
            // does not include the rect of [0, 0, group.width, group.height], which
            // is probably weird for users. Should we make a break change for it?
            var layoutPos = {};
            var layouted = $501dc28f6c4d24ac$export$74054bd96b5eeef1(el, elOption, containerInfo, null, {
                hv: elOption.hv,
                boundingMode: elOption.bounding
            }, layoutPos);
            if (!$af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el).isNew && layouted) {
                var transition = elOption.transition;
                var animatePos = {};
                for(var k = 0; k < xy.length; k++){
                    var key = xy[k];
                    var val = layoutPos[key];
                    if (transition && ((0, $4ad5d316e369014d$export$6f3361b4b8d7a8ba)(transition) || $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(transition, key) >= 0)) animatePos[key] = val;
                    else el[key] = val;
                }
                (0, $b40111164617dd60$export$c8dce3c08436e91e)(el, animatePos, graphicModel, 0);
            } else el.attr(layoutPos);
        }
    };
    /**
   * Clear all elements.
   */ GraphicComponentView.prototype._clear = function() {
        var _this = this;
        var elMap = this._elMap;
        elMap.each(function(el) {
            $af2cd1e7ee6aeaf5$var$removeEl(el, $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el).option, elMap, _this._lastGraphicModel);
        });
        this._elMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
    };
    GraphicComponentView.prototype.dispose = function() {
        this._clear();
    };
    GraphicComponentView.type = 'graphic';
    return GraphicComponentView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $af2cd1e7ee6aeaf5$var$newEl(graphicType) {
    var Clz = $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3($af2cd1e7ee6aeaf5$var$nonShapeGraphicElements, graphicType) ? $af2cd1e7ee6aeaf5$var$nonShapeGraphicElements[graphicType] : $8eb95236e1aa01e7$export$51df4b5565a58189(graphicType);
    var el = new Clz({});
    $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el).type = graphicType;
    return el;
}
function $af2cd1e7ee6aeaf5$var$createEl(id, targetElParent, graphicType, elMap) {
    var el = $af2cd1e7ee6aeaf5$var$newEl(graphicType);
    targetElParent.add(el);
    elMap.set(id, el);
    $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el).id = id;
    $af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(el).isNew = true;
    return el;
}
function $af2cd1e7ee6aeaf5$var$removeEl(elExisting, elOption, elMap, graphicModel) {
    var existElParent = elExisting && elExisting.parent;
    if (existElParent) {
        elExisting.type === 'group' && elExisting.traverse(function(el) {
            $af2cd1e7ee6aeaf5$var$removeEl(el, elOption, elMap, graphicModel);
        });
        (0, $4ad5d316e369014d$export$15575b6d82d35bb3)(elExisting, elOption, graphicModel);
        elMap.removeKey($af2cd1e7ee6aeaf5$export$4ae363f1d88fb658(elExisting).id);
    }
}
function $af2cd1e7ee6aeaf5$var$updateCommonAttrs(el, elOption, defaultZ, defaultZlevel) {
    if (!el.isGroup) $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
        [
            'cursor',
            (0, $cfd8540aca1ca40f$export$2e2bcd8739ae039).prototype.cursor
        ],
        // We should not support configure z and zlevel in the element level.
        // But seems we didn't limit it previously. So here still use it to avoid breaking.
        [
            'zlevel',
            defaultZlevel || 0
        ],
        [
            'z',
            defaultZ || 0
        ],
        // z2 must not be null/undefined, otherwise sort error may occur.
        [
            'z2',
            0
        ]
    ], function(item) {
        var prop = item[0];
        if ($1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3(elOption, prop)) el[prop] = $1b239fc9d3a2f8ae$export$995e01f2f5c9d030(elOption[prop], item[1]);
        else if (el[prop] == null) el[prop] = item[1];
    });
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43($1b239fc9d3a2f8ae$export$ed97f33186d4b816(elOption), function(key) {
        // Assign event handlers.
        // PENDING: should enumerate all event names or use pattern matching?
        if (key.indexOf('on') === 0) {
            var val = elOption[key];
            el[key] = $1b239fc9d3a2f8ae$export$f6e2535fb5126e54(val) ? val : null;
        }
    });
    if ($1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3(elOption, 'draggable')) el.draggable = elOption.draggable;
    // Other attributes
    elOption.name != null && (el.name = elOption.name);
    elOption.id != null && (el.id = elOption.id);
}
// Remove unnecessary props to avoid potential problems.
function $af2cd1e7ee6aeaf5$var$getCleanedElOption(elOption) {
    elOption = $1b239fc9d3a2f8ae$export$8b58be045bf06082({}, elOption);
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
        'id',
        'parentId',
        '$action',
        'hv',
        'bounding',
        'textContent',
        'clipPath'
    ].concat($501dc28f6c4d24ac$export$a9aa2cc018afbed), function(name) {
        delete elOption[name];
    });
    return elOption;
}
function $af2cd1e7ee6aeaf5$var$setEventData(el, graphicModel, elOption) {
    var eventData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).eventData;
    // Simple optimize for large amount of elements that no need event.
    if (!el.silent && !el.ignore && !eventData) eventData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).eventData = {
        componentType: 'graphic',
        componentIndex: graphicModel.componentIndex,
        name: el.name
    };
    // `elOption.info` enables user to mount some info on
    // elements and use them in event handlers.
    if (eventData) eventData.info = elOption.info;
}


function $0beabf04143da971$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $cc708c5d0ddd00ce$export$6d85925da4d2cf23));
    registers.registerComponentView((0, $af2cd1e7ee6aeaf5$export$1132c9ab9ad80748));
    registers.registerPreprocessor(function(option) {
        var graphicOption = option.graphic;
        // Convert
        // {graphic: [{left: 10, type: 'circle'}, ...]}
        // or
        // {graphic: {left: 10, type: 'circle'}}
        // to
        // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(graphicOption)) {
            if (!graphicOption[0] || !graphicOption[0].elements) option.graphic = [
                {
                    elements: graphicOption
                }
            ];
            else // Only one graphic instance can be instantiated. (We don't
            // want that too many views are created in echarts._viewMap.)
            option.graphic = [
                option.graphic[0]
            ];
        } else if (graphicOption && !graphicOption.elements) option.graphic = [
            {
                elements: [
                    graphicOption
                ]
            }
        ];
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
var $7ffe4a2ff6463652$export$f25521e726513e83 = [
    'x',
    'y',
    'radius',
    'angle',
    'single'
];
// Supported coords.
// FIXME: polar has been broken (but rarely used).
var $7ffe4a2ff6463652$var$SERIES_COORDS = [
    'cartesian2d',
    'polar',
    'singleAxis'
];
function $7ffe4a2ff6463652$export$2d449d4adc0d2cfc(seriesModel) {
    var coordType = seriesModel.get('coordinateSystem');
    return (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)($7ffe4a2ff6463652$var$SERIES_COORDS, coordType) >= 0;
}
function $7ffe4a2ff6463652$export$90855f7219399082(axisDim) {
    return axisDim + 'Axis';
}
function $7ffe4a2ff6463652$export$f9c16e110bf1e902(axisDim) {
    return axisDim + 'AxisIndex';
}
function $7ffe4a2ff6463652$export$fa8714b2310ddff9(axisDim) {
    return axisDim + 'AxisId';
}
function $7ffe4a2ff6463652$export$9e00b6c2b8b2e9a7(ecModel, payload) {
    // Key: `DataZoomAxisDimension`
    var axisRecords = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    var effectedModels = [];
    // Key: uid of dataZoomModel
    var effectedModelMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    // Find the dataZooms specified by payload.
    ecModel.eachComponent({
        mainType: 'dataZoom',
        query: payload
    }, function(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid)) addToEffected(dataZoomModel);
    });
    // Start from the given dataZoomModels, travel the graph to find
    // all of the linked dataZoom models.
    var foundNewLink;
    do {
        foundNewLink = false;
        ecModel.eachComponent('dataZoom', processSingle);
    }while (foundNewLink);
    function processSingle(dataZoomModel) {
        if (!effectedModelMap.get(dataZoomModel.uid) && isLinked(dataZoomModel)) {
            addToEffected(dataZoomModel);
            foundNewLink = true;
        }
    }
    function addToEffected(dataZoom) {
        effectedModelMap.set(dataZoom.uid, true);
        effectedModels.push(dataZoom);
        markAxisControlled(dataZoom);
    }
    function isLinked(dataZoomModel) {
        var isLink = false;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var axisIdxArr = axisRecords.get(axisDim);
            if (axisIdxArr && axisIdxArr[axisIndex]) isLink = true;
        });
        return isLink;
    }
    function markAxisControlled(dataZoomModel) {
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            (axisRecords.get(axisDim) || axisRecords.set(axisDim, []))[axisIndex] = true;
        });
    }
    return effectedModels;
}
function $7ffe4a2ff6463652$export$b41173dee9da195b(dataZoomModel) {
    var ecModel = dataZoomModel.ecModel;
    var coordSysInfoWrap = {
        infoList: [],
        infoMap: (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)()
    };
    dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
        var axisModel = ecModel.getComponent($7ffe4a2ff6463652$export$90855f7219399082(axisDim), axisIndex);
        if (!axisModel) return;
        var coordSysModel = axisModel.getCoordSysModel();
        if (!coordSysModel) return;
        var coordSysUid = coordSysModel.uid;
        var coordSysInfo = coordSysInfoWrap.infoMap.get(coordSysUid);
        if (!coordSysInfo) {
            coordSysInfo = {
                model: coordSysModel,
                axisModels: []
            };
            coordSysInfoWrap.infoList.push(coordSysInfo);
            coordSysInfoWrap.infoMap.set(coordSysUid, coordSysInfo);
        }
        coordSysInfo.axisModels.push(axisModel);
    });
    return coordSysInfoWrap;
}



var $c71b8584d0593ae5$var$DataZoomAxisInfo = /** @class */ function() {
    function DataZoomAxisInfo() {
        this.indexList = [];
        this.indexMap = [];
    }
    DataZoomAxisInfo.prototype.add = function(axisCmptIdx) {
        // Remove duplication.
        if (!this.indexMap[axisCmptIdx]) {
            this.indexList.push(axisCmptIdx);
            this.indexMap[axisCmptIdx] = true;
        }
    };
    return DataZoomAxisInfo;
}();
var $c71b8584d0593ae5$var$DataZoomModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(DataZoomModel, _super);
    function DataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomModel.type;
        _this._autoThrottle = true;
        _this._noTarget = true;
        /**
     * It is `[rangeModeForMin, rangeModeForMax]`.
     * The optional values for `rangeMode`:
     * + `'value'` mode: the axis extent will always be determined by
     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
     *     how data like and how `axis.min` and `axis.max` are.
     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
     *
     * For example, when users are using dynamic data (update data periodically via `setOption`),
     * if in `'value`' mode, the window will be kept in a fixed value range despite how
     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
     * the appended data (suppose `axis.min` and `axis.max` are not specified).
     */ _this._rangePropMode = [
            'percent',
            'percent'
        ];
        return _this;
    }
    DataZoomModel.prototype.init = function(option, parentModel, ecModel) {
        var inputRawOption = $c71b8584d0593ae5$var$retrieveRawOption(option);
        /**
     * Suppose a "main process" start at the point that model prepared (that is,
     * model initialized or merged or method called in `action`).
     * We should keep the `main process` idempotent, that is, given a set of values
     * on `option`, we get the same result.
     *
     * But sometimes, values on `option` will be updated for providing users
     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
     * should not be the base/input of the `main process`.
     *
     * So in that case we should save and keep the input of the `main process`
     * separately, called `settledOption`.
     *
     * For example, consider the case:
     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
     *     where the original input `option.startValue`, `option.endValue` are earsed by
     *     calculated value.
     * (Step)2) click the legend to hide and show a series,
     *     where the new range is calculated by the earsed `startValue` and `endValue`,
     *     which brings incorrect result.
     */ this.settledOption = inputRawOption;
        this.mergeDefaultAndTheme(option, ecModel);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype.mergeOption = function(newOption) {
        var inputRawOption = $c71b8584d0593ae5$var$retrieveRawOption(newOption);
        // FIX #2591
        (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(this.option, newOption, true);
        (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(this.settledOption, inputRawOption, true);
        this._doInit(inputRawOption);
    };
    DataZoomModel.prototype._doInit = function(inputRawOption) {
        var thisOption = this.option;
        this._setDefaultThrottle(inputRawOption);
        this._updateRangeUse(inputRawOption);
        var settledOption = this.settledOption;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names, index) {
            // start/end has higher priority over startValue/endValue if they
            // both set, but we should make chart.setOption({endValue: 1000})
            // effective, rather than chart.setOption({endValue: 1000, end: null}).
            if (this._rangePropMode[index] === 'value') thisOption[names[0]] = settledOption[names[0]] = null;
        // Otherwise do nothing and use the merge result.
        }, this);
        this._resetTarget();
    };
    DataZoomModel.prototype._resetTarget = function() {
        var optionOrient = this.get('orient', true);
        var targetAxisIndexMap = this._targetAxisInfoMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        var hasAxisSpecified = this._fillSpecifiedTargetAxis(targetAxisIndexMap);
        if (hasAxisSpecified) this._orient = optionOrient || this._makeAutoOrientByTargetAxis();
        else {
            this._orient = optionOrient || 'horizontal';
            this._fillAutoTargetAxisByOrient(targetAxisIndexMap, this._orient);
        }
        this._noTarget = true;
        targetAxisIndexMap.each(function(axisInfo) {
            if (axisInfo.indexList.length) this._noTarget = false;
        }, this);
    };
    DataZoomModel.prototype._fillSpecifiedTargetAxis = function(targetAxisIndexMap) {
        var hasAxisSpecified = false;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $7ffe4a2ff6463652$export$f25521e726513e83), function(axisDim) {
            var refering = this.getReferringComponents((0, $7ffe4a2ff6463652$export$90855f7219399082)(axisDim), (0, $9ac03c46e8b6e711$export$48d598924ce4892c));
            // When user set axisIndex as a empty array, we think that user specify axisIndex
            // but do not want use auto mode. Because empty array may be encountered when
            // some error occurred.
            if (!refering.specified) return;
            hasAxisSpecified = true;
            var axisInfo = new $c71b8584d0593ae5$var$DataZoomAxisInfo();
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(refering.models, function(axisModel) {
                axisInfo.add(axisModel.componentIndex);
            });
            targetAxisIndexMap.set(axisDim, axisInfo);
        }, this);
        return hasAxisSpecified;
    };
    DataZoomModel.prototype._fillAutoTargetAxisByOrient = function(targetAxisIndexMap, orient) {
        var ecModel = this.ecModel;
        var needAuto = true;
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisDim = orient === 'vertical' ? 'y' : 'x';
            var axisModels = ecModel.findComponents({
                mainType: axisDim + 'Axis'
            });
            setParallelAxis(axisModels, axisDim);
        }
        // Find axis that parallel to dataZoom as default.
        if (needAuto) {
            var axisModels = ecModel.findComponents({
                mainType: 'singleAxis',
                filter: function(axisModel) {
                    return axisModel.get('orient', true) === orient;
                }
            });
            setParallelAxis(axisModels, 'single');
        }
        function setParallelAxis(axisModels, axisDim) {
            // At least use the first parallel axis as the target axis.
            var axisModel = axisModels[0];
            if (!axisModel) return;
            var axisInfo = new $c71b8584d0593ae5$var$DataZoomAxisInfo();
            axisInfo.add(axisModel.componentIndex);
            targetAxisIndexMap.set(axisDim, axisInfo);
            needAuto = false;
            // Find parallel axes in the same grid.
            if (axisDim === 'x' || axisDim === 'y') {
                var gridModel_1 = axisModel.getReferringComponents('grid', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
                gridModel_1 && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axisModels, function(axModel) {
                    if (axisModel.componentIndex !== axModel.componentIndex && gridModel_1 === axModel.getReferringComponents('grid', (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0]) axisInfo.add(axModel.componentIndex);
                });
            }
        }
        if (needAuto) // If no parallel axis, find the first category axis as default. (Also consider polar).
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $7ffe4a2ff6463652$export$f25521e726513e83), function(axisDim) {
            if (!needAuto) return;
            var axisModels = ecModel.findComponents({
                mainType: (0, $7ffe4a2ff6463652$export$90855f7219399082)(axisDim),
                filter: function(axisModel) {
                    return axisModel.get('type', true) === 'category';
                }
            });
            if (axisModels[0]) {
                var axisInfo = new $c71b8584d0593ae5$var$DataZoomAxisInfo();
                axisInfo.add(axisModels[0].componentIndex);
                targetAxisIndexMap.set(axisDim, axisInfo);
                needAuto = false;
            }
        }, this);
    };
    DataZoomModel.prototype._makeAutoOrientByTargetAxis = function() {
        var dim;
        // Find the first axis
        this.eachTargetAxis(function(axisDim) {
            !dim && (dim = axisDim);
        }, this);
        return dim === 'y' ? 'vertical' : 'horizontal';
    };
    DataZoomModel.prototype._setDefaultThrottle = function(inputRawOption) {
        // When first time user set throttle, auto throttle ends.
        if (inputRawOption.hasOwnProperty('throttle')) this._autoThrottle = false;
        if (this._autoThrottle) {
            var globalOption = this.ecModel.option;
            this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
        }
    };
    DataZoomModel.prototype._updateRangeUse = function(inputRawOption) {
        var rangePropMode = this._rangePropMode;
        var rangeModeInOption = this.get('rangeMode');
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names, index) {
            var percentSpecified = inputRawOption[names[0]] != null;
            var valueSpecified = inputRawOption[names[1]] != null;
            if (percentSpecified && !valueSpecified) rangePropMode[index] = 'percent';
            else if (!percentSpecified && valueSpecified) rangePropMode[index] = 'value';
            else if (rangeModeInOption) rangePropMode[index] = rangeModeInOption[index];
            else if (percentSpecified) // percentSpecified && valueSpecified
            rangePropMode[index] = 'percent';
        // else remain its original setting.
        });
    };
    DataZoomModel.prototype.noTarget = function() {
        return this._noTarget;
    };
    DataZoomModel.prototype.getFirstTargetAxisModel = function() {
        var firstAxisModel;
        this.eachTargetAxis(function(axisDim, axisIndex) {
            if (firstAxisModel == null) firstAxisModel = this.ecModel.getComponent((0, $7ffe4a2ff6463652$export$90855f7219399082)(axisDim), axisIndex);
        }, this);
        return firstAxisModel;
    };
    /**
   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
   */ DataZoomModel.prototype.eachTargetAxis = function(callback, context) {
        this._targetAxisInfoMap.each(function(axisInfo, axisDim) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axisInfo.indexList, function(axisIndex) {
                callback.call(context, axisDim, axisIndex);
            });
        });
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisProxy = function(axisDim, axisIndex) {
        var axisModel = this.getAxisModel(axisDim, axisIndex);
        if (axisModel) return axisModel.__dzAxisProxy;
    };
    /**
   * @return If not found, return null/undefined.
   */ DataZoomModel.prototype.getAxisModel = function(axisDim, axisIndex) {
        var axisInfo = this._targetAxisInfoMap.get(axisDim);
        if (axisInfo && axisInfo.indexMap[axisIndex]) return this.ecModel.getComponent((0, $7ffe4a2ff6463652$export$90855f7219399082)(axisDim), axisIndex);
    };
    /**
   * If not specified, set to undefined.
   */ DataZoomModel.prototype.setRawRange = function(opt) {
        var thisOption = this.option;
        var settledOption = this.settledOption;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            [
                'start',
                'startValue'
            ],
            [
                'end',
                'endValue'
            ]
        ], function(names) {
            // Consider the pair <start, startValue>:
            // If one has value and the other one is `null/undefined`, we both set them
            // to `settledOption`. This strategy enables the feature to clear the original
            // value in `settledOption` to `null/undefined`.
            // But if both of them are `null/undefined`, we do not set them to `settledOption`
            // and keep `settledOption` with the original value. This strategy enables users to
            // only set <end or endValue> but not set <start or startValue> when calling
            // `dispatchAction`.
            // The pair <end, endValue> is treated in the same way.
            if (opt[names[0]] != null || opt[names[1]] != null) {
                thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
                thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
            }
        }, this);
        this._updateRangeUse(opt);
    };
    DataZoomModel.prototype.setCalculatedRange = function(opt) {
        var option = this.option;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            'start',
            'startValue',
            'end',
            'endValue'
        ], function(name) {
            option[name] = opt[name];
        });
    };
    DataZoomModel.prototype.getPercentRange = function() {
        var axisProxy = this.findRepresentativeAxisProxy();
        if (axisProxy) return axisProxy.getDataPercentWindow();
    };
    /**
   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
   *
   * @return [startValue, endValue] value can only be '-' or finite number.
   */ DataZoomModel.prototype.getValueRange = function(axisDim, axisIndex) {
        if (axisDim == null && axisIndex == null) {
            var axisProxy = this.findRepresentativeAxisProxy();
            if (axisProxy) return axisProxy.getDataValueWindow();
        } else return this.getAxisProxy(axisDim, axisIndex).getDataValueWindow();
    };
    /**
   * @param axisModel If axisModel given, find axisProxy
   *      corresponding to the axisModel
   */ DataZoomModel.prototype.findRepresentativeAxisProxy = function(axisModel) {
        if (axisModel) return axisModel.__dzAxisProxy;
        // Find the first hosted axisProxy
        var firstProxy;
        var axisDimList = this._targetAxisInfoMap.keys();
        for(var i = 0; i < axisDimList.length; i++){
            var axisDim = axisDimList[i];
            var axisInfo = this._targetAxisInfoMap.get(axisDim);
            for(var j = 0; j < axisInfo.indexList.length; j++){
                var proxy = this.getAxisProxy(axisDim, axisInfo.indexList[j]);
                if (proxy.hostedBy(this)) return proxy;
                if (!firstProxy) firstProxy = proxy;
            }
        }
        // If no hosted proxy found, still need to return a proxy.
        // This case always happens in toolbox dataZoom, where axes are all hosted by
        // other dataZooms.
        return firstProxy;
    };
    DataZoomModel.prototype.getRangePropMode = function() {
        return this._rangePropMode.slice();
    };
    DataZoomModel.prototype.getOrient = function() {
        return this._orient;
    };
    DataZoomModel.type = 'dataZoom';
    DataZoomModel.dependencies = [
        'xAxis',
        'yAxis',
        'radiusAxis',
        'angleAxis',
        'singleAxis',
        'series',
        'toolbox'
    ];
    DataZoomModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        filterMode: 'filter',
        start: 0,
        end: 100
    };
    return DataZoomModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
/**
 * Retrieve those raw params from option, which will be cached separately,
 * because they will be overwritten by normalized/calculated values in the main
 * process.
 */ function $c71b8584d0593ae5$var$retrieveRawOption(option) {
    var ret = {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        'start',
        'end',
        'startValue',
        'endValue',
        'throttle'
    ], function(name) {
        option.hasOwnProperty(name) && (ret[name] = option[name]);
    });
    return ret;
}
var $c71b8584d0593ae5$export$2e2bcd8739ae039 = $c71b8584d0593ae5$var$DataZoomModel;


var $9c03a3a54c328fa0$var$SelectDataZoomModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SelectDataZoomModel, _super);
    function SelectDataZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomModel.type;
        return _this;
    }
    SelectDataZoomModel.type = 'dataZoom.select';
    return SelectDataZoomModel;
}((0, $c71b8584d0593ae5$export$2e2bcd8739ae039));
var $9c03a3a54c328fa0$export$2e2bcd8739ae039 = $9c03a3a54c328fa0$var$SelectDataZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $ead8453d3c95e378$var$DataZoomView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(DataZoomView, _super);
    function DataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = DataZoomView.type;
        return _this;
    }
    DataZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        this.dataZoomModel = dataZoomModel;
        this.ecModel = ecModel;
        this.api = api;
    };
    DataZoomView.type = 'dataZoom';
    return DataZoomView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $ead8453d3c95e378$export$2e2bcd8739ae039 = $ead8453d3c95e378$var$DataZoomView;


var $426148805c2dc638$var$SelectDataZoomView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SelectDataZoomView, _super);
    function SelectDataZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SelectDataZoomView.type;
        return _this;
    }
    SelectDataZoomView.type = 'dataZoom.select';
    return SelectDataZoomView;
}((0, $ead8453d3c95e378$export$2e2bcd8739ae039));
var $426148805c2dc638$export$2e2bcd8739ae039 = $426148805c2dc638$var$SelectDataZoomView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $17ac6683b62e837d$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $17ac6683b62e837d$var$asc = $9fd90cf3bf18fbcd$export$debe6e778e0a6d32;
/**
 * Operate single axis.
 * One axis can only operated by one axis operator.
 * Different dataZoomModels may be defined to operate the same axis.
 * (i.e. 'inside' data zoom and 'slider' data zoom components)
 * So dataZoomModels share one axisProxy in that case.
 */ var $17ac6683b62e837d$var$AxisProxy = /** @class */ function() {
    function AxisProxy(dimName, axisIndex, dataZoomModel, ecModel) {
        this._dimName = dimName;
        this._axisIndex = axisIndex;
        this.ecModel = ecModel;
        this._dataZoomModel = dataZoomModel;
    // /**
    //  * @readOnly
    //  * @private
    //  */
    // this.hasSeriesStacked;
    }
    /**
   * Whether the axisProxy is hosted by dataZoomModel.
   */ AxisProxy.prototype.hostedBy = function(dataZoomModel) {
        return this._dataZoomModel === dataZoomModel;
    };
    /**
   * @return Value can only be NaN or finite value.
   */ AxisProxy.prototype.getDataValueWindow = function() {
        return this._valueWindow.slice();
    };
    /**
   * @return {Array.<number>}
   */ AxisProxy.prototype.getDataPercentWindow = function() {
        return this._percentWindow.slice();
    };
    AxisProxy.prototype.getTargetSeriesModels = function() {
        var seriesModels = [];
        this.ecModel.eachSeries(function(seriesModel) {
            if ((0, $7ffe4a2ff6463652$export$2d449d4adc0d2cfc)(seriesModel)) {
                var axisMainType = (0, $7ffe4a2ff6463652$export$90855f7219399082)(this._dimName);
                var axisModel = seriesModel.getReferringComponents(axisMainType, (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
                if (axisModel && this._axisIndex === axisModel.componentIndex) seriesModels.push(seriesModel);
            }
        }, this);
        return seriesModels;
    };
    AxisProxy.prototype.getAxisModel = function() {
        return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
    };
    AxisProxy.prototype.getMinMaxSpan = function() {
        return $1b239fc9d3a2f8ae$export$9cd59f9826255e47(this._minMaxSpan);
    };
    /**
   * Only calculate by given range and this._dataExtent, do not change anything.
   */ AxisProxy.prototype.calculateDataWindow = function(opt) {
        var dataExtent = this._dataExtent;
        var axisModel = this.getAxisModel();
        var scale = axisModel.axis.scale;
        var rangePropMode = this._dataZoomModel.getRangePropMode();
        var percentExtent = [
            0,
            100
        ];
        var percentWindow = [];
        var valueWindow = [];
        var hasPropModeValue;
        $17ac6683b62e837d$var$each([
            'start',
            'end'
        ], function(prop, idx) {
            var boundPercent = opt[prop];
            var boundValue = opt[prop + 'Value'];
            // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
            // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
            // but not min/max of axis, which will be calculated by data window then).
            // The former one is suitable for cases that a dataZoom component controls multiple
            // axes with different unit or extent, and the latter one is suitable for accurate
            // zoom by pixel (e.g., in dataZoomSelect).
            // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
            // only when setOption or dispatchAction, otherwise it remains its original value.
            // (Why not only record `percentProp` and always map to `valueProp`? Because
            // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
            // `valueProp`. consider two axes constrolled by one dataZoom. They have different
            // data extent. All of values that are overflow the `dataExtent` will be calculated
            // to percent '100%').
            if (rangePropMode[idx] === 'percent') {
                boundPercent == null && (boundPercent = percentExtent[idx]);
                // Use scale.parse to math round for category or time axis.
                boundValue = scale.parse($9fd90cf3bf18fbcd$export$d3f68fbaa670562(boundPercent, percentExtent, dataExtent));
            } else {
                hasPropModeValue = true;
                boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue);
                // Calculating `percent` from `value` may be not accurate, because
                // This calculation can not be inversed, because all of values that
                // are overflow the `dataExtent` will be calculated to percent '100%'
                boundPercent = $9fd90cf3bf18fbcd$export$d3f68fbaa670562(boundValue, dataExtent, percentExtent);
            }
            // valueWindow[idx] = round(boundValue);
            // percentWindow[idx] = round(boundPercent);
            // fallback to extent start/end when parsed value or percent is invalid
            valueWindow[idx] = boundValue == null || isNaN(boundValue) ? dataExtent[idx] : boundValue;
            percentWindow[idx] = boundPercent == null || isNaN(boundPercent) ? percentExtent[idx] : boundPercent;
        });
        $17ac6683b62e837d$var$asc(valueWindow);
        $17ac6683b62e837d$var$asc(percentWindow);
        // The windows from user calling of `dispatchAction` might be out of the extent,
        // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we don't restrict window
        // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
        // where API is able to initialize/modify the window size even though `zoomLock`
        // specified.
        var spans = this._minMaxSpan;
        hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
        function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
            var suffix = toValue ? 'Span' : 'ValueSpan';
            (0, $15a7158def1e4179$export$2e2bcd8739ae039)(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
            for(var i = 0; i < 2; i++){
                toWindow[i] = $9fd90cf3bf18fbcd$export$d3f68fbaa670562(fromWindow[i], fromExtent, toExtent, true);
                toValue && (toWindow[i] = scale.parse(toWindow[i]));
            }
        }
        return {
            valueWindow: valueWindow,
            percentWindow: percentWindow
        };
    };
    /**
   * Notice: reset should not be called before series.restoreData() is called,
   * so it is recommended to be called in "process stage" but not "model init
   * stage".
   */ AxisProxy.prototype.reset = function(dataZoomModel) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var targetSeries = this.getTargetSeriesModels();
        // Culculate data window and data extent, and record them.
        this._dataExtent = $17ac6683b62e837d$var$calculateDataExtent(this, this._dimName, targetSeries);
        // `calculateDataWindow` uses min/maxSpan.
        this._updateMinMaxSpan();
        var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
        this._valueWindow = dataWindow.valueWindow;
        this._percentWindow = dataWindow.percentWindow;
        // Update axis setting then.
        this._setAxisModel();
    };
    AxisProxy.prototype.filterData = function(dataZoomModel, api) {
        if (dataZoomModel !== this._dataZoomModel) return;
        var axisDim = this._dimName;
        var seriesModels = this.getTargetSeriesModels();
        var filterMode = dataZoomModel.get('filterMode');
        var valueWindow = this._valueWindow;
        if (filterMode === 'none') return;
        // FIXME
        // Toolbox may has dataZoom injected. And if there are stacked bar chart
        // with NaN data, NaN will be filtered and stack will be wrong.
        // So we need to force the mode to be set empty.
        // In fect, it is not a big deal that do not support filterMode-'filter'
        // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
        // selection" some day, which might need "adapt to data extent on the
        // otherAxis", which is disabled by filterMode-'empty'.
        // But currently, stack has been fixed to based on value but not index,
        // so this is not an issue any more.
        // let otherAxisModel = this.getOtherAxisModel();
        // if (dataZoomModel.get('$fromToolbox')
        //     && otherAxisModel
        //     && otherAxisModel.hasSeriesStacked
        // ) {
        //     filterMode = 'empty';
        // }
        // TODO
        // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
        $17ac6683b62e837d$var$each(seriesModels, function(seriesModel) {
            var seriesData = seriesModel.getData();
            var dataDims = seriesData.mapDimensionsAll(axisDim);
            if (!dataDims.length) return;
            if (filterMode === 'weakFilter') {
                var store_1 = seriesData.getStore();
                var dataDimIndices_1 = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(dataDims, function(dim) {
                    return seriesData.getDimensionIndex(dim);
                }, seriesData);
                seriesData.filterSelf(function(dataIndex) {
                    var leftOut;
                    var rightOut;
                    var hasValue;
                    for(var i = 0; i < dataDims.length; i++){
                        var value = store_1.get(dataDimIndices_1[i], dataIndex);
                        var thisHasValue = !isNaN(value);
                        var thisLeftOut = value < valueWindow[0];
                        var thisRightOut = value > valueWindow[1];
                        if (thisHasValue && !thisLeftOut && !thisRightOut) return true;
                        thisHasValue && (hasValue = true);
                        thisLeftOut && (leftOut = true);
                        thisRightOut && (rightOut = true);
                    }
                    // If both left out and right out, do not filter.
                    return hasValue && leftOut && rightOut;
                });
            } else $17ac6683b62e837d$var$each(dataDims, function(dim) {
                if (filterMode === 'empty') seriesModel.setData(seriesData = seriesData.map(dim, function(value) {
                    return !isInWindow(value) ? NaN : value;
                }));
                else {
                    var range = {};
                    range[dim] = valueWindow;
                    // console.time('select');
                    seriesData.selectRange(range);
                // console.timeEnd('select');
                }
            });
            $17ac6683b62e837d$var$each(dataDims, function(dim) {
                seriesData.setApproximateExtent(valueWindow, dim);
            });
        });
        function isInWindow(value) {
            return value >= valueWindow[0] && value <= valueWindow[1];
        }
    };
    AxisProxy.prototype._updateMinMaxSpan = function() {
        var minMaxSpan = this._minMaxSpan = {};
        var dataZoomModel = this._dataZoomModel;
        var dataExtent = this._dataExtent;
        $17ac6683b62e837d$var$each([
            'min',
            'max'
        ], function(minMax) {
            var percentSpan = dataZoomModel.get(minMax + 'Span');
            var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
            valueSpan != null && (valueSpan = this.getAxisModel().axis.scale.parse(valueSpan));
            // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
            if (valueSpan != null) percentSpan = $9fd90cf3bf18fbcd$export$d3f68fbaa670562(dataExtent[0] + valueSpan, dataExtent, [
                0,
                100
            ], true);
            else if (percentSpan != null) valueSpan = $9fd90cf3bf18fbcd$export$d3f68fbaa670562(percentSpan, [
                0,
                100
            ], dataExtent, true) - dataExtent[0];
            minMaxSpan[minMax + 'Span'] = percentSpan;
            minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
        }, this);
    };
    AxisProxy.prototype._setAxisModel = function() {
        var axisModel = this.getAxisModel();
        var percentWindow = this._percentWindow;
        var valueWindow = this._valueWindow;
        if (!percentWindow) return;
        // [0, 500]: arbitrary value, guess axis extent.
        var precision = $9fd90cf3bf18fbcd$export$666260d9a2dda8a7(valueWindow, [
            0,
            500
        ]);
        precision = Math.min(precision, 20);
        // For value axis, if min/max/scale are not set, we just use the extent obtained
        // by series data, which may be a little different from the extent calculated by
        // `axisHelper.getScaleExtent`. But the different just affects the experience a
        // little when zooming. So it will not be fixed until some users require it strongly.
        var rawExtentInfo = axisModel.axis.scale.rawExtentInfo;
        if (percentWindow[0] !== 0) rawExtentInfo.setDeterminedMinMax('min', +valueWindow[0].toFixed(precision));
        if (percentWindow[1] !== 100) rawExtentInfo.setDeterminedMinMax('max', +valueWindow[1].toFixed(precision));
        rawExtentInfo.freeze();
    };
    return AxisProxy;
}();
function $17ac6683b62e837d$var$calculateDataExtent(axisProxy, axisDim, seriesModels) {
    var dataExtent = [
        Infinity,
        -Infinity
    ];
    $17ac6683b62e837d$var$each(seriesModels, function(seriesModel) {
        (0, $5435624263a719a6$export$635fe7f20d0f4c70)(dataExtent, seriesModel.getData(), axisDim);
    });
    // It is important to get "consistent" extent when more then one axes is
    // controlled by a `dataZoom`, otherwise those axes will not be synchronized
    // when zooming. But it is difficult to know what is "consistent", considering
    // axes have different type or even different meanings (For example, two
    // time axes are used to compare data of the same date in different years).
    // So basically dataZoom just obtains extent by series.data (in category axis
    // extent can be obtained from axis.data).
    // Nevertheless, user can set min/max/scale on axes to make extent of axes
    // consistent.
    var axisModel = axisProxy.getAxisModel();
    var rawExtentResult = (0, $2c2289b75ab1ab72$export$5c3dbcbeb9ce7f5a)(axisModel.axis.scale, axisModel, dataExtent).calculate();
    return [
        rawExtentResult.min,
        rawExtentResult.max
    ];
}
var $17ac6683b62e837d$export$2e2bcd8739ae039 = $17ac6683b62e837d$var$AxisProxy;


var $6f02c5ad7ec23e01$var$dataZoomProcessor = {
    // `dataZoomProcessor` will only be performed in needed series. Consider if
    // there is a line series and a pie series, it is better not to update the
    // line series if only pie series is needed to be updated.
    getTargetSeries: function(ecModel) {
        function eachAxisModel(cb) {
            ecModel.eachComponent('dataZoom', function(dataZoomModel) {
                dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                    var axisModel = ecModel.getComponent((0, $7ffe4a2ff6463652$export$90855f7219399082)(axisDim), axisIndex);
                    cb(axisDim, axisIndex, axisModel, dataZoomModel);
                });
            });
        }
        // FIXME: it brings side-effect to `getTargetSeries`.
        // Prepare axis proxies.
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // dispose all last axis proxy, in case that some axis are deleted.
            axisModel.__dzAxisProxy = null;
        });
        var proxyList = [];
        eachAxisModel(function(axisDim, axisIndex, axisModel, dataZoomModel) {
            // Different dataZooms may constrol the same axis. In that case,
            // an axisProxy serves both of them.
            if (!axisModel.__dzAxisProxy) {
                // Use the first dataZoomModel as the main model of axisProxy.
                axisModel.__dzAxisProxy = new (0, $17ac6683b62e837d$export$2e2bcd8739ae039)(axisDim, axisIndex, dataZoomModel, ecModel);
                proxyList.push(axisModel.__dzAxisProxy);
            }
        });
        var seriesModelMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(proxyList, function(axisProxy) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axisProxy.getTargetSeriesModels(), function(seriesModel) {
                seriesModelMap.set(seriesModel.uid, seriesModel);
            });
        });
        return seriesModelMap;
    },
    // Consider appendData, where filter should be performed. Because data process is
    // in block mode currently, it is not need to worry about that the overallProgress
    // execute every frame.
    overallReset: function(ecModel, api) {
        ecModel.eachComponent('dataZoom', function(dataZoomModel) {
            // We calculate window and reset axis here but not in model
            // init stage and not after action dispatch handler, because
            // reset should be called after seriesData.restoreData.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).reset(dataZoomModel);
            });
            // Caution: data zoom filtering is order sensitive when using
            // percent range and no min/max/scale set on axis.
            // For example, we have dataZoom definition:
            // [
            //      {xAxisIndex: 0, start: 30, end: 70},
            //      {yAxisIndex: 0, start: 20, end: 80}
            // ]
            // In this case, [20, 80] of y-dataZoom should be based on data
            // that have filtered by x-dataZoom using range of [30, 70],
            // but should not be based on full raw data. Thus sliding
            // x-dataZoom will change both ranges of xAxis and yAxis,
            // while sliding y-dataZoom will only change the range of yAxis.
            // So we should filter x-axis after reset x-axis immediately,
            // and then reset y-axis and filter y-axis.
            dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
                dataZoomModel.getAxisProxy(axisDim, axisIndex).filterData(dataZoomModel, api);
            });
        });
        ecModel.eachComponent('dataZoom', function(dataZoomModel) {
            // Fullfill all of the range props so that user
            // is able to get them from chart.getOption().
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var percentRange = axisProxy.getDataPercentWindow();
                var valueRange = axisProxy.getDataValueWindow();
                dataZoomModel.setCalculatedRange({
                    start: percentRange[0],
                    end: percentRange[1],
                    startValue: valueRange[0],
                    endValue: valueRange[1]
                });
            }
        });
    }
};
var $6f02c5ad7ec23e01$export$2e2bcd8739ae039 = $6f02c5ad7ec23e01$var$dataZoomProcessor;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $fd4c5a1e28fd099e$export$2e2bcd8739ae039(registers) {
    registers.registerAction('dataZoom', function(payload, ecModel) {
        var effectedModels = (0, $7ffe4a2ff6463652$export$9e00b6c2b8b2e9a7)(ecModel, payload);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(effectedModels, function(dataZoomModel) {
            dataZoomModel.setRawRange({
                start: payload.start,
                end: payload.end,
                startValue: payload.startValue,
                endValue: payload.endValue
            });
        });
    });
}


var $a4957b6f96aa8101$var$installed = false;
function $a4957b6f96aa8101$export$2e2bcd8739ae039(registers) {
    if ($a4957b6f96aa8101$var$installed) return;
    $a4957b6f96aa8101$var$installed = true;
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, (0, $6f02c5ad7ec23e01$export$2e2bcd8739ae039));
    (0, $fd4c5a1e28fd099e$export$2e2bcd8739ae039)(registers);
    registers.registerSubTypeDefaulter('dataZoom', function() {
        // Default 'slider' when no type specified.
        return 'slider';
    });
}


function $57d47011456b0986$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $9c03a3a54c328fa0$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $426148805c2dc638$export$2e2bcd8739ae039));
    (0, $a4957b6f96aa8101$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ var $0a908f01d9563844$export$1426bfb1b0bcf539 = /** @class */ function() {
    function ToolboxFeature() {}
    return ToolboxFeature;
}();
var $0a908f01d9563844$var$features = {};
function $0a908f01d9563844$export$c6213a6f247cf906(name, ctor) {
    $0a908f01d9563844$var$features[name] = ctor;
}
function $0a908f01d9563844$export$bba2e7bbd72e62e1(name) {
    return $0a908f01d9563844$var$features[name];
}



var $c6aa3f3586db4ceb$var$ToolboxModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ToolboxModel, _super);
    function ToolboxModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ToolboxModel.type;
        return _this;
    }
    ToolboxModel.prototype.optionUpdated = function() {
        _super.prototype.optionUpdated.apply(this, arguments);
        var ecModel = this.ecModel;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this.option.feature, function(featureOpt, featureName) {
            var Feature = $0a908f01d9563844$export$bba2e7bbd72e62e1(featureName);
            if (Feature) {
                if (Feature.getDefaultOption) Feature.defaultOption = Feature.getDefaultOption(ecModel);
                $1b239fc9d3a2f8ae$export$4950aa0f605343fb(featureOpt, Feature.defaultOption);
            }
        });
    };
    ToolboxModel.type = 'toolbox';
    ToolboxModel.layoutMode = {
        type: 'box',
        ignoreSize: true
    };
    ToolboxModel.defaultOption = {
        show: true,
        z: 6,
        // zlevel: 0,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        // right
        // bottom
        backgroundColor: 'transparent',
        borderColor: '#ccc',
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemSize: 15,
        itemGap: 8,
        showTitle: true,
        iconStyle: {
            borderColor: '#666',
            color: 'none'
        },
        emphasis: {
            iconStyle: {
                borderColor: '#3E98C5'
            }
        },
        // textStyle: {},
        // feature
        tooltip: {
            show: false,
            position: 'bottom'
        }
    };
    return ToolboxModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $c6aa3f3586db4ceb$export$2e2bcd8739ae039 = $c6aa3f3586db4ceb$var$ToolboxModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck



function $270ca9502cccb922$export$b3219800bda33a1f(group, componentModel, api) {
    var boxLayoutParams = componentModel.getBoxLayoutParams();
    var padding = componentModel.get('padding');
    var viewportSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var rect = (0, $501dc28f6c4d24ac$export$4517a5ca639a7293)(boxLayoutParams, viewportSize, padding);
    (0, $501dc28f6c4d24ac$export$827f4ee28efc37)(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
    (0, $501dc28f6c4d24ac$export$74054bd96b5eeef1)(group, boxLayoutParams, viewportSize, padding);
}
function $270ca9502cccb922$export$fae23936eedfad4f(rect, componentModel) {
    var padding = $ff2fba995230f3c9$export$f3a38102c49f4268(componentModel.get('padding'));
    var style = componentModel.getItemStyle([
        'color',
        'opacity'
    ]);
    style.fill = componentModel.get('backgroundColor');
    rect = new $37476269d425e3f6$export$2e2bcd8739ae039({
        shape: {
            x: rect.x - padding[3],
            y: rect.y - padding[0],
            width: rect.width + padding[1] + padding[3],
            height: rect.height + padding[0] + padding[2],
            r: componentModel.get('borderRadius')
        },
        style: style,
        silent: true,
        z2: -1
    });
    // FIXME
    // `subPixelOptimizeRect` may bring some gap between edge of viewpart
    // and background rect when setting like `left: 0`, `top: 0`.
    // graphic.subPixelOptimizeRect(rect);
    return rect;
}







var $b5030b047c964655$var$ToolboxView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ToolboxView, _super);
    function ToolboxView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ToolboxView.prototype.render = function(toolboxModel, ecModel, api, payload) {
        var group = this.group;
        group.removeAll();
        if (!toolboxModel.get('show')) return;
        var itemSize = +toolboxModel.get('itemSize');
        var isVertical = toolboxModel.get('orient') === 'vertical';
        var featureOpts = toolboxModel.get('feature') || {};
        var features = this._features || (this._features = {});
        var featureNames = [];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(featureOpts, function(opt, name) {
            featureNames.push(name);
        });
        new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove($1b239fc9d3a2f8ae$export$c3095a23b368d1f2(processFeature, null)).execute();
        // Keep for diff.
        this._featureNames = featureNames;
        function processFeature(newIndex, oldIndex) {
            var featureName = featureNames[newIndex];
            var oldName = featureNames[oldIndex];
            var featureOpt = featureOpts[featureName];
            var featureModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(featureOpt, toolboxModel, toolboxModel.ecModel);
            var feature;
            // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
            if (payload && payload.newTitle != null && payload.featureName === featureName) featureOpt.title = payload.newTitle;
            if (featureName && !oldName) {
                // Create
                if ($b5030b047c964655$var$isUserFeatureName(featureName)) feature = {
                    onclick: featureModel.option.onclick,
                    featureName: featureName
                };
                else {
                    var Feature = (0, $0a908f01d9563844$export$bba2e7bbd72e62e1)(featureName);
                    if (!Feature) return;
                    feature = new Feature();
                }
                features[featureName] = feature;
            } else {
                feature = features[oldName];
                // If feature does not exist.
                if (!feature) return;
            }
            feature.uid = (0, $4e8eadf530aecaff$export$6d2b3473b0986646)('toolbox-feature');
            feature.model = featureModel;
            feature.ecModel = ecModel;
            feature.api = api;
            var isToolboxFeature = feature instanceof (0, $0a908f01d9563844$export$1426bfb1b0bcf539);
            if (!featureName && oldName) {
                isToolboxFeature && feature.dispose && feature.dispose(ecModel, api);
                return;
            }
            if (!featureModel.get('show') || isToolboxFeature && feature.unusable) {
                isToolboxFeature && feature.remove && feature.remove(ecModel, api);
                return;
            }
            createIconPaths(featureModel, feature, featureName);
            featureModel.setIconStatus = function(iconName, status) {
                var option = this.option;
                var iconPaths = this.iconPaths;
                option.iconStatus = option.iconStatus || {};
                option.iconStatus[iconName] = status;
                if (iconPaths[iconName]) (status === 'emphasis' ? (0, $b414df7d361a211c$export$b2d02638cc34c042) : (0, $b414df7d361a211c$export$11be6f716239ac55))(iconPaths[iconName]);
            };
            if (feature instanceof (0, $0a908f01d9563844$export$1426bfb1b0bcf539)) {
                if (feature.render) feature.render(featureModel, ecModel, api, payload);
            }
        }
        function createIconPaths(featureModel, feature, featureName) {
            var iconStyleModel = featureModel.getModel('iconStyle');
            var iconStyleEmphasisModel = featureModel.getModel([
                'emphasis',
                'iconStyle'
            ]);
            // If one feature has multiple icons, they are organized as
            // {
            //     icon: {
            //         foo: '',
            //         bar: ''
            //     },
            //     title: {
            //         foo: '',
            //         bar: ''
            //     }
            // }
            var icons = feature instanceof (0, $0a908f01d9563844$export$1426bfb1b0bcf539) && feature.getIcons ? feature.getIcons() : featureModel.get('icon');
            var titles = featureModel.get('title') || {};
            var iconsMap;
            var titlesMap;
            if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(icons)) {
                iconsMap = {};
                iconsMap[featureName] = icons;
            } else iconsMap = icons;
            if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(titles)) {
                titlesMap = {};
                titlesMap[featureName] = titles;
            } else titlesMap = titles;
            var iconPaths = featureModel.iconPaths = {};
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(iconsMap, function(iconStr, iconName) {
                var path = $8eb95236e1aa01e7$export$274edc73af1ae9c8(iconStr, {}, {
                    x: -itemSize / 2,
                    y: -itemSize / 2,
                    width: itemSize,
                    height: itemSize
                }); // TODO handling image
                path.setStyle(iconStyleModel.getItemStyle());
                var pathEmphasisState = path.ensureState('emphasis');
                pathEmphasisState.style = iconStyleEmphasisModel.getItemStyle();
                // Text position calculation
                // TODO: extract `textStyle` from `iconStyle` and use `createTextStyle`
                var textContent = new (0, $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039)({
                    style: {
                        text: titlesMap[iconName],
                        align: iconStyleEmphasisModel.get('textAlign'),
                        borderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
                        padding: iconStyleEmphasisModel.get('textPadding'),
                        fill: null,
                        font: (0, $3828198b2f2de836$export$155316a870a9d61e)({
                            fontStyle: iconStyleEmphasisModel.get('textFontStyle'),
                            fontFamily: iconStyleEmphasisModel.get('textFontFamily'),
                            fontSize: iconStyleEmphasisModel.get('textFontSize'),
                            fontWeight: iconStyleEmphasisModel.get('textFontWeight')
                        }, ecModel)
                    },
                    ignore: true
                });
                path.setTextContent(textContent);
                $8eb95236e1aa01e7$export$fc6410d97fab306c({
                    el: path,
                    componentModel: toolboxModel,
                    itemName: iconName,
                    formatterParamsExtra: {
                        title: titlesMap[iconName]
                    }
                });
                path.__title = titlesMap[iconName];
                path.on('mouseover', function() {
                    // Should not reuse above hoverStyle, which might be modified.
                    var hoverStyle = iconStyleEmphasisModel.getItemStyle();
                    var defaultTextPosition = isVertical ? toolboxModel.get('right') == null && toolboxModel.get('left') !== 'right' ? 'right' : 'left' : toolboxModel.get('bottom') == null && toolboxModel.get('top') !== 'bottom' ? 'bottom' : 'top';
                    textContent.setStyle({
                        fill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
                        backgroundColor: iconStyleEmphasisModel.get('textBackgroundColor')
                    });
                    path.setTextConfig({
                        position: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
                    });
                    textContent.ignore = !toolboxModel.get('showTitle');
                    // Use enterEmphasis and leaveEmphasis provide by ec.
                    // There are flags managed by the echarts.
                    api.enterEmphasis(this);
                }).on('mouseout', function() {
                    if (featureModel.get([
                        'iconStatus',
                        iconName
                    ]) !== 'emphasis') api.leaveEmphasis(this);
                    textContent.hide();
                });
                (featureModel.get([
                    'iconStatus',
                    iconName
                ]) === 'emphasis' ? (0, $b414df7d361a211c$export$b2d02638cc34c042) : (0, $b414df7d361a211c$export$11be6f716239ac55))(path);
                group.add(path);
                path.on('click', $1b239fc9d3a2f8ae$export$2385a24977818dd0(feature.onclick, feature, ecModel, api, iconName));
                iconPaths[iconName] = path;
            });
        }
        $270ca9502cccb922$export$b3219800bda33a1f(group, toolboxModel, api);
        // Render background after group is layout
        // FIXME
        group.add($270ca9502cccb922$export$fae23936eedfad4f(group.getBoundingRect(), toolboxModel));
        // Adjust icon title positions to avoid them out of screen
        isVertical || group.eachChild(function(icon) {
            var titleText = icon.__title;
            // const hoverStyle = icon.hoverStyle;
            // TODO simplify code?
            var emphasisState = icon.ensureState('emphasis');
            var emphasisTextConfig = emphasisState.textConfig || (emphasisState.textConfig = {});
            var textContent = icon.getTextContent();
            var emphasisTextState = textContent && textContent.ensureState('emphasis');
            // May be background element
            if (emphasisTextState && !$1b239fc9d3a2f8ae$export$f6e2535fb5126e54(emphasisTextState) && titleText) {
                var emphasisTextStyle = emphasisTextState.style || (emphasisTextState.style = {});
                var rect = $297531217517fbce$export$c381147bfed79d9f(titleText, (0, $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039).makeFont(emphasisTextStyle));
                var offsetX = icon.x + group.x;
                var offsetY = icon.y + group.y + itemSize;
                var needPutOnTop = false;
                if (offsetY + rect.height > api.getHeight()) {
                    emphasisTextConfig.position = 'top';
                    needPutOnTop = true;
                }
                var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 10;
                if (offsetX + rect.width / 2 > api.getWidth()) {
                    emphasisTextConfig.position = [
                        '100%',
                        topOffset
                    ];
                    emphasisTextStyle.align = 'right';
                } else if (offsetX - rect.width / 2 < 0) {
                    emphasisTextConfig.position = [
                        0,
                        topOffset
                    ];
                    emphasisTextStyle.align = 'left';
                }
            }
        });
    };
    ToolboxView.prototype.updateView = function(toolboxModel, ecModel, api, payload) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $0a908f01d9563844$export$1426bfb1b0bcf539) && feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
        });
    };
    // updateLayout(toolboxModel, ecModel, api, payload) {
    //     zrUtil.each(this._features, function (feature) {
    //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
    //     });
    // },
    ToolboxView.prototype.remove = function(ecModel, api) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $0a908f01d9563844$export$1426bfb1b0bcf539) && feature.remove && feature.remove(ecModel, api);
        });
        this.group.removeAll();
    };
    ToolboxView.prototype.dispose = function(ecModel, api) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this._features, function(feature) {
            feature instanceof (0, $0a908f01d9563844$export$1426bfb1b0bcf539) && feature.dispose && feature.dispose(ecModel, api);
        });
    };
    ToolboxView.type = 'toolbox';
    return ToolboxView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $b5030b047c964655$var$isUserFeatureName(featureName) {
    return featureName.indexOf('my') === 0;
}
var $b5030b047c964655$export$2e2bcd8739ae039 = $b5030b047c964655$var$ToolboxView;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $1b54c0bd59a42a63$var$SaveAsImage = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SaveAsImage, _super);
    function SaveAsImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SaveAsImage.prototype.onclick = function(ecModel, api) {
        var model = this.model;
        var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
        var isSvg = api.getZr().painter.getType() === 'svg';
        var type = isSvg ? 'svg' : model.get('type', true) || 'png';
        var url = api.getConnectedDataURL({
            type: type,
            backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
            connectedBackgroundColor: model.get('connectedBackgroundColor'),
            excludeComponents: model.get('excludeComponents'),
            pixelRatio: model.get('pixelRatio')
        });
        var browser = (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).browser;
        // Chrome, Firefox, New Edge
        if (typeof MouseEvent === 'function' && (browser.newEdge || !browser.ie && !browser.edge)) {
            var $a = document.createElement('a');
            $a.download = title + '.' + type;
            $a.target = '_blank';
            $a.href = url;
            var evt = new MouseEvent('click', {
                // some micro front-end framework， window maybe is a Proxy
                view: document.defaultView,
                bubbles: true,
                cancelable: false
            });
            $a.dispatchEvent(evt);
        } else // @ts-ignore
        if (window.navigator.msSaveOrOpenBlob || isSvg) {
            var parts = url.split(',');
            // data:[<mime type>][;charset=<charset>][;base64],<encoded data>
            var base64Encoded = parts[0].indexOf('base64') > -1;
            var bstr = isSvg ? decodeURIComponent(parts[1]) : parts[1];
            // only `atob` when the data uri is encoded with base64
            // otherwise, like `svg` data uri exported by zrender,
            // there will be an error, for it's not encoded with base64.
            // (just a url-encoded string through `encodeURIComponent`)
            base64Encoded && (bstr = window.atob(bstr));
            var filename = title + '.' + type;
            // @ts-ignore
            if (window.navigator.msSaveOrOpenBlob) {
                var n = bstr.length;
                var u8arr = new Uint8Array(n);
                while(n--)u8arr[n] = bstr.charCodeAt(n);
                var blob = new Blob([
                    u8arr
                ]); // @ts-ignore
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                var frame = document.createElement('iframe');
                document.body.appendChild(frame);
                var cw = frame.contentWindow;
                var doc = cw.document;
                doc.open('image/svg+xml', 'replace');
                doc.write(bstr);
                doc.close();
                cw.focus();
                doc.execCommand('SaveAs', true, filename);
                document.body.removeChild(frame);
            }
        } else {
            var lang = model.get('lang');
            var html = '<body style="margin:0;"><img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
            var tab = window.open();
            tab.document.write(html);
            tab.document.title = title;
        }
    };
    SaveAsImage.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'saveAsImage',
                'title'
            ]),
            type: 'png',
            // Default use option.backgroundColor
            // backgroundColor: '#fff',
            connectedBackgroundColor: '#fff',
            name: '',
            excludeComponents: [
                'toolbox'
            ],
            // use current pixel ratio of device by default
            // pixelRatio: 1,
            lang: ecModel.getLocaleModel().get([
                'toolbox',
                'saveAsImage',
                'lang'
            ])
        };
        return defaultOption;
    };
    return SaveAsImage;
}((0, $0a908f01d9563844$export$1426bfb1b0bcf539));
var $1b54c0bd59a42a63$export$2e2bcd8739ae039 = $1b54c0bd59a42a63$var$SaveAsImage;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $4e0939f0cb62f0bd$var$INNER_STACK_KEYWORD = '__ec_magicType_stack__';
var $4e0939f0cb62f0bd$var$ICON_TYPES = [
    'line',
    'bar',
    'stack'
];
// stack and tiled appears in pair for the title
var $4e0939f0cb62f0bd$var$TITLE_TYPES = [
    'line',
    'bar',
    'stack',
    'tiled'
];
var $4e0939f0cb62f0bd$var$radioTypes = [
    [
        'line',
        'bar'
    ],
    [
        'stack'
    ]
];
var $4e0939f0cb62f0bd$var$MagicType = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MagicType, _super);
    function MagicType() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MagicType.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get('icon');
        var icons = {};
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(model.get('type'), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    MagicType.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: [],
            // Icon group
            icon: {
                line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
                bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
                // eslint-disable-next-line
                stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
            },
            // `line`, `bar`, `stack`, `tiled`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'magicType',
                'title'
            ]),
            option: {},
            seriesIndex: {}
        };
        return defaultOption;
    };
    MagicType.prototype.onclick = function(ecModel, api, type) {
        var model = this.model;
        var seriesIndex = model.get([
            'seriesIndex',
            type
        ]);
        // Not supported magicType
        if (!$4e0939f0cb62f0bd$var$seriesOptGenreator[type]) return;
        var newOption = {
            series: []
        };
        var generateNewSeriesTypes = function(seriesModel) {
            var seriesType = seriesModel.subType;
            var seriesId = seriesModel.id;
            var newSeriesOpt = $4e0939f0cb62f0bd$var$seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
            if (newSeriesOpt) {
                // PENDING If merge original option?
                $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(newSeriesOpt, seriesModel.option);
                newOption.series.push(newSeriesOpt);
            }
            // Modify boundaryGap
            var coordSys = seriesModel.coordinateSystem;
            if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
                var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
                if (categoryAxis) {
                    var axisDim = categoryAxis.dim;
                    var axisType = axisDim + 'Axis';
                    var axisModel = seriesModel.getReferringComponents(axisType, (0, $9ac03c46e8b6e711$export$f076738ec84e693c)).models[0];
                    var axisIndex = axisModel.componentIndex;
                    newOption[axisType] = newOption[axisType] || [];
                    for(var i = 0; i <= axisIndex; i++)newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
                    newOption[axisType][axisIndex].boundaryGap = type === 'bar';
                }
            }
        };
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43($4e0939f0cb62f0bd$var$radioTypes, function(radio) {
            if ($1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(radio, type) >= 0) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(radio, function(item) {
                model.setIconStatus(item, 'normal');
            });
        });
        model.setIconStatus(type, 'emphasis');
        ecModel.eachComponent({
            mainType: 'series',
            query: seriesIndex == null ? null : {
                seriesIndex: seriesIndex
            }
        }, generateNewSeriesTypes);
        var newTitle;
        var currentType = type;
        // Change title of stack
        if (type === 'stack') {
            // use titles in model instead of ecModel
            // as stack and tiled appears in pair, just flip them
            // no need of checking stack state
            newTitle = $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
                stack: model.option.title.tiled,
                tiled: model.option.title.stack
            }, model.option.title);
            if (model.get([
                'iconStatus',
                type
            ]) !== 'emphasis') currentType = 'tiled';
        }
        api.dispatchAction({
            type: 'changeMagicType',
            currentType: currentType,
            newOption: newOption,
            newTitle: newTitle,
            featureName: 'magicType'
        });
    };
    return MagicType;
}((0, $0a908f01d9563844$export$1426bfb1b0bcf539));
var $4e0939f0cb62f0bd$var$seriesOptGenreator = {
    'line': function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === 'bar') return $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
            id: seriesId,
            type: 'line',
            // Preserve data related option
            data: seriesModel.get('data'),
            stack: seriesModel.get('stack'),
            markPoint: seriesModel.get('markPoint'),
            markLine: seriesModel.get('markLine')
        }, model.get([
            'option',
            'line'
        ]) || {}, true);
    },
    'bar': function(seriesType, seriesId, seriesModel, model) {
        if (seriesType === 'line') return $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
            id: seriesId,
            type: 'bar',
            // Preserve data related option
            data: seriesModel.get('data'),
            stack: seriesModel.get('stack'),
            markPoint: seriesModel.get('markPoint'),
            markLine: seriesModel.get('markLine')
        }, model.get([
            'option',
            'bar'
        ]) || {}, true);
    },
    'stack': function(seriesType, seriesId, seriesModel, model) {
        var isStack = seriesModel.get('stack') === $4e0939f0cb62f0bd$var$INNER_STACK_KEYWORD;
        if (seriesType === 'line' || seriesType === 'bar') {
            model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
            return $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
                id: seriesId,
                stack: isStack ? '' : $4e0939f0cb62f0bd$var$INNER_STACK_KEYWORD
            }, model.get([
                'option',
                'stack'
            ]) || {}, true);
        }
    }
};
// TODO: SELF REGISTERED.
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: 'changeMagicType',
    event: 'magicTypeChanged',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    ecModel.mergeOption(payload.newOption);
});
var $4e0939f0cb62f0bd$export$2e2bcd8739ae039 = $4e0939f0cb62f0bd$var$MagicType;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/* global document */ var $752176b90ee5d2f1$var$BLOCK_SPLITER = new Array(60).join('-');
var $752176b90ee5d2f1$var$ITEM_SPLITER = '\t';
/**
 * Group series into two types
 *  1. on category axis, like line, bar
 *  2. others, like scatter, pie
 */ function $752176b90ee5d2f1$var$groupSeries(ecModel) {
    var seriesGroupByCategoryAxis = {};
    var otherSeries = [];
    var meta = [];
    ecModel.eachRawSeries(function(seriesModel) {
        var coordSys = seriesModel.coordinateSystem;
        if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
            // TODO: TYPE Consider polar? Include polar may increase unecessary bundle size.
            var baseAxis = coordSys.getBaseAxis();
            if (baseAxis.type === 'category') {
                var key = baseAxis.dim + '_' + baseAxis.index;
                if (!seriesGroupByCategoryAxis[key]) {
                    seriesGroupByCategoryAxis[key] = {
                        categoryAxis: baseAxis,
                        valueAxis: coordSys.getOtherAxis(baseAxis),
                        series: []
                    };
                    meta.push({
                        axisDim: baseAxis.dim,
                        axisIndex: baseAxis.index
                    });
                }
                seriesGroupByCategoryAxis[key].series.push(seriesModel);
            } else otherSeries.push(seriesModel);
        } else otherSeries.push(seriesModel);
    });
    return {
        seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
        other: otherSeries,
        meta: meta
    };
}
/**
 * Assemble content of series on cateogory axis
 * @inner
 */ function $752176b90ee5d2f1$var$assembleSeriesWithCategoryAxis(groups) {
    var tables = [];
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(groups, function(group, key) {
        var categoryAxis = group.categoryAxis;
        var valueAxis = group.valueAxis;
        var valueAxisDim = valueAxis.dim;
        var headers = [
            ' '
        ].concat($1b239fc9d3a2f8ae$export$871de8747c9eaa88(group.series, function(series) {
            return series.name;
        }));
        // @ts-ignore TODO Polar
        var columns = [
            categoryAxis.model.getCategories()
        ];
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(group.series, function(series) {
            var rawData = series.getRawData();
            columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function(val) {
                return val;
            }));
        });
        // Assemble table content
        var lines = [
            headers.join($752176b90ee5d2f1$var$ITEM_SPLITER)
        ];
        for(var i = 0; i < columns[0].length; i++){
            var items = [];
            for(var j = 0; j < columns.length; j++)items.push(columns[j][i]);
            lines.push(items.join($752176b90ee5d2f1$var$ITEM_SPLITER));
        }
        tables.push(lines.join('\n'));
    });
    return tables.join('\n\n' + $752176b90ee5d2f1$var$BLOCK_SPLITER + '\n\n');
}
/**
 * Assemble content of other series
 */ function $752176b90ee5d2f1$var$assembleOtherSeries(series) {
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(series, function(series) {
        var data = series.getRawData();
        var lines = [
            series.name
        ];
        var vals = [];
        data.each(data.dimensions, function() {
            var argLen = arguments.length;
            var dataIndex = arguments[argLen - 1];
            var name = data.getName(dataIndex);
            for(var i = 0; i < argLen - 1; i++)vals[i] = arguments[i];
            lines.push((name ? name + $752176b90ee5d2f1$var$ITEM_SPLITER : '') + vals.join($752176b90ee5d2f1$var$ITEM_SPLITER));
        });
        return lines.join('\n');
    }).join('\n\n' + $752176b90ee5d2f1$var$BLOCK_SPLITER + '\n\n');
}
function $752176b90ee5d2f1$var$getContentFromModel(ecModel) {
    var result = $752176b90ee5d2f1$var$groupSeries(ecModel);
    return {
        value: $1b239fc9d3a2f8ae$export$3dea766d36a8935f([
            $752176b90ee5d2f1$var$assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis),
            $752176b90ee5d2f1$var$assembleOtherSeries(result.other)
        ], function(str) {
            return !!str.replace(/[\n\t\s]/g, '');
        }).join('\n\n' + $752176b90ee5d2f1$var$BLOCK_SPLITER + '\n\n'),
        meta: result.meta
    };
}
function $752176b90ee5d2f1$var$trim(str) {
    return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
}
/**
 * If a block is tsv format
 */ function $752176b90ee5d2f1$var$isTSVFormat(block) {
    // Simple method to find out if a block is tsv format
    var firstLine = block.slice(0, block.indexOf('\n'));
    if (firstLine.indexOf($752176b90ee5d2f1$var$ITEM_SPLITER) >= 0) return true;
}
var $752176b90ee5d2f1$var$itemSplitRegex = new RegExp('[' + $752176b90ee5d2f1$var$ITEM_SPLITER + ']+', 'g');
/**
 * @param {string} tsv
 * @return {Object}
 */ function $752176b90ee5d2f1$var$parseTSVContents(tsv) {
    var tsvLines = tsv.split(/\n+/g);
    var headers = $752176b90ee5d2f1$var$trim(tsvLines.shift()).split($752176b90ee5d2f1$var$itemSplitRegex);
    var categories = [];
    var series = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(headers, function(header) {
        return {
            name: header,
            data: []
        };
    });
    for(var i = 0; i < tsvLines.length; i++){
        var items = $752176b90ee5d2f1$var$trim(tsvLines[i]).split($752176b90ee5d2f1$var$itemSplitRegex);
        categories.push(items.shift());
        for(var j = 0; j < items.length; j++)series[j] && (series[j].data[i] = items[j]);
    }
    return {
        series: series,
        categories: categories
    };
}
function $752176b90ee5d2f1$var$parseListContents(str) {
    var lines = str.split(/\n+/g);
    var seriesName = $752176b90ee5d2f1$var$trim(lines.shift());
    var data = [];
    for(var i = 0; i < lines.length; i++){
        // if line is empty, ignore it.
        // there is a case that a user forgot to delete `\n`.
        var line = $752176b90ee5d2f1$var$trim(lines[i]);
        if (!line) continue;
        var items = line.split($752176b90ee5d2f1$var$itemSplitRegex);
        var name_1 = '';
        var value = void 0;
        var hasName = false;
        if (isNaN(items[0])) {
            // First item is name
            hasName = true;
            name_1 = items[0];
            items = items.slice(1);
            data[i] = {
                name: name_1,
                value: []
            };
            value = data[i].value;
        } else value = data[i] = [];
        for(var j = 0; j < items.length; j++)value.push(+items[j]);
        if (value.length === 1) hasName ? data[i].value = value[0] : data[i] = value[0];
    }
    return {
        name: seriesName,
        data: data
    };
}
function $752176b90ee5d2f1$var$parseContents(str, blockMetaList) {
    var blocks = str.split(new RegExp('\n*' + $752176b90ee5d2f1$var$BLOCK_SPLITER + '\n*', 'g'));
    var newOption = {
        series: []
    };
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(blocks, function(block, idx) {
        if ($752176b90ee5d2f1$var$isTSVFormat(block)) {
            var result = $752176b90ee5d2f1$var$parseTSVContents(block);
            var blockMeta = blockMetaList[idx];
            var axisKey = blockMeta.axisDim + 'Axis';
            if (blockMeta) {
                newOption[axisKey] = newOption[axisKey] || [];
                newOption[axisKey][blockMeta.axisIndex] = {
                    data: result.categories
                };
                newOption.series = newOption.series.concat(result.series);
            }
        } else {
            var result = $752176b90ee5d2f1$var$parseListContents(block);
            newOption.series.push(result);
        }
    });
    return newOption;
}
var $752176b90ee5d2f1$var$DataView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(DataView, _super);
    function DataView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataView.prototype.onclick = function(ecModel, api) {
        // FIXME: better way?
        setTimeout(function() {
            api.dispatchAction({
                type: 'hideTip'
            });
        });
        var container = api.getDom();
        var model = this.model;
        if (this._dom) container.removeChild(this._dom);
        var root = document.createElement('div');
        // use padding to avoid 5px whitespace
        root.style.cssText = 'position:absolute;top:0;bottom:0;left:0;right:0;padding:5px';
        root.style.backgroundColor = model.get('backgroundColor') || '#fff';
        // Create elements
        var header = document.createElement('h4');
        var lang = model.get('lang') || [];
        header.innerHTML = lang[0] || model.get('title');
        header.style.cssText = 'margin:10px 20px';
        header.style.color = model.get('textColor');
        var viewMain = document.createElement('div');
        var textarea = document.createElement('textarea');
        viewMain.style.cssText = 'overflow:auto';
        var optionToContent = model.get('optionToContent');
        var contentToOption = model.get('contentToOption');
        var result = $752176b90ee5d2f1$var$getContentFromModel(ecModel);
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(optionToContent)) {
            var htmlOrDom = optionToContent(api.getOption());
            if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(htmlOrDom)) viewMain.innerHTML = htmlOrDom;
            else if ($1b239fc9d3a2f8ae$export$9f57505b7bd8dae(htmlOrDom)) viewMain.appendChild(htmlOrDom);
        } else {
            // Use default textarea
            textarea.readOnly = model.get('readOnly');
            var style = textarea.style;
            // eslint-disable-next-line max-len
            style.cssText = 'display:block;width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;resize:none;box-sizing:border-box;outline:none';
            style.color = model.get('textColor');
            style.borderColor = model.get('textareaBorderColor');
            style.backgroundColor = model.get('textareaColor');
            textarea.value = result.value;
            viewMain.appendChild(textarea);
        }
        var blockMetaList = result.meta;
        var buttonContainer = document.createElement('div');
        buttonContainer.style.cssText = 'position:absolute;bottom:5px;left:0;right:0';
        // eslint-disable-next-line max-len
        var buttonStyle = 'float:right;margin-right:20px;border:none;cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
        var closeButton = document.createElement('div');
        var refreshButton = document.createElement('div');
        buttonStyle += ';background-color:' + model.get('buttonColor');
        buttonStyle += ';color:' + model.get('buttonTextColor');
        var self = this;
        function close() {
            container.removeChild(root);
            self._dom = null;
        }
        (0, $8f7ba7c16ab1583e$export$3f65cefe8380dbea)(closeButton, 'click', close);
        (0, $8f7ba7c16ab1583e$export$3f65cefe8380dbea)(refreshButton, 'click', function() {
            if (contentToOption == null && optionToContent != null || contentToOption != null && optionToContent == null) {
                close();
                return;
            }
            var newOption;
            try {
                if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(contentToOption)) newOption = contentToOption(viewMain, api.getOption());
                else newOption = $752176b90ee5d2f1$var$parseContents(textarea.value, blockMetaList);
            } catch (e) {
                close();
                throw new Error('Data view format error ' + e);
            }
            if (newOption) api.dispatchAction({
                type: 'changeDataView',
                newOption: newOption
            });
            close();
        });
        closeButton.innerHTML = lang[1];
        refreshButton.innerHTML = lang[2];
        refreshButton.style.cssText = closeButton.style.cssText = buttonStyle;
        !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
        buttonContainer.appendChild(closeButton);
        root.appendChild(header);
        root.appendChild(viewMain);
        root.appendChild(buttonContainer);
        viewMain.style.height = container.clientHeight - 80 + 'px';
        container.appendChild(root);
        this._dom = root;
    };
    DataView.prototype.remove = function(ecModel, api) {
        this._dom && api.getDom().removeChild(this._dom);
    };
    DataView.prototype.dispose = function(ecModel, api) {
        this.remove(ecModel, api);
    };
    DataView.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            readOnly: false,
            optionToContent: null,
            contentToOption: null,
            // eslint-disable-next-line
            icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'dataView',
                'title'
            ]),
            lang: ecModel.getLocaleModel().get([
                'toolbox',
                'dataView',
                'lang'
            ]),
            backgroundColor: '#fff',
            textColor: '#000',
            textareaColor: '#fff',
            textareaBorderColor: '#333',
            buttonColor: '#c23531',
            buttonTextColor: '#fff'
        };
        return defaultOption;
    };
    return DataView;
}((0, $0a908f01d9563844$export$1426bfb1b0bcf539));
/**
 * @inner
 */ function $752176b90ee5d2f1$var$tryMergeDataOption(newData, originalData) {
    return $1b239fc9d3a2f8ae$export$871de8747c9eaa88(newData, function(newVal, idx) {
        var original = originalData && originalData[idx];
        if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(original) && !$1b239fc9d3a2f8ae$export$43bee75e5e14138e(original)) {
            var newValIsObject = $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(newVal) && !$1b239fc9d3a2f8ae$export$43bee75e5e14138e(newVal);
            if (!newValIsObject) newVal = {
                value: newVal
            };
            // original data has name but new data has no name
            var shouldDeleteName = original.name != null && newVal.name == null;
            // Original data has option
            newVal = $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(newVal, original);
            shouldDeleteName && delete newVal.name;
            return newVal;
        } else return newVal;
    });
}
// TODO: SELF REGISTERED.
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: 'changeDataView',
    event: 'dataViewChanged',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    var newSeriesOptList = [];
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(payload.newOption.series, function(seriesOpt) {
        var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
        if (!seriesModel) // New created series
        // Geuss the series type
        newSeriesOptList.push($1b239fc9d3a2f8ae$export$8b58be045bf06082({
            // Default is scatter
            type: 'scatter'
        }, seriesOpt));
        else {
            var originalData = seriesModel.get('data');
            newSeriesOptList.push({
                name: seriesOpt.name,
                data: $752176b90ee5d2f1$var$tryMergeDataOption(seriesOpt.data, originalData)
            });
        }
    });
    ecModel.mergeOption($1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
        series: newSeriesOptList
    }, payload.newOption));
});
var $752176b90ee5d2f1$export$2e2bcd8739ae039 = $752176b90ee5d2f1$var$DataView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $b8e1e9b87c9c3e04$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $b8e1e9b87c9c3e04$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $b8e1e9b87c9c3e04$export$4cbf152802aa238(ecModel, newSnapshot) {
    var storedSnapshots = $b8e1e9b87c9c3e04$var$getStoreSnapshots(ecModel);
    // If previous dataZoom can not be found,
    // complete an range with current range.
    $b8e1e9b87c9c3e04$var$each(newSnapshot, function(batchItem, dataZoomId) {
        var i = storedSnapshots.length - 1;
        for(; i >= 0; i--){
            var snapshot = storedSnapshots[i];
            if (snapshot[dataZoomId]) break;
        }
        if (i < 0) {
            // No origin range set, create one by current range.
            var dataZoomModel = ecModel.queryComponents({
                mainType: 'dataZoom',
                subType: 'select',
                id: dataZoomId
            })[0];
            if (dataZoomModel) {
                var percentRange = dataZoomModel.getPercentRange();
                storedSnapshots[0][dataZoomId] = {
                    dataZoomId: dataZoomId,
                    start: percentRange[0],
                    end: percentRange[1]
                };
            }
        }
    });
    storedSnapshots.push(newSnapshot);
}
function $b8e1e9b87c9c3e04$export$3e41007ebfff0e64(ecModel) {
    var storedSnapshots = $b8e1e9b87c9c3e04$var$getStoreSnapshots(ecModel);
    var head = storedSnapshots[storedSnapshots.length - 1];
    storedSnapshots.length > 1 && storedSnapshots.pop();
    // Find top for all dataZoom.
    var snapshot = {};
    $b8e1e9b87c9c3e04$var$each(head, function(batchItem, dataZoomId) {
        for(var i = storedSnapshots.length - 1; i >= 0; i--){
            batchItem = storedSnapshots[i][dataZoomId];
            if (batchItem) {
                snapshot[dataZoomId] = batchItem;
                break;
            }
        }
    });
    return snapshot;
}
function $b8e1e9b87c9c3e04$export$42ffd38884aecdac(ecModel) {
    $b8e1e9b87c9c3e04$var$inner(ecModel).snapshots = null;
}
function $b8e1e9b87c9c3e04$export$85b9a36db797e02b(ecModel) {
    return $b8e1e9b87c9c3e04$var$getStoreSnapshots(ecModel).length;
}
/**
 * History length of each dataZoom may be different.
 * this._history[0] is used to store origin range.
 */ function $b8e1e9b87c9c3e04$var$getStoreSnapshots(ecModel) {
    var store = $b8e1e9b87c9c3e04$var$inner(ecModel);
    if (!store.snapshots) store.snapshots = [
        {}
    ];
    return store.snapshots;
}



var $2d7774ad89fb2efa$var$RestoreOption = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(RestoreOption, _super);
    function RestoreOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestoreOption.prototype.onclick = function(ecModel, api) {
        $b8e1e9b87c9c3e04$export$42ffd38884aecdac(ecModel);
        api.dispatchAction({
            type: 'restore',
            from: this.uid
        });
    };
    RestoreOption.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            // eslint-disable-next-line
            icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'restore',
                'title'
            ])
        };
        return defaultOption;
    };
    return RestoreOption;
}((0, $0a908f01d9563844$export$1426bfb1b0bcf539));
// TODO: SELF REGISTERED.
$b45c5a9506b77a4f$export$408c24786cd729c6({
    type: 'restore',
    event: 'restore',
    update: 'prepareAndUpdate'
}, function(payload, ecModel) {
    ecModel.resetOption('recreate');
});
var $2d7774ad89fb2efa$export$2e2bcd8739ae039 = $2d7774ad89fb2efa$var$RestoreOption;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



// FIXME
// how to genarialize to more coordinate systems.
var $2964360305142861$var$INCLUDE_FINDER_MAIN_TYPES = [
    'grid',
    'xAxis',
    'yAxis',
    'geo',
    'graph',
    'polar',
    'radiusAxis',
    'angleAxis',
    'bmap'
];
var $2964360305142861$var$BrushTargetManager = /** @class */ function() {
    /**
   * @param finder contains Index/Id/Name of xAxis/yAxis/geo/grid
   *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
   * @param opt.include include coordinate system types.
   */ function BrushTargetManager(finder, ecModel, opt) {
        var _this = this;
        this._targetInfoList = [];
        var foundCpts = $2964360305142861$var$parseFinder(ecModel, finder);
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)($2964360305142861$var$targetInfoBuilders, function(builder, type) {
            if (!opt || !opt.include || (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(opt.include, type) >= 0) builder(foundCpts, _this._targetInfoList);
        });
    }
    BrushTargetManager.prototype.setOutputRanges = function(areas, ecModel) {
        this.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            (area.coordRanges || (area.coordRanges = [])).push(coordRange);
            // area.coordRange is the first of area.coordRanges
            if (!area.coordRange) {
                area.coordRange = coordRange;
                // In 'category' axis, coord to pixel is not reversible, so we can not
                // rebuild range by coordRange accrately, which may bring trouble when
                // brushing only one item. So we use __rangeOffset to rebuilding range
                // by coordRange. And this it only used in brush component so it is no
                // need to be adapted to coordRanges.
                var result = $2964360305142861$var$coordConvert[area.brushType](0, coordSys, coordRange);
                area.__rangeOffset = {
                    offset: $2964360305142861$var$diffProcessor[area.brushType](result.values, area.range, [
                        1,
                        1
                    ]),
                    xyMinMax: result.xyMinMax
                };
            }
        });
        return areas;
    };
    BrushTargetManager.prototype.matchOutputRanges = function(areas, ecModel, cb) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            if (targetInfo && targetInfo !== true) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(targetInfo.coordSyses, function(coordSys) {
                var result = $2964360305142861$var$coordConvert[area.brushType](1, coordSys, area.range, true);
                cb(area, result.values, coordSys, ecModel);
            });
        }, this);
    };
    /**
   * the `areas` is `BrushModel.areas`.
   * Called in layout stage.
   * convert `area.coordRange` to global range and set panelId to `area.range`.
   */ BrushTargetManager.prototype.setInputRanges = function(areas, ecModel) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(areas, function(area) {
            var targetInfo = this.findTargetInfo(area, ecModel);
            area.range = area.range || [];
            // convert coordRange to global range and set panelId.
            if (targetInfo && targetInfo !== true) {
                area.panelId = targetInfo.panelId;
                // (1) area.range should always be calculate from coordRange but does
                // not keep its original value, for the sake of the dataZoom scenario,
                // where area.coordRange remains unchanged but area.range may be changed.
                // (2) Only support converting one coordRange to pixel range in brush
                // component. So do not consider `coordRanges`.
                // (3) About __rangeOffset, see comment above.
                var result = $2964360305142861$var$coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
                var rangeOffset = area.__rangeOffset;
                area.range = rangeOffset ? $2964360305142861$var$diffProcessor[area.brushType](result.values, rangeOffset.offset, $2964360305142861$var$getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
            }
        }, this);
    };
    BrushTargetManager.prototype.makePanelOpts = function(api, getDefaultBrushType) {
        return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(this._targetInfoList, function(targetInfo) {
            var rect = targetInfo.getPanelRect();
            return {
                panelId: targetInfo.panelId,
                defaultBrushType: getDefaultBrushType ? getDefaultBrushType(targetInfo) : null,
                clipPath: $1b1a2d237741e26c$export$fee17964a62a87a7(rect),
                isTargetByCursor: $1b1a2d237741e26c$export$e63e66b3b18aa99f(rect, api, targetInfo.coordSysModel),
                getLinearBrushOtherExtent: $1b1a2d237741e26c$export$7280070e90fad7a0(rect)
            };
        });
    };
    BrushTargetManager.prototype.controlSeries = function(area, seriesModel, ecModel) {
        // Check whether area is bound in coord, and series do not belong to that coord.
        // If do not do this check, some brush (like lineX) will controll all axes.
        var targetInfo = this.findTargetInfo(area, ecModel);
        return targetInfo === true || targetInfo && (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
    };
    /**
   * If return Object, a coord found.
   * If return true, global found.
   * Otherwise nothing found.
   */ BrushTargetManager.prototype.findTargetInfo = function(area, ecModel) {
        var targetInfoList = this._targetInfoList;
        var foundCpts = $2964360305142861$var$parseFinder(ecModel, area);
        for(var i = 0; i < targetInfoList.length; i++){
            var targetInfo = targetInfoList[i];
            var areaPanelId = area.panelId;
            if (areaPanelId) {
                if (targetInfo.panelId === areaPanelId) return targetInfo;
            } else for(var j = 0; j < $2964360305142861$var$targetInfoMatchers.length; j++){
                if ($2964360305142861$var$targetInfoMatchers[j](foundCpts, targetInfo)) return targetInfo;
            }
        }
        return true;
    };
    return BrushTargetManager;
}();
function $2964360305142861$var$formatMinMax(minMax) {
    minMax[0] > minMax[1] && minMax.reverse();
    return minMax;
}
function $2964360305142861$var$parseFinder(ecModel, finder) {
    return (0, $9ac03c46e8b6e711$export$95de80076abac814)(ecModel, finder, {
        includeMainTypes: $2964360305142861$var$INCLUDE_FINDER_MAIN_TYPES
    });
}
var $2964360305142861$var$targetInfoBuilders = {
    grid: function(foundCpts, targetInfoList) {
        var xAxisModels = foundCpts.xAxisModels;
        var yAxisModels = foundCpts.yAxisModels;
        var gridModels = foundCpts.gridModels;
        // Remove duplicated.
        var gridModelMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
        var xAxesHas = {};
        var yAxesHas = {};
        if (!xAxisModels && !yAxisModels && !gridModels) return;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(xAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
        });
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(yAxisModels, function(axisModel) {
            var gridModel = axisModel.axis.grid.model;
            gridModelMap.set(gridModel.id, gridModel);
            yAxesHas[gridModel.id] = true;
        });
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(gridModels, function(gridModel) {
            gridModelMap.set(gridModel.id, gridModel);
            xAxesHas[gridModel.id] = true;
            yAxesHas[gridModel.id] = true;
        });
        gridModelMap.each(function(gridModel) {
            var grid = gridModel.coordinateSystem;
            var cartesians = [];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(grid.getCartesians(), function(cartesian, index) {
                if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(xAxisModels, cartesian.getAxis('x').model) >= 0 || (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(yAxisModels, cartesian.getAxis('y').model) >= 0) cartesians.push(cartesian);
            });
            targetInfoList.push({
                panelId: 'grid--' + gridModel.id,
                gridModel: gridModel,
                coordSysModel: gridModel,
                // Use the first one as the representitive coordSys.
                coordSys: cartesians[0],
                coordSyses: cartesians,
                getPanelRect: $2964360305142861$var$panelRectBuilders.grid,
                xAxisDeclared: xAxesHas[gridModel.id],
                yAxisDeclared: yAxesHas[gridModel.id]
            });
        });
    },
    geo: function(foundCpts, targetInfoList) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(foundCpts.geoModels, function(geoModel) {
            var coordSys = geoModel.coordinateSystem;
            targetInfoList.push({
                panelId: 'geo--' + geoModel.id,
                geoModel: geoModel,
                coordSysModel: geoModel,
                coordSys: coordSys,
                coordSyses: [
                    coordSys
                ],
                getPanelRect: $2964360305142861$var$panelRectBuilders.geo
            });
        });
    }
};
var $2964360305142861$var$targetInfoMatchers = [
    // grid
    function(foundCpts, targetInfo) {
        var xAxisModel = foundCpts.xAxisModel;
        var yAxisModel = foundCpts.yAxisModel;
        var gridModel = foundCpts.gridModel;
        !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
        !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
        return gridModel && gridModel === targetInfo.gridModel;
    },
    // geo
    function(foundCpts, targetInfo) {
        var geoModel = foundCpts.geoModel;
        return geoModel && geoModel === targetInfo.geoModel;
    }
];
var $2964360305142861$var$panelRectBuilders = {
    grid: function() {
        // grid is not Transformable.
        return this.coordSys.master.getRect().clone();
    },
    geo: function() {
        var coordSys = this.coordSys;
        var rect = coordSys.getBoundingRect().clone();
        // geo roam and zoom transform
        rect.applyTransform($8eb95236e1aa01e7$export$fce0c6cfca85ed96(coordSys));
        return rect;
    }
};
var $2964360305142861$var$coordConvert = {
    lineX: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($2964360305142861$var$axisConvert, 0),
    lineY: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($2964360305142861$var$axisConvert, 1),
    rect: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xminymin = to ? coordSys.pointToData([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][0],
            rangeOrCoordRange[1][0]
        ], clamp);
        var xmaxymax = to ? coordSys.pointToData([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp) : coordSys.dataToPoint([
            rangeOrCoordRange[0][1],
            rangeOrCoordRange[1][1]
        ], clamp);
        var values = [
            $2964360305142861$var$formatMinMax([
                xminymin[0],
                xmaxymax[0]
            ]),
            $2964360305142861$var$formatMinMax([
                xminymin[1],
                xmaxymax[1]
            ])
        ];
        return {
            values: values,
            xyMinMax: values
        };
    },
    polygon: function(to, coordSys, rangeOrCoordRange, clamp) {
        var xyMinMax = [
            [
                Infinity,
                -Infinity
            ],
            [
                Infinity,
                -Infinity
            ]
        ];
        var values = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(rangeOrCoordRange, function(item) {
            var p = to ? coordSys.pointToData(item, clamp) : coordSys.dataToPoint(item, clamp);
            xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
            xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
            xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
            xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
            return p;
        });
        return {
            values: values,
            xyMinMax: xyMinMax
        };
    }
};
function $2964360305142861$var$axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
    var axis = coordSys.getAxis([
        'x',
        'y'
    ][axisNameIndex]);
    var values = $2964360305142861$var$formatMinMax((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)([
        0,
        1
    ], function(i) {
        return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i]), true) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
    }));
    var xyMinMax = [];
    xyMinMax[axisNameIndex] = values;
    xyMinMax[1 - axisNameIndex] = [
        NaN,
        NaN
    ];
    return {
        values: values,
        xyMinMax: xyMinMax
    };
}
var $2964360305142861$var$diffProcessor = {
    lineX: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($2964360305142861$var$axisDiffProcessor, 0),
    lineY: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($2964360305142861$var$axisDiffProcessor, 1),
    rect: function(values, refer, scales) {
        return [
            [
                values[0][0] - scales[0] * refer[0][0],
                values[0][1] - scales[0] * refer[0][1]
            ],
            [
                values[1][0] - scales[1] * refer[1][0],
                values[1][1] - scales[1] * refer[1][1]
            ]
        ];
    },
    polygon: function(values, refer, scales) {
        return (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(values, function(item, idx) {
            return [
                item[0] - scales[0] * refer[idx][0],
                item[1] - scales[1] * refer[idx][1]
            ];
        });
    }
};
function $2964360305142861$var$axisDiffProcessor(axisNameIndex, values, refer, scales) {
    return [
        values[0] - scales[axisNameIndex] * refer[0],
        values[1] - scales[axisNameIndex] * refer[1]
    ];
}
// We have to process scale caused by dataZoom manually,
// although it might be not accurate.
// Return [0~1, 0~1]
function $2964360305142861$var$getScales(xyMinMaxCurr, xyMinMaxOrigin) {
    var sizeCurr = $2964360305142861$var$getSize(xyMinMaxCurr);
    var sizeOrigin = $2964360305142861$var$getSize(xyMinMaxOrigin);
    var scales = [
        sizeCurr[0] / sizeOrigin[0],
        sizeCurr[1] / sizeOrigin[1]
    ];
    isNaN(scales[0]) && (scales[0] = 1);
    isNaN(scales[1]) && (scales[1] = 1);
    return scales;
}
function $2964360305142861$var$getSize(xyMinMax) {
    return xyMinMax ? [
        xyMinMax[0][1] - xyMinMax[0][0],
        xyMinMax[1][1] - xyMinMax[1][0]
    ] : [
        NaN,
        NaN
    ];
}
var $2964360305142861$export$2e2bcd8739ae039 = $2964360305142861$var$BrushTargetManager;







var $f1f10e4c4d162dfb$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $f1f10e4c4d162dfb$var$DATA_ZOOM_ID_BASE = (0, $9ac03c46e8b6e711$export$1753133c42e665e8)('toolbox-dataZoom_');
var $f1f10e4c4d162dfb$var$ICON_TYPES = [
    'zoom',
    'back'
];
var $f1f10e4c4d162dfb$var$DataZoomFeature = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(DataZoomFeature, _super);
    function DataZoomFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataZoomFeature.prototype.render = function(featureModel, ecModel, api, payload) {
        if (!this._brushController) {
            this._brushController = new (0, $f3dfc951a5a73cbe$export$2e2bcd8739ae039)(api.getZr());
            this._brushController.on('brush', $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._onBrush, this)).mount();
        }
        $f1f10e4c4d162dfb$var$updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
        $f1f10e4c4d162dfb$var$updateBackBtnStatus(featureModel, ecModel);
    };
    DataZoomFeature.prototype.onclick = function(ecModel, api, type) {
        $f1f10e4c4d162dfb$var$handlers[type].call(this);
    };
    DataZoomFeature.prototype.remove = function(ecModel, api) {
        this._brushController && this._brushController.unmount();
    };
    DataZoomFeature.prototype.dispose = function(ecModel, api) {
        this._brushController && this._brushController.dispose();
    };
    DataZoomFeature.prototype._onBrush = function(eventParam) {
        var areas = eventParam.areas;
        if (!eventParam.isEnd || !areas.length) return;
        var snapshot = {};
        var ecModel = this.ecModel;
        this._brushController.updateCovers([]); // remove cover
        var brushTargetManager = new (0, $2964360305142861$export$2e2bcd8739ae039)($f1f10e4c4d162dfb$var$makeAxisFinder(this.model), ecModel, {
            include: [
                'grid'
            ]
        });
        brushTargetManager.matchOutputRanges(areas, ecModel, function(area, coordRange, coordSys) {
            if (coordSys.type !== 'cartesian2d') return;
            var brushType = area.brushType;
            if (brushType === 'rect') {
                setBatch('x', coordSys, coordRange[0]);
                setBatch('y', coordSys, coordRange[1]);
            } else setBatch({
                lineX: 'x',
                lineY: 'y'
            }[brushType], coordSys, coordRange);
        });
        $b8e1e9b87c9c3e04$export$4cbf152802aa238(ecModel, snapshot);
        this._dispatchZoomAction(snapshot);
        function setBatch(dimName, coordSys, minMax) {
            var axis = coordSys.getAxis(dimName);
            var axisModel = axis.model;
            var dataZoomModel = findDataZoom(dimName, axisModel, ecModel);
            // Restrict range.
            var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
            if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) minMax = (0, $15a7158def1e4179$export$2e2bcd8739ae039)(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
            dataZoomModel && (snapshot[dataZoomModel.id] = {
                dataZoomId: dataZoomModel.id,
                startValue: minMax[0],
                endValue: minMax[1]
            });
        }
        function findDataZoom(dimName, axisModel, ecModel) {
            var found;
            ecModel.eachComponent({
                mainType: 'dataZoom',
                subType: 'select'
            }, function(dzModel) {
                var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
                has && (found = dzModel);
            });
            return found;
        }
    };
    DataZoomFeature.prototype._dispatchZoomAction = function(snapshot) {
        var batch = [];
        // Convert from hash map to array.
        $f1f10e4c4d162dfb$var$each(snapshot, function(batchItem, dataZoomId) {
            batch.push($1b239fc9d3a2f8ae$export$9cd59f9826255e47(batchItem));
        });
        batch.length && this.api.dispatchAction({
            type: 'dataZoom',
            from: this.uid,
            batch: batch
        });
    };
    DataZoomFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            filterMode: 'filter',
            // Icon group
            icon: {
                zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
                back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
            },
            // `zoom`, `back`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'dataZoom',
                'title'
            ]),
            brushStyle: {
                borderWidth: 0,
                color: 'rgba(210,219,238,0.2)'
            }
        };
        return defaultOption;
    };
    return DataZoomFeature;
}((0, $0a908f01d9563844$export$1426bfb1b0bcf539));
var $f1f10e4c4d162dfb$var$handlers = {
    zoom: function() {
        var nextActive = !this._isZoomActive;
        this.api.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'dataZoomSelect',
            dataZoomSelectActive: nextActive
        });
    },
    back: function() {
        this._dispatchZoomAction($b8e1e9b87c9c3e04$export$3e41007ebfff0e64(this.ecModel));
    }
};
function $f1f10e4c4d162dfb$var$makeAxisFinder(dzFeatureModel) {
    var setting = {
        xAxisIndex: dzFeatureModel.get('xAxisIndex', true),
        yAxisIndex: dzFeatureModel.get('yAxisIndex', true),
        xAxisId: dzFeatureModel.get('xAxisId', true),
        yAxisId: dzFeatureModel.get('yAxisId', true)
    };
    // If both `xAxisIndex` `xAxisId` not set, it means 'all'.
    // If both `yAxisIndex` `yAxisId` not set, it means 'all'.
    // Some old cases set like this below to close yAxis control but leave xAxis control:
    // `{ feature: { dataZoom: { yAxisIndex: false } }`.
    if (setting.xAxisIndex == null && setting.xAxisId == null) setting.xAxisIndex = 'all';
    if (setting.yAxisIndex == null && setting.yAxisId == null) setting.yAxisIndex = 'all';
    return setting;
}
function $f1f10e4c4d162dfb$var$updateBackBtnStatus(featureModel, ecModel) {
    featureModel.setIconStatus('back', $b8e1e9b87c9c3e04$export$85b9a36db797e02b(ecModel) > 1 ? 'emphasis' : 'normal');
}
function $f1f10e4c4d162dfb$var$updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
    var zoomActive = view._isZoomActive;
    if (payload && payload.type === 'takeGlobalCursor') zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
    view._isZoomActive = zoomActive;
    featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
    var brushTargetManager = new (0, $2964360305142861$export$2e2bcd8739ae039)($f1f10e4c4d162dfb$var$makeAxisFinder(featureModel), ecModel, {
        include: [
            'grid'
        ]
    });
    var panels = brushTargetManager.makePanelOpts(api, function(targetInfo) {
        return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
    });
    view._brushController.setPanels(panels).enableBrush(zoomActive && panels.length ? {
        brushType: 'auto',
        brushStyle: featureModel.getModel('brushStyle').getItemStyle()
    } : false);
}
(0, $deee41f242222a3b$export$5a90be4668898d38)('dataZoom', function(ecModel) {
    var toolboxModel = ecModel.getComponent('toolbox', 0);
    var featureDataZoomPath = [
        'feature',
        'dataZoom'
    ];
    if (!toolboxModel || toolboxModel.get(featureDataZoomPath) == null) return;
    var dzFeatureModel = toolboxModel.getModel(featureDataZoomPath);
    var dzOptions = [];
    var finder = $f1f10e4c4d162dfb$var$makeAxisFinder(dzFeatureModel);
    var finderResult = (0, $9ac03c46e8b6e711$export$95de80076abac814)(ecModel, finder);
    $f1f10e4c4d162dfb$var$each(finderResult.xAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, 'xAxis', 'xAxisIndex');
    });
    $f1f10e4c4d162dfb$var$each(finderResult.yAxisModels, function(axisModel) {
        return buildInternalOptions(axisModel, 'yAxis', 'yAxisIndex');
    });
    function buildInternalOptions(axisModel, axisMainType, axisIndexPropName) {
        var axisIndex = axisModel.componentIndex;
        var newOpt = {
            type: 'select',
            $fromToolbox: true,
            // Default to be filter
            filterMode: dzFeatureModel.get('filterMode', true) || 'filter',
            // Id for merge mapping.
            id: $f1f10e4c4d162dfb$var$DATA_ZOOM_ID_BASE + axisMainType + axisIndex
        };
        newOpt[axisIndexPropName] = axisIndex;
        dzOptions.push(newOpt);
    }
    return dzOptions;
});
var $f1f10e4c4d162dfb$export$2e2bcd8739ae039 = $f1f10e4c4d162dfb$var$DataZoomFeature;


function $3b2428b047d0a41e$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $c6aa3f3586db4ceb$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $b5030b047c964655$export$2e2bcd8739ae039));
    (0, $0a908f01d9563844$export$c6213a6f247cf906)('saveAsImage', (0, $1b54c0bd59a42a63$export$2e2bcd8739ae039));
    (0, $0a908f01d9563844$export$c6213a6f247cf906)('magicType', (0, $4e0939f0cb62f0bd$export$2e2bcd8739ae039));
    (0, $0a908f01d9563844$export$c6213a6f247cf906)('dataView', (0, $752176b90ee5d2f1$export$2e2bcd8739ae039));
    (0, $0a908f01d9563844$export$c6213a6f247cf906)('dataZoom', (0, $f1f10e4c4d162dfb$export$2e2bcd8739ae039));
    (0, $0a908f01d9563844$export$c6213a6f247cf906)('restore', (0, $2d7774ad89fb2efa$export$2e2bcd8739ae039));
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $57d47011456b0986$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $319b16d47b957103$var$TooltipModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TooltipModel, _super);
    function TooltipModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipModel.type;
        return _this;
    }
    TooltipModel.type = 'tooltip';
    TooltipModel.dependencies = [
        'axisPointer'
    ];
    TooltipModel.defaultOption = {
        // zlevel: 0,
        z: 60,
        show: true,
        // tooltip main content
        showContent: true,
        // 'trigger' only works on coordinate system.
        // 'item' | 'axis' | 'none'
        trigger: 'item',
        // 'click' | 'mousemove' | 'none'
        triggerOn: 'mousemove|click',
        alwaysShowContent: false,
        displayMode: 'single',
        renderMode: 'auto',
        // whether restraint content inside viewRect.
        // If renderMode: 'richText', default true.
        // If renderMode: 'html', defaut false (for backward compat).
        confine: null,
        showDelay: 0,
        hideDelay: 100,
        // Animation transition time, unit is second
        transitionDuration: 0.4,
        enterable: false,
        backgroundColor: '#fff',
        // box shadow
        shadowBlur: 10,
        shadowColor: 'rgba(0, 0, 0, .2)',
        shadowOffsetX: 1,
        shadowOffsetY: 2,
        // tooltip border radius, unit is px, default is 4
        borderRadius: 4,
        // tooltip border width, unit is px, default is 0 (no border)
        borderWidth: 1,
        // Tooltip inside padding, default is 5 for all direction
        // Array is allowed to set up, right, bottom, left, same with css
        // The default value: See `tooltip/tooltipMarkup.ts#getPaddingFromTooltipModel`.
        padding: null,
        // Extra css text
        extraCssText: '',
        // axis indicator, trigger by axis
        axisPointer: {
            // default is line
            // legal values: 'line' | 'shadow' | 'cross'
            type: 'line',
            // Valid when type is line, appoint tooltip line locate on which line. Optional
            // legal values: 'x' | 'y' | 'angle' | 'radius' | 'auto'
            // default is 'auto', chose the axis which type is category.
            // for multiply y axis, cartesian coord chose x axis, polar chose angle axis
            axis: 'auto',
            animation: 'auto',
            animationDurationUpdate: 200,
            animationEasingUpdate: 'exponentialOut',
            crossStyle: {
                color: '#999',
                width: 1,
                type: 'dashed',
                // TODO formatter
                textStyle: {}
            }
        },
        textStyle: {
            color: '#666',
            fontSize: 14
        }
    };
    return TooltipModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $319b16d47b957103$export$2e2bcd8739ae039 = $319b16d47b957103$var$TooltipModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

function $5e3fe82b07048e41$export$a309528050824ba4(tooltipModel) {
    var confineOption = tooltipModel.get('confine');
    return confineOption != null ? !!confineOption : tooltipModel.get('renderMode') === 'richText';
}
function $5e3fe82b07048e41$var$testStyle(styleProps) {
    if (!(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).domSupported) return;
    var style = document.documentElement.style;
    for(var i = 0, len = styleProps.length; i < len; i++){
        if (styleProps[i] in style) return styleProps[i];
    }
}
var $5e3fe82b07048e41$export$7b4286b1e4a23439 = $5e3fe82b07048e41$var$testStyle([
    'transform',
    'webkitTransform',
    'OTransform',
    'MozTransform',
    'msTransform'
]);
var $5e3fe82b07048e41$export$70a631ae991b5e76 = $5e3fe82b07048e41$var$testStyle([
    'webkitTransition',
    'transition',
    'OTransition',
    'MozTransition',
    'msTransition'
]);
function $5e3fe82b07048e41$export$5886acafe29a08d1(styleVendor, styleProp) {
    if (!styleVendor) return styleProp;
    styleProp = (0, $ff2fba995230f3c9$export$86f54f62aa7a7514)(styleProp, true);
    var idx = styleVendor.indexOf(styleProp);
    styleVendor = idx === -1 ? styleProp : "-" + styleVendor.slice(0, idx) + "-" + styleProp;
    return styleVendor.toLowerCase();
}
function $5e3fe82b07048e41$export$3735103072e4a80(el, style) {
    var stl = el.currentStyle || document.defaultView && document.defaultView.getComputedStyle(el);
    return stl ? style ? stl[style] : stl : null;
}



/* global document, window */ var $0d2b6abd94bfee1b$var$CSS_TRANSITION_VENDOR = (0, $5e3fe82b07048e41$export$5886acafe29a08d1)((0, $5e3fe82b07048e41$export$70a631ae991b5e76), 'transition');
var $0d2b6abd94bfee1b$var$CSS_TRANSFORM_VENDOR = (0, $5e3fe82b07048e41$export$5886acafe29a08d1)((0, $5e3fe82b07048e41$export$7b4286b1e4a23439), 'transform');
// eslint-disable-next-line
var $0d2b6abd94bfee1b$var$gCssText = "position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;" + ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).transform3dSupported ? 'will-change:transform;' : '');
function $0d2b6abd94bfee1b$var$mirrorPos(pos) {
    pos = pos === 'left' ? 'right' : pos === 'right' ? 'left' : pos === 'top' ? 'bottom' : 'top';
    return pos;
}
function $0d2b6abd94bfee1b$var$assembleArrow(tooltipModel, borderColor, arrowPosition) {
    if (!(0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(arrowPosition) || arrowPosition === 'inside') return '';
    var backgroundColor = tooltipModel.get('backgroundColor');
    var borderWidth = tooltipModel.get('borderWidth');
    borderColor = (0, $ff2fba995230f3c9$export$cda04d03233e5555)(borderColor);
    var arrowPos = $0d2b6abd94bfee1b$var$mirrorPos(arrowPosition);
    var arrowSize = Math.max(Math.round(borderWidth) * 1.5, 6);
    var positionStyle = '';
    var transformStyle = $0d2b6abd94bfee1b$var$CSS_TRANSFORM_VENDOR + ':';
    var rotateDeg;
    if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)([
        'left',
        'right'
    ], arrowPos) > -1) {
        positionStyle += 'top:50%';
        transformStyle += "translateY(-50%) rotate(" + (rotateDeg = arrowPos === 'left' ? -225 : -45) + "deg)";
    } else {
        positionStyle += 'left:50%';
        transformStyle += "translateX(-50%) rotate(" + (rotateDeg = arrowPos === 'top' ? 225 : 45) + "deg)";
    }
    var rotateRadian = rotateDeg * Math.PI / 180;
    var arrowWH = arrowSize + borderWidth;
    var rotatedWH = arrowWH * Math.abs(Math.cos(rotateRadian)) + arrowWH * Math.abs(Math.sin(rotateRadian));
    var arrowOffset = Math.round(((rotatedWH - Math.SQRT2 * borderWidth) / 2 + Math.SQRT2 * borderWidth - (rotatedWH - arrowWH) / 2) * 100) / 100;
    positionStyle += ";" + arrowPos + ":-" + arrowOffset + "px";
    var borderStyle = borderColor + " solid " + borderWidth + "px;";
    var styleCss = [
        "position:absolute;width:" + arrowSize + "px;height:" + arrowSize + "px;z-index:-1;",
        positionStyle + ";" + transformStyle + ";",
        "border-bottom:" + borderStyle,
        "border-right:" + borderStyle,
        "background-color:" + backgroundColor + ";"
    ];
    return "<div style=\"" + styleCss.join('') + "\"></div>";
}
function $0d2b6abd94bfee1b$var$assembleTransition(duration, onlyFade) {
    var transitionCurve = 'cubic-bezier(0.23,1,0.32,1)';
    var transitionOption = " " + duration / 2 + "s " + transitionCurve;
    var transitionText = "opacity" + transitionOption + ",visibility" + transitionOption;
    if (!onlyFade) {
        transitionOption = " " + duration + "s " + transitionCurve;
        transitionText += (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).transformSupported ? "," + $0d2b6abd94bfee1b$var$CSS_TRANSFORM_VENDOR + transitionOption : ",left" + transitionOption + ",top" + transitionOption;
    }
    return $0d2b6abd94bfee1b$var$CSS_TRANSITION_VENDOR + ':' + transitionText;
}
function $0d2b6abd94bfee1b$var$assembleTransform(x, y, toString) {
    // If using float on style, the final width of the dom might
    // keep changing slightly while mouse move. So `toFixed(0)` them.
    var x0 = x.toFixed(0) + 'px';
    var y0 = y.toFixed(0) + 'px';
    // not support transform, use `left` and `top` instead.
    if (!(0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).transformSupported) return toString ? "top:" + y0 + ";left:" + x0 + ";" : [
        [
            'top',
            y0
        ],
        [
            'left',
            x0
        ]
    ];
    // support transform
    var is3d = (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).transform3dSupported;
    var translate = "translate" + (is3d ? '3d' : '') + "(" + x0 + "," + y0 + (is3d ? ',0' : '') + ")";
    return toString ? 'top:0;left:0;' + $0d2b6abd94bfee1b$var$CSS_TRANSFORM_VENDOR + ':' + translate + ';' : [
        [
            'top',
            0
        ],
        [
            'left',
            0
        ],
        [
            (0, $5e3fe82b07048e41$export$7b4286b1e4a23439),
            translate
        ]
    ];
}
/**
 * @param {Object} textStyle
 * @return {string}
 * @inner
 */ function $0d2b6abd94bfee1b$var$assembleFont(textStyleModel) {
    var cssText = [];
    var fontSize = textStyleModel.get('fontSize');
    var color = textStyleModel.getTextColor();
    color && cssText.push('color:' + color);
    cssText.push('font:' + textStyleModel.getFont());
    // @ts-ignore, leave it to the tooltip refactor.
    var lineHeight = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textStyleModel.get('lineHeight'), Math.round(fontSize * 3 / 2));
    fontSize && cssText.push('line-height:' + lineHeight + 'px');
    var shadowColor = textStyleModel.get('textShadowColor');
    var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
    var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
    var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
    shadowColor && shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        'decoration',
        'align'
    ], function(name) {
        var val = textStyleModel.get(name);
        val && cssText.push('text-' + name + ':' + val);
    });
    return cssText.join(';');
}
function $0d2b6abd94bfee1b$var$assembleCssText(tooltipModel, enableTransition, onlyFade) {
    var cssText = [];
    var transitionDuration = tooltipModel.get('transitionDuration');
    var backgroundColor = tooltipModel.get('backgroundColor');
    var shadowBlur = tooltipModel.get('shadowBlur');
    var shadowColor = tooltipModel.get('shadowColor');
    var shadowOffsetX = tooltipModel.get('shadowOffsetX');
    var shadowOffsetY = tooltipModel.get('shadowOffsetY');
    var textStyleModel = tooltipModel.getModel('textStyle');
    var padding = (0, $6ceb7d0f0435c9d1$export$3048212c802df496)(tooltipModel, 'html');
    var boxShadow = shadowOffsetX + "px " + shadowOffsetY + "px " + shadowBlur + "px " + shadowColor;
    cssText.push('box-shadow:' + boxShadow);
    // Animation transition. Do not animate when transitionDuration is 0.
    enableTransition && transitionDuration && cssText.push($0d2b6abd94bfee1b$var$assembleTransition(transitionDuration, onlyFade));
    if (backgroundColor) cssText.push('background-color:' + backgroundColor);
    // Border style
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        'width',
        'color',
        'radius'
    ], function(name) {
        var borderName = 'border-' + name;
        var camelCase = (0, $ff2fba995230f3c9$export$86f54f62aa7a7514)(borderName);
        var val = tooltipModel.get(camelCase);
        val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
    });
    // Text style
    cssText.push($0d2b6abd94bfee1b$var$assembleFont(textStyleModel));
    // Padding
    if (padding != null) cssText.push('padding:' + (0, $ff2fba995230f3c9$export$f3a38102c49f4268)(padding).join('px ') + 'px');
    return cssText.join(';') + ';';
}
// If not able to make, do not modify the input `out`.
function $0d2b6abd94bfee1b$var$makeStyleCoord(out, zr, container, zrX, zrY) {
    var zrPainter = zr && zr.painter;
    if (container) {
        var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
        if (zrViewportRoot) // Some APPs might use scale on body, so we support CSS transform here.
        (0, $8032584326d71745$export$8c5c02e118307e20)(out, zrViewportRoot, container, zrX, zrY);
    } else {
        out[0] = zrX;
        out[1] = zrY;
        // xy should be based on canvas root. But tooltipContent is
        // the sibling of canvas root. So padding of ec container
        // should be considered here.
        var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
        if (viewportRootOffset) {
            out[0] += viewportRootOffset.offsetLeft;
            out[1] += viewportRootOffset.offsetTop;
        }
    }
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $0d2b6abd94bfee1b$var$TooltipHTMLContent = /** @class */ function() {
    function TooltipHTMLContent(api, opt) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._enterable = true;
        this._alwaysShowContent = false;
        this._firstShow = true;
        this._longHide = true;
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).wxa) return null;
        var el = document.createElement('div');
        // TODO: TYPE
        el.domBelongToZr = true;
        this.el = el;
        var zr = this._zr = api.getZr();
        var appendTo = opt.appendTo;
        var container = appendTo && ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(appendTo) ? document.querySelector(appendTo) : (0, $1b239fc9d3a2f8ae$export$9f57505b7bd8dae)(appendTo) ? appendTo : (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(appendTo) && appendTo(api.getDom()));
        $0d2b6abd94bfee1b$var$makeStyleCoord(this._styleCoord, zr, container, api.getWidth() / 2, api.getHeight() / 2);
        (container || api.getDom()).appendChild(el);
        this._api = api;
        this._container = container;
        // FIXME
        // Is it needed to trigger zr event manually if
        // the browser do not support `pointer-events: none`.
        var self = this;
        el.onmouseenter = function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        };
        el.onmousemove = function(e) {
            e = e || window.event;
            if (!self._enterable) {
                // `pointer-events: none` is set to tooltip content div
                // if `enterable` is set as `false`, and `el.onmousemove`
                // can not be triggered. But in browser that do not
                // support `pointer-events`, we need to do this:
                // Try trigger zrender event to avoid mouse
                // in and out shape too frequently
                var handler = zr.handler;
                var zrViewportRoot = zr.painter.getViewportRoot();
                (0, $8f7ba7c16ab1583e$export$40fadb093aebad71)(zrViewportRoot, e, true);
                handler.dispatch('mousemove', e);
            }
        };
        el.onmouseleave = function() {
            // set `_inContent` to `false` before `hideLater`
            self._inContent = false;
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
        };
    }
    /**
   * Update when tooltip is rendered
   */ TooltipHTMLContent.prototype.update = function(tooltipModel) {
        // FIXME
        // Move this logic to ec main?
        if (!this._container) {
            var container = this._api.getDom();
            var position = (0, $5e3fe82b07048e41$export$3735103072e4a80)(container, 'position');
            var domStyle = container.style;
            if (domStyle.position !== 'absolute' && position !== 'absolute') domStyle.position = 'relative';
        }
        // move tooltip if chart resized
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
        // update className
        this.el.className = tooltipModel.get('className') || '';
    // Hide the tooltip
    // PENDING
    // this.hide();
    };
    TooltipHTMLContent.prototype.show = function(tooltipModel, nearPointColor) {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var el = this.el;
        var style = el.style;
        var styleCoord = this._styleCoord;
        if (!el.innerHTML) style.display = 'none';
        else style.cssText = $0d2b6abd94bfee1b$var$gCssText + $0d2b6abd94bfee1b$var$assembleCssText(tooltipModel, !this._firstShow, this._longHide) + $0d2b6abd94bfee1b$var$assembleTransform(styleCoord[0], styleCoord[1], true) + ("border-color:" + (0, $ff2fba995230f3c9$export$cda04d03233e5555)(nearPointColor) + ";") + (tooltipModel.get('extraCssText') || '') + (";pointer-events:" + (this._enterable ? 'auto' : 'none'));
        this._show = true;
        this._firstShow = false;
        this._longHide = false;
    };
    TooltipHTMLContent.prototype.setContent = function(content, markers, tooltipModel, borderColor, arrowPosition) {
        var el = this.el;
        if (content == null) {
            el.innerHTML = '';
            return;
        }
        var arrow = '';
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(arrowPosition) && tooltipModel.get('trigger') === 'item' && !(0, $5e3fe82b07048e41$export$a309528050824ba4)(tooltipModel)) arrow = $0d2b6abd94bfee1b$var$assembleArrow(tooltipModel, borderColor, arrowPosition);
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(content)) el.innerHTML = content + arrow;
        else if (content) {
            // Clear previous
            el.innerHTML = '';
            if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(content)) content = [
                content
            ];
            for(var i = 0; i < content.length; i++)if ((0, $1b239fc9d3a2f8ae$export$9f57505b7bd8dae)(content[i]) && content[i].parentNode !== el) el.appendChild(content[i]);
            // no arrow if empty
            if (arrow && el.childNodes.length) {
                // no need to create a new parent element, but it's not supported by IE 10 and older.
                // const arrowEl = document.createRange().createContextualFragment(arrow);
                var arrowEl = document.createElement('div');
                arrowEl.innerHTML = arrow;
                el.appendChild(arrowEl);
            }
        }
    };
    TooltipHTMLContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipHTMLContent.prototype.getSize = function() {
        var el = this.el;
        return el ? [
            el.offsetWidth,
            el.offsetHeight
        ] : [
            0,
            0
        ];
    };
    TooltipHTMLContent.prototype.moveTo = function(zrX, zrY) {
        if (!this.el) return;
        var styleCoord = this._styleCoord;
        $0d2b6abd94bfee1b$var$makeStyleCoord(styleCoord, this._zr, this._container, zrX, zrY);
        if (styleCoord[0] != null && styleCoord[1] != null) {
            var style_1 = this.el.style;
            var transforms = $0d2b6abd94bfee1b$var$assembleTransform(styleCoord[0], styleCoord[1]);
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(transforms, function(transform) {
                style_1[transform[0]] = transform[1];
            });
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipHTMLContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipHTMLContent.prototype.hide = function() {
        var _this = this;
        var style = this.el.style;
        style.visibility = 'hidden';
        style.opacity = '0';
        (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).transform3dSupported && (style.willChange = '');
        this._show = false;
        this._longHideTimeout = setTimeout(function() {
            return _this._longHide = true;
        }, 500);
    };
    TooltipHTMLContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout((0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipHTMLContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipHTMLContent.prototype.dispose = function() {
        clearTimeout(this._hideTimeout);
        clearTimeout(this._longHideTimeout);
        var parentNode = this.el.parentNode;
        parentNode && parentNode.removeChild(this.el);
        this.el = this._container = null;
    };
    return TooltipHTMLContent;
}();
var $0d2b6abd94bfee1b$export$2e2bcd8739ae039 = $0d2b6abd94bfee1b$var$TooltipHTMLContent;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $c23f83aa086ffc0c$var$TooltipRichContent = /** @class */ function() {
    function TooltipRichContent(api) {
        this._show = false;
        this._styleCoord = [
            0,
            0,
            0,
            0
        ];
        this._alwaysShowContent = false;
        this._enterable = true;
        this._zr = api.getZr();
        $c23f83aa086ffc0c$var$makeStyleCoord(this._styleCoord, this._zr, api.getWidth() / 2, api.getHeight() / 2);
    }
    /**
   * Update when tooltip is rendered
   */ TooltipRichContent.prototype.update = function(tooltipModel) {
        var alwaysShowContent = tooltipModel.get('alwaysShowContent');
        alwaysShowContent && this._moveIfResized();
        // update alwaysShowContent
        this._alwaysShowContent = alwaysShowContent;
    };
    TooltipRichContent.prototype.show = function() {
        if (this._hideTimeout) clearTimeout(this._hideTimeout);
        this.el.show();
        this._show = true;
    };
    /**
   * Set tooltip content
   */ TooltipRichContent.prototype.setContent = function(content, markupStyleCreator, tooltipModel, borderColor, arrowPosition) {
        var _this = this;
        if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(content)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)('');
        if (this.el) this._zr.remove(this.el);
        var textStyleModel = tooltipModel.getModel('textStyle');
        this.el = new (0, $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039)({
            style: {
                rich: markupStyleCreator.richTextStyles,
                text: content,
                lineHeight: 22,
                borderWidth: 1,
                borderColor: borderColor,
                textShadowColor: textStyleModel.get('textShadowColor'),
                fill: tooltipModel.get([
                    'textStyle',
                    'color'
                ]),
                padding: (0, $6ceb7d0f0435c9d1$export$3048212c802df496)(tooltipModel, 'richText'),
                verticalAlign: 'top',
                align: 'left'
            },
            z: tooltipModel.get('z')
        });
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
            'backgroundColor',
            'borderRadius',
            'shadowColor',
            'shadowBlur',
            'shadowOffsetX',
            'shadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = tooltipModel.get(propName);
        });
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
            'textShadowBlur',
            'textShadowOffsetX',
            'textShadowOffsetY'
        ], function(propName) {
            _this.el.style[propName] = textStyleModel.get(propName) || 0;
        });
        this._zr.add(this.el);
        var self = this;
        this.el.on('mouseover', function() {
            // clear the timeout in hideLater and keep showing tooltip
            if (self._enterable) {
                clearTimeout(self._hideTimeout);
                self._show = true;
            }
            self._inContent = true;
        });
        this.el.on('mouseout', function() {
            if (self._enterable) {
                if (self._show) self.hideLater(self._hideDelay);
            }
            self._inContent = false;
        });
    };
    TooltipRichContent.prototype.setEnterable = function(enterable) {
        this._enterable = enterable;
    };
    TooltipRichContent.prototype.getSize = function() {
        var el = this.el;
        var bounding = this.el.getBoundingRect();
        // bounding rect does not include shadow. For renderMode richText,
        // if overflow, it will be cut. So calculate them accurately.
        var shadowOuterSize = $c23f83aa086ffc0c$var$calcShadowOuterSize(el.style);
        return [
            bounding.width + shadowOuterSize.left + shadowOuterSize.right,
            bounding.height + shadowOuterSize.top + shadowOuterSize.bottom
        ];
    };
    TooltipRichContent.prototype.moveTo = function(x, y) {
        var el = this.el;
        if (el) {
            var styleCoord = this._styleCoord;
            $c23f83aa086ffc0c$var$makeStyleCoord(styleCoord, this._zr, x, y);
            x = styleCoord[0];
            y = styleCoord[1];
            var style = el.style;
            var borderWidth = $c23f83aa086ffc0c$var$mathMaxWith0(style.borderWidth || 0);
            var shadowOuterSize = $c23f83aa086ffc0c$var$calcShadowOuterSize(style);
            // rich text x, y do not include border.
            el.x = x + borderWidth + shadowOuterSize.left;
            el.y = y + borderWidth + shadowOuterSize.top;
            el.markRedraw();
        }
    };
    /**
   * when `alwaysShowContent` is true,
   * move the tooltip after chart resized
   */ TooltipRichContent.prototype._moveIfResized = function() {
        // The ratio of left to width
        var ratioX = this._styleCoord[2];
        // The ratio of top to height
        var ratioY = this._styleCoord[3];
        this.moveTo(ratioX * this._zr.getWidth(), ratioY * this._zr.getHeight());
    };
    TooltipRichContent.prototype.hide = function() {
        if (this.el) this.el.hide();
        this._show = false;
    };
    TooltipRichContent.prototype.hideLater = function(time) {
        if (this._show && !(this._inContent && this._enterable) && !this._alwaysShowContent) {
            if (time) {
                this._hideDelay = time;
                // Set show false to avoid invoke hideLater multiple times
                this._show = false;
                this._hideTimeout = setTimeout($1b239fc9d3a2f8ae$export$2385a24977818dd0(this.hide, this), time);
            } else this.hide();
        }
    };
    TooltipRichContent.prototype.isShow = function() {
        return this._show;
    };
    TooltipRichContent.prototype.dispose = function() {
        this._zr.remove(this.el);
    };
    return TooltipRichContent;
}();
function $c23f83aa086ffc0c$var$mathMaxWith0(val) {
    return Math.max(0, val);
}
function $c23f83aa086ffc0c$var$calcShadowOuterSize(style) {
    var shadowBlur = $c23f83aa086ffc0c$var$mathMaxWith0(style.shadowBlur || 0);
    var shadowOffsetX = $c23f83aa086ffc0c$var$mathMaxWith0(style.shadowOffsetX || 0);
    var shadowOffsetY = $c23f83aa086ffc0c$var$mathMaxWith0(style.shadowOffsetY || 0);
    return {
        left: $c23f83aa086ffc0c$var$mathMaxWith0(shadowBlur - shadowOffsetX),
        right: $c23f83aa086ffc0c$var$mathMaxWith0(shadowBlur + shadowOffsetX),
        top: $c23f83aa086ffc0c$var$mathMaxWith0(shadowBlur - shadowOffsetY),
        bottom: $c23f83aa086ffc0c$var$mathMaxWith0(shadowBlur + shadowOffsetY)
    };
}
function $c23f83aa086ffc0c$var$makeStyleCoord(out, zr, zrX, zrY) {
    out[0] = zrX;
    out[1] = zrY;
    out[2] = out[0] / zr.getWidth();
    out[3] = out[1] / zr.getHeight();
}
var $c23f83aa086ffc0c$export$2e2bcd8739ae039 = $c23f83aa086ffc0c$var$TooltipRichContent;




















var $38120641cfc598a9$var$proxyRect = new (0, $37476269d425e3f6$export$2e2bcd8739ae039)({
    shape: {
        x: -1,
        y: -1,
        width: 2,
        height: 2
    }
});
var $38120641cfc598a9$var$TooltipView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TooltipView, _super);
    function TooltipView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TooltipView.type;
        return _this;
    }
    TooltipView.prototype.init = function(ecModel, api) {
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var tooltipModel = ecModel.getComponent('tooltip');
        var renderMode = this._renderMode = (0, $9ac03c46e8b6e711$export$cc0a17a5d27b4e17)(tooltipModel.get('renderMode'));
        this._tooltipContent = renderMode === 'richText' ? new (0, $c23f83aa086ffc0c$export$2e2bcd8739ae039)(api) : new (0, $0d2b6abd94bfee1b$export$2e2bcd8739ae039)(api, {
            appendTo: tooltipModel.get('appendToBody', true) ? 'body' : tooltipModel.get('appendTo', true)
        });
    };
    TooltipView.prototype.render = function(tooltipModel, ecModel, api) {
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node || !api.getDom()) return;
        // Reset
        this.group.removeAll();
        this._tooltipModel = tooltipModel;
        this._ecModel = ecModel;
        this._api = api;
        var tooltipContent = this._tooltipContent;
        tooltipContent.update(tooltipModel);
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        this._initGlobalListener();
        this._keepShow();
        // PENDING
        // `mousemove` event will be triggered very frequently when the mouse moves fast,
        // which causes that the `updatePosition` function was also called frequently.
        // In Chrome with devtools open and Firefox, tooltip looks laggy and shakes. See #14695 #16101
        // To avoid frequent triggering,
        // consider throttling it in 50ms when transition is enabled
        if (this._renderMode !== 'richText' && tooltipModel.get('transitionDuration')) (0, $ef22ba67fe7cfc59$export$958e3e1a02eac4b6)(this, '_updatePosition', 50, 'fixRate');
        else (0, $ef22ba67fe7cfc59$export$42ffd38884aecdac)(this, '_updatePosition');
    };
    TooltipView.prototype._initGlobalListener = function() {
        var tooltipModel = this._tooltipModel;
        var triggerOn = tooltipModel.get('triggerOn');
        $86b7fb18065b1c0c$export$6503ec6e8aabbaf('itemTooltip', this._api, (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(function(currTrigger, e, dispatchAction) {
            // If 'none', it is not controlled by mouse totally.
            if (triggerOn !== 'none') {
                if (triggerOn.indexOf(currTrigger) >= 0) this._tryShow(e, dispatchAction);
                else if (currTrigger === 'leave') this._hide(dispatchAction);
            }
        }, this));
    };
    TooltipView.prototype._keepShow = function() {
        var tooltipModel = this._tooltipModel;
        var ecModel = this._ecModel;
        var api = this._api;
        var triggerOn = tooltipModel.get('triggerOn');
        // Try to keep the tooltip show when refreshing
        if (this._lastX != null && this._lastY != null && triggerOn !== 'none' && triggerOn !== 'click') {
            var self_1 = this;
            clearTimeout(this._refreshUpdateTimeout);
            this._refreshUpdateTimeout = setTimeout(function() {
                // Show tip next tick after other charts are rendered
                // In case highlight action has wrong result
                // FIXME
                !api.isDisposed() && self_1.manuallyShowTip(tooltipModel, ecModel, api, {
                    x: self_1._lastX,
                    y: self_1._lastY,
                    dataByCoordSys: self_1._lastDataByCoordSys
                });
            });
        }
    };
    /**
   * Show tip manually by
   * dispatchAction({
   *     type: 'showTip',
   *     x: 10,
   *     y: 10
   * });
   * Or
   * dispatchAction({
   *      type: 'showTip',
   *      seriesIndex: 0,
   *      dataIndex or dataIndexInside or name
   * });
   *
   *  TODO Batch
   */ TooltipView.prototype.manuallyShowTip = function(tooltipModel, ecModel, api, payload) {
        if (payload.from === this.uid || (0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node || !api.getDom()) return;
        var dispatchAction = $38120641cfc598a9$var$makeDispatchAction(payload, api);
        // Reset ticket
        this._ticket = '';
        // When triggered from axisPointer.
        var dataByCoordSys = payload.dataByCoordSys;
        var cmptRef = $38120641cfc598a9$var$findComponentReference(payload, ecModel, api);
        if (cmptRef) {
            var rect = cmptRef.el.getBoundingRect().clone();
            rect.applyTransform(cmptRef.el.transform);
            this._tryShow({
                offsetX: rect.x + rect.width / 2,
                offsetY: rect.y + rect.height / 2,
                target: cmptRef.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.tooltip && payload.x != null && payload.y != null) {
            var el = $38120641cfc598a9$var$proxyRect;
            el.x = payload.x;
            el.y = payload.y;
            el.update();
            (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).tooltipConfig = {
                name: null,
                option: payload.tooltip
            };
            // Manually show tooltip while view is not using zrender elements.
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                target: el
            }, dispatchAction);
        } else if (dataByCoordSys) this._tryShow({
            offsetX: payload.x,
            offsetY: payload.y,
            position: payload.position,
            dataByCoordSys: dataByCoordSys,
            tooltipOption: payload.tooltipOption
        }, dispatchAction);
        else if (payload.seriesIndex != null) {
            if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) return;
            var pointInfo = (0, $0b09587509d00b8a$export$2e2bcd8739ae039)(payload, ecModel);
            var cx = pointInfo.point[0];
            var cy = pointInfo.point[1];
            if (cx != null && cy != null) this._tryShow({
                offsetX: cx,
                offsetY: cy,
                target: pointInfo.el,
                position: payload.position,
                // When manully trigger, the mouse is not on the el, so we'd better to
                // position tooltip on the bottom of the el and display arrow is possible.
                positionDefault: 'bottom'
            }, dispatchAction);
        } else if (payload.x != null && payload.y != null) {
            // FIXME
            // should wrap dispatchAction like `axisPointer/globalListener` ?
            api.dispatchAction({
                type: 'updateAxisPointer',
                x: payload.x,
                y: payload.y
            });
            this._tryShow({
                offsetX: payload.x,
                offsetY: payload.y,
                position: payload.position,
                target: api.getZr().findHover(payload.x, payload.y).target
            }, dispatchAction);
        }
    };
    TooltipView.prototype.manuallyHideTip = function(tooltipModel, ecModel, api, payload) {
        var tooltipContent = this._tooltipContent;
        if (this._tooltipModel) tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
        this._lastX = this._lastY = this._lastDataByCoordSys = null;
        if (payload.from !== this.uid) this._hide($38120641cfc598a9$var$makeDispatchAction(payload, api));
    };
    // Be compatible with previous design, that is, when tooltip.type is 'axis' and
    // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
    // and tooltip.
    TooltipView.prototype._manuallyAxisShowTip = function(tooltipModel, ecModel, api, payload) {
        var seriesIndex = payload.seriesIndex;
        var dataIndex = payload.dataIndex;
        // @ts-ignore
        var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
        if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) return;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        if (!seriesModel) return;
        var data = seriesModel.getData();
        var tooltipCascadedModel = $38120641cfc598a9$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            seriesModel,
            (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel);
        if (tooltipCascadedModel.get('trigger') !== 'axis') return;
        api.dispatchAction({
            type: 'updateAxisPointer',
            seriesIndex: seriesIndex,
            dataIndex: dataIndex,
            position: payload.position
        });
        return true;
    };
    TooltipView.prototype._tryShow = function(e, dispatchAction) {
        var el = e.target;
        var tooltipModel = this._tooltipModel;
        if (!tooltipModel) return;
        // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
        this._lastX = e.offsetX;
        this._lastY = e.offsetY;
        var dataByCoordSys = e.dataByCoordSys;
        if (dataByCoordSys && dataByCoordSys.length) this._showAxisTooltip(dataByCoordSys, e);
        else if (el) {
            var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
            if (ecData.ssrType === 'legend') // Don't trigger tooltip for legend tooltip item
            return;
            this._lastDataByCoordSys = null;
            var seriesDispatcher_1;
            var cmptDispatcher_1;
            (0, $ee614fdac89517fb$export$8a4fca9e04eb4df6)(el, function(target) {
                // Always show item tooltip if mouse is on the element with dataIndex
                if ((0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(target).dataIndex != null) {
                    seriesDispatcher_1 = target;
                    return true;
                }
                // Tooltip provided directly. Like legend.
                if ((0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(target).tooltipConfig != null) {
                    cmptDispatcher_1 = target;
                    return true;
                }
            }, true);
            if (seriesDispatcher_1) this._showSeriesItemTooltip(e, seriesDispatcher_1, dispatchAction);
            else if (cmptDispatcher_1) this._showComponentItemTooltip(e, cmptDispatcher_1, dispatchAction);
            else this._hide(dispatchAction);
        } else {
            this._lastDataByCoordSys = null;
            this._hide(dispatchAction);
        }
    };
    TooltipView.prototype._showOrMove = function(tooltipModel, cb) {
        // showDelay is used in this case: tooltip.enterable is set
        // as true. User intent to move mouse into tooltip and click
        // something. `showDelay` makes it easier to enter the content
        // but tooltip do not move immediately.
        var delay = tooltipModel.get('showDelay');
        cb = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(cb, this);
        clearTimeout(this._showTimout);
        delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
    };
    TooltipView.prototype._showAxisTooltip = function(dataByCoordSys, e) {
        var ecModel = this._ecModel;
        var globalTooltipModel = this._tooltipModel;
        var point = [
            e.offsetX,
            e.offsetY
        ];
        var singleTooltipModel = $38120641cfc598a9$var$buildTooltipModel([
            e.tooltipOption
        ], globalTooltipModel);
        var renderMode = this._renderMode;
        var cbParamsList = [];
        var articleMarkup = (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('section', {
            blocks: [],
            noHeader: true
        });
        // Only for legacy: `Serise['formatTooltip']` returns a string.
        var markupTextArrLegacy = [];
        var markupStyleCreator = new (0, $6ceb7d0f0435c9d1$export$2fba3afbcdcf3e18)();
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dataByCoordSys, function(itemCoordSys) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(itemCoordSys.dataByAxis, function(axisItem) {
                var axisModel = ecModel.getComponent(axisItem.axisDim + 'Axis', axisItem.axisIndex);
                var axisValue = axisItem.value;
                if (!axisModel || axisValue == null) return;
                var axisValueLabel = $4c9900f2e2ca23a4$export$7cffee0f9aed39d0(axisValue, axisModel.axis, ecModel, axisItem.seriesDataIndices, axisItem.valueLabelOpt);
                var axisSectionMarkup = (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('section', {
                    header: axisValueLabel,
                    noHeader: !(0, $1b239fc9d3a2f8ae$export$87c2784dc9fc4ab)(axisValueLabel),
                    sortBlocks: true,
                    blocks: []
                });
                articleMarkup.blocks.push(axisSectionMarkup);
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(axisItem.seriesDataIndices, function(idxItem) {
                    var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
                    var dataIndex = idxItem.dataIndexInside;
                    var cbParams = series.getDataParams(dataIndex);
                    // Can't find data.
                    if (cbParams.dataIndex < 0) return;
                    cbParams.axisDim = axisItem.axisDim;
                    cbParams.axisIndex = axisItem.axisIndex;
                    cbParams.axisType = axisItem.axisType;
                    cbParams.axisId = axisItem.axisId;
                    cbParams.axisValue = $5435624263a719a6$export$a5a32f324c1fa457(axisModel.axis, {
                        value: axisValue
                    });
                    cbParams.axisValueLabel = axisValueLabel;
                    // Pre-create marker style for makers. Users can assemble richText
                    // text in `formatter` callback and use those markers style.
                    cbParams.marker = markupStyleCreator.makeTooltipMarker('item', (0, $ff2fba995230f3c9$export$cda04d03233e5555)(cbParams.color), renderMode);
                    var seriesTooltipResult = (0, $36ff81ce502a4a00$export$2d16fa82a50c4741)(series.formatTooltip(dataIndex, true, null));
                    var frag = seriesTooltipResult.frag;
                    if (frag) {
                        var valueFormatter = $38120641cfc598a9$var$buildTooltipModel([
                            series
                        ], globalTooltipModel).get('valueFormatter');
                        axisSectionMarkup.blocks.push(valueFormatter ? (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
                            valueFormatter: valueFormatter
                        }, frag) : frag);
                    }
                    if (seriesTooltipResult.text) markupTextArrLegacy.push(seriesTooltipResult.text);
                    cbParamsList.push(cbParams);
                });
            });
        });
        // In most cases, the second axis is displays upper on the first one.
        // So we reverse it to look better.
        articleMarkup.blocks.reverse();
        markupTextArrLegacy.reverse();
        var positionExpr = e.position;
        var orderMode = singleTooltipModel.get('order');
        var builtMarkupText = (0, $6ceb7d0f0435c9d1$export$6969ffb02c1cb49a)(articleMarkup, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), singleTooltipModel.get('textStyle'));
        builtMarkupText && markupTextArrLegacy.unshift(builtMarkupText);
        var blockBreak = renderMode === 'richText' ? '\n\n' : '<br/>';
        var allMarkupText = markupTextArrLegacy.join(blockBreak);
        this._showOrMove(singleTooltipModel, function() {
            if (this._updateContentNotChangedOnAxis(dataByCoordSys, cbParamsList)) this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, cbParamsList);
            else this._showTooltipContent(singleTooltipModel, allMarkupText, cbParamsList, Math.random() + '', point[0], point[1], positionExpr, null, markupStyleCreator);
        });
    // Do not trigger events here, because this branch only be entered
    // from dispatchAction.
    };
    TooltipView.prototype._showSeriesItemTooltip = function(e, dispatcher, dispatchAction) {
        var ecModel = this._ecModel;
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(dispatcher);
        // Use dataModel in element if possible
        // Used when mouseover on a element like markPoint or edge
        // In which case, the data is not main data in series.
        var seriesIndex = ecData.seriesIndex;
        var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
        // For example, graph link.
        var dataModel = ecData.dataModel || seriesModel;
        var dataIndex = ecData.dataIndex;
        var dataType = ecData.dataType;
        var data = dataModel.getData(dataType);
        var renderMode = this._renderMode;
        var positionDefault = e.positionDefault;
        var tooltipModel = $38120641cfc598a9$var$buildTooltipModel([
            data.getItemModel(dataIndex),
            dataModel,
            seriesModel && (seriesModel.coordinateSystem || {}).model
        ], this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var tooltipTrigger = tooltipModel.get('trigger');
        if (tooltipTrigger != null && tooltipTrigger !== 'item') return;
        var params = dataModel.getDataParams(dataIndex, dataType);
        var markupStyleCreator = new (0, $6ceb7d0f0435c9d1$export$2fba3afbcdcf3e18)();
        // Pre-create marker style for makers. Users can assemble richText
        // text in `formatter` callback and use those markers style.
        params.marker = markupStyleCreator.makeTooltipMarker('item', (0, $ff2fba995230f3c9$export$cda04d03233e5555)(params.color), renderMode);
        var seriesTooltipResult = (0, $36ff81ce502a4a00$export$2d16fa82a50c4741)(dataModel.formatTooltip(dataIndex, false, dataType));
        var orderMode = tooltipModel.get('order');
        var valueFormatter = tooltipModel.get('valueFormatter');
        var frag = seriesTooltipResult.frag;
        var markupText = frag ? (0, $6ceb7d0f0435c9d1$export$6969ffb02c1cb49a)(valueFormatter ? (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
            valueFormatter: valueFormatter
        }, frag) : frag, markupStyleCreator, renderMode, orderMode, ecModel.get('useUTC'), tooltipModel.get('textStyle')) : seriesTooltipResult.text;
        var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
        this._showOrMove(tooltipModel, function() {
            this._showTooltipContent(tooltipModel, markupText, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markupStyleCreator);
        });
        // FIXME
        // duplicated showtip if manuallyShowTip is called from dispatchAction.
        dispatchAction({
            type: 'showTip',
            dataIndexInside: dataIndex,
            dataIndex: data.getRawIndex(dataIndex),
            seriesIndex: seriesIndex,
            from: this.uid
        });
    };
    TooltipView.prototype._showComponentItemTooltip = function(e, el, dispatchAction) {
        var isHTMLRenderMode = this._renderMode === 'html';
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
        var tooltipConfig = ecData.tooltipConfig;
        var tooltipOpt = tooltipConfig.option || {};
        var encodeHTMLContent = tooltipOpt.encodeHTMLContent;
        if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(tooltipOpt)) {
            var content = tooltipOpt;
            tooltipOpt = {
                content: content,
                // Fixed formatter
                formatter: content
            };
            // when `tooltipConfig.option` is a string rather than an object,
            // we can't know if the content needs to be encoded
            // for the sake of security, encode it by default.
            encodeHTMLContent = true;
        }
        if (encodeHTMLContent && isHTMLRenderMode && tooltipOpt.content) {
            // clone might be unnecessary?
            tooltipOpt = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(tooltipOpt);
            tooltipOpt.content = (0, $8032584326d71745$export$f9d6449b9af28dc1)(tooltipOpt.content);
        }
        var tooltipModelCascade = [
            tooltipOpt
        ];
        var cmpt = this._ecModel.getComponent(ecData.componentMainType, ecData.componentIndex);
        if (cmpt) tooltipModelCascade.push(cmpt);
        // In most cases, component tooltip formatter has different params with series tooltip formatter,
        // so that they cannot share the same formatter. Since the global tooltip formatter is used for series
        // by convention, we do not use it as the default formatter for component.
        tooltipModelCascade.push({
            formatter: tooltipOpt.content
        });
        var positionDefault = e.positionDefault;
        var subTooltipModel = $38120641cfc598a9$var$buildTooltipModel(tooltipModelCascade, this._tooltipModel, positionDefault ? {
            position: positionDefault
        } : null);
        var defaultHtml = subTooltipModel.get('content');
        var asyncTicket = Math.random() + '';
        // PENDING: this case do not support richText style yet.
        var markupStyleCreator = new (0, $6ceb7d0f0435c9d1$export$2fba3afbcdcf3e18)();
        // Do not check whether `trigger` is 'none' here, because `trigger`
        // only works on coordinate system. In fact, we have not found case
        // that requires setting `trigger` nothing on component yet.
        this._showOrMove(subTooltipModel, function() {
            // Use formatterParams from element defined in component
            // Avoid users modify it.
            var formatterParams = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(subTooltipModel.get('formatterParams') || {});
            this._showTooltipContent(subTooltipModel, defaultHtml, formatterParams, asyncTicket, e.offsetX, e.offsetY, e.position, el, markupStyleCreator);
        });
        // If not dispatch showTip, tip may be hide triggered by axis.
        dispatchAction({
            type: 'showTip',
            from: this.uid
        });
    };
    TooltipView.prototype._showTooltipContent = function(// Use Model<TooltipOption> insteadof TooltipModel because this model may be from series or other options.
    // Instead of top level tooltip.
    tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markupStyleCreator) {
        // Reset ticket
        this._ticket = '';
        if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) return;
        var tooltipContent = this._tooltipContent;
        tooltipContent.setEnterable(tooltipModel.get('enterable'));
        var formatter = tooltipModel.get('formatter');
        positionExpr = positionExpr || tooltipModel.get('position');
        var html = defaultHtml;
        var nearPoint = this._getNearestPoint([
            x,
            y
        ], params, tooltipModel.get('trigger'), tooltipModel.get('borderColor'));
        var nearPointColor = nearPoint.color;
        if (formatter) {
            if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(formatter)) {
                var useUTC = tooltipModel.ecModel.get('useUTC');
                var params0 = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(params) ? params[0] : params;
                var isTimeAxis = params0 && params0.axisType && params0.axisType.indexOf('time') >= 0;
                html = formatter;
                if (isTimeAxis) html = (0, $1e22c322bcf5ac75$export$d9468344d3651243)(params0.axisValue, html, useUTC);
                html = (0, $ff2fba995230f3c9$export$2028496a35766e41)(html, params, true);
            } else if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(formatter)) {
                var callback = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(function(cbTicket, html) {
                    if (cbTicket === this._ticket) {
                        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
                        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
                    }
                }, this);
                this._ticket = asyncTicket;
                html = formatter(params, asyncTicket, callback);
            } else html = formatter;
        }
        tooltipContent.setContent(html, markupStyleCreator, tooltipModel, nearPointColor, positionExpr);
        tooltipContent.show(tooltipModel, nearPointColor);
        this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
    };
    TooltipView.prototype._getNearestPoint = function(point, tooltipDataParams, trigger, borderColor) {
        if (trigger === 'axis' || (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || (this._renderMode === 'html' ? '#fff' : 'none')
        };
        if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(tooltipDataParams)) return {
            color: borderColor || tooltipDataParams.color || tooltipDataParams.borderColor
        };
    };
    TooltipView.prototype._updatePosition = function(tooltipModel, positionExpr, x, // Mouse x
    y, // Mouse y
    content, params, el) {
        var viewWidth = this._api.getWidth();
        var viewHeight = this._api.getHeight();
        positionExpr = positionExpr || tooltipModel.get('position');
        var contentSize = content.getSize();
        var align = tooltipModel.get('align');
        var vAlign = tooltipModel.get('verticalAlign');
        var rect = el && el.getBoundingRect().clone();
        el && rect.applyTransform(el.transform);
        if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(positionExpr)) // Callback of position can be an array or a string specify the position
        positionExpr = positionExpr([
            x,
            y
        ], params, content.el, rect, {
            viewSize: [
                viewWidth,
                viewHeight
            ],
            contentSize: contentSize.slice()
        });
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(positionExpr)) {
            x = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionExpr[0], viewWidth);
            y = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(positionExpr[1], viewHeight);
        } else if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(positionExpr)) {
            var boxLayoutPosition = positionExpr;
            boxLayoutPosition.width = contentSize[0];
            boxLayoutPosition.height = contentSize[1];
            var layoutRect = (0, $501dc28f6c4d24ac$export$4517a5ca639a7293)(boxLayoutPosition, {
                width: viewWidth,
                height: viewHeight
            });
            x = layoutRect.x;
            y = layoutRect.y;
            align = null;
            // When positionExpr is left/top/right/bottom,
            // align and verticalAlign will not work.
            vAlign = null;
        } else if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(positionExpr) && el) {
            var pos = $38120641cfc598a9$var$calcTooltipPosition(positionExpr, rect, contentSize, tooltipModel.get('borderWidth'));
            x = pos[0];
            y = pos[1];
        } else {
            var pos = $38120641cfc598a9$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
            x = pos[0];
            y = pos[1];
        }
        align && (x -= $38120641cfc598a9$var$isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
        vAlign && (y -= $38120641cfc598a9$var$isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
        if ((0, $5e3fe82b07048e41$export$a309528050824ba4)(tooltipModel)) {
            var pos = $38120641cfc598a9$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight);
            x = pos[0];
            y = pos[1];
        }
        content.moveTo(x, y);
    };
    // FIXME
    // Should we remove this but leave this to user?
    TooltipView.prototype._updateContentNotChangedOnAxis = function(dataByCoordSys, cbParamsList) {
        var lastCoordSys = this._lastDataByCoordSys;
        var lastCbParamsList = this._cbParamsList;
        var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
        contentNotChanged && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(lastCoordSys, function(lastItemCoordSys, indexCoordSys) {
            var lastDataByAxis = lastItemCoordSys.dataByAxis || [];
            var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
            var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
            contentNotChanged = contentNotChanged && lastDataByAxis.length === thisDataByAxis.length;
            contentNotChanged && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(lastDataByAxis, function(lastItem, indexAxis) {
                var thisItem = thisDataByAxis[indexAxis] || {};
                var lastIndices = lastItem.seriesDataIndices || [];
                var newIndices = thisItem.seriesDataIndices || [];
                contentNotChanged = contentNotChanged && lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
                contentNotChanged && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(lastIndices, function(lastIdxItem, j) {
                    var newIdxItem = newIndices[j];
                    contentNotChanged = contentNotChanged && lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
                });
                // check is cbParams data value changed
                lastCbParamsList && (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(lastItem.seriesDataIndices, function(idxItem) {
                    var seriesIdx = idxItem.seriesIndex;
                    var cbParams = cbParamsList[seriesIdx];
                    var lastCbParams = lastCbParamsList[seriesIdx];
                    if (cbParams && lastCbParams && lastCbParams.data !== cbParams.data) contentNotChanged = false;
                });
            });
        });
        this._lastDataByCoordSys = dataByCoordSys;
        this._cbParamsList = cbParamsList;
        return !!contentNotChanged;
    };
    TooltipView.prototype._hide = function(dispatchAction) {
        // Do not directly hideLater here, because this behavior may be prevented
        // in dispatchAction when showTip is dispatched.
        // FIXME
        // duplicated hideTip if manuallyHideTip is called from dispatchAction.
        this._lastDataByCoordSys = null;
        dispatchAction({
            type: 'hideTip',
            from: this.uid
        });
    };
    TooltipView.prototype.dispose = function(ecModel, api) {
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node || !api.getDom()) return;
        (0, $ef22ba67fe7cfc59$export$42ffd38884aecdac)(this, '_updatePosition');
        this._tooltipContent.dispose();
        $86b7fb18065b1c0c$export$d07f55d4c15c0440('itemTooltip', api);
    };
    TooltipView.type = 'tooltip';
    return TooltipView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
/**
 * From top to bottom. (the last one should be globalTooltipModel);
 */ function $38120641cfc598a9$var$buildTooltipModel(modelCascade, globalTooltipModel, defaultTooltipOption) {
    // Last is always tooltip model.
    var ecModel = globalTooltipModel.ecModel;
    var resultModel;
    if (defaultTooltipOption) {
        resultModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(defaultTooltipOption, ecModel, ecModel);
        resultModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(globalTooltipModel.option, resultModel, ecModel);
    } else resultModel = globalTooltipModel;
    for(var i = modelCascade.length - 1; i >= 0; i--){
        var tooltipOpt = modelCascade[i];
        if (tooltipOpt) {
            if (tooltipOpt instanceof (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)) tooltipOpt = tooltipOpt.get('tooltip', true);
            // In each data item tooltip can be simply write:
            // {
            //  value: 10,
            //  tooltip: 'Something you need to know'
            // }
            if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(tooltipOpt)) tooltipOpt = {
                formatter: tooltipOpt
            };
            if (tooltipOpt) resultModel = new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(tooltipOpt, resultModel, ecModel);
        }
    }
    return resultModel;
}
function $38120641cfc598a9$var$makeDispatchAction(payload, api) {
    return payload.dispatchAction || (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(api.dispatchAction, api);
}
function $38120641cfc598a9$var$refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    if (gapH != null) {
        // Add extra 2 pixels for this case:
        // At present the "values" in default tooltip are using CSS `float: right`.
        // When the right edge of the tooltip box is on the right side of the
        // viewport, the `float` layout might push the "values" to the second line.
        if (x + width + gapH + 2 > viewWidth) x -= width + gapH;
        else x += gapH;
    }
    if (gapV != null) {
        if (y + height + gapV > viewHeight) y -= height + gapV;
        else y += gapV;
    }
    return [
        x,
        y
    ];
}
function $38120641cfc598a9$var$confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
    var size = content.getSize();
    var width = size[0];
    var height = size[1];
    x = Math.min(x + width, viewWidth) - width;
    y = Math.min(y + height, viewHeight) - height;
    x = Math.max(x, 0);
    y = Math.max(y, 0);
    return [
        x,
        y
    ];
}
function $38120641cfc598a9$var$calcTooltipPosition(position, rect, contentSize, borderWidth) {
    var domWidth = contentSize[0];
    var domHeight = contentSize[1];
    var offset = Math.ceil(Math.SQRT2 * borderWidth) + 8;
    var x = 0;
    var y = 0;
    var rectWidth = rect.width;
    var rectHeight = rect.height;
    switch(position){
        case 'inside':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'top':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y - domHeight - offset;
            break;
        case 'bottom':
            x = rect.x + rectWidth / 2 - domWidth / 2;
            y = rect.y + rectHeight + offset;
            break;
        case 'left':
            x = rect.x - domWidth - offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
            break;
        case 'right':
            x = rect.x + rectWidth + offset;
            y = rect.y + rectHeight / 2 - domHeight / 2;
    }
    return [
        x,
        y
    ];
}
function $38120641cfc598a9$var$isCenterAlign(align) {
    return align === 'center' || align === 'middle';
}
/**
 * Find target component by payload like:
 * ```js
 * { legendId: 'some_id', name: 'xxx' }
 * { toolboxIndex: 1, name: 'xxx' }
 * { geoName: 'some_name', name: 'xxx' }
 * ```
 * PENDING: at present only
 *
 * If not found, return null/undefined.
 */ function $38120641cfc598a9$var$findComponentReference(payload, ecModel, api) {
    var queryOptionMap = (0, $9ac03c46e8b6e711$export$fe600815775d9400)(payload).queryOptionMap;
    var componentMainType = queryOptionMap.keys()[0];
    if (!componentMainType || componentMainType === 'series') return;
    var queryResult = (0, $9ac03c46e8b6e711$export$dc741340f7e5f186)(ecModel, componentMainType, queryOptionMap.get(componentMainType), {
        useDefault: false,
        enableAll: false,
        enableNone: false
    });
    var model = queryResult.models[0];
    if (!model) return;
    var view = api.getViewOfComponentModel(model);
    var el;
    view.group.traverse(function(subEl) {
        var tooltipConfig = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(subEl).tooltipConfig;
        if (tooltipConfig && tooltipConfig.name === payload.name) {
            el = subEl;
            return true; // stop
        }
    });
    if (el) return {
        componentMainType: componentMainType,
        componentIndex: model.componentIndex,
        el: el
    };
}
var $38120641cfc598a9$export$2e2bcd8739ae039 = $38120641cfc598a9$var$TooltipView;



function $e4806f212bc08aa2$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $d1d2b9dcfa505105$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $319b16d47b957103$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $38120641cfc598a9$export$2e2bcd8739ae039));
    /**
   * @action
   * @property {string} type
   * @property {number} seriesIndex
   * @property {number} dataIndex
   * @property {number} [x]
   * @property {number} [y]
   */ registers.registerAction({
        type: 'showTip',
        event: 'showTip',
        update: 'tooltip:manuallyShowTip'
    }, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
    registers.registerAction({
        type: 'hideTip',
        event: 'hideTip',
        update: 'tooltip:manuallyHideTip'
    }, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $9cd8103bbc9f634a$var$DEFAULT_TOOLBOX_BTNS = [
    'rect',
    'polygon',
    'keep',
    'clear'
];
function $9cd8103bbc9f634a$export$2e2bcd8739ae039(option, isNew) {
    var brushComponents = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(option ? option.brush : []);
    if (!brushComponents.length) return;
    var brushComponentSpecifiedBtns = [];
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(brushComponents, function(brushOpt) {
        var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
        if (tbs instanceof Array) brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
    });
    var toolbox = option && option.toolbox;
    if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(toolbox)) toolbox = toolbox[0];
    if (!toolbox) {
        toolbox = {
            feature: {}
        };
        option.toolbox = [
            toolbox
        ];
    }
    var toolboxFeature = toolbox.feature || (toolbox.feature = {});
    var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
    var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
    brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
    $9cd8103bbc9f634a$var$removeDuplicate(brushTypes);
    if (isNew && !brushTypes.length) brushTypes.push.apply(brushTypes, $9cd8103bbc9f634a$var$DEFAULT_TOOLBOX_BTNS);
}
function $9cd8103bbc9f634a$var$removeDuplicate(arr) {
    var map = {};
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(arr, function(val) {
        map[val] = 1;
    });
    arr.length = 0;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(map, function(flag, val) {
        arr.push(val);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual solution, for consistent option specification.
 */ 


var $8c6eb7416a8c3770$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
function $8c6eb7416a8c3770$var$hasKeys(obj) {
    if (obj) for(var name_1 in obj){
        if (obj.hasOwnProperty(name_1)) return true;
    }
}
function $8c6eb7416a8c3770$export$89974527642f24a0(option, stateList, supplementVisualOption) {
    var visualMappings = {};
    $8c6eb7416a8c3770$var$each(stateList, function(state) {
        var mappings = visualMappings[state] = createMappings();
        $8c6eb7416a8c3770$var$each(option[state], function(visualData, visualType) {
            if (!(0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).isValidType(visualType)) return;
            var mappingOption = {
                type: visualType,
                visual: visualData
            };
            supplementVisualOption && supplementVisualOption(mappingOption, state);
            mappings[visualType] = new (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039)(mappingOption);
            // Prepare a alpha for opacity, for some case that opacity
            // is not supported, such as rendering using gradient color.
            if (visualType === 'opacity') {
                mappingOption = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(mappingOption);
                mappingOption.type = 'colorAlpha';
                mappings.__hidden.__alphaForOpacity = new (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039)(mappingOption);
            }
        });
    });
    return visualMappings;
    function createMappings() {
        var Creater = function() {};
        // Make sure hidden fields will not be visited by
        // object iteration (with hasOwnProperty checking).
        Creater.prototype.__hidden = Creater.prototype;
        var obj = new Creater();
        return obj;
    }
}
function $8c6eb7416a8c3770$export$797d20c0a6de578f(thisOption, newOption, keys) {
    // Visual attributes merge is not supported, otherwise it
    // brings overcomplicated merge logic. See #2853. So if
    // newOption has anyone of these keys, all of these keys
    // will be reset. Otherwise, all keys remain.
    var has;
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $8c6eb7416a8c3770$var$hasKeys(newOption[key])) has = true;
    });
    has && $1b239fc9d3a2f8ae$export$79b2f7037acddd43(keys, function(key) {
        if (newOption.hasOwnProperty(key) && $8c6eb7416a8c3770$var$hasKeys(newOption[key])) thisOption[key] = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(newOption[key]);
        else delete thisOption[key];
    });
}
function $8c6eb7416a8c3770$export$bb1ef43951d58629(stateList, visualMappings, data, getValueState, scope, dimension) {
    var visualTypesMap = {};
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    var dataIndex;
    function getVisual(key) {
        return (0, $aa7643c8305265d3$export$91d919a86b2df624)(data, dataIndex, key);
    }
    function setVisual(key, value) {
        (0, $aa7643c8305265d3$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
    }
    if (dimension == null) data.each(eachItem);
    else data.each([
        dimension
    ], eachItem);
    function eachItem(valueOrIndex, index) {
        dataIndex = dimension == null ? valueOrIndex // First argument is index
         : index;
        var rawDataItem = data.getRawDataItem(dataIndex);
        // Consider performance
        // @ts-ignore
        if (rawDataItem && rawDataItem.visualMap === false) return;
        var valueState = getValueState.call(scope, valueOrIndex);
        var mappings = visualMappings[valueState];
        var visualTypes = visualTypesMap[valueState];
        for(var i = 0, len = visualTypes.length; i < len; i++){
            var type = visualTypes[i];
            mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
        }
    }
}
function $8c6eb7416a8c3770$export$fc0ef8703cccf128(stateList, visualMappings, getValueState, dim) {
    var visualTypesMap = {};
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(stateList, function(state) {
        var visualTypes = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).prepareVisualTypes(visualMappings[state]);
        visualTypesMap[state] = visualTypes;
    });
    return {
        progress: function progress(params, data) {
            var dimIndex;
            if (dim != null) dimIndex = data.getDimensionIndex(dim);
            function getVisual(key) {
                return (0, $aa7643c8305265d3$export$91d919a86b2df624)(data, dataIndex, key);
            }
            function setVisual(key, value) {
                (0, $aa7643c8305265d3$export$3aab879e9d0e7c75)(data, dataIndex, key, value);
            }
            var dataIndex;
            var store = data.getStore();
            while((dataIndex = params.next()) != null){
                var rawDataItem = data.getRawDataItem(dataIndex);
                // Consider performance
                // @ts-ignore
                if (rawDataItem && rawDataItem.visualMap === false) continue;
                var value = dim != null ? store.get(dimIndex, dataIndex) : dataIndex;
                var valueState = getValueState(value);
                var mappings = visualMappings[valueState];
                var visualTypes = visualTypesMap[valueState];
                for(var i = 0, len = visualTypes.length; i < len; i++){
                    var type = visualTypes[i];
                    mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
                }
            }
        }
    };
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


function $f16c89bcb45c1577$export$2225cfa0a999c142(area) {
    var brushType = area.brushType;
    // Do not use function binding or curry for performance.
    var selectors = {
        point: function(itemLayout) {
            return $f16c89bcb45c1577$var$selector[brushType].point(itemLayout, selectors, area);
        },
        rect: function(itemLayout) {
            return $f16c89bcb45c1577$var$selector[brushType].rect(itemLayout, selectors, area);
        }
    };
    return selectors;
}
var $f16c89bcb45c1577$var$selector = {
    lineX: $f16c89bcb45c1577$var$getLineSelectors(0),
    lineY: $f16c89bcb45c1577$var$getLineSelectors(1),
    rect: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.intersect(itemLayout);
        }
    },
    polygon: {
        point: function(itemLayout, selectors, area) {
            return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && $945622e457f87e31$export$8893e2b90ba10d92(area.range, itemLayout[0], itemLayout[1]);
        },
        rect: function(itemLayout, selectors, area) {
            var points = area.range;
            if (!itemLayout || points.length <= 1) return false;
            var x = itemLayout.x;
            var y = itemLayout.y;
            var width = itemLayout.width;
            var height = itemLayout.height;
            var p = points[0];
            if ($945622e457f87e31$export$8893e2b90ba10d92(points, x, y) || $945622e457f87e31$export$8893e2b90ba10d92(points, x + width, y) || $945622e457f87e31$export$8893e2b90ba10d92(points, x, y + height) || $945622e457f87e31$export$8893e2b90ba10d92(points, x + width, y + height) || (0, $020465b49a1dd45f$export$2e2bcd8739ae039).create(itemLayout).contain(p[0], p[1]) || (0, $8eb95236e1aa01e7$export$4f47c855a5e9ae9)(x, y, x + width, y, points) || (0, $8eb95236e1aa01e7$export$4f47c855a5e9ae9)(x, y, x, y + height, points) || (0, $8eb95236e1aa01e7$export$4f47c855a5e9ae9)(x + width, y, x + width, y + height, points) || (0, $8eb95236e1aa01e7$export$4f47c855a5e9ae9)(x, y + height, x + width, y + height, points)) return true;
        }
    }
};
function $f16c89bcb45c1577$var$getLineSelectors(xyIndex) {
    var xy = [
        'x',
        'y'
    ];
    var wh = [
        'width',
        'height'
    ];
    return {
        point: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var p = itemLayout[xyIndex];
                return $f16c89bcb45c1577$var$inLineRange(p, range);
            }
        },
        rect: function(itemLayout, selectors, area) {
            if (itemLayout) {
                var range = area.range;
                var layoutRange = [
                    itemLayout[xy[xyIndex]],
                    itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]
                ];
                layoutRange[1] < layoutRange[0] && layoutRange.reverse();
                return $f16c89bcb45c1577$var$inLineRange(layoutRange[0], range) || $f16c89bcb45c1577$var$inLineRange(layoutRange[1], range) || $f16c89bcb45c1577$var$inLineRange(range[0], layoutRange) || $f16c89bcb45c1577$var$inLineRange(range[1], layoutRange);
            }
        }
    };
}
function $f16c89bcb45c1577$var$inLineRange(p, range) {
    return range[0] <= p && p <= range[1];
}
var $f16c89bcb45c1577$export$2e2bcd8739ae039 = $f16c89bcb45c1577$var$selector;




var $c54f27f9b8d00ae1$var$STATE_LIST = [
    'inBrush',
    'outOfBrush'
];
var $c54f27f9b8d00ae1$var$DISPATCH_METHOD = '__ecBrushSelect';
var $c54f27f9b8d00ae1$var$DISPATCH_FLAG = '__ecInBrushSelectEvent';
function $c54f27f9b8d00ae1$export$ead1205d8c0d8375(ecModel) {
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel) {
        var brushTargetManager = brushModel.brushTargetManager = new (0, $2964360305142861$export$2e2bcd8739ae039)(brushModel.option, ecModel);
        brushTargetManager.setInputRanges(brushModel.areas, ecModel);
    });
}
function $c54f27f9b8d00ae1$export$2e2bcd8739ae039(ecModel, api, payload) {
    var brushSelected = [];
    var throttleType;
    var throttleDelay;
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel) {
        payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
            brushType: false
        });
    });
    $c54f27f9b8d00ae1$export$ead1205d8c0d8375(ecModel);
    ecModel.eachComponent({
        mainType: 'brush'
    }, function(brushModel, brushIndex) {
        var thisBrushSelected = {
            brushId: brushModel.id,
            brushIndex: brushIndex,
            brushName: brushModel.name,
            areas: $1b239fc9d3a2f8ae$export$9cd59f9826255e47(brushModel.areas),
            selected: []
        };
        // Every brush component exists in event params, convenient
        // for user to find by index.
        brushSelected.push(thisBrushSelected);
        var brushOption = brushModel.option;
        var brushLink = brushOption.brushLink;
        var linkedSeriesMap = [];
        var selectedDataIndexForLink = [];
        var rangeInfoBySeries = [];
        var hasBrushExists = false;
        if (!brushIndex) {
            // Only the first throttle setting works.
            throttleType = brushOption.throttleType;
            throttleDelay = brushOption.throttleDelay;
        }
        // Add boundingRect and selectors to range.
        var areas = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(brushModel.areas, function(area) {
            var builder = $c54f27f9b8d00ae1$var$boundingRectBuilders[area.brushType];
            var selectableArea = $1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
                boundingRect: builder ? builder(area) : void 0
            }, area);
            selectableArea.selectors = (0, $f16c89bcb45c1577$export$2225cfa0a999c142)(selectableArea);
            return selectableArea;
        });
        var visualMappings = $8c6eb7416a8c3770$export$89974527642f24a0(brushModel.option, $c54f27f9b8d00ae1$var$STATE_LIST, function(mappingOption) {
            mappingOption.mappingMethod = 'fixed';
        });
        $1b239fc9d3a2f8ae$export$43bee75e5e14138e(brushLink) && $1b239fc9d3a2f8ae$export$79b2f7037acddd43(brushLink, function(seriesIndex) {
            linkedSeriesMap[seriesIndex] = 1;
        });
        function linkOthers(seriesIndex) {
            return brushLink === 'all' || !!linkedSeriesMap[seriesIndex];
        }
        // If no supported brush or no brush on the series,
        // all visuals should be in original state.
        function brushed(rangeInfoList) {
            return !!rangeInfoList.length;
        }
        /**
     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
     *
     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
     *                └!hasBrushExist┘                                              └nothing.
     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
     *   !brushed┘                                                                  └nothing.
     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
     */ // Step A
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
            seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
        });
        function stepAParallel(seriesModel, seriesIndex) {
            var coordSys = seriesModel.coordinateSystem;
            hasBrushExists = hasBrushExists || coordSys.hasAxisBrushed();
            linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function(activeState, dataIndex) {
                activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
            });
        }
        function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
            if (!seriesModel.brushSelector || $c54f27f9b8d00ae1$var$brushModelNotControll(brushModel, seriesIndex)) return;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(areas, function(area) {
                if (brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel)) rangeInfoList.push(area);
                hasBrushExists = hasBrushExists || brushed(rangeInfoList);
            });
            if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
                var data_1 = seriesModel.getData();
                data_1.each(function(dataIndex) {
                    if ($c54f27f9b8d00ae1$var$checkInRange(seriesModel, rangeInfoList, data_1, dataIndex)) selectedDataIndexForLink[dataIndex] = 1;
                });
            }
        }
        // Step B
        ecModel.eachSeries(function(seriesModel, seriesIndex) {
            var seriesBrushSelected = {
                seriesId: seriesModel.id,
                seriesIndex: seriesIndex,
                seriesName: seriesModel.name,
                dataIndex: []
            };
            // Every series exists in event params, convenient
            // for user to find series by seriesIndex.
            thisBrushSelected.selected.push(seriesBrushSelected);
            var rangeInfoList = rangeInfoBySeries[seriesIndex];
            var data = seriesModel.getData();
            var getValueState = linkOthers(seriesIndex) ? function(dataIndex) {
                return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
            } : function(dataIndex) {
                return $c54f27f9b8d00ae1$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
            };
            // If no supported brush or no brush, all visuals are in original state.
            (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && $8c6eb7416a8c3770$export$bb1ef43951d58629($c54f27f9b8d00ae1$var$STATE_LIST, visualMappings, data, getValueState);
        });
    });
    $c54f27f9b8d00ae1$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
}
function $c54f27f9b8d00ae1$var$dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
    // This event will not be triggered when `setOpion`, otherwise dead lock may
    // triggered when do `setOption` in event listener, which we do not find
    // satisfactory way to solve yet. Some considered resolutions:
    // (a) Diff with prevoius selected data ant only trigger event when changed.
    // But store previous data and diff precisely (i.e., not only by dataIndex, but
    // also detect value changes in selected data) might bring complexity or fragility.
    // (b) Use spectial param like `silent` to suppress event triggering.
    // But such kind of volatile param may be weird in `setOption`.
    if (!payload) return;
    var zr = api.getZr();
    if (zr[$c54f27f9b8d00ae1$var$DISPATCH_FLAG]) return;
    if (!zr[$c54f27f9b8d00ae1$var$DISPATCH_METHOD]) zr[$c54f27f9b8d00ae1$var$DISPATCH_METHOD] = $c54f27f9b8d00ae1$var$doDispatch;
    var fn = $ef22ba67fe7cfc59$export$958e3e1a02eac4b6(zr, $c54f27f9b8d00ae1$var$DISPATCH_METHOD, throttleDelay, throttleType);
    fn(api, brushSelected);
}
function $c54f27f9b8d00ae1$var$doDispatch(api, brushSelected) {
    if (!api.isDisposed()) {
        var zr = api.getZr();
        zr[$c54f27f9b8d00ae1$var$DISPATCH_FLAG] = true;
        api.dispatchAction({
            type: 'brushSelect',
            batch: brushSelected
        });
        zr[$c54f27f9b8d00ae1$var$DISPATCH_FLAG] = false;
    }
}
function $c54f27f9b8d00ae1$var$checkInRange(seriesModel, rangeInfoList, data, dataIndex) {
    for(var i = 0, len = rangeInfoList.length; i < len; i++){
        var area = rangeInfoList[i];
        if (seriesModel.brushSelector(dataIndex, data, area.selectors, area)) return true;
    }
}
function $c54f27f9b8d00ae1$var$brushModelNotControll(brushModel, seriesIndex) {
    var seriesIndices = brushModel.option.seriesIndex;
    return seriesIndices != null && seriesIndices !== 'all' && ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(seriesIndices) ? $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
}
var $c54f27f9b8d00ae1$var$boundingRectBuilders = {
    rect: function(area) {
        return $c54f27f9b8d00ae1$var$getBoundingRectFromMinMax(area.range);
    },
    polygon: function(area) {
        var minMax;
        var range = area.range;
        for(var i = 0, len = range.length; i < len; i++){
            minMax = minMax || [
                [
                    Infinity,
                    -Infinity
                ],
                [
                    Infinity,
                    -Infinity
                ]
            ];
            var rg = range[i];
            rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
            rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
            rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
            rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
        }
        return minMax && $c54f27f9b8d00ae1$var$getBoundingRectFromMinMax(minMax);
    }
};
function $c54f27f9b8d00ae1$var$getBoundingRectFromMinMax(minMax) {
    return new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
}



var $e9484fcc06038ab6$var$BrushView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BrushView, _super);
    function BrushView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushView.type;
        return _this;
    }
    BrushView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
        this.model;
        (this._brushController = new (0, $f3dfc951a5a73cbe$export$2e2bcd8739ae039)(api.getZr())).on('brush', $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._onBrush, this)).mount();
    };
    BrushView.prototype.render = function(brushModel, ecModel, api, payload) {
        this.model = brushModel;
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateTransform = function(brushModel, ecModel, api, payload) {
        // PENDING: `updateTransform` is a little tricky, whose layout need
        // to be calculate mandatorily and other stages will not be performed.
        // Take care the correctness of the logic. See #11754 .
        (0, $c54f27f9b8d00ae1$export$ead1205d8c0d8375)(ecModel);
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateVisual = function(brushModel, ecModel, api, payload) {
        this.updateTransform(brushModel, ecModel, api, payload);
    };
    BrushView.prototype.updateView = function(brushModel, ecModel, api, payload) {
        this._updateController(brushModel, ecModel, api, payload);
    };
    BrushView.prototype._updateController = function(brushModel, ecModel, api, payload) {
        // Do not update controller when drawing.
        (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
    };
    // updateLayout: updateController,
    // updateVisual: updateController,
    BrushView.prototype.dispose = function() {
        this._brushController.dispose();
    };
    BrushView.prototype._onBrush = function(eventParam) {
        var modelId = this.model.id;
        var areas = this.model.brushTargetManager.setOutputRanges(eventParam.areas, this.ecModel);
        // Action is not dispatched on drag end, because the drag end
        // emits the same params with the last drag move event, and
        // may have some delay when using touch pad, which makes
        // animation not smooth (when using debounce).
        (!eventParam.isEnd || eventParam.removeOnClick) && this.api.dispatchAction({
            type: 'brush',
            brushId: modelId,
            areas: $1b239fc9d3a2f8ae$export$9cd59f9826255e47(areas),
            $from: modelId
        });
        eventParam.isEnd && this.api.dispatchAction({
            type: 'brushEnd',
            brushId: modelId,
            areas: $1b239fc9d3a2f8ae$export$9cd59f9826255e47(areas),
            $from: modelId
        });
    };
    BrushView.type = 'brush';
    return BrushView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $e9484fcc06038ab6$export$2e2bcd8739ae039 = $e9484fcc06038ab6$var$BrushView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $bd8830caa1e74115$var$DEFAULT_OUT_OF_BRUSH_COLOR = '#ddd';
var $bd8830caa1e74115$var$BrushModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BrushModel, _super);
    function BrushModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = BrushModel.type;
        /**
     * @readOnly
     */ _this.areas = [];
        /**
     * Current brush painting area settings.
     * @readOnly
     */ _this.brushOption = {};
        return _this;
    }
    BrushModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $8c6eb7416a8c3770$export$797d20c0a6de578f(thisOption, newOption, [
            'inBrush',
            'outOfBrush'
        ]);
        var inBrush = thisOption.inBrush = thisOption.inBrush || {};
        // Always give default visual, consider setOption at the second time.
        thisOption.outOfBrush = thisOption.outOfBrush || {
            color: $bd8830caa1e74115$var$DEFAULT_OUT_OF_BRUSH_COLOR
        };
        if (!inBrush.hasOwnProperty('liftZ')) // Bigger than the highlight z lift, otherwise it will
        // be effected by the highlight z when brush.
        inBrush.liftZ = 5;
    };
    /**
   * If `areas` is null/undefined, range state remain.
   */ BrushModel.prototype.setAreas = function(areas) {
        // If areas is null/undefined, range state remain.
        // This helps user to dispatchAction({type: 'brush'}) with no areas
        // set but just want to get the current brush select info from a `brush` event.
        if (!areas) return;
        this.areas = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(areas, function(area) {
            return $bd8830caa1e74115$var$generateBrushOption(this.option, area);
        }, this);
    };
    /**
   * Set the current painting brush option.
   */ BrushModel.prototype.setBrushOption = function(brushOption) {
        this.brushOption = $bd8830caa1e74115$var$generateBrushOption(this.option, brushOption);
        this.brushType = this.brushOption.brushType;
    };
    BrushModel.type = 'brush';
    BrushModel.dependencies = [
        'geo',
        'grid',
        'xAxis',
        'yAxis',
        'parallel',
        'series'
    ];
    BrushModel.defaultOption = {
        seriesIndex: 'all',
        brushType: 'rect',
        brushMode: 'single',
        transformable: true,
        brushStyle: {
            borderWidth: 1,
            color: 'rgba(210,219,238,0.3)',
            borderColor: '#D2DBEE'
        },
        throttleType: 'fixRate',
        throttleDelay: 0,
        removeOnClick: true,
        z: 10000
    };
    return BrushModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
function $bd8830caa1e74115$var$generateBrushOption(option, brushOption) {
    return $1b239fc9d3a2f8ae$export$4950aa0f605343fb({
        brushType: option.brushType,
        brushMode: option.brushMode,
        transformable: option.transformable,
        brushStyle: new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(option.brushStyle).getItemStyle(),
        removeOnClick: option.removeOnClick,
        z: option.z
    }, brushOption, true);
}
var $bd8830caa1e74115$export$2e2bcd8739ae039 = $bd8830caa1e74115$var$BrushModel;



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $a6e865eb3a4780f3$var$ICON_TYPES = [
    'rect',
    'polygon',
    'lineX',
    'lineY',
    'keep',
    'clear'
];
var $a6e865eb3a4780f3$var$BrushFeature = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(BrushFeature, _super);
    function BrushFeature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BrushFeature.prototype.render = function(featureModel, ecModel, api) {
        var brushType;
        var brushMode;
        var isBrushed;
        ecModel.eachComponent({
            mainType: 'brush'
        }, function(brushModel) {
            brushType = brushModel.brushType;
            brushMode = brushModel.brushOption.brushMode || 'single';
            isBrushed = isBrushed || !!brushModel.areas.length;
        });
        this._brushType = brushType;
        this._brushMode = brushMode;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(featureModel.get('type', true), function(type) {
            featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
        });
    };
    BrushFeature.prototype.updateView = function(featureModel, ecModel, api) {
        this.render(featureModel, ecModel, api);
    };
    BrushFeature.prototype.getIcons = function() {
        var model = this.model;
        var availableIcons = model.get('icon', true);
        var icons = {};
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(model.get('type', true), function(type) {
            if (availableIcons[type]) icons[type] = availableIcons[type];
        });
        return icons;
    };
    BrushFeature.prototype.onclick = function(ecModel, api, type) {
        var brushType = this._brushType;
        var brushMode = this._brushMode;
        if (type === 'clear') {
            // Trigger parallel action firstly
            api.dispatchAction({
                type: 'axisAreaSelect',
                intervals: []
            });
            api.dispatchAction({
                type: 'brush',
                command: 'clear',
                // Clear all areas of all brush components.
                areas: []
            });
        } else api.dispatchAction({
            type: 'takeGlobalCursor',
            key: 'brush',
            brushOption: {
                brushType: type === 'keep' ? brushType : brushType === type ? false : type,
                brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
            }
        });
    };
    BrushFeature.getDefaultOption = function(ecModel) {
        var defaultOption = {
            show: true,
            type: $a6e865eb3a4780f3$var$ICON_TYPES.slice(),
            icon: {
                /* eslint-disable */ rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
                polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
                lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
                lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
                keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
                clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
            },
            // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
            title: ecModel.getLocaleModel().get([
                'toolbox',
                'brush',
                'title'
            ])
        };
        return defaultOption;
    };
    return BrushFeature;
}((0, $0a908f01d9563844$export$1426bfb1b0bcf539));
var $a6e865eb3a4780f3$export$2e2bcd8739ae039 = $a6e865eb3a4780f3$var$BrushFeature;




function $bb2a82545ff8fb99$export$4b3e715f166fdd78(registers) {
    registers.registerComponentView((0, $e9484fcc06038ab6$export$2e2bcd8739ae039));
    registers.registerComponentModel((0, $bd8830caa1e74115$export$2e2bcd8739ae039));
    registers.registerPreprocessor((0, $9cd8103bbc9f634a$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.BRUSH, (0, $c54f27f9b8d00ae1$export$2e2bcd8739ae039));
    registers.registerAction({
        type: 'brush',
        event: 'brush',
        update: 'updateVisual'
    }, function(payload, ecModel) {
        ecModel.eachComponent({
            mainType: 'brush',
            query: payload
        }, function(brushModel) {
            brushModel.setAreas(payload.areas);
        });
    });
    /**
   * payload: {
   *      brushComponents: [
   *          {
   *              brushId,
   *              brushIndex,
   *              brushName,
   *              series: [
   *                  {
   *                      seriesId,
   *                      seriesIndex,
   *                      seriesName,
   *                      rawIndices: [21, 34, ...]
   *                  },
   *                  ...
   *              ]
   *          },
   *          ...
   *      ]
   * }
   */ registers.registerAction({
        type: 'brushSelect',
        event: 'brushSelected',
        update: 'none'
    }, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
    registers.registerAction({
        type: 'brushEnd',
        event: 'brushEnd',
        update: 'none'
    }, (0, $1b239fc9d3a2f8ae$export$8793edee2d425525));
    (0, $0a908f01d9563844$export$c6213a6f247cf906)('brush', (0, $a6e865eb3a4780f3$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 








var $97ee0ab49bcb15ab$var$TitleModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TitleModel, _super);
    function TitleModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleModel.type;
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        return _this;
    }
    TitleModel.type = 'title';
    TitleModel.defaultOption = {
        // zlevel: 0,
        z: 6,
        show: true,
        text: '',
        target: 'blank',
        subtext: '',
        subtarget: 'blank',
        left: 0,
        top: 0,
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        textStyle: {
            fontSize: 18,
            fontWeight: 'bold',
            color: '#464646'
        },
        subtextStyle: {
            fontSize: 12,
            color: '#6E7079'
        }
    };
    return TitleModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
// View
var $97ee0ab49bcb15ab$var$TitleView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TitleView, _super);
    function TitleView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TitleView.type;
        return _this;
    }
    TitleView.prototype.render = function(titleModel, ecModel, api) {
        this.group.removeAll();
        if (!titleModel.get('show')) return;
        var group = this.group;
        var textStyleModel = titleModel.getModel('textStyle');
        var subtextStyleModel = titleModel.getModel('subtextStyle');
        var textAlign = titleModel.get('textAlign');
        var textVerticalAlign = $1b239fc9d3a2f8ae$export$995e01f2f5c9d030(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
        var textEl = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                text: titleModel.get('text'),
                fill: textStyleModel.getTextColor()
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var textRect = textEl.getBoundingRect();
        var subText = titleModel.get('subtext');
        var subTextEl = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(subtextStyleModel, {
                text: subText,
                fill: subtextStyleModel.getTextColor(),
                y: textRect.height + titleModel.get('itemGap'),
                verticalAlign: 'top'
            }, {
                disableBox: true
            }),
            z2: 10
        });
        var link = titleModel.get('link');
        var sublink = titleModel.get('sublink');
        var triggerEvent = titleModel.get('triggerEvent', true);
        textEl.silent = !link && !triggerEvent;
        subTextEl.silent = !sublink && !triggerEvent;
        if (link) textEl.on('click', function() {
            (0, $ff2fba995230f3c9$export$13e13f9b96dbe8fa)(link, '_' + titleModel.get('target'));
        });
        if (sublink) subTextEl.on('click', function() {
            (0, $ff2fba995230f3c9$export$13e13f9b96dbe8fa)(sublink, '_' + titleModel.get('subtarget'));
        });
        (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(textEl).eventData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(subTextEl).eventData = triggerEvent ? {
            componentType: 'title',
            componentIndex: titleModel.componentIndex
        } : null;
        group.add(textEl);
        subText && group.add(subTextEl);
        // If no subText, but add subTextEl, there will be an empty line.
        var groupRect = group.getBoundingRect();
        var layoutOption = titleModel.getBoxLayoutParams();
        layoutOption.width = groupRect.width;
        layoutOption.height = groupRect.height;
        var layoutRect = (0, $501dc28f6c4d24ac$export$4517a5ca639a7293)(layoutOption, {
            width: api.getWidth(),
            height: api.getHeight()
        }, titleModel.get('padding'));
        // Adjust text align based on position
        if (!textAlign) {
            // Align left if title is on the left. center and right is same
            textAlign = titleModel.get('left') || titleModel.get('right');
            // @ts-ignore
            if (textAlign === 'middle') textAlign = 'center';
            // Adjust layout by text align
            if (textAlign === 'right') layoutRect.x += layoutRect.width;
            else if (textAlign === 'center') layoutRect.x += layoutRect.width / 2;
        }
        if (!textVerticalAlign) {
            textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
            // @ts-ignore
            if (textVerticalAlign === 'center') textVerticalAlign = 'middle';
            if (textVerticalAlign === 'bottom') layoutRect.y += layoutRect.height;
            else if (textVerticalAlign === 'middle') layoutRect.y += layoutRect.height / 2;
            textVerticalAlign = textVerticalAlign || 'top';
        }
        group.x = layoutRect.x;
        group.y = layoutRect.y;
        group.markRedraw();
        var alignStyle = {
            align: textAlign,
            verticalAlign: textVerticalAlign
        };
        textEl.setStyle(alignStyle);
        subTextEl.setStyle(alignStyle);
        // Render background
        // Get groupRect again because textAlign has been changed
        groupRect = group.getBoundingRect();
        var padding = layoutRect.margin;
        var style = titleModel.getItemStyle([
            'color',
            'opacity'
        ]);
        style.fill = titleModel.get('backgroundColor');
        var rect = new $37476269d425e3f6$export$2e2bcd8739ae039({
            shape: {
                x: groupRect.x - padding[3],
                y: groupRect.y - padding[0],
                width: groupRect.width + padding[1] + padding[3],
                height: groupRect.height + padding[0] + padding[2],
                r: titleModel.get('borderRadius')
            },
            style: style,
            subPixelOptimize: true,
            silent: true
        });
        group.add(rect);
    };
    TitleView.type = 'title';
    return TitleView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $97ee0ab49bcb15ab$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($97ee0ab49bcb15ab$var$TitleModel);
    registers.registerComponentView($97ee0ab49bcb15ab$var$TitleView);
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $cb94e868180ccc54$var$TimelineModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TimelineModel, _super);
    function TimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineModel.type;
        _this.layoutMode = 'box';
        return _this;
    }
    /**
   * @override
   */ TimelineModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._initData();
    };
    /**
   * @override
   */ TimelineModel.prototype.mergeOption = function(option) {
        _super.prototype.mergeOption.apply(this, arguments);
        this._initData();
    };
    TimelineModel.prototype.setCurrentIndex = function(currentIndex) {
        if (currentIndex == null) currentIndex = this.option.currentIndex;
        var count = this._data.count();
        if (this.option.loop) currentIndex = (currentIndex % count + count) % count;
        else {
            currentIndex >= count && (currentIndex = count - 1);
            currentIndex < 0 && (currentIndex = 0);
        }
        this.option.currentIndex = currentIndex;
    };
    /**
   * @return {number} currentIndex
   */ TimelineModel.prototype.getCurrentIndex = function() {
        return this.option.currentIndex;
    };
    /**
   * @return {boolean}
   */ TimelineModel.prototype.isIndexMax = function() {
        return this.getCurrentIndex() >= this._data.count() - 1;
    };
    /**
   * @param {boolean} state true: play, false: stop
   */ TimelineModel.prototype.setPlayState = function(state) {
        this.option.autoPlay = !!state;
    };
    /**
   * @return {boolean} true: play, false: stop
   */ TimelineModel.prototype.getPlayState = function() {
        return !!this.option.autoPlay;
    };
    /**
   * @private
   */ TimelineModel.prototype._initData = function() {
        var thisOption = this.option;
        var dataArr = thisOption.data || [];
        var axisType = thisOption.axisType;
        var names = this._names = [];
        var processedDataArr;
        if (axisType === 'category') {
            processedDataArr = [];
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dataArr, function(item, index) {
                var value = (0, $9ac03c46e8b6e711$export$fb1a222ba5dd6e51)((0, $9ac03c46e8b6e711$export$2c944e12edb48d4b)(item), '');
                var newItem;
                if ((0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(item)) {
                    newItem = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(item);
                    newItem.value = index;
                } else newItem = index;
                processedDataArr.push(newItem);
                names.push(value);
            });
        } else processedDataArr = dataArr;
        var dimType = {
            category: 'ordinal',
            time: 'time',
            value: 'number'
        }[axisType] || 'number';
        var data = this._data = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)([
            {
                name: 'value',
                type: dimType
            }
        ], this);
        data.initData(processedDataArr, names);
    };
    TimelineModel.prototype.getData = function() {
        return this._data;
    };
    /**
   * @public
   * @return {Array.<string>} categoreis
   */ TimelineModel.prototype.getCategories = function() {
        if (this.get('axisType') === 'category') return this._names.slice();
    };
    TimelineModel.type = 'timeline';
    /**
   * @protected
   */ TimelineModel.defaultOption = {
        // zlevel: 0,                  // 一级层叠
        z: 4,
        show: true,
        axisType: 'time',
        realtime: true,
        left: '20%',
        top: null,
        right: '20%',
        bottom: 0,
        width: null,
        height: 40,
        padding: 5,
        controlPosition: 'left',
        autoPlay: false,
        rewind: false,
        loop: true,
        playInterval: 2000,
        currentIndex: 0,
        itemStyle: {},
        label: {
            color: '#000'
        },
        data: []
    };
    return TimelineModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $cb94e868180ccc54$export$2e2bcd8739ae039 = $cb94e868180ccc54$var$TimelineModel;





var $46529f8f9a8202ca$var$SliderTimelineModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SliderTimelineModel, _super);
    function SliderTimelineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineModel.type;
        return _this;
    }
    SliderTimelineModel.type = 'timeline.slider';
    /**
   * @protected
   */ SliderTimelineModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $cb94e868180ccc54$export$2e2bcd8739ae039).defaultOption, {
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        borderWidth: 0,
        orient: 'horizontal',
        inverse: false,
        tooltip: {
            trigger: 'item' // data item may also have tootip attr.
        },
        symbol: 'circle',
        symbolSize: 12,
        lineStyle: {
            show: true,
            width: 2,
            color: '#DAE1F5'
        },
        label: {
            position: 'auto',
            // When using number, label position is not
            // restricted by viewRect.
            // positive: right/bottom, negative: left/top
            show: true,
            interval: 'auto',
            rotate: 0,
            // formatter: null,
            // 其余属性默认使用全局文本样式，详见TEXTSTYLE
            color: '#A4B1D7'
        },
        itemStyle: {
            color: '#A4B1D7',
            borderWidth: 1
        },
        checkpointStyle: {
            symbol: 'circle',
            symbolSize: 15,
            color: '#316bf3',
            borderColor: '#fff',
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: 'rgba(0, 0, 0, 0.3)',
            // borderColor: 'rgba(194,53,49, 0.5)',
            animation: true,
            animationDuration: 300,
            animationEasing: 'quinticInOut'
        },
        controlStyle: {
            show: true,
            showPlayBtn: true,
            showPrevBtn: true,
            showNextBtn: true,
            itemSize: 24,
            itemGap: 12,
            position: 'left',
            playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
            stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
            // eslint-disable-next-line max-len
            nextIcon: 'M2,18.5A1.52,1.52,0,0,1,.92,18a1.49,1.49,0,0,1,0-2.12L7.81,9.36,1,3.11A1.5,1.5,0,1,1,3,.89l8,7.34a1.48,1.48,0,0,1,.49,1.09,1.51,1.51,0,0,1-.46,1.1L3,18.08A1.5,1.5,0,0,1,2,18.5Z',
            // eslint-disable-next-line max-len
            prevIcon: 'M10,.5A1.52,1.52,0,0,1,11.08,1a1.49,1.49,0,0,1,0,2.12L4.19,9.64,11,15.89a1.5,1.5,0,1,1-2,2.22L1,10.77A1.48,1.48,0,0,1,.5,9.68,1.51,1.51,0,0,1,1,8.58L9,.92A1.5,1.5,0,0,1,10,.5Z',
            prevBtnSize: 18,
            nextBtnSize: 18,
            color: '#A4B1D7',
            borderColor: '#A4B1D7',
            borderWidth: 1
        },
        emphasis: {
            label: {
                show: true,
                // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                color: '#6f778d'
            },
            itemStyle: {
                color: '#316BF3'
            },
            controlStyle: {
                color: '#316BF3',
                borderColor: '#316BF3',
                borderWidth: 2
            }
        },
        progress: {
            lineStyle: {
                color: '#316BF3'
            },
            itemStyle: {
                color: '#316BF3'
            },
            label: {
                color: '#6f778d'
            }
        },
        data: []
    });
    return SliderTimelineModel;
}((0, $cb94e868180ccc54$export$2e2bcd8739ae039));
(0, $1b239fc9d3a2f8ae$export$e36fc9d62a853069)($46529f8f9a8202ca$var$SliderTimelineModel, (0, $36ff81ce502a4a00$export$f23396ae04ea95a7).prototype);
var $46529f8f9a8202ca$export$2e2bcd8739ae039 = $46529f8f9a8202ca$var$SliderTimelineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $b8d5933bafe4ffdc$var$TimelineView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TimelineView, _super);
    function TimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = TimelineView.type;
        return _this;
    }
    TimelineView.type = 'timeline';
    return TimelineView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $b8d5933bafe4ffdc$export$2e2bcd8739ae039 = $b8d5933bafe4ffdc$var$TimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/**
 * Extend axis 2d
 */ var $a6dd9b6973857f9d$var$TimelineAxis = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(TimelineAxis, _super);
    function TimelineAxis(dim, scale, coordExtent, axisType) {
        var _this = _super.call(this, dim, scale, coordExtent) || this;
        _this.type = axisType || 'value';
        return _this;
    }
    /**
   * @override
   */ TimelineAxis.prototype.getLabelModel = function() {
        // Force override
        return this.model.getModel('label');
    };
    /**
   * @override
   */ TimelineAxis.prototype.isHorizontal = function() {
        return this.model.get('orient') === 'horizontal';
    };
    return TimelineAxis;
}((0, $099c976b90502319$export$2e2bcd8739ae039));
var $a6dd9b6973857f9d$export$2e2bcd8739ae039 = $a6dd9b6973857f9d$var$TimelineAxis;













var $f71273770c10dde4$var$PI = Math.PI;
var $f71273770c10dde4$var$labelDataIndexStore = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $f71273770c10dde4$var$SliderTimelineView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SliderTimelineView, _super);
    function SliderTimelineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderTimelineView.type;
        return _this;
    }
    SliderTimelineView.prototype.init = function(ecModel, api) {
        this.api = api;
    };
    /**
   * @override
   */ SliderTimelineView.prototype.render = function(timelineModel, ecModel, api) {
        this.model = timelineModel;
        this.api = api;
        this.ecModel = ecModel;
        this.group.removeAll();
        if (timelineModel.get('show', true)) {
            var layoutInfo_1 = this._layout(timelineModel, api);
            var mainGroup_1 = this._createGroup('_mainGroup');
            var labelGroup = this._createGroup('_labelGroup');
            var axis_1 = this._axis = this._createAxis(layoutInfo_1, timelineModel);
            timelineModel.formatTooltip = function(dataIndex) {
                var name = axis_1.scale.getLabel({
                    value: dataIndex
                });
                return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                    noName: true,
                    value: name
                });
            };
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
                'AxisLine',
                'AxisTick',
                'Control',
                'CurrentPointer'
            ], function(name) {
                this['_render' + name](layoutInfo_1, mainGroup_1, axis_1, timelineModel);
            }, this);
            this._renderAxisLabel(layoutInfo_1, labelGroup, axis_1, timelineModel);
            this._position(layoutInfo_1, timelineModel);
        }
        this._doPlayStop();
        this._updateTicksStatus();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.remove = function() {
        this._clearTimer();
        this.group.removeAll();
    };
    /**
   * @override
   */ SliderTimelineView.prototype.dispose = function() {
        this._clearTimer();
    };
    SliderTimelineView.prototype._layout = function(timelineModel, api) {
        var labelPosOpt = timelineModel.get([
            'label',
            'position'
        ]);
        var orient = timelineModel.get('orient');
        var viewRect = $f71273770c10dde4$var$getViewRect(timelineModel, api);
        var parsedLabelPos;
        // Auto label offset.
        if (labelPosOpt == null || labelPosOpt === 'auto') parsedLabelPos = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
        else if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(labelPosOpt)) parsedLabelPos = ({
            horizontal: {
                top: '-',
                bottom: '+'
            },
            vertical: {
                left: '-',
                right: '+'
            }
        })[orient][labelPosOpt];
        else // is number
        parsedLabelPos = labelPosOpt;
        var labelAlignMap = {
            horizontal: 'center',
            vertical: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'left' : 'right'
        };
        var labelBaselineMap = {
            horizontal: parsedLabelPos >= 0 || parsedLabelPos === '+' ? 'top' : 'bottom',
            vertical: 'middle'
        };
        var rotationMap = {
            horizontal: 0,
            vertical: $f71273770c10dde4$var$PI / 2
        };
        // Position
        var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
        var controlModel = timelineModel.getModel('controlStyle');
        var showControl = controlModel.get('show', true);
        var controlSize = showControl ? controlModel.get('itemSize') : 0;
        var controlGap = showControl ? controlModel.get('itemGap') : 0;
        var sizePlusGap = controlSize + controlGap;
        // Special label rotate.
        var labelRotation = timelineModel.get([
            'label',
            'rotate'
        ]) || 0;
        labelRotation = labelRotation * $f71273770c10dde4$var$PI / 180; // To radian.
        var playPosition;
        var prevBtnPosition;
        var nextBtnPosition;
        var controlPosition = controlModel.get('position', true);
        var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
        var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
        var showNextBtn = showControl && controlModel.get('showNextBtn', true);
        var xLeft = 0;
        var xRight = mainLength;
        // position[0] means left, position[1] means middle.
        if (controlPosition === 'left' || controlPosition === 'bottom') {
            showPlayBtn && (playPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                xLeft,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        } else {
            // 'top' 'right'
            showPlayBtn && (playPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
            showPrevBtn && (prevBtnPosition = [
                0,
                0
            ], xLeft += sizePlusGap);
            showNextBtn && (nextBtnPosition = [
                xRight - controlSize,
                0
            ], xRight -= sizePlusGap);
        }
        var axisExtent = [
            xLeft,
            xRight
        ];
        if (timelineModel.get('inverse')) axisExtent.reverse();
        return {
            viewRect: viewRect,
            mainLength: mainLength,
            orient: orient,
            rotation: rotationMap[orient],
            labelRotation: labelRotation,
            labelPosOpt: parsedLabelPos,
            labelAlign: timelineModel.get([
                'label',
                'align'
            ]) || labelAlignMap[orient],
            labelBaseline: timelineModel.get([
                'label',
                'verticalAlign'
            ]) || timelineModel.get([
                'label',
                'baseline'
            ]) || labelBaselineMap[orient],
            // Based on mainGroup.
            playPosition: playPosition,
            prevBtnPosition: prevBtnPosition,
            nextBtnPosition: nextBtnPosition,
            axisExtent: axisExtent,
            controlSize: controlSize,
            controlGap: controlGap
        };
    };
    SliderTimelineView.prototype._position = function(layoutInfo, timelineModel) {
        // Position is be called finally, because bounding rect is needed for
        // adapt content to fill viewRect (auto adapt offset).
        // Timeline may be not all in the viewRect when 'offset' is specified
        // as a number, because it is more appropriate that label aligns at
        // 'offset' but not the other edge defined by viewRect.
        var mainGroup = this._mainGroup;
        var labelGroup = this._labelGroup;
        var viewRect = layoutInfo.viewRect;
        if (layoutInfo.orient === 'vertical') {
            // transform to horizontal, inverse rotate by left-top point.
            var m = $78537c687449356c$export$185802fd694ee1f5();
            var rotateOriginX = viewRect.x;
            var rotateOriginY = viewRect.y + viewRect.height;
            $78537c687449356c$export$d73ee8ef04f5226a(m, m, [
                -rotateOriginX,
                -rotateOriginY
            ]);
            $78537c687449356c$export$bb628a54ab399bc9(m, m, -$f71273770c10dde4$var$PI / 2);
            $78537c687449356c$export$d73ee8ef04f5226a(m, m, [
                rotateOriginX,
                rotateOriginY
            ]);
            viewRect = viewRect.clone();
            viewRect.applyTransform(m);
        }
        var viewBound = getBound(viewRect);
        var mainBound = getBound(mainGroup.getBoundingRect());
        var labelBound = getBound(labelGroup.getBoundingRect());
        var mainPosition = [
            mainGroup.x,
            mainGroup.y
        ];
        var labelsPosition = [
            labelGroup.x,
            labelGroup.y
        ];
        labelsPosition[0] = mainPosition[0] = viewBound[0][0];
        var labelPosOpt = layoutInfo.labelPosOpt;
        if (labelPosOpt == null || (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(labelPosOpt)) {
            // '+' or '-'
            var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
        } else {
            var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
            toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
            labelsPosition[1] = mainPosition[1] + labelPosOpt;
        }
        mainGroup.setPosition(mainPosition);
        labelGroup.setPosition(labelsPosition);
        mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
        setOrigin(mainGroup);
        setOrigin(labelGroup);
        function setOrigin(targetGroup) {
            targetGroup.originX = viewBound[0][0] - targetGroup.x;
            targetGroup.originY = viewBound[1][0] - targetGroup.y;
        }
        function getBound(rect) {
            // [[xmin, xmax], [ymin, ymax]]
            return [
                [
                    rect.x,
                    rect.x + rect.width
                ],
                [
                    rect.y,
                    rect.y + rect.height
                ]
            ];
        }
        function toBound(fromPos, from, to, dimIdx, boundIdx) {
            fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
        }
    };
    SliderTimelineView.prototype._createAxis = function(layoutInfo, timelineModel) {
        var data = timelineModel.getData();
        var axisType = timelineModel.get('axisType');
        var scale = $f71273770c10dde4$var$createScaleByModel(timelineModel, axisType);
        // Customize scale. The `tickValue` is `dataIndex`.
        scale.getTicks = function() {
            return data.mapArray([
                'value'
            ], function(value) {
                return {
                    value: value
                };
            });
        };
        var dataExtent = data.getDataExtent('value');
        scale.setExtent(dataExtent[0], dataExtent[1]);
        scale.calcNiceTicks();
        var axis = new (0, $a6dd9b6973857f9d$export$2e2bcd8739ae039)('value', scale, layoutInfo.axisExtent, axisType);
        axis.model = timelineModel;
        return axis;
    };
    SliderTimelineView.prototype._createGroup = function(key) {
        var newGroup = this[key] = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this.group.add(newGroup);
        return newGroup;
    };
    SliderTimelineView.prototype._renderAxisLine = function(layoutInfo, group, axis, timelineModel) {
        var axisExtent = axis.getExtent();
        if (!timelineModel.get([
            'lineStyle',
            'show'
        ])) return;
        var line = new $8324e8379a5583a5$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                y1: 0,
                x2: axisExtent[1],
                y2: 0
            },
            style: (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({
                lineCap: 'round'
            }, timelineModel.getModel('lineStyle').getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(line);
        var progressLine = this._progressLine = new $8324e8379a5583a5$export$2e2bcd8739ae039({
            shape: {
                x1: axisExtent[0],
                x2: this._currentPointer ? this._currentPointer.x : axisExtent[0],
                y1: 0,
                y2: 0
            },
            style: (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
                lineCap: 'round',
                lineWidth: line.style.lineWidth
            }, timelineModel.getModel([
                'progress',
                'lineStyle'
            ]).getLineStyle()),
            silent: true,
            z2: 1
        });
        group.add(progressLine);
    };
    SliderTimelineView.prototype._renderAxisTick = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var data = timelineModel.getData();
        // Show all ticks, despite ignoring strategy.
        var ticks = axis.scale.getTicks();
        this._tickSymbols = [];
        // The value is dataIndex, see the customized scale.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(ticks, function(tick) {
            var tickCoord = axis.dataToCoord(tick.value);
            var itemModel = data.getItemModel(tick.value);
            var itemStyleModel = itemModel.getModel('itemStyle');
            var hoverStyleModel = itemModel.getModel([
                'emphasis',
                'itemStyle'
            ]);
            var progressStyleModel = itemModel.getModel([
                'progress',
                'itemStyle'
            ]);
            var symbolOpt = {
                x: tickCoord,
                y: 0,
                onclick: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this._changeTimeline, _this, tick.value)
            };
            var el = $f71273770c10dde4$var$giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
            el.ensureState('emphasis').style = hoverStyleModel.getItemStyle();
            el.ensureState('progress').style = progressStyleModel.getItemStyle();
            (0, $b414df7d361a211c$export$5f393df0b5aee2e7)(el);
            var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
            if (itemModel.get('tooltip')) {
                ecData.dataIndex = tick.value;
                ecData.dataModel = timelineModel;
            } else ecData.dataIndex = ecData.dataModel = null;
            _this._tickSymbols.push(el);
        });
    };
    SliderTimelineView.prototype._renderAxisLabel = function(layoutInfo, group, axis, timelineModel) {
        var _this = this;
        var labelModel = axis.getLabelModel();
        if (!labelModel.get('show')) return;
        var data = timelineModel.getData();
        var labels = axis.getViewLabels();
        this._tickLabels = [];
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(labels, function(labelItem) {
            // The tickValue is dataIndex, see the customized scale.
            var dataIndex = labelItem.tickValue;
            var itemModel = data.getItemModel(dataIndex);
            var normalLabelModel = itemModel.getModel('label');
            var hoverLabelModel = itemModel.getModel([
                'emphasis',
                'label'
            ]);
            var progressLabelModel = itemModel.getModel([
                'progress',
                'label'
            ]);
            var tickCoord = axis.dataToCoord(labelItem.tickValue);
            var textEl = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                x: tickCoord,
                y: 0,
                rotation: layoutInfo.labelRotation - layoutInfo.rotation,
                onclick: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(_this._changeTimeline, _this, dataIndex),
                silent: false,
                style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(normalLabelModel, {
                    text: labelItem.formattedLabel,
                    align: layoutInfo.labelAlign,
                    verticalAlign: layoutInfo.labelBaseline
                })
            });
            textEl.ensureState('emphasis').style = (0, $3828198b2f2de836$export$f8998c3d0a13de59)(hoverLabelModel);
            textEl.ensureState('progress').style = (0, $3828198b2f2de836$export$f8998c3d0a13de59)(progressLabelModel);
            group.add(textEl);
            (0, $b414df7d361a211c$export$5f393df0b5aee2e7)(textEl);
            $f71273770c10dde4$var$labelDataIndexStore(textEl).dataIndex = dataIndex;
            _this._tickLabels.push(textEl);
        });
    };
    SliderTimelineView.prototype._renderControl = function(layoutInfo, group, axis, timelineModel) {
        var controlSize = layoutInfo.controlSize;
        var rotation = layoutInfo.rotation;
        var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
        var hoverStyle = timelineModel.getModel([
            'emphasis',
            'controlStyle'
        ]).getItemStyle();
        var playState = timelineModel.getPlayState();
        var inverse = timelineModel.get('inverse', true);
        makeBtn(layoutInfo.nextBtnPosition, 'next', (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? '-' : '+'));
        makeBtn(layoutInfo.prevBtnPosition, 'prev', (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._changeTimeline, this, inverse ? '+' : '-'));
        makeBtn(layoutInfo.playPosition, playState ? 'stop' : 'play', (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._handlePlayClick, this, !playState), true);
        function makeBtn(position, iconName, onclick, willRotate) {
            if (!position) return;
            var iconSize = (0, $297531217517fbce$export$e8514cb5a5e2b40f)((0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(timelineModel.get([
                'controlStyle',
                iconName + 'BtnSize'
            ]), controlSize), controlSize);
            var rect = [
                0,
                -iconSize / 2,
                iconSize,
                iconSize
            ];
            var btn = $f71273770c10dde4$var$makeControlIcon(timelineModel, iconName + 'Icon', rect, {
                x: position[0],
                y: position[1],
                originX: controlSize / 2,
                originY: 0,
                rotation: willRotate ? -rotation : 0,
                rectHover: true,
                style: itemStyle,
                onclick: onclick
            });
            btn.ensureState('emphasis').style = hoverStyle;
            group.add(btn);
            (0, $b414df7d361a211c$export$5f393df0b5aee2e7)(btn);
        }
    };
    SliderTimelineView.prototype._renderCurrentPointer = function(layoutInfo, group, axis, timelineModel) {
        var data = timelineModel.getData();
        var currentIndex = timelineModel.getCurrentIndex();
        var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
        var me = this;
        var callback = {
            onCreate: function(pointer) {
                pointer.draggable = true;
                pointer.drift = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(me._handlePointerDrag, me);
                pointer.ondragend = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(me._handlePointerDragend, me);
                $f71273770c10dde4$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel, true);
            },
            onUpdate: function(pointer) {
                $f71273770c10dde4$var$pointerMoveTo(pointer, me._progressLine, currentIndex, axis, timelineModel);
            }
        };
        // Reuse when exists, for animation and drag.
        this._currentPointer = $f71273770c10dde4$var$giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
    };
    SliderTimelineView.prototype._handlePlayClick = function(nextState) {
        this._clearTimer();
        this.api.dispatchAction({
            type: 'timelinePlayChange',
            playState: nextState,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._handlePointerDrag = function(dx, dy, e) {
        this._clearTimer();
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ]);
    };
    SliderTimelineView.prototype._handlePointerDragend = function(e) {
        this._pointerChangeTimeline([
            e.offsetX,
            e.offsetY
        ], true);
    };
    SliderTimelineView.prototype._pointerChangeTimeline = function(mousePos, trigger) {
        var toCoord = this._toAxisCoord(mousePos)[0];
        var axis = this._axis;
        var axisExtent = $9fd90cf3bf18fbcd$export$debe6e778e0a6d32(axis.getExtent().slice());
        toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
        toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
        this._currentPointer.x = toCoord;
        this._currentPointer.markRedraw();
        var progressLine = this._progressLine;
        if (progressLine) {
            progressLine.shape.x2 = toCoord;
            progressLine.dirty();
        }
        var targetDataIndex = this._findNearestTick(toCoord);
        var timelineModel = this.model;
        if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) this._changeTimeline(targetDataIndex);
    };
    SliderTimelineView.prototype._doPlayStop = function() {
        var _this = this;
        this._clearTimer();
        if (this.model.getPlayState()) this._timer = setTimeout(function() {
            // Do not cache
            var timelineModel = _this.model;
            _this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
        }, this.model.get('playInterval'));
    };
    SliderTimelineView.prototype._toAxisCoord = function(vertex) {
        var trans = this._mainGroup.getLocalTransform();
        return $8eb95236e1aa01e7$export$9f9dcb98c894b623(vertex, trans, true);
    };
    SliderTimelineView.prototype._findNearestTick = function(axisCoord) {
        var data = this.model.getData();
        var dist = Infinity;
        var targetDataIndex;
        var axis = this._axis;
        data.each([
            'value'
        ], function(value, dataIndex) {
            var coord = axis.dataToCoord(value);
            var d = Math.abs(coord - axisCoord);
            if (d < dist) {
                dist = d;
                targetDataIndex = dataIndex;
            }
        });
        return targetDataIndex;
    };
    SliderTimelineView.prototype._clearTimer = function() {
        if (this._timer) {
            clearTimeout(this._timer);
            this._timer = null;
        }
    };
    SliderTimelineView.prototype._changeTimeline = function(nextIndex) {
        var currentIndex = this.model.getCurrentIndex();
        if (nextIndex === '+') nextIndex = currentIndex + 1;
        else if (nextIndex === '-') nextIndex = currentIndex - 1;
        this.api.dispatchAction({
            type: 'timelineChange',
            currentIndex: nextIndex,
            from: this.uid
        });
    };
    SliderTimelineView.prototype._updateTicksStatus = function() {
        var currentIndex = this.model.getCurrentIndex();
        var tickSymbols = this._tickSymbols;
        var tickLabels = this._tickLabels;
        if (tickSymbols) for(var i = 0; i < tickSymbols.length; i++)tickSymbols && tickSymbols[i] && tickSymbols[i].toggleState('progress', i < currentIndex);
        if (tickLabels) for(var i = 0; i < tickLabels.length; i++)tickLabels && tickLabels[i] && tickLabels[i].toggleState('progress', $f71273770c10dde4$var$labelDataIndexStore(tickLabels[i]).dataIndex <= currentIndex);
    };
    SliderTimelineView.type = 'timeline.slider';
    return SliderTimelineView;
}((0, $b8d5933bafe4ffdc$export$2e2bcd8739ae039));
function $f71273770c10dde4$var$createScaleByModel(model, axisType) {
    axisType = axisType || model.get('type');
    if (axisType) switch(axisType){
        // Buildin scale
        case 'category':
            return new (0, $0c02dcf77630eefb$export$2e2bcd8739ae039)({
                ordinalMeta: model.getCategories(),
                extent: [
                    Infinity,
                    -Infinity
                ]
            });
        case 'time':
            return new (0, $998964b027d914e1$export$2e2bcd8739ae039)({
                locale: model.ecModel.getLocaleModel(),
                useUTC: model.ecModel.get('useUTC')
            });
        default:
            // default to be value
            return new (0, $2388fa31203c7d49$export$2e2bcd8739ae039)();
    }
}
function $f71273770c10dde4$var$getViewRect(model, api) {
    return $501dc28f6c4d24ac$export$4517a5ca639a7293(model.getBoxLayoutParams(), {
        width: api.getWidth(),
        height: api.getHeight()
    }, model.get('padding'));
}
function $f71273770c10dde4$var$makeControlIcon(timelineModel, objPath, rect, opts) {
    var style = opts.style;
    var icon = $8eb95236e1aa01e7$export$274edc73af1ae9c8(timelineModel.get([
        'controlStyle',
        objPath
    ]), opts || {}, new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(rect[0], rect[1], rect[2], rect[3]));
    // TODO createIcon won't use style in opt.
    if (style) icon.setStyle(style);
    return icon;
}
/**
 * Create symbol or update symbol
 * opt: basic position and event handlers
 */ function $f71273770c10dde4$var$giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
    var color = itemStyleModel.get('color');
    if (!symbol) {
        var symbolType = hostModel.get('symbol');
        symbol = (0, $da6220012439db7b$export$af050e04da3a02e8)(symbolType, -1, -1, 2, 2, color);
        symbol.setStyle('strokeNoScale', true);
        group.add(symbol);
        callback && callback.onCreate(symbol);
    } else {
        symbol.setColor(color);
        group.add(symbol); // Group may be new, also need to add.
        callback && callback.onUpdate(symbol);
    }
    // Style
    var itemStyle = itemStyleModel.getItemStyle([
        'color'
    ]);
    symbol.setStyle(itemStyle);
    // Transform and events.
    opt = (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)({
        rectHover: true,
        z2: 100
    }, opt, true);
    var symbolSize = (0, $da6220012439db7b$export$a84524f03e8e8dfb)(hostModel.get('symbolSize'));
    opt.scaleX = symbolSize[0] / 2;
    opt.scaleY = symbolSize[1] / 2;
    var symbolOffset = (0, $da6220012439db7b$export$e3e292895c033f6d)(hostModel.get('symbolOffset'), symbolSize);
    if (symbolOffset) {
        opt.x = (opt.x || 0) + symbolOffset[0];
        opt.y = (opt.y || 0) + symbolOffset[1];
    }
    var symbolRotate = hostModel.get('symbolRotate');
    opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
    symbol.attr(opt);
    // FIXME
    // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
    // getBoundingRect will return wrong result.
    // (This is supposed to be resolved in zrender, but it is a little difficult to
    // leverage performance and auto updateTransform)
    // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
    symbol.updateTransform();
    return symbol;
}
function $f71273770c10dde4$var$pointerMoveTo(pointer, progressLine, dataIndex, axis, timelineModel, noAnimation) {
    if (pointer.dragging) return;
    var pointerModel = timelineModel.getModel('checkpointStyle');
    var toCoord = axis.dataToCoord(timelineModel.getData().get('value', dataIndex));
    if (noAnimation || !pointerModel.get('animation', true)) {
        pointer.attr({
            x: toCoord,
            y: 0
        });
        progressLine && progressLine.attr({
            shape: {
                x2: toCoord
            }
        });
    } else {
        var animationCfg = {
            duration: pointerModel.get('animationDuration', true),
            easing: pointerModel.get('animationEasing', true)
        };
        pointer.stopAnimation(null, true);
        pointer.animateTo({
            x: toCoord,
            y: 0
        }, animationCfg);
        progressLine && progressLine.animateTo({
            shape: {
                x2: toCoord
            }
        }, animationCfg);
    }
}
var $f71273770c10dde4$export$2e2bcd8739ae039 = $f71273770c10dde4$var$SliderTimelineView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $8cadd35e26e56d01$export$780c34b7cfe44e86(registers) {
    registers.registerAction({
        type: 'timelineChange',
        event: 'timelineChanged',
        update: 'prepareAndUpdate'
    }, function(payload, ecModel, api) {
        var timelineModel = ecModel.getComponent('timeline');
        if (timelineModel && payload.currentIndex != null) {
            timelineModel.setCurrentIndex(payload.currentIndex);
            if (!timelineModel.get('loop', true) && timelineModel.isIndexMax() && timelineModel.getPlayState()) {
                timelineModel.setPlayState(false);
                // The timeline has played to the end, trigger event
                api.dispatchAction({
                    type: 'timelinePlayChange',
                    playState: false,
                    from: payload.from
                });
            }
        }
        // Set normalized currentIndex to payload.
        ecModel.resetOption('timeline', {
            replaceMerge: timelineModel.get('replaceMerge', true)
        });
        return (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
            currentIndex: timelineModel.option.currentIndex
        }, payload);
    });
    registers.registerAction({
        type: 'timelinePlayChange',
        event: 'timelinePlayChanged',
        update: 'update'
    }, function(payload, ecModel) {
        var timelineModel = ecModel.getComponent('timeline');
        if (timelineModel && payload.playState != null) timelineModel.setPlayState(payload.playState);
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

function $329c9362a3dc2c31$export$2e2bcd8739ae039(option) {
    var timelineOpt = option && option.timeline;
    if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(timelineOpt)) timelineOpt = timelineOpt ? [
        timelineOpt
    ] : [];
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(timelineOpt, function(opt) {
        if (!opt) return;
        $329c9362a3dc2c31$var$compatibleEC2(opt);
    });
}
function $329c9362a3dc2c31$var$compatibleEC2(opt) {
    var type = opt.type;
    var ec2Types = {
        'number': 'value',
        'time': 'time'
    };
    // Compatible with ec2
    if (ec2Types[type]) {
        opt.axisType = ec2Types[type];
        delete opt.type;
    }
    $329c9362a3dc2c31$var$transferItem(opt);
    if ($329c9362a3dc2c31$var$has(opt, 'controlPosition')) {
        var controlStyle = opt.controlStyle || (opt.controlStyle = {});
        if (!$329c9362a3dc2c31$var$has(controlStyle, 'position')) controlStyle.position = opt.controlPosition;
        if (controlStyle.position === 'none' && !$329c9362a3dc2c31$var$has(controlStyle, 'show')) {
            controlStyle.show = false;
            delete controlStyle.position;
        }
        delete opt.controlPosition;
    }
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(opt.data || [], function(dataItem) {
        if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(dataItem) && !$1b239fc9d3a2f8ae$export$43bee75e5e14138e(dataItem)) {
            if (!$329c9362a3dc2c31$var$has(dataItem, 'value') && $329c9362a3dc2c31$var$has(dataItem, 'name')) // In ec2, using name as value.
            dataItem.value = dataItem.name;
            $329c9362a3dc2c31$var$transferItem(dataItem);
        }
    });
}
function $329c9362a3dc2c31$var$transferItem(opt) {
    var itemStyle = opt.itemStyle || (opt.itemStyle = {});
    var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {});
    // Transfer label out
    var label = opt.label || opt.label || {};
    var labelNormal = label.normal || (label.normal = {});
    var excludeLabelAttr = {
        normal: 1,
        emphasis: 1
    };
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(label, function(value, name) {
        if (!excludeLabelAttr[name] && !$329c9362a3dc2c31$var$has(labelNormal, name)) labelNormal[name] = value;
    });
    if (itemStyleEmphasis.label && !$329c9362a3dc2c31$var$has(label, 'emphasis')) {
        label.emphasis = itemStyleEmphasis.label;
        delete itemStyleEmphasis.label;
    }
}
function $329c9362a3dc2c31$var$has(obj, attr) {
    return obj.hasOwnProperty(attr);
}


function $ee7f1f710d7dd7b8$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $46529f8f9a8202ca$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $f71273770c10dde4$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter('timeline', function() {
        // Only slider now.
        return 'slider';
    });
    (0, $8cadd35e26e56d01$export$780c34b7cfe44e86)(registers);
    registers.registerPreprocessor((0, $329c9362a3dc2c31$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $06b11b2303133840$export$2e2bcd8739ae039(seriesOpts, markerType) {
    if (!seriesOpts) return false;
    var seriesOptArr = (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(seriesOpts) ? seriesOpts : [
        seriesOpts
    ];
    for(var idx = 0; idx < seriesOptArr.length; idx++){
        if (seriesOptArr[idx] && seriesOptArr[idx][markerType]) return true;
    }
    return false;
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






function $024def422baea00f$var$fillLabel(opt) {
    (0, $9ac03c46e8b6e711$export$abdcc6a26372f94b)(opt, 'label', [
        'show'
    ]);
}
// { [componentType]: MarkerModel }
var $024def422baea00f$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $024def422baea00f$var$MarkerModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkerModel, _super);
    function MarkerModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerModel.type;
        /**
     * If marker model is created by self from series
     */ _this.createdBySelf = false;
        return _this;
    }
    /**
   * @overrite
   */ MarkerModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        this._mergeOption(option, ecModel, false, true);
    };
    MarkerModel.prototype.isAnimationEnabled = function() {
        if ((0, $ab22291f3e1e51d6$export$2e2bcd8739ae039).node) return false;
        var hostSeries = this.__hostSeries;
        return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
    };
    /**
   * @overrite
   */ MarkerModel.prototype.mergeOption = function(newOpt, ecModel) {
        this._mergeOption(newOpt, ecModel, false, false);
    };
    MarkerModel.prototype._mergeOption = function(newOpt, ecModel, createdBySelf, isInit) {
        var componentType = this.mainType;
        if (!createdBySelf) ecModel.eachSeries(function(seriesModel) {
            // mainType can be markPoint, markLine, markArea
            var markerOpt = seriesModel.get(this.mainType, true);
            var markerModel = $024def422baea00f$var$inner(seriesModel)[componentType];
            if (!markerOpt || !markerOpt.data) {
                $024def422baea00f$var$inner(seriesModel)[componentType] = null;
                return;
            }
            if (!markerModel) {
                if (isInit) // Default label emphasis `position` and `show`
                $024def422baea00f$var$fillLabel(markerOpt);
                $1b239fc9d3a2f8ae$export$79b2f7037acddd43(markerOpt.data, function(item) {
                    // FIXME Overwrite fillLabel method ?
                    if (item instanceof Array) {
                        $024def422baea00f$var$fillLabel(item[0]);
                        $024def422baea00f$var$fillLabel(item[1]);
                    } else $024def422baea00f$var$fillLabel(item);
                });
                markerModel = this.createMarkerModelFromSeries(markerOpt, this, ecModel);
                // markerModel = new ImplementedMarkerModel(
                //     markerOpt, this, ecModel
                // );
                $1b239fc9d3a2f8ae$export$8b58be045bf06082(markerModel, {
                    mainType: this.mainType,
                    // Use the same series index and name
                    seriesIndex: seriesModel.seriesIndex,
                    name: seriesModel.name,
                    createdBySelf: true
                });
                markerModel.__hostSeries = seriesModel;
            } else markerModel._mergeOption(markerOpt, ecModel, true);
            $024def422baea00f$var$inner(seriesModel)[componentType] = markerModel;
        }, this);
    };
    MarkerModel.prototype.formatTooltip = function(dataIndex, multipleSeries, dataType) {
        var data = this.getData();
        var value = this.getRawValue(dataIndex);
        var itemName = data.getName(dataIndex);
        return (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('section', {
            header: this.name,
            blocks: [
                (0, $6ceb7d0f0435c9d1$export$cf63b23ce77d1921)('nameValue', {
                    name: itemName,
                    value: value,
                    noName: !itemName,
                    noValue: value == null
                })
            ]
        });
    };
    MarkerModel.prototype.getData = function() {
        return this._data;
    };
    MarkerModel.prototype.setData = function(data) {
        this._data = data;
    };
    MarkerModel.prototype.getDataParams = function(dataIndex, dataType) {
        var params = (0, $36ff81ce502a4a00$export$f23396ae04ea95a7).prototype.getDataParams.call(this, dataIndex, dataType);
        var hostSeries = this.__hostSeries;
        if (hostSeries) {
            params.seriesId = hostSeries.id;
            params.seriesName = hostSeries.name;
            params.seriesType = hostSeries.subType;
        }
        return params;
    };
    MarkerModel.getMarkerModelFromSeries = function(seriesModel, // Support three types of markers. Strict check.
    componentType) {
        return $024def422baea00f$var$inner(seriesModel)[componentType];
    };
    MarkerModel.type = 'marker';
    MarkerModel.dependencies = [
        'series',
        'grid',
        'polar',
        'geo'
    ];
    return MarkerModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
$1b239fc9d3a2f8ae$export$e36fc9d62a853069($024def422baea00f$var$MarkerModel, (0, $36ff81ce502a4a00$export$f23396ae04ea95a7).prototype);
var $024def422baea00f$export$2e2bcd8739ae039 = $024def422baea00f$var$MarkerModel;


var $52289d8f4dfc7334$var$MarkPointModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkPointModel, _super);
    function MarkPointModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointModel.type;
        return _this;
    }
    MarkPointModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkPointModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkPointModel.type = 'markPoint';
    MarkPointModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: 'pin',
        symbolSize: 50,
        // symbolRotate: 0,
        // symbolOffset: [0, 0]
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'inside'
        },
        itemStyle: {
            borderWidth: 2
        },
        emphasis: {
            label: {
                show: true
            }
        }
    };
    return MarkPointModel;
}((0, $024def422baea00f$export$2e2bcd8739ae039));
var $52289d8f4dfc7334$export$2e2bcd8739ae039 = $52289d8f4dfc7334$var$MarkPointModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



function $83afc660f32ac756$var$hasXOrY(item) {
    return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
}
function $83afc660f32ac756$var$hasXAndY(item) {
    return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
}
function $83afc660f32ac756$var$markerTypeCalculatorWithExtent(markerType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
    var coordArr = [];
    var stacked = (0, $495dfc021fe3a3f7$export$1dedc39359ae35c)(data, targetDataDim /* , otherDataDim */ );
    var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
    var value = $83afc660f32ac756$export$18ddefb55c03640b(data, calcDataDim, markerType);
    var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
    coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
    coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
    var coordArrValue = data.get(targetDataDim, dataIndex);
    // Make it simple, do not visit all stacked value to count precision.
    var precision = $9fd90cf3bf18fbcd$export$e0c74b50bbd10f68(data.get(targetDataDim, dataIndex));
    precision = Math.min(precision, 20);
    if (precision >= 0) coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
    return [
        coordArr,
        coordArrValue
    ];
}
// TODO Specified percent
var $83afc660f32ac756$var$markerTypeCalculator = {
    min: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($83afc660f32ac756$var$markerTypeCalculatorWithExtent, 'min'),
    max: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($83afc660f32ac756$var$markerTypeCalculatorWithExtent, 'max'),
    average: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($83afc660f32ac756$var$markerTypeCalculatorWithExtent, 'average'),
    median: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($83afc660f32ac756$var$markerTypeCalculatorWithExtent, 'median')
};
function $83afc660f32ac756$export$3eebd2d54b98c04f(seriesModel, item) {
    if (!item) return;
    var data = seriesModel.getData();
    var coordSys = seriesModel.coordinateSystem;
    var dims = coordSys && coordSys.dimensions;
    // 1. If not specify the position with pixel directly
    // 2. If `coord` is not a data array. Which uses `xAxis`,
    // `yAxis` to specify the coord on each dimension
    // parseFloat first because item.x and item.y can be percent string like '20%'
    if (!$83afc660f32ac756$var$hasXAndY(item) && !(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(item.coord) && (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(dims)) {
        var axisInfo = $83afc660f32ac756$export$bd39458db76002ab(item, data, coordSys, seriesModel);
        // Clone the option
        // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
        item = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(item);
        if (item.type && $83afc660f32ac756$var$markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
            var otherCoordIndex = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(dims, axisInfo.baseAxis.dim);
            var targetCoordIndex = (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(dims, axisInfo.valueAxis.dim);
            var coordInfo = $83afc660f32ac756$var$markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
            item.coord = coordInfo[0];
            // Force to use the value of calculated value.
            // let item use the value without stack.
            item.value = coordInfo[1];
        } else // FIXME Only has one of xAxis and yAxis.
        item.coord = [
            item.xAxis != null ? item.xAxis : item.radiusAxis,
            item.yAxis != null ? item.yAxis : item.angleAxis
        ];
    }
    // x y is provided
    if (item.coord == null || !(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(dims)) item.coord = [];
    else {
        // Each coord support max, min, average
        var coord = item.coord;
        for(var i = 0; i < 2; i++)if ($83afc660f32ac756$var$markerTypeCalculator[coord[i]]) coord[i] = $83afc660f32ac756$export$18ddefb55c03640b(data, data.mapDimension(dims[i]), coord[i]);
    }
    return item;
}
function $83afc660f32ac756$export$bd39458db76002ab(item, data, coordSys, seriesModel) {
    var ret = {};
    if (item.valueIndex != null || item.valueDim != null) {
        ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
        ret.valueAxis = coordSys.getAxis($83afc660f32ac756$var$dataDimToCoordDim(seriesModel, ret.valueDataDim));
        ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
    } else {
        ret.baseAxis = seriesModel.getBaseAxis();
        ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
        ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
        ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
    }
    return ret;
}
function $83afc660f32ac756$var$dataDimToCoordDim(seriesModel, dataDim) {
    var dimItem = seriesModel.getData().getDimensionInfo(dataDim);
    return dimItem && dimItem.coordDim;
}
function $83afc660f32ac756$export$179695f4a9040f73(// Currently only polar and cartesian has containData.
coordSys, item) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containData && item.coord && !$83afc660f32ac756$var$hasXOrY(item) ? coordSys.containData(item.coord) : true;
}
function $83afc660f32ac756$export$c869311b63462da6(// Currently only polar and cartesian has containData.
coordSys, item1, item2) {
    // Always return true if there is no coordSys
    return coordSys && coordSys.containZone && item1.coord && item2.coord && !$83afc660f32ac756$var$hasXOrY(item1) && !$83afc660f32ac756$var$hasXOrY(item2) ? coordSys.containZone(item1.coord, item2.coord) : true;
}
function $83afc660f32ac756$export$a53767c3c8f69cf7(inCoordSys, dims) {
    return inCoordSys ? function(item, dimName, dataIndex, dimIndex) {
        var rawVal = dimIndex < 2 ? item.coord && item.coord[dimIndex] : item.value;
        return (0, $b0b05721170d73df$export$cc7175145baad076)(rawVal, dims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $b0b05721170d73df$export$cc7175145baad076)(item.value, dims[dimIndex]);
    };
}
function $83afc660f32ac756$export$18ddefb55c03640b(data, valueDataDim, type) {
    if (type === 'average') {
        var sum_1 = 0;
        var count_1 = 0;
        data.each(valueDataDim, function(val, idx) {
            if (!isNaN(val)) {
                sum_1 += val;
                count_1++;
            }
        });
        return sum_1 / count_1;
    } else if (type === 'median') return data.getMedian(valueDataDim);
    else // max & min
    return data.getDataExtent(valueDataDim)[type === 'max' ? 1 : 0];
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 





var $8428d84f33d296e6$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $8428d84f33d296e6$var$MarkerView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkerView, _super);
    function MarkerView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkerView.type;
        return _this;
    }
    MarkerView.prototype.init = function() {
        this.markerGroupMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    };
    MarkerView.prototype.render = function(markerModel, ecModel, api) {
        var _this = this;
        var markerGroupMap = this.markerGroupMap;
        markerGroupMap.each(function(item) {
            $8428d84f33d296e6$var$inner(item).keep = false;
        });
        ecModel.eachSeries(function(seriesModel) {
            var markerModel = (0, $024def422baea00f$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            markerModel && _this.renderSeries(seriesModel, markerModel, ecModel, api);
        });
        markerGroupMap.each(function(item) {
            !$8428d84f33d296e6$var$inner(item).keep && _this.group.remove(item.group);
        });
    };
    MarkerView.prototype.markKeep = function(drawGroup) {
        $8428d84f33d296e6$var$inner(drawGroup).keep = true;
    };
    MarkerView.prototype.toggleBlurSeries = function(seriesModelList, isBlur) {
        var _this = this;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(seriesModelList, function(seriesModel) {
            var markerModel = (0, $024def422baea00f$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, _this.type);
            if (markerModel) {
                var data = markerModel.getData();
                data.eachItemGraphicEl(function(el) {
                    if (el) isBlur ? (0, $b414df7d361a211c$export$207f9cb3e1099375)(el) : (0, $b414df7d361a211c$export$fd4a9ec75456d3c1)(el);
                });
            }
        });
    };
    MarkerView.type = 'marker';
    return MarkerView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $8428d84f33d296e6$export$2e2bcd8739ae039 = $8428d84f33d296e6$var$MarkerView;






function $0267d56a67607ad7$var$updateMarkerLayout(mpData, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    mpData.each(function(idx) {
        var itemModel = mpData.getItemModel(idx);
        var point;
        var xPx = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(itemModel.get('x'), api.getWidth());
        var yPx = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(itemModel.get('y'), api.getHeight());
        if (!isNaN(xPx) && !isNaN(yPx)) point = [
            xPx,
            yPx
        ];
        else if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
        else if (coordSys) {
            var x = mpData.get(coordSys.dimensions[0], idx);
            var y = mpData.get(coordSys.dimensions[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
        mpData.setItemLayout(idx, point);
    });
}
var $0267d56a67607ad7$var$MarkPointView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkPointView, _super);
    function MarkPointView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkPointView.type;
        return _this;
    }
    MarkPointView.prototype.updateTransform = function(markPointModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mpModel = (0, $024def422baea00f$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, 'markPoint');
            if (mpModel) {
                $0267d56a67607ad7$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkPointView.prototype.renderSeries = function(seriesModel, mpModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var symbolDrawMap = this.markerGroupMap;
        var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new (0, $89a14c17b9971b0f$export$2e2bcd8739ae039)());
        var mpData = $0267d56a67607ad7$var$createData(coordSys, seriesModel, mpModel);
        // FIXME
        mpModel.setData(mpData);
        $0267d56a67607ad7$var$updateMarkerLayout(mpModel.getData(), seriesModel, api);
        mpData.each(function(idx) {
            var itemModel = mpData.getItemModel(idx);
            var symbol = itemModel.getShallow('symbol');
            var symbolSize = itemModel.getShallow('symbolSize');
            var symbolRotate = itemModel.getShallow('symbolRotate');
            var symbolOffset = itemModel.getShallow('symbolOffset');
            var symbolKeepAspect = itemModel.getShallow('symbolKeepAspect');
            // TODO: refactor needed: single data item should not support callback function
            if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbol) || (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbolSize) || (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbolRotate) || (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbolOffset)) {
                var rawIdx = mpModel.getRawValue(idx);
                var dataParams = mpModel.getDataParams(idx);
                if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbol)) symbol = symbol(rawIdx, dataParams);
                if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbolSize)) // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
                symbolSize = symbolSize(rawIdx, dataParams);
                if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbolRotate)) symbolRotate = symbolRotate(rawIdx, dataParams);
                if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(symbolOffset)) symbolOffset = symbolOffset(rawIdx, dataParams);
            }
            var style = itemModel.getModel('itemStyle').getItemStyle();
            var color = (0, $aa7643c8305265d3$export$d76e333a86ea1a2)(seriesData, 'color');
            if (!style.fill) style.fill = color;
            mpData.setItemVisual(idx, {
                symbol: symbol,
                symbolSize: symbolSize,
                symbolRotate: symbolRotate,
                symbolOffset: symbolOffset,
                symbolKeepAspect: symbolKeepAspect,
                style: style
            });
        });
        // TODO Text are wrong
        symbolDraw.updateData(mpData);
        this.group.add(symbolDraw.group);
        // Set host model for tooltip
        // FIXME
        mpData.eachItemGraphicEl(function(el) {
            el.traverse(function(child) {
                (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(child).dataModel = mpModel;
            });
        });
        this.markKeep(symbolDraw);
        symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
    };
    MarkPointView.type = 'markPoint';
    return MarkPointView;
}((0, $8428d84f33d296e6$export$2e2bcd8739ae039));
function $0267d56a67607ad7$var$createData(coordSys, seriesModel, mpModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var mpData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(coordDimsInfos, mpModel);
    var dataOpt = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(mpModel.get('data'), (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($83afc660f32ac756$export$3eebd2d54b98c04f, seriesModel));
    if (coordSys) dataOpt = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(dataOpt, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($83afc660f32ac756$export$179695f4a9040f73, coordSys));
    var dimValueGetter = $83afc660f32ac756$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    mpData.initData(dataOpt, null, dimValueGetter);
    return mpData;
}
var $0267d56a67607ad7$export$2e2bcd8739ae039 = $0267d56a67607ad7$var$MarkPointView;


function $e20d8037bba036d7$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $52289d8f4dfc7334$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $0267d56a67607ad7$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $06b11b2303133840$export$2e2bcd8739ae039)(opt.series, 'markPoint')) // Make sure markPoint component is enabled
        opt.markPoint = opt.markPoint || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $250c49ffbb18cbb1$var$MarkLineModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkLineModel, _super);
    function MarkLineModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineModel.type;
        return _this;
    }
    MarkLineModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkLineModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkLineModel.type = 'markLine';
    MarkLineModel.defaultOption = {
        // zlevel: 0,
        z: 5,
        symbol: [
            'circle',
            'arrow'
        ],
        symbolSize: [
            8,
            16
        ],
        // symbolRotate: 0,
        symbolOffset: 0,
        precision: 2,
        tooltip: {
            trigger: 'item'
        },
        label: {
            show: true,
            position: 'end',
            distance: 5
        },
        lineStyle: {
            type: 'dashed'
        },
        emphasis: {
            label: {
                show: true
            },
            lineStyle: {
                width: 3
            }
        },
        animationEasing: 'linear'
    };
    return MarkLineModel;
}((0, $024def422baea00f$export$2e2bcd8739ae039));
var $250c49ffbb18cbb1$export$2e2bcd8739ae039 = $250c49ffbb18cbb1$var$MarkLineModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 












var $f433d25a846a3b03$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $f433d25a846a3b03$var$markLineTransform = function(seriesModel, coordSys, mlModel, item) {
    var data = seriesModel.getData();
    var itemArray;
    if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(item)) {
        // Special type markLine like 'min', 'max', 'average', 'median'
        var mlType = item.type;
        if (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' || item.xAxis != null || item.yAxis != null) {
            var valueAxis = void 0;
            var value = void 0;
            if (item.yAxis != null || item.xAxis != null) {
                valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
                value = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(item.yAxis, item.xAxis);
            } else {
                var axisInfo = $83afc660f32ac756$export$bd39458db76002ab(item, data, coordSys, seriesModel);
                valueAxis = axisInfo.valueAxis;
                var valueDataDim = (0, $495dfc021fe3a3f7$export$909db2be4938fbdf)(data, axisInfo.valueDataDim);
                value = $83afc660f32ac756$export$18ddefb55c03640b(data, valueDataDim, mlType);
            }
            var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
            var baseIndex = 1 - valueIndex;
            // Normized to 2d data with start and end point
            var mlFrom = (0, $1b239fc9d3a2f8ae$export$9cd59f9826255e47)(item);
            var mlTo = {
                coord: []
            };
            mlFrom.type = null;
            mlFrom.coord = [];
            mlFrom.coord[baseIndex] = -Infinity;
            mlTo.coord[baseIndex] = Infinity;
            var precision = mlModel.get('precision');
            if (precision >= 0 && (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(value)) value = +value.toFixed(Math.min(precision, 20));
            mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
            itemArray = [
                mlFrom,
                mlTo,
                {
                    type: mlType,
                    valueIndex: item.valueIndex,
                    // Force to use the value of calculated value.
                    value: value
                }
            ];
        } else itemArray = [];
    } else itemArray = item;
    var normalizedItem = [
        $83afc660f32ac756$export$3eebd2d54b98c04f(seriesModel, itemArray[0]),
        $83afc660f32ac756$export$3eebd2d54b98c04f(seriesModel, itemArray[1]),
        (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, itemArray[2])
    ];
    // Avoid line data type is extended by from(to) data type
    normalizedItem[2].type = normalizedItem[2].type || null;
    // Merge from option and to option into line option
    (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[0]);
    (0, $1b239fc9d3a2f8ae$export$4950aa0f605343fb)(normalizedItem[2], normalizedItem[1]);
    return normalizedItem;
};
function $f433d25a846a3b03$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markLine has one dim
function $f433d25a846a3b03$var$ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    var dimName = coordSys.dimensions[dimIndex];
    return $f433d25a846a3b03$var$isInfinity(fromCoord[otherDimIndex]) && $f433d25a846a3b03$var$isInfinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
}
function $f433d25a846a3b03$var$markLineFilter(coordSys, item) {
    if (coordSys.type === 'cartesian2d') {
        var fromCoord = item[0].coord;
        var toCoord = item[1].coord;
        // In case
        // {
        //  markLine: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($f433d25a846a3b03$var$ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || $f433d25a846a3b03$var$ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
    }
    return $83afc660f32ac756$export$179695f4a9040f73(coordSys, item[0]) && $83afc660f32ac756$export$179695f4a9040f73(coordSys, item[1]);
}
function $f433d25a846a3b03$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(itemModel.get('x'), api.getWidth());
    var yPx = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(itemModel.get('y'), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) // Use the getMarkerPosition
        point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
        else {
            var dims = coordSys.dimensions;
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            point = coordSys.dataToPoint([
                x,
                y
            ]);
        }
        // Expand line to the edge of grid if value on one axis is Inifnity
        // In case
        //  markLine: {
        //    data: [{
        //      yAxis: 2
        //      // or
        //      type: 'average'
        //    }]
        //  }
        if ((0, $9ca39efe18dd5899$export$8567506e6336616)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var dims = coordSys.dimensions;
            if ($f433d25a846a3b03$var$isInfinity(data.get(dims[0], idx))) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
            else if ($f433d25a846a3b03$var$isInfinity(data.get(dims[1], idx))) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    data.setItemLayout(idx, point);
}
var $f433d25a846a3b03$var$MarkLineView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkLineView, _super);
    function MarkLineView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkLineView.type;
        return _this;
    }
    MarkLineView.prototype.updateTransform = function(markLineModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var mlModel = (0, $024def422baea00f$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, 'markLine');
            if (mlModel) {
                var mlData_1 = mlModel.getData();
                var fromData_1 = $f433d25a846a3b03$var$inner(mlModel).from;
                var toData_1 = $f433d25a846a3b03$var$inner(mlModel).to;
                // Update visual and layout of from symbol and to symbol
                fromData_1.each(function(idx) {
                    $f433d25a846a3b03$var$updateSingleMarkerEndLayout(fromData_1, idx, true, seriesModel, api);
                    $f433d25a846a3b03$var$updateSingleMarkerEndLayout(toData_1, idx, false, seriesModel, api);
                });
                // Update layout of line
                mlData_1.each(function(idx) {
                    mlData_1.setItemLayout(idx, [
                        fromData_1.getItemLayout(idx),
                        toData_1.getItemLayout(idx)
                    ]);
                });
                this.markerGroupMap.get(seriesModel.id).updateLayout();
            }
        }, this);
    };
    MarkLineView.prototype.renderSeries = function(seriesModel, mlModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var lineDrawMap = this.markerGroupMap;
        var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new (0, $52292566d9cfa1f6$export$2e2bcd8739ae039)());
        this.group.add(lineDraw.group);
        var mlData = $f433d25a846a3b03$var$createList(coordSys, seriesModel, mlModel);
        var fromData = mlData.from;
        var toData = mlData.to;
        var lineData = mlData.line;
        $f433d25a846a3b03$var$inner(mlModel).from = fromData;
        $f433d25a846a3b03$var$inner(mlModel).to = toData;
        // Line data for tooltip and formatter
        mlModel.setData(lineData);
        // TODO
        // Functionally, `symbolSize` & `symbolOffset` can also be 2D array now.
        // But the related logic and type definition are not finished yet.
        // Finish it if required
        var symbolType = mlModel.get('symbol');
        var symbolSize = mlModel.get('symbolSize');
        var symbolRotate = mlModel.get('symbolRotate');
        var symbolOffset = mlModel.get('symbolOffset');
        // TODO: support callback function like markPoint
        if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(symbolType)) symbolType = [
            symbolType,
            symbolType
        ];
        if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(symbolSize)) symbolSize = [
            symbolSize,
            symbolSize
        ];
        if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(symbolRotate)) symbolRotate = [
            symbolRotate,
            symbolRotate
        ];
        if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(symbolOffset)) symbolOffset = [
            symbolOffset,
            symbolOffset
        ];
        // Update visual and layout of from symbol and to symbol
        mlData.from.each(function(idx) {
            updateDataVisualAndLayout(fromData, idx, true);
            updateDataVisualAndLayout(toData, idx, false);
        });
        // Update visual and layout of line
        lineData.each(function(idx) {
            var lineStyle = lineData.getItemModel(idx).getModel('lineStyle').getLineStyle();
            // lineData.setItemVisual(idx, {
            //     color: lineColor || fromData.getItemVisual(idx, 'color')
            // });
            lineData.setItemLayout(idx, [
                fromData.getItemLayout(idx),
                toData.getItemLayout(idx)
            ]);
            if (lineStyle.stroke == null) lineStyle.stroke = fromData.getItemVisual(idx, 'style').fill;
            lineData.setItemVisual(idx, {
                fromSymbolKeepAspect: fromData.getItemVisual(idx, 'symbolKeepAspect'),
                fromSymbolOffset: fromData.getItemVisual(idx, 'symbolOffset'),
                fromSymbolRotate: fromData.getItemVisual(idx, 'symbolRotate'),
                fromSymbolSize: fromData.getItemVisual(idx, 'symbolSize'),
                fromSymbol: fromData.getItemVisual(idx, 'symbol'),
                toSymbolKeepAspect: toData.getItemVisual(idx, 'symbolKeepAspect'),
                toSymbolOffset: toData.getItemVisual(idx, 'symbolOffset'),
                toSymbolRotate: toData.getItemVisual(idx, 'symbolRotate'),
                toSymbolSize: toData.getItemVisual(idx, 'symbolSize'),
                toSymbol: toData.getItemVisual(idx, 'symbol'),
                style: lineStyle
            });
        });
        lineDraw.updateData(lineData);
        // Set host model for tooltip
        // FIXME
        mlData.line.eachItemGraphicEl(function(el) {
            (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el).dataModel = mlModel;
            el.traverse(function(child) {
                (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(child).dataModel = mlModel;
            });
        });
        function updateDataVisualAndLayout(data, idx, isFrom) {
            var itemModel = data.getItemModel(idx);
            $f433d25a846a3b03$var$updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
            var style = itemModel.getModel('itemStyle').getItemStyle();
            if (style.fill == null) style.fill = (0, $aa7643c8305265d3$export$d76e333a86ea1a2)(seriesData, 'color');
            data.setItemVisual(idx, {
                symbolKeepAspect: itemModel.get('symbolKeepAspect'),
                // `0` should be considered as a valid value, so use `retrieve2` instead of `||`
                symbolOffset: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemModel.get('symbolOffset', true), symbolOffset[isFrom ? 0 : 1]),
                symbolRotate: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemModel.get('symbolRotate', true), symbolRotate[isFrom ? 0 : 1]),
                // TODO: when 2d array is supported, it should ignore parent
                symbolSize: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemModel.get('symbolSize'), symbolSize[isFrom ? 0 : 1]),
                symbol: (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(itemModel.get('symbol', true), symbolType[isFrom ? 0 : 1]),
                style: style
            });
        }
        this.markKeep(lineDraw);
        lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
    };
    MarkLineView.type = 'markLine';
    return MarkLineView;
}((0, $8428d84f33d296e6$export$2e2bcd8739ae039));
function $f433d25a846a3b03$var$createList(coordSys, seriesModel, mlModel) {
    var coordDimsInfos;
    if (coordSys) coordDimsInfos = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
        var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {};
        // In map series data don't have lng and lat dimension. Fallback to same with coordSys
        return (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, info), {
            name: coordDim,
            // DON'T use ordinalMeta to parse and collect ordinal.
            ordinalMeta: null
        });
    });
    else coordDimsInfos = [
        {
            name: 'value',
            type: 'float'
        }
    ];
    var fromData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    var toData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(coordDimsInfos, mlModel);
    // No dimensions
    var lineData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)([], mlModel);
    var optData = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(mlModel.get('data'), (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f433d25a846a3b03$var$markLineTransform, seriesModel, coordSys, mlModel));
    if (coordSys) optData = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(optData, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($f433d25a846a3b03$var$markLineFilter, coordSys));
    var dimValueGetter = $83afc660f32ac756$export$a53767c3c8f69cf7(!!coordSys, coordDimsInfos);
    fromData.initData((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(optData, function(item) {
        return item[0];
    }), null, dimValueGetter);
    toData.initData((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(optData, function(item) {
        return item[1];
    }), null, dimValueGetter);
    lineData.initData((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(optData, function(item) {
        return item[2];
    }));
    lineData.hasItemOption = true;
    return {
        from: fromData,
        to: toData,
        line: lineData
    };
}
var $f433d25a846a3b03$export$2e2bcd8739ae039 = $f433d25a846a3b03$var$MarkLineView;


function $b0e14ecf29a061c9$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $250c49ffbb18cbb1$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $f433d25a846a3b03$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $06b11b2303133840$export$2e2bcd8739ae039)(opt.series, 'markLine')) // Make sure markLine component is enabled
        opt.markLine = opt.markLine || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8afd89c6a13ddc50$var$MarkAreaModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkAreaModel, _super);
    function MarkAreaModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaModel.type;
        return _this;
    }
    MarkAreaModel.prototype.createMarkerModelFromSeries = function(markerOpt, masterMarkerModel, ecModel) {
        return new MarkAreaModel(markerOpt, masterMarkerModel, ecModel);
    };
    MarkAreaModel.type = 'markArea';
    MarkAreaModel.defaultOption = {
        // zlevel: 0,
        // PENDING
        z: 1,
        tooltip: {
            trigger: 'item'
        },
        // markArea should fixed on the coordinate system
        animation: false,
        label: {
            show: true,
            position: 'top'
        },
        itemStyle: {
            // color and borderColor default to use color from series
            // color: 'auto'
            // borderColor: 'auto'
            borderWidth: 0
        },
        emphasis: {
            label: {
                show: true,
                position: 'top'
            }
        }
    };
    return MarkAreaModel;
}((0, $024def422baea00f$export$2e2bcd8739ae039));
var $8afd89c6a13ddc50$export$2e2bcd8739ae039 = $8afd89c6a13ddc50$var$MarkAreaModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 















var $fceb540896c10ba4$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $fceb540896c10ba4$var$markAreaTransform = function(seriesModel, coordSys, maModel, item) {
    // item may be null
    var item0 = item[0];
    var item1 = item[1];
    if (!item0 || !item1) return;
    var lt = $83afc660f32ac756$export$3eebd2d54b98c04f(seriesModel, item0);
    var rb = $83afc660f32ac756$export$3eebd2d54b98c04f(seriesModel, item1);
    // FIXME make sure lt is less than rb
    var ltCoord = lt.coord;
    var rbCoord = rb.coord;
    ltCoord[0] = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(ltCoord[0], -Infinity);
    ltCoord[1] = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(ltCoord[1], -Infinity);
    rbCoord[0] = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(rbCoord[0], Infinity);
    rbCoord[1] = (0, $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66)(rbCoord[1], Infinity);
    // Merge option into one
    var result = (0, $1b239fc9d3a2f8ae$export$18aef43295bbe906)([
        {},
        lt,
        rb
    ]);
    result.coord = [
        lt.coord,
        rb.coord
    ];
    result.x0 = lt.x;
    result.y0 = lt.y;
    result.x1 = rb.x;
    result.y1 = rb.y;
    return result;
};
function $fceb540896c10ba4$var$isInfinity(val) {
    return !isNaN(val) && !isFinite(val);
}
// If a markArea has one dim
function $fceb540896c10ba4$var$ifMarkAreaHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
    var otherDimIndex = 1 - dimIndex;
    return $fceb540896c10ba4$var$isInfinity(fromCoord[otherDimIndex]) && $fceb540896c10ba4$var$isInfinity(toCoord[otherDimIndex]);
}
function $fceb540896c10ba4$var$markAreaFilter(coordSys, item) {
    var fromCoord = item.coord[0];
    var toCoord = item.coord[1];
    var item0 = {
        coord: fromCoord,
        x: item.x0,
        y: item.y0
    };
    var item1 = {
        coord: toCoord,
        x: item.x1,
        y: item.y1
    };
    if ((0, $9ca39efe18dd5899$export$8567506e6336616)(coordSys, 'cartesian2d')) {
        // In case
        // {
        //  markArea: {
        //    data: [{ yAxis: 2 }]
        //  }
        // }
        if (fromCoord && toCoord && ($fceb540896c10ba4$var$ifMarkAreaHasOnlyDim(1, fromCoord, toCoord, coordSys) || $fceb540896c10ba4$var$ifMarkAreaHasOnlyDim(0, fromCoord, toCoord, coordSys))) return true;
        // Directly returning true may also do the work,
        // because markArea will not be shown automatically
        // when it's not included in coordinate system.
        // But filtering ahead can avoid keeping rendering markArea
        // when there are too many of them.
        return $83afc660f32ac756$export$c869311b63462da6(coordSys, item0, item1);
    }
    return $83afc660f32ac756$export$179695f4a9040f73(coordSys, item0) || $83afc660f32ac756$export$179695f4a9040f73(coordSys, item1);
}
// dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
function $fceb540896c10ba4$var$getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
    var coordSys = seriesModel.coordinateSystem;
    var itemModel = data.getItemModel(idx);
    var point;
    var xPx = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(itemModel.get(dims[0]), api.getWidth());
    var yPx = $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f(itemModel.get(dims[1]), api.getHeight());
    if (!isNaN(xPx) && !isNaN(yPx)) point = [
        xPx,
        yPx
    ];
    else {
        // Chart like bar may have there own marker positioning logic
        if (seriesModel.getMarkerPosition) {
            // Consider the case that user input the right-bottom point first
            // Pick the larger x and y as 'x1' and 'y1'
            var pointValue0 = data.getValues([
                'x0',
                'y0'
            ], idx);
            var pointValue1 = data.getValues([
                'x1',
                'y1'
            ], idx);
            var clampPointValue0 = coordSys.clampData(pointValue0);
            var clampPointValue1 = coordSys.clampData(pointValue1);
            var pointValue = [];
            if (dims[0] === 'x0') pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue1[0] : pointValue0[0];
            else pointValue[0] = clampPointValue0[0] > clampPointValue1[0] ? pointValue0[0] : pointValue1[0];
            if (dims[1] === 'y0') pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue1[1] : pointValue0[1];
            else pointValue[1] = clampPointValue0[1] > clampPointValue1[1] ? pointValue0[1] : pointValue1[1];
            // Use the getMarkerPosition
            point = seriesModel.getMarkerPosition(pointValue, dims, true);
        } else {
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            var pt = [
                x,
                y
            ];
            coordSys.clampData && coordSys.clampData(pt, pt);
            point = coordSys.dataToPoint(pt, true);
        }
        if ((0, $9ca39efe18dd5899$export$8567506e6336616)(coordSys, 'cartesian2d')) {
            // TODO: TYPE ts@4.1 may still infer it as Axis instead of Axis2D. Not sure if it's a bug
            var xAxis = coordSys.getAxis('x');
            var yAxis = coordSys.getAxis('y');
            var x = data.get(dims[0], idx);
            var y = data.get(dims[1], idx);
            if ($fceb540896c10ba4$var$isInfinity(x)) point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
            else if ($fceb540896c10ba4$var$isInfinity(y)) point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
        }
        // Use x, y if has any
        if (!isNaN(xPx)) point[0] = xPx;
        if (!isNaN(yPx)) point[1] = yPx;
    }
    return point;
}
var $fceb540896c10ba4$export$fc5a505a325de211 = [
    [
        'x0',
        'y0'
    ],
    [
        'x1',
        'y0'
    ],
    [
        'x1',
        'y1'
    ],
    [
        'x0',
        'y1'
    ]
];
var $fceb540896c10ba4$var$MarkAreaView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(MarkAreaView, _super);
    function MarkAreaView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = MarkAreaView.type;
        return _this;
    }
    MarkAreaView.prototype.updateTransform = function(markAreaModel, ecModel, api) {
        ecModel.eachSeries(function(seriesModel) {
            var maModel = (0, $024def422baea00f$export$2e2bcd8739ae039).getMarkerModelFromSeries(seriesModel, 'markArea');
            if (maModel) {
                var areaData_1 = maModel.getData();
                areaData_1.each(function(idx) {
                    var points = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)($fceb540896c10ba4$export$fc5a505a325de211, function(dim) {
                        return $fceb540896c10ba4$var$getSingleMarkerEndPoint(areaData_1, idx, dim, seriesModel, api);
                    });
                    // Layout
                    areaData_1.setItemLayout(idx, points);
                    var el = areaData_1.getItemGraphicEl(idx);
                    el.setShape('points', points);
                });
            }
        }, this);
    };
    MarkAreaView.prototype.renderSeries = function(seriesModel, maModel, ecModel, api) {
        var coordSys = seriesModel.coordinateSystem;
        var seriesId = seriesModel.id;
        var seriesData = seriesModel.getData();
        var areaGroupMap = this.markerGroupMap;
        var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
            group: new $6c313c3ef6000a43$export$2e2bcd8739ae039()
        });
        this.group.add(polygonGroup.group);
        this.markKeep(polygonGroup);
        var areaData = $fceb540896c10ba4$var$createList(coordSys, seriesModel, maModel);
        // Line data for tooltip and formatter
        maModel.setData(areaData);
        // Update visual and layout of line
        areaData.each(function(idx) {
            // Layout
            var points = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)($fceb540896c10ba4$export$fc5a505a325de211, function(dim) {
                return $fceb540896c10ba4$var$getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
            });
            var xAxisScale = coordSys.getAxis('x').scale;
            var yAxisScale = coordSys.getAxis('y').scale;
            var xAxisExtent = xAxisScale.getExtent();
            var yAxisExtent = yAxisScale.getExtent();
            var xPointExtent = [
                xAxisScale.parse(areaData.get('x0', idx)),
                xAxisScale.parse(areaData.get('x1', idx))
            ];
            var yPointExtent = [
                yAxisScale.parse(areaData.get('y0', idx)),
                yAxisScale.parse(areaData.get('y1', idx))
            ];
            $9fd90cf3bf18fbcd$export$debe6e778e0a6d32(xPointExtent);
            $9fd90cf3bf18fbcd$export$debe6e778e0a6d32(yPointExtent);
            var overlapped = !(xAxisExtent[0] > xPointExtent[1] || xAxisExtent[1] < xPointExtent[0] || yAxisExtent[0] > yPointExtent[1] || yAxisExtent[1] < yPointExtent[0]);
            // If none of the area is inside coordSys, allClipped is set to be true
            // in layout so that label will not be displayed. See #12591
            var allClipped = !overlapped;
            areaData.setItemLayout(idx, {
                points: points,
                allClipped: allClipped
            });
            var style = areaData.getItemModel(idx).getModel('itemStyle').getItemStyle();
            var color = (0, $aa7643c8305265d3$export$d76e333a86ea1a2)(seriesData, 'color');
            if (!style.fill) {
                style.fill = color;
                if ((0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(style.fill)) style.fill = $35573db24643e2ef$export$ab4754bf42583a26(style.fill, 0.4);
            }
            if (!style.stroke) style.stroke = color;
            // Visual
            areaData.setItemVisual(idx, 'style', style);
        });
        areaData.diff($fceb540896c10ba4$var$inner(polygonGroup).data).add(function(idx) {
            var layout = areaData.getItemLayout(idx);
            if (!layout.allClipped) {
                var polygon = new $399011f87accd5da$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(idx, polygon);
                polygonGroup.group.add(polygon);
            }
        }).update(function(newIdx, oldIdx) {
            var polygon = $fceb540896c10ba4$var$inner(polygonGroup).data.getItemGraphicEl(oldIdx);
            var layout = areaData.getItemLayout(newIdx);
            if (!layout.allClipped) {
                if (polygon) $b40111164617dd60$export$c8dce3c08436e91e(polygon, {
                    shape: {
                        points: layout.points
                    }
                }, maModel, newIdx);
                else polygon = new $399011f87accd5da$export$2e2bcd8739ae039({
                    shape: {
                        points: layout.points
                    }
                });
                areaData.setItemGraphicEl(newIdx, polygon);
                polygonGroup.group.add(polygon);
            } else if (polygon) polygonGroup.group.remove(polygon);
        }).remove(function(idx) {
            var polygon = $fceb540896c10ba4$var$inner(polygonGroup).data.getItemGraphicEl(idx);
            polygonGroup.group.remove(polygon);
        }).execute();
        areaData.eachItemGraphicEl(function(polygon, idx) {
            var itemModel = areaData.getItemModel(idx);
            var style = areaData.getItemVisual(idx, 'style');
            polygon.useStyle(areaData.getItemVisual(idx, 'style'));
            (0, $3828198b2f2de836$export$9a13992917966657)(polygon, (0, $3828198b2f2de836$export$9739a32674be5893)(itemModel), {
                labelFetcher: maModel,
                labelDataIndex: idx,
                defaultText: areaData.getName(idx) || '',
                inheritColor: (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(style.fill) ? $35573db24643e2ef$export$ab4754bf42583a26(style.fill, 1) : '#000'
            });
            (0, $b414df7d361a211c$export$48b68047d330bbc9)(polygon, itemModel);
            (0, $b414df7d361a211c$export$e51187539ff11209)(polygon, null, null, itemModel.get([
                'emphasis',
                'disabled'
            ]));
            (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(polygon).dataModel = maModel;
        });
        $fceb540896c10ba4$var$inner(polygonGroup).data = areaData;
        polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
    };
    MarkAreaView.type = 'markArea';
    return MarkAreaView;
}((0, $8428d84f33d296e6$export$2e2bcd8739ae039));
function $fceb540896c10ba4$var$createList(coordSys, seriesModel, maModel) {
    var areaData;
    var dataDims;
    var dims = [
        'x0',
        'y0',
        'x1',
        'y1'
    ];
    if (coordSys) {
        var coordDimsInfos_1 = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(coordSys && coordSys.dimensions, function(coordDim) {
            var data = seriesModel.getData();
            var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {};
            // In map series data don't have lng and lat dimension. Fallback to same with coordSys
            return (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, info), {
                name: coordDim,
                // DON'T use ordinalMeta to parse and collect ordinal.
                ordinalMeta: null
            });
        });
        dataDims = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(dims, function(dim, idx) {
            return {
                name: dim,
                type: coordDimsInfos_1[idx % 2].type
            };
        });
        areaData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(dataDims, maModel);
    } else {
        dataDims = [
            {
                name: 'value',
                type: 'float'
            }
        ];
        areaData = new (0, $3df3379dddbd72fe$export$2e2bcd8739ae039)(dataDims, maModel);
    }
    var optData = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(maModel.get('data'), (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($fceb540896c10ba4$var$markAreaTransform, seriesModel, coordSys, maModel));
    if (coordSys) optData = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(optData, (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($fceb540896c10ba4$var$markAreaFilter, coordSys));
    var dimValueGetter = coordSys ? function(item, dimName, dataIndex, dimIndex) {
        // TODO should convert to ParsedValue?
        var rawVal = item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
        return (0, $b0b05721170d73df$export$cc7175145baad076)(rawVal, dataDims[dimIndex]);
    } : function(item, dimName, dataIndex, dimIndex) {
        return (0, $b0b05721170d73df$export$cc7175145baad076)(item.value, dataDims[dimIndex]);
    };
    areaData.initData(optData, null, dimValueGetter);
    areaData.hasItemOption = true;
    return areaData;
}
var $fceb540896c10ba4$export$2e2bcd8739ae039 = $fceb540896c10ba4$var$MarkAreaView;


function $8fd430d032c22a3c$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $8afd89c6a13ddc50$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $fceb540896c10ba4$export$2e2bcd8739ae039));
    registers.registerPreprocessor(function(opt) {
        if ((0, $06b11b2303133840$export$2e2bcd8739ae039)(opt.series, 'markArea')) // Make sure markArea component is enabled
        opt.markArea = opt.markArea || {};
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $de47d38e7eb28c1c$var$getDefaultSelectorOptions = function(ecModel, type) {
    if (type === 'all') return {
        type: 'all',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'all'
        ])
    };
    else if (type === 'inverse') return {
        type: 'inverse',
        title: ecModel.getLocaleModel().get([
            'legend',
            'selector',
            'inverse'
        ])
    };
};
var $de47d38e7eb28c1c$var$LegendModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LegendModel, _super);
    function LegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendModel.type;
        _this.layoutMode = {
            type: 'box',
            // legend.width/height are maxWidth/maxHeight actually,
            // whereas real width/height is calculated by its content.
            // (Setting {left: 10, right: 10} does not make sense).
            // So consider the case:
            // `setOption({legend: {left: 10});`
            // then `setOption({legend: {right: 10});`
            // The previous `left` should be cleared by setting `ignoreSize`.
            ignoreSize: true
        };
        return _this;
    }
    LegendModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
        option.selected = option.selected || {};
        this._updateSelector(option);
    };
    LegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        this._updateSelector(option);
    };
    LegendModel.prototype._updateSelector = function(option) {
        var selector = option.selector;
        var ecModel = this.ecModel;
        if (selector === true) selector = option.selector = [
            'all',
            'inverse'
        ];
        if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(selector)) $1b239fc9d3a2f8ae$export$79b2f7037acddd43(selector, function(item, index) {
            $1b239fc9d3a2f8ae$export$844ec244b1367d54(item) && (item = {
                type: item
            });
            selector[index] = $1b239fc9d3a2f8ae$export$4950aa0f605343fb(item, $de47d38e7eb28c1c$var$getDefaultSelectorOptions(ecModel, item.type));
        });
    };
    LegendModel.prototype.optionUpdated = function() {
        this._updateData(this.ecModel);
        var legendData = this._data;
        // If selectedMode is single, try to select one
        if (legendData[0] && this.get('selectedMode') === 'single') {
            var hasSelected = false;
            // If has any selected in option.selected
            for(var i = 0; i < legendData.length; i++){
                var name_1 = legendData[i].get('name');
                if (this.isSelected(name_1)) {
                    // Force to unselect others
                    this.select(name_1);
                    hasSelected = true;
                    break;
                }
            }
            // Try select the first if selectedMode is single
            !hasSelected && this.select(legendData[0].get('name'));
        }
    };
    LegendModel.prototype._updateData = function(ecModel) {
        var potentialData = [];
        var availableNames = [];
        ecModel.eachRawSeries(function(seriesModel) {
            var seriesName = seriesModel.name;
            availableNames.push(seriesName);
            var isPotential;
            if (seriesModel.legendVisualProvider) {
                var provider = seriesModel.legendVisualProvider;
                var names = provider.getAllNames();
                if (!ecModel.isSeriesFiltered(seriesModel)) availableNames = availableNames.concat(names);
                if (names.length) potentialData = potentialData.concat(names);
                else isPotential = true;
            } else isPotential = true;
            if (isPotential && (0, $9ac03c46e8b6e711$export$beae19a2652b3368)(seriesModel)) potentialData.push(seriesModel.name);
        });
        /**
     * @type {Array.<string>}
     * @private
     */ this._availableNames = availableNames;
        // If legend.data is not specified in option, use availableNames as data,
        // which is convenient for user preparing option.
        var rawData = this.get('data') || potentialData;
        var legendNameMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var legendData = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(rawData, function(dataItem) {
            // Can be string or number
            if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(dataItem) || $1b239fc9d3a2f8ae$export$7e4aa119212bc614(dataItem)) dataItem = {
                name: dataItem
            };
            if (legendNameMap.get(dataItem.name)) // remove legend name duplicate
            return null;
            legendNameMap.set(dataItem.name, true);
            return new (0, $3c5c9c3617b9c261$export$2e2bcd8739ae039)(dataItem, this, this.ecModel);
        }, this);
        /**
     * @type {Array.<module:echarts/model/Model>}
     * @private
     */ this._data = $1b239fc9d3a2f8ae$export$3dea766d36a8935f(legendData, function(item) {
            return !!item;
        });
    };
    LegendModel.prototype.getData = function() {
        return this._data;
    };
    LegendModel.prototype.select = function(name) {
        var selected = this.option.selected;
        var selectedMode = this.get('selectedMode');
        if (selectedMode === 'single') {
            var data = this._data;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(data, function(dataItem) {
                selected[dataItem.get('name')] = false;
            });
        }
        selected[name] = true;
    };
    LegendModel.prototype.unSelect = function(name) {
        if (this.get('selectedMode') !== 'single') this.option.selected[name] = false;
    };
    LegendModel.prototype.toggleSelected = function(name) {
        var selected = this.option.selected;
        // Default is true
        if (!selected.hasOwnProperty(name)) selected[name] = true;
        this[selected[name] ? 'unSelect' : 'select'](name);
    };
    LegendModel.prototype.allSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(data, function(dataItem) {
            selected[dataItem.get('name', true)] = true;
        });
    };
    LegendModel.prototype.inverseSelect = function() {
        var data = this._data;
        var selected = this.option.selected;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(data, function(dataItem) {
            var name = dataItem.get('name', true);
            // Initially, default value is true
            if (!selected.hasOwnProperty(name)) selected[name] = true;
            selected[name] = !selected[name];
        });
    };
    LegendModel.prototype.isSelected = function(name) {
        var selected = this.option.selected;
        return !(selected.hasOwnProperty(name) && !selected[name]) && $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(this._availableNames, name) >= 0;
    };
    LegendModel.prototype.getOrient = function() {
        return this.get('orient') === 'vertical' ? {
            index: 1,
            name: 'vertical'
        } : {
            index: 0,
            name: 'horizontal'
        };
    };
    LegendModel.type = 'legend.plain';
    LegendModel.dependencies = [
        'series'
    ];
    LegendModel.defaultOption = {
        // zlevel: 0,
        z: 4,
        show: true,
        orient: 'horizontal',
        left: 'center',
        // right: 'center',
        top: 0,
        // bottom: null,
        align: 'auto',
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        borderRadius: 0,
        borderWidth: 0,
        padding: 5,
        itemGap: 10,
        itemWidth: 25,
        itemHeight: 14,
        symbolRotate: 'inherit',
        symbolKeepAspect: true,
        inactiveColor: '#ccc',
        inactiveBorderColor: '#ccc',
        inactiveBorderWidth: 'auto',
        itemStyle: {
            color: 'inherit',
            opacity: 'inherit',
            borderColor: 'inherit',
            borderWidth: 'auto',
            borderCap: 'inherit',
            borderJoin: 'inherit',
            borderDashOffset: 'inherit',
            borderMiterLimit: 'inherit'
        },
        lineStyle: {
            width: 'auto',
            color: 'inherit',
            inactiveColor: '#ccc',
            inactiveWidth: 2,
            opacity: 'inherit',
            type: 'inherit',
            cap: 'inherit',
            join: 'inherit',
            dashOffset: 'inherit',
            miterLimit: 'inherit'
        },
        textStyle: {
            color: '#333'
        },
        selectedMode: true,
        selector: false,
        selectorLabel: {
            show: true,
            borderRadius: 10,
            padding: [
                3,
                5,
                3,
                5
            ],
            fontSize: 12,
            fontFamily: 'sans-serif',
            color: '#666',
            borderWidth: 1,
            borderColor: '#666'
        },
        emphasis: {
            selectorLabel: {
                show: true,
                color: '#eee',
                backgroundColor: '#666'
            }
        },
        selectorPosition: 'auto',
        selectorItemGap: 7,
        selectorButtonGap: 10,
        tooltip: {
            show: false
        }
    };
    return LegendModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $de47d38e7eb28c1c$export$2e2bcd8739ae039 = $de47d38e7eb28c1c$var$LegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 











var $8b73e9c39ee089ff$var$curry = $1b239fc9d3a2f8ae$export$c3095a23b368d1f2;
var $8b73e9c39ee089ff$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $8b73e9c39ee089ff$var$Group = $6c313c3ef6000a43$export$2e2bcd8739ae039;
var $8b73e9c39ee089ff$var$LegendView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(LegendView, _super);
    function LegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = LegendView.type;
        _this.newlineDisabled = false;
        return _this;
    }
    LegendView.prototype.init = function() {
        this.group.add(this._contentGroup = new $8b73e9c39ee089ff$var$Group());
        this.group.add(this._selectorGroup = new $8b73e9c39ee089ff$var$Group());
        this._isFirstRender = true;
    };
    /**
   * @protected
   */ LegendView.prototype.getContentGroup = function() {
        return this._contentGroup;
    };
    /**
   * @protected
   */ LegendView.prototype.getSelectorGroup = function() {
        return this._selectorGroup;
    };
    /**
   * @override
   */ LegendView.prototype.render = function(legendModel, ecModel, api) {
        var isFirstRender = this._isFirstRender;
        this._isFirstRender = false;
        this.resetInner();
        if (!legendModel.get('show', true)) return;
        var itemAlign = legendModel.get('align');
        var orient = legendModel.get('orient');
        if (!itemAlign || itemAlign === 'auto') itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
        // selector has been normalized to an array in model
        var selector = legendModel.get('selector', true);
        var selectorPosition = legendModel.get('selectorPosition', true);
        if (selector && (!selectorPosition || selectorPosition === 'auto')) selectorPosition = orient === 'horizontal' ? 'end' : 'start';
        this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        // Perform layout.
        var positionInfo = legendModel.getBoxLayoutParams();
        var viewportSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        var padding = legendModel.get('padding');
        var maxSize = $501dc28f6c4d24ac$export$4517a5ca639a7293(positionInfo, viewportSize, padding);
        var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition);
        // Place mainGroup, based on the calculated `mainRect`.
        var layoutRect = $501dc28f6c4d24ac$export$4517a5ca639a7293($1b239fc9d3a2f8ae$export$ebe90cb607ad99e({
            width: mainRect.width,
            height: mainRect.height
        }, positionInfo), viewportSize, padding);
        this.group.x = layoutRect.x - mainRect.x;
        this.group.y = layoutRect.y - mainRect.y;
        this.group.markRedraw();
        // Render background after group is layout.
        this.group.add(this._backgroundEl = (0, $270ca9502cccb922$export$fae23936eedfad4f)(mainRect, legendModel));
    };
    LegendView.prototype.resetInner = function() {
        this.getContentGroup().removeAll();
        this._backgroundEl && this.group.remove(this._backgroundEl);
        this.getSelectorGroup().removeAll();
    };
    LegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var legendDrawnMap = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
        var selectMode = legendModel.get('selectedMode');
        var excludeSeriesId = [];
        ecModel.eachRawSeries(function(seriesModel) {
            !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
        });
        $8b73e9c39ee089ff$var$each(legendModel.getData(), function(legendItemModel, dataIndex) {
            var name = legendItemModel.get('name');
            // Use empty string or \n as a newline string
            if (!this.newlineDisabled && (name === '' || name === '\n')) {
                var g = new $8b73e9c39ee089ff$var$Group();
                // @ts-ignore
                g.newline = true;
                contentGroup.add(g);
                return;
            }
            // Representitive series.
            var seriesModel = ecModel.getSeriesByName(name)[0];
            if (legendDrawnMap.get(name)) // Have been drawn
            return;
            // Legend to control series.
            if (seriesModel) {
                var data = seriesModel.getData();
                var lineVisualStyle = data.getVisual('legendLineStyle') || {};
                var legendIcon = data.getVisual('legendIcon');
                /**
         * `data.getVisual('style')` may be the color from the register
         * in series. For example, for line series,
         */ var style = data.getVisual('style');
                var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, style, legendIcon, selectMode, api);
                itemGroup.on('click', $8b73e9c39ee089ff$var$curry($8b73e9c39ee089ff$var$dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', $8b73e9c39ee089ff$var$curry($8b73e9c39ee089ff$var$dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', $8b73e9c39ee089ff$var$curry($8b73e9c39ee089ff$var$dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
                if (ecModel.ssr) itemGroup.eachChild(function(child) {
                    var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(child);
                    ecData.seriesIndex = seriesModel.seriesIndex;
                    ecData.dataIndex = dataIndex;
                    ecData.ssrType = 'legend';
                });
                legendDrawnMap.set(name, true);
            } else // Legend to control data. In pie and funnel.
            ecModel.eachRawSeries(function(seriesModel) {
                // In case multiple series has same data name
                if (legendDrawnMap.get(name)) return;
                if (seriesModel.legendVisualProvider) {
                    var provider = seriesModel.legendVisualProvider;
                    if (!provider.containName(name)) return;
                    var idx = provider.indexOfName(name);
                    var style = provider.getItemVisual(idx, 'style');
                    var legendIcon = provider.getItemVisual(idx, 'legendIcon');
                    var colorArr = (0, $35573db24643e2ef$export$98e6a39c04603d36)(style.fill);
                    // Color may be set to transparent in visualMap when data is out of range.
                    // Do not show nothing.
                    if (colorArr && colorArr[3] === 0) {
                        colorArr[3] = 0.2;
                        // TODO color is set to 0, 0, 0, 0. Should show correct RGBA
                        style = $1b239fc9d3a2f8ae$export$8b58be045bf06082($1b239fc9d3a2f8ae$export$8b58be045bf06082({}, style), {
                            fill: (0, $35573db24643e2ef$export$fac44ee5b035f737)(colorArr, 'rgba')
                        });
                    }
                    var itemGroup = this._createItem(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, {}, style, legendIcon, selectMode, api);
                    // FIXME: consider different series has items with the same name.
                    itemGroup.on('click', $8b73e9c39ee089ff$var$curry($8b73e9c39ee089ff$var$dispatchSelectAction, null, name, api, excludeSeriesId))// Should not specify the series name, consider legend controls
                    // more than one pie series.
                    .on('mouseover', $8b73e9c39ee089ff$var$curry($8b73e9c39ee089ff$var$dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', $8b73e9c39ee089ff$var$curry($8b73e9c39ee089ff$var$dispatchDownplayAction, null, name, api, excludeSeriesId));
                    if (ecModel.ssr) itemGroup.eachChild(function(child) {
                        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(child);
                        ecData.seriesIndex = seriesModel.seriesIndex;
                        ecData.dataIndex = dataIndex;
                        ecData.ssrType = 'legend';
                    });
                    legendDrawnMap.set(name, true);
                }
            }, this);
        }, this);
        if (selector) this._createSelector(selector, legendModel, api, orient, selectorPosition);
    };
    LegendView.prototype._createSelector = function(selector, legendModel, api, orient, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        $8b73e9c39ee089ff$var$each(selector, function createSelectorButton(selectorItem) {
            var type = selectorItem.type;
            var labelText = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                style: {
                    x: 0,
                    y: 0,
                    align: 'center',
                    verticalAlign: 'middle'
                },
                onclick: function() {
                    api.dispatchAction({
                        type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect',
                        legendId: legendModel.id
                    });
                }
            });
            selectorGroup.add(labelText);
            var labelModel = legendModel.getModel('selectorLabel');
            var emphasisLabelModel = legendModel.getModel([
                'emphasis',
                'selectorLabel'
            ]);
            (0, $3828198b2f2de836$export$9a13992917966657)(labelText, {
                normal: labelModel,
                emphasis: emphasisLabelModel
            }, {
                defaultText: selectorItem.title
            });
            (0, $b414df7d361a211c$export$5f393df0b5aee2e7)(labelText);
        });
    };
    LegendView.prototype._createItem = function(seriesModel, name, dataIndex, legendItemModel, legendModel, itemAlign, lineVisualStyle, itemVisualStyle, legendIcon, selectMode, api) {
        var drawType = seriesModel.visualDrawType;
        var itemWidth = legendModel.get('itemWidth');
        var itemHeight = legendModel.get('itemHeight');
        var isSelected = legendModel.isSelected(name);
        var iconRotate = legendItemModel.get('symbolRotate');
        var symbolKeepAspect = legendItemModel.get('symbolKeepAspect');
        var legendIconType = legendItemModel.get('icon');
        legendIcon = legendIconType || legendIcon || 'roundRect';
        var style = $8b73e9c39ee089ff$var$getLegendStyle(legendIcon, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api);
        var itemGroup = new $8b73e9c39ee089ff$var$Group();
        var textStyleModel = legendItemModel.getModel('textStyle');
        if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(seriesModel.getLegendIcon) && (!legendIconType || legendIconType === 'inherit')) // Series has specific way to define legend icon
        itemGroup.add(seriesModel.getLegendIcon({
            itemWidth: itemWidth,
            itemHeight: itemHeight,
            icon: legendIcon,
            iconRotate: iconRotate,
            itemStyle: style.itemStyle,
            lineStyle: style.lineStyle,
            symbolKeepAspect: symbolKeepAspect
        }));
        else {
            // Use default legend icon policy for most series
            var rotate = legendIconType === 'inherit' && seriesModel.getData().getVisual('symbol') ? iconRotate === 'inherit' ? seriesModel.getData().getVisual('symbolRotate') : iconRotate : 0; // No rotation for no icon
            itemGroup.add($8b73e9c39ee089ff$var$getDefaultLegendIcon({
                itemWidth: itemWidth,
                itemHeight: itemHeight,
                icon: legendIcon,
                iconRotate: rotate,
                itemStyle: style.itemStyle,
                lineStyle: style.lineStyle,
                symbolKeepAspect: symbolKeepAspect
            }));
        }
        var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
        var textAlign = itemAlign;
        var formatter = legendModel.get('formatter');
        var content = name;
        if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(formatter) && formatter) content = formatter.replace('{name}', name != null ? name : '');
        else if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(formatter)) content = formatter(name);
        var textColor = isSelected ? textStyleModel.getTextColor() : legendItemModel.get('inactiveColor');
        itemGroup.add(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                text: content,
                x: textX,
                y: itemHeight / 2,
                fill: textColor,
                align: textAlign,
                verticalAlign: 'middle'
            }, {
                inheritColor: textColor
            })
        }));
        // Add a invisible rect to increase the area of mouse hover
        var hitRect = new $37476269d425e3f6$export$2e2bcd8739ae039({
            shape: itemGroup.getBoundingRect(),
            style: {
                // Cannot use 'invisible' because SVG SSR will miss the node
                fill: 'transparent'
            }
        });
        var tooltipModel = legendItemModel.getModel('tooltip');
        if (tooltipModel.get('show')) $8eb95236e1aa01e7$export$fc6410d97fab306c({
            el: hitRect,
            componentModel: legendModel,
            itemName: name,
            itemTooltipOption: tooltipModel.option
        });
        itemGroup.add(hitRect);
        itemGroup.eachChild(function(child) {
            child.silent = true;
        });
        hitRect.silent = !selectMode;
        this.getContentGroup().add(itemGroup);
        (0, $b414df7d361a211c$export$5f393df0b5aee2e7)(itemGroup);
        // @ts-ignore
        itemGroup.__legendDataIndex = dataIndex;
        return itemGroup;
    };
    LegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var contentGroup = this.getContentGroup();
        var selectorGroup = this.getSelectorGroup();
        // Place items in contentGroup.
        $501dc28f6c4d24ac$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
        var contentRect = contentGroup.getBoundingRect();
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        selectorGroup.markRedraw();
        contentGroup.markRedraw();
        if (selector) {
            // Place buttons in selectorGroup
            $501dc28f6c4d24ac$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
            'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
            var selectorRect = selectorGroup.getBoundingRect();
            var selectorPos = [
                -selectorRect.x,
                -selectorRect.y
            ];
            var selectorButtonGap = legendModel.get('selectorButtonGap', true);
            var orientIdx = legendModel.getOrient().index;
            var wh = orientIdx === 0 ? 'width' : 'height';
            var hw = orientIdx === 0 ? 'height' : 'width';
            var yx = orientIdx === 0 ? 'y' : 'x';
            if (selectorPosition === 'end') selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
            else contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
            // Always align selector to content as 'middle'
            selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            var mainRect = {
                x: 0,
                y: 0
            };
            mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
            mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
            return mainRect;
        } else {
            contentGroup.x = contentPos[0];
            contentGroup.y = contentPos[1];
            return this.group.getBoundingRect();
        }
    };
    /**
   * @protected
   */ LegendView.prototype.remove = function() {
        this.getContentGroup().removeAll();
        this._isFirstRender = true;
    };
    LegendView.type = 'legend.plain';
    return LegendView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $8b73e9c39ee089ff$var$getLegendStyle(iconType, legendItemModel, lineVisualStyle, itemVisualStyle, drawType, isSelected, api) {
    /**
   * Use series style if is inherit;
   * elsewise, use legend style
   */ function handleCommonProps(style, visualStyle) {
        // If lineStyle.width is 'auto', it is set to be 2 if series has border
        if (style.lineWidth === 'auto') style.lineWidth = visualStyle.lineWidth > 0 ? 2 : 0;
        $8b73e9c39ee089ff$var$each(style, function(propVal, propName) {
            style[propName] === 'inherit' && (style[propName] = visualStyle[propName]);
        });
    }
    // itemStyle
    var itemStyleModel = legendItemModel.getModel('itemStyle');
    var itemStyle = itemStyleModel.getItemStyle();
    var iconBrushType = iconType.lastIndexOf('empty', 0) === 0 ? 'fill' : 'stroke';
    var decalStyle = itemStyleModel.getShallow('decal');
    itemStyle.decal = !decalStyle || decalStyle === 'inherit' ? itemVisualStyle.decal : (0, $6d9628e7c6bac2b0$export$a3ba048e1a648972)(decalStyle, api);
    if (itemStyle.fill === 'inherit') /**
     * Series with visualDrawType as 'stroke' should have
     * series stroke as legend fill
     */ itemStyle.fill = itemVisualStyle[drawType];
    if (itemStyle.stroke === 'inherit') /**
     * icon type with "emptyXXX" should use fill color
     * in visual style
     */ itemStyle.stroke = itemVisualStyle[iconBrushType];
    if (itemStyle.opacity === 'inherit') /**
     * Use lineStyle.opacity if drawType is stroke
     */ itemStyle.opacity = (drawType === 'fill' ? itemVisualStyle : lineVisualStyle).opacity;
    handleCommonProps(itemStyle, itemVisualStyle);
    // lineStyle
    var legendLineModel = legendItemModel.getModel('lineStyle');
    var lineStyle = legendLineModel.getLineStyle();
    handleCommonProps(lineStyle, lineVisualStyle);
    // Fix auto color to real color
    itemStyle.fill === 'auto' && (itemStyle.fill = itemVisualStyle.fill);
    itemStyle.stroke === 'auto' && (itemStyle.stroke = itemVisualStyle.fill);
    lineStyle.stroke === 'auto' && (lineStyle.stroke = itemVisualStyle.fill);
    if (!isSelected) {
        var borderWidth = legendItemModel.get('inactiveBorderWidth');
        /**
     * Since stroke is set to be inactiveBorderColor, it may occur that
     * there is no border in series but border in legend, so we need to
     * use border only when series has border if is set to be auto
     */ var visualHasBorder = itemStyle[iconBrushType];
        itemStyle.lineWidth = borderWidth === 'auto' ? itemVisualStyle.lineWidth > 0 && visualHasBorder ? 2 : 0 : itemStyle.lineWidth;
        itemStyle.fill = legendItemModel.get('inactiveColor');
        itemStyle.stroke = legendItemModel.get('inactiveBorderColor');
        lineStyle.stroke = legendLineModel.get('inactiveColor');
        lineStyle.lineWidth = legendLineModel.get('inactiveWidth');
    }
    return {
        itemStyle: itemStyle,
        lineStyle: lineStyle
    };
}
function $8b73e9c39ee089ff$var$getDefaultLegendIcon(opt) {
    var symboType = opt.icon || 'roundRect';
    var icon = (0, $da6220012439db7b$export$af050e04da3a02e8)(symboType, 0, 0, opt.itemWidth, opt.itemHeight, opt.itemStyle.fill, opt.symbolKeepAspect);
    icon.setStyle(opt.itemStyle);
    icon.rotation = (opt.iconRotate || 0) * Math.PI / 180;
    icon.setOrigin([
        opt.itemWidth / 2,
        opt.itemHeight / 2
    ]);
    if (symboType.indexOf('empty') > -1) {
        icon.style.stroke = icon.style.fill;
        icon.style.fill = '#fff';
        icon.style.lineWidth = 2;
    }
    return icon;
}
function $8b73e9c39ee089ff$var$dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
    // downplay before unselect
    $8b73e9c39ee089ff$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
    api.dispatchAction({
        type: 'legendToggleSelect',
        name: seriesName != null ? seriesName : dataName
    });
    // highlight after select
    // TODO highlight immediately may cause animation loss.
    $8b73e9c39ee089ff$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
}
function $8b73e9c39ee089ff$var$isUseHoverLayer(api) {
    var list = api.getZr().storage.getDisplayList();
    var emphasisState;
    var i = 0;
    var len = list.length;
    while(i < len && !(emphasisState = list[i].states.emphasis))i++;
    return emphasisState && emphasisState.hoverLayer;
}
function $8b73e9c39ee089ff$var$dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$8b73e9c39ee089ff$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'highlight',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
function $8b73e9c39ee089ff$var$dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
    // If element hover will move to a hoverLayer.
    if (!$8b73e9c39ee089ff$var$isUseHoverLayer(api)) api.dispatchAction({
        type: 'downplay',
        seriesName: seriesName,
        name: dataName,
        excludeSeriesId: excludeSeriesId
    });
}
var $8b73e9c39ee089ff$export$2e2bcd8739ae039 = $8b73e9c39ee089ff$var$LegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $0042c425ac2c01f6$export$2e2bcd8739ae039(ecModel) {
    var legendModels = ecModel.findComponents({
        mainType: 'legend'
    });
    if (legendModels && legendModels.length) ecModel.filterSeries(function(series) {
        // If in any legend component the status is not selected.
        // Because in legend series is assumed selected when it is not in the legend data.
        for(var i = 0; i < legendModels.length; i++){
            if (!legendModels[i].isSelected(series.name)) return false;
        }
        return true;
    });
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $248afd679f5ff235$var$legendSelectActionHandler(methodName, payload, ecModel) {
    var isAllSelect = methodName === 'allSelect' || methodName === 'inverseSelect';
    var selectedMap = {};
    var actionLegendIndices = [];
    ecModel.eachComponent({
        mainType: 'legend',
        query: payload
    }, function(legendModel) {
        if (isAllSelect) legendModel[methodName]();
        else legendModel[methodName](payload.name);
        $248afd679f5ff235$var$makeSelectedMap(legendModel, selectedMap);
        actionLegendIndices.push(legendModel.componentIndex);
    });
    var allSelectedMap = {};
    // make selectedMap from all legend components
    ecModel.eachComponent('legend', function(legendModel) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(selectedMap, function(isSelected, name) {
            // Force other legend has same selected status
            // Or the first is toggled to true and other are toggled to false
            // In the case one legend has some item unSelected in option. And if other legend
            // doesn't has the item, they will assume it is selected.
            legendModel[isSelected ? 'select' : 'unSelect'](name);
        });
        $248afd679f5ff235$var$makeSelectedMap(legendModel, allSelectedMap);
    });
    // Return the event explicitly
    return isAllSelect ? {
        selected: allSelectedMap,
        // return legendIndex array to tell the developers which legends are allSelect / inverseSelect
        legendIndex: actionLegendIndices
    } : {
        name: payload.name,
        selected: allSelectedMap
    };
}
function $248afd679f5ff235$var$makeSelectedMap(legendModel, out) {
    var selectedMap = out || {};
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(legendModel.getData(), function(model) {
        var name = model.get('name');
        // Wrap element
        if (name === '\n' || name === '') return;
        var isItemSelected = legendModel.isSelected(name);
        if ((0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(selectedMap, name)) // Unselected if any legend is unselected
        selectedMap[name] = selectedMap[name] && isItemSelected;
        else selectedMap[name] = isItemSelected;
    });
    return selectedMap;
}
function $248afd679f5ff235$export$139982ea529c452f(registers) {
    /**
   * @event legendToggleSelect
   * @type {Object}
   * @property {string} type 'legendToggleSelect'
   * @property {string} [from]
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendToggleSelect', 'legendselectchanged', (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($248afd679f5ff235$var$legendSelectActionHandler, 'toggleSelected'));
    registers.registerAction('legendAllSelect', 'legendselectall', (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($248afd679f5ff235$var$legendSelectActionHandler, 'allSelect'));
    registers.registerAction('legendInverseSelect', 'legendinverseselect', (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($248afd679f5ff235$var$legendSelectActionHandler, 'inverseSelect'));
    /**
   * @event legendSelect
   * @type {Object}
   * @property {string} type 'legendSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendSelect', 'legendselected', (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($248afd679f5ff235$var$legendSelectActionHandler, 'select'));
    /**
   * @event legendUnSelect
   * @type {Object}
   * @property {string} type 'legendUnSelect'
   * @property {string} name Series name or data item name
   */ registers.registerAction('legendUnSelect', 'legendunselected', (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($248afd679f5ff235$var$legendSelectActionHandler, 'unSelect'));
}


function $e0970dd977697728$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $de47d38e7eb28c1c$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $8b73e9c39ee089ff$export$2e2bcd8739ae039));
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.SERIES_FILTER, (0, $0042c425ac2c01f6$export$2e2bcd8739ae039));
    registers.registerSubTypeDefaulter('legend', function() {
        return 'plain';
    });
    (0, $248afd679f5ff235$export$139982ea529c452f)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $aa484cf2eb3ff40a$var$ScrollableLegendModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ScrollableLegendModel, _super);
    function ScrollableLegendModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendModel.type;
        return _this;
    }
    /**
   * @param {number} scrollDataIndex
   */ ScrollableLegendModel.prototype.setScrollDataIndex = function(scrollDataIndex) {
        this.option.scrollDataIndex = scrollDataIndex;
    };
    ScrollableLegendModel.prototype.init = function(option, parentModel, ecModel) {
        var inputPositionParams = (0, $501dc28f6c4d24ac$export$4b0d20af19c9875e)(option);
        _super.prototype.init.call(this, option, parentModel, ecModel);
        $aa484cf2eb3ff40a$var$mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
    };
    /**
   * @override
   */ ScrollableLegendModel.prototype.mergeOption = function(option, ecModel) {
        _super.prototype.mergeOption.call(this, option, ecModel);
        $aa484cf2eb3ff40a$var$mergeAndNormalizeLayoutParams(this, this.option, option);
    };
    ScrollableLegendModel.type = 'legend.scroll';
    ScrollableLegendModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $de47d38e7eb28c1c$export$2e2bcd8739ae039).defaultOption, {
        scrollDataIndex: 0,
        pageButtonItemGap: 5,
        pageButtonGap: null,
        pageButtonPosition: 'end',
        pageFormatter: '{current}/{total}',
        pageIcons: {
            horizontal: [
                'M0,0L12,-10L12,10z',
                'M0,0L-12,-10L-12,10z'
            ],
            vertical: [
                'M0,0L20,0L10,-20z',
                'M0,0L20,0L10,20z'
            ]
        },
        pageIconColor: '#2f4554',
        pageIconInactiveColor: '#aaa',
        pageIconSize: 15,
        pageTextStyle: {
            color: '#333'
        },
        animationDurationUpdate: 800
    });
    return ScrollableLegendModel;
}((0, $de47d38e7eb28c1c$export$2e2bcd8739ae039));
// Do not `ignoreSize` to enable setting {left: 10, right: 10}.
function $aa484cf2eb3ff40a$var$mergeAndNormalizeLayoutParams(legendModel, target, raw) {
    var orient = legendModel.getOrient();
    var ignoreSize = [
        1,
        1
    ];
    ignoreSize[orient.index] = 0;
    (0, $501dc28f6c4d24ac$export$1754cb91f16ca028)(target, raw, {
        type: 'box',
        ignoreSize: !!ignoreSize
    });
}
var $aa484cf2eb3ff40a$export$2e2bcd8739ae039 = $aa484cf2eb3ff40a$var$ScrollableLegendModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $3a497a7d2d5c9b02$var$Group = $6c313c3ef6000a43$export$2e2bcd8739ae039;
var $3a497a7d2d5c9b02$var$WH = [
    'width',
    'height'
];
var $3a497a7d2d5c9b02$var$XY = [
    'x',
    'y'
];
var $3a497a7d2d5c9b02$var$ScrollableLegendView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ScrollableLegendView, _super);
    function ScrollableLegendView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ScrollableLegendView.type;
        _this.newlineDisabled = true;
        _this._currentIndex = 0;
        return _this;
    }
    ScrollableLegendView.prototype.init = function() {
        _super.prototype.init.call(this);
        this.group.add(this._containerGroup = new $3a497a7d2d5c9b02$var$Group());
        this._containerGroup.add(this.getContentGroup());
        this.group.add(this._controllerGroup = new $3a497a7d2d5c9b02$var$Group());
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.resetInner = function() {
        _super.prototype.resetInner.call(this);
        this._controllerGroup.removeAll();
        this._containerGroup.removeClipPath();
        this._containerGroup.__rectSize = null;
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.renderInner = function(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
        var self = this;
        // Render content items.
        _super.prototype.renderInner.call(this, itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
        var controllerGroup = this._controllerGroup;
        // FIXME: support be 'auto' adapt to size number text length,
        // e.g., '3/12345' should not overlap with the control arrow button.
        var pageIconSize = legendModel.get('pageIconSize', true);
        var pageIconSizeArr = $1b239fc9d3a2f8ae$export$43bee75e5e14138e(pageIconSize) ? pageIconSize : [
            pageIconSize,
            pageIconSize
        ];
        createPageButton('pagePrev', 0);
        var pageTextStyleModel = legendModel.getModel('pageTextStyle');
        controllerGroup.add(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            name: 'pageText',
            style: {
                // Placeholder to calculate a proper layout.
                text: 'xx/xx',
                fill: pageTextStyleModel.getTextColor(),
                font: pageTextStyleModel.getFont(),
                verticalAlign: 'middle',
                align: 'center'
            },
            silent: true
        }));
        createPageButton('pageNext', 1);
        function createPageButton(name, iconIdx) {
            var pageDataIndexName = name + 'DataIndex';
            var icon = $8eb95236e1aa01e7$export$274edc73af1ae9c8(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
                // Buttons will be created in each render, so we do not need
                // to worry about avoiding using legendModel kept in scope.
                onclick: $1b239fc9d3a2f8ae$export$2385a24977818dd0(self._pageGo, self, pageDataIndexName, legendModel, api)
            }, {
                x: -pageIconSizeArr[0] / 2,
                y: -pageIconSizeArr[1] / 2,
                width: pageIconSizeArr[0],
                height: pageIconSizeArr[1]
            });
            icon.name = name;
            controllerGroup.add(icon);
        }
    };
    /**
   * @override
   */ ScrollableLegendView.prototype.layoutInner = function(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
        var selectorGroup = this.getSelectorGroup();
        var orientIdx = legendModel.getOrient().index;
        var wh = $3a497a7d2d5c9b02$var$WH[orientIdx];
        var xy = $3a497a7d2d5c9b02$var$XY[orientIdx];
        var hw = $3a497a7d2d5c9b02$var$WH[1 - orientIdx];
        var yx = $3a497a7d2d5c9b02$var$XY[1 - orientIdx];
        selector && $501dc28f6c4d24ac$export$827f4ee28efc37(// Buttons in selectorGroup always layout horizontally
        'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
        var selectorButtonGap = legendModel.get('selectorButtonGap', true);
        var selectorRect = selectorGroup.getBoundingRect();
        var selectorPos = [
            -selectorRect.x,
            -selectorRect.y
        ];
        var processMaxSize = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(maxSize);
        selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
        var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx, xy);
        if (selector) {
            if (selectorPosition === 'end') selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
            else {
                var offset = selectorRect[wh] + selectorButtonGap;
                selectorPos[orientIdx] -= offset;
                mainRect[xy] -= offset;
            }
            mainRect[wh] += selectorRect[wh] + selectorButtonGap;
            selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
            mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
            mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
            selectorGroup.x = selectorPos[0];
            selectorGroup.y = selectorPos[1];
            selectorGroup.markRedraw();
        }
        return mainRect;
    };
    ScrollableLegendView.prototype._layoutContentAndController = function(legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx, xy) {
        var contentGroup = this.getContentGroup();
        var containerGroup = this._containerGroup;
        var controllerGroup = this._controllerGroup;
        // Place items in contentGroup.
        $501dc28f6c4d24ac$export$827f4ee28efc37(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
        $501dc28f6c4d24ac$export$827f4ee28efc37(// Buttons in controller are layout always horizontally.
        'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
        var contentRect = contentGroup.getBoundingRect();
        var controllerRect = controllerGroup.getBoundingRect();
        var showController = this._showController = contentRect[wh] > maxSize[wh];
        // In case that the inner elements of contentGroup layout do not based on [0, 0]
        var contentPos = [
            -contentRect.x,
            -contentRect.y
        ];
        // Remain contentPos when scroll animation perfroming.
        // If first rendering, `contentGroup.position` is [0, 0], which
        // does not make sense and may cause unexepcted animation if adopted.
        if (!isFirstRender) contentPos[orientIdx] = contentGroup[xy];
        // Layout container group based on 0.
        var containerPos = [
            0,
            0
        ];
        var controllerPos = [
            -controllerRect.x,
            -controllerRect.y
        ];
        var pageButtonGap = $1b239fc9d3a2f8ae$export$995e01f2f5c9d030(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true));
        // Place containerGroup and controllerGroup and contentGroup.
        if (showController) {
            var pageButtonPosition = legendModel.get('pageButtonPosition', true);
            // controller is on the right / bottom.
            if (pageButtonPosition === 'end') controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
            else containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
        }
        // Always align controller to content as 'middle'.
        controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
        contentGroup.setPosition(contentPos);
        containerGroup.setPosition(containerPos);
        controllerGroup.setPosition(controllerPos);
        // Calculate `mainRect` and set `clipPath`.
        // mainRect should not be calculated by `this.group.getBoundingRect()`
        // for sake of the overflow.
        var mainRect = {
            x: 0,
            y: 0
        };
        // Consider content may be overflow (should be clipped).
        mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
        mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]);
        // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
        mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
        containerGroup.__rectSize = maxSize[wh];
        if (showController) {
            var clipShape = {
                x: 0,
                y: 0
            };
            clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
            clipShape[hw] = mainRect[hw];
            containerGroup.setClipPath(new $37476269d425e3f6$export$2e2bcd8739ae039({
                shape: clipShape
            }));
            // Consider content may be larger than container, container rect
            // can not be obtained from `containerGroup.getBoundingRect()`.
            containerGroup.__rectSize = clipShape[wh];
        } else // Do not remove or ignore controller. Keep them set as placeholders.
        controllerGroup.eachChild(function(child) {
            child.attr({
                invisible: true,
                silent: true
            });
        });
        // Content translate animation.
        var pageInfo = this._getPageInfo(legendModel);
        pageInfo.pageIndex != null && $b40111164617dd60$export$c8dce3c08436e91e(contentGroup, {
            x: pageInfo.contentPosition[0],
            y: pageInfo.contentPosition[1]
        }, // When switch from "show controller" to "not show controller", view should be
        // updated immediately without animation, otherwise causes weird effect.
        showController ? legendModel : null);
        this._updatePageInfoView(legendModel, pageInfo);
        return mainRect;
    };
    ScrollableLegendView.prototype._pageGo = function(to, legendModel, api) {
        var scrollDataIndex = this._getPageInfo(legendModel)[to];
        scrollDataIndex != null && api.dispatchAction({
            type: 'legendScroll',
            scrollDataIndex: scrollDataIndex,
            legendId: legendModel.id
        });
    };
    ScrollableLegendView.prototype._updatePageInfoView = function(legendModel, pageInfo) {
        var controllerGroup = this._controllerGroup;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
            'pagePrev',
            'pageNext'
        ], function(name) {
            var key = name + 'DataIndex';
            var canJump = pageInfo[key] != null;
            var icon = controllerGroup.childOfName(name);
            if (icon) {
                icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
                icon.cursor = canJump ? 'pointer' : 'default';
            }
        });
        var pageText = controllerGroup.childOfName('pageText');
        var pageFormatter = legendModel.get('pageFormatter');
        var pageIndex = pageInfo.pageIndex;
        var current = pageIndex != null ? pageIndex + 1 : 0;
        var total = pageInfo.pageCount;
        pageText && pageFormatter && pageText.setStyle('text', $1b239fc9d3a2f8ae$export$844ec244b1367d54(pageFormatter) ? pageFormatter.replace('{current}', current == null ? '' : current + '').replace('{total}', total == null ? '' : total + '') : pageFormatter({
            current: current,
            total: total
        }));
    };
    /**
   *  contentPosition: Array.<number>, null when data item not found.
   *  pageIndex: number, null when data item not found.
   *  pageCount: number, always be a number, can be 0.
   *  pagePrevDataIndex: number, null when no previous page.
   *  pageNextDataIndex: number, null when no next page.
   * }
   */ ScrollableLegendView.prototype._getPageInfo = function(legendModel) {
        var scrollDataIndex = legendModel.get('scrollDataIndex', true);
        var contentGroup = this.getContentGroup();
        var containerRectSize = this._containerGroup.__rectSize;
        var orientIdx = legendModel.getOrient().index;
        var wh = $3a497a7d2d5c9b02$var$WH[orientIdx];
        var xy = $3a497a7d2d5c9b02$var$XY[orientIdx];
        var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
        var children = contentGroup.children();
        var targetItem = children[targetItemIndex];
        var itemCount = children.length;
        var pCount = !itemCount ? 0 : 1;
        var result = {
            contentPosition: [
                contentGroup.x,
                contentGroup.y
            ],
            pageCount: pCount,
            pageIndex: pCount - 1,
            pagePrevDataIndex: null,
            pageNextDataIndex: null
        };
        if (!targetItem) return result;
        var targetItemInfo = getItemInfo(targetItem);
        result.contentPosition[orientIdx] = -targetItemInfo.s;
        // Strategy:
        // (1) Always align based on the left/top most item.
        // (2) It is user-friendly that the last item shown in the
        // current window is shown at the begining of next window.
        // Otherwise if half of the last item is cut by the window,
        // it will have no chance to display entirely.
        // (3) Consider that item size probably be different, we
        // have calculate pageIndex by size rather than item index,
        // and we can not get page index directly by division.
        // (4) The window is to narrow to contain more than
        // one item, we should make sure that the page can be fliped.
        for(var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i){
            currItemInfo = getItemInfo(children[i]);
            if (// Half of the last item is out of the window.
            !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
                if (winEndItemInfo.i > winStartItemInfo.i) winStartItemInfo = winEndItemInfo;
                else // e.g., when page size is smaller than item size.
                winStartItemInfo = currItemInfo;
                if (winStartItemInfo) {
                    if (result.pageNextDataIndex == null) result.pageNextDataIndex = winStartItemInfo.i;
                    ++result.pageCount;
                }
            }
            winEndItemInfo = currItemInfo;
        }
        for(var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i){
            currItemInfo = getItemInfo(children[i]);
            if (// If the the end item does not intersect with the window started
            // from the current item, a page can be settled.
            (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && winStartItemInfo.i < winEndItemInfo.i) {
                winEndItemInfo = winStartItemInfo;
                if (result.pagePrevDataIndex == null) result.pagePrevDataIndex = winStartItemInfo.i;
                ++result.pageCount;
                ++result.pageIndex;
            }
            winStartItemInfo = currItemInfo;
        }
        return result;
        function getItemInfo(el) {
            if (el) {
                var itemRect = el.getBoundingRect();
                var start = itemRect[xy] + el[xy];
                return {
                    s: start,
                    e: start + itemRect[wh],
                    i: el.__legendDataIndex
                };
            }
        }
        function intersect(itemInfo, winStart) {
            return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
        }
    };
    ScrollableLegendView.prototype._findTargetItemIndex = function(targetDataIndex) {
        if (!this._showController) return 0;
        var index;
        var contentGroup = this.getContentGroup();
        var defaultIndex;
        contentGroup.eachChild(function(child, idx) {
            var legendDataIdx = child.__legendDataIndex;
            // FIXME
            // If the given targetDataIndex (from model) is illegal,
            // we use defaultIndex. But the index on the legend model and
            // action payload is still illegal. That case will not be
            // changed until some scenario requires.
            if (defaultIndex == null && legendDataIdx != null) defaultIndex = idx;
            if (legendDataIdx === targetDataIndex) index = idx;
        });
        return index != null ? index : defaultIndex;
    };
    ScrollableLegendView.type = 'legend.scroll';
    return ScrollableLegendView;
}((0, $8b73e9c39ee089ff$export$2e2bcd8739ae039));
var $3a497a7d2d5c9b02$export$2e2bcd8739ae039 = $3a497a7d2d5c9b02$var$ScrollableLegendView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ function $d3c6c4054c973bc6$export$2e2bcd8739ae039(registers) {
    /**
   * @event legendScroll
   * @type {Object}
   * @property {string} type 'legendScroll'
   * @property {string} scrollDataIndex
   */ registers.registerAction('legendScroll', 'legendscroll', function(payload, ecModel) {
        var scrollDataIndex = payload.scrollDataIndex;
        scrollDataIndex != null && ecModel.eachComponent({
            mainType: 'legend',
            subType: 'scroll',
            query: payload
        }, function(legendModel) {
            legendModel.setScrollDataIndex(scrollDataIndex);
        });
    });
}


function $eae7df18090dd9d1$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $e0970dd977697728$export$4b3e715f166fdd78));
    registers.registerComponentModel((0, $aa484cf2eb3ff40a$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $3a497a7d2d5c9b02$export$2e2bcd8739ae039));
    (0, $d3c6c4054c973bc6$export$2e2bcd8739ae039)(registers);
}


function $8b168421a553d117$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $e0970dd977697728$export$4b3e715f166fdd78));
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $eae7df18090dd9d1$export$4b3e715f166fdd78));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $2481d926e75cce9b$var$InsideZoomModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(InsideZoomModel, _super);
    function InsideZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = InsideZoomModel.type;
        return _this;
    }
    InsideZoomModel.type = 'dataZoom.inside';
    InsideZoomModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $c71b8584d0593ae5$export$2e2bcd8739ae039).defaultOption, {
        disabled: false,
        zoomLock: false,
        zoomOnMouseWheel: true,
        moveOnMouseMove: true,
        moveOnMouseWheel: false,
        preventDefaultMouseMove: true
    });
    return InsideZoomModel;
}((0, $c71b8584d0593ae5$export$2e2bcd8739ae039));
var $2481d926e75cce9b$export$2e2bcd8739ae039 = $2481d926e75cce9b$var$InsideZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Only create one roam controller for each coordinate system.
// one roam controller might be refered by two inside data zoom
// components (for example, one for x and one for y). When user
// pan or zoom, only dispatch one action for those data zoom
// components.





var $608cfdd2c69d85b3$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $608cfdd2c69d85b3$export$c499fdc26107c565(api, dataZoomModel, getRange) {
    $608cfdd2c69d85b3$var$inner(api).coordSysRecordMap.each(function(coordSysRecord) {
        var dzInfo = coordSysRecord.dataZoomInfoMap.get(dataZoomModel.uid);
        if (dzInfo) dzInfo.getRange = getRange;
    });
}
function $608cfdd2c69d85b3$export$d074fdbbb2bf218c(api, dataZoomModel) {
    var coordSysRecordMap = $608cfdd2c69d85b3$var$inner(api).coordSysRecordMap;
    var coordSysKeyArr = coordSysRecordMap.keys();
    for(var i = 0; i < coordSysKeyArr.length; i++){
        var coordSysKey = coordSysKeyArr[i];
        var coordSysRecord = coordSysRecordMap.get(coordSysKey);
        var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
        if (dataZoomInfoMap) {
            var dzUid = dataZoomModel.uid;
            var dzInfo = dataZoomInfoMap.get(dzUid);
            if (dzInfo) {
                dataZoomInfoMap.removeKey(dzUid);
                if (!dataZoomInfoMap.keys().length) $608cfdd2c69d85b3$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
            }
        }
    }
}
function $608cfdd2c69d85b3$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord) {
    if (coordSysRecord) {
        coordSysRecordMap.removeKey(coordSysRecord.model.uid);
        var controller = coordSysRecord.controller;
        controller && controller.dispose();
    }
}
function $608cfdd2c69d85b3$var$createCoordSysRecord(api, coordSysModel) {
    // These init props will never change after record created.
    var coordSysRecord = {
        model: coordSysModel,
        containsPoint: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($608cfdd2c69d85b3$var$containsPoint, coordSysModel),
        dispatchAction: (0, $1b239fc9d3a2f8ae$export$c3095a23b368d1f2)($608cfdd2c69d85b3$var$dispatchAction, api),
        dataZoomInfoMap: null,
        controller: null
    };
    // Must not do anything depends on coordSysRecord outside the event handler here,
    // because coordSysRecord not completed yet.
    var controller = coordSysRecord.controller = new (0, $36ebde58055237cc$export$2e2bcd8739ae039)(api.getZr());
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
        'pan',
        'zoom',
        'scrollMove'
    ], function(eventName) {
        controller.on(eventName, function(event) {
            var batch = [];
            coordSysRecord.dataZoomInfoMap.each(function(dzInfo) {
                // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
                // moveOnMouseWheel, ...) enabled.
                if (!event.isAvailableBehavior(dzInfo.model.option)) return;
                var method = (dzInfo.getRange || {})[eventName];
                var range = method && method(dzInfo.dzReferCoordSysInfo, coordSysRecord.model.mainType, coordSysRecord.controller, event);
                !dzInfo.model.get('disabled', true) && range && batch.push({
                    dataZoomId: dzInfo.model.id,
                    start: range[0],
                    end: range[1]
                });
            });
            batch.length && coordSysRecord.dispatchAction(batch);
        });
    });
    return coordSysRecord;
}
/**
 * This action will be throttled.
 */ function $608cfdd2c69d85b3$var$dispatchAction(api, batch) {
    if (!api.isDisposed()) api.dispatchAction({
        type: 'dataZoom',
        animation: {
            easing: 'cubicOut',
            duration: 100
        },
        batch: batch
    });
}
function $608cfdd2c69d85b3$var$containsPoint(coordSysModel, e, x, y) {
    return coordSysModel.coordinateSystem.containPoint([
        x,
        y
    ]);
}
/**
 * Merge roamController settings when multiple dataZooms share one roamController.
 */ function $608cfdd2c69d85b3$var$mergeControllerParams(dataZoomInfoMap) {
    var controlType;
    // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
    // as string, it is probably revert to reserved word by compress tool. See #7411.
    var prefix = 'type_';
    var typePriority = {
        'type_true': 2,
        'type_move': 1,
        'type_false': 0,
        'type_undefined': -1
    };
    var preventDefaultMouseMove = true;
    dataZoomInfoMap.each(function(dataZoomInfo) {
        var dataZoomModel = dataZoomInfo.model;
        var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
        if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) controlType = oneType;
        // Prevent default move event by default. If one false, do not prevent. Otherwise
        // users may be confused why it does not work when multiple insideZooms exist.
        preventDefaultMouseMove = preventDefaultMouseMove && dataZoomModel.get('preventDefaultMouseMove', true);
    });
    return {
        controlType: controlType,
        opt: {
            // RoamController will enable all of these functionalities,
            // and the final behavior is determined by its event listener
            // provided by each inside zoom.
            zoomOnMouseWheel: true,
            moveOnMouseMove: true,
            moveOnMouseWheel: true,
            preventDefaultMouseMove: !!preventDefaultMouseMove
        }
    };
}
function $608cfdd2c69d85b3$export$f3632ddafc9ea51e(registers) {
    registers.registerProcessor(registers.PRIORITY.PROCESSOR.FILTER, function(ecModel, api) {
        var apiInner = $608cfdd2c69d85b3$var$inner(api);
        var coordSysRecordMap = apiInner.coordSysRecordMap || (apiInner.coordSysRecordMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)());
        coordSysRecordMap.each(function(coordSysRecord) {
            // `coordSysRecordMap` always exists (because it holds the `roam controller`, which should
            // better not re-create each time), but clear `dataZoomInfoMap` each round of the workflow.
            coordSysRecord.dataZoomInfoMap = null;
        });
        ecModel.eachComponent({
            mainType: 'dataZoom',
            subType: 'inside'
        }, function(dataZoomModel) {
            var dzReferCoordSysWrap = (0, $7ffe4a2ff6463652$export$b41173dee9da195b)(dataZoomModel);
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(dzReferCoordSysWrap.infoList, function(dzCoordSysInfo) {
                var coordSysUid = dzCoordSysInfo.model.uid;
                var coordSysRecord = coordSysRecordMap.get(coordSysUid) || coordSysRecordMap.set(coordSysUid, $608cfdd2c69d85b3$var$createCoordSysRecord(api, dzCoordSysInfo.model));
                var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap || (coordSysRecord.dataZoomInfoMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)());
                // Notice these props might be changed each time for a single dataZoomModel.
                dataZoomInfoMap.set(dataZoomModel.uid, {
                    dzReferCoordSysInfo: dzCoordSysInfo,
                    model: dataZoomModel,
                    getRange: null
                });
            });
        });
        // (1) Merge dataZoom settings for each coord sys and set to the roam controller.
        // (2) Clear coord sys if not refered by any dataZoom.
        coordSysRecordMap.each(function(coordSysRecord) {
            var controller = coordSysRecord.controller;
            var firstDzInfo;
            var dataZoomInfoMap = coordSysRecord.dataZoomInfoMap;
            if (dataZoomInfoMap) {
                var firstDzKey = dataZoomInfoMap.keys()[0];
                if (firstDzKey != null) firstDzInfo = dataZoomInfoMap.get(firstDzKey);
            }
            if (!firstDzInfo) {
                $608cfdd2c69d85b3$var$disposeCoordSysRecord(coordSysRecordMap, coordSysRecord);
                return;
            }
            var controllerParams = $608cfdd2c69d85b3$var$mergeControllerParams(dataZoomInfoMap);
            controller.enable(controllerParams.controlType, controllerParams.opt);
            controller.setPointerChecker(coordSysRecord.containsPoint);
            $ef22ba67fe7cfc59$export$958e3e1a02eac4b6(coordSysRecord, 'dispatchAction', firstDzInfo.model.get('throttle', true), 'fixRate');
        });
    });
}



var $48a53ff36963f339$var$InsideZoomView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(InsideZoomView, _super);
    function InsideZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataZoom.inside';
        return _this;
    }
    InsideZoomView.prototype.render = function(dataZoomModel, ecModel, api) {
        _super.prototype.render.apply(this, arguments);
        if (dataZoomModel.noTarget()) {
            this._clear();
            return;
        }
        // Hence the `throttle` util ensures to preserve command order,
        // here simply updating range all the time will not cause missing
        // any of the the roam change.
        this.range = dataZoomModel.getPercentRange();
        // Reset controllers.
        $608cfdd2c69d85b3$export$c499fdc26107c565(api, dataZoomModel, {
            pan: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($48a53ff36963f339$var$getRangeHandlers.pan, this),
            zoom: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($48a53ff36963f339$var$getRangeHandlers.zoom, this),
            scrollMove: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)($48a53ff36963f339$var$getRangeHandlers.scrollMove, this)
        });
    };
    InsideZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    InsideZoomView.prototype._clear = function() {
        $608cfdd2c69d85b3$export$d074fdbbb2bf218c(this.api, this.dataZoomModel);
        this.range = null;
    };
    InsideZoomView.type = 'dataZoom.inside';
    return InsideZoomView;
}((0, $ead8453d3c95e378$export$2e2bcd8739ae039));
var $48a53ff36963f339$var$getRangeHandlers = {
    zoom: function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var directionInfo = $48a53ff36963f339$var$getDirectionInfo[coordSysMainType](null, [
            e.originX,
            e.originY
        ], axisModel, controller, coordSysInfo);
        var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
        var scale = Math.max(1 / e.scale, 0);
        range[0] = (range[0] - percentPoint) * scale + percentPoint;
        range[1] = (range[1] - percentPoint) * scale + percentPoint;
        // Restrict range.
        var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        (0, $15a7158def1e4179$export$2e2bcd8739ae039)(0, range, [
            0,
            100
        ], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    },
    pan: $48a53ff36963f339$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $48a53ff36963f339$var$getDirectionInfo[coordSysMainType]([
            e.oldX,
            e.oldY
        ], [
            e.newX,
            e.newY
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
    }),
    scrollMove: $48a53ff36963f339$var$makeMover(function(range, axisModel, coordSysInfo, coordSysMainType, controller, e) {
        var directionInfo = $48a53ff36963f339$var$getDirectionInfo[coordSysMainType]([
            0,
            0
        ], [
            e.scrollDelta,
            e.scrollDelta
        ], axisModel, controller, coordSysInfo);
        return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
    })
};
function $48a53ff36963f339$var$makeMover(getPercentDelta) {
    return function(coordSysInfo, coordSysMainType, controller, e) {
        var lastRange = this.range;
        var range = lastRange.slice();
        // Calculate transform by the first axis.
        var axisModel = coordSysInfo.axisModels[0];
        if (!axisModel) return;
        var percentDelta = getPercentDelta(range, axisModel, coordSysInfo, coordSysMainType, controller, e);
        (0, $15a7158def1e4179$export$2e2bcd8739ae039)(percentDelta, range, [
            0,
            100
        ], 'all');
        this.range = range;
        if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) return range;
    };
}
var $48a53ff36963f339$var$getDirectionInfo = {
    grid: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.dim === 'x') {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // axis.dim === 'y'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    polar: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var ret = {};
        var polar = coordSysInfo.model.coordinateSystem;
        var radiusExtent = polar.getRadiusAxis().getExtent();
        var angleExtent = polar.getAngleAxis().getExtent();
        oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [
            0,
            0
        ];
        newPoint = polar.pointToCoord(newPoint);
        if (axisModel.mainType === 'radiusAxis') {
            ret.pixel = newPoint[0] - oldPoint[0];
            // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
            // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
            ret.pixelLength = radiusExtent[1] - radiusExtent[0];
            ret.pixelStart = radiusExtent[0];
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'angleAxis'
            ret.pixel = newPoint[1] - oldPoint[1];
            // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
            // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
            ret.pixelLength = angleExtent[1] - angleExtent[0];
            ret.pixelStart = angleExtent[0];
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    },
    singleAxis: function(oldPoint, newPoint, axisModel, controller, coordSysInfo) {
        var axis = axisModel.axis;
        var rect = coordSysInfo.model.coordinateSystem.getRect();
        var ret = {};
        oldPoint = oldPoint || [
            0,
            0
        ];
        if (axis.orient === 'horizontal') {
            ret.pixel = newPoint[0] - oldPoint[0];
            ret.pixelLength = rect.width;
            ret.pixelStart = rect.x;
            ret.signal = axis.inverse ? 1 : -1;
        } else {
            // 'vertical'
            ret.pixel = newPoint[1] - oldPoint[1];
            ret.pixelLength = rect.height;
            ret.pixelStart = rect.y;
            ret.signal = axis.inverse ? -1 : 1;
        }
        return ret;
    }
};
var $48a53ff36963f339$export$2e2bcd8739ae039 = $48a53ff36963f339$var$InsideZoomView;




function $45a375fcae74d72f$export$4b3e715f166fdd78(registers) {
    (0, $a4957b6f96aa8101$export$2e2bcd8739ae039)(registers);
    registers.registerComponentModel((0, $2481d926e75cce9b$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $48a53ff36963f339$export$2e2bcd8739ae039));
    (0, $608cfdd2c69d85b3$export$f3632ddafc9ea51e)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $fe641d66b2439f75$var$SliderZoomModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SliderZoomModel, _super);
    function SliderZoomModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomModel.type;
        return _this;
    }
    SliderZoomModel.type = 'dataZoom.slider';
    SliderZoomModel.layoutMode = 'box';
    SliderZoomModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $c71b8584d0593ae5$export$2e2bcd8739ae039).defaultOption, {
        show: true,
        // deault value can only be drived in view stage.
        right: 'ph',
        top: 'ph',
        width: 'ph',
        height: 'ph',
        left: null,
        bottom: null,
        borderColor: '#d2dbee',
        borderRadius: 3,
        backgroundColor: 'rgba(47,69,84,0)',
        // dataBackgroundColor: '#ddd',
        dataBackground: {
            lineStyle: {
                color: '#d2dbee',
                width: 0.5
            },
            areaStyle: {
                color: '#d2dbee',
                opacity: 0.2
            }
        },
        selectedDataBackground: {
            lineStyle: {
                color: '#8fb0f7',
                width: 0.5
            },
            areaStyle: {
                color: '#8fb0f7',
                opacity: 0.2
            }
        },
        // Color of selected window.
        fillerColor: 'rgba(135,175,274,0.2)',
        handleIcon: 'path://M-9.35,34.56V42m0-40V9.5m-2,0h4a2,2,0,0,1,2,2v21a2,2,0,0,1-2,2h-4a2,2,0,0,1-2-2v-21A2,2,0,0,1-11.35,9.5Z',
        // Percent of the slider height
        handleSize: '100%',
        handleStyle: {
            color: '#fff',
            borderColor: '#ACB8D1'
        },
        moveHandleSize: 7,
        moveHandleIcon: 'path://M-320.9-50L-320.9-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-348-41-339-50-320.9-50z M-212.3-50L-212.3-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-239.4-41-230.4-50-212.3-50z M-103.7-50L-103.7-50c18.1,0,27.1,9,27.1,27.1V85.7c0,18.1-9,27.1-27.1,27.1l0,0c-18.1,0-27.1-9-27.1-27.1V-22.9C-130.9-41-121.8-50-103.7-50z',
        moveHandleStyle: {
            color: '#D2DBEE',
            opacity: 0.7
        },
        showDetail: true,
        showDataShadow: 'auto',
        realtime: true,
        zoomLock: false,
        textStyle: {
            color: '#6E7079'
        },
        brushSelect: true,
        brushStyle: {
            color: 'rgba(135,175,274,0.15)'
        },
        emphasis: {
            handleLabel: {
                show: true
            },
            handleStyle: {
                borderColor: '#8FB0F7'
            },
            moveHandleStyle: {
                color: '#8FB0F7'
            }
        }
    });
    return SliderZoomModel;
}((0, $c71b8584d0593ae5$export$2e2bcd8739ae039));
var $fe641d66b2439f75$export$2e2bcd8739ae039 = $fe641d66b2439f75$var$SliderZoomModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 













var $0e253d66b1b3759d$var$Rect = $37476269d425e3f6$export$2e2bcd8739ae039;
// Constants
var $0e253d66b1b3759d$var$DEFAULT_LOCATION_EDGE_GAP = 7;
var $0e253d66b1b3759d$var$DEFAULT_FRAME_BORDER_WIDTH = 1;
var $0e253d66b1b3759d$var$DEFAULT_FILLER_SIZE = 30;
var $0e253d66b1b3759d$var$DEFAULT_MOVE_HANDLE_SIZE = 7;
var $0e253d66b1b3759d$var$HORIZONTAL = 'horizontal';
var $0e253d66b1b3759d$var$VERTICAL = 'vertical';
var $0e253d66b1b3759d$var$LABEL_GAP = 5;
var $0e253d66b1b3759d$var$SHOW_DATA_SHADOW_SERIES_TYPE = [
    'line',
    'bar',
    'candlestick',
    'scatter'
];
var $0e253d66b1b3759d$var$REALTIME_ANIMATION_CONFIG = {
    easing: 'cubicOut',
    duration: 100,
    delay: 0
};
var $0e253d66b1b3759d$var$SliderZoomView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(SliderZoomView, _super);
    function SliderZoomView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = SliderZoomView.type;
        _this._displayables = {};
        return _this;
    }
    SliderZoomView.prototype.init = function(ecModel, api) {
        this.api = api;
        // A unique handler for each dataZoom component
        this._onBrush = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onBrush, this);
        this._onBrushEnd = (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onBrushEnd, this);
    };
    SliderZoomView.prototype.render = function(dataZoomModel, ecModel, api, payload) {
        _super.prototype.render.apply(this, arguments);
        $ef22ba67fe7cfc59$export$958e3e1a02eac4b6(this, '_dispatchZoomAction', dataZoomModel.get('throttle'), 'fixRate');
        this._orient = dataZoomModel.getOrient();
        if (dataZoomModel.get('show') === false) {
            this.group.removeAll();
            return;
        }
        if (dataZoomModel.noTarget()) {
            this._clear();
            this.group.removeAll();
            return;
        }
        // Notice: this._resetInterval() should not be executed when payload.type
        // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
        // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
        if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) this._buildView();
        this._updateView();
    };
    SliderZoomView.prototype.dispose = function() {
        this._clear();
        _super.prototype.dispose.apply(this, arguments);
    };
    SliderZoomView.prototype._clear = function() {
        $ef22ba67fe7cfc59$export$42ffd38884aecdac(this, '_dispatchZoomAction');
        var zr = this.api.getZr();
        zr.off('mousemove', this._onBrush);
        zr.off('mouseup', this._onBrushEnd);
    };
    SliderZoomView.prototype._buildView = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        this._brushing = false;
        this._displayables.brushRect = null;
        this._resetLocation();
        this._resetInterval();
        var barGroup = this._displayables.sliderGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        this._renderBackground();
        this._renderHandle();
        this._renderDataShadow();
        thisGroup.add(barGroup);
        this._positionGroup();
    };
    SliderZoomView.prototype._resetLocation = function() {
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var showMoveHandle = dataZoomModel.get('brushSelect');
        var moveHandleSize = showMoveHandle ? $0e253d66b1b3759d$var$DEFAULT_MOVE_HANDLE_SIZE : 0;
        // If some of x/y/width/height are not specified,
        // auto-adapt according to target grid.
        var coordRect = this._findCoordRect();
        var ecSize = {
            width: api.getWidth(),
            height: api.getHeight()
        };
        // Default align by coordinate system rect.
        var positionInfo = this._orient === $0e253d66b1b3759d$var$HORIZONTAL ? {
            // Why using 'right', because right should be used in vertical,
            // and it is better to be consistent for dealing with position param merge.
            right: ecSize.width - coordRect.x - coordRect.width,
            top: ecSize.height - $0e253d66b1b3759d$var$DEFAULT_FILLER_SIZE - $0e253d66b1b3759d$var$DEFAULT_LOCATION_EDGE_GAP - moveHandleSize,
            width: coordRect.width,
            height: $0e253d66b1b3759d$var$DEFAULT_FILLER_SIZE
        } : {
            right: $0e253d66b1b3759d$var$DEFAULT_LOCATION_EDGE_GAP,
            top: coordRect.y,
            width: $0e253d66b1b3759d$var$DEFAULT_FILLER_SIZE,
            height: coordRect.height
        };
        // Do not write back to option and replace value 'ph', because
        // the 'ph' value should be recalculated when resize.
        var layoutParams = $501dc28f6c4d24ac$export$4b0d20af19c9875e(dataZoomModel.option);
        // Replace the placeholder value.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            'right',
            'top',
            'width',
            'height'
        ], function(name) {
            if (layoutParams[name] === 'ph') layoutParams[name] = positionInfo[name];
        });
        var layoutRect = $501dc28f6c4d24ac$export$4517a5ca639a7293(layoutParams, ecSize);
        this._location = {
            x: layoutRect.x,
            y: layoutRect.y
        };
        this._size = [
            layoutRect.width,
            layoutRect.height
        ];
        this._orient === $0e253d66b1b3759d$var$VERTICAL && this._size.reverse();
    };
    SliderZoomView.prototype._positionGroup = function() {
        var thisGroup = this.group;
        var location = this._location;
        var orient = this._orient;
        // Just use the first axis to determine mapping.
        var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
        var inverse = targetAxisModel && targetAxisModel.get('inverse');
        var sliderGroup = this._displayables.sliderGroup;
        var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse;
        // Transform barGroup.
        sliderGroup.attr(orient === $0e253d66b1b3759d$var$HORIZONTAL && !inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: 1
        } : orient === $0e253d66b1b3759d$var$HORIZONTAL && inverse ? {
            scaleY: otherAxisInverse ? 1 : -1,
            scaleX: -1
        } : orient === $0e253d66b1b3759d$var$VERTICAL && !inverse ? {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: 1,
            rotation: Math.PI / 2
        } : {
            scaleY: otherAxisInverse ? -1 : 1,
            scaleX: -1,
            rotation: Math.PI / 2
        });
        // Position barGroup
        var rect = thisGroup.getBoundingRect([
            sliderGroup
        ]);
        thisGroup.x = location.x - rect.x;
        thisGroup.y = location.y - rect.y;
        thisGroup.markRedraw();
    };
    SliderZoomView.prototype._getViewExtent = function() {
        return [
            0,
            this._size[0]
        ];
    };
    SliderZoomView.prototype._renderBackground = function() {
        var dataZoomModel = this.dataZoomModel;
        var size = this._size;
        var barGroup = this._displayables.sliderGroup;
        var brushSelect = dataZoomModel.get('brushSelect');
        barGroup.add(new $0e253d66b1b3759d$var$Rect({
            silent: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: dataZoomModel.get('backgroundColor')
            },
            z2: -40
        }));
        // Click panel, over shadow, below handles.
        var clickPanel = new $0e253d66b1b3759d$var$Rect({
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1]
            },
            style: {
                fill: 'transparent'
            },
            z2: 0,
            onclick: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onClickPanel, this)
        });
        var zr = this.api.getZr();
        if (brushSelect) {
            clickPanel.on('mousedown', this._onBrushStart, this);
            clickPanel.cursor = 'crosshair';
            zr.on('mousemove', this._onBrush);
            zr.on('mouseup', this._onBrushEnd);
        } else {
            zr.off('mousemove', this._onBrush);
            zr.off('mouseup', this._onBrushEnd);
        }
        barGroup.add(clickPanel);
    };
    SliderZoomView.prototype._renderDataShadow = function() {
        var info = this._dataShadowInfo = this._prepareDataShadowInfo();
        this._displayables.dataShadowSegs = [];
        if (!info) return;
        var size = this._size;
        var oldSize = this._shadowSize || [];
        var seriesModel = info.series;
        var data = seriesModel.getRawData();
        var candlestickDim = seriesModel.getShadowDim && seriesModel.getShadowDim();
        var otherDim = candlestickDim && data.getDimensionInfo(candlestickDim) ? seriesModel.getShadowDim() // @see candlestick
         : info.otherDim;
        if (otherDim == null) return;
        var polygonPts = this._shadowPolygonPts;
        var polylinePts = this._shadowPolylinePts;
        // Not re-render if data doesn't change.
        if (data !== this._shadowData || otherDim !== this._shadowDim || size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            var otherDataExtent_1 = data.getDataExtent(otherDim);
            // Nice extent.
            var otherOffset = (otherDataExtent_1[1] - otherDataExtent_1[0]) * 0.3;
            otherDataExtent_1 = [
                otherDataExtent_1[0] - otherOffset,
                otherDataExtent_1[1] + otherOffset
            ];
            var otherShadowExtent_1 = [
                0,
                size[1]
            ];
            var thisShadowExtent = [
                0,
                size[0]
            ];
            var areaPoints_1 = [
                [
                    size[0],
                    0
                ],
                [
                    0,
                    0
                ]
            ];
            var linePoints_1 = [];
            var step_1 = thisShadowExtent[1] / (data.count() - 1);
            var thisCoord_1 = 0;
            // Optimize for large data shadow
            var stride_1 = Math.round(data.count() / size[0]);
            var lastIsEmpty_1;
            data.each([
                otherDim
            ], function(value, index) {
                if (stride_1 > 0 && index % stride_1) {
                    thisCoord_1 += step_1;
                    return;
                }
                // FIXME
                // Should consider axis.min/axis.max when drawing dataShadow.
                // FIXME
                // 应该使用统一的空判断？还是在list里进行空判断？
                var isEmpty = value == null || isNaN(value) || value === '';
                // See #4235.
                var otherCoord = isEmpty ? 0 : (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(value, otherDataExtent_1, otherShadowExtent_1, true);
                // Attempt to draw data shadow precisely when there are empty value.
                if (isEmpty && !lastIsEmpty_1 && index) {
                    areaPoints_1.push([
                        areaPoints_1[areaPoints_1.length - 1][0],
                        0
                    ]);
                    linePoints_1.push([
                        linePoints_1[linePoints_1.length - 1][0],
                        0
                    ]);
                } else if (!isEmpty && lastIsEmpty_1) {
                    areaPoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                    linePoints_1.push([
                        thisCoord_1,
                        0
                    ]);
                }
                areaPoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                linePoints_1.push([
                    thisCoord_1,
                    otherCoord
                ]);
                thisCoord_1 += step_1;
                lastIsEmpty_1 = isEmpty;
            });
            polygonPts = this._shadowPolygonPts = areaPoints_1;
            polylinePts = this._shadowPolylinePts = linePoints_1;
        }
        this._shadowData = data;
        this._shadowDim = otherDim;
        this._shadowSize = [
            size[0],
            size[1]
        ];
        var dataZoomModel = this.dataZoomModel;
        function createDataShadowGroup(isSelectedArea) {
            var model = dataZoomModel.getModel(isSelectedArea ? 'selectedDataBackground' : 'dataBackground');
            var group = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
            var polygon = new $399011f87accd5da$export$2e2bcd8739ae039({
                shape: {
                    points: polygonPts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel('areaStyle').getAreaStyle(),
                silent: true,
                z2: -20
            });
            var polyline = new $f7f6523750aec7c8$export$2e2bcd8739ae039({
                shape: {
                    points: polylinePts
                },
                segmentIgnoreThreshold: 1,
                style: model.getModel('lineStyle').getLineStyle(),
                silent: true,
                z2: -19
            });
            group.add(polygon);
            group.add(polyline);
            return group;
        }
        // let dataBackgroundModel = dataZoomModel.getModel('dataBackground');
        for(var i = 0; i < 3; i++){
            var group = createDataShadowGroup(i === 1);
            this._displayables.sliderGroup.add(group);
            this._displayables.dataShadowSegs.push(group);
        }
    };
    SliderZoomView.prototype._prepareDataShadowInfo = function() {
        var dataZoomModel = this.dataZoomModel;
        var showDataShadow = dataZoomModel.get('showDataShadow');
        if (showDataShadow === false) return;
        // Find a representative series.
        var result;
        var ecModel = this.ecModel;
        dataZoomModel.eachTargetAxis(function(axisDim, axisIndex) {
            var seriesModels = dataZoomModel.getAxisProxy(axisDim, axisIndex).getTargetSeriesModels();
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(seriesModels, function(seriesModel) {
                if (result) return;
                if (showDataShadow !== true && (0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)($0e253d66b1b3759d$var$SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) return;
                var thisAxis = ecModel.getComponent((0, $7ffe4a2ff6463652$export$90855f7219399082)(axisDim), axisIndex).axis;
                var otherDim = $0e253d66b1b3759d$var$getOtherDim(axisDim);
                var otherAxisInverse;
                var coordSys = seriesModel.coordinateSystem;
                if (otherDim != null && coordSys.getOtherAxis) otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
                otherDim = seriesModel.getData().mapDimension(otherDim);
                result = {
                    thisAxis: thisAxis,
                    series: seriesModel,
                    thisDim: axisDim,
                    otherDim: otherDim,
                    otherAxisInverse: otherAxisInverse
                };
            }, this);
        }, this);
        return result;
    };
    SliderZoomView.prototype._renderHandle = function() {
        var thisGroup = this.group;
        var displayables = this._displayables;
        var handles = displayables.handles = [
            null,
            null
        ];
        var handleLabels = displayables.handleLabels = [
            null,
            null
        ];
        var sliderGroup = this._displayables.sliderGroup;
        var size = this._size;
        var dataZoomModel = this.dataZoomModel;
        var api = this.api;
        var borderRadius = dataZoomModel.get('borderRadius') || 0;
        var brushSelect = dataZoomModel.get('brushSelect');
        var filler = displayables.filler = new $0e253d66b1b3759d$var$Rect({
            silent: brushSelect,
            style: {
                fill: dataZoomModel.get('fillerColor')
            },
            textConfig: {
                position: 'inside'
            }
        });
        sliderGroup.add(filler);
        // Frame border.
        sliderGroup.add(new $0e253d66b1b3759d$var$Rect({
            silent: true,
            subPixelOptimize: true,
            shape: {
                x: 0,
                y: 0,
                width: size[0],
                height: size[1],
                r: borderRadius
            },
            style: {
                // deprecated option
                stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
                lineWidth: $0e253d66b1b3759d$var$DEFAULT_FRAME_BORDER_WIDTH,
                fill: 'rgba(0,0,0,0)'
            }
        }));
        // Left and right handle to resize
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            var iconStr = dataZoomModel.get('handleIcon');
            if (!(0, $da6220012439db7b$export$33fc3b478d332725)[iconStr] && iconStr.indexOf('path://') < 0 && iconStr.indexOf('image://') < 0) // Compatitable with the old icon parsers. Which can use a path string without path://
            iconStr = 'path://' + iconStr;
            var path = (0, $da6220012439db7b$export$af050e04da3a02e8)(iconStr, -1, 0, 2, 2, null, true);
            path.attr({
                cursor: $0e253d66b1b3759d$var$getCursor(this._orient),
                draggable: true,
                drift: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onDragMove, this, handleIndex),
                ondragend: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onDragEnd, this),
                onmouseover: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._showDataInfo, this, true),
                onmouseout: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._showDataInfo, this, false),
                z2: 5
            });
            var bRect = path.getBoundingRect();
            var handleSize = dataZoomModel.get('handleSize');
            this._handleHeight = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(handleSize, this._size[1]);
            this._handleWidth = bRect.width / bRect.height * this._handleHeight;
            path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
            path.style.strokeNoScale = true;
            path.rectHover = true;
            path.ensureState('emphasis').style = dataZoomModel.getModel([
                'emphasis',
                'handleStyle'
            ]).getItemStyle();
            (0, $b414df7d361a211c$export$5f393df0b5aee2e7)(path);
            var handleColor = dataZoomModel.get('handleColor'); // deprecated option
            // Compatitable with previous version
            if (handleColor != null) path.style.fill = handleColor;
            sliderGroup.add(handles[handleIndex] = path);
            var textStyleModel = dataZoomModel.getModel('textStyle');
            var handleLabel = dataZoomModel.get('handleLabel') || {};
            var handleLabelShow = handleLabel.show || false;
            thisGroup.add(handleLabels[handleIndex] = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                silent: true,
                invisible: !handleLabelShow,
                style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                    x: 0,
                    y: 0,
                    text: '',
                    verticalAlign: 'middle',
                    align: 'center',
                    fill: textStyleModel.getTextColor(),
                    font: textStyleModel.getFont()
                }),
                z2: 10
            }));
        }, this);
        // Handle to move. Only visible when brushSelect is set true.
        var actualMoveZone = filler;
        if (brushSelect) {
            var moveHandleHeight = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(dataZoomModel.get('moveHandleSize'), size[1]);
            var moveHandle_1 = displayables.moveHandle = new $37476269d425e3f6$export$2e2bcd8739ae039({
                style: dataZoomModel.getModel('moveHandleStyle').getItemStyle(),
                silent: true,
                shape: {
                    r: [
                        0,
                        0,
                        2,
                        2
                    ],
                    y: size[1] - 0.5,
                    height: moveHandleHeight
                }
            });
            var iconSize = moveHandleHeight * 0.8;
            var moveHandleIcon = displayables.moveHandleIcon = (0, $da6220012439db7b$export$af050e04da3a02e8)(dataZoomModel.get('moveHandleIcon'), -iconSize / 2, -iconSize / 2, iconSize, iconSize, '#fff', true);
            moveHandleIcon.silent = true;
            moveHandleIcon.y = size[1] + moveHandleHeight / 2 - 0.5;
            moveHandle_1.ensureState('emphasis').style = dataZoomModel.getModel([
                'emphasis',
                'moveHandleStyle'
            ]).getItemStyle();
            var moveZoneExpandSize = Math.min(size[1] / 2, Math.max(moveHandleHeight, 10));
            actualMoveZone = displayables.moveZone = new $37476269d425e3f6$export$2e2bcd8739ae039({
                invisible: true,
                shape: {
                    y: size[1] - moveZoneExpandSize,
                    height: moveHandleHeight + moveZoneExpandSize
                }
            });
            actualMoveZone.on('mouseover', function() {
                api.enterEmphasis(moveHandle_1);
            }).on('mouseout', function() {
                api.leaveEmphasis(moveHandle_1);
            });
            sliderGroup.add(moveHandle_1);
            sliderGroup.add(moveHandleIcon);
            sliderGroup.add(actualMoveZone);
        }
        actualMoveZone.attr({
            draggable: true,
            cursor: $0e253d66b1b3759d$var$getCursor(this._orient),
            drift: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onDragMove, this, 'all'),
            ondragstart: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._showDataInfo, this, true),
            ondragend: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._onDragEnd, this),
            onmouseover: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._showDataInfo, this, true),
            onmouseout: (0, $1b239fc9d3a2f8ae$export$2385a24977818dd0)(this._showDataInfo, this, false)
        });
    };
    SliderZoomView.prototype._resetInterval = function() {
        var range = this._range = this.dataZoomModel.getPercentRange();
        var viewExtent = this._getViewExtent();
        this._handleEnds = [
            (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(range[0], [
                0,
                100
            ], viewExtent, true),
            (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(range[1], [
                0,
                100
            ], viewExtent, true)
        ];
    };
    SliderZoomView.prototype._updateInterval = function(handleIndex, delta) {
        var dataZoomModel = this.dataZoomModel;
        var handleEnds = this._handleEnds;
        var viewExtend = this._getViewExtent();
        var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
        var percentExtent = [
            0,
            100
        ];
        (0, $15a7158def1e4179$export$2e2bcd8739ae039)(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
        var lastRange = this._range;
        var range = this._range = (0, $9fd90cf3bf18fbcd$export$debe6e778e0a6d32)([
            (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(handleEnds[0], viewExtend, percentExtent, true),
            (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(handleEnds[1], viewExtend, percentExtent, true)
        ]);
        return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
    };
    SliderZoomView.prototype._updateView = function(nonRealtime) {
        var displaybles = this._displayables;
        var handleEnds = this._handleEnds;
        var handleInterval = (0, $9fd90cf3bf18fbcd$export$debe6e778e0a6d32)(handleEnds.slice());
        var size = this._size;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)([
            0,
            1
        ], function(handleIndex) {
            // Handles
            var handle = displaybles.handles[handleIndex];
            var handleHeight = this._handleHeight;
            handle.attr({
                scaleX: handleHeight / 2,
                scaleY: handleHeight / 2,
                // This is a trick, by adding an extra tiny offset to let the default handle's end point align to the drag window.
                // NOTE: It may affect some custom shapes a bit. But we prefer to have better result by default.
                x: handleEnds[handleIndex] + (handleIndex ? -1 : 1),
                y: size[1] / 2 - handleHeight / 2
            });
        }, this);
        // Filler
        displaybles.filler.setShape({
            x: handleInterval[0],
            y: 0,
            width: handleInterval[1] - handleInterval[0],
            height: size[1]
        });
        var viewExtent = {
            x: handleInterval[0],
            width: handleInterval[1] - handleInterval[0]
        };
        // Move handle
        if (displaybles.moveHandle) {
            displaybles.moveHandle.setShape(viewExtent);
            displaybles.moveZone.setShape(viewExtent);
            // Force update path on the invisible object
            displaybles.moveZone.getBoundingRect();
            displaybles.moveHandleIcon && displaybles.moveHandleIcon.attr('x', viewExtent.x + viewExtent.width / 2);
        }
        // update clip path of shadow.
        var dataShadowSegs = displaybles.dataShadowSegs;
        var segIntervals = [
            0,
            handleInterval[0],
            handleInterval[1],
            size[0]
        ];
        for(var i = 0; i < dataShadowSegs.length; i++){
            var segGroup = dataShadowSegs[i];
            var clipPath = segGroup.getClipPath();
            if (!clipPath) {
                clipPath = new $37476269d425e3f6$export$2e2bcd8739ae039();
                segGroup.setClipPath(clipPath);
            }
            clipPath.setShape({
                x: segIntervals[i],
                y: 0,
                width: segIntervals[i + 1] - segIntervals[i],
                height: size[1]
            });
        }
        this._updateDataInfo(nonRealtime);
    };
    SliderZoomView.prototype._updateDataInfo = function(nonRealtime) {
        var dataZoomModel = this.dataZoomModel;
        var displaybles = this._displayables;
        var handleLabels = displaybles.handleLabels;
        var orient = this._orient;
        var labelTexts = [
            '',
            ''
        ];
        // FIXME
        // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
        if (dataZoomModel.get('showDetail')) {
            var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
            if (axisProxy) {
                var axis = axisProxy.getAxisModel().axis;
                var range = this._range;
                var dataInterval = nonRealtime ? axisProxy.calculateDataWindow({
                    start: range[0],
                    end: range[1]
                }).valueWindow : axisProxy.getDataValueWindow();
                labelTexts = [
                    this._formatLabel(dataInterval[0], axis),
                    this._formatLabel(dataInterval[1], axis)
                ];
            }
        }
        var orderedHandleEnds = (0, $9fd90cf3bf18fbcd$export$debe6e778e0a6d32)(this._handleEnds.slice());
        setLabel.call(this, 0);
        setLabel.call(this, 1);
        function setLabel(handleIndex) {
            // Label
            // Text should not transform by barGroup.
            // Ignore handlers transform
            var barTransform = $8eb95236e1aa01e7$export$fce0c6cfca85ed96(displaybles.handles[handleIndex].parent, this.group);
            var direction = $8eb95236e1aa01e7$export$fff94e9792354cfa(handleIndex === 0 ? 'right' : 'left', barTransform);
            var offset = this._handleWidth / 2 + $0e253d66b1b3759d$var$LABEL_GAP;
            var textPoint = $8eb95236e1aa01e7$export$9f9dcb98c894b623([
                orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset),
                this._size[1] / 2
            ], barTransform);
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                verticalAlign: orient === $0e253d66b1b3759d$var$HORIZONTAL ? 'middle' : direction,
                align: orient === $0e253d66b1b3759d$var$HORIZONTAL ? direction : 'center',
                text: labelTexts[handleIndex]
            });
        }
    };
    SliderZoomView.prototype._formatLabel = function(value, axis) {
        var dataZoomModel = this.dataZoomModel;
        var labelFormatter = dataZoomModel.get('labelFormatter');
        var labelPrecision = dataZoomModel.get('labelPrecision');
        if (labelPrecision == null || labelPrecision === 'auto') labelPrecision = axis.getPixelPrecision();
        var valueStr = value == null || isNaN(value) ? '' : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel({
            value: Math.round(value)
        }) : value.toFixed(Math.min(labelPrecision, 20));
        return (0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(labelFormatter) ? labelFormatter(value, valueStr) : (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
    };
    /**
   * @param isEmphasis true: show, false: hide
   */ SliderZoomView.prototype._showDataInfo = function(isEmphasis) {
        var handleLabel = this.dataZoomModel.get('handleLabel') || {};
        var normalShow = handleLabel.show || false;
        var emphasisHandleLabel = this.dataZoomModel.getModel([
            'emphasis',
            'handleLabel'
        ]);
        var emphasisShow = emphasisHandleLabel.get('show') || false;
        // Dragging is considered as emphasis, unless emphasisShow is false
        var toShow = isEmphasis || this._dragging ? emphasisShow : normalShow;
        var displayables = this._displayables;
        var handleLabels = displayables.handleLabels;
        handleLabels[0].attr('invisible', !toShow);
        handleLabels[1].attr('invisible', !toShow);
        // Highlight move handle
        displayables.moveHandle && this.api[toShow ? 'enterEmphasis' : 'leaveEmphasis'](displayables.moveHandle, 1);
    };
    SliderZoomView.prototype._onDragMove = function(handleIndex, dx, dy, event) {
        this._dragging = true;
        // For mobile device, prevent screen slider on the button.
        $8f7ba7c16ab1583e$export$fa6813432f753b0d(event.event);
        // Transform dx, dy to bar coordination.
        var barTransform = this._displayables.sliderGroup.getLocalTransform();
        var vertex = $8eb95236e1aa01e7$export$9f9dcb98c894b623([
            dx,
            dy
        ], barTransform, true);
        var changed = this._updateInterval(handleIndex, vertex[0]);
        var realtime = this.dataZoomModel.get('realtime');
        this._updateView(!realtime);
        // Avoid dispatch dataZoom repeatly but range not changed,
        // which cause bad visual effect when progressive enabled.
        changed && realtime && this._dispatchZoomAction(true);
    };
    SliderZoomView.prototype._onDragEnd = function() {
        this._dragging = false;
        this._showDataInfo(false);
        // While in realtime mode and stream mode, dispatch action when
        // drag end will cause the whole view rerender, which is unnecessary.
        var realtime = this.dataZoomModel.get('realtime');
        !realtime && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onClickPanel = function(e) {
        var size = this._size;
        var localPoint = this._displayables.sliderGroup.transformCoordToLocal(e.offsetX, e.offsetY);
        if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) return;
        var handleEnds = this._handleEnds;
        var center = (handleEnds[0] + handleEnds[1]) / 2;
        var changed = this._updateInterval('all', localPoint[0] - center);
        this._updateView();
        changed && this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrushStart = function(e) {
        var x = e.offsetX;
        var y = e.offsetY;
        this._brushStart = new $1a833abf0e5915e2$export$2e2bcd8739ae039(x, y);
        this._brushing = true;
        this._brushStartTime = +new Date();
    // this._updateBrushRect(x, y);
    };
    SliderZoomView.prototype._onBrushEnd = function(e) {
        if (!this._brushing) return;
        var brushRect = this._displayables.brushRect;
        this._brushing = false;
        if (!brushRect) return;
        brushRect.attr('ignore', true);
        var brushShape = brushRect.shape;
        var brushEndTime = +new Date();
        // console.log(brushEndTime - this._brushStartTime);
        if (brushEndTime - this._brushStartTime < 200 && Math.abs(brushShape.width) < 5) // Will treat it as a click
        return;
        var viewExtend = this._getViewExtent();
        var percentExtent = [
            0,
            100
        ];
        this._range = (0, $9fd90cf3bf18fbcd$export$debe6e778e0a6d32)([
            (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(brushShape.x, viewExtend, percentExtent, true),
            (0, $9fd90cf3bf18fbcd$export$d3f68fbaa670562)(brushShape.x + brushShape.width, viewExtend, percentExtent, true)
        ]);
        this._handleEnds = [
            brushShape.x,
            brushShape.x + brushShape.width
        ];
        this._updateView();
        this._dispatchZoomAction(false);
    };
    SliderZoomView.prototype._onBrush = function(e) {
        if (this._brushing) {
            // For mobile device, prevent screen slider on the button.
            $8f7ba7c16ab1583e$export$fa6813432f753b0d(e.event);
            this._updateBrushRect(e.offsetX, e.offsetY);
        }
    };
    SliderZoomView.prototype._updateBrushRect = function(mouseX, mouseY) {
        var displayables = this._displayables;
        var dataZoomModel = this.dataZoomModel;
        var brushRect = displayables.brushRect;
        if (!brushRect) {
            brushRect = displayables.brushRect = new $0e253d66b1b3759d$var$Rect({
                silent: true,
                style: dataZoomModel.getModel('brushStyle').getItemStyle()
            });
            displayables.sliderGroup.add(brushRect);
        }
        brushRect.attr('ignore', false);
        var brushStart = this._brushStart;
        var sliderGroup = this._displayables.sliderGroup;
        var endPoint = sliderGroup.transformCoordToLocal(mouseX, mouseY);
        var startPoint = sliderGroup.transformCoordToLocal(brushStart.x, brushStart.y);
        var size = this._size;
        endPoint[0] = Math.max(Math.min(size[0], endPoint[0]), 0);
        brushRect.setShape({
            x: startPoint[0],
            y: 0,
            width: endPoint[0] - startPoint[0],
            height: size[1]
        });
    };
    /**
   * This action will be throttled.
   */ SliderZoomView.prototype._dispatchZoomAction = function(realtime) {
        var range = this._range;
        this.api.dispatchAction({
            type: 'dataZoom',
            from: this.uid,
            dataZoomId: this.dataZoomModel.id,
            animation: realtime ? $0e253d66b1b3759d$var$REALTIME_ANIMATION_CONFIG : null,
            start: range[0],
            end: range[1]
        });
    };
    SliderZoomView.prototype._findCoordRect = function() {
        // Find the grid corresponding to the first axis referred by dataZoom.
        var rect;
        var coordSysInfoList = (0, $7ffe4a2ff6463652$export$b41173dee9da195b)(this.dataZoomModel).infoList;
        if (!rect && coordSysInfoList.length) {
            var coordSys = coordSysInfoList[0].model.coordinateSystem;
            rect = coordSys.getRect && coordSys.getRect();
        }
        if (!rect) {
            var width = this.api.getWidth();
            var height = this.api.getHeight();
            rect = {
                x: width * 0.2,
                y: height * 0.2,
                width: width * 0.6,
                height: height * 0.6
            };
        }
        return rect;
    };
    SliderZoomView.type = 'dataZoom.slider';
    return SliderZoomView;
}((0, $ead8453d3c95e378$export$2e2bcd8739ae039));
function $0e253d66b1b3759d$var$getOtherDim(thisDim) {
    // FIXME
    // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
    var map = {
        x: 'y',
        y: 'x',
        radius: 'angle',
        angle: 'radius'
    };
    return map[thisDim];
}
function $0e253d66b1b3759d$var$getCursor(orient) {
    return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}
var $0e253d66b1b3759d$export$2e2bcd8739ae039 = $0e253d66b1b3759d$var$SliderZoomView;



function $a080a581dea71881$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $fe641d66b2439f75$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $0e253d66b1b3759d$export$2e2bcd8739ae039));
    (0, $a4957b6f96aa8101$export$2e2bcd8739ae039)(registers);
}


function $cb18f41c6f42bb55$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $45a375fcae74d72f$export$4b3e715f166fdd78));
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $a080a581dea71881$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * @file Visual mapping.
 */ 
var $6650d53cb2636a7d$var$visualDefault = {
    /**
   * @public
   */ get: function(visualType, key, isCategory) {
        var value = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(($6650d53cb2636a7d$var$defaultOption[visualType] || {})[key]);
        return isCategory ? $1b239fc9d3a2f8ae$export$43bee75e5e14138e(value) ? value[value.length - 1] : value : value;
    }
};
var $6650d53cb2636a7d$var$defaultOption = {
    color: {
        active: [
            '#006edd',
            '#e0ffff'
        ],
        inactive: [
            'rgba(0,0,0,0)'
        ]
    },
    colorHue: {
        active: [
            0,
            360
        ],
        inactive: [
            0,
            0
        ]
    },
    colorSaturation: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    colorLightness: {
        active: [
            0.9,
            0.5
        ],
        inactive: [
            0,
            0
        ]
    },
    colorAlpha: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    opacity: {
        active: [
            0.3,
            1
        ],
        inactive: [
            0,
            0
        ]
    },
    symbol: {
        active: [
            'circle',
            'roundRect',
            'diamond'
        ],
        inactive: [
            'none'
        ]
    },
    symbolSize: {
        active: [
            10,
            50
        ],
        inactive: [
            0,
            0
        ]
    }
};
var $6650d53cb2636a7d$export$2e2bcd8739ae039 = $6650d53cb2636a7d$var$visualDefault;







var $8f160b3855b6aca1$var$mapVisual = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).mapVisual;
var $8f160b3855b6aca1$var$eachVisual = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).eachVisual;
var $8f160b3855b6aca1$var$isArray = $1b239fc9d3a2f8ae$export$43bee75e5e14138e;
var $8f160b3855b6aca1$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $8f160b3855b6aca1$var$asc = $9fd90cf3bf18fbcd$export$debe6e778e0a6d32;
var $8f160b3855b6aca1$var$linearMap = $9fd90cf3bf18fbcd$export$d3f68fbaa670562;
var $8f160b3855b6aca1$var$VisualMapModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(VisualMapModel, _super);
    function VisualMapModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapModel.type;
        _this.stateList = [
            'inRange',
            'outOfRange'
        ];
        _this.replacableOptionKeys = [
            'inRange',
            'outOfRange',
            'target',
            'controller',
            'color'
        ];
        _this.layoutMode = {
            type: 'box',
            ignoreSize: true
        };
        /**
     * [lowerBound, upperBound]
     */ _this.dataBound = [
            -Infinity,
            Infinity
        ];
        _this.targetVisuals = {};
        _this.controllerVisuals = {};
        return _this;
    }
    VisualMapModel.prototype.init = function(option, parentModel, ecModel) {
        this.mergeDefaultAndTheme(option, ecModel);
    };
    /**
   * @protected
   */ VisualMapModel.prototype.optionUpdated = function(newOption, isInit) {
        var thisOption = this.option;
        !isInit && $8c6eb7416a8c3770$export$797d20c0a6de578f(thisOption, newOption, this.replacableOptionKeys);
        this.textStyleModel = this.getModel('textStyle');
        this.resetItemSize();
        this.completeVisualOption();
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetVisual = function(supplementVisualOption) {
        var stateList = this.stateList;
        supplementVisualOption = $1b239fc9d3a2f8ae$export$2385a24977818dd0(supplementVisualOption, this);
        this.controllerVisuals = $8c6eb7416a8c3770$export$89974527642f24a0(this.option.controller, stateList, supplementVisualOption);
        this.targetVisuals = $8c6eb7416a8c3770$export$89974527642f24a0(this.option.target, stateList, supplementVisualOption);
    };
    /**
   * @public
   */ VisualMapModel.prototype.getItemSymbol = function() {
        return null;
    };
    /**
   * @protected
   * @return {Array.<number>} An array of series indices.
   */ VisualMapModel.prototype.getTargetSeriesIndices = function() {
        var optionSeriesIndex = this.option.seriesIndex;
        var seriesIndices = [];
        if (optionSeriesIndex == null || optionSeriesIndex === 'all') this.ecModel.eachSeries(function(seriesModel, index) {
            seriesIndices.push(index);
        });
        else seriesIndices = $9ac03c46e8b6e711$export$4f07b212a02c8051(optionSeriesIndex);
        return seriesIndices;
    };
    /**
   * @public
   */ VisualMapModel.prototype.eachTargetSeries = function(callback, context) {
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this.getTargetSeriesIndices(), function(seriesIndex) {
            var seriesModel = this.ecModel.getSeriesByIndex(seriesIndex);
            if (seriesModel) callback.call(context, seriesModel);
        }, this);
    };
    /**
   * @pubilc
   */ VisualMapModel.prototype.isTargetSeries = function(seriesModel) {
        var is = false;
        this.eachTargetSeries(function(model) {
            model === seriesModel && (is = true);
        });
        return is;
    };
    /**
   * @example
   * this.formatValueText(someVal); // format single numeric value to text.
   * this.formatValueText(someVal, true); // format single category value to text.
   * this.formatValueText([min, max]); // format numeric min-max to text.
   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
   *
   * @param value Real value, or this.dataBound[0 or 1].
   * @param isCategory Only available when value is number.
   * @param edgeSymbols Open-close symbol when value is interval.
   * @protected
   */ VisualMapModel.prototype.formatValueText = function(value, isCategory, edgeSymbols) {
        var option = this.option;
        var precision = option.precision;
        var dataBound = this.dataBound;
        var formatter = option.formatter;
        var isMinMax;
        edgeSymbols = edgeSymbols || [
            '<',
            '>'
        ];
        if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(value)) {
            value = value.slice();
            isMinMax = true;
        }
        var textValue = isCategory ? value // Value is string when isCategory
         : isMinMax ? [
            toFixed(value[0]),
            toFixed(value[1])
        ] : toFixed(value);
        if ($1b239fc9d3a2f8ae$export$844ec244b1367d54(formatter)) return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
        else if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(formatter)) return isMinMax ? formatter(value[0], value[1]) : formatter(value);
        if (isMinMax) {
            if (value[0] === dataBound[0]) return edgeSymbols[0] + ' ' + textValue[1];
            else if (value[1] === dataBound[1]) return edgeSymbols[1] + ' ' + textValue[0];
            else return textValue[0] + ' - ' + textValue[1];
        } else // Format single value (includes category case).
        return textValue;
        function toFixed(val) {
            return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
        }
    };
    /**
   * @protected
   */ VisualMapModel.prototype.resetExtent = function() {
        var thisOption = this.option;
        // Can not calculate data extent by data here.
        // Because series and data may be modified in processing stage.
        // So we do not support the feature "auto min/max".
        var extent = $8f160b3855b6aca1$var$asc([
            thisOption.min,
            thisOption.max
        ]);
        this._dataExtent = extent;
    };
    /**
   * PENDING:
   * delete this method if no outer usage.
   *
   * Return  Concrete dimension. If null/undefined is returned, no dimension is used.
   */ // getDataDimension(data: SeriesData) {
    //     const optDim = this.option.dimension;
    //     if (optDim != null) {
    //         return data.getDimension(optDim);
    //     }
    //     const dimNames = data.dimensions;
    //     for (let i = dimNames.length - 1; i >= 0; i--) {
    //         const dimName = dimNames[i];
    //         const dimInfo = data.getDimensionInfo(dimName);
    //         if (!dimInfo.isCalculationCoord) {
    //             return dimName;
    //         }
    //     }
    // }
    VisualMapModel.prototype.getDataDimensionIndex = function(data) {
        var optDim = this.option.dimension;
        if (optDim != null) return data.getDimensionIndex(optDim);
        var dimNames = data.dimensions;
        for(var i = dimNames.length - 1; i >= 0; i--){
            var dimName = dimNames[i];
            var dimInfo = data.getDimensionInfo(dimName);
            if (!dimInfo.isCalculationCoord) return dimInfo.storeDimIndex;
        }
    };
    VisualMapModel.prototype.getExtent = function() {
        return this._dataExtent.slice();
    };
    VisualMapModel.prototype.completeVisualOption = function() {
        var ecModel = this.ecModel;
        var thisOption = this.option;
        var base = {
            inRange: thisOption.inRange,
            outOfRange: thisOption.outOfRange
        };
        var target = thisOption.target || (thisOption.target = {});
        var controller = thisOption.controller || (thisOption.controller = {});
        $1b239fc9d3a2f8ae$export$4950aa0f605343fb(target, base); // Do not override
        $1b239fc9d3a2f8ae$export$4950aa0f605343fb(controller, base); // Do not override
        var isCategory = this.isCategory();
        completeSingle.call(this, target);
        completeSingle.call(this, controller);
        completeInactive.call(this, target, 'inRange', 'outOfRange');
        // completeInactive.call(this, target, 'outOfRange', 'inRange');
        completeController.call(this, controller);
        function completeSingle(base) {
            // Compatible with ec2 dataRange.color.
            // The mapping order of dataRange.color is: [high value, ..., low value]
            // whereas inRange.color and outOfRange.color is [low value, ..., high value]
            // Notice: ec2 has no inverse.
            if ($8f160b3855b6aca1$var$isArray(thisOption.color) && !base.inRange) base.inRange = {
                color: thisOption.color.slice().reverse()
            };
            // Compatible with previous logic, always give a default color, otherwise
            // simple config with no inRange and outOfRange will not work.
            // Originally we use visualMap.color as the default color, but setOption at
            // the second time the default color will be erased. So we change to use
            // constant DEFAULT_COLOR.
            // If user do not want the default color, set inRange: {color: null}.
            base.inRange = base.inRange || {
                color: ecModel.get('gradientColor')
            };
        }
        function completeInactive(base, stateExist, stateAbsent) {
            var optExist = base[stateExist];
            var optAbsent = base[stateAbsent];
            if (optExist && !optAbsent) {
                optAbsent = base[stateAbsent] = {};
                $8f160b3855b6aca1$var$each(optExist, function(visualData, visualType) {
                    if (!(0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).isValidType(visualType)) return;
                    var defa = (0, $6650d53cb2636a7d$export$2e2bcd8739ae039).get(visualType, 'inactive', isCategory);
                    if (defa != null) {
                        optAbsent[visualType] = defa;
                        // Compatibable with ec2:
                        // Only inactive color to rgba(0,0,0,0) can not
                        // make label transparent, so use opacity also.
                        if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) optAbsent.opacity = [
                            0,
                            0
                        ];
                    }
                });
            }
        }
        function completeController(controller) {
            var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
            var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
            var inactiveColor = this.get('inactiveColor');
            var itemSymbol = this.getItemSymbol();
            var defaultSymbol = itemSymbol || 'roundRect';
            $8f160b3855b6aca1$var$each(this.stateList, function(state) {
                var itemSize = this.itemSize;
                var visuals = controller[state];
                // Set inactive color for controller if no other color
                // attr (like colorAlpha) specified.
                if (!visuals) visuals = controller[state] = {
                    color: isCategory ? inactiveColor : [
                        inactiveColor
                    ]
                };
                // Consistent symbol and symbolSize if not specified.
                if (visuals.symbol == null) visuals.symbol = symbolExists && $1b239fc9d3a2f8ae$export$9cd59f9826255e47(symbolExists) || (isCategory ? defaultSymbol : [
                    defaultSymbol
                ]);
                if (visuals.symbolSize == null) visuals.symbolSize = symbolSizeExists && $1b239fc9d3a2f8ae$export$9cd59f9826255e47(symbolSizeExists) || (isCategory ? itemSize[0] : [
                    itemSize[0],
                    itemSize[0]
                ]);
                // Filter none
                visuals.symbol = $8f160b3855b6aca1$var$mapVisual(visuals.symbol, function(symbol) {
                    return symbol === 'none' ? defaultSymbol : symbol;
                });
                // Normalize symbolSize
                var symbolSize = visuals.symbolSize;
                if (symbolSize != null) {
                    var max_1 = -Infinity;
                    // symbolSize can be object when categories defined.
                    $8f160b3855b6aca1$var$eachVisual(symbolSize, function(value) {
                        value > max_1 && (max_1 = value);
                    });
                    visuals.symbolSize = $8f160b3855b6aca1$var$mapVisual(symbolSize, function(value) {
                        return $8f160b3855b6aca1$var$linearMap(value, [
                            0,
                            max_1
                        ], [
                            0,
                            itemSize[0]
                        ], true);
                    });
                }
            }, this);
        }
    };
    VisualMapModel.prototype.resetItemSize = function() {
        this.itemSize = [
            parseFloat(this.get('itemWidth')),
            parseFloat(this.get('itemHeight'))
        ];
    };
    VisualMapModel.prototype.isCategory = function() {
        return !!this.option.categories;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.setSelected = function(selected) {};
    VisualMapModel.prototype.getSelected = function() {
        return null;
    };
    /**
   * @public
   * @abstract
   */ VisualMapModel.prototype.getValueState = function(value) {
        return null;
    };
    /**
   * FIXME
   * Do not publish to thirt-part-dev temporarily
   * util the interface is stable. (Should it return
   * a function but not visual meta?)
   *
   * @pubilc
   * @abstract
   * @param getColorVisual
   *        params: value, valueState
   *        return: color
   * @return {Object} visualMeta
   *        should includes {stops, outerColors}
   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
   */ VisualMapModel.prototype.getVisualMeta = function(getColorVisual) {
        return null;
    };
    VisualMapModel.type = 'visualMap';
    VisualMapModel.dependencies = [
        'series'
    ];
    VisualMapModel.defaultOption = {
        show: true,
        // zlevel: 0,
        z: 4,
        seriesIndex: 'all',
        min: 0,
        max: 200,
        left: 0,
        right: null,
        top: null,
        bottom: 0,
        itemWidth: null,
        itemHeight: null,
        inverse: false,
        orient: 'vertical',
        backgroundColor: 'rgba(0,0,0,0)',
        borderColor: '#ccc',
        contentColor: '#5793f3',
        inactiveColor: '#aaa',
        borderWidth: 0,
        padding: 5,
        // 接受数组分别设定上右下左边距，同css
        textGap: 10,
        precision: 0,
        textStyle: {
            color: '#333' // 值域文字颜色
        }
    };
    return VisualMapModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $8f160b3855b6aca1$export$2e2bcd8739ae039 = $8f160b3855b6aca1$var$VisualMapModel;




// Constant
var $7cd6f782a9fd6433$var$DEFAULT_BAR_BOUND = [
    20,
    140
];
var $7cd6f782a9fd6433$var$ContinuousModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ContinuousModel, _super);
    function ContinuousModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousModel.type;
        return _this;
    }
    /**
   * @override
   */ ContinuousModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        this.resetVisual(function(mappingOption) {
            mappingOption.mappingMethod = 'linear';
            mappingOption.dataExtent = this.getExtent();
        });
        this._resetRange();
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.resetItemSize = function() {
        _super.prototype.resetItemSize.apply(this, arguments);
        var itemSize = this.itemSize;
        (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = $7cd6f782a9fd6433$var$DEFAULT_BAR_BOUND[0]);
        (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = $7cd6f782a9fd6433$var$DEFAULT_BAR_BOUND[1]);
    };
    /**
   * @private
   */ ContinuousModel.prototype._resetRange = function() {
        var dataExtent = this.getExtent();
        var range = this.option.range;
        if (!range || range.auto) {
            // `range` should always be array (so we don't use other
            // value like 'auto') for user-friend. (consider getOption).
            dataExtent.auto = 1;
            this.option.range = dataExtent;
        } else if ($1b239fc9d3a2f8ae$export$43bee75e5e14138e(range)) {
            if (range[0] > range[1]) range.reverse();
            range[0] = Math.max(range[0], dataExtent[0]);
            range[1] = Math.min(range[1], dataExtent[1]);
        }
    };
    /**
   * @protected
   * @override
   */ ContinuousModel.prototype.completeVisualOption = function() {
        _super.prototype.completeVisualOption.apply(this, arguments);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this.stateList, function(state) {
            var symbolSize = this.option.controller[state].symbolSize;
            if (symbolSize && symbolSize[0] !== symbolSize[1]) symbolSize[0] = symbolSize[1] / 3; // For good looking.
        }, this);
    };
    /**
   * @override
   */ ContinuousModel.prototype.setSelected = function(selected) {
        this.option.range = selected.slice();
        this._resetRange();
    };
    /**
   * @public
   */ ContinuousModel.prototype.getSelected = function() {
        var dataExtent = this.getExtent();
        var dataInterval = $9fd90cf3bf18fbcd$export$debe6e778e0a6d32((this.get('range') || []).slice());
        // Clamp
        dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
        dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
        dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
        dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
        return dataInterval;
    };
    /**
   * @override
   */ ContinuousModel.prototype.getValueState = function(value) {
        var range = this.option.range;
        var dataExtent = this.getExtent();
        // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
        // range[1] is processed likewise.
        return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
    };
    ContinuousModel.prototype.findTargetDataIndices = function(range) {
        var result = [];
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @implement
   */ ContinuousModel.prototype.getVisualMeta = function(getColorVisual) {
        var oVals = $7cd6f782a9fd6433$var$getColorStopValues(this, 'outOfRange', this.getExtent());
        var iVals = $7cd6f782a9fd6433$var$getColorStopValues(this, 'inRange', this.option.range.slice());
        var stops = [];
        function setStop(value, valueState) {
            stops.push({
                value: value,
                color: getColorVisual(value, valueState)
            });
        }
        // Format to: outOfRange -- inRange -- outOfRange.
        var iIdx = 0;
        var oIdx = 0;
        var iLen = iVals.length;
        var oLen = oVals.length;
        for(; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++)// If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
        if (oVals[oIdx] < iVals[iIdx]) setStop(oVals[oIdx], 'outOfRange');
        for(var first = 1; iIdx < iLen; iIdx++, first = 0){
            // If range is full, value beyond min, max will be clamped.
            // make a singularity
            first && stops.length && setStop(iVals[iIdx], 'outOfRange');
            setStop(iVals[iIdx], 'inRange');
        }
        for(var first = 1; oIdx < oLen; oIdx++)if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
            // make a singularity
            if (first) {
                stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
                first = 0;
            }
            setStop(oVals[oIdx], 'outOfRange');
        }
        var stopsLen = stops.length;
        return {
            stops: stops,
            outerColors: [
                stopsLen ? stops[0].color : 'transparent',
                stopsLen ? stops[stopsLen - 1].color : 'transparent'
            ]
        };
    };
    ContinuousModel.type = 'visualMap.continuous';
    ContinuousModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $8f160b3855b6aca1$export$2e2bcd8739ae039).defaultOption, {
        align: 'auto',
        calculable: false,
        hoverLink: true,
        realtime: true,
        handleIcon: 'path://M-11.39,9.77h0a3.5,3.5,0,0,1-3.5,3.5h-22a3.5,3.5,0,0,1-3.5-3.5h0a3.5,3.5,0,0,1,3.5-3.5h22A3.5,3.5,0,0,1-11.39,9.77Z',
        handleSize: '120%',
        handleStyle: {
            borderColor: '#fff',
            borderWidth: 1
        },
        indicatorIcon: 'circle',
        indicatorSize: '50%',
        indicatorStyle: {
            borderColor: '#fff',
            borderWidth: 2,
            shadowBlur: 2,
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowColor: 'rgba(0,0,0,0.2)'
        }
    });
    return ContinuousModel;
}((0, $8f160b3855b6aca1$export$2e2bcd8739ae039));
function $7cd6f782a9fd6433$var$getColorStopValues(visualMapModel, valueState, dataExtent) {
    if (dataExtent[0] === dataExtent[1]) return dataExtent.slice();
    // When using colorHue mapping, it is not linear color any more.
    // Moreover, canvas gradient seems not to be accurate linear.
    // FIXME
    // Should be arbitrary value 100? or based on pixel size?
    var count = 200;
    var step = (dataExtent[1] - dataExtent[0]) / count;
    var value = dataExtent[0];
    var stopValues = [];
    for(var i = 0; i <= count && value < dataExtent[1]; i++){
        stopValues.push(value);
        value += step;
    }
    stopValues.push(dataExtent[1]);
    return stopValues;
}
var $7cd6f782a9fd6433$export$2e2bcd8739ae039 = $7cd6f782a9fd6433$var$ContinuousModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $6e864d1ede82eca7$var$VisualMapView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(VisualMapView, _super);
    function VisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = VisualMapView.type;
        _this.autoPositionValues = {
            left: 1,
            right: 1,
            top: 1,
            bottom: 1
        };
        return _this;
    }
    VisualMapView.prototype.init = function(ecModel, api) {
        this.ecModel = ecModel;
        this.api = api;
    };
    /**
   * @protected
   */ VisualMapView.prototype.render = function(visualMapModel, ecModel, api, payload // TODO: TYPE
    ) {
        this.visualMapModel = visualMapModel;
        if (visualMapModel.get('show') === false) {
            this.group.removeAll();
            return;
        }
        this.doRender(visualMapModel, ecModel, api, payload);
    };
    /**
   * @protected
   */ VisualMapView.prototype.renderBackground = function(group) {
        var visualMapModel = this.visualMapModel;
        var padding = $ff2fba995230f3c9$export$f3a38102c49f4268(visualMapModel.get('padding') || 0);
        var rect = group.getBoundingRect();
        group.add(new (0, $37476269d425e3f6$export$2e2bcd8739ae039)({
            z2: -1,
            silent: true,
            shape: {
                x: rect.x - padding[3],
                y: rect.y - padding[0],
                width: rect.width + padding[3] + padding[1],
                height: rect.height + padding[0] + padding[2]
            },
            style: {
                fill: visualMapModel.get('backgroundColor'),
                stroke: visualMapModel.get('borderColor'),
                lineWidth: visualMapModel.get('borderWidth')
            }
        }));
    };
    /**
   * @protected
   * @param targetValue can be Infinity or -Infinity
   * @param visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
   * @param opts
   * @param opts.forceState Specify state, instead of using getValueState method.
   * @param opts.convertOpacityToAlpha For color gradient in controller widget.
   * @return {*} Visual value.
   */ VisualMapView.prototype.getControllerVisual = function(targetValue, visualCluster, opts) {
        opts = opts || {};
        var forceState = opts.forceState;
        var visualMapModel = this.visualMapModel;
        var visualObj = {};
        // Default values.
        if (visualCluster === 'color') {
            var defaultColor = visualMapModel.get('contentColor');
            visualObj.color = defaultColor;
        }
        function getter(key) {
            return visualObj[key];
        }
        function setter(key, value) {
            visualObj[key] = value;
        }
        var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
        var visualTypes = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(visualTypes, function(type) {
            var visualMapping = mappings[type];
            if (opts.convertOpacityToAlpha && type === 'opacity') {
                type = 'colorAlpha';
                visualMapping = mappings.__alphaForOpacity;
            }
            if ((0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).dependsOn(type, visualCluster)) visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
        });
        return visualObj[visualCluster];
    };
    VisualMapView.prototype.positionGroup = function(group) {
        var model = this.visualMapModel;
        var api = this.api;
        $501dc28f6c4d24ac$export$74054bd96b5eeef1(group, model.getBoxLayoutParams(), {
            width: api.getWidth(),
            height: api.getHeight()
        });
    };
    VisualMapView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {};
    VisualMapView.type = 'visualMap';
    return VisualMapView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
var $6e864d1ede82eca7$export$2e2bcd8739ae039 = $6e864d1ede82eca7$var$VisualMapView;





/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 

var $8bd2de6be4ac6291$var$paramsSet = [
    [
        'left',
        'right',
        'width'
    ],
    [
        'top',
        'bottom',
        'height'
    ]
];
function $8bd2de6be4ac6291$export$dca53c4702e35c6(visualMapModel, api, itemSize) {
    var modelOption = visualMapModel.option;
    var itemAlign = modelOption.align;
    if (itemAlign != null && itemAlign !== 'auto') return itemAlign;
    // Auto decision align.
    var ecSize = {
        width: api.getWidth(),
        height: api.getHeight()
    };
    var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
    var reals = $8bd2de6be4ac6291$var$paramsSet[realIndex];
    var fakeValue = [
        0,
        null,
        10
    ];
    var layoutInput = {};
    for(var i = 0; i < 3; i++){
        layoutInput[$8bd2de6be4ac6291$var$paramsSet[1 - realIndex][i]] = fakeValue[i];
        layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
    }
    var rParam = [
        [
            'x',
            'width',
            3
        ],
        [
            'y',
            'height',
            0
        ]
    ][realIndex];
    var rect = (0, $501dc28f6c4d24ac$export$4517a5ca639a7293)(layoutInput, ecSize, modelOption.padding);
    return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
}
function $8bd2de6be4ac6291$export$5381a9dc5427ba18(batch, visualMapModel) {
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43(batch || [], function(batchItem) {
        if (batchItem.dataIndex != null) {
            batchItem.dataIndexInside = batchItem.dataIndex;
            batchItem.dataIndex = null;
        }
        batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
    });
    return batch;
}










var $87bda2503e5f50e7$var$linearMap = $9fd90cf3bf18fbcd$export$d3f68fbaa670562;
var $87bda2503e5f50e7$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
var $87bda2503e5f50e7$var$mathMin = Math.min;
var $87bda2503e5f50e7$var$mathMax = Math.max;
// Arbitrary value
var $87bda2503e5f50e7$var$HOVER_LINK_SIZE = 12;
var $87bda2503e5f50e7$var$HOVER_LINK_OUT = 6;
// Notice:
// Any "interval" should be by the order of [low, high].
// "handle0" (handleIndex === 0) maps to
// low data value: this._dataInterval[0] and has low coord.
// "handle1" (handleIndex === 1) maps to
// high data value: this._dataInterval[1] and has high coord.
// The logic of transform is implemented in this._createBarGroup.
var $87bda2503e5f50e7$var$ContinuousView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(ContinuousView, _super);
    function ContinuousView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = ContinuousView.type;
        _this._shapes = {};
        _this._dataInterval = [];
        _this._handleEnds = [];
        _this._hoverLinkDataIndices = [];
        return _this;
    }
    ContinuousView.prototype.init = function(ecModel, api) {
        _super.prototype.init.call(this, ecModel, api);
        this._hoverLinkFromSeriesMouseOver = $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._hoverLinkFromSeriesMouseOver, this);
        this._hideIndicator = $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._hideIndicator, this);
    };
    ContinuousView.prototype.doRender = function(visualMapModel, ecModel, api, payload) {
        if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) this._buildView();
    };
    ContinuousView.prototype._buildView = function() {
        this.group.removeAll();
        var visualMapModel = this.visualMapModel;
        var thisGroup = this.group;
        this._orient = visualMapModel.get('orient');
        this._useHandle = visualMapModel.get('calculable');
        this._resetInterval();
        this._renderBar(thisGroup);
        var dataRangeText = visualMapModel.get('text');
        this._renderEndsText(thisGroup, dataRangeText, 0);
        this._renderEndsText(thisGroup, dataRangeText, 1);
        // Do this for background size calculation.
        this._updateView(true);
        // After updating view, inner shapes is built completely,
        // and then background can be rendered.
        this.renderBackground(thisGroup);
        // Real update view
        this._updateView();
        this._enableHoverLinkToSeries();
        this._enableHoverLinkFromSeries();
        this.positionGroup(thisGroup);
    };
    ContinuousView.prototype._renderEndsText = function(group, dataRangeText, endsIndex) {
        if (!dataRangeText) return;
        // Compatible with ec2, text[0] map to high value, text[1] map low value.
        var text = dataRangeText[1 - endsIndex];
        text = text != null ? text + '' : '';
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get('textGap');
        var itemSize = visualMapModel.itemSize;
        var barGroup = this._shapes.mainGroup;
        var position = this._applyTransform([
            itemSize[0] / 2,
            endsIndex === 0 ? -textGap : itemSize[1] + textGap
        ], barGroup);
        var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
        var orient = this._orient;
        var textStyleModel = this.visualMapModel.textStyleModel;
        this.group.add(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                x: position[0],
                y: position[1],
                verticalAlign: orient === 'horizontal' ? 'middle' : align,
                align: orient === 'horizontal' ? align : 'center',
                text: text
            })
        }));
    };
    ContinuousView.prototype._renderBar = function(targetGroup) {
        var visualMapModel = this.visualMapModel;
        var shapes = this._shapes;
        var itemSize = visualMapModel.itemSize;
        var orient = this._orient;
        var useHandle = this._useHandle;
        var itemAlign = $8bd2de6be4ac6291$export$dca53c4702e35c6(visualMapModel, this.api, itemSize);
        var mainGroup = shapes.mainGroup = this._createBarGroup(itemAlign);
        var gradientBarGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        mainGroup.add(gradientBarGroup);
        // Bar
        gradientBarGroup.add(shapes.outOfRange = $87bda2503e5f50e7$var$createPolygon());
        gradientBarGroup.add(shapes.inRange = $87bda2503e5f50e7$var$createPolygon(null, useHandle ? $87bda2503e5f50e7$var$getCursor(this._orient) : null, $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._dragHandle, this, 'all', false), $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._dragHandle, this, 'all', true)));
        // A border radius clip.
        gradientBarGroup.setClipPath(new $37476269d425e3f6$export$2e2bcd8739ae039({
            shape: {
                x: 0,
                y: 0,
                width: itemSize[0],
                height: itemSize[1],
                r: 3
            }
        }));
        var textRect = visualMapModel.textStyleModel.getTextRect("\u56FD");
        var textSize = $87bda2503e5f50e7$var$mathMax(textRect.width, textRect.height);
        // Handle
        if (useHandle) {
            shapes.handleThumbs = [];
            shapes.handleLabels = [];
            shapes.handleLabelPoints = [];
            this._createHandle(visualMapModel, mainGroup, 0, itemSize, textSize, orient);
            this._createHandle(visualMapModel, mainGroup, 1, itemSize, textSize, orient);
        }
        this._createIndicator(visualMapModel, mainGroup, itemSize, textSize, orient);
        targetGroup.add(mainGroup);
    };
    ContinuousView.prototype._createHandle = function(visualMapModel, mainGroup, handleIndex, itemSize, textSize, orient) {
        var onDrift = $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._dragHandle, this, handleIndex, false);
        var onDragEnd = $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._dragHandle, this, handleIndex, true);
        var handleSize = (0, $297531217517fbce$export$e8514cb5a5e2b40f)(visualMapModel.get('handleSize'), itemSize[0]);
        var handleThumb = (0, $da6220012439db7b$export$af050e04da3a02e8)(visualMapModel.get('handleIcon'), -handleSize / 2, -handleSize / 2, handleSize, handleSize, null, true);
        var cursor = $87bda2503e5f50e7$var$getCursor(this._orient);
        handleThumb.attr({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            ondragend: onDragEnd,
            onmousemove: function(e) {
                $8f7ba7c16ab1583e$export$fa6813432f753b0d(e.event);
            }
        });
        handleThumb.x = itemSize[0] / 2;
        handleThumb.useStyle(visualMapModel.getModel('handleStyle').getItemStyle());
        handleThumb.setStyle({
            strokeNoScale: true,
            strokeFirst: true
        });
        handleThumb.style.lineWidth *= 2;
        handleThumb.ensureState('emphasis').style = visualMapModel.getModel([
            'emphasis',
            'handleStyle'
        ]).getItemStyle();
        (0, $b414df7d361a211c$export$9ba15aea1e048d48)(handleThumb, true);
        mainGroup.add(handleThumb);
        // Text is always horizontal layout but should not be effected by
        // transform (orient/inverse). So label is built separately but not
        // use zrender/graphic/helper/RectText, and is located based on view
        // group (according to handleLabelPoint) but not barGroup.
        var textStyleModel = this.visualMapModel.textStyleModel;
        var handleLabel = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            cursor: cursor,
            draggable: true,
            drift: onDrift,
            onmousemove: function(e) {
                // For mobile device, prevent screen slider on the button.
                $8f7ba7c16ab1583e$export$fa6813432f753b0d(e.event);
            },
            ondragend: onDragEnd,
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ''
            })
        });
        handleLabel.ensureState('blur').style = {
            opacity: 0.1
        };
        handleLabel.stateTransition = {
            duration: 200
        };
        this.group.add(handleLabel);
        var handleLabelPoint = [
            handleSize,
            0
        ];
        var shapes = this._shapes;
        shapes.handleThumbs[handleIndex] = handleThumb;
        shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
        shapes.handleLabels[handleIndex] = handleLabel;
    };
    ContinuousView.prototype._createIndicator = function(visualMapModel, mainGroup, itemSize, textSize, orient) {
        var scale = (0, $297531217517fbce$export$e8514cb5a5e2b40f)(visualMapModel.get('indicatorSize'), itemSize[0]);
        var indicator = (0, $da6220012439db7b$export$af050e04da3a02e8)(visualMapModel.get('indicatorIcon'), -scale / 2, -scale / 2, scale, scale, null, true);
        indicator.attr({
            cursor: 'move',
            invisible: true,
            silent: true,
            x: itemSize[0] / 2
        });
        var indicatorStyle = visualMapModel.getModel('indicatorStyle').getItemStyle();
        if (indicator instanceof (0, $29f98103052059af$export$2e2bcd8739ae039)) {
            var pathStyle = indicator.style;
            indicator.useStyle($1b239fc9d3a2f8ae$export$8b58be045bf06082({
                // TODO other properties like x, y ?
                image: pathStyle.image,
                x: pathStyle.x,
                y: pathStyle.y,
                width: pathStyle.width,
                height: pathStyle.height
            }, indicatorStyle));
        } else indicator.useStyle(indicatorStyle);
        mainGroup.add(indicator);
        var textStyleModel = this.visualMapModel.textStyleModel;
        var indicatorLabel = new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            silent: true,
            invisible: true,
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                x: 0,
                y: 0,
                text: ''
            })
        });
        this.group.add(indicatorLabel);
        var indicatorLabelPoint = [
            (orient === 'horizontal' ? textSize / 2 : $87bda2503e5f50e7$var$HOVER_LINK_OUT) + itemSize[0] / 2,
            0
        ];
        var shapes = this._shapes;
        shapes.indicator = indicator;
        shapes.indicatorLabel = indicatorLabel;
        shapes.indicatorLabelPoint = indicatorLabelPoint;
        this._firstShowIndicator = true;
    };
    ContinuousView.prototype._dragHandle = function(handleIndex, isEnd, // dx is event from ondragend if isEnd is true. It's not used
    dx, dy) {
        if (!this._useHandle) return;
        this._dragging = !isEnd;
        if (!isEnd) {
            // Transform dx, dy to bar coordination.
            var vertex = this._applyTransform([
                dx,
                dy
            ], this._shapes.mainGroup, true);
            this._updateInterval(handleIndex, vertex[1]);
            this._hideIndicator();
            // Considering realtime, update view should be executed
            // before dispatch action.
            this._updateView();
        }
        // dragEnd do not dispatch action when realtime.
        if (isEnd === !this.visualMapModel.get('realtime')) // jshint ignore:line
        this.api.dispatchAction({
            type: 'selectDataRange',
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: this._dataInterval.slice()
        });
        if (isEnd) !this._hovering && this._clearHoverLinkToSeries();
        else if ($87bda2503e5f50e7$var$useHoverLinkOnHandle(this.visualMapModel)) this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
    };
    ContinuousView.prototype._resetInterval = function() {
        var visualMapModel = this.visualMapModel;
        var dataInterval = this._dataInterval = visualMapModel.getSelected();
        var dataExtent = visualMapModel.getExtent();
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        this._handleEnds = [
            $87bda2503e5f50e7$var$linearMap(dataInterval[0], dataExtent, sizeExtent, true),
            $87bda2503e5f50e7$var$linearMap(dataInterval[1], dataExtent, sizeExtent, true)
        ];
    };
    /**
   * @private
   * @param {(number|string)} handleIndex 0 or 1 or 'all'
   * @param {number} dx
   * @param {number} dy
   */ ContinuousView.prototype._updateInterval = function(handleIndex, delta) {
        delta = delta || 0;
        var visualMapModel = this.visualMapModel;
        var handleEnds = this._handleEnds;
        var sizeExtent = [
            0,
            visualMapModel.itemSize[1]
        ];
        (0, $15a7158def1e4179$export$2e2bcd8739ae039)(delta, handleEnds, sizeExtent, handleIndex, // cross is forbidden
        0);
        var dataExtent = visualMapModel.getExtent();
        // Update data interval.
        this._dataInterval = [
            $87bda2503e5f50e7$var$linearMap(handleEnds[0], sizeExtent, dataExtent, true),
            $87bda2503e5f50e7$var$linearMap(handleEnds[1], sizeExtent, dataExtent, true)
        ];
    };
    ContinuousView.prototype._updateView = function(forSketch) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var shapes = this._shapes;
        var outOfRangeHandleEnds = [
            0,
            visualMapModel.itemSize[1]
        ];
        var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
        var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
        var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
        shapes.inRange.setStyle({
            fill: visualInRange.barColor
        }).setShape('points', visualInRange.barPoints);
        shapes.outOfRange.setStyle({
            fill: visualOutOfRange.barColor
        }).setShape('points', visualOutOfRange.barPoints);
        this._updateHandle(inRangeHandleEnds, visualInRange);
    };
    ContinuousView.prototype._createBarVisual = function(dataInterval, dataExtent, handleEnds, forceState) {
        var opts = {
            forceState: forceState,
            convertOpacityToAlpha: true
        };
        var colorStops = this._makeColorGradient(dataInterval, opts);
        var symbolSizes = [
            this.getControllerVisual(dataInterval[0], 'symbolSize', opts),
            this.getControllerVisual(dataInterval[1], 'symbolSize', opts)
        ];
        var barPoints = this._createBarPoints(handleEnds, symbolSizes);
        return {
            barColor: new (0, $e082211bdfcbd68a$export$2e2bcd8739ae039)(0, 0, 0, 1, colorStops),
            barPoints: barPoints,
            handlesColor: [
                colorStops[0].color,
                colorStops[colorStops.length - 1].color
            ]
        };
    };
    ContinuousView.prototype._makeColorGradient = function(dataInterval, opts) {
        // Considering colorHue, which is not linear, so we have to sample
        // to calculate gradient color stops, but not only calculate head
        // and tail.
        var sampleNumber = 100; // Arbitrary value.
        var colorStops = [];
        var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
        colorStops.push({
            color: this.getControllerVisual(dataInterval[0], 'color', opts),
            offset: 0
        });
        for(var i = 1; i < sampleNumber; i++){
            var currValue = dataInterval[0] + step * i;
            if (currValue > dataInterval[1]) break;
            colorStops.push({
                color: this.getControllerVisual(currValue, 'color', opts),
                offset: i / sampleNumber
            });
        }
        colorStops.push({
            color: this.getControllerVisual(dataInterval[1], 'color', opts),
            offset: 1
        });
        return colorStops;
    };
    ContinuousView.prototype._createBarPoints = function(handleEnds, symbolSizes) {
        var itemSize = this.visualMapModel.itemSize;
        return [
            [
                itemSize[0] - symbolSizes[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[0]
            ],
            [
                itemSize[0],
                handleEnds[1]
            ],
            [
                itemSize[0] - symbolSizes[1],
                handleEnds[1]
            ]
        ];
    };
    ContinuousView.prototype._createBarGroup = function(itemAlign) {
        var orient = this._orient;
        var inverse = this.visualMapModel.get('inverse');
        return new $6c313c3ef6000a43$export$2e2bcd8739ae039(orient === 'horizontal' && !inverse ? {
            scaleX: itemAlign === 'bottom' ? 1 : -1,
            rotation: Math.PI / 2
        } : orient === 'horizontal' && inverse ? {
            scaleX: itemAlign === 'bottom' ? -1 : 1,
            rotation: -Math.PI / 2
        } : orient === 'vertical' && !inverse ? {
            scaleX: itemAlign === 'left' ? 1 : -1,
            scaleY: -1
        } : {
            scaleX: itemAlign === 'left' ? 1 : -1
        });
    };
    ContinuousView.prototype._updateHandle = function(handleEnds, visualInRange) {
        if (!this._useHandle) return;
        var shapes = this._shapes;
        var visualMapModel = this.visualMapModel;
        var handleThumbs = shapes.handleThumbs;
        var handleLabels = shapes.handleLabels;
        var itemSize = visualMapModel.itemSize;
        var dataExtent = visualMapModel.getExtent();
        var align = this._applyTransform('left', shapes.mainGroup);
        $87bda2503e5f50e7$var$each([
            0,
            1
        ], function(handleIndex) {
            var handleThumb = handleThumbs[handleIndex];
            handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
            handleThumb.y = handleEnds[handleIndex];
            var val = $87bda2503e5f50e7$var$linearMap(handleEnds[handleIndex], [
                0,
                itemSize[1]
            ], dataExtent, true);
            var symbolSize = this.getControllerVisual(val, 'symbolSize');
            handleThumb.scaleX = handleThumb.scaleY = symbolSize / itemSize[0];
            handleThumb.x = itemSize[0] - symbolSize / 2;
            // Update handle label position.
            var textPoint = $8eb95236e1aa01e7$export$9f9dcb98c894b623(shapes.handleLabelPoints[handleIndex], $8eb95236e1aa01e7$export$fce0c6cfca85ed96(handleThumb, this.group));
            if (this._orient === 'horizontal') {
                // If visualMap controls symbol size, an additional offset needs to be added to labels to avoid collision at minimum size.
                // Offset reaches value of 0 at "maximum" position, so maximum position is not altered at all.
                var minimumOffset = align === 'left' || align === 'top' ? (itemSize[0] - symbolSize) / 2 : (itemSize[0] - symbolSize) / -2;
                textPoint[1] += minimumOffset;
            }
            handleLabels[handleIndex].setStyle({
                x: textPoint[0],
                y: textPoint[1],
                text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
                verticalAlign: 'middle',
                align: this._orient === 'vertical' ? this._applyTransform('left', shapes.mainGroup) : 'center'
            });
        }, this);
    };
    ContinuousView.prototype._showIndicator = function(cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
        var visualMapModel = this.visualMapModel;
        var dataExtent = visualMapModel.getExtent();
        var itemSize = visualMapModel.itemSize;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var shapes = this._shapes;
        var indicator = shapes.indicator;
        if (!indicator) return;
        indicator.attr('invisible', false);
        var opts = {
            convertOpacityToAlpha: true
        };
        var color = this.getControllerVisual(cursorValue, 'color', opts);
        var symbolSize = this.getControllerVisual(cursorValue, 'symbolSize');
        var y = $87bda2503e5f50e7$var$linearMap(cursorValue, dataExtent, sizeExtent, true);
        var x = itemSize[0] - symbolSize / 2;
        var oldIndicatorPos = {
            x: indicator.x,
            y: indicator.y
        };
        // Update handle label position.
        indicator.y = y;
        indicator.x = x;
        var textPoint = $8eb95236e1aa01e7$export$9f9dcb98c894b623(shapes.indicatorLabelPoint, $8eb95236e1aa01e7$export$fce0c6cfca85ed96(indicator, this.group));
        var indicatorLabel = shapes.indicatorLabel;
        indicatorLabel.attr('invisible', false);
        var align = this._applyTransform('left', shapes.mainGroup);
        var orient = this._orient;
        var isHorizontal = orient === 'horizontal';
        indicatorLabel.setStyle({
            text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
            verticalAlign: isHorizontal ? align : 'middle',
            align: isHorizontal ? 'center' : align
        });
        var indicatorNewProps = {
            x: x,
            y: y,
            style: {
                fill: color
            }
        };
        var labelNewProps = {
            style: {
                x: textPoint[0],
                y: textPoint[1]
            }
        };
        if (visualMapModel.ecModel.isAnimationEnabled() && !this._firstShowIndicator) {
            var animationCfg = {
                duration: 100,
                easing: 'cubicInOut',
                additive: true
            };
            indicator.x = oldIndicatorPos.x;
            indicator.y = oldIndicatorPos.y;
            indicator.animateTo(indicatorNewProps, animationCfg);
            indicatorLabel.animateTo(labelNewProps, animationCfg);
        } else {
            indicator.attr(indicatorNewProps);
            indicatorLabel.attr(labelNewProps);
        }
        this._firstShowIndicator = false;
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.enterBlur(handleLabels[i]);
    };
    ContinuousView.prototype._enableHoverLinkToSeries = function() {
        var self = this;
        this._shapes.mainGroup.on('mousemove', function(e) {
            self._hovering = true;
            if (!self._dragging) {
                var itemSize = self.visualMapModel.itemSize;
                var pos = self._applyTransform([
                    e.offsetX,
                    e.offsetY
                ], self._shapes.mainGroup, true, true);
                // For hover link show when hover handle, which might be
                // below or upper than sizeExtent.
                pos[1] = $87bda2503e5f50e7$var$mathMin($87bda2503e5f50e7$var$mathMax(0, pos[1]), itemSize[1]);
                self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
            }
        }).on('mouseout', function() {
            // When mouse is out of handle, hoverLink still need
            // to be displayed when realtime is set as false.
            self._hovering = false;
            !self._dragging && self._clearHoverLinkToSeries();
        });
    };
    ContinuousView.prototype._enableHoverLinkFromSeries = function() {
        var zr = this.api.getZr();
        if (this.visualMapModel.option.hoverLink) {
            zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
            zr.on('mouseout', this._hideIndicator, this);
        } else this._clearHoverLinkFromSeries();
    };
    ContinuousView.prototype._doHoverLinkToSeries = function(cursorPos, hoverOnBar) {
        var visualMapModel = this.visualMapModel;
        var itemSize = visualMapModel.itemSize;
        if (!visualMapModel.option.hoverLink) return;
        var sizeExtent = [
            0,
            itemSize[1]
        ];
        var dataExtent = visualMapModel.getExtent();
        // For hover link show when hover handle, which might be below or upper than sizeExtent.
        cursorPos = $87bda2503e5f50e7$var$mathMin($87bda2503e5f50e7$var$mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
        var halfHoverLinkSize = $87bda2503e5f50e7$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
        var hoverRange = [
            cursorPos - halfHoverLinkSize,
            cursorPos + halfHoverLinkSize
        ];
        var cursorValue = $87bda2503e5f50e7$var$linearMap(cursorPos, sizeExtent, dataExtent, true);
        var valueRange = [
            $87bda2503e5f50e7$var$linearMap(hoverRange[0], sizeExtent, dataExtent, true),
            $87bda2503e5f50e7$var$linearMap(hoverRange[1], sizeExtent, dataExtent, true)
        ];
        // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
        // where china and india has very large population.
        hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
        hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity);
        // Do not show indicator when mouse is over handle,
        // otherwise labels overlap, especially when dragging.
        if (hoverOnBar) {
            if (valueRange[0] === -Infinity) this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
            else if (valueRange[1] === Infinity) this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
            else this._showIndicator(cursorValue, cursorValue, "\u2248 ", halfHoverLinkSize);
        }
        // When realtime is set as false, handles, which are in barGroup,
        // also trigger hoverLink, which help user to realize where they
        // focus on when dragging. (see test/heatmap-large.html)
        // When realtime is set as true, highlight will not show when hover
        // handle, because the label on handle, which displays a exact value
        // but not range, might mislead users.
        var oldBatch = this._hoverLinkDataIndices;
        var newBatch = [];
        if (hoverOnBar || $87bda2503e5f50e7$var$useHoverLinkOnHandle(visualMapModel)) newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
        var resultBatches = $9ac03c46e8b6e711$export$6d12cabb0c9bf8e3(oldBatch, newBatch);
        this._dispatchHighDown('downplay', $8bd2de6be4ac6291$export$5381a9dc5427ba18(resultBatches[0], visualMapModel));
        this._dispatchHighDown('highlight', $8bd2de6be4ac6291$export$5381a9dc5427ba18(resultBatches[1], visualMapModel));
    };
    ContinuousView.prototype._hoverLinkFromSeriesMouseOver = function(e) {
        var ecData;
        (0, $ee614fdac89517fb$export$8a4fca9e04eb4df6)(e.target, function(target) {
            var currECData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(target);
            if (currECData.dataIndex != null) {
                ecData = currECData;
                return true;
            }
        }, true);
        if (!ecData) return;
        var dataModel = this.ecModel.getSeriesByIndex(ecData.seriesIndex);
        var visualMapModel = this.visualMapModel;
        if (!visualMapModel.isTargetSeries(dataModel)) return;
        var data = dataModel.getData(ecData.dataType);
        var value = data.getStore().get(visualMapModel.getDataDimensionIndex(data), ecData.dataIndex);
        if (!isNaN(value)) this._showIndicator(value, value);
    };
    ContinuousView.prototype._hideIndicator = function() {
        var shapes = this._shapes;
        shapes.indicator && shapes.indicator.attr('invisible', true);
        shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
        var handleLabels = this._shapes.handleLabels;
        if (handleLabels) for(var i = 0; i < handleLabels.length; i++)// Fade out handle labels.
        // NOTE: Must use api enter/leave on emphasis/blur/select state. Or the global states manager will change it.
        this.api.leaveBlur(handleLabels[i]);
    };
    ContinuousView.prototype._clearHoverLinkToSeries = function() {
        this._hideIndicator();
        var indices = this._hoverLinkDataIndices;
        this._dispatchHighDown('downplay', $8bd2de6be4ac6291$export$5381a9dc5427ba18(indices, this.visualMapModel));
        indices.length = 0;
    };
    ContinuousView.prototype._clearHoverLinkFromSeries = function() {
        this._hideIndicator();
        var zr = this.api.getZr();
        zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
        zr.off('mouseout', this._hideIndicator);
    };
    ContinuousView.prototype._applyTransform = function(vertex, element, inverse, global) {
        var transform = $8eb95236e1aa01e7$export$fce0c6cfca85ed96(element, global ? null : this.group);
        return $1b239fc9d3a2f8ae$export$43bee75e5e14138e(vertex) ? $8eb95236e1aa01e7$export$9f9dcb98c894b623(vertex, transform, inverse) : $8eb95236e1aa01e7$export$fff94e9792354cfa(vertex, transform, inverse);
    };
    // TODO: TYPE more specified payload types.
    ContinuousView.prototype._dispatchHighDown = function(type, batch) {
        batch && batch.length && this.api.dispatchAction({
            type: type,
            batch: batch
        });
    };
    /**
   * @override
   */ ContinuousView.prototype.dispose = function() {
        this._clearHoverLinkFromSeries();
        this._clearHoverLinkToSeries();
    };
    ContinuousView.type = 'visualMap.continuous';
    return ContinuousView;
}((0, $6e864d1ede82eca7$export$2e2bcd8739ae039));
function $87bda2503e5f50e7$var$createPolygon(points, cursor, onDrift, onDragEnd) {
    return new $399011f87accd5da$export$2e2bcd8739ae039({
        shape: {
            points: points
        },
        draggable: !!onDrift,
        cursor: cursor,
        drift: onDrift,
        onmousemove: function(e) {
            // For mobile device, prevent screen slider on the button.
            $8f7ba7c16ab1583e$export$fa6813432f753b0d(e.event);
        },
        ondragend: onDragEnd
    });
}
function $87bda2503e5f50e7$var$getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
    var halfHoverLinkSize = $87bda2503e5f50e7$var$HOVER_LINK_SIZE / 2;
    var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
    if (hoverLinkDataSize) halfHoverLinkSize = $87bda2503e5f50e7$var$linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
    return halfHoverLinkSize;
}
function $87bda2503e5f50e7$var$useHoverLinkOnHandle(visualMapModel) {
    var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
    return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
}
function $87bda2503e5f50e7$var$getCursor(orient) {
    return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
}
var $87bda2503e5f50e7$export$2e2bcd8739ae039 = $87bda2503e5f50e7$var$ContinuousView;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ var $6fffd77fd88bf0ea$export$c5097295b52f5ecd = {
    type: 'selectDataRange',
    event: 'dataRangeSelected',
    // FIXME use updateView appears wrong
    update: 'update'
};
var $6fffd77fd88bf0ea$export$8655c04a6fcbaa76 = function(payload, ecModel) {
    ecModel.eachComponent({
        mainType: 'visualMap',
        query: payload
    }, function(model) {
        model.setSelected(payload.selected);
    });
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 



var $eb278eda98c1990b$export$5933e7c74ab358d1 = [
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var resetDefines = [];
            ecModel.eachComponent('visualMap', function(visualMapModel) {
                var pipelineContext = seriesModel.pipelineContext;
                if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) return;
                resetDefines.push($8c6eb7416a8c3770$export$fc0ef8703cccf128(visualMapModel.stateList, visualMapModel.targetVisuals, $1b239fc9d3a2f8ae$export$2385a24977818dd0(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimensionIndex(seriesModel.getData())));
            });
            return resetDefines;
        }
    },
    // Only support color.
    {
        createOnAllSeries: true,
        reset: function(seriesModel, ecModel) {
            var data = seriesModel.getData();
            var visualMetaList = [];
            ecModel.eachComponent('visualMap', function(visualMapModel) {
                if (visualMapModel.isTargetSeries(seriesModel)) {
                    var visualMeta = visualMapModel.getVisualMeta($1b239fc9d3a2f8ae$export$2385a24977818dd0($eb278eda98c1990b$var$getColorVisual, null, seriesModel, visualMapModel)) || {
                        stops: [],
                        outerColors: []
                    };
                    var dimIdx = visualMapModel.getDataDimensionIndex(data);
                    if (dimIdx >= 0) {
                        // visualMeta.dimension should be dimension index, but not concrete dimension.
                        visualMeta.dimension = dimIdx;
                        visualMetaList.push(visualMeta);
                    }
                }
            });
            // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
            seriesModel.getData().setVisual('visualMeta', visualMetaList);
        }
    }
];
// FIXME
// performance and export for heatmap?
// value can be Infinity or -Infinity
function $eb278eda98c1990b$var$getColorVisual(seriesModel, visualMapModel, value, valueState) {
    var mappings = visualMapModel.targetVisuals[valueState];
    var visualTypes = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).prepareVisualTypes(mappings);
    var resultVisual = {
        color: (0, $aa7643c8305265d3$export$d76e333a86ea1a2)(seriesModel.getData(), 'color') // default color.
    };
    for(var i = 0, len = visualTypes.length; i < len; i++){
        var type = visualTypes[i];
        var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
        mapping && mapping.applyVisual(value, getVisual, setVisual);
    }
    return resultVisual.color;
    function getVisual(key) {
        return resultVisual[key];
    }
    function setVisual(key, value) {
        resultVisual[key] = value;
    }
}



/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // @ts-nocheck

var $45497e69d66b14d1$var$each = $1b239fc9d3a2f8ae$export$79b2f7037acddd43;
function $45497e69d66b14d1$export$2e2bcd8739ae039(option) {
    var visualMap = option && option.visualMap;
    if (!$1b239fc9d3a2f8ae$export$43bee75e5e14138e(visualMap)) visualMap = visualMap ? [
        visualMap
    ] : [];
    $45497e69d66b14d1$var$each(visualMap, function(opt) {
        if (!opt) return;
        // rename splitList to pieces
        if ($45497e69d66b14d1$var$has(opt, 'splitList') && !$45497e69d66b14d1$var$has(opt, 'pieces')) {
            opt.pieces = opt.splitList;
            delete opt.splitList;
        }
        var pieces = opt.pieces;
        if (pieces && $1b239fc9d3a2f8ae$export$43bee75e5e14138e(pieces)) $45497e69d66b14d1$var$each(pieces, function(piece) {
            if ($1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(piece)) {
                if ($45497e69d66b14d1$var$has(piece, 'start') && !$45497e69d66b14d1$var$has(piece, 'min')) piece.min = piece.start;
                if ($45497e69d66b14d1$var$has(piece, 'end') && !$45497e69d66b14d1$var$has(piece, 'max')) piece.max = piece.end;
            }
        });
    });
}
function $45497e69d66b14d1$var$has(obj, name) {
    return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
}


var $ac922d851d7b22f4$var$installed = false;
function $ac922d851d7b22f4$export$2e2bcd8739ae039(registers) {
    if ($ac922d851d7b22f4$var$installed) return;
    $ac922d851d7b22f4$var$installed = true;
    registers.registerSubTypeDefaulter('visualMap', function(option) {
        // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
        return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
    });
    registers.registerAction((0, $6fffd77fd88bf0ea$export$c5097295b52f5ecd), (0, $6fffd77fd88bf0ea$export$8655c04a6fcbaa76));
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $eb278eda98c1990b$export$5933e7c74ab358d1), function(handler) {
        registers.registerVisual(registers.PRIORITY.VISUAL.COMPONENT, handler);
    });
    registers.registerPreprocessor((0, $45497e69d66b14d1$export$2e2bcd8739ae039));
}


function $b1d6b437a4e7085d$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $7cd6f782a9fd6433$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $87bda2503e5f50e7$export$2e2bcd8739ae039));
    (0, $ac922d851d7b22f4$export$2e2bcd8739ae039)(registers);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 






var $ca8f8810c7b9bd15$var$PiecewiseModel = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PiecewiseModel, _super);
    function PiecewiseModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseModel.type;
        /**
     * The order is always [low, ..., high].
     * [{text: string, interval: Array.<number>}, ...]
     */ _this._pieceList = [];
        return _this;
    }
    PiecewiseModel.prototype.optionUpdated = function(newOption, isInit) {
        _super.prototype.optionUpdated.apply(this, arguments);
        this.resetExtent();
        var mode = this._mode = this._determineMode();
        this._pieceList = [];
        $ca8f8810c7b9bd15$var$resetMethods[this._mode].call(this, this._pieceList);
        this._resetSelected(newOption, isInit);
        var categories = this.option.categories;
        this.resetVisual(function(mappingOption, state) {
            if (mode === 'categories') {
                mappingOption.mappingMethod = 'category';
                mappingOption.categories = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(categories);
            } else {
                mappingOption.dataExtent = this.getExtent();
                mappingOption.mappingMethod = 'piecewise';
                mappingOption.pieceList = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(this._pieceList, function(piece) {
                    piece = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(piece);
                    if (state !== 'inRange') // FIXME
                    // outOfRange do not support special visual in pieces.
                    piece.visual = null;
                    return piece;
                });
            }
        });
    };
    /**
   * @protected
   * @override
   */ PiecewiseModel.prototype.completeVisualOption = function() {
        // Consider this case:
        // visualMap: {
        //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
        // }
        // where no inRange/outOfRange set but only pieces. So we should make
        // default inRange/outOfRange for this case, otherwise visuals that only
        // appear in `pieces` will not be taken into account in visual encoding.
        var option = this.option;
        var visualTypesInPieces = {};
        var visualTypes = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).listVisualTypes();
        var isCategory = this.isCategory();
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(option.pieces, function(piece) {
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(visualTypes, function(visualType) {
                if (piece.hasOwnProperty(visualType)) visualTypesInPieces[visualType] = 1;
            });
        });
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(visualTypesInPieces, function(v, visualType) {
            var exists = false;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this.stateList, function(state) {
                exists = exists || has(option, state, visualType) || has(option.target, state, visualType);
            }, this);
            !exists && $1b239fc9d3a2f8ae$export$79b2f7037acddd43(this.stateList, function(state) {
                (option[state] || (option[state] = {}))[visualType] = (0, $6650d53cb2636a7d$export$2e2bcd8739ae039).get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
            });
        }, this);
        function has(obj, state, visualType) {
            return obj && obj[state] && obj[state].hasOwnProperty(visualType);
        }
        _super.prototype.completeVisualOption.apply(this, arguments);
    };
    PiecewiseModel.prototype._resetSelected = function(newOption, isInit) {
        var thisOption = this.option;
        var pieceList = this._pieceList;
        // Selected do not merge but all override.
        var selected = (isInit ? thisOption : newOption).selected || {};
        thisOption.selected = selected;
        // Consider 'not specified' means true.
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(pieceList, function(piece, index) {
            var key = this.getSelectedMapKey(piece);
            if (!selected.hasOwnProperty(key)) selected[key] = true;
        }, this);
        if (thisOption.selectedMode === 'single') {
            // Ensure there is only one selected.
            var hasSel_1 = false;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(pieceList, function(piece, index) {
                var key = this.getSelectedMapKey(piece);
                if (selected[key]) hasSel_1 ? selected[key] = false : hasSel_1 = true;
            }, this);
        }
    // thisOption.selectedMode === 'multiple', default: all selected.
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getItemSymbol = function() {
        return this.get('itemSymbol');
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getSelectedMapKey = function(piece) {
        return this._mode === 'categories' ? piece.value + '' : piece.index + '';
    };
    /**
   * @public
   */ PiecewiseModel.prototype.getPieceList = function() {
        return this._pieceList;
    };
    /**
   * @return {string}
   */ PiecewiseModel.prototype._determineMode = function() {
        var option = this.option;
        return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
    };
    /**
   * @override
   */ PiecewiseModel.prototype.setSelected = function(selected) {
        this.option.selected = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(selected);
    };
    /**
   * @override
   */ PiecewiseModel.prototype.getValueState = function(value) {
        var index = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).findPieceIndex(value, this._pieceList);
        return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
    };
    /**
   * @public
   * @param pieceIndex piece index in visualMapModel.getPieceList()
   */ PiecewiseModel.prototype.findTargetDataIndices = function(pieceIndex) {
        var result = [];
        var pieceList = this._pieceList;
        this.eachTargetSeries(function(seriesModel) {
            var dataIndices = [];
            var data = seriesModel.getData();
            data.each(this.getDataDimensionIndex(data), function(value, dataIndex) {
                // Should always base on model pieceList, because it is order sensitive.
                var pIdx = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).findPieceIndex(value, pieceList);
                pIdx === pieceIndex && dataIndices.push(dataIndex);
            }, this);
            result.push({
                seriesId: seriesModel.id,
                dataIndex: dataIndices
            });
        }, this);
        return result;
    };
    /**
   * @private
   * @param piece piece.value or piece.interval is required.
   * @return  Can be Infinity or -Infinity
   */ PiecewiseModel.prototype.getRepresentValue = function(piece) {
        var representValue;
        if (this.isCategory()) representValue = piece.value;
        else if (piece.value != null) representValue = piece.value;
        else {
            var pieceInterval = piece.interval || [];
            representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
        }
        return representValue;
    };
    PiecewiseModel.prototype.getVisualMeta = function(getColorVisual) {
        // Do not support category. (category axis is ordinal, numerical)
        if (this.isCategory()) return;
        var stops = [];
        var outerColors = [
            '',
            ''
        ];
        var visualMapModel = this;
        function setStop(interval, valueState) {
            var representValue = visualMapModel.getRepresentValue({
                interval: interval
            }); // Not category
            if (!valueState) valueState = visualMapModel.getValueState(representValue);
            var color = getColorVisual(representValue, valueState);
            if (interval[0] === -Infinity) outerColors[0] = color;
            else if (interval[1] === Infinity) outerColors[1] = color;
            else stops.push({
                value: interval[0],
                color: color
            }, {
                value: interval[1],
                color: color
            });
        }
        // Suplement
        var pieceList = this._pieceList.slice();
        if (!pieceList.length) pieceList.push({
            interval: [
                -Infinity,
                Infinity
            ]
        });
        else {
            var edge = pieceList[0].interval[0];
            edge !== -Infinity && pieceList.unshift({
                interval: [
                    -Infinity,
                    edge
                ]
            });
            edge = pieceList[pieceList.length - 1].interval[1];
            edge !== Infinity && pieceList.push({
                interval: [
                    edge,
                    Infinity
                ]
            });
        }
        var curr = -Infinity;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(pieceList, function(piece) {
            var interval = piece.interval;
            if (interval) {
                // Fulfill gap.
                interval[0] > curr && setStop([
                    curr,
                    interval[0]
                ], 'outOfRange');
                setStop(interval.slice());
                curr = interval[1];
            }
        }, this);
        return {
            stops: stops,
            outerColors: outerColors
        };
    };
    PiecewiseModel.type = 'visualMap.piecewise';
    PiecewiseModel.defaultOption = (0, $4e8eadf530aecaff$export$68acc510e46fef2)((0, $8f160b3855b6aca1$export$2e2bcd8739ae039).defaultOption, {
        selected: null,
        minOpen: false,
        maxOpen: false,
        align: 'auto',
        itemWidth: 20,
        itemHeight: 14,
        itemSymbol: 'roundRect',
        pieces: null,
        categories: null,
        splitNumber: 5,
        selectedMode: 'multiple',
        itemGap: 10,
        hoverLink: true // Enable hover highlight.
    });
    return PiecewiseModel;
}((0, $8f160b3855b6aca1$export$2e2bcd8739ae039));
/**
 * Key is this._mode
 * @type {Object}
 * @this {module:echarts/component/viusalMap/PiecewiseMode}
 */ var $ca8f8810c7b9bd15$var$resetMethods = {
    splitNumber: function(outPieceList) {
        var thisOption = this.option;
        var precision = Math.min(thisOption.precision, 20);
        var dataExtent = this.getExtent();
        var splitNumber = thisOption.splitNumber;
        splitNumber = Math.max(parseInt(splitNumber, 10), 1);
        thisOption.splitNumber = splitNumber;
        var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber;
        // Precision auto-adaption
        while(+splitStep.toFixed(precision) !== splitStep && precision < 5)precision++;
        thisOption.precision = precision;
        splitStep = +splitStep.toFixed(precision);
        if (thisOption.minOpen) outPieceList.push({
            interval: [
                -Infinity,
                dataExtent[0]
            ],
            close: [
                0,
                0
            ]
        });
        for(var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++){
            var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
            outPieceList.push({
                interval: [
                    curr,
                    max
                ],
                close: [
                    1,
                    1
                ]
            });
        }
        if (thisOption.maxOpen) outPieceList.push({
            interval: [
                dataExtent[1],
                Infinity
            ],
            close: [
                0,
                0
            ]
        });
        (0, $9fd90cf3bf18fbcd$export$12f7386070bc380a)(outPieceList);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(outPieceList, function(piece, index) {
            piece.index = index;
            piece.text = this.formatValueText(piece.interval);
        }, this);
    },
    categories: function(outPieceList) {
        var thisOption = this.option;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(thisOption.categories, function(cate) {
            // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
            // 是否改一致。
            outPieceList.push({
                text: this.formatValueText(cate, true),
                value: cate
            });
        }, this);
        // See "Order Rule".
        $ca8f8810c7b9bd15$var$normalizeReverse(thisOption, outPieceList);
    },
    pieces: function(outPieceList) {
        var thisOption = this.option;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(thisOption.pieces, function(pieceListItem, index) {
            if (!$1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a(pieceListItem)) pieceListItem = {
                value: pieceListItem
            };
            var item = {
                text: '',
                index: index
            };
            if (pieceListItem.label != null) item.text = pieceListItem.label;
            if (pieceListItem.hasOwnProperty('value')) {
                var value = item.value = pieceListItem.value;
                item.interval = [
                    value,
                    value
                ];
                item.close = [
                    1,
                    1
                ];
            } else {
                // `min` `max` is legacy option.
                // `lt` `gt` `lte` `gte` is recommended.
                var interval = item.interval = [];
                var close_1 = item.close = [
                    0,
                    0
                ];
                var closeList = [
                    1,
                    0,
                    1
                ];
                var infinityList = [
                    -Infinity,
                    Infinity
                ];
                var useMinMax = [];
                for(var lg = 0; lg < 2; lg++){
                    var names = [
                        [
                            'gte',
                            'gt',
                            'min'
                        ],
                        [
                            'lte',
                            'lt',
                            'max'
                        ]
                    ][lg];
                    for(var i = 0; i < 3 && interval[lg] == null; i++){
                        interval[lg] = pieceListItem[names[i]];
                        close_1[lg] = closeList[i];
                        useMinMax[lg] = i === 2;
                    }
                    interval[lg] == null && (interval[lg] = infinityList[lg]);
                }
                useMinMax[0] && interval[1] === Infinity && (close_1[0] = 0);
                useMinMax[1] && interval[0] === -Infinity && (close_1[1] = 0);
                if (interval[0] === interval[1] && close_1[0] && close_1[1]) // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
                // we use value to lift the priority when min === max
                item.value = interval[0];
            }
            item.visual = (0, $e0963dffa3af9ce8$export$2e2bcd8739ae039).retrieveVisuals(pieceListItem);
            outPieceList.push(item);
        }, this);
        // See "Order Rule".
        $ca8f8810c7b9bd15$var$normalizeReverse(thisOption, outPieceList);
        // Only pieces
        (0, $9fd90cf3bf18fbcd$export$12f7386070bc380a)(outPieceList);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(outPieceList, function(piece) {
            var close = piece.close;
            var edgeSymbols = [
                [
                    '<',
                    "\u2264"
                ][close[1]],
                [
                    '>',
                    "\u2265"
                ][close[0]]
            ];
            piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
        }, this);
    }
};
function $ca8f8810c7b9bd15$var$normalizeReverse(thisOption, pieceList) {
    var inverse = thisOption.inverse;
    if (thisOption.orient === 'vertical' ? !inverse : inverse) pieceList.reverse();
}
var $ca8f8810c7b9bd15$export$2e2bcd8739ae039 = $ca8f8810c7b9bd15$var$PiecewiseModel;


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 







var $f28328f40dd4f158$var$PiecewiseVisualMapView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(PiecewiseVisualMapView, _super);
    function PiecewiseVisualMapView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = PiecewiseVisualMapView.type;
        return _this;
    }
    PiecewiseVisualMapView.prototype.doRender = function() {
        var thisGroup = this.group;
        thisGroup.removeAll();
        var visualMapModel = this.visualMapModel;
        var textGap = visualMapModel.get('textGap');
        var textStyleModel = visualMapModel.textStyleModel;
        var textFont = textStyleModel.getFont();
        var textFill = textStyleModel.getTextColor();
        var itemAlign = this._getItemAlign();
        var itemSize = visualMapModel.itemSize;
        var viewData = this._getViewData();
        var endsText = viewData.endsText;
        var showLabel = $1b239fc9d3a2f8ae$export$8a4d17b6e8486e66(visualMapModel.get('showLabel', true), !endsText);
        var silent = !visualMapModel.get('selectedMode');
        endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(viewData.viewPieceList, function(item) {
            var piece = item.piece;
            var itemGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
            itemGroup.onclick = $1b239fc9d3a2f8ae$export$2385a24977818dd0(this._onItemClick, this, piece);
            this._enableHoverLink(itemGroup, item.indexInModelPieceList);
            // TODO Category
            var representValue = visualMapModel.getRepresentValue(piece);
            this._createItemSymbol(itemGroup, representValue, [
                0,
                0,
                itemSize[0],
                itemSize[1]
            ], silent);
            if (showLabel) {
                var visualState = this.visualMapModel.getValueState(representValue);
                itemGroup.add(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
                    style: {
                        x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
                        y: itemSize[1] / 2,
                        text: piece.text,
                        verticalAlign: 'middle',
                        align: itemAlign,
                        font: textFont,
                        fill: textFill,
                        opacity: visualState === 'outOfRange' ? 0.5 : 1
                    },
                    silent: silent
                }));
            }
            thisGroup.add(itemGroup);
        }, this);
        endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
        $501dc28f6c4d24ac$export$827f4ee28efc37(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
        this.renderBackground(thisGroup);
        this.positionGroup(thisGroup);
    };
    PiecewiseVisualMapView.prototype._enableHoverLink = function(itemGroup, pieceIndex) {
        var _this = this;
        itemGroup.on('mouseover', function() {
            return onHoverLink('highlight');
        }).on('mouseout', function() {
            return onHoverLink('downplay');
        });
        var onHoverLink = function(method) {
            var visualMapModel = _this.visualMapModel;
            // TODO: TYPE More detailed action types
            visualMapModel.option.hoverLink && _this.api.dispatchAction({
                type: method,
                batch: $8bd2de6be4ac6291$export$5381a9dc5427ba18(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
            });
        };
    };
    PiecewiseVisualMapView.prototype._getItemAlign = function() {
        var visualMapModel = this.visualMapModel;
        var modelOption = visualMapModel.option;
        if (modelOption.orient === 'vertical') return $8bd2de6be4ac6291$export$dca53c4702e35c6(visualMapModel, this.api, visualMapModel.itemSize);
        else {
            // horizontal, most case left unless specifying right.
            var align = modelOption.align;
            if (!align || align === 'auto') align = 'left';
            return align;
        }
    };
    PiecewiseVisualMapView.prototype._renderEndsText = function(group, text, itemSize, showLabel, itemAlign) {
        if (!text) return;
        var itemGroup = new $6c313c3ef6000a43$export$2e2bcd8739ae039();
        var textStyleModel = this.visualMapModel.textStyleModel;
        itemGroup.add(new $76f8f1d5b5bbe4fc$export$2e2bcd8739ae039({
            style: (0, $3828198b2f2de836$export$f8998c3d0a13de59)(textStyleModel, {
                x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
                y: itemSize[1] / 2,
                verticalAlign: 'middle',
                align: showLabel ? itemAlign : 'center',
                text: text
            })
        }));
        group.add(itemGroup);
    };
    /**
   * @private
   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
   */ PiecewiseVisualMapView.prototype._getViewData = function() {
        var visualMapModel = this.visualMapModel;
        var viewPieceList = $1b239fc9d3a2f8ae$export$871de8747c9eaa88(visualMapModel.getPieceList(), function(piece, index) {
            return {
                piece: piece,
                indexInModelPieceList: index
            };
        });
        var endsText = visualMapModel.get('text');
        // Consider orient and inverse.
        var orient = visualMapModel.get('orient');
        var inverse = visualMapModel.get('inverse');
        // Order of model pieceList is always [low, ..., high]
        if (orient === 'horizontal' ? inverse : !inverse) viewPieceList.reverse();
        else if (endsText) endsText = endsText.slice().reverse();
        return {
            viewPieceList: viewPieceList,
            endsText: endsText
        };
    };
    PiecewiseVisualMapView.prototype._createItemSymbol = function(group, representValue, shapeParam, silent) {
        var itemSymbol = (0, $da6220012439db7b$export$af050e04da3a02e8)(// symbol will be string
        this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], // color will be string
        this.getControllerVisual(representValue, 'color'));
        itemSymbol.silent = silent;
        group.add(itemSymbol);
    };
    PiecewiseVisualMapView.prototype._onItemClick = function(piece) {
        var visualMapModel = this.visualMapModel;
        var option = visualMapModel.option;
        var selectedMode = option.selectedMode;
        if (!selectedMode) return;
        var selected = $1b239fc9d3a2f8ae$export$9cd59f9826255e47(option.selected);
        var newKey = visualMapModel.getSelectedMapKey(piece);
        if (selectedMode === 'single' || selectedMode === true) {
            selected[newKey] = true;
            $1b239fc9d3a2f8ae$export$79b2f7037acddd43(selected, function(o, key) {
                selected[key] = key === newKey;
            });
        } else selected[newKey] = !selected[newKey];
        this.api.dispatchAction({
            type: 'selectDataRange',
            from: this.uid,
            visualMapId: this.visualMapModel.id,
            selected: selected
        });
    };
    PiecewiseVisualMapView.type = 'visualMap.piecewise';
    return PiecewiseVisualMapView;
}((0, $6e864d1ede82eca7$export$2e2bcd8739ae039));
var $f28328f40dd4f158$export$2e2bcd8739ae039 = $f28328f40dd4f158$var$PiecewiseVisualMapView;



function $40490ae85c73737a$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel((0, $ca8f8810c7b9bd15$export$2e2bcd8739ae039));
    registers.registerComponentView((0, $f28328f40dd4f158$export$2e2bcd8739ae039));
    (0, $ac922d851d7b22f4$export$2e2bcd8739ae039)(registers);
}


function $021aa7bfc32c9b88$export$4b3e715f166fdd78(registers) {
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $b1d6b437a4e7085d$export$4b3e715f166fdd78));
    (0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $40490ae85c73737a$export$4b3e715f166fdd78));
// Do not install './dataZoomSelect',
// since it only work for toolbox dataZoom.
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $1689785e63c3ab7b$var$DEFAULT_OPTION = {
    label: {
        enabled: true
    },
    decal: {
        show: false
    }
};
var $1689785e63c3ab7b$var$inner = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $1689785e63c3ab7b$var$decalPaletteScope = {};
function $1689785e63c3ab7b$export$2e2bcd8739ae039(ecModel, api) {
    var ariaModel = ecModel.getModel('aria');
    // See "area enabled" detection code in `GlobalModel.ts`.
    if (!ariaModel.get('enabled')) return;
    var defaultOption = $1b239fc9d3a2f8ae$export$9cd59f9826255e47($1689785e63c3ab7b$var$DEFAULT_OPTION);
    $1b239fc9d3a2f8ae$export$4950aa0f605343fb(defaultOption.label, ecModel.getLocaleModel().get('aria'), false);
    $1b239fc9d3a2f8ae$export$4950aa0f605343fb(ariaModel.option, defaultOption, false);
    setDecal();
    setLabel();
    function setDecal() {
        var decalModel = ariaModel.getModel('decal');
        var useDecal = decalModel.get('show');
        if (useDecal) {
            // Each type of series use one scope.
            // Pie and funnel are using different scopes.
            var paletteScopeGroupByType_1 = $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4();
            ecModel.eachSeries(function(seriesModel) {
                if (seriesModel.isColorBySeries()) return;
                var decalScope = paletteScopeGroupByType_1.get(seriesModel.type);
                if (!decalScope) {
                    decalScope = {};
                    paletteScopeGroupByType_1.set(seriesModel.type, decalScope);
                }
                $1689785e63c3ab7b$var$inner(seriesModel).scope = decalScope;
            });
            ecModel.eachRawSeries(function(seriesModel) {
                if (ecModel.isSeriesFiltered(seriesModel)) return;
                if ($1b239fc9d3a2f8ae$export$f6e2535fb5126e54(seriesModel.enableAriaDecal)) {
                    // Let series define how to use decal palette on data
                    seriesModel.enableAriaDecal();
                    return;
                }
                var data = seriesModel.getData();
                if (!seriesModel.isColorBySeries()) {
                    var dataAll_1 = seriesModel.getRawData();
                    var idxMap_1 = {};
                    var decalScope_1 = $1689785e63c3ab7b$var$inner(seriesModel).scope;
                    data.each(function(idx) {
                        var rawIdx = data.getRawIndex(idx);
                        idxMap_1[rawIdx] = idx;
                    });
                    var dataCount_1 = dataAll_1.count();
                    dataAll_1.each(function(rawIdx) {
                        var idx = idxMap_1[rawIdx];
                        var name = dataAll_1.getName(rawIdx) || rawIdx + '';
                        var paletteDecal = (0, $6d8b6513f520ae7c$export$e4d892222945a227)(seriesModel.ecModel, name, decalScope_1, dataCount_1);
                        var specifiedDecal = data.getItemVisual(idx, 'decal');
                        data.setItemVisual(idx, 'decal', mergeDecal(specifiedDecal, paletteDecal));
                    });
                } else {
                    var paletteDecal = (0, $6d8b6513f520ae7c$export$e4d892222945a227)(seriesModel.ecModel, seriesModel.name, $1689785e63c3ab7b$var$decalPaletteScope, ecModel.getSeriesCount());
                    var specifiedDecal = data.getVisual('decal');
                    data.setVisual('decal', mergeDecal(specifiedDecal, paletteDecal));
                }
                function mergeDecal(specifiedDecal, paletteDecal) {
                    // Merge decal from palette to decal from itemStyle.
                    // User do not need to specify all of the decal props.
                    var resultDecal = specifiedDecal ? $1b239fc9d3a2f8ae$export$8b58be045bf06082($1b239fc9d3a2f8ae$export$8b58be045bf06082({}, paletteDecal), specifiedDecal) : paletteDecal;
                    resultDecal.dirty = true;
                    return resultDecal;
                }
            });
        }
    }
    function setLabel() {
        var dom = api.getZr().dom;
        // TODO: support for SSR
        if (!dom) return;
        var labelLocale = ecModel.getLocaleModel().get('aria');
        var labelModel = ariaModel.getModel('label');
        labelModel.option = $1b239fc9d3a2f8ae$export$ebe90cb607ad99e(labelModel.option, labelLocale);
        if (!labelModel.get('enabled')) return;
        dom.setAttribute('role', 'img');
        if (labelModel.get('description')) {
            dom.setAttribute('aria-label', labelModel.get('description'));
            return;
        }
        var seriesCnt = ecModel.getSeriesCount();
        var maxDataCnt = labelModel.get([
            'data',
            'maxCount'
        ]) || 10;
        var maxSeriesCnt = labelModel.get([
            'series',
            'maxCount'
        ]) || 10;
        var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
        var ariaLabel;
        if (seriesCnt < 1) // No series, no aria label
        return;
        else {
            var title = getTitle();
            if (title) {
                var withTitle = labelModel.get([
                    'general',
                    'withTitle'
                ]);
                ariaLabel = replace(withTitle, {
                    title: title
                });
            } else ariaLabel = labelModel.get([
                'general',
                'withoutTitle'
            ]);
            var seriesLabels_1 = [];
            var prefix = seriesCnt > 1 ? labelModel.get([
                'series',
                'multiple',
                'prefix'
            ]) : labelModel.get([
                'series',
                'single',
                'prefix'
            ]);
            ariaLabel += replace(prefix, {
                seriesCount: seriesCnt
            });
            ecModel.eachSeries(function(seriesModel, idx) {
                if (idx < displaySeriesCnt) {
                    var seriesLabel = void 0;
                    var seriesName = seriesModel.get('name');
                    var withName = seriesName ? 'withName' : 'withoutName';
                    seriesLabel = seriesCnt > 1 ? labelModel.get([
                        'series',
                        'multiple',
                        withName
                    ]) : labelModel.get([
                        'series',
                        'single',
                        withName
                    ]);
                    seriesLabel = replace(seriesLabel, {
                        seriesId: seriesModel.seriesIndex,
                        seriesName: seriesModel.get('name'),
                        seriesType: getSeriesTypeName(seriesModel.subType)
                    });
                    var data = seriesModel.getData();
                    if (data.count() > maxDataCnt) {
                        // Show part of data
                        var partialLabel = labelModel.get([
                            'data',
                            'partialData'
                        ]);
                        seriesLabel += replace(partialLabel, {
                            displayCnt: maxDataCnt
                        });
                    } else seriesLabel += labelModel.get([
                        'data',
                        'allData'
                    ]);
                    var middleSeparator_1 = labelModel.get([
                        'data',
                        'separator',
                        'middle'
                    ]);
                    var endSeparator_1 = labelModel.get([
                        'data',
                        'separator',
                        'end'
                    ]);
                    var excludeDimensionId_1 = labelModel.get([
                        'data',
                        'excludeDimensionId'
                    ]);
                    var dataLabels = [];
                    for(var i = 0; i < data.count(); i++)if (i < maxDataCnt) {
                        var name_1 = data.getName(i);
                        var value = !excludeDimensionId_1 ? data.getValues(i) : $1b239fc9d3a2f8ae$export$3dea766d36a8935f(data.getValues(i), function(v, j) {
                            return $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2(excludeDimensionId_1, j) === -1;
                        });
                        var dataLabel = labelModel.get([
                            'data',
                            name_1 ? 'withName' : 'withoutName'
                        ]);
                        dataLabels.push(replace(dataLabel, {
                            name: name_1,
                            value: value.join(middleSeparator_1)
                        }));
                    }
                    seriesLabel += dataLabels.join(middleSeparator_1) + endSeparator_1;
                    seriesLabels_1.push(seriesLabel);
                }
            });
            var separatorModel = labelModel.getModel([
                'series',
                'multiple',
                'separator'
            ]);
            var middleSeparator = separatorModel.get('middle');
            var endSeparator = separatorModel.get('end');
            ariaLabel += seriesLabels_1.join(middleSeparator) + endSeparator;
            dom.setAttribute('aria-label', ariaLabel);
        }
    }
    function replace(str, keyValues) {
        if (!$1b239fc9d3a2f8ae$export$844ec244b1367d54(str)) return str;
        var result = str;
        $1b239fc9d3a2f8ae$export$79b2f7037acddd43(keyValues, function(value, key) {
            result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
        });
        return result;
    }
    function getTitle() {
        var title = ecModel.get('title');
        if (title && title.length) title = title[0];
        return title && title.text;
    }
    function getSeriesTypeName(type) {
        var typeNames = ecModel.getLocaleModel().get([
            'series',
            'typeNames'
        ]);
        return typeNames[type] || typeNames.chart;
    }
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
function $81f75ed49da446c6$export$2e2bcd8739ae039(option) {
    if (!option || !option.aria) return;
    var aria = option.aria;
    // aria.show is deprecated and should use aria.enabled instead
    if (aria.show != null) aria.enabled = aria.show;
    aria.label = aria.label || {};
    // move description, general, series, data to be under aria.label
    $1b239fc9d3a2f8ae$export$79b2f7037acddd43([
        'description',
        'general',
        'series',
        'data'
    ], function(name) {
        if (aria[name] != null) aria.label[name] = aria[name];
    });
}


function $d63f2023c7233bcd$export$4b3e715f166fdd78(registers) {
    registers.registerPreprocessor((0, $81f75ed49da446c6$export$2e2bcd8739ae039));
    registers.registerVisual(registers.PRIORITY.VISUAL.ARIA, (0, $1689785e63c3ab7b$export$2e2bcd8739ae039));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 


var $12630c51f2a07a75$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP = {
    value: 'eq',
    // PENDING: not good for literal semantic?
    '<': 'lt',
    '<=': 'lte',
    '>': 'gt',
    '>=': 'gte',
    '=': 'eq',
    '!=': 'ne',
    '<>': 'ne'
};
// type RelationalExpressionOpEvaluate = (tarVal: unknown, condVal: unknown) => boolean;
var $12630c51f2a07a75$var$RegExpEvaluator = /** @class */ function() {
    function RegExpEvaluator(rVal) {
        // Support condVal: RegExp | string
        var condValue = this._condVal = (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(rVal) ? new RegExp(rVal) : (0, $1b239fc9d3a2f8ae$export$49841c62b9eff15)(rVal) ? rVal : null;
        if (condValue == null) {
            var errMsg = '';
            (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        }
    }
    RegExpEvaluator.prototype.evaluate = function(lVal) {
        var type = typeof lVal;
        return (0, $1b239fc9d3a2f8ae$export$844ec244b1367d54)(type) ? this._condVal.test(lVal) : (0, $1b239fc9d3a2f8ae$export$7e4aa119212bc614)(type) ? this._condVal.test(lVal + '') : false;
    };
    return RegExpEvaluator;
}();
var $12630c51f2a07a75$var$ConstConditionInternal = /** @class */ function() {
    function ConstConditionInternal() {}
    ConstConditionInternal.prototype.evaluate = function() {
        return this.value;
    };
    return ConstConditionInternal;
}();
var $12630c51f2a07a75$var$AndConditionInternal = /** @class */ function() {
    function AndConditionInternal() {}
    AndConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (!children[i].evaluate()) return false;
        }
        return true;
    };
    return AndConditionInternal;
}();
var $12630c51f2a07a75$var$OrConditionInternal = /** @class */ function() {
    function OrConditionInternal() {}
    OrConditionInternal.prototype.evaluate = function() {
        var children = this.children;
        for(var i = 0; i < children.length; i++){
            if (children[i].evaluate()) return true;
        }
        return false;
    };
    return OrConditionInternal;
}();
var $12630c51f2a07a75$var$NotConditionInternal = /** @class */ function() {
    function NotConditionInternal() {}
    NotConditionInternal.prototype.evaluate = function() {
        return !this.child.evaluate();
    };
    return NotConditionInternal;
}();
var $12630c51f2a07a75$var$RelationalConditionInternal = /** @class */ function() {
    function RelationalConditionInternal() {}
    RelationalConditionInternal.prototype.evaluate = function() {
        var needParse = !!this.valueParser;
        // Call getValue with no `this`.
        var getValue = this.getValue;
        var tarValRaw = getValue(this.valueGetterParam);
        var tarValParsed = needParse ? this.valueParser(tarValRaw) : null;
        // Relational cond follow "and" logic internally.
        for(var i = 0; i < this.subCondList.length; i++){
            if (!this.subCondList[i].evaluate(needParse ? tarValParsed : tarValRaw)) return false;
        }
        return true;
    };
    return RelationalConditionInternal;
}();
function $12630c51f2a07a75$var$parseOption(exprOption, getters) {
    if (exprOption === true || exprOption === false) {
        var cond = new $12630c51f2a07a75$var$ConstConditionInternal();
        cond.value = exprOption;
        return cond;
    }
    var errMsg = '';
    if (!$12630c51f2a07a75$var$isObjectNotArray(exprOption)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    if (exprOption.and) return $12630c51f2a07a75$var$parseAndOrOption('and', exprOption, getters);
    else if (exprOption.or) return $12630c51f2a07a75$var$parseAndOrOption('or', exprOption, getters);
    else if (exprOption.not) return $12630c51f2a07a75$var$parseNotOption(exprOption, getters);
    return $12630c51f2a07a75$var$parseRelationalOption(exprOption, getters);
}
function $12630c51f2a07a75$var$parseAndOrOption(op, exprOption, getters) {
    var subOptionArr = exprOption[op];
    var errMsg = '';
    if (!(0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(subOptionArr)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    if (!subOptionArr.length) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    var cond = op === 'and' ? new $12630c51f2a07a75$var$AndConditionInternal() : new $12630c51f2a07a75$var$OrConditionInternal();
    cond.children = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(subOptionArr, function(subOption) {
        return $12630c51f2a07a75$var$parseOption(subOption, getters);
    });
    if (!cond.children.length) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $12630c51f2a07a75$var$parseNotOption(exprOption, getters) {
    var subOption = exprOption.not;
    var errMsg = '';
    if (!$12630c51f2a07a75$var$isObjectNotArray(subOption)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $12630c51f2a07a75$var$NotConditionInternal();
    cond.child = $12630c51f2a07a75$var$parseOption(subOption, getters);
    if (!cond.child) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    return cond;
}
function $12630c51f2a07a75$var$parseRelationalOption(exprOption, getters) {
    var errMsg = '';
    var valueGetterParam = getters.prepareGetValue(exprOption);
    var subCondList = [];
    var exprKeys = (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(exprOption);
    var parserName = exprOption.parser;
    var valueParser = parserName ? (0, $b0b05721170d73df$export$c88237b7c265b36b)(parserName) : null;
    for(var i = 0; i < exprKeys.length; i++){
        var keyRaw = exprKeys[i];
        if (keyRaw === 'parser' || getters.valueGetterAttrMap.get(keyRaw)) continue;
        var op = (0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)($12630c51f2a07a75$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP, keyRaw) ? $12630c51f2a07a75$var$RELATIONAL_EXPRESSION_OP_ALIAS_MAP[keyRaw] : keyRaw;
        var condValueRaw = exprOption[keyRaw];
        var condValueParsed = valueParser ? valueParser(condValueRaw) : condValueRaw;
        var evaluator = (0, $b0b05721170d73df$export$f2644c3485f94c4e)(op, condValueParsed) || op === 'reg' && new $12630c51f2a07a75$var$RegExpEvaluator(condValueParsed);
        if (!evaluator) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        subCondList.push(evaluator);
    }
    if (!subCondList.length) // No relational operator always disabled in case of dangers result.
    (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
    var cond = new $12630c51f2a07a75$var$RelationalConditionInternal();
    cond.valueGetterParam = valueGetterParam;
    cond.valueParser = valueParser;
    cond.getValue = getters.getValue;
    cond.subCondList = subCondList;
    return cond;
}
function $12630c51f2a07a75$var$isObjectNotArray(val) {
    return (0, $1b239fc9d3a2f8ae$export$a6cdc56e425d0d0a)(val) && !(0, $1b239fc9d3a2f8ae$export$1e2f57719e155213)(val);
}
var $12630c51f2a07a75$var$ConditionalExpressionParsed = /** @class */ function() {
    function ConditionalExpressionParsed(exprOption, getters) {
        this._cond = $12630c51f2a07a75$var$parseOption(exprOption, getters);
    }
    ConditionalExpressionParsed.prototype.evaluate = function() {
        return this._cond.evaluate();
    };
    return ConditionalExpressionParsed;
}();
function $12630c51f2a07a75$export$cd61647d82cec762(exprOption, getters) {
    return new $12630c51f2a07a75$var$ConditionalExpressionParsed(exprOption, getters);
}




var $ffee25b36d36eb06$export$dc15474d94cdc2b3 = {
    type: 'echarts:filter',
    // PENDING: enhance to filter by index rather than create new data
    transform: function(params) {
        // [Caveat] Fail-Fast:
        // Do not return the whole dataset unless user config indicates it explicitly.
        // For example, if no condition is specified by mistake, returning an empty result
        // is better than returning the entire raw source for the user to find the mistake.
        var upstream = params.upstream;
        var rawItem;
        var condition = (0, $12630c51f2a07a75$export$cd61647d82cec762)(params.config, {
            valueGetterAttrMap: (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)({
                dimension: true
            }),
            prepareGetValue: function(exprOption) {
                var errMsg = '';
                var dimLoose = exprOption.dimension;
                if (!(0, $1b239fc9d3a2f8ae$export$b5a638e9b3fff9f3)(exprOption, 'dimension')) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
                var dimInfo = upstream.getDimensionInfo(dimLoose);
                if (!dimInfo) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
                return {
                    dimIdx: dimInfo.index
                };
            },
            getValue: function(param) {
                return upstream.retrieveValueFromItem(rawItem, param.dimIdx);
            }
        });
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++){
            rawItem = upstream.getRawDataItem(i);
            if (condition.evaluate()) resultData.push(rawItem);
        }
        return {
            data: resultData
        };
    }
};


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $f32a8273a44dc77f$var$sampleLog = '';
var $f32a8273a44dc77f$export$505f1bb66427eaee = {
    type: 'echarts:sort',
    transform: function(params) {
        var upstream = params.upstream;
        var config = params.config;
        var errMsg = '';
        // Normalize
        // const orderExprList: OrderExpression[] = isArray(config[0])
        //     ? config as OrderExpression[]
        //     : [config as OrderExpression];
        var orderExprList = (0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(config);
        if (!orderExprList.length) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        var orderDefList = [];
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(orderExprList, function(orderExpr) {
            var dimLoose = orderExpr.dimension;
            var order = orderExpr.order;
            var parserName = orderExpr.parser;
            var incomparable = orderExpr.incomparable;
            if (dimLoose == null) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
            if (order !== 'asc' && order !== 'desc') (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
            if (incomparable && incomparable !== 'min' && incomparable !== 'max') {
                var errMsg_1 = '';
                (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg_1);
            }
            if (order !== 'asc' && order !== 'desc') {
                var errMsg_2 = '';
                (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg_2);
            }
            var dimInfo = upstream.getDimensionInfo(dimLoose);
            if (!dimInfo) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
            var parser = parserName ? (0, $b0b05721170d73df$export$c88237b7c265b36b)(parserName) : null;
            if (parserName && !parser) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
            orderDefList.push({
                dimIdx: dimInfo.index,
                parser: parser,
                comparator: new (0, $b0b05721170d73df$export$ed75a5d7b0144167)(order, incomparable)
            });
        });
        // TODO: support it?
        var sourceFormat = upstream.sourceFormat;
        if (sourceFormat !== (0, $369d2fc585e5938e$export$fcd62ebf51387903) && sourceFormat !== (0, $369d2fc585e5938e$export$703ae8a2d83f441)) (0, $4ef07c0eafe44628$export$8bf7aba4a9e09055)(errMsg);
        // Other upstream format are all array.
        var resultData = [];
        for(var i = 0, len = upstream.count(); i < len; i++)resultData.push(upstream.getRawDataItem(i));
        resultData.sort(function(item0, item1) {
            for(var i = 0; i < orderDefList.length; i++){
                var orderDef = orderDefList[i];
                var val0 = upstream.retrieveValueFromItem(item0, orderDef.dimIdx);
                var val1 = upstream.retrieveValueFromItem(item1, orderDef.dimIdx);
                if (orderDef.parser) {
                    val0 = orderDef.parser(val0);
                    val1 = orderDef.parser(val1);
                }
                var result = orderDef.comparator.evaluate(val0, val1);
                if (result !== 0) return result;
            }
            return 0;
        });
        return {
            data: resultData
        };
    }
};


function $46259e7bb3fe93d3$export$4b3e715f166fdd78(registers) {
    registers.registerTransform((0, $ffee25b36d36eb06$export$dc15474d94cdc2b3));
    registers.registerTransform((0, $f32a8273a44dc77f$export$505f1bb66427eaee));
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 




var $8ddb7abf1db65807$export$83e718f1c3c9edae = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(DatasetModel, _super);
    function DatasetModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataset';
        return _this;
    }
    DatasetModel.prototype.init = function(option, parentModel, ecModel) {
        _super.prototype.init.call(this, option, parentModel, ecModel);
        this._sourceManager = new (0, $9b5faf969a385e96$export$af4db9ec7e200ea2)(this);
        (0, $9b5faf969a385e96$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.mergeOption = function(newOption, ecModel) {
        _super.prototype.mergeOption.call(this, newOption, ecModel);
        (0, $9b5faf969a385e96$export$9451f4e9047441ec)(this);
    };
    DatasetModel.prototype.optionUpdated = function() {
        this._sourceManager.dirty();
    };
    DatasetModel.prototype.getSourceManager = function() {
        return this._sourceManager;
    };
    DatasetModel.type = 'dataset';
    DatasetModel.defaultOption = {
        seriesLayoutBy: (0, $369d2fc585e5938e$export$7b3f3c6551b4949b)
    };
    return DatasetModel;
}((0, $ba6ce7bfb5e68143$export$2e2bcd8739ae039));
var $8ddb7abf1db65807$var$DatasetView = /** @class */ function(_super) {
    (0, $68b7c89c821485ed$export$a8ba968b8961cb8a)(DatasetView, _super);
    function DatasetView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'dataset';
        return _this;
    }
    DatasetView.type = 'dataset';
    return DatasetView;
}((0, $8b851331e51a1131$export$2e2bcd8739ae039));
function $8ddb7abf1db65807$export$4b3e715f166fdd78(registers) {
    registers.registerComponentModel($8ddb7abf1db65807$export$83e718f1c3c9edae);
    registers.registerComponentView($8ddb7abf1db65807$var$DatasetView);
}


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // Universal transitions that can animate between any shapes(series) and any properties in any amounts.


/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 














var $14783103db5619f6$var$CMD = (0, $3fd2aad7811d6df2$export$2e2bcd8739ae039).CMD;
function $14783103db5619f6$var$aroundEqual(a, b) {
    return Math.abs(a - b) < 1e-5;
}
function $14783103db5619f6$export$fbc91cffd4bdf629(path) {
    var data = path.data;
    var len = path.len();
    var bezierArrayGroups = [];
    var currentSubpath;
    var xi = 0;
    var yi = 0;
    var x0 = 0;
    var y0 = 0;
    function createNewSubpath(x, y) {
        if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
        currentSubpath = [
            x,
            y
        ];
    }
    function addLine(x0, y0, x1, y1) {
        if (!($14783103db5619f6$var$aroundEqual(x0, x1) && $14783103db5619f6$var$aroundEqual(y0, y1))) currentSubpath.push(x0, y0, x1, y1, x1, y1);
    }
    function addArc(startAngle, endAngle, cx, cy, rx, ry) {
        var delta = Math.abs(endAngle - startAngle);
        var len = Math.tan(delta / 4) * 4 / 3;
        var dir = endAngle < startAngle ? -1 : 1;
        var c1 = Math.cos(startAngle);
        var s1 = Math.sin(startAngle);
        var c2 = Math.cos(endAngle);
        var s2 = Math.sin(endAngle);
        var x1 = c1 * rx + cx;
        var y1 = s1 * ry + cy;
        var x4 = c2 * rx + cx;
        var y4 = s2 * ry + cy;
        var hx = rx * len * dir;
        var hy = ry * len * dir;
        currentSubpath.push(x1 - hx * s1, y1 + hy * c1, x4 + hx * s2, y4 - hy * c2, x4, y4);
    }
    var x1;
    var y1;
    var x2;
    var y2;
    for(var i = 0; i < len;){
        var cmd = data[i++];
        var isFirst = i === 1;
        if (isFirst) {
            xi = data[i];
            yi = data[i + 1];
            x0 = xi;
            y0 = yi;
            if (cmd === $14783103db5619f6$var$CMD.L || cmd === $14783103db5619f6$var$CMD.C || cmd === $14783103db5619f6$var$CMD.Q) currentSubpath = [
                x0,
                y0
            ];
        }
        switch(cmd){
            case $14783103db5619f6$var$CMD.M:
                xi = x0 = data[i++];
                yi = y0 = data[i++];
                createNewSubpath(x0, y0);
                break;
            case $14783103db5619f6$var$CMD.L:
                x1 = data[i++];
                y1 = data[i++];
                addLine(xi, yi, x1, y1);
                xi = x1;
                yi = y1;
                break;
            case $14783103db5619f6$var$CMD.C:
                currentSubpath.push(data[i++], data[i++], data[i++], data[i++], xi = data[i++], yi = data[i++]);
                break;
            case $14783103db5619f6$var$CMD.Q:
                x1 = data[i++];
                y1 = data[i++];
                x2 = data[i++];
                y2 = data[i++];
                currentSubpath.push(xi + 2 / 3 * (x1 - xi), yi + 2 / 3 * (y1 - yi), x2 + 2 / 3 * (x1 - x2), y2 + 2 / 3 * (y1 - y2), x2, y2);
                xi = x2;
                yi = y2;
                break;
            case $14783103db5619f6$var$CMD.A:
                var cx = data[i++];
                var cy = data[i++];
                var rx = data[i++];
                var ry = data[i++];
                var startAngle = data[i++];
                var endAngle = data[i++] + startAngle;
                i += 1;
                var anticlockwise = !data[i++];
                x1 = Math.cos(startAngle) * rx + cx;
                y1 = Math.sin(startAngle) * ry + cy;
                if (isFirst) {
                    x0 = x1;
                    y0 = y1;
                    createNewSubpath(x0, y0);
                } else addLine(xi, yi, x1, y1);
                xi = Math.cos(endAngle) * rx + cx;
                yi = Math.sin(endAngle) * ry + cy;
                var step = (anticlockwise ? -1 : 1) * Math.PI / 2;
                for(var angle = startAngle; anticlockwise ? angle > endAngle : angle < endAngle; angle += step){
                    var nextAngle = anticlockwise ? Math.max(angle + step, endAngle) : Math.min(angle + step, endAngle);
                    addArc(angle, nextAngle, cx, cy, rx, ry);
                }
                break;
            case $14783103db5619f6$var$CMD.R:
                x0 = xi = data[i++];
                y0 = yi = data[i++];
                x1 = x0 + data[i++];
                y1 = y0 + data[i++];
                createNewSubpath(x1, y0);
                addLine(x1, y0, x1, y1);
                addLine(x1, y1, x0, y1);
                addLine(x0, y1, x0, y0);
                addLine(x0, y0, x1, y0);
                break;
            case $14783103db5619f6$var$CMD.Z:
                currentSubpath && addLine(xi, yi, x0, y0);
                xi = x0;
                yi = y0;
                break;
        }
    }
    if (currentSubpath && currentSubpath.length > 2) bezierArrayGroups.push(currentSubpath);
    return bezierArrayGroups;
}
function $14783103db5619f6$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, out, scale) {
    if ($14783103db5619f6$var$aroundEqual(x0, x1) && $14783103db5619f6$var$aroundEqual(y0, y1) && $14783103db5619f6$var$aroundEqual(x2, x3) && $14783103db5619f6$var$aroundEqual(y2, y3)) {
        out.push(x3, y3);
        return;
    }
    var PIXEL_DISTANCE = 2 / scale;
    var PIXEL_DISTANCE_SQR = PIXEL_DISTANCE * PIXEL_DISTANCE;
    var dx = x3 - x0;
    var dy = y3 - y0;
    var d = Math.sqrt(dx * dx + dy * dy);
    dx /= d;
    dy /= d;
    var dx1 = x1 - x0;
    var dy1 = y1 - y0;
    var dx2 = x2 - x3;
    var dy2 = y2 - y3;
    var cp1LenSqr = dx1 * dx1 + dy1 * dy1;
    var cp2LenSqr = dx2 * dx2 + dy2 * dy2;
    if (cp1LenSqr < PIXEL_DISTANCE_SQR && cp2LenSqr < PIXEL_DISTANCE_SQR) {
        out.push(x3, y3);
        return;
    }
    var projLen1 = dx * dx1 + dy * dy1;
    var projLen2 = -dx * dx2 - dy * dy2;
    var d1Sqr = cp1LenSqr - projLen1 * projLen1;
    var d2Sqr = cp2LenSqr - projLen2 * projLen2;
    if (d1Sqr < PIXEL_DISTANCE_SQR && projLen1 >= 0 && d2Sqr < PIXEL_DISTANCE_SQR && projLen2 >= 0) {
        out.push(x3, y3);
        return;
    }
    var tmpSegX = [];
    var tmpSegY = [];
    (0, $eea9463646207a7b$export$a2ee23a0567039da)(x0, x1, x2, x3, 0.5, tmpSegX);
    (0, $eea9463646207a7b$export$a2ee23a0567039da)(y0, y1, y2, y3, 0.5, tmpSegY);
    $14783103db5619f6$var$adpativeBezier(tmpSegX[0], tmpSegY[0], tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], tmpSegX[3], tmpSegY[3], out, scale);
    $14783103db5619f6$var$adpativeBezier(tmpSegX[4], tmpSegY[4], tmpSegX[5], tmpSegY[5], tmpSegX[6], tmpSegY[6], tmpSegX[7], tmpSegY[7], out, scale);
}
function $14783103db5619f6$export$163f4950160f2337(path, scale) {
    var bezierArrayGroups = $14783103db5619f6$export$fbc91cffd4bdf629(path);
    var polygons = [];
    scale = scale || 1;
    for(var i = 0; i < bezierArrayGroups.length; i++){
        var beziers = bezierArrayGroups[i];
        var polygon = [];
        var x0 = beziers[0];
        var y0 = beziers[1];
        polygon.push(x0, y0);
        for(var k = 2; k < beziers.length;){
            var x1 = beziers[k++];
            var y1 = beziers[k++];
            var x2 = beziers[k++];
            var y2 = beziers[k++];
            var x3 = beziers[k++];
            var y3 = beziers[k++];
            $14783103db5619f6$var$adpativeBezier(x0, y0, x1, y1, x2, y2, x3, y3, polygon, scale);
            x0 = x3;
            y0 = y3;
        }
        polygons.push(polygon);
    }
    return polygons;
}



function $48898afe56067714$var$getDividingGrids(dimSize, rowDim, count) {
    var rowSize = dimSize[rowDim];
    var columnSize = dimSize[1 - rowDim];
    var ratio = Math.abs(rowSize / columnSize);
    var rowCount = Math.ceil(Math.sqrt(ratio * count));
    var columnCount = Math.floor(count / rowCount);
    if (columnCount === 0) {
        columnCount = 1;
        rowCount = count;
    }
    var grids = [];
    for(var i = 0; i < rowCount; i++)grids.push(columnCount);
    var currentCount = rowCount * columnCount;
    var remained = count - currentCount;
    if (remained > 0) for(var i = 0; i < remained; i++)grids[i % rowCount] += 1;
    return grids;
}
function $48898afe56067714$var$divideSector(sectorShape, count, outShapes) {
    var r0 = sectorShape.r0;
    var r = sectorShape.r;
    var startAngle = sectorShape.startAngle;
    var endAngle = sectorShape.endAngle;
    var angle = Math.abs(endAngle - startAngle);
    var arcLen = angle * r;
    var deltaR = r - r0;
    var isAngleRow = arcLen > Math.abs(deltaR);
    var grids = $48898afe56067714$var$getDividingGrids([
        arcLen,
        deltaR
    ], isAngleRow ? 0 : 1, count);
    var rowSize = (isAngleRow ? angle : deltaR) / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = (isAngleRow ? deltaR : angle) / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            if (isAngleRow) {
                newShape.startAngle = startAngle + rowSize * row;
                newShape.endAngle = startAngle + rowSize * (row + 1);
                newShape.r0 = r0 + columnSize * column;
                newShape.r = r0 + columnSize * (column + 1);
            } else {
                newShape.startAngle = startAngle + columnSize * column;
                newShape.endAngle = startAngle + columnSize * (column + 1);
                newShape.r0 = r0 + rowSize * row;
                newShape.r = r0 + rowSize * (row + 1);
            }
            newShape.clockwise = sectorShape.clockwise;
            newShape.cx = sectorShape.cx;
            newShape.cy = sectorShape.cy;
            outShapes.push(newShape);
        }
    }
}
function $48898afe56067714$var$divideRect(rectShape, count, outShapes) {
    var width = rectShape.width;
    var height = rectShape.height;
    var isHorizontalRow = width > height;
    var grids = $48898afe56067714$var$getDividingGrids([
        width,
        height
    ], isHorizontalRow ? 0 : 1, count);
    var rowSizeDim = isHorizontalRow ? 'width' : 'height';
    var columnSizeDim = isHorizontalRow ? 'height' : 'width';
    var rowDim = isHorizontalRow ? 'x' : 'y';
    var columnDim = isHorizontalRow ? 'y' : 'x';
    var rowSize = rectShape[rowSizeDim] / grids.length;
    for(var row = 0; row < grids.length; row++){
        var columnSize = rectShape[columnSizeDim] / grids[row];
        for(var column = 0; column < grids[row]; column++){
            var newShape = {};
            newShape[rowDim] = row * rowSize;
            newShape[columnDim] = column * columnSize;
            newShape[rowSizeDim] = rowSize;
            newShape[columnSizeDim] = columnSize;
            newShape.x += rectShape.x;
            newShape.y += rectShape.y;
            outShapes.push(newShape);
        }
    }
}
function $48898afe56067714$var$crossProduct2d(x1, y1, x2, y2) {
    return x1 * y2 - x2 * y1;
}
function $48898afe56067714$var$lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
    var mx = a2x - a1x;
    var my = a2y - a1y;
    var nx = b2x - b1x;
    var ny = b2y - b1y;
    var nmCrossProduct = $48898afe56067714$var$crossProduct2d(nx, ny, mx, my);
    if (Math.abs(nmCrossProduct) < 1e-6) return null;
    var b1a1x = a1x - b1x;
    var b1a1y = a1y - b1y;
    var p = $48898afe56067714$var$crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
    if (p < 0 || p > 1) return null;
    return new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)(p * mx + a1x, p * my + a1y);
}
function $48898afe56067714$var$projPtOnLine(pt, lineA, lineB) {
    var dir = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
    (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub(dir, lineB, lineA);
    dir.normalize();
    var dir2 = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
    (0, $1a833abf0e5915e2$export$2e2bcd8739ae039).sub(dir2, pt, lineA);
    var len = dir2.dot(dir);
    return len;
}
function $48898afe56067714$var$addToPoly(poly, pt) {
    var last = poly[poly.length - 1];
    if (last && last[0] === pt[0] && last[1] === pt[1]) return;
    poly.push(pt);
}
function $48898afe56067714$var$splitPolygonByLine(points, lineA, lineB) {
    var len = points.length;
    var intersections = [];
    for(var i = 0; i < len; i++){
        var p0 = points[i];
        var p1 = points[(i + 1) % len];
        var intersectionPt = $48898afe56067714$var$lineLineIntersect(p0[0], p0[1], p1[0], p1[1], lineA.x, lineA.y, lineB.x, lineB.y);
        if (intersectionPt) intersections.push({
            projPt: $48898afe56067714$var$projPtOnLine(intersectionPt, lineA, lineB),
            pt: intersectionPt,
            idx: i
        });
    }
    if (intersections.length < 2) return [
        {
            points: points
        },
        {
            points: points
        }
    ];
    intersections.sort(function(a, b) {
        return a.projPt - b.projPt;
    });
    var splitPt0 = intersections[0];
    var splitPt1 = intersections[intersections.length - 1];
    if (splitPt1.idx < splitPt0.idx) {
        var tmp = splitPt0;
        splitPt0 = splitPt1;
        splitPt1 = tmp;
    }
    var splitPt0Arr = [
        splitPt0.pt.x,
        splitPt0.pt.y
    ];
    var splitPt1Arr = [
        splitPt1.pt.x,
        splitPt1.pt.y
    ];
    var newPolyA = [
        splitPt0Arr
    ];
    var newPolyB = [
        splitPt1Arr
    ];
    for(var i = splitPt0.idx + 1; i <= splitPt1.idx; i++)$48898afe56067714$var$addToPoly(newPolyA, points[i].slice());
    $48898afe56067714$var$addToPoly(newPolyA, splitPt1Arr);
    $48898afe56067714$var$addToPoly(newPolyA, splitPt0Arr);
    for(var i = splitPt1.idx + 1; i <= splitPt0.idx + len; i++)$48898afe56067714$var$addToPoly(newPolyB, points[i % len].slice());
    $48898afe56067714$var$addToPoly(newPolyB, splitPt0Arr);
    $48898afe56067714$var$addToPoly(newPolyB, splitPt1Arr);
    return [
        {
            points: newPolyA
        },
        {
            points: newPolyB
        }
    ];
}
function $48898afe56067714$var$binaryDividePolygon(polygonShape) {
    var points = polygonShape.points;
    var min = [];
    var max = [];
    (0, $9757a65ec1dd85b5$export$188c3cd07b4129dd)(points, min, max);
    var boundingRect = new (0, $020465b49a1dd45f$export$2e2bcd8739ae039)(min[0], min[1], max[0] - min[0], max[1] - min[1]);
    var width = boundingRect.width;
    var height = boundingRect.height;
    var x = boundingRect.x;
    var y = boundingRect.y;
    var pt0 = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
    var pt1 = new (0, $1a833abf0e5915e2$export$2e2bcd8739ae039)();
    if (width > height) {
        pt0.x = pt1.x = x + width / 2;
        pt0.y = y;
        pt1.y = y + height;
    } else {
        pt0.y = pt1.y = y + height / 2;
        pt0.x = x;
        pt1.x = x + width;
    }
    return $48898afe56067714$var$splitPolygonByLine(points, pt0, pt1);
}
function $48898afe56067714$var$binaryDivideRecursive(divider, shape, count, out) {
    if (count === 1) out.push(shape);
    else {
        var mid = Math.floor(count / 2);
        var sub = divider(shape);
        $48898afe56067714$var$binaryDivideRecursive(divider, sub[0], mid, out);
        $48898afe56067714$var$binaryDivideRecursive(divider, sub[1], count - mid, out);
    }
    return out;
}
function $48898afe56067714$export$9cd59f9826255e47(path, count) {
    var paths = [];
    for(var i = 0; i < count; i++)paths.push((0, $f444b8fb72be0619$export$18711d956bf1c3eb)(path));
    return paths;
}
function $48898afe56067714$var$copyPathProps(source, target) {
    target.setStyle(source.style);
    target.z = source.z;
    target.z2 = source.z2;
    target.zlevel = source.zlevel;
}
function $48898afe56067714$var$polygonConvert(points) {
    var out = [];
    for(var i = 0; i < points.length;)out.push([
        points[i++],
        points[i++]
    ]);
    return out;
}
function $48898afe56067714$export$65980d18b75784e2(path, count) {
    var outShapes = [];
    var shape = path.shape;
    var OutShapeCtor;
    switch(path.type){
        case 'rect':
            $48898afe56067714$var$divideRect(shape, count, outShapes);
            OutShapeCtor = (0, $37476269d425e3f6$export$2e2bcd8739ae039);
            break;
        case 'sector':
            $48898afe56067714$var$divideSector(shape, count, outShapes);
            OutShapeCtor = (0, $5fa26352e0605e60$export$2e2bcd8739ae039);
            break;
        case 'circle':
            $48898afe56067714$var$divideSector({
                r0: 0,
                r: shape.r,
                startAngle: 0,
                endAngle: Math.PI * 2,
                cx: shape.cx,
                cy: shape.cy
            }, count, outShapes);
            OutShapeCtor = (0, $5fa26352e0605e60$export$2e2bcd8739ae039);
            break;
        default:
            var m = path.getComputedTransform();
            var scale = m ? Math.sqrt(Math.max(m[0] * m[0] + m[1] * m[1], m[2] * m[2] + m[3] * m[3])) : 1;
            var polygons = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)((0, $14783103db5619f6$export$163f4950160f2337)(path.getUpdatedPathProxy(), scale), function(poly) {
                return $48898afe56067714$var$polygonConvert(poly);
            });
            var polygonCount = polygons.length;
            if (polygonCount === 0) $48898afe56067714$var$binaryDivideRecursive($48898afe56067714$var$binaryDividePolygon, {
                points: polygons[0]
            }, count, outShapes);
            else if (polygonCount === count) for(var i = 0; i < polygonCount; i++)outShapes.push({
                points: polygons[i]
            });
            else {
                var totalArea_1 = 0;
                var items = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(polygons, function(poly) {
                    var min = [];
                    var max = [];
                    (0, $9757a65ec1dd85b5$export$188c3cd07b4129dd)(poly, min, max);
                    var area = (max[1] - min[1]) * (max[0] - min[0]);
                    totalArea_1 += area;
                    return {
                        poly: poly,
                        area: area
                    };
                });
                items.sort(function(a, b) {
                    return b.area - a.area;
                });
                var left = count;
                for(var i = 0; i < polygonCount; i++){
                    var item = items[i];
                    if (left <= 0) break;
                    var selfCount = i === polygonCount - 1 ? left : Math.ceil(item.area / totalArea_1 * count);
                    if (selfCount < 0) continue;
                    $48898afe56067714$var$binaryDivideRecursive($48898afe56067714$var$binaryDividePolygon, {
                        points: item.poly
                    }, selfCount, outShapes);
                    left -= selfCount;
                }
            }
            OutShapeCtor = (0, $399011f87accd5da$export$2e2bcd8739ae039);
            break;
    }
    if (!OutShapeCtor) return $48898afe56067714$export$9cd59f9826255e47(path, count);
    var out = [];
    for(var i = 0; i < outShapes.length; i++){
        var subPath = new OutShapeCtor();
        subPath.setShape(outShapes[i]);
        $48898afe56067714$var$copyPathProps(path, subPath);
        out.push(subPath);
    }
    return out;
}



function $2b443e6b54f03b98$var$alignSubpath(subpath1, subpath2) {
    var len1 = subpath1.length;
    var len2 = subpath2.length;
    if (len1 === len2) return [
        subpath1,
        subpath2
    ];
    var tmpSegX = [];
    var tmpSegY = [];
    var shorterPath = len1 < len2 ? subpath1 : subpath2;
    var shorterLen = Math.min(len1, len2);
    var diff = Math.abs(len2 - len1) / 6;
    var shorterBezierCount = (shorterLen - 2) / 6;
    var eachCurveSubDivCount = Math.ceil(diff / shorterBezierCount) + 1;
    var newSubpath = [
        shorterPath[0],
        shorterPath[1]
    ];
    var remained = diff;
    for(var i = 2; i < shorterLen;){
        var x0 = shorterPath[i - 2];
        var y0 = shorterPath[i - 1];
        var x1 = shorterPath[i++];
        var y1 = shorterPath[i++];
        var x2 = shorterPath[i++];
        var y2 = shorterPath[i++];
        var x3 = shorterPath[i++];
        var y3 = shorterPath[i++];
        if (remained <= 0) {
            newSubpath.push(x1, y1, x2, y2, x3, y3);
            continue;
        }
        var actualSubDivCount = Math.min(remained, eachCurveSubDivCount - 1) + 1;
        for(var k = 1; k <= actualSubDivCount; k++){
            var p = k / actualSubDivCount;
            (0, $eea9463646207a7b$export$a2ee23a0567039da)(x0, x1, x2, x3, p, tmpSegX);
            (0, $eea9463646207a7b$export$a2ee23a0567039da)(y0, y1, y2, y3, p, tmpSegY);
            x0 = tmpSegX[3];
            y0 = tmpSegY[3];
            newSubpath.push(tmpSegX[1], tmpSegY[1], tmpSegX[2], tmpSegY[2], x0, y0);
            x1 = tmpSegX[5];
            y1 = tmpSegY[5];
            x2 = tmpSegX[6];
            y2 = tmpSegY[6];
        }
        remained -= actualSubDivCount - 1;
    }
    return shorterPath === subpath1 ? [
        newSubpath,
        subpath2
    ] : [
        subpath1,
        newSubpath
    ];
}
function $2b443e6b54f03b98$var$createSubpath(lastSubpathSubpath, otherSubpath) {
    var len = lastSubpathSubpath.length;
    var lastX = lastSubpathSubpath[len - 2];
    var lastY = lastSubpathSubpath[len - 1];
    var newSubpath = [];
    for(var i = 0; i < otherSubpath.length;){
        newSubpath[i++] = lastX;
        newSubpath[i++] = lastY;
    }
    return newSubpath;
}
function $2b443e6b54f03b98$export$d7b853a0ab412a07(array1, array2) {
    var _a;
    var lastSubpath1;
    var lastSubpath2;
    var newArray1 = [];
    var newArray2 = [];
    for(var i = 0; i < Math.max(array1.length, array2.length); i++){
        var subpath1 = array1[i];
        var subpath2 = array2[i];
        var newSubpath1 = void 0;
        var newSubpath2 = void 0;
        if (!subpath1) {
            newSubpath1 = $2b443e6b54f03b98$var$createSubpath(lastSubpath1 || subpath2, subpath2);
            newSubpath2 = subpath2;
        } else if (!subpath2) {
            newSubpath2 = $2b443e6b54f03b98$var$createSubpath(lastSubpath2 || subpath1, subpath1);
            newSubpath1 = subpath1;
        } else {
            _a = $2b443e6b54f03b98$var$alignSubpath(subpath1, subpath2), newSubpath1 = _a[0], newSubpath2 = _a[1];
            lastSubpath1 = newSubpath1;
            lastSubpath2 = newSubpath2;
        }
        newArray1.push(newSubpath1);
        newArray2.push(newSubpath2);
    }
    return [
        newArray1,
        newArray2
    ];
}
function $2b443e6b54f03b98$export$e2a20c553f6c85ce(array) {
    var signedArea = 0;
    var cx = 0;
    var cy = 0;
    var len = array.length;
    for(var i = 0, j = len - 2; i < len; j = i, i += 2){
        var x0 = array[j];
        var y0 = array[j + 1];
        var x1 = array[i];
        var y1 = array[i + 1];
        var a = x0 * y1 - x1 * y0;
        signedArea += a;
        cx += (x0 + x1) * a;
        cy += (y0 + y1) * a;
    }
    if (signedArea === 0) return [
        array[0] || 0,
        array[1] || 0
    ];
    return [
        cx / signedArea / 3,
        cy / signedArea / 3,
        signedArea
    ];
}
function $2b443e6b54f03b98$var$findBestRingOffset(fromSubBeziers, toSubBeziers, fromCp, toCp) {
    var bezierCount = (fromSubBeziers.length - 2) / 6;
    var bestScore = Infinity;
    var bestOffset = 0;
    var len = fromSubBeziers.length;
    var len2 = len - 2;
    for(var offset = 0; offset < bezierCount; offset++){
        var cursorOffset = offset * 6;
        var score = 0;
        for(var k = 0; k < len; k += 2){
            var idx = k === 0 ? cursorOffset : (cursorOffset + k - 2) % len2 + 2;
            var x0 = fromSubBeziers[idx] - fromCp[0];
            var y0 = fromSubBeziers[idx + 1] - fromCp[1];
            var x1 = toSubBeziers[k] - toCp[0];
            var y1 = toSubBeziers[k + 1] - toCp[1];
            var dx = x1 - x0;
            var dy = y1 - y0;
            score += dx * dx + dy * dy;
        }
        if (score < bestScore) {
            bestScore = score;
            bestOffset = offset;
        }
    }
    return bestOffset;
}
function $2b443e6b54f03b98$var$reverse(array) {
    var newArr = [];
    var len = array.length;
    for(var i = 0; i < len; i += 2){
        newArr[i] = array[len - i - 2];
        newArr[i + 1] = array[len - i - 1];
    }
    return newArr;
}
function $2b443e6b54f03b98$var$findBestMorphingRotation(fromArr, toArr, searchAngleIteration, searchAngleRange) {
    var result = [];
    var fromNeedsReverse;
    for(var i = 0; i < fromArr.length; i++){
        var fromSubpathBezier = fromArr[i];
        var toSubpathBezier = toArr[i];
        var fromCp = $2b443e6b54f03b98$export$e2a20c553f6c85ce(fromSubpathBezier);
        var toCp = $2b443e6b54f03b98$export$e2a20c553f6c85ce(toSubpathBezier);
        if (fromNeedsReverse == null) fromNeedsReverse = fromCp[2] < 0 !== toCp[2] < 0;
        var newFromSubpathBezier = [];
        var newToSubpathBezier = [];
        var bestAngle = 0;
        var bestScore = Infinity;
        var tmpArr = [];
        var len = fromSubpathBezier.length;
        if (fromNeedsReverse) fromSubpathBezier = $2b443e6b54f03b98$var$reverse(fromSubpathBezier);
        var offset = $2b443e6b54f03b98$var$findBestRingOffset(fromSubpathBezier, toSubpathBezier, fromCp, toCp) * 6;
        var len2 = len - 2;
        for(var k = 0; k < len2; k += 2){
            var idx = (offset + k) % len2 + 2;
            newFromSubpathBezier[k + 2] = fromSubpathBezier[idx] - fromCp[0];
            newFromSubpathBezier[k + 3] = fromSubpathBezier[idx + 1] - fromCp[1];
        }
        newFromSubpathBezier[0] = fromSubpathBezier[offset] - fromCp[0];
        newFromSubpathBezier[1] = fromSubpathBezier[offset + 1] - fromCp[1];
        if (searchAngleIteration > 0) {
            var step = searchAngleRange / searchAngleIteration;
            for(var angle = -searchAngleRange / 2; angle <= searchAngleRange / 2; angle += step){
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                var score = 0;
                for(var k = 0; k < fromSubpathBezier.length; k += 2){
                    var x0 = newFromSubpathBezier[k];
                    var y0 = newFromSubpathBezier[k + 1];
                    var x1 = toSubpathBezier[k] - toCp[0];
                    var y1 = toSubpathBezier[k + 1] - toCp[1];
                    var newX1 = x1 * ca - y1 * sa;
                    var newY1 = x1 * sa + y1 * ca;
                    tmpArr[k] = newX1;
                    tmpArr[k + 1] = newY1;
                    var dx = newX1 - x0;
                    var dy = newY1 - y0;
                    score += dx * dx + dy * dy;
                }
                if (score < bestScore) {
                    bestScore = score;
                    bestAngle = angle;
                    for(var m = 0; m < tmpArr.length; m++)newToSubpathBezier[m] = tmpArr[m];
                }
            }
        } else for(var i_1 = 0; i_1 < len; i_1 += 2){
            newToSubpathBezier[i_1] = toSubpathBezier[i_1] - toCp[0];
            newToSubpathBezier[i_1 + 1] = toSubpathBezier[i_1 + 1] - toCp[1];
        }
        result.push({
            from: newFromSubpathBezier,
            to: newToSubpathBezier,
            fromCp: fromCp,
            toCp: toCp,
            rotation: -bestAngle
        });
    }
    return result;
}
function $2b443e6b54f03b98$export$f9f720a01590a46f(path) {
    return path.__isCombineMorphing;
}
function $2b443e6b54f03b98$export$ddee3124b756354f(el) {
    return el.__morphT >= 0;
}
var $2b443e6b54f03b98$var$SAVED_METHOD_PREFIX = '__mOriginal_';
function $2b443e6b54f03b98$var$saveAndModifyMethod(obj, methodName, modifiers) {
    var savedMethodName = $2b443e6b54f03b98$var$SAVED_METHOD_PREFIX + methodName;
    var originalMethod = obj[savedMethodName] || obj[methodName];
    if (!obj[savedMethodName]) obj[savedMethodName] = obj[methodName];
    var replace = modifiers.replace;
    var after = modifiers.after;
    var before = modifiers.before;
    obj[methodName] = function() {
        var args = arguments;
        var res;
        before && before.apply(this, args);
        if (replace) res = replace.apply(this, args);
        else res = originalMethod.apply(this, args);
        after && after.apply(this, args);
        return res;
    };
}
function $2b443e6b54f03b98$var$restoreMethod(obj, methodName) {
    var savedMethodName = $2b443e6b54f03b98$var$SAVED_METHOD_PREFIX + methodName;
    if (obj[savedMethodName]) {
        obj[methodName] = obj[savedMethodName];
        obj[savedMethodName] = null;
    }
}
function $2b443e6b54f03b98$var$applyTransformOnBeziers(bezierCurves, mm) {
    for(var i = 0; i < bezierCurves.length; i++){
        var subBeziers = bezierCurves[i];
        for(var k = 0; k < subBeziers.length;){
            var x = subBeziers[k];
            var y = subBeziers[k + 1];
            subBeziers[k++] = mm[0] * x + mm[2] * y + mm[4];
            subBeziers[k++] = mm[1] * x + mm[3] * y + mm[5];
        }
    }
}
function $2b443e6b54f03b98$var$prepareMorphPath(fromPath, toPath) {
    var fromPathProxy = fromPath.getUpdatedPathProxy();
    var toPathProxy = toPath.getUpdatedPathProxy();
    var _a = $2b443e6b54f03b98$export$d7b853a0ab412a07((0, $14783103db5619f6$export$fbc91cffd4bdf629)(fromPathProxy), (0, $14783103db5619f6$export$fbc91cffd4bdf629)(toPathProxy)), fromBezierCurves = _a[0], toBezierCurves = _a[1];
    var fromPathTransform = fromPath.getComputedTransform();
    var toPathTransform = toPath.getComputedTransform();
    function updateIdentityTransform() {
        this.transform = null;
    }
    fromPathTransform && $2b443e6b54f03b98$var$applyTransformOnBeziers(fromBezierCurves, fromPathTransform);
    toPathTransform && $2b443e6b54f03b98$var$applyTransformOnBeziers(toBezierCurves, toPathTransform);
    $2b443e6b54f03b98$var$saveAndModifyMethod(toPath, 'updateTransform', {
        replace: updateIdentityTransform
    });
    toPath.transform = null;
    var morphingData = $2b443e6b54f03b98$var$findBestMorphingRotation(fromBezierCurves, toBezierCurves, 10, Math.PI);
    var tmpArr = [];
    $2b443e6b54f03b98$var$saveAndModifyMethod(toPath, 'buildPath', {
        replace: function(path) {
            var t = toPath.__morphT;
            var onet = 1 - t;
            var newCp = [];
            for(var i = 0; i < morphingData.length; i++){
                var item = morphingData[i];
                var from = item.from;
                var to = item.to;
                var angle = item.rotation * t;
                var fromCp = item.fromCp;
                var toCp = item.toCp;
                var sa = Math.sin(angle);
                var ca = Math.cos(angle);
                (0, $3dde7d051fe20daa$export$3a89f8d6f6bf6c9f)(newCp, fromCp, toCp, t);
                for(var m = 0; m < from.length; m += 2){
                    var x0_1 = from[m];
                    var y0_1 = from[m + 1];
                    var x1 = to[m];
                    var y1 = to[m + 1];
                    var x = x0_1 * onet + x1 * t;
                    var y = y0_1 * onet + y1 * t;
                    tmpArr[m] = x * ca - y * sa + newCp[0];
                    tmpArr[m + 1] = x * sa + y * ca + newCp[1];
                }
                var x0 = tmpArr[0];
                var y0 = tmpArr[1];
                path.moveTo(x0, y0);
                for(var m = 2; m < from.length;){
                    var x1 = tmpArr[m++];
                    var y1 = tmpArr[m++];
                    var x2 = tmpArr[m++];
                    var y2 = tmpArr[m++];
                    var x3 = tmpArr[m++];
                    var y3 = tmpArr[m++];
                    if (x0 === x1 && y0 === y1 && x2 === x3 && y2 === y3) path.lineTo(x3, y3);
                    else path.bezierCurveTo(x1, y1, x2, y2, x3, y3);
                    x0 = x3;
                    y0 = y3;
                }
            }
        }
    });
}
function $2b443e6b54f03b98$export$7174e282c1c7df1c(fromPath, toPath, animationOpts) {
    if (!fromPath || !toPath) return toPath;
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    $2b443e6b54f03b98$var$prepareMorphPath(fromPath, toPath);
    toPath.__morphT = 0;
    function restoreToPath() {
        $2b443e6b54f03b98$var$restoreMethod(toPath, 'buildPath');
        $2b443e6b54f03b98$var$restoreMethod(toPath, 'updateTransform');
        toPath.__morphT = -1;
        toPath.createPathProxy();
        toPath.dirtyShape();
    }
    toPath.animateTo({
        __morphT: 1
    }, (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
        during: function(p) {
            toPath.dirtyShape();
            oldDuring && oldDuring(p);
        },
        done: function() {
            restoreToPath();
            oldDone && oldDone();
        }
    }, animationOpts));
    return toPath;
}
function $2b443e6b54f03b98$var$hilbert(x, y, minX, minY, maxX, maxY) {
    var bits = 16;
    x = maxX === minX ? 0 : Math.round(32767 * (x - minX) / (maxX - minX));
    y = maxY === minY ? 0 : Math.round(32767 * (y - minY) / (maxY - minY));
    var d = 0;
    var tmp;
    for(var s = (1 << bits) / 2; s > 0; s /= 2){
        var rx = 0;
        var ry = 0;
        if ((x & s) > 0) rx = 1;
        if ((y & s) > 0) ry = 1;
        d += s * s * (3 * rx ^ ry);
        if (ry === 0) {
            if (rx === 1) {
                x = s - 1 - x;
                y = s - 1 - y;
            }
            tmp = x;
            x = y;
            y = tmp;
        }
    }
    return d;
}
function $2b443e6b54f03b98$var$sortPaths(pathList) {
    var xMin = Infinity;
    var yMin = Infinity;
    var xMax = -Infinity;
    var yMax = -Infinity;
    var cps = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(pathList, function(path) {
        var rect = path.getBoundingRect();
        var m = path.getComputedTransform();
        var x = rect.x + rect.width / 2 + (m ? m[4] : 0);
        var y = rect.y + rect.height / 2 + (m ? m[5] : 0);
        xMin = Math.min(x, xMin);
        yMin = Math.min(y, yMin);
        xMax = Math.max(x, xMax);
        yMax = Math.max(y, yMax);
        return [
            x,
            y
        ];
    });
    var items = (0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(cps, function(cp, idx) {
        return {
            cp: cp,
            z: $2b443e6b54f03b98$var$hilbert(cp[0], cp[1], xMin, yMin, xMax, yMax),
            path: pathList[idx]
        };
    });
    return items.sort(function(a, b) {
        return a.z - b.z;
    }).map(function(item) {
        return item.path;
    });
}
function $2b443e6b54f03b98$var$defaultDividePath(param) {
    return (0, $48898afe56067714$export$65980d18b75784e2)(param.path, param.count);
}
function $2b443e6b54f03b98$var$createEmptyReturn() {
    return {
        fromIndividuals: [],
        toIndividuals: [],
        count: 0
    };
}
function $2b443e6b54f03b98$export$57d3bac3565fd555(fromList, toPath, animationOpts) {
    var fromPathList = [];
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2b443e6b54f03b98$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    addFromPath(fromList);
    var separateCount = fromPathList.length;
    if (!separateCount) return $2b443e6b54f03b98$var$createEmptyReturn();
    var dividePath = animationOpts.dividePath || $2b443e6b54f03b98$var$defaultDividePath;
    var toSubPathList = dividePath({
        path: toPath,
        count: separateCount
    });
    if (toSubPathList.length !== separateCount) {
        console.error('Invalid morphing: unmatched splitted path');
        return $2b443e6b54f03b98$var$createEmptyReturn();
    }
    fromPathList = $2b443e6b54f03b98$var$sortPaths(fromPathList);
    toSubPathList = $2b443e6b54f03b98$var$sortPaths(toSubPathList);
    var oldDone = animationOpts.done;
    var oldDuring = animationOpts.during;
    var individualDelay = animationOpts.individualDelay;
    var identityTransform = new (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039)();
    for(var i = 0; i < separateCount; i++){
        var from = fromPathList[i];
        var to = toSubPathList[i];
        to.parent = toPath;
        to.copyTransform(identityTransform);
        if (!individualDelay) $2b443e6b54f03b98$var$prepareMorphPath(from, to);
    }
    toPath.__isCombineMorphing = true;
    toPath.childrenRef = function() {
        return toSubPathList;
    };
    function addToSubPathListToZr(zr) {
        for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].addSelfToZr(zr);
    }
    $2b443e6b54f03b98$var$saveAndModifyMethod(toPath, 'addSelfToZr', {
        after: function(zr) {
            addToSubPathListToZr(zr);
        }
    });
    $2b443e6b54f03b98$var$saveAndModifyMethod(toPath, 'removeSelfFromZr', {
        after: function(zr) {
            for(var i = 0; i < toSubPathList.length; i++)toSubPathList[i].removeSelfFromZr(zr);
        }
    });
    function restoreToPath() {
        toPath.__isCombineMorphing = false;
        toPath.__morphT = -1;
        toPath.childrenRef = null;
        $2b443e6b54f03b98$var$restoreMethod(toPath, 'addSelfToZr');
        $2b443e6b54f03b98$var$restoreMethod(toPath, 'removeSelfFromZr');
    }
    var toLen = toSubPathList.length;
    if (individualDelay) {
        var animating_1 = toLen;
        var eachDone = function() {
            animating_1--;
            if (animating_1 === 0) {
                restoreToPath();
                oldDone && oldDone();
            }
        };
        for(var i = 0; i < toLen; i++){
            var indivdualAnimationOpts = individualDelay ? (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
                delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toSubPathList[i]),
                done: eachDone
            }, animationOpts) : animationOpts;
            $2b443e6b54f03b98$export$7174e282c1c7df1c(fromPathList[i], toSubPathList[i], indivdualAnimationOpts);
        }
    } else {
        toPath.__morphT = 0;
        toPath.animateTo({
            __morphT: 1
        }, (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
            during: function(p) {
                for(var i = 0; i < toLen; i++){
                    var child = toSubPathList[i];
                    child.__morphT = toPath.__morphT;
                    child.dirtyShape();
                }
                oldDuring && oldDuring(p);
            },
            done: function() {
                restoreToPath();
                for(var i = 0; i < fromList.length; i++)$2b443e6b54f03b98$var$restoreMethod(fromList[i], 'updateTransform');
                oldDone && oldDone();
            }
        }, animationOpts));
    }
    if (toPath.__zr) addToSubPathListToZr(toPath.__zr);
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toSubPathList,
        count: toLen
    };
}
function $2b443e6b54f03b98$export$b6ed198024fe6db8(fromPath, toPathList, animationOpts) {
    var toLen = toPathList.length;
    var fromPathList = [];
    var dividePath = animationOpts.dividePath || $2b443e6b54f03b98$var$defaultDividePath;
    function addFromPath(fromList) {
        for(var i = 0; i < fromList.length; i++){
            var from = fromList[i];
            if ($2b443e6b54f03b98$export$f9f720a01590a46f(from)) addFromPath(from.childrenRef());
            else if (from instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039)) fromPathList.push(from);
        }
    }
    if ($2b443e6b54f03b98$export$f9f720a01590a46f(fromPath)) {
        addFromPath(fromPath.childrenRef());
        var fromLen = fromPathList.length;
        if (fromLen < toLen) {
            var k = 0;
            for(var i = fromLen; i < toLen; i++)fromPathList.push((0, $f444b8fb72be0619$export$18711d956bf1c3eb)(fromPathList[k++ % fromLen]));
        }
        fromPathList.length = toLen;
    } else {
        fromPathList = dividePath({
            path: fromPath,
            count: toLen
        });
        var fromPathTransform = fromPath.getComputedTransform();
        for(var i = 0; i < fromPathList.length; i++)fromPathList[i].setLocalTransform(fromPathTransform);
        if (fromPathList.length !== toLen) {
            console.error('Invalid morphing: unmatched splitted path');
            return $2b443e6b54f03b98$var$createEmptyReturn();
        }
    }
    fromPathList = $2b443e6b54f03b98$var$sortPaths(fromPathList);
    toPathList = $2b443e6b54f03b98$var$sortPaths(toPathList);
    var individualDelay = animationOpts.individualDelay;
    for(var i = 0; i < toLen; i++){
        var indivdualAnimationOpts = individualDelay ? (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
            delay: (animationOpts.delay || 0) + individualDelay(i, toLen, fromPathList[i], toPathList[i])
        }, animationOpts) : animationOpts;
        $2b443e6b54f03b98$export$7174e282c1c7df1c(fromPathList[i], toPathList[i], indivdualAnimationOpts);
    }
    return {
        fromIndividuals: fromPathList,
        toIndividuals: toPathList,
        count: toPathList.length
    };
}






function $f63db70a051731ce$var$isMultiple(elements) {
    return (0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(elements[0]);
}
function $f63db70a051731ce$var$prepareMorphBatches(one, many) {
    var batches = [];
    var batchCount = one.length;
    for(var i = 0; i < batchCount; i++)batches.push({
        one: one[i],
        many: []
    });
    for(var i = 0; i < many.length; i++){
        var len = many[i].length;
        var k = void 0;
        for(k = 0; k < len; k++)batches[k % batchCount].many.push(many[i][k]);
    }
    var off = 0;
    // If one has more paths than each one of many. average them.
    for(var i = batchCount - 1; i >= 0; i--)if (!batches[i].many.length) {
        var moveFrom = batches[off].many;
        if (moveFrom.length <= 1) {
            // Not enough
            // Start from the first one.
            if (off) off = 0;
            else return batches;
        }
        var len = moveFrom.length;
        var mid = Math.ceil(len / 2);
        batches[i].many = moveFrom.slice(mid, len);
        batches[off].many = moveFrom.slice(0, mid);
        off++;
    }
    return batches;
}
var $f63db70a051731ce$var$pathDividers = {
    clone: function(params) {
        var ret = [];
        // Fitting the alpha
        var approxOpacity = 1 - Math.pow(1 - params.path.style.opacity, 1 / params.count);
        for(var i = 0; i < params.count; i++){
            var cloned = (0, $f444b8fb72be0619$export$18711d956bf1c3eb)(params.path);
            cloned.setStyle('opacity', approxOpacity);
            ret.push(cloned);
        }
        return ret;
    },
    // Use the default divider
    split: null
};
function $f63db70a051731ce$export$c6ab3ab2bfe1ec39(from, to, divideShape, seriesModel, dataIndex, animateOtherProps) {
    if (!from.length || !to.length) return;
    var updateAnimationCfg = (0, $b40111164617dd60$export$5cc7add7ab591d0a)('update', seriesModel, dataIndex);
    if (!(updateAnimationCfg && updateAnimationCfg.duration > 0)) return;
    var animationDelay = seriesModel.getModel('universalTransition').get('delay');
    var animationCfg = Object.assign({
        // Need to setToFinal so the further calculation based on the style can be correct.
        // Like emphasis color.
        setToFinal: true
    }, updateAnimationCfg);
    var many;
    var one;
    if ($f63db70a051731ce$var$isMultiple(from)) {
        // manyToOne
        many = from;
        one = to;
    }
    if ($f63db70a051731ce$var$isMultiple(to)) {
        // oneToMany
        many = to;
        one = from;
    }
    function morphOneBatch(batch, fromIsMany, animateIndex, animateCount, forceManyOne) {
        var batchMany = batch.many;
        var batchOne = batch.one;
        if (batchMany.length === 1 && !forceManyOne) {
            // Is one to one
            var batchFrom = fromIsMany ? batchMany[0] : batchOne;
            var batchTo = fromIsMany ? batchOne : batchMany[0];
            if ((0, $2b443e6b54f03b98$export$f9f720a01590a46f)(batchFrom)) // Keep doing combine animation.
            morphOneBatch({
                many: [
                    batchFrom
                ],
                one: batchTo
            }, true, animateIndex, animateCount, true);
            else {
                var individualAnimationCfg = animationDelay ? (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
                    delay: animationDelay(animateIndex, animateCount)
                }, animationCfg) : animationCfg;
                (0, $2b443e6b54f03b98$export$7174e282c1c7df1c)(batchFrom, batchTo, individualAnimationCfg);
                animateOtherProps(batchFrom, batchTo, batchFrom, batchTo, individualAnimationCfg);
            }
        } else {
            var separateAnimationCfg = (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
                dividePath: $f63db70a051731ce$var$pathDividers[divideShape],
                individualDelay: animationDelay && function(idx, count, fromPath, toPath) {
                    return animationDelay(idx + animateIndex, animateCount);
                }
            }, animationCfg);
            var _a = fromIsMany ? (0, $2b443e6b54f03b98$export$57d3bac3565fd555)(batchMany, batchOne, separateAnimationCfg) : (0, $2b443e6b54f03b98$export$b6ed198024fe6db8)(batchOne, batchMany, separateAnimationCfg), fromIndividuals = _a.fromIndividuals, toIndividuals = _a.toIndividuals;
            var count = fromIndividuals.length;
            for(var k = 0; k < count; k++){
                var individualAnimationCfg = animationDelay ? (0, $1b239fc9d3a2f8ae$export$ebe90cb607ad99e)({
                    delay: animationDelay(k, count)
                }, animationCfg) : animationCfg;
                animateOtherProps(fromIndividuals[k], toIndividuals[k], fromIsMany ? batchMany[k] : batch.one, fromIsMany ? batch.one : batchMany[k], individualAnimationCfg);
            }
        }
    }
    var fromIsMany = many ? many === from : from.length > to.length;
    var morphBatches = many ? $f63db70a051731ce$var$prepareMorphBatches(one, many) : $f63db70a051731ce$var$prepareMorphBatches(fromIsMany ? to : from, [
        fromIsMany ? from : to
    ]);
    var animateCount = 0;
    for(var i = 0; i < morphBatches.length; i++)animateCount += morphBatches[i].many.length;
    var animateIndex = 0;
    for(var i = 0; i < morphBatches.length; i++){
        morphOneBatch(morphBatches[i], fromIsMany, animateIndex, animateCount);
        animateIndex += morphBatches[i].many.length;
    }
}
function $f63db70a051731ce$export$ad61593d7c3fa814(elements) {
    if (!elements) return [];
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(elements)) {
        var pathList_1 = [];
        for(var i = 0; i < elements.length; i++)pathList_1.push($f63db70a051731ce$export$ad61593d7c3fa814(elements[i]));
        return pathList_1;
    }
    var pathList = [];
    elements.traverse(function(el) {
        if (el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039) && !el.disableMorphing && !el.invisible && !el.ignore) pathList.push(el);
    });
    return pathList;
}









var $77866047d8cbc3a8$var$DATA_COUNT_THRESHOLD = 1e4;
var $77866047d8cbc3a8$var$TRANSITION_NONE = 0;
var $77866047d8cbc3a8$var$TRANSITION_P2C = 1;
var $77866047d8cbc3a8$var$TRANSITION_C2P = 2;
var $77866047d8cbc3a8$var$getUniversalTransitionGlobalStore = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $77866047d8cbc3a8$var$getDimension(data, visualDimension) {
    var dimensions = data.dimensions;
    for(var i = 0; i < dimensions.length; i++){
        var dimInfo = data.getDimensionInfo(dimensions[i]);
        if (dimInfo && dimInfo.otherDims[visualDimension] === 0) return dimensions[i];
    }
}
// get value by dimension. (only get value of itemGroupId or childGroupId, so convert it to string)
function $77866047d8cbc3a8$var$getValueByDimension(data, dataIndex, dimension) {
    var dimInfo = data.getDimensionInfo(dimension);
    var dimOrdinalMeta = dimInfo && dimInfo.ordinalMeta;
    if (dimInfo) {
        var value = data.get(dimInfo.name, dataIndex);
        if (dimOrdinalMeta) return dimOrdinalMeta.categories[value] || value + '';
        return value + '';
    }
}
function $77866047d8cbc3a8$var$getGroupId(data, dataIndex, dataGroupId, isChild) {
    // try to get groupId from encode
    var visualDimension = isChild ? 'itemChildGroupId' : 'itemGroupId';
    var groupIdDim = $77866047d8cbc3a8$var$getDimension(data, visualDimension);
    if (groupIdDim) {
        var groupId = $77866047d8cbc3a8$var$getValueByDimension(data, dataIndex, groupIdDim);
        return groupId;
    }
    // try to get groupId from raw data item
    var rawDataItem = data.getRawDataItem(dataIndex);
    var property = isChild ? 'childGroupId' : 'groupId';
    if (rawDataItem && rawDataItem[property]) return rawDataItem[property] + '';
    // fallback
    if (isChild) return;
    // try to use series.dataGroupId as groupId, otherwise use dataItem's id as groupId
    return dataGroupId || data.getId(dataIndex);
}
// flatten all data items from different serieses into one arrary
function $77866047d8cbc3a8$var$flattenDataDiffItems(list) {
    var items = [];
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(list, function(seriesInfo) {
        var data = seriesInfo.data;
        var dataGroupId = seriesInfo.dataGroupId;
        if (data.count() > $77866047d8cbc3a8$var$DATA_COUNT_THRESHOLD) return;
        var indices = data.getIndices();
        for(var dataIndex = 0; dataIndex < indices.length; dataIndex++)items.push({
            data: data,
            groupId: $77866047d8cbc3a8$var$getGroupId(data, dataIndex, dataGroupId, false),
            childGroupId: $77866047d8cbc3a8$var$getGroupId(data, dataIndex, dataGroupId, true),
            divide: seriesInfo.divide,
            dataIndex: dataIndex
        });
    });
    return items;
}
function $77866047d8cbc3a8$var$fadeInElement(newEl, newSeries, newIndex) {
    newEl.traverse(function(el) {
        if (el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039)) // TODO use fade in animation for target element.
        (0, $b40111164617dd60$export$a121566aadcfe021)(el, {
            style: {
                opacity: 0
            }
        }, newSeries, {
            dataIndex: newIndex,
            isFrom: true
        });
    });
}
function $77866047d8cbc3a8$var$removeEl(el) {
    if (el.parent) {
        // Bake parent transform to element.
        // So it can still have proper transform to transition after it's removed.
        var computedTransform = el.getComputedTransform();
        el.setLocalTransform(computedTransform);
        el.parent.remove(el);
    }
}
function $77866047d8cbc3a8$var$stopAnimation(el) {
    el.stopAnimation();
    if (el.isGroup) el.traverse(function(child) {
        child.stopAnimation();
    });
}
function $77866047d8cbc3a8$var$animateElementStyles(el, dataIndex, seriesModel) {
    var animationConfig = (0, $b40111164617dd60$export$5cc7add7ab591d0a)('update', seriesModel, dataIndex);
    animationConfig && el.traverse(function(child) {
        if (child instanceof (0, $cfd8540aca1ca40f$export$2e2bcd8739ae039)) {
            var oldStyle = (0, $b40111164617dd60$export$ccb1f1e4d2fa86ac)(child);
            if (oldStyle) child.animateFrom({
                style: oldStyle
            }, animationConfig);
        }
    });
}
function $77866047d8cbc3a8$var$isAllIdSame(oldDiffItems, newDiffItems) {
    var len = oldDiffItems.length;
    if (len !== newDiffItems.length) return false;
    for(var i = 0; i < len; i++){
        var oldItem = oldDiffItems[i];
        var newItem = newDiffItems[i];
        if (oldItem.data.getId(oldItem.dataIndex) !== newItem.data.getId(newItem.dataIndex)) return false;
    }
    return true;
}
function $77866047d8cbc3a8$var$transitionBetween(oldList, newList, api) {
    var oldDiffItems = $77866047d8cbc3a8$var$flattenDataDiffItems(oldList);
    var newDiffItems = $77866047d8cbc3a8$var$flattenDataDiffItems(newList);
    function updateMorphingPathProps(from, to, rawFrom, rawTo, animationCfg) {
        if (rawFrom || from) to.animateFrom({
            style: rawFrom && rawFrom !== from ? (0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)((0, $1b239fc9d3a2f8ae$export$8b58be045bf06082)({}, rawFrom.style), from.style) : from.style
        }, animationCfg);
    }
    var hasMorphAnimation = false;
    /**
   * With groupId and childGroupId, we can build parent-child relationships between dataItems.
   * However, we should mind the parent-child "direction" between old and new options.
   *
   * For example, suppose we have two dataItems from two series.data:
   *
   * dataA: [                          dataB: [
   *   {                                 {
   *     value: 5,                         value: 3,
   *     groupId: 'creatures',             groupId: 'animals',
   *     childGroupId: 'animals'           childGroupId: 'dogs'
   *   },                                },
   *   ...                               ...
   * ]                                 ]
   *
   * where dataA is belong to optionA and dataB is belong to optionB.
   *
   * When we `setOption(optionB)` from optionA, we choose childGroupId of dataItemA and groupId of
   * dataItemB as keys so the two keys are matched (both are 'animals'), then universalTransition
   * will work. This derection is "parent -> child".
   *
   * If we `setOption(optionA)` from optionB, we also choose groupId of dataItemB and childGroupId
   * of dataItemA as keys and universalTransition will work. This derection is "child -> parent".
   *
   * If there is no childGroupId specified, which means no multiLevelDrillDown/Up is needed and no
   * parent-child relationship exists. This direction is "none".
   *
   * So we need to know whether to use groupId or childGroupId as the key when we call the keyGetter
   * functions. Thus, we need to decide the direction first.
   *
   * The rule is:
   *
   * if (all childGroupIds in oldDiffItems and all groupIds in newDiffItems have common value) {
   *   direction = 'parent -> child';
   * } else if (all groupIds in oldDiffItems and all childGroupIds in newDiffItems have common value) {
   *   direction = 'child -> parent';
   * } else {
   *   direction = 'none';
   * }
   */ var direction = $77866047d8cbc3a8$var$TRANSITION_NONE;
    // find all groupIds and childGroupIds from oldDiffItems
    var oldGroupIds = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    var oldChildGroupIds = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    oldDiffItems.forEach(function(item) {
        item.groupId && oldGroupIds.set(item.groupId, true);
        item.childGroupId && oldChildGroupIds.set(item.childGroupId, true);
    });
    // traverse newDiffItems and decide the direction according to the rule
    for(var i = 0; i < newDiffItems.length; i++){
        var newGroupId = newDiffItems[i].groupId;
        if (oldChildGroupIds.get(newGroupId)) {
            direction = $77866047d8cbc3a8$var$TRANSITION_P2C;
            break;
        }
        var newChildGroupId = newDiffItems[i].childGroupId;
        if (newChildGroupId && oldGroupIds.get(newChildGroupId)) {
            direction = $77866047d8cbc3a8$var$TRANSITION_C2P;
            break;
        }
    }
    function createKeyGetter(isOld, onlyGetId) {
        return function(diffItem) {
            var data = diffItem.data;
            var dataIndex = diffItem.dataIndex;
            // TODO if specified dim
            if (onlyGetId) return data.getId(dataIndex);
            if (isOld) return direction === $77866047d8cbc3a8$var$TRANSITION_P2C ? diffItem.childGroupId : diffItem.groupId;
            else return direction === $77866047d8cbc3a8$var$TRANSITION_C2P ? diffItem.childGroupId : diffItem.groupId;
        };
    }
    // Use id if it's very likely to be an one to one animation
    // It's more robust than groupId
    // TODO Check if key dimension is specified.
    var useId = $77866047d8cbc3a8$var$isAllIdSame(oldDiffItems, newDiffItems);
    var isElementStillInChart = {};
    if (!useId) // We may have different diff strategy with basicTransition if we use other dimension as key.
    // If so, we can't simply check if oldEl is same with newEl. We need a map to check if oldEl is still being used in the new chart.
    // We can't use the elements that already being morphed. Let it keep it's original basic transition.
    for(var i = 0; i < newDiffItems.length; i++){
        var newItem = newDiffItems[i];
        var el = newItem.data.getItemGraphicEl(newItem.dataIndex);
        if (el) isElementStillInChart[el.id] = true;
    }
    function updateOneToOne(newIndex, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var newItem = newDiffItems[newIndex];
        var newSeries = newItem.data.hostModel;
        // TODO Mark this elements is morphed and don't morph them anymore
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        var newEl = newItem.data.getItemGraphicEl(newItem.dataIndex);
        // Can't handle same elements.
        if (oldEl === newEl) {
            newEl && $77866047d8cbc3a8$var$animateElementStyles(newEl, newItem.dataIndex, newSeries);
            return;
        }
        if (// We can't use the elements that already being morphed
        oldEl && isElementStillInChart[oldEl.id]) return;
        if (newEl) {
            // TODO: If keep animating the group in case
            // some of the elements don't want to be morphed.
            // TODO Label?
            $77866047d8cbc3a8$var$stopAnimation(newEl);
            if (oldEl) {
                $77866047d8cbc3a8$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $77866047d8cbc3a8$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $f63db70a051731ce$export$c6ab3ab2bfe1ec39)((0, $f63db70a051731ce$export$ad61593d7c3fa814)(oldEl), (0, $f63db70a051731ce$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $77866047d8cbc3a8$var$fadeInElement(newEl, newSeries, newIndex);
        }
    // else keep oldEl leaving animation.
    }
    new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(oldDiffItems, newDiffItems, createKeyGetter(true, useId), createKeyGetter(false, useId), null, 'multiple').update(updateOneToOne).updateManyToOne(function(newIndex, oldIndices) {
        var newItem = newDiffItems[newIndex];
        var newData = newItem.data;
        var newSeries = newData.hostModel;
        var newEl = newData.getItemGraphicEl(newItem.dataIndex);
        var oldElsList = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(oldIndices, function(idx) {
            return oldDiffItems[idx].data.getItemGraphicEl(oldDiffItems[idx].dataIndex);
        }), function(oldEl) {
            return oldEl && oldEl !== newEl && !isElementStillInChart[oldEl.id];
        });
        if (newEl) {
            $77866047d8cbc3a8$var$stopAnimation(newEl);
            if (oldElsList.length) {
                // If old element is doing leaving animation. stop it and remove it immediately.
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(oldElsList, function(oldEl) {
                    $77866047d8cbc3a8$var$stopAnimation(oldEl);
                    $77866047d8cbc3a8$var$removeEl(oldEl);
                });
                hasMorphAnimation = true;
                (0, $f63db70a051731ce$export$c6ab3ab2bfe1ec39)((0, $f63db70a051731ce$export$ad61593d7c3fa814)(oldElsList), (0, $f63db70a051731ce$export$ad61593d7c3fa814)(newEl), newItem.divide, newSeries, newIndex, updateMorphingPathProps);
            } else $77866047d8cbc3a8$var$fadeInElement(newEl, newSeries, newItem.dataIndex);
        }
    // else keep oldEl leaving animation.
    }).updateOneToMany(function(newIndices, oldIndex) {
        var oldItem = oldDiffItems[oldIndex];
        var oldEl = oldItem.data.getItemGraphicEl(oldItem.dataIndex);
        // We can't use the elements that already being morphed
        if (oldEl && isElementStillInChart[oldEl.id]) return;
        var newElsList = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)((0, $1b239fc9d3a2f8ae$export$871de8747c9eaa88)(newIndices, function(idx) {
            return newDiffItems[idx].data.getItemGraphicEl(newDiffItems[idx].dataIndex);
        }), function(el) {
            return el && el !== oldEl;
        });
        var newSeris = newDiffItems[newIndices[0]].data.hostModel;
        if (newElsList.length) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $77866047d8cbc3a8$var$stopAnimation(newEl);
            });
            if (oldEl) {
                $77866047d8cbc3a8$var$stopAnimation(oldEl);
                // If old element is doing leaving animation. stop it and remove it immediately.
                $77866047d8cbc3a8$var$removeEl(oldEl);
                hasMorphAnimation = true;
                (0, $f63db70a051731ce$export$c6ab3ab2bfe1ec39)((0, $f63db70a051731ce$export$ad61593d7c3fa814)(oldEl), (0, $f63db70a051731ce$export$ad61593d7c3fa814)(newElsList), oldItem.divide, // Use divide on old.
                newSeris, newIndices[0], updateMorphingPathProps);
            } else (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newElsList, function(newEl) {
                return $77866047d8cbc3a8$var$fadeInElement(newEl, newSeris, newIndices[0]);
            });
        }
    // else keep oldEl leaving animation.
    }).updateManyToMany(function(newIndices, oldIndices) {
        // If two data are same and both have groupId.
        // Normally they should be diff by id.
        new (0, $74d9e7a7c8458183$export$2e2bcd8739ae039)(oldIndices, newIndices, function(rawIdx) {
            return oldDiffItems[rawIdx].data.getId(oldDiffItems[rawIdx].dataIndex);
        }, function(rawIdx) {
            return newDiffItems[rawIdx].data.getId(newDiffItems[rawIdx].dataIndex);
        }).update(function(newIndex, oldIndex) {
            // Use the original index
            updateOneToOne(newIndices[newIndex], oldIndices[oldIndex]);
        }).execute();
    }).execute();
    if (hasMorphAnimation) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(newList, function(_a) {
        var data = _a.data;
        var seriesModel = data.hostModel;
        var view = seriesModel && api.getViewOfSeriesModel(seriesModel);
        var animationCfg = (0, $b40111164617dd60$export$5cc7add7ab591d0a)('update', seriesModel, 0); // use 0 index.
        if (view && seriesModel.isAnimationEnabled() && animationCfg && animationCfg.duration > 0) view.group.traverse(function(el) {
            if (el instanceof (0, $f9698154c9fcf427$export$2e2bcd8739ae039) && !el.animators.length) // We can't accept there still exists element that has no animation
            // if universalTransition is enabled
            el.animateFrom({
                style: {
                    opacity: 0
                }
            }, animationCfg);
        });
    });
}
function $77866047d8cbc3a8$var$getSeriesTransitionKey(series) {
    var seriesKey = series.getModel('universalTransition').get('seriesKey');
    if (!seriesKey) // Use series id by default.
    return series.id;
    return seriesKey;
}
function $77866047d8cbc3a8$var$convertArraySeriesKeyToString(seriesKey) {
    if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(seriesKey)) // Order independent.
    return seriesKey.sort().join(',');
    return seriesKey;
}
function $77866047d8cbc3a8$var$getDivideShapeFromData(data) {
    if (data.hostModel) return data.hostModel.getModel('universalTransition').get('divideShape');
}
function $77866047d8cbc3a8$var$findTransitionSeriesBatches(globalStore, params) {
    var updateBatches = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    var oldDataMap = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    // Map that only store key in array seriesKey.
    // Which is used to query the old data when transition from one to multiple series.
    var oldDataMapForSplit = (0, $1b239fc9d3a2f8ae$export$55f8aa7ef875b0a4)();
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(globalStore.oldSeries, function(series, idx) {
        var oldDataGroupId = globalStore.oldDataGroupIds[idx];
        var oldData = globalStore.oldData[idx];
        var transitionKey = $77866047d8cbc3a8$var$getSeriesTransitionKey(series);
        var transitionKeyStr = $77866047d8cbc3a8$var$convertArraySeriesKeyToString(transitionKey);
        oldDataMap.set(transitionKeyStr, {
            dataGroupId: oldDataGroupId,
            data: oldData
        });
        if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(transitionKey)) // Same key can't in different array seriesKey.
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(transitionKey, function(key) {
            oldDataMapForSplit.set(key, {
                key: transitionKeyStr,
                dataGroupId: oldDataGroupId,
                data: oldData
            });
        });
    });
    function checkTransitionSeriesKeyDuplicated(transitionKeyStr) {
        if (updateBatches.get(transitionKeyStr)) (0, $4ef07c0eafe44628$export$c106dd0671a0fc2d)("Duplicated seriesKey in universalTransition " + transitionKeyStr);
    }
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
        if (series.isUniversalTransitionEnabled() && series.isAnimationEnabled()) {
            var newDataGroupId = series.get('dataGroupId');
            var newData = series.getData();
            var transitionKey = $77866047d8cbc3a8$var$getSeriesTransitionKey(series);
            var transitionKeyStr = $77866047d8cbc3a8$var$convertArraySeriesKeyToString(transitionKey);
            // Only transition between series with same id.
            var oldData = oldDataMap.get(transitionKeyStr);
            // string transition key is the best match.
            if (oldData) // TODO check if data is same?
            updateBatches.set(transitionKeyStr, {
                oldSeries: [
                    {
                        dataGroupId: oldData.dataGroupId,
                        divide: $77866047d8cbc3a8$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    }
                ],
                newSeries: [
                    {
                        dataGroupId: newDataGroupId,
                        divide: $77866047d8cbc3a8$var$getDivideShapeFromData(newData),
                        data: newData
                    }
                ]
            });
            else // Transition from multiple series.
            // e.g. 'female', 'male' -> ['female', 'male']
            if ((0, $1b239fc9d3a2f8ae$export$43bee75e5e14138e)(transitionKey)) {
                var oldSeries_1 = [];
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(transitionKey, function(key) {
                    var oldData = oldDataMap.get(key);
                    if (oldData.data) oldSeries_1.push({
                        dataGroupId: oldData.dataGroupId,
                        divide: $77866047d8cbc3a8$var$getDivideShapeFromData(oldData.data),
                        data: oldData.data
                    });
                });
                if (oldSeries_1.length) updateBatches.set(transitionKeyStr, {
                    oldSeries: oldSeries_1,
                    newSeries: [
                        {
                            dataGroupId: newDataGroupId,
                            data: newData,
                            divide: $77866047d8cbc3a8$var$getDivideShapeFromData(newData)
                        }
                    ]
                });
            } else {
                // Try transition to multiple series.
                // e.g. ['female', 'male'] -> 'female', 'male'
                var oldData_1 = oldDataMapForSplit.get(transitionKey);
                if (oldData_1) {
                    var batch = updateBatches.get(oldData_1.key);
                    if (!batch) {
                        batch = {
                            oldSeries: [
                                {
                                    dataGroupId: oldData_1.dataGroupId,
                                    data: oldData_1.data,
                                    divide: $77866047d8cbc3a8$var$getDivideShapeFromData(oldData_1.data)
                                }
                            ],
                            newSeries: []
                        };
                        updateBatches.set(oldData_1.key, batch);
                    }
                    batch.newSeries.push({
                        dataGroupId: newDataGroupId,
                        data: newData,
                        divide: $77866047d8cbc3a8$var$getDivideShapeFromData(newData)
                    });
                }
            }
        }
    });
    return updateBatches;
}
function $77866047d8cbc3a8$var$querySeries(series, finder) {
    for(var i = 0; i < series.length; i++){
        var found = finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id;
        if (found) return i;
    }
}
function $77866047d8cbc3a8$var$transitionSeriesFromOpt(transitionOpt, globalStore, params, api) {
    var from = [];
    var to = [];
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(transitionOpt.from), function(finder) {
        var idx = $77866047d8cbc3a8$var$querySeries(globalStore.oldSeries, finder);
        if (idx >= 0) from.push({
            dataGroupId: globalStore.oldDataGroupIds[idx],
            data: globalStore.oldData[idx],
            // TODO can specify divideShape in transition.
            divide: $77866047d8cbc3a8$var$getDivideShapeFromData(globalStore.oldData[idx]),
            groupIdDim: finder.dimension
        });
    });
    (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(transitionOpt.to), function(finder) {
        var idx = $77866047d8cbc3a8$var$querySeries(params.updatedSeries, finder);
        if (idx >= 0) {
            var data = params.updatedSeries[idx].getData();
            to.push({
                dataGroupId: globalStore.oldDataGroupIds[idx],
                data: data,
                divide: $77866047d8cbc3a8$var$getDivideShapeFromData(data),
                groupIdDim: finder.dimension
            });
        }
    });
    if (from.length > 0 && to.length > 0) $77866047d8cbc3a8$var$transitionBetween(from, to, api);
}
function $77866047d8cbc3a8$export$efd07f28fd73e88c(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecMOdel, api, params) {
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(params.seriesTransition), function(transOpt) {
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(transOpt.to), function(finder) {
                var series = params.updatedSeries;
                for(var i = 0; i < series.length; i++)if (finder.seriesIndex != null && finder.seriesIndex === series[i].seriesIndex || finder.seriesId != null && finder.seriesId === series[i].id) series[i][0, $19b580a0cd6e92eb$export$e960441116ae2799] = true;
            });
        });
    });
    registers.registerUpdateLifecycle('series:transition', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var globalStore = $77866047d8cbc3a8$var$getUniversalTransitionGlobalStore(api);
        // TODO multiple to multiple series.
        if (globalStore.oldSeries && params.updatedSeries && params.optionChanged) {
            // TODO transitionOpt was used in an old implementation and can be removed now
            // Use give transition config if its' give;
            var transitionOpt = params.seriesTransition;
            if (transitionOpt) (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)((0, $9ac03c46e8b6e711$export$4f07b212a02c8051)(transitionOpt), function(opt) {
                $77866047d8cbc3a8$var$transitionSeriesFromOpt(opt, globalStore, params, api);
            });
            else {
                // Else guess from series based on transition series key.
                var updateBatches_1 = $77866047d8cbc3a8$var$findTransitionSeriesBatches(globalStore, params);
                (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(updateBatches_1.keys(), function(key) {
                    var batch = updateBatches_1.get(key);
                    $77866047d8cbc3a8$var$transitionBetween(batch.oldSeries, batch.newSeries, api);
                });
            }
            // Reset
            (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(params.updatedSeries, function(series) {
                // Reset;
                if (series[0, $19b580a0cd6e92eb$export$e960441116ae2799]) series[0, $19b580a0cd6e92eb$export$e960441116ae2799] = false;
            });
        }
        // Save all series of current update. Not only the updated one.
        var allSeries = ecModel.getSeries();
        var savedSeries = globalStore.oldSeries = [];
        var savedDataGroupIds = globalStore.oldDataGroupIds = [];
        var savedData = globalStore.oldData = [];
        for(var i = 0; i < allSeries.length; i++){
            var data = allSeries[i].getData();
            // Only save the data that can have transition.
            // Avoid large data costing too much extra memory
            if (data.count() < $77866047d8cbc3a8$var$DATA_COUNT_THRESHOLD) {
                savedSeries.push(allSeries[i]);
                savedDataGroupIds.push(allSeries[i].get('dataGroupId'));
                savedData.push(data);
            }
        }
    });
}

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ 
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ /**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */ /*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/ // TODO: move labels out of viewport.










function $bcb1cd6c8563ced2$var$cloneArr(points) {
    if (points) {
        var newPoints = [];
        for(var i = 0; i < points.length; i++)newPoints.push(points[i].slice());
        return newPoints;
    }
}
function $bcb1cd6c8563ced2$var$prepareLayoutCallbackParams(labelItem, hostEl) {
    var label = labelItem.label;
    var labelLine = hostEl && hostEl.getTextGuideLine();
    return {
        dataIndex: labelItem.dataIndex,
        dataType: labelItem.dataType,
        seriesIndex: labelItem.seriesModel.seriesIndex,
        text: labelItem.label.style.text,
        rect: labelItem.hostRect,
        labelRect: labelItem.rect,
        // x: labelAttr.x,
        // y: labelAttr.y,
        align: label.style.align,
        verticalAlign: label.style.verticalAlign,
        labelLinePoints: $bcb1cd6c8563ced2$var$cloneArr(labelLine && labelLine.shape.points)
    };
}
var $bcb1cd6c8563ced2$var$LABEL_OPTION_TO_STYLE_KEYS = [
    'align',
    'verticalAlign',
    'width',
    'height',
    'fontSize'
];
var $bcb1cd6c8563ced2$var$dummyTransformable = new (0, $cd11a033fc7d29e7$export$2e2bcd8739ae039)();
var $bcb1cd6c8563ced2$var$labelLayoutInnerStore = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
var $bcb1cd6c8563ced2$var$labelLineAnimationStore = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $bcb1cd6c8563ced2$var$extendWithKeys(target, source, keys) {
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (source[key] != null) target[key] = source[key];
    }
}
var $bcb1cd6c8563ced2$var$LABEL_LAYOUT_PROPS = [
    'x',
    'y',
    'rotation'
];
var $bcb1cd6c8563ced2$var$LabelManager = /** @class */ function() {
    function LabelManager() {
        this._labelList = [];
        this._chartViewList = [];
    }
    LabelManager.prototype.clearLabels = function() {
        this._labelList = [];
        this._chartViewList = [];
    };
    /**
   * Add label to manager
   */ LabelManager.prototype._addLabel = function(dataIndex, dataType, seriesModel, label, layoutOption) {
        var labelStyle = label.style;
        var hostEl = label.__hostTarget;
        var textConfig = hostEl.textConfig || {};
        // TODO: If label is in other state.
        var labelTransform = label.getComputedTransform();
        var labelRect = label.getBoundingRect().plain();
        (0, $020465b49a1dd45f$export$2e2bcd8739ae039).applyTransform(labelRect, labelRect, labelTransform);
        if (labelTransform) $bcb1cd6c8563ced2$var$dummyTransformable.setLocalTransform(labelTransform);
        else {
            // Identity transform.
            $bcb1cd6c8563ced2$var$dummyTransformable.x = $bcb1cd6c8563ced2$var$dummyTransformable.y = $bcb1cd6c8563ced2$var$dummyTransformable.rotation = $bcb1cd6c8563ced2$var$dummyTransformable.originX = $bcb1cd6c8563ced2$var$dummyTransformable.originY = 0;
            $bcb1cd6c8563ced2$var$dummyTransformable.scaleX = $bcb1cd6c8563ced2$var$dummyTransformable.scaleY = 1;
        }
        $bcb1cd6c8563ced2$var$dummyTransformable.rotation = (0, $1851ee851ae60f55$export$d44861331f213635)($bcb1cd6c8563ced2$var$dummyTransformable.rotation);
        var host = label.__hostTarget;
        var hostRect;
        if (host) {
            hostRect = host.getBoundingRect().plain();
            var transform = host.getComputedTransform();
            (0, $020465b49a1dd45f$export$2e2bcd8739ae039).applyTransform(hostRect, hostRect, transform);
        }
        var labelGuide = hostRect && host.getTextGuideLine();
        this._labelList.push({
            label: label,
            labelLine: labelGuide,
            seriesModel: seriesModel,
            dataIndex: dataIndex,
            dataType: dataType,
            layoutOption: layoutOption,
            computedLayoutOption: null,
            rect: labelRect,
            hostRect: hostRect,
            // Label with lower priority will be hidden when overlapped
            // Use rect size as default priority
            priority: hostRect ? hostRect.width * hostRect.height : 0,
            // Save default label attributes.
            // For restore if developers want get back to default value in callback.
            defaultAttr: {
                ignore: label.ignore,
                labelGuideIgnore: labelGuide && labelGuide.ignore,
                x: $bcb1cd6c8563ced2$var$dummyTransformable.x,
                y: $bcb1cd6c8563ced2$var$dummyTransformable.y,
                scaleX: $bcb1cd6c8563ced2$var$dummyTransformable.scaleX,
                scaleY: $bcb1cd6c8563ced2$var$dummyTransformable.scaleY,
                rotation: $bcb1cd6c8563ced2$var$dummyTransformable.rotation,
                style: {
                    x: labelStyle.x,
                    y: labelStyle.y,
                    align: labelStyle.align,
                    verticalAlign: labelStyle.verticalAlign,
                    width: labelStyle.width,
                    height: labelStyle.height,
                    fontSize: labelStyle.fontSize
                },
                cursor: label.cursor,
                attachedPos: textConfig.position,
                attachedRot: textConfig.rotation
            }
        });
    };
    LabelManager.prototype.addLabelsOfSeries = function(chartView) {
        var _this = this;
        this._chartViewList.push(chartView);
        var seriesModel = chartView.__model;
        var layoutOption = seriesModel.get('labelLayout');
        /**
     * Ignore layouting if it's not specified anything.
     */ if (!((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(layoutOption) || (0, $1b239fc9d3a2f8ae$export$ed97f33186d4b816)(layoutOption).length)) return;
        chartView.group.traverse(function(child) {
            if (child.ignore) return true; // Stop traverse descendants.
            // Only support label being hosted on graphic elements.
            var textEl = child.getTextContent();
            var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(child);
            // Can only attach the text on the element with dataIndex
            if (textEl && !textEl.disableLabelLayout) _this._addLabel(ecData.dataIndex, ecData.dataType, seriesModel, textEl, layoutOption);
        });
    };
    LabelManager.prototype.updateLayoutConfig = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        function createDragHandler(el, labelLineModel) {
            return function() {
                (0, $8503bd2779bcc1a6$export$cc93ba643cd97d83)(el, labelLineModel);
            };
        }
        for(var i = 0; i < this._labelList.length; i++){
            var labelItem = this._labelList[i];
            var label = labelItem.label;
            var hostEl = label.__hostTarget;
            var defaultLabelAttr = labelItem.defaultAttr;
            var layoutOption = void 0;
            // TODO A global layout option?
            if ((0, $1b239fc9d3a2f8ae$export$f6e2535fb5126e54)(labelItem.layoutOption)) layoutOption = labelItem.layoutOption($bcb1cd6c8563ced2$var$prepareLayoutCallbackParams(labelItem, hostEl));
            else layoutOption = labelItem.layoutOption;
            layoutOption = layoutOption || {};
            labelItem.computedLayoutOption = layoutOption;
            var degreeToRadian = Math.PI / 180;
            // TODO hostEl should always exists.
            // Or label should not have parent because the x, y is all in global space.
            if (hostEl) hostEl.setTextConfig({
                // Force to set local false.
                local: false,
                // Ignore position and rotation config on the host el if x or y is changed.
                position: layoutOption.x != null || layoutOption.y != null ? null : defaultLabelAttr.attachedPos,
                // Ignore rotation config on the host el if rotation is changed.
                rotation: layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.attachedRot,
                offset: [
                    layoutOption.dx || 0,
                    layoutOption.dy || 0
                ]
            });
            var needsUpdateLabelLine = false;
            if (layoutOption.x != null) {
                // TODO width of chart view.
                label.x = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(layoutOption.x, width);
                label.setStyle('x', 0); // Ignore movement in style. TODO: origin.
                needsUpdateLabelLine = true;
            } else {
                label.x = defaultLabelAttr.x;
                label.setStyle('x', defaultLabelAttr.style.x);
            }
            if (layoutOption.y != null) {
                // TODO height of chart view.
                label.y = (0, $9fd90cf3bf18fbcd$export$e8514cb5a5e2b40f)(layoutOption.y, height);
                label.setStyle('y', 0); // Ignore movement in style.
                needsUpdateLabelLine = true;
            } else {
                label.y = defaultLabelAttr.y;
                label.setStyle('y', defaultLabelAttr.style.y);
            }
            if (layoutOption.labelLinePoints) {
                var guideLine = hostEl.getTextGuideLine();
                if (guideLine) {
                    guideLine.setShape({
                        points: layoutOption.labelLinePoints
                    });
                    // Not update
                    needsUpdateLabelLine = false;
                }
            }
            var labelLayoutStore = $bcb1cd6c8563ced2$var$labelLayoutInnerStore(label);
            labelLayoutStore.needsUpdateLabelLine = needsUpdateLabelLine;
            label.rotation = layoutOption.rotate != null ? layoutOption.rotate * degreeToRadian : defaultLabelAttr.rotation;
            label.scaleX = defaultLabelAttr.scaleX;
            label.scaleY = defaultLabelAttr.scaleY;
            for(var k = 0; k < $bcb1cd6c8563ced2$var$LABEL_OPTION_TO_STYLE_KEYS.length; k++){
                var key = $bcb1cd6c8563ced2$var$LABEL_OPTION_TO_STYLE_KEYS[k];
                label.setStyle(key, layoutOption[key] != null ? layoutOption[key] : defaultLabelAttr.style[key]);
            }
            if (layoutOption.draggable) {
                label.draggable = true;
                label.cursor = 'move';
                if (hostEl) {
                    var hostModel = labelItem.seriesModel;
                    if (labelItem.dataIndex != null) {
                        var data = labelItem.seriesModel.getData(labelItem.dataType);
                        hostModel = data.getItemModel(labelItem.dataIndex);
                    }
                    label.on('drag', createDragHandler(hostEl, hostModel.getModel('labelLine')));
                }
            } else {
                // TODO Other drag functions?
                label.off('drag');
                label.cursor = defaultLabelAttr.cursor;
            }
        }
    };
    LabelManager.prototype.layout = function(api) {
        var width = api.getWidth();
        var height = api.getHeight();
        var labelList = (0, $59fb24bbd5ce7072$export$6c403cad1ae3e239)(this._labelList);
        var labelsNeedsAdjustOnX = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftX';
        });
        var labelsNeedsAdjustOnY = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.moveOverlap === 'shiftY';
        });
        (0, $59fb24bbd5ce7072$export$b6b2b07f8ed32bd6)(labelsNeedsAdjustOnX, 0, width);
        (0, $59fb24bbd5ce7072$export$118c25e0932528e4)(labelsNeedsAdjustOnY, 0, height);
        var labelsNeedsHideOverlap = (0, $1b239fc9d3a2f8ae$export$3dea766d36a8935f)(labelList, function(item) {
            return item.layoutOption.hideOverlap;
        });
        (0, $59fb24bbd5ce7072$export$8ce774e164a49410)(labelsNeedsHideOverlap);
    };
    /**
   * Process all labels. Not only labels with layoutOption.
   */ LabelManager.prototype.processLabelsOverall = function() {
        var _this = this;
        (0, $1b239fc9d3a2f8ae$export$79b2f7037acddd43)(this._chartViewList, function(chartView) {
            var seriesModel = chartView.__model;
            var ignoreLabelLineUpdate = chartView.ignoreLabelLineUpdate;
            var animationEnabled = seriesModel.isAnimationEnabled();
            chartView.group.traverse(function(child) {
                if (child.ignore && !child.forceLabelAnimation) return true; // Stop traverse descendants.
                var needsUpdateLabelLine = !ignoreLabelLineUpdate;
                var label = child.getTextContent();
                if (!needsUpdateLabelLine && label) needsUpdateLabelLine = $bcb1cd6c8563ced2$var$labelLayoutInnerStore(label).needsUpdateLabelLine;
                if (needsUpdateLabelLine) _this._updateLabelLine(child, seriesModel);
                if (animationEnabled) _this._animateLabels(child, seriesModel);
            });
        });
    };
    LabelManager.prototype._updateLabelLine = function(el, seriesModel) {
        // Only support label being hosted on graphic elements.
        var textEl = el.getTextContent();
        // Update label line style.
        var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
        var dataIndex = ecData.dataIndex;
        // Only support labelLine on the labels represent data.
        if (textEl && dataIndex != null) {
            var data = seriesModel.getData(ecData.dataType);
            var itemModel = data.getItemModel(dataIndex);
            var defaultStyle = {};
            var visualStyle = data.getItemVisual(dataIndex, 'style');
            if (visualStyle) {
                var visualType = data.getVisual('drawType');
                // Default to be same with main color
                defaultStyle.stroke = visualStyle[visualType];
            }
            var labelLineModel = itemModel.getModel('labelLine');
            (0, $8503bd2779bcc1a6$export$c09e0b0574bdd2dc)(el, (0, $8503bd2779bcc1a6$export$2979fdbf5ebce521)(itemModel), defaultStyle);
            (0, $8503bd2779bcc1a6$export$cc93ba643cd97d83)(el, labelLineModel);
        }
    };
    LabelManager.prototype._animateLabels = function(el, seriesModel) {
        var textEl = el.getTextContent();
        var guideLine = el.getTextGuideLine();
        // Animate
        if (textEl && (el.forceLabelAnimation || !textEl.ignore && !textEl.invisible && !el.disableLabelAnimation && !(0, $b40111164617dd60$export$5b89d4b643713034)(el))) {
            var layoutStore = $bcb1cd6c8563ced2$var$labelLayoutInnerStore(textEl);
            var oldLayout = layoutStore.oldLayout;
            var ecData = (0, $ea063383a2a89e3f$export$b1c39b2bacd1ddc2)(el);
            var dataIndex = ecData.dataIndex;
            var newProps = {
                x: textEl.x,
                y: textEl.y,
                rotation: textEl.rotation
            };
            var data = seriesModel.getData(ecData.dataType);
            if (!oldLayout) {
                textEl.attr(newProps);
                // Disable fade in animation if value animation is enabled.
                if (!(0, $3828198b2f2de836$export$f62786d3261ab0f4)(textEl).valueAnimation) {
                    var oldOpacity = (0, $1b239fc9d3a2f8ae$export$995e01f2f5c9d030)(textEl.style.opacity, 1);
                    // Fade in animation
                    textEl.style.opacity = 0;
                    (0, $b40111164617dd60$export$a121566aadcfe021)(textEl, {
                        style: {
                            opacity: oldOpacity
                        }
                    }, seriesModel, dataIndex);
                }
            } else {
                textEl.attr(oldLayout);
                // Make sure the animation from is in the right status.
                var prevStates = el.prevStates;
                if (prevStates) {
                    if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(prevStates, 'select') >= 0) textEl.attr(layoutStore.oldLayoutSelect);
                    if ((0, $1b239fc9d3a2f8ae$export$305f7d4e9d4624f2)(prevStates, 'emphasis') >= 0) textEl.attr(layoutStore.oldLayoutEmphasis);
                }
                (0, $b40111164617dd60$export$c8dce3c08436e91e)(textEl, newProps, seriesModel, dataIndex);
            }
            layoutStore.oldLayout = newProps;
            if (textEl.states.select) {
                var layoutSelect = layoutStore.oldLayoutSelect = {};
                $bcb1cd6c8563ced2$var$extendWithKeys(layoutSelect, newProps, $bcb1cd6c8563ced2$var$LABEL_LAYOUT_PROPS);
                $bcb1cd6c8563ced2$var$extendWithKeys(layoutSelect, textEl.states.select, $bcb1cd6c8563ced2$var$LABEL_LAYOUT_PROPS);
            }
            if (textEl.states.emphasis) {
                var layoutEmphasis = layoutStore.oldLayoutEmphasis = {};
                $bcb1cd6c8563ced2$var$extendWithKeys(layoutEmphasis, newProps, $bcb1cd6c8563ced2$var$LABEL_LAYOUT_PROPS);
                $bcb1cd6c8563ced2$var$extendWithKeys(layoutEmphasis, textEl.states.emphasis, $bcb1cd6c8563ced2$var$LABEL_LAYOUT_PROPS);
            }
            (0, $3828198b2f2de836$export$dd6101605f5c186)(textEl, dataIndex, data, seriesModel, seriesModel);
        }
        if (guideLine && !guideLine.ignore && !guideLine.invisible) {
            var layoutStore = $bcb1cd6c8563ced2$var$labelLineAnimationStore(guideLine);
            var oldLayout = layoutStore.oldLayout;
            var newLayout = {
                points: guideLine.shape.points
            };
            if (!oldLayout) {
                guideLine.setShape(newLayout);
                guideLine.style.strokePercent = 0;
                (0, $b40111164617dd60$export$a121566aadcfe021)(guideLine, {
                    style: {
                        strokePercent: 1
                    }
                }, seriesModel);
            } else {
                guideLine.attr({
                    shape: oldLayout
                });
                (0, $b40111164617dd60$export$c8dce3c08436e91e)(guideLine, {
                    shape: newLayout
                }, seriesModel);
            }
            layoutStore.oldLayout = newLayout;
        }
    };
    return LabelManager;
}();
var $bcb1cd6c8563ced2$export$2e2bcd8739ae039 = $bcb1cd6c8563ced2$var$LabelManager;


var $2afe152c32887698$var$getLabelManager = (0, $9ac03c46e8b6e711$export$64df9f8d92ae083f)();
function $2afe152c32887698$export$5320d1b3745c02a5(registers) {
    registers.registerUpdateLifecycle('series:beforeupdate', function(ecModel, api, params) {
        // TODO api provide an namespace that can save stuff per instance
        var labelManager = $2afe152c32887698$var$getLabelManager(api).labelManager;
        if (!labelManager) labelManager = $2afe152c32887698$var$getLabelManager(api).labelManager = new (0, $bcb1cd6c8563ced2$export$2e2bcd8739ae039)();
        labelManager.clearLabels();
    });
    registers.registerUpdateLifecycle('series:layoutlabels', function(ecModel, api, params) {
        var labelManager = $2afe152c32887698$var$getLabelManager(api).labelManager;
        params.updatedSeries.forEach(function(series) {
            labelManager.addLabelsOfSeries(api.getViewOfSeriesModel(series));
        });
        labelManager.updateLayoutConfig(api);
        labelManager.layout(api);
        labelManager.processLabelsOverall();
    });
}


// -----------------
// Render engines
// -----------------
// Render via Canvas.
// echarts.init(dom, null, { renderer: 'canvas' })
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)([
    (0, $f3906492a1ee40ef$export$4b3e715f166fdd78)
]);
// Render via SVG.
// echarts.init(dom, null, { renderer: 'svg' })
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)([
    (0, $9017ee1f0b09b5da$export$4b3e715f166fdd78)
]);
// ----------------
// Charts (series)
// ----------------
// All of the series types, for example:
// chart.setOption({
//     series: [{
//         type: 'line' // or 'bar', 'pie', ...
//     }]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)([
    (0, $0b9643135da9a2ad$export$4b3e715f166fdd78),
    (0, $9348aed335468b05$export$4b3e715f166fdd78),
    (0, $6bcac0aff570bb6f$export$4b3e715f166fdd78),
    (0, $e44ec2a6885fa0f6$export$4b3e715f166fdd78),
    (0, $36c64f43e7840177$export$4b3e715f166fdd78),
    (0, $f204e5dbe71b9b2d$export$4b3e715f166fdd78),
    (0, $5c4df8e42fbaca0b$export$4b3e715f166fdd78),
    (0, $f993502a4ef2f084$export$4b3e715f166fdd78),
    (0, $79203a7e07e1ae9b$export$4b3e715f166fdd78),
    (0, $df0f48503277acc3$export$4b3e715f166fdd78),
    (0, $874ce9d907064d71$export$4b3e715f166fdd78),
    (0, $223f95c2d7b7ecc0$export$4b3e715f166fdd78),
    (0, $2194da37bf3543d5$export$4b3e715f166fdd78),
    (0, $91cfb17b659a052e$export$4b3e715f166fdd78),
    (0, $1fdfdcf3811ef3f5$export$4b3e715f166fdd78),
    (0, $d149b2646419b32d$export$4b3e715f166fdd78),
    (0, $d7cc9df24d777511$export$4b3e715f166fdd78),
    (0, $9956c93250b2085d$export$4b3e715f166fdd78),
    (0, $80e5f7bfc017ec2e$export$4b3e715f166fdd78),
    (0, $8c75f7b1260d18e8$export$4b3e715f166fdd78),
    (0, $c27c6ba19daaef65$export$4b3e715f166fdd78),
    (0, $294e9fb89da1901a$export$4b3e715f166fdd78)
]);
// -------------------
// Coordinate systems
// -------------------
// All of the axis modules have been included in the
// coordinate system module below, do not need to
// make extra import.
// `cartesian` coordinate system. For some historical
// reasons, it is named as grid, for example:
// chart.setOption({
//     grid: {...},
//     xAxis: {...},
//     yAxis: {...},
//     series: [{...}]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $3fdff82213dffd8e$export$4b3e715f166fdd78));
// `polar` coordinate system, for example:
// chart.setOption({
//     polar: {...},
//     radiusAxis: {...},
//     angleAxis: {...},
//     series: [{
//         coordinateSystem: 'polar'
//     }]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $e1106d6cbdf816de$export$4b3e715f166fdd78));
// `geo` coordinate system, for example:
// chart.setOption({
//     geo: {...},
//     series: [{
//         coordinateSystem: 'geo'
//     }]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $cd1245ce0ea8a98b$export$4b3e715f166fdd78));
// `singleAxis` coordinate system (notice, it is a coordinate system
// with only one axis, work for chart like theme river), for example:
// chart.setOption({
//     singleAxis: {...}
//     series: [{type: 'themeRiver', ...}]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $ce032a9d547c6354$export$4b3e715f166fdd78));
// `parallel` coordinate system, only work for parallel series, for example:
// chart.setOption({
//     parallel: {...},
//     parallelAxis: [{...}, ...],
//     series: [{
//         type: 'parallel'
//     }]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $fd0deca40be1b110$export$4b3e715f166fdd78));
// `calendar` coordinate system. for example,
// chart.setOption({
//     calendar: {...},
//     series: [{
//         coordinateSystem: 'calendar'
//     }]
// );
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $db3c318a0e442502$export$4b3e715f166fdd78));
// ------------------
// Other components
// ------------------
// `graphic` component, for example:
// chart.setOption({
//     graphic: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $0beabf04143da971$export$4b3e715f166fdd78));
// `toolbox` component, for example:
// chart.setOption({
//     toolbox: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $3b2428b047d0a41e$export$4b3e715f166fdd78));
// `tooltip` component, for example:
// chart.setOption({
//     tooltip: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $e4806f212bc08aa2$export$4b3e715f166fdd78));
// `axisPointer` component, for example:
// chart.setOption({
//     tooltip: {axisPointer: {...}, ...}
// });
// Or
// chart.setOption({
//     axisPointer: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $d1d2b9dcfa505105$export$4b3e715f166fdd78));
// `brush` component, for example:
// chart.setOption({
//     brush: {...}
// });
// Or
// chart.setOption({
//     tooltip: {feature: {brush: {...}}
// })
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $bb2a82545ff8fb99$export$4b3e715f166fdd78));
// `title` component, for example:
// chart.setOption({
//     title: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $97ee0ab49bcb15ab$export$4b3e715f166fdd78));
// `timeline` component, for example:
// chart.setOption({
//     timeline: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $ee7f1f710d7dd7b8$export$4b3e715f166fdd78));
// `markPoint` component, for example:
// chart.setOption({
//     series: [{markPoint: {...}}]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $e20d8037bba036d7$export$4b3e715f166fdd78));
// `markLine` component, for example:
// chart.setOption({
//     series: [{markLine: {...}}]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $b0e14ecf29a061c9$export$4b3e715f166fdd78));
// `markArea` component, for example:
// chart.setOption({
//     series: [{markArea: {...}}]
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $8fd430d032c22a3c$export$4b3e715f166fdd78));
// `legend` component not scrollable. for example:
// chart.setOption({
//     legend: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $8b168421a553d117$export$4b3e715f166fdd78));
// `dataZoom` component including both `dataZoomInside` and `dataZoomSlider`.
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $cb18f41c6f42bb55$export$4b3e715f166fdd78));
// `dataZoom` component providing drag, pinch, wheel behaviors
// inside coordinate system, for example:
// chart.setOption({
//     dataZoom: {type: 'inside'}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $45a375fcae74d72f$export$4b3e715f166fdd78));
// `dataZoom` component providing a slider bar, for example:
// chart.setOption({
//     dataZoom: {type: 'slider'}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $a080a581dea71881$export$4b3e715f166fdd78));
// `visualMap` component including both `visualMapContinuous` and `visualMapPiecewise`.
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $021aa7bfc32c9b88$export$4b3e715f166fdd78));
// `visualMap` component providing continuous bar, for example:
// chart.setOption({
//     visualMap: {type: 'continuous'}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $b1d6b437a4e7085d$export$4b3e715f166fdd78));
// `visualMap` component providing pieces bar, for example:
// chart.setOption({
//     visualMap: {type: 'piecewise'}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $40490ae85c73737a$export$4b3e715f166fdd78));
// `aria` component providing aria, for example:
// chart.setOption({
//     aria: {...}
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $d63f2023c7233bcd$export$4b3e715f166fdd78));
// dataset transform
// chart.setOption({
//     dataset: {
//          transform: []
//     }
// });
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $46259e7bb3fe93d3$export$4b3e715f166fdd78));
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $8ddb7abf1db65807$export$4b3e715f166fdd78));
// universal transition
// chart.setOption({
//     series: {
//         universalTransition: { enabled: true }
//     }
// })
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $77866047d8cbc3a8$export$efd07f28fd73e88c));
// label layout
// chart.setOption({
//     series: {
//         labelLayout: { hideOverlap: true }
//     }
// })
(0, $dcd0766d99a0579a$export$1f96ae73734a86cc)((0, $2afe152c32887698$export$5320d1b3745c02a5));


var $ec7fe9989af67c51$exports = {};
/* @license
Papa Parse
v5.5.3
https://github.com/mholt/PapaParse
License: MIT
*/ ((e, t)=>{
    "function" == typeof define && define.amd ? define([], t) : $ec7fe9989af67c51$exports = t();
})($ec7fe9989af67c51$exports, function r() {
    var n = "undefined" != typeof self ? self : "undefined" != typeof window ? window : void 0 !== n ? n : {};
    var d, s = !n.document && !!n.postMessage, a = n.IS_PAPA_WORKER || !1, o = {}, h = 0, v = {};
    function u(e) {
        this._handle = null, this._finished = !1, this._completed = !1, this._halted = !1, this._input = null, this._baseIndex = 0, this._partialLine = "", this._rowCount = 0, this._start = 0, this._nextChunk = null, this.isFirstChunk = !0, this._completeResults = {
            data: [],
            errors: [],
            meta: {}
        }, (function(e) {
            var t = b(e);
            t.chunkSize = parseInt(t.chunkSize), e.step || e.chunk || (t.chunkSize = null);
            this._handle = new i(t), (this._handle.streamer = this)._config = t;
        }).call(this, e), this.parseChunk = function(t, e) {
            var i = parseInt(this._config.skipFirstNLines) || 0;
            if (this.isFirstChunk && 0 < i) {
                let e = this._config.newline;
                e || (r = this._config.quoteChar || '"', e = this._handle.guessLineEndings(t, r)), t = [
                    ...t.split(e).slice(i)
                ].join(e);
            }
            this.isFirstChunk && U(this._config.beforeFirstChunk) && void 0 !== (r = this._config.beforeFirstChunk(t)) && (t = r), this.isFirstChunk = !1, this._halted = !1;
            var i = this._partialLine + t, r = (this._partialLine = "", this._handle.parse(i, this._baseIndex, !this._finished));
            if (!this._handle.paused() && !this._handle.aborted()) {
                t = r.meta.cursor, i = (this._finished || (this._partialLine = i.substring(t - this._baseIndex), this._baseIndex = t), r && r.data && (this._rowCount += r.data.length), this._finished || this._config.preview && this._rowCount >= this._config.preview);
                if (a) n.postMessage({
                    results: r,
                    workerId: v.WORKER_ID,
                    finished: i
                });
                else if (U(this._config.chunk) && !e) {
                    if (this._config.chunk(r, this._handle), this._handle.paused() || this._handle.aborted()) return void (this._halted = !0);
                    this._completeResults = r = void 0;
                }
                return this._config.step || this._config.chunk || (this._completeResults.data = this._completeResults.data.concat(r.data), this._completeResults.errors = this._completeResults.errors.concat(r.errors), this._completeResults.meta = r.meta), this._completed || !i || !U(this._config.complete) || r && r.meta.aborted || (this._config.complete(this._completeResults, this._input), this._completed = !0), i || r && r.meta.paused || this._nextChunk(), r;
            }
            this._halted = !0;
        }, this._sendError = function(e) {
            U(this._config.error) ? this._config.error(e) : a && this._config.error && n.postMessage({
                workerId: v.WORKER_ID,
                error: e,
                finished: !1
            });
        };
    }
    function f(e) {
        var r;
        (e = e || {}).chunkSize || (e.chunkSize = v.RemoteChunkSize), u.call(this, e), this._nextChunk = s ? function() {
            this._readChunk(), this._chunkLoaded();
        } : function() {
            this._readChunk();
        }, this.stream = function(e) {
            this._input = e, this._nextChunk();
        }, this._readChunk = function() {
            if (this._finished) this._chunkLoaded();
            else {
                if (r = new XMLHttpRequest, this._config.withCredentials && (r.withCredentials = this._config.withCredentials), s || (r.onload = y(this._chunkLoaded, this), r.onerror = y(this._chunkError, this)), r.open(this._config.downloadRequestBody ? "POST" : "GET", this._input, !s), this._config.downloadRequestHeaders) {
                    var e, t = this._config.downloadRequestHeaders;
                    for(e in t)r.setRequestHeader(e, t[e]);
                }
                var i;
                this._config.chunkSize && (i = this._start + this._config.chunkSize - 1, r.setRequestHeader("Range", "bytes=" + this._start + "-" + i));
                try {
                    r.send(this._config.downloadRequestBody);
                } catch (e) {
                    this._chunkError(e.message);
                }
                s && 0 === r.status && this._chunkError();
            }
        }, this._chunkLoaded = function() {
            4 === r.readyState && (r.status < 200 || 400 <= r.status ? this._chunkError() : (this._start += this._config.chunkSize || r.responseText.length, this._finished = !this._config.chunkSize || this._start >= ((e)=>null !== (e = e.getResponseHeader("Content-Range")) ? parseInt(e.substring(e.lastIndexOf("/") + 1)) : -1)(r), this.parseChunk(r.responseText)));
        }, this._chunkError = function(e) {
            e = r.statusText || e;
            this._sendError(new Error(e));
        };
    }
    function l(e) {
        (e = e || {}).chunkSize || (e.chunkSize = v.LocalChunkSize), u.call(this, e);
        var i, r, n = "undefined" != typeof FileReader;
        this.stream = function(e) {
            this._input = e, r = e.slice || e.webkitSlice || e.mozSlice, n ? ((i = new FileReader).onload = y(this._chunkLoaded, this), i.onerror = y(this._chunkError, this)) : i = new FileReaderSync, this._nextChunk();
        }, this._nextChunk = function() {
            this._finished || this._config.preview && !(this._rowCount < this._config.preview) || this._readChunk();
        }, this._readChunk = function() {
            var e = this._input, t = (this._config.chunkSize && (t = Math.min(this._start + this._config.chunkSize, this._input.size), e = r.call(e, this._start, t)), i.readAsText(e, this._config.encoding));
            n || this._chunkLoaded({
                target: {
                    result: t
                }
            });
        }, this._chunkLoaded = function(e) {
            this._start += this._config.chunkSize, this._finished = !this._config.chunkSize || this._start >= this._input.size, this.parseChunk(e.target.result);
        }, this._chunkError = function() {
            this._sendError(i.error);
        };
    }
    function c(e) {
        var i;
        u.call(this, e = e || {}), this.stream = function(e) {
            return i = e, this._nextChunk();
        }, this._nextChunk = function() {
            var e, t;
            if (!this._finished) return e = this._config.chunkSize, i = e ? (t = i.substring(0, e), i.substring(e)) : (t = i, ""), this._finished = !i, this.parseChunk(t);
        };
    }
    function p(e) {
        u.call(this, e = e || {});
        var t = [], i = !0, r = !1;
        this.pause = function() {
            u.prototype.pause.apply(this, arguments), this._input.pause();
        }, this.resume = function() {
            u.prototype.resume.apply(this, arguments), this._input.resume();
        }, this.stream = function(e) {
            this._input = e, this._input.on("data", this._streamData), this._input.on("end", this._streamEnd), this._input.on("error", this._streamError);
        }, this._checkIsFinished = function() {
            r && 1 === t.length && (this._finished = !0);
        }, this._nextChunk = function() {
            this._checkIsFinished(), t.length ? this.parseChunk(t.shift()) : i = !0;
        }, this._streamData = y(function(e) {
            try {
                t.push("string" == typeof e ? e : e.toString(this._config.encoding)), i && (i = !1, this._checkIsFinished(), this.parseChunk(t.shift()));
            } catch (e) {
                this._streamError(e);
            }
        }, this), this._streamError = y(function(e) {
            this._streamCleanUp(), this._sendError(e);
        }, this), this._streamEnd = y(function() {
            this._streamCleanUp(), r = !0, this._streamData("");
        }, this), this._streamCleanUp = y(function() {
            this._input.removeListener("data", this._streamData), this._input.removeListener("end", this._streamEnd), this._input.removeListener("error", this._streamError);
        }, this);
    }
    function i(m) {
        var n, s, a, t, o = Math.pow(2, 53), h = -o, u = /^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/, d = /^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/, i = this, r = 0, f = 0, l = !1, e = !1, c = [], p = {
            data: [],
            errors: [],
            meta: {}
        };
        function y(e) {
            return "greedy" === m.skipEmptyLines ? "" === e.join("").trim() : 1 === e.length && 0 === e[0].length;
        }
        function g() {
            if (p && a && (k("Delimiter", "UndetectableDelimiter", "Unable to auto-detect delimiting character; defaulted to '" + v.DefaultDelimiter + "'"), a = !1), m.skipEmptyLines && (p.data = p.data.filter(function(e) {
                return !y(e);
            })), _()) {
                if (p) {
                    if (Array.isArray(p.data[0])) {
                        for(var e = 0; _() && e < p.data.length; e++)p.data[e].forEach(t);
                        p.data.splice(0, 1);
                    } else p.data.forEach(t);
                }
                function t(e, t) {
                    U(m.transformHeader) && (e = m.transformHeader(e, t)), c.push(e);
                }
            }
            function i(e, t) {
                for(var i = m.header ? {} : [], r = 0; r < e.length; r++){
                    var n = r, s = e[r], s = ((e, t)=>((e)=>(m.dynamicTypingFunction && void 0 === m.dynamicTyping[e] && (m.dynamicTyping[e] = m.dynamicTypingFunction(e)), !0 === (m.dynamicTyping[e] || m.dynamicTyping)))(e) ? "true" === t || "TRUE" === t || "false" !== t && "FALSE" !== t && (((e)=>{
                            if (u.test(e)) {
                                e = parseFloat(e);
                                if (h < e && e < o) return 1;
                            }
                        })(t) ? parseFloat(t) : d.test(t) ? new Date(t) : "" === t ? null : t) : t)(n = m.header ? r >= c.length ? "__parsed_extra" : c[r] : n, s = m.transform ? m.transform(s, n) : s);
                    "__parsed_extra" === n ? (i[n] = i[n] || [], i[n].push(s)) : i[n] = s;
                }
                return m.header && (r > c.length ? k("FieldMismatch", "TooManyFields", "Too many fields: expected " + c.length + " fields but parsed " + r, f + t) : r < c.length && k("FieldMismatch", "TooFewFields", "Too few fields: expected " + c.length + " fields but parsed " + r, f + t)), i;
            }
            var r;
            p && (m.header || m.dynamicTyping || m.transform) && (r = 1, !p.data.length || Array.isArray(p.data[0]) ? (p.data = p.data.map(i), r = p.data.length) : p.data = i(p.data, 0), m.header && p.meta && (p.meta.fields = c), f += r);
        }
        function _() {
            return m.header && 0 === c.length;
        }
        function k(e, t, i, r) {
            e = {
                type: e,
                code: t,
                message: i
            };
            void 0 !== r && (e.row = r), p.errors.push(e);
        }
        U(m.step) && (t = m.step, m.step = function(e) {
            p = e, _() ? g() : (g(), 0 !== p.data.length && (r += e.data.length, m.preview && r > m.preview ? s.abort() : (p.data = p.data[0], t(p, i))));
        }), this.parse = function(e, t, i) {
            var r = m.quoteChar || '"', r = (m.newline || (m.newline = this.guessLineEndings(e, r)), a = !1, m.delimiter ? U(m.delimiter) && (m.delimiter = m.delimiter(e), p.meta.delimiter = m.delimiter) : ((r = ((e, t, i, r, n)=>{
                var s, a, o, h;
                n = n || [
                    ",",
                    "\t",
                    "|",
                    ";",
                    v.RECORD_SEP,
                    v.UNIT_SEP
                ];
                for(var u = 0; u < n.length; u++){
                    for(var d, f = n[u], l = 0, c = 0, p = 0, g = (o = void 0, new E({
                        comments: r,
                        delimiter: f,
                        newline: t,
                        preview: 10
                    }).parse(e)), _ = 0; _ < g.data.length; _++)i && y(g.data[_]) ? p++ : (d = g.data[_].length, c += d, void 0 === o ? o = d : 0 < d && (l += Math.abs(d - o), o = d));
                    0 < g.data.length && (c /= g.data.length - p), (void 0 === a || l <= a) && (void 0 === h || h < c) && 1.99 < c && (a = l, s = f, h = c);
                }
                return {
                    successful: !!(m.delimiter = s),
                    bestDelimiter: s
                };
            })(e, m.newline, m.skipEmptyLines, m.comments, m.delimitersToGuess)).successful ? m.delimiter = r.bestDelimiter : (a = !0, m.delimiter = v.DefaultDelimiter), p.meta.delimiter = m.delimiter), b(m));
            return m.preview && m.header && r.preview++, n = e, s = new E(r), p = s.parse(n, t, i), g(), l ? {
                meta: {
                    paused: !0
                }
            } : p || {
                meta: {
                    paused: !1
                }
            };
        }, this.paused = function() {
            return l;
        }, this.pause = function() {
            l = !0, s.abort(), n = U(m.chunk) ? "" : n.substring(s.getCharIndex());
        }, this.resume = function() {
            i.streamer._halted ? (l = !1, i.streamer.parseChunk(n, !0)) : setTimeout(i.resume, 3);
        }, this.aborted = function() {
            return e;
        }, this.abort = function() {
            e = !0, s.abort(), p.meta.aborted = !0, U(m.complete) && m.complete(p), n = "";
        }, this.guessLineEndings = function(e, t) {
            e = e.substring(0, 1048576);
            var t = new RegExp(P(t) + "([^]*?)" + P(t), "gm"), i = (e = e.replace(t, "")).split("\r"), t = e.split("\n"), e = 1 < t.length && t[0].length < i[0].length;
            if (1 === i.length || e) return "\n";
            for(var r = 0, n = 0; n < i.length; n++)"\n" === i[n][0] && r++;
            return r >= i.length / 2 ? "\r\n" : "\r";
        };
    }
    function P(e) {
        return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }
    function E(C) {
        var S = (C = C || {}).delimiter, O = C.newline, x = C.comments, I = C.step, A = C.preview, T = C.fastMode, D = null, L = !1, F = null == C.quoteChar ? '"' : C.quoteChar, j = F;
        if (void 0 !== C.escapeChar && (j = C.escapeChar), ("string" != typeof S || -1 < v.BAD_DELIMITERS.indexOf(S)) && (S = ","), x === S) throw new Error("Comment character same as delimiter");
        !0 === x ? x = "#" : ("string" != typeof x || -1 < v.BAD_DELIMITERS.indexOf(x)) && (x = !1), "\n" !== O && "\r" !== O && "\r\n" !== O && (O = "\n");
        var z = 0, M = !1;
        this.parse = function(i, t, r) {
            if ("string" != typeof i) throw new Error("Input must be a string");
            var n = i.length, e = S.length, s = O.length, a = x.length, o = U(I), h = [], u = [], d = [], f = z = 0;
            if (!i) return w();
            if (T || !1 !== T && -1 === i.indexOf(F)) {
                for(var l = i.split(O), c = 0; c < l.length; c++){
                    if (d = l[c], z += d.length, c !== l.length - 1) z += O.length;
                    else if (r) return w();
                    if (!x || d.substring(0, a) !== x) {
                        if (o) {
                            if (h = [], k(d.split(S)), R(), M) return w();
                        } else k(d.split(S));
                        if (A && A <= c) return h = h.slice(0, A), w(!0);
                    }
                }
                return w();
            }
            for(var p = i.indexOf(S, z), g = i.indexOf(O, z), _ = new RegExp(P(j) + P(F), "g"), m = i.indexOf(F, z);;)if (i[z] === F) for(m = z, z++;;){
                if (-1 === (m = i.indexOf(F, m + 1))) return r || u.push({
                    type: "Quotes",
                    code: "MissingQuotes",
                    message: "Quoted field unterminated",
                    row: h.length,
                    index: z
                }), E();
                if (m === n - 1) return E(i.substring(z, m).replace(_, F));
                if (F === j && i[m + 1] === j) m++;
                else if (F === j || 0 === m || i[m - 1] !== j) {
                    -1 !== p && p < m + 1 && (p = i.indexOf(S, m + 1));
                    var y = v(-1 === (g = -1 !== g && g < m + 1 ? i.indexOf(O, m + 1) : g) ? p : Math.min(p, g));
                    if (i.substr(m + 1 + y, e) === S) {
                        d.push(i.substring(z, m).replace(_, F)), i[z = m + 1 + y + e] !== F && (m = i.indexOf(F, z)), p = i.indexOf(S, z), g = i.indexOf(O, z);
                        break;
                    }
                    y = v(g);
                    if (i.substring(m + 1 + y, m + 1 + y + s) === O) {
                        if (d.push(i.substring(z, m).replace(_, F)), b(m + 1 + y + s), p = i.indexOf(S, z), m = i.indexOf(F, z), o && (R(), M)) return w();
                        if (A && h.length >= A) return w(!0);
                        break;
                    }
                    u.push({
                        type: "Quotes",
                        code: "InvalidQuotes",
                        message: "Trailing quote on quoted field is malformed",
                        row: h.length,
                        index: z
                    }), m++;
                }
            }
            else if (x && 0 === d.length && i.substring(z, z + a) === x) {
                if (-1 === g) return w();
                z = g + s, g = i.indexOf(O, z), p = i.indexOf(S, z);
            } else if (-1 !== p && (p < g || -1 === g)) d.push(i.substring(z, p)), z = p + e, p = i.indexOf(S, z);
            else {
                if (-1 === g) break;
                if (d.push(i.substring(z, g)), b(g + s), o && (R(), M)) return w();
                if (A && h.length >= A) return w(!0);
            }
            return E();
            function k(e) {
                h.push(e), f = z;
            }
            function v(e) {
                var t = 0;
                return t = -1 !== e && (e = i.substring(m + 1, e)) && "" === e.trim() ? e.length : t;
            }
            function E(e) {
                return r || (void 0 === e && (e = i.substring(z)), d.push(e), z = n, k(d), o && R()), w();
            }
            function b(e) {
                z = e, k(d), d = [], g = i.indexOf(O, z);
            }
            function w(e) {
                if (C.header && !t && h.length && !L) {
                    var s = h[0], a = Object.create(null), o = new Set(s);
                    let n = !1;
                    for(let r = 0; r < s.length; r++){
                        let i = s[r];
                        if (a[i = U(C.transformHeader) ? C.transformHeader(i, r) : i]) {
                            let e, t = a[i];
                            for(; e = i + "_" + t, t++, o.has(e););
                            o.add(e), s[r] = e, a[i]++, n = !0, (D = null === D ? {} : D)[e] = i;
                        } else a[i] = 1, s[r] = i;
                        o.add(i);
                    }
                    n && console.warn("Duplicate headers found and renamed."), L = !0;
                }
                return {
                    data: h,
                    errors: u,
                    meta: {
                        delimiter: S,
                        linebreak: O,
                        aborted: M,
                        truncated: !!e,
                        cursor: f + (t || 0),
                        renamedHeaders: D
                    }
                };
            }
            function R() {
                I(w()), h = [], u = [];
            }
        }, this.abort = function() {
            M = !0;
        }, this.getCharIndex = function() {
            return z;
        };
    }
    function g(e) {
        var t = e.data, i = o[t.workerId], r = !1;
        if (t.error) i.userError(t.error, t.file);
        else if (t.results && t.results.data) {
            var n = {
                abort: function() {
                    r = !0, _(t.workerId, {
                        data: [],
                        errors: [],
                        meta: {
                            aborted: !0
                        }
                    });
                },
                pause: m,
                resume: m
            };
            if (U(i.userStep)) {
                for(var s = 0; s < t.results.data.length && (i.userStep({
                    data: t.results.data[s],
                    errors: t.results.errors,
                    meta: t.results.meta
                }, n), !r); s++);
                delete t.results;
            } else U(i.userChunk) && (i.userChunk(t.results, n, t.file), delete t.results);
        }
        t.finished && !r && _(t.workerId, t.results);
    }
    function _(e, t) {
        var i = o[e];
        U(i.userComplete) && i.userComplete(t), i.terminate(), delete o[e];
    }
    function m() {
        throw new Error("Not implemented.");
    }
    function b(e) {
        if ("object" != typeof e || null === e) return e;
        var t, i = Array.isArray(e) ? [] : {};
        for(t in e)i[t] = b(e[t]);
        return i;
    }
    function y(e, t) {
        return function() {
            e.apply(t, arguments);
        };
    }
    function U(e) {
        return "function" == typeof e;
    }
    return v.parse = function(e, t) {
        var i = (t = t || {}).dynamicTyping || !1;
        U(i) && (t.dynamicTypingFunction = i, i = {});
        if (t.dynamicTyping = i, t.transform = !!U(t.transform) && t.transform, !t.worker || !v.WORKERS_SUPPORTED) return i = null, v.NODE_STREAM_INPUT, "string" == typeof e ? (e = ((e)=>65279 !== e.charCodeAt(0) ? e : e.slice(1))(e), i = new (t.download ? f : c)(t)) : !0 === e.readable && U(e.read) && U(e.on) ? i = new p(t) : (n.File && e instanceof File || e instanceof Object) && (i = new l(t)), i.stream(e);
        (i = (()=>{
            var e;
            return !!v.WORKERS_SUPPORTED && (e = (()=>{
                var e = n.URL || n.webkitURL || null, t = r.toString();
                return v.BLOB_URL || (v.BLOB_URL = e.createObjectURL(new Blob([
                    "var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ",
                    "(",
                    t,
                    ")();"
                ], {
                    type: "text/javascript"
                })));
            })(), (e = new n.Worker(e)).onmessage = g, e.id = h++, o[e.id] = e);
        })()).userStep = t.step, i.userChunk = t.chunk, i.userComplete = t.complete, i.userError = t.error, t.step = U(t.step), t.chunk = U(t.chunk), t.complete = U(t.complete), t.error = U(t.error), delete t.worker, i.postMessage({
            input: e,
            config: t,
            workerId: i.id
        });
    }, v.unparse = function(e, t) {
        var n = !1, _ = !0, m = ",", y = "\r\n", s = '"', a = s + s, i = !1, r = null, o = !1, h = ((()=>{
            if ("object" == typeof t) {
                if ("string" != typeof t.delimiter || v.BAD_DELIMITERS.filter(function(e) {
                    return -1 !== t.delimiter.indexOf(e);
                }).length || (m = t.delimiter), "boolean" != typeof t.quotes && "function" != typeof t.quotes && !Array.isArray(t.quotes) || (n = t.quotes), "boolean" != typeof t.skipEmptyLines && "string" != typeof t.skipEmptyLines || (i = t.skipEmptyLines), "string" == typeof t.newline && (y = t.newline), "string" == typeof t.quoteChar && (s = t.quoteChar), "boolean" == typeof t.header && (_ = t.header), Array.isArray(t.columns)) {
                    if (0 === t.columns.length) throw new Error("Option columns is empty");
                    r = t.columns;
                }
                void 0 !== t.escapeChar && (a = t.escapeChar + s), t.escapeFormulae instanceof RegExp ? o = t.escapeFormulae : "boolean" == typeof t.escapeFormulae && t.escapeFormulae && (o = /^[=+\-@\t\r].*$/);
            }
        })(), new RegExp(P(s), "g"));
        "string" == typeof e && (e = JSON.parse(e));
        if (Array.isArray(e)) {
            if (!e.length || Array.isArray(e[0])) return u(null, e, i);
            if ("object" == typeof e[0]) return u(r || Object.keys(e[0]), e, i);
        } else if ("object" == typeof e) return "string" == typeof e.data && (e.data = JSON.parse(e.data)), Array.isArray(e.data) && (e.fields || (e.fields = e.meta && e.meta.fields || r), e.fields || (e.fields = Array.isArray(e.data[0]) ? e.fields : "object" == typeof e.data[0] ? Object.keys(e.data[0]) : []), Array.isArray(e.data[0]) || "object" == typeof e.data[0] || (e.data = [
            e.data
        ])), u(e.fields || [], e.data || [], i);
        throw new Error("Unable to serialize unrecognized input");
        function u(e, t, i) {
            var r = "", n = ("string" == typeof e && (e = JSON.parse(e)), "string" == typeof t && (t = JSON.parse(t)), Array.isArray(e) && 0 < e.length), s = !Array.isArray(t[0]);
            if (n && _) {
                for(var a = 0; a < e.length; a++)0 < a && (r += m), r += k(e[a], a);
                0 < t.length && (r += y);
            }
            for(var o = 0; o < t.length; o++){
                var h = (n ? e : t[o]).length, u = !1, d = n ? 0 === Object.keys(t[o]).length : 0 === t[o].length;
                if (i && !n && (u = "greedy" === i ? "" === t[o].join("").trim() : 1 === t[o].length && 0 === t[o][0].length), "greedy" === i && n) {
                    for(var f = [], l = 0; l < h; l++){
                        var c = s ? e[l] : l;
                        f.push(t[o][c]);
                    }
                    u = "" === f.join("").trim();
                }
                if (!u) {
                    for(var p = 0; p < h; p++){
                        0 < p && !d && (r += m);
                        var g = n && s ? e[p] : p;
                        r += k(t[o][g], p);
                    }
                    o < t.length - 1 && (!i || 0 < h && !d) && (r += y);
                }
            }
            return r;
        }
        function k(e, t) {
            var i, r;
            return null == e ? "" : e.constructor === Date ? JSON.stringify(e).slice(1, 25) : (r = !1, o && "string" == typeof e && o.test(e) && (e = "'" + e, r = !0), i = e.toString().replace(h, a), (r = r || !0 === n || "function" == typeof n && n(e, t) || Array.isArray(n) && n[t] || ((e, t)=>{
                for(var i = 0; i < t.length; i++)if (-1 < e.indexOf(t[i])) return !0;
                return !1;
            })(i, v.BAD_DELIMITERS) || -1 < i.indexOf(m) || " " === i.charAt(0) || " " === i.charAt(i.length - 1)) ? s + i + s : i);
        }
    }, v.RECORD_SEP = String.fromCharCode(30), v.UNIT_SEP = String.fromCharCode(31), v.BYTE_ORDER_MARK = "\ufeff", v.BAD_DELIMITERS = [
        "\r",
        "\n",
        '"',
        v.BYTE_ORDER_MARK
    ], v.WORKERS_SUPPORTED = !s && !!n.Worker, v.NODE_STREAM_INPUT = 1, v.LocalChunkSize = 10485760, v.RemoteChunkSize = 5242880, v.DefaultDelimiter = ",", v.Parser = E, v.ParserHandle = i, v.NetworkStreamer = f, v.FileStreamer = l, v.StringStreamer = c, v.ReadableStreamStreamer = p, n.jQuery && ((d = n.jQuery).fn.parse = function(o) {
        var i = o.config || {}, h = [];
        return this.each(function(e) {
            if (!("INPUT" === d(this).prop("tagName").toUpperCase() && "file" === d(this).attr("type").toLowerCase() && n.FileReader) || !this.files || 0 === this.files.length) return !0;
            for(var t = 0; t < this.files.length; t++)h.push({
                file: this.files[t],
                inputElem: this,
                instanceConfig: d.extend({}, i)
            });
        }), e(), this;
        function e() {
            if (0 === h.length) U(o.complete) && o.complete();
            else {
                var e, t, i, r, n = h[0];
                if (U(o.before)) {
                    var s = o.before(n.file, n.inputElem);
                    if ("object" == typeof s) {
                        if ("abort" === s.action) return e = "AbortError", t = n.file, i = n.inputElem, r = s.reason, void (U(o.error) && o.error({
                            name: e
                        }, t, i, r));
                        if ("skip" === s.action) return void u();
                        "object" == typeof s.config && (n.instanceConfig = d.extend(n.instanceConfig, s.config));
                    } else if ("skip" === s) return void u();
                }
                var a = n.instanceConfig.complete;
                n.instanceConfig.complete = function(e) {
                    U(a) && a(e, n.file, n.inputElem), u();
                }, v.parse(n.file, n.instanceConfig);
            }
        }
        function u() {
            h.splice(0, 1), e();
        }
    }), a && (n.onmessage = function(e) {
        e = e.data;
        void 0 === v.WORKER_ID && e && (v.WORKER_ID = e.workerId);
        "string" == typeof e.input ? n.postMessage({
            workerId: v.WORKER_ID,
            results: v.parse(e.input, e.config),
            finished: !0
        }) : (n.File && e.input instanceof File || e.input instanceof Object) && (e = v.parse(e.input, e.config)) && n.postMessage({
            workerId: v.WORKER_ID,
            results: e,
            finished: !0
        });
    }), (f.prototype = Object.create(u.prototype)).constructor = f, (l.prototype = Object.create(u.prototype)).constructor = l, (c.prototype = Object.create(c.prototype)).constructor = c, (p.prototype = Object.create(u.prototype)).constructor = p, v;
});


function $c997a156bd6937f3$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $c997a156bd6937f3$var$id = 0;
function $c997a156bd6937f3$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $c997a156bd6937f3$var$id++ + "_" + name;
}
// We're using a generic because languages have different plural rules.
// eslint-disable-next-line no-use-before-define
function $c997a156bd6937f3$var$insertReplacement(source, rx, replacement) {
    const newParts = [];
    source.forEach((chunk)=>{
        // When the source contains multiple placeholders for interpolation,
        // we should ignore chunks that are not strings, because those
        // can be JSX objects and will be otherwise incorrectly turned into strings.
        // Without this condition we’d get this: [object Object] hello [object Object] my <button>
        if (typeof chunk !== 'string') return newParts.push(chunk);
        return rx[Symbol.split](chunk).forEach((raw, i, list)=>{
            if (raw !== '') newParts.push(raw);
            // Interlace with the `replacement` value
            if (i < list.length - 1) newParts.push(replacement);
        });
    });
    return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param phrase that needs interpolation, with placeholders
 * @param options with values that will be used to replace placeholders
 */ function $c997a156bd6937f3$var$interpolate(phrase, options) {
    const dollarRegex = /\$/g;
    const dollarBillsYall = '$$$$';
    let interpolated = [
        phrase
    ];
    if (options == null) return interpolated;
    for (const arg of Object.keys(options))if (arg !== '_') {
        // Ensure replacement value is escaped to prevent special $-prefixed
        // regex replace tokens. the "$$$$" is needed because each "$" needs to
        // be escaped with "$" itself, and we need two in the resulting output.
        let replacement = options[arg];
        if (typeof replacement === 'string') replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        interpolated = $c997a156bd6937f3$var$insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, 'g'), replacement);
    }
    return interpolated;
}
const $c997a156bd6937f3$var$defaultOnMissingKey = (key)=>{
    throw new Error(`missing string: ${key}`);
};
/**
 * Translates strings with interpolation & pluralization support.
 * Extensible with custom dictionaries and pluralization functions.
 *
 * Borrows heavily from and inspired by Polyglot https://github.com/airbnb/polyglot.js,
 * basically a stripped-down version of it. Differences: pluralization functions are not hardcoded
 * and can be easily added among with dictionaries, nested objects are used for pluralization
 * as opposed to `||||` delimeter
 *
 * Usage example: `translator.translate('files_chosen', {smart_count: 3})`
 */ var $c997a156bd6937f3$var$_onMissingKey = /*#__PURE__*/ $c997a156bd6937f3$var$_classPrivateFieldLooseKey("onMissingKey");
var $c997a156bd6937f3$var$_apply = /*#__PURE__*/ $c997a156bd6937f3$var$_classPrivateFieldLooseKey("apply");
class $c997a156bd6937f3$export$2e2bcd8739ae039 {
    constructor(locales, _temp){
        let { onMissingKey: onMissingKey = $c997a156bd6937f3$var$defaultOnMissingKey } = _temp === void 0 ? {} : _temp;
        Object.defineProperty(this, $c997a156bd6937f3$var$_apply, {
            value: $c997a156bd6937f3$var$_apply2
        });
        Object.defineProperty(this, $c997a156bd6937f3$var$_onMissingKey, {
            writable: true,
            value: void 0
        });
        this.locale = {
            strings: {},
            pluralize (n) {
                if (n === 1) return 0;
                return 1;
            }
        };
        if (Array.isArray(locales)) locales.forEach($c997a156bd6937f3$var$_classPrivateFieldLooseBase(this, $c997a156bd6937f3$var$_apply)[$c997a156bd6937f3$var$_apply], this);
        else $c997a156bd6937f3$var$_classPrivateFieldLooseBase(this, $c997a156bd6937f3$var$_apply)[$c997a156bd6937f3$var$_apply](locales);
        $c997a156bd6937f3$var$_classPrivateFieldLooseBase(this, $c997a156bd6937f3$var$_onMissingKey)[$c997a156bd6937f3$var$_onMissingKey] = onMissingKey;
    }
    /**
   * Public translate method
   *
   * @param key
   * @param options with values that will be used later to replace placeholders in string
   * @returns string translated (and interpolated)
   */ translate(key, options) {
        return this.translateArray(key, options).join('');
    }
    /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @returns The translated and interpolated parts, in order.
   */ translateArray(key, options) {
        let string = this.locale.strings[key];
        if (string == null) {
            $c997a156bd6937f3$var$_classPrivateFieldLooseBase(this, $c997a156bd6937f3$var$_onMissingKey)[$c997a156bd6937f3$var$_onMissingKey](key);
            string = key;
        }
        const hasPluralForms = typeof string === 'object';
        if (hasPluralForms) {
            if (options && typeof options.smart_count !== 'undefined') {
                const plural = this.locale.pluralize(options.smart_count);
                return $c997a156bd6937f3$var$interpolate(string[plural], options);
            }
            throw new Error('Attempted to use a string with plural forms, but no value was given for %{smart_count}');
        }
        if (typeof string !== 'string') throw new Error(`string was not a string`);
        return $c997a156bd6937f3$var$interpolate(string, options);
    }
}
function $c997a156bd6937f3$var$_apply2(locale) {
    if (!(locale != null && locale.strings)) return;
    const prevLocale = this.locale;
    Object.assign(this.locale, {
        strings: {
            ...prevLocale.strings,
            ...locale.strings
        },
        pluralize: locale.pluralize || prevLocale.pluralize
    });
}


var $760bc9a020ea9458$exports = {};
/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/ $760bc9a020ea9458$exports = function createNamespaceEmitter() {
    var emitter = {};
    var _fns = emitter._fns = {};
    /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */ emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) emitAll(event, toEmit, [
            arg1,
            arg2,
            arg3,
            arg4,
            arg5,
            arg6
        ]);
    };
    /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */ emitter.on = function on(event, fn) {
        if (!_fns[event]) _fns[event] = [];
        _fns[event].push(fn);
    };
    /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */ emitter.once = function once(event, fn) {
        function one() {
            fn.apply(this, arguments);
            emitter.off(event, one);
        }
        this.on(event, one);
    };
    /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */ emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
            var fns = this._fns[event];
            var i = 0;
            var l = fns ? fns.length : 0;
            for(i; i < l; i++)if (fns[i] !== fn) keep.push(fns[i]);
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
    };
    function getListeners(e) {
        var out = _fns[e] ? _fns[e] : [];
        var idx = e.indexOf(':');
        var args = idx === -1 ? [
            e
        ] : [
            e.substring(0, idx),
            e.substring(idx + 1)
        ];
        var keys = Object.keys(_fns);
        var i = 0;
        var l = keys.length;
        for(i; i < l; i++){
            var key = keys[i];
            if (key === '*') out = out.concat(_fns[key]);
            if (args.length === 2 && args[0] === key) {
                out = out.concat(_fns[key]);
                break;
            }
        }
        return out;
    }
    function emitAll(e, fns, args) {
        var i = 0;
        var l = fns.length;
        for(i; i < l; i++){
            if (!fns[i]) break;
            fns[i].event = e;
            fns[i].apply(fns[i], args);
        }
    }
    return emitter;
};


let $8e93258aecdd4641$var$urlAlphabet = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
let $8e93258aecdd4641$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = '';
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $8e93258aecdd4641$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = '';
    let i = size;
    while(i--)id += $8e93258aecdd4641$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $011ad752b8925e1c$exports = {};
var $5f4f87c16bc439af$exports = {};
var $a907a279eb9c391c$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $a907a279eb9c391c$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$a907a279eb9c391c$exports = $a907a279eb9c391c$var$isObject;


var $f9363bf9ab3ea737$exports = {};
var $68f320efee199526$exports = {};
var $17534b7afc6b7691$exports = {};
/** Detect free variable `global` from Node.js. */ var $17534b7afc6b7691$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$17534b7afc6b7691$exports = $17534b7afc6b7691$var$freeGlobal;


/** Detect free variable `self`. */ var $68f320efee199526$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $68f320efee199526$var$root = $17534b7afc6b7691$exports || $68f320efee199526$var$freeSelf || Function('return this')();
$68f320efee199526$exports = $68f320efee199526$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $f9363bf9ab3ea737$var$now = function() {
    return $68f320efee199526$exports.Date.now();
};
$f9363bf9ab3ea737$exports = $f9363bf9ab3ea737$var$now;


var $4f16d17886ecab16$exports = {};
var $43c6ca3074827280$exports = {};
var $b9ea4808882332f6$exports = {};
/** Used to match a single whitespace character. */ var $b9ea4808882332f6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $b9ea4808882332f6$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $b9ea4808882332f6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$b9ea4808882332f6$exports = $b9ea4808882332f6$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $43c6ca3074827280$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $43c6ca3074827280$var$baseTrim(string) {
    return string ? string.slice(0, $b9ea4808882332f6$exports(string) + 1).replace($43c6ca3074827280$var$reTrimStart, '') : string;
}
$43c6ca3074827280$exports = $43c6ca3074827280$var$baseTrim;



var $5339777265736955$exports = {};
var $3125d712601865c3$exports = {};
var $e62011c91336a38e$exports = {};

/** Built-in value references. */ var $e62011c91336a38e$var$Symbol = $68f320efee199526$exports.Symbol;
$e62011c91336a38e$exports = $e62011c91336a38e$var$Symbol;


var $4e0e22547af04f15$exports = {};

/** Used for built-in method references. */ var $4e0e22547af04f15$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4e0e22547af04f15$var$hasOwnProperty = $4e0e22547af04f15$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $4e0e22547af04f15$var$nativeObjectToString = $4e0e22547af04f15$var$objectProto.toString;
/** Built-in value references. */ var $4e0e22547af04f15$var$symToStringTag = $e62011c91336a38e$exports ? $e62011c91336a38e$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $4e0e22547af04f15$var$getRawTag(value) {
    var isOwn = $4e0e22547af04f15$var$hasOwnProperty.call(value, $4e0e22547af04f15$var$symToStringTag), tag = value[$4e0e22547af04f15$var$symToStringTag];
    try {
        value[$4e0e22547af04f15$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $4e0e22547af04f15$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$4e0e22547af04f15$var$symToStringTag] = tag;
        else delete value[$4e0e22547af04f15$var$symToStringTag];
    }
    return result;
}
$4e0e22547af04f15$exports = $4e0e22547af04f15$var$getRawTag;


var $a886961d63455237$exports = {};
/** Used for built-in method references. */ var $a886961d63455237$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $a886961d63455237$var$nativeObjectToString = $a886961d63455237$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $a886961d63455237$var$objectToString(value) {
    return $a886961d63455237$var$nativeObjectToString.call(value);
}
$a886961d63455237$exports = $a886961d63455237$var$objectToString;


/** `Object#toString` result references. */ var $3125d712601865c3$var$nullTag = '[object Null]', $3125d712601865c3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $3125d712601865c3$var$symToStringTag = $e62011c91336a38e$exports ? $e62011c91336a38e$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $3125d712601865c3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $3125d712601865c3$var$undefinedTag : $3125d712601865c3$var$nullTag;
    return $3125d712601865c3$var$symToStringTag && $3125d712601865c3$var$symToStringTag in Object(value) ? $4e0e22547af04f15$exports(value) : $a886961d63455237$exports(value);
}
$3125d712601865c3$exports = $3125d712601865c3$var$baseGetTag;


var $211120fa3b9d50b6$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $211120fa3b9d50b6$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$211120fa3b9d50b6$exports = $211120fa3b9d50b6$var$isObjectLike;


/** `Object#toString` result references. */ var $5339777265736955$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $5339777265736955$var$isSymbol(value) {
    return typeof value == 'symbol' || $211120fa3b9d50b6$exports(value) && $3125d712601865c3$exports(value) == $5339777265736955$var$symbolTag;
}
$5339777265736955$exports = $5339777265736955$var$isSymbol;


/** Used as references for various `Number` constants. */ var $4f16d17886ecab16$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $4f16d17886ecab16$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4f16d17886ecab16$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4f16d17886ecab16$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4f16d17886ecab16$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4f16d17886ecab16$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($5339777265736955$exports(value)) return $4f16d17886ecab16$var$NAN;
    if ($a907a279eb9c391c$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $a907a279eb9c391c$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $43c6ca3074827280$exports(value);
    var isBinary = $4f16d17886ecab16$var$reIsBinary.test(value);
    return isBinary || $4f16d17886ecab16$var$reIsOctal.test(value) ? $4f16d17886ecab16$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4f16d17886ecab16$var$reIsBadHex.test(value) ? $4f16d17886ecab16$var$NAN : +value;
}
$4f16d17886ecab16$exports = $4f16d17886ecab16$var$toNumber;


/** Error message constants. */ var $5f4f87c16bc439af$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5f4f87c16bc439af$var$nativeMax = Math.max, $5f4f87c16bc439af$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $5f4f87c16bc439af$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($5f4f87c16bc439af$var$FUNC_ERROR_TEXT);
    wait = $4f16d17886ecab16$exports(wait) || 0;
    if ($a907a279eb9c391c$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $5f4f87c16bc439af$var$nativeMax($4f16d17886ecab16$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $5f4f87c16bc439af$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $f9363bf9ab3ea737$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($f9363bf9ab3ea737$exports());
    }
    function debounced() {
        var time = $f9363bf9ab3ea737$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$5f4f87c16bc439af$exports = $5f4f87c16bc439af$var$debounce;



/** Error message constants. */ var $011ad752b8925e1c$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $011ad752b8925e1c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($011ad752b8925e1c$var$FUNC_ERROR_TEXT);
    if ($a907a279eb9c391c$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $5f4f87c16bc439af$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$011ad752b8925e1c$exports = $011ad752b8925e1c$var$throttle;


function $a467add224e16bf9$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $a467add224e16bf9$var$id = 0;
function $a467add224e16bf9$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $a467add224e16bf9$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $a467add224e16bf9$var$packageJson = {
    "version": "3.2.2"
};
var $a467add224e16bf9$var$_callbacks = /*#__PURE__*/ $a467add224e16bf9$var$_classPrivateFieldLooseKey("callbacks");
var $a467add224e16bf9$var$_publish = /*#__PURE__*/ $a467add224e16bf9$var$_classPrivateFieldLooseKey("publish");
/**
 * Default store that keeps state in a simple object.
 */ class $a467add224e16bf9$var$DefaultStore {
    constructor(){
        Object.defineProperty(this, $a467add224e16bf9$var$_publish, {
            value: $a467add224e16bf9$var$_publish2
        });
        this.state = {};
        Object.defineProperty(this, $a467add224e16bf9$var$_callbacks, {
            writable: true,
            value: new Set()
        });
    }
    getState() {
        return this.state;
    }
    setState(patch) {
        const prevState = {
            ...this.state
        };
        const nextState = {
            ...this.state,
            ...patch
        };
        this.state = nextState;
        $a467add224e16bf9$var$_classPrivateFieldLooseBase(this, $a467add224e16bf9$var$_publish)[$a467add224e16bf9$var$_publish](prevState, nextState, patch);
    }
    subscribe(listener) {
        $a467add224e16bf9$var$_classPrivateFieldLooseBase(this, $a467add224e16bf9$var$_callbacks)[$a467add224e16bf9$var$_callbacks].add(listener);
        return ()=>{
            $a467add224e16bf9$var$_classPrivateFieldLooseBase(this, $a467add224e16bf9$var$_callbacks)[$a467add224e16bf9$var$_callbacks].delete(listener);
        };
    }
}
function $a467add224e16bf9$var$_publish2() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $a467add224e16bf9$var$_classPrivateFieldLooseBase(this, $a467add224e16bf9$var$_callbacks)[$a467add224e16bf9$var$_callbacks].forEach((listener)=>{
        listener(...args);
    });
}
$a467add224e16bf9$var$DefaultStore.VERSION = $a467add224e16bf9$var$packageJson.version;
var $a467add224e16bf9$export$2e2bcd8739ae039 = $a467add224e16bf9$var$DefaultStore;


/**
 * Takes a full filename string and returns an object {name, extension}
 */ function $85bf854dfb6901a1$export$2e2bcd8739ae039(fullFileName) {
    const lastDot = fullFileName.lastIndexOf('.');
    // these count as no extension: "no-dot", "trailing-dot."
    if (lastDot === -1 || lastDot === fullFileName.length - 1) return {
        name: fullFileName,
        extension: undefined
    };
    return {
        name: fullFileName.slice(0, lastDot),
        extension: fullFileName.slice(lastDot + 1)
    };
}


// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
var $b42c14b7b498bf4c$export$2e2bcd8739ae039 = {
    __proto__: null,
    md: 'text/markdown',
    markdown: 'text/markdown',
    mp4: 'video/mp4',
    mp3: 'audio/mp3',
    svg: 'image/svg+xml',
    jpg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    gif: 'image/gif',
    heic: 'image/heic',
    heif: 'image/heif',
    yaml: 'text/yaml',
    yml: 'text/yaml',
    csv: 'text/csv',
    tsv: 'text/tab-separated-values',
    tab: 'text/tab-separated-values',
    avi: 'video/x-msvideo',
    mks: 'video/x-matroska',
    mkv: 'video/x-matroska',
    mov: 'video/quicktime',
    dicom: 'application/dicom',
    doc: 'application/msword',
    docm: 'application/vnd.ms-word.document.macroenabled.12',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    dot: 'application/msword',
    dotm: 'application/vnd.ms-word.template.macroenabled.12',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    xla: 'application/vnd.ms-excel',
    xlam: 'application/vnd.ms-excel.addin.macroenabled.12',
    xlc: 'application/vnd.ms-excel',
    xlf: 'application/x-xliff+xml',
    xlm: 'application/vnd.ms-excel',
    xls: 'application/vnd.ms-excel',
    xlsb: 'application/vnd.ms-excel.sheet.binary.macroenabled.12',
    xlsm: 'application/vnd.ms-excel.sheet.macroenabled.12',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xlt: 'application/vnd.ms-excel',
    xltm: 'application/vnd.ms-excel.template.macroenabled.12',
    xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    xlw: 'application/vnd.ms-excel',
    txt: 'text/plain',
    text: 'text/plain',
    conf: 'text/plain',
    log: 'text/plain',
    pdf: 'application/pdf',
    zip: 'application/zip',
    '7z': 'application/x-7z-compressed',
    rar: 'application/x-rar-compressed',
    tar: 'application/x-tar',
    gz: 'application/gzip',
    dmg: 'application/x-apple-diskimage'
};


function $36e7cd0f6c76118b$export$2e2bcd8739ae039(file) {
    var _getFileNameAndExtens;
    if (file.type) return file.type;
    const fileExtension = file.name ? (_getFileNameAndExtens = (0, $85bf854dfb6901a1$export$2e2bcd8739ae039)(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
    if (fileExtension && fileExtension in (0, $b42c14b7b498bf4c$export$2e2bcd8739ae039)) // else, see if we can map extension to a mime type
    return (0, $b42c14b7b498bf4c$export$2e2bcd8739ae039)[fileExtension];
    // if all fails, fall back to a generic byte stream type
    return 'application/octet-stream';
}




function $89f97f6b4f199a3f$var$encodeCharacter(character) {
    return character.charCodeAt(0).toString(32);
}
function $89f97f6b4f199a3f$var$encodeFilename(name) {
    let suffix = '';
    return name.replace(/[^A-Z0-9]/gi, (character)=>{
        suffix += `-${$89f97f6b4f199a3f$var$encodeCharacter(character)}`;
        return '/';
    }) + suffix;
}
function $89f97f6b4f199a3f$export$2e2bcd8739ae039(file, instanceId) {
    // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
    // is slower! simple string concatenation is fast
    let id = instanceId || 'uppy';
    if (typeof file.name === 'string') id += `-${$89f97f6b4f199a3f$var$encodeFilename(file.name.toLowerCase())}`;
    if (file.type !== undefined) id += `-${file.type}`;
    if (file.meta && typeof file.meta.relativePath === 'string') id += `-${$89f97f6b4f199a3f$var$encodeFilename(file.meta.relativePath.toLowerCase())}`;
    if (file.data.size !== undefined) id += `-${file.data.size}`;
    if (file.data.lastModified !== undefined) id += `-${file.data.lastModified}`;
    return id;
}
// If the provider has a stable, unique ID, then we can use that to identify the file.
// Then we don't have to generate our own ID, and we can add the same file many times if needed (different path)
function $89f97f6b4f199a3f$var$hasFileStableId(file) {
    if (!file.isRemote || !file.remote) return false;
    // These are the providers that it seems like have stable IDs for their files. The other's I haven't checked yet.
    const stableIdProviders = new Set([
        'box',
        'dropbox',
        'drive',
        'facebook',
        'unsplash'
    ]);
    return stableIdProviders.has(file.remote.provider);
}
function $89f97f6b4f199a3f$export$2ff5b23440673856(file, instanceId) {
    if ($89f97f6b4f199a3f$var$hasFileStableId(file)) return file.id;
    const fileType = (0, $36e7cd0f6c76118b$export$2e2bcd8739ae039)(file);
    return $89f97f6b4f199a3f$export$2e2bcd8739ae039({
        ...file,
        type: fileType
    }, instanceId);
}


// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
function $82dd8fafdce0efe0$export$2e2bcd8739ae039(userAgent) {
    // Allow passing in userAgent for tests
    if (userAgent == null && typeof navigator !== 'undefined') // eslint-disable-next-line no-param-reassign
    userAgent = navigator.userAgent;
    // Assume it works because basically everything supports progress events.
    if (!userAgent) return true;
    const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
    if (!m) return true;
    const edgeVersion = m[1];
    const version = edgeVersion.split('.', 2);
    const major = parseInt(version[0], 10);
    const minor = parseInt(version[1], 10);
    // Worked before:
    // Edge 40.15063.0.0
    // Microsoft EdgeHTML 15.15063
    if (major < 15 || major === 15 && minor < 15063) return true;
    // Fixed in:
    // Microsoft EdgeHTML 18.18218
    if (major > 18 || major === 18 && minor >= 18218) return true;
    // other versions don't work.
    return false;
}


function $1e50c190e0dd6818$export$2e2bcd8739ae039(fileType, fileDescriptor) {
    if (fileDescriptor.name) return fileDescriptor.name;
    if (fileType.split('/')[0] === 'image') return `${fileType.split('/')[0]}.${fileType.split('/')[1]}`;
    return 'noname';
}


/* eslint-disable no-console */ /**
 * Adds zero to strings shorter than two characters.
 */ function $bcce701e8cb57d93$var$pad(number) {
    return number < 10 ? `0${number}` : number.toString();
}
function $bcce701e8cb57d93$export$2e2bcd8739ae039() {
    const date = new Date();
    const hours = $bcce701e8cb57d93$var$pad(date.getHours());
    const minutes = $bcce701e8cb57d93$var$pad(date.getMinutes());
    const seconds = $bcce701e8cb57d93$var$pad(date.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
}


// Swallow all logs, except errors.
// default if logger is not set or debug: false
const $89b55000e21c3276$export$51086a57eba987c9 = {
    debug: ()=>{},
    warn: ()=>{},
    error: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return console.error(`[Uppy] [${(0, $bcce701e8cb57d93$export$2e2bcd8739ae039)()}]`, ...args);
    }
};
// Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
const $89b55000e21c3276$export$e6a390ea6399b7d8 = {
    debug: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return console.debug(`[Uppy] [${(0, $bcce701e8cb57d93$export$2e2bcd8739ae039)()}]`, ...args);
    },
    warn: function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return console.warn(`[Uppy] [${(0, $bcce701e8cb57d93$export$2e2bcd8739ae039)()}]`, ...args);
    },
    error: function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return console.error(`[Uppy] [${(0, $bcce701e8cb57d93$export$2e2bcd8739ae039)()}]`, ...args);
    }
};


/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-classes-per-file, class-methods-use-this */ var $9e10288afc1c6b0c$exports = {};
"use strict";
$9e10288afc1c6b0c$exports = function prettierBytes(input) {
    if (typeof input !== 'number' || Number.isNaN(input)) throw new TypeError(`Expected a number, got ${typeof input}`);
    const neg = input < 0;
    let num = Math.abs(input);
    if (neg) num = -num;
    if (num === 0) return '0 B';
    const units = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
    ];
    const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    const value = Number(num / 1024 ** exponent);
    const unit = units[exponent];
    return `${value >= 10 || value % 1 === 0 ? Math.round(value) : value.toFixed(1)} ${unit}`;
};


var $183e2dd8e3bee243$exports = {};
var $11ad6b3a643c7ec8$exports = {};
/* jshint node: true */ 'use strict';
/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/ function $11ad6b3a643c7ec8$var$WildcardMatcher(text, separator) {
    this.text = text = text || '';
    this.hasWild = ~text.indexOf('*');
    this.separator = separator;
    this.parts = text.split(separator);
}
$11ad6b3a643c7ec8$var$WildcardMatcher.prototype.match = function(input) {
    var matches = true;
    var parts = this.parts;
    var ii;
    var partsCount = parts.length;
    var testParts;
    if (typeof input == 'string' || input instanceof String) {
        if (!this.hasWild && this.text != input) matches = false;
        else {
            testParts = (input || '').split(this.separator);
            for(ii = 0; matches && ii < partsCount; ii++){
                if (parts[ii] === '*') continue;
                else if (ii < testParts.length) matches = parts[ii] === testParts[ii];
                else matches = false;
            }
            // If matches, then return the component parts
            matches = matches && testParts;
        }
    } else if (typeof input.splice == 'function') {
        matches = [];
        for(ii = input.length; ii--;)if (this.match(input[ii])) matches[matches.length] = input[ii];
    } else if (typeof input == 'object') {
        matches = {};
        for(var key in input)if (this.match(key)) matches[key] = input[key];
    }
    return matches;
};
$11ad6b3a643c7ec8$exports = function(text, test, separator) {
    var matcher = new $11ad6b3a643c7ec8$var$WildcardMatcher(text, separator || /[\/\.]/);
    if (typeof test != 'undefined') return matcher.match(test);
    return matcher;
};


var $183e2dd8e3bee243$var$reMimePartSplit = /[\/\+\.]/;
/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/ $183e2dd8e3bee243$exports = function(target, pattern) {
    function test(pattern) {
        var result = $11ad6b3a643c7ec8$exports(pattern, target, $183e2dd8e3bee243$var$reMimePartSplit);
        // ensure that we have a valid mime type (should have two parts)
        return result && result.length >= 2;
    }
    return pattern ? test(pattern.split(';')[0]) : test;
};


/**
 * The minimal required properties to be present from UppyFile in order to validate it.
 */ const $bf6cd51ac16577aa$export$ba43bf67f3d48107 = {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: null,
    requiredMetaFields: []
};
class $bf6cd51ac16577aa$export$e4d147272ce048a7 extends Error {
    constructor(message, opts){
        var _opts$isUserFacing;
        super(message);
        this.isRestriction = true;
        this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
        if (opts != null && opts.file) this.file = opts.file; // only some restriction errors are related to a particular file
    }
}
class $bf6cd51ac16577aa$export$c464a380a24dd3b8 {
    constructor(getOpts, getI18n){
        this.getI18n = getI18n;
        this.getOpts = ()=>{
            var _opts$restrictions;
            const opts = getOpts();
            if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) throw new TypeError('`restrictions.allowedFileTypes` must be an array');
            return opts;
        };
    }
    // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
    validateAggregateRestrictions(existingFiles, addingFiles) {
        const { maxTotalFileSize: maxTotalFileSize, maxNumberOfFiles: maxNumberOfFiles } = this.getOpts().restrictions;
        if (maxNumberOfFiles) {
            const nonGhostFiles = existingFiles.filter((f)=>!f.isGhost);
            if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) throw new $bf6cd51ac16577aa$export$e4d147272ce048a7(`${this.getI18n()('youCanOnlyUploadX', {
                smart_count: maxNumberOfFiles
            })}`);
        }
        if (maxTotalFileSize) {
            const totalFilesSize = [
                ...existingFiles,
                ...addingFiles
            ].reduce((total, f)=>{
                var _f$size;
                return total + ((_f$size = f.size) != null ? _f$size : 0);
            }, 0);
            if (totalFilesSize > maxTotalFileSize) throw new $bf6cd51ac16577aa$export$e4d147272ce048a7(this.getI18n()('aggregateExceedsSize', {
                sizeAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($9e10288afc1c6b0c$exports)))(maxTotalFileSize),
                size: (0, (/*@__PURE__*/$parcel$interopDefault($9e10288afc1c6b0c$exports)))(totalFilesSize)
            }));
        }
    }
    validateSingleFile(file) {
        const { maxFileSize: maxFileSize, minFileSize: minFileSize, allowedFileTypes: allowedFileTypes } = this.getOpts().restrictions;
        if (allowedFileTypes) {
            const isCorrectFileType = allowedFileTypes.some((type)=>{
                // check if this is a mime-type
                if (type.includes('/')) {
                    if (!file.type) return false;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($183e2dd8e3bee243$exports)))(file.type.replace(/;.*?$/, ''), type);
                }
                // otherwise this is likely an extension
                if (type[0] === '.' && file.extension) return file.extension.toLowerCase() === type.slice(1).toLowerCase();
                return false;
            });
            if (!isCorrectFileType) {
                const allowedFileTypesString = allowedFileTypes.join(', ');
                throw new $bf6cd51ac16577aa$export$e4d147272ce048a7(this.getI18n()('youCanOnlyUploadFileTypes', {
                    types: allowedFileTypesString
                }), {
                    file: file
                });
            }
        }
        // We can't check maxFileSize if the size is unknown.
        if (maxFileSize && file.size != null && file.size > maxFileSize) throw new $bf6cd51ac16577aa$export$e4d147272ce048a7(this.getI18n()('exceedsSize', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($9e10288afc1c6b0c$exports)))(maxFileSize),
            file: file.name
        }), {
            file: file
        });
        // We can't check minFileSize if the size is unknown.
        if (minFileSize && file.size != null && file.size < minFileSize) throw new $bf6cd51ac16577aa$export$e4d147272ce048a7(this.getI18n()('inferiorSize', {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($9e10288afc1c6b0c$exports)))(minFileSize)
        }), {
            file: file
        });
    }
    validate(existingFiles, addingFiles) {
        addingFiles.forEach((addingFile)=>{
            this.validateSingleFile(addingFile);
        });
        this.validateAggregateRestrictions(existingFiles, addingFiles);
    }
    validateMinNumberOfFiles(files) {
        const { minNumberOfFiles: minNumberOfFiles } = this.getOpts().restrictions;
        if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) throw new $bf6cd51ac16577aa$export$e4d147272ce048a7(this.getI18n()('youHaveToAtLeastSelectX', {
            smart_count: minNumberOfFiles
        }));
    }
    getMissingRequiredMetaFields(file) {
        const error = new $bf6cd51ac16577aa$export$e4d147272ce048a7(this.getI18n()('missingRequiredMetaFieldOnFile', {
            fileName: file.name
        }));
        const { requiredMetaFields: requiredMetaFields } = this.getOpts().restrictions;
        const missingFields = [];
        for (const field of requiredMetaFields)if (!Object.hasOwn(file.meta, field) || file.meta[field] === '') missingFields.push(field);
        return {
            missingFields: missingFields,
            error: error
        };
    }
}


var $cf47bdc0ed946068$export$2e2bcd8739ae039 = {
    strings: {
        addBulkFilesFailed: {
            0: 'Failed to add %{smart_count} file due to an internal error',
            1: 'Failed to add %{smart_count} files due to internal errors'
        },
        youCanOnlyUploadX: {
            0: 'You can only upload %{smart_count} file',
            1: 'You can only upload %{smart_count} files'
        },
        youHaveToAtLeastSelectX: {
            0: 'You have to select at least %{smart_count} file',
            1: 'You have to select at least %{smart_count} files'
        },
        aggregateExceedsSize: 'You selected %{size} of files, but maximum allowed size is %{sizeAllowed}',
        exceedsSize: '%{file} exceeds maximum allowed size of %{size}',
        missingRequiredMetaField: 'Missing required meta fields',
        missingRequiredMetaFieldOnFile: 'Missing required meta fields in %{fileName}',
        inferiorSize: 'This file is smaller than the allowed size of %{size}',
        youCanOnlyUploadFileTypes: 'You can only upload: %{types}',
        noMoreFilesAllowed: 'Cannot add more files',
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: 'Connection with Companion failed',
        authAborted: 'Authentication aborted',
        companionUnauthorizeHint: 'To unauthorize to your %{provider} account, please go to %{url}',
        failedToUpload: 'Failed to upload %{file}',
        noInternetConnection: 'No Internet connection',
        connectedToInternet: 'Connected to the Internet',
        // Strings for remote providers
        noFilesFound: 'You have no files or folders here',
        noSearchResults: 'Unfortunately, there are no results for this search',
        selectX: {
            0: 'Select %{smart_count}',
            1: 'Select %{smart_count}'
        },
        allFilesFromFolderNamed: 'All files from folder %{name}',
        openFolderNamed: 'Open folder %{name}',
        cancel: 'Cancel',
        logOut: 'Log out',
        filter: 'Filter',
        resetFilter: 'Reset filter',
        loading: 'Loading...',
        loadedXFiles: 'Loaded %{numFiles} files',
        authenticateWithTitle: 'Please authenticate with %{pluginName} to select files',
        authenticateWith: 'Connect to %{pluginName}',
        signInWithGoogle: 'Sign in with Google',
        searchImages: 'Search for images',
        enterTextToSearch: 'Enter text to search for images',
        search: 'Search',
        resetSearch: 'Reset search',
        emptyFolderAdded: 'No files were added from empty folder',
        addedNumFiles: 'Added %{numFiles} file(s)',
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: 'Added %{smart_count} file from %{folder}',
            1: 'Added %{smart_count} files from %{folder}'
        },
        additionalRestrictionsFailed: '%{count} additional restrictions were not fulfilled',
        unnamed: 'Unnamed'
    }
};


let $bb94bbccedce200d$var$_Symbol$for, $bb94bbccedce200d$var$_Symbol$for2;
function $bb94bbccedce200d$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $bb94bbccedce200d$var$id = 0;
function $bb94bbccedce200d$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $bb94bbccedce200d$var$id++ + "_" + name;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $bb94bbccedce200d$var$packageJson = {
    "version": "3.13.1"
};
/*
 * UnknownProviderPlugin can be any Companion plugin (such as Google Drive).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `storage`
 * will error in the `Provider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `Provider` class.
 * `Provider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ /*
 * UnknownSearchProviderPlugin can be any search Companion plugin (such as Unsplash).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `title`
 * will error in the `SearchProvider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `SearchProvider` class.
 * `SearchProvider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ // TODO: can we use namespaces in other plugins to populate this?
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// The user facing type for UppyOptions used in uppy.setOptions()
/** @deprecated */ const $bb94bbccedce200d$var$defaultUploadState = {
    totalProgress: 0,
    allowNewUpload: true,
    error: null,
    recoveredState: null
};
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */ var $bb94bbccedce200d$var$_plugins = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("plugins");
var $bb94bbccedce200d$var$_restricter = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("restricter");
var $bb94bbccedce200d$var$_storeUnsubscribe = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("storeUnsubscribe");
var $bb94bbccedce200d$var$_emitter = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("emitter");
var $bb94bbccedce200d$var$_preProcessors = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("preProcessors");
var $bb94bbccedce200d$var$_uploaders = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("uploaders");
var $bb94bbccedce200d$var$_postProcessors = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("postProcessors");
var $bb94bbccedce200d$var$_informAndEmit = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("informAndEmit");
var $bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("checkRequiredMetaFieldsOnFile");
var $bb94bbccedce200d$var$_checkRequiredMetaFields = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("checkRequiredMetaFields");
var $bb94bbccedce200d$var$_assertNewUploadAllowed = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("assertNewUploadAllowed");
var $bb94bbccedce200d$var$_transformFile = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("transformFile");
var $bb94bbccedce200d$var$_startIfAutoProceed = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("startIfAutoProceed");
var $bb94bbccedce200d$var$_checkAndUpdateFileState = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("checkAndUpdateFileState");
var $bb94bbccedce200d$var$_addListeners = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("addListeners");
var $bb94bbccedce200d$var$_updateOnlineStatus = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("updateOnlineStatus");
var $bb94bbccedce200d$var$_requestClientById = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("requestClientById");
var $bb94bbccedce200d$var$_createUpload = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("createUpload");
var $bb94bbccedce200d$var$_getUpload = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("getUpload");
var $bb94bbccedce200d$var$_removeUpload = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("removeUpload");
var $bb94bbccedce200d$var$_runUpload = /*#__PURE__*/ $bb94bbccedce200d$var$_classPrivateFieldLooseKey("runUpload");
$bb94bbccedce200d$var$_Symbol$for = Symbol.for('uppy test: getPlugins');
$bb94bbccedce200d$var$_Symbol$for2 = Symbol.for('uppy test: createUpload');
class $bb94bbccedce200d$export$1c95bea2669f592b {
    /**
   * Instantiate Uppy
   */ constructor(_opts){
        /**
     * Run an upload. This picks up where it left off in case the upload is being restored.
     */ Object.defineProperty(this, $bb94bbccedce200d$var$_runUpload, {
            value: $bb94bbccedce200d$var$_runUpload2
        });
        /**
     * Remove an upload, eg. if it has been canceled or completed.
     *
     */ Object.defineProperty(this, $bb94bbccedce200d$var$_removeUpload, {
            value: $bb94bbccedce200d$var$_removeUpload2
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_getUpload, {
            value: $bb94bbccedce200d$var$_getUpload2
        });
        /**
     * Create an upload for a bunch of files.
     *
     */ Object.defineProperty(this, $bb94bbccedce200d$var$_createUpload, {
            value: $bb94bbccedce200d$var$_createUpload2
        });
        /**
     * Registers listeners for all global actions, like:
     * `error`, `file-removed`, `upload-progress`
     */ Object.defineProperty(this, $bb94bbccedce200d$var$_addListeners, {
            value: $bb94bbccedce200d$var$_addListeners2
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_checkAndUpdateFileState, {
            value: $bb94bbccedce200d$var$_checkAndUpdateFileState2
        });
        // Schedule an upload if `autoProceed` is enabled.
        Object.defineProperty(this, $bb94bbccedce200d$var$_startIfAutoProceed, {
            value: $bb94bbccedce200d$var$_startIfAutoProceed2
        });
        /**
     * Create a file state object based on user-provided `addFile()` options.
     */ Object.defineProperty(this, $bb94bbccedce200d$var$_transformFile, {
            value: $bb94bbccedce200d$var$_transformFile2
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_assertNewUploadAllowed, {
            value: $bb94bbccedce200d$var$_assertNewUploadAllowed2
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_checkRequiredMetaFields, {
            value: $bb94bbccedce200d$var$_checkRequiredMetaFields2
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile, {
            value: $bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile2
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_informAndEmit, {
            value: $bb94bbccedce200d$var$_informAndEmit2
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_plugins, {
            writable: true,
            value: Object.create(null)
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_restricter, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_storeUnsubscribe, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_emitter, {
            writable: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($760bc9a020ea9458$exports)))()
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_preProcessors, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_uploaders, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_postProcessors, {
            writable: true,
            value: new Set()
        });
        this.scheduledAutoProceed = null;
        this.wasOffline = false;
        // ___Why throttle at 500ms?
        //    - We must throttle at >250ms for superfocus in Dashboard to work well
        //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
        //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
        //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
        //    - We must throttle at around >500ms to avoid performance lags.
        //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.
        // todo when uploading multiple files, this will cause problems because they share the same throttle,
        // meaning some files might never get their progress reported (eaten up by progress events from other files)
        this.calculateProgress = (0, (/*@__PURE__*/$parcel$interopDefault($011ad752b8925e1c$exports)))((file, data)=>{
            const fileInState = this.getFile(file == null ? void 0 : file.id);
            if (file == null || !fileInState) {
                this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
                return;
            }
            if (fileInState.progress.percentage === 100) {
                this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
                return;
            }
            // bytesTotal may be null or zero; in that case we can't divide by it
            const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
            this.setFileState(file.id, {
                progress: {
                    ...fileInState.progress,
                    bytesUploaded: data.bytesUploaded,
                    bytesTotal: data.bytesTotal,
                    percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
                }
            });
            this.calculateTotalProgress();
        }, 500, {
            leading: true,
            trailing: true
        });
        Object.defineProperty(this, $bb94bbccedce200d$var$_updateOnlineStatus, {
            writable: true,
            value: this.updateOnlineStatus.bind(this)
        });
        // We need to store request clients by a unique ID, so we can share RequestClient instances across files
        // this allows us to do rate limiting and synchronous operations like refreshing provider tokens
        // example: refreshing tokens: if each file has their own requestclient,
        // we don't have any way to synchronize all requests in order to
        // - block all requests
        // - refresh the token
        // - unblock all requests and allow them to run with a the new access token
        // back when we had a requestclient per file, once an access token expired,
        // all 6 files would go ahead and refresh the token at the same time
        // (calling /refresh-token up to 6 times), which will probably fail for some providers
        Object.defineProperty(this, $bb94bbccedce200d$var$_requestClientById, {
            writable: true,
            value: new Map()
        });
        this.defaultLocale = (0, $cf47bdc0ed946068$export$2e2bcd8739ae039);
        const defaultOptions = {
            id: 'uppy',
            autoProceed: false,
            allowMultipleUploadBatches: true,
            debug: false,
            restrictions: (0, $bf6cd51ac16577aa$export$ba43bf67f3d48107),
            meta: {},
            onBeforeFileAdded: (file, files)=>!Object.hasOwn(files, file.id),
            onBeforeUpload: (files)=>files,
            store: new (0, $a467add224e16bf9$export$2e2bcd8739ae039)(),
            logger: (0, $89b55000e21c3276$export$51086a57eba987c9),
            infoTimeout: 5000
        };
        const merged = {
            ...defaultOptions,
            ..._opts
        };
        // Merge default options with the ones set by user,
        // making sure to merge restrictions too
        this.opts = {
            ...merged,
            restrictions: {
                ...defaultOptions.restrictions,
                ..._opts && _opts.restrictions
            }
        };
        // Support debug: true for backwards-compatability, unless logger is set in opts
        // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions
        if (_opts && _opts.logger && _opts.debug) this.log('You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.', 'warning');
        else if (_opts && _opts.debug) this.opts.logger = (0, $89b55000e21c3276$export$e6a390ea6399b7d8);
        this.log(`Using Core v${$bb94bbccedce200d$export$1c95bea2669f592b.VERSION}`);
        this.i18nInit();
        this.store = this.opts.store;
        this.setState({
            ...$bb94bbccedce200d$var$defaultUploadState,
            plugins: {},
            files: {},
            currentUploads: {},
            capabilities: {
                uploadProgress: (0, $82dd8fafdce0efe0$export$2e2bcd8739ae039)(),
                individualCancellation: true,
                resumableUploads: false
            },
            meta: {
                ...this.opts.meta
            },
            info: []
        });
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_restricter)[$bb94bbccedce200d$var$_restricter] = new (0, $bf6cd51ac16577aa$export$c464a380a24dd3b8)(()=>this.opts, ()=>this.i18n);
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_storeUnsubscribe)[$bb94bbccedce200d$var$_storeUnsubscribe] = this.store.subscribe(// eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        (prevState, nextState, patch)=>{
            // eslint-disable-next-line
            // @ts-ignore Store is incorrectly typed
            this.emit('state-update', prevState, nextState, patch);
            this.updateAll(nextState);
        });
        // Exposing uppy object on window for debugging and testing
        if (this.opts.debug && typeof window !== 'undefined') // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Mutating the global object for debug purposes
        window[this.opts.id] = this;
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_addListeners)[$bb94bbccedce200d$var$_addListeners]();
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_emitter)[$bb94bbccedce200d$var$_emitter].emit(event, ...args);
    }
    on(event, callback) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_emitter)[$bb94bbccedce200d$var$_emitter].on(event, callback);
        return this;
    }
    once(event, callback) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_emitter)[$bb94bbccedce200d$var$_emitter].once(event, callback);
        return this;
    }
    off(event, callback) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_emitter)[$bb94bbccedce200d$var$_emitter].off(event, callback);
        return this;
    }
    /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */ updateAll(state) {
        this.iteratePlugins((plugin)=>{
            plugin.update(state);
        });
    }
    /**
   * Updates state with a patch
   */ setState(patch) {
        // eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        this.store.setState(patch);
    }
    /**
   * Returns current state.
   */ getState() {
        // eslint-disable-next-line
        // @ts-ignore Store is incorrectly typed
        return this.store.getState();
    }
    patchFilesState(filesWithNewState) {
        const existingFilesState = this.getState().files;
        this.setState({
            files: {
                ...existingFilesState,
                ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref)=>{
                    let [fileID, newFileState] = _ref;
                    return [
                        fileID,
                        {
                            ...existingFilesState[fileID],
                            ...newFileState
                        }
                    ];
                }))
            }
        });
    }
    /**
   * Shorthand to set state for a specific file.
   */ setFileState(fileID, state) {
        if (!this.getState().files[fileID]) throw new Error(`Can\u{2019}t set state for ${fileID} (the file could have been removed)`);
        this.patchFilesState({
            [fileID]: state
        });
    }
    i18nInit() {
        const onMissingKey = (key)=>this.log(`Missing i18n string: ${key}`, 'error');
        const translator = new (0, $c997a156bd6937f3$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.opts.locale
        ], {
            onMissingKey: onMissingKey
        });
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.locale = translator.locale;
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts,
            restrictions: {
                ...this.opts.restrictions,
                ...newOpts == null ? void 0 : newOpts.restrictions
            }
        };
        if (newOpts.meta) this.setMeta(newOpts.meta);
        this.i18nInit();
        if (newOpts.locale) this.iteratePlugins((plugin)=>{
            plugin.setOptions(newOpts);
        });
        // Note: this is not the preact `setState`, it's an internal function that has the same name.
        this.setState(undefined); // so that UI re-renders with new options
    }
    // todo next major: remove
    resetProgress() {
        const defaultProgress = {
            percentage: 0,
            bytesUploaded: 0,
            uploadComplete: false,
            uploadStarted: null
        };
        const files = {
            ...this.getState().files
        };
        const updatedFiles = {};
        Object.keys(files).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...files[fileID],
                progress: {
                    ...files[fileID].progress,
                    ...defaultProgress
                }
            };
        });
        this.setState({
            files: updatedFiles,
            ...$bb94bbccedce200d$var$defaultUploadState
        });
        this.emit('reset-progress');
    }
    // @todo next major: rename to `clear()`, make it also cancel ongoing uploads
    // or throw and say you need to cancel manually
    clearUploadedFiles() {
        const { capabilities: capabilities, currentUploads: currentUploads } = this.getState();
        if (Object.keys(currentUploads).length > 0 && !capabilities.individualCancellation) throw new Error('The installed uploader plugin does not allow removing files during an upload.');
        this.setState({
            ...$bb94bbccedce200d$var$defaultUploadState,
            files: {}
        });
    }
    addPreProcessor(fn) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_preProcessors)[$bb94bbccedce200d$var$_preProcessors].add(fn);
    }
    removePreProcessor(fn) {
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_preProcessors)[$bb94bbccedce200d$var$_preProcessors].delete(fn);
    }
    addPostProcessor(fn) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_postProcessors)[$bb94bbccedce200d$var$_postProcessors].add(fn);
    }
    removePostProcessor(fn) {
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_postProcessors)[$bb94bbccedce200d$var$_postProcessors].delete(fn);
    }
    addUploader(fn) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_uploaders)[$bb94bbccedce200d$var$_uploaders].add(fn);
    }
    removeUploader(fn) {
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_uploaders)[$bb94bbccedce200d$var$_uploaders].delete(fn);
    }
    setMeta(data) {
        const updatedMeta = {
            ...this.getState().meta,
            ...data
        };
        const updatedFiles = {
            ...this.getState().files
        };
        Object.keys(updatedFiles).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                meta: {
                    ...updatedFiles[fileID].meta,
                    ...data
                }
            };
        });
        this.log('Adding metadata:');
        this.log(data);
        this.setState({
            meta: updatedMeta,
            files: updatedFiles
        });
    }
    setFileMeta(fileID, data) {
        const updatedFiles = {
            ...this.getState().files
        };
        if (!updatedFiles[fileID]) {
            this.log('Was trying to set metadata for a file that has been removed: ', fileID);
            return;
        }
        const newMeta = {
            ...updatedFiles[fileID].meta,
            ...data
        };
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            meta: newMeta
        };
        this.setState({
            files: updatedFiles
        });
    }
    /**
   * Get a file object.
   */ getFile(fileID) {
        return this.getState().files[fileID];
    }
    /**
   * Get all files in an array.
   */ getFiles() {
        const { files: files } = this.getState();
        return Object.values(files);
    }
    getFilesByIds(ids) {
        return ids.map((id)=>this.getFile(id));
    }
    getObjectOfFilesPerState() {
        const { files: filesObject, totalProgress: totalProgress, error: error } = this.getState();
        const files = Object.values(filesObject);
        const inProgressFiles = [];
        const newFiles = [];
        const startedFiles = [];
        const uploadStartedFiles = [];
        const pausedFiles = [];
        const completeFiles = [];
        const erroredFiles = [];
        const inProgressNotPausedFiles = [];
        const processingFiles = [];
        for (const file of files){
            const { progress: progress } = file;
            if (!progress.uploadComplete && progress.uploadStarted) {
                inProgressFiles.push(file);
                if (!file.isPaused) inProgressNotPausedFiles.push(file);
            }
            if (!progress.uploadStarted) newFiles.push(file);
            if (progress.uploadStarted || progress.preprocess || progress.postprocess) startedFiles.push(file);
            if (progress.uploadStarted) uploadStartedFiles.push(file);
            if (file.isPaused) pausedFiles.push(file);
            if (progress.uploadComplete) completeFiles.push(file);
            if (file.error) erroredFiles.push(file);
            if (progress.preprocess || progress.postprocess) processingFiles.push(file);
        }
        return {
            newFiles: newFiles,
            startedFiles: startedFiles,
            uploadStartedFiles: uploadStartedFiles,
            pausedFiles: pausedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: uploadStartedFiles.length > 0,
            isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
            isAllErrored: !!error && erroredFiles.length === files.length,
            isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
            isUploadInProgress: inProgressFiles.length > 0,
            isSomeGhost: files.some((file)=>file.isGhost)
        };
    }
    validateRestrictions(file, files) {
        if (files === void 0) files = this.getFiles();
        try {
            $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_restricter)[$bb94bbccedce200d$var$_restricter].validate(files, [
                file
            ]);
        } catch (err) {
            return err;
        }
        return null;
    }
    checkIfFileAlreadyExists(fileID) {
        const { files: files } = this.getState();
        if (files[fileID] && !files[fileID].isGhost) return true;
        return false;
    }
    /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   */ addFile(file) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_assertNewUploadAllowed)[$bb94bbccedce200d$var$_assertNewUploadAllowed](file);
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_checkAndUpdateFileState)[$bb94bbccedce200d$var$_checkAndUpdateFileState]([
            file
        ]);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_informAndEmit)[$bb94bbccedce200d$var$_informAndEmit](restrictionErrors);
        if (errors.length > 0) throw errors[0];
        this.setState({
            files: nextFilesState
        });
        const [firstValidFileToAdd] = validFilesToAdd;
        this.emit('file-added', firstValidFileToAdd);
        this.emit('files-added', validFilesToAdd);
        this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_startIfAutoProceed)[$bb94bbccedce200d$var$_startIfAutoProceed]();
        return firstValidFileToAdd.id;
    }
    /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */ addFiles(fileDescriptors) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_assertNewUploadAllowed)[$bb94bbccedce200d$var$_assertNewUploadAllowed]();
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_checkAndUpdateFileState)[$bb94bbccedce200d$var$_checkAndUpdateFileState](fileDescriptors);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_informAndEmit)[$bb94bbccedce200d$var$_informAndEmit](restrictionErrors);
        const nonRestrictionErrors = errors.filter((error)=>!error.isRestriction);
        if (nonRestrictionErrors.length > 0) {
            let message = 'Multiple errors occurred while adding files:\n';
            nonRestrictionErrors.forEach((subError)=>{
                message += `\n * ${subError.message}`;
            });
            this.info({
                message: this.i18n('addBulkFilesFailed', {
                    smart_count: nonRestrictionErrors.length
                }),
                details: message
            }, 'error', this.opts.infoTimeout);
            if (typeof AggregateError === 'function') throw new AggregateError(nonRestrictionErrors, message);
            else {
                const err = new Error(message);
                // @ts-expect-error fallback when AggregateError is not available
                err.errors = nonRestrictionErrors;
                throw err;
            }
        }
        // OK, we haven't thrown an error, we can start updating state and emitting events now:
        this.setState({
            files: nextFilesState
        });
        validFilesToAdd.forEach((file)=>{
            this.emit('file-added', file);
        });
        this.emit('files-added', validFilesToAdd);
        if (validFilesToAdd.length > 5) this.log(`Added batch of ${validFilesToAdd.length} files`);
        else Object.values(validFilesToAdd).forEach((file)=>{
            this.log(`Added file: ${file.name}\n id: ${file.id}\n type: ${file.type}`);
        });
        if (validFilesToAdd.length > 0) $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_startIfAutoProceed)[$bb94bbccedce200d$var$_startIfAutoProceed]();
    }
    removeFiles(fileIDs, reason) {
        const { files: files, currentUploads: currentUploads } = this.getState();
        const updatedFiles = {
            ...files
        };
        const updatedUploads = {
            ...currentUploads
        };
        const removedFiles = Object.create(null);
        fileIDs.forEach((fileID)=>{
            if (files[fileID]) {
                removedFiles[fileID] = files[fileID];
                delete updatedFiles[fileID];
            }
        });
        // Remove files from the `fileIDs` list in each upload.
        function fileIsNotRemoved(uploadFileID) {
            return removedFiles[uploadFileID] === undefined;
        }
        Object.keys(updatedUploads).forEach((uploadID)=>{
            const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
            // Remove the upload if no files are associated with it anymore.
            if (newFileIDs.length === 0) {
                delete updatedUploads[uploadID];
                return;
            }
            const { capabilities: capabilities } = this.getState();
            if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) throw new Error('The installed uploader plugin does not allow removing files during an upload.');
            updatedUploads[uploadID] = {
                ...currentUploads[uploadID],
                fileIDs: newFileIDs
            };
        });
        const stateUpdate = {
            currentUploads: updatedUploads,
            files: updatedFiles
        };
        // If all files were removed - allow new uploads,
        // and clear recoveredState
        if (Object.keys(updatedFiles).length === 0) {
            stateUpdate.allowNewUpload = true;
            stateUpdate.error = null;
            stateUpdate.recoveredState = null;
        }
        this.setState(stateUpdate);
        this.calculateTotalProgress();
        const removedFileIDs = Object.keys(removedFiles);
        removedFileIDs.forEach((fileID)=>{
            this.emit('file-removed', removedFiles[fileID], reason);
        });
        if (removedFileIDs.length > 5) this.log(`Removed ${removedFileIDs.length} files`);
        else this.log(`Removed files: ${removedFileIDs.join(', ')}`);
    }
    removeFile(fileID, reason) {
        this.removeFiles([
            fileID
        ], reason);
    }
    pauseResume(fileID) {
        if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) return undefined;
        const wasPaused = this.getFile(fileID).isPaused || false;
        const isPaused = !wasPaused;
        this.setFileState(fileID, {
            isPaused: isPaused
        });
        this.emit('upload-pause', fileID, isPaused);
        return isPaused;
    }
    pauseAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: true
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit('pause-all');
    }
    resumeAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit('resume-all');
    }
    retryAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const filesToRetry = Object.keys(updatedFiles).filter((file)=>{
            return updatedFiles[file].error;
        });
        filesToRetry.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles,
            error: null
        });
        this.emit('retry-all', filesToRetry);
        if (filesToRetry.length === 0) return Promise.resolve({
            successful: [],
            failed: []
        });
        const uploadID = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_createUpload)[$bb94bbccedce200d$var$_createUpload](filesToRetry, {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_runUpload)[$bb94bbccedce200d$var$_runUpload](uploadID);
    }
    cancelAll(_temp) {
        let { reason: reason = 'user' } = _temp === void 0 ? {} : _temp;
        this.emit('cancel-all', {
            reason: reason
        });
        // Only remove existing uploads if user is canceling
        if (reason === 'user') {
            const { files: files } = this.getState();
            const fileIDs = Object.keys(files);
            if (fileIDs.length) this.removeFiles(fileIDs, 'cancel-all');
            this.setState($bb94bbccedce200d$var$defaultUploadState);
        // todo should we call this.emit('reset-progress') like we do for resetProgress?
        }
    }
    retryUpload(fileID) {
        this.setFileState(fileID, {
            error: null,
            isPaused: false
        });
        this.emit('upload-retry', fileID);
        const uploadID = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_createUpload)[$bb94bbccedce200d$var$_createUpload]([
            fileID
        ], {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_runUpload)[$bb94bbccedce200d$var$_runUpload](uploadID);
    }
    logout() {
        this.iteratePlugins((plugin)=>{
            var _provider;
            (_provider = plugin.provider) == null || _provider.logout == null || _provider.logout();
        });
    }
    calculateTotalProgress() {
        // calculate total progress, using the number of files currently uploading,
        // multiplied by 100 and the summ of individual progress of each file
        const files = this.getFiles();
        const inProgress = files.filter((file)=>{
            return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
        });
        if (inProgress.length === 0) {
            this.emit('progress', 0);
            this.setState({
                totalProgress: 0
            });
            return;
        }
        const sizedFiles = inProgress.filter((file)=>file.progress.bytesTotal != null);
        const unsizedFiles = inProgress.filter((file)=>file.progress.bytesTotal == null);
        if (sizedFiles.length === 0) {
            const progressMax = inProgress.length * 100;
            const currentProgress = unsizedFiles.reduce((acc, file)=>{
                return acc + file.progress.percentage;
            }, 0);
            const totalProgress = Math.round(currentProgress / progressMax * 100);
            this.setState({
                totalProgress: totalProgress
            });
            return;
        }
        let totalSize = sizedFiles.reduce((acc, file)=>{
            var _file$progress$bytesT;
            return acc + ((_file$progress$bytesT = file.progress.bytesTotal) != null ? _file$progress$bytesT : 0);
        }, 0);
        const averageSize = totalSize / sizedFiles.length;
        totalSize += averageSize * unsizedFiles.length;
        let uploadedSize = 0;
        sizedFiles.forEach((file)=>{
            uploadedSize += file.progress.bytesUploaded;
        });
        unsizedFiles.forEach((file)=>{
            uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
        });
        let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100);
        // hot fix, because:
        // uploadedSize ended up larger than totalSize, resulting in 1325% total
        if (totalProgress > 100) totalProgress = 100;
        this.setState({
            totalProgress: totalProgress
        });
        this.emit('progress', totalProgress);
    }
    updateOnlineStatus() {
        var _window$navigator$onL;
        const online = (_window$navigator$onL = window.navigator.onLine) != null ? _window$navigator$onL : true;
        if (!online) {
            this.emit('is-offline');
            this.info(this.i18n('noInternetConnection'), 'error', 0);
            this.wasOffline = true;
        } else {
            this.emit('is-online');
            if (this.wasOffline) {
                this.emit('back-online');
                this.info(this.i18n('connectedToInternet'), 'success', 3000);
                this.wasOffline = false;
            }
        }
    }
    getID() {
        return this.opts.id;
    }
    /**
   * Registers a plugin with Core.
   */ use(Plugin, opts) {
        if (typeof Plugin !== 'function') {
            const msg = `Expected a plugin class, but got ${Plugin === null ? 'null' : typeof Plugin}.` + ' Please verify that the plugin was imported and spelled correctly.';
            throw new TypeError(msg);
        }
        // Instantiate
        const plugin = new Plugin(this, opts);
        const pluginId = plugin.id;
        if (!pluginId) throw new Error('Your plugin must have an id');
        if (!plugin.type) throw new Error('Your plugin must have a type');
        const existsPluginAlready = this.getPlugin(pluginId);
        if (existsPluginAlready) {
            const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + 'Uppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.';
            throw new Error(msg);
        }
        // @ts-expect-error does exist
        if (Plugin.VERSION) // @ts-expect-error does exist
        this.log(`Using ${pluginId} v${Plugin.VERSION}`);
        if (plugin.type in $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins]) $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins][plugin.type].push(plugin);
        else $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins][plugin.type] = [
            plugin
        ];
        plugin.install();
        this.emit('plugin-added', plugin);
        return this;
    }
    /**
   * Find one Plugin by name.
   */ getPlugin(id) {
        for (const plugins of Object.values($bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins])){
            const foundPlugin = plugins.find((plugin)=>plugin.id === id);
            if (foundPlugin != null) return foundPlugin;
        }
        return undefined;
    }
    [$bb94bbccedce200d$var$_Symbol$for](type) {
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins][type];
    }
    /**
   * Iterate through all `use`d plugins.
   *
   */ iteratePlugins(method) {
        Object.values($bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins]).flat(1).forEach(method);
    }
    /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */ removePlugin(instance) {
        this.log(`Removing plugin ${instance.id}`);
        this.emit('plugin-remove', instance);
        if (instance.uninstall) instance.uninstall();
        const list = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins][instance.type];
        // list.indexOf failed here, because Vue3 converted the plugin instance
        // to a Proxy object, which failed the strict comparison test:
        // obj !== objProxy
        const index = list.findIndex((item)=>item.id === instance.id);
        if (index !== -1) list.splice(index, 1);
        const state = this.getState();
        const updatedState = {
            plugins: {
                ...state.plugins,
                [instance.id]: undefined
            }
        };
        this.setState(updatedState);
    }
    /**
   * Uninstall all plugins and close down this Uppy instance.
   */ // @todo next major: rename to `destroy`.
    // Cancel local uploads, cancel remote uploads, DON'T cancel assemblies
    // document that if you do want to cancel assemblies, you need to call smth manually.
    // Potentially remove reason, as it’s confusing, just come up with a default behaviour.
    close(_temp2) {
        let { reason: reason } = _temp2 === void 0 ? {} : _temp2;
        this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
        this.cancelAll({
            reason: reason
        });
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_storeUnsubscribe)[$bb94bbccedce200d$var$_storeUnsubscribe]();
        this.iteratePlugins((plugin)=>{
            this.removePlugin(plugin);
        });
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('online', $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_updateOnlineStatus)[$bb94bbccedce200d$var$_updateOnlineStatus]);
            window.removeEventListener('offline', $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_updateOnlineStatus)[$bb94bbccedce200d$var$_updateOnlineStatus]);
        }
    }
    hideInfo() {
        const { info: info } = this.getState();
        this.setState({
            info: info.slice(1)
        });
        this.emit('info-hidden');
    }
    /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   */ info(message, type, duration) {
        if (type === void 0) type = 'info';
        if (duration === void 0) duration = 3000;
        const isComplexMessage = typeof message === 'object';
        this.setState({
            info: [
                ...this.getState().info,
                {
                    type: type,
                    message: isComplexMessage ? message.message : message,
                    details: isComplexMessage ? message.details : null
                }
            ]
        });
        setTimeout(()=>this.hideInfo(), duration);
        this.emit('info-visible');
    }
    /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   */ log(message, type) {
        const { logger: logger } = this.opts;
        switch(type){
            case 'error':
                logger.error(message);
                break;
            case 'warning':
                logger.warn(message);
                break;
            default:
                logger.debug(message);
                break;
        }
    }
    registerRequestClient(id, client) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_requestClientById)[$bb94bbccedce200d$var$_requestClientById].set(id, client);
    }
    /** @protected */ getRequestClientForFile(file) {
        if (!file.remote) throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
        const requestClient = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_requestClientById)[$bb94bbccedce200d$var$_requestClientById].get(file.remote.requestClientId);
        if (requestClient == null) throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
        return requestClient;
    }
    /**
   * Restore an upload by its ID.
   */ restore(uploadID) {
        this.log(`Core: attempting to restore upload "${uploadID}"`);
        if (!this.getState().currentUploads[uploadID]) {
            $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_removeUpload)[$bb94bbccedce200d$var$_removeUpload](uploadID);
            return Promise.reject(new Error('Nonexistent upload'));
        }
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_runUpload)[$bb94bbccedce200d$var$_runUpload](uploadID);
    }
    [$bb94bbccedce200d$var$_Symbol$for2]() {
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/47595
        return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_createUpload)[$bb94bbccedce200d$var$_createUpload](...arguments);
    }
    /**
   * Add data to an upload's result object.
   */ addResultData(uploadID, data) {
        if (!$bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_getUpload)[$bb94bbccedce200d$var$_getUpload](uploadID)) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            return;
        }
        const { currentUploads: currentUploads } = this.getState();
        const currentUpload = {
            ...currentUploads[uploadID],
            result: {
                ...currentUploads[uploadID].result,
                ...data
            }
        };
        this.setState({
            currentUploads: {
                ...currentUploads,
                [uploadID]: currentUpload
            }
        });
    }
    /**
   * Start an upload for all the files that are not currently being uploaded.
   */ upload() {
        var _classPrivateFieldLoo;
        if (!((_classPrivateFieldLoo = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_plugins)[$bb94bbccedce200d$var$_plugins]['uploader']) != null && _classPrivateFieldLoo.length)) this.log('No uploader type plugins are used', 'warning');
        let { files: files } = this.getState();
        const onBeforeUploadResult = this.opts.onBeforeUpload(files);
        if (onBeforeUploadResult === false) return Promise.reject(new Error('Not starting the upload because onBeforeUpload returned false'));
        if (onBeforeUploadResult && typeof onBeforeUploadResult === 'object') {
            files = onBeforeUploadResult;
            // Updating files in state, because uploader plugins receive file IDs,
            // and then fetch the actual file object from state
            this.setState({
                files: files
            });
        }
        return Promise.resolve().then(()=>$bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_restricter)[$bb94bbccedce200d$var$_restricter].validateMinNumberOfFiles(files)).catch((err)=>{
            $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_informAndEmit)[$bb94bbccedce200d$var$_informAndEmit]([
                err
            ]);
            throw err;
        }).then(()=>{
            if (!$bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_checkRequiredMetaFields)[$bb94bbccedce200d$var$_checkRequiredMetaFields](files)) throw new (0, $bf6cd51ac16577aa$export$e4d147272ce048a7)(this.i18n('missingRequiredMetaField'));
        }).catch((err)=>{
            // Doing this in a separate catch because we already emited and logged
            // all the errors in `checkRequiredMetaFields` so we only throw a generic
            // missing fields error here.
            throw err;
        }).then(()=>{
            const { currentUploads: currentUploads } = this.getState();
            // get a list of files that are currently assigned to uploads
            const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr)=>curr.fileIDs);
            const waitingFileIDs = [];
            Object.keys(files).forEach((fileID)=>{
                const file = this.getFile(fileID);
                // if the file hasn't started uploading and hasn't already been assigned to an upload..
                if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) waitingFileIDs.push(file.id);
            });
            const uploadID = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_createUpload)[$bb94bbccedce200d$var$_createUpload](waitingFileIDs);
            return $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_runUpload)[$bb94bbccedce200d$var$_runUpload](uploadID);
        }).catch((err)=>{
            this.emit('error', err);
            this.log(err, 'error');
            throw err;
        });
    }
}
function $bb94bbccedce200d$var$_informAndEmit2(errors) {
    for (const error of errors){
        if (error.isRestriction) this.emit('restriction-failed', error.file, error);
        else this.emit('error', error, error.file);
        this.log(error, 'warning');
    }
    const userFacingErrors = errors.filter((error)=>error.isUserFacing);
    // don't flood the user: only show the first 4 toasts
    const maxNumToShow = 4;
    const firstErrors = userFacingErrors.slice(0, maxNumToShow);
    const additionalErrors = userFacingErrors.slice(maxNumToShow);
    firstErrors.forEach((_ref2)=>{
        let { message: message, details: details = '' } = _ref2;
        this.info({
            message: message,
            details: details
        }, 'error', this.opts.infoTimeout);
    });
    if (additionalErrors.length > 0) this.info({
        message: this.i18n('additionalRestrictionsFailed', {
            count: additionalErrors.length
        })
    });
}
function $bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile2(file) {
    const { missingFields: missingFields, error: error } = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_restricter)[$bb94bbccedce200d$var$_restricter].getMissingRequiredMetaFields(file);
    if (missingFields.length > 0) {
        this.setFileState(file.id, {
            missingRequiredMetaFields: missingFields
        });
        this.log(error.message);
        this.emit('restriction-failed', file, error);
        return false;
    }
    return true;
}
function $bb94bbccedce200d$var$_checkRequiredMetaFields2(files) {
    let success = true;
    for (const file of Object.values(files))if (!$bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile)[$bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile](file)) success = false;
    return success;
}
function $bb94bbccedce200d$var$_assertNewUploadAllowed2(file) {
    const { allowNewUpload: allowNewUpload } = this.getState();
    if (allowNewUpload === false) {
        const error = new (0, $bf6cd51ac16577aa$export$e4d147272ce048a7)(this.i18n('noMoreFilesAllowed'), {
            file: file
        });
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_informAndEmit)[$bb94bbccedce200d$var$_informAndEmit]([
            error
        ]);
        throw error;
    }
}
function $bb94bbccedce200d$var$_transformFile2(fileDescriptorOrFile) {
    // Uppy expects files in { name, type, size, data } format.
    // If the actual File object is passed from input[type=file] or drag-drop,
    // we normalize it to match Uppy file object
    const file = fileDescriptorOrFile instanceof File ? {
        name: fileDescriptorOrFile.name,
        type: fileDescriptorOrFile.type,
        size: fileDescriptorOrFile.size,
        data: fileDescriptorOrFile
    } : fileDescriptorOrFile;
    const fileType = (0, $36e7cd0f6c76118b$export$2e2bcd8739ae039)(file);
    const fileName = (0, $1e50c190e0dd6818$export$2e2bcd8739ae039)(fileType, file);
    const fileExtension = (0, $85bf854dfb6901a1$export$2e2bcd8739ae039)(fileName).extension;
    const id = (0, $89f97f6b4f199a3f$export$2ff5b23440673856)(file, this.getID());
    const meta = file.meta || {};
    meta.name = fileName;
    meta.type = fileType;
    // `null` means the size is unknown.
    const size = Number.isFinite(file.data.size) ? file.data.size : null;
    return {
        source: file.source || '',
        id: id,
        name: fileName,
        extension: fileExtension || '',
        meta: {
            ...this.getState().meta,
            ...meta
        },
        type: fileType,
        data: file.data,
        progress: {
            percentage: 0,
            bytesUploaded: 0,
            bytesTotal: size,
            uploadComplete: false,
            uploadStarted: null
        },
        size: size,
        isGhost: false,
        isRemote: file.isRemote || false,
        // TODO: this should not be a string
        // @ts-expect-error wrong
        remote: file.remote || '',
        preview: file.preview
    };
}
function $bb94bbccedce200d$var$_startIfAutoProceed2() {
    if (this.opts.autoProceed && !this.scheduledAutoProceed) this.scheduledAutoProceed = setTimeout(()=>{
        this.scheduledAutoProceed = null;
        this.upload().catch((err)=>{
            if (!err.isRestriction) this.log(err.stack || err.message || err);
        });
    }, 4);
}
function $bb94bbccedce200d$var$_checkAndUpdateFileState2(filesToAdd) {
    const { files: existingFiles } = this.getState();
    // create a copy of the files object only once
    const nextFilesState = {
        ...existingFiles
    };
    const validFilesToAdd = [];
    const errors = [];
    for (const fileToAdd of filesToAdd)try {
        var _existingFiles$newFil;
        let newFile = $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_transformFile)[$bb94bbccedce200d$var$_transformFile](fileToAdd);
        // If a file has been recovered (Golden Retriever), but we were unable to recover its data (probably too large),
        // users are asked to re-select these half-recovered files and then this method will be called again.
        // In order to keep the progress, meta and everything else, we keep the existing file,
        // but we replace `data`, and we remove `isGhost`, because the file is no longer a ghost now
        const isGhost = (_existingFiles$newFil = existingFiles[newFile.id]) == null ? void 0 : _existingFiles$newFil.isGhost;
        if (isGhost) {
            const existingFileState = existingFiles[newFile.id];
            newFile = {
                ...existingFileState,
                isGhost: false,
                data: fileToAdd.data
            };
            this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
        }
        const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
        if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) throw new (0, $bf6cd51ac16577aa$export$e4d147272ce048a7)(this.i18n('noDuplicates', {
            fileName: newFile.name
        }), {
            file: fileToAdd
        });
        // Pass through reselected files from Golden Retriever
        if (onBeforeFileAddedResult === false && !isGhost) // Don’t show UI info for this error, as it should be done by the developer
        throw new (0, $bf6cd51ac16577aa$export$e4d147272ce048a7)('Cannot add the file because onBeforeFileAdded returned false.', {
            isUserFacing: false,
            file: fileToAdd
        });
        else if (typeof onBeforeFileAddedResult === 'object' && onBeforeFileAddedResult !== null) newFile = onBeforeFileAddedResult;
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_restricter)[$bb94bbccedce200d$var$_restricter].validateSingleFile(newFile);
        // need to add it to the new local state immediately, so we can use the state to validate the next files too
        nextFilesState[newFile.id] = newFile;
        validFilesToAdd.push(newFile);
    } catch (err) {
        errors.push(err);
    }
    try {
        // need to run this separately because it's much more slow, so if we run it inside the for-loop it will be very slow
        // when many files are added
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_restricter)[$bb94bbccedce200d$var$_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
    } catch (err) {
        errors.push(err);
        // If we have any aggregate error, don't allow adding this batch
        return {
            nextFilesState: existingFiles,
            validFilesToAdd: [],
            errors: errors
        };
    }
    return {
        nextFilesState: nextFilesState,
        validFilesToAdd: validFilesToAdd,
        errors: errors
    };
}
function $bb94bbccedce200d$var$_addListeners2() {
    // Type inference only works for inline functions so we have to type it again
    const errorHandler = (error, file, response)=>{
        let errorMsg = error.message || 'Unknown error';
        if (error.details) errorMsg += ` ${error.details}`;
        this.setState({
            error: errorMsg
        });
        if (file != null && file.id in this.getState().files) this.setFileState(file.id, {
            error: errorMsg,
            response: response
        });
    };
    this.on('error', errorHandler);
    this.on('upload-error', (file, error, response)=>{
        errorHandler(error, file, response);
        if (typeof error === 'object' && error.message) {
            var _file$name;
            this.log(error.message, 'error');
            const newError = new Error(this.i18n('failedToUpload', {
                file: (_file$name = file == null ? void 0 : file.name) != null ? _file$name : ''
            })); // we may want a new custom error here
            newError.isUserFacing = true; // todo maybe don't do this with all errors?
            newError.details = error.message;
            if (error.details) newError.details += ` ${error.details}`;
            $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_informAndEmit)[$bb94bbccedce200d$var$_informAndEmit]([
                newError
            ]);
        } else $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_informAndEmit)[$bb94bbccedce200d$var$_informAndEmit]([
            error
        ]);
    });
    let uploadStalledWarningRecentlyEmitted = null;
    this.on('upload-stalled', (error, files)=>{
        const { message: message } = error;
        const details = files.map((file)=>file.meta.name).join(', ');
        if (!uploadStalledWarningRecentlyEmitted) {
            this.info({
                message: message,
                details: details
            }, 'warning', this.opts.infoTimeout);
            uploadStalledWarningRecentlyEmitted = setTimeout(()=>{
                uploadStalledWarningRecentlyEmitted = null;
            }, this.opts.infoTimeout);
        }
        this.log(`${message} ${details}`.trim(), 'warning');
    });
    this.on('upload', ()=>{
        this.setState({
            error: null
        });
    });
    const onUploadStarted = (files)=>{
        const filesFiltered = files.filter((file)=>{
            const exists = file != null && this.getFile(file.id);
            if (!exists) this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return exists;
        });
        const filesState = Object.fromEntries(filesFiltered.map((file)=>[
                file.id,
                {
                    progress: {
                        uploadStarted: Date.now(),
                        uploadComplete: false,
                        percentage: 0,
                        bytesUploaded: 0,
                        bytesTotal: file.size
                    }
                }
            ]));
        this.patchFilesState(filesState);
    };
    this.on('upload-start', (files)=>{
        files.forEach((file)=>{
            // todo backward compat, remove this event in a next major
            this.emit('upload-started', file);
        });
        onUploadStarted(files);
    });
    this.on('upload-progress', this.calculateProgress);
    this.on('upload-success', (file, uploadResp)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const currentProgress = this.getFile(file.id).progress;
        this.setFileState(file.id, {
            progress: {
                ...currentProgress,
                postprocess: $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_postProcessors)[$bb94bbccedce200d$var$_postProcessors].size > 0 ? {
                    mode: 'indeterminate'
                } : undefined,
                uploadComplete: true,
                percentage: 100,
                bytesUploaded: currentProgress.bytesTotal
            },
            response: uploadResp,
            uploadURL: uploadResp.uploadURL,
            isPaused: false
        });
        // Remote providers sometimes don't tell us the file size,
        // but we can know how many bytes we uploaded once the upload is complete.
        if (file.size == null) this.setFileState(file.id, {
            size: uploadResp.bytesUploaded || currentProgress.bytesTotal
        });
        this.calculateTotalProgress();
    });
    this.on('preprocess-progress', (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getFile(file.id).progress,
                preprocess: progress
            }
        });
    });
    this.on('preprocess-complete', (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.preprocess;
        this.setState({
            files: files
        });
    });
    this.on('postprocess-progress', (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getState().files[file.id].progress,
                postprocess: progress
            }
        });
    });
    this.on('postprocess-complete', (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.postprocess;
        this.setState({
            files: files
        });
    });
    this.on('restored', ()=>{
        // Files may have changed--ensure progress is still accurate.
        this.calculateTotalProgress();
    });
    // @ts-expect-error should fix itself when dashboard it typed (also this doesn't belong here)
    this.on('dashboard:file-edit-complete', (file)=>{
        if (file) $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile)[$bb94bbccedce200d$var$_checkRequiredMetaFieldsOnFile](file);
    });
    // show informer if offline
    if (typeof window !== 'undefined' && window.addEventListener) {
        window.addEventListener('online', $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_updateOnlineStatus)[$bb94bbccedce200d$var$_updateOnlineStatus]);
        window.addEventListener('offline', $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_updateOnlineStatus)[$bb94bbccedce200d$var$_updateOnlineStatus]);
        setTimeout($bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_updateOnlineStatus)[$bb94bbccedce200d$var$_updateOnlineStatus], 3000);
    }
}
function $bb94bbccedce200d$var$_createUpload2(fileIDs, opts) {
    if (opts === void 0) opts = {};
    // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
    const { forceAllowNewUpload: forceAllowNewUpload = false } = opts;
    const { allowNewUpload: allowNewUpload, currentUploads: currentUploads } = this.getState();
    if (!allowNewUpload && !forceAllowNewUpload) throw new Error('Cannot create a new upload: already uploading.');
    const uploadID = (0, $8e93258aecdd4641$export$ac4959f4f1338dfc)();
    this.emit('upload', {
        id: uploadID,
        fileIDs: fileIDs
    });
    this.setState({
        allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
        currentUploads: {
            ...currentUploads,
            [uploadID]: {
                fileIDs: fileIDs,
                step: 0,
                result: {}
            }
        }
    });
    return uploadID;
}
function $bb94bbccedce200d$var$_getUpload2(uploadID) {
    const { currentUploads: currentUploads } = this.getState();
    return currentUploads[uploadID];
}
function $bb94bbccedce200d$var$_removeUpload2(uploadID) {
    const currentUploads = {
        ...this.getState().currentUploads
    };
    delete currentUploads[uploadID];
    this.setState({
        currentUploads: currentUploads
    });
}
async function $bb94bbccedce200d$var$_runUpload2(uploadID) {
    const getCurrentUpload = ()=>{
        const { currentUploads: currentUploads } = this.getState();
        return currentUploads[uploadID];
    };
    let currentUpload = getCurrentUpload();
    const steps = [
        ...$bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_preProcessors)[$bb94bbccedce200d$var$_preProcessors],
        ...$bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_uploaders)[$bb94bbccedce200d$var$_uploaders],
        ...$bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_postProcessors)[$bb94bbccedce200d$var$_postProcessors]
    ];
    try {
        for(let step = currentUpload.step || 0; step < steps.length; step++){
            if (!currentUpload) break;
            const fn = steps[step];
            this.setState({
                currentUploads: {
                    ...this.getState().currentUploads,
                    [uploadID]: {
                        ...currentUpload,
                        step: step
                    }
                }
            });
            const { fileIDs: fileIDs } = currentUpload;
            // TODO give this the `updatedUpload` object as its only parameter maybe?
            // Otherwise when more metadata may be added to the upload this would keep getting more parameters
            await fn(fileIDs, uploadID);
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();
        }
    } catch (err) {
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_removeUpload)[$bb94bbccedce200d$var$_removeUpload](uploadID);
        throw err;
    }
    // Set result data.
    if (currentUpload) {
        // Mark postprocessing step as complete if necessary; this addresses a case where we might get
        // stuck in the postprocessing UI while the upload is fully complete.
        // If the postprocessing steps do not do any work, they may not emit postprocessing events at
        // all, and never mark the postprocessing as complete. This is fine on its own but we
        // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
        // state if any postprocessors are registered. That is to avoid a "flash of completed state"
        // before the postprocessing plugins can emit events.
        //
        // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
        // postprocessing completion, we do it instead.
        currentUpload.fileIDs.forEach((fileID)=>{
            const file = this.getFile(fileID);
            if (file && file.progress.postprocess) this.emit('postprocess-complete', file);
        });
        const files = currentUpload.fileIDs.map((fileID)=>this.getFile(fileID));
        const successful = files.filter((file)=>!file.error);
        const failed = files.filter((file)=>file.error);
        this.addResultData(uploadID, {
            successful: successful,
            failed: failed,
            uploadID: uploadID
        });
        // Update currentUpload value in case it was modified asynchronously.
        currentUpload = getCurrentUpload();
    }
    // Emit completion events.
    // This is in a separate function so that the `currentUploads` variable
    // always refers to the latest state. In the handler right above it refers
    // to an outdated object without the `.result` property.
    let result;
    if (currentUpload) {
        result = currentUpload.result;
        this.emit('complete', result);
        $bb94bbccedce200d$var$_classPrivateFieldLooseBase(this, $bb94bbccedce200d$var$_removeUpload)[$bb94bbccedce200d$var$_removeUpload](uploadID);
    }
    if (result == null) this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
    return result;
}
$bb94bbccedce200d$export$1c95bea2669f592b.VERSION = $bb94bbccedce200d$var$packageJson.version;
var $bb94bbccedce200d$export$2e2bcd8739ae039 = $bb94bbccedce200d$export$1c95bea2669f592b;


var $4e0ca152409a9912$var$n, $4e0ca152409a9912$export$41c562ebe57d11e2, $4e0ca152409a9912$var$u, $4e0ca152409a9912$export$a8257692ac88316c, $4e0ca152409a9912$var$i, $4e0ca152409a9912$var$r, $4e0ca152409a9912$var$o, $4e0ca152409a9912$var$e, $4e0ca152409a9912$var$f, $4e0ca152409a9912$var$c, $4e0ca152409a9912$var$s, $4e0ca152409a9912$var$a, $4e0ca152409a9912$var$h, $4e0ca152409a9912$var$p = {}, $4e0ca152409a9912$var$v = [], $4e0ca152409a9912$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $4e0ca152409a9912$var$w = Array.isArray;
function $4e0ca152409a9912$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $4e0ca152409a9912$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $4e0ca152409a9912$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $4e0ca152409a9912$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $4e0ca152409a9912$var$m(l, e, i, r, null);
}
function $4e0ca152409a9912$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$4e0ca152409a9912$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $4e0ca152409a9912$export$41c562ebe57d11e2.vnode && $4e0ca152409a9912$export$41c562ebe57d11e2.vnode(e), e;
}
function $4e0ca152409a9912$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $4e0ca152409a9912$export$ffb0004e005737fa(n) {
    return n.children;
}
function $4e0ca152409a9912$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $4e0ca152409a9912$var$S(n, l) {
    if (null == l) return n.__ ? $4e0ca152409a9912$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $4e0ca152409a9912$var$S(n) : null;
}
function $4e0ca152409a9912$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $4e0ca152409a9912$var$C(n);
    }
}
function $4e0ca152409a9912$var$M(n) {
    (!n.__d && (n.__d = !0) && $4e0ca152409a9912$var$i.push(n) && !$4e0ca152409a9912$var$$.__r++ || $4e0ca152409a9912$var$r != $4e0ca152409a9912$export$41c562ebe57d11e2.debounceRendering) && (($4e0ca152409a9912$var$r = $4e0ca152409a9912$export$41c562ebe57d11e2.debounceRendering) || $4e0ca152409a9912$var$o)($4e0ca152409a9912$var$$);
}
function $4e0ca152409a9912$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $4e0ca152409a9912$var$i.length;)$4e0ca152409a9912$var$i.length > s && $4e0ca152409a9912$var$i.sort($4e0ca152409a9912$var$e), n = $4e0ca152409a9912$var$i.shift(), s = $4e0ca152409a9912$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $4e0ca152409a9912$var$d({}, r)).__v = r.__v + 1, $4e0ca152409a9912$export$41c562ebe57d11e2.vnode && $4e0ca152409a9912$export$41c562ebe57d11e2.vnode(t), $4e0ca152409a9912$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $4e0ca152409a9912$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $4e0ca152409a9912$var$N(f, t, c), t.__e != o && $4e0ca152409a9912$var$C(t)));
    $4e0ca152409a9912$var$$.__r = 0;
}
function $4e0ca152409a9912$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _, m = t && t.__k || $4e0ca152409a9912$var$v, b = l.length;
    for(f = $4e0ca152409a9912$var$P(u, l, m, f, b), a = 0; a < b; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $4e0ca152409a9912$var$p : m[y.__i] || $4e0ca152409a9912$var$p, y.__i = a, g = $4e0ca152409a9912$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $4e0ca152409a9912$var$B(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), (_ = !!(4 & y.__u)) || h.__k === y.__k ? f = $4e0ca152409a9912$var$A(y, f, n, _) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $4e0ca152409a9912$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $4e0ca152409a9912$var$m(null, o, null, null, null) : $4e0ca152409a9912$var$w(o) ? $4e0ca152409a9912$var$m($4e0ca152409a9912$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $4e0ca152409a9912$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $4e0ca152409a9912$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $4e0ca152409a9912$var$S(e)), $4e0ca152409a9912$var$D(e, e));
    return t;
}
function $4e0ca152409a9912$var$A(n, l, u, t) {
    var i, r;
    if ("function" == typeof n.type) {
        for(i = n.__k, r = 0; i && r < i.length; r++)i[r] && (i[r].__ = n, l = $4e0ca152409a9912$var$A(i[r], l, u, t));
        return l;
    }
    n.__e != l && (t && (l && n.type && !l.parentNode && (l = $4e0ca152409a9912$var$S(n)), u.insertBefore(n.__e, l || null)), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $4e0ca152409a9912$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($4e0ca152409a9912$var$w(n) ? n.some(function(n) {
        $4e0ca152409a9912$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $4e0ca152409a9912$var$L(n, l, u, t) {
    var i, r, o, e = n.key, f = n.type, c = l[u], s = null != c && 0 == (2 & c.__u);
    if (null === c && null == n.key || s && e == c.key && f == c.type) return u;
    if (t > (s ? 1 : 0)) {
        for(i = u - 1, r = u + 1; i >= 0 || r < l.length;)if (null != (c = l[o = i >= 0 ? i-- : r++]) && 0 == (2 & c.__u) && e == c.key && f == c.type) return o;
    }
    return -1;
}
function $4e0ca152409a9912$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $4e0ca152409a9912$var$y.test(l) ? u : u + "px";
}
function $4e0ca152409a9912$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $4e0ca152409a9912$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $4e0ca152409a9912$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($4e0ca152409a9912$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $4e0ca152409a9912$var$c, n.addEventListener(l, r ? $4e0ca152409a9912$var$a : $4e0ca152409a9912$var$s, r)) : n.removeEventListener(l, r ? $4e0ca152409a9912$var$a : $4e0ca152409a9912$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $4e0ca152409a9912$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $4e0ca152409a9912$var$c++;
            else if (u.t < t.u) return;
            return t($4e0ca152409a9912$export$41c562ebe57d11e2.event ? $4e0ca152409a9912$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $4e0ca152409a9912$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $4e0ca152409a9912$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $4e0ca152409a9912$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $4e0ca152409a9912$var$E), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $4e0ca152409a9912$var$d({}, h.__s)), $4e0ca152409a9912$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $4e0ca152409a9912$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $4e0ca152409a9912$var$d($4e0ca152409a9912$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $4e0ca152409a9912$export$ffb0004e005737fa && null == a.key && (L = $4e0ca152409a9912$var$V(a.props.children)), f = $4e0ca152409a9912$var$I(n, $4e0ca152409a9912$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else {
                for(T = o.length; T--;)$4e0ca152409a9912$var$g(o[T]);
                $4e0ca152409a9912$var$z(u);
            }
        } else u.__e = t.__e, u.__k = t.__k, n.then || $4e0ca152409a9912$var$z(u);
        $4e0ca152409a9912$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $4e0ca152409a9912$var$q(t.__e, u, t, i, r, o, e, c, s);
    return (a = $4e0ca152409a9912$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $4e0ca152409a9912$var$z(n) {
    n && n.__c && (n.__c.__e = !0), n && n.__k && n.__k.forEach($4e0ca152409a9912$var$z);
}
function $4e0ca152409a9912$var$N(n, u, t) {
    for(var i = 0; i < t.length; i++)$4e0ca152409a9912$var$B(t[i], t[++i], t[++i]);
    $4e0ca152409a9912$export$41c562ebe57d11e2.__c && $4e0ca152409a9912$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $4e0ca152409a9912$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $4e0ca152409a9912$var$V(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $4e0ca152409a9912$var$w(n) ? n.map($4e0ca152409a9912$var$V) : $4e0ca152409a9912$var$d({}, n);
}
function $4e0ca152409a9912$var$q(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($4e0ca152409a9912$export$41c562ebe57d11e2.__m && $4e0ca152409a9912$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $4e0ca152409a9912$var$n.call(u.childNodes), b = i.props || $4e0ca152409a9912$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $4e0ca152409a9912$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $4e0ca152409a9912$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $4e0ca152409a9912$var$I("template" == t.type ? u.content : u, $4e0ca152409a9912$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $4e0ca152409a9912$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$4e0ca152409a9912$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $4e0ca152409a9912$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $4e0ca152409a9912$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $4e0ca152409a9912$var$B(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $4e0ca152409a9912$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $4e0ca152409a9912$var$D(n, u, t) {
    var i, r;
    if ($4e0ca152409a9912$export$41c562ebe57d11e2.unmount && $4e0ca152409a9912$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $4e0ca152409a9912$var$B(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $4e0ca152409a9912$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $4e0ca152409a9912$var$D(i[r], u, t || "function" != typeof n.type);
    t || $4e0ca152409a9912$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $4e0ca152409a9912$var$E(n, l, u) {
    return this.constructor(n, u);
}
function $4e0ca152409a9912$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $4e0ca152409a9912$export$41c562ebe57d11e2.__ && $4e0ca152409a9912$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $4e0ca152409a9912$var$O(t, u = (!r && i || t).__k = $4e0ca152409a9912$export$c8a8987d4410bf2d($4e0ca152409a9912$export$ffb0004e005737fa, null, [
        u
    ]), o || $4e0ca152409a9912$var$p, $4e0ca152409a9912$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $4e0ca152409a9912$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $4e0ca152409a9912$var$N(e, u, f);
}
function $4e0ca152409a9912$export$fa8d919ba61d84db(n, l) {
    $4e0ca152409a9912$export$b3890eb0ae9dca99(n, l, $4e0ca152409a9912$export$fa8d919ba61d84db);
}
function $4e0ca152409a9912$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $4e0ca152409a9912$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $4e0ca152409a9912$var$n.call(arguments, 2) : t), $4e0ca152409a9912$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $4e0ca152409a9912$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $4e0ca152409a9912$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $4e0ca152409a9912$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$4e0ca152409a9912$var$n = $4e0ca152409a9912$var$v.slice, $4e0ca152409a9912$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $4e0ca152409a9912$var$u = 0, $4e0ca152409a9912$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $4e0ca152409a9912$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $4e0ca152409a9912$var$d({}, this.state), "function" == typeof n && (n = n($4e0ca152409a9912$var$d({}, u), this.props)), n && $4e0ca152409a9912$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $4e0ca152409a9912$var$M(this));
}, $4e0ca152409a9912$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $4e0ca152409a9912$var$M(this));
}, $4e0ca152409a9912$export$16fa2f45be04daa8.prototype.render = $4e0ca152409a9912$export$ffb0004e005737fa, $4e0ca152409a9912$var$i = [], $4e0ca152409a9912$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $4e0ca152409a9912$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $4e0ca152409a9912$var$$.__r = 0, $4e0ca152409a9912$var$f = /(PointerCapture)$|Capture$/i, $4e0ca152409a9912$var$c = 0, $4e0ca152409a9912$var$s = $4e0ca152409a9912$var$F(!1), $4e0ca152409a9912$var$a = $4e0ca152409a9912$var$F(!0), $4e0ca152409a9912$var$h = 0;


/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 */ function $1fa2684c81960768$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    if (!('nodeType' in obj)) return false;
    return obj.nodeType === Node.ELEMENT_NODE;
}


function $575ee8287eb62b26$var$findDOMElement(element, context) {
    if (context === void 0) context = document;
    if (typeof element === 'string') return context.querySelector(element);
    if ((0, $1fa2684c81960768$export$2e2bcd8739ae039)(element)) return element;
    return null;
}
var $575ee8287eb62b26$export$2e2bcd8739ae039 = $575ee8287eb62b26$var$findDOMElement;


/**
 * Get the declared text direction for an element.
 */ function $a17051e4531cfe7d$var$getTextDirection(element) {
    var _element;
    // There is another way to determine text direction using getComputedStyle(), as done here:
    // https://github.com/pencil-js/text-direction/blob/2a235ce95089b3185acec3b51313cbba921b3811/text-direction.js
    //
    // We do not use that approach because we are interested specifically in the _declared_ text direction.
    // If no text direction is declared, we have to provide our own explicit text direction so our
    // bidirectional CSS style sheets work.
    while(element && !element.dir)// eslint-disable-next-line no-param-reassign
    element = element.parentNode;
    return (_element = element) == null ? void 0 : _element.dir;
}
var $a17051e4531cfe7d$export$2e2bcd8739ae039 = $a17051e4531cfe7d$var$getTextDirection;


/* eslint-disable class-methods-use-this */ /**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */ 
class $aaca8ff080553d35$export$2e2bcd8739ae039 {
    constructor(uppy, opts){
        this.uppy = uppy;
        this.opts = opts != null ? opts : {};
    }
    getPluginState() {
        const { plugins: plugins } = this.uppy.getState();
        return (plugins == null ? void 0 : plugins[this.id]) || {};
    }
    setPluginState(update) {
        const { plugins: plugins } = this.uppy.getState();
        this.uppy.setState({
            plugins: {
                ...plugins,
                [this.id]: {
                    ...plugins[this.id],
                    ...update
                }
            }
        });
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts
        };
        this.setPluginState(undefined); // so that UI re-renders with new options
        this.i18nInit();
    }
    i18nInit() {
        const translator = new (0, $c997a156bd6937f3$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.uppy.locale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.setPluginState(undefined); // so that UI re-renders and we see the updated locale
    }
    /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addTarget(plugin) {
        throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {}
    uninstall() {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(state) {}
    // Called after every state update, after everything's mounted. Debounced.
    afterUpdate() {}
}


function $060f749236ff2adb$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $060f749236ff2adb$var$id = 0;
function $060f749236ff2adb$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $060f749236ff2adb$var$id++ + "_" + name;
}
/**
 * Defer a frequent call to the microtask queue.
 */ function $060f749236ff2adb$var$debounce(fn) {
    let calling = null;
    let latestArgs;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        latestArgs = args;
        if (!calling) calling = Promise.resolve().then(()=>{
            calling = null;
            // At this point `args` may be different from the most
            // recent state, if multiple calls happened since this task
            // was queued. So we use the `latestArgs`, which definitely
            // is the most recent call.
            return fn(...latestArgs);
        });
        return calling;
    };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */ var $060f749236ff2adb$var$_updateUI = /*#__PURE__*/ $060f749236ff2adb$var$_classPrivateFieldLooseKey("updateUI");
class $060f749236ff2adb$var$UIPlugin extends (0, $aaca8ff080553d35$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, $060f749236ff2adb$var$_updateUI, {
            writable: true,
            value: void 0
        });
    }
    getTargetPlugin(target // eslint-disable-line no-use-before-define
    ) {
        let targetPlugin;
        if (typeof (target == null ? void 0 : target.addTarget) === 'function') {
            // Targeting a plugin *instance*
            targetPlugin = target;
            if (!(targetPlugin instanceof $060f749236ff2adb$var$UIPlugin)) // eslint-disable-next-line no-console
            console.warn(new Error('The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.', {
                cause: {
                    targetPlugin: targetPlugin,
                    UIPlugin: $060f749236ff2adb$var$UIPlugin
                }
            }));
        } else if (typeof target === 'function') {
            // Targeting a plugin type
            const Target = target;
            // Find the target plugin instance.
            this.uppy.iteratePlugins((p)=>{
                if (p instanceof Target) targetPlugin = p;
            });
        }
        return targetPlugin;
    }
    /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */ mount(target, // eslint-disable-line no-use-before-define
    plugin) {
        const callerPluginName = plugin.id;
        const targetElement = (0, $575ee8287eb62b26$export$2e2bcd8739ae039)(target);
        if (targetElement) {
            this.isTargetDOMEl = true;
            // When target is <body> with a single <div> element,
            // Preact thinks it’s the Uppy root element in there when doing a diff,
            // and destroys it. So we are creating a fragment (could be empty div)
            const uppyRootElement = document.createElement('div');
            uppyRootElement.classList.add('uppy-Root');
            // API for plugins that require a synchronous rerender.
            $060f749236ff2adb$var$_classPrivateFieldLooseBase(this, $060f749236ff2adb$var$_updateUI)[$060f749236ff2adb$var$_updateUI] = $060f749236ff2adb$var$debounce((state)=>{
                // plugin could be removed, but this.rerender is debounced below,
                // so it could still be called even after uppy.removePlugin or uppy.close
                // hence the check
                if (!this.uppy.getPlugin(this.id)) return;
                (0, $4e0ca152409a9912$export$b3890eb0ae9dca99)(this.render(state), uppyRootElement);
                this.afterUpdate();
            });
            this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
            if (this.opts.replaceTargetContent) // Doing render(h(null), targetElement), which should have been
            // a better way, since because the component might need to do additional cleanup when it is removed,
            // stopped working — Preact just adds null into target, not replacing
            targetElement.innerHTML = '';
            (0, $4e0ca152409a9912$export$b3890eb0ae9dca99)(this.render(this.uppy.getState()), uppyRootElement);
            this.el = uppyRootElement;
            targetElement.appendChild(uppyRootElement);
            // Set the text direction if the page has not defined one.
            uppyRootElement.dir = this.opts.direction || (0, $a17051e4531cfe7d$export$2e2bcd8739ae039)(uppyRootElement) || 'ltr';
            this.onMount();
            return this.el;
        }
        const targetPlugin = this.getTargetPlugin(target);
        if (targetPlugin) {
            this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
            this.parent = targetPlugin;
            this.el = targetPlugin.addTarget(plugin);
            this.onMount();
            return this.el;
        }
        this.uppy.log(`Not installing ${callerPluginName}`);
        let message = `Invalid target option given to ${callerPluginName}.`;
        if (typeof target === 'function') message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
        else message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
        throw new Error(message);
    }
    /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    render(state) {
        throw new Error('Extend the render method to add your plugin to a DOM element');
    }
    update(state) {
        if (this.el != null) {
            var _classPrivateFieldLoo, _classPrivateFieldLoo2;
            (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = $060f749236ff2adb$var$_classPrivateFieldLooseBase(this, $060f749236ff2adb$var$_updateUI))[$060f749236ff2adb$var$_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
        }
    }
    unmount() {
        if (this.isTargetDOMEl) {
            var _this$el;
            (_this$el = this.el) == null || _this$el.remove();
        }
        this.onUnmount();
    }
    onMount() {}
    onUnmount() {}
}
var $060f749236ff2adb$export$2e2bcd8739ae039 = $060f749236ff2adb$var$UIPlugin;


/**
 * Converts list into array
 */ var $178a0ac8c0af6e5c$export$2e2bcd8739ae039 = Array.from;


/**
 * Checks if the browser supports Drag & Drop (not supported on mobile devices, for example).
 */ function $7b41cadcbda31d01$export$2e2bcd8739ae039() {
    const div = document.body;
    if (!('draggable' in div) || !('ondragstart' in div && 'ondrop' in div)) return false;
    if (!('FormData' in window)) return false;
    if (!('FileReader' in window)) return false;
    return true;
}


/**
 * Recursive function, calls the original callback() when the directory is entirely parsed.
 */ function $b16931d296b3cf4a$export$2e2bcd8739ae039(directoryReader, oldEntries, logDropError, _ref) {
    let { onSuccess: onSuccess } = _ref;
    directoryReader.readEntries((entries)=>{
        const newEntries = [
            ...oldEntries,
            ...entries
        ];
        // According to the FileSystem API spec, getFilesAndDirectoriesFromDirectory()
        // must be called until it calls the onSuccess with an empty array.
        if (entries.length) queueMicrotask(()=>{
            $b16931d296b3cf4a$export$2e2bcd8739ae039(directoryReader, newEntries, logDropError, {
                onSuccess: onSuccess
            });
        });
        else onSuccess(newEntries);
    }, // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error)=>{
        logDropError(error);
        onSuccess(oldEntries);
    });
}


/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */ function $515e0c00a6bf6c79$var$getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        kind: // eslint-disable-next-line no-nested-ternary
        entry.isFile ? 'file' : entry.isDirectory ? 'directory' : undefined,
        name: entry.name,
        getFile () {
            return new Promise((resolve, reject)=>entry.file(resolve, reject));
        },
        async *values () {
            // If the file is a directory.
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve)=>{
                (0, $b16931d296b3cf4a$export$2e2bcd8739ae039)(directoryReader, [], logDropError, {
                    onSuccess: (dirEntries)=>resolve(dirEntries.map((file)=>$515e0c00a6bf6c79$var$getAsFileSystemHandleFromEntry(file, logDropError)))
                });
            });
            yield* entries;
        },
        isSameEntry: undefined
    };
}
function $515e0c00a6bf6c79$var$createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
    try {
        if (lastResortFile === void 0) lastResortFile = undefined;
        return async function*() {
            const getNextRelativePath = ()=>`${relativePath}/${entry.name}`;
            // For each dropped item, - make sure it's a file/directory, and start deepening in!
            if (entry.kind === 'file') {
                const file = await entry.getFile();
                if (file != null) {
                    file.relativePath = relativePath ? getNextRelativePath() : null;
                    yield file;
                } else if (lastResortFile != null) yield lastResortFile;
            } else if (entry.kind === 'directory') for await (const handle of entry.values())// Recurse on the directory, appending the dir name to the relative path
            yield* $515e0c00a6bf6c79$var$createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
            else if (lastResortFile != null) yield lastResortFile;
        }();
    } catch (e) {
        return Promise.reject(e);
    }
}
async function* $515e0c00a6bf6c79$export$2e2bcd8739ae039(dataTransfer, logDropError) {
    // Retrieving the dropped items must happen synchronously
    // otherwise only the first item gets treated and the other ones are garbage collected.
    // https://github.com/transloadit/uppy/pull/3998
    const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item)=>{
        var _fileSystemHandle;
        let fileSystemHandle;
        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
        // if (window.isSecureContext && item.getAsFileSystemHandle != null)
        // fileSystemHandle = await item.getAsFileSystemHandle()
        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
        const getAsEntry = ()=>typeof item.getAsEntry === 'function' ? item.getAsEntry() : item.webkitGetAsEntry();
        // eslint-disable-next-line prefer-const
        (_fileSystemHandle = fileSystemHandle) != null ? _fileSystemHandle : fileSystemHandle = $515e0c00a6bf6c79$var$getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
        return {
            fileSystemHandle: fileSystemHandle,
            lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail
        };
    }));
    for (const { lastResortFile: lastResortFile, fileSystemHandle: fileSystemHandle } of fileSystemHandles){
        // fileSystemHandle and lastResortFile can be null when we drop an url.
        if (fileSystemHandle != null) try {
            yield* $515e0c00a6bf6c79$var$createPromiseToAddFileOrParseDirectory(fileSystemHandle, '', lastResortFile);
        } catch (err) {
            // Example: If dropping a symbolic link, Chromium will throw:
            // "DOMException: A requested file or directory could not be found at the time an operation was processed.",
            // So we will use lastResortFile instead. See https://github.com/transloadit/uppy/issues/3505.
            if (lastResortFile != null) yield lastResortFile;
            else logDropError(err);
        }
        else if (lastResortFile != null) yield lastResortFile;
    }
}



function $9d1648efa51077eb$export$2e2bcd8739ae039(dataTransfer) {
    const files = (0, $178a0ac8c0af6e5c$export$2e2bcd8739ae039)(dataTransfer.files);
    return Promise.resolve(files);
}


async function $4ce4cbaf958081a1$export$2e2bcd8739ae039(dataTransfer, options) {
    var _options$logDropError;
    // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari
    const logDropError = (_options$logDropError = options == null ? void 0 : options.logDropError) != null ? _options$logDropError : Function.prototype;
    try {
        const accumulator = [];
        for await (const file of (0, $515e0c00a6bf6c79$export$2e2bcd8739ae039)(dataTransfer, logDropError))accumulator.push(file);
        return accumulator;
    // Otherwise just return all first-order files
    } catch  {
        return (0, $9d1648efa51077eb$export$2e2bcd8739ae039)(dataTransfer);
    }
}



var $45e149ed921bfa9b$export$2e2bcd8739ae039 = {
    strings: {
        // Text to show on the droppable area.
        // `%{browse}` is replaced with a link that opens the system file selection dialog.
        dropHereOr: 'Drop here or %{browse}',
        // Used as the label for the link that opens the system file selection dialog.
        browse: 'browse'
    }
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $e7163d8793c4d860$var$packageJson = {
    "version": "3.1.1"
};
// Default options, must be kept in sync with @uppy/react/src/DragDrop.js.
const $e7163d8793c4d860$var$defaultOptions = {
    inputName: 'files[]',
    width: '100%',
    height: '100%'
};
class $e7163d8793c4d860$export$2e2bcd8739ae039 extends (0, $060f749236ff2adb$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$e7163d8793c4d860$var$defaultOptions,
            ...opts
        });
        // Check for browser dragDrop support
        this.isDragDropSupported = (0, $7b41cadcbda31d01$export$2e2bcd8739ae039)();
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        this.onInputChange = (event)=>{
            const files = (0, $178a0ac8c0af6e5c$export$2e2bcd8739ae039)(event.target.files);
            if (files.length > 0) {
                this.uppy.log('[DragDrop] Files selected through input');
                this.addFiles(files);
            }
            // We clear the input after a file is selected, because otherwise
            // change event is not fired in Chrome and Safari when a file
            // with the same name is selected.
            // ___Why not use value="" on <input/> instead?
            //    Because if we use that method of clearing the input,
            //    Chrome will not trigger change if we drop the same file twice (Issue #768).
            // @ts-expect-error TS freaks out, but this is fine
            // eslint-disable-next-line no-param-reassign
            event.target.value = null;
        };
        this.handleDragOver = (event)=>{
            var _this$opts$onDragOver, _this$opts;
            event.preventDefault();
            event.stopPropagation();
            // Check if the "type" of the datatransfer object includes files. If not, deny drop.
            const { types: types } = event.dataTransfer;
            const hasFiles = types.some((type)=>type === 'Files');
            const { allowNewUpload: allowNewUpload } = this.uppy.getState();
            if (!hasFiles || !allowNewUpload) {
                // eslint-disable-next-line no-param-reassign
                event.dataTransfer.dropEffect = 'none';
                clearTimeout(this.removeDragOverClassTimeout);
                return;
            }
            // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the browser
            // https://github.com/transloadit/uppy/issues/1978)
            //
            // eslint-disable-next-line no-param-reassign
            event.dataTransfer.dropEffect = 'copy';
            clearTimeout(this.removeDragOverClassTimeout);
            this.setPluginState({
                isDraggingOver: true
            });
            (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
        };
        this.handleDragLeave = (event)=>{
            var _this$opts$onDragLeav, _this$opts2;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            // Timeout against flickering, this solution is taken from drag-drop library.
            // Solution with 'pointer-events: none' didn't work across browsers.
            this.removeDragOverClassTimeout = setTimeout(()=>{
                this.setPluginState({
                    isDraggingOver: false
                });
            }, 50);
            (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
        };
        this.handleDrop = async (event)=>{
            var _this$opts$onDrop, _this$opts3;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            // Remove dragover class
            this.setPluginState({
                isDraggingOver: false
            });
            const logDropError = (error)=>{
                this.uppy.log(error, 'error');
            };
            // Add all dropped files
            const files = await (0, $4ce4cbaf958081a1$export$2e2bcd8739ae039)(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log('[DragDrop] Files dropped');
                this.addFiles(files);
            }
            (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
        };
        this.type = 'acquirer';
        this.id = this.opts.id || 'DragDrop';
        this.title = 'Drag & Drop';
        this.defaultLocale = (0, $45e149ed921bfa9b$export$2e2bcd8739ae039);
        this.i18nInit();
    }
    renderHiddenFileInput() {
        const { restrictions: restrictions } = this.uppy.opts;
        return (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("input", {
            className: "uppy-DragDrop-input",
            type: "file",
            hidden: true,
            ref: (ref)=>{
                this.fileInputRef = ref;
            },
            name: this.opts.inputName,
            multiple: restrictions.maxNumberOfFiles !== 1,
            accept: restrictions.allowedFileTypes,
            onChange: this.onInputChange
        });
    }
    static renderArrowSvg() {
        return (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-DragDrop-arrow",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16"
        }, (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("path", {
            d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
            fillRule: "evenodd"
        }));
    }
    renderLabel() {
        return (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("div", {
            className: "uppy-DragDrop-label"
        }, this.i18nArray('dropHereOr', {
            browse: (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("span", {
                className: "uppy-DragDrop-browse"
            }, this.i18n('browse'))
        }));
    }
    renderNote() {
        return (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DragDrop-note"
        }, this.opts.note);
    }
    render() {
        const dragDropClass = `uppy-u-reset
      uppy-DragDrop-container
      ${this.isDragDropSupported ? 'uppy-DragDrop--isDragDropSupported' : ''}
      ${this.getPluginState().isDraggingOver ? 'uppy-DragDrop--isDraggingOver' : ''}
    `;
        const dragDropStyle = {
            width: this.opts.width,
            height: this.opts.height
        };
        return (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("button", {
            type: "button",
            className: dragDropClass,
            style: dragDropStyle,
            onClick: ()=>this.fileInputRef.click(),
            onDragOver: this.handleDragOver,
            onDragLeave: this.handleDragLeave,
            onDrop: this.handleDrop
        }, this.renderHiddenFileInput(), (0, $4e0ca152409a9912$export$c8a8987d4410bf2d)("div", {
            className: "uppy-DragDrop-inner"
        }, $e7163d8793c4d860$export$2e2bcd8739ae039.renderArrowSvg(), this.renderLabel(), this.renderNote()));
    }
    install() {
        const { target: target } = this.opts;
        this.setPluginState({
            isDraggingOver: false
        });
        if (target) this.mount(target, this);
    }
    uninstall() {
        this.unmount();
    }
}
$e7163d8793c4d860$export$2e2bcd8739ae039.VERSION = $e7163d8793c4d860$var$packageJson.version;







// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $58fa31c1ed3042b1$var$packageJson = {
    "version": "2.1.0"
};
// Default options
const $58fa31c1ed3042b1$var$defaultOpts = {
    target: null
};
function $58fa31c1ed3042b1$var$isFileTransfer(event) {
    var _event$dataTransfer$t, _event$dataTransfer;
    return (_event$dataTransfer$t = (_event$dataTransfer = event.dataTransfer) == null || (_event$dataTransfer = _event$dataTransfer.types) == null ? void 0 : _event$dataTransfer.some((type)=>type === 'Files')) != null ? _event$dataTransfer$t : false;
}
class $58fa31c1ed3042b1$export$2e2bcd8739ae039 extends (0, $aaca8ff080553d35$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$58fa31c1ed3042b1$var$defaultOpts,
            ...opts
        });
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        this.handleDrop = async (event)=>{
            var _event$currentTarget, _this$opts$onDrop, _this$opts;
            if (!$58fa31c1ed3042b1$var$isFileTransfer(event)) return;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            (_event$currentTarget = event.currentTarget) == null || _event$currentTarget.classList.remove('uppy-is-drag-over');
            this.setPluginState({
                isDraggingOver: false
            });
            // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === 'acquirer') // @ts-expect-error Every Plugin with .type acquirer can define handleRootDrop(event)
                plugin.handleRootDrop == null || plugin.handleRootDrop(event);
            });
            // Add all dropped files, handle errors
            let executedDropErrorOnce = false;
            const logDropError = (error)=>{
                this.uppy.log(error, 'error');
                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                    this.uppy.info(error.message, 'error');
                    executedDropErrorOnce = true;
                }
            };
            const files = await (0, $4ce4cbaf958081a1$export$2e2bcd8739ae039)(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log('[DropTarget] Files were dropped');
                this.addFiles(files);
            }
            (_this$opts$onDrop = (_this$opts = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts, event);
        };
        this.handleDragOver = (event)=>{
            var _this$opts$onDragOver, _this$opts2;
            if (!$58fa31c1ed3042b1$var$isFileTransfer(event)) return;
            event.preventDefault();
            event.stopPropagation();
            // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the browser,
            // https://github.com/transloadit/uppy/issues/1978)
            event.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
            clearTimeout(this.removeDragOverClassTimeout);
            event.currentTarget.classList.add('uppy-is-drag-over');
            this.setPluginState({
                isDraggingOver: true
            });
            (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts2, event);
        };
        this.handleDragLeave = (event)=>{
            var _this$opts$onDragLeav, _this$opts3;
            if (!$58fa31c1ed3042b1$var$isFileTransfer(event)) return;
            event.preventDefault();
            event.stopPropagation();
            const { currentTarget: currentTarget } = event;
            clearTimeout(this.removeDragOverClassTimeout);
            // Timeout against flickering, this solution is taken from drag-drop library.
            // Solution with 'pointer-events: none' didn't work across browsers.
            this.removeDragOverClassTimeout = setTimeout(()=>{
                currentTarget.classList.remove('uppy-is-drag-over');
                this.setPluginState({
                    isDraggingOver: false
                });
            }, 50);
            (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts3, event);
        };
        this.addListeners = ()=>{
            const { target: target } = this.opts;
            if (target instanceof Element) this.nodes = [
                target
            ];
            else if (typeof target === 'string') this.nodes = (0, $178a0ac8c0af6e5c$export$2e2bcd8739ae039)(document.querySelectorAll(target));
            if (!this.nodes || this.nodes.length === 0) throw new Error(`"${target}" does not match any HTML elements`);
            this.nodes.forEach((node)=>{
                node.addEventListener('dragover', this.handleDragOver, false);
                node.addEventListener('dragleave', this.handleDragLeave, false);
                node.addEventListener('drop', this.handleDrop, false);
            });
        };
        this.removeListeners = ()=>{
            if (this.nodes) this.nodes.forEach((node)=>{
                node.removeEventListener('dragover', this.handleDragOver, false);
                node.removeEventListener('dragleave', this.handleDragLeave, false);
                node.removeEventListener('drop', this.handleDrop, false);
            });
        };
        this.type = 'acquirer';
        this.id = this.opts.id || 'DropTarget';
        // @ts-expect-error TODO: remove in major
        this.title = 'Drop Target';
    }
    install() {
        this.setPluginState({
            isDraggingOver: false
        });
        this.addListeners();
    }
    uninstall() {
        this.removeListeners();
    }
}
$58fa31c1ed3042b1$export$2e2bcd8739ae039.VERSION = $58fa31c1ed3042b1$var$packageJson.version;






function $7bdf638cc3f095b6$export$78406e843f5312da(byte) {
    return `${byte < 0 ? "-" : ""}0x${Math.abs(byte).toString(16).padStart(2, "0")}`;
}


// ExtensionCodec to handle MessagePack extensions
/**
 * ExtData is used to handle Extension Types that are not registered to ExtensionCodec.
 */ class $4c590382d717c63b$export$bcbeb236456bc779 {
    constructor(type, data){
        this.type = type;
        this.data = data;
    }
}


// https://github.com/msgpack/msgpack/blob/master/spec.md#timestamp-extension-type
class $87d968ef13b62755$export$ef3eed12d06c0285 extends Error {
    constructor(message){
        super(message);
        // fix the prototype chain in a cross-platform way
        const proto = Object.create($87d968ef13b62755$export$ef3eed12d06c0285.prototype);
        Object.setPrototypeOf(this, proto);
        Object.defineProperty(this, "name", {
            configurable: true,
            enumerable: false,
            value: $87d968ef13b62755$export$ef3eed12d06c0285.name
        });
    }
}


// Integer Utility
const $71754ee758078552$export$3314b2c271c86d70 = 4294967295;
function $71754ee758078552$export$20f71c4c8b0f96c3(view, offset, value) {
    const high = value / 4294967296;
    const low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $71754ee758078552$export$8532a5209571c04a(view, offset, value) {
    const high = Math.floor(value / 4294967296);
    const low = value; // high bits are truncated by DataView
    view.setUint32(offset, high);
    view.setUint32(offset + 4, low);
}
function $71754ee758078552$export$69825c7adcc820c6(view, offset) {
    const high = view.getInt32(offset);
    const low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}
function $71754ee758078552$export$59a2dbf579ff9568(view, offset) {
    const high = view.getUint32(offset);
    const low = view.getUint32(offset + 4);
    return high * 4294967296 + low;
}


const $d02f1e1b555b6a48$export$f18369fc203f4e13 = -1;
const $d02f1e1b555b6a48$var$TIMESTAMP32_MAX_SEC = 4294967295; // 32-bit unsigned int
const $d02f1e1b555b6a48$var$TIMESTAMP64_MAX_SEC = 17179869183; // 34-bit unsigned int
function $d02f1e1b555b6a48$export$2fd05b828dd81159({ sec: sec, nsec: nsec }) {
    if (sec >= 0 && nsec >= 0 && sec <= $d02f1e1b555b6a48$var$TIMESTAMP64_MAX_SEC) {
        // Here sec >= 0 && nsec >= 0
        if (nsec === 0 && sec <= $d02f1e1b555b6a48$var$TIMESTAMP32_MAX_SEC) {
            // timestamp 32 = { sec32 (unsigned) }
            const rv = new Uint8Array(4);
            const view = new DataView(rv.buffer);
            view.setUint32(0, sec);
            return rv;
        } else {
            // timestamp 64 = { nsec30 (unsigned), sec34 (unsigned) }
            const secHigh = sec / 0x100000000;
            const secLow = sec & 0xffffffff;
            const rv = new Uint8Array(8);
            const view = new DataView(rv.buffer);
            // nsec30 | secHigh2
            view.setUint32(0, nsec << 2 | secHigh & 0x3);
            // secLow32
            view.setUint32(4, secLow);
            return rv;
        }
    } else {
        // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
        const rv = new Uint8Array(12);
        const view = new DataView(rv.buffer);
        view.setUint32(0, nsec);
        (0, $71754ee758078552$export$8532a5209571c04a)(view, 4, sec);
        return rv;
    }
}
function $d02f1e1b555b6a48$export$221d97b3b00b03c2(date) {
    const msec = date.getTime();
    const sec = Math.floor(msec / 1e3);
    const nsec = (msec - sec * 1e3) * 1e6;
    // Normalizes { sec, nsec } to ensure nsec is unsigned.
    const nsecInSec = Math.floor(nsec / 1e9);
    return {
        sec: sec + nsecInSec,
        nsec: nsec - nsecInSec * 1e9
    };
}
function $d02f1e1b555b6a48$export$32420f352fe0fc83(object) {
    if (object instanceof Date) {
        const timeSpec = $d02f1e1b555b6a48$export$221d97b3b00b03c2(object);
        return $d02f1e1b555b6a48$export$2fd05b828dd81159(timeSpec);
    } else return null;
}
function $d02f1e1b555b6a48$export$abfc8800a5159711(data) {
    const view = new DataView(data.buffer, data.byteOffset, data.byteLength);
    // data may be 32, 64, or 96 bits
    switch(data.byteLength){
        case 4:
            {
                // timestamp 32 = { sec32 }
                const sec = view.getUint32(0);
                const nsec = 0;
                return {
                    sec: sec,
                    nsec: nsec
                };
            }
        case 8:
            {
                // timestamp 64 = { nsec30, sec34 }
                const nsec30AndSecHigh2 = view.getUint32(0);
                const secLow32 = view.getUint32(4);
                const sec = (nsec30AndSecHigh2 & 0x3) * 0x100000000 + secLow32;
                const nsec = nsec30AndSecHigh2 >>> 2;
                return {
                    sec: sec,
                    nsec: nsec
                };
            }
        case 12:
            {
                // timestamp 96 = { nsec32 (unsigned), sec64 (signed) }
                const sec = (0, $71754ee758078552$export$69825c7adcc820c6)(view, 4);
                const nsec = view.getUint32(0);
                return {
                    sec: sec,
                    nsec: nsec
                };
            }
        default:
            throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Unrecognized data size for timestamp (expected 4, 8, or 12): ${data.length}`);
    }
}
function $d02f1e1b555b6a48$export$80b8ff9315e4298f(data) {
    const timeSpec = $d02f1e1b555b6a48$export$abfc8800a5159711(data);
    return new Date(timeSpec.sec * 1e3 + timeSpec.nsec / 1e6);
}
const $d02f1e1b555b6a48$export$8654479533463da1 = {
    type: $d02f1e1b555b6a48$export$f18369fc203f4e13,
    encode: $d02f1e1b555b6a48$export$32420f352fe0fc83,
    decode: $d02f1e1b555b6a48$export$80b8ff9315e4298f
};


class $02feec7394dad08d$export$12677a794dbd89d7 {
    constructor(){
        // built-in extensions
        this.builtInEncoders = [];
        this.builtInDecoders = [];
        // custom extensions
        this.encoders = [];
        this.decoders = [];
        this.register((0, $d02f1e1b555b6a48$export$8654479533463da1));
    }
    register({ type: type, encode: encode, decode: decode }) {
        if (type >= 0) {
            // custom extensions
            this.encoders[type] = encode;
            this.decoders[type] = decode;
        } else {
            // built-in extensions
            const index = -1 - type;
            this.builtInEncoders[index] = encode;
            this.builtInDecoders[index] = decode;
        }
    }
    tryToEncode(object, context) {
        // built-in extensions
        for(let i = 0; i < this.builtInEncoders.length; i++){
            const encodeExt = this.builtInEncoders[i];
            if (encodeExt != null) {
                const data = encodeExt(object, context);
                if (data != null) {
                    const type = -1 - i;
                    return new (0, $4c590382d717c63b$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        // custom extensions
        for(let i = 0; i < this.encoders.length; i++){
            const encodeExt = this.encoders[i];
            if (encodeExt != null) {
                const data = encodeExt(object, context);
                if (data != null) {
                    const type = i;
                    return new (0, $4c590382d717c63b$export$bcbeb236456bc779)(type, data);
                }
            }
        }
        if (object instanceof (0, $4c590382d717c63b$export$bcbeb236456bc779)) // to keep ExtData as is
        return object;
        return null;
    }
    decode(data, type, context) {
        const decodeExt = type < 0 ? this.builtInDecoders[-1 - type] : this.decoders[type];
        if (decodeExt) return decodeExt(data, type, context);
        else // decode() does not fail, returns ExtData instead.
        return new (0, $4c590382d717c63b$export$bcbeb236456bc779)(type, data);
    }
}
$02feec7394dad08d$export$12677a794dbd89d7.defaultCodec = new $02feec7394dad08d$export$12677a794dbd89d7();



function $e9b3e50ac63e3b33$export$b61de95301265227(str) {
    const strLength = str.length;
    let byteLength = 0;
    let pos = 0;
    while(pos < strLength){
        let value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            byteLength++;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        byteLength += 2;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    const extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) // 3-byte
            byteLength += 3;
            else // 4-byte
            byteLength += 4;
        }
    }
    return byteLength;
}
function $e9b3e50ac63e3b33$export$1042e4338f1ef853(str, output, outputOffset) {
    const strLength = str.length;
    let offset = outputOffset;
    let pos = 0;
    while(pos < strLength){
        let value = str.charCodeAt(pos++);
        if ((value & 0xffffff80) === 0) {
            // 1-byte
            output[offset++] = value;
            continue;
        } else if ((value & 0xfffff800) === 0) // 2-bytes
        output[offset++] = value >> 6 & 0x1f | 0xc0;
        else {
            // handle surrogate pair
            if (value >= 0xd800 && value <= 0xdbff) // high surrogate
            {
                if (pos < strLength) {
                    const extra = str.charCodeAt(pos);
                    if ((extra & 0xfc00) === 0xdc00) {
                        ++pos;
                        value = ((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000;
                    }
                }
            }
            if ((value & 0xffff0000) === 0) {
                // 3-byte
                output[offset++] = value >> 12 & 0x0f | 0xe0;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            } else {
                // 4-byte
                output[offset++] = value >> 18 & 0x07 | 0xf0;
                output[offset++] = value >> 12 & 0x3f | 0x80;
                output[offset++] = value >> 6 & 0x3f | 0x80;
            }
        }
        output[offset++] = value & 0x3f | 0x80;
    }
}
// TextEncoder and TextDecoder are standardized in whatwg encoding:
// https://encoding.spec.whatwg.org/
// and available in all the modern browsers:
// https://caniuse.com/textencoder
// They are available in Node.js since v12 LTS as well:
// https://nodejs.org/api/globals.html#textencoder
const $e9b3e50ac63e3b33$var$sharedTextEncoder = new TextEncoder();
// This threshold should be determined by benchmarking, which might vary in engines and input data.
// Run `npx ts-node benchmark/encode-string.ts` for details.
const $e9b3e50ac63e3b33$var$TEXT_ENCODER_THRESHOLD = 50;
function $e9b3e50ac63e3b33$export$34cfdc82d430524(str, output, outputOffset) {
    $e9b3e50ac63e3b33$var$sharedTextEncoder.encodeInto(str, output.subarray(outputOffset));
}
function $e9b3e50ac63e3b33$export$e1b32e613f230dc6(str, output, outputOffset) {
    if (str.length > $e9b3e50ac63e3b33$var$TEXT_ENCODER_THRESHOLD) $e9b3e50ac63e3b33$export$34cfdc82d430524(str, output, outputOffset);
    else $e9b3e50ac63e3b33$export$1042e4338f1ef853(str, output, outputOffset);
}
const $e9b3e50ac63e3b33$var$CHUNK_SIZE = 4096;
function $e9b3e50ac63e3b33$export$551117984c2adf4f(bytes, inputOffset, byteLength) {
    let offset = inputOffset;
    const end = offset + byteLength;
    const units = [];
    let result = "";
    while(offset < end){
        const byte1 = bytes[offset++];
        if ((byte1 & 0x80) === 0) // 1 byte
        units.push(byte1);
        else if ((byte1 & 0xe0) === 0xc0) {
            // 2 bytes
            const byte2 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 6 | byte2);
        } else if ((byte1 & 0xf0) === 0xe0) {
            // 3 bytes
            const byte2 = bytes[offset++] & 0x3f;
            const byte3 = bytes[offset++] & 0x3f;
            units.push((byte1 & 0x1f) << 12 | byte2 << 6 | byte3);
        } else if ((byte1 & 0xf8) === 0xf0) {
            // 4 bytes
            const byte2 = bytes[offset++] & 0x3f;
            const byte3 = bytes[offset++] & 0x3f;
            const byte4 = bytes[offset++] & 0x3f;
            let unit = (byte1 & 0x07) << 0x12 | byte2 << 0x0c | byte3 << 0x06 | byte4;
            if (unit > 0xffff) {
                unit -= 0x10000;
                units.push(unit >>> 10 & 0x3ff | 0xd800);
                unit = 0xdc00 | unit & 0x3ff;
            }
            units.push(unit);
        } else units.push(byte1);
        if (units.length >= $e9b3e50ac63e3b33$var$CHUNK_SIZE) {
            result += String.fromCharCode(...units);
            units.length = 0;
        }
    }
    if (units.length > 0) result += String.fromCharCode(...units);
    return result;
}
const $e9b3e50ac63e3b33$var$sharedTextDecoder = new TextDecoder();
// This threshold should be determined by benchmarking, which might vary in engines and input data.
// Run `npx ts-node benchmark/decode-string.ts` for details.
const $e9b3e50ac63e3b33$var$TEXT_DECODER_THRESHOLD = 200;
function $e9b3e50ac63e3b33$export$6ed79e41309992dc(bytes, inputOffset, byteLength) {
    const stringBytes = bytes.subarray(inputOffset, inputOffset + byteLength);
    return $e9b3e50ac63e3b33$var$sharedTextDecoder.decode(stringBytes);
}
function $e9b3e50ac63e3b33$export$db70ef86b2db322a(bytes, inputOffset, byteLength) {
    if (byteLength > $e9b3e50ac63e3b33$var$TEXT_DECODER_THRESHOLD) return $e9b3e50ac63e3b33$export$6ed79e41309992dc(bytes, inputOffset, byteLength);
    else return $e9b3e50ac63e3b33$export$551117984c2adf4f(bytes, inputOffset, byteLength);
}


function $4f4377cdb95196fb$var$isArrayBufferLike(buffer) {
    return buffer instanceof ArrayBuffer || typeof SharedArrayBuffer !== "undefined" && buffer instanceof SharedArrayBuffer;
}
function $4f4377cdb95196fb$export$f8d669c2a17882f2(buffer) {
    if (buffer instanceof Uint8Array) return buffer;
    else if (ArrayBuffer.isView(buffer)) return new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength);
    else if ($4f4377cdb95196fb$var$isArrayBufferLike(buffer)) return new Uint8Array(buffer);
    else // ArrayLike<number>
    return Uint8Array.from(buffer);
}



const $5cdb5cb657f0f48c$var$DEFAULT_MAX_KEY_LENGTH = 16;
const $5cdb5cb657f0f48c$var$DEFAULT_MAX_LENGTH_PER_KEY = 16;
class $5cdb5cb657f0f48c$export$529b830450faf29c {
    constructor(maxKeyLength = $5cdb5cb657f0f48c$var$DEFAULT_MAX_KEY_LENGTH, maxLengthPerKey = $5cdb5cb657f0f48c$var$DEFAULT_MAX_LENGTH_PER_KEY){
        this.hit = 0;
        this.miss = 0;
        this.maxKeyLength = maxKeyLength;
        this.maxLengthPerKey = maxLengthPerKey;
        // avoid `new Array(N)`, which makes a sparse array,
        // because a sparse array is typically slower than a non-sparse array.
        this.caches = [];
        for(let i = 0; i < this.maxKeyLength; i++)this.caches.push([]);
    }
    canBeCached(byteLength) {
        return byteLength > 0 && byteLength <= this.maxKeyLength;
    }
    find(bytes, inputOffset, byteLength) {
        const records = this.caches[byteLength - 1];
        FIND_CHUNK: for (const record of records){
            const recordBytes = record.bytes;
            for(let j = 0; j < byteLength; j++){
                if (recordBytes[j] !== bytes[inputOffset + j]) continue FIND_CHUNK;
            }
            return record.str;
        }
        return null;
    }
    store(bytes, value) {
        const records = this.caches[bytes.length - 1];
        const record = {
            bytes: bytes,
            str: value
        };
        if (records.length >= this.maxLengthPerKey) // `records` are full!
        // Set `record` to an arbitrary position.
        records[Math.random() * records.length | 0] = record;
        else records.push(record);
    }
    decode(bytes, inputOffset, byteLength) {
        const cachedValue = this.find(bytes, inputOffset, byteLength);
        if (cachedValue != null) {
            this.hit++;
            return cachedValue;
        }
        this.miss++;
        const str = (0, $e9b3e50ac63e3b33$export$551117984c2adf4f)(bytes, inputOffset, byteLength);
        // Ensure to copy a slice of bytes because the bytes may be a NodeJS Buffer and Buffer#slice() returns a reference to its internal ArrayBuffer.
        const slicedCopyOfBytes = Uint8Array.prototype.slice.call(bytes, inputOffset, inputOffset + byteLength);
        this.store(slicedCopyOfBytes, str);
        return str;
    }
}



const $0ce7c8b8e406fea4$var$STATE_ARRAY = "array";
const $0ce7c8b8e406fea4$var$STATE_MAP_KEY = "map_key";
const $0ce7c8b8e406fea4$var$STATE_MAP_VALUE = "map_value";
const $0ce7c8b8e406fea4$var$mapKeyConverter = (key)=>{
    if (typeof key === "string" || typeof key === "number") return key;
    throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)("The type of key must be string or number but " + typeof key);
};
class $0ce7c8b8e406fea4$var$StackPool {
    constructor(){
        this.stack = [];
        this.stackHeadPosition = -1;
    }
    get length() {
        return this.stackHeadPosition + 1;
    }
    top() {
        return this.stack[this.stackHeadPosition];
    }
    pushArrayState(size) {
        const state = this.getUninitializedStateFromPool();
        state.type = $0ce7c8b8e406fea4$var$STATE_ARRAY;
        state.position = 0;
        state.size = size;
        state.array = new Array(size);
    }
    pushMapState(size) {
        const state = this.getUninitializedStateFromPool();
        state.type = $0ce7c8b8e406fea4$var$STATE_MAP_KEY;
        state.readCount = 0;
        state.size = size;
        state.map = {};
    }
    getUninitializedStateFromPool() {
        this.stackHeadPosition++;
        if (this.stackHeadPosition === this.stack.length) {
            const partialState = {
                type: undefined,
                size: 0,
                array: undefined,
                position: 0,
                readCount: 0,
                map: undefined,
                key: null
            };
            this.stack.push(partialState);
        }
        return this.stack[this.stackHeadPosition];
    }
    release(state) {
        const topStackState = this.stack[this.stackHeadPosition];
        if (topStackState !== state) throw new Error("Invalid stack state. Released state is not on top of the stack.");
        if (state.type === $0ce7c8b8e406fea4$var$STATE_ARRAY) {
            const partialState = state;
            partialState.size = 0;
            partialState.array = undefined;
            partialState.position = 0;
            partialState.type = undefined;
        }
        if (state.type === $0ce7c8b8e406fea4$var$STATE_MAP_KEY || state.type === $0ce7c8b8e406fea4$var$STATE_MAP_VALUE) {
            const partialState = state;
            partialState.size = 0;
            partialState.map = undefined;
            partialState.readCount = 0;
            partialState.type = undefined;
        }
        this.stackHeadPosition--;
    }
    reset() {
        this.stack.length = 0;
        this.stackHeadPosition = -1;
    }
}
const $0ce7c8b8e406fea4$var$HEAD_BYTE_REQUIRED = -1;
const $0ce7c8b8e406fea4$var$EMPTY_VIEW = new DataView(new ArrayBuffer(0));
const $0ce7c8b8e406fea4$var$EMPTY_BYTES = new Uint8Array($0ce7c8b8e406fea4$var$EMPTY_VIEW.buffer);
try {
    // IE11: The spec says it should throw RangeError,
    // IE11: but in IE11 it throws TypeError.
    $0ce7c8b8e406fea4$var$EMPTY_VIEW.getInt8(0);
} catch (e) {
    if (!(e instanceof RangeError)) throw new Error("This module is not supported in the current JavaScript engine because DataView does not throw RangeError on out-of-bounds access");
}
const $0ce7c8b8e406fea4$var$MORE_DATA = new RangeError("Insufficient data");
const $0ce7c8b8e406fea4$var$sharedCachedKeyDecoder = new (0, $5cdb5cb657f0f48c$export$529b830450faf29c)();
class $0ce7c8b8e406fea4$export$f9de6ca0bc043724 {
    constructor(options){
        this.totalPos = 0;
        this.pos = 0;
        this.view = $0ce7c8b8e406fea4$var$EMPTY_VIEW;
        this.bytes = $0ce7c8b8e406fea4$var$EMPTY_BYTES;
        this.headByte = $0ce7c8b8e406fea4$var$HEAD_BYTE_REQUIRED;
        this.stack = new $0ce7c8b8e406fea4$var$StackPool();
        this.entered = false;
        this.extensionCodec = options?.extensionCodec ?? (0, $02feec7394dad08d$export$12677a794dbd89d7).defaultCodec;
        this.context = options?.context; // needs a type assertion because EncoderOptions has no context property when ContextType is undefined
        this.useBigInt64 = options?.useBigInt64 ?? false;
        this.rawStrings = options?.rawStrings ?? false;
        this.maxStrLength = options?.maxStrLength ?? (0, $71754ee758078552$export$3314b2c271c86d70);
        this.maxBinLength = options?.maxBinLength ?? (0, $71754ee758078552$export$3314b2c271c86d70);
        this.maxArrayLength = options?.maxArrayLength ?? (0, $71754ee758078552$export$3314b2c271c86d70);
        this.maxMapLength = options?.maxMapLength ?? (0, $71754ee758078552$export$3314b2c271c86d70);
        this.maxExtLength = options?.maxExtLength ?? (0, $71754ee758078552$export$3314b2c271c86d70);
        this.keyDecoder = options?.keyDecoder !== undefined ? options.keyDecoder : $0ce7c8b8e406fea4$var$sharedCachedKeyDecoder;
        this.mapKeyConverter = options?.mapKeyConverter ?? $0ce7c8b8e406fea4$var$mapKeyConverter;
    }
    clone() {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        return new $0ce7c8b8e406fea4$export$f9de6ca0bc043724({
            extensionCodec: this.extensionCodec,
            context: this.context,
            useBigInt64: this.useBigInt64,
            rawStrings: this.rawStrings,
            maxStrLength: this.maxStrLength,
            maxBinLength: this.maxBinLength,
            maxArrayLength: this.maxArrayLength,
            maxMapLength: this.maxMapLength,
            maxExtLength: this.maxExtLength,
            keyDecoder: this.keyDecoder
        });
    }
    reinitializeState() {
        this.totalPos = 0;
        this.headByte = $0ce7c8b8e406fea4$var$HEAD_BYTE_REQUIRED;
        this.stack.reset();
    // view, bytes, and pos will be re-initialized in setBuffer()
    }
    setBuffer(buffer) {
        const bytes = (0, $4f4377cdb95196fb$export$f8d669c2a17882f2)(buffer);
        this.bytes = bytes;
        this.view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
        this.pos = 0;
    }
    appendBuffer(buffer) {
        if (this.headByte === $0ce7c8b8e406fea4$var$HEAD_BYTE_REQUIRED && !this.hasRemaining(1)) this.setBuffer(buffer);
        else {
            const remainingData = this.bytes.subarray(this.pos);
            const newData = (0, $4f4377cdb95196fb$export$f8d669c2a17882f2)(buffer);
            // concat remainingData + newData
            const newBuffer = new Uint8Array(remainingData.length + newData.length);
            newBuffer.set(remainingData);
            newBuffer.set(newData, remainingData.length);
            this.setBuffer(newBuffer);
        }
    }
    hasRemaining(size) {
        return this.view.byteLength - this.pos >= size;
    }
    createExtraByteError(posToShow) {
        const { view: view, pos: pos } = this;
        return new RangeError(`Extra ${view.byteLength - pos} of ${view.byteLength} byte(s) found at buffer[${posToShow}]`);
    }
    /**
     * @throws {@link DecodeError}
     * @throws {@link RangeError}
     */ decode(buffer) {
        if (this.entered) {
            const instance = this.clone();
            return instance.decode(buffer);
        }
        try {
            this.entered = true;
            this.reinitializeState();
            this.setBuffer(buffer);
            const object = this.doDecodeSync();
            if (this.hasRemaining(1)) throw this.createExtraByteError(this.pos);
            return object;
        } finally{
            this.entered = false;
        }
    }
    *decodeMulti(buffer) {
        if (this.entered) {
            const instance = this.clone();
            yield* instance.decodeMulti(buffer);
            return;
        }
        try {
            this.entered = true;
            this.reinitializeState();
            this.setBuffer(buffer);
            while(this.hasRemaining(1))yield this.doDecodeSync();
        } finally{
            this.entered = false;
        }
    }
    async decodeAsync(stream) {
        if (this.entered) {
            const instance = this.clone();
            return instance.decodeAsync(stream);
        }
        try {
            this.entered = true;
            let decoded = false;
            let object;
            for await (const buffer of stream){
                if (decoded) {
                    this.entered = false;
                    throw this.createExtraByteError(this.totalPos);
                }
                this.appendBuffer(buffer);
                try {
                    object = this.doDecodeSync();
                    decoded = true;
                } catch (e) {
                    if (!(e instanceof RangeError)) throw e; // rethrow
                // fallthrough
                }
                this.totalPos += this.pos;
            }
            if (decoded) {
                if (this.hasRemaining(1)) throw this.createExtraByteError(this.totalPos);
                return object;
            }
            const { headByte: headByte, pos: pos, totalPos: totalPos } = this;
            throw new RangeError(`Insufficient data in parsing ${(0, $7bdf638cc3f095b6$export$78406e843f5312da)(headByte)} at ${totalPos} (${pos} in the current buffer)`);
        } finally{
            this.entered = false;
        }
    }
    decodeArrayStream(stream) {
        return this.decodeMultiAsync(stream, true);
    }
    decodeStream(stream) {
        return this.decodeMultiAsync(stream, false);
    }
    async *decodeMultiAsync(stream, isArray) {
        if (this.entered) {
            const instance = this.clone();
            yield* instance.decodeMultiAsync(stream, isArray);
            return;
        }
        try {
            this.entered = true;
            let isArrayHeaderRequired = isArray;
            let arrayItemsLeft = -1;
            for await (const buffer of stream){
                if (isArray && arrayItemsLeft === 0) throw this.createExtraByteError(this.totalPos);
                this.appendBuffer(buffer);
                if (isArrayHeaderRequired) {
                    arrayItemsLeft = this.readArraySize();
                    isArrayHeaderRequired = false;
                    this.complete();
                }
                try {
                    while(true){
                        yield this.doDecodeSync();
                        if (--arrayItemsLeft === 0) break;
                    }
                } catch (e) {
                    if (!(e instanceof RangeError)) throw e; // rethrow
                // fallthrough
                }
                this.totalPos += this.pos;
            }
        } finally{
            this.entered = false;
        }
    }
    doDecodeSync() {
        DECODE: while(true){
            const headByte = this.readHeadByte();
            let object;
            if (headByte >= 0xe0) // negative fixint (111x xxxx) 0xe0 - 0xff
            object = headByte - 0x100;
            else if (headByte < 0xc0) {
                if (headByte < 0x80) // positive fixint (0xxx xxxx) 0x00 - 0x7f
                object = headByte;
                else if (headByte < 0x90) {
                    // fixmap (1000 xxxx) 0x80 - 0x8f
                    const size = headByte - 0x80;
                    if (size !== 0) {
                        this.pushMapState(size);
                        this.complete();
                        continue DECODE;
                    } else object = {};
                } else if (headByte < 0xa0) {
                    // fixarray (1001 xxxx) 0x90 - 0x9f
                    const size = headByte - 0x90;
                    if (size !== 0) {
                        this.pushArrayState(size);
                        this.complete();
                        continue DECODE;
                    } else object = [];
                } else {
                    // fixstr (101x xxxx) 0xa0 - 0xbf
                    const byteLength = headByte - 0xa0;
                    object = this.decodeString(byteLength, 0);
                }
            } else if (headByte === 0xc0) // nil
            object = null;
            else if (headByte === 0xc2) // false
            object = false;
            else if (headByte === 0xc3) // true
            object = true;
            else if (headByte === 0xca) // float 32
            object = this.readF32();
            else if (headByte === 0xcb) // float 64
            object = this.readF64();
            else if (headByte === 0xcc) // uint 8
            object = this.readU8();
            else if (headByte === 0xcd) // uint 16
            object = this.readU16();
            else if (headByte === 0xce) // uint 32
            object = this.readU32();
            else if (headByte === 0xcf) {
                // uint 64
                if (this.useBigInt64) object = this.readU64AsBigInt();
                else object = this.readU64();
            } else if (headByte === 0xd0) // int 8
            object = this.readI8();
            else if (headByte === 0xd1) // int 16
            object = this.readI16();
            else if (headByte === 0xd2) // int 32
            object = this.readI32();
            else if (headByte === 0xd3) {
                // int 64
                if (this.useBigInt64) object = this.readI64AsBigInt();
                else object = this.readI64();
            } else if (headByte === 0xd9) {
                // str 8
                const byteLength = this.lookU8();
                object = this.decodeString(byteLength, 1);
            } else if (headByte === 0xda) {
                // str 16
                const byteLength = this.lookU16();
                object = this.decodeString(byteLength, 2);
            } else if (headByte === 0xdb) {
                // str 32
                const byteLength = this.lookU32();
                object = this.decodeString(byteLength, 4);
            } else if (headByte === 0xdc) {
                // array 16
                const size = this.readU16();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xdd) {
                // array 32
                const size = this.readU32();
                if (size !== 0) {
                    this.pushArrayState(size);
                    this.complete();
                    continue DECODE;
                } else object = [];
            } else if (headByte === 0xde) {
                // map 16
                const size = this.readU16();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xdf) {
                // map 32
                const size = this.readU32();
                if (size !== 0) {
                    this.pushMapState(size);
                    this.complete();
                    continue DECODE;
                } else object = {};
            } else if (headByte === 0xc4) {
                // bin 8
                const size = this.lookU8();
                object = this.decodeBinary(size, 1);
            } else if (headByte === 0xc5) {
                // bin 16
                const size = this.lookU16();
                object = this.decodeBinary(size, 2);
            } else if (headByte === 0xc6) {
                // bin 32
                const size = this.lookU32();
                object = this.decodeBinary(size, 4);
            } else if (headByte === 0xd4) // fixext 1
            object = this.decodeExtension(1, 0);
            else if (headByte === 0xd5) // fixext 2
            object = this.decodeExtension(2, 0);
            else if (headByte === 0xd6) // fixext 4
            object = this.decodeExtension(4, 0);
            else if (headByte === 0xd7) // fixext 8
            object = this.decodeExtension(8, 0);
            else if (headByte === 0xd8) // fixext 16
            object = this.decodeExtension(16, 0);
            else if (headByte === 0xc7) {
                // ext 8
                const size = this.lookU8();
                object = this.decodeExtension(size, 1);
            } else if (headByte === 0xc8) {
                // ext 16
                const size = this.lookU16();
                object = this.decodeExtension(size, 2);
            } else if (headByte === 0xc9) {
                // ext 32
                const size = this.lookU32();
                object = this.decodeExtension(size, 4);
            } else throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Unrecognized type byte: ${(0, $7bdf638cc3f095b6$export$78406e843f5312da)(headByte)}`);
            this.complete();
            const stack = this.stack;
            while(stack.length > 0){
                // arrays and maps
                const state = stack.top();
                if (state.type === $0ce7c8b8e406fea4$var$STATE_ARRAY) {
                    state.array[state.position] = object;
                    state.position++;
                    if (state.position === state.size) {
                        object = state.array;
                        stack.release(state);
                    } else continue DECODE;
                } else if (state.type === $0ce7c8b8e406fea4$var$STATE_MAP_KEY) {
                    if (object === "__proto__") throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)("The key __proto__ is not allowed");
                    state.key = this.mapKeyConverter(object);
                    state.type = $0ce7c8b8e406fea4$var$STATE_MAP_VALUE;
                    continue DECODE;
                } else {
                    // it must be `state.type === State.MAP_VALUE` here
                    state.map[state.key] = object;
                    state.readCount++;
                    if (state.readCount === state.size) {
                        object = state.map;
                        stack.release(state);
                    } else {
                        state.key = null;
                        state.type = $0ce7c8b8e406fea4$var$STATE_MAP_KEY;
                        continue DECODE;
                    }
                }
            }
            return object;
        }
    }
    readHeadByte() {
        if (this.headByte === $0ce7c8b8e406fea4$var$HEAD_BYTE_REQUIRED) this.headByte = this.readU8();
        return this.headByte;
    }
    complete() {
        this.headByte = $0ce7c8b8e406fea4$var$HEAD_BYTE_REQUIRED;
    }
    readArraySize() {
        const headByte = this.readHeadByte();
        switch(headByte){
            case 0xdc:
                return this.readU16();
            case 0xdd:
                return this.readU32();
            default:
                if (headByte < 0xa0) return headByte - 0x90;
                else throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Unrecognized array type byte: ${(0, $7bdf638cc3f095b6$export$78406e843f5312da)(headByte)}`);
        }
    }
    pushMapState(size) {
        if (size > this.maxMapLength) throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Max length exceeded: map length (${size}) > maxMapLengthLength (${this.maxMapLength})`);
        this.stack.pushMapState(size);
    }
    pushArrayState(size) {
        if (size > this.maxArrayLength) throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Max length exceeded: array length (${size}) > maxArrayLength (${this.maxArrayLength})`);
        this.stack.pushArrayState(size);
    }
    decodeString(byteLength, headerOffset) {
        if (!this.rawStrings || this.stateIsMapKey()) return this.decodeUtf8String(byteLength, headerOffset);
        return this.decodeBinary(byteLength, headerOffset);
    }
    /**
     * @throws {@link RangeError}
     */ decodeUtf8String(byteLength, headerOffset) {
        if (byteLength > this.maxStrLength) throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Max length exceeded: UTF-8 byte length (${byteLength}) > maxStrLength (${this.maxStrLength})`);
        if (this.bytes.byteLength < this.pos + headerOffset + byteLength) throw $0ce7c8b8e406fea4$var$MORE_DATA;
        const offset = this.pos + headerOffset;
        let object;
        if (this.stateIsMapKey() && this.keyDecoder?.canBeCached(byteLength)) object = this.keyDecoder.decode(this.bytes, offset, byteLength);
        else object = (0, $e9b3e50ac63e3b33$export$db70ef86b2db322a)(this.bytes, offset, byteLength);
        this.pos += headerOffset + byteLength;
        return object;
    }
    stateIsMapKey() {
        if (this.stack.length > 0) {
            const state = this.stack.top();
            return state.type === $0ce7c8b8e406fea4$var$STATE_MAP_KEY;
        }
        return false;
    }
    /**
     * @throws {@link RangeError}
     */ decodeBinary(byteLength, headOffset) {
        if (byteLength > this.maxBinLength) throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Max length exceeded: bin length (${byteLength}) > maxBinLength (${this.maxBinLength})`);
        if (!this.hasRemaining(byteLength + headOffset)) throw $0ce7c8b8e406fea4$var$MORE_DATA;
        const offset = this.pos + headOffset;
        const object = this.bytes.subarray(offset, offset + byteLength);
        this.pos += headOffset + byteLength;
        return object;
    }
    decodeExtension(size, headOffset) {
        if (size > this.maxExtLength) throw new (0, $87d968ef13b62755$export$ef3eed12d06c0285)(`Max length exceeded: ext length (${size}) > maxExtLength (${this.maxExtLength})`);
        const extType = this.view.getInt8(this.pos + headOffset);
        const data = this.decodeBinary(size, headOffset + 1 /* extType */ );
        return this.extensionCodec.decode(data, extType, this.context);
    }
    lookU8() {
        return this.view.getUint8(this.pos);
    }
    lookU16() {
        return this.view.getUint16(this.pos);
    }
    lookU32() {
        return this.view.getUint32(this.pos);
    }
    readU8() {
        const value = this.view.getUint8(this.pos);
        this.pos++;
        return value;
    }
    readI8() {
        const value = this.view.getInt8(this.pos);
        this.pos++;
        return value;
    }
    readU16() {
        const value = this.view.getUint16(this.pos);
        this.pos += 2;
        return value;
    }
    readI16() {
        const value = this.view.getInt16(this.pos);
        this.pos += 2;
        return value;
    }
    readU32() {
        const value = this.view.getUint32(this.pos);
        this.pos += 4;
        return value;
    }
    readI32() {
        const value = this.view.getInt32(this.pos);
        this.pos += 4;
        return value;
    }
    readU64() {
        const value = (0, $71754ee758078552$export$59a2dbf579ff9568)(this.view, this.pos);
        this.pos += 8;
        return value;
    }
    readI64() {
        const value = (0, $71754ee758078552$export$69825c7adcc820c6)(this.view, this.pos);
        this.pos += 8;
        return value;
    }
    readU64AsBigInt() {
        const value = this.view.getBigUint64(this.pos);
        this.pos += 8;
        return value;
    }
    readI64AsBigInt() {
        const value = this.view.getBigInt64(this.pos);
        this.pos += 8;
        return value;
    }
    readF32() {
        const value = this.view.getFloat32(this.pos);
        this.pos += 4;
        return value;
    }
    readF64() {
        const value = this.view.getFloat64(this.pos);
        this.pos += 8;
        return value;
    }
}


function $1889e7630e596c4f$export$2f872c0f2117be69(buffer, options) {
    const decoder = new (0, $0ce7c8b8e406fea4$export$f9de6ca0bc043724)(options);
    return decoder.decode(buffer);
}
function $1889e7630e596c4f$export$43cc91859d9fdc54(buffer, options) {
    const decoder = new (0, $0ce7c8b8e406fea4$export$f9de6ca0bc043724)(options);
    return decoder.decodeMulti(buffer);
}


var $b0c7071b3a123ac3$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $b0c7071b3a123ac3$var$MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var $b0c7071b3a123ac3$var$funcTag = '[object Function]', $b0c7071b3a123ac3$var$genTag = '[object GeneratorFunction]';
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $b0c7071b3a123ac3$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $b0c7071b3a123ac3$var$arrayFilter(array, predicate) {
    var index = -1, length = array ? array.length : 0, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b0c7071b3a123ac3$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $b0c7071b3a123ac3$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b0c7071b3a123ac3$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/** Used for built-in method references. */ var $b0c7071b3a123ac3$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b0c7071b3a123ac3$var$objectToString = $b0c7071b3a123ac3$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b0c7071b3a123ac3$var$nativeMax = Math.max;
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $b0c7071b3a123ac3$var$baseRest(func, start) {
    start = $b0c7071b3a123ac3$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $b0c7071b3a123ac3$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = array;
        return $b0c7071b3a123ac3$var$apply(func, this, otherArgs);
    };
}
/**
 * This method is like `_.zip` except that it accepts an array of grouped
 * elements and creates an array regrouping the elements to their pre-zip
 * configuration.
 *
 * @static
 * @memberOf _
 * @since 1.2.0
 * @category Array
 * @param {Array} array The array of grouped elements to process.
 * @returns {Array} Returns the new array of regrouped elements.
 * @example
 *
 * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 *
 * _.unzip(zipped);
 * // => [['a', 'b'], [1, 2], [true, false]]
 */ function $b0c7071b3a123ac3$var$unzip(array) {
    if (!(array && array.length)) return [];
    var length = 0;
    array = $b0c7071b3a123ac3$var$arrayFilter(array, function(group) {
        if ($b0c7071b3a123ac3$var$isArrayLikeObject(group)) {
            length = $b0c7071b3a123ac3$var$nativeMax(group.length, length);
            return true;
        }
    });
    return $b0c7071b3a123ac3$var$baseTimes(length, function(index) {
        return $b0c7071b3a123ac3$var$arrayMap(array, $b0c7071b3a123ac3$var$baseProperty(index));
    });
}
/**
 * Creates an array of grouped elements, the first of which contains the
 * first elements of the given arrays, the second of which contains the
 * second elements of the given arrays, and so on.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to process.
 * @returns {Array} Returns the new array of grouped elements.
 * @example
 *
 * _.zip(['a', 'b'], [1, 2], [true, false]);
 * // => [['a', 1, true], ['b', 2, false]]
 */ var $b0c7071b3a123ac3$var$zip = $b0c7071b3a123ac3$var$baseRest($b0c7071b3a123ac3$var$unzip);
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $b0c7071b3a123ac3$var$isArrayLike(value) {
    return value != null && $b0c7071b3a123ac3$var$isLength(value.length) && !$b0c7071b3a123ac3$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $b0c7071b3a123ac3$var$isArrayLikeObject(value) {
    return $b0c7071b3a123ac3$var$isObjectLike(value) && $b0c7071b3a123ac3$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b0c7071b3a123ac3$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $b0c7071b3a123ac3$var$isObject(value) ? $b0c7071b3a123ac3$var$objectToString.call(value) : '';
    return tag == $b0c7071b3a123ac3$var$funcTag || tag == $b0c7071b3a123ac3$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $b0c7071b3a123ac3$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $b0c7071b3a123ac3$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b0c7071b3a123ac3$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b0c7071b3a123ac3$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
$b0c7071b3a123ac3$exports = $b0c7071b3a123ac3$var$zip;


// Utility functions
function $15f9f3049a7ed3be$var$uint8ToUint16(uint8) {
    return new Int16Array(new Uint8Array(uint8).buffer);
}
function $15f9f3049a7ed3be$var$uint8ToUint32(uint8) {
    return new Int32Array(new Uint8Array(uint8).buffer);
}
function $15f9f3049a7ed3be$var$normalizeEnvelopeFormat(rawObj) {
    if (!rawObj || typeof rawObj !== "object") return rawObj;
    if (!rawObj.H || !Array.isArray(rawObj.D)) return rawObj;
    const header = rawObj.H || {};
    const firstData = rawObj.D && rawObj.D[0] || {};
    const normalizedType = rawObj.type ?? header.FT;
    return {
        ...rawObj,
        ...firstData,
        productID: rawObj.productID ?? header.PrjID ?? header.DevName,
        type: typeof normalizedType === "string" ? normalizedType.toUpperCase() : normalizedType,
        version: rawObj.version ?? header.v,
        t: rawObj.t ?? header.t
    };
}
function $15f9f3049a7ed3be$var$removeOffset(wave) {
    var x;
    return wave;
}
function $15f9f3049a7ed3be$var$getPropertyByPath(obj, path) {
    return path.split('.').reduce((acc, part)=>acc && acc[part], obj);
}
function $15f9f3049a7ed3be$var$setPropertyByPath(obj, path, value) {
    const parts = path.split('.');
    const last = parts.pop();
    const target = parts.reduce((acc, part)=>acc && acc[part], obj);
    if (target) target[last] = value;
}
const $15f9f3049a7ed3be$var$MEASURE_CALIBRATION_MAP = [
    // Formato nuevo (COEFF en mayúsculas, MEASURE en minúsculas)
    {
        measureKey: "fcr",
        coeffKey: "FCR"
    },
    {
        measureKey: "fcs",
        coeffKey: "FCS"
    },
    {
        measureKey: "fct",
        coeffKey: "FCT"
    },
    {
        measureKey: "pir",
        coeffKey: "PIR"
    },
    {
        measureKey: "pis",
        coeffKey: "PIS"
    },
    {
        measureKey: "pit",
        coeffKey: "PIT"
    },
    {
        measureKey: "pin",
        coeffKey: "PIN"
    },
    {
        measureKey: "zfr",
        coeffKey: "ZFR"
    },
    {
        measureKey: "zfs",
        coeffKey: "ZFS"
    },
    {
        measureKey: "zft",
        coeffKey: "ZFT"
    }
];
// Redondea a 6 decimales si es un número
function $15f9f3049a7ed3be$var$roundTo6(value) {
    if (typeof value !== 'number' || !isFinite(value)) return value;
    return Math.round(value * 1e6) / 1e6;
}
function $15f9f3049a7ed3be$var$applyMeasureCalibration(measure, coeff) {
    console.log("calibrando", measure, coeff);
    if (!measure || typeof measure !== "object" || !coeff || typeof coeff !== "object") return measure;
    const calibrated = {
        ...measure
    };
    $15f9f3049a7ed3be$var$MEASURE_CALIBRATION_MAP.forEach(({ measureKey: measureKey, coeffKey: coeffKey })=>{
        const factor = coeff[coeffKey];
        if (factor === undefined || calibrated[measureKey] === undefined) return;
        const value = calibrated[measureKey];
        if (Array.isArray(value)) calibrated[measureKey] = value.map((v)=>$15f9f3049a7ed3be$var$roundTo6(v * factor));
        else if (ArrayBuffer.isView(value) && typeof value.map === "function") calibrated[measureKey] = value.map((v)=>$15f9f3049a7ed3be$var$roundTo6(v * factor));
        else if (typeof value === "number") calibrated[measureKey] = $15f9f3049a7ed3be$var$roundTo6(value * factor);
    });
    return calibrated;
}
const $15f9f3049a7ed3be$var$SPECIAL_PARSERS = {
    timestamp: (value)=>new Date(value * 1000).toLocaleString(),
    version: (value)=>{
        let v = value;
        if (typeof v !== 'bigint') try {
            v = BigInt(value);
        } catch (e) {
            return value;
        }
        const major = Number(v >> 48n & 0xFFFFn);
        const minor = Number(v >> 32n & 0xFFFFn);
        const patch = Number(v >> 16n & 0xFFFFn);
        const revision = Number(v & 0xFFFFn);
        return `${major}.${minor}.${patch}.${revision}`;
    },
    calibrateMeasure: (value, root)=>$15f9f3049a7ed3be$var$applyMeasureCalibration(value, root?.COEFF)
};
// Configuration objects for different document types
const $15f9f3049a7ed3be$var$PRODUCT_CONFIGS = {
    "24P002": {
        types: {
            0: {
                versions: {
                    0: {
                        fields: [
                            "VA",
                            "VB",
                            "VC",
                            "IA",
                            "IB",
                            "IC",
                            "IN"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint32,
                        applyOffset: false,
                        excludedFields: [
                            "COEFF.FCR"
                        ],
                        gridConfig: {
                            voltageFields: [
                                "VA",
                                "VB",
                                "VC"
                            ],
                            currentFields: [
                                "IA",
                                "IB",
                                "IC",
                                "IN"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        }
                    },
                    // Versiones 1, 2, 3 comparten la misma configuración
                    "1,2,3": {
                        fields: [
                            "FCR",
                            "FCS",
                            "FCT",
                            "PIR",
                            "PIS",
                            "PIT",
                            "PIN",
                            "ZFR",
                            "ZFS",
                            "ZFT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint32,
                        applyOffset: false,
                        enableDownload: true,
                        gridConfig: {
                            voltageFields: [
                                "FCR",
                                "FCS",
                                "FCT"
                            ],
                            currentFields: [
                                "PIR",
                                "PIS",
                                "PIT",
                                "PIN",
                                "ZFR",
                                "ZFS",
                                "ZFT"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        }
                    },
                    // O puedes usar wildcard para versiones 4 en adelante
                    "*": {
                        fields: [
                            "FCR",
                            "FCS",
                            "FCT",
                            "PIR",
                            "PIS",
                            "PIT",
                            "PIN",
                            "ZFR",
                            "ZFS",
                            "ZFT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint32,
                        applyOffset: false,
                        enableDownload: true,
                        specialParsers: {
                            "t": "timestamp",
                            "SYSSTATUS.VERSION": "version",
                            "MEASURE": "calibrateMeasure"
                        },
                        gridConfig: {
                            voltageFields: [
                                "FCR",
                                "FCS",
                                "FCT"
                            ],
                            currentFields: [
                                "PIR",
                                "PIS",
                                "PIT",
                                "PIN",
                                "ZFR",
                                "ZFS",
                                "ZFT"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        }
                    }
                }
            },
            1: {
                versions: {
                    "*": {
                        fields: [
                            "FCR",
                            "FCS",
                            "FCT",
                            "PIR",
                            "PIS",
                            "PIT",
                            "PIN",
                            "ZFR",
                            "ZFS",
                            "ZFT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        offsetFields: [
                            "FCR",
                            "FCS",
                            "FCT"
                        ],
                        specialParsers: {
                            "t": "timestamp",
                            "SYSSTATUS.VERSION": "version",
                            "MEASURE": "calibrateMeasure"
                        },
                        gridConfig: {
                            voltageFields: [
                                "FCR",
                                "FCS",
                                "FCT"
                            ],
                            currentFields: [
                                "PIR",
                                "PIS",
                                "PIT",
                                "PIN",
                                "ZFR",
                                "ZFS",
                                "ZFT"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        }
                    }
                }
            },
            3: {
                versions: {
                    "*": {
                        fields: [
                            "FCR",
                            "FCS",
                            "FCT",
                            "PIR",
                            "PIS",
                            "PIT",
                            "PIN",
                            "ZFR",
                            "ZFS",
                            "ZFT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint32,
                        applyOffset: false,
                        enableDownload: true,
                        specialParsers: {
                            "t": "timestamp",
                            "SYSSTATUS.VERSION": "version",
                            "MEASURE": "calibrateMeasure"
                        },
                        gridConfig: {
                            voltageFields: [
                                "FCR",
                                "FCS",
                                "FCT"
                            ],
                            currentFields: [
                                "PIR",
                                "PIS",
                                "PIT",
                                "PIN",
                                "ZFR",
                                "ZFS",
                                "ZFT"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        }
                    }
                }
            },
            4: {
                versions: {
                    "*": {
                        fields: [
                            "FCR",
                            "FCS",
                            "FCT",
                            "PIR",
                            "PIS",
                            "PIT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        offsetFields: [
                            "FCR",
                            "FCS",
                            "FCT"
                        ],
                        excludedFields: [],
                        specialParsers: {
                            "t": "timestamp",
                            "SYSSTATUS.VERSION": "version",
                            "MEASURE": "calibrateMeasure"
                        },
                        gridConfig: {
                            voltageFields: [
                                "FCR",
                                "FCS",
                                "FCT"
                            ],
                            currentFields: [
                                "PIR",
                                "PIS",
                                "PIT"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        scaleConfig: {
                            voltage: {
                                fields: [
                                    "FCR",
                                    "FCS",
                                    "FCT"
                                ],
                                factor: 1,
                                removeOffset: false
                            },
                            current: {
                                fields: [
                                    "PIR",
                                    "PIS",
                                    "PIT"
                                ],
                                factor: 0.037014,
                                removeOffset: false
                            }
                        },
                        titleTemplate: (data)=>`24P002 MEASURE12`
                    }
                }
            },
            5: {
                versions: {
                    "*": {
                        fields: [
                            "FCR",
                            "FCS",
                            "FCT",
                            "PIR",
                            "PIS",
                            "PIT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        offsetFields: [
                            "FCR",
                            "FCS",
                            "FCT"
                        ],
                        axisConfig: {
                            timeAxis: true
                        },
                        specialParsers: {
                            "t": "timestamp",
                            "SYSSTATUS.VERSION": "version",
                            "MEASURE": "calibrateMeasure"
                        },
                        gridConfig: {
                            voltageFields: [
                                "FCR",
                                "FCS",
                                "FCT"
                            ],
                            currentFields: [
                                "PIR",
                                "PIS",
                                "PIT"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        scaleConfig: {
                            voltage: {
                                fields: [
                                    "FCR",
                                    "FCS",
                                    "FCT"
                                ],
                                factor: 1,
                                removeOffset: false
                            },
                            current: {
                                fields: [
                                    "PIR",
                                    "PIS",
                                    "PIT"
                                ],
                                factor: 0.037014,
                                removeOffset: false
                            }
                        },
                        titleTemplate: (data)=>`24P002 Fault`
                    }
                }
            }
        }
    },
    "22P003": {
        types: {
            0: {
                versions: {
                    "*": {
                        fields: [
                            "VA",
                            "VB",
                            "VC",
                            "IA",
                            "IB",
                            "IC"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint32,
                        applyOffset: false,
                        gridConfig: {
                            voltageFields: [
                                "VA",
                                "VB",
                                "VC"
                            ],
                            currentFields: [
                                "IA",
                                "IB",
                                "IC"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        titleTemplate: (data)=>`22P003: ${data.ADE}`
                    }
                }
            }
        }
    },
    "25P004": {
        types: {
            0: {
                versions: {
                    "*": {
                        fields: [
                            "PIR",
                            "PIS",
                            "PIT",
                            "PIN",
                            "PICA1",
                            "PICA2",
                            "PICA3",
                            "PICA4"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint32,
                        applyOffset: false,
                        gridConfig: {
                            voltageFields: [
                                "PIR",
                                "PIS",
                                "PIT",
                                "PIN"
                            ],
                            currentFields: [
                                "PICA1",
                                "PICA2",
                                "PICA3",
                                "PICA4"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        titleTemplate: (data)=>`25P004 MEASURE24`
                    }
                }
            },
            1: {
                versions: {
                    "*": {
                        fields: [
                            "PIR",
                            "PIS",
                            "PIT",
                            "PIN",
                            "PICA1",
                            "PICA2",
                            "PICA3",
                            "PICA4"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        gridConfig: {
                            voltageFields: [
                                "PIR",
                                "PIS",
                                "PIT",
                                "PIN"
                            ],
                            currentFields: [
                                "PICA1",
                                "PICA2",
                                "PICA3",
                                "PICA4"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        titleTemplate: (data)=>`25P004 MEASURE16`
                    }
                }
            },
            4: {
                versions: {
                    "*": {
                        fields: [
                            "PICA1",
                            "PICA2",
                            "PICA3",
                            "PIR",
                            "PIS",
                            "PIT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        gridConfig: {
                            voltageFields: [
                                "PIR",
                                "PIS",
                                "PIT"
                            ],
                            currentFields: [
                                "PICA1",
                                "PICA2",
                                "PICA3"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        titleTemplate: (data)=>`25P004 MEASURE12`
                    }
                }
            },
            5: {
                versions: {
                    "*": {
                        fields: [
                            "PICA1",
                            "PICA2",
                            "PICA3",
                            "PIR",
                            "PIS",
                            "PIT"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        axisConfig: {
                            timeAxis: true
                        },
                        gridConfig: {
                            voltageFields: [
                                "PIR",
                                "PIS",
                                "PIT"
                            ],
                            currentFields: [
                                "PICA1",
                                "PICA2",
                                "PICA3"
                            ],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        titleTemplate: (data)=>`25P004 Fault`
                    }
                }
            }
        }
    },
    "25P021": {
        types: {
            FAULT: {
                versions: {
                    "*": {
                        fields: [
                            "FAULT_CURRENT_BUFFER"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        specialParsers: {
                            "t": "timestamp"
                        },
                        gridConfig: {
                            voltageFields: [
                                "FAULT_CURRENT_BUFFER"
                            ],
                            currentFields: [],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        titleTemplate: ()=>"25P021 Fault"
                    }
                }
            }
        }
    },
    "22P004": {
        types: {
            FAULT_EVENT: {
                versions: {
                    "*": {
                        fields: [
                            "x",
                            "y",
                            "z"
                        ],
                        dataProcessor: $15f9f3049a7ed3be$var$uint8ToUint16,
                        applyOffset: false,
                        specialParsers: {
                            "t": "timestamp"
                        },
                        gridConfig: {
                            voltageFields: [
                                "x",
                                "y",
                                "z"
                            ],
                            currentFields: [],
                            grids: [
                                {
                                    bottom: "60%"
                                },
                                {
                                    top: "60%"
                                }
                            ]
                        },
                        titleTemplate: ()=>""
                    }
                }
            }
        }
    }
};
// Generic processing functions
function $15f9f3049a7ed3be$var$processDataFields(deserializedObj, config) {
    const data = {
        type: deserializedObj.type,
        productID: deserializedObj.productID
    };
    // Process main fields
    config.fields.forEach((field)=>{
        if (deserializedObj[field]) data[field] = config.dataProcessor(deserializedObj[field]);
    });
    // Apply offset removal if configured
    if (config.applyOffset && config.offsetFields) config.offsetFields.forEach((field)=>{
        if (data[field]) data[field] = $15f9f3049a7ed3be$var$removeOffset(data[field]);
    });
    // Handle custom mappings
    if (config.customMaps) Object.entries(config.customMaps).forEach(([mapName, mapArray])=>{
        const mapKey = mapName.toLowerCase();
        if (deserializedObj[mapKey] !== undefined) data[mapName] = mapArray[deserializedObj[mapKey]];
    });
    return data;
}
function $15f9f3049a7ed3be$var$createEChartsConfig(data, config, meta = {}) {
    const { fields: fields, gridConfig: gridConfig } = config;
    const hasBottomPane = Array.isArray(gridConfig?.currentFields) && gridConfig.currentFields.length > 0;
    const timeAxisEnabled = Boolean(config.axisConfig?.timeAxis) && Number.isFinite(meta.timestampSec) && Number.isFinite(meta.sampleFrequency) && meta.sampleFrequency > 0;
    const formatTimeMs = (ms)=>{
        const date = new Date(ms);
        const pad = (num, size)=>String(num).padStart(size, "0");
        const hh = pad(date.getHours(), 2);
        const mm = pad(date.getMinutes(), 2);
        const ss = pad(date.getSeconds(), 2);
        const msPart = pad(date.getMilliseconds(), 3);
        return `${hh}:${mm}:${ss}.${msPart}`;
    };
    const timeAxisFormatter = timeAxisEnabled ? function(value, idx) {
        const baseMs = meta.timestampSec * 1000;
        const stepMs = 1000 / meta.sampleFrequency;
        const ms = baseMs + Number(value) * stepMs;
        return formatTimeMs(ms);
    } : undefined;
    // Create dataset
    const fieldArrays = fields.map((field)=>data[field]);
    const dataset = $b0c7071b3a123ac3$exports(...fieldArrays).map((row, index)=>[
            index,
            ...row
        ]);
    // Create series configuration
    const series = fields.map((name, i)=>{
        const isVoltage = gridConfig.voltageFields.includes(name);
        const axisIndex = hasBottomPane ? isVoltage ? 0 : 1 : 0;
        return {
            name: name,
            type: "line",
            large: true,
            sampling: "lttb",
            smooth: true,
            lineStyle: {
                width: 1
            },
            areaStyle: null,
            encode: {
                x: "index",
                y: name
            },
            xAxisIndex: axisIndex,
            yAxisIndex: axisIndex
        };
    });
    const xAxisBase = timeAxisEnabled ? {
        type: "category",
        axisLabel: {
            formatter: timeAxisFormatter
        }
    } : {
        type: "category"
    };
    const defaultSingleGrid = {
        top: "12%",
        bottom: "14%"
    };
    const grid = hasBottomPane ? gridConfig.grids : [
        config.singlePaneGrid || defaultSingleGrid
    ];
    const xAxis = hasBottomPane ? [
        xAxisBase,
        {
            ...xAxisBase,
            gridIndex: 1
        }
    ] : [
        xAxisBase
    ];
    const yAxis = hasBottomPane ? [
        {
            type: "value"
        },
        {
            type: "value",
            gridIndex: 1
        }
    ] : [
        {
            type: "value"
        }
    ];
    const chartConfig = {
        dataset: {
            source: dataset,
            dimensions: [
                "index",
                ...fields
            ]
        },
        grid: grid,
        xAxis: xAxis,
        yAxis: yAxis,
        legend: {
            data: fields,
            itemGap: 5
        },
        series: series
    };
    if (timeAxisEnabled) chartConfig.tooltip = {
        trigger: "axis",
        formatter: function(params) {
            const baseMs = meta.timestampSec * 1000;
            const stepMs = 1000 / meta.sampleFrequency;
            const axisValue = Array.isArray(params) && params.length ? params[0].axisValue : 0;
            const ms = baseMs + Number(axisValue) * stepMs;
            const header = formatTimeMs(ms);
            const lines = (Array.isArray(params) ? params : []).map((p)=>{
                const marker = p.marker || "";
                return `${marker}${p.seriesName}: ${p.data?.[p.encode?.y?.[0]] ?? p.value?.[p.encode?.y?.[0]] ?? p.value}`;
            });
            return [
                header,
                ...lines
            ].join("<br/>");
        }
    };
    // Add title if configured
    if (config.titleTemplate && typeof config.titleTemplate === 'function') chartConfig.title = {
        text: config.titleTemplate(data)
    };
    else chartConfig.title = {
        text: ''
    };
    return chartConfig;
}
function $15f9f3049a7ed3be$var$getDocumentConfig(productID, type, version) {
    const product = $15f9f3049a7ed3be$var$PRODUCT_CONFIGS[productID];
    if (!product) return null;
    const typeConfig = product.types[type];
    if (!typeConfig) return null;
    // Check for specific version first
    let versionConfig = typeConfig.versions[version];
    // If not found, check for version ranges or arrays
    if (!versionConfig) {
        // Check for version arrays like "1,2,3"
        for (const [versionKey, config] of Object.entries(typeConfig.versions))if (versionKey.includes(',')) {
            const supportedVersions = versionKey.split(',').map((v)=>parseInt(v.trim()));
            if (supportedVersions.includes(version)) {
                versionConfig = config;
                break;
            }
        }
    }
    // Fall back to wildcard
    if (!versionConfig) versionConfig = typeConfig.versions["*"];
    return versionConfig;
}
// Generic document processor
function $15f9f3049a7ed3be$var$processDocument(deserializedObj, config, filename, meta) {
    if (!config) {
        console.error("Invalid document configuration");
        return null;
    }
    console.log(deserializedObj);
    // Process data fields according to configuration
    const data = $15f9f3049a7ed3be$var$processDataFields(deserializedObj, config);
    // Create ECharts configuration
    return $15f9f3049a7ed3be$var$createEChartsConfig(data, config, meta);
}
function $15f9f3049a7ed3be$export$e3af4d503e89baa0(file, filename) {
    const deserializedObj = $15f9f3049a7ed3be$var$normalizeEnvelopeFormat((0, $1889e7630e596c4f$export$2f872c0f2117be69)(file));
    const rawTimestampSec = deserializedObj?.t;
    const rawSampleFrequency = deserializedObj?.config?.sampleFrequency;
    if (!deserializedObj.productID) {
        console.log("No productID found:", deserializedObj);
        return null;
    }
    // Get configuration for this document
    const config = $15f9f3049a7ed3be$var$getDocumentConfig(deserializedObj.productID, deserializedObj.type, deserializedObj.version);
    if (!config) {
        console.error(`Unsupported document: productID=${deserializedObj.productID}, type=${deserializedObj.type}, version=${deserializedObj.version}`);
        console.log("Available configurations:", Object.keys($15f9f3049a7ed3be$var$PRODUCT_CONFIGS));
        return null;
    }
    // Apply special parsers to deserializedObj
    if (config.specialParsers) Object.entries(config.specialParsers).forEach(([path, parserName])=>{
        const value = $15f9f3049a7ed3be$var$getPropertyByPath(deserializedObj, path);
        if (value !== undefined) {
            const parser = $15f9f3049a7ed3be$var$SPECIAL_PARSERS[parserName];
            if (parser) {
                const newValue = parser(value, deserializedObj);
                $15f9f3049a7ed3be$var$setPropertyByPath(deserializedObj, path, newValue);
            }
        }
    });
    // Process using the generic processor
    const option = $15f9f3049a7ed3be$var$processDocument(deserializedObj, config, filename, {
        timestampSec: Number(rawTimestampSec),
        sampleFrequency: Number(rawSampleFrequency)
    });
    return {
        option: option,
        deserializedObj: deserializedObj,
        config: config
    };
}
function $15f9f3049a7ed3be$export$590b97d22be9cfa6(productID, typeConfig) {
    if (!$15f9f3049a7ed3be$var$PRODUCT_CONFIGS[productID]) $15f9f3049a7ed3be$var$PRODUCT_CONFIGS[productID] = {
        types: {}
    };
    Object.assign($15f9f3049a7ed3be$var$PRODUCT_CONFIGS[productID].types, typeConfig);
}
function $15f9f3049a7ed3be$export$50826654379cfd0b() {
    const supported = {};
    Object.entries($15f9f3049a7ed3be$var$PRODUCT_CONFIGS).forEach(([productID, product])=>{
        supported[productID] = {};
        Object.entries(product.types).forEach(([type, typeConfig])=>{
            supported[productID][type] = Object.keys(typeConfig.versions);
        });
    });
    return supported;
}


/**
 * Parser para archivos del producto 24T232
 * Formato de archivo: <imei>_<date:ymd>_<hora:hms>_Slv-<slave_id>-24T232.txt
 * 
 * Estructura del archivo:
 * - Primera línea: Header con metadata del dispositivo
 * - Secciones de datos binarios uint16 precedidas por etiquetas:
 *   - X axys:
 *   - Y axys:
 *   - Z axys:
 *   - ADC HALL:
 *   - ADC COIL:
 *   - ADC DC HALL:
 */ 
// Etiquetas que identifican cada sección de datos (incluyen CRLF final)
const $a067a2b6ec4e8982$var$DATA_LABELS = [
    '\r\nX axys:\r\n',
    '\r\nY axys:\r\n',
    '\r\nZ axys:\r\n',
    '\r\nADC HALL:\r\n',
    '\r\nADC COIL:\r\n',
    '\r\nADC DC HALL:\r\n'
];
// Nombres amigables para las series
const $a067a2b6ec4e8982$var$FIELD_NAMES = {
    '\r\nX axys:\r\n': 'X',
    '\r\nY axys:\r\n': 'Y',
    '\r\nZ axys:\r\n': 'Z',
    '\r\nADC HALL:\r\n': 'ADC_HALL',
    '\r\nADC COIL:\r\n': 'ADC_COIL',
    '\r\nADC DC HALL:\r\n': 'ADC_DC_HALL'
};
// Configuración de grids: qué campos van en cada gráfico
const $a067a2b6ec4e8982$var$GRID_CONFIG = {
    axisFields: [
        'X',
        'Y',
        'Z'
    ],
    adcFields: [
        'ADC_HALL',
        'ADC_COIL',
        'ADC_DC_HALL'
    ] // Grid inferior (ADCs)
};
/**
 * Parsea el header del archivo para extraer metadata
 * Ejemplo: "LANAVA 65981296 Default V15.0.35.14-ACT Boot 17P10 V11.0.2 Slave ID 1 Device Type 24T232 V2.0.0.7 Event Type 0"
 */ function $a067a2b6ec4e8982$var$parseHeader(headerLine) {
    const metadata = {
        raw: headerLine,
        deviceType: null,
        eventType: null,
        isPeriodic: false,
        slaveId: null,
        version: null,
        serialNumber: null
    };
    // Extraer Device Type
    const deviceTypeMatch = headerLine.match(/Device Type\s+(\w+)/i);
    if (deviceTypeMatch) metadata.deviceType = deviceTypeMatch[1];
    // Detectar Periodic Measure
    if (/Periodic Measure/i.test(headerLine)) metadata.isPeriodic = true;
    else {
        // Extraer Event Type (solo si no es periódico)
        const eventTypeMatch = headerLine.match(/Event Type\s+(\d+)/i);
        if (eventTypeMatch) metadata.eventType = parseInt(eventTypeMatch[1], 10);
    }
    // Extraer Slave ID
    const slaveIdMatch = headerLine.match(/Slave ID\s+(\d+)/i);
    if (slaveIdMatch) metadata.slaveId = parseInt(slaveIdMatch[1], 10);
    // Extraer versión del dispositivo (después de Device Type y antes de Event Type)
    const versionMatch = headerLine.match(/Device Type\s+\w+\s+(V[\d.]+)/i);
    if (versionMatch) metadata.version = versionMatch[1];
    // Extraer número de serie (segundo campo después de LANAVA)
    const serialMatch = headerLine.match(/LANAVA\s+(\d+)/i);
    if (serialMatch) metadata.serialNumber = serialMatch[1];
    return metadata;
}
/**
 * Encuentra las posiciones de las etiquetas en el buffer
 * Usa latin1 (ISO-8859-1) para preservar el mapeo 1:1 byte->char con datos binarios
 */ function $a067a2b6ec4e8982$var$findLabelPositions(buffer) {
    const text = new TextDecoder('latin1').decode(buffer);
    const positions = [];
    for (const label of $a067a2b6ec4e8982$var$DATA_LABELS){
        const idx = text.indexOf(label);
        if (idx !== -1) positions.push({
            label: label,
            fieldName: $a067a2b6ec4e8982$var$FIELD_NAMES[label],
            textIndex: idx,
            dataStart: idx + label.length
        });
    }
    // Ordenar por posición
    positions.sort((a, b)=>a.textIndex - b.textIndex);
    // Calcular el final de cada sección (inicio de la siguiente o fin del buffer)
    for(let i = 0; i < positions.length; i++)if (i < positions.length - 1) positions[i].dataEnd = positions[i + 1].textIndex;
    else positions[i].dataEnd = buffer.byteLength;
    return positions;
}
/**
 * Extrae los datos uint16 de una sección del buffer
 */ function $a067a2b6ec4e8982$var$extractUint16Data(buffer, start, end) {
    // Los datos binarios empiezan directamente en start (el CRLF ya está incluido en la etiqueta)
    const dataLength = end - start;
    // Asegurar alineación a 2 bytes
    const alignedLength = Math.floor(dataLength / 2) * 2;
    if (alignedLength <= 0) return new Int16Array(0);
    // Crear una copia del buffer para asegurar alineación
    const slice = buffer.slice(start, start + alignedLength);
    return new Int16Array(slice);
}
/**
 * Parsea el archivo completo y retorna los datos estructurados
 */ function $a067a2b6ec4e8982$var$parseFile(arrayBuffer) {
    const buffer = arrayBuffer;
    // Decodificar con latin1 para preservar mapeo 1:1 byte->char
    const fullText = new TextDecoder('latin1').decode(buffer);
    const firstLineEnd = fullText.indexOf('\n');
    const headerLine = fullText.substring(0, firstLineEnd).trim();
    // Parsear metadata del header
    const metadata = $a067a2b6ec4e8982$var$parseHeader(headerLine);
    // Verificar que es un archivo 24T232
    if (metadata.deviceType !== '24T232') return null;
    // Encontrar posiciones de las etiquetas
    const labelPositions = $a067a2b6ec4e8982$var$findLabelPositions(buffer);
    // Extraer datos de cada sección
    const data = {
        metadata: metadata,
        fields: {}
    };
    for (const pos of labelPositions){
        const uint16Data = $a067a2b6ec4e8982$var$extractUint16Data(buffer, pos.dataStart, pos.dataEnd);
        data.fields[pos.fieldName] = uint16Data;
    }
    return data;
}
/**
 * Genera la configuración de ECharts para visualizar los datos
 */ function $a067a2b6ec4e8982$var$createEChartsOption(parsedData) {
    const { metadata: metadata, fields: fields } = parsedData;
    // Separar campos disponibles por grid
    const axisFields = $a067a2b6ec4e8982$var$GRID_CONFIG.axisFields.filter((f)=>fields[f] && fields[f].length > 0);
    const adcFields = $a067a2b6ec4e8982$var$GRID_CONFIG.adcFields.filter((f)=>fields[f] && fields[f].length > 0);
    const availableFields = [
        ...axisFields,
        ...adcFields
    ];
    if (availableFields.length === 0) return null;
    // Crear datasets separados para cada grid (cada uno con su propia longitud)
    const axisMaxLength = Math.max(...axisFields.map((f)=>fields[f]?.length || 0), 0);
    const adcMaxLength = Math.max(...adcFields.map((f)=>fields[f]?.length || 0), 0);
    // Dataset para ejes (grid 0)
    const axisDataset = [];
    for(let i = 0; i < axisMaxLength; i++){
        const row = [
            i
        ];
        for (const field of axisFields){
            const arr = fields[field];
            row.push(arr && i < arr.length ? arr[i] : null);
        }
        axisDataset.push(row);
    }
    // Dataset para ADCs (grid 1)
    const adcDataset = [];
    for(let i = 0; i < adcMaxLength; i++){
        const row = [
            i
        ];
        for (const field of adcFields){
            const arr = fields[field];
            row.push(arr && i < arr.length ? arr[i] : null);
        }
        adcDataset.push(row);
    }
    // Crear series para ejes (usan datasetIndex 0)
    const axisSeries = axisFields.map((name, idx)=>({
            name: name,
            type: 'line',
            large: true,
            sampling: 'lttb',
            smooth: false,
            lineStyle: {
                width: 1
            },
            areaStyle: null,
            datasetIndex: 0,
            encode: {
                x: 0,
                y: idx + 1
            },
            xAxisIndex: 0,
            yAxisIndex: 0
        }));
    // Crear series para ADCs (usan datasetIndex 1)
    const adcSeries = adcFields.map((name, idx)=>({
            name: name,
            type: 'line',
            large: true,
            sampling: 'lttb',
            smooth: false,
            lineStyle: {
                width: 1
            },
            areaStyle: null,
            datasetIndex: 1,
            encode: {
                x: 0,
                y: idx + 1
            },
            xAxisIndex: 1,
            yAxisIndex: 1
        }));
    const series = [
        ...axisSeries,
        ...adcSeries
    ];
    // Construir título según tipo de medida
    const measureType = metadata.isPeriodic ? 'Periodic Measure' : `Event Type ${metadata.eventType ?? '?'}`;
    const option = {
        title: {
            text: `24T232 - Slave ${metadata.slaveId || '?'} - ${measureType}`
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                animation: false,
                label: {
                    backgroundColor: '#505765'
                }
            }
        },
        legend: {
            data: availableFields,
            top: 30
        },
        grid: [
            {
                left: 60,
                right: 60,
                top: 80,
                bottom: '55%'
            },
            {
                left: 60,
                right: 60,
                top: '55%',
                bottom: 60
            } // Grid inferior (ADC)
        ],
        dataZoom: [
            {
                type: 'inside',
                xAxisIndex: [
                    0,
                    1
                ]
            },
            {
                type: 'slider',
                xAxisIndex: [
                    0,
                    1
                ],
                bottom: 10
            }
        ],
        xAxis: [
            {
                type: 'category',
                gridIndex: 0,
                boundaryGap: false
            },
            {
                type: 'category',
                gridIndex: 1,
                boundaryGap: false
            }
        ],
        yAxis: [
            {
                type: 'value',
                gridIndex: 0,
                name: 'Ejes (X,Y,Z)'
            },
            {
                type: 'value',
                gridIndex: 1,
                name: 'ADC'
            }
        ],
        dataset: [
            {
                source: axisDataset,
                dimensions: [
                    'index',
                    ...axisFields
                ]
            },
            {
                source: adcDataset,
                dimensions: [
                    'index',
                    ...adcFields
                ]
            }
        ],
        series: series
    };
    return option;
}
function $a067a2b6ec4e8982$export$9de0d08985792775(filename) {
    return /^\d+_\d+_\d+_Slv-\d+-24T232\.txt$/i.test(filename);
}
function $a067a2b6ec4e8982$export$60dd82cec33eb6b6(arrayBuffer, filename) {
    const parsedData = $a067a2b6ec4e8982$var$parseFile(arrayBuffer);
    if (!parsedData) {
        console.warn('No se pudo parsear el archivo como 24T232:', filename);
        return null;
    }
    const option = $a067a2b6ec4e8982$var$createEChartsOption(parsedData);
    return {
        option: option,
        data: parsedData,
        config: {
            productID: '24T232',
            fields: Object.keys(parsedData.fields),
            gridConfig: $a067a2b6ec4e8982$var$GRID_CONFIG
        }
    };
}
var $a067a2b6ec4e8982$export$2e2bcd8739ae039 = {
    is24T232File: $a067a2b6ec4e8982$export$9de0d08985792775,
    process24T232File: $a067a2b6ec4e8982$export$60dd82cec33eb6b6,
    parseHeader: $a067a2b6ec4e8982$var$parseHeader,
    GRID_CONFIG: $a067a2b6ec4e8982$var$GRID_CONFIG
};


/*
MIT License

Copyright (c) 2025 Andreas Pfau

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.

*/ var $7f45c7d6a3bda4f2$var$q = `.container{background-color:var(--base00);color:var(--base05);padding:10px;letter-spacing:0.5px;font-family:monospace;border-radius:3px}.toolbar{display:flex;justify-content:space-between;align-items:center;margin-bottom:10px;padding-bottom:5px;border-bottom:solid 1px var(--base02)}.toolbar .options,.toolbar .search-wrapper{display:flex;align-items:center}.toolbar .icon-wrapper{height:15px;display:flex;align-items:center;padding:2px 5px}.toolbar .icon-wrapper:hover{background-color:var(--base02);border-radius:3px}.toolbar .icon-wrapper:first-child{margin-left:0px}.toolbar .search.icon{margin-right:5px}.toolbar .search-input{border:none;background:transparent;outline:none;flex:1;font-size:16px;color:var(--base0D)}.match{background-color:yellow;font-weight:bold;color:red}.data-row{padding:3px 0}.data-row .data-row{border-left:solid 1px var(--base02);padding-left:20px;margin-left:5px;display:none}.data-row.expanded>.data-row{display:block}.data-row .key-value-wrapper{display:flex;align-items:center}.data-row .key{color:var(--base07)}.data-row .key.number{color:var(--base0C)}.data-row .colon{color:var(--base07);margin:0 5px 0 0}.clickable{cursor:pointer}.data-row .opening-parenthesis,.data-row .closing-parenthesis{color:var(--base07)}.data-row .ellipsis{color:var(--base09)}.data-row.expanded>.key-value-wrapper .closing-parenthesis,.data-row.expanded>.key-value-wrapper .ellipsis{display:none}.data-row>.closing-parenthesis{display:none}.data-row.expanded>.closing-parenthesis{display:inline-block}.data-row .items-size{margin-left:10px;color:var(--base04);font-style:italic;display:none}.show-size .data-row .items-size{display:inline-block}.data-row .value.bool,.data-row .value.boolean{color:var(--base0E)}.data-row .value.function{color:var(--base0D)}.data-row .value.int,.data-row .value.integer{color:var(--base0F)}.data-row .value.float{color:var(--base0B)}.data-row .value.string{color:var(--base09)}.data-row .value.string .content{overflow-wrap:break-word}.data-row .value.string .content::before{content:open-quote}.data-row .value.string .content::after{content:close-quote}.data-row .value.regexp{color:var(--base0A)}.data-row .value.nan{color:var(--base08)}.data-row .value.null{color:var(--base0A)}.data-row .value.undefined{color:var(--base05)}.data-row .value.date{color:var(--base0D)}.data-row .value.nan,.data-row .value.null,.data-row .value.undefined{border-radius:3px;background-color:var(--base02);padding:1px 2px}.data-row .value .type{font-size:smaller;margin-right:4px;opacity:0.8;display:none}.data-row .value .value-data{word-break:break-all}.show-data-types .data-row .value .type{display:inline-block}.icon-wrapper,.copy-icon-wrapper{display:inline-block;cursor:pointer}.icon{display:block;position:relative}.icon:before,.icon:after{content:"";position:absolute;display:block}.expand.icon{margin-right:5px}.expand-icon-arrow .expand.icon{margin-left:3px;width:0;height:0;border-left:solid 6px var(--base0E);border-top:solid 6px transparent;border-bottom:solid 6px transparent}.expand-icon-arrow .expanded>.key-value-wrapper .expand.icon,.expand-icon-arrow .expanded.icon.expand{transform:rotate(90deg);border-left-color:var(--base0D)}.expand-icon-square .expand.icon,.expand-icon-circle .expand.icon{display:block;width:9px;height:9px;border-radius:2px;border:solid 1px var(--base0E)}.expand-icon-circle .expand.icon{border-radius:50%}.expand-icon-square .expand.icon:before,.expand-icon-circle .expand.icon:before,.expand-icon-square .expand.icon:after,.expand-icon-circle .expand.icon:after{width:5px;height:1px;background-color:var(--base0E);left:2px;top:4px}.expand-icon-square .expand.icon:after,.expand-icon-circle .expand.icon:after{transform:rotate(90deg)}.expand-icon-square .expanded>.key-value-wrapper .expand.icon:after,.expand-icon-circle .expanded>.key-value-wrapper .expand.icon:after,.expand-icon-square .expand.icon.expanded:after,.expand-icon-circle .expand.icon.expanded:after{display:none}.expand-icon-square .expanded>.key-value-wrapper .expand.icon,.expand-icon-circle .expanded>.key-value-wrapper .expand.icon,.expand-icon-square .expand.icon.expanded,.expand-icon-circle .expanded.expand.icon{border-color:var(--base0D)}.expand-icon-square .expanded>.key-value-wrapper .expand.icon:before,.expand-icon-circle .expanded>.key-value-wrapper .expand.icon:before,.expand-icon-square .expanded.expand.icon:before,.expand-icon-circle .expanded.expand.icon:before{background-color:var(--base0D)}.icon-wrapper{display:inline-block;cursor:pointer}.show-copy .key-value-wrapper:hover .icon.copy{display:block}.copy.icon{margin-left:10px;display:none;width:8px;height:10px;border:solid 1px var(--base0D);border-radius:1px;position:relative;top:4px;transition:0.2s all}.copy.icon:active{transform:scale(1.6);background-color:var(--base0B)}.copy.icon:before{content:"";display:block;left:-3px;top:-3px;width:8px;height:10px;border-top:solid 1px var(--base0D);border-left:solid 1px var(--base0D);border-radius:1px 0 0 0}.plus.icon{width:11px;height:1px;background-color:var(--base0D)}.plus.icon:after{content:"";width:11px;height:1px;background-color:var(--base0D);-webkit-transform:rotate(90deg);transform:rotate(90deg)}.minus.icon{width:11px;height:1px;background-color:var(--base0D)}.indent.icon{color:var(--base0D);width:17px;height:8px;border-top:solid 1px var(--base0D);border-bottom:solid 1px var(--base0D)}.indent.icon:before{content:"";position:absolute;top:2px;right:0;width:11px;height:2px;border-top:solid 1px var(--base0D);border-bottom:solid 1px var(--base0D)}.indent.icon:after{content:"";position:absolute;top:1px;width:0;height:0;border-top:solid 3px transparent;border-bottom:solid 3px transparent;border-left:solid 3px var(--base0D);border-right:solid 3px transparent}.outdent.icon{color:var(--base0D);margin-left:2px;width:17px;height:8px;border-top:solid 1px var(--base0D);border-bottom:solid 1px var(--base0D)}.outdent.icon:before{content:"";top:2px;right:0;width:11px;height:2px;border-top:solid 1px var(--base0D);border-bottom:solid 1px var(--base0D)}.outdent.icon:after{content:"";top:1px;left:-3px;width:0;height:0;border-top:solid 3px transparent;border-bottom:solid 3px transparent;border-left:solid 3px transparent;border-right:solid 3px var(--base0D)}.refresh.icon{color:var(--base0D);width:10px;height:10px;border-radius:50%;border-top:solid 1px var(--base0D);border-bottom:solid 1px var(--base0D);border-left:solid 1px transparent;border-right:solid 1px var(--base0D)}.refresh.icon:before{content:"";left:1px;top:8px;width:3px;height:3px;border-top:solid 1px var(--base0D);border-left:solid 1px var(--base0D);-webkit-transform:rotate(-22.5deg);transform:rotate(-22.5deg)}.info.icon{width:12px;height:11px;border:solid 1px var(--base0D);border-radius:2px}.info.icon::before{top:5px;left:5px;width:2px;height:5px;background-color:var(--base0D)}.info.icon::after{top:2px;left:5px;width:2px;height:2px;background-color:var(--base0D)}.info.icon.active{background-color:var(--base0D)}.info.icon.active::before,.info.icon.active::after{background-color:var(--base02)}.search.icon{color:var(--base0D);width:11px;height:11px;border:solid 1px var(--base0D);border-radius:100%;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.search.icon:before{content:"";top:11px;left:5px;height:6px;width:1px;background-color:var(--base0D)}
`;
var $7f45c7d6a3bda4f2$var$A = {
    apathy: [
        "#031a16",
        "#0b342d",
        "#184e45",
        "#2b685e",
        "#5f9c92",
        "#81b5ac",
        "#a7cec8",
        "#d2e7e4",
        "#3e9688",
        "#3e7996",
        "#3e4c96",
        "#883e96",
        "#963e4c",
        "#96883e",
        "#4c963e",
        "#3e965b"
    ],
    ashes: [
        "#1c2023",
        "#393f45",
        "#565e65",
        "#747c84",
        "#adb3ba",
        "#c7ccd1",
        "#dfe2e5",
        "#f3f4f5",
        "#c7ae95",
        "#c7c795",
        "#aec795",
        "#95c7ae",
        "#95aec7",
        "#ae95c7",
        "#c795ae",
        "#c79595"
    ],
    "atelier-dune-light": [
        "#fefbec",
        "#e8e4cf",
        "#a6a28c",
        "#999580",
        "#7d7a68",
        "#6e6b5e",
        "#292824",
        "#20201d",
        "#d73737",
        "#b65611",
        "#ae9513",
        "#60ac39",
        "#1fad83",
        "#6684e1",
        "#b854d4",
        "#d43552"
    ],
    "atelier-dune": [
        "#20201d",
        "#292824",
        "#6e6b5e",
        "#7d7a68",
        "#999580",
        "#a6a28c",
        "#e8e4cf",
        "#fefbec",
        "#d73737",
        "#b65611",
        "#ae9513",
        "#60ac39",
        "#1fad83",
        "#6684e1",
        "#b854d4",
        "#d43552"
    ],
    atlas: [
        "#002635",
        "#00384d",
        "#517f8d",
        "#6c8b91",
        "#869696",
        "#a1a19a",
        "#e6e6dc",
        "#fafaf8",
        "#ff5a67",
        "#f08e48",
        "#ffcc1b",
        "#7fc06e",
        "#14747e",
        "#5dd7b9",
        "#9a70a4",
        "#c43060"
    ],
    bespin: [
        "#28211c",
        "#36312e",
        "#5e5d5c",
        "#666666",
        "#797977",
        "#8a8986",
        "#9d9b97",
        "#baae9e",
        "#cf6a4c",
        "#cf7d34",
        "#f9ee98",
        "#54be0d",
        "#afc4db",
        "#5ea6ea",
        "#9b859d",
        "#937121"
    ],
    "black-metal": [
        "#000000",
        "#121212",
        "#222222",
        "#333333",
        "#999999",
        "#c1c1c1",
        "#999999",
        "#c1c1c1",
        "#5f8787",
        "#aaaaaa",
        "#a06666",
        "#dd9999",
        "#aaaaaa",
        "#888888",
        "#999999",
        "#444444"
    ],
    brewer: [
        "#0c0d0e",
        "#2e2f30",
        "#515253",
        "#737475",
        "#959697",
        "#b7b8b9",
        "#dadbdc",
        "#fcfdfe",
        "#e31a1c",
        "#e6550d",
        "#dca060",
        "#31a354",
        "#80b1d3",
        "#3182bd",
        "#756bb1",
        "#b15928"
    ],
    bright: [
        "#000000",
        "#303030",
        "#505050",
        "#b0b0b0",
        "#d0d0d0",
        "#e0e0e0",
        "#f5f5f5",
        "#ffffff",
        "#fb0120",
        "#fc6d24",
        "#fda331",
        "#a1c659",
        "#76c7b7",
        "#6fb3d2",
        "#d381c3",
        "#be643c"
    ],
    brogrammer: [
        "#1f1f1f",
        "#f81118",
        "#2dc55e",
        "#ecba0f",
        "#2a84d2",
        "#4e5ab7",
        "#1081d6",
        "#d6dbe5",
        "#d6dbe5",
        "#de352e",
        "#1dd361",
        "#f3bd09",
        "#1081d6",
        "#5350b9",
        "#0f7ddb",
        "#ffffff"
    ],
    "brushtrees-dark": [
        "#485867",
        "#5a6d7a",
        "#6d828e",
        "#8299a1",
        "#98afb5",
        "#b0c5c8",
        "#c9dbdc",
        "#e3efef",
        "#b38686",
        "#d8bba2",
        "#aab386",
        "#87b386",
        "#86b3b3",
        "#868cb3",
        "#b386b2",
        "#b39f9f"
    ],
    brushtrees: [
        "#e3efef",
        "#c9dbdc",
        "#b0c5c8",
        "#98afb5",
        "#8299a1",
        "#6d828e",
        "#5a6d7a",
        "#485867",
        "#b38686",
        "#d8bba2",
        "#aab386",
        "#87b386",
        "#86b3b3",
        "#868cb3",
        "#b386b2",
        "#b39f9f"
    ],
    chalk: [
        "#151515",
        "#202020",
        "#303030",
        "#505050",
        "#b0b0b0",
        "#d0d0d0",
        "#e0e0e0",
        "#f5f5f5",
        "#fb9fb1",
        "#eda987",
        "#ddb26f",
        "#acc267",
        "#12cfc0",
        "#6fc2ef",
        "#e1a3ee",
        "#deaf8f"
    ],
    circus: [
        "#191919",
        "#202020",
        "#303030",
        "#5f5a60",
        "#505050",
        "#a7a7a7",
        "#808080",
        "#ffffff",
        "#dc657d",
        "#4bb1a7",
        "#c3ba63",
        "#84b97c",
        "#4bb1a7",
        "#639ee4",
        "#b888e2",
        "#b888e2"
    ],
    "classic-dark": [
        "#151515",
        "#202020",
        "#303030",
        "#505050",
        "#b0b0b0",
        "#d0d0d0",
        "#e0e0e0",
        "#f5f5f5",
        "#ac4142",
        "#d28445",
        "#f4bf75",
        "#90a959",
        "#75b5aa",
        "#6a9fb5",
        "#aa759f",
        "#8f5536"
    ],
    "classic-light": [
        "#f5f5f5",
        "#e0e0e0",
        "#d0d0d0",
        "#b0b0b0",
        "#505050",
        "#303030",
        "#202020",
        "#151515",
        "#ac4142",
        "#d28445",
        "#f4bf75",
        "#90a959",
        "#75b5aa",
        "#6a9fb5",
        "#aa759f",
        "#8f5536"
    ],
    codeschool: [
        "#232c31",
        "#1c3657",
        "#2a343a",
        "#3f4944",
        "#84898c",
        "#9ea7a6",
        "#a7cfa3",
        "#b5d8f6",
        "#2a5491",
        "#43820d",
        "#a03b1e",
        "#237986",
        "#b02f30",
        "#484d79",
        "#c59820",
        "#c98344"
    ],
    cupcake: [
        "#fbf1f2",
        "#f2f1f4",
        "#d8d5dd",
        "#bfb9c6",
        "#a59daf",
        "#8b8198",
        "#72677e",
        "#585062",
        "#d57e85",
        "#ebb790",
        "#dcb16c",
        "#a3b367",
        "#69a9a7",
        "#7297b9",
        "#bb99b4",
        "#baa58c"
    ],
    cupertino: [
        "#ffffff",
        "#c0c0c0",
        "#c0c0c0",
        "#808080",
        "#808080",
        "#404040",
        "#404040",
        "#5e5e5e",
        "#c41a15",
        "#eb8500",
        "#826b28",
        "#007400",
        "#318495",
        "#0000ff",
        "#a90d91",
        "#826b28"
    ],
    darcula: [
        "#2b2b2b",
        "#323232",
        "#323232",
        "#606366",
        "#a4a3a3",
        "#a9b7c6",
        "#ffc66d",
        "#ffffff",
        "#4eade5",
        "#689757",
        "#bbb529",
        "#6a8759",
        "#629755",
        "#9876aa",
        "#cc7832",
        "#808080"
    ],
    darktooth: [
        "#1d2021",
        "#32302f",
        "#504945",
        "#665c54",
        "#928374",
        "#a89984",
        "#d5c4a1",
        "#fdf4c1",
        "#fb543f",
        "#fe8625",
        "#fac03b",
        "#95c085",
        "#8ba59b",
        "#0d6678",
        "#8f4673",
        "#a87322"
    ],
    "default-dark": [
        "#181818",
        "#282828",
        "#383838",
        "#585858",
        "#b8b8b8",
        "#d8d8d8",
        "#e8e8e8",
        "#f8f8f8",
        "#ab4642",
        "#dc9656",
        "#f7ca88",
        "#a1b56c",
        "#86c1b9",
        "#7cafc2",
        "#ba8baf",
        "#a16946"
    ],
    "default-light": [
        "#ffffff",
        "#e8e8e8",
        "#d8d8d8",
        "#b8b8b8",
        "#585858",
        "#383838",
        "#282828",
        "#181818",
        "#ab4642",
        "#dc9656",
        "#ab4642",
        "#a1b56c",
        "#86c1b9",
        "#7cafc2",
        "#ba8baf",
        "#a16946"
    ],
    dracula: [
        "#282936",
        "#3a3c4e",
        "#4d4f68",
        "#626483",
        "#62d6e8",
        "#e9e9f4",
        "#f1f2f8",
        "#f7f7fb",
        "#ea51b2",
        "#b45bcf",
        "#00f769",
        "#ebff87",
        "#a1efe4",
        "#62d6e8",
        "#b45bcf",
        "#00f769"
    ],
    eighties: [
        "#2d2d2d",
        "#393939",
        "#515151",
        "#747369",
        "#a09f93",
        "#d3d0c8",
        "#e8e6df",
        "#f2f0ec",
        "#f2777a",
        "#f99157",
        "#ffcc66",
        "#99cc99",
        "#66cccc",
        "#6699cc",
        "#cc99cc",
        "#d27b53"
    ],
    embers: [
        "#16130f",
        "#2c2620",
        "#433b32",
        "#5a5047",
        "#8a8075",
        "#a39a90",
        "#beb6ae",
        "#dbd6d1",
        "#826d57",
        "#828257",
        "#6d8257",
        "#57826d",
        "#576d82",
        "#6d5782",
        "#82576d",
        "#825757"
    ],
    flat: [
        "#2c3e50",
        "#34495e",
        "#7f8c8d",
        "#95a5a6",
        "#bdc3c7",
        "#e0e0e0",
        "#f5f5f5",
        "#ecf0f1",
        "#e74c3c",
        "#e67e22",
        "#f1c40f",
        "#2ecc71",
        "#1abc9c",
        "#3498db",
        "#9b59b6",
        "#be643c"
    ],
    "fruit-soda": [
        "#f1ecf1",
        "#e0dee0",
        "#d8d5d5",
        "#b5b4b6",
        "#979598",
        "#515151",
        "#474545",
        "#2d2c2c",
        "#fe3e31",
        "#fe6d08",
        "#f7e203",
        "#47f74c",
        "#0f9cfd",
        "#2931df",
        "#611fce",
        "#b16f40"
    ],
    github: [
        "#ffffff",
        "#f5f5f5",
        "#c8c8fa",
        "#969896",
        "#e8e8e8",
        "#333333",
        "#ffffff",
        "#969896",
        "#ed6a43",
        "#0086b3",
        "#795da3",
        "#183691",
        "#183691",
        "#795da3",
        "#a71d5d",
        "#333333"
    ],
    "google-dark": [
        "#1d1f21",
        "#282a2e",
        "#373b41",
        "#969896",
        "#b4b7b4",
        "#c5c8c6",
        "#e0e0e0",
        "#ffffff",
        "#cc342b",
        "#f96a38",
        "#fba922",
        "#198844",
        "#3971ed",
        "#3971ed",
        "#a36ac7",
        "#3971ed"
    ],
    "google-light": [
        "#ffffff",
        "#e0e0e0",
        "#c5c8c6",
        "#b4b7b4",
        "#969896",
        "#373b41",
        "#282a2e",
        "#1d1f21",
        "#cc342b",
        "#f96a38",
        "#fba922",
        "#198844",
        "#3971ed",
        "#3971ed",
        "#a36ac7",
        "#3971ed"
    ],
    "grayscale-dark": [
        "#101010",
        "#252525",
        "#464646",
        "#525252",
        "#ababab",
        "#b9b9b9",
        "#e3e3e3",
        "#f7f7f7",
        "#7c7c7c",
        "#999999",
        "#a0a0a0",
        "#8e8e8e",
        "#868686",
        "#686868",
        "#747474",
        "#5e5e5e"
    ],
    "grayscale-light": [
        "#f7f7f7",
        "#e3e3e3",
        "#b9b9b9",
        "#ababab",
        "#525252",
        "#464646",
        "#252525",
        "#101010",
        "#7c7c7c",
        "#999999",
        "#a0a0a0",
        "#8e8e8e",
        "#868686",
        "#686868",
        "#747474",
        "#5e5e5e"
    ],
    greenscreen: [
        "#001100",
        "#003300",
        "#005500",
        "#007700",
        "#009900",
        "#00bb00",
        "#00dd00",
        "#00ff00",
        "#007700",
        "#009900",
        "#007700",
        "#00bb00",
        "#005500",
        "#009900",
        "#00bb00",
        "#005500"
    ],
    "gruvbox-dark-hard": [
        "#1d2021",
        "#3c3836",
        "#504945",
        "#665c54",
        "#bdae93",
        "#d5c4a1",
        "#ebdbb2",
        "#fbf1c7",
        "#fb4934",
        "#fe8019",
        "#fabd2f",
        "#b8bb26",
        "#8ec07c",
        "#83a598",
        "#d3869b",
        "#d65d0e"
    ],
    "gruvbox-light-hard": [
        "#f9f5d7",
        "#ebdbb2",
        "#d5c4a1",
        "#bdae93",
        "#665c54",
        "#504945",
        "#3c3836",
        "#282828",
        "#9d0006",
        "#af3a03",
        "#b57614",
        "#79740e",
        "#427b58",
        "#076678",
        "#8f3f71",
        "#d65d0e"
    ],
    "harmonic-dark": [
        "#0b1c2c",
        "#223b54",
        "#405c79",
        "#627e99",
        "#aabcce",
        "#cbd6e2",
        "#e5ebf1",
        "#f7f9fb",
        "#bf8b56",
        "#bfbf56",
        "#8bbf56",
        "#56bf8b",
        "#568bbf",
        "#8b56bf",
        "#bf568b",
        "#bf5656"
    ],
    "harmonic-light": [
        "#f7f9fb",
        "#e5ebf1",
        "#cbd6e2",
        "#aabcce",
        "#627e99",
        "#405c79",
        "#223b54",
        "#0b1c2c",
        "#bf8b56",
        "#bfbf56",
        "#8bbf56",
        "#56bf8b",
        "#568bbf",
        "#8b56bf",
        "#bf568b",
        "#bf5656"
    ],
    "heetch-light": [
        "#feffff",
        "#392551",
        "#7b6d8b",
        "#9c92a8",
        "#ddd6e5",
        "#5a496e",
        "#470546",
        "#190134",
        "#27d9d5",
        "#bdb6c5",
        "#5ba2b6",
        "#f80059",
        "#c33678",
        "#47f9f5",
        "#bd0152",
        "#dedae2"
    ],
    heetch: [
        "#190134",
        "#392551",
        "#5a496e",
        "#7b6d8b",
        "#9c92a8",
        "#bdb6c5",
        "#dedae2",
        "#feffff",
        "#27d9d5",
        "#5ba2b6",
        "#8f6c97",
        "#c33678",
        "#f80059",
        "#bd0152",
        "#82034c",
        "#470546"
    ],
    helios: [
        "#1d2021",
        "#383c3e",
        "#53585b",
        "#6f7579",
        "#cdcdcd",
        "#d5d5d5",
        "#dddddd",
        "#e5e5e5",
        "#d72638",
        "#eb8413",
        "#f19d1a",
        "#88b92d",
        "#1ba595",
        "#1e8bac",
        "#be4264",
        "#c85e0d"
    ],
    hopscotch: [
        "#322931",
        "#433b42",
        "#5c545b",
        "#797379",
        "#989498",
        "#b9b5b8",
        "#d5d3d5",
        "#ffffff",
        "#dd464c",
        "#fd8b19",
        "#fdcc59",
        "#8fc13e",
        "#149b93",
        "#1290bf",
        "#c85e7c",
        "#b33508"
    ],
    "horizon-dark": [
        "#1c1e26",
        "#232530",
        "#2e303e",
        "#676a8d",
        "#ced1d0",
        "#cbced0",
        "#dcdfe4",
        "#e3e6ee",
        "#e93c58",
        "#e58d7d",
        "#efb993",
        "#efaf8e",
        "#24a8b4",
        "#df5273",
        "#b072d1",
        "#e4a382"
    ],
    "ia-dark": [
        "#1a1a1a",
        "#222222",
        "#1d414d",
        "#767676",
        "#b8b8b8",
        "#cccccc",
        "#e8e8e8",
        "#f8f8f8",
        "#d88568",
        "#d86868",
        "#b99353",
        "#83a471",
        "#7c9cae",
        "#8eccdd",
        "#b98eb2",
        "#8b6c37"
    ],
    "ia-light": [
        "#f6f6f6",
        "#dedede",
        "#bde5f2",
        "#898989",
        "#767676",
        "#181818",
        "#e8e8e8",
        "#898989",
        "#9c5a02",
        "#c43e18",
        "#c48218",
        "#38781c",
        "#2d6bb1",
        "#48bac2",
        "#a94598",
        "#8b6c37"
    ],
    icy: [
        "#021012",
        "#031619",
        "#041f23",
        "#052e34",
        "#064048",
        "#095b67",
        "#0c7c8c",
        "#109cb0",
        "#16c1d9",
        "#b3ebf2",
        "#80deea",
        "#4dd0e1",
        "#26c6da",
        "#00bcd4",
        "#00acc1",
        "#0097a7"
    ],
    isotope: [
        "#000000",
        "#404040",
        "#606060",
        "#808080",
        "#c0c0c0",
        "#d0d0d0",
        "#e0e0e0",
        "#ffffff",
        "#ff0000",
        "#ff9900",
        "#ff0099",
        "#33ff00",
        "#00ffff",
        "#0066ff",
        "#cc00ff",
        "#3300ff"
    ],
    macintosh: [
        "#000000",
        "#404040",
        "#404040",
        "#808080",
        "#808080",
        "#c0c0c0",
        "#c0c0c0",
        "#ffffff",
        "#dd0907",
        "#ff6403",
        "#fbf305",
        "#1fb714",
        "#02abea",
        "#0000d3",
        "#4700a5",
        "#90713a"
    ],
    marrakesh: [
        "#201602",
        "#302e00",
        "#5f5b17",
        "#6c6823",
        "#86813b",
        "#948e48",
        "#ccc37a",
        "#faf0a5",
        "#c35359",
        "#b36144",
        "#a88339",
        "#18974e",
        "#75a738",
        "#477ca1",
        "#8868b3",
        "#b3588e"
    ],
    materia: [
        "#263238",
        "#2c393f",
        "#37474f",
        "#707880",
        "#c9ccd3",
        "#cdd3de",
        "#d5dbe5",
        "#ffffff",
        "#ec5f67",
        "#ea9560",
        "#ffcc00",
        "#8bd649",
        "#80cbc4",
        "#89ddff",
        "#82aaff",
        "#ec5f67"
    ],
    "material-lighter": [
        "#fafafa",
        "#e7eaec",
        "#cceae7",
        "#ccd7da",
        "#8796b0",
        "#80cbc4",
        "#80cbc4",
        "#666666",
        "#ff5370",
        "#f76d47",
        "#ffb62c",
        "#91b859",
        "#39adb5",
        "#6182b8",
        "#7c4dff",
        "#e53935"
    ],
    material: [
        "#263238",
        "#2e3c43",
        "#314549",
        "#546e7a",
        "#b2ccd6",
        "#eeffff",
        "#eeffff",
        "#ffffff",
        "#f07178",
        "#f78c6c",
        "#ffcb6b",
        "#c3e88d",
        "#89ddff",
        "#82aaff",
        "#c792ea",
        "#ff5370"
    ],
    "mellow-purple": [
        "#1e0528",
        "#1a092d",
        "#331354",
        "#320f55",
        "#873582",
        "#ffeeff",
        "#ffeeff",
        "#f8c0ff",
        "#00d9e9",
        "#aa00a3",
        "#955ae7",
        "#05cb0d",
        "#b900b1",
        "#550068",
        "#8991bb",
        "#4d6fff"
    ],
    "mexico-light": [
        "#f8f8f8",
        "#e8e8e8",
        "#d8d8d8",
        "#b8b8b8",
        "#585858",
        "#383838",
        "#282828",
        "#181818",
        "#ab4642",
        "#dc9656",
        "#f79a0e",
        "#538947",
        "#4b8093",
        "#7cafc2",
        "#96609e",
        "#a16946"
    ],
    mocha: [
        "#3b3228",
        "#534636",
        "#645240",
        "#7e705a",
        "#b8afad",
        "#d0c8c6",
        "#e9e1dd",
        "#f5eeeb",
        "#cb6077",
        "#d28b71",
        "#f4bc87",
        "#beb55b",
        "#7bbda4",
        "#8ab3b5",
        "#a89bb9",
        "#bb9584"
    ],
    monokai: [
        "#272822",
        "#383830",
        "#49483e",
        "#75715e",
        "#a59f85",
        "#f8f8f2",
        "#f5f4f1",
        "#f9f8f5",
        "#f92672",
        "#fd971f",
        "#f4bf75",
        "#a6e22e",
        "#a1efe4",
        "#66d9ef",
        "#ae81ff",
        "#cc6633"
    ],
    nord: [
        "#2e3440",
        "#3b4252",
        "#434c5e",
        "#4c566a",
        "#d8dee9",
        "#e5e9f0",
        "#eceff4",
        "#8fbcbb",
        "#88c0d0",
        "#81a1c1",
        "#5e81ac",
        "#bf616a",
        "#d08770",
        "#ebcb8b",
        "#a3be8c",
        "#b48ead"
    ],
    ocean: [
        "#2b303b",
        "#343d46",
        "#4f5b66",
        "#65737e",
        "#a7adba",
        "#c0c5ce",
        "#dfe1e8",
        "#eff1f5",
        "#bf616a",
        "#d08770",
        "#ebcb8b",
        "#a3be8c",
        "#96b5b4",
        "#8fa1b3",
        "#b48ead",
        "#ab7967"
    ],
    "one-light": [
        "#fafafa",
        "#f0f0f1",
        "#e5e5e6",
        "#a0a1a7",
        "#696c77",
        "#383a42",
        "#202227",
        "#090a0b",
        "#ca1243",
        "#d75f00",
        "#c18401",
        "#50a14f",
        "#0184bc",
        "#4078f2",
        "#a626a4",
        "#986801"
    ],
    onedark: [
        "#282c34",
        "#353b45",
        "#3e4451",
        "#545862",
        "#565c64",
        "#abb2bf",
        "#b6bdca",
        "#c8ccd4",
        "#e06c75",
        "#d19a66",
        "#e5c07b",
        "#98c379",
        "#56b6c2",
        "#61afef",
        "#c678dd",
        "#be5046"
    ],
    "papercolor-dark": [
        "#1c1c1c",
        "#af005f",
        "#5faf00",
        "#d7af5f",
        "#5fafd7",
        "#808080",
        "#d7875f",
        "#d0d0d0",
        "#585858",
        "#5faf5f",
        "#afd700",
        "#af87d7",
        "#ffaf00",
        "#ff5faf",
        "#00afaf",
        "#5f8787"
    ],
    "papercolor-light": [
        "#eeeeee",
        "#af0000",
        "#008700",
        "#5f8700",
        "#0087af",
        "#878787",
        "#005f87",
        "#444444",
        "#bcbcbc",
        "#d70000",
        "#d70087",
        "#8700af",
        "#d75f00",
        "#d75f00",
        "#005faf",
        "#005f87"
    ],
    paraiso: [
        "#2f1e2e",
        "#41323f",
        "#4f424c",
        "#776e71",
        "#8d8687",
        "#a39e9b",
        "#b9b6b0",
        "#e7e9db",
        "#ef6155",
        "#f99b15",
        "#fec418",
        "#48b685",
        "#5bc4bf",
        "#06b6ef",
        "#815ba4",
        "#e96ba8"
    ],
    pico: [
        "#000000",
        "#1d2b53",
        "#7e2553",
        "#008751",
        "#ab5236",
        "#5f574f",
        "#c2c3c7",
        "#fff1e8",
        "#ff004d",
        "#ffa300",
        "#fff024",
        "#00e756",
        "#29adff",
        "#83769c",
        "#ff77a8",
        "#ffccaa"
    ],
    pop: [
        "#000000",
        "#202020",
        "#303030",
        "#505050",
        "#b0b0b0",
        "#d0d0d0",
        "#e0e0e0",
        "#ffffff",
        "#eb008a",
        "#f29333",
        "#f8ca12",
        "#37b349",
        "#00aabb",
        "#0e5a94",
        "#b31e8d",
        "#7a2d00"
    ],
    railscasts: [
        "#2b2b2b",
        "#272935",
        "#3a4055",
        "#5a647e",
        "#d4cfc9",
        "#e6e1dc",
        "#f4f1ed",
        "#f9f7f3",
        "#da4939",
        "#cc7833",
        "#ffc66d",
        "#a5c261",
        "#519f50",
        "#6d9cbe",
        "#b6b3eb",
        "#bc9458"
    ],
    seti: [
        "#151718",
        "#282a2b",
        "#3b758c",
        "#41535b",
        "#43a5d5",
        "#d6d6d6",
        "#eeeeee",
        "#ffffff",
        "#cd3f45",
        "#db7b55",
        "#e6cd69",
        "#9fca56",
        "#55dbbe",
        "#55b5db",
        "#a074c4",
        "#8a553f"
    ],
    "solarized-dark": [
        "#002b36",
        "#073642",
        "#586e75",
        "#657b83",
        "#839496",
        "#93a1a1",
        "#eee8d5",
        "#fdf6e3",
        "#dc322f",
        "#cb4b16",
        "#b58900",
        "#859900",
        "#2aa198",
        "#268bd2",
        "#6c71c4",
        "#d33682"
    ],
    "solarized-light": [
        "#fdf6e3",
        "#eee8d5",
        "#93a1a1",
        "#839496",
        "#657b83",
        "#586e75",
        "#073642",
        "#002b36",
        "#dc322f",
        "#cb4b16",
        "#b58900",
        "#859900",
        "#2aa198",
        "#268bd2",
        "#6c71c4",
        "#d33682"
    ],
    spacemacs: [
        "#1f2022",
        "#282828",
        "#444155",
        "#585858",
        "#b8b8b8",
        "#a3a3a3",
        "#e8e8e8",
        "#f8f8f8",
        "#f2241f",
        "#ffa500",
        "#b1951d",
        "#67b11d",
        "#2d9574",
        "#4f97d7",
        "#a31db1",
        "#b03060"
    ],
    "summerfruit-dark": [
        "#151515",
        "#202020",
        "#303030",
        "#505050",
        "#b0b0b0",
        "#d0d0d0",
        "#e0e0e0",
        "#ffffff",
        "#ff0086",
        "#fd8900",
        "#aba800",
        "#00c918",
        "#1faaaa",
        "#3777e6",
        "#ad00a1",
        "#cc6633"
    ],
    "summerfruit-light": [
        "#ffffff",
        "#e0e0e0",
        "#d0d0d0",
        "#b0b0b0",
        "#000000",
        "#101010",
        "#151515",
        "#202020",
        "#ff0086",
        "#fd8900",
        "#aba800",
        "#00c918",
        "#1faaaa",
        "#3777e6",
        "#ad00a1",
        "#cc6633"
    ],
    "tomorrow-night": [
        "#1d1f21",
        "#282a2e",
        "#373b41",
        "#969896",
        "#b4b7b4",
        "#c5c8c6",
        "#e0e0e0",
        "#ffffff",
        "#cc6666",
        "#de935f",
        "#f0c674",
        "#b5bd68",
        "#8abeb7",
        "#81a2be",
        "#b294bb",
        "#a3685a"
    ],
    tomorrow: [
        "#ffffff",
        "#e0e0e0",
        "#d6d6d6",
        "#8e908c",
        "#969896",
        "#4d4d4c",
        "#282a2e",
        "#1d1f21",
        "#c82829",
        "#f5871f",
        "#eab700",
        "#718c00",
        "#3e999f",
        "#4271ae",
        "#8959a8",
        "#a3685a"
    ],
    tube: [
        "#231f20",
        "#1c3f95",
        "#5a5758",
        "#737171",
        "#959ca1",
        "#d9d8d8",
        "#e7e7e8",
        "#ffffff",
        "#ee2e24",
        "#f386a1",
        "#ffd204",
        "#00853e",
        "#85cebc",
        "#009ddc",
        "#98005d",
        "#b06110"
    ],
    twilight: [
        "#1e1e1e",
        "#323537",
        "#464b50",
        "#5f5a60",
        "#838184",
        "#a7a7a7",
        "#c3c3c3",
        "#ffffff",
        "#cf6a4c",
        "#cda869",
        "#f9ee98",
        "#8f9d6a",
        "#afc4db",
        "#7587a6",
        "#9b859d",
        "#9b703f"
    ],
    woodland: [
        "#231e18",
        "#302b25",
        "#48413a",
        "#9d8b70",
        "#b4a490",
        "#cabcb1",
        "#d7c8bc",
        "#e4d4c8",
        "#d35c5c",
        "#ca7f32",
        "#e0ac16",
        "#b7ba53",
        "#6eb958",
        "#88a4d3",
        "#bb90e2",
        "#b49368"
    ],
    zenburn: [
        "#383838",
        "#404040",
        "#606060",
        "#6f6f6f",
        "#808080",
        "#dcdccc",
        "#c0c0c0",
        "#ffffff",
        "#dca3a3",
        "#dfaf8f",
        "#e0cf9f",
        "#5f7f5f",
        "#93e0e3",
        "#7cb8bb",
        "#dc8cc3",
        "#000000"
    ]
}, $7f45c7d6a3bda4f2$var$V = Object.keys($7f45c7d6a3bda4f2$var$A), $7f45c7d6a3bda4f2$var$R = (a)=>{
    let e;
    if (typeof a == "string") {
        if ($7f45c7d6a3bda4f2$var$A[a] === void 0) throw new Error(`${a} not found`);
        e = $7f45c7d6a3bda4f2$var$A[a].reduce((d, r, o)=>{
            let t = `base0${o.toString(16).toUpperCase()}`;
            return d[t] = r, d;
        }, {});
    } else e = a;
    return `.container{${Object.keys(e).map((d)=>`--${d}: ${e[d]};`).join("")}}`;
};
var $7f45c7d6a3bda4f2$var$j = (a)=>{
    try {
        return new URL(a), true;
    } catch  {
        return !1;
    }
}, $7f45c7d6a3bda4f2$var$W = (a)=>{
    if (Array.isArray(a)) return "array";
    if (a === null) return "null";
    if (a instanceof RegExp) return "regexp";
    let e = typeof a;
    return e === "number" ? isNaN(a) ? "NaN" : isFinite(a) ? Number.isInteger(a) ? "int" : "float" : "Infinity" : e === "boolean" ? "bool" : e === "object" && a instanceof Date ? "date" : e;
};
var $7f45c7d6a3bda4f2$var$$ = (a)=>{
    if (typeof a == "boolean") return a;
    if (a === "true") return !0;
    if (a === "false") return !1;
    throw new Error("should be a boolean!");
}, $7f45c7d6a3bda4f2$var$J = (a)=>{
    if (typeof a == "string") return a;
    throw new Error("should be a string!");
}, $7f45c7d6a3bda4f2$var$O = (a)=>{
    if (typeof a == "number" && a >= 0) return a;
    if (typeof a == "string" && (a = parseFloat(a)), isNaN(a) || a < 0) throw new Error("should be a positive number!");
    return a;
}, $7f45c7d6a3bda4f2$var$B = (a)=>{
    if (typeof a == "boolean" || typeof a == "number") return a;
    if (a === "true") return !0;
    if (a === "false") return !1;
    if (typeof a == "string" && (a = parseFloat(a), !isNaN(a) && a >= 0)) return a;
    throw new Error("should be a boolean or a positive number!");
}, $7f45c7d6a3bda4f2$var$z = (a)=>{
    if (typeof a == "object") return a;
    if (typeof a == "string") try {
        return JSON.parse(a);
    } catch  {
        return a;
    }
    throw new Error("should be a string or JSON!");
};
var $7f45c7d6a3bda4f2$var$P = function({ key: a, value: e, expanded: d, indent: r, onToggleExpand: o, level: t = 0, parentRow: v }) {
    let n = document.createElement("div");
    this.maxLevel = t;
    let i = $7f45c7d6a3bda4f2$var$W(e), m = i === "array" || i === "object", x = d === !0 || d > t, p, g, b, h;
    n.className = `data-row ${x ? "expanded" : ""}`, n.dataset.key = a, n.dataset.level = t, t > 0 && (n.style.paddingLeft = `${r * 5}px`);
    let f = document.createElement("span");
    f.className = "key-value-wrapper", n.appendChild(f);
    let w = ()=>{
        n.classList.toggle("expanded"), o && (n.classList.contains("expanded") ? o(t + 1) : o(t));
    };
    if (m) {
        let c = document.createElement("span");
        c.className = "icon-wrapper", f.appendChild(c), p = document.createElement("span"), p.className = "expand icon clickable", p.setAttribute("title", x ? "Collapse" : "Expand"), c.appendChild(p), c.addEventListener("click", ()=>w());
    }
    if (a !== null && a !== "") {
        let c = typeof a;
        b = document.createElement("span"), b.className = `key clickable ${c === "number" ? "number" : ""}`, b.textContent = c === "number" ? a : `${a}`, b.addEventListener("click", ()=>w()), f.appendChild(b);
        let s = document.createElement("span");
        s.classList.add("colon"), s.textContent = ":", f.appendChild(s);
    }
    if (m) {
        let c = document.createElement("span");
        c.className = "opening-parenthesis", c.textContent = i === "array" ? "[" : "{", f.appendChild(c);
        let s = document.createElement("span");
        s.className = "ellipsis clickable", s.textContent = "...", s.addEventListener("click", ()=>w()), f.appendChild(s);
        let l = document.createElement("span");
        l.className = "closing-parenthesis", l.textContent = i === "array" ? "]" : "}", f.appendChild(l);
        let E = document.createElement("span"), D = i === "array" ? e.length : Object.keys(e).length;
        E.className = "items-size", E.textContent = `${D} item${D === 1 ? "" : "s"}`, f.appendChild(E), g = [], (i === "array" ? e.map((C, k)=>k) : Object.keys(e)).forEach((C)=>{
            let k = new $7f45c7d6a3bda4f2$var$P({
                key: C,
                value: e[C],
                expanded: d,
                indent: r,
                onToggleExpand: o,
                level: t + 1,
                parentRow: n
            });
            g.push(k), n.appendChild(k.element), this.maxLevel = Math.max(this.maxLevel, k.maxLevel);
        });
        let S = document.createElement("span");
        S.className = "closing-parenthesis", S.textContent = i === "array" ? "]" : "}", n.appendChild(S);
    } else {
        let c = null;
        [
            "nan",
            "NaN",
            "undefined",
            "null"
        ].includes(i) || (c = document.createElement("span"), c.className = "type", c.textContent = i.toLowerCase());
        let s = document.createElement("span");
        s.className = `value ${i.toLowerCase()}`, h = document.createElement("span"), h.className = "value-data", h.textContent = i === "string" ? `"${e}"` : e, c && s.appendChild(c), s.appendChild(h), f.appendChild(s);
    }
    let u = document.createElement("span");
    u.className = "copy icon", u.setAttribute("title", "Copy to clipboard");
    let y = document.createElement("span");
    y.className = "icon-wrapper", y.addEventListener("click", ()=>{
        navigator.clipboard.writeText(JSON.stringify(e, null, r));
    }), y.appendChild(u), f.appendChild(y);
    let N = (c)=>{
        let s = new RegExp(c, "gi"), l = [];
        b && l.push(b), h && l.push(h);
        let E = !1;
        l.forEach((D)=>{
            let L = D.textContent;
            if (D.innerHTML = L, !c || c === "") return;
            let S = [
                ...L.matchAll(s)
            ].map((I)=>I.index), C = [], k = 0;
            S.forEach((I)=>{
                E = !0, C.push(L.slice(k, I)), C.push(`<span class="match">${c}</span>`), k = I + c.length;
            }), C.push(L.slice(k)), D.innerHTML = C.join("");
        }), E && !n.classList.contains("expanded") && (w(), v && v.classList.add("expanded"));
    };
    this.update = ({ expanded: c, indent: s, searchTerm: l })=>{
        s !== void 0 && t > 0 && (n.style.paddingLeft = `${s * 5}px`), c !== void 0 && (x = c === !0 || c > t, n.classList.toggle("expanded", x), p && (p.title = x ? "Collapse" : "Expand")), l != null && N(l), g && g.forEach((E)=>E.update({
                expanded: c,
                indent: s,
                searchTerm: l
            }));
    }, this.element = n;
}, $7f45c7d6a3bda4f2$var$U = $7f45c7d6a3bda4f2$var$P;
var $7f45c7d6a3bda4f2$var$G = function({ expanded: a, indent: e, onChange: d, onSearch: r, showDetails: o }) {
    this.indent = e || 2, this.expanded = typeof a == "number" ? a : 2, this.showDetails = o !== !1, this.maxExpandLevel = 0;
    let t, v = document.createElement("div");
    v.className = "toolbar";
    let n = document.createElement("div");
    n.className = "options", v.appendChild(n);
    let i = document.createElement("div");
    i.className = "search-wrapper", v.appendChild(i);
    let m = document.createElement("div");
    m.className = "icon-wrapper clickable", n.appendChild(m);
    let x = document.createElement("span");
    x.className = "icon refresh", m.onclick = ()=>this.refresh(), m.appendChild(x);
    let p = document.createElement("div");
    p.className = "icon-wrapper clickable", n.appendChild(p);
    let g = document.createElement("span");
    g.className = "icon plus", p.appendChild(g), p.onclick = ()=>{
        this.expanded < this.maxExpandLevel && (this.expanded += 1), d({
            expanded: this.expanded
        });
    };
    let b = document.createElement("div");
    b.className = "icon-wrapper clickable", n.appendChild(b);
    let h = document.createElement("span");
    h.className = "icon minus", b.appendChild(h), b.onclick = ()=>{
        this.expanded > this.maxExpandLevel && (this.expanded = this.maxExpandLevel), this.expanded > 0 && (this.expanded -= 1), d({
            expanded: this.expanded
        });
    };
    let f = document.createElement("div");
    f.className = "icon-wrapper clickable", n.appendChild(f);
    let w = document.createElement("span");
    w.className = "icon indent", f.onclick = ()=>{
        this.indent += 1, d({
            indent: this.indent
        });
    }, f.appendChild(w);
    let u = document.createElement("div");
    u.className = "icon-wrapper clickable", n.appendChild(u);
    let y = document.createElement("span");
    y.className = "icon outdent", u.onclick = ()=>{
        this.indent -= 1, d({
            indent: this.indent
        });
    }, u.appendChild(y);
    let N = document.createElement("div");
    N.className = "icon-wrapper clickable", n.appendChild(N);
    let c = document.createElement("span");
    c.className = `icon info ${this.showDetails ? "active" : ""}`, N.onclick = ()=>{
        c.classList.toggle("active"), this.showDetails = !this.showDetails, d({
            showDetails: this.showDetails
        });
    }, N.appendChild(c);
    let s = document.createElement("span");
    s.className = "icon search", i.appendChild(s), t = document.createElement("input"), t.className = "search-input", t.placeholder = "Search", t.oninput = (l)=>{
        r(l.target.value);
    }, i.appendChild(t), this.refresh = ()=>{
        this.expanded = 1, this.indent = 2, t && (t.value = ""), d({
            indent: 2,
            expanded: 1
        }), r("");
    }, this.updateShowDetails = (l)=>{
        this.showDetails = l, this.showDetails ? c.classList.add("active") : c.classList.remove("active");
    }, this.element = v;
}, $7f45c7d6a3bda4f2$var$M = $7f45c7d6a3bda4f2$var$G;
function $7f45c7d6a3bda4f2$var$K(a, e = {}) {
    let d = document.createElement("div");
    d.className = "container", a.appendChild(d);
    let r = null, o = null, t = {};
    this.update = ({ data: v, expanded: n, indent: i, expandIconType: m, showDataTypes: x, showToolbar: p, showSize: g, showCopy: b })=>{
        if (v) {
            let f = JSON.stringify(v);
            t.dataComapreString !== f && (t.dataComapreString = f, r = new $7f45c7d6a3bda4f2$var$U({
                key: "",
                value: v,
                expanded: n,
                indent: i,
                onToggleExpand: (w)=>{
                    o && (o.expanded = w), t.expanded = w;
                }
            }), d.replaceChildren(r.element), t.showToolbar && o && (d.prepend(o.element), o.maxExpandLevel = r.maxLevel, o.refresh()));
        }
        if (p !== void 0 && t.showToolbar !== p) {
            if (t.showToolbar = p, p) o || (o = new $7f45c7d6a3bda4f2$var$M({
                expanded: t.expanded,
                indent: t.indent,
                onChange: ({ expanded: f, indent: w, showDetails: u })=>{
                    let y = {
                        expanded: f,
                        indent: w
                    };
                    u !== void 0 && (y.showCopy = u, y.showSize = u, y.showDataTypes = u), this.update(y);
                },
                onSearch: (f)=>{
                    r && r.update({
                        searchTerm: f
                    });
                }
            })), r && (o.maxExpandLevel = r.maxLevel), d.prepend(o.element);
            else {
                let f = d.querySelector(".toolbar");
                f && f.remove();
            }
        }
        let h = {};
        n !== void 0 && t.expanded !== n && (t.expanded = n, h.expanded = n), i !== void 0 && t.indent !== i && (t.indent = i, h.indent = i), Object.keys(h).length > 0 && r && r.update(h), b !== void 0 && t.showCopy !== b && (t.showCopy = b, d.classList.toggle("show-copy", b)), g !== void 0 && t.showSize !== g && (t.showSize = g, d.classList.toggle("show-size", g), o && o.updateShowDetails(t.showSize || t.showDataTypes)), x !== void 0 && t.showDataTypes !== x && (t.showDataTypes = x, d.classList.toggle("show-data-types", x), o && o.updateShowDetails(t.showSize || t.showDataTypes)), m !== void 0 && t.expandIconType !== m && (d.classList.add(`expand-icon-${m}`), d.classList.remove(`expand-icon-${t.expandIconType}`), t.expandIconType = m);
    }, this.update(e);
}
var $7f45c7d6a3bda4f2$var$F = $7f45c7d6a3bda4f2$var$K;
var $7f45c7d6a3bda4f2$var$H = {
    indent: 2,
    expanded: 1,
    theme: "default-light",
    showDataTypes: !0,
    showToolbar: !1,
    expandIconType: "arrow",
    showCopy: !0,
    showSize: !0,
    data: null
}, $7f45c7d6a3bda4f2$var$T = class a extends HTMLElement {
    #t;
    #e;
    #c;
    #n;
    constructor(){
        super(), this.#e = {
            ...$7f45c7d6a3bda4f2$var$H
        }, this.#t = document.createElement("style");
        let e = this.attachShadow({
            mode: "open"
        }), d = document.createElement("style");
        d.textContent = `${$7f45c7d6a3bda4f2$var$q}`, e.appendChild(d), e.appendChild(this.#t), this.theme = this.#e.theme, this.#n = new $7f45c7d6a3bda4f2$var$F(e, this.#e);
    }
    static get observedAttributes() {
        return Object.keys($7f45c7d6a3bda4f2$var$H).map((e)=>e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase());
    }
    static allowedAttributes = [
        "id"
    ].concat(a.observedAttributes);
    #d = (...e)=>{
        console.warn(`JsonViewer${this.id ? ` (${this.id})` : ""}:`, ...e);
    };
    #a = (e, d, r, o)=>{
        try {
            if (d = r(d), o && !o.includes(d)) throw new Error(`should be one of ${o.join(", ")}`);
            if (this.#e[e] === d) return;
            this.#e[e] = d, this.#o();
        } catch (t) {
            this.#d(`Attribute ${e}: ${t.message}`);
        }
    };
    set showDataTypes(e) {
        this.#a("showDataTypes", e, $7f45c7d6a3bda4f2$var$$);
    }
    set showToolbar(e) {
        this.#a("showToolbar", e, $7f45c7d6a3bda4f2$var$$);
    }
    set indent(e) {
        this.#a("indent", e, $7f45c7d6a3bda4f2$var$O);
    }
    set expandIconType(e) {
        this.#a("expandIconType", e, $7f45c7d6a3bda4f2$var$J, [
            "arrow",
            "square",
            "circle"
        ]);
    }
    set expanded(e) {
        this.#a("expanded", e, $7f45c7d6a3bda4f2$var$B);
    }
    set showSize(e) {
        this.#a("showSize", e, $7f45c7d6a3bda4f2$var$$);
    }
    set showCopy(e) {
        this.#a("showCopy", e, $7f45c7d6a3bda4f2$var$$);
    }
    set theme(e) {
        try {
            if (e = $7f45c7d6a3bda4f2$var$z(e), this.#e.theme === e && this.#t.textContent !== "") return;
            this.#t.textContent = $7f45c7d6a3bda4f2$var$R(e), this.#e.theme = e;
        } catch (d) {
            this.#d(`Attribute theme: ${d.message}`);
        }
    }
    set data(e) {
        try {
            e = $7f45c7d6a3bda4f2$var$z(e);
            let d = JSON.stringify(e);
            if (this.#e.data === d) return;
            this.#e.data = d, $7f45c7d6a3bda4f2$var$j(e) ? fetch(e).then((r)=>r.json()).then((r)=>{
                this.#c = r, this.#o();
            }) : (this.#c = e, this.#o());
        } catch (d) {
            this.#d(`Attribute data: ${d.message}`);
        }
    }
    get options() {
        return this.#e;
    }
    connectedCallback() {
        window.addEventListener("DOMContentLoaded", ()=>{
            let e = this.textContent;
            this.textContent = "", e && (this.data = e);
        });
    }
    attributeChangedCallback(e, d, r) {
        if (a.allowedAttributes.indexOf(e) > -1) {
            let o = e.replace(/-([a-z])/g, (t)=>t[1].toUpperCase());
            this[o] = r;
        } else this.#d(`Attribute ${e} is not supported and will be ignored!`), this.removeAttribute(e);
    }
    #o = ()=>{
        this.#n.update({
            data: this.#c,
            expanded: this.#e.expanded,
            expandIconType: this.#e.expandIconType,
            indent: this.#e.indent,
            showDataTypes: this.#e.showDataTypes,
            showToolbar: this.#e.showToolbar,
            showSize: this.#e.showSize,
            showCopy: this.#e.showCopy
        });
    };
};
customElements.get("andypf-json-viewer") || customElements.define("andypf-json-viewer", $7f45c7d6a3bda4f2$var$T);


// convierte un uint8array a un uint16array
function $d706c914d748cb55$var$uint8ToUint16(uint8) {
    return new Int16Array(new Uint8Array(uint8).buffer);
}
let $d706c914d748cb55$var$dataset = [];
let $d706c914d748cb55$var$currentData = null;
let $d706c914d748cb55$var$currentConfig = null;
// Configuración de escala por defecto (valores genéricos)
const $d706c914d748cb55$var$DEFAULT_SCALE_CONFIG = {
    voltage: {
        fields: [],
        factor: 1,
        removeOffset: false
    },
    current: {
        fields: [],
        factor: 1,
        removeOffset: false
    }
};
let $d706c914d748cb55$var$currentScaleConfig = JSON.parse(JSON.stringify($d706c914d748cb55$var$DEFAULT_SCALE_CONFIG));
// Obtiene la configuración de escala desde el config actual o devuelve valores por defecto
function $d706c914d748cb55$var$getScaleConfigFromCurrentConfig() {
    if (!$d706c914d748cb55$var$currentConfig || !$d706c914d748cb55$var$currentConfig.scaleConfig) return JSON.parse(JSON.stringify($d706c914d748cb55$var$DEFAULT_SCALE_CONFIG));
    const sc = $d706c914d748cb55$var$currentConfig.scaleConfig;
    return {
        voltage: {
            fields: sc.voltage?.fields || [],
            factor: sc.voltage?.factor ?? 1,
            removeOffset: sc.voltage?.removeOffset ?? false
        },
        current: {
            fields: sc.current?.fields || [],
            factor: sc.current?.factor ?? 1,
            removeOffset: sc.current?.removeOffset ?? false
        }
    };
}
var $d706c914d748cb55$var$chartDom = document.getElementById('main');
var $d706c914d748cb55$var$myChart = $b45c5a9506b77a4f$export$2cd8252107eb640b($d706c914d748cb55$var$chartDom, 'dark');
var $d706c914d748cb55$var$option;
// Registrar transform personalizado para escalar datos
$b45c5a9506b77a4f$export$f01d71dd0389d7e4({
    type: 'scale:apply',
    transform: function(params) {
        const upstream = params.upstream;
        const config = params.config || {};
        const voltageFields = config.voltageFields || [];
        const currentFields = config.currentFields || [];
        const voltageFactor = config.voltageFactor ?? 1;
        const currentFactor = config.currentFactor ?? 1;
        const voltageRemoveOffset = config.voltageRemoveOffset ?? false;
        const currentRemoveOffset = config.currentRemoveOffset ?? false;
        const rawData = upstream.cloneRawData();
        const dimensions = upstream.cloneAllDimensionInfo().map((d)=>d.name);
        // Calcular offsets si es necesario
        const offsets = {};
        const fieldsToOffset = [
            ...voltageRemoveOffset ? voltageFields : [],
            ...currentRemoveOffset ? currentFields : []
        ];
        fieldsToOffset.forEach((field)=>{
            const idx = dimensions.indexOf(field);
            if (idx >= 0 && rawData.length > 0) {
                const sum = rawData.reduce((acc, row)=>acc + (Number(row[idx]) || 0), 0);
                offsets[field] = sum / rawData.length;
            }
        });
        // Aplicar transformación
        const result = rawData.map((row)=>{
            const newRow = [
                ...row
            ];
            dimensions.forEach((dim, idx)=>{
                if (voltageFields.includes(dim)) {
                    const offset = offsets[dim] || 0;
                    newRow[idx] = (Number(row[idx]) - offset) * voltageFactor;
                } else if (currentFields.includes(dim)) {
                    const offset = offsets[dim] || 0;
                    newRow[idx] = (Number(row[idx]) - offset) * currentFactor;
                }
            });
            return newRow;
        });
        return {
            data: result
        };
    }
});
let $d706c914d748cb55$var$resizeRafId = null;
function $d706c914d748cb55$var$scheduleChartResize() {
    if (!$d706c914d748cb55$var$myChart) return;
    if ($d706c914d748cb55$var$resizeRafId !== null) cancelAnimationFrame($d706c914d748cb55$var$resizeRafId);
    $d706c914d748cb55$var$resizeRafId = requestAnimationFrame(()=>{
        $d706c914d748cb55$var$myChart.resize();
        $d706c914d748cb55$var$resizeRafId = null;
    });
}
window.addEventListener('resize', $d706c914d748cb55$var$scheduleChartResize);
const $d706c914d748cb55$var$ADC_REF_V = 3.3;
const $d706c914d748cb55$var$ADC_FULL_SCALE = 4096;
function $d706c914d748cb55$var$isWaveExportEnabled() {
    return Boolean($d706c914d748cb55$var$currentData) && $d706c914d748cb55$var$currentData.productID === '24P002' && Number($d706c914d748cb55$var$currentData.type) === 5;
}
function $d706c914d748cb55$var$isScaleConfigEnabled() {
    return Boolean($d706c914d748cb55$var$currentConfig) && Boolean($d706c914d748cb55$var$currentConfig.scaleConfig);
}
function $d706c914d748cb55$var$updateToolboxVisibility() {
    // Muestra/oculta los botones del toolbox según el tipo de archivo
    $d706c914d748cb55$var$myChart.setOption({
        toolbox: {
            feature: {
                dataView: {
                    show: $d706c914d748cb55$var$isWaveExportEnabled()
                },
                myScale: {
                    show: $d706c914d748cb55$var$isScaleConfigEnabled()
                }
            }
        }
    });
}
function $d706c914d748cb55$var$updateWaveExportToolboxVisibility() {
    $d706c914d748cb55$var$updateToolboxVisibility();
}
function $d706c914d748cb55$var$downloadTextFile(filename, text) {
    const blob = new Blob([
        text
    ], {
        type: 'text/plain;charset=utf-8'
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
}
$d706c914d748cb55$var$option = {
    grid: {
        bottom: 80
    },
    toolbox: {
        show: true,
        feature: {
            dataZoom: {
                show: true
            },
            dataView: {
                show: false,
                title: 'Exportar onda',
                readOnly: true,
                lang: [
                    'Exportar onda',
                    'Cerrar',
                    'Actualizar'
                ],
                optionToContent: function() {
                    const wrap = document.createElement('div');
                    wrap.style.padding = '12px';
                    wrap.style.fontFamily = 'Consolas, Menlo, Monaco, "Courier New", monospace';
                    if (!$d706c914d748cb55$var$currentData || !$d706c914d748cb55$var$currentConfig) {
                        const msg = document.createElement('div');
                        msg.textContent = 'No hay datos cargados. Carga un .mpk primero.';
                        wrap.appendChild(msg);
                        return wrap;
                    }
                    if ($d706c914d748cb55$var$currentData.productID !== '24P002' || Number($d706c914d748cb55$var$currentData.type) !== 5) {
                        const msg = document.createElement('div');
                        msg.textContent = `Documento actual: ${$d706c914d748cb55$var$currentData.productID} tipo ${$d706c914d748cb55$var$currentData.type}. Esta vista aplica s\xf3lo a 24P002 tipo 5.`;
                        wrap.appendChild(msg);
                        return wrap;
                    }
                    const fields = Array.isArray($d706c914d748cb55$var$currentConfig?.fields) ? $d706c914d748cb55$var$currentConfig.fields : [];
                    const row = document.createElement('div');
                    row.style.display = 'flex';
                    row.style.gap = '8px';
                    row.style.alignItems = 'center';
                    row.style.marginBottom = '10px';
                    const label = document.createElement('span');
                    label.textContent = 'Serie:';
                    label.style.fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, Arial';
                    row.appendChild(label);
                    const select = document.createElement('select');
                    select.style.minWidth = '160px';
                    fields.forEach((f)=>{
                        const opt = document.createElement('option');
                        opt.value = f;
                        opt.textContent = f;
                        select.appendChild(opt);
                    });
                    row.appendChild(select);
                    const btnDownload = document.createElement('button');
                    btnDownload.textContent = 'Descargar';
                    row.appendChild(btnDownload);
                    const btnCopy = document.createElement('button');
                    btnCopy.textContent = 'Copiar';
                    row.appendChild(btnCopy);
                    wrap.appendChild(row);
                    const hint = document.createElement('div');
                    hint.style.fontFamily = 'system-ui, -apple-system, Segoe UI, Roboto, Arial';
                    hint.style.fontSize = '12px';
                    hint.style.opacity = '0.85';
                    hint.style.marginBottom = '8px';
                    hint.textContent = 'Formato: [tiempo_segundos] [valor_escalado]';
                    wrap.appendChild(hint);
                    const textarea = document.createElement('textarea');
                    textarea.style.width = '100%';
                    textarea.style.height = '320px';
                    textarea.style.boxSizing = 'border-box';
                    textarea.readOnly = true;
                    wrap.appendChild(textarea);
                    const refresh = ()=>{
                        const built = buildWaveTextFor24P002Type5(select.value);
                        textarea.value = built?.error ? built.error : built.text;
                    };
                    btnDownload.onclick = ()=>{
                        const built = buildWaveTextFor24P002Type5(select.value);
                        if (built?.error) {
                            alert(built.error);
                            return;
                        }
                        $d706c914d748cb55$var$downloadTextFile(built.filename, built.text);
                    };
                    btnCopy.onclick = async ()=>{
                        const built = buildWaveTextFor24P002Type5(select.value);
                        if (built?.error) {
                            alert(built.error);
                            return;
                        }
                        try {
                            await navigator.clipboard.writeText(built.text);
                        } catch (_) {
                            textarea.focus();
                            textarea.select();
                            document.execCommand('copy');
                        }
                    };
                    select.onchange = refresh;
                    refresh();
                    return wrap;
                }
            },
            restore: {
                show: true
            },
            saveAsImage: {
                show: true
            },
            myScale: {
                show: false,
                title: 'Escala',
                icon: 'path://M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z',
                onclick: function() {
                    $d706c914d748cb55$var$showScalePopup();
                }
            },
            myInfo: {
                show: true,
                title: 'Info',
                icon: 'path://M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z',
                onclick: function() {
                    $d706c914d748cb55$var$showInfoPopup();
                }
            }
        }
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'cross',
            animation: false,
            label: {
                backgroundColor: '#505765'
            }
        }
    },
    dataZoom: [
        {
            show: true,
            realtime: true,
            type: 'inside'
        }
    ],
    xAxis: [
        {
            type: 'category',
            boundaryGap: false,
            axisLine: {
                onZero: false
            }
        }
    ],
    yAxis: [
        {
            name: '',
            type: 'value'
        }
    ],
    dataset: {
        // Provide a set of data.
        source: $d706c914d748cb55$var$dataset
    },
    series: [],
    animationEasing: 'elasticOut'
};
$d706c914d748cb55$var$option && $d706c914d748cb55$var$myChart.setOption($d706c914d748cb55$var$option);
$d706c914d748cb55$var$updateWaveExportToolboxVisibility();
const $d706c914d748cb55$var$uppy = new (0, $bb94bbccedce200d$export$2e2bcd8739ae039)({
    debug: true,
    autoProceed: false
});
//.use(DragDrop, { target: '#drag-drop' });
$d706c914d748cb55$var$uppy.use((0, $58fa31c1ed3042b1$export$2e2bcd8739ae039), {
    target: document.body
});
$d706c914d748cb55$var$uppy.on('file-added', async (file)=>{
    console.log(`File added: ${file.name}`, file);
    document.getElementById('popupOverlay').style.display = 'none';
    document.getElementById('scalePopupOverlay').style.display = 'none';
    if (file) {
        if (file.name.includes('.mpk')) {
            let binFile = await file.data.arrayBuffer();
            let result = (0, $15f9f3049a7ed3be$export$e3af4d503e89baa0)(binFile, file.name);
            if (result && result.option) {
                $d706c914d748cb55$var$currentData = result.deserializedObj;
                $d706c914d748cb55$var$currentConfig = result.config;
                // Inicializar configuración de escala desde el config del archivo
                $d706c914d748cb55$var$currentScaleConfig = $d706c914d748cb55$var$getScaleConfigFromCurrentConfig();
                // Si hay scaleConfig definido, configurar datasets con transform para escala
                if ($d706c914d748cb55$var$currentConfig.scaleConfig) {
                    const originalDataset = result.option.dataset;
                    result.option.dataset = [
                        {
                            id: 'raw',
                            source: originalDataset.source,
                            dimensions: originalDataset.dimensions
                        },
                        {
                            id: 'scaled',
                            fromDatasetId: 'raw',
                            transform: {
                                type: 'scale:apply',
                                config: {
                                    voltageFields: $d706c914d748cb55$var$currentScaleConfig.voltage.fields,
                                    currentFields: $d706c914d748cb55$var$currentScaleConfig.current.fields,
                                    voltageFactor: $d706c914d748cb55$var$currentScaleConfig.voltage.factor,
                                    currentFactor: $d706c914d748cb55$var$currentScaleConfig.current.factor,
                                    voltageRemoveOffset: $d706c914d748cb55$var$currentScaleConfig.voltage.removeOffset,
                                    currentRemoveOffset: $d706c914d748cb55$var$currentScaleConfig.current.removeOffset
                                }
                            }
                        }
                    ];
                    // Actualizar series para usar el dataset escalado
                    if (result.option.series) result.option.series = result.option.series.map((s)=>({
                            ...s,
                            datasetIndex: 1 // Usar el dataset 'scaled'
                        }));
                }
                $d706c914d748cb55$var$myChart.setOption(result.option, {
                    notMerge: false,
                    replaceMerge: [
                        'series',
                        'xAxis',
                        'yAxis',
                        'grid',
                        'dataZoom',
                        'dataset'
                    ]
                });
                $d706c914d748cb55$var$updateWaveExportToolboxVisibility();
            }
        } else if ((0, $a067a2b6ec4e8982$export$9de0d08985792775)(file.name)) {
            // Archivo del producto 24T232 (formato Slv-{n}_{timestamp}.txt)
            const arrayBuffer = await file.data.arrayBuffer();
            const result = (0, $a067a2b6ec4e8982$export$60dd82cec33eb6b6)(arrayBuffer, file.name);
            if (result && result.option) {
                $d706c914d748cb55$var$myChart.setOption(result.option, {
                    notMerge: false,
                    replaceMerge: [
                        'series',
                        'xAxis',
                        'yAxis',
                        'grid',
                        'dataZoom',
                        'dataset'
                    ]
                });
                $d706c914d748cb55$var$currentData = result.data;
                $d706c914d748cb55$var$currentConfig = result.config;
            } else {
                console.warn('No se pudo procesar el archivo 24T232:', file.name);
                $d706c914d748cb55$var$currentData = null;
                $d706c914d748cb55$var$currentConfig = null;
            }
            $d706c914d748cb55$var$updateWaveExportToolboxVisibility();
        } else if (file.name.includes('.txt') || file.name.includes('.txs')) {
            $d706c914d748cb55$var$currentData = null;
            $d706c914d748cb55$var$currentConfig = null;
            $d706c914d748cb55$var$updateWaveExportToolboxVisibility();
            const separador = '\r\n*****---*****$\r\n';
            let text = await file.data.text();
            let post = text.indexOf(separador);
            console.log("fault");
            const arrayBuf = await file.data.slice(post + separador.length).arrayBuffer();
            var int16Array = new Int16Array(arrayBuf, 0, Math.floor(arrayBuf.byteLength / 2));
            const numCols = 1;
            $d706c914d748cb55$var$dataset = [
                ...int16Array
            ].map((row, index)=>{
                return [
                    index,
                    row
                ];
            });
            const series = [];
            const legend = [];
            for(let i = 0; i < numCols; i++){
                legend.push(`serie ${i + 1}`);
                series.push({
                    name: `serie ${i + 1}`,
                    type: 'line',
                    large: true,
                    sampling: 'lttb',
                    smooth: true,
                    lineStyle: {
                        width: 1
                    },
                    areaStyle: null
                });
            }
            $d706c914d748cb55$var$myChart.setOption({
                title: {
                    text: ''
                },
                dataset: {
                    // Provide a set of data.
                    source: $d706c914d748cb55$var$dataset
                },
                legend: {
                    data: legend,
                    itemGap: 5
                },
                dataZoom: [
                    {
                        type: 'inside',
                        realtime: true
                    }
                ],
                series: series
            }, {
                replaceMerge: [
                    'series',
                    'dataZoom',
                    'dataset'
                ]
            });
        } else {
            $d706c914d748cb55$var$currentData = null;
            $d706c914d748cb55$var$currentConfig = null;
            $d706c914d748cb55$var$updateWaveExportToolboxVisibility();
            (0, (/*@__PURE__*/$parcel$interopDefault($ec7fe9989af67c51$exports))).parse(file.data, {
                dynamicTyping: true,
                complete: function(results) {
                    $d706c914d748cb55$var$dataset = results.data;
                    if (file.name.includes('fft_')) $d706c914d748cb55$var$myChart.setOption({
                        title: {
                            text: ''
                        },
                        dataset: {
                            // Provide a set of data.
                            source: $d706c914d748cb55$var$dataset
                        },
                        dataZoom: [
                            {
                                type: 'inside',
                                realtime: true
                            }
                        ],
                        series: [
                            {
                                name: '',
                                type: 'line',
                                large: true,
                                //step: 'middle',
                                smooth: true,
                                sampling: 'lttb',
                                areaStyle: {},
                                lineStyle: {
                                    width: 1
                                }
                            }
                        ]
                    }, {
                        replaceMerge: [
                            'series',
                            'dataZoom',
                            'dataset'
                        ]
                    });
                    else if (file.name.includes('injection_')) {
                        // agrega el index en la primera columna del dataset
                        const numCols = $d706c914d748cb55$var$dataset[0].length;
                        $d706c914d748cb55$var$dataset = $d706c914d748cb55$var$dataset.map((row, index)=>[
                                index,
                                ...row
                            ]);
                        console.log($d706c914d748cb55$var$dataset);
                        const series = [];
                        const legend = [];
                        for(let i = 0; i < numCols; i++){
                            legend.push(`serie ${i + 1}`);
                            series.push({
                                name: `serie ${i + 1}`,
                                type: 'line',
                                large: true,
                                sampling: 'lttb',
                                smooth: true,
                                lineStyle: {
                                    width: 1
                                },
                                areaStyle: null
                            });
                        }
                        $d706c914d748cb55$var$myChart.setOption({
                            title: {
                                text: ''
                            },
                            dataset: {
                                // Provide a set of data.
                                source: $d706c914d748cb55$var$dataset
                            },
                            legend: {
                                data: legend,
                                itemGap: 5
                            },
                            dataZoom: [
                                {
                                    type: 'inside',
                                    realtime: true
                                }
                            ],
                            series: series
                        }, {
                            replaceMerge: [
                                'series',
                                'dataZoom',
                                'dataset'
                            ]
                        });
                    }
                }
            });
        }
    }
    $d706c914d748cb55$var$uppy.cancelAll({
        reason: 'user'
    });
});
function $d706c914d748cb55$var$deletePropertyPath(obj, path) {
    const parts = path.split('.');
    const last = parts.pop();
    let current = obj;
    for (const part of parts){
        if (current[part] === undefined) return;
        current = current[part];
    }
    if (current) delete current[last];
}
function $d706c914d748cb55$var$showInfoPopup() {
    if (!$d706c914d748cb55$var$currentData) {
        alert('No data loaded');
        return;
    }
    const excludedKeys = new Set($d706c914d748cb55$var$currentConfig?.fields || []);
    const excludedPaths = $d706c914d748cb55$var$currentConfig?.excludedFields || [];
    function safeClone(obj) {
        if (obj === null || typeof obj !== 'object') return obj;
        if (ArrayBuffer.isView(obj)) return `[TypedArray(${obj.byteLength} bytes)]`;
        if (Array.isArray(obj)) return obj.map(safeClone);
        const clone = {};
        for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) clone[key] = safeClone(obj[key]);
        return clone;
    }
    const dataToShow = safeClone($d706c914d748cb55$var$currentData);
    // Remove graphed fields (top level)
    excludedKeys.forEach((key)=>{
        delete dataToShow[key];
    });
    // Remove excluded paths
    excludedPaths.forEach((path)=>{
        $d706c914d748cb55$var$deletePropertyPath(dataToShow, path);
    });
    const container = document.getElementById('jsonContainer');
    container.innerHTML = ''; // Clear previous content
    const jsonViewer = document.createElement("andypf-json-viewer");
    jsonViewer.id = "json-viewer";
    jsonViewer.expanded = 1;
    jsonViewer.indent = 2;
    jsonViewer.showDataTypes = true;
    jsonViewer.theme = "monokai";
    jsonViewer.showToolbar = true;
    jsonViewer.showSize = true;
    jsonViewer.showCopy = true;
    jsonViewer.expandIconType = "square";
    // We need to set data after element creation
    jsonViewer.data = dataToShow;
    container.appendChild(jsonViewer);
    document.getElementById('popupOverlay').style.display = 'block';
}
function $d706c914d748cb55$var$closeInfoPopup() {
    document.getElementById('popupOverlay').style.display = 'none';
}
document.getElementById('popupOverlay').addEventListener('click', (e)=>{
    if (e.target.id === 'popupOverlay') $d706c914d748cb55$var$closeInfoPopup();
});
document.getElementById('closePopup').addEventListener('click', $d706c914d748cb55$var$closeInfoPopup);
// ===================== SCALE CONFIGURATION =====================
function $d706c914d748cb55$var$showScalePopup() {
    if (!$d706c914d748cb55$var$isScaleConfigEnabled()) {
        alert("La configuraci\xf3n de escala no est\xe1 disponible para este tipo de archivo");
        return;
    }
    const container = document.getElementById('scaleConfigContainer');
    container.innerHTML = '';
    const createFieldGroup = (title, prefix, config)=>{
        const group = document.createElement('div');
        group.className = 'field-group';
        const titleEl = document.createElement('h4');
        titleEl.textContent = title;
        titleEl.className = 'field-group__title';
        group.appendChild(titleEl);
        // Factor de conversión
        const factorRow = document.createElement('div');
        factorRow.className = 'form-row';
        const factorLabel = document.createElement('label');
        factorLabel.textContent = 'Factor:';
        factorLabel.className = 'form-label';
        factorRow.appendChild(factorLabel);
        const factorInput = document.createElement('input');
        factorInput.type = 'number';
        factorInput.step = 'any';
        factorInput.value = config.factor;
        factorInput.id = `${prefix}Factor`;
        factorInput.className = 'input-text';
        factorRow.appendChild(factorInput);
        group.appendChild(factorRow);
        // Remove offset - Switch toggle
        const offsetRow = document.createElement('div');
        offsetRow.className = 'form-row';
        const offsetLabel = document.createElement('label');
        offsetLabel.textContent = 'Eliminar offset:';
        offsetLabel.className = 'form-label';
        offsetRow.appendChild(offsetLabel);
        // Switch container
        const switchLabel = document.createElement('label');
        switchLabel.className = 'switch';
        const offsetCheck = document.createElement('input');
        offsetCheck.type = 'checkbox';
        offsetCheck.checked = config.removeOffset;
        offsetCheck.id = `${prefix}Offset`;
        offsetCheck.className = 'switch__input';
        const slider = document.createElement('span');
        slider.className = 'switch__slider';
        switchLabel.appendChild(offsetCheck);
        switchLabel.appendChild(slider);
        offsetRow.appendChild(switchLabel);
        group.appendChild(offsetRow);
        return group;
    };
    const voltageFieldsLabel = $d706c914d748cb55$var$currentScaleConfig.voltage.fields.join(', ') || 'Voltaje';
    const currentFieldsLabel = $d706c914d748cb55$var$currentScaleConfig.current.fields.join(', ') || 'Corriente';
    container.appendChild(createFieldGroup(`Voltaje (${voltageFieldsLabel})`, 'voltage', $d706c914d748cb55$var$currentScaleConfig.voltage));
    container.appendChild(createFieldGroup(`Corriente (${currentFieldsLabel})`, 'current', $d706c914d748cb55$var$currentScaleConfig.current));
    document.getElementById('scalePopupOverlay').style.display = 'block';
}
function $d706c914d748cb55$var$applyScaleAndRedraw() {
    // Leer valores del formulario
    const voltageFactor = parseFloat(document.getElementById('voltageFactor').value) || 1;
    const voltageOffset = document.getElementById('voltageOffset').checked;
    const currentFactor = parseFloat(document.getElementById('currentFactor').value) || 1;
    const currentOffset = document.getElementById('currentOffset').checked;
    // Preservar los fields y actualizar factor/offset
    $d706c914d748cb55$var$currentScaleConfig.voltage = {
        fields: $d706c914d748cb55$var$currentScaleConfig.voltage.fields,
        factor: voltageFactor,
        removeOffset: voltageOffset
    };
    $d706c914d748cb55$var$currentScaleConfig.current = {
        fields: $d706c914d748cb55$var$currentScaleConfig.current.fields,
        factor: currentFactor,
        removeOffset: currentOffset
    };
    // Actualizar el transform en el dataset sin modificar los datos originales
    if ($d706c914d748cb55$var$currentConfig) $d706c914d748cb55$var$myChart.setOption({
        dataset: [
            {
                id: 'raw'
            },
            {
                id: 'scaled',
                fromDatasetId: 'raw',
                transform: {
                    type: 'scale:apply',
                    config: {
                        voltageFields: $d706c914d748cb55$var$currentScaleConfig.voltage.fields,
                        currentFields: $d706c914d748cb55$var$currentScaleConfig.current.fields,
                        voltageFactor: $d706c914d748cb55$var$currentScaleConfig.voltage.factor,
                        currentFactor: $d706c914d748cb55$var$currentScaleConfig.current.factor,
                        voltageRemoveOffset: $d706c914d748cb55$var$currentScaleConfig.voltage.removeOffset,
                        currentRemoveOffset: $d706c914d748cb55$var$currentScaleConfig.current.removeOffset
                    }
                }
            }
        ]
    });
    document.getElementById('scalePopupOverlay').style.display = 'none';
}
document.getElementById('scalePopupOverlay').addEventListener('click', (e)=>{
    if (e.target.id === 'scalePopupOverlay') document.getElementById('scalePopupOverlay').style.display = 'none';
});
document.getElementById('scaleApplyBtn').addEventListener('click', $d706c914d748cb55$var$applyScaleAndRedraw);
document.getElementById('scaleCancelBtn').addEventListener('click', ()=>{
    document.getElementById('scalePopupOverlay').style.display = 'none';
});


//# sourceMappingURL=dashboard.6c299d95.js.map
